(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Lims = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
const qrTranslator = require('./qr-translation');

class QRBus
{
    /**
	 * Instantiate a QRBus instance.
	 *
	 * @param {object} settings (optional) Settings to use.
	 */
    constructor(settings)
    {
        this._QREventHandler = (event) => {};
        if (settings.eventHandler)
        {
            this._QREventHandler = settings.eventHandler;
        }
        this._GetByQRCode = (entity, qr) => { return { QRCode: qr } };
        if (settings.getByQRCode)
        {
            this._GetByQRCode = settings.getByQRCode;
        }
        this.receiveScan = this._debounce(this._receiveScanInternal);
    }

    /**
     * Simple debounce implementation.
     * @param {Function} func 
     * @returns 
     */
    _debounce(func, time) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), time || 200);
        };
    }

    /**
     * A function that handles a scanning instance from a scanner and propogates an event from it.
     * @param {String} code - A scanned QR Code.
     */
    async _receiveScanInternal(code)
    {
        /**  
         * @typedef {Object|Array<String>} Payload
         * @property {String} [QRCode] - QRCode value of the item scanned.
         */
        /**  
         * @typedef {Object} QREvent
         * @property {Payload} payload - payload for the event.
         * @property {String} event - the action for the ui to consume from the event.
         */
        /** @type QREvent */
        const QREvent = 
        {
            payload: { QRCode: code },
            event: 'no-action'
        };

        const translation = qrTranslator.translateQRCode(code);
        console.info('[QRBus] Translated QR Code: ', translation);

        if (translation.type === 'Action')
        {
            QREvent.event = translation.action;
            QREvent.payload = translation.actionTokens;
        }
        else
        {
            try
            {
                const entity = await this._GetByQRCode(translation.type, translation.code);
                if (entity.Error)
                {
                    throw new Error('Found no matching items.');
                }
                QREvent.payload = entity;
                QREvent.event = `scanned-${ translation.type }`;
            }
            catch (err)
            {
                console.info(`[QRBus] Failed to fetch ${ translation.type } with QR Code: ${ translation.code }`);
            }
        }

        this._QREventHandler(QREvent);
    }
}

module.exports = 
{
    QRBus
};
},{"./qr-translation":2}],2:[function(require,module,exports){
/**
 * JS file that has functions for translating qr code urls and telling the consumer what they are for.
 */

/**
 * Function for translating QR Codes into component objects that are meaningful to the library.
 * @param {String} qrCode 
 * @returns {Object} translation object constructed from the result.
 */
function translateQRCode(qrCode)
{
    
    const tokens = qrCode.split('/').filter((t) => { return !t.includes('links') && !t.includes('https'); });

    const result = 
    {
        untranslatedCode: qrCode,
        code: qrCode,
        type: 'Sample',
        actionTokens: [],
        action: '',
        queryString: qrCode.split('?')?.[1] || ''
    };
    if (tokens.length == 1)
    {
        return result;
    }
    let foundAction = false;
    tokens.forEach((t, i) =>
    {
        // If we hit the qr token, the next token is the qr code 
        // and the previous token may be the type or non existent 
        // (in which case the type is Sample)
        if (t === 'qr')
        {
            if (i !== 0)
            {
                result.type = tokens[i - 1] || 'Sample';
            }
            result.code = tokens?.[i + 1] || qrCode;
        }
        // If we hit the action token, this is an action type code.
        // Construct an array of subsequent tokens that can be used to determine what actions to take.
        if (foundAction)
        {
            result.actionTokens.push(t.split('?')[0]);
            result.code = result.actionTokens.join('/');
        }
        if (t === 'action')
        {
            foundAction = true;
            result.type = 'Action';
        }
    });
    // First action token should be the "Action", separate that from the rest of the tokens.
    if (result.actionTokens.length)
    {
        result.action = result.actionTokens[0];
        result.actionTokens = result.actionTokens.slice(1);
    }
    result.code = result.code.split('?')[0];
    return result;
}

module.exports = {
    translateQRCode
};
},{}],3:[function(require,module,exports){

const Util = require('util');

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/** @typedef {import('fable')} Fable */
/** @typedef {import('headlight-rest-client')} HeadlightRestClient */

/**
 * Manage bridge documents.
 *
 * TODO: Abstract away bridge. Make this an inspection document manager.
 *
 *   * Create missing inspection documents that are needed given its type.
 */
class HeadlightBridgeDocumentManager extends libFableServiceProviderBase
{
	/**
	 * @param {Fable} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Fable & { HeadlightRestClient: HeadlightRestClient }} */
		this.fable;

		/** @type {any} */
		this.options;

		this.serviceType = 'BridgeDocumentManager';

		// Check if there is a REST client ... if not make one
		if (!this.fable.hasOwnProperty('HeadlightRestClient'))
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = '/1.0/';
			}
			this.client = this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		}
		else
		{
			this.client = this.fable.HeadlightRestClient;
		}

		/** @type {HeadlightRestClient} */
		this.client;
		this._fieldsToConcat = [ 'Notes' ];
	}

	/**
	 * @private
	 * @param {string|number} fromDocumentID
	 * @param {boolean} [lite=false]
	 * @return {Promise<Array<any>>}
	 */
	async _loadDocumentPolyJoinsFromDocument(fromDocumentID, lite = true)
	{
		const joins = await this._get(`DocumentPolyJoins${lite ? '/LiteExtended/RemoteType,Ordinal' : ''}/FilteredTo/FBV~IDDocument~EQ~${fromDocumentID}~FBV~RemoteType~EQ~Document~FSF~Ordinal~ASC~0~FSF~IDDocumentPolyJoin~ASC~0`);
		for (const join of joins)
		{
			if (lite)
			{
				delete join.Value; // if we want to re-save these, this breaks that
			}
			else
			{
				// these being here slows down saves, and also re-saves the underlying record
				delete join.RemoteRecord;
			}
		}
		if (!lite) // sorting is broken in the API for non-lite requests...
		{
			joins.sort((a, b) =>
			{
				if (a.Ordinal == b.Ordinal)
				{
					return a.IDDocumentPolyJoin - b.IDDocumentPolyJoin;
				}
				return a.Ordinal - b.Ordinal;
			});
		}
		return joins;
	}

	/**
	 * @private
	 * @param {number|string} inspectionID
	 * @return {Promise<Array<any>>}
	 */
	async _loadInspectionDocumentJoins(inspectionID)
	{
		return await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${inspectionID}~FSF~Ordinal~ASC~0~FSF~IDInspectionDocumentJoin~ASC~0`);
	}

	/**
	 * @private
	 * @param {string|number} fromDocumentID
	 * @param {string|number} toDocumentID
	 * @param {boolean} [lite=false]
	 * @return {Promise<any>}
	 */
	async _loadDocumentPolyJoinToDocument(fromDocumentID, toDocumentID, lite = true)
	{
		const joins = await this._get(`DocumentPolyJoins${lite ? '/LiteExtended/RemoteType,Ordinal' : ''}/FilteredTo/FBV~IDDocument~EQ~${fromDocumentID}~FBV~RemoteType~EQ~Document~FBV~IDRemote~EQ~${toDocumentID}`);
		for (const join of joins)
		{
			if (lite)
			{
				delete join.Value;
			}
			else
			{
				// these being here slows down saves, and also re-saves the underlying record
				delete join.RemoteRecord;
			}
		}
		return joins[0];
	}

	/**
	 * Async wrapper for HTTP get.
	 *
	 * @param {String} uri The URI to get.
	 *
	 * @return {Promise<any>} The result of the get.
	 */
	async _get(uri)
	{
		this.fable.log.info(`GET ${uri}`);
		return Util.promisify(this.client.getJSON.bind(this.client))(uri);
	}

	/**
	 * Async wrapper for HTTP put.
	 *
	 * @param {String} uri The URI to put to.
	 * @param {any} payload The payload to put (as JSON).
	 *
	 * @return {Promise<any>} The result of the put.
	 */
	async _put(uri, payload)
	{
		this.fable.log.info(`PUT ${uri}`, { payload });
		return Util.promisify(this.client.putJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP post.
	 *
	 * @param {String} uri The URI to post to.
	 * @param {any} payload The payload to post (as JSON).
	 *
	 * @return {Promise<Object>} The result of the post.
	 */
	async _post(uri, payload)
	{
		this.fable.log.info(`POST ${uri}`, { payload });
		return Util.promisify(this.client.postJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP delete.
	 *
	 * @param {string} entityType The entity type to delete.
	 * @param {string|number} entityID The entity ID to delete.
	 *
	 * @return {Promise<Object>} The result of the delete.
	 */
	async _deleteEntity(entityType, entityID)
	{
		this.fable.log.info(`DELETE ${entityType}:${entityID}`, { entityType, entityID });
		return Util.promisify(this.client.deleteEntity.bind(this.client))(entityType, entityID);
	}

	/**
	 * Create a Bridge inspection.
	 *
	 * @param {Number} bridgeID
	 * @param {any} inspectionPayload - The new inspection record shape.
	 * @param {Boolean} [physicalAssetPassed] - Set to true if a physical asset id was passed instead of a bridge.
	 *
	 * @return {Promise<any>} The inspection record.
	 */
	/**
	 * Create an inspection for a PhysicalAsset. This is the generic entry
	 * point — creates the inspection, links it to the asset, and generates
	 * the initial inspection documents.
	 *
	 * @param {number|string} pIDPhysicalAsset - The PhysicalAsset ID.
	 * @param {Object} pInspectionPayload - The inspection record to create.
	 * @return {Promise<Object>} The created inspection record.
	 */
	async createInspection(pIDPhysicalAsset, pInspectionPayload)
	{
		return this.createBridgeInspection(pIDPhysicalAsset, pInspectionPayload, true);
	}

	/**
	 * Create an inspection for a Bridge. Resolves Bridge → PhysicalAsset
	 * unless physicalAssetPassed is true, in which case bridgeID is treated
	 * as an IDPhysicalAsset directly.
	 *
	 * @deprecated Use createInspection() for new code — it accepts
	 * IDPhysicalAsset directly without the Bridge lookup.
	 *
	 * @param {number|string} bridgeID - Bridge ID or PhysicalAsset ID.
	 * @param {Object} inspectionPayload - The inspection record.
	 * @param {boolean} [physicalAssetPassed] - If true, bridgeID is an IDPhysicalAsset.
	 * @return {Promise<Object>} The created inspection record.
	 */
	async createBridgeInspection(bridgeID, inspectionPayload, physicalAssetPassed)
	{
		const inspection = await this._post('Inspection', inspectionPayload);
		try
		{
			if (physicalAssetPassed)
			{
				// create join to physical asset
				await this._post('InspectionPhysicalAssetJoin',
					{
						IDPhysicalAsset: bridgeID,
						IDInspection: inspection.IDInspection,
					});
				return inspection;
			}
			// look up bridge
			const bridge = await this._get(`Bridge/${bridgeID}`);
			if (!bridge)
			{
				this.log.error(`Bridge with ID ${bridgeID} not found; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			if (!bridge.StructureNumber)
			{
				this.log.error(`Bridge with ID ${bridgeID} has no structure number; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			if (inspectionPayload.StatusDisplay && !inspectionPayload.IDInspectionStatus)
			{
				// attempt to look up by name
				const status = (await this._get(`InspectionStatuss/FilteredTo/FBV~Code~EQ~${inspectionPayload.StatusDisplay}`))[0];
				if (status)
				{
					inspection.IDInspectionStatus = status.IDInspectionStatus;
				}
			}
			// look up physical asset
			const physicalAssetPolyJoin = (await this._get(`PhysicalAssetPolyJoins/FilteredTo/FBV~RemoteType~EQ~Bridge~FBV~IDRemote~EQ~${bridgeID}`))[0];
			if (!physicalAssetPolyJoin)
			{
				this.log.error(`Physical asset association for bridge ID ${bridgeID} not found; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			const physicalAsset = await this._get(`PhysicalAsset/${physicalAssetPolyJoin.IDPhysicalAsset}`);
			if (!physicalAsset)
			{
				this.log.error(`Physical asset with ID ${physicalAssetPolyJoin.IDPhysicalAsset} not found; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			// create join to physical asset
			await this._post('InspectionPhysicalAssetJoin',
				{
					IDPhysicalAsset: physicalAsset.IDPhysicalAsset,
					IDInspection: inspection.IDInspection,
				});
		}
		finally
		{
			try
			{
				await this.createInspectionDocuments(inspection);
			}
			catch (err)
			{
				this.log.error('Failed to create inspection documents', { inspection, err });
			}
		}
		return inspection;
	}

	/**
	 * @param {number|string} inspectionID
	 *
	 * @return {Promise<any>}
	 */
	/**
	 * Get the PhysicalAsset linked to an inspection.
	 *
	 * @param {number|string} pInspectionID - The inspection ID.
	 * @return {Promise<Object|null>} The PhysicalAsset record, or null.
	 */
	async getPhysicalAssetForInspection(pInspectionID)
	{
		const tmpJoins = await this._get(`InspectionPhysicalAssetJoins/FilteredTo/FBV~IDInspection~EQ~${pInspectionID}`);
		if (tmpJoins.length > 0)
		{
			return await this._get(`PhysicalAsset/${tmpJoins[0].IDPhysicalAsset}`);
		}
		return null;
	}

	/**
	 * Get the Bridge linked to an inspection via PhysicalAsset → PolyJoin.
	 *
	 * @deprecated Use getPhysicalAssetForInspection() for generic asset
	 * lookups. This method is Bridge-specific.
	 *
	 * @param {number|string} inspectionID
	 * @return {Promise<Object|null>}
	 */
	async _getBridgeForInspection(inspectionID)
	{
		const tmpPhysicalAsset = await this.getPhysicalAssetForInspection(inspectionID);
		if (tmpPhysicalAsset)
		{
			const tmpPolyJoin = (await this._get(`PhysicalAssetPolyJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${tmpPhysicalAsset.IDPhysicalAsset}~FBV~RemoteType~EQ~Bridge`))[0];
			if (tmpPolyJoin)
			{
				return await this._get(`Bridge/${tmpPolyJoin.IDRemote}`);
			}
		}
		return null;
	}

	/**
	 * @param {String} dateString
	 * @return {String} formattedDateString
	 */
	addCurrentTimeToDateString(dateString)
	{
		const dateStr = dateString ? dateString : new Date().toISOString();
		const currentDateAndTime = new Date();
		const hours = String(currentDateAndTime.getHours()).padStart(2, '0');
		const minutes = String(currentDateAndTime.getMinutes()).padStart(2, '0');
		const seconds = String(currentDateAndTime.getSeconds()).padStart(2, '0');
		const timeString = `${hours}:${minutes}:${seconds}`;

		const formattedDateString = dateStr.includes('T') ? `${dateStr.split('T')[0]}T${timeString}:000Z` : `${dateStr}T${timeString}:000Z`;
		return formattedDateString;
	}

	/**
	 * Load the list of current inspection documents for an inspection.
	 * @param {number|string} inspectionID
	 * @return {Promise<Array<any>>} The list of current inspection documents.
	 */
	async getListOfCurrentInspectionIDDocuments(inspectionID)
	{
		if (!inspectionID)
		{
			throw new Error('InspectionID is required');
		}
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		if (inspectionDocJoins.length === 0)
		{
			this.log.warn(`No inspection documents found for inspection ID ${inspectionID}`);
			return [];
		}
		const inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}`);
		if (inspectionDocs.length === 0)
		{
			this.log.warn(`No inspection documents found for inspection ID ${inspectionID} with joins ${inspectionDocJoins.map((j) => j.IDDocument).join(',')}`);
			return [];
		}
		// return only the IDDocuments that are not deleted
		const IDDocumentList = inspectionDocs.filter((doc) => !doc.Deleted).map((j) => j.IDDocument);
		return IDDocumentList.length > 0 ? IDDocumentList : [];
	}

	/**
	 * Create missing inspection documents.
	 *
	 * @param {any} inspection
	 * @param {Number} [projectID]
	 *
	 * @return {Promise<Array<any>>} The documents
	 */
	async createInspectionDocuments(inspection, projectID)
	{
		const createdDocs = [];
		const inspectionID = typeof inspection === 'number' && inspection;
		if (inspectionID && inspectionID > 0)
		{
			// support ID for convenience
			inspection = (await this._get(`Inspections/FilteredTo/FBV~IDInspection~EQ~${inspectionID}`))[0];
		}
		if (!inspection)
		{
			throw new Error('Inspection is required');
		}
		if (!inspection.IDInspection)
		{
			this.log.error('Inspection does not have an IDInspection', { inspection });
			return createdDocs;
		}
		if (!inspection.IDInspectionType)
		{
			this.log.error('Inspection does not have an IDInspectionType', { inspection });
			return createdDocs;
		}
		if (!projectID)
		{
			projectID = inspection.IDProject;
		}
		if (!projectID)
		{
			throw new Error('ProjectID is required to create inspection documents; either pass it or set it on the inspection');
		}

		// get expected documents for inspection type
		const rniJoins = await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${inspection.IDInspectionType}~FSF~Ordinal~ASC~0~FSF~IDInspectionTypeReportNamedInstanceJoin~ASC~0`);

		// get existing documents for inspection
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspection.IDInspection);
		const inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((d) => d.IDDocument).join(',')}`);

		// create missing documents
		const rnis = await this._get(`ReportNamedInstances/FilteredTo/FBL~IDReportNamedInstance~INN~${rniJoins.map((rni) => rni.IDReportNamedInstance).join(',')}`);

		// Index RNIs by ID for lookup, then build missingTypes in rniJoin ordinal order
		const rnisByID = {};
		for (const rni of rnis)
		{
			rnisByID[rni.IDReportNamedInstance] = rni;
		}
		const missingTypes = rniJoins
			.map((join) => rnisByID[join.IDReportNamedInstance])
			.filter((rni) => rni && !inspectionDocs.some((d) => d.DocumentType === rni.Hash));

		const bridge = await this._getBridgeForInspection(inspection.IDInspection);

		const formData = { };
		if (bridge)
		{
			// this lets the form know this is coming from external so it can handle it specially
			formData.InitialIDBridge = String(bridge.IDBridge);
		}
		let dossier;
		for (const rni of missingTypes)
		{
			const inspectionDate = inspection.StartDate || inspection.ScheduledStartDate || new Date().toISOString();
			const inspectionDateWithCurrentTime = this.addCurrentTimeToDateString(inspectionDate);
			const documentPayload =
			{
				IDProject: projectID,
				DocumentType: rni.Hash,
				Name: `${rni.Name} for ${inspection.Name}`,
				DocumentDate: inspectionDateWithCurrentTime,
				Form: 1,
				FormData: Object.assign({}, formData),
			};
			if (rni.Hash === 'Bridge-Inspection')
			{
				documentPayload.FormData.CurrentInspection = { Date: this._formatDate(inspectionDate, 'MM/YYYY') };
			}
			const doc = await this._post('Document', documentPayload);
			if (doc.DocumentType === 'Inspection-Dossier')
			{
				dossier = doc;
			}
			inspectionDocJoins.push(
				{
					IDInspection: inspection.IDInspection,
					IDDocument: doc.IDDocument,
					IncludeOnDossier: 1,
				});
			inspectionDocs.push(doc);
			createdDocs.push(doc);
		}
		// New docs were created in InspectionTypeReportNamedInstanceJoin.Ordinal order;
		// existing inspections keep their user-set order with new docs appended.
		const updatedJoins = await this._saveJoins(inspectionDocJoins);

		if (!dossier)
		{
			dossier = (await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${updatedJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`))[0];
		}
		if (dossier)
		{
			const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
			for (const join of updatedJoins)
			{
				if (join.IDDocument == dossier.IDDocument)
				{
					continue;
				}
				if (!join.IncludeOnDossier)
				{
					continue;
				}
				if (!previousDPJoins.some((j) => j.RemoteType == 'Document' && j.IDRemote == join.IDDocument))
				{
					previousDPJoins.push({ IDDocument: dossier.IDDocument, IDRemote: join.IDDocument, RemoteType: 'Document', Ordinal: 0 });
				}
			}

			this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
			await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
		}
		return createdDocs;
	}

	/**
	 * @typedef {Function} InspectionDocumentsCallback
	 * @param {any} [error] - The error, if any.
	 * @param {Array<any>} [documents] - The documents, if no error.
	 */

	/**
	 * Create missing inspection documents.
	 *
	 * @param {any} inspection
	 * @param {InspectionDocumentsCallback} callback
	 */
	createInspectionDocumentsCallback(inspection, callback)
	{
		const onceCallback = (err, docs) =>
		{
			const cb = callback;
			callback = () =>
			{
			};
			cb(err, docs);
		};
		this.createInspectionDocuments(inspection).then((docs) => onceCallback(null, docs)).catch((err) => onceCallback(err));
	}

	/**
	 * Add a document type to an inspection type.
	 *
	 * @param {Number} inspectionTypeID
	 * @param {Number} reportNamedInstanceID
	 *
	 * @return {Promise<any>} The (existing, or new) join object.
	 */
	async addDocumentTypeToInspectionType(inspectionTypeID, reportNamedInstanceID)
	{
		if (!(inspectionTypeID > 0) || !(reportNamedInstanceID > 0))
		{
			throw new Error('InspectionTypeID and ReportNamedInstanceID are required');
		}
		if (!(await this._get(`InspectionType/${inspectionTypeID}`))) // don't care, just make sure it exists
		{
			throw new Error(`InspectionType with ID ${inspectionTypeID} does not exist`);
		}
		if (!(await this._get(`ReportNamedInstance/${reportNamedInstanceID}`))) // don't care, just make sure it exists
		{
			throw new Error(`ReportNamedInstance with ID ${reportNamedInstanceID} does not exist`);
		}
		const existing = (await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${inspectionTypeID}~FBV~IDReportNamedInstance~EQ~${reportNamedInstanceID}~FSF~Ordinal~ASC~0~FSF~IDInspectionTypeReportNamedInstanceJoin~ASC~0`))[0];
		if (existing)
		{
			return existing;
		}
		return await this._post('InspectionTypeReportNamedInstanceJoin',
			{
				IDInspectionType: inspectionTypeID,
				IDReportNamedInstance: reportNamedInstanceID,
			});
	}

	/**
	 * @typedef {Function} AddDocumentTypeToInspectionTypeCallback
	 * @param {any} [error] - The error, if any.
	 * @param {any} [join] - The join object, if no error.
	 */

	/**
	 * Create missing inspection documents.
	 *
	 * @param {Number} inspectionTypeID
	 * @param {Number} reportNamedInstanceID
	 * @param {AddDocumentTypeToInspectionTypeCallback} callback
	 */
	addDocumentTypeToInspectionTypeCallback(inspectionTypeID, reportNamedInstanceID, callback)
	{
		const onceCallback = (err, docs) =>
		{
			const cb = callback;
			callback = () =>
			{
			};
			cb(err, docs);
		};
		this.addDocumentTypeToInspectionType(inspectionTypeID, reportNamedInstanceID).then((docs) => onceCallback(null, docs)).catch((err) => onceCallback(err));
	}

	/**
	 * Set the included bit on a document in an inspection.
	 *
	 * @param {Number} documentID
	 * @param {Number} inspectionID
	 * @param {Boolean} isIncluded
	 */
	async includeDocumentInInspectionDossier(documentID, inspectionID, isIncluded)
	{
		const join = await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${inspectionID}~FBV~IDDocument~EQ~${documentID}`).then((joins) => joins[0]);
		if (!join)
		{
			throw new Error(`Document ${documentID} is not associated with inspection ${inspectionID}`);
		}
		const newInclude = !!isIncluded ? 1 : 0;
		if (newInclude == join.IncludeOnDossier)
		{
			return join;
		}
		join.IncludeOnDossier = newInclude;
		const inspectionDocumentJoin = await this._put(`InspectionDocumentJoin`, join);
		// get dossier from inspection
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const dossier = await this._get(`Documents/Lite/FilteredTo/FBV~DocumentType~EQ~Inspection-Dossier~FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}`).then((docs) => docs[0]);
		if (!dossier)
		{
			this.log.warn(`Inspection ${inspectionID} does not have an associated dossier document`);
			return inspectionDocumentJoin;
		}
		// ensure it has a document poly join to this document (or not) based on isIncluded
		const existingPolyJoin = await this._loadDocumentPolyJoinToDocument(dossier.IDDocument, documentID);
		if (existingPolyJoin && !isIncluded)
		{
			await this._deleteEntity(`DocumentPolyJoin`, existingPolyJoin.IDDocumentPolyJoin);
		}
		else if (!existingPolyJoin && isIncluded && dossier.IDDocument != documentID)
		{
			const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
			const orderedDPJoins = previousDPJoins.concat([ { IDDocument: dossier.IDDocument, RemoteType: 'Document', IDRemote: documentID } ]);
			this._sortDocumentPolyJoinsByInspectionJoins(inspectionDocJoins, orderedDPJoins);
			await this._saveJoins(orderedDPJoins, 'DocumentPolyJoin');
		}
		return inspectionDocumentJoin;
	}

	/**
	 * @param {number|string} documentID
	 * @param {number|string} inspectionID
	 * @param {boolean} [includeOnDossier=false]
	 */
	async addDocumentToInspection(documentID, inspectionID, includeOnDossier = false)
	{
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const existingJoin = inspectionDocJoins.find((j) => j.IDDocument == documentID);
		let dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
		const existingPolyJoin = dossier && await this._loadDocumentPolyJoinToDocument(dossier.IDDocument, documentID);
		if (existingJoin && (existingJoin.IncludeOnDossier ? existingPolyJoin : !existingPolyJoin))
		{
			throw new Error(`Document ${documentID} is already associated with inspection ${inspectionID}`);
		}

		let updatedJoins = inspectionDocJoins;
		let join = existingJoin;
		if (!join)
		{
			join = await this._post('InspectionDocumentJoin', { IDInspection: inspectionID, IDDocument: documentID, IncludeOnDossier: includeOnDossier ? 1 : 0 });
			const orderedJoins = inspectionDocJoins.concat([ join ]);
			updatedJoins = await this._saveJoins(orderedJoins);
		}
		if (join.IncludeOnDossier && !existingPolyJoin)
		{
			// decided to not delete joins here since this is an add method
			if (!dossier)
			{
				// handles the case where the document being added is a dossier, so we add existing documents to it
				dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~EQ~${documentID}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
				if (dossier)
				{
					let needToSave = false;
					const polyJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
					// need to create joins to this dossier?
					for (const join of updatedJoins)
					{
						if (join.IDDocument == dossier.IDDocument || !join.IncludeOnDossier || polyJoins.some((j) => j.IDRemote == join.IDDocument))
						{
							continue;
						}
						needToSave = true;
						polyJoins.push({ IDDocument: dossier.IDDocument, RemoteType: 'Document', IDRemote: join.IDDocument });
					}

					if (needToSave)
					{
						this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, polyJoins);
						await this._saveJoins(polyJoins, 'DocumentPolyJoin');
					}
				}
			}
			else
			{
				const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
				const orderedDPJoins = previousDPJoins.concat([ { IDDocument: dossier.IDDocument, RemoteType: 'Document', IDRemote: documentID } ]);
				this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, orderedDPJoins);
				await this._saveJoins(orderedDPJoins, 'DocumentPolyJoin');
			}
		}

		return join;
	}

	/**
	 * @private
	 * @param {Array<any>} inspectionDocJoins
	 * @param {Array<any>} documentPolyJoins
	 */
	_sortDocumentPolyJoinsByInspectionJoins(inspectionDocJoins, documentPolyJoins)
	{
		const joinsByIDDocument = {};
		for (const join of inspectionDocJoins)
		{
			joinsByIDDocument[join.IDDocument] = join;
		}
		documentPolyJoins.sort((a, b) =>
		{
			const joinA = joinsByIDDocument[a.IDRemote];
			const joinB = joinsByIDDocument[b.IDRemote];
			if (!joinA && !joinB)
			{
				return 0;
			}
			if (!joinB)
			{
				return -1;
			}
			if (!joinA)
			{
				return 1;
			}
			return joinA.Ordinal - joinB.Ordinal;
		});
	}

	/**
	 * @param {number|string} inspectionID
	 * @param {number|string} documentID
	 * @param {number} ordinalOffset
	 */
	async rearrangeDocument(inspectionID, documentID, ordinalOffset)
	{
		if (!ordinalOffset)
		{
			return;
		}
		/** @type {Array<any>} */
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const existingJoinIndex = inspectionDocJoins.findIndex((j) => j.IDDocument == documentID);
		if (existingJoinIndex < 0)
		{
			throw new Error(`Document ${documentID} is not associated with inspection ${inspectionID}`);
		}
		if (existingJoinIndex + ordinalOffset < 0 || existingJoinIndex + ordinalOffset >= inspectionDocJoins.length)
		{
			this.log.error(`Document ${documentID} cannot be moved to ordinal ${existingJoinIndex + ordinalOffset} in inspection ${inspectionID}`,
				{ inspectionID, documentID, ordinalOffset, existingJoinIndex });
			return;
		}
		const existingJoin = inspectionDocJoins[existingJoinIndex];
		inspectionDocJoins.splice(existingJoinIndex, 1);
		inspectionDocJoins.splice(existingJoinIndex + ordinalOffset, 0, existingJoin);
		const updatedJoins = await this._saveJoins(inspectionDocJoins);

		const dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
		const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
		this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
		await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
	}

	/**
	 * @param {number|string} documentID
	 * @param {number|string} inspectionID
	 */
	async removeDocumentFromInspection(documentID, inspectionID)
	{
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const existingJoin = inspectionDocJoins.find((j) => j.IDDocument == documentID);
		const dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
		const existingPolyJoin = dossier && await this._loadDocumentPolyJoinToDocument(dossier.IDDocument, documentID);

		if (!existingJoin && !existingPolyJoin)
		{
			throw new Error(`Document ${documentID} is not associated with inspection ${inspectionID}`);
		}
		if (existingJoin)
		{
			await this._deleteEntity('InspectionDocumentJoin', existingJoin.IDInspectionDocumentJoin);
		}
		if (existingPolyJoin)
		{
			await this._deleteEntity('DocumentPolyJoin', existingPolyJoin.IDDocumentPolyJoin);
		}
	}

	/**
	 * @param {Array<any>} joins
	 * @param {string} [table='InspectionDocumentJoin']
	 * @return {Promise<Array<any>>} the updated joins
	 */
	async _saveJoins(joins, table = 'InspectionDocumentJoin')
	{
		const updatedJoins = [];
		// update join ordinals and create / update records as needed
		for (let i = 0; i < joins.length; i++)
		{
			const join = joins[i];
			const desiredOrdinal = i;
			if (join[`ID${table}`]) // existing record
			{
				if (join.Ordinal == desiredOrdinal)
				{
					updatedJoins.push(join);
					continue;
				}
				join.Ordinal = desiredOrdinal;
				const updated = await this._put(table, join);
				updatedJoins.push(updated);
			}
			else
			{
				join.Ordinal = desiredOrdinal;
				const created = await this._post(table, join);
				updatedJoins.push(created);
			}
		}
		return updatedJoins;
	}

	/**
	 * Reorder the InspectionTypeReportNamedInstanceJoins for an inspection type.
	 *
	 * @param {Number} inspectionTypeID
	 * @param {Array<Number>} orderedJoinIDs - The IDs of the joins in the desired order.
	 *
	 * @return {Promise<Array<any>>} The updated joins.
	 */
	async reorderInspectionTypeDocuments(inspectionTypeID, orderedJoinIDs)
	{
		if (!(inspectionTypeID > 0))
		{
			throw new Error('InspectionTypeID is required');
		}
		if (!Array.isArray(orderedJoinIDs) || orderedJoinIDs.length === 0)
		{
			throw new Error('orderedJoinIDs must be a non-empty array');
		}
		// Verify the inspection type exists
		if (!(await this._get(`InspectionType/${inspectionTypeID}`)))
		{
			throw new Error(`InspectionType with ID ${inspectionTypeID} does not exist`);
		}

		// Bulk load all joins for this inspection type
		const allJoins = await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${inspectionTypeID}~FSF~Ordinal~ASC~0~FSF~IDInspectionTypeReportNamedInstanceJoin~ASC~0`);

		// Sniff test: ensure the passed IDs cover all joins (no partial reorders)
		if (orderedJoinIDs.length !== allJoins.length)
		{
			throw new Error(`Expected ${allJoins.length} join IDs for InspectionType ${inspectionTypeID} but received ${orderedJoinIDs.length}; all joins must be included in a reorder`);
		}

		// Index joins by ID for fast lookup
		const joinsByID = {};
		for (const join of allJoins)
		{
			joinsByID[join.IDInspectionTypeReportNamedInstanceJoin] = join;
		}

		// Validate every passed ID exists and belongs to this inspection type
		for (const joinID of orderedJoinIDs)
		{
			if (!joinsByID[joinID])
			{
				throw new Error(`InspectionTypeReportNamedInstanceJoin with ID ${joinID} does not exist for InspectionType ${inspectionTypeID}`);
			}
		}

		// Only update joins whose ordinal actually changed
		const updatedJoins = [];
		for (let i = 0; i < orderedJoinIDs.length; i++)
		{
			const join = joinsByID[orderedJoinIDs[i]];
			if (join.Ordinal !== i)
			{
				join.Ordinal = i;
				const updated = await this._put('InspectionTypeReportNamedInstanceJoin', join);
				updatedJoins.push(updated);
			}
			else
			{
				updatedJoins.push(join);
			}
		}
		return updatedJoins;
	}

	/**
	 * NOTE: stolen from pict DateFormat template instruction
	 * @param {string} dateValue
	 * @param {string} formatString
	 * @return {string}
	 */
	_formatDate(dateValue, formatString)
	{
		let tmpDayJS = this.fable.Dates.dayJS.utc(dateValue);
		try
		{
			// Try to cast the day to be a specific timezone if one is set for the app
			if (this.options.Timezone)
			{
				tmpDayJS = tmpDayJS.tz(this.options.Timezone);
			}
			else
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
		}
		catch
		{
			//this.log.error(`Error casting date passed timezone using tz .. casting to the browser guess which is [${this.fable.Dates.dayJS.tz.guess()}].`);
			// Day.js will try to guess the user's timezone for us
			try
			{
				tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
			}
			catch (pError)
			{
				this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
			}
		}

		return tmpDayJS.format(formatString);
	}

	/**
	 * @param {Number|String} inspectionID
	 * @param {Number|String} projectID
	 * @param {String} documentType
	 * @param {Number|String} userID
	 * @param {Boolean} [includeOnDossier=true]
	 * @return {Promise<any>}
	 */
	async createInspectionDocumentForUser(inspectionID, projectID, documentType, userID, includeOnDossier = true)
	{
		const user = await this._get(`User/${userID}`);
		if (!user)
		{
			throw new Error(`User with ID ${userID} not found`);
		}
		const inspection = await this._get(`Inspection/${inspectionID}`);
		if (!inspection)
		{
			throw new Error(`Inspection with ID ${inspectionID} not found`);
		}
		const rni = (await this._get(`ReportNamedInstancesByProject/${projectID}/0/100`)).find((rni) => rni.Hash === documentType);
		if (!rni)
		{
			throw new Error(`Failed to resolve report hash ${documentType} in project ${projectID}`);
		}
		const bridge = await this._getBridgeForInspection(inspectionID);
		const documentPayload =
		{
			//TODO: should we put their name in the document name? makes re-assign really funky
			Name: `${rni.Name} for ${inspection.Name}`,
			IDProject: projectID,
			DocumentType: documentType,
			DocumentDate: new Date().toISOString(),
			Form: 1,
			FormData: { },
		};
		const inspectionDate = inspection.StartDate || inspection.ScheduledStartDate;
		if (bridge)
		{
			documentPayload.FormData.InitialIDBridge = bridge.IDBridge;
		}
		if (rni.Hash === 'Bridge-Inspection')
		{
			documentPayload.FormData.CurrentInspection = { Date: this._formatDate(inspectionDate, 'MM/YYYY') };
		}
		//TODO: check if user already has a document of this type?
		const doc = await this._post('Document', documentPayload);
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspection.IDInspection);
		const newJoin = await this._post('InspectionDocumentJoin', { IDInspection: inspectionID, IDDocument: doc.IDDocument, IncludeOnDossier: includeOnDossier ? 1 : 0 });
		const orderedJoins = inspectionDocJoins.concat([ newJoin ]);
		const updatedJoins = await this._saveJoins(orderedJoins);

		if (includeOnDossier)
		{
			const dossier = (await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${updatedJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`))[0];
			if (dossier && dossier.IDDocument != doc.IDDocument)
			{
				const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
				if (!previousDPJoins.some((j) => j.RemoteType == 'Document' && j.IDRemote == doc.IDDocument))
				{
					previousDPJoins.push({ IDDocument: dossier.IDDocument, IDRemote: doc.IDDocument, RemoteType: 'Document' });
				}
				this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
				await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
			}
		}

		await this._get(`Permissions/AssignOwner/Document/${doc.IDDocument}/To/User/${userID}`);
		// ensure it has a document poly join to this document (or not) based on isIncluded
		return doc;
	}

	/**
	 * @param {String} field
	 * @param {Set<String>} touchedMergedElementConditions
	 * @return {boolean}
	 */
	_fieldSeen(field, touchedMergedElementConditions)
	{
		if (touchedMergedElementConditions.has(field))
		{
			return true;
		}
		touchedMergedElementConditions.add(field);
		return false;
	}

	/**
	 * NOTE: provisional - we want to make a tool to allow manual merging eventually
	 *
	 * FIXME: The only document type that this currently supports is bridge inspection (element condition) documents.
	 *
	 * @param {Number|String} inspectionID
	 * @param {Number|String} documentType
	 * @param {Array<Number|String>} [documentIDs]
	 * @param {Number|String} [existingMergedDocumentID]
	 * @param {Boolean} [includeOnDossier=true]
	 */
	async mergeDocuments(inspectionID, documentType, documentIDs, existingMergedDocumentID, includeOnDossier = true)
	{
		if (documentType !== 'Bridge-Inspection')
		{
			throw new Error(`Document type ${documentType} is not supported for merging`);
		}
		// load inspection documents of the given type
		/** @type {Array<any>} */
		let inspectionDocs;
		if (Array.isArray(documentIDs))
		{
			inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${documentIDs.join(',')}~FBV~DocumentType~EQ~${documentType}`);
		}
		else
		{
			const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
			inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((d) => d.IDDocument).join(',')}~FBV~DocumentType~EQ~${documentType}`);
		}
		if (!inspectionDocs || inspectionDocs.length < 2)
		{
			throw new Error(`Inspection ${inspectionID} does not have at least two documents of type ${documentType}`);
		}
		let existingMergedDoc;
		if (!existingMergedDocumentID)
		{
			existingMergedDoc = inspectionDocs.find((d) => d.FormData?.Meta?.Merge == true);
			if (existingMergedDoc)
			{
				existingMergedDocumentID = existingMergedDoc.IDDocument;
			}
		}
		// sanity check documents
		let docType;
		let projectID;
		for (const doc of inspectionDocs)
		{
			if (!docType)
			{
				docType = doc.DocumentType;
			}
			else if (doc.DocumentType !== docType)
			{
				throw new Error(`Documents are not all of the same type; expected ${docType} but found ${doc.DocumentType} on document ${doc.IDDocument}`);
			}
			if (!projectID)
			{
				projectID = doc.IDProject;
			}
			else if (doc.IDProject != projectID)
			{
				throw new Error(`Documents are not all in the same project; expected ${projectID} but found ${doc.IDProject} on document ${doc.IDDocument}`);
			}
		}
		// merge
		let newDoc;
		let resetConcat = false; // for concatentated fields, should we reset to note duplicate values
		if (existingMergedDocumentID)
		{
			if (!existingMergedDoc)
			{
				existingMergedDoc = inspectionDocs.find((d) => d.IDDocument == existingMergedDocumentID);
			}
			if (existingMergedDoc)
			{
				newDoc = existingMergedDoc;
				inspectionDocs = inspectionDocs.filter((d) => d.IDDocument != existingMergedDocumentID);
				resetConcat = true;
			}
			else
			{
				newDoc = this._get(`Document/${existingMergedDocumentID}`);
			}
		}
		if (!newDoc)
		{
			newDoc = JSON.parse(JSON.stringify(inspectionDocs.shift()));
			newDoc.Name = `${newDoc.Name} (Merged)`;
			delete newDoc.IDDocument;
			delete newDoc.GUIDDocument;
			delete newDoc.CreatingIDUser;
			delete newDoc.CreateDate;
			delete newDoc.UpdatingIDUser;
			delete newDoc.UpdateDate;
			if (!newDoc.FormData)
			{
				newDoc.FormData = { };
			}
			if (!newDoc.FormData.Meta)
			{
				newDoc.FormData.Meta = { };
			}
			newDoc.FormData.Meta.Merge = true;
		}
		if (!Array.isArray(newDoc.Observations))
		{
			newDoc.Observations = [];
		}
		const mergedFormData = newDoc.FormData;
		const touchedMergedElementConditions = new Set();
		for (const doc of inspectionDocs)
		{
			if (Array.isArray(doc.Observations))
			{
				for (const obsID of doc.Observations)
				{
					if (!newDoc.Observations.includes(obsID))
					{
						newDoc.Observations.push(obsID);
					}
				}
			}
			const formData = doc.FormData;
			if (typeof formData.ElementConditionTotalMap === 'object')
			{
				if (!mergedFormData.ElementConditionTotalMap)
				{
					mergedFormData.ElementConditionTotalMap = { };
				}
				for (const elementID in formData.ElementConditionTotalMap)
				{
					if (mergedFormData.ElementConditionTotalMap.hasOwnProperty(elementID))
					{
						const mergedElementCondition = mergedFormData.ElementConditionTotalMap[elementID];
						const elementCondition = formData.ElementConditionTotalMap[elementID];
						mergedElementCondition.CS2 = String((parseInt(mergedElementCondition.CS2) || 0) + (parseInt(elementCondition.CS2) || 0));
						mergedElementCondition.CS3 = String((parseInt(mergedElementCondition.CS3) || 0) + (parseInt(elementCondition.CS3) || 0));
						mergedElementCondition.CS4 = String((parseInt(mergedElementCondition.CS4) || 0) + (parseInt(elementCondition.CS4) || 0));
						if (mergedElementCondition.TotalAmount)
						{
							mergedElementCondition.CS1 = String(parseInt(mergedElementCondition.TotalAmount) -
								(parseInt(mergedElementCondition.CS2) || 0) - (parseInt(mergedElementCondition.CS3) || 0) - (parseInt(mergedElementCondition.CS4) || 0));
							mergedElementCondition.CS1Percentage = String((parseInt(mergedElementCondition.CS1) / parseInt(mergedElementCondition.TotalAmount) * 100));
							mergedElementCondition.CS2Percentage = String((parseInt(mergedElementCondition.CS2) / parseInt(mergedElementCondition.TotalAmount) * 100));
							mergedElementCondition.CS3Percentage = String((parseInt(mergedElementCondition.CS3) / parseInt(mergedElementCondition.TotalAmount) * 100));
							mergedElementCondition.CS4Percentage = String((parseInt(mergedElementCondition.CS4) / parseInt(mergedElementCondition.TotalAmount) * 100));
						}

						if (Array.isArray(elementCondition.Defects))
						{
							if (!Array.isArray(mergedElementCondition.Defects))
							{
								mergedElementCondition.Defects = [];
							}
							for (const defect of elementCondition.Defects)
							{
								const existingDefect = mergedElementCondition.Defects.find((d) => d.GUIDPart == defect.GUIDPart);
								if (existingDefect)
								{
									mergedElementCondition.Defects = mergedElementCondition.Defects.filter((d) => d.GUIDPart != defect.GUIDPart);
								}
								mergedElementCondition.Defects.push(defect);
								this._transferDefect(doc, newDoc, defect);
							}
						}
					}
					else
					{
						mergedFormData.ElementConditionTotalMap[elementID] = JSON.parse(JSON.stringify(formData.ElementConditionTotalMap[elementID]));
					}
				}
			}
			if (typeof formData.CurrentInspection === 'object')
			{
				if (!mergedFormData.CurrentInspection)
				{
					mergedFormData.CurrentInspection = { };
				}
				for (const field in formData.CurrentInspection)
				{
					if (field == 'ElementConditions')
					{
						if (!mergedFormData.CurrentInspection.ElementConditions)
						{
							mergedFormData.CurrentInspection.ElementConditions = { };
						}
						// merge notes
						for (const elementID of Object.keys(formData.CurrentInspection.ElementConditions))
						{
							if (!mergedFormData.CurrentInspection.ElementConditions[elementID])
							{
								mergedFormData.CurrentInspection.ElementConditions[elementID] = { };
							}
							if (resetConcat && !this._fieldSeen(`CurrentInspection.ElementConditions.${elementID}.Notes`, touchedMergedElementConditions))
							{
								mergedFormData.CurrentInspection.ElementConditions[elementID].Notes = formData.CurrentInspection.ElementConditions[elementID].Notes;
							}
							else if (typeof formData.CurrentInspection.ElementConditions[elementID].Notes === 'string' && formData.CurrentInspection.ElementConditions[elementID].Notes.length > 0)
							{
								if (!mergedFormData.CurrentInspection.ElementConditions[elementID].Notes)
								{
									mergedFormData.CurrentInspection.ElementConditions[elementID].Notes = formData.CurrentInspection.ElementConditions[elementID].Notes;
								}
								else
								{
									mergedFormData.CurrentInspection.ElementConditions[elementID].Notes += '\n';
									mergedFormData.CurrentInspection.ElementConditions[elementID].Notes += formData.CurrentInspection.ElementConditions[elementID].Notes;
								}
							}
						}
					}
					else if (!mergedFormData.CurrentInspection.hasOwnProperty(field))
					{
						mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
					}
					else if (this._fieldsToConcat.includes(field))
					{
						if (resetConcat && !this._fieldSeen(`CurrentInspection.${field}`, touchedMergedElementConditions))
						{
							mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
						}
						// merge field - we don't merge all of them, but remarks etc get concatenated
						else if (typeof formData.CurrentInspection[field] === 'string' && formData.CurrentInspection[field].length > 0)
						{
							if (!mergedFormData.CurrentInspection[field])
							{
								mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
							}
							else
							{
								mergedFormData.CurrentInspection[field] += '\n';
								mergedFormData.CurrentInspection[field] += formData.CurrentInspection[field];
							}
						}
					}
					else if (!mergedFormData.CurrentInspection[field])
					{
						mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
					}
				}
			}
			for (const formDataKey of Object.keys(formData))
			{
				if (!mergedFormData.hasOwnProperty(formDataKey))
				{
					mergedFormData[formDataKey] = formData[formDataKey];
				}
			}
		}

		delete newDoc.FormData.InitialIDBridge; // never want this on a merged doc - can be there if one doc to merge was never opened
		// save as new document
		const savedMergedDoc = await this._put('Document/Upsert', newDoc);
		if (!newDoc.IDDocument)
		{
			const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
			const orderedJoins = inspectionDocJoins.concat([ { IDInspection: inspectionID, IDDocument: savedMergedDoc.IDDocument, IncludeOnDossier: includeOnDossier ? 1 : 0 } ]);
			const updatedJoins = await this._saveJoins(orderedJoins);
			if (includeOnDossier)
			{
				const dossier = (await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${updatedJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`))[0];
				if (dossier)
				{
					const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
					if (!previousDPJoins.some((j) => j.RemoteType == 'Document' && j.IDRemote == savedMergedDoc.IDDocument))
					{
						previousDPJoins.push({ IDDocument: dossier.IDDocument, IDRemote: savedMergedDoc.IDDocument, RemoteType: 'Document' });
						this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
						await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
					}
				}
			}
		}
	}

	/**
	 * @param {any} mergedFormData
	 * @param {any} sourceFormData
	 * @param {any} defect
	 */
	_transferDefect(mergedFormData, sourceFormData, defect)
	{
		// observation set binding to defect
		const binding = `${defect.IDDefect}-${defect.GUIDPart}`;
		if (sourceFormData[binding])
		{
			if (mergedFormData[binding] && mergedFormData[binding] != sourceFormData[binding])
			{
				this.fable.log.warn(`Defect binding ${binding} already exists in merged document`, { old: mergedFormData[binding], new: sourceFormData[binding] });
			}
			mergedFormData[binding] = sourceFormData[binding];
		}
	}
}

module.exports = HeadlightBridgeDocumentManager;

},{"fable-serviceproviderbase":398,"headlight-rest-client":12,"util":755}],4:[function(require,module,exports){
(function (setImmediate){(function (){
/* eslint brace-style: ["error", "allman"] */

/**
 * A comprehension the processor can consume without holding it in memory.
 *
 * The processor used to take the whole comprehension as one object, which caps a load at whatever
 * fits in the heap — and the records are the overwhelming majority of that. Everything it does
 * before the records reach an adapter, though, needs only two things up front:
 *
 *   1. which entity types are present, and
 *   2. the *shape* of each — the field names, which is what the dependency sort reads.
 *
 * So a source declares those two, and hands records over in batches. A caller with a comprehension
 * already in memory builds one with `fromComprehension`; a caller reading a lake table builds one
 * that pages.
 *
 * ## Shapes carry two field sets, and the distinction is load-bearing
 *
 * The dependency sort treats the two reference forms differently, and collapsing them changes the
 * graph:
 *
 *   - `GUID<Entity>` / `_GUID<Entity>` create an edge only when some record holds a **truthy value**.
 *     A record carrying `GUIDMaterial: ''` does not depend on Material.
 *   - `…_Via_GUID<Entity>` creates an edge on **field name alone**.
 *
 * A shape built from field names only would invent dependencies from empty columns — and since the
 * sort throws on a cycle, an invented edge can fail a load that would otherwise have run.
 *
 * @typedef {Object} EntityShape
 * @property {Array<string>} Fields - Every field name seen on any record of this entity.
 * @property {Array<string>} PopulatedFields - Field names that held a truthy value on some record.
 *
 * @typedef {Object} ComprehensionSource
 * @property {Array<string>} EntityTypes - Entity names, in no particular order; the sort orders them.
 * @property {Object<string, EntityShape>} EntityShapes
 * @property {(pEntity: string) => number|null} recordCount - Known count, or null when unknowable
 *           without reading (a paging source may not know until it has read).
 * @property {(pEntity: string, fOnBatch: (pRecords: Array<Object>, fNext: (pError?: Error) => void) => void, fDone: (pError?: Error) => void) => void} streamRecords
 */

/**
 * Fold one record into an accumulating shape.
 *
 * @param {EntityShape} pShape
 * @param {Object} pRecord
 * @return {EntityShape}
 */
const foldRecordIntoShape = function(pShape, pRecord)
{
	if (!pRecord || (typeof(pRecord) !== 'object'))
	{
		return pShape;
	}
	for (const tmpFieldKey of Object.keys(pRecord))
	{
		if (pShape.Fields.indexOf(tmpFieldKey) < 0)
		{
			pShape.Fields.push(tmpFieldKey);
		}
		if (pRecord[tmpFieldKey] && (pShape.PopulatedFields.indexOf(tmpFieldKey) < 0))
		{
			pShape.PopulatedFields.push(tmpFieldKey);
		}
	}
	return pShape;
};

/**
 * @return {EntityShape}
 */
const emptyShape = function()
{
	return { Fields: [], PopulatedFields: [] };
};

/**
 * @param {Array<Object>|Object<string, Object>} pRecords
 * @return {EntityShape}
 */
const deriveEntityShape = function(pRecords)
{
	const tmpShape = emptyShape();
	const tmpList = Array.isArray(pRecords) ? pRecords : Object.values(pRecords || {});
	for (const tmpRecord of tmpList)
	{
		foldRecordIntoShape(tmpShape, tmpRecord);
	}
	return tmpShape;
};

/**
 * Wrap an in-memory comprehension as a source, so the streaming path is the only path the processor
 * has and the existing entry point keeps working unchanged.
 *
 * @param {Object<string, Array<Object>|Object<string, Object>>} pComprehension
 * @param {Object} [pOptions]
 * @param {number} [pOptions.BatchSize] - Records handed over per batch.
 * @return {ComprehensionSource}
 */
const fromComprehension = function(pComprehension, pOptions)
{
	const tmpComprehension = pComprehension || {};
	const tmpBatchSize = (pOptions && pOptions.BatchSize) || 5000;
	const tmpEntityTypes = Object.keys(tmpComprehension);
	/** @type {Object<string, EntityShape>} */
	const tmpShapes = {};
	for (const tmpEntity of tmpEntityTypes)
	{
		tmpShapes[tmpEntity] = deriveEntityShape(tmpComprehension[tmpEntity]);
	}

	const recordsOf = function(pEntity)
	{
		const tmpRecords = tmpComprehension[pEntity];
		if (!tmpRecords)
		{
			return [];
		}
		return Array.isArray(tmpRecords) ? tmpRecords : Object.values(tmpRecords);
	};

	return {
		EntityTypes: tmpEntityTypes,
		EntityShapes: tmpShapes,
		recordCount: (pEntity) => recordsOf(pEntity).length,
		streamRecords: (pEntity, fOnBatch, fDone) =>
		{
			const tmpRecords = recordsOf(pEntity);
			let tmpOffset = 0;
			const fPump = () =>
			{
				if (tmpOffset >= tmpRecords.length)
				{
					return fDone();
				}
				const tmpBatch = tmpRecords.slice(tmpOffset, tmpOffset + tmpBatchSize);
				tmpOffset += tmpBatchSize;
				// Recursing through the callback would grow the stack by one frame per batch on an
				// in-memory source, where nothing yields to the event loop between batches.
				return fOnBatch(tmpBatch, (pError) => (pError ? fDone(pError) : setImmediate(fPump)));
			};
			return fPump();
		},
	};
};

/**
 * A comprehension table stores either one record per row — `EntityName`, `RecordGUID`,
 * `RecordJSON` — or one CHUNK of records per row. The chunked layout exists because a single-pass
 * streaming clone cannot produce a per-record `RecordJSON`: `{~DataJson:Record~}` in that layout
 * serializes the source row, and building the JSON by string interpolation instead is what
 * produced 268 malformed rows the last time it was tried. A chunk's `RecordsJSON` is serialized
 * from the already-projected records, so the problem does not arise.
 *
 * @typedef {Object} ChunkRow
 * @property {string} EntityName
 * @property {number} ChunkOrdinal - 0-based, contiguous within an entity.
 * @property {number} ChunkCount - Chunks this entity is expected to have.
 * @property {number} RecordCount - Records in this chunk.
 * @property {number} SourceRowCount - Records this entity is expected to have.
 * @property {string} RecordsJSON - JSON array of records.
 */

/**
 * @param {Object} pRow
 * @return {boolean}
 */
const isChunkRow = function(pRow)
{
	return !!pRow && (typeof(pRow) === 'object') && Object.prototype.hasOwnProperty.call(pRow, 'RecordsJSON');
};

/**
 * @param {string|Array<Object>} pRecordsJSON
 * @param {string} pWhere - identifies the row in an error message
 * @return {Array<Object>}
 */
const parseChunkRecords = function(pRecordsJSON, pWhere)
{
	if (Array.isArray(pRecordsJSON))
	{
		return pRecordsJSON;
	}
	let tmpParsed;
	try
	{
		tmpParsed = JSON.parse(pRecordsJSON);
	}
	catch (pError)
	{
		throw new Error(`${pWhere}: RecordsJSON is not valid JSON — ${pError.message}`);
	}
	if (!Array.isArray(tmpParsed))
	{
		throw new Error(`${pWhere}: RecordsJSON parsed to ${typeof(tmpParsed)}, expected an array of records.`);
	}
	return tmpParsed;
};

/**
 * Everything a chunked entity claims about itself, accumulated as its rows are read.
 *
 * @return {Object}
 */
const emptyChunkTally = function()
{
	return { Ordinals: [], RecordSum: 0, DeclaredChunks: null, DeclaredRecords: null, Shape: emptyShape() };
};

/**
 * Decide whether an entity's chunks amount to a complete set.
 *
 * A dropped write costs `ChunkSize` records here rather than one, and `WriteRecords` has reported
 * success while losing whole chunks. So this is a precondition, not a diagnostic: three
 * independent invariants, any of which failing means the table is not loadable.
 *
 * @param {string} pEntity
 * @param {Object} pTally
 * @return {Array<string>} problems; empty when the entity is complete
 */
const findChunkProblems = function(pEntity, pTally)
{
	const tmpProblems = [];
	if (pTally.DeclaredChunks === null)
	{
		return [ `${pEntity}: no chunk rows found` ];
	}
	if (pTally.Ordinals.length !== pTally.DeclaredChunks)
	{
		tmpProblems.push(`${pEntity}: ${pTally.Ordinals.length} chunk row(s) present, ${pTally.DeclaredChunks} declared`);
	}
	const tmpSorted = pTally.Ordinals.slice().sort((pLeft, pRight) => pLeft - pRight);
	for (let i = 0; i < tmpSorted.length; i++)
	{
		if (tmpSorted[i] !== i)
		{
			tmpProblems.push(`${pEntity}: chunk ordinals are not contiguous — expected ${i}, found ${tmpSorted[i]}`);
			break;
		}
	}
	if (pTally.RecordSum !== pTally.DeclaredRecords)
	{
		tmpProblems.push(`${pEntity}: chunk record counts sum to ${pTally.RecordSum}, SourceRowCount declares ${pTally.DeclaredRecords}`);
	}
	return tmpProblems;
};

/**
 * Build a source over a chunked comprehension table.
 *
 * Two passes. The first reads every chunk row to derive each entity's shape and prove the set
 * complete, keeping only the shape — the records are parsed and discarded, so memory stays at one
 * chunk. The second pass is `streamRecords`, which re-reads and hands each chunk over as a batch.
 *
 * The shape cannot be sampled: `PopulatedFields` drives the dependency sort, and a populated field
 * that appears only in a late record would go unseen, dropping an edge and letting a child load
 * before its parent.
 *
 * @param {(pEntity: string|null, pOffset: number, pLimit: number, fCallback: (pError: Error|null, pRows?: Array<ChunkRow>) => void) => void} fReadChunkPage
 *        Pages chunk rows in a stable order. `pEntity` null means every entity.
 * @param {Object} [pOptions]
 * @param {number} [pOptions.PageSize] - Chunk ROWS per read. Resident records are this times the
 *        chunk size, so it is deliberately small.
 * @param {function} fCallback - function(pError, pSource)
 * @return {void}
 */
const fromChunkedTable = function(fReadChunkPage, pOptions, fCallback)
{
	const tmpPageSize = (pOptions && pOptions.PageSize) || 20;
	/** @type {Object<string, Object>} */
	const tmpTallies = {};
	let tmpOffset = 0;

	const fScanPage = () =>
	{
		fReadChunkPage(null, tmpOffset, tmpPageSize, (pError, pRows) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			const tmpRows = Array.isArray(pRows) ? pRows : [];
			if (tmpRows.length === 0)
			{
				return fFinishScan();
			}
			for (const tmpRow of tmpRows)
			{
				const tmpEntity = tmpRow.EntityName;
				if (!tmpEntity)
				{
					return fCallback(new Error(`Chunk row at offset ${tmpOffset} is missing EntityName — not a comprehension table.`));
				}
				if (!tmpTallies[tmpEntity])
				{
					tmpTallies[tmpEntity] = emptyChunkTally();
				}
				const tmpTally = tmpTallies[tmpEntity];
				let tmpRecords;
				try
				{
					tmpRecords = parseChunkRecords(tmpRow.RecordsJSON, `${tmpEntity} chunk ${tmpRow.ChunkOrdinal}`);
				}
				catch (pParseError)
				{
					return fCallback(pParseError);
				}
				tmpTally.Ordinals.push(parseInt(tmpRow.ChunkOrdinal, 10));
				tmpTally.RecordSum += tmpRecords.length;
				tmpTally.DeclaredChunks = parseInt(tmpRow.ChunkCount, 10);
				tmpTally.DeclaredRecords = parseInt(tmpRow.SourceRowCount, 10);
				// RecordCount is what the row claims; the parsed length is what it holds. A
				// disagreement means the row was truncated in transit and the sum below would
				// otherwise validate against the claim rather than the contents.
				const tmpClaimed = parseInt(tmpRow.RecordCount, 10);
				if (Number.isFinite(tmpClaimed) && (tmpClaimed !== tmpRecords.length))
				{
					return fCallback(new Error(`${tmpEntity} chunk ${tmpRow.ChunkOrdinal}: RecordCount claims ${tmpClaimed} but RecordsJSON holds ${tmpRecords.length}.`));
				}
				for (const tmpRecord of tmpRecords)
				{
					foldRecordIntoShape(tmpTally.Shape, tmpRecord);
				}
			}
			tmpOffset += tmpRows.length;
			return setImmediate(fScanPage);
		});
	};

	const fFinishScan = () =>
	{
		const tmpEntityTypes = Object.keys(tmpTallies);
		if (tmpEntityTypes.length === 0)
		{
			return fCallback(new Error('The chunked comprehension table holds no rows.'));
		}
		let tmpProblems = [];
		for (const tmpEntity of tmpEntityTypes)
		{
			tmpProblems = tmpProblems.concat(findChunkProblems(tmpEntity, tmpTallies[tmpEntity]));
		}
		if (tmpProblems.length > 0)
		{
			return fCallback(new Error(`The chunked comprehension is incomplete and was not loaded: ${tmpProblems.join('; ')}.`));
		}

		/** @type {Object<string, EntityShape>} */
		const tmpShapes = {};
		for (const tmpEntity of tmpEntityTypes)
		{
			tmpShapes[tmpEntity] = tmpTallies[tmpEntity].Shape;
		}

		return fCallback(null,
			{
				EntityTypes: tmpEntityTypes,
				EntityShapes: tmpShapes,
				recordCount: (pEntity) => (tmpTallies[pEntity] ? tmpTallies[pEntity].RecordSum : 0),
				streamRecords: (pEntity, fOnBatch, fDone) =>
				{
					let tmpStreamOffset = 0;
					const fPump = () =>
					{
						fReadChunkPage(pEntity, tmpStreamOffset, tmpPageSize, (pError, pRows) =>
						{
							if (pError)
							{
								return fDone(pError);
							}
							const tmpRows = Array.isArray(pRows) ? pRows : [];
							if (tmpRows.length === 0)
							{
								return fDone();
							}
							tmpStreamOffset += tmpRows.length;
							let tmpIndex = 0;
							const fNextRow = () =>
							{
								if (tmpIndex >= tmpRows.length)
								{
									return setImmediate(fPump);
								}
								const tmpRow = tmpRows[tmpIndex++];
								let tmpRecords;
								try
								{
									tmpRecords = parseChunkRecords(tmpRow.RecordsJSON, `${pEntity} chunk ${tmpRow.ChunkOrdinal}`);
								}
								catch (pParseError)
								{
									return fDone(pParseError);
								}
								// One chunk is one batch — the shape was built for exactly this.
								return fOnBatch(tmpRecords, (pBatchError) => (pBatchError ? fDone(pBatchError) : setImmediate(fNextRow)));
							};
							return fNextRow();
						});
					};
					return fPump();
				},
			});
	};

	return fScanPage();
};

/**
 * @param {any} pCandidate
 * @return {boolean} True when this is already a source rather than a raw comprehension.
 */
const isComprehensionSource = function(pCandidate)
{
	return !!pCandidate && Array.isArray(pCandidate.EntityTypes) && (typeof(pCandidate.streamRecords) === 'function');
};

/**
 * Accept either shape at an entry point, so callers holding a comprehension keep working.
 *
 * @param {Object|ComprehensionSource} pCandidate
 * @return {ComprehensionSource}
 */
const asComprehensionSource = function(pCandidate)
{
	return isComprehensionSource(pCandidate) ? pCandidate : fromComprehension(pCandidate);
};

module.exports =
	{
		deriveEntityShape,
		foldRecordIntoShape,
		emptyShape,
		fromComprehension,
		fromChunkedTable,
		isChunkRow,
		parseChunkRecords,
		findChunkProblems,
		isComprehensionSource,
		asComprehensionSource,
	};

}).call(this)}).call(this,require("timers").setImmediate)

},{"timers":749}],5:[function(require,module,exports){

const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libIntegrationAdapter = require('headlight-integration-adapter');
const libGUIDBatchResolver = libIntegrationAdapter.GUIDBatchResolver;
const libDeletedRecordReviver = require('./Headlight-Deleted-Record-Reviver.js');
const libComprehensionSource = require('./Comprehension-Source.js');

const SPECIAL_TABLES_KEYS = new Set(['OnSave', 'OnApprovalAction', 'OnEnteringState', 'ExecutionLog']);

class HeadlightComprehensionProcessor extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the adapter
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client') }} */
		this.fable;

		this.serviceType = 'ComprehensionProcessor';

		/** @type {import('headlight-rest-client')} */
		this._Client = null;

		/** @type {import('headlight-integration-adapter').GUIDBatchResolver} */
		this._GUIDBatchResolver = null;
	}

	/**
	 * Order the entity types so a referenced entity is always integrated before the entity that
	 * references it.
	 *
	 * Reads shapes only — never records — so this costs the same on a 200-row comprehension and a
	 * 200,000-row one. The two ordering forms are deliberately tested differently: a `GUID<Entity>`
	 * edge needs a populated value somewhere, while a `…_Via_GUID<Entity>` edge is established by the
	 * field name alone. `_GUID<Entity>` addresses a record that already exists on the server, so it
	 * establishes no edge at all.
	 *
	 * @param {import('./Comprehension-Source.js').ComprehensionSource|Object} pSource - A source, or
	 *        a raw comprehension, which is wrapped.
	 * @return {Array<string>} The entity types in dependency order.
	 */
	getAdapterSequence(pSource)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pSource);
		/** @type {Record<string, Array<string>>} */
		const tmpDependencyMap = { };
		const tmpTables = tmpSource.EntityTypes.filter((pTable) => !SPECIAL_TABLES_KEYS.has(pTable));
		for (const tmpTable of tmpTables)
		{
			const tmpShape = tmpSource.EntityShapes[tmpTable] || libComprehensionSource.emptyShape();
			for (const tmpTableKey of tmpTables)
			{
				if (tmpTable === tmpTableKey)
				{
					continue;
				}
				// A direct reference counts only where some record populated it; an empty column is
				// not a dependency.
				let tmpHasDependency = (tmpShape.PopulatedFields.indexOf(`GUID${tmpTableKey}`) > -1);

				// `_Dest_IDEntity_*_Via_GUID{Table}` is established by the field name.
				if (!tmpHasDependency)
				{
					const tmpViaKey = `_Via_GUID${tmpTableKey}`;
					for (const tmpFieldKey of tmpShape.Fields)
					{
						if (tmpFieldKey.endsWith(tmpViaKey))
						{
							tmpHasDependency = true;
							break;
						}
					}
				}

				if (tmpHasDependency)
				{
					if (!tmpDependencyMap[tmpTable])
					{
						tmpDependencyMap[tmpTable] = [];
					}
					if (!tmpDependencyMap[tmpTable].includes(tmpTableKey))
					{
						this.fable.log.info(`Data dependency detected: [${tmpTableKey}] must come before [${tmpTable}]`);
						tmpDependencyMap[tmpTable].push(tmpTableKey);
					}
				}
			}
		}
		return this.topologicalSort(tmpTables, tmpDependencyMap);
	}

	/**
	 * Sort the adapters topologically based on their dependencies.
	 *
	 * @param {Array<string>} pNodes - The nodes to sort
	 * @param {Record<string, Array<string>>} pDependencyMap - The dependency map
	 *
	 * @return {Array<string>} - The sorted keys
	 */
	topologicalSort(pNodes, pDependencyMap)
	{
		/* Algorithm source: https://en.wikipedia.org/wiki/Topological_sorting#Kahn's_algorithm
		L ← Empty list that will contain the sorted elements
		S ← Set of all nodes with no incoming edges
		while S is non-empty do
			remove a node n from S
			add n to tail of L
			for each node m with an edge e from n to m do
				remove edge e from the graph
				if m has no other incoming edges then
					insert m into S
		if graph has edges then
			return error (graph has at least one cycle)
		else
			return L (a topologically sorted order)
		 */
		const tmpL = [];
		const tmpS = pNodes.filter((pNode) => !Object.keys(pDependencyMap).includes(pNode));
		const tmpDependencyMap = JSON.parse(JSON.stringify(pDependencyMap));

		while (tmpS.length > 0)
		{
			const tmpN = tmpS.pop();
			tmpL.push(tmpN);
			for (const tmpM in tmpDependencyMap)
			{
				if (tmpDependencyMap[tmpM].includes(tmpN))
				{
					tmpDependencyMap[tmpM] = tmpDependencyMap[tmpM].filter((pNode) => pNode !== tmpN);
					if (tmpDependencyMap[tmpM].length === 0)
					{
						tmpS.push(tmpM);
						delete tmpDependencyMap[tmpM];
					}
				}
			}
		}
		if (Object.keys(tmpDependencyMap).length > 0)
		{
			throw new Error(`Graph has at least one cycle: ${JSON.stringify(tmpDependencyMap)}`);
		}
		return tmpL;
	}

	/**
	 * @param {Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>} pComprehension - The comprehension to integrate
	 * @param {Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>} pPreviousComprehension - The previous comprehension to diff against. Any GUIDs not present in the new comprehension will be deleted.
	 * @param {(pError?: Error, pUpdatedComprehension?: Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>) => void} fCallback - A callback invoked when the integration is complete - if records are deleted, the updated comprehension after deletions will be passed as the second parameter
	 * @param {(pRecord: Record<string, any>, pTable: string) => boolean} [fCanRecordBeDeleted] - (optional) A function that determines if a record can be deleted. If not provided, all records not present in the new comprehension will be deleted.
	 */
	integrateComprehensionWithDiffDelete(pComprehension, pPreviousComprehension, fCallback, fCanRecordBeDeleted)
	{
		let tmpUpdatedComprehension = JSON.parse(JSON.stringify(pPreviousComprehension || { }));
		this.integrateComprehension(pComprehension, (pError) =>
		{
			// Surgically merge the new entity records (regular tables) into the copy of the previous
			// comprehension. Intent-typed special keys (OnSave/OnApprovalAction/OnEnteringState) live only on
			// Document.EntityData (never in the FormData entity-data copy); the copy above preserves them
			// untouched, and we skip them here so they are never merged, diffed, or deleted.
			for (const tmpTableKey in pComprehension)
			{
				if (SPECIAL_TABLES_KEYS.has(tmpTableKey))
				{
					continue;
				}
				const tmpRecordMap = pComprehension[tmpTableKey];
				for (const tmpRecordGUID in tmpRecordMap)
				{
					tmpUpdatedComprehension[tmpTableKey] = tmpUpdatedComprehension[tmpTableKey] || {};
					tmpUpdatedComprehension[tmpTableKey][tmpRecordGUID] = tmpRecordMap[tmpRecordGUID];
				}
			}
			if (!pPreviousComprehension || Object.keys(pPreviousComprehension).length === 0)
			{
				// No baseline to diff against (e.g. first save): nothing to delete; persist the merged comprehension.
				return fCallback(pError, tmpUpdatedComprehension);
			}
			const tmpRecordsToDelete = [];
			for (const tmpTableKey in pPreviousComprehension)
			{
				if (SPECIAL_TABLES_KEYS.has(tmpTableKey))
				{
					continue;
				}
				const tmpPreviousRecordMap = pPreviousComprehension[tmpTableKey];
				for (const tmpRecordGUID in tmpPreviousRecordMap)
				{
					if (pComprehension?.[tmpTableKey]?.[tmpRecordGUID])
					{
						continue;
					}
					if (typeof fCanRecordBeDeleted === 'function' && !fCanRecordBeDeleted(tmpPreviousRecordMap[tmpRecordGUID], tmpTableKey))
					{
						continue;
					}
					tmpRecordsToDelete.push({ Table: tmpTableKey, GUID: tmpRecordGUID });
					if (tmpUpdatedComprehension?.[tmpTableKey]?.[tmpRecordGUID])
					{
						delete tmpUpdatedComprehension[tmpTableKey][tmpRecordGUID];
					}
				}
			}
			if (tmpRecordsToDelete.length < 1)
			{
				// Nothing to delete, but the merged comprehension (new entities + preserved special keys) must persist.
				return fCallback(pError, tmpUpdatedComprehension);
			}
			const tmpClient = this.client;
			const tmpAnticipate = this.fable.newAnticipate();
			tmpAnticipate.anticipate(
				(fNext) =>
				{
					tmpClient.getJSON('CheckSession', (pError, pSession) =>
					{
						if (!pError && pSession?.LoggedIn)
						{
							return fNext();
						}
						tmpClient.authenticate(
							(pError, pResponse) =>
							{
								if (pError)
								{
									this.log.error(`Error authenticating`, pError);
								}
								else
								{
									this.log.info(`Authenticated - Session [${pResponse.SessionID}]`);
								}
								return fNext(pError);
							});
					});
				});

			tmpAnticipate.anticipate(
				(fNext) =>
				{
					this.fable.log.info(`Going to delete ${tmpRecordsToDelete.length} records by GUID...`);
					/** @type {Map<string, Set<string>>} */
					const tmpDeleteTargets = new Map();
					for (const tmpRecord of tmpRecordsToDelete)
					{
						if (!tmpDeleteTargets.has(tmpRecord.Table))
						{
							tmpDeleteTargets.set(tmpRecord.Table, new Set());
						}
						tmpDeleteTargets.get(tmpRecord.Table).add(tmpRecord.GUID);
					}
					this.guidBatchResolver.resolveReferences(tmpDeleteTargets)
						.then(() => fNext())
						.catch((pError) =>
						{
							this.fable.log.warn(`Could not resolve records to delete in batches: ${pError.message || pError}`);
							return fNext();
						});
				});
			const fResolveRecordID = (pTable, pGUID) =>
			{
				const tmpGUIDMap = this.guidBatchResolver.guidMap;
				return tmpGUIDMap.getHeadlightIDFromExternalGUID(pTable, pGUID) || tmpGUIDMap.getIDFromGUID(pTable, pGUID);
			};
			for (const tmpRecord of tmpRecordsToDelete)
			{
				tmpAnticipate.anticipate(
					(fNext) =>
					{
						const tmpIDRecord = fResolveRecordID(tmpRecord.Table, tmpRecord.GUID);
						if (!tmpIDRecord)
						{
							this.fable.log.warn(`Record to delete not found: ${tmpRecord.Table} - ${tmpRecord.GUID}`);
							return fNext();
						}
						tmpClient.deleteEntity(tmpRecord.Table, tmpIDRecord, (pError) =>
							{
								if (pError)
								{
									this.fable.log.error(`Error deleting record: ${tmpRecord.Table} - ${tmpRecord.GUID}`, pError);
								}
								return fNext();
							});
					});
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error importing comprehension file.`, pError);
						return fCallback(pError, tmpUpdatedComprehension);
					}
					this.fable.log.info(`Finished importing comprehension file.`);
					return fCallback(null, tmpUpdatedComprehension);
				});
		});
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		if (this.options.UseSiloedClient)
		{
			if (!this._Client)
			{
				this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
				this._Client = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', this.options);
			}
			return this._Client;
		}

		let tmpClient = this.fable.services.HeadlightRestClient;
		if (!tmpClient)
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			tmpClient = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', this.options);
		}
		return tmpClient;
	}

	set client(pClient)
	{
		this._Client = pClient;
	}

	/**
	 * Build the option set for one entity's integration adapter. The caller's
	 * upsert tuning — RecordThresholdForBulkUpsert, BulkUpsertBatchSize,
	 * RecordPushRetryThreshold — is forwarded when supplied as a positive
	 * integer on the processor's options; the adapter's own defaults apply
	 * otherwise.
	 *
	 * @param {string} pEntity - The entity the adapter will integrate.
	 * @return {Record<string, any>} Options for a headlight-integration-adapter instance.
	 */
	buildAdapterOptions(pEntity)
	{
		/** @type {Record<string, any>} */
		const tmpOptions =
			{
				Entity: pEntity,
				EntityGUIDMarshalPrefix: '',
				AdapterSetGUIDMarshalPrefix: '',
				SimpleMarshal: true,
				ForceMarshal: true,
			};
		for (const tmpTuningKey of [ 'RecordThresholdForBulkUpsert', 'BulkUpsertBatchSize', 'RecordPushRetryThreshold' ])
		{
			const tmpValue = parseInt(this.options[tmpTuningKey], 10);
			if (Number.isFinite(tmpValue) && tmpValue > 0)
			{
				tmpOptions[tmpTuningKey] = tmpValue;
			}
		}
		return tmpOptions;
	}

	/**
	 * Revive any soft-deleted records the comprehension is about to upsert.
	 *
	 * Enabled by the `ReviveDeletedRecords` option. Off by default because the
	 * scan costs a paged read per entity, and most loads never touch a deleted
	 * GUID; a pipeline that deletes and later restores records wants it on.
	 *
	 * @param {Record<string, any>} pComprehension
	 * @param {(pError?: Error, pSummary?: Object) => void} fCallback
	 */
	reviveDeletedRecords(pSource, fCallback)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pSource);
		let tmpEntitySequence;
		try
		{
			tmpEntitySequence = this.getAdapterSequence(tmpSource).filter((pEntity) => !SPECIAL_TABLES_KEYS.has(pEntity));
		}
		catch (pError)
		{
			return fCallback(pError);
		}

		this.fable.serviceManager.addServiceType('DeletedRecordReviver', libDeletedRecordReviver);
		const tmpReviver = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('DeletedRecordReviver',
			{ ScanLimit: this.options.RevivalScanLimit });
		tmpReviver.client = this.client;

		// Per entity, per batch: `reviveEntity` answers a tally, so batches sum rather than needing
		// the whole comprehension resident.
		const tmpResults = [];
		let tmpTotalRevived = 0;
		let tmpTotalFailed = 0;
		const fReviveEntity = (pIndex, fDone) =>
		{
			if (pIndex >= tmpEntitySequence.length)
			{
				return fDone();
			}
			const tmpEntity = tmpEntitySequence[pIndex];
			return tmpSource.streamRecords(tmpEntity,
				(pRecords, fNext) =>
				{
					tmpReviver.reviveEntity(tmpEntity, pRecords)
						.then((pResult) =>
						{
							tmpResults.push(pResult);
							tmpTotalRevived += pResult.Revived;
							tmpTotalFailed += pResult.Failed;
							return fNext();
						})
						.catch((pError) => fNext(pError));
				},
				(pError) => (pError ? fDone(pError) : fReviveEntity(pIndex + 1, fDone)));
		};

		return fReviveEntity(0, (pError) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				return fCallback(null, { Entities: tmpResults, TotalRevived: tmpTotalRevived, TotalFailed: tmpTotalFailed });
			});
	}

	/**
	 * The batch resolver shared by every entity in one comprehension load.
	 *
	 * @return {import('headlight-integration-adapter').GUIDBatchResolver}
	 */
	get guidBatchResolver()
	{
		if (!this._GUIDBatchResolver)
		{
			this.fable.serviceManager.addServiceType('IntegrationGUIDBatchResolver', libGUIDBatchResolver);
			this._GUIDBatchResolver = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('IntegrationGUIDBatchResolver',
				this.options.GUIDBatchResolutionOptions || {});
		}
		this._GUIDBatchResolver.client = this.client;
		return this._GUIDBatchResolver;
	}

	/**
	 * Ask the server, once, whether it serves the body-driven read route, so the
	 * batch resolver can send large IN lists in a request body instead of
	 * chunking them across URI-bounded reads.  The capability rides along on
	 * every entity's schema, so any entity in the comprehension answers it.
	 *
	 * @param {Array<string>} pEntitySequence - The entities being loaded.
	 * @param {() => void} fCallback - Invoked once the capability is known (or known to be unknowable).
	 */
	loadBatchReadCapability(pEntitySequence, fCallback)
	{
		const tmpResolver = this.guidBatchResolver;
		if (typeof(tmpResolver.QueryEndpointSupported) === 'boolean' || pEntitySequence.length < 1)
		{
			return fCallback();
		}
		this.client.getJSON(`${pEntitySequence[0]}/Schema`,
			(pError, pSchema) =>
			{
				if (pError)
				{
					this.fable.log.info(`Could not read the [${pEntitySequence[0]}] schema to detect batch read capabilities; using URI reads.`);
					tmpResolver.QueryEndpointSupported = false;
					return fCallback();
				}
				tmpResolver.applySchemaCapabilities(pSchema);
				return fCallback();
			});
	}

	/**
	 * Resolve every GUID the comprehension references, across all of its
	 * entities, in batched reads before any adapter runs.
	 *
	 * The per-entity adapters do the same thing for their own slice, but doing
	 * it once for the whole comprehension collapses what would otherwise be one
	 * batch round-trip per entity into a handful -- which is what the browser
	 * save path (many entities, few records each) actually spends its time on.
	 * Only hits are cached: a reference whose target this run is about to create
	 * has to stay resolvable later.
	 *
	 * @param {Record<string, any>} pComprehension - The comprehension to scan.
	 * @param {Array<string>} pEntitySequence - The entities being loaded.
	 * @param {(pError?: Error, pSummary?: Object) => void} fCallback - Invoked when the prefetch is done.
	 */
	prefetchComprehensionGUIDs(pSource, pEntitySequence, fCallback)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pSource);
		/** @type {Map<string, Set<string>>} */
		let tmpReferences = new Map();

		// The collector merges into an existing map, so batches fold in one at a time and the map
		// stays bounded by distinct referenced GUIDs rather than by record count.
		const tmpEntities = pEntitySequence.filter((pEntity) => !SPECIAL_TABLES_KEYS.has(pEntity));
		const fCollectEntity = (pIndex, fDone) =>
		{
			if (pIndex >= tmpEntities.length)
			{
				return fDone();
			}
			const tmpEntity = tmpEntities[pIndex];
			return tmpSource.streamRecords(tmpEntity,
				(pRecords, fNext) =>
				{
					tmpReferences = libGUIDBatchResolver.collectMappedGUIDReferences(pRecords, `GUID${tmpEntity}`, tmpReferences);
					return fNext();
				},
				(pError) => (pError ? fDone(pError) : fCollectEntity(pIndex + 1, fDone)));
		};

		return fCollectEntity(0, (pStreamError) =>
		{
		if (pStreamError)
		{
			this.fable.log.warn(`Could not read records for GUID pre-resolution; entity adapters will resolve references themselves: ${pStreamError.message || pStreamError}`);
			return fCallback();
		}
		if (tmpReferences.size < 1)
		{
			return fCallback();
		}

		this.loadBatchReadCapability(pEntitySequence,
			() =>
			{
				this.guidBatchResolver.resolveReferences(tmpReferences)
					.then((pSummary) =>
					{
						const tmpUnverifiedNote = (pSummary.Unverified > 0) ? `, ${pSummary.Unverified} left to single lookups` : '';
						this.fable.log.info(`Pre-resolved ${pSummary.Resolved} of ${pSummary.Requested} referenced GUID(s) across ${tmpReferences.size} entities in ${pSummary.Requests} batch read(s)${tmpUnverifiedNote}.`);
						return fCallback(null, pSummary);
					})
					.catch((pError) =>
					{
						this.fable.log.warn(`Batch GUID pre-resolution did not complete; entity adapters will resolve references themselves: ${pError.message || pError}`);
						return fCallback();
					});
			});
		});
	}

	/**
	 * @param {Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>} pComprehension - The comprehension to integrate
	 * @param {(pError?: Error) => void} fCallback - A callback invoked when the integration is complete
	 */
	integrateComprehension(pComprehension, fCallback)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pComprehension);
		const tmpClient = this.client;
		const tmpAnticipate = this.fable.newAnticipate();

		// Track stats for the summary
		let tmpStats = { entities: {}, startTime: Date.now(), warnings: 0, errors: 0, revived: 0 };

		// Intercept log warnings/errors to count them
		let tmpOriginalWarn = this.fable.log.warn.bind(this.fable.log);
		let tmpOriginalError = this.fable.log.error.bind(this.fable.log);
		this.fable.log.warn = (...pArgs) => { tmpStats.warnings++; return tmpOriginalWarn(...pArgs); };
		this.fable.log.error = (...pArgs) => { tmpStats.errors++; return tmpOriginalError(...pArgs); };

		this.fable.log.info(`Initializing and configuring data integration adapters...`);
		this.fable.serviceManager.addServiceType('IntegrationAdapter', libIntegrationAdapter);

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				tmpClient.getJSON('CheckSession', (pError, pSession) =>
				{
					if (!pError && pSession?.LoggedIn)
					{
						return fCallback();
					}
					tmpClient.authenticate(
						(pError, pResponse) =>
						{
							if (pError)
							{
								this.log.error(`Error authenticating`, pError);
							}
							else
							{
								this.log.info(`Authenticated - Session [${pResponse.SessionID}]`);
							}
							return fCallback(pError);
						});
				});
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				if (!this.options.ReviveDeletedRecords)
				{
					return fCallback();
				}
				// Upsert cannot see a soft-deleted row, so a GUID belonging to one
				// would create a silent duplicate instead of reviving the original.
				// Revive them first, before any adapter runs.
				this.reviveDeletedRecords(tmpSource,
					(pError, pSummary) =>
					{
						if (pError)
						{
							this.fable.log.error(`Error reviving soft-deleted records; continuing with the push.`, pError);
						}
						else if (pSummary && pSummary.TotalRevived > 0)
						{
							tmpStats.revived = pSummary.TotalRevived;
							this.fable.log.info(`Revived ${pSummary.TotalRevived} soft-deleted record(s) before upsert.`);
						}
						return fCallback();
					});
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				if (this.options.BatchGUIDResolution === false)
				{
					return fCallback();
				}
				let tmpEntitySequence;
				try
				{
					tmpEntitySequence = this.getAdapterSequence(tmpSource);
				}
				catch (pError)
				{
					// A dependency cycle is reported by the wiring stage below.
					return fCallback();
				}
				return this.prefetchComprehensionGUIDs(tmpSource, tmpEntitySequence, () => fCallback());
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				this.fable.log.info(`Wiring up Integration Adapters...`);

				const tmpIntegrationAdapterSet = this.getAdapterSequence(tmpSource);
				this.fable.log.info(`Integration Adapter sequence: ${tmpIntegrationAdapterSet.join(' -> ')}`);

				try
				{
					for (let i = 0; i < tmpIntegrationAdapterSet.length; i++)
					{
						// Initialize the adapter
						const tmpAdapterKey = tmpIntegrationAdapterSet[i];
						const tmpRecordCount = tmpSource.recordCount(tmpAdapterKey);
						tmpStats.entities[tmpAdapterKey] = { input: tmpRecordCount };

						if (tmpRecordCount === 0)
						{
							//NOTE: if you invoke the adapter with zero records, it logs an error; just skip, nothing to do
							continue;
						}

						/** @type {libIntegrationAdapter} */
						const tmpAdapter = this.fable.instantiateServiceProviderWithoutRegistration('IntegrationAdapter', this.buildAdapterOptions(tmpAdapterKey));
						tmpAdapter.client = tmpClient;
						this.runAdapter(tmpAnticipate, tmpAdapter, tmpSource, tmpAdapterKey);
					}
				}
				catch (pError)
				{
					this.fable.log.error(`Error wiring up integration adapters: ${pError}`, pError);
					return fCallback(pError);
				}

				return fCallback();
			});

		tmpAnticipate.wait(
			(pError) =>
			{
				// Restore original log methods
				this.fable.log.warn = tmpOriginalWarn;
				this.fable.log.error = tmpOriginalError;

				// Print summary
				let tmpElapsed = ((Date.now() - tmpStats.startTime) / 1000).toFixed(1);
				this.fable.log.info(`\n========== Integration Summary ==========`);
				this.fable.log.info(`Duration: ${tmpElapsed}s`);
				this.fable.log.info(`Entity records pushed:`);
				for (let tmpEntity in tmpStats.entities)
				{
					this.fable.log.info(`  ${tmpEntity}: ${tmpStats.entities[tmpEntity].input}`);
				}
				if (tmpStats.revived > 0)
				{
					this.fable.log.info(`Soft-deleted records revived before upsert: ${tmpStats.revived}`);
				}
				if (tmpStats.warnings > 0)
				{
					this.fable.log.warn(`Warnings: ${tmpStats.warnings} (review log output above for details)`);
				}
				if (tmpStats.errors > 0)
				{
					this.fable.log.error(`Errors: ${tmpStats.errors} (review log output above for details)`);
				}
				if (tmpStats.warnings === 0 && tmpStats.errors === 0)
				{
					this.fable.log.info(`No warnings or errors.`);
				}
				this.fable.log.info(`==========================================\n`);

				if (pError)
				{
					this.fable.log.error(`Error importing comprehension file.`, pError);
					return fCallback(pError);
				}
				this.fable.log.info(`Finished importing comprehension file.`);
				return fCallback(pError);
			});
	}

	/**
	 * Feed one entity's records into its adapter, a batch at a time.
	 *
	 * The adapter still accumulates what it is given before `integrateRecords` runs, so this bounds
	 * what the PROCESSOR holds, not yet what the adapter does — see the note in the class header.
	 *
	 * @param {any} pAnticipate - The anticipate instance - FIXME: not exporting this interface - fake types anyway
	 * @param {import('headlight-integration-adapter')} pAdapter - The adapter to feed
	 * @param {import('./Comprehension-Source.js').ComprehensionSource} pSource - The record source
	 * @param {string} pEntity - The entity type to stream
	 * @param {(pRecord: Record<string, any>) => Record<string, any>} [fMarshalRecord] - (optional) A function to marshal each record before integration
	 */
	runAdapter(pAnticipate, pAdapter, pSource, pEntity, fMarshalRecord)
	{
		let tmpAdapter = pAdapter;

		if (!tmpAdapter)
		{
			throw new Error(`Adapter not found.`);
		}
		let tmpPrefix = this.options.prefix || this.fable.settings.prefix;
		if (tmpPrefix)
		{
			tmpAdapter.AdapterSetGUIDMarshalPrefix = tmpPrefix;
		}

		let tmpMarshalRecordFunction = fMarshalRecord;
		pAnticipate.anticipate(
			(fDone) =>
			{
				pSource.streamRecords(pEntity,
					(pRecords, fNext) =>
					{
						for (const tmpRecord of pRecords)
						{
							tmpAdapter.addSourceRecord(tmpRecord);
						}
						return fNext();
					},
					fDone);
			});
		pAnticipate.anticipate(
			(fDone) =>
			{
				tmpAdapter.integrateRecords(fDone, tmpMarshalRecordFunction);
			});
	}

	getCapitalLettersAsString(inputString)
	{
		let tmpRegex = /[A-Z]/g;
		let tmpMatch = inputString.match(tmpRegex);
		let tmpString = tmpMatch ? tmpMatch.join('') : 'UNK';
		return tmpString;
	}
}

module.exports = HeadlightComprehensionProcessor;
/** @type {Record<string, any>} */
module.exports.default_configuration = { };

},{"./Comprehension-Source.js":4,"./Headlight-Deleted-Record-Reviver.js":6,"fable-serviceproviderbase":398,"headlight-integration-adapter":7,"headlight-rest-client":12}],6:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Reads exclude soft-deleted rows unless this exact query parameter is present.
 * It is case-sensitive and value-sensitive: `includedeleted`, `IncludeDeleted`
 * and `includeDeleted=1` are all ignored, silently returning zero rows.
 */
const INCLUDE_DELETED_PARAMETER = 'includeDeleted=true';

/**
 * Records are read back in pages of this size while scanning for soft-deleted
 * GUIDs. Kept modest because the read carries every column.
 */
const SCAN_PAGE_SIZE = 500;

/**
 * A scan that would walk more rows than this bails out and reports it rather
 * than silently spending minutes on a table with a large delete history. The
 * caller can raise it deliberately.
 */
const DEFAULT_SCAN_LIMIT = 20000;

/**
 * Revives soft-deleted records whose GUIDs are about to be upserted.
 *
 * Upsert resolves an existing record by reading it back by GUID, and reads
 * exclude soft-deleted rows. A GUID belonging to a deleted row therefore looks
 * absent, so Upsert takes the CREATE branch -- and the create is then rejected
 * by the GUID uniqueness guard, which does see the deleted row:
 *
 *     Error creating record:Error in DAL create: Record with GUID <guid> already exists!
 *
 * That rejection arrives as an `Error` property inside an HTTP **200** body
 * with no identity column, so it does not surface as a transport error. The
 * integration adapter cannot match it either -- its duplicate-detection looks
 * for `Duplicate entry`, which this message does not contain -- so the record
 * burns the retry budget and is then abandoned. The net effect is a record
 * that silently never lands, on a load that reports success.
 *
 * This service closes the gap by reviving those rows before the push, so the
 * subsequent Upsert finds the original and updates it in place.
 *
 * Reviving requires two things from the API:
 *   - reading soft-deleted rows, via `?includeDeleted=true`; and
 *   - `GET /<Entity>/Undelete/:IDRecord`, which exists in meadow-endpoints 4.x
 *     but is NOT registered in 2.1.1 (`api/headlight`). Update cannot
 *     substitute -- meadow excludes the Deleted column from updatable fields,
 *     so clearing it through Update or Upsert returns 200 and changes nothing.
 *
 * `tools/smoke-test-deleted-record-revival.js` asserts all of the above
 * against a live server and is the acceptance test for the 2.x Undelete work.
 */
class HeadlightDeletedRecordReviver extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'DeletedRecordReviver';

		/** @type {import('headlight-rest-client')} */
		this._Client = null;
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		return this._Client;
	}

	set client(pClient)
	{
		this._Client = pClient;
	}

	/**
	 * Build the meadow filter that finds soft-deleted rows for an entity,
	 * optionally scoped to one customer.
	 *
	 * @param {number} [pIDCustomer]
	 * @return {string}
	 */
	buildDeletedFilter(pIDCustomer)
	{
		const tmpClauses = [ 'FBV~Deleted~EQ~1' ];
		if (pIDCustomer > 0)
		{
			tmpClauses.push(`FBV~IDCustomer~EQ~${pIDCustomer}`);
		}
		return tmpClauses.join('~');
	}

	/**
	 * Scan an entity's soft-deleted rows and return the ones whose GUID appears
	 * in the supplied set.
	 *
	 * @param {string} pEntity
	 * @param {Set<string>} pGUIDs - GUIDs about to be upserted.
	 * @param {number} [pIDCustomer]
	 * @return {Promise<{ Matches: Array<{ GUID: string, ID: number }>, Scanned: number, Truncated: boolean }>}
	 */
	async findDeletedMatches(pEntity, pGUIDs, pIDCustomer)
	{
		const tmpGUIDColumn = `GUID${pEntity}`;
		const tmpIDColumn = `ID${pEntity}`;
		const tmpFilter = this.buildDeletedFilter(pIDCustomer);
		const tmpScanLimit = this.options.ScanLimit || DEFAULT_SCAN_LIMIT;

		/** @type {Array<{ GUID: string, ID: number }>} */
		const tmpMatches = [];
		let tmpScanned = 0;
		let tmpTruncated = false;

		for (let tmpOffset = 0; ; tmpOffset += SCAN_PAGE_SIZE)
		{
			if (tmpOffset >= tmpScanLimit)
			{
				tmpTruncated = true;
				break;
			}

			/** @type {Array<Record<string, any>>} */
			const tmpPage = await new Promise((resolve, reject) =>
			{
				this.client.getJSON(`${pEntity}s/FilteredTo/${tmpFilter}/${tmpOffset}/${SCAN_PAGE_SIZE}?${INCLUDE_DELETED_PARAMETER}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						return resolve(Array.isArray(pBody) ? pBody : []);
					});
			});

			if (tmpPage.length < 1)
			{
				break;
			}
			tmpScanned += tmpPage.length;

			for (const tmpRecord of tmpPage)
			{
				const tmpGUID = tmpRecord[tmpGUIDColumn];
				if (tmpGUID && pGUIDs.has(tmpGUID))
				{
					tmpMatches.push({ GUID: tmpGUID, ID: tmpRecord[tmpIDColumn] });
				}
			}

			if (tmpPage.length < SCAN_PAGE_SIZE)
			{
				break;
			}
		}

		return { Matches: tmpMatches, Scanned: tmpScanned, Truncated: tmpTruncated };
	}

	/**
	 * @param {string} pEntity
	 * @param {number} pIDRecord
	 * @return {Promise<boolean>}
	 */
	async undeleteRecord(pEntity, pIDRecord)
	{
		return new Promise((resolve) =>
		{
			this.client.getJSON(`${pEntity}/Undelete/${pIDRecord}`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.warn(`Could not undelete [${pEntity}] ID [${pIDRecord}]: ${pError.message || pError}`);
						return resolve(false);
					}
					const tmpCount = (pBody && typeof pBody.Count === 'number') ? pBody.Count : 0;
					if (tmpCount < 1)
					{
						this.log.warn(`Undelete of [${pEntity}] ID [${pIDRecord}] affected no rows.`);
						return resolve(false);
					}
					return resolve(true);
				});
		});
	}

	/**
	 * Revive records from an explicit ledger of `{ EntityName, RecordGUID,
	 * IDRecord }` captured when they were deleted.
	 *
	 * Preferred over scanning when the caller already knows the IDs: it costs
	 * one Undelete call per record instead of paging the entity's whole
	 * delete history.
	 *
	 * @param {Array<{ EntityName: string, RecordGUID: string, IDRecord: number }>} pLedger
	 * @param {Record<string, any>} pComprehension - Only ledger entries whose GUID reappears here are revived.
	 * @return {Promise<{ Considered: number, Revived: number, Failed: number, Skipped: number }>}
	 */
	async reviveFromLedger(pLedger, pComprehension)
	{
		const tmpResult = { Considered: 0, Revived: 0, Failed: 0, Skipped: 0 };
		if (!Array.isArray(pLedger) || pLedger.length < 1)
		{
			return tmpResult;
		}

		/** @type {Map<string, Set<string>>} */
		const tmpIncomingGUIDs = new Map();
		for (const tmpEntity of Object.keys(pComprehension || {}))
		{
			const tmpGUIDColumn = `GUID${tmpEntity}`;
			const tmpRecords = Array.isArray(pComprehension[tmpEntity]) ? pComprehension[tmpEntity] : Object.values(pComprehension[tmpEntity] || {});
			tmpIncomingGUIDs.set(tmpEntity, new Set(tmpRecords.map((pRecord) => String(pRecord[tmpGUIDColumn] || pRecord[`_${tmpGUIDColumn}`] || '')).filter(Boolean)));
		}

		for (const tmpEntry of pLedger)
		{
			const tmpEntityGUIDs = tmpIncomingGUIDs.get(tmpEntry.EntityName);
			if (!tmpEntityGUIDs || !tmpEntityGUIDs.has(String(tmpEntry.RecordGUID)))
			{
				tmpResult.Skipped++;
				continue;
			}
			if (!(Number(tmpEntry.IDRecord) > 0))
			{
				tmpResult.Skipped++;
				continue;
			}

			tmpResult.Considered++;
			const tmpUndeleted = await this.undeleteRecord(tmpEntry.EntityName, Number(tmpEntry.IDRecord));
			if (tmpUndeleted)
			{
				tmpResult.Revived++;
			}
			else
			{
				tmpResult.Failed++;
			}
		}

		if (tmpResult.Revived > 0)
		{
			this.log.info(`Revived ${tmpResult.Revived} previously deleted record(s) from the deletion ledger.`);
		}
		return tmpResult;
	}

	/**
	 * Revive every soft-deleted record in one entity's slice of a comprehension.
	 *
	 * @param {string} pEntity
	 * @param {Record<string, Record<string, any>> | Array<Record<string, any>>} pRecords
	 * @return {Promise<{ Entity: string, Candidates: number, Revived: number, Failed: number, Scanned: number, Truncated: boolean }>}
	 */
	async reviveEntity(pEntity, pRecords)
	{
		const tmpGUIDColumn = `GUID${pEntity}`;
		/** @type {Set<string>} */
		const tmpGUIDs = new Set();
		let tmpIDCustomer = 0;

		const tmpRecordList = Array.isArray(pRecords) ? pRecords : Object.values(pRecords || {});
		for (const tmpRecord of tmpRecordList)
		{
			const tmpGUID = tmpRecord[tmpGUIDColumn] || tmpRecord[`_${tmpGUIDColumn}`];
			if (tmpGUID)
			{
				tmpGUIDs.add(String(tmpGUID));
			}
			if (!tmpIDCustomer && tmpRecord.IDCustomer > 0)
			{
				tmpIDCustomer = Number(tmpRecord.IDCustomer);
			}
		}

		const tmpResult = { Entity: pEntity, Candidates: tmpGUIDs.size, Revived: 0, Failed: 0, Scanned: 0, Truncated: false };
		if (tmpGUIDs.size < 1)
		{
			return tmpResult;
		}

		let tmpFound;
		try
		{
			tmpFound = await this.findDeletedMatches(pEntity, tmpGUIDs, tmpIDCustomer);
		}
		catch (pError)
		{
			// A table without a Deleted column rejects the filter. That is not a
			// failure of the load -- it just cannot hold a soft-deleted row.
			this.log.info(`Skipping delete-revival scan for [${pEntity}]: ${pError.message || pError}`);
			return tmpResult;
		}

		tmpResult.Scanned = tmpFound.Scanned;
		tmpResult.Truncated = tmpFound.Truncated;

		if (tmpFound.Truncated)
		{
			this.log.warn(`Delete-revival scan for [${pEntity}] stopped at the scan limit after ${tmpFound.Scanned} rows; soft-deleted records beyond it were not checked and may upsert as duplicates.`);
		}
		if (tmpFound.Matches.length < 1)
		{
			return tmpResult;
		}

		this.log.info(`Reviving ${tmpFound.Matches.length} soft-deleted [${pEntity}] record(s) before upsert.`);

		for (const tmpMatch of tmpFound.Matches)
		{
			const tmpUndeleted = await this.undeleteRecord(pEntity, tmpMatch.ID);
			if (tmpUndeleted)
			{
				tmpResult.Revived++;
			}
			else
			{
				tmpResult.Failed++;
			}
		}

		return tmpResult;
	}

	/**
	 * Revive soft-deleted records across a whole comprehension.
	 *
	 * @param {Record<string, any>} pComprehension
	 * @param {Array<string>} [pEntitySequence] - Restrict/order the entities scanned.
	 * @return {Promise<{ Entities: Array<Object>, TotalRevived: number, TotalFailed: number }>}
	 */
	async reviveComprehension(pComprehension, pEntitySequence)
	{
		const tmpEntities = pEntitySequence || Object.keys(pComprehension || {});
		const tmpResults = [];
		let tmpTotalRevived = 0;
		let tmpTotalFailed = 0;

		for (const tmpEntity of tmpEntities)
		{
			if (!pComprehension[tmpEntity])
			{
				continue;
			}
			const tmpResult = await this.reviveEntity(tmpEntity, pComprehension[tmpEntity]);
			tmpResults.push(tmpResult);
			tmpTotalRevived += tmpResult.Revived;
			tmpTotalFailed += tmpResult.Failed;
		}

		return { Entities: tmpResults, TotalRevived: tmpTotalRevived, TotalFailed: tmpTotalFailed };
	}
}

module.exports = HeadlightDeletedRecordReviver;
module.exports.default_configuration = { ScanLimit: DEFAULT_SCAN_LIMIT };
module.exports.SCAN_PAGE_SIZE = SCAN_PAGE_SIZE;
module.exports.DEFAULT_SCAN_LIMIT = DEFAULT_SCAN_LIMIT;
module.exports.INCLUDE_DELETED_PARAMETER = INCLUDE_DELETED_PARAMETER;

},{"fable-serviceproviderbase":398}],7:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libAsync = require('async');
const libGUIDMap = require('./Headlight-Integration-GUIDMap.js');
const libGUIDBatchResolver = require('./Headlight-Integration-GUIDBatchResolver.js');

// Conservative default used until loadSchema() applies the authoritative
// per-entity GUID column size from the live Headlight API.
const _GUID_MAX_LENGTH_FALLBACK = 36;

// Composite-key separator for the unresolved-reference set. Printable on purpose: a literal NUL
// here makes GNU grep treat this whole source file as binary and silently skip it.
const UNRESOLVED_GUID_KEY_SEPARATOR = '\u241F';

/**
 * Is a source record's `Deleted` flag set, in whatever shape the source produced it?
 *
 * Storage layers disagree about how a boolean is represented and every one of them is legitimate:
 * MySQL's `tinyint` arrives as `1`/`0` through mysql2, PostgreSQL gives a real `true`/`false`, and
 * anything that has been through JSON, a CSV, a spreadsheet or a comprehension projection arrives
 * as the string `"1"`. A strict `=== true` honoured only the second of those and treated the rest as
 * a live record — an upsert instead of a delete, reported as success.
 *
 * Only the SET side is widened. `0`, `"0"`, `""`, `false`, `"false"`, `null`, `undefined` and an
 * absent property all remain not-deleted, so a record can never become a delete by accident.
 *
 * Kept in step with the same predicate in `meadow-integration`, which this adapter is a fork of.
 *
 * @param {any} pValue - the source record's `Deleted` value, in any representation
 * @return {boolean} true when the record should be routed to the delete pass
 */
const isDeletedFlagSet = function(pValue)
{
	if (typeof (pValue) === 'boolean')
	{
		return pValue;
	}
	if (typeof (pValue) === 'number')
	{
		return (pValue !== 0);
	}
	if (typeof (pValue) === 'string')
	{
		const tmpValue = pValue.trim().toLowerCase();
		return (tmpValue === '1') || (tmpValue === 'true') || (tmpValue === 't') || (tmpValue === 'y') || (tmpValue === 'yes');
	}
	return false;
};

const defaultHeadlightIntegrationAdapterOptions = (
	{
		"Entity": "DefaultEntity",

		"AdapterSetGUIDMarshalPrefix": false,

		"EntityGUIDMarshalPrefix": false,

		// Maximum allowed length for generated Headlight GUIDs.
		// When 0, the authoritative per-entity size is applied by
		// loadSchema() (called automatically from integrateRecords()).
		// Until then, _GUID_MAX_LENGTH_FALLBACK (36) is used as a
		// conservative default.  Set to a positive integer to explicitly
		// override for all entities.
		"GUIDMaxLength": 0,

		// Optional pre-fetched entity schema document (same shape as the
		// /{Entity}/Schema API response).  When provided, the adapter
		// applies it at construction time and loadSchema() skips the
		// network round-trip.  Useful for callers that cache schemas
		// across many adapters.  Caller is responsible for keeping the
		// cached copy reasonably fresh relative to the deployed server.
		"Schema": null,

		// When false (default), the adapter will throw an error if a generated GUID
		// exceeds GUIDMaxLength, halting the integration.
		// When true, the prefix is truncated to fit while preserving the full external GUID.
		// Only enable this for one-time imports where GUID stability is not required.
		"AllowGUIDTruncation": false,

		"PerformUpserts": true,
		"PerformDeletes": true,

		// Resolve every mapped GUID reference in the source buffer with batched
		// IN-list reads before marshaling, instead of one lookup per reference.
		"BatchGUIDResolution": true,

		// Options for the batch resolver (batch sizes, read mode, whether the
		// body-driven read route may be used) -- see
		// Headlight-Integration-GUIDBatchResolver.js.
		"GUIDBatchResolutionOptions": {},

		"RecordPushRetryThreshold": 5,

		"RecordThresholdForBulkUpsert": 250,
		"BulkUpsertBatchSize": 100,

		"HeadlightAPIURL": '/1.0/'
	});

/**
 * Pull a readable message out of the per-record `Error` property meadow-endpoints attaches to a
 * row that failed inside a bulk operation.
 *
 * The shape depends on the server's meadow-endpoints major -- 2.x sets a preformatted string,
 * 4.x an error object -- so anything truthy counts as a failure and is reduced to a string.
 *
 * @param {any} pRecord - a record row from a bulk response
 * @return {string|false} the failure message, or false when the row carries no error
 */
const getRecordErrorMessage = function(pRecord)
{
	if (!pRecord || (typeof(pRecord) !== 'object') || !pRecord.Error)
	{
		return false;
	}

	const tmpError = pRecord.Error;

	if (typeof(tmpError) === 'string')
	{
		return tmpError;
	}
	if (typeof(tmpError.message) === 'string')
	{
		return tmpError.message;
	}
	if (typeof(tmpError.Error) === 'string')
	{
		return tmpError.Error;
	}

	try
	{
		return JSON.stringify(tmpError);
	}
	catch (pStringifyError)
	{
		return String(tmpError);
	}
};

class HeadlightIntegrationAdapter extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadlightIntegrationAdapterOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client'), HeadlightGUIDMap: libGUIDMap, ProgressTrackerSet: any }} */
		this.fable;
		this.serviceType = 'IntegrationAdapter';

		// Check if there is a GUIDMap .. if not make one
		if (!this.fable.hasOwnProperty('HeadlightGUIDMap'))
		{
			this.fable.addAndInstantiateServiceType('HeadlightGUIDMap', libGUIDMap);
		}

		/** @type {import('headlight-rest-client')} */
		this.client = this.options.Client || this.fable.HeadlightRestClient;
		// Check if there is a REST client ... if not make one
		if (!this.client)
		{
			this.fable.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = '/1.0/';
			}
			this.client = this.fable.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		}
		this.client.prepareRequestOptions = (pOptions) =>
		{
			pOptions.timeout = 600000;
			return pOptions;
		};

		this.fable.instantiateServiceProviderIfNotExists('ProgressTrackerSet');

		this.Entity = this.options.Entity;
		this.EntityGUIDName = `GUID${this.Entity}`;
		this.EntityIDName = `ID${this.Entity}`;

		// Automagic GUID Components
		this.AdapterSetGUIDMarshalPrefix = this.options.AdapterSetGUIDMarshalPrefix;
		if (typeof this.AdapterSetGUIDMarshalPrefix !== 'string')
		{
			if (typeof this.fable.settings.AdapterSetGUIDMarshalPrefix === 'string')
			{
				this.AdapterSetGUIDMarshalPrefix = this.fable.settings.AdapterSetGUIDMarshalPrefix;
			}
			else
			{
				this.AdapterSetGUIDMarshalPrefix = 'INTG-DEF';
			}
		}
		this.EntityGUIDMarshalPrefix = this.options.EntityGUIDMarshalPrefix;
		if (typeof this.EntityGUIDMarshalPrefix !== 'string')
		{
			this.EntityGUIDMarshalPrefix = `E-${this.Entity}`;
		}

		// Resolve GUID max length: explicit option > fallback.  The
		// authoritative per-entity size is applied by loadSchema() once
		// the live server schema has been fetched.
		if (this.options.GUIDMaxLength > 0)
		{
			this.GUIDMaxLength = this.options.GUIDMaxLength;
		}
		else
		{
			this.GUIDMaxLength = _GUID_MAX_LENGTH_FALLBACK;
		}
		this.AllowGUIDTruncation = this.options.AllowGUIDTruncation;

		// Integration Adapter Controls
		this._PerformUpserts = this.options.PerformUpserts;
		this._PerformDeletes = this.options.PerformDeletes;

		this._RecordPushRetryThreshold = this.options.RecordPushRetryThreshold;

		// Meta progress tracker — an optional external progress tracker hash that is
		// incremented alongside the per-entity tracker so callers can monitor overall
		// progress across multiple adapters/entities.
		this.MetaProgressTrackerHash = false;
		// How often (in records) to log the meta progress tracker status (0 = never auto-log).
		this.MetaProgressTrackerLogInterval = 0;

		// The source records (coming from the external system)
		this._SourceRecords = {};

		// The marshaled records (going to HeadLight or Queued for Delete)
		this._MarshaledRecords = {};
		this._DeletedRecords = {};

		// Records the server refused, one entry per record, for the run summary.
		/** @type {Array<{ Entity: string, RecordKey: string, Error: string }>} */
		this.RecordPushFailures = [];

		/** @type {import('./Headlight-Integration-GUIDBatchResolver.js')} */
		this._GUIDBatchResolver = null;

		// Mapped GUIDs the server has already been asked about -- and did not
		// have -- during the current marshal pass.  Without this, a reference
		// that resolves to nothing is re-requested once per record that carries
		// it.  Scoped to the pass because a GUID absent now can be created by a
		// later stage of the same run.
		/** @type {Set<string>} */
		this._UnresolvedMappedGUIDs = new Set();

		// Whether this server serves the body-driven read route, per the
		// capabilities its schema advertises.
		/** @type {boolean|undefined} */
		this.QueryEndpointSupported = undefined;

		// Optional caller-supplied schema: stash it and apply the authoritative
		// GUID size now so consumers can generate GUIDs without first awaiting
		// a network round-trip.
		if (this.options.Schema)
		{
			this._applySchemaDocument(this.options.Schema);
		}
	}

	/**
	 * Apply an entity schema document (in the shape returned by the
	 * /{Entity}/Schema API) to this adapter: stash it on meadowSchema and,
	 * unless the caller explicitly set GUIDMaxLength in options, adopt the
	 * GUID column size from the schema's `properties` map.
	 *
	 * @param {Object} pSchemaDocument - The entity schema document
	 * @private
	 */
	_applySchemaDocument(pSchemaDocument)
	{
		if (!pSchemaDocument || typeof(pSchemaDocument) !== 'object')
		{
			return;
		}
		this.meadowSchema = pSchemaDocument;

		// The advertised capability describes the server, not the entity, so it
		// applies to every entity this adapter resolves references against.
		const tmpCapabilities = pSchemaDocument.RetoldMetadata && pSchemaDocument.RetoldMetadata.Capabilities;
		if (tmpCapabilities && typeof(tmpCapabilities.QueryEndpoint) === 'boolean')
		{
			this.QueryEndpointSupported = tmpCapabilities.QueryEndpoint;
			if (this._GUIDBatchResolver)
			{
				this._GUIDBatchResolver.QueryEndpointSupported = tmpCapabilities.QueryEndpoint;
			}
		}

		if (this.options.GUIDMaxLength <= 0
			&& pSchemaDocument.properties
			&& pSchemaDocument.properties[this.EntityGUIDName])
		{
			let tmpSchemaSize = Number(pSchemaDocument.properties[this.EntityGUIDName].size);
			if (tmpSchemaSize > 0)
			{
				if (tmpSchemaSize !== this.GUIDMaxLength)
				{
					this.log.info(`Schema GUID column size for [${this.Entity}] is ${tmpSchemaSize} (was ${this.GUIDMaxLength}); using schema value.`);
				}
				this.GUIDMaxLength = tmpSchemaSize;
			}
		}
	}

	/**
	 * Load the live entity schema from the Headlight API and apply the
	 * authoritative GUID column size when no explicit GUIDMaxLength override
	 * was provided.  integrateRecords() calls this automatically; consumers
	 * that need to generate GUIDs before integration runs should call it
	 * explicitly.  Idempotent: if a schema has already been applied (via the
	 * Schema option or a prior call), the network fetch is skipped.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback fired when the schema has been loaded (or failed to load)
	 */
	loadSchema(fCallback)
	{
		if (this.meadowSchema && typeof(this.meadowSchema) === 'object')
		{
			return fCallback();
		}
		this.fable.log.info(`Getting schema for ${this.Entity}....`);
		let tmpRequestOptions = (
			{
				url: `${this.client.serverURL}${this.Entity}/Schema`
			});
		tmpRequestOptions = this.client._prepareRequestOptions(tmpRequestOptions);
		return this.client.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (!pError)
				{
					this._applySchemaDocument(pBody);
				}
				return fCallback(pError);
			});
	}

	/**
	 * TODO: This was lifted from the old HDOT integration code but a more elegant streaming solution would be way cooler.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are integrated
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - (optional) Function to call to marshal extra data per-record
	 */
	integrateRecords(fCallback, fMarshalExtraData)
	{
		let tmpMarshalExtraData = fMarshalExtraData;
		let tmpAnticipate = this.fable.newAnticipate();
		if (this.options.ValidateSession)
		{
			tmpAnticipate.anticipate(
				(fStageComplete)=>
				{
					this.client.getJSON('CheckSession', (pError, pBody) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error checking session with Headlight server: ${pError.message || pError}`, { Stack: pError.stack });
								return fStageComplete(pError);
							}
							if (!pBody || !pBody.LoggedIn)
							{
								this.fable.log.error(`Not logged in; cannot proceed with integration of ${this.Entity} records.`, { Response: pBody });
								return fStageComplete(new Error('Not logged in'));
							}
							return fStageComplete();
						});
				});
		}
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				this.loadSchema(fStageComplete);
			});
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				this.fable.log.info(`Marshaling ${this.Entity} records....`);
				this.marshalSourceRecords(fStageComplete, tmpMarshalExtraData);
			});
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				this.fable.log.info(`Posting ${this.Entity} records....`);
				this.pushRecordsToServer(fStageComplete);
			});
		// Retirements are routed to _DeletedRecords by marshalSingleSourceRecord, and
		// pushRecordsToServer only walks _MarshaledRecords -- so without this stage the delete queue
		// was built and then dropped when the adapter went out of scope. A record flagged Deleted
		// therefore neither upserted nor deleted, and the run reported success either way. Guarded
		// inside deleteRecordsFromServer by PerformDeletes, and a no-op when nothing is queued.
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				const tmpDeleteCount = Object.keys(this._DeletedRecords).length;
				if (tmpDeleteCount < 1)
				{
					return fStageComplete();
				}
				this.fable.log.info(`Deleting ${tmpDeleteCount} ${this.Entity} record(s)....`);
				this.deleteRecordsFromServer(fStageComplete);
			});
		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Add a record to the adapter's Source Records buffer to be pushed
	 *
	 * @param {Object} pRecord - The record to add
	 */
	addSourceRecord(pRecord)
	{
		if (!pRecord || typeof(pRecord) !== 'object' || Array.isArray(pRecord))
		{
			this.log.error(`Passed-in record was null, or not of type "object" (${typeof(pRecord)}), therefore it was not added to the Source Record buffer.`);
			return false;
		}
		let tmpRecordGUID = pRecord[this.EntityGUIDName];
		if (!tmpRecordGUID && (!pRecord.hasOwnProperty(this.EntityIDName) || !(pRecord[this.EntityIDName])))
		{
			tmpRecordGUID = pRecord[`_${this.EntityGUIDName}`];
			if (!tmpRecordGUID)
			{
				this.log.error(`Passed-in record did not contain a source system GUID data element [${this.Entity}].[${this.EntityGUIDName}], therefore it was not added to the Source Record Buffer:`, pRecord);
				return false;
			}
		}

		if (tmpRecordGUID)
		{
			this._SourceRecords[tmpRecordGUID] = pRecord;
		}
		else
		{
			this._SourceRecords[pRecord[this.EntityIDName]] = pRecord;
		}
	}

	get GUIDPrefix()
	{
		let tmpPrefix = '';
		if (this.AdapterSetGUIDMarshalPrefix)
		{
			tmpPrefix += `${this.AdapterSetGUIDMarshalPrefix}-`;
		}
		if (this.EntityGUIDMarshalPrefix)
		{
			tmpPrefix += `${this.EntityGUIDMarshalPrefix}-`;
		}
		return tmpPrefix;
	}

	/**
	 * Generate a Headlight GUID from an external system GUID
	 *
	 * If the generated GUID would exceed GUIDMaxLength (resolved per-entity
	 * from the Headlight schema) and AllowGUIDTruncation is false (the
	 * default), an error is thrown so the integration stops immediately with
	 * a clear message.
	 *
	 * When AllowGUIDTruncation is true (one-time imports only), the prefix is
	 * progressively truncated to fit while preserving the full external GUID.
	 *
	 * @param {string} pExternalGUID - The external system GUID to generate a Headlight GUID from
	 * @return {string} The generated Headlight GUID
	 */
	generateHeadlightGUIDFromExternalGUID(pExternalGUID)
	{
		let tmpFullGUID = `${this.GUIDPrefix}${pExternalGUID}`;

		if (this.GUIDMaxLength > 0 && tmpFullGUID.length > this.GUIDMaxLength)
		{
			if (!this.AllowGUIDTruncation)
			{
				let tmpMessage = `Generated GUID for [${this.Entity}] exceeds the maximum allowed length of ${this.GUIDMaxLength} characters.\n`
					+ `  Comprehension GUID: [${pExternalGUID}] (${pExternalGUID.length} chars)\n`
					+ `  Server GUID:        [${tmpFullGUID}] (${tmpFullGUID.length} chars)\n`
					+ `  Prefix:             [${this.GUIDPrefix}] (${this.GUIDPrefix.length} chars)\n`
					+ `  To allow automatic prefix truncation for one-time imports, set AllowGUIDTruncation to true (CLI: --allowguidtruncation).`;
				this.log.error(tmpMessage);
				throw new Error(tmpMessage);
			}

			// AllowGUIDTruncation is on -- the external GUID is sacrosanct, so truncate the prefix instead.
			let tmpAvailablePrefixLength = this.GUIDMaxLength - pExternalGUID.length;

			if (tmpAvailablePrefixLength <= 0)
			{
				// External GUID alone meets or exceeds the limit; drop the prefix entirely.
				this.log.warn(`External GUID [${pExternalGUID}] for [${this.Entity}] is ${pExternalGUID.length} characters which meets or exceeds the GUID max length of ${this.GUIDMaxLength}.  Using external GUID with no prefix.`);
				tmpFullGUID = pExternalGUID.substring(0, this.GUIDMaxLength);
			}
			else
			{
				let tmpTruncatedPrefix = this.GUIDPrefix.substring(0, tmpAvailablePrefixLength);
				tmpFullGUID = `${tmpTruncatedPrefix}${pExternalGUID}`;
				this.log.warn(`Generated GUID for [${this.Entity}] would be ${this.GUIDPrefix.length + pExternalGUID.length} characters (limit ${this.GUIDMaxLength}); prefix truncated from [${this.GUIDPrefix}] to [${tmpTruncatedPrefix}].`);
			}
		}

		return tmpFullGUID;
	}

	/**
	 * The batch resolver used to pre-populate the GUID map before marshaling.
	 *
	 * @return {import('./Headlight-Integration-GUIDBatchResolver.js')}
	 */
	get guidBatchResolver()
	{
		if (!this._GUIDBatchResolver)
		{
			this.fable.addServiceType('IntegrationGUIDBatchResolver', libGUIDBatchResolver);
			const tmpOptions = Object.assign({}, this.options.GUIDBatchResolutionOptions, { QueryEndpointSupported: this.QueryEndpointSupported });
			this._GUIDBatchResolver = this.fable.instantiateServiceProviderWithoutRegistration('IntegrationGUIDBatchResolver', tmpOptions);
		}
		this._GUIDBatchResolver.client = this.client;
		return this._GUIDBatchResolver;
	}

	/**
	 * @param {string} pMappedEntityName - The referenced entity.
	 * @param {string} pMappedGUIDValue - The referenced GUID.
	 * @return {string} The key this pass tracks an unresolvable reference under.
	 * @private
	 */
	_unresolvedMappedGUIDKey(pMappedEntityName, pMappedGUIDValue)
	{
		return `${pMappedEntityName}${UNRESOLVED_GUID_KEY_SEPARATOR}${pMappedGUIDValue}`;
	}

	/**
	 * Resolve every mapped GUID reference in the source buffer up front, in
	 * batched IN-list reads, so the marshal path finds them in the GUID map.
	 *
	 * References already answered by the in-memory maps -- entities pushed
	 * earlier in this run, GUIDs resolved by an earlier batch -- are never
	 * re-requested.  Failures are not fatal: anything a batch does not resolve
	 * still goes through the single-GUID lookup during marshaling.
	 *
	 * @return {Promise<Object|null>} The resolver's summary, or null when nothing was prefetched.
	 */
	async prefetchMappedEntityIDs()
	{
		if (!this.options.BatchGUIDResolution)
		{
			return null;
		}

		try
		{
			const tmpReferences = libGUIDBatchResolver.collectMappedGUIDReferences(this._SourceRecords, this.EntityGUIDName);
			if (tmpReferences.size < 1)
			{
				return null;
			}

			const tmpSummary = await this.guidBatchResolver.resolveReferences(tmpReferences);

			for (const [tmpMappedEntityName, tmpMissingGUIDs] of tmpSummary.Missing)
			{
				for (const tmpMissingGUID of tmpMissingGUIDs)
				{
					this._UnresolvedMappedGUIDs.add(this._unresolvedMappedGUIDKey(tmpMappedEntityName, tmpMissingGUID));
				}
			}

			if (tmpSummary.Requested > 0)
			{
				const tmpUnverifiedNote = (tmpSummary.Unverified > 0) ? `, ${tmpSummary.Unverified} left to single lookups` : '';
				this.fable.log.info(`Resolved ${tmpSummary.Resolved} of ${tmpSummary.Requested} referenced GUID(s) for [${this.Entity}] in ${tmpSummary.Requests} batch read(s) (${tmpSummary.Cached} already cached${tmpUnverifiedNote}).`);
			}
			return tmpSummary;
		}
		catch (pError)
		{
			this.fable.log.warn(`Batch GUID resolution for [${this.Entity}] did not complete; falling back to per-reference lookups: ${pError.message || pError}`, { Stack: pError.stack });
			return null;
		}
	}

	/**
	 * Resolve a referenced entity's GUID to its Headlight ID, consistently for
	 * every mapped-GUID form (`GUID<Entity>`, `_GUID<Entity>`, and
	 * `_Dest_IDEntity_..._Via_GUID<Entity>`).
	 *
	 * Resolution order:
	 *   1. This run's in-memory external map (external GUID -> Headlight GUID ->
	 *      ID), populated when the referenced entity was integrated earlier in
	 *      the same run.
	 *   2. A direct GUID lookup that checks the in-memory map -- which the batch
	 *      prefetch has usually already filled -- and then falls back to a live
	 *      server fetch.  This second step is what lets a reference resolve when
	 *      its target was loaded by a *prior* run (and so is absent from this
	 *      run's cache) -- the case the `GUID<Entity>` branch used to miss,
	 *      dropping the foreign key.
	 *
	 * @param {string} pMappedEntityName - The referenced entity (e.g. 'PayItem')
	 * @param {string} pMappedGUIDValue - The referenced GUID (external or Headlight)
	 * @return {Promise<number>} The resolved Headlight ID, or 0 if none could be found
	 */
	async resolveMappedEntityID(pMappedEntityName, pMappedGUIDValue)
	{
		if (!pMappedGUIDValue)
		{
			return 0;
		}

		// 1. External-GUID cache (external GUID -> Headlight GUID -> ID).
		let tmpHeadlightIDValue = this.fable.HeadlightGUIDMap.getHeadlightIDFromExternalGUID(pMappedEntityName, pMappedGUIDValue);
		if (tmpHeadlightIDValue)
		{
			return tmpHeadlightIDValue;
		}

		const tmpUnresolvedKey = this._unresolvedMappedGUIDKey(pMappedEntityName, pMappedGUIDValue);
		if (this._UnresolvedMappedGUIDs.has(tmpUnresolvedKey))
		{
			return 0;
		}

		// 2. Direct GUID lookup: in-memory map, then live server fetch.  Covers
		//    GUIDs that are already Headlight GUIDs, were stored without a prefix,
		//    or belong to an entity integrated by a prior run (not in this run's
		//    cache).
		return await new Promise((resolve) =>
		{
			this.fable.HeadlightGUIDMap.getIDFromGUIDAsync(pMappedEntityName, pMappedGUIDValue,
			(pError, pResponse) =>
			{
				if (pResponse)
				{
					return resolve(pResponse);
				}
				if (pError)
				{
					this.fable.log.warn(`Error getting Headlight id for ${pMappedEntityName} GUID [${pMappedGUIDValue}]: ${pError.message || pError}`, { Stack: pError.stack });
				}
				this._UnresolvedMappedGUIDs.add(tmpUnresolvedKey);
				return resolve(0);
			}, this.client);
		});
	}

	/**
	 * Marshal a record from the source system to a Headlight record
	 *
	 * @param {Object} pSourceRecord - The source record to marshal
	 * @return {Promise<Object>} The marshaled record
	 */
	async marshalRecord(pSourceRecord)
	{
		let tmpRecord = {};

		// Create the new GUID
		let tmpRecordHeadLightGUID;
		let tmpRecordExternalGUID = pSourceRecord[this.EntityGUIDName];
		if (tmpRecordExternalGUID)
		{
			tmpRecordHeadLightGUID = this.generateHeadlightGUIDFromExternalGUID(tmpRecordExternalGUID);
		}
		else
		{
			tmpRecordExternalGUID = pSourceRecord[`_${this.EntityGUIDName}`];
			tmpRecordHeadLightGUID = tmpRecordExternalGUID;
		}

		if (!tmpRecordHeadLightGUID && !pSourceRecord.hasOwnProperty(this.EntityIDName))
		{
			throw new Error(`Could not marshal record for [${this.Entity}] because no external system GUID was found in source record.`);
		}

		if (tmpRecordHeadLightGUID)
		{
			// Mapping table for going between HeadLight system GUIDs and External system GUIDs.
			tmpRecord[this.EntityGUIDName] = tmpRecordHeadLightGUID;
			this.fable.HeadlightGUIDMap.mapExternalGUIDtoHeadlightGUID(this.Entity, tmpRecordExternalGUID, tmpRecordHeadLightGUID);
		}

		// Now that we've dealt with basic identifiers, time to see if there are other Mapped GUIDs to look up.
		// TODO: This can be the path through to a recursive integration -- if
		//       the GUIDs are not found, then the appropriate adapter can launch
		//       (and integrate just the proper records!)
		for (const tmpRecordKey of Object.keys(pSourceRecord))
		{
			const tmpMappedReference = libGUIDBatchResolver.classifyMappedGUIDField(tmpRecordKey, this.EntityGUIDName);

			if (tmpMappedReference)
			{
				const tmpMappedEntityName = tmpMappedReference.MappedEntityName;
				const tmpMappedEntityGUIDValue = pSourceRecord[tmpRecordKey];

				let tmpHeadlightIDValue = await this.resolveMappedEntityID(tmpMappedEntityName, tmpMappedEntityGUIDValue);
				if (tmpHeadlightIDValue)
				{
					const tmpIDDestinationField = tmpMappedReference.DestinationField || pSourceRecord[`_Dest_${tmpRecordKey}`] || `ID${tmpMappedEntityName}`;
					tmpRecord[tmpIDDestinationField] = tmpHeadlightIDValue;
					if (tmpMappedReference.SetMappedEntityIDField)
					{
						tmpRecord[`ID${tmpMappedEntityName}`] = tmpHeadlightIDValue;
					}
				}
				else
				{
					const tmpGUIDLabel = (tmpMappedReference.Kind === 'External') ? 'External GUID' : 'GUID';
					this.fable.log.warn(`Could not find Headlight ID for [${tmpMappedEntityName}] with ${tmpGUIDLabel} [${tmpMappedEntityGUIDValue}] while integrating [${this.Entity}] record [${tmpRecord[this.EntityGUIDName]}].`)
				}
			}
			else if (tmpRecordKey == this.EntityGUIDName || tmpRecordKey == `_${this.EntityGUIDName}`)
			{
				// Don't do anything for the GUID whose already set...
			}
			else if (tmpRecordKey.startsWith('_Dest_'))
			{
				// skip this, it's a destination field override for a GUID
			}
			else if ((this.meadowSchema && this.meadowSchema.hasOwnProperty('properties')) && (this.meadowSchema.properties.hasOwnProperty(tmpRecordKey)))
			{
				// Check the length if it's a string -- truncate if it isn't there for now.
				// TODO: MAKE THIS CONFIGURABLE AND OVERRIDABLE
				if (this.options.SimpleMarshal)
				{
					//FIXME: this is a hack I added to allow me to marshal object types without things breaking; revisit - bigal
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
				}
				else if ((this.meadowSchema.properties[tmpRecordKey].type == 'string')
					&& pSourceRecord.hasOwnProperty(tmpRecordKey)
					&& (pSourceRecord[tmpRecordKey] != null)
					&& (pSourceRecord[tmpRecordKey].toString().length > this.meadowSchema.properties[tmpRecordKey].size))
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey].substring(0, this.meadowSchema.properties[tmpRecordKey].size);
				}
				else if (this.meadowSchema.properties[tmpRecordKey].type == 'string')
				{
					if ((pSourceRecord[tmpRecordKey] !== null) && (pSourceRecord[tmpRecordKey] !== undefined))
					{
						tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey].toString();
					}
				}
				else
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
				}
			}
			else if (this.options.ForceMarshal)
			{
				tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
			}
		}

		// Clean any elements in the record that are reserved by HeadLight
		if (tmpRecord.hasOwnProperty('CreateDate')) delete tmpRecord.CreateDate;
		if (tmpRecord.hasOwnProperty('UpdateDate')) delete tmpRecord.UpdateDate;
		if (tmpRecord.hasOwnProperty('Deleted')) delete tmpRecord.Deleted;

		return tmpRecord;
	}

	/**
	 * Marshal a single source record
	 *
	 * @param {string} pSourceRecordGUID - The GUID of the source record to marshal
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - (optional) Function to call to marshal extra data per-record
	 *
	 * @return {Promise<boolean>} - Promise that resolves to true (why?)
	 */
	async marshalSingleSourceRecord(pSourceRecordGUID, fMarshalExtraData)
	{
		// 0. Get the original GUID
		let tmpSourceRecordGUID = pSourceRecordGUID;

		// 0.3 Get the Source Record
		let tmpSourceRecord = this._SourceRecords[tmpSourceRecordGUID];

		if (!tmpSourceRecord)
		{
			this.log.fatal(`Could not marshal source record for [${this.Entity}] because source record with GUID [${tmpSourceRecordGUID}] was not found in Source Records buffer.`);
			return;
		}

		// 0.5 Check if this is a delete
		let tmpDeleteOperation = isDeletedFlagSet(tmpSourceRecord.Deleted);

		// 1. Marshal the Source record into a HeadLight record
		let tmpMarshaledRecord = await this.marshalRecord(tmpSourceRecord);

		// 2. Get the GUID of the record after Marshaling...
		let tmpMarshaledRecordGUID = tmpMarshaledRecord[this.EntityIDName];
		if (tmpMarshaledRecord.hasOwnProperty(this.EntityGUIDName))
		{
			tmpMarshaledRecordGUID = tmpMarshaledRecord[this.EntityGUIDName];
		}
		else if (tmpMarshaledRecord.hasOwnProperty(`_${this.EntityGUIDName}`))
		{
			tmpMarshaledRecordGUID = tmpMarshaledRecord[`_${this.EntityGUIDName}`];
		}

		// 3. Get a new Object or the existing object as start of the append operation
		let tmpOriginalRecord = (this._MarshaledRecords.hasOwnProperty(tmpMarshaledRecordGUID)) ? this._MarshaledRecords[tmpMarshaledRecordGUID] : {};

		// 4. Now merge the properties of the two records, using the new one as the more important values
		//    Yes this will guaranteed overwrite the GUID like a zillion times, but, whatevers
		if (tmpDeleteOperation)
		{
			this._DeletedRecords[tmpMarshaledRecordGUID] = tmpMarshaledRecord;
		}
		else
		{
			this._MarshaledRecords[tmpMarshaledRecordGUID] = Object.assign(tmpOriginalRecord, tmpMarshaledRecord);
		}

		// 4.5 Inject a marshal stack
		if (typeof(fMarshalExtraData) == 'function')
		{
			fMarshalExtraData(tmpSourceRecord, tmpMarshaledRecord);
		}

		// 5. Now delete the record from the SourceRecords set so next marshal operation doesn't do it again needlessly
		delete this._SourceRecords[tmpSourceRecordGUID];

		return true;
	}

	/**
	 * Take all Source Records in the buffer and marshal them
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are marshaled
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - (optional) Function to call to marshal extra data per-record
	 * @return {Promise<void>} - Promise that resolves when all records are marshaled
	 */
	async marshalSourceRecords(fCallback, fMarshalExtraData)
	{
		try
		{
			this._UnresolvedMappedGUIDs.clear();
			await this.prefetchMappedEntityIDs();

			let tmpRecordKeys = Object.keys(this._SourceRecords);

			// Later switch to something paralleler?
			for (let i = 0; i < tmpRecordKeys.length; i++)
			{
				await this.marshalSingleSourceRecord(tmpRecordKeys[i], fMarshalExtraData);
			}

			return fCallback();
		}
		catch (error)
		{
			return fCallback(error);
		}
	}

	/**
	 * Log a record the server refused and tally it for the run summary.
	 *
	 * These are decisions the server has already made about one record -- a constraint violation,
	 * a value too long for its column -- so they are terminal for that record and never retried.
	 * The rest of the batch is unaffected and the load continues.
	 *
	 * @param {string} pRecordKey - the GUID (or ID) the marshaled record is keyed on
	 * @param {string} pMessage - the failure as reported by the server
	 */
	trackRecordPushFailure(pRecordKey, pMessage)
	{
		this.RecordPushFailures.push({ Entity: this.Entity, RecordKey: pRecordKey, Error: pMessage });
		this.log.error(`Record push failure for [${this.Entity}].[${pRecordKey}]: ${pMessage}`);
	}

	/**
	 * Match a bulk upsert response back to the batch that was sent: map the records that landed,
	 * and log the ones that did not.
	 *
	 * A bulk upsert answers 200 whether or not every row succeeded, and the two shapes of
	 * per-record failure both arrive inside that 200. meadow-endpoints 2.x returns the failed row
	 * in the array with an `Error` property set; 4.x omits it from the array entirely and reports
	 * the counts in `X-Meadow-Upsert-*` response headers, which the REST client does not surface.
	 * Trusting every returned row therefore writes a GUID -> undefined entry into the GUID map,
	 * which every later reference to that record then resolves against.
	 *
	 * @param {string[]} pRecordGUIDs - the record keys sent in this batch
	 * @param {Array<Object>} pResponseRecords - the array the server answered with
	 * @return {number} how many records in the batch did not land
	 */
	reconcileBulkUpsertResponse(pRecordGUIDs, pResponseRecords)
	{
		let tmpResponseByKey = {};

		for (let i = 0; i < pResponseRecords.length; i++)
		{
			let tmpResponseRecord = pResponseRecords[i];

			if (!tmpResponseRecord || (typeof(tmpResponseRecord) !== 'object'))
			{
				continue;
			}
			if (tmpResponseRecord[this.EntityGUIDName])
			{
				tmpResponseByKey[tmpResponseRecord[this.EntityGUIDName]] = tmpResponseRecord;
			}
			if (tmpResponseRecord[this.EntityIDName])
			{
				tmpResponseByKey[tmpResponseRecord[this.EntityIDName]] = tmpResponseRecord;
			}
		}

		let tmpFailureCount = 0;

		for (let i = 0; i < pRecordGUIDs.length; i++)
		{
			let tmpRecordGUID = pRecordGUIDs[i];
			let tmpResponseRecord = tmpResponseByKey[tmpRecordGUID];

			if (!tmpResponseRecord)
			{
				tmpFailureCount++;
				this.trackRecordPushFailure(tmpRecordGUID, `The server did not return a row for this record in the bulk upsert response.`);
				continue;
			}

			let tmpErrorMessage = getRecordErrorMessage(tmpResponseRecord);
			if (tmpErrorMessage)
			{
				tmpFailureCount++;
				this.trackRecordPushFailure(tmpRecordGUID, tmpErrorMessage);
				continue;
			}

			if (!(tmpResponseRecord[this.EntityIDName] > 0))
			{
				tmpFailureCount++;
				this.trackRecordPushFailure(tmpRecordGUID, `The server returned this record without a valid ${this.EntityIDName}; it was not persisted.`);
				continue;
			}

			let tmpMappedGUID = (tmpResponseRecord[this.EntityGUIDName]) ? tmpResponseRecord[this.EntityGUIDName] : tmpRecordGUID;
			this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, tmpMappedGUID, tmpResponseRecord[this.EntityIDName]);
		}

		if (tmpFailureCount > 0)
		{
			this.log.error(`[${this.Entity}] Bulk upsert batch of ${pRecordGUIDs.length} records completed with ${tmpFailureCount} record-level failure(s); these are not retried.`);
		}

		return tmpFailureCount;
	}

	/**
	 * Take a single record and push it to the server
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the record is pushed
	 * @param {string} pRecordGUID - The GUID of the record to push
	 * @param {number} [pRetryCount] - (optional) The number of times this record has been retried
	 */
	upsertSingleRecord(fCallback, pRecordGUID, pRetryCount)
	{
		// TODO: The retry count recursion method here is very brute force.  Fix it!
		let tmpRetryCount = (typeof(pRetryCount) === 'undefined') ? 0 : pRetryCount;

		// Non-configurable cap for a bit here... until better logic is written.
		if ((tmpRetryCount > this._RecordPushRetryThreshold) || (tmpRetryCount > 50))
		{
			let tmpIdentifierType = 'GUID';
			this.trackRecordPushFailure(pRecordGUID, `Upsert retry threshold of ${this._RecordPushRetryThreshold} reached.`);

			// upsert failed, so we will try to read the record instead so we can at least have a valid ID / GUID mapping
			const tmpFallbackCallback = (pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error reading record ${tmpIdentifierType} [${pRecordGUID}] after upsert failures: ${pError.message || pError}`, { Stack: pError.stack });
				}
				else if (pBody &&
						// Check that the server returned a valid record (look for the Identity column)
						(pBody.hasOwnProperty(this.EntityIDName)) &&
						// Check that the server returned a record that has a numeric ID which is nonzero
						(pBody[this.EntityIDName] > 0) &&
						// Check that the server also returned a GUID
						(pBody.hasOwnProperty(this.EntityGUIDName)) &&
						// Check that the GUID or ID matches what we expect
						((pBody[this.EntityGUIDName] === pRecordGUID) || (pBody[this.EntityIDName] == pRecordGUID))
					)
				{
					this.log.info(`Fallback: Loaded and mapping record ${tmpIdentifierType} [${pRecordGUID}] after upsert failure.`,
						{
							Record: pBody,
							Entity: this.Entity,
							IdentifierType: tmpIdentifierType,
							GUID: pBody[this.EntityGUIDName],
							ID: pBody[this.EntityIDName]
						});
					this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, pBody[this.EntityGUIDName], pBody[this.EntityIDName]);
				}
				else
				{
					this.log.error(`Could not verify record ${tmpIdentifierType} [${pRecordGUID}] after upsert failures; record not found or invalid response.`, { Record: pBody });
				}
				return fCallback();
			};
			if (this._MarshaledRecords[pRecordGUID][this.EntityIDName] == pRecordGUID)
			{
				tmpIdentifierType = 'ID';
				// It's an ID, not a GUID
				return this.client.getEntity(this.Entity, pRecordGUID, tmpFallbackCallback);
			}
			return this.client.getEntityByGUID(this.Entity, pRecordGUID, tmpFallbackCallback);
		}

		this.client.upsertEntity(this.Entity, this._MarshaledRecords[pRecordGUID],
			(pError, pBody)=>
			{
				if (pError)
				{
					this.log.error(`Error sending PUT [${this.Entity}].[${pRecordGUID}] to server:  ${pError}`);
					let tmpErrorMessage = (typeof(pError.message) === 'string') ? pError.message : String(pError);
					if (tmpErrorMessage.indexOf('Error in DAL create: Error: Duplicate entry') > 0)
					{
						this.log.warn(`Duplicate record attempted when sending PUT to server record GUID [${pRecordGUID}]: ${tmpErrorMessage}`, pBody);
						return fCallback();
					}
					if (tmpErrorMessage.indexOf('exceeds the maximum allowed length') > 0)
					{
						this.trackRecordPushFailure(pRecordGUID, `GUID length rejected by server (${pRecordGUID.length} chars): ${tmpErrorMessage}`);
						return fCallback();
					}
					if (tmpErrorMessage.indexOf('Rejected Create') > -1 && tmpErrorMessage.indexOf('GUID') > -1)
					{
						this.trackRecordPushFailure(pRecordGUID, `Server rejected create due to a GUID issue: ${tmpErrorMessage}`);
						return fCallback();
					}

					// simple delay for retries to not spam the server
					setTimeout(() =>
					{
						this.upsertSingleRecord(fCallback, pRecordGUID, tmpRetryCount + 1);
					}, 500);
					return;
				}

				if (
						pBody &&
						// Check that the server returned a valid record (look for the Identity column)
						(pBody.hasOwnProperty(this.EntityIDName)) &&
						// Check that the server returned a record that has a numeric ID which is nonzero
						(pBody[this.EntityIDName] > 0) &&
						// Check that the server also returned a GUID
						(pBody.hasOwnProperty(this.EntityGUIDName)) &&
						// Check that the GUID or ID matches what we expect
						((pBody[this.EntityGUIDName] === pRecordGUID) || (pBody[this.EntityIDName] == pRecordGUID))
					)
				{
					// Add the record ID to the lookup table
					this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, pBody[this.EntityGUIDName], pBody[this.EntityIDName]);
					return fCallback();
				}

				// Try again...
				this.log.error(`Problem sending PUT [${this.Entity}].[${pRecordGUID}] to server.  Incrementing retry count and trying again.`, { Record: pBody, RetryCount: tmpRetryCount });
				this.upsertSingleRecord(fCallback, pRecordGUID, tmpRetryCount + 1);
			});
	}

	/**
	 * Take a set of records and push them to the server
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are pushed
	 * @param {string[]} pRecordGUIDs - The GUIDs of the records to push
	 * @param {number} [pRetryCount] - (optional) The number of times this record has been retried
	 */
	upsertBulkRecords(fCallback, pRecordGUIDs, pRetryCount)
	{
		// TODO: The retry count recursion method here is very brute force.  Fix it!
		let tmpRetryCount = (typeof(pRetryCount) === 'undefined') ? 0 : pRetryCount;

		// Non-configurable cap for a bit here... until better logic is written.
		if ((tmpRetryCount > this._RecordPushRetryThreshold) || (tmpRetryCount > 50))
		{
			for (let i = 0; i < pRecordGUIDs.length; i++)
			{
				this.trackRecordPushFailure(pRecordGUIDs[i], `Bulk upsert retry threshold of ${this._RecordPushRetryThreshold} reached.`);
			}
			//FIXME: handle reading records in bulk to backfill ID / GUID map?
			return fCallback();
		}

		let tmpRecordsToUpsert = [];

		for (let i = 0; i < pRecordGUIDs.length; i++)
		{
			tmpRecordsToUpsert.push(this._MarshaledRecords[pRecordGUIDs[i]]);
		}

		this.client.upsertEntities(this.Entity, tmpRecordsToUpsert,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error sending PUT [${this.Entity}] to server:  ${pError}`);
					return this.upsertBulkRecords(fCallback, pRecordGUIDs, tmpRetryCount + 1);
				}

				if (Array.isArray(pBody))
				{
					this.reconcileBulkUpsertResponse(pRecordGUIDs, pBody);
					return fCallback();
				}

				// Try again...
				this.log.error(`Problem sending PUT [${this.Entity}] to server.  Incrementing retry count and trying again.`, { Records: pBody, RetryCount: tmpRetryCount });
				this.upsertBulkRecords(fCallback, pRecordGUIDs, tmpRetryCount + 1);
			});
	}

	/**
	 * Increment the meta progress tracker (if configured) and conditionally log its status.
	 *
	 * @param {number} pAmount - The number of operations to increment by
	 */
	_incrementMetaProgressTracker(pAmount)
	{
		if (!this.MetaProgressTrackerHash)
		{
			return;
		}
		let tmpTracker = this.fable.ProgressTrackerSet;
		let tmpStatus = tmpTracker.incrementProgressTracker(this.MetaProgressTrackerHash, pAmount);

		if (this.MetaProgressTrackerLogInterval > 0 && tmpStatus)
		{
			// Use a threshold-crossing check rather than exact modulo so that
			// bulk increments (e.g. +100) reliably trigger a log when they cross
			// an interval boundary.  This makes the interval mean "log at least
			// every N records" regardless of whether records are pushed one at a
			// time or in batches.
			let tmpPreviousCount = tmpStatus.CurrentCount - pAmount;
			let tmpPreviousInterval = Math.floor(tmpPreviousCount / this.MetaProgressTrackerLogInterval);
			let tmpCurrentInterval = Math.floor(tmpStatus.CurrentCount / this.MetaProgressTrackerLogInterval);

			if (tmpCurrentInterval > tmpPreviousInterval
				|| tmpStatus.CurrentCount >= tmpStatus.TotalCount)
			{
				tmpTracker.logProgressTrackerStatus(this.MetaProgressTrackerHash);
			}
		}
	}

	/**
	 * Push any records in the adapter buffer to the server
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are pushed
	 */
	pushRecordsToServer(fCallback)
	{
		if (!this._PerformUpserts)
		{
			return fCallback();
		}
		// Run the upserts...
		let tmpRecordKeys = Object.keys(this._MarshaledRecords);
		// Nothing to upsert is a legitimate outcome, not a problem: a retirement-only load routes
		// every record to the delete queue. Falling through would build a progress tracker with a
		// total of 0, which logs at ERROR level and flips an otherwise clean run to
		// `succeeded-with-failures` -- the one status a caller must not learn to ignore.
		if (tmpRecordKeys.length < 1)
		{
			return fCallback();
		}
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpProgressTrackerGUID = this.fable.getUUID();
		let tmpProgressTracker = this.fable.ProgressTrackerSet;
		tmpProgressTracker.createProgressTracker(tmpProgressTrackerGUID, tmpRecordKeys.length);
		tmpProgressTracker.startProgressTracker(tmpProgressTrackerGUID);

		// Log meta tracker at the start of each entity
		if (this.MetaProgressTrackerHash)
		{
			this.log.info(`[${this.Entity}] Starting push of ${tmpRecordKeys.length} records...`);
			tmpProgressTracker.logProgressTrackerStatus(this.MetaProgressTrackerHash);
		}

		// Determine if bulk upserts are possible
		if (tmpRecordKeys.length > this.options.RecordThresholdForBulkUpsert)
		{
			let tmpBulkUpsertBatchCount = Math.ceil(tmpRecordKeys.length / this.options.BulkUpsertBatchSize);
			for (let i = 0; i < tmpBulkUpsertBatchCount; i++)
			{
				let tmpBatchRecordKeys = [];
				for (let j = 0; j < this.options.BulkUpsertBatchSize; j++)
				{
					let tmpRecordKey = tmpRecordKeys[(i * this.options.BulkUpsertBatchSize) + j];
					if (tmpRecordKey)
					{
						tmpBatchRecordKeys.push(tmpRecordKey);
					}
				}

				tmpAnticipate.anticipate(
					function(fDone)
					{
						this.log.trace(`[${this.Entity}] Bulk Upserting ${tmpBatchRecordKeys.length} records to server for transaction set [${tmpProgressTrackerGUID}]...`);
						this.upsertBulkRecords(
							(pError, pBody)=>
							{
								if (pError)
								{
									this.log.error(`Error sending Bulk Upserts for [${this.Entity}] to server:  ${pError}`);
								}
								tmpProgressTracker.incrementProgressTracker(tmpProgressTrackerGUID, tmpBatchRecordKeys.length);
								tmpProgressTracker.logProgressTrackerStatus(tmpProgressTrackerGUID);
								this._incrementMetaProgressTracker(tmpBatchRecordKeys.length);
								return fDone();
							}, tmpBatchRecordKeys);
					}.bind(this));
			}
		}
		else
		{
			for (let i = 0; i < tmpRecordKeys.length; i++)
			{
				let tmpRecordKey = tmpRecordKeys[i];
				tmpAnticipate.anticipate(
					function(fDone)
					{
						this.log.trace(`[${this.Entity}] Record [${tmpRecordKey}] pushing to server...`);
						tmpProgressTracker.incrementProgressTracker(tmpProgressTrackerGUID, 1);
						tmpProgressTracker.logProgressTrackerStatus(tmpProgressTrackerGUID);
						this.upsertSingleRecord(
							()=>
							{
								this._incrementMetaProgressTracker(1);
								return fDone();
							}, tmpRecordKey);
					}.bind(this));
			}
		}

		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Delete record from the adapter's marshaled records buffer
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records have been deleted
	 */
	deleteRecordsFromServer(fCallback)
	{
		if (!this._PerformDeletes)
		{
			return fCallback();
		}
		// Run the deletes...
		// TODO: THIS IS DANGEROUS
		let tmpRecordKeys = Object.keys(this._DeletedRecords);
		if (tmpRecordKeys.length < 1)
		{
			return fCallback();
		}

		const fDeleteRecords = () =>
		{
			libAsync.eachSeries(tmpRecordKeys,
				(pRecordGUID, fDeleteComplete) =>
				{
					this.log.trace(`[${this.Entity}] Record [${this._MarshaledRecords[this.EntityGUIDName]}] deleting from server...`);
					const tmpIDRecord = this.fable.HeadlightGUIDMap.getIDFromGUID(this.Entity, pRecordGUID);
					if (tmpIDRecord)
					{
						return this.client.deleteEntity(this.Entity, tmpIDRecord, fDeleteComplete);
					}

					this.log.warn(`Could not delete [${this.Entity}] GUID [${pRecordGUID}] because lookup on HeadLight did not return an IDRecord.`);
					return fDeleteComplete();
				},
				(pError)=>
				{
					if (pError)
					{
						this.log.error(`Error sending trying to Delete from [${this.Entity}]:  ${pError}`);
					}
					return fCallback(pError);
				});
		};

		if (!this.options.BatchGUIDResolution)
		{
			libAsync.eachSeries(tmpRecordKeys,
				(pRecordGUID, fLookupComplete) =>
				{
					this.client.getEntityByGUID(this.Entity, pRecordGUID,
						(pReadError, pReadBody)=>
						{
							if (pReadError)
							{
								this.log.warn(`Could not read [${this.Entity}] GUID [${pRecordGUID}] for DELETE operation:  ${pReadError}`);
								return fLookupComplete();
							}
							if (pReadBody && pReadBody.hasOwnProperty(this.EntityIDName))
							{
								this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, pRecordGUID, pReadBody[this.EntityIDName]);
							}
							return fLookupComplete();
						});
				},
				() => fDeleteRecords());
			return;
		}

		this.guidBatchResolver.resolveEntityGUIDs(this.Entity, tmpRecordKeys)
			.then(() => fDeleteRecords())
			.catch((pError) =>
			{
				this.log.warn(`Could not resolve [${this.Entity}] records to delete in batches: ${pError.message || pError}`);
				return fDeleteRecords();
			});
	}
}

module.exports = HeadlightIntegrationAdapter;

// Macro for backwards compatibility
module.exports.getAdapter = (
	/**
	 * @param {import('fable')} pFable
	 * @param {string} pEntity
	 * @param {string} pEntityPrefix
	 * @param {Object} [pCustomOptions]
	 */
	function(pFable, pEntity, pEntityPrefix, pCustomOptions)
	{
		if (pFable.servicesMap.IntegrationAdapter && pFable.servicesMap.IntegrationAdapter.hasOwnProperty(pEntity))
		{
			pFable.log.info(`Reusing existing Integration Adapter for entity [${pEntity}].`);
			return pFable.servicesMap.IntegrationAdapter[pEntity];
		}
		else
		{
			const tmpOptions = Object.assign({}, pCustomOptions, { Entity: pEntity, EntityGUIDMarshalPrefix: pEntityPrefix });
			return pFable.instantiateServiceProvider('IntegrationAdapter', tmpOptions, pEntity);
		}
	});

module.exports.default_configuration = defaultHeadlightIntegrationAdapterOptions;
module.exports.GUID_MAX_LENGTH_FALLBACK = _GUID_MAX_LENGTH_FALLBACK;
module.exports.GUIDBatchResolver = libGUIDBatchResolver;

// Exported for testing: the predicate that decides whether a source record is a delete.
module.exports.isDeletedFlagSet = isDeletedFlagSet;

// Exported for testing: the normalizer for the per-record `Error` property on a bulk response row.
module.exports.getRecordErrorMessage = getRecordErrorMessage;

/**
 * Report every record the server refused across all of a run's adapters.
 *
 * The bulk endpoints answer 200 for a batch in which individual rows failed, so these never reach
 * a run-level error callback. They are terminal for the record and not retried, which makes an
 * end-of-run tally the only place a partial load is visible.
 *
 * @param {import('fable')} pFable - the fable the adapters were registered on
 * @return {number} how many records were rejected across every entity
 */
module.exports.logRecordPushFailureSummary = function(pFable)
{
	let tmpAdapters = pFable.servicesMap.IntegrationAdapter;

	if (!tmpAdapters)
	{
		return 0;
	}

	let tmpFailures = [];
	let tmpFailureCountByEntity = {};
	let tmpAdapterKeys = Object.keys(tmpAdapters);

	for (let i = 0; i < tmpAdapterKeys.length; i++)
	{
		let tmpAdapter = tmpAdapters[tmpAdapterKeys[i]];

		if (!tmpAdapter || !Array.isArray(tmpAdapter.RecordPushFailures) || (tmpAdapter.RecordPushFailures.length < 1))
		{
			continue;
		}

		tmpFailureCountByEntity[tmpAdapter.Entity] = tmpAdapter.RecordPushFailures.length;
		tmpFailures = tmpFailures.concat(tmpAdapter.RecordPushFailures);
	}

	if (tmpFailures.length < 1)
	{
		pFable.log.info(`No records were rejected by the server during this load.`);
		return 0;
	}

	pFable.log.error(`${tmpFailures.length} record(s) were rejected by the server during this load and were NOT persisted:`);

	let tmpEntityKeys = Object.keys(tmpFailureCountByEntity);
	for (let i = 0; i < tmpEntityKeys.length; i++)
	{
		pFable.log.error(`  [${tmpEntityKeys[i]}]: ${tmpFailureCountByEntity[tmpEntityKeys[i]]} rejected record(s)`);
	}

	for (let i = 0; i < tmpFailures.length; i++)
	{
		pFable.log.error(`  [${tmpFailures[i].Entity}].[${tmpFailures[i].RecordKey}]: ${tmpFailures[i].Error}`);
	}

	return tmpFailures.length;
};

},{"./Headlight-Integration-GUIDBatchResolver.js":8,"./Headlight-Integration-GUIDMap.js":9,"async":275,"fable-serviceproviderbase":398,"headlight-rest-client":12}],8:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Reads default to a cap of 250 records (`MeadowDefaultMaxCap`), so every batch
 * read has to state its own cap or the tail of a large IN list is silently
 * dropped.
 */
const DEFAULT_BATCH_SIZE = 100;

/**
 * The body-driven `POST <Entity>s/Query` read carries the filter outside the
 * URI, so batches there are bounded by nothing but the server's read cap.
 */
const DEFAULT_QUERY_BATCH_SIZE = 500;

/**
 * Length at which a GET read URL is considered too long to be safe through
 * Kong and restify. Matches the threshold the web Select2 reader uses to swap
 * a GET for the equivalent POST.
 */
const DEFAULT_URL_LENGTH_BUDGET = 1800;

/**
 * How many entities are resolved concurrently.
 */
const DEFAULT_ENTITY_CONCURRENCY = 4;

/**
 * A `~` separates filter terms and a `,` separates the members of an IN list,
 * and both are split *after* the transport layer has URL-decoded the filter
 * once. A GUID containing either character therefore cannot travel inside an IN
 * list on any route, and has to fall back to a single-GUID lookup.
 */
const UNBATCHABLE_GUID_PATTERN = /[,~]/;

const defaultHeadlightIntegrationGUIDBatchResolverOptions = (
	{
		BatchSize: DEFAULT_BATCH_SIZE,
		QueryBatchSize: DEFAULT_QUERY_BATCH_SIZE,
		URLLengthBudget: DEFAULT_URL_LENGTH_BUDGET,
		EntityConcurrency: DEFAULT_ENTITY_CONCURRENCY,

		// Read mode for the batch lookup. 'Lite' returns every ID/GUID column
		// (all this needs) instead of every column; 'Reads' returns whole records.
		ReadMode: 'Lite',

		// Route template for the body-driven read, used when the server
		// advertises RetoldMetadata.Capabilities.QueryEndpoint on its schema.
		QueryEndpointRoute: '<Entity>s/Query',

		// Set false to keep every batch on the URI-based GET route.
		UseQueryEndpoint: true
	});

/**
 * @typedef {Object} MappedGUIDReference
 * @property {'External'|'Headlight'|'Destination'} Kind - Which mapped-GUID form the field uses.
 * @property {string} MappedEntityName - The referenced entity.
 * @property {string} [DestinationField] - The ID column the value lands in, when the field name dictates it.
 * @property {boolean} SetMappedEntityIDField - Whether `ID<MappedEntity>` is also written.
 */

/**
 * Classify one source-record field as a mapped-GUID reference, or not a
 * reference at all.
 *
 * This is the single definition of what counts as a foreign key in a
 * comprehension record: the marshal path and the batch prefetch both read it,
 * so they cannot disagree about which fields need resolving.
 *
 * @param {string} pFieldKey - The source record's field name.
 * @param {string} pEntityGUIDName - The owning entity's own GUID column (`GUID<Entity>`), which is never a reference.
 * @return {MappedGUIDReference|null} The reference, or null when the field is not one.
 */
const classifyMappedGUIDField = (pFieldKey, pEntityGUIDName) =>
{
	if (!pFieldKey || typeof(pFieldKey) !== 'string')
	{
		return null;
	}
	if (pFieldKey === pEntityGUIDName || pFieldKey === `_${pEntityGUIDName}`)
	{
		return null;
	}
	if (pFieldKey.startsWith('_Dest_IDEntity_') && pFieldKey.includes('_Via_'))
	{
		const tmpMappedEntityGUIDName = pFieldKey.split('_Via_')[1];
		return (
			{
				Kind: 'Destination',
				MappedEntityName: tmpMappedEntityGUIDName.substring(4),
				DestinationField: pFieldKey.split('_Via_')[0].split('_Dest_IDEntity_')[1],
				SetMappedEntityIDField: false
			});
	}
	if (pFieldKey.startsWith('_Dest_'))
	{
		return null;
	}
	if (pFieldKey.startsWith('GUID'))
	{
		return { Kind: 'External', MappedEntityName: pFieldKey.substring(4), SetMappedEntityIDField: false };
	}
	if (pFieldKey.startsWith('_GUID'))
	{
		return { Kind: 'Headlight', MappedEntityName: pFieldKey.substring(5), SetMappedEntityIDField: true };
	}
	return null;
};

/**
 * Gather every mapped-GUID reference in a set of source records, grouped by the
 * entity being referenced.
 *
 * @param {Array<Record<string, any>>|Record<string, Record<string, any>>} pRecords - The source records.
 * @param {string} pEntityGUIDName - The owning entity's own GUID column.
 * @param {Map<string, Set<string>>} [pReferences] - An existing map to merge into.
 * @return {Map<string, Set<string>>} Referenced entity -> the GUID values referenced.
 */
const collectMappedGUIDReferences = (pRecords, pEntityGUIDName, pReferences) =>
{
	const tmpReferences = pReferences || new Map();
	const tmpRecordList = Array.isArray(pRecords) ? pRecords : Object.values(pRecords || {});

	for (const tmpRecord of tmpRecordList)
	{
		if (!tmpRecord || typeof(tmpRecord) !== 'object')
		{
			continue;
		}
		for (const tmpFieldKey of Object.keys(tmpRecord))
		{
			const tmpReference = classifyMappedGUIDField(tmpFieldKey, pEntityGUIDName);
			if (!tmpReference || !tmpReference.MappedEntityName)
			{
				continue;
			}
			const tmpValue = tmpRecord[tmpFieldKey];
			if (typeof(tmpValue) !== 'string' && typeof(tmpValue) !== 'number')
			{
				continue;
			}
			const tmpGUIDValue = String(tmpValue);
			if (!tmpGUIDValue)
			{
				continue;
			}
			if (!tmpReferences.has(tmpReference.MappedEntityName))
			{
				tmpReferences.set(tmpReference.MappedEntityName, new Set());
			}
			tmpReferences.get(tmpReference.MappedEntityName).add(tmpGUIDValue);
		}
	}

	return tmpReferences;
};

/**
 * Resolves referenced-entity GUIDs to Headlight IDs in batches, filling the
 * shared GUID map so the per-record marshal path finds them in memory instead
 * of issuing one request per reference.
 *
 * Every batch is an IN list against the referenced entity's GUID column, sent
 * either as `GET <Entity>s/Lite/FilteredTo/<filter>/0/<cap>` or, when the
 * server advertises the capability, as the body-driven
 * `POST <Entity>s/Query` — which carries far larger lists because the filter
 * never touches the URI.
 *
 * Values are URI-encoded in both directions: the body-driven read decodes the
 * `Filter` exactly once, mirroring what the HTTP layer does to the equivalent
 * GET path segment.
 */
class HeadlightIntegrationGUIDBatchResolver extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the resolver.
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, defaultHeadlightIntegrationGUIDBatchResolverOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client'), HeadlightGUIDMap: import('./Headlight-Integration-GUIDMap.js') }} */
		this.fable;
		this.serviceType = 'IntegrationGUIDBatchResolver';

		if (!this.fable.hasOwnProperty('HeadlightGUIDMap'))
		{
			this.fable.addAndInstantiateServiceType('HeadlightGUIDMap', require('./Headlight-Integration-GUIDMap.js'));
		}

		/** @type {import('headlight-rest-client')} */
		this._Client = this.options.Client || null;

		/**
		 * Whether the server serves the body-driven read. Left undefined until a
		 * caller sets it from the schema's RetoldMetadata capabilities; the
		 * URI-based GET route is used until then.
		 *
		 * @type {boolean|undefined}
		 */
		this.QueryEndpointSupported = this.options.QueryEndpointSupported;
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		return this._Client || this.fable.HeadlightRestClient;
	}

	set client(pClient)
	{
		this._Client = pClient;
	}

	/**
	 * @return {import('./Headlight-Integration-GUIDMap.js')}
	 */
	get guidMap()
	{
		return this.fable.HeadlightGUIDMap;
	}

	/**
	 * Adopt the batch-read capability advertised by an entity schema document.
	 * The capability describes the server, not the entity, so any entity's
	 * schema answers for all of them.
	 *
	 * @param {Object} pSchemaDocument - A `/{Entity}/Schema` response.
	 */
	applySchemaCapabilities(pSchemaDocument)
	{
		if (!pSchemaDocument || typeof(pSchemaDocument) !== 'object')
		{
			return;
		}
		const tmpCapabilities = pSchemaDocument.RetoldMetadata && pSchemaDocument.RetoldMetadata.Capabilities;
		if (tmpCapabilities && typeof(tmpCapabilities.QueryEndpoint) === 'boolean')
		{
			this.QueryEndpointSupported = tmpCapabilities.QueryEndpoint;
		}
	}

	/**
	 * @return {boolean} Whether batches should go out on the body-driven read route.
	 */
	get useQueryEndpoint()
	{
		return (this.options.UseQueryEndpoint !== false) && (this.QueryEndpointSupported === true);
	}

	/**
	 * Whether a GUID is already answered by the in-memory maps the marshal path
	 * consults first: the external-GUID map (populated as earlier entities in
	 * this run were pushed) and the Headlight GUID map (populated by upserts and
	 * by earlier batches).
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {string} pGUID - The referenced GUID.
	 * @return {boolean} True when a lookup would be answered from memory.
	 */
	isCached(pEntity, pGUID)
	{
		return Boolean(this.guidMap.getHeadlightIDFromExternalGUID(pEntity, pGUID))
			|| Boolean(this.guidMap.getIDFromGUID(pEntity, pGUID));
	}

	/**
	 * Reduce a set of referenced GUIDs to the ones actually worth asking the
	 * server about.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Set<string>|Array<string>} pGUIDs - The referenced GUIDs.
	 * @return {{ Pending: Array<string>, Cached: number, Unbatchable: Array<string> }} The split.
	 */
	partitionGUIDs(pEntity, pGUIDs)
	{
		/** @type {Array<string>} */
		const tmpPending = [];
		/** @type {Array<string>} */
		const tmpUnbatchable = [];
		let tmpCached = 0;

		for (const tmpGUID of pGUIDs)
		{
			if (!tmpGUID)
			{
				continue;
			}
			if (this.isCached(pEntity, tmpGUID))
			{
				tmpCached++;
				continue;
			}
			if (UNBATCHABLE_GUID_PATTERN.test(tmpGUID))
			{
				tmpUnbatchable.push(tmpGUID);
				continue;
			}
			tmpPending.push(tmpGUID);
		}

		return { Pending: tmpPending, Cached: tmpCached, Unbatchable: tmpUnbatchable };
	}

	/**
	 * Build the meadow IN filter for a batch of GUIDs.
	 *
	 * The instruction must be `FBL` (filter by list): `FBV` binds the whole
	 * comma-joined value as a single scalar, producing `IN ('a,b,c')` -- which
	 * matches nothing and reports no error.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Array<string>} pGUIDs - The GUIDs in the batch.
	 * @return {string} The filter expression.
	 */
	buildGUIDFilter(pEntity, pGUIDs)
	{
		return `FBL~GUID${pEntity}~INN~${pGUIDs.map(encodeURIComponent).join(',')}`;
	}

	/**
	 * Take the next batch off the front of a pending queue, bounded by the batch
	 * size and — on the URI-based route — by the length of the URL it would
	 * produce.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Array<string>} pQueue - The pending GUIDs; the returned batch is spliced off it.
	 * @return {Array<string>} The next batch.
	 */
	takeBatch(pEntity, pQueue)
	{
		if (this.useQueryEndpoint)
		{
			return pQueue.splice(0, this.options.QueryBatchSize);
		}

		// `<Entity>s/Lite/FilteredTo/<filter>/0/<cap>` less the filter itself,
		// with room for the server URL prefix the client prepends.
		let tmpBudget = this.options.URLLengthBudget - (pEntity.length * 2) - 48;
		const tmpBatch = [];

		while (pQueue.length > 0 && tmpBatch.length < this.options.BatchSize)
		{
			const tmpCost = encodeURIComponent(pQueue[0]).length + 1;
			if (tmpBatch.length > 0 && tmpCost > tmpBudget)
			{
				break;
			}
			tmpBudget -= tmpCost;
			tmpBatch.push(pQueue.shift());
		}

		return tmpBatch;
	}

	/**
	 * Read one batch of GUIDs.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Array<string>} pGUIDs - The GUIDs in the batch.
	 * @return {Promise<Array<Record<string, any>>|null>} The records, or null when the body-driven read is unavailable and the batch should be retried on the GET route.
	 */
	async readBatch(pEntity, pGUIDs)
	{
		const tmpFilter = this.buildGUIDFilter(pEntity, pGUIDs);

		if (this.useQueryEndpoint)
		{
			try
			{
				return await this._postQueryBatch(pEntity, tmpFilter, pGUIDs.length);
			}
			catch (pError)
			{
				this.log.warn(`Batch GUID read for [${pEntity}] could not use the body-driven read route; falling back to URI reads: ${pError.message || pError}`);
				this.QueryEndpointSupported = false;
				return null;
			}
		}

		try
		{
			return await this._getFilteredBatch(pEntity, tmpFilter, pGUIDs.length);
		}
		catch (pError)
		{
			this.log.warn(`Batch GUID read for [${pEntity}] failed for ${pGUIDs.length} GUID(s); those references fall back to single lookups: ${pError.message || pError}`);
			return [];
		}
	}

	/**
	 * @param {string} pEntity - The referenced entity.
	 * @param {string} pFilter - The IN filter.
	 * @param {number} pCap - The record cap.
	 * @return {Promise<Array<Record<string, any>>>} The records.
	 * @private
	 */
	_getFilteredBatch(pEntity, pFilter, pCap)
	{
		const tmpReadMode = (this.options.ReadMode === 'Lite') ? '/Lite' : '';
		return new Promise((resolve, reject) =>
		{
			this.client.getJSON(`${pEntity}s${tmpReadMode}/FilteredTo/${pFilter}/0/${pCap}`,
				(pError, pBody) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					return resolve(Array.isArray(pBody) ? pBody : []);
				});
		});
	}

	/**
	 * @param {string} pEntity - The referenced entity.
	 * @param {string} pFilter - The IN filter.
	 * @param {number} pCap - The record cap.
	 * @return {Promise<Array<Record<string, any>>>} The records.
	 * @private
	 */
	_postQueryBatch(pEntity, pFilter, pCap)
	{
		const tmpRoute = this.options.QueryEndpointRoute.replace('<Entity>', pEntity);
		const tmpBody = { Filter: pFilter, Begin: 0, Cap: pCap };
		if (this.options.ReadMode === 'Lite')
		{
			tmpBody.Lite = true;
		}
		return new Promise((resolve, reject) =>
		{
			this.client.postJSON(tmpRoute, tmpBody,
				(pError, pBody) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					if (!Array.isArray(pBody))
					{
						return reject(new Error(`Body-driven read of [${pEntity}] did not return a record array.`));
					}
					return resolve(pBody);
				});
		});
	}

	/**
	 * Resolve one entity's referenced GUIDs, mapping every hit into the shared
	 * GUID map.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Set<string>|Array<string>} pGUIDs - The referenced GUIDs.
	 * @return {Promise<{ Entity: string, Requested: number, Cached: number, Resolved: number, Missing: Array<string>, Unverified: number, Requests: number }>} What the batch resolved.
	 */
	async resolveEntityGUIDs(pEntity, pGUIDs)
	{
		const tmpPartition = this.partitionGUIDs(pEntity, pGUIDs);
		const tmpResult = (
			{
				Entity: pEntity,
				Requested: tmpPartition.Pending.length,
				Cached: tmpPartition.Cached,
				Resolved: 0,
				Missing: [],
				Unverified: tmpPartition.Unbatchable.length,
				Requests: 0
			});

		if (tmpPartition.Pending.length < 1)
		{
			return tmpResult;
		}

		const tmpGUIDColumn = `GUID${pEntity}`;
		const tmpIDColumn = `ID${pEntity}`;
		const tmpQueue = tmpPartition.Pending.slice();

		while (tmpQueue.length > 0)
		{
			const tmpBatch = this.takeBatch(pEntity, tmpQueue);
			const tmpRecords = await this.readBatch(pEntity, tmpBatch);

			if (tmpRecords === null)
			{
				// The body-driven route dropped out; the batch goes back on the
				// queue and is re-cut for the (smaller) URI route.
				tmpQueue.unshift(...tmpBatch);
				continue;
			}

			tmpResult.Requests++;

			const tmpFound = new Set();
			for (const tmpRecord of tmpRecords)
			{
				if (!tmpRecord || typeof(tmpRecord) !== 'object')
				{
					continue;
				}
				const tmpGUID = tmpRecord[tmpGUIDColumn];
				const tmpID = tmpRecord[tmpIDColumn];
				if (!tmpGUID || !(tmpID > 0))
				{
					continue;
				}
				this.guidMap.mapGUIDToID(pEntity, tmpGUID, tmpID);
				tmpFound.add(tmpGUID);
			}

			if (tmpFound.size < 1)
			{
				// A batch that matches nothing at all is far more likely to be a
				// broken filter or route than a batch of entirely absent records,
				// and a caller that trusted it would skip the single-GUID lookups
				// that would have resolved them.  Report those GUIDs as unverified
				// rather than missing.
				tmpResult.Unverified += tmpBatch.length;
				this.log.warn(`Batch read of ${tmpBatch.length} [${pEntity}] GUID(s) matched no records; those references fall back to single lookups.`);
				continue;
			}

			tmpResult.Resolved += tmpFound.size;
			for (const tmpGUID of tmpBatch)
			{
				if (!tmpFound.has(tmpGUID))
				{
					tmpResult.Missing.push(tmpGUID);
				}
			}
		}

		return tmpResult;
	}

	/**
	 * Resolve a whole map of referenced GUIDs, a few entities at a time.
	 *
	 * @param {Map<string, Set<string>>} pReferences - Referenced entity -> GUID values.
	 * @return {Promise<{ Entities: Array<Object>, Requested: number, Cached: number, Resolved: number, Unverified: number, Requests: number, Missing: Map<string, Set<string>> }>} What the pass resolved.
	 */
	async resolveReferences(pReferences)
	{
		const tmpSummary = { Entities: [], Requested: 0, Cached: 0, Resolved: 0, Unverified: 0, Requests: 0, Missing: new Map() };
		const tmpEntities = Array.from(pReferences.keys()).filter((pEntity) => Boolean(pEntity));
		if (tmpEntities.length < 1)
		{
			return tmpSummary;
		}

		let tmpNextEntityIndex = 0;
		const tmpWorkerCount = Math.max(1, Math.min(this.options.EntityConcurrency, tmpEntities.length));
		const tmpWorkers = [];

		for (let i = 0; i < tmpWorkerCount; i++)
		{
			tmpWorkers.push((async () =>
			{
				while (tmpNextEntityIndex < tmpEntities.length)
				{
					const tmpEntity = tmpEntities[tmpNextEntityIndex++];
					const tmpResult = await this.resolveEntityGUIDs(tmpEntity, pReferences.get(tmpEntity));
					tmpSummary.Entities.push(tmpResult);
					tmpSummary.Requested += tmpResult.Requested;
					tmpSummary.Cached += tmpResult.Cached;
					tmpSummary.Resolved += tmpResult.Resolved;
					tmpSummary.Unverified += tmpResult.Unverified;
					tmpSummary.Requests += tmpResult.Requests;
					if (tmpResult.Missing.length > 0)
					{
						tmpSummary.Missing.set(tmpEntity, new Set(tmpResult.Missing));
					}
				}
			})());
		}

		await Promise.all(tmpWorkers);

		return tmpSummary;
	}
}

module.exports = HeadlightIntegrationGUIDBatchResolver;

module.exports.default_configuration = defaultHeadlightIntegrationGUIDBatchResolverOptions;
module.exports.classifyMappedGUIDField = classifyMappedGUIDField;
module.exports.collectMappedGUIDReferences = collectMappedGUIDReferences;
module.exports.UNBATCHABLE_GUID_PATTERN = UNBATCHABLE_GUID_PATTERN;

},{"./Headlight-Integration-GUIDMap.js":9,"fable-serviceproviderbase":398}],9:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const defaultHeadlightGUIDMapOptions = (
	{
		// Nothing here yet.
		// Maybe overwrite rules?  Right now it's just obliterate.
		// When we add persistence that would be here as well.
	});

class HeadlightGUIDMap extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadlightGUIDMapOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client') }} */
		this.fable;
		this.serviceType = 'HeadlightGUIDMap';

		// For now, keep GUID mappings to IDs in memory forever.
		// At the moment, we don't have enough data throughput for that to be a problem really.
		// When it becomes so, we can shift the persistence to some kind of key-value store.
		// These are back and forth between the Headlight GUIDs and the Headlight IDs
		this._GUIDMap = {};
		this._IDMap = {};

		// Keep track of *external* GUIDS that map to Headlight GUIDs
		this._ExternalGUIDMap = {};
	}

	// Add an entity for the mapping
	addEntity(pEntity)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this._GUIDMap[pEntity] = {};
			this._IDMap[pEntity] = {};
			this._ExternalGUIDMap[pEntity] = {};
		}

		return true;
	}

	// Map a Headlight GUID to an ID
	mapGUIDToID(pEntity, pGUID, pID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._GUIDMap[pEntity][pGUID] = pID;
		this._IDMap[pEntity][pID] = pGUID;

		return true;
	}

	// Get an ID from a GUID
	getIDFromGUID(pEntity, pGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._GUIDMap[pEntity].hasOwnProperty(pGUID)) ? this._GUIDMap[pEntity][pGUID] : false;
	}

	/**
	 * @param {string} pEntity
	 * @param {string} pGUID
	 * @param {(pError: Error|null, pID?: number|false) => void} fCallback
	 * @param {import('headlight-rest-client')} [pClient] - the client instance to use; defaults to the default fable service
	 */
	getIDFromGUIDAsync(pEntity, pGUID, fCallback, pClient)
	{
		const tmpClient = pClient || this.fable.HeadlightRestClient;
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		// If it has already been loaded, return it.
		if (this._GUIDMap[pEntity].hasOwnProperty(pGUID))
		{
			fCallback(null, this._GUIDMap[pEntity][pGUID]);
		}
		else
		{
			// Try to load it from the server
			tmpClient.getEntityByGUID(pEntity, pGUID,
				(pError, pBody) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					else
					{
						let tmpEntityIDName = `ID${pEntity}`;
						if (pBody && pBody.hasOwnProperty(tmpEntityIDName))
						{
							this.mapGUIDToID(pEntity, pGUID, pBody[tmpEntityIDName]);
							return fCallback(pError, pBody[tmpEntityIDName]);
						}
						else
						{
							return fCallback(pError, false)
						}
					}
				});
		}
	}

	// Get a GUID from an ID
	getGUIDFromID(pEntity, pID)
	{
		if (!this._IDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._IDMap[pEntity].hasOwnProperty(pID)) ? this._IDMap[pEntity][pID] : false;
	}

	// For now this is one-directional; we may need two for bi-directional sync but there are other ways to resolve this.
	mapExternalGUIDtoHeadlightGUID(pEntity, pExternalGUID, pHeadlightGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._ExternalGUIDMap[pEntity][pExternalGUID] = pHeadlightGUID;

		return true;
	}

	getHeadlightGUIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._ExternalGUIDMap[pEntity].hasOwnProperty(pExternalGUID)) ? this._ExternalGUIDMap[pEntity][pExternalGUID] : false;
	}

	getHeadlightIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		let tmpHeadlightGUID = this.getHeadlightGUIDFromExternalGUID(pEntity, pExternalGUID);
		return (tmpHeadlightGUID) ? this.getIDFromGUID(pEntity, tmpHeadlightGUID) : false;
	}
}

module.exports = HeadlightGUIDMap;

module.exports.default_configuration = defaultHeadlightGUIDMapOptions;

},{"fable-serviceproviderbase":398}],10:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libCrypto = require('crypto');
const libIntegrationAdapter = require('headlight-integration-adapter');

const SPECIFICATION_SET_LINE_ITEM_SAMPLE = 500;
// INN values ride in the URL path; the browser -> Kong path drops requests well below what Node -> API accepts.
const INN_VALUE_CHARACTER_BUDGET = 2000;

class SamplePlanService extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'SamplePlanService';
	}

	/**
	 * The HeadlightRestClient instance from the fable service manager.
	 * Both CLI and web contexts register this service on fable.
	 */
	get restClient()
	{
		return this.fable.HeadlightRestClient;
	}

	/**
	 * Generate a deterministic GUID from a prefix and composite key using MD5.
	 *
	 * @param {string} pPrefix - The prefix for the GUID (e.g., 'MSP-PLIMT', 'MSP-MLJ').
	 * @param {string} pCompositeKey - The composite key to hash.
	 * @return {string} The generated GUID.
	 */
	generateGUID(pPrefix, pCompositeKey)
	{
		let tmpHash = libCrypto.createHash('md5').update(pCompositeKey).digest('hex').substring(0, 12);
		return `${pPrefix}-${tmpHash}`;
	}

	/**
	 * Split INN filter values into batches whose comma-joined length stays within a character budget, so short
	 * numeric IDs batch widely and long strings batch small. A value longer than the budget goes out alone.
	 *
	 * @param {Array<string|number>} pValues - The values to filter by.
	 * @param {number} [pBudget] - Maximum comma-joined length per batch; defaults to INN_VALUE_CHARACTER_BUDGET.
	 * @return {Array<Array<string|number>>} The batches, in input order.
	 */
	batchINNValues(pValues, pBudget)
	{
		let tmpBudget = pBudget || INN_VALUE_CHARACTER_BUDGET;
		let tmpBatches = [];
		let tmpBatch = [];
		let tmpBatchLength = 0;
		for (let i = 0; i < pValues.length; i++)
		{
			let tmpValueLength = String(pValues[i]).length;
			let tmpNextLength = (tmpBatch.length > 0) ? (tmpBatchLength + 1 + tmpValueLength) : tmpValueLength;
			if ((tmpBatch.length > 0) && (tmpNextLength > tmpBudget))
			{
				tmpBatches.push(tmpBatch);
				tmpBatch = [];
				tmpNextLength = tmpValueLength;
			}
			tmpBatch.push(pValues[i]);
			tmpBatchLength = tmpNextLength;
		}
		if (tmpBatch.length > 0)
		{
			tmpBatches.push(tmpBatch);
		}
		return tmpBatches;
	}

	/**
	 * Fetch entities in batched INN filters, each within INN_VALUE_CHARACTER_BUDGET, to avoid URL length limits.
	 *
	 * @param {string} pEntityType - The Meadow entity type.
	 * @param {string} pFilterField - The field to filter on.
	 * @param {Array<string|number>} pIDs - The values to filter by (IDs, or strings such as ItemCode).
	 * @param {string|null} pExtraFilter - Additional filter expression to append.
	 * @param {Function} fCallback - Callback: (error, records[]).
	 */
	getEntitySetBatched(pEntityType, pFilterField, pIDs, pExtraFilter, fCallback)
	{
		let tmpAllRecords = [];

		if (pIDs.length === 0)
		{
			return fCallback(null, []);
		}

		let tmpBatches = this.batchINNValues(pIDs);

		let tmpBatchIndex = 0;
		let tmpProcessBatch = () =>
		{
			if (tmpBatchIndex >= tmpBatches.length)
			{
				this.log.info(`    ... fetched ${tmpAllRecords.length} ${pEntityType} records total.`);
				return fCallback(null, tmpAllRecords);
			}

			if (tmpBatches.length > 1)
			{
				this.log.info(`    ... batch ${tmpBatchIndex + 1}/${tmpBatches.length} (${tmpAllRecords.length} records so far)`);
			}

			let tmpBatchIDs = tmpBatches[tmpBatchIndex].join(',');
			let tmpFilter = `FBL~${pFilterField}~INN~${tmpBatchIDs}~FBV~Deleted~EQ~0`;
			if (pExtraFilter)
			{
				tmpFilter += `~${pExtraFilter}`;
			}

			this.restClient.getEntitySet(pEntityType, tmpFilter,
				(pError, pRecords) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					tmpAllRecords = tmpAllRecords.concat(pRecords);
					tmpBatchIndex++;
					tmpProcessBatch();
				}, 0, 200000);
		};
		tmpProcessBatch();
	}

	/**
	 * Count entities in batched INN filters, each within INN_VALUE_CHARACTER_BUDGET, to avoid URL length limits.
	 *
	 * @param {string} pEntityType - The Meadow entity type.
	 * @param {string} pFilterField - The field to filter on.
	 * @param {Array<string|number>} pIDs - The values to filter by (IDs, or strings such as ItemCode).
	 * @param {string|null} pExtraFilter - Additional filter expression to append.
	 * @param {(pError?: any, pCount?: number) => void} fCallback - Callback with the total across batches.
	 */
	getEntitySetCountBatched(pEntityType, pFilterField, pIDs, pExtraFilter, fCallback)
	{
		let tmpBatches = this.batchINNValues(pIDs);
		let tmpTotal = 0;
		let tmpBatchIndex = 0;

		let tmpProcessBatch = () =>
		{
			if (tmpBatchIndex >= tmpBatches.length)
			{
				return fCallback(null, tmpTotal);
			}

			let tmpFilter = `FBL~${pFilterField}~INN~${tmpBatches[tmpBatchIndex].join(',')}~FBV~Deleted~EQ~0`;
			if (pExtraFilter)
			{
				tmpFilter += `~${pExtraFilter}`;
			}
			tmpBatchIndex++;

			this.restClient.getEntitySetCount(pEntityType, tmpFilter,
				(pError, pResult) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					tmpTotal += (pResult && pResult.Count) ? pResult.Count : 0;
					tmpProcessBatch();
				});
		};
		tmpProcessBatch();
	}

	/**
	 * Index line items by ItemCode. When an ItemCode repeats, the last line item read wins, and the
	 * repeats are reported so the caller can warn.
	 *
	 * @param {Array<Record<string, any>>} pLineItems - Line items carrying ItemCode.
	 * @return {{ByItemCode: Record<string, Record<string, any>>, DuplicateItemCodes: Array<string>, Warning: string|null}} The index.
	 */
	indexLineItemsByItemCode(pLineItems)
	{
		let tmpByItemCode = {};
		let tmpDuplicates = {};
		for (let i = 0; i < pLineItems.length; i++)
		{
			let tmpItemCode = pLineItems[i].ItemCode;
			if (!tmpItemCode)
			{
				continue;
			}
			if (tmpByItemCode[tmpItemCode])
			{
				tmpDuplicates[tmpItemCode] = true;
			}
			tmpByItemCode[tmpItemCode] = pLineItems[i];
		}

		let tmpDuplicateItemCodes = Object.keys(tmpDuplicates);
		let tmpWarning = null;
		if (tmpDuplicateItemCodes.length > 0)
		{
			let tmpShown = tmpDuplicateItemCodes.slice(0, 10).join(', ') + ((tmpDuplicateItemCodes.length > 10) ? ', ...' : '');
			tmpWarning = `${tmpDuplicateItemCodes.length} item code(s) appear on more than one source line item, so the plan is copied from only one of them: ${tmpShown}.`;
		}
		return { ByItemCode: tmpByItemCode, DuplicateItemCodes: tmpDuplicateItemCodes, Warning: tmpWarning };
	}

	/**
	 * @typedef {object} SamplePlanProjectContext
	 * @property {Record<string, any>} Project - The Project record.
	 * @property {Record<string, any>|null} Contract - The project's Contract, or null when it has none.
	 * @property {Array<{IDProject: number, Name: string}>} ContractProjects - Every live project on that Contract, this one included.
	 */

	/**
	 * @typedef {object} ProjectSpecificationSets
	 * @property {number} IDProject - The project.
	 * @property {string} Name - The project name.
	 * @property {Record<string, any>|null} Contract - The project's Contract, or null.
	 * @property {Array<{IDProject: number, Name: string}>} ContractProjects - Every live project on that Contract.
	 * @property {number} ItemIDTestSpecificationSet - The Contract's item set, else the single set the line items' pay items share; 0 when neither resolves.
	 * @property {number} MaterialIDTestSpecificationSet - The Contract's material set, else the item set.
	 * @property {string} Basis - Where the item set came from: 'Contract', 'PayItems' or 'None'.
	 * @property {Record<string, number>} PayItemSetDistribution - Line item count per PayItem.IDTestSpecificationSet.
	 * @property {boolean} PayItemSetMixed - True when the line items' pay items span more than one set.
	 * @property {number} LineItemsWithoutPayItem - Line items with no live pay item.
	 * @property {number} LineItemsExamined - Line items the distribution was built from.
	 * @property {Record<string, string>} [SpecificationSetNames] - TestSpecificationSet names by ID, when fetched.
	 */

	/**
	 * @typedef {object} LineItemPayItemRemap
	 * @property {number} IDLineItem - The destination line item.
	 * @property {string} GUIDLineItem - Its existing GUID, used verbatim to update in place.
	 * @property {string} ItemCode - The ItemCode the pay items were matched on.
	 * @property {string} Name - The line item name.
	 * @property {number} FromIDPayItem - The current pay item.
	 * @property {number} FromIDTestSpecificationSet - The current pay item's set.
	 * @property {number} ToIDPayItem - The target-set pay item.
	 */

	/**
	 * @typedef {object} SpecificationSetContractUpdate
	 * @property {number} IDContract - The destination Contract.
	 * @property {string} GUIDContract - Its existing GUID, used verbatim to update in place.
	 * @property {string} Name - The Contract name.
	 * @property {{ItemIDTestSpecificationSet: number, MaterialIDTestSpecificationSet: number}} Before - Current sets.
	 * @property {{ItemIDTestSpecificationSet: number, MaterialIDTestSpecificationSet: number}} After - Target sets.
	 * @property {Array<{IDProject: number, Name: string}>} SharedWithProjects - Other projects on the same Contract.
	 */

	/**
	 * @typedef {object} SpecificationSetAlignment
	 * @property {boolean} Crossing - True when the destination sits on different sets than the source.
	 * @property {number} ItemIDTestSpecificationSet - Target item set.
	 * @property {number} MaterialIDTestSpecificationSet - Target material set.
	 * @property {SpecificationSetContractUpdate|null} Contract - The Contract update, or null when none is needed or possible.
	 * @property {Array<LineItemPayItemRemap>} LineItemRemaps - Line items to move onto target-set pay items.
	 * @property {Array<{IDLineItem: number, ItemCode: string, Name: string, Reason: string}>} Unmapped - Line items on another set that cannot be moved.
	 * @property {number} AlreadyAlignedCount - Line items already on target-set pay items.
	 * @property {number} WithoutPayItemCount - Line items with no live pay item, left alone.
	 * @property {Array<string>} Warnings - Conditions to surface before the load.
	 * @property {boolean} [Flip] - Set by `resolveSpecificationSetAlignment`: whether the copy applies the plan.
	 */

	/**
	 * Fetch a project, its Contract (if any) and every live project sharing that Contract.
	 *
	 * @param {number} pIDProject - The project.
	 * @param {(pError?: any, pContext?: SamplePlanProjectContext) => void} fCallback - Callback.
	 */
	getProjectContext(pIDProject, fCallback)
	{
		this.restClient.getEntity('Project', pIDProject,
			(pError, pProject) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpContext = { Project: pProject || {}, Contract: null, ContractProjects: [] };
				if (!(tmpContext.Project.IDContract > 0))
				{
					return fCallback(null, tmpContext);
				}
				this.restClient.getEntity('Contract', tmpContext.Project.IDContract,
					(pContractError, pContract) =>
					{
						if (pContractError)
						{
							return fCallback(pContractError);
						}
						if (!pContract || !(pContract.IDContract > 0))
						{
							return fCallback(null, tmpContext);
						}
						tmpContext.Contract = pContract;
						this.restClient.getEntitySet('Project', `FBV~IDContract~EQ~${pContract.IDContract}~FBV~Deleted~EQ~0`,
							(pProjectsError, pProjects) =>
							{
								if (pProjectsError)
								{
									return fCallback(pProjectsError);
								}
								tmpContext.ContractProjects = (pProjects || []).map((pSharingProject) => ({ IDProject: pSharingProject.IDProject, Name: pSharingProject.Name || '' }));
								return fCallback(null, tmpContext);
							}, 0, 1000);
					});
			});
	}

	/**
	 * Fetch the live pay items referenced by a set of line items.
	 *
	 * @param {Array<Record<string, any>>} pLineItems - Line items carrying IDPayItem.
	 * @param {(pError?: any, pPayItemsByID?: Record<string, Record<string, any>>) => void} fCallback - Callback.
	 */
	getPayItemsForLineItems(pLineItems, fCallback)
	{
		let tmpIDs = [ ...new Set(pLineItems.map((pLineItem) => pLineItem.IDPayItem).filter((pID) => pID > 0)) ];
		this.getEntitySetBatched('PayItem', 'IDPayItem', tmpIDs, null,
			(pError, pPayItems) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpPayItemsByID = {};
				for (let i = 0; i < pPayItems.length; i++)
				{
					tmpPayItemsByID[pPayItems[i].IDPayItem] = pPayItems[i];
				}
				return fCallback(null, tmpPayItemsByID);
			});
	}

	/**
	 * Fetch TestSpecificationSet names.
	 *
	 * @param {Array<number>} pSetIDs - Set IDs; zeros and repeats are ignored.
	 * @param {(pError?: any, pNames?: Record<string, string>) => void} fCallback - Callback.
	 */
	getSpecificationSetNames(pSetIDs, fCallback)
	{
		let tmpIDs = [ ...new Set(pSetIDs.filter((pID) => pID > 0)) ];
		this.getEntitySetBatched('TestSpecificationSet', 'IDTestSpecificationSet', tmpIDs, null,
			(pError, pSets) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpNames = {};
				for (let i = 0; i < pSets.length; i++)
				{
					tmpNames[pSets[i].IDTestSpecificationSet] = pSets[i].Name || '';
				}
				return fCallback(null, tmpNames);
			});
	}

	/**
	 * Work out which specification sets a project is on. The Contract is authoritative; a project
	 * without one falls back to PayItem.IDTestSpecificationSet across its line items.
	 *
	 * @param {SamplePlanProjectContext} pContext - The project and its Contract.
	 * @param {Array<Record<string, any>>} pLineItems - The line items to read pay item sets from.
	 * @param {Record<string, Record<string, any>>} pPayItemsByID - Pay items by IDPayItem.
	 * @return {ProjectSpecificationSets} The project's sets.
	 */
	summarizeProjectSpecificationSets(pContext, pLineItems, pPayItemsByID)
	{
		let tmpDistribution = {};
		let tmpWithoutPayItem = 0;
		for (let i = 0; i < pLineItems.length; i++)
		{
			let tmpPayItem = pPayItemsByID[pLineItems[i].IDPayItem];
			if (!tmpPayItem)
			{
				tmpWithoutPayItem++;
				continue;
			}
			let tmpSetID = Number(tmpPayItem.IDTestSpecificationSet) || 0;
			tmpDistribution[tmpSetID] = (tmpDistribution[tmpSetID] || 0) + 1;
		}
		let tmpPayItemSetIDs = Object.keys(tmpDistribution);
		let tmpPayItemSetID = (tmpPayItemSetIDs.length === 1) ? parseInt(tmpPayItemSetIDs[0], 10) : 0;

		let tmpContract = pContext.Contract;
		let tmpItemSetID = 0;
		let tmpBasis = 'None';
		if (tmpContract && (Number(tmpContract.ItemIDTestSpecificationSet) > 0))
		{
			tmpItemSetID = Number(tmpContract.ItemIDTestSpecificationSet);
			tmpBasis = 'Contract';
		}
		else if (tmpPayItemSetID > 0)
		{
			tmpItemSetID = tmpPayItemSetID;
			tmpBasis = 'PayItems';
		}
		let tmpMaterialSetID = (tmpContract && (Number(tmpContract.MaterialIDTestSpecificationSet) > 0)) ? Number(tmpContract.MaterialIDTestSpecificationSet) : tmpItemSetID;

		return (
			{
				IDProject: pContext.Project.IDProject,
				Name: pContext.Project.Name || '',
				Contract: tmpContract,
				ContractProjects: pContext.ContractProjects,
				ItemIDTestSpecificationSet: tmpItemSetID,
				MaterialIDTestSpecificationSet: tmpMaterialSetID,
				Basis: tmpBasis,
				PayItemSetDistribution: tmpDistribution,
				PayItemSetMixed: tmpPayItemSetIDs.length > 1,
				LineItemsWithoutPayItem: tmpWithoutPayItem,
				LineItemsExamined: pLineItems.length
			});
	}

	/**
	 * Work out a project's specification sets from its Contract, else from a sample of its own line items.
	 *
	 * @param {SamplePlanProjectContext} pContext - The project and its Contract.
	 * @param {number} [pLineItemLimit] - Maximum line items to sample for the pay item fallback.
	 * @param {(pError?: any, pSets?: ProjectSpecificationSets) => void} fCallback - Callback.
	 */
	resolveProjectSpecificationSets(pContext, pLineItemLimit, fCallback)
	{
		this.restClient.getEntitySet('LineItem', `FBV~IDProject~EQ~${pContext.Project.IDProject}~FBV~Deleted~EQ~0`,
			(pError, pRecords) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpLineItems = pRecords || [];
				this.getPayItemsForLineItems(tmpLineItems,
					(pPayItemError, pPayItemsByID) =>
					{
						if (pPayItemError)
						{
							return fCallback(pPayItemError);
						}
						return fCallback(null, this.summarizeProjectSpecificationSets(pContext, tmpLineItems, pPayItemsByID));
					});
			}, 0, pLineItemLimit || SPECIFICATION_SET_LINE_ITEM_SAMPLE);
	}

	/**
	 * Describe a project's specification sets for display.
	 *
	 * @param {number} pIDProject - The project.
	 * @param {number|null} pLineItemLimit - Maximum line items to sample for the pay item fallback; null for the default.
	 * @param {(pError?: any, pSets?: ProjectSpecificationSets) => void} fCallback - Callback.
	 */
	describeProjectSpecificationSets(pIDProject, pLineItemLimit, fCallback)
	{
		let tmpSets = null;

		this.fable.Utility.waterfall(
			[
				(fStageComplete) =>
				{
					this.getProjectContext(pIDProject,
						(pError, pContext) =>
						{
							if (pError)
							{
								return fStageComplete(pError);
							}
							this.resolveProjectSpecificationSets(pContext, pLineItemLimit,
								(pSetsError, pSets) =>
								{
									tmpSets = pSets;
									return fStageComplete(pSetsError);
								});
						});
				},
				(fStageComplete) =>
				{
					this.getSpecificationSetNames([ tmpSets.ItemIDTestSpecificationSet, tmpSets.MaterialIDTestSpecificationSet ],
						(pError, pNames) =>
						{
							tmpSets.SpecificationSetNames = pNames || {};
							return fStageComplete(pError);
						});
				}
			],
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`Error describing specification sets for project ${pIDProject}`, pError);
				}
				return fCallback(pError, tmpSets);
			});
	}

	/**
	 * Plan the Contract and LineItem updates that move a destination project onto the source's
	 * specification sets. Line items are matched to target-set pay items by ItemCode through
	 * PayItem.IDTestSpecificationSet.
	 *
	 * @param {object} pInputs - Planning inputs.
	 * @param {number} pInputs.ItemIDTestSpecificationSet - Target item set; 0 disables realignment.
	 * @param {number} pInputs.MaterialIDTestSpecificationSet - Target material set; defaults to the item set.
	 * @param {number} pInputs.DestIDProject - The destination project.
	 * @param {Record<string, any>|null} pInputs.DestContract - The destination's Contract, or null.
	 * @param {Array<{IDProject: number, Name: string}>} pInputs.DestContractProjects - Every live project on that Contract.
	 * @param {Array<Record<string, any>>} pInputs.DestLineItems - Every destination line item.
	 * @param {Record<string, Record<string, any>>} pInputs.DestPayItemsByID - The destination line items' pay items.
	 * @param {Record<string, Array<Record<string, any>>>} pInputs.TargetPayItemsByItemCode - Target-set pay items by ItemCode.
	 * @return {SpecificationSetAlignment} The plan.
	 */
	planSpecificationSetAlignment(pInputs)
	{
		let tmpItemSetID = Number(pInputs.ItemIDTestSpecificationSet) || 0;
		let tmpMaterialSetID = Number(pInputs.MaterialIDTestSpecificationSet) || tmpItemSetID;
		let tmpAlignment = (
			{
				Crossing: false,
				ItemIDTestSpecificationSet: tmpItemSetID,
				MaterialIDTestSpecificationSet: tmpMaterialSetID,
				Contract: null,
				LineItemRemaps: [],
				Unmapped: [],
				AlreadyAlignedCount: 0,
				WithoutPayItemCount: 0,
				Warnings: []
			});

		if (tmpItemSetID < 1)
		{
			return tmpAlignment;
		}

		let tmpContract = pInputs.DestContract;
		if (tmpContract)
		{
			let tmpBefore = (
				{
					ItemIDTestSpecificationSet: Number(tmpContract.ItemIDTestSpecificationSet) || 0,
					MaterialIDTestSpecificationSet: Number(tmpContract.MaterialIDTestSpecificationSet) || 0
				});
			if ((tmpBefore.ItemIDTestSpecificationSet !== tmpItemSetID) || (tmpBefore.MaterialIDTestSpecificationSet !== tmpMaterialSetID))
			{
				tmpAlignment.Crossing = true;
				let tmpSharedWith = (pInputs.DestContractProjects || []).filter((pProject) => Number(pProject.IDProject) !== Number(pInputs.DestIDProject));
				if (!tmpContract.GUIDContract)
				{
					tmpAlignment.Warnings.push(`Contract ${tmpContract.Name || tmpContract.IDContract} has no stable identifier (GUID), so its specification sets cannot be updated by this copy.`);
				}
				else
				{
					tmpAlignment.Contract = (
						{
							IDContract: tmpContract.IDContract,
							GUIDContract: tmpContract.GUIDContract,
							Name: tmpContract.Name || '',
							Before: tmpBefore,
							After: { ItemIDTestSpecificationSet: tmpItemSetID, MaterialIDTestSpecificationSet: tmpMaterialSetID },
							SharedWithProjects: tmpSharedWith
						});
					if (tmpSharedWith.length > 0)
					{
						tmpAlignment.Warnings.push(`Contract ${tmpContract.Name || tmpContract.IDContract} is shared with ${tmpSharedWith.length} other project(s) (${tmpSharedWith.map((pProject) => pProject.IDProject).join(', ')}); changing its specification sets affects them too.`);
					}
				}
			}
		}

		let tmpLineItems = pInputs.DestLineItems || [];
		for (let i = 0; i < tmpLineItems.length; i++)
		{
			let tmpLineItem = tmpLineItems[i];
			let tmpPayItem = (tmpLineItem.IDPayItem > 0) ? pInputs.DestPayItemsByID[tmpLineItem.IDPayItem] : null;
			if (!tmpPayItem)
			{
				tmpAlignment.WithoutPayItemCount++;
				continue;
			}
			let tmpFromSetID = Number(tmpPayItem.IDTestSpecificationSet) || 0;
			if (tmpFromSetID === tmpItemSetID)
			{
				tmpAlignment.AlreadyAlignedCount++;
				continue;
			}

			tmpAlignment.Crossing = true;
			let tmpItemCode = tmpPayItem.ItemCode || tmpLineItem.ItemCode || '';
			let tmpCandidates = (tmpItemCode && pInputs.TargetPayItemsByItemCode[tmpItemCode]) || [];
			let tmpReason = '';
			if (tmpCandidates.length === 0)
			{
				tmpReason = `No pay item with item code ${tmpItemCode} in specification set ${tmpItemSetID}.`;
			}
			else if (tmpCandidates.length > 1)
			{
				tmpReason = `${tmpCandidates.length} pay items share item code ${tmpItemCode} in specification set ${tmpItemSetID}.`;
			}
			else if (!tmpLineItem.GUIDLineItem)
			{
				tmpReason = 'Line item has no stable identifier (GUID), so it cannot be updated.';
			}
			if (tmpReason)
			{
				tmpAlignment.Unmapped.push({ IDLineItem: tmpLineItem.IDLineItem, ItemCode: tmpLineItem.ItemCode || '', Name: tmpLineItem.Name || '', Reason: tmpReason });
				continue;
			}

			tmpAlignment.LineItemRemaps.push(
				{
					IDLineItem: tmpLineItem.IDLineItem,
					GUIDLineItem: tmpLineItem.GUIDLineItem,
					ItemCode: tmpItemCode,
					Name: tmpLineItem.Name || '',
					FromIDPayItem: tmpLineItem.IDPayItem,
					FromIDTestSpecificationSet: tmpFromSetID,
					ToIDPayItem: tmpCandidates[0].IDPayItem
				});
		}

		if (tmpAlignment.Unmapped.length > 0)
		{
			tmpAlignment.Warnings.push(`${tmpAlignment.Unmapped.length} destination line item(s) have no matching pay item in specification set ${tmpItemSetID} and will keep their current pay item.`);
		}

		return tmpAlignment;
	}

	/**
	 * Settle what a copy applies from an alignment plan. With the flip on the plan is kept as-is; with it off the
	 * crossing is still reported, but no Contract or LineItem change is planned.
	 *
	 * @param {SpecificationSetAlignment} pAlignment - The plan from `planSpecificationSetAlignment`.
	 * @param {boolean} pFlipTargetSpecificationSet - Whether the copy moves the destination onto the source's sets.
	 * @return {SpecificationSetAlignment} The alignment the copy applies, with `Flip` set.
	 */
	resolveSpecificationSetAlignment(pAlignment, pFlipTargetSpecificationSet)
	{
		if (pFlipTargetSpecificationSet)
		{
			return Object.assign({}, pAlignment, { Flip: true });
		}
		return Object.assign({}, pAlignment, { Flip: false, Contract: null, LineItemRemaps: [], Unmapped: [], Warnings: [] });
	}

	/**
	 * Turn an alignment plan into comprehension records. Both entities update existing rows, so
	 * they carry `_GUID<Entity>` (used verbatim) rather than `GUID<Entity>` (which gets prefixed
	 * and would insert a new row).
	 *
	 * @param {SpecificationSetAlignment} pAlignment - The plan.
	 * @return {{Contract?: Record<string, Record<string, any>>, LineItem?: Record<string, Record<string, any>>}} Comprehension entities; empty when nothing changes.
	 */
	buildSpecificationSetRealignmentRecords(pAlignment)
	{
		let tmpRecords = {};
		if (pAlignment.Contract)
		{
			tmpRecords.Contract = {};
			tmpRecords.Contract[pAlignment.Contract.GUIDContract] = (
				{
					_GUIDContract: pAlignment.Contract.GUIDContract,
					ItemIDTestSpecificationSet: pAlignment.Contract.After.ItemIDTestSpecificationSet,
					MaterialIDTestSpecificationSet: pAlignment.Contract.After.MaterialIDTestSpecificationSet
				});
		}
		if (pAlignment.LineItemRemaps.length > 0)
		{
			tmpRecords.LineItem = {};
			for (let i = 0; i < pAlignment.LineItemRemaps.length; i++)
			{
				let tmpRemap = pAlignment.LineItemRemaps[i];
				tmpRecords.LineItem[tmpRemap.GUIDLineItem] = { _GUIDLineItem: tmpRemap.GUIDLineItem, IDPayItem: tmpRemap.ToIDPayItem };
			}
		}
		return tmpRecords;
	}

	/**
	 * @typedef {object} SamplePlanCopyOptions
	 * @property {boolean} [FlipTargetSpecificationSet] - Also move the destination onto the source's specification sets
	 *   (Contract set columns and LineItem.IDPayItem). Off by default: the destination keeps its sets and only plan rows are copied.
	 */

	/**
	 * Build a sample plan comprehension by matching source project line items
	 * to destination project line items by ItemCode. The copy only adds and updates rows; it never removes any.
	 *
	 * @param {number} pSourceIDProject - Source (master) project IDProject.
	 * @param {number} pDestIDProject - Destination project IDProject.
	 * @param {SamplePlanCopyOptions|Function} pOptions - Copy options; may be omitted, in which case this is the callback.
	 * @param {Function} [fCallback] - Callback: (error, result) where result is { comprehension, reportData, warnings }.
	 */
	buildComprehension(pSourceIDProject, pDestIDProject, pOptions, fCallback)
	{
		if (typeof pOptions === 'function')
		{
			return this.buildComprehension(pSourceIDProject, pDestIDProject, {}, pOptions);
		}
		let tmpFlipTargetSpecificationSet = !!(pOptions && pOptions.FlipTargetSpecificationSet);

		let tmpSourceProject = {};
		let tmpDestProject = {};
		let tmpSourceContext = null;
		let tmpDestContext = null;
		let tmpPayItemsByID = {};
		let tmpSourceSets = null;
		let tmpDestSets = null;
		let tmpTargetPayItemsByItemCode = {};
		let tmpSetNames = {};
		let tmpSourceLineItems = [];
		let tmpSourceLineItemCount = 0;
		let tmpSourcePLIMTTotal = 0;
		let tmpSourcePLIMTs = [];
		let tmpSourceMLIJs = [];
		let tmpDestLineItems = [];
		let tmpDestExistingPLIMTCount = 0;
		let tmpDestExistingMLIJCount = 0;
		let tmpWarnings = [];

		this.log.info(`Sample Plan Comprehension Builder`);
		this.log.info(`  Source IDProject:      ${pSourceIDProject}`);
		this.log.info(`  Destination IDProject: ${pDestIDProject}`);
		this.log.info(`  Flip target specification set: ${tmpFlipTargetSpecificationSet ? 'yes' : 'no'}`);

		this.fable.Utility.waterfall(
			[
				// Stage 1: Fetch both projects and their contracts
				(fStageComplete) =>
				{
					this.log.info(`Fetching project records...`);
					this.getProjectContext(pSourceIDProject,
						(pError, pSourceContext) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source project`, pError);
								return fStageComplete(pError);
							}
							tmpSourceContext = pSourceContext;
							tmpSourceProject = pSourceContext.Project;
							this.log.info(`  Source:      [${tmpSourceProject.IDProject}] ${tmpSourceProject.Name || '(unnamed)'}`);

							this.getProjectContext(pDestIDProject,
								(pError2, pDestContext) =>
								{
									if (pError2)
									{
										this.log.error(`Error fetching destination project`, pError2);
										return fStageComplete(pError2);
									}
									tmpDestContext = pDestContext;
									tmpDestProject = pDestContext.Project;
									this.log.info(`  Destination: [${tmpDestProject.IDProject}] ${tmpDestProject.Name || '(unnamed)'}`);
									let tmpDestContract = tmpDestContext.Contract;
									if (tmpDestContract)
									{
										this.log.info(`  Destination contract [${tmpDestContract.IDContract}] item set ${tmpDestContract.ItemIDTestSpecificationSet}, material set ${tmpDestContract.MaterialIDTestSpecificationSet}, on ${tmpDestContext.ContractProjects.length} project(s)`);
									}
									return fStageComplete();
								});
						});
				},

				// Stage 2: Count all source line items (regardless of matching)
				(fStageComplete) =>
				{
					this.log.info(`Counting source project line items...`);
					this.restClient.getEntitySetCount('LineItem',
						`FBV~IDProject~EQ~${pSourceIDProject}~FBV~Deleted~EQ~0`,
						(pError, pResult) =>
						{
							if (pError)
							{
								this.log.error(`Error counting source line items`, pError);
								return fStageComplete(pError);
							}
							tmpSourceLineItemCount = (pResult && pResult.Count) ? pResult.Count : 0;
							this.log.info(`  Source project has ${tmpSourceLineItemCount} total line items.`);
							this.restClient.getEntitySetCount('ProjectLineItemMaterialTest',
								`FBV~IDProject~EQ~${pSourceIDProject}~FBV~Deleted~EQ~0`,
								(pPLIMTError, pPLIMTResult) =>
								{
									if (pPLIMTError)
									{
										this.log.error(`Error counting source PLIMTs`, pPLIMTError);
										return fStageComplete(pPLIMTError);
									}
									tmpSourcePLIMTTotal = (pPLIMTResult && pPLIMTResult.Count) ? pPLIMTResult.Count : 0;
									this.log.info(`  Source project has ${tmpSourcePLIMTTotal} sample plan tests.`);
									return fStageComplete();
								});
						});
				},

				// Stage 3: Fetch destination line items
				(fStageComplete) =>
				{
					this.log.info(`Fetching destination project line items...`);
					this.restClient.getEntitySet('LineItem',
						`FBV~IDProject~EQ~${pDestIDProject}~FBV~Deleted~EQ~0`,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching destination line items`, pError);
							}
							else
							{
								tmpDestLineItems = pRecords;
								this.log.info(`  Found ${tmpDestLineItems.length} destination line items.`);
							}
							return fStageComplete(pError);
						}, 0, 100000);
				},

				// Stage 4: Fetch matching source line items by ItemCode
				(fStageComplete) =>
				{
					this.log.info(`Fetching matching source project line items...`);
					let tmpDestItemCodes = {};
					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						if (tmpDestLineItems[i].ItemCode)
						{
							tmpDestItemCodes[tmpDestLineItems[i].ItemCode] = true;
						}
					}
					let tmpUniqueItemCodes = Object.keys(tmpDestItemCodes);
					this.log.info(`  Destination has ${tmpUniqueItemCodes.length} unique ItemCodes.`);

					if (tmpUniqueItemCodes.length === 0)
					{
						this.log.warn(`  No ItemCodes found in destination — nothing to match.`);
						return fStageComplete();
					}

					this.getEntitySetBatched('LineItem', 'ItemCode', tmpUniqueItemCodes,
						`FBV~IDProject~EQ~${pSourceIDProject}`,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source line items`, pError);
							}
							else
							{
								tmpSourceLineItems = pRecords;
								this.log.info(`  Found ${tmpSourceLineItems.length} matching source line items.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 5: Fetch source PLIMTs
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);

					if (tmpSourceLineItemIDs.length === 0)
					{
						this.log.warn(`No matching source line items — skipping PLIMT fetch.`);
						return fStageComplete();
					}

					this.log.info(`Fetching source ProjectLineItemMaterialTests for ${tmpSourceLineItemIDs.length} line items...`);
					this.getEntitySetBatched('ProjectLineItemMaterialTest', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source PLIMTs`, pError);
							}
							else
							{
								tmpSourcePLIMTs = pRecords;
								this.log.info(`  Found ${tmpSourcePLIMTs.length} source ProjectLineItemMaterialTests.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 6: Fetch source MaterialLineItemJoins
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);

					if (tmpSourceLineItemIDs.length === 0)
					{
						this.log.warn(`No matching source line items — skipping MLJ fetch.`);
						return fStageComplete();
					}

					this.log.info(`Fetching source MaterialLineItemJoins...`);
					this.getEntitySetBatched('MaterialLineItemJoin', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source MLIJs`, pError);
							}
							else
							{
								tmpSourceMLIJs = pRecords;
								this.log.info(`  Found ${tmpSourceMLIJs.length} source MaterialLineItemJoins.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 7: Check for existing sample plan data in destination
				(fStageComplete) =>
				{
					this.log.info(`Checking for existing sample plan data in destination...`);
					this.restClient.getEntitySetCount('ProjectLineItemMaterialTest',
						`FBV~IDProject~EQ~${pDestIDProject}~FBV~Deleted~EQ~0`,
						(pError, pResult) =>
						{
							if (pError)
							{
								this.log.error(`Error checking existing PLIMTs`, pError);
								return fStageComplete(pError);
							}

							let tmpExistingCount = (pResult && pResult.Count) ? pResult.Count : 0;
							tmpDestExistingPLIMTCount = tmpExistingCount;
							if (tmpExistingCount > 0)
							{
								let tmpMsg = `Destination project already has ${tmpExistingCount} sample plan tests. The copy adds to them and removes none, so they may duplicate the copied tests.`;
								this.log.warn(tmpMsg);
								tmpWarnings.push(tmpMsg);
							}
							else
							{
								this.log.info(`  No existing sample plan data in destination.`);
							}

							let tmpDestLineItemIDs = tmpDestLineItems.map((pLI) => pLI.IDLineItem);
							this.getEntitySetCountBatched('MaterialLineItemJoin', 'IDLineItem', tmpDestLineItemIDs, null,
								(pMLIJError, pMLIJCount) =>
								{
									if (pMLIJError)
									{
										let tmpMsg = `Could not check whether the destination line items already have materials assigned.`;
										this.log.warn(tmpMsg, pMLIJError);
										tmpWarnings.push(tmpMsg);
									}
									else if (pMLIJCount > 0)
									{
										tmpDestExistingMLIJCount = pMLIJCount;
										let tmpMsg = `Destination line items already have ${pMLIJCount} materials assigned.`;
										this.log.warn(tmpMsg);
										tmpWarnings.push(tmpMsg);
									}
									return fStageComplete();
								});
						});
				},

				// Stage 8: Resolve each project's specification sets
				(fStageComplete) =>
				{
					this.log.info(`Resolving specification sets...`);
					this.resolveProjectSpecificationSets(tmpSourceContext, SPECIFICATION_SET_LINE_ITEM_SAMPLE,
						(pSourceError, pSourceSets) =>
						{
							if (pSourceError)
							{
								this.log.error(`Error resolving the source project's specification sets`, pSourceError);
								return fStageComplete(pSourceError);
							}
							tmpSourceSets = pSourceSets;
							this.getPayItemsForLineItems(tmpDestLineItems,
								(pError, pPayItemsByID) =>
								{
									if (pError)
									{
										this.log.error(`Error fetching destination line item pay items`, pError);
										return fStageComplete(pError);
									}
									tmpPayItemsByID = pPayItemsByID;
									tmpDestSets = this.summarizeProjectSpecificationSets(tmpDestContext, tmpDestLineItems, tmpPayItemsByID);
									this.log.info(`  Source:      item set ${tmpSourceSets.ItemIDTestSpecificationSet}, material set ${tmpSourceSets.MaterialIDTestSpecificationSet} (from ${tmpSourceSets.Basis})`);
									this.log.info(`  Destination: item set ${tmpDestSets.ItemIDTestSpecificationSet}, material set ${tmpDestSets.MaterialIDTestSpecificationSet} (from ${tmpDestSets.Basis})`);
									if (tmpFlipTargetSpecificationSet && tmpSourceSets.PayItemSetMixed && (tmpSourceSets.Basis !== 'Contract'))
									{
										let tmpSetCounts = Object.keys(tmpSourceSets.PayItemSetDistribution).map((pID) => `set ${pID}: ${tmpSourceSets.PayItemSetDistribution[pID]}`).join(', ');
										let tmpMsg = `Source line items use pay items from more than one specification set (${tmpSetCounts}), so the destination will not be moved onto the source's sets.`;
										this.log.warn(tmpMsg);
										tmpWarnings.push(tmpMsg);
									}
									return fStageComplete();
								});
						});
				},

				// Stage 9: Fetch target-set pay items for destination line items on another set
				(fStageComplete) =>
				{
					let tmpTargetSetID = tmpSourceSets.ItemIDTestSpecificationSet;
					if (!tmpFlipTargetSpecificationSet || !(tmpTargetSetID > 0))
					{
						return fStageComplete();
					}

					let tmpItemCodes = {};
					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						let tmpPayItem = tmpPayItemsByID[tmpDestLineItems[i].IDPayItem];
						let tmpItemCode = tmpPayItem ? (tmpPayItem.ItemCode || tmpDestLineItems[i].ItemCode) : null;
						if (tmpItemCode && ((Number(tmpPayItem.IDTestSpecificationSet) || 0) !== tmpTargetSetID))
						{
							tmpItemCodes[tmpItemCode] = true;
						}
					}
					let tmpUniqueItemCodes = Object.keys(tmpItemCodes);
					if (tmpUniqueItemCodes.length === 0)
					{
						return fStageComplete();
					}

					this.log.info(`Fetching set ${tmpTargetSetID} pay items for ${tmpUniqueItemCodes.length} destination ItemCodes on another set...`);
					let tmpExtraFilter = `FBV~IDTestSpecificationSet~EQ~${tmpTargetSetID}`;
					if (tmpDestProject.IDCustomer > 0)
					{
						tmpExtraFilter += `~FBV~IDCustomer~EQ~${tmpDestProject.IDCustomer}`;
					}
					this.getEntitySetBatched('PayItem', 'ItemCode', tmpUniqueItemCodes, tmpExtraFilter,
						(pError, pPayItems) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching target-set pay items`, pError);
								return fStageComplete(pError);
							}
							for (let i = 0; i < pPayItems.length; i++)
							{
								let tmpItemCode = pPayItems[i].ItemCode;
								if (!tmpTargetPayItemsByItemCode[tmpItemCode])
								{
									tmpTargetPayItemsByItemCode[tmpItemCode] = [];
								}
								tmpTargetPayItemsByItemCode[tmpItemCode].push(pPayItems[i]);
							}
							return fStageComplete();
						});
				},

				// Stage 10: Name the specification sets involved
				(fStageComplete) =>
				{
					let tmpSetIDs = [
						tmpSourceSets.ItemIDTestSpecificationSet,
						tmpSourceSets.MaterialIDTestSpecificationSet,
						tmpDestSets.ItemIDTestSpecificationSet,
						tmpDestSets.MaterialIDTestSpecificationSet
					].concat(Object.keys(tmpDestSets.PayItemSetDistribution).map((pID) => parseInt(pID, 10)));
					this.getSpecificationSetNames(tmpSetIDs,
						(pError, pNames) =>
						{
							if (pError)
							{
								this.log.warn(`Could not fetch specification set names; IDs will be shown instead.`, pError);
							}
							tmpSetNames = pNames || {};
							return fStageComplete();
						});
				},

				// Stage 11: Build the comprehension and report data
				(fStageComplete) =>
				{
					this.log.info(`Building comprehension...`);
					this.log.info(`  Indexing source data...`);
					let tmpSourceIndex = this.indexLineItemsByItemCode(tmpSourceLineItems);
					let tmpSourceLineItemsByItemCode = tmpSourceIndex.ByItemCode;
					if (tmpSourceIndex.Warning)
					{
						this.log.warn(tmpSourceIndex.Warning);
						tmpWarnings.push(tmpSourceIndex.Warning);
					}

					let tmpSourcePLIMTsByIDLineItem = {};
					for (let i = 0; i < tmpSourcePLIMTs.length; i++)
					{
						let tmpPLIMT = tmpSourcePLIMTs[i];
						if (!tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem])
						{
							tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem] = [];
						}
						tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem].push(tmpPLIMT);
					}

					let tmpSourceMLIJsByIDLineItem = {};
					for (let i = 0; i < tmpSourceMLIJs.length; i++)
					{
						let tmpMLIJ = tmpSourceMLIJs[i];
						if (!tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem])
						{
							tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem] = [];
						}
						tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem].push(tmpMLIJ);
					}

					let tmpAlignment = this.resolveSpecificationSetAlignment(this.planSpecificationSetAlignment(
						{
							ItemIDTestSpecificationSet: tmpSourceSets.ItemIDTestSpecificationSet,
							MaterialIDTestSpecificationSet: tmpSourceSets.MaterialIDTestSpecificationSet,
							DestIDProject: pDestIDProject,
							DestContract: tmpDestContext.Contract,
							DestContractProjects: tmpDestContext.ContractProjects,
							DestLineItems: tmpDestLineItems,
							DestPayItemsByID: tmpPayItemsByID,
							TargetPayItemsByItemCode: tmpTargetPayItemsByItemCode
						}), tmpFlipTargetSpecificationSet);
					if (tmpAlignment.Crossing && tmpAlignment.Flip)
					{
						this.log.info(`  Specification set crossing: ${tmpAlignment.Contract ? 1 : 0} Contract update, ${tmpAlignment.LineItemRemaps.length} LineItem pay item remaps, ${tmpAlignment.Unmapped.length} unmapped, ${tmpAlignment.AlreadyAlignedCount} already aligned.`);
					}
					else if (tmpAlignment.Crossing)
					{
						tmpAlignment.Warnings.push(`The source is on specification set ${tmpSourceSets.ItemIDTestSpecificationSet} and the destination on ${tmpDestSets.ItemIDTestSpecificationSet || 'none'}. The destination keeps its specification sets and line item pay items; sample plan tests are copied onto its line items by item code.`);
					}
					for (let i = 0; i < tmpAlignment.Warnings.length; i++)
					{
						this.log.warn(tmpAlignment.Warnings[i]);
						tmpWarnings.push(tmpAlignment.Warnings[i]);
					}

					let tmpComprehension = Object.assign(this.buildSpecificationSetRealignmentRecords(tmpAlignment),
						{
							ProjectLineItemMaterialTest: {},
							MaterialLineItemJoin: {}
						});

					let tmpMatchedCount = 0;
					let tmpUnmatchedCount = 0;
					let tmpPLIMTRowCount = 0;
					let tmpMLIJCount = 0;
					let tmpSeenMLIJKeys = {};
					let tmpUsedSourceLineItemIDs = {};
					let tmpReportLineItems = [];

					this.log.info(`  Indexed ${Object.keys(tmpSourceLineItemsByItemCode).length} source ItemCodes, ${Object.keys(tmpSourcePLIMTsByIDLineItem).length} PLIMT groups, ${Object.keys(tmpSourceMLIJsByIDLineItem).length} MLJ groups.`);
					this.log.info(`Processing ${tmpDestLineItems.length} destination line items...`);

					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						let tmpDestLI = tmpDestLineItems[i];
						let tmpSourceLI = tmpSourceLineItemsByItemCode[tmpDestLI.ItemCode];

						if (!tmpSourceLI)
						{
							tmpUnmatchedCount++;
							tmpReportLineItems.push({
								itemCode: tmpDestLI.ItemCode || '',
								name: tmpDestLI.Name || '',
								units: tmpDestLI.Units || '',
								contractQuantity: tmpDestLI.ContractQuantity || 0,
								matched: false,
								plimtCount: 0,
								mljCount: 0,
								tests: []
							});
							continue;
						}

						tmpMatchedCount++;
						tmpUsedSourceLineItemIDs[tmpSourceLI.IDLineItem] = true;
						let tmpSourcePLIMTsForLI = tmpSourcePLIMTsByIDLineItem[tmpSourceLI.IDLineItem] || [];
						let tmpSourceMLIJsForLI = tmpSourceMLIJsByIDLineItem[tmpSourceLI.IDLineItem] || [];
						this.log.info(`  [${tmpMatchedCount}] ${tmpDestLI.ItemCode} (IDLineItem ${tmpDestLI.IDLineItem}) -> ${tmpSourcePLIMTsForLI.length} PLIMTs, ${tmpSourceMLIJsForLI.length} MLIJs`);

						let tmpTestDetails = [];

						// Copy PLIMTs for this line item
						for (let j = 0; j < tmpSourcePLIMTsForLI.length; j++)
						{
							let tmpSrc = tmpSourcePLIMTsForLI[j];
							let tmpCompositeKey = `${pDestIDProject}|${tmpDestLI.IDLineItem}|${tmpSrc.IDMaterial}|${tmpSrc.IDTest}|${tmpSrc.SampleType}`;
							let tmpGUID = this.generateGUID('MSP-PLIMT', tmpCompositeKey);

							tmpComprehension.ProjectLineItemMaterialTest[tmpGUID] = {
								GUIDProjectLineItemMaterialTest: tmpGUID,
								IDProject: pDestIDProject,
								IDLineItem: tmpDestLI.IDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								IDTest: tmpSrc.IDTest,
								IDLab: tmpSrc.IDLab || 0,
								Intent: tmpSrc.Intent || '',
								SampleType: tmpSrc.SampleType || '',
								SampleSize: tmpSrc.SampleSize || 0,
								SampleUnits: tmpSrc.SampleUnits || '',
								Rate: tmpSrc.Rate || 0,
								Frequency: tmpSrc.Frequency || 0,
								Units: tmpSrc.Units || '',
								TestDescription: tmpSrc.TestDescription || '',
								SampleDescription: tmpSrc.SampleDescription || '',
								SamplingInstructions: tmpSrc.SamplingInstructions || '',
								SamplingRequirements: tmpSrc.SamplingRequirements || '',
								SamplingPeriod: tmpSrc.SamplingPeriod || '',
								Remarks: tmpSrc.Remarks || '',
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								CertificateRequired: tmpSrc.CertificateRequired || 0,
								TestsNotRequired: tmpSrc.TestsNotRequired || 0,
								ErrorOmission: tmpSrc.ErrorOmission || 0,
								ErrorOmissionDetail: tmpSrc.ErrorOmissionDetail || '',
								ManualPlannedSampleCount: -1,
								ManualRequiredSampleCount: -1,
								ComputedPlannedSampleCount: 0,
								ComputedRequiredSampleCount: 0,
								CreatedSampleCount: 0,
								PassingSampleCount: 0,
								FailingSampleCount: 0,
								Deleted: 0
							};
							tmpPLIMTRowCount++;

							tmpTestDetails.push({
								testDescription: tmpSrc.TestDescription || '',
								sampleType: tmpSrc.SampleType || '',
								intent: tmpSrc.Intent || '',
								rate: tmpSrc.Rate || 0,
								frequency: tmpSrc.Frequency || 0,
								units: tmpSrc.Units || '',
								sampleSize: tmpSrc.SampleSize || 0,
								sampleUnits: tmpSrc.SampleUnits || '',
								remarks: tmpSrc.Remarks || ''
							});
						}

						// Copy MLIJs for this line item (deduplicate)
						let tmpLIMljCount = 0;
						for (let j = 0; j < tmpSourceMLIJsForLI.length; j++)
						{
							let tmpSrc = tmpSourceMLIJsForLI[j];
							let tmpMLIJKey = `${tmpDestLI.IDLineItem}|${tmpSrc.IDMaterial}`;

							if (tmpSeenMLIJKeys[tmpMLIJKey]) continue;
							tmpSeenMLIJKeys[tmpMLIJKey] = true;

							let tmpGUID = this.generateGUID('MSP-MLJ', tmpMLIJKey);

							tmpComprehension.MaterialLineItemJoin[tmpGUID] = {
								GUIDMaterialLineItemJoin: tmpGUID,
								IDLineItem: tmpDestLI.IDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								ApprovedSourceRequired: tmpSrc.ApprovedSourceRequired || 0,
								SpecialInstructions: tmpSrc.SpecialInstructions || '',
								Units: tmpSrc.Units || '',
								SampleRate: tmpSrc.SampleRate || 0,
								SampleFrequency: tmpSrc.SampleFrequency || 0,
								RequiredSampleCount: tmpSrc.RequiredSampleCount || 0,
								Quantity: tmpSrc.Quantity || 0,
								Deleted: 0
							};
							tmpMLIJCount++;
							tmpLIMljCount++;
						}

						tmpReportLineItems.push({
							itemCode: tmpDestLI.ItemCode || '',
							name: tmpDestLI.Name || '',
							units: tmpDestLI.Units || '',
							contractQuantity: tmpDestLI.ContractQuantity || 0,
							matched: true,
							plimtCount: tmpSourcePLIMTsForLI.length,
							mljCount: tmpLIMljCount,
							tests: tmpTestDetails
						});
					}

					let tmpPLIMTCount = Object.keys(tmpComprehension.ProjectLineItemMaterialTest).length;
					let tmpMappedSourcePLIMTCount = 0;
					for (let i = 0; i < tmpSourcePLIMTs.length; i++)
					{
						if (tmpUsedSourceLineItemIDs[tmpSourcePLIMTs[i].IDLineItem])
						{
							tmpMappedSourcePLIMTCount++;
						}
					}
					let tmpUnmappedSourcePLIMTCount = Math.max(0, tmpSourcePLIMTTotal - tmpMappedSourcePLIMTCount);
					let tmpCollapsedPLIMTCount = tmpPLIMTRowCount - tmpPLIMTCount;

					this.log.info(`=== Comprehension Built ===`);
					this.log.info(`  Source Line Items: ${tmpSourceLineItems.length}`);
					this.log.info(`  Destination Line Items: ${tmpDestLineItems.length}`);
					this.log.info(`  Matched Line Items: ${tmpMatchedCount}`);
					this.log.info(`  Unmatched Destination Line Items: ${tmpUnmatchedCount}`);
					this.log.info(`  Source ProjectLineItemMaterialTests: ${tmpSourcePLIMTTotal} (${tmpMappedSourcePLIMTCount} on matched line items, ${tmpUnmappedSourcePLIMTCount} unmapped)`);
					this.log.info(`  ProjectLineItemMaterialTest Records: ${tmpPLIMTCount}`);
					this.log.info(`  MaterialLineItemJoin Records: ${tmpMLIJCount}`);

					if (tmpUnmatchedCount > 0)
					{
						let tmpMsg = `${tmpUnmatchedCount} destination line items have no line item with the same item code in the source project.`;
						this.log.warn(tmpMsg);
						tmpWarnings.push(tmpMsg);
					}
					if (tmpUnmappedSourcePLIMTCount > 0)
					{
						let tmpMsg = `${tmpUnmappedSourcePLIMTCount} of the source's ${tmpSourcePLIMTTotal} sample plan tests are on line items whose item code the destination does not have (or repeats of an item code), so they are not copied.`;
						this.log.warn(tmpMsg);
						tmpWarnings.push(tmpMsg);
					}
					if (tmpCollapsedPLIMTCount > 0)
					{
						let tmpMsg = `${tmpCollapsedPLIMTCount} source sample plan tests repeat the same material, test and sample type on one line item, so each repeat is copied once.`;
						this.log.warn(tmpMsg);
						tmpWarnings.push(tmpMsg);
					}

					let tmpReportData = {
						sourceProject: tmpSourceProject,
						destProject: tmpDestProject,
						generatedDate: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }),
						stats: {
							sourceLineItemCount: tmpSourceLineItemCount,
							destLineItemCount: tmpDestLineItems.length,
							matched: tmpMatchedCount,
							unmatched: tmpUnmatchedCount,
							plimtCount: tmpPLIMTCount,
							mljCount: tmpMLIJCount,
							sourcePlimtCount: tmpSourcePLIMTTotal,
							mappedSourcePlimtCount: tmpMappedSourcePLIMTCount,
							unmappedSourcePlimtCount: tmpUnmappedSourcePLIMTCount,
							collapsedPlimtCount: tmpCollapsedPLIMTCount,
							destExistingPlimtCount: tmpDestExistingPLIMTCount,
							destExistingMljCount: tmpDestExistingMLIJCount,
							contractUpdateCount: tmpAlignment.Contract ? 1 : 0,
							lineItemRemapCount: tmpAlignment.LineItemRemaps.length,
							lineItemUnmappedCount: tmpAlignment.Unmapped.length
						},
						options: { FlipTargetSpecificationSet: tmpFlipTargetSpecificationSet },
						lineItems: tmpReportLineItems,
						specificationSets: {
							Source: tmpSourceSets,
							Dest: tmpDestSets,
							Names: tmpSetNames,
							Alignment: tmpAlignment
						}
					};

					return fStageComplete(null, { comprehension: tmpComprehension, reportData: tmpReportData, warnings: tmpWarnings });
				}
			],
			(pError, pResult) =>
			{
				if (pError)
				{
					this.log.error(`Sample plan comprehension build failed.`, pError);
				}
				return fCallback(pError, pResult);
			});
	}

	/**
	 * Look up a Project record by GUIDProject. Returns null (not an error) when not found,
	 * so the caller can use "missing" as a natural skip case.
	 *
	 * @param {string} pGUIDProject - The GUID to look up.
	 * @param {Function} fCallback - Callback: (error, project or null).
	 */
	lookupProjectByGUID(pGUIDProject, fCallback)
	{
		if (!pGUIDProject)
		{
			return fCallback(null, null);
		}
		let tmpFilter = `FBV~GUIDProject~EQ~${encodeURIComponent(pGUIDProject)}`;
		this.restClient.getEntitySet('Project', tmpFilter,
			(pError, pRecords) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				if (!pRecords || pRecords.length === 0)
				{
					return fCallback(null, null);
				}
				return fCallback(null, pRecords[0]);
			}, 0, 1);
	}

	/**
	 * Sibling of `buildComprehension` for the case where the destination project (and its
	 * LineItems) does NOT yet exist on the server — typically because it's about to be
	 * created in the same comprehension push the caller is assembling.
	 *
	 * Differences from `buildComprehension`:
	 *   - Source project is looked up by `GUIDProject` instead of an integer `IDProject`.
	 *   - Destination LineItems are passed in directly rather than fetched via REST.
	 *   - Output PLIMT / MLJ records use `GUIDProject` / `GUIDLineItem` FK refs (not integer IDs)
	 *     so the integration adapter resolves them at push time against the same comprehension.
	 *
	 * Returns `null` for `result` when the source GUID does not resolve, so callers can use
	 * "no master sample plan for this year, skip" as a natural pattern.
	 *
	 * @param {object} pOptions
	 * @param {string} pOptions.SourceGUIDProject - GUID of the source / master sample plan project (e.g. `HLICLI-P-L26-ProtoMSP`).
	 * @param {string} pOptions.DestGUIDProject - GUID of the destination project (used as the FK ref in output records).
	 * @param {Array<{GUIDLineItem: string, ItemCode: string}>} pOptions.DestLineItems - Destination line items from the in-flight comprehension. Each must carry at least `GUIDLineItem` and `ItemCode`.
	 * @param {string} [pOptions.GUIDPrefixPLIMT] - Prefix for generated PLIMT GUIDs. Defaults to `MSP-PLIMT`.
	 * @param {string} [pOptions.GUIDPrefixMLJ] - Prefix for generated MLJ GUIDs. Defaults to `MSP-MLJ`.
	 * @param {Function} fCallback - Callback: (error, result) where result is { comprehension, reportData, warnings } or null when the source project is not found.
	 */
	buildComprehensionFromLineItems(pOptions, fCallback)
	{
		let tmpOptions = pOptions || {};
		let tmpSourceGUIDProject = tmpOptions.SourceGUIDProject;
		let tmpDestGUIDProject = tmpOptions.DestGUIDProject;
		let tmpDestLineItems = Array.isArray(tmpOptions.DestLineItems) ? tmpOptions.DestLineItems : [];
		let tmpGUIDPrefixPLIMT = tmpOptions.GUIDPrefixPLIMT || 'MSP-PLIMT';
		let tmpGUIDPrefixMLJ = tmpOptions.GUIDPrefixMLJ || 'MSP-MLJ';

		if (!tmpSourceGUIDProject)
		{
			return fCallback(new Error('SourceGUIDProject is required.'));
		}
		if (!tmpDestGUIDProject)
		{
			return fCallback(new Error('DestGUIDProject is required.'));
		}

		let tmpSourceProject = null;
		let tmpSourceSets = null;
		let tmpSourceLineItems = [];
		let tmpSourceLineItemCount = 0;
		let tmpSourcePLIMTs = [];
		let tmpSourceMLIJs = [];
		let tmpWarnings = [];

		this.log.info(`Sample Plan Comprehension (in-flight dest) Builder`);
		this.log.info(`  Source GUIDProject:    ${tmpSourceGUIDProject}`);
		this.log.info(`  Dest GUIDProject:      ${tmpDestGUIDProject}`);
		this.log.info(`  Dest LineItems given:  ${tmpDestLineItems.length}`);

		this.fable.Utility.waterfall(
			[
				// Stage 1: Look up source project by GUID. Missing source = silent skip.
				(fStageComplete) =>
				{
					this.lookupProjectByGUID(tmpSourceGUIDProject,
						(pError, pRecord) =>
						{
							if (pError)
							{
								this.log.error(`Error looking up source project by GUID`, pError);
								return fStageComplete(pError);
							}
							if (!pRecord)
							{
								this.log.info(`  Source project [${tmpSourceGUIDProject}] not found — skipping sample plan section.`);
								return fStageComplete('SKIP');
							}
							tmpSourceProject = pRecord;
							this.log.info(`  Source resolved:       [${tmpSourceProject.IDProject}] ${tmpSourceProject.Name || '(unnamed)'}`);
							return fStageComplete();
						});
				},

				// Stage 2: Count source line items (stats only).
				(fStageComplete) =>
				{
					this.restClient.getEntitySetCount('LineItem',
						`FBV~IDProject~EQ~${tmpSourceProject.IDProject}~FBV~Deleted~EQ~0`,
						(pError, pResult) =>
						{
							if (pError)
							{
								this.log.error(`Error counting source line items`, pError);
								return fStageComplete(pError);
							}
							tmpSourceLineItemCount = (pResult && pResult.Count) ? pResult.Count : 0;
							this.log.info(`  Source project has ${tmpSourceLineItemCount} total line items.`);
							return fStageComplete();
						});
				},

				// Stage 3: Fetch matching source line items by ItemCode (only those that match dest).
				(fStageComplete) =>
				{
					let tmpDestItemCodes = {};
					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						if (tmpDestLineItems[i].ItemCode)
						{
							tmpDestItemCodes[tmpDestLineItems[i].ItemCode] = true;
						}
					}
					let tmpUniqueItemCodes = Object.keys(tmpDestItemCodes);
					this.log.info(`  Destination has ${tmpUniqueItemCodes.length} unique ItemCodes.`);

					if (tmpUniqueItemCodes.length === 0)
					{
						this.log.warn(`  No ItemCodes found in destination — nothing to match.`);
						return fStageComplete();
					}

					this.getEntitySetBatched('LineItem', 'ItemCode', tmpUniqueItemCodes,
						`FBV~IDProject~EQ~${tmpSourceProject.IDProject}`,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source line items`, pError);
							}
							else
							{
								tmpSourceLineItems = pRecords;
								this.log.info(`  Found ${tmpSourceLineItems.length} matching source line items.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 4: Fetch source PLIMTs.
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);
					if (tmpSourceLineItemIDs.length === 0) return fStageComplete();

					this.getEntitySetBatched('ProjectLineItemMaterialTest', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source PLIMTs`, pError);
							}
							else
							{
								tmpSourcePLIMTs = pRecords;
								this.log.info(`  Found ${tmpSourcePLIMTs.length} source ProjectLineItemMaterialTests.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 5: Fetch source MaterialLineItemJoins.
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);
					if (tmpSourceLineItemIDs.length === 0) return fStageComplete();

					this.getEntitySetBatched('MaterialLineItemJoin', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source MLIJs`, pError);
							}
							else
							{
								tmpSourceMLIJs = pRecords;
								this.log.info(`  Found ${tmpSourceMLIJs.length} source MaterialLineItemJoins.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 6: Resolve the source's specification sets so the caller can check them against its contract.
				(fStageComplete) =>
				{
					this.getProjectContext(tmpSourceProject.IDProject,
						(pContextError, pContext) =>
						{
							if (pContextError)
							{
								this.log.warn(`Could not read the source project's contract; its specification sets are unknown.`, pContextError);
								return fStageComplete();
							}
							this.resolveProjectSpecificationSets(pContext, SPECIFICATION_SET_LINE_ITEM_SAMPLE,
								(pSetsError, pSets) =>
								{
									if (pSetsError)
									{
										this.log.warn(`Could not read the source project's line item pay items; its specification sets are unknown.`, pSetsError);
										return fStageComplete();
									}
									tmpSourceSets = pSets;
									return fStageComplete();
								});
						});
				},

				// Stage 7: Build the comprehension. Uses GUID refs (not IDs) for the dest FKs.
				(fStageComplete) =>
				{
					let tmpSourceIndex = this.indexLineItemsByItemCode(tmpSourceLineItems);
					let tmpSourceLineItemsByItemCode = tmpSourceIndex.ByItemCode;
					if (tmpSourceIndex.Warning)
					{
						this.log.warn(tmpSourceIndex.Warning);
						tmpWarnings.push(tmpSourceIndex.Warning);
					}

					let tmpSourcePLIMTsByIDLineItem = {};
					for (let i = 0; i < tmpSourcePLIMTs.length; i++)
					{
						let tmpPLIMT = tmpSourcePLIMTs[i];
						if (!tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem])
						{
							tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem] = [];
						}
						tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem].push(tmpPLIMT);
					}

					let tmpSourceMLIJsByIDLineItem = {};
					for (let i = 0; i < tmpSourceMLIJs.length; i++)
					{
						let tmpMLIJ = tmpSourceMLIJs[i];
						if (!tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem])
						{
							tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem] = [];
						}
						tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem].push(tmpMLIJ);
					}

					let tmpComprehension = {
						ProjectLineItemMaterialTest: {},
						MaterialLineItemJoin: {}
					};

					let tmpMatchedCount = 0;
					let tmpUnmatchedCount = 0;
					let tmpPLIMTCount = 0;
					let tmpMLIJCount = 0;
					let tmpSeenMLIJKeys = {};

					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						let tmpDestLI = tmpDestLineItems[i];
						let tmpSourceLI = tmpSourceLineItemsByItemCode[tmpDestLI.ItemCode];

						if (!tmpSourceLI)
						{
							tmpUnmatchedCount++;
							continue;
						}

						tmpMatchedCount++;
						let tmpSourcePLIMTsForLI = tmpSourcePLIMTsByIDLineItem[tmpSourceLI.IDLineItem] || [];
						let tmpSourceMLIJsForLI = tmpSourceMLIJsByIDLineItem[tmpSourceLI.IDLineItem] || [];

						for (let j = 0; j < tmpSourcePLIMTsForLI.length; j++)
						{
							let tmpSrc = tmpSourcePLIMTsForLI[j];
							let tmpCompositeKey = `${tmpDestGUIDProject}|${tmpDestLI.GUIDLineItem}|${tmpSrc.IDMaterial}|${tmpSrc.IDTest}|${tmpSrc.SampleType}`;
							let tmpGUID = this.generateGUID(tmpGUIDPrefixPLIMT, tmpCompositeKey);

							tmpComprehension.ProjectLineItemMaterialTest[tmpGUID] = {
								GUIDProjectLineItemMaterialTest: tmpGUID,
								GUIDProject: tmpDestGUIDProject,
								GUIDLineItem: tmpDestLI.GUIDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								IDTest: tmpSrc.IDTest,
								IDLab: tmpSrc.IDLab || 0,
								Intent: tmpSrc.Intent || '',
								SampleType: tmpSrc.SampleType || '',
								SampleSize: tmpSrc.SampleSize || 0,
								SampleUnits: tmpSrc.SampleUnits || '',
								Rate: tmpSrc.Rate || 0,
								Frequency: tmpSrc.Frequency || 0,
								Units: tmpSrc.Units || '',
								TestDescription: tmpSrc.TestDescription || '',
								SampleDescription: tmpSrc.SampleDescription || '',
								SamplingInstructions: tmpSrc.SamplingInstructions || '',
								SamplingRequirements: tmpSrc.SamplingRequirements || '',
								SamplingPeriod: tmpSrc.SamplingPeriod || '',
								Remarks: tmpSrc.Remarks || '',
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								CertificateRequired: tmpSrc.CertificateRequired || 0,
								TestsNotRequired: tmpSrc.TestsNotRequired || 0,
								ErrorOmission: tmpSrc.ErrorOmission || 0,
								ErrorOmissionDetail: tmpSrc.ErrorOmissionDetail || '',
								ManualPlannedSampleCount: -1,
								ManualRequiredSampleCount: -1,
								ComputedPlannedSampleCount: 0,
								ComputedRequiredSampleCount: 0,
								CreatedSampleCount: 0,
								PassingSampleCount: 0,
								FailingSampleCount: 0,
								Deleted: 0
							};
							tmpPLIMTCount++;
						}

						for (let j = 0; j < tmpSourceMLIJsForLI.length; j++)
						{
							let tmpSrc = tmpSourceMLIJsForLI[j];
							let tmpMLIJKey = `${tmpDestLI.GUIDLineItem}|${tmpSrc.IDMaterial}`;

							if (tmpSeenMLIJKeys[tmpMLIJKey]) continue;
							tmpSeenMLIJKeys[tmpMLIJKey] = true;

							let tmpGUID = this.generateGUID(tmpGUIDPrefixMLJ, tmpMLIJKey);

							tmpComprehension.MaterialLineItemJoin[tmpGUID] = {
								GUIDMaterialLineItemJoin: tmpGUID,
								GUIDLineItem: tmpDestLI.GUIDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								ApprovedSourceRequired: tmpSrc.ApprovedSourceRequired || 0,
								SpecialInstructions: tmpSrc.SpecialInstructions || '',
								Units: tmpSrc.Units || '',
								SampleRate: tmpSrc.SampleRate || 0,
								SampleFrequency: tmpSrc.SampleFrequency || 0,
								RequiredSampleCount: tmpSrc.RequiredSampleCount || 0,
								Quantity: tmpSrc.Quantity || 0,
								Deleted: 0
							};
							tmpMLIJCount++;
						}
					}

					this.log.info(`=== Comprehension (in-flight dest) Built ===`);
					this.log.info(`  Matched / Unmatched dest LineItems: ${tmpMatchedCount} / ${tmpUnmatchedCount}`);
					this.log.info(`  PLIMT: ${tmpPLIMTCount}, MLJ: ${tmpMLIJCount}`);

					if (tmpUnmatchedCount > 0)
					{
						tmpWarnings.push(`${tmpUnmatchedCount} destination line items have no line item with the same item code in source [${tmpSourceGUIDProject}].`);
					}

					let tmpReportData = {
						sourceProject: tmpSourceProject,
						destGUIDProject: tmpDestGUIDProject,
						specificationSets: { Source: tmpSourceSets },
						stats: {
							sourceLineItemCount: tmpSourceLineItemCount,
							destLineItemCount: tmpDestLineItems.length,
							matched: tmpMatchedCount,
							unmatched: tmpUnmatchedCount,
							plimtCount: tmpPLIMTCount,
							mljCount: tmpMLIJCount
						}
					};

					return fStageComplete(null, { comprehension: tmpComprehension, reportData: tmpReportData, warnings: tmpWarnings });
				}
			],
			(pError, pResult) =>
			{
				// Sentinel "SKIP" means the source project didn't exist — surface null result, not an error.
				if (pError === 'SKIP')
				{
					return fCallback(null, null);
				}
				if (pError)
				{
					this.log.error(`Sample plan (in-flight dest) comprehension build failed.`, pError);
				}
				return fCallback(pError, pResult);
			});
	}

	/**
	 * @typedef {object} SamplePlanEntityLoadResult
	 * @property {string} Entity - The Meadow entity.
	 * @property {number} Sent - Records in the comprehension.
	 * @property {number} Succeeded - Records the server accepted.
	 * @property {number} Failed - Records that failed to marshal or were refused by the server.
	 * @property {string} Status - 'Loaded', 'Errors', or 'Not attempted' when an earlier entity failed.
	 */

	/**
	 * Load a sample plan comprehension into the destination project via the Headlight Integration
	 * Adapter (batch upserts with retry). Entities load in order -- Contract, LineItem,
	 * ProjectLineItemMaterialTest, MaterialLineItemJoin -- and a failed entity stops the ones after it.
	 *
	 * @param {Record<string, Record<string, any>>} pComprehension - Output of `buildComprehension` or `buildComprehensionFromLineItems`.
	 * @param {(pError?: any, pResult?: {entities: Array<SamplePlanEntityLoadResult>}) => void} fCallback - Callback.
	 */
	loadComprehension(pComprehension, fCallback)
	{
		let tmpEntityPlan = [
			{ Entity: 'Contract' },
			{ Entity: 'LineItem' },
			{ Entity: 'ProjectLineItemMaterialTest', EntityGUIDMarshalPrefix: 'MSP-PLIMT' },
			{ Entity: 'MaterialLineItemJoin', EntityGUIDMarshalPrefix: 'MSP-MLJ' }
		];

		// Register the IntegrationAdapter service type if not already registered
		if (!this.fable.servicesMap.IntegrationAdapter)
		{
			this.fable.addServiceType('IntegrationAdapter', libIntegrationAdapter);
		}

		let tmpAdapterOptions = {
			ForceMarshal: true,
			PerformDeletes: false,
			AllowGUIDTruncation: true,
		};

		let tmpResults = [];
		let tmpStages = [];
		for (let i = 0; i < tmpEntityPlan.length; i++)
		{
			let tmpPlan = tmpEntityPlan[i];
			let tmpRecords = pComprehension[tmpPlan.Entity] || {};
			let tmpKeys = Object.keys(tmpRecords);
			if (tmpKeys.length === 0)
			{
				continue;
			}

			let tmpResult = { Entity: tmpPlan.Entity, Sent: tmpKeys.length, Succeeded: 0, Failed: 0, Status: 'Not attempted' };
			tmpResults.push(tmpResult);
			tmpStages.push(
				(fStageComplete) =>
				{
					// Create fresh adapter instances each load (not cached via getAdapter)
					// so that source/marshaled record buffers are clean between runs.
					let tmpAdapter = this.fable.instantiateServiceProviderWithoutRegistration('IntegrationAdapter', Object.assign({}, tmpAdapterOptions, tmpPlan));
					for (let j = 0; j < tmpKeys.length; j++)
					{
						tmpAdapter.addSourceRecord(tmpRecords[tmpKeys[j]]);
					}

					this.log.info(`Integrating ${tmpKeys.length} ${tmpPlan.Entity} records...`);
					tmpAdapter.integrateRecords(
						(pError) =>
						{
							let tmpLanded = Object.keys(tmpAdapter._MarshaledRecords).length - tmpAdapter.RecordPushFailures.length;
							tmpResult.Succeeded = Math.max(0, tmpLanded);
							tmpResult.Failed = tmpResult.Sent - tmpResult.Succeeded;
							tmpResult.Status = (pError || (tmpResult.Failed > 0)) ? 'Errors' : 'Loaded';
							if (pError)
							{
								this.log.error(`Error integrating ${tmpPlan.Entity} records`, pError);
							}
							return fStageComplete(pError);
						});
				});
		}

		this.log.info(`Loading comprehension via Integration Adapter: ${tmpResults.map((pResult) => `${pResult.Sent} ${pResult.Entity}`).join(', ')}`);
		if (tmpStages.length === 0)
		{
			return fCallback(null, { entities: tmpResults });
		}

		this.fable.Utility.waterfall(tmpStages,
			(pError) =>
			{
				this.log.info(`=== Comprehension Load Complete ===`);
				for (let i = 0; i < tmpResults.length; i++)
				{
					this.log.info(`  ${tmpResults[i].Entity}: ${tmpResults[i].Succeeded} of ${tmpResults[i].Sent} succeeded, ${tmpResults[i].Failed} failed (${tmpResults[i].Status})`);
				}
				return fCallback(pError, { entities: tmpResults });
			});
	}
}

module.exports = SamplePlanService;

module.exports.default_configuration = {
	Name: 'SamplePlanService'
};

module.exports.INN_VALUE_CHARACTER_BUDGET = INN_VALUE_CHARACTER_BUDGET;

},{"crypto":353,"fable-serviceproviderbase":398,"headlight-integration-adapter":7}],11:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const dayJS = require('dayjs');
/**
 * Headlight LegacyQRCodeGenerator fable service
 */
class HeadlightQRCodeHash extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance
	 * @param {any} [pOptions] - The options for the service
	 * @param {any} [pServiceHash] - The hash for the service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadlightQRCodeHash';

		this.generatedGUIDs = [];
	}

	/**
	* A generic method to generate a GUID (unique id) string value out of alphanumeric
	* characters. The default length is 10 characters long but can be customized.
	* @param {number} [prefix] - an optional prefix, used to make the scope more clear
	* @param {number} [length] - the number of characters in the return string
	* @return {string} - a generated id string
	*/
	// TODO: Should we replace this with a Pict/Fable method that does the same thing but better? Unsure if it exists, but probably does.
	_generateGUID(prefix, length)
	{
		const alphanumericString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		// use a custom length?
		length = length ? length : 10;
		// make a string id of random characters
		let guid = '';
		for (let i = 0; i < length; i++)
		{
			guid += alphanumericString.charAt(Math.floor(Math.random() * alphanumericString.length));
		}
		// if we have an optional prefix, set that now
		guid = prefix ? prefix + guid : guid;
		return guid;
	};

	/**
	 * Generates QR Codes in the "new" format, takes a project id and user id.
	 * @param {Number} projectId 
	 * @param {Number} userId 
	 * @returns {String}
	 */
	_generateHLQRCode(projectId, userId) {
		let guid = null, attempts = 0;
		do {
			attempts++;
	
			if(attempts > 100) {
				console.error('Failed to generate unique guid. Too many attempts. Returning random string.');
				break;
			}
	
			// simple left pad
			const lpad = (v, len, char = '') => {
				let r = String(v);
				while(r.length < len) r = char + r;
				return r;
			}
	
			let calendarDayMap = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V'];
			let date = new Date();
			let year = lpad(date.getFullYear() % 100, 2, '0');
			let month = calendarDayMap[date.getMonth()+1];
			let day = calendarDayMap[date.getDate()];
			let hour = lpad(date.getHours() % 12, 2, '0');
			let min = lpad(date.getMinutes(), 2, '0');
			let sec = lpad(date.getSeconds(), 2, '0');
			let ms = lpad(date.getMilliseconds().toString(36), 2, '0');
	
			const projectCode = projectId ? parseInt(projectId).toString(36) : '0';
	
			const userCode = userId ? parseInt(userId).toString(36) : '0';
	
			// what we want for this pattern
			guid = `${projectCode.toUpperCase()}-${userCode.toUpperCase()}-${year}${month}${day}${hour}${min}${sec}${ms}`;
		} while(this.generatedGUIDs.includes(guid));
	
		this.generatedGUIDs.push(guid);
	
		return guid;
	}
	
	/**
	* This method is used to generate a QR code string for a given GUID in the legacy "date/hash" format. (LADOTD, SiteManager, etc)
	*
	* QR code should contain the User ID as well as the Date, to aid in finding Samples via the SiteManager user interface
	* This is what needs to happen:
	* QRCode: CMS_UID + year (2 chars) + month (1 char) + date (1 char) + hour - min - sec (6 chars)
	* where CMS_UID = user
	* and date = a letter
	* So, e.g. my sample id is 0x591745201D11585798 (0x59174598.20.1.D.11.58.57)
	* my user = 0x59174598
	* year = 20
	* month = 1
	* day = D (A- 10th, B - 11th, C - 12th, D - 13th)
	* hour-min-sec = 115857
	* @param {string} tmpGUIDString - The GUID to generate the QR code for
	* @return {string} - The QR code string
	*/
	_generateLegacyGUID(tmpGUIDString)
	{
		tmpGUIDString = tmpGUIDString ? tmpGUIDString : '';
		// there's a limit to the length of the QR code, so we need to truncate the GUID at 10 characters
		if (tmpGUIDString.length > 10)
		{
			tmpGUIDString = tmpGUIDString.substring(0, 10);
		}
		const calendarDayMap = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V' ];
		const time = new Date().toISOString();
		// Match the materials app's SiteManager generator (generateDateID): format the components in the
		// PROJECT timezone and on a 12-hour clock ('hh'). In forms the fable Dates service is configured with
		// the project TZ (with fallback), so formatDate applies it; only off-form does this fall back to the
		// bare dayjs (runtime-local).
		const tmpFormat = (pFormat) => (this.fable && this.fable.Dates && typeof this.fable.Dates.formatDate === 'function') ? (this.fable.Dates.formatDate(time, pFormat) || '') : dayJS(time).format(pFormat);
		const year = tmpFormat('YY');
		const hour = tmpFormat('hh');
		const min = tmpFormat('mm');
		const sec = tmpFormat('ss');
		let month = tmpFormat('M');
		// use the day as an index for calendarDayMap above
		let day = tmpFormat('D');
		month = calendarDayMap[month];
		day = calendarDayMap[day];
		// what we want for this pattern
		return tmpGUIDString + year + month + day + hour + min + sec;
	}

	/**
	 * This handles the generation of the QR code hash string based on the options passed in
	 * @param {object} [pOptions] - The options for the hash generation
	 * @return {string} - The hash string
	 */
	generateQRCodeHash(pOptions)
	{
		if (pOptions && typeof pOptions !== 'object')
		{
			throw new Error('generateQRCodeHash() was expecting an object of options, but received a non-object value.');
		}
		pOptions = pOptions || {};
		// generate a LegacyFormat QR code hash if the option is set
		if (pOptions.LegacyFormat && pOptions.GUIDPrefix)
		{
			return this._generateLegacyGUID(pOptions.GUIDPrefix);
		}
		if (pOptions.LegacyFormat && !pOptions.GUIDPrefix)
		{
			throw new Error('generateQRCodeHash() was expecting a GUIDPrefix value for the LegacyFormat option, but received none.');
		}
		return this._generateHLQRCode(pOptions.IDProject, pOptions.IDUser);
		
	}
}

module.exports = HeadlightQRCodeHash;

},{"dayjs":354,"fable-serviceproviderbase":398}],12:[function(require,module,exports){
const FableServiceProviderBase = require('fable-serviceproviderbase');

const defaultHeadLightRestClientOptions = (
	{
		DownloadBatchSize: 100,

		ServerURL: 'https://api.qa.headlight.com/1.0/',
		UserID: 'DEFAULT',
		Password: false,

		// When a request comes back 401 on a session this client logged in itself (authenticate() with its own
		// UserID / Password), log in again and replay the request once. Sessions handed in (setSessionData) or
		// impersonated are never re-established: that would run the caller's request as a different user.
		AutoReauthenticate: true,
		// Before logging in again, ask CheckSession whether the session really expired; a 401 on a live session
		// (e.g. passed through from a downstream service) is returned as is.
		ReauthenticateVerifySession: true,
		// fable RestClient retry policy for the login request itself: transient failures only (502/503/504,
		// timeouts, dropped connections). A refused login is never retried. `false` disables.
		AuthenticateRetry: { MaxAttempts: 3 },
		// A failed authenticate() leaves the session the client already has in place, rather than clearing it.
		KeepSessionOnFailedAuthenticate: true
	});

//NOTE: copied from @paviasystems/service_pieces/HeadLightAPI
/**
 * @typedef {Object} SessionInfo
 * @description Shape of the session object stored in memcache, and returned from CheckSession.
 *
 * @property {string} SessionID - The session ID.
 * @property {boolean} LoggedIn - True if the user is logged in.
 * @property {string} UserRole - The human readable role of the user.
 * @property {number} UserRoleIndex - The user's (0-5) level.
 * @property {number} UserID - The IDUser (database ID) of the user.
 * @property {number} CustomerID - The IDCustomer (database ID) of the customer.
 * @property {string} Title - The title of the user.
 * @property {string} NameFirst - The first name of the user.
 * @property {string} NameLast - The last name of the user.
 * @property {string} Email - The email of the user.
 * @property {string} LoginID - The login ID of the user.
 * @property {string} UIHash - The UI hash of the user. (not sure what this is for)
 * @property {string} Timezone - The timezone of the user.
 * @property {object} Settings - The user's settings.
 * @property {string} LastSessionID - The user's last session ID.
 * @property {string} LastLoginTime - The time of the user's last login.
 * @property {Array<string>} UserRoles - The roles of the user.
 * @property {string} DeviceID - The device ID associated with the session.
 * @property {number} IDDevice - The IDDevice (database ID) of the device record associated with the session.
 */

/**
 * Per-request options, accepted wherever a method takes a URL. Every property except `url` passes through to fable's
 * RestClient unchanged, so the names are its own (fable docs/services/rest-client.md).
 *
 * @typedef {Object} HeadlightRequestOptions
 * @property {string} url - Relative to the server URL, or absolute.
 * @property {boolean} [RetrySafe] - The request may be replayed under the retry policy although its method is not
 *     idempotent (only set it when repeating the request cannot do harm, e.g. a full replace).
 * @property {boolean|number|Object} [Retry] - Override the retry policy for this request (`false` disables).
 * @property {number} [timeout] - Socket timeout in milliseconds (default: the fable `DefaultRestTimeout` setting, else 270000).
 * @property {Object<string, string>} [headers] - Extra request headers.
 */

/**
 * REST client fable service.
 */
class HeadlightRestClient extends FableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance.
	 * @param {Object<String, any>} [pOptions] - The options for the client.
	 * @param {String} [pServiceHash] - A service hash for the fable service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadLightRestClientOptions, pOptions);

		// TODO: Should this default to local instead?
		if (!tmpOptions.hasOwnProperty('HeadlightAPIURL'))
		{
			tmpOptions.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
		}

		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'HeadLightRestClient';

		this.serverURL = this.options.ServerURL;
		this.userID = this.options.UserID;
		this.password = this.options.Password;
		this.enforceSSL = this.options.EnforceSSL ?? true;

		if (!this.serverURL)
		{
			//this.log.warn('No ServerURL was provided in the HeadLightFableClient options; requests will fail.');
		}

		/** @type {SessionInfo} */
		this._SessionData = false;
		this._Impersonating = false;
		/** @type {String} */
		this._SessionToken = null;
		this._LoggedIn = false;
		if (this.options.SessionToken)
		{
			this._SessionToken = this.options.SessionToken;
		}

		// Construct a RestClient to use for all requests
		// KeepAlive is configurable via options or fable settings (RestClientKeepAlive)
		let tmpRestClientOptions = {};
		if (this.options.KeepAlive || this.fable.settings.RestClientKeepAlive)
		{
			tmpRestClientOptions.KeepAlive = true;
		}
		this.restClient = this.fable.serviceManager.instantiateServiceProvider('RestClient', tmpRestClientOptions, 'HeadLightFableClient-RestClient');
		/** @type {'credentials'|'external'|null} How the current session was obtained: our own login, or handed in. */
		this._SessionSource = null;
		/** @type {number} Bumped whenever the session changes; stamped on each request so recovery can tell a 401 for a session already replaced. */
		this._SessionGeneration = 0;
		if (this.options.AutoReauthenticate !== false)
		{
			this.restClient.authenticationRecovery = (pContext) => this._recoverSession(pContext);
		}
		this.cache = {};
		/** @type {Record<string, Array<Function>>} callbacks waiting on an entity read already in flight */
		this._entityRequestsInFlight = {};
		this.urlParams = {};
		// checkDefaultsInSettings() populates this from fable settings, but it only
		// runs via authenticate(). Callers that use setSessionData() directly (e.g.
		// impersonated/session-reuse flows) never call authenticate, so initialize
		// here to avoid _prepareRequestOptions assigning undefined into pOptions.headers.
		/** @type {Record<string, string>} */
		this.defaultHeaders = {};
	}

	/**
	 * Check for default values in DefaultProgramConfiguration in settings if they haven't been set.
	 * 
	 */
	checkDefaultsInSettings()
	{
		if (!this.serverURL && this.fable.ProgramConfiguration && this.fable.ProgramConfiguration.ServerURL)
		{
			this.serverURL = this.fable.ProgramConfiguration.ServerURL;
		}
		else if (!this.serverURL && this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.ServerURL)
		{
			this.serverURL = this.fable.settings.DefaultProgramConfiguration.ServerURL;
		}
		else if (!this.serverURL)
		{
			throw new Error(`Headlight REST client cannot interact with a server without a Server URL.  If this is a user-facing tool, please check your .headlight.config.json and add a ServerURL: parameter, or run the auth command.`);
		}

		if (this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.Headers)
		{
			this.defaultHeaders = this.fable.settings.DefaultProgramConfiguration.Headers;
		}
		else
		{
			this.defaultHeaders = {};
		}

		if ((!this.userID || this.userID == 'DEFAULT') && this.fable.ProgramConfiguration && this.fable.ProgramConfiguration.UserID)
		{
			this.userID = this.fable.ProgramConfiguration.UserID;
		}
		else if ((!this.userID || this.userID == 'DEFAULT') && this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.UserID)
		{
			this.userID = this.fable.settings.DefaultProgramConfiguration.UserID;
		}
		else if (!this.userID || this.userID == 'DEFAULT')
		{
			throw new Error(`Headlight REST client cannot interact with a server without a User ID.  If this is a user-facing tool, please check your .headlight.config.json and add a UserID: parameter, or run the auth command.`);
		}

		if (!this.password && this.fable.ProgramConfiguration && this.fable.ProgramConfiguration.Password)
		{
			this.password = this.fable.ProgramConfiguration.Password;
		}
		else if (!this.password && this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.Password)
		{
			this.password = this.fable.settings.DefaultProgramConfiguration.Password;
		}
		else if (!this.password)
		{
			throw new Error(`Headlight REST client cannot interact with a server without a Password.  If this is a user-facing tool, please check your .headlight.config.json and add a Password: parameter, or run the auth command.`);
		}
	}

	/**
	 * @param {String} pName - The name of the parameter.
	 * @param {String} pValue - The value of the parameter.
	 */
	setUrlParam(pName, pValue)
	{
		this.urlParams[pName] = pValue;
	}

	/**
	 * @param {Object<String, any>} pOptions - The request options.
	 *
	 * @return {Object<String, any>} - The request options to use.
	 */
	prepareRequestOptions(pOptions)
	{
		return pOptions;
	}

	/**
	 * @param {Object<String, any>} pOptions - The request options.
	 */
	_prepareRequestOptions(pOptions)
	{
		if (!this._SessionData && this._SessionToken)
		{
			if ((pOptions.url.indexOf('?') > -1) && (pOptions.url.indexOf('SessionToken=') === -1))
			{
				pOptions.url += `&SessionToken=${this._SessionToken}`;
			}
			else if (pOptions.url.indexOf('SessionToken=') === -1)
			{
				pOptions.url += `?SessionToken=${this._SessionToken}`;
			}
		}
		else if (this.fable.settings.HeadlightBearerToken && this._SessionData && this._SessionData.hasOwnProperty('SessionID'))
		{
			if (!pOptions.headers)
			{
				pOptions.headers = {};
			}

			pOptions.headers.Authorization = `Bearer ${this._SessionData.SessionID}`;
		}
		const defaultHeaders = this.defaultHeaders;
		// Always a per-request object: fable writes the session cookie into it, and on the shared defaults that cookie
		// would ride every later request as if the caller had supplied it, outliving any session change.
		pOptions.headers = Object.assign(pOptions.headers || {}, defaultHeaders);
		if (!('rejectUnauthorized' in pOptions))
		{
			pOptions.rejectUnauthorized = this.enforceSSL;
		}

		pOptions.HeadlightSessionGeneration = this._SessionGeneration;

		if (!pOptions.timeout)
		{
			if (this.fable.settings.DefaultRestTimeout)
			{
				pOptions.timeout = this.fable.settings.DefaultRestTimeout;
			}
			else
			{
				pOptions.timeout = 270000;
			}
		}

		return this.prepareRequestOptions(pOptions);
	}

	/**
	 * @param {Error | String} pError - The error.
	 * @param {any} pResponse - The HTTP response object.
	 * @param {any} pBody - The respone body.
	 */
	_checkForError(pError, pResponse, pBody)
	{
		/** @type {Error} */
		let tmpError = typeof pError === 'string' ? new Error(pError) : pError;
		if (!tmpError && pBody && pBody.Error)
		{
			tmpError = new Error(pBody.Error);
		}
		if (!tmpError && pResponse && pResponse.statusCode >= 400)
		{
			tmpError = new Error(pBody ? JSON.stringify(pBody) : `Failed with status code ${pResponse.statusCode}`);
		}
		if (!tmpError && pBody && pBody.ErrorCode)
		{
			tmpError = new Error(`Failed with ErrorCode: ${pBody.ErrorCode}`);
		}
		return tmpError;
	}

	/**
	 * Check one page of a bulk entity read before its body is trusted as records: any failure
	 * _checkForError recognizes, and any other body that is not a record array.
	 * Same rule as pict's Pict-Meadow-EntityProvider _validateEntityPageResponse.
	 *
	 * @param {Error | String} pError - The transport error, if any.
	 * @param {any} pResponse - The HTTP response object.
	 * @param {any} pBody - The parsed response body.
	 * @return {Error|null} The failure, or null when the body is a usable record array.
	 */
	_checkForPageError(pError, pResponse, pBody)
	{
		const tmpError = this._checkForError(pError, pResponse, pBody);
		if (tmpError)
		{
			return tmpError;
		}
		if (!Array.isArray(pBody))
		{
			const tmpStatusCode = (pResponse && pResponse.statusCode) ? pResponse.statusCode : 'no response';
			return new Error(`${tmpStatusCode} response body was not a record array: ${JSON.stringify(pBody === undefined ? null : pBody).substring(0, 300)}`);
		}
		return null;
	}

	////////////////////////////////////////////////////////////////////////////////
	// Entity Creation and Update Methods
	/**
	 * Create a new entity record.
	 *
	 * @param {String} pEntityType - The entity type to create.
	 * @param {Object<String, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	createEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.postJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error creating ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Created ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Update an entity record.
	 *
	 * @param {String} pEntityType - The entity type to create.
	 * @param {Object<String, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	updateEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error updating ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Updated ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Upsert an entity record.
	 *
	 * @param {String} pEntityType - The entity type to be upserted.
	 * @param {Object<String, any>} pRecord - The record to upsert.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upsert`),
				body: pRecord
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error upserting ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Upserted ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Upsert a array of entity records.
	 *
	 * @param {String} pEntityType - The entity type to be upserted.
	 * @param {Array<Object<String, any>>} pRecords - The records to upsert.
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntities(pEntityType, pRecords, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upserts`),
				body: pRecords
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error upserting ${pEntityType} records: ${pError.message}`);
				}
				else
				{
					this.log.info(`Upserted multiple ${pEntityType} records (count: ${pBody.length})`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Delete an entity record.
	 *
	 * @param {String} pEntityType - The entity type to create.
	 * @param {String | Number} pIDRecord - The ID of the record to delete.
	 * @param {Function} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	deleteEntity(pEntityType, pIDRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/${pIDRecord}`),
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.delJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error deleting ${pEntityType} record ID ${pIDRecord}: ${pError.message}`);
				}
				else
				{
					this.log.info(`Deleted ${pEntityType} record ID ${pIDRecord}`);
				}
				return fCallback(pError, pBody);
			});
	}

	////////////////////////////////////////////////////////////////////////////////
	// Entity Request Methods
	/**
	 * Initialize cache for a given entity type.
	 *
	 * @param {String} pEntityType - The entity type to cache.
	 */
	initializeCache(pEntityType)
	{
		// This should not be happening as often as it's happening.
		if (!this.cache.hasOwnProperty(pEntityType))
		{
			this.cache[pEntityType] = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('ObjectCache');
			// TODO: Make this a configuration?
			// For now cache for 30 seconds.
			this.cache[pEntityType].maxAge = 30000;
			this.cache[pEntityType].maxLength = 10000;
		}
	}

	/**
	 * Read a record by ID.
	 *
	 * @param {String} pEntityType - The entity type to read.
	 * @param {String | Number} pIDRecord - The ID of the record to read.
	 * @param {Function} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	getEntity(pEntityType, pIDRecord, fCallback)
	{
		this.initializeCache(pEntityType);
		// Discard anything from the cache that has expired or is over size.
		this.cache[pEntityType].prune(
			()=>
			{
				let tmpPossibleRecord = this.cache[pEntityType].read(pIDRecord);

				if (tmpPossibleRecord)
				{
					return fCallback(null, tmpPossibleRecord);
				}

				// Callers asking for a record already being fetched wait on that request instead of issuing another.
				const tmpRequestKey = `${pEntityType}/${pIDRecord}`;
				if (this._entityRequestsInFlight[tmpRequestKey])
				{
					this._entityRequestsInFlight[tmpRequestKey].push(fCallback);
					return;
				}
				this._entityRequestsInFlight[tmpRequestKey] = [ fCallback ];

				let tmpRequestOptions = (
					{
						url: this.formatUrl(`${pEntityType}/${pIDRecord}`),
					});
				tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

				return this.restClient.getJSON(tmpRequestOptions,
					(pError, pResponse, pBody) =>
					{
						pError = this._checkForError(pError, pResponse, pBody);
						if (!pError && pBody)
						{
							this.cache[pEntityType].put(pBody, pIDRecord);
						}
						const tmpWaitingCallbacks = this._entityRequestsInFlight[tmpRequestKey] || [];
						delete this._entityRequestsInFlight[tmpRequestKey];
						for (const tmpWaitingCallback of tmpWaitingCallbacks)
						{
							// One caller's failure must not starve the others waiting on the same record.
							try
							{
								tmpWaitingCallback(pError, pBody);
							}
							catch (pCallbackError)
							{
								this.log.error(`Error in getEntity callback for ${tmpRequestKey}: ${pCallbackError.message || pCallbackError}`);
							}
						}
					});
			}
		);
	}

	/**
	 * Read a record by GUID.
	 *
	 * @param {String} pEntityType - The entity type to read.
	 * @param {String} pGUIDRecord - The GUID of the record to read.
	 * @param {Function} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	getEntityByGUID(pEntityType, pGUIDRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}s/By/GUID${pEntityType}/${encodeURIComponent(pGUIDRecord)}`),
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		return this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError || !Array.isArray(pBody))
				{
					return fCallback(pError || new Error('No body returned') );
				}
				if (pBody && pBody.length > 0)
				{
					return fCallback(pError, pBody[0]);
				}
				else
				{
					return fCallback(pError);
				}
			});
	}

	/**
	 * Format a URL for the HTTP client.
	 *
	 * @param {String} pUrl - The URL to format.
	 *
	 * @return {String} the formatted URL.
	 */
	formatUrl(pUrl, makeAbsolute = true)
	{
		if (Object.keys(this.urlParams).length === 0)
		{
			return (makeAbsolute && !pUrl.includes('://')) ? `${this.serverURL}${pUrl}` : pUrl;
		}
		let joiningPart = pUrl.includes('?') ? '&' : '?';
		for(let paramName in this.urlParams)
		{
			const paramValue = this.urlParams[paramName];
			pUrl += joiningPart + `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`

			// any subsequent parameters join with an &
			joiningPart += '&';
		}

		if (makeAbsolute && !pUrl.includes('://'))
		{
			return `${this.serverURL}${pUrl}`;
		}
		return pUrl;
	}

	/**
	 * @param {String} [pMeadowFilterExpression] - A meadow filter expression; empty selects the unfiltered route.
	 * @return {String} The `/FilteredTo/<filter>` route segment, or an empty string.
	 */
	_filterSegment(pMeadowFilterExpression)
	{
		if (!pMeadowFilterExpression)
		{
			return '';
		}
		return `/FilteredTo/${pMeadowFilterExpression}`;
	}

	/**
	 * Read a count of records with filter.
	 *
	 * @param {String} pEntity - The entity type to read.
	 * @param {String} pMeadowFilterExpression - The filter expression to use.
	 * @param {(pError?: Error, pResults?: { Count: number }) => void} fCallback - The callback to call when the request is complete.
	 */
	getEntitySetCount(pEntity, pMeadowFilterExpression, fCallback)
	{
		this.initializeCache(pEntity);
		// TODO: Should we test for too many record IDs here by string length?
		// FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		// Discard anything from the cache that has expired or is over size.
		let tmpCountOptions = (
			{
				url: this.formatUrl(`${pEntity}s/Count${this._filterSegment(pMeadowFilterExpression)}`),
				rejectUnauthorized: this.enforceSSL,
			});
		if (pEntity.indexOf('/Lite') > 0)
		{
			tmpCountOptions = (
				{
					url: this.formatUrl(`${pEntity.replace('/Lite','')}/Count${this._filterSegment(pMeadowFilterExpression)}`),
					rejectUnauthorized: this.enforceSSL,
				});
		}
		tmpCountOptions = this.prepareRequestOptions(tmpCountOptions);

		return this.restClient.getJSON(tmpCountOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error getting bulk entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Read records with filter.
	 *
	 * @param {String} pEntity - The entity type to read.
	 * @param {String} pMeadowFilterExpression - The filter expression to use.
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 * @param {Number|String} [pCursorStart] - Zero-based index of where to start downloading records from
	 * @param {Number|String} [pRecordLimit] - The maximum number of records to return
	 */
	getEntitySet(pEntity, pMeadowFilterExpression, fCallback, pCursorStart, pRecordLimit)
	{
		this.initializeCache(pEntity);

		// TODO: Should we test for too many record IDs here by string length?
		// FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		// Discard anything from the cache that has expired or is over size.
		let tmpCountOptions = (
			{
				url: this.formatUrl(`${pEntity}s/Count${this._filterSegment(pMeadowFilterExpression)}`),
				rejectUnauthorized: this.enforceSSL,
			});
		if (pEntity.indexOf('/Lite') > 0)
		{
			tmpCountOptions = (
				{
					url: this.formatUrl(`${pEntity.replace('/Lite','')}/Count${this._filterSegment(pMeadowFilterExpression)}`),
					rejectUnauthorized: this.enforceSSL,
				});
		}
		tmpCountOptions = this.prepareRequestOptions(tmpCountOptions);

		let tmpCursorStart = (typeof(pCursorStart) !== 'undefined') ? parseInt(String(pCursorStart)) : 0;
		let tmpRecordLimit = (typeof(pRecordLimit) !== 'undefined') ? parseInt(String(pRecordLimit)) : 1000;

		return this.restClient.getJSON(tmpCountOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error getting bulk entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				let tmpRecordCount = 0;
				if (pBody.Count)
				{
					tmpRecordCount = pBody.Count;
				}

				if (tmpCursorStart > tmpRecordCount)
				{
					let tmpErrorMessage = `Cursor start of ${tmpCursorStart} for [${pEntity}] filtered to [${pMeadowFilterExpression}] is greater than the total records ${tmpRecordCount}.`;
					this.log.error(tmpErrorMessage);
					return fCallback(new Error(tmpErrorMessage));
				}

				let tmpDownloadURIFragments = [];
				let tmpDownloadBatchSize = this.options.DownloadBatchSize;

				// Create a depleting maximum as we create the uri fragments
				let tmpDepletingMaximum = tmpRecordLimit;

				for (let i = 0; i < (tmpRecordCount / tmpDownloadBatchSize); i++)
				{
					// If we've depleted the maximum, stop generating URI fragments
					if (tmpDepletingMaximum < 1)
					{
						continue;
					}

					// Depletion logic
					let tmpFragmentRecordCount = Math.min(tmpDepletingMaximum, tmpDownloadBatchSize);
					tmpDepletingMaximum = tmpDepletingMaximum - tmpFragmentRecordCount;

					// Generate each of the URI fragments to download -- Lite records come prepluralized
					if (pEntity.indexOf('/Lite') > 0)
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}${this._filterSegment(pMeadowFilterExpression)}/${(i*tmpDownloadBatchSize)+tmpCursorStart}/${tmpFragmentRecordCount}`));
					}
					else
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}s${this._filterSegment(pMeadowFilterExpression)}/${(i*tmpDownloadBatchSize)+tmpCursorStart}/${tmpFragmentRecordCount}`));
					}
				}

				let tmpEntitySet = [];
				// Now run these in series (it's possible to parallelize but no reason to)
				this.fable.Utility.eachLimit(tmpDownloadURIFragments, 1,
					(pURIFragment, fDownloadCallback)=>
					{
						let tmpRecordBatchRequestOptions = (
						{
							url: `${pURIFragment}`,
							rejectUnauthorized: this.enforceSSL,
						});
						tmpRecordBatchRequestOptions = this.prepareRequestOptions(tmpRecordBatchRequestOptions);

						this.restClient.getJSON(tmpRecordBatchRequestOptions,
							(pDownloadError, pDownloadResponse, pDownloadBody)=>
							{
								let tmpDownloadError = this._checkForPageError(pDownloadError, pDownloadResponse, pDownloadBody);
								if (tmpDownloadError)
								{
									this.log.error(`Error downloading bulk entities of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpRecordBatchRequestOptions.url}]: ${tmpDownloadError}`);
									return fDownloadCallback(tmpDownloadError);
								}
								tmpEntitySet = tmpEntitySet.concat(pDownloadBody);
								// Should we be caching each record?
								return fDownloadCallback();
							});
					},
					(pFullDownloadError)=>
					{
						return fCallback(pFullDownloadError, tmpEntitySet);
					})
			});
	}


	/**
	 * Read records with filter, executing a function for initial count and with each returned page.
	 *
	 * Great for longer queries.
	 *
	 * @param {String} pEntity - The entity type to read.
	 * @param {String} pMeadowFilterExpression - The filter expression to use.
	 * @param {(count: Number) => void} fCountFunction - The function to call the count of records
	 * @param {(count: Number, records: Array<any>) => void} fPageFunction - The function to call with each page of records
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 */
	getEntitySetWithPages(pEntity, pMeadowFilterExpression, fCountFunction, fPageFunction, fCallback)
	{
		this.initializeCache(pEntity);
		// TODO: Should we test for too many record IDs here by string length?
		// FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		// Discard anything from the cache that has expired or is over size.
		let tmpCountOptions = (
			{
				url: this.formatUrl(`${pEntity}s/Count${this._filterSegment(pMeadowFilterExpression)}`),
				rejectUnauthorized: this.enforceSSL,
			});
		if (pEntity.indexOf('/Lite') > 0)
		{
			tmpCountOptions = (
				{
					url: this.formatUrl(`${pEntity.replace('/Lite','')}/Count${this._filterSegment(pMeadowFilterExpression)}`),
					rejectUnauthorized: this.enforceSSL,
				});
		}
		tmpCountOptions = this.prepareRequestOptions(tmpCountOptions);

		return this.restClient.getJSON(tmpCountOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error getting bulk entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				let tmpRecordCount = 0;
				if (pBody.Count)
				{
					tmpRecordCount = pBody.Count;
				}

				// TODO: Map out if we need more than these hooks.
				try
				{
					fCountFunction(tmpRecordCount);
				}
				catch(pCountFunctionError)
				{
					this.log.error(`Error executing count function for getEntitySetWithPages [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pCountFunctionError}`);
				}

				let tmpDownloadURIFragments = [];
				let tmpDownloadBatchSize = this.options.DownloadBatchSize;
				for (let i = 0; i < (tmpRecordCount / tmpDownloadBatchSize); i++)
				{
					// Generate each of the URI fragments to download
					if (pEntity.indexOf('/Lite') > 0)
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}${this._filterSegment(pMeadowFilterExpression)}/${i*tmpDownloadBatchSize}/${tmpDownloadBatchSize}`));
					}
					else
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}s${this._filterSegment(pMeadowFilterExpression)}/${i*tmpDownloadBatchSize}/${tmpDownloadBatchSize}`));
					}
				}

				let tmpEntitySet = [];
				// Now run these in series (it's possible to parallelize but no reason to)
				this.fable.Utility.eachLimit(tmpDownloadURIFragments, 1,
					(pURIFragment, fDownloadCallback)=>
					{
						let tmpRecordBatchRequestOptions = (
						{
							url: `${pURIFragment}`,
							rejectUnauthorized: this.enforceSSL,
						});
						tmpRecordBatchRequestOptions = this.prepareRequestOptions(tmpRecordBatchRequestOptions);

						this.restClient.getJSON(tmpRecordBatchRequestOptions,
							(pDownloadError, pDownloadResponse, pDownloadBody)=>
							{
								let tmpDownloadError = this._checkForPageError(pDownloadError, pDownloadResponse, pDownloadBody);
								if (tmpDownloadError)
								{
									this.log.error(`Error downloading bulk entities of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpRecordBatchRequestOptions.url}]: ${tmpDownloadError}`);
									return fDownloadCallback(tmpDownloadError);
								}
								tmpEntitySet = tmpEntitySet.concat(pDownloadBody);

								try
								{
									if (Array.isArray(pDownloadBody))
									{
										fPageFunction(pDownloadBody.length, pDownloadBody);
									}
								}
								catch(pPageFunctionError)
								{
									this.log.error(`Error executing page received function for getEntitySetWithPages [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pPageFunctionError}`);
								}

								// Should we be caching each record?
								return fDownloadCallback();
							});
					},
					(pFullDownloadError)=>
					{
						return fCallback(pFullDownloadError, tmpEntitySet);
					})
			});
	}

	/**
	 * Request options for a URL argument: a string, or an options object whose `url` is formatted like a string URL
	 * and whose other properties pass through to fable's RestClient (e.g. `RetrySafe`, `Retry`, `timeout`).
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL, or the request options.
	 * @param {boolean} [pMakeAbsolute] - Prefix a relative URL with the server URL (formatUrl).
	 *
	 * @return {Record<string, any>} A fresh request options object.
	 */
	_requestOptionsFor(pURL, pMakeAbsolute = true)
	{
		if (pURL && (typeof(pURL) === 'object'))
		{
			let tmpOptions = Object.assign({}, pURL, { url: this.formatUrl(pURL.url, pMakeAbsolute) });
			if (pURL.headers)
			{
				tmpOptions.headers = Object.assign({}, pURL.headers);
			}
			return tmpOptions;
		}
		return { url: this.formatUrl(String(pURL), pMakeAbsolute) };
	}

	/**
	 * @param {String|HeadlightRequestOptions} pURL - The URL, or the request options.
	 *
	 * @return {String} The URL as the caller gave it, for log lines.
	 */
	_requestURLFor(pURL)
	{
		return (pURL && (typeof(pURL) === 'object')) ? pURL.url : String(pURL);
	}

	////////////////////////////////////////////////////////////////////////////////
	// Low-level API service requests
	/**
	 * Send a GET request. Parses response as JSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 */
	getJSON(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL));

		return this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error reading JSON from server [${tmpRequestOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(null, pBody);
			});
	}

	/**
	 * Send a GET request. Parses response as a Buffer.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {(pError?: Error, pResult?: Buffer) => void} fCallback - The callback to call when the request is complete.
	 */
	getBinary(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL));

		return this.restClient.executeChunkedRequestBinary(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error reading Binary GET from from server [${tmpRequestOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(null, pBody);
			});
	}

	/**
	 * Upload binary data to the server with optional progress tracking.
	 *
	 * Routes through this.restClient.executeBinaryUpload() so the offline
	 * interceptor can catch matching URLs at the RestClient layer, the
	 * same way JSON requests are intercepted via executeJSONRequest.
	 *
	 * @param {string|HeadlightRequestOptions} pURL - Relative URL (will be formatted with serverURL prefix), or request options carrying it (`url`)
	 * @param {File|Blob} pFile - The binary data to upload
	 * @param {string} pMimeType - MIME type for Content-Type header
	 * @param {function} fCallback - Callback (pError, pResponseBody)
	 * @param {function} [fOnProgress] - Optional progress callback (0.0 to 1.0)
	 */
	postBinary(pURL, pFile, pMimeType, fCallback, fOnProgress)
	{
		let tmpRequestOptions = this._requestOptionsFor(pURL, true);
		tmpRequestOptions.method = 'POST';
		tmpRequestOptions.body = pFile;
		tmpRequestOptions.headers = Object.assign({}, tmpRequestOptions.headers, { 'Content-Type': pMimeType });
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		return this.restClient.executeBinaryUpload(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error uploading binary to [${this._requestURLFor(pURL)}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(null, pBody);
			},
			fOnProgress);
	}

	/**
	 * Download binary data from the server as a Blob.
	 *
	 * Routes through this.restClient so the offline interceptor can
	 * catch matching URLs at the IPC layer. Uses executeChunkedRequest
	 * (raw response, no JSON parsing) and converts the result to a Blob
	 * for browser consumers.
	 *
	 * @param {string|HeadlightRequestOptions} pURL - Relative URL (will be formatted with serverURL prefix), or request options carrying it (`url`)
	 * @param {function} fCallback - Callback (pError, pBlob)
	 */
	getBinaryBlob(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL, true));

		return this.restClient.executeChunkedRequest(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error downloading binary from [${this._requestURLFor(pURL)}]: ${pError}`);
					return fCallback(pError);
				}

				// If the body is already a Blob (e.g., from IPC BlobStore), return directly
				if (typeof Blob !== 'undefined' && pBody instanceof Blob)
				{
					return fCallback(null, pBody);
				}

				// Convert Buffer/string/ArrayBuffer to Blob for browser consumers
				if (typeof Blob !== 'undefined')
				{
					try
					{
						let tmpBlob = new Blob([pBody]);
						return fCallback(null, tmpBlob);
					}
					catch (pBlobError)
					{
						return fCallback(pBlobError);
					}
				}

				// Node.js: return the raw body as-is (Buffer/string)
				return fCallback(null, pBody);
			});
	}

	/**
	 * Send a POST request. Parses response as JSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {any} pRequestPostObject - The object to send in the body of the request as JSON.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 */
	postJSON(pURL, pRequestPostObject, fCallback)
	{
		let tmpRequestOptions = this._requestOptionsFor(pURL);
		tmpRequestOptions.body = pRequestPostObject;
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.postJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error posting to ${this._requestURLFor(pURL)}: ${pError.message}`, pRequestPostObject);
				}
				else
				{
					this.log.info(`Posted to ${this._requestURLFor(pURL)}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Send a PUT request. Parses response as JSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {any} pRequestPutObject - The object to send in the body of the request as JSON.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 */
	putJSON(pURL, pRequestPutObject, fCallback)
	{
		let tmpRequestOptions = this._requestOptionsFor(pURL);
		tmpRequestOptions.body = pRequestPutObject;
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error putting to ${this._requestURLFor(pURL)}: ${pError.message}`, pRequestPutObject);
				}
				else
				{
					this.log.info(`Put to ${this._requestURLFor(pURL)}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Issue a DELETE to an arbitrary URL (for endpoints that aren't a plain entity delete, e.g.
	 * `Permissions/Memberships/For/User/:IDUser/In/:Context/:IDContext`). Mirrors putJSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL, or request options carrying it (`url`).
	 * @param {Function} fCallback - (error, body)
	 */
	deleteJSON(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL));

		this.restClient.delJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error deleting ${this._requestURLFor(pURL)}: ${pError.message}`);
				}
				else
				{
					this.log.info(`Deleted ${this._requestURLFor(pURL)}`);
				}
				return fCallback(pError, pBody);
			});
	}


	////////////////////////////////////////////////////////////////////////////////
	// User and Session Management
	/**
	 * @return {SessionInfo?} - The session data.
	 */
	get session()
	{
		return this._SessionData;
	}

	/**
	 * @return {Boolean} - True if the client is authenticated.
	 */
	get loggedIn()
	{
		return this._LoggedIn;
	}

	/**
	 * @param {String} [pSessionToken] - The session token to set on requests.
	 */
	setSessionToken(pSessionToken)
	{
		this._SessionToken = pSessionToken;
	}

	/**
	 * @param {SessionInfo} [pSessionData] - The session data to set.
	 */
	setSessionData(pSessionData)
	{
		this._SessionData = pSessionData;
		this._SessionSource = 'external';
		this._SessionGeneration++;

		if (!this.restClient.cookie)
		{
			this.restClient.cookie = {};
		}

		if ((typeof(this._SessionData) == 'object') && this._SessionData.SessionID)
		{
			this.restClient.cookie['UserSession'] = this._SessionData.SessionID;
		}
	}

	/**
	 * Clear local cookies and session data.
	 */
	resetSessionData()
	{
		if (typeof(this.restClient.cookie) === 'object')
		{
			this.restClient.cookie = false;
		}
		this._SessionData = false;
		this._SessionSource = null;
		this._SessionGeneration++;
		this._Impersonating = false;
	}

	/**
	 * @return {Boolean} - True if the client is impersonating.
	 */
	get impersonating()
	{
		return this._Impersonating;
	}

	/**
	 * Authenticate with the server.
	 *
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	authenticate(fCallback)
	{
		this.checkDefaultsInSettings();
		this.restClient.postJSON(
			this._authRequestOptions(
				{
					url: this.formatUrl('/Authenticate'),
					body:
						{
							UserName: this.userID,
							Password: this.password
						},
					rejectUnauthorized: this.enforceSSL,
				}),
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					const tmpKeepSession = (this.options.KeepSessionOnFailedAuthenticate !== false) && this._SessionData && this._SessionData.SessionID;
					this.log.error(`Problem Logging Into HeadLight API Server [${this.serverURL}] as ${this.userID}: ${pError.message || pError}${tmpKeepSession ? ' (keeping the existing session)' : ''}`);
					if (!tmpKeepSession)
					{
						this.resetSessionData();
					}
					return fCallback(pError, false);
				}

				//this.log.info(`Successfully logged into HeadLight API Server as ${pBody.LoginID}`);

				this.setSessionData(pBody);
				this._SessionSource = 'credentials';

				return fCallback(null, this._SessionData)
			});
	}

	/**
	 * Options for a request that is part of authentication itself: never routed through session recovery (it would
	 * wait on the recovery it belongs to), and replayed on transient failures under `AuthenticateRetry`.
	 *
	 * @param {Record<string, any>} pOptions - The request options.
	 * @param {boolean} [pRetry] - Apply the `AuthenticateRetry` policy (login requests only).
	 *
	 * @return {Record<string, any>} The same options, decorated.
	 */
	_authRequestOptions(pOptions, pRetry = true)
	{
		pOptions.AuthenticationRecovery = false;
		if (pRetry && this.options.AuthenticateRetry)
		{
			pOptions.Retry = this.options.AuthenticateRetry;
			// Logging in twice is harmless; the second login just mints another session.
			pOptions.RetrySafe = true;
		}
		return pOptions;
	}

	/**
	 * @return {boolean} True when the current session came from this client's own login and the credentials to log in
	 *     again are at hand. Never true for a session handed in or an impersonated one.
	 */
	_canReauthenticate()
	{
		return (this.options.AutoReauthenticate !== false)
			&& (this._SessionSource === 'credentials')
			&& !this._Impersonating
			&& !!this.userID && (this.userID !== 'DEFAULT')
			&& !!this.password;
	}

	/**
	 * fable RestClient authenticationRecovery hook: a request came back 401. When the session is one this client
	 * logged in itself and it has really expired, log in again; fable then replays the request once.
	 *
	 * @param {{ options: Record<string, any>, response: any }} pContext - The request about to be replayed, and the 401.
	 *
	 * @return {Promise<boolean>} True when a new session is in place and the request should be replayed.
	 */
	_recoverSession(pContext)
	{
		return new Promise((fResolve) =>
		{
			if (!this._canReauthenticate())
			{
				return fResolve(false);
			}
			const tmpRequest = `${(pContext.options && pContext.options.method) || 'request'} ${(pContext.options && pContext.options.url) || ''}`;
			const tmpSentGeneration = pContext.options ? pContext.options.HeadlightSessionGeneration : undefined;
			if ((typeof(tmpSentGeneration) === 'number') && (tmpSentGeneration !== this._SessionGeneration))
			{
				// Sent on a session that has since been replaced (another request's recovery logged in again).
				return fResolve(true);
			}
			const fLogin = () =>
			{
				this.authenticate((pError) =>
				{
					if (pError)
					{
						this.log.warn(`Session for ${this.userID} expired and logging in again failed; returning the 401 for ${tmpRequest}.`);
						return fResolve(false);
					}
					this.log.info(`Session for ${this.userID} expired; logged in again, replaying ${tmpRequest}.`);
					return fResolve(true);
				});
			};
			if (this.options.ReauthenticateVerifySession === false)
			{
				return fLogin();
			}
			this.checkSession((pError, pLoggedIn) =>
			{
				if (!pError && pLoggedIn)
				{
					this.log.warn(`Got a 401 for ${tmpRequest}, but the session for ${this.userID} is still valid; not logging in again.`);
					return fResolve(false);
				}
				return fLogin();
			});
		});
	}

	/**
	 * Authenticate with the server using credentials.
	 *
	 * @param {String} pUserID - The user ID to authenticate with.
	 * @param {String} pPassword - The password to authenticate with.
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	authenticateWithCredentials(pUserID, pPassword, fCallback)
	{
		this.restClient.postJSON(
			this._authRequestOptions(
				{
					url: this.formatUrl('/Authenticate'),
					body:
						{
							UserName: pUserID,
							Password: pPassword
						},
					// Honor the client's SSL-enforcement setting, matching authenticate()
					// and impersonate() (via _prepareRequestOptions). Without this, the
					// credential login falls back to Node's https default of
					// rejectUnauthorized:true, so an EnforceSSL:false client (e.g. one
					// talking to an internal gateway host like kong:8443 whose cert does
					// not list that hostname) fails the TLS handshake before authenticating.
					rejectUnauthorized: this.enforceSSL,
				}),
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Problem Logging Into HeadLight API Server [${this.serverURL}] as ${pUserID}:`, pError);
					this.resetSessionData();
					return fCallback(pError, this._SessionData);
				}

				//this.log.info(`Successfully logged into HeadLight API Server as ${pBody.LoginID}`);

				this.setSessionData(pBody);

				return fCallback(null, this._SessionData)
			});
	}

	/**
	 * Deauthenticate with the server.
	 *
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	deauthenticate(fCallback)
	{
		this.restClient.getJSON(
			this._authRequestOptions(
				{
					url: this.formatUrl('/Deauthenticate'),
				}, false),
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Problem Logging out of HeadLight API Server [${this.serverURL}] as ${this.userID}:`, pError);
				}

				this.log.info(`Successfully logged out of the HeadLight API Server`);
				this.resetSessionData();

				return fCallback(pError, this._SessionData)
			});
	}

	/**
	 * Impersonate a user.
	 *
	 * @param {String | Number} pIDUser - The ID of the user to impersonate.
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	impersonate(pIDUser, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`/Authentication/Impersonate/${pIDUser}`),
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Problem Impersonating User ${pIDUser}`, pError);
					return fCallback(pError);
				}

				if (pBody.Success)
				{
					// Never log the response body — it carries the live SessionID of
					// a privileged session.
					const tmpUser = pBody.User || {};
					this.log.info(`Successfully Impersonating User ${pIDUser}`,
						{ UserID: tmpUser.UserID, LoginID: tmpUser.LoginID, CustomerID: tmpUser.CustomerID, UserRoleIndex: tmpUser.UserRoleIndex });
					this._Impersonating = true;
					this.setSessionData(pBody.User);
					return fCallback(null, this._SessionData);
				}
				else
				{
					this.log.error(`Impersonating User ${pIDUser} Failed`, pBody);
					return fCallback(new Error(`Impersonation of ${pIDUser} was not successful!`));
				}
			});
	};

	/**
	 * Check out a new session token.
	 *
	 * @param {(pError?: Error, pResult?: String) => void} fCallback - The callback to call when the request is complete.
	 */
	checkoutSessionToken(fCallback)
	{
		this.restClient.getJSON(
			{
				url: this.formatUrl(`/CheckoutSessionToken`),
			},
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error('Problem Checking Out a Session Token from HeadLight API Server', pError);
					return fCallback(pError);
				}

				if (pBody.hasOwnProperty('Token'))
				{
					this.setSessionToken(pBody.Token);
				}

				return fCallback(null, pBody);
			});
	}

	/**
	 * Validate current authentication with the server. Updates local session state if it is de-synced.
	 *
	 * @param {(pError?: Error, pResult?: Boolean) => void} fCallback - The callback to call when the request is complete.
	 */
	checkSession(fCallback)
	{
		let tmpRequestOptions = this._authRequestOptions(
			{
				url: this.formatUrl(`/CheckSession`),
			}, false);
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error('Problem Checking Session on HeadLight API Server', pError);
					return fCallback(pError);
				}

				if (pBody.hasOwnProperty('LoggedIn') && pBody.LoggedIn)
				{
					// Update cached session data in case configuration changed
					this._SessionData = pBody;
					this._LoggedIn = true;
					return fCallback(null, true);
				}
				else
				{
					this._LoggedIn = false;
					this._SessionData = false;
					return fCallback(null, false);
				}
			});
	}
}

module.exports = HeadlightRestClient;

module.exports.default_configuration = defaultHeadLightRestClientOptions;

},{"fable-serviceproviderbase":398}],13:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Headlight Stationing fable service
 */
class HeadlightStationing extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance
	 * @param {any} [pOptions] - The options for the service
	 * @param {any} [pServiceHash] - The hash for the service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadLightStationing';
	}

	/**
	 * convert a "station" value to a number
	 * EX: "125+00" to "12500"
	 * @param {string|number} pValue
	 * @return {number} the numeric value of the station and offset
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue = '125+00';
	 * const tmpNumberValue = tmpHeadlightStationing.fromStationValue(tmpValue);
	 * // tmpNumberValue = 12500
	*/
	fromStationValue(pValue)
	{
		// we expect a string here regardless of what's passed
		const tmpValue = typeof (pValue) === 'undefined' ? '' : pValue.toString();

		// if they included the plus sign manually, or it's an updated 'pValue'
		if (tmpValue.indexOf('+') !== -1)
		{
			// honor the first +, ignore any subsequent ones, strip spaces, then do our best
			const tmpDescendingValues = tmpValue.split(/\s*\+\s*/);

			let tmpComputed = 0;
			for (let i = 0; i < tmpDescendingValues.length; i++)
			{
				tmpComputed += Math.pow(100, 1 - i) * (parseFloat(tmpDescendingValues[i]) || 0);
			}
			return tmpComputed;
		}

		const tmpDecimalIndex = tmpValue.indexOf('.');
		if (tmpDecimalIndex === -1 && tmpValue.trim().length < 3)
		{
			return parseFloat(tmpValue) * 100; // two digits or fewer is treated as a station value (I hate this)
		}
		return parseFloat(tmpValue);
	}

	/**
	 * Normalize a value that may be EITHER a station-formatted string ("0+50")
	 * OR an already-numeric station offset (50) into a numeric offset in feet.
	 *
	 * Unlike fromStationValue(), this does NOT apply the "a bare two-digit number
	 * means N+00" (x100) heuristic. A value without a '+' is treated as a literal
	 * offset, so an offset of 50 stays 50 (it does not become 5000 / "50+00").
	 *
	 * This is what consumers need when the value has already been reduced to a
	 * numeric offset (e.g. the Station input provider stores the numeric offset
	 * as its bound value), while still tolerating legacy rows that persisted the
	 * station-formatted string.
	 *
	 * @param {string|number} pValue
	 * @return {number} the numeric station offset, or NaN if unparseable
	 * @memberof HeadlightStationing
	 * @example
	 * tmpHeadlightStationing.normalizeStationOffset(50);      // 50
	 * tmpHeadlightStationing.normalizeStationOffset('0+50');  // 50
	 * tmpHeadlightStationing.normalizeStationOffset('1+50');  // 150
	*/
	normalizeStationOffset(pValue)
	{
		if (typeof pValue === 'number')
		{
			return pValue;
		}
		const tmpValue = (typeof pValue === 'undefined' || pValue === null) ? '' : pValue.toString();
		// A '+' means it's a station-formatted string ("0+50"); parse it the normal way.
		if (tmpValue.indexOf('+') !== -1)
		{
			return this.fromStationValue(tmpValue);
		}
		// Otherwise it is already a literal numeric offset in feet - do not scale it.
		return parseFloat(tmpValue);
	}

	/**
	 * convert a number string to a "station" value
	 * EX: "12500" to "125+00"
	 * @param {any} pValue - the numeric offset
	 * @return {string} the converted station and offset
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue = 12500;
	 * const tmpStationValue = tmpHeadlightStationing.toStationValue(tmpValue);
	 * // tmpStationValue = '125+00'
	*/
	toStationValue(pValue)
	{
		/** @type {number|string} */
		let tmpValue;
		switch (typeof pValue)
		{
			case 'string':
				tmpValue = pValue.includes('+') ? this.fromStationValue(pValue) : parseFloat(pValue);
				break;
			case 'number':
				tmpValue = pValue;
				break;
			default:
				tmpValue = String(pValue);
		}
		let returnValue = '';

		// if they pass a non-parseable value, return it as is early
		if (isNaN(Number(tmpValue)))
		{
			console.error('Invalid station value: ' + pValue);
			return pValue;
		}
		tmpValue = tmpValue.toString();

		// we have to account for decimals too
		const [ whole, fractional ] = tmpValue.split('.');

		// insert the '+' before the last two digits before the decimal
		if (whole.length === 2)
		{
			returnValue = '0+' + whole;
		}
		else if (whole.length === 1)
		{
			returnValue = '0+0' + whole;
		}
		else if (whole.length)
		{
			returnValue = whole.slice(0, whole.length - 2) + '+' + whole.slice(whole.length - 2);
		}
		else
		{
			this.fable.log.error('Invalid station value: ' + pValue);
			// return the original value, ignore the decimal and formatting
			return pValue;
		}
		// if there's a decimal, add it
		if (fractional)
		{
			returnValue += '.' + fractional;
		}

		return returnValue;
	}

	/**
	 * add two station values together
	 *
	 * @param {string|number} pValue1
	 * @param {string|number} pValue2
	 *
	 * @return {string} the sum of the two station values, formatted as a station value
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = '125+00';
	 * const tmpNumberValue = tmpHeadlightStationing.addStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = '250+00'
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = 'potato';
	 * const tmpNumberValue = tmpHeadlightStationing.addStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = 'NaN'
	*/
	addStationValues(pValue1, pValue2)
	{
		return this.toStationValue(this.fromStationValue(pValue1) + this.fromStationValue(pValue2));
	}

	/**
	 * subtract two station values
	 *
	 * @param {string|number} pValue1
	 * @param {string|number} pValue2
	 *
	 * @return {string} the difference of the two station values, formatted as a station value
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = '125+00';
	 * const tmpNumberValue = tmpHeadlightStationing.subtractStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = '0+00'
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = 'potato';
	 * const tmpNumberValue = tmpHeadlightStationing.subtractStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = 'NaN'
	*/
	subtractStationValues(pValue1, pValue2)
	{
		return this.toStationValue(this.fromStationValue(pValue1) - this.fromStationValue(pValue2));
	}
}

module.exports = HeadlightStationing;

},{"fable-serviceproviderbase":398}],14:[function(require,module,exports){

const FableServiceProviderBase = require('fable-serviceproviderbase');
const JsonDiff = require('json-diff');
const Fs = require('fs');
const Path = require('path');
const IntegrationAdapter = require('headlight-integration-adapter');

/**
 * Headlight Manifest Packaging fable service
 *
 * WARNING: This is a work in progress.
 */
class ManifestPackagingService extends FableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance
	 * @param {any} [pOptions] - The options for the service
	 * @param {any} [pServiceHash] - The hash for the service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & {
		 *    HeadlightRestClient: import('headlight-rest-client')
		 * 	  PictApplication: any
		 * 	  newManyfest: any
		 * 	  providers: any
		 *    servicesMap: {
		 *      IntegrationAdapter: { [hash: string]: IntegrationAdapter? },
		 *    },
		 *  }} */
		this.fable;
		this.serviceType = 'HeadlightPackaging';

		if (!('HeadlightRestClient' in this.fable.services))
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				//TODO: should this be /1.0/ only? is there a web usecase? branching on that?
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', this.options);
		}

		this.comprehension = {};
		this.manifestCache = {};
		this.cacheInitialized = false;
	}

	/**
	 * Fetch data from a URI
	 *
	 * @param {string} uri - the URI to fetch
	 * @return {Promise<any>} the fetched data
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.fable.HeadlightRestClient.getJSON(uri, (error, data) =>
			{
				if (error)
				{
					return reject(error);
				}
				resolve(data);
			});
		});
	}

	/**
	 * Fetch an entity set with filtering
	 *
	 * @param {string} entity - the entity to fetch
	 * @param {string} filter - the filter to apply to the entity request
	 * @return {Promise<any>} the fetched data
	 */
	async _getEntitySetAsync(entity, filter)
	{
		return await new Promise((resolve, reject) => 
		{
			// @ts-ignore
			this.fable.EntityProvider.getEntitySet(entity, filter, (error, result) => 
			{
				if (error)
				{
					return reject(error);
				}
				resolve (result);
			}, null, { NoCount: true });
		});
	}

	/**
	 * Fetch the form manifest, if configured.
	 *
	 * NOTE: Mirrors the logic in report_definitions/global/server_js/mixins/document.pre-render-mixins.js#LoadFormManifest
	 *
	 * @param {any} pRNI - the ReportNamedInstance
	 * @param {(uri: string) => Promise<any>} [getImpl] - alternate implementation of HTTP get
	 *
	 * @return {Promise<any>} the form manifest object, or null
	 */
	async _loadFormManifest(pRNI, getImpl)
	{
		const get = getImpl || this._get.bind(this);
		const reportOptions = pRNI.Options;
		if (typeof reportOptions.FormDefinition === 'object')
		{
			return reportOptions.FormDefinition;
		}
		try
		{
			// Resolve the root ManifestSchema record. New ingestion tooling
			// (BLT / bridge-push) sets Options.FormManifestSchemaHash instead
			// of FormManifestSchemaID — accept both.
			let rootManifest = null;
			if (reportOptions.FormManifestSchemaID > 0)
			{
				rootManifest = await get(`ManifestSchema/${reportOptions.FormManifestSchemaID}`);
			}
			else if (reportOptions.FormManifestSchemaHash)
			{
				// Hash is NOT unique across customers, so prefer the schema
				// whose IDCustomer matches the RNI's IDCustomer.
				const tmpSchemas = await get(`ManifestSchemas/FilteredTo/FBV~Hash~EQ~${encodeURIComponent(reportOptions.FormManifestSchemaHash)}`);
				if (Array.isArray(tmpSchemas) && tmpSchemas.length > 0)
				{
					rootManifest = tmpSchemas.find((pSchema) => pSchema.IDCustomer == pRNI.IDCustomer) || tmpSchemas[0];
				}
				else
				{
					this.fable.log.warn(`No ManifestSchema found for hash ${reportOptions.FormManifestSchemaHash} (RNI ${pRNI.Hash || pRNI.IDReportNamedInstance}).`);
				}
			}

			if (!rootManifest)
			{
				return null;
			}

			// Fetch and merge partials using the resolved schema's ID.
			const manifestPartialJoins = await get(`ManifestSchemaManifestSchemaPartialJoins/FilteredTo/FBV~IDManifestSchema~EQ~${rootManifest.IDManifestSchema}`);
			let manifestPartials = [];
			if (manifestPartialJoins.length > 0)
			{
				const manifestSchemaPartialToOrdinal = {};
				for (const join of manifestPartialJoins)
				{
					manifestSchemaPartialToOrdinal[join.IDManifestSchemaPartial] = join.Ordinal;
				}
				manifestPartials = await get(`ManifestSchemaPartials/FilteredTo/FBL~IDManifestSchemaPartial~INN~${manifestPartialJoins.map(j => j.IDManifestSchemaPartial).join(',')}`);
				manifestPartials.sort((a, b) =>
				{
					return (manifestSchemaPartialToOrdinal[a.IDManifestSchemaPartial] ?? 0) - (manifestSchemaPartialToOrdinal[b.IDManifestSchemaPartial] ?? 0);
				});
			}
			return this._mergeManifests(rootManifest, manifestPartials);
		}
		catch (error)
		{
			this.fable.log.error(`Error loading form manifest: ${error}`);
		}
		return null;
	}

	/**
	 * @param {Record<string, any>} pTargetManifest - The target manifest to merge into.
	 * @param {Record<string, any>} pSourceManifest - The source manifest to merge from.
	 *
	 * @return {Record<string, any>} the merged manifest
	 */
	_simpleManifestMerge(pTargetManifest, pSourceManifest)
	{
		if (!pTargetManifest.Descriptors)
		{
			pTargetManifest.Descriptors = {};
		}
		if (!Array.isArray(pTargetManifest.Sections))
		{
			pTargetManifest.Sections = [];
		}
		if (!pTargetManifest.ReferenceManifests)
		{
			pTargetManifest.ReferenceManifests = {};
		}
		for (const [ descriptorKey, descriptor ] of Object.entries(pSourceManifest?.Descriptors || {}))
		{
			if (!pTargetManifest.Descriptors[descriptorKey])
			{
				pTargetManifest.Descriptors[descriptorKey] = descriptor;
			}
			else
			{
				//TODO: do we need to merge descriptors that repeat?
			}
		}
		for (const section of pSourceManifest?.Sections || [])
		{
			if (!pTargetManifest.Sections.find(s => s.Hash === section.Hash))
			{
				pTargetManifest.Sections.push(section);
			}
			else
			{
				//TODO: do we need to merge sections that repeat?
			}
		}
		for (const [ referenceKey, reference ] of Object.entries(pSourceManifest?.ReferenceManifests || {}))
		{
			if (!pTargetManifest.ReferenceManifests[referenceKey])
			{
				pTargetManifest.ReferenceManifests[referenceKey] = reference;
			}
			else
			{
				//TODO: do we need to merge references that repeat?
			}
		}
		return pTargetManifest;
	}

	/**
	 * @param {any} rootManifest - The root ManifestSchema Database Record to merge into.
	 * @param {any[]} manifestPartials - The ManifestSchemaPartial Database Records to merge.
	 * @return {any} the merged schema
	 */
	_mergeManifests(rootManifest, manifestPartials)
	{
		const manifest = rootManifest.Manifest || {};
		manifest.Source = { ManifestSchemaID: rootManifest.IDManifestSchema };
		if (!manifest.Descriptors)
		{
			manifest.Descriptors = {};
		}
		if (!Array.isArray(manifest.Sections))
		{
			manifest.Sections = [];
		}
		if (!manifest.ReferenceManifests)
		{
			manifest.ReferenceManifests = {};
		}
		for (const partial of manifestPartials)
		{
			this._simpleManifestMerge(manifest, partial.ManifestPartial);
		}
		const manifestDefinition =
		{
			Product: 'HeadlightDynamicForm', //TODO: does this matter? does it do anything?
			DefaultFormManifest: manifest,
		};
		return manifestDefinition;
	}

	foundDashboard(recordset, hash)
	{
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		for (let recordSet of recordSets)
		{
			const r = recordSet.RecordSet;
			if (r == recordset && recordSet.RecordSetDashboardManifests?.includes?.(hash))
			{
				return true;
			}
		}
		return false;
	}

	async dynamicDashboardLoad(recordset, hash)
	{
		if (this.foundDashboard(recordset, hash))
		{
			return true;
		}
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		for (let x = 0; x < recordSets.length; x++)
		{
			let recordSet = recordSets[x];
			const r = recordSet.RecordSet;
			if (r == recordset)
			{
				let activeRecordsetConfig = this.fable.services.PictSectionRecordSet.recordSetProviderConfigurations[r];
				activeRecordsetConfig[`RecordSetFilterURLTemplate-Dashboard-${ hash }`] = `/PSRS/{~D:Record.RecordSet~}/SpecificDashboard/${ hash }/FilteredTo/{~D:Record.FilterString~}`;
				activeRecordsetConfig.RecordSetDashboardManifests = recordSet.RecordSetDashboardManifests ? [hash] : recordSet.RecordSetDashboardManifests.concat([hash]);
			}
		}
		return await this.loadRecordSetSchemasForProduct(null, ['Dashboard'], recordset);
	}

	async getAvailableSpecificDashboards(recordset)
	{
		const manifests = await this._getManifestSchemas(`${ recordset }-Dashboard-`, true);
		const hashes = [];
		for (let m of manifests)
		{
			if (m.Manifest?.Scope && !hashes.includes(m.Manifest.Scope))
			{
				hashes.push(m.Manifest.Scope);
			}
		}
		return hashes;
	}

	constructDashboardNav()
	{
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		const navObj = 
		{
			topNav: '',
			sideNav: []
		};
		for (let recordSet of recordSets)
		{
			const r = recordSet.RecordSet;
			const manifestHashes = recordSet.RecordSetDashboardManifests;
			for (let m of manifestHashes)
			{
				const manifest = this.fable.services.PictSectionRecordSet.manifestDefinitions[m];
				if (!manifest || [`${ r }-List`, `${ r }-Dashboard`].includes(m))
				{
					continue;
				}
				navObj.topNav += /*html*/ `
				<a class="navbar-item" onclick="toggleNavBarHamburgerMenu()" href="#/PSRS/${ r }/SpecificDashboard/${ m }">
					<span class="icon">
						<i class="fas ${ manifest.Icon || 'fa-rectangle-list' }"></i>
					</span>
					<span class="icon-text">${ manifest.TitleTemplate || manifest.Scope || m }</span>
				</a>`;
				navObj.sideNav.push( 
				{
					Hash: m,
					Name: manifest.TitleTemplate || manifest.Scope || m,
					Icon: `fas ${ manifest.Icon || 'fa-rectangle-list' }`,
					Address: `#/PSRS/${ r }/SpecificDashboard/${ m }`,
					PanelSource: null,
				});
			}
		}
		return navObj;
	}

	/**
	 * Loads and overrides all manifest schemas for all recordsets (for a particular product/app).
	 * @param {string} [product] - limits the schema load by product
	 * @param {Array<String>} [actions] - limits the schema load to only specific actions
	 * @param {string} [limitingRecordSet] - limits the schema load to only a single recordset
	 */
	async loadRecordSetSchemasForProduct(product, actions = ['List', 'Dashboard', 'Create', 'View', 'Edit', 'Filter'], limitingRecordSet)
	{
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		const manifestPromises = [];
		for (let x = 0; x < recordSets.length; x++)
		{
			let recordSet = recordSets[x];
			const r = recordSet.RecordSet;
			let activeRecordsetConfig = this.fable.services.PictSectionRecordSet.recordSetProviderConfigurations[r];
			if (limitingRecordSet && limitingRecordSet !== r)
			{
				continue;
			}
			try
			{
				const dynamicDashboardHashes = await this.getAvailableSpecificDashboards(r);
				activeRecordsetConfig.RecordSetDashboardManifests = recordSet.RecordSetDashboardManifests || [];
				for (let d of dynamicDashboardHashes)
				{
					if (!recordSet.RecordSetDashboardManifests.includes(d))
					{
						activeRecordsetConfig.RecordSetDashboardManifests.push(d);
						activeRecordsetConfig[`RecordSetFilterURLTemplate-Dashboard-${ d }`] = `/PSRS/{~D:Record.RecordSet~}/SpecificDashboard/${ d }/FilteredTo/{~D:Record.FilterString~}`;
					}
				}
				const dashboardManifestSet = [...(recordSet.RecordSetDashboardManifests || [])];
				const dashboardManifestFetch = async (d) => 
				{
					let tempManifest = await this.loadRecordManifestSchema(r, 'Dashboard', product, d);
					if (!tempManifest)
					{
						tempManifest = this.fable.PictApplication.options.pict_configuration.Manifests[d];
					}
					if (!tempManifest.Form)
					{
						this.fable.services.PictSectionRecordSet.generateManifestTableCells(tempManifest);
					}
					this.fable.services.PictSectionRecordSet.manifestDefinitions[d] = tempManifest;
					this.fable.services.PictSectionRecordSet.manifests[d] = tempManifest.Form ? tempManifest : this.fable.newManyfest(tempManifest);
				};				
				for (let d of dashboardManifestSet)
				{
					if ([`${ r }-List`, `${ r }-Dashboard`].includes(d))
					{
						continue;
					}
					manifestPromises.push(dashboardManifestFetch(d));
				}
				const actionManifestFetch = async (a) => 
				{
					let tempManifest = await this.loadRecordManifestSchema(r, a, product);
					if (!tempManifest)
					{
						tempManifest = this.fable.PictApplication.options.pict_configuration.Manifests[`${ r }-${ a }`];
					}
					if (['Dashboard', 'List'].includes(a))
					{
						this.fable.services.PictSectionRecordSet.generateManifestTableCells(tempManifest);
					}
					this.fable.services.PictSectionRecordSet.manifestDefinitions[`${ r }-${ a }`] = tempManifest;
					this.fable.services.PictSectionRecordSet.manifests[`${ r }-${ a }`] = !['Dashboard', 'List'].includes(a) ? tempManifest : this.fable.newManyfest(tempManifest);
					if (a == 'Filter' && this.fable?.providers?.[`RSP-Provider-${ r }`]?._FilterSchema && tempManifest)
					{
						this.fable.providers[`RSP-Provider-${ r }`]._FilterSchema = tempManifest.ReplaceBaseFilters ? tempManifest.Descriptors : Object.assign(this.fable.providers[`RSP-Provider-${ r }`]._FilterSchema, tempManifest.Descriptors);
					}
				};
				for (let a of actions)
				{
					manifestPromises.push(actionManifestFetch(a));
				}
			}
			catch (e)
			{
				this.fable.log.error('Failed to get manifest for record set.', e);
			}
		}
		await Promise.all(manifestPromises);
	}

	async loadQuickSummaryManifests(entities, defaults, product)
	{
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const manifestPromises = [];
		const manifestConfig = defaults || {};
		for (const entity of entities)
		{
			try
			{
				const summaryManifestFetch = async () => 
				{
					const tempManifest = await this.loadRecordManifestSchema(entity, 'Summary', product);
					if (tempManifest)
					{
						manifestConfig[entity] = tempManifest;
					}
					return tempManifest;
				};
				manifestPromises.push(summaryManifestFetch());
			}
			catch (e)
			{
				this.fable.log.error('Failed to get manifest for entity.', e);
			}
		}
		await Promise.all(manifestPromises);
		this.fable.services.HeadlightQuickSummaries.applyTypeConfig(manifestConfig);
	}

	async loadPrintableManifests(entities, defaults, product)
	{
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const manifestPromises = [];
		const manifestConfig = defaults || {};
		for (const entity of entities)
		{
			try
			{
				const summaryManifestFetch = async () => 
				{
					const tempManifest = await this.loadRecordManifestSchema(entity, 'Printable', product);
					if (tempManifest)
					{
						manifestConfig[entity] = tempManifest;
					}
					return tempManifest;
				};
				manifestPromises.push(summaryManifestFetch());
			}
			catch (e)
			{
				this.fable.log.error('Failed to get manifest for entity.', e);
			}
		}
		await Promise.all(manifestPromises);
		this.fable.providers.QRCodeProvider.applyTypeConfig(manifestConfig);
	}

	/**
	 * Loads a record manifest schema for a particular action type.
	 * @param {string} recordset - The recordset we are fetching a "RecordManifest" for.
	 * @param {string} verb - The verb/"action" this is for (options include Create/View/Edit/List/Dashboard).
	 * @param {string} [product] - The product we are fetching this manifest for.
	 * @param {string} [specifier] - A further specifier beyond the verb. Main purpose is for multiple types of Dashboard.
	 * @returns {Promise<null|Object>} - returns null or the schema loaded from the DB.
	 */
	async loadRecordManifestSchema(recordset, verb, product, specifier)
	{
		if (!recordset || !verb)
		{
			return null;
		}
		let rootManifest = (await this._getManifestSchemas(`${ product ? `${ product }-` : '' }${ recordset }-${ verb }${ specifier ? `-${ specifier }` : '' }`))?.[0];
		if (!rootManifest)
		{
			if (specifier)
			{
				return await this.loadRecordManifestSchema(recordset, verb, product);
			}
			if (product)
			{
				return await this.loadRecordManifestSchema(recordset, verb, null, specifier);
			}
			if (verb === 'Edit')
			{
				return await this.loadRecordManifestSchema(recordset, 'View');
			}
			return null;
		}
		const manifestSchemaPartialJoins = await this._getManifestSchemaPartialJoins(rootManifest.IDManifestSchema);
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			(await this._getManifestSchemaPartials(manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial))) : [];
		const manifest = this._mergeManifests(rootManifest, manifestPartials);
		return manifest?.DefaultFormManifest;
	}

	async primeManifestCache(product, entities)
	{
		if (this.cacheInitialized)
		{
			return;
		}
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const tempCache = {
			ManifestSchema: {},
			ManifestSchemaPartialJoin: {},
			ManifestSchemaPartial: {}
		};
		let schemaArr = [];
		// If a set of entities is passed, limit the set of customer level entities to cache for.
		if (entities)
		{
			const filters = ['FBV~Type~EQ~RecordManifest'];
			// Get all for the product
			if (product)
			{
				filters.push(`FBV~Type~EQ~RecordManifest~FBV~SubType~LK~${ product }-%25`);
			}
			// Get any customer level ones limited by entity.
			for (let e of entities)
			{
				filters.push(`FBVOR~Type~EQ~RecordManifest~FBV~SubType~LK~${ e }-%25`);
			}
			schemaArr = await this._getEntitySetAsync('ManifestSchema', filters.join('~'));
		}
		else
		{
			schemaArr = await this._getEntitySetAsync('ManifestSchema', 'FBV~Type~EQ~RecordManifest');
		}

		for (let s of schemaArr)
		{
			tempCache.ManifestSchema[s.SubType] = s;
		}
		const manifestSchemaPartialJoins = await this._getEntitySetAsync('ManifestSchemaManifestSchemaPartialJoin', `FBL~IDManifestSchema~INN~${ schemaArr.map(s => s.IDManifestSchema).join(',') }`);
		for (let mspj of manifestSchemaPartialJoins)
		{
			tempCache.ManifestSchemaPartialJoin[mspj.IDManifestSchema] = tempCache.ManifestSchemaPartialJoin[mspj.IDManifestSchema] || [];
			tempCache.ManifestSchemaPartialJoin[mspj.IDManifestSchema].push(mspj);
		}
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			(await this._getEntitySetAsync('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${ manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial).join(',') }`)) : [];
		for (let msp of manifestPartials)
		{
			tempCache.ManifestSchemaPartial[msp.IDManifestSchemaPartial] = msp;
		}
		this.manifestCache = tempCache
		this.cacheInitialized = true;
	}

	async _getManifestSchemas(subType, partialMatch)
	{
		if (!this.cacheInitialized)
		{
			return await this._getEntitySetAsync('ManifestSchema', `FBV~Type~EQ~RecordManifest~${partialMatch ? `FBV~SubType~LK~%25${ subType }%25` : `FBV~SubType~EQ~${ subType }` }`);
		}
		if (partialMatch)
		{
			const output = [];
			for (let m of Object.keys(this.manifestCache.ManifestSchema))
			{
				if (m.includes(subType))
				{
					output.push(this.manifestCache.ManifestSchema[m]);
				}
			}
			return output;
		}
		return this.manifestCache.ManifestSchema[subType] ? [this.manifestCache.ManifestSchema[subType]] : [];
	}

	async _getManifestSchemaPartials(IDManifestSchemaPartials)
	{
		if (!this.cacheInitialized)
		{
			return await this._getEntitySetAsync('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${ IDManifestSchemaPartials.join(',') }`);
		}
		let output = [];
		for (let id of IDManifestSchemaPartials)
		{
			if (this.manifestCache.ManifestSchemaPartial[id])
			{
				output.push(this.manifestCache.ManifestSchemaPartial[id]);
			}
		}
		return output;
	}

	async _getManifestSchemaPartialJoins(IDManifestSchema)
	{
		if (!this.cacheInitialized)
		{
			return await this._getEntitySetAsync('ManifestSchemaManifestSchemaPartialJoin', `FBV~IDManifestSchema~EQ~${ IDManifestSchema }`);
		}
		if (this.manifestCache.ManifestSchemaPartialJoin[IDManifestSchema])
		{
			return this.manifestCache.ManifestSchemaPartialJoin[IDManifestSchema];
		}
		return [];
	}

	async validate()
	{
		const rnis = await this._get(`ReportNamedInstancesByProject/9898/0/250`);
		for (const rni of rnis)
		{
			const fullManifest = rni.Options.FormDefinition;
			if (!fullManifest)
			{
				continue;
			}
			const newPipelineManifest = await this._loadFormManifest(rni);
			const baseSchema = await this._get(`ManifestSchemas/By/Hash/${rni.Hash.toLocaleLowerCase()}`).then((schemas) => schemas[0]);
			if (!baseSchema)
			{
				this.fable.log.info(`ERROR: No base schema for ${rni.Hash}`);
				continue;
			}
			delete rni.Options.FormDefinition;
			rni.Options.FormManifestSchemaID = baseSchema.IDManifestSchema;
			const newPipelineMergedManifest = await this._loadFormManifest(rni, (uri) => this._get(uri));
			const diff = JsonDiff.diffString(newPipelineManifest, newPipelineMergedManifest);
			this.fable.log.info(`Diff for ${rni.Hash}: ${diff}`);
			/*
			const newManifestString = JSON.stringify(newPipelineManifest, null, 2);
			const newMergedManifestString = JSON.stringify(newPipelineMergedManifest, null, 2);
			const fullManifestString = JSON.stringify(fullManifest, null, 2);
			if (newManifestString !== fullManifestString)
			{
				this.fable.log.info(`Mismatch for ${rni.Hash}`);
				this.fable.log.info(`New: ${newManifestString}`);
				this.fable.log.info(`Old: ${fullManifestString}`);
			}
			if (newManifestString !== newMergedManifestString)
			{
				this.fable.log.info(`Mismatch for ${rni.Hash}`);
				this.fable.log.info(`New: ${newManifestString}`);
				this.fable.log.info(`Merged: ${newMergedManifestString}`);
			}
			*/
		}
	}

	/**
	 * @param {string} form - the form name
	 * @param {string} descriptorKey - the descriptor key
	 * @param {any} descriptor - the descriptor object
	 * @param {string} [context] - the context - ie. which manifest or sub-manifest this descriptor is from
	 */
	sanityCheckDescriptor(form, descriptorKey, descriptor, context = 'Root Manifest')
	{
		let result = false;
		if (descriptorKey.includes(' ') || descriptorKey.includes('\t'))
		{
			this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has spaces in key.`);
			result = true;
		}

		if (!descriptor.Hash || typeof descriptor.Hash !== 'string')
		{
			this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has no Hash.`, { descriptor });
			result = true;
		}
		else if (descriptor.Hash.includes('.') || descriptor.Hash.includes(' '))
		{
			this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has Hash with illegal character.`, { descriptor });
			result = true;
		}

		if (Array.isArray(descriptor.PictForm?.SelectOptions))
		{
			const options = descriptor.PictForm.SelectOptions;
			const optionCount = options.length;
			const uniqueOptions = new Set(options.map((o) => o.id));
			if (uniqueOptions.size !== optionCount)
			{
				this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has duplicate SelectOptions ids.`, { options });
				result = true;
			}
			for (const option of options)
			{
				if (!option.id)
				{
					this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has SelectOption without id.`, { option });
					result = true;
				}
				if (!option.text)
				{
					this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has SelectOption without text.`, { option });
					result = true;
				}
				if (option.id == option.text && option.id.includes(' '))
				{
					this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has SelectOption with probably overspecified id`, { option });
					result = true;
				}
			}
			/* I used this to print all the select lists for Victoria
			this.fable.log.info(`DESCRIPTOR: Form [${form}] [${context}] Descriptor [${descriptorKey}] has ${optionCount} SelectOptions:`);
			for (const option of options)
			{
				this.fable.log.info(`DESCRIPTOR: ${option.id}: ${option.text}`);
			}
			*/
		}
		return result;
	}

	/**
	 * @param {any} manifest - the manifest to check
	 * @param {string} name - the name of the manifest
	 */
	checkManifestForAddressConflicts(manifest, name)
	{
		let result = false;
		const addresses = new Set();
		for (const [ key, descriptor ] of Object.entries(manifest.Descriptors || { }))
		{
			if (addresses.has(key))
			{
				this.fable.log.info(`[WARN] ${name} has duplicate DataAddress [${key}].`, { key, descriptor });
				result = true;
			}
			const sliced = key.split('.');
			while (sliced.length > 1)
			{
				sliced.pop();
				const prefix = sliced.join('.');
				if (addresses.has(prefix))
				{
					const conflict = manifest.Descriptors[prefix];
					this.fable.log.info(`[WARN] ${name} has conflicting DataAddress [${key}] with descriptor at [${prefix}].`, { key, descriptor, conflict });
					result = true;
				}
			}
			addresses.add(key);
		}
		return result;
	}

	/**
	 * @param {string} file - the file path
	 * @return {string} the guessed form name
	 */
	_guessFormName(file)
	{
		const candidates = Path.dirname(file).split(Path.sep);
		while (candidates.length > 0)
		{
			const candidate = candidates.pop();
			if (candidate !== 'source' && candidate.toLowerCase() != 'tmp')
			{
				return candidate;
			}
		}
		return null;
	}

	/**
	 * @param {string} globPath - the glob path to search
	 * @return {Array<ManifestInfo>} the manifest info
	findManifests(globPath)
	{
		const paths = [];
		for (const file of Glob.globSync(globPath, { absolute: true }))
		{
			this.fable.log.info(`Found candidate manifest: ${file}`);
			const wrproducterManifestData = require(file);
			const data = wrproducterManifestData.DefaultFormManifest;
			if (!data)
			{
				this.fable.log.info(`[WARN] No DefaultFormManifest in [${file}]; skipping.`);
				continue;
			}
			paths.push({ path: file, name: this._guessFormName(file), data }) || wrproducterManifestData.DefaultFormManifest.Form || 'uknknown-form';
		}
		return paths;
	}
	 */

	/**
	 * @param {ManifestInfo} manifestInfo - the manifest info
	 * @param {any} comprehension - the comprehension object
	 * @return {boolean} true if problems were found, otherwise false
	 */
	addManifestToComprehension(manifestInfo, comprehension)
	{
		const manifestSchema =
		{
			GUIDManifestSchema: manifestInfo.name,
			Hash: manifestInfo.name,
			Type: 'Form',
			Title: manifestInfo.name,
			Version: 1, //FIXME: version awareness - and Version in GUID
			Description: '',
			Manifest:
			{
				Descriptors: {},
			},
		};
		// copy over any key that isn't part of the three processed by this script
		for (const manifestKey of Object.keys(manifestInfo.data))
		{
			if (manifestKey === 'Descriptors' || manifestKey === 'Sections' || manifestKey === 'ReferenceManifests')
			{
				continue;
			}
			manifestSchema.Manifest[manifestKey] = manifestInfo.data[manifestKey];
		}
		// new manifest per section
		// split the desceriptors by section
		// split the ReferenceManifests by <tk logic>
		const referenceManifestMap = {};
		const seenManifests = new Set();
		const descriptorSectionKeys = new Set();
		const descriptorMap = {};
		const declarationDescriptors = []; // contains descriptors without a section - they are presumed to be declarations
		const declarationDescriptorKeys = new Set();
		const fieldDescriptorKeys = new Set();
		const sectionKeys = new Set();
		const orderedSectionHashes = [];
		const includeBySection = {};
		if (Array.isArray(manifestInfo.data.Sections))
		{
			for (const section of manifestInfo.data.Sections)
			{
				if (typeof section.Hash === 'string')
				{
					if (!sectionKeys.has(section.Hash))
					{
						orderedSectionHashes.push(section.Hash);
						sectionKeys.add(section.Hash);
					}
				}
			}
		}
		let problems = this.checkManifestForAddressConflicts(manifestInfo.data, 'Root Manifest');
		for (const [ descriptorKey, descriptor ] of Object.entries(manifestInfo.data.Descriptors))
		{
			if (descriptorKey !== descriptor.DataAddress)
			{
				this.fable.log.info(`[WARN] Descriptor hash mismatch [${descriptorKey} != ${descriptor.DataAddress}].`, { descriptor });
			}

			descriptorMap[descriptorKey] = descriptor;

			this.sanityCheckDescriptor(manifestInfo.name, descriptorKey, descriptor);

			const sectionHash = descriptor.PictForm?.Section;
			if (typeof sectionHash !== 'string')
			{
				declarationDescriptors.push(descriptor);
				declarationDescriptorKeys.add(descriptorKey);
				continue;
			}
			descriptorSectionKeys.add(sectionHash);
			fieldDescriptorKeys.add(descriptorKey);

			if (!includeBySection[sectionHash])
			{
				includeBySection[sectionHash] = {};
			}
			if (!includeBySection[sectionHash].Descriptors)
			{
				includeBySection[sectionHash].Descriptors = {};
			}
			includeBySection[sectionHash].Descriptors[descriptorKey] = descriptor;
		}
		if (manifestInfo.data.ReferenceManifests)
		{
			for (const [ key, manifest ] of Object.entries(manifestInfo.data.ReferenceManifests))
			{
				problems = this.checkManifestForAddressConflicts(manifestInfo.data, key) || problems;
				referenceManifestMap[key] = manifest;
				for (const [ descriptorKey, descriptor ] of Object.entries(manifest.Descriptors || { }))
				{
					this.sanityCheckDescriptor(manifestInfo.name, descriptorKey, descriptor, `Reference Manifest ${key}`);
				}
			}
		}
		const allSolvers = {};
		const orphanedDeclarationDescriptorHashes = new Set(declarationDescriptorKeys);
		if (Array.isArray(manifestInfo.data.Sections))
		{
			for (const section of manifestInfo.data.Sections)
			{
				if (!section.Hash)
				{
					this.fable.log.info(`[ERROR] No hash for section; skipping.`, { section });
					continue;
				}
				if (!sectionKeys.has(section.Hash))
				{
					orderedSectionHashes.push(section.Hash);
					sectionKeys.add(section.Hash);
				}

				let recordSetCount = 0;
				if (Array.isArray(section.Groups))
				{
					for (const group of section.Groups)
					{
						if (group.RecordSetAddress)
						{
							if (declarationDescriptorKeys.has(group.RecordSetAddress))
							{
								if (!includeBySection[section.Hash])
								{
									includeBySection[section.Hash] = {};
								}
								if (!includeBySection[section.Hash].Descriptors)
								{
									includeBySection[section.Hash].Descriptors = {};
								}
								includeBySection[section.Hash].Descriptors[group.RecordSetAddress] = descriptorMap[group.RecordSetAddress];
								++recordSetCount;
								orphanedDeclarationDescriptorHashes.delete(group.RecordSetAddress);
							}
							else if (!fieldDescriptorKeys.has(group.RecordSetAddress))
							{
								this.fable.log.info(`[WARN] Section [${section.Hash}] Group [${group.Hash || group.Name || '--N/A--'}] RecordSetAddress [${group.RecordSetAddress}] has no matching declaration.`, { group });
							}
						}

						if (group.RecordManifest)
						{
							const referenceManifest = referenceManifestMap[group.RecordManifest];
							if (referenceManifest)
							{
								seenManifests.add(group.RecordManifest);

								if (!includeBySection[section.Hash])
								{
									includeBySection[section.Hash] = {};
								}
								if (!includeBySection[section.Hash].ReferenceManifests)
								{
									includeBySection[section.Hash].ReferenceManifests = {};
								}
								includeBySection[section.Hash].ReferenceManifests[group.RecordManifest] = referenceManifest;
							}
							else
							{
								this.fable.log.info(`[WARN] Section [${section.Hash}] Group [${group.Hash || group.Name || '--N/A--'}] RecordManifest [${group.RecordManifest}] not found.`, { group });
							}
						}
					}
				}
				if (recordSetCount == 0 && !descriptorSectionKeys.has(section.Hash))
				{
					this.fable.log.info(`[WARN] Section [${section.Hash}] exists but no descriptor has that section.`);
				}
				if (Array.isArray(section.Solvers))
				{
					allSolvers[section.Hash] = [];
					for (const solver of section.Solvers)
					{
						allSolvers[section.Hash].push(solver);
					}
				}
			}
		}
		if (orphanedDeclarationDescriptorHashes.size)
		{
			for (const address of Array.from(orphanedDeclarationDescriptorHashes))
			{
				const descriptor = descriptorMap[address];
				const matcher = this.getEscapedRegex(descriptor.Hash);
				const dependentSections = Object.entries(allSolvers).filter(([ sectionHash, solvers ]) => solvers.some((s) => s.match(matcher))).map(([ sectionHash ]) => manifestInfo.data.Sections.find((s) => s.Hash === sectionHash));
				if (!dependentSections.length)
				{
					this.fable.log.info(`[WARN] Orphaned declaration descriptor; including at root: [${descriptor.DataAddress}](${descriptor.Hash})`);
					manifestSchema.Manifest.Descriptors[address] = descriptor;
				}
				else
				{
					orphanedDeclarationDescriptorHashes.delete(address);
					for (const section of dependentSections)
					{
						if (!includeBySection[section.Hash])
						{
							includeBySection[section.Hash] = {};
						}
						if (!includeBySection[section.Hash].Descriptors)
						{
							includeBySection[section.Hash].Descriptors = {};
						}
						includeBySection[section.Hash].Descriptors[address] = descriptor;
					}
				}
			}
		}
		for (const refManifestKey of Object.keys(referenceManifestMap))
		{
			if (!seenManifests.has(refManifestKey))
			{
				this.fable.log.info(`[ERROR] ReferenceManifest [${refManifestKey}] not used.`);
			}
		}

		// generate export
		if (orderedSectionHashes.length < 1)
		{
			this.fable.log.info(`[WARN] No sections found for [${manifestInfo.name}]; skipping.`);
			return problems;
		}
		comprehension.ManifestSchema.push(manifestSchema);
		let ordinal = 0;
		for (const sectionHash of orderedSectionHashes)
		{
			++ordinal;
			const sectionManifest =
			{
				Descriptors: includeBySection[sectionHash]?.Descriptors || {},
				Sections: [],
				ReferenceManifests: includeBySection[sectionHash]?.ReferenceManifests || {},
			};
			const section = manifestInfo.data.Sections.find((s) => s.Hash === sectionHash);
			if (section)
			{
				sectionManifest.Sections.push(section);
			}
			const manifestSchemaPartial =
			{
				GUIDManifestSchemaPartial: `${manifestSchema.GUIDManifestSchema}-${sectionHash}`,
				Hash: sectionHash,
				Type: 'Section',
				Title: `[${manifestSchema.Title}] ${section.Name || sectionHash}`,
				Version: 1,
				Description: '',
				ManifestPartial: sectionManifest,
			};
			comprehension.ManifestSchemaPartial.push(manifestSchemaPartial);
			const manifestSchemaManifestSchemaPartialJoin =
			{
				GUIDManifestSchemaManifestSchemaPartialJoin: `${manifestSchema.GUIDManifestSchema}-${sectionHash}`,
				GUIDManifestSchema: manifestSchema.GUIDManifestSchema,
				GUIDManifestSchemaPartial: manifestSchemaPartial.GUIDManifestSchemaPartial,
				Ordinal: ordinal,
			};
			comprehension.ManifestSchemaManifestSchemaPartialJoin.push(manifestSchemaManifestSchemaPartialJoin);
		}
		return problems;
	}

	/**
	 * @typedef {Object} ManifestInfo
	 * @property {string} name - the name of the manifest
	 * @property {string} path - the path to the manifest
	 * @property {any} data - the manifest data
	 */

	/**
	 * @param {Array<ManifestInfo>} manifestInfos - the manifest info
	 */
	async generateComprehension(manifestInfos, comprehensionOutputPath = 'comprehension.json')
	{
		const comprehension =
		{
			ManifestSchema: [],
			ManifestSchemaPartial: [],
			ManifestSchemaManifestSchemaPartialJoin: [],
		};
		for (const manifestInfo of manifestInfos)
		{
			if (this.addManifestToComprehension(manifestInfo, comprehension))
			{
				this.fable.log.info(`[WARN] Problems found in [${manifestInfo.name}].`);
			}
		}
		this.fable.log.info('Writing output...');
		Fs.writeFileSync(comprehensionOutputPath, JSON.stringify(comprehension, null, 2));
		return Path.resolve(comprehensionOutputPath);
	}

	/**
	 * Generate a RegExp to match a string, escaping any special characters.
	 *
	 * @param {string} str - the string to match
	 * @return {RegExp} the escaped regex
	 */
	getEscapedRegex(str)
	{
		return new RegExp(`\\b${str.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}\\b`);
	}

	/*
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.options.CommandKeyword = 'load_comprehension';
		this.options.Description = 'Load a comprehension into Headlight.';

		this.options.Aliases.push('load');

		this.options.CommandArguments.push({ Name: '<comprehension_file>', Description: 'The comprehension file path.' });

		this.addCommand();

		if (!('HeadlightRestClient' in this.fable.services))
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', this.pict.ProgramConfiguration);
		}

		this.comprehension = {};
	}
	*/

	runAdapter(pAnticipate, pAdapter, pDataMap, fMarshalRecord)
	{
		let tmpAdapter = this.fable.servicesMap.IntegrationAdapter[pAdapter];
		let tmpMarshalRecordFunction = fMarshalRecord;
		if (!tmpAdapter)
		{
			throw new Error(`Adapter [${pAdapter}] not found.`);
		}
		if (!pDataMap)
		{
			this.log.info(`No records to push for [${pAdapter}].`);
			return false;
		}
		pAnticipate.anticipate(
			(fDone) =>
			{
				for (const tmpRecord in pDataMap)
				{
					tmpAdapter.addSourceRecord(pDataMap[tmpRecord]);
				}
				return fDone()
			});
		pAnticipate.anticipate(
			(fDone) =>
			{
				tmpAdapter.integrateRecords(fDone, tmpMarshalRecordFunction);
			});
	}

	getCapitalLettersAsString(inputString)
	{
		let tmpRegex = /[A-Z]/g;
		let tmpMatch = inputString.match(tmpRegex);
		let tmpString = tmpMatch ? tmpMatch.join('') : 'UNK';
		return tmpString;
	}

	pushComprehension(pComprehensionFilePath, fCallback)
	{
		let tmpAnticipate = this.fable.newAnticipate();
		this.fable.log.info(`Pushing comprehension file [${pComprehensionFilePath}] to the Headlight API.`);

		this.fable.log.info(`Initializing and configuring data integration adapters...`);
		this.fable.serviceManager.addServiceType('IntegrationAdapter', IntegrationAdapter);

		/*
		 * TODO: is this necessary?
		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				this.fable.HeadlightRestClient.authenticate(
					(pError, pResponse) =>
					{
						if (pError)
						{
							this.log.error(`Error authenticating`, pError);
							return fCallback(typeof pError === 'string' ? new Error(pError) : pError);
						}
						this.log.info(`Authenticated - Session [${pResponse.SessionID}]`);
						return fCallback();
					});
			});
		 */

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				try
				{
					this.fable.log.info(`Loading Comprehension File...`);
					this.comprehension = require(pComprehensionFilePath);
					return fCallback();
				}
				catch(pError)
				{
					this.fable.log.error(`Error loading comprehension file [${pComprehensionFilePath}]: ${pError}`, pError);
					return fCallback(pError);
				}
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				this.fable.log.info(`Wiring up Integration Adapters...`);

				let tmpIntegrationAdapterSet = Object.keys(this.comprehension);

				for (let i = 0; i < tmpIntegrationAdapterSet.length; i++)
				{
					// Initialize the adapter
					let tmpAdapterKey = tmpIntegrationAdapterSet[i];
					IntegrationAdapter.getAdapter(this.fable, tmpAdapterKey, this.getCapitalLettersAsString(tmpAdapterKey), { SimpleMarshal: true });
					this.runAdapter(tmpAnticipate, tmpAdapterKey, this.comprehension[tmpAdapterKey]);
				}

				return fCallback();
			});

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error importing comprehension file.`, pError);
					return fCallback(pError);
				}
				this.fable.log.info(`Finished importing comprehension file.`);
				return fCallback();
			});
	}
}

module.exports = ManifestPackagingService;

},{"fable-serviceproviderbase":398,"fs":321,"headlight-integration-adapter":7,"headlight-rest-client":12,"json-diff":440,"path":468}],15:[function(require,module,exports){

const SALT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

const Util = require('util');

const libFableServiceProviderBase = require('fable-serviceproviderbase');

const MaterialsLabRouter = require('./Materials-Lab-Router.js');

/**
 * Customer-agnostic substring patterns identifying LIMS-managed report named instances.
 *
 * Heuristic. The customer prefix segment (e.g. 'LADOTD') is intentionally excluded so the
 * check works across customers; future iterations should migrate to a structural marker
 * such as a ReportArchetype-driven membership lookup.
 *
 * @type {ReadonlyArray<string>}
 */
const LIMS_GUID_PATTERNS = Object.freeze([ 'LIMS-ContainerForm', '-MSP-', '-RNI-SO-' ]);
// Backstop for the IDMaterialParent walk — no FK prevents a cyclic/runaway chain.
const MAX_MATERIAL_PARENT_DEPTH = 16;

// Sample-level lab selector InputTypes seeded by _setSampleLabsInDocument. Deliberately excludes the
// per-test lab inputs (MaterialsTestLabSelector / MaterialsTestLabPicker) and the display-only variants.
const LAB_SELECTOR_INPUT_TYPES = Object.freeze([ 'MaterialsLabSelector', 'MaterialsLabPicker', 'LabSelector' ]);
// Long-lived instances (the pict web apps register this service once per page
// session) must pick up LabTestSpecificationSetJoin changes without a reload.
const DEFAULT_ALLOWED_LAB_SCOPE_CACHE_TTL_SECONDS = 60;

/**
 * @param {string} pGUIDReportNamedInstance
 * @return {boolean} true if the GUID matches the LIMS-form heuristic
 */
const isLIMSForm = (pGUIDReportNamedInstance) =>
{
	if (typeof pGUIDReportNamedInstance !== 'string')
	{
		return false;
	}
	for (const tmpPattern of LIMS_GUID_PATTERNS)
	{
		if (pGUIDReportNamedInstance.indexOf(tmpPattern) >= 0)
		{
			return true;
		}
	}
	return false;
};

/**
 * @typedef {object} FormGroupContext
 * @property {Record<string, any>} [ConciergeConfig] - Resolved ConciergeDefaults/Sample
 *   config for the project (e.g. `{ Hashes: ['...'], Enabled: true, CreatePerLab: false }`).
 *   When present, group membership unions any RNI whose Hash appears in `ConciergeConfig.Hashes`.
 */

/**
 * @typedef {object} FormGroupDescriptor
 * @property {string} Identifier - Stable machine identifier for the group
 * @property {string} Name - Human display name
 * @property {string} Description - Short description for the bulk-add UI
 * @property {(pAvailableRNIs: Array<Record<string, any>>, pContext?: FormGroupContext) => Array<Record<string, any>>} getMembers
 *   - Filter `pAvailableRNIs` to the subset belonging to this group given the project context.
 */

/**
 * Resolve the set of RNIs that should be treated as LIMS-managed for a given project context.
 *
 * Union of:
 *   - heuristic match: GUID/Hash contains a `LIMS_GUID_PATTERNS` substring
 *   - configured extras: `pContext.ConciergeConfig.Hashes` — the project-level "extra forms"
 *     list the materials API auto-creates on each sample sync regardless of whether they
 *     match the GUID heuristic. See SampleTestController.syncSampleTests's
 *     `tmpDefaultFormConfigs.Hashes` block.
 *
 * @param {Array<Record<string, any>>} pAvailableRNIs - candidate RNIs (typically the project's available list)
 * @param {FormGroupContext} [pContext]
 * @return {Array<Record<string, any>>} subset of pAvailableRNIs that are LIMS-managed in the given context
 */
const getLIMSFormCandidates = (pAvailableRNIs, pContext) =>
{
	if (!Array.isArray(pAvailableRNIs))
	{
		return [];
	}
	const tmpExtraHashesSource = pContext && pContext.ConciergeConfig && pContext.ConciergeConfig.Hashes;
	const tmpExtraHashes = new Set(Array.isArray(tmpExtraHashesSource) ? tmpExtraHashesSource : []);
	return pAvailableRNIs.filter((pRNI) =>
	{
		if (!pRNI)
		{
			return false;
		}
		if (isLIMSForm(pRNI.GUIDReportNamedInstance) || isLIMSForm(pRNI.Hash))
		{
			return true;
		}
		if (pRNI.Hash && tmpExtraHashes.has(pRNI.Hash))
		{
			return true;
		}
		return false;
	});
};

/**
 * Registry of named report-named-instance groups consumable by tooling that wants to
 * present forms in semantic clusters (e.g. the forms-editor bulk-add modal).
 *
 * Group descriptors expose `getMembers(pAvailableRNIs, pContext)` rather than a static
 * predicate so groups whose membership depends on project-level state (e.g. LIMS, where
 * "extra forms" are configured per-project via ConciergeDefaults/Sample.Hashes) can
 * resolve correctly. Groups with purely static membership simply ignore `pContext`.
 *
 * @type {Readonly<Record<string, FormGroupDescriptor>>}
 */
const FORM_GROUPS = Object.freeze(
{
	LIMS: Object.freeze(
	{
		Identifier: 'LIMS',
		Name: 'LIMS Forms',
		Description: 'Forms managed by the Lab Information Management System concierge auto-creation pipeline.',
		getMembers: getLIMSFormCandidates,
	}),
});

class MaterialsFormManager extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the adapter
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client'), AppData: Record<string, any> }} */
		this.fable;

		if (!this.fable.AppData)
		{
			this.fable.AppData = {};
		}
		/** @type {import('headlight-rest-client')} */
		this._Client = null;

		this.serviceType = 'MaterialsFormManager';
		this.fable.addServiceType('ManifestPackagingService', require('manifest-packaging-service'));
		this.fable.instantiateServiceProviderIfNotExists('ManifestPackagingService', require('manifest-packaging-service'));

		/** @type {Record<number, { CachedAt: number, AllowedLabIDs: Set<number>|null }>} */
		this._AllowedLabIDsByContract = {};

		/** @type {MaterialsLabRouter|null} */
		this._LabRouter = null;
	}

	/**
	 * The lab router deciding which lab a sample ships to and which bench runs each of its tests.
	 *
	 * A customer needing behavior the declarative `LabRouting` rules cannot express names a registered fable
	 * service in `LabRouting.ResolverService`; it must answer `selectSampleLabID` / `selectTestLabID` with
	 * the same shape. An unresolvable name falls back to the built-in router rather than failing the sync.
	 *
	 * @param {Record<string, any>} [pLabRoutingConfig] - the ConciergeDefaults `LabRouting` block
	 *
	 * @return {MaterialsLabRouter}
	 */
	getLabRouter(pLabRoutingConfig)
	{
		if (this._LabRouter)
		{
			return this._LabRouter;
		}
		const tmpResolverService = pLabRoutingConfig && pLabRoutingConfig.ResolverService;
		if (tmpResolverService)
		{
			let tmpCustomRouter = this.fable.services[tmpResolverService];
			if (!tmpCustomRouter && (tmpResolverService in this.fable.serviceManager.servicesMap))
			{
				tmpCustomRouter = this.fable.serviceManager.instantiateServiceProvider(tmpResolverService, this.options);
			}
			if (tmpCustomRouter && typeof tmpCustomRouter.selectTestLabID === 'function')
			{
				this.fable.log.info(`Lab routing is delegated to the customer resolver service '${tmpResolverService}'.`);
				this._LabRouter = tmpCustomRouter;
			}
			else
			{
				this.fable.log.warn(`Lab routing resolver service '${tmpResolverService}' is not registered (or does not implement selectTestLabID); using the built-in router.`);
			}
		}
		if (!this._LabRouter)
		{
			this._LabRouter = new MaterialsLabRouter(this.fable, this.options);
		}
		// Bound lazily rather than at construction so the router reads through whatever session the manager
		// is impersonating at call time.
		this._LabRouter.setDataReaders(
			{
				get: (pURI) => this._get(pURI),
				getAll: (pURI) => this._getAll(pURI),
			});
		return this._LabRouter;
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		if (this.options.UseSiloedClient)
		{
			if (!this._Client)
			{
				this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
				this._Client = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', this.options);
			}
			return this._Client;
		}

		let tmpClient = this.fable.services.HeadlightRestClient;
		if (!tmpClient)
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			tmpClient = this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', this.options);
		}
		return tmpClient;
	}

	/**
	 * Async wrapper for HTTP get.
	 *
	 * @param {String} uri The URI to get.
	 *
	 * @return {Promise<any>} The result of the get.
	 */
	async _get(uri)
	{
		this.fable.log.info(`GET ${uri}`);
		return Util.promisify(this.client.getJSON.bind(this.client))(uri);
	}

	/**
	 * @param {String} pURI
	 * @param {number} [pPageSize=250]
	 *
	 * @return {Promise<Array<any>>}
	 */
	async _getAll(pURI, pPageSize = 250)
	{
		let tmpResults = [];
		let tmpOffset = 0;
		let tmpPage;
		do
		{
			const tmpPageURI = `${pURI}/${tmpOffset}/${pPageSize}`;
			tmpPage = await this._get(tmpPageURI);
			if (!Array.isArray(tmpPage))
			{
				throw new Error(`Expected array response from GET ${tmpPageURI}`);
			}
			tmpResults = tmpResults.concat(tmpPage);
			tmpOffset += pPageSize;
		}
		while (tmpPage.length >= pPageSize);
		return tmpResults;
	}

	/**
	 * Async wrapper for HTTP put.
	 *
	 * @param {String} uri The URI to put to.
	 * @param {any} payload The payload to put (as JSON).
	 *
	 * @return {Promise<any>} The result of the put.
	 */
	async _put(uri, payload)
	{
		this.fable.log.info(`PUT ${uri}`, { payload });
		return Util.promisify(this.client.putJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP post.
	 *
	 * @param {String} uri The URI to post to.
	 * @param {any} payload The payload to post (as JSON).
	 *
	 * @return {Promise<Object>} The result of the post.
	 */
	async _post(uri, payload)
	{
		this.fable.log.info(`POST ${uri}`, { payload });
		return Util.promisify(this.client.postJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP delete.
	 *
	 * @param {string} entityType The entity type to delete.
	 * @param {string|number} entityID The entity ID to delete.
	 *
	 * @return {Promise<Object>} The result of the delete.
	 */
	async _deleteEntity(entityType, entityID)
	{
		this.fable.log.info(`DELETE ${entityType}:${entityID}`, { entityType, entityID });
		return Util.promisify(this.client.deleteEntity.bind(this.client))(entityType, entityID);
	}

	/**
	 * @param {Record<string, any>} pManifestSchema
	 *
	 * @return {void}
	 */
	_decorateManifestSchema(pManifestSchema)
	{
		switch (pManifestSchema.Type)
		{
			case 'Test':
				pManifestSchema.DisplayName = `Test Hash: ${pManifestSchema.SubType}`;
				pManifestSchema.TestHash = pManifestSchema.SubType;
				break;
			case 'Header':
				pManifestSchema.DisplayName = `Form Header: ${pManifestSchema.Title}`;
				break;
			case 'Footer':
				pManifestSchema.DisplayName = `Form Footer: ${pManifestSchema.Title}`;
				break;
			default:
				pManifestSchema.DisplayName = pManifestSchema.Title;
		}
		pManifestSchema.Enabled = true;
	}

	// things we need:
	// * get default manifests for a given IDMaterial
	// * get available RNIs and extract test and material mappings?
	//   * TODO: how do we map materials to RNIs? maybe we can put that in the RNI for now? but not long term
	// * return a summary of tests for a given material so it can be visualized
	// * function to apply a subset of the tests (manifests to one or more documents, RNIs as new forms)

	/**
	 * @param {Array<number>} pIDMaterials
	 *
	 * @return {Promise<Array<Record<string, any>>>} The manifests for the given IDMaterial
	 */
	async getManifestsForIDMaterial(pIDMaterials)
	{
		// load MaterialManifestSetJoins for given IDMaterial
		const tmpMaterialManifestSetJoins = await this._getAll(`MaterialManifestSetJoins/FilteredTo/FBL~IDMaterial~INN~${pIDMaterials}`);
		// then load ManifestSets recursively using ManifestSetManifestSetJoin
		let tmpManifestSets = await this._getAll(`ManifestSets/FilteredTo/FBL~IDManifestSet~INN~${tmpMaterialManifestSetJoins.map((join) => join.IDManifestSet).join(',')}`);
		let tmpManifestSchemas = [];
		if (tmpManifestSets.length > 0)
		{
			let tmpLoadedJoins;
			let tmpManifestSetIDs = tmpManifestSets.map((ms) => ms.IDManifestSet);
			const tmpSeenManifestSetIDs = new Set(tmpManifestSetIDs);
			let tmp
			do
			{
				tmpLoadedJoins = await this._getAll(`ManifestSetManifestSetJoins/FilteredTo/FBL~IDManifestSet~INN~${tmpManifestSetIDs.map((ms) => ms.IDManifestSet).join(',')}~FSF~Ordinal~ASC~0`);
				tmpManifestSetIDs = tmpLoadedJoins.map((join) => join.IncludedIDManifestSet).filter((id) => !tmpSeenManifestSetIDs.has(id));
				tmpManifestSetIDs.forEach((id) => tmpSeenManifestSetIDs.add(id));
				if (tmpManifestSetIDs.length > 0)
				{
					tmpManifestSets = tmpManifestSets.concat(await this._getAll(`ManifestSets/FilteredTo/FBL~IDManifestSet~INN~${tmpManifestSetIDs.join(',')}`));
				}
			}
			while (tmpLoadedJoins.length > 0);

			// load ManifestSetManifestSchemaJoins in bulk for the loaded ManifestSets
			const tmpManifestSetManifestSchemaJoins = await this._getAll(`ManifestSetManifestSchemaJoins/FilteredTo/FBL~IDManifestSet~INN~${tmpManifestSets.map((ms) => ms.IDManifestSet).join(',')}~FSF~Ordinal~ASC~0`);
			//FIXME: sort the sets then joins by Ordinal to enforce order on the returned records
			// load ManifestSchema records as we go using ManifestSetManifestSchemaJoin
			tmpManifestSchemas = await this._getAll(`ManifestSchemas/FilteredTo/FBL~IDManifestSchema~INN~${tmpManifestSetManifestSchemaJoins.map((join) => join.IDManifestSchema).join(',')}`);
		}
		// format the results (decide the shape)a
		for (const tmpManifestSchema of tmpManifestSchemas)
		{
			tmpManifestSchema.Enabled = true;
			this._decorateManifestSchema(tmpManifestSchema);
		}
		return tmpManifestSchemas;
	}

	/**
	 * @param {number|string} [pIDProject]
	 *
	 * @return {Promise<Array<Record<string, any>>>} The available RNIs for the given project
	 */
	async _getAvailableRNIs(pIDProject)
	{
		const tmpIDProject = pIDProject ? pIDProject : await this._get(`Projects/0/1`).then((res) => res[0].IDProject);
		if (!tmpIDProject)
		{
			throw new Error(`Could not determine a valid project ID to load RNIs for.`);
		}
		return this._getAll(`ReportNamedInstancesByProject/${tmpIDProject}`, 100);
	}

	/**
	 * Walk a material up its IDMaterialParent chain, returning the material and
	 * every ancestor (so tests/labs assigned to a parent material flow through to
	 * a child-material sample). The walk is guarded against cyclic or
	 * self-referential IDMaterialParent data (no FK prevents it): a repeat id or
	 * the depth cap stops the walk and logs, degrading to "use what we walked"
	 * rather than looping forever.
	 *
	 * @param {number} pIDMaterial
	 *
	 * @return {Promise<Array<number>>} The given material and its parent materials
	 */
	async _resolveMaterialParents(pIDMaterial)
	{
		let tmpIDMaterial = pIDMaterial;
		const tmpMaterialIDs = [];
		const tmpVisited = new Set();
		while (tmpIDMaterial && !tmpVisited.has(tmpIDMaterial) && tmpMaterialIDs.length < MAX_MATERIAL_PARENT_DEPTH)
		{
			tmpVisited.add(tmpIDMaterial);
			tmpMaterialIDs.push(tmpIDMaterial);
			const tmpMaterialRecord = await this._get(`Material/${tmpIDMaterial}`);
			//TODO: if the starting material doesn't exist, do we want to throw?
			tmpIDMaterial = tmpMaterialRecord && tmpMaterialRecord.IDMaterialParent;
		}
		if (tmpIDMaterial && tmpVisited.has(tmpIDMaterial))
		{
			this.fable.log.warn(`Material parent chain for ${pIDMaterial} hit a cycle at material ${tmpIDMaterial}; stopping walk`, { ResolvedMaterialIDs: tmpMaterialIDs });
		}
		else if (tmpIDMaterial && tmpMaterialIDs.length >= MAX_MATERIAL_PARENT_DEPTH)
		{
			this.fable.log.warn(`Material parent chain for ${pIDMaterial} exceeded depth ${MAX_MATERIAL_PARENT_DEPTH}; stopping walk`, { ResolvedMaterialIDs: tmpMaterialIDs });
		}
		return tmpMaterialIDs;
	}

	/**
	 * Index rows carrying `IDTest` + `IDLab` (TestLabJoin, LabTestDefault) into the per-test lab sets the
	 * router narrows with.
	 *
	 * @param {Array<Record<string, any>>} pRows
	 *
	 * @return {Record<string, Set<number>>}
	 */
	_indexLabIDsByTest(pRows)
	{
		/** @type {Record<string, Set<number>>} */
		const tmpIndex = {};
		for (const tmpRow of (pRows || []))
		{
			const tmpIDTest = (tmpRow.IDTest === null || tmpRow.IDTest === undefined) ? '' : String(tmpRow.IDTest).trim();
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDTest === '' || !(tmpIDLab > 0))
			{
				continue;
			}
			if (!tmpIndex[tmpIDTest])
			{
				tmpIndex[tmpIDTest] = new Set();
			}
			tmpIndex[tmpIDTest].add(tmpIDLab);
		}
		return tmpIndex;
	}

	/**
	 * @param {number|string} pIDSample
	 *
	 * @return {Promise<Array<number>>} The lab IDs associated with the sample
	 */
	async getSampleLabIDs(pIDSample)
	{
		return this._getAll(`SampleLabJoins/FilteredTo/FBV~IDSample~EQ~${pIDSample}`).then((res) => res.map((join) => join.IDLab));
	}

	/**
	 * Resolve the contract's materials specification set ID. The explicit
	 * MaterialIDTestSpecificationSet FK wins; when unset, fall back to matching a
	 * TestSpecificationSet by the contract's MaterialsSpecificationYear.
	 *
	 * @param {Record<string, any>} pContract
	 * @return {Promise<number>} The set ID, or 0 when the contract references none
	 */
	async _resolveMaterialSpecificationSetID(pContract)
	{
		if (pContract.MaterialIDTestSpecificationSet > 0)
		{
			return pContract.MaterialIDTestSpecificationSet;
		}
		const tmpYear = pContract.MaterialsSpecificationYear == null ? '' : String(pContract.MaterialsSpecificationYear).trim();
		if (tmpYear === '' || tmpYear === '0')
		{
			return 0;
		}
		// A year is NOT unique: a customer may run a provisional set alongside the live one for the same year,
		// and nothing on TestSpecificationSet distinguishes them. Lowest id — the earliest set for the year —
		// is the stable pick; an ambiguous year is logged rather than resolved silently.
		const tmpSets = await this._getAll(`TestSpecificationSets/FilteredTo/FBV~IDCustomer~EQ~${pContract.IDCustomer}~FBV~Year~EQ~${encodeURIComponent(tmpYear)}~FSF~IDTestSpecificationSet~ASC~0`);
		if (tmpSets.length > 1)
		{
			this.fable.log.warn(`Specification year ${tmpYear} matches ${tmpSets.length} specification sets for customer ${pContract.IDCustomer}; using the lowest id (${tmpSets[0].IDTestSpecificationSet}). Set the contract's MaterialIDTestSpecificationSet to resolve this explicitly.`);
		}
		return tmpSets.length > 0 ? tmpSets[0].IDTestSpecificationSet : 0;
	}

	/**
	 * Labs assignable under the contract's materials specification set, per
	 * LabTestSpecificationSetJoin. Fails open — returns null (no constraint) when
	 * the contract resolves no materials set, the set has no lab joins, or the
	 * read fails — matching the sample form's lab-picker scoping.
	 *
	 * Cached per contract for options.AllowedLabScopeCacheTTLSeconds (default 60).
	 *
	 * @param {Record<string, any>} pContract
	 * @return {Promise<Set<number>|null>} Allowed lab IDs, or null when unconstrained
	 */
	async getAllowedLabIDsForContract(pContract)
	{
		if (!pContract || !(pContract.IDContract > 0))
		{
			return null;
		}
		const tmpTTLSeconds = (typeof this.options.AllowedLabScopeCacheTTLSeconds === 'number') ? this.options.AllowedLabScopeCacheTTLSeconds : DEFAULT_ALLOWED_LAB_SCOPE_CACHE_TTL_SECONDS;
		const tmpCacheEntry = this._AllowedLabIDsByContract[pContract.IDContract];
		if (tmpCacheEntry && (Date.now() - tmpCacheEntry.CachedAt) < (tmpTTLSeconds * 1000))
		{
			return tmpCacheEntry.AllowedLabIDs;
		}
		let tmpAllowedLabIDs = null;
		try
		{
			const tmpSpecSetID = await this._resolveMaterialSpecificationSetID(pContract);
			if (tmpSpecSetID > 0)
			{
				const tmpJoins = await this._getAll(`LabTestSpecificationSetJoins/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpSpecSetID}`);
				const tmpJoinedLabIDs = new Set(tmpJoins.map((pJoin) => pJoin.IDLab).filter((pIDLab) => pIDLab > 0));
				if (tmpJoinedLabIDs.size > 0)
				{
					tmpAllowedLabIDs = tmpJoinedLabIDs;
				}
			}
		}
		catch (pError)
		{
			this.fable.log.warn(`Failed to resolve the assignable-lab scope for contract ${pContract.IDContract}; failing open: ${pError.message}`);
		}
		this._AllowedLabIDsByContract[pContract.IDContract] = { CachedAt: Date.now(), AllowedLabIDs: tmpAllowedLabIDs };
		return tmpAllowedLabIDs;
	}

	/**
	 * Resolve the default lab for a material and sample type using LabTestDefaults.
	 * This mirrors the auto-select toggle behavior in the materials-sampletracking app's
	 * distilled-field component, which determines default labs from LabTestDefault records
	 * and resolves them to their parent lab ID.
	 *
	 * When a project is provided, candidates are constrained to the contract's
	 * materials-specification-set lab joins (see getAllowedLabIDsForContract); a
	 * candidate qualifies when it or its parent lab is joined.
	 *
	 * @param {number} pIDMaterial - The material ID
	 * @param {string} [pSampleType='ACPT'] - The sample type
	 * @param {number} [pIDProject=0] - Project whose contract scopes assignable labs
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 *
	 * @return {Promise<number>} The default parent lab ID, or 0 if none found
	 */
	async getDefaultLabForMaterial(pIDMaterial, pSampleType = 'ACPT', pIDProject = 0, pConciergeConfig = undefined)
	{
		const tmpResult = await this.getDefaultLabForMaterialWithDiagnostics(pIDMaterial, pSampleType, pIDProject, pConciergeConfig);
		return tmpResult.IDLab;
	}

	/**
	 * Same resolution as {@link getDefaultLabForMaterial}, but surfaces the bare-0
	 * causes as a structured Reason so callers can report why no default applied:
	 *   'OK'                        — a default parent lab resolved
	 *   'NoDefaults'                — no LabTestDefault (or lab record) for the material/sample-type,
	 *                                 and no routing rule named a lab for the project either
	 *   'ExcludedBySpecSetLabJoins' — defaults exist, but every candidate lab falls
	 *                                 outside the contract's materials-specification-set lab joins
	 *
	 * Which of several candidates wins is decided by the lab router: a parent lab the project's routing
	 * rules name (its district laboratory before its field unit, for a DOT) outranks one of the project's
	 * own joined labs, which outranks the first candidate the read happened to return. With routing rules
	 * configured this also answers where it previously could not — a material carrying no LabTestDefault
	 * still ships to the project's own lab — so configuring them only ever ADDS defaulting.
	 *
	 * @param {number} pIDMaterial - The material ID
	 * @param {string} [pSampleType='ACPT'] - The sample type
	 * @param {number} [pIDProject=0] - Project whose contract scopes assignable labs
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 *
	 * @return {Promise<{ IDLab: number, Reason: string, CandidateLabIDs: Array<number>, Source: string }>}
	 */
	async getDefaultLabForMaterialWithDiagnostics(pIDMaterial, pSampleType = 'ACPT', pIDProject = 0, pConciergeConfig = undefined)
	{
		const tmpLabRoutingConfig = pConciergeConfig && pConciergeConfig.LabRouting;
		const tmpRouter = this.getLabRouter(tmpLabRoutingConfig);
		const tmpAffinityRootIDs = await tmpRouter.getAffinityRootIDs(pIDProject, tmpLabRoutingConfig);
		const tmpProjectRootLabIDs = tmpLabRoutingConfig ? await this._getProjectRootLabIDs(pIDProject, tmpRouter) : [];
		const fSelect = (pCandidateLabIDs, pCandidateDiagnosticIDs) =>
		{
			const tmpSelection = tmpRouter.selectSampleLabID(pCandidateLabIDs, { AffinityRootIDs: tmpAffinityRootIDs, ProjectRootLabIDs: tmpProjectRootLabIDs });
			if (!(tmpSelection.IDLab > 0))
			{
				return { IDLab: 0, Reason: 'NoDefaults', CandidateLabIDs: pCandidateDiagnosticIDs, Source: 'None' };
			}
			return { IDLab: tmpSelection.IDLab, Reason: 'OK', CandidateLabIDs: pCandidateDiagnosticIDs, Source: tmpSelection.Source };
		};
		if (!pIDMaterial || pIDMaterial <= 0)
		{
			return fSelect([], []);
		}
		const tmpMaterialIDs = await this._resolveMaterialParents(pIDMaterial);
		const tmpLabTestDefaults = await this._getAll(`LabTestDefaults/FilteredTo/FBL~IDMaterial~INN~${tmpMaterialIDs.join(',')}~FBV~SampleType~EQ~${pSampleType}`);
		if (tmpLabTestDefaults.length < 1)
		{
			return fSelect([], []);
		}
		// Get unique lab IDs from the defaults
		const tmpLabIDs = [...new Set(tmpLabTestDefaults.map((ltd) => ltd.IDLab))];
		// Fetch the lab records to resolve parent labs
		let tmpLabs = await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${tmpLabIDs.join(',')}`);
		if (tmpLabs.length < 1)
		{
			return fSelect([], tmpLabIDs);
		}
		if (pIDProject > 0)
		{
			const tmpProject = await this._get(`Project/${pIDProject}`);
			const tmpContract = tmpProject && tmpProject.IDContract > 0 ? await this._get(`Contract/${tmpProject.IDContract}`) : null;
			const tmpAllowedLabIDs = await this.getAllowedLabIDsForContract(tmpContract);
			if (tmpAllowedLabIDs)
			{
				tmpLabs = tmpLabs.filter((pLab) => tmpAllowedLabIDs.has(pLab.IDLab) || tmpAllowedLabIDs.has(pLab.IDLabParent));
				if (tmpLabs.length < 1)
				{
					this.fable.log.info(`All default labs for material ${pIDMaterial} fall outside the contract's materials-specification-set lab joins; no default lab resolved`);
					return { IDLab: 0, Reason: 'ExcludedBySpecSetLabJoins', CandidateLabIDs: tmpLabIDs, Source: 'None' };
				}
			}
		}
		// The router promotes through its own lab tree, matching the web app's indexing by IDLabParent. A lab
		// the catalog does not carry has no tree to promote through, so its own parent pointer stands in.
		await tmpRouter.loadLabCatalog();
		const tmpCandidateRootIDs = tmpLabs.map((pLab) => tmpRouter.getLab(pLab.IDLab) ? pLab.IDLab : (pLab.IDLabParent > 0 ? pLab.IDLabParent : pLab.IDLab));
		return fSelect(tmpCandidateRootIDs, tmpLabIDs);
	}

	/**
	 * The project's own PARENT labs, from `ProjectLabJoin`. A customer that joins a bench instead of its
	 * parent still scopes to the right family, because the ids are normalized through the lab tree.
	 *
	 * NB: `ProjectLabJoin` has no `Deleted` column — foxhound's soft-delete predicate is schema-driven, so a
	 * hand-written `Deleted` clause would error the read and silently fail open to no project labs.
	 *
	 * @param {number} pIDProject
	 * @param {MaterialsLabRouter} pLabRouter - the router whose lab tree normalizes the joined ids
	 *
	 * @return {Promise<Array<number>>}
	 */
	async _getProjectRootLabIDs(pIDProject, pLabRouter)
	{
		if (!(pIDProject > 0))
		{
			return [];
		}
		const tmpJoins = await this._getAll(`ProjectLabJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}`);
		await pLabRouter.loadLabCatalog();
		return Array.from(pLabRouter.rootsOf(tmpJoins.map((pJoin) => pJoin.IDLab)));
	}

	/**
	 * @param {number} pIDMaterial
	 * @param {number} pIDProject
	 * @param {string} [pSampleType='ACPT']
	 * @param {Array<number>} [pSelectedParentLabIDs=undefined]
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 *
	 * @return {Promise<Array<Record<string, any>>>} The default tests by material.
	 */
	async getMaterialTestDefaults(pIDMaterial, pIDProject, pSampleType = 'ACPT', pSelectedParentLabIDs = undefined, pConciergeConfig = undefined)
	{
		const tmpResult = await this.getMaterialTestDefaultsWithDiagnostics(pIDMaterial, pIDProject, pSampleType, pSelectedParentLabIDs, pConciergeConfig);
		return tmpResult.Tests;
	}

	/**
	 * Same resolution as {@link getMaterialTestDefaults}, but returns the bare
	 * `[]` causes as a structured Reason instead of an empty array — so callers
	 * (the LIMS concierge) can tell "material is not in this contract's spec
	 * year" apart from "configured but nothing to create". Reason is one of:
	 *   'OK'              — at least one default test resolved
	 *   'NoContract'      — the project has no contract (no spec year to draw from)
	 *   'NoSamplingPlan'  — contract present, but no ProjectLineItemMaterialTest
	 *                       row for this material/sample-type (the spec-year miss)
	 *   'TestsUnresolved' — sampling-plan rows present, but none resolved to a
	 *                       live Test record
	 *
	 * Each resolved test is routed to exactly one lab — a BENCH (leaf) where the capability tables name one,
	 * the sample's parent lab otherwise — so the returned entries partition across `LabID` rather than
	 * repeating a test under several labs.
	 *
	 * @param {number} pIDMaterial
	 * @param {number} pIDProject
	 * @param {string} [pSampleType='ACPT']
	 * @param {Array<number>} [pSelectedParentLabIDs=undefined]
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 * @return {Promise<{ Tests: Array<Record<string, any>>, Reason: string, Diagnostics: Record<string, any> }>}
	 */
	async getMaterialTestDefaultsWithDiagnostics(pIDMaterial, pIDProject, pSampleType = 'ACPT', pSelectedParentLabIDs = undefined, pConciergeConfig = undefined)
	{
		const tmpLabRoutingConfig = pConciergeConfig && pConciergeConfig.LabRouting;
		const tmpRouter = this.getLabRouter(tmpLabRoutingConfig);
		const tmpAffinityRootIDs = await tmpRouter.getAffinityRootIDs(pIDProject, tmpLabRoutingConfig);
		const tmpProject = await this._get(`Project/${pIDProject}`);
		const tmpContract = tmpProject && tmpProject.IDContract > 0 ? await this._get(`Contract/${tmpProject.IDContract}`) : null;
		if (!tmpContract)
		{
			this.log.warn(`No Contract found for Project ${pIDProject}`);
			return { Tests: [], Reason: 'NoContract', Diagnostics: { IDProject: pIDProject, IDMaterial: pIDMaterial, SampleType: pSampleType, IDContract: (tmpProject && tmpProject.IDContract) || 0 } };
		}
		/*
		const tmpSpecificationSet = tmpContract && tmpContract.ItemIDTestSpecificationSet > 0 ?
			await this._get(`TestSpecificationSet/${tmpContract.ItemIDTestSpecificationSet}`) :
			await this._getAll(`TestSpecificationSets/FilteredTo/FBV~Year~EQ~${tmpContract.ItemSpecificationYear}`).then((res) => res[0]);
		if (!tmpSpecificationSet)
		{
			this.log.warn(`No TestSpecificationSet found for Contract ${tmpContract.IDContract}`);
			return [];
		}
		*/
		//const tmpSpecifications = await this._getAll(`TestSpecifications/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpSpecificationSet.IDTestSpecificationSet}`);
		const tmpMaterialIDs = await this._resolveMaterialParents(pIDMaterial);
		//const tmpTestJoins = await this._getAll(`TestSpecificationMaterialTestJoins/FilteredTo/FBL~IDMaterial~INN~${tmpMaterialIDs.join(',')}~FBL~IDTestSpecification~INN~${tmpSpecifications.map((spec) => spec.IDTestSpecification).join(',')}`);
		let tmpLabIDs = pSelectedParentLabIDs;
		let tmpParentLabs = [];
		let tmpChildLabs = [];
		if (Array.isArray(tmpLabIDs) && tmpLabIDs.length > 0)
		{
			[ tmpParentLabs, tmpChildLabs ] = await Promise.all([
				this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${tmpLabIDs.join(',')}`),
				this._getAll(`Labs/FilteredTo/FBL~IDLabParent~INN~${tmpLabIDs.join(',')}`)
			]);
			this.fable.log.info(`Resolved attached labs with ids: ${ tmpLabIDs.join(',') }`);
		}
		else
		{
			// use ProjectLabJoin if no labs are specified
			const tmpProjectLabsJoins = await this._getAll(`ProjectLabJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}`);
			tmpParentLabs = tmpProjectLabsJoins.length < 1 ? [] : await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${tmpProjectLabsJoins.map((pl) => pl.IDLab).join(',')}`);
			tmpChildLabs = tmpProjectLabsJoins.length < 1 ? [] : await this._getAll(`Labs/FilteredTo/FBL~IDLabParent~INN~${tmpProjectLabsJoins.map((pl) => pl.IDLab).join(',')}`);
			tmpLabIDs = Array.from(new Set(tmpParentLabs.map((lab) => lab.IDLab)));
			this.fable.log.info(`Falling back to Project Lab Joins for project ${ pIDProject }, found lab ids: ${ tmpLabIDs.join(',') }`);
		}
		const tmpAllowedLabIDs = await this.getAllowedLabIDsForContract(tmpContract);
		if (tmpAllowedLabIDs)
		{
			// Joined labs sit at either level of the depth-2 lab tree: a child lab is
			// assignable when it or its parent is joined; a parent when it or one of
			// its surviving children is joined.
			tmpChildLabs = tmpChildLabs.filter((pLab) => tmpAllowedLabIDs.has(pLab.IDLab) || tmpAllowedLabIDs.has(pLab.IDLabParent));
			tmpParentLabs = tmpParentLabs.filter((pLab) => tmpAllowedLabIDs.has(pLab.IDLab) || tmpChildLabs.some((pChildLab) => pChildLab.IDLabParent === pLab.IDLab));
			this.fable.log.info(`Assignable labs constrained by the materials-specification-set lab joins for contract ${tmpContract.IDContract}: parent labs [${tmpParentLabs.map((pLab) => pLab.IDLab).join(',')}], child labs [${tmpChildLabs.map((pLab) => pLab.IDLab).join(',')}]`);
		}
		// check for defaults on parent and child labs
		const tmpAllLabs = tmpParentLabs.concat(tmpChildLabs);
		// FIXME: Some of the above code is redundant with this change but we are switching this to use ProjectLineItemMaterialTests. Get this working for now.
		let tmpTestDefaults = await this._getAll(`ProjectLineItemMaterialTests/FilteredTo/FBL~SampleType~INN~${ pSampleType },~FBV~IDProject~EQ~${ pIDProject }~FBL~IDMaterial~INN~${ tmpMaterialIDs.join(',') }`);
		this.fable.log.info(`Found the following PLIMTs for Project ${ pIDProject }, Materials ${ tmpMaterialIDs.join(',') }, Sample Type: ${ pSampleType }: `, { TestDefaults: tmpTestDefaults });
		const tmpSamplingPlanRowCount = tmpTestDefaults.length;
		// Fallback: when the project has no sampling plan for this material/sample-type,
		// pull tests from the contract's specification year (item spec set), scoped to
		// the project's pay items via MaterialPayItemJoin. Sample type is not carried in
		// the spec-year tables, so it is not filtered there (intentional, coarser).
		let tmpResolutionSource = 'SamplingPlan';
		let tmpSpecYear = null;
		if (tmpTestDefaults.length === 0)
		{
			tmpSpecYear = await this._resolveSpecYearTestDefaults(pIDMaterial, tmpMaterialIDs, pIDProject, tmpContract, pSampleType);
			if (tmpSpecYear.Tests.length > 0)
			{
				tmpTestDefaults = tmpSpecYear.Tests;
				tmpResolutionSource = 'SpecYear';
				this.fable.log.info(`No sampling plan for material ${pIDMaterial} in project ${pIDProject}; using contract spec-year fallback (${tmpTestDefaults.length} test(s))`, { Diagnostics: tmpSpecYear.Diagnostics });
			}
		}

		/* FIXME: this tries to use the test specification to find the tests, but this isn't working...
		const tmpTestDefaults = tmpChildLabs.length < 1 ?
			await this._getAll(`LabTestDefaults/FilteredTo/FBL~SampleType~INN~${pSampleType},~FBL~IDTest~INN~${tmpTestJoins.map((join) => join.IDTest).join(',')}`) :
			await this._getAll(`LabTestDefaults/FilteredTo/FBL~SampleType~INN~${pSampleType},~FBL~IDTest~INN~${tmpTestJoins.map((join) => join.IDTest).join(',')}~FBL~IDLab~INN~${tmpChildLabs.map((pl) => pl.IDLab).join(',')}`);
			*/
		// Commenting this out for now but leaving for reference since plimts won't have IDLab on them.
		/*if (tmpParentLabs.length < 1)
		{
			tmpChildLabs = await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${Array.from(new Set(tmpTestDefaults.map((td) => td.IDLab))).join(',')}`);
			tmpParentLabs = tmpChildLabs.length < 1 ? [] : await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${Array.from(new Set(tmpChildLabs.map((cl) => cl.IDLabParent))).join(',')}`);
		}*/
		const tmpTestIDs = Array.from(new Set(tmpTestDefaults.map((td) => td.IDTest)));
		const tmpTests = tmpTestIDs.length < 1 ? [] : await this._getAll(`Tests/FilteredTo/FBL~IDTest~INN~${tmpTestIDs.join(',')}`);
		// TestLabJoin is scoped to every in-scope lab, not just the benches: a project lab with no children
		// beneath it IS the bench, and scoping to children alone would leave it with no capability rows.
		const tmpScopeLabIDs = Array.from(new Set(tmpAllLabs.map((pLab) => pLab.IDLab).filter((pIDLab) => pIDLab > 0)));
		const tmpTestLabJoins = (tmpTestIDs.length < 1 || tmpScopeLabIDs.length < 1) ? [] : await this._getAll(`TestLabJoins/FilteredTo/FOP~0~(~0~FBV~DateEnd~GT~${new Date().toISOString()}~FBVOR~DateEnd~EQ~~FCP~0~)~0~FBL~IDTest~INN~${tmpTestIDs.join(',')}~FBL~IDLab~INN~${tmpScopeLabIDs.join(',')}`);
		this.fable.log.info(`Found the following test lab joins for labs ${ tmpScopeLabIDs.join(',') }, Tests ${ tmpTestIDs.join(',') }: `, { TestLabJoins: tmpTestLabJoins });
		// LabTestDefault is the per-test BACK-OFF axis: it narrows a test to its material's usual bench where
		// it has coverage, but it disagrees with TestLabJoin often enough that it is never allowed to empty
		// the candidates. Keyed on material, so it is skipped without one.
		const tmpLabTestDefaultRows = (tmpTestIDs.length < 1 || tmpMaterialIDs.length < 1) ? [] :
			await this._getAll(`LabTestDefaults/FilteredTo/FBL~IDMaterial~INN~${tmpMaterialIDs.join(',')}~FBV~SampleType~EQ~${pSampleType}~FBL~IDTest~INN~${tmpTestIDs.join(',')}`);

		const tmpTestMap = {};
		for (const tmpTest of tmpTests)
		{
			tmpTestMap[tmpTest.IDTest] = tmpTest;
		}
		// A test is run by ONE bench, so the routing below is a partition: every test resolves to exactly one
		// lab and appears in exactly one bucket. Nothing here fans a test out across labs — a sample gets a
		// second copy of a test only when a TestInstance already exists for the second lab.
		await tmpRouter.loadLabCatalog();
		tmpRouter.mergeLabCatalog(tmpAllLabs);
		const tmpTestLabsByTest = this._indexLabIDsByTest(tmpTestLabJoins);
		const tmpTestLabDefaultsByTest = this._indexLabIDsByTest(tmpLabTestDefaultRows);
		const tmpSpecSetFloor = tmpRouter.expandSpecSetFloor(tmpAllowedLabIDs);
		const tmpScopeParentLabIDs = tmpParentLabs.map((pLab) => pLab.IDLab);
		const tmpFirstParentLab = tmpParentLabs[0];
		/** @type {Record<string, number>} */
		const tmpTestLabAssignments = {};
		/** @type {Record<string, string>} */
		const tmpTestLabSources = {};
		for (const tmpIDTest of tmpTestIDs)
		{
			const tmpSelection = tmpRouter.selectTestLabID(tmpIDTest,
				{
					TestLabIDs: tmpTestLabsByTest[String(tmpIDTest)],
					TestLabDefaultIDs: tmpTestLabDefaultsByTest[String(tmpIDTest)],
					ParentLabIDs: tmpScopeParentLabIDs,
					SpecSetFloor: tmpSpecSetFloor,
					AffinityRootIDs: tmpAffinityRootIDs,
				});
			if (tmpSelection.IDLab > 0)
			{
				tmpTestLabAssignments[String(tmpIDTest)] = tmpRouter.applyAggregation(tmpSelection.IDLab);
				tmpTestLabSources[String(tmpIDTest)] = tmpSelection.Source;
				continue;
			}
			// No bench qualified. The sample's own parent lab still routes the test somewhere a technician can
			// see it, which is the behavior that predates per-test resolution.
			if (!tmpFirstParentLab)
			{
				this.fable.log.warn(`Test ID ${tmpIDTest} is not associated with a Lab ID and no parent lab was found; will create tests with no lab for material ${pIDMaterial}`);
				tmpTestLabAssignments[String(tmpIDTest)] = 0;
				tmpTestLabSources[String(tmpIDTest)] = 'None';
				continue;
			}
			tmpTestLabAssignments[String(tmpIDTest)] = tmpFirstParentLab.IDLab;
			tmpTestLabSources[String(tmpIDTest)] = 'SampleParentLab';
		}
		this.fable.log.info(`Resolved test lab assignments for material ${pIDMaterial} in project ${pIDProject}`, { TestLabAssignments: tmpTestLabAssignments, TestLabSources: tmpTestLabSources });
		const tmpTestDefaultsByLab = {};
		for (const tmpTestDefault of tmpTestDefaults)
		{
			const tmpAssignedLabID = tmpTestLabAssignments[String(tmpTestDefault.IDTest)] || 0;
			const tmpLabKey = String(tmpAssignedLabID);
			if (!tmpTestDefaultsByLab[tmpLabKey])
			{
				tmpTestDefaultsByLab[tmpLabKey] = [];
			}
			if (!tmpTestDefaultsByLab[tmpLabKey].find((t) => t.IDTest == tmpTestDefault.IDTest))
			{
				tmpTestDefaultsByLab[tmpLabKey].push(tmpTestDefault);
			}
		}
		const tmpRNIs = await this._getAvailableRNIs(pIDProject);
		// organize RNIs by tests
		let tmpResults = [];
		for (const [ tmpIDLab, tmpTestDefaults ] of Object.entries(tmpTestDefaultsByLab))
		{
			for (const tmpTestDefault of tmpTestDefaults)
			{
				const tmpTestID = tmpTestDefault.IDTest;
				const tmpTest = tmpTestMap[tmpTestID];
				if (!tmpTest)
				{
					this.fable.log.warn(`No test record found for default test ID ${tmpTestID} for material ${pIDMaterial}`);
					continue;
				}
				const tmpLabID = Number(tmpIDLab);
				const tmpLabName = tmpIDLab == '0' ? '' : (tmpAllLabs.find((lab) => lab.IDLab === tmpLabID) || tmpRouter.getLab(tmpLabID) || {}).Name || `Lab ${tmpIDLab}`;
				const tmpRNI = tmpRNIs.find((rni) => rni.Options.TestHash === tmpTest.Hash);
				const tmpFallbackRNI = tmpRNIs.find((rni) => Array.isArray(rni.Options.TestHashes) && rni.Options.TestHashes.includes(tmpTest.Hash));
				const tmpMatchedRNI = tmpRNI || tmpFallbackRNI;
				if (tmpMatchedRNI)
				{
					// Check if we already have a result for this RNI + lab combination
					const tmpExistingResult = tmpResults.find((r) => r.IDReportNamedInstance === tmpMatchedRNI.IDReportNamedInstance && r.LabID === tmpLabID);
					if (tmpExistingResult)
					{
						this.fable.log.info(`Form ${ tmpMatchedRNI.Name } for test ID ${tmpTestID} (hash: ${tmpTest.Hash}) already in result set.`);
						// Accumulate this test into the existing result
						if (!tmpExistingResult.SatisfiedTestHashes.includes(tmpTest.Hash))
						{
							tmpExistingResult.SatisfiedTestHashes.push(tmpTest.Hash);
						}
						if (!tmpExistingResult.SatisfiedIDTests.includes(tmpTestID))
						{
							tmpExistingResult.SatisfiedIDTests.push(tmpTestID);
						}
						continue;
					}
					this.fable.log.info(`Adding Form ${ tmpMatchedRNI.Name } for test ID ${tmpTestID} (hash: ${tmpTest.Hash}) to result set.`);

					const tmpResult = Object.assign({}, tmpMatchedRNI);
					tmpResult.Enabled = true;
					tmpResult.DisplayName = `Default Test RNI: ${tmpMatchedRNI.Name}`;
					tmpResult.TestHashes = tmpMatchedRNI.Options.TestHashes;
					tmpResult.TestHash = tmpRNI ? tmpRNI.Options.TestHash : tmpTest.Hash;
					tmpResult.IDTest = tmpTestID;
					tmpResult.SatisfiedIDTests = [tmpTestID];
					tmpResult.SatisfiedTestHashes = [tmpTest.Hash];
					tmpResult.LabID = tmpLabID;
					tmpResult.LabName = tmpLabName;
					tmpResult.LineItemIDs = tmpTestDefault.IDLineItem ? [ tmpTestDefault.IDLineItem ] : [];
					tmpResults.push(tmpResult);
					continue;
				}
				// Use the join-aware resolver — checks TestManifestSchemaJoin first then falls back
				// to Hash-based lookup. tmpTest already has IDTest/IDCustomer/Hash so no refetch.
				const tmpInjectableManifest = await this._resolveManifestForTestRecord(tmpTest);
				if (tmpInjectableManifest)
				{
					this.fable.log.info(`Found injectable Manifest with ID ${ tmpInjectableManifest.IDManifestSchema } for test ID ${tmpTestID} (hash: ${tmpTest.Hash}), adding to result set.`);
					tmpInjectableManifest.Enabled = true;
					tmpInjectableManifest.IDTest = tmpTestID;
					tmpInjectableManifest.SatisfiedIDTests = [tmpTestID];
					tmpInjectableManifest.SatisfiedTestHashes = [tmpTest.Hash];
					tmpInjectableManifest.LabID = tmpLabID;
					tmpInjectableManifest.LabName = tmpLabName;
					tmpInjectableManifest.Name = tmpInjectableManifest.Name || tmpTest.Name || tmpTest.Hash;
					tmpInjectableManifest.LineItemIDs = tmpTestDefault.IDLineItem ? [ tmpTestDefault.IDLineItem ] : [];
					tmpResults.push(tmpInjectableManifest);
					continue;
				}
				this.fable.log.warn(`No RNI or manifest found for default test ID ${tmpTestID} (hash: ${tmpTest.Hash}) for material ${pIDMaterial}`, { tmpTest });
				const tmpMissingTestEntry = Object.assign({}, tmpTest,
				{
					Enabled: true,
					IDTest: tmpTestID,
					SatisfiedIDTests: [tmpTestID],
					SatisfiedTestHashes: [tmpTest.Hash],
					LabID: tmpLabID,
					LabName: tmpLabName,
					DisplayName: tmpTest.Name || tmpTest.Hash,
					Missing: true,
					TestHash: tmpTest.Hash,
					LineItemIDs: tmpTestDefault.IDLineItem ? [ tmpTestDefault.IDLineItem ] : [],
				});
				tmpResults.push(tmpMissingTestEntry);
			}
		}
		let tmpReason = 'OK';
		if (tmpResults.length === 0)
		{
			if (tmpTestDefaults.length > 0)
			{
				tmpReason = 'TestsUnresolved';
			}
			else if (tmpSpecYear)
			{
				// The sampling plan was empty AND the spec-year fallback found nothing —
				// surface the fallback's specific reason (NoSpecYear / NoMatchingPayItems /
				// MaterialNotInPayItems / NoSpecYearTests).
				tmpReason = tmpSpecYear.Reason;
			}
			else
			{
				tmpReason = 'NoSamplingPlan';
			}
		}
		return {
			Tests: tmpResults,
			Reason: tmpReason,
			Diagnostics:
			{
				IDProject: pIDProject,
				IDMaterial: pIDMaterial,
				SampleType: pSampleType,
				IDContract: tmpContract.IDContract,
				ItemSpecificationYear: tmpContract.ItemSpecificationYear,
				ResolvedMaterialIDs: tmpMaterialIDs,
				Source: tmpResolutionSource,
				SamplingPlanRowCount: tmpSamplingPlanRowCount,
				ResolvedTestCount: tmpResults.length,
				MissingFormCount: tmpResults.filter((r) => r.Missing).length,
				ResolvedLabIDs: Object.keys(tmpTestDefaultsByLab),
				TestLabAssignments: tmpTestLabAssignments,
				TestLabSources: tmpTestLabSources,
				AffinityLabIDs: tmpAffinityRootIDs,
				AssignableLabScope: tmpAllowedLabIDs ? { AllowedLabCount: tmpAllowedLabIDs.size, ParentLabIDs: tmpParentLabs.map((pLab) => pLab.IDLab), ChildLabIDs: tmpChildLabs.map((pLab) => pLab.IDLab) } : null,
				SpecYear: tmpSpecYear ? tmpSpecYear.Diagnostics : null,
			},
		};
	}

	/**
	 * Fallback test resolution from the contract's specification year, used when a
	 * project has no sampling plan (ProjectLineItemMaterialTest) for a material.
	 * Reads the spec-year requirements (PayItemMaterialTestRequirement — the
	 * pay-item / material / test / sample-type shape) and HARD-GATES on the
	 * project's pay items: a requirement is honored only when its pay item appears
	 * on the project's line items (matched by IDPayItem, or by ItemCode ->
	 * PayItem.ItemCode within the contract's spec set). Sample type is filtered
	 * against the sample's type (a blank requirement SampleType is treated as
	 * "any"). Returns the same `{ IDTest, IDMaterial }` shape the PLIMT branch
	 * produces so the downstream resolution is identical.
	 *
	 * @param {number} pIDMaterial - the sample's material
	 * @param {Array<number>} pMaterialIDs - the material and its parent chain
	 * @param {number} pIDProject
	 * @param {Record<string, any>} pContract - the project's contract
	 * @param {string} pSampleType - the sample's type to filter requirements by
	 * @return {Promise<{ Tests: Array<Record<string, any>>, Reason: string, Diagnostics: Record<string, any> }>}
	 *   Reason: 'OK' | 'NoSpecYear' | 'NoMatchingPayItems' | 'MaterialNotInPayItems' | 'NoSpecYearTests'
	 */
	async _resolveSpecYearTestDefaults(pIDMaterial, pMaterialIDs, pIDProject, pContract, pSampleType)
	{
		const tmpDiagnostics = { IDProject: pIDProject, IDMaterial: pIDMaterial, SampleType: pSampleType };
		// 1. Resolve the contract's ITEM specification set (explicit id, else by year).
		let tmpSpecSetID = pContract.ItemIDTestSpecificationSet > 0 ? pContract.ItemIDTestSpecificationSet : 0;
		if (!tmpSpecSetID && pContract.ItemSpecificationYear)
		{
			// See _resolveMaterialSpecificationSetID: a year can match a provisional set as well as the live one.
			const tmpSets = await this._getAll(`TestSpecificationSets/FilteredTo/FBV~IDCustomer~EQ~${pContract.IDCustomer}~FBV~Year~EQ~${encodeURIComponent(pContract.ItemSpecificationYear)}~FSF~IDTestSpecificationSet~ASC~0`);
			if (tmpSets.length > 1)
			{
				this.fable.log.warn(`Item specification year ${pContract.ItemSpecificationYear} matches ${tmpSets.length} specification sets for customer ${pContract.IDCustomer}; using the lowest id (${tmpSets[0].IDTestSpecificationSet}). Set the contract's ItemIDTestSpecificationSet to resolve this explicitly.`);
			}
			tmpSpecSetID = tmpSets.length > 0 ? tmpSets[0].IDTestSpecificationSet : 0;
		}
		tmpDiagnostics.IDTestSpecificationSet = tmpSpecSetID;
		if (!tmpSpecSetID)
		{
			return { Tests: [], Reason: 'NoSpecYear', Diagnostics: tmpDiagnostics };
		}
		// 2. The project's pay items, matched to the set's pay items by IDPayItem or
		//    ItemCode. Fetch the set's pay-item catalog once (paged) and intersect in
		//    code — avoids oversized INN filter URLs on large projects.
		const tmpLineItems = await this._getAll(`LineItems/FilteredTo/FBV~IDProject~EQ~${pIDProject}`);
		const tmpLineItemPayItemIDs = new Set(tmpLineItems.map((li) => li.IDPayItem).filter((id) => id > 0));
		const tmpLineItemCodes = new Set(tmpLineItems.map((li) => li.ItemCode).filter((c) => c != null && String(c).length > 0));
		tmpDiagnostics.ProjectLineItemCount = tmpLineItems.length;
		const tmpSetPayItems = await this._getAll(`PayItems/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpSpecSetID}`);
		const tmpScopedPayItemIDs = new Set(tmpSetPayItems
			.filter((pi) => tmpLineItemPayItemIDs.has(pi.IDPayItem) || tmpLineItemCodes.has(pi.ItemCode))
			.map((pi) => pi.IDPayItem));
		tmpDiagnostics.MatchedPayItemCount = tmpScopedPayItemIDs.size;
		if (tmpScopedPayItemIDs.size === 0)
		{
			return { Tests: [], Reason: 'NoMatchingPayItems', Diagnostics: tmpDiagnostics };
		}
		// 3. Spec-year requirements for the material (+ parents). Query by material
		//    (tiny list), then HARD-GATE to the project's matched pay items in code.
		const tmpRequirements = await this._getAll(`PayItemMaterialTestRequirements/FilteredTo/FBL~IDMaterial~INN~${pMaterialIDs.join(',')}`);
		const tmpGatedRequirements = tmpRequirements.filter((r) => tmpScopedPayItemIDs.has(r.IDPayItem));
		tmpDiagnostics.PayItemGatedRequirementCount = tmpGatedRequirements.length;
		if (tmpGatedRequirements.length === 0)
		{
			return { Tests: [], Reason: 'MaterialNotInPayItems', Diagnostics: tmpDiagnostics };
		}
		// 4. Filter by sample type (a blank requirement SampleType means "any type"),
		//    then collapse to unique IDTest in the PLIMT-compatible shape.
		const tmpWantType = String(pSampleType || '').trim().toUpperCase();
		const tmpTests = [];
		const tmpSeenTestIDs = new Set();
		for (const tmpRequirement of tmpGatedRequirements)
		{
			const tmpRowType = String(tmpRequirement.SampleType || '').trim().toUpperCase();
			if (tmpRowType && tmpWantType && tmpRowType !== tmpWantType)
			{
				continue;
			}
			if (tmpRequirement.IDTest > 0 && !tmpSeenTestIDs.has(tmpRequirement.IDTest))
			{
				tmpSeenTestIDs.add(tmpRequirement.IDTest);
				tmpTests.push({ IDTest: tmpRequirement.IDTest, IDMaterial: tmpRequirement.IDMaterial, SampleType: tmpRequirement.SampleType, Source: 'SpecYear' });
			}
		}
		tmpDiagnostics.SpecYearTestCount = tmpTests.length;
		return { Tests: tmpTests, Reason: tmpTests.length > 0 ? 'OK' : 'NoSpecYearTests', Diagnostics: tmpDiagnostics };
	}

	async _getRNIForDocumentRecord(pDocumentRecord)
	{
		return (await this._getAvailableRNIs(pDocumentRecord.IDProject))?.find?.((rni) => rni.Hash === pDocumentRecord.DocumentType);
	}

	/**
	 * @param {Record<string, any>} pDocumentRecord
	 *
	 * @return {Promise<Record<string, any>>}
	 */
	async _getManifestForDocumentRecord(pDocumentRecord)
	{
		//FIXME: ...
		const tmpRNI = await this._getRNIForDocumentRecord(pDocumentRecord);
		if (!tmpRNI)
		{
			this.fable.log.warn(`No RNI found for document record`, { pDocumentRecord });
			return null;
		}
		return await this._loadFormManifest(tmpRNI);
	}

	/**
	 * Fetch the form manifest, if configured.
	 *
	 * NOTE: Mirrors the logic in report_definitions/global/server_js/mixins/document.pre-render-mixins.js#LoadFormManifest
	 *
	 * @param {any} pRNI - the ReportNamedInstance
	 *
	 * @return {Promise<Record<string, any>>} the form manifest object, or null
	 */
	async _loadFormManifest(pRNI)
	{
		const reportOptions = pRNI.Options;
		if (typeof reportOptions.FormDefinition === 'object')
		{
			return reportOptions.FormDefinition.DefaultFormManifest;
		}
		try
		{
			if (reportOptions.FormManifestSchemaID > 0)
			{
				return this.getManifestByID(reportOptions.FormManifestSchemaID).then((pManifestSchema) => pManifestSchema.Manifest);
			}
			if (reportOptions.FormManifestSchemaHash)
			{
				return this.getManifestByHash(reportOptions.FormManifestSchemaHash, pRNI.IDCustomer);
			}
		}
		catch (error)
		{
			this.fable.log.error(`Error loading form manifest: ${error}`);
		}
		return null;
	};

	/**
	 * Seed the sample-level Lab selector on a generated document.
	 *
	 * The Concierge resolves the sample's labs server-side, but a generated document is never driven
	 * through the interactive sample-selection chain that would otherwise derive them, so the Labs
	 * field renders empty. Writes the lab ids straight to the descriptor's address instead.
	 *
	 * The value is a comma-joined list of IDLab — the shape the Multiple entity selector parses
	 * (PictProvider-InputType-MaterialsEntitySelector splits a string value on commas). Per-test lab
	 * inputs (MaterialsTestLab*) are deliberately not matched; this is the sample-level field only.
	 *
	 * @param {Record<string, any>} pDocumentRecord - The document to seed (mutated in place).
	 * @param {Record<string, any>} pDocumentManifest - The already-resolved manifest for the document.
	 * @param {Array<number>} pLabIDs - The resolved lab ids for the sample.
	 *
	 * @return {string} the address written, or '' when the form has no lab selector
	 */
	_setSampleLabsInDocument(pDocumentRecord, pDocumentManifest, pLabIDs)
	{
		if (!Array.isArray(pLabIDs) || pLabIDs.length < 1 || !pDocumentManifest)
		{
			return '';
		}
		let tmpLabDescriptor;
		let tmpLabAddress = '';
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(pDocumentManifest.Descriptors || {}))
		{
			if (LAB_SELECTOR_INPUT_TYPES.indexOf(tmpDescriptor.PictForm?.InputType) < 0)
			{
				continue;
			}
			if (tmpLabDescriptor)
			{
				this.fable.log.warn(`Multiple sample lab selectors found in document manifest; seeding the first ('${tmpLabAddress}') and ignoring '${tmpDescriptor.DataAddress || tmpKey}'.`);
				continue;
			}
			tmpLabDescriptor = tmpDescriptor;
			tmpLabAddress = tmpDescriptor.DataAddress || tmpKey;
		}
		if (!tmpLabDescriptor)
		{
			// Not every generated form carries a Labs field; nothing to seed.
			return '';
		}
		const tmpUniqueLabIDs = Array.from(new Set(pLabIDs.map((pIDLab) => Number(pIDLab)).filter((pIDLab) => pIDLab > 0)));
		if (tmpUniqueLabIDs.length < 1)
		{
			return '';
		}
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpLabAddress, tmpUniqueLabIDs.join(','));
		return tmpLabAddress;
	}

	/**
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {string} [pGUIDSample]
	 * @param {Array<number>} [pLabIDs] - resolved lab ids for the sample, seeded into the form's Labs field
	 *
	 * @return {Promise<string>}
	 */
	async setSampleIdentityInDocument(pDocumentRecord, pGUIDSample, pLabIDs)
	{
		if (!pDocumentRecord)
		{
			throw new Error(`No document record provided to setSampleIdentityInDocument`);
		}
		if (!pDocumentRecord.GUIDDocument)
		{
			pDocumentRecord.GUIDDocument = this.fable.getUUID();
		}
		if (!pDocumentRecord.FormData)
		{
			pDocumentRecord.FormData = {};
		}
		if (!pDocumentRecord.FormData.__DynamicSectionData)
		{
			pDocumentRecord.FormData.__DynamicSectionData = {};
		}
		if (!Array.isArray(pDocumentRecord.FormData.__DynamicSectionData.Sequence))
		{
			pDocumentRecord.FormData.__DynamicSectionData.Sequence = [];
		}
		const tmpDocumentManifest = await this._getManifestForDocumentRecord(pDocumentRecord);
		if (pGUIDSample != null)
		{
			let tmpSampleSelectorDescriptor;
			if (tmpDocumentManifest)
			{
				for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDocumentManifest.Descriptors || {}))
				{
					if (tmpDescriptor.PictForm?.InputType === 'SampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsSampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenSampleSelector')
					{
						tmpSampleSelectorDescriptor = tmpDescriptor;
						if (!tmpSampleSelectorDescriptor.DataAddress)
						{
							tmpSampleSelectorDescriptor.DataAddress = tmpKey;
						}
					}
				}
				if (!tmpSampleSelectorDescriptor)
				{
					this.fable.log.warn(`No Sample Selector found in document manifest; defaulting to 'SampleID' address.`);
				}
			}
			else
			{
				this.fable.log.warn(`No document manifest found; defaulting to 'SampleID' address.`);
			}
			const tmpSampleAddress = tmpSampleSelectorDescriptor ? tmpSampleSelectorDescriptor.DataAddress : 'SampleID';
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleAddress, String(pGUIDSample));
			const tmpSampleSaltDataAddress = `${tmpSampleAddress}__Salt`;

			let tmpSampleSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress);
			if (!tmpSampleSalt)
			{
				tmpSampleSalt = this._generateSaltStr();
				this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress, tmpSampleSalt);
			}
			const tmpLabAddress = this._setSampleLabsInDocument(pDocumentRecord, tmpDocumentManifest, pLabIDs);
			if (tmpLabAddress)
			{
				this.fable.log.info(`Seeded ${tmpLabAddress} on document ${pDocumentRecord.GUIDDocument} with labs [${pLabIDs.join(',')}].`);
			}
			return tmpSampleSalt;
		}
		return null;
	}

	/**
	 * NOTE: does not save document
	 *
	 * @param {Array<Record<string, any>>} pTests - tests retrieved from getMaterialTestDefaults with Enabled flags set as desired
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {string} [pGUIDSample]
	 *
	 * @return {Promise<Record<string, Record<string, Record<string, any>>>>} - The updated document record with tests applied.
	 */
	async applyMaterialTestsToDocumentRecord(pTests, pDocumentRecord, pGUIDSample)
	{
		if (!pDocumentRecord)
		{
			throw new Error(`No document record provided to applyMaterialTestsToDocumentRecord`);
		}
		if (!pDocumentRecord.GUIDDocument)
		{
			pDocumentRecord.GUIDDocument = this.fable.getUUID();
		}
		if (!pDocumentRecord.FormData)
		{
			pDocumentRecord.FormData = {};
		}
		if (!pDocumentRecord.FormData.__DynamicSectionData)
		{
			pDocumentRecord.FormData.__DynamicSectionData = {};
		}
		if (!Array.isArray(pDocumentRecord.FormData.__DynamicSectionData.Sequence))
		{
			pDocumentRecord.FormData.__DynamicSectionData.Sequence = [];
		}
		const tmpDocumentManifest = await this._getManifestForDocumentRecord(pDocumentRecord);
		const tmpTestInputMap = { };
		if (pGUIDSample != null)
		{
			let tmpSampleSelectorDescriptor;
			if (tmpDocumentManifest)
			{
				for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDocumentManifest.Descriptors || {}))
				{
					if (tmpDescriptor.PictForm?.InputType === 'SampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsSampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenSampleSelector')
					{
						tmpSampleSelectorDescriptor = tmpDescriptor;
						if (!tmpSampleSelectorDescriptor.DataAddress)
						{
							tmpSampleSelectorDescriptor.DataAddress = tmpKey;
						}
					}
					if (tmpDescriptor.PictForm?.InputType === 'TestSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsTestSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenTestSelector')
					{
						if (tmpDescriptor.Default)
						{
							tmpTestInputMap[tmpDescriptor.Default] = tmpDescriptor;
						}
					}
				}
				if (!tmpSampleSelectorDescriptor)
				{
					this.fable.log.warn(`No Sample Selector found in document manifest; defaulting to 'SampleID' address.`);
				}
			}
			else
			{
				this.fable.log.warn(`No document manifest found; defaulting to 'SampleID' address.`);
			}
			const tmpSampleAddress = tmpSampleSelectorDescriptor ? tmpSampleSelectorDescriptor.DataAddress : 'SampleID';
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleAddress, String(pGUIDSample));
		}
		const tmpDynamicSectionData = pDocumentRecord.FormData.__DynamicSectionData;
		const tmpTestRecordComprehension =
		{
			TestInstance: { }, TestInstanceSampleJoin: { }, DocumentPolyJoin: { },
			Document:
			{
				[`${ pDocumentRecord.GUIDDocument }`]: { GUIDDocument: pDocumentRecord.GUIDDocument, IDProject: pDocumentRecord.IDProject }
			}
		};
		let tmpTestDescriptor;
		let tmpSampleDescriptor;
		if (tmpDocumentManifest)
		{
			for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDocumentManifest.Descriptors || {}))
			{
				if (tmpDescriptor.PictForm?.InputType === 'MaterialsTestSelector' ||
					tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenTestSelector')
				{
					tmpTestDescriptor = tmpDescriptor;
					if (!tmpTestDescriptor.DataAddress)
					{
						tmpTestDescriptor.DataAddress = tmpKey;
					}
					break;
				}
				if (tmpDescriptor.PictForm?.InputType === 'MaterialsSampleSelector' ||
					tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenSampleSelector')
				{
					tmpSampleDescriptor = tmpDescriptor;
					if (!tmpSampleDescriptor.DataAddress)
					{
						tmpSampleDescriptor.DataAddress = tmpKey;
					}
					break;
				}
			}
		}
		this._addSampleToComprehension(pGUIDSample, pDocumentRecord, tmpSampleDescriptor, tmpTestRecordComprehension);
		for (const tmpTest of pTests)
		{
			if (!tmpTest.Enabled)
			{
				continue;
			}
			if (tmpTest.IDReportNamedInstance)
			{
				// we can't apply an RNI to an existing document; will be handled externally
				const tmpSatisfiedTestHashes = tmpTest.SatisfiedTestHashes || tmpTest.TestHashes || [];
				const tmpSatisfiedIDTests = tmpTest.SatisfiedIDTests || [];
				for (let tmpIdx = 0; tmpIdx < tmpSatisfiedTestHashes.length; tmpIdx++)
				{
					const tmpTestHash = tmpSatisfiedTestHashes[tmpIdx];
					const tmpTestDescriptor = tmpTestInputMap[tmpTestHash];
					if (!tmpTestDescriptor)
					{
						this.fable.log.error(`No test selector for test hash ${tmpTestHash} in the ${pDocumentRecord.DocumentType} manifest; its TestInstance is not linked to this document`, { IDReportNamedInstance: tmpTest.IDReportNamedInstance, TestHash: tmpTestHash });
						continue;
					}
					const tmpTestDataAddress = tmpTestDescriptor?.DataAddress;
					if (!tmpTestDataAddress)
					{
						this.fable.log.error(`No data address on the test selector for test hash ${tmpTestHash} in the ${pDocumentRecord.DocumentType} manifest; its TestInstance is not linked to this document`, { IDReportNamedInstance: tmpTest.IDReportNamedInstance, TestHash: tmpTestHash });
						continue;
					}
					// Reuse the existing salt if the document already has one for this
					// test slot, so the same TestInstance GUID is produced and the
					// comprehension upserts the existing record rather than creating a
					// duplicate.
					const tmpSampleSaltDataAddress = `${tmpTestDataAddress}__Salt`;
					let tmpSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress);
					if (!tmpSalt)
					{
						tmpSalt = this._generateSaltStr();
						this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress, tmpSalt);
					}
					const tmpHash = `${tmpSalt}_${tmpTestHash}`;
					// Standalone-form path: the test binds to a flat decorated selector whose DataAddress IS the record
					// base (the *-ladotd manifests carry only String selectors, no record/container address). Write flat
					// so the form reads the same salt and adopts the TestInstance; only the injectable dynamic-section
					// path below nests under <salt>_<testHash>.
					// Resolve the correct IDTest for this specific test hash
					const tmpIDTest = tmpSatisfiedIDTests[tmpIdx] || tmpTest.IDTest;
					const tmpTestInstanceForHash = tmpTest.TestInstance
						? Object.assign({}, tmpTest.TestInstance, { IDTest: tmpIDTest })
						: { IDTest: tmpIDTest };
					await this._addTestToComprehension({ TestHash: tmpTestHash, IDTest: tmpIDTest, TestInstance: tmpTestInstanceForHash }, pGUIDSample, { Hash: tmpHash, Flat: true }, pDocumentRecord, tmpTestDescriptor, tmpTestRecordComprehension);
				}
				continue;
			}
			if (tmpTest.IDManifestSchema || tmpTest.TestHash)
			{
				const tmpSalt = this._generateSaltStr();
				let tmpHash;
				if (tmpTest.TestHash)
				{
					// add manifest schema to document
					//FIXME: currently we are just adding the test hash, rework to add arbitrary manifest schemas?
					tmpHash = `${tmpSalt}_${tmpTest.TestHash}`;
					tmpDynamicSectionData.Sequence.push(tmpHash);
					tmpDynamicSectionData[tmpHash] =
					{
						Hash: tmpHash,
						SaltHash: tmpSalt,
						TestHash: tmpTest.TestHash,
					};
				}
				else
				{
					tmpHash = tmpSalt;
					tmpDynamicSectionData.Sequence.push(tmpHash);
					tmpDynamicSectionData[tmpHash] =
					{
						Hash: tmpHash,
						SaltHash: tmpSalt,
						IDManifestSchema: tmpTest.IDManifestSchema,
					};
				}
				await this._addTestToComprehension(tmpTest, pGUIDSample, tmpDynamicSectionData[tmpHash], pDocumentRecord, tmpTestDescriptor, tmpTestRecordComprehension);
			}
			else
			{
				this.fable.log.warn(`Unknown test type encountered in applyMaterialTestsToDocumentRecord`, { tmpTest });
			}
		}
		return tmpTestRecordComprehension;
	}

	/**
	 * @param {string} pGUIDSample
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {Record<string, any>} pSampleDescriptor
	 * @param {Record<string, Record<string, any>>} pTestRecordComprehension
	 */
	_addSampleToComprehension(pGUIDSample, pDocumentRecord, pSampleDescriptor, pTestRecordComprehension)
	{
		//TODO: support for multi-sample forms?
		const tmpSampleDataAddress = pSampleDescriptor?.DataAddress || 'SampleID';
		const tmpSampleSaltDataAddress = `${tmpSampleDataAddress}__Salt`;

		let tmpSampleSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress);
		if (!tmpSampleSalt)
		{
			tmpSampleSalt = this._generateSaltStr();
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress, tmpSampleSalt);
		}
		const tmpDocumentPolyJoin =
		{
			GUIDDocumentPolyJoin: `${pDocumentRecord.GUIDDocument}-S_DPJ-${tmpSampleSalt}`,
			GUIDDocument: pDocumentRecord.GUIDDocument,
			RemoteType: 'Sample',
			_GUIDSample: pGUIDSample,
			_Dest__GUIDSample: 'IDRemote',
		};
		if (pDocumentRecord.IDDocument > 0)
		{
			tmpDocumentPolyJoin.IDDocument = pDocumentRecord.IDDocument;
		}
		else
		{
			tmpDocumentPolyJoin.GUIDDocument = pDocumentRecord.GUIDDocument;
		}
		pTestRecordComprehension.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
	}

	/**
	 * The write a record needs. A record that does not exist yet is written whole. An existing record
	 * may have been edited by someone else since it was read, so it carries only its identity and the
	 * fields that differ from the row as read — or nothing at all when no field does.
	 *
	 * @param {string} pEntity - The entity name, e.g. 'TestInstance'.
	 * @param {Record<string, any>} pRecordAsRead - A copy of the record taken before any change was applied.
	 * @param {Record<string, any>} pRecord - The record as it stands now.
	 *
	 * @return {Record<string, any> | null} the record to write, or null when there is nothing to write
	 */
	_getRecordWrite(pEntity, pRecordAsRead, pRecord)
	{
		const tmpIDField = `ID${pEntity}`;
		const tmpGUIDField = `GUID${pEntity}`;
		if (!(pRecord[tmpIDField] > 0))
		{
			return pRecord;
		}
		/** @type {Record<string, any>} */
		const tmpWrite = { [tmpIDField]: pRecord[tmpIDField] };
		let tmpHasChange = false;
		for (const [ tmpField, tmpValue ] of Object.entries(pRecord))
		{
			if (tmpField === tmpIDField || pRecordAsRead[tmpField] === tmpValue)
			{
				continue;
			}
			tmpWrite[tmpField] = tmpValue;
			tmpHasChange = true;
		}
		if (!tmpHasChange)
		{
			return null;
		}
		if (pRecord[tmpGUIDField])
		{
			tmpWrite[tmpGUIDField] = pRecord[tmpGUIDField];
		}
		return tmpWrite;
	}

	/**
	 * @param {Record<string, any>} pTest
	 * @param {string} pGUIDSample
	 * @param {Record<string, any>} pUniqueTestData
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {Record<string, any>} pTestDescriptor
	 * @param {Record<string, Record<string, any>>} pTestRecordComprehension
	 *
	 * @return {Promise<void>}
	 */
	async _addTestToComprehension(pTest, pGUIDSample, pUniqueTestData, pDocumentRecord, pTestDescriptor, pTestRecordComprehension)
	{
		if (!pGUIDSample)
		{
			this.fable.log.error(`No GUIDSample provided to _addTestToComprehension`, { pTest, pUniqueTestData, pDocumentRecord, pTestDescriptor });
			return;
		}
		const tmpTestDataAddressBase = pTestDescriptor?.DataAddress || 'TestID';
		// Injectable tests live in a dynamic section keyed <salt>_<testHash>; a standalone form binds the test to a
		// flat decorated selector whose DataAddress IS the record base. Nesting a standalone record under the
		// section key hides it from the flat selector, which then mints a second TestInstance on save (duplicate).
		const tmpTestDataAddress = pUniqueTestData.Flat ? tmpTestDataAddressBase : `${pUniqueTestData.Hash}.${tmpTestDataAddressBase}`;
		const tmpTestSaltDataAddress = `${tmpTestDataAddress}__Salt`;
		const tmpTestInstanceDataAddress = `${tmpTestDataAddress}__Record_Instance`;
		const tmpTestInstanceSampleJoinDataAddress = `${tmpTestDataAddress}__Record_SampleJoin`;
		const tmpDocumentPolyJoinDataAddress = `${tmpTestDataAddress}__Record_DocumentPolyJoin`;

		let tmpTestSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpTestSaltDataAddress);
		if (!tmpTestSalt)
		{
			tmpTestSalt = this._generateSaltStr();
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpTestSaltDataAddress, tmpTestSalt);
		}
		let tmpTestInstance = pTest.TestInstance
			|| this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpTestInstanceDataAddress)
			|| { };
		const tmpTestInstanceAsRead = Object.assign({ }, tmpTestInstance);
		if (!tmpTestInstance.GUIDTestInstance)
		{
			tmpTestInstance.GUIDTestInstance = `${pDocumentRecord.GUIDDocument}-TI-${tmpTestSalt}`;
		}
		if (!tmpTestInstance.IDTest)
		{
			tmpTestInstance.IDTest = pTest.IDTest || (await this._getTestByHash(pTest.TestHash))?.IDTest || 0;
		}
		if (!tmpTestInstance.IDTest)
		{
			this.fable.log.error(`Could not resolve IDTest for test in applyMaterialTestsToDocumentRecord`, { pTest });
			return;
		}
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpTestInstanceDataAddress, tmpTestInstance);
		let tmpTestInstanceSampleJoin;
		if (tmpTestInstance.IDTestInstance > 0)
		{
			const tmpSample = await this._get(`Samples/FilteredTo/FBV~GUIDSample~EQ~${encodeURIComponent(pGUIDSample)}`).then((res) => res[0]);
			if (tmpSample)
			{
				tmpTestInstanceSampleJoin = await this._get(`TestInstanceSampleJoins/FilteredTo/FBV~IDTestInstance~EQ~${tmpTestInstance.IDTestInstance}~FBV~IDSample~EQ~${tmpSample.IDSample}`).then((res) => res[0]);
			}
		}
		if (!tmpTestInstanceSampleJoin)
		{
			tmpTestInstanceSampleJoin =
			{
				GUIDTestInstanceSampleJoin: `${pDocumentRecord.GUIDDocument}-TISJ-${tmpTestSalt}`,
				GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
				_GUIDSample: pGUIDSample,
			};
		}
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpTestInstanceSampleJoinDataAddress, tmpTestInstanceSampleJoin);
		const tmpDocumentPolyJoin =
		{
			GUIDDocumentPolyJoin: `${pDocumentRecord.GUIDDocument}-TI_DPJ-${tmpTestSalt}`,
			RemoteType: 'TestInstance',
			GUIDDocument: pDocumentRecord.GUIDDocument,
			GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
			_Dest_GUIDTestInstance: 'IDRemote',

		};
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpDocumentPolyJoinDataAddress, tmpDocumentPolyJoin);
		// The joins carry the instance's GUID, which the processor resolves from the server when the instance is not written here.
		const tmpTestInstanceWrite = this._getRecordWrite('TestInstance', tmpTestInstanceAsRead, tmpTestInstance);
		if (tmpTestInstanceWrite)
		{
			pTestRecordComprehension.TestInstance[tmpTestInstance.GUIDTestInstance] = tmpTestInstanceWrite;
		}
		if (!(tmpTestInstanceSampleJoin.IDTestInstanceSampleJoin > 0))
		{
			pTestRecordComprehension.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
		}
		pTestRecordComprehension.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
	}

	/**
	 * @typedef {Object} TestSectionDescriptor
	 * @property {string} Hash - the section's registration hash
	 * @property {string} [SaltHash]
	 * @property {string} [TestHash]
	 * @property {number} [IDManifestSchema]
	 * @property {number} IDTest - from the section's __Record_Instance bookkeeping (0 when unknown)
	 * @property {string} [GUIDTestInstance]
	 * @property {string} [GUIDDocumentPolyJoin]
	 * @property {boolean} ConciergeManaged - true when the section carries __Record_Instance bookkeeping
	 * @property {string} [RemovedTime] - present on tombstoned sections
	 */

	/**
	 * Describe one dynamic test section of a document record.
	 *
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {string} pSectionHash
	 * @param {Record<string, any>} pSectionEntry - the section's registration entry (from __DynamicSectionData or __RemovedSectionData)
	 *
	 * @return {TestSectionDescriptor}
	 */
	_describeTestSection(pDocumentRecord, pSectionHash, pSectionEntry)
	{
		const tmpDescriptor =
		{
			Hash: pSectionHash,
			SaltHash: pSectionEntry?.SaltHash,
			TestHash: pSectionEntry?.TestHash,
			IDManifestSchema: pSectionEntry?.IDManifestSchema,
			IDTest: 0,
			GUIDTestInstance: undefined,
			GUIDDocumentPolyJoin: undefined,
			ConciergeManaged: false,
			RemovedTime: pSectionEntry?.RemovedTime,
		};
		const tmpSectionData = pDocumentRecord?.FormData?.[pSectionHash];
		if (tmpSectionData && typeof tmpSectionData === 'object')
		{
			for (const tmpKey of Object.keys(tmpSectionData))
			{
				if (tmpKey.endsWith('__Record_Instance'))
				{
					tmpDescriptor.ConciergeManaged = true;
					tmpDescriptor.IDTest = Number(tmpSectionData[tmpKey]?.IDTest) || 0;
					tmpDescriptor.GUIDTestInstance = tmpSectionData[tmpKey]?.GUIDTestInstance;
				}
				else if (tmpKey.endsWith('__Record_DocumentPolyJoin'))
				{
					tmpDescriptor.GUIDDocumentPolyJoin = tmpSectionData[tmpKey]?.GUIDDocumentPolyJoin;
				}
			}
		}
		return tmpDescriptor;
	}

	/**
	 * Enumerate a document record's dynamic test sections: Active (registered in
	 * __DynamicSectionData.Sequence) and Removed (tombstoned in __RemovedSectionData).
	 *
	 * @param {Record<string, any>} pDocumentRecord
	 *
	 * @return {{ Active: Array<TestSectionDescriptor>, Removed: Array<TestSectionDescriptor> }}
	 */
	listTestSectionsInDocumentRecord(pDocumentRecord)
	{
		const tmpResult = { Active: [], Removed: [] };
		const tmpFormData = pDocumentRecord?.FormData;
		if (!tmpFormData)
		{
			return tmpResult;
		}
		const tmpDynamicSectionData = tmpFormData.__DynamicSectionData || { };
		const tmpSequence = Array.isArray(tmpDynamicSectionData.Sequence) ? tmpDynamicSectionData.Sequence : [];
		for (const tmpSectionHash of tmpSequence)
		{
			if (tmpDynamicSectionData[tmpSectionHash])
			{
				tmpResult.Active.push(this._describeTestSection(pDocumentRecord, tmpSectionHash, tmpDynamicSectionData[tmpSectionHash]));
			}
		}
		const tmpRemovedSectionData = tmpFormData.__RemovedSectionData || { };
		for (const tmpSectionHash of Object.keys(tmpRemovedSectionData))
		{
			tmpResult.Removed.push(this._describeTestSection(pDocumentRecord, tmpSectionHash, tmpRemovedSectionData[tmpSectionHash]));
		}
		return tmpResult;
	}

	/**
	 * NOTE: does not save document
	 *
	 * Remove dynamic test sections from a document record by section hash. Each
	 * section's registration moves from __DynamicSectionData (and its Sequence)
	 * to a __RemovedSectionData tombstone; the section's entered data under
	 * FormData[<hash>] is left in place so removal is recoverable.
	 *
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {Array<string>} pSectionHashes
	 *
	 * @return {Array<TestSectionDescriptor>} descriptors of the sections actually removed
	 */
	removeTestSectionsFromDocumentRecord(pDocumentRecord, pSectionHashes)
	{
		if (!pDocumentRecord)
		{
			throw new Error(`No document record provided to removeTestSectionsFromDocumentRecord`);
		}
		const tmpRemoved = [];
		const tmpDynamicSectionData = pDocumentRecord.FormData?.__DynamicSectionData;
		if (!tmpDynamicSectionData || !Array.isArray(pSectionHashes) || pSectionHashes.length === 0)
		{
			return tmpRemoved;
		}
		const tmpRemovedTime = new Date().toISOString();
		for (const tmpSectionHash of pSectionHashes)
		{
			const tmpSectionEntry = tmpDynamicSectionData[tmpSectionHash];
			if (!tmpSectionEntry)
			{
				continue;
			}
			if (!pDocumentRecord.FormData.__RemovedSectionData)
			{
				pDocumentRecord.FormData.__RemovedSectionData = { };
			}
			pDocumentRecord.FormData.__RemovedSectionData[tmpSectionHash] = Object.assign({ }, tmpSectionEntry, { RemovedTime: tmpRemovedTime });
			delete tmpDynamicSectionData[tmpSectionHash];
			tmpRemoved.push(this._describeTestSection(pDocumentRecord, tmpSectionHash, pDocumentRecord.FormData.__RemovedSectionData[tmpSectionHash]));
		}
		if (tmpRemoved.length > 0 && Array.isArray(tmpDynamicSectionData.Sequence))
		{
			const tmpRemovedHashes = new Set(tmpRemoved.map((pSection) => pSection.Hash));
			tmpDynamicSectionData.Sequence = tmpDynamicSectionData.Sequence.filter((pSequenceHash) => !tmpRemovedHashes.has(pSequenceHash));
		}
		return tmpRemoved;
	}

	/**
	 * @param {string} pTestHash - The test hash to get.
	 *
	 * @return {Promise<Record<string, any>>} - The test record for the test hash.
	 */
	async _getTestByHash(pTestHash)
	{
		return await this._get(`Tests/FilteredTo/FBV~Hash~EQ~${pTestHash}`).then((res) => res[0]);
	}

	/**
	 * @param {number} pIDTest - The test ID to get the manifest or RNI for.
	 * @param {number} pIDProject - The Sample's project.
	 * @param {number} pIDMaterial - The Sample's material.
	 *
	 * @return {Promise<Record<string, any>>} - The manifest or RNI for the test ID.
	 */
	async getTestDefinitionForTestID(pIDTest, pIDProject, pIDMaterial)
	{
		// get RNIs
		const tmpRNIs = await this._getAvailableRNIs(pIDProject);
		/**
		 * @type {object|null}
		 */
		let tmpManifest = null;
		const test = await new Promise((resolve, reject) =>
		{
			this.client.getJSON(`Test/${ pIDTest }`, async (pError, pBody) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Test: ${ pError }`, pError);
					return reject(pError);
				}
				if (!pBody)
				{
					this.fable.log.error(`No Test found for ID: ${ pIDTest }`);
					return reject(new Error(`No Test found for ID: ${ pIDTest }`));
				}
				// Use the join-aware resolver so the join table is consulted on this hot path.
				tmpManifest = await this._resolveManifestForTestRecord(pBody);
				resolve(pBody);
			});
		});

		let tmpFallbackRNI;
		for (const tmpRNI of tmpRNIs)
		{
			if (tmpRNI.Options.TestHash == test.Hash)
			{
				tmpRNI.Enabled = true;
				tmpRNI.DisplayName = `Default Test RNI: ${tmpRNI.Name}`;
				tmpRNI.TestHash = tmpRNI.Options.TestHash;
				tmpRNI.TestHashes = tmpRNI.Options.TestHashes;
				tmpRNI.IDTest = pIDTest;
				tmpRNI.SatisfiedIDTests = [pIDTest];
				tmpRNI.SatisfiedTestHashes = [test.Hash];
				return tmpRNI;
			}
			if (Array.isArray(tmpRNI.Options.TestHashes) && tmpRNI.Options.TestHashes.includes(test.Hash))
			{
				tmpFallbackRNI = tmpRNI;
			}
		}
		if (tmpFallbackRNI)
		{
			tmpFallbackRNI.Enabled = true;
			tmpFallbackRNI.DisplayName = `Default Test RNI: ${tmpFallbackRNI.Name}`;
			tmpFallbackRNI.TestHash = test.Hash;
			tmpFallbackRNI.TestHashes = tmpFallbackRNI.Options.TestHashes;
			tmpFallbackRNI.IDTest = pIDTest;
			tmpFallbackRNI.SatisfiedIDTests = [pIDTest];
			tmpFallbackRNI.SatisfiedTestHashes = [test.Hash];
			return tmpFallbackRNI;
		}

		if (tmpManifest)
		{
			tmpManifest.Enabled = true;
			tmpManifest.DisplayName = `Test Hash: ${test.Hash}`;
			tmpManifest.TestHash = test.Hash;
			tmpManifest.TestHashes = [tmpManifest.TestHash];
			tmpManifest.IDTest = pIDTest;
			tmpManifest.SatisfiedIDTests = [pIDTest];
			tmpManifest.SatisfiedTestHashes = [test.Hash];
			return tmpManifest;
		}

		this.fable.log.warn(`No manifest or RNI found for Test ID: ${ pIDTest }`);
		const tmpMissingTestEntry = Object.assign({}, test,
		{
			Enabled: true,
			IDTest: pIDTest,
			SatisfiedIDTests: [pIDTest],
			SatisfiedTestHashes: [test.Hash],
			//LabID: Number(tmpIDLab),
			//LabName: tmpIDLab == '0' ? '' : (tmpParentLabs.find((lab) => lab.IDLab === Number(tmpIDLab)) || {}).Name || `Lab ${tmpIDLab}`,
			DisplayName: test.Name || test.Hash,
			Missing: true,
			TestHash: test.Hash,
		});

		return tmpMissingTestEntry;
	}

	/**
	 * Resolve the ManifestSchema for a given Test ID.
	 *
	 * Resolution order (added 2026-04 to address ManifestSchema hash collisions caused by the
	 * spec-year-2026 overlay deployment):
	 *
	 *   1. Look up TestManifestSchemaJoin rows for this IDTest (scoped by IDCustomer).
	 *      - Exactly 1 join row → deterministic binding; fetch the MS by ID and return.
	 *      - Multiple rows → data error per design; log.fatal and return the lowest-ID match defensively.
	 *      - Zero rows OR the join lookup hard-errors (e.g. table doesn't exist yet pre-migration) →
	 *        fall through to the legacy Hash-based path below. This is the safe-degrade path that
	 *        protects against deployment-order issues (code shipping ahead of schema migration).
	 *   2. Legacy: Test.Hash → getManifestForTestHash → getManifestByHash. First-match-wins on
	 *      collisions (Materials-Form-Manager.js:1110); this is the silent-ambiguity path that
	 *      the join table is here to eliminate for known-collision cases.
	 *
	 * Background: ~/dev/lims_test_routing_investigation_2026-04-28.md §9.1.
	 *
	 * @param {number} pTestID - The test ID to get the manifest for.
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test ID.
	 */
	async getManifestForTestID(pTestID)
	{
		if (!pTestID)
		{
			this.fable.log.error('No Test ID provided.');
			throw new Error('No Test ID provided.');
		}

		// Fetch the Test record (need its IDCustomer for the customer-scoped join lookup,
		// and its Hash for the legacy fallback).
		const tmpTest = await new Promise((resolve, reject) =>
		{
			this.client.getJSON(`Test/${pTestID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Test: ${pError}`, pError);
					return reject(pError);
				}
				if (!pBody)
				{
					this.fable.log.error(`No Test found for ID: ${pTestID}`);
					return reject(new Error(`No Test found for ID: ${pTestID}`));
				}
				return resolve(pBody);
			});
		});

		return this._resolveManifestForTestRecord(tmpTest);
	}

	/**
	 * Resolve a ManifestSchema given an already-fetched Test record. This is the join-aware
	 * resolution path used by both `getManifestForTestID` (after fetching the Test) and internal
	 * call sites in `getMaterialTestDefaults` etc. that already hold a Test record (avoids a
	 * redundant Test refetch on hot paths).
	 *
	 * Resolution order matches `getManifestForTestID`:
	 *   1. TestManifestSchemaJoin lookup by (IDTest, IDCustomer) — preferred, deterministic.
	 *   2. Hash-based lookup via `getManifestForTestHash(Test.Hash)` — legacy fallback.
	 *
	 * Fail-soft: any error in (1) is logged as warn and falls through to (2). Multiple rows in (1)
	 * is a data error — log.fatal fires and the lowest-ID match is returned defensively.
	 *
	 * @param {Record<string, any>} pTest - the Test record (must have IDTest, IDCustomer, Hash)
	 * @return {Promise<Record<string, any>>} the resolved ManifestSchema
	 */
	async _resolveManifestForTestRecord(pTest)
	{
		if (!pTest || !pTest.IDTest)
		{
			throw new Error('No Test record provided to _resolveManifestForTestRecord.');
		}

		let tmpJoinRows = null;
		try
		{
			tmpJoinRows = await new Promise((resolve, reject) =>
			{
				this.client.getJSON(`TestManifestSchemaJoins/FilteredTo/FBV~IDTest~EQ~${pTest.IDTest}~FBV~IDCustomer~EQ~${pTest.IDCustomer}/0/2`,
					(pError, pBody) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						return resolve(Array.isArray(pBody) ? pBody : []);
					});
			});
		}
		catch (pError)
		{
			// Likely causes: table doesn't exist yet (migration hasn't run), endpoint not wired,
			// transient API failure. Don't fail the form lookup — fall through to legacy Hash-based
			// resolution which preserves pre-2026-04 behavior.
			this.fable.log.warn(`TestManifestSchemaJoin lookup failed for IDTest ${pTest.IDTest}; falling back to legacy Hash-based lookup. Expected if schema migration has not yet applied.`,
				{ IDTest: pTest.IDTest, error: pError && pError.message });
			tmpJoinRows = null;
		}

		if (Array.isArray(tmpJoinRows) && tmpJoinRows.length === 1)
		{
			return this.getManifestByID(tmpJoinRows[0].IDManifestSchema);
		}
		if (Array.isArray(tmpJoinRows) && tmpJoinRows.length > 1)
		{
			// Data error per design — TestManifestSchemaJoin is meant to be 1:1 per (IDTest, IDCustomer).
			// Deterministic recovery: pick the lowest IDManifestSchema. Page oncall via log.fatal.
			this.fable.log.fatal(`Multiple TestManifestSchemaJoin rows for IDTest ${pTest.IDTest} (IDCustomer ${pTest.IDCustomer}); expected at most 1`,
				{ IDTest: pTest.IDTest, IDCustomer: pTest.IDCustomer, JoinRows: tmpJoinRows });
			const tmpFirst = [ ...tmpJoinRows ].sort((a, b) => a.IDManifestSchema - b.IDManifestSchema)[0];
			return this.getManifestByID(tmpFirst.IDManifestSchema);
		}

		// Legacy fallback: Hash-based MS lookup.
		return this.getManifestForTestHash(pTest.Hash);
	}

	/**
	 * @param {string} pManifestSchemaHash - The manifest schema hash to get.
	 * @param {number} pCustomerID - The customer ID for scoping.
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test hash.
	 */
	async getManifestByHash(pManifestSchemaHash, pCustomerID)
	{
		return new Promise((resolve, reject) =>
		{
			this.client.getJSON(`ManifestSchemas/FilteredTo/FBV~Hash~EQ~${pManifestSchemaHash}`, (pError, pManifestSchemas) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Manifest Schema for hash: ${pManifestSchemaHash}`, pError);
					return reject(pError);
				}
				if (!pManifestSchemas || !Array.isArray(pManifestSchemas) || pManifestSchemas.length === 0)
				{
					this.fable.log.error(`No Manifest Schema found for hash: ${pManifestSchemaHash}`);
					return reject(new Error(`No Manifest Schema found for hash: ${pManifestSchemaHash}`));
				}
				const tmpManifestSchema = pManifestSchemas.find((ms) => ms.IDCustomer == pCustomerID) || pManifestSchemas[0];
				//TODO: consolidate this with getManifestByID below
				this.client.getEntitySetWithPages('ManifestSchemaManifestSchemaPartialJoin', `FBV~IDManifestSchema~EQ~${tmpManifestSchema.IDManifestSchema}`,
					() => { }, () => { }, (pError, pManifestSchemaManifestSchemaPartialJoins) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error getting Manifest Schema Partial Joins for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`, pError);
						return reject(pError);
					}
					if (!pManifestSchemaManifestSchemaPartialJoins || !Array.isArray(pManifestSchemaManifestSchemaPartialJoins))
					{
						this.fable.log.error(`Invalid response for Manifest Schema Partial Joins.`);
						return reject(new Error(`Invalid response for Manifest Schema Partial Joins.`));
					}
					const tmpAnticipate = this.fable.newAnticipate();

					const tmpManifestSchemaPartialsByIDManifestSchema = {};
					const chunkSize = 100;
					for (let i = 0; i < pManifestSchemaManifestSchemaPartialJoins.length; i += chunkSize)
					{
						const chunk = pManifestSchemaManifestSchemaPartialJoins.slice(i, i + chunkSize);
						tmpAnticipate.anticipate(
							(fRequestCallback) =>
							{
								this.client.getEntitySetWithPages('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${chunk.map((ms) => ms.IDManifestSchemaPartial).join(',')}`,
									() => { }, () => { }, (pError, pManifestSchemaPartials) =>
								{
									if (pError)
									{
										this.fable.log.error(`Error getting Manifest Schema Partials for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`, pError);
										return fRequestCallback(pError);
									}
									if (!pManifestSchemaPartials || !Array.isArray(pManifestSchemaPartials))
									{
										this.fable.log.error(`Invalid response for Manifest Schema Partials.`);
										return fRequestCallback(pError);
									}
									if (pManifestSchemaPartials.length !== chunk.length)
									{
										this.fable.log.warn(`Mismatch in expected Manifest Schema Partials returned. Expected: ${chunk.length}, Received: ${pManifestSchemaPartials.length}`);
									}
									for (const tmpJoin of chunk)
									{
										const tmpManifestSchemaPartial = pManifestSchemaPartials.find((msp) => msp.IDManifestSchemaPartial === tmpJoin.IDManifestSchemaPartial);
										if (!tmpManifestSchemaPartial)
										{
											this.fable.log.warn(`Manifest Schema Partial not found for ID: ${tmpJoin.IDManifestSchemaPartial}`);
											continue;
										}
										if (!tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema])
										{
											tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema] = [];
										}
										tmpManifestSchemaPartial.Ordinal = tmpJoin.Ordinal;
										tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema].push(tmpManifestSchemaPartial);
									}
									fRequestCallback();
								});
							});
					}
					tmpAnticipate.wait(
						(pError) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error caching Test manifest for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`, pError);
								return reject(pError);
							}
							/** @type {Record<string, any>} */
							const tmpPartials = tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchema.IDManifestSchema] || [];
							tmpPartials.sort((a, b) => a.Ordinal - b.Ordinal);
							let tmpMergedConfig = this.fable.services.ManifestPackagingService._mergeManifests(tmpManifestSchema, tmpPartials)?.DefaultFormManifest;
							if (!tmpMergedConfig)
							{
								this.fable.log.error(`Manifest merge failed for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`);
							}
							this._decorateManifestSchema(tmpManifestSchema);
							tmpManifestSchema.Manifest = tmpMergedConfig;
							resolve(tmpManifestSchema);
						},
					);
				});
			});
		});
	}

	/**
	 * @param {number} pManifestSchemaID
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test hash.
	 */
	async getManifestByID(pManifestSchemaID)
	{
		return new Promise((resolve, reject) =>
		{
			this.client.getJSON(`ManifestSchema/${pManifestSchemaID}`, (pError, pManifestSchema) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Manifest Schema ID: ${pManifestSchemaID}`, pError);
					return reject(pError);
				}
				if (!pManifestSchema)
				{
					this.fable.log.error(`Invalid response for Manifest Schema.`);
					return reject(new Error(`Invalid response for Manifest Schema.`));
				}
				this.client.getEntitySetWithPages('ManifestSchemaManifestSchemaPartialJoin', `FBV~IDManifestSchema~EQ~${pManifestSchemaID}`,
					() => { }, () => { }, (pError, pManifestSchemaManifestSchemaPartialJoins) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error getting Manifest Schema Partial Joins for Manifest Schema ID: ${pManifestSchemaID}`, pError);
						return reject(pError);
					}
					if (!pManifestSchemaManifestSchemaPartialJoins || !Array.isArray(pManifestSchemaManifestSchemaPartialJoins))
					{
						this.fable.log.error(`Invalid response for Manifest Schema Partial Joins.`);
						return reject(new Error(`Invalid response for Manifest Schema Partial Joins.`));
					}
					const tmpAnticipate = this.fable.newAnticipate();

					const tmpManifestSchemaPartialsByIDManifestSchema = {};
					const chunkSize = 100;
					for (let i = 0; i < pManifestSchemaManifestSchemaPartialJoins.length; i += chunkSize)
					{
						const chunk = pManifestSchemaManifestSchemaPartialJoins.slice(i, i + chunkSize);
						tmpAnticipate.anticipate(
							(fRequestCallback) =>
							{
								this.client.getEntitySetWithPages('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${chunk.map((ms) => ms.IDManifestSchemaPartial).join(',')}`,
									() => { }, () => { }, (pError, pManifestSchemaPartials) =>
								{
									if (pError)
									{
										this.fable.log.error(`Error getting Manifest Schema Partials for Manifest Schema ID: ${pManifestSchemaID}`, pError);
										return fRequestCallback(pError);
									}
									if (!pManifestSchemaPartials || !Array.isArray(pManifestSchemaPartials))
									{
										this.fable.log.error(`Invalid response for Manifest Schema Partials.`);
										return fRequestCallback(pError);
									}
									if (pManifestSchemaPartials.length !== chunk.length)
									{
										this.fable.log.warn(`Mismatch in expected Manifest Schema Partials returned. Expected: ${chunk.length}, Received: ${pManifestSchemaPartials.length}`);
									}
									for (const tmpJoin of chunk)
									{
										const tmpManifestSchemaPartial = pManifestSchemaPartials.find((msp) => msp.IDManifestSchemaPartial === tmpJoin.IDManifestSchemaPartial);
										if (!tmpManifestSchemaPartial)
										{
											this.fable.log.warn(`Manifest Schema Partial not found for ID: ${tmpJoin.IDManifestSchemaPartial}`);
											continue;
										}
										if (!tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema])
										{
											tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema] = [];
										}
										tmpManifestSchemaPartial.Ordinal = tmpJoin.Ordinal;
										tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema].push(tmpManifestSchemaPartial);
									}
									fRequestCallback();
								});
							});
					}
					tmpAnticipate.wait(
						(pError) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error caching Test manifest for Manifest Schema ID: ${pManifestSchemaID}`, pError);
								return reject(pError);
							}
							/** @type {Record<string, any>} */
							const tmpPartials = tmpManifestSchemaPartialsByIDManifestSchema[pManifestSchema.IDManifestSchema] || [];
							tmpPartials.sort((a, b) => a.Ordinal - b.Ordinal);
							let tmpMergedConfig = this.fable.services.ManifestPackagingService._mergeManifests(pManifestSchema, tmpPartials)?.DefaultFormManifest;
							if (!tmpMergedConfig)
							{
								this.fable.log.error(`Manifest merge failed for Manifest Schema ID: ${pManifestSchema.IDManifestSchema}`);
							}
							this._decorateManifestSchema(pManifestSchema);
							pManifestSchema.Manifest = tmpMergedConfig;
							resolve(pManifestSchema);
						},
					);
				});
			});
		});
	}

	/**
	 * @param {string} pTestHash - The test hash to get the manifest for.
	 * @param {Record<string, Record<string, any>>} [pOverrideManifestMap] - An optional manifest map to override the default one
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test hash.
	 */
	async getManifestForTestHash(pTestHash, pOverrideManifestMap)
	{
		if (pOverrideManifestMap && pOverrideManifestMap[pTestHash])
		{
			return JSON.parse(JSON.stringify({ Manifest: pOverrideManifestMap[pTestHash]}));
		}
		let tmpTestManifestCache = this.fable.AppData._TestManifestCache;
		if (tmpTestManifestCache)
		{
			return tmpTestManifestCache[pTestHash] ? JSON.parse(JSON.stringify(tmpTestManifestCache[pTestHash])) : null;
		}
		return new Promise((resolve, reject) =>
		{
			this.client.getEntitySetWithPages('ManifestSchema', 'FBV~Type~EQ~Test', () => { }, () => { }, (pError, pManifestSchemas) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error caching Test manifest schemas for Test Hash: ${pTestHash}`, pError);
					return reject(pError);
				}
				if (!pManifestSchemas || !Array.isArray(pManifestSchemas))
				{
					this.fable.log.error(`No Manifest Schemas found for Tests.`);
					return reject(new Error(`No Manifest Schemas found for Tests.`));
				}

				this.client.getEntitySetWithPages('ManifestSchemaManifestSchemaPartialJoin', `FBL~IDManifestSchema~INN~${pManifestSchemas.map((ms) => ms.IDManifestSchema).join(',')}`,
					() => { }, () => { }, (pError, pManifestSchemaManifestSchemaPartialJoins) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error caching Test manifest schema partials for Test Hash: ${pTestHash}`, pError);
						return reject(pError);
					}
					if (!pManifestSchemaManifestSchemaPartialJoins || !Array.isArray(pManifestSchemaManifestSchemaPartialJoins))
					{
						this.fable.log.error(`Invalid response for Manifest Schema Partial Joins.`);
						return reject(new Error(`Invalid response for Manifest Schema Partial Joins.`));
					}
					const tmpAnticipate = this.fable.newAnticipate();

					const tmpManifestSchemaPartialsByIDManifestSchema = {};
					const chunkSize = 100;
					for (let i = 0; i < pManifestSchemaManifestSchemaPartialJoins.length; i += chunkSize)
					{
						const chunk = pManifestSchemaManifestSchemaPartialJoins.slice(i, i + chunkSize);
						tmpAnticipate.anticipate(
							(fRequestCallback) =>
							{
								this.client.getEntitySetWithPages('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${chunk.map((ms) => ms.IDManifestSchemaPartial).join(',')}`,
									() => { }, () => { }, (pError, pManifestSchemaPartials) =>
								{
									if (pError)
									{
										this.fable.log.error(`Error caching Test manifest schema partials for Test Hash: ${pTestHash}`, pError);
										return fRequestCallback(pError);
									}
									if (!pManifestSchemaPartials || !Array.isArray(pManifestSchemaPartials))
									{
										this.fable.log.error(`Invalid response for Manifest Schema Partials.`);
										return fRequestCallback(pError);
									}
									if (pManifestSchemaPartials.length !== chunk.length)
									{
										this.fable.log.warn(`Mismatch in expected Manifest Schema Partials returned. Expected: ${chunk.length}, Received: ${pManifestSchemaPartials.length}`);
									}
									for (const tmpManifestSchemaPartial of pManifestSchemaPartials)
									{
										if (!tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchemaPartial.IDManifestSchema])
										{
											tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchemaPartial.IDManifestSchema] = [];
										}
										tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchemaPartial.IDManifestSchema].push(tmpManifestSchemaPartial);
									}
									fRequestCallback();
								});
							});
					}
					tmpAnticipate.wait(
						(pError) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error caching Test manifest for Test Hash: ${pTestHash}`, pError);
								return reject(pError);
							}
							tmpTestManifestCache = {};
							for (const tmpManifestSchema of pManifestSchemas)
							{
								let tmpMergedConfig = this.fable.services.ManifestPackagingService._mergeManifests(tmpManifestSchema, tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchema.IDManifestSchema] || [])?.DefaultFormManifest;
								if (tmpTestManifestCache[tmpManifestSchema.SubType])
								{
									// this causes us to merge manifest whose SubType collides on the same hash
									tmpMergedConfig = this.fable.services.ManifestPackagingService._simpleManifestMerge(
										JSON.parse(JSON.stringify(tmpTestManifestCache[tmpManifestSchema.SubType])),
										tmpMergedConfig);
								}
								if (!tmpMergedConfig)
								{
									this.fable.log.error(`Manifest merge failed for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`);
									continue;
								}
								this._decorateManifestSchema(tmpManifestSchema);
								tmpManifestSchema.Manifest = tmpMergedConfig;
								tmpTestManifestCache[tmpManifestSchema.SubType] = tmpManifestSchema;
							}
							resolve(tmpTestManifestCache[pTestHash] ? JSON.parse(JSON.stringify(tmpTestManifestCache[pTestHash])) : null);
						},
					);
				});
			});
		});
	}

	/**
	 * @param {number} [pLength=8]
	 * @return {string} a random salt to identify this input instance
	 */
	_generateSaltStr(pLength = 8)
	{
		let result = '';
		for (let i = 0; i < pLength; i++)
		{
			result += SALT_CHARS.charAt(Math.floor(Math.random() * SALT_CHARS.length));
		}
		return result;
	}
}

module.exports = MaterialsFormManager;
/** @type {Record<string, any>} */
module.exports.default_configuration = { };
module.exports.LIMS_GUID_PATTERNS = LIMS_GUID_PATTERNS;
module.exports.isLIMSForm = isLIMSForm;
module.exports.getLIMSFormCandidates = getLIMSFormCandidates;
module.exports.FORM_GROUPS = FORM_GROUPS;

},{"./Materials-Lab-Router.js":16,"fable-serviceproviderbase":398,"headlight-rest-client":12,"manifest-packaging-service":14,"util":755}],16:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * @typedef {object} LabAffinityRule
 * @property {string} LabField - the Lab column matched against (e.g. 'Name', 'ExternalLabID').
 * @property {string} Pattern - a regular expression with `{KeyName}` placeholders filled from the project keys.
 * @property {Array<string>} [Requires] - project key names that must resolve before the rule is evaluated.
 * @property {string} [Flags] - regular-expression flags (default 'i').
 */

/**
 * @typedef {object} LabRoutingConfiguration
 * @property {Record<string, Array<string>>} [ProjectKeys] - key name -> ordered `Project.CustomProperties` keys; first non-empty wins.
 * @property {Array<LabAffinityRule>} [Rules] - ordered; the order is the routing priority order.
 * @property {string} [ResolverService] - fable service hash of a customer-specific router replacing this one.
 * @property {boolean} [FormsPerTestLab] - false to keep every test's form on one document regardless of lab.
 */

/**
 * @typedef {object} SampleLabContext
 * @property {Array<number>} [AffinityRootIDs] - affinity-matched parent labs, in priority order.
 * @property {Set<number>|Array<number>} [ProjectRootLabIDs] - the project's own parent labs (ProjectLabJoin).
 */

/**
 * @typedef {object} TestLabContext
 * @property {Set<number>} [TestLabIDs] - labs named by `TestLabJoin` for this test.
 * @property {Set<number>} [TestLabDefaultIDs] - labs named by `LabTestDefault` for this test (back-off axis).
 * @property {Set<number>|Array<number>} [ParentLabIDs] - the sample's assigned parent labs.
 * @property {Set<number>|Array<number>} [ProjectRootLabIDs] - the project's own parent labs.
 * @property {Set<number>|null} [SpecSetFloor] - the family-expanded `LabTestSpecificationSetJoin` floor.
 * @property {Array<number>} [AffinityRootIDs] - affinity-matched parent labs, in priority order.
 */

/**
 * @typedef {object} LabSelection
 * @property {number} IDLab - the chosen lab, or 0 when no axis answered.
 * @property {string} Source - which axis settled it: 'TestLabJoin' | 'LabTestDefault' | 'Affinity' |
 *   'ParentFamily' | 'Ambiguous' | 'None' for tests; 'LabTestDefault' | 'Affinity' | 'ProjectLabJoin' |
 *   'None' for samples.
 */

/**
 * MaterialsLabRouter — decides which lab a sample ships to and which bench runs each of its tests.
 *
 * The lab model is two-level: a PARENT lab is the routing destination a sample is assigned to, and its
 * CHILD labs are the benches that actually run tests. `ProjectLabJoin` names parents; `TestLabJoin` and
 * `LabTestDefault` name children. The concierge therefore asks two different questions:
 *
 *   - {@link selectSampleLabID} picks the PARENT lab for the sample's `SampleLabJoin`.
 *   - {@link selectTestLabID} picks the LEAF lab for a test's `TestInstance` and its form.
 *
 * Per-test narrowing intersects the axes that carry data — the test's capable labs (`TestLabJoin`, resolved
 * to leaves), the families of the sample's parent labs, and the families of the project's labs — then keeps
 * only leaves and applies the specification-set floor. `LabTestDefault` is a BACK-OFF axis: it narrows where
 * it has coverage but is never allowed to empty the candidates, because it disagrees with `TestLabJoin` often
 * enough that intersecting it hard would strand a test with no bench.
 *
 * Which of several surviving benches wins is customer data, not code: `LabRouting.Rules` match project
 * metadata (`Project.CustomProperties`) against Lab columns to name the parent labs belonging to a project —
 * the district laboratory and the field unit, for a DOT — and rule order is priority order. Without a
 * `LabRouting` block the affinity tier is simply absent and selection falls through to the data axes.
 *
 * This mirrors the web `LabScopeResolver` the sample form uses, so a form the concierge generates offers the
 * same labs the engineer would have picked by hand.
 */
class MaterialsLabRouter extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the router
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'MaterialsLabRouter';

		/** @type {Map<number, Record<string, any>>} the customer lab catalog, by IDLab */
		this._Labs = new Map();
		/** @type {Map<number, Set<number>>} IDLab -> its child IDLab set */
		this._ChildrenByParent = new Map();
		this._LabsLoaded = false;
		/** @type {Map<number, Array<number>>} IDProject -> affinity-matched parent labs, in rule order */
		this._AffinityByProject = new Map();
		/** @type {{ get: (pURI: string) => Promise<any>, getAll: (pURI: string) => Promise<Array<any>> }|null} */
		this._Readers = null;
	}

	/**
	 * Bind the router to a caller's API readers. The router owns no client of its own so it reads through
	 * whatever session the caller is already impersonating.
	 *
	 * @param {{ get: (pURI: string) => Promise<any>, getAll: (pURI: string) => Promise<Array<any>> }} pReaders
	 *
	 * @return {void}
	 */
	setDataReaders(pReaders)
	{
		this._Readers = pReaders;
	}

	// --- lab tree ------------------------------------------------------------------------------------

	/**
	 * The customer's lab catalog, loaded once per instance — the tree does not move mid-sync. Read in full
	 * rather than through the Lite projection, which emits only `ID*`/`GUID*` columns and so carries neither
	 * the names nor the codes the affinity rules match on.
	 *
	 * The sort clause is also what makes this a legal paged read: meadow-endpoints exposes no bare
	 * `s/:Begin/:Cap`, only `s/FilteredTo/:Filter/:Begin/:Cap`.
	 *
	 * @return {Promise<void>}
	 */
	async loadLabCatalog()
	{
		if (this._LabsLoaded || !this._Readers)
		{
			return;
		}
		const tmpRows = await this._Readers.getAll(`Labs/FilteredTo/FSF~Name~ASC~0`);
		this.setLabCatalog(tmpRows);
	}

	/**
	 * Seed the lab tree from records already in hand (or from a test fixture), instead of reading them.
	 *
	 * @param {Array<Record<string, any>>} pLabs
	 *
	 * @return {void}
	 */
	setLabCatalog(pLabs)
	{
		this._Labs = new Map();
		this._ChildrenByParent = new Map();
		for (const tmpRow of (pLabs || []))
		{
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDLab > 0)
			{
				this._Labs.set(tmpIDLab, tmpRow);
			}
		}
		for (const tmpLab of this._Labs.values())
		{
			const tmpIDLab = parseInt(tmpLab.IDLab, 10);
			const tmpParent = parseInt(tmpLab.IDLabParent, 10) || 0;
			if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
			{
				continue;
			}
			let tmpChildren = this._ChildrenByParent.get(tmpParent);
			if (!tmpChildren)
			{
				tmpChildren = new Set();
				this._ChildrenByParent.set(tmpParent, tmpChildren);
			}
			tmpChildren.add(tmpIDLab);
		}
		this._LabsLoaded = true;
	}

	/**
	 * Add lab records the caller already holds without discarding what is loaded. The concierge fetches the
	 * project's labs on its own path anyway, so merging them guarantees the tree covers every lab a decision
	 * touches even when the catalog read returned nothing.
	 *
	 * @param {Array<Record<string, any>>} pLabs
	 *
	 * @return {void}
	 */
	mergeLabCatalog(pLabs)
	{
		let tmpAdded = false;
		for (const tmpRow of (pLabs || []))
		{
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDLab > 0 && !this._Labs.has(tmpIDLab))
			{
				this._Labs.set(tmpIDLab, tmpRow);
				tmpAdded = true;
			}
		}
		if (tmpAdded)
		{
			this.setLabCatalog(Array.from(this._Labs.values()));
		}
	}

	/**
	 * The lab record from the catalog, or null when it is not loaded.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {Record<string, any>|null}
	 */
	getLab(pIDLab)
	{
		return this._Labs.get(parseInt(String(pIDLab), 10)) || null;
	}

	/**
	 * The parent of a lab, or the lab itself when it is already a root. A parent pointer referencing a lab
	 * outside the catalog (or the lab itself) is treated as "no parent" rather than followed.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {number}
	 */
	getParentLabID(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return 0;
		}
		const tmpLab = this._Labs.get(tmpIDLab);
		const tmpParent = tmpLab ? (parseInt(tmpLab.IDLabParent, 10) || 0) : 0;
		if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
		{
			return tmpIDLab;
		}
		return tmpParent;
	}

	/**
	 * Whether a lab is a leaf — it has no children, so a test assigned to it needs no further routing. A lab
	 * absent from the catalog counts as a leaf so an unloaded tree never hides an option.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {boolean}
	 */
	isLeafLab(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return false;
		}
		const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
		return !tmpChildren || tmpChildren.size < 1;
	}

	/**
	 * The child labs of a lab.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {Set<number>}
	 */
	getChildLabIDs(pIDLab)
	{
		return new Set(this._ChildrenByParent.get(parseInt(String(pIDLab), 10)) || []);
	}

	/**
	 * Resolve a set of labs to the leaves a test can actually be assigned to: a leaf stays, a parent is
	 * replaced by its children. Falls back to the input when the resolution empties it (a catalog that has
	 * not loaded), so this never removes the only options a caller had.
	 *
	 * @param {Set<number>|Array<number>|null|undefined} pLabIDs
	 *
	 * @return {Set<number>|null}
	 */
	resolveToLeaves(pLabIDs)
	{
		const tmpInput = this._toSet(pLabIDs);
		if (tmpInput.size < 1)
		{
			return null;
		}
		const tmpLeaves = new Set();
		for (const tmpIDLab of tmpInput)
		{
			const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
			if (tmpChildren && tmpChildren.size > 0)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpLeaves.add(tmpChild);
				}
				continue;
			}
			tmpLeaves.add(tmpIDLab);
		}
		return (tmpLeaves.size > 0) ? tmpLeaves : tmpInput;
	}

	/**
	 * Every lab in the families rooted at the given labs — each root plus its children. The root itself is
	 * included so a childless parent lab stays selectable per-test.
	 *
	 * @param {Set<number>|Array<number>} pRootIDs
	 *
	 * @return {Set<number>}
	 */
	expandFamilies(pRootIDs)
	{
		const tmpFamily = new Set();
		for (const tmpRoot of this._toSet(pRootIDs))
		{
			tmpFamily.add(tmpRoot);
			const tmpChildren = this._ChildrenByParent.get(tmpRoot);
			if (tmpChildren)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpFamily.add(tmpChild);
				}
			}
		}
		return tmpFamily;
	}

	/**
	 * The distinct parent labs standing over a set of labs.
	 *
	 * @param {Set<number>|Array<number>} pLabIDs
	 *
	 * @return {Set<number>}
	 */
	rootsOf(pLabIDs)
	{
		const tmpRoots = new Set();
		for (const tmpIDLab of this._toSet(pLabIDs))
		{
			const tmpRoot = this.getParentLabID(tmpIDLab);
			if (tmpRoot > 0)
			{
				tmpRoots.add(tmpRoot);
			}
		}
		return tmpRoots;
	}

	/**
	 * Collapse a bench to the lab its results aggregate to. `AggregateTo` on a PARENT means its benches'
	 * tests roll up to it; `AggregateTo` on the bench itself means the bench is the aggregation point and
	 * stays put.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {number}
	 */
	applyAggregation(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return 0;
		}
		const tmpLab = this._Labs.get(tmpIDLab);
		if (!tmpLab || tmpLab.AggregateTo)
		{
			return tmpIDLab;
		}
		const tmpParentID = this.getParentLabID(tmpIDLab);
		const tmpParent = (tmpParentID !== tmpIDLab) ? this._Labs.get(tmpParentID) : null;
		return (tmpParent && tmpParent.AggregateTo) ? tmpParentID : tmpIDLab;
	}

	/**
	 * The specification-set lab floor, expanded across the lab family: a lab is admitted when IT is in
	 * `LabTestSpecificationSetJoin`, when its PARENT is, or when any of its CHILDREN is.
	 *
	 * Membership is declared at the FAMILY level — the set names the parent labs and their benches come
	 * along — so raw membership empties whichever level the set was not authored at. The floor's real job,
	 * separating parallel lab generations mid-rename, survives the expansion because generations differ by
	 * FAMILY: expanding within a family never reaches across to the other one.
	 *
	 * @param {Set<number>|Array<number>|null} pAdmittedLabIDs - the raw joined lab ids.
	 *
	 * @return {Set<number>|null} null when the join has no coverage (no floor at all).
	 */
	expandSpecSetFloor(pAdmittedLabIDs)
	{
		const tmpAdmitted = this._toSet(pAdmittedLabIDs);
		if (tmpAdmitted.size < 1)
		{
			return null;
		}
		const tmpFloor = new Set(tmpAdmitted);
		for (const tmpIDLab of tmpAdmitted)
		{
			const tmpParent = this.getParentLabID(tmpIDLab);
			if (tmpParent > 0)
			{
				tmpFloor.add(tmpParent);
			}
			for (const tmpChild of this.getChildLabIDs(tmpIDLab))
			{
				tmpFloor.add(tmpChild);
			}
		}
		return tmpFloor;
	}

	// --- selection -----------------------------------------------------------------------------------

	/**
	 * The PARENT lab a sample should be assigned to.
	 *
	 * Candidates are the parents standing over whatever the caller resolved from `LabTestDefault`, ranked:
	 * an affinity-matched parent (in rule order — the project's own district laboratory before its field
	 * unit) wins, then one of the project's own labs, then the first candidate, which is the answer this
	 * gave before any routing configuration existed.
	 *
	 * With no candidates at all the affinity and project axes still answer on their own, so configuring
	 * routing rules ADDS defaulting where a material carried no `LabTestDefault` rather than removing it.
	 *
	 * @param {Set<number>|Array<number>} pCandidateLabIDs - labs resolved from `LabTestDefault` (any level).
	 * @param {SampleLabContext} [pContext]
	 *
	 * @return {LabSelection}
	 */
	selectSampleLabID(pCandidateLabIDs, pContext)
	{
		const tmpContext = pContext || {};
		const tmpAffinityRootIDs = Array.isArray(tmpContext.AffinityRootIDs) ? tmpContext.AffinityRootIDs : [];
		const tmpProjectRoots = this.rootsOf(tmpContext.ProjectRootLabIDs);
		const tmpCandidateRoots = this.rootsOf(pCandidateLabIDs);
		if (tmpCandidateRoots.size > 0)
		{
			for (const tmpAffinityRoot of tmpAffinityRootIDs)
			{
				if (tmpCandidateRoots.has(tmpAffinityRoot))
				{
					return { IDLab: tmpAffinityRoot, Source: 'Affinity' };
				}
			}
			const tmpInProject = this._lowest(this._intersect([ tmpCandidateRoots, tmpProjectRoots ]));
			if (tmpInProject > 0)
			{
				return { IDLab: tmpInProject, Source: 'ProjectLabJoin' };
			}
			return { IDLab: Array.from(tmpCandidateRoots)[0], Source: 'LabTestDefault' };
		}
		for (const tmpAffinityRoot of tmpAffinityRootIDs)
		{
			if (tmpProjectRoots.size < 1 || tmpProjectRoots.has(tmpAffinityRoot))
			{
				return { IDLab: tmpAffinityRoot, Source: 'Affinity' };
			}
		}
		return { IDLab: 0, Source: 'None' };
	}

	/**
	 * The LEAF lab that should run a test.
	 *
	 * Intersects the axes that carry data — the test's capable labs, the families of the sample's parent
	 * labs, and the families of the project's labs — keeps only leaves, applies the specification-set floor,
	 * then narrows by `LabTestDefault` where that does not empty the result. A tie is broken only when
	 * something distinguishes the benches — the project's own labs in routing-rule order, then the sample's
	 * lab families — and each tier must resolve to exactly one bench to settle it.
	 *
	 * Returns 0 when no axis carries data, the floor admits nothing, or the tie stands; the caller falls back
	 * to the sample's parent lab rather than guessing a bench.
	 *
	 * @param {number|string} pIDTest
	 * @param {TestLabContext} [pContext]
	 *
	 * @return {LabSelection}
	 */
	selectTestLabID(pIDTest, pContext)
	{
		const tmpContext = pContext || {};
		/** @type {Array<Set<number>>} */
		const tmpAxes = [];
		const tmpTestLabs = this.resolveToLeaves(tmpContext.TestLabIDs);
		if (tmpTestLabs)
		{
			tmpAxes.push(tmpTestLabs);
		}
		const tmpParentFamilies = this.expandFamilies(tmpContext.ParentLabIDs);
		if (tmpParentFamilies.size > 0)
		{
			tmpAxes.push(tmpParentFamilies);
		}
		const tmpProjectFamilies = this.expandFamilies(tmpContext.ProjectRootLabIDs);
		if (tmpProjectFamilies.size > 0)
		{
			tmpAxes.push(tmpProjectFamilies);
		}
		if (tmpAxes.length < 1)
		{
			return { IDLab: 0, Source: 'None' };
		}
		// Leaf grain is an invariant of this selection, not a property of one axis: the family axes carry
		// their roots so a childless parent stays selectable, and with no TestLabJoin rows those roots
		// would otherwise be chosen.
		let tmpCandidates = this._keepLeaves(this._intersect(tmpAxes));
		if (tmpContext.SpecSetFloor && tmpContext.SpecSetFloor.size > 0)
		{
			tmpCandidates = this._intersect([ tmpCandidates, tmpContext.SpecSetFloor ]);
		}
		if (tmpCandidates.size < 1)
		{
			return { IDLab: 0, Source: 'None' };
		}
		let tmpSource = tmpTestLabs ? 'TestLabJoin' : 'ParentFamily';
		const tmpDefaults = this.resolveToLeaves(tmpContext.TestLabDefaultIDs);
		if (tmpDefaults)
		{
			const tmpNarrowed = this._intersect([ tmpCandidates, tmpDefaults ]);
			if (tmpNarrowed.size > 0)
			{
				tmpCandidates = tmpNarrowed;
				tmpSource = 'LabTestDefault';
			}
		}
		if (tmpCandidates.size === 1)
		{
			return { IDLab: Array.from(tmpCandidates)[0], Source: tmpSource };
		}
		// Ties are broken only where something actually distinguishes the benches — the project's own labs in
		// routing-rule order, then the sample's lab families. Guessing between equals is how a router ends up
		// sending a test to the wrong bench, so an unbroken tie declines and the caller keeps the sample's
		// parent lab, where a technician can route it by hand.
		const tmpAffinityRootIDs = Array.isArray(tmpContext.AffinityRootIDs) ? tmpContext.AffinityRootIDs : [];
		for (const tmpAffinityRoot of tmpAffinityRootIDs)
		{
			const tmpInFamily = this._filterByRoot(tmpCandidates, tmpAffinityRoot);
			if (tmpInFamily.size === 1)
			{
				return { IDLab: Array.from(tmpInFamily)[0], Source: 'Affinity' };
			}
		}
		const tmpParentRoots = this.rootsOf(tmpContext.ParentLabIDs);
		const tmpInParentFamily = new Set();
		for (const tmpIDLab of tmpCandidates)
		{
			if (tmpParentRoots.has(this.getParentLabID(tmpIDLab)))
			{
				tmpInParentFamily.add(tmpIDLab);
			}
		}
		if (tmpInParentFamily.size === 1)
		{
			return { IDLab: Array.from(tmpInParentFamily)[0], Source: 'ParentFamily' };
		}
		return { IDLab: 0, Source: 'Ambiguous' };
	}

	// --- affinity ------------------------------------------------------------------------------------

	/**
	 * The parent labs belonging to a project, from the `LabRouting` naming rules, in rule (priority) order.
	 * Cached per project. Every step fails open to "no affinity", which costs the routing preference and
	 * nothing else — the data axes still answer.
	 *
	 * @param {number} pIDProject
	 * @param {LabRoutingConfiguration} [pLabRoutingConfig]
	 *
	 * @return {Promise<Array<number>>}
	 */
	async getAffinityRootIDs(pIDProject, pLabRoutingConfig)
	{
		if (!pLabRoutingConfig || !Array.isArray(pLabRoutingConfig.Rules) || pLabRoutingConfig.Rules.length < 1 || !(pIDProject > 0))
		{
			return [];
		}
		if (this._AffinityByProject.has(pIDProject))
		{
			return this._AffinityByProject.get(pIDProject);
		}
		let tmpMatched = [];
		try
		{
			await this.loadLabCatalog();
			const tmpProject = this._Readers ? await this._Readers.get(`Project/${pIDProject}`) : null;
			const tmpKeys = this.resolveAffinityKeys(pLabRoutingConfig, this.readCustomProperties(tmpProject));
			tmpMatched = this.matchAffinityRules(pLabRoutingConfig, tmpKeys);
			this.fable.log.info(`Lab routing affinity for project ${pIDProject} resolved keys ${JSON.stringify(tmpKeys)} to parent labs [${tmpMatched.join(',')}]`);
		}
		catch (pError)
		{
			this.fable.log.warn(`Lab routing affinity failed to resolve for project ${pIDProject}; continuing without it: ${pError.message}`);
			tmpMatched = [];
		}
		this._AffinityByProject.set(pIDProject, tmpMatched);
		return tmpMatched;
	}

	/**
	 * `CustomProperties` as an object, whether it arrives parsed or as a JSON string.
	 *
	 * @param {Record<string, any>|null} pProject
	 *
	 * @return {Record<string, any>}
	 */
	readCustomProperties(pProject)
	{
		const tmpRaw = pProject ? pProject.CustomProperties : null;
		if (!tmpRaw)
		{
			return {};
		}
		if (typeof tmpRaw !== 'string')
		{
			return tmpRaw;
		}
		try
		{
			return JSON.parse(tmpRaw) || {};
		}
		catch (pError)
		{
			return {};
		}
	}

	/**
	 * Resolve each configured key to its first non-empty project value. A value that is all digits and
	 * numerically zero is the customer's "unassigned" sentinel and counts as unset.
	 *
	 * @param {LabRoutingConfiguration} pLabRoutingConfig
	 * @param {Record<string, any>} pProperties
	 *
	 * @return {Record<string, string>}
	 */
	resolveAffinityKeys(pLabRoutingConfig, pProperties)
	{
		/** @type {Record<string, string>} */
		const tmpKeys = {};
		const tmpProjectKeys = pLabRoutingConfig.ProjectKeys || {};
		for (const tmpName of Object.keys(tmpProjectKeys))
		{
			const tmpCandidates = Array.isArray(tmpProjectKeys[tmpName]) ? tmpProjectKeys[tmpName] : [ tmpProjectKeys[tmpName] ];
			for (const tmpCandidate of tmpCandidates)
			{
				const tmpRaw = (pProperties || {})[tmpCandidate];
				const tmpValue = (tmpRaw === null || tmpRaw === undefined) ? '' : String(tmpRaw).trim();
				if (tmpValue === '' || (/^\d+$/.test(tmpValue) && Number(tmpValue) === 0))
				{
					continue;
				}
				tmpKeys[tmpName] = tmpValue;
				break;
			}
		}
		return tmpKeys;
	}

	/**
	 * The parent labs matched by the routing rules, in rule order.
	 *
	 * @param {LabRoutingConfiguration} pLabRoutingConfig
	 * @param {Record<string, string>} pKeys
	 *
	 * @return {Array<number>}
	 */
	matchAffinityRules(pLabRoutingConfig, pKeys)
	{
		const tmpMatched = [];
		for (const tmpRule of (pLabRoutingConfig.Rules || []))
		{
			if (!tmpRule || !tmpRule.LabField || !tmpRule.Pattern)
			{
				continue;
			}
			const tmpRequires = Array.isArray(tmpRule.Requires) ? tmpRule.Requires : Object.keys(pKeys);
			if (tmpRequires.some((pRequired) => !pKeys[pRequired]))
			{
				continue;
			}
			let tmpExpression;
			try
			{
				tmpExpression = new RegExp(this.interpolatePattern(tmpRule.Pattern, pKeys), tmpRule.Flags || 'i');
			}
			catch (pError)
			{
				this.fable.log.warn(`Lab routing rule pattern is not a valid expression: ${tmpRule.Pattern}`);
				continue;
			}
			for (const tmpLab of this._Labs.values())
			{
				const tmpIDLab = parseInt(tmpLab.IDLab, 10);
				// Routing rules name the destination, so only parents are matched; benches inherit.
				if (this.getParentLabID(tmpIDLab) !== tmpIDLab || tmpMatched.indexOf(tmpIDLab) > -1)
				{
					continue;
				}
				const tmpFieldValue = (tmpLab[tmpRule.LabField] === null || tmpLab[tmpRule.LabField] === undefined) ? '' : tmpLab[tmpRule.LabField];
				if (tmpExpression.test(String(tmpFieldValue)))
				{
					tmpMatched.push(tmpIDLab);
				}
			}
		}
		return tmpMatched;
	}

	/**
	 * Fill `{KeyName}` placeholders in a rule pattern. An all-digits value interpolates as `0*<digits>` with
	 * leading zeros stripped, so one pattern matches both `District 02 Lab` and `District 2 Lab` and the
	 * customer's project metadata does not have to agree with its lab names on zero-padding. Anything else is
	 * escaped and matched literally.
	 *
	 * @param {string} pPattern
	 * @param {Record<string, string>} pKeys
	 *
	 * @return {string}
	 */
	interpolatePattern(pPattern, pKeys)
	{
		return String(pPattern).replace(/\{([A-Za-z0-9_]+)\}/g, (pMatch, pName) =>
		{
			const tmpValue = pKeys[pName];
			if (tmpValue === undefined)
			{
				return pMatch;
			}
			if (/^\d+$/.test(tmpValue))
			{
				return `0*${String(Number(tmpValue))}`;
			}
			return tmpValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		});
	}

	// --- helpers -------------------------------------------------------------------------------------

	/**
	 * @param {Set<number>|Array<number>|null|undefined} pValues
	 *
	 * @return {Set<number>} the positive integers in the input.
	 */
	_toSet(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of (pValues || []))
		{
			const tmpID = parseInt(String(tmpValue), 10);
			if (tmpID > 0)
			{
				tmpSet.add(tmpID);
			}
		}
		return tmpSet;
	}

	/**
	 * @param {Array<Set<number>>} pSets
	 *
	 * @return {Set<number>}
	 */
	_intersect(pSets)
	{
		const tmpResult = new Set(pSets[0]);
		for (let i = 1; i < pSets.length; i++)
		{
			for (const tmpValue of Array.from(tmpResult))
			{
				if (!pSets[i].has(tmpValue))
				{
					tmpResult.delete(tmpValue);
				}
			}
		}
		return tmpResult;
	}

	/**
	 * Drop any lab that routes further — a parent with benches beneath it. Its benches, when they qualify,
	 * are already in the set beside it.
	 *
	 * @param {Set<number>} pLabIDs
	 *
	 * @return {Set<number>}
	 */
	_keepLeaves(pLabIDs)
	{
		const tmpLeaves = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			if (this.isLeafLab(tmpIDLab))
			{
				tmpLeaves.add(tmpIDLab);
			}
		}
		return tmpLeaves;
	}

	/**
	 * @param {Set<number>} pLabIDs
	 * @param {number} pRootID
	 *
	 * @return {Set<number>} the members of pLabIDs standing under pRootID.
	 */
	_filterByRoot(pLabIDs, pRootID)
	{
		const tmpMatched = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			if (this.getParentLabID(tmpIDLab) === pRootID)
			{
				tmpMatched.add(tmpIDLab);
			}
		}
		return tmpMatched;
	}

	/**
	 * @param {Set<number>} pLabIDs
	 *
	 * @return {number} the lowest id in the set, or 0 when it is empty.
	 */
	_lowest(pLabIDs)
	{
		let tmpLowest = 0;
		for (const tmpIDLab of pLabIDs)
		{
			if (tmpLowest === 0 || tmpIDLab < tmpLowest)
			{
				tmpLowest = tmpIDLab;
			}
		}
		return tmpLowest;
	}
}

module.exports = MaterialsLabRouter;

},{"fable-serviceproviderbase":398}],17:[function(require,module,exports){

const Util = require('util');

const PictApplication = require('pict-application');
const PictSectionForm = require('pict-section-form');
const PictFormMetacontroller = require('pict-section-form/source/views/Pict-View-Form-Metacontroller.js');
const PictSectionModal = require('pict-section-modal');

const HeadlightRestClient = require('headlight-rest-client');
const HeadlightViewSignatures = require('headlight-view-signatures');
const HeadlightPanels = require('headlight-view-panels');
const HeadlightViewLogin = require('headlight-view-login');

const InputTypeBehaviorProvider = require('./providers/InputTypeBehaviorProvider.js');
const DistillingProvider = require('./providers/DistillingProvider.js');
const AutoSaveProvider = require('./providers/AutoSaveProvider.js');

const ManifestConditionEvaluator = require('./services/ManifestConditionEvaluator.js');
const HeadlightFormLoadTiming = require('./services/Headlight-FormLoadTiming.js');

const libHeadlightQuickSummariesService = require('../../../../lib/web/headlight-quick-summaries/Headlight-Quick-Summaries-Service.js');

//FIXME: hack to hook into onAfterRenderAsync to perform local initialization
const originalPictFormMetacontrollerOnAfterRenderAsync = PictFormMetacontroller.prototype.onAfterRenderAsync;
PictFormMetacontroller.prototype.onAfterRenderAsync = function(pRenderable)
{
	const res = originalPictFormMetacontrollerOnAfterRenderAsync.call(this, pRenderable);
	this.onAfterRenderAsyncCallbacks?.forEach((callback) => callback());
	return res;
};

//FIXME: hack to hook into onAfterRender to perform local initialization
const originalPictFormMetacontrollerOnAfterMarshalToView = PictFormMetacontroller.prototype.onAfterMarshalToView;
PictFormMetacontroller.prototype.onAfterMarshalToView = function()
{
	const res = originalPictFormMetacontrollerOnAfterMarshalToView.call(this);
	this.onAfterMarshalToViewCallbacks?.forEach((callback) => callback());
	return res;
};

/** @typedef {import('./providers/DistillingProvider.js').FieldDistillingMapping} FieldDistillingMapping */

/**
 * FIXME: figure out how to flow these types through in a more sane way...
 * @typedef {import('pict') & import('fable') &
 * {
 *   HeadlightRestClient: import('headlight-rest-client'),
 *   MetaTemplate: any, // import('fable').MetaTemplate,
 *   views: { PictFormMetacontroller: import('pict-section-form').PictFormMetacontroller },
 *   fable: import('fable'),
 *   PictApplication: HeadlightConfigurableApplication,
 *   providers: {
 *     Input: import('./providers/InputTypeBehaviorProvider'),
 *     Distilling: import('./providers/DistillingProvider'),
 *     AutoSave: import('./providers/AutoSaveProvider'),
 *     PictFormSectionDefaultTemplateProvider: import('pict-section-form').PictFormTemplateProvider,
 *   },
 *   options: {
 *     Timezone: string,
 *     [key: string]: any,
 *   },
 * }} Pict
 */

/** @typedef {import('fable')} Fable */
/** @typedef {(pError?: Error) => void} ErrorCallback */


/**
 * Base class for Pict applications with configuration driven UI.
 *
 * Comes with pre-registered stock views and providers.
 *
 * NOTE: This class is a merge of each layer with an attempt to normalize and refactor.
 */
class HeadlightConfigurableApplication extends PictApplication
{
	/**
	 * Apply default options to the passed in options, if absent.
	 *
	 * @param {Object} pOptions - The options to apply defaults to.
	 */
	static applyDefaultOptions(pOptions)
	{
		if (!pOptions.Login)
		{
			pOptions.Login = { };
		}
		if (!('Required' in pOptions.Login))
		{
			pOptions.Login.Required = true;
		}
		if (!pOptions.Document)
		{
			pOptions.Document = { };
		}
		if (!('Required' in pOptions.Document))
		{
			pOptions.Document.Required = true;
		}
	}

	/**
	 * Check whether a builtin section should be rendered.
	 *
	 * Builtin section values follow this convention:
	 *   - `undefined` / `null` → enabled (shown by default)
	 *   - `false`              → disabled (hidden)
	 *   - `true`               → enabled
	 *   - any other value (e.g. a template string) → enabled (future use)
	 *
	 * @param {boolean | string | undefined | null} pBuiltinValue - The value from `manifest.Builtins.<Section>`.
	 * @return {boolean} `true` if the section should be shown, `false` if it should be hidden.
	 */
	static isBuiltinSectionEnabled(pBuiltinValue)
	{
		if (pBuiltinValue === undefined || pBuiltinValue === null)
		{
			return true;
		}
		return pBuiltinValue !== false;
	}

	/**
	 * Perform any pre-processing needed on the form definition.
	 *
	 * @param {Object<String, any>} formDefinition - The form definition to preprocess.
	 *
	 * @return {Object<String, any>} - The processed form definition. (it's just the original one, mutated)
	 */
	static preprocessFormDefinition(formDefinition)
	{
		//NOTE: This prevents PictSectionForm from automatically bootstrapping views and allows us to control when that happens.
		if (formDefinition?.DefaultFormManifest)
		{
			formDefinition.MyDefaultFormManifest = formDefinition.DefaultFormManifest;
			delete formDefinition.DefaultFormManifest;
		}
		// duck typing
		if (!formDefinition?.MyDefaultFormManifest?.Descriptors)
		{
			console.error(`Form manifest Descriptors is missing. No form configuration found.`, { formDefinition });
			return formDefinition;
		}
		let descriptors = formDefinition.MyDefaultFormManifest.Descriptors;
		descriptors = HeadlightConfigurableApplication.repairDescriptorMap(descriptors) || descriptors;
		descriptors = HeadlightConfigurableApplication.backfillWidthValueForDescriptors(descriptors) || descriptors;
		for (const descriptor of Object.values(descriptors))
		{
			InputTypeBehaviorProvider.validateDescriptor(descriptor);
			if (descriptor.PictForm?.DistillingKey)
			{
				if (descriptor.PictForm?.SelectOptionsPickList)
				{
					continue;
				}
				const tmpPickLists = formDefinition.MyDefaultFormManifest.PickLists || [];
				formDefinition.MyDefaultFormManifest.PickLists = tmpPickLists;
				const tmpPickListHash = `Distilling-${descriptor.PictForm.DistillingBundleHash}-${descriptor.PictForm.DistillingKey}`;
				descriptor.PictForm.SelectOptionsPickList = tmpPickListHash;
				if (!tmpPickLists.find((pl) => pl.Hash === tmpPickListHash))
				{
					tmpPickLists.push({ Hash: tmpPickListHash, Dynamic: true });
				}
			}
		}
		formDefinition.MyDefaultFormManifest.Descriptors = descriptors;
		return formDefinition;
	}

	/**
	 * Align all sections to 12 columns
	 *
	 * TODO: Pretty sure we can do this inside pict by making a default value but not sure how off the top of my head. Pre-process descriptors here
	 *
	 * @param {any} descriptorMap - The descriptor map to backfill.
	 *
	 * @return {any} - The backfilled descriptor map.
	 */
	static backfillWidthValueForDescriptors(descriptorMap)
	{
		if (Array.isArray(descriptorMap))
		{
			console.error(`Form manifest Descriptors is an array. Fatal error. Cannot continue.`, { descriptorMap });
			throw new Error('Descriptors should be an object, not an array');
		}

		for (const descriptor of Object.values(descriptorMap))
		{
			descriptor.Width = descriptor.Width || 1;
		}

		return descriptorMap;
	}

	/**
	 * Repair the descriptor map to be an object instead of an array.
	 *
	 * @param {any} descriptorMap - The descriptor map to repair.
	 *
	 * @return {Object<String, any> | any} - The repaired descriptor map, or the original value if it is not an array.
	 */
	static repairDescriptorMap(descriptorMap)
	{
		if (Array.isArray(descriptorMap))
		{
			console.error(`Form manifest Descriptors is an array which is not supported. Converting to object.`, { descriptorMap });
			//FIXME: this is a hack to make sure this works - template needs to be converted
			const newDescriptorMap = { };
			for (const descriptor of descriptorMap)
			{
				if (descriptor.Hash in newDescriptorMap)
				{
					console.error(`Duplicate descriptor hash found. Skipping.`, { descriptor });
					continue;
				}
				newDescriptorMap[descriptor.Hash] = descriptor;
			}
			console.trace(`Converted Descriptors to object.`, { newDescriptorMap });
			if (Object.keys(newDescriptorMap).length != descriptorMap.length)
			{
				console.error(`Descriptor map array had duplicate keys. Converted object is smaller. (${Object.keys(newDescriptorMap).length} != ${descriptorMap.length})`);
			}
			return newDescriptorMap;
		}
		return descriptorMap;
	}

	/**
	 * @param {Fable} pFable - The fable instance.
	 * @param {Object} [pOptions] - The options for the application.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = (pOptions || {});
		HeadlightConfigurableApplication.applyDefaultOptions(tmpOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Phase 0 form-load instrumentation. Constructed first so `Boot` is marked as early as the
		// application can mark anything; its startTime carries everything the page did before this.
		// See services/Headlight-FormLoadTiming.js for the phases and how to read the numbers.
		/** @type {HeadlightFormLoadTiming} */
		this.FormLoadTiming = new HeadlightFormLoadTiming(
		{
			Log: this.pict?.log,
			Context: this.options?.ApplicationName || 'Form',
		});
		this.markFormLoadPhase('Boot');

		/**
		 * FIXME: figure out how to flow these types through in a more sane way...
		 * @type {Pict}
		 */
		this.pict;

		/** @type {Fable} */
		this.fable;

		/** @type {any} */
		this.options;

		this.registerServiceTypes(
		{
			HeadlightRestClient,
			HeadlightStationing: require('../../../../lib/service/headlight-stationing-service/Headlight-Stationing.js'),
			HeadlightQRCodeHash: require('../../../../lib/service/headlight-qrcode-hash-service/Headlight-QRCodeHash.js'),
			HeadlightHintHighlighting: require('./services/Headlight-HintHighlighting.js'),
			HeadlightDocumentService: require('./services/Headlight-Document-Service.js'),
		});

		this.instantiateServices(
		{
			HeadlightRestClient: { ServerURL: this.options.HeadlightAPIURL || '/1.0/' },
			HeadlightStationing: { },
			HeadlightQRCodeHash: { },
			HeadlightHintHighlighting: { },
			HeadlightDocumentService: { },
		});

		/** @type {HeadlightViewSignatures} */
		this.pict.views.HeadlightSignatures;
		/**
		 * @type {HeadlightViewLogin}
		 */
		this.pict.views.HeadlightLogin;

		/**
		 * @type {Object<String, any>}
		 */
		this.services;

		// Add the pict form service
		this.pict.addServiceType('PictSectionForm', PictSectionForm);

		// Add the pict form metacontroller service, which provides programmaatic view construction from manifests and render/marshal methods.
		this.pict.addView('PictFormMetacontroller', {}, PictSectionForm.PictFormMetacontroller);

		this.pict.views.PictFormMetacontroller.onAfterRenderAsyncCallbacks = [];
		this.pict.views.PictFormMetacontroller.onAfterMarshalToViewCallbacks = [];

		// pict-section-modal — the canonical modal/tooltip view. Registered here in
		// the shared base so every web app and document that renders dynamic-input
		// forms has the tooltip surface the chips use (PictProvider-ChipTooltips
		// attaches pinnable tooltips to chip anchors). Guarded so an app that
		// already registered it (e.g. the data dashboards) isn't clobbered. Chips
		// degrade to native title tooltips if this is ever absent.
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addViewSingleton('Pict-Section-Modal', PictSectionModal.default_configuration, PictSectionModal);
		}
		/**
		 * @type {{
		 *	Interactive: boolean,
		 *	InitialSaveRequired: boolean,
		 *	Status: string,
		 *	DistillingMapping: Array<FieldDistillingMapping>,
		 *	Select2OptionsCache: Object<String, Array<{ id: string, text: string }>>,
		 *	DocumentData: any,
		 *	CurrentUser: any,
		 *	[key: string]: any, // allow for arbitrary data to be added
		 * }}
		 */
		this.AppData;
		// this is set on each index.html for the respective document behavior
		this.AppData.Interactive = window._InteractiveForm;

		// log noise level for pict
		this.pict.LogNoisiness = this.options.LogNoisiness ?? 0;

		//FIXME: what layer does this belong at - some kind of "reports" customization layer?
		const tempSessionToken = this.pict.ContentAssignment.readContent('#DocumentObjectSessionToken');
		if (tempSessionToken)
		{
			this.pict.HeadlightRestClient.setUrlParam('SessionToken', String(tempSessionToken));
		}

		// do a basic "to lower case" operation on the data
		this.pict.MetaTemplate.addPattern('{~ToLowerCase:', '~}', (pHash, pData, pContextArray) =>
		{
			const value = this.pict.manifest.getValueAtAddress(pData, pHash);
			return (value === undefined || value === null) ? '' : String(value).toLowerCase();
		});

		// create disabled attribute for values that are set to true
		this.pict.MetaTemplate.addPattern('{~Attr:', '~}', (pHash, pData, pContextArray) =>
		{
			// split on first colon only
			const [ attr, path ] = pHash.split(/:(.*)/s);
			if (!path)
			{
				this.pict.log.error('Invalid path in {~Attr:...~} pattern', pHash);
				return '';
			}

			let value = this.pict.manifest.getValueAtAddress(pData, path);
			if (!value)
			{
				return '';
			}

			// these attributes values should be the same as their name
			// I dont think this is a hard requirement but its cleaner than having random values in there
			if ([ 'disabled', 'readonly' ].includes(attr))
			{
				value = attr;
			}

			return `${attr}="${value}"`;
		});

		// include all three themes for the document (edit, read, print)
		this.registerProviders(
		{
			Input: { Provider: InputTypeBehaviorProvider, Options: { } },
			Distilling: { Provider: DistillingProvider, Options: { } },
			AutoSave: { Provider: AutoSaveProvider, Options: { } },
			SessionProvider: { Provider: require('../../../../web/providers/Session-Provider.js'), Options: { } },
		});

		// callbacks to run after the form is rendered
		this.pict.views.PictFormMetacontroller.onAfterRenderAsyncCallbacks.push(() =>
		{
			this.onAfterRenderAsync();
		});

		// callbacks to run after the form is marshalled to the view
		this.pict.views.PictFormMetacontroller.onAfterMarshalToViewCallbacks.push(() =>
		{
			// only run this if we are in interactive mode
			if (!this.AppData.Interactive)
			{
				return;
			}

			this.pict.log.info('onAfterMarshalToView running...');
			// find elements with dynamic-data-lookup and set their values based on entity and ID
			$('input.dynamic-data-lookup').each((_, element) =>
			{
				const $element = $(element);
				const entityType = $element.attr('data-entity-type');
				const entityDisplayField = $element.attr('data-entity-field');
				const entityIDField = $element.attr('data-entity-id');
				const entityIDElementID = $element.attr('data-entity-html-ref-id');
				const idElement = entityIDElementID ? $(`#${entityIDElementID}`) : null;

				let record;
				switch (entityType)
				{
				case 'Project':
					record = this.AppData.DocumentData?.ReportData?.Project;
					break;
				}
				const id = record?.[entityIDField];
				if (id && idElement)
				{
					idElement.val(id);
				}
				const value = record?.[entityDisplayField];
				if (value)
				{
					$element.val(value);
				}
			});
			this.pict.log.info('onAfterMarshalToView done.');
		});
		this.pict.serviceManager.addAndInstantiateServiceType('HeadlightQuickSummaries', libHeadlightQuickSummariesService);
	}

	/**
	 * Record a form-load phase for the Phase 0 latency instrumentation.
	 *
	 * The base marks Boot, SessionReady, DocumentLoaded and FirstRender itself. Subclasses mark
	 * SpinnerRemoved from their own removeLoadingSpinner(), which is what emits the summary line.
	 * Safe to call from anywhere: unknown or repeated phases are ignored and nothing here throws.
	 *
	 * @param {String} pPhase - One of the phases in services/Headlight-FormLoadTiming.js.
	 * @return {Boolean} True when this call recorded the phase.
	 */
	markFormLoadPhase(pPhase)
	{
		// Every mark call site sits in front of work the form needs (the render callback, the login
		// callback, the spinner teardown), so nothing below this line is allowed to escape.
		try
		{
			return this.FormLoadTiming ? this.FormLoadTiming.mark(pPhase) : false;
		}
		catch (pError)
		{
			return false;
		}
	}

	/**
	 * Marshals data from any rendered dynamic views to application data.
	 */
	marshalDataFromDynamicViewsToAppData()
	{
		this.pict.views.PictFormMetacontroller.marshalFromView();
	}

	/**
	 * Marshals data from the application data to any rendered dynamic views.
	 */
	marshalDataFromAppDataToDynamicViews()
	{
		this.pict.views.PictFormMetacontroller.marshalToView();
	}

	/**
	 * Called during construction to register service types. Override to mutate or add service types.
	 *
	 * @param {Object<String, any>} pServiceTypes - The service types to register.
	 */
	registerServiceTypes(pServiceTypes)
	{
		for (const [ serviceHash, serviceClass ] of Object.entries(pServiceTypes))
		{
			this.fable.serviceManager.addServiceType(serviceHash, serviceClass);
		}
	}

	/**
	 * Called during construction to instantiate services. Override to mutate or add services and options.
	 *
	 * @param {Object<String, Object>} pServiceOptions - The service options to instantiate.
	 */
	instantiateServices(pServiceOptions)
	{
		for (const [ serviceHash, serviceOptions ] of Object.entries(pServiceOptions))
		{
			this.fable.serviceManager.instantiateServiceProvider(serviceHash, serviceOptions);
		}
	}

	/**
	 * Called during construction to register providers. Override to mutate or add providers.
	 *
	 * @param {Object<String, { Provider: any, Options: Object }>} pProviders - The providers to register.
	 */
	registerProviders(pProviders)
	{
		for (const [ providerHash, providerSetup ] of Object.entries(pProviders))
		{
			this.pict.addProvider(providerHash, providerSetup.Options, providerSetup.Provider);
		}
	}

	/**
	 * Called during onInitialize to instantiate shared views. Override to mutate or add shared views.
	 *
	 * @param {Object<String, { View: any, Options: Object }>} pViews - The views to instantiate.
	 */
	instantiateGlobalViews(pViews)
	{
		for (const [ viewHash, viewSetup ] of Object.entries(pViews))
		{
			viewSetup.preInitialize?.(this);
			this.pict.addView(viewHash, viewSetup.Options, viewSetup.View);
			viewSetup.postInitialize?.(this);
		}
	}

	/**
	 * Check if the document has a logo preference set in the report options via the RNI.
	 * @return {string} - The source path for the document logo image
	 */
	getDocumentLogoSource()
	{
		// check if the document has a program logo set in the document data
		const programId = this.AppData.DocumentData?.ReportData?.IDProgram;
		const programLogo = this.AppData.DocumentData?.ReportData?.ProgramLogoURL;
		if (programId && programLogo)
		{
			return programLogo;
		}
		// check if the document has a logo set in the report options
		const configLogo = this.AppData.DocumentData?.ReportOptions?.Header?.logoPreference || '';
		if (configLogo)
		{
			if (configLogo.toLowerCase() === 'customer')
			{
				return `Assets/customer_report_logo.png`;
			}
			else if (configLogo.toLowerCase() === 'project')
			{
				return `Assets/project_report_logo.png`;
			}
		}
	};

	/**
	 * TEMPORARY? Provide an on-after-render callback for the metacontroller.
	 * @param {Function} [fCallback] - The callback to call when the method has completed.
	 */
	onAfterRenderAsync(fCallback)
	{
		const logoSrc = this.getDocumentLogoSource();
		if (logoSrc)
		{
			const tmpLogoWrapper = document.getElementById('Document-Logo-Wrapper');
			if (tmpLogoWrapper)
			{
				this.pict.ContentAssignment.assignContent('#Document-Logo-Wrapper', /*html*/`<img class="image" src="${ logoSrc }" style="max-height: 100px" alt="Logo" />`);
			}
		}

		if (fCallback)
		{
			fCallback();
		}
	}

	/**
	 * View initialization lifecycle hook.
	 * @return {boolean}
	 */
	onInitialize()
	{
		this.instantiateGlobalViews(
		{
			HeadlightSignatures: { View: HeadlightViewSignatures, Options: { } },
			HeadlightLogin:
			{
				View: HeadlightViewLogin,
				Options: false, // ???
				preInitialize: (app) =>
				{
					// create a login section for every form
					let loginSection = document.getElementById('HeadlightLogin-Standard-Wrap');
					if (!loginSection)
					{
						loginSection = document.createElement('section');
						loginSection.id = 'HeadlightLogin-Standard-Wrap';
						document.body.appendChild(loginSection);
					}
				},
			},
			HeadlightPanels:
			{
				View: HeadlightPanels,
				Options: this.options.HeadlightPanels,
				preInitialize: (app) =>
				{
					// create a panel section for every form
					let panelSection = document.getElementById('HeadlightPanels-Container');
					if (!panelSection)
					{
						panelSection = document.createElement('section');
						panelSection.id = 'HeadlightPanels-Container';
						document.body.appendChild(panelSection);
					}
				},
			},
		});
		this.pict.CSSMap.generateCSS();
		this.pict.CSSMap.injectCSS();

		return super.onInitialize();
	}

	/**
	 * @param {Event} event - The event that triggered the logout.
	 * @return {Promise<void>} - A promise that resolves when the logout process is complete.
	 */
	logout(event)
	{
		if (event instanceof Event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		return this.pict.HeadlightRestClient.getJSON('Deauthenticate', (pError, pResponse) =>
		{
			if (pError)
			{
				this.pict.log.error(`Error deauthenticating: ${pError.message || pError}`);
			}
			this.pict.providers.SessionProvider?.invalidateSession?.();
			this.loginAsync((pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error in post-logout loginAsync: ${pError.message || pError}`);
				}
			});
		});
	}

	/**
	 * Loads data for the application.
	 * @param {ErrorCallback} fCallback - The callback to call when the method has completed.
	 */
	onLoadDataAsync(fCallback)
	{
		let tmpError = null;
		this.loadData()
		.then((data) =>
		{
			this.DATA = data;
			this.pict.options.Timezone = data.DocumentData?.ReportData?.Timezone || this.pict.options.Timezone;
			this.pict.Dates.dayJS.tz.setDefault(this.pict.options.Timezone);
			// Marked here rather than in loadData() so a subclass override of loadData() is still covered.
			this.markFormLoadPhase('DocumentLoaded');
		})
		.catch((error) =>
		{
			this.DATA = { };
			this.pict.log.error(`Error loading data: ${error.message || error}`, { Stack: error.stack });
			tmpError = error;
		})
		.finally(() =>
		{
			fCallback(tmpError);
		});
	}

	/**
	 * Loads data for the application.
	 *
	 * @return {Promise<any>}
	 */
	async loadData()
	{
		if (!this.loggedIn)
		{
			this.pict.log.info('Not logged in so not loading data by default.');
			return { };
		}
		const doc = await this.fable.services.HeadlightDocumentService.fetchCurrentDocumentReportParameters();
		// The user record fetch started in onBeforeLoginAsync; make sure it landed before anything can save.
		if (this.AppData.FullUserRecordPromise)
		{
			await this.AppData.FullUserRecordPromise;
		}
		this.pict.options.Timezone = doc?.ReportData?.Timezone || this.pict.options.Timezone;
		this.pict.Dates.dayJS.tz.setDefault(this.pict.options.Timezone);
		this.dataLoaded = true;
		return { DocumentData: doc };
	}

	/**
	 * Lifecycle method called before the document is saved.
	 * FIXME: lock into new Lifecycle
	 *
	 * @return {Promise<void>}
	 */
	async onBeforeDocumentSave()
	{
	}

	/**
	 * Lifecycle method called after the document is saved.
	 * FIXME: lock into new Lifecycle
	 *
	 * @return {Promise<void>}
	 */
	async onAfterDocumentSave()
	{
	}

	/**
	 * Arm periodic auto-saving for this document, if the manifest and the document allow it.
	 *
	 * Called from the load lifecycle once the document, the manifest and the edit/read theme decision
	 * are all in place. Subclasses can override to suppress auto-save for an app whose save path is
	 * not the standard document save.
	 *
	 * @return {boolean} Whether auto-save is now running.
	 */
	startAutoSave()
	{
		const tmpAutoSaveProvider = this.pict.providers?.AutoSave;
		if (!tmpAutoSaveProvider)
		{
			return false;
		}
		try
		{
			return tmpAutoSaveProvider.initializeFromManifest();
		}
		catch (pError)
		{
			// Auto-save is a convenience; a failure to arm it must never break loading the form.
			this.pict.log.error(`Error starting auto-save: ${pError.message || pError}`, { Stack: pError.stack });
			return false;
		}
	}

	/**
	 * Disarm periodic auto-saving.
	 * @param {String} [pReason] - Logged when supplied.
	 * @return {void}
	 */
	stopAutoSave(pReason)
	{
		this.pict.providers?.AutoSave?.stop(pReason);
	}

	/**
	 * @param {*} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		const tmpSessionProvider = this.pict.providers.SessionProvider;
		// On the boot login the SessionProvider synced moments ago during initialize, so reuse that.
		// Every later login (logout, the login form, a session change) asks the server again, since
		// those paths do not all go through logout() to invalidate the cached session.
		const tmpReuseSession = !this._initialLoginCompleted && tmpSessionProvider.hasSession();
		this._initialLoginCompleted = true;
		const tmpSessionLoad = tmpReuseSession ? tmpSessionProvider.getSession() : tmpSessionProvider.syncLoggedInState();
		tmpSessionLoad.then((session) =>
		{
			if (session && session.LoggedIn)
			{
				this.AppData.CurrentUser = session;
				this.loggedIn = true;
				this.pict.log.info(`User is already logged in.`);
				// Load the full user record (ExternalSyncGUID for sample QRCode generation; CheckSession
				// does not carry it) alongside the document instead of before it. loadData awaits the
				// promise, so the record is still in place before any sample is synthesized. Fail-open:
				// a failed fetch leaves FullUserRecord unset and the QRCode falls back.
				this.AppData.FullUserRecordPromise = new Promise((resolve) =>
				{
					this.pict.HeadlightRestClient.getJSON(`User/${session.UserID}`, (pError, pResult) =>
					{
						if (pResult)
						{
							this.AppData.FullUserRecord = pResult;
						}
						resolve();
					});
				});
			}
			else
			{
				this.loggedIn = false;
				delete this.AppData.CurrentUser;
				this.pict.log.info(`User is not logged in.`);
			}
		})
		.catch((error) =>
		{
			this.pict.log.warn(`session check failed: ${error?.message || error || 'not logged in'}`, { Stack: error?.stack });
			this.loggedIn = false;
		})
		.finally(() =>
		{
			// Marked on both outcomes: a failed session check still ends the session leg.
			this.markFormLoadPhase('SessionReady');
			return fCallback();
		});
	}

	/**
	 *
	 * @param {*} fCallback
	 * @return {void}
	 */
	onLoginAsync(fCallback)
	{
		if (this.loggedIn)
		{
			this.pict.log.info(`User logged in.`);
			this.loadDataAsync((error) =>
			{
				if (error)
				{
					this.pict.log.error(`Error loading data after login: ${error.message || error}`, { Stack: error.stack });
				}
				const tmpManifest = this.pict.settings.MyDefaultFormManifest;
				// The Fable ExpressionParser dereferences identifiers in the expression against the
				// scope object (e.g. `AppData.DocumentData.ReportData.Locked` walks AppData.* in scope).
				const tmpConditionScope = { AppData: this.pict.AppData };
				// Locked loads skip the solve pass by default (SkipSolveWhenLocked defaults true;
				// SkipSolveWhen adds expression-based gating) — re-running section solvers would
				// overwrite the frozen snapshot values with re-derived ones from current state.
				// A manifest opts back in with an explicit SkipSolveWhenLocked: false.
				if (ManifestConditionEvaluator.shouldSkipSolveOnLoad(tmpManifest, tmpConditionScope, this.fable))
				{
					this.pict.log.info('Skipping post-load solve() — manifest condition matched (Locked snapshot).');
				}
				else
				{
					this.solve();
				}
				this.prepareForPrintingAsync()
				.catch((error) =>
				{
					this.pict.log.error(`Error preparing for printing: ${error.message || error}`, { Stack: error.stack });
				})
				.finally(() =>
				{
					return fCallback();
				});
			});
			return;
		}

		this.pict.log.info(`User logged out.`);
		this.dataLoaded = false;
		this.DATA = { };
		this.loggedIn = false;
		if (this.pict.views.HeadlightLogin && this.options.Login.Required)
		{
			this.pict.views.HeadlightLogin.show();
		}
		fCallback();
	}

	/**
	 * Called after the Pict form views have been bootstrapped from the manifest.
	 * @param {*} fCallback
	 * @return {*}
	 */
	onAfterBootstrapPictFormViewsFromManifestAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Called after data has been loaded.
	 * @param {*} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		// Auto-save is armed here rather than in onInitialize because eligibility depends on state that
		// only exists once the document has loaded: Interactive, Locked, CanEdit, and the manifest.
		const fCallbackWithAutoSave = (pError) =>
		{
			this.startAutoSave();
			return fCallback(pError);
		};
		//TODO: this is a shim that ties the old fake lifecylce into the new lifecycle events - should eventually remove
		this.onDataLoad(this.DATA).catch((error) =>
		{
			this.pict.log.error(`Error in onDataLoad: ${error.message || error}`, { Stack: error.stack });
		}).finally(() =>
		{
			// The InitialBundle only needs the loaded document, so fetch it while the panels render.
			let tmpInitialBundleLoad = null;
			if (this.pict.settings.MyDefaultFormManifest)
			{
				const tmpManifest = this.pict.settings.MyDefaultFormManifest;
				const tmpConditionScope = { AppData: this.pict.AppData };
				const tmpInitialBundle = ManifestConditionEvaluator.shouldSkipInitialBundle(tmpManifest, tmpConditionScope, this.fable) ?
					[] :
					(tmpManifest.InitialBundle || []);
				tmpInitialBundleLoad = new Promise((resolve) =>
				{
					this.pict.EntityProvider.gatherDataFromServer(tmpInitialBundle, (pError) => resolve(pError));
				});
			}
			this.pict.views.HeadlightPanels.renderAsync(() =>
			{
				this.pict.log.info('HeadlightPanels rendered via Async');
				if (!this.pict.settings.MyDefaultFormManifest)
				{
					this.render();
					this.markFormLoadPhase('FirstRender');
					return fCallbackWithAutoSave();
				}
				else
				{
					const tmpBootstrapAndRender = (pError) =>
					{
						// Same decision as the post-load solve() gate, so an explicit
						// SkipSolveWhenLocked: false re-enables solving everywhere.
						this.pict.views.PictFormMetacontroller.AutoSolveOnFirstRender = this.pict.AppData.Interactive
							&& !ManifestConditionEvaluator.shouldSkipSolveOnLoad(this.pict.settings.MyDefaultFormManifest, { AppData: this.pict.AppData }, this.fable);
						this.pict.views.PictFormMetacontroller.FirstRenderCompleted = false;
						this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.pict.settings.MyDefaultFormManifest);
						//TODO: this gives us a chance to take actions after everything is prepared but before rendering - think more about this pattern
						this.onAfterBootstrapPictFormViewsFromManifestAsync(() =>
						{
							this.render();
							this.pict.views.PictFormMetacontroller.renderDefaultFormSections();
							// Marked here, not from the metacontroller's onAfterRenderAsyncCallbacks: that list only
							// runs when something calls the metacontroller's renderAsync, and this load path renders
							// synchronously, so the callback never fires on a normal form open.
							// renderDefaultFormSections() is synchronous, so the sections are drawn by this line.
							this.markFormLoadPhase('FirstRender');
							return fCallbackWithAutoSave(pError);
						});
					};

					tmpInitialBundleLoad.then((pError) =>
					{
						tmpBootstrapAndRender(pError);
					}).catch((pError) =>
					{
						this.pict.log.error(`Error bootstrapping the form after the InitialBundle load: ${pError.message || pError}`, { Stack: pError.stack });
					});
				}
			});
		});
	}

	/**
	 * Called after authentication has been verified.
	 *
	 * Override this method to perform actions after the user has been authenticated.
	 *
	 * FIXME: need to retool this
	 *
	 * @param {Object<String, any>} data - The data that was loaded.
	 *
	 * @return {Promise<Object<String, any>>}
	 */
	async onDataLoad(data)
	{
		const doc = data?.DocumentData?.ReportData;

		if (!doc)
		{
			this.pict.log.error('Document data not found in onDataLoad', { doc });
		}

		//FIXME: should be handled by document provider implicitly? how does this flow into the login stuff, etc. in a better way
		// The signature render, the input provider and the distilling bundle fetch are independent; run them together.
		const tmpLoadTasks = [];
		const tmpBuiltins = this.pict.settings?.MyDefaultFormManifest?.Builtins;
		if (HeadlightConfigurableApplication.isBuiltinSectionEnabled(tmpBuiltins?.SignatureSection))
		{
			if (this.pict.views.HeadlightSignatures)
			{
				tmpLoadTasks.push(new Promise((resolve) =>
				{
					this.pict.views.HeadlightSignatures.renderAsync(undefined, undefined, undefined, (error) =>
					{
						if (error)
						{
							this.pict.log.error(`Error rendering HeadlightSignatures view: ${error.message || error}`, { Stack: error.stack });
							//TODO: should this reject?
						}
						resolve();
					});
				}));
			}
		}
		else
		{
			const tmpSignatureContainer = document.getElementById('Headlight-View-Signatures');
			if (tmpSignatureContainer)
			{
				tmpSignatureContainer.style.display = 'none';
			}
		}

		if (this.pict.providers.Input)
		{
			tmpLoadTasks.push(this.pict.providers.Input.onDataLoad(data));
		}
		if (this.pict.providers.Distilling)
		{
			tmpLoadTasks.push(this.pict.providers.Distilling.onDataLoad(data));
		}
		await Promise.all(tmpLoadTasks);
	}

	/**
	 * Resolves the destination for lifecycle comprehension data.
	 *
	 * @return {String} - The destination address for marshalling data.
	 */
	resolveComprehensionMarshallDestination()
	{
		if (this.options.Document?.Required)
		{
			return 'AppData.DocumentData.ReportData.EntityData';
		}
		return 'AppData';
	}

	/**
	 * Resolves the destination for marshalling data.
	 *
	 * @return {String} - The destination address for marshalling data.
	 */
	resolveDataMarshallDestination()
	{
		if (this.options.Document?.Required)
		{
			return 'AppData.DocumentData.ReportData.FormData';
		}
		return 'AppData';
	}

	/**
	 * Lifecycle hook for adding tempplates to the metacontroller.
	 */
	registerTemplates()
	{
		this.pict.addProviderSingleton('PictFormSectionDefaultTemplateProvider', PictSectionForm.PictFormTemplateProvider.default_configuration, PictSectionForm.PictFormTemplateProvider);
	}

	/**
	 * Lifecycle method called after the application has been initialized.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the method has completed, and indicate if an error occurred.
	 */
	async onInitializeAsync(fCallback)
	{
		super.onInitializeAsync(async (pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}

			this.registerTemplates();

			this.pict.views.PictFormMetacontroller.viewMarshalDestination = this.resolveDataMarshallDestination();
			this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress = this.resolveComprehensionMarshallDestination();
			this.pict.views.PictFormMetacontroller.AutoSolveOnFirstRender = false;

			this.pict.log.info('onInitializeAsync HeadlightConfigurableApplication');

			return fCallback();
		});
	}

	/**
	 * Prepares the application for printing.
	 */
	async prepareForPrintingAsync()
	{
		try
		{
			for (const provider of Object.keys(this.pict.providers))
			{
				if (typeof this.pict.providers[provider]?.completeRender == 'function')
				{
					try
					{
						await this.pict.providers[provider].completeRender();
					}
					catch (error)
					{
						this.pict.log.error(`Error resolving render for provider ${ provider }: ${error.message || error}`, { Stack: error.stack });
					}
				}
			}

			//FIXME: need to add controls for this
			window.status = 'ready_to_print';
		}
		catch (error)
		{
			this.pict.log.error(`Error in onAfterInitializeAsync: ${error.message || error}`, { Stack: error.stack });

			if (this.pict.views.HeadlightPanels)
			{
				// TODO: maybe we want to handle this differently?
				this.pict.views.HeadlightPanels.renderAsync(() =>
				{
					this.pict.log.info('HeadlightPanels rendered via Async with error');
				});
				this.pict.views.HeadlightPaneIssues?.addIssueLog?.('HeadlightPanels rendered via Async with error', error);
			}
		}
	}

	/**
	 * Lifecycle method called after the application has been initialized.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the method has completed, and indicate if an error occurred.
	 */
	onAfterInitializeAsync(fCallback)
	{
		super.onAfterInitializeAsync((pError) =>
		{
			if (pError)
			{
				this.pict.log.error(`Error in onAfterInitializeAsync: ${pError.message || pError}`, { Stack: pError.stack });
			}

			// Hook: allow external code to configure the application
			// (e.g. REST client interceptors) before the login/data-load
			// lifecycle begins.  The hook receives the Pict instance so it
			// can wire up services, interceptors, IPC routes, etc.
			if (typeof window._onBeforeFormInit === 'function')
			{
				try
				{
					this.pict.log.info('HeadlightConfigurableApplication: Calling window._onBeforeFormInit hook.');
					window._onBeforeFormInit(this.pict);
				}
				catch (pHookError)
				{
					this.pict.log.error('HeadlightConfigurableApplication: Error in _onBeforeFormInit hook: ' + pHookError, { Stack: pHookError.stack });
				}
			}

			this.loginAsync(async (pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error in onAfterInitializeAsync loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
				}

				return fCallback(pError);
			});
		});
	}
	/** @typedef {(pError: (Error | String | null), pSuccess: Boolean) => void} ErrorBooleanCallback */

	/**
	 * Check if the user is authenticated.
	 *
	 * @param {ErrorBooleanCallback} callback - error-first callback to notify on loggedin status (error, true|false)
	 */
	isUserLoggedIn(callback)
	{
		this.pict.HeadlightRestClient.getJSON(`CheckSession`, (pError, pBody) =>
		{
			if (pError || !pBody.LoggedIn)
			{
				// this.AppData.CurrentUser = undefined;
				this.pict.log.trace('session check failed');
				callback(null, false);
				return;
			}
			// Fetch the user record first so that we can use it for generating the QRCode if needed.
			this.pict.HeadlightRestClient.getJSON('User/' + pBody.UserID, (pError, pResult) =>
			{
				if (pResult)
				{
					this.AppData.FullUserRecord = pResult;
				}
				// already logged in
				this.AppData.CurrentUser = pBody;
				callback(null, true);
			});
		});
	}

	/**
	 * Checks if a user is logged in.
	 *
	 * @return {Promise<Boolean>} - A promise that resolves to true if the user is logged in, false otherwise.
	 */
	async checkLogin()
	{
		//FIXME: we should separate login into a provider and a view
		const isLoggedIn = Util.promisify(this.isUserLoggedIn.bind(this));
		return await isLoggedIn();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		// only run this if we are in interactive mode
		if (!this.AppData.Interactive)
		{
			return;
		}

		if (!this.loggedIn && this.pict.views.HeadlightLogin && this.options.Login.Required)
		{
			return;
		}

		return super.onSolve();
	}

	/**
	 * Lifecycle method called before the view is rendered.
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		// over-ride some CSS class names for the tab section selector to use Bulma classes
		if (this.pict.providers['Pict-Input-TabSectionSelector'])
		{
			this.pict.providers['Pict-Input-TabSectionSelector'].cssSelectedTabClass = 'is-active';
			this.pict.providers['Pict-Input-TabSectionSelector'].cssHideClass = 'is-hidden';
		}
		// over-ride some CSS class names for the tab group selector to use Bulma classes
		if (this.pict.providers['Pict-Input-TabGroupSelector'])
		{
			this.pict.providers['Pict-Input-TabGroupSelector'].cssSelectedTabClass = 'is-active';
			this.pict.providers['Pict-Input-TabGroupSelector'].cssHideClass = 'is-hidden';
		}

		return super.onBeforeRender();
	}

	/**
	 * Set up the native bridge functions used by the iOS configurable form
	 * WKWebView. This mode is activated when the page is captured via
	 * single-file with ?Mode=OfflineTemplate. The captured HTML is later
	 * loaded from the device filesystem; the native layer injects a
	 * StorageAdapter and DocumentBridge via WKUserScript, then calls
	 * initFormWithManifest() to bootstrap the form.
	 *
	 * This is a static method so all subclasses (HeadlightDynamicForm,
	 * HeadlightDocument, etc.) inherit it. Each HTML template calls:
	 *   AppClass.setupOfflineTemplate(AppClass);
	 *
	 * @param {typeof HeadlightConfigurableApplication} pAppClass - The application class to use for form initialization.
	 */
	static setupOfflineTemplate(pAppClass)
	{
		/**
		 * Initialise the PICT configurable-form application with the
		 * given manifest and optional bundle (project reference data).
		 *
		 * Called by the iOS native layer after the page finishes loading.
		 *
		 * @param {object} pManifest - The resolved form manifest JSON.
		 * @param {object} [pBundle] - Optional project bundle/reference data.
		 */
		window.initFormWithManifest = (pManifest, pBundle) =>
		{
			window._InteractiveForm = true;
			window._OfflineMode = true;
			window._OfflineBundleData = pBundle || {};

			pAppClass.default_configuration.pict_configuration =
				pAppClass.preprocessFormDefinition(pManifest);

			Pict.safeLoadPictApplication(pAppClass, 3);
		};

		/**
		 * Load a document record from native storage and marshal it into
		 * the live form.  Called by the iOS native layer after
		 * initFormWithManifest has completed.
		 *
		 * @param {string} pGUID - The GUIDDocument or external index to load.
		 */
		window.nativeLoadDocument = (pGUID) =>
		{
			if (!window._configurableFormDocumentBridge)
			{
				console.error('[OfflineTemplate] _configurableFormDocumentBridge not available');
				return;
			}

			window._configurableFormDocumentBridge.loadDocument(pGUID, (pDocData) =>
			{
				if (!window._Pict || !window._Pict.PictApplication)
				{
					console.error('[OfflineTemplate] PICT application not ready');
					return;
				}

				const tmpApp = window._Pict.PictApplication;
				tmpApp.AppData.DocumentData = pDocData;

				// Bootstrap form views from manifest if not yet done
				if (typeof tmpApp.bootstrapPictFormViewsFromManifest === 'function')
				{
					tmpApp.bootstrapPictFormViewsFromManifest();
				}

				tmpApp.render();

				// Marshal document data into form fields
				if (tmpApp.pict && tmpApp.pict.views && tmpApp.pict.views.PictFormMetacontroller)
				{
					tmpApp.pict.views.PictFormMetacontroller.marshalToView();
				}

				// Offline, the document arrives here rather than through the load lifecycle, so this is
				// the first moment auto-save can tell whether the record is editable. Saves route back
				// through nativeSaveCurrentForm to the native bridge, not the REST client.
				tmpApp.startAutoSave();
			});
		};

		/**
		 * Run a full application save. Called by the iOS native layer before dismissing the form view
		 * controller, and by auto-save on its interval.
		 *
		 * This is the SAME save the online form runs: the whole lifecycle, so every provider's
		 * `onBeforeSaveDataAsync` marshals and emits, and only the transport underneath differs
		 * (`HeadlightDocumentService` writes through the native bridge instead of PUTting). Persisting
		 * the record directly from here would skip the marshal the form applications do and would never
		 * build `Document.EntityData`, so nothing the form created would exist once the device synced.
		 *
		 * Resolves once the save has been persisted, so the caller can await it before tearing the
		 * webview down. `callAsyncJavaScript:` resolves the returned promise; a caller using
		 * `evaluateJavaScript:` gets no such guarantee and will race the teardown.
		 *
		 * @return {Promise<{Saved: boolean, Error?: string}>} The outcome of the save.
		 */
		window.nativeSaveCurrentForm = async () =>
		{
			if (!window._Pict || !window._Pict.PictApplication)
			{
				return { Saved: false, Error: 'The form application is not ready.' };
			}

			const tmpApp = window._Pict.PictApplication;
			const tmpDocumentProvider = tmpApp.pict && tmpApp.pict.providers && tmpApp.pict.providers.DocumentProvider;
			if (!tmpDocumentProvider || typeof tmpDocumentProvider.handleSaveAsync !== 'function')
			{
				const tmpMessage = 'No DocumentProvider is registered, so this form has no save lifecycle to run.';
				tmpApp.pict.log.error(`nativeSaveCurrentForm: ${tmpMessage}`);
				return { Saved: false, Error: tmpMessage };
			}

			const tmpError = await tmpDocumentProvider.handleSaveAsync(true);
			if (tmpError)
			{
				return { Saved: false, Error: tmpError.message || String(tmpError) };
			}
			return { Saved: true };
		};

		/**
		 * Wire the native storage adapter (injected by iOS via
		 * ConfigurableFormStorageAdapter.js) into the FormPersistence
		 * provider once the PICT application has initialised.
		 *
		 * Can be called from native or from initFormWithManifest's
		 * post-init hook.
		 */
		window.setupNativeFormPersistence = () =>
		{
			if (!window._Pict || !window._nativeStorageAdapter)
			{
				return;
			}
			const tmpPersistence = window._Pict.providers && window._Pict.providers.FormPersistence;
			if (tmpPersistence && typeof tmpPersistence.setStorageAdapter === 'function')
			{
				tmpPersistence.setStorageAdapter(window._nativeStorageAdapter);
			}
		};
	}
}

/** @type {Record<string, any>} */
HeadlightConfigurableApplication.default_configuration = Object.assign(
{
	'MainViewportViewIdentifier': 'PictFormMetacontroller',
},
HeadlightConfigurableApplication.default_configuration,
{
	'AutoRenderMainViewportViewAfterInitialize': false,
});
/** @type {Record<string, any>} */
HeadlightConfigurableApplication.pict_configuration = require('./application-pict-config.json');

module.exports = HeadlightConfigurableApplication;

},{"../../../../lib/service/headlight-qrcode-hash-service/Headlight-QRCodeHash.js":11,"../../../../lib/service/headlight-stationing-service/Headlight-Stationing.js":13,"../../../../lib/web/headlight-quick-summaries/Headlight-Quick-Summaries-Service.js":246,"../../../../web/providers/Session-Provider.js":885,"./application-pict-config.json":18,"./providers/AutoSaveProvider.js":19,"./providers/DistillingProvider.js":20,"./providers/InputTypeBehaviorProvider.js":21,"./services/Headlight-Document-Service.js":22,"./services/Headlight-FormLoadTiming.js":23,"./services/Headlight-HintHighlighting.js":24,"./services/ManifestConditionEvaluator.js":25,"headlight-rest-client":12,"headlight-view-login":252,"headlight-view-panels":796,"headlight-view-signatures":253,"pict-application":476,"pict-section-form":497,"pict-section-form/source/views/Pict-View-Form-Metacontroller.js":564,"pict-section-modal":590,"util":755}],18:[function(require,module,exports){
module.exports={
    "Product": "HeadlightConfigurableApplication",
    "ProductVersion": "1.0.0",

    "Manifests":
    {
    }
}

},{}],19:[function(require,module,exports){
const PictProvider = require('pict-provider');

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */

/** Ships on by default; a manifest opts out with `AutoSave: false` (or `AutoSave: { Enabled: false }`). */
const DEFAULT_INTERVAL_SECONDS = 90;
/** Below this, saves stack up behind each other on a slow connection and hammer the API. */
const MINIMUM_INTERVAL_SECONDS = 15;
/** An hour. Anything longer is indistinguishable from "off" and is almost certainly a typo. */
const MAXIMUM_INTERVAL_SECONDS = 3600;
/** Consecutive failed auto-saves before the provider stops trying. */
const DEFAULT_MAX_CONSECUTIVE_FAILURES = 3;

/**
 * Auto-save states, in the order a healthy session moves through them.
 * `offline` and `retrying` are transient; `suspended` is terminal until a
 * successful save (manual or programmatic) revives the provider.
 */
const STATES = {
	DISABLED: 'disabled',
	IDLE: 'idle',
	SAVING: 'saving',
	SAVED: 'saved',
	OFFLINE: 'offline',
	RETRYING: 'retrying',
	SUSPENDED: 'suspended',
};

/**
 * Presentation metadata per state. Class names (not markup) so the navbar
 * template composes the DOM — see `HeadlightPanels-NavBar-AutoSaveStatus`.
 */
const STATE_PRESENTATION = {
	[STATES.IDLE]: { IconClass: 'fa-cloud', StateClass: 'is-idle' },
	[STATES.SAVING]: { IconClass: 'fa-circle-notch fa-spin', StateClass: 'is-saving' },
	[STATES.SAVED]: { IconClass: 'fa-check', StateClass: 'is-saved' },
	[STATES.OFFLINE]: { IconClass: 'fa-plug', StateClass: 'is-offline' },
	[STATES.RETRYING]: { IconClass: 'fa-exclamation-triangle', StateClass: 'is-retrying' },
	[STATES.SUSPENDED]: { IconClass: 'fa-exclamation-triangle', StateClass: 'is-suspended' },
};

/**
 * Message fragments that mean "the server refused you", as opposed to "the server was unreachable".
 * The REST client flattens the response into `new Error('Failed with status code 403')` (or the
 * JSON-stringified error body), so there is no status code property to read — matching on the
 * message is the only signal available.
 */
const AUTHORIZATION_ERROR_PATTERNS = [ /\b401\b/, /\b403\b/, /unauthorized/i, /forbidden/i, /not authorized/i, /permission/i ];

/** The navbar Save button in the panels configuration; auto-save follows whether it is offered. */
const SAVE_BUTTON_ID = 'HeadlightPanels-NavBar-Save-Button';

/** The document form element. Every document HTML shell uses this id, and it is never re-rendered. */
const DOCUMENT_FORM_ID = 'Headlight-Document-Form';

/**
 * Hook the framework's own "a value changed" calls so a custom input provider counts as an interaction.
 *
 * The DOM listener in the provider catches typing the moment a key lands, but pict binds `onchange` and
 * many widgets never fire a native event at all — pict-section-picker portals its dropdown to `<body>`,
 * so the option click happens outside the form and the value is written programmatically. Selecting
 * from a dropdown is half the interaction case we care about, so it has to be caught here rather than
 * in the DOM.
 *
 * Patched the same way the base application already patches the metacontroller's render hooks: the
 * upstream methods notify only a provider literally named `FormPersistence`, which this platform does
 * not register.
 */
const PictViewDynamicForm = require('pict-section-form/source/views/Pict-View-DynamicForm.js');
for (const tmpMethodName of [ 'dataChanged', 'dataChangedTabular' ])
{
	const tmpOriginalMethod = PictViewDynamicForm.prototype[tmpMethodName];
	if (typeof tmpOriginalMethod !== 'function')
	{
		continue;
	}
	PictViewDynamicForm.prototype[tmpMethodName] = function(...pArguments)
	{
		// Before, not after: the first interaction is what baselines the document for change detection,
		// and this method is what marshals the edit into it. Baselining afterwards would fold the edit
		// into the baseline, and a picker selection — which fires no DOM event to catch it earlier —
		// would never read as a change and so would never be auto-saved.
		try
		{
			this.pict?.providers?.AutoSave?.noteUserInteraction?.(tmpMethodName);
		}
		catch (pError)
		{
			// Never let auto-save bookkeeping break an edit.
			this.log?.error?.(`AutoSave: error recording a form interaction: ${pError?.message || pError}`);
		}
		return tmpOriginalMethod.apply(this, pArguments);
	};
}

/**
 * Keys under `AppData.CurrentUser.Settings.HeadlightPanels` that the Settings panel writes. They follow
 * the panel's `setting-<Key>` element-id convention so `updateUserPreferences` can paint them.
 */
const USER_PREFERENCE_ENABLED_KEY = 'AutoSave';
const USER_PREFERENCE_INTERVAL_KEY = 'AutoSaveIntervalSeconds';

/**
 * Periodically persists an editable document while the user works in it.
 *
 * Registered by `HeadlightConfigurableApplication` so every configuration-driven form app
 * (headlight-dynamic-form, materials-form, and anything else extending the base) inherits the
 * behavior without wiring anything up.
 *
 * ## Manifest configuration
 *
 * Read from the top level of the form manifest, alongside `SkipSolveWhenLocked` and friends:
 *
 * ```json
 * { "AutoSave": false }                                       // opt out entirely
 * { "AutoSave": { "IntervalSeconds": 300 } }                  // every 5 minutes instead of 90 seconds
 * { "AutoSave": { "Enabled": true, "SkipWhenUnchanged": false } }
 * ```
 *
 * | Key | Default | Meaning |
 * | --- | --- | --- |
 * | `Enabled` | `true` | Master switch. `AutoSave: false` is shorthand for `{ Enabled: false }`. |
 * | `IntervalSeconds` | `90` | Delay before the first save and between saves. Clamped to 15–3600. |
 * | `SkipWhenUnchanged` | `true` | Skip a cycle when nothing has changed since the last save. |
 * | `MaxConsecutiveFailures` | `3` | Failures in a row before auto-save suspends itself. |
 *
 * ## Guarantees
 *
 * - Sleeps between saves. The timer is dormant until a change is observed, runs one interval, saves,
 *   and goes dormant again — it does not poll. "Change" means the document differs from what the last
 *   save actually sent, so a value typed and then taken back out again wakes nothing.
 * - Never runs outside a form: it requires a `MyDefaultFormManifest`, which the web applications
 *   sharing this base class (LIMS, the configuration apps, internals, data) do not have.
 * - Follows the Save button: an application or customer whose panel configuration removes or hides the
 *   navbar Save button has turned saving off, and auto-save turns off with it.
 * - Never runs on a document the user cannot edit (locked, `CanEdit` false) or on a non-interactive
 *   render pass (the PDF/print bundle).
 * - Never runs on another customer's document, so a support user spot-checking a form in edit view does
 *   not silently stamp it. Manual saves are deliberate and are left alone.
 * - Never starts a second save lifecycle: it defers to `DocumentProvider`'s single-flight latch
 *   rather than queueing behind an in-flight save, and skips entirely while an approval action runs.
 * - Never spams a server that is refusing the write. Repeated failures — or any single failure that
 *   looks like a permission change — suspend auto-save until a save succeeds again.
 * - Works offline: in the iOS WKWebView offline template the save routes through the native document
 *   bridge instead of the REST client, and a browser reporting `navigator.onLine === false` skips the
 *   cycle without burning a failure.
 */
class AutoSaveProvider extends PictProvider
{
	/**
	 * Normalize whatever the manifest carries at `AutoSave` into a complete configuration object.
	 *
	 * Fails open — a malformed value logs and falls back to the default rather than disabling
	 * auto-save, because a typo in an optional tuning key should not silently cost a customer their
	 * unsaved work.
	 *
	 * @param {boolean | Object | undefined | null} pManifestAutoSave - The manifest's `AutoSave` value.
	 * @param {any} [pLog] - Optional logger for surfacing coercions.
	 * @return {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }}
	 */
	static resolveConfiguration(pManifestAutoSave, pLog)
	{
		const tmpConfiguration =
		{
			Enabled: true,
			IntervalSeconds: DEFAULT_INTERVAL_SECONDS,
			SkipWhenUnchanged: true,
			MaxConsecutiveFailures: DEFAULT_MAX_CONSECUTIVE_FAILURES,
		};

		if (pManifestAutoSave === undefined || pManifestAutoSave === null)
		{
			return tmpConfiguration;
		}
		if (typeof pManifestAutoSave === 'boolean')
		{
			tmpConfiguration.Enabled = pManifestAutoSave;
			return tmpConfiguration;
		}
		if (typeof pManifestAutoSave !== 'object' || Array.isArray(pManifestAutoSave))
		{
			pLog?.warn?.(`AutoSave: manifest value is a ${Array.isArray(pManifestAutoSave) ? 'array' : typeof pManifestAutoSave}; expected a boolean or an object. Using auto-save defaults.`);
			return tmpConfiguration;
		}

		if ('Enabled' in pManifestAutoSave)
		{
			tmpConfiguration.Enabled = pManifestAutoSave.Enabled !== false;
		}
		if ('SkipWhenUnchanged' in pManifestAutoSave)
		{
			tmpConfiguration.SkipWhenUnchanged = pManifestAutoSave.SkipWhenUnchanged !== false;
		}
		if ('IntervalSeconds' in pManifestAutoSave)
		{
			tmpConfiguration.IntervalSeconds = AutoSaveProvider.resolveIntervalSeconds(
				pManifestAutoSave.IntervalSeconds, DEFAULT_INTERVAL_SECONDS, 'manifest IntervalSeconds', pLog);
		}
		if ('MaxConsecutiveFailures' in pManifestAutoSave)
		{
			const tmpFailures = Number(pManifestAutoSave.MaxConsecutiveFailures);
			if (!Number.isFinite(tmpFailures) || tmpFailures < 1)
			{
				pLog?.warn?.(`AutoSave: MaxConsecutiveFailures "${pManifestAutoSave.MaxConsecutiveFailures}" is not a positive number; using ${DEFAULT_MAX_CONSECUTIVE_FAILURES}.`);
			}
			else
			{
				tmpConfiguration.MaxConsecutiveFailures = Math.round(tmpFailures);
			}
		}

		return tmpConfiguration;
	}

	/**
	 * Validate and clamp an interval to the supported range.
	 *
	 * @param {any} pValue - The candidate interval, from a manifest or a user preference.
	 * @param {number} pFallback - The interval to keep when the candidate is unusable.
	 * @param {String} pSource - Where the value came from, for the warning text.
	 * @param {any} [pLog] - Optional logger.
	 * @return {number}
	 */
	static resolveIntervalSeconds(pValue, pFallback, pSource, pLog)
	{
		const tmpInterval = Number(pValue);
		if (!Number.isFinite(tmpInterval) || tmpInterval <= 0)
		{
			pLog?.warn?.(`AutoSave: ${pSource} interval "${pValue}" is not a positive number; using ${pFallback} seconds.`);
			return pFallback;
		}
		const tmpRounded = Math.round(tmpInterval);
		const tmpClamped = Math.min(MAXIMUM_INTERVAL_SECONDS, Math.max(MINIMUM_INTERVAL_SECONDS, tmpRounded));
		if (tmpClamped !== tmpRounded)
		{
			pLog?.warn?.(`AutoSave: ${pSource} interval ${tmpRounded} is outside the supported ${MINIMUM_INTERVAL_SECONDS}-${MAXIMUM_INTERVAL_SECONDS} second range; using ${tmpClamped} seconds.`);
		}
		return tmpClamped;
	}

	/**
	 * Resolve whether auto-save is on, across the three things that get a say.
	 *
	 * The precedence is deliberate and not symmetric:
	 *   - A manifest opt-out is the customer's decision about the form and nobody overrides it.
	 *   - An explicit user preference beats everything below it, in either direction.
	 *   - Impersonation only moves the *default*. Someone impersonating is testing, and a timer save
	 *     would be an edit they did not mean to make — but a tester chasing an auto-save bug has to be
	 *     able to switch it back on, so this is a preference, not a lock.
	 *
	 * @param {boolean} pManifestEnabled - Whether the form manifest allows auto-save at all.
	 * @param {boolean} pImpersonating - Whether this session is impersonating another user.
	 * @param {boolean | undefined} pUserPreference - The user's stored `AutoSave` preference, if any.
	 * @return {boolean}
	 */
	static resolveEnabled(pManifestEnabled, pImpersonating, pUserPreference)
	{
		if (!pManifestEnabled)
		{
			return false;
		}
		if (pUserPreference === false)
		{
			return false;
		}
		if (pUserPreference === true)
		{
			return true;
		}
		return !pImpersonating;
	}

	/**
	 * Layer the logged-in user's Settings-panel preferences over the manifest configuration.
	 *
	 * The user has the final say on cadence, and can switch auto-save off for themselves entirely. They
	 * cannot switch it back **on** for a form whose manifest opted out: that is a decision the customer
	 * made about the form, not a personal preference, so `Enabled` is only ever narrowed here.
	 *
	 * @param {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }} pConfiguration - The manifest-resolved configuration.
	 * @param {Object | null | undefined} pUserPreferences - `CurrentUser.Settings.HeadlightPanels`.
	 * @param {any} [pLog] - Optional logger.
	 * @param {boolean} [pImpersonating] - Whether this session is impersonating another user.
	 * @return {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }} A new configuration; the input is not mutated.
	 */
	static applyUserPreferences(pConfiguration, pUserPreferences, pLog, pImpersonating)
	{
		const tmpConfiguration = Object.assign({ }, pConfiguration);
		const tmpUserPreferences = (pUserPreferences && typeof pUserPreferences === 'object') ? pUserPreferences : { };
		// `pConfiguration` is the manifest's configuration, so its Enabled is the ceiling.
		tmpConfiguration.Enabled = AutoSaveProvider.resolveEnabled(
			pConfiguration.Enabled, Boolean(pImpersonating), tmpUserPreferences[USER_PREFERENCE_ENABLED_KEY]);
		if (tmpUserPreferences[USER_PREFERENCE_INTERVAL_KEY] !== undefined && tmpUserPreferences[USER_PREFERENCE_INTERVAL_KEY] !== null)
		{
			tmpConfiguration.IntervalSeconds = AutoSaveProvider.resolveIntervalSeconds(
				tmpUserPreferences[USER_PREFERENCE_INTERVAL_KEY], tmpConfiguration.IntervalSeconds, 'user preference', pLog);
		}
		return tmpConfiguration;
	}

	/**
	 * @param {any} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {any} */
		this.options;

		/** @type {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }} */
		this.Configuration = AutoSaveProvider.resolveConfiguration(undefined);
		/**
		 * The manifest's configuration before the user's preferences are layered on. Kept so the Settings
		 * panel can distinguish "the customer turned this off for this form" from "you turned it off".
		 * @type {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }}
		 */
		this.ManifestConfiguration = this.Configuration;
		/** @type {boolean} - Whether the interval timer is currently armed. */
		this.Running = false;
		/** @type {boolean} - Whether auto-save stopped itself because saving kept failing. */
		this.Suspended = false;
		/** @type {number} - Failed auto-saves since the last successful one. */
		this.ConsecutiveFailures = 0;
		/** @type {any} - The pending interval timer handle. */
		this._Timer = null;
		/** @type {?String} - Serialized document state as of the last save, for change detection. */
		this._SavedSnapshot = null;
		/** @type {boolean} - Whether the save currently in flight was started by this provider. */
		this._AutoSaveInFlight = false;
		/** @type {?Date} - When a save last completed, whoever asked for it. */
		this.LastSavedAt = null;
		/**
		 * Whether the user has modified anything in this form yet. The clock does not start until they
		 * have: opening someone's form to read it should never write to it 90 seconds later.
		 * @type {boolean}
		 */
		this.UserHasInteracted = false;
		/** @type {?Function} - The detach handle for the first-interaction DOM listener. */
		this._DetachInteractionListener = null;
		/** @type {String} */
		this.State = STATES.DISABLED;
		/** @type {String} */
		this.StateMessage = '';

		this._publishStatus();
	}

	/**
	 * Read the manifest's `AutoSave` block and arm the timer if the document qualifies.
	 *
	 * Called from the base application once the document is loaded and the form has rendered, so
	 * `Locked` / `CanEdit` / the print-vs-edit theme decision have all been made by then.
	 *
	 * @return {boolean} Whether auto-save is now running.
	 */
	initializeFromManifest()
	{
		this.ManifestConfiguration = AutoSaveProvider.resolveConfiguration(this.pict.settings?.MyDefaultFormManifest?.AutoSave, this.log);
		this.Configuration = AutoSaveProvider.applyUserPreferences(
			this.ManifestConfiguration, this.readUserPreferences(), this.log, this.isImpersonating());
		return this.start();
	}

	/**
	 * Whether this session is impersonating another user — CheckSession reports it.
	 *
	 * Read permissively: this only moves a default the user can change, so treating an unexpected
	 * truthy shape as impersonation errs toward not writing to a document somebody is testing on.
	 * @return {boolean}
	 */
	isImpersonating()
	{
		return Boolean(this.pict.AppData?.CurrentUser?.Impersonation);
	}

	/**
	 * The logged-in user's panel preferences, or undefined when nobody is logged in.
	 * @return {Object | undefined}
	 */
	readUserPreferences()
	{
		return this.pict.AppData?.CurrentUser?.Settings?.HeadlightPanels;
	}

	/**
	 * Re-read the manifest and the user's Settings-panel preferences, then re-arm.
	 *
	 * Called when the user changes an auto-save preference, so it takes effect on the open document
	 * rather than at the next page load. Re-arming also resets the countdown, which is the behavior a
	 * user changing the cadence expects.
	 * @return {boolean} Whether auto-save is running after the change.
	 */
	reconfigure()
	{
		return this.initializeFromManifest();
	}

	/**
	 * Describe auto-save for the Settings panel.
	 *
	 * `Available` is about whether the controls are meaningful on this screen at all, not about the
	 * document currently open: the preference is per-user and carries to their next document, so a
	 * locked document does not make it unavailable.
	 *
	 * @return {{ Available: boolean, Locked: boolean, Reason: string, Enabled: boolean, IntervalSeconds: number, DefaultIntervalSeconds: number, MinimumIntervalSeconds: number, MaximumIntervalSeconds: number }}
	 */
	getUserFacingState()
	{
		// Not a form application, or an application whose navbar offers no Save button: the controls
		// would be inert, so the panel hides them entirely.
		const tmpAvailable = Boolean(this.pict.settings?.MyDefaultFormManifest) && this.isSaveControlAvailable();
		// Conditions the user cannot change from here. Both leave the rows visible but inert, with the
		// reason spelled out, rather than a live toggle that does nothing.
		const tmpForeignCustomer = !this.isSameCustomerAsDocument();
		const tmpManifestOptedOut = !this.ManifestConfiguration.Enabled;
		const tmpEnabled = this.Configuration.Enabled && !tmpForeignCustomer;
		// Locked is "you cannot change this here". Impersonation is not locked — it only moved the
		// default — but it still explains itself, so the reason is tracked separately.
		let tmpReason = '';
		if (tmpForeignCustomer)
		{
			tmpReason = 'Auto-save is off because this document belongs to another customer.';
		}
		else if (tmpManifestOptedOut)
		{
			tmpReason = 'Auto-save is turned off for this form type.';
		}
		else if (!tmpEnabled && this.isImpersonating())
		{
			tmpReason = 'Auto-save defaults to off while impersonating. Turn it on if you are testing auto-save itself.';
		}
		return {
			Available: tmpAvailable,
			Locked: tmpForeignCustomer || tmpManifestOptedOut,
			Reason: tmpReason,
			Enabled: tmpEnabled,
			IntervalSeconds: this.Configuration.IntervalSeconds,
			DefaultIntervalSeconds: DEFAULT_INTERVAL_SECONDS,
			MinimumIntervalSeconds: MINIMUM_INTERVAL_SECONDS,
			MaximumIntervalSeconds: MAXIMUM_INTERVAL_SECONDS,
		};
	}

	/**
	 * Whether this document should be auto-saved at all.
	 *
	 * Re-checked on every cycle, not just at start: a document that gets locked mid-session (the user
	 * submits it in another tab, an approver locks it) must stop being written to.
	 * @return {boolean}
	 */
	isEligible()
	{
		if (!this.Configuration.Enabled)
		{
			return false;
		}
		// No form manifest means no form. Roughly a dozen web applications (LIMS, the configuration
		// apps, internals, data) extend this same base class and several of them set Interactive true
		// for their own purposes, so this — not Interactive — is what structurally keeps auto-save out
		// of them. The base class does not bootstrap form section views without a manifest either.
		if (!this.pict.settings?.MyDefaultFormManifest)
		{
			return false;
		}
		// The PDF/print render pass loads the same application with Interactive false. Saving there
		// would write the render's derived state back over the document.
		if (!this.pict.AppData?.Interactive)
		{
			return false;
		}
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData)
		{
			return false;
		}
		// A TINYINT Locked can arrive as the string "0", which is JS-truthy — the same trap
		// ManifestConditionEvaluator guards against.
		if (tmpReportData.Locked && tmpReportData.Locked !== '0')
		{
			return false;
		}
		if (!tmpReportData.CanEdit)
		{
			return false;
		}
		if (!this.isSameCustomerAsDocument())
		{
			return false;
		}
		return this.isSaveControlAvailable();
	}

	/**
	 * Whether the logged-in user belongs to the same customer as the open document.
	 *
	 * Support and engineering users (role index 5) open other customers' forms to spot-check them — open,
	 * read, close, no edits intended. In edit view a timer save would still fire, stamping the document
	 * with a foreign updating user, and in some configurations that leaves the customer's own users
	 * unable to open or edit it afterwards. A person who deliberately clicks Save has decided to write;
	 * a timer has not, so this guard is deliberately scoped to auto-save and leaves manual saves alone.
	 *
	 * Safe to apply unconditionally: only customer 1 (Headlight's own team) is supposed to be able to
	 * edit across customers at all, so a mismatch here is always an internal tester looking at someone
	 * else's document — never a customer doing their own work. That is why this gates on the customer
	 * rather than on the role index: a role-5 user inside their own customer is doing ordinary work and
	 * keeps auto-save.
	 *
	 * Fails open when either id is unresolvable: absence is not evidence of a mismatch, and the offline
	 * template has no session to compare against at all. Both ids come back as database integers, but
	 * they cross JSON boundaries from different endpoints, so compare them numerically rather than by
	 * identity.
	 * @return {boolean}
	 */
	isSameCustomerAsDocument()
	{
		const tmpUserCustomerID = Number(this.pict.AppData?.CurrentUser?.CustomerID);
		const tmpDocumentCustomerID = Number(this.pict.AppData?.DocumentData?.ReportData?.IDCustomer);
		if (!Number.isFinite(tmpUserCustomerID) || !Number.isFinite(tmpDocumentCustomerID) || tmpUserCustomerID <= 0 || tmpDocumentCustomerID <= 0)
		{
			return true;
		}
		return tmpUserCustomerID === tmpDocumentCustomerID;
	}

	/**
	 * Whether the panels navbar offers this application a Save button.
	 *
	 * Auto-save follows the Save button: an application or customer that turned saving off through the
	 * panel configuration should not have a timer writing the document behind their back. This reads
	 * the configuration rather than the DOM deliberately — the navbar hides the Save button at runtime
	 * whenever there is no document context, and that toggle is not a statement about whether saving is
	 * offered.
	 *
	 * Fails open when there is no panels configuration at all: an embedded or stripped shell that never
	 * renders a navbar has said nothing either way, and the manifest and document gates still apply.
	 * @return {boolean}
	 */
	isSaveControlAvailable()
	{
		const tmpNavBar = this.pict.settings?.HeadlightPanels?.Configuration?.NavBar;
		if (!tmpNavBar || !Array.isArray(tmpNavBar.Buttons))
		{
			return true;
		}
		if (tmpNavBar.hideNavbar)
		{
			return false;
		}
		const tmpSaveButton = tmpNavBar.Buttons.find((pButton) => pButton && (pButton.id === SAVE_BUTTON_ID || pButton.name === 'save'));
		if (!tmpSaveButton)
		{
			return false;
		}
		return !String(tmpSaveButton.wrapperClass || '').split(/\s+/).includes('is-hidden');
	}

	/**
	 * Arm the auto-save timer.
	 * @return {boolean} Whether the timer was armed.
	 */
	start()
	{
		this.stop();
		this.Suspended = false;
		this.ConsecutiveFailures = 0;
		if (!this.isEligible())
		{
			this.log.info('AutoSave: not enabled for this document (disabled by manifest, locked, read-only, or a non-interactive render).');
			this._setState(STATES.DISABLED);
			return false;
		}
		this.Running = true;
		if (!this.UserHasInteracted)
		{
			// A form opened to be read — the case a support user spot-checking someone else's document is
			// in — is never written to. The baseline moves to that first edit, which is also truer than
			// this one: entity hydration, the media registry and the load-time solve all settle in
			// between, and none of that is the user's work.
			this._captureSnapshot();
		}
		this._listenForInteractions();
		this._setState(STATES.IDLE);
		// Dormant by default. Re-arming here covers a reconfigure (the user changing the cadence in
		// Settings) that lands on top of edits which have not been written yet.
		if (this.UserHasInteracted && this._hasPendingWork())
		{
			this.log.info(`AutoSave: enabled; unsaved changes are pending, saving in ${this.Configuration.IntervalSeconds} seconds.`);
			this._scheduleNextCycle();
			return true;
		}
		this.log.info(`AutoSave: enabled; the ${this.Configuration.IntervalSeconds} second countdown starts at the next change.`);
		return true;
	}

	/**
	 * Whether there is anything worth waking up for.
	 *
	 * The document as it stands differs from what the last save actually sent — so a value typed and
	 * then taken back out again is not pending work, because the payload would be identical.
	 * `SkipWhenUnchanged: false` is a manifest opting out of exactly this reasoning, so it keeps the
	 * timer running regardless.
	 * @return {boolean}
	 */
	_hasPendingWork()
	{
		if (!this.Configuration.SkipWhenUnchanged)
		{
			return true;
		}
		return this._hasUnsavedChanges();
	}

	/**
	 * Record that the user has modified the form, and start the countdown if this is the first time.
	 *
	 * Cheap and idempotent — it is called on every keystroke and every framework data change, so the
	 * already-interacted path is a single boolean test.
	 *
	 * @param {String} [pSource] - What observed the interaction, for the log line.
	 * @return {void}
	 */
	noteUserInteraction(pSource)
	{
		const tmpFirstEver = !this.UserHasInteracted;
		if (tmpFirstEver)
		{
			this.UserHasInteracted = true;
		}
		if (!this.Running)
		{
			// Auto-save is off for this document; the flag still latches so a later reconfigure (the user
			// switching it on in Settings mid-edit) does not have to wait for another edit.
			return;
		}
		if (this._Timer)
		{
			// A countdown is already running. Deliberately not restarted — a fast typist would otherwise
			// push the deadline out indefinitely and never be saved.
			return;
		}
		if (tmpFirstEver)
		{
			// Baseline the document as it stands immediately before this first edit lands, so the edit
			// itself is what the cycle sees as a change. After this, only a save moves the baseline.
			this._captureSnapshot();
		}
		this.log.info(`AutoSave: change observed (${pSource || 'unknown'}); saving in ${this.Configuration.IntervalSeconds} seconds.`);
		this._scheduleNextCycle();
	}

	/**
	 * Watch the document form for the first sign of the user entering data.
	 *
	 * One delegated listener on the form element, in the capture phase. The per-element
	 * `addEventListener` ban does not apply: this is a single listener on the shell's own `<form>`,
	 * which is never re-rendered (the section views render inside it), so there is nothing to leak.
	 * `input` rather than `change` because pict binds `onchange` — waiting for blur would leave someone
	 * typing for minutes with no countdown running at all.
	 * @return {void}
	 */
	_listenForInteractions()
	{
		this._stopListeningForInteractions();
		const tmpFormElement = this._resolveDocumentFormElement();
		if (!tmpFormElement)
		{
			// No form element to watch. The framework hooks still catch edits; this is only the fast path.
			return;
		}
		// Stays attached for the life of the provider: the timer goes dormant after every save, so each
		// later edit is what wakes it again. The handler is a couple of boolean tests once a countdown
		// is already running, which is what makes it cheap enough to sit on every keystroke.
		const fHandler = (pEvent) =>
		{
			this.noteUserInteraction(pEvent?.type === 'input' ? 'typing' : 'selection');
		};
		tmpFormElement.addEventListener('input', fHandler, true);
		tmpFormElement.addEventListener('change', fHandler, true);
		this._DetachInteractionListener = () =>
		{
			tmpFormElement.removeEventListener('input', fHandler, true);
			tmpFormElement.removeEventListener('change', fHandler, true);
		};
	}

	/**
	 * The document form element the shells all declare, or null outside a browser.
	 * @return {?any}
	 */
	_resolveDocumentFormElement()
	{
		if (typeof document === 'undefined')
		{
			return null;
		}
		return document.getElementById(DOCUMENT_FORM_ID);
	}

	/**
	 * @return {void}
	 */
	_stopListeningForInteractions()
	{
		if (this._DetachInteractionListener)
		{
			this._DetachInteractionListener();
			this._DetachInteractionListener = null;
		}
	}

	/**
	 * Disarm the timer. Safe to call when nothing is running.
	 * @param {String} [pReason] - Logged when supplied.
	 * @return {void}
	 */
	stop(pReason)
	{
		this._stopListeningForInteractions();
		if (this._Timer)
		{
			clearTimeout(this._Timer);
			this._Timer = null;
		}
		if (this.Running && pReason)
		{
			this.log.info(`AutoSave: stopping — ${pReason}`);
		}
		this.Running = false;
	}

	/**
	 * Stop auto-saving because saving is failing, and tell the user once.
	 *
	 * Deliberately terminal: a form whose saves are being refused (expired session, revoked edit
	 * permission, a document locked out from under the user) would otherwise retry forever, filling
	 * the log and the network tab with writes that can never land.
	 *
	 * @param {String} pMessage - User-facing explanation.
	 * @return {void}
	 */
	suspend(pMessage)
	{
		this.stop();
		this.Suspended = true;
		this.log.warn(`AutoSave: suspended — ${pMessage}`);
		this._setState(STATES.SUSPENDED, pMessage);
		this.pict.views?.HeadlightPanels?.toast?.(
		{
			message: `<strong>Auto-save paused.</strong><br/><em>${pMessage}</em>`,
			type: 'is-warning',
			duration: 8000,
		});
	}

	/**
	 * Re-arm auto-save after a suspension. A successful save of any kind calls this.
	 * @return {boolean} Whether auto-save is running again.
	 */
	resume()
	{
		if (!this.isEligible())
		{
			return false;
		}
		this.log.info('AutoSave: resuming after a successful save.');
		return this.start();
	}

	/**
	 * Run one save immediately, bypassing the interval and the unchanged-document check.
	 *
	 * Resolves with the error rather than rejecting, matching `DocumentProvider.handleSaveAsync`.
	 * @return {Promise<Error|undefined>}
	 */
	async saveNow()
	{
		this._setState(STATES.SAVING);
		this._AutoSaveInFlight = true;
		// Snapshot what this save is about to send. Promoting *this* on success rather than the state
		// afterwards is what keeps an edit made while the save was in flight counted as pending — with a
		// dormant timer nothing would come back for it otherwise.
		const tmpSentSnapshot = this._serializeDocumentState();
		/** @type {Error|undefined} */
		let tmpError;
		try
		{
			tmpError = await this._executeSave();
		}
		catch (pError)
		{
			tmpError = pError;
		}
		finally
		{
			this._AutoSaveInFlight = false;
		}
		if (tmpError)
		{
			this._recordFailure(tmpError);
		}
		else
		{
			this._recordSuccess(tmpSentSnapshot);
		}
		return tmpError;
	}

	/**
	 * Notification from `DocumentProvider` that a save lifecycle finished, whoever started it.
	 *
	 * Restarts the countdown from the last save rather than from the last tick, so a manual Save
	 * resets the clock — the user who just saved should not get an auto-save two seconds later.
	 * Also revives a suspended provider: if a manual save now succeeds, whatever was refusing the
	 * write has cleared.
	 *
	 * @param {Error} [pError] - The error the save lifecycle produced, if any.
	 * @return {void}
	 */
	onSaveLifecycleSettled(pError)
	{
		// The auto-save path owns its own bookkeeping in saveNow(); this callback fires first for
		// those saves and would double-publish the status.
		if (this._AutoSaveInFlight)
		{
			return;
		}
		if (pError)
		{
			// A failed manual save is reported to the user by whoever requested it; auto-save keeps
			// its own counter for its own writes and does not escalate on someone else's failure.
			return;
		}
		this._captureSnapshot();
		this.LastSavedAt = new Date();
		if (this.Suspended)
		{
			this.resume();
			return;
		}
		if (!this.Running)
		{
			return;
		}
		this.ConsecutiveFailures = 0;
		this._setState(STATES.SAVED, '', true);
		if (!this.UserHasInteracted)
		{
			// Someone saved a form they have not edited — a deliberate manual save on a document they are
			// only looking at. That is their call to make once; it does not start a timer that would keep
			// making it for them.
			return;
		}
		// A manual save settles the document, so the timer sleeps until the next change — the same as
		// after an auto-save. Anything the user changed while the save was in flight keeps it awake.
		if (this._hasPendingWork())
		{
			this._scheduleNextCycle();
			return;
		}
		this._goDormant();
	}

	/**
	 * Put the timer to sleep until the next change wakes it.
	 *
	 * Clears any countdown still in flight: a manual save can settle part-way through one, and that
	 * pending timer would otherwise fire against a document already written.
	 * @return {void}
	 */
	_goDormant()
	{
		if (this._Timer)
		{
			clearTimeout(this._Timer);
			this._Timer = null;
		}
	}

	/**
	 * Arm the timer for the next cycle, replacing any pending one.
	 * @return {void}
	 */
	_scheduleNextCycle()
	{
		if (this._Timer)
		{
			clearTimeout(this._Timer);
		}
		this._Timer = setTimeout(() =>
		{
			this._Timer = null;
			this._runCycle();
		}, this.Configuration.IntervalSeconds * 1000);
	}

	/**
	 * One timer tick: attempt a save, then re-arm.
	 * @return {Promise<void>}
	 */
	async _runCycle()
	{
		if (!this.Running)
		{
			return;
		}
		try
		{
			await this._attemptSave();
		}
		catch (pError)
		{
			this.log.error(`AutoSave: unexpected error during an auto-save cycle: ${pError?.message || pError}`, { Stack: pError?.stack });
		}
		// A suspension inside the cycle clears Running, which is what stops the loop. Otherwise the timer
		// only continues while there is something outstanding: a save that could not run yet (a manual
		// save in flight, an approval action, no connection), or one that failed and will be retried.
		// With nothing pending it goes dormant, and the next change is what wakes it.
		if (!this.Running)
		{
			return;
		}
		if (this._hasPendingWork())
		{
			this._scheduleNextCycle();
			return;
		}
		this._goDormant();
	}

	/**
	 * Decide whether this cycle should actually write, and write if so.
	 * @return {Promise<void>}
	 */
	async _attemptSave()
	{
		if (!this.isEligible())
		{
			this.stop('the document is no longer editable.');
			this._setState(STATES.DISABLED);
			return;
		}
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		if (tmpDocumentProvider)
		{
			// An approval action is mid-flight (it may be locking the document right now). Writing
			// underneath it is exactly the race this feature is meant to close.
			if (tmpDocumentProvider.isTakingAction)
			{
				return;
			}
			// A manual save is already running. Its completion calls onSaveLifecycleSettled, which
			// restarts our countdown — queueing a second write here would be pure duplication.
			if (tmpDocumentProvider.IsSaving)
			{
				return;
			}
		}
		else
		{
			// No save path at all — an app shell that never registered the panels providers. Stay armed
			// in case one appears rather than reporting a failure the user cannot act on.
			return;
		}
		if (this._isBrowserOffline())
		{
			this._setState(STATES.OFFLINE, 'Waiting for a connection.');
			return;
		}
		if (this.Configuration.SkipWhenUnchanged && !this._hasUnsavedChanges())
		{
			return;
		}
		await this.saveNow();
	}

	/**
	 * Request an application save.
	 *
	 * Every save goes through the document save lifecycle, offline included — the transport is chosen
	 * inside `HeadlightDocumentService`, below this. Writing to the native bridge from here instead
	 * would skip the lifecycle, and with it the marshal and the `Document.EntityData` emission the
	 * server applies when the record reaches it.
	 *
	 * @return {Promise<Error|undefined>}
	 */
	_executeSave()
	{
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		if (!tmpDocumentProvider || typeof tmpDocumentProvider.handleSaveAsync !== 'function')
		{
			return Promise.resolve(new Error('No document save path is available.'));
		}
		// Muted: the whole point of auto-save is that it does not interrupt with a toast.
		return Promise.resolve(tmpDocumentProvider.handleSaveAsync(true));
	}

	/**
	 * Whether this form's saves are written to local storage rather than to the server.
	 *
	 * `HeadlightDocumentService` owns the transport decision; this only asks it, so auto-save and the
	 * save itself can never disagree about which one is running.
	 *
	 * @return {boolean}
	 */
	_isLocalDocumentTransport()
	{
		const tmpDocumentService = this.pict.services?.HeadlightDocumentService;
		if (!tmpDocumentService || typeof tmpDocumentService.isLocalDocumentTransport !== 'function')
		{
			return false;
		}
		return tmpDocumentService.isLocalDocumentTransport();
	}

	/**
	 * Whether the browser is reporting no network. Skipping on this is not a failure — the device is
	 * in a tunnel, not the server refusing us — so it must not count toward the suspension budget.
	 *
	 * A form on the local transport is never blocked by this: the save goes to the device, and having
	 * no network is the state it is built for.
	 *
	 * @return {boolean}
	 */
	_isBrowserOffline()
	{
		if (this._isLocalDocumentTransport())
		{
			return false;
		}
		return typeof navigator !== 'undefined' && navigator.onLine === false;
	}

	/**
	 * Serialize the parts of the document the save actually sends, for change detection.
	 * @return {?String} The snapshot, or null when it could not be produced.
	 */
	_serializeDocumentState()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData)
		{
			return null;
		}
		try
		{
			return JSON.stringify(
			{
				FormData: tmpReportData.FormData,
				EntityData: tmpReportData.EntityData,
				Observations: Array.isArray(tmpReportData.Observations) ? tmpReportData.Observations.map((pObservation) => pObservation?.IDObservation) : tmpReportData.Observations,
			});
		}
		catch (pError)
		{
			this.log.warn(`AutoSave: could not serialize the document for change detection (${pError?.message || pError}); auto-saving unconditionally.`);
			return null;
		}
	}

	/**
	 * Record the current document state as "saved".
	 * @return {void}
	 */
	_captureSnapshot()
	{
		this._SavedSnapshot = this._serializeDocumentState();
	}

	/**
	 * Whether anything has changed since the last snapshot. Unserializable state is treated as
	 * changed so a form with exotic values still gets saved.
	 * @return {boolean}
	 */
	_hasUnsavedChanges()
	{
		const tmpSnapshot = this._serializeDocumentState();
		if (tmpSnapshot === null || this._SavedSnapshot === null)
		{
			return true;
		}
		return tmpSnapshot !== this._SavedSnapshot;
	}

	/**
	 * @param {?String} [pSentSnapshot] - The document state this save sent, if it is known.
	 * @return {void}
	 */
	_recordSuccess(pSentSnapshot)
	{
		this.ConsecutiveFailures = 0;
		if (pSentSnapshot === undefined)
		{
			this._captureSnapshot();
		}
		else
		{
			this._SavedSnapshot = pSentSnapshot;
		}
		this.LastSavedAt = new Date();
		this._setState(STATES.SAVED, '', true);
	}

	/**
	 * Escalate a failed auto-save: back off, then suspend once it is clear the write cannot land.
	 * @param {Error} pError - The save error.
	 * @return {void}
	 */
	_recordFailure(pError)
	{
		this.ConsecutiveFailures++;
		this.log.error(`AutoSave: save attempt ${this.ConsecutiveFailures} failed: ${pError?.message || pError}`);
		if (AutoSaveProvider.isAuthorizationError(pError))
		{
			this.suspend('Your permission to edit this document has changed. Reload the page to continue.');
			return;
		}
		if (this.ConsecutiveFailures >= this.Configuration.MaxConsecutiveFailures)
		{
			this.suspend('The document could not be saved after several attempts. Use the Save button once the problem clears.');
			return;
		}
		this._setState(STATES.RETRYING, 'The last auto-save did not complete. Retrying.');
	}

	/**
	 * Whether an error means "the server refused you" rather than "the server was unreachable".
	 * @param {any} pError - The error to classify.
	 * @return {boolean}
	 */
	static isAuthorizationError(pError)
	{
		if (!pError)
		{
			return false;
		}
		const tmpStatus = pError.StatusCode ?? pError.statusCode ?? pError.status;
		if (tmpStatus === 401 || tmpStatus === 403)
		{
			return true;
		}
		const tmpMessage = String(pError.message || pError);
		return AUTHORIZATION_ERROR_PATTERNS.some((pPattern) => pPattern.test(tmpMessage));
	}

	/**
	 * @param {String} pState - One of STATES.
	 * @param {String} [pMessage] - Optional user-facing detail, surfaced as the indicator tooltip.
	 * @param {boolean} [pFlash] - Whether the indicator should briefly draw attention to itself.
	 * @return {void}
	 */
	_setState(pState, pMessage, pFlash)
	{
		this.State = pState;
		this.StateMessage = pMessage || '';
		this._publishStatus(pFlash);
	}

	/**
	 * Push the current state into AppData for the navbar indicator, and nudge the panels view to
	 * repaint it.
	 *
	 * `StatusSlot` is the one-or-zero-element array the navbar template iterates: empty renders
	 * nothing at all, which is what a form with auto-save turned off should show.
	 * @param {boolean} [pFlash] - Whether this transition should animate.
	 * @return {void}
	 */
	_publishStatus(pFlash)
	{
		const tmpRecord = this._buildStatusRecord(pFlash);
		this.pict.AppData.AutoSave =
		{
			Enabled: Boolean(this.Configuration?.Enabled),
			Running: this.Running,
			Suspended: this.Suspended,
			State: this.State,
			IntervalSeconds: this.Configuration?.IntervalSeconds,
			LastSavedISO: this.LastSavedAt ? this.LastSavedAt.toISOString() : null,
			StatusSlot: tmpRecord ? [ tmpRecord ] : [],
		};
		this.pict.views?.HeadlightPanels?.syncAutoSaveStatus?.();
	}

	/**
	 * Build the record the indicator template renders, or null when nothing should be shown.
	 * @param {boolean} [pFlash] - Whether this transition should animate.
	 * @return {?{ State: String, Label: String, IconClass: String, StateClass: String, Tooltip: String, FlashClass: String }}
	 */
	_buildStatusRecord(pFlash)
	{
		if (this.State === STATES.DISABLED)
		{
			return null;
		}
		const tmpPresentation = STATE_PRESENTATION[this.State] || STATE_PRESENTATION[STATES.IDLE];
		const tmpSavedClock = this.LastSavedAt ? this._formatClockTime(this.LastSavedAt) : '';
		let tmpLabel;
		switch (this.State)
		{
		case STATES.SAVING:
			tmpLabel = 'Saving…';
			break;
		case STATES.SAVED:
			tmpLabel = `Saved ${tmpSavedClock}`;
			break;
		case STATES.OFFLINE:
			tmpLabel = 'Waiting for connection';
			break;
		case STATES.RETRYING:
			tmpLabel = 'Save retrying';
			break;
		case STATES.SUSPENDED:
			tmpLabel = 'Auto-save paused';
			break;
		default:
			tmpLabel = tmpSavedClock ? `Saved ${tmpSavedClock}` : 'Auto-save on';
			break;
		}
		let tmpTooltip = this.StateMessage;
		if (!tmpTooltip)
		{
			tmpTooltip = tmpSavedClock ?
				`Auto-saving every ${this.Configuration.IntervalSeconds} seconds. Last saved at ${tmpSavedClock}.` :
				`Auto-saving every ${this.Configuration.IntervalSeconds} seconds.`;
		}
		return {
			State: this.State,
			Label: tmpLabel,
			IconClass: tmpPresentation.IconClass,
			StateClass: tmpPresentation.StateClass,
			Tooltip: tmpTooltip,
			FlashClass: pFlash ? 'is-flashing' : '',
		};
	}

	/**
	 * Format a wall-clock time in the document's timezone when Fable's Dates service is available.
	 * @param {Date} pDate - The moment to format.
	 * @return {String}
	 */
	_formatClockTime(pDate)
	{
		try
		{
			if (this.fable?.Dates?.dayJS)
			{
				return this.fable.Dates.dayJS(pDate).format('h:mm A');
			}
		}
		catch (pError)
		{
			this.log.trace?.(`AutoSave: falling back to the native clock formatter (${pError?.message || pError}).`);
		}
		return pDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	}
}

module.exports = AutoSaveProvider;
module.exports.STATES = STATES;
module.exports.DEFAULT_INTERVAL_SECONDS = DEFAULT_INTERVAL_SECONDS;
module.exports.MINIMUM_INTERVAL_SECONDS = MINIMUM_INTERVAL_SECONDS;
module.exports.MAXIMUM_INTERVAL_SECONDS = MAXIMUM_INTERVAL_SECONDS;
module.exports.DEFAULT_MAX_CONSECUTIVE_FAILURES = DEFAULT_MAX_CONSECUTIVE_FAILURES;
module.exports.USER_PREFERENCE_ENABLED_KEY = USER_PREFERENCE_ENABLED_KEY;
module.exports.USER_PREFERENCE_INTERVAL_KEY = USER_PREFERENCE_INTERVAL_KEY;

},{"pict-provider":479,"pict-section-form/source/views/Pict-View-DynamicForm.js":563}],20:[function(require,module,exports){
const Async = require('async');
const PictProvider = require('pict-provider');

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */
/** @typedef {import('./InputTypeBehaviorProvider')} InputTypeBehaviorProvider */

/**
 * @typedef {Object} FieldDistillingMapping
 *
 * @property {String} DatumKey - The data locatinon with in the form.
 * @property {String} BundleHash - The bundle hash to load from the distilling service.
 * @property {String} [BundleNameKey] - (optional) The bundle key that represents the value's name (for display). If omitted, the value is used for name and value.
 * @property {String} BundleValueKey - The bundle key that represents the value to store in the form datum.
 * @property {String} Type - The type of control (used to understand how to marshal data). 'select' is for a select2 dropdown, otherwise it is treated as scalar text.
 * @property {Boolean} [Readonly] - (optional) If the field should be readonly.
 * @property {String} [NoSelectionName] - (optional) The name to use for the "no selection" option.
 * @property {String} [NoSelectionValue] - (optional) The value to use for the "no selection" option.
 */

/**
 * Provider to add behaviors to interface with views / controls based on InputType.
 *
 * Ideas:
 *
 * Understand what kind of values the control can accept? Single- vs. multi-value?
 * Understand whether the control is editable / readonly.
 * Understand whether the control can be auto-filled.
 * Understand whether the control is part of a formula? (ex. in case we need to trigger the solver on distilling?)
 * Understand the control's connection to the distilling bundle.
 * Get / set the control value / selection.
 */
class DistillingProvider extends PictProvider
{
	/**
	 * @param {any} pFable - Fable instance
	 * @param {Object} pOptions - Options for the provider
	 * @param {String} pServiceHash - Hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/**
		 * @type {{
		 *	Interactive: boolean,
		 *	ConditionalCSS: Record<String, String>,
		 *	InitialSaveRequired: boolean,
		 *	Status: string,
		 *	DistillingMapping: Array<FieldDistillingMapping>,
		 *	Select2OptionsCache: Record<String, Array<{ id: string, text: string }>>,
		 *	DocumentData: any,
		 * }}
		 */
		this.AppData;
		// this is set on each index.html for the respective document behavior
		this.AppData.Interactive = window['_InteractiveForm'];
		this.Application = this.pict.PictApplication;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;
	}

	/**
	 * Using this top get the right type checking. zzz
	 *
	 * @return {InputTypeBehaviorProvider}
	 */
	get input()
	{
		return this.pict.providers.Input;
	}

	/**
	 * Initialize the provider. Call this before any other methods to provide relevant configuration.
	 *
	 * @private
	 *
	 * @param {Object} reportOptions - The report options.
	 * @param {Object} formManifestDefinition - The form manifest definition.
	 */
	_initializeProvider(reportOptions, formManifestDefinition)
	{
		if (Array.isArray(reportOptions?.DistillingMapping))
		{
			this.AppData.DistillingMapping = reportOptions.DistillingMapping;
		}
		else
		{
			this.AppData.DistillingMapping = this.extractDistillingMappingFromManifest(formManifestDefinition?.Descriptors);
		}
		if (Array.isArray(this.AppData.DistillingMapping))
		{
			// only keep mapping with required values populated
			this.AppData.DistillingMapping = this.AppData.DistillingMapping.filter((mapping) =>
			{
				const isValid = mapping?.BundleValueKey && mapping?.BundleHash && mapping?.DatumKey;
				if (!isValid)
				{
					this.pict.log.error('Invalid distilling mapping; ignoring', { mapping });
				}
				return isValid;
			});
		}
	}

	/**
	 * Initialize an HTML element as a distilling enabled control.
	 *
	 * @param {HTMLElement} input - The input to initialize.
	 * @param {Array<FieldDistillingMapping>} [dataToBundleKeyMappings] - The mappings from form fields to distilling bundle keys.
	 *
	 * @return {boolean} - True if the control was initialized.
	 */
	initializeControl(input, dataToBundleKeyMappings)
	{
		//FIXME: separation of concerns
		if (input instanceof HTMLSelectElement && input.getAttribute('pict-initialized') !== 'true')
		{
			const datumInput = this.input.getInputElementForControlElement(input);
			if (!datumInput)
			{
				this.pict.fable.log.error('No datum input found for control', { input });
				return false;
			}
			const options = { };
			const datumKey = datumInput.getAttribute('data-i-datum');
			if (datumKey && dataToBundleKeyMappings.some((mapping) => mapping.DatumKey == datumKey))
			{
				options.dataAdapter = $.fn.select2.amd.require('select2/data/localPaginationAdapter');
				options.ajax = {}; // necessary for pagination to work
				options.datumKey = datumKey; // attaches to the select2 options cache for local pagination (currently only used by distilling)
			}
			this.pict.log.info(`Initializing select2 for ${datumKey} with distilling`, { input });
			$(input).select2(options);
			input.setAttribute('pict-initialized', 'true');
			return true;
		}
		return false;
	}

	/**
	 * Synthesize the distilling mapping from the form definition.
	 *
	 * @param {Record<String, any> | Array<any>} descriptorMap - The descriptor map.
	 *
	 * @return {Array<FieldDistillingMapping>} - The field level distilling mappings to use.
	 */
	extractDistillingMappingFromManifest(descriptorMap)
	{
		const mapping = [];
		if (!descriptorMap)
		{
			return mapping;
		}

		if (!(typeof descriptorMap === 'object'))
		{
			this.pict.fable.log.error('Invalid descriptor map type', { descriptorMap });
			return mapping;
		}

		for (const [ datumKey, descriptor ] of Object.entries(descriptorMap))
		{
			if (typeof descriptor.PictForm?.DistillingMapping === 'object')
			{
				descriptor.PictForm.DistillingMapping.DatumKey = datumKey;
				// attempting to note here fields that should not be considered selected (readonly)
				descriptor.PictForm.DistillingMapping.Type = descriptor.PictForm?.InputType?.toLowerCase() || descriptor.DataType?.toLowerCase();
				if (!('Readonly' in descriptor.PictForm.DistillingMapping))
				{
					descriptor.PictForm.DistillingMapping.Readonly = descriptor.PictForm.Readonly || descriptor.PictForm.DistillingMapping.Type.toLowerCase() == 'readonly';
				}
				mapping.push(descriptor.PictForm.DistillingMapping);
			}
		}
		return mapping;
	}

	/**
	 * Handle document loaded event.
	 *
	 * @param {Record<String, any>} data - The loaded data.
	 */
	async onDataLoad(data)
	{
		//FIXME: once lifecycle exists for real: await super.onDataLoad(data);
		const doc = data?.DocumentData?.ReportData;

		//FIXME: should be able to work from other data sources, not just documents
		if (!doc)
		{
			this.pict.log.error('No document found for distilling provider', { data });
			return;
		}

		//FIXME: just once?
		this._initializeProvider(doc?.ReportOptions, this.pict.settings.DefaultFormManifest);

		//FIXME: streamline / parallelize this
		/**
		 * @type {Record<String, import('@paviasystems/grafee').Grafee>}
		 */
		this.Graphs = { };
		if (this.AppData.DistillingMapping?.length > 0)
		{
			const bundlesToLoad = Array.from(new Set(this.AppData.DistillingMapping
				.map((mapping) => mapping.BundleHash)
				.filter((bundleHash) => typeof bundleHash === 'string')));
			await Async.eachLimit(bundlesToLoad, 3, (bundleHash, next) =>
			{
				//FIXME: may want to source the project ID from elsewhere in some cases
				const uri = bundleHash ? `Distilling/For/${bundleHash}/Project/${doc.IDProject}` : `Distilling/For/Project/${doc.IDProject}`;
				this.pict.HeadlightRestClient.getJSON(uri, (err, bundleResponse) =>
				{
					if (err)
					{
						if (!(err instanceof Error))
						{
							err = new Error(err);
						}
						return next(err);
					}
					const graph = new window.Grafee(bundleResponse.Bundle);
					this.Graphs[bundleHash] = graph;
					next();
				});
			});
		}
	}

	/**
	 * Use configuration to look up current values for distilling mapped fields.
	 *
	 * @return {Record<String, String>} - The distilled values.
	 */
	getDistilledValues()
	{
		/** @type {Record<string, string>} */
		const snapshot = { };
		if (!this.AppData.DistillingMapping?.length)
		{
			return snapshot;
		}
		const formData = this.AppData.DocumentData?.ReportData?.FormData;
		if (!formData)
		{
			return snapshot;
		}
		for (const { DatumKey: datumKey } of this.AppData.DistillingMapping)
		{
			const value = this.pict.manifest.getValueAtAddress(formData, datumKey);
			snapshot[datumKey] = value;
		}
		return snapshot;
	}

	/**
	 * Wire any ui controls to pull data from the distilling graph, based on configuration.
	 *
	 * @param {Array<FieldDistillingMapping>} dataToBundleKeyMappings - The mappings from form fields to distilling bundle keys.
	 */
	registerDistilling(dataToBundleKeyMappings)
	{
		if (!Array.isArray(dataToBundleKeyMappings))
		{
			return;
		}

		const getSelectedValues = () =>
		{
			const snapshot = this.getDistilledValues();
			const selectedValues = { };
			for (const { DatumKey: datumKey, BundleValueKey: bundleValueKey, Readonly: readonly } of dataToBundleKeyMappings)
			{
				if (readonly)
				{
					// don't put readonly fields in the selected values as they are not editable
					continue;
				}
				if (snapshot[datumKey] !== undefined && snapshot[datumKey] !== null && snapshot[datumKey] !== '')
				{
					selectedValues[bundleValueKey] = snapshot[datumKey];
				}
			}
			return selectedValues;
		};

		/**
		 * Trigger the distilling cascade for a given field mapping.
		 *
		 * TODO: decide how we want to handle autofill then removing the original value
		 *
		 * @param {FieldDistillingMapping} sourceFieldMapping - The source field mapping.
		*/
		const triggerDistillingCascade = (sourceFieldMapping) =>
		{
			//TODO: this should also handle invalidating fields as needed
			for (const fieldMapping of dataToBundleKeyMappings)
			{
				const { BundleHash: bundleHash, DatumKey: datumKey, BundleNameKey: bundleNameKey, BundleValueKey: bundleValueKey, Type: type } = fieldMapping;
				/** @type {import('@paviasystems/grafee').Grafee} */
				const graph = this.Graphs[bundleHash];
				if (!graph || !type || type == 'select' || type == 'option')
				{
					continue;
				}
				const values = graph.listValues(bundleValueKey, getSelectedValues());
				if (values && values.length == 1)
				{
					let nameAndValue;
					if (bundleNameKey)
					{
						nameAndValue = graph.extractJoinedValues(bundleValueKey, values, [ bundleNameKey || bundleValueKey ])[0];
					}
					else
					{
						nameAndValue = { [bundleValueKey]: values[0] };
					}
					//FIXME: how should we approach setting both value and display name? do we need that?
					this.input.setValue(`[data-i-datum="${datumKey}"]`, nameAndValue[bundleNameKey || bundleValueKey]);
				}
			}
		};

		const initValues = getSelectedValues();
		for (const fieldMapping of dataToBundleKeyMappings)
		{
			const {
				BundleHash: bundleHash,
				DatumKey: datumKey,
				BundleNameKey: bundleNameKey,
				BundleValueKey: bundleValueKey,
				Type: type,
				NoSelectionName: noSelectionName = 'Select an option',
				NoSelectionValue: noSelectionValue = fieldMapping.Type == 'numeric' ? '0' :'',
			} = fieldMapping;

			const graph = this.Graphs[bundleHash];
			if (!graph)
			{
				this.pict.fable.log.error(`No data graph found for ${bundleHash} processing distilling mapping for ${datumKey}`, { fieldMapping });
				continue;
			}
			if (!type || type == 'select' || type == 'option')
			{
				const element = document.querySelector(`[data-i-datum="${datumKey}"]`);
				let inputElement;
				let selectElement;
				if (element && element instanceof HTMLInputElement)
				{
					inputElement = element;
					//FIXME: this belongs in the input provider
					selectElement = document.getElementById('SELECT-FOR-' + element.id);
				}
				if (element && element instanceof HTMLSelectElement)
				{
					selectElement = element;
					inputElement = this.input.getInputElementForControlElement(element);
				}
				if (!inputElement || !selectElement || !(selectElement instanceof HTMLSelectElement) || !(inputElement instanceof HTMLInputElement))
				{
					this.pict.log.error('Unable to resolve elements for control', { element });
					continue;
				}
				const $selectElement = $(selectElement);
				const cacheDistilledSelect2OptionsJustInTime = () =>
				{
					const selectedValues = getSelectedValues();
					//FIXME: using search and making this dynamic would be much better
					const values = graph.listValues(bundleValueKey, selectedValues);
					/** @type {Array<Record<String, any>>} */
					let namesAndValues;
					//FIXME: put an option for "no selection" in here??
					if (bundleNameKey)
					{
						namesAndValues = graph.extractJoinedValues(bundleValueKey, values, [ bundleNameKey || bundleValueKey ]);
					}
					else
					{
						// no need to query, but convert to objects so code below is agnostic
						namesAndValues = values.map((value) => ({ [bundleValueKey]: value }));
					}
					/** @type {Array<Array<string>>} */
					const select2Options = namesAndValues.map((nameAndValue) =>
						[
							nameAndValue[bundleValueKey] ?? '',
							nameAndValue[bundleNameKey || bundleValueKey] ?? '(no name)',
						]);
					select2Options.unshift([ noSelectionValue, noSelectionName || 'N/A' ]);
					this.pict.fable.log.info(`Pushing ${namesAndValues.length} values for ${datumKey} from ${bundleNameKey || bundleValueKey} (${bundleValueKey})`);
					this.input.setOptions(`[data-i-datum="${datumKey}"]`, select2Options);
				};
				//FIXME: how to delegate all of this to the InputTypeProvider?
				$selectElement.on('select2:opening', cacheDistilledSelect2OptionsJustInTime);
				$selectElement.on('select2:close', triggerDistillingCascade.bind(this, fieldMapping));

				// set initial select2 state for distilled fields
				$selectElement.empty();
				const emptyOption = new Option(noSelectionName, noSelectionValue, true, false);
				$selectElement.append(emptyOption).trigger('change');

				// on load, we just put one value in there, so we can show the selection - the full list is deferred until interaction
				if (bundleValueKey in initValues)
				{
					const value = initValues[bundleValueKey];
					const nameAndValue = graph.extractJoinedValues(bundleValueKey, [ value ], [ bundleNameKey || bundleValueKey ])[0];
					const newOption = new Option(nameAndValue?.[bundleNameKey || bundleValueKey] || value, value, false, true);
					$selectElement.append(newOption).trigger('change');
				}
			}
			//FIXME: how to support other types of inputs in a sane way?
			else // sane?
			{
				const values = graph.listValues(bundleValueKey, getSelectedValues());
				if (values && values.length == 1)
				{
					this.input.setValue(`[data-i-datum="${datumKey}"]`, values[0]);
				}
			}
		}
	}
/*
	Below are the available events from the parent class (PictProvider):

	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}
*/
}

module.exports = DistillingProvider;

},{"async":275,"pict-provider":479}],21:[function(require,module,exports){
const PictProvider = require('pict-provider');

/** @typedef {import('./DistillingProvider')} DistillingProvider */
/** @typedef {import('./DistillingProvider').FieldDistillingMapping} FieldDistillingMapping */

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */

/**
 * Base class for InputType providers.
 *
 * Ideas:
 *
 * Understand what kind of values the control can accept? Single- vs. multi-value?
 * Understand whether the control is editable / readonly.
 * Understand whether the control can be auto-filled.
 * Understand whether the control is part of a formula? (ex. in case we need to trigger the solver on distilling?)
 * Understand the control's connection to the distilling bundle.
 * Get / set the control value / selection.
 */
class InputTypeProvider
{
	/**
	 * @param {Pict} pict - The Pict instance.
	 * @param {Function} formManifestDefinitionProvider - The form manifest definition.
	 */
	constructor(pict, formManifestDefinitionProvider)
	{
		this.pict = pict;
		this.formManifestDefinitionProvider = formManifestDefinitionProvider;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is supported by this provider.
	 */
	isControlSupported(element)
	{
		return false;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {boolean} - Whether the control is a scalar value (only stores a single selection).
	 */
	isScalar(element, manifestDefinition)
	{
		return true;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is editable.
	 */
	isEditable(element)
	{
		return true;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is aut-fill-able.
	 */
	isAutoFillEnabled(element)
	{
		return true;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is part of a solver formula.
	 */
	isSolved(element)
	{
		return true;
	}

	/**
	 * Get the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(element, manifestDefinition)
	{
		return '';
	}

	/**
	 * Set the available options for the control (if supported).
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Array<Array<string>> | Array<string>} options - The options to set. Each array element is [ value, display ]. If there is no display, inner array can be the value string.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setOptions(element, options, manifestDefinition)
	{
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to set.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setValue(element, value, manifestDefinition)
	{
	}

	/**
	 * Add a control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to add.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	addValue(element, value, manifestDefinition)
	{
	}

	/**
	 * Remove the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to remove.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	removeValue(element, value, manifestDefinition)
	{
	}

	/**
	 * Get the input element for the control (where the value is stored in the DOM / has data-i-datum / etc.).
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {HTMLInputElement} the input element
	 */
	getInputElement(element)
	{
		if (element instanceof HTMLInputElement)
		{
			return element;
		}
		return null;
	}
}

/**
 * Provider for select input types.
 *
 * NOTE: We use select2 for all select inputs.
 */
class SelectInputTypeProvider extends InputTypeProvider
{
	/**
	 * @param {Pict} pict - The Pict instance.
	 * @param {Function} formManifestDefinitionProvider - The form manifest definition.
	 */
	constructor(pict, formManifestDefinitionProvider)
	{
		super(pict, formManifestDefinitionProvider);
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is supported by this provider.
	 */
	isControlSupported(element)
	{
		if (element.tagName == 'SELECT')
		{
			return true;
		}
		// if the control is the hidden control, resolve over to the select control
		const selectElement = document.getElementById('SELECT-FOR-' + element.id);
		if (selectElement && selectElement.tagName == 'SELECT')
		{
			return true;
		}
		return false;
	}

	/**
	 * Get the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(element, manifestDefinition)
	{
		return $(element).val();
	}

	/**
	 * Set the available options for the control (if supported).
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Array<Array<string>> | Array<string>} options - The options to set. Each array element is [ value, display ]. If there is no display, inner array can be the value string.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setOptions(element, options, manifestDefinition)
	{
		/** @type {Array<{ id: string, text: string }>} */
		const select2Options = options.map((option) =>
		{
			if (Array.isArray(option))
			{
				return { id: option[0], text: option[1] || option[0] || '(no name)' };
			}
			return { id: option, text: option };
		});
		const inputElement = this.getInputElement(element);
		if (!inputElement)
		{
			this.pict.log.error(`SelectInputTypeProvider::setOptions: Could not find input element for select control.`, { element });
			return;
		}
		const datumKey = inputElement.getAttribute('data-i-datum');
		this.setSelect2OptionsForDatumKey(datumKey, select2Options);
	}

	/**
	 * Cache available values for a given field.
	 *
	 * @param {String} datumKey - The datum key to cache values for.
	 * @param {Array<{ id: string, text: string }>} namesAndValues - The values to cache.
	 */
	setSelect2OptionsForDatumKey(datumKey, namesAndValues)
	{
		const cache = this.pict.AppData.Select2OptionsCache = this.pict.AppData.Select2OptionsCache || { };
		cache[datumKey] = namesAndValues;
		this.pict.AppData.Select2OptionsCache = cache;
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to set.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setValue(element, value, manifestDefinition)
	{
		$(element).val(value).trigger('change');
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number} value - The value to add.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	addValue(element, value, manifestDefinition)
	{
		if (this.isScalar(element, manifestDefinition))
		{
			this.setValue(element, value, manifestDefinition);
			return;
		}

		let selection = $(element).val();
		if (!Array.isArray(selection))
		{
			selection = [ String(selection) ];
		}
		if (selection.includes(String(value)))
		{
			return;
		}
		$(element).val(selection.concat([ String(value) ])).trigger('change');
	}

	/**
	 * Remove a value from the control.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to remove.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	removeValue(element, value, manifestDefinition)
	{
		if (this.isScalar(element, manifestDefinition))
		{
			this.setValue(element, '', manifestDefinition);
			return;
		}

		let selection = $(element).val();
		if (!Array.isArray(selection))
		{
			selection = [ String(selection) ];
		}
		if (!selection.includes(String(value)))
		{
			return;
		}
		$(element).val(selection.filter((i) => i == value)).trigger('change');
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {boolean} - Whether the control is a scalar value (only stores a single selection).
	 */
	isScalar(element, manifestDefinition)
	{
		//FIXME: made up this property - does it exist?
		return !manifestDefinition?.MultiSelect;
	}

	/**
	 * Get the input element for the control (where the value is stored in the DOM / has data-i-datum / etc.).
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {HTMLInputElement} the input element
	 */
	getInputElement(element)
	{
		if (element instanceof HTMLSelectElement && element.id.startsWith('SELECT-FOR-'))
		{
			const hiddenElementID = element.id.replace('SELECT-FOR-', '');
			const hiddenInput = document.getElementById(hiddenElementID);
			if (!hiddenInput || !(hiddenInput instanceof HTMLInputElement))
			{
				this.pict.fable.log.error(`Could not find datum element for select; referenced element not found: ${hiddenElementID}`, { element });
				return null;
			}
			return hiddenInput;
		}
		if (element instanceof HTMLInputElement)
		{
			const selectElementID = 'SELECT-FOR-' + element.id;
			const selectInput = document.getElementById(selectElementID);
			if (!selectInput || !(selectInput instanceof HTMLSelectElement))
			{
				this.pict.fable.log.error(`Could not find datum element for select; referenced element not found: ${element.id}`, { element });
				return null;
			}
			return element;
		}
		this.pict.fable.log.error(`Could not find datum element for select; malformed ID: ${element.id}`, { element });
		return null;
	}
}

/**
 * Provider for text input types.
 */
class TextInputTypeProvider extends InputTypeProvider
{
	/**
	 * @param {Pict} pict - The Pict instance.
	 * @param {Function} formManifestDefinitionProvider - The form manifest definition.
	 */
	constructor(pict, formManifestDefinitionProvider)
	{
		super(pict, formManifestDefinitionProvider);
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is supported by this provider.
	 */
	isControlSupported(element)
	{
		return element instanceof HTMLInputElement;
	}

	/**
	 * Get the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(element)
	{
		if (element instanceof HTMLInputElement)
		{
			return element.value;
		}
		return element.innerText;
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to set.
	 */
	setValue(element, value)
	{
		if (Array.isArray(value))
		{
			value = value.join(', ');
		}
		if (typeof value == 'number')
		{
			value = String(value);
		}
		if (element instanceof HTMLInputElement)
		{
			element.value = value;
		}
		element.innerText = value;
	}
}

/**
 * Provider to add behaviors to interface with views / controls based on InputType.
 */
class InputTypeBehaviorProvider extends PictProvider
{
	/**
	 * @param {any} pFable - Fable instance
	 * @param {Object} pOptions - Options for the provider
	 * @param {String} pServiceHash - Hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {Array<InputTypeProvider>} */
		this.providers = [];

		this.addTypeProvider(SelectInputTypeProvider);
		this.setFallbackProvider(this.addTypeProvider(TextInputTypeProvider));
	}

	/**
	 * @return {DistillingProvider}
	 */
	get distilling()
	{
		return this.pict.providers.Distilling;
	}

	/**
	 * Validate a manifest descriptor.
	 *
	 * @param {Object} descriptor - The descriptor to validate.
	 */
	static validateDescriptor(descriptor)
	{
		//FIXME: how to do branching at this point?
		if (descriptor.DataType?.toLowerCase() == 'select' && !Array.isArray(descriptor?.PictForm?.SelectOptions))
		{
			if (descriptor.PictForm?.DistillingMapping)
			{
				console.info(`Descriptor for ${descriptor.Hash} is a select control with distilling mapping. Values will be populated just in time.`,
					{ mapping: descriptor.PictForm.DistillingMapping });
			}
			else
			{
				// TODO: We need to accurately account for "server-side paged" Select2 flow here. This warning can be a red herring.
				console.warn(`Descriptor for ${descriptor.Hash} is a select control but has no options provided.`, { descriptor });
				descriptor.SelectOptions = [ 'no options provided' ]; //FIXME: seems dumb - select2 currently renders weird if there is nothing in here
			}
		}
	}

	/** @typedef {typeof InputTypeProvider} InputTypeProviderClass */

	/**
	 * Add an InputType specific provider.
	 *
	 * @param {InputTypeProviderClass} TypeProviderClass - The provider to add.
	 *
	 * @return {InputTypeProvider} - The provider instance
	 */
	addTypeProvider(TypeProviderClass)
	{
		const provider = new TypeProviderClass(this.pict, () => this.formManifestDefinition);
		this.providers.push(provider);
		return provider;
	}

	/**
	 * Set the fallback provider. Used if no registered provider claims the control.
	 *
	 * @param {InputTypeProvider} provider - The provider to use
	 */
	setFallbackProvider(provider)
	{
		this.fallbackProvider = provider;
	}

	/**
	 * Get the provider for an element.
	 *
	 * @param {HTMLElement} element - The element to get the provider for.
	 *
	 * @return {InputTypeProvider} - The provider for the element.
	 */
	getProviderForElement(element)
	{
		for (const provider of this.providers)
		{
			if (provider.isControlSupported(element))
			{
				return provider;
			}
		}
		return this.fallbackProvider;
	}

	/**
	 * Handle Initialize lifecycle event.
	 */
	onInitialize()
	{
		if (!this.pict.AppData.Interactive)
		{
			return true;
		}

		this.registerSelect2Plugins();
		return super.onInitialize();
	}

	/**
	 * Register custom select2 plugins. Currently, a local pagination adapter.
	 */
	registerSelect2Plugins()
	{
		// idea: use this to get distilling options, or uhh, whatever we got
		const getOptions = (adapter) =>
		{
			return this.pict.AppData.Select2OptionsCache?.[adapter.options.options.datumKey] || [];
		};

		//NOTE: the select2 types don't include define here, but this works
		// @ts-ignore
		$.fn.select2.amd.define('select2/data/localPaginationAdapter', [
			'select2/data/array',
			'select2/utils',
		],
		function(ArrayAdapter, Utils)
		{
			/**
			 * The local pagination adapter "class".
			 *
			 * @param {JQuery<HTMLElement>} $element - The element to attach the adapter to.
			 * @param {any} options - The options for the adapter.
			 */
			function LocalPaginationAdapter($element, options)
			{
				//NOTE: the __super__ isn't recognized because the extension APIs / types aren't in the generated types
				// @ts-ignore
				LocalPaginationAdapter.__super__.constructor.call(this, $element, options);
			}
			Utils.Extend(LocalPaginationAdapter, ArrayAdapter); // eslint-disable-line new-cap

			LocalPaginationAdapter.prototype.query = function(params, callback)
			{
				const fullData = getOptions(this);
				//TODO: customizable
				const pageSize = 100;

				if (!('page' in params))
				{
					params.page = 1;
				}
				const term = (params.term || '').toLowerCase();
				let results;
				if (term == '')
				{
					results = fullData;
				}
				else
				{
					results = $.map(fullData, function(obj)
					{
						//TODO: something more locale friendly
						if (obj.text && obj.text.toLowerCase().includes(term))
						{
							return obj;
						}
					});
				}
				callback({
					results: results.slice((params.page - 1) * pageSize, params.page * pageSize),
					pagination: {
						more: results.length >= params.page * pageSize,
					},
				});
			};

			return LocalPaginationAdapter;
		});
	}

	/**
	 * Handle document loaded event.
	 *
	 * @param {Object<String, any>} data - The loaded data.
	 */
	async onDataLoad(data)
	{
		//FIXME: once lifecycle exists for real: await super.onDataLoad(data);
		this.formManifestDefinition = this.pict.settings.DefaultFormManifest;
	}

	/**
	 * Get the manifest definition for an element.
	 *
	 * @param {HTMLElement} element - The element to get the manifest definition for.
	 *
	 * @return {Object} - The manifest definition for the element.
	 */
	getElementManifestDefinition(element)
	{
		//TODO: also look at data-i-form..? do we need to since it's a manifest key and can't be duplicated? not sure
		const inputElement = this.getInputElementForControlElement(element);
		if (!inputElement)
		{
			this.pict.log.error(`SelectInputTypeProvider::setOptions: Could not find input element for select control.`, { element });
			return;
		}
		const elementDatumKey = inputElement.getAttribute('data-i-datum');
		const manifestDefinition = this.formManifestDefinition;
		return manifestDefinition?.Descriptors?.[elementDatumKey];
	}

	/**
	 * Set the available options for the control (if supported).
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 * @param {Array<Array<string>> | Array<string>} options - The options to set. Each array element is [ value, display ]. If there is no display, inner array can be the value string.
	 */
	setOptions(selector, options)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
			this.pict.log.warn(`InputType::setOptions: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`InputType::setOptions: Could not find element matching: ${selector}`);
			return;
		}
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return;
		}
		const manifestDefinition = this.getElementManifestDefinition(element);
		provider.setOptions(element, options, manifestDefinition);
	}

	/**
	 * Get the input (value storage) element for a control.
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 *
	 * @return {HTMLInputElement} - The input element.
	 */
	getInputElement(selector)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
			this.pict.log.warn(`InputType::setOptions: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`InputType::setOptions: Could not find element matching: ${selector}`);
			return;
		}
		return this.getInputElementForControlElement(element);
	}

	/**
	 * Get the input (value storage) element for a control based on one element.
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {HTMLInputElement} - The input element.
	 */
	getInputElementForControlElement(element)
	{
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return;
		}
		return provider.getInputElement(element);
	}

	/**
	 * Set a control's value.
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 * @param {String} value - The value to set.
	 */
	setValue(selector, value)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
			this.pict.log.warn(`InputType::setValue: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`InputType::setValue: Could not find element matching: ${selector}`);
			return;
		}
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return;
		}
		const manifestDefinition = this.getElementManifestDefinition(element);
		provider.setValue(element, value, manifestDefinition);
	}

	/**
	 * Get a control's value.
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(selector)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
		this.pict.log.warn(`InputType::getValue: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`Could not find element matching: ${selector}`);
			return '';
		}
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return '';
		}
		const manifestDefinition = this.getElementManifestDefinition(element);
		return provider.getValue(element, manifestDefinition);
	}

	/**
	 * Initialize any uninitialized controls on the DOM.
	 *
	 * TODO: figure out how to distrubute the logic into control specific providers in a sane way
	 */
	initializeControls()
	{
		if (this.pict.AppData.DistillingMapping?.length > 0)
		{
			if (this.distilling)
			{
				//FIXME: how does this work with multiple mappings?
				this.distilling.registerDistilling(this.pict.AppData.DistillingMapping);
			}
		}
	}
}

module.exports = InputTypeBehaviorProvider;

},{"pict-provider":479}],22:[function(require,module,exports){
const FableServiceProviderBase = require('fable-serviceproviderbase');
//const SyncShim = require('sync-shim');

/** @typedef {import('fable')} Fable */
/** @typedef {import('headlight-rest-client')} HeadlightRestClient */

/**
 * Document management services (load, save, download, etc.).
 */
class HeadlightDocumentService extends FableServiceProviderBase
{
	/**
	 * @param {Fable} pFable - The fable instance
	 * @param {any} pOptions - Options for this service
	 * @param {any} pServiceHash - The fable service hash for this instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { PictApplication?: any, AppData?: any, MetaTemplate?: any }} */
		this.pict = this.fable; // for parity with pict providers / views

		this.serviceType = 'HeadlightDocumentService';
	}

	/**
	 * @return {HeadlightRestClient} the headlight client instance
	 */
	get HeadlightRestClient()
	{
		return this.fable.services.HeadlightRestClient;
	}

	/**
	 * Get the current document id from the URL or the DOM
	 *
	 * @return {string} The current document id
	 */
	get documentId()
	{
		if (!this._documentId)
		{
			let documentId = null;
			const currentDocIDElement = document.querySelector('#Data_IDDocument');
			if (currentDocIDElement)
			{
				documentId = currentDocIDElement.textContent.trim();
			}

			if (!documentId)
			{
				const params = new URLSearchParams(window.location.search);
				documentId = params.get('documentID') || params.get('IDDocument');
			}

			this._documentId = documentId;
		}

		return this._documentId;
	}

	/**
	 * Fetch the current document from the server
	 *
	 * @return {Promise<any>} The current document
	 */
	async fetchCurrentDocumentReportParameters()
	{
		if (this.pict.settings.IsHeadlightWebApplication)
		{
			// Headlight Document service skipping download Document entity record because this app has flagged itself as a web application
			return false;
		}
		const documentId = this.documentId;
		if (documentId)
		{
			if (Number.isNaN(documentId))
			{
				this.log.error(`Invalid document id ${documentId}`);
				return null;
			}
			const doc = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`Document/${documentId}/ReportParameters`, (err, body) =>
				{
					if (err)
					{
						return reject(err);
					}
					resolve(body);
				});
			});
			this.pict.PictApplication.AppData.DocumentData = doc;
			return doc;
		}
		else
		{
			this.log.error('Failed to fetch current document, no document id provided');
		}
	}

	/**
	 * The native document bridge this form persists through, or null when it persists to the server.
	 *
	 * On the iOS offline template the native layer owns the document row: the form writes to local
	 * storage and the device syncs the record up later. The record it writes is the same one the PUT
	 * would carry, so this is a transport choice and nothing above it needs to know which one ran.
	 *
	 * @return {?any} The bridge, or null.
	 */
	get localDocumentBridge()
	{
		if (typeof window === 'undefined')
		{
			return null;
		}
		/** @type {any} */
		const tmpWindow = window;
		const tmpBridge = tmpWindow._configurableFormDocumentBridge;
		if (!tmpWindow._OfflineMode || !tmpBridge || typeof tmpBridge.saveDocument !== 'function')
		{
			return null;
		}
		return tmpBridge;
	}

	/**
	 * Whether a save from this form lands locally rather than on the server.
	 *
	 * Load-bearing for `Document.EntityData`: the server applies the comprehension when the record
	 * reaches it, so anything that may only advance once the server has seen the payload has to ask
	 * this first.
	 *
	 * @return {boolean} True when the save is written to local storage.
	 */
	isLocalDocumentTransport()
	{
		return !!this.localDocumentBridge;
	}

	/**
	 * Build the document record a save writes, whichever transport carries it.
	 *
	 * @return {Record<string, any>} The record to persist.
	 */
	buildDocumentSaveRecord()
	{
		const tmpDocument = this.pict.PictApplication.AppData.DocumentData.ReportData;
		// spread the IDObservation list into a new array so we don't mutate the original collection
		const tmpObservations = Array.isArray(tmpDocument.Observations) ? tmpDocument.Observations : [];
		return {
			IDDocument: tmpDocument.IDDocument,
			IDProject: tmpDocument.IDProject,
			FormData: tmpDocument.FormData,
			EntityData: tmpDocument.EntityData,
			Observations: [ ...tmpObservations.map((obs) => obs.IDObservation) ],
		};
	}

	/**
	 * Do the document save (this is the same as clicking the save button in the UI).
	 *
	 * Resolves with the saved record the transport handed back, which the server decorates and the
	 * local bridge does not — callers must treat everything on it as optional.
	 *
	 * @return {Promise<any>}
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async saveDocument()
	{
		try
		{
			const tmpRecord = this.buildDocumentSaveRecord();
			const tmpLocalBridge = this.localDocumentBridge;
			if (tmpLocalBridge)
			{
				return await this._saveDocumentToLocalBridge(tmpLocalBridge, tmpRecord);
			}
			const response = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.putJSON(`Document/`, tmpRecord,
				(err, body) =>
				{
					if (err)
					{
						return reject(err);
					}
					resolve(body);
				});
			});
			return response;
		}
		catch (error)
		{
			this.log.error('Failed to save document', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Hand the document record to the native bridge and wait for it to be persisted.
	 *
	 * Rejects on a bridge failure so the save lifecycle reports it exactly as it reports a failed PUT;
	 * a write that did not land must not be reported as one that did.
	 *
	 * @param {any} pBridge - The native document bridge.
	 * @param {Record<string, any>} pRecord - The record to persist.
	 * @return {Promise<any>} Resolves with whatever the bridge returned.
	 */
	_saveDocumentToLocalBridge(pBridge, pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			try
			{
				pBridge.saveDocument(pRecord, (pError, pResult) =>
				{
					if (pError)
					{
						return reject((pError instanceof Error) ? pError : new Error(String(pError)));
					}
					return resolve(pResult);
				});
			}
			catch (pError)
			{
				return reject((pError instanceof Error) ? pError : new Error(String(pError)));
			}
		});
	}

	/**
	 * Downloads the document as a PDF file; if the document is not locked, then a refreshed PDF is generated
	 * @param {boolean} forceRender - If true, then a refreshed PDF is generated regardless of the document's locked state
	 * @param {object} [pReportData] - Optional alternative ReportData (if we want to download "not my current document" data)
	 * @param {function} [pCallback] - Optional callback when the download is complete
	 * @return {Promise<void>}
	 */
	async downloadDocument(forceRender = false, pReportData, pCallback)
	{
		const reportData = pReportData || this.pict.PictApplication.AppData.DocumentData.ReportData;
		let url = `/1.0/Document/${reportData.IDDocument}/DCR.pdf`;
		// if the document is not locked, then we need to regenerate a rerfeshed pdf
		if (forceRender || !reportData.Locked)
		{
			// fetch the GUIDReportDescription from the server to use in the url
			const response = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`Report/Render/${reportData.IDDocument}/pdf`, (err, body) =>
				{
					if (err)
					{
						reject(err);
					}
					else
					{
						resolve(body);
					}
				});
			});
			url = `/1.0/Report/${ response.GUIDReportDescription }/index.pdf`;
		}
		// format the metadata for the pdf file name
		const metaList = [
			reportData.DocumentType,
			this.fable.Dates.dayJS(reportData.DocumentDate).format('YYYY-MM-DD'),
		];
		// create a download link and click it to download the pdf
		const downloadLink = document.createElement('a');
		downloadLink.href = url;
		downloadLink.classList.add('is-hidden');
		// config option to optionally show the project name in the pdf download file name
		if (reportData.ReportOptions?.Meta?.ShowProjectNameInPDF)
		{
			metaList.push(reportData?.Project?.Name?.replace(/[^a-z0-9]/gi, '_'));
		}
		downloadLink.download = metaList.join('_') + '.pdf';
		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);

		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
	}

	/**
	 * Get the current document's approval state
	 * @return {Promise<any>} The approval state of the document
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async fetchApprovalState()
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.log.error('No document id found');
				return null;
			}
			const approvalResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`DocumentApproval/${docId}/State`, (err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.log.info('Approval state fetched', { approvalResults });
			return approvalResults;
		}
		catch (error)
		{
			this.log.error('Failed to get approval state', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Fetch the list of users that can approve the current document
	 * @return {Promise<any>} The list of users that can approve the document
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async fetchApprovalUsersList()
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.log.error('No document id found');
				return null;
			}
			const approvalUserListResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`DocumentApproval/${docId}/ApproverList`, (err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.log.info('Approval user list fetched', { approvalUserListResults });
			return approvalUserListResults;
		}
		catch (error)
		{
			this.log.error('Failed to get approval user list', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Fetch the approval history of the current document (logs of who approved/rejected the document and when)
	 * @return {Promise<any>} The approval history of the document
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async fetchApprovalHistory()
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.fable.log.error('No document id found');
				return null;
			}
			const approvalHistoryResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`DocumentApprovalLogs/By/IDDocument/${docId}`, (err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.fable.log.info('Approval history fetched', { approvalHistoryResults });
			return approvalHistoryResults;
		}
		catch (error)
		{
			this.fable.log.error('Failed to get approval history', error);
			throw error;
		}
	}

	/**
	 * Take an approval action on the current document (approve, reject, etc)
	 * @param {string} pAction The action to take on the document
	 * @return {Promise<any>} The results of the approval action
	 * @memberof HeadlightDocumentService
	 * @async
	 * @example
	 * await this.fable.services.HeadlightDocumentService.doApprovalAction('Approve');
	 * await this.fable.services.HeadlightDocumentService.doApprovalAction('Reject');
	 */
	async doApprovalAction(pAction)
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.fable.log.error('No document id found');
				return null;
			}
			const approvalResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.postJSON(`DocumentApproval`,
				{
					Action: pAction,
					IDDocument: docId,
				},
				(err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.fable.log.info('Approval action taken', { approvalResults });
			return approvalResults;
		}
		catch (error)
		{
			this.fable.log.error('Failed to take approval action', error);
			throw error;
		}
	}

	// TODO: Move this to a User provider? It doesn't belong here, but not sure where yet.
	/**
	 * Update the user's settings on the server.
	 *
	 * Impersonated sessions write somewhere else, and write less. `AppData.CurrentUser` is the
	 * *impersonated* user — including their Settings — so persisting it as-is would save a tester's
	 * preference onto the customer's record. Retargeting the write at the real user is not enough on
	 * its own either: sending CurrentUser.Settings to the real user would overwrite the real user's
	 * preferences with the impersonated user's. So an impersonated write goes to the real user
	 * (`ImpersonatingIDUser`, which stays pointed at the root user across chained impersonations) and
	 * carries only the keys that actually changed, merged onto that user's stored settings.
	 *
	 * Note the read side is unchanged: while impersonating, the panels still read the impersonated
	 * user's preferences, which is what makes "see what they see" work. A preference changed while
	 * impersonating therefore applies to the tester's own next session, not the current one.
	 *
	 * @param {Object} [pChangedSettings] - The settings that changed, e.g. `{ HeadlightPanels: { AutoSave: false } }`.
	 *   Required for impersonated sessions; without it there is no safe way to write.
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async updateUserSettings(pChangedSettings)
	{
		try
		{
			const user = this.pict.AppData.CurrentUser;
			if (!user)
			{
				this.log.warn('No current user; not updating user settings.');
				return;
			}
			if (user.Impersonation)
			{
				return await this._updateImpersonatingUserSettings(user, pChangedSettings);
			}
			this.pict.log.info('Updating user settings', { user });

			const userResults = await new Promise((resolve, reject) =>
			{
					this.HeadlightRestClient.putJSON(`User`,
					{
						IDUser: user.UserID,
						Settings: user.Settings,
					},
					(err, body) =>
					{
						if (err)
						{
							reject(err);
							return;
						}
						resolve(body);
					});
			});
				this.fable.log.info('User Settings updated', { userResults });
				return userResults;
		}
		catch (error)
		{
			this.log.error('Failed to update user settings', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Persist a settings change made during an impersonated session onto the real user's record.
	 *
	 * Refuses rather than guesses: with no changed-settings delta, or no real user to write to, the
	 * only options are to overwrite the real user's preferences with the impersonated user's or to
	 * write the tester's preference onto the customer's record. Skipping beats both.
	 *
	 * @param {any} pCurrentUser - The impersonated session user.
	 * @param {Object} [pChangedSettings] - The settings that changed.
	 * @return {Promise<any>}
	 */
	async _updateImpersonatingUserSettings(pCurrentUser, pChangedSettings)
	{
		const tmpRealIDUser = pCurrentUser.ImpersonatingIDUser;
		if (!tmpRealIDUser)
		{
			this.log.warn('Impersonated session carries no ImpersonatingIDUser; not saving the settings change to either user.');
			return;
		}
		if (!pChangedSettings || typeof pChangedSettings !== 'object')
		{
			this.log.warn(`Impersonated session changed a setting without saying which; not saving it to user ${tmpRealIDUser}.`);
			return;
		}
		const tmpRealUser = await new Promise((resolve) =>
		{
			this.HeadlightRestClient.getJSON(`User/${tmpRealIDUser}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Failed to load the impersonating user ${tmpRealIDUser} to save a settings change: ${pError.message || pError}`);
					return resolve(null);
				}
				return resolve(pBody);
			});
		});
		if (!tmpRealUser)
		{
			return;
		}
		let tmpRealSettings = tmpRealUser.Settings;
		if (!tmpRealSettings && tmpRealUser.SettingsJSON)
		{
			try
			{
				tmpRealSettings = JSON.parse(tmpRealUser.SettingsJSON);
			}
			catch (pParseError)
			{
				this.log.warn(`Could not parse settings for user ${tmpRealIDUser}; starting from an empty set.`);
			}
		}
		tmpRealSettings = tmpRealSettings || { };
		// Shallow per-namespace merge: the delta names a namespace (HeadlightPanels) and the keys within
		// it that changed, so the real user's other preferences in that namespace survive.
		for (const [ tmpNamespace, tmpValues ] of Object.entries(pChangedSettings))
		{
			if (tmpValues && typeof tmpValues === 'object' && !Array.isArray(tmpValues))
			{
				tmpRealSettings[tmpNamespace] = Object.assign({ }, tmpRealSettings[tmpNamespace], tmpValues);
			}
			else
			{
				tmpRealSettings[tmpNamespace] = tmpValues;
			}
		}
		this.log.info(`Impersonated session: saving the settings change to the real user ${tmpRealIDUser}, not the impersonated user ${pCurrentUser.UserID}.`, { ChangedSettings: pChangedSettings });
		return await new Promise((resolve, reject) =>
		{
			this.HeadlightRestClient.putJSON(`User`, { IDUser: tmpRealIDUser, Settings: tmpRealSettings }, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				return resolve(pBody);
			});
		});
	}
}

module.exports = HeadlightDocumentService;

},{"fable-serviceproviderbase":398}],23:[function(require,module,exports){
/**
 * Headlight-FormLoadTiming
 *
 * Phase 0 instrumentation for the form load latency work (the plan lives at
 * `docs/plans/form-load-latency-assessment.md`, §5 Phase 0). Drops a
 * `performance.mark()` at each of the five points that bound a form open and
 * emits one summary log line when the last one lands.
 *
 * The phases, in the order they are expected to arrive:
 *
 *	 - `Boot`			- the HeadlightConfigurableApplication constructor.
 *						  Bounds script parse + eval before the app exists.
 *	 - `SessionReady`	- `onBeforeLoginAsync` .finally(). Bounds the cached
 *						  session read or the CheckSession round trip.
 *	 - `DocumentLoaded` - `onLoadDataAsync` .then(). Bounds the
 *						  ReportParameters fetch plus the full user record.
 *	 - `FirstRender`	- `onAfterLoadDataAsync`, once the form sections
 *						  have rendered. Bounds the InitialBundle fetch, the
 *						  manifest bootstrap and the section render.
 *	 - `SpinnerRemoved` - the application's `removeLoadingSpinner()`. Bounds
 *						  whatever still covers the form after it is drawn.
 *
 * A mark's `startTime` is milliseconds since `performance.timeOrigin` - that
 * is, since navigation started - so `Boot` already carries the cost of
 * everything that ran before the application was constructed, and
 * `SpinnerRemoved` is the click-to-drawn number Phase 0 targets (p50 under 4 s
 * on QA for a 50-descriptor form).
 *
 * `SpinnerRemoved` is marked when `removeLoadingSpinner()` is CALLED, not when
 * the 200 ms fade finishes. The form underneath is already drawn at that
 * point; the fade is cosmetic, and excluding it keeps the number comparable
 * across apps that fade differently.
 *
 * This changes no behavior. Every entry point is guarded so a missing or
 * throwing `performance` API - node tests, jsdom, the offline template - is a
 * no-op, and each phase is recorded only once, so a re-login or a re-render
 * cannot overwrite the first-open numbers.
 *
 * Three ways to read the results:
 *
 *	 - the log line, prefixed `[FormLoad]` so it greps next to the existing
 *	   `[populateCanEditField]` timing lines;
 *	 - `window._HeadlightFormLoad`, for a harness or a console snippet;
 *	 - in DevTools, the marks and the span between each adjacent pair:
 *	   `performance.getEntriesByType('mark').filter((e) => e.name.startsWith('HeadlightFormLoad:'))`
 */

/** Prefix on every mark and measure name, so the entries filter cleanly out of the Performance timeline. */
const MARK_PREFIX = 'HeadlightFormLoad:';

/** The phases, in expected arrival order. The summary renders them in this order regardless of when they land. */
const PHASES = [ 'Boot', 'SessionReady', 'DocumentLoaded', 'FirstRender', 'SpinnerRemoved' ];

/**
 * Records the five form-load phases and emits the one-line summary.
 */
class HeadlightFormLoadTiming
{
	/**
	 * @param {Object} [pOptions] - Options.
	 * @param {any} [pOptions.Log] - A pict/fable logger. Optional; without one the summary is only on `window`.
	 * @param {any} [pOptions.Performance] - The `performance` object to use. Defaults to the global one. Injectable for tests.
	 * @param {String} [pOptions.Context] - A label for the log line (the application name, typically).
	 * @param {String} [pOptions.TerminalPhase] - The phase whose arrival emits the summary. Defaults to the last phase.
	 */
	constructor(pOptions)
	{
		const tmpOptions = pOptions || {};
		this.log = tmpOptions.Log || null;
		this.performance = tmpOptions.Performance || ((typeof globalThis !== 'undefined') ? globalThis.performance : null);
		this.Context = tmpOptions.Context || 'Form';
		this.TerminalPhase = tmpOptions.TerminalPhase || PHASES[PHASES.length - 1];

		/**
		 * Milliseconds since navigation start, per phase, in arrival order.
		 * @type {Object<String, Number>}
		 */
		this.Phases = {};
		this.SummaryEmitted = false;
		this._warnedPhases = {};
	}

	/**
	 * Whether the environment can be measured at all.
	 *
	 * @return {Boolean} True when a usable `performance` object is present.
	 */
	get enabled()
	{
		return !!(this.performance && (typeof this.performance.now === 'function'));
	}

	/**
	 * Record a phase. The first call for a phase wins; later calls are ignored.
	 *
	 * @param {String} pPhase - One of the PHASES names.
	 * @return {Boolean} True when this call recorded the phase.
	 */
	mark(pPhase)
	{
		if (!this.enabled || !pPhase)
		{
			return false;
		}
		if (PHASES.indexOf(pPhase) < 0)
		{
			// A typo in a call site would otherwise vanish silently. Warn once per name.
			if (this.log && !this._warnedPhases[pPhase])
			{
				this._warnedPhases[pPhase] = true;
				this.log.warn(`[FormLoad] ignoring unknown phase "${pPhase}"`);
			}
			return false;
		}
		if (pPhase in this.Phases)
		{
			return false;
		}

		try
		{
			const tmpName = MARK_PREFIX + pPhase;
			const tmpMark = this.performance.mark(tmpName);
			// performance.mark() returns the entry in current browsers; older ones return undefined.
			this.Phases[pPhase] = (tmpMark && (typeof tmpMark.startTime === 'number')) ?
				tmpMark.startTime :
				this._lookupMarkStartTime(tmpName);
			this._measureFromPreviousPhase(pPhase);
		}
		catch (pError)
		{
			// Instrumentation must never be able to break a form load.
			return false;
		}

		if (pPhase === this.TerminalPhase)
		{
			this.emitSummary();
		}
		return true;
	}

	/**
	 * Resolve a mark's start time when `performance.mark()` did not hand one back.
	 *
	 * @param {String} pName - The full mark name.
	 * @return {Number} Milliseconds since navigation start.
	 */
	_lookupMarkStartTime(pName)
	{
		if (typeof this.performance.getEntriesByName === 'function')
		{
			const tmpEntries = this.performance.getEntriesByName(pName, 'mark');
			if (tmpEntries && tmpEntries.length)
			{
				return tmpEntries[tmpEntries.length - 1].startTime;
			}
		}
		return this.performance.now();
	}

	/**
	 * Draw a measure from the most recently recorded earlier phase, so DevTools shows the span.
	 *
	 * @param {String} pPhase - The phase just recorded.
	 */
	_measureFromPreviousPhase(pPhase)
	{
		if (typeof this.performance.measure !== 'function')
		{
			return;
		}
		const tmpRecorded = PHASES.filter((pName) => (pName in this.Phases));
		const tmpIndex = tmpRecorded.indexOf(pPhase);
		if (tmpIndex < 1)
		{
			return;
		}
		const tmpPrevious = tmpRecorded[tmpIndex - 1];
		try
		{
			this.performance.measure(`${MARK_PREFIX}${tmpPrevious}->${pPhase}`, MARK_PREFIX + tmpPrevious, MARK_PREFIX + pPhase);
		}
		catch (pError)
		{
			// A measure is a convenience; losing it is not worth a thrown error.
		}
	}

	/**
	 * The numbers behind the summary line.
	 *
	 * @return {{ Context: String, Phases: Object<String, Number>, Deltas: Object<String, Number>, TotalMS: Number, Complete: Boolean }}
	 */
	summary()
	{
		const tmpPhases = {};
		const tmpDeltas = {};
		let tmpPrevious = 0;
		let tmpLast = 0;
		for (const tmpPhase of PHASES)
		{
			if (!(tmpPhase in this.Phases))
			{
				continue;
			}
			const tmpAt = Math.round(this.Phases[tmpPhase]);
			tmpPhases[tmpPhase] = tmpAt;
			tmpDeltas[tmpPhase] = tmpAt - tmpPrevious;
			tmpPrevious = tmpAt;
			tmpLast = tmpAt;
		}
		return {
			Context: this.Context,
			Phases: tmpPhases,
			Deltas: tmpDeltas,
			TotalMS: tmpLast,
			Complete: PHASES.every((pPhase) => (pPhase in this.Phases)),
		};
	}

	/**
	 * Render the one-line summary.
	 *
	 * @return {String} The log line.
	 */
	formatSummary()
	{
		const tmpSummary = this.summary();
		const tmpParts = PHASES.map((pPhase) =>
		{
			if (!(pPhase in tmpSummary.Phases))
			{
				return `${pPhase} -`;
			}
			return `${pPhase} +${tmpSummary.Deltas[pPhase]}ms`;
		});
		return `[FormLoad] ${tmpSummary.Context} total ${tmpSummary.TotalMS}ms (navigation to drawn) - ${tmpParts.join(' | ')}`;
	}

	/**
	 * Publish the summary: one log line, plus the numbers on `window` for a harness to scrape.
	 * Runs once per page; later calls are ignored.
	 *
	 * @return {Boolean} True when this call emitted the summary.
	 */
	emitSummary()
	{
		if (this.SummaryEmitted || !this.enabled)
		{
			return false;
		}
		this.SummaryEmitted = true;
		const tmpSummary = this.summary();
		try
		{
			if (typeof window !== 'undefined')
			{
				window._HeadlightFormLoad = tmpSummary;
			}
		}
		catch (pError)
		{
			// No window (node, a worker) - the log line is still worth emitting.
		}
		try
		{
			if (this.log && (typeof this.log.info === 'function'))
			{
				this.log.info(this.formatSummary());
			}
		}
		catch (pError)
		{
			// SpinnerRemoved marks ahead of the spinner teardown, so a logger that throws here would
			// otherwise leave the form sitting behind the loading overlay.
			return false;
		}
		return true;
	}
}

module.exports = HeadlightFormLoadTiming;
module.exports.PHASES = PHASES;
module.exports.MARK_PREFIX = MARK_PREFIX;

},{}],24:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/** @typedef {import('fable')} Fable */

/**
 * Headlight Hint Highlighting service.
 */
class HeadlightHintHighlighting extends libFableServiceProviderBase
{
	/**
	 * @param {Fable} pFable - The fable instance
	 * @param {any} pOptions - Options for this service
	 * @param {any} pServiceHash - The fable service hash for this instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { PictApplication?: any, AppData?: any, MetaTemplate?: any }} */
		this.pict = this.fable; // for parity with pict providers / views

		this.serviceType = 'HeadLightHintHighlighting';

		//FIXME: we should use the manifest tech for this, I think
		const pathEval = (path, record) => path
			.split(/[.[\]]/g)
			.reduce((p, c) => p && p[c],
			{
				Record: record,
				AppData: this.pict.AppData,
			});

		// create a label for the hint forumla
		this.pict.MetaTemplate.addPattern('{~HintLabel:', '~}', (pHash, pData, pContext) =>
		{
			const record = pathEval(pHash, pData);
			// NOTE: this is to support the old way until we migrate everything to the new way
			const hint = record?.PictForm?.Hint || record?.PictForm?.Formula || record?.hint;
			let hintConnections = record?.hintConnections;
			// parse the formula for the hint connections (non-numeric values are hint connections)
			if (!hintConnections && record?.PictForm?.Formula)
			{
				const formula = record.PictForm.Formula;
				const formulaArray = formula.split(/[\s\+\-\*\/\(\)]/);
				hintConnections = formulaArray.filter((value) => isNaN(value) && value !== '');
			}
			let template = ``;
			if (hint)
			{
				template =
				`<span class="hint-label is-pulled-right" data-hint-connections="${hintConnections}" onclick="this.pict.services.HeadlightHintHighlighting.toggleHintConnections(event)">
					<span class="icon"><i class="fas"></i></span>
					<span>${hint}</span>
				</span>`;
			}
			return template;
		});

		// create an ordinal tag for hint indentification
		this.pict.MetaTemplate.addPattern('{~HintOrdinal:', '~}', (pHash, pData, pContext) =>
		{
			const record = pathEval(pHash, pData);
			// NOTE: this is to support the old way until we migrate everything to the new way
			const ordinal = record?.PictForm?.Ordinal || record?.ordinal;
			return ordinal ? `<span class="hint-ordinal tag">${ordinal}</span>` : '';
		});

		// create a connection tag for hint connections
		this.pict.MetaTemplate.addPattern('{~HintConnection:', '~}', (pHash, pData, pContext) =>
		{
			const data = pathEval(pHash, pData);
			let template = ``;
			if (data)
			{
				template = `data-hint-connection="${data}"`;
			}
			return template;
		});
	}

	/**
	 * Find the parent element of an element that matches a selector
	 * @param {EventTarget} target - the element to start from
	 * @param {string} selector - the selector to match
	 * @return {Element[]} - an array of parent elements that match the selector
	 * @example
	 * const parents = this.findParents(el, '.parent-class');
	 * // parents = [HTMLElement, HTMLElement, HTMLElement]
	**/
	parents(target, selector)
	{
		if (!(target instanceof Element))
		{
			return [];
		}
		/** @type {Element} */
		let el = target;
		const parents = [];
		while (el.parentNode instanceof Element && (el = el.parentNode))
		{
			if (!selector || el.matches(selector))
			{
				parents.push(el);
			}
		}
		return parents;
	}

	/**
	 * This handles the highlighting of hint connections on the UI.
	 * If a hint connection is clicked, it will highlight the connection and the origin row to show the relationship
	 * @param {Event} event
	 * @memberof Application
	 *
	**/
	toggleHintConnections(event)
	{
		// remove rows that are currently active
		document.querySelectorAll('.hint-highlight-connection').forEach((hint) =>
		{
			hint.classList.remove('hint-highlight-connection');
		});
		// toggle active class on the hint connection
		if (this.parents(event.currentTarget, '.hint-highlight-origin').length)
		{
			this.parents(event.currentTarget, '.hint-highlight-origin')[0].classList.remove('hint-highlight-origin');
			return;
		}
		// turn off all other hint connections labels
		document.querySelectorAll('.hint-highlight-origin').forEach((hint) =>
		{
			hint.classList.remove('hint-highlight-origin');
		});
		// turn on the active class for this hint connection
		if (this.parents(event.currentTarget, '[data-hint-connection]').length)
		{
			this.parents(event.currentTarget, '[data-hint-connection]')[0].classList.add('hint-highlight-origin');
		}
		// for each row that has a hint connection, add the active class
		const connectionsList = event.currentTarget instanceof Element && event.currentTarget.getAttribute('data-hint-connections').split(',');
		if (connectionsList && connectionsList.length)
		{
			connectionsList.forEach((connection) =>
			{
				// NOTE: need to handle non-unqiue connections/ordinals (this only hightlights the first one found)
				document.querySelector(`[data-hint-connection="${connection}"]`)?.classList?.add('hint-highlight-connection');
			});
		}
	}
}

module.exports = HeadlightHintHighlighting;

},{"fable-serviceproviderbase":398}],25:[function(require,module,exports){
/**
 * ManifestConditionEvaluator
 *
 * Thin wrapper around `fable.ExpressionParser` that lets a form manifest gate
 * top-level lifecycle steps with a solver expression. Used by the base dynamic
 * form to decide whether to:
 *
 *   - skip the `InitialBundle` data fetch  (`shouldSkipInitialBundle`)
 *   - skip the post-load `solve()` pass    (`shouldSkipSolveOnLoad`)
 *
 * The expressions are the same Fable solver language the manifest's section
 * `Solvers: [...]` arrays already use, so form authors only have to know one
 * language. See `/Pavia/retold/modules/fable/fable/source/services/Fable-Service-ExpressionParser.js`
 * for the parser; `solve(expression, dataSource, results, manifest)` is the
 * public entry point.
 *
 * Two manifest shapes are honored per gating step:
 *
 *   - **Sugar:** `SkipInitialBundleWhenLocked: true` / `SkipSolveWhenLocked: true`
 *     Shorthand for "skip when the document is locked." Internally resolves to
 *     a `WHEN(AppData.DocumentData.ReportData.Locked, 1, 0)` expression so
 *     truthy-Locked returns truthy, falsy-Locked / missing-Locked returns 0.
 *     The solve sugar defaults to **true** (omitting `SkipSolveWhenLocked`
 *     skips solve on locked loads); the bundle sugar defaults to false.
 *
 *   - **General:** `SkipInitialBundleWhen: "<expression>"` / `SkipSolveWhen: "<expression>"`
 *     Any Fable solver expression. Evaluated against the supplied scope object
 *     (typically `{ AppData: ... }`). Truthy result → skip.
 *
 * When both are present, OR semantics apply — either matching is enough.
 *
 * Failure modes are fail-safe — a missing parser, a malformed expression, or a
 * thrown error during evaluation all resolve to "do not skip." We never skip
 * caller work unless the manifest is unambiguously correct and the expression
 * evaluates truthy.
 *
 * NB: The Fable solver returns numeric results as strings (`"1"` / `"0"`), so
 * the `_isTruthy` helper coerces strings: `"0"` and `""` are falsy, anything
 * else non-empty is truthy.
 */

const LOCKED_ADDRESS = 'AppData.DocumentData.ReportData.Locked';
const LOCKED_SUGAR_EXPRESSION = `WHEN(${LOCKED_ADDRESS}, 1, 0)`;

/**
 * Resolve `AppData.DocumentData.ReportData.Locked` from the scope using native
 * JavaScript truthiness — `0`, `"0"`, `false`, `null`, `undefined`, `""`, `NaN`
 * are all falsy.
 *
 * The sugar form (`SkipInitialBundleWhenLocked: true` / `SkipSolveWhenLocked: true`)
 * intentionally bypasses Fable's `WHEN(...)` for the resolution: Fable's
 * `Logic.when` checks truthiness with `!pValue`, which evaluates the *string*
 * `"0"` as truthy because non-empty strings are JS-truthy. The expression
 * parser stringifies numeric address values before passing them to `Logic.when`,
 * so a numeric `0` from the database (the common case for a draft document's
 * `Locked` TINYINT) was being mis-classified as "locked" and the InitialBundle
 * was being skipped on draft loads. See the test suite's "treats numeric 0 as
 * unlocked" case for the regression guard.
 *
 * @param {Object} pScope - The runtime scope (typically `{ AppData: ... }`).
 * @returns {boolean} `true` when the document is meaningfully locked.
 */
function _resolveLockedTruthy(pScope)
{
	const tmpLocked = pScope?.AppData?.DocumentData?.ReportData?.Locked;
	// Defensively treat the literal string "0" as falsy in addition to native
	// JS-falsy values. A TINYINT `Locked` column normally arrives as numeric 0/1,
	// but some serialization paths (older Meadow versions, JSON-stringified
	// snapshots) can deliver it as the string "0" / "1" — and `Boolean("0")` is
	// `true` in JS, which would re-introduce the same Locked=0 misclassification
	// we're fixing here.
	if (tmpLocked === '0')
	{
		return false;
	}
	return Boolean(tmpLocked);
}

/**
 * Coerce the parser's string-typed numeric output (or any other return shape)
 * to a boolean. Treats `"0"`, `""`, `null`, `undefined`, `false`, `NaN` as
 * falsy; anything else truthy.
 *
 * @param {*} pValue
 * @returns {boolean}
 */
function _isTruthy(pValue)
{
	if (pValue === null || pValue === undefined || pValue === false)
	{
		return false;
	}
	if (typeof pValue === 'number')
	{
		return pValue !== 0 && !Number.isNaN(pValue);
	}
	if (typeof pValue === 'string')
	{
		return pValue.length > 0 && pValue !== '0';
	}
	return Boolean(pValue);
}

/**
 * Evaluate a single Fable solver expression against the supplied scope.
 *
 * @param {string | null | undefined} pExpression - The solver expression to evaluate.
 * @param {Object} pScope - Data source object the parser dereferences against
 *   (typically `{ AppData: <runtime AppData> }`).
 * @param {*} pFable - The Fable instance, used to reach `ExpressionParser`.
 *   Optional — when absent the function fails closed (returns false).
 * @returns {boolean} `true` when the expression evaluates truthy.
 */
function evaluateExpression(pExpression, pScope, pFable)
{
	if (typeof pExpression !== 'string' || pExpression.length === 0)
	{
		return false;
	}
	if (!pFable)
	{
		return false;
	}
	let tmpParser = pFable.ExpressionParser;
	if (!tmpParser && typeof pFable.instantiateServiceProviderIfNotExists === 'function')
	{
		try
		{
			pFable.instantiateServiceProviderIfNotExists('ExpressionParser');
			tmpParser = pFable.ExpressionParser;
		}
		catch (pError)
		{
			return false;
		}
	}
	if (!tmpParser || typeof tmpParser.solve !== 'function')
	{
		return false;
	}
	try
	{
		const tmpResult = tmpParser.solve(pExpression, pScope || {}, {});
		return _isTruthy(tmpResult);
	}
	catch (pError)
	{
		if (pFable.log && typeof pFable.log.warn === 'function')
		{
			pFable.log.warn(`ManifestConditionEvaluator: expression failed to evaluate (${pError && pError.message ? pError.message : pError}). Expression: ${pExpression}`);
		}
		return false;
	}
}

/**
 * Decide whether to skip the InitialBundle fetch for the current load.
 *
 * Honors two manifest-level keys:
 *   - `SkipInitialBundleWhenLocked: true` — sugar; resolves to a Locked check.
 *   - `SkipInitialBundleWhen: "<expression>"` — general Fable solver expression.
 *
 * OR semantics across both — either truthy → skip.
 *
 * @param {Object | null | undefined} pManifest
 * @param {Object} pScope - The runtime scope (typically `{ AppData: ... }`).
 * @param {*} pFable - The Fable instance carrying ExpressionParser.
 * @returns {boolean}
 */
function shouldSkipInitialBundle(pManifest, pScope, pFable)
{
	if (!pManifest)
	{
		return false;
	}
	if (pManifest.SkipInitialBundleWhenLocked === true && _resolveLockedTruthy(pScope))
	{
		return true;
	}
	if (typeof pManifest.SkipInitialBundleWhen === 'string' && pManifest.SkipInitialBundleWhen.length > 0)
	{
		return evaluateExpression(pManifest.SkipInitialBundleWhen, pScope, pFable);
	}
	return false;
}

/**
 * Decide whether to skip the post-data-load `solve()` pass for the current
 * load. Used by snapshot forms that must not have stored values overwritten by
 * re-running the manifest's solver expressions on a Locked re-open.
 *
 * Honors two manifest-level keys:
 *   - `SkipSolveWhenLocked` — sugar; resolves to a Locked check. **Defaults to
 *     true**: a locked load skips solve unless the manifest explicitly sets
 *     `SkipSolveWhenLocked: false` (persisted solver outputs are part of the
 *     locked snapshot; re-deriving them from current state is the exception,
 *     not the rule).
 *   - `SkipSolveWhen: "<expression>"` — general Fable solver expression.
 *
 * OR semantics across both.
 *
 * @param {Object | null | undefined} pManifest
 * @param {Object} pScope
 * @param {*} pFable
 * @returns {boolean}
 */
function shouldSkipSolveOnLoad(pManifest, pScope, pFable)
{
	if (!pManifest)
	{
		return false;
	}
	if (pManifest.SkipSolveWhenLocked !== false && _resolveLockedTruthy(pScope))
	{
		return true;
	}
	if (typeof pManifest.SkipSolveWhen === 'string' && pManifest.SkipSolveWhen.length > 0)
	{
		return evaluateExpression(pManifest.SkipSolveWhen, pScope, pFable);
	}
	return false;
}

module.exports = {
	evaluateExpression,
	shouldSkipInitialBundle,
	shouldSkipSolveOnLoad,
	LOCKED_ADDRESS,
	LOCKED_SUGAR_EXPRESSION,
};

},{}],26:[function(require,module,exports){

/** @type{Record<string, typeof import('pict-provider')>} */
const providers = {};
providers.BridgeDisplay = require('./providers/PictProvider-InputType-BridgeDisplay.js');
providers.BridgeSelector = require('./providers/PictProvider-InputType-BridgeSelector.js');
providers['Bulma-HTML'] = require('./providers/PictProvider-Bulma-HTML.js');
providers['Bulma-Markdown'] = require('./providers/PictProvider-Bulma-Markdown.js');
// InputType MarkdownDisplay: the value-bound sibling of Markdown, for a remark a user typed.
providers['Bulma-MarkdownDisplay'] = require('./providers/PictProvider-Bulma-MarkdownDisplay.js');
providers['Bulma-MaterialsQRCodeDisplay'] = require('./providers/PictProvider-Bulma-MaterialsQRCodeDisplay.js');
providers['Bulma-TableControls'] = require('./providers/PictProvider-Bulma-TableControls.js');
providers['Bulma-RecordSetControls'] = require('./providers/PictProvider-Bulma-RecordSetControls.js');
providers.DataTypeDatePicker = require('./providers/PictProvider-DataType-DatePicker.js');
providers.DataTypeDateTimePicker = require('./providers/PictProvider-DataType-DateTimePicker.js');
providers.DataTypeTimePicker = require('./providers/PictProvider-DataType-TimePicker.js');
providers.DatePickerProvider = require('./providers/PictProvider-DataType-DatePicker.js');
providers.DateTimePickerProvider = require('./providers/PictProvider-DataType-DateTimePicker.js');
providers.DraggableUtil = require('./providers/PictProvider-DraggableUtil.js');
providers.EmailAddressProvider = require('./providers/PictProvider-InputType-EmailAddress.js');
providers.EntityBundleClient = require('./providers/PictProvider-EntityBundleClient.js');
providers.FlatpickrUtilProvider = require('./providers/PictProvider-FlatpickrUtil.js');
providers.InputValidation = require('./providers/PictProvider-InputValidation.js');
providers.ChipTooltips = require('./providers/PictProvider-ChipTooltips.js');
providers.NumberScrollLock = require('./providers/PictProvider-NumberScrollLock.js');
providers.LabDisplay = require('./providers/PictProvider-InputType-LabDisplay.js');
providers.LabSelector = require('./providers/PictProvider-InputType-LabSelector.js');
providers.SampleTypeSelector = require('./providers/PictProvider-InputType-SampleTypeSelector.js');
providers.LineItemDisplay = require('./providers/PictProvider-InputType-LineItemDisplay.js');
providers.LineItemSelector = require('./providers/PictProvider-InputType-LineItemSelector.js');
providers.GeolocationSelector = require('./providers/PictProvider-InputType-GeolocationSelector.js');
providers.MaterialDisplay = require('./providers/PictProvider-InputType-MaterialDisplay.js');
providers.MaterialSelector = require('./providers/PictProvider-InputType-MaterialSelector.js');
providers.MixSpecificationDisplay = require('./providers/PictProvider-InputType-MixSpecificationDisplay.js');
providers.MixSpecificationSelector = require('./providers/PictProvider-InputType-MixSpecificationSelector.js');
providers.ObservationCardDeckProvider = require('./providers/PictProvider-InputType-ObservationCardDeck.js');
providers.ObservationTypeDisplay = require('./providers/PictProvider-InputType-ObservationTypeDisplay.js');
providers.ObservationTypeSelector = require('./providers/PictProvider-InputType-ObservationTypeSelector.js');
providers.PhoneNumberProvider = require('./providers/PictProvider-InputType-PhoneNumber.js');
providers.PhysicalAssetSelector = require('./providers/PictProvider-InputType-PhysicalAssetSelector.js');
providers.PlantDisplay = require('./providers/PictProvider-InputType-PlantDisplay.js');
providers.PlantSelector = require('./providers/PictProvider-InputType-PlantSelector.js');
providers.FileSelector = require('./providers/PictProvider-InputType-FileSelector.js');
providers.PrecompiledFileSelector = require('./providers/PictProvider-InputType-PrecompiledFileSelector.js');
providers.ProducerDisplay = require('./providers/PictProvider-InputType-ProducerDisplay.js');
providers.ProducerSelector = require('./providers/PictProvider-InputType-ProducerSelector.js');
providers.ProductDisplay = require('./providers/PictProvider-InputType-ProductDisplay.js');
providers.ProductSelector = require('./providers/PictProvider-InputType-ProductSelector.js');
providers.EntityDisplay = require('./providers/PictProvider-InputType-EntityDisplay.js');
providers.EntitySelector = require('./providers/PictProvider-InputType-EntitySelector.js');
providers.EntityDisplayMultiple = require('./providers/PictProvider-InputType-EntityDisplayMultiple.js');
providers.EntitySelectorMultiple = require('./providers/PictProvider-InputType-EntitySelectorMultiple.js');
// pict-section-picker: the widget provider + the select2-free 'Picker' InputType (a Headlight subclass
// of the module's form-input adapter that adds project + spec-year scoping). Replaces EntitySelectorMultiple.
providers['Pict-Section-Picker'] = require('pict-section-picker');
providers.Picker = require('./providers/PictProvider-InputType-Picker.js');
// Unified test acceptance — the Picker-stack replacement for the legacy SampleTestResult select, plus
// the disclosure that shows its sibling RichText remarks field.
providers.SampleTestAcceptance = require('./providers/PictProvider-InputType-SampleTestAcceptance.js');
// Complex-editor InputTypes from pict-section-form. PSF exports these provider classes but does NOT
// auto-register them (their heavy editor deps are opt-in), so the bundle registers them here under the
// exact hashes the templates' DefaultInputExtensions reference. Each is a Headlight subclass adding the
// inline View/Edit presentation behavior.
// @ts-ignore - subclasses of an external provider class, same shape the Picker registration above has
providers['Pict-Input-Diagram'] = require('./providers/PictProvider-InputType-Diagram.js');
// @ts-ignore
providers['Pict-Input-RichText'] = require('./providers/PictProvider-InputType-RichText.js');
// PickerDisplay: the non-interactive Read/Print display for 'Picker' (resolves value -> label / entity name).
providers.PickerDisplay = require('./providers/PictProvider-InputType-PickerDisplay.js');
// The MaterialsEntitySelector cascade ports, each named by its wave's port-forward template. Each @ts-ignore
// below suppresses the same pict-provider static-identity mismatch the 'Picker' registration above carries.
// @ts-ignore — wave 5: SampleType cascade
providers.SampleTypePicker = require('./providers/PictProvider-InputType-SampleTypePicker.js');
// @ts-ignore — shared cascade base (waves 6-9)
providers.MaterialsCascadePicker = require('./providers/PictProvider-InputType-MaterialsCascadePicker.js');
// @ts-ignore — wave 6: Sample hub
providers.MaterialsSamplePicker = require('./providers/PictProvider-InputType-MaterialsSamplePicker.js');
// @ts-ignore — wave 7: Test driver (save-projection)
providers.MaterialsTestPicker = require('./providers/PictProvider-InputType-MaterialsTestPicker.js');
// @ts-ignore — wave 8: Lab join
providers.MaterialsLabPicker = require('./providers/PictProvider-InputType-MaterialsLabPicker.js');
// @ts-ignore — wave 8: LineItem join
providers.MaterialsLineItemPicker = require('./providers/PictProvider-InputType-MaterialsLineItemPicker.js');
// @ts-ignore — wave 8: Test-Lab join
providers.MaterialsTestLabPicker = require('./providers/PictProvider-InputType-MaterialsTestLabPicker.js');
// @ts-ignore — wave 9: Test injector (__Record opt-out)
providers.MaterialsTestInjectorPicker = require('./providers/PictProvider-InputType-MaterialsTestInjectorPicker.js');
// @ts-ignore — wave 10: the base MaterialsEntitySelector (descriptor-named Entity)
providers.MaterialsEntityPicker = require('./providers/PictProvider-InputType-MaterialsEntityPicker.js');
// @ts-ignore — SampleStatus vocabulary port (managed code list + the test-result status derivation)
providers.SampleStatusPicker = require('./providers/PictProvider-InputType-SampleStatusPicker.js');
// wave 9: Sample Read/Print display (PickerDisplay + QR-image prepend)
providers.MaterialsSamplePickerDisplay = require('./providers/PictProvider-InputType-MaterialsSamplePickerDisplay.js');
providers.MaterialsEntitySelector = require('./providers/PictProvider-InputType-MaterialsEntitySelector.js');
providers.MaterialsEntityDisplay = require('./providers/PictProvider-InputType-MaterialsEntityDisplay.js');
providers.MaterialsSampleSelector = require('./providers/PictProvider-InputType-MaterialsSampleSelector.js');
providers.MaterialsSampleDisplay = require('./providers/PictProvider-InputType-MaterialsSampleDisplay.js');
providers.MaterialsTestInjector = require('./providers/PictProvider-InputType-MaterialsTestInjector.js');
providers.MaterialsTestSectionRemover = require('./providers/PictProvider-InputType-MaterialsTestSectionRemover.js');
providers.MaterialsTestSelector = require('./providers/PictProvider-InputType-MaterialsTestSelector.js');
providers.MaterialsTestDisplay = require('./providers/PictProvider-InputType-MaterialsTestDisplay.js');
providers.MaterialsLineItemSelector = require('./providers/PictProvider-InputType-MaterialsLineItemSelector.js');
providers.MaterialsLabSelector = require('./providers/PictProvider-InputType-MaterialsLabSelector.js');
providers.MaterialsTestLabSelector = require('./providers/PictProvider-InputType-MaterialsTestLabSelector.js');
providers.MaterialsPlantSelector = require('./providers/PictProvider-InputType-MaterialsPlantSelector.js');
providers.MaterialsLabDisplay = require('./providers/PictProvider-InputType-MaterialsLabDisplay.js');
providers.MaterialsLineItemDisplay = require('./providers/PictProvider-InputType-MaterialsLineItemDisplay.js');
providers.SampleStatusSelector = require('./providers/PictProvider-InputType-SampleStatusSelector.js');
providers.SampleTestResult = require('./providers/PictProvider-InputType-SampleTestResult.js');
providers.ProjectDisplay = require('./providers/PictProvider-InputType-ProjectDisplay.js');
providers.ProjectSelector = require('./providers/PictProvider-InputType-ProjectSelector.js');
providers.QRCode = require('./providers/PictProvider-QRCode.js');
providers.ResponsiveUIAdjustmentProvider = require('./providers/PictProvider-ResponsiveUIAdjustment.js');
providers.SampleDisplay = require('./providers/PictProvider-InputType-SampleDisplay.js');
providers.SampleSelector = require('./providers/PictProvider-InputType-SampleSelector.js');
// EntityFilterEngine: the Headlight filter-composition engine extracted from Select2Util (which now
// extends it). Registered on its own so the pict-section-picker 'Picker' broker can call it directly.
providers.EntityFilterEngine = require('./providers/PictProvider-EntityFilterEngine.js');
providers.Select2Util = require('./providers/PictProvider-Select2Util.js');
providers.SpecScopeResolver = require('./providers/PictProvider-SpecScopeResolver.js');
providers.ThroughScopeResolver = require('./providers/PictProvider-ThroughScopeResolver.js');
providers.LabScopeResolver = require('./providers/PictProvider-LabScopeResolver.js');
providers.Station = require('./providers/PictProvider-InputType-Station.js');
providers.TimePickerProvider = require('./providers/PictProvider-DataType-TimePicker.js');
providers.MediaRegistry = require('./providers/PictProvider-MediaRegistry.js');
// MediaDetailCards provider removed — InputType now routes through ObservationCardDeckProvider via template redirect and patchedConfiguration.
providers.SignatureProvider = require('./providers/PictProvider-InputType-Signature.js');
providers.TextAreaProvider = require('./providers/PictProvider-InputType-TextArea.js');
providers.DistillingBundleManager = require('./providers/Pict-Provider-DistillingBundleManager.js');
providers.DistilledInput = require('./providers/Pict-Provider-Input-DistilledInput.js');
providers.DataRequirementsProvider = require('./providers/PictProvider-DataRequirements.js');
// NOTE: We have to 'override' the default Select provider to make trigger groups work since it's hardcoded to `Pict-Input-Select` in the trigger logic
providers['Pict-Input-Select'] = require('./providers/PictProvider-InputType-Select.js');
// Tier-2.5 a11y: Read/Print-theme static-display painter for the Color input, whose locked
// state can't use the `readonly` attribute. Paints a swatch + hex into the display node;
// no-op when that node is absent (Edit theme).
providers['Pict-Input-Color'] = require('./providers/PictProvider-InputType-Color.js');
providers['Pict-Input-TabGroupSelector'] = require('./providers/PictProvider-InputType-TabGroupSelector.js');
providers['Pict-Input-TabSectionSelector'] = require('./providers/PictProvider-InputType-TabSectionSelector.js');

/**
 * @typedef {Object} ThemeProvider
 * @property {String} TemplatePrefix - The template prefix for the theme.
 * @property {Array<Object>} Templates - The templates for the theme.
 * TODO: this is probably incomplete, and definitely not living in the right place; move this eventually
 */

/** @type {Record<string, ThemeProvider>} */
const themes = { };
themes.Base = require('./themes/PictProvider-Theme-Base.js');
themes.Edit = require('./themes/PictProvider-Theme-Edit.js');
themes.Read = require('./themes/PictProvider-Theme-Read.js');
themes.Print = require('./themes/PictProvider-Theme-Print.js');
// Body markup for the Geolocation input types, assembled per presentation by {~GeolocationBody:~}.
const libGeolocationBodies = require('./templates/GeolocationBodies.js');
// Body markup for the Diagram / RichText editor input types, assembled per presentation by {~EditorBody:~}.
const libEditorBodies = require('./templates/EditorBodies.js');
// Target/rel attribute resolution for the Link input type, emitted per anchor by {~LinkTarget:~}.
const libLinkTarget = require('./providers/PictProvider-Template-LinkTarget.js');

const libFilterToggleUI = require('./providers/_FilterToggleUI.js');
/** @type {Record<string, typeof import('pict-view')>} */
const views = {};
views.FormHeader = require('./views/PictView-FormHeader.js');
// @ts-ignore
views.GeolocationSelector = require('./views/PictView-GeolocationSelector.js');

// inject all the templates for the themed views
const themedTemplatesList = require('./templates/_index.js');
for (const template of themedTemplatesList)
{
	for (const [ themeKey, themeTemplate ] of Object.entries(template))
	{
		if (!themes[themeKey])
		{
			themes[themeKey] = {
				TemplatePrefix: 'PictProvider-Theme-' + themeKey,
				Templates: [],
			};
		}
		themes[themeKey].Templates.push(...themeTemplate);
	}
}

class HeadlightDynamicInputsBundle
{
	static getProviderMap()
	{
		return providers;
	}

	static getViewMap()
	{
		return views;
	}

	static getThemeMap()
	{
		return themes;
	}

	/**
	 * @param {import('pict')} pict
	 */
	constructor(pict)
	{
		this.pict = pict;
	}

	attach(providerOptionsMap = { }, viewOptionsMap = { })
	{
		this.attachProviders(providerOptionsMap);
		this.attachInstructions();
		this.attachViews(viewOptionsMap);
		this.injectThemes();
	}

	attachProviders(providerOptionsMap = { })
	{
		for (const [ key, provider ] of Object.entries(providers))
		{
			let tmpOptions = providerOptionsMap[key] || { };
			// One dropdown open at a time (select2 parity), fleet-wide; an app-supplied option still wins.
			if (key === 'Pict-Section-Picker' && !('SingleActivePicker' in tmpOptions))
			{
				tmpOptions = Object.assign({ SingleActivePicker: true }, tmpOptions);
			}
			this.pict.addProvider(key, tmpOptions, provider);
		}
	}

	attachViews(viewOptionsMap = { })
	{
		for (const [ key, view ] of Object.entries(views))
		{
			this.pict.addView(key, viewOptionsMap[key] || { }, view);
		}
	}

	injectThemes()
	{
		for (const templateSet of Object.values(themes))
		{
			this.pict.providers.PictFormSectionDefaultTemplateProvider.injectTemplateSet(templateSet);
		}
	}

	attachInstructions()
	{
		// create a label, but also account for extra inline tags, if they exist
		// NOTE: We do this here so that the "label" and any extra tags are all in same
		//	    flex container, so that they can be balanced properly
		this.pict.MetaTemplate.addPattern('{~LabelWithChips:', '~}', (pHash, pData) =>
		{
			// we need to first build the actual label content
			const labelContentTag = `<span${pData.PictForm.Required ? ' class="is-required"' : ''}>${pData.Name}</span>`;
			// if no data or chips, return the label string value
			if (!pData?.PictForm?.Chips) return labelContentTag;
			// if there are chips, build them
			const chips = {};
			// ignore the "Units" chip, as it's handled separately
			// TODO: Remove the script that puts "Units" in the chips object once we're sure it's not needed anymore
			for (const chipKey in pData.PictForm.Chips)
			{
				if (chipKey != 'Units')
				{
					chips[chipKey] = pData.PictForm.Chips[chipKey];
				}
			}
			// here's are basic chip map of known chips (icon, color)
			const chipMap = {
				'ExternalDatabaseID': {
					'icon': 'fa-database',
					'color': 'is-info',
				},
				'New': {
					'icon': 'fa-sparkles',
					'color': 'is-warning',
				},
			};
			// Escape a value for safe use in both an HTML attribute (double-quoted)
			// and an element text node. The chip value/id come from server data.
			const fEscape = (pStr) => String(pStr == null ? '' : pStr)
				.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			let template = `<span class="chips">`;
			// todo: implement switch for TabularLabel if other tabular labels are needed
			// check hash for TabularLabel and add the appropriate template
			if (!pHash.includes('TabularLabel'))
			{
				template += `${ labelContentTag }`;
			}
			// Emit each chip as a self-contained, reflow-free anchor. The chip's
			// text lives in `.chip-label` (hidden on screen, revealed only in the
			// Print theme) and is mirrored in `data-chip-label` so the runtime
			// PictProvider-ChipTooltips can wire a pinnable tooltip to the anchor
			// without re-reading the DOM. No inline onclick / is-active here — the
			// provider owns hover + click-to-pin behavior and pin persistence.
			// eslint-disable-next-line guard-for-in
			for (const chipKey in chips)
			{
				const chipObject = {};
				// if it's a custom object, use it
				if (typeof pData.PictForm.Chips[chipKey] == 'object')
				{
					chipObject._id = chipKey;
					chipObject._value = pData.PictForm.Chips[chipKey].Value || pData.PictForm.Chips[chipKey].value || chipKey;
					// set the passed values, or use the map, or use the defaults
					chipObject.icon = pData.PictForm.Chips[chipKey].Icon || pData.PictForm.Chips[chipKey].icon || chipMap?.[chipKey]?.icon || 'fa-info';
					chipObject.color = pData.PictForm.Chips[chipKey].Color || pData.PictForm.Chips[chipKey].color || chipMap?.[chipKey]?.color || 'is-text';
				}
				else if (typeof pData.PictForm.Chips[chipKey] == 'string')
				{
					chipObject._id = chipKey;
					chipObject._value = pData.PictForm.Chips[chipKey];
					// check if it's in the chipMap and if so, use the icon and color (or defaults)
					chipObject.icon = chipMap?.[chipKey]?.icon || 'fa-info';
					chipObject.color = chipMap?.[chipKey]?.color || 'is-text';
				}
				else
				{
					// if it's not a string or object, we don't know what's going on, so skip it
					continue;
				}
				const tmpId = fEscape(chipObject._id);
				const tmpValue = fEscape(chipObject._value);
				const tmpIcon = fEscape(chipObject.icon);
				const tmpColor = fEscape(chipObject.color || '');
				template +=
				`<button type="button" class="chip ${tmpColor}"
					data-chip-for="${tmpId}"
					data-chip-label="${tmpValue}"
					data-chip-icon="${tmpIcon}"
					data-chip-color="${tmpColor}"
					aria-label="${tmpId}: ${tmpValue}">
					<span class="icon">
						<i class="fa fa-fw ${tmpIcon}"></i>
					</span>
					<span class="chip-label">${tmpValue}</span>
				</button>`;
			}
			// close the chips span
			template += '</span>';
			// check hash for TabularLabel and add the appropriate template
			if (pHash.includes('TabularLabel'))
			{
				template += `<span class="label">${ labelContentTag }</span>`;
			}
			return template;
		});

		// Start the runtime chip-tooltip wiring (idempotent). attachProviders()
		// runs before attachInstructions() in every host app, so the provider
		// exists here; it lazily wires any chip the MetaTemplate above emits.
		if (this.pict.providers.ChipTooltips && typeof this.pict.providers.ChipTooltips.start === 'function')
		{
			this.pict.providers.ChipTooltips.start();
		}

		this.pict.MetaTemplate.addPattern('{~UnitsAddon:', '~}', (pHash, pData) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// if this is a tabular context, don't return anything
			if (isTabular && !useInlineUnits)
			{
				return '';
			}
			// if there are units, return the units. aria-hidden keeps the
			// decorative unit pill from being announced as a separate
			// interactive control (already conveyed by the label). (Tier 4)
			return `<p class="control control-status addon">
						<button tabindex="-1" aria-hidden="true" class="addon-button button is-static" type="button">${tmpUnits}</button>
					</p>`;
		});

		// TODO: Consider making Print an optional flag on the previous method
		this.pict.MetaTemplate.addPattern('{~UnitsAddonPrint:', '~}', (pHash, pData) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// if this is a tabular context, don't return anything
			if (isTabular && !useInlineUnits)
			{
				return '';
			}
			// if there are units, return the units
			return `<span class="control">
				<div class="input is-static has-text-text-50 units-text">${tmpUnits}</div>
			</span>`;
		});

		this.pict.MetaTemplate.addPattern('{~UnitsTabularHeader:', '~}', (pHash, pData) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// if this is tabular and we are using inline units, don't return anything for the header on the table
			if (isTabular && useInlineUnits)
			{
				return '';
			}
			// if there are units, return the units
			return `<div class="tag has-text-centered is-block" style="line-height: 1.5rem">${tmpUnits}</div>`;
		});

		// add the required + aria-required attributes if the field is required.
		// The PictProvider-InputValidation runtime sync may later strip these
		// when the input becomes hidden (e.g. inactive tab) so that the
		// browser/framework's checkValidity() and assistive tech reflect what
		// the user can actually see.
		//
		// a11y tiers (tracked here): Tiers 1, 2, 2.5, 3 (Half A) and 4 are DONE,
		// as is Tier 5. See test/Templates-A11y-Tier2-*.{js,md},
		// test/Templates-A11y-Tier3-*.js and test/Templates-A11y-Tier4-*.js for
		// per-template coverage and the smoke checklist. (Tier 5 is runtime DOM
		// in PictProvider-InputValidation, so it has no string-level test here.)
		//   Tier 1 — aria-required / aria-disabled / aria-invalid / role=alert on validation-text /
		//     aria-describedby help-text pairing (PictProvider-InputValidation).
		//   Tier 2 — Read theme `disabled="disabled"` -> `readonly aria-readonly="true"` on text and
		//     number inputs (incl. Geolocation lat/long; its disableMap gate also treats readonly as
		//     locked). The locked look is preserved by the `[aria-readonly="true"]` rule in
		//     lib/web/headlight-styles/bulma-extended.scss.
		//   Tier 2.5 — non-text controls that can't use `readonly` present a static locked value:
		//     Option/Select2 render the selected LABEL into the DISPLAY-FOR node
		//     (PictProvider-InputType-Select); Boolean keeps a disabled checkbox (filled/empty, matches
		//     Print); Color paints a swatch + hex via PictProvider-InputType-Color in both Read and Print.
		//   Note (by design): the required-label "*" is a CSS ::after pseudo-element, not announced by
		//     mainstream screen readers; switch to an explicit aria-hidden span only if axe flags it.
		//   Note (carry-over): AJAX / dynamic-pick-list selects may show the raw id in the static view
		//     if PictForm.SelectOptions lacks the label (same gap the Print path already had).
		//
		//   Tier 3 (tab semantics) — Half A DONE, Half B intentionally skipped:
		//     Half A (shipped): <ul><li onclick> tab markup carries
		//       role="tablist" / role="presentation" / role="tab" + aria-selected,
		//       and each tab is wired to its panel via aria-controls <-> the
		//       panel's role="tabpanel" + aria-labelledby. The static roles live
		//       in the templates; the stateful aria-selected and the cross-element
		//       relationships (the panel id carries a runtime UUID/formID) are set
		//       in selectTabByViewHash, overridden in the local Tab*Selector
		//       providers. See: templates/InputType-TabSectionSelector.js,
		//            templates/InputType-TabGroupSelector.js,
		//            providers/PictProvider-InputType-Tab{Section,Group}Selector.js.
		//     Half B (NOT done, by decision): roving tabindex + arrow/Home/End
		//       key navigation. Skipped deliberately — tabs are already natively
		//       Tab/Shift+Tab focusable (WCAG 2.x keyboard-operable); roving
		//       tabindex would only trim Tab stops on long strips (ours are 3-5),
		//       and it requires a net-new keydown handler the team prefers to
		//       avoid for non-critical cases. Revisit only if long tab strips or
		//       a specific AT request makes the ergonomics worthwhile; it slots
		//       cleanly into the same provider override with no template churn.
		//
		//   Tier 4 (single-input edge cases) — DONE. See
		//     test/Templates-A11y-Tier4-IconLabels_tests.js.
		//     - Signature: aria-label on the modal drawing canvas + on the
		//       icon-only "edit" (pen) trigger buttons and the modal Undo/Redo
		//       buttons; alt text on every signature-preview <img>.
		//       See: templates/InputType-Signature.js,
		//            providers/PictProvider-InputType-Signature.js.
		//     - Tabular menus: aria-label on the icon-only row-actions ellipsis
		//       trigger; aria-hidden="true" on the decorative fa icons that sit
		//       beside visible text labels. See: templates/Tabular-Group.js.
		//     - aria-hidden="true" on the static-button units addon in
		//       {~UnitsAddon:~} above so the unit pill isn't read as a separate
		//       interactive control.
		//
		//   Tier 5 (richer announcements) — DONE.
		//     - aria-errormessage on the input pointing to the injected
		//       validation-text node's id (paired with the existing
		//       aria-invalid; cleared on every valid/hidden path). Lives in
		//       PictProvider-InputValidation alongside the validation-text
		//       injection in handleValidationHelpTextElementUpdate. Runtime DOM
		//       wiring, so no string-level test in this package.
		//
		// data-required="true" is the *persistent* marker — the manifest's
		// declaration of required-ness. The provider's runtime sync may flip
		// the `required` / `aria-required` attributes on/off as the field
		// becomes visible/hidden (e.g. tab switches), but data-required
		// stays put so we can restore the live attributes for fields that
		// re-appear, and so the pre-submit sweep can find every "ever
		// required" input across the form.
		this.pict.MetaTemplate.addPattern('{~Required:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.Required)
			{
				return 'required aria-required="true" data-required="true"';
			}
			return '';
		});

		// add the disabled + aria-disabled attributes if the field is disabled.
		// aria-disabled mirrors the native disabled state for assistive tech;
		// some screen readers don't announce native disabled consistently
		// across input variants, so emitting both belt-and-suspenders style.
		this.pict.MetaTemplate.addPattern('{~Disabled:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.Disabled)
			{
				return 'disabled aria-disabled="true"';
			}
			return '';
		});

		// add the min attribute if the field has a minimum value
		this.pict.MetaTemplate.addPattern('{~Min:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.hasOwnProperty('NumberMin'))
			{
				return 'min="' + pData.PictForm.NumberMin + '"';
			}
			return '';
		});

		// add the max attribute if the field has a maximum value
		this.pict.MetaTemplate.addPattern('{~Max:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.hasOwnProperty('NumberMax'))
			{
				return 'max="' + pData.PictForm.NumberMax + '"';
			}
			return '';
		});

		// add the max attribute if the field has a maximum value
		this.pict.MetaTemplate.addPattern('{~Step:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.hasOwnProperty('NumberStep'))
			{
				return 'step="' + pData.PictForm.NumberStep + '"';
			}
			return 'step="any"';
		});

		// manage the placeholder string value at a consistent level
		this.pict.MetaTemplate.addPattern('{~Placeholder:', '~}', (pHash, pData) =>
		{
			// if there is a custom placeholder, use it
			if (typeof pData.PictForm.Placeholder !== 'undefined')
			{
				return `${pData.PictForm.Placeholder}`;
			}
			// or if there is a predefined placeholder, use it
			else
			{
				switch (pData.PictForm.InputType || pData.DataType)
				{
				case 'String':
				case 'TextArea':
					return 'Enter text...';
				case 'Number':
					return '0';
				case 'Option':
				case 'Select':
				case 'Select2':
				case 'Select2Multiple':
					return 'Select...';
				case 'DateTime':
				case 'DateTimePicker':
					return 'Select date/time...';
				case 'Date':
				case 'DatePicker':
					return 'Select date...';
				case 'Time':
				case 'TimePicker':
					return 'Select time...';
				case 'PhoneNumber':
					return '(555) 555-5555';
				case 'EmailAddress':
					return 'yourname@domain.com';
				case 'StreetAddress':
					return '1234 West St.';
				case 'Station':
					return 'station (ex. 23+07)';
				default:
					return '';
				}
			}
		});

		// balance the columns based on the width set in the configuration
		this.pict.MetaTemplate.addPattern('{~ColumnWidth:', '~}', (pHash, pData) =>
		{
			let tmpClasses = '';
			// a layout-excluded column (explicit zero width / hidden input) must take no horizontal space and never emit is-0
			if (pData.PictForm._LayoutExcluded)
			{
				// close the class attribute and open a style attribute, mirroring the percentage path's quote handling
				return `" style="display:none;`;
			}
			// if there is a Bulma column class set, use it
			if (pData.PictForm._BulmaColumnClasses)
			{
				tmpClasses = pData.PictForm._BulmaColumnClasses;
			}
			// if there is a width percentage set, use it instead of a Bulma column class
			else if (pData.PictForm._AdjustedWidthPercentage)
			{
				// if there is a width percentage set, use it
				const tmpWidthPercentage = parseFloat(pData.PictForm._AdjustedWidthPercentage);
				if (tmpWidthPercentage > 0 && tmpWidthPercentage <= 100)
				{
					// NOTE: This is a workaround for Bulma's column width classes, which are based on a 12-column grid
					tmpClasses = `" style="flex:none; width:${tmpWidthPercentage}%;`;
				}
			}
			// fallback to the original manual widths for backward compatibility
			// if there is a width set, use it
			else if (pData.PictForm.Width)
			{
				const tmpWidth = parseFloat(pData.PictForm.Width);
				if (tmpWidth > 0 && tmpWidth <= 12)
				{
					tmpClasses = `is-${tmpWidth}`;
				}
				// if there is a width offset set, add it to the classes
				if (pData.PictForm.WidthOffset)
				{
					const tmpWidthOffset = parseFloat(pData.PictForm.WidthOffset);
					if (tmpWidthOffset > 0 && tmpWidthOffset <= 12)
					{
						tmpClasses += ` is-offset-${tmpWidthOffset}`;
					}
				}
			}

			return tmpClasses;
		});

		this.pict.MetaTemplate.addPattern('{~FilterToggleHidden:', '~}', (pHash, pData) =>
		{
			// Visibility class for the inline "Show All" toggle — hidden unless the descriptor (or its config-map entry) enables it.
			return libFilterToggleUI.isToggleVisible(pData) ? '' : 'is-hidden';
		});

		this.pict.MetaTemplate.addPattern('{~FilterToggleDisabled:', '~}', (pHash, pData) =>
		{
			// Inert class for the inline "Show All" toggle on a read-only / disabled field — filtering a
			// picker whose value cannot change is wasted work, and a live-looking toggle implies otherwise.
			// The class is painted here so there is no enabled->disabled flash; _FilterToggleUI re-applies it
			// at input-initialize for descriptors disabled after render (e.g. DisabledOnceSaved).
			return libFilterToggleUI.isInputDisabled(pData) ? libFilterToggleUI.DISABLED_CLASS : '';
		});
		libFilterToggleUI.ensureFilterToggleCSS(this.pict);

		// support overcrowded columns for the row in the group
		this.pict.MetaTemplate.addPattern('{~ColumnsOvercrowded:', '~}', (pHash, pData) =>
		{
			// if there is a Bulma column class set, use it
			if (pData._OvercrowdedColumns)
			{
				// if the columns are overcrowded, return the class
				return pData._OvercrowdedColumns ? 'is-multiline' : '';
			}
			// otherwise, return an empty string
			return '';
		});

		// Lazily resolve and cache the group layout (Tabular | RecordSet | ...) on the input descriptor
		// so layout-aware macros below can branch on it without re-walking the data-context array.
		/**
		 * @param {any} pDataObject
		 * @param {Array<any>} pContext
		 * @returns {string | null | undefined}
		 */
		const resolveGroupLayout = (pDataObject, pContext) =>
		{
			if (!pDataObject?.PictForm) return undefined;
			if (pDataObject.PictForm._GroupLayout !== undefined) return pDataObject.PictForm._GroupLayout;
			if (!Array.isArray(pContext)) return undefined;
			const tmpView = pContext.find((pEntry) => pEntry && typeof pEntry.getGroup === 'function');
			const tmpGroupIndex = pDataObject.PictForm.GroupIndex;
			if (tmpView && tmpGroupIndex !== undefined)
			{
				const tmpGroup = tmpView.getGroup(tmpGroupIndex);
				pDataObject.PictForm._GroupLayout = tmpGroup?.Layout || null;
			}
			else
			{
				pDataObject.PictForm._GroupLayout = null;
			}
			return pDataObject.PictForm._GroupLayout;
		};

		// support column alignment for the label and input
		this.pict.MetaTemplate.addPattern('{~ColumnAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData, /** @type {Array<any>} */ pContext) =>
		{
			let tmpClasses = '';
			if (pData.PictForm.ColumnAlignment)
			{
				switch (pData.PictForm.ColumnAlignment)
				{
				case 'LEFT':
				case 'Left':
				case 'left':
					tmpClasses = 'has-text-left';
					break;
				case 'CENTER':
				case 'Center':
				case 'center':
					tmpClasses = 'has-text-centered';
					break;
				case 'RIGHT':
				case 'Right':
				case 'right':
					tmpClasses = 'has-text-right';
					break;
				default:
					tmpClasses = '';
					break;
				}
			}
			else
			{
				// if no alignment is set, align numbers to the right for numbers and precise numbers by default
				if (!pData.PictForm.InputType && (pData.DataType === 'Number' || pData.DataType === 'PreciseNumber' || pData.DataType === 'PreciseNumberReadOnly'))
				{
					tmpClasses = 'has-text-right' + (pData?.PictForm?.InputType?.includes('ReadOnly') && this.pict.AppData.Interactive ? ' pr-3' : '');
				}
				// Boolean checkbox cells are usually narrow single-checkbox columns — center in plain Tabular,
				// left everywhere else (standard, vertical, RecordSet)
				else if (pData.PictForm?.InputType === 'Boolean')
				{
					tmpClasses = resolveGroupLayout(pData, pContext) === 'Tabular' ? 'has-text-centered' : 'has-text-left';
				}
			}
			return tmpClasses;
		});

		// build help text content for vertical forms
		this.pict.MetaTemplate.addPattern('{~SelectOnFocus:', '~}', (pHash, pData) =>
		{
			return `onfocus="this.select();"`;
		});

		// NOTE: These are duplicated in the Panels, but we need them here for the form too.
		// TODO: Determine if we can remove the duplication with a Utility-like meta template collection
		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideContent:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject.Content || tmpDataObject.Default) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowContent:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject.Content || tmpDataObject.Default) ? '' : 'is-hidden';
		});

		// add the ".is-hidden-tablet" class to the input label if PictForm.HideLabel is set
		// NOTE: Mobile devices keep the label, as it's needed for context in a stacked layout
		this.pict.MetaTemplate.addPattern('{~HideLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			const hideLabel = tmpDataObject?.PictForm?.hasOwnProperty('HideLabel') && tmpDataObject?.PictForm?.HideLabel;
			return hideLabel ? 'is-hidden-tablet' : '';
		});

		// For Boolean inputs in a RecordSet layout, hide the cell-prefix "header" label since the checkbox template
		// renders its own inline label. Use "is-invisible" (preserves space) when sibling labels are visible so
		// row alignment matches; collapse fully ("is-hidden") only if PictForm.HideLabel is also set.
		this.pict.MetaTemplate.addPattern('{~HideCheckboxCellLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			if (tmpDataObject?.PictForm?.InputType !== 'Boolean') return '';
			if (resolveGroupLayout(tmpDataObject, pContext) !== 'RecordSet') return '';
			return tmpDataObject.PictForm.HideLabel ? 'is-hidden' : 'is-invisible';
		});

		// For Boolean inputs in a plain Tabular (non-RecordSet) layout, hide the inline checkbox label since
		// the Tabular column header already labels the field — keep visible in RecordSet (no column header there).
		this.pict.MetaTemplate.addPattern('{~HideCheckboxInlineLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			if (tmpDataObject?.PictForm?.InputType !== 'Boolean') return '';
			return resolveGroupLayout(tmpDataObject, pContext) === 'Tabular' ? 'is-hidden' : '';
		});

		// Geolocation input types have two presentations — the full picker (address search + editable
		// lat/long + readout + labeled buttons) and a compact readout bar whose picker lives in an Edit
		// modal. Rather than emit both and hide one, this macro picks the presentation and renders just
		// that body, so ids stay unique and no dead chrome ships in every tabular row. The tag carries
		// the theme (`{~GeolocationBody:Edit~}`); everything else comes off the input descriptor.
		//
		// Full size is the default everywhere and PictForm.Compact opts in — EXCEPT a Tabular table,
		// which is always compact because a full picker cannot fit a table cell. A Record Set stacks its
		// records, so it honors the flag exactly like a Standard field does.
		this.pict.MetaTemplate.addPattern('{~GeolocationBody:', '~}', (pHash, pData, pContext) =>
		{
			const tmpTabular = !!pData?.IsTabular;
			const tmpCompact = (resolveGroupLayout(pData, pContext) === 'Tabular') || !!pData?.PictForm?.Compact;
			const tmpBody = libGeolocationBodies.buildGeolocationBody(
				{
					Theme: `${pHash}`.trim(),
					Compact: tmpCompact,
					HasMap: pData?.PictForm?.InputType === 'GeolocationSelectorWithMap',
					Tabular: tmpTabular,
				});
			// Resolve the body's own tags against this same record + context (the macro output is not
			// re-parsed by the engine).
			return this.pict.parseTemplate(tmpBody, pData, null, pContext);
		});

		// Diagram / RichText editor body. Emits the inline View/Edit presentation for the theme the tag
		// carries (`{~EditorBody:Edit~}`); the InputType comes off the record. Like the geolocation macro,
		// the emitted body still contains {~D:...~} tags, so it is parsed here against the same record.
		this.pict.MetaTemplate.addPattern('{~EditorBody:', '~}', (pHash, pData, pContext) =>
		{
			const tmpBody = libEditorBodies.buildEditorBody(
				{
					Theme: `${pHash}`.trim(),
					InputType: pData?.PictForm?.InputType,
				});
			return this.pict.parseTemplate(tmpBody, pData, null, pContext);
		});

		// add the ".is-hidden" class to the group title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowGroupTitle:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject.hasOwnProperty('ShowTitle') && !tmpDataObject.ShowTitle) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the section title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowSectionTitle:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject.hasOwnProperty('ShowTitle') && !tmpDataObject.ShowTitle) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the input if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideInPDF:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			let tmpHideFlag = false;
			// input level
			if (tmpDataObject?.hasOwnProperty('PictForm') && tmpDataObject.PictForm && tmpDataObject.PictForm?.hasOwnProperty('InputExtra') && tmpDataObject.PictForm.InputExtra)
			{
				tmpHideFlag = tmpDataObject.PictForm?.InputExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			// group level
			else if (tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				tmpHideFlag = tmpDataObject?.GroupExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			// section level
			else if (tmpDataObject?.hasOwnProperty('SectionExtra') && tmpDataObject.SectionExtra)
			{
				tmpHideFlag = tmpDataObject?.SectionExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			return tmpHideFlag ? 'is-hidden' : '';
		});

		// emit target/rel on Link anchors when the descriptor opts in via PictForm.LinkTarget
		this.pict.MetaTemplate.addPattern('{~LinkTarget:', '~}', (pHash, pData, pContext) =>
		{
			return libLinkTarget.resolveLinkTargetAttributes(this.pict.resolveStateFromAddress(pHash, pData, pContext));
		});

		this.pict.MetaTemplate.addPattern('{~HiddenInputTabularAdjustment:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the input is hidden in a tabular context, we need to add a placeholder to maintain alignment
			if (tmpDataObject.PictForm?.InputType === 'Hidden' && pData.IsTabular)
			{
				return `is-hidden`;
			}
			return '';
		});

		// human readable count summaries
		this.pict.addTemplate(require('./providers/PictProvider-Template-HumanCount.js'));
	}
}

module.exports = HeadlightDynamicInputsBundle;

},{"./providers/Pict-Provider-DistillingBundleManager.js":27,"./providers/Pict-Provider-Input-DistilledInput.js":28,"./providers/PictProvider-Bulma-HTML.js":29,"./providers/PictProvider-Bulma-Markdown.js":30,"./providers/PictProvider-Bulma-MarkdownDisplay.js":31,"./providers/PictProvider-Bulma-MaterialsQRCodeDisplay.js":32,"./providers/PictProvider-Bulma-RecordSetControls.js":33,"./providers/PictProvider-Bulma-TableControls.js":34,"./providers/PictProvider-ChipTooltips.js":36,"./providers/PictProvider-DataRequirements.js":37,"./providers/PictProvider-DataType-DatePicker.js":38,"./providers/PictProvider-DataType-DateTimePicker.js":39,"./providers/PictProvider-DataType-TimePicker.js":40,"./providers/PictProvider-DraggableUtil.js":41,"./providers/PictProvider-EntityBundleClient.js":42,"./providers/PictProvider-EntityFilterEngine.js":43,"./providers/PictProvider-FlatpickrUtil.js":44,"./providers/PictProvider-InputType-BridgeDisplay.js":45,"./providers/PictProvider-InputType-BridgeSelector.js":46,"./providers/PictProvider-InputType-Color.js":47,"./providers/PictProvider-InputType-Diagram.js":48,"./providers/PictProvider-InputType-EmailAddress.js":51,"./providers/PictProvider-InputType-EntityDisplay.js":52,"./providers/PictProvider-InputType-EntityDisplayMultiple.js":53,"./providers/PictProvider-InputType-EntitySelector.js":54,"./providers/PictProvider-InputType-EntitySelectorMultiple.js":55,"./providers/PictProvider-InputType-FileSelector.js":56,"./providers/PictProvider-InputType-GeolocationSelector.js":58,"./providers/PictProvider-InputType-LabDisplay.js":59,"./providers/PictProvider-InputType-LabSelector.js":60,"./providers/PictProvider-InputType-LineItemDisplay.js":61,"./providers/PictProvider-InputType-LineItemSelector.js":62,"./providers/PictProvider-InputType-MaterialDisplay.js":63,"./providers/PictProvider-InputType-MaterialSelector.js":64,"./providers/PictProvider-InputType-MaterialsCascadePicker.js":65,"./providers/PictProvider-InputType-MaterialsEntityDisplay.js":66,"./providers/PictProvider-InputType-MaterialsEntityPicker.js":67,"./providers/PictProvider-InputType-MaterialsEntitySelector.js":68,"./providers/PictProvider-InputType-MaterialsLabDisplay.js":69,"./providers/PictProvider-InputType-MaterialsLabPicker.js":70,"./providers/PictProvider-InputType-MaterialsLabSelector.js":71,"./providers/PictProvider-InputType-MaterialsLineItemDisplay.js":72,"./providers/PictProvider-InputType-MaterialsLineItemPicker.js":73,"./providers/PictProvider-InputType-MaterialsLineItemSelector.js":74,"./providers/PictProvider-InputType-MaterialsPlantSelector.js":75,"./providers/PictProvider-InputType-MaterialsSampleDisplay.js":76,"./providers/PictProvider-InputType-MaterialsSamplePicker.js":77,"./providers/PictProvider-InputType-MaterialsSamplePickerDisplay.js":78,"./providers/PictProvider-InputType-MaterialsSampleSelector.js":79,"./providers/PictProvider-InputType-MaterialsTestDisplay.js":80,"./providers/PictProvider-InputType-MaterialsTestInjector.js":81,"./providers/PictProvider-InputType-MaterialsTestInjectorPicker.js":82,"./providers/PictProvider-InputType-MaterialsTestLabPicker.js":83,"./providers/PictProvider-InputType-MaterialsTestLabSelector.js":84,"./providers/PictProvider-InputType-MaterialsTestPicker.js":85,"./providers/PictProvider-InputType-MaterialsTestSectionRemover.js":86,"./providers/PictProvider-InputType-MaterialsTestSelector.js":87,"./providers/PictProvider-InputType-MixSpecificationDisplay.js":88,"./providers/PictProvider-InputType-MixSpecificationSelector.js":89,"./providers/PictProvider-InputType-ObservationCardDeck.js":90,"./providers/PictProvider-InputType-ObservationTypeDisplay.js":91,"./providers/PictProvider-InputType-ObservationTypeSelector.js":92,"./providers/PictProvider-InputType-PhoneNumber.js":93,"./providers/PictProvider-InputType-PhysicalAssetSelector.js":94,"./providers/PictProvider-InputType-Picker.js":95,"./providers/PictProvider-InputType-PickerDisplay.js":96,"./providers/PictProvider-InputType-PlantDisplay.js":97,"./providers/PictProvider-InputType-PlantSelector.js":98,"./providers/PictProvider-InputType-PrecompiledFileSelector.js":99,"./providers/PictProvider-InputType-ProducerDisplay.js":100,"./providers/PictProvider-InputType-ProducerSelector.js":101,"./providers/PictProvider-InputType-ProductDisplay.js":102,"./providers/PictProvider-InputType-ProductSelector.js":103,"./providers/PictProvider-InputType-ProjectDisplay.js":104,"./providers/PictProvider-InputType-ProjectSelector.js":105,"./providers/PictProvider-InputType-RichText.js":106,"./providers/PictProvider-InputType-SampleDisplay.js":107,"./providers/PictProvider-InputType-SampleSelector.js":108,"./providers/PictProvider-InputType-SampleStatusPicker.js":109,"./providers/PictProvider-InputType-SampleStatusSelector.js":110,"./providers/PictProvider-InputType-SampleTestAcceptance.js":111,"./providers/PictProvider-InputType-SampleTestResult.js":112,"./providers/PictProvider-InputType-SampleTypePicker.js":113,"./providers/PictProvider-InputType-SampleTypeSelector.js":114,"./providers/PictProvider-InputType-Select.js":115,"./providers/PictProvider-InputType-Signature.js":116,"./providers/PictProvider-InputType-Station.js":117,"./providers/PictProvider-InputType-TabGroupSelector.js":118,"./providers/PictProvider-InputType-TabSectionSelector.js":119,"./providers/PictProvider-InputType-TextArea.js":120,"./providers/PictProvider-InputValidation.js":121,"./providers/PictProvider-LabScopeResolver.js":122,"./providers/PictProvider-MediaRegistry.js":123,"./providers/PictProvider-NumberScrollLock.js":124,"./providers/PictProvider-QRCode.js":125,"./providers/PictProvider-ResponsiveUIAdjustment.js":126,"./providers/PictProvider-Select2Util.js":127,"./providers/PictProvider-SpecScopeResolver.js":128,"./providers/PictProvider-Template-HumanCount.js":129,"./providers/PictProvider-Template-LinkTarget.js":130,"./providers/PictProvider-ThroughScopeResolver.js":131,"./providers/_FilterToggleUI.js":136,"./templates/EditorBodies.js":153,"./templates/GeolocationBodies.js":156,"./templates/_index.js":235,"./themes/PictProvider-Theme-Base.js":236,"./themes/PictProvider-Theme-Edit.js":237,"./themes/PictProvider-Theme-Print.js":238,"./themes/PictProvider-Theme-Read.js":239,"./views/PictView-FormHeader.js":240,"./views/PictView-GeolocationSelector.js":241,"pict-section-picker":605}],27:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

class DistillingBundleManager extends PictProvider
{
	/**
	 * @param {Pict} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - (optional) The options for the provider.
	 * @param {string} [pServiceHash] - (optional) The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable') & import('pict')} */
		this.fable;

		/** @type {Record<string, any>} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		this.pict.AppData._DistillingBundleData = {};
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after data load is complete.
	 *
	 * @return {void}
	 */
	onLoadDataAsync(fCallback)
	{
		return super.onLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}

			const tmpManifest = this.pict.settings.MyDefaultFormManifest;
			if (!tmpManifest)
			{
				return fCallback();
			}
			this._primeBundlesFromManifest(tmpManifest, fCallback);
		});
	}

	/**
	 * @param {Record<string, any>} pManifest
	 * @param {(pError?: Error) => void} fCallback
	 */
	_primeBundlesFromManifest(pManifest, fCallback)
	{
		const tmpBundlesToLoad = {};
		for (const tmpDescriptor of Object.values(pManifest.Descriptors || {}))
		{
			if (tmpDescriptor.PictForm?.DistillingBundleHash)
			{
				//FIXME: support alternate source for project ID; ex. the loaded sample record
				tmpBundlesToLoad[tmpDescriptor.PictForm.DistillingBundleHash] = this.pict.AppData.DocumentData.ReportData.IDProject;
			}
		}
		const tmpPromises = [];
		if (Object.keys(tmpBundlesToLoad).length > 0)
		{
			for (const [ tmpBundleHash, tmpIDProject ] of Object.entries(tmpBundlesToLoad))
			{
				tmpPromises.push(this.getBundle(tmpBundleHash, tmpIDProject).catch((pError) =>
				{
					this.pict.log.error(`Error loading distilling bundle ${tmpBundleHash}: ${pError.message}`, { Stack: pError.stack });
				}));
			}
		}
		Promise.all(tmpPromises).finally(() => fCallback());
	}

	/**
	 * Hook on pre-solve to detect changes to required bundles.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		return super.onPreSolveAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			// Ensure all bundles used in the current document are loaded
			const tmpManifest = this.pict.views.PictFormMetacontroller.manifestDefinition;
			if (!tmpManifest)
			{
				return fCallback();
			}
			this._primeBundlesFromManifest(tmpManifest, fCallback);
		});
	}

	/**
	 * @param {string} pBundleHash
	 * @param {number} [pIDProject]
	 *
	 * @return {Promise<any>}
	 */
	async getBundle(pBundleHash, pIDProject)
	{
		if (pIDProject == null)
		{
			pIDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		}
		let tmpBundle = this.pict.AppData._DistillingBundleData[pBundleHash]?.[pIDProject]?.Bundle;
		if (!tmpBundle)
		{
			tmpBundle = await this._loadBundle(pBundleHash, pIDProject);
		}
		return tmpBundle;
	}

	/**
	 * @param {string} pBundleHash
	 * @param {number} [pIDProject]
	 *
	 * @return {Grafee|null}
	 */
	getLatestGraph(pBundleHash, pIDProject)
	{
		let tmpData = this.pict.AppData._DistillingBundleData[pBundleHash]?.[pIDProject];
		if (!tmpData)
		{
			tmpData = this.pict.AppData._DistillingBundleData[pBundleHash]?.[this.pict.AppData._DistillingBundleData[pBundleHash]?.LatestProject];
		}
		if (!tmpData)
		{
			this.pict.log.warn(`Distilling bundle data for hash ${pBundleHash} not loaded yet.`);
			return null;
		}
		if (tmpData.Graph)
		{
			return tmpData.Graph;
		}
		if (tmpData.Bundle)
		{
			tmpData.Graph = new Grafee(tmpData.Bundle);
			return tmpData.Graph;
		}
		return null;
	}

	/**
	 * @param {string} pBundleHash
	 * @param {number} [pIDProject]
	 *
	 * @return {Promise<any>}
	 */
	async _loadBundle(pBundleHash, pIDProject)
	{
		this.pict.log.info(`Loading distilling bundle ${pBundleHash} for project ${pIDProject}`);
		const tmpBundle = await this._get(`Distilling/For/${pBundleHash}/Project/${pIDProject}`);
		this.pict.AppData._DistillingBundleData[pBundleHash] = this.pict.AppData._DistillingBundleData[pBundleHash] || {};
		this.pict.AppData._DistillingBundleData[pBundleHash].LatestProject = pIDProject;
		this.pict.AppData._DistillingBundleData[pBundleHash][pIDProject] = this.pict.AppData._DistillingBundleData[pBundleHash][pIDProject] || {};
		this.pict.AppData._DistillingBundleData[pBundleHash][pIDProject].Bundle = tmpBundle;
		//TODO: remove old bundles from AppData to release memory?
		return tmpBundle;
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 *
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = DistillingBundleManager;
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"headlight-rest-client":12,"pict-provider":479}],28:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// what it do:
//
// * detects changes to linked inputs and evaluates the local input value
//   * This may result in clearing the value if it is no longer valid
// * updates options list / filtering
//
class DistilledInputHandler extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}
	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!this._suppressDistillingEmit)
		{
			this._emitDistillingDataChangeEvent(pInput.PictForm.DistillingKey, pValue || '');
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {number} pRowIndex - The row index of the tabular data
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//TODO: any special handling for tabular / rows? ex. distilling that is row-local?
		if (!this._suppressDistillingEmit)
		{
			this._emitDistillingDataChangeEvent(pInput.PictForm.DistillingKey, pValue || '');
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * NOTE: You can pass in a date value with the :date flag in the DistillingDisplay field to format date fields.
	 * TODO: add tabular version...
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpResult = super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		if (typeof pEvent !== 'string')
		{
			return tmpResult;
		}
		const tmpEventParts = pEvent.split(':');
		const tmpEventHash = tmpEventParts[0];
		if (tmpEventHash !== 'GetPickList')
		{
			return tmpResult;
		}
		const tmpListHash = tmpEventParts[1];
		if (tmpListHash !== pInput.PictForm.SelectOptionsPickList)
		{
			return tmpResult;
		}
		const tmpListDataAddress = tmpEventParts[2];
		const tmpEventOptions = JSON.parse(tmpEventParts.slice(3).join(':'));
		this.pict.log.info(`CustomSelectInputProvider received event: ${pEvent} for list ${tmpListHash} with options:`, { tmpEventHash, tmpListHash, tmpListDataAddress, tmpEventOptions });
		const tmpListData = this.pict.manifest.getValueByHash(this.pict, tmpListDataAddress);
		if (!Array.isArray(tmpListData))
		{
			this.pict.log.error(`CustomSelectInputProvider expected array data at address ${tmpListDataAddress} but found:`, { tmpListData });
			return tmpResult;
		}
		if (tmpListData.length > 0)
		{
			// this happens when multiple inputs share the same picklist - don't want to double-populate
			return tmpResult;
		}
		/** @type {import('@paviasystems/grafee').Grafee} */
		const tmpGraph = this.pict.providers.DistillingBundleManager.getLatestGraph(pInput.PictForm.DistillingBundleHash);
		let tmpAvailableValues;
		if (tmpEventOptions.extractRootKey)
		{
			tmpAvailableValues = Array.isArray(tmpEventOptions.extractRootKey) ? tmpEventOptions.extractRootKey : [ tmpEventOptions.extractRootKey ];
		}
		else
		{
			const tmpSearchSelections = this._getSelectedDistillingValues(pView, pInput.PictForm.DistillingBundleHash, pInput.PictForm.DistillingKey);
			if (pInput.PictForm?.IgnoreKeys)
			{
				for (let k of pInput.PictForm.IgnoreKeys)
				{
					if (tmpSearchSelections[k])
					{
						delete tmpSearchSelections[k];
					}
				}
			}
			tmpAvailableValues = tmpGraph.searchValues(pInput.PictForm.DistillingKey, tmpEventOptions, tmpSearchSelections);
		}
		const tmpDisplayFields = (pInput.PictForm.DistillingDisplay || '').split(',').filter((v) => v !== '');
		const tmpDisplayFieldsWithDateFlags = [];
		// for each tmpDisplayFields, check for a `:date` flag at the end of the key and remove it/store it for formatting
		if (tmpDisplayFields.length > 0)
		{
			for (let i = 0; i < tmpDisplayFields.length; i++)
			{
				const tmpFieldParts = tmpDisplayFields[i].split(':');
				if (tmpFieldParts.length > 1 && tmpFieldParts[tmpFieldParts.length - 1] === 'date')
				{
					// store as date field
					tmpDisplayFieldsWithDateFlags.push({ field: tmpFieldParts.slice(0, -1).join(':'), isDate: true });
					// update original array to remove :date flag
					tmpDisplayFields[i] = tmpFieldParts.slice(0, -1).join(':');
				}
				else
				{
					tmpDisplayFieldsWithDateFlags.push({ field: tmpFieldParts.join(':'), isDate: false });
				}
			}
		}
		const tmpMappedValues = tmpGraph.extractJoinedValues(pInput.PictForm.DistillingKey, tmpAvailableValues, tmpDisplayFields);
		let tmpArray = [];
		const usedKeys = {};
		for (const tmpMappedValue of tmpMappedValues)
		{
			const displayParts = [];
			for (const tmpDisplayField of tmpDisplayFieldsWithDateFlags)
			{
				let fieldValue = tmpMappedValue[tmpDisplayField.field];
				// for date fields, format as YYYY-MM-DD
				if (tmpDisplayField.isDate && fieldValue)
				{
					const tmpDate = new Date(fieldValue);
					if (!isNaN(tmpDate.getTime()))
					{
						fieldValue = this.pict.Dates.dayJS(tmpDate).format('YYYY-MM-DD');
					}
				}
				if (fieldValue)
				{
					displayParts.push(fieldValue);
				}
			}
			const id = tmpMappedValue[pInput.PictForm.DistillingKey];
			const text = displayParts.filter((v) => v).join(': ') || tmpMappedValue[pInput.PictForm.DistillingKey];
			// This is to prevent duplicate key/values which can sometimes happen in the distilling bundle.
			if (usedKeys[id] !== text)
			{
				usedKeys[id] = text;
				tmpArray.push({
					id: tmpMappedValue[pInput.PictForm.DistillingKey],
					text: displayParts.filter((v) => v).join(': ') || tmpMappedValue[pInput.PictForm.DistillingKey],
				});
			}
		}
		tmpArray = tmpArray.sort((a, b) => {
			return a.text > b.text ? 1 : -1;
		});
		for (const t of tmpArray)
		{
			tmpListData.push(t);
		}
		return tmpResult;
	}

	/**
	 * @param {string} pDistillingKey - The distilling key that changed.
	 * @param {string} pDistillingValues - The distilling value that changed.
	 */
	_emitDistillingDataChangeEvent(pDistillingKey, pDistillingValues)
	{
		const tmpEvent = `InputDistilling:${pDistillingKey}:${pDistillingValues}`;
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this.pict.log.info(`DistilledInputHandler completed distilling data change event handling event ${pDistillingKey}.`);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 *
	 * @return {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 *
	 * @return {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID, pRowIndex);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @param {number} [pRowIndex] - The row index of the tabular data (if tabular).
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID, pRowIndex)
	{
		if (typeof pEvent !== 'string')
		{
			return;
		}
		const [ tmpType, tmpUpdatedKey ] = pEvent.split(':');
		if (tmpType !== 'InputDistilling')
		{
			return;
		}
		if (tmpUpdatedKey === pInput.PictForm.DistillingKey && pInput.PictForm.DistillingMode !== 'Projection')
		{
			return;
		}
		this.pict.log.info(`DistilledInputHandler handling event ${pEvent} for input ${pInput.Hash} in section ${pView.Hash}`);
		/** @type {import('@paviasystems/grafee').Grafee} */
		const tmpGraph = this.pict.providers.DistillingBundleManager.getLatestGraph(pInput.PictForm.DistillingBundleHash);
		let tmpChanged = false;
		if (pInput.PictForm.DistillingMode === 'Projection')
		{
			const tmpSelectedKeyValues = this._getSelectedDistillingValues(pView, pInput.PictForm.DistillingBundleHash)[pInput.PictForm.DistillingKey] || [];
			const tmpDisplayFields = (pInput.PictForm.DistillingDisplay || '').split(',').filter((v) => v !== '');
			const tmpMappedValues = tmpGraph.extractJoinedValues(pInput.PictForm.DistillingKey, tmpSelectedKeyValues, tmpDisplayFields);
			const tmpNewValue = tmpMappedValues.map((v) => tmpDisplayFields.map((f) => v[f]).filter((val) => val).join(': ') || v[pInput.PictForm.DistillingKey]).join(', ');
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), pInput.Hash, tmpNewValue);
		}
		else
		{
			const tmpListSelections = this._getSelectedDistillingValues(pView, pInput.PictForm.DistillingBundleHash, pInput.PictForm.DistillingKey);
			const tmpAvailableValues = tmpGraph.listValues(pInput.PictForm.DistillingKey, tmpListSelections);
			let tmpValue = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pInput.Hash);
			if (typeof tmpValue === 'string')
			{
				tmpValue = tmpValue.split(',').filter((v) => v !== '');
			}
			else if (tmpValue)
			{
				tmpValue = [ tmpValue ];
			}
			else
			{
				tmpValue = [];
			}
			//FIXME: doing a find here with a soft equals to deal with mixed strings and numbers... ugh - fix this upstream
			if (tmpValue.length > 0)
			{
				const tmpValidValues = tmpValue.filter((pValue) => tmpAvailableValues.find((v) => v == pValue) != null);
				if (tmpValidValues.length !== tmpValue.length)
				{
					this.pict.log.info(`DistilledInputHandler clearing value for input ${pInput.Hash} in section ${pView.Hash} due to distilling change.`);
					const tmpNewValue = tmpValidValues.length === 1 ? tmpValidValues[0] : tmpValidValues.length === 0 ? (pInput.Default ?? '') : tmpValidValues.join(',');
					pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), pInput.Hash, tmpNewValue);
					tmpValue = tmpValidValues;
					tmpChanged = true;
				}
			}
			if (tmpAvailableValues.length === 1 && (tmpValue.length !== 1 || tmpAvailableValues[0] != tmpValue[0]))
			{
				this.pict.log.info(`DistilledInputHandler auto-selecting only available value for input ${pInput.Hash} in section ${pView.Hash} due to distilling change.`);
				pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), pInput.Hash, tmpAvailableValues[0]);
				tmpChanged = true;
			}
		}
		if (tmpChanged)
		{
			if (pRowIndex != null)
			{
				pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
			}
			else
			{
				pView.manualMarshalDataToViewByInput(pInput);
			}
			const tmpPrevSuppressDistillingEmit = this._suppressDistillingEmit;
			this._suppressDistillingEmit = true;
			try
			{
				const tmpCommittedValue = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pInput.Hash);
				if (pRowIndex != null)
				{
					pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpCommittedValue);
				}
				else
				{
					pView.setDataByInput(pInput, tmpCommittedValue);
				}
			}
			finally
			{
				this._suppressDistillingEmit = tmpPrevSuppressDistillingEmit;
			}
		}
	}

	/**
	 * @param {InstanceType<import('pict-section-form')>} pView - The view object.
	 * @param {string} pDistillingBundleHash - The distilling bundle hash.
	 * @param {string} [pIgnoreKey] - A distilling key to ignore (usually the one that triggered the event).
	 *
	 * @return {Record<string, any>} - The selected distilling values.
	 */
	_getSelectedDistillingValues(pView, pDistillingBundleHash, pIgnoreKey)
	{
		//TODO: collect via event?
		/** @type {Record<string, any>} */
		const tmpSelectedValues = {};
		const tmpManifest = this.pict.views.PictFormMetacontroller.manifestDescription;
		if (!tmpManifest)
		{
			this.pict.log.warn('DistilledInputHandler could not get manifest description to collect selected distilling values.');
			return tmpSelectedValues;
		}
		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors || {}))
		{
			if (tmpDescriptor.PictForm?.DistillingBundleHash === pDistillingBundleHash && (pIgnoreKey == null || tmpDescriptor.PictForm?.DistillingKey !== pIgnoreKey))
			{
				const tmpRemoteValue = this._getInputDistillingValues(pView, tmpDescriptor);
				if (tmpRemoteValue && (!Array.isArray(tmpRemoteValue) || tmpRemoteValue.length > 0))
				{
					tmpSelectedValues[tmpDescriptor.PictForm.DistillingKey] = typeof tmpRemoteValue === 'string' && tmpRemoteValue.includes(',') ? tmpRemoteValue.split(',').filter((v) => { return v !== '' && v != '0'; }) : tmpRemoteValue;
				}
				if (tmpSelectedValues[tmpDescriptor.PictForm.DistillingKey] == 0)
				{
					delete tmpSelectedValues[tmpDescriptor.PictForm.DistillingKey];
				}
			}
		}
		return tmpSelectedValues;
	}

	/**
	 * @param {InstanceType<import('pict-section-form')>} pView - The view object.
	 * @param {Object} pDescriptor - The descriptor object.
	 *
	 * @return {any} - The distilling values for the input.
	 */
	_getInputDistillingValues(pView, pDescriptor)
	{
		//FIXME: how does this work for tabular inputs? do we just need to emit an event instead?
		return pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pDescriptor.Hash);
	}
}

module.exports = DistilledInputHandler;

},{"pict-section-form":497}],29:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		return tmpContent;
	}

	/**
	 * Adds Bulma flavor to the provided content (expected "default Bulma classes" on HTML elements).
	 * NOTE: We try to target only vanilla HTML elements with no existing classes - to give the designer more control.
	 * @param {string} pContent - The content to which to add Bulma flavor.
	 * @return {string} - The content with Bulma flavor added.
	 */
	addBulmaFlavor(pContent)
	{
		if (pContent)
		{
			// for tables, add the table class
			pContent = pContent.replace(/<table>/g, '<table class="table is-fullwidth is-striped is-hoverable">');
			// for images, add the image class
			pContent = pContent.replace(/<img/g, '<img class="image"');
			// h1-h6 (headings), add the title class with appropriate size modifier (NOTE: we bump down the size by 1 to make it less prominent)
			pContent = pContent.replace(/<h1>/g, '<h1 class="title is-2">');
			pContent = pContent.replace(/<h2>/g, '<h2 class="title is-3">');
			pContent = pContent.replace(/<h3>/g, '<h3 class="title is-4">');
			pContent = pContent.replace(/<h4>/g, '<h4 class="title is-5">');
			pContent = pContent.replace(/<h5>/g, '<h5 class="title is-6">');
			pContent = pContent.replace(/<h6>/g, '<h6 class="title is-7">');
		}
		return pContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpBulmaFlavoredContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],30:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (tmpContent)
		{
			tmpContent = libMarked.parse(tmpContent);
		}
		return tmpContent;
	}

	/**
	 * Adds Bulma flavor to the provided content (expected "default Bulma classes" on HTML elements).
	 * @param {string} pContent - The content to which to add Bulma flavor.
	 * @return {string} - The content with Bulma flavor added.
	 */
	addBulmaFlavor(pContent)
	{
		if (pContent)
		{
			// for tables, add the table class
			pContent = pContent.replace(/<table>/g, '<table class="table is-fullwidth is-striped is-hoverable">');
			// for images, add the image class
			pContent = pContent.replace(/<img/g, '<img class="image"');
			// h1-h6 (headings), add the title class with appropriate size modifier (NOTE: we bump down the size by 1 to make it less prominent)
			pContent = pContent.replace(/<h1>/g, '<h1 class="title is-2">');
			pContent = pContent.replace(/<h2>/g, '<h2 class="title is-3">');
			pContent = pContent.replace(/<h3>/g, '<h3 class="title is-4">');
			pContent = pContent.replace(/<h4>/g, '<h4 class="title is-5">');
			pContent = pContent.replace(/<h5>/g, '<h5 class="title is-6">');
			pContent = pContent.replace(/<h6>/g, '<h6 class="title is-7">');
		}
		return pContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpBulmaFlavoredContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"marked":442,"pict-section-form":497}],31:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libBulmaMarkdown = require('./PictProvider-Bulma-Markdown.js');
const libUserMarkdown = require('./_UserMarkdown.js');

/**
 * The input extension behind InputType `MarkdownDisplay`: a read-only field that renders the
 * markdown held in its *value* -- a remark a user typed -- rather than static markdown authored in
 * the manifest.
 *
 * InputType `Markdown` cannot do this. Its templates gate the display div on the descriptor's
 * Content/Default, so a descriptor bound to a data address renders the "No Markdown content
 * available to display" notification and hides the content, and it carries no label.
 *
 * @class
 * @extends libBulmaMarkdown
 */
class CustomInputHandler extends libBulmaMarkdown
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.log;

		this._remarksCSSRegistered = false;
	}

	/**
	 * Renders the markdown for this input.
	 *
	 * A Content/Default in the descriptor is markdown we authored, so it keeps the trusted
	 * rendering the Markdown InputType has always given it. A value is markdown a user typed, so it
	 * goes through the hardened renderer instead -- see _UserMarkdown.js for what that changes.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The input value.
	 * @return {String} - The rendered HTML.
	 */
	getInputContent(pInput, pValue)
	{
		const tmpHasAuthoredContent = (pInput && (((typeof(pInput.Content) === 'string') && pInput.Content) || ((typeof(pInput.Default) === 'string') && pInput.Default)));
		if (tmpHasAuthoredContent)
		{
			return super.getInputContent(pInput, pValue);
		}
		// Templates call this directly to render a remark (Sample Authorization's test summary), with no
		// MarkdownDisplay input on the form to register the stylesheet.
		this.registerRemarksCSS();
		return libUserMarkdown.renderUserMarkdown(pValue, this.log);
	}

	/**
	 * A remark is body copy, not page furniture. The template already wraps it in Bulma's `content`
	 * class, and the parent's title classes would blow an `# h1` in a remark up to 2.5rem inside a
	 * form field, so the heading sizing is left to the shared remarks stylesheet.
	 *
	 * @param {string} pContent - The rendered content.
	 * @return {string} - The content, unchanged.
	 */
	addBulmaFlavor(pContent)
	{
		return pContent;
	}

	/**
	 * Puts the shared remarks styling in the page. Done on first render rather than in the
	 * constructor, because providers are attached before the document is ready.
	 */
	registerRemarksCSS()
	{
		if (this._remarksCSSRegistered || !this.pict.CSSMap)
		{
			return;
		}
		this._remarksCSSRegistered = true;
		this.pict.CSSMap.addCSS('Headlight-Markdown-Remarks', libUserMarkdown.RemarksCSS, 500, 'Bulma-MarkdownDisplay');
		this.pict.CSSMap.injectCSS();
		libUserMarkdown.watchRemarksTruncation();
	}

	/**
	 * The parent only writes to the display element when there is content, which would leave the
	 * previous remark on screen after the value is cleared. Emptying it first keeps the field honest.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The input value.
	 */
	clearDisplayWhenEmpty(pInput, pValue)
	{
		if (!this.getInputContent(pInput, pValue))
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), '');
		}
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.registerRemarksCSS();
		this.clearDisplayWhenEmpty(pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.registerRemarksCSS();
		this.clearDisplayWhenEmpty(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"./PictProvider-Bulma-Markdown.js":30,"./_UserMarkdown.js":144}],32:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const BulmaHTMLInputHandler = require('./PictProvider-Bulma-HTML.js');

/**
 * Renders a scannable QR code image into an input's display container from a QR code value.
 *
 * Subclasses the Bulma-HTML extension so it inherits the DISPLAY-FOR container plumbing (single
 * and tabular) and only swaps the content generation: the value (a Sample.QRCode string) is turned
 * into an <img> via QRCodeProvider.create. That path is fully offline — a canvas drawn by the
 * bundled window.QRCode library, no network round-trip — so the code is scannable on a sample that
 * has not been saved yet.
 *
 * @class
 * @extends BulmaHTMLInputHandler
 * @memberof providers.inputs
 */
class MaterialsQRCodeDisplayInputHandler extends BulmaHTMLInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Build the <img> HTML for a QR code value, or null when there is nothing to render (the base
	 * class skips assignment on a falsy return, leaving the template's "no QR code" message).
	 *
	 * @param {Object} pInput - The input descriptor (reads PictForm.QRCodeSize, default 192px).
	 * @param {any} pValue - The QR code value (a Sample.QRCode string).
	 * @return {string|null}
	 */
	getInputContent(pInput, pValue)
	{
		if (!pValue || typeof pValue !== 'string')
		{
			return null;
		}
		const tmpQRCodeProvider = this.pict.providers.QRCodeProvider;
		if (!tmpQRCodeProvider || typeof tmpQRCodeProvider.create !== 'function')
		{
			return null;
		}
		const tmpSize = (pInput && pInput.PictForm && pInput.PictForm.QRCodeSize) || 192;
		try
		{
			const tmpSource = tmpQRCodeProvider.create(pValue, { size: tmpSize });
			return `<img src="${tmpSource}" alt="Sample QR Code" style="width:${tmpSize}px;height:${tmpSize}px;" />`;
		}
		catch (pError)
		{
			this.pict.log.warn(`MaterialsQRCodeDisplay could not render a QR code: ${pError.message || pError}`);
			return null;
		}
	}

	/**
	 * Toggle the template's EMPTY-MESSAGE vs DISPLAY container after (re)assigning content. The
	 * `{~ShowContent~}`/`{~HideContent~}` classes are baked at render time from the value as it was
	 * THEN; the Sample QRCode is synthesized AFTER first render, so without this the field stays on
	 * "No QR code available" even once the value (and the <img>) have arrived in the DISPLAY div.
	 *
	 * @param {Object} pInput
	 * @param {boolean} pHasContent
	 * @return {void}
	 */
	_setContentVisibility(pInput, pHasContent)
	{
		const tmpRawHTMLID = pInput && pInput.Macro && pInput.Macro.RawHTMLID;
		if (!tmpRawHTMLID || typeof document === 'undefined')
		{
			return;
		}
		const tmpDisplay = document.getElementById(`DISPLAY-FOR-${tmpRawHTMLID}`);
		const tmpEmpty = document.getElementById(`EMPTY-MESSAGE-FOR-${tmpRawHTMLID}`);
		if (tmpDisplay)
		{
			tmpDisplay.classList.toggle('is-hidden', !pHasContent);
		}
		if (tmpEmpty)
		{
			tmpEmpty.classList.toggle('is-hidden', !!pHasContent);
		}
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pRow
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {boolean}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._setContentVisibility(pInput, !!(pValue && String(pValue).trim()));
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pRow
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._setContentVisibility(pInput, !!(pValue && String(pValue).trim()));
		return tmpResult;
	}
}

module.exports = MaterialsQRCodeDisplayInputHandler;

},{"./PictProvider-Bulma-HTML.js":29}],33:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const ScopedEntityData = require('./_ScopedEntityData.js');

class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { HeadlightPopover: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.pict.MetaTemplate.addPattern('{~HideRecordSetControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hideRecordSetControls = false;
			if (tmpDataObject && tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				// if we find 'HideRecordSetControls' or 'Hide RecordSet Controls' in the GroupExtra string, hide the record set controls manually
				// NOTE: We also support 'Hide Table Controls' and 'HideTableControls' for backward compatibility with the TableControls provider since Table controls is the common name for both tables and record sets
				if ([ 'HideRecordSetControls', 'Hide RecordSet Controls', 'Hide Record Set Controls', 'HideTableControls', 'Hide Table Controls' ].some((i) => tmpDataObject.GroupExtra.includes(i)))
				{
					hideRecordSetControls = true;
				}
			}
			else if (tmpDataObject.MinimumRowCount && tmpDataObject.MaximumRowCount)
			{
				hideRecordSetControls = tmpDataObject.MinimumRowCount >= tmpDataObject.MaximumRowCount;
			}
			return (hideRecordSetControls) ? 'hide-recordset-controls' : '';
		});
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getRecordSetHTMLID(pInputHTMLID)
	{
		return `#RECORDSET-FOR-${pInputHTMLID}`;
	}
	getRecordSetWrapperHTMLID(pInputHTMLID)
	{
		return `#RECORDSET-WRAPPER-FOR-${pInputHTMLID}`;
	}

	/**
	 * Tombstone the rows the row's selectors own before the row is spliced away.
	 *
	 * Row deletion is the one removal route with no input-level seam: `deleteDynamicTableRow` splices
	 * the record set and notifies nothing, so each selector in the row is asked for its owned rows here,
	 * the last point at which they still exist.
	 *
	 * @param {Object} pView - The dynamic-form view owning the row.
	 * @param {Record<string, any>} pGroup - The group descriptor (for its RecordSetAddress).
	 * @param {number|string} pRowIndex - The row about to be deleted.
	 * @return {number} - How many tombstones were staged.
	 */
	stageRowRemovalTombstones(pView, pGroup, pRowIndex)
	{
		if (!ScopedEntityData.isEnabled(this.pict))
		{
			return 0;
		}
		const tmpRemovals = ScopedEntityData.collectRowSelectorRemovals(this.pict, pView, pGroup, pRowIndex);
		if (tmpRemovals.length < 1)
		{
			return 0;
		}
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, ScopedEntityData.DEFAULT_CONTEXT, tmpRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`Bulma-RecordSetControls: staged deletion of ${tmpResult.Staged.length} record(s) with row ${pRowIndex} of [${pGroup.RecordSetAddress}].`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * Handle a record set action from a dropdown menu.
	 * @param {string} pAction - The action to perform.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {number} pGroupIndex - The group number of the table row.
	 * @param {string} pRowIndex - The key of the table row.
	 * @return {boolean} - True if the action was successful, false otherwise.
	 */
	handleRecordSetMenuButtonEvent(pAction, pViewHash, pGroupIndex, pRowIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		// handle toast notifications for table row actions based on min/max row counts
		if (pAction === 'Delete')
		{
			if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
			{
				this.pict.log.error(`Cannot delete record set, minimum set count reached: ${tmpGroup.MinimumRowCount}`);
				this.pict.views.HeadlightPanels.toast({
					message: `Cannot delete record set, minimum set count reached: ${tmpGroup.MinimumRowCount}`,
					type: 'is-warning',
				});
				this.fable.HeadlightPopover.hideAll();
				return false;
			}
			this.stageRowRemovalTombstones(tmpView, tmpGroup, pRowIndex);
			this.pict.views[pViewHash].deleteDynamicTableRow(pGroupIndex, pRowIndex);
		}
		else if (pAction === 'MoveUp')
		{
			const tmpRowIndex = parseInt(String(pRowIndex), 10);
			if (tmpRowIndex == 0)
			{
				this.pict.log.error(`Cannot move record set up, already at the top: ${tmpRowIndex}`);
				this.pict.views.HeadlightPanels.toast({
					message: `Cannot move record set up, already at the top.`,
					type: 'is-warning',
				});
				this.fable.HeadlightPopover.hideAll();
				return false;
			}
			this.pict.views[pViewHash].moveDynamicTableRowUp(pGroupIndex, pRowIndex);
		}
		else if (pAction === 'MoveDown')
		{
			const tmpRowIndex = parseInt(String(pRowIndex), 10);
			if (tmpRowIndex == (tmpDestinationObject.length - 1))
			{
				this.pict.log.error(`Cannot move record set down, already at the bottom: ${tmpRowIndex}`);
				this.pict.views.HeadlightPanels.toast({
					message: `Cannot move record set down, already at the bottom.`,
					type: 'is-warning',
				});
				this.fable.HeadlightPopover.hideAll();
				return false;
			}
			this.pict.views[pViewHash].moveDynamicTableRowDown(pGroupIndex, pRowIndex);
		}
		else
		{
			this.pict.log.error(`Unknown action: ${pAction}`);
		}
		// Update any necessary controls
		this.prepareAnyExtraRecordSetControls();
		// Hide the popover menu after the action is performed
		this.fable.HeadlightPopover.hideAll();
		return true;
	}

	/**
	 * Enable/disable each record set's "Add new set" button(s) against MaximumRowCount.
	 *
	 * Previously selected `button[data-recordset-controls="add-set"]`, but that
	 * attribute sits on the wrapping <div>, not on the button -- so this matched
	 * nothing and RecordSet groups were never actually capped. Select on
	 * `data-max-sets` instead: only add buttons carry it, it picks up both the
	 * bottom bar and the opt-in top bar, and it will not catch the entry-mode
	 * toggle button that shares the same wrapper.
	 */
	prepareAnyExtraRecordSetControls()
	{
		const tmpEntryControls = this.getEntryControlsProvider();
		const tmpRecordSetWrappers = document.querySelectorAll('.section-recordset-wrapper');
		tmpRecordSetWrappers.forEach((pWrapper) =>
		{
			const tmpAddButtons = pWrapper.querySelectorAll('button[data-max-sets]');
			if (!tmpAddButtons.length || !tmpEntryControls)
			{
				return;
			}
			const tmpEntryCount = pWrapper.querySelectorAll('.RecordSetEntry').length;
			tmpEntryControls.applyAddButtonRowLimit(tmpAddButtons, tmpEntryCount, 'data-max-sets', 'data-min-sets');
		});
		// recalculate responsive UI adjustments for label alignments, etc.
		this.pict.providers.ResponsiveUIAdjustmentProvider.onWindowResize();
	}

	/**
	 * The shared entry-controls engine. Every knob (add-bar position, modal
	 * entry, entry point, the inline/modal toggle) is implemented once in
	 * Bulma-TableControls and driven from here for RecordSet groups -- including
	 * the three MetaTemplate macros, which are registered there and NEVER also
	 * here (a second addPattern on the same pattern silently shadows the first).
	 * @return {Object|null} - The Bulma-TableControls provider, or null.
	 */
	getEntryControlsProvider()
	{
		const tmpProvider = this.pict.providers['Bulma-TableControls'];
		if (!tmpProvider || (typeof tmpProvider.handleAddEntryButtonClickEvents !== 'function'))
		{
			this.pict.log.error('Bulma-RecordSetControls could not resolve the Bulma-TableControls entry-controls provider.');
			return null;
		}
		return tmpProvider;
	}

	/**
	 * The single entry point for both add bars on a RecordSet group. With no
	 * `EntryControls` on the group this reproduces exactly what the template's
	 * onclick used to inline: create the set, then the post-add fixups.
	 * @param {Event} pEvent - The click event.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True when an entry was started.
	 */
	handleAddEntryButtonClickEvents(pEvent, pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`Entry controls could not resolve view [${pViewHash}].`);
			return false;
		}
		const tmpEntryControls = this.getEntryControlsProvider();
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		if (!tmpEntryControls || !tmpEntryControls.getEntryControlsConfig(tmpGroup))
		{
			// Legacy path.
			tmpView.createDynamicTableRow(pGroupIndex);
			this.handleAddRowButtonClickEvents(pEvent);
			return true;
		}
		return tmpEntryControls.handleAddEntryButtonClickEvents(pEvent, pViewHash, pGroupIndex);
	}

	/**
	 * Flip a RecordSet group between inline and modal entry.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True on success.
	 */
	toggleEntryMode(pViewHash, pGroupIndex)
	{
		const tmpEntryControls = this.getEntryControlsProvider();
		if (!tmpEntryControls)
		{
			return false;
		}
		return tmpEntryControls.toggleEntryMode(pViewHash, pGroupIndex);
	}

	/**
	 * Handle the click event for the "Add Row" button in a set.
	 * NOTE: This is a secondary call to prepare any extra set controls after the row is added/rendered - it doesn't actually add the row (that is handled by the Pict Provider).
	 * @param {Event} event - The click event.
	 */
	handleAddRowButtonClickEvents(event)
	{
		setTimeout(() =>
		{
			// Update any necessary controls
			this.prepareAnyExtraRecordSetControls();
		}, 100);
	}
}

module.exports = CustomInputHandler;

},{"./_ScopedEntityData.js":139,"pict-section-form":497}],34:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const ScopedEntityData = require('./_ScopedEntityData.js');

// CSS for the Headlight "hide column in PDF only" toggle injected into each row of the
// pict-section-form ColumnChooser popover (opted-in groups only). The eye icon is the
// PDF visibility state; the row's existing checkbox remains the interactive (HTML) visibility.
const _PDFColumnChooserCSS = /*css*/`
	.pict-tabular-colchooser-row.has-pdf-toggle { justify-content: space-between; }
	.pict-tabular-colchooser-row.has-pdf-toggle .colchooser-html-label { display: inline-flex; align-items: center; gap: 0.5rem; flex: 1 1 auto; min-width: 0; cursor: pointer; }
	.pict-tabular-colchooser-row.has-pdf-toggle .colchooser-html-label span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.colchooser-pdf-toggle { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.1rem; cursor: pointer;
		border: 1px solid transparent; background: transparent; border-radius: 6px; padding: 0.1rem 0.3rem;
		color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; }
	.colchooser-pdf-toggle:hover:not([disabled]) { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
	.colchooser-pdf-toggle.is-pdf-hidden { color: var(--bulma-danger, #c0392b); }
	.colchooser-pdf-toggle[disabled] { opacity: 0.4; cursor: not-allowed; }
	.colchooser-pdf-toggle .icon { margin: 0; }
`;

// Theme tokens aren't loaded on form surfaces, so the light fallbacks above would show in dark mode. Same three dark
// signals as pict-section-form's ColumnChooser dark rules (Pict-Layout-Tabular.js); keep the two in step.
const _PDFColumnChooserDarkRules = (pScope) => /*css*/`
	${pScope} .colchooser-pdf-toggle { color: var(--theme-color-text-muted, #8b95a4); }
	${pScope} .colchooser-pdf-toggle:hover:not([disabled]) { background: var(--theme-color-background-tertiary, #2c3542); color: var(--theme-color-text-primary, #e6e9ee); }
`;
const _PDFColumnChooserDarkCSS = _PDFColumnChooserDarkRules('[data-theme="dark"]')
	+ _PDFColumnChooserDarkRules('.theme-dark')
	+ `@media (prefers-color-scheme: dark) {` + _PDFColumnChooserDarkRules('html:not([data-theme="light"])') + `}`;

// A group with `GroupExtra: "Hide Table Controls"` still reserved the height of the
// controls row (~21px of dead space under the last data row). The wrapper gets
// `.hide-table-controls`, but the existing rule in bulma-table.scss only reaches
// elements carrying `[data-table-controls]` -- and the controls ROW and its two
// `.column` children carry no such attribute, so they kept rendering.
//
// Collapse the row, but ONLY while the scroll slider inside it is hidden. That
// slider is deliberately exempt from `.hide-table-controls` so a WIDE table with
// controls hidden can still be scrolled; blanket-hiding the row would take that
// away. `:has()` re-evaluates when prepareAnyExtraTableControls() reveals the
// slider, so the row returns exactly when it is needed.
//
// Lives here rather than in headlight-styles.scss so the fix ships with the bundle
// rebuild instead of regenerating headlight-styles.css, which has to be coordinated
// with the in-flight Select2 -> Pict-Section-Picker migration.
const _HiddenTableControlsCSS = /*css*/`
	.hide-table-controls .columns:has([data-table-controls="scroll-slider"].is-hidden) { display: none; }
`;


// ─────────────────────────────────────────────────────────────────────────
// Entry controls (opt-in per group via `Group.EntryControls`)
//
// Long Tabular / RecordSet groups are frequently several viewport-heights
// tall, and the only "Add" button lives BELOW the whole group -- so adding an
// entry means scrolling to the bottom and back. `EntryControls` lets a form
// author put the add bar at the top, open the new entry in a modal, and/or
// prepend rather than append. Every knob is opt-in: a group with no
// `EntryControls` renders exactly the markup it did before this existed.
//
// NOTE: `EntryControls.Position` is the ADD BAR. It is orthogonal to the
// pict-section-form group option `EditingControlsPosition`, which positions
// the per-row del/up/down menu COLUMN (left/right/hidden). Similar names,
// different controls.
// ─────────────────────────────────────────────────────────────────────────
const _EntryControlsDefaults =
{
	Position: 'bottom',
	EntryPoint: 'end',
	Mode: 'inline',
	AllowModeToggle: false,
	RowThreshold: 10,
	ViewportMultiple: 3,
	ModalTitle: '',
	ModalWidth: 'min(1100px, 92vw)',
	ModalColumns: 1,
};

// localStorage key prefix for the per-user inline/modal preference. Bump the
// version segment if the stored shape ever changes.
const _ENTRY_MODE_STORAGE_PREFIX = 'Headlight.EntryMode.v1';

const _EntryControlsCSS = /*css*/`
	.pict-entry-mode-toggle { margin-right: 0.5rem; }
	.pict-entry-modal-body { max-height: min(70vh, 720px); overflow-y: auto; }
	.pict-entry-modal-body .columns { margin: 0; }
	.pict-entry-modal-body .column { padding: 0.4rem 0.6rem; }
	.pict-entry-modal-body .label { margin-bottom: 0.25rem; }
	.pict-entry-modal-body .help { margin-top: 0.15rem; }
	.pict-entry-modal-field--chooser-hidden > .label::after { content: ' (hidden in table)'; font-weight: 400; opacity: 0.7; font-size: 0.8em; }
`;

// Escape a manifest-authored string for safe interpolation into a template's
// text node. The value comes from form config rather than user data, but these
// templates are assembled as HTML strings, so escaping is the mitigation --
// see the same idiom in HeadlightDynamicInputsBundle's {~LabelWithChips:~}.
const _escapeTemplateText = (pString) => String(pString == null ? '' : pString)
	.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { HeadlightPopover: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.pict.MetaTemplate.addPattern('{~HideTableControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hideTableControls = false;
			if (tmpDataObject && tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				// if we find 'HideTableControls' or 'Hide Table Controls' in the GroupExtra string, hide the table controls manually
				if ([ 'HideTableControls', 'Hide Table Controls' ].some((i) => tmpDataObject.GroupExtra.includes(i)))
				{
					hideTableControls = true;
				}
			}
			else if (tmpDataObject.MinimumRowCount && tmpDataObject.MaximumRowCount)
			{
				hideTableControls = tmpDataObject.MinimumRowCount >= tmpDataObject.MaximumRowCount;
			}
			return (hideTableControls) ? 'hide-table-controls' : '';
		});

		// EditingControlsPosition 'hidden' has no menu column to toggle, so hide the
		// toggle button (Bulma 'is-hidden'). Record is the group descriptor.
		this.pict.MetaTemplate.addPattern('{~HideMenuColumnToggle:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			if (tmpDataObject && (tmpDataObject.EditingControlsPosition === 'hidden'))
			{
				return 'is-hidden';
			}
			return '';
		});

		// Per-group copy for the tabular "no rows" placeholder row. The row itself
		// and its show/hide are not ours -- the Group-Postfix template always emits
		// `tr.table-emtpy-row` (sic) last in the tbody and bulma-table.scss hides it
		// via `:not(:first-child)`. Only the WORDING was a hardcoded literal, so a
		// manifest had no way to explain why a particular table is empty.
		//
		// Body is `<address>:<default copy>`, split on the FIRST colon -- the default
		// is each theme's existing literal, so a group that does not opt in renders
		// byte-identically to before this macro existed.
		this.pict.MetaTemplate.addPattern('{~TabularEmptyMessage:', '~}', (pHash, pData, fCallback) =>
		{
			return this.resolveTabularEmptyMessage(pHash, pData, fCallback);
		});

		// 'left' controls: the framework's {~TEC:~} cell emits bare del/up/down links;
		// override it to reuse our right-side menu button so both positions match.
		this.overrideTabularEditingControlsRenderer();

		// Register CSS for the PDF-only column-hide toggle injected into the chooser popover.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Headlight-Tabular-PDFColumnChooser-CSS', _PDFColumnChooserCSS + _PDFColumnChooserDarkCSS, 500);
			this.pict.CSSMap.addCSS('Headlight-Tabular-HiddenControls-CSS', _HiddenTableControlsCSS, 500);
		}

		// "Hide column in PDF (Print theme) only" — opt-in via group ColumnChooser.SelectPDFOnlyColumns.
		this.overrideColumnChooserForPDF();

		// ── Entry controls ────────────────────────────────────────────────
		// These three macros are registered HERE ONLY, never also in
		// Bulma-RecordSetControls: both providers are always attached together
		// and a second addPattern() on the same pattern silently shadows the
		// first. The RecordSet templates consume the same macros.

		// Top add bar: hidden unless the group opted into 'top' or 'both'.
		this.pict.MetaTemplate.addPattern('{~HideTopEntryControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpConfig = this.getEntryControlsConfig(this.pict.resolveStateFromAddress(pHash, pData, fCallback));
			return (tmpConfig && ((tmpConfig.Position === 'top') || (tmpConfig.Position === 'both'))) ? '' : 'is-hidden';
		});

		// Bottom add bar: visible unless the group explicitly moved it to 'top'.
		// The no-config case MUST return '' -- that is what keeps every existing
		// form rendering exactly as it does today.
		//
		// EXCEPT on a read-only table. `EditingControlsPosition: 'hidden'` already
		// removes the per-row del/up/down column and the menu-column toggle; a table
		// with no row controls is a report, and offering "Add new row" underneath it
		// is incoherent -- a reader clicks it and gets a blank row on a dashboard
		// that cannot save. The two express one intent, so the one flag drives both
		// rather than adding a second key nobody would remember to set.
		this.pict.MetaTemplate.addPattern('{~HideBottomEntryControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpGroup = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			if (tmpGroup && (tmpGroup.EditingControlsPosition === 'hidden'))
			{
				return 'is-hidden';
			}
			const tmpConfig = this.getEntryControlsConfig(tmpGroup);
			return (tmpConfig && (tmpConfig.Position === 'top')) ? 'is-hidden' : '';
		});

		// The inline/modal preference toggle. Emits nothing at all unless the
		// group set AllowModeToggle; when it does emit it starts hidden and
		// refreshEntryModeToggleVisibility() reveals it once the group is big
		// enough to be painful.
		// The whole opt-in TOP add bar (add button + mode toggle), or '' when the
		// group never opted in -- so untouched forms emit no extra markup.
		this.pict.MetaTemplate.addPattern('{~EntryAddBarTop:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpGroup = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// Same reasoning as the bottom bar: a read-only table has nothing to add to.
			if (tmpGroup && (tmpGroup.EditingControlsPosition === 'hidden'))
			{
				return '';
			}
			return this.renderEntryAddBarHTML(tmpGroup);
		});

		this.pict.MetaTemplate.addPattern('{~EntryModeToggleButton:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpGroup = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.renderEntryModeToggleHTML(tmpGroup);
		});

		// Column classes for one field cell inside the entry modal. Record is the
		// COLUMN DESCRIPTOR; buildModalRowTemplate stamps the two flags read here.
		// The modal deliberately does not honour per-descriptor PictForm.Width --
		// it is a stacked entry form, not the grid.
		this.pict.MetaTemplate.addPattern('{~EntryModalCellClass:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpInput = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const tmpPictForm = (tmpInput && tmpInput.PictForm) ? tmpInput.PictForm : {};
			let tmpClasses = tmpPictForm._EntryModalHalfWidth ? 'is-6' : 'is-12';
			if (tmpPictForm._EntryModalChooserHidden)
			{
				tmpClasses += ' pict-entry-modal-field--chooser-hidden';
			}
			return tmpClasses;
		});

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Headlight-Tabular-EntryControls-CSS', _EntryControlsCSS, 500);
		}

		// While a modal entry is staged, suppress the tabular layout's mid-marshal
		// rebuild so the staged row never gets an inline DOM twin.
		this.overrideTabularMarshalForModalEntry();

		// The staged-entry record, or null. Only one modal entry at a time (the
		// modal itself is a singleton overlay).
		/** @type {{ViewHash: string, GroupIndex: number, StagedIndex: number, Committed: boolean, Dialog: any}|null} */
		this._modalEntryState = null;
	}

	/**
	 * Override the Tabular layout's left-controls renderer ({~TEC:~}) to use our menu
	 * button. Idempotent; no-op if the layout provider isn't registered.
	 */
	overrideTabularEditingControlsRenderer()
	{
		const tmpTabularLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpTabularLayout ||
			(typeof tmpTabularLayout._renderTabularEditingControlsHTML !== 'function') ||
			tmpTabularLayout._headlightEditingControlsOverridden)
		{
			return;
		}
		const tmpSelf = this;
		tmpTabularLayout._headlightEditingControlsOverridden = true;
		tmpTabularLayout._renderTabularEditingControlsHTML = function(pView, pGroupIndex, pRowKey)
		{
			return tmpSelf.renderTabularEditingControlsMenuCell(pView, pGroupIndex, pRowKey);
		};
	}

	// ─────────────────────────────────────────────────────────────────────────
	// "Hide column in PDF (Print theme) only"
	//
	// pict-section-form's ColumnChooser hides columns by NOT rendering them, driven
	// by a form-data array of column hashes at `<GroupHash>_HiddenColumns` (read via
	// Pict-Layout-Tabular._getTabularColumnChooserHiddenSet). That array hides a
	// column in EVERY theme. This Headlight feature adds a SECOND, parallel array,
	// `<GroupHash>_PDFHiddenColumns`, whose columns are hidden ONLY in the Print
	// theme — and unions it into the effective hidden set at render time when (and
	// only when) we are rendering non-interactively. Because the union always
	// includes the base (interactive) hidden set, an interactively-hidden column is
	// necessarily hidden in the PDF too (HTML-hide cascades to PDF; PDF-hide is the
	// lower-priority, additive layer). Nothing is written to pict-section-form.
	//
	// Opt-in: a tabular group sets `ColumnChooser: { SelectPDFOnlyColumns: true }`.
	// Per-column default: a descriptor sets `PictForm.TabularPDFDefaultHidden: true`.
	// ─────────────────────────────────────────────────────────────────────────

	/**
	 * The absolute form-data address of a group's PDF-only hidden-column-hash array.
	 * Mirrors Pict-Layout-Tabular._getTabularHiddenColumnsAddress; defaults to
	 * `<GroupHash>_PDFHiddenColumns`, overridable via ColumnChooser.PDFDataAddress.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @return {string} - The absolute address.
	 */
	getPDFHiddenColumnsAddress(pView, pGroup)
	{
		const tmpChooser = (pGroup && pGroup.ColumnChooser) || {};
		const tmpDataAddress = (typeof tmpChooser.PDFDataAddress === 'string' && tmpChooser.PDFDataAddress.length > 0) ?
			tmpChooser.PDFDataAddress :
			`${pGroup.Hash}_PDFHiddenColumns`;
		return `${pView.getMarshalDestinationAddress()}.${tmpDataAddress}`;
	}

	/**
	 * The set of column hashes hidden-in-PDF BY DEFAULT for a group: the group's
	 * `ColumnChooser.PDFDefaultHiddenColumns` array plus every choosable descriptor
	 * flagged `PictForm.TabularPDFDefaultHidden`. Mirrors the framework's
	 * `_getTabularColumnChooserDefaultHidden` (which merges `DefaultHiddenColumns`
	 * with per-descriptor `TabularDefaultHidden`). Applies only until the user makes
	 * an explicit choice (which writes an array to form data).
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @return {Array<string>} - Array of column hashes.
	 */
	getPDFDefaultHidden(pGroup)
	{
		const tmpDefaults = {};
		// group-level list (raw ColumnChooser config, same place SelectPDFOnlyColumns lives)
		const tmpChooser = (pGroup && pGroup.ColumnChooser) || {};
		if (Array.isArray(tmpChooser.PDFDefaultHiddenColumns))
		{
			for (let i = 0; i < tmpChooser.PDFDefaultHiddenColumns.length; i++)
			{
				tmpDefaults[String(tmpChooser.PDFDefaultHiddenColumns[i])] = true;
			}
		}
		// per-descriptor flags
		const tmpManifest = pGroup && pGroup.supportingManifest;
		if (tmpManifest && Array.isArray(tmpManifest.elementAddresses))
		{
			for (let k = 0; k < tmpManifest.elementAddresses.length; k++)
			{
				const tmpHash = String(tmpManifest.elementAddresses[k]);
				const tmpDescriptor = tmpManifest.elementDescriptors[tmpHash];
				if (tmpDescriptor && tmpDescriptor.PictForm &&
					!tmpDescriptor.PictForm.TabularHidden &&
					tmpDescriptor.PictForm.TabularPDFDefaultHidden === true)
				{
					tmpDefaults[tmpHash] = true;
				}
			}
		}
		return Object.keys(tmpDefaults);
	}

	/**
	 * The EFFECTIVE set of PDF-only-hidden column hashes for a group: the array
	 * stored in form data when the user has chosen, otherwise the configured
	 * defaults. This is the explicit "hide in PDF" layer only — it does NOT include
	 * the interactive hidden set (the union happens in the layout override).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @return {Set<string>} - Set of column hashes.
	 */
	getPDFHiddenColumnsSet(pView, pGroup)
	{
		const tmpStored = this.pict.resolveStateFromAddress(this.getPDFHiddenColumnsAddress(pView, pGroup));
		const tmpList = Array.isArray(tmpStored) ? tmpStored : this.getPDFDefaultHidden(pGroup);
		const tmpSet = new Set();
		for (let i = 0; i < tmpList.length; i++)
		{
			tmpSet.add(String(tmpList[i]));
		}
		return tmpSet;
	}

	/**
	 * Union the PDF-only hidden columns into a base (interactive) hidden set. Returns
	 * a NEW set so the caller's base set is never mutated.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @param {Set<string>} pBaseSet - The interactive hidden set.
	 * @return {Set<string>} - base ∪ PDF-only.
	 */
	unionPDFHiddenColumns(pView, pGroup, pBaseSet)
	{
		const tmpResult = new Set(pBaseSet);
		const tmpPDFSet = this.getPDFHiddenColumnsSet(pView, pGroup);
		tmpPDFSet.forEach((pHash) => tmpResult.add(pHash));
		return tmpResult;
	}

	/**
	 * Install the two Headlight overrides on the singleton Pict-Layout-Tabular
	 * provider (same monkey-patch pattern as overrideTabularEditingControlsRenderer):
	 *   1. _getTabularColumnChooserHiddenSet — union the PDF-only set when rendering
	 *      non-interactively (Print theme) for opted-in groups.
	 *   2. _renderTabularColumnChooserPopover — add a per-row PDF-hide toggle to the
	 *      chooser menu for opted-in groups.
	 * Idempotent; no-op if the layout provider isn't registered.
	 */
	overrideColumnChooserForPDF()
	{
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout ||
			(typeof tmpLayout._getTabularColumnChooserHiddenSet !== 'function') ||
			(typeof tmpLayout._renderTabularColumnChooserPopover !== 'function') ||
			tmpLayout._headlightPDFColumnChooserOverridden)
		{
			return;
		}
		const tmpSelf = this;
		tmpLayout._headlightPDFColumnChooserOverridden = true;

		// 1) Union PDF-only hidden columns into the effective hidden set — Print theme only.
		const fOriginalHiddenSet = tmpLayout._getTabularColumnChooserHiddenSet;
		tmpLayout._getTabularColumnChooserHiddenSet = function(pView, pGroup)
		{
			const tmpBaseSet = fOriginalHiddenSet.call(this, pView, pGroup);
			// Falsy base = chooser disabled (preserve legacy path). Interactive = no PDF
			// hiding. No opt-in = feature dormant. In all three, return the base untouched.
			if (!tmpBaseSet ||
				tmpSelf.pict.AppData.Interactive ||
				!(pGroup && pGroup.ColumnChooser && pGroup.ColumnChooser.SelectPDFOnlyColumns))
			{
				return tmpBaseSet;
			}
			return tmpSelf.unionPDFHiddenColumns(pView, pGroup, tmpBaseSet);
		};

		// 2) Add the per-row PDF-hide toggle to the chooser popover — opted-in groups only.
		const fOriginalPopover = tmpLayout._renderTabularColumnChooserPopover;
		tmpLayout._renderTabularColumnChooserPopover = function(pView, pGroup)
		{
			if (!(pGroup && pGroup.ColumnChooser && pGroup.ColumnChooser.SelectPDFOnlyColumns))
			{
				return fOriginalPopover.call(this, pView, pGroup);
			}
			return tmpSelf.renderColumnChooserPopoverWithPDF(this, pView, pGroup);
		};

		// 3) "Reset to defaults" must also reset the PDF-only hidden set (not just the
		// interactive hidden set). Write the PDF defaults BEFORE the framework reset so its
		// rebuild + popover repaint already reflect the cleared PDF indicators.
		if (typeof tmpLayout.resetTabularColumnVisibility === 'function')
		{
			const fOriginalReset = tmpLayout.resetTabularColumnVisibility;
			tmpLayout.resetTabularColumnVisibility = function(pViewHash, pGroupIndex)
			{
				const tmpView = tmpSelf.pict.views[pViewHash];
				const tmpGroup = (tmpView && tmpView.sectionDefinition && Array.isArray(tmpView.sectionDefinition.Groups)) ?
					tmpView.sectionDefinition.Groups[Number(pGroupIndex)] :
					null;
				if (tmpGroup && tmpGroup.ColumnChooser && tmpGroup.ColumnChooser.SelectPDFOnlyColumns)
				{
					tmpSelf.pict.setStateValueAtAddress(tmpSelf.getPDFHiddenColumnsAddress(tmpView, tmpGroup), null, tmpSelf.getPDFDefaultHidden(tmpGroup));
				}
				return fOriginalReset.call(this, pViewHash, pGroupIndex);
			};
		}
	}

	/**
	 * Render the ColumnChooser popover for an opted-in group: the framework's
	 * backdrop + panel + reset footer, but each column row carries the existing
	 * HTML show/hide checkbox AND a Headlight PDF-hide toggle. Replicates the
	 * framework markup (Pict-Layout-Tabular._renderTabularColumnChooserPopover) so
	 * the menu looks and behaves identically apart from the extra toggle.
	 * @param {Object} pLayout - The Pict-Layout-Tabular provider (override `this`).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 */
	renderColumnChooserPopoverWithPDF(pLayout, pView, pGroup)
	{
		const tmpColumns = pLayout._getTabularChoosableColumns(pView, pGroup);
		const tmpPDFSet = this.getPDFHiddenColumnsSet(pView, pGroup);
		let tmpRowsHTML = '';
		for (let i = 0; i < tmpColumns.length; i++)
		{
			const tmpColumn = tmpColumns[i];
			const tmpHTMLHidden = !tmpColumn.Visible;
			const tmpExplicitPDFHidden = tmpPDFSet.has(tmpColumn.Key);
			// Effective: a column hidden interactively is necessarily hidden in PDF.
			const tmpPDFHidden = tmpHTMLHidden || tmpExplicitPDFHidden;
			tmpRowsHTML += this.renderColumnChooserRowHTML(pLayout, pView, pGroup, tmpColumn, tmpHTMLHidden, tmpPDFHidden, tmpExplicitPDFHidden);
		}
		const tmpPopoverHTML = `<div class="pict-tabular-colchooser-backdrop" onclick="_Pict.providers['Pict-Layout-Tabular'].closeTabularColumnChooser('${pView.Hash}', ${pGroup.GroupIndex})"></div>` +
			`<div class="pict-tabular-colchooser-panel">` +
			`<div class="pict-tabular-colchooser-list">${tmpRowsHTML}</div>` +
			`<div class="pict-tabular-colchooser-footer">` +
			`<button type="button" class="pict-tabular-colchooser-reset" onclick="_Pict.providers['Pict-Layout-Tabular'].resetTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex})">Reset to defaults</button>` +
			`</div>` +
			`</div>`;
		this.pict.ContentAssignment.assignContent(`#${pLayout._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}`, tmpPopoverHTML);
	}

	/**
	 * Build one chooser row: the framework's HTML show/hide checkbox plus the
	 * Headlight PDF-hide toggle. The PDF toggle is disabled (locked) when the column
	 * is hidden in the interactive view, since that already forces it hidden in PDF.
	 * @param {Object} pLayout - The Pict-Layout-Tabular provider (for _escapeHTML).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @param {{Key: string, Name: string, ColumnIndex: number, Visible: boolean}} pColumn - The choosable column.
	 * @param {boolean} pHTMLHidden - Column hidden in the interactive (HTML) view.
	 * @param {boolean} pPDFHidden - Column effectively hidden in PDF (HTML-hidden OR PDF-hidden).
	 * @param {boolean} pExplicitPDFHidden - Column in the explicit PDF-only hidden set.
	 * @return {string} - The row HTML.
	 */
	renderColumnChooserRowHTML(pLayout, pView, pGroup, pColumn, pHTMLHidden, pPDFHidden, pExplicitPDFHidden)
	{
		const tmpName = pLayout._escapeHTML(pColumn.Name);
		// Same checkbox + handler the framework uses, so interactive show/hide is unchanged.
		const tmpCheckbox = `<label class="colchooser-html-label">` +
			`<input type="checkbox"${pColumn.Visible ? ' checked="checked"' : ''} ` +
			`onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumn.ColumnIndex}, this.checked)">` +
			`<span>${tmpName}</span>` +
			`</label>`;
		const tmpEyeIcon = pPDFHidden ? 'fa-eye-slash' : 'fa-eye';
		const tmpStateClass = pPDFHidden ? ' is-pdf-hidden' : '';
		const tmpDisabledAttr = pHTMLHidden ? ' disabled="disabled"' : '';
		const tmpTitle = pHTMLHidden ?
			'Hidden in all views (including PDF)' :
			(pExplicitPDFHidden ? 'Hidden in PDF — click to show in PDF' : 'Shown in PDF — click to hide in PDF');
		// Toggle target: flip the EXPLICIT PDF-only membership (cascade is read-only).
		const tmpNewHidden = String(!pExplicitPDFHidden);
		const tmpButton = `<button type="button" class="colchooser-pdf-toggle${tmpStateClass}"${tmpDisabledAttr} ` +
			`title="${tmpTitle}" aria-label="${tmpTitle}" ` +
			`onclick="_Pict.providers['Bulma-TableControls'].toggleTabularColumnPDFVisibility('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumn.ColumnIndex}, ${tmpNewHidden})">` +
			`<span class="icon is-small"><i class="fas fa-file-pdf" aria-hidden="true"></i></span>` +
			`<span class="icon is-small"><i class="fas ${tmpEyeIcon}" aria-hidden="true"></i></span>` +
			`</button>`;
		return `<div class="pict-tabular-colchooser-row has-pdf-toggle">${tmpCheckbox}${tmpButton}</div>`;
	}

	/**
	 * Inline-handler entry point for the PDF-hide toggle: add/remove a column from
	 * the group's PDF-only hidden set, persist it to form data, and repaint the
	 * popover (the interactive table is not rebuilt — its column set is unchanged).
	 * Refuses to hide the last column that would still print.
	 * @param {string} pViewHash - The view hash.
	 * @param {number|string} pGroupIndex - The tabular group index.
	 * @param {number|string} pColumnIndex - The column's manifest index.
	 * @param {boolean} pHidden - true to hide the column in PDF, false to show it.
	 * @return {boolean} - True on success.
	 */
	toggleTabularColumnPDFVisibility(pViewHash, pGroupIndex, pColumnIndex, pHidden)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		const tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !(tmpGroup.ColumnChooser && tmpGroup.ColumnChooser.SelectPDFOnlyColumns))
		{
			return false;
		}
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || (typeof tmpLayout._getTabularChoosableColumns !== 'function'))
		{
			return false;
		}
		const tmpColumns = tmpLayout._getTabularChoosableColumns(tmpView, tmpGroup);
		const tmpColumn = tmpColumns.find((pCandidate) => pCandidate.ColumnIndex === Number(pColumnIndex));
		if (!tmpColumn)
		{
			return false;
		}
		const tmpPDFSet = this.getPDFHiddenColumnsSet(tmpView, tmpGroup);
		if (pHidden)
		{
			// Don't let the last column that still prints be hidden — keep a non-empty PDF table.
			const tmpVisibleInPDF = tmpColumns.filter((pCandidate) => pCandidate.Visible && !tmpPDFSet.has(pCandidate.Key)).length;
			if (tmpVisibleInPDF <= 1 && tmpColumn.Visible && !tmpPDFSet.has(tmpColumn.Key))
			{
				this.pict.log.warn(`Headlight PDF column chooser on group [${tmpGroup.Hash}] refused to hide the last PDF-visible column [${tmpColumn.Key}].`);
				this.rerenderColumnChooserPopover(tmpView, tmpGroup);
				return false;
			}
			tmpPDFSet.add(tmpColumn.Key);
		}
		else
		{
			tmpPDFSet.delete(tmpColumn.Key);
		}
		this.pict.setStateValueAtAddress(this.getPDFHiddenColumnsAddress(tmpView, tmpGroup), null, Array.from(tmpPDFSet));
		this.rerenderColumnChooserPopover(tmpView, tmpGroup);
		return true;
	}

	/**
	 * Repaint a group's chooser popover and keep it open (mirrors what the framework
	 * toggle handlers do after a change).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 */
	rerenderColumnChooserPopover(pView, pGroup)
	{
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || (typeof tmpLayout._renderTabularColumnChooserPopover !== 'function'))
		{
			return;
		}
		tmpLayout._renderTabularColumnChooserPopover(pView, pGroup);
		if (typeof tmpLayout._paintTabularColumnChooserOpenState === 'function')
		{
			tmpLayout._paintTabularColumnChooserOpenState(pView, pGroup, true);
		}
	}

	/**
	 * Render the left-position editing-controls cell: the same menu button the
	 * right-side ('Postfix') controls use. Mirrors -TabularTemplate-Row-ExtraPostfix.
	 * @param {Object} pView - The form view.
	 * @param {number|string} pGroupIndex - The tabular group index.
	 * @param {number|string} pRowKey - The row key/index.
	 * @return {string} - The <td> editing-controls cell HTML.
	 */
	renderTabularEditingControlsMenuCell(pView, pGroupIndex, pRowKey)
	{
		if (!pView)
		{
			return '';
		}
		const tmpUUID = pView.UUID;
		const tmpViewHash = pView.Hash;
		const tmpButtonID = `TABLE-MENU-BUTTON-FOR-${tmpUUID}-${tmpViewHash}-${pGroupIndex}-${pRowKey}`;
		return `<td class="extra-table-column" data-table-controls="menu">` +
			`<button id="${tmpButtonID}" class="button is-link is-outlined" type="button" aria-haspopup="true"` +
			` onmouseover="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '${tmpUUID}', '${tmpViewHash}', '${pGroupIndex}', '${pRowKey}', event)"` +
			` onclick="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '${tmpUUID}', '${tmpViewHash}', '${pGroupIndex}', '${pRowKey}', event)">` +
			`<span class="icon is-small"><i class="fas fa-ellipsis" aria-hidden="true"></i></span>` +
			`</button>` +
			`</td>`;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getTableHTMLID(pInputHTMLID)
	{
		return `#TABLE-FOR-${pInputHTMLID}`;
	}
	getTableWrapperHTMLID(pInputHTMLID)
	{
		return `#TABLE-WRAPPER-FOR-${pInputHTMLID}`;
	}
	getTableSliderHTMLID(pInputHTMLID)
	{
		return `#TABLE-SLIDER-FOR-${pInputHTMLID}`;
	}
	getTableSliderWrapperHTMLID(pInputHTMLID)
	{
		return `#TABLE-SLIDER-WRAPPER-FOR-${pInputHTMLID}`;
	}

	/**
	 * Check if an element has scroll overflow.
	 * @param {string} pInputHTMLID - The HTML ID of the element.
	 * @return {boolean} - True if the element has scroll overflow, false otherwise.
	 */
	doesElementHaveScrollOverflow(pInputHTMLID)
	{
		const tmpTableElement = document.querySelector(this.getTableHTMLID(pInputHTMLID));
		const tmpTableWrapperElement = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		return tmpTableElement.scrollWidth > tmpTableWrapperElement.clientWidth ? true : false;
	}

	/**
	 * Tombstone the rows the row's selectors own before the row is spliced away.
	 *
	 * Row deletion is the one removal route with no input-level seam: `deleteDynamicTableRow` splices
	 * the record set and notifies nothing, so each selector in the row is asked for its owned rows here,
	 * the last point at which they still exist.
	 *
	 * @param {Object} pView - The dynamic-form view owning the row.
	 * @param {Record<string, any>} pGroup - The group descriptor (for its RecordSetAddress).
	 * @param {number|string} pRowIndex - The row about to be deleted.
	 * @return {number} - How many tombstones were staged.
	 */
	stageRowRemovalTombstones(pView, pGroup, pRowIndex)
	{
		if (!ScopedEntityData.isEnabled(this.pict))
		{
			return 0;
		}
		const tmpRemovals = ScopedEntityData.collectRowSelectorRemovals(this.pict, pView, pGroup, pRowIndex);
		if (tmpRemovals.length < 1)
		{
			return 0;
		}
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, ScopedEntityData.DEFAULT_CONTEXT, tmpRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`Bulma-TableControls: staged deletion of ${tmpResult.Staged.length} record(s) with row ${pRowIndex} of [${pGroup.RecordSetAddress}].`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * Handle a table row action from a dropdown menu.
	 * @param {string} pAction - The action to perform.
	 * @param {string} pGUID - The GUID of the table row.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {number} pGroupIndex - The group number of the table row.
	 * @param {string} pRowIndex - The key of the table row.
	 * @return {boolean} - True if the action was successful, false otherwise.
	 */
	handleTableMenuButtonEvent(pAction, pGUID, pViewHash, pGroupIndex, pRowIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		// Hide the popover menu before the action is performed to avoid visual glitches
		this.fable.HeadlightPopover.hideAll();
		// Perform the action after a short delay to allow the popover to hide properly and not UI jump to the top left of the screen
		setTimeout(() =>
		{
			// handle toast notifications for table row actions based on min/max row counts
			if (pAction === 'Delete')
			{
				if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
				{
					this.pict.log.error(`Cannot delete row, minimum row count reached: ${tmpGroup.MinimumRowCount}`);
					this.pict.views.HeadlightPanels.toast({
						message: `Cannot delete row, minimum row count reached: ${tmpGroup.MinimumRowCount}`,
						type: 'is-warning',
					});
					this.fable.HeadlightPopover.hideAll();
					return false;
				}
				this.stageRowRemovalTombstones(tmpView, tmpGroup, pRowIndex);
				this.pict.views[pViewHash].deleteDynamicTableRow(pGroupIndex, pRowIndex);
			}
			else if (pAction === 'MoveUp')
			{
				const tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == 0)
				{
					this.pict.log.error(`Cannot move row up, already at the top: ${tmpRowIndex}`);
					this.pict.views.HeadlightPanels.toast({
						message: `Cannot move row up, already at the top.`,
						type: 'is-warning',
					});
					this.fable.HeadlightPopover.hideAll();
					return false;
				}
				this.pict.views[pViewHash].moveDynamicTableRowUp(pGroupIndex, pRowIndex);
			}
			else if (pAction === 'MoveDown')
			{
				const tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == (tmpDestinationObject.length - 1))
				{
					this.pict.log.error(`Cannot move row down, already at the bottom: ${tmpRowIndex}`);
					this.pict.views.HeadlightPanels.toast({
						message: `Cannot move row down, already at the bottom.`,
						type: 'is-warning',
					});
					this.fable.HeadlightPopover.hideAll();
					return false;
				}
				this.pict.views[pViewHash].moveDynamicTableRowDown(pGroupIndex, pRowIndex);
			}
			else
			{
				this.pict.log.error(`Unknown action: ${pAction}`);
			}
			// Update any necessary controls
			this.prepareAnyExtraTableControls();
		}, 0);
		return true;
	}

	/**
	 * Add a dropdown menu to the toggle button for a table row.
	 * @param {string} pElementId - The ID of the element to attach the popover menu to.
	 * @param {string} pGUID - The GUID of the table row.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {number} pGroup - The group number of the table row.
	 * @param {string} pKey - The key of the table row.
	 * @param {Event} pEvent - The event that triggered the function.
	 */
	showMenuForTable(pElementId, pGUID, pViewHash, pGroup, pKey, pEvent)
	{
		const tmpMenuElement = document.getElementById(`TABLE-MENU-BUTTON-FOR-${pGUID}-${pViewHash}-${pGroup}-${pKey}`);
		if (!tmpMenuElement)
		{
			return;
		}

		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'PictProvider-Theme-Edit-TabularTemplate-RowHeader-ExtraPostfix-TableMenu',
			PopoverTemplateRecord:
				{
					UUID: pGUID,
					Hash: pViewHash,
					Group: pGroup,
					Key: pKey,
				},
			theme: 'dropdown',
			delay: [ 500, 0 ], // delay showing the menu to allow for click events to propagate, avoid accidental hover displays, etc.
		});
	}

	/**
	 * Show any slider controls for tables that have scroll overflow.
	 */
	prepareAnyExtraTableControls()
	{
		const tmpScrollTables = document.querySelectorAll('.section-table-wrapper table');

		this.pict.log.info(`Checking ${ tmpScrollTables.length } tables for scroll overflow...`);
		tmpScrollTables.forEach((pTable) =>
		{
			if (!pTable.id.startsWith('TABLE-FOR-'))
			{
				return;
			}
			const tmpHTMLID = pTable.id.replace('TABLE-FOR-', '');
			// add a slider control to the table if it has scroll overflow
			this.toggleScrollTableSlider(tmpHTMLID);
			// Enable/disable both add bars (the default bottom one and the opt-in top
			// one) against MaximumRowCount.
			//
			// NOTE the placeholder row's class really is 'table-emtpy-row' (sic) -- that
			// is what the group templates emit. This used to count every tbody row and
			// then subtract one via `tr:not(.table-empty-row)`, a selector whose spelling
			// matched nothing, so it happened to land on the right number only because
			// there is always exactly one placeholder. Exclude it directly instead.
			const currentNumRows = pTable.querySelectorAll('tbody tr:not(.table-emtpy-row)').length;
			this.applyAddButtonRowLimit(
				[ document.getElementById(`TABLE-ADD-BUTTON-FOR-${tmpHTMLID}`), document.getElementById(`TABLE-ADD-BUTTON-TOP-FOR-${tmpHTMLID}`) ],
				currentNumRows, 'data-max-rows', 'data-min-rows');
		});
		// reveal the inline/modal entry toggle on groups that have grown large enough
		this.refreshEntryModeToggleVisibility();
		// recalculate responsive UI adjustments for label alignments, etc.
		this.pict.providers.ResponsiveUIAdjustmentProvider.onWindowResize();
	}

	/**
	 * Toggle the slider control for a table that has scroll overflow.
	 * @param {string} pHTMLSelector - The HTML ID of the table.
	 */
	toggleScrollTableSlider(pHTMLSelector)
	{
		const tmpSliderElement = document.querySelector(this.getTableSliderWrapperHTMLID(pHTMLSelector));
		if (tmpSliderElement)
		{
			if (this.doesElementHaveScrollOverflow(pHTMLSelector))
			{
				this.pict.log.info(`Adding slider to overflow table ID: ${ pHTMLSelector }`);
				tmpSliderElement.classList.remove('is-hidden');
			}
			else
			{
				tmpSliderElement.classList.add('is-hidden');
			}
		}
	}

	/**
	 * Handle the click event for the "Toggle Extra Column" button in a table.
	 * @param {Event} event - The click event.
	 * @param {string} pInputHTMLID - The HTML ID of the table.
	 */
	handleToggleExtraColumnButtonClickEvents(event, pInputHTMLID)
	{
		const tmpButton = /** @type {HTMLButtonElement} */ (event.currentTarget);
		const tmpTableWrapperElement = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		if (tmpTableWrapperElement && tmpButton)
		{
			// find the parent '.section-table-wrapper' element and toggle the 'hide-extra-table-columns' class on it to show/hide the extra column via CSS
			const tmpSectionTableWrapperElement = tmpTableWrapperElement.closest('.section-table-wrapper');
			if (tmpSectionTableWrapperElement)
			{
				const isVisible = !tmpSectionTableWrapperElement.classList.contains('hide-extra-table-columns');
				if (isVisible)
				{
					tmpSectionTableWrapperElement.classList.add('hide-extra-table-columns');
					this.setMenuColumnToggleButtonContent(tmpButton, 'fa-eye', ' Show Menu Column');
				}
				else
				{
					tmpSectionTableWrapperElement.classList.remove('hide-extra-table-columns');
					this.setMenuColumnToggleButtonContent(tmpButton, 'fa-eye-slash', ' Hide Menu Column');
				}
				// recalculate responsive UI adjustments for label alignments, etc.
				this.pict.providers.ResponsiveUIAdjustmentProvider.onWindowResize();
			}
		}
	}

	/**
	 * Repopulate the show/hide menu-column toggle button with an icon + label via DOM
	 * nodes (not an HTML string).
	 * @param {HTMLButtonElement} pButton - The toggle button to repopulate.
	 * @param {string} pIconClass - The Font Awesome icon class (e.g. 'fa-eye').
	 * @param {string} pLabel - The button label (leading space preserved for icon spacing).
	 */
	setMenuColumnToggleButtonContent(pButton, pIconClass, pLabel)
	{
		const tmpIconSpan = document.createElement('span');
		tmpIconSpan.className = 'icon';
		const tmpIcon = document.createElement('i');
		tmpIcon.className = `fas ${pIconClass}`;
		tmpIcon.setAttribute('aria-hidden', 'true'); // decorative; label text carries meaning
		tmpIconSpan.appendChild(tmpIcon);

		const tmpLabelSpan = document.createElement('span');
		tmpLabelSpan.textContent = pLabel;

		// Clear via removeChild loop (replaceChildren isn't in this bundle's browserslist target).
		while (pButton.firstChild)
		{
			pButton.removeChild(pButton.firstChild);
		}
		pButton.appendChild(tmpIconSpan);
		pButton.appendChild(tmpLabelSpan);
	}

	/**
	 * Handle the scroll event for a table that has scroll overflow the user uses the slider control to scroll.
	 * @param {string} pInputHTMLID - The HTML ID of the table.
	 * @param {Event} pEvent - The event that triggered the function.
	 */
	updateScrollTableFromSliderEvent(pInputHTMLID, pEvent)
	{
		pEvent.preventDefault();
		pEvent.stopPropagation();
		//console.log('handleScrollTableBySliderEvent', pEvent.currentTarget.value);
		// make the slider and the table horizontally scroll together
		/** @type {HTMLDivElement} */
		const tmpTableWrapper = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		/** @type {HTMLTableElement} */
		const tmpTable = document.querySelector(this.getTableHTMLID(pInputHTMLID));
		/** @type {HTMLInputElement} */
		const tmpSlider = document.querySelector(this.getTableSliderHTMLID(pInputHTMLID));
		// @ts-ignore
		const sliderValue = Number(pEvent.currentTarget.value);
		// if the table and the slider are found, make them scroll together
		if (tmpTableWrapper && tmpTable && tmpSlider)
		{
			// scroll the table horizontally based on the slider value
			const maxScrollLeft = tmpTable.scrollWidth - tmpTableWrapper.clientWidth;
			const scrollLeft = (Number(sliderValue) / 100) * maxScrollLeft;
			tmpTableWrapper.scrollLeft = scrollLeft;
		}
	}

	/**
	 * Handle the scroll event for a table that has scroll overflow the user scrolls the table horizontally.
	 * @param {string} pInputHTMLID - The HTML ID of the table.
	 * @param {Event} pEvent - The event that triggered the function.
	 */
	updateSliderFromScrollTableEvent(pInputHTMLID, pEvent)
	{
		pEvent.preventDefault();
		pEvent.stopPropagation();
		//console.log('updateSliderFromScrollTableEvent', pEvent.currentTarget.scrollLeft);
		// make the slider and the table horizontally scroll together
		/** @type {HTMLDivElement} */
		const tmpTableWrapper = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		/** @type {HTMLTableElement} */
		const tmpTable = document.querySelector(this.getTableHTMLID(pInputHTMLID));
		/** @type {HTMLInputElement} */
		const tmpSlider = document.querySelector(this.getTableSliderHTMLID(pInputHTMLID));
		// if the table and the slider are found, make them scroll together
		if (tmpTableWrapper && tmpTable && tmpSlider)
		{
			// update the slider value based on the table scroll position
			const maxScrollLeft = tmpTable.scrollWidth - tmpTableWrapper.clientWidth;
			const sliderValue = ((tmpTableWrapper.scrollLeft / maxScrollLeft) * 100).toFixed(0);
			tmpSlider.value = sliderValue;
		}
	}

	/**
	 * Keep the "Add Row" button in view after adding a row to a table.
	 * @param {HTMLButtonElement} pButtonElement - The button element to keep in view.
	 */
	keepButtonInView(pButtonElement)
	{
		// Ensure the button is in view after adding a row
		const tmpButton = pButtonElement;
		const navBottomHeight = document.getElementById('HeadlightPanels-NavBar') ? document.getElementById('HeadlightPanels-NavBar').offsetHeight : 60;
		const extraSpacingGap = 10;
		window.scrollTo({
			top: tmpButton.getBoundingClientRect().top + window.scrollY + navBottomHeight + extraSpacingGap,
			behavior: 'smooth',
		});
	}

	/**
	 * Handle the click event for the "Add Row" button in a table.
	 * NOTE: This is a secondary call to prepare any extra table controls after the row is added/rendered - it doesn't actually add the row (that is handled by the Pict Provider).
	 * @param {Event} event - The click event.
	 */
	handleAddRowButtonClickEvents(event)
	{
		/** @ts-ignore */
		const tmpButton = event.currentTarget.TagName === 'BUTTON' ? event.currentTarget : event.currentTarget.parentElement;
		// After a short delay, keep the button in view
		setTimeout(() =>
		{
			this.keepButtonInView(tmpButton);
			// Update any necessary controls
			this.prepareAnyExtraTableControls();
		}, 100);
	}

	// ═════════════════════════════════════════════════════════════════════
	// Empty-table message
	// ═════════════════════════════════════════════════════════════════════

	/**
	 * Resolve the copy for a tabular group's "no rows" placeholder row.
	 *
	 * Backs the `{~TabularEmptyMessage:<address>:<default copy>~}` macro. The
	 * pattern body is split on the FIRST colon so the default copy may itself
	 * contain colons; everything after that first colon is the fallback.
	 *
	 * @param {string} pPatternBody - The macro body: `<address>:<default copy>`.
	 * @param {Object} pData - The template data scope.
	 * @param {any} [fCallback] - Passed through to resolveStateFromAddress.
	 * @return {string} - The escaped message text.
	 */
	resolveTabularEmptyMessage(pPatternBody, pData, fCallback)
	{
		const tmpBody = (typeof pPatternBody === 'string') ? pPatternBody : '';
		const tmpSeparatorIndex = tmpBody.indexOf(':');
		const tmpAddress = (tmpSeparatorIndex < 0) ? tmpBody : tmpBody.substring(0, tmpSeparatorIndex);
		const tmpDefaultMessage = (tmpSeparatorIndex < 0) ? '' : tmpBody.substring(tmpSeparatorIndex + 1);
		const tmpGroup = this.pict.resolveStateFromAddress(tmpAddress, pData, fCallback);
		// A group that never opted in falls back to the theme's own literal, which
		// the template passes in -- that is what keeps every existing form identical.
		const tmpMessage = (tmpGroup && tmpGroup.EmptyMessage) ? tmpGroup.EmptyMessage : tmpDefaultMessage;
		return _escapeTemplateText(tmpMessage);
	}

	// ═════════════════════════════════════════════════════════════════════
	// Entry controls
	// ═════════════════════════════════════════════════════════════════════

	/**
	 * Normalize a group's `EntryControls` block. Returns null when the group did
	 * not opt in (or explicitly disabled it) -- every caller treats null as
	 * "behave exactly the way this table behaved before the feature existed".
	 * @param {Object} pGroup - The group descriptor.
	 * @return {Object|null} - The normalized config, or null.
	 */
	getEntryControlsConfig(pGroup)
	{
		if (!pGroup || !pGroup.EntryControls || (typeof pGroup.EntryControls !== 'object'))
		{
			return null;
		}
		const tmpRaw = pGroup.EntryControls;
		if (tmpRaw.Enabled === false)
		{
			return null;
		}
		const tmpAutoReveal = (tmpRaw.ModeToggleAutoReveal && (typeof tmpRaw.ModeToggleAutoReveal === 'object')) ? tmpRaw.ModeToggleAutoReveal : {};
		const tmpPosition = ([ 'top', 'bottom', 'both' ].indexOf(tmpRaw.Position) > -1) ? tmpRaw.Position : _EntryControlsDefaults.Position;
		const tmpEntryPoint = ([ 'start', 'end' ].indexOf(tmpRaw.EntryPoint) > -1) ? tmpRaw.EntryPoint : _EntryControlsDefaults.EntryPoint;
		const tmpMode = ([ 'inline', 'modal' ].indexOf(tmpRaw.Mode) > -1) ? tmpRaw.Mode : _EntryControlsDefaults.Mode;
		return (
			{
				Position: tmpPosition,
				EntryPoint: tmpEntryPoint,
				Mode: tmpMode,
				AllowModeToggle: (tmpRaw.AllowModeToggle === true),
				RowThreshold: (typeof tmpAutoReveal.RowThreshold === 'number') ? tmpAutoReveal.RowThreshold : _EntryControlsDefaults.RowThreshold,
				// A ViewportMultiple of 0 disables the height half of the heuristic.
				ViewportMultiple: (typeof tmpAutoReveal.ViewportMultiple === 'number') ? tmpAutoReveal.ViewportMultiple : _EntryControlsDefaults.ViewportMultiple,
				// `false` means "always visible" -- skip the size heuristic entirely.
				AutoReveal: (tmpRaw.ModeToggleAutoReveal !== false),
				ModalTitle: (typeof tmpRaw.ModalTitle === 'string') ? tmpRaw.ModalTitle : _EntryControlsDefaults.ModalTitle,
				ModalWidth: (typeof tmpRaw.ModalWidth === 'string') ? tmpRaw.ModalWidth : _EntryControlsDefaults.ModalWidth,
				ModalColumns: (tmpRaw.ModalColumns === 2) ? 2 : _EntryControlsDefaults.ModalColumns,
			});
	}

	/**
	 * True when the group renders through the RecordSet layout rather than Tabular.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {boolean}
	 */
	isRecordSetGroup(pGroup)
	{
		return !!(pGroup && (pGroup.Layout === 'RecordSet'));
	}

	/**
	 * The form view hash that owns a group.
	 *
	 * Groups are not stamped with it, so find the section view whose own group list
	 * CONTAINS this exact group object. Do NOT read PictForm.ViewHash off the
	 * supportingManifest descriptors: ManifestFactory writes that onto the shared
	 * `ReferenceManifests` descriptor objects, so two groups built from the same
	 * RecordManifest overwrite each other and the last view to initialize wins.
	 *
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The view hash, or '' when it cannot be resolved.
	 */
	getGroupViewHash(pGroup)
	{
		if (!pGroup)
		{
			return '';
		}
		if (typeof pGroup._EntryControlsViewHash === 'string')
		{
			return pGroup._EntryControlsViewHash;
		}
		const tmpViewHashes = Object.keys(this.pict.views || {});
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			const tmpView = this.pict.views[tmpViewHashes[i]];
			if (!tmpView || !tmpView.isPictSectionForm || (typeof tmpView.getGroups !== 'function'))
			{
				continue;
			}
			const tmpGroups = tmpView.getGroups();
			if (!Array.isArray(tmpGroups))
			{
				continue;
			}
			for (let g = 0; g < tmpGroups.length; g++)
			{
				if (tmpGroups[g] === pGroup)
				{
					pGroup._EntryControlsViewHash = String(tmpView.Hash);
					return pGroup._EntryControlsViewHash;
				}
			}
		}
		return '';
	}

	/**
	 * The localStorage-shaped object the entry-mode preference lives in, or null
	 * when storage is unavailable. Mirrors PictProvider-SpecScopeResolver's
	 * accessor so tests can inject a fake via `options.EntryModeStorage`.
	 * @return {Object|null}
	 */
	_entryModeStorage()
	{
		try
		{
			if (this.options && this.options.EntryModeStorage)
			{
				return this.options.EntryModeStorage;
			}
			return (typeof localStorage !== 'undefined') ? localStorage : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The storage key for this group's entry-mode preference.
	 */
	getEntryModeStorageKey(pViewHash, pGroup)
	{
		return `${_ENTRY_MODE_STORAGE_PREFIX}.${pViewHash}.${(pGroup && pGroup.Hash) || 'UnknownGroup'}`;
	}

	/**
	 * The user's stored inline/modal preference for a group, or null when they
	 * have never chosen. Never read when the group didn't allow the toggle.
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @return {string|null} - 'inline' | 'modal' | null.
	 */
	readEntryModePreference(pViewHash, pGroup, pConfig)
	{
		if (!pConfig || !pConfig.AllowModeToggle)
		{
			return null;
		}
		const tmpStorage = this._entryModeStorage();
		if (!tmpStorage)
		{
			return null;
		}
		try
		{
			const tmpValue = tmpStorage.getItem(this.getEntryModeStorageKey(pViewHash, pGroup));
			return ((tmpValue === 'inline') || (tmpValue === 'modal')) ? tmpValue : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * Persist the user's inline/modal preference for a group.
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @param {string} pMode - 'inline' | 'modal'.
	 * @return {boolean} - True when it was written.
	 */
	writeEntryModePreference(pViewHash, pGroup, pConfig, pMode)
	{
		if (!pConfig || !pConfig.AllowModeToggle || ((pMode !== 'inline') && (pMode !== 'modal')))
		{
			return false;
		}
		const tmpStorage = this._entryModeStorage();
		if (!tmpStorage)
		{
			return false;
		}
		try
		{
			tmpStorage.setItem(this.getEntryModeStorageKey(pViewHash, pGroup), pMode);
			return true;
		}
		catch (pError)
		{
			return false;
		}
	}

	/**
	 * The mode that actually applies right now: the group's configured default,
	 * overridden by the user's stored preference when the toggle is allowed.
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - 'inline' | 'modal'.
	 */
	getEffectiveEntryMode(pViewHash, pGroup)
	{
		const tmpConfig = this.getEntryControlsConfig(pGroup);
		if (!tmpConfig)
		{
			return 'inline';
		}
		return this.readEntryModePreference(pViewHash, pGroup, tmpConfig) || tmpConfig.Mode;
	}

	/**
	 * The opt-in TOP add bar for a group, or '' when the group did not ask for
	 * one. Emitted as a whole from a macro (rather than living in the template
	 * behind a hide class) so that a group without `EntryControls` produces no
	 * extra DOM at all -- existing forms render exactly what they rendered before.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The bar HTML.
	 */
	renderEntryAddBarHTML(pGroup)
	{
		const tmpConfig = this.getEntryControlsConfig(pGroup);
		if (!tmpConfig || ((tmpConfig.Position !== 'top') && (tmpConfig.Position !== 'both')))
		{
			return '';
		}
		const tmpViewHash = this.getGroupViewHash(pGroup);
		const tmpView = this.pict.views[tmpViewHash];
		if (!tmpView)
		{
			this.pict.log.warn(`Entry controls on group [${pGroup.Hash}] could not resolve its form view; skipping the top add bar.`);
			return '';
		}
		const tmpIsRecordSet = this.isRecordSetGroup(pGroup);
		const tmpProviderHash = tmpIsRecordSet ? 'Bulma-RecordSetControls' : 'Bulma-TableControls';
		// The top bar is tagged 'entry-bar-top' so it is still swept up by the
		// `.hide-table-controls [data-table-controls]` /
		// `.hide-recordset-controls [data-recordset-controls]` suppression rules.
		const tmpControlsAttribute = tmpIsRecordSet ? 'data-recordset-controls' : 'data-table-controls';
		const tmpElementKey = `${tmpView.UUID}-${tmpViewHash}-${pGroup.Hash}`;
		const tmpButtonID = `${tmpIsRecordSet ? 'RECORDSET' : 'TABLE'}-ADD-BUTTON-TOP-FOR-${tmpElementKey}`;
		const tmpLabel = tmpIsRecordSet ? 'Add new set' : 'Add new row';
		const tmpMaxAttribute = tmpIsRecordSet ? 'data-max-sets' : 'data-max-rows';
		const tmpMinAttribute = tmpIsRecordSet ? 'data-min-sets' : 'data-min-rows';
		const tmpMaxValue = (pGroup.MaximumRowCount == null) ? '' : String(pGroup.MaximumRowCount);
		const tmpMinValue = (pGroup.MinimumRowCount == null) ? '' : String(pGroup.MinimumRowCount);
		return `<div class="columns is-vcentered is-mobile p-0 m-0" ${tmpControlsAttribute}="entry-bar-top">` +
			`<div class="column p-0 mt-2 mb-2 mr-3 has-text-right">` +
			this.renderEntryModeToggleHTML(pGroup) +
			`<button type="button" id="${this._escapeEntryAttribute(tmpButtonID)}" class="button is-link"` +
			` ${tmpControlsAttribute}="${tmpIsRecordSet ? 'add-set' : 'add-row'}"` +
			` ${tmpMaxAttribute}="${this._escapeEntryAttribute(tmpMaxValue)}" ${tmpMinAttribute}="${this._escapeEntryAttribute(tmpMinValue)}"` +
			` onclick="_Pict.providers['${tmpProviderHash}'].handleAddEntryButtonClickEvents(event, '${this._escapeEntryAttribute(tmpViewHash)}', '${this._escapeEntryAttribute(String(pGroup.GroupIndex))}')">` +
			`<span class="icon"><i class="fas fa-plus" aria-hidden="true"></i></span>` +
			`<span> ${tmpLabel}</span>` +
			`</button>` +
			`</div>` +
			`</div>`;
	}

	/**
	 * The inline/modal toggle button markup, or '' when the group didn't opt in.
	 * Starts hidden; refreshEntryModeToggleVisibility() reveals it.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The button HTML.
	 */
	renderEntryModeToggleHTML(pGroup)
	{
		const tmpConfig = this.getEntryControlsConfig(pGroup);
		if (!tmpConfig || !tmpConfig.AllowModeToggle)
		{
			return '';
		}
		const tmpViewHash = this.getGroupViewHash(pGroup);
		const tmpMode = tmpViewHash ? this.getEffectiveEntryMode(tmpViewHash, pGroup) : tmpConfig.Mode;
		const tmpIsModal = (tmpMode === 'modal');
		const tmpLabel = tmpIsModal ? 'Entry: Dialog' : 'Entry: Inline';
		const tmpIcon = tmpIsModal ? 'fa-window-restore' : 'fa-list';
		const tmpTitle = tmpIsModal ?
			'New entries open in a dialog. Click to switch to inline entry.' :
			'New entries are added inline. Click to switch to dialog entry.';
		// Hidden until the group is big enough to warrant the choice (or always,
		// when the author turned the heuristic off).
		const tmpHiddenClass = tmpConfig.AutoReveal ? ' is-hidden' : '';
		const tmpProviderHash = this.isRecordSetGroup(pGroup) ? 'Bulma-RecordSetControls' : 'Bulma-TableControls';
		return `<button type="button" class="button is-link is-outlined pict-entry-mode-toggle${tmpHiddenClass}"` +
			` data-entry-mode-toggle="${this._escapeEntryAttribute(String(pGroup.Hash))}"` +
			` data-entry-mode-group-index="${this._escapeEntryAttribute(String(pGroup.GroupIndex))}"` +
			` data-entry-mode-rows="${tmpConfig.RowThreshold}"` +
			` data-entry-mode-viewport="${tmpConfig.ViewportMultiple}"` +
			` title="${tmpTitle}" aria-label="${tmpTitle}"` +
			` onclick="_Pict.providers['${tmpProviderHash}'].toggleEntryMode('${this._escapeEntryAttribute(tmpViewHash)}', '${this._escapeEntryAttribute(String(pGroup.GroupIndex))}')">` +
			`<span class="icon is-small"><i class="fas ${tmpIcon}" aria-hidden="true"></i></span>` +
			`<span>${tmpLabel}</span>` +
			`</button>`;
	}

	/**
	 * Minimal attribute escaping for values interpolated into the toggle markup.
	 * @param {string} pValue - The raw value.
	 * @return {string} - The escaped value.
	 */
	_escapeEntryAttribute(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	/**
	 * Flip a group between inline and modal entry, persist the choice, and
	 * repaint the group so the toggle's own label updates.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True on success.
	 */
	toggleEntryMode(pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			return false;
		}
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);
		if (!tmpConfig || !tmpConfig.AllowModeToggle)
		{
			return false;
		}
		const tmpNextMode = (this.getEffectiveEntryMode(pViewHash, tmpGroup) === 'modal') ? 'inline' : 'modal';
		this.writeEntryModePreference(pViewHash, tmpGroup, tmpConfig, tmpNextMode);
		// The toggle lives in the group's baked markup, so a plain render is
		// enough to relabel it -- no template rebuild needed.
		tmpView.render();
		tmpView.marshalToView();
		this.prepareAnyExtraEntryControls(tmpGroup);
		return true;
	}

	/**
	 * The single entry point for BOTH add bars (top and bottom) on both layouts.
	 * When the group never opted into EntryControls this reproduces the exact
	 * legacy behavior the template's onclick used to inline.
	 * @param {Event} pEvent - The click event.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True when an entry was started.
	 */
	handleAddEntryButtonClickEvents(pEvent, pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`Entry controls could not resolve view [${pViewHash}].`);
			return false;
		}
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);

		if (!tmpConfig)
		{
			// Legacy path: create the row, then the original post-add fixups.
			tmpView.createDynamicTableRow(pGroupIndex);
			this.handleAddRowButtonClickEvents(pEvent);
			return true;
		}

		if (this.getEffectiveEntryMode(pViewHash, tmpGroup) === 'modal')
		{
			return this.openEntryModal(pViewHash, pGroupIndex);
		}
		return this.addEntryInline(pViewHash, pGroupIndex, tmpConfig);
	}

	/**
	 * Add a row inline, honoring EntryPoint. For 'start' the row is appended
	 * first and only then moved to index 0 -- see the comment in
	 * moveStagedEntryToStart for why the array must never be spliced at 0
	 * against a stale DOM.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @return {boolean} - True on success.
	 */
	addEntryInline(pViewHash, pGroupIndex, pConfig)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpRecordSet = this.getEntryRecordSet(tmpView, tmpGroup);
		if (!Array.isArray(tmpRecordSet))
		{
			return false;
		}
		const tmpLengthBefore = tmpRecordSet.length;
		tmpView.createDynamicTableRow(pGroupIndex);
		if (tmpRecordSet.length === tmpLengthBefore)
		{
			// createDynamicTableRow warns and no-ops at MaximumRowCount.
			this.toastEntryControlsMessage(`Cannot add: the maximum of ${tmpGroup.MaximumRowCount} has been reached.`);
			return false;
		}
		const tmpIndex = this.moveStagedEntryToStart(tmpView, pGroupIndex, pConfig, tmpRecordSet.length - 1);
		if (tmpIndex !== (tmpRecordSet.length - 1))
		{
			// The row moved, so the table DOM has to be rebuilt -- see the note in
			// moveStagedEntryToStart about undefined values not clearing an input.
			this.reconcileRecordSet(tmpView, tmpGroup);
		}
		this.prepareAnyExtraEntryControls(tmpGroup);
		this.scrollEntryIntoView(pViewHash, pGroupIndex, tmpIndex);
		return true;
	}


	/**
	 * Reflect a group's MaximumRowCount on its add button(s).
	 *
	 * Toggles BOTH ways on purpose. These functions used to only ever set
	 * `disabled`, never clear it, so a group that hit its cap kept a dead add
	 * button even after the user deleted rows back under it. Nothing else in the
	 * bundle disables an add button, so clearing it here is safe.
	 *
	 * @param {NodeList|Array} pButtons - The add buttons for one group (top and/or bottom).
	 * @param {number} pEntryCount - How many entries the group currently has.
	 * @param {string} pMaxAttribute - 'data-max-rows' (Tabular) or 'data-max-sets' (RecordSet).
	 * @param {string} pMinAttribute - 'data-min-rows' or 'data-min-sets'.
	 * @return {void}
	 */
	applyAddButtonRowLimit(pButtons, pEntryCount, pMaxAttribute, pMinAttribute)
	{
		for (let i = 0; i < pButtons.length; i++)
		{
			const tmpButton = pButtons[i];
			if (!tmpButton)
			{
				continue;
			}
			const tmpMaximum = parseInt(tmpButton.getAttribute(pMaxAttribute), 10);
			const tmpMinimum = parseInt(tmpButton.getAttribute(pMinAttribute), 10) || 0;
			// No configured maximum means the group is never capped.
			if (isNaN(tmpMaximum) || ((tmpMaximum > tmpMinimum) && (pEntryCount < tmpMaximum)))
			{
				tmpButton.removeAttribute('disabled');
				continue;
			}
			tmpButton.setAttribute('disabled', 'disabled');
		}
	}

	/**
	 * Run the post-mutation control fixups appropriate to a group's layout.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {void}
	 */
	prepareAnyExtraEntryControls(pGroup)
	{
		if (this.isRecordSetGroup(pGroup))
		{
			const tmpRecordSetControls = this.pict.providers['Bulma-RecordSetControls'];
			if (tmpRecordSetControls && (typeof tmpRecordSetControls.prepareAnyExtraRecordSetControls === 'function'))
			{
				tmpRecordSetControls.prepareAnyExtraRecordSetControls();
				// The RecordSet path has no table scan of its own, so drive the
				// toggle reveal from here.
				this.refreshEntryModeToggleVisibility();
				return;
			}
		}
		this.prepareAnyExtraTableControls();
	}

	/**
	 * The record-set array backing a group.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {Array|null}
	 */
	getEntryRecordSet(pView, pGroup)
	{
		if (!pView || !pGroup || (typeof pGroup.RecordSetAddress !== 'string'))
		{
			return null;
		}
		const tmpRecordSet = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pGroup.RecordSetAddress);
		return Array.isArray(tmpRecordSet) ? tmpRecordSet : null;
	}

	/**
	 * Move a just-added entry to the top when EntryPoint is 'start'.
	 *
	 * This MUST go through setDynamicTableRowIndex rather than splicing the array
	 * directly. `data-i-index` is baked into the DOM at render time and an
	 * ordinary marshal does not re-render, so splicing at index 0 against a table
	 * that still shows the old order leaves every existing row's index off by one
	 * and Informary writes row k's DOM values into record k+1. setDynamicTableRowIndex
	 * also permutes dependent positional DynamicColumns before they re-resolve.
	 *
	 * The CALLER must then re-render the group. setDynamicTableRowIndex's repaint
	 * deliberately skips re-rendering the source view (re-initializing entity
	 * selectors costs seconds per move) and relies on the marshal pushing the
	 * reordered model into the existing row DOM. That is fine for a user-initiated
	 * move of populated rows, but a freshly added row's fields are `undefined` and
	 * Informary does not clear an input for an undefined value -- so the new empty
	 * row at index 0 would keep displaying whatever used to be there.
	 *
	 * @param {Object} pView - The form view.
	 * @param {number|string} pGroupIndex - The group index.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @param {number} pIndex - The index the new entry currently occupies.
	 * @return {number} - The index the entry ended up at.
	 */
	moveStagedEntryToStart(pView, pGroupIndex, pConfig, pIndex)
	{
		if (!pConfig || (pConfig.EntryPoint !== 'start') || (pIndex <= 0))
		{
			return pIndex;
		}
		pView.setDynamicTableRowIndex(pGroupIndex, pIndex, 0);
		return 0;
	}

	/**
	 * Non-blocking notice through the Headlight panels toast, when available.
	 * @param {string} pMessage - The message.
	 * @param {string} [pType] - A Bulma type class (default 'is-warning').
	 * @return {void}
	 */
	toastEntryControlsMessage(pMessage, pType)
	{
		this.pict.log.warn(pMessage);
		const tmpPanels = this.pict.views ? this.pict.views.HeadlightPanels : null;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast({ message: pMessage, type: pType || 'is-warning' });
		}
	}

	/**
	 * Open the "add a new entry" modal for a group.
	 *
	 * Stage-then-commit: a REAL row is appended to the record set first (without
	 * render/solve/marshal), and the modal renders that row's inputs. Because the
	 * row is genuinely in the model, per-row RecordSetSolvers, ReadOnly computed
	 * fields and AutofillTriggerGroup / EntityBundleRequest cascades all work
	 * live inside the dialog. Because the table is NOT re-rendered while the modal
	 * is open, the staged row has no inline DOM twin -- `data-i-index` for that
	 * index exists in exactly one place in the document.
	 *
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True when the modal opened.
	 */
	openEntryModal(pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView ? tmpView.getGroup(pGroupIndex) : null;
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);
		if (!tmpView || !tmpGroup || !tmpConfig)
		{
			return false;
		}

		const tmpModal = this.pict.views['Pict-Section-Modal'] || this.pict.views['PictSectionModal'];
		if (!tmpModal || (typeof tmpModal.show !== 'function'))
		{
			// pict-section-modal is a soft dependency -- degrade to inline entry.
			this.pict.log.warn(`Entry controls on group [${tmpGroup.Hash}] requested modal entry but pict-section-modal is unavailable; adding inline.`);
			return this.addEntryInline(pViewHash, pGroupIndex, tmpConfig);
		}
		if (this._modalEntryState)
		{
			this.pict.log.warn('An entry modal is already open; ignoring the second request.');
			return false;
		}

		const tmpRecordSet = this.getEntryRecordSet(tmpView, tmpGroup);
		if (!tmpRecordSet)
		{
			return false;
		}
		if (tmpGroup.MaximumRowCount && (tmpRecordSet.length >= tmpGroup.MaximumRowCount))
		{
			this.toastEntryControlsMessage(`Cannot add: the maximum of ${tmpGroup.MaximumRowCount} has been reached.`);
			return false;
		}

		// Stage the row. Always at the END, even for EntryPoint 'start' -- the
		// move to index 0 happens on commit, after a render has refreshed every
		// row's data-i-index.
		const tmpLengthBefore = tmpRecordSet.length;
		this.pict.providers.DynamicTabularData.createDynamicTableRowWithoutEvents(tmpView, pGroupIndex);
		if (tmpRecordSet.length === tmpLengthBefore)
		{
			this.toastEntryControlsMessage(`Cannot add: the maximum of ${tmpGroup.MaximumRowCount} has been reached.`);
			return false;
		}
		const tmpStagedIndex = tmpRecordSet.length - 1;

		this._modalEntryState =
			{
				ViewHash: pViewHash,
				GroupIndex: Number(pGroupIndex),
				StagedIndex: tmpStagedIndex,
				Committed: false,
				Dialog: null,
			};

		const tmpIsRecordSet = this.isRecordSetGroup(tmpGroup);
		const tmpTemplateHash = tmpIsRecordSet ?
			tmpGroup.SectionTabularRowTemplateHash :
			this.buildModalRowTemplate(tmpView, tmpGroup, tmpConfig);

		// Context[0] must be the view and Context[2] the {Value, Key, Group} row
		// wrapper -- the MetaTemplate parser pushes exactly one level per nesting
		// and parseTemplateByHash pushes the record, so pass TWO context entries.
		// Get this wrong and data-i-index and the onchange handler render blank.
		const tmpRowHTML = this.pict.parseTemplateByHash(
			tmpTemplateHash,
			{ Value: tmpRecordSet[tmpStagedIndex], Key: tmpStagedIndex, Group: Number(pGroupIndex) },
			null,
			[ tmpView, tmpView.sectionDefinition ]);

		const tmpNounLabel = tmpIsRecordSet ? 'Record' : 'Row';
		tmpModal.show(
			{
				title: tmpConfig.ModalTitle || `Add New ${tmpGroup.Name || tmpNounLabel}`,
				content: `<div class="pict-entry-modal-body">${tmpRowHTML}</div>`,
				width: tmpConfig.ModalWidth,
				closeable: true,
				buttons:
					[
						{ Hash: 'cancel', Label: 'Cancel' },
						{ Hash: 'done', Label: 'Done', Style: 'primary' },
						{ Hash: 'done-goto', Label: `Finish and go to ${tmpNounLabel}`, Style: 'primary' },
					],
				onOpen: (pDialog) =>
				{
					if (this._modalEntryState)
					{
						this._modalEntryState.Dialog = pDialog;
					}
					this.initializeStagedRowInputs(tmpView, tmpGroup, tmpStagedIndex);
				},
			}).then((pResult) =>
			{
				this.handleEntryModalResult(pResult);
			});
		return true;
	}

	/**
	 * Compose a stacked, labeled "one record" template for a TABULAR group.
	 *
	 * The group's own SectionTabularRowTemplateHash emits bare <td>s (invalid
	 * inside a modal <div>, and carrying no labels -- those live in the <th>s), so
	 * it cannot be reused the way the RecordSet layout's can. Instead re-run the
	 * same input-metatemplate composition the layout does, wrapped in our own
	 * field markup. Every input template is reused verbatim, so Picker,
	 * MaterialsEntitySelector, Signature, Diagram etc. render exactly as inline.
	 *
	 * Rebuilt on every open -- it is cheap string work and it picks up
	 * DynamicColumns changes for free.
	 *
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @return {string} - The registered template hash.
	 */
	buildModalRowTemplate(pView, pGroup, pConfig)
	{
		const tmpGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpManifest = pGroup.supportingManifest;
		const tmpHash = `Headlight-Form-Template-TabularRow-Modal-${pView.options.Hash}-G${pGroup.GroupIndex}`;
		if (!tmpManifest || !Array.isArray(tmpManifest.elementAddresses))
		{
			this.pict.TemplateProvider.addTemplate(tmpHash, '');
			return tmpHash;
		}

		// ColumnChooser-hidden columns are SHOWN in the modal (marked with a note):
		// hiding is a transient view preference, and a hidden-but-required column
		// the user cannot fill is a dead end. TabularHidden is structural and is skipped.
		let tmpChooserHiddenSet = null;
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (tmpLayout && (typeof tmpLayout._getTabularColumnChooserHiddenSet === 'function'))
		{
			try
			{
				tmpChooserHiddenSet = tmpLayout._getTabularColumnChooserHiddenSet(pView, pGroup);
			}
			catch (pError)
			{
				tmpChooserHiddenSet = null;
			}
		}

		let tmpTemplate = '<div class="columns is-multiline">';
		for (let k = 0; k < tmpManifest.elementAddresses.length; k++)
		{
			const tmpKey = tmpManifest.elementAddresses[k];
			const tmpInput = tmpManifest.elementDescriptors[tmpKey];
			if (!tmpInput || !tmpInput.PictForm || tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			// Same index stamping the layouts perform on bake -- the input
			// templates read PictForm.InputIndex.
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			// Read back by the {~EntryModalCellClass:~} macro below.
			tmpInput.PictForm._EntryModalHalfWidth = (pConfig.ModalColumns === 2);
			tmpInput.PictForm._EntryModalChooserHidden = !!(tmpChooserHiddenSet &&
				(typeof tmpChooserHiddenSet.has === 'function') && tmpChooserHiddenSet.has(String(tmpKey)));

			const tmpAddress = `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`;
			tmpTemplate += tmpGenerator.getMetatemplateTemplateReference(pView, '-TabularTemplate-ModalCell-Prefix', tmpAddress);
			tmpTemplate += tmpGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType,
				(tmpInput.PictForm.InputType || 'Default'), tmpAddress, pGroup.GroupIndex, k);
			tmpTemplate += tmpGenerator.getMetatemplateTemplateReference(pView, '-TabularTemplate-ModalCell-Postfix', tmpAddress);
		}
		tmpTemplate += '</div>';
		this.pict.TemplateProvider.addTemplate(tmpHash, tmpTemplate);
		return tmpHash;
	}

	/**
	 * Initialize the input widgets of the staged row only.
	 *
	 * Deliberately NOT pView.runInputProviderFunctions: that walks every group and
	 * every non-tabular input in the section, re-initializing widgets that are
	 * already live and logging out-of-bounds errors for sibling groups whose
	 * record sets are shorter than this row index. This is its tabular branch,
	 * scoped to one group and one row.
	 *
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {number} pRowIndex - The staged row index.
	 * @return {void}
	 */
	initializeStagedRowInputs(pView, pGroup, pRowIndex)
	{
		const tmpManifest = pGroup.supportingManifest;
		if (!tmpManifest || !Array.isArray(tmpManifest.elementAddresses))
		{
			return;
		}
		// TransactionTracking is a runtime service on the pict instance that the
		// published pict types do not describe.
		const tmpPict = /** @type {any} */ (this.pict);
		const tmpTransactionGUID = this.fable.getUUID();
		const tmpTransaction = tmpPict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		for (let k = 0; k < tmpManifest.elementAddresses.length; k++)
		{
			const tmpInput = tmpManifest.elementDescriptors[tmpManifest.elementAddresses[k]];
			if (!tmpInput || !tmpInput.PictForm || tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			const tmpProviderList = pView.getInputProviderList(tmpInput);
			for (let l = 0; l < tmpProviderList.length; l++)
			{
				const tmpProvider = this.pict.providers[tmpProviderList[l]];
				if (!tmpProvider || (typeof tmpProvider.onInputInitializeTabular !== 'function'))
				{
					continue;
				}
				const tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(
					tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				const tmpValue = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpValueAddress);
				try
				{
					if (tmpPict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey,
						`TI${tmpInput.Hash}-P${tmpProviderList[l]}-R${pRowIndex}`, 'onInputInitialize'))
					{
						tmpProvider.onInputInitializeTabular(pView, pGroup, tmpInput, tmpValue,
							tmpInput.Macro.HTMLSelectorTabular, pRowIndex, tmpTransactionGUID);
					}
				}
				catch (pError)
				{
					this.pict.log.error(`Entry modal failed to initialize provider [${tmpProviderList[l]}] for input [${tmpInput.Hash}]: ${pError}`);
				}
			}
		}
		// Push the staged record's values (defaults, and anything a solver has
		// already produced) into the freshly rendered modal inputs.
		this.pict.providers.Informary.marshalDataToForm(pView.getMarshalDestinationObject(), pView.formID, pView.sectionManifest);
	}

	/**
	 * Resolve the entry modal: commit the staged row, or roll it back.
	 * @param {string|null} pResult - The clicked button hash, or null when dismissed.
	 * @return {boolean} - True when a row was committed.
	 */
	handleEntryModalResult(pResult)
	{
		const tmpState = this._modalEntryState;
		if (!tmpState)
		{
			return false;
		}
		this._modalEntryState = null;

		// pict-section-modal resolves the promise SYNCHRONOUSLY but only removes
		// the dialog from the DOM 220ms later. Empty the body now: the commit
		// render below paints inline row N with the same element ids and the same
		// data-i-index, and we must not let the two coexist even briefly.
		this.teardownEntryModalBody(tmpState.Dialog);

		const tmpView = this.pict.views[tmpState.ViewHash];
		const tmpGroup = tmpView ? tmpView.getGroup(tmpState.GroupIndex) : null;
		if (!tmpView || !tmpGroup)
		{
			return false;
		}
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);
		const tmpCommitted = ((pResult === 'done') || (pResult === 'done-goto'));

		if (!tmpCommitted)
		{
			this.rollbackStagedEntry(tmpView, tmpGroup, tmpState.StagedIndex);
		}

		// Any rebuild the marshal guard swallowed while the modal was open has to
		// happen exactly once, now that the DOM and the model agree again.
		this.flushDeferredEntryRebuild(tmpView, tmpGroup);

		// Reorder BEFORE reconciling so a prepend costs one render, not two. The
		// reorder's own repaint marshals into a table that is still one row short;
		// that is harmless (Informary addresses rows by data-i-index and simply
		// finds nothing for the staged index) and the reconcile below repaints it.
		let tmpFinalIndex = tmpState.StagedIndex;
		if (tmpCommitted)
		{
			tmpFinalIndex = this.moveStagedEntryToStart(tmpView, tmpState.GroupIndex, tmpConfig, tmpState.StagedIndex);
		}

		this.reconcileRecordSet(tmpView, tmpGroup);
		this.prepareAnyExtraEntryControls(tmpGroup);

		if (tmpCommitted && (pResult === 'done-goto'))
		{
			this.scrollEntryIntoView(tmpState.ViewHash, tmpState.GroupIndex, tmpFinalIndex);
		}
		return tmpCommitted;
	}

	/**
	 * Remove the modal-hosted inputs from the document immediately.
	 * @param {any} pDialog - The pict-section-modal dialog element.
	 * @return {void}
	 */
	teardownEntryModalBody(pDialog)
	{
		if (!pDialog || (typeof pDialog.querySelector !== 'function'))
		{
			return;
		}
		const tmpBody = pDialog.querySelector('.pict-entry-modal-body') || pDialog.querySelector('.pict-modal-dialog-body');
		if (!tmpBody)
		{
			return;
		}
		while (tmpBody.firstChild)
		{
			tmpBody.removeChild(tmpBody.firstChild);
		}
	}

	/**
	 * Remove a cancelled staged entry from the record set.
	 *
	 * Deliberately NOT deleteDynamicTableRow: that refuses once the array is at
	 * MinimumRowCount, and the staged row is exactly what pushed it over. Splicing
	 * returns to the pre-add count, which was already a legal count.
	 *
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {number} pStagedIndex - The staged row index.
	 * @return {boolean} - True when a row was removed.
	 */
	rollbackStagedEntry(pView, pGroup, pStagedIndex)
	{
		const tmpRecordSet = this.getEntryRecordSet(pView, pGroup);
		if (!tmpRecordSet || (pStagedIndex < 0) || (pStagedIndex >= tmpRecordSet.length))
		{
			return false;
		}
		tmpRecordSet.splice(pStagedIndex, 1);
		const tmpTabular = this.pict.providers.DynamicTabularData;
		if (tmpTabular && (typeof tmpTabular._spliceDependentPositionalColumns === 'function'))
		{
			try
			{
				tmpTabular._spliceDependentPositionalColumns(pGroup.RecordSetAddress, pStagedIndex, pStagedIndex + 1);
			}
			catch (pError)
			{
				this.pict.log.error(`Entry modal rollback could not splice dependent positional columns: ${pError}`);
			}
		}
		return true;
	}

	/**
	 * Run the one rebuild the modal-entry marshal guard suppressed, if any.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {void}
	 */
	flushDeferredEntryRebuild(pView, pGroup)
	{
		if (!pGroup || !pGroup._HeadlightModalDeferredRebuild)
		{
			return;
		}
		pGroup._HeadlightModalDeferredRebuild = false;
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (tmpLayout && (typeof tmpLayout._rebuildTabularGroupView === 'function'))
		{
			tmpLayout._rebuildTabularGroupView(pView);
		}
	}

	/**
	 * Repaint + resolve everything bound to a group's record set. Mirrors the tail
	 * of DynamicTabularData.createDynamicTableRow: render the bound views,
	 * rebuild dependent DynamicColumns views, solve, marshal.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {void}
	 */
	reconcileRecordSet(pView, pGroup)
	{
		const tmpAddress = pGroup.RecordSetAddress;
		const tmpTabular = this.pict.providers.DynamicTabularData;
		const tmpViews = this.pict.views.PictFormMetacontroller.filterViews((pCandidate) =>
		{
			if (!pCandidate.isPictSectionForm)
			{
				return false;
			}
			const tmpGroups = pCandidate.getGroups();
			for (let i = 0; i < tmpGroups.length; i++)
			{
				if (tmpGroups[i].RecordSetAddress === tmpAddress)
				{
					return true;
				}
			}
			return false;
		});

		// _renderViewsPreservingRecordSet snapshots/restores entity-selector values
		// across the re-render; a plain render loses them ("the Source I just
		// picked disappeared after adding a row").
		if (tmpTabular && (typeof tmpTabular._renderViewsPreservingRecordSet === 'function'))
		{
			tmpTabular._renderViewsPreservingRecordSet(tmpAddress, tmpViews);
		}
		else
		{
			this.pict.log.warn('DynamicTabularData._renderViewsPreservingRecordSet is unavailable; falling back to a plain render (entity-selector values may be clobbered).');
			for (let i = 0; i < tmpViews.length; i++)
			{
				tmpViews[i].render();
			}
		}
		if (tmpTabular && (typeof tmpTabular._rebuildDependentDynamicColumnViews === 'function'))
		{
			tmpTabular._rebuildDependentDynamicColumnViews(tmpAddress);
		}
		this.pict.providers.DynamicSolver.solveViews();
		this.pict.views.PictFormMetacontroller.marshalFormSections();
	}

	/**
	 * Scroll a group's entry into view, but only when it is not already visible.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @param {number} pRowIndex - The entry index.
	 * @return {boolean} - True when the entry element was found.
	 */
	scrollEntryIntoView(pViewHash, pGroupIndex, pRowIndex)
	{
		if (typeof document === 'undefined')
		{
			return false;
		}
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView ? tmpView.getGroup(pGroupIndex) : null;
		const tmpSelector = this.isRecordSetGroup(tmpGroup) ?
			`[data-recordset-group-index="${pGroupIndex}"][data-recordset-row-index="${pRowIndex}"]` :
			`tr[data-tabular-group-index="${pGroupIndex}"][data-tabular-row-index="${pRowIndex}"]`;
		const tmpElement = document.querySelector(tmpSelector);
		if (!tmpElement)
		{
			return false;
		}
		const tmpNavBar = document.getElementById('HeadlightPanels-NavBar');
		const tmpNavHeight = tmpNavBar ? tmpNavBar.offsetHeight : 60;
		const tmpRect = tmpElement.getBoundingClientRect();
		const tmpViewportHeight = window.innerHeight || 0;
		if ((tmpRect.top >= tmpNavHeight) && (tmpRect.bottom <= tmpViewportHeight))
		{
			return true;
		}
		window.scrollTo({ top: (tmpRect.top + window.scrollY) - tmpNavHeight - 10, behavior: 'smooth' });
		return true;
	}

	/**
	 * Reveal the inline/modal toggle on groups that have grown big enough to
	 * warrant the choice. Strictly read-all-then-write-all so the measurement
	 * never interleaves reads and writes, and STICKY -- once revealed a toggle is
	 * never hidden again, so a user who switched to modal entry does not lose the
	 * control when the row count drops back under the threshold.
	 *
	 * Called from prepareAnyExtraTableControls (every bake / add / delete) and
	 * from ResponsiveUIAdjustmentProvider.onWindowResize (already debounced), so
	 * it registers no listeners of its own.
	 *
	 * @return {void}
	 */
	refreshEntryModeToggleVisibility()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const tmpToggles = document.querySelectorAll('[data-entry-mode-toggle]');
		if (!tmpToggles.length)
		{
			return;
		}
		const tmpViewportHeight = window.innerHeight || 0;
		const tmpToReveal = [];

		// PASS 1 -- reads only.
		for (let i = 0; i < tmpToggles.length; i++)
		{
			const tmpToggle = tmpToggles[i];
			if (!tmpToggle.classList.contains('is-hidden'))
			{
				continue;
			}
			const tmpContainer = tmpToggle.closest('.section-table-wrapper') || tmpToggle.closest('.section-recordset-wrapper');
			if (!tmpContainer)
			{
				continue;
			}
			const tmpRowThreshold = parseInt(tmpToggle.getAttribute('data-entry-mode-rows'), 10);
			const tmpViewportMultiple = parseFloat(tmpToggle.getAttribute('data-entry-mode-viewport'));
			// NOTE: the placeholder row's class really is 'table-emtpy-row' (sic) --
			// that spelling is what the group templates emit.
			let tmpEntryCount = tmpContainer.querySelectorAll('tbody tr:not(.table-emtpy-row)').length;
			if (!tmpEntryCount)
			{
				tmpEntryCount = tmpContainer.querySelectorAll('.RecordSetEntry').length;
			}
			const tmpHeight = tmpContainer.getBoundingClientRect().height;
			const tmpRevealByRows = (!isNaN(tmpRowThreshold) && (tmpRowThreshold > 0) && (tmpEntryCount >= tmpRowThreshold));
			const tmpRevealByHeight = (!isNaN(tmpViewportMultiple) && (tmpViewportMultiple > 0) && (tmpViewportHeight > 0) &&
				(tmpHeight >= (tmpViewportMultiple * tmpViewportHeight)));
			if (tmpRevealByRows || tmpRevealByHeight)
			{
				tmpToReveal.push(tmpToggle);
			}
		}

		// PASS 2 -- writes only.
		for (let i = 0; i < tmpToReveal.length; i++)
		{
			tmpToReveal[i].classList.remove('is-hidden');
		}
	}

	/**
	 * While a modal entry is staged the row exists in the model but deliberately
	 * NOT in the table DOM. The tabular layout's onDataMarshalToForm can rebuild
	 * mid-marshal (a DynamicColumns set change, or a ColumnChooser state-key
	 * drift), which would paint an inline twin of the modal's row carrying the
	 * same data-i-index. Defer that rebuild until the modal closes.
	 *
	 * Idempotent; no-op when the layout provider isn't registered.
	 * @return {void}
	 */
	overrideTabularMarshalForModalEntry()
	{
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout ||
			(typeof tmpLayout.onDataMarshalToForm !== 'function') ||
			tmpLayout._headlightModalEntryMarshalOverridden)
		{
			return;
		}
		const tmpSelf = this;
		tmpLayout._headlightModalEntryMarshalOverridden = true;
		const fOriginalMarshal = tmpLayout.onDataMarshalToForm;
		tmpLayout.onDataMarshalToForm = function(pView, pGroup)
		{
			const tmpState = tmpSelf._modalEntryState;
			if (tmpState && !tmpState.Committed && pView && pGroup &&
				(pView.Hash === tmpState.ViewHash) &&
				(Number(pGroup.GroupIndex) === Number(tmpState.GroupIndex)))
			{
				pGroup._HeadlightModalDeferredRebuild = true;
				return true;
			}
			return fOriginalMarshal.call(this, pView, pGroup);
		};
	}

	/**
	 * Generate the HTML for a group layout template.
	 * @param {Object} pGroup - The group object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pGroupKey - The key of the group.
	 * @param {Object} pGroupData - The data for the group.
	 * @param {number} pGroupDataIndex - The index of the group data.
	 * @param {string} pGroupDataKey - The key of the group data.
	 * @return {string} - The generated HTML for the group layout template.
	 */
	generateGroupLayoutTemplate(pGroup, pGroupIndex, pGroupKey, pGroupData, pGroupDataIndex, pGroupDataKey)
	{
		this.prepareAnyExtraTableControls();
		return '';
	}
}

module.exports = CustomInputHandler;

},{"./_ScopedEntityData.js":139,"pict-section-form":497}],35:[function(require,module,exports){
/**
 * Component-owned chip styling for PictProvider-ChipTooltips.
 *
 * The chip color/structure palette (and its theme variants) lives in the
 * headlight-styles Bulma layer (`bulma-chip.scss`), authored with the
 * `--bulma-*` design tokens. This file holds only the small set of rules that
 * belong with the runtime behavior: the keyboard-focus affordance for the chip
 * button-anchor and the tooltip body layout.
 */
module.exports = /*css*/`
.chip:focus-visible
{
	outline: 2px solid var(--bulma-link, #485fc7);
	outline-offset: 1px;
}

.chip-tooltip
{
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	white-space: nowrap;
}

.chip-tooltip .fa
{
	opacity: 0.85;
}

/* Chip tooltips must sit BELOW open Select2 dropdowns (z-index 30 in
   headlight-styles' bulma-select2) and other menus/overlays — a hover or pinned
   chip tooltip should never cover an open dropdown list. The shared
   .pict-modal-tooltip z-index (1020) is tuned for tooltips inside modal dialogs;
   chip tooltips live on form labels and only need to clear page content, so the
   chip-tooltip-bubble marker (added to every chip tooltip) scopes a lower value. */
.pict-modal-tooltip.chip-tooltip-bubble
{
	z-index: 20;
}

/* Theme the tooltip bubble (and its arrow, which reads --pict-modal-tooltip-bg)
   to the chip's color variant — a darker, saturated take on the chip color with
   a light same-hue label. PictProvider-ChipTooltips passes chip-tooltip-<variant>
   derived from the chip's is-<variant> class; unknown/default chips keep the
   standard dark tooltip. Uses the Bulma color tokens so it tracks the theme. */
.pict-modal-tooltip.chip-tooltip-primary
{
	--pict-modal-tooltip-bg: var(--bulma-primary-40);
	--pict-modal-tooltip-fg: var(--bulma-primary-95);
}
.pict-modal-tooltip.chip-tooltip-link
{
	--pict-modal-tooltip-bg: var(--bulma-link-40);
	--pict-modal-tooltip-fg: var(--bulma-link-95);
}
.pict-modal-tooltip.chip-tooltip-info
{
	--pict-modal-tooltip-bg: var(--bulma-info-40);
	--pict-modal-tooltip-fg: var(--bulma-info-95);
}
.pict-modal-tooltip.chip-tooltip-success
{
	--pict-modal-tooltip-bg: var(--bulma-success-40);
	--pict-modal-tooltip-fg: var(--bulma-success-95);
}
.pict-modal-tooltip.chip-tooltip-warning
{
	--pict-modal-tooltip-bg: var(--bulma-warning-40);
	--pict-modal-tooltip-fg: var(--bulma-warning-95);
}
.pict-modal-tooltip.chip-tooltip-danger
{
	--pict-modal-tooltip-bg: var(--bulma-danger-40);
	--pict-modal-tooltip-fg: var(--bulma-danger-95);
}
`;

},{}],36:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');
const libChipTooltipsCSS = require('./PictProvider-ChipTooltips-CSS.js');

/**
 * ChipTooltips — runtime behavior for the "chips" that the LabelWithChips
 * MetaTemplate renders next to form-field labels.
 *
 * The MetaTemplate emits each chip as a `<button class="chip" data-chip-for
 * data-chip-label ...>` with a zero-width `.chip-label` span. This provider gives
 * the chip its two states:
 *   - UNPINNED: hover / focus shows the chip's value in a portaled pict-section-
 *     modal tooltip (no DOM reflow); and
 *   - PINNED: clicking a chip toggles its whole *type* (e.g. "New",
 *     "ExternalDatabaseID") active and persists it via the existing
 *     HeadlightPaneSettings.toggleChipTypeActive (ActiveChipTypes). That toggles
 *     an `is-active` class on every chip of the type, and the headlight-styles
 *     CSS expands the `.chip-label` inline — the value reads as an extension of
 *     the field label, in the content flow. A pinned chip shows no portaled
 *     tooltip, so pinned chips never overlay the labels/inputs above them.
 *
 * Graceful fallback: if the Pict-Section-Modal view is not registered (or is an
 * older build without richTooltip), the chip falls back to a native `title`
 * tooltip — no hard dependency, nothing breaks. The inline pinned state is
 * independent of the modal (it's pure CSS + the settings view).
 *
 * Wiring is reactive: a MutationObserver re-sweeps as forms re-render (tab
 * switches, recordset row add/remove, dynamic sections), wiring any new chip
 * once and destroying handles for chips that leave the DOM.
 */
class ChipTooltips extends PictProvider
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this._started = false;
		this._sweepPending = false;
		this._observer = null;
		this._cssInjected = false;
		// Per-type hover-tooltip registry: { [chipTypeId]: Array<{ element, handle }> }.
		// `handle` is null for a pinned chip (it shows its value inline, no tooltip).
		this._handlesByType = {};
	}

	/**
	 * Begin wiring chips. Idempotent — safe to call from every host app's
	 * attachInstructions(). No-op outside a browser (tests / SSR).
	 */
	start()
	{
		if (this._started || typeof document === 'undefined')
		{
			return;
		}
		this._started = true;
		this._injectChipCSS();
		// Wire whatever is already on screen, after the current render flushes.
		this._scheduleSweep();
		// Re-wire as forms re-render. MutationObserver is the sanctioned way to
		// react to DOM the framework rebuilds outside our own render cycle.
		if (typeof MutationObserver !== 'undefined' && document.body)
		{
			this._observer = new MutationObserver(() => this._scheduleSweep());
			this._observer.observe(document.body, { childList: true, subtree: true });
		}
	}

	/**
	 * Register + inject the chip CSS once (the chip color/structure styling
	 * lives in the headlight-styles Bulma layer; this is the small set of
	 * component-owned rules — the button-anchor a11y ring and tooltip body).
	 */
	_injectChipCSS()
	{
		if (this._cssInjected || !this.pict || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function')
		{
			return;
		}
		this.pict.CSSMap.addCSS('Headlight-ChipTooltips', libChipTooltipsCSS, 500);
		if (typeof this.pict.CSSMap.injectCSS === 'function')
		{
			this.pict.CSSMap.injectCSS();
		}
		this._cssInjected = true;
	}

	/** Coalesce many mutations into a single wiring pass per tick. */
	_scheduleSweep()
	{
		if (this._sweepPending)
		{
			return;
		}
		this._sweepPending = true;
		setTimeout(() =>
		{
			this._sweepPending = false;
			this.wireChips();
		}, 0);
	}

	/** The modal view, if registered and tooltip-capable; otherwise null. */
	get modal()
	{
		const tmpModal = this.pict && this.pict.views && this.pict.views['Pict-Section-Modal'];
		return (tmpModal && typeof tmpModal.richTooltip === 'function') ? tmpModal : null;
	}

	/** The settings view that owns the persisted ActiveChipTypes preference. */
	get paneSettings()
	{
		return (this.pict && this.pict.views && this.pict.views.HeadlightPaneSettings) || null;
	}

	/**
	 * Whether a chip type is currently "active" (pinned — shows its label inline).
	 *
	 * @param {string} pId
	 * @return {boolean}
	 */
	checkChipTypeActive(pId)
	{
		const tmpView = this.paneSettings;
		return !!(tmpView && typeof tmpView.checkChipTypeActive === 'function' && tmpView.checkChipTypeActive(pId));
	}

	/** Wire every not-yet-wired chip currently in the DOM. */
	wireChips()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		this._pruneDetachedHandles();
		const tmpChips = document.querySelectorAll('.chip[data-chip-for]:not([data-chip-wired])');
		for (let i = 0; i < tmpChips.length; i++)
		{
			this._wireChip(/** @type {HTMLElement} */ (tmpChips[i]));
		}
	}

	/**
	 * Wire a single chip: seed its pinned (is-active) state, attach the click
	 * that toggles the whole type, and give it a hover tooltip while unpinned.
	 *
	 * @param {HTMLElement} pChip
	 */
	_wireChip(pChip)
	{
		pChip.setAttribute('data-chip-wired', 'true');
		const tmpId = pChip.getAttribute('data-chip-for') || '';
		const tmpLabel = pChip.getAttribute('data-chip-label') || '';

		const tmpModal = this.modal;
		if (!tmpModal)
		{
			// Graceful fallback: native tooltip, no reflow, no dependency. (The
			// inline pinned state still works — it's CSS + the settings view.)
			if (tmpLabel)
			{
				pChip.setAttribute('title', tmpLabel);
			}
			return;
		}

		// Seed the persisted pinned state onto chips rendered after load (tab
		// switches, dynamic rows) so the inline label shows immediately; chips
		// present at load already got is-active from the settings view.
		const tmpActive = this.checkChipTypeActive(tmpId);
		if (tmpActive)
		{
			pChip.classList.add('is-active');
		}

		// Click toggles the whole chip TYPE's pinned state + persists it. A real
		// listener, not an inline onclick in the emitted markup.
		pChip.addEventListener('click', (pEvent) => this._onChipToggle(pEvent, tmpId));

		// Hover/focus tooltip for the UNPINNED state only — a pinned chip shows
		// its value inline, so it needs no portaled tooltip.
		const tmpHandle = tmpActive ? null : this._attachHoverTooltip(pChip);

		if (!this._handlesByType[tmpId])
		{
			this._handlesByType[tmpId] = [];
		}
		this._handlesByType[tmpId].push({ element: pChip, handle: tmpHandle });
	}

	/**
	 * Attach a portaled hover/focus tooltip (pict-section-modal richTooltip) to a
	 * chip and return its handle (or null if the modal is unavailable).
	 *
	 * @param {HTMLElement} pChip
	 * @return {?{ destroy: function }}
	 */
	_attachHoverTooltip(pChip)
	{
		const tmpModal = this.modal;
		if (!tmpModal)
		{
			return null;
		}
		const tmpLabel = pChip.getAttribute('data-chip-label') || '';
		// Theme the tooltip bubble to the chip's color variant (e.g. is-info ->
		// chip-tooltip-info); unknown/default variants keep the standard dark
		// tooltip. The chip-tooltip-bubble marker scopes component CSS (e.g. the
		// z-index below the Select2 dropdown) to chip tooltips only. See
		// PictProvider-ChipTooltips-CSS.
		const tmpVariant = (pChip.getAttribute('data-chip-color') || '').replace(/^is-/, '').trim();
		const tmpClassName = 'chip-tooltip-bubble' + (tmpVariant ? ` chip-tooltip-${tmpVariant}` : '');
		return tmpModal.richTooltip(pChip, this._buildTooltipHTML(pChip, tmpLabel),
			{
				position: 'top',
				className: tmpClassName,
			});
	}

	/**
	 * Build the tooltip body for a chip — the icon for brand consistency plus
	 * the chip's text.
	 *
	 * @param {HTMLElement} pChip
	 * @param {string} pLabel
	 * @return {string}
	 */
	_buildTooltipHTML(pChip, pLabel)
	{
		const tmpIcon = pChip.getAttribute('data-chip-icon') || 'fa-info';
		const fEscape = (pStr) => String(pStr == null ? '' : pStr)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		return `<span class="chip-tooltip"><i class="fa fa-fw ${fEscape(tmpIcon)}"></i> ${fEscape(pLabel)}</span>`;
	}

	/**
	 * Toggle a chip TYPE's pinned state on click. Delegates the state change to
	 * HeadlightPaneSettings (flips ActiveChipTypes, toggles the `is-active` class
	 * on every chip of the type so the CSS expands the inline label, and persists
	 * to the server), then reconciles the hover tooltips for that type.
	 *
	 * @param {Event} pEvent
	 * @param {string} pId
	 */
	_onChipToggle(pEvent, pId)
	{
		const tmpView = this.paneSettings;
		if (!tmpView || typeof tmpView.toggleChipTypeActive !== 'function')
		{
			return;
		}
		tmpView.toggleChipTypeActive(pEvent, pId);
		this._syncHoverTooltips(pId);
	}

	/**
	 * Keep the hover tooltips consistent with the pinned state: a pinned chip
	 * shows its value inline and gets no hover tooltip; an unpinned one does.
	 *
	 * @param {string} pId
	 */
	_syncHoverTooltips(pId)
	{
		const tmpActive = this.checkChipTypeActive(pId);
		const tmpList = this._handlesByType[pId] || [];
		for (let i = 0; i < tmpList.length; i++)
		{
			const tmpEntry = tmpList[i];
			if (tmpActive && tmpEntry.handle)
			{
				// Now pinned: drop the portaled hover tooltip (value is inline).
				if (typeof tmpEntry.handle.destroy === 'function')
				{
					tmpEntry.handle.destroy();
				}
				tmpEntry.handle = null;
			}
			else if (!tmpActive && !tmpEntry.handle && tmpEntry.element && tmpEntry.element.isConnected)
			{
				// Now unpinned: (re)attach the hover tooltip.
				tmpEntry.handle = this._attachHoverTooltip(tmpEntry.element);
			}
		}
	}

	/**
	 * Drop handles whose chip element has left the DOM (form re-rendered),
	 * destroying their tooltips so no orphaned tooltip lingers.
	 */
	_pruneDetachedHandles()
	{
		const tmpKeys = Object.keys(this._handlesByType);
		for (let k = 0; k < tmpKeys.length; k++)
		{
			const tmpList = this._handlesByType[tmpKeys[k]];
			const tmpKept = [];
			for (let i = 0; i < tmpList.length; i++)
			{
				const tmpEntry = tmpList[i];
				if (tmpEntry.element && tmpEntry.element.isConnected)
				{
					tmpKept.push(tmpEntry);
				}
				else if (tmpEntry.handle && typeof tmpEntry.handle.destroy === 'function')
				{
					tmpEntry.handle.destroy();
				}
			}
			if (tmpKept.length)
			{
				this._handlesByType[tmpKeys[k]] = tmpKept;
			}
			else
			{
				delete this._handlesByType[tmpKeys[k]];
			}
		}
	}
}

module.exports = ChipTooltips;

},{"./PictProvider-ChipTooltips-CSS.js":35,"pict-provider":479}],37:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const DATA_REQUIREMENTS_SOLVER_SOURCE = 'DataRequirements';

// The host form's own inputs carry no OriginalHash, so they translate to themselves.
const HOST_MANIFEST_COPY = Object.freeze({ RegistrationHash: null, TestHash: null, HashTranslation: Object.freeze({ }), AddressTranslation: Object.freeze({ }) });

class DataRequirementsProvider extends PictProvider
{
	/**
	 * @param {Pict} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - (optional) The options for the provider.
	 * @param {string} [pServiceHash] - (optional) The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { ExpressionParser: any }} */
		this.pict;

		/** @type {import('fable') & import('pict') & { ExpressionParser: any }} */
		this.fable;

		/** @type {Record<string, any>} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		this.pict.instantiateServiceProviderIfNotExists('ExpressionParser');
		this.pict.ExpressionParser.addSolverFunction('settestresult', 'fable.providers.DataRequirementsProvider._setTestResult', 'Sets a test result by hash (for test requirement outcomes)', [ 2, 4 ]);
	}

	/**
	 * @param {string} pTestHash - The hash of the test to set the result for.
	 * @param {string} pTestResult - The test result hash to set for the test.
	 * @param {string} [pPreviousValueAddress] - (optional) If provided, will only apply the change if the current value differes from the previous value (if present).
	 * @param {string} [pCurrentValue] - (optional) Should be provided if pPreviousValueAddress is provided. Value that will be stored if the change is applied.
	 * @param {string} [pPreviousValueFallbackAddress] - (optional) Read when pPreviousValueAddress holds nothing. Documents saved before the last-value key gained a copy scope hold it at the unscoped address.
	 */
	_setTestResult(pTestHash, pTestResult, pPreviousValueAddress, pCurrentValue, pPreviousValueFallbackAddress)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		if (pPreviousValueAddress)
		{
			if (pCurrentValue != null && this._getPreviousTestResultValue(pPreviousValueAddress, pPreviousValueFallbackAddress) === pCurrentValue)
			{
				return;
			}
		}
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SetTestResultByHash:${pTestHash}:${pTestResult}:TempData["${tmpPayloadUUID}"]`);
		if (this.pict.TempData[tmpPayloadUUID])
		{
			// we only set the previous value if the change was applied; ex. in cases where the solver runs before an injected test has been resolved
			if (pPreviousValueAddress)
			{
				this.pict.manifest.setValueByHash(this.pict, pPreviousValueAddress, pCurrentValue);
			}
			delete this.pict.TempData[tmpPayloadUUID];
		}
	}

	/**
	 * The last value a test result outcome was applied for, read from the copy-scoped address and falling back
	 * to the unscoped one a document saved before the scope existed holds. Nothing is written back through the
	 * fallback: an old document keeps the key it was saved with until its outcome actually changes.
	 *
	 * @param {string} pPreviousValueAddress - The address the current solver writes.
	 * @param {string} [pPreviousValueFallbackAddress] - The pre-copy-scope address, when it differs.
	 *
	 * @return {any}
	 */
	_getPreviousTestResultValue(pPreviousValueAddress, pPreviousValueFallbackAddress)
	{
		const tmpValue = this.pict.manifest.getValueByHash(this.pict, pPreviousValueAddress);
		if (tmpValue == null && pPreviousValueFallbackAddress)
		{
			return this.pict.manifest.getValueByHash(this.pict, pPreviousValueFallbackAddress);
		}
		return tmpValue;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after data load is complete.
	 *
	 * @return {void}
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}

			const tmpManifest = this.pict.settings.MyDefaultFormManifest;
			if (!tmpManifest)
			{
				return fCallback();
			}
			const tmpMarshalDestination = this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			this._populateDataRequiremetsForManifest(tmpManifest, tmpMarshalDestination, fCallback);
		});
	}

	/**
	 * Check to see if any new tests need to have data requirements loaded.
	 *
	 * @param {Record<string, any>} pManifest
	 * @param {(pError?: Error) => void} fCallback
	 * @param {Array<string>} [pTestHashes] - (optional) If provided, will include these test hashes when determining data requirements, in addition to any hashes already present in the manifest or marshal destination.
	 */
	updateDataRequirementsForManifest(pManifest, fCallback, pTestHashes)
	{
		if (Array.isArray(pTestHashes) && pTestHashes.length > 0)
		{
			if (this.AppData._DataRequirementsCache && Array.isArray(this.AppData._DataRequirementsCache.Tests))
			{
				if (pTestHashes.every((h) => this.AppData._DataRequirementsCache.Tests.some((t) => t.Hash === h)))
				{
					return fCallback();
				}
			}
		}
		this._populateDataRequiremetsForManifest(pManifest, this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.pict.views.PictFormMetacontroller.viewMarshalDestination), fCallback);
	}

	/**
	 * @param {Record<string, any>} pManifest
	 * @param {Record<string, any>} pMarshalDestination
	 * @param {(pError?: Error) => void} fCallback
	 * @param {Array<string>} [pTestHashes] - (optional) If provided, will include these test hashes.
	 */
	_populateDataRequiremetsForManifest(pManifest, pMarshalDestination, fCallback, pTestHashes)
	{
		const tmpTestHashes = new Set(pTestHashes || []);
		for (const tmpDescriptor of Object.values(pManifest.Descriptors || {}))
		{
			if (tmpDescriptor.PictForm?.TestHashes)
			{
				if (Array.isArray(tmpDescriptor.PictForm.TestHashes))
				{
					for (const tmpHash of tmpDescriptor.PictForm.TestHashes)
					{
						tmpTestHashes.add(tmpHash);
					}
				}
				else
				{
					tmpTestHashes.add(tmpDescriptor.PictForm.TestHashes);
				}
			}
			else if (tmpDescriptor.PictForm && (tmpDescriptor.PictForm.InputType === 'MaterialsTestSelector' || tmpDescriptor.PictForm.InputType === 'MaterialsHiddenTestSelector'))
			{
				if (tmpDescriptor.Default)
				{
					tmpTestHashes.add(tmpDescriptor.Default);
				}
			}
		}
		if (pMarshalDestination && pMarshalDestination.__DynamicSectionData)
		{
			for (const tmpHash of pMarshalDestination.__DynamicSectionData.Sequence)
			{
				const tmpSectionData = pMarshalDestination.__DynamicSectionData[tmpHash];
				if (tmpSectionData && tmpSectionData.TestHash)
				{
					tmpTestHashes.add(tmpSectionData.TestHash);
				}
			}
		}
		const tmpPromises = [];
		if (tmpTestHashes.size > 0)
		{
			tmpPromises.push(this.loadDataRequirementsForTestHashes(Array.from(tmpTestHashes)).catch((pError) =>
			{
				this.log.error('Error loading data requirements for test hashes', { testHashes: Array.from(tmpTestHashes), error: pError });
			}));
		}
		Promise.all(tmpPromises).finally(() => fCallback());
	}

	/**
	 * @param {Array<string>} pTestHashes
	 *
	 * @return {Promise<void>}
	 */
	async loadDataRequirementsForTestHashes(pTestHashes)
	{
		try
		{
			if (pTestHashes.length < 1)
			{
				this.log.info('No test hashes provided, skipping data requirements load.', { testHashes: pTestHashes });
				return;
			}
			const tmpTests = await this._get(`Tests/FilteredTo/FBL~Hash~INN~${pTestHashes.map((h) => encodeURIComponent(h)).join(',')}`);
			if (tmpTests.length < 1)
			{
				this.log.info('No tests found for provided test hashes, unable to determine data requirements.', { testHashes: pTestHashes });
				return;
			}
			const tmpTestSpecificationMaterialTestJoins = await this._getAll(`TestSpecificationMaterialTestJoins/FilteredTo/FBL~IDTest~INN~${tmpTests.map((t) => t.IDTest).join(',')}`);
			const tmpTestSpecificationIDs = Array.from(new Set(tmpTestSpecificationMaterialTestJoins.map((j) => j.IDTestSpecification)));
			const tmpHasSpecifications = tmpTestSpecificationIDs.length > 0;
			const tmpTestSpecificationRequirements = tmpHasSpecifications ? await this._getAll(`TestSpecificationRequirements/FilteredTo/FBL~IDTestSpecification~INN~${tmpTestSpecificationIDs.join(',')}`) : [ ];
			const tmpTestSpecifications = tmpHasSpecifications ? await this._getAll(`TestSpecifications/FilteredTo/FBL~IDTestSpecification~INN~${tmpTestSpecificationIDs.join(',')}`) : [ ];
			const tmpTestSpecificationToSetIDMap = {};
			for (const tmpTestSpecification of tmpTestSpecifications)
			{
				tmpTestSpecificationToSetIDMap[tmpTestSpecification.IDTestSpecification] = tmpTestSpecification.IDTestSpecificationSet;
			}
			this.AppData._DataRequirementsCache =
			{
				Tests: tmpTests ?? [],
				TestSpecificationMaterialTestJoins: tmpTestSpecificationMaterialTestJoins ?? [],
				TestSpecificationRequirements: tmpTestSpecificationRequirements ?? [],
				TestSpecifications: tmpTestSpecifications ?? [],
				TestSpecificationToSetIDMap: tmpTestSpecificationToSetIDMap ?? [],
			};
			if (this.AppData._DataRequirementsDeferredLoad)
			{
				const tmpParams = this.AppData._DataRequirementsDeferredLoad;
				delete this.AppData._DataRequirementsDeferredLoad;
				await this.applyDataRequirements(tmpParams.Manifest, tmpParams.SampleRecord);
			}
		}
		catch (pError)
		{
			this.log.error('Failed to load data requirements for test hashes', { testHashes: pTestHashes, error: pError });
		}
	}

	/**
	 * @param {Record<string, any>} pManifest
	 * @param {Record<string, any>} pSampleRecord
	 */
	async applyDataRequirements(pManifest, pSampleRecord)
	{
		if (!pSampleRecord)
		{
			this.log.warn('No valid sample record provided, unable to determine data requirements.', { sampleRecord: pSampleRecord });
			return;
		}
		if (!this.AppData._DataRequirementsCache || !Array.isArray(this.AppData._DataRequirementsCache.TestSpecificationMaterialTestJoins) ||
			!Array.isArray(this.AppData._DataRequirementsCache.TestSpecificationRequirements) || this.AppData._DataRequirementsCache.TestSpecificationRequirements.length < 1)
		{
			//FIXME: defer in case cache is still loading?
			this.AppData._DataRequirementsDeferredLoad = { Manifest: pManifest, SampleRecord: pSampleRecord };
			return;
		}
		const tmpSample = pSampleRecord;
		let tmpTestSpecificationSet;
		if (tmpSample)
		{
			if (tmpSample.IDProject > 0)
			{
				const tmpProject = await this._get(`Projects/Lite/FilteredTo/FBV~IDProject~EQ~${tmpSample.IDProject}`).then((projects) => projects[0]);
				if (tmpProject)
				{
					const tmpContract = await this._get(`Contract/${tmpProject.IDContract}`);
					if (tmpContract)
					{
						if (tmpContract.ItemIDTestSpecificationSet > 0)
						{
							tmpTestSpecificationSet = await this._get(`TestSpecificationSets/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpContract.ItemIDTestSpecificationSet}`).then((sets) => sets[0]);
						}
						if (!tmpTestSpecificationSet && tmpContract.ItemSpecificationYear)
						{
							// A year is NOT unique (a provisional set can share it with the live one) and nothing on
							// the record distinguishes them — take the lowest id and flag the ambiguity.
							tmpTestSpecificationSet = await this._get(`TestSpecificationSets/FilteredTo/FBV~Year~EQ~${tmpContract.ItemSpecificationYear}~FSF~IDTestSpecificationSet~ASC~0`).then((sets) =>
							{
								if (Array.isArray(sets) && sets.length > 1)
								{
									this.log.warn(`Specification year ${tmpContract.ItemSpecificationYear} matches ${sets.length} specification sets; using the lowest id (${sets[0]?.IDTestSpecificationSet}). Set the contract's ItemIDTestSpecificationSet to resolve this explicitly.`);
								}
								return Array.isArray(sets) ? sets[0] : undefined;
							});
						}
					}
				}
			}
			if (!tmpTestSpecificationSet)
			{
				//FIXME: default specification set logic?
				this.log.info('Sample is not linked to a project, unable to determine specification set based on project contract. Defaulting to most recent specification set.', { sampleRecord: pSampleRecord });
				tmpTestSpecificationSet = await this._get(`TestSpecificationSets/FilteredTo/FSF~Year~DESC~0/0/1`).then((sets) => sets[0]);
			}
			if (!tmpTestSpecificationSet)
			{
				this.log.warn('No test specification sets found, unable to determine test specification requirements.', { sampleRecord: pSampleRecord });
				return;
			}
			const tmpSampleIDMaterial = tmpSample.IDMaterial ?? 0;
			const tmpValidSpecs = new Set();
			for (const tmpSpec of this.AppData._DataRequirementsCache.TestSpecifications)
			{
				if (tmpSpec.IDTestSpecificationSet == tmpTestSpecificationSet.IDTestSpecificationSet)
				{
					tmpValidSpecs.add(tmpSpec.IDTestSpecification);
				}
			}
			const tmpSpecificationMaterialJoins = this.AppData._DataRequirementsCache.TestSpecificationMaterialTestJoins
				.filter((j) => j.IDMaterial == tmpSampleIDMaterial && tmpValidSpecs.has(j.IDTestSpecification));
			const tmpSpecificationIDs = new Set(tmpSpecificationMaterialJoins.map((j) => j.IDTestSpecification));
			const tmpTestSpecificationRequirements = this.AppData._DataRequirementsCache.TestSpecificationRequirements
				.filter((r) => tmpSpecificationIDs.has(r.IDTestSpecification));
			if (tmpTestSpecificationRequirements.length < 1)
			{
				return;
			}

			// convert requirements into solver statements, once per copy of the test the requirement targets
			const tmpHostTestHashes = this._collectHostTestHashes(pManifest);
			const tmpSolvers = [];
			for (const tmpRequirement of tmpTestSpecificationRequirements)
			{
				const tmpTestID = tmpSpecificationMaterialJoins.find((j) => j.IDTestSpecification === tmpRequirement.IDTestSpecification)?.IDTest;
				const tmpTest = this.AppData._DataRequirementsCache.Tests.find((t) => t.IDTest === tmpTestID);
				const tmpCopies = this._resolveRequirementCopies(tmpTest?.Hash, tmpHostTestHashes);
				if (tmpCopies.length < 1)
				{
					this.log.info(`Test specification requirement ${tmpRequirement.IDTestSpecificationRequirement} targets test ${tmpTest?.Hash ?? tmpTestID}, which is not on this form; skipping it.`,
						{ IDTestSpecificationRequirement: tmpRequirement.IDTestSpecificationRequirement, IDTest: tmpTestID, TestHash: tmpTest?.Hash });
					continue;
				}
				for (const tmpCopy of tmpCopies)
				{
					tmpSolvers.push(...this._buildRequirementSolvers(pManifest, tmpRequirement, tmpTest, tmpTestID, tmpCopy, tmpCopies.length));
				}
			}
			if (tmpSolvers.length > 0)
			{
				this._replaceGeneratedValidationSolvers(pManifest, tmpSolvers);
				if (this.pict.PictApplication)
				{
					this.pict.PictApplication.solve();
				}
			}
		}
	}

	/**
	 * The test hashes the host form declares on its own inputs. A descriptor carrying an OriginalHash or an
	 * OriginalDataAddress came from an injected copy, which the section manager tracks separately; what is
	 * left is the host's own, and its references translate to themselves.
	 *
	 * @param {Record<string, any>} pManifest - The merged form manifest.
	 *
	 * @return {Set<string>}
	 */
	_collectHostTestHashes(pManifest)
	{
		const tmpTestHashes = new Set();
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || { }))
		{
			if (tmpDescriptor.OriginalHash || tmpDescriptor.OriginalDataAddress)
			{
				continue;
			}
			if (tmpDescriptor.PictForm?.TestHashes)
			{
				const tmpDescriptorHashes = Array.isArray(tmpDescriptor.PictForm.TestHashes) ? tmpDescriptor.PictForm.TestHashes : [ tmpDescriptor.PictForm.TestHashes ];
				for (const tmpHash of tmpDescriptorHashes)
				{
					tmpTestHashes.add(tmpHash);
				}
			}
			else if (tmpDescriptor.PictForm && (tmpDescriptor.PictForm.InputType === 'MaterialsTestSelector' || tmpDescriptor.PictForm.InputType === 'MaterialsHiddenTestSelector'))
			{
				if (tmpDescriptor.Default)
				{
					tmpTestHashes.add(tmpDescriptor.Default);
				}
			}
		}
		return tmpTestHashes;
	}

	/**
	 * Which copies of a test's inputs a requirement should be solved against.
	 *
	 * A test can be injected more than once, and every injected copy carries the same OriginalHash values, so
	 * the translation has to come from the copy the section manager recorded at injection rather than from the
	 * merged form manifest. A test the host form owns needs no translation at all.
	 *
	 * @param {string} [pTestHash] - The Test.Hash the requirement resolved to.
	 * @param {Set<string>} pHostTestHashes - The test hashes the host form declares on its own inputs.
	 *
	 * @return {Array<Record<string, any>>} - One entry per copy; empty when the test is not on this form.
	 */
	_resolveRequirementCopies(pTestHash, pHostTestHashes)
	{
		const tmpSectionManager = this.pict.providers?.DocumentDynamicSectionManager;
		if (pTestHash && tmpSectionManager && typeof tmpSectionManager.getInjectedManifestTranslationsForTestHash === 'function')
		{
			const tmpInjectedCopies = tmpSectionManager.getInjectedManifestTranslationsForTestHash(pTestHash);
			if (tmpInjectedCopies.length > 0)
			{
				return tmpInjectedCopies;
			}
		}
		if (!pTestHash || !tmpSectionManager || pHostTestHashes.has(pTestHash))
		{
			return [ HOST_MANIFEST_COPY ];
		}
		return [];
	}

	/**
	 * The descriptor an outcome target names, within one copy of the manifest.
	 *
	 * @param {Record<string, any>} pManifest - The merged form manifest.
	 * @param {string} pInputHash - The input hash as the requirement names it, before any salting.
	 * @param {Record<string, any>} pCopy - The copy to resolve within.
	 *
	 * @return {Record<string, any>|undefined}
	 */
	_findCopyDescriptor(pManifest, pInputHash, pCopy)
	{
		const tmpCopyHash = pCopy.RegistrationHash ? pCopy.HashTranslation[pInputHash] : pInputHash;
		if (!tmpCopyHash)
		{
			return undefined;
		}
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || { }))
		{
			if (tmpDescriptor.Hash !== tmpCopyHash || !tmpDescriptor.PictForm || !tmpDescriptor.PictForm.Section)
			{
				continue;
			}
			if (!pCopy.RegistrationHash && tmpDescriptor.OriginalHash)
			{
				continue;
			}
			return tmpDescriptor;
		}
		return undefined;
	}

	/**
	 * Build the validation solvers for one requirement against one copy of the test's inputs, rewritten
	 * through that copy's own translation maps.
	 *
	 * @param {Record<string, any>} pManifest - The merged form manifest.
	 * @param {Record<string, any>} pRequirement - The TestSpecificationRequirement row.
	 * @param {Record<string, any>} [pTest] - The Test row the requirement resolved to.
	 * @param {number} [pTestID] - The IDTest the requirement resolved to, for diagnostics when pTest is missing.
	 * @param {Record<string, any>} pCopy - The copy to solve against.
	 * @param {number} pCopyCount - How many copies of this test are on the form.
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_buildRequirementSolvers(pManifest, pRequirement, pTest, pTestID, pCopy, pCopyCount)
	{
		const tmpSolvers = [];
		const tmpLegacyResultKey = `Result_${pRequirement.IDTestSpecificationRequirement}`;
		// The last-value address is written into FormData and persisted with the document, so the key only
		// gains a copy scope where it has to: when the same test is on the form more than once. A form with a
		// single copy keeps the key every document saved before this change already holds.
		const tmpResultKey = (pCopyCount > 1 && pCopy.RegistrationHash) ? `${tmpLegacyResultKey}_${pCopy.RegistrationHash}` : tmpLegacyResultKey;
		const tmpResultAddress = `TempData._DataRequirementsValues.${tmpResultKey}`;
		const tmpLastValueAddress = `AppData.DocumentData.ReportData.FormData._DataRequirementsLastValues.${tmpResultKey}`;
		const tmpLegacyLastValueAddress = `AppData.DocumentData.ReportData.FormData._DataRequirementsLastValues.${tmpLegacyResultKey}`;
		const tmpComputationTemplate = pRequirement.ComputationTemplate;
		switch (pRequirement.OperationType)
		{
		case 'AddressInRange':
			// get value at address in ComputationTemplate
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, ">=", "${pRequirement.ValueMinimum}", IF(${tmpComputationTemplate}, "<=", "${pRequirement.ValueMaximum}", 1, 0), 0))`);
			break;
		case 'AddressOutOfRange':
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, ">=", "${pRequirement.ValueMaximum}", 1, IF(${tmpComputationTemplate}, "<=", "${pRequirement.ValueMinimum}", 1, 0)))`);
			break;
		case 'Solver': // just run it; outcome doesn't matter
			tmpSolvers.push(tmpComputationTemplate);
			return this._translateCopySolvers(tmpSolvers, pCopy);
		case 'TrueExpression':
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, "==", "true", 1, IF(${tmpComputationTemplate}, "==", 1, 1, IF(${tmpComputationTemplate}, "==", "yes", 1, 0))))`);
			break;
		case 'FalseExpression':
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, "==", "true", 0, IF(${tmpComputationTemplate}, "==", 1, 0, IF(${tmpComputationTemplate}, "==", "yes", 0, 1))))`);
			break;
		}
		const tmpOutcomeTargets = typeof pRequirement.OutcomeTargets !== 'string' ? [] : pRequirement.OutcomeTargets.split(',').map((t) => t.trim()).filter((t) => t.length > 0);
		switch (pRequirement.OutcomeType)
		{
		case 'ColorInputs':
			for (const tmpInputHash of tmpOutcomeTargets)
			{
				const tmpDescriptor = this._findCopyDescriptor(pManifest, tmpInputHash, pCopy);
				if (!tmpDescriptor)
				{
					continue;
				}
				//TODO: is there a risk of having quoted values in the DB?
				const tmpOutcome = `IF(GETVALUE("${tmpResultAddress}"), "==", 1, "${pRequirement.ComputationSuccessOutcome}", "${pRequirement.ComputationFailureOutcome}")`;
				tmpSolvers.push(`colorinputbackground("${tmpDescriptor.PictForm.Section}", "${tmpInputHash}", ${tmpOutcome}, WHEN(${tmpOutcome}, 1, 0))`);
			}
			break;
		case 'ShowSection':
			for (const tmpSectionHash of tmpOutcomeTargets)
			{
				tmpSolvers.push(`setsectionvisibility("${tmpSectionHash}", GETVALUE("${tmpResultAddress}"))`);
			}
			break;
		case 'HideSection':
			for (const tmpSectionHash of tmpOutcomeTargets)
			{
				tmpSolvers.push(`setsectionvisibility("${tmpSectionHash}", IF(GETVALUE("${tmpResultAddress}"), "==", 1, 0, 1))`);
			}
			break;
		case 'AssignContent':
			// do we have a solver function for this? do not think so... just doing an assingment for now
			for (const tmpOutputHash of tmpOutcomeTargets)
			{
				tmpSolvers.push(`${tmpOutputHash} = IF(GETVALUE("${tmpResultAddress}"), ${pRequirement.ComputationSuccessOutcome}, ${pRequirement.ComputationFailureOutcome}))`);
			}
			break;
		case 'TestResult':
			{
				//FIXME: should these somehow use tracking GUIDs? this still falls over when the same test is on
				//       the form twice: the solver names the test by hash, so the result lands on whichever
				//       TestInstance the global event resolves first.
				// The fifth argument is the pre-copy-scope address, so a document saved before the key gained a
				// scope is still read rather than re-applied from scratch.
				const tmpLastValueArguments = (tmpResultKey === tmpLegacyResultKey) ? `"${tmpLastValueAddress}", GETVALUE("${tmpResultAddress}")` : `"${tmpLastValueAddress}", GETVALUE("${tmpResultAddress}"), "${tmpLegacyLastValueAddress}"`;
				tmpSolvers.push(`settestresult("${pTest?.Hash ?? `test ${pTestID} not found`}", IF(GETVALUE("${tmpResultAddress}"), "==", 1, "${pRequirement.ComputationSuccessOutcome}", "${pRequirement.ComputationFailureOutcome}"), ${tmpLastValueArguments})`);
			}
			break;
		}
		return this._translateCopySolvers(tmpSolvers, pCopy);
	}

	/**
	 * Rewrite raw solver expressions through one copy's translation maps and wrap them as generated solvers.
	 *
	 * @param {Array<string>} pSolverExpressions - The raw expressions.
	 * @param {Record<string, any>} pCopy - The copy whose maps to rewrite through.
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_translateCopySolvers(pSolverExpressions, pCopy)
	{
		return pSolverExpressions.map((pExpression) => (
			{
				Expression: this.pict.views.PictFormMetacontroller.rewriteSolverExpression(pExpression, pCopy.HashTranslation, pCopy.AddressTranslation),
				Ordinal: 1,
				SolverSource: DATA_REQUIREMENTS_SOLVER_SOURCE,
			}));
	}

	/**
	 * Is this validation solver one this provider generated from test specification requirements?
	 *
	 * @param {any} pSolver - A validation solver entry, either an expression string or a solver object.
	 *
	 * @return {boolean}
	 */
	_isGeneratedValidationSolver(pSolver)
	{
		return (pSolver != null) && (typeof pSolver === 'object') && (pSolver.SolverSource === DATA_REQUIREMENTS_SOLVER_SOURCE);
	}

	/**
	 * Swap the validation solvers this provider generated on a previous pass for a freshly generated set,
	 * in place, leaving every other entry alone.
	 *
	 * The form manifest's ValidationSolvers array is shared: the metacontroller merges each injected
	 * section copy's translated solvers into it, so this provider may only touch its own entries.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest holding the validation solvers.
	 * @param {Array<Record<string, any>>} pGeneratedSolvers - The generated solvers to write.
	 *
	 * @return {void}
	 */
	_replaceGeneratedValidationSolvers(pManifest, pGeneratedSolvers)
	{
		const tmpExistingSolvers = Array.isArray(pManifest.ValidationSolvers) ? pManifest.ValidationSolvers : [];
		let tmpInsertAtIndex = tmpExistingSolvers.findIndex((pSolver) => this._isGeneratedValidationSolver(pSolver));
		const tmpRetainedSolvers = tmpExistingSolvers.filter((pSolver) => !this._isGeneratedValidationSolver(pSolver));
		if (tmpInsertAtIndex < 0)
		{
			tmpInsertAtIndex = tmpRetainedSolvers.length;
		}
		tmpRetainedSolvers.splice(tmpInsertAtIndex, 0, ...pGeneratedSolvers);
		pManifest.ValidationSolvers = tmpRetainedSolvers;
	}

	/**
	 * @param {any} pValue
	 *
	 * @return {boolean}
	 */
	_isTruthy(pValue)
	{
		if (pValue == null)
		{
			return false;
		}
		if (typeof pValue === 'boolean')
		{
			return pValue;
		}
		if (typeof pValue === 'number')
		{
			return pValue != 0;
		}
		const tmpCleanValue = String(pValue).trim().toLowerCase();
		return tmpCleanValue == '1' || tmpCleanValue == 'true' || tmpCleanValue == 'yes' || tmpCleanValue == 'y' || tmpCleanValue == 't';
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 *
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {string} uri - The URI to get all results from, should include any necessary filtering but not pagination (skip/take).
	 *
	 * @return {Promise<Array<any>>} - The aggregated results from all pages.
	 */
	async _getAll(uri)
	{
		let tmpResults = [];
		let tmpSkip = 0;
		const tmpPageSize = 250;
		while (true)
		{
			const tmpPage = await this._get(`${uri}/${tmpSkip}/${tmpPageSize}`);
			tmpResults = tmpResults.concat(tmpPage);
			if (tmpPage.length < tmpPageSize)
			{
				break;
			}
			tmpSkip += tmpPageSize;
		}
		return tmpResults;
	}
}

module.exports = DataRequirementsProvider;
module.exports.default_configuration =
{
	// register to receive data load/save lifecycle events, which are off by default
	AutoSaveDataWithApp: true,
	// default ordinal is zero; we want to come after other providers (ex. the dynamic section manager) so any existing dynamic sections are already loaded when we run
	AutoLoadDataOrdinal: 1,
};

},{"headlight-rest-client":12,"pict-provider":479}],38:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// default date format in DayJS format
		this.defaultDateFormat = 'YYYY-MM-DD';
	}

	getDateHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getDateDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DATE-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularDateHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATE-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDateDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATE-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pValue The the date value in ISO format.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} pRowIndex The row index
	 */
	configureFlatpickr(pInput, pValue, isTabular = false, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			return;
		}
		// NOTE: pValue is expected to be in ISO format (e.g., "2024-06-01T00:00:00Z") for proper timezone handling
		this.pict.providers.FlatpickrUtilProvider.initializeFlatpickr({
			PickerType: 'date',
			AllowInput: true,
			HTMLID: isTabular ? this.getTabularDateDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getDateDisplayInputHTMLID(pInput.Macro.RawHTMLID),
			ISODateString: pValue,
			Timezone: pInput.PictForm.Timezone || this.fable.options.Timezone,
			DayJSDateFormat: pInput.PictForm.DateFormat || this.defaultDateFormat, // ex: 'YYYY-MM-DD'
			DefaultValue: pInput.Default,
			DisablePicker: pInput.PictForm.Disabled || false,
		});
	}

	/**
	 * Resolve a logical default token ('now'/'today') carried in the marshaled model
	 * value to a concrete ISO string and lock that value into the form's data model, so
	 * a defaulted-but-untouched field persists the instant it was created instead of
	 * re-evaluating live on every reload. Returns the (possibly resolved) value to use
	 * for the rest of the marshal. Non-token values pass through untouched.
	 *
	 * @param {Object} pView - The dynamic form view.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The marshaled model value.
	 * @param {number} [pRowIndex] - Row index when marshaling a tabular cell.
	 * @return {any} The value to continue the marshal with (resolved ISO for tokens).
	 */
	lockInSpecialDefault(pView, pInput, pValue, pRowIndex)
	{
		const tmpFlatpickr = this.pict.providers.FlatpickrUtilProvider;
		if (!tmpFlatpickr.isSpecialDefaultValue(pValue))
		{
			return pValue;
		}
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpResolvedISO = tmpFlatpickr.resolveSpecialDefaultToISO(pValue, tmpTimezone, 'date');
		if (pView && typeof pView.getMarshalDestinationObject === 'function' && pView.sectionManifest)
		{
			let tmpAddress = pInput.Hash;
			if (pRowIndex != null)
			{
				tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpAddress, tmpResolvedISO);
		}
		return tmpResolvedISO;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat);
		this.pict.ContentAssignment.assignContent(this.getDateHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getDateDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, false, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue, pRowIndex);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat);
		this.pict.ContentAssignment.assignContent(this.getTabularDateHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getTabularDateDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getDateDisplayInputHTMLID(pInput.Macro.RawHTMLID));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'date',
				);
				this.pict.ContentAssignment.assignContent(this.getDateHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpISOValue);
				pView.dataChanged(pInput.Hash);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Date input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTabularDateDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'date',
				);
				this.pict.ContentAssignment.assignContent(this.getTabularDateHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpISOValue);
				pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Date tabular input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],39:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// whether to use 24-hour time format
		this.use24HourTime = false;
		this.defaultDateFormat = this.use24HourTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD hh:mm a';
	}

	getDateTimeHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getDateTimeDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DATETIME-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularDateTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDateTimeInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pValue The the date value in ISO format.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} pRowIndex The row index
	 */
	configureFlatpickr(pInput, pValue, isTabular = false, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			return;
		}
		// NOTE: pValue is expected to be in ISO format (e.g., "2024-06-01T00:00:00Z") for proper timezone handling
		this.pict.providers.FlatpickrUtilProvider.initializeFlatpickr({
			PickerType: 'datetime',
			AllowInput: true,
			HTMLID: isTabular ? this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getDateTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID),
			HiddenInputSelector: isTabular ? this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID),
			ISODateString: pValue,
			Timezone: pInput.PictForm.Timezone || this.fable.options.Timezone,
			DayJSDateFormat: pInput.PictForm.DateFormat || this.defaultDateFormat, // ex: 'YYYY-MM-DD'
			DefaultValue: pInput.Default,
			DisablePicker: pInput.PictForm.Disabled || false,
			Time24Hour: this.use24HourTime,
		});
	}

	/**
	 * Resolve a logical default token ('now'/'today') carried in the marshaled model
	 * value to a concrete ISO string and lock that value into the form's data model, so
	 * a defaulted-but-untouched field persists the instant it was created instead of
	 * re-evaluating live on every reload. Returns the (possibly resolved) value to use
	 * for the rest of the marshal. Non-token values pass through untouched.
	 *
	 * @param {Object} pView - The dynamic form view.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The marshaled model value.
	 * @param {number} [pRowIndex] - Row index when marshaling a tabular cell.
	 * @return {any} The value to continue the marshal with (resolved ISO for tokens).
	 */
	lockInSpecialDefault(pView, pInput, pValue, pRowIndex)
	{
		const tmpFlatpickr = this.pict.providers.FlatpickrUtilProvider;
		if (!tmpFlatpickr.isSpecialDefaultValue(pValue))
		{
			return pValue;
		}
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpResolvedISO = tmpFlatpickr.resolveSpecialDefaultToISO(pValue, tmpTimezone, 'datetime');
		if (pView && typeof pView.getMarshalDestinationObject === 'function' && pView.sectionManifest)
		{
			let tmpAddress = pInput.Hash;
			if (pRowIndex != null)
			{
				tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpAddress, tmpResolvedISO);
		}
		return tmpResolvedISO;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.use24HourTime = pInput.PictForm.Time24Hour || false;
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat);
		this.pict.ContentAssignment.assignContent(this.getDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getDateTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, false, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.use24HourTime = pInput.PictForm.Time24Hour || false;
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue, pRowIndex);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat);
		this.pict.ContentAssignment.assignContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpDisplayDate);
		this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpValue);
		this.configureFlatpickr(pInput, tmpValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a datetime input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getDateTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'datetime',
				);
				this.pict.ContentAssignment.assignContent(this.getDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpISOValue);
				pView.dataChanged(pInput.Hash);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`DateTime input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular datetime input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'datetime',
				);
				this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpISOValue);
				pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`DateTime tabular input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Special handling for filters inputs, do not remove.
		if (pView.Hash === 'PSRSFilterProxyView')
		{
			pValue = this.pict.fable.Dates.dayJS(pValue).toISOString();
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.InformaryDataAddress, pValue);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],40:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// whether to use 24-hour time format
		this.use24HourTime = false;
		this.defaultDateFormat = this.use24HourTime ? 'HH:mm' : 'hh:mm a';
	}

	getTimeHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getTimeDisplayInputHTMLID(pInputHTMLID)
	{
		return `#TIME-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularTimeDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pValue The the date value in ISO format.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} pRowIndex The row index
	 */
	configureFlatpickr(pInput, pValue, isTabular = false, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			return;
		}
		// NOTE: pValue is expected to be in ISO format (e.g., "2024-06-01T00:00:00Z") for proper timezone handling
		this.pict.providers.FlatpickrUtilProvider.initializeFlatpickr({
			PickerType: 'time',
			AllowInput: true,
			HTMLID: isTabular ? this.getTabularTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID),
			HiddenInputSelector: isTabular ? this.getTabularTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID),
			ISODateString: pValue,
			Timezone: pInput.PictForm.Timezone || this.fable.options.Timezone,
			DayJSDateFormat: pInput.PictForm.DateFormat || this.defaultDateFormat, // ex: 'YYYY-MM-DD'
			DefaultValue: pInput.Default,
			DisablePicker: pInput.PictForm.Disabled || false,
			Time24Hour: this.use24HourTime,
		});
	}
	/**
	 * Resolve a logical default token ('now'/'today') carried in the marshaled model
	 * value to a concrete ISO string and lock that value into the form's data model, so
	 * a defaulted-but-untouched field persists the instant it was created instead of
	 * re-evaluating live on every reload. Returns the (possibly resolved) value to use
	 * for the rest of the marshal. Non-token values pass through untouched.
	 *
	 * @param {Object} pView - The dynamic form view.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The marshaled model value.
	 * @param {number} [pRowIndex] - Row index when marshaling a tabular cell.
	 * @return {any} The value to continue the marshal with (resolved ISO for tokens).
	 */
	lockInSpecialDefault(pView, pInput, pValue, pRowIndex)
	{
		const tmpFlatpickr = this.pict.providers.FlatpickrUtilProvider;
		if (!tmpFlatpickr.isSpecialDefaultValue(pValue))
		{
			return pValue;
		}
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpResolvedISO = tmpFlatpickr.resolveSpecialDefaultToISO(pValue, tmpTimezone, 'time');
		if (pView && typeof pView.getMarshalDestinationObject === 'function' && pView.sectionManifest)
		{
			let tmpAddress = pInput.Hash;
			if (pRowIndex != null)
			{
				tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpAddress, tmpResolvedISO);
		}
		return tmpResolvedISO;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.use24HourTime = pInput.PictForm.Time24Hour || false;
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat, tmpTimezone, true);
		this.pict.ContentAssignment.assignContent(this.getTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, false, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.use24HourTime = pInput.PictForm.Time24Hour || false;
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue, pRowIndex);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat, tmpTimezone, true);
		this.pict.ContentAssignment.assignContent(this.getTabularTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getTabularTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a time input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'time',
				);
				this.pict.ContentAssignment.assignContent(this.getTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpISOValue);
				pView.dataChanged(pInput.Hash);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Time input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular time input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTabularTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'time',
				);
				this.pict.ContentAssignment.assignContent(this.getTabularTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpISOValue);
				pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Time tabular input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],41:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
/**
 * @typedef {Object} DraggableOptions
 * @property {boolean} [limitToOwnCollection] - If true, items can only be dropped within the same parent container, preventing cross-container dragging. This is useful for maintaining logical groupings of items.
 * @property {boolean} [disabled] - If true, the draggable behavior will not be initialized, preventing any reordering of items. This is useful for locked or read-only states.
 * @property {string} [elementSelector] - CSS selector for the draggable element. If not provided, the entire container element will be draggable.
 * @property {function(HTMLElement, HTMLElement): void} [onDrag] - Callback function that is called continuously while dragging. Receives the dragged element and the current event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragStart] - Callback function that is called when dragging starts. Receives the dragged element and the original event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragEnter] - Callback function that is called when the dragged element enters a valid drop target. Receives the dragged element and the drop target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragOver] - Callback function that is called when the dragged element is moved over a valid drop target. Receives the dragged element and the current event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragLeave] - Callback function that is called when the dragged element leaves a valid drop target. Receives the dragged element and the drop target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragEnd] - Callback function that is called when dragging ends. Receives the dragged element and the original event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDrop] - Callback function that is called when the dragged element is dropped. Receives the dragged element and the drop target as arguments.
*/

class DraggableUtil extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.customCSSInjected = false;
		this.animationDuration = 500; // default duration for any animations related to dragging (e.g., shake animation when drop is denied)
		this.outlineThickness = 3; // default thickness for outlines when dragging over valid drop targets
	}

	/**
	 * Inject the custom CSS styles for the draggable behavior into the document head. This includes styles for the draggable items, drag-over states,
	 * and any animations for denied drops. The method checks if the styles have already been injected to avoid duplicates.
	 * @returns {void}
	 */
	injectCustomCSS()
	{
		if (this.customCSSInjected || document.getElementById('DraggableUtil-Styles')) return;

		const styleElement = document.createElement('style');
		styleElement.id = 'DraggableUtil-Styles';
		styleElement.textContent = /*css*/`
			/* Draggable item styles */
			[draggable="true"] {
				cursor: move;
				transition: transform 150ms ease, border-color 150ms ease;
			}
			/* Optional drag class for styling the dragged element */
			.is-dragging {
				opacity: 0.5;
			}
			/* Optional class for styling drop targets when an item is dragged over them */
			.is-drag-over {
				border: calc(${this.outlineThickness}px) solid var(--bulma-info);
				transform: scale(1.1, 1.1);
			}
			/* Optional class for styling drop targets when a drop is denied - shakes */
			.is-drag-over-denied {
				border: calc(${this.outlineThickness}px) solid var(--bulma-danger);
			}
			/* Optional class for styling the drop container when a drop is denied - shakes */
			.is-drag-over-denied-collection {
				animation: shake ${this.animationDuration}ms ease;
			}
			@keyframes shake {
				0% { transform: translate(0, 0) }
				25% { transform: translate(-5px, 0) }
				50% { transform: translate(5px, 0) }
				75% { transform: translate(-5px, 0) }
				100% { transform: translate(0, 0) }	
			}`;
		document.head.appendChild(styleElement);
		this.customCSSInjected = true;
	}

	/**
	 * Initializes the draggable behavior on a given element with specified options.
	 * @param {HTMLElement} containerElement - The container element that holds the draggable items.
	 * @param {DraggableOptions} options - Configuration options for the draggable behavior.
	 */
	initializeDraggableCollection(containerElement, options)
	{
		// If disabled option is set, do not initialize draggable behavior (these are for locked/readonly states)
		if (options.disabled)
		{
			this.pict.log.info('DraggableUtil: Draggable behavior is prevented by options, skipping initialization.');
			return;
		}
		if (!containerElement)
		{
			this.pict.log.warn('DraggableUtil: No container element provided for initializing draggable collection.');
			return;
		}
		if (options.elementSelector && typeof options.elementSelector !== 'string')
		{
			this.pict.log.warn('DraggableUtil: Invalid elementSelector provided in options. Expected a string CSS selector. Draggable behavior will not be initialized.');
			return;
		}
		this.injectCustomCSS();

		// make each item in the container that matches the elementSelector draggable and apply the necessary event listeners for drag-and-drop interactions
		const draggableItems = containerElement.querySelectorAll(options.elementSelector);
		draggableItems.forEach((item) =>
		{
			this.makeElementDraggable(/** @type {HTMLElement} */ (item), options);
		});
	}

	/**
	 * Makes a single element draggable and applies the necessary event listeners for drag-and-drop interactions.
	 * @param {HTMLElement|String} pElement - The element node or selector string to be made draggable.
	 * @param {DraggableOptions} pOptions - Configuration options for the draggable behavior.
	 */
	makeElementDraggable(pElement, pOptions)
	{
		if (pOptions.disabled)
		{
			this.pict.log.info('DraggableUtil: Draggable behavior is disabled by options, skipping initialization.');
			return;
		}
		const tmpElementNode = typeof pElement === 'string' ? document.querySelector(pElement) : pElement;
		if (!tmpElementNode)
		{
			this.pict.log.warn('DraggableUtil: No element found for making draggable with selector:', pElement);
			return;
		}
		tmpElementNode.setAttribute('draggable', 'true');
		tmpElementNode.classList.add('is-draggable');
		tmpElementNode.setAttribute('data-draggable-id', `draggable-${Math.random().toString(36).substr(2, 9)}`); // Assign a unique ID for tracking
		this.applyEventListenersToCard(/** @type {HTMLElement} */ (tmpElementNode), pOptions);
	}

	/**
	 * Applies the necessary event listeners to a draggable item for handling drag-and-drop interactions.
	 * @param {HTMLElement} item - The draggable item element.
	 * @param {DraggableOptions} options - Configuration options for the draggable behavior.
	 */
	applyEventListenersToCard(item, options)
	{
		item.addEventListener('dragstart', (/** @type {DragEvent} */ event) =>
		{
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			this._dragSourceElement = item;
			event.dataTransfer.effectAllowed = 'move';
			event.dataTransfer.dropEffect = 'move';
			event.dataTransfer.setData('text/plain', item.getAttribute('data-draggable-id')); // Store the unique ID of the dragged element for later reference (e.g., to identify the dragged element during drop)
			event.dataTransfer.setData('text/html', ''); // Required for Firefox compatibility
			item.classList.add('is-dragging');

			if (options.onDragStart)
			{
				options.onDragStart(item, /** @type {HTMLElement} */ (event.currentTarget));
			}
		}, false);

		item.addEventListener('dragenter', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			const isSameContainer = this._dragSourceElement.parentElement === target.parentElement;
			// if limitToOwnCollection option is set, only allow drag enter if the target is in the same parent container as the drag source (this is to prevent dragging items between different collections/containers which may have different rules or constraints)
			if (options.limitToOwnCollection && !isSameContainer)
			{
				this.pict.log.info('DraggableUtil: Drag enter ignored due to limitToOwnCollection option and different parent containers.');
				return;
			}
			target.classList.add('is-drag-over');

			if (options.onDragEnter)
			{
				options.onDragEnter(item, target);
			}
		}, false);

		item.addEventListener('dragover', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault(); // Necessary to allow dropping
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			target.classList.add('is-drag-over'); // Ensure the drag-over class is applied while dragging over the target

			if (options.onDragOver)
			{
				options.onDragOver(item, target);
			}
		}, false);

		item.addEventListener('dragleave', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			target.classList.remove('is-drag-over');

			if (options.onDragLeave)
			{
				options.onDragLeave(item, target);
			}
		}, false);

		item.addEventListener('drag', (/** @type {DragEvent} */ event) =>
		{
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			target.classList.add('is-skeleton'); // Hide the original element while dragging to allow the drag image to be visible (especially if using a custom drag image)

			if (options.onDrag)
			{
				options.onDrag(item, target);
			}
		}, false);

		item.addEventListener('drop', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			this._dragSourceElement.classList.remove('is-skeleton'); // Unhide the original element after dropping

			// if the drop target is in the same collection as the drag source, we can allow dropping and reordering within the same container,
			// otherwise, we ignore the drop (this is to prevent dragging items between different collections/containers which may have different rules or constraints)
			if (item !== this._dragSourceElement)
			{
				/** @type {HTMLElement} */
				const target = /** @type {HTMLElement} */ (event.currentTarget);
				target.classList.remove('is-drag-over');

				// if limitToOwnCollection option is set, check if the drop target is in the same parent container as the drag source before allowing the drop
				if (options.limitToOwnCollection && item.parentElement !== this._dragSourceElement.parentElement)
				{
					this.pict.log.info('DraggableUtil: Drop ignored due to limitToOwnCollection option and different parent containers.');
					item.classList.remove('is-drag-over');
					this._dragSourceElement.classList.add('is-drag-over-denied');
					this._dragSourceElement.classList.remove('is-dragging');
					const sourceElement = this._dragSourceElement; // Store reference to the dragged element for use in the timeout callback
					setTimeout(() => sourceElement?.classList?.remove('is-drag-over-denied'), this.animationDuration);
					// find the parent container of the dropped element and apply a shake animation to indicate the drop was denied (optional, can be styled with CSS)
					const parentContainer = item.parentElement;
					if (parentContainer)
					{
						parentContainer.classList.add('is-drag-over-denied-collection');
						setTimeout(() => parentContainer.classList.remove('is-drag-over-denied-collection'), this.animationDuration);
					}
					return;
				}
				item.classList.remove('is-drag-over');
				// Move the dragged item to its new position in the DOM (before or after the drop target depending on cursor position within the target)
				const rect = item.getBoundingClientRect();
				const midpoint = rect.left + rect.width / 2;
				if (event.clientX > midpoint)
				{
					item.parentNode.insertBefore(this._dragSourceElement, item.nextSibling);
				}
				else
				{
					item.parentNode.insertBefore(this._dragSourceElement, item);
				}

				if (options.onDrop)
				{
					options.onDrop(item, /** @type {HTMLElement} */ (event.currentTarget));
				}
			}
		}, false);

		item.addEventListener('dragend', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			item.classList.remove('is-dragging');
			item.classList.remove('is-skeleton');
			// Clean up any remaining drag-over classes on potential drop targets after dragging ends
			const dropTargets = document.querySelectorAll('.is-drag-over');
			dropTargets.forEach((target) => target.classList.remove('is-drag-over'));

			if (options.onDragEnd)
			{
				options.onDragEnd(item, /** @type {HTMLElement} */ (event.currentTarget));
			}
			this._dragSourceElement = null;
		}, false);
	}
}

module.exports = DraggableUtil;

},{"pict-provider":479}],42:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const LOCAL_SCRATCH_ADDRESS = 'AppData.EntityBundleClientScratch';

/**
 * EntityBundleClient — executes a pict EntityProvider bundle (MeadowEntity
 * steps with `Bundle.<Entity>` destinations) against the entity_bundles
 * service in ONE round trip, falling back to local execution through this
 * app's own pict EntityProvider when the service is unreachable (offline
 * clients, environments without the service). Both paths return the same
 * `{ <Entity>: rows[] }` map, so consumers author the steps once.
 *
 * Remote: POST /1.0/EntityBundle/ExecutePictBundle. The response must carry
 * an array for every step's destination — a step the service rejected (e.g.
 * over its record cap) surfaces as a missing key and fails the remote path
 * rather than silently returning partial scope.
 *
 * Local: the same steps re-homed to a scratch address (PJU references
 * rewritten to match) and forced to `NoCount` pagination, so the reads stay
 * plain FilteredTo GETs an offline entity store can serve — pict's Query/
 * Count/Schema conveniences are avoided or degrade gracefully.
 *
 * Usage:
 *   const client = pict.providers.EntityBundleClient;
 *   const result = await client.executeBundle(steps);
 *   // result.Data.<Entity> => rows[], result.Source => 'remote'|'local'
 */
class EntityBundleClient extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Execute a bundle remotely, falling back to local execution.
	 *
	 * @param {Array<Record<string, any>>} pSteps - MeadowEntity steps with `Bundle.<Entity>` destinations.
	 * @param {{ Context?: Record<string, any>, AllowRemote?: boolean, AllowLocal?: boolean }} [pOptions]
	 * @return {Promise<{ Data: Record<string, Array<any>>, Source: ('remote'|'local') }>}
	 */
	async executeBundle(pSteps, pOptions)
	{
		const tmpOptions = pOptions || {};
		if (!Array.isArray(pSteps) || pSteps.length === 0)
		{
			return { Data: {}, Source: 'local' };
		}
		if (tmpOptions.AllowRemote !== false)
		{
			try
			{
				return { Data: await this._executeRemote(pSteps, tmpOptions.Context || {}), Source: 'remote' };
			}
			catch (pError)
			{
				if (tmpOptions.AllowLocal === false)
				{
					throw pError;
				}
				this.pict?.log?.warn(`[EntityBundleClient] Remote bundle execution failed (${pError?.message || pError}); executing locally.`);
			}
		}
		if (tmpOptions.AllowLocal === false)
		{
			throw new Error('EntityBundleClient: remote execution disabled and local execution disallowed.');
		}
		return { Data: await this._executeLocal(pSteps), Source: 'local' };
	}

	/**
	 * @param {Record<string, any>} pStep
	 * @return {string} the response key for a step — the last Destination segment.
	 */
	destinationKey(pStep)
	{
		const tmpDestination = String(pStep?.Destination || '');
		return tmpDestination.substring(tmpDestination.lastIndexOf('.') + 1);
	}

	/**
	 * @param {Array<Record<string, any>>} pSteps
	 * @param {Record<string, any>} pContext
	 * @return {Promise<Record<string, Array<any>>>}
	 */
	_executeRemote(pSteps, pContext)
	{
		return new Promise((fResolve, fReject) =>
		{
			this.pict.HeadlightRestClient.postJSON('EntityBundle/ExecutePictBundle',
				{ bundle: pSteps, context: pContext, skipEntities: [] },
				(pError, pBody) =>
				{
					if (pError)
					{
						return fReject(pError);
					}
					const tmpData = pBody && pBody.Data;
					if (!tmpData || typeof tmpData !== 'object')
					{
						return fReject(new Error('ExecutePictBundle response carried no Data.'));
					}
					/** @type {Record<string, Array<any>>} */
					const tmpResult = {};
					for (const tmpStep of pSteps)
					{
						const tmpKey = this.destinationKey(tmpStep);
						if (!Array.isArray(tmpData[tmpKey]))
						{
							return fReject(new Error(`ExecutePictBundle response is missing step result [${tmpKey}] (step rejected server-side?).`));
						}
						tmpResult[tmpKey] = tmpData[tmpKey];
					}
					fResolve(tmpResult);
				});
		});
	}

	/**
	 * Execute the steps through this app's pict EntityProvider. Destinations
	 * (and PJU references to them) are re-homed under a scratch address so a
	 * live app's own `Bundle.*` state is never touched, and `NoCount` keeps
	 * pagination offline-servable.
	 *
	 * @param {Array<Record<string, any>>} pSteps
	 * @return {Promise<Record<string, Array<any>>>}
	 */
	async _executeLocal(pSteps)
	{
		const tmpLocalSteps = pSteps.map((pStep) =>
		{
			const tmpStep = Object.assign({}, pStep, { NoCount: true });
			tmpStep.Destination = `${LOCAL_SCRATCH_ADDRESS}.${this.destinationKey(pStep)}`;
			if (typeof tmpStep.Filter === 'string')
			{
				tmpStep.Filter = tmpStep.Filter.split('^Bundle.').join(`^${LOCAL_SCRATCH_ADDRESS}.`);
			}
			return tmpStep;
		});
		try
		{
			await new Promise((fResolve, fReject) =>
			{
				this.pict.EntityProvider.gatherDataFromServer(tmpLocalSteps, (pError) => (pError ? fReject(pError) : fResolve(undefined)));
			});
			const tmpScratch = this.pict.AppData.EntityBundleClientScratch || {};
			/** @type {Record<string, Array<any>>} */
			const tmpResult = {};
			for (const tmpStep of pSteps)
			{
				const tmpKey = this.destinationKey(tmpStep);
				tmpResult[tmpKey] = Array.isArray(tmpScratch[tmpKey]) ? tmpScratch[tmpKey] : [];
			}
			return tmpResult;
		}
		finally
		{
			delete this.pict.AppData.EntityBundleClientScratch;
		}
	}
}

module.exports = EntityBundleClient;

},{"pict-provider":479}],43:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/**
 * EntityFilterEngine — the Headlight-domain filter-composition half of the old Select2Util,
 * extracted verbatim so it can be shared without the select2 transport.
 *
 * These methods compose FoxHound scope clauses (Static / Dynamic `FromField` + per-row
 * `FromRowField` / SamplePlan / Through / Lab), split mandatory vs. back-off-able, and resolve
 * the Show-All override. They are select2-/DOM-free — they read live form state via
 * `this.pict.manifest` and delegate id-set resolution to the domain scope resolvers
 * (`SpecScopeResolver` / `ThroughScopeResolver` / `LabScopeResolver`), so they are unit-tested
 * directly against `this.pict` stubs.
 *
 * Two consumers share this one implementation:
 *   - `Select2Util` (the legacy select2 transport) **extends** this class, so its
 *     `getOptionsAjax` keeps calling `this.applyStaticFilters(...)` etc. unchanged.
 *   - the pict-section-picker `Picker` broker **calls** this via `this.pict.providers.EntityFilterEngine`
 *     from `getContextualSearchFilters`, feeding the composed clauses to PSP's `BaseFilter`.
 *
 * The manifest shapes (`PictForm.StaticFilters` / `DynamicFilters` / `ShowAllToggle` /
 * `OverrideField`) are unchanged — see docs/Filters.md — so no form edits are required.
 */
class EntityFilterEngineProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Append descriptor-level static scope filters to a select2 search filter
	 * list. Read from `pInput.PictForm.StaticFilters` — used to scope a picker
	 * to a polymorphic slice of its entity (e.g. `Organization` by `Type`,
	 * `Product` by `ProductCategory`). Applied on top of the per-provider
	 * `HandleSearchFilters` so the scope always constrains the result.
	 *
	 * Each entry is either:
	 *   - a structured `{ Field, Operator = 'EQ', Value }` (scalar) or
	 *     `{ Field, Operator = 'INN', Values: [...] }` (list) object whose
	 *     value(s) are URL-encoded here — the recommended form; or
	 *   - a ready Foxhound clause string, pushed verbatim (caller must
	 *     URL-encode any values — the `FilteredTo/<…>/` path rejects raw spaces).
	 *
	 * A filter entry flagged `BackOff: true` is routed to `pBackoff` (when provided) instead of
	 * `pFilters`, so the URL builder can drop it on the empty-result retry (see `getOptionsAjax`).
	 * Default static filters are deliberate scopes and stay mandatory.
	 *
	 * @param {string[]} pFilters - The mandatory filter list to append to.
	 * @param {object} pInput - The descriptor (reads `pInput.PictForm.StaticFilters`).
	 * @param {string[]} [pBackoff] - Optional back-off-able filter list for `BackOff: true` entries.
	 * @return {string[]} The (mutated) mandatory filter list.
	 */
	applyStaticFilters(pFilters, pInput, pBackoff)
	{
		pFilters = pFilters || [];
		const tmpStaticFilters = pInput && pInput.PictForm ? pInput.PictForm.StaticFilters : null;
		if (!Array.isArray(tmpStaticFilters))
		{
			return pFilters;
		}
		for (const tmpFilter of tmpStaticFilters)
		{
			if (typeof tmpFilter === 'string')
			{
				if (tmpFilter)
				{
					pFilters.push(tmpFilter);
				}
				continue;
			}
			if (!tmpFilter || !tmpFilter.Field)
			{
				continue;
			}
			const tmpTarget = (pBackoff && tmpFilter.BackOff === true) ? pBackoff : pFilters;
			const tmpOperator = tmpFilter.Operator || 'EQ';
			if (Array.isArray(tmpFilter.Values))
			{
				tmpTarget.push(`FBL~${tmpFilter.Field}~${tmpOperator}~${tmpFilter.Values.map((pValue) => encodeURIComponent(pValue)).join(',')}`);
			}
			else
			{
				tmpTarget.push(`FBV~${tmpFilter.Field}~${tmpOperator}~${encodeURIComponent(tmpFilter.Value)}`);
			}
		}
		return pFilters;
	}

	/**
	 * Append sibling-field-driven dynamic scope filters to a select2 search
	 * filter list, narrowing a picker to the entities associated with another
	 * field's current selection (e.g. Product scoped to the picked Producer:
	 * `Product.IDOrganization = <H.Producer>`). Read from
	 * `pInput.PictForm.DynamicFilters`.
	 *
	 * Each entry is `{ Field, FromField, Operator = 'EQ' }` where `FromField` is
	 * a pict address (e.g. `AppData.DocumentData.ReportData.FormData.H.Producer`)
	 * whose current value is read and URL-encoded into `FBV~Field~OP~<value>`.
	 * When the source value is unset — null, undefined, '', or the 1-based-id unset
	 * sentinel 0 / "0" — the filter is omitted (the picker shows its full set) rather
	 * than emitting `FBV~Field~EQ~0` (which would match nothing). The now-orphaned
	 * dependent value is cleared separately on the anchor's change (see
	 * MaterialsEntitySelector.onAfterEventCompletion), so an unset anchor never leaves
	 * a stale selection behind.
	 *
	 * Per-row tabular narrowing: when this picker is a column in a RecordSet table,
	 * `FromField` resolves a single global address — identical for every row — which
	 * is wrong when each row's anchor differs (e.g. each Aggregate Product row has its
	 * own Source/Producer). Use `FromRowField` instead: the sibling column's datum hash
	 * within the SAME row. It composes `<InformaryContainerAddress>[<pRowIndex>].<FromRowField>`
	 * and reads it from the marshal destination, so each row narrows by its OWN anchor.
	 * Requires `pRowIndex` and `pView` (threaded from MaterialsEntitySelector.initializeSelect2
	 * via the ajax options). Outside a tabular context (`pRowIndex == null`) a `FromRowField`
	 * entry without a `FromField` is skipped. `FromField` keeps working unchanged.
	 *
	 * @param {string[]} pFilters - The filter list to append to.
	 * @param {object} pInput - The descriptor (reads `pInput.PictForm.DynamicFilters`).
	 * @param {number} [pRowIndex] - The row index when this is a tabular column (enables `FromRowField`).
	 * @param {object} [pView] - The form view (provides the marshal destination for `FromRowField`).
	 * @param {string[]} [pBackoff] - Optional back-off-able filter list for `BackOff: true` entries (see `getOptionsAjax`).
	 * @return {string[]} The (mutated) mandatory filter list.
	 */
	applyDynamicFilters(pFilters, pInput, pRowIndex, pView, pBackoff)
	{
		pFilters = pFilters || [];
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters))
		{
			return pFilters;
		}
		// Show All is a MANUAL OVERRIDE WITH THE HIGHEST PRIORITY: it drops every sibling-driven
		// narrowing on this picker — the direct `FromField` / `FromRowField` clauses that solvers and
		// autofill triggers drive, as well as the `SamplePlanScope` / `Through` / `LabScope` id-set
		// scopes — so the dropdown falls back to the scope it would have had with
		// NO other selections made. `StaticFilters`, project scoping and the selector's own intrinsic
		// `HandleSearchFilters` are not "other selections" and still apply. Evaluated once, here, WITH
		// the row index, so a tabular picker honors its own row's toggle rather than the flat address
		// (the per-shape guards below repeat the check for direct callers, and are unit-tested as such).
		if (this.isFilterOverridden(pInput, pRowIndex))
		{
			return pFilters;
		}
		const tmpIsTabular = (pRowIndex != null) && pView && pInput.PictForm && pInput.PictForm.InformaryContainerAddress;
		for (const tmpFilter of tmpDynamicFilters)
		{
			// Sampling-plan scope is a distinct shape: it reads one or more upstream
			// siblings and resolves an INN id-set from the plan, rather than a single
			// FromField EQ clause. Handle (and skip) it before the generic guard below.
			if (tmpFilter && tmpFilter.SamplePlanScope)
			{
				this._applySamplePlanFilter(pFilters, tmpFilter, pInput);
				continue;
			}
			// Through ("chained") scope: narrows by a relationship with no direct FK on
			// this entity, hopping a bridge table via ThroughScopeResolver. Like the
			// sampling-plan scope it resolves an INN id-set, not a FromField EQ clause.
			if (tmpFilter && tmpFilter.Through)
			{
				this._applyThroughFilter(pFilters, tmpFilter, pInput);
				continue;
			}
			// Lab scope: parent labs for the sample-level selector, the leaf labs that can run the test for a
			// per-test one, resolved by LabScopeResolver. Like the other scopes it resolves an INN id-set.
			if (tmpFilter && tmpFilter.LabScope)
			{
				this._applyLabScopeFilter(pFilters, tmpFilter, pInput, pRowIndex, pView);
				continue;
			}
			if (!tmpFilter || !tmpFilter.Field || (!tmpFilter.FromField && !tmpFilter.FromRowField))
			{
				continue;
			}
			let tmpValue;
			if (tmpIsTabular && tmpFilter.FromRowField)
			{
				// Same-row sibling: compose `<container>[<row>].<datum>` and read the live value
				// from the marshal destination, so this row narrows by its own anchor cell.
				const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, tmpFilter.FromRowField);
				tmpValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
			}
			else if (tmpFilter.FromField)
			{
				tmpValue = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			}
			else
			{
				// A FromRowField-only entry outside a tabular context — nothing to resolve against.
				continue;
			}
			// Treat an unset anchor as "no constraint" and OMIT the filter (show the full set),
			// rather than emitting `FBV~Field~EQ~0` which would match nothing. FK ids are 1-based,
			// so 0 / "0" is the unset sentinel (e.g. ProductionPlant.IDOrganization = 0); null /
			// undefined / "" are also unset. The dependent's stale value is cleared separately when
			// the anchor changes (see MaterialsEntitySelector.onAfterEventCompletion).
			const tmpNormalized = (tmpValue === null || tmpValue === undefined) ? '' : String(tmpValue).trim();
			if (tmpNormalized === '' || tmpNormalized === '0')
			{
				continue;
			}
			const tmpOperator = tmpFilter.Operator || 'EQ';
			// Sibling-driven narrowing flagged `BackOff: true` routes to the back-off-able list so the
			// picker shows its full set rather than an empty dropdown when the anchor has no matches.
			const tmpTarget = (pBackoff && tmpFilter.BackOff === true) ? pBackoff : pFilters;
			tmpTarget.push(`FBV~${tmpFilter.Field}~${tmpOperator}~${encodeURIComponent(tmpValue)}`);
		}
		return pFilters;
	}

	/**
	 * Apply a sampling-plan scope clause for a DynamicFilters entry carrying a
	 * `SamplePlanScope` ('LineItem' | 'Material' | 'Test'). Reads the sibling values
	 * named by the entry's `SampleTypeFromField` / `LineItemFromField` /
	 * `MaterialFromField` / `TestFromField` addresses — bidirectional: each axis
	 * narrows by every OTHER axis's current selection through the plan, not just the
	 * upstream ones. Asks SpecScopeResolver for the plan-allowed ids on that axis and
	 * pushes a mandatory `FBL~Field~INN~<ids>` clause.
	 *
	 * Pushed to the mandatory list (not the back-off list) so an empty plan-filtered
	 * result does NOT auto-widen — it stays constrained until the user toggles Show
	 * All, which drops it here via isFilterOverridden. Omitted (fail-open) when there
	 * is no plan (resolver returns null) or the upstream selection yields no plan ids
	 * on this axis (so the picker keeps its other scopes rather than forcing empty).
	 *
	 * @param {string[]} pFilters - the mandatory filter list (mutated)
	 * @param {object} pFilter - the DynamicFilters entry (reads SamplePlanScope, Field, *FromField)
	 * @param {object} pInput - the descriptor (for the Show All override check)
	 * @return {void}
	 */
	_applySamplePlanFilter(pFilters, pFilter, pInput)
	{
		if (this.isFilterOverridden(pInput))
		{
			return;
		}
		const tmpResolver = this.pict.providers.SpecScopeResolver;
		if (!tmpResolver || !pFilter.Field)
		{
			return;
		}
		const tmpRead = (pAddress) => (pAddress ? this.pict.manifest.getValueByHash(this.pict, pAddress) : undefined);
		const tmpSampleType = tmpRead(pFilter.SampleTypeFromField);
		const tmpIDLineItem = tmpRead(pFilter.LineItemFromField);
		const tmpIDTest = tmpRead(pFilter.TestFromField);
		// The Material anchor is PUSHED to the Test / LineItem axes — expand it UP so a leaf
		// selection also matches plan rows bound to its parent categories. (Material is the only
		// hierarchical axis.) Comma-joined: the plan getters are list-aware (_samplePlanIDs).
		const tmpMaterialAnchor = tmpRead(pFilter.MaterialFromField);
		const tmpIDMaterial = (tmpMaterialAnchor && tmpResolver.expandMaterialAnchorsUp) ?
			Array.from(tmpResolver.expandMaterialAnchorsUp(tmpMaterialAnchor)).join(',') :
			tmpMaterialAnchor;
		let tmpAllowed = null;
		switch (pFilter.SamplePlanScope)
		{
		case 'LineItem':
			tmpAllowed = tmpResolver.getSamplePlanLineItemIDs?.(tmpSampleType, tmpIDMaterial, tmpIDTest);
			break;
		case 'Material':
			tmpAllowed = tmpResolver.getSamplePlanMaterialIDs?.(tmpSampleType, tmpIDLineItem, tmpIDTest);
			// The Material axis is this dropdown's own filter — expand the allowed set DOWN so a
			// child material is selectable under an allowed (parent/category) plan material.
			if (tmpAllowed && tmpResolver.expandMaterialSetDown)
			{
				tmpAllowed = tmpResolver.expandMaterialSetDown(tmpAllowed);
			}
			break;
		case 'Test':
			tmpAllowed = tmpResolver.getSamplePlanTestIDs?.(tmpSampleType, tmpIDLineItem, tmpIDMaterial);
			break;
		default:
			return;
		}
		if (tmpAllowed && tmpAllowed.size > 0)
		{
			pFilters.push(`FBL~${pFilter.Field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
		else if (tmpAllowed)
		{
			// Non-null but EMPTY: the plan IS loaded and authoritatively has no rows for this selection
			// (e.g. a SampleType with no plan tests) — constrain to none rather than fail open to the full
			// list. A null tmpAllowed (no plan loaded at all) still fails open below, and Show All overrides
			// both via isFilterOverridden at the top.
			pFilters.push(this._constrainToNoneClause(pFilter, pInput));
		}
	}

	/**
	 * Zero-row constraint clause for a scope filter. Targets the entity PK (`ID<Entity>` from
	 * `pInput.PictForm.Entity`) — always a positive auto-increment, so `0` can never match — rather than the
	 * scope `Field`, whose `0` may be a legitimate value (a status, or a nullable / parent FK such as
	 * `IDLabParent` which is 0 for root records). Falls back to `Field` only when the Entity is unknown.
	 * @param {object} pFilter @param {object} pInput @return {string}
	 */
	_constrainToNoneClause(pFilter, pInput)
	{
		const tmpEntity = (pInput && pInput.PictForm) ? pInput.PictForm.Entity : null;
		// Scalar EQ~0 (the "matches nothing" idiom the applyDynamicFilters unset-anchor path documents) rather
		// than INN~0 — no list to sanitize, and self-documenting as a zero-row constraint.
		return `FBV~${tmpEntity ? ('ID' + tmpEntity) : pFilter.Field}~EQ~0`;
	}

	/**
	 * Apply a Through ("chained") scope clause for a DynamicFilters entry carrying a
	 * `Through` bridge config. Reads the live anchor at `FromField`, asks
	 * ThroughScopeResolver for the bridge-allowed ids on the picker's `Field`, and
	 * pushes a mandatory `FBL~Field~INN~<ids>` clause (dropped by Show All via
	 * isFilterOverridden). Fail-open: omitted when there is no resolver, no resolved
	 * id-set (slice not yet primed), or an empty set — the picker keeps its full
	 * list rather than forcing empty.
	 *
	 * @param {string[]} pFilters - the mandatory filter list (mutated)
	 * @param {object} pFilter - the DynamicFilters entry (Through, ThroughKey, ThroughSelect, FromField, Field, Strategy)
	 * @param {object} pInput - the descriptor (for the Show All override check)
	 * @return {void}
	 */
	_applyThroughFilter(pFilters, pFilter, pInput)
	{
		if (this.isFilterOverridden(pInput))
		{
			return;
		}
		const tmpResolver = this.pict.providers.ThroughScopeResolver;
		if (!tmpResolver || !pFilter.Field)
		{
			return;
		}
		const tmpAnchor = pFilter.FromField ? this.pict.manifest.getValueByHash(this.pict, pFilter.FromField) : undefined;
		let tmpAllowed;
		const tmpSpecResolver = this.pict.providers.SpecScopeResolver;
		if (tmpAnchor && pFilter.ThroughKey === 'IDMaterial' && tmpSpecResolver?.expandMaterialAnchorsUp)
		{
			// A material anchor pushed through a bridge expands UP — rows for the material OR its
			// parent categories match. getThroughIDs is single-anchor, so union per id (null/not-yet-
			// primed ancestors are skipped; all-null stays null = fail-open). Map strategy is fully
			// covered; a query-strategy ancestor whose slice was not primed simply contributes nothing.
			tmpAllowed = null;
			for (const tmpMaterialID of tmpSpecResolver.expandMaterialAnchorsUp(tmpAnchor))
			{
				const tmpSet = tmpResolver.getThroughIDs(pFilter, tmpMaterialID);
				if (tmpSet)
				{
					if (!tmpAllowed)
					{
						tmpAllowed = new Set();
					}
					for (const tmpID of tmpSet)
					{
						tmpAllowed.add(tmpID);
					}
				}
			}
		}
		else
		{
			tmpAllowed = tmpResolver.getThroughIDs(pFilter, tmpAnchor);
		}
		if (tmpAllowed && tmpAllowed.size > 0)
		{
			pFilters.push(`FBL~${pFilter.Field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
	}

	/**
	 * Apply a lab-scope clause for a DynamicFilters entry carrying `LabScope` ('Sample' | 'Test'), resolved by
	 * LabScopeResolver.
	 *
	 *   'Sample' → the PARENT labs a sample can ship to (the project's labs, else the parents of the labs that
	 *              can run the selected tests).
	 *   'Test'   → the LEAF labs that can run this row's test. Reads the per-row test from `TestFromRowField`
	 *              (tabular) or `TestFromField`. Capability is the only clause: the project's own labs and the
	 *              material defaults rank the list (`getPreferredLabIDs`, pinned by the selector) rather than
	 *              narrowing it, so the dropdown and auto-fill order one list the same way.
	 *
	 * The mandatory set becomes `FBL~Field~INN~<ids>`; an empty-but-resolved set constrains to none (Show All
	 * overrides) and a null resolve stays fail-open. Only capability can produce that empty set, because it is
	 * the only clause whose emptiness is a fact rather than a preference.
	 *
	 * @param {Array<string>} pFilters
	 * @param {Object} pFilter
	 * @param {Object} pInput
	 * @param {number|string|null} [pRowIndex]
	 * @param {Object} [pView]
	 */
	_applyLabScopeFilter(pFilters, pFilter, pInput, pRowIndex, pView)
	{
		if (this.isFilterOverridden(pInput, pRowIndex))
		{
			return;
		}
		const tmpResolver = this.pict.providers.LabScopeResolver;
		if (!tmpResolver || !pFilter.Field)
		{
			return;
		}
		let tmpAllowed = null;
		if (pFilter.LabScope === 'Test')
		{
			const tmpIDTest = this._readLabScopeTestID(pFilter, pInput, pRowIndex, pView);
			tmpAllowed = tmpResolver.getTestLabIDs(tmpIDTest);
		}
		else
		{
			tmpAllowed = tmpResolver.getSampleLabIDs();
		}
		if (tmpAllowed && tmpAllowed.size > 0)
		{
			pFilters.push(`FBL~${pFilter.Field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
		else if (tmpAllowed)
		{
			// Empty (but resolved) set — no lab qualifies for this test on this project. Constrain to none
			// (Show All overrides); a null resolve (no data on any axis) stays fail-open and omits the clause.
			pFilters.push(this._constrainToNoneClause(pFilter, pInput));
		}
	}

	/**
	 * The test a per-test lab selector is bound to: the row's own sibling cell when tabular, else a flat address.
	 *
	 * @param {Object} pFilter @param {Object} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {any}
	 */
	_readLabScopeTestID(pFilter, pInput, pRowIndex, pView)
	{
		if (pRowIndex != null && pFilter.TestFromRowField && pInput.PictForm && pInput.PictForm.InformaryContainerAddress && pView)
		{
			const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pFilter.TestFromRowField);
			return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
		}
		if (pFilter.TestFromField)
		{
			return this.pict.manifest.getValueByHash(this.pict, pFilter.TestFromField);
		}
		return undefined;
	}

	/**
	 * Whether a descriptor's filters are currently user-overridden ("show all"). When
	 * `PictForm.OverrideField` names a form address whose live value is truthy, the back-off-able
	 * filters (spec-year, `BackOff` static/dynamic) are dropped entirely for that picker — the manual
	 * companion to the automatic empty-result back-off.
	 *
	 * @param {object} pInput - The descriptor (reads `pInput.PictForm.ShowAllToggle` / `OverrideField`).
	 * @param {number|string} [pRowIndex] - Row index for a tabular picker; selects the per-row state.
	 * @return {boolean}
	 */
	isFilterOverridden(pInput, pRowIndex)
	{
		const tmpPictForm = pInput && pInput.PictForm ? pInput.PictForm : null;
		if (!tmpPictForm)
		{
			return false;
		}
		// Integrated "Show All" toggle: the override state persists at the <DataAddress>__ShowAll suffix.
		// Tabular is per-row, keyed by Hash with a _<rowIndex> suffix (the col DataAddress may be a nested
		// path like TestInstance.IDLab, which can't compose a flat state address). Legacy forms instead
		// point PictForm.OverrideField at an external checkbox address.
		let tmpField;
		if (tmpPictForm.ShowAllToggle && pRowIndex != null && (pInput.Hash || pInput.DataAddress))
		{
			tmpField = `AppData.DocumentData.ReportData.FormData.${pInput.Hash || pInput.DataAddress}__ShowAll_${pRowIndex}`;
		}
		else if (tmpPictForm.ShowAllToggle && pInput.DataAddress)
		{
			tmpField = `AppData.DocumentData.ReportData.FormData.${pInput.DataAddress}__ShowAll`;
		}
		else
		{
			tmpField = tmpPictForm.OverrideField;
		}
		if (!tmpField)
		{
			return false;
		}
		const tmpValue = this.pict.manifest.getValueByHash(this.pict, tmpField);
		return tmpValue === true || tmpValue === 1 || tmpValue === 'true' || tmpValue === '1';
	}
}

module.exports = EntityFilterEngineProvider;

},{"pict-provider":479}],44:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const customParseFormat = require('dayjs/plugin/customParseFormat');

// Logical "live" default tokens a descriptor's `Default` may carry instead of a
// concrete value. They resolve to the current date/time when the form loads.
// Kept in one place so the date/time/datetime input types don't each carry their
// own copy of the list — route every check through isSpecialDefaultValue().
const SPECIAL_DEFAULT_VALUES = [ 'now', 'today' ];

/**
 * @typedef {Object} FlatpickrOptions
 * @property {boolean} AllowInput - Whether to allow manual input.
 * @property {string} DayJSDateFormat - The date format string, will be converted to Flatpickr format. (assumes standard DayJS formatting, e.g., 'YYYY-MM-DD')
 * @property {string} DefaultValue - The default value for the date input.
 * @property {boolean} DisablePicker - Whether to disable the date picker.
 * @property {string} HTMLID - The HTML ID of the input element.
 * @property {string} ISODateString - The date value in ISO format.
 * @property {string} PickerType - The type of picker (e.g., 'date', 'datetime', or 'time').
 * @property {string} Timezone - The timezone for the date input.
 * @property {boolean} [Time24Hour] - Whether to use 24-hour time format (only applicable for time or datetime pickers).
 * @property {string} [HiddenInputSelector] - The HTML ID of the hidden input element that stores the ISO value
 */

class FlatpickrUtilProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Extend dayJS with customParseFormat plugin work with Safari
		if (this.fable.Dates?.dayJS && !this.fable.Dates.dayJS.customParseFormatExtended)
		{
			this.fable.Dates.dayJS.extend(customParseFormat);
			this.fable.Dates.dayJS.customParseFormatExtended = true;
		}
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {FlatpickrOptions} pFlatpickrOptions The Flatpickr options.
	 * @return {void}
	 */
	initializeFlatpickr(pFlatpickrOptions)
	{
		if (!window.flatpickr)
		{
			console.error('Flatpickr library is not loaded.');
			return;
		}
		if (pFlatpickrOptions.DisablePicker)
		{
			console.info('Flatpickr initialization skipped because the picker is disabled.');
			return;
		}
		if (!pFlatpickrOptions.HTMLID)
		{
			console.error('Flatpickr initialization failed: HTMLID is required.');
			return;
		}
		// If the target input is a Read-theme static display (the Tier-2
		// a11y swap), don't attach the picker — the field is meant to be a
		// static, focusable, copyable display, not an interactive control.
		// We also tear down any prior Flatpickr instance from an earlier
		// render pass (e.g., the form transitioned Edit → Read at runtime),
		// since simply returning would leave the stale picker still
		// listening for focus / click.
		//
		// Discriminate ONLY on `aria-readonly="true"`: that is the marker
		// the Read-theme templates emit, and Flatpickr never sets it. We
		// must NOT also key off a bare `readonly` attribute — Flatpickr
		// itself stamps `readonly` on the input whenever it initializes with
		// allowInput:false, which this provider does on touch devices (see
		// tmpIsTouchDevice below). Treating that Flatpickr-set `readonly` as
		// a Read-theme signal would destroy a live, legitimately-initialized
		// Edit-mode picker on the very next marshal, leaving every date/time
		// field dead on tablets/phones after the first interaction.
		const tmpTargetElement = document.querySelector(pFlatpickrOptions.HTMLID);
		if (tmpTargetElement && tmpTargetElement.getAttribute('aria-readonly') === 'true')
		{
			if (tmpTargetElement['_flatpickr'] && typeof tmpTargetElement['_flatpickr'].destroy === 'function')
			{
				tmpTargetElement['_flatpickr'].destroy();
			}
			console.info(`Flatpickr initialization skipped for [${pFlatpickrOptions.HTMLID}] because the input is aria-readonly (Read-theme static display).`);
			return;
		}
		// Don't tear down a picker the user is actively using. A re-marshal can
		// fire mid-interaction: clicking the hour/minute spinner arrows or the
		// AM/PM toggle dispatches a native `change` on the display input (Flatpickr
		// updateTime -> _debouncedChange -> triggerEvent), which routes through the
		// data request -> solve -> marshal -> back into here. Re-initializing calls
		// window.flatpickr(), which destroys and recreates the instance, slamming
		// the open picker shut. Only skip re-init when the calendar is genuinely
		// rendered and visible — never for a stale/invisible "open" flag, so any bad
		// state always self-heals on the next marshal instead of getting stuck.
		const tmpExistingInstance = tmpTargetElement ? tmpTargetElement['_flatpickr'] : null;
		const tmpOpenCalendar = tmpExistingInstance ? tmpExistingInstance.calendarContainer : null;
		const tmpPickerIsOpen = !!tmpExistingInstance &&
			tmpExistingInstance.isOpen === true &&
			!!tmpOpenCalendar &&
			tmpOpenCalendar.classList.contains('open') &&
			tmpOpenCalendar.getBoundingClientRect().height > 0;
		if (tmpPickerIsOpen)
		{
			return;
		}
		// Define picker type map for resuable settings
		const pickerTypeMap = {
			date: {
				displayName: 'Date',
				flatpickrDateFormat: 'Y-m-d',
				dayJSDateFormat: 'YYYY-MM-DD',
				icon: 'fa-calendar',
			},
			datetime: {
				displayName: 'Date & Time',
				flatpickrDateFormat: 'Y-m-d H:i',
				dayJSDateFormat: 'YYYY-MM-DD HH:mm',
				icon: 'fa-calendar-clock',
			},
			time: {
				displayName: 'Time',
				flatpickrDateFormat: 'H:i',
				dayJSDateFormat: 'HH:mm',
				icon: 'fa-clock',
			},
		};
		const tmpPickerType = pFlatpickrOptions.PickerType?.toLowerCase() || 'date';
		const tmpHTMLID = pFlatpickrOptions.HTMLID;
		const tmpDayJSFormat = pFlatpickrOptions.DayJSDateFormat || pickerTypeMap[tmpPickerType]?.dayJSDateFormat || 'YYYY-MM-DD';
		const tmpISODateString = pFlatpickrOptions.ISODateString || '';
		const tmpDefaultValue = pFlatpickrOptions.DefaultValue || '';
		const tmpRequestedAllowInput = pFlatpickrOptions.AllowInput !== undefined ? pFlatpickrOptions.AllowInput : true;
		// Detect touch-primary devices so we can suppress manual keyboard entry on
		// mobile. Without this guard, iOS Safari opens the soft keyboard the
		// instant the user taps a date field, then the Flatpickr calendar overlay
		// (now forced on mobile via disableMobile: true) renders on top of the
		// keyboard — a screen-real-estate fight that hides part of the calendar
		// and confuses users about which UI is authoritative. The (maxTouchPoints
		// > 1) clause is intentional: touch-enabled laptops report 1 only for a
		// trackpad, so we don't accidentally strip typing from Surface/iPad-with-
		// keyboard users who do have a real keyboard attached. Explicit
		// AllowInput: false from callers is still honored everywhere.
		const tmpIsTouchDevice = (typeof navigator !== 'undefined') && (((navigator.maxTouchPoints || 0) > 1) || ('ontouchstart' in window));
		const tmpAllowInput = tmpRequestedAllowInput && !tmpIsTouchDevice;
		// Resolve timezone defensively: an invalid or unset timezone otherwise propagates
		// into dayjs.tz() and throws an exception that Flatpickr's init swallows silently.
		let tmpTimezone;
		let isDifferentTimezone = false;
		let timeZoneDisplay = '';
		try
		{
			tmpTimezone = this.resolveTimezone(pFlatpickrOptions.Timezone);
			const tmpCurrentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
			isDifferentTimezone = tmpTimezone && (tmpTimezone !== tmpCurrentTimezone);
			if (isDifferentTimezone)
			{
				const hourDifference = this.pict.Dates.dayJS().tz(tmpTimezone).utcOffset() - this.pict.Dates.dayJS().tz(tmpCurrentTimezone).utcOffset();
				timeZoneDisplay = tmpTimezone + ' ' + (hourDifference > 0 || hourDifference < 0 ? `(+${Math.abs(hourDifference / 60)} hrs)` : `(-${Math.abs(hourDifference / 60)} hrs)`);
			}
		}
		catch (err)
		{
			console.warn(`FlatpickrUtilProvider: timezone resolution failed during init, continuing with browser-local. Reason: ${err?.message}`);
			tmpTimezone = undefined;
			isDifferentTimezone = false;
			timeZoneDisplay = '';
		}
		const enableTime = (tmpPickerType === 'datetime' || tmpPickerType === 'time');
		// Capture provider reference for use in Flatpickr event handler closures
		const self = this;
		// Convert ISO/default value to a fake-local Date that Flatpickr will display as document-TZ time
		const tmpDefaultDate = this.pict.providers.FlatpickrUtilProvider.toFlatpickrDate(tmpISODateString || tmpDefaultValue, tmpTimezone);
		// track manual time input changes for auto-save on close
		// store on the element to persist across re-initializations
		const tmpElement = document.querySelector(tmpHTMLID);
		if (tmpElement && (tmpElement).hasOwnProperty('_hasTimeChanges') === false)
		{
			tmpElement['_hasTimeChanges'] = false;
		}
		// Reset _userCleared on each initialization (marshal pushes fresh state)
		if (tmpElement)
		{
			tmpElement['_userCleared'] = false;
		}
		// Preview-only flag: when the picker is seeded with "now" on open, this tracks
		// whether the user has explicitly interacted. If still true on close, we revert.
		if (tmpElement && !tmpElement.hasOwnProperty('_previewOnly'))
		{
			tmpElement['_previewOnly'] = false;
		}
		// store the hidden input ID on element for use by clearDatePicker/setDatePickerToNow
		if (tmpElement && pFlatpickrOptions.HiddenInputSelector)
		{
			tmpElement['_hiddenInputID'] = pFlatpickrOptions.HiddenInputSelector;
		}
		// NOTE: Flatpickr Plugin options and documentation: https://flatpickr.js.org/options/
		const tmpConfig = {
			dateFormat: this.convertDayJSToFlatpickrFormat(tmpDayJSFormat),
			allowInput: tmpAllowInput,
			defaultDate: tmpDefaultDate,
			enableTime: enableTime,
			noCalendar: (tmpPickerType === 'time'),
			time_24hr: pFlatpickrOptions.Time24Hour !== undefined ? pFlatpickrOptions.Time24Hour : true,
			// Force the Flatpickr UI on mobile devices instead of falling back to the
			// browser's native date/time picker. By default, Flatpickr detects mobile
			// user agents and silently swaps our <input type="text"> for a native
			// type="date" / "time" / "datetime-local", which causes iOS Safari to show
			// its OS UIDatePicker. That native path bypasses every lifecycle hook in
			// this provider — including the fake-local Date pattern (toFlatpickrDate /
			// fromFlatpickrDate) responsible for document-timezone correctness — so
			// dates picked on mobile would be written back without the TZ adjustment
			// the desktop flow applies. Keeping the Flatpickr UI on mobile also
			// ensures the Clear / "Set to Current" extras and the timezone indicator
			// render consistently across devices.
			disableMobile: true,
			// customize the picker UI after it's ready
			onReady: function(dateObj, dateStr, instance)
			{
				const template =
				`<div class="flatpicker-extras">
					${ isDifferentTimezone ? `<div class="timezone-indicator input is-static is-fullwidth is-small"><span class="has-text-text-50">Times shown in</span> ${timeZoneDisplay}</div>` : '' }
					<div class="buttons py-1 is-centered mb-0">
						<button class="button is-outline is-small" type="button" onclick="_Pict.providers.FlatpickrUtilProvider.clearDatePicker('${tmpHTMLID}')">
							<span class="icon">
								<i class="fa fa-fw fa-undo"></i>
							</span>
							<span class="icon-text">
								Clear
							</span>
						</button>
						<button class="button is-link is-small" type="button" onclick="_Pict.providers.FlatpickrUtilProvider.setDatePickerToNow('${tmpHTMLID}')">
							<span class="icon">
								<i class="fa fa-fw ${ pickerTypeMap[tmpPickerType]?.icon || 'fa-calendar'}"></i>
							</span>
							<span class="icon-text">
								Set to Current ${ pickerTypeMap[tmpPickerType]?.displayName || 'Date' }
							</span>
						</button>
					</div>
				</div>`;
				if (instance?.calendarContainer)
				{
					// add the extra buttons to the calendar container
					instance.calendarContainer.insertAdjacentHTML('beforeend', template);
				}
				// listeners for time picker manual inputs (hour, minute, AM/PM) to detect changes
				// only needed for time/datetime pickers - date picker saves automatically
				if (instance?.calendarContainer && enableTime)
				{
					const timeInputs = instance.calendarContainer.querySelectorAll('.flatpickr-hour, .flatpickr-minute');
					timeInputs.forEach(function(input)
					{
						input.addEventListener('input', function()
						{
							instance.input._hasTimeChanges = true;
							// User explicitly touched time inputs — no longer a preview
							instance.input._previewOnly = false;
						});
					});
					// Also track AM/PM toggle clicks!
					const ampmToggle = instance.calendarContainer.querySelector('.flatpickr-am-pm');
					if (ampmToggle)
					{
						ampmToggle.addEventListener('click', function()
						{
							instance.input._hasTimeChanges = true;
							// User explicitly toggled AM/PM — no longer a preview
							instance.input._previewOnly = false;
						});
					}
					// Close picker on Tab key ONLY when tabbing past the last time element.
					// Flatpickr only auto-parses typed input on Enter — Tab bypasses that,
					// so we parse it ourselves via setDate before closing.
					// In 12-hour mode the tab order is: input → hour → minute → AM/PM → close.
					// In 24-hour mode the tab order is: input → hour → minute → close.
					if (!tmpElement['_tabKeyHandler'])
					{
						tmpElement['_tabKeyHandler'] = function(event)
						{
							if (event.key !== 'Tab')
							{
								return;
							}
							const currentInstance = tmpElement?.['_flatpickr'];
							if (!currentInstance?.isOpen)
							{
								return;
							}
							const container = currentInstance.calendarContainer;
							if (!container)
							{
								return;
							}
							const target = event.target;
							// Determine the last focusable time element based on 12/24-hour mode
							const ampmToggle = container.querySelector('.flatpickr-am-pm');
							const minuteInput = container.querySelector('.flatpickr-minute');
							const lastTimeElement = ampmToggle || minuteInput;
							// Determine the first focusable time element (hour input)
							const hourInput = container.querySelector('.flatpickr-hour');
							const firstTimeElement = hourInput || currentInstance.input;
							// Only close when tabbing forward past the last element
							// or shift-tabbing before the first element (back to the main input)
							const isTabbingPastEnd = !event.shiftKey && (target === lastTimeElement);
							const isTabbingBeforeStart = event.shiftKey && (target === firstTimeElement || target === currentInstance.input);
							if (isTabbingPastEnd || isTabbingBeforeStart)
							{
								event.preventDefault();
								// Parse any manually typed value so selectedDates reflect what the user typed
								const inputValue = currentInstance.input?.value?.trim();
								if (inputValue)
								{
									// triggerChange=true fires onChange, which resets _hasTimeChanges
									// and dispatches the data request via the change event
									currentInstance.setDate(inputValue, true);
								}
								currentInstance.close();
								// Move focus to the next/previous focusable element outside the picker
								if (!event.shiftKey)
								{
									currentInstance.input.focus();
								}
							}
						};
						// Listen on document (capture phase) so we intercept Tab inside the
						// calendar container's time inputs, not just on the main input element
						document.addEventListener('keydown', tmpElement['_tabKeyHandler'], true);
					}
					// handle outside click/touch to close picker (known Flatpickr bug with allowInput + enableTime)
					if (tmpAllowInput && !tmpElement['_outsideClickHandler'])
					{
						tmpElement['_outsideClickHandler'] = function(event)
						{
							// get the current element and instance
							const currentElement = document.querySelector(tmpHTMLID);
							if (!currentElement)
							{
								return;
							}
							const currentInstance = currentElement['_flatpickr'];
							// check if picker is open using classList (isOpen property can be unreliable)
							const isPickerOpen = currentInstance?.calendarContainer?.classList.contains('open');
							if (!currentInstance || !isPickerOpen)
							{
								return;
							}
							const target = event.target;
							const isInsidePicker = currentInstance.calendarContainer?.contains(target);
							const isInput = currentInstance.input === target || currentInstance.input?.contains(target);
							if (!isInsidePicker && !isInput)
							{
								currentInstance.close();
							}
						};
						document.addEventListener('mousedown', tmpElement['_outsideClickHandler']);
						// Passive touchstart: the handler never calls preventDefault, and on
						// iOS Safari non-passive touchstart listeners block scroll/gesture
						// compositing while they run — a noticeable jank source on long forms.
						document.addEventListener('touchstart', tmpElement['_outsideClickHandler'], { passive: true });
					}
				}
			},
			onOpen: function(selectedDates, dateStr, instance)
			{
				// For time-enabled pickers: if the input is empty and hasn't been explicitly
				// cleared by the user, seed the picker UI with "now" in document timezone
				// as a visual preview. The value won't commit to the input field unless the
				// user explicitly interacts (clicks a date, edits time, clicks "Set to Current",
				// or presses Enter). If they close without interacting, we revert.
				if (enableTime && selectedDates.length === 0 && !instance.input['_userCleared'])
				{
					const fakeLocalNow = self.toFlatpickrDate('now', tmpTimezone);
					if (fakeLocalNow)
					{
						// false = don't trigger onChange, this is just a UI preview
						instance.setDate(fakeLocalNow, false);
						instance.input['_previewOnly'] = true;
						// Clear the display input so it still appears empty / shows placeholder
						instance.input.value = '';
					}
				}
				// On touch devices, scroll the input near the top of the viewport so
				// the calendar overlay has room to render below it without being
				// clipped — especially important for datetime and time pickers,
				// which are taller and where the iOS soft keyboard can still surface
				// for the in-picker hour/minute inputs. setTimeout defers the scroll
				// until after Flatpickr has placed its calendar, so Flatpickr's own
				// scroll-reposition handler runs once with the input in its final
				// resting spot rather than chasing a moving target.
				if (tmpIsTouchDevice)
				{
					setTimeout(function()
					{
						const tmpRect = instance.input.getBoundingClientRect();
						// Target ~80px from the top of the viewport — keeps the
						// field label visible above and frees maximum vertical
						// space below for the calendar (~340px for date-only,
						// taller for datetime/time pickers).
						const tmpTargetOffsetFromTop = 80;
						const tmpScrollDelta = tmpRect.top - tmpTargetOffsetFromTop;
						// Only scroll when we'd move more than a few pixels to
						// avoid jitter if the input is already well-placed.
						if (Math.abs(tmpScrollDelta) > 8)
						{
							window.scrollBy({ top: tmpScrollDelta, behavior: 'smooth' });
						}
					}, 50);
				}
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				if (selectedDates.length > 0)
				{
					// No offset math needed — Flatpickr now operates in document-TZ context.
					// The picker displays fake-local dates (via toFlatpickrDate), and the providers'
					// onDataRequest methods use fromFlatpickrDate to interpret the result correctly.
					if (enableTime)
					{
						// reset time changes flag for time/datetime pickers
						instance.input['_hasTimeChanges'] = false;
					}
					// User explicitly selected a value — no longer a preview
					instance.input['_previewOnly'] = false;
					// Clear the user-cleared flag since a value is now selected
					instance.input['_userCleared'] = false;
				}
			},
			onClose: function(selectedDates, dateStr, instance)
			{
				// If the picker was seeded with a preview "now" and the user never
				// interacted, revert — don't commit the previewed value.
				if (instance.input['_previewOnly'])
				{
					instance.clear();
					instance.input['_previewOnly'] = false;
					instance.input['_hasTimeChanges'] = false;
					return;
				}
				// auto-save any pending manual time changes when closing the picker
				if (enableTime && instance.input['_hasTimeChanges'])
				{
					// get current values from the time input fields (dateStr may be stale)
					const hourInput = instance.calendarContainer.querySelector('.flatpickr-hour');
					const minuteInput = instance.calendarContainer.querySelector('.flatpickr-minute');
					const ampmInput = instance.calendarContainer.querySelector('.flatpickr-am-pm');
					if (hourInput && minuteInput)
					{
						let hour = parseInt(hourInput.value, 10);
						const minute = parseInt(minuteInput.value, 10);
						// Handle AM/PM for 12-hour mode
						if (ampmInput && !pFlatpickrOptions.Time24Hour)
						{
							const isPM = ampmInput.textContent === 'PM';
							// Convert 12-hour to 24-hour format
							if (isPM && hour !== 12)
							{
								hour = hour + 12;
							}
							else if (!isPM && hour === 12)
							{
								hour = 0;
							}
						}
						// Create a fake-local Date with the manually entered time
						// (components represent document-TZ values since the picker operates in that context)
						const baseDate = selectedDates[0] || new Date();
						const newDate = new Date(
							baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(),
							hour, minute, 0, 0,
						);
						// Set date without triggering onChange - onDataRequest will use fromFlatpickrDate
						instance.setDate(newDate, false);
						// Dispatch change event to trigger onDataRequest
						const tmpChangeEvent = new Event('change', { bubbles: true });
						instance.input.dispatchEvent(tmpChangeEvent);
					}
					instance.input['_hasTimeChanges'] = false;
				}
				// Reset _userCleared after close so the next open of an empty picker
				// can seed the UI preview with "now" again
				instance.input['_userCleared'] = false;
			},
		};
		// initialize the flatpickr plugin
		window.flatpickr(tmpHTMLID, tmpConfig);
	}

	// TODO: Expand this to support more DayJS to Flatpickr format conversions as needed
	/**
	 * Convert a DayJS date format string to a Flatpickr date format string.
	 * @param {string} pDayJSFormat The DayJS date format string.
	 * @return {string} The converted Flatpickr date format string.
	 */
	convertDayJSToFlatpickrFormat(pDayJSFormat)
	{
		// simple mapping for common formats
		// TODO: expand this mapping as needed or implement a more robust conversion
		const formatMappings = {
			'YYYY-MM-DD': 'Y-m-d',
			'YYYY-MM-DD HH:mm': 'Y-m-d H:i',
			'YYYY-MM-DD HH:mm:ss': 'Y-m-d H:i:S',
			'YYYY-MM-DD HH:mm a': 'Y-m-d H:i K',
			'YYYY-MM-DD hh:mm a': 'Y-m-d h:i K',
			'YYYY-MM-DD HH:mm A': 'Y-m-d H:i K',
			'MM/DD/YYYY': 'm/d/Y',
			'MM/DD/YYYY HH:mm': 'm/d/Y H:i',
			'MM/DD/YYYY HH:mm:ss': 'm/d/Y H:i:S',
			'MM/DD/YYYY HH:mm a': 'm/d/Y H:i K',
			'MM/DD/YYYY hh:mm a': 'm/d/Y h:i K',
			'MM/DD/YYYY HH:mm A': 'm/d/Y H:i K',
			'HH:mm:ss': 'H:i:S',
			'HH:mm': 'H:i',
			'hh:mm': 'h:i',
			'HH:mm a': 'H:i K',
			'HH:mm A': 'H:i K',
			'hh:mm a': 'h:i K',
			'hh:mm A': 'h:i K',
			'hh:mm:ss a': 'h:i:S K',
			'hh:mm:ss A': 'h:i:S K',
		};
		if (formatMappings[pDayJSFormat])
		{
			return formatMappings[pDayJSFormat];
		}
		// if no mapping found, return the original format (may not work correctly)
		console.warn(`No Flatpickr format mapping found for DayJS format: ${pDayJSFormat}. Using original format.`);
		console.info('Consider expanding the formatMappings in convertDayJSToFlatpickrFormat() for better compatibility.');
		return pDayJSFormat;
	}

	/**
	 * Safely resolve a timezone string, falling back to the document timezone option,
	 * and ultimately to undefined (which causes dayjs.tz() to use the browser-local
	 * zone instead of throwing). An invalid or unrecognized timezone otherwise causes
	 * dayjs.tz() to throw, and Flatpickr's init swallows that exception silently —
	 * so callers should always route through this helper.
	 *
	 * @param {string} [pTimezone] - Candidate timezone string (e.g., 'America/Chicago')
	 * @return {string|undefined} A validated timezone string, or undefined to mean "browser local"
	 */
	resolveTimezone(pTimezone)
	{
		const candidate = pTimezone || this.fable?.options?.Timezone;
		if (!candidate)
		{
			return undefined;
		}
		try
		{
			// Intl rejects unknown zones with a RangeError; this is the canonical validity check
			new Intl.DateTimeFormat('en-US', { timeZone: candidate });
			return candidate;
		}
		catch (err)
		{
			console.warn(`FlatpickrUtilProvider: invalid timezone "${candidate}", falling back to browser local. Reason: ${err?.message}`);
			return undefined;
		}
	}

	/**
	 * Convert an ISO string (or special value) to a Date object whose local components
	 * match the document-timezone representation. This "tricks" Flatpickr into displaying
	 * document-TZ time as if it were browser-local time, so the user sees the correct
	 * document-context date/time without any post-hoc shifting.
	 *
	 * @param {string|Date|null} pISOValue - ISO string, Date object, 'now', 'today', or null/empty
	 * @param {string} [pDocumentTZ] - Document timezone (e.g., 'America/Chicago')
	 * @return {Date|null} A Date whose local components match document-TZ values, or null if invalid
	 */
	toFlatpickrDate(pISOValue, pDocumentTZ)
	{
		if (!pISOValue)
		{
			return null;
		}

		const tmpTimezone = this.resolveTimezone(pDocumentTZ);

		// Handle 'now' / 'today' special values
		if (this.isSpecialDefaultValue(pISOValue))
		{
			const nowInDocTZ = this.pict.Dates.dayJS().tz(tmpTimezone);
			return new Date(
				nowInDocTZ.year(), nowInDocTZ.month(), nowInDocTZ.date(),
				nowInDocTZ.hour(), nowInDocTZ.minute(), 0, 0,
			);
		}

		const parsed = this.pict.Dates.dayJS(pISOValue);
		if (!parsed.isValid())
		{
			return null;
		}

		// Convert to document timezone and extract components
		const inDocTZ = parsed.tz(tmpTimezone);

		// Create a fake-local Date whose .getHours(), .getDate(), etc. match document-TZ values
		// Flatpickr will display these as-is since it assumes everything is browser-local
		return new Date(
			inDocTZ.year(), inDocTZ.month(), inDocTZ.date(),
			inDocTZ.hour(), inDocTZ.minute(), inDocTZ.second(), inDocTZ.millisecond(),
		);
	}

	/**
	 * Convert a Date picked by Flatpickr back to an ISO string, interpreting its local
	 * components as document-timezone values (since we fed Flatpickr a fake-local Date
	 * via toFlatpickrDate). This is the inverse of toFlatpickrDate.
	 *
	 * @param {Date} pFlatpickrDate - Date object from Flatpickr (browser-local interpretation)
	 * @param {string} pDocumentTZ - Document timezone (e.g., 'America/Chicago')
	 * @param {string} [pPickerType='datetime'] - 'date', 'time', or 'datetime'
	 * @return {string} ISO string representing the picked moment in document-TZ context
	 */
	fromFlatpickrDate(pFlatpickrDate, pDocumentTZ, pPickerType = 'datetime')
	{
		if (!pFlatpickrDate || !(pFlatpickrDate instanceof Date) || isNaN(pFlatpickrDate.getTime()))
		{
			return '';
		}

		const tmpTimezone = this.resolveTimezone(pDocumentTZ);

		// Read the components the user actually saw in the Flatpickr UI
		const y = pFlatpickrDate.getFullYear();
		const m = pFlatpickrDate.getMonth() + 1; // JS Date is 0-indexed
		const d = pFlatpickrDate.getDate();
		const h = pFlatpickrDate.getHours();
		const min = pFlatpickrDate.getMinutes();
		const sec = pFlatpickrDate.getSeconds();

		// For date-only pickers, zero out the time to avoid DST edge cases
		const timeH = (pPickerType === 'date') ? 0 : h;
		const timeM = (pPickerType === 'date') ? 0 : min;
		const timeS = (pPickerType === 'date') ? 0 : sec;

		// Build a date-time string and interpret it as document-TZ. The static dayjs.tz()
		// form throws on an undefined timezone (unlike the instance .tz()), so when
		// resolveTimezone falls through to undefined we parse as browser-local instead.
		const dateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')} ${String(timeH).padStart(2, '0')}:${String(timeM).padStart(2, '0')}:${String(timeS).padStart(2, '0')}`;
		const interpreted = tmpTimezone ?
			this.pict.Dates.dayJS.tz(dateStr, 'YYYY-MM-DD HH:mm:ss', tmpTimezone) :
			this.pict.Dates.dayJS(dateStr, 'YYYY-MM-DD HH:mm:ss');

		if (!interpreted.isValid())
		{
			return '';
		}

		return interpreted.toISOString();
	}

	/**
	 * Determine whether a value is one of the logical "live" default tokens
	 * ('now', 'today') rather than a concrete date value. Matching is trimmed and
	 * case-insensitive so configuration authors aren't tripped up by casing.
	 *
	 * @param {any} pValue - Candidate value (typically a descriptor's `Default` or a marshaled model value)
	 * @return {boolean} True when the value is a recognized special default token
	 */
	isSpecialDefaultValue(pValue)
	{
		return (typeof pValue === 'string') && SPECIAL_DEFAULT_VALUES.includes(pValue.trim().toLowerCase());
	}

	/**
	 * Resolve a logical default token ('now'/'today') to the concrete ISO string that
	 * would have been stored had the user picked that moment. Composes the same
	 * fake-local round-trip (toFlatpickrDate → fromFlatpickrDate) the interactive
	 * onDataRequest path uses, so a locked-in default is byte-for-byte consistent with
	 * a user-entered value for the same instant. Returns '' for non-special values.
	 *
	 * @param {any} pValue - The value to resolve (only special tokens produce a result)
	 * @param {string} [pTimezone] - Document timezone (e.g., 'America/Chicago')
	 * @param {string} [pPickerType='datetime'] - 'date', 'time', or 'datetime'
	 * @return {string} The resolved ISO string, or '' if the value is not a special token
	 */
	resolveSpecialDefaultToISO(pValue, pTimezone, pPickerType = 'datetime')
	{
		if (!this.isSpecialDefaultValue(pValue))
		{
			return '';
		}
		const tmpFakeLocalDate = this.toFlatpickrDate(pValue, pTimezone);
		return this.fromFlatpickrDate(tmpFakeLocalDate, pTimezone, pPickerType);
	}

	/**
	 * @deprecated Use fromFlatpickrDate() instead. Kept for backward compatibility during migration.
	 * Convert parsed local time to ISO string, adjusting for timezone context.
	 * For edits (storedValue exists), interprets input as record timezone.
	 * For initial entry, interprets input as browser local time.
	 * @param {object} pLocalParsed dayJS parsed object (browser local interpretation)
	 * @param {string} pStoredValue existing ISO value (empty/null for initial entry)
	 * @param {string} pTimezone record timezone (e.g., 'America/Chicago')
	 * @return {string} ISO string
	 */
	convertToISOWithTimezoneContext(pLocalParsed, pStoredValue, pTimezone)
	{
		if (pStoredValue && typeof pStoredValue === 'string' && pStoredValue.length > 10)
		{
			// Edit
			const browserTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
			const browserOffset = pLocalParsed.tz(browserTimezone).utcOffset();
			const recordOffset = pLocalParsed.tz(pTimezone).utcOffset();
			const offsetDiffMinutes = recordOffset - browserOffset;
			return pLocalParsed.subtract(offsetDiffMinutes, 'minute').toISOString();
		}
		// Initial entry
		return pLocalParsed.toISOString();
	}

	/**
	 * Clear the date time picker.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	clearDatePicker(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				tmpFlatpickrInstance.clear();
				// Mark as explicitly cleared so onOpen won't re-seed with "now"
				tmpFlatpickrElement['_userCleared'] = true;
				// Reset time changes flag so onClose doesn't re-apply stale hour/minute values
				tmpFlatpickrElement['_hasTimeChanges'] = false;
				// Clear hidden input so next entry is treated as initial (not edit)
				const tmpHiddenID = tmpFlatpickrElement['_hiddenInputID'];
				if (tmpHiddenID)
				{
					this.pict.ContentAssignment.assignContent(tmpHiddenID, '');
				}
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}

	/**
	 * Format a date value with the given format and timezone. Usually, the timezone is set for the document record, but can be overridden.
	 * @param {string|Date} pDateValue The date value to format.
	 * @param {string} pDayJSDateFormat The date format string. (assumes DayJS formatting)
	 * @param {string} [pTimezone] (optional) The timezone to use for formatting.
	 * @param {boolean} [isTimeOnly] (optional) Whether the value is time-only. Defaults to false. If true, the date portion will be applied to today's date.
	 * @return {string} The formatted date string.
	 */
	formatDateWithTimezone(pDateValue, pDayJSDateFormat, pTimezone, isTimeOnly = false)
	{
		if (!pDateValue)
		{
			return '';
		}
		if (!pDayJSDateFormat)
		{
			console.error('DayJS date format is required for formatting the date value.');
			return '';
		}
		// use the provided timezone or fall back to the document timezone
		const tmpTimezone = this.resolveTimezone(pTimezone);
		// handle special 'now' or 'today' values
		if (this.isSpecialDefaultValue(pDateValue))
		{
			if (isTimeOnly)
			{
				// for time-only, combine today's date with the current time to make it a valid date for Flatpickr (will be saved as ISO time later)
				const tmpTodayDate = this.pict.Dates.dayJS().tz(tmpTimezone).format('YYYY-MM-DD');
				const tmpCurrentTime = this.pict.Dates.dayJS().tz(tmpTimezone).format(pDayJSDateFormat);
				return this.pict.Dates.dayJS(tmpTodayDate + ' ' + tmpCurrentTime).tz(tmpTimezone).format('YYYY-MM-DD ' + pDayJSDateFormat);
			}
			// for date or datetime, just return the current date/time in the specified timezone
			return this.pict.Dates.dayJS().tz(tmpTimezone).format(pDayJSDateFormat);
		}
		// validate the date value
		if (this.pict.Dates.dayJS(pDateValue).isValid() === false)
		{
			console.error(`Invalid date value provided: ${pDateValue}`);
			return '';
		}
		if ((typeof pDateValue == 'string' || pDateValue instanceof String) && pDateValue?.length == 10)
		{
			return this.pict.Dates.dayJS(pDateValue).format(pDayJSDateFormat);
		}
		return this.pict.Dates.dayJS(pDateValue).tz(tmpTimezone).format(pDayJSDateFormat);
	}

	/**
	 * Set the date time picker to the 'now' date/time.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	setDatePickerToNow(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				// Clear hidden input so the next save writes fresh
				const tmpHiddenID = tmpFlatpickrElement['_hiddenInputID'];
				if (tmpHiddenID)
				{
					this.pict.ContentAssignment.assignContent(tmpHiddenID, '');
				}
				// Create a fake-local Date representing "now" in document timezone
				const tmpTimezone = this.resolveTimezone();
				const nowInDocTZ = this.pict.Dates.dayJS().tz(tmpTimezone);
				const fakeLocalNow = new Date(
					nowInDocTZ.year(), nowInDocTZ.month(), nowInDocTZ.date(),
					nowInDocTZ.hour(), nowInDocTZ.minute(), 0, 0,
				);
				tmpFlatpickrInstance.setDate(fakeLocalNow);
				// "Set to Current" commits a real value. setDate() above runs with
				// triggerChange=false (no onChange), so clear the onOpen "now" preview
				// flag (and any pending manual-time flag) ourselves — otherwise the
				// trailing close() -> onClose sees _previewOnly and reverts the value we
				// just set, so it would only reappear on a later marshal.
				tmpFlatpickrElement['_previewOnly'] = false;
				tmpFlatpickrElement['_hasTimeChanges'] = false;
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}
}

module.exports = FlatpickrUtilProvider;

},{"dayjs/plugin/customParseFormat":355,"pict-provider":479}],45:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#BRIDGE-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedBridge.StructureNumber || 'N/A',
				this.pict.AppData.SelectedBridge.Name || ('Unnamed Bridge #' + this.pict.AppData.SelectedBridge.IDBridge),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedBridge.Name || ('Unnamed Bridge #' + this.pict.AppData.SelectedBridge.IDBridge);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), resolve the Bridge for display (StructureNumber, Name)
		if (pValue)
		{
			// Prefer the bridge cached in FormData (the document is a point-in-time record), so long
			// as it matches the selection.
			const tmpCachedBridge = this.pict.AppData?.DocumentData?.ReportData?.FormData?.Bridge;
			if (tmpCachedBridge && tmpCachedBridge.IDBridge > 0 && tmpCachedBridge.IDBridge == pValue)
			{
				//FIXME: this input type managing SelectedBridge in AppData feels like a hack
				this.pict.AppData.SelectedBridge = tmpCachedBridge;
			}
			else if (!this.pict.AppData.SelectedBridge)
			{
				const tmpResult = await this.pict.providers.BridgeProvider.getBridgeByID(pValue);
				this.pict.AppData.SelectedBridge = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],46:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.onChangeCallbacks = [];
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#BRIDGE-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Adds an onChange callback to the input handler.
	 * @param {function} pCallback The callback function.
	 */
	addOnChangeCallback(pCallback)
	{
		if (!pCallback || typeof pCallback !== 'function')
		{
			this.pict.log.error('Invalid onChangeCallback provided.');
			return;
		}
		// check if the callback is already in the list
		if (this.onChangeCallbacks.indexOf(pCallback) > -1)
		{
			this.pict.log.warn('onChangeCallback already exists in the list.');
			return;
		}
		this.onChangeCallbacks.push(pCallback);
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pStateFilter The state fitler string.
	 */
	initializeSelect2(pInput, pStateFilter)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Bridge',
				{
					Input: pInput,
					SearchFields: [ 'StructureNumber', 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Select a Bridge by name or code...',
					HandleSearchFilters: (pFilters) =>
					{
						if (!pStateFilter)
						{
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						if (Array.isArray(pStateFilter))
						{
							pFilters.push(`FBL~State~INN~${pStateFilter.join(',')}`);
						}
						else
						{
							pFilters.push(`FBV~State~EQ~${pStateFilter}`);
						}
						return pFilters;
					},
					GetRecordUserFacingID: (pBridge) => pBridge.StructureNumber || 'N/A',
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), resolve the Bridge for display (StructureNumber, Name)
		if (pValue && typeof pValue === 'string' || typeof pValue === 'number')
		{
			// Prefer the bridge cached in FormData (the document is a point-in-time record), so long
			// as it matches the selection.
			const tmpCachedBridge = this.pict.AppData?.DocumentData?.ReportData?.FormData?.Bridge;
			let tmpBridge;
			if (tmpCachedBridge && tmpCachedBridge.IDBridge > 0 && tmpCachedBridge.IDBridge == pValue)
			{
				tmpBridge = tmpCachedBridge;
			}
			else
			{
				tmpBridge = await this.pict.providers.BridgeProvider.getBridgeByID(pValue);
			}
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			if (!tmpSelectElement)
			{
				return false;
			}
			tmpOption.value = tmpBridge.IDBridge;
			tmpOption.text = `${tmpBridge.StructureNumber || 'N/A'}|~|${tmpBridge.Name || ('Unnamed Bridge #' + tmpBridge.IDBridge)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		else
		{
			this.pict.log.info('No Bridge selected.');
		}
		// set the bridge selection callback for the Bridge Search Panel
		this.pict.views.HeadlightPaneBridges.setBridgeSelectionCallback((pBridge) =>
		{
			this.pict.log.info('Bridge selected:', pBridge.IDBridge);
			this.pict.log.info('Assigning bridge to the following input element:', pInput.Macro.RawHTMLID);
			// NOTE: ContentAssignment is failing to set this value for some reason, should investigate later
			document.getElementById(pInput.Macro.RawHTMLID)['value'] = pBridge.IDBridge;
			document.getElementById(pInput.Macro.RawHTMLID).dispatchEvent(new Event('change'));
		});
		// get the configuration for the current user to filter the Bridge search results (by State, etc.)
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.pict.AppData?.CurrentUser?.CustomerID, (pConfig) =>
		{
			const tmpStateFilter = pConfig?.StateAbbreviation || null;
			this.initializeSelect2(pInput, tmpStateFilter);
			this.removeLoadingSkeleton(pInput);
		});
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data change event for a select input in the PictProviderInputSelect class.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.onChangeCallbacks.length > 0)
		{
			this.onChangeCallbacks.forEach((pCallback) =>
			{
				pCallback(pView, pInput, pValue, pHTMLSelector);
			});
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],47:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/*
	Tier-2.5 accessibility helper for the Color input type.

	`readonly` does nothing on `<input type="color">`, so the Read (locked) theme can't use
	the text-input readonly swap. Instead the Read template renders a static display node
	(`DISPLAY-FOR-{RawHTMLID}`) and this extension paints a color swatch plus the hex value
	text into it — readable and announced, instead of a `disabled` color control that screen
	readers skip and that gives no textual value.

	Acts only when the display node is present (Read theme); a no-op in Edit/Print, where
	`super` still drives the core informary binding of the live control. Per the repo
	convention we build node content with createElement/append, not HTML strings.
*/
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Returns the HTML selector for the Read-theme static display node.
	 * @param {string} pInputHTMLID - The raw HTML ID of the input.
	 * @return {string} - The selector for the display node.
	 */
	getDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Returns the HTML selector for the Read-theme tabular static display node.
	 * @param {string} pInputHTMLID - The raw HTML ID of the input.
	 * @param {number} pRowIndex - The tabular row index.
	 * @return {string} - The selector for the tabular display node.
	 */
	getTabularDisplayHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-TABULAR-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Normalizes a marshalled value into a `#rrggbb` (or `#rgb`) hex string, or null if it
	 * doesn't look like a hex color. Used both as the swatch background and the visible text.
	 * @param {any} pValue - The value to normalize.
	 * @return {string|null} - The normalized hex string, or null.
	 */
	normalizeHex(pValue)
	{
		if (typeof pValue !== 'string')
		{
			return null;
		}
		const tmpTrimmed = pValue.trim();
		return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(tmpTrimmed) ? tmpTrimmed.toLowerCase() : null;
	}

	/**
	 * Paints the swatch + hex text into the display node, if present.
	 * @param {string} pDisplaySelector - The selector for the display node.
	 * @param {any} pValue - The marshalled value.
	 * @return {void}
	 */
	renderColorDisplay(pDisplaySelector, pValue)
	{
		const tmpElements = this.pict.ContentAssignment.getElement(pDisplaySelector);
		if (!tmpElements || tmpElements.length < 1)
		{
			return;
		}
		const tmpHex = this.normalizeHex(pValue);

		const tmpContainer = document.createElement('span');
		tmpContainer.className = 'color-display';

		const tmpSwatch = document.createElement('span');
		tmpSwatch.className = 'color-swatch';
		// Swatch is decorative; the adjacent hex text carries the value for assistive tech.
		tmpSwatch.setAttribute('aria-hidden', 'true');
		if (tmpHex)
		{
			tmpSwatch.style.backgroundColor = tmpHex;
		}
		tmpContainer.appendChild(tmpSwatch);

		const tmpText = document.createElement('span');
		tmpText.textContent = tmpHex || (typeof pValue === 'string' && pValue.trim() ? pValue.trim() : 'None');
		tmpContainer.appendChild(tmpText);

		for (let i = 0; i < tmpElements.length; i++)
		{
			const tmpTarget = tmpElements[i];
			// Clear via a removeChild loop rather than replaceChildren(), which isn't available
			// on the older browsers in this bundle's "since 2018" browserslist target.
			while (tmpTarget.firstChild)
			{
				tmpTarget.removeChild(tmpTarget.firstChild);
			}
			tmpTarget.appendChild(tmpContainer.cloneNode(true));
		}
	}

	/**
	 * Marshals the color value into the Read-theme display node (no-op outside Read).
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of super.onDataMarshalToForm.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.renderColorDisplay(this.getDisplayHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals the color value into the Read-theme tabular display node (no-op outside Read).
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of super.onDataMarshalToFormTabular.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.renderColorDisplay(this.getTabularDisplayHTMLID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],48:[function(require,module,exports){
// Headlight `Diagram` input provider — the Excalidraw-backed drawing canvas from pict-section-form,
// wrapped with the shared inline View/Edit presentation behavior (see EditorBase). PSF does
// not auto-register this provider (its heavy editor dep is an opt-in), so the Headlight bundle registers
// it under the hash `Pict-Input-Diagram` that the templates' DefaultInputExtensions reference.
const DiagramInput = require('pict-section-form').DiagramInput;
const { buildEditorInputProvider } = require('./PictProvider-InputType-EditorBase.js');

// The Excalidraw vendor bundle is ~25MB (8.4MB wrapper + 13MB fonts + locales), so it is never bundled
// or script-tagged — pict-section-excalidraw lazy-loads it from these URLs on the FIRST edit only.
// Defaulting them here means every form in every app that attaches this bundle gets a working editor
// with no per-descriptor config. Resolution order (first wins):
//   1. PictForm.Diagram.EditorOptions.LazyLoad*URL  — per field
//   2. provider option ExcalidrawVendorPath         — per app, e.g. attachProviders({'Pict-Input-Diagram': {...}})
//   3. the default below                            — document-relative, matching how headlight-dynamic-form
//                                                     serves its libs (./ alongside index.html)
// The host must serve the contents of
// node_modules/pict-section-excalidraw/vendor/excalidraw-built/ at that path.
const _DEFAULT_VENDOR_PATH = './excalidraw';
const _EDITOR_REACHABLE_TIMEOUT_MS = 5000;
const _UNAVAILABLE_NOTICE_CLASS = 'headlight-diagram-unavailable-notice';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Input-Diagram',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Join the app save-data lifecycle so EditorBase.onBeforeSaveDataAsync fires — it flushes an editor
	// left open at save time into FormData (the per-keystroke marshal is deferred to View, so without
	// this a Save-while-editing would persist the pre-edit value). NOT a framework default.
	AutoSaveDataWithApp: true,

	ExcalidrawVendorPath: _DEFAULT_VENDOR_PATH,
};

const EditorProviderBase = buildEditorInputProvider(DiagramInput, _DEFAULT_CONFIGURATION);

class PictProviderInputTypeDiagram extends EditorProviderBase
{
	/**
	 * Point the editor view at the lazily-loaded Excalidraw vendor bundle unless the field or the app
	 * already named its own URLs.
	 *
	 * @param {Record<string, any>} pInput @param {any} pValue @param {Record<string, any>} pInst
	 * @return {Record<string, any>}
	 */
	_buildEditorOptions(pInput, pValue, pInst)
	{
		const tmpOptions = super._buildEditorOptions(pInput, pValue, pInst);
		const tmpVendorPath = (this.options && this.options.ExcalidrawVendorPath) || _DEFAULT_VENDOR_PATH;

		// IFRAME mode is the default here, and that is a Headlight-specific requirement rather than a
		// preference: the form document already loads React 17 as a window global, Excalidraw needs
		// React 18+ (it calls ReactDOM.createRoot), and the react embed only fetches its own bundled
		// React when `window.React` is ABSENT — so in this host it binds to React 17 and dies with
		// "tmpReactDOM.createRoot is not a function". The iframe host loads its own React 18 inside the
		// frame, so the page's React is irrelevant. Switch to 'react' only in a host with React 18+.
		//
		// pict-section-form passes the field's choice as `EditorImplementation`, but the excalidraw
		// module reads `EmbedMode` — so map it here, which is also what makes the descriptor's
		// documented "EditorImplementation" option actually take effect.
		//
		// Read the choice off the DESCRIPTOR, not off the options PSF just built: PSF always writes
		// `EditorImplementation: <field value> || 'react'`, so the key is never absent and testing it
		// would pin every field to react and never reach the iframe default below.
		const tmpDiagramOptions = (pInput && pInput.PictForm && pInput.PictForm.Diagram) || {};
		const tmpRequestedMode = tmpOptions.EmbedMode || tmpDiagramOptions.EditorImplementation;
		const tmpEmbedMode = tmpRequestedMode || 'iframe';
		tmpOptions.EmbedMode = tmpEmbedMode;
		// Keep the two in step so anything reading the PSF-style key sees the mode actually in use.
		tmpOptions.EditorImplementation = tmpEmbedMode;

		if (!tmpOptions.IframeHostURL)
		{
			tmpOptions.IframeHostURL = `${tmpVendorPath}/excalidraw-iframe-host.html`;
		}
		// Fonts + locales. In iframe mode the wrapper runs INSIDE the host page (which already sits in
		// the vendor directory), so the path is relative to that; in react mode it runs in this page.
		if (!tmpOptions.AssetBaseURL)
		{
			tmpOptions.AssetBaseURL = (tmpEmbedMode === 'iframe') ? './assets/' : `${tmpVendorPath}/assets/`;
		}

		// Lazy-load URLs are for REACT mode only. Setting them in iframe mode is not merely redundant:
		// the react view's _lazyLoadVendor() unconditionally injects a <script> for the wrapper, so a
		// stray URL pulls all ~8.4MB of it into the PARENT page — which the iframe host never uses,
		// because it loads its own copy (and its own React) inside the frame.
		if (tmpEmbedMode === 'react')
		{
			// PSF merges PictForm.Diagram.EditorOptions first, so a field-level URL is already present
			// here and must not be clobbered.
			if (!tmpOptions.LazyLoadWrapperURL)
			{
				tmpOptions.LazyLoadWrapperURL = `${tmpVendorPath}/excalidraw-wrapper.min.js`;
			}
			if (!tmpOptions.LazyLoadReactVendorURL)
			{
				tmpOptions.LazyLoadReactVendorURL = `${tmpVendorPath}/react-vendor.min.js`;
			}
		}
		else
		{
			// IFRAME re-seeding. Reopening a saved diagram has to parse the scene back out of the stored
			// SVG, and only the iframe side has the vendor that can do it — the parent's
			// `_extractSceneFromSvg` calls `window.PictSectionExcalidrawVendor`, which is never present in
			// this host (that absence is the whole reason we run in the iframe), so it returns null and
			// the editor opens blank over real content. Hand the raw SVG through as InitialData.svgSource;
			// the iframe host (patched) parses it before mount. `_resolveInitialData` only falls back to
			// InitialData when the AppData scene is empty, which it always is here, so this does not fight
			// the react path. elements:[] is required — an empty array still reads as "no scene yet".
			if (this._isLikelySvg(pValue))
			{
				tmpOptions.InitialData =
				{
					elements: [],
					appState: {},
					files: {},
					svgSource: pValue,
				};
			}
		}
		return tmpOptions;
	}

	/**
	 * An iOS offline form (`window._OfflineMode`) carries no Excalidraw vendor, because the offline capture
	 * keeps only the scripts already on the page, and the iPad app loads that form from a local file even when
	 * online. There, Edit first checks that the editor can load; if it
	 * cannot, the field stays in View with the saved drawing and a note, instead of opening a blank editor.
	 *
	 * @param {string} pInputHash @param {string} pRawHTMLID @param {string} pMode - 'edit' | 'view'
	 */
	setEditorMode(pInputHash, pRawHTMLID, pMode)
	{
		if ((pMode !== 'edit') || (typeof window === 'undefined') || !(/** @type {any} */ (window))._OfflineMode)
		{
			return super.setEditorMode(pInputHash, pRawHTMLID, pMode);
		}
		this._isEditorReachable().then((pReachable) =>
		{
			if (pReachable)
			{
				super.setEditorMode(pInputHash, pRawHTMLID, pMode);
				return;
			}
			this._showEditorUnavailable(pRawHTMLID);
		});
	}

	/**
	 * @return {Promise<boolean>} True when the Excalidraw iframe host page can be fetched right now.
	 */
	_isEditorReachable()
	{
		if ((typeof navigator !== 'undefined') && (navigator.onLine === false))
		{
			return Promise.resolve(false);
		}
		const tmpVendorPath = (this.options && this.options.ExcalidrawVendorPath) || _DEFAULT_VENDOR_PATH;
		let tmpURL;
		try
		{
			tmpURL = new URL(`${tmpVendorPath}/excalidraw-iframe-host.html`, document.baseURI).href;
		}
		catch (pError)
		{
			return Promise.resolve(false);
		}
		const tmpTimeout = new Promise((fResolve) => setTimeout(() => fResolve(false), _EDITOR_REACHABLE_TIMEOUT_MS));
		// The reports service answers a missing asset with 200 and a JSON body, so a JSON reply is a miss.
		const tmpProbe = fetch(tmpURL, { cache: 'no-store' }).then(
			(pResponse) => pResponse.ok && !(pResponse.headers.get('content-type') || '').includes('json'),
			() => false);
		return Promise.race([ tmpProbe, tmpTimeout ]);
	}

	/**
	 * @param {string} pRawHTMLID
	 */
	_showEditorUnavailable(pRawHTMLID)
	{
		const tmpSlot = document.getElementById(this.getContentDisplayHTMLID(pRawHTMLID));
		if (!tmpSlot || tmpSlot.querySelector(`.${_UNAVAILABLE_NOTICE_CLASS}`))
		{
			return;
		}
		const tmpNotice = document.createElement('p');
		tmpNotice.className = `help is-warning ${_UNAVAILABLE_NOTICE_CLASS}`;
		tmpNotice.textContent = 'Drawings can\'t be edited in the iPad app yet. The saved drawing is unchanged.';
		tmpSlot.appendChild(tmpNotice);
	}
}

// NOTE: there is deliberately no "wipe guard" here. An earlier version refused to let a blank export
// overwrite a diagram whose scene could not be re-seeded, paired with a Clear button. Both were removed
// 2026-07-22 (Doug's call): with the export + re-seed fixes in place, a real Excalidraw diagram always
// carries an embedded scene and re-opens with its content, so open→close preserves it on its own. The
// only unseedable values left are hand-authored placeholder SVGs (the examples) — and treating an
// intentional blank (Excalidraw's nav-menu "reset the canvas") as a value worth keeping is the behavior
// Doug wants: what the editor shows on close is what saves, blank included.

module.exports = PictProviderInputTypeDiagram;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-EditorBase.js":50,"pict-section-form":497}],49:[function(require,module,exports){
/**
 * Headlight presentation styling for the Diagram / RichText editor input types.
 *
 * This is the WRAPPER chrome plus the small typography gaps PSF's view CSS leaves — the controls row,
 * the View/Edit segmented switch, rendered-markdown headings/lists, the single-segment editor, and the
 * print-theme border. The editors' own internals (Excalidraw, the markdown editor) self-register their
 * CSS; this only fills what the wrapper needs and what the app reset strips.
 *
 * NOTE: this whole module is a JS template literal — NEVER put a backtick in these comments, it
 * terminates the string and the module stops parsing (there is a test asserting no backticks).
 */
module.exports = /*css*/`
.pict-editor-controls
{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
}

/* is-small controls; align-items:center keeps them the same height, margin-bottom:0 undoes Bulma's
   .button spacing so the row height is exactly the button height. */
.pict-editor-controls .button
{
	margin-bottom: 0;
}

/* The View/Edit segmented switch. Both segments ship as is-link is-soft (soft, inactive look); the
   ACTIVE one is promoted to solid link here. The .button in the selector lifts specificity above
   Bulma's own .button.is-link.is-soft so the solid fill wins without !important. */
.pict-editor-switch
{
	margin-bottom: 0;
}
.pict-editor:not(.is-editing) .button.pict-editor-switch-view,
.pict-editor.is-editing .button.pict-editor-switch-edit
{
	background-color: var(--bulma-link, #485fc7);
	border-color: var(--bulma-link, #485fc7);
	color: var(--bulma-link-invert, #ffffff);
	z-index: 1;
}

/* --- Rendered-markdown typography (RichText view) ------------------------------------------------
   PSF's view CSS gives headings a color and margin but NO font-size, and does not touch lists at all,
   so the app's reset flattens h1..h6 to body size and strips bullets (verified: h1 rendered at 15px /
   weight 400, ul at list-style:none / padding:0). Restore a plain prose scale, scoped to the view. */
.pict-section-form-richtext-view h1 { font-size: 1.6em; font-weight: 700; }
.pict-section-form-richtext-view h2 { font-size: 1.35em; font-weight: 700; }
.pict-section-form-richtext-view h3 { font-size: 1.15em; font-weight: 700; }
.pict-section-form-richtext-view h4 { font-size: 1em; font-weight: 700; }
.pict-section-form-richtext-view h5 { font-size: 0.9em; font-weight: 700; }
.pict-section-form-richtext-view h6 { font-size: 0.85em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; }
.pict-section-form-richtext-view ul,
.pict-section-form-richtext-view ol
{
	margin: 0.5em 0;
	padding-left: 1.5em;
}
.pict-section-form-richtext-view ul { list-style: disc outside; }
.pict-section-form-richtext-view ol { list-style: decimal outside; }
.pict-section-form-richtext-view li { margin: 0.15em 0; display: list-item; }

/* Single segment per field: PSF's provider only ever serialises one segment (its onContentChange
   writes the changed segment over the whole value), but the markdown editor still renders an
   "Add Segment" button. Hide it so the UI matches the model — extra segments only ever got dropped. */
.pict-section-form-richtext .pict-mde-add-segment
{
	display: none;
}

/* Remarks are text-only: PSF rejects the upload unless the descriptor sets RichText.AllowImages, and the
   hardened renderer drops the data: URI the editor would inline. Hide the Insert Image button to match. */
.pict-section-form-richtext .pict-mde-sidebar-btn-image
{
	display: none;
}

/* Print/PDF theme: drop the view's outline so the exported document reads as content, not a form
   field. Read keeps the border on purpose (an on-screen boundary). Scoped to the print container class
   the template adds only for the Print theme. */
.pict-editor-print .pict-section-form-diagram,
.pict-editor-print .pict-section-form-richtext
{
	border: 0;
	border-radius: 0;
}
`;

},{}],50:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

// Shared Headlight behavior for the pict-section-form complex-editor input types (Diagram, RichText).
//
// PSF ships these editors booting in VIEW mode with no edit affordance — the host must drive setMode.
// The Diagram and RichText providers are structurally identical (same setMode/getMode/commit API, same
// _instances-keyed-by-Hash, same #DISPLAY-FOR-{RawHTMLID} slot), differing only in their base class and
// provider identifier, so this factory adds the Headlight presentation behavior once and both providers
// reuse it. The presentation is a single inline one: the field edits in place, and a View/Edit segmented
// switch (setEditorMode) flips between the static view and the live editor, toggling the `is-editing`
// class the CSS keys off. Switching to View commits first (a final synchronous export so a quick
// edit-then-View does not drop the last change).
//
// The field opens and closes through that switch ON PURPOSE. Closing is the commit point, so an
// "always editing" presentation would be a field with no moment at which its value is known to be
// exported — that mode was considered and dropped rather than carry an unreliable save path. (A
// floating "Compact" modal presentation also existed and was removed 2026-07-22: the inline editor
// carries its own toolbar, so the modal added bug surface — backdrop, centering, scroll containment,
// preview sizing — without a need it earned.)
//
// Tabular is intentionally unsupported — the PSF base throws in onInputInitializeTabular (N editors per
// row is a performance landmine), so these types are Standard/Vertical (and RecordSet-as-Tabular) only.

const libEditorCSS = require('./PictProvider-InputType-Editor-CSS.js');

/**
 * Build a Headlight subclass of a PSF complex-editor input provider.
 *
 * @param {any} pBaseClass - The PSF provider class (DiagramInput / RichTextInput).
 * @param {Record<string, any>} pDefaultConfiguration - Provider configuration (ProviderIdentifier etc.).
 * @return {any} The Headlight subclass.
 */
function buildEditorInputProvider(pBaseClass, pDefaultConfiguration)
{
	class HeadlightEditorInput extends pBaseClass
	{
		/**
		 * @param {import('fable')} pFable @param {Record<string, any>} [pOptions] @param {string} [pServiceHash]
		 */
		constructor(pFable, pOptions, pServiceHash)
		{
			super(pFable, Object.assign({}, pDefaultConfiguration, pOptions), pServiceHash);
			/** @type {Pict} */
			this.pict;
		}

		/**
		 * The id of the Headlight presentation container the templates wrap the field in. The PSF base
		 * only toggles mode classes on the hidden input / display slot, so the View/Edit switch needs its
		 * own container hook (the `is-editing` class), which this owns.
		 * @param {string} pRawHTMLID @return {string}
		 */
		getEditorContainerID(pRawHTMLID)
		{
			return `PICT-EDITOR-FOR-${pRawHTMLID}`;
		}

		/**
		 * Reflect edit/view state on the presentation container so the switch highlight and the
		 * view/editor swap respond in CSS.
		 * @param {string} pRawHTMLID @param {string} pMode - 'edit' | 'view'
		 */
		_reflectEditorState(pRawHTMLID, pMode)
		{
			if (typeof document === 'undefined')
			{
				return;
			}
			const tmpContainer = document.getElementById(this.getEditorContainerID(pRawHTMLID));
			if (tmpContainer && tmpContainer.classList)
			{
				tmpContainer.classList.toggle('is-editing', pMode === 'edit');
			}
		}

		/** One-time registration of the Headlight wrapper CSS (the PSF provider injects its own editor CSS separately). */
		_injectEditorCSS()
		{
			if (this._editorCSSInjected || !this.pict || !this.pict.CSSMap || (typeof this.pict.CSSMap.addCSS !== 'function'))
			{
				return;
			}
			this._editorCSSInjected = true;
			this.pict.CSSMap.addCSS('Headlight-Editor-Inputs', libEditorCSS, 500);
			if (typeof this.pict.CSSMap.injectCSS === 'function')
			{
				this.pict.CSSMap.injectCSS();
			}
		}

		onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
		{
			this._injectEditorCSS();
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}

		/**
		 * While an editor is OPEN, never let a marshal push content back into it — the open editor is
		 * the authority on its own content.
		 *
		 * Upstream, both PSF providers treat edit mode as "hot-replace what the user is working on":
		 * RichText re-renders its view (which destroys and rebuilds the CodeMirror EditorView) and
		 * Diagram calls setScene() on the live canvas. That fires on the field's OWN export, so every
		 * keystroke / tool click loops:
		 *     editor change -> _writeHiddenInputValue dispatches 'change' -> form marshals every section
		 *     -> onDataMarshalToForm hits this still-open editor -> it replaces itself mid-edit.
		 * Symptoms were RichText losing focus on the first keypress (unusable) and the Diagram canvas
		 * blanking on any tool click — the marshaled value there is the descriptor's hand-written
		 * placeholder SVG, which carries no embedded Excalidraw scene, so the replacement scene is empty.
		 *
		 * Skipping is safe in both directions: the echo case is a value the editor just produced, and a
		 * genuine external write (a solver) would be hostile mid-edit anyway — it would silently discard
		 * what the user is typing. Closing the editor commits, so the user's content wins on the way out.
		 * View mode still delegates, because re-mounting the static view from a new value IS correct.
		 * The base InputExtension.onDataMarshalToForm is a `return true` no-op, so returning true here
		 * matches the contract exactly.
		 *
		 * @param {Object} pView @param {Object} pGroup @param {Object} pRow @param {Object} pInput
		 * @param {any} pValue @param {string} pHTMLSelector @param {string} pTransactionGUID
		 * @return {any}
		 */
		onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
		{
			const tmpInstance = (this._instances && pInput) ? this._instances[pInput.Hash] : null;
			if (tmpInstance && (tmpInstance.mode === 'edit'))
			{
				return true;
			}
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}

		/**
		 * Defer the per-keystroke whole-form marshal to the View (accept) step.
		 *
		 * PSF writes the editor's value into the hidden <input> on every keystroke (RichText) / scene
		 * change (Diagram), and each write dispatches a 'change' that runs the form's WHOLE-form marshal —
		 * every section re-marshals on every keystroke (other providers' onDataMarshalToForm all fire; it
		 * shows up as their console logs and is pure overhead for a display field nothing else reads live).
		 * The value write is cheap and worth keeping (the hidden input stays current and informary-bound,
		 * so a save that re-reads fields still sees the latest); the 'change' DISPATCH is the expensive
		 * part. So while a field is being edited we keep the value write but SUPPRESS the dispatch. The one
		 * marshal then fires on toggle to View — the natural "accept" point before a document save (see
		 * setEditorMode → _flushMarshal). Diagram's OnChange is already throttled (150ms); this collapses
		 * both editors to a single marshal per edit session.
		 * @param {string} pInputHTMLID @param {any} pValue @return {boolean}
		 */
		_writeHiddenInputValue(pInputHTMLID, pValue)
		{
			if ((typeof document !== 'undefined') && this._isEditingRawHTMLID(pInputHTMLID))
			{
				const tmpElement = /** @type {HTMLInputElement} */ (document.getElementById(pInputHTMLID));
				if (!tmpElement)
				{
					return false;
				}
				// Keep the bound value current, but do NOT dispatch 'change' — the marshal waits for View.
				tmpElement.value = (pValue == null) ? '' : String(pValue);
				return true;
			}
			return super._writeHiddenInputValue(pInputHTMLID, pValue);
		}

		/**
		 * @param {string} pRawHTMLID @return {boolean} True if an instance with this RawHTMLID is editing.
		 */
		_isEditingRawHTMLID(pRawHTMLID)
		{
			if (!this._instances)
			{
				return false;
			}
			for (const tmpHash of Object.keys(this._instances))
			{
				const tmpInstance = this._instances[tmpHash];
				if (tmpInstance && (tmpInstance.mode === 'edit') && tmpInstance.input && tmpInstance.input.Macro &&
					(tmpInstance.input.Macro.RawHTMLID === pRawHTMLID))
				{
					return true;
				}
			}
			return false;
		}

		/**
		 * Dispatch one 'change' on the hidden input so its (already-current) value marshals a single time.
		 * Used both on View and at save time. The value is already in the bound hidden input; the 'change'
		 * makes the form read it into FormData (and propagate). The onDataMarshalToForm guard keeps this
		 * from disturbing a still-open editor.
		 * @param {string} pRawHTMLID
		 */
		/**
		 * The open editor's own latest content, for providers that track it; undefined when they don't.
		 * RichText overrides this (PSF keeps it as `lastValue` on every keystroke). Diagram does not: its
		 * value comes from a forced export at commit, so re-asserting a remembered value could clobber it.
		 * @param {Record<string, any>} pInstance @return {string|undefined}
		 */
		_getOpenEditorValue(pInstance)
		{
			return undefined;
		}

		/**
		 * Put an open editor's own content back into its hidden input before that input is flushed.
		 *
		 * The hidden input is the only place a typed value lives until it marshals, and the form writes
		 * FormData back into EVERY input on a whole-form marshal -- the provider's onDataMarshalToForm skip
		 * above cannot stop that. So with two editors open, the first one's flush reset the second one's
		 * hidden input to its stale saved value, and the second flush then saved the stale value: every
		 * open remark but one was lost on Save (Matt, LADOTD F&E forms, 2026-09-24).
		 * @param {Record<string, any>} pInstance
		 */
		_reassertHiddenInputValue(pInstance)
		{
			const tmpValue = this._getOpenEditorValue(pInstance);
			if ((typeof tmpValue !== 'string') || (typeof document === 'undefined') || !pInstance || !pInstance.input || !pInstance.input.Macro)
			{
				return;
			}
			const tmpElement = /** @type {HTMLInputElement} */ (document.getElementById(pInstance.input.Macro.RawHTMLID));
			if (tmpElement)
			{
				tmpElement.value = tmpValue;
			}
		}

		_flushMarshal(pRawHTMLID)
		{
			if (typeof document === 'undefined')
			{
				return;
			}
			const tmpElement = document.getElementById(pRawHTMLID);
			if (tmpElement && (typeof tmpElement.dispatchEvent === 'function'))
			{
				try
				{
					tmpElement.dispatchEvent(new Event('change', { bubbles: true }));
				}
				catch (pError)
				{
					// jsdom-in-test sometimes lacks the Event constructor; harmless in the browser.
				}
			}
		}

		/**
		 * Save-lifecycle hook — flush any editor still OPEN when the document is saved.
		 *
		 * The per-keystroke marshal is deferred to View (see _writeHiddenInputValue), and the app's save
		 * path reads the in-memory FormData without re-reading the DOM — so a Save fired while an editor is
		 * open would persist the PRE-edit value (the typed value is only in the bound hidden input, not yet
		 * in FormData). Here we flush each open editor first: the value is already in its hidden input, so
		 * one 'change' reads it into FormData before save proceeds. Requires AutoSaveDataWithApp:true in the
		 * provider config, or this hook never runs. Closed editors are already current and are skipped.
		 * @param {(pError?: Error) => void} fCallback
		 */
		onBeforeSaveDataAsync(fCallback)
		{
			if (this._instances)
			{
				for (const tmpHash of Object.keys(this._instances))
				{
					const tmpInstance = this._instances[tmpHash];
					if (tmpInstance && (tmpInstance.mode === 'edit') && tmpInstance.input && tmpInstance.input.Macro)
					{
						// An earlier editor's flush may have reset this one's hidden input -- see above.
						this._reassertHiddenInputValue(tmpInstance);
						this._flushMarshal(tmpInstance.input.Macro.RawHTMLID);
					}
				}
			}
			return super.onBeforeSaveDataAsync(fCallback);
		}

		/**
		 * Move a field to an explicit mode. Driven by the View/Edit segmented switch, where each segment
		 * names its target mode rather than flipping whatever is current.
		 * @param {string} pInputHash @param {string} pRawHTMLID @param {string} pMode - 'edit' | 'view'
		 */
		setEditorMode(pInputHash, pRawHTMLID, pMode)
		{
			if (this.getMode(pInputHash) === pMode)
			{
				return;
			}
			if (pMode === 'view')
			{
				// Commit (Diagram forces a final export; RichText already has the value from keystrokes),
				// drop to view, THEN marshal once. That single flush is the deferred, accept-time marshal
				// of everything done while editing — see _writeHiddenInputValue for why per-keystroke
				// marshals are suppressed. Flushing after setMode means the field is in view mode, so the
				// dispatch is not re-suppressed and onDataMarshalToForm delegates normally.
				this.commit(pInputHash, () =>
				{
					this.setMode(pInputHash, 'view', () =>
					{
						this._reflectEditorState(pRawHTMLID, 'view');
						// Any whole-form marshal while this was open (another editor's View, a picker change)
						// reset its hidden input to the saved value; put the typed content back first.
						this._reassertHiddenInputValue(this._instances ? this._instances[pInputHash] : null);
						this._flushMarshal(pRawHTMLID);
					});
				});
				return;
			}
			this.setMode(pInputHash, 'edit', () => this._reflectEditorState(pRawHTMLID, 'edit'));
		}
	}
	return HeadlightEditorInput;
}

module.exports = { buildEditorInputProvider };

},{"./PictProvider-InputType-Editor-CSS.js":49}],51:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Validates the email address as a possible real email address.
	 * @param {string} pInput - The phone number.
	 * @param {string} pValue - The markdown content.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 */
	validateEmailAddress(pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, pattern.test(pValue));
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRowIndex - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRowIndex, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.validateEmailAddress(pInput, pValue, pHTMLSelector, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRowIndex, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.validateEmailAddress(pInput, pValue, pHTMLSelector, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],52:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getTextInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularTextInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const inputMethod = pRowIndex != null ? 'getTabularTextInputID' : 'getTextInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputTextElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputTextElements || tmpInputTextElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLInputElement} */
		const tmpInputTextElement = tmpInputTextElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, pValue,
			{
				IdentityField: pInput.PictForm.IdentityField || null,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let tmpDisplayTemplate = '';
				if (tmpInputTextElement.tagName === 'DIV')
				{
					const tmpEntityTag = tmpEntity[pInput.PictForm.EntityTag];
					const tmpTaggedName = tmpDisplayName || (`Unnamed ${ pInput.PictForm.Entity } #` + tmpEntity[`ID${ pInput.PictForm.Entity }`]);
					// A configured-but-empty tag paints no badge, rendering exactly as the untagged case
					// below does. An EntityTag naming a field the record does not carry (or carries blank)
					// used to invent an "N/A" pill here that the edit selector never showed, so an author
					// only ever saw it in the PDF. A numeric 0 is a real tag and still badges.
					tmpDisplayTemplate = (tmpEntityTag === undefined || tmpEntityTag === null || tmpEntityTag === '') ?
						tmpTaggedName :
						this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
							tmpEntityTag,
							tmpTaggedName,
							false,
							tmpEntity.EntityTagLast,
						);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ pInput.PictForm.Entity } #` + tmpEntity[`ID${ pInput.PictForm.Entity }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputTextElement, tmpDisplayTemplate);
			}
			else
			{
				this.pict.ContentAssignment.assignContent(tmpInputTextElement, tmpDisplayName);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputTextElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],53:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-DISPLAY-MULTIPLE-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-DISPLAY-MULTIPLE-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-DISPLAY-MULTIPLE-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders the static `...TABULAR-DATA-...` div, not a `...DROPDOWN-...` select2 node.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			if (typeof pValue === 'string')
			{
				pValue = pValue.split(',').map((pVal) => pVal.trim());
			}
			if (Array.isArray(pValue) && pValue.length > 0)
			{
				const tmpDisplayValues = [];
				for (const tmpValue of pValue)
				{
					const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue,
					{
						IdentityField: pInput.PictForm.IdentityField || null,
						JoinEntity: pInput.PictForm.JoinEntity,
						JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
						EntityDisplayField: pInput.PictForm.EntityDisplayField,
						JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
						JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
						EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
					});
					// if we have an EntityTag, display that as a tag along with the Name
					if (pInput.PictForm.EntityTag)
					{
						let tmpDisplayTemplate = '';
						if (tmpInputSelectElement.tagName === 'DIV')
						{
							const tmpEntityTag = tmpEntity[pInput.PictForm.EntityTag];
							const tmpTaggedName = tmpDisplayName || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
							// A configured-but-empty tag paints no badge (per record, so a mixed list still
							// badges the records that have one), rendering as the untagged case below does.
							// This used to invent an "N/A" pill the edit selector never showed. 0 still badges.
							tmpDisplayTemplate = (tmpEntityTag === undefined || tmpEntityTag === null || tmpEntityTag === '') ?
								tmpTaggedName :
								this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
									tmpEntityTag,
									tmpTaggedName,
									true,
									tmpEntity.EntityTagLast,
								);
						}
						else
						{
							tmpDisplayTemplate = tmpValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
						}
						tmpDisplayValues.push(tmpDisplayTemplate);
					}
					else
					{
						tmpDisplayValues.push(tmpDisplayName);
					}
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayValues.join(', '));
				return;
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],54:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} inputID The input id.
	 */
	addLoadingSkeleton(inputID, rawID)
	{
		return;
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${rawID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(inputID)[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(inputID, 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} inputID The input id.
	 */
	removeLoadingSkeleton(inputID, rawID)
	{
		return;
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${rawID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(inputID, 'is-hidden');
	}

	/**
	 * Determines if a word starts with a leading vowel.
	 * @param {string} pWord The word to check.
	 * @returns {boolean} True if the word starts with a vowel, false otherwise.
	 */
	hasLeadingVowel(pWord)
	{
		return [ 'A', 'E', 'I', 'O', 'U' ].includes(pWord.charAt(0).toUpperCase());
	}

	// TODO: we need to handle Project Joins for all entity selectors in a more generic way - this is just a temporary solution for until we can implement that
	localHandleSearchFilters(pFilters, pInput, pRowIndex)
	{
		pFilters = pFilters || [];

		// Project scoping for project-resident entities. Off-switch:
		// PictForm.disableProjectFilteringForEntity.
		const tmpProjectEntityList = [ 'LineItem', 'BidItem' ];
		if (!pInput.PictForm.disableProjectFilteringForEntity &&
			tmpProjectEntityList.includes(pInput.PictForm.Entity))
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID && !pFilters.includes(`FBV~IDProject~EQ~${tmpProjectID}`))
			{
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
		}

		return pFilters;
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput, pRowIndex)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpConfigOptions = {
				Input: pInput,
				SearchFallbackPlaceholder: `Select ${ this.hasLeadingVowel(pInput.PictForm.Entity) ? 'an' : 'a' } ${ pInput.PictForm.Entity }...`,
				ApplySort: true,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				Disabled: pInput.PictForm.Disabled || false,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
				HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput, pRowIndex),
			};
			// Honor IdentityField so the bound value matches what the caller wants to persist
			// (e.g. storing Hash strings, not database IDs). Without this override the
			// select2 ajax pipeline always emits ID${Entity} as the option value.
			if (pInput.PictForm.IdentityField && pInput.PictForm.IdentityField !== `ID${pInput.PictForm.Entity}`)
			{
				const tmpIdentityField = pInput.PictForm.IdentityField;
				tmpConfigOptions.GetRecordID = (pEntity) => pEntity[tmpIdentityField];
			}
			// if an EntityTag is defined, use it to enhance the search and display
			if (pInput.PictForm.EntityTag)
			{
				tmpConfigOptions.GetRecordUserFacingID = (pEntity) => pEntity?.[pInput.PictForm.EntityTag] || 'N/A';
			}
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax(pInput.PictForm.Entity, tmpConfigOptions);
			// tabular vs. non-tabular context
			const methodNameByContext = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).data('select2'))
			{
				window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.addLoadingSkeleton(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue && pValue !== 'null')
		{
			// get the value of the selected Entity and set it as the selected Entity on the data object
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, pValue,
			{
				IdentityField: pInput.PictForm.IdentityField || null,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
				HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput),
			});
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex))[0];
			tmpOption.value = tmpEntity[`ID${ pInput.PictForm.Entity }`];
			tmpOption.text = tmpDisplayName;
			// if the EntityTag is defined and the entity has that property, use it for the leading tag in the selection display
			if (pInput.PictForm.EntityTag && tmpEntity.hasOwnProperty(pInput.PictForm.EntityTag))
			{
				if (pInput.PictForm.EntityTagLast)
				{
					tmpOption.text = `${tmpDisplayName || tmpEntity.Name || (`Unnamed ${pInput.PictForm.Entity} #` + tmpEntity[`ID${ pInput.PictForm.Entity }`])}|~|${tmpEntity[pInput.PictForm.EntityTag] || 'N/A'}`;
				}
				else
				{
					tmpOption.text = `${tmpEntity[pInput.PictForm.EntityTag] || 'N/A'}|~|${tmpDisplayName || tmpEntity.Name || (`Unnamed ${pInput.PictForm.Entity} #` + tmpEntity[`ID${ pInput.PictForm.Entity }`])}`;
				}
			}
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput, pRowIndex);
		this.initializeSelect2(pInput, pRowIndex);
	}

	/**
	 * When the picker is configured as a Sample selector, refresh the
	 * resolver's plan scope from the newly-picked sample. Resolver
	 * dedupes on unchanged project. No-op otherwise. Selectors with a
	 * non-default IdentityField (e.g. GUIDSample) pass that through.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.PictForm?.Entity === 'Sample')
		{
			const tmpIdentityField = pInput.PictForm.IdentityField || 'IDSample';
			this.pict.providers.SpecScopeResolver?.loadForSampleByIdentifier?.(pValue, tmpIdentityField);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Tabular variant of onDataChange. Same gate; same call shape.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm?.Entity === 'Sample')
		{
			const tmpIdentityField = pInput.PictForm.IdentityField || 'IDSample';
			this.pict.providers.SpecScopeResolver?.loadForSampleByIdentifier?.(pValue, tmpIdentityField);
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],55:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-SELECT-MULTIPLE-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-MULTIPLE-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-MULTIPLE-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} inputID The input id.
	 */
	addLoadingSkeleton(inputID, rawID)
	{
		return;
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${rawID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(inputID)[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(inputID, 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} inputID The input id.
	 */
	removeLoadingSkeleton(inputID, rawID)
	{
		return;
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${rawID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(inputID, 'is-hidden');
	}

	/**
	 * Determines if a word starts with a leading vowel.
	 * @param {string} pWord The word to check.
	 * @returns {boolean} True if the word starts with a vowel, false otherwise.
	 */
	hasLeadingVowel(pWord)
	{
		return [ 'A', 'E', 'I', 'O', 'U' ].includes(pWord.charAt(0).toUpperCase());
	}

	// TODO: we need to handle Project Joins for all entity selectors in a more generic way - this is just a temporary solution for until we can implement that
	localHandleSearchFilters(pFilters, pInput, pRowIndex)
	{
		pFilters = pFilters || [];

		// Project scoping for project-resident entities. Off-switch:
		// PictForm.disableProjectFilteringForEntity.
		const tmpProjectEntityList = [ 'LineItem', 'BidItem' ];
		if (!pInput.PictForm.disableProjectFilteringForEntity &&
			tmpProjectEntityList.includes(pInput.PictForm.Entity))
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID && !pFilters.includes(`FBV~IDProject~EQ~${tmpProjectID}`))
			{
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
		}

		return pFilters;
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput, pRowIndex)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpConfigOptions = {
				Input: pInput,
				Multiple: true,
				SearchFallbackPlaceholder: `Select ${ this.hasLeadingVowel(pInput.PictForm.Entity) ? 'an' : 'a' } ${ pInput.PictForm.Entity }...`,
				ApplySort: true,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				Disabled: pInput.PictForm.Disabled || false,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
				HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput, pRowIndex),
			};
			// Honor IdentityField so the bound value matches what the caller wants to persist
			// (e.g. storing Hash strings, not database IDs). Without this override the
			// select2 ajax pipeline always emits ID${Entity} as the option value.
			if (pInput.PictForm.IdentityField && pInput.PictForm.IdentityField !== `ID${pInput.PictForm.Entity}`)
			{
				const tmpIdentityField = pInput.PictForm.IdentityField;
				tmpConfigOptions.GetRecordID = (pEntity) => pEntity[tmpIdentityField];
			}
			// if an EntityTag is defined, use it to enhance the search and display
			if (pInput.PictForm.EntityTag)
			{
				tmpConfigOptions.GetRecordUserFacingID = (pEntity) => pEntity?.[pInput.PictForm.EntityTag] || 'N/A';
			}
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax(pInput.PictForm.Entity, tmpConfigOptions);
			// tabular vs. non-tabular context
			const methodNameByContext = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).data('select2'))
			{
				window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.addLoadingSkeleton(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpInputSelectElement = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex))?.[0];
		if (!tmpInputSelectElement)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const tmpValues = pValue && typeof(pValue) === 'string' ? pValue.split(',') : [];
			if (tmpInputSelectElement?.options?.length > 0)
			{
				// for each option that is not in the list, add it as a custom value
				for (let i = 0; i < tmpValues.length; i++)
				{
					let tmpValueSelected = false;
					for (let j = 0; j < tmpInputSelectElement.options.length; j++)
					{
						if (tmpInputSelectElement.options[j].value === tmpValues[i])
						{
							tmpInputSelectElement.options[j].selected = true;
							tmpValueSelected = true;
							break;
						}
					}
					if (!tmpValueSelected)
					{
						const tmpOption = document.createElement('option');
						tmpOption.value = tmpValues[i];
						const { Record: result, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, tmpValues[i],
						{
							Multiple: true,
							IdentityField: pInput.PictForm.IdentityField || null,
							JoinEntity: pInput.PictForm.JoinEntity,
							JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
							JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
							EntityDisplayField: pInput.PictForm.EntityDisplayField,
							JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
							EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
							HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput),
						});
						// if we want to show the EntityTag in the selection display
						if (pInput.PictForm.EntityTag)
						{
							tmpOption.text = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
								result[pInput.PictForm.EntityTag] || 'N/A',
								tmpDisplayName,
								true,
								result.EntityTagLast,
							);
						}
						else
						{
							tmpOption.text = tmpDisplayName;
						}
						tmpOption.selected = true;
						tmpInputSelectElement.appendChild(tmpOption);
					}
				}
			}
			else
			{
				for (let i = 0; i < tmpValues.length; i++)
				{
					const tmpOption = document.createElement('option');
					tmpOption.value = tmpValues[i];
					const { Record: result, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, tmpValues[i],
					{
						IdentityField: pInput.PictForm.IdentityField || null,
						JoinEntity: pInput.PictForm.JoinEntity,
						JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
						JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
						EntityDisplayField: pInput.PictForm.EntityDisplayField,
						JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
						EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
						HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput),
					});
					// if we want to show the EntityTag in the selection display
					if (pInput.PictForm.EntityTag)
					{
						tmpOption.text = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
							result[pInput.PictForm.EntityTag] || 'N/A',
							tmpDisplayName,
							true,
							result.EntityTagLast,
						);
					}
					else
					{
						tmpOption.text = tmpDisplayName;
					}
					tmpOption.selected = true;
					tmpInputSelectElement.appendChild(tmpOption);
				}
			}
		}
		this.removeLoadingSkeleton(pInput, pRowIndex);
		this.initializeSelect2(pInput, pRowIndex);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Special handling for filters inputs, do not remove.
		if (pView.Hash === 'PSRSFilterProxyView')
		{
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.InformaryDataAddress.replace('StringArrayValue', 'Values'), pValue ? pValue.split(',') : []);
		}
		// Plan scope from the picked sample (multi-select case).
		// The resolver is single-project; multi-sample means the project is
		// only well-defined when all picks share one. Best-effort: take the
		// first identifier and warn loudly when there's more than one so a
		// real misconfiguration surfaces in logs. Resolver dedupes when the
		// project hasn't changed.
		if (pInput.PictForm?.Entity === 'Sample' && pValue && this.pict.providers.SpecScopeResolver)
		{
			const tmpIdentifiers = typeof pValue === 'string' ? pValue.split(',').map((v) => v.trim()).filter((v) => v.length > 0) : [];
			if (tmpIdentifiers.length > 1)
			{
				this.pict.log.warn(`EntitySelectorMultiple [${pInput?.Hash}]: multi-sample selection with plan scope active — using the first sample (${tmpIdentifiers[0]}) as the scope source. Picker has ${tmpIdentifiers.length} samples selected.`);
			}
			if (tmpIdentifiers.length > 0)
			{
				const tmpIdentityField = pInput.PictForm.IdentityField || 'IDSample';
				this.pict.providers.SpecScopeResolver.loadForSampleByIdentifier?.(tmpIdentifiers[0], tmpIdentityField);
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],56:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class FileSelectorInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getControlContainerHTMLID(pInputHTMLID)
	{
		return `#CONTROL-FOR-${pInputHTMLID}`;
	}

	getInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	getFileInputHTMLID(pInputHTMLID)
	{
		return `#FILE-INPUT-FOR-${pInputHTMLID}`;
	}

	getLoadingInputHTMLID(pInputHTMLID)
	{
		return `#LOADING-FOR-${pInputHTMLID}`;
	}

	getTabularControlContainerHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-CONTROL-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DISPLAY-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularFileInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-FILE-INPUT-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularLoadingInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-LOADING-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Hides the loading indicator for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	hideLoadingIndicator(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpLoadingElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularLoadingInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getLoadingInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpLoadingElements) && tmpLoadingElements.length > 0)
		{
			const tmpLoadingElement = tmpLoadingElements[0];
			if (tmpLoadingElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.addClass(tmpLoadingElement, 'is-hidden');
			}
		}
	}

	/**
	 * Shows the loading indicator for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	showLoadingIndicator(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpLoadingElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularLoadingInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getLoadingInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpLoadingElements) && tmpLoadingElements.length > 0)
		{
			const tmpLoadingElement = tmpLoadingElements[0];
			if (tmpLoadingElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.removeClass(tmpLoadingElement, 'is-hidden');
			}
		}
	}

	/**
	 * Hides the entry container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	hideEntryContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpControlContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularControlContainerHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getControlContainerHTMLID(pInputHTMLID));
		if (Array.isArray(tmpControlContainerElements) && tmpControlContainerElements.length > 0)
		{
			const tmpControlContainerElement = tmpControlContainerElements[0];
			if (tmpControlContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.addClass(tmpControlContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * Shows the entry container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	showEntryContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpControlContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularControlContainerHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getControlContainerHTMLID(pInputHTMLID));
		if (Array.isArray(tmpControlContainerElements) && tmpControlContainerElements.length > 0)
		{
			const tmpControlContainerElement = tmpControlContainerElements[0];
			if (tmpControlContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.removeClass(tmpControlContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * Hides the display container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	hideDisplayContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpDisplayContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpDisplayContainerElements) && tmpDisplayContainerElements.length > 0)
		{
			const tmpDisplayContainerElement = tmpDisplayContainerElements[0];
			if (tmpDisplayContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.addClass(tmpDisplayContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * Shows the display container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	showDisplayContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpDisplayContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpDisplayContainerElements) && tmpDisplayContainerElements.length > 0)
		{
			const tmpDisplayContainerElement = tmpDisplayContainerElements[0];
			if (tmpDisplayContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.removeClass(tmpDisplayContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * This function updates the display container for a given input HTML ID with the provided value if the value corresponds to a valid observation.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pValue - the value to set
	 * @param {*} [pResult] - the observation result object (if already known)
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	async updateDisplayContainer(pInputHTMLID, pValue, pResult, isTabular = false, pRowIndex = null)
	{
		const tmpDisplayElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInputHTMLID));
		let tmpObservation = pResult;
		// if no value is passed, clear it out and we're done
		if (!pValue)
		{
			// find the display element and update it
			if (Array.isArray(tmpDisplayElements) && tmpDisplayElements.length > 0)
			{
				const tmpDisplayElement = tmpDisplayElements[0];
				if (tmpDisplayElement instanceof HTMLElement)
				{
					this.pict.ContentAssignment.assignContent(tmpDisplayElement, '');
					return;
				}
			}
		}
		// look up the observation to get the Name and Description if we don't already have record available
		if (!tmpObservation)
		{
			tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pValue);
		}
		// now build the template for display
		if (tmpObservation)
		{
			const tmpName = tmpObservation.Name || `Unnamed Observation #${pValue}`;
			const tmpFileType = this.pict.providers.ObservationProvider.getObservationFileType(tmpObservation);
			const tmpFileIcon = this.pict.providers.ObservationProvider.returnFileIconFromFileType(tmpFileType);
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			// set the input value to the ID and Name in a predefined format
			let tmpTemplate = '';
			// if we're in interactive mode, add links for rename and delete
			if (this.pict.AppData.Interactive && !this.pict.AppData?.DocumentData?.ReportData?.Locked)
			{
				tmpTemplate = /*HTML*/`
					<span class="tag has-background-text-90 mr-2">
						<span class="pr-1">
							<i class="fa fa-fw ${tmpFileIcon}"></i>
						</span>
						<span class="icon-text">${tmpFileType}</span>
					</span>
					<a class="has-text-text" href="javascript:void(0);" onclick="window._Pict.views.HeadlightPaneObservations.showObservationDetailView(event, ${pValue});">
						<strong class="mr-1">${tmpName}</strong>
					</a>
					<a class="ml-1 has-text-link" href="javascript:void(0);" onclick="window._Pict.providers.FileSelector.handleRenameFile('${pInputHTMLID}', ${pValue}, '${tmpName}', ${isTabular}, ${pRowIndex});" title="Rename File">
						<i class="fa fa-fw fa-edit"></i>
					</a>
					<a class="ml-1 has-text-danger" href="javascript:void(0);" onclick="window._Pict.providers.FileSelector.handleRemoveFile('${pInputHTMLID}', ${isTabular}, ${pRowIndex});" title="Remove File">
						<i class="fa fa-fw fa-times-circle"></i>
					</a>`;
			}
			else
			{
				tmpTemplate = /*HTML*/`
					<span class="tag has-background-text-90 mr-2">
						<span class="pr-1">
							<i class="fa fa-fw ${tmpFileIcon}"></i>
						</span>
						<span class="icon-text">${tmpFileType}</span>
					</span>
					<a href="${ this.pict.providers.UtilityProvider.buildLinksUrl() }/#/project/${ tmpProjectID }/journal/list/observation/${ pValue }" target="_blank" rel="noopener noreferrer">
						<strong class="mr-1">${tmpName}</strong>
					</a>`;
			}
			// find the display element and update it
			if (Array.isArray(tmpDisplayElements) && tmpDisplayElements.length > 0)
			{
				const tmpDisplayElement = tmpDisplayElements[0];
				if (tmpDisplayElement instanceof HTMLElement)
				{
					this.pict.ContentAssignment.assignContent(tmpDisplayElement, tmpTemplate);
				}
			}
		}
	}

	/**
	 * This function opens the observation search panel to allow the user to select an observation to associate with the input.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pViewHash - the hash of the current view
	 * @param {*} pInputHash - the hash of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	openObservationSearchPanel(pInputHTMLID, pViewHash, pInputHash, isTabular = false, pRowIndex = null)
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', async () =>
		{
			// start at the upload tab
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
			const tmpInput = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getInputHTMLID(pInputHTMLID));
			if (!Array.isArray(tmpInput) || tmpInput.length < 1)
			{
				console.warn(`Could not find input element for HTML ID: ${pInputHTMLID}`);
				return;
			}
			const tmpInputName = tmpInput[0] ? tmpInput[0].getAttribute('name') || 'Input Field' : 'Input Field';
			this.pict.views.HeadlightPaneObservations.setObservationPanelTarget(this.pict.views[pViewHash], tmpInput[0], tmpInputName, 'add-to-set');
			/** @type {(observationInfos: Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>) => Promise<void>} */
			this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = async (observationInfos) =>
			{
				// if we have at least one observation, use the first one
				if (Array.isArray(observationInfos) && observationInfos.length > 0)
				{
					const tmpObservationInfo = observationInfos[0];
					if (tmpObservationInfo && tmpObservationInfo.IDObservation)
					{
						// update the hidden input value to the ID of the observation
						this.updateHiddenInputValue(pInputHTMLID, tmpObservationInfo.IDObservation, isTabular, pRowIndex);
						// update the display container with the new observation info
						await this.updateDisplayContainer(pInputHTMLID, tmpObservationInfo.IDObservation, tmpObservationInfo.Observation, isTabular, pRowIndex);
						// show/hide the appropriate containers
						this.hideLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
						this.hideEntryContainer(pInputHTMLID, isTabular, pRowIndex);
						this.showDisplayContainer(pInputHTMLID, isTabular, pRowIndex);
						// close/clear the panel
						this.pict.views.HeadlightPaneObservations.setObservationPanelTarget();
						this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
					}
				}
			};
		});
	}

	/**
	 * This function updates the hidden input value for a given input HTML ID with the provided value.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pValue - the value to set
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	updateHiddenInputValue(pInputHTMLID, pValue, isTabular = false, pRowIndex = null)
	{
		// set the hidden input value to the ID of the observation
		const tmpHiddenElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpHiddenElements) && tmpHiddenElements.length > 0)
		{
			const tmpHiddenElement = tmpHiddenElements[0];
			if (tmpHiddenElement instanceof HTMLInputElement)
			{
				this.pict.ContentAssignment.setAttribute(tmpHiddenElement, 'value', pValue);
				// trigger change event on the hidden input to notify any listeners
				const event = new Event('change', { bubbles: true });
				tmpHiddenElement.dispatchEvent(event);
			}
		}
	}

	/**
	 * This function handles the renaming of a file associated with a given input HTML ID and observation ID.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pObservationID - the ID of the observation to rename
	 * @param {*} pCurrentName - the current name of the observation
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	handleRenameFile(pInputHTMLID, pObservationID, pCurrentName, isTabular = false, pRowIndex = null)
	{
		this.fable.HeadlightModal.spawnModal({
			title: 'Rename Observation',
			modalBodyTemplate: /*HTML*/`
				<div>
					<label class="label" for="FileInputType-Modal-Rename-Field">Observation Name:</label>
					<p class="control is-expanded">
						<input class="input" type="text" id="FileInputType-Modal-Rename-Field" value="${pCurrentName}" />
					</p>
				</div>
			`,
			confirmText: 'Done',
		}, async () =>
		{
			const newName = document.getElementById('FileInputType-Modal-Rename-Field');
			if (Array.isArray(newName) || !(newName instanceof HTMLInputElement) || !newName.value || newName.value.trim().length < 1 || newName.value.trim() === pCurrentName)
			{
				console.info('No change to name, or invalid name provided');
				return;
			}
			await this.pict.providers.ObservationProvider.updateObservation({
				IDObservation: pObservationID,
				Name: newName.value.trim(),
			});
			// update the display container with the new name
			await this.updateDisplayContainer(pInputHTMLID, pObservationID, newName.value.trim(), isTabular, pRowIndex);
		});
	}

	/**
	 * This function handles the removal of a file associated with a given input HTML ID.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	handleRemoveFile(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		// show a confirmation modal
		this.fable.HeadlightModal.spawnModal({
			title: 'Remove File?',
			message: 'Are you sure you want to remove the selected file? This will not delete the underlying observation, but it will disassociate it from this form input field.',
			cancelColor: 'is-danger is-soft',
			confirmColor: 'is-danger',
			confirmText: 'Remove File',
			confirmIcon: 'trash',
		},
		() =>
		{
			// NOTE: we do NOT delete the observation here, just disassociate it from the input field (it's still available in the document's observation list)
			// NOTE: we also do NOT auto-save the document here, as the user may want to make other changes first or change their mind by closing the form...
			const tmpHiddenElements = this.pict.ContentAssignment.getElement('#' + pInputHTMLID);
			if (Array.isArray(tmpHiddenElements) && tmpHiddenElements.length > 0)
			{
				const tmpHiddenElement = tmpHiddenElements[0];
				if (tmpHiddenElement instanceof HTMLInputElement)
				{
					tmpHiddenElement.value = '';
				}
			}
			this.hideDisplayContainer(pInputHTMLID, isTabular, pRowIndex);
			this.hideLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
			this.showEntryContainer(pInputHTMLID, isTabular, pRowIndex);
			this.updateHiddenInputValue(pInputHTMLID, '', isTabular, pRowIndex);
		});
	}

	/**
	 * This function handles the file selection event for a file input element.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 * @returns {Promise<boolean>} - true if successful
	 */
	async handleFileSelection(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpInputElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularFileInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getFileInputHTMLID(pInputHTMLID));
		if (!Array.isArray(tmpInputElements) || tmpInputElements.length < 1)
		{
			return false;
		}
		const tmpInputElement = tmpInputElements[0];
		if (!(tmpInputElement instanceof HTMLInputElement))
		{
			return false;
		}
		const files = tmpInputElement.files;
		// if we have a file, process it
		if (files && files.length > 0)
		{
			this.hideEntryContainer(pInputHTMLID, isTabular, pRowIndex);
			this.showLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
			const tmpFile = files[0];
			// formatted object to store in the list
			const tmpFileDetails = {
				Name: tmpFile.name, // can be updated by the user - becomes the 'Observation Name'
				FileName: tmpFile.name, // for display purposes only
				File: tmpFile, // the original file object in its entirety
				ObservationType: this.pict.providers.ObservationProvider.returnObservationTypeFromFileType(tmpFile.type), // the type of observation to create
				GUID: this.pict.getUUID(), // a unique identifier for the file
			};
			await new Promise((resolve) =>
			{
				this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(tmpFileDetails, this.AppData?.DocumentData?.ReportData?.IDProject,
				(observationResult) =>
				{
					const observationResultList = [];
					// add the result to the list
					observationResultList.push(observationResult);
					// update the file object with the result so we can use it for the preview replacement
					tmpFileDetails._ObservationResult = observationResult;
					// join to the document, if we have one
					this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument, async () =>
					{
						// add the new observation to the document list (these are 'included' observations)
						const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
						// add result to our document if we have one and it is not already in the observations list
						if (tmpObservations && Array.isArray(tmpObservations) && tmpObservations.findIndex((o) => o.IDObservation === observationResult.IDObservation) < 0)
						{
							tmpObservations.push(observationResult);
						}
						resolve(observationResult);
					});
				});
			});
			// set the hidden input value to the new observation ID
			this.updateHiddenInputValue(pInputHTMLID, tmpFileDetails._ObservationResult.IDObservation, isTabular, pRowIndex);
			// if it's a document, we should auto-save the document now too
			if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				this.pict.providers.DocumentProvider.handleSave(true);
			}
			// update the display container with the new observation details
			await this.updateDisplayContainer(pInputHTMLID, tmpFileDetails._ObservationResult.IDObservation, tmpFileDetails._ObservationResult, isTabular, pRowIndex);
			// show/hide the appropriate containers
			this.hideLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
			this.hideEntryContainer(pInputHTMLID, isTabular, pRowIndex);
			this.showDisplayContainer(pInputHTMLID, isTabular, pRowIndex);
			// clear out the file input value so we can re-use it if needed
			tmpInputElement.value = '';
			return true;
		}
		// If no file is selected, don't change anything
		return true;
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be set.
	 * @param {boolean} [isTabular=false] - Whether the input is part of a tabular input set.
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 * @returns {Promise<void>}
	 */
	async handleInputValue(pInput, pValue, isTabular = false, pRowIndex)
	{
		const tmpInputElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getInputHTMLID(pInput.Macro.RawHTMLID));
		if (Array.isArray(tmpInputElements) && tmpInputElements.length > 0)
		{
			const tmpInputElement = tmpInputElements[0];
			if (tmpInputElement instanceof HTMLInputElement)
			{
				if (pValue && Number(pValue) !== 0 && !isNaN(Number(pValue)))
				{
					// set the input value to the ID
					this.pict.ContentAssignment.assignContent(tmpInputElement, pValue);
					// immediately hide the upload controls to prevent flicker during async load
					this.hideEntryContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
					this.showLoadingIndicator(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
					// update the display container with the new value
					await this.updateDisplayContainer(pInput.Macro.RawHTMLID, pValue, null, isTabular, pRowIndex);
					this.hideLoadingIndicator(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
					this.showDisplayContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
				}
			}
		}
		else
		{
			this.hideDisplayContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
			this.hideLoadingIndicator(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
			this.showEntryContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputNumericValue = this.pict.ContentAssignment.readContent(pInput.Macro.RawHTMLID);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputNumericValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputNumericValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = FileSelectorInputHandler;

},{"pict-section-form":497}],57:[function(require,module,exports){
/**
 * Component-owned styling for the Geolocation input types.
 *
 * Everything here is phone-layout work. The desktop presentations are plain Bulma (columns, level,
 * addons) and need no rules of their own; below the tablet breakpoint the full picker's action row
 * and the compact presentation's edit modal both need a different shape than Bulma's defaults give.
 */
module.exports = /*css*/`
/* --- Full picker: phone action row ---------------------------------------------------------
   Bulma's .level.is-mobile keeps the readout and the action buttons on one line. On a phone that
   squeezes the coordinates until they wrap underneath the pin, leaving the marker stranded above
   and centered. Give the readout its own full-width row (pin left, coordinates beside it) and drop
   the buttons to a second row, split evenly the way a mobile action row normally reads. */
@media screen and (max-width: 768px)
{
	.geolocation-input .geo-action-level
	{
		display: block;
	}

	.geolocation-input .geo-action-level .level-left
	{
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: flex-start;
		min-width: 0;
		margin-bottom: 0.5rem;
	}

	.geolocation-input .geo-action-level .level-right
	{
		display: block;
		margin-left: 0;
	}

	/* Deliberately unscoped: geo-action-buttons is our own class, and the same even split is wanted
	   in both places it appears — the inline control's action row and the Edit modal's — for the
	   larger tap targets a phone needs. */
	.geo-action-buttons
	{
		display: flex;
		flex-wrap: nowrap;
		gap: 0.5rem;
	}

	/* Bulma's .buttons spaces children with margins; the flex gap owns spacing here so both
	   buttons can share the row exactly evenly. */
	.geo-action-buttons .button
	{
		flex: 1 1 0;
		min-width: 0;
		margin: 0;
	}
}

/* --- Compact presentation: full-screen edit modal on a phone -------------------------------
   The shared dialog centers itself with a translate and caps at 90vw/90vh, which on a phone leaves
   a cramped card with slivers of page around it — and the map inside wants every pixel. The class
   is added to the dialog element in onOpen, so this only ever reshapes the location editor.
   The .pict-modal-visible selector is included because the visible state re-declares transform. */
@media screen and (max-width: 768px)
{
	.pict-modal-dialog.geolocation-edit-modal,
	.pict-modal-dialog.geolocation-edit-modal.pict-modal-visible
	{
		top: 0;
		left: 0;
		width: 100vw;
		max-width: 100vw;
		height: 100vh;
		height: 100dvh;
		max-height: 100dvh;
		transform: none;
		border: none;
		border-radius: 0;
	}

	.pict-modal-dialog.geolocation-edit-modal .pict-modal-dialog-header
	{
		border-radius: 0;
	}
}
`;

},{}],58:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libGeolocationCSS = require('./PictProvider-InputType-GeolocationSelector-CSS.js');

// Coordinate display precision (decimal degrees) for the combined read-only readout.
const GEO_DISPLAY_PRECISION = 6;
// Fixed key for the transient "edit location" modal instance (only one modal is open at a time).
const GEO_MODAL_KEY = 'GEO-MODAL';
// Wide "no fix yet" default view (continental US) used when opening a map with no value.
const GEO_DEFAULT_CENTER = { Latitude: 39.5, Longitude: -98.35 };

/*
	Geolocation input type (both `GeolocationSelector` and `GeolocationSelectorWithMap`).

	Single control, both single-record and tabular. The map variant adds a full-width Leaflet map with a
	draggable marker + click-to-place + address search; the no-map variant is the same control without the
	map. The value persists as a {Latitude, Longitude} object via two informary-bound number inputs whose
	data-i-datum is suffixed `.Latitude`/`.Longitude`.

	Maps are LAZY-mounted via an IntersectionObserver (mounted only once their container is actually
	visible, then invalidateSize()). This resolves the old "map mis-centers when initialized behind a form
	tab" bug the previous implementation punted on, and is the same trick that makes the modal-hosted map
	work.

	All transient state (address-search results, per-map data) is keyed by the field rawHTMLID, so a form
	may hold many geolocation fields, N tabular rows, and the edit modal at once without collisions.
*/
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// Address-search results, keyed by rawHTMLID (fields + the GEO_MODAL_KEY modal instance).
		this._addressResultsByID = {};
		// Guards onDataChange from re-syncing the map when the change originated from a map gesture or a
		// programmatic commit (only user-typed coordinate edits should move the marker).
		this._suppressMapSync = {};
		// Pending lazy-mount IntersectionObservers, keyed by rawHTMLID, so we can disconnect on teardown.
		this._mapObservers = {};
		// Latest working value for the open modal (read on Save, robust to modal-DOM teardown timing).
		this._modalValue = { Latitude: '', Longitude: '' };
		// Guards the one-time CSS registration.
		this._cssInjected = false;
		// Row identity for full-size tabular/record-set cells, keyed by `<rawHTMLID>-<rowIndex>`. The
		// address search is written against a single instance id, so this is how a result picked in a
		// row finds its way back to the right row commit.
		this._rowContexts = {};
	}

	/** The instance id a tabular/record-set row shares with the address-search DOM helpers. */
	getRowKey(pInputHTMLID, pRowIndex)
	{
		return `${pInputHTMLID}-${pRowIndex}`;
	}

	/** Register the component's phone-layout rules once per app. */
	_injectCSS()
	{
		if (this._cssInjected || !this.pict || !this.pict.CSSMap || (typeof this.pict.CSSMap.addCSS !== 'function'))
		{
			return;
		}
		this._cssInjected = true;
		this.pict.CSSMap.addCSS('Headlight-GeolocationSelector', libGeolocationCSS, 500);
		if (typeof this.pict.CSSMap.injectCSS === 'function')
		{
			this.pict.CSSMap.injectCSS();
		}
	}

	// --- HTML id helpers -----------------------------------------------------------------------------

	getMapContainerHTMLID(pInputHTMLID)
	{
		return `#MAP-CONTAINER-FOR-${pInputHTMLID}`;
	}

	/** Strip the map container/element prefix back to the owning rawHTMLID (or modal key). */
	getMapIDFromContainerID(pContainerID)
	{
		if (!pContainerID)
		{
			return '';
		}
		if (pContainerID.indexOf('MAP-CONTAINER-FOR-') > -1)
		{
			return pContainerID.replace('MAP-CONTAINER-FOR-', '');
		}
		if (pContainerID.indexOf('MAP-FOR-') > -1)
		{
			return pContainerID.replace('MAP-FOR-', '');
		}
		return pContainerID;
	}

	getLatitudeInputHTMLID(pInputHTMLID)
	{
		return `#LATITUDE-FOR-${pInputHTMLID}`;
	}

	getLongitudeInputHTMLID(pInputHTMLID)
	{
		return `#LONGITUDE-FOR-${pInputHTMLID}`;
	}

	getCombinedDisplayID(pInputHTMLID)
	{
		return `#GEO-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getAddressResultsID(pInputHTMLID)
	{
		return `GEO-ADDRESS-RESULTS-${pInputHTMLID}`;
	}

	getAddressInputID(pInputHTMLID)
	{
		return `GEO-ADDRESS-INPUT-${pInputHTMLID}`;
	}

	getTabularLatitudeInputID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-LAT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularLongitudeInputID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-LONG-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDisplayID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-DISPLAY-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * The full-size row presentation's visible coordinate editors. These are NOT informary-bound —
	 * the hidden Begin-partial inputs remain the only binding — so they are kept in sync from the
	 * value and commit back through the row methods.
	 */
	getRowEditorLatitudeID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-RS-LAT-${pInputHTMLID}-${pRowIndex}`;
	}

	getRowEditorLongitudeID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-RS-LONG-${pInputHTMLID}-${pRowIndex}`;
	}

	// --- DOM value get/set (loosely typed — these are always <input> elements found by id/selector) ---

	/**
	 * @param {any} pElement
	 * @return {string}
	 */
	_domValue(pElement)
	{
		return (pElement && pElement.value != null) ? String(pElement.value) : '';
	}

	/**
	 * @param {any} pElement
	 * @param {any} pValue
	 */
	_setDomValue(pElement, pValue)
	{
		if (pElement)
		{
			pElement.value = (pValue === '' || pValue == null) ? '' : String(pValue);
		}
	}

	// --- Value coercion / formatting -----------------------------------------------------------------

	/**
	 * Normalize any stored representation to a { Latitude, Longitude } pair. Accepts the canonical object,
	 * a legacy JSON string ({"Latitude":..,"Longitude":..} — the old WithMap serialization), or empty.
	 * @param {any} pValue
	 * @return {{ Latitude: (string|number), Longitude: (string|number) }}
	 */
	_coerceLatLong(pValue)
	{
		if (pValue == null || pValue === '' || pValue === 'null')
		{
			return { Latitude: '', Longitude: '' };
		}
		if (typeof pValue === 'object')
		{
			return { Latitude: pValue.Latitude != null ? pValue.Latitude : '', Longitude: pValue.Longitude != null ? pValue.Longitude : '' };
		}
		if (typeof pValue === 'string')
		{
			try
			{
				const tmpParsed = JSON.parse(pValue);
				if (tmpParsed && typeof tmpParsed === 'object')
				{
					return { Latitude: tmpParsed.Latitude != null ? tmpParsed.Latitude : '', Longitude: tmpParsed.Longitude != null ? tmpParsed.Longitude : '' };
				}
			}
			catch (pError)
			{/* not JSON — fall through to empty */}
		}
		return { Latitude: '', Longitude: '' };
	}

	/** True when both coordinates are present, numeric, and within valid lat/long ranges. */
	_inRange(pLatitude, pLongitude)
	{
		if (pLatitude === '' || pLongitude === '' || pLatitude == null || pLongitude == null)
		{
			return false;
		}
		const tmpLat = Number(pLatitude);
		const tmpLng = Number(pLongitude);
		return Number.isFinite(tmpLat) && Number.isFinite(tmpLng) && (tmpLat >= -90) && (tmpLat <= 90) && (tmpLng >= -180) && (tmpLng <= 180);
	}

	/** Format the combined readout string, or the empty-state placeholder. */
	formatLocationDisplay(pLatitude, pLongitude)
	{
		if (!this._inRange(pLatitude, pLongitude))
		{
			return 'No location set';
		}
		return `${Number(pLatitude).toFixed(GEO_DISPLAY_PRECISION)}, ${Number(pLongitude).toFixed(GEO_DISPLAY_PRECISION)}`;
	}

	/** Repaint the single-record combined readout from the current lat/long inputs. No-op if absent. */
	refreshCombinedDisplay(pInputHTMLID)
	{
		if (!document.querySelector(this.getCombinedDisplayID(pInputHTMLID)))
		{
			return;
		}
		const tmpLat = $(this.getLatitudeInputHTMLID(pInputHTMLID)).val();
		const tmpLng = $(this.getLongitudeInputHTMLID(pInputHTMLID)).val();
		this.pict.ContentAssignment.assignContent(this.getCombinedDisplayID(pInputHTMLID), this.formatLocationDisplay(tmpLat, tmpLng));
	}

	/**
	 * Print/PDF only: populate the static map <img> from the value via the Google Static Maps helper. A
	 * single image (which the PDF renderer waits for) fills its container reliably, unlike a live Leaflet
	 * map whose raster tiles get sized to the narrower init width and leave the frame's right edge blank.
	 * No-op when the img is absent (Edit/Read themes render a live map instead) or the value is empty.
	 * @param {string} pInputHTMLID
	 * @param {{ Latitude: (string|number), Longitude: (string|number) }} pSeed
	 */
	_refreshStaticMapImage(pInputHTMLID, pSeed)
	{
		this._paintStaticMapImg(document.getElementById(`MAP-IMG-FOR-${pInputHTMLID}`), pSeed);
	}

	/** Build the Google Static Maps URL for a value (framed at neighborhood zoom), or '' when empty. */
	_staticMapURL(pSeed)
	{
		const tmpUtility = this.pict.providers.UtilityProvider;
		if (!pSeed || !this._inRange(pSeed.Latitude, pSeed.Longitude) || !tmpUtility || (typeof tmpUtility.getGoogleMapURLFromEntityRecord !== 'function'))
		{
			return '';
		}
		let tmpURL = tmpUtility.getGoogleMapURLFromEntityRecord(
			{ Latitude: pSeed.Latitude, Longitude: pSeed.Longitude },
			{ size: '640x360', scale: 2, markerColor: 'blue' });
		// The helper emits only a marker (no center/zoom → Google auto-fits a single point oddly); frame it
		// on the point at a neighborhood zoom to match the live map.
		if (tmpURL)
		{
			tmpURL += `&zoom=14&center=${encodeURIComponent(`${pSeed.Latitude},${pSeed.Longitude}`)}`;
		}
		return tmpURL;
	}

	/** Paint a static-map <img>: set src + show, or clear + hide when there's no URL. No-op if absent. */
	_paintStaticMapImg(pImgEl, pSeed)
	{
		if (!pImgEl)
		{
			return;
		}
		const tmpURL = this._staticMapURL(pSeed);
		if (tmpURL)
		{
			pImgEl.setAttribute('src', tmpURL);
			pImgEl.style.display = 'block';
		}
		else
		{
			pImgEl.removeAttribute('src');
			pImgEl.style.display = 'none';
		}
	}

	/** Print/PDF only: static map image for one record-set record (the Print theme's map host is an <img>). */
	_refreshRecordSetRowStaticImage(pInput, pRowIndex, pSeed)
	{
		this._paintStaticMapImg(document.getElementById(`GEO-RS-MAPIMG-FOR-${pInput.Macro.RawHTMLID}-${pRowIndex}`), pSeed);
	}

	_toast(pMessage, pType)
	{
		if (this.pict.views.HeadLightPanels && (typeof this.pict.views.HeadLightPanels.toast === 'function'))
		{
			this.pict.views.HeadLightPanels.toast({ message: pMessage, type: pType || 'is-info' });
		}
	}

	// --- Single-record lifecycle ---------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._injectCSS();
		const tmpHideMap = pInput.PictForm.InputType !== 'GeolocationSelectorWithMap';
		pView.options.hideLeafletMap = tmpHideMap;

		const rawHTMLID = pInput.Macro.RawHTMLID;
		// Bind the two number inputs to the .Latitude/.Longitude sub-addresses so the datum marshals as a
		// { Latitude, Longitude } object (the canonical shape for both variants).
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length && tmpLat.data('iDatum'))
		{
			tmpLat.attr('data-i-datum', `${tmpLat.data('iDatum')}.Latitude`);
		}
		if (tmpLong.length && tmpLong.data('iDatum'))
		{
			tmpLong.attr('data-i-datum', `${tmpLong.data('iDatum')}.Longitude`);
		}

		// Seed inputs from the incoming value (covers legacy JSON-string persistence, where informary can't
		// reach the .Latitude/.Longitude sub-addresses of a string base value).
		const tmpSeed = this._coerceLatLong(pValue);
		if (tmpSeed.Latitude !== '' && !tmpLat.val())
		{
			tmpLat.val(tmpSeed.Latitude);
		}
		if (tmpSeed.Longitude !== '' && !tmpLong.val())
		{
			tmpLong.val(tmpSeed.Longitude);
		}
		this.refreshCombinedDisplay(rawHTMLID);

		if (!tmpHideMap)
		{
			// Print theme renders a static map image; Edit/Read mount the live Leaflet map. Each no-ops when
			// its target element is absent, so exactly one runs per theme.
			this._refreshStaticMapImage(rawHTMLID, tmpSeed);
			this._observeAndMountMap(rawHTMLID, pInput);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshal a value into the single-record control. Coerces object/legacy-string, repaints the readout,
	 * and (map variant) moves the marker. Populating the inputs here also migrates legacy string data to the
	 * object shape on next save.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const tmpSeed = this._coerceLatLong(pValue);
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			tmpLat.val(tmpSeed.Latitude === '' ? '' : tmpSeed.Latitude);
		}
		if (tmpLong.length)
		{
			tmpLong.val(tmpSeed.Longitude === '' ? '' : tmpSeed.Longitude);
		}
		this.refreshCombinedDisplay(rawHTMLID);
		this._refreshStaticMapImage(rawHTMLID, tmpSeed);
		// Marshal runs after every tabular row add/delete (marshalFormSections), so this is where a map
		// whose DOM was just regenerated gets re-mounted. No-op when the map is healthy or absent.
		this._observeAndMountMap(rawHTMLID, pInput);
		if (this._inRange(tmpSeed.Latitude, tmpSeed.Longitude))
		{
			this.moveMarkerTo(rawHTMLID, Number(tmpSeed.Latitude), Number(tmpSeed.Longitude));
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const rawHTMLID = pInput.Macro.RawHTMLID;
		this.refreshCombinedDisplay(rawHTMLID);
		// A user edit of the lat/long fields (not a map gesture / programmatic commit): follow it on the map.
		if (!this._suppressMapSync[rawHTMLID])
		{
			const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID)).val();
			const tmpLng = $(this.getLongitudeInputHTMLID(rawHTMLID)).val();
			if (this._inRange(tmpLat, tmpLng))
			{
				this.moveMarkerTo(rawHTMLID, Number(tmpLat), Number(tmpLng));
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	// --- Map: lazy mount, marker, click/drag/programmatic move ---------------------------------------

	/**
	 * Defer the Leaflet mount until the map container is actually visible (fixes the behind-a-tab
	 * mis-centering), then invalidateSize(). Falls back to an immediate mount where IntersectionObserver
	 * is unavailable.
	 */
	_observeAndMountMap(rawHTMLID, pInput)
	{
		const tmpContainer = (typeof document !== 'undefined') ? document.getElementById(`MAP-CONTAINER-FOR-${rawHTMLID}`) : null;
		if (!tmpContainer)
		{
			return;
		}
		// Keep an existing map ONLY if its container is still in the live DOM inside the current container.
		// A re-render (e.g. a tabular row add/delete calls pView.render(), which also regenerates this
		// field's DOM) swaps in a fresh empty container and detaches the old map — so a plain "map already
		// exists" guard would leave the map gone for good. Detect the stale map, tear it down, and re-mount.
		const tmpExisting = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpExisting && tmpExisting.map)
		{
			const tmpMapEl = (typeof tmpExisting.map.getContainer === 'function') ? tmpExisting.map.getContainer() : null;
			if (tmpMapEl && document.body.contains(tmpMapEl) && tmpContainer.contains(tmpMapEl))
			{
				return;
			}
			try
			{
 tmpExisting.map.remove();
			}
			catch (pError)
			{/* already detached */}
			delete this.pict.AppData.LeafletMapsData[rawHTMLID];
		}
		// A prior observer may still be watching the old (detached) container — retire it before re-observing.
		if (this._mapObservers[rawHTMLID])
		{
			this._mapObservers[rawHTMLID].disconnect();
			delete this._mapObservers[rawHTMLID];
		}
		const tmpMount = () =>
		{
			if (this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID] && this.pict.AppData.LeafletMapsData[rawHTMLID].map)
			{
				return;
			}
			this.initializeLeafletMap(rawHTMLID, pInput);
			const tmpMapData = this.pict.AppData.LeafletMapsData[rawHTMLID];
			if (tmpMapData && tmpMapData.map)
			{
				setTimeout(() =>
				{
					try
					{
 tmpMapData.map.invalidateSize();
					}
					catch (pError)
					{/* container detached */}
				}, 60);
			}
		};
		if (typeof IntersectionObserver === 'undefined')
		{
			tmpMount();
			return;
		}
		const tmpObserver = new IntersectionObserver((pEntries) =>
		{
			for (let i = 0; i < pEntries.length; i++)
			{
				if (pEntries[i].isIntersecting)
				{
					tmpObserver.disconnect();
					delete this._mapObservers[rawHTMLID];
					tmpMount();
					return;
				}
			}
		});
		this._mapObservers[rawHTMLID] = tmpObserver;
		tmpObserver.observe(tmpContainer);

		// Fallback for environments where the observer callback may not fire in time (e.g. a headless PDF
		// render that never scrolls): if the container is already visible shortly after init and still
		// unmounted, mount eagerly. A container hidden behind a tab has offsetParent === null, so it stays
		// deferred to the observer.
		setTimeout(() =>
		{
			if (this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID] && this.pict.AppData.LeafletMapsData[rawHTMLID].map)
			{
				return;
			}
			if (tmpContainer.offsetParent !== null)
			{
				if (this._mapObservers[rawHTMLID])
				{
					this._mapObservers[rawHTMLID].disconnect();
					delete this._mapObservers[rawHTMLID];
				}
				tmpMount();
			}
		}, 250);
	}

	/**
	 * Render the shared Leaflet view into this field's map container, seed the marker from the current
	 * lat/long, and wire click-to-place (unless the inputs are locked/read-only).
	 */
	initializeLeafletMap(rawHTMLID, pInput)
	{
		this.pict.views.GeolocationSelector.rawHTMLID = rawHTMLID;
		this.pict.views.GeolocationSelector.render('GeolocationSelector', this.getMapContainerHTMLID(rawHTMLID), pInput);

		const tmpMapData = this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (!tmpMapData || !tmpMapData.map)
		{
			return;
		}
		const tmpMap = tmpMapData.map;

		// Seed from the (now marshaled) input values.
		const tmpLatVal = $(this.getLatitudeInputHTMLID(rawHTMLID)).val();
		const tmpLngVal = $(this.getLongitudeInputHTMLID(rawHTMLID)).val();
		if (this._inRange(tmpLatVal, tmpLngVal))
		{
			const tmpLat = Number(tmpLatVal);
			const tmpLng = Number(tmpLngVal);
			tmpMapData.marker = this.setLeafletMarker({ lat: tmpLat, lng: tmpLng }, tmpMap, null, rawHTMLID);
			tmpMapData.location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
			tmpMap.setView([ tmpLat, tmpLng ], Math.max(tmpMap.getZoom() || 13, 13));
		}

		// Read theme renders the inputs readonly/aria-readonly; keep the map non-interactive to match.
		const tmpLatInput = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLocked = tmpLatInput.is(':disabled') || tmpLatInput.is('[readonly]') || tmpLatInput.attr('aria-readonly') === 'true';
		if (tmpLocked)
		{
			this.disableMap(tmpMap, tmpMapData.destinationAddress);
		}
		else
		{
			tmpMap.on('click', this.onMapSelectionMade, this);
		}
	}

	disableMap(pMap, pDestinationAddress)
	{
		pMap.dragging.disable();
		pMap.touchZoom.disable();
		pMap.doubleClickZoom.disable();
		pMap.scrollWheelZoom.disable();
		pMap.boxZoom.disable();
		pMap.keyboard.disable();
		// @ts-ignore
		if (pMap.tap) pMap.tap.disable();
		const tmpEl = document.getElementById(pDestinationAddress);
		if (tmpEl)
		{
			tmpEl.style.cursor = 'default';
		}
	}

	/**
	 * Create (draggable) or move a marker. Does NOT recenter the map — callers control the view so a drag
	 * doesn't yank the map out from under the user.
	 */
	setLeafletMarker(pLatLng, pMap, pMarker, pRawHTMLID)
	{
		if (pLatLng.lat == null || pLatLng.lng == null)
		{
			return pMarker;
		}
		const libLeaflet = window.L;
		let tmpMarker = pMarker;
		if (!tmpMarker)
		{
			tmpMarker = libLeaflet.marker(pLatLng, { draggable: true });
			tmpMarker.on('dragend', (pEvent) =>
			{
				const tmpLatLng = pEvent.target.getLatLng();
				// Marker is already where the user dropped it — commit the value without recentering.
				this._commitLatLong(pRawHTMLID, tmpLatLng.lat, tmpLatLng.lng);
			});
		}
		tmpMarker.setLatLng(pLatLng).addTo(pMap);
		return tmpMarker;
	}

	/** Map click handler: place the marker at the clicked point and commit (no recenter). */
	onMapSelectionMade(pEvent)
	{
		const tmpContainerID = (pEvent && pEvent.target && (typeof pEvent.target.getContainer === 'function')) ? pEvent.target.getContainer().id : '';
		const rawHTMLID = this.getMapIDFromContainerID(tmpContainerID);
		if (!rawHTMLID)
		{
			return;
		}
		const tmpMapData = this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpMapData && tmpMapData.map)
		{
			tmpMapData.marker = this.setLeafletMarker({ lat: pEvent.latlng.lat, lng: pEvent.latlng.lng }, tmpMapData.map, tmpMapData.marker, rawHTMLID);
		}
		this._commitLatLong(rawHTMLID, pEvent.latlng.lat, pEvent.latlng.lng);
	}

	/**
	 * Move the marker + recenter to a programmatically supplied point (typed coordinates, address pick, or
	 * GPS). Pure map operation — does not write the inputs (the caller commits separately), which avoids a
	 * commit/change loop.
	 */
	moveMarkerTo(rawHTMLID, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (!tmpMapData || !tmpMapData.map)
		{
			return;
		}
		const tmpLat = Number(pLatitude);
		const tmpLng = Number(pLongitude);
		if (!Number.isFinite(tmpLat) || !Number.isFinite(tmpLng))
		{
			return;
		}
		tmpMapData.marker = this.setLeafletMarker({ lat: tmpLat, lng: tmpLng }, tmpMapData.map, tmpMapData.marker, rawHTMLID);
		tmpMapData.location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
		tmpMapData.map.setView([ tmpLat, tmpLng ], Math.max(tmpMapData.map.getZoom() || 13, 13));
	}

	/**
	 * Write both lat/long inputs, repaint the readout, and marshal (single change on the latitude input;
	 * onDataChange handles the pair). The suppress flag prevents onDataChange from re-syncing the map.
	 */
	_commitLatLong(rawHTMLID, pLatitude, pLongitude)
	{
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			tmpLat.val(String(pLatitude));
		}
		if (tmpLong.length)
		{
			tmpLong.val(String(pLongitude));
		}
		this.refreshCombinedDisplay(rawHTMLID);
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpMapData)
		{
			tmpMapData.location = { Latitude: String(pLatitude), Longitude: String(pLongitude) };
		}
		if (rawHTMLID === GEO_MODAL_KEY)
		{
			this._modalValue = { Latitude: String(pLatitude), Longitude: String(pLongitude) };
		}
		this._suppressMapSync[rawHTMLID] = true;
		if (tmpLat.length)
		{
			tmpLat.trigger('change');
		}
		this._suppressMapSync[rawHTMLID] = false;
	}

	// --- Use My Location (device GPS) ----------------------------------------------------------------

	onUseMyLocation(rawHTMLID)
	{
		if (!navigator.geolocation)
		{
			this._toast('Could not fetch user location', 'is-error');
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pPosition) => this.setLocation(rawHTMLID, pPosition),
			() =>
			{
				this.pict.log.info('GeolocationSelector', 'onUseMyLocation', 'getCurrentPosition failed');
				this._toast('Could not fetch user location', 'is-error');
			});
	}

	setLocation(rawHTMLID, pPosition)
	{
		const tmpLat = pPosition.coords.latitude;
		const tmpLng = pPosition.coords.longitude;
		this._commitLatLong(rawHTMLID, tmpLat, tmpLng);
		this.moveMarkerTo(rawHTMLID, tmpLat, tmpLng);
	}

	// --- Address geocoding (Nominatim / OpenStreetMap) -----------------------------------------------

	/**
	 * Geocode the field's address box via public Nominatim — same provider as the tiles, no API key. One
	 * request per explicit Search (no as-you-type), keeping within OSM fair-use. Results render as clickable
	 * rows; picking one (chooseAddressResult) drops the pin.
	 * @param {string} rawHTMLID
	 */
	async searchAddress(rawHTMLID)
	{
		const tmpInputEl = document.getElementById(this.getAddressInputID(rawHTMLID));
		const tmpQuery = this._domValue(tmpInputEl).trim();
		if (!tmpQuery)
		{
			return;
		}
		this._renderAddressStatus(rawHTMLID, 'Searching…', false);
		try
		{
			const tmpURL = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=5&q=${encodeURIComponent(tmpQuery)}`;
			const tmpResponse = await fetch(tmpURL, { headers: { 'Accept': 'application/json' } });
			if (!tmpResponse.ok)
			{
				throw new Error(`the geocoder returned ${tmpResponse.status}`);
			}
			const tmpRows = await tmpResponse.json();
			this._addressResultsByID[rawHTMLID] = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pRow) => ({ DisplayName: String(pRow.display_name || 'result'), Latitude: Number(pRow.lat), Longitude: Number(pRow.lon) }))
				.filter((pRow) => Number.isFinite(pRow.Latitude) && Number.isFinite(pRow.Longitude))
				.slice(0, 5);
			this._renderAddressResults(rawHTMLID);
		}
		catch (pError)
		{
			this._addressResultsByID[rawHTMLID] = [];
			this._renderAddressStatus(rawHTMLID, `Address search failed: ${pError.message || pError}`, true);
		}
	}

	_clearAddressResultsDOM(rawHTMLID)
	{
		const tmpEl = document.getElementById(this.getAddressResultsID(rawHTMLID));
		if (tmpEl)
		{
			while (tmpEl.firstChild)
			{
				tmpEl.removeChild(tmpEl.firstChild);
			}
		}
		return tmpEl;
	}

	/** Render clickable result rows (createElement/append — no HTML-string injection). */
	_renderAddressResults(rawHTMLID)
	{
		const tmpEl = this._clearAddressResultsDOM(rawHTMLID);
		if (!tmpEl)
		{
			return;
		}
		const tmpResults = this._addressResultsByID[rawHTMLID] || [];
		if (tmpResults.length === 0)
		{
			this._renderAddressStatus(rawHTMLID, 'No matches found for that address.', false);
			return;
		}
		for (let i = 0; i < tmpResults.length; i++)
		{
			const tmpRow = document.createElement('button');
			tmpRow.type = 'button';
			tmpRow.className = 'button is-small is-fullwidth has-text-left mb-1';
			tmpRow.textContent = tmpResults[i].DisplayName;
			// eslint-disable-next-line no-loop-func
			tmpRow.addEventListener('click', ((pIndex) => () => this.chooseAddressResult(rawHTMLID, pIndex))(i));
			tmpEl.appendChild(tmpRow);
		}
	}

	_renderAddressStatus(rawHTMLID, pText, pIsError)
	{
		const tmpEl = this._clearAddressResultsDOM(rawHTMLID);
		if (!tmpEl)
		{
			return;
		}
		const tmpStatus = document.createElement('p');
		tmpStatus.className = pIsError ? 'help is-danger' : 'help';
		tmpStatus.textContent = pText;
		tmpEl.appendChild(tmpStatus);
	}

	chooseAddressResult(rawHTMLID, pIndex)
	{
		const tmpRow = (this._addressResultsByID[rawHTMLID] || [])[Number(pIndex)];
		if (!tmpRow)
		{
			return;
		}
		this._addressResultsByID[rawHTMLID] = [];
		this._clearAddressResultsDOM(rawHTMLID);
		// A full-size row's search is keyed by `<rawHTMLID>-<rowIndex>`; commit it to that row rather
		// than to a same-named single-record field.
		const tmpRowContext = this._rowContexts[rawHTMLID];
		if (tmpRowContext)
		{
			this._commitTabularRow(tmpRowContext.viewHash, tmpRowContext.groupIndex, tmpRowContext.inputIndex,
				tmpRowContext.rowIndex, tmpRowContext.rawHTMLID, tmpRow.Latitude, tmpRow.Longitude);
			return;
		}
		this._commitLatLong(rawHTMLID, tmpRow.Latitude, tmpRow.Longitude);
		this.moveMarkerTo(rawHTMLID, Number(tmpRow.Latitude), Number(tmpRow.Longitude));
	}

	// --- Clear / reset -------------------------------------------------------------------------------

	clearValue(rawHTMLID)
	{
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			tmpLat.val('');
		}
		if (tmpLong.length)
		{
			tmpLong.val('');
		}
		this.refreshCombinedDisplay(rawHTMLID);
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpMapData)
		{
			tmpMapData.location = { Latitude: '', Longitude: '' };
			if (tmpMapData.marker && tmpMapData.map)
			{
				try
				{
 tmpMapData.map.removeLayer(tmpMapData.marker);
				}
				catch (pError)
				{/* already removed */}
				tmpMapData.marker = null;
			}
		}
		this._addressResultsByID[rawHTMLID] = [];
		this._clearAddressResultsDOM(rawHTMLID);
		this._suppressMapSync[rawHTMLID] = true;
		if (tmpLat.length)
		{
			tmpLat.trigger('change');
		}
		this._suppressMapSync[rawHTMLID] = false;
	}

	// --- Tabular -------------------------------------------------------------------------------------

	/** Repaint a tabular cell's readout (both presentations share the id) from a value. */
	_paintTabularDisplay(rawHTMLID, pRowIndex, pSeed)
	{
		if (!document.querySelector(this.getTabularDisplayID(rawHTMLID, pRowIndex)))
		{
			return;
		}
		this.pict.ContentAssignment.assignContent(this.getTabularDisplayID(rawHTMLID, pRowIndex),
			this.formatLocationDisplay(pSeed.Latitude, pSeed.Longitude));
	}

	/**
	 * Mirror a row's value into the full-size presentation's visible coordinate editors. No-op in the
	 * compact presentation, which has no editors (the value is edited in the modal instead).
	 */
	_syncRowEditors(rawHTMLID, pRowIndex, pSeed)
	{
		const tmpLatEl = document.querySelector(this.getRowEditorLatitudeID(rawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getRowEditorLongitudeID(rawHTMLID, pRowIndex));
		if (!tmpLatEl && !tmpLngEl)
		{
			return;
		}
		this._setDomValue(tmpLatEl, pSeed.Latitude);
		this._setDomValue(tmpLngEl, pSeed.Longitude);
	}

	/** Repaint a tabular cell's derived display + editors from its two hidden inputs. */
	_refreshTabularDisplay(rawHTMLID, pRowIndex)
	{
		const tmpLatEl = document.querySelector(this.getTabularLatitudeInputID(rawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getTabularLongitudeInputID(rawHTMLID, pRowIndex));
		const tmpSeed = { Latitude: this._domValue(tmpLatEl), Longitude: this._domValue(tmpLngEl) };
		this._paintTabularDisplay(rawHTMLID, pRowIndex, tmpSeed);
		this._syncRowEditors(rawHTMLID, pRowIndex, tmpSeed);
	}

	/** Write a row's two hidden inputs and repaint its display (does not marshal — caller does). */
	setTabularLatLong(rawHTMLID, pRowIndex, pLatitude, pLongitude)
	{
		const tmpLatEl = document.querySelector(this.getTabularLatitudeInputID(rawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getTabularLongitudeInputID(rawHTMLID, pRowIndex));
		this._setDomValue(tmpLatEl, pLatitude);
		this._setDomValue(tmpLngEl, pLongitude);
		this._refreshTabularDisplay(rawHTMLID, pRowIndex);
	}

	/**
	 * Commit a row's value from any of its controls: hidden inputs + derived display + editors, the
	 * inline record-set marker, then marshal the row. Every row-level action funnels through here.
	 */
	_commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, pLatitude, pLongitude)
	{
		this.setTabularLatLong(pRawHTMLID, pRowIndex, pLatitude, pLongitude);
		this._syncRecordSetRowMarker(`RS-${pRawHTMLID}-${pRowIndex}`, { Latitude: pLatitude, Longitude: pLongitude });
		if (this.pict.views[pViewHash])
		{
			this.pict.views[pViewHash].dataChangedTabular(pGroupIndex, pInputIndex, pRowIndex);
		}
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._injectCSS();
		const tmpSeed = this._coerceLatLong(pValue);
		this._paintTabularDisplay(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		this._syncRowEditors(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		// Record Sets render each record stacked (not a compact table), so the map variant gets an inline
		// per-record map. The compact Tabular table skips this and keeps its map in the Edit modal.
		if (pGroup && pGroup.Layout === 'RecordSet')
		{
			this._ensureRecordSetRowMap(pView, pGroup, pInput, pRowIndex, tmpSeed);
			this._refreshRecordSetRowStaticImage(pInput, pRowIndex, tmpSeed);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/** The readout and editors are derived state, so they must be repainted to the row's value after a reorder. */
	onTabularRowReorderRepaintTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpSeed = this._coerceLatLong(pValue);
		this._paintTabularDisplay(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		this._syncRowEditors(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		if (pGroup && pGroup.Layout === 'RecordSet')
		{
			this._ensureRecordSetRowMap(pView, pGroup, pInput, pRowIndex, tmpSeed);
			this._refreshRecordSetRowStaticImage(pInput, pRowIndex, tmpSeed);
		}
		// (base method is a no-op; not chaining super avoids a stale shipped-.d.ts type error)
		return true;
	}

	// --- Record Set inline per-record map (map variant only) -----------------------------------------

	/**
	 * Reveal + (re)mount the inline map for one record-set record. Visibility-gated (defers to an
	 * IntersectionObserver when the record is behind an inactive tab) and stale-aware (a record-set
	 * re-render on row add/delete regenerates the host, so the detached map is torn down and re-mounted).
	 * No-op for the no-map variant (no host element).
	 * @param {any} pView @param {any} pGroup @param {any} pInput @param {number} pRowIndex @param {any} pSeed
	 */
	_ensureRecordSetRowMap(pView, pGroup, pInput, pRowIndex, pSeed)
	{
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const tmpHost = document.getElementById(`GEO-RS-MAP-FOR-${rawHTMLID}-${pRowIndex}`);
		if (!tmpHost)
		{
			return;
		}
		tmpHost.style.display = 'block';
		const tmpLocked = tmpHost.getAttribute('data-geo-locked') === 'true';
		const tmpKey = `RS-${rawHTMLID}-${pRowIndex}`;
		const tmpContext = { view: pView, groupIndex: pGroup.GroupIndex, inputIndex: pInput.PictForm.InputIndex, rowIndex: pRowIndex, rawHTMLID };

		const tmpExisting = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[tmpKey];
		if (tmpExisting && tmpExisting.map)
		{
			const tmpEl = (typeof tmpExisting.map.getContainer === 'function') ? tmpExisting.map.getContainer() : null;
			if (tmpEl && tmpEl === tmpHost && document.body.contains(tmpEl))
			{
				tmpExisting.recordSet = tmpContext;
				this._syncRecordSetRowMarker(tmpKey, pSeed);
				return;
			}
			try
			{
 tmpExisting.map.remove();
			}
			catch (pError)
			{/* already detached */}
			delete this.pict.AppData.LeafletMapsData[tmpKey];
		}
		if (this._mapObservers[tmpKey])
		{
			this._mapObservers[tmpKey].disconnect();
			delete this._mapObservers[tmpKey];
		}

		const tmpMount = () =>
		{
			if (this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[tmpKey] && this.pict.AppData.LeafletMapsData[tmpKey].map)
			{
				return;
			}
			this._mountRecordSetRowMap(tmpKey, tmpHost, tmpContext, pSeed, tmpLocked);
		};
		if ((typeof IntersectionObserver === 'undefined') || (tmpHost.offsetParent !== null))
		{
			tmpMount();
			return;
		}
		const tmpObserver = new IntersectionObserver((pEntries) =>
		{
			for (let i = 0; i < pEntries.length; i++)
			{
				if (pEntries[i].isIntersecting)
				{
					tmpObserver.disconnect();
					delete this._mapObservers[tmpKey];
					tmpMount();
					return;
				}
			}
		});
		this._mapObservers[tmpKey] = tmpObserver;
		tmpObserver.observe(tmpHost);
	}

	_mountRecordSetRowMap(pKey, pHost, pContext, pSeed, pLocked)
	{
		const libLeaflet = window.L;
		if (!libLeaflet || !pHost)
		{
			return;
		}
		const tmpSeed = this._coerceLatLong(pSeed);
		const tmpHasFix = this._inRange(tmpSeed.Latitude, tmpSeed.Longitude);
		const tmpLat = tmpHasFix ? Number(tmpSeed.Latitude) : GEO_DEFAULT_CENTER.Latitude;
		const tmpLng = tmpHasFix ? Number(tmpSeed.Longitude) : GEO_DEFAULT_CENTER.Longitude;

		const tmpMap = libLeaflet.map(pHost).setView([ tmpLat, tmpLng ], tmpHasFix ? 13 : 4);
		libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(tmpMap);

		this.pict.AppData.LeafletMapsData = this.pict.AppData.LeafletMapsData || {};
		this.pict.AppData.LeafletMapsData[pKey] = {
			map: tmpMap,
			RawHTMLID: pKey,
			destinationAddress: pHost.id,
			hideMap: false,
			marker: null,
			location: { Latitude: '', Longitude: '' },
			locked: pLocked,
			recordSet: pContext,
		};
		if (tmpHasFix)
		{
			this.pict.AppData.LeafletMapsData[pKey].marker = this._recordSetMarker(pKey, tmpLat, tmpLng);
			this.pict.AppData.LeafletMapsData[pKey].location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
		}
		if (pLocked)
		{
			this.disableMap(tmpMap, pHost.id);
		}
		else
		{
			tmpMap.on('click', (pEvent) => this._onRecordSetRowMapClick(pKey, pEvent.latlng.lat, pEvent.latlng.lng));
		}
		setTimeout(() =>
		{
			try
			{
 tmpMap.invalidateSize();
			}
			catch (pError)
			{/* host detached */}
		}, 60);
	}

	/** Create (draggable) or move the record's marker. */
	_recordSetMarker(pKey, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData || !tmpMapData.map)
		{
			return tmpMapData ? tmpMapData.marker : null;
		}
		const libLeaflet = window.L;
		const tmpLatLng = { lat: Number(pLatitude), lng: Number(pLongitude) };
		let tmpMarker = tmpMapData.marker;
		if (!tmpMarker)
		{
			tmpMarker = libLeaflet.marker(tmpLatLng, { draggable: !tmpMapData.locked });
			if (!tmpMapData.locked)
			{
				tmpMarker.on('dragend', (pEvent) =>
				{
					const tmpDrag = pEvent.target.getLatLng();
					this._commitRecordSetRow(pKey, tmpDrag.lat, tmpDrag.lng);
				});
			}
		}
		tmpMarker.setLatLng(tmpLatLng).addTo(tmpMapData.map);
		return tmpMarker;
	}

	_onRecordSetRowMapClick(pKey, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData)
		{
			return;
		}
		tmpMapData.marker = this._recordSetMarker(pKey, pLatitude, pLongitude);
		this._commitRecordSetRow(pKey, pLatitude, pLongitude);
	}

	/** Write a record's value from its map gesture: hidden inputs + compact display, then marshal the row. */
	_commitRecordSetRow(pKey, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData || !tmpMapData.recordSet)
		{
			return;
		}
		const tmpContext = tmpMapData.recordSet;
		tmpMapData.location = { Latitude: String(pLatitude), Longitude: String(pLongitude) };
		this.setTabularLatLong(tmpContext.rawHTMLID, tmpContext.rowIndex, pLatitude, pLongitude);
		if (tmpContext.view && (typeof tmpContext.view.dataChangedTabular === 'function'))
		{
			tmpContext.view.dataChangedTabular(tmpContext.groupIndex, tmpContext.inputIndex, tmpContext.rowIndex);
		}
	}

	/** Refresh a healthy record map's marker to the marshaled row value (marker follows external edits). */
	_syncRecordSetRowMarker(pKey, pSeed)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData || !tmpMapData.map)
		{
			return;
		}
		const tmpSeed = this._coerceLatLong(pSeed);
		if (this._inRange(tmpSeed.Latitude, tmpSeed.Longitude))
		{
			const tmpLat = Number(tmpSeed.Latitude);
			const tmpLng = Number(tmpSeed.Longitude);
			tmpMapData.marker = this._recordSetMarker(pKey, tmpLat, tmpLng);
			tmpMapData.location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
			// Recenter: a non-gesture set (Get-My-Location, Edit modal) may land off-screen, so bring it
			// into view. Map drag/click never routes here, so a drag is never yanked back to center.
			tmpMapData.map.setView([ tmpLat, tmpLng ], Math.max(tmpMapData.map.getZoom() || 13, 13));
		}
		else if (tmpMapData.marker)
		{
			try
			{
 tmpMapData.map.removeLayer(tmpMapData.marker);
			}
			catch (pError)
			{/* already gone */}
			tmpMapData.marker = null;
			tmpMapData.location = { Latitude: '', Longitude: '' };
		}
	}

	onUseMyLocationTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		if (!navigator.geolocation)
		{
			this._toast('Could not fetch user location', 'is-error');
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pPosition) => this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID,
				pPosition.coords.latitude, pPosition.coords.longitude),
			() => this._toast('Could not fetch user location', 'is-error'));
	}

	clearValueTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpKey = this.getRowKey(pRawHTMLID, pRowIndex);
		this._addressResultsByID[tmpKey] = [];
		this._clearAddressResultsDOM(tmpKey);
		this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, '', '');
	}

	/**
	 * A typed edit in the full-size row presentation's coordinate editors. Those inputs are unbound,
	 * so the value is pushed into the row's hidden informary inputs and marshaled from here.
	 */
	onRowCoordinateEdit(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpLat = this._domValue(document.querySelector(this.getRowEditorLatitudeID(pRawHTMLID, pRowIndex)));
		const tmpLng = this._domValue(document.querySelector(this.getRowEditorLongitudeID(pRawHTMLID, pRowIndex)));
		this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, tmpLat, tmpLng);
	}

	/**
	 * Address search from the full-size row presentation. The search DOM is keyed by instance id, so
	 * the row's identity is stashed first — chooseAddressResult reads it back to commit the pick to
	 * the right row.
	 */
	searchAddressTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpKey = this.getRowKey(pRawHTMLID, pRowIndex);
		this._rowContexts[tmpKey] = { viewHash: pViewHash, groupIndex: pGroupIndex, inputIndex: pInputIndex, rowIndex: pRowIndex, rawHTMLID: pRawHTMLID };
		return this.searchAddress(tmpKey);
	}

	openEditModalTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpInput = (tmpView && typeof tmpView.getTabularRecordInput === 'function') ? tmpView.getTabularRecordInput(pGroupIndex, pInputIndex) : null;
		const tmpHasMap = !!(tmpInput && tmpInput.PictForm && tmpInput.PictForm.InputType === 'GeolocationSelectorWithMap');
		const tmpLatEl = document.querySelector(this.getTabularLatitudeInputID(pRawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getTabularLongitudeInputID(pRawHTMLID, pRowIndex));
		const tmpCurrent = { Latitude: this._domValue(tmpLatEl), Longitude: this._domValue(tmpLngEl) };
		this._openLocationModal(tmpHasMap, tmpCurrent, (pResult) =>
			this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, pResult.Latitude, pResult.Longitude));
	}

	/**
	 * Open the edit-location modal for a single-record field — the compact presentation's Edit button,
	 * where the picker lives in the modal instead of inline. Saving commits through the same path a
	 * map gesture uses, so the inline map (map variant) follows.
	 * @param {string} rawHTMLID
	 * @param {boolean} pHasMap
	 */
	openEditModal(rawHTMLID, pHasMap)
	{
		const tmpCurrent = {
			Latitude: $(this.getLatitudeInputHTMLID(rawHTMLID)).val(),
			Longitude: $(this.getLongitudeInputHTMLID(rawHTMLID)).val(),
		};
		this._openLocationModal(!!pHasMap, tmpCurrent, (pResult) =>
		{
			// An emptied modal is a clear — clearValue also drops the marker, which a bare commit
			// would leave stranded at the old point.
			if (!this._inRange(pResult.Latitude, pResult.Longitude))
			{
				this.clearValue(rawHTMLID);
				return;
			}
			this._commitLatLong(rawHTMLID, pResult.Latitude, pResult.Longitude);
			this.moveMarkerTo(rawHTMLID, Number(pResult.Latitude), Number(pResult.Longitude));
		});
	}

	// --- Edit-location modal (hosts the full picker; used by tabular Edit) ----------------------------

	/**
	 * The modal reuses the field-level methods keyed by GEO_MODAL_KEY: its lat/long inputs are
	 * LATITUDE-FOR-GEO-MODAL / LONGITUDE-FOR-GEO-MODAL, its search box GEO-ADDRESS-INPUT-GEO-MODAL, and its
	 * map is a self-contained Leaflet instance in LeafletMapsData[GEO_MODAL_KEY].
	 */
	_buildModalContentHTML(pHasMap)
	{
		const tmpKey = GEO_MODAL_KEY;
		let tmpHTML = '' +
			'<div class="field has-addons">' +
			'<div class="control is-expanded"><input id="' + this.getAddressInputID(tmpKey) + '" class="input" type="text" placeholder="Search an address or place…" autocomplete="off" ' +
			'onkeydown="if(event.key===\'Enter\'){event.preventDefault();_Pict.providers.GeolocationSelector.searchAddress(\'' + tmpKey + '\');}" /></div>' +
			'<div class="control"><button type="button" class="button is-soft" onclick="_Pict.providers.GeolocationSelector.searchAddress(\'' + tmpKey + '\')"><span class="icon"><i class="fas fa-search"></i></span><span class="is-hidden-mobile">Search</span></button></div>' +
			'</div>' +
			'<div id="' + this.getAddressResultsID(tmpKey) + '"></div>' +
			// Plain columns (no is-mobile) so the coordinate pair stacks into full-width rows on a phone
			// rather than truncating long decimals side by side.
			'<div class="columns mt-1">' +
			'<div class="column"><label class="label is-small">Latitude</label>' +
			'<input id="LATITUDE-FOR-' + tmpKey + '" class="input" type="number" step="any" onchange="_Pict.providers.GeolocationSelector.onModalCoordEdit()" /></div>' +
			'<div class="column"><label class="label is-small">Longitude</label>' +
			'<input id="LONGITUDE-FOR-' + tmpKey + '" class="input" type="number" step="any" onchange="_Pict.providers.GeolocationSelector.onModalCoordEdit()" /></div>' +
			'</div>' +
			// geo-action-buttons splits the pair evenly across the row on a phone, matching the
			// inline control's action row.
			'<div class="buttons are-small mt-1 geo-action-buttons">' +
			'<button type="button" class="button is-link" onclick="_Pict.providers.GeolocationSelector.onUseMyLocation(\'' + tmpKey + '\')"><span class="icon"><i class="fa fa-location-crosshairs"></i></span><span>Use My Location</span></button>' +
			'<button type="button" class="button is-link is-soft" onclick="_Pict.providers.GeolocationSelector.clearValue(\'' + tmpKey + '\')"><span class="icon"><i class="fa fa-eraser"></i></span><span>Clear</span></button>' +
			'</div>';
		if (pHasMap)
		{
			tmpHTML += '<div id="MAP-CONTAINER-FOR-' + tmpKey + '" class="mt-2" style="min-height: 300px; z-index: 1;"></div>';
		}
		return tmpHTML;
	}

	/** Typed edit inside the modal: follow it on the modal map + capture the working value. */
	onModalCoordEdit()
	{
		const tmpKey = GEO_MODAL_KEY;
		const tmpLat = (this._domValue(document.getElementById(`LATITUDE-FOR-${tmpKey}`)));
		const tmpLng = (this._domValue(document.getElementById(`LONGITUDE-FOR-${tmpKey}`)));
		this._modalValue = { Latitude: tmpLat, Longitude: tmpLng };
		if (this._inRange(tmpLat, tmpLng))
		{
			this.moveMarkerTo(tmpKey, Number(tmpLat), Number(tmpLng));
		}
	}

	_mountModalMap(pCurrent)
	{
		const tmpKey = GEO_MODAL_KEY;
		const libLeaflet = window.L;
		const tmpHost = document.getElementById(`MAP-CONTAINER-FOR-${tmpKey}`);
		if (!libLeaflet || !tmpHost)
		{
			return;
		}
		const tmpSeed = this._coerceLatLong(pCurrent);
		const tmpHasFix = this._inRange(tmpSeed.Latitude, tmpSeed.Longitude);
		const tmpLat = tmpHasFix ? Number(tmpSeed.Latitude) : GEO_DEFAULT_CENTER.Latitude;
		const tmpLng = tmpHasFix ? Number(tmpSeed.Longitude) : GEO_DEFAULT_CENTER.Longitude;

		const tmpMap = libLeaflet.map(tmpHost).setView([ tmpLat, tmpLng ], tmpHasFix ? 13 : 4);
		libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(tmpMap);

		this.pict.AppData.LeafletMapsData = this.pict.AppData.LeafletMapsData || {};
		this.pict.AppData.LeafletMapsData[tmpKey] = {
			map: tmpMap,
			RawHTMLID: tmpKey,
			destinationAddress: `MAP-CONTAINER-FOR-${tmpKey}`,
			hideMap: false,
			marker: null,
			location: { Latitude: '', Longitude: '' },
		};
		if (tmpHasFix)
		{
			this.pict.AppData.LeafletMapsData[tmpKey].marker = this.setLeafletMarker({ lat: tmpLat, lng: tmpLng }, tmpMap, null, tmpKey);
			this.pict.AppData.LeafletMapsData[tmpKey].location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
		}
		tmpMap.on('click', this.onMapSelectionMade, this);
		setTimeout(() =>
		{
			try
			{
 tmpMap.invalidateSize();
			}
			catch (pError)
			{/* host detached */}
		}, 80);
	}

	_teardownModalMap()
	{
		const tmpKey = GEO_MODAL_KEY;
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[tmpKey];
		if (tmpMapData && tmpMapData.map)
		{
			try
			{
 tmpMapData.map.remove();
			}
			catch (pError)
			{/* already removed */}
		}
		if (this.pict.AppData.LeafletMapsData)
		{
			delete this.pict.AppData.LeafletMapsData[tmpKey];
		}
		delete this._addressResultsByID[tmpKey];
	}

	/**
	 * Open the shared edit-location modal, prefilled to pCurrent, and invoke pOnSave({Latitude, Longitude})
	 * when the user confirms. The working value is captured live (this._modalValue), so Save is robust to
	 * modal-DOM teardown timing.
	 */
	_openLocationModal(pHasMap, pCurrent, pOnSave)
	{
		const tmpKey = GEO_MODAL_KEY;
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || (typeof tmpModal.show !== 'function'))
		{
			this._toast('Location editor is unavailable', 'is-error');
			return;
		}
		this._addressResultsByID[tmpKey] = [];
		this._modalValue = { Latitude: pCurrent ? pCurrent.Latitude : '', Longitude: pCurrent ? pCurrent.Longitude : '' };

		tmpModal.show(
		{
			title: 'Edit Location',
			content: this._buildModalContentHTML(pHasMap),
			closeable: true,
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' },
			],
			onOpen: (pDialog) =>
			{
				// Scopes the phone-only full-screen rules to this dialog (the shared modal has no
				// full-screen option of its own).
				if (pDialog && pDialog.classList)
				{
					pDialog.classList.add('geolocation-edit-modal');
				}
				const tmpLatEl = document.getElementById(`LATITUDE-FOR-${tmpKey}`);
				const tmpLngEl = document.getElementById(`LONGITUDE-FOR-${tmpKey}`);
				if (pCurrent && pCurrent.Latitude !== '' && pCurrent.Latitude != null)
				{
					this._setDomValue(tmpLatEl, pCurrent.Latitude);
				}
				if (pCurrent && pCurrent.Longitude !== '' && pCurrent.Longitude != null)
				{
					this._setDomValue(tmpLngEl, pCurrent.Longitude);
				}
				if (pHasMap)
				{
					this._mountModalMap(pCurrent);
				}
				if (tmpLatEl)
				{
					tmpLatEl.focus();
				}
			},
			onClose: () => this._teardownModalMap(),
		}).then((pHash) =>
		{
			if (pHash !== 'save')
			{
				return;
			}
			pOnSave({ Latitude: this._modalValue.Latitude, Longitude: this._modalValue.Longitude });
		});
	}
}

module.exports = CustomInputHandler;

},{"./PictProvider-InputType-GeolocationSelector-CSS.js":57,"pict-section-form":497}],59:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LAB-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Lab for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Lab record yet, get it and store it
			if (!this.pict.AppData.SelectedLab || this.pict.AppData.SelectedLab.length < 1)
			{
				const tmpResult = await this.pict.providers.LabProvider.getLabByID(pValue);
				this.pict.AppData.SelectedLab = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedLab?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],60:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LAB-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Lab',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Lab...',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}


	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Lab for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Lab and set it as the selected Lab on the data object
			const tmpLab = await this.pict.providers.LabProvider.getLabByID(pValue);
			this.pict.AppData.SelectedLab = tmpLab;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedLab.IDLab;
			tmpOption.text = this.pict.AppData.SelectedLab.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],61:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LINEITEM-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedLineItem.ItemCode || 'N/A',
				this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the LineItem for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the LineItem record yet, get it and store it
			if (!this.pict.AppData.SelectedLineItem)
			{
				const tmpResult = await this.pict.providers.LineItemProvider.getLineItemByID(pValue);
				this.pict.AppData.SelectedLineItem = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
		return true;
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],62:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LINEITEM-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('LineItem',
				{
					Input: pInput,
					SearchFields: [ 'ItemCode', 'Name' ],
					SearchFallbackPlaceholder: 'Select a Line Item by name or code...',
					GetRecordUserFacingID: (pLineItem) => pLineItem.ItemCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the LineItem for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected LineItem and set it as the selected LineItem on the data object
			const tmpLineItem = await this.pict.providers.LineItemProvider.getLineItemByID(pValue);
			this.pict.AppData.SelectedLineItem = tmpLineItem;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedLineItem.IDLineItem;
			tmpOption.text = `${this.pict.AppData.SelectedLineItem.ItemCode || 'N/A'}|~|${this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],63:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.selectedMaterial = null;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIAL-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.SelectedMaterial.ItemCode || 'N/A',
				this.SelectedMaterial.Name || ('Unnamed Material #' + this.SelectedMaterial.IDMaterial),
			);
		}
		else
		{
			tmpDisplayTemplate = this.SelectedMaterial.Name || ('Unnamed Material #' + this.SelectedMaterial.IDMaterial);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the Material for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Material record yet, get it and store it
			if (!this.SelectedMaterial || this.SelectedMaterial.IDMaterial !== pValue)
			{
				try
				{
					const tmpMaterial = await this.pict.providers.MaterialProvider.getMaterialByID(pValue);
					this.SelectedMaterial = tmpMaterial;
				}
				catch (e)
				{
					this.pict.log.error(`Error fetching Material with ID ${ pValue }: ${ e }`);
					this.SelectedMaterial =
					{
						IDMaterial: pValue,
						Name: 'Unkown Material',
					};
				}
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],64:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.inputID = '';
		this.placeholder = '';
		this.showAllMaterials = false;
		this.disableSpecYearSiloing = false;
		this.selectedMaterial = null;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIAL-SELECT-FOR-${pInputHTMLID}`;
	}

	getSelectFilterToggleID(pInputHTMLID)
	{
		return `#MATERIAL-SELECT-FILTER-TOGGLE-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 */
	initializeSelect2()
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpShowAllMaterials = this.showAllMaterials;
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Material',
				{
					SearchFields: [ 'ItemCode', 'Name' ],
					SearchPlaceholder: this.placeholder,
					GetRecordUserFacingID: (pMaterial) => pMaterial.ItemCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// if we are showing all materials, do not apply the parent filter
						// otherwise, filter to only show top-level materials (no parent)
						if (tmpShowAllMaterials)
						{
							// always ensure we have a sort by Name ascending
							if (!pFilters.length || !pFilters.includes('FSF'))
							{
								pFilters.push('FSF~Name~ASC~0');
							}
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						pFilters.push('FBV~IDMaterialParent~EQ~0');
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.inputID).data('select2'))
			{
				window['jQuery'](this.inputID).select2(tmpSelectOptions);
			}
		}
	}

	updateToggleFilterLink(pInputHTMLID)
	{
		// update the link toggle icon
		if (this.showAllMaterials)
		{
			const newToggleLinkIconElement = document.createElement('i');
			newToggleLinkIconElement.classList.add('fas', 'fa-toggle-on');
			this.pict.ContentAssignment.assignContent(this.getSelectFilterToggleID(pInputHTMLID) + ' > .icon', newToggleLinkIconElement.outerHTML);
		}
		else
		{
			const newToggleLinkIconElement = document.createElement('i');
			newToggleLinkIconElement.classList.add('fas', 'fa-toggle-off');
			this.pict.ContentAssignment.assignContent(this.getSelectFilterToggleID(pInputHTMLID) + ' > .icon', newToggleLinkIconElement.outerHTML);
		}
	}

	/**
	 * Toggle the material filter for the input element based on the user's selection.
	 * @param {string} pInputHTMLID The input HTML ID.
	 */
	toggleMaterialFilter(pInputHTMLID)
	{
		this.showAllMaterials = !this.showAllMaterials;
		this.updateToggleFilterLink(pInputHTMLID);
		// destroy and reinitialize the select2 plugin with the new filter settings
		window['jQuery'](this.getSelectInputHTMLID(pInputHTMLID)).data('select2').destroy();
		this.initializeSelect2();
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Material for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Material and set it as the selected Material on the data object
			try
			{
				const tmpMaterial = await this.pict.providers.MaterialProvider.getMaterialByID(pValue);
				this.SelectedMaterial = tmpMaterial;
			}
			catch (e)
			{
				this.pict.log.error(`Error fetching Material with ID ${ pValue }: ${ e }`);
				this.SelectedMaterial =
				{
					IDMaterial: pValue,
					Name: 'Unkown Material',
				};
			}
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.SelectedMaterial.IDMaterial;
			tmpOption.text = `${this.SelectedMaterial.ItemCode || 'N/A'}|~|${this.SelectedMaterial.Name || ('Unnamed Material #' + this.SelectedMaterial.IDMaterial)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		if (pInput)
		{
			this.inputID = this.getSelectInputHTMLID(pInput.Macro.RawHTMLID);
			this.showAllMaterials = pInput.PictForm?.InputExtra && typeof(pInput.PictForm?.InputExtra) === 'string' && pInput.PictForm?.InputExtra.toLowerCase().replaceAll(' ', '') === 'showallmaterials' ? true : false;
			this.updateToggleFilterLink(pInput.Macro.RawHTMLID);
			this.placeholder = pInput?.PictForm?.Placeholder || 'Select a Material by name or code...';
			this.removeLoadingSkeleton(pInput);
			this.initializeSelect2();
		}
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],65:[function(require,module,exports){
const PickerProvider = require('./PictProvider-InputType-Picker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const EntityDataBaseline = require('./_EntityDataBaseline.js');

const SALT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
// Special committed value marking "create a new entity" — same sentinel the legacy MES used, so the
// synthesis path is diff-reviewable against it. Committed by the PSP type-to-create OnCreate row.
const NEW_ENTITY_ID = '__NEW__';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsCascadePicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The intermediate broker base for the MaterialsEntitySelector family port (beast §8.8, architecture A):
 * `Picker` (config, `__Record`, filters, defaults) → `MaterialsCascadePicker` (THIS — the shared cascade
 * infrastructure the legacy MES base carried) → the bespoke `Materials*Picker` subclasses, each mirroring
 * its MES counterpart 1:1 for diff-review.
 *
 * Shared infrastructure ported from the MES base:
 *   - the cross-widget EVENT BUS fan-out (`<Entity>Changed:<trackingGUID>:<recordAddress>` +
 *     `FireTriggerGroupOnRecordRefresh`), fired from `_onEntityRecordCascade` — the broker seam that
 *     replaces the legacy `_onRecordRefresh` — and received via onAfterEvent(Tabular)Completion.
 *   - tracking-GUID plumbing (`MATERIALS-ENTITY-TRACKING-GUID-…` — SAME element id as the legacy
 *     templates, so still-legacy sibling selectors keep binding from a migrated Sample during the
 *     phased rollout).
 *   - `__Salt` (record-uniqueness salt kept beside `__Record`) + record-template translation.
 *   - the creation-GUID record identity (`GUID<Entity>` when creation is enabled) + the System-1
 *     local-record resolver, which doubles as the `_refreshEntityRecord` CLOBBER-GUARD: a synthesized
 *     unsaved record would miss every server lookup, and the guard keeps the snapshot without a
 *     guaranteed-miss round trip.
 */
class PictProviderInputTypeMaterialsCascadePicker extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		// Inherited fable-service members the duplicate-pict-provider type chain hides from tsc.
		/** @type {Record<string, any>} */
		this.options;
		/** @type {any} */
		this.log;
	}

	/**
	 * Whether entity creation is enabled for this input — the per-input PictForm flag, falling back to
	 * the provider option the creating subclasses set. Latches a provider-level flag so the save-time
	 * EntityData projection fires even on a form where no sibling selector owns that trigger.
	 * Ported from the MES base.
	 * @param {Record<string, any>} pInput @return {boolean}
	 */
	_isEntityCreationEnabled(pInput)
	{
		const tmpEnabled = ((pInput?.PictForm?.AllowEntityCreation ?? this.options.AllowEntityCreation) === true);
		if (tmpEnabled)
		{
			this._entityCreationEnabled = true;
		}
		return tmpEnabled;
	}

	/**
	 * The record identity: a creation-enabled selector tracks records by `GUID<Entity>` (a new record
	 * has no numeric `ID<Entity>` yet) — the MES `_getDefaultRecordIdentity` branch layered onto the
	 * base broker's RecordIdentity/IdentityField precedence.
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (tmpPictForm.RecordIdentity || tmpPictForm.IdentityField)
		{
			return super._getRecordIdentity(pInput);
		}
		const tmpEntity = this._resolveEntity(tmpPictForm);
		if (this._isEntityCreationEnabled(pInput))
		{
			return `GUID${tmpEntity}`;
		}
		return `ID${tmpEntity}`;
	}

	/**
	 * Carry the cascade identity into the picker config: a creation-enabled field commits its GUID
	 * identity, so PSP's ValueField must match what the legacy select2 committed (GetRecordID read
	 * `_getRecordIdentity` too).
	 * @param {Record<string, any>} pInput @param {string} pHostSelector @param {Function} fOnChange
	 * @return {Record<string, any>}
	 */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpConfig = super._buildPickerConfig(pInput, pHostSelector, fOnChange);
		if (tmpConfig.Entity)
		{
			const tmpIdentity = this._getRecordIdentity(pInput);
			if (!((pInput.PictForm || {}).IdentityField) && tmpIdentity !== `ID${tmpConfig.Entity}`)
			{
				tmpConfig.ValueField = tmpIdentity;
			}
			// Type-to-create (Doug's locked creation-UX call — zero PSP surface): PSP's OnCreate shows a
			// "Create …" row once a term is typed; committing it lands the legacy NEW_ENTITY_ID sentinel,
			// which onDataChange rewrites into a synthesized record — the same flow the legacy pinned
			// "New <Entity>..." row (GetPinnedItem) drove. The typed term is deliberately ignored, like
			// the legacy row ignored it.
			if (this._isEntityCreationEnabled(pInput) && !tmpConfig.OnCreate)
			{
				tmpConfig.OnCreate = () => ({ Value: NEW_ENTITY_ID, Text: `New ${tmpConfig.Entity}...` });
			}
			// A distilled field lists its Dynamic picklist, as MaterialsEntitySelector's dynamicLocalPaginationAdapter did.
			const fPickListDataProvider = this._createDynamicPickListDataProvider(pInput);
			if (fPickListDataProvider)
			{
				tmpConfig.PickListDataProvider = fPickListDataProvider;
			}
			if (typeof tmpConfig.ResolveValue !== 'function')
			{
				const tmpMountContext = this._activeTabularContext;
				const tmpMountView = tmpMountContext ? tmpMountContext.pView : null;
				const tmpMountRow = (tmpMountContext && tmpMountContext.pRowIndex != null) ? tmpMountContext.pRowIndex : null;
				tmpConfig.ResolveValue = (pValue) => this._resolveHeldOrEntityOption(tmpConfig, pInput, tmpMountView, tmpMountRow, pValue);
			}
		}
		return tmpConfig;
	}

	/**
	 * Label a saved value from the `__Record` the form holds, as MaterialsEntitySelector did (its local-record render),
	 * so a record the server cannot return (offline, deleted, unreadable) still reads by name and a re-render costs no
	 * read; a value the form holds no record for is read the way pict-section-picker reads any value.
	 * @param {Record<string, any>} pConfig @param {Record<string, any>} pInput @param {Object|null} pView
	 * @param {number|string|null} pRowIndex @param {any} pValue
	 * @return {Promise<Record<string, any>|null>} the option, or null.
	 */
	_resolveHeldOrEntityOption(pConfig, pInput, pView, pRowIndex, pValue)
	{
		const tmpIdentity = this._getRecordIdentity(pInput);
		if (this._findHeldRecord(pView, pInput, tmpIdentity, pValue, pRowIndex))
		{
			return this._resolveIdentityOption(pConfig, pInput, tmpIdentity, pView, pRowIndex, pValue);
		}
		return Promise.resolve(this.pict.providers['Pict-Section-Picker'].createEntityResolveValue(pConfig)(pValue));
	}

	/**
	 * Mount the entity picker, then page a Dynamic picklist in place of the entity search when the config carries
	 * one. The saved value still resolves through the entity read, so it labels from its record.
	 * @param {string} pPickerHash @param {Record<string, any>} pConfig @return {any} The picker view.
	 */
	_instantiatePicker(pPickerHash, pConfig)
	{
		const tmpView = super._instantiatePicker(pPickerHash, pConfig);
		if (tmpView?.options && pConfig && (typeof pConfig.PickListDataProvider === 'function'))
		{
			tmpView.options.DataProvider = pConfig.PickListDataProvider;
		}
		return tmpView;
	}

	/**
	 * Leave out a tag that reads the same as the option's label, as the Select2 family does (Select2Util's
	 * option text, MaterialsEntitySelector._formatRecordForDisplay): every Lab picker is tagged on the Lab's own
	 * Name, and a Sample created on a form is named by its QR code.
	 *
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {Record<string, any>} pConfig - the picker config.
	 * @return {Record<string, any>} The option, or a copy of it.
	 */
	_presentEntityOption(pOption, pConfig)
	{
		const tmpOption = super._presentEntityOption(pOption, pConfig);
		if (!tmpOption || (typeof tmpOption !== 'object') || tmpOption.Tag === undefined || tmpOption.Tag === null)
		{
			return tmpOption;
		}
		const tmpText = (tmpOption.Text === undefined || tmpOption.Text === null) ? '' : String(tmpOption.Text);
		if (String(tmpOption.Tag).trim() !== tmpText.trim())
		{
			return tmpOption;
		}
		const tmpPresented = Object.assign({}, tmpOption);
		delete tmpPresented.Tag;
		return tmpPresented;
	}

	// --- Creation primitives (ported from the MES base _getDefaultRecord/_handleDefaultRecord) ---

	/**
	 * The record to synthesize for a new entity: the descriptor's `DefaultRecord`, plus — when creation
	 * is enabled and not opted out via `GenerateGUID: false` — a client `GUID<Entity>` minted from the
	 * document GUID + a per-input stanza (`GUIDEntityTypeStanza`, e.g. the Sample subclass's 'S') + the
	 * `__Salt`. Raw template tokens; translated downstream in _handleDefaultRecord.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>|undefined}
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = pInput.PictForm?.DefaultRecord;
		if (this._isEntityCreationEnabled(pInput) && pInput.PictForm?.GenerateGUID !== false)
		{
			const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
			const tmpGUIDField = `GUID${tmpEntity}`;
			tmpRecord = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? JSON.parse(JSON.stringify(tmpRecord)) : { };
			if (!tmpRecord[tmpGUIDField])
			{
				const tmpStanza = pInput.PictForm?.GUIDEntityTypeStanza || tmpEntity;
				tmpRecord[tmpGUIDField] = `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-${tmpStanza}-${this._getSalt(pView, pInput, pRowIndex)}`;
			}
		}
		return tmpRecord;
	}

	/**
	 * Synthesize the new record: deep-copy + translate the template tokens, land the record at
	 * `__Record` and its identity as the committed value, and return that value. The subsequent record
	 * refresh hits the System-1 local-record short-circuit (an unsaved GUID would miss every server
	 * lookup), so the cascade fires with the synthesized record and nothing clobbers it.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string|null} [pRowIndex]
	 * @return {any} the synthesized identity value (or null when nothing synthesized)
	 */
	_handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		let tmpDefaultRecord = this._getDefaultRecord(pView, pInput, pRowIndex);
		if (tmpDefaultRecord)
		{
			tmpDefaultRecord = JSON.parse(JSON.stringify(tmpDefaultRecord));
			this._translateRecordTemplateFields(tmpDefaultRecord);
			const tmpDefaultID = tmpDefaultRecord[this._getRecordIdentity(pInput)];
			pValue = tmpDefaultID || null;
			const tmpDestination = pView.getMarshalDestinationObject();
			if (pValue)
			{
				this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex, ''), pValue);
			}
			this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex), tmpDefaultRecord);
			// A record created here has no server row yet, so this open never needs to read it.
			const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
			if (pValue && !(Number(tmpDefaultRecord[`ID${tmpEntity}`]) > 0))
			{
				this._openRefreshes().add(this._openRefreshKey(pInput, pValue, pRowIndex));
			}
		}
		return pValue;
	}

	/**
	 * Intercept the NEW_ENTITY_ID commit (the type-to-create row): force a fresh salt, synthesize the
	 * record, rewrite the committed value to its identity in the DOM (mid provider-loop — no second
	 * dataChanged), then continue the standard path: the base's record refresh short-circuits on the
	 * local record and fires the cascade fenced.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, null);
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, null, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, null);
			this._syncCommittedValueDOM(pInput, pValue, null);
		}
		else if (this._isClearedPickerValue(pValue))
		{
			this._handleEntitySelectionCleared(pView, pInput, null);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of the NEW_ENTITY_ID intercept. */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, pRowIndex);
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
			this._syncCommittedValueDOM(pInput, pValue, pRowIndex);
		}
		else if (this._isClearedPickerValue(pValue))
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * True when init must SYNTHESIZE a record rather than hydrate a stored one: a MaterialsHidden
	 * InputType or a `DefaultToNewRecord` field with no value auto-creates, and a persisted
	 * NEW_ENTITY_ID token re-synthesizes.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_isInitSynthesisValue(pInput, pValue)
	{
		const tmpInputType = pInput?.PictForm?.InputType || '';
		if (pValue === NEW_ENTITY_ID)
		{
			return true;
		}
		return !pValue && (tmpInputType.startsWith('MaterialsHidden') || !!pInput?.PictForm?.DefaultToNewRecord);
	}

	/**
	 * True when init carries a stored value to hydrate. Uses the same split `_refreshEntityRecord`
	 * decides "cleared" on, so the load path can never take that method's destructive clear branch —
	 * init must not blank a `__Record` slot it was not asked to fill.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_hasInitValueToHydrate(pInput, pValue)
	{
		return this._splitPickerValues(pValue, pInput).length > 0;
	}

	/**
	 * Init-time creation (ported) OR load-time hydration. The synthesis branch auto-creates the record;
	 * every other init routes the STORED value through the record refresh, which is the family's only
	 * cascade seam — `MaterialsEntitySelector.onInputInitialize` refreshes unconditionally, and without
	 * the same call here opening a saved document runs no DocumentPolyJoin synthesis, no `<Entity>Changed`
	 * fan-out, no spec-scope prime and no join reconciliation. The local-record short-circuit answers a
	 * matching persisted snapshot without a fetch, so the hydration costs a cascade, not a round trip.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._generateSaltIfNeeded(pView, pInput, null);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (this._isInitSynthesisValue(pInput, pValue))
		{
			const tmpValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, null);
			if (tmpValue)
			{
				this._syncCommittedValueDOM(pInput, tmpValue, null);
				this._refreshEntityRecord(pView, pInput, tmpValue, pTransactionGUID, null);
			}
		}
		else if (this._hasInitValueToHydrate(pInput, pValue))
		{
			this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, null);
		}
		return tmpResult;
	}

	/** Tabular twin of the init-time creation and load-time hydration. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._generateSaltIfNeeded(pView, pInput, pRowIndex);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (this._isInitSynthesisValue(pInput, pValue))
		{
			const tmpValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
			if (tmpValue)
			{
				this._syncCommittedValueDOM(pInput, tmpValue, pRowIndex);
				this._refreshEntityRecord(pView, pInput, tmpValue, pTransactionGUID, pRowIndex);
			}
		}
		else if (this._hasInitValueToHydrate(pInput, pValue))
		{
			this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		}
		return tmpResult;
	}

	/**
	 * Whether the document is frozen (read-only / Locked): the same signal the entity selector gates refresh on.
	 * @return {boolean}
	 */
	_isRecordFrozen()
	{
		return !this.pict?.AppData?.Interactive || !!this.pict?.AppData?.DocumentData?.ReportData?.Locked;
	}

	/**
	 * Whether a sample-join refresh may rewrite this input's joins. A frozen document keeps the joins it
	 * saved; an input that must follow the database even then sets `PictForm.RefreshJoinsWhenLocked: true`.
	 * @param {Record<string, any>} pInput
	 * @return {boolean}
	 */
	_shouldRefreshSampleJoins(pInput)
	{
		return !this._isRecordFrozen() || pInput?.PictForm?.RefreshJoinsWhenLocked === true;
	}

	/**
	 * The empty-result branch of a sample-join refresh: drop the held joins whose rows were soft-deleted
	 * since the document was saved, and their values from the selection. Only a row read back as deleted
	 * is dropped (`ScopedEntityData.resolveSoftDeletedJoins`); anything else keeps the persisted value. The
	 * drop is a load, so no deletion is staged, and it re-salts the input so a re-add mints a GUID the
	 * deleted row does not own. An input with `RefreshOnOpen: false` keeps its saved snapshot.
	 *
	 * The drop is applied to the joins and value the input holds when the reads settle
	 * (`ScopedEntityData.applySoftDeletedDrop`), not to the ones it started from, so a refresh that landed
	 * meanwhile is not undone and an overlapping drop that already removed the links writes nothing.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {{ Entity: string, ValueField: string, JoinAddress: string, Value: any, Label: string }} pJoinScope
	 * @param {(pDropped: number) => void} fDone - Called once, after any write, with the number of held links
	 *   found deleted.
	 */
	_dropSoftDeletedHeldJoins(pView, pInput, pRowIndex, pJoinScope, fDone)
	{
		if (pInput.PictForm?.RefreshOnOpen === false)
		{
			return fDone(0);
		}
		const tmpHeldJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), pJoinScope.JoinAddress);
		ScopedEntityData.resolveSoftDeletedJoins(this.pict, pJoinScope.Entity, pJoinScope.ValueField, tmpHeldJoins, pJoinScope.Value, (pResult) =>
		{
			if (pResult.Dropped.length < 1)
			{
				return fDone(0);
			}
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpDrop = ScopedEntityData.applySoftDeletedDrop(pJoinScope.Entity, pJoinScope.ValueField,
				this.pict.manifest.getValueAtAddress(tmpDestination, pJoinScope.JoinAddress),
				this.pict.manifest.getValueAtAddress(tmpDestination, this._getPickerValueAddress(pInput, pRowIndex)),
				pResult);
			if (!tmpDrop.Changed)
			{
				return fDone(pResult.Dropped.length);
			}
			ScopedEntityData.beginProgrammaticLoad(this.pict);
			try
			{
				if (tmpDrop.Removed.length > 0)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, pJoinScope.JoinAddress, tmpDrop.Joins);
				}
				const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpHeldRecords = this.pict.manifest.getValueAtAddress(tmpDestination, tmpRecordAddress);
				const tmpKeptRecords = ScopedEntityData.pruneRecordsToValue(tmpHeldRecords, pJoinScope.ValueField, tmpDrop.Value);
				if (tmpKeptRecords !== tmpHeldRecords)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, tmpKeptRecords);
				}
				if (tmpDrop.ValueChanged)
				{
					this._setValueAndCommit(pView, pInput, tmpDrop.Value, pRowIndex);
				}
			}
			finally
			{
				ScopedEntityData.endProgrammaticLoad(this.pict);
			}
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			this.log.info(`${pJoinScope.Label}: dropped ${tmpDrop.Removed.length} link(s) whose record was deleted since the document was saved: ${pResult.Dropped.join(', ')}; value now [${tmpDrop.Value}].`);
			return fDone(pResult.Dropped.length);
		});
	}

	// --- __Salt + record-template translation (ported from the MES base) ---

	/** @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {boolean} [pForce] */
	_generateSaltIfNeeded(pView, pInput, pRowIndex, pForce)
	{
		const tmpSaltAddress = this._getRecordAddress(pInput, pRowIndex, '__Salt');
		const tmpSalt = !pForce && this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress);
		if (!tmpSalt)
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress, this._generateSaltStr());
		}
	}

	/** @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @return {string} */
	_getSalt(pView, pInput, pRowIndex)
	{
		return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex, '__Salt'));
	}

	/** @param {number} [pLength=8] @return {string} */
	_generateSaltStr(pLength = 8)
	{
		let tmpResult = '';
		for (let i = 0; i < pLength; i++)
		{
			tmpResult += SALT_CHARS.charAt(Math.floor(Math.random() * SALT_CHARS.length));
		}
		return tmpResult;
	}

	/** Translate `{~D:…~}` template tokens in every string field of a synthesized record (in place). */
	_translateRecordTemplateFields(pRecord)
	{
		for (const tmpField in pRecord)
		{
			if (typeof pRecord[tmpField] === 'string')
			{
				pRecord[tmpField] = this.pict.parseTemplate(pRecord[tmpField], this.pict);
			}
		}
	}

	// --- Tracking-GUID plumbing (ported; SAME element ids as the legacy templates) ---

	/** @param {string} pInputHTMLID @param {number|string|null} [pRowIndex] @param {string} [pType] @return {string} */
	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType)
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/** @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {string} [pType] @return {string} */
	_getTrackingGUID(pInput, pRowIndex, pType)
	{
		if (pRowIndex == null)
		{
			switch (pType)
			{
			case 'TEST':
				if (pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
				{
					return /** @type {string} */ (pInput.PictForm.TestTrackingGUID);
				}
			// eslint-disable-next-line no-fallthrough
			default:
				if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
				{
					return /** @type {string} */ (pInput.PictForm.SampleTrackingGUID);
				}
			}
		}
		return /** @type {string} */ (this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType)));
	}

	/** @param {Record<string, any>} pInput @param {number|string|null} pRowIndex @param {string} pTrackingGUID @param {string} [pType] */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	/**
	 * Bind a NON-Sample cascade selector's tracking GUID from its sibling Sample descriptor (tabular
	 * group first, then the global manifest) — the sample owns the family's tracking identity.
	 * Ported from the MES base; fired from the marshal hooks like the legacy.
	 * @param {Object} pView @param {Object} pGroup @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (this._resolveEntity((pInput && pInput.PictForm) || {}) == 'Sample')
		{
			return;
		}
		if (pRowIndex != null)
		{
			const tmpLocalManifest = pGroup && pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('MaterialsCascadePicker: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('MaterialsCascadePicker: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('MaterialsCascadePicker: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}

	/** Bind the tracking GUID and bring the value's record on marshal, like the legacy MES onDataMarshalToForm did. */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, null);
		// @ts-ignore — inherited through the PSP chain tsc cannot see (duplicate pict-provider types).
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._backfillRecordOnMarshal(pView, pInput, pValue, null);
		return tmpResult;
	}

	/** Tabular twin of the marshal-time tracking-GUID bind and record backfill. */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		const tmpResult = super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._backfillRecordOnMarshal(pView, pInput, pValue, pRowIndex);
		return tmpResult;
	}

	/**
	 * When a marshalled single value (a solver or an autofill wrote it) is not the entity its held `__Record` holds,
	 * read the value's row into `__Record`, as `MaterialsEntitySelector._backfillMissingRecords` did on marshal: the
	 * record only, with no cascade, so a solver reading `__Record` computes from the row the field shows. A frozen
	 * document keeps its saved record, a failed read keeps what is held, and a read that lands after the value moved
	 * on writes nothing.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 * @return {Promise<void>|void}
	 */
	_backfillRecordOnMarshal(pView, pInput, pValue, pRowIndex)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (this._isRecordFrozen() || this._isMultiplePicker(tmpPictForm) || !pView || (typeof pView.getMarshalDestinationObject !== 'function'))
		{
			return;
		}
		const tmpValues = this._splitPickerValues(pValue, pInput);
		if (tmpValues.length !== 1 || tmpValues[0] === NEW_ENTITY_ID || this._getLocalRecordForValue(pView, pInput, tmpValues[0], pRowIndex))
		{
			return;
		}
		const tmpEntity = this._resolveEntity(tmpPictForm);
		const tmpKey = this._openRefreshKey(pInput, tmpValues[0], pRowIndex);
		if (!tmpEntity || this._openRefreshes().has(tmpKey))
		{
			return;
		}
		this._openRefreshes().add(tmpKey);
		const tmpValueAddress = (pRowIndex != null) ?
			this.pict.providers.Informary.getComposedContainerAddress(tmpPictForm.InformaryContainerAddress, pRowIndex, tmpPictForm.InformaryDataAddress) :
			(pInput.DataAddress || pInput.Hash);
		const tmpIdentity = this._getRecordIdentity(pInput);
		return this._resolveEntityRecord(tmpEntity, tmpValues[0], pInput).then((pRecord) =>
		{
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpCurrentValue = this._splitPickerValues(this.pict.manifest.getValueAtAddress(tmpDestination, tmpValueAddress), pInput);
			if (!pRecord || (pRecord[tmpIdentity] == null) || (tmpCurrentValue.length !== 1) || (tmpCurrentValue[0] !== tmpValues[0]))
			{
				return;
			}
			this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex), pRecord);
		}).catch((pError) =>
		{
			this.pict.log.warn(`Picker [${pInput.Hash}]: marshal record backfill failed for [${tmpValues[0]}]: ${pError.message || pError}`);
		});
	}

	// --- System-1 local-record resolve + the __Record clobber-guard ---

	/**
	 * The locally-held record for a value — the persisted `__Record` snapshot or a freshly synthesized
	 * record — when its IDENTITY MATCHES the committed value. Returns a shallow copy, or null when
	 * System 2 must load.
	 *
	 * REASONED DIVERGENCE from the MES base (live-found 2026-07-17, the B2 clear-reset family): the
	 * legacy carried a second keep-branch — "unsaved record (client identity, no server id) → retain" —
	 * which returned the SYNTHESIZED record even after the user picked a DIFFERENT entity, so the
	 * cascade (DocumentPolyJoin, SampleChanged fan-out) ran against the phantom created record. The
	 * branch was creation-flow armor the port does not need: every creation path (the NEW_ENTITY_ID
	 * intercepts and the init auto-create) rewrites the committed value to the synthesized identity
	 * BEFORE the record refresh runs, so the identity-match branch already covers creation — a mismatch
	 * can only mean the value moved on, exactly when the snapshot must NOT be kept.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>|null}
	 */
	_getLocalRecordForValue(pView, pInput, pValue, pRowIndex)
	{
		const tmpLocalRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		if (tmpLocalRecord && typeof tmpLocalRecord === 'object' && !Array.isArray(tmpLocalRecord))
		{
			const tmpIdentity = this._getRecordIdentity(pInput);
			if (tmpLocalRecord[tmpIdentity] == pValue)
			{
				return Object.assign({}, tmpLocalRecord);
			}
		}
		return null;
	}

	/**
	 * CLOBBER-GUARD + System-1 short-circuit over the base record refresh: when the committed (single)
	 * value is already answered by the local `__Record` and `_keepsHeldRecord` allows it — a frozen
	 * document, `RefreshOnOpen: false`, a freshly synthesized unsaved record whose GUID would miss every
	 * server lookup, or a value this document open has already read — keep it and fire the cascade seam
	 * directly. Everything else (clears, multi, a value to read) delegates to the base, which reconciles
	 * the row through `_reconcileRefreshedRecord`.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string|null} [pRowIndex]
	 * @return {Promise<any>|void}
	 */
	_refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		const tmpValues = this._splitPickerValues(pValue, pInput);
		if (tmpValues.length === 1 && !this._isMultiplePicker(pInput.PictForm) && pView && typeof pView.getMarshalDestinationObject === 'function')
		{
			const tmpLocalRecord = this._getLocalRecordForValue(pView, pInput, tmpValues[0], pRowIndex);
			if (tmpLocalRecord && this._keepsHeldRecord(pInput, tmpLocalRecord, tmpValues[0], pRowIndex))
			{
				// The snapshot at the address IS the record (the copy protects the caller); fence the
				// cascade exactly like the base select path so async cascade writes land pre-PostSolvers.
				const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
				const tmpOperationHash = `PickerRecordLocal-${this._getRecordAddress(pInput, pRowIndex)}-${this.pict.getUUID()}`;
				const tmpFenced = !!pTransactionGUID && typeof pView.registerEventTransactionAsyncOperation === 'function';
				if (tmpFenced)
				{
					pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpOperationHash);
				}
				return Promise.resolve()
					.then(() => this._onEntityRecordCascade(pView, pInput, tmpRecord, pRowIndex, pTransactionGUID))
					.catch((pError) =>
					{
						this.pict.log.error(`Picker [${pInput.Hash}]: error in local-record cascade: ${pError.message || pError}`);
					})
					.finally(() =>
					{
						if (tmpFenced)
						{
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpOperationHash);
						}
					});
			}
			this._openRefreshes().add(this._openRefreshKey(pInput, tmpValues[0], pRowIndex));
		}
		return super._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
	}

	/**
	 * Whether a refresh answers from the record the form holds instead of reading the server. The open-refresh
	 * rule `MaterialsEntitySelector._refreshRecord` applies, and the two must agree: a frozen document or a field
	 * with `RefreshOnOpen: false` keeps its saved record. The port adds one case: a value this document open has
	 * already read, or created (`_handleDefaultRecord` marks a new record read), so neither a re-render nor a record
	 * with no server row yet costs a read. A held record without an `ID<Entity>` is still read: the server may have
	 * saved it after the document did.
	 * @param {Record<string, any>} pInput @param {Record<string, any>} pHeldRecord @param {any} pValue
	 * @param {number|string|null} [pRowIndex]
	 * @return {boolean}
	 */
	_keepsHeldRecord(pInput, pHeldRecord, pValue, pRowIndex)
	{
		if (this._isRecordFrozen() || pInput?.PictForm?.RefreshOnOpen === false)
		{
			return true;
		}
		return this._openRefreshes().has(this._openRefreshKey(pInput, pValue, pRowIndex));
	}

	/**
	 * @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 * @return {string} the key a document open records a read under.
	 */
	_openRefreshKey(pInput, pValue, pRowIndex)
	{
		const tmpDocument = this.pict?.AppData?.DocumentData?.ReportData?.GUIDDocument || '';
		return `${tmpDocument}|${this._getRecordAddress(pInput, pRowIndex)}|${pValue}`;
	}

	/** @return {Set<string>} the values read since the document opened (see `_openRefreshKey`). */
	_openRefreshes()
	{
		if (!this._openRefreshedKeys)
		{
			this._openRefreshedKeys = new Set();
		}
		return this._openRefreshedKeys;
	}

	/**
	 * Reconcile a refreshed row with the record the form holds — the rule `MaterialsEntitySelector._reconcileRefreshedRecord`
	 * applies, and the two must agree. A re-read of the held record is server state, so the baseline takes the
	 * fields the server moved (`EntityDataBaseline.classifyRecordRefresh`); a held change the server does not
	 * have keeps the held record; a changed selection takes the row. No "out of date" flag: DetectDesync is not
	 * ported to this family.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pHeldRecord
	 * @param {Record<string, any>} pFetchedRecord @param {string} pIdentityField @param {any} pValue
	 * @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>} the record to write.
	 */
	_reconcileRefreshedRecord(pView, pInput, pHeldRecord, pFetchedRecord, pIdentityField, pValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !pHeldRecord || typeof pHeldRecord !== 'object' || Array.isArray(pHeldRecord) || pHeldRecord[pIdentityField] != pValue)
		{
			return pFetchedRecord;
		}
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpGUID = pFetchedRecord[`GUID${tmpEntity}`] || pHeldRecord[`GUID${tmpEntity}`];
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpDecision = EntityDataBaseline.classifyRecordRefresh(this.pict, tmpContext, tmpEntity, tmpGUID, pHeldRecord, pFetchedRecord);
		if (tmpDecision.Action === 'keep')
		{
			this.pict.log.info(`MaterialsCascadePicker: kept the held ${tmpEntity} ${tmpGUID} over the server row: ${tmpDecision.Reason}.`);
			return pHeldRecord;
		}
		if (tmpDecision.Action === 'adopt')
		{
			EntityDataBaseline.adoptRefreshedFields(this.pict, tmpContext, tmpEntity, tmpGUID, pFetchedRecord, tmpDecision.Fields);
		}
		return pFetchedRecord;
	}

	// --- The event bus (the port of the legacy MES base _onRecordRefresh fan-out) ---

	/**
	 * Fan the record refresh out on the cross-widget bus: `<Entity>Changed:<trackingGUID>:<address>`,
	 * plus the opt-in `TriggerGroup:<hash>:RecordRefresh:…` (tabular variant carries the emitting row
	 * index so a dependent picker clears only its own row). Subclasses layer their bespoke cascade on
	 * top and call super for the fan-out.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 * @return {void|Promise<any>}
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpEvent = `${tmpEntity}Changed:${this._getTrackingGUID(pInput, pRowIndex)}:${this._getRecordAddress(pInput, pRowIndex)}`;
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, pTransactionGUID);
		if (pInput.PictForm.FireTriggerGroupOnRecordRefresh)
		{
			const tmpEmitterHash = pInput.Hash || pInput.DataAddress;
			// Hydration guard: this fan-out is a SYNCHRONOUS cascade (the trigger group plus every sibling
			// autofill it emits), and a load is authoritative — persisted values must display, not be re-vetted
			// against the current filter scope. The autofill-scope vet skips while the counter is set. Shared
			// with MaterialsEntitySelector by name so either family suppresses the other. Counter handles
			// re-entrant refreshes; finally guarantees the reset even if a handler throws.
			this.pict._MaterialsEntityHydrationDepth = (this.pict._MaterialsEntityHydrationDepth || 0) + 1;
			try
			{
				if (pRowIndex != null)
				{
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${pRowIndex}:${this.pict.getUUID()}`);
				}
				else
				{
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${this.pict.getUUID()}`);
				}
			}
			finally
			{
				this.pict._MaterialsEntityHydrationDepth--;
			}
		}
	}

	// --- Cross-widget event reception (the legacy onAfterEvent(Tabular)Completion seam) ---

	/**
	 * The per-subclass event handler. The base handles the save-projection sweep; subclasses override
	 * to handle their targeted events and call super (or replace it — the Sample subclass projects via
	 * its own _handleEvent, idempotently over the same GUID key).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	// eslint-disable-next-line no-unused-vars
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID);
	}

	// --- The _EntityData save projection (ported from the MES base) ---

	/**
	 * Fire the save-time EntityData projection when this provider has at least one creation-enabled
	 * input (latched in _isEntityCreationEnabled): reset `FormData._EntityData`, broadcast the
	 * ProjectEntityDataRecords sweep inside a transaction so every cascade input projects its created
	 * `__Record` (+ DocumentPolyJoin) into it, then continue the save once the sweep completes.
	 * Providers' onBeforeSaveDataAsync run once each; redundant passes are idempotent (same target,
	 * same GUID keys). No-op — and no empty _EntityData reset — with no creation-enabled input.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (!this._entityCreationEnabled)
		{
			// @ts-ignore — inherited through the PSP chain tsc cannot see.
			return super.onBeforeSaveDataAsync(fCallback);
		}
		if (!this._isScopedEntityDataEnabled())
		{
			this.pict.manifest.setValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.FormData._EntityData', { });
		}
		const tmpEvent = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';
		const tmpTransactionGUID = this.pict.getUUID();
		/** @type {any} */ (this.pict).TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this._sanitizeProjectedComprehensions();
			// @ts-ignore — inherited through the PSP chain tsc cannot see.
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * The object this input projects its created records into on the save sweep, keyed
	 * `<Entity>.<GUID>`. THE ONE PLACE the scoped/legacy decision is made on the emission side: the
	 * projectors below take the object and are identical on both paths, because a context root and
	 * the legacy ledger have the same shape.
	 *
	 * Scoped roots are remembered for the post-sweep sanitize pass.
	 *
	 * @param {Record<string, any>} pInput - The form input descriptor.
	 * @param {string} pEvent - The sweep event.
	 * @return {Record<string, any>|null} - The projection target, or null when this is not a sweep
	 *   event or no target resolves (never fabricates one).
	 */
	_getProjectionTarget(pInput, pEvent)
	{
		if (typeof pEvent !== 'string')
		{
			return null;
		}
		const [ tmpEventType, tmpTargetAddress ] = pEvent.split(':');
		if (tmpEventType !== 'ProjectEntityDataRecords')
		{
			return null;
		}
		if (this._isScopedEntityDataEnabled())
		{
			const tmpContext = this._getComprehensionContext(pInput);
			const tmpContextRoot = ScopedEntityData.resolveContextRoot(this.pict, tmpContext);
			// A baseline sweep collects into a detached scratch tree: nothing was emitted, so neither the
			// FormEntityCreator cross-check nor the post-sweep delta pass may be armed by it.
			if (tmpContextRoot && !ScopedEntityData.getBaselineSweepTarget(this.pict))
			{
				ScopedEntityData.markActive(this.pict);
				if (!this._scopedProjectionRoots)
				{
					this._scopedProjectionRoots = new Map();
				}
				this._scopedProjectionRoots.set(tmpContext, tmpContextRoot);
				ScopedEntityData.noteProjectionRoot(this.pict, tmpContext, tmpContextRoot);
			}
			return tmpContextRoot;
		}
		if (!tmpTargetAddress)
		{
			return null;
		}
		const tmpTarget = this.pict.manifest.getValueAtAddress(this.pict, tmpTargetAddress);
		if (!tmpTarget || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return null;
		}
		return tmpTarget;
	}

	/**
	 * Narrow every scoped root this provider projected into during the sweep: strip transient `__` UI
	 * state, then reduce each record to what changed since the baseline. Runs once, after the sweep,
	 * rather than at each write — the projectors key the form's LIVE record objects in, so acting
	 * earlier would either mutate the record the form renders from or force every projector to clone.
	 *
	 * Shares the pass with `MaterialsEntitySelector` so the two families cannot disagree on what a
	 * change is; they sweep one target and a partially-converted family would emit incoherently.
	 */
	_sanitizeProjectedComprehensions()
	{
		// Roots any picker-family input noted on this sweep, not only this provider's: a driver with no
		// inputs of its own still re-projects every other provider's records.
		const tmpRoots = new Map(this._scopedProjectionRoots || []);
		for (const [ tmpContext, tmpContextRoot ] of ScopedEntityData.takeNotedProjectionRoots(this.pict))
		{
			tmpRoots.set(tmpContext, tmpContextRoot);
		}
		if (tmpRoots.size < 1)
		{
			return;
		}
		// Handed to the document save, which folds every provider's emission ONCE just before the PUT.
		// Folding here instead would advance the baseline mid-save, and the next provider's prune over
		// this same root would then suppress every record and send an empty comprehension.
		const tmpEmitted = new Map();
		for (const [ tmpContext, tmpContextRoot ] of tmpRoots)
		{
			EntityDataBaseline.pruneContextRootToDelta(this.pict, tmpContext, tmpContextRoot);
			tmpEmitted.set(tmpContext, tmpContextRoot);
		}
		if (this._scopedProjectionRoots)
		{
			this._scopedProjectionRoots.clear();
		}
		tmpEmitted.forEach((pContextRoot, pContext) => EntityDataBaseline.recordPendingEmission(this.pict, pContext, pContextRoot));
	}

	/**
	 * Ask for the load-settled baseline capture on this render transaction. Idempotent across every
	 * input on the form and across both input families — the first to ask schedules it.
	 * @param {Object} pView @param {string} [pTransactionGUID]
	 */
	_scheduleBaselineCapture(pView, pTransactionGUID)
	{
		if (!this._isScopedEntityDataEnabled())
		{
			return;
		}
		EntityDataBaseline.scheduleLoadBaselineCapture(this.pict, pView, pTransactionGUID);
	}


	/**
	 * Generic save-time projection handler: on the ProjectEntityDataRecords sweep, write this input's
	 * created `__Record` into the shared collection (keyed `[Entity][GUID<Entity>]`), plus any sibling
	 * DocumentPolyJoin. Opt-in via creation; opt-out per input via SkipEntityDataProjection;
	 * _syncRecordToEntityData no-ops unless the record carries its GUID — a second safety gate.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string' || !this._isEntityCreationEnabled(pInput) || pInput?.PictForm?.SkipEntityDataProjection)
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpDocumentPolyJoinAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${tmpRecordAddress}_DocumentPolyJoin`;
		const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
		if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
		{
			if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
			{
				tmpTarget.DocumentPolyJoin = { };
			}
			tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
		}
	}

	/**
	 * Whether this provider emits scoped `Document.EntityData` comprehensions instead of the legacy
	 * `FormData._EntityData` ledger. The same flag stands `FormEntityCreator` down, so the two
	 * paths never run together.
	 * @return {boolean}
	 */
	_isScopedEntityDataEnabled()
	{
		return ScopedEntityData.isEnabled(this.pict);
	}

	/**
	 * The trigger context this input's records are applied under. Scheduling is manifest data:
	 * `PictForm.ComprehensionContext` selects it, the provider default (`OnSave`) applies otherwise.
	 * @param {Record<string, any>} pInput
	 * @return {string}
	 */
	_getComprehensionContext(pInput)
	{
		return ScopedEntityData.resolveContext(pInput, this.options?.ComprehensionContext || ScopedEntityData.DEFAULT_CONTEXT);
	}

	/** A committed picker value that means "nothing selected". @param {any} pValue @return {boolean} */
	_isClearedPickerValue(pValue)
	{
		return (pValue == null) || (pValue === '') || (pValue === 'null') || (pValue === 'undefined');
	}


	/**
	 * A creation-enabled selection was cleared. Two things follow, both only under the scoped path:
	 * a tombstone for the record IF it is known to exist server-side (never for one that has not
	 * been saved), and a FRESH `__Salt` so a re-add mints a NEW GUID — the apply cannot un-delete a
	 * soft-deleted row, because `Deleted` is stripped at marshal, so re-using the GUID would upsert
	 * into the tombstoned row. No-op unless the cleared record actually carried its client GUID.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_handleEntitySelectionCleared(pView, pInput, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !this._isEntityCreationEnabled(pInput))
		{
			return;
		}
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		const tmpGUID = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[`GUID${tmpEntity}`] : null;
		if (!tmpGUID)
		{
			return;
		}
		this._stageRemovalTombstones(pInput, this._collectRemovedDependentRecords(pView, pInput, pRowIndex, new Set()), 'clear');
		this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
	}

	/**
	 * Stage tombstones for a set of removed records and report what happened. Every removal route in
	 * this family funnels through here, so the gates (persisted, document-owned) and the logging are
	 * applied once. A record the guard would refuse is logged at debug and NOT staged — see
	 * `docs/plans/entitydata-round2/05-client-delete-completeness.md` §4.
	 * @param {Record<string, any>} pInput @param {Array<{ Entity: string, Record: Record<string, any> }>} pRemovals
	 * @param {string} pReason - What removed them, for the log line.
	 * @return {number} - How many tombstones were staged.
	 */
	_stageRemovalTombstones(pInput, pRemovals, pReason)
	{
		if (!this._isScopedEntityDataEnabled() || !Array.isArray(pRemovals) || pRemovals.length < 1)
		{
			return 0;
		}
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, tmpContext, pRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`MaterialsCascadePicker[${pInput.Hash || pInput.DataAddress}]: staged deletion of ${tmpResult.Staged.length} record(s) on ${pReason}.`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * The identity values a committed selection retains, as a Set of strings.
	 * @param {any} pValue @return {Set<string>}
	 */
	_getRetainedIdentitySet(pValue)
	{
		const tmpRetained = new Set();
		if (pValue == null || pValue === '')
		{
			return tmpRetained;
		}
		for (const tmpToken of String(pValue).split(','))
		{
			const tmpTrimmed = tmpToken.trim();
			if (tmpTrimmed.length > 0)
			{
				tmpRetained.add(tmpTrimmed);
			}
		}
		return tmpRetained;
	}

	/**
	 * Records this input's SUBCLASS holds that belong to a de-selected value. The base holds none.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	// eslint-disable-next-line no-unused-vars
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		if (pRetainedIdentities.size > 0)
		{
			return [ ];
		}
		const tmpAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${this._getRecordAddress(pInput, pRowIndex)}_DocumentPolyJoin`;
		return ScopedEntityData.collectTestInstanceUnit({ DocumentPolyJoin: this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress) });
	}

	/**
	 * The de-selection seam — the Picker twin of `MaterialsEntitySelector._handleSelectionRemovals`,
	 * and asserted equivalent to it by the parity contract. Suppressed during a programmatic load,
	 * because a loader that seeds a value re-enters here indistinguishably from a user de-selection.
	 * Anything removed also rotates `__Salt`, exactly as the selector does.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 */
	_handleSelectionRemovals(pView, pInput, pValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || ScopedEntityData.isProgrammaticLoad(this.pict))
		{
			return;
		}
		const tmpRetained = this._getRetainedIdentitySet(pValue);
		const tmpRemovals = this._collectRemovedDependentRecords(pView, pInput, pRowIndex, tmpRetained);
		this._stageRemovalTombstones(pInput, tmpRemovals, 'de-selection');
		if (tmpRemovals.length > 0)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
		}
	}

	/**
	 * Project this input's `__Record` into the entity-data collection, keyed `[Entity][GUID<Entity>]`.
	 * No-op unless the record carries its client GUID (only created/creating records project).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Record<string, Record<string, any>>} [pTargetObject]
	 */
	_syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !tmpRecord[`GUID${tmpEntity}`])
		{
			return;
		}
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}
		if (!tmpEntityData[tmpEntity] || typeof tmpEntityData[tmpEntity] !== 'object' || Array.isArray(tmpEntityData[tmpEntity]))
		{
			tmpEntityData[tmpEntity] = { };
		}
		tmpEntityData[tmpEntity][tmpRecord[`GUID${tmpEntity}`]] = tmpRecord;
	}

	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = PictProviderInputTypeMaterialsCascadePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;
module.exports.NEW_ENTITY_ID = NEW_ENTITY_ID;

},{"./PictProvider-InputType-Picker.js":95,"./_EntityDataBaseline.js":132,"./_ScopedEntityData.js":139}],66:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libEntityDisplayName = require('./_EntityDisplayName.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorDisplayInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}

	/**
	 * The display name for a resolved entity, matching the PSP PickerDisplay contract so the old and new
	 * providers render identically through the migration:
	 *   - a present resolved name passes through,
	 *   - a resolved-but-blank name -> `<entity label> #<record ID>` (`Contractor #3456`),
	 *   - an unresolved/orphan id -> the raw stored value (orphan visibility), never an "Unnamed ..." label.
	 *
	 * @param {any} pDisplayName - The resolved display name from Select2Util.getEntityWithDisplayAsync.
	 * @param {Record<string, any>} pEntity - The raw entity record (has `.Name`, never `.DisplayName`).
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The raw stored value (id) for the orphan fallback.
	 * @return {string}
	 */
	_resolveDisplayNameHTML(pDisplayName, pEntity, pInput, pValue)
	{
		if (pDisplayName !== undefined && pDisplayName !== null && String(pDisplayName).trim() !== '')
		{
			return String(pDisplayName);
		}
		if (pEntity && pEntity[`ID${ this._getEntity(pInput) }`])
		{
			return libEntityDisplayName.unnamedEntityLabel(this._getEntity(pInput), pEntity[`ID${ this._getEntity(pInput) }`], pInput?.Name);
		}
		// Nothing resolved (orphan id) -> show the raw value so the bad reference stays visible.
		return String(pValue);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders a static `...TABULAR-DATA-...` div (no select2 dropdown), so target that
		// via getTabularSelectInputID. The `...TABULAR-DROPDOWN-...` id is never rendered here, so using it
		// silently bailed and left the raw ID the base marshal wrote into the cell.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];

		// if multiple, pValue will be a comma-separated list of IDs
		if (pInput.PictForm && pInput.PictForm.Multiple && typeof(pValue) === 'string')
		{
			const tmpValues = pValue.split(',');
			const tmpDisplayValues = [];
			for (const tmpValue of tmpValues)
			{
				if (tmpValue)
				{
					const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue,
					{
						JoinEntity: pInput.PictForm.JoinEntity,
						JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
						JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
						EntityDisplayField: pInput.PictForm.EntityDisplayField,
						JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
						Disabled: pInput.PictForm.Disabled || false,
						EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
					});
					// if we have an EntityTag, display that as a tag along with the Name
					if (pInput.PictForm.EntityTag)
					{
						let isDateTag = false;
						let tmpEntityTag = pInput.PictForm.EntityTag;
						if (pInput.PictForm.EntityTag.includes(':date'))
						{
							// update the EntityTag to remove the :date for display purposes
							tmpEntityTag = tmpEntityTag.replace(':date', '');
							isDateTag = true;
						}
						let tmpDisplayTemplate = '';
						if (tmpInputSelectElement.tagName === 'DIV')
						{
							tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
								isDateTag ? this.pict.Dates.dayJS(tmpEntity[tmpEntityTag]).format('YYYY-MM-DD') : tmpEntity[tmpEntityTag] || 'N/A',
								this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, tmpValue),
								true,
								tmpEntity.EntityTagLast,
							);
						}
						else
						{
							tmpDisplayTemplate = tmpValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
						}
						tmpDisplayValues.push(tmpDisplayTemplate);
					}
					else
					{
						tmpDisplayValues.push(this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, tmpValue));
					}
				}
			}
			// make the container look like a textarea for multiple values
			this.pict.ContentAssignment.addClass(tmpInputSelectElement, 'textarea');
			this.pict.ContentAssignment.removeClass(tmpInputSelectElement, 'input');
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayValues.join(', '));
			return;
		}
		// for single value
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), pValue,
			{
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				Disabled: pInput.PictForm.Disabled || false,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let isDateTag = false;
				let tmpEntityTag = pInput.PictForm.EntityTag;
				if (pInput.PictForm.EntityTag.includes(':date'))
				{
					// update the EntityTag to remove the :date for display purposes
					tmpEntityTag = tmpEntityTag.replace(':date', '');
					isDateTag = true;
				}
				let tmpDisplayTemplate = '';
				if (tmpInputSelectElement.tagName === 'DIV')
				{
					tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
						isDateTag ? this.pict.Dates.dayJS(tmpEntity[tmpEntityTag]).format('YYYY-MM-DD') : tmpEntity[tmpEntityTag] || 'N/A',
						this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, pValue),
						false,
						tmpEntity.EntityTagLast,
					);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
			}
			else
			{
				const displayString = this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, pValue);
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, displayString);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = MaterialsSelectorDisplayInputHandler;

},{"./_EntityDisplayName.js":133,"pict-section-form":497}],67:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const libEntityDisplayName = require('./_EntityDisplayName.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsEntityPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The base MaterialsEntitySelector on the Picker stack (Wave 10): a field that names its own Entity (Material,
 * MixDesign, Organization, Product, …) on the MaterialsCascadePicker base, which already carries the legacy base's
 * cascade, creation and save projection. This class holds only where the legacy base differed from the broker's
 * defaults for such a field: list order and search, a dotted display field's label, AllowCustomValues and the
 * placeholder. Its config-map entry (`MaterialsEntitySelector`) brings the rest of the Materials family behaviour.
 */
class PictProviderInputTypeMaterialsEntityPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/**
	 * The broker's picker config, with the legacy base's list and creation behaviour.
	 * @param {Record<string, any>} pInput @param {string} pHostSelector @param {Function} fOnChange
	 * @return {Record<string, any>}
	 */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpConfig = super._buildPickerConfig(pInput, pHostSelector, fOnChange);
		if (!tmpConfig.Entity)
		{
			return tmpConfig;
		}
		const tmpPictForm = (pInput && pInput.PictForm) || {};

		// Select2Util searched and sorted by SearchFields, in order, and by Name when the descriptor named none.
		// PSP sorts on one field, so the first stands in for the list.
		if (!Array.isArray(tmpPictForm.SearchFields) || tmpPictForm.SearchFields.length === 0)
		{
			tmpConfig.SearchFields = [ 'Name' ];
		}
		const tmpSortField = String(tmpConfig.SearchFields[0]);
		if (tmpPictForm.Sort === undefined && !tmpSortField.includes('.'))
		{
			tmpConfig.Sort = tmpSortField;
		}

		// The legacy base never read AllowCustomValues, so a typed term is never committed as the ID; a
		// creation-enabled field keeps the "New <Entity>..." row the broker's custom-value row displaced.
		if (tmpPictForm.AllowCustomValues)
		{
			delete tmpConfig.OnCreate;
			if (this._isEntityCreationEnabled(pInput))
			{
				tmpConfig.OnCreate = () => ({ Value: MaterialsCascadePicker.NEW_ENTITY_ID, Text: `New ${tmpConfig.Entity}...` });
			}
		}

		if (!tmpPictForm.Placeholder)
		{
			const tmpEntityLabel = String(tmpConfig.Entity).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
			tmpConfig.Placeholder = `Select ${/^[AEIOU]/i.test(tmpEntityLabel) ? 'an' : 'a'} ${tmpEntityLabel}...`;
		}
		return tmpConfig;
	}

	/**
	 * PSP reads the display field as a flat key, so a dotted one (`MixMetadata.MixName`) would label every option
	 * blank; walk it the way the legacy base and PickerDisplay do.
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {Record<string, any>} pConfig - the picker config.
	 * @return {Record<string, any>} The option, or a copy of it.
	 */
	_presentEntityOption(pOption, pConfig)
	{
		const tmpTextField = pConfig.TextField;
		if (pOption && (typeof pOption === 'object') && pOption.Record && !pConfig.TextTemplate
			&& (typeof tmpTextField === 'string') && tmpTextField.includes('.'))
		{
			const tmpText = libEntityDisplayName.resolveEntityDisplayName(pConfig.Entity, pOption.Record, { TextField: tmpTextField });
			return super._presentEntityOption(Object.assign({}, pOption, { Text: tmpText }), pConfig);
		}
		return super._presentEntityOption(pOption, pConfig);
	}
}

module.exports = PictProviderInputTypeMaterialsEntityPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65,"./_EntityDisplayName.js":133}],68:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const NEW_ENTITY_ID = '__NEW__'; // special value to indicate a new entity is being created and not collide with other possible values
const SALT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

//FIXME: should this subclass the shared entity selector?
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const ScopedEntityData = require('./_ScopedEntityData.js');
const EntityDataBaseline = require('./_EntityDataBaseline.js');
const libFilterToggleUI = require('./_FilterToggleUI.js');
const libLabRouting = require('./_LabRouting.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

// Spec-set floors applied by entity: axis name -> resolver getter + the id column it floors.
// Materials, tests and pay items narrow through their DynamicFilters entries now; the lab axis
// is the one remaining set-membership floor. Extend by adding an axis here.
const SPEC_SET_AXIS =
{
	Lab: { getter: 'getAllowedLabIDs', field: 'IDLab' },
};

/**
 * A selection value as a set of identity strings: comma-separated or an array, blanks dropped.
 * @param {any} pValue
 * @return {Set<string>}
 */
function toIdentitySet(pValue)
{
	const tmpParts = Array.isArray(pValue) ? pValue : String(pValue ?? '').split(',');
	return new Set(tmpParts.map((pPart) => String(pPart ?? '').trim()).filter((pPart) => pPart.length > 0));
}

class MaterialsEntityInputType extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Latched true once any creation-enabled input initializes on this provider, so
		// onBeforeSaveDataAsync knows to fire the save-time EntityData projection.
		this._entityCreationEnabled = false;
	}

	/**
	 * Master opt-in gate for entity creation on this input. Reads PictForm.AllowEntityCreation,
	 * falling back to the provider option the creating subclasses set. Latches a provider-level
	 * flag so onBeforeSaveDataAsync fires the save-time EntityData projection even on a form with
	 * no sibling selector (e.g. a Test selector) that owns that trigger.
	 * @param {Object} pInput
	 * @return {boolean}
	 */
	_isEntityCreationEnabled(pInput)
	{
		const tmpEnabled = ((pInput?.PictForm?.AllowEntityCreation ?? this.options.AllowEntityCreation) === true);
		if (tmpEnabled)
		{
			this._entityCreationEnabled = true;
		}
		return tmpEnabled;
	}

	/**
	 * @param {string} pInputHTMLID
	 *
	 * @return {string}
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @param {number|string} pRowIndex
	 *
	 * @return {string}
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @param {number|string} pRowIndex
	 *
	 * @return {string}
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @param {number|string} [pRowIndex]
	 * @param {string} [pType]
	 */
	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType)
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/**
	 * Determines if a word starts with a leading vowel.
	 * @param {string} pWord The word to check.
	 * @returns {boolean} True if the word starts with a vowel, false otherwise.
	 */
	hasLeadingVowel(pWord)
	{
		if (typeof pWord !== 'string' || pWord.length === 0)
		{
			return false;
		}
		return [ 'A', 'E', 'I', 'O', 'U' ].includes(pWord.charAt(0).toUpperCase());
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		pConfigOptions.GetRecordName = (pRecord) =>
		{
			return this._formatRecordForDisplay(pRecord, pInput);
		};
	}

	/**
	 * Append the spec-set floor for this descriptor's entity. The resolver getter
	 * returns null on the fail-open paths (no contract FK, empty set, no join rows),
	 * in which case pFilters is left unchanged.
	 *
	 * Off-switch: PictForm.DisableSpecYearSiloing.
	 *
	 * Subclasses that bind Entity in the constructor (e.g. MaterialsLabSelector →
	 * 'Lab') are routed correctly via _getEntity(). Every other entity narrows
	 * through its DynamicFilters entries instead and gets nothing here.
	 *
	 * @param {Array<string>} pFilters
	 * @param {Object} pInput
	 * @param {Array<string>} [pBackoff] - Optional back-off-able filter list. When provided, the clause
	 *   routes here (self-omits on an empty result + override); when omitted it is mandatory (pFilters).
	 *   The call site (initializeSelect2) passes it only for descriptors that opt in via
	 *   PictForm.SpecYearBackOff, so the floor is mandatory by default.
	 * @param {number|string} [pRowIndex] - Row index for a tabular picker, so the Show All check below
	 *   reads THIS row's toggle state rather than the flat (non-tabular) address.
	 *
	 * @return {Array<string>}
	 */
	localHandleSearchFilters(pFilters, pInput, pBackoff, pRowIndex)
	{
		pFilters = pFilters || [];
		if (pInput?.PictForm?.DisableSpecYearSiloing || !this.pict.providers.SpecScopeResolver)
		{
			return pFilters;
		}
		const tmpAxis = SPEC_SET_AXIS[this._getEntity(pInput)];
		// Lab is the only axis here, and its floor must be read family-expanded: spec-set membership is
		// declared per FAMILY, so raw IDLab membership empties one level or the other (see
		// _LabRouting.resolveSpecSetLabFloor).
		const tmpAllowed = tmpAxis ? libLabRouting.resolveSpecSetLabFloor(this.pict) : null;
		if (tmpAllowed && tmpAllowed.size > 0 && (pInput?.PictForm?.SpecYearMandatory || !this.pict.providers.Select2Util?.isFilterOverridden?.(pInput, pRowIndex)))
		{
			// Honor pBackoff when the caller provides it; otherwise the clause is mandatory
			// (pFilters) — it stays applied even when it empties a search, so an out-of-spec search
			// trips the no-results signal instead of silently widening. The "Show all" override drops
			// it unless PictForm.SpecYearMandatory is set.
			(Array.isArray(pBackoff) ? pBackoff : pFilters).push(`FBL~${tmpAxis.field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
		return pFilters;
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput - The input object.
	 * @param {number} [pRowIndex] - The row index (optional, for tabular inputs).
	 */
	initializeSelect2(pView, pInput, pRowIndex)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpEntity = this._getEntity(pInput);
			// Human-readable entity label for the placeholder: de-camelCase the entity name so it reads with
			// spaces (SampleType -> "Sample Type", MixDesign -> "Mix Design", ProductionPlant -> "Production
			// Plant", LineItem -> "Line Item"). The baked input types own this; it is not a manifest concern.
			const tmpEntityLabel = String(tmpEntity || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2');
			/** @type {import('./PictProvider-Select2Util.js').Select2AjaxOptions} */
			const tmpConfigOptions = {
				Multiple: pInput.PictForm?.Multiple == true,
				Input: pInput,
				SearchFallbackPlaceholder: `Select ${ this.hasLeadingVowel(tmpEntityLabel) ? 'an' : 'a' } ${tmpEntityLabel}...`,
				ApplySort: true,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				// Honor descriptor SearchFields (e.g. ['Name','ManufacturerCode']) so a picker is searchable by
				// the code shown in its chip, not just Name. Subclass _updateSelect2Options may still override.
				SearchFields: pInput.PictForm.SearchFields,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				Disabled: pInput.PictForm.Disabled || false,
				GetRecordID: (pEntity) => pEntity?.[this._getRecordIdentity(pInput)] || '',
				// Threaded so Select2Util.applyDynamicFilters can resolve a per-row
				// FromRowField against THIS row's sibling cell (each row's ajax closure
				// captures its own RowIndex). Undefined for non-tabular pickers.
				RowIndex: pRowIndex,
				View: pView,
			};
			// give child classes an opportunity to modify the select2 options
			this._updateSelect2Options(tmpConfigOptions, pView, pInput, pRowIndex);
			// Layer the spec-set floor over whatever HandleSearchFilters the
			// subclass installed. Subclasses replace HandleSearchFilters
			// wholesale (e.g. to force Active=1) rather than chaining, so
			// we wrap here once after _updateSelect2Options runs. Filters
			// the subclass added are evaluated first; the floor then narrows
			// the result. Off-switch handled inside localHandleSearchFilters
			// via PictForm.DisableSpecYearSiloing.
			const tmpSubclassHandleSearchFilters = tmpConfigOptions.HandleSearchFilters;
			tmpConfigOptions.HandleSearchFilters = (pFilters, pParams, pBackoff) =>
			{
				let tmpFilters = pFilters || [];
				if (typeof tmpSubclassHandleSearchFilters === 'function')
				{
					tmpFilters = tmpSubclassHandleSearchFilters(tmpFilters, pParams, pBackoff) || tmpFilters;
				}
				// The floor is mandatory by default; a descriptor opts into a back-off-able one (self-omit
				// on empty) via PictForm.SpecYearBackOff, which routes the clause into the back-off list.
				return this.localHandleSearchFilters(tmpFilters, pInput, pInput?.PictForm?.SpecYearBackOff ? pBackoff : undefined, pRowIndex);
			};
			const methodNameByContext = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			const tmpSelectElementSelector = this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex);
			if (tmpConfigOptions.Multiple)
			{
				this.pict.ContentAssignment.setAttribute(tmpSelectElementSelector, 'multiple', 'multiple');
				const tmpSelectWrapper = document.querySelector(tmpSelectElementSelector)?.parentElement;
				if (tmpSelectWrapper && tmpSelectWrapper.classList.contains('select'))
				{
					tmpSelectWrapper.classList.remove('select');
					if (!tmpSelectWrapper.classList.contains('is-multiple'))
					{
						tmpSelectWrapper.classList.add('is-multiple');
					}
				}
				// Strip the placeholder option -- but ONLY on a first initialization. This runs
				// on every initializeSelect2 call, and a re-init (any onAfterRender re-runs
				// onInputInitialize for every input in the section) would otherwise wipe the
				// user's real selections here and leave the picker visibly EMPTY until the
				// marshal repopulated it. Measured on LADOTD Sample Creation: removing one
				// test blanked the Tests picker for ~212ms (tags 1 -> 0 -> 1). Gate it on the
				// same condition the widget creation below uses, so first-init is unchanged.
				if (!window['jQuery'](tmpSelectElementSelector).data('select2'))
				{
					window['jQuery'](tmpSelectElementSelector).empty();
				}
			}
			if (this._isEntityCreationEnabled(pInput))
			{
				tmpConfigOptions.GetPinnedItem = () =>
				{
					return { id: NEW_ENTITY_ID, text: `New ${this._getEntity(pInput)}...` };
				}; //FIXME: human readable entity...
			}
			// if an EntityTag is defined, use it to enhance the search and display
			if (pInput.PictForm.EntityTag)
			{
				tmpConfigOptions.GetRecordUserFacingID = (pEntity) =>
				{
					return pEntity?.[pInput.PictForm.EntityTag] || 'N/A';
				};
			}
			/** @type {import('select2').Options & { [key: string]: any }} */
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax(tmpEntity, tmpConfigOptions);
			if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic)
			{
				tmpSelectOptions.ajax = {}; // necessary for custom data adapter to be used
				tmpSelectOptions.dataAdapter = $.fn.select2.amd.require('select2/data/dynamicLocalPaginationAdapter');
				// plumbing necessary context for the adapter since it doesn't have access to pict
				tmpSelectOptions.Input = pInput;
				tmpSelectOptions.DynamicMetaLists = this.pict.providers.DynamicMetaLists; //FIXME: ...
			}
			// tabular vs. non-tabular context
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](tmpSelectElementSelector).data('select2'))
			{
				window['jQuery'](tmpSelectElementSelector).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 *
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._generateSaltIfNeeded(pView, pInput);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		// initialize the select2 plugin
		this.initializeSelect2(pView, pInput);
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			// Empty picker on a new form — apply the descriptor Default (resolving it via DefaultField if set). The
			// async resolve's setDataByInput lands the id and repaints. Blank pValue so that, in the rare case the
			// value arrived as a raw token, super / _refreshRecord don't try to load a record keyed by it.
			this._applyConfiguredDefault(pView, pInput, null);
			pValue = '';
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput));
		if (pInput.PictForm?.DetectDesync && pValue)
		{
			this._checkRecordDesync(pView, pInput).catch((pError) =>
			{
				this.pict.log.warn(`MaterialsEntitySelector de-sync check failed: ${pError.message || pError}`);
			});
		}
		if (pInput.PictForm?.ShowAllToggle)
		{
			this._updateFilterToggleIcon(pInput.Macro.RawHTMLID, !!this.pict.providers.Select2Util?.isFilterOverridden?.(pInput));
			this._syncFilterToggleDisabledState(pInput);
		}
		// only put a default sample in if we are hidden, or user selected "new record"
		if (!pValue && (pInput.PictForm.InputType.startsWith('MaterialsHidden') || pInput.PictForm.DefaultToNewRecord) || pValue === NEW_ENTITY_ID)
		{
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID);
		}
		return tmpResult;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @return {string} the integrated "Show All" filter-toggle element ID for this picker.
	 */
	getSelectFilterToggleID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-FILTER-TOGGLE-${pInputHTMLID}${(pRowIndex != null) ? `-${pRowIndex}` : ''}`;
	}

	/**
	 * Flip the integrated "Show All" override for this picker. The state persists at `<key>__ShowAll`
	 * (non-tabular) or `<key>__ShowAll_<rowIndex>` (tabular, per-row), read by Select2Util.isFilterOverridden,
	 * so the next option fetch drops or re-applies the scoped filters.
	 * @param {string} pInputHTMLID
	 * @param {string} pKey - state key: the DataAddress (non-tabular) or the input Hash (tabular per-row).
	 * @param {number|string} [pRowIndex] - present for a tabular per-row toggle.
	 */
	toggleFilterOverride(pInputHTMLID, pKey, pRowIndex)
	{
		// A read-only / disabled selector paints the toggle inert (_FilterToggleUI) — swallow the click rather
		// than writing override state and re-running the option fetch for a field whose value cannot change.
		if (libFilterToggleUI.isToggleDisabled(this.pict, this.getSelectFilterToggleID(pInputHTMLID, pRowIndex)))
		{
			return;
		}
		const tmpSuffix = (pRowIndex != null) ? `__ShowAll_${pRowIndex}` : '__ShowAll';
		const tmpAddress = `AppData.DocumentData.ReportData.FormData.${pKey}${tmpSuffix}`;
		const tmpNewState = !this.pict.manifest.getValueByHash(this.pict, tmpAddress);
		this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpNewState);
		this._updateFilterToggleIcon(pInputHTMLID, tmpNewState, pRowIndex);
	}

	/**
	 * Paint the toggle inert when the field is read-only / disabled. The render-time `{~FilterToggleDisabled:~}`
	 * macro already covers a manifest-declared Disabled; this catches one set AFTER render — `MaterialsSampleSelector`
	 * flips PictForm.Disabled from `DisabledOnceSaved` inside its own onInputInitialize.
	 * @param {Object} pInput @param {number|string} [pRowIndex]
	 */
	_syncFilterToggleDisabledState(pInput, pRowIndex)
	{
		libFilterToggleUI.syncToggleDisabledState(this.pict, this.getSelectFilterToggleID(pInput.Macro.RawHTMLID, pRowIndex), libFilterToggleUI.isInputDisabled(pInput));
	}

	/**
	 * Repaint the toggle icon to reflect the current override state.
	 * @param {string} pInputHTMLID
	 * @param {boolean} pState
	 * @param {number|string} [pRowIndex]
	 */
	_updateFilterToggleIcon(pInputHTMLID, pState, pRowIndex)
	{
		if (!this.pict?.ContentAssignment)
		{
			return;
		}
		const tmpIcon = pState ? 'fa-toggle-on' : 'fa-toggle-off';
		this.pict.ContentAssignment.assignContent(`${this.getSelectFilterToggleID(pInputHTMLID, pRowIndex)} > .icon`, `<i class="fas ${tmpIcon}"></i>`);
	}

	_getTrackingGUID(pInput, pRowIndex, pType)
	{
		if (pRowIndex == null)
		{
			switch (pType)
			{
			case 'TEST':
				if (pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
				{
					return pInput.PictForm.TestTrackingGUID;
				}
			default:
				if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
				{
					return pInput.PictForm.SampleTrackingGUID;
				}
			}
		}
		return this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType));
	}

	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (this._getEntity(pInput) == 'Sample')
		{
			return;
		}
		// modalities:
		//
		// single global sample
		// tabular row-based tests
		// tabular row-based sample and tests

		if (pRowIndex != null)
		{
			// tabular
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('MaterialsEntitySelector: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		// check sibling Descriptors for a sample descriptor
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('MaterialsEntitySelector: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('MaterialsEntitySelector: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index parameter. If present, this is a tabular input.
	 *
	 * @return {string}
	 */
	_handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		//FIXME: should not do this on every marshall - only on initial value marshall - move to on-init? does that flow in well with the initial value coming in or do those clash?
		let tmpDefaultRecord = this._getDefaultRecord(pView, pInput, pRowIndex);
		if (tmpDefaultRecord)
		{
			tmpDefaultRecord = JSON.parse(JSON.stringify(tmpDefaultRecord));
			this._translateRecordTemplateFields(tmpDefaultRecord);
			const tmpDefaultID = tmpDefaultRecord[this._getRecordIdentity(pInput)];
			pValue = tmpDefaultID || null;
			if (!pValue)
			{
				//FIXME: some kind of negative ID thing to maintain uniqueness until we save? figure that out
			}
			if (pValue)
			{
				//FIXME: is this right? it seems weird but copied from another input provider; debug it
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), pInput.PictForm.InformaryDataAddress, pValue);
			}
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex), tmpDefaultRecord);
		}
		if (pValue)
		{
			// don't need to do this if we didn't synthesize a value, since it already had no value
			this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), pRowIndex, (pRecord) =>
			{
				if (pRecord)
				{
					//FIXME: if this finds a value, what should we do? iterate our uniqueness? push this value back into the sample selector? how do we tell select2 that we changed the value?
					/*
					if (pRowIndex != null)
					{
						this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pRecord[`ID${this._getEntity(pInput)}`]);
					}
					else
					{
						this.pict.ContentAssignment.assignContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), pRecord[`ID${this._getEntity(pInput)}`]);
					}*/
					if (pRowIndex != null)
					{
						this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pRecord[this._getRecordIdentity(pInput)]);
					}
					else
					{
						this.pict.ContentAssignment.assignContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), pRecord[this._getRecordIdentity(pInput)]);
					}
					//FIXME: how we get select2 to update?
				}
			});
		}
		return pValue;
	}


	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = pInput.PictForm?.DefaultRecord;
		// When creation is enabled, mint a client GUID<Entity> so a synthesized record has a stable,
		// trackable identity before it is saved. Opt out via PictForm.GenerateGUID = false when the
		// caller supplies the GUID another way. The stanza segment defaults to the entity name and is
		// overridable via PictForm.GUIDEntityTypeStanza (e.g. the Sample subclass uses 'S'). The raw
		// template is translated downstream in _handleDefaultRecord.
		if (this._isEntityCreationEnabled(pInput) && pInput.PictForm?.GenerateGUID !== false)
		{
			const tmpEntity = this._getEntity(pInput);
			const tmpGUIDField = `GUID${tmpEntity}`;
			tmpRecord = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? JSON.parse(JSON.stringify(tmpRecord)) : { };
			if (!tmpRecord[tmpGUIDField])
			{
				const tmpStanza = pInput.PictForm?.GUIDEntityTypeStanza || tmpEntity;
				tmpRecord[tmpGUIDField] = `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-${tmpStanza}-${this._getSalt(pView, pInput, pRowIndex)}`;
			}
		}
		return tmpRecord;
	}

	_getRecordSimpleIdentity(pInput)
	{
		return `ID${this._getEntity(pInput)}`;
	}

	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || this._getDefaultRecordIdentity(pInput);
	}

	_getDefaultRecordIdentity(pInput)
	{
		// A creation-enabled selector tracks records by GUID<Entity> (a new record has no numeric
		// ID<Entity> yet), mirroring the Sample subclass's hard-coded GUIDSample identity. Still
		// overridable per input via PictForm.RecordIdentity. Non-creating selectors keep ID<Entity>.
		if (this._isEntityCreationEnabled(pInput))
		{
			return `GUID${this._getEntity(pInput)}`;
		}
		return this._getRecordSimpleIdentity(pInput);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} [pRowIndex]
	 * @param {boolean} [pForce]
	 */
	_generateSaltIfNeeded(pView, pInput, pRowIndex, pForce)
	{
		const tmpSaltAddress = this._getRecordAddress(pView, pInput, pRowIndex, '__Salt');
		let tmpSalt = !pForce && this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress);
		if (!tmpSalt)
		{
			tmpSalt = this._generateSaltStr();

			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress, tmpSalt);
		}
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 * @return {string} the salt to identify this input instance
	 */
	_getSalt(pView, pInput, pRowIndex)
	{
		const tmpSaltAddress = this._getRecordAddress(pView, pInput, pRowIndex, '__Salt');
		return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress);
	}

	/**
	 * @param {number} [pLength=8]
	 * @return {string} a random salt to identify this input instance
	 */
	_generateSaltStr(pLength = 8)
	{
		let result = '';
		for (let i = 0; i < pLength; i++)
		{
			result += SALT_CHARS.charAt(Math.floor(Math.random() * SALT_CHARS.length));
		}
		return result;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 * @param {string} [pSuffix]
	 */
	_getRecordAddress(pView, pInput, pRowIndex, pSuffix = '__Record')
	{
		if (pInput.PictForm?.RecordAddress)
		{
			return pInput.PictForm.RecordAddress;
		}
		if (pRowIndex != null)
		{
			return pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + pSuffix;
			//FIXME: cute thing but not supported by setValueAtAddress in Manyfest
			//const tmpTestAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + '..__' + pInput.DataAddress;
			/** @type {string} */
			const tmpTestAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			const tmpSplitPoint = tmpTestAddress.lastIndexOf('.');
			if (tmpSplitPoint >= 0)
			{
				return tmpTestAddress.substring(0, tmpSplitPoint + 1) + '__' + tmpTestAddress.substring(tmpSplitPoint + 1);
			}

			return `__${tmpTestAddress}`;
		}
		//FIXME: if pRowIndex is given, this is tabular and we need to adjust the address accordingly? unless, we can apply this in the local tabular context
		return `${pInput.DataAddress || pInput.Hash}${pSuffix}`;
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options?.Entity || null;
	}

	/**
	 * Resolve the VALUE (not __Record) data address for this input/row -- the same address the
	 * marshal binds the select element to.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} [pRowIndex]
	 * @return {string}
	 */
	_getValueAddress(pView, pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.PictForm?.InformaryDataAddress || pInput.DataAddress || pInput.Hash;
	}

	/**
	 * Normalize a CLEARED entity selection. select2's clear ("x") marshals the literal string
	 * "null" (or null) into the value field; left as-is it persists in saved FormData and prints
	 * as "null" in the exported PDF, and _refreshRecord treats "null" as a real id so the previous
	 * __Record is never cleared (a stale record then drives downstream displays). Coerce a cleared
	 * value to '' and correct the value the marshal already wrote, so the caller's _refreshRecord('')
	 * takes its clear branch and resets __Record.
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {number} [pRowIndex]
	 * @return {any} the normalized value ('' when cleared, otherwise pValue unchanged)
	 */
	_coerceClearedEntityValue(pView, pInput, pValue, pRowIndex)
	{
		if ((pValue === 'null') || (pValue === 'undefined') || (pValue === null) || (typeof pValue === 'undefined'))
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pView, pInput, pRowIndex), '');
			return '';
		}
		return pValue;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._generateSaltIfNeeded(pView, pInput, pRowIndex);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		this.initializeSelect2(pView, pInput, pRowIndex);
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			// See onInputInitialize — apply the Default on an empty picker (blank pValue so a raw token, if any,
			// isn't loaded as a record key).
			this._applyConfiguredDefault(pView, pInput, pRowIndex);
			pValue = '';
		}
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), pRowIndex);
		if (pInput.PictForm?.ShowAllToggle)
		{
			this._updateFilterToggleIcon(pInput.Macro.RawHTMLID, !!this.pict.providers.Select2Util?.isFilterOverridden?.(pInput, pRowIndex), pRowIndex);
			this._syncFilterToggleDisabledState(pInput, pRowIndex);
		}
		// only put a default sample in if we are hidden, or user selected "new record"
		if (!pValue && (pInput.PictForm.InputType.startsWith('MaterialsHidden') || pInput.PictForm.DefaultToNewRecord) || pValue === NEW_ENTITY_ID)
		{
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * True when a declarative `Default` should be applied to the picker. Fires when the picker is empty — the new
	 * form's marshal destination holds `''` (a DEFINED empty string) at the address, so manyfest's getValueByHash
	 * does NOT substitute the descriptor Default (it only does so for `undefined`); `pValue` therefore arrives as
	 * `''` and we apply the Default ourselves. Also fires if `pValue` DID arrive as the raw Default token (from an
	 * undefined address) for a by-field default, so that token can be resolved. Mirrors the value-gate
	 * `_handleDefaultRecord` uses — once a value is set the gate is false and it does not re-fire.
	 *
	 * @param {Object} pInput @param {any} pValue @return {boolean}
	 */
	_shouldApplyConfiguredDefault(pInput, pValue)
	{
		if (pInput.Default == null || pInput.Default === '')
		{
			return false;
		}
		if (pValue == null || pValue === '')
		{
			return true;
		}
		// Non-empty but equal to the raw Default token (manyfest surfaced it at an undefined address) — resolve it,
		// but only for a by-field default; a by-id value already IS the record id and must not re-apply.
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		return (pValue === pInput.Default && !!tmpField && tmpField !== this._getRecordIdentity(pInput));
	}

	/**
	 * Apply `pInput.Default` to an empty picker. `PictForm.DefaultField` names a NON-identity field to match on
	 * (e.g. `Hash`) so the default is portable across customers — `Default:"ACPT"` + `DefaultField:"Hash"` resolves
	 * the customer's ACPT SampleType by its id via one read. Without a `DefaultField` (or when it IS the record
	 * identity) the `Default` is already the id and is set directly. `setDataByInput` writes the id into FormData,
	 * so the value-gate closes and this does not re-fire; a re-entrancy latch dedupes concurrent init passes while
	 * the read is in flight.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|null} [pRowIndex]
	 */
	_applyConfiguredDefault(pView, pInput, pRowIndex)
	{
		if (pInput._DefaultResolving)
		{
			return;
		}
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		if (!tmpField || tmpField === this._getRecordIdentity(pInput))
		{
			// Default is already the record id — set it directly, no resolve.
			this._setResolvedDefault(pView, pInput, pRowIndex, pInput.Default);
			return;
		}
		const tmpEntity = this._getEntity(pInput);
		if (!tmpEntity || !this.pict.HeadlightRestClient)
		{
			return;
		}
		pInput._DefaultResolving = true;
		this.pict.HeadlightRestClient.getJSON(`${tmpEntity}s/FilteredTo/FBV~${tmpField}~EQ~${encodeURIComponent(pInput.Default)}/0/1`, (pError, pRows) =>
		{
			pInput._DefaultResolving = false;
			const tmpRecord = (!pError && Array.isArray(pRows)) ? pRows[0] : null;
			if (tmpRecord)
			{
				this._setResolvedDefault(pView, pInput, pRowIndex, tmpRecord[this._getRecordIdentity(pInput)]);
			}
		});
	}

	/**
	 * Set a resolved default value onto the picker (single or tabular), which drives the record refresh + repaint.
	 * @param {Object} pView @param {Object} pInput @param {number|null} pRowIndex @param {any} pValue
	 */
	_setResolvedDefault(pView, pInput, pRowIndex, pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '')
		{
			return;
		}
		if (pRowIndex != null)
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pValue);
		}
		else
		{
			pView.setDataByInput(pInput, pValue);
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Repaint this cell's select2 to the row's current value after a tabular row REORDER.
	 *
	 * A plain marshal (`_renderEntitiesToPicker`) only APPENDS a selected `<option>`; for a cell
	 * that already shows a value, appending the reordered-in value's option does not deselect the
	 * stale one, so select2 keeps displaying the old product. Here we make sure the option exists
	 * (append it from the local `__Record` if not) and then EXPLICITLY set the select's value,
	 * which switches the display. `change.select2` is UI-only, so this does not re-enter the
	 * framework's data-change/marshal cycle. This is what lets `_repaintAfterRowReorder` skip the
	 * expensive full source-view render (which re-initialized every select2).
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The row's current value for this input.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onTabularRowReorderRepaintTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		try
		{
			const tmpElementID = this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex);
			const tmpElements = this.pict.ContentAssignment.getElement(tmpElementID);
			if (!tmpElements || tmpElements.length < 1)
			{
				return true;
			}
			const tmpJQuery = window['jQuery'];
			// Cleared cell -> clear the picker.
			if (pValue == null || pValue === '' || pValue === 'null')
			{
				tmpJQuery(tmpElementID).val(null).trigger('change.select2');
				return true;
			}
			// Ensure the option for the row's current value is present (append it from the locally
			// held record when select2 doesn't already carry it), then force-select it.
			const tmpIdentity = this._getRecordIdentity(pInput);
			const tmpAlreadyPresent = Array.prototype.some.call(tmpElements[0].options || [], (pOption) => String(pOption.value) === String(pValue));
			if (!tmpAlreadyPresent)
			{
				const tmpRecord = this._getLocalRecordForValue(pView, pInput, pValue, pRowIndex);
				if (tmpRecord && (tmpRecord[tmpIdentity] != null))
				{
					tmpJQuery(tmpElementID).append(new Option(this._formatRecordForDisplay(tmpRecord, pInput), tmpRecord[tmpIdentity], false, false));
				}
			}
			tmpJQuery(tmpElementID).val(String(pValue)).trigger('change.select2');
		}
		catch (pError)
		{
			this.pict.log.error(`MaterialsEntitySelector[${this._getEntity(pInput)}].onTabularRowReorderRepaintTabular error: ${pError.message || pError}`);
		}
		return true;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
			if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
			{
				return false;
			}
			let tmpCurrentSelection = this._safeSelect2Data(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
			let tmpValues = (pValue == null || pValue == '') ? [] : [ pValue ];
			let tmpNeedsClear = false;
			if (pInput.PictForm?.Multiple == true && typeof pValue === 'string')
			{
				tmpValues = pValue.split(',').map((v) => v.trim()).filter((v) => v.length > 0);
				if (Array.isArray(tmpCurrentSelection) && tmpCurrentSelection.length == tmpValues.length && tmpValues.every((v) => tmpCurrentSelection.find((s) => s.id == v)))
				{
					return;
				}
				tmpNeedsClear = true;
			}
			const tmpEntities = [];
			const tmpMissingValues = [];
			if (pInput.PictForm.SelectOptionsPickList)
			{
				tmpEntities.push(...this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList, { extractRootKey: tmpValues }));
				for (const tmpEntity of tmpEntities)
				{
					tmpEntity.__Value = tmpEntity.id;
				}
			}
			else
			{
				for (const tmpValue of tmpValues)
				{
					// System 1: render single-select pickers from the local snapshot first; only load when missing.
					if (tmpValue && tmpValue !== 'null' && tmpValue !== NEW_ENTITY_ID) //FIXME: what's up with this null string?
					{
						// Prefer the local __Record (persisted snapshot / freshly synthesized record) — synchronous, no
						// fetch. No snapshot -> single-select defers to async backfill; multi-select fetches inline.
						let tmpEntity = this._getLocalRecordForValue(pView, pInput, tmpValue, pRowIndex);
						if (!tmpEntity)
						{
							if (!pInput.PictForm?.Multiple)
							{
								tmpMissingValues.push(tmpValue);
								continue;
							}
							try
							{
								const tmpEntityDisplay = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue, this._buildEntityFetchOptions(pInput));
								tmpEntity = Object.assign({}, tmpEntityDisplay.Record, { __DisplayName: tmpEntityDisplay.DisplayName });
							}
							catch (pFetchError)
							{
								tmpEntity = null;
							}
						}
						if (tmpEntity && typeof tmpEntity === 'object' && tmpEntity[this._getRecordIdentity(pInput)])
						{
							tmpEntity.__Value = tmpValue;
							tmpEntities.push(tmpEntity);
						}
					}
				}
			}
			if (tmpNeedsClear)
			{
				// Drop only the options that are no longer selected, rather than emptying the
				// element and letting _renderEntitiesToPicker rebuild it. select2 repaints from
				// the element, so a full empty makes every tag vanish and come back -- and the
				// marshal fan-out runs this ~4x per field per change, so the user sees it.
				// Measured on LADOTD Sample Creation (one test removed): 8 empties across the
				// Tests and Labs pickers, both blanking mid-change.
				//
				// This is the second half of the flicker. The first was the ungated placeholder
				// strip in initializeSelect2; both had to go. _renderEntitiesToPicker below
				// already appends only what is missing, so pruning here leaves the picker
				// converging on the right set without ever being empty.
				this._pruneUnselectedOptions(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex), tmpValues);
				tmpCurrentSelection = this._safeSelect2Data(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
			}
			// _renderEntitiesToPicker only APPENDS selected options; a single-select clear resolves nothing to
			// render, so reset the picker explicitly. Guarded to a genuine clear (not a value pending backfill
			// or a new-record pin). Multi-select clears via the tmpNeedsClear path above.
			if (!pInput.PictForm?.Multiple && tmpEntities.length === 0 && tmpMissingValues.length === 0 && !tmpValues.includes(NEW_ENTITY_ID) && tmpCurrentSelection.length > 0)
			{
				window['jQuery'](this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex)).val(null).trigger('change.select2');
			}
			this._renderEntitiesToPicker(pInput, tmpEntities, pRowIndex);
			this._renderDesyncAffordance(pView, pInput, pRowIndex);
			// System 2: load any values that had no local snapshot in the background and update the UI when they
			// arrive — non-blocking, so the user is in the form immediately on whatever System 1 rendered.
			if (tmpMissingValues.length > 0)
			{
				this._backfillMissingRecords(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, tmpMissingValues).catch((pError) =>
				{
					this.pict.log.warn(`MaterialsEntitySelector[${this._getEntity(pInput)}]: record backfill failed: ${pError.message || pError}`);
				});
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Error in MaterialsEntitySelector[${this._getEntity(pInput)}]._onDataMarshalToForm: ${pError.message || pError}`);
		}
	}

	/**
	 * Build the entity-fetch options object (DB display fetch / backfill share it).
	 * @param {Object} pInput
	 * @return {Object}
	 */
	_buildEntityFetchOptions(pInput)
	{
		return {
			IdentityField: this._getRecordIdentity(pInput),
			JoinEntity: pInput.PictForm.JoinEntity,
			JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
			JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
			EntityDisplayField: pInput.PictForm.EntityDisplayField,
			JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
			Disabled: pInput.PictForm.Disabled || false,
			EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
		};
	}

	/**
	 * System 1 resolver: the locally-held record for a value — the persisted __Record snapshot or a freshly
	 * synthesized record, when its identity matches the value. Returns a shallow copy (so the transient marshal
	 * __Value never lands on the persisted snapshot), or null when there is no local record (System 2 must load).
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {number|string} [pRowIndex]
	 * @return {Record<string, any>|null}
	 */
	_getLocalRecordForValue(pView, pInput, pValue, pRowIndex)
	{
		const tmpLocalRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		if (tmpLocalRecord && typeof tmpLocalRecord === 'object' && !Array.isArray(tmpLocalRecord))
		{
			const tmpIdentity = this._getRecordIdentity(pInput);
			if (tmpLocalRecord[tmpIdentity] == pValue)
			{
				return Object.assign({}, tmpLocalRecord);
			}
			// A synthesized/unsaved record carries its client identity (e.g. a GUID) but no server ID.
			// This is for the record creation path; retain the local record in this case.
			if (tmpLocalRecord[tmpIdentity] && !tmpLocalRecord[`ID${this._getEntity(pInput)}`])
			{
				return Object.assign({}, tmpLocalRecord);
			}
		}
		return null;
	}

	/**
	 * Append the given resolved records as selected options on the picker and repaint select2. Shared by the
	 * synchronous marshal (System 1) and the async backfill (System 2). Dedupes against the live selection.
	 * @param {Object} pInput
	 * @param {Array<Record<string, any>>} pEntities - each carrying the transient __Value (the option id) and, when resolved from a fetch, __DisplayName
	 * @param {number|string} [pRowIndex]
	 */
	_renderEntitiesToPicker(pInput, pEntities, pRowIndex)
	{
		const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpCurrentSelection = this._safeSelect2Data(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		let tmpChanged = false;
		for (const tmpEntity of pEntities)
		{
			if (!tmpCurrentSelection.find((s) => s.id == tmpEntity.__Value))
			{
				let tmpOption;
				if (pInput.PictForm.SelectOptionsPickList)
				{
					tmpOption = new Option(tmpEntity.text, tmpEntity.id, false, true);
				}
				else
				{
					tmpOption = new Option(this._formatRecordForDisplay(tmpEntity, pInput), tmpEntity[this._getRecordIdentity(pInput)], false, true);
				}
				tmpChanged = true;
				window['jQuery'](this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex)).append(tmpOption);
			}
			delete tmpEntity.__Value;
			delete tmpEntity.__DisplayName;
		}
		if (tmpChanged)
		{
			window['jQuery'](this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex)).trigger('change.select2');
		}
	}

	/**
	 * System 2: asynchronously load records that had no local snapshot, persist single-select results at
	 * __Record, and render them — non-blocking. Keeps any existing __Record on failure (offline-tolerant).
	 * @param {Object} pView @param {Object} pGroup @param {Object} pRow @param {Object} pInput
	 * @param {any} pValue @param {string} pHTMLSelector @param {number|string} [pRowIndex] @param {Array<any>} [pValues]
	 */
	async _backfillMissingRecords(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, pValues = [])
	{
		const tmpLoaded = [];
		for (const tmpValue of pValues)
		{
			let tmpEntity = null;
			let tmpDisplayName = null;
			try
			{
				const tmpEntityDisplay = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue, this._buildEntityFetchOptions(pInput));
				tmpEntity = tmpEntityDisplay.Record;
				tmpDisplayName = tmpEntityDisplay.DisplayName;
			}
			catch (pFetchError)
			{
				this.pict.log.warn(`MaterialsEntitySelector[${this._getEntity(pInput)}]: backfill load failed for [${tmpValue}]: ${pFetchError.message || pFetchError}`);
			}
			if (tmpEntity && typeof tmpEntity === 'object' && tmpEntity[this._getRecordIdentity(pInput)])
			{
				if (!pInput.PictForm?.Multiple)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex), tmpEntity);
				}
				const tmpForRender = Object.assign({}, tmpEntity);
				tmpForRender.__Value = tmpValue;
				tmpForRender.__DisplayName = tmpDisplayName;
				tmpLoaded.push(tmpForRender);
			}
		}
		if (tmpLoaded.length > 0)
		{
			this._renderEntitiesToPicker(pInput, tmpLoaded, pRowIndex);
		}
	}

	/**
	 * Pure decision for the de-sync state of a snapshot vs the server record.
	 * @param {Record<string, any>} pSnapshot - the locally-held __Record snapshot
	 * @param {any} pFetched - the freshly-fetched server record (or null/empty if not found)
	 * @param {string} pIdentityField - the record identity field (e.g. GUIDSample)
	 * @return {'stale'|'deleted'|null}
	 */
	_computeDesyncState(pSnapshot, pFetched, pIdentityField)
	{
		if (!pFetched || typeof pFetched !== 'object' || Array.isArray(pFetched) || !pFetched[pIdentityField])
		{
			return 'deleted';
		}
		if (pSnapshot && pSnapshot.UpdateDate && pFetched.UpdateDate && pSnapshot.UpdateDate !== pFetched.UpdateDate)
		{
			return 'stale';
		}
		return null;
	}

	_desyncKey(pInput, pRowIndex)
	{
		return `${pInput.Macro.RawHTMLID}::${(pRowIndex || pRowIndex === 0) ? pRowIndex : '_'}`;
	}

	_desyncState()
	{
		if (!this._recordDesyncState)
		{
			this._recordDesyncState = {};
			this._recordDesyncFetched = {};
		}
		return this._recordDesyncState;
	}

	/**
	 * System 2 de-sync check (opt-in via PictForm.DetectDesync). Asynchronously compares the rendered snapshot
	 * __Record against the server and flags 'stale'/'deleted' without mutating the snapshot. Non-blocking; never
	 * runs on a synthesized (unsaved) record, a multi-select picker, or a frozen document.
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	async _checkRecordDesync(pView, pInput, pRowIndex)
	{
		if (!pInput.PictForm?.DetectDesync || pInput.PictForm?.Multiple || this._isRecordFrozen())
		{
			return;
		}
		const tmpSnapshot = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		if (!tmpSnapshot || typeof tmpSnapshot !== 'object' || Array.isArray(tmpSnapshot))
		{
			return;
		}
		const tmpIdentity = tmpSnapshot[this._getRecordIdentity(pInput)];
		// Only a saved record (has a DB id) is comparable; a synthesized record has nothing on the server yet.
		if (!tmpIdentity || !tmpSnapshot[`ID${this._getEntity(pInput)}`])
		{
			return;
		}
		let tmpFetched = null;
		try
		{
			tmpFetched = await this.pict.providers.Select2Util.getEntityAsync(this._getEntity(pInput), tmpIdentity, Object.assign({ }, this._buildEntityFetchOptions(pInput), { BypassCache: true }));
		}
		catch (pError)
		{
			// Couldn't reach the server (offline): leave the snapshot as-is, raise no false de-sync flag.
			return;
		}
		const tmpKey = this._desyncKey(pInput, pRowIndex);
		const tmpState = this._computeDesyncState(tmpSnapshot, tmpFetched, this._getRecordIdentity(pInput));
		this._desyncState()[tmpKey] = tmpState;
		if (tmpState === 'stale')
		{
			this._recordDesyncFetched[tmpKey] = tmpFetched;
		}
		this._renderDesyncAffordance(pView, pInput, pRowIndex);
	}

	/**
	 * Inject/update the "out of date / no longer exists" affordance next to the picker, reflecting the
	 * transient de-sync state. Clicking it runs the manual refresh. No-op outside a browser.
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	_renderDesyncAffordance(pView, pInput, pRowIndex)
	{
		if (typeof document === 'undefined' || !window['jQuery'])
		{
			return;
		}
		const tmpMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpSelectID = this[tmpMethod](pInput.Macro.RawHTMLID, pRowIndex);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpSelectID);
		const tmpSelectElement = tmpElements && tmpElements[0];
		if (!tmpSelectElement || !tmpSelectElement.parentElement)
		{
			return;
		}
		const tmpState = this._desyncState()[this._desyncKey(pInput, pRowIndex)];
		const tmpAffordanceID = `${tmpSelectID}--desync`.replace(/[^A-Za-z0-9_-]/g, '');
		let tmpAffordance = document.getElementById(tmpAffordanceID);
		if (!tmpState)
		{
			if (tmpAffordance)
			{
				tmpAffordance.remove();
			}
			return;
		}
		if (!tmpAffordance)
		{
			tmpAffordance = document.createElement('a');
			tmpAffordance.id = tmpAffordanceID;
			tmpAffordance.className = 'materials-record-desync is-size-7 has-text-warning';
			tmpAffordance.style.cssText = 'display:block;cursor:pointer;margin-top:2px;';
			tmpAffordance.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				this._refreshRecordManually(pView, pInput, pRowIndex);
			});
			tmpSelectElement.parentElement.appendChild(tmpAffordance);
		}
		tmpAffordance.textContent = tmpState === 'deleted' ? '⚠ This record no longer exists — dismiss' : '↻ Out of date — refresh';
	}

	/**
	 * Manual refresh: apply the freshly-fetched record as the new snapshot and re-sync the autofilled sibling
	 * fields (via _onRecordRefresh), then clear the de-sync flag. A 'deleted' record is simply dismissed,
	 * keeping the last-known snapshot.
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	_refreshRecordManually(pView, pInput, pRowIndex)
	{
		const tmpKey = this._desyncKey(pInput, pRowIndex);
		if (this._desyncState()[tmpKey] === 'stale')
		{
			const tmpFetched = this._recordDesyncFetched[tmpKey];
			if (tmpFetched)
			{
				const tmpAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress, tmpFetched);
				this._onRecordRefresh(pView, pInput, tmpFetched, tmpAddress, this.pict.getUUID(), pRowIndex);
				const tmpEntity = this._getEntity(pInput);
				const tmpGUID = tmpFetched[`GUID${tmpEntity}`];
				if (this._isScopedEntityDataEnabled() && typeof tmpGUID === 'string' && tmpGUID.length > 0)
				{
					EntityDataBaseline.refreshBaselineRecords(this.pict, tmpEntity, [ tmpGUID ]);
				}
			}
		}
		delete this._recordDesyncFetched[tmpKey];
		this._desyncState()[tmpKey] = null;
		this._renderDesyncAffordance(pView, pInput, pRowIndex);
		pView.marshalToView();
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 * @param {boolean} [pUseEntityTag=false]
	 *
	 * @return {string}
	 */
	_formatRecordForDisplay(pRecord, pInput, pUseEntityTag = true)
	{
		const tmpDisplayName = this._getRecordDisplayName(pRecord, pInput);
		// if the EntityTag is defined and the entity has that property, use it for the leading tag in the selection display
		if (pUseEntityTag && pInput.PictForm.EntityTag)
		{
			const tmpTag = pRecord[pInput.PictForm.EntityTag];
			// Suppress the leading tag when it's empty or identical to the name (e.g. Labs whose code IS their
			// name) — it would otherwise render a redundant "(X) X" pill (and the PDF shows only the name).
			if (tmpTag != null && String(tmpTag).trim() !== '' && String(tmpTag).trim() !== String(tmpDisplayName).trim())
			{
				return `${tmpTag}|~|${tmpDisplayName}`;
			}
		}
		return tmpDisplayName;
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		// if an EntityDisplayField is defined, use it
		if (pInput.PictForm.EntityDisplayField && pRecord[pInput.PictForm.EntityDisplayField])
		{
			return pRecord[pInput.PictForm.EntityDisplayField];
		}
		// if a EntityDisplayField is defined with dot notation, use it's child field
		else if (pInput.PictForm.EntityDisplayField && pInput.PictForm.EntityDisplayField.includes('.'))
		{
			const tmpJoinParts = pInput.PictForm.EntityDisplayField.split('.');
			if (tmpJoinParts.length === 2 && pRecord[tmpJoinParts[0]] && pRecord[tmpJoinParts[0]][tmpJoinParts[1]])
			{
				return pRecord[tmpJoinParts[0]][tmpJoinParts[1]];
			}
		}
		return pRecord.__DisplayName || pRecord.DisplayName || pRecord.Name || (`Unnamed ${this._getEntity(pInput)} #` + pRecord[`ID${this._getEntity(pInput)}`]);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, null);
		pValue = this._coerceClearedEntityValue(pView, pInput, pValue, null);
		let tmpNewEntity = false;
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, null, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID);
			tmpNewEntity = true;
		}
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), null, (pRecord) =>
		{
			if (!pRecord && tmpNewEntity)
			{
				const tmpRecordAddress = this._getRecordAddress(pView, pInput);
				const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
				if (tmpRecord)
				{
					this._onRecordRefresh(pView, pInput, tmpRecord, this._getRecordAddress(pView, pInput), pTransactionGUID);
				}
			}
		});
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Cross-field dependency cleanup. When an anchor field this picker depends on
	 * (declared via `PictForm.DynamicFilters[].TriggerGroupHash`) changes, the
	 * value already selected here may no longer belong to the new anchor — so
	 * clear it. The anchor emits the group through Pict-Input-AutofillTriggerGroup
	 * (`TriggerAllInputs: true`); this handler receives it like every other input.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pEvent - global event payload, e.g. `TriggerGroup:<hash>:DataChange:<emitter>:<uuid>`
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpMatchedFilter = this._matchedDynamicFilterForEvent(pInput, pEvent);
		if (tmpMatchedFilter && (!pInput.PictForm?.SmartClear || this._isSelectionIllegalForFilter(pView, pInput, tmpMatchedFilter, null)))
		{
			this._clearForDynamicFilter(pView, pInput, null);
		}
		// Autofill scope vetting (opt-in via PictForm.VetAutofillScope): when an autofill from a non-projection
		// source lands a value illegal for THIS picker's own Through filter, suppress it. Async — the Through
		// slice primes on demand, so it runs after the sync autofill has landed the value. Fail-open throughout.
		if (pInput.PictForm?.VetAutofillScope && !this.pict._MaterialsEntityHydrationDepth && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, null).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		// Warm any query-strategy Through slice for the new anchor value so a
		// dependent picker's INN clause resolves synchronously once it is opened.
		this.pict.providers.ThroughScopeResolver?.primeQueryScopesFromForm?.();
		// Re-prime lab scoping — the project or the selected-test set may have changed. Idempotent: only re-fetches
		// (ProjectLabJoin + batched TestLabJoin) when the (project, test-set) key actually changes.
		this.pict.providers.LabScopeResolver?.primeFromForm?.();
		this._handleBaseSaveProjectionEvent(pView, pInput, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Pure: does a global event target one of this input's DynamicFilters?
	 * Returns the matching filter entry, or null. Self-emitted events are ignored.
	 *
	 * @param {Object} pInput
	 * @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEvent(pInput, pEvent)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters))
		{
			return null;
		}
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup')
		{
			return null;
		}
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash)
		{
			return null;
		}
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Tabular sibling of `_matchedDynamicFilterForEvent`. A tabular anchor fires a
	 * ROW-SCOPED event (`TriggerGroup:<hash>:RecordRefresh:<emitter>:<rowIndex>:<uuid>`,
	 * see _onRecordRefresh). The global broadcast delivers it to EVERY row's
	 * onAfterEventTabularCompletion, so a dependent column must act on its own row
	 * ONLY — otherwise changing one row's Source would wipe valid selections in every
	 * other row. We therefore require the event's row index (slot [4]) to equal this
	 * picker's `pRowIndex`. A global (non-row-scoped) event has a UUID in slot [4],
	 * which `parseInt` yields NaN for, so it never matches here.
	 *
	 * @param {Object} pInput
	 * @param {string} pEvent
	 * @param {number} pRowIndex - this picker's row
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters))
		{
			return null;
		}
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup')
		{
			return null;
		}
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		const tmpEventRowIndex = parseInt(tmpParts[4], 10);
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash)
		{
			return null;
		}
		// Only row-scoped events carry an integer row index here; require it to be OUR row.
		if (isNaN(tmpEventRowIndex) || tmpEventRowIndex !== Number(pRowIndex))
		{
			return null;
		}
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Tabular sibling of onAfterEventCompletion: when an anchor in THIS row changes,
	 * clear this row's now-orphaned selection so it can't keep a value that no longer
	 * belongs to the new anchor. The next dropdown open re-fetches with the updated
	 * per-row FromRowField filter.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpMatchedFilter = this._matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex);
		if (tmpMatchedFilter && (!pInput.PictForm?.SmartClear || this._isSelectionIllegalForFilter(pView, pInput, tmpMatchedFilter, pRowIndex)))
		{
			this._clearForDynamicFilter(pView, pInput, pRowIndex);
		}
		// Autofill scope vetting (opt-in) — tabular sibling; vet only this row's autofilled value. Async / fail-open.
		if (pInput.PictForm?.VetAutofillScope && !this.pict._MaterialsEntityHydrationDepth && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		this._handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Smart-clear gate (opt-in via `PictForm.SmartClear`). Returns true only when this picker's resolved
	 * record is DEFINITIVELY illegal for the changed anchor — the record carries the filter's `Field` and
	 * its value no longer equals the anchor's current value. When the record isn't resolved yet, lacks the
	 * FK, or the anchor is unset, illegality can't be proven, so we keep the value: this avoids clobbering a
	 * just-autofilled selection during sample projection, and preserves a user override that sits outside
	 * the filter. (Without this, plain always-clear on the anchor's trigger group would wipe a Product/
	 * MixDesign that a sample selection is concurrently projecting.)
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {object} pFilter - the matched DynamicFilters entry (`{ Field, FromField | FromRowField, ... }`).
	 * @param {number|null} [pRowIndex]
	 * @return {boolean} true only when the current selection is provably illegal for pFilter.
	 */
	_isSelectionIllegalForFilter(pView, pInput, pFilter, pRowIndex)
	{
		if (!pFilter || !pFilter.Field)
		{
			return false;
		}
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !(pFilter.Field in tmpRecord))
		{
			return false;
		}
		let tmpAnchorValue;
		if (pFilter.FromRowField && pRowIndex != null && pInput.PictForm && pInput.PictForm.InformaryContainerAddress)
		{
			const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pFilter.FromRowField);
			tmpAnchorValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
		}
		else if (pFilter.FromField)
		{
			tmpAnchorValue = this.pict.manifest.getValueByHash(this.pict, pFilter.FromField);
		}
		else
		{
			return false;
		}
		// An unset anchor imposes no constraint (applyDynamicFilters omits it), so nothing is illegal.
		const tmpAnchorNormalized = (tmpAnchorValue === null || tmpAnchorValue === undefined) ? '' : String(tmpAnchorValue).trim();
		if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0')
		{
			return false;
		}
		return String(tmpRecord[pFilter.Field]) !== tmpAnchorNormalized;
	}

	/**
	 * Pure: does a global event correspond to an AUTOFILL into this input (an AutofillTriggerGroup entry whose
	 * TriggerGroupHash matches the event)? Returns the matched entry, or null. Self-emitted events, and entries
	 * flagged `AllowInvalidProjection`, are skipped — the latter marks record-projection sources (e.g. linking a
	 * saved sample) that legitimately carry pre-existing, possibly out-of-scope values that must not be vetted.
	 *
	 * @param {Object} pInput
	 * @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedAutofillGroupForEvent(pInput, pEvent)
	{
		let tmpGroups = (pInput && pInput.PictForm) ? pInput.PictForm.AutofillTriggerGroup : null;
		if (!tmpGroups)
		{
			return null;
		}
		if (!Array.isArray(tmpGroups))
		{
			tmpGroups = [ tmpGroups ];
		}
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup')
		{
			return null;
		}
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash)
		{
			return null;
		}
		return tmpGroups.find((pGroup) => pGroup && pGroup.TriggerGroupHash === tmpGroupHash && !pGroup.AllowInvalidProjection) || null;
	}

	/**
	 * Vet this picker's current value against its own Through DynamicFilters and suppress it when it is
	 * PROVABLY not a legal option — the selected `ThroughSelect` id is absent from the resolved allowed set for
	 * the current anchor. Fail-open everywhere else: no anchor, an unprimed/unresolved scope (getThroughIDs
	 * null), or no value all KEEP the value. Async because query-strategy Through slices load on demand — which
	 * also means it runs after the synchronous autofill has landed the value. Rejects an autofill (e.g.
	 * Plant → Producer) that lands an org outside the material-scoped supplier set; a plain user pick is always
	 * in-scope, and record-projection sources are excluded upstream via `_matchedAutofillGroupForEvent`.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|null} [pRowIndex]
	 * @return {Promise<void>}
	 */
	async _vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex)
	{
		const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
		const tmpResolver = this.pict.providers.ThroughScopeResolver;
		if (!Array.isArray(tmpFilters) || !tmpResolver)
		{
			return;
		}
		const tmpThroughFilters = tmpFilters.filter((pFilter) => pFilter && pFilter.Through && pFilter.ThroughSelect && pFilter.FromField);
		if (!tmpThroughFilters.length)
		{
			return;
		}
		const tmpDestination = pView.getMarshalDestinationObject();
		for (const tmpFilter of tmpThroughFilters)
		{
			const tmpAnchor = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			const tmpAnchorNormalized = (tmpAnchor === null || tmpAnchor === undefined) ? '' : String(tmpAnchor).trim();
			if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0')
			{
				continue;
			}
			const tmpRecord = this.pict.manifest.getValueAtAddress(tmpDestination, this._getRecordAddress(pView, pInput, pRowIndex));
			let tmpSelected = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[tmpFilter.ThroughSelect] : null;
			if ((tmpSelected === null || tmpSelected === undefined || tmpSelected === '') && pRowIndex == null)
			{
				tmpSelected = this.pict.manifest.getValueAtAddress(tmpDestination, pInput.DataAddress);
			}
			if (tmpSelected === null || tmpSelected === undefined || tmpSelected === '' || Number(tmpSelected) === 0)
			{
				continue;
			}
			await tmpResolver.primeThroughSlice(tmpFilter, tmpAnchor);
			const tmpAllowed = tmpResolver.getThroughIDs(tmpFilter, tmpAnchor);
			// Fail-open backstop: an empty allowed set means the scope couldn't be resolved (sparse/missing
			// OrganizationMaterialJoin data, or a failed prime) — treat that as "can't constrain", not "everything
			// is illegal". Clearing on an empty set would nuke a legitimately-chosen value. A genuinely-scoped
			// anchor returns a non-empty set and still clears an out-of-scope value below.
			if (!tmpAllowed || typeof tmpAllowed.has !== 'function' || tmpAllowed.size === 0)
			{
				continue;
			}
			if (!tmpAllowed.has(Number(tmpSelected)))
			{
				this._clearForDynamicFilter(pView, pInput, pRowIndex);
				return;
			}
		}
	}

	/**
	 * Reset this picker's value and its resolved-record companion (`__Record`),
	 * then re-marshal so the select2 reflects the cleared state. `__Record` is
	 * reset to an empty object (not deleted) to match the selector convention —
	 * new-record flows write fields into it and assume it is always an object.
	 * The next dropdown open re-fetches with the updated DynamicFilters (the new
	 * anchor value), so neither a stale selection nor a stale resolved record
	 * survives an anchor change.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|null} [pRowIndex]
	 */
	_clearForDynamicFilter(pView, pInput, pRowIndex)
	{
		try
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex, '__Record');
			// Reset the value and its resolved-record companion. __Record is reset to
			// an EMPTY OBJECT (not undefined/deleted) to match the selector convention:
			// downstream flows write fields into __Record and assume it is always an
			// object (e.g. new-record creation in MaterialsSampleSelector, which sets
			// tmpRecord.Status on SampleStatusChanged).
			this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, {});
			if (pRowIndex != null)
			{
				// Tabular: clear ONLY this row's cell + its own select2 instance.
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pInput.Default ?? '');
				const tmpTabularSelectID = this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex);
				if (window['jQuery'] && window['jQuery'](tmpTabularSelectID).data('select2'))
				{
					window['jQuery'](tmpTabularSelectID).val(null).empty().trigger('change.select2');
				}
				pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
			}
			else
			{
				pView.setDataByInput(pInput, pInput.Default ?? '');
				const tmpSelectID = this.getSelectInputHTMLID(pInput.Macro.RawHTMLID);
				if (window['jQuery'] && window['jQuery'](tmpSelectID).data('select2'))
				{
					window['jQuery'](tmpSelectID).val(null).empty().trigger('change.select2');
				}
				pView.manualMarshalDataToViewByInput(pInput);
			}
			this.pict.log.info(`DynamicFilter: cleared dependent input [${pInput.Hash}]${pRowIndex != null ? ` row ${pRowIndex}` : ''} after its anchor changed.`);
		}
		catch (pError)
		{
			this.pict.log.error(`DynamicFilter: failed to clear dependent input [${pInput && pInput.Hash}]: ${pError}`);
		}
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, pRowIndex);
		pValue = this._coerceClearedEntityValue(pView, pInput, pValue, pRowIndex);
		let tmpNewEntity = false;
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
			tmpNewEntity = true;
		}
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), pRowIndex, (pRecord) =>
		{
			if (!pRecord && tmpNewEntity)
			{
				const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
				if (tmpRecord)
				{
					this._onRecordRefresh(pView, pInput, tmpRecord, this._getRecordAddress(pView, pInput), pTransactionGUID);
				}
			}
		});
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	_translateRecordTemplateFields(pRecord)
	{
		for (const tmpField in pRecord)
		{
			if (typeof pRecord[tmpField] === 'string')
			{
				pRecord[tmpField] = this.pict.parseTemplate(pRecord[tmpField], this.pict);
			}
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string|number} pIDValue
	 * @param {string} pEntity
	 * @param {string} pTransactionGUID - A transaction GUID to associate with this operation.
	 * @param {string} [pRecordIdentityField]
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 * @param {(pRecord: Record<string, any>) => void} [fCallback] - (optional) A callback function to be called after the record is refreshed.
	 */
	/**
	 * Whether the document is frozen (read-only / Locked). A frozen document always uses the persisted
	 * snapshot — System 2 never refreshes it. Same lock signal the sibling selectors gate interactivity on.
	 * @return {boolean}
	 */
	_isRecordFrozen()
	{
		return !this.pict?.AppData?.Interactive || !!this.pict?.AppData?.DocumentData?.ReportData?.Locked;
	}

	/**
	 * Whether a record fetch has been overtaken: the input's committed value no longer names the ids the
	 * fetch asked for. A value nobody has written yet is no evidence either way, so it never counts as stale.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {any} pRequestedValue - The value the fetch was issued for.
	 * @return {boolean}
	 */
	_isStaleRecordRefresh(pView, pInput, pRowIndex, pRequestedValue)
	{
		const tmpCurrentValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pView, pInput, pRowIndex));
		if (tmpCurrentValue === undefined || tmpCurrentValue === null)
		{
			return false;
		}
		const tmpCurrent = toIdentitySet(tmpCurrentValue);
		const tmpRequested = toIdentitySet(pRequestedValue);
		if (tmpCurrent.size !== tmpRequested.size)
		{
			return true;
		}
		for (const tmpIdentity of tmpRequested)
		{
			if (!tmpCurrent.has(tmpIdentity))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * Fetch the record(s) behind a value and cascade them. A response that arrives after the value has moved on
	 * is discarded without writing the record, cascading or calling fCallback; the async operation still completes.
	 * @param {Object} pView @param {Object} pInput @param {any} pIDValue @param {string} pEntity
	 * @param {string} pTransactionGUID @param {string} [pRecordIdentityField] @param {number|string|null} [pRowIndex]
	 * @param {(pRecord: any) => void} [fCallback]
	 */
	_refreshRecord(pView, pInput, pIDValue, pEntity, pTransactionGUID, pRecordIdentityField, pRowIndex, fCallback)
	{
		const tmpRefreshEvent = `${pEntity}Refresh`;
		pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pIDValue)
		{
			// if we don't have an ID value, we should clear out any existing record at this address and fire the change event with an empty record
			// rather than go do a fetch with an empty or undefined ID which is wasteful
			const tmpRecordPayload = pInput.PictForm.Multiple ? [] : { };
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress, tmpRecordPayload);
			this._onRecordRefresh(pView, pInput, tmpRecordPayload, tmpRecordAddress, pTransactionGUID, pRowIndex);
			if (typeof fCallback === 'function')
			{
				fCallback(tmpRecordPayload);
			}
			pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			return;
		}
		const tmpRecordIdentityField = pRecordIdentityField || `ID${pEntity}`;
		// Refresh by default: re-fetch the latest record on open. Two cases keep the persisted snapshot instead (when
		// it already matches the value): a frozen document (read-only / Locked), or a field that explicitly opts out
		// with PictForm.RefreshOnOpen === false. A changed selection never matches the snapshot, so it always loads.
		const tmpExistingRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!pInput.PictForm?.Multiple && tmpExistingRecord && typeof tmpExistingRecord === 'object' && !Array.isArray(tmpExistingRecord) &&
			tmpExistingRecord[tmpRecordIdentityField] == pIDValue && (this._isRecordFrozen() || pInput.PictForm?.RefreshOnOpen === false))
		{
			this._onRecordRefresh(pView, pInput, tmpExistingRecord, tmpRecordAddress, pTransactionGUID, pRowIndex);
			if (typeof fCallback === 'function')
			{
				fCallback(tmpExistingRecord);
			}
			pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			return;
		}
		const fOnRecords = (pError, pRecords) =>
		{
			// The value moved on while this fetch was in flight; the refresh for the current value owns the record.
			if (this._isStaleRecordRefresh(pView, pInput, pRowIndex, pIDValue))
			{
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
				return;
			}
			if (pError || !Array.isArray(pRecords))
			{
				this.pict.log.error(`Error fetching ${pEntity} record with ${tmpRecordIdentityField} = ${pIDValue}: ${pError || 'No records found'}`);
				if (typeof fCallback === 'function')
				{
					fCallback(null);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
				return;
			}
			let tmpRecordPayload;
			if (pInput.PictForm.Multiple)
			{
				tmpRecordPayload = this._alignRecordsToRequestedValues(pRecords || [], pIDValue, tmpRecordIdentityField, pEntity);
			}
			else
			{
				if (pRecords.length > 1)
				{
					this.pict.log.warn(`Multiple ${pEntity} records found with ${tmpRecordIdentityField} = ${pIDValue}. Using the first record.`);
				}
				const tmpHeldRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
				tmpRecordPayload = pRecords[0] ? this._reconcileRefreshedRecord(pView, pInput, tmpHeldRecord, pRecords[0], tmpRecordIdentityField, pIDValue, pRowIndex) : (tmpHeldRecord || { });
			}
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress, tmpRecordPayload);
			this._onRecordRefresh(pView, pInput, tmpRecordPayload, tmpRecordAddress, pTransactionGUID, pRowIndex);
			if (typeof fCallback === 'function')
			{
				fCallback(tmpRecordPayload);
			}
			pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
		};
		if (libSharedEntityRead.isEmptyIdentityValue(tmpRecordIdentityField, pIDValue))
		{
			fOnRecords(null, [ ]);
			return;
		}
		libSharedEntityRead.readJSON(this.pict, `${pEntity}s/FilteredTo/FBL~${tmpRecordIdentityField}~INN~${encodeURIComponent(pIDValue)}`, { ReuseResult: false }, fOnRecords);
	}

	/**
	 * Choose what a single-record refresh writes: the server row, or the record the form already holds.
	 *
	 * A re-fetch of the record already selected is server state, not an edit, so the baseline moves with
	 * the fields the server changed (`EntityDataBaseline.classifyRecordRefresh`). When the held record
	 * carries a change the server does not have yet, the row is not written; the record is flagged out of
	 * date instead, and the manual refresh stays the user's choice. A changed selection always takes the row.
	 * `MaterialsCascadePicker._reconcileRefreshedRecord` is the Picker family's copy; the two must agree.
	 *
	 * @param {Object} pView @param {Object} pInput
	 * @param {Record<string, any>|null} pHeldRecord - The record at the address when the row arrived.
	 * @param {Record<string, any>} pFetchedRecord - The server row.
	 * @param {string} pRecordIdentityField @param {any} pIDValue @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>} - The record to write.
	 */
	_reconcileRefreshedRecord(pView, pInput, pHeldRecord, pFetchedRecord, pRecordIdentityField, pIDValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !pHeldRecord || typeof pHeldRecord !== 'object' || Array.isArray(pHeldRecord) || pHeldRecord[pRecordIdentityField] != pIDValue)
		{
			return pFetchedRecord;
		}
		const tmpEntity = this._getEntity(pInput);
		const tmpGUID = pFetchedRecord[`GUID${tmpEntity}`] || pHeldRecord[`GUID${tmpEntity}`];
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpDecision = EntityDataBaseline.classifyRecordRefresh(this.pict, tmpContext, tmpEntity, tmpGUID, pHeldRecord, pFetchedRecord);
		if (tmpDecision.Action === 'keep')
		{
			this.pict.log.info(`MaterialsEntitySelector: kept the held ${tmpEntity} ${tmpGUID} over the server row: ${tmpDecision.Reason}.`);
			const tmpKey = this._desyncKey(pInput, pRowIndex);
			this._desyncState()[tmpKey] = 'stale';
			this._recordDesyncFetched[tmpKey] = pFetchedRecord;
			this._renderDesyncAffordance(pView, pInput, /** @type {number} */ (pRowIndex));
			return pHeldRecord;
		}
		if (tmpDecision.Action === 'adopt')
		{
			EntityDataBaseline.adoptRefreshedFields(this.pict, tmpContext, tmpEntity, tmpGUID, pFetchedRecord, tmpDecision.Fields);
		}
		return pFetchedRecord;
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - A transaction GUID to associate with this operation.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpEvent = `${this._getEntity(pInput)}Changed:${this._getTrackingGUID(pInput, pRowIndex)}:${this._getRecordAddress(pView, pInput, pRowIndex)}`;
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, pTransactionGUID);
		if (pInput.PictForm.FireTriggerGroupOnRecordRefresh)
		{
			const tmpEmitterHash = pInput.Hash || pInput.DataAddress;
			// Hydration guard: this record-refresh fan-out is a SYNCHRONOUS cascade (the trigger group plus every
			// sibling autofill it emits). A load is authoritative — persisted values must display, not be re-vetted
			// against the current filter scope — so mark the fan-out; the autofill-scope vet skips while it is set
			// (see onAfterEventCompletion / onAfterEventTabularCompletion). Counter handles re-entrant refreshes;
			// finally guarantees reset even if a handler throws.
			this.pict._MaterialsEntityHydrationDepth = (this.pict._MaterialsEntityHydrationDepth || 0) + 1;
			try
			{
				if (pRowIndex != null)
				{
					// Tabular anchor: include the emitting row index so a dependent picker
					// clears ONLY its own row, not every row of the table (see
					// _matchedDynamicFilterForEventTabular). The global broadcast still fans
					// this out to every row's onAfterEventTabularCompletion; the row index in
					// slot [4] is what lets each row decide whether the change was its own.
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${pRowIndex}:${this.pict.getUUID()}`);
				}
				else
				{
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${this.pict.getUUID()}`);
				}
			}
			finally
			{
				this.pict._MaterialsEntityHydrationDepth--;
			}
		}
	}

	/**
	 * Fire the save-time EntityData projection when this provider has at least one creation-enabled
	 * input (latched in _isEntityCreationEnabled). Mirrors the trigger the Test selector owns, so a
	 * creating base selector persists its records on a form with no Test selector present. Providers'
	 * onBeforeSaveDataAsync run once each, sequentially (Anticipate waterfall ordered by
	 * AutoSaveDataOrdinal); when both this and the Test selector are present each fires once and every
	 * projector re-collects from its current __Record, so the redundant pass is idempotent. No-op (and
	 * no empty _EntityData reset) for a provider with no creation-enabled input — default behavior.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (!this._entityCreationEnabled)
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}
		if (!this._isScopedEntityDataEnabled())
		{
			this.pict.manifest.setValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.FormData._EntityData', { });
		}
		const tmpEvent = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';
		const tmpTransactionGUID = this.pict.getUUID();
		/** @type {any} */ (this.pict).TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this._sanitizeProjectedComprehensions();
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * The object this input projects its created records into on the save sweep, keyed
	 * `<Entity>.<GUID>`. THE ONE PLACE the scoped/legacy decision is made on the emission side: the
	 * projectors below take the object and are identical on both paths, because a context root and
	 * the legacy ledger have the same shape.
	 *
	 * Scoped roots are remembered for the post-sweep sanitize pass.
	 *
	 * @param {Object} pInput - The form input descriptor.
	 * @param {string} pEvent - The sweep event.
	 * @return {Record<string, any>|null} - The projection target, or null when this is not a sweep
	 *   event or no target resolves (never fabricates one).
	 */
	_getProjectionTarget(pInput, pEvent)
	{
		if (typeof pEvent !== 'string')
		{
			return null;
		}
		const [ tmpEventType, tmpTargetAddress ] = pEvent.split(':');
		if (tmpEventType !== 'ProjectEntityDataRecords')
		{
			return null;
		}
		if (this._isScopedEntityDataEnabled())
		{
			const tmpContext = this._getComprehensionContext(pInput);
			const tmpContextRoot = ScopedEntityData.resolveContextRoot(this.pict, tmpContext);
			// A baseline sweep collects into a detached scratch tree: nothing was emitted, so neither the
			// FormEntityCreator cross-check nor the post-sweep delta pass may be armed by it.
			if (tmpContextRoot && !ScopedEntityData.getBaselineSweepTarget(this.pict))
			{
				ScopedEntityData.markActive(this.pict);
				if (!this._scopedProjectionRoots)
				{
					this._scopedProjectionRoots = new Map();
				}
				this._scopedProjectionRoots.set(tmpContext, tmpContextRoot);
			}
			return tmpContextRoot;
		}
		if (!tmpTargetAddress)
		{
			return null;
		}
		const tmpTarget = this.pict.manifest.getValueAtAddress(this.pict, tmpTargetAddress);
		if (!tmpTarget || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return null;
		}
		return tmpTarget;
	}

	/**
	 * Narrow every scoped root this provider projected into during the sweep: strip transient `__` UI
	 * state, then reduce each record to what changed since the baseline. Runs once, after the sweep,
	 * rather than at each write — the projectors key the form's LIVE record objects in, so acting
	 * earlier would either mutate the record the form renders from or force every projector to clone.
	 */
	_sanitizeProjectedComprehensions()
	{
		// Also the roots the picker family noted (this family never notes any): on a form that runs the
		// pickers, this provider's sweep re-projects their records and would otherwise send them whole.
		const tmpRoots = new Map(this._scopedProjectionRoots || []);
		for (const [ tmpContext, tmpContextRoot ] of ScopedEntityData.takeNotedProjectionRoots(this.pict))
		{
			tmpRoots.set(tmpContext, tmpContextRoot);
		}
		if (tmpRoots.size < 1)
		{
			return;
		}
		// Handed to the document save, which folds every provider's emission ONCE just before the PUT.
		// Folding here instead would advance the baseline mid-save, and the next provider's prune over
		// this same root would then suppress every record and send an empty comprehension.
		const tmpEmitted = new Map();
		for (const [ tmpContext, tmpContextRoot ] of tmpRoots)
		{
			EntityDataBaseline.pruneContextRootToDelta(this.pict, tmpContext, tmpContextRoot);
			tmpEmitted.set(tmpContext, tmpContextRoot);
		}
		if (this._scopedProjectionRoots)
		{
			this._scopedProjectionRoots.clear();
		}
		tmpEmitted.forEach((pContextRoot, pContext) => EntityDataBaseline.recordPendingEmission(this.pict, pContext, pContextRoot));
	}

	/**
	 * Ask for the load-settled baseline capture on this render transaction. Idempotent across every
	 * input on the form and across both input families — the first to ask schedules it.
	 * @param {Object} pView @param {string} pTransactionGUID
	 */
	_scheduleBaselineCapture(pView, pTransactionGUID)
	{
		if (!this._isScopedEntityDataEnabled())
		{
			return;
		}
		EntityDataBaseline.scheduleLoadBaselineCapture(this.pict, pView, pTransactionGUID);
	}


	/**
	 * Generic save-time projection handler. On the ProjectEntityDataRecords sweep, write this input's
	 * created __Record into the target _getProjectionTarget resolved (keyed by GUID<Entity> inside
	 * _syncRecordToEntityData), plus any sibling DocumentPolyJoin. Opt-in via AllowEntityCreation;
	 * opt-out per input via SkipEntityDataProjection. No-op for non-creating selectors, so default
	 * behavior is unchanged. _syncRecordToEntityData itself no-ops unless the record carries a
	 * GUID<Entity>, a second safety gate. Subclasses that already project via their own _handleEvent
	 * (e.g. Sample) re-run this idempotently through super — same target object, same GUID key.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string' || !this._isEntityCreationEnabled(pInput) || pInput?.PictForm?.SkipEntityDataProjection)
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpDocumentPolyJoinAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${tmpRecordAddress}_DocumentPolyJoin`;
		const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
		if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
		{
			if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
			{
				tmpTarget.DocumentPolyJoin = { };
			}
			tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
		}
	}

	/**
	 * Whether this provider emits scoped `Document.EntityData` comprehensions instead of the legacy
	 * `FormData._EntityData` ledger. The same flag stands `FormEntityCreator` down, so the two
	 * paths never run together.
	 * @return {boolean}
	 */
	_isScopedEntityDataEnabled()
	{
		return ScopedEntityData.isEnabled(this.pict);
	}

	/**
	 * The trigger context this input's records are applied under. Scheduling is manifest data:
	 * `PictForm.ComprehensionContext` selects it, the provider default (`OnSave`) applies otherwise.
	 * @param {Object} pInput
	 * @return {string}
	 */
	_getComprehensionContext(pInput)
	{
		return ScopedEntityData.resolveContext(pInput, this.options?.ComprehensionContext || ScopedEntityData.DEFAULT_CONTEXT);
	}


	/**
	 * Whether a sample-join refresh may rewrite this input's joins. A frozen document keeps the joins it
	 * saved; an input that must follow the database even then sets `PictForm.RefreshJoinsWhenLocked: true`.
	 * @param {Object} pInput
	 * @return {boolean}
	 */
	_shouldRefreshSampleJoins(pInput)
	{
		return !this._isRecordFrozen() || pInput?.PictForm?.RefreshJoinsWhenLocked === true;
	}

	/**
	 * The empty-result branch of a sample-join refresh: drop the held joins whose rows were soft-deleted
	 * since the document was saved, and their values from the selection. Only a row read back as deleted
	 * is dropped (`ScopedEntityData.resolveSoftDeletedJoins`); anything else keeps the persisted value. The
	 * drop is a load, so no deletion is staged, and it re-salts the input so a re-add mints a GUID the
	 * deleted row does not own. An input with `RefreshOnOpen: false` keeps its saved snapshot.
	 *
	 * The drop is applied to the joins and value the input holds when the reads settle
	 * (`ScopedEntityData.applySoftDeletedDrop`), not to the ones it started from, so a refresh that landed
	 * meanwhile is not undone and an overlapping drop that already removed the links writes nothing.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {{ Entity: string, ValueField: string, JoinAddress: string, Value: any, Label: string }} pJoinScope
	 * @param {(pDropped: number) => void} fDone - Called once, after any write, with the number of held links
	 *   found deleted.
	 */
	_dropSoftDeletedHeldJoins(pView, pInput, pRowIndex, pJoinScope, fDone)
	{
		if (pInput.PictForm?.RefreshOnOpen === false)
		{
			return fDone(0);
		}
		const tmpHeldJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), pJoinScope.JoinAddress);
		ScopedEntityData.resolveSoftDeletedJoins(this.pict, pJoinScope.Entity, pJoinScope.ValueField, tmpHeldJoins, pJoinScope.Value, (pResult) =>
		{
			if (pResult.Dropped.length < 1)
			{
				return fDone(0);
			}
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpDrop = ScopedEntityData.applySoftDeletedDrop(pJoinScope.Entity, pJoinScope.ValueField,
				this.pict.manifest.getValueAtAddress(tmpDestination, pJoinScope.JoinAddress),
				this.pict.manifest.getValueAtAddress(tmpDestination, this._getValueAddress(pView, pInput, pRowIndex)),
				pResult);
			if (!tmpDrop.Changed)
			{
				return fDone(pResult.Dropped.length);
			}
			ScopedEntityData.beginProgrammaticLoad(this.pict);
			try
			{
				if (tmpDrop.Removed.length > 0)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, pJoinScope.JoinAddress, tmpDrop.Joins);
				}
				const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpHeldRecords = this.pict.manifest.getValueAtAddress(tmpDestination, tmpRecordAddress);
				const tmpKeptRecords = ScopedEntityData.pruneRecordsToValue(tmpHeldRecords, pJoinScope.ValueField, tmpDrop.Value);
				if (tmpKeptRecords !== tmpHeldRecords)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, tmpKeptRecords);
				}
				if (tmpDrop.ValueChanged)
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpDrop.Value);
					}
					else
					{
						pView.setDataByInput(pInput, tmpDrop.Value);
					}
				}
			}
			finally
			{
				ScopedEntityData.endProgrammaticLoad(this.pict);
			}
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			this.log.info(`${pJoinScope.Label}: dropped ${tmpDrop.Removed.length} link(s) whose record was deleted since the document was saved: ${pResult.Dropped.join(', ')}; value now [${tmpDrop.Value}].`);
			return fDone(pResult.Dropped.length);
		});
	}

	/**
	 * A creation-enabled selection was cleared. Two things follow, both only under the scoped path:
	 * tombstones for the rows this selector owns (`_collectRemovedDependentRecords`; never the selected
	 * record itself), and a FRESH `__Salt` so a re-add mints a NEW GUID — an upsert cannot un-delete a
	 * soft-deleted row, so re-using the GUID would upsert into the tombstoned row. No-op unless the
	 * cleared record actually carried its client GUID.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} [pRowIndex]
	 */
	_handleEntitySelectionCleared(pView, pInput, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !this._isEntityCreationEnabled(pInput))
		{
			return;
		}
		const tmpEntity = this._getEntity(pInput);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		const tmpGUID = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[`GUID${tmpEntity}`] : null;
		if (!tmpGUID)
		{
			return;
		}
		this._stageRemovalTombstones(pInput, this._collectRemovedDependentRecords(pView, pInput, pRowIndex, new Set()), 'clear');
		this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
	}

	/**
	 * Stage tombstones for a set of removed records and report what happened. Every removal route in
	 * this family funnels through here, so the gates (persisted, document-owned) and the logging are
	 * applied once. A record the guard would refuse is logged at debug and NOT staged — see
	 * `docs/plans/entitydata-round2/05-client-delete-completeness.md` §4.
	 * @param {Object} pInput @param {Array<{ Entity: string, Record: Record<string, any> }>} pRemovals
	 * @param {string} pReason - What removed them, for the log line.
	 * @return {number} - How many tombstones were staged.
	 */
	_stageRemovalTombstones(pInput, pRemovals, pReason)
	{
		if (!this._isScopedEntityDataEnabled() || !Array.isArray(pRemovals) || pRemovals.length < 1)
		{
			return 0;
		}
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, tmpContext, pRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`MaterialsEntitySelector[${pInput.Hash || pInput.DataAddress}]: staged deletion of ${tmpResult.Staged.length} record(s) on ${pReason}.`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * The identity values a committed selection retains, as a Set of strings. The value list IS the
	 * identity list for a Multiple selector (`_alignRecordsToRequestedValues` depends on the same
	 * property).
	 * @param {any} pValue @return {Set<string>}
	 */
	_getRetainedIdentitySet(pValue)
	{
		const tmpRetained = new Set();
		if (pValue == null || pValue === '')
		{
			return tmpRetained;
		}
		for (const tmpToken of String(pValue).split(','))
		{
			const tmpTrimmed = tmpToken.trim();
			if (tmpTrimmed.length > 0)
			{
				tmpRetained.add(tmpTrimmed);
			}
		}
		return tmpRetained;
	}

	/**
	 * The rows this selector owns for a de-selected value — the rows correlated to its selection, never the
	 * selected record. Subclasses declare their own (TestInstance units, `SampleLabJoin`s, `SampleLineItemJoin`s);
	 * the base owns the document's `DocumentPolyJoin` to the selection, which goes when nothing stays selected.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities - The identities still selected.
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		if (pRetainedIdentities.size > 0)
		{
			return [ ];
		}
		const tmpAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${this._getRecordAddress(pView, pInput, pRowIndex)}_DocumentPolyJoin`;
		return ScopedEntityData.collectTestInstanceUnit({ DocumentPolyJoin: this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress) });
	}

	/**
	 * The de-selection seam. A Multiple selector expresses removal by committing a SHORTER value
	 * list, which `_pruneUnselectedOptions` then reflects in the DOM and `_refreshRecord` replaces
	 * `__Record` from — so the only moment the dropped records still exist is before that runs.
	 *
	 * Suppressed during a programmatic load: `setDataByInput` routes into `onDataChange`, so an
	 * adoption (`_loadSampleTests`) or a `SampleChanged` re-bind arrives here looking exactly like a
	 * user de-selection. Those detach records from the form without removing them from the sample,
	 * which is why they must stage nothing.
	 *
	 * Anything removed also rotates `__Salt`, so a later re-add of the same value mints a new GUID
	 * rather than the removed row's. Kept records carry their stored GUIDs and are never re-derived
	 * from the salt, so the rotation only reaches records minted after it.
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 */
	_handleSelectionRemovals(pView, pInput, pValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || ScopedEntityData.isProgrammaticLoad(this.pict))
		{
			return;
		}
		const tmpRetained = this._getRetainedIdentitySet(pValue);
		const tmpRemovals = this._collectRemovedDependentRecords(pView, pInput, pRowIndex, tmpRetained);
		this._stageRemovalTombstones(pInput, tmpRemovals, 'de-selection');
		if (tmpRemovals.length > 0)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Record<string, Record<string, any>>} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntity = this._getEntity(pInput);
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !tmpRecord[`GUID${tmpEntity}`])
		{
			return;
		}
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		if (!tmpEntityData[tmpEntity] || typeof tmpEntityData[tmpEntity] !== 'object' || Array.isArray(tmpEntityData[tmpEntity]))
		{
			tmpEntityData[tmpEntity] = { };
		}
		tmpEntityData[tmpEntity][tmpRecord[`GUID${tmpEntity}`]] = tmpRecord;
	}

	/**
	 * Remove only the <option>s that are no longer selected, leaving the rest untouched.
	 *
	 * The multi-select marshal used to `.empty()` the whole element and let
	 * _renderEntitiesToPicker rebuild it. Functionally fine, visually not: select2 repaints
	 * from the element, so every tag vanishes and comes back -- and the marshal fan-out runs
	 * it several times per change.
	 *
	 * Pruning is the half `.empty()` was actually needed for (dropping de-selected values);
	 * adding back is already _renderEntitiesToPicker's job and it appends only what is
	 * missing. Doing both incrementally means the picker is never empty.
	 *
	 * @param {string} pSelector - The select element's selector.
	 * @param {Array<string>} pValues - The values that should remain.
	 * @return {number} - How many options were removed.
	 */
	_pruneUnselectedOptions(pSelector, pValues)
	{
		const tmpElement = window['jQuery'](pSelector)[0];
		if (!tmpElement || !tmpElement.options)
		{
			return 0;
		}
		const tmpKeep = {};
		for (let i = 0; i < (pValues || []).length; i++)
		{
			tmpKeep[String(pValues[i])] = true;
		}
		let tmpRemoved = 0;
		// Backwards: removing shifts the live options collection.
		for (let i = tmpElement.options.length - 1; i >= 0; i--)
		{
			if (!tmpKeep[String(tmpElement.options[i].value)])
			{
				tmpElement.remove(i);
				tmpRemoved++;
			}
		}
		return tmpRemoved;
	}

	/**
	 * Reduce a Multiple selector's hydrated records to exactly ONE per selected value.
	 *
	 * The hydration query (`<Entity>s/FilteredTo/FBL~<identity>~INN~<values>`) is not scoped
	 * to a customer, so an identity field that is not globally unique returns a row per
	 * MATCH rather than per SELECTED VALUE. Seen on LADOTD Sample Creation: `SampleTestIDs`
	 * holds Test HASHES, and `FLDGLB01v1`/`LABGLB01v1` each exist for IDCustomer 10 AND 114,
	 * so two selected tests hydrated four records -- which the test-instance builder then
	 * turned into four table rows ("sometimes there are two tests instead of one").
	 *
	 * The single-value branch below has always collapsed this ("Using the first record"); the
	 * Multiple branch kept every row. A Multiple selector's records must be 1:1 with its
	 * values -- the value list IS the identity list.
	 *
	 * ⚠️ Ambiguity is resolved by taking the FIRST match, matching the single-value branch,
	 * and warns when it has to choose. It cannot prefer the "right" customer: there is no
	 * reliable client-side customer here (`CurrentUser.CustomerID` is the logged-in user's,
	 * which is 1 for internal staff, not the document's). Scoping the query -- or the
	 * endpoint -- is the real fix; this keeps the form self-consistent meanwhile.
	 *
	 * Fails OPEN: if nothing lines up (an identity field that is not what the value list
	 * holds) the original records are returned untouched rather than blanking the field.
	 *
	 * @param {Array<any>} pRecords - The hydrated records.
	 * @param {any} pIDValue - The selected value(s), comma-delimited.
	 * @param {string} pRecordIdentityField - The field the values are matched against.
	 * @param {string} pEntity - Entity name, for logging.
	 * @return {Array<any>} - One record per selected value, in the selected order.
	 */
	_alignRecordsToRequestedValues(pRecords, pIDValue, pRecordIdentityField, pEntity)
	{
		const tmpRequested = String((pIDValue === null || pIDValue === undefined) ? '' : pIDValue)
			.split(',').map((pValue) => pValue.trim()).filter((pValue) => pValue !== '');
		if (!tmpRequested.length || !Array.isArray(pRecords) || !pRecords.length)
		{
			return pRecords;
		}
		const tmpAligned = [];
		for (let i = 0; i < tmpRequested.length; i++)
		{
			const tmpMatches = pRecords.filter((pRecord) => pRecord && (String(pRecord[pRecordIdentityField]) === tmpRequested[i]));
			if (!tmpMatches.length)
			{
				continue;
			}
			if (tmpMatches.length > 1)
			{
				this.pict.log.warn(`Multiple ${pEntity} records share ${pRecordIdentityField} = ${tmpRequested[i]} (${tmpMatches.length} found); using the first. The hydration query is not customer-scoped.`);
			}
			tmpAligned.push(tmpMatches[0]);
		}
		// Nothing matched -- the identity field is not what the value list holds. Leave it alone.
		return tmpAligned.length ? tmpAligned : pRecords;
	}

	/**
	 * Safely read a select2 element's current selection, returning [] when the element isn't
	 * select2-initialized yet. The form can marshal a value before the picker's select2 finishes
	 * initializing; calling `.select2('data')` then logs "called on an element not using Select2"
	 * and throws "Cannot read properties of undefined (reading 'data')". Gate on the select2 instance.
	 *
	 * @param {string} pSelector
	 * @return {Array<any>}
	 */
	_safeSelect2Data(pSelector)
	{
		const tmp$ = window['jQuery'](pSelector);
		return (tmp$.data('select2') ? tmp$.select2('data') : null) || [];
	}
}

module.exports = MaterialsEntityInputType;

},{"./_EntityDataBaseline.js":132,"./_FilterToggleUI.js":136,"./_LabRouting.js":137,"./_ScopedEntityData.js":139,"./_SharedEntityRead.js":140,"pict-section-form":497}],69:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorLabDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = MaterialsSelectorLabDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":66}],70:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsLabPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'Lab',
};

/**
 * The Lab picker (beast B4 — a JOIN cascade): the Picker-stack port of MaterialsLabSelector, mirroring
 * the legacy provider 1:1 on the MaterialsCascadePicker base. Multi-select by default; selecting labs
 * reconciles the sibling SampleLabJoin array (reuse-by-IDLab so server ids and downstream edits — e.g.
 * Received — survive re-selection). On the bound sample's SampleChanged it re-derives value + joins from
 * the DB; SampleLabSync (broadcast when a per-test lab changes) reconciles this selection with them; the
 * ProjectEntityDataRecords sweep projects the joins into _EntityData.
 */
class PictProviderInputTypeMaterialsLabPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/** Labs are customer-scoped (row-level auth), not project-scoped — the legacy hook only added the
	 *  Name sort on top of the shared pipeline. @param {Record<string, any>} pInput
	 *  @param {number|string|null} [pRowIndex] @param {Object} [pView] @return {{Filters: Array<string>, BackOffFilters: Array<string>}} */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		tmpSplit.Filters.push('FSF~Name~ASC~0');
		return tmpSplit;
	}

	/** Init: legacy defaults (multi-select, Name EntityTag) + the configured family tracking GUID. */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyLabDefaults(pInput);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** Tabular twin of the init. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyLabDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** A sample can ship to several labs (multi-select), tag on Name. @param {Record<string, any>} pInput */
	_applyLabDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
	}

	/**
	 * Reconcile the selected Labs against the existing SampleLabJoins: reuse matches (by IDLab —
	 * preserving server ids + downstream edits), synthesize new (GUID minted off the document + salt +
	 * IDLab; saved-vs-unsaved sample keying), drop deselected. Ported 1:1.
	 * @param {Array<Record<string, any>>} pLabs @param {Array<Record<string, any>>} pCurrentSampleLabJoins
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex @return {Array<Record<string, any>>}
	 */
	_syncSampleLabJoins(pLabs, pCurrentSampleLabJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLabJoins) ? pCurrentSampleLabJoins.slice() : [ ];
		const tmpSampleLabJoins = [ ];
		for (const tmpLab of pLabs || [])
		{
			if (!tmpLab || typeof tmpLab !== 'object')
			{
				continue;
			}
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLab == tmpLab.IDLab);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLabJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLabJoinRecord ||
				{
					GUIDSampleLabJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLab: tmpLab.IDLab,
					Received: 0,
				}));
			tmpNewJoin.GUIDSampleLabJoin += `-${tmpLab.IDLab}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLabJoin)
			{
				tmpNewJoin.GUIDSampleLabJoin = this.pict.getUUID();
			}
			tmpSampleLabJoins.push(tmpNewJoin);
		}
		return tmpSampleLabJoins;
	}

	/**
	 * A de-selected Lab takes its `SampleLabJoin` with it. Picker twin of the selector hook.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpRecordAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLab)))
			{
				tmpRemovals.push({ Entity: 'SampleLabJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * The Lab cascade — the port of the legacy `_onRecordRefresh`: reconcile the SampleLabJoin array
	 * beside the record (clear → drop all joins), repaint dependents in-section, then super (the family
	 * bus fan-out). A cleared picker hands the seam `{}`/`[]` — normalized to "no labs" like the legacy's
	 * falsy-record branch.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpLabs = Array.isArray(pRecord) ? pRecord :
			((pRecord && typeof pRecord === 'object' && Object.keys(pRecord).length > 0) ? [ pRecord ] : [ ]);
		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		let tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLabJoins))
		{
			if (tmpSampleLabJoins)
			{
				this.log.error(`MaterialsLabPicker: SampleLabJoins at address ${tmpSampleLabJoinsAddress} is not an array`, { tmpSampleLabJoins });
			}
			tmpSampleLabJoins = [ ];
		}
		tmpSampleLabJoins = this._syncSampleLabJoins(tmpLabs, tmpSampleLabJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress, tmpSampleLabJoins);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * Family + save-sweep events — ported 1:1 from the legacy `_handleEvent`:
	 *   - SampleChanged (tracking-matched): re-derive this selector from the DB — load the sample's
	 *     SampleLabJoins, land them at the join address, and commit the joined lab ids as the value
	 *     (the programmatic set re-runs the provider loop, so the join reconcile rides the same path a
	 *     user pick does). No/invalid sample resets the joins. The fence op is registered only when a
	 *     fetch actually runs (the legacy registered before its IDSample check and leaked the op —
	 *     unreachable-hang family, same reasoned-divergence lineage as B2's clear-reset).
	 *   - SampleLabSync (broadcast, no tracking): the per-test labs changed. Reconcile OUR value with
	 *     them (_LabRouting.syncSampleLabSelection) and commit — the programmatic set re-runs the
	 *     provider loop, so the join array derives itself.
	 *   - ProjectEntityDataRecords: project the joins (+ any sibling DocumentPolyJoin) into the sweep
	 *     target.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpSampleLabJoinAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			const tmpRefreshEvent = 'SampleLabJoinRefresh';
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLabJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no labs". Treating it as an empty set and writing that
				// through overwrites the persisted selection on a transient network error -- and the document
				// auto-save then persists the loss with no user action. Abort instead: leave both the joins
				// address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLabPicker: failed to load SampleLabJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLabValue = pRecords.map((pJoin) => pJoin.IDLab).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex, ''));
				if (tmpLabValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLabJoin', ValueField: 'IDLab', JoinAddress: tmpSampleLabJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLabPicker' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLabPicker: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLabJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale; the outgoing sample's
				// joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					this._setValueAndCommit(pView, pInput, tmpLabValue, pRowIndex);
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === libLabRouting.SAMPLE_LAB_SYNC_EVENT)
		{
			const tmpNextValue = libLabRouting.syncSampleLabSelection(this.pict, pInput, pView.getMarshalDestinationObject(),
				this._getRecordAddress(pInput, null, '__Promoted'), pView.getValueByHash(pInput.Hash));
			if (tmpNextValue !== null)
			{
				this._setValueAndCommit(pView, pInput, tmpNextValue, null);
			}
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLabAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpTarget && typeof tmpTarget === 'object' && !Array.isArray(tmpTarget))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Project the SampleLabJoin array into the entity-data collection (keyed by GUIDSampleLabJoin) —
	 * the plural counterpart of the base _syncRecordToEntityData (the Lab CATALOG record itself never
	 * projects; the joins are the created data). Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		const tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		if (Array.isArray(tmpSampleLabJoins))
		{
			if (!tmpEntityData.SampleLabJoin || typeof tmpEntityData.SampleLabJoin !== 'object' || Array.isArray(tmpEntityData.SampleLabJoin))
			{
				tmpEntityData.SampleLabJoin = { };
			}
			for (const tmpSampleLabJoin of tmpSampleLabJoins)
			{
				tmpEntityData.SampleLabJoin[tmpSampleLabJoin.GUIDSampleLabJoin] = tmpSampleLabJoin;
			}
		}
	}

	/**
	 * The bound Sample record: ask the family over the bus (PushRecord into TempData), falling back to
	 * the conventional SampleAddress. Ported 1:1 (pView may be absent on a BaseFilter-closure call —
	 * the bus path needs no view).
	 * @param {Object|null} pView @param {Record<string, any>} pInput @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			if (!pView || typeof pView.getMarshalDestinationObject !== 'function')
			{
				return null;
			}
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = PictProviderInputTypeMaterialsLabPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65,"./_LabRouting.js":137,"./_ScopedEntityData.js":139}],71:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

/**
 * Install the pin-to-top resolver for a lab selector's select2 options, when the descriptor scopes by
 * `LabScope` and the LabScopeResolver is registered. The resolver answers with its preference ranking
 * (`LabScopeResolver.getPreferredLabIDs`); nothing is hidden.
 *
 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
 * @param {Object} pInput @param {number} [pRowIndex] @param {Object} [pView]
 */
function applyLabPriorityIDs(pPict, pConfigOptions, pInput, pRowIndex, pView)
{
	const tmpEngine = pPict.providers.EntityFilterEngine;
	const tmpResolver = pPict.providers.LabScopeResolver;
	if (!tmpEngine || !tmpResolver || pConfigOptions.GetPriorityIDs)
	{
		return;
	}
	const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
	if (!Array.isArray(tmpFilters))
	{
		return;
	}
	const tmpFilter = tmpFilters.find((pEntry) => pEntry && pEntry.LabScope);
	if (!tmpFilter)
	{
		return;
	}
	const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
	pConfigOptions.GetPriorityIDs = () =>
	{
		return tmpResolver.getPreferredLabIDs(tmpFilter.LabScope,
			{
				IDTest: tmpEngine._readLabScopeTestID(tmpFilter, pInput, tmpRowIndex, pView || null),
			});
	};
}

class MaterialsLabSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleLabJoinAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			const tmpRefreshEvent = 'SampleLabJoinRefresh';
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLabJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no labs". Treating it as an empty set and writing that
				// through overwrites the persisted selection on a transient network error -- and the document
				// auto-save then persists the loss with no user action. Abort instead: leave both the joins
				// address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLabSelectorInputType: failed to load SampleLabJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLabValue = pRecords.map((pJoin) => pJoin.IDLab).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex, ''));
				if (tmpLabValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLabJoin', ValueField: 'IDLab', JoinAddress: tmpSampleLabJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLabSelectorInputType' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLabSelectorInputType: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLabJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale. It routes through
				// setDataByInput, which enters onDataChange looking exactly like a user de-selection -- but the
				// outgoing sample's joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpLabValue);
					}
					else
					{
						pView.setDataByInput(pInput, tmpLabValue);
					}
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLabAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}

		if (tmpEventType === libLabRouting.SAMPLE_LAB_SYNC_EVENT)
		{
			// The per-test labs changed. Reconcile OUR value (the source of truth) and commit through setDataByInput,
			// which fires onDataChange -> _onRecordRefresh, so the join array derives itself.
			const tmpNextValue = libLabRouting.syncSampleLabSelection(this.pict, pInput, pView.getMarshalDestinationObject(),
				this._getRecordAddress(pView, pInput, null, '__Promoted'), pView.getValueByHash(pInput.Hash));
			if (tmpNextValue !== null)
			{
				pView.setDataByInput(pInput, tmpNextValue);
			}
		}
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * A de-selected Lab takes its `SampleLabJoin` with it. The joins are keyed by `IDLab`, which is
	 * also what this input's value list holds, so the retained set filters them directly.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		const tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		if (!Array.isArray(tmpSampleLabJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpSampleLabJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLab)))
			{
				tmpRemovals.push({ Entity: 'SampleLabJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * @param {Array<Record<string, any>>} pLabs
	 * @param {Array<Record<string, any>>} pCurrentSampleLabJoins
	 * @param {Record<string, any>} pSample
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} pRowIndex
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_syncSampleLabJoins(pLabs, pCurrentSampleLabJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLabJoins) ? pCurrentSampleLabJoins.slice() : [ ];
		const tmpSampleLabJoins = [ ];
		for (const tmpLab of pLabs || [])
		{
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLab == tmpLab.IDLab);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLabJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLabJoinRecord ||
				{
					GUIDSampleLabJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLab: tmpLab.IDLab,
					Received: 0,
				}));
			tmpNewJoin.GUIDSampleLabJoin += `-${tmpLab.IDLab}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLabJoin)
			{
				tmpNewJoin.GUIDSampleLabJoin = this.pict.getUUID();
			}
			tmpSampleLabJoins.push(tmpNewJoin);
		}
		return tmpSampleLabJoins;
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pRecord)
		{
			pRecord = pInput.PictForm.Multiple ? [] : { };
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLabAddress, pRecord);
		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		let tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLabJoins))
		{
			if (tmpSampleLabJoins)
			{
				this.log.error(`MaterialsLabSelectorInputType: SampleLabJoins at address ${tmpSampleLabJoinsAddress} is not an array`, { tmpSampleLabJoins });
			}
			tmpSampleLabJoins = [ ];
		}
		tmpSampleLabJoins = this._syncSampleLabJoins(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpSampleLabJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress, tmpSampleLabJoins);
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		const tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		if (Array.isArray(tmpSampleLabJoins))
		{
			if (!tmpEntityData.SampleLabJoin || typeof tmpEntityData.SampleLabJoin !== 'object' || Array.isArray(tmpEntityData.SampleLabJoin))
			{
				tmpEntityData.SampleLabJoin = { };
			}
			for (const tmpSampleLabJoin of tmpSampleLabJoins)
			{
				tmpEntityData.SampleLabJoin[tmpSampleLabJoin.GUIDSampleLabJoin] = tmpSampleLabJoin;
			}
		}
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			// Labs are customer-scoped (row-level auth), not project-scoped — just sort by Name.
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
		applyLabPriorityIDs(this.pict, pConfigOptions, pInput, pRowIndex, pView);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = MaterialsLabSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68,"./_LabRouting.js":137,"./_ScopedEntityData.js":139}],72:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorLineItemDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'LineItem'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple != null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple != null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = MaterialsSelectorLineItemDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":66}],73:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsLineItemPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'LineItem',
};

/**
 * The LineItem picker (beast B4 — a JOIN cascade): the Picker-stack port of MaterialsLineItemSelector,
 * mirroring the legacy provider 1:1 on the MaterialsCascadePicker base. Multi-select by default;
 * selecting line items reconciles the sibling SampleLineItemJoin array (reuse-by-IDLineItem so server
 * ids and the entered RepresentedQuantity survive re-selection) and stamps the display-only
 * `LineItemUnits` onto each join row for the tabular units column. On the bound sample's SampleChanged
 * it re-derives value + joins from the DB; the ProjectEntityDataRecords sweep projects the joins
 * (display fields stripped) into _EntityData.
 */
class PictProviderInputTypeMaterialsLineItemPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/**
	 * Project scoping + Name sort, ported from the legacy hook: the legacy scoped to the BOUND SAMPLE's
	 * project first (document project as fallback), so the base broker's document-project LineItem clause
	 * is suppressed for the super call and the sample-preferred clause applied here (existing clauses
	 * paren-wrapped so it ANDs the whole set, like the legacy).
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}}
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpPriorFlag = tmpPictForm.disableProjectFilteringForEntity;
		tmpPictForm.disableProjectFilteringForEntity = true;
		let tmpSplit;
		try
		{
			tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		}
		finally
		{
			tmpPictForm.disableProjectFilteringForEntity = tmpPriorFlag;
		}
		const tmpFilters = tmpSplit.Filters;
		if (!tmpPictForm.disableProjectFilteringForEntity)
		{
			const tmpSample = this._getBoundSampleRecord(pView, pInput);
			const tmpProjectID = tmpSample?.IDProject || this.pict.AppData.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID > 0)
			{
				if (tmpFilters.length > 0)
				{
					//FIXME: handle existing sort instructions (FSF)
					tmpFilters.unshift('FOP~0~(~0');
					tmpFilters.push('FCP~0~)~0');
				}
				tmpFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
		}
		tmpFilters.push('FSF~Name~ASC~0');
		return tmpSplit;
	}

	/** Init: legacy defaults (multi-select, ItemCode EntityTag) + the configured family tracking GUID. */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyLineItemDefaults(pInput);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** Tabular twin of the init. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyLineItemDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** A sample can represent several line items (multi-select), tag on ItemCode. @param {Record<string, any>} pInput */
	_applyLineItemDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
	}

	/**
	 * Reconcile the selected LineItems against the existing SampleLineItemJoins: reuse matches (by
	 * IDLineItem — preserving server ids + the entered RepresentedQuantity), synthesize new (GUID minted
	 * off the document + salt + IDLineItem; saved-vs-unsaved sample keying), drop deselected, then stamp
	 * the display-only units column. Ported 1:1.
	 * @param {Array<Record<string, any>>} pLineItems @param {Array<Record<string, any>>} pCurrentSampleLineItemJoins
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex @return {Array<Record<string, any>>}
	 */
	_syncSampleLineItemJoins(pLineItems, pCurrentSampleLineItemJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLineItemJoins) ? pCurrentSampleLineItemJoins.slice() : [ ];
		const tmpSampleLineItemJoins = [ ];
		for (const tmpLineItem of pLineItems || [])
		{
			if (!tmpLineItem || typeof tmpLineItem !== 'object')
			{
				continue;
			}
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLineItem == tmpLineItem.IDLineItem);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLineItemJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLineItemJoinRecord ||
				{
					GUIDSampleLineItemJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLIJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLineItem: tmpLineItem.IDLineItem,
					RepresentedQuantity: '0.000',
				}));
			tmpNewJoin.GUIDSampleLineItemJoin += `-${tmpLineItem.IDLineItem}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLineItemJoin)
			{
				tmpNewJoin.GUIDSampleLineItemJoin = this.pict.getUUID();
			}
			tmpSampleLineItemJoins.push(tmpNewJoin);
		}
		this._stampJoinDisplayFields(tmpSampleLineItemJoins, pLineItems);
		return tmpSampleLineItemJoins;
	}

	/**
	 * Stamp a display-only flat `LineItemUnits` onto each join row (the LineItem's unit, matched by
	 * IDLineItem) so the tabular Rep Qty Units column reads it directly as plain text — a 2nd
	 * EntityDisplay on the same LineItem doesn't render. NOT a SampleLineItemJoin column —
	 * `_syncRecordsToEntityData` MUST strip it or the upsert breaks. Ported 1:1.
	 * @param {Array<Record<string, any>>} pSampleLineItemJoins
	 * @param {Array<Record<string, any>>} pLineItems - The selected LineItem records (carry `Units`).
	 */
	_stampJoinDisplayFields(pSampleLineItemJoins, pLineItems)
	{
		if (!Array.isArray(pSampleLineItemJoins))
		{
			return;
		}
		const tmpUnitsByLineItem = { };
		for (const tmpLineItem of (pLineItems || [ ]))
		{
			if (tmpLineItem && tmpLineItem.IDLineItem != null)
			{
				tmpUnitsByLineItem[tmpLineItem.IDLineItem] = tmpLineItem.Units;
			}
		}
		for (const tmpJoin of pSampleLineItemJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && tmpUnitsByLineItem[tmpJoin.IDLineItem] != null)
			{
				tmpJoin.LineItemUnits = tmpUnitsByLineItem[tmpJoin.IDLineItem];
			}
		}
	}

	/**
	 * A de-selected LineItem takes its `SampleLineItemJoin` with it. Picker twin of the selector hook.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpRecordAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLineItem)))
			{
				tmpRemovals.push({ Entity: 'SampleLineItemJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * The LineItem cascade — the port of the legacy `_onRecordRefresh`: reconcile the SampleLineItemJoin
	 * array beside the record (clear → drop all joins), repaint dependents in-section, then super (the
	 * family bus fan-out). A cleared picker hands the seam `{}`/`[]` — normalized to "no line items"
	 * like the legacy's falsy-record branch.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpLineItems = Array.isArray(pRecord) ? pRecord :
			((pRecord && typeof pRecord === 'object' && Object.keys(pRecord).length > 0) ? [ pRecord ] : [ ]);
		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		let tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLineItemJoins))
		{
			if (tmpSampleLineItemJoins)
			{
				this.log.error(`MaterialsLineItemPicker: SampleLineItemJoins at address ${tmpSampleLineItemJoinsAddress} is not an array`, { tmpSampleLineItemJoins });
			}
			tmpSampleLineItemJoins = [ ];
		}
		tmpSampleLineItemJoins = this._syncSampleLineItemJoins(tmpLineItems, tmpSampleLineItemJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress, tmpSampleLineItemJoins);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * Family + save-sweep events — ported 1:1 from the legacy `_handleEvent`:
	 *   - SampleChanged (tracking-matched): re-derive this selector from the DB — load the sample's
	 *     SampleLineItemJoins, land them at the join address, and commit the joined line-item ids as the
	 *     value (the programmatic set re-runs the provider loop, so the join reconcile rides the same
	 *     path a user pick does). No/invalid sample resets the joins. The fence op is registered only
	 *     when a fetch actually runs (the legacy registered before its IDSample check and leaked the op —
	 *     unreachable-hang family, same reasoned-divergence lineage as B2's clear-reset).
	 *   - ProjectEntityDataRecords: project the joins (+ any sibling DocumentPolyJoin) into the sweep
	 *     target.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpSampleLineItemJoinAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			const tmpRefreshEvent = 'SampleLineItemJoinRefresh';
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLineItemJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no line items". Treating it as an empty set and writing
				// that through overwrites the persisted selection on a transient network error -- and the
				// document auto-save then persists the loss with no user action. Abort instead: leave both the
				// joins address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLineItemPicker: failed to load SampleLineItemJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLineItemValue = pRecords.map((pJoin) => pJoin.IDLineItem).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex, ''));
				if (tmpLineItemValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLineItemJoin', ValueField: 'IDLineItem', JoinAddress: tmpSampleLineItemJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLineItemPicker' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLineItemPicker: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLineItemJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale; the outgoing sample's
				// joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					this._setValueAndCommit(pView, pInput, tmpLineItemValue, pRowIndex);
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLineItemAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpTarget && typeof tmpTarget === 'object' && !Array.isArray(tmpTarget))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Project the SampleLineItemJoin array into the entity-data collection (keyed by
	 * GUIDSampleLineItemJoin), stripping the display-only unit fields that are not join columns (they
	 * would break the upsert). The plural counterpart of the base _syncRecordToEntityData (the LineItem
	 * CATALOG record itself never projects; the joins are the created data). Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		if (Array.isArray(tmpSampleLineItemJoins))
		{
			if (!tmpEntityData.SampleLineItemJoin || typeof tmpEntityData.SampleLineItemJoin !== 'object' || Array.isArray(tmpEntityData.SampleLineItemJoin))
			{
				tmpEntityData.SampleLineItemJoin = { };
			}
			for (const tmpSampleLineItemJoin of tmpSampleLineItemJoins)
			{
				const tmpPersistedJoin = { ...tmpSampleLineItemJoin };
				// Display-only fields (current + legacy attempts) — NOT SampleLineItemJoin columns; would break the upsert.
				delete tmpPersistedJoin.LineItemUnits;
				delete tmpPersistedJoin.IDLineItemUnits;
				delete tmpPersistedJoin.RepQtyUnits;
				tmpEntityData.SampleLineItemJoin[tmpPersistedJoin.GUIDSampleLineItemJoin] = tmpPersistedJoin;
			}
		}
	}

	/**
	 * The bound Sample record: ask the family over the bus (PushRecord into TempData), falling back to
	 * the conventional SampleAddress. Ported 1:1 (pView may be absent on a BaseFilter-closure call —
	 * the bus path needs no view).
	 * @param {Object|null} pView @param {Record<string, any>} pInput @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			if (!pView || typeof pView.getMarshalDestinationObject !== 'function')
			{
				return null;
			}
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = PictProviderInputTypeMaterialsLineItemPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65,"./_ScopedEntityData.js":139}],74:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

class MaterialsLineItemSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'LineItem'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleLineItemJoinAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			const tmpRefreshEvent = 'SampleLineItemJoinRefresh';
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, []);
				return;
			}
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			this.pict.HeadlightRestClient.getJSON(`SampleLineItemJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no line items". Treating it as an empty set and writing
				// that through overwrites the persisted selection on a transient network error -- and the
				// document auto-save then persists the loss with no user action. Abort instead: leave both the
				// joins address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLineItemSelectorInputType: failed to load SampleLineItemJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLineItemValue = pRecords.map((pJoin) => pJoin.IDLineItem).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex, ''));
				if (tmpLineItemValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLineItemJoin', ValueField: 'IDLineItem', JoinAddress: tmpSampleLineItemJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLineItemSelectorInputType' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLineItemSelectorInputType: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLineItemJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale. It routes through
				// setDataByInput, which enters onDataChange looking exactly like a user de-selection -- but the
				// outgoing sample's joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpLineItemValue);
					}
					else
					{
						pView.setDataByInput(pInput, tmpLineItemValue);
					}
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLineItemAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * A de-selected LineItem takes its `SampleLineItemJoin` with it. The joins are keyed by
	 * `IDLineItem`, which is also what this input's value list holds.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLineItem)))
			{
				tmpRemovals.push({ Entity: 'SampleLineItemJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * @param {Array<Record<string, any>>} pLineItems
	 * @param {Array<Record<string, any>>} pCurrentSampleLineItemJoins
	 * @param {Record<string, any>} pSample
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} pRowIndex
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_syncSampleLineItemJoins(pLineItems, pCurrentSampleLineItemJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLineItemJoins) ? pCurrentSampleLineItemJoins.slice() : [ ];
		const tmpSampleLineItemJoins = [ ];
		for (const tmpLineItem of pLineItems || [])
		{
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLineItem == tmpLineItem.IDLineItem);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLineItemJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLineItemJoinRecord ||
				{
					GUIDSampleLineItemJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLIJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLineItem: tmpLineItem.IDLineItem,
					RepresentedQuantity: '0.000',
				}));
			tmpNewJoin.GUIDSampleLineItemJoin += `-${tmpLineItem.IDLineItem}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLineItemJoin)
			{
				tmpNewJoin.GUIDSampleLineItemJoin = this.pict.getUUID();
			}
			tmpSampleLineItemJoins.push(tmpNewJoin);
		}
		this._stampJoinDisplayFields(tmpSampleLineItemJoins, pLineItems);
		return tmpSampleLineItemJoins;
	}

	/**
	 * Stamp a display-only flat `LineItemUnits` onto each join row (the LineItem's unit, matched by IDLineItem) so the
	 * tabular Rep Qty Units column reads it directly as plain text — a 2nd EntityDisplay on the same LineItem doesn't
	 * render. NOT a SampleLineItemJoin column — `_syncRecordsToEntityData` MUST strip it or the upsert breaks.
	 *
	 * @param {Array<Record<string, any>>} pSampleLineItemJoins
	 * @param {Array<Record<string, any>>} pLineItems - The selected LineItem records (carry `Units`).
	 */
	_stampJoinDisplayFields(pSampleLineItemJoins, pLineItems)
	{
		if (!Array.isArray(pSampleLineItemJoins))
		{
			return;
		}
		const tmpUnitsByLineItem = { };
		for (const tmpLineItem of (pLineItems || [ ]))
		{
			if (tmpLineItem && tmpLineItem.IDLineItem != null)
			{
				tmpUnitsByLineItem[tmpLineItem.IDLineItem] = tmpLineItem.Units;
			}
		}
		for (const tmpJoin of pSampleLineItemJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && tmpUnitsByLineItem[tmpJoin.IDLineItem] != null)
			{
				tmpJoin.LineItemUnits = tmpUnitsByLineItem[tmpJoin.IDLineItem];
			}
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pRecord)
		{
			pRecord = pInput.PictForm.Multiple ? [] : { };
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLineItemAddress, pRecord);
		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		let tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLineItemJoins))
		{
			if (tmpSampleLineItemJoins)
			{
				this.log.error(`MaterialsLineItemSelectorInputType: SampleLineItemJoins at address ${tmpSampleLineItemJoinsAddress} is not an array`, { tmpSampleLineItemJoins });
			}
			tmpSampleLineItemJoins = [ ];
		}
		tmpSampleLineItemJoins = this._syncSampleLineItemJoins(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpSampleLineItemJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress, tmpSampleLineItemJoins);
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		if (Array.isArray(tmpSampleLineItemJoins))
		{
			if (!tmpEntityData.SampleLineItemJoin || typeof tmpEntityData.SampleLineItemJoin !== 'object' || Array.isArray(tmpEntityData.SampleLineItemJoin))
			{
				tmpEntityData.SampleLineItemJoin = { };
			}
			for (const tmpSampleLineItemJoin of tmpSampleLineItemJoins)
			{
				const tmpPersistedJoin = { ...tmpSampleLineItemJoin };
				// Display-only fields (current + legacy attempts) — NOT SampleLineItemJoin columns; would break the upsert.
				delete tmpPersistedJoin.LineItemUnits;
				delete tmpPersistedJoin.IDLineItemUnits;
				delete tmpPersistedJoin.RepQtyUnits;
				tmpEntityData.SampleLineItemJoin[tmpPersistedJoin.GUIDSampleLineItemJoin] = tmpPersistedJoin;
			}
		}
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'ItemCode', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			const tmpSample = this._getBoundSampleRecord(pView, pInput);
			const tmpProjectID = tmpSample?.IDProject || this.pict.AppData.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID > 0)
			{
				if (pFilters.length > 0)
				{
					//FIXME: handle existing sort instructions (FSF)
					pFilters.unshift('FOP~0~(~0');
					pFilters.push('FCP~0~)~0');
				}
				//TODO: do we want to support disabling this filter?
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = MaterialsLineItemSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68,"./_ScopedEntityData.js":139}],75:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

class MaterialsPlantSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'ProductionPlant';
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Name' ];
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			// ProductionPlants are customer-scoped (row-level auth), not project-scoped — just sort by Name.
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
	}
}

module.exports = MaterialsPlantSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68}],76:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorSampleDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Sample'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.SelectedSample.QRCode || 'N/A',
				this.SelectedSample.Name || ('Unnamed Sample #' + this.SelectedSample.GUIDSample),
			);
		}
		else
		{
			tmpDisplayTemplate = this.SelectedSample.Name || ('Unnamed Material #' + this.SelectedSample.IDMaterial);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Build the QR Code Image and prepend it to the input element.
	 * @param {HTMLSelectElement} tmpInputSelectElement The input element.
	 */
	buildPrependedQRCodeImage(tmpInputSelectElement)
	{
		if (this.SelectedSample && !this.appliedQRCodeAlready)
		{
			const tmpCanvas = this.pict.providers.QRCodeProvider.create(this.SelectedSample.QRCode);
			const tmpElement = `<figure class="image mr-2 is-64x64"><img src="${tmpCanvas}" alt="QR Code" /></figure>`;
			// find the parent .column element
			const tmpParentElement = tmpInputSelectElement.closest('.column');
			if (tmpParentElement)
			{
				// prepend the QR Code Image
				tmpParentElement.insertAdjacentHTML('afterbegin', tmpElement);
				tmpParentElement.classList.add('is-flex');
				tmpParentElement.classList.add('is-align-items-center');
				this.appliedQRCodeAlready = true;
			}
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the Material for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Sample record yet, get it and store it
			if (!this.SelectedSample || this.SelectedSample.GUIDSample !== pValue)
			{
				try
				{
					const tmpSample = await this.pict.providers.SampleProvider.getSampleByGUID(pValue);
					this.SelectedSample = tmpSample;
				}
				catch (e)
				{
					this.pict.log.error(`Error fetching Sample with ID ${ pValue }: ${ e }`);
					this.SelectedSample =
					{
						IDMaterial: pValue,
						Name: 'Unkown Material',
					};
				}
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
			// for PDF view, we want to prepend the QRCode Image to the display, if we have one
			this.buildPrependedQRCodeImage(tmpInputSelectElement);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = MaterialsSelectorSampleDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":66}],77:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsSamplePicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Opt into the app save-data lifecycle so onBeforeSaveDataAsync (the SampleSequencing stamp, run
	// before the _EntityData projection sweep) actually fires — legacy parity (the MES Sample selector
	// set AutoSaveDataWithApp too).
	AutoSaveDataWithApp: true,
	// The sample selector creates samples by default; a field opts out via PictForm.AllowEntityCreation.
	AllowEntityCreation: true,
	Entity: 'Sample',
};

/**
 * The Sample picker (beast B2 — THE HUB): the Picker-stack port of MaterialsSampleSelector, mirroring
 * the legacy provider 1:1 on the MaterialsCascadePicker base. The sample owns the family's tracking
 * identity; its cascade drives the DocumentPolyJoin synthesis, the spec-year scope, the auto-generated
 * Sample Name, and the form's data requirements; its save hook stamps naming/numbering before the
 * _EntityData projection sweep. Creation (type-to-create) synthesizes a QR-coded, project-bound record.
 */
class PictProviderInputTypeMaterialsSamplePicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/**
	 * A sample is ALWAYS tracked by GUIDSample (legacy hard override — even with creation configured
	 * off, the value identity stays the GUID).
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || 'GUIDSample';
	}

	/**
	 * The synthesized sample: the base mint (document GUID + stanza + salt), then the sample-specific
	 * enrichment — project binding, creating user, designated time, and a fresh QR code. Ported 1:1
	 * (including the legacy '-S-' fallback for a GenerateGUID-opted-out record).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>}
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			tmpRecord = { GUIDSample: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		if (this.pict.AppData.DocumentData?.ReportData?.IDProject > 0)
		{
			tmpRecord.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		}
		tmpRecord.CreatingIDUser = this.pict.AppData.CurrentUser?.UserID;
		tmpRecord.DesignatedTime = new Date().toISOString();
		tmpRecord.QRCode = this.pict.providers.QRCodeProvider.generateNewQRCode(tmpRecord);
		return tmpRecord;
	}

	/**
	 * Init: default the QRCode EntityTag, wire the external Sample Search Panel, and mint/bind the
	 * family tracking GUID — the sample OWNS the tracking identity the sibling selectors bind from.
	 * Ported 1:1; the search-panel selection lands through the broker value-commit primitive instead
	 * of the legacy select2 DOM pokes.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		this._applyDisabledOnceSaved(pInput, pValue);
		this._wireSampleSearchPanel(pView, pInput, null);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = tmpTrackingGUID;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		this._applyDisabledOnceSaved(pInput, pValue);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Wire the external Sample Search Panel to THIS picker: a panel selection stashes the record and
	 * lands it through the value-commit primitive. The panel's row is a fresh server read, so it is
	 * reconciled with the held record like an open refresh (a re-pick of the held sample keeps an
	 * unsaved edit to it) and pre-written to `__Record`, and the value is marked read so the fenced
	 * refresh short-circuits on it (no re-fetch); committing the GUID then runs the cascade + widget
	 * repaint on the standard path. (The legacy FIXME about the last-initialized selector winning still
	 * applies — one panel callback slot.)
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 */
	_wireSampleSearchPanel(pView, pInput, pRowIndex)
	{
		const tmpPanel = this.pict.views.HeadlightPaneSamples;
		if (!tmpPanel || typeof tmpPanel.setSampleSelectionCallback !== 'function')
		{
			return;
		}
		tmpPanel.setSampleSelectionCallback((pSample) =>
		{
			this.pict.log.info(`Sample selected from the search panel: ${pSample?.GUIDSample} -> input ${pInput.Macro.RawHTMLID}`);
			this.pict.AppData.SelectedSample = pSample;
			const tmpIdentity = this._getRecordIdentity(pInput);
			const tmpValue = pSample[tmpIdentity];
			const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress,
				this._reconcileRefreshedRecord(pView, pInput, tmpHeld, pSample, tmpIdentity, tmpValue, pRowIndex));
			this._openRefreshes().add(this._openRefreshKey(pInput, tmpValue, pRowIndex));
			this._setValueAndCommit(pView, pInput, tmpValue, pRowIndex);
		});
	}

	/**
	 * Opt-in via PictForm.DisabledOnceSaved: disable this selector once it has a value AND the document has
	 * been persisted, so a saved selection can't be swapped; a brand-new (unsaved) form stays editable. Sets
	 * PictForm.Disabled before the picker mounts. Ported 1:1 from `MaterialsSampleSelector._applyDisabledOnceSaved`.
	 * @param {Record<string, any>} pInput @param {any} pValue - the selected sample's GUID, when one exists.
	 */
	_applyDisabledOnceSaved(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || !pInput.PictForm.DisabledOnceSaved)
		{
			return;
		}
		const tmpDocumentSaved = this.pict?.AppData?.DocumentData?.ReportData?.IDDocument > 0;
		if (pValue && tmpDocumentSaved)
		{
			pInput.PictForm.Disabled = true;
		}
	}

	/**
	 * Save-lifecycle hook: stamp naming + numbering (Name, LabControlNumber, Sequenced) on the Sample
	 * record BEFORE the base projects it into _EntityData (super), so the projected copy carries the
	 * stamped values. Delegates to SampleSequencing; idempotent and fail-safe. Ported 1:1.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpProvider = this.pict.providers?.SampleSequencing;
		if (!tmpProvider || typeof tmpProvider.applyBeforeSave !== 'function')
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}
		tmpProvider.applyBeforeSave().then(() => super.onBeforeSaveDataAsync(fCallback)).catch((pError) =>
		{
			this.pict.log.error(`SampleSequencing stamp failed before save (continuing): ${pError?.message || pError}`);
			super.onBeforeSaveDataAsync(fCallback);
		});
	}

	/**
	 * The Sample cascade — the port of the legacy `_onRecordRefresh`, fired from the seam after
	 * `__Record` lands (select, create, seed and clear paths):
	 *   1. synthesize/maintain the sibling DocumentPolyJoin (document linkage; template-minted GUID,
	 *      saved-vs-unsaved document key, IDRemote or the GUIDSample+_Dest_GUIDSample redirect);
	 *   2. repaint dependents in-section (marshalToView);
	 *   3. super — the family event bus (SampleChanged:<trackingGUID>:<address> + trigger group);
	 *   4. refresh the spec-year scope from the sample's project (resolver dedupes, fail-open);
	 *   5. live-refresh the auto-generated Sample Name (never clobbers a manual edit);
	 *   6. re-apply the form's data requirements for the new sample.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpSampleAddress = this._getRecordAddress(pInput, pRowIndex);
		/** @type {Record<string, any>|null} */
		let tmpSample = (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord)) ? pRecord : null;
		if (!tmpSample)
		{
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		if (tmpSample && typeof tmpSample === 'object' && Object.keys(tmpSample).length === 0)
		{
			// The seam hands a cleared picker `{}`; the legacy refresh handed a falsy record. Normalize so
			// the DocumentPolyJoin branch below sees "no sample", exactly like the legacy did.
			tmpSample = null;
		}
		const tmpSampleDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress);
		if (ScopedEntityData.referencesSample(tmpSample))
		{
			// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
			if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
			{
				tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
					{
						GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
						RemoteType: 'Sample',
						IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
						GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
						IDRemote: tmpSample.IDSample,
					}));
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
				{
					this._translateRecordTemplateFields(tmpDocumentPolyJoin);
				}
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			const tmpDocument = this.pict.AppData.DocumentData.ReportData;
			if (tmpDocument)
			{
				if (tmpDocument.IDDocument > 0)
				{
					tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
					delete tmpDocumentPolyJoin.GUIDDocument;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
					delete tmpDocumentPolyJoin.IDDocument;
				}
			}
			if (!tmpDocumentPolyJoin.IDRemote)
			{
				if (tmpSample.IDSample)
				{
					tmpDocumentPolyJoin.IDRemote = tmpSample.IDSample;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDSample = tmpSample.GUIDSample;
					tmpDocumentPolyJoin._Dest_GUIDSample = 'IDRemote';
					delete tmpDocumentPolyJoin.IDRemote;
				}
			}
		}
		else if (tmpDocumentPolyJoin && !tmpSample)
		{
			tmpDocumentPolyJoin = { };
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
		// Refresh spec-year scope from the sample's project. Resolver dedupes when the project hasn't
		// changed; fail-open paths inside the resolver handle bare contracts / empty stub sets / no
		// spec infra. Triggered here because providers don't receive the form's global event channel.
		this.pict.providers.SpecScopeResolver?.loadForSampleRecord?.(tmpSample);
		// Live-refresh the auto-generated Sample Name from the current source fields — only while the
		// user hasn't edited the (now editable) Name field, so a manual edit is never clobbered.
		if (this.pict.providers.SampleSequencing?.refreshSampleName?.())
		{
			if (typeof pView.marshalToView === 'function')
			{
				pView.marshalToView();
			}
		}
		this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, pRecord).catch((pError) =>
		{
			this.pict.log.error(`Error applying data requirements after sample refresh: ${pError.message || pError}`);
		});
	}

	/**
	 * Family + save-sweep events — ported 1:1 from the legacy `_handleEvent`:
	 *   - ProjectEntityDataRecords: project the sample + its DocumentPolyJoin into the sweep target
	 *     (the base sweep handler re-runs idempotently through super — same target, same GUID keys);
	 *   - targeted (tracking-GUID-matched): SampleStatusChanged stamps the status onto the record;
	 *     PushRecord copies the record to the requested address.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpSampleAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}

			return;
		}
		// global events above here; below are targetted events
		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (tmpEventType === 'SampleStatusChanged')
		{
			const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
			tmpRecord.Status = tmpEventPayload;
			return;
		}

		if (tmpEventType === 'PushRecord')
		{
			const tmpSampleAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
			this.pict.manifest.setValueAtAddress(this.pict, tmpEventPayload, tmpSampleRecord);
		}
	}
}

module.exports = PictProviderInputTypeMaterialsSamplePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65,"./_ScopedEntityData.js":139}],78:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerDisplayProvider = require('./PictProvider-InputType-PickerDisplay.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsSamplePickerDisplay',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The Sample Read/Print display (beast B5): PickerDisplay plus the one bespoke behavior the legacy
 * MaterialsSampleDisplay carried — a QR-CODE IMAGE prepended beside the display node (the printed form's
 * scannable sample link). Value resolution itself is the base's: `__Record`-first (a created-but-unsaved
 * sample exists ONLY there), then the GUID identity fetch, with the `[QRCode] Name` compound the shared
 * map configures.
 */
class PictProviderInputTypeMaterialsSamplePickerDisplay extends PickerDisplayProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/** Paint the display, then prepend the QR image for the resolved sample (non-tabular; once —
	 *  the legacy `appliedQRCodeAlready` latch). */
	async _paint(pView, pInput, pValue, pRowIndex)
	{
		const tmpPainted = await super._paint(pView, pInput, pValue, pRowIndex);
		if (tmpPainted && pValue && pRowIndex == null)
		{
			this._prependQRCodeImage(pView, pInput, pValue);
		}
		return tmpPainted;
	}

	/**
	 * The legacy buildPrependedQRCodeImage, ported: render the sample's QR code as a small figure before
	 * the display node's host column (Read + Print). The sample record comes from the local `__Record`
	 * snapshot — the same source the paint just resolved from; no snapshot (or no QR code) → no image.
	 * @param {object} pView @param {object} pInput @param {any} pValue
	 */
	_prependQRCodeImage(pView, pInput, pValue)
	{
		if (this.appliedQRCodeAlready || !this.pict.providers.QRCodeProvider)
		{
			return;
		}
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpIdentity = this._identityField(tmpPictForm);
		const tmpSample = this._localEntityRecords(pView, pInput, null).find((pRecord) => pRecord[tmpIdentity] == pValue);
		if (!tmpSample || !tmpSample.QRCode)
		{
			return;
		}
		const tmpElements = this.pict.ContentAssignment.getElement(this.getDisplayNodeID(pInput.Macro.RawHTMLID));
		if (!tmpElements || tmpElements.length < 1 || typeof tmpElements[0].closest !== 'function')
		{
			return;
		}
		const tmpParentElement = tmpElements[0].closest('.column');
		if (tmpParentElement)
		{
			const tmpFigure = document.createElement('figure');
			tmpFigure.className = 'image mr-2 is-64x64';
			const tmpImage = document.createElement('img');
			tmpImage.src = this.pict.providers.QRCodeProvider.create(tmpSample.QRCode);
			tmpImage.alt = 'QR Code';
			tmpFigure.append(tmpImage);
			tmpParentElement.prepend(tmpFigure);
			tmpParentElement.classList.add('is-flex');
			tmpParentElement.classList.add('is-align-items-center');
			this.appliedQRCodeAlready = true;
		}
	}
}

module.exports = PictProviderInputTypeMaterialsSamplePickerDisplay;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-PickerDisplay.js":96}],79:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

class MaterialsSampleInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Sample'; //TODO: use default options for this?
		pOptions.AllowEntityCreation = true; // can turn off via PictForm option of same name
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'GUIDSample';
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			//FIXME: need to get some kind of record uniqueness injected here
			tmpRecord = { GUIDSample: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		if (this.pict.AppData.DocumentData?.ReportData?.IDProject > 0)
		{
			tmpRecord.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		}
		tmpRecord.CreatingIDUser = this.pict.AppData.CurrentUser?.UserID;
		tmpRecord.DesignatedTime = new Date().toISOString();
		tmpRecord.QRCode = this.pict.providers.QRCodeProvider.generateNewQRCode(tmpRecord);
		return tmpRecord;
	}

	/**
	 * Opt-in via PictForm.DisabledOnceSaved: disable this selector once it has a value AND the document
	 * has been persisted, so a saved selection can't be swapped. A brand-new (unsaved) form stays editable.
	 * Sets PictForm.Disabled, which the template honors for both the <select> and the advanced
	 * Sample-Search-Panel button. Distinct from the document-level lock (ReportData.Locked), which freezes
	 * the whole form via the Read theme. A selector that is never editable sets PictForm.Disabled directly.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value (the selected sample's GUID, when one exists).
	 */
	_applyDisabledOnceSaved(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || !pInput.PictForm.DisabledOnceSaved)
		{
			return;
		}
		const tmpDocumentSaved = this.pict?.AppData?.DocumentData?.ReportData?.IDDocument > 0;
		if (pValue && tmpDocumentSaved)
		{
			pInput.PictForm.Disabled = true;
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		// Opt-in via PictForm.DisabledOnceSaved: a saved sample can't be swapped, a blank new form can.
		this._applyDisabledOnceSaved(pInput, pValue);
		//FIXME: this seems to assume there will only be a single sample selector on the page at a time................
		//       this should be wired up only when the user clicks the button to open the panel.
		// set the Sample selection callback for the Sample Search Panel
		this.pict.views.HeadlightPaneSamples.setSampleSelectionCallback((pSample) =>
		{
			this.pict.log.info('Sample selected:', pSample.GUIDSample);
			this.pict.log.info('Assigning Sample to the following input element:', pInput.Macro.RawHTMLID);
			this.pict.AppData.SelectedSample = pSample;
			document.getElementById(pInput.Macro.RawHTMLID)['value'] = pSample.GUIDSample;
			document.getElementById(pInput.Macro.RawHTMLID).dispatchEvent(new Event('change'));
			//FIXME: consolidate this with the base class..........
			// update the select2 element to show the selected sample
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			const tmpOption = document.createElement('option');
			tmpOption.value = pSample[this._getRecordIdentity(pInput)];
			tmpOption.text = this._formatRecordForDisplay(pSample, pInput);
			tmpOption.selected = true;
			// remove any existing options
			while (tmpSelectElement.firstChild)
			{
				tmpSelectElement.removeChild(tmpSelectElement.firstChild);
			}
			tmpSelectElement.appendChild(tmpOption);
			// trigger change to update select2
			$(tmpSelectElement).trigger('change');
		});
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = tmpTrackingGUID;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		// Honor PictForm.DisabledOnceSaved for tabular sample selectors too (see onInputInitialize).
		this._applyDisabledOnceSaved(pInput, pValue);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Save-lifecycle hook: stamp naming + numbering (Name, LabControlNumber, Sequenced) on the
	 * Sample record BEFORE the base class projects it into _EntityData (super), so the projected
	 * copy carries the stamped values. Delegates to the SampleSequencing provider; idempotent and
	 * fail-safe, so a stamp failure never blocks the save.
	 *
	 * @param {(pError?: Error) => void} fCallback
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpProvider = this.pict.providers?.SampleSequencing;
		if (!tmpProvider || typeof tmpProvider.applyBeforeSave !== 'function')
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}
		tmpProvider.applyBeforeSave().then(() => super.onBeforeSaveDataAsync(fCallback)).catch((pError) =>
		{
			this.pict.log.error(`SampleSequencing stamp failed before save (continuing): ${pError?.message || pError}`);
			super.onBeforeSaveDataAsync(fCallback);
		});
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpSampleAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		let tmpSample = pRecord;
		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		if (tmpSample && typeof tmpSample === 'object' && Object.keys(tmpSample).length === 0)
		{
			tmpSample = null;
		}
		const tmpSampleDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress);
		if (ScopedEntityData.referencesSample(tmpSample))
		{
			// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
			if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
			{
				tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
					{
						GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
						RemoteType: 'Sample',
						IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
						GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
						IDRemote: tmpSample.IDSample,
					}));
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
				{
					this._translateRecordTemplateFields(tmpDocumentPolyJoin);
				}
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			const tmpDocument = this.pict.AppData.DocumentData.ReportData;
			if (tmpDocument)
			{
				if (tmpDocument.IDDocument > 0)
				{
					tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
					delete tmpDocumentPolyJoin.GUIDDocument;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
					delete tmpDocumentPolyJoin.IDDocument;
				}
			}
			if (!tmpDocumentPolyJoin.IDRemote)
			{
				if (tmpSample.IDSample)
				{
					tmpDocumentPolyJoin.IDRemote = tmpSample.IDSample;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDSample = tmpSample.GUIDSample;
					tmpDocumentPolyJoin._Dest_GUIDSample = 'IDRemote';
					delete tmpDocumentPolyJoin.IDRemote;
				}
			}
		}
		else if (tmpDocumentPolyJoin && !tmpSample)
		{
			tmpDocumentPolyJoin = { };
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		//TOOD: is this a good idea? this ensures any fields that use this record are updated immediately, if they are in the same section
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
		// Refresh spec-year scope from the sample's project. Resolver dedupes
		// when the project hasn't changed; fail-open paths inside the resolver
		// handle bare contracts / empty stub sets / no spec infra. Triggered
		// here (rather than via PictFormMetacontroller's global event channel,
		// which only routes to views) because providers don't receive those
		// events. See ~/dev/material_selectors_spec_year_audit.md §10.7 for
		// the wiring rationale.
		this.pict.providers.SpecScopeResolver?.loadForSampleRecord?.(tmpSample);
		// Live-refresh the auto-generated Sample Name from the current source fields (project / material /
		// date). Guarded so it only regenerates while the user hasn't edited the (now editable) Name field —
		// so it shows and tracks the fields early, yet a manual edit is never clobbered. Same bridge rationale
		// as SpecScopeResolver above: providers don't receive the form's global events.
		if (this.pict.providers.SampleSequencing?.refreshSampleName?.())
		{
			pView.marshalToView();
		}
		this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, pRecord).catch((pError) =>
		{
			this.pict.log.error(`Error applying data requirements after sample refresh: ${pError.message || pError}`);
		});
	}


	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpSampleAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}

			return;
		}
		// global events above here; below are targetted events
		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (tmpEventType === 'SampleStatusChanged')
		{
			const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
			tmpRecord.Status = tmpEventPayload;
			return;
		}

		if (tmpEventType === 'PushRecord')
		{
			const tmpSampleAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
			this.pict.manifest.setValueAtAddress(this.pict, tmpEventPayload, tmpSampleRecord);
		}
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		let tmpName = pRecord.Name;
		if (!pRecord.Name)
		{
			if (!pRecord.LabControlNumber)
			{
				// A synthesized (not-yet-saved) sample has no IDSample; show "New Sample" rather than "#??".
				tmpName = pRecord.IDSample ? `Unnamed Sample #${pRecord.IDSample}` : 'New Sample';
			}
			else
			{
				tmpName = `LCN: ${pRecord.LabControlNumber}`;
			}
		}
		return tmpName;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'QRCode', 'Name' ];
	}
}

module.exports = MaterialsSampleInputType;
// Opt into the app save-data lifecycle so onBeforeSaveDataAsync (the SampleSequencing stamp, run
// before the _EntityData projection sweep) actually fires. NOT a framework default — sibling
// selectors that project records on save (Test, SampleTestResult) set this too.
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68,"./_ScopedEntityData.js":139}],80:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorTestDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}


	// NOTE: This all is duplicated from the base EntityDisplay class becuase we need to be able to pass IdentityField as 'Hash' for Tests, should refactor later

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders the static `...TABULAR-DATA-...` div, not a `...DROPDOWN-...` select2 node.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), pValue,
			{
				IdentityField: 'Hash',
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let tmpDisplayTemplate = '';
				if (tmpInputSelectElement.tagName === 'DIV')
				{
					tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
						tmpEntity[pInput.PictForm.EntityTag] || 'N/A',
						tmpDisplayName || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]),
						false,
						tmpEntity.EntityTagLast,
					);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
			}
			else
			{
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayName);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = MaterialsSelectorTestDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":66}],81:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

class MaterialsTestInjectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord()
	{
		const tmpPayloadUUID = this.pict.getUUID();
		//FIXME: I think this event is busted - it works but not in a good way
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${tmpPayloadUUID}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: this is terrible
			const tmpSampleAddress = 'SampleID__Record';
			const tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			tmpSample = this.pict.manifest.getValueAtAddress(tmpViewMarshalDestinationObject, tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * @param {string} pTestHash - The test hash to register.
	 * @param {string} pSaltHash - The salt hash to register.
	 * @param {(pError?: Error) => void} [fCallback] - Optional callback function to be called after registration.
	 */
	registerTest(pTestHash, pSaltHash, fCallback)
	{
		if (!pTestHash)
		{
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		if (!this.pict.providers.DocumentDynamicSectionManager)
		{
			this.pict.log.error(`MaterialsTestInjectorInputType: DocumentDynamicSectionManager provider not available; cannot register test`, { pTestHash });
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		this.pict.providers.DocumentDynamicSectionManager.registerTest(pTestHash, pSaltHash, (pViews) =>
		{
			if (Array.isArray(pViews) && pViews.length > 0)
			{
				const tmpSample = this._getBoundSampleRecord();
				if (!tmpSample)
				{
					this.pict.log.warn(`Unable to look up sample record after test injection; skipping data requirement update`, { pTestHash });
					this.pict.PictApplication.solve();
					return;
				}
				this.pict.providers.DataRequirementsProvider.updateDataRequirementsForManifest(this.pict.views.PictFormMetacontroller.manifestDescription, () =>
				{
					this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, tmpSample).catch((pError) =>
					{
						this.pict.log.error(`Error applying data requirements after test injection: ${pError.message || pError}`);
					}).finally(() =>
					{
						this.pict.PictApplication.solve(); //FIXME: this may be a second solve, depending on the data requirements outcome
						if (typeof fCallback === 'function')
						{
							fCallback();
						}
					});
				}, [ pTestHash ]);
			}
		});
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'Hash';
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// kinda weird; we don't want to load the test record from the parent class, but we want most of the other parent behaviors
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// kinda weird; we don't want to load the test record from the parent class, but we want most of the other parent behaviors
		return true;
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		if (!pRecord.Name)
		{
			if (pRecord.Description)
			{
				return pRecord.Description;
			}
			if (pRecord.Hash)
			{
				return `Test Code ${pRecord.Hash}`;
			}
			return `Unnamed Test #${pRecord.IDTest ?? '??'}`;
		}
		return pRecord.Name;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Hash', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			//FIXME: care about wrapping sort instructions...
			if (pFilters.length > 0)
			{
				pFilters.unshift('FOP~0~(~0');
				pFilters.push('FCP~0~)~0');
			}
			pFilters.push('FBV~Active~EQ~1');
			pFilters.push('FBV~Injectable~EQ~1');
			return pFilters;
		};
	}
}

module.exports = MaterialsTestInjectorInputType;

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68}],82:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsTestInjectorPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'Test',
};

/**
 * The Test injector picker (beast B5): the Picker-stack port of MaterialsTestInjector, mirroring the
 * legacy provider 1:1 on the MaterialsCascadePicker base. A narrow selector: the user picks an ACTIVE,
 * INJECTABLE test (committed by Hash) and clicks the template's "Add Test" addon button, which calls
 * `registerTest` — DocumentDynamicSectionManager injects the test's form sections, then the data
 * requirements re-apply for the bound sample. The picked value is a section recipe, NOT form data:
 * `_refreshEntityRecord` is OPTED OUT (no `__Record` snapshot, no cascade — the legacy onDataChange
 * suppressed the record load the same way).
 */
class PictProviderInputTypeMaterialsTestInjectorPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any, PictApplication: any }} */
		this.pict;
	}

	/** An injectable Test commits by HASH — the section-registration key (legacy _getDefaultRecordIdentity).
	 *  @param {Record<string, any>} pInput @return {string} */
	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || 'Hash';
	}

	/**
	 * Mandatory injector scoping, ported from the legacy HandleSearchFilters: only Active, INJECTABLE
	 * tests are offered. Contextual filters paren-wrapped so the appended clauses AND the whole set.
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}}
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		const tmpFilters = tmpSplit.Filters;
		if (tmpFilters.length > 0)
		{
			tmpFilters.unshift('FOP~0~(~0');
			tmpFilters.push('FCP~0~)~0');
		}
		tmpFilters.push('FBV~Active~EQ~1');
		tmpFilters.push('FBV~Injectable~EQ~1');
		return tmpSplit;
	}

	/** Init: default the Hash EntityTag (ported 1:1). */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of the init. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * THE `__Record` OPT-OUT: the injector's value is a section recipe, not form data — the legacy
	 * onDataChange deliberately skipped the record load ("we don't want to load the test record"), so
	 * the broker's snapshot + cascade machinery is suppressed wholesale here.
	 */
	// eslint-disable-next-line no-unused-vars
	_refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		return;
	}

	/**
	 * The bound Sample record — ported VERBATIM, both legacy FIXMEs intact: the PushRecord tracking slot
	 * carries a fresh UUID no sample will ever match (busted-but-works), so resolution effectively rides
	 * the conventional-address fallback.
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord()
	{
		const tmpPayloadUUID = this.pict.getUUID();
		//FIXME: I think this event is busted - it works but not in a good way
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${tmpPayloadUUID}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: this is terrible
			const tmpSampleAddress = 'SampleID__Record';
			const tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			tmpSample = this.pict.manifest.getValueAtAddress(tmpViewMarshalDestinationObject, tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * Inject the picked test's sections — the template's "Add Test" button target, ported 1:1:
	 * DocumentDynamicSectionManager registers the test (salted, so the same test can inject twice),
	 * then the data requirements recompute + re-apply for the bound sample, then the app re-solves.
	 * @param {string} pTestHash - The test hash to register.
	 * @param {string} pSaltHash - The salt hash to register.
	 * @param {(pError?: Error) => void} [fCallback] - Optional callback function to be called after registration.
	 */
	registerTest(pTestHash, pSaltHash, fCallback)
	{
		if (!pTestHash)
		{
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		if (!this.pict.providers.DocumentDynamicSectionManager)
		{
			this.pict.log.error(`MaterialsTestInjectorPicker: DocumentDynamicSectionManager provider not available; cannot register test`, { pTestHash });
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		this.pict.providers.DocumentDynamicSectionManager.registerTest(pTestHash, pSaltHash, (pViews) =>
		{
			if (Array.isArray(pViews) && pViews.length > 0)
			{
				const tmpSample = this._getBoundSampleRecord();
				if (!tmpSample)
				{
					this.pict.log.warn(`Unable to look up sample record after test injection; skipping data requirement update`, { pTestHash });
					this.pict.PictApplication.solve();
					return;
				}
				this.pict.providers.DataRequirementsProvider.updateDataRequirementsForManifest(this.pict.views.PictFormMetacontroller.manifestDescription, () =>
				{
					this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, tmpSample).catch((pError) =>
					{
						this.pict.log.error(`Error applying data requirements after test injection: ${pError.message || pError}`);
					}).finally(() =>
					{
						this.pict.PictApplication.solve(); //FIXME: this may be a second solve, depending on the data requirements outcome
						if (typeof fCallback === 'function')
						{
							fCallback();
						}
					});
				}, [ pTestHash ]);
			}
		});
	}
}

module.exports = PictProviderInputTypeMaterialsTestInjectorPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65}],83:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const libLabRouting = require('./_LabRouting.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsTestLabPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'Lab',
};

/**
 * The per-test Lab picker (beast B4): the Picker-stack port of MaterialsTestLabSelector, mirroring the
 * legacy provider 1:1 on the MaterialsCascadePicker base.
 *
 * SIBLING of MaterialsLabPicker (NOT a subclass): both are thin layers with Entity:'Lab', but the BIND
 * TARGET differs — MaterialsLabPicker binds the sample's labs (SampleLabJoin); this one binds a single
 * TEST's lab (the row's TestInstance from the Test selector's triple). On a lab pick it DUAL-WRITES the
 * test's lab — `TestInstance.IDLab` (direct FK) and a `TestInstanceLabJoin` — and asks the sample's lab
 * selector to reconcile with the per-test labs (`SampleLabSync`, see _LabRouting). Single-select (one lab
 * per test).
 */
class PictProviderInputTypeMaterialsTestLabPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/** Labs are customer-scoped (row-level auth), sorted by Name — same as the sample lab picker.
	 *  @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 *  @return {{Filters: Array<string>, BackOffFilters: Array<string>}} */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		tmpSplit.Filters.push('FSF~Name~ASC~0');
		return tmpSplit;
	}

	/** Init: legacy defaults (single-select, Name EntityTag). */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Tabular init + the persisted-lab seed: the column binds to the nested TestInstance.IDLab, which a
	 * tabular cell does NOT marshal into pValue on (re)open — so a persisted/adopted lab renders blank.
	 * PUSH it via the value-commit primitive — which writes the value AND drives the fetch + widget
	 * paint, exactly like a fresh pick. Ported 1:1.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if ((pValue === undefined || pValue === null || pValue === '') && pRowIndex != null)
		{
			const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
			if (tmpTestInstance && tmpTestInstance.IDLab)
			{
				this._setValueAndCommit(pView, pInput, tmpTestInstance.IDLab, pRowIndex);
			}
			else
			{
				this._autoFillTestLab(pView, pInput, pRowIndex);
			}
		}
		return tmpResult;
	}

	/**
	 * Fill a row with the resolver's auto-fill answer (see LabScopeResolver.getAutoFillLabID). Only ever runs
	 * on a row that has no lab, so a persisted or user-chosen value is never overwritten; commits through the
	 * same primitive a user pick uses, so the join dual-write and the sample-lab sync ride along unchanged.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string} pRowIndex
	 */
	_autoFillTestLab(pView, pInput, pRowIndex)
	{
		libLabRouting.autoFillTestLab(this.pict, pInput, pRowIndex, pView,
			() => this._getRowTestInstance(pView, pInput, pRowIndex)?.IDLab,
			(pIDLab) => this._setValueAndCommit(pView, pInput, pIDLab, pRowIndex));
	}

	/** One lab per test (single-select), tag on Name. @param {Record<string, any>} pInput */
	_applyTestLabDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = false;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
	}

	/**
	 * The TestLab cascade — the port of the legacy `_onRecordRefresh`: dual-write the test's lab
	 * (TestInstance.IDLab + a TestInstanceLabJoin), ask the sample's labs to reconcile with the per-test
	 * labs, then the in-section repaint + the family bus (super). The row record IS the test triple.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpLab = Array.isArray(pRecord) ? pRecord[0] : pRecord;
		const tmpIDLab = tmpLab && tmpLab.IDLab;
		const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
		if (tmpTestInstance && tmpIDLab)
		{
			tmpTestInstance.IDLab = tmpIDLab;
			this._ensureTestInstanceLabJoin(pView, pInput, pRowIndex, tmpTestInstance, tmpLab);
		}
		libLabRouting.requestSampleLabSync(this.pict);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * The TestInstance for this row. The Testing-G2 table binds to the Test selector's triple collection
	 * (`${TestAddress}_Instances`), so the row record is `{ TestInstance, TestInstanceSampleJoin, ... }`.
	 * Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @return {Record<string, any>|null}
	 */
	_getRowTestInstance(pView, pInput, pRowIndex)
	{
		const tmpRowAddress = this._getRecordAddress(pInput, pRowIndex);
		// the lab address sits inside the row record; walk up to the row triple and read its TestInstance
		const tmpTripleAddress = pInput.PictForm.TestInstanceTripleAddress || tmpRowAddress.replace(/\.[^.]+$/, '');
		const tmpTriple = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTripleAddress);
		if (tmpTriple && tmpTriple.TestInstance && typeof tmpTriple.TestInstance === 'object')
		{
			return tmpTriple.TestInstance;
		}
		// fallback: the row record itself is/holds the TestInstance
		return (tmpTriple && typeof tmpTriple === 'object' && !Array.isArray(tmpTriple)) ? tmpTriple : null;
	}

	/**
	 * Create (or retarget) the TestInstanceLabJoin for this test instance, stored on the row triple at
	 * `_TestInstanceLabJoin` so the projection can sweep it into _EntityData. Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Record<string, any>} pTestInstance @param {Record<string, any>} pLab
	 */
	_ensureTestInstanceLabJoin(pView, pInput, pRowIndex, pTestInstance, pLab)
	{
		// Compose the row-triple sibling address (…_Instances[row]._TestInstanceLabJoin) directly. The record
		// address is the lab's own (…row.TestInstance.IDLab__Record), so stripping one segment lands INSIDE the
		// TestInstance — which drags the join into the TestInstance insert and breaks it with malformed SQL.
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpExisting = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		const tmpJoin = (tmpExisting && typeof tmpExisting === 'object' && !Array.isArray(tmpExisting)) ? tmpExisting : { };
		tmpJoin.IDLab = pLab.IDLab;
		if (pTestInstance.IDTestInstance > 0)
		{
			tmpJoin.IDTestInstance = pTestInstance.IDTestInstance;
			delete tmpJoin.GUIDTestInstance;
		}
		else if (pTestInstance.GUIDTestInstance)
		{
			tmpJoin.GUIDTestInstance = pTestInstance.GUIDTestInstance;
			delete tmpJoin.IDTestInstance;
		}
		if (!tmpJoin.GUIDTestInstanceLabJoin)
		{
			const tmpDocumentGUID = this.pict.manifest.getValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.GUIDDocument') || '';
			// Keyed off the test instance rather than a fresh UUID. There is one join per instance, so the
			// key has to be re-derivable - a re-mint that cannot reproduce it inserts a duplicate row
			// instead of upserting the existing one.
			let tmpTestKey = `ID${pTestInstance.IDTestInstance}`;
			if (pTestInstance.GUIDTestInstance)
			{
				tmpTestKey = String(pTestInstance.GUIDTestInstance).replace(`${tmpDocumentGUID}-`, '');
			}
			tmpJoin.GUIDTestInstanceLabJoin = `${tmpDocumentGUID}-TILJ-${tmpTestKey}`;
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress, tmpJoin);
	}

	/**
	 * Per-row save-time projection hook, dispatched by the base _handleEvent on the sweep. A lab picker
	 * creates no Lab reference record, so the base's creation-gated `__Record` projection is replaced
	 * with projecting this row's TestInstanceLabJoin (rows with no lab picked staged no join, so the
	 * sync no-ops on them). Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string')
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
	}

	/**
	 * Save-time projection: sweep this row's TestInstanceLabJoin into _EntityData. (TestInstance.IDLab
	 * itself rides the Test selector's TestInstance projection — we only own the join here.) Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}
		// Same composed row-triple sibling address as _ensureTestInstanceLabJoin (see the note there).
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		if (tmpJoin && typeof tmpJoin === 'object' && !Array.isArray(tmpJoin) && tmpJoin.GUIDTestInstanceLabJoin)
		{
			if (!tmpEntityData.TestInstanceLabJoin || typeof tmpEntityData.TestInstanceLabJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceLabJoin))
			{
				tmpEntityData.TestInstanceLabJoin = { };
			}
			tmpEntityData.TestInstanceLabJoin[tmpJoin.GUIDTestInstanceLabJoin] = tmpJoin;
		}
	}
}

module.exports = PictProviderInputTypeMaterialsTestLabPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65,"./_LabRouting.js":137}],84:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const libLabRouting = require('./_LabRouting.js');

/**
 * MaterialsTestLabSelector — per-row lab selector for the Testing table.
 *
 * SIBLING of MaterialsLabSelector (NOT a subclass): both are thin layers over MaterialsEntitySelector with
 * Entity:'Lab', so the lab UI (select2 / list / display) is shared base behavior. The difference is the BIND
 * TARGET — MaterialsLabSelector binds the sample's labs (SampleLabJoin); this one binds a single TEST's lab
 * (the row's TestInstance), so it stays a sibling off the base to avoid the 3-level super-entanglement on
 * onInputInitialize.
 *
 * On a lab pick it DUAL-WRITES the test's lab — `TestInstance.IDLab` (direct FK on the row's TestInstance) and
 * a `TestInstanceLabJoin` (IDTestInstance→IDLab) — and asks the sample's lab selector to reconcile with the
 * per-test labs (`SampleLabSync`, see _LabRouting). Single-select (one lab per test). Tabular: the row record is the test triple from
 * the Test selector (`{TestInstance, TestInstanceSampleJoin, DocumentPolyJoin}`), TestInstance carrying IDLab.
 */
/**
 * Install the pin-to-top resolver for a lab selector's select2 options, when the descriptor scopes by
 * `LabScope` and the LabScopeResolver is registered. The resolver answers with its preference ranking
 * (`LabScopeResolver.getPreferredLabIDs`); nothing is hidden.
 *
 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
 * @param {Object} pInput @param {number} [pRowIndex] @param {Object} [pView]
 */
function applyLabPriorityIDs(pPict, pConfigOptions, pInput, pRowIndex, pView)
{
	const tmpEngine = pPict.providers.EntityFilterEngine;
	const tmpResolver = pPict.providers.LabScopeResolver;
	if (!tmpEngine || !tmpResolver || pConfigOptions.GetPriorityIDs)
	{
		return;
	}
	const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
	if (!Array.isArray(tmpFilters))
	{
		return;
	}
	const tmpFilter = tmpFilters.find((pEntry) => pEntry && pEntry.LabScope);
	if (!tmpFilter)
	{
		return;
	}
	const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
	pConfigOptions.GetPriorityIDs = () =>
	{
		return tmpResolver.getPreferredLabIDs(tmpFilter.LabScope,
			{
				IDTest: tmpEngine._readLabScopeTestID(tmpFilter, pInput, tmpRowIndex, pView || null),
				SelectedLabIDs: libLabRouting.collectSelectedTestLabIDs(pPict),
			});
	};
}

class MaterialsTestLabSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab';
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * @param {Object} pView @param {Object} pGroup @param {Object} pRow @param {Object} pInput
	 * @param {any} pValue @param {string} pHTMLSelector @param {string} pTransactionGUID @return {boolean}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pGroup @param {Object} pInput @param {any} pValue
	 * @param {string} pHTMLSelector @param {number} pRowIndex @param {string} pTransactionGUID @return {any}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		// The col binds to the nested TestInstance.IDLab, which a tabular cell does NOT marshal into pValue on
		// (re)open — so a persisted/adopted lab renders blank. Passing the id to super only reaches the fetch; it is
		// never written to the cell's storage, so it's lost on re-marshal. PUSH it via setData — which writes the
		// value AND drives the fetch + select2 paint, exactly like a fresh pick.
		if ((pValue === undefined || pValue === null || pValue === '') && pRowIndex != null)
		{
			const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
			if (tmpTestInstance && tmpTestInstance.IDLab)
			{
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpTestInstance.IDLab);
			}
			else
			{
				this._autoFillTestLab(pView, pInput, pRowIndex);
			}
		}
		return tmpResult;
	}

	/**
	 * Fill a row with the resolver's auto-fill answer (see LabScopeResolver.getAutoFillLabID). Only ever runs on a
	 * row that has no lab, so a persisted or user-chosen value is never overwritten; committed through the same
	 * setData path a user pick uses, so the join dual-write and the sample-lab sync ride along unchanged.
	 * @param {Object} pView @param {Object} pInput @param {number|string} pRowIndex
	 */
	_autoFillTestLab(pView, pInput, pRowIndex)
	{
		libLabRouting.autoFillTestLab(this.pict, pInput, pRowIndex, pView,
			() => this._getRowTestInstance(pView, pInput, pRowIndex)?.IDLab,
			(pIDLab) => pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pIDLab));
	}

	/**
	 * One lab per test (single-select), tag on Name.
	 * @param {Object} pInput
	 */
	_applyTestLabDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = false;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
	}

	/**
	 * Lab list is customer-scoped (row-level auth), sorted by Name — same as the sample lab selector.
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Name' ];
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
		applyLabPriorityIDs(this.pict, pConfigOptions, pInput, pRowIndex, pView);
	}

	/**
	 * On a lab pick: dual-write the test's lab (TestInstance.IDLab + a TestInstanceLabJoin), then ask the sample's
	 * labs to reconcile with the per-test labs. The row record IS the test triple (TestInstance + joins).
	 * @param {Object} pView @param {Object} pInput @param {Object} pRecord @param {string} pRecordAddress
	 * @param {string} pTransactionGUID @param {number} [pRowIndex]
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLab = Array.isArray(pRecord) ? pRecord[0] : pRecord;
		const tmpIDLab = tmpLab && tmpLab.IDLab;
		const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
		if (tmpTestInstance && tmpIDLab)
		{
			tmpTestInstance.IDLab = tmpIDLab;
			this._ensureTestInstanceLabJoin(pView, pInput, pRowIndex, tmpTestInstance, tmpLab);
		}
		libLabRouting.requestSampleLabSync(this.pict);
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLabAddress, pRecord || { });
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * The TestInstance for this row. The Testing-G2 table binds to the Test selector's triple collection
	 * (`${TestAddress}_Instances`), so the row record is `{ TestInstance, TestInstanceSampleJoin, ... }`.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @return {Record<string, any>|null}
	 */
	_getRowTestInstance(pView, pInput, pRowIndex)
	{
		const tmpRowAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		// the lab address sits inside the row record; walk up to the row triple and read its TestInstance
		const tmpTripleAddress = pInput.PictForm.TestInstanceTripleAddress || tmpRowAddress.replace(/\.[^.]+$/, '');
		const tmpTriple = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTripleAddress);
		if (tmpTriple && tmpTriple.TestInstance && typeof tmpTriple.TestInstance === 'object')
		{
			return tmpTriple.TestInstance;
		}
		// fallback: the row record itself is/holds the TestInstance
		return (tmpTriple && typeof tmpTriple === 'object' && !Array.isArray(tmpTriple)) ? tmpTriple : null;
	}

	/**
	 * Create (or retarget) the TestInstanceLabJoin for this test instance, stored on the row triple at
	 * `_TestInstanceLabJoin` so the projection can sweep it into _EntityData.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Record<string, any>} pTestInstance @param {Record<string, any>} pLab
	 */
	_ensureTestInstanceLabJoin(pView, pInput, pRowIndex, pTestInstance, pLab)
	{
		// Compose the row-triple sibling address (…_Instances[row]._TestInstanceLabJoin) directly. The record
		// address is the lab's own (…row.TestInstance.IDLab__Record), so stripping one segment lands INSIDE the
		// TestInstance — which drags the join into the TestInstance insert and breaks it with malformed SQL.
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpExisting = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		const tmpJoin = (tmpExisting && typeof tmpExisting === 'object' && !Array.isArray(tmpExisting)) ? tmpExisting : { };
		tmpJoin.IDLab = pLab.IDLab;
		if (pTestInstance.IDTestInstance > 0)
		{
			tmpJoin.IDTestInstance = pTestInstance.IDTestInstance;
			delete tmpJoin.GUIDTestInstance;
		}
		else if (pTestInstance.GUIDTestInstance)
		{
			tmpJoin.GUIDTestInstance = pTestInstance.GUIDTestInstance;
			delete tmpJoin.IDTestInstance;
		}
		if (!tmpJoin.GUIDTestInstanceLabJoin)
		{
			const tmpDocumentGUID = this.pict.manifest.getValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.GUIDDocument') || '';
			// Keyed off the test instance rather than a fresh UUID. There is one join per instance, so the
			// key has to be re-derivable - a re-mint that cannot reproduce it inserts a duplicate row
			// instead of upserting the existing one.
			let tmpTestKey = `ID${pTestInstance.IDTestInstance}`;
			if (pTestInstance.GUIDTestInstance)
			{
				tmpTestKey = String(pTestInstance.GUIDTestInstance).replace(`${tmpDocumentGUID}-`, '');
			}
			tmpJoin.GUIDTestInstanceLabJoin = `${tmpDocumentGUID}-TILJ-${tmpTestKey}`;
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress, tmpJoin);
	}

	/**
	 * Per-row save-time projection hook. The base dispatches this per row on the ProjectEntityDataRecords sweep
	 * (via onAfterEventTabularCompletion). A lab picker creates no Lab reference record, so we override the base
	 * (skipping its AllowEntityCreation-gated Lab upsert) and instead project this row's TestInstanceLabJoin into
	 * the shared _EntityData. Rows with no lab picked staged no join, so the sync no-ops on them.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string')
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
	}

	/**
	 * Save-time projection: sweep this row's TestInstanceLabJoin into _EntityData. (TestInstance.IDLab itself
	 * rides the Test selector's TestInstance projection — we only own the join here.)
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}
		// Compose the row-triple sibling address (…_Instances[row]._TestInstanceLabJoin) directly. The record
		// address is the lab's own (…row.TestInstance.IDLab__Record), so stripping one segment lands INSIDE the
		// TestInstance — which drags the join into the TestInstance insert and breaks it with malformed SQL.
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		if (tmpJoin && typeof tmpJoin === 'object' && !Array.isArray(tmpJoin) && tmpJoin.GUIDTestInstanceLabJoin)
		{
			if (!tmpEntityData.TestInstanceLabJoin || typeof tmpEntityData.TestInstanceLabJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceLabJoin))
			{
				tmpEntityData.TestInstanceLabJoin = { };
			}
			tmpEntityData.TestInstanceLabJoin[tmpJoin.GUIDTestInstanceLabJoin] = tmpJoin;
		}
	}
}

module.exports = MaterialsTestLabSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68,"./_LabRouting.js":137}],85:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsTestPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// The Test selector is THE save-projection driver: its onBeforeSaveDataAsync fires the
	// _EntityData sweep unconditionally (legacy parity), so it must ride the app save lifecycle.
	AutoSaveDataWithApp: true,
	Entity: 'Test',
};

/**
 * The Test picker (beast B3 — the projection DRIVER): the Picker-stack port of MaterialsTestSelector,
 * mirroring the 1030-line legacy provider 1:1 on the MaterialsCascadePicker base. Selecting tests
 * synthesizes a per-test THREE-RECORD TRIPLE — TestInstance / TestInstanceSampleJoin /
 * DocumentPolyJoin — reconciled by IDTest so server-assigned ids and downstream edits survive
 * re-selection; the single-select path keeps the legacy singular shapes (`_Instance` / `_SampleJoin` /
 * `_DocumentPolyJoin`, un-suffixed GUIDs). On a bound sample's SampleChanged it re-keys the joins and
 * soft-adopts the sample's PERSISTED tests from the DB (3-level REST walk). Its save hook drives the
 * ProjectEntityDataRecords sweep for the whole form.
 */
class PictProviderInputTypeMaterialsTestPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/**
	 * A Test is committed by its HASH (the legacy identity — not the id, not a GUID), so the picker's
	 * ValueField, the identity-aware `__Record` resolve (`FBL~Hash~INN`) and the local-record guard all
	 * key on it.
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || 'Hash';
	}

	/**
	 * Mandatory Test-catalog scoping, ported from the legacy HandleSearchFilters: only Active,
	 * non-Collection tests are selectable. Any contextual filters are paren-wrapped so the appended
	 * clauses AND against the whole set.
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}}
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		const tmpFilters = tmpSplit.Filters;
		if (tmpFilters.length > 0)
		{
			tmpFilters.unshift('FOP~0~(~0');
			tmpFilters.push('FCP~0~)~0');
		}
		tmpFilters.push('FBV~Active~EQ~1');
		tmpFilters.push('FBV~Collection~EQ~0');
		return tmpSplit;
	}

	/** The (creation-opt-in) synthesized Test — legacy '-T-' GUID fallback preserved. */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			tmpRecord = { GUIDTest: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-T-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		return tmpRecord;
	}

	/** Init: default the Hash EntityTag + mint/configure the TEST-type tracking GUID (ported 1:1). */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, null, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = tmpTrackingGUID;
		}
		return tmpResult;
	}

	/** Tabular twin of the init (per-row TEST tracking GUIDs; the flag collapses to true). */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return tmpResult;
	}

	/**
	 * Whether this input is configured for multi-test selection: the non-Multiple path keeps the legacy
	 * SINGULAR data shapes (one TestInstance at `${addr}_Instance`, un-suffixed GUIDs); Multiple builds
	 * the keyed `_Instances` triple collection with per-test GUID suffixes.
	 * @param {Record<string, any>} pInput @return {boolean}
	 */
	_isMultiple(pInput)
	{
		return !!(pInput && pInput.PictForm && pInput.PictForm.Multiple);
	}

	/**
	 * Read the triple collection for this input/row, always as an array.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>}
	 */
	_getTestInstances(pView, pInput, pRowIndex)
	{
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		return Array.isArray(tmpTestInstances) ? tmpTestInstances : [ ];
	}

	/**
	 * A de-selected Test takes its whole triple with it. Picker twin of
	 * `MaterialsTestSelector._collectRemovedDependentRecords`.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpTriples = this._getTestInstances(pView, pInput, pRowIndex);
		if (tmpTriples.length < 1)
		{
			return [ ];
		}
		const tmpIdentity = this._getRecordIdentity(pInput);
		const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		const tmpRetainedIDTests = new Set();
		for (const tmpRecord of Array.isArray(tmpHeld) ? tmpHeld : [ tmpHeld ])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			if (pRetainedIdentities.has(String(tmpRecord[tmpIdentity])))
			{
				tmpRetainedIDTests.add(String(tmpRecord.IDTest));
			}
		}
		const tmpRemovals = [ ];
		for (const tmpTriple of tmpTriples)
		{
			const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
			if (!tmpTestInstance || typeof tmpTestInstance !== 'object')
			{
				continue;
			}
			if (tmpRetainedIDTests.has(String(tmpTestInstance.IDTest)))
			{
				continue;
			}
			tmpRemovals.push(...ScopedEntityData.collectTestInstanceUnit(tmpTriple));
		}
		return tmpRemovals;
	}

	/**
	 * Build (or reuse, matched by IDTest — preserving server ids + downstream edits) the
	 * TestInstance / TestInstanceSampleJoin / DocumentPolyJoin triple for one selected Test.
	 * Ported 1:1 (per-test GUID suffixes off one salt; saved-vs-unsaved document + sample keying).
	 * @param {Record<string, any>} pRecord @param {Array<any>} pCurrentInstances
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex
	 * @return {{ Name: string, TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }}
	 */
	_buildTestInstanceTriple(pRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		// Per-test GUID suffix so multiple instances built off one salt don't collide.
		const tmpGUIDSuffix = (pRecord && pRecord.IDTest != null) ? `-${pRecord.IDTest}` : '';
		const tmpTestHash = (pRecord && pRecord.Hash) || '';
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;

		const tmpExistingIndex = Array.isArray(pCurrentInstances) ? pCurrentInstances.findIndex((pTriple) => pTriple && pTriple.TestInstance && pTriple.TestInstance.IDTest == pRecord.IDTest) : -1;
		let tmpTestInstance;
		let tmpTestInstanceSampleJoin;
		let tmpDocumentPolyJoin;
		let tmpExistingTriple = null;
		if (tmpExistingIndex >= 0)
		{
			tmpExistingTriple = pCurrentInstances[tmpExistingIndex];
			pCurrentInstances.splice(tmpExistingIndex, 1);
			tmpTestInstance = tmpExistingTriple.TestInstance;
			tmpTestInstanceSampleJoin = tmpExistingTriple.TestInstanceSampleJoin;
			tmpDocumentPolyJoin = tmpExistingTriple.DocumentPolyJoin;
		}

		if (!tmpTestInstance)
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: pRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
			tmpTestInstance.GUIDTestInstance += tmpGUIDSuffix;
			tmpTestInstance.IDTest = pRecord.IDTest;
		}
		else
		{
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}${tmpGUIDSuffix}`;
			}
			tmpTestInstance.IDTest = pRecord.IDTest;
			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		if (!(tmpTestInstance.IDProject > 0) && tmpDocument && tmpDocument.IDProject > 0)
		{
			tmpTestInstance.IDProject = tmpDocument.IDProject;
		}
		if (pRecord && typeof pRecord === 'object')
		{
			if (pRecord.IDTest > 0)
			{
				tmpTestInstance.IDTest = pRecord.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (pRecord.GUIDTest)
			{
				tmpTestInstance.GUIDTest = pRecord.GUIDTest;
			}
		}

		if (!tmpDocumentPolyJoin)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${tmpSalt}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin += tmpGUIDSuffix;
			}
			tmpDocumentPolyJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
		}
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}

		if (!tmpTestInstanceSampleJoin)
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${tmpSalt}`,
				}));
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin += tmpGUIDSuffix;
			}
		}
		if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
		{
			if (tmpTestInstance.IDTestInstance > 0)
			{
				tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
				delete tmpTestInstanceSampleJoin.GUIDTestInstance;
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
			}
		}
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (pSample && typeof pSample === 'object')
		{
			if (pSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = pSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (pSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = pSample.GUIDSample;
			}
		}

		// Name is a display-only flat field for the tabular Test column; the wrapper is never persisted (the
		// projection writes TestInstance / TestInstanceSampleJoin / DocumentPolyJoin), so it needs no strip. A reused
		// triple keeps the row state other inputs park on it — the per-test lab selector's `_TestInstanceLabJoin`.
		return Object.assign({ }, tmpExistingTriple, { Name: (tmpTestInstance && tmpTestInstance.Name) || '', TestInstance: tmpTestInstance, TestInstanceSampleJoin: tmpTestInstanceSampleJoin, DocumentPolyJoin: tmpDocumentPolyJoin });
	}

	/**
	 * Diff the selected Tests against the existing triples: reuse matches (by IDTest), synthesize new,
	 * drop deselected. Ported 1:1.
	 * @param {Array<Record<string, any>>} pRecords @param {Array<any>} pCurrentInstances
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex @return {Array<any>}
	 */
	_syncTestInstances(pRecords, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		if (!Array.isArray(pCurrentInstances))
		{
			pCurrentInstances = [];
		}
		const tmpInstances = [ ];
		for (const tmpRecord of pRecords || [])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object')
			{
				continue;
			}
			tmpInstances.push(this._buildTestInstanceTriple(tmpRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex));
		}
		return tmpInstances;
	}

	/**
	 * Soft-adopt the bound Sample's PERSISTED tests from the DB on (re)open — the saved FormData triples
	 * can be stale client placeholders that were never persisted (the materials concierge creates the
	 * real TestInstances server-side). Walks TestInstanceSampleJoins(IDSample) → TestInstances → Tests,
	 * assembles each triple FROM the DB record (the DB TestInstanceLabJoin via `_attachAdoptedLabJoins`;
	 * DocumentPolyJoin left null for _buildTestInstanceTriple
	 * to synthesize against the doc), writes them at the instances address, then setDataByInput the
	 * hashes so the rebuild reconciles by IDTest and REUSES the adopted triples. Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Record<string, any>} pSampleRecord
	 */
	_loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, pSampleRecord)
	{
		const tmpRefreshEvent = 'SampleTestAdopt';
		pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
		const fComplete = () => pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
		this.pict.HeadlightRestClient.getJSON(`TestInstanceSampleJoins/FilteredTo/FBV~IDSample~EQ~${pSampleRecord.IDSample}`, (pError, pJoins) =>
		{
			const tmpJoins = Array.isArray(pJoins) ? pJoins.filter((pJoin) => parseInt(pJoin.IDTestInstance, 10) > 0) : [];
			if (!tmpJoins.length)
			{
				fComplete();
				return;
			}
			const tmpIDTestInstances = [ ...new Set(tmpJoins.map((pJoin) => parseInt(pJoin.IDTestInstance, 10))) ];
			this.pict.HeadlightRestClient.getJSON(`TestInstances/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError2, pTestInstances) =>
			{
				const tmpTestInstances = Array.isArray(pTestInstances) ? pTestInstances.filter((pTestInstance) => parseInt(pTestInstance.IDTest, 10) > 0) : [];
				if (!tmpTestInstances.length)
				{
					fComplete();
					return;
				}
				const tmpIDTests = [ ...new Set(tmpTestInstances.map((pTestInstance) => parseInt(pTestInstance.IDTest, 10))) ];
				this.pict.HeadlightRestClient.getJSON(`Tests/FilteredTo/FBL~IDTest~INN~${tmpIDTests.join(',')}`, (pError3, pTests) =>
				{
					const tmpHashByTest = {};
					for (const tmpTest of Array.isArray(pTests) ? pTests : [])
					{
						if (tmpTest && tmpTest.Hash)
						{
							tmpHashByTest[tmpTest.IDTest] = tmpTest.Hash;
						}
					}
					const tmpJoinByTI = {};
					for (const tmpJoin of tmpJoins)
					{
						tmpJoinByTI[parseInt(tmpJoin.IDTestInstance, 10)] = tmpJoin;
					}
					const tmpAdopted = [];
					const tmpHashes = [];
					for (const tmpTestInstance of tmpTestInstances)
					{
						const tmpHash = tmpHashByTest[tmpTestInstance.IDTest];
						if (!tmpHash)
						{
							continue;
						}
						const tmpJoin = tmpJoinByTI[parseInt(tmpTestInstance.IDTestInstance, 10)] || {};
						tmpAdopted.push(
							{
								Name: tmpTestInstance.Name || `Sample Test for ${tmpHash}`,
								TestInstance: ScopedEntityData.adoptTestInstance(this.pict, tmpTestInstance),
								TestInstanceSampleJoin: { IDTestInstanceSampleJoin: tmpJoin.IDTestInstanceSampleJoin, GUIDTestInstanceSampleJoin: tmpJoin.GUIDTestInstanceSampleJoin, IDSample: tmpJoin.IDSample, IDTestInstance: tmpTestInstance.IDTestInstance },
								DocumentPolyJoin: null,
							});
						tmpHashes.push(tmpHash);
					}
					if (!tmpAdopted.length)
					{
						fComplete();
						return;
					}
					this._attachAdoptedLabJoins(tmpAdopted, this._getTestInstances(pView, pInput, pRowIndex), () =>
					{
						const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
						const tmpInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
						this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpInstancesAddress, tmpAdopted);
						ScopedEntityData.beginProgrammaticLoad(this.pict);
						try
						{
							pView.setDataByInput(pInput, tmpHashes.join(','));
						}
						finally
						{
							ScopedEntityData.endProgrammaticLoad(this.pict);
						}
						fComplete();
					});
				});
			});
		});
	}

	/**
	 * The triple the form held before adoption for the same test: matched on the TestInstance id, then its GUID,
	 * then the Test.
	 *
	 * @param {Record<string, any>} pTriple - An adopted triple.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @return {Record<string, any>|null} - The held triple, or null.
	 */
	_findHeldTriple(pTriple, pHeldInstances)
	{
		const tmpTestInstance = (pTriple && pTriple.TestInstance) || { };
		const tmpHeld = (Array.isArray(pHeldInstances) ? pHeldInstances : [ ]).filter((pHeldTriple) => pHeldTriple && pHeldTriple.TestInstance && typeof pHeldTriple.TestInstance === 'object');
		const tmpMatchers =
		[
			(pHeldTriple) => Number(tmpTestInstance.IDTestInstance) > 0 && Number(pHeldTriple.TestInstance.IDTestInstance) === Number(tmpTestInstance.IDTestInstance),
			(pHeldTriple) => !!tmpTestInstance.GUIDTestInstance && pHeldTriple.TestInstance.GUIDTestInstance === tmpTestInstance.GUIDTestInstance,
			(pHeldTriple) => Number(tmpTestInstance.IDTest) > 0 && Number(pHeldTriple.TestInstance.IDTest) === Number(tmpTestInstance.IDTest),
		];
		for (const fMatches of tmpMatchers)
		{
			const tmpMatch = tmpHeld.find(fMatches);
			if (tmpMatch)
			{
				return tmpMatch;
			}
		}
		return null;
	}

	/**
	 * Give each adopted triple the lab join the database holds for its TestInstance, so the per-test lab picker
	 * reuses the persisted row rather than minting one the (TestInstance, Lab) unique key refuses. Where a
	 * TestInstance has several, the one on its own lab wins. With no live row the triple keeps the lab join the form
	 * held for that test, and a failed read keeps every held one. Mirrors MaterialsTestSelector.
	 *
	 * @param {Array<Record<string, any>>} pAdopted - The triples assembled from the database.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @param {() => void} fDone - Called once, when every triple's lab join is settled.
	 */
	_attachAdoptedLabJoins(pAdopted, pHeldInstances, fDone)
	{
		const fCarryHeld = (pTriple) =>
		{
			const tmpHeld = this._findHeldTriple(pTriple, pHeldInstances);
			if (tmpHeld && tmpHeld._TestInstanceLabJoin && typeof tmpHeld._TestInstanceLabJoin === 'object')
			{
				pTriple._TestInstanceLabJoin = tmpHeld._TestInstanceLabJoin;
			}
		};
		let tmpSettled = false;
		const fSettle = () =>
		{
			if (tmpSettled)
			{
				return;
			}
			tmpSettled = true;
			fDone();
		};
		const tmpIDTestInstances = [ ...new Set(pAdopted.map((pTriple) => parseInt(pTriple.TestInstance.IDTestInstance, 10)).filter((pID) => pID > 0)) ];
		if (tmpIDTestInstances.length < 1)
		{
			pAdopted.forEach(fCarryHeld);
			return fSettle();
		}
		try
		{
			this.pict.HeadlightRestClient.getJSON(`TestInstanceLabJoins/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError, pLabJoins) =>
			{
				try
				{
					if (pError || !Array.isArray(pLabJoins))
					{
						pAdopted.forEach(fCarryHeld);
						return;
					}
					const tmpRowsByTestInstance = { };
					for (const tmpRow of pLabJoins)
					{
						if (!tmpRow || !(Number(tmpRow.IDTestInstanceLabJoin) > 0) || typeof tmpRow.GUIDTestInstanceLabJoin !== 'string')
						{
							continue;
						}
						const tmpKey = parseInt(tmpRow.IDTestInstance, 10);
						tmpRowsByTestInstance[tmpKey] = tmpRowsByTestInstance[tmpKey] || [ ];
						tmpRowsByTestInstance[tmpKey].push(tmpRow);
					}
					for (const tmpTriple of pAdopted)
					{
						const tmpRows = tmpRowsByTestInstance[parseInt(tmpTriple.TestInstance.IDTestInstance, 10)] || [ ];
						if (tmpRows.length < 1)
						{
							fCarryHeld(tmpTriple);
							continue;
						}
						const tmpRow = tmpRows.find((pRow) => Number(pRow.IDLab) === Number(tmpTriple.TestInstance.IDLab)) || tmpRows[0];
						if (tmpRows.length > 1 && this.log && typeof this.log.warn === 'function')
						{
							this.log.warn(`MaterialsTestPicker: TestInstance ${tmpTriple.TestInstance.IDTestInstance} has ${tmpRows.length} lab joins; adopting ${tmpRow.IDTestInstanceLabJoin} (lab ${tmpRow.IDLab}).`);
						}
						tmpTriple._TestInstanceLabJoin =
						{
							IDTestInstanceLabJoin: Number(tmpRow.IDTestInstanceLabJoin),
							GUIDTestInstanceLabJoin: tmpRow.GUIDTestInstanceLabJoin,
							IDTestInstance: Number(tmpRow.IDTestInstance),
							IDLab: Number(tmpRow.IDLab),
						};
					}
				}
				catch (pError2)
				{
					pAdopted.forEach((pTriple) =>
					{
						if (!pTriple._TestInstanceLabJoin)
						{
							fCarryHeld(pTriple);
						}
					});
				}
				finally
				{
					fSettle();
				}
			});
		}
		catch (pError)
		{
			pAdopted.forEach(fCarryHeld);
			fSettle();
		}
	}

	/**
	 * The Test cascade — the port of the legacy `_onRecordRefresh`. Multiple: reconcile the triple
	 * collection at `_Instances` (clear → []). Single: the legacy singular shapes. Then the in-section
	 * repaint + the family bus (super).
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		if (!this._isMultiple(pInput))
		{
			this._onRecordRefreshSingle(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
			return;
		}
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpCleared = !pRecord || (Array.isArray(pRecord) && pRecord.length === 0) ||
			(typeof pRecord === 'object' && !Array.isArray(pRecord) && Object.keys(pRecord).length === 0);
		if (tmpCleared)
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, [ ]);
			libLabRouting.requestSampleLabSync(this.pict);
			if (typeof pView.marshalToView === 'function')
			{
				pView.marshalToView();
			}
			super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
			return;
		}
		let tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		if (!Array.isArray(tmpTestInstances))
		{
			if (tmpTestInstances)
			{
				this.log.error(`MaterialsTestPicker: TestInstances at address ${tmpTestInstancesAddress} is not an array`, { tmpTestInstances });
			}
			tmpTestInstances = [ ];
		}
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		tmpTestInstances = this._syncTestInstances(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpTestInstances, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, tmpTestInstances);
		libLabRouting.requestSampleLabSync(this.pict);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * Single-select refresh: the legacy singular TestInstance / DocumentPolyJoin / TestInstanceSampleJoin
	 * objects (one each, un-suffixed GUIDs) at their historical addresses. Ported 1:1; a cleared picker
	 * ({} from the seam) resets all three.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onRecordRefreshSingle(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
		const tmpTestDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
		const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceSampleJoinAddress || `${tmpTestAddress}_SampleJoin`;
		/** @type {Record<string, any>|null} */
		let tmpRecord = null;
		if (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord) && Object.keys(pRecord).length > 0)
		{
			tmpRecord = pRecord;
		}
		else if (Array.isArray(pRecord) && pRecord.length > 0)
		{
			tmpRecord = pRecord[0];
		}
		if (!tmpRecord)
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, { });
			super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
			return;
		}
		const tmpTestHash = tmpRecord.Hash || '';
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
		let tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
		if (!tmpTestInstance || (typeof tmpTestInstance === 'object' && Object.keys(tmpTestInstance).length === 0))
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: tmpRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
		}
		else
		{
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
			tmpTestInstance.IDTest = tmpRecord.IDTest;
			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);

		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress);
		// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
		if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
		}
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		let tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!tmpTestInstanceSampleJoin || (typeof tmpTestInstanceSampleJoin === 'object' && Object.keys(tmpTestInstanceSampleJoin).length === 0))
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${this._getSalt(pView, pInput, pRowIndex)}`,
				}));
			if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
			{
				if (tmpTestInstance.IDTestInstance > 0)
				{
					tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
					delete tmpTestInstanceSampleJoin.GUIDTestInstance;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
				}
			}
			if (tmpSample && tmpSample.GUIDSample)
			{
				if (tmpSample.IDSample > 0)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
				}
			}

			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
		}
		if (tmpTest && typeof tmpTest === 'object')
		{
			if (tmpTest.IDTest > 0)
			{
				tmpTestInstance.IDTest = tmpTest.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (tmpTest.GUIDTest)
			{
				tmpTestInstance.GUIDTest = tmpTest.GUIDTest;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (tmpSample && typeof tmpSample === 'object')
		{
			if (tmpSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (tmpSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, tmpTestInstanceSampleJoin);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * The bound Sample record: ask the family over the bus (PushRecord into TempData), falling back to
	 * the conventional SampleAddress. Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * THE PROJECTION DRIVER: unlike the creation-latched base, the Test selector fires the _EntityData
	 * sweep on EVERY save (legacy parity — every sibling projector rides this trigger).
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		this._entityCreationEnabled = true;
		return super.onBeforeSaveDataAsync(fCallback);
	}

	/**
	 * Family + save-sweep events — ported 1:1: TestResultChanged (TEST-tracking-matched: stamp the
	 * result onto the instance(s)); GetTestHash (TEST-tracking-matched: write the hash to the payload
	 * address); SampleChanged (SAMPLE-tracking-matched: re-key the joins to the new sample; multi also
	 * soft-adopts its persisted tests); ProjectEntityDataRecords (project the triples).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'TestResultChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestResult = tmpEventPayload;

			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
				const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
			}
			return;
		}

		if (tmpEventType === 'GetTestHash')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
			const tmpTestRecord = Array.isArray(tmpTest) ? tmpTest[0] : tmpTest;
			const tmpTestHash = tmpTestRecord ? tmpTestRecord.Hash : null;
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload, tmpTestHash);
		}

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				return;
			}
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
				const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
				return;
			}
			if (tmpSampleRecord.IDSample)
			{
				this._loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, tmpSampleRecord);
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstanceSampleJoin = tmpTriple && tmpTriple.TestInstanceSampleJoin;
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
			}
			return;
		}
		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
				const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpDocumentPolyJoin = tmpTriple && tmpTriple.DocumentPolyJoin;
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
			}
		}
	}

	/**
	 * Project a TestInstance into the save-time comprehension with its TestResult held back. The result
	 * is staged when the user sets it (`_stageDeferredTestResult`), not from here. Both Test families
	 * route through the same primitive.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance record being projected.
	 * @param {Record<string, any>} pEntityData - The save-time `<Entity>.<GUID>` target.
	 */
	_projectTestInstanceDeferringResult(pTestInstance, pEntityData)
	{
		if (!ScopedEntityData.projectTestInstanceDeferringResult(pTestInstance, pEntityData))
		{
			this.pict.log.warn(`MaterialsTestPicker: could not project the test instance ${pTestInstance?.GUIDTestInstance}; it will not be saved.`);
		}
	}

	/**
	 * Stage the test result the user just entered for the workflow trigger that applies it
	 * (`PictForm.DeferredComprehensionContext`, default `OnEnteringState.Approved`).
	 *
	 * Staging happens at the edit rather than on the save sweep: the sweep writes what the form holds,
	 * which cannot tell a result the user cleared from one that was never entered, and would re-assert a
	 * standing leaf on every save. A cleared result stages as a clear — no result is a valid outcome.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance whose result changed.
	 * @param {Record<string, any>} pInput - The form input descriptor.
	 * @return {boolean} - True when the result was staged.
	 */
	_stageDeferredTestResult(pTestInstance, pInput)
	{
		const tmpGUID = pTestInstance && pTestInstance.GUIDTestInstance;
		if (!tmpGUID)
		{
			this.pict.log.warn('MaterialsTestPicker: a test result changed on an instance with no GUIDTestInstance; it cannot be staged for approval.');
			return false;
		}
		const tmpDeferredContext = ScopedEntityData.resolveDeferredContext(pInput, this.options?.DeferredComprehensionContext);
		return ScopedEntityData.stageDeferredValue(this.pict, tmpDeferredContext, 'TestInstance', tmpGUID, 'TestResult', pTestInstance.TestResult);
	}

	/**
	 * Project the triple records (keyed by their GUIDs) into the entity-data collection — the plural
	 * counterpart of the base _syncRecordToEntityData. Single + multi shapes ported 1:1 (the Test
	 * CATALOG record itself never projects; the triples are the created data).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		if (!this._isMultiple(pInput))
		{
			const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
			const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
			const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}
			return;
		}

		for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
		{
			if (!tmpTriple || typeof tmpTriple !== 'object')
			{
				continue;
			}
			const tmpTestInstance = tmpTriple.TestInstance;
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoin = tmpTriple.TestInstanceSampleJoin;
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}

			const tmpDocumentPolyJoin = tmpTriple.DocumentPolyJoin;
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpEntityData.DocumentPolyJoin || typeof tmpEntityData.DocumentPolyJoin !== 'object' || Array.isArray(tmpEntityData.DocumentPolyJoin))
				{
					tmpEntityData.DocumentPolyJoin = { };
				}
				tmpEntityData.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}
}

module.exports = PictProviderInputTypeMaterialsTestPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":65,"./_LabRouting.js":137,"./_ScopedEntityData.js":139}],86:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * Input type that lets a user remove a dynamically injected test section from a
 * form. Confirms via modal, then delegates to DocumentDynamicSectionManager to
 * tombstone the section registration, stage deletion of the underlying
 * TestInstance in the document's OnSave comprehension, and tear down the live
 * section views.
 */
class MaterialsTestSectionRemoverInputType extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Prompt for confirmation, then remove the dynamic section registered at the
	 * given hash along with its underlying TestInstance (deleted on form save).
	 *
	 * @param {string} pRegistrationHash - The __DynamicSectionData registration hash for the section.
	 */
	requestSectionRemoval(pRegistrationHash)
	{
		const tmpSectionManager = this.pict.providers.DocumentDynamicSectionManager;
		if (!tmpSectionManager)
		{
			this.pict.log.error(`MaterialsTestSectionRemoverInputType: DocumentDynamicSectionManager provider not available; cannot remove section.`, { pRegistrationHash });
			return;
		}
		const tmpRegistration = this.pict.AppData.DocumentData?.ReportData?.FormData?.__DynamicSectionData?.[pRegistrationHash];
		if (!tmpRegistration)
		{
			this.pict.log.error(`MaterialsTestSectionRemoverInputType: No dynamic section registration found for hash [${pRegistrationHash}]; cannot remove section.`);
			return;
		}
		const tmpTestLabel = tmpRegistration.TestHash ? ` ${tmpRegistration.TestHash}` : '';
		this.fable.HeadlightModal.spawnModal(
			{
				title: 'Remove Test',
				message: `Remove test${tmpTestLabel} and its section from this form? The test will be deleted from the sample when the form is saved.`,
				confirmText: 'Remove Test',
				confirmIcon: 'trash-alt',
				confirmColor: 'is-danger',
			},
			() =>
			{
				tmpSectionManager.removeTestSection(pRegistrationHash);
			},
			null);
	}
}

module.exports = MaterialsTestSectionRemoverInputType;

},{"pict-section-form":497}],87:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

class MaterialsTestSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, null, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = tmpTrackingGUID;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'Hash';
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			//FIXME: need to get some kind of record uniqueness injected here
			tmpRecord = { GUIDTest: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-T-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		return tmpRecord;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'TestResultChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestResult = tmpEventPayload;

			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
				const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
			}
			return;
		}

		if (tmpEventType === 'GetTestHash')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
			const tmpTestRecord = Array.isArray(tmpTest) ? tmpTest[0] : tmpTest;
			const tmpTestHash = tmpTestRecord ? tmpTestRecord.Hash : null;
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload, tmpTestHash);
		}

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				return;
			}
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
				const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
				return;
			}
			if (tmpSampleRecord.IDSample)
			{
				this._loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, tmpSampleRecord);
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstanceSampleJoin = tmpTriple && tmpTriple.TestInstanceSampleJoin;
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
			}
			return;
		}
		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
				const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpDocumentPolyJoin = tmpTriple && tmpTriple.DocumentPolyJoin;
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
			}
		}
	}

	/**
	 * Whether this input is configured for multi-test selection. The non-Multiple (single-select) path keeps the
	 * legacy singular data shapes (one TestInstance object at ${addr}_Instance, un-suffixed GUIDs); the Multiple
	 * path builds the keyed _Instances triple collection with per-test GUID suffixes.
	 *
	 * @param {Object} pInput - The input object.
	 *
	 * @return {boolean}
	 */
	_isMultiple(pInput)
	{
		return !!(pInput && pInput.PictForm && pInput.PictForm.Multiple);
	}

	/**
	 * Read the TestInstance triple collection (TestInstance / TestInstanceSampleJoin / DocumentPolyJoin per
	 * selected Test) for this input/row, always as an array (empty when unset or malformed).
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} [pRowIndex] - The row index. If present, this is a tabular input.
	 *
	 * @return {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>}
	 */
	_getTestInstances(pView, pInput, pRowIndex)
	{
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		return Array.isArray(tmpTestInstances) ? tmpTestInstances : [ ];
	}

	/**
	 * A de-selected Test takes its whole triple with it — the `TestInstance`, its
	 * `TestInstanceSampleJoin` and its `DocumentPolyJoin` — none of which the base sees, because the
	 * value list holds Test identities and the triples are keyed by `IDTest`.
	 *
	 * The retained `IDTest` set is resolved from the records the input STILL holds, since those are
	 * the only place the identity-to-`IDTest` mapping exists before `_refreshRecord` replaces them.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpTriples = this._getTestInstances(pView, pInput, pRowIndex);
		if (tmpTriples.length < 1)
		{
			return [ ];
		}
		const tmpIdentity = this._getRecordIdentity(pInput);
		const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		const tmpRetainedIDTests = new Set();
		for (const tmpRecord of Array.isArray(tmpHeld) ? tmpHeld : [ tmpHeld ])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			if (pRetainedIdentities.has(String(tmpRecord[tmpIdentity])))
			{
				tmpRetainedIDTests.add(String(tmpRecord.IDTest));
			}
		}
		const tmpRemovals = [ ];
		for (const tmpTriple of tmpTriples)
		{
			const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
			if (!tmpTestInstance || typeof tmpTestInstance !== 'object')
			{
				continue;
			}
			if (tmpRetainedIDTests.has(String(tmpTestInstance.IDTest)))
			{
				continue;
			}
			tmpRemovals.push(...ScopedEntityData.collectTestInstanceUnit(tmpTriple));
		}
		return tmpRemovals;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Build (or reuse) the TestInstance / TestInstanceSampleJoin / DocumentPolyJoin triple for a single selected
	 * Test record. When a matching triple already exists in pCurrentInstances (same IDTest) it is reused so any
	 * server-assigned ids and downstream edits are preserved; otherwise a fresh triple is synthesized with a
	 * per-test-unique GUID (suffixed with the test's IDTest, the way the Lab selector suffixes -${IDLab}).
	 *
	 * @param {Record<string, any>} pRecord - The selected Test record.
	 * @param {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>} pCurrentInstances - Existing triples to diff against (matches are spliced out).
	 * @param {Record<string, any>|null} pSample - The bound Sample record (or null).
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index. If present, this is a tabular input.
	 *
	 * @return {{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }}
	 */
	_buildTestInstanceTriple(pRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		// Per-test GUID suffix so multiple instances built off one salt don't collide.
		const tmpGUIDSuffix = (pRecord && pRecord.IDTest != null) ? `-${pRecord.IDTest}` : '';
		const tmpTestHash = (pRecord && pRecord.Hash) || '';
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;

		const tmpExistingIndex = Array.isArray(pCurrentInstances) ? pCurrentInstances.findIndex((pTriple) => pTriple && pTriple.TestInstance && pTriple.TestInstance.IDTest == pRecord.IDTest) : -1;
		let tmpTestInstance;
		let tmpTestInstanceSampleJoin;
		let tmpDocumentPolyJoin;
		let tmpExistingTriple = null;
		if (tmpExistingIndex >= 0)
		{
			tmpExistingTriple = pCurrentInstances[tmpExistingIndex];
			pCurrentInstances.splice(tmpExistingIndex, 1);
			tmpTestInstance = tmpExistingTriple.TestInstance;
			tmpTestInstanceSampleJoin = tmpExistingTriple.TestInstanceSampleJoin;
			tmpDocumentPolyJoin = tmpExistingTriple.DocumentPolyJoin;
		}

		if (!tmpTestInstance)
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: pRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
			tmpTestInstance.GUIDTestInstance += tmpGUIDSuffix;
			tmpTestInstance.IDTest = pRecord.IDTest;
		}
		else
		{
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}${tmpGUIDSuffix}`;
			}
			tmpTestInstance.IDTest = pRecord.IDTest;
			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		if (!(tmpTestInstance.IDProject > 0) && tmpDocument && tmpDocument.IDProject > 0)
		{
			tmpTestInstance.IDProject = tmpDocument.IDProject;
		}
		if (pRecord && typeof pRecord === 'object')
		{
			if (pRecord.IDTest > 0)
			{
				tmpTestInstance.IDTest = pRecord.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (pRecord.GUIDTest)
			{
				tmpTestInstance.GUIDTest = pRecord.GUIDTest;
			}
		}

		if (!tmpDocumentPolyJoin)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${tmpSalt}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin += tmpGUIDSuffix;
			}
			tmpDocumentPolyJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
		}
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}

		if (!tmpTestInstanceSampleJoin)
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${tmpSalt}`,
				}));
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin += tmpGUIDSuffix;
			}
		}
		if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
		{
			if (tmpTestInstance.IDTestInstance > 0)
			{
				tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
				delete tmpTestInstanceSampleJoin.GUIDTestInstance;
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
			}
		}
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (pSample && typeof pSample === 'object')
		{
			if (pSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = pSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (pSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = pSample.GUIDSample;
			}
		}

		// Name is a display-only flat field for the tabular Test column; the wrapper is never persisted (the projection
		// writes TestInstance / TestInstanceSampleJoin / DocumentPolyJoin), so it needs no strip. A reused triple keeps
		// the row state other inputs park on it — the per-test lab selector's `_TestInstanceLabJoin`.
		return Object.assign({ }, tmpExistingTriple, { Name: (tmpTestInstance && tmpTestInstance.Name) || '', TestInstance: tmpTestInstance, TestInstanceSampleJoin: tmpTestInstanceSampleJoin, DocumentPolyJoin: tmpDocumentPolyJoin });
	}

	/**
	 * Diff the currently-selected Tests against the existing TestInstance triples, reusing matched triples (same
	 * IDTest), synthesizing new ones for newly-selected tests, and dropping deselected ones. Mirrors the Lab
	 * selector's _syncSampleLabJoins, but each entry carries the full TestInstance/TestInstanceSampleJoin/
	 * DocumentPolyJoin triple rather than a single join.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The currently-selected Test records.
	 * @param {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>} pCurrentInstances - The existing triples to diff against.
	 * @param {Record<string, any>|null} pSample - The bound Sample record (or null).
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index. If present, this is a tabular input.
	 *
	 * @return {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>}
	 */
	_syncTestInstances(pRecords, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		if (!Array.isArray(pCurrentInstances))
		{
			pCurrentInstances = [];
		}
		const tmpInstances = [ ];
		for (const tmpRecord of pRecords || [])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object')
			{
				continue;
			}
			tmpInstances.push(this._buildTestInstanceTriple(tmpRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex));
		}
		return tmpInstances;
	}

	/**
	 * Soft-adopt the bound Sample's persisted tests from the DB on (re)open — mirrors the Lab/LineItem selectors'
	 * SampleChanged loaders (load persisted records by IDSample, set them as the current records, then setDataByInput
	 * so the rebuild reconciles by reusing them). The doc's saved FormData triples can be stale client placeholders
	 * that were never persisted — e.g. the materials concierge creates the real TestInstances (carrying IDLab)
	 * server-side without touching the doc, so the FormData keeps the user's original GUID-only triples. This walks
	 * TestInstanceSampleJoins(by IDSample) → TestInstances → Tests, assembles each triple FROM the DB record
	 * (TestInstance with its IDLab + IDTestInstance identity, the DB TISJ, the DB TestInstanceLabJoin via
	 * `_attachAdoptedLabJoins`; DocumentPolyJoin left null for
	 * _buildTestInstanceTriple to synthesize against the doc, since none is persisted), writes them at the instances
	 * address, then setDataByInput the hashes. _syncTestInstances reconciles by IDTest and REUSES the adopted triples,
	 * so per-test labs + identities reflect persisted state and SampleTestChange redraws the Testing section.
	 * Persisted state is authoritative on (re)open.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index (null for the non-tabular SampleTestIDs field).
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Record<string, any>} pSampleRecord - The bound Sample record (must carry a persisted IDSample).
	 */
	_loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, pSampleRecord)
	{
		const tmpRefreshEvent = 'SampleTestAdopt';
		pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
		const fComplete = () => pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
		this.pict.HeadlightRestClient.getJSON(`TestInstanceSampleJoins/FilteredTo/FBV~IDSample~EQ~${pSampleRecord.IDSample}`, (pError, pJoins) =>
		{
			const tmpJoins = Array.isArray(pJoins) ? pJoins.filter((pJoin) => parseInt(pJoin.IDTestInstance, 10) > 0) : [];
			if (!tmpJoins.length)
			{
				fComplete();
				return;
			}
			const tmpIDTestInstances = [ ...new Set(tmpJoins.map((pJoin) => parseInt(pJoin.IDTestInstance, 10))) ];
			this.pict.HeadlightRestClient.getJSON(`TestInstances/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError2, pTestInstances) =>
			{
				const tmpTestInstances = Array.isArray(pTestInstances) ? pTestInstances.filter((pTestInstance) => parseInt(pTestInstance.IDTest, 10) > 0) : [];
				if (!tmpTestInstances.length)
				{
					fComplete();
					return;
				}
				const tmpIDTests = [ ...new Set(tmpTestInstances.map((pTestInstance) => parseInt(pTestInstance.IDTest, 10))) ];
				this.pict.HeadlightRestClient.getJSON(`Tests/FilteredTo/FBL~IDTest~INN~${tmpIDTests.join(',')}`, (pError3, pTests) =>
				{
					const tmpHashByTest = {};
					for (const tmpTest of Array.isArray(pTests) ? pTests : [])
					{
						if (tmpTest && tmpTest.Hash)
						{
							tmpHashByTest[tmpTest.IDTest] = tmpTest.Hash;
						}
					}
					const tmpJoinByTI = {};
					for (const tmpJoin of tmpJoins)
					{
						tmpJoinByTI[parseInt(tmpJoin.IDTestInstance, 10)] = tmpJoin;
					}
					const tmpAdopted = [];
					const tmpHashes = [];
					for (const tmpTestInstance of tmpTestInstances)
					{
						const tmpHash = tmpHashByTest[tmpTestInstance.IDTest];
						if (!tmpHash)
						{
							continue;
						}
						const tmpJoin = tmpJoinByTI[parseInt(tmpTestInstance.IDTestInstance, 10)] || {};
						tmpAdopted.push(
							{
								Name: tmpTestInstance.Name || `Sample Test for ${tmpHash}`,
								TestInstance: ScopedEntityData.adoptTestInstance(this.pict, tmpTestInstance),
								TestInstanceSampleJoin: { IDTestInstanceSampleJoin: tmpJoin.IDTestInstanceSampleJoin, GUIDTestInstanceSampleJoin: tmpJoin.GUIDTestInstanceSampleJoin, IDSample: tmpJoin.IDSample, IDTestInstance: tmpTestInstance.IDTestInstance },
								DocumentPolyJoin: null,
							});
						tmpHashes.push(tmpHash);
					}
					if (!tmpAdopted.length)
					{
						fComplete();
						return;
					}
					this._attachAdoptedLabJoins(tmpAdopted, this._getTestInstances(pView, pInput, pRowIndex), () =>
					{
						const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
						const tmpInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
						this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpInstancesAddress, tmpAdopted);
						ScopedEntityData.beginProgrammaticLoad(this.pict);
						try
						{
							pView.setDataByInput(pInput, tmpHashes.join(','));
						}
						finally
						{
							ScopedEntityData.endProgrammaticLoad(this.pict);
						}
						fComplete();
					});
				});
			});
		});
	}

	/**
	 * The triple the form held before adoption for the same test: matched on the TestInstance id, then its GUID,
	 * then the Test.
	 *
	 * @param {Record<string, any>} pTriple - An adopted triple.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @return {Record<string, any>|null} - The held triple, or null.
	 */
	_findHeldTriple(pTriple, pHeldInstances)
	{
		const tmpTestInstance = (pTriple && pTriple.TestInstance) || { };
		const tmpHeld = (Array.isArray(pHeldInstances) ? pHeldInstances : [ ]).filter((pHeldTriple) => pHeldTriple && pHeldTriple.TestInstance && typeof pHeldTriple.TestInstance === 'object');
		const tmpMatchers =
		[
			(pHeldTriple) => Number(tmpTestInstance.IDTestInstance) > 0 && Number(pHeldTriple.TestInstance.IDTestInstance) === Number(tmpTestInstance.IDTestInstance),
			(pHeldTriple) => !!tmpTestInstance.GUIDTestInstance && pHeldTriple.TestInstance.GUIDTestInstance === tmpTestInstance.GUIDTestInstance,
			(pHeldTriple) => Number(tmpTestInstance.IDTest) > 0 && Number(pHeldTriple.TestInstance.IDTest) === Number(tmpTestInstance.IDTest),
		];
		for (const fMatches of tmpMatchers)
		{
			const tmpMatch = tmpHeld.find(fMatches);
			if (tmpMatch)
			{
				return tmpMatch;
			}
		}
		return null;
	}

	/**
	 * Give each adopted triple the lab join the database holds for its TestInstance, so the per-test lab selector
	 * reuses the persisted row rather than minting a new one the (TestInstance, Lab) unique key refuses. Where a
	 * TestInstance has several, the one on its own lab wins. With no live row the triple keeps the lab join the form
	 * held for that test, and a failed read keeps every held one.
	 *
	 * @param {Array<Record<string, any>>} pAdopted - The triples assembled from the database.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @param {() => void} fDone - Called once, when every triple's lab join is settled.
	 */
	_attachAdoptedLabJoins(pAdopted, pHeldInstances, fDone)
	{
		const fCarryHeld = (pTriple) =>
		{
			const tmpHeld = this._findHeldTriple(pTriple, pHeldInstances);
			if (tmpHeld && tmpHeld._TestInstanceLabJoin && typeof tmpHeld._TestInstanceLabJoin === 'object')
			{
				pTriple._TestInstanceLabJoin = tmpHeld._TestInstanceLabJoin;
			}
		};
		let tmpSettled = false;
		const fSettle = () =>
		{
			if (tmpSettled)
			{
				return;
			}
			tmpSettled = true;
			fDone();
		};
		const tmpIDTestInstances = [ ...new Set(pAdopted.map((pTriple) => parseInt(pTriple.TestInstance.IDTestInstance, 10)).filter((pID) => pID > 0)) ];
		if (tmpIDTestInstances.length < 1)
		{
			pAdopted.forEach(fCarryHeld);
			return fSettle();
		}
		try
		{
			this.pict.HeadlightRestClient.getJSON(`TestInstanceLabJoins/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError, pLabJoins) =>
			{
				try
				{
					if (pError || !Array.isArray(pLabJoins))
					{
						pAdopted.forEach(fCarryHeld);
						return;
					}
					const tmpRowsByTestInstance = { };
					for (const tmpRow of pLabJoins)
					{
						if (!tmpRow || !(Number(tmpRow.IDTestInstanceLabJoin) > 0) || typeof tmpRow.GUIDTestInstanceLabJoin !== 'string')
						{
							continue;
						}
						const tmpKey = parseInt(tmpRow.IDTestInstance, 10);
						tmpRowsByTestInstance[tmpKey] = tmpRowsByTestInstance[tmpKey] || [ ];
						tmpRowsByTestInstance[tmpKey].push(tmpRow);
					}
					for (const tmpTriple of pAdopted)
					{
						const tmpRows = tmpRowsByTestInstance[parseInt(tmpTriple.TestInstance.IDTestInstance, 10)] || [ ];
						if (tmpRows.length < 1)
						{
							fCarryHeld(tmpTriple);
							continue;
						}
						const tmpRow = tmpRows.find((pRow) => Number(pRow.IDLab) === Number(tmpTriple.TestInstance.IDLab)) || tmpRows[0];
						if (tmpRows.length > 1 && this.log && typeof this.log.warn === 'function')
						{
							this.log.warn(`MaterialsTestSelector: TestInstance ${tmpTriple.TestInstance.IDTestInstance} has ${tmpRows.length} lab joins; adopting ${tmpRow.IDTestInstanceLabJoin} (lab ${tmpRow.IDLab}).`);
						}
						tmpTriple._TestInstanceLabJoin =
						{
							IDTestInstanceLabJoin: Number(tmpRow.IDTestInstanceLabJoin),
							GUIDTestInstanceLabJoin: tmpRow.GUIDTestInstanceLabJoin,
							IDTestInstance: Number(tmpRow.IDTestInstance),
							IDLab: Number(tmpRow.IDLab),
						};
					}
				}
				catch (pError2)
				{
					pAdopted.forEach((pTriple) =>
					{
						if (!pTriple._TestInstanceLabJoin)
						{
							fCarryHeld(pTriple);
						}
					});
				}
				finally
				{
					fSettle();
				}
			});
		}
		catch (pError)
		{
			pAdopted.forEach(fCarryHeld);
			fSettle();
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		if (!this._isMultiple(pInput))
		{
			this._onRecordRefreshSingle(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
			return;
		}
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		if (!pRecord || (Array.isArray(pRecord) && pRecord.length === 0))
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, [ ]);
			libLabRouting.requestSampleLabSync(this.pict);
			pView.marshalToView();
			super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
			return;
		}
		let tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		if (!Array.isArray(tmpTestInstances))
		{
			if (tmpTestInstances)
			{
				this.log.error(`MaterialsTestSelectorInputType: TestInstances at address ${tmpTestInstancesAddress} is not an array`, { tmpTestInstances });
			}
			tmpTestInstances = [ ];
		}
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		tmpTestInstances = this._syncTestInstances(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpTestInstances, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, tmpTestInstances);
		libLabRouting.requestSampleLabSync(this.pict);
		//TOOD: is this a good idea? this ensures any fields that use this record are updated immediately, if they are in the same section
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * Single-select (non-Multiple) record refresh. Writes the legacy singular TestInstance / DocumentPolyJoin /
	 * TestInstanceSampleJoin objects (one each) at the ${addr}_Instance / ${addr}_DocumentPolyJoin /
	 * ${addr}_SampleJoin addresses with un-suffixed GUIDs, matching the historical single-record data shape.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefreshSingle(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
		const tmpTestDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
		const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceSampleJoinAddress || `${tmpTestAddress}_SampleJoin`;
		if (!pRecord || (Array.isArray(pRecord) && pRecord.length === 0))
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, { });
			return;
		}
		const tmpTestHash = pRecord.Hash || '';
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
		//FIXME: do these need special tabular handling?
		let tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
		if (!tmpTestInstance || (typeof tmpTestInstance === 'object' && Object.keys(tmpTestInstance).length === 0))
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: pRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
		}
		else
		{
			// Ensure GUID is set - use existing or generate new
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}

			tmpTestInstance.IDTest = pRecord.IDTest;

			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);

		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress);
		// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
		if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
		}
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		let tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!tmpTestInstanceSampleJoin || (typeof tmpTestInstanceSampleJoin === 'object' && Object.keys(tmpTestInstanceSampleJoin).length === 0))
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${this._getSalt(pView, pInput, pRowIndex)}`,
				}));
			if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
			{
				if (tmpTestInstance.IDTestInstance > 0)
				{
					tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
					delete tmpTestInstanceSampleJoin.GUIDTestInstance;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
				}
			}
			if (tmpSample && tmpSample.GUIDSample)
			{
				if (tmpSample.IDSample > 0)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
				}
			}

			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
		}
		if (tmpTest && typeof tmpTest === 'object')
		{
			if (tmpTest.IDTest > 0)
			{
				tmpTestInstance.IDTest = tmpTest.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (tmpTest.GUIDTest)
			{
				tmpTestInstance.GUIDTest = tmpTest.GUIDTest;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (tmpSample && typeof tmpSample === 'object')
		{
			if (tmpSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (tmpSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, tmpTestInstanceSampleJoin);
		//TOOD: is this a good idea? this ensures any fields that use this record are updated immediately, if they are in the same section
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (!this._isScopedEntityDataEnabled())
		{
			this.pict.manifest.setValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.FormData._EntityData', { });
		}
		const tmpEvent = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this._sanitizeProjectedComprehensions();
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * Project a TestInstance into the save-time comprehension with its TestResult held back. The result
	 * is staged when the user sets it (`_stageDeferredTestResult`), not from here. Both Test families
	 * route through the same primitive.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance record being projected.
	 * @param {Record<string, any>} pEntityData - The save-time `<Entity>.<GUID>` target.
	 */
	_projectTestInstanceDeferringResult(pTestInstance, pEntityData)
	{
		if (!ScopedEntityData.projectTestInstanceDeferringResult(pTestInstance, pEntityData))
		{
			this.pict.log.warn(`MaterialsTestSelector: could not project the test instance ${pTestInstance?.GUIDTestInstance}; it will not be saved.`);
		}
	}

	/**
	 * Stage the test result the user just entered for the workflow trigger that applies it
	 * (`PictForm.DeferredComprehensionContext`, default `OnEnteringState.Approved`).
	 *
	 * Staging happens at the edit rather than on the save sweep: the sweep writes what the form holds,
	 * which cannot tell a result the user cleared from one that was never entered, and would re-assert a
	 * standing leaf on every save. A cleared result stages as a clear — no result is a valid outcome.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance whose result changed.
	 * @param {Object} pInput - The form input descriptor.
	 * @return {boolean} - True when the result was staged.
	 */
	_stageDeferredTestResult(pTestInstance, pInput)
	{
		const tmpGUID = pTestInstance && pTestInstance.GUIDTestInstance;
		if (!tmpGUID)
		{
			this.pict.log.warn('MaterialsTestSelector: a test result changed on an instance with no GUIDTestInstance; it cannot be staged for approval.');
			return false;
		}
		const tmpDeferredContext = ScopedEntityData.resolveDeferredContext(pInput, this.options?.DeferredComprehensionContext);
		return ScopedEntityData.stageDeferredValue(this.pict, tmpDeferredContext, 'TestInstance', tmpGUID, 'TestResult', pTestInstance.TestResult);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		if (!this._isMultiple(pInput))
		{
			const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
			const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
			const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}
			return;
		}

		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		if (!Array.isArray(tmpTestInstances))
		{
			return;
		}
		for (const tmpTriple of tmpTestInstances)
		{
			if (!tmpTriple || typeof tmpTriple !== 'object')
			{
				continue;
			}
			const tmpTestInstance = tmpTriple.TestInstance;
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoin = tmpTriple.TestInstanceSampleJoin;
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}

			const tmpDocumentPolyJoin = tmpTriple.DocumentPolyJoin;
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpEntityData.DocumentPolyJoin || typeof tmpEntityData.DocumentPolyJoin !== 'object' || Array.isArray(tmpEntityData.DocumentPolyJoin))
				{
					tmpEntityData.DocumentPolyJoin = { };
				}
				tmpEntityData.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		if (!pRecord.Name)
		{
			if (pRecord.Description)
			{
				return pRecord.Description;
			}
			if (pRecord.Hash)
			{
				return `Test Code ${pRecord.Hash}`;
			}
			return `Unnamed Test #${pRecord.IDTest ?? '??'}`;
		}
		return pRecord.Name;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Hash', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			if (pFilters.length > 0)
			{
				pFilters.unshift('FOP~0~(~0');
				pFilters.push('FCP~0~)~0');
			}
			pFilters.push('FBV~Active~EQ~1');
			pFilters.push('FBV~Collection~EQ~0');
			return pFilters;
		};
	}
}

module.exports = MaterialsTestSelectorInputType;
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68,"./_LabRouting.js":137,"./_ScopedEntityData.js":139}],88:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MIXSPECIFICATION-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedMixSpecification.Code || 'N/A',
				this.pict.AppData.SelectedMixSpecification.Description || ('Unnamed MixSpecification #' + this.pict.AppData.SelectedMixSpecification.IDMixSpecification),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedMixSpecification.Description || ('Unnamed MixSpecification #' + this.pict.AppData.SelectedMixSpecification.IDMixSpecification);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the MixSpecification for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the MixSpecification record yet, get it and store it
			if (!this.pict.AppData.SelectedMixSpecification)
			{
				const tmpResult = await this.pict.providers.MixSpecificationProvider.getMixSpecificationByID(pValue);
				this.pict.AppData.SelectedMixSpecification = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],89:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MIXSPECIFICATION-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('MixSpecification',
				{
					SearchFields: [ 'Code', 'Description' ],
					SearchFallbackPlaceholder: 'Select a Mix Specification by code or description...',
					GetRecordUserFacingID: (pMaterial) => pMaterial.ItemCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the MixSpecification for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected MixSpecification and set it as the selected MixSpecification on the data object
			const tmpMixSpecification = await this.pict.providers.MixSpecificationProvider.getMixSpecificationByID(pValue);
			this.pict.AppData.SelectedMixSpecification = tmpMixSpecification;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedMixSpecification.IDMixSpecification;
			tmpOption.text = `${this.pict.AppData.SelectedMixSpecification.Code || 'N/A'}|~|${this.pict.AppData.SelectedMixSpecification.Description || ('Unnamed MixSpecification #' + this.pict.AppData.SelectedMixSpecification.IDMixSpecification)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],90:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** HIGH-LEVEL NOTES ABOUT BEHAVIOR
 * FOR DATA MANAGEMENT:
 * 	- FOR NON-SETS (Document joined observations array, either in full, or filtered by some criteria such as type or label):
 * 		- The input hash stored is the namespace that is registered in the MediaRegistry for the set of observations that we want to display in the deck.
 *  	- If, we don't find a match for the namespace on load, we assume it's a new collection that needs to be created and we create a new namespace and store it.
 * 			- Attempt to apply any filters that were passed in through options to try to find a matching set of observations to display from the document collection - no results would show an empty message.
 * 		- Else, if not filters are set, then we fallback to all document observations case, where we just display all image observations that are associated with the document in the deck.
 * 			- Additionally, there is an "excludeObservationSets" option that can be set to exclude any observations that are part of an observation set from being displayed in the deck (the "negative"/"orphan" set case).
 * 	- FOR OBSERVATION-SETS (Records in the database that are bound to IDObservationSet values):
 * 		- The IDObservationSet is stored as the value of the hidden input (either by default value, by new creation on first addition, or by selector choice)
 * 		and the namespace for that observation set is stored in the dynamic GUID map for the input hash so that we can look up the relevant observations to display in the deck.
 * FOR INTERACTIVE RENDERING:
 * - The deck layout can be configured through options, and can support different display styles such as 'thumbnail', or 'list'.
 * - We will support two types of display (but only need thumbnail/list for V1, the others are for future use):
 *  - Thumbnail: The default view which is basically the same Observation Image Set template layout we've had before.
 *  - List: The list layout of the observations, which can be useful for displaying more details about each observation in a more compact format. Makes reordering vertical instead of horizontal.
 *  - Details: shows a "media card" for each observation in the set, which can display more information and metadata about the observation in a more visually appealing way. This can be useful for observations that have rich media or a lot of details to show.
 * FOR PRINT RENDERING:
 * - In print mode, we support all the previous templates through the Media Card Builder, including "minimalist", "embed", and "default" layouts, which can be configured through options.
 * - The "embed" layout will attempt to embed the actual media content directly in the card for supported types such as images and PDFs, which can be useful for users who want to see the content of the media directly in print without having to go to a separate media section or open each media item individually.
 * FUTURE PROOFING:
 *  - Would like to make this work for ANY observation type, not locked down to Media types - could provide observation editing through modals.
*/

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const MediaCardBuilder = require('./../../../media-detail-cards/source/MediaCardBuilder.js');

class ObservationCardDeck extends PictSectionInputExtension
{
	/**
	 * @param {Object} pFable - The Fable application instance.
	 * @param {Object} pOptions - The provider options.
	 * @param {string} pServiceHash - The service hash for this provider registration.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pdfjsLib = null;
		// commonly used DOM markers for the deck elements and cards within the deck to make it easier to manage the DOM manipulation for the deck
		this.cardClassName = 'observation-card';
		this.cardAttributeId = 'data-observation-id';
		this.deckClassName = 'observation-card-deck';
		this.deckIsDocumentListAttribute = 'data-deck-is-full-document-list';
		this.deckIsExcludedSetAttribute = 'data-deck-is-excluding-observation-sets';
		this.deckIsFilteredDocumentListAttribute = 'data-deck-is-filtered-document-list';
		this.deckIsObservationSetAttribute = 'data-deck-is-observation-set';
		this.deckInputHashAttribute = 'data-input-hash';
		this.deckViewHashAttribute = 'data-view-hash';
		this.packageTypeSelectorMap = {
			'AllDocumentLists': `.${this.deckClassName}[${this.deckIsDocumentListAttribute}="true"]`, // this includes all filtered lists and 'AllNegativeDocumentLists' since those are subsets of the document lists, aka, everthing NOT an Observation Set
			'AllNegativeDocumentLists': `.${this.deckClassName}[${this.deckIsExcludedSetAttribute}="true"]`,
			'AllObservationSets': `.${this.deckClassName}[${this.deckIsObservationSetAttribute}="true"]`,
		};
		// observation types that are considered "actionable" for filtered decks — quick capture and upload always produce one of these types,
		// so decks filtered by these types can safely allow Add/Remove/QuickCapture actions
		this.actionableObservationTypes = [ 'Legacy Image', 'Legacy Video', 'Legacy Audio', 'File' ];
		// additional options that only this provider should be providing (not configurable by users) that are necessary for the functionality of the deck and to manage some of the edge cases with the deck content and rendering
		this.cacheBusterAttemptTimers = [ 5000, 20000 ];
		// print rendering has no other backstop: the rasterizer only force-terminates the whole page. This bounds each
		// INDIVIDUAL pdf.js operation (document load, page load, page raster) so a stalled artifact cannot hang the
		// document. It is deliberately not a per-attachment budget — total time must stay free to scale with page count.
		this.embeddedPDFOperationTimeoutMS = 30000;
		// print rendering waits on the creator-name lookup (resolveCreatorNamesForDeck), so bound it too
		this.creatorNameLookupTimeoutMS = 10000;
		this.customCSSInjected = false;
		this.draggableConfigurationForDeck = {};
		// default options for the deck, can be overridden by passing in options through the Pict descriptor configuration for the input, or through the observation set configuration if using observation sets to manage the deck content
		this.defaultConfiguration = {
			appendNewCardToStartOfDeck: false, // option to append new cards to the start of the deck instead of the end when they are added (e.g. through quick capture or other means)
			customEmptyStateMessage: 'No items have been added to this collection.',
			customEmptyStateMessageForPrint: 'No items to display.', // option to set a custom empty state message for print view that is different from the interactive view message, which can be useful if the default message doesn't make sense in the context of printing or if we want to provide more specific instructions for users in print view
			customIconClassForQuickCaptureButton: '', // option to set a custom icon class for the quick capture button (e.g. "fa-camera" or "fas fa-camera"), if not set, it will default to a camera circle icon
			customTextForQuickCaptureButton: '', // option to set custom text for the quick capture button, if not set, it will default to "Quick Capture"
			deckLayout: 'thumbnail', // default layout style for the deck (can be 'thumbnail', 'list', or 'details')
			deckLayoutForPrint: 'default', // default layout style for the deck in print view (can be 'default', or 'minimalist' for a more compact card style)
			preventEmbeddingPDFsForPrint: false, // when true, prevents PDFs from being embedded (rendered page-by-page via pdf.js) in the deck in print view — by default PDFs are embedded so users can see the content directly in the printed output without navigating to a separate media section
			excludeObservationSets: false, // option to exclude observations that are part of an observation set from being displayed in the deck (only applicable when not using observation sets to manage the deck content)
			alwaysExcludeObservationSets: false, // when true, forces excludeObservationSets to always be active and disables the user toggle — used for decks that structurally represent the orphan/negative set (e.g. Inspection Photos)
			hideIndexTags: false, // option to hide the index tags that show up on top of the card thumbnails
			hideFiltersInHeader: false, // option to hide the filter tags in the header of the deck
			hideQuickCapture: false, // option to hide the quick capture button for adding new observations to the deck
			indexTagScope: 'local', // option to configure the scope of the index tags on card - can be "local" (default) or "document" (note: "global" might eventually be a third option later if we have a server provided index that is consistent across all clients)
			preventAddingCards: false, // flag to prevent adding new cards to the deck when true (used for print view and can be configured for interactive view as well through options)
			preventCrossDeckDragging: true, // (TODO: FALSE is not implimented yet!) flag to prevent dragging and dropping cards between different decks (true until we can account for filtering)
			preventReorderingCards: false, // flag to prevent reordering of cards in the deck when true (used for print view and can be configured for interactive view as well through options)
			preventRemovingCards: false, // flag to prevent removing cards from the deck when true (used for print view and can be configured for interactive view as well through options)
			sortOrder: 'custom', // use the media registry by default (for now)
			useObservationSet: false, // flag to indicate whether we are using Observation Sets to manage the observations in the deck, or if we are just using a flat list of observations from the MediaRegistry
			useObservationSetSelector: false, // flag to indicate whether to show the observation set selector in the header of the deck when using observation sets to manage the content in the deck
			requireExplicitSetCreation: false, // when true (and useObservationSetSelector is true), the deck will NOT auto-create a set on Add/QuickCapture clicks — the user must explicitly create a set via "Create New Set" first, and Add/QuickCapture buttons are hidden until a set is selected
			filters: { Include: {}, Exclude: {} }, // default filters for the deck, used to filter observations displayed based on different criteria such as observation type, label types, etc.
		};
		// default options for when we were routed here from an old "ObservationImageSet", "ObservationStandardSet", or "MediaDetailCards" InputType with legacy configuration options that we want to attempt to map to the new configuration options for the deck to preserve backwards compatibility with existing forms that use those input types
		this.patchedConfiguration = {
			ObservationCardDeck: {}, // this is just a placeholder to make it easier to check
			ObservationImageSet: {
				deckLayout: 'thumbnail',
				useObservationSet: true,
				useObservationSetSelector: false,
				filters: { Include: { ObservationTypes: [ 'Legacy Image', 'File' ] } },
			},
			// "ObservationSet" is the MTIWHA InputType name (maps to InputType-ObservationSet.js template);
			// "ObservationStandardSet" is the provider name (PictProvider-InputType-ObservationStandardSet.js).
			// Both aliases are needed because pInput.PictForm.InputType can be either value depending on context.
			ObservationSet: {
				deckLayout: 'thumbnail',
				useObservationSet: true,
				useObservationSetSelector: true,
				requireExplicitSetCreation: true,
				filters: { Include: { ObservationTypes: this.actionableObservationTypes } },
			},
			ObservationStandardSet: {
				deckLayout: 'thumbnail',
				useObservationSet: true,
				useObservationSetSelector: true,
				requireExplicitSetCreation: true,
				filters: { Include: { ObservationTypes: this.actionableObservationTypes } },
			},
			// "MediaDetailCards" is the legacy InputType that previously had its own provider and template.
			// It now routes through ObservationCardDeck via template redirect (same pattern as ObservationImageSet).
			// (Note: an earlier "MediaCards" entry existed here by mistake — no form ever used that InputType name.)
			MediaDetailCards: {
				deckLayout: 'details',
				useObservationSet: false,
				useObservationSetSelector: false,
				excludeObservationSets: false,
				filters: { Include: { ObservationTypes: this.actionableObservationTypes } },
			},
		};
		/** @type {Pict} */
		this.pict;
		this.pict.TemplateProvider.addTemplate('Observation-Description-Popover', /*html*/`<div class="px-2 py-1">{~D:Record.Description~}</div>`);
		this.pict.AppData.ObservationCardDeckProvider =
		{
			dynamicGUIDMap: {}, // separate map to store dynamic GUIDs for each input hash for better management and to avoid conflicts with the main GUID map used for other purposes in the application
			dynamicSettingsMap: {}, // separate map to store dynamic settings (including filters) for each input hash
			customHandleObservationSetCreateSetButtonClick: null, // custom handler for the create set button, set via setCustomHandleObservationSetCreateSetButtonClick()
			customOnAfterObservationSetCreated: null, // callback invoked after a new observation set is created via the modal (receives: pSavedSet, pInput)
			customOnAfterObservationSetChanged: null, // callback invoked after an observation is added to or removed from an observation set (receives: pInput, pIDObservation, pObservationSet)
			documentContextCallback: null, // callback invoked after observation set content changes for broader document-level side effects (e.g. orphan observation recalculation)
			customHandleSearchFiltersForSelector: null, // optional custom filter callback for the set selector's Select2 AJAX query (receives: pFilters[], returns: pFilters[])
			customOnAfterMarshal: null, // callback invoked after the CardDeck finishes marshalling and rendering cards for an input (receives: pInput, pObservationList)
			settingsOverridesByInputAddress: {}, // map of input Address → CardDeckSettings overrides, merged in setCurrentSettingsForInput after pSettings but before persisted overrides
			documentScopeEmptyState: false, // flag set by the custom search filter when document scope is active but no sets exist yet — used by processResults to show a contextual empty message
			userNameCache: {}, // map of IDUser → display name, populated by resolveCreatorNamesForDeck() for the details view and print cards
		};
		// fallback in-memory store for user-toggled overrides (e.g. excludeObservationSets) used when no FormData root is available yet.
		// The persisted store lives at FormData.ObservationCardDeckOverrides so it survives save/reload alongside MediaRegistryStore.
		this._inMemoryOverridesStore = {};
		// cache of IDObservationSet → saved Name, populated lazily on first header render.
		// Values are Promises while the fetch is in flight, then resolved strings, so concurrent callers share a single request.
		/** @type {Object<string, string|Promise<string>>} */
		this._observationSetNameCache = {};
		// caches for managing the state of the deck content and rendering to account for some of the edge cases with the deck such as multiple decks on the same form,
		// multiple views with the same deck, and keeping the content up to date when changes are made to the observations in the document through other means outside of the deck (e.g. through the observation panels, quick capture, etc.)
		/**
		 * @type {Promise<any>[]}
		 */
		this.renderPromises = [];
		/**
		 * @type {Promise<any>[]}
		 */
		this.marshalPromises = [];
		this._isRemarshalInProgress = false;
		this._previousObservationSetIDs = {};
		/**
		 * @type {any[]}
		 */
		this.registeredDependencyInputHashList = [];
		// tracks Add/QuickCapture buttons that have been put into an `is-loading` state pending the
		// completion of a panel-driven add flow. If the user dismisses the panel without completing
		// the flow (X button, escape, background click, etc.), the panel's closeHandler calls
		// clearPendingAddButtonLoadingState() to ensure these don't get stuck in the loading state.
		/** @type {Set<HTMLElement>} */
		this._pendingAddButtonElements = new Set();
		// Per-input re-entrancy guard for the async print-view deck build (buildCardDeckCardsForPrintView).
		// The form solve/marshal cycle can invoke the build more than once for the same input during a single
		// PDF render; because the build awaits pdf.js, overlapping runs would interleave their appends and
		// duplicate embedded PDFs. This flag lets a build-in-flight short-circuit later overlapping calls.
		/** @type {Object<string, boolean>} */
		this._printBuildInFlight = {};
	}

	/**
	 * Whether the current document is locked (read-only).
	 * @returns {boolean}
	 */
	get isDocumentLocked()
	{
		return !!this.pict.AppData?.DocumentData?.ReportData?.Locked;
	}

	/**
	 * Whether the current user has edit permissions on the document.
	 * @returns {boolean}
	 */
	get canEditDocument()
	{
		return !!this.pict.AppData?.DocumentData?.ReportData?.CanEdit;
	}

	/**
	 * Returns the root object used to persist user-toggled deck overrides across save/reload.
	 * Lives under FormData (like MediaRegistryStore) so it is saved with the document, and falls back to an
	 * in-memory object when no FormData root is available (e.g. unit tests, pre-document-init bootstrap).
	 * @returns {Object} - The persisted override store object, keyed by input hash.
	 */
	getPersistedOverridesStore()
	{
		const formData = this.pict.AppData?.DocumentData?.ReportData?.FormData;
		if (!formData)
		{
			return this._inMemoryOverridesStore;
		}
		if (!formData.ObservationCardDeckOverrides)
		{
			formData.ObservationCardDeckOverrides = {};
		}
		return formData.ObservationCardDeckOverrides;
	}

	/**
	 * Returns the persisted overrides for a given input (or null if none saved).
	 * @param {Object} pInput - The input object (used to access the input hash).
	 * @returns {Object|null}
	 */
	getPersistedOverridesForInput(pInput)
	{
		const store = this.getPersistedOverridesStore();
		return store[pInput.Hash] || null;
	}

	/**
	 * Writes a single override key/value to the persisted overrides store for a given input.
	 * @param {Object} pInput - The input object (used to access the input hash).
	 * @param {string} pOverrideKey - The override field name (e.g. 'excludeObservationSets').
	 * @param {any} pOverrideValue - The override value to persist.
	 */
	setPersistedOverrideForInput(pInput, pOverrideKey, pOverrideValue)
	{
		const store = this.getPersistedOverridesStore();
		if (!store[pInput.Hash])
		{
			store[pInput.Hash] = {};
		}
		store[pInput.Hash][pOverrideKey] = pOverrideValue;
	}

	getHiddenInputHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}
	getLabelHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#LABEL-FOR-${pInputHTMLID}`;
	}
	getCardDeckContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-CONTAINER-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderFilterContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-FILTERS-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderExcludeObservationSetHiddenInputHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetSelectorContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-CONTAINER-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetCreateButtonHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-CREATE-BUTTON-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetEditButtonHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#EDIT-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetSelectorHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetDisplayHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-${pInputHTMLID}`;
	}
	getCardDeckContentHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-CONTENT-FOR-${pInputHTMLID}`;
	}
	getCardDeckContainerEmptyMessageHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#EMPTY-MESSAGE-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderActionsContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-ACTIONS-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderActionsButtonAddHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-ACTIONS-ADD-BUTTON-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderActionsButtonQuickCaptureHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-ACTIONS-QUICK-CAPTURE-BUTTON-FOR-${pInputHTMLID}`;
	}

	/**
	 * Updates the text content of the empty message element for a given input's card deck.
	 * @param {Object} pInput - The input object.
	 * @param {string} pMessage - The message to display.
	 */
	updateEmptyMessageText(pInput, pMessage)
	{
		const emptyMessageElement = document.querySelector(this.getCardDeckContainerEmptyMessageHTMLID(pInput.Macro.RawHTMLID));
		if (emptyMessageElement)
		{
			const textSpan = emptyMessageElement.querySelector('.icon-text');
			if (textSpan)
			{
				textSpan.textContent = pMessage;
			}
		}
	}

	/**
	 * Function to build a consistent namespace string for a card deck based on input hash, observation set ID, and whether it is temporary.
	 * @param {string} pInputHash - The hash of the input element.
	 * @param {string|number|null} [pIDObservationSet=null] - The ID of the observation set, if applicable.
	 * @param {boolean} [isTemporary=false] - Flag indicating if the card deck is temporary - for Observation Set that have not yet been saved (we only save a new pristine set up user action taken, not form load).
	 * @returns {string} - The constructed namespace string or an error string if inputs are invalid.
	 */
	buildNamespaceForCardDeck(pInputHash, pIDObservationSet = null, isTemporary = false)
	{
		if (isTemporary && !pIDObservationSet)
		{
			return `TEMP-CardDeck-For-IDObservationSet-${pInputHash}`;
		}
		else if (pIDObservationSet)
		{
			return `CardDeck-For-IDObservationSet-${pIDObservationSet}`;
		}
		else if (pInputHash)
		{
			return `CardDeck-For-${pInputHash}`;
		}
		else
		{
			this.pict.log.error(`Cannot build namespace for card deck without either a valid input hash or IDObservationSet. Received input hash: ${ pInputHash }, IDObservationSet: ${ pIDObservationSet }, isTemporary: ${ isTemporary }`);
			return 'ERROR-Invalid-Namespace-For-CardDeck';
		}
	}

	/**
	 * Drains a queue of promises, logging any errors, then empties the queue.
	 * @param {Promise<any>[]} queue - The promise queue to drain.
	 * @param {string} label - A label for error messages to identify which queue failed.
	 */
	async _drainPromiseQueue(queue, label)
	{
		for (const p of queue)
		{
			try
			{
				await p;
			}
			catch (error)
			{
				this.pict.log.error(`Error in ${label}: ${ error }`);
			}
		}
		queue.length = 0;
	}

	/**
	 * Function that can be awaited by other functions to ensure that this input type has finished rendering.
	 */
	async completeRender()
	{
		await this._drainPromiseQueue(this.renderPromises, 'PictProvider-InputType-ObservationCardDeck');
	}

	/**
	 * Function that can be awaited to ensure that all pending marshal operations (triggered by reMarshalAllViewsWithCardDecks) have completed.
	 * This is used to serialize view refreshes so that multiple card deck instances don't race over shared state.
	 */
	async waitForPendingMarshals()
	{
		await this._drainPromiseQueue(this.marshalPromises, 'pending marshal');
	}

	/**
	 * This is a callback for external functions to call when they want to trigger a refresh of the card decks that are displaying a specific observation,
	 * such as when an observation is added or removed from the document through other means outside of the deck (e.g. through the observation panels, quick capture, etc.)
	 * to ensure that the content in the deck stays up to date and reflects the current state of the document.
	 * @param {string} pIDObservation - The ID of the observation that was added, removed, or updated.
	 * @param {string} action - The type of action that triggered the refresh, which can be 'add', 'remove', or 'update', and can be used to determine how to refresh the deck content (e.g. whether to add a new card, remove an existing card, or update the content of an existing card).
	 * @param {any[]} pUpdatedObservationList - The updated list of observations in the document, used to refresh the deck content accurately.
	 * @param {string} source - The source of the action that triggered the refresh, which can be used for logging or to determine if certain decks should be refreshed based on where the action originated from (e.g. if the action came from the observation panels, we might want to refresh all decks, but if it came from a specific deck, we might only want to refresh that deck).
	 * @return {Promise<void>}
	 */
	async refreshCardDecks(pIDObservation, action, pUpdatedObservationList, source)
	{
		if (!this.pict.AppData?.DocumentData)
		{
			this.pict.log.warn('No document data found. Skipping refreshCardDecks.');
			return;
		}
		if (this.isDocumentLocked)
		{
			this.pict.log.warn('Document is locked. Skipping refreshCardDecks.');
			return;
		}
		// we need basic info to even attempt to find the cards to update, so if we don't have that, we should log a warning and exit the function to avoid unnecessary processing and potential errors
		if (!pIDObservation || !action || !source)
		{
			this.pict.log.warn(`refreshCardDecks called with invalid parameters. pIDObservation: ${pIDObservation}, action: ${action}, pUpdatedObservationList: ${pUpdatedObservationList}, source: ${source}`);
			return;
		}
		if (!pUpdatedObservationList || !Array.isArray(pUpdatedObservationList))
		{
			this.pict.log.warn(`refreshCardDecks called without a valid updated observation list. This should be the latest state of the DocumentRecord.Observations array.`);
			return;
		}
		// make sure we're using the latest list of observations from the document to ensure that any changes are reflected accurately in the deck content
		this.pict.AppData.DocumentData.ReportData.Observations = pUpdatedObservationList;
		await this.pict.providers.MediaRegistry.refreshDocumentObservations(pUpdatedObservationList);
		// refresh both document-list decks and observation-set decks, since an add/remove action can affect either type
		await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllDocumentLists', true);
		await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllObservationSets', true);
		return;
	}

	/**
	 * Function to register a promise that pdf rendering depends on.
	 * @param {Promise<any>} dependency - The promise we want to add to the dependency set.
	 */
	registerRenderDependency(dependency)
	{
		if (!this.pict.AppData.Interactive && dependency instanceof Promise)
		{
			this.renderPromises.push(dependency);
		}
	}

	/**
	 * Function to remove the initial loading message from the deck elements once content is loaded (we default to showing a loading message on the empty container message that is displayed when the deck is empty or prior to content being loaded).
	 * @param {Object} pInput - The input object containing the deck elements.
	 * @param {Object} pInput.Macro - The macro object for the input, which contains the raw HTML ID used to find the relevant deck content area element in the DOM to remove the loading message from.
	 * @param {string} pInput.Macro.RawHTMLID - The raw HTML ID of the input, used to find the relevant deck content area element in the DOM to remove the loading message from.
	 */
	removeInitialLoadingMessage(pInput)
	{
		const cardDeckContentAreaHTMLID = this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID);
		const cardDeckContentAreaElement = document.querySelector(cardDeckContentAreaHTMLID);
		if (cardDeckContentAreaElement)
		{
			const loadingMessageElement = cardDeckContentAreaElement.querySelector('.initial-loading-message');
			if (loadingMessageElement)
			{
				loadingMessageElement.remove();
			}
		}
	}

	/**
	 * Parse the legacy "key:value,key:value" string from PictForm.InputExtra into an options object
	 * for MediaCardBuilder. Carried over from the removed MediaDetailCards provider so legacy form
	 * configs (cardTheme, cardSize, ordinalScope, etc.) still flow through on print.
	 * @param {string} pInputExtraString - The stringy configuration data from the PictForm.InputExtra field
	 * @return {Object} - The processed configuration options
	 */
	processPictDescriptorConfigurationOptions(pInputExtraString)
	{
		if (!pInputExtraString || pInputExtraString.length === 0)
		{
			return {};
		}
		const newConfigOptions = {};
		const tmpConfig = pInputExtraString.split(',').map((item) => item.trim());
		tmpConfig.forEach((item) =>
		{
			const [ key, value ] = item.split(':').map((part) => part.trim());
			if (key && value)
			{
				if (value === 'true' || value === 'false')
				{
					newConfigOptions[key] = value === 'true';
				}
				else
				{
					newConfigOptions[key] = value;
				}
			}
		});
		return newConfigOptions;
	}

	/**
	 * Function to handle rendering of the deck in print view for variable templates. In print view, we want to render the content of the deck in a way that is optimized for printing,
	 * which may include showing more details about each observation and adjusting the layout to fit better on a printed page. We will also hide interactive elements such as buttons
	 * and popovers in print mode. The rendering logic will adjust based on the selected layout style for print view, which can be configured through options.
	 *
	 * TODO: Rename this to "ObservationCardPrintBuilder" (or similar) and refactor to support any observation type —
	 *       non-media observations should render with thumbnail placeholders rather than being filtered out by
	 *       curateMediaObservationList. This would replace the prevention logic added for non-media types and let the
	 *       print builder be a general-purpose observation card renderer. Deferring until current fixes are shipped.
	 *       When this refactor happens, also update the bridge element conditions provider's _hasRenderableMediaArtifact()
	 *       filter in bridgeinspection-elementconditions-provider.js to align with the builder's acceptance logic.
	 *
	 * @param {Object} pView - the view object for the input, which contains information about the current view and can be used to determine if we are in print view or not
	 * @param {Object} pInput - the input object for which we are rendering the deck, which contains information about the input and can be used to get the current settings and filters for the deck
	 * @param {string} pNamespace - the namespace for the deck content, which can be used to look up the relevant observations from the MediaRegistry to display in the deck
	 * @param {any[]} pObservationList - the list of observations to be rendered in the deck, which can be filtered and sorted based on the current settings and filters for the deck
	 */
	async buildCardDeckCardsForPrintView(pView, pInput, pNamespace, pObservationList)
	{
		// Re-entrancy guard. The form's solve/marshal cycle can call this multiple times for the same input
		// during one PDF render. The build is async (pdf.js rasterizes embedded PDFs page-by-page), so
		// overlapping runs each clear-then-append and interleave their canvases — duplicating embedded PDFs
		// in the output. While a build for this input is in flight, skip later overlapping calls: print data
		// is static, so the in-flight build already reflects the final content. (Interactive mode doesn't need
		// this because buildObservationCardDeck reconciles via a DOM diff instead of appending.)
		if (this._printBuildInFlight[pInput.Hash])
		{
			return;
		}
		this._printBuildInFlight[pInput.Hash] = true;
		try
		{
			await this._buildCardDeckCardsForPrintView(pView, pInput, pNamespace, pObservationList);
		}
		finally
		{
			this._printBuildInFlight[pInput.Hash] = false;
		}
	}

	/**
	 * Inner implementation of the print-view deck build. Always invoke via buildCardDeckCardsForPrintView,
	 * which guards against re-entrant/overlapping builds for the same input.
	 * @param {Object} pView - the view object for the input
	 * @param {Object} pInput - the input object for which we are rendering the deck
	 * @param {string} pNamespace - the namespace for the deck content
	 * @param {any[]} pObservationList - the list of observations to be rendered in the deck
	 */
	async _buildCardDeckCardsForPrintView(pView, pInput, pNamespace, pObservationList)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const displayStyle = currentSettings?.deckLayoutForPrint || 'default';
		const cardDeckContentAreaHTMLID = this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID);
		const cardDeckContentAreaElement = document.querySelector(cardDeckContentAreaHTMLID);
		// if we can't find the container element for the deck, we have a problem and can't render the deck, so we should log an error and bail out of the function to avoid further issues
		if (!cardDeckContentAreaElement)
		{
			this.pict.log.error(`Card deck container not found for HTML ID: ${cardDeckContentAreaHTMLID}`);
			return;
		}
		// Reset the content area before (re)building. Unlike the interactive buildObservationCardDeck (which diffs cards
		// against the DOM and is idempotent), the print builder only appends — so a second marshal pass during PDF
		// generation would otherwise tack on a duplicate copy of every card / embedded PDF.
		cardDeckContentAreaElement.innerHTML = '';
		// Determine whether PDFs should be fully embedded (rendered page-by-page via pdf.js).
		// By default PDFs are embedded unless the form explicitly opts out via preventEmbeddingPDFsForPrint.
		// The minimalist layout always embeds regardless of the setting.
		const willEmbedPDFs = !currentSettings?.preventEmbeddingPDFsForPrint || displayStyle === 'minimalist';
		const embeddedPDFIds = new Set(
			willEmbedPDFs ?
				pObservationList
					.filter((/** @type {any} */ o) => o?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf')
					.map((/** @type {any} */ o) => o.IDObservation) :
				[],
		);

		// Shared config for building thumbnail cards via MediaCardBuilder
		const pictConfigOptions = this.processPictDescriptorConfigurationOptions(pInput?.PictForm?.InputExtra || '');
		const blendedConfigOptions = { ...{
			cardTheme: pictConfigOptions?.cardTheme || displayStyle,
			cardSize: pictConfigOptions?.cardSize || (displayStyle === 'minimalist' ? 'half' : ''),
			ordinalScope: pictConfigOptions?.ordinalScope || (displayStyle === 'minimalist' ? 'global' : ''),
			landscapeMode: this.pict.AppData?.DocumentData?.ReportData?.ReportOptions?.Meta?.orientation === 'landscape',
			isPrintView: !this.pict.AppData.Interactive,
			// cached creator names render directly; the rest are back-filled by resolveCreatorNamesForDeck
			userNameMap: this.pict.AppData.ObservationCardDeckProvider.userNameCache,
			// Disable the default DesignatedTime sort inside MediaCardBuilder.buildCards() so that the
			// user's saved drag/reorder sequence (already reflected in pObservationList) is preserved.
			// Without this, curateMediaObservationList re-sorts the batch by date and destroys the custom order.
			sortBy: null,
			sortOrder: null,
		}, ...pictConfigOptions };

		// Walk observations IN ORDER so that embedded PDFs and thumbnail cards are interleaved
		// at their correct positions — preserving the user's custom sort/drag order.
		let thumbnailBatch = [];
		let batchIndex = 0;

		/**
		 * Flush any accumulated thumbnail-card observations into a wrapper div appended to the container.
		 * Uses MediaCardBuilder.buildCards with a temporary target element.
		 */
		const flushThumbnailBatch = () =>
		{
			if (!thumbnailBatch.length)
			{
				return;
			}
			const batchWrapper = document.createElement('div');
			const batchId = `${pInput.Macro.RawHTMLID}-print-batch-${batchIndex++}`;
			batchWrapper.id = batchId;
			cardDeckContentAreaElement.appendChild(batchWrapper);
			const mediaCardBuilder = new MediaCardBuilder();
			mediaCardBuilder.buildCards(thumbnailBatch, { ...blendedConfigOptions, target: batchId });
			thumbnailBatch = [];
		};

		for (const obs of pObservationList)
		{
			if (embeddedPDFIds.has(obs.IDObservation))
			{
				// Flush any preceding thumbnail cards before inserting the embedded PDF
				flushThumbnailBatch();
				await this.buildEmbeddedPDFsForPrintView([ obs ], cardDeckContentAreaElement);
			}
			else
			{
				thumbnailBatch.push(obs);
			}
		}
		// Flush any remaining thumbnail cards after the last embedded PDF
		flushThumbnailBatch();
	}

	/**
	 * Races a promise against a timeout so a stalled dependency cannot hang print rendering indefinitely.
	 *
	 * @param {Promise<any>} pPromise - The promise to bound.
	 * @param {number} pTimeoutMS - Milliseconds to wait before rejecting.
	 * @param {string} pLabel - Description of the awaited work, used in the timeout message.
	 * @return {Promise<any>} - The promise result, or a rejection if the timeout elapsed first.
	 */
	async _withTimeout(pPromise, pTimeoutMS, pLabel)
	{
		let tmpTimeoutID;
		try
		{
			return await Promise.race(
				[
					pPromise,
					new Promise((resolve, reject) =>
					{
						tmpTimeoutID = setTimeout(() => reject(new Error(`${pLabel} timed out after ${pTimeoutMS} ms.`)), pTimeoutMS);
					}),
				]);
		}
		finally
		{
			clearTimeout(tmpTimeoutID);
		}
	}

	/**
	 * Builds the print-view stand-in shown where an embedded PDF could not be rendered, so a missing
	 * attachment is visible in the printed output rather than silently absent.
	 *
	 * @param {string} pObservationName - Display name of the observation the attachment belongs to.
	 * @param {number} [pRenderedPageCount] - Pages that rendered before the failure, so a partial embed reads correctly.
	 * @return {HTMLDivElement} - The placeholder element.
	 */
	buildEmbeddedPDFErrorPlaceholder(pObservationName, pRenderedPageCount)
	{
		const tmpContainer = document.createElement('div');
		tmpContainer.style['break-inside'] = 'avoid';
		tmpContainer.style['margin-bottom'] = '10px';
		tmpContainer.style['padding'] = '10px';
		tmpContainer.style['border'] = '2px solid grey';
		const tmpLabel = document.createElement('b');
		tmpLabel.style.fontSize = '15px';
		tmpLabel.textContent = pRenderedPageCount > 0 ?
			`Observation: ${ pObservationName } - the remaining pages of this attachment could not be displayed.` :
			`Observation: ${ pObservationName } - attachment could not be displayed.`;
		tmpContainer.appendChild(tmpLabel);
		return tmpContainer;
	}

	/**
	 * Resolve pdf.js on first use. Only the PDF templates load it, so the interactive form never pays for it.
	 * @returns {any} the pdf.js library, or null when the page did not load it
	 */
	resolvePDFJS()
	{
		// @ts-ignore
		const tmpPDFJS = globalThis.pdfjsLib;
		if (!this.pdfjsLib && tmpPDFJS)
		{
			tmpPDFJS.GlobalWorkerOptions.workerSrc = './pdfjs-dist/build/pdf.worker.mjs';
			this.pdfjsLib = tmpPDFJS;
		}
		return this.pdfjsLib;
	}

	/**
	 * Function to build embedded PDFs in the deck for print view when the deck is configured to embed PDFs directly in print view instead of linking to them.
	 * @param {any[]} pdfs - the list of observation objects whose files are PDFs to be embedded into the print view
	 * @param {Element} containerElement - the container element for the deck content area where the embedded PDFs will be rendered
	 */
	async buildEmbeddedPDFsForPrintView(pdfs, containerElement)
	{
		if (!this.resolvePDFJS())
		{
			throw new Error(`Currently the ObservationCardDeck InputType provider requires pdfjs to be loaded in the DOM, but it isn't.`);
		}
		if (!pdfs.length || !containerElement)
		{
			return;
		}
		const embedTemplate = document.createElement('div');
		for (const o of pdfs)
		{
			const obsName = o?.Name?.length > 60 ? o.Name.substring(0, 60) + '...' : o.Name;
			const tmpIDArtifact = o?.Details?.File?.[0]?.IDArtifact;
			const tmpVersion = o?.Details?.File?.[0]?.Version;
			const tmpMediaURL = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
			//@ts-ignore
			const task = this.pdfjsLib.getDocument(tmpMediaURL);
			let tmpRenderedPageCount = 0;
			try
			{
				const pdf = await this._withTimeout(task.promise, this.embeddedPDFOperationTimeoutMS, `Loading embedded PDF ${tmpMediaURL}`);
				const pageTotal = pdf.numPages;
				for (let i = 0; i < pageTotal; i++)
				{
					const page = await this._withTimeout(pdf.getPage(i + 1), this.embeddedPDFOperationTimeoutMS, `Loading page ${i + 1} of embedded PDF ${tmpMediaURL}`);
					const viewport = page.getViewport({ scale: 2 });
					const container = document.createElement('div');
					container.style['margin-bottom'] = '10px';
					// Build the page header from DOM nodes — obsName is the user-supplied observation/file name, so avoid HTML-string injection
					const headerLabel = document.createElement('span');
					headerLabel.style.fontSize = '15px';
					const headerBold = document.createElement('b');
					headerBold.textContent = `Observation: ${ obsName } - Page ${ i + 1 }`;
					headerLabel.appendChild(headerBold);
					container.appendChild(headerLabel);
					container.style['break-inside'] = 'avoid';
					const canvas = document.createElement( 'canvas' );
					canvas.style.display = 'block';
					canvas.style['position'] = 'absolute';
					canvas.style['left'] = '0px';
					canvas.style['margin-left'] = '20px';
					const scaleFactor = (window.innerWidth - 60) / viewport.width;
					canvas.style.width = `${ scaleFactor * viewport.width }px`;
					canvas.style.height = `${ scaleFactor * viewport.height }px`;
					container.style['height'] = `${ (scaleFactor * viewport.height) + 20 }px`;
					canvas.style.border = '2px solid grey';
					const context = canvas.getContext('2d');
					canvas.height = viewport.height;
					canvas.width = viewport.width;
					await this._withTimeout(page.render({ canvasContext: context, viewport: viewport }).promise, this.embeddedPDFOperationTimeoutMS, `Rendering page ${i + 1} of embedded PDF ${tmpMediaURL}`);
					container.appendChild(canvas);
					embedTemplate.appendChild(container);
					tmpRenderedPageCount++;
				}
			}
			catch (pError)
			{
				this.pict.log.error(`[ObservationCardDeck] Could not embed PDF ${tmpMediaURL} in print view: ${pError.message || pError}`,
					{
						IDObservation: o?.IDObservation,
						IDArtifact: tmpIDArtifact,
						Version: tmpVersion,
					});
				embedTemplate.appendChild(this.buildEmbeddedPDFErrorPlaceholder(obsName, tmpRenderedPageCount));
				Promise.resolve(task.destroy()).catch((pDestroyError) =>
				{
					this.pict.log.warn(`[ObservationCardDeck] Failed to release the pdf.js task for ${tmpMediaURL}: ${pDestroyError.message || pDestroyError}`);
				});
			}
		}
		// update the styles for the content area to allow the embedded PDFs to break into multiple pages when we have a lot of them,
		// and to avoid awkward blank spaces at the bottom of pages when the PDF viewer is too large to fit on one page but gets cut off instead of breaking onto the next page
		containerElement['style']['break-inside'] = 'auto';
		if (containerElement.parentElement)
		{
			containerElement.parentElement['style']['break-inside'] = 'auto';
		}
		containerElement.appendChild(embedTemplate);
		return true;
	}

	/**
	 * Toggle the deck style for the observation card deck.
	 * @param {string} id - the ID of the element to toggle the deck style for
	 * @param {string} style - the style to apply to the deck
	 */
	toggleDeckStyle(id, style)
	{
		/** @type {HTMLElement} */
		const element = /** @type {HTMLElement} */ (document.getElementById(id));
		if (!element)
		{
			this.pict.log.error(`Could not find element with ID ${ id } to toggle deck style.`);
			return;
		}
		element.classList.remove('observation-deck-style-thumbnail', 'observation-deck-style-cards', 'observation-deck-style-list', 'observation-deck-style-details');
		element.classList.add(`observation-deck-style-${style}`);
		// toggle active state on the buttons
		const buttons = element.parentElement.querySelectorAll('button');
		buttons.forEach((btn)=>
		{
			btn.classList.remove('is-active');
			if (btn.dataset.deckStyle === style)
			{
				btn.classList.add('is-active');
			}
		});
	}

	/**
	 * Build the modifier (filter/observation set) tags for the observation card deck header. These are little color (red, green, blue, or gray) coded tags
	 * that show up in the header next to the label to indicate which modifications are currently applied to the deck. This is helpful because the deck can be
	 * configured to show different subset lists of document observations based on different filters applied, or it may be an Observation Set, so it can be easy for
	 * users to forget which modifiers are currently applied, especially if they navigate away from the page and come back later. These tags provide a quick visual
	 * reference for users to understand what they're looking at in the deck. Optionally, this UI can be configured to be hidden through options if users find it overwhelming or distracting.
	 * @param {Object} pView - the pict-view instance hosting the input (used to look up bound form metadata)
	 * @param {Object} pInput - the input object for which to build the modifier tags (used to get the raw HTML ID for the input, which we use to find the container element for the header and to store the current modifiers in a data attribute on the input element)
	 * @param {boolean} hideModifiersInHeader - flag to indicate whether we should hide the modifier tags in the header based on options (if true, we won't build or show any modifier tags, even if there are modifiers applied)
	 * @returns {string} - the HTML string for the modifier tags to be inserted into the header
	 */
	/**
	 * Builds the icon + label pair used by the deck header tags and toggles as DOM nodes rather than an
	 * HTML string. Emits no whitespace between the two spans, matching the markup this replaced.
	 * @param {string} pIconClasses - classes for the <i> element (e.g. 'fa fa-fw fa-toggle-on has-text-link')
	 * @param {string} pLabelText - the label text
	 * @param {string} [pIconSpanExtraClasses] - extra classes for the icon <span>, beyond 'icon'
	 * @param {string} [pLabelSpanClasses] - classes for the label <span>; omit for a bare <span>
	 * @return {DocumentFragment}
	 */
	buildIconLabelNodes(pIconClasses, pLabelText, pIconSpanExtraClasses, pLabelSpanClasses)
	{
		const tmpFragment = document.createDocumentFragment();
		const tmpIconSpan = document.createElement('span');
		tmpIconSpan.className = pIconSpanExtraClasses ? `icon ${ pIconSpanExtraClasses }` : 'icon';
		const tmpIcon = document.createElement('i');
		tmpIcon.className = pIconClasses;
		tmpIconSpan.appendChild(tmpIcon);
		const tmpLabelSpan = document.createElement('span');
		if (pLabelSpanClasses)
		{
			tmpLabelSpan.className = pLabelSpanClasses;
		}
		tmpLabelSpan.textContent = pLabelText;
		tmpFragment.appendChild(tmpIconSpan);
		tmpFragment.appendChild(tmpLabelSpan);
		return tmpFragment;
	}

	buildFilterTagsForCardDeckHeader(pView, pInput, hideModifiersInHeader = false)
	{
		if (hideModifiersInHeader)
		{
			return '';
		}
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const tagDisplayLimit = 3; // max number of tags to show in the header before we switch to showing a summary tag instead
		const hasModifiersApplied = this.hasFiltersApplied(pInput);

		// if we don't have any modifiers to show, we should show a tag that indicates that we're showing all document observations so that users have some context for what they're looking at in the deck instead of just seeing an empty header with no tags and wondering if something is broken
		if (!hasModifiersApplied)
		{
			const headerContainer = this.getCardDeckHeaderFilterContainerHTMLID(pInput.Macro.RawHTMLID);
			const headerContainerElement = document.querySelector(headerContainer);
			if (!headerContainerElement)
			{
				this.pict.log.error(`Could not find header container element with ID ${ headerContainer } to build modifier tags for header.`);
				return '';
			}
			headerContainerElement.innerHTML = '';
			headerContainerElement.classList.add('is-flex', 'is-align-items-center', 'gap-1');
			const tag = document.createElement('span');
			tag.classList.add('tag', 'pl-1', 'is-primary', 'is-light');
			tag.appendChild(this.buildIconLabelNodes('fa fa-fw fa-file', 'All Document Observations', 'mr-0', 'icon-text'));
			headerContainerElement.appendChild(tag);

			// only show the exclude observation sets toggle if there are other card decks on the form that use observation sets, otherwise it's not relevant
			const isAlwaysExcluding = !!currentSettings.alwaysExcludeObservationSets;
			if (!isAlwaysExcluding)
			{
				// Only show the toggle when other set-based decks exist on the form — otherwise there are
				// no sets to exclude and the button would be meaningless.
				const hasObservationSetDecks = Object.values(this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap).some((settings) => settings.useObservationSet);
				if (!hasObservationSetDecks)
				{
					return '';
				}
			}
			// add a toggle switch for excluding observation sets so users can flip between views in real time
			const isExcluding = !!currentSettings.excludeObservationSets;
			const toggleButton = document.createElement('button');
			toggleButton.type = 'button';
			toggleButton.classList.add('button', 'is-ghost', 'is-flex', 'is-align-items-center', 'gap-1', 'ml-1', 'px-2');
			toggleButton.style.fontSize = '0.85em';
			toggleButton.style.whiteSpace = 'nowrap';
			toggleButton.style.textDecoration = 'none';
			toggleButton.setAttribute('data-input-hash', pInput.Hash);
			toggleButton.setAttribute('data-raw-html-id', pInput.Macro.RawHTMLID);
			toggleButton.setAttribute('data-excluding', isExcluding ? 'true' : 'false');
			if (isAlwaysExcluding)
			{
				// Locked on — show as permanently active with no click handler
				toggleButton.appendChild(this.buildIconLabelNodes('fa fa-fw fa-toggle-on has-text-link', 'Exclude Observation Sets'));
				toggleButton.setAttribute('disabled', 'disabled');
				toggleButton.style.opacity = '0.7';
				toggleButton.style.cursor = 'default';
			}
			else
			{
				toggleButton.appendChild(this.buildIconLabelNodes(`fa fa-fw ${ isExcluding ? 'fa-toggle-on has-text-link' : 'fa-toggle-off has-text-grey' }`, 'Exclude Observation Sets'));
				toggleButton.addEventListener('click', () => this.handleExcludeObservationSetsToggle(toggleButton));
			}
			headerContainerElement.appendChild(toggleButton);
			return '';
		}
		// make a deep copy of the filters so we don't mutate the original object when we manipulate the label types for display
		const filterCopy = JSON.parse(JSON.stringify(currentFilters));
		const headerContainer = this.getCardDeckHeaderFilterContainerHTMLID(pInput.Macro.RawHTMLID);
		/**
		 * @type {HTMLSpanElement[]}
		 */
		const tmpFiltersTags = [];
		/** @type {HTMLElement} */
		const headerContainerElement = document.querySelector(headerContainer);
		if (!headerContainerElement)
		{
			this.pict.log.error(`Could not find header container element with ID ${ headerContainer } to build modifier tags for header.`);
			return '';
		}
		headerContainerElement.classList.add('is-flex', 'is-align-items-left', 'gap-1');
		// for each modifier type (include/exclude), we want to create a tag for each modifier that is applied, and color code it green for include and red for exclude.
		let modifierCount = 0;
		Object.entries(filterCopy).forEach(([ type ])=>
		{
			// skip the internal default-filter flag — it's not a real filter direction
			if (type === '_isDefaultTypeFilter')
			{
				return;
			}
			const joinType = type; // include or exclude
			for (let [ key, value ] of Object.entries(filterCopy[type]))
			{
				// Label Types are nested objects and we need to pull out the tags to be [LabelType]: [LabelValue1, LabelValue2] instead of just showing the raw object in the tag, which isn't helpful for users to understand what the modifier is
				if (key === 'LabelTypes')
				{
					value = value.map((/** @type {any} */ v)=>
					{
						for (const [ labelType, labelValues ] of Object.entries(v))
						{
							if (labelType.toLowerCase() === 'type')
							{
								v.Type = labelValues;
							}
							else if (labelType.toLowerCase() === 'value')
							{
								v.Values = labelValues;
							}
						}
						return `${ v.Type }: ${ v.Values.join(', ') }`;
					});
				}
				else
				{
					value = Array.isArray(value) ? value?.join(', ') : value;
					const tmpKey = key === 'ObservationTypes' ? 'Type' : key; // just to make it a little more user friendly in the tag
					const tmpValue = value.replace(/Legacy\s*/g, ''); // strip all "Legacy " prefixes from observation type names for cleaner display (e.g. "Legacy Image" → "Image")
					value = `${ tmpKey }: ${ tmpValue }`;
				}
				modifierCount++;
				const tag = document.createElement('span');
				tag.classList.add('tag', 'pl-1', 'mr-1', joinType.toLowerCase() === 'include' ? 'is-success' : 'is-danger', 'is-light');
				const tagIconWrapper = document.createElement('span');
				tagIconWrapper.classList.add('icon', 'mr-0');
				const tagIcon = document.createElement('i');
				tagIcon.classList.add('fa', 'fa-fw', joinType.toLowerCase() === 'include' ? 'fa-plus-circle' : 'fa-minus-circle');
				tagIconWrapper.appendChild(tagIcon);
				const tagText = document.createElement('span');
				tagText.classList.add('icon-text');
				// value is derived from user-influenced filter/label data — set as text, not markup
				tagText.textContent = modifierCount > tagDisplayLimit ? `${ modifierCount }+ modifiers applied` : value;
				tag.appendChild(tagIconWrapper);
				tag.appendChild(tagText);
				tmpFiltersTags.push(tag);
			}
		});
		// clear out any existing tags in the header container before we add the new ones so we don't end up with duplicates when the modifiers change
		headerContainerElement.innerHTML = '';
		// if we have more than tagDisplayLimit modifier tags, we should just show a summary tag instead of overwhelming the user with a million tags in the header
		// we will show them the summary of modifiers on hover with a tooltip for more info
		if (modifierCount > tagDisplayLimit)
		{
			const summaryTag = document.createElement('span');
			summaryTag.classList.add('tag', 'pl-1', 'is-info', 'is-light');
			const summaryIconWrapper = document.createElement('span');
			summaryIconWrapper.classList.add('icon', 'mr-0');
			const summaryIcon = document.createElement('i');
			summaryIcon.classList.add('fa', 'fa-fw', 'fa-info-circle');
			summaryIcon.setAttribute('tooltip', tmpFiltersTags.map((tag) => tag.innerText).join(', '));
			summaryIconWrapper.appendChild(summaryIcon);
			const summaryText = document.createElement('span');
			summaryText.classList.add('icon-text');
			summaryText.textContent = `${ modifierCount } modifiers applied`;
			summaryTag.appendChild(summaryIconWrapper);
			summaryTag.appendChild(summaryText);
			headerContainerElement.appendChild(summaryTag);
		}
		else
		{
			tmpFiltersTags.forEach((tag)=>
			{
				headerContainerElement.appendChild(tag);
			});
		}
		// When alwaysExcludeObservationSets is set, append the locked-on toggle after the filter tags
		// so it's always visible regardless of which filters are applied.
		if (currentSettings.alwaysExcludeObservationSets)
		{
			const toggleButton = document.createElement('button');
			toggleButton.type = 'button';
			toggleButton.classList.add('button', 'is-ghost', 'is-flex', 'is-align-items-center', 'gap-1', 'ml-1', 'px-2');
			toggleButton.style.fontSize = '0.85em';
			toggleButton.style.whiteSpace = 'nowrap';
			toggleButton.style.textDecoration = 'none';
			toggleButton.style.opacity = '0.7';
			toggleButton.style.cursor = 'default';
			toggleButton.setAttribute('disabled', 'disabled');
			toggleButton.setAttribute('data-excluding', 'true');
			toggleButton.appendChild(this.buildIconLabelNodes('fa fa-fw fa-toggle-on has-text-link', 'Exclude Observation Sets'));
			headerContainerElement.appendChild(toggleButton);
		}
		return '';
	}

	/**
	 * Returns the MediaRegistry namespaces for observation set card decks that are currently rendered on the DOM.
	 * This is used to scope the "exclude observation sets" logic so that only observations visible in other set-based decks
	 * on the form are excluded, rather than excluding observations from every set in the NamespaceObservationSetMap.
	 * @returns {Array<string>} - Array of MediaRegistry namespace strings for observation set decks on the DOM.
	 */
	getObservationSetNamespacesOnDOM()
	{
		if (typeof document === 'undefined')
		{
			return [];
		}
		const namespaces = [];
		const setDecksOnDOM = document.querySelectorAll(this.packageTypeSelectorMap['AllObservationSets']);
		for (const deckElement of setDecksOnDOM)
		{
			const inputHash = deckElement.getAttribute(this.deckInputHashAttribute);
			if (!inputHash)
			{
				continue;
			}
			// get the RawHTMLID from the container element's ID (format: CARD-DECK-CONTAINER-FOR-{RawHTMLID})
			const containerElement = deckElement.closest('[id^="CARD-DECK-CONTAINER-FOR-"]');
			if (!containerElement)
			{
				continue;
			}
			const rawHTMLID = containerElement.id.replace('CARD-DECK-CONTAINER-FOR-', '');
			// read the IDObservationSet from the hidden input element
			const hiddenInput = /** @type {HTMLInputElement} */ (document.getElementById(rawHTMLID));
			const tmpIDObservationSet = hiddenInput?.value ? parseInt(hiddenInput.value) : null;
			// build the namespace the same way the marshal flow does
			if (tmpIDObservationSet)
			{
				namespaces.push(this.buildNamespaceForCardDeck(inputHash, tmpIDObservationSet));
			}
			else
			{
				// temporary set that hasn't been saved yet
				namespaces.push(this.buildNamespaceForCardDeck(inputHash, null, true));
			}
		}
		return namespaces;
	}

	/**
	 * Resolves the list of set-based deck namespaces to use when filtering observations for an exclude-sets deck.
	 * Prefers DOM-discovered set decks (accurate to what is currently rendered on this form), but falls back to the
	 * persisted NamespaceObservationSetMap when the DOM list is empty — this is important on cold reload, where
	 * document-list decks can marshal before set-based decks have applied their DOM marker attributes. Without the
	 * fallback, the deck would rebuild the registry with the full (unfiltered) document observation list on every reload.
	 * @returns {Array<string>|null} - An array of namespaces, or null to signal "use everything in NamespaceObservationSetMap".
	 */
	getObservationSetNamespacesForExcludeFiltering()
	{
		const domNamespaces = this.getObservationSetNamespacesOnDOM();
		if (domNamespaces.length)
		{
			return domNamespaces;
		}
		// null signals to MediaRegistry.getDocumentObservationsExcludingCurrentSets to use all persisted set namespaces
		return null;
	}

	/**
	 * Handles the toggle for excluding observation sets from the card deck. This is called when the user clicks the "Exclude Observation Sets" toggle button in the header.
	 * It updates the dynamic settings for the deck and triggers a remarshal to refresh the deck contents in real time.
	 * @param {HTMLButtonElement} pToggleButton - The toggle button element that was clicked.
	 */
	handleExcludeObservationSetsToggle(pToggleButton)
	{
		const inputHash = pToggleButton.getAttribute('data-input-hash');
		const rawHTMLID = pToggleButton.getAttribute('data-raw-html-id');
		// look up the view hash from the deck container at click time (it may not be available at build time)
		const deckContainerElement = rawHTMLID ? document.querySelector(`${this.getCardDeckContainerHTMLID(rawHTMLID)} .${this.deckClassName}`) : null;
		const viewHash = deckContainerElement?.getAttribute(this.deckViewHashAttribute);
		if (!inputHash || !viewHash || !rawHTMLID)
		{
			this.pict.log.error('Could not find input hash, view hash, or raw HTML ID on the exclude observation sets toggle element. Cannot toggle setting.');
			return;
		}
		const currentSettings = this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[inputHash];
		if (!currentSettings)
		{
			this.pict.log.error(`Could not find settings for input hash ${inputHash}. Cannot toggle excludeObservationSets.`);
			return;
		}
		// flip the current state
		const newValue = pToggleButton.getAttribute('data-excluding') !== 'true';
		const tmpView = this.pict.views[viewHash];
		const pInput = tmpView?.getInputFromHash(inputHash);
		// persist the override to FormData so it survives save/reload and remarshals within this session
		if (pInput)
		{
			this.setPersistedOverrideForInput(pInput, 'excludeObservationSets', newValue);
		}
		currentSettings.excludeObservationSets = newValue;
		// update the exclude hidden input so it stays in sync with the toggle state for reference
		const hiddenInputElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderExcludeObservationSetHiddenInputHTMLID(rawHTMLID))?.[0];
		if (hiddenInputElement)
		{
			hiddenInputElement.value = newValue ? 'true' : 'false';
		}
		// show a loading indicator immediately so the user sees feedback during the multi-second async rebuild:
		// clear the deck body, drop in the spinner, and mark the toggle button as loading
		this.showLoadingStateForDeck(rawHTMLID);
		pToggleButton.classList.add('is-loading');
		pToggleButton.setAttribute('disabled', 'disabled');
		if (tmpView && pInput)
		{
			// dataChanged() triggers marshalToView() (which rebuilds the deck) and notifies FormPersistence for autosave
			tmpView.dataChanged(inputHash);
		}
		// explicitly trigger a document autosave so the FormData-persisted override reaches the server even when
		// no bound input value actually changed (dataChanged only dirties the input record via Informary)
		if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument && this.pict.providers?.DocumentProvider?.handleSave)
		{
			this.pict.providers.DocumentProvider.handleSave(true);
		}
	}

	/**
	 * Clears the deck body and injects the initial loading spinner, signaling to the user that a rebuild is in flight.
	 * Used when the deck content is about to change due to a user action (e.g. toggling excludeObservationSets) so there is visible feedback during the async rebuild.
	 * @param {string} pInputHTMLID - The raw HTML ID of the deck input.
	 */
	showLoadingStateForDeck(pInputHTMLID)
	{
		const cardDeckContentAreaElement = document.querySelector(this.getCardDeckContentHTMLID(pInputHTMLID));
		if (cardDeckContentAreaElement)
		{
			const tmpLoadingMessage = document.createElement('span');
			tmpLoadingMessage.className = 'initial-loading-message';
			const tmpSpinnerIcon = document.createElement('i');
			tmpSpinnerIcon.className = 'fa fa-fw fa-circle-notch fa-spin';
			tmpLoadingMessage.appendChild(tmpSpinnerIcon);
			// this container is looked up from the DOM, not freshly created, so clear it as the assignment did
			cardDeckContentAreaElement.textContent = '';
			cardDeckContentAreaElement.appendChild(tmpLoadingMessage);
		}
	}

	/**
	 * Build the observation card deck for a given input.
	 * @param {Object} pView - the view object for which to build the observation card deck (used to get the current view hash for storing in data attributes on the cards for reference in interactivity, and for logging purposes)
	 * @param {Object} pInput - the input object for which to build the observation card deck (used to get the raw HTML ID for the input, which we use to find the container element for the deck and to store the current namespace for the deck in a data attribute on the input element)
	 * @param {string} pNamespace - the namespace for the observation list
	 * @param {any[]} pObservationList - the list of observations to display in the card deck
	 */
	buildObservationCardDeck(pView, pInput, pNamespace, pObservationList)
	{
		const deckContent = this.pict.ContentAssignment.getElement(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const deckContainerElement = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID) + (` .${this.deckClassName}`))?.[0];

		if (!deckContent || !deckContainerElement)
		{
			this.pict.log.error(`Could not find deck container elements for input with HTML ID ${pInput.Macro.RawHTMLID}. Cannot build observation card deck.`);
			return;
		}
		// apply the deck layout style as a class to the container for styling purposes (default is 'thumbnail', but can be configured through options to be 'thumbnail', 'list', or 'details')
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const deckLayout = currentSettings?.deckLayout || 'thumbnail';
		deckContent.classList.add(`observation-deck-style-${deckLayout}`);
		// sync the toggle button active state to match the configured deck layout (template defaults to thumbnail being active)
		if (deckLayout !== 'thumbnail')
		{
			const toggleButtons = deckContainerElement.querySelectorAll('.observation-card-deck-style-toggle button');
			toggleButtons.forEach((/** @type {HTMLElement} */ btn) =>
			{
				btn.classList.remove('is-active');
				if (btn.dataset.deckStyle === deckLayout)
				{
					btn.classList.add('is-active');
				}
			});
		}
		// container marker attributes (view/input hash + deck type markers) are applied by prepareUIBeforeBuildingCardDeck via applyDeckContainerMarkerAttributes
		// surgical DOM diff: only add/remove cards that actually changed to avoid flickering existing images
		const desiredIDs = pObservationList.map((/** @type {any} */ o) => String(o.IDObservation));
		const existingCards = Array.from(deckContent.querySelectorAll(`.${this.cardClassName}`));
		const existingIDMap = new Map();
		for (const card of existingCards)
		{
			existingIDMap.set(card.getAttribute(this.cardAttributeId), card);
		}
		// remove cards that are no longer in the observation list
		for (const [ id, card ] of existingIDMap)
		{
			if (!desiredIDs.includes(id))
			{
				card.remove();
				existingIDMap.delete(id);
			}
		}
		// add new cards and reorder all cards to match pObservationList
		let previousSibling = null;
		for (const [ index, observation ] of pObservationList.entries())
		{
			const obsID = String(observation.IDObservation);
			let card = existingIDMap.get(obsID);
			if (!card)
			{
				// new card — build and make individually draggable
				card = this.buildObservationCard(pView, pInput, observation, index);
				this.pict.providers.DraggableUtil.makeElementDraggable(card, this.draggableConfigurationForDeck);
			}
			// position the card correctly (move existing or insert new)
			const nextSibling = previousSibling ? previousSibling.nextSibling : deckContent.firstChild;
			if (card !== nextSibling)
			{
				deckContent.insertBefore(card, nextSibling);
			}
			previousSibling = card;
		}
		// on first render (deck was empty), initialize draggable on the full collection
		if (existingCards.length === 0)
		{
			_Pict.providers.DraggableUtil.initializeDraggableCollection(deckContent, this.draggableConfigurationForDeck);
		}
		// update index numbers and remove loading skeletons
		this.updateIndexNumbersOnUIForDeck(pInput, pObservationList);
		this.removeInitialLoadingMessage(pInput);
	}

	/**
	 * Function to update the index numbers that show up on top of the card thumbnails in the deck based on the current order of the observations in the deck on the DOM.
	 * @param {Object} pInput - the input object for which to update the index numbers (used to get the raw HTML ID for the input, which we use to find the card elements in the deck and to get the current options for the deck)
	 * @param {any[]} [pOrderedIDObservationList] - the list of observation IDs in the current order they are displayed in the deck, which we can use to update the index numbers on the cards to reflect their current position in the deck (if not provided, we will just use the order of the card elements in the DOM to update the index numbers)
	*/
	updateIndexNumbersOnUIForDeck(pInput, pOrderedIDObservationList)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const indexTagScope = currentSettings.indexTagScope || 'local';
		// only update local indices when the scope is 'local' — document-scoped decks will be handled by updateDocumentIndexNumbers below
		if (indexTagScope === 'local')
		{
			const cardElements = document.querySelectorAll(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID) + ` .${this.cardClassName}`);
			cardElements.forEach((card, index) =>
			{
				const obsID = card.getAttribute(this.cardAttributeId);
				const obsIndex = pOrderedIDObservationList?.length ? pOrderedIDObservationList.findIndex((/** @type {any} */ o) => o.IDObservation == obsID) : index;
				if (obsIndex !== -1)
				{
					const indexTag = card.querySelector('.card-index');
					if (indexTag)
					{
						indexTag.textContent = (obsIndex + 1).toString();
					}
				}
			});
		}
		// always run the document-level index update — it will only affect decks configured with indexTagScope: 'document'
		this.updateDocumentIndexNumbers();
	}

	/**
	 * Resolves the current settings for a deck by looking up the input hash stored on the deck's parent container element.
	 * @param {Element} pDeckBodyElement - a `.observation-card-deck-body` element
	 * @returns {Object|null} - the settings object for the deck's input, or null if the input could not be resolved
	 */
	_getSettingsForDeckElement(pDeckBodyElement)
	{
		const deckContainer = pDeckBodyElement?.closest(`.${this.deckClassName}`);
		if (!deckContainer)
		{
			return null;
		}
		const inputHash = deckContainer.getAttribute(this.deckInputHashAttribute);
		if (!inputHash)
		{
			return null;
		}
		return this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[inputHash] || null;
	}

	/**
	 * Updates index numbers across ALL card decks on the page that are configured with `indexTagScope: 'document'`.
	 * Cards are numbered sequentially based on their visual DOM order from top to bottom of the page.
	 */
	updateDocumentIndexNumbers()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const allDeckBodies = document.querySelectorAll('.observation-card-deck-body');
		if (!allDeckBodies.length)
		{
			return;
		}
		let documentIndex = 1;
		allDeckBodies.forEach((deckBody) =>
		{
			const settings = this._getSettingsForDeckElement(deckBody);
			const indexTagScope = settings?.indexTagScope || 'local';
			if (indexTagScope !== 'document')
			{
				return;
			}
			const cardElements = deckBody.querySelectorAll(`.${this.cardClassName}`);
			cardElements.forEach((card) =>
			{
				const indexTag = card.querySelector('.card-index');
				if (indexTag)
				{
					indexTag.textContent = documentIndex.toString();
				}
				documentIndex++;
			});
		});
	}

	/**
	 * Set the observations for the deck based on a provided list of observations. This will overwrite any existing observations in the deck.
	 * NOTE: This is only used for Interactive mode, there is a separate function for building the deck in Print called "buildCardDeckCardsForPrintView()"
	 * @param {any} pView - the pict-view instance hosting the input
	 * @param {any} pInput - the input object for which to build the observation card
	 * @param {Object} pObservation - the observation object to set for the deck (should have the necessary properties for display in the deck)
	 * @param {number} pIndex - the index of the observation in the deck (used to determine the ordinal number for display)
	 * @returns {HTMLElement|undefined} - returns the card template of the observation
	 */
	buildObservationCard(pView, pInput, pObservation, pIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			this.pict.log.error(`Attempted to build an observation card for a non-interactive document, which is not supported. Please use the buildCardDeckCardsForPrintView function for rendering the deck in print view instead, which is optimized for non-interactive documents.`);
			return;
		}
		if (pObservation?.IDObservation === undefined)
		{
			this.pict.log.error(`Observation object is missing IDObservation property or it is undefined. Cannot build card for observation: ${ JSON.stringify(pObservation) }`);
			return;
		}
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const cardElement = document.createElement('div');
		cardElement.setAttribute(this.cardAttributeId, pObservation.IDObservation);
		cardElement.classList.add(this.cardClassName);
		cardElement.innerHTML = ``;
		const tmpOrdinal = pIndex + 1; /* we want the number in the UI to be local to the set, not the Ordinal itself since that can be global and not reflect the current order in the deck if there are other sets of observations in the document */

		const MAX_DESCRIPTION_LENGTH = 250;

		const hasDescription = typeof pObservation.Description === 'string' && pObservation.Description.trim() !== '';
		let shortDescription = '';
		let fullDescription = '';
		let useReadMore = false;

		if (hasDescription)
		{
			fullDescription = pObservation.Description.replace(/'/g, '\\\'');
			if (pObservation.Description.length > MAX_DESCRIPTION_LENGTH)
			{
				shortDescription = pObservation.Description.slice(0, MAX_DESCRIPTION_LENGTH).replace(/'/g, '\\\'') + '...';
				useReadMore = true;
			}
			else
			{
				shortDescription = fullDescription;
			}
		}

		let tmpCardContent = '';
		// don't add duplicates
		if (document.querySelector(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID) + ` .${this.cardClassName}[${this.cardAttributeId}="${pObservation.IDObservation}"]`))
		{
			return;
		}
		let removeButtonTemplate = '';
		// if the document is locked, we can still show the image, but we can't remove it from the set
		if (!currentSettings.preventRemovingCards && !this.isDocumentLocked && this.canEditDocument)
		{
			removeButtonTemplate = `<button type="button" class="delete card-delete"
				onclick="_Pict.providers.ObservationCardDeckProvider.removeCardFromDeck('${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })"></button>`;
		}

		// format designated time and creator name for the details view
		const tmpDesignatedDate = pObservation.DesignatedTime ? new Date(pObservation.DesignatedTime).toLocaleDateString() : '';
		const tmpDesignatedTime = pObservation.DesignatedTime ? new Date(pObservation.DesignatedTime).toLocaleTimeString() : '';
		// resolve creator name from the user name cache (populated asynchronously by resolveCreatorNamesForDeck)
		const userNameCache = this.pict.AppData.ObservationCardDeckProvider?.userNameCache || {};
		const tmpCreatorName = userNameCache[pObservation.CreatingIDUser] || '';

		// Compact layout — used by thumbnail and list deck styles (toggled purely via CSS)
		const compactLayout =
		`<article class="media card-layout-compact" style="position: relative;">
			<span class="${ currentSettings.hideIndexTags ? 'is-hidden' : '' } card-index badge is-info">${ tmpOrdinal }</span>
			${ removeButtonTemplate }
			<figure class="image ${this.cardClassName}-content has-background-text-soft is-128x128 media-left">
				<img loading="lazy" class="photo-image is-clickable" height="128px" width="128px" src="/1.0/Observation/${ pObservation.IDObservation }/Image/Thumbnail-Dense?t=${ new Date().getTime() }"
					onclick="_Pict.providers.ObservationCardDeckProvider.handleClickForCardThumbnail(event, '${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })" />
			</figure>
			<div class="media-content">
				<div class="content pr-5">
					<strong class="title is-size-6">${ pObservation.Name || `Observation #${pObservation.IDObservation}` }</strong>
					<p class="subtitle is-size-7 has-text-text-30">
						${ shortDescription || '<i class="has-text-text-50">No description</i>' }
						${ useReadMore ? `<a href="javascript:void(0);" onclick="_Pict.providers.ObservationCardDeckProvider.handleClickForCardThumbnail(event, '${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })">Read More</a>` : '' }
					</p>
				</div>
				<span class="${ currentSettings.preventReorderingCards ? 'is-hidden' : '' } card-drag-handle icon has-text-text-50">
					<i class="fa fa-fw fa-grip"></i>
				</span>
			</div>
		</article>`;

		// Build label tags for the details view from the raw observation Labels object
		let labelTagsHtml = '';
		if (pObservation.Labels && typeof pObservation.Labels === 'object')
		{
			const MAX_LABEL_TAGS = 6; // truncate to first few to keep the card compact
			let tagCount = 0;
			let truncated = false;
			const tagParts = [];
			for (const [ labelTypeKey, labelObjects ] of Object.entries(pObservation.Labels))
			{
				if (labelTypeKey === 'SAVE') continue;
				const items = Array.isArray(labelObjects) ? labelObjects : [ labelObjects ];
				for (const labelObj of items)
				{
					if (!labelObj?.Tag || !labelObj.Tag.length) continue;
					if (tagCount >= MAX_LABEL_TAGS)
					{
						truncated = true; break;
					}
					tagParts.push(`<span class="tag is-small is-rounded tag-outlined-primary">${ labelTypeKey }: ${ labelObj.Tag }</span>`);
					tagCount++;
				}
				if (truncated) break;
			}
			if (tagParts.length)
			{
				labelTagsHtml = `
				<div class="card-details-row">
					<div class="card-details-field" style="grid-column: span 2;">
						<div class="title is-7 has-text-text-50 mb-1">Labels</div>
						<div class="card-details-labels">${ tagParts.join(' ') }${ truncated ? '<span class="tag is-small is-rounded has-text-text-50">...</span>' : '' }</div>
					</div>
				</div>`;
			}
		}

		// Details layout — postcard-style with image on the left and observation metadata on the right (similar to print standard card)
		const detailsLayout =
		`<article class="card-layout-details" style="position: relative;">
			<span class="${ currentSettings.hideIndexTags ? 'is-hidden' : '' } card-index badge is-info">${ tmpOrdinal }</span>
			${ removeButtonTemplate }
			<span class="${ currentSettings.preventReorderingCards ? 'is-hidden' : '' } card-drag-handle icon has-text-text-50">
				<i class="fa fa-fw fa-grip"></i>
			</span>
			<div class="card-details-grid">
				<figure class="card-details-image has-background-text-soft">
					<img loading="lazy" class="photo-image is-clickable" src="/1.0/Observation/${ pObservation.IDObservation }/Image/Preview?t=${ new Date().getTime() }"
						onclick="_Pict.providers.ObservationCardDeckProvider.handleClickForCardThumbnail(event, '${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })" />
				</figure>
				<div class="card-details-metadata">
					<div class="card-details-header has-background-text-soft px-3 py-2">
						<strong class="title is-6 mb-0">${ pObservation.Name || `Observation #${pObservation.IDObservation}` }</strong>
						<span class="subtitle is-7 has-text-text-30">#${ pObservation.IDObservation }</span>
					</div>
					<div class="card-details-body px-3 py-2">
						<div class="card-details-row">
							<div class="card-details-field">
								<div class="title is-7 has-text-text-50 mb-1">Created by</div>
								<div class="subtitle is-7 card-details-creator-name" data-creator-id="${ pObservation.CreatingIDUser || '' }">${ tmpCreatorName || 'N/A' }</div>
							</div>
							<div class="card-details-field">
								<div class="title is-7 has-text-text-50 mb-1">Designated Time</div>
								<div class="subtitle is-7">${ tmpDesignatedDate }${ tmpDesignatedTime ? ' at ' + tmpDesignatedTime : '' }</div>
							</div>
						</div>
						<div class="card-details-row">
							<div class="card-details-field" style="grid-column: span 2;">
								<div class="title is-7 has-text-text-50 mb-1">Description</div>
								<div class="subtitle is-7">${ pObservation.Description || '<span class="has-text-text-50">No description provided</span>' }</div>
							</div>
						</div>
						${ labelTagsHtml }
					</div>
				</div>
			</div>
		</article>`;

		tmpCardContent = compactLayout + detailsLayout;
		cardElement.innerHTML = tmpCardContent;
		return cardElement;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.log.info(`Marshaling data to form for Observation Card Deck input with value: ${ pValue } and HTML selector: ${ pHTMLSelector }`);
		const tmpMarshalPromise = this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
		.catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		this.marshalPromises.push(tmpMarshalPromise);
		// EVERY marshal gates print rendering. This used to register only the first marshal per input hash, on the
		// assumption that it already covered the deck build — it does not. prepareUIBeforeBuildingCardDeck fires the
		// async print build separately, so a later marshal's build could begin after completeRender() had already
		// drained, and the rasterizer would snapshot an empty deck. registerRenderDependency is a no-op in interactive
		// mode, so this only accumulates across the finite marshal cycle of a print render.
		if (!this.registeredDependencyInputHashList.includes(pInput.Hash))
		{
			this.registeredDependencyInputHashList.push(pInput.Hash);
		}
		this.registerRenderDependency(tmpMarshalPromise);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Custom CSS injection for the observation card deck. This is needed to apply specific styles to the deck and its cards that are not covered by the primary CSS collection, especially during development when we are iterating on the design and functionality of the deck and may need to make frequent updates to the styles without worrying about caching issues. We will eventually migrate these styles to the primary CSS collection, but for now this allows us to develop the functionality and styles in parallel.
	 * @param {Object} currentSettings - the current settings for the deck, which can be used to conditionally apply styles based on the configuration of the deck (ex: different styles for print view vs interactive view, or based on the selected display style for the deck)
	 */
	injectCustomCSS(currentSettings)
	{
		if (this.customCSSInjected || document.getElementById('ObservationCardDeck-Styles')) return;

		const styleElement = document.createElement('style');
		styleElement.id = 'ObservationCardDeck-Styles';
		styleElement.textContent = /*CSS*/`
			/* Observation Card Deck (Collection) specific styles */
			.observation-card-deck {
				/* NOTE: Would be nice if we could add an extension for Bulma cards instead of this duplication... */
				/* duplication of the ".card" class from Bulma, but renamed to avoid confusion with our Card elements inside the deck which aren't necessarily Bulma cards and to allow for more customization specific to the deck container itself */
				--bulma-card-color: var(--bulma-text);
				--bulma-card-background-color: var(--bulma-scheme-main);
				--bulma-card-shadow: var(--bulma-shadow);
				--bulma-card-radius: 0.75rem;
				--bulma-card-header-background-color: transparent;
				--bulma-card-header-color: var(--bulma-text-strong);
				--bulma-card-header-padding: 0.75rem 1rem;
				--bulma-card-header-shadow: 0 0.125em 0.25em hsla(var(--bulma-scheme-h), var(--bulma-scheme-s), var(--bulma-scheme-invert-l), 0.1);
				--bulma-card-header-weight: var(--bulma-weight-bold);
				--bulma-card-content-background-color: transparent;
				--bulma-card-content-padding: 1.5rem;
				--bulma-card-media-margin: var(--bulma-block-spacing);
				background-color: var(--bulma-card-background-color);
				border-radius: var(--bulma-card-radius);
				box-shadow: var(--bulma-card-shadow);
				color: var(--bulma-card-color);
				max-width: 100%;
				position: relative;
				margin-top: 0.5rem;
				margin-bottom: 0.5rem;
			}
			/* initialization message to show that something is happening */
			.observation-card-deck .initial-loading-message {
				vertical-align: middle;
				color: var(--bulma-text-soft);
				text-align: center;
				width: 100%;
				display: block;
				font-size: 3.25rem;
				padding: 2rem 0 1rem 0;
			}
			/* specific styles for the observation cards inside the deck */
			.observation-card-deck .observation-card .card-delete {
				display: none;
			}
			.observation-card-deck .observation-card:hover .card-delete {
				display: block;
			}
			.observation-card-deck.deck-filters-applied .observation-card .card-delete,
			.observation-card-deck.deck-filters-applied .observation-card:hover .card-delete {
				display: none;
			}
			.observation-card-deck .observation-card .badge.card-index {
				position: absolute; 
				top: 12px; 
				left: -4px; 
				z-index: 1; 
				right: auto;
			}
			.observation-card-deck .observation-card .card-delete {
				position: absolute; 
				top: 2px; 
				right: 2px; 
				z-index: 1;
				background-color: var(--bulma-danger-50);
				opacity: 0.8;
			}
			.observation-card-deck .observation-card-deck-header {
				border-start-start-radius: var(--bulma-card-radius);
				border-start-end-radius: var(--bulma-card-radius);
				background-color: var(--bulma-card-header-background-color);
				align-items: stretch;
				box-shadow: var(--bulma-card-header-shadow);
				display: flex;
				padding: var(--bulma-card-header-padding);
				position: relative;
				z-index: 1;
				justify-content: space-between;
				flex-wrap: wrap;
				gap: 0.5rem;
				font-weight: var(--bulma-card-header-weight);
				color: var(--bulma-card-header-color);
			}
			.observation-card-deck .observation-card-deck-header .card-deck-header-actions {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				vertical-align: middle;
			}
			.observation-card-deck .observation-card-deck-header .card-deck-header-filters {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				vertical-align: middle;
				/* this is to allow the filter tags to wrap to a new line if there are too many to fit in the header, instead of overflowing and breaking the layout */
				flex-wrap: wrap;
				max-width: 100%;
				justify-content: flex-start;
				flex-grow: 1; /* allow the filters container to grow and take up available space when it wraps */
				/* we also want to make sure that the filters don't get pushed down below the header on smaller screens, so we can set a min-width on the header to prevent that from happening */
				min-width: 300px;
				/* and we want to make sure that the filters don't get too squished on smaller screens, so we can set a max-width on the filters container to prevent that from happening */
				max-width: 100%;
				/* if there are a lot of filters and they wrap to a new line, we want to add some spacing between the header and the filters to visually separate them, so we can add a margin-top to the filters container when it wraps */
				margin-top: 0.5rem;
			}
			.observation-card-deck .observation-card-deck-header .card-deck-header-observation-set-selector {
				display: block;
				align-items: center;
				vertical-align: middle;
				max-width: 100%;
				font-size: 0.9rem;
				flex-grow: 1; /* allow the filters container to grow and take up available space when it wraps */
			}
			.observation-card-deck .observation-card-deck-body,
			.observation-card-deck .observation-card-deck-empty-message {
				gap: calc(var(--bulma-column-gap) * 0.5);
				padding: calc(var(--bulma-column-gap) * 0.75);
				display: flex;
				flex-wrap: wrap;
				position: relative;
				background-color: var(--bulma-background);
				justify-content: flex-start;
				align-items: flex-start;
				border: 1px solid var(--bulma-border);
				border-bottom-left-radius: var(--bulma-card-radius);
				border-bottom-right-radius: var(--bulma-card-radius);
				border-top: none;
				/* no forced min-height — cards dictate the height naturally.
				   The empty-message sibling handles its own min-height when the body is :empty.
				   The initial-loading-message spinner has its own padding to prevent full collapse during load. */
				/* transition for when hovering over cards and the deck resizes due to description popovers showing up and changing the size of the cards */
				transition: all 0.3s ease;
				/* this is to prevent the deck from jumping around when we hover over cards and the popovers show up and change the size of the cards, by allowing the deck to grow in height instead of overflowing and causing a scrollbar to appear */
				overflow: visible;
			}
			.observation-card-deck .observation-card-deck-body:empty {
				display: none;
			}
			.observation-card-deck .observation-card-deck-body:not(:empty) + .observation-card-deck-empty-message {
				display: none;
			}
			.observation-card-deck .observation-card-deck-body:empty + .observation-card-deck-empty-message {
				display: flex;
				align-items: center;
				justify-content: center;
				color: var(--bulma-text-50);
				min-height: 75px;
				font-size: 0.875rem;
			}
			/* Observation Card (Item) specific styles */
			@keyframes observationCardFadeIn {
				from { opacity: 0; }
				to { opacity: 1; }
			}
			.observation-card {
				border: 3px solid transparent;
				border-radius: 6px;
				width: calc(128px + (3px * 2)); /* thumbnail size + border */
				animation: observationCardFadeIn 0.25s ease-in;
			}
			.observation-card img {
				opacity: 1;
				transition: opacity 0.25s ease-in;
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
			.observation-card:hover {
				border: 3px solid var(--bulma-primary);
			}
			.observation-card .card-layout-compact {
				margin: 0;
			}
			.observation-card .observation-card-content-inner {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 0.5rem;
			}
			.observation-deck-style-thumbnail .observation-card {
				width: calc(128px + (3px * 2)); /* thumbnail size + border */
			}
			.observation-deck-style-list .observation-card {
				width: 100%;
			}
			.observation-card-deck .media-content {
				display: none;
			}
			.observation-deck-style-list figure.is-128x128 {
				display: flex;
				align-items: flex-start;
				gap: 1rem;
				height: 64px;
				width: 64px;
			}
			.observation-deck-style-list .media {
				border: 1px solid var(--bulma-border);
				padding: 0.5rem;
				border-radius: 4px;
			}
			.observation-deck-style-list .media-content {
				display: block;
			}
			.observation-card-deck .observation-card .media-content .card-drag-handle {
				position: absolute;
				right: 5px;
				top: 50%;
				transform: translateY(-50%);
				z-index: 1;
			}
			.observation-deck-style-list .card-observation-read-more-button {
				display: none;
			}

			/* Details layout — postcard-style view: hide by default, show only in details mode */
			.observation-card-deck .card-layout-details {
				display: none;
			}
			.observation-deck-style-details .card-layout-details {
				display: block;
			}
			.observation-deck-style-details .card-layout-compact {
				display: none;
			}
			.observation-deck-style-details .observation-card {
				width: 100%;
			}
			.card-details-grid {
				display: grid;
				grid-template-columns: 300px 1fr;
				border: 1px solid var(--bulma-border);
				border-radius: 6px;
				overflow: hidden;
				min-height: 300px;
			}
			.card-details-image {
				margin: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				overflow: hidden;
			}
			.card-details-image img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
			.card-details-header {
				display: flex;
				align-items: baseline;
				gap: 0.5rem;
				border-bottom: 1px solid var(--bulma-border);
			}
			.card-details-row {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 0.5rem;
				margin-bottom: 0.5rem;
			}
			.card-details-row:last-child {
				margin-bottom: 0;
			}
			.card-details-labels {
				display: flex;
				flex-wrap: wrap;
				gap: 0.25rem;
			}
			.tag.tag-outlined-primary {
				background-color: transparent;
				border: 1px solid var(--bulma-primary);
				color: var(--bulma-primary);
			}
			.observation-deck-style-details .card-layout-details .card-drag-handle {
				position: absolute;
				right: 0.75rem;
				top: 0.75rem;
				z-index: 1;
			}

			.observation-card-deck-style-toggle .button.is-ghost {
				color: var(--bulma-text-soft);
			}
			.observation-card-deck-style-toggle .button.is-ghost.is-active {
				color: var(--bulma-text);
			}

			/* Print Only types for PDF viewer */
			.for-print-only .observation-card-deck,
			.for-print-only .observation-card-deck .observation-card-deck-body {
				display: block;
				padding: 0;
				border: none;
				border-radius: 0;
				gap: 0;
				background-color: transparent;
				min-height: auto;
				transition: none;
				overflow: visible;
				page-break-inside: auto;
				box-shadow: none;
				width: 100%;
				max-width: none;
			}
			.for-print-only .observation-card-deck .observation-card {
				page-break-inside: avoid;
				border: none;
				border-radius: 0;
				width: auto;
				margin-bottom: 1rem;
			}
			/* TODO: we might want to show the filters in the header for print as well, but for now we'll hide the header entirely for print since the filters are more for interactive use and don't make as much sense in a static format like PDF */
			.for-print-only .observation-card-deck .observation-card-deck-header {
				display: none;
			}
			.for-print-only .observation-card-deck .observation-card-deck-empty-message {
				border-radius: 5px;
				border: none;
			}
			`;
		document.head.appendChild(styleElement);
		this.customCSSInjected = true;
	};

	/**
	 * Attempts to get the observation set for the deck based on the passed value (expected to be only the Observation Set ID),
	 * or if no passed value, then it will attempt to find the observation set based on the input hash as the namespace.
	 * If that doesn't work, it will attempt to create a new observation set based on the document observations and any filters provided in options.
	 * Finally, it will build the observation card deck based on the observation set it found or created.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		if (!this.pict.AppData.DocumentData)
		{
			this.pict.log.error('Document data or document ID is missing from AppData. Cannot marshal data to form for Observation Card Deck.');
			return;
		}
		// always start by making sure our MediaRegistry is up to date with the latest document observation list (in case anything was added externally, etc)
		this.pict.providers.MediaRegistry.updateRegistryFromFormData();
		// blend the default and current settings passed in from PictForm.
		// Persisted user overrides (FormData.ObservationCardDeckOverrides) are applied last inside setCurrentSettingsForInput
		// so toggled preferences like excludeObservationSets survive save/reload and Edit→Print view switches.
		const currentSettings = this.setCurrentSettingsForInput(pInput, pInput?.PictForm?.CardDeckSettings);
		// Keep the exclude hidden input in sync with the resolved setting
		const excludeHiddenInput = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderExcludeObservationSetHiddenInputHTMLID(pInput.Macro.RawHTMLID))?.[0];
		if (excludeHiddenInput)
		{
			excludeHiddenInput.value = currentSettings.excludeObservationSets ? 'true' : 'false';
		}
		this.injectCustomCSS(currentSettings);
		// If we are using sets, we need to check the hidden value or prepare for the possibility of not having a value if the user hasn't selected/created an observation set yet.
		// The selector in the header is optional, and new pristine selectors that are using sets will have a temporary namespace until the first observation is add, which creates the set ID.
		// NOTE: Filters are not used for the IDObservationSet case, because we assume that if an IDObservationSet is provided, then the user has already applied any necessary filters to create that set, and they want to see that specific set in the deck.
		// If we apply additional filters on top of that, we might end up with an empty deck or a different set of observations than the user intended to display.
		currentSettings.useObservationSet ? await this.handleOnDataMarshalForObservationSetCase(pView, pInput, pValue) : await this.handleOnDataMarshalForObservationListCase(pView, pInput);
	}

	/**
	 * Toggles the visibility of the "Add" and "Quick Capture" buttons in the header of the card deck based on the config settings.
	 * @param {Object} pInput - The input object for which to toggle the visibility of the header buttons (used to get the raw HTML ID for the input, which we use to find the header button elements)
	 */
	toggleVisibilityForAddCardHeaderButtons(pInput)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const addButton = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderActionsButtonAddHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const quickCaptureButton = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderActionsButtonQuickCaptureHTMLID(pInput.Macro.RawHTMLID))?.[0];
		// when requireExplicitSetCreation is enabled, check whether a set is currently selected —
		// if not, hide Add/QuickCapture so the user must go through "Create New Set" first
		let hasSelectedSet = true;
		if (currentSettings?.requireExplicitSetCreation && currentSettings?.useObservationSetSelector)
		{
			const tmpHiddenValue = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID))?.[0]?.value;
			hasSelectedSet = !isNaN(parseInt(tmpHiddenValue));
		}
		// show the add/qc buttons in the header if we're not preventing adding cards and the document isn't locked and is editable
		const canAddCards = !currentSettings?.preventAddingCards && !this.isDocumentLocked && this.canEditDocument && (!this.hasFiltersApplied(pInput) || this.hasActionableFilters(pInput));
		if (canAddCards)
		{
			if (addButton)
			{
				addButton.classList.remove('is-hidden', 'is-skeleton');
			}
			if (quickCaptureButton)
			{
				quickCaptureButton.classList.remove('is-hidden', 'is-skeleton');
			}
			// when the buttons are visible but no set is selected, show them as disabled instead of hiding
			// so the user can see the actions are available once they create/select a set
			if (!hasSelectedSet)
			{
				addButton?.setAttribute('disabled', 'disabled');
				quickCaptureButton?.setAttribute('disabled', 'disabled');
			}
			else
			{
				addButton?.removeAttribute('disabled');
				quickCaptureButton?.removeAttribute('disabled');
			}
		}
		else
		{
			if (addButton)
			{
				addButton.classList.add('is-hidden');
			}
			if (quickCaptureButton)
			{
				quickCaptureButton.classList.add('is-hidden');
			}
		}
	}

	/**
	 * Handles adjusting the header UI depending on which settings are enabled for the deck, such as showing/hiding the filter tags or the observation set selector
	 * in the header based on whether we're using sets or just a filtered list of observations, and based on the specific settings for what to show in the header.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pNamespace - The namespace for the deck.
	 */
	handleHeaderContentForCardDeck(pView, pInput, pNamespace)
	{
		// if we are using sets, we do some additional set up in the header
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const usingSets = currentSettings.useObservationSet;
		const usingSetSelector = currentSettings.useObservationSetSelector;
		const tmpIDObservationSet = usingSets && !pNamespace.startsWith('TEMP-') ? parseInt(pNamespace.split('-').pop()) : null;
		const headerFilterContainer = this.getCardDeckHeaderFilterContainerHTMLID(pInput.Macro.RawHTMLID);
		const headerSetSelectorContainer = this.getCardDeckHeaderObservationSetSelectorContainerHTMLID(pInput.Macro.RawHTMLID);
		const headerStaticObservationSetDisplayContainer = this.getCardDeckHeaderObservationSetDisplayHTMLID(pInput.Macro.RawHTMLID);
		// first let's hide everything, then add back what we need based on the settings
		this.pict.ContentAssignment.addClass(headerFilterContainer, 'is-hidden');
		this.pict.ContentAssignment.addClass(headerSetSelectorContainer, 'is-hidden');
		this.pict.ContentAssignment.addClass(headerStaticObservationSetDisplayContainer, 'is-hidden');

		if (usingSets && usingSetSelector)
		{
			this.buildSetSelectorOptionForCurrentObservationSetID(pInput, tmpIDObservationSet);
			this.pict.ContentAssignment.removeClass(headerSetSelectorContainer, 'is-hidden');
		}
		else if (usingSets)
		{
			// Prefer the user-given Name (pre-populated in the set-name cache by handleOnDataMarshalForObservationSetCase),
			// falling back to "Observation Set {id}" for unnamed/auto-timestamped sets so users don't see ugly default labels.
			const tmpLabel = this.getDisplayLabelForObservationSet(tmpIDObservationSet);
			// Show a pencil-edit affordance when the user can actually rename the set — hidden for locked or read-only documents,
			// and for brand-new (not-yet-saved) sets that don't have an ID to save under yet.
			const canRename = !!tmpIDObservationSet && !this.isDocumentLocked && this.canEditDocument;
			let renameButtonHTML = '';
			if (canRename)
			{
				const renameOnClick = `_Pict.providers.ObservationCardDeckProvider.handleInlineRenameSetClick('${pInput.Macro.RawHTMLID}', ${tmpIDObservationSet})`;
				renameButtonHTML = `<button type="button" class="button is-ghost is-small p-0 ml-1" title="Rename Observation Set" style="height: auto; min-height: 0;" onclick="${renameOnClick}"><span class="icon is-small"><i class="fa fa-fw fa-pencil"></i></span></button>`;
			}
			const staticContent =
			`<div class="tag mt-2 pl-1">
				<span class="icon mr-0">
					<i class="fa fa-fw fa-layer-group"></i>
				</span>
				<span class="icon-text">${tmpLabel}</span>
				${renameButtonHTML}
			</div>`;
			// clear the display container and replace the content with the new static content template
			const tmpDisplayContainer = this.pict.ContentAssignment.getElement(headerStaticObservationSetDisplayContainer)?.[0];
			if (tmpDisplayContainer)
			{
				tmpDisplayContainer.innerHTML = '';
				tmpDisplayContainer.insertAdjacentHTML('beforeend', staticContent);
				this.pict.ContentAssignment.removeClass(headerStaticObservationSetDisplayContainer, 'is-hidden');
			}
		}
		else
		{
			this.buildFilterTagsForCardDeckHeader(pView, pInput, currentSettings?.hideFiltersInHeader);
			this.pict.ContentAssignment.removeClass(headerFilterContainer, 'is-hidden');
			// Apply the deck-filters-applied CSS marker to hide card delete buttons when non-label filters are active.
			// Label-only filtered decks are actionable (we can auto-apply labels), so delete buttons remain visible.
			const deckContainerElement = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID) + (` .${this.deckClassName}`))?.[0];
			if (deckContainerElement)
			{
				if (this.hasFiltersApplied(pInput) && !this.hasActionableFilters(pInput))
				{
					deckContainerElement.classList.add('deck-filters-applied');
				}
				else
				{
					deckContainerElement.classList.remove('deck-filters-applied');
				}
			}
		}
		this.toggleVisibilityForAddCardHeaderButtons(pInput);
	}

	/**
	 * Prepares the UI before building the card deck. This includes setting up any necessary headers, selectors, and draggable configurations based on the current settings and observation list.
	 * Also handles the branching paths between Interactive and Print views to make sure we are only building the necessary elements for each view based on their specific needs and use cases.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pNameSpace - The namespace for the deck.
	 * @param {any[]} pObservationList - The list of observations to display in the deck.
	 */
	prepareUIBeforeBuildingCardDeck(pView, pInput, pNameSpace, pObservationList)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		// this will handle the branching paths of what to show in the header of the card deck
		this.handleHeaderContentForCardDeck(pView, pInput, pNameSpace);
		// tag the deck container with the marker attributes used by cross-deck lookups (e.g. getObservationSetNamespacesOnDOM)
		// before handing off to either the interactive or print builder — print decks also need these markers so
		// persisted excludeObservationSets can resolve set membership when rendering PDFs.
		this.applyDeckContainerMarkerAttributes(pView, pInput, currentSettings);
		// handle which view we are going into, templates are built differently for each since Interactive has more dynamic functionality and options,
		// while Print is optimized for static display and performance for large decks in PDF view, so we want to make sure we are only building the necessary elements for each view
		if (this.pict.AppData.Interactive)
		{
			this.setDraggableConfigurationForDeck(pInput, currentSettings, pNameSpace);
			this.buildObservationCardDeck(pView, pInput, pNameSpace, pObservationList);
			// asynchronously resolve creator names for the details view — cards render immediately with placeholders,
			// and the creator name cells are back-filled once the lookup completes
			this.resolveCreatorNamesForDeck(pInput, pObservationList);
		}
		else
		{
			// The print build is async — pdf.js fetches each embedded PDF artifact and rasterizes it page by page — and it
			// clears the deck container before it appends. It MUST gate the render: prepareForPrintingAsync() sets
			// window.status='ready_to_print' as soon as completeRender() drains, and the rasterizer snapshots on that
			// signal, so leaving the build unregistered captures an empty Media section.
			this.registerRenderDependency(this.buildCardDeckCardsForPrintView(pView, pInput, pNameSpace, pObservationList));
			// print cards render before the name lookup returns, so back-fill them too — registered so the PDF waits for it
			this.registerRenderDependency(this.resolveCreatorNamesForDeck(pInput, pObservationList));
		}
		// Safety net: always remove the initial loading spinner after deck building completes.
		// buildObservationCardDeck calls removeInitialLoadingMessage internally, but if it bails early
		// (e.g. container elements not yet in the DOM on the synchronous useObservationSet NaN path),
		// the spinner would persist indefinitely. This explicit call ensures it is always cleared.
		this.removeInitialLoadingMessage(pInput);
		// invoke the custom after-marshal callback if registered (e.g. bridge defect photo count label update on initial load / set selection)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterMarshal === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.customOnAfterMarshal(pInput, pObservationList);
		}
	}

	/**
	 * Asynchronously resolves creator display names for observations in the deck. Collects unique CreatingIDUser values
	 * that are not already cached, fetches them via UserProvider.getUsersByIDList, and back-fills any rendered creator
	 * name cells (interactive `.card-details-creator-name`, print `.media-card-creator-name`) with the resolved names.
	 * @param {Object} pInput - The input object.
	 * @param {Array} pObservationList - The list of observations to resolve names for.
	 */
	async resolveCreatorNamesForDeck(pInput, pObservationList)
	{
		if (!pObservationList || !pObservationList.length) return;
		const cache = this.pict.AppData.ObservationCardDeckProvider.userNameCache;
		// collect unique user IDs that aren't already cached
		const uncachedIDs = [ ...new Set(
			pObservationList
				.map((obs) => obs.CreatingIDUser)
				.filter((id) => id && !cache[id]),
		) ];
		if (uncachedIDs.length > 0 && this.pict.providers.UserProvider)
		{
			try
			{
				const userRecords = await this._withTimeout(this.pict.providers.UserProvider.getUsersByIDList(uncachedIDs), this.creatorNameLookupTimeoutMS, 'Creator name lookup');
				if (userRecords && Array.isArray(userRecords))
				{
					for (const user of userRecords)
					{
						cache[user.IDUser] = `${user.NameFirst || ''} ${user.NameLast || ''}`.trim() || 'N/A';
					}
				}
			}
			catch (err)
			{
				this.pict.log.warn('[ObservationCardDeck] Failed to resolve creator names:', err);
			}
		}
		// back-fill any rendered creator name placeholders in this deck
		const deckContent = document.getElementById(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID).replace('#', ''));
		if (!deckContent) return;
		const creatorCells = deckContent.querySelectorAll('.card-details-creator-name[data-creator-id], .media-card-creator-name[data-creator-id]');
		creatorCells.forEach((/** @type {HTMLElement} */ cell) =>
		{
			const userId = cell.getAttribute('data-creator-id');
			if (userId && cache[userId])
			{
				cell.textContent = cache[userId];
			}
		});
	}

	/**
	 * Applies the deck-type marker attributes (observation-set, document-list, filtered, excluded-set) and the view/input hash attributes
	 * to the deck container element. Shared by both the interactive and print rendering paths so cross-deck lookups work in both modes.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pCurrentSettings - The resolved settings for the deck.
	 */
	applyDeckContainerMarkerAttributes(pView, pInput, pCurrentSettings)
	{
		const deckContainerElement = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID) + (` .${this.deckClassName}`))?.[0];
		if (!deckContainerElement)
		{
			return;
		}
		deckContainerElement.setAttribute(this.deckViewHashAttribute, pView.Hash);
		deckContainerElement.setAttribute(this.deckInputHashAttribute, pInput.Hash);
		if (pCurrentSettings?.useObservationSet)
		{
			deckContainerElement.setAttribute(this.deckIsObservationSetAttribute, 'true');
			return;
		}
		deckContainerElement.setAttribute(this.deckIsDocumentListAttribute, 'true');
		if (this.hasFiltersApplied(pInput))
		{
			deckContainerElement.setAttribute(this.deckIsFilteredDocumentListAttribute, 'true');
		}
		if (pCurrentSettings?.excludeObservationSets)
		{
			deckContainerElement.setAttribute(this.deckIsExcludedSetAttribute, 'true');
		}
		else
		{
			deckContainerElement.removeAttribute(this.deckIsExcludedSetAttribute);
		}
	}

	/**
	 * Handles the case where we are not using observation sets. In this case, we will just apply any filters provided in the options to the full list of observations from the registry
	 * and build the deck based on that filtered list, and we will update the deck dynamically as the filters change by reapplying the filters to the full list of observations and rebuilding
	 * the deck on each filter change.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @returns {Promise<void>} - Returns a promise that resolves when the data has been marshaled and the deck has been built.
	 */
	async handleOnDataMarshalForObservationListCase(pView, pInput)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		// if we're not using observation sets, then we will just apply any filters provided in the options to the full list of observations from the registry and build the deck based on that filtered list, and we will update the deck dynamically as the filters change by reapplying the filters to the full list of observations and rebuilding the deck on each filter change
		let tmpCurrentObservationList;
		// Prefer DOM-discovered set decks (accurate for the current form) but fall back to the persisted NamespaceObservationSetMap
		// so exclude filtering still applies on cold reload before set decks have set their marker attributes —
		// otherwise the registry gets rebuilt with the full, unfiltered document list and the saved 6-item state reverts to 7.
		const excludeNamespaces = currentSettings.excludeObservationSets ? this.getObservationSetNamespacesForExcludeFiltering() : null;
		if (this._isRemarshalInProgress)
		{
			// During remarshal, use the authoritative local observation list that was already
			// updated by refreshCardDecks — avoids stale API re-fetch
			const localObservations = this.pict.AppData.DocumentData.ReportData.Observations || [];
			if (currentSettings.excludeObservationSets)
			{
				const currentSetObservationIDs = new Set();
				// Use DOM-discovered namespaces when available, otherwise all persisted set namespaces
				const namespacesToCheck = excludeNamespaces || Object.keys(this.pict.AppData.MediaRegistryStore?.NamespaceObservationSetMap || {});
				for (const namespace of namespacesToCheck)
				{
					const setObservations = await this.pict.providers.MediaRegistry.getMediaSet(namespace);
					for (const o of setObservations)
					{
						currentSetObservationIDs.add(o.IDObservation);
					}
				}
				tmpCurrentObservationList = localObservations.filter((/** @type {any} */ o) => !currentSetObservationIDs.has(o.IDObservation));
			}
			else
			{
				tmpCurrentObservationList = localObservations;
			}
		}
		else
		{
			tmpCurrentObservationList = currentSettings.excludeObservationSets ? await this.pict.providers.MediaRegistry.getDocumentObservationsExcludingCurrentSets(excludeNamespaces) : await this.pict.providers.MediaRegistry.getDocumentObservations();
		}
		const tmpNamespaceFromInputHash = this.buildNamespaceForCardDeck(pInput.Hash);
		this.pict.log.info(`Marshaling data to form for Observation Card Deck using input hash as namespace: ${pInput.Hash}`);
		let observationListFromRegistry = await this.pict.providers.MediaRegistry.getMediaSet(tmpNamespaceFromInputHash);
		// Preserve Ordinal values from the registry onto the local observation list
		// so that any user-defined ordering (e.g. from drag-and-drop) is not lost during remarshal
		if (observationListFromRegistry && observationListFromRegistry.length)
		{
			const registryOrdinalMap = new Map();
			for (const regObs of observationListFromRegistry)
			{
				if (regObs.Ordinal !== undefined)
				{
					registryOrdinalMap.set(regObs.IDObservation, regObs.Ordinal);
				}
			}
			if (registryOrdinalMap.size)
			{
				const knownObservations = [];
				const newObservations = [];
				for (const obs of tmpCurrentObservationList)
				{
					if (registryOrdinalMap.has(obs.IDObservation))
					{
						obs.Ordinal = registryOrdinalMap.get(obs.IDObservation);
						knownObservations.push(obs);
					}
					else
					{
						newObservations.push(obs);
					}
				}
				knownObservations.sort((a, b) => a.Ordinal - b.Ordinal);
				if (currentSettings.appendNewCardToStartOfDeck)
				{
					tmpCurrentObservationList = [ ...newObservations, ...knownObservations ];
				}
				else
				{
					tmpCurrentObservationList = [ ...knownObservations, ...newObservations ];
				}
			}
		}
		// set the current filters (or default ones) passed in from Pict config — filters now live as a sub-object of settings (CardDeckSettings.filters)
		const tmpFilters = this.setCurrentFiltersForInput(pInput, { ...this.patchedConfiguration[pInput?.PictForm?.InputType]?.filters, ...(pInput?.PictForm?.CardDeckSettings?.filters || this.defaultConfiguration.filters) });
		// if we find an existing observation list in the registry for this namespace, we need to compare it to the current document observations to see if there have been any changes (observations added or removed)
		// since the last time we marshaled data to the form for this input and update the registry if needed before we build the deck, because we want to make sure we are working with the most up to date data
		// from the document when we build the deck
		if (observationListFromRegistry && observationListFromRegistry.length)
		{
			const addedObservationIDs = [];
			const removedObservationIDs = [];
			// new observations added to the document, not yet in the registry set for this namespace
			for (const obs of tmpCurrentObservationList)
			{
				if (!observationListFromRegistry.find((/** @type {any} */ o) => o.IDObservation === obs.IDObservation))
				{
					this.pict.log.info(`Observation with ID ${obs.IDObservation} is in the document observations but not in the registry set for namespace ${tmpNamespaceFromInputHash}. Adding it to the registry set.`);
					if (currentSettings.appendNewCardToStartOfDeck)
					{
						observationListFromRegistry.unshift(obs);
					}
					else
					{
						observationListFromRegistry.push(obs);
					}
					addedObservationIDs.push(obs.IDObservation);
				}
			}
			// observations removed from the document, but still in the registry set for this namespace
			for (const obs of [ ...observationListFromRegistry ])
			{
				if (!tmpCurrentObservationList.find((/** @type {any} */ o) => o.IDObservation === obs.IDObservation))
				{
					this.pict.log.info(`Observation with ID ${obs.IDObservation} is in the registry set for namespace ${tmpNamespaceFromInputHash} but not in the document observations. Removing it from the registry set.`);
					observationListFromRegistry = observationListFromRegistry.filter((/** @type {any} */ o) => o.IDObservation !== obs.IDObservation);
					removedObservationIDs.push(obs.IDObservation);
				}
			}
			// if there were any additions or removals, we need to update the registry with the new list for that namespace so that it's up to date for the next time we marshal data to the form for this input
			if (addedObservationIDs.length || removedObservationIDs.length)
			{
				let updatedObservationList = [];
				this.pict.log.info(`Updated observation list for namespace ${tmpNamespaceFromInputHash}. Added: ${addedObservationIDs.join(', ')}, Removed: ${removedObservationIDs.join(', ')}`);
				updatedObservationList = this.pict.providers.ObservationProvider.handleFilteringObservationsInList(tmpFilters, tmpCurrentObservationList);
				updatedObservationList = await this.pict.providers.MediaRegistry.registerMediaSet(tmpNamespaceFromInputHash, updatedObservationList);
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceFromInputHash, updatedObservationList);
				return;
			}
			else
			{
				this.pict.log.info(`Existing observation list for namespace ${tmpNamespaceFromInputHash} contains ${observationListFromRegistry.length} observations.`);
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceFromInputHash, observationListFromRegistry);
				return;
			}
		}
		else
		{
			this.pict.log.warn(`No observation set found in MediaRegistry for namespace observation list at hash: ${pInput.Hash}. Will attempt to create new namespace and compile observation list based on options and document observations.`);
			const tmpObservationList = this.pict.providers.ObservationProvider.handleFilteringObservationsInList(tmpFilters, tmpCurrentObservationList);
			observationListFromRegistry = await this.pict.providers.MediaRegistry.registerMediaSet(tmpNamespaceFromInputHash, tmpObservationList);
			this.pict.log.info(`Registered new media set in MediaRegistry for namespace ${tmpNamespaceFromInputHash} with ${observationListFromRegistry.length} observations after filtering.`);
			this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceFromInputHash, observationListFromRegistry);
			return;
		}
	}

	/**
	 * Handles the case where we are using observation sets for the deck, which means we expect the value passed in to be the ID of the observation set we want to display in the deck,
	 * so we need to get that set from the registry and build the deck based on that set. If we don't have a valid ID passed in, then we will wait until we have an ID to pull the set
	 * and build the deck, which will happen when the user adds their first observation and we create a new set for them based on the input hash as the namespace and the current document observations.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled, expected to be the ID of the observation set to display in the deck.
	 * @returns {Promise<void>} - A promise that resolves when the deck has been built based on the observation set, or if we are waiting for an ID to be provided, it will resolve immediately and we will build the deck later when we have an ID to work with.
	 */
	async handleOnDataMarshalForObservationSetCase(pView, pInput, pValue)
	{
		// if we are using observation sets, then we expect the value passed in to be the ID of the observation set we want to display in the deck, so we need to get that set from the registry and build the deck based on that set
		const tmpIDObservationSet = parseInt(pValue);
		// the "empty"/"temp" set case where we don't have a valid observation set ID provided yet, which will be the case when the user first adds the deck to the form and hasn't added any observations to it yet,
		// so we don't have an observation set created for it yet since sets are created based on the input hash as the namespace once the first observation is added to the deck.
		if (isNaN(tmpIDObservationSet))
		{
			this.pict.log.info(`No valid Observation Set ID provided for input ${pInput.Macro.RawHTMLID}. Value received: ${pValue}. Will attempt to build deck with a temp ID until an image is added and we can generate a proper Observation Set record.`);
			const currentSettings = this.getCurrentSettingsForInput(pInput);
			const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInput.Hash, null, true);
			// Register an empty observation list for the temp namespace — no API call needed since there's no
			// real ObservationSet record yet.  The previous call to registerMediaSetByIDObservationSet(ns, [])
			// passed [] which is truthy, bypassing the falsy guard and calling loadSetObservations([]) which
			// hit the server at /1.0/ObservationSet/ with an empty ID, producing a "record not found" error
			// on every marshal cycle.
			this.pict.providers.MediaRegistry.registerMediaSet(tmpNamespaceForIDObservationSet, []);
			// Yield to the browser before touching the DOM — unlike the non-NaN set path and the
			// non-set observation list path (both of which do async API work that naturally defers
			// DOM manipulation), this NaN path is fully synchronous.  When the framework calls
			// onDataMarshalToForm during the initial render cycle, the section template may not
			// have been flushed to the DOM yet, so buildObservationCardDeck can't find its container
			// elements and bails.  A single await on a resolved promise yields to the microtask
			// queue, giving the browser a chance to commit the pending template HTML before we
			// attempt to query and manipulate the deck elements.
			await Promise.resolve();
			this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceForIDObservationSet, []);
			// Show a contextual empty message when using the set selector with no set selected
			if (currentSettings.useObservationSetSelector)
			{
				this.updateEmptyMessageText(pInput, 'No observation set is currently selected.');
			}
			this.handleObservationSetEditButtonStateOnChange(pInput);
			return;
		}
		// if we have a set id, we're good to go, we can pull the observations for that set from the registry and build the deck, if not,
		// we'll wait until we have an ID to pull the set and build the deck, which will happen when the user adds their first observation
		// and we create a new set for them based on the input hash as the namespace and the current document observations
		else
		{
			const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInput.Hash, tmpIDObservationSet);
			this.pict.log.info(`Marshaling data to form for Observation Card Deck with provided Observation Set ID: ${tmpIDObservationSet}`);
			// Populate dynamicGUIDMap during marshal so other decks' Select2 processResults
			// wrappers can detect this set as "in use" on initial form load — not just after
			// user interaction.  Without this, reopening a saved form leaves the GUID map empty
			// until a user manually changes a selector, allowing duplicate set selection.
			this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID] = tmpIDObservationSet;
			// Populate the set-name cache before rendering so the header selector/static label use the saved Name on first paint
			// and survive subsequent re-renders without flashing the "Observation Set {id}" fallback back over the correct name.
			await this.fetchObservationSetName(tmpIDObservationSet);
			// this will fetch or create a namespace for the observation set based on the ID and return the observations in that set for us to render in the deck
			let observationListFromRegistry = await this.pict.providers.MediaRegistry.getObservationSetByNamespace(tmpNamespaceForIDObservationSet);
			// if we don't find any observations in the registry for that namespace, then we need to create the namespace and register the observation set based on the ID provided, then fetch the list again to build the deck
			const currentSettings = this.getCurrentSettingsForInput(pInput);
			if (observationListFromRegistry && observationListFromRegistry.length)
			{
				this.pict.log.info(`Found existing observation set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet} with ${observationListFromRegistry.length} observations.`);
				// If appendNewCardToStartOfDeck is enabled, detect new observations by comparing against
				// the previously tracked set of IDs and move them to the front of the list
				if (currentSettings.appendNewCardToStartOfDeck && this._previousObservationSetIDs?.[tmpNamespaceForIDObservationSet])
				{
					const previousIDs = this._previousObservationSetIDs[tmpNamespaceForIDObservationSet];
					const existingObs = observationListFromRegistry.filter((/** @type {any} */ o) => previousIDs.has(o.IDObservation));
					const newObs = observationListFromRegistry.filter((/** @type {any} */ o) => !previousIDs.has(o.IDObservation));
					if (newObs.length)
					{
						observationListFromRegistry = [ ...newObs, ...existingObs ];
					}
				}
				// Track current IDs so the next remarshal can detect new additions
				this._previousObservationSetIDs[tmpNamespaceForIDObservationSet] = new Set(observationListFromRegistry.map((/** @type {any} */ o) => o.IDObservation));
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceForIDObservationSet, observationListFromRegistry);
				this.handleObservationSetEditButtonStateOnChange(pInput);
				return;
			}
			else
			{
				this.pict.log.warn(`No observation set found in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet}. Will attempt to create new namespace and compile observation list based on observation set ${tmpIDObservationSet}.`);
				observationListFromRegistry = await this.pict.providers.MediaRegistry.registerMediaSetByIDObservationSet(tmpNamespaceForIDObservationSet, tmpIDObservationSet);
				this.pict.log.info(`Registered new media set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet} with ${observationListFromRegistry.length} observations from observation set ID ${tmpIDObservationSet}.`);
				// Establish baseline IDs on first render so subsequent remarshals can detect new additions
				this._previousObservationSetIDs[tmpNamespaceForIDObservationSet] = new Set(observationListFromRegistry.map((/** @type {any} */ o) => o.IDObservation));
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceForIDObservationSet, observationListFromRegistry);
				this.handleObservationSetEditButtonStateOnChange(pInput);
				return;
			}
		}
	}

	/**
	 * Sets the draggable configuration for the deck based on the current settings for the input, and registers the onDrop event handler to update the order of the cards in the registry when a card is dropped in a new position in the deck.
	 * @param {Object} pInput - The input object containing the macro and raw HTML ID.
	 * @param {Object} currentSettings - The current settings for the deck, which can be used to conditionally enable or disable dragging and dropping of cards based on the configuration of the deck (ex: preventing reordering of cards will disable dragging and dropping for reordering, but we may still want to allow dragging and dropping for moving cards between decks if we build that functionality in the future, so we can use different settings to control those different behaviors).
	 * @param {string} pNamespace - The namespace for the observation set associated with this deck, which is used to pull the list of observations from the registry and update the registry with the new order when cards are reordered in the deck.
	 */
	setDraggableConfigurationForDeck(pInput, currentSettings, pNamespace)
	{
		if (currentSettings.preventReorderingCards)
		{
			this.pict.log.info(`Card deck for input ${pNamespace} is set to prevent reordering of cards. Draggable configuration will not be applied to the deck.`);
			this.draggableConfigurationForDeck = { disabled: true };
			return;
		}
		this.draggableConfigurationForDeck = {
			limitToOwnCollection: true || currentSettings.preventCrossDeckDragging, // NOTE: Must be true until we build cross-apply filtering - see options above for more details
			disabled: this.isDocumentLocked || !this.canEditDocument || currentSettings.preventReorderingCards,
			elementSelector: `.${this.cardClassName}`,
			onDrop: async (/** @type {any} */ pItem, /** @type {any} */ pEvent) =>
			{
				const deckContainer = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID))?.[0];
				const currentObservationList = await this.pict.providers.MediaRegistry.getMediaSet(pNamespace);
				if (!deckContainer)
				{
					this.pict.log.error(`Could not find card deck container for input ${pNamespace} when handling drop event for card reordering. HTML ID used to query: ${this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID)}. Cannot update card order in registry.`);
					return;
				}
				// update the MediaRegistry order based on the new order of the cards in the deck after the drop is completed
				const cardElements = deckContainer.querySelectorAll(`.${this.cardClassName}`);
				// get the array of ids in order
				const newOrderArray = Array.from(cardElements)
				.map((card) =>
				{
					const observationID = card.getAttribute(this.cardAttributeId);
					return parseInt(observationID);
				})
				.filter((id) => !isNaN(id));
				const newOrderList = [];
				// loop through the new order array and build a new ordered list of observation objects based on the new order of ids
				for (const [ i, obsID ] of newOrderArray.entries())
				{
					const obs = currentObservationList.find((/** @type {any} */ o) => o.IDObservation == obsID);
					// reset the ordinal for all obs and use the new order we pass in
					if (obs)
					{
						obs.Ordinal = i + 1;
						newOrderList.push(obs);
					}
				}
				this.pict.providers.MediaRegistry.registerMediaSet(pNamespace, newOrderList);
				_Pict.providers.ObservationCardDeckProvider.updateIndexNumbersOnUIForDeck(pInput, newOrderList);
				this.pict.log.info(`Cards reordered in deck for input ${pNamespace}.`);
			},
		};
	}

	/**
	 * Returns a Set of observation set IDs that are currently assigned to other card deck selectors on the form,
	 * excluding the given input's own set. Used to disable already-in-use options in the select2 dropdown.
	 *
	 * Validates that each entry's hidden input still exists in the DOM before including it.
	 * When a containing row (e.g. a bridge defect) is removed, the hidden input is destroyed
	 * but the dynamicGUIDMap entry can linger — without this check, deleted rows' sets stay
	 * permanently marked as "in use" in the remaining selectors.
	 * @param {Object} pInput - The input object (used to identify the current deck via RawHTMLID).
	 * @returns {Set<number>} - Set of IDObservationSet values in use by other decks.
	 */
	getObservationSetIDsInUseByOtherDecks(pInput)
	{
		const inUseIDs = new Set();
		const guidMap = this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap;
		for (const [ rawHTMLID, idObservationSet ] of Object.entries(guidMap))
		{
			if (rawHTMLID !== pInput.Macro.RawHTMLID && idObservationSet)
			{
				// Verify the hidden input still exists in the DOM — if the containing
				// row (e.g. a bridge defect) was deleted, the input is gone and
				// this entry is stale.
				const hiddenInput = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(rawHTMLID))?.[0];
				if (hiddenInput)
				{
					inUseIDs.add(Number(idObservationSet));
				}
				else
				{
					// Prune the stale entry so it doesn't accumulate across sessions
					delete guidMap[rawHTMLID];
				}
			}
		}
		return inUseIDs;
	}

	/**
	 * Returns the fallback display label used before the real saved Name has been fetched.
	 * @param {string|number|null} pIDObservationSet - The observation set ID, or null for a brand-new (unsaved) set.
	 * @returns {string}
	 */
	getFallbackObservationSetLabel(pIDObservationSet)
	{
		return pIDObservationSet ? `Observation Set ${pIDObservationSet}` : 'New Observation Set';
	}

	/**
	 * Returns the cached saved Name for an observation set, or null if no resolved value is in the cache yet.
	 * Pending in-flight fetches (Promise values) are treated as uncached so callers fall back to the placeholder label.
	 * @param {string|number|null} pIDObservationSet - The observation set ID to look up.
	 * @returns {string|null}
	 */
	getCachedObservationSetName(pIDObservationSet)
	{
		if (!pIDObservationSet)
		{
			return null;
		}
		const cached = this._observationSetNameCache[String(pIDObservationSet)];
		return typeof cached === 'string' ? cached : null;
	}

	/**
	 * Detects Names that were auto-generated by createNewObservationSetForCardDeck / handleConfirmCreateSetModal —
	 * both of those append a Date.toLocaleString()-style "(M/D/YYYY, H:MM:SS AM)" timestamp to the set label.
	 * Names matching that signature are ugly to show to users, so the UI treats them as "unnamed" and falls back to "Observation Set {id}".
	 *
	 * The match is anchored to the start of the string so that names with a meaningful prefix
	 * (e.g. "Elevation Photo (5/23/2025, 11:48:24 AM)") are preserved as-is in the UI.
	 * Only names that consist *entirely* of a timestamp are treated as auto-generated.
	 * @param {string|null|undefined} pName - The set Name to check.
	 * @returns {boolean}
	 */
	isAutoGeneratedSetName(pName)
	{
		if (!pName || !String(pName).trim())
		{
			return true;
		}
		return /^\s*\(?\s*\d{1,2}\/\d{1,2}\/\d{2,4},?\s+\d{1,2}:\d{1,2}(:\d{1,2})?\s*(AM|PM)?\s*\)?\s*$/i.test(pName);
	}

	/**
	 * Returns the label to show in the deck header for an observation set: the user-given Name when set, or "Observation Set {id}" otherwise.
	 * Names detected as auto-generated by isAutoGeneratedSetName are treated as unset so users don't see timestamp noise in the header.
	 * @param {string|number|null} pIDObservationSet - The observation set ID.
	 * @returns {string}
	 */
	getDisplayLabelForObservationSet(pIDObservationSet)
	{
		const cachedName = this.getCachedObservationSetName(pIDObservationSet);
		if (cachedName && !this.isAutoGeneratedSetName(cachedName))
		{
			return cachedName;
		}
		return this.getFallbackObservationSetLabel(pIDObservationSet);
	}

	/**
	 * Fetches the saved Name for an observation set (cached by ID). Returns the fallback label on failure so callers always get a usable string.
	 * @param {string|number} pIDObservationSet - The observation set ID to look up.
	 * @returns {Promise<string>} - Resolves to the saved Name, or the fallback "Observation Set {id}" label if the fetch fails.
	 */
	async fetchObservationSetName(pIDObservationSet)
	{
		if (!pIDObservationSet)
		{
			return this.getFallbackObservationSetLabel(pIDObservationSet);
		}
		const cacheKey = String(pIDObservationSet);
		const cached = this._observationSetNameCache[cacheKey];
		if (cached)
		{
			return cached;
		}
		const tmpPromise = (async () =>
		{
			try
			{
				const tmpSet = await this.pict.providers.ObservationSetProvider.loadSet(pIDObservationSet);
				const tmpName = tmpSet?.Name || this.getFallbackObservationSetLabel(pIDObservationSet);
				this._observationSetNameCache[cacheKey] = tmpName;
				return tmpName;
			}
			catch (error)
			{
				this.pict.log.error(`Error loading observation set ${pIDObservationSet} for label: ${error}`);
				delete this._observationSetNameCache[cacheKey];
				return this.getFallbackObservationSetLabel(pIDObservationSet);
			}
		})();
		this._observationSetNameCache[cacheKey] = tmpPromise;
		return tmpPromise;
	}

	/**
	 * Builds the option element for the current observation set ID and updates the select element with it.
	 * @param {Object} pInput - The input object containing the macro and raw HTML ID.
	 * @param {string|number} tmpIDObservationSet - The ID of the current observation set.
	 */
	buildSetSelectorOptionForCurrentObservationSetID(pInput, tmpIDObservationSet)
	{
		// update the selector with the current IDObservationSet value so that if the user changes the filters and we need to re-render the deck,
		// we know which observation set ID to pull from the registry to get the updated list of observations to render in the deck based on the selected filters
		const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetSelectorHTMLID(pInput.Macro.RawHTMLID))?.[0];
		if (!tmpSelectElement)
		{
			this.pict.log.error(`Could not find select element for observation set selector with HTML ID ${this.getCardDeckHeaderObservationSetSelectorHTMLID(pInput.Macro.RawHTMLID)}. Cannot update selector value for Observation Set ID ${tmpIDObservationSet}.`);
			this.removeInitialLoadingMessage(pInput);
			return;
		}
		// only create and select an option when we have a valid observation set ID —
		// when NaN (no set yet), leave the selector on the empty placeholder so it renders
		// as "Select a set..." and the user must explicitly create or pick one
		const hasValidSetID = !isNaN(Number(tmpIDObservationSet)) && tmpIDObservationSet !== null;
		if (hasValidSetID)
		{
			// build the prefilled value for the select dropdown.
			// Prefer the user-given Name (pre-populated in the set-name cache before render) and fall back to "Observation Set {id}"
			// for unnamed/auto-timestamped sets so re-renders stay stable and users don't see ugly defaults.
			const tmpOption = tmpSelectElement.querySelector(`[value="${tmpIDObservationSet}"]`) || document.createElement('option');
			tmpOption.value = tmpIDObservationSet;
			tmpOption.text = this.getDisplayLabelForObservationSet(tmpIDObservationSet);
			tmpOption.selected = true;
			if (!tmpSelectElement.querySelector(`[value="${tmpIDObservationSet}"]`))
			{
				tmpSelectElement.appendChild(tmpOption);
			}
		}
		else
		{
			// ensure the placeholder <option value=""> is selected so Select2 shows "Select a set..."
			const tmpPlaceholderOption = tmpSelectElement.querySelector('option[value=""]');
			if (tmpPlaceholderOption)
			{
				tmpPlaceholderOption.selected = true;
			}
		}
		// initialize the select2 dropdown on the selector element if it's available, which will handle the searching and selecting of different observation sets to display in the deck
		// if the user wants to switch to a different set
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpConfigOptions = {
				Input: pInput,
				SearchFallbackPlaceholder: `Select Observation Set...`,
				ApplySort: true,
				Disabled: this.isDocumentLocked || !this.canEditDocument,
				HandleSearchFilters: (/** @type {string[]} */ pFilters) =>
				{
					const customFilter = this.pict.AppData.ObservationCardDeckProvider.customHandleSearchFiltersForSelector;
					if (typeof customFilter === 'function')
					{
						return customFilter(pFilters);
					}
					if (this.pict.AppData?.DocumentData?.ReportData?.IDProject)
					{
						pFilters.push('FBV~IDProject~EQ~' + this.pict.AppData?.DocumentData?.ReportData?.IDProject);
					}
					return pFilters;
				},
			};
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('ObservationSet', tmpConfigOptions);
			// Override noResults to show a contextual message when document scope filter is
			// active but no sets exist on this document yet, instead of generic "No results found."
			const providerAppData = this.pict.AppData.ObservationCardDeckProvider;
			tmpSelectOptions.language = Object.assign({}, tmpSelectOptions.language, {
				noResults: () =>
				{
					if (providerAppData?.documentScopeEmptyState)
					{
						return 'No sets created in this document yet';
					}
					return 'No results found.';
				},
			});
			// Wrap processResults to disable observation sets already in use by other card decks
			const originalProcessResults = tmpSelectOptions.ajax.processResults;
			tmpSelectOptions.ajax.processResults = (/** @type {any} */ data, /** @type {any} */ params) =>
			{
				const pageInfo = originalProcessResults(data, params);
				const inUseIDs = this.getObservationSetIDsInUseByOtherDecks(pInput);
				for (const result of pageInfo.results)
				{
					if (inUseIDs.has(Number(result.id)))
					{
						result.disabled = true;
						result.text = result.text + ' (in use)';
					}
				}
				return pageInfo;
			};
			window['jQuery'](tmpSelectElement).select2(tmpSelectOptions);
			// when no valid set ID, explicitly clear Select2's internal selection so it shows the placeholder
			// (Select2 can cache stale selections from prior initializations on the same DOM element)
			if (!hasValidSetID)
			{
				window['jQuery'](tmpSelectElement).val('').trigger('change.select2');
			}
		}
	}

	/**
	 * Sets the current settings for the given input in the dynamicSettings, which is used to store the configuration settings for each input separately so that we can apply different configurations to different decks on the same page if needed.
	 * @param {Object} pInput - The input object to set the settings for (used to access the input hash for storing in the dynamicSettings).
	 * @param {Object} pSettings - The settings object to set for the given input, see defaultConfiguration for the structure of this object and what settings are available to be set for each input.
	 */
	setCurrentSettingsForInput(pInput, pSettings)
	{
		const tmpSettings = JSON.parse(JSON.stringify(Object.assign({}, this.defaultConfiguration, this.patchedConfiguration[pInput?.PictForm?.InputType], pSettings)));
		// guard: normalize indexTagScope to 'local' if it's not a recognized value
		if (tmpSettings.indexTagScope !== 'local' && tmpSettings.indexTagScope !== 'document')
		{
			tmpSettings.indexTagScope = 'local';
		}
		// apply address-based overrides registered by consuming views (e.g. bridge element conditions)
		// These take precedence over patchedConfiguration and pSettings but yield to persisted user overrides.
		const addressOverrides = this.pict.AppData.ObservationCardDeckProvider?.settingsOverridesByInputAddress?.[pInput?.Address];
		if (addressOverrides)
		{
			Object.assign(tmpSettings, JSON.parse(JSON.stringify(addressOverrides)));
		}
		// apply any persisted user-toggled overrides (from FormData) so they survive save/reload and remarshals within a session
		const persistedOverrides = this.getPersistedOverridesForInput(pInput);
		if (persistedOverrides)
		{
			Object.assign(tmpSettings, persistedOverrides);
		}
		// alwaysExcludeObservationSets is a structural override that cannot be toggled by the user —
		// force excludeObservationSets on AFTER all other merges so nothing can turn it off.
		if (tmpSettings.alwaysExcludeObservationSets)
		{
			tmpSettings.excludeObservationSets = true;
		}
		this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[pInput.Hash] = tmpSettings;
		return tmpSettings;
	}

	/**
	 * Gets the current settings for the given input from the dynamicSettings, or returns the default settings if no settings are set for that input.
	 * @param {Object} pInput - The input object to get the settings for (used to access the input hash for looking up in the dynamicSettings).
	 * @returns {Object} - The settings object for the given input, either from the dynamicSettings or the default settings if no settings are set.
	 */
	getCurrentSettingsForInput(pInput)
	{
		return this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[pInput.Hash] || this.defaultConfiguration;
	}

	/**
	 * Sets the current filters for the given input as a sub-object of the input's settings. This keeps all deck configuration in one collection
	 * while still allowing filters to be set independently from other settings.
	 * @param {Object} pInput - The input object to set the filters for (used to access the input hash for storing in the settings).
	 * @param {Object} filters - The filters object to set for the given input, which should have the structure of { Include: { ObservationTypes: [], LabelTypes: [] }, Exclude: { ObservationTypes: [], LabelTypes: [] } } or a subset of those properties depending on what filters are being applied.
	 */
	setCurrentFiltersForInput(pInput, filters)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		// When no Include ObservationTypes are explicitly configured, default to the supported media
		// types so that non-media observations (e.g. Weather) don't leak into the deck display.
		// Mark with _isDefaultTypeFilter so hasFiltersApplied can distinguish injected defaults from
		// explicit user/config filters — the default should not trigger filter tag rendering in the header.
		if (!filters?.Include?.ObservationTypes?.length)
		{
			if (!filters.Include)
			{
 filters.Include = {};
			}
			filters.Include.ObservationTypes = [ ...this.actionableObservationTypes ];
			filters._isDefaultTypeFilter = true;
		}
		else
		{
			delete filters._isDefaultTypeFilter;
		}
		currentSettings.filters = filters;
		this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[pInput.Hash] = currentSettings;
		return filters;
	}

	/**
	 * Checks whether the given input's deck has filters applied and those filters are all "actionable" —
	 * meaning we can safely allow Add/Remove/QuickCapture on the deck because:
	 * - ObservationType filters (if any) only include media types that quick capture/upload naturally produces
	 * - LabelType filters (if any) can be auto-applied to new observations
	 * - No Description filters are present (not supported)
	 * @param {Object} pInput - The input object to check filters for.
	 * @returns {boolean} - True if filters are applied and all are actionable.
	 */
	hasActionableFilters(pInput)
	{
		if (!this.hasFiltersApplied(pInput))
		{
			return false;
		}
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		for (const filterDirection of [ 'Include', 'Exclude' ])
		{
			if (currentFilters[filterDirection]?.Descriptions?.length)
			{
				return false;
			}
			const obsTypes = currentFilters[filterDirection]?.ObservationTypes;
			if (obsTypes?.length && !obsTypes.every((/** @type {any} */ t) => this.actionableObservationTypes.includes(t)))
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * Checks whether a single observation's ObservationType passes the deck's Include/Exclude ObservationType filters.
	 * Returns true when no ObservationType filters are configured (i.e. unrestricted decks always pass).
	 * Used as a gate before adding observations to filtered decks so that mismatched types are rejected
	 * with a user-visible warning instead of silently disappearing from the deck.
	 * @param {Object} pInput - The input object whose current filters should be checked.
	 * @param {Object} pObservation - The observation record (must have an `ObservationType` field).
	 * @returns {boolean} True if the observation is allowed by the filters, false if it should be rejected.
	 */
	observationMatchesTypeFilter(pInput, pObservation)
	{
		if (!pObservation?.ObservationType)
		{
			return true; // no type to check — allow
		}
		// When no explicit filters are configured, default to only allowing the supported media types
		// (Legacy Image, Legacy Video, Legacy Audio, File). We haven't built e2e support for other
		// observation types yet, so this prevents users from depending on unsupported types.
		if (!this.hasFiltersApplied(pInput))
		{
			return this.actionableObservationTypes.includes(pObservation.ObservationType);
		}
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const includeTypes = currentFilters?.Include?.ObservationTypes;
		if (includeTypes?.length && !includeTypes.includes(pObservation.ObservationType))
		{
			return false; // observation type not in the Include list
		}
		const excludeTypes = currentFilters?.Exclude?.ObservationTypes;
		if (excludeTypes?.length && excludeTypes.includes(pObservation.ObservationType))
		{
			return false; // observation type is in the Exclude list
		}
		return true;
	}

	/**
	 * Shows a transient user-facing warning when an observation's type doesn't match the deck's filter.
	 * Uses the Headlight notification system if available, otherwise falls back to a console warning.
	 * @param {Object} pInput - The input object (used for deck name context).
	 * @param {string} pObservationType - The observation's type that was rejected.
	 */
	showFilterMismatchWarning(pInput, pObservationType)
	{
		const deckName = pInput?.Name || 'this deck';
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const allowedTypes = currentFilters?.Include?.ObservationTypes || [];
		const allowedLabel = (allowedTypes.length ? allowedTypes : this.actionableObservationTypes).map((/** @type {string} */ t) => t.replace(/^Legacy\s*/, '')).join(', ');
		const displayType = pObservationType.replace(/^Legacy\s*/, '');
		const message = `Cannot add "${displayType}" observation to ${deckName} — this deck only accepts: ${allowedLabel}.`;
		// Use the Headlight notification/toast system if available, otherwise fall back to a basic alert
		if (this.pict?.views?.HeadlightNotifications?.addNotification)
		{
			this.pict.views.HeadlightNotifications.addNotification({ message: message, type: 'warning', duration: 5000 });
		}
		else if (this.pict?.providers?.Informary?.addWarning)
		{
			this.pict.providers.Informary.addWarning(message);
		}
		else
		{
			this.pict.log.warn(message);
		}
	}

	/**
	 * Applies the Include LabelType filters from the deck's current filter configuration to a newly created observation,
	 * so that it matches the filter criteria and appears in the filtered deck. Only applies labels that are not already
	 * present on the observation. Persists the updated observation to the server.
	 * @param {Object} pInput - The input object to get the filters from.
	 * @param {Object} pObservationRecord - The observation record to apply labels to.
	 */
	async applyFilterLabelsToObservation(pInput, pObservationRecord)
	{
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const includeLabelFilters = currentFilters?.Include?.LabelTypes;
		if (!includeLabelFilters?.length)
		{
			return;
		}
		// Build the Tags array as tag value strings — the API expects Tags as string values (not IDs or objects)
		const existingTags = Array.isArray(pObservationRecord.Tags) ? pObservationRecord.Tags.filter((/** @type {any} */ t) => t != null) : [];
		/**
		 * @type {any[]}
		 */
		const tagsToAdd = [];
		for (const labelFilter of includeLabelFilters)
		{
			for (const tagValue of labelFilter.Values)
			{
				if (!existingTags.includes(tagValue) && !tagsToAdd.includes(tagValue))
				{
					tagsToAdd.push(tagValue);
				}
			}
		}
		if (!tagsToAdd.length)
		{
			return;
		}
		pObservationRecord.Tags = [ ...existingTags, ...tagsToAdd ];
		await this.pict.providers.ObservationProvider.updateObservation(pObservationRecord, (/** @type {any} */ updatedObs) =>
		{
			this.pict.log.info(`Applied filter labels to observation ${pObservationRecord.IDObservation}: Tags=${pObservationRecord.Tags}`);
			// Replace the stale observation in the local document list with the server's updated record
			// so that subsequent refreshDocumentObservations and filter logic sees the correct Labels
			const docObservations = this.pict.AppData?.DocumentData?.ReportData?.Observations;
			if (updatedObs && Array.isArray(docObservations))
			{
				const idx = docObservations.findIndex((/** @type {any} */ o) => o.IDObservation === pObservationRecord.IDObservation);
				if (idx !== -1)
				{
					docObservations[idx] = updatedObs;
				}
			}
		});
	}

	/**
	 * Gets the current filters for the given input from the settings, or returns an empty object if no filters are set for that input.
	 * @param {Object} pInput - The input object to get the filters for (used to access the input hash for looking up in the settings).
	 * @returns {Object} - The filters object for the given input from the settings, or an empty object if no filters are set.
	 */
	getCurrentFiltersForInput(pInput)
	{
		return this.getCurrentSettingsForInput(pInput).filters || {};
	}

	/**
	 * Returns true if the given input's deck has any Include or Exclude filters applied (non-empty filter keys).
	 * When only the default actionable-type filter has been injected (marked by `_isDefaultTypeFilter`),
	 * this returns false so that UI paths (header tags, exclude-sets toggle) treat the deck as unfiltered.
	 * The injected defaults still apply at the data-filtering level — callers that need the raw filter
	 * arrays (e.g. `observationMatchesTypeFilter`) read them directly from `getCurrentFiltersForInput`.
	 * @param {Object} pInput - The input object to check filters for.
	 * @returns {boolean}
	 */
	hasFiltersApplied(pInput)
	{
		const currentFilters = this.getCurrentFiltersForInput(pInput);

		// When the only populated filter is the injected default ObservationTypes (matching the
		// actionableObservationTypes list exactly), treat as "no filters" for UI purposes — the toggle,
		// header tags, and add-button visibility should behave as if the deck is unfiltered.
		// The defaults still gate observations at the data level via observationMatchesTypeFilter.
		// We check both the `_isDefaultTypeFilter` flag AND a content-based comparison so the detection
		// survives code paths that deep-clone or re-spread settings without preserving the flag.
		const isDefaultOnly = this._isOnlyDefaultTypeFilter(currentFilters);
		if (isDefaultOnly)
		{
			return false;
		}

		return Object.keys(currentFilters).some((key) =>
		{
			if (key === '_isDefaultTypeFilter')
			{
				return false;
			}
			const val = currentFilters[key];
			return val && typeof val === 'object' && Object.keys(val).length > 0;
		});
	}

	/**
	 * Returns true when the given filters object contains ONLY the injected default ObservationTypes
	 * (matching `actionableObservationTypes` exactly) and no other explicit filter criteria.
	 * Uses a flag-first check for speed, then falls back to a content comparison so deep-cloned
	 * or re-spread filter objects are still recognized as defaults.
	 * @param {Object} currentFilters - The filters object from getCurrentFiltersForInput.
	 * @returns {boolean}
	 */
	_isOnlyDefaultTypeFilter(currentFilters)
	{
		if (!currentFilters)
		{
			return true;
		} // no filters at all

		// Quick check: if there are any Exclude entries with values, this is not default-only
		if (currentFilters.Exclude && Object.keys(currentFilters.Exclude).some((k) => currentFilters.Exclude[k]?.length > 0))
		{
			return false;
		}
		// Quick check: if there are Include entries beyond ObservationTypes, this is not default-only
		if (currentFilters.Include)
		{
			const includeKeys = Object.keys(currentFilters.Include);
			if (includeKeys.some((k) => k !== 'ObservationTypes' && currentFilters.Include[k]?.length > 0))
			{
				return false;
			}
		}

		// Flag-based check: if the flag was set by setCurrentFiltersForInput and survived, trust it
		if (currentFilters._isDefaultTypeFilter)
		{
			return true;
		}

		// Content-based fallback: compare Include.ObservationTypes to actionableObservationTypes
		const includeTypes = currentFilters.Include?.ObservationTypes;
		if (!includeTypes?.length)
		{
			return true; // no Include types at all — treat as default (empty/unfiltered)
		}
		// Match if the Include types are exactly the actionable defaults (same items, same order)
		if (includeTypes.length !== this.actionableObservationTypes.length)
		{
			return false;
		}
		return includeTypes.every((/** @type {string} */ t, /** @type {number} */ i) => t === this.actionableObservationTypes[i]);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object (NOTE: Doesn't work on buttons)
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {boolean}
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		// Read the newly selected value from the set selector dropdown (where the user made their choice).
		// Only fall back to the hidden input when the selector element doesn't exist (non-selector cases).
		// When the selector exists, always trust its value — an empty string means the user cleared the selection.
		const tmpSelectorElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetSelectorHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const tmpInputSelectValue = tmpSelectorElement ? tmpSelectorElement.value : this.pict.ContentAssignment.readContent(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID));
		// Write the new value to both the hidden input and the form data address so the value is persisted
		this.pict.ContentAssignment.assignContent(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpInputSelectValue);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		// Keep the dynamicGUIDMap up to date so other deck selectors know which sets are in use
		if (tmpSelectorElement && tmpInputSelectValue)
		{
			this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID] = tmpInputSelectValue;
		}
		else if (tmpSelectorElement)
		{
			delete this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID];
		}
		// Only notify the framework of a data change when the resolved value actually differs from
		// the value that was passed in.  Previously, dataChanged() was called unconditionally which
		// triggered a full marshalToView() cycle on every onDataRequest invocation — even when the
		// value hadn't changed.  When a new defect row is added with an empty Observation Set value,
		// the marshal→request→dataChanged→marshal cycle would repeat indefinitely, causing an
		// infinite loop that locked up the browser.
		if (tmpInputSelectValue !== pValue)
		{
			pView.dataChanged(pInput.Hash);
			this.pict.log.info(`Observation Set selection changed for input ${pInput.Macro.RawHTMLID}. New value: ${tmpInputSelectValue}. Updating deck to reflect new selection.`);
			this.updateDeckForObservationSetSelectionChange(pInput, tmpInputSelectValue);
		}
		this.handleObservationSetEditButtonStateOnChange(pInput);
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * @param {any} pInput - The input object.
	 * @param {string} tmpInputSelectValue - The new value selected in the observation set selector.
	 */
	async updateDeckForObservationSetSelectionChange(pInput, tmpInputSelectValue)
	{
		const tmpParsedID = parseInt(tmpInputSelectValue);
		// Handle the "cleared" case — user cleared the selector, so reset the deck to an empty state
		if (!tmpInputSelectValue || isNaN(tmpParsedID))
		{
			this.pict.log.info(`Observation Set selector cleared for input ${pInput.Macro.RawHTMLID}. Resetting deck to empty state.`);
			const cardDeckContentElement = document.querySelector(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID));
			if (cardDeckContentElement)
			{
				cardDeckContentElement.innerHTML = '';
			}
			this.updateEmptyMessageText(pInput, 'No observation set is currently selected.');
			this.toggleVisibilityForAddCardHeaderButtons(pInput);
			return;
		}
		// Restore the default empty message before building the deck with the new set
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		this.updateEmptyMessageText(pInput, currentSettings.customEmptyStateMessage);
		const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInput.Hash, tmpParsedID);
		try
		{
			// Populate the set-name cache before rendering so the header label uses the saved Name on first paint
			await this.fetchObservationSetName(tmpParsedID);
			let observationListFromRegistry = await this.pict.providers.MediaRegistry.getObservationSetByNamespace(tmpNamespaceForIDObservationSet);
			if (observationListFromRegistry && observationListFromRegistry.length)
			{
				this.pict.log.info(`Found existing observation set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet} with ${observationListFromRegistry.length} observations. Updating deck to display this set.`);
			}
			else
			{
				// Set not yet in registry — fetch it from the server and register it so the deck can display it
				this.pict.log.info(`No observation set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet}. Fetching and registering set ${tmpParsedID}.`);
				observationListFromRegistry = await this.pict.providers.MediaRegistry.registerMediaSetByIDObservationSet(tmpNamespaceForIDObservationSet, tmpParsedID);
			}
			this.prepareUIBeforeBuildingCardDeck(this.pict.views[pInput.ViewHash], pInput, tmpNamespaceForIDObservationSet, observationListFromRegistry);
		}
		catch (error)
		{
			this.pict.log.error(`Error updating deck for observation set selection change (namespace: ${tmpNamespaceForIDObservationSet}): ${error}.`);
		}
	}

	/**
	 * Handles the click event for the manage set button.
	 * @param {string} pRawID - The id of the hidden input element.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {string} pInputHash - The hash of the input.
	 */
	async handleObservationSetEditButtonClick(pRawID, pViewHash, pInputHash)
	{
		// set the button to loading state
		const tmpButton = document.querySelector(this.getCardDeckHeaderObservationSetEditButtonHTMLID(pRawID));
		if (tmpButton)
		{
			tmpButton.classList.add('is-loading');
		}
		// handle the empty message display
		let tmpSetId = 0;
		// check if the user has selected a new set name from the dropdown or an existing set
		const tmpEl = document.querySelector(this.getCardDeckHeaderObservationSetSelectorHTMLID(pRawID));
		if (!(tmpEl instanceof HTMLSelectElement))
		{
			// set the button to normal state
			if (tmpButton)
			{
				tmpButton.classList.remove('is-loading');
			}
			return;
		}
		const tmpSelectedValue = tmpEl.value;
		if (tmpSelectedValue && !isNaN(parseInt(tmpSelectedValue)))
		{
			tmpSetId = parseInt(tmpSelectedValue);
		}
		this.pict.fable.services.HeadlightPanels.applyUIHighlight(this.getCardDeckContentHTMLID(pRawID));
		// open the image panel for the user to select images
		this.pict.views.ObservationSet.handleFormManageSetButtonClick(tmpSetId, () =>
		{
			// set the button to normal state
			if (tmpButton)
			{
				tmpButton.classList.remove('is-loading');
			}
			this.pict.views.ObservationSet.handlePanelAddObservationButtonClick(null);
		});
	}

	/**
	 * Handles the click event for the create set button. Opens a modal with a name input and optional next-action selector.
	 * @param {string} pRawID - The raw HTML ID of the hidden input element.
	 * @param {string} pViewHash - The view hash for resolving the input context.
	 * @param {string} pInputHash - The input hash for resolving the input context.
	 */
	async handleObservationSetCreateSetButtonClick(pRawID, pViewHash, pInputHash)
	{
		const inputEl = this.pict.ContentAssignment.getElement(`#${ pRawID }`)?.[0];
		if (!inputEl)
		{
			this.pict.log.warn('Could not find obs set input for create set modal.');
			return;
		}
		// store context so the confirm handler can resolve the correct view/input
		this._pendingCreateSetContext = { rawID: pRawID, viewHash: pViewHash, inputHash: pInputHash };
		// get the previously saved user preferences for the next action to take after the set is created
		const tmpNextAction = this.pict.views.HeadlightPaneSettings.readUserPreference('ObservationSetNextAction') || '';
		this.nextActionAfterCreate = tmpNextAction;
		// if we have a custom handler, use it instead of the default modal
		if (this.pict.AppData.ObservationCardDeckProvider.customHandleObservationSetCreateSetButtonClick)
		{
			const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(pRawID));
			if (tmpCreateButton)
			{
				tmpCreateButton.classList.add('is-loading');
			}
			await this.pict.AppData.ObservationCardDeckProvider.customHandleObservationSetCreateSetButtonClick(pRawID, tmpNextAction);
			if (tmpCreateButton)
			{
				tmpCreateButton.classList.remove('is-loading');
			}
			return;
		}
		// build modal body with set name input
		const modalBodyTemplate = /*html*/`
			<div class="columns is-mobile">
				<div class="column">
					<div class="field">
						<label class="label">Set Name</label>
						<div class="control">
							<input class="input is-fullwidth" id="ObservationSetCreateNameInput" type="text" value="New Observation Set" placeholder="New Observation Set" onfocus="this.select()" />
						</div>
					</div>
				</div>
			</div>`;
		// build modal footer with next-action selector on the left and action buttons on the right
		const modalFooterTemplate = /*html*/`
			<div class="columns is-flex-grow-1 is-vcentered">
				<div class="column">
					<div class="field">
						<div class="control select is-fullwidth">
							<select id="CreateSetNextActionSelect">
								<option value="" ${ !tmpNextAction ? 'selected' : '' }>Pick an action (optional)</option>
								<option value="manage" ${ tmpNextAction === 'manage' ? 'selected' : '' }>Manage Set</option>
								<option value="capture" ${ tmpNextAction === 'capture' ? 'selected' : '' }>Quick Capture</option>
							</select>
						</div>
					</div>
				</div>
				<div class="column is-narrow">
					<div class="buttons is-right">
						<button type="button" class="button is-link is-soft" onclick="_Pict.providers.ObservationCardDeckProvider.handleCancelCreateSetModal()">
							<span class="icon"><i class="fas fa-fw fa-times"></i></span>
							<span>Cancel</span>
						</button>
						<button type="button" class="button is-link" onclick="_Pict.providers.ObservationCardDeckProvider.handleConfirmCreateSetModal()">
							<span class="icon"><i class="fas fa-fw fa-plus"></i></span>
							<span>Create New Set</span>
						</button>
					</div>
				</div>
			</div>`;
		this.fable.HeadlightModal.spawnModal({
			title: 'Create Observation Set',
			modalBodyTemplate: modalBodyTemplate,
			modalFooterTemplate: modalFooterTemplate,
			hideModalFooter: false,
			disableBackgroundClickToClose: true,
		});
		// set the button to loading state
		const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(pRawID));
		if (tmpCreateButton)
		{
			tmpCreateButton.classList.add('is-loading');
		}
	}

	/**
	 * Handles the cancel action for the create set modal. Dismisses the modal and removes the loading state from the create button.
	 */
	handleCancelCreateSetModal()
	{
		this.fable.HeadlightModal.dismissModals();
		if (this._pendingCreateSetContext)
		{
			const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(this._pendingCreateSetContext.rawID));
			if (tmpCreateButton)
			{
				tmpCreateButton.classList.remove('is-loading');
			}
			this._pendingCreateSetContext = null;
		}
	}

	/**
	 * Handles the confirm action for the create set modal. Creates the set, updates the selector and deck, then applies the selected next action.
	 */
	async handleConfirmCreateSetModal()
	{
		if (!this._pendingCreateSetContext)
		{
			this.pict.log.error('No pending create set context found. Cannot create set.');
			return;
		}
		const { rawID, viewHash, inputHash } = this._pendingCreateSetContext;
		// read the set name from the modal input
		const tmpNameInput = /** @type {HTMLInputElement} */ (document.getElementById('ObservationSetCreateNameInput'));
		const tmpName = tmpNameInput?.value?.trim() || 'New Observation Set (' + new Date().toLocaleString() + ')';
		// read the next action selection and persist the preference
		const tmpNextActionSelect = /** @type {HTMLSelectElement} */ (document.getElementById('CreateSetNextActionSelect'));
		const tmpNextAction = tmpNextActionSelect?.value || '';
		this.nextActionAfterCreate = tmpNextAction;
		this.pict.views.HeadlightPaneSettings.updateUserPreferences('ObservationSetNextAction', tmpNextAction);
		// create and save the new observation set
		const tmpProjectId = this.pict.AppData?.DocumentData?.ReportData?.IDProject || null;
		const tmpNewSet = this.pict.providers.ObservationSetProvider.createSet(tmpName, tmpProjectId);
		let savedSet;
		try
		{
			savedSet = await this.pict.providers.ObservationSetProvider.saveSet(tmpNewSet);
		}
		catch (error)
		{
			this.pict.log.error(`Error creating observation set: ${error}`);
			this.handleCancelCreateSetModal();
			return;
		}
		const pView = this.pict.views[viewHash];
		const pInput = pView?.getInputFromHash(inputHash);
		// seed the set-name cache so header labels resolve immediately without a follow-up network fetch
		if (savedSet?.IDObservationSet && savedSet?.Name)
		{
			this._observationSetNameCache[String(savedSet.IDObservationSet)] = savedSet.Name;
		}
		// update the GUID map and hidden input with the new set ID
		this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[rawID] = savedSet.IDObservationSet;
		this.pict.ContentAssignment.assignContent(this.getHiddenInputHTMLID(rawID), savedSet.IDObservationSet);
		// update the select2 dropdown with the new set option
		const tmpSelectElement = document.querySelector(this.getCardDeckHeaderObservationSetSelectorHTMLID(rawID));
		if (tmpSelectElement && window['jQuery'])
		{
			const newOption = new Option(savedSet.Name, `${ savedSet.IDObservationSet }`, true, true);
			window['jQuery'](tmpSelectElement).append(newOption).trigger('change');
		}
		// marshal the form data so the new value is persisted
		if (pView && pInput)
		{
			pView.dataChanged(pInput.Hash);
		}
		// invoke the custom post-create callback if registered (e.g. bridge defect sequence number increment)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetCreated === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetCreated(savedSet, pInput);
		}
		// auto-save the document if applicable
		if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument)
		{
			this.pict.providers.DocumentProvider.handleSave(true);
		}
		// update the deck to display the new (empty) set
		if (pInput)
		{
			await this.updateDeckForObservationSetSelectionChange(pInput, `${ savedSet.IDObservationSet }`);
			this.handleObservationSetEditButtonStateOnChange(pInput);
		}
		// dismiss the modal and clear loading state
		this.fable.HeadlightModal.dismissModals();
		const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(rawID));
		if (tmpCreateButton)
		{
			tmpCreateButton.classList.remove('is-loading');
		}
		this._pendingCreateSetContext = null;
		// apply the next action if one was selected
		if (tmpNextAction === 'manage')
		{
			this.handleObservationSetEditButtonClick(rawID, viewHash, inputHash);
		}
		else if (tmpNextAction === 'capture')
		{
			// programmatically trigger the quick capture file input
			const tmpQuickCaptureLabel = document.querySelector(this.getCardDeckHeaderActionsButtonQuickCaptureHTMLID(rawID));
			const tmpFileInput = /** @type {HTMLInputElement} */ (tmpQuickCaptureLabel?.querySelector('input[type="file"]'));
			if (tmpFileInput)
			{
				tmpFileInput.click();
			}
		}
	}

	/**
	 * Sets a custom handler for the create set button click event.
	 * @param {Function} pFunction - The custom handler function.
	 */
	setCustomHandleObservationSetCreateSetButtonClick(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customHandleObservationSetCreateSetButtonClick = pFunction;
	}

	/**
	 * Sets a custom callback invoked after a new observation set is created via the create set modal.
	 * Useful for external components that need to perform additional actions after set creation (e.g. incrementing sequence numbers).
	 * @param {Function} pFunction - Callback receiving (pSavedSet, pInput).
	 */
	setCustomOnAfterObservationSetCreated(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetCreated = pFunction;
	}

	/**
	 * Sets a custom callback invoked after an observation is added to or removed from an observation set.
	 * Useful for external components that need to react to set content changes (e.g. updating photo count labels).
	 * @param {Function} pFunction - Callback receiving (pInput, pIDObservation, pObservationSet).
	 */
	setCustomOnAfterObservationSetChanged(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged = pFunction;
	}

	/**
	 * Sets a document-level context callback invoked after observation set content changes.
	 * Useful for triggering broader document recalculations (e.g. orphan observation list reorganization).
	 * @param {Function} pFunction - Callback receiving no arguments.
	 */
	setDocumentContextCallback(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.documentContextCallback = pFunction;
	}

	/**
	 * Sets a custom HandleSearchFilters callback for the observation set selector's Select2 AJAX query.
	 * When provided, this replaces the default project-scoped filter. The callback receives the current
	 * filter array and should return the modified filter array.
	 * @param {((pFilters: string[]) => string[]) | null} pFunction - The custom filter callback, or null to reset.
	 */
	setCustomHandleSearchFiltersForSelector(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customHandleSearchFiltersForSelector = pFunction;
	}

	/**
	 * Sets a custom callback invoked after the CardDeck finishes marshalling and rendering cards for an input.
	 * Useful for external components that need to react to deck content after the DOM is populated (e.g. updating photo count labels on initial load or set selection).
	 * @param {Function} pFunction - Callback receiving (pInput, pObservationList).
	 */
	setCustomOnAfterMarshal(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customOnAfterMarshal = pFunction;
	}

	/**
	 * Opens the inline rename modal for an observation set attached to a non-selector card deck.
	 * Triggered by the pencil icon rendered next to the static set label.
	 * @param {string} pRawHTMLID - The raw HTML ID of the deck input, used to locate the display container on confirm.
	 * @param {number|string} pIDObservationSet - The set to rename.
	 */
	async handleInlineRenameSetClick(pRawHTMLID, pIDObservationSet)
	{
		if (!pIDObservationSet || this.isDocumentLocked || !this.canEditDocument)
		{
			return;
		}
		let tmpSet;
		try
		{
			tmpSet = await this.pict.providers.ObservationSetProvider.loadSet(pIDObservationSet);
		}
		catch (error)
		{
			this.pict.log.error(`Error loading observation set ${pIDObservationSet} for rename: ${error}`);
			return;
		}
		if (!tmpSet)
		{
			this.pict.log.error(`No observation set record returned for ID ${pIDObservationSet}. Cannot open rename modal.`);
			return;
		}
		// If the stored name is auto-generated (timestamped), start with an empty input so the user isn't renaming the timestamp
		const tmpInitialValue = this.isAutoGeneratedSetName(tmpSet.Name) ? '' : (tmpSet.Name || '');
		const tmpFallbackLabel = this.getFallbackObservationSetLabel(pIDObservationSet);
		this._pendingRenameSetContext = { rawHTMLID: pRawHTMLID, idObservationSet: pIDObservationSet, setRecord: tmpSet };
		const tmpInitialValueEscaped = tmpInitialValue.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		const tmpFallbackEscaped = tmpFallbackLabel.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		const modalBodyTemplate = /*html*/`
			<div class="columns is-mobile">
				<div class="column">
					<div class="field">
						<label class="label">Set Name</label>
						<div class="control">
							<input class="input is-fullwidth" id="ObservationSetRenameInput" type="text" value="${tmpInitialValueEscaped}" placeholder="${tmpFallbackEscaped}" onfocus="this.select()" />
						</div>
						<p class="help">Leave blank to keep the default "${tmpFallbackEscaped}" label.</p>
					</div>
				</div>
			</div>`;
		const modalFooterTemplate = /*html*/`
			<div class="buttons is-right is-flex-grow-1">
				<button type="button" class="button is-link is-soft" onclick="_Pict.providers.ObservationCardDeckProvider.handleCancelRenameSetModal()">
					<span class="icon"><i class="fas fa-fw fa-times"></i></span>
					<span>Cancel</span>
				</button>
				<button type="button" class="button is-link" onclick="_Pict.providers.ObservationCardDeckProvider.handleConfirmRenameSetModal()">
					<span class="icon"><i class="fas fa-fw fa-check"></i></span>
					<span>Save</span>
				</button>
			</div>`;
		this.fable.HeadlightModal.spawnModal({
			title: 'Rename Observation Set',
			modalBodyTemplate: modalBodyTemplate,
			modalFooterTemplate: modalFooterTemplate,
			hideModalFooter: false,
			disableBackgroundClickToClose: true,
		});
	}

	/**
	 * Handles the cancel action for the rename set modal. Dismisses the modal and clears pending context.
	 */
	handleCancelRenameSetModal()
	{
		this.fable.HeadlightModal.dismissModals();
		this._pendingRenameSetContext = null;
	}

	/**
	 * Handles the confirm action for the rename set modal. Saves the new name to the server, updates the set-name cache,
	 * and refreshes the header label so the change is reflected immediately without requiring a full remarshal.
	 */
	async handleConfirmRenameSetModal()
	{
		if (!this._pendingRenameSetContext)
		{
			this.pict.log.error('No pending rename set context found. Cannot save rename.');
			return;
		}
		const { rawHTMLID, idObservationSet, setRecord } = this._pendingRenameSetContext;
		const tmpInput = /** @type {HTMLInputElement} */ (document.getElementById('ObservationSetRenameInput'));
		const tmpNewName = tmpInput?.value?.trim() || '';
		// Empty input → keep the previously-stored Name unchanged; display logic will still show the fallback label if it's auto-generated
		const tmpNameToSave = tmpNewName || setRecord.Name || this.getFallbackObservationSetLabel(idObservationSet);
		// Short-circuit if nothing actually changed
		if (tmpNameToSave === setRecord.Name)
		{
			this.handleCancelRenameSetModal();
			return;
		}
		setRecord.Name = tmpNameToSave;
		try
		{
			await this.pict.providers.ObservationSetProvider.saveSet(setRecord);
		}
		catch (error)
		{
			this.pict.log.error(`Error saving renamed observation set ${idObservationSet}: ${error}`);
			this.handleCancelRenameSetModal();
			return;
		}
		// Update the cache so any subsequent re-render uses the new name synchronously
		this._observationSetNameCache[String(idObservationSet)] = tmpNameToSave;
		// Refresh the header label directly so the change appears without waiting for a full marshal cycle
		const tmpDisplayContainer = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetDisplayHTMLID(rawHTMLID))?.[0];
		const tmpTextSpan = tmpDisplayContainer?.querySelector('.icon-text');
		if (tmpTextSpan)
		{
			tmpTextSpan.textContent = this.getDisplayLabelForObservationSet(idObservationSet);
		}
		this.fable.HeadlightModal.dismissModals();
		this._pendingRenameSetContext = null;
	}

	/**
	 * Handle the state of the edit button based on the hidden input value.
	 * @param {Object} pInput - The input object.
	 */
	handleObservationSetEditButtonStateOnChange(pInput)
	{
		const tmpHiddenElement = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const tmpValue = tmpHiddenElement instanceof HTMLInputElement && tmpHiddenElement.value;
		const tmpEditButton = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetEditButtonHTMLID(pInput.Macro.RawHTMLID))?.[0];
		if (!tmpValue)
		{
			tmpEditButton?.setAttribute('disabled', 'disabled');
		}
		else
		{
			tmpEditButton?.removeAttribute('disabled');
		}
	}

	/**
	 * Handles the the inline add button click event for the given input.
	 * This event is triggered when the user clicks the inline add button for an input.
	 * @param {Object} event - The event object.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {boolean} pQuickCaptureButton - Whether the button clicked was the quick capture button.
	 */
	async handleAddNewCardToDeckButtonEvent(event, pViewHash, pInputHash, pQuickCaptureButton = false)
	{
		const currentSettings = this.getCurrentSettingsForInput(this.pict.views[pViewHash].getInputFromHash(pInputHash));
		// The raw event target — for the Add button, this can be a child of the button (the icon
		// <span> or <i>) depending on where the click actually landed; for Quick Capture, this is
		// always the <input type="file"> (since the change event fires on the input).
		/** @type {HTMLElement} */
		const tmpRawEventTarget = event.target;
		// The visible button surface that should receive the `is-loading` class. Resolve via
		// event.currentTarget (the element the listener is attached to via onclick/onchange) when
		// it already has the .button class; otherwise climb to the nearest .button so the loading
		// state always lands on the visible button — for Quick Capture this is the wrapping <label>.
		/** @type {HTMLElement} */
		const currentButtonElement = (event.currentTarget && event.currentTarget.classList?.contains('button')) ? event.currentTarget : (tmpRawEventTarget?.closest?.('.button') || event.currentTarget || tmpRawEventTarget);
		let tmpView = this.pict.views[pViewHash];
		let tmpInput = tmpView.getInputFromHash(pInputHash);
		currentButtonElement.classList.add('is-loading');
		// track for panel-close cleanup — only the panel-opening (non-quick-capture) path can leave
		// this stuck if the user dismisses the panel without completing the add flow, but it's safe
		// to track quick capture too since handleAddCardToNewSetRecord/the upload path always reaches
		// its callback and unregisters synchronously after removing the class.
		this._pendingAddButtonElements.add(currentButtonElement);

		if (!currentSettings?.useObservationSet && this.hasFiltersApplied(tmpInput) && !this.hasActionableFilters(tmpInput))
		{
			this.pict.log.warn('Cannot add new observation through the card deck when non-label filters are applied on a non-set based deck.');
			currentButtonElement.classList.remove('is-loading');
			this._pendingAddButtonElements.delete(currentButtonElement);
			return false;
		}
		// for the Obeservation Set Path
		if (currentSettings.useObservationSet)
		{
			// if we are using observation sets, we need to make sure we have an observation set to add the new observation to,
			// since the set is what manages the list of observations that are displayed in the deck and the filters that are applied to those observations,
			// so if we don't have a set to add the new observation to, then we won't be able to display it in the deck or apply any filters to it
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetSelectorHTMLID(tmpInput.Macro.RawHTMLID))?.[0];
			let currentObservationSetID = isNaN(parseInt(tmpSelectElement?.value)) ? null : parseInt(tmpSelectElement?.value);
			// If the selector element doesn't exist (useObservationSetSelector is false), fall back to the hidden input
			// which always contains the IDObservationSet from the initial data marshal
			if (!currentObservationSetID)
			{
				const tmpHiddenInputValue = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(tmpInput.Macro.RawHTMLID))?.[0]?.value;
				currentObservationSetID = isNaN(parseInt(tmpHiddenInputValue)) ? null : parseInt(tmpHiddenInputValue);
			}
			let currentObservationSet = currentObservationSetID ? await this.pict.providers.ObservationSetProvider.loadSet(currentObservationSetID) : null;
			// if there's no set id yet, we have to go create one before we can begin adding images
			if (!currentObservationSetID && !currentObservationSet)
			{
				// when requireExplicitSetCreation is enabled, block the auto-create fallback — the user
				// must use "Create New Set" (which goes through the custom handler) before adding images
				if (currentSettings.requireExplicitSetCreation)
				{
					this.pict.log.warn('Cannot add observation — no set is selected and requireExplicitSetCreation is enabled. Use "Create New Set" first.');
					currentButtonElement.classList.remove('is-loading');
					this._pendingAddButtonElements.delete(currentButtonElement);
					return false;
				}
				this.pict.log.info('No Observation Set ID found, creating a new one.');
				const newSet = await this.createNewObservationSetForCardDeck(pViewHash, pInputHash);
				currentObservationSetID = newSet.IDObservationSet;
				currentObservationSet = newSet;
				// get the temp namespace so we can clear it out now (garbage collection effort)
				const tmpNamespaceForTempIDObservationSet = this.buildNamespaceForCardDeck(pInputHash, null, true);
				// check the media registry to see find the TEMP namespace we created for this input hash when we first built the deck, and if it exists, we need to update that namespace to point to the new set ID and pull the observations for that set so that we can update the deck with the correct set of observations based on the new set ID
				await this.pict.providers.MediaRegistry.clearNamespace(tmpNamespaceForTempIDObservationSet);
				// update the card deck header selector with the new set ID so that it's selected and we can pull the correct set from the registry to display in the deck
				const tmpNamespaceForNewIDObservationSet = this.buildNamespaceForCardDeck(pInputHash, currentObservationSetID);
				await this.pict.providers.MediaRegistry.registerMediaSetByIDObservationSet(tmpNamespaceForNewIDObservationSet, currentObservationSetID);
				this.handleHeaderContentForCardDeck(tmpView, tmpInput, tmpNamespaceForNewIDObservationSet);
				// update the views so we have the latest state of elements to inject the image into
				tmpView = this.pict.views[pViewHash];
				tmpInput = tmpView.getInputFromHash(pInputHash);
			}
			// set the IDObservationSet for the image panel so that interactions there will apply to the current set
			this.pict.views.ObservationSet.setObservationSetID(currentObservationSet.IDObservationSet);
			this.pict.views.ObservationSet.ActiveObservationSet = currentObservationSet;

			// Quick capture will bypass the observation selection panel and just add the captured image directly to the set and deck,
			// while the regular add button will open the observation panel for the user to select/search/upload images to add to the set and deck
			if (pQuickCaptureButton)
			{
				// quickCaptureImage expects the underlying <input type="file">, not the wrapping
				// <label class="button"> that currentButtonElement now resolves to.
				const tmpFileInput = /** @type {HTMLInputElement} */ (tmpRawEventTarget);
				this.pict.views.ObservationCreateMedia.quickCaptureImage(tmpFileInput, { IDDocument: this.pict?.AppData?.DocumentData?.ReportData?.IDDocument },
					async (/** @type {any[]} */ observationInfos) =>
					{
						await this.handleAddCardToNewSetRecord(pViewHash, pInputHash, observationInfos);
						currentButtonElement.classList.remove('is-loading');
						this._pendingAddButtonElements.delete(currentButtonElement);
						tmpFileInput.value = ''; // reset the file input so that the same file can be uploaded again if needed
					});
			}
			else
			{
				this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open',
					() =>
					{
						// start at the upload tab
						this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation');
						// 'add-to-set' is the recognized CSS mode that triggers the green banner and add-mode UI
						this.pict.views.HeadlightPaneObservations.setObservationPanelTarget(tmpView.Hash, tmpInput.Hash, this.pict.views.ObservationSet.ActiveObservationSet?.Name || tmpInput.Name, 'add-to-set');
						this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Observation Set';
						this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Observation Set';
						/** @type {(observationInfos: Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>) => Promise<void>} */
						this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = async (observationInfos) =>
						{
							await this.handleAddCardToNewSetRecord(pViewHash, pInputHash, observationInfos);
							currentButtonElement.classList.remove('is-loading');
							this._pendingAddButtonElements.delete(currentButtonElement);
						};
					});
			}
			return true;
		}
		// For the Document List Path (non-set decks, with or without label-only filters)
		if (pQuickCaptureButton)
		{
			// quickCaptureImage expects the underlying <input type="file">, not the wrapping
			// <label class="button"> that currentButtonElement now resolves to.
			const tmpFileInput = /** @type {HTMLInputElement} */ (tmpRawEventTarget);
			this.pict.views.ObservationCreateMedia.quickCaptureImage(tmpFileInput, { IDDocument: this.pict?.AppData?.DocumentData?.ReportData?.IDDocument },
				async (/** @type {any[]} */ observationInfos) =>
				{
					// The new observation is already in DocumentData.ReportData.Observations (added by quickCaptureImage).
					// Gate: reject observations whose type doesn't match the deck's ObservationType filters.
					const validObservations = observationInfos.filter((obsInfo) =>
					{
						const obsRecord = obsInfo.Observation ||
							this.pict.AppData?.DocumentData?.ReportData?.Observations?.find((/** @type {any} */ o) => o.IDObservation == obsInfo.IDObservation);
						if (obsRecord && !this.observationMatchesTypeFilter(tmpInput, obsRecord))
						{
							this.pict.log.warn(`Observation ${obsInfo.IDObservation} (type "${obsRecord.ObservationType}") does not match the deck's ObservationType filter — skipping.`);
							this.showFilterMismatchWarning(tmpInput, obsRecord.ObservationType);
							return false;
						}
						return true;
					});
					// If label-only filters are active, auto-apply the Include labels so the new observation matches the filter criteria.
					for (const obsInfo of validObservations)
					{
						if (obsInfo.Observation && this.hasActionableFilters(tmpInput))
						{
							await this.applyFilterLabelsToObservation(tmpInput, obsInfo.Observation);
						}
					}
					// Refresh the MediaRegistry's document observations and remarshal all document-list decks to pick it up.
					await this.pict.providers.MediaRegistry.refreshDocumentObservations(this.pict.AppData.DocumentData.ReportData.Observations);
					for (const obsInfo of validObservations)
					{
						await this.reMarshalAllViewsWithCardDecks(obsInfo.IDObservation, 'AllDocumentLists', true);
					}
					currentButtonElement.classList.remove('is-loading');
					this._pendingAddButtonElements.delete(currentButtonElement);
					tmpFileInput.value = '';
				});
		}
		else
		{
			// open the observation panel for the user to select/search/upload images to add to the document
			tmpView.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open',
				async () =>
				{
					// start at the upload tab
					this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation');
					tmpView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(tmpView.Hash, tmpInput?.Hash, tmpInput?.Name, 'add-to-document');
					this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Document';
					this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Document';
					/** @type {(observationInfos: Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>) => Promise<void>} */
					this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = async (observationInfos) =>
					{
						// Gate: reject observations whose type doesn't match the deck's ObservationType filters.
						const validObservations = observationInfos.filter((obsInfo) =>
						{
							const obsRecord = obsInfo.Observation ||
								this.pict.AppData?.DocumentData?.ReportData?.Observations?.find((/** @type {any} */ o) => o.IDObservation == obsInfo.IDObservation);
							if (obsRecord && !this.observationMatchesTypeFilter(tmpInput, obsRecord))
							{
								this.pict.log.warn(`Observation ${obsInfo.IDObservation} (type "${obsRecord.ObservationType}") does not match the deck's ObservationType filter — skipping.`);
								this.showFilterMismatchWarning(tmpInput, obsRecord.ObservationType);
								return false;
							}
							return true;
						});
						// If label-only filters are active, auto-apply the Include labels so the new observation matches the filter criteria.
						for (const obsInfo of validObservations)
						{
							if (obsInfo.Observation && this.hasActionableFilters(tmpInput))
							{
								await this.applyFilterLabelsToObservation(tmpInput, obsInfo.Observation);
							}
						}
						await this.pict.providers.MediaRegistry.refreshDocumentObservations(this.pict.AppData.DocumentData.ReportData.Observations);
						for (const obsInfo of validObservations)
						{
							await this.reMarshalAllViewsWithCardDecks(obsInfo.IDObservation, 'AllDocumentLists', true);
						}
						currentButtonElement.classList.remove('is-loading');
						this._pendingAddButtonElements.delete(currentButtonElement);
					};
				});
		}
		return true;
	}

	/**
	 * Clear the "is-loading" state from any Add or QuickCapture buttons that opened a panel-driven
	 * add flow but never completed it. This is called from HeadlightPaneObservations.closeHandler()
	 * when the user dismisses the Observations panel (X button, escape, background click, toggle).
	 *
	 * The button only gets removed from the tracking set after a successful completion of the
	 * add flow (where its onAfterCallback fires), so anything still in the set at panel-close time
	 * is by definition stuck. Defensive: we'd rather show a button as not-loading momentarily
	 * than leave it semi-permanently stuck for the user.
	 * @returns {void}
	 */
	clearPendingAddButtonLoadingState()
	{
		if (!this._pendingAddButtonElements || this._pendingAddButtonElements.size === 0)
		{
			return;
		}
		for (const tmpButtonElement of this._pendingAddButtonElements)
		{
			tmpButtonElement?.classList?.remove('is-loading');
		}
		this._pendingAddButtonElements.clear();
	}

	/**
	 * Handles the process of adding a card to the deck and the corresponding observation to the active observation set when a new observation is added through the card deck UI, including adding the observation to the set if it's not already in there and removing the card from any decks that are configured to exclude the set that the observation was added to.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>} pObservations - An array of objects containing information about the observations that were added through the card deck UI, including their IDs and any additional details that may be needed for processing.
	 */
	async handleAddCardToNewSetRecord(pViewHash, pInputHash, pObservations)
	{
		if (!this.pict.views.ObservationSet.ActiveObservationSet)
		{
			this.pict.log.warn('No active observation set to add observation to.');
			return;
		}
		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView?.getInputFromHash(pInputHash);
		const tmpIDObservationSet = this.pict.views.ObservationSet.ActiveObservationSet.IDObservationSet;
		for (const tmpObservation of pObservations)
		{
			if (!tmpObservation.IDObservation)
			{
				this.pict.log.warn('Observation info is missing IDObservation:', tmpObservation);
				continue;
			}
			// Gate: reject observations whose type doesn't match the deck's ObservationType filters.
			// Resolve the full observation record from the callback payload, the document list, or a fresh API fetch.
			const tmpObsRecord = tmpObservation.Observation ||
				this.pict.AppData?.DocumentData?.ReportData?.Observations?.find((/** @type {any} */ o) => o.IDObservation == tmpObservation.IDObservation);
			if (tmpInput && tmpObsRecord && !this.observationMatchesTypeFilter(tmpInput, tmpObsRecord))
			{
				this.pict.log.warn(`Observation ${tmpObservation.IDObservation} (type "${tmpObsRecord.ObservationType}") does not match the deck's ObservationType filter — skipping.`);
				this.showFilterMismatchWarning(tmpInput, tmpObsRecord.ObservationType);
				continue;
			}
			// if the observation is not already in the active set, add it to the set before we add the card to the deck
			if (!this.pict.views.ObservationSet.ActiveObservationSet.Observations.find((/** @type {any} */ obs) => obs.IDObservation === tmpObservation.IDObservation))
			{
				await this.pict.views.ObservationSet.addObservationToSet(tmpObservation.IDObservation);
			}
			// refresh the MediaRegistry namespace for the active observation set so addCardToDeck can find the newly added observation
			if (tmpIDObservationSet)
			{
				await this.pict.providers.MediaRegistry.updateNamespacesByIDObservationSet(tmpIDObservationSet);
			}
			// after we add the observation to the set, we can add the card to the deck
			await this.addCardToDeck(pViewHash, pInputHash, tmpObservation.IDObservation)
			.then(async () =>
			{
				this.pict.log.info(`Added card to deck for observation ID ${tmpObservation.IDObservation} after adding observation to set.`);
				// for all other non-sets based decks, we need refresh the decks so they pick up the new image in the document observation list update
				await this.reMarshalAllViewsWithCardDecks(tmpObservation.IDObservation, 'AllDocumentLists', true);
			})
			.catch((error) =>
			{
				this.pict.log.error(`Error adding card to deck for observation ID ${tmpObservation.IDObservation}: ${error}`);
				return;
			});
		}
		// remarshal all observation-set-backed decks so any other decks showing this set also reflect the new observation(s)
		if (tmpIDObservationSet && pObservations.length)
		{
			await this.reMarshalAllViewsWithCardDecks(pObservations[pObservations.length - 1].IDObservation, 'AllObservationSets', true);
		}
		// invoke the custom observation set changed callback if registered (e.g. bridge defect photo count label update)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged(tmpInput, pObservations[pObservations.length - 1]?.IDObservation, this.pict.views.ObservationSet.ActiveObservationSet);
		}
		// invoke the document context callback if registered (e.g. orphan observation recalculation)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.documentContextCallback === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.documentContextCallback();
		}
	}

	/**
	 * Remarshals all views that have card decks in them based on the given observation ID and package type, which is used to trigger a refresh of the decks in those views so that
	 * they can pick up any changes to the observations (ex: new image added to an observation, observation added/removed from the document, etc.) and update the cards in the deck
	 * accordingly, and optionally runs a cache busting function for the images in those decks if needed.
	 * @param {number|string} pIDObservation - The ID of the observation that was changed and is being used as the basis for determining which decks need to be refreshed.
	 * @param {string} pPackType - The package type that is used to determine which views have card decks that may need to be refreshed based on the observation change.
	 * @param {boolean} pRunCacheBust - Whether to run the cache busting function for the images in the decks that are being refreshed, which may be needed if the observation change involves an update to an existing image rather than just adding a new image or adding/removing an observation from the document.
	 */
	async reMarshalAllViewsWithCardDecks(pIDObservation, pPackType, pRunCacheBust = false)
	{
		const allPotentialDecksToReMarshal = document.querySelectorAll(this.packageTypeSelectorMap[pPackType]);
		if (!allPotentialDecksToReMarshal.length)
		{
			this.pict.log.info('No card decks found to refresh.');
			return;
		}
		// for each view that has a card deck, we'll remarshal that view (rather than individual inputs)
		/**
		 * @type {any[]}
		 */
		const viewsToRefresh = [];
		allPotentialDecksToReMarshal.forEach((deck) =>
		{
			const viewHash = deck.getAttribute(this.deckViewHashAttribute);
			if (viewHash)
			{
				if (!viewsToRefresh.includes(viewHash))
				{
					viewsToRefresh.push(viewHash);
				}
			}
		});
		if (viewsToRefresh.length)
		{
			for (const viewHash of viewsToRefresh)
			{
				const tmpView = this.pict.views[viewHash];
				if (tmpView)
				{
					this._isRemarshalInProgress = true;
					tmpView.marshalToView();
					// wait for all async card deck marshal work to complete before moving to the next view,
					// preventing concurrent rebuilds from racing over shared MediaRegistry state
					await this.waitForPendingMarshals();
					this._isRemarshalInProgress = false;
					if (pRunCacheBust && pIDObservation)
					{
						await this.pict.providers.ObservationProvider.cacheBustObsImages(pIDObservation, this.cacheBusterAttemptTimers);
					}
				}
			}
		}
	}

	/**
	 * Handles the click event for a card thumbnail in the deck.
	 * @param {Event} event - The click event object.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {number} pIDObservation - The observation ID associated with the clicked thumbnail.
	 */
	handleClickForCardThumbnail(event, pViewHash, pInputHash, pIDObservation)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		const currentSettings = this.getCurrentSettingsForInput(this.pict.views[pViewHash].getInputFromHash(pInputHash));
		// if there's a custom callback defined for when clicking on a thumbnail in the deck, use that, otherwise fall back to the default behavior of opening the image panel with the observation details
		if (currentSettings.onClickThumbnailClickCallback && typeof currentSettings.onClickThumbnailClickCallback === 'function')
		{
			currentSettings.onClickThumbnailClickCallback(event, this.pict.views[pViewHash], this.pict.views[pViewHash].getInputFromHash(pInputHash), pIDObservation);
		}
		else
		{
			// for the annotation workflow path, we want to open the observation detail view in the side panel when clicking on a thumbnail, and if the ObservationSubImageSelector view is active,
			// we want to set the intent for that view so that it knows to update based on interactions in the observation detail view
			if (this.pict?.views?.ObservationSubImageSelector?.intent)
			{
				const parentID = event.target instanceof HTMLElement && event.target.parentElement?.parentElement?.id;
				const obsSetMappedID = parentID?.replace('IMAGE-CONTAINER-FOR-', '') || 0;
				if (obsSetMappedID)
				{
					this.pict.fable.services.HeadlightPanels.applyUIHighlight(`#${ parentID?.replace('IMAGE-CONTAINER-FOR-', 'ELEMENT-CONTAINER-FOR-') }`);
					this.pict.log.info('Found ObservationSet ID: ', obsSetMappedID);
					this.pict.views.ObservationSubImageSelector.intent =
					{
						type: 'ObservationSet',
						IDObservationSet: this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[obsSetMappedID],
					};
				}
			}
			this.pict.views.HeadlightPaneObservations.showObservationDetailView(event, pIDObservation, null);
		}
	}

	/**
	 * Adds a card to the deck for the given observation ID.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {number|string} pIDObservation - The observation ID.
	 * @return {Promise<void>}
	 */
	async addCardToDeck(pViewHash, pInputHash, pIDObservation)
	{
		if (!pIDObservation)
		{
			this.pict.log.warn('No observation ID provided. Cannot add card to deck.');
			return Promise.reject(new Error('No observation ID provided. Cannot add card to deck.'));
		}
		if (!pViewHash || !pInputHash)
		{
			this.pict.log.warn('No view hash or input hash provided. Cannot add card to deck.');
			return Promise.reject(new Error('No view hash or input hash provided. Cannot add card to deck.'));
		}
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.warn(`View with hash ${pViewHash} not found. Cannot add card to deck.`);
			return Promise.reject(new Error(`View with hash ${pViewHash} not found. Cannot add card to deck.`));
		}
		const tmpInput = tmpView.getInputFromHash(pInputHash);
		if (!tmpInput)
		{
			this.pict.log.warn(`Input with hash ${pInputHash} not found in view ${pViewHash}. Cannot add card to deck.`);
			return Promise.reject(new Error(`Input with hash ${pInputHash} not found in view ${pViewHash}. Cannot add card to deck.`));
		}
		const tmpCurrentSettings = this.getCurrentSettingsForInput(tmpInput);
		// disable adding cards if the setting is enabled for the deck
		if (tmpCurrentSettings.preventAddingCards)
		{
			return;
		}
		const deckContainer = this.pict.ContentAssignment.getElement(this.getCardDeckContentHTMLID(tmpInput.Macro.RawHTMLID))?.[0];
		if (tmpInput && deckContainer)
		{
			let tmpObservationRecord;
			// check sets for the observation before we add it to the deck, since if we're using sets to manage the lists of observations that are displayed in the deck
			if (tmpCurrentSettings.useObservationSet)
			{
				const tmpIDObservationSet = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(tmpInput.Macro.RawHTMLID))?.[0]?.value;
				const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInputHash, tmpIDObservationSet);
				const tmpObservationSetList = await this.pict.providers.MediaRegistry.getMediaSet(tmpNamespaceForIDObservationSet);
				tmpObservationRecord = tmpObservationSetList.find((/** @type {any} */ obs) => obs.IDObservation == pIDObservation);
				if (!tmpObservationRecord)
				{
					this.pict.log.error(`Could not find observation with ID ${pIDObservation} in the observation set for input ${tmpInput.Macro.RawHTMLID}. Cannot add card to deck.`);
					return Promise.reject(new Error(`Could not find observation with ID ${pIDObservation} in the observation set for input ${tmpInput.Macro.RawHTMLID}. Cannot add card to deck.`));
				}
			}
			else
			{
				const currentFilters = this.getCurrentFiltersForInput(tmpInput);
				if (currentFilters && Object.keys(currentFilters).length)
				{
					tmpObservationRecord = this.pict.AppData.DocumentData.ReportData.Observations.find((/** @type {any} */ obs) => obs.IDObservation == pIDObservation);
				}
				if (!tmpObservationRecord)
				{
					this.pict.log.error(`Could not find observation with ID ${pIDObservation} in document observations. Cannot add card to deck.`);
					return Promise.reject(new Error(`Could not find observation with ID ${pIDObservation} in document observations. Cannot add card to deck.`));
				}
			}

			return Promise.resolve(tmpObservationRecord);
		}
	}

	/**
	 * Removes a card from the deck for the given observation ID.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {string|number} pIDObservation - The observation ID.
	 * @return {Promise<void>}
	 */
	async removeCardFromDeck(pViewHash, pInputHash, pIDObservation)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView.getInputFromHash(pInputHash);
		const tmpCurrentSettings = this.getCurrentSettingsForInput(tmpInput);
		// disabled removing cards if the setting is enabled for the deck
		if (tmpCurrentSettings.preventRemovingCards)
		{
			return;
		}
		if (tmpInput)
		{
			if (this.isDocumentLocked || !this.canEditDocument)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'This document is locked. You cannot remove images from the set.',
					type: 'is-warning',
				});
				return;
			}
			this.pict.log.info(`Removing observation ${pIDObservation} from set for input ${tmpInput.Macro.RawHTMLID}.`);
			// NOTE: We intentionally are not doing confirmation prompt for sets as a UX choice - we want to encourage users to add/remove images to the set, so we want to make it easy to remove them.
			// for sets vs non-sets
			const tmpSetID = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(tmpInput.Macro.RawHTMLID))?.[0]?.value;
			if (tmpCurrentSettings.useObservationSet && tmpSetID)
			{
				let tmpSet = await this.pict.providers.ObservationSetProvider.loadSet(tmpSetID);
				const tmpObservation = tmpSet.Observations.find((/** @type {any} */ pObservation) => pObservation.IDObservation == pIDObservation);
				if (!tmpObservation)
				{
					this.pict.log.error(`Could not find observation with ID ${pIDObservation} in observation set with ID ${tmpSetID}. Cannot remove card from deck.`);
					return;
				}
				tmpSet = await this.pict.providers.ObservationSetProvider.removeObservation(tmpSet, tmpObservation).catch((/** @type {any} */ error) =>
				{
					this.pict.log.error(`Error removing observation with ID ${pIDObservation} from observation set with ID ${tmpSetID}: ${error}`);
					throw error;
				});
				this.pict.providers.ObservationSetProvider.saveSet(tmpSet);
				// invoke the custom observation set changed callback if registered (e.g. bridge defect photo count label update)
				if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged === 'function')
				{
					this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged(tmpInput, pIDObservation, tmpSet);
				}
				// invoke the document context callback if registered (e.g. orphan observation recalculation)
				if (typeof this.pict.AppData.ObservationCardDeckProvider.documentContextCallback === 'function')
				{
					this.pict.AppData.ObservationCardDeckProvider.documentContextCallback();
				}
			}
			else
			{
				// remove this observation from the document observation list (which will update if they save)
				this.pict.AppData.DocumentData.ReportData.Observations = this.pict.AppData.DocumentData.ReportData.Observations.filter((/** @type {any} */ obs) => obs.IDObservation != pIDObservation);
				this.pict.providers.MediaRegistry.refreshDocumentObservations(this.pict.AppData.DocumentData.ReportData.Observations);
			}
			// refresh the decks so they pick up the removed image in the document observation list update
			await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllDocumentLists', false);
			// also remarshal all observation-set-backed decks so the deck that just had the observation
			// removed (and any other decks showing the same set) reflect the change — without this,
			// useObservationSet decks (which are marked with data-deck-is-observation-set, not
			// data-deck-is-document-list) would never be re-rendered and the removed card would
			// remain visible in the UI
			await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllObservationSets', false);
		}
	}

	/**
	 * This will create a new Observation Set if one doesn't already exist for this input.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @return {Promise<*>}
	 */
	async createNewObservationSetForCardDeck(pViewHash, pInputHash)
	{
		return new Promise(async (resolve, reject) =>
		{
			this.pict.log.info('Creating a new Observation Set');

			const pView = this.pict.views[pViewHash];
			const pInput = pView.getInputFromHash(pInputHash);
			// make a new set if we don't have a value yet (should only be done the first time per form load)
			const tmpLabel = document.querySelector(this.getLabelHTMLID(pInput.Macro.RawHTMLID))['innerText'] || 'New Observation Set';
			const tmpName = tmpLabel + ' (' + new Date().toLocaleString() + ')';
			const tmpProjectId = this.pict.AppData?.DocumentData?.ReportData?.IDProject || null;
			// create a new observation set
			const tmpNewSet = this.pict.providers.ObservationSetProvider.createSet(tmpName, tmpProjectId);
			// and save the new set
			try
			{
				const pResult = await this.pict.providers.ObservationSetProvider.saveSet(tmpNewSet);
				// collect the new set ID and update the map
				this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID] = pResult.IDObservationSet;
				// set the IDObservationSet value for the hidden input so that it gets saved in the FormData and we can reference it later when adding observations to the set
				this.pict.ContentAssignment.assignContent(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID), pResult.IDObservationSet);
				// marshal the form to data so that it saves properly in the FormData
				pView.dataChanged(pInput.Hash);
				// if it's a document, we should auto-save the document now too
				if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument)
				{
					this.pict.providers.DocumentProvider.handleSave(true);
				}
				this.pict.log.info('New Observation Set created successfully. Created Set ID: ' + pResult.IDObservationSet);
				resolve(pResult);
			}
			catch (pError)
			{
				this.pict.log.error(`Error in createNewObservationSetForCardDeck: ${pError}`);
				resolve(false);
			}
		});
	}
}

module.exports = ObservationCardDeck;

},{"./../../../media-detail-cards/source/MediaCardBuilder.js":247,"pict-section-form":497}],91:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#OBSERVATIONTYPE-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Observation Type for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Observation Type record yet, get it and store it
			if (!this.pict.AppData.SelectedObservationType || this.pict.AppData.SelectedObservationType.length < 1)
			{
				const tmpResult = await this.pict.providers.ObservationTypeSelector._getObservationTypeByID(pValue);
				this.pict.AppData.SelectedObservationType = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedObservationType?.DisplayName);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],92:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @typedef {import('./PictProvider-Select2Util.js')} Select2UtilProvider */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/** @return {Select2UtilProvider} */
	get Select2Util()
	{
		return this.pict.providers.Select2Util;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#OBSERVATIONTYPE-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	async initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			// TODO:
			// 	This was copied from Observation-View-Search and is how the current panels search handles things.
			//	It currently returns 25 ObservationManifests for IDCustomer=0 (the first 25 rows of the table).
			//  It needs to be filtering by the user's IDCustomer, combining customer and project types, found in
			// 		ObservationManifests and ProjectObservationManifestJoin, respectively.
			// 	That combination is tricky, however, because ProjectObservationManifestJoin is not a true SQL join:
			//		there is no foreign key or reference to IDObservationManifest, only an ObservationManifestName.
			//		If we include ProjectObservationManifestJoin, what ID do we save when the user chooses those?
			//		Also, rows in ProjectObservationManifestJoin don't have matching rows in ObservationManifests.
			//			For example, IDCustomer=1 has many ProjectObservationManifestJoin rows, but no
			//			ObservationManifests rows.
			// 	To add Project types, we'll need a endpoint that puts together project + customer types,
			//		and there seems like there's going to be some work to make that possible.
			this.initializeSelect2Plugin({
				dropdownCssClass: 'theme-dark has-sticky-option',
				placeholder: 'Select an Observation Type...',
				ElementID: this.getSelectInputHTMLID(pInput.Macro.RawHTMLID).replace('#', ''),
				// ParentID: 'ObservationSearch-SearchEntry',
				URL: 'ObservationManifests',
				IDField: 'Name',
				TextField: 'DisplayName',
				StickyOption: { id: 'Legacy Image', text: 'Image' },
			}, () => null);
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			// dropdownParent: $('#' + pOptions.ParentID),
			// dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			// selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			allowClear: true,
			width: '100%',
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change.select2');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the ObservationType for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected ObservationType and set it as the selected ObservationType on the data object
			const tmpObservationType = await this._getObservationTypeByID(pValue);
			this.pict.AppData.SelectedObservationType = tmpObservationType;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedObservationType.IDObservationManifest;
			tmpOption.text = `${this.pict.AppData.SelectedObservationType.DisplayName || ('Unnamed Observation Type #' + this.pict.AppData.SelectedObservationType.IDSObservationType)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	async _getObservationTypeByID(pID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pID)
			{
				this.pict.log.error('No Observation Type ID provided.');
				return reject(new Error('No Observation Type ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`ObservationManifest/${pID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Observation Type: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	async _getProjectObservationManifestJoins(projectID)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`ProjectObservationManifestJoins/By/IDProject/${projectID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Project Observation Type Joins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],93:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.isValid = false;
	}

	/**
	 * Converts the number to a phone number format.
	 * @param {string} pValue - The markdown content.
	 * @return {string} - The HTML content.
	 */
	convertToPhoneNumber(pValue)
	{
		let tmpContent = '';
		const pattern = /^\(\d{3}\) \d{3}-\d{4}$/;
		if (pValue)
		{
			if (pattern.test(pValue))
			{
				tmpContent = pValue;
				this.isValid = true;
			}
			else
			{
				// strip out any non-numeric characters, including dashes and parenthesses
				const tmpPhoneNumber = pValue.replace(/\D/g, '');
				// be smart about the phone number format based on the length of the number
				if (tmpPhoneNumber.length === 7)
				{
					tmpContent = `${tmpPhoneNumber.substring(0, 3)}-${tmpPhoneNumber.substring(3, 7)}`;
					this.isValid = true;
				}
				else if (tmpPhoneNumber.length === 10)
				{
					tmpContent = `(${tmpPhoneNumber.substring(0, 3)}) ${tmpPhoneNumber.substring(3, 6)}-${tmpPhoneNumber.substring(6, 10)}`;
					this.isValid = true;
				}
				else if (tmpPhoneNumber.length === 11)
				{
					tmpContent = `+${tmpPhoneNumber.substring(0, 1)} (${tmpPhoneNumber.substring(1, 4)}) ${tmpPhoneNumber.substring(4, 7)}-${tmpPhoneNumber.substring(7, 11)}`;
					this.isValid = true;
				}
				else
				{
					tmpContent = pValue;
					this.isValid = false;
				}
			}
		}
		return tmpContent;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.convertToPhoneNumber(pValue);
		this.pict.ContentAssignment.assignContent('#' + pInput.Macro.RawHTMLID, tmpContent);
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, 0, this.isValid);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.convertToPhoneNumber(pValue);
		this.pict.ContentAssignment.assignContent(('#' + pInput.Macro.RawHTMLID + '-' + pRowIndex), tmpContent);
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, this.isValid);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],94:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.onChangeCallbacks = [];

		// add the ".is-hidden" class to the type selector by default
		this.pict.MetaTemplate.addPattern('{~ShowTypeSelector:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject?.PictForm?.InputExtra?.includes('Show Type Selector')) ? '' : 'is-hidden';
		});
	}

	getPhysicalAssetSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}-Asset`;
	}

	getAssetTypeSelectInput(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}-Type`;
	}

	getPhysicalAssetHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}-Asset`;
	}

	getAssetTypeHiddenInput(pInputHTMLID)
	{
		return `#${pInputHTMLID}-Type`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PHYSICALASSET-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PHYSICALASSET-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Adds an onChange callback to the input handler.
	 * @param {function} pCallback The callback function.
	 */
	addOnChangeCallback(pCallback)
	{
		if (!pCallback || typeof pCallback !== 'function')
		{
			this.pict.log.error('Invalid onChangeCallback provided.');
			return;
		}
		// check if the callback is already in the list
		if (this.onChangeCallbacks.indexOf(pCallback) > -1)
		{
			this.pict.log.warn('onChangeCallback already exists in the list.');
			return;
		}
		this.onChangeCallbacks.push(pCallback);
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.getElement(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
		this.pict.ContentAssignment.addClass(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
		this.pict.ContentAssignment.removeClass(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {number} pTypeFilter The state fitler string.
	 */
	initializeSelect2(pInput, pTypeFilter)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpAssetTypeSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('AssetType',
				{
					Input: pInput,
					SearchFields: [ 'AssetNumber', 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Select an Asset Type...',
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID)).select2(tmpAssetTypeSelectOptions);
			}

			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('PhysicalAsset',
				{
					Input: pInput,
					SearchFields: [ 'AssetNumber', 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: `Select a Physical Asset by name or code...`,
					HandleSearchFilters: (pFilters) =>
					{
						if (!pTypeFilter)
						{
							return pFilters;
						}
						pFilters.push(`FBV~IDAssetType~EQ~${pTypeFilter}`);

						return pFilters;
					},
					GetRecordUserFacingID: (pPhysicalasset) => pPhysicalasset.AssetNumber || 'N/A',
				});
			window['jQuery'](this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const assetHiddenInput = $(this.getPhysicalAssetHiddenInputHTMLID(rawHTMLID));
		const assetTypeHiddenInput = $(this.getAssetTypeHiddenInput(rawHTMLID));
		assetHiddenInput.attr('data-i-datum', `${pInput.DataAddress}.Asset`);
		assetTypeHiddenInput.attr('data-i-datum', `${pInput.DataAddress}.AssetType`);
		if (pInput.Default)
		{
			this.assetType = pInput.Default;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		if (this.assetType && !pValue.AssetType)
		{
			const assetTypes = await this.pict.providers.PhysicalAssetProvider.getPhysicalAssetTypeByName(this.pict.AppData?.CurrentUser?.CustomerID, this.assetType);
			if (assetTypes && assetTypes.length > 0)
			{
				pValue.AssetType = assetTypes[0].IDAssetType;
			}
		}

		const tmpAssetInputSelectElements = this.pict.ContentAssignment.getElement(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID));
		const tmpAssetInputAssetTypeSelectElements = this.pict.ContentAssignment.getElement(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID));
		if ((!tmpAssetInputSelectElements || tmpAssetInputSelectElements.length < 1) && (!tmpAssetInputAssetTypeSelectElements || tmpAssetInputAssetTypeSelectElements.length < 1))
		{
			return false;
		}

		await this.updateDataFields(pInput, pValue);

		// get the configuration for the current user to filter the Physicalasset search results (by State, etc.)
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.pict.AppData?.CurrentUser?.CustomerID, async (pConfig) =>
		{
			let assetType;
			if (Number.isNaN(parseInt(this.assetType)))
			{
				assetType = await this.pict.providers.PhysicalAssetProvider.getPhysicalAssetTypeByName(this.pict.AppData?.CurrentUser?.CustomerID, this.assetType);
			}
			else
			{
				assetType = this.assetType ? await this.pict.providers.PhysicalAssetProvider.getAssetTypeByID(this.assetType) : null;
			}
			this.initializeSelect2(pInput, assetType?.IDAssetType);
			this.removeLoadingSkeleton(pInput);
		});
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		let tmpInputSelectAssetValue = $(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID)).val();
		const tmpInputSelectAssetTypeValue = $(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID)).val();
		if (pValue.AssetType != tmpInputSelectAssetTypeValue)
		{
			tmpInputSelectAssetValue = '';
		}
		const tmpInputValues = {
			AssetType: tmpInputSelectAssetTypeValue,
			Asset: tmpInputSelectAssetValue,
		};
		this.pict.ContentAssignment.assignContent(this.getPhysicalAssetHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpInputSelectAssetValue.toString());
		this.pict.ContentAssignment.assignContent(this.getAssetTypeHiddenInput(pInput.Macro.RawHTMLID), tmpInputSelectAssetTypeValue.toString());
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputValues, pHTMLSelector);
	}

	async updateDataFields(pInput, pValue)
	{
		// if we have a value (ID), go fetch the Physicalasset for display (Name, etc.)
		if (pValue && (pValue.hasOwnProperty('Asset') || pValue.hasOwnProperty('AssetType')))
		{
			const assetType = pValue.AssetType;
			const asset = pValue.Asset;
			// get the value of the selected Physicalasset and set it as the selected Physicalasset on the data object
			const tmpPhysicalasset = asset ? await this.pict.providers.PhysicalAssetProvider.getPhysicalAssetByID(asset) : null;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			if (!tmpSelectElement)
			{
				return false;
			}

			if (tmpPhysicalasset?.IDAssetType == assetType)
			{
				tmpOption.value = tmpPhysicalasset.IDPhysicalAsset;
				tmpOption.text = `${tmpPhysicalasset.AssetNumber || 'N/A'}|~|${tmpPhysicalasset.Name || ('Unnamed Physicalasset #' + this.pict.AppData.SelectedPhysicalasset.IDPhysicalasset)}`;
				tmpOption.selected = true;
				tmpSelectElement.appendChild(tmpOption);
			}
			else
			{
				tmpOption.value = ``;
				tmpOption.text = ``;
				tmpOption.selected = true;
				tmpSelectElement.appendChild(tmpOption);
				this.pict.ContentAssignment.assignContent(this.getPhysicalAssetHiddenInputHTMLID(pInput.Macro.RawHTMLID), '');
			}

			// get the value of the selected Physicalasset and set it as the selected Physicalasset on the data object
			const tmpPhysicalAssetType = assetType ? await this.pict.providers.PhysicalAssetProvider.getAssetTypeByID(assetType) : null;
			// build the prefilled value for the select2 dropdown
			const tmpAssetTypeOption = document.createElement('option');
			const tmpAssetTypeSelectElement = this.pict.ContentAssignment.getElement(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID))[0];
			if (!tmpAssetTypeSelectElement)
			{
				tmpOption.value = ``;
				tmpOption.text = ``;
				tmpOption.selected = true;
				tmpSelectElement.appendChild(tmpOption);
				this.pict.ContentAssignment.assignContent(this.getAssetTypeHiddenInput(pInput.Macro.RawHTMLID), '');
			}
			else
			{
				tmpAssetTypeOption.value = tmpPhysicalAssetType.IDAssetType;
				tmpAssetTypeOption.text = `${tmpPhysicalAssetType.Name}`;
				tmpAssetTypeOption.selected = true;
				tmpAssetTypeSelectElement.appendChild(tmpAssetTypeOption);
			}

			this.assetType = assetType;
		}
		else
		{
			this.pict.log.info('No Physicalasset selected.');
		}
	}

	/**
	 * Handles the data change event for a select input in the PictProviderInputSelect class.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.onChangeCallbacks.length > 0)
		{
			this.onChangeCallbacks.forEach((pCallback) =>
			{
				pCallback(pView, pInput, pValue, pHTMLSelector);
			});
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],95:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

// The pict-section-form input-type adapter from pict-section-picker (host-agnostic). This Headlight
// subclass supplies the HOST-SPECIFIC context the module deliberately knows nothing about: project
// scoping for project-resident entities + the spec-set floor on the lab axis. It is the
// select2-free replacement for EntitySelectorMultiple — same Entity/Multiple descriptor config, but
// rendered by the pict-native picker.
const PictInputTypePicker = require('pict-section-picker/form').PictInputTypePicker;
// The values a descriptor's picker paints as "nothing selected" — handed to the widget via _resolveEmptyValues
// and used to keep `__Record` in step with what the control shows.
const libPickerEmptyValues = require('./_PickerEmptyValues.js');
// Reads by a non-simple identity share an in-flight request with any other selector reading the same row.
const libSharedEntityRead = require('./_SharedEntityRead.js');

// Headlight override CSS for the Picker — injected once (higher CSSMap priority than pict-section-picker's
// base `.pps` block so it wins, and the selectors out-specify the base rules regardless). Theme-aware via
// --bulma-*/--theme-color-* tokens (light + dark inherit for free). Three concerns:
//   1. Disabled parity (PictForm.Disabled) — a greyed, non-interactive box matching the sibling disabled
//      inputs, using the exact --bulma-input-disabled-* palette (headlight-styles/bulma-extended.scss):
//      borderless (the disabled border token equals the fill), light-gray fill, muted text/placeholder,
//      chevron hidden (a visible chevron on a disabled control was a Select2 quirk). Scoped to a
//      `data-disabled` host marker the broker sets per field, so it never restyles a genuine ReadOnly
//      picker (whose interactive widget also carries `.pps-readonly`); the dropdown stays hidden even
//      under a stray keyboard-open.
//   2. EntityTag pill (Edit theme) — the pill color follows SELECTION so selected items scan at a glance:
//      UNSELECTED dropdown options keep pict-section-picker's muted base `.pps-tag`; SELECTED options
//      (`.pps-option.pps-selected`) + the in-field chips (`.pps-chip`) / single value (`.pps-valuebox`)
//      get a solid brand pill with near-white text. A color transition is set for the fade, but note the
//      dropdown re-renders its option list on select, so the smooth toggle-fade only shows where the
//      element persists (a class-toggle in PSP `_renderList` would make it fully animate — publish-gated).
//      (Read/Print `.select2-*` pill keeps its own bulma-print look, unchanged.)
//   3. Blank-display fallback — a selection with no display text and no record ID to label it by (an entity
//      record with no name reads `Document #282` instead; see _labelBlankEntityOption) shows a faded marker
//      so a user/developer can spot it: Edit paints nothing into the text spans, so an :empty::after
//      supplies it; Read/Print paints the `.picker-display-empty` span (see PickerDisplay).
//   4. Placeholder color — align the picker's empty-state placeholder to Bulma's faded --bulma-input-
//      placeholder-color so it matches native inputs (PSP's default --theme-color-text-muted read darker).
//   5. Split-pill chip (Edit) — an in-field chip whose EntityTag leads is fused into ONE pill: the chip
//      drops its left/top/bottom padding and the leading `.pps-tag` fills the left flush + full-height
//      with squared right corners, so it reads as a single pill split in half (dark entity | light value).
//      Scoped via :has(> .pps-tag:first-child) so tagless chips + the dropdown options are untouched.
//   6. Addons flush (Bulma has-addons, e.g. the Sample template's search-panel button): Bulma squares the
//      touching corners of ITS controls (.input/.button/.select) only — the picker's .pps-control keeps
//      rounded corners against the addon button. Square the touching edge on both sides.
//   7. Validation state — InputValidation marks the field's `.control.control-status` wrapper is-danger /
//      is-success; Bulma only recolors native .input/.textarea from it, so the picker's .pps-control border
//      follows the same state (the Select2 twin is in headlight-styles bulma-control-status.scss).
//   8. Dark theme — pict-section-picker paints with --theme-color-* tokens and falls back to LIGHT literals
//      when they're undefined, which they are on form/report surfaces. Under Headlight's dark selectors
//      (headlight-styles bulma-dark.scss) the picker gets the surface/text/border tokens mapped onto Bulma's
//      theme variables. Light mode keeps PSP's literals, and brand-primary keeps HeadLight blue in both.
//   9. Solver background color — ColorInputBackground / ColorInputBackgroundTabular set an inline
//      background-color on the host (it carries the ControlAttr), which PSP's opaque .pps-control would hide;
//      the control inherits it instead, and goes back to its own fill once the inline color is cleared.
// Mapped as headlight-platform-configuration/css/headlight-theme.css maps them; keep the two in step.
const _PICKER_DARK_THEME_TOKENS = /*css*/`
	--theme-color-background-primary: var(--bulma-scheme-main);
	--theme-color-background-tertiary: var(--bulma-scheme-main-ter);
	--theme-color-background-panel: var(--bulma-scheme-main);
	--theme-color-text-primary: var(--bulma-text-strong);
	--theme-color-text-secondary: var(--bulma-text);
	--theme-color-text-muted: var(--bulma-text-weak);
	--theme-color-border-default: var(--bulma-border);
	--theme-color-border-light: var(--bulma-border-weak);
	--theme-color-border-strong: var(--bulma-border);
`;
const _HEADLIGHT_PICKER_OVERRIDES_CSS = /*css*/`
.pps-form-host[data-disabled="true"] { pointer-events: none; }
.pps-form-host[data-disabled="true"] .pps-control {
	background: var(--bulma-input-disabled-background-color);
	border-color: var(--bulma-input-disabled-border-color);
	box-shadow: none;
	color: var(--bulma-input-disabled-color);
	cursor: not-allowed;
}
.pps-form-host[data-disabled="true"] .pps-control:hover { border-color: var(--bulma-input-disabled-border-color); box-shadow: none; }
.pps-form-host[data-disabled="true"] .pps-value { color: var(--bulma-input-disabled-color); }
.pps-form-host[data-disabled="true"] .pps-value.pps-placeholder,
.pps-form-host[data-disabled="true"] .pps-chips-ph { color: var(--bulma-input-disabled-placeholder-color); }
.pps-form-host[data-disabled="true"] .pps-chevron { display: none; }
.pps-form-host[data-disabled="true"] .pps-pop,
.pps-form-host[data-disabled="true"] .pps-backdrop { display: none; }
.pps-tag { transition: background-color 0.15s ease, color 0.15s ease; }
.pps-chip .pps-tag,
.pps-valuebox .pps-tag,
.pps-option.pps-selected .pps-tag {
	background: var(--theme-color-brand-primary, #156dd1);
	color: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, #ffffff);
}
.pps-chip:has(> .pps-tag:first-child) { padding-top: 0; padding-bottom: 0; padding-left: 0; }
.pps-chip:has(> .pps-tag:first-child) > .pps-tag:first-child {
	align-self: stretch;
	padding: 0.2rem 0.45rem;
	border-radius: 6px 0 0 6px;
}
.pps-value:empty::after,
.pps-chip-text:empty::after,
.pps-option-label:empty::after { content: 'no text provided'; font-style: italic; opacity: 0.55; }
.picker-display-empty { font-style: italic; opacity: 0.55; }
.pps-value.pps-placeholder,
.pps-chips-ph { color: var(--bulma-input-placeholder-color, var(--bulma-text-weak)); }
.field.has-addons .control:not(:last-child) .pps-control {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.field.has-addons .control:not(:first-child) .pps-control {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}
.control.control-status.is-danger .pps-control { border-color: var(--bulma-danger); }
.control.control-status.is-success .pps-control { border-color: var(--bulma-success); }
.pps-form-host[style*="background-color"] > .pps,
.pps-form-host[style*="background-color"] .pps-control { background-color: inherit; }
[data-theme="dark"] .pps, [data-theme="dark"] .pps-pop,
.theme-dark .pps, .theme-dark .pps-pop {${_PICKER_DARK_THEME_TOKENS}}
@media (prefers-color-scheme: dark) {
	html:not([data-theme="light"]) .pps, html:not([data-theme="light"]) .pps-pop {${_PICKER_DARK_THEME_TOKENS}}
}
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Picker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

// R2 port-forward map for the specialized per-entity selectors (LabSelector, PlantSelector, …) —
// their Entity is provider-hardcoded, not in the descriptor. Shared with PictProvider-InputType-
// PickerDisplay so the Edit picker and the Read/Print display infer the entity identically.
const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');
const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');
const libEntityOptionSource = require('./_EntityOptionSource.js');
const libFilterToggleUI = require('./_FilterToggleUI.js');
const libLabRouting = require('./_LabRouting.js');
const libEntityDisplayName = require('./_EntityDisplayName.js');

// Spec-set floors — the SpecScopeResolver getter + FoxHound id-field per entity. Kept in lockstep
// with the MES's SPEC_SET_AXIS (defined in-broker to avoid coupling to the retiring MES module).
// Materials, tests and pay items narrow through their DynamicFilters entries; the lab axis is the
// one remaining set-membership floor.
const _SPEC_SET_AXIS =
{
	Lab: { getter: 'getAllowedLabIDs', field: 'IDLab' },
};

class PictProviderInputTypePicker extends PictInputTypePicker
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
		// Inherited fable-service member the duplicate-pict-provider type chain hides from tsc.
		/** @type {Record<string, any>} */
		this.options;
		// Host-app onChange subscriptions (the legacy per-selector addOnChangeCallback API — e.g. the
		// bridge depth-soundings view re-solves when its BridgeSelector field changes). One broker serves
		// every InputType, so each entry may carry an InputType filter.
		/** @type {Array<{Callback: Function, InputType: (string|null)}>} */
		this.onChangeCallbacks = [];
	}

	/**
	 * Subscribe to committed selections, ported from the legacy selector providers' addOnChangeCallback
	 * (BridgeSelector et al.). The callback receives (pView, pInput, pValue, pHTMLSelector). Because the
	 * Picker broker serves every InputType, pass pInputTypeFilter (e.g. 'BridgeSelector') to hear only
	 * that InputType's fields; omit it to hear every picker field.
	 * @param {Function} pCallback @param {string} [pInputTypeFilter]
	 */
	addOnChangeCallback(pCallback, pInputTypeFilter)
	{
		if (!pCallback || typeof pCallback !== 'function')
		{
			this.pict.log.error('Invalid onChangeCallback provided.');
			return;
		}
		// Lazy init: test harnesses build the provider via Object.create (no constructor run).
		if (!Array.isArray(this.onChangeCallbacks)) { this.onChangeCallbacks = []; }
		if (this.onChangeCallbacks.some((pEntry) => pEntry.Callback === pCallback))
		{
			this.pict.log.warn('onChangeCallback already exists in the list.');
			return;
		}
		this.onChangeCallbacks.push({ Callback: pCallback, InputType: pInputTypeFilter || null });
	}

	/** Fire any subscribed onChange callbacks whose InputType filter matches this input (legacy parity:
	 *  fired ahead of the rest of the change handling, args (pView, pInput, pValue, pHTMLSelector)). */
	_fireOnChangeCallbacks(pView, pInput, pValue, pHTMLSelector)
	{
		if (!Array.isArray(this.onChangeCallbacks) || this.onChangeCallbacks.length < 1) { return; }
		const tmpInputType = pInput?.PictForm?.InputType;
		this.onChangeCallbacks.forEach((pEntry) =>
		{
			if (pEntry.InputType && pEntry.InputType !== tmpInputType) { return; }
			try { pEntry.Callback(pView, pInput, pValue, pHTMLSelector); }
			catch (pError) { this.pict.log.error(`Picker onChangeCallback threw for [${pInput?.Hash}]:`, pError); }
		});
	}

	/**
	 * Map the EntitySelectorMultiple descriptor vocabulary onto the picker's, so migrating a schema is
	 * just an InputType change: IdentityField → ValueField, EntityDisplayField → TextField (+ search it).
	 *
	 * @param {Record<string, any>} pInput @param {string} pHostSelector @param {Function} fOnChange
	 * @return {Record<string, any>}
	 */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpConfig = super._buildPickerConfig(pInput, pHostSelector, fOnChange);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		// R2 port-forward: a specialized selector (LabSelector, PlantSelector, …) hardcodes its Entity and display
		// config in its legacy provider. Infer them from the InputType BEFORE the generic (non-entity) Select
		// fallback below, which would otherwise treat an entity-less descriptor as a static option list. A
		// descriptor naming the same Entity still gets the map's config (legacy ignored the descriptor's Entity);
		// display config the descriptor sets itself wins. See _SPECIALIZED_SELECTOR_MAP.
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType];
		if (tmpSpecialized && (!tmpConfig.Entity || tmpConfig.Entity === tmpSpecialized.Entity))
		{
			tmpConfig.Entity = tmpSpecialized.Entity;
			if (!tmpConfig.TextField && !tmpPictForm.EntityDisplayField && tmpSpecialized.TextField) { tmpConfig.TextField = tmpSpecialized.TextField; }
			if (!tmpConfig.SearchFields && Array.isArray(tmpSpecialized.SearchFields)) { tmpConfig.SearchFields = tmpSpecialized.SearchFields.slice(); }
			if (!tmpConfig.EntityTag && tmpSpecialized.EntityTag) { tmpConfig.EntityTag = tmpSpecialized.EntityTag; }
		}
		// The config map's placeholder applies whenever the descriptor sets none, Entity or not (legacy parity).
		// Test the descriptor: PSP's adapter always pre-fills a default Placeholder.
		if (!tmpPictForm.Placeholder && tmpSpecialized?.Placeholder) { tmpConfig.Placeholder = tmpSpecialized.Placeholder; }
		if (!tmpConfig.ValueField && tmpPictForm.IdentityField) { tmpConfig.ValueField = tmpPictForm.IdentityField; }
		if (!tmpConfig.TextField && tmpPictForm.EntityDisplayField) { tmpConfig.TextField = tmpPictForm.EntityDisplayField; }
		if (!tmpConfig.SearchFields && tmpConfig.TextField) { tmpConfig.SearchFields = [ tmpConfig.TextField ]; }
		// Composed, disambiguated display for User pickers — mirror the recordset entity-filter "list entry"
		// (name + email/login) so a FORM's assignee / created-by picker reads the same as the list filters,
		// instead of one ambiguous field. Applies to every app's User pickers; a schema can override by
		// setting its own PictForm.TextTemplate. (The per-entity template should eventually live on Stricture.)
		if (tmpConfig.Entity === 'User' && !tmpConfig.TextTemplate)
		{
			this._registerUserListEntryTemplates();
			tmpConfig.TextTemplate = '{~DWTF:Record.NameFull:HL-EntityListEntry-User-NameParts~} ({~DWTF:Record.Email:HL-EntityListEntry-User-Login~})';
			// Make the disambiguators searchable too (so you can type an email/login, not just a name).
			if (!tmpPictForm.SearchFields)
			{
				tmpConfig.SearchFields = [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ];
			}
		}

		// A–Z like legacy: every select2 entity selector sorted by its label (Select2Util `FSF~<field>~ASC~0`).
		// PictForm.Sort (else the config map's Sort) names another field or `false` opts out; a dotted label path cannot be sorted server-side.
		if (tmpConfig.Entity && tmpConfig.Sort === undefined)
		{
			let tmpSortField = tmpPictForm.Sort;
			if (tmpSortField === undefined && tmpSpecialized && (tmpConfig.Entity === tmpSpecialized.Entity))
			{
				tmpSortField = tmpSpecialized.Sort;
			}
			if (tmpSortField === undefined) { tmpSortField = tmpConfig.TextField || ((tmpConfig.Entity === 'User') ? 'NameFirst' : 'Name'); }
			if (tmpSortField && !String(tmpSortField).includes('.')) { tmpConfig.Sort = tmpSortField; }
		}

		// Generic (non-entity) Select path — map the legacy SelectOptions / SelectOptionsPickList
		// vocabulary onto the picker so a Select / Option / Select2 / Select2Multiple field migrates to
		// InputType 'Picker' with no data edits. Skipped when an Entity (server path) or a native
		// Options array is already in play.
		if (!tmpConfig.Entity && (!Array.isArray(tmpConfig.Options) || tmpConfig.Options.length === 0))
		{
			this._applyGenericSelectSource(tmpConfig, pInput);
		}
		// Hide the search box on short STATIC option lists (<= 3 items) — a Yes/No/Maybe or Left/Center/Right
		// picker doesn't need one. Only when the descriptor didn't set Searchable explicitly, and only for the
		// resolved static Options path (entity pickers + dynamic picklists always server-search, so leave those).
		// AllowCustomValues keeps it too: the search box is the only place to type a new value.
		if (!tmpConfig.Entity && !tmpConfig.DataProvider && tmpPictForm.Searchable === undefined && !tmpPictForm.AllowCustomValues && Array.isArray(tmpConfig.Options))
		{
			tmpConfig.Searchable = (tmpConfig.Options.length > 3);
		}
		// AllowCustomValues (select2 `tags`) → the picker's creatable OnCreate: a typed value matching
		// no option becomes a "Create <term>" row committing the raw string as both value and label.
		if (tmpPictForm.AllowCustomValues && !tmpConfig.OnCreate)
		{
			tmpConfig.OnCreate = (pTerm) => ({ Value: pTerm, Text: pTerm });
		}
		this._applyFacetCreate(tmpConfig, pInput);
		this._applyCustomValueMemory(tmpConfig, pInput);
		if (this._isMultiplePicker(tmpPictForm))
		{
			tmpConfig.Mode = 'multi';
		}
		// Clearable parity (found live on the B1 fixture): every legacy select2 path defaulted
		// allowClear TRUE (Select2Util `?? true`, generic Select unconditional), but neither PSP's
		// form adapter nor this broker mapped it — so a migrated single picker had NO user-facing
		// clear (writing '' became unreachable, an MVP-rule functional loss). Same default + same
		// descriptor override (PictForm.AllowClear: false). PSP applies it in single mode only
		// (multi clears chip-by-chip, as before).
		if (tmpConfig.AllowClear === undefined)
		{
			// The config map's AllowClear sits between the two (legacy BridgeSelector was never clearable).
			tmpConfig.AllowClear = tmpPictForm.AllowClear ?? tmpSpecialized?.AllowClear ?? true;
		}
		// Tabular: thread the row context into the per-row BaseFilter closure (plan §5.3). The tabular mount
		// override stashes { pView, pRowIndex } transiently around this build (see _withTabularContext), so
		// capture them here — once per row, at build time — and each row's search then narrows by its OWN
		// FromRowField / per-row Show-All. Non-tabular keeps super's row-less BaseFilter (pRowIndex null → the
		// engine's per-row paths no-op, exactly as before).
		const tmpTabCtx = this._activeTabularContext;
		if (tmpTabCtx && tmpTabCtx.pRowIndex != null)
		{
			const tmpRowIndex = tmpTabCtx.pRowIndex;
			const tmpRowView = tmpTabCtx.pView;
			tmpConfig.BaseFilter = () => this.getContextualSearchFilters(pInput, tmpRowIndex, tmpRowView);
		}
		// Legacy ProjectSelector pinned the document's own project to the top of its list (GetPinnedItem).
		if (tmpPictForm.InputType === 'ProjectSelector' && !tmpConfig.PriorityValues)
		{
			const tmpDocumentProjectID = this._getDocumentProjectID();
			if (tmpDocumentProjectID) { tmpConfig.PriorityValues = [ tmpDocumentProjectID ]; }
		}
		// Pin-to-top for lab pickers: float the project's own labs above the rest of the first browse page
		// without removing anything. PSP resolves this once per data-provider closure, which createEntityPicker
		// rebuilds on every marshal-driven re-mount — so a changed anchor (a new parent lab, a new test) is
		// picked up on the next marshal rather than sticking for the session.
		this._applyLabPriorityValues(tmpConfig, pInput, tmpTabCtx);
		this._applyEmptyListLabel(tmpConfig, pInput, tmpTabCtx);
		// Minimum-search-length parity: legacy select2 gated searches at `MinimumInputLengthForSearch`
		// (per-input, with a HeadlightPanels global fallback; Select2Util `?? ?? 0`). Only set it when
		// non-zero so the PSP default (0 = always query) stands for the common case.
		const tmpMinSearch = tmpPictForm.MinimumInputLengthForSearch ??
			this.pict.views?.HeadlightPanels?.MinimumInputLengthForSearch ??
			0;
		if (tmpMinSearch)
		{
			tmpConfig.MinimumSearchLength = tmpMinSearch;
		}
		// PSP's default ResolveValue reads `<Entity>/<value>`, which finds a record by its numeric id only, so a
		// value committed under another identity (GUIDSample, a Test Hash) would paint as its raw value.
		const tmpIdentity = tmpConfig.Entity ? this._getRecordIdentity(pInput) : null;
		if (tmpIdentity && (tmpIdentity !== `ID${tmpConfig.Entity}`) && (typeof tmpConfig.ResolveValue !== 'function'))
		{
			const tmpResolveView = tmpTabCtx ? tmpTabCtx.pView : null;
			const tmpResolveRow = (tmpTabCtx && tmpTabCtx.pRowIndex != null) ? tmpTabCtx.pRowIndex : null;
			tmpConfig.ResolveValue = (pValue) => this._resolveIdentityOption(tmpConfig, pInput, tmpIdentity, tmpResolveView, tmpResolveRow, pValue);
		}
		// Not a pict-section-picker option: _presentEntityOption labels a nameless record with it.
		if (tmpConfig.Entity && pInput && pInput.Name)
		{
			tmpConfig.FieldLabel = pInput.Name;
		}
		return tmpConfig;
	}

	/**
	 * Label a held value whose record identity is not the numeric `ID<Entity>`: from the `__Record` the form
	 * already holds when it matches, else read by identity — the order PickerDisplay resolves the same value in.
	 * Composed by pict-section-picker's own option builder, so the label matches the value's dropdown row.
	 *
	 * @param {Record<string, any>} pConfig - the picker config (Entity, TextField, EntityTag, join settings).
	 * @param {Record<string, any>} pInput @param {string} pIdentityField
	 * @param {Object|null} pView - the form view, when the picker was mounted by one.
	 * @param {number|string|null} pRowIndex @param {any} pValue
	 * @return {Promise<Record<string, any>|null>} the option `{ Value, Text, Record[, Tag][, Tags] }`, or null.
	 */
	_resolveIdentityOption(pConfig, pInput, pIdentityField, pView, pRowIndex, pValue)
	{
		const tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (pValue === undefined || pValue === null || pValue === '' || !tmpProvider || (typeof tmpProvider._composeOption !== 'function'))
		{
			return Promise.resolve(null);
		}
		const tmpHeld = this._findHeldRecord(pView, pInput, pIdentityField, pValue, pRowIndex);
		const tmpLookup = tmpHeld ? Promise.resolve(Object.assign({}, tmpHeld)) : this._resolveEntityRecordByIdentity(pConfig.Entity, pIdentityField, pValue);
		const tmpJoinConfig = tmpProvider._resolveJoinConfig(pConfig);
		return tmpLookup
			.then((pRecord) =>
			{
				if (!pRecord)
				{
					return null;
				}
				const tmpFK = tmpJoinConfig ? pRecord[tmpJoinConfig.FKColumn] : null;
				if (tmpFK === undefined || tmpFK === null || tmpFK === '')
				{
					return pRecord;
				}
				return new Promise((resolve) =>
				{
					this.pict.EntityProvider.getEntity(tmpJoinConfig.Entity, tmpFK, (pJoinError, pJoinRecord) =>
					{
						if (!pJoinError && pJoinRecord)
						{
							pRecord.JoinRecord = pJoinRecord;
							pRecord.JoinName = pJoinRecord[tmpJoinConfig.DisplayField];
						}
						resolve(pRecord);
					});
				});
			})
			.then((pRecord) => (pRecord ? tmpProvider._composeOption(pRecord, pIdentityField, pConfig.TextField || 'Name', tmpJoinConfig,
				pConfig.EntityTag || false, pConfig.TextTemplate || false, Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false) : null))
			.catch((pError) =>
			{
				this.pict.log.warn(`Picker [${pConfig.Entity}]: could not label [${pValue}]: ${pError?.message || pError}`);
				return null;
			});
	}

	/**
	 * The held `__Record` (or, for a multi picker, the held record in its array) whose identity is pValue.
	 * @param {Object|null} pView @param {Record<string, any>} pInput @param {string} pIdentityField @param {any} pValue
	 * @param {number|string|null} pRowIndex
	 * @return {Record<string, any>|null}
	 */
	_findHeldRecord(pView, pInput, pIdentityField, pValue, pRowIndex)
	{
		if (!pView || (typeof pView.getMarshalDestinationObject !== 'function'))
		{
			return null;
		}
		const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		const tmpCandidates = Array.isArray(tmpHeld) ? tmpHeld : [ tmpHeld ];
		return tmpCandidates.find((pRecord) => pRecord && (typeof pRecord === 'object') && (pRecord[pIdentityField] == pValue)) || null;
	}

	/**
	 * Install the lab pin-to-top resolver on a picker config, when the descriptor scopes by `LabScope` and the
	 * LabScopeResolver is registered. The resolver answers with the labs belonging to the project (its district
	 * lab, its unit lab — whatever the manifest's `LabAffinity` rules name), in rule order. Empty when the form
	 * configures no affinity, which leaves the picker exactly as it was.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @param {{pView: Object, pRowIndex: number|string}|null} [pTabularContext] - the row context when tabular.
	 */
	_applyLabPriorityValues(pConfig, pInput, pTabularContext)
	{
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		const tmpResolver = this.pict.providers.LabScopeResolver;
		if (!tmpEngine || !tmpResolver || pConfig.PriorityValues)
		{
			return;
		}
		const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpFilters))
		{
			return;
		}
		const tmpFilter = tmpFilters.find((pEntry) => pEntry && pEntry.LabScope);
		if (!tmpFilter)
		{
			return;
		}
		const tmpRowIndex = (pTabularContext && pTabularContext.pRowIndex != null) ? pTabularContext.pRowIndex : null;
		const tmpRowView = (pTabularContext && pTabularContext.pView) ? pTabularContext.pView : null;
		pConfig.PriorityValues = () =>
		{
			return tmpResolver.getPreferredLabIDs(tmpFilter.LabScope,
				{
					IDTest: tmpEngine._readLabScopeTestID(tmpFilter, pInput, tmpRowIndex, tmpRowView),
					SelectedLabIDs: libLabRouting.collectSelectedTestLabIDs(this.pict),
				});
		};
	}

	/**
	 * Run a tabular mount with { pView, pRowIndex } stashed on the instance so the synchronous
	 * _buildPickerConfig call inside it can capture the row into the per-row BaseFilter closure (plan §5.3).
	 * Mounts are synchronous and one-row-at-a-time, so a transient instance field is race-free; restored in
	 * a finally (nesting-safe) so a single (non-tabular) mount never sees a stale row. The mounted value
	 * rides along for _applyCustomValueMemory.
	 * @param {Object} pView @param {number|string} pRowIndex @param {Function} fCallback @param {any} [pValue] @return {any}
	 */
	_withTabularContext(pView, pRowIndex, fCallback, pValue)
	{
		const tmpPrior = this._activeTabularContext || null;
		this._activeTabularContext = { pView, pRowIndex, pValue };
		try { return fCallback(); }
		finally { this._activeTabularContext = tmpPrior; }
	}

	/**
	 * Whether this picker is multi-select — the single rule both the widget Mode and the `__Record`
	 * payload shape (array vs object) resolve from, so the two can't disagree.
	 *
	 * Port-forwarded legacy multi InputTypes infer it from their NAME: `Select2Multiple` (multi keyed off
	 * the InputType name in the Select provider) and `EntitySelectorMultiple` (whose provider hardcoded
	 * Multiple: true) carry no `PictForm.Multiple` flag; their templates render via the Picker but keep
	 * the original InputType, so a field needs no manifest edit to stay multi.
	 *
	 * @param {Record<string, any>} pPictForm @return {boolean}
	 */
	_isMultiplePicker(pPictForm)
	{
		if (!pPictForm) { return false; }
		return !!pPictForm.Multiple || pPictForm.InputType === 'Select2Multiple' || pPictForm.InputType === 'EntitySelectorMultiple';
	}

	/**
	 * Mount the picker view, then route an entity picker's search results and its saved-value resolve
	 * through _presentEntityOption, so a record with no name reads `Document #282` in the dropdown, in the
	 * chip a pick leaves, and when a saved form reloads. createPicker re-assigns a fresh DataProvider and
	 * ResolveValue on every mount, so the wrap is re-applied each time rather than stacked.
	 *
	 * @param {string} pPickerHash @param {Record<string, any>} pConfig @return {any} The picker view.
	 */
	_instantiatePicker(pPickerHash, pConfig)
	{
		const tmpView = super._instantiatePicker(pPickerHash, pConfig);
		if (!tmpView?.options || !pConfig?.Entity)
		{
			return tmpView;
		}
		const fLabel = (pOption) => this._presentEntityOption(pOption, pConfig);
		const fDataProvider = tmpView.options.DataProvider;
		if (typeof fDataProvider === 'function')
		{
			tmpView.options.DataProvider = (pSearchTerm, pPage) => Promise.resolve(fDataProvider(pSearchTerm, pPage)).then((pResult) =>
			{
				if (!pResult || !Array.isArray(pResult.results))
				{
					return pResult;
				}
				return Object.assign({}, pResult, { results: pResult.results.map(fLabel) });
			});
		}
		const fResolveValue = tmpView.options.ResolveValue;
		if (typeof fResolveValue === 'function')
		{
			tmpView.options.ResolveValue = (pValue) => Promise.resolve(fResolveValue(pValue)).then(fLabel);
		}
		return tmpView;
	}

	/**
	 * An entity option as this picker shows it in the dropdown, in the chip a pick leaves and when a saved value
	 * reloads: a blank label reads `<entity label> #<record ID>` (_labelBlankEntityOption).
	 *
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {Record<string, any>} pConfig - the picker config.
	 * @return {Record<string, any>} The option, or a copy of it.
	 */
	_presentEntityOption(pOption, pConfig)
	{
		return this._labelBlankEntityOption(pOption, pConfig.Entity, pConfig.FieldLabel);
	}

	/**
	 * An entity option whose label is blank takes `<entity label> #<record ID>` as its label (`Document #282`,
	 * `Contractor #3456`), the same text PickerDisplay paints for it in Read/Print. A tag of its own is kept.
	 *
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {string} pEntity - the picker's entity, naming the record's ID column.
	 * @param {string} [pFieldLabel] - the field's label, which names an Organization's role.
	 * @return {Record<string, any>} The option, or a labelled copy of it.
	 */
	_labelBlankEntityOption(pOption, pEntity, pFieldLabel)
	{
		if (!pOption || (typeof pOption !== 'object'))
		{
			return pOption;
		}
		const tmpText = (pOption.Text === undefined || pOption.Text === null) ? '' : String(pOption.Text);
		if (tmpText.trim() !== '')
		{
			return pOption;
		}
		const tmpRecordID = pOption.Record ? pOption.Record[`ID${pEntity}`] : undefined;
		const tmpID = (tmpRecordID === undefined || tmpRecordID === null || tmpRecordID === '') ? pOption.Value : tmpRecordID;
		const tmpLabel = libEntityDisplayName.unnamedEntityLabel(pEntity, tmpID, pFieldLabel);
		if (tmpLabel === '')
		{
			return pOption;
		}
		return Object.assign({}, pOption, { Text: tmpLabel });
	}

	/**
	 * Source a picker from a managed code-list vocabulary (`_VocabularySelectorMap` — SampleStatus and
	 * friends). The referencing record persists the vocabulary's CODE, and the table is small enough to
	 * read whole, so this wires a local-filtering DataProvider over the loaded rows rather than the
	 * remote-search entity path. Both the descriptor's own `SelectOptionsEntity` and a
	 * vocabulary-mapped InputType route here; a customer with no rows (or a failed read) falls back to
	 * the static `PictForm.SelectOptions` the map installs, matching the legacy Select-family provider.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {boolean} - True when this picker is vocabulary-backed and the source was installed.
	 */
	_applyVocabularySource(pConfig, pInput)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (!tmpPictForm.SelectOptionsEntity)
		{
			return false;
		}
		const tmpPageSize = tmpPictForm.PageSize || 100;
		const fLoad = () => libEntityOptionSource.resolveOptionsAsync(this, pInput);
		pConfig.DataProvider = (pSearchTerm, pPage) =>
		{
			const tmpPage = pPage || 1;
			return fLoad().then((pOptions) =>
			{
				const tmpTerm = String(pSearchTerm || '').toLowerCase();
				const tmpMatches = tmpTerm ?
					pOptions.filter((pOption) => String(pOption.text || '').toLowerCase().includes(tmpTerm) || String(pOption.id || '').toLowerCase().includes(tmpTerm)) :
					pOptions;
				const tmpStart = (tmpPage - 1) * tmpPageSize;
				return {
					results: tmpMatches.slice(tmpStart, tmpStart + tmpPageSize).map((pOption) => ({ Value: pOption.id, Text: pOption.text })),
					hasMore: (tmpStart + tmpPageSize) < tmpMatches.length,
				};
			});
		};
		// A code retired from the managed list still has to render on an existing record, so an
		// unresolved value labels as its own code rather than blank.
		pConfig.ResolveValue = (pValue) => fLoad().then((pOptions) =>
		{
			const tmpMatch = pOptions.find((pOption) => pOption.id === pValue);
			return tmpMatch ?
				{ Value: tmpMatch.id, Text: tmpMatch.text } :
				{ Value: pValue, Text: (pValue === null || pValue === undefined) ? '' : String(pValue) };
		});
		return true;
	}

	/**
	 * Source a non-entity picker's options from the legacy Select descriptor vocabulary, so a
	 * Select / Option / Select2 / Select2Multiple field becomes InputType 'Picker' with no data edits.
	 * Mirrors PictProvider-InputType-Select: a static `PictForm.SelectOptions` array, a precomputed
	 * `SelectOptionsPickList` (DynamicMetaLists.getList), or a Dynamic picklist (paged + filtered via a
	 * DataProvider, exactly as the select2 dynamicLocalPaginationAdapter did). The Select provider's
	 * `{ id, text }` option shape is mapped to the picker's `{ Value, Text }`.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {void}
	 */
	_applyGenericSelectSource(pConfig, pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpToOption = (pItem) => ({ Value: pItem.id, Text: pItem.text });
		if (this._applyVocabularySource(pConfig, pInput))
		{
			return;
		}
		const tmpPickList = tmpPictForm.SelectOptionsPickList;
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if (tmpPickList && tmpMetaLists)
		{
			const fPickListDataProvider = this._createDynamicPickListDataProvider(pInput);
			if (fPickListDataProvider)
			{
				pConfig.DataProvider = fPickListDataProvider;
				return;
			}
			// Precomputed picklist: resolve the full list into static Options. The config is rebuilt on every
			// marshal-driven re-mount, so a Facet rule narrows it by the rest of the row after each solve.
			if (typeof tmpMetaLists.hasList === 'function' && tmpMetaLists.hasList(tmpPickList))
			{
				pConfig.Options = this._applyFacetRules(pInput, tmpMetaLists.getList(tmpPickList) || []).map(tmpToOption);
				return;
			}
		}
		// Static inline options.
		if (Array.isArray(tmpPictForm.SelectOptions))
		{
			pConfig.Options = tmpPictForm.SelectOptions.map(tmpToOption);
		}
	}

	/**
	 * A DataProvider over the input's Dynamic `SelectOptionsPickList`: page + filter through getList on every search
	 * (startIndex / maxResults / filterString / searchFields), matching the old select2 dynamicLocalPaginationAdapter.
	 * The list's `{ id, text }` rows map to the picker's `{ Value, Text }`.
	 *
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {((pSearchTerm: string, pPage: number) => Promise<Record<string, any>>)|null} null when the input names no Dynamic picklist.
	 */
	_createDynamicPickListDataProvider(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpPickList = tmpPictForm.SelectOptionsPickList;
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if (!tmpPickList || !tmpMetaLists || !tmpMetaLists.listDefinitions || !tmpMetaLists.listDefinitions[tmpPickList] || !tmpMetaLists.listDefinitions[tmpPickList].Dynamic)
		{
			return null;
		}
		const tmpPageSize = tmpPictForm.PageSize || 100;
		const tmpSearchFields = String(tmpPictForm.DistillingDisplay || '').split(',').map((pField) => pField.trim()).filter((pField) => pField !== '');
		return (pSearchTerm, pPage) =>
		{
			const tmpPage = pPage || 1;
			const tmpRows = tmpMetaLists.getList(tmpPickList,
				{
					startIndex: (tmpPage - 1) * tmpPageSize,
					maxResults: tmpPageSize,
					filterString: String(pSearchTerm || '').toLowerCase(),
					searchFields: tmpSearchFields,
				}) || [];
			return Promise.resolve({ results: tmpRows.map((pItem) => ({ Value: pItem.id, Text: pItem.text })), hasMore: tmpRows.length >= tmpPageSize });
		};
	}

	/**
	 * Narrow a picklist by the input's pict-section-form Facet ListFilterRules (sibling values in the same
	 * tabular row, or the same view outside a table). Inputs without a Facet rule are returned unchanged:
	 * the picker has never applied ListFilterRules, so other rule types stay dormant rather than changing
	 * existing forms.
	 *
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @param {Array<{ id: string, text: string }>} pList - the picklist entries.
	 * @return {Array<{ id: string, text: string }>}
	 */
	_applyFacetRules(pInput, pList)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpContext = this._activeTabularContext;
		if (!tmpDistilling || (typeof tmpDistilling.getFacetRule !== 'function') || !tmpDistilling.getFacetRule(pInput) || !tmpContext || !tmpContext.pView)
		{
			return pList;
		}
		return tmpDistilling.filterList(tmpContext.pView, pInput, pList, (tmpContext.pRowIndex == null) ? undefined : tmpContext.pRowIndex);
	}

	/**
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {Record<string, any>|null} the input's pict-section-form Facet rule, if it has one.
	 */
	_getFacetRule(pInput)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		if (!tmpDistilling || (typeof tmpDistilling.getFacetRule !== 'function'))
		{
			return null;
		}
		return tmpDistilling.getFacetRule(pInput);
	}

	/**
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {boolean} whether the input has a Facet rule and the Pict-Input-FacetFilter provider, which clears its
	 * value when a sibling change leaves it invalid (unless the rule sets ClearInvalid false).
	 */
	_isClearedByFacetFilter(pInput)
	{
		const tmpRule = this._getFacetRule(pInput);
		const tmpProviders = (pInput && pInput.PictForm && Array.isArray(pInput.PictForm.Providers)) ? pInput.PictForm.Providers : [];
		return !!tmpRule && (tmpRule.ClearInvalid !== false) && tmpProviders.includes('Pict-Input-FacetFilter');
	}

	/**
	 * On a Facet input that allows custom values and reads a global join list (JoinListAddressGlobal),
	 * "Create <term>" first adds a provisional record to that join list (see _addProvisionalFacetRecord), so
	 * FacetFilter treats the new value as consistent with its siblings when it commits. When no record can be
	 * added the cleaned, re-cased term commits as a plain custom value. A join list in form data is never
	 * written, since the form data is saved with the document.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {void}
	 */
	_applyFacetCreate(pConfig, pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpContext = this._activeTabularContext;
		if (!tmpPictForm.AllowCustomValues || pConfig.Entity || pConfig.DataProvider || (typeof pConfig.OnCreate !== 'function'))
		{
			return;
		}
		const tmpRule = this._getFacetRule(pInput);
		if (!tmpRule || !tmpRule.JoinListAddressGlobal || !tmpContext || !tmpContext.pView)
		{
			return;
		}
		const tmpView = tmpContext.pView;
		const tmpRowIndex = (tmpContext.pRowIndex == null) ? undefined : tmpContext.pRowIndex;
		const fCreate = pConfig.OnCreate;
		pConfig.OnCreate = (pTerm) =>
		{
			const tmpValue = this._addProvisionalFacetRecord(tmpView, pInput, tmpRowIndex, pTerm);
			return fCreate((tmpValue === null) ? pTerm : tmpValue);
		};
	}

	/**
	 * Add a provisional record for a value typed into a Facet input: the constraining siblings' values (the
	 * preceding ones under NarrowBy Preceding, every other one otherwise; '' when empty), the rule's static
	 * Facets values (a literal Value compared with EQ), the term at the input's own JoinListValueAddress, and
	 * `Provisional: true`. A sibling value the join list does not hold is written as it stands, so FacetFilter
	 * keeps it. The term is trimmed, its whitespace collapsed, and re-cased to a spelling the join list already
	 * holds at that address, whether or not a record is added. The pick lists built from the join list are then
	 * rebuilt. Nothing is added when a record already agrees with the non-empty values, or when the rule reads no
	 * global join list.
	 *
	 * @param {Object} pView - the view the input is in.
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @param {number|string|undefined} pRowIndex - the tabular row, undefined outside a table.
	 * @param {any} pTerm - the typed term.
	 * @return {string|null} the value to commit, or null when the input reads no global join list.
	 */
	_addProvisionalFacetRecord(pView, pInput, pRowIndex, pTerm)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpRule = this._getFacetRule(pInput);
		const fClean = (pValue) => String(pValue ?? '').trim().replace(/\s+/g, ' ');
		const tmpTerm = fClean(pTerm);
		if (!tmpRule || !tmpRule.JoinListValueAddress || (tmpTerm === ''))
		{
			return null;
		}
		const tmpJoinList = this._getWritableFacetJoinList(pView, tmpRule, false);
		if (!tmpJoinList)
		{
			return null;
		}
		const tmpManifest = this.pict.manifest;
		const fValueAt = (pRecord, pAddress) => tmpManifest.getValueAtAddress(pRecord, pAddress);
		const tmpLowerTerm = tmpTerm.toLowerCase();
		const tmpSameSpelling = tmpJoinList.find((pRecord) =>
		{
			const tmpExisting = fValueAt(pRecord, tmpRule.JoinListValueAddress);
			return !tmpDistilling.isEmptyFacetValue(tmpExisting) && (fClean(tmpExisting).toLowerCase() === tmpLowerTerm);
		});
		const tmpValue = tmpSameSpelling ? String(fValueAt(tmpSameSpelling, tmpRule.JoinListValueAddress)) : tmpTerm;
		const tmpSiblings = tmpDistilling.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpOwnIndex = tmpSiblings.findIndex((pSibling) => pSibling.Input === pInput);
		// Same constraining-sibling rule as ListDistilling.getFacetMatchingRecords.
		const tmpPrecedingOnly = (tmpRule.NarrowBy === 'Preceding') && (tmpOwnIndex >= 0);
		const tmpParents = tmpSiblings.filter((pSibling, pIndex) => (pSibling.Input !== pInput) && !(tmpPrecedingOnly && (pIndex > tmpOwnIndex)));
		const tmpStaticParts = this._getStaticFacetParts(tmpRule);
		const tmpParentParts = tmpParents.map((pParent) => ({ Address: pParent.Rule.JoinListValueAddress, Value: tmpDistilling.isEmptyFacetValue(pParent.Value) ? '' : pParent.Value }));
		const tmpOwnPart = { Address: tmpRule.JoinListValueAddress, Value: tmpValue };
		const tmpConstraints = tmpStaticParts.concat(tmpParentParts.filter((pPart) => pPart.Value !== ''), [ tmpOwnPart ]);
		const tmpCovered = tmpJoinList.some((pRecord) => tmpConstraints.every((pPart) =>
		{
			const tmpExisting = fValueAt(pRecord, pPart.Address);
			return String(tmpDistilling.isEmptyFacetValue(tmpExisting) ? '' : tmpExisting) === String(pPart.Value);
		}));
		if (tmpCovered)
		{
			return tmpValue;
		}
		const tmpTarget = this._getWritableFacetJoinList(pView, tmpRule, true);
		if (!tmpTarget)
		{
			return tmpValue;
		}
		const tmpRecord = {};
		tmpStaticParts.concat(tmpParentParts, [ tmpOwnPart ]).forEach((pPart) => tmpManifest.setValueAtAddress(tmpRecord, pPart.Address, pPart.Value));
		tmpRecord.Provisional = true;
		tmpTarget.push(tmpRecord);
		this._rebuildPickListsFromSource(tmpRule.JoinListAddress);
		return tmpValue;
	}

	/**
	 * A Facet rule's static constraints: Facets entries with a literal Value (no ValueAddress) compared with EQ.
	 * @param {Record<string, any>} pRule - the input's Facet rule.
	 * @return {Array<{ Address: string, Value: any }>}
	 */
	_getStaticFacetParts(pRule)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpFacets = Array.isArray(pRule.Facets) ? pRule.Facets : [];
		// Same EQ test as ListDistilling.compareFacetValue.
		return tmpFacets
			.filter((pFacet) => pFacet && pFacet.JoinListValueAddress && !('ValueAddress' in pFacet) && !tmpDistilling.isEmptyFacetValue(pFacet.Value) && (!pFacet.Operator || (pFacet.Operator === 'EQ')))
			.map((pFacet) => ({ Address: pFacet.JoinListValueAddress, Value: pFacet.Value }));
	}

	/**
	 * The array a global Facet rule (JoinListAddressGlobal) reads its join list from, for adding records to.
	 * One that is not set yet reads as a new empty array; with pCreate it is first created as an empty array in
	 * application state (AppData, Pict, Bundle), so application state changes only when a record is added.
	 * Null for a join list in form data, or when the rule would not see a record pushed onto the returned array
	 * (a keyed object, or an address that cannot be created).
	 *
	 * @param {Object} pView - the view the input is in.
	 * @param {Record<string, any>} pRule - the input's Facet rule.
	 * @param {boolean} pCreate - whether to create a join list that is not set yet.
	 * @return {Array<any>|null}
	 */
	_getWritableFacetJoinList(pView, pRule, pCreate)
	{
		if (!pRule.JoinListAddressGlobal)
		{
			return null;
		}
		const tmpManifest = this.pict.manifest;
		const tmpApplicationState = { Fable: this.pict, Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle };
		const tmpCurrent = tmpManifest.getValueAtAddress(tmpApplicationState, pRule.JoinListAddress);
		if ((tmpCurrent === undefined) || (tmpCurrent === null))
		{
			if (!pCreate)
			{
				return [];
			}
			tmpManifest.setValueAtAddress(tmpApplicationState, pRule.JoinListAddress, []);
		}
		// The same address space ListDistilling.getFacetJoinList reads a global join list from.
		const tmpRead = tmpManifest.getValueAtAddress(Object.assign({ View: pView }, tmpApplicationState), pRule.JoinListAddress);
		return Array.isArray(tmpRead) ? tmpRead : null;
	}

	/**
	 * Rebuild every DynamicMetaLists pick list whose source is the given application-state address.
	 * @param {string} pSourceAddress - a ListSourceAddress read with ListSourceAddressGlobal.
	 * @return {void}
	 */
	_rebuildPickListsFromSource(pSourceAddress)
	{
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if (!tmpMetaLists || !tmpMetaLists.listDefinitions || (typeof tmpMetaLists.rebuildListByHash !== 'function'))
		{
			return;
		}
		for (const tmpHash of Object.keys(tmpMetaLists.listDefinitions))
		{
			const tmpDefinition = tmpMetaLists.listDefinitions[tmpHash];
			if (tmpDefinition && tmpDefinition.ListSourceAddressGlobal && (tmpDefinition.ListSourceAddress === pSourceAddress))
			{
				tmpMetaLists.rebuildListByHash(tmpHash);
			}
		}
	}

	/**
	 * Keep an AllowCustomValues field's own custom values in its dropdown, as legacy select2 did (PD-4487): a
	 * bound value missing from the source list, or one created through OnCreate, stays offered after it is
	 * cleared. Legacy injected an `<option>` that lived until the list was rebuilt or the form re-rendered, so
	 * the memory resets when the source list changes (a City list after a new State) and on re-initialize.
	 * A filled list replaced by a different one (another list, or none: a new State with no Cities yet) is such a
	 * rebuild: select2 lost the bound value with its options there, so a bound value the new list lacks is not
	 * carried over but cleared once the mount is done. An empty list filling in is a first load, not a rebuild.
	 * A Facet input the FacetFilter provider clears never takes that clear (FacetFilter owns clearing there):
	 * its list changes with every sibling choice, so each new list is treated as a first load.
	 * Static Options only; entity and dynamic-picklist pickers never allowed creation here.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {void}
	 */
	_applyCustomValueMemory(pConfig, pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (!tmpPictForm.AllowCustomValues || pConfig.Entity || pConfig.DataProvider || !Array.isArray(pConfig.Options))
		{
			return;
		}
		const tmpContext = this._activeTabularContext;
		const tmpKey = this._getCustomValueMemoryKey(pInput, tmpContext ? tmpContext.pRowIndex : null);
		if (!tmpKey)
		{
			return;
		}
		const tmpSourceValues = pConfig.Options.map((pOption) => String(pOption.Value));
		const tmpSignature = tmpSourceValues.join('\u0000');
		if (!this._customValueMemory)
		{
			/** @type {Record<string, { Signature: string, SourceValues: Set<string>, Values: Array<string> }>} */
			this._customValueMemory = {};
		}
		const tmpEntry = this._customValueMemory[tmpKey];
		const tmpRebuilt = !!tmpEntry && (tmpEntry.Signature !== tmpSignature) && (tmpEntry.SourceValues.size > 0) && !this._isClearedByFacetFilter(pInput);
		if (!tmpEntry || tmpEntry.Signature !== tmpSignature)
		{
			this._customValueMemory[tmpKey] = { Signature: tmpSignature, SourceValues: new Set(tmpSourceValues), Values: [] };
		}
		if (tmpContext)
		{
			const tmpCandidates = this._getCustomValueCandidates(pInput, tmpContext.pValue);
			if (tmpRebuilt)
			{
				const tmpKept = tmpCandidates.filter((pValue) => this._customValueMemory[tmpKey].SourceValues.has(pValue));
				if (tmpKept.length < tmpCandidates.length)
				{
					this._queueCustomValueClear(tmpContext.pView, pInput, tmpContext.pRowIndex, tmpKept);
				}
			}
			else
			{
				tmpCandidates.forEach((pValue) => this._rememberCustomValue(tmpKey, pValue));
			}
		}
		const fCreate = pConfig.OnCreate;
		if (typeof fCreate === 'function')
		{
			pConfig.OnCreate = (pTerm) =>
			{
				const tmpRecord = fCreate(pTerm);
				if (tmpRecord && tmpRecord.Value !== undefined && tmpRecord.Value !== null)
				{
					this._rememberCustomValue(tmpKey, String(tmpRecord.Value));
				}
				return tmpRecord;
			};
		}
		const tmpRemembered = this._customValueMemory[tmpKey].Values;
		if (tmpRemembered.length > 0)
		{
			pConfig.Options = tmpRemembered.slice().reverse().map((pValue) => ({ Value: pValue, Text: pValue })).concat(pConfig.Options);
		}
	}

	/**
	 * The custom-value memory slot for a field: its Hash, plus the row for a tabular field (legacy kept one
	 * `<select>` per row, and Facet rules can give each row its own list).
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @return {string|null}
	 */
	_getCustomValueMemoryKey(pInput, pRowIndex)
	{
		if (!pInput || !pInput.Hash)
		{
			return null;
		}
		return (pRowIndex == null) ? pInput.Hash : `${pInput.Hash}#${pRowIndex}`;
	}

	/**
	 * The bound values worth remembering: each csv part of a multi picker, the whole value of a single one (a
	 * single value may itself contain a comma), and never a blank or an unset sentinel.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {Array<string>}
	 */
	_getCustomValueCandidates(pInput, pValue)
	{
		if (this._isMultiplePicker(pInput.PictForm || {}))
		{
			return this._splitPickerValues(pValue, pInput);
		}
		if (pValue === undefined || pValue === null || typeof pValue === 'object')
		{
			return [];
		}
		const tmpValue = String(pValue);
		if (tmpValue.trim() === '' || libPickerEmptyValues.isEmptyValue(pInput, tmpValue))
		{
			return [];
		}
		return [ tmpValue ];
	}

	/**
	 * Commit what a rebuilt list still offers of a field's bound value (a multi keeps its surviving parts; a
	 * single falls back to its Default, as the DistilledInput handler does). Queued, because the rebuild runs
	 * inside the sibling's change pass, and committing there would nest a second provider pass.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex @param {Array<string>} pKept
	 */
	_queueCustomValueClear(pView, pInput, pRowIndex, pKept)
	{
		const tmpValue = this._isMultiplePicker(pInput.PictForm || {}) ? pKept.join(',') : (pInput.Default ?? '');
		queueMicrotask(() => this._setValueAndCommit(pView, pInput, tmpValue, pRowIndex));
	}

	/** Remember one custom value in a memory slot, unless the slot's source list already offers it. @param {string} pKey @param {string} pValue */
	_rememberCustomValue(pKey, pValue)
	{
		const tmpEntry = this._customValueMemory && this._customValueMemory[pKey];
		if (!tmpEntry || tmpEntry.SourceValues.has(pValue) || tmpEntry.Values.includes(pValue))
		{
			return;
		}
		tmpEntry.Values.push(pValue);
	}

	/** Drop a field's remembered custom values: a re-initialized input starts from its source list, as a re-rendered select2 did.
	 *  @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] */
	_forgetCustomValues(pInput, pRowIndex)
	{
		const tmpKey = this._getCustomValueMemoryKey(pInput, pRowIndex);
		if (tmpKey && this._customValueMemory)
		{
			delete this._customValueMemory[tmpKey];
		}
	}

	/** Register the User list-entry display fall-back templates (name parts; login when email is empty). Idempotent. */
	_registerUserListEntryTemplates()
	{
		if (this._userListEntryTemplatesRegistered) { return; }
		this._userListEntryTemplatesRegistered = true;
		this.pict.TemplateProvider.addTemplate('HL-EntityListEntry-User-NameParts', '{~D:Record.NameFirst~} {~D:Record.NameLast~}');
		this.pict.TemplateProvider.addTemplate('HL-EntityListEntry-User-Login', '{~D:Record.LoginID~}');
	}

	/**
	 * The entity this picker targets: the descriptor's own Entity, else the entity the specialized
	 * selector's provider hardcodes (R2 port-forward — see _SPECIALIZED_SELECTOR_MAP), else the entity
	 * this provider was configured with. Every place that scopes by entity (contextual filters, sample
	 * spec-year priming) resolves through here so a migrated specialized selector scopes exactly as its
	 * descriptor-carried generic cousin would.
	 *
	 * The provider-option leg mirrors `MaterialsEntitySelector._getEntity` and is what serves an
	 * InputType the map does not name — the `MaterialsHidden*` family, which carries no descriptor
	 * `Entity` and which `MaterialsCascadePicker.onInputInitialize` branches on by name.
	 *
	 * @param {Record<string, any>} pPictForm @return {string|undefined}
	 */
	_resolveEntity(pPictForm)
	{
		if (pPictForm && pPictForm.Entity)
		{
			return pPictForm.Entity;
		}
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[pPictForm && pPictForm.InputType];
		if (tmpSpecialized && tmpSpecialized.Entity)
		{
			return tmpSpecialized.Entity;
		}
		return (this.options && this.options.Entity) || undefined;
	}

	/**
	 * Headlight contextual scoping, ported in spirit from
	 * PictProvider-InputType-EntitySelectorMultiple.localHandleSearchFilters: extra FoxHound stanzas
	 * AND-applied to the entity search. The picker module calls this on every search via its BaseFilter
	 * hook; the module stays host-agnostic, the host knows about projects + spec years.
	 *
	 * Row context (pRowIndex, pView) enables per-row `FromRowField` / `LabScope` and per-row `__ShowAll`
	 * for tabular pickers — captured into the per-row BaseFilter closure by the tabular mount override
	 * (plan §5.3). A non-tabular picker passes neither (treated as null).
	 *
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}} The pict-section-picker 1.9.0
	 *   BaseFilter split: mandatory clauses + the preferred (auto-widen-on-empty) back-off clauses.
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpEntity = this._resolveEntity(tmpPictForm);
		const tmpFilters = [];
		const tmpBackoff = [];
		const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
		const tmpView = pView || null;
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		// The engine reads StaticFilters / ShowAllToggle off the descriptor, so hand it the config-map defaults too.
		const tmpFilterInput = this._withMapFilterDefaults(pInput);
		// Show-All override, read once (per-row when tabular). Drops the back-off list + the non-mandatory
		// scope clauses (the spec-set floor unless SpecYearMandatory, and the engine's SamplePlan/Through/Lab scopes).
		const tmpOverridden = !!(tmpEngine && tmpEngine.isFilterOverridden(tmpFilterInput, tmpRowIndex));

		// Project scoping for project-resident entities. Off-switches: PictForm.disableProjectFilteringForEntity,
		// or the config map's DisableProjectFiltering (a specialized selector whose legacy provider never scoped).
		const tmpProjectEntityList = [ 'LineItem', 'BidItem' ];
		const tmpScopingDisabled = tmpPictForm.disableProjectFilteringForEntity || _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.DisableProjectFiltering;
		if (!tmpScopingDisabled && tmpProjectEntityList.includes(tmpEntity))
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID) { tmpFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`); }
		}

		// Customer state scoping (legacy BridgeSelector): only the customer's configured state(s).
		if (_SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.CustomerStateFilter)
		{
			const tmpStateClause = this._getCustomerStateClause();
			if (tmpStateClause) { tmpFilters.push(tmpStateClause); }
		}

		// Spec-set floor — ported faithfully from MES.localHandleSearchFilters. Gated by Show-All UNLESS
		// PictForm.SpecYearMandatory; routed to the back-off list when PictForm.SpecYearBackOff. The
		// resolver getter returns null on the fail-open paths (no contract FK / empty set / no join
		// rows) — leave unfiltered then.
		if (!tmpPictForm.DisableSpecYearSiloing && this.pict.providers.SpecScopeResolver)
		{
			const tmpAxis = _SPEC_SET_AXIS[tmpEntity];
			// Lab is the only axis here, and its floor must be read family-expanded: spec-set membership is
			// declared per FAMILY, so raw IDLab membership empties one level or the other (see
			// _LabRouting.resolveSpecSetLabFloor).
			const tmpAllowed = tmpAxis ? libLabRouting.resolveSpecSetLabFloor(this.pict) : null;
			if (tmpAllowed && tmpAllowed.size > 0 && (tmpPictForm.SpecYearMandatory || !tmpOverridden))
			{
				(tmpPictForm.SpecYearBackOff ? tmpBackoff : tmpFilters).push(`FBL~${tmpAxis.field}~INN~${Array.from(tmpAllowed).join(',')}`);
			}
		}

		// Descriptor-level Static/Dynamic scope filters via the extracted engine (StaticFilters, DynamicFilters
		// FromField / per-row FromRowField / SamplePlan / Through / Lab). The engine appends mandatory clauses
		// to tmpFilters and `BackOff: true` clauses to tmpBackoff. Row context threads per-row FromRowField /
		// LabScope (plan §5.3).
		if (tmpEngine)
		{
			tmpEngine.applyStaticFilters(tmpFilters, tmpFilterInput, tmpBackoff);
			tmpEngine.applyDynamicFilters(tmpFilters, tmpFilterInput, tmpRowIndex, tmpView, tmpBackoff);
		}

		// Fold in any descriptor-level scope hook (e.g. the recordset entity filter base's GetContextScopeFilter).
		const tmpBase = super.getContextualSearchFilters(pInput);
		if (tmpBase) { tmpFilters.push(Array.isArray(tmpBase) ? tmpBase.filter(Boolean).join('~') : tmpBase); }

		// The `{ Filters, BackOffFilters }` split is pict-section-picker 1.9.0's BaseFilter contract: both
		// sets apply together, and an EMPTY first page auto-retries once WITHOUT the back-off set — the
		// legacy getOptionsAjax auto-widen (§5.6), restored. Show-All drops the back-off set entirely
		// (legacy parity); the mandatory set survives.
		return {
			Filters: tmpFilters.filter(Boolean),
			BackOffFilters: tmpOverridden ? [] : tmpBackoff.filter(Boolean),
		};
	}

	/**
	 * The descriptor with its config-map filter defaults (StaticFilters, ShowAllToggle) filled in where it sets
	 * none: MaterialSelector's top-level-only filter and its toggle. A copy, and Picker-path only; the legacy
	 * Select2Util shares the filter engine and must not see the defaults before its type flips.
	 * @param {Record<string, any>} pInput @return {Record<string, any>}
	 */
	_withMapFilterDefaults(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType];
		if (!tmpSpecialized) { return pInput; }
		const tmpDefaults = {};
		if (tmpPictForm.StaticFilters === undefined && tmpSpecialized.StaticFilters) { tmpDefaults.StaticFilters = tmpSpecialized.StaticFilters; }
		if (tmpPictForm.ShowAllToggle === undefined && tmpSpecialized.ShowAllToggle !== undefined) { tmpDefaults.ShowAllToggle = tmpSpecialized.ShowAllToggle; }
		if (Object.keys(tmpDefaults).length < 1) { return pInput; }
		return Object.assign({}, pInput, { PictForm: Object.assign({}, tmpPictForm, tmpDefaults) });
	}

	/**
	 * Give the picker an EmptyLabel function (pict-section-picker 1.9.8) that explains an empty list its own
	 * scope narrowed. It reads the config's BaseFilter when the list renders empty, so a BaseFilter a subclass
	 * sets after this call, or a scope that changed since the last search, is the one checked.
	 *
	 * @param {Record<string, any>} pConfig - The picker config being built; left alone if it sets its own EmptyLabel.
	 * @param {Record<string, any>} pInput - The descriptor.
	 * @param {{pRowIndex?: number, pView?: Object}|null} pTabularContext - The row being mounted, for a tabular picker.
	 */
	_applyEmptyListLabel(pConfig, pInput, pTabularContext)
	{
		if (pConfig.EmptyLabel !== undefined)
		{
			return;
		}
		const tmpRowIndex = (pTabularContext && pTabularContext.pRowIndex != null) ? pTabularContext.pRowIndex : null;
		pConfig.EmptyLabel = () => this.getEmptyListLabel(pInput, pConfig, tmpRowIndex);
	}

	/**
	 * The empty-list wording the Select2 dropdowns used (PictProvider-Select2Util noResults), for an entity picker
	 * whose BaseFilter currently narrows the search: the field's FilteredNoResultsMessage, else a "Show all" hint
	 * while the field offers an override that is off, else "No matches with the current filter.". Blank (the
	 * module's own "No matches") when nothing narrowed it, and for pick-list, custom-provider and local pickers.
	 *
	 * @param {Record<string, any>} pInput - The descriptor.
	 * @param {Record<string, any>} pConfig - The picker config (Entity, BaseFilter, DataProvider, PickListDataProvider).
	 * @param {number|null} [pRowIndex] - The row of a tabular picker, for its own Show all state.
	 * @return {string}
	 */
	getEmptyListLabel(pInput, pConfig, pRowIndex)
	{
		if (!pConfig || !pConfig.Entity || pConfig.DataProvider || pConfig.PickListDataProvider)
		{
			return '';
		}
		let tmpScope = pConfig.BaseFilter;
		if (typeof tmpScope === 'function')
		{
			try
			{
				tmpScope = tmpScope();
			}
			catch (pError)
			{
				return '';
			}
		}
		if (!this._scopeNarrows(tmpScope))
		{
			return '';
		}
		const tmpFilterInput = this._withMapFilterDefaults(pInput);
		const tmpPictForm = (tmpFilterInput && tmpFilterInput.PictForm) || {};
		if (tmpPictForm.FilteredNoResultsMessage)
		{
			return tmpPictForm.FilteredNoResultsMessage;
		}
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		const tmpOffersShowAll = !!(tmpPictForm.ShowAllToggle || tmpPictForm.OverrideField);
		const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
		if (tmpOffersShowAll && !(tmpEngine && tmpEngine.isFilterOverridden(tmpFilterInput, tmpRowIndex)))
		{
			return 'No matches with the current filter — turn on "Show all" to see everything.';
		}
		return 'No matches with the current filter.';
	}

	/**
	 * Whether a resolved BaseFilter value (a stanza string, an array of them, or the `{ Filters, BackOffFilters }`
	 * split) holds at least one clause.
	 * @param {any} pScope @return {boolean}
	 */
	_scopeNarrows(pScope)
	{
		const fHasClause = (pPart) => Array.isArray(pPart) ? pPart.some(Boolean) : !!pPart;
		if (pScope && typeof pScope === 'object' && !Array.isArray(pScope))
		{
			return fHasClause(pScope.Filters) || fHasClause(pScope.BackOffFilters);
		}
		return fHasClause(pScope);
	}

	/**
	 * The customer's state clause for a state-scoped selector (legacy BridgeSelector), from ConfigurationProvider's
	 * `StateAbbreviation`: one state (`FBV~State~EQ`), several (`FBL~State~INN`), or none (unscoped). Cached per
	 * customer, because the lookup logs on every call and this runs on every search.
	 * @return {string|null}
	 */
	_getCustomerStateClause()
	{
		const tmpCustomerID = this.pict.AppData?.CurrentUser?.CustomerID;
		const tmpProvider = this.pict.providers.ConfigurationProvider;
		if (!tmpCustomerID || !tmpProvider || typeof tmpProvider.getConfigurationByScope !== 'function') { return null; }
		this._customerStateClauses = this._customerStateClauses || {};
		if (!(tmpCustomerID in this._customerStateClauses))
		{
			const tmpConfig = tmpProvider.getConfigurationByScope(tmpCustomerID);
			const tmpState = (tmpConfig && !(tmpConfig instanceof Error)) ? tmpConfig.StateAbbreviation : null;
			let tmpClause = null;
			if (Array.isArray(tmpState) && tmpState.length > 0) { tmpClause = `FBL~State~INN~${tmpState.map((pState) => encodeURIComponent(pState)).join(',')}`; }
			else if (tmpState && !Array.isArray(tmpState)) { tmpClause = `FBV~State~EQ~${encodeURIComponent(tmpState)}`; }
			this._customerStateClauses[tmpCustomerID] = tmpClause;
		}
		return this._customerStateClauses[tmpCustomerID];
	}

	// --- Show-All filter override (beast MVP, §8.7) — the user's escape hatch from an over-narrow filter ---

	/** The integrated "Show All" toggle element id for this picker. Broker-namespaced so it never collides
	 *  with a legacy MES toggle during coexistence. @param {string} pInputHTMLID @param {number|string} [pRowIndex] */
	getSelectFilterToggleID(pInputHTMLID, pRowIndex)
	{
		return `#PICKER-FILTER-TOGGLE-${pInputHTMLID}${(pRowIndex != null) ? `-${pRowIndex}` : ''}`;
	}

	/**
	 * Flip the "Show All" override for this picker. State persists at `<key>__ShowAll` (non-tabular) or
	 * `<key>__ShowAll_<rowIndex>` (tabular, per-row) — the same address `EntityFilterEngine.isFilterOverridden`
	 * reads in getContextualSearchFilters — so the NEXT search drops (or re-applies) the back-off + non-mandatory
	 * scope clauses. Ported from MES.toggleFilterOverride. No forced re-search is needed: PSP drops its loaded
	 * pages when the dropdown closes, and its backdrop swallows the click that closes it, so the toggle is only
	 * ever actuated while closed — the next open re-queries and re-resolves BaseFilter against the state written
	 * here. (Through PSP 1.9.0 this called a public reload() to punch through a cache that outlived the close.)
	 * @param {string} pInputHTMLID @param {string} pKey - DataAddress (non-tabular) or input Hash (tabular per-row)
	 * @param {number|string} [pRowIndex]
	 */
	toggleFilterOverride(pInputHTMLID, pKey, pRowIndex)
	{
		// A read-only / disabled picker paints the toggle inert (_FilterToggleUI) — swallow the click rather
		// than writing override state and re-composing filters for a field whose value cannot change.
		if (libFilterToggleUI.isToggleDisabled(this.pict, this.getSelectFilterToggleID(pInputHTMLID, pRowIndex))) { return; }
		const tmpSuffix = (pRowIndex != null) ? `__ShowAll_${pRowIndex}` : '__ShowAll';
		const tmpAddress = `AppData.DocumentData.ReportData.FormData.${pKey}${tmpSuffix}`;
		const tmpNewState = !this.pict.manifest.getValueByHash(this.pict, tmpAddress);
		this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpNewState);
		this._updateFilterToggleIcon(pInputHTMLID, tmpNewState, pRowIndex);
	}

	/** Repaint the toggle icon to reflect the current override state. Ported from MES._updateFilterToggleIcon.
	 *  @param {string} pInputHTMLID @param {boolean} pState @param {number|string} [pRowIndex] */
	_updateFilterToggleIcon(pInputHTMLID, pState, pRowIndex)
	{
		if (!this.pict?.ContentAssignment) { return; }
		const tmpIcon = pState ? 'fa-toggle-on' : 'fa-toggle-off';
		this.pict.ContentAssignment.assignContent(`${this.getSelectFilterToggleID(pInputHTMLID, pRowIndex)} > .icon`, `<i class="fas ${tmpIcon}"></i>`);
	}

	/**
	 * Three concerns on a committed selection:
	 *   1. Spec-year scope from the picked sample, ported from EntitySelectorMultiple.onDataChange: when a
	 *      Sample is selected, prime the SpecScopeResolver so the pickers it gates narrow.
	 *      Single-project resolver, so for a multi-select we take the first identifier (and warn).
	 *   2. Populate the field's `__Record` slot (see _refreshEntityRecord).
	 *   3. Re-sync the Required state and live validation (see _syncRequiredStateAfterCommit).
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._fireOnChangeCallbacks(pView, pInput, pValue, pHTMLSelector);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (this._resolveEntity(tmpPictForm) === 'Sample' && pValue && this.pict.providers.SpecScopeResolver)
		{
			const tmpIdentifiers = (typeof pValue === 'string' ? pValue.split(',') : (Array.isArray(pValue) ? pValue : []))
				.map((pVal) => String(pVal).trim()).filter((pVal) => pVal.length > 0);
			if (tmpIdentifiers.length > 1)
			{
				this.pict.log.warn(`Picker [${pInput?.Hash}]: multi-sample selection with spec-year scope active — using the first sample (${tmpIdentifiers[0]}) as the scope source. Picker has ${tmpIdentifiers.length} samples selected.`);
			}
			if (tmpIdentifiers.length > 0)
			{
				const tmpIdentityField = tmpPictForm.IdentityField || 'IDSample';
				this.pict.providers.SpecScopeResolver.loadForSampleByIdentifier?.(tmpIdentifiers[0], tmpIdentityField);
			}
		}
		this._publishSelectedProject(pInput, pValue);
		this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID);
		// The picker id helpers live on the (untyped-to-tsc) pict-section-picker base.
		const tmpSelf = /** @type {any} */ (this);
		this._syncRequiredStateAfterCommit(pInput, pInput.Macro.HTMLSelector, tmpSelf.getPickerHostID(pInput.Macro.RawHTMLID));
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of onDataChange's record refresh + Required re-sync — the record lands at the row's own address. */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._fireOnChangeCallbacks(pView, pInput, pValue, pHTMLSelector);
		this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		const tmpSelf = /** @type {any} */ (this);
		this._syncRequiredStateAfterCommit(pInput, tmpSelf.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex), tmpSelf.getTabularPickerHostID(pInput.Macro.RawHTMLID, pRowIndex));
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/** Load-path twin of onDataChange's SelectedProject publish: legacy ProjectSelector set it on every marshal. */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._publishSelectedProject(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Legacy ProjectSelector parity: publish the chosen Project as `AppData.SelectedProject`, which LADOTD
	 * sample names read (SampleSequencing.buildSampleName → ExternalProjectID). Like legacy, an empty value
	 * leaves it as-is and tabular never publishes. The latest request wins if lookups settle out of order.
	 * @param {Record<string, any>} pInput @param {any} pValue
	 * @return {Promise<void>|void}
	 */
	_publishSelectedProject(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || pInput.PictForm.InputType !== 'ProjectSelector') { return; }
		const tmpProjectID = this._splitPickerValues(pValue, pInput)[0];
		if (!tmpProjectID || !this.pict.EntityProvider) { return; }
		const tmpRequest = this._selectedProjectRequest = {};
		return this._resolveEntityRecord('Project', tmpProjectID, pInput).then((pProject) =>
		{
			if (pProject && this._selectedProjectRequest === tmpRequest) { this.pict.AppData.SelectedProject = pProject; }
		});
	}

	// --- Entity __Record population ---

	/**
	 * The `__Record` address for this input/row, ported from MaterialsEntitySelector so a port-forwarded
	 * field's record lands at the SAME address its consumers already read. pSuffix supports the sibling
	 * slots the cascade family keeps next to the record (`__Salt`, `_DocumentPolyJoin` — legacy parity:
	 * an explicit PictForm.RecordAddress wins regardless of suffix).
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex] @param {string} [pSuffix] @return {string}
	 */
	_getRecordAddress(pInput, pRowIndex, pSuffix = '__Record')
	{
		if (pInput.PictForm?.RecordAddress) { return pInput.PictForm.RecordAddress; }
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + pSuffix;
		}
		return `${pInput.DataAddress || pInput.Hash}${pSuffix}`;
	}

	/**
	 * The committed picker value as a list of entity ids: multi commits csv (PSP's _commit joins the
	 * array), single commits the bare id, a cleared picker commits ''.
	 *
	 * An unset SENTINEL drops out alongside the blanks (pInput given): a pristine `DataType: Number`
	 * field marshals in as manyfest's DataType default 0, which the widget paints as its placeholder —
	 * so `__Record` must read as cleared too, not fetch the entity #0 that does not exist.
	 * @param {any} pValue @param {Record<string, any>} [pInput] @return {Array<string>}
	 */
	_splitPickerValues(pValue, pInput)
	{
		const tmpValues = Array.isArray(pValue) ? pValue : String(pValue ?? '').split(',');
		return tmpValues.map((pEntry) => String(pEntry).trim()).filter((pEntry) =>
			(pEntry.length > 0) && !(pInput && libPickerEmptyValues.isEmptyValue(pInput, pEntry)));
	}

	/** The widget's `EmptyValues` from the shared Headlight rule, so the control, `__Record` and Read/Print agree. */
	_resolveEmptyValues(pInput)
	{
		return libPickerEmptyValues.resolveEmptyValues(pInput);
	}

	/**
	 * The committed VALUE address for this input/row (not `__Record`): the slot the marshal binds the picker to.
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex] @return {string}
	 */
	_getPickerValueAddress(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.PictForm?.InformaryDataAddress || pInput.DataAddress || pInput.Hash;
	}

	/**
	 * Whether the committed value moved on while a record lookup was in flight. A value nobody has written
	 * yet is no evidence either way, so it never counts as stale.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null|undefined} pRowIndex
	 * @param {Array<string>} pRequestedValues - The split values the lookup was issued for.
	 * @return {boolean}
	 */
	_isStaleEntityRecordRefresh(pView, pInput, pRowIndex, pRequestedValues)
	{
		const tmpCurrentValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getPickerValueAddress(pInput, pRowIndex));
		if (tmpCurrentValue === undefined || tmpCurrentValue === null)
		{
			return false;
		}
		const tmpCurrent = new Set(this._splitPickerValues(tmpCurrentValue, pInput));
		const tmpRequested = new Set(pRequestedValues);
		if (tmpCurrent.size !== tmpRequested.size)
		{
			return true;
		}
		for (const tmpValue of tmpRequested)
		{
			if (!tmpCurrent.has(tmpValue))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * One entity record for a picker value, resolved through the SAME path PSP resolves the display label
	 * with (EntityProvider.getEntity, which reads its recordCache first). The picker's own dropdown load
	 * caches every option's full record, so a selection is normally a cache hit costing no round-trip; a
	 * genuine miss (a value outside the loaded set, or one past the cache's 30s TTL) fetches. Resolves
	 * null on failure — the caller keeps whatever record is already there (offline-tolerant, as the MES's
	 * backfill is).
	 *
	 * Identity-aware (beast B2): a creation-family field commits its GUID identity (e.g. `GUIDSample`),
	 * which EntityProvider.getEntity cannot look up (it fetches by numeric id) — those route through the
	 * legacy MES `_refreshRecord` fetch shape instead (`FBL~<identity>~INN~<value>`).
	 * @param {string} pEntity @param {string} pValue @param {Record<string, any>} [pInput]
	 * @return {Promise<Record<string, any>|null>}
	 */
	_resolveEntityRecord(pEntity, pValue, pInput)
	{
		const tmpIdentity = pInput ? this._getRecordIdentity(pInput) : `ID${pEntity}`;
		if (tmpIdentity !== `ID${pEntity}`)
		{
			return this._resolveEntityRecordByIdentity(pEntity, tmpIdentity, pValue);
		}
		return new Promise((resolve) =>
		{
			this.pict.EntityProvider.getEntity(pEntity, pValue, (pError, pRecord) =>
			{
				if (pError || !libSharedEntityRead.isEntityRecord(pEntity, pRecord))
				{
					this.pict.log.warn(`Picker [${pEntity}]: record lookup failed for [${pValue}]: ${pError?.message || pError || pRecord?.Error || 'no record returned'}`);
					return resolve(null);
				}
				return resolve(pRecord);
			});
		});
	}

	/**
	 * Fetch a record by a NON-simple identity field (the legacy MES `_refreshRecord` System-2 shape), through the
	 * shared read MES uses, so concurrent reads of one row share a request and an empty or placeholder identity
	 * is never read. Resolves null on failure/no-match — same keep-prior-record semantics as the getEntity path.
	 * @param {string} pEntity @param {string} pIdentityField @param {string} pValue
	 * @return {Promise<Record<string, any>|null>}
	 */
	_resolveEntityRecordByIdentity(pEntity, pIdentityField, pValue)
	{
		return new Promise((resolve) =>
		{
			if (libSharedEntityRead.isEmptyIdentityValue(pIdentityField, pValue))
			{
				return resolve(null);
			}
			if (!this.pict.HeadlightRestClient)
			{
				this.pict.log.warn(`Picker [${pEntity}]: no HeadlightRestClient — cannot resolve by [${pIdentityField}].`);
				return resolve(null);
			}
			libSharedEntityRead.readJSON(this.pict, `${pEntity}s/FilteredTo/FBL~${pIdentityField}~INN~${encodeURIComponent(pValue)}`, { ReuseResult: false }, (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords) || pRecords.length < 1)
				{
					this.pict.log.warn(`Picker [${pEntity}]: record lookup by ${pIdentityField} failed for [${pValue}]: ${pError?.message || pError || 'no records found'}`);
					return resolve(null);
				}
				if (pRecords.length > 1)
				{
					this.pict.log.warn(`Picker [${pEntity}]: multiple records with ${pIdentityField} = [${pValue}]; using the first.`);
				}
				return resolve(pRecords[0]);
			});
		});
	}

	/**
	 * Populate `<DataAddress>__Record` with the full entity record(s) behind the committed value — the
	 * write the legacy MaterialsEntitySelector did on selection and the port-forwarded picker dropped
	 * (PSP fetches a record to render the label but keeps only {Value, Text, Tag}). Without it every
	 * autofill-receiver PostSolver, compound display and PDF field reads an empty record.
	 *
	 * Timing: the lookup is async, so the write is fenced with a transaction async-op — registered
	 * SYNCHRONOUSLY here, before the form view's finalizeTransaction runs in its `finally`. That holds the
	 * transaction, and therefore the AutofillTriggerGroup PostSolvers that read `__Record`, open until the
	 * record has landed: no race, no one-save lag. Same fence Pict-Provider-Input-EntityBundleRequest uses
	 * for its fetches. Registered even on the cache-hit path — the promise still settles a microtask late,
	 * and a uniform fence beats a write whose visibility depends on cache luck.
	 *
	 * See docs/Picker-EntityRecord-Timing.md.
	 *
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string} [pRowIndex]
	 * @return {Promise<any>|void} resolves once the record has landed (the tests await it).
	 */
	_refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		// A non-entity picker (a static / picklist Select port-forward) has no record to hold.
		if (!tmpEntity || !pView || typeof pView.getMarshalDestinationObject !== 'function') { return; }
		const tmpMultiple = this._isMultiplePicker(pInput.PictForm);
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const fWriteRecord = (pRecord) => this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress, pRecord);
		const tmpValues = this._splitPickerValues(pValue, pInput);

		// Cleared: reset the slot synchronously (no fetch) so nothing downstream reads the previous record.
		if (tmpValues.length < 1)
		{
			const tmpCleared = tmpMultiple ? [] : { };
			fWriteRecord(tmpCleared);
			// Fire the cascade seam on clear too (a subclass may clear dependent joins / receivers). Sync path:
			// the writes land in this same dataChanged cycle, before finalizeTransaction — no fence needed.
			this._onEntityRecordCascade(pView, pInput, tmpCleared, pRowIndex, pTransactionGUID);
			return;
		}
		if (!this.pict.EntityProvider)
		{
			this.pict.log.warn(`Picker [${pInput.Hash}]: no EntityProvider registered — cannot populate [${tmpRecordAddress}].`);
			return;
		}

		// Unique per (field, row, change) so concurrent pickers in one transaction can't cross-complete.
		const tmpOperationHash = `PickerRecordRefresh-${tmpEntity}-${tmpRecordAddress}-${this.pict.getUUID()}`;
		const tmpFenced = !!pTransactionGUID && typeof pView.registerEventTransactionAsyncOperation === 'function';
		if (tmpFenced) { pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpOperationHash); }
		return Promise.all(tmpValues.map((pEntityValue) => this._resolveEntityRecord(tmpEntity, pEntityValue, pInput)))
			.then((pRecords) =>
			{
				// The value moved on while the lookups were in flight; the refresh for the current value owns the record.
				if (this._isStaleEntityRecordRefresh(pView, pInput, pRowIndex, tmpValues))
				{
					return undefined;
				}
				const tmpResolved = pRecords.filter((pRecord) => !!pRecord);
				let tmpWritten;
				if (tmpMultiple)
				{
					// A failed lookup keeps the record the form holds for that value, as a failed single lookup does.
					const tmpIdentity = this._getRecordIdentity(pInput);
					tmpWritten = tmpValues.map((pEntityValue, pIndex) => pRecords[pIndex] || this._findHeldRecord(pView, pInput, tmpIdentity, pEntityValue, pRowIndex)).filter((pRecord) => !!pRecord);
					fWriteRecord(tmpWritten);
				}
				else if (tmpResolved.length > 0)
				{
					const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
					tmpWritten = this._reconcileRefreshedRecord(pView, pInput, tmpHeld, tmpResolved[0], this._getRecordIdentity(pInput), tmpValues[0], pRowIndex);
					fWriteRecord(tmpWritten);
				}
				else
				{
					// Every lookup failed — keep any prior record, else normalize the empty slot to {}.
					tmpWritten = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
					if (!tmpWritten) { tmpWritten = { }; fWriteRecord(tmpWritten); }
				}
				// Fire the cascade seam AFTER __Record lands and INSIDE the fence; return its result so the
				// transaction awaits an async cascade before its PostSolvers run (see _onEntityRecordCascade).
				return this._onEntityRecordCascade(pView, pInput, tmpWritten, pRowIndex, pTransactionGUID);
			})
			.catch((pError) =>
			{
				this.pict.log.error(`Picker [${pInput.Hash}]: error populating [${tmpRecordAddress}]: ${pError.message || pError}`);
			})
			.finally(() =>
			{
				if (tmpFenced) { pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpOperationHash); }
			});
	}

	/**
	 * The per-InputType CASCADE seam for the MaterialsEntitySelector "beast" migration (plan §8.8).
	 *
	 * Fired right AFTER `__Record` is written and — on the select path — INSIDE the fenced transaction,
	 * so a subclass's cascade FormData writes (join records, `_EntityData` projection, dependent-field
	 * fills) inherit the exact land-before-transaction-complete guarantee the `__Record` fix proved (the
	 * select-path caller `return`s this so the fence awaits an async cascade before its PostSolvers run).
	 * Also fired on the clear path (synchronously) so a subclass can clear dependent state.
	 *
	 * The base broker is a NO-OP — a plain entity Picker has no cascade, so existing migrated fields are
	 * unaffected. `MaterialsCascadePicker` and the bespoke `Materials*Picker` subclasses override this to
	 * reproduce the legacy MES `_onRecordRefresh` behavior. Return a Promise to make the transaction wait.
	 *
	 * @param {Object} pView - the dynamic-form view.
	 * @param {Record<string, any>} pInput - the field descriptor.
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord - what was just written to `__Record`
	 *   (an object in single mode, an array in multi mode, `{}`/`[]` on clear).
	 * @param {number|string} [pRowIndex] - the row index for a tabular picker.
	 * @param {string} [pTransactionGUID] - the active transaction (for a subclass that needs to fence its own async work).
	 * @return {void|Promise<any>}
	 */
	// eslint-disable-next-line no-unused-vars
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		// No-op default. The beast (§8.8) overrides this.
	}

	/**
	 * Choose what a single-record refresh writes. The base takes the server row; `MaterialsCascadePicker`
	 * reconciles it against the record the form already holds.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {any} pHeldRecord - the record at the address when the row arrived.
	 * @param {Record<string, any>} pFetchedRecord - the server row.
	 * @param {string} pIdentityField @param {any} pValue @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>} the record to write.
	 */
	// eslint-disable-next-line no-unused-vars
	_reconcileRefreshedRecord(pView, pInput, pHeldRecord, pFetchedRecord, pIdentityField, pValue, pRowIndex)
	{
		return pFetchedRecord;
	}

	/**
	 * The per-InputType SELECTION-CLEARED seam, fired before any pathway blanks this field's value and
	 * `__Record` — the user clear, the anchor-change clear and the autofill-scope vet all route here.
	 *
	 * The base broker is a NO-OP: a plain entity Picker creates nothing, so it has nothing to tombstone
	 * and no salt to rotate. `MaterialsCascadePicker` overrides it to stage the scoped-EntityData
	 * tombstone and mint a fresh `__Salt`.
	 *
	 * @param {Object} pView - the dynamic-form view.
	 * @param {Record<string, any>} pInput - the field descriptor.
	 * @param {number|string|null} [pRowIndex] - the row index for a tabular picker.
	 */
	// eslint-disable-next-line no-unused-vars
	_handleEntitySelectionCleared(pView, pInput, pRowIndex)
	{
		// No-op default. MaterialsCascadePicker overrides this.
	}

	// --- Programmatic value commit + declarative defaults (beast B1, plan §8.8) ---

	/**
	 * Commit a PROGRAMMATIC value (a resolved Default, a cascade's reverse-seed, a creation flow) the way
	 * a user selection would land it, without double-driving the form cycle:
	 *   1. `setDataByInput` / `setDataTabularByHash` — the framework's programmatic set: writes the model
	 *      and runs this input's provider loop inside a fenced transaction, so the broker's own
	 *      `onDataChange` populates `__Record` and fires the cascade seam with the same
	 *      land-before-PostSolvers guarantee a user pick gets. (It does NOT solve/marshal — same as the
	 *      legacy MES `_setResolvedDefault`, whose select2 repainted via its own change plumbing.)
	 *   2. Sync the hidden informary input, so a later whole-form marshal-from-view cannot clobber the
	 *      model with the stale pre-commit DOM value.
	 *   3. `setValue` on the mounted picker widget — DISPLAY only (PSP's setValue deliberately fires no
	 *      OnChange). Routing through PSP's OnChange/_commit instead would call dataChanged a second
	 *      time: a double transaction + a double record refresh.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {number|string|null} [pRowIndex]
	 */
	_setValueAndCommit(pView, pInput, pValue, pRowIndex)
	{
		if (pRowIndex != null)
		{
			if (typeof pView.setDataTabularByHash === 'function')
			{
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pValue);
			}
		}
		else if (typeof pView.setDataByInput === 'function')
		{
			pView.setDataByInput(pInput, pValue);
		}
		this._syncCommittedValueDOM(pInput, pValue, pRowIndex);
	}

	/**
	 * Steps 2–3 of _setValueAndCommit on their own: sync the hidden informary input + repaint the
	 * mounted widget (display-only) for a value the MODEL already holds. Used by the cascade family
	 * when it rewrites the committed value MID provider-loop (e.g. `__NEW__` → the synthesized GUID),
	 * where re-driving setDataByInput would nest a second provider pass.
	 * @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 */
	_syncCommittedValueDOM(pInput, pValue, pRowIndex)
	{
		// The picker id helpers live on the (untyped-to-tsc) pict-section-picker base; reach them via a cast.
		const tmpSelf = /** @type {any} */ (this);
		const tmpCSV = Array.isArray(pValue) ? pValue.join(',') : ((pValue === undefined || pValue === null) ? '' : pValue);
		const tmpHiddenSelector = (pRowIndex != null) ? tmpSelf.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex) : pInput.Macro.HTMLSelector;
		const tmpPickerHash = (pRowIndex != null) ? tmpSelf.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex) : tmpSelf.getPickerHash(pInput.Macro.RawHTMLID);
		if (this.pict.ContentAssignment)
		{
			this.pict.ContentAssignment.assignContent(tmpHiddenSelector, tmpCSV);
		}
		const tmpPickerView = this.pict.views && this.pict.views[tmpPickerHash];
		if (tmpPickerView && typeof tmpPickerView.setValue === 'function')
		{
			tmpPickerView.setValue(pValue);
		}
	}

	/**
	 * The field the picker's committed value identifies a record by — PSP's ValueField. Mirrors the MES
	 * `_getRecordIdentity` (minus the creation-GUID branch, which arrives with the creation primitives
	 * in B2 Sample).
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		return tmpPictForm.RecordIdentity || tmpPictForm.IdentityField || `ID${this._resolveEntity(tmpPictForm) || ''}`;
	}

	/**
	 * True when this InputType gets the legacy MES defaults-on-empty behavior (see the map's
	 * `MaterialsFamily` flag). GATE, not vestige: enabling descriptor Defaults base-wide would make
	 * already-shipped generic Select→Picker fields carrying a `Default` suddenly self-populate on new
	 * forms — a data-result change. A bespoke cascade subclass may override to opt in directly.
	 *
	 * The `MaterialsHidden*` leg is membership, not a widening: those InputTypes are served by the same
	 * providers and carry a descriptor `Default` as their normal shape (the generated test-slot
	 * descriptors are `Default: '<test hash>'`), so the map's omission of them dropped a behaviour the
	 * legacy applied. `_clearsOnAnchorChange` already reads the same membership.
	 * @param {Record<string, any>} pInput @return {boolean}
	 */
	_appliesConfiguredDefaults(pInput)
	{
		const tmpInputType = pInput?.PictForm?.InputType || '';
		if (tmpInputType.startsWith('MaterialsHidden'))
		{
			return true;
		}
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpInputType];
		return !!(tmpSpecialized && tmpSpecialized.MaterialsFamily);
	}

	/**
	 * True when a declarative `Default` should be applied to the picker. Ported from the MES: a new form's
	 * marshal destination holds a DEFINED '' at the address, so manyfest's getValueByHash does NOT
	 * substitute the descriptor Default (it only does so for `undefined`) — pValue arrives '' and we apply
	 * it ourselves. Also fires when pValue DID arrive as the raw Default token (from an undefined address)
	 * for a by-field default, so the token can be resolved to an id; a by-id value already IS the record id
	 * and must not re-apply.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_shouldApplyConfiguredDefault(pInput, pValue)
	{
		if (!this._appliesConfiguredDefaults(pInput))
		{
			return false;
		}
		if (pInput.Default == null || pInput.Default === '')
		{
			return false;
		}
		if (pValue == null || pValue === '')
		{
			return true;
		}
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		return (pValue === pInput.Default && !!tmpField && tmpField !== this._getRecordIdentity(pInput));
	}

	/**
	 * Apply `pInput.Default` to an empty picker (ported from the MES). `PictForm.DefaultField` names a
	 * NON-identity field to match on (e.g. `Hash`) so the default is portable across customers —
	 * `Default:"ACPT"` + `DefaultField:"Hash"` resolves the customer's ACPT SampleType by its id via one
	 * read. Without a DefaultField (or when it IS the identity) the Default is already the id and is set
	 * directly. The commit closes the value-gate so this does not re-fire; a re-entrancy latch dedupes
	 * concurrent init passes while the read is in flight.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_applyConfiguredDefault(pView, pInput, pRowIndex)
	{
		if (pInput._DefaultResolving)
		{
			return;
		}
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		if (!tmpField || tmpField === this._getRecordIdentity(pInput))
		{
			this._setResolvedDefault(pView, pInput, pRowIndex, pInput.Default);
			return;
		}
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		if (!tmpEntity || !this.pict.HeadlightRestClient)
		{
			return;
		}
		pInput._DefaultResolving = true;
		this.pict.HeadlightRestClient.getJSON(`${tmpEntity}s/FilteredTo/FBV~${tmpField}~EQ~${encodeURIComponent(pInput.Default)}/0/1`, (pError, pRows) =>
		{
			pInput._DefaultResolving = false;
			const tmpRecord = (!pError && Array.isArray(pRows)) ? pRows[0] : null;
			if (tmpRecord)
			{
				this._setResolvedDefault(pView, pInput, pRowIndex, tmpRecord[this._getRecordIdentity(pInput)]);
			}
		});
	}

	/**
	 * Land a resolved default through the value-commit primitive (record refresh + cascade + repaint).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex @param {any} pValue
	 */
	_setResolvedDefault(pView, pInput, pRowIndex, pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '')
		{
			return;
		}
		this._setValueAndCommit(pView, pInput, pValue, pRowIndex);
	}

	/** The document's own project id (`ReportData.Project.IDProject`, else `ReportData.IDProject`), or null. @return {number|string|null} */
	_getDocumentProjectID()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		const tmpIDProject = tmpReportData?.Project?.IDProject || tmpReportData?.IDProject;
		return (Number(tmpIDProject) > 0) ? tmpIDProject : null;
	}

	/**
	 * Legacy ProjectSelector parity: an empty project field on an editable document takes the document's project,
	 * which saves the field and publishes `AppData.SelectedProject` for sample naming. A descriptor Default wins.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 * @return {string|null} - The committed project id, or null when nothing was committed.
	 */
	_applyDocumentProjectDefault(pView, pInput, pValue, pRowIndex)
	{
		if (!pInput || !pInput.PictForm || pInput.PictForm.InputType !== 'ProjectSelector')
		{
			return null;
		}
		if ((pInput.Default != null && pInput.Default !== '') || (pValue != null && pValue !== ''))
		{
			return null;
		}
		const tmpIDProject = this._getDocumentProjectID();
		if (!tmpIDProject || this.pict.AppData.DocumentData.ReportData.Locked)
		{
			return null;
		}
		this._setResolvedDefault(pView, pInput, pRowIndex, String(tmpIDProject));
		return String(tmpIDProject);
	}

	/**
	 * Wire the Bridge Search Panel to this picker (legacy BridgeSelector parity): a panel pick lands through the
	 * value-commit primitive, so the record refresh, cascade and repaint take the standard path. One callback
	 * slot, as legacy: the last BridgeSelector initialized wins.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 */
	_wireBridgeSearchPanel(pView, pInput, pRowIndex)
	{
		const tmpPanel = this.pict.views.HeadlightPaneBridges;
		if (!tmpPanel || typeof tmpPanel.setBridgeSelectionCallback !== 'function')
		{
			return;
		}
		tmpPanel.setBridgeSelectionCallback((pBridge) =>
		{
			if (pBridge && pBridge.IDBridge) { this._setValueAndCommit(pView, pInput, pBridge.IDBridge, pRowIndex); }
		});
	}

	/** Apply a declarative Default (MES-family fields) before the mount, mirroring MES.onInputInitialize:
	 *  pValue is blanked so the mount never renders a raw unresolved token; the async resolve lands
	 *  through _setValueAndCommit. BridgeSelector also claims the Bridge Search Panel here. */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._forgetCustomValues(pInput, null);
		const tmpProjectDefault = this._applyDocumentProjectDefault(pView, pInput, pValue, null);
		if (tmpProjectDefault !== null)
		{
			pValue = tmpProjectDefault;
		}
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			this._applyConfiguredDefault(pView, pInput, null);
			pValue = '';
		}
		if (pInput?.PictForm?.InputType === 'BridgeSelector')
		{
			this._wireBridgeSearchPanel(pView, pInput, null);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of onInputInitialize's default application and Bridge Search Panel wiring. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._forgetCustomValues(pInput, pRowIndex);
		const tmpProjectDefault = this._applyDocumentProjectDefault(pView, pInput, pValue, pRowIndex);
		if (tmpProjectDefault !== null)
		{
			pValue = tmpProjectDefault;
		}
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			this._applyConfiguredDefault(pView, pInput, pRowIndex);
			pValue = '';
		}
		if (pInput?.PictForm?.InputType === 'BridgeSelector')
		{
			this._wireBridgeSearchPanel(pView, pInput, pRowIndex);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	// --- Disabled-state parity (BUG-2) + open-dropdown re-render guard (BUG-1 interim) ---

	/** Register the Headlight Picker override CSS once (idempotent), above pict-section-picker's base block. */
	_ensureHeadlightPickerCSS()
	{
		if (this._headlightPickerCSSInjected) { return; }
		const tmpCSSMap = this.pict && this.pict.CSSMap;
		if (tmpCSSMap && typeof tmpCSSMap.addCSS === 'function')
		{
			tmpCSSMap.addCSS('Headlight-Picker-Overrides-CSS', _HEADLIGHT_PICKER_OVERRIDES_CSS, 600);
			if (typeof tmpCSSMap.injectCSS === 'function') { tmpCSSMap.injectCSS(); }
			this._headlightPickerCSSInjected = true;
		}
	}

	/**
	 * Reflect the descriptor's `PictForm.Disabled` onto the picker host as a `data-disabled` marker (BUG-2).
	 * pict-section-picker has no Disabled concept — its form-input maps only ReadOnly, which additionally
	 * strips the border + chevron — so a port-forwarded Disabled field would otherwise render as a fully
	 * interactive picker. The marker drives the greyed, non-interactive override CSS (chevron hidden),
	 * matching the sibling disabled inputs. Re-applied on every (re)mount because a full picker render
	 * rebuilds the widget DOM inside the host.
	 * @param {Record<string, any>} pInput @param {string} pHostSelector
	 */
	_reflectDisabledState(pInput, pHostSelector)
	{
		const tmpDisabled = !!(pInput && pInput.PictForm && pInput.PictForm.Disabled);
		const tmpElement = this.pict.ContentAssignment && this.pict.ContentAssignment.getElement(pHostSelector);
		const tmpHost = tmpElement && tmpElement[0];
		if (!tmpHost || typeof tmpHost.setAttribute !== 'function') { return; }
		if (tmpDisabled) { tmpHost.setAttribute('data-disabled', 'true'); }
		else if (typeof tmpHost.removeAttribute === 'function') { tmpHost.removeAttribute('data-disabled'); }
	}

	/** @param {string} pSelector @return {any} the first element the selector matches, or null. */
	_firstElement(pSelector)
	{
		const tmpElements = this.pict.ContentAssignment && this.pict.ContentAssignment.getElement(pSelector);
		return (tmpElements && tmpElements[0]) || null;
	}

	/**
	 * Reflect the descriptor's `PictForm.Required` onto the parts of the field the template can't reach
	 * (the template already marks the value input `data-required`): the value input's `data-empty-values`
	 * — this picker's unset sentinels, since an unset Number picker marshals in as 0, which InputValidation's
	 * value check would otherwise count as a selection — and `aria-required` on the widget's combobox.
	 * Re-applied after every (re)mount and commit because a picker render rebuilds the combobox.
	 * @param {Record<string, any>} pInput @param {string} pValueInputSelector @param {string} pHostSelector
	 */
	_reflectRequiredState(pInput, pValueInputSelector, pHostSelector)
	{
		const tmpRequired = !!(pInput && pInput.PictForm && pInput.PictForm.Required);
		const tmpValueInput = this._firstElement(pValueInputSelector);
		if (tmpValueInput && typeof tmpValueInput.setAttribute === 'function')
		{
			if (tmpRequired)
			{
				tmpValueInput.setAttribute('data-empty-values', JSON.stringify(this._resolveEmptyValues(pInput).map(String)));
			}
			else
			{
				tmpValueInput.removeAttribute('data-empty-values');
			}
		}
		const tmpHost = this._firstElement(pHostSelector);
		const tmpCombobox = (tmpHost && typeof tmpHost.querySelector === 'function') ? tmpHost.querySelector('[role="combobox"]') : null;
		if (!tmpCombobox)
		{
			return;
		}
		if (tmpRequired)
		{
			tmpCombobox.setAttribute('aria-required', 'true');
		}
		else
		{
			tmpCombobox.removeAttribute('aria-required');
		}
	}

	/**
	 * After a commit: re-apply the Required state the commit's render wiped, and — once the form has been
	 * submitted (`show-validation`) — revalidate the field, because a picker commit writes the value input
	 * without firing the DOM event InputValidation's form-level listener waits for.
	 * @param {Record<string, any>} pInput @param {string} pValueInputSelector @param {string} pHostSelector
	 */
	_syncRequiredStateAfterCommit(pInput, pValueInputSelector, pHostSelector)
	{
		this._reflectRequiredState(pInput, pValueInputSelector, pHostSelector);
		const tmpValidation = this.pict.providers && this.pict.providers.InputValidation;
		if (!tmpValidation || typeof tmpValidation.revalidateInputElement !== 'function')
		{
			return;
		}
		const tmpValueInput = this._firstElement(pValueInputSelector);
		if (!tmpValueInput || tmpValueInput.getAttribute('data-required') !== 'true')
		{
			return;
		}
		if (typeof tmpValueInput.closest !== 'function' || !tmpValueInput.closest('.show-validation'))
		{
			return;
		}
		tmpValidation.revalidateInputElement(tmpValueInput);
	}

	/**
	 * True when a picker is already mounted, its dropdown is OPEN, and its widget DOM is still present —
	 * i.e. the user is mid-interaction and this is a marshal re-render, not a section teardown.
	 *
	 * On a marshal-driven re-render (RenderMethod 'replace') we skip the destructive re-mount while the
	 * dropdown is open: the committed value is already reflected in the open picker, and skipping preserves
	 * the search box's text + focus mid-multi-pick (a full re-render rebuilds the search input empty). The
	 * DOM-presence check still lets a genuine teardown re-mount. (This originally also worked around a
	 * pre-1.9.0 position:fixed dropdown that detached on re-render; PSP 1.9.0's absolute/portal anchoring
	 * removed that failure mode, so the search/focus preservation is now the sole reason to keep the skip.)
	 * @param {string} pPickerHash @return {boolean}
	 */
	_isOpenAndMounted(pPickerHash)
	{
		const tmpView = this.pict.views && this.pict.views[pPickerHash];
		if (!tmpView || !tmpView._open) { return false; }
		if (typeof document === 'undefined') { return false; }
		return !!document.getElementById(`PPS_${pPickerHash}`);
	}

	/**
	 * Paint the Show-All toggle icon from the persisted override state on (re)mount — a full picker render
	 * rebuilds the field DOM, so the icon (default `fa-toggle-off` in the template) must be re-synced. No-op
	 * unless the field opts in via PictForm.ShowAllToggle or its config-map entry. Mirrors MES.onInputInitialize's icon sync.
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex]
	 */
	_syncShowAllIcon(pInput, pRowIndex)
	{
		if (!libFilterToggleUI.isToggleVisible(pInput)) { return; }
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		const tmpState = !!(tmpEngine && tmpEngine.isFilterOverridden(this._withMapFilterDefaults(pInput), (pRowIndex == null) ? undefined : pRowIndex));
		this._updateFilterToggleIcon(pInput.Macro.RawHTMLID, tmpState, pRowIndex);
		// The render-time macro already painted a manifest-declared Disabled; this catches a descriptor
		// disabled AFTER render, and re-paints it over the rebuilt field DOM a full picker render leaves.
		libFilterToggleUI.syncToggleDisabledState(this.pict, this.getSelectFilterToggleID(pInput.Macro.RawHTMLID, pRowIndex), libFilterToggleUI.isInputDisabled(pInput));
	}

	// --- Dynamic-filter dependent clearing (the legacy MES onAfterEventCompletion port, §9 parity) ---
	// When an ANCHOR field a picker depends on (PictForm.DynamicFilters[].TriggerGroupHash) changes, the
	// value already selected here may no longer belong to the new anchor. The engine narrows the OPTION
	// list per query, but only this pathway clears an already-committed stale value. Ported verbatim from
	// MaterialsEntitySelector (deleted in the §9 wave) and gated to the MES family like the legacy was —
	// generic entity pickers with TriggerGroupHash never auto-cleared legacy-side, so enabling it
	// base-wide would be a data-result change (the same reasoning as the _appliesConfiguredDefaults gate).

	/** True when this InputType inherits the legacy MES anchor-change clearing. @param {Record<string, any>} pInput */
	_clearsOnAnchorChange(pInput)
	{
		const tmpInputType = pInput?.PictForm?.InputType || '';
		return this._appliesConfiguredDefaults(pInput)
			|| tmpInputType === 'MaterialsEntitySelector'
			|| tmpInputType.startsWith('MaterialsHidden');
	}

	/**
	 * The shared clear decision: a TriggerGroup event from one of this input's DynamicFilters anchors
	 * clears the dependent value — unless the field opted into `PictForm.SmartClear`, which keeps the
	 * value when illegality can't be PROVEN (see _isSelectionIllegalForFilter).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {string} pEvent
	 * @param {number|string|null} pRowIndex
	 */
	_maybeClearForDynamicFilter(pView, pInput, pEvent, pRowIndex)
	{
		if (!this._clearsOnAnchorChange(pInput)) { return; }
		const tmpMatchedFilter = (pRowIndex == null)
			? this._matchedDynamicFilterForEvent(pInput, pEvent)
			: this._matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex);
		if (tmpMatchedFilter && (!pInput.PictForm?.SmartClear || this._isSelectionIllegalForFilter(pView, pInput, tmpMatchedFilter, pRowIndex)))
		{
			this._clearForDynamicFilter(pView, pInput, (pRowIndex == null) ? null : pRowIndex);
		}
	}

	/**
	 * Pure: does a global event target one of this input's DynamicFilters?
	 * Returns the matching filter entry, or null. Self-emitted events are ignored.
	 * @param {Record<string, any>} pInput @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEvent(pInput, pEvent)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters)) { return null; }
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup') { return null; }
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash) { return null; }
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Tabular sibling of `_matchedDynamicFilterForEvent`. A tabular anchor fires a ROW-SCOPED event
	 * (`TriggerGroup:<hash>:RecordRefresh:<emitter>:<rowIndex>:<uuid>`); the global broadcast delivers it
	 * to EVERY row, so a dependent column must act on its OWN row only — otherwise changing one row's
	 * anchor would wipe valid selections in every other row. A global (non-row-scoped) event has a UUID
	 * in slot [4], which parseInt yields NaN for, so it never matches here.
	 * @param {Record<string, any>} pInput @param {string} pEvent @param {number|string} pRowIndex
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters)) { return null; }
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup') { return null; }
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		const tmpEventRowIndex = parseInt(tmpParts[4], 10);
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash) { return null; }
		if (isNaN(tmpEventRowIndex) || tmpEventRowIndex !== Number(pRowIndex)) { return null; }
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Smart-clear gate (opt-in via `PictForm.SmartClear`). Returns true only when this picker's resolved
	 * record is DEFINITIVELY illegal for the changed anchor — the record carries the filter's `Field` and
	 * its value no longer equals the anchor's current value. When the record isn't resolved yet, lacks the
	 * FK, or the anchor is unset, illegality can't be proven, so we keep the value: this avoids clobbering a
	 * just-autofilled selection during sample projection, and preserves a user override that sits outside
	 * the filter.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {object} pFilter - the matched DynamicFilters entry (`{ Field, FromField | FromRowField, … }`).
	 * @param {number|string|null} [pRowIndex]
	 * @return {boolean} true only when the current selection is provably illegal for pFilter.
	 */
	_isSelectionIllegalForFilter(pView, pInput, pFilter, pRowIndex)
	{
		if (!pFilter || !pFilter.Field) { return false; }
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !(pFilter.Field in tmpRecord))
		{
			return false;
		}
		let tmpAnchorValue;
		if (pFilter.FromRowField && pRowIndex != null && pInput.PictForm && pInput.PictForm.InformaryContainerAddress)
		{
			const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pFilter.FromRowField);
			tmpAnchorValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
		}
		else if (pFilter.FromField)
		{
			tmpAnchorValue = this.pict.manifest.getValueByHash(this.pict, pFilter.FromField);
		}
		else
		{
			return false;
		}
		// An unset anchor imposes no constraint (applyDynamicFilters omits it), so nothing is illegal.
		const tmpAnchorNormalized = (tmpAnchorValue === null || tmpAnchorValue === undefined) ? '' : String(tmpAnchorValue).trim();
		if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0') { return false; }
		return String(tmpRecord[pFilter.Field]) !== tmpAnchorNormalized;
	}

	/**
	 * Reset this picker's value and its resolved-record companion (`__Record`), committed through
	 * _setValueAndCommit so the model, the hidden informary input and the mounted widget all reflect the
	 * cleared state (the legacy select2 val(null) + re-marshal, in Picker terms). `__Record` is reset to
	 * an EMPTY OBJECT (not deleted) to match the selector convention — record flows write fields into it
	 * and assume it is always an object. The next dropdown open re-fetches with the updated DynamicFilters
	 * (the new anchor value).
	 *
	 * Routed through `_handleEntitySelectionCleared` FIRST, so a programmatic clear of a creation-enabled
	 * field mints its tombstone and re-salts exactly like a user clear does — reusing the `__Salt` would
	 * make a later re-add upsert into the soft-deleted row.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_clearForDynamicFilter(pView, pInput, pRowIndex)
	{
		try
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex), {});
			this._setValueAndCommit(pView, pInput, pInput.Default ?? '', pRowIndex);
			this.pict.log.info(`DynamicFilter: cleared dependent input [${pInput.Hash}]${pRowIndex != null ? ` row ${pRowIndex}` : ''} after its anchor changed.`);
		}
		catch (pError)
		{
			this.pict.log.error(`DynamicFilter: failed to clear dependent input [${pInput && pInput.Hash}]: ${pError}`);
		}
	}

	/**
	 * Pure: does a global event correspond to an AUTOFILL into this input (an AutofillTriggerGroup entry
	 * whose TriggerGroupHash matches the event)? Self-emitted events, and entries flagged
	 * `AllowInvalidProjection` (record-projection sources whose out-of-scope values are legitimate), are
	 * skipped.
	 * @param {Record<string, any>} pInput @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedAutofillGroupForEvent(pInput, pEvent)
	{
		let tmpGroups = (pInput && pInput.PictForm) ? pInput.PictForm.AutofillTriggerGroup : null;
		if (!tmpGroups) { return null; }
		if (!Array.isArray(tmpGroups)) { tmpGroups = [ tmpGroups ]; }
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup') { return null; }
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash) { return null; }
		return tmpGroups.find((pGroup) => pGroup && pGroup.TriggerGroupHash === tmpGroupHash && !pGroup.AllowInvalidProjection) || null;
	}

	/**
	 * Vet this picker's current value against its own Through DynamicFilters and suppress it when it is
	 * PROVABLY not a legal option — the selected `ThroughSelect` id is absent from the resolved allowed
	 * set for the current anchor. Fail-open everywhere else (no anchor, unprimed scope, no value → keep).
	 * Async because query-strategy Through slices load on demand — which also means it runs after the
	 * synchronous autofill has landed the value. Opt-in via PictForm.VetAutofillScope.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Promise<void>}
	 */
	async _vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex)
	{
		const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
		const tmpResolver = this.pict.providers.ThroughScopeResolver;
		if (!Array.isArray(tmpFilters) || !tmpResolver) { return; }
		const tmpThroughFilters = tmpFilters.filter((pFilter) => pFilter && pFilter.Through && pFilter.ThroughSelect && pFilter.FromField);
		if (!tmpThroughFilters.length) { return; }
		const tmpDestination = pView.getMarshalDestinationObject();
		for (const tmpFilter of tmpThroughFilters)
		{
			const tmpAnchor = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			const tmpAnchorNormalized = (tmpAnchor === null || tmpAnchor === undefined) ? '' : String(tmpAnchor).trim();
			if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0') { continue; }
			const tmpRecord = this.pict.manifest.getValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex));
			let tmpSelected = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[tmpFilter.ThroughSelect] : null;
			if ((tmpSelected === null || tmpSelected === undefined || tmpSelected === '') && pRowIndex == null)
			{
				tmpSelected = this.pict.manifest.getValueAtAddress(tmpDestination, pInput.DataAddress);
			}
			if (tmpSelected === null || tmpSelected === undefined || tmpSelected === '' || Number(tmpSelected) === 0) { continue; }
			await tmpResolver.primeThroughSlice(tmpFilter, tmpAnchor);
			const tmpAllowed = tmpResolver.getThroughIDs(tmpFilter, tmpAnchor);
			// Fail-open backstop: an empty allowed set means the scope could not be resolved (sparse or missing
			// join data, or a failed prime) — that is "cannot constrain", not "everything is illegal". Clearing
			// on it would nuke a legitimately-chosen value. A genuinely-scoped anchor returns a non-empty set
			// and still clears an out-of-scope value below.
			if (!tmpAllowed || typeof tmpAllowed.has !== 'function' || tmpAllowed.size === 0)
			{
				continue;
			}
			if (!tmpAllowed.has(Number(tmpSelected)))
			{
				this._clearForDynamicFilter(pView, pInput, pRowIndex);
				return;
			}
		}
	}

	/**
	 * True while a record-refresh cascade is fanning out — a LOAD is authoritative, so persisted values
	 * must display rather than be re-vetted against the current filter scope. The counter lives on the
	 * pict instance under the name `MaterialsEntitySelector` sets, so a cascade fired by either family
	 * suppresses the vet in the other while both run on one form.
	 * @return {boolean}
	 */
	_isHydrating()
	{
		return !!this.pict._MaterialsEntityHydrationDepth;
	}

	/** The anchor-change event pathway (the legacy MES onAfterEventCompletion, ported): dependent clear +
	 *  autofill-scope vetting + idempotent scope re-priming for the new anchor. */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._maybeClearForDynamicFilter(pView, pInput, pEvent, null);
		if (pInput.PictForm?.VetAutofillScope && !this._isHydrating() && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, null).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		// Warm any query-strategy Through slice / lab scope for the new anchor value so a dependent
		// picker's INN clause resolves synchronously once it is opened. Both are idempotent (keyed
		// re-fetch only on change).
		this.pict.providers.ThroughScopeResolver?.primeQueryScopesFromForm?.();
		this.pict.providers.LabScopeResolver?.primeFromForm?.();
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/** Tabular twin: act on this row's own anchor events only (see _matchedDynamicFilterForEventTabular). */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._maybeClearForDynamicFilter(pView, pInput, pEvent, pRowIndex);
		if (pInput.PictForm?.VetAutofillScope && !this._isHydrating() && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		this.pict.providers.ThroughScopeResolver?.primeQueryScopesFromForm?.();
		this.pict.providers.LabScopeResolver?.primeFromForm?.();
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/** Override the mount: guard the destructive open re-render (BUG-1) + stamp the disabled marker (BUG-2)
	 *  and the Required state + sync the Show-All toggle icon. */
	_mountPicker(pView, pInput, pValue, pHostSelector, pPickerHash, fOnChange)
	{
		this._ensureHeadlightPickerCSS();
		if (this._isOpenAndMounted(pPickerHash)) { return true; }
		// A null row keeps the BaseFilter row-less while giving _applyFacetRules the view.
		const tmpMounted = this._withTabularContext(pView, null, () => super._mountPicker(pView, pInput, pValue, pHostSelector, pPickerHash, fOnChange), pValue);
		if (tmpMounted)
		{
			this._reflectDisabledState(pInput, pHostSelector);
			this._reflectRequiredState(pInput, pInput.Macro.HTMLSelector, pHostSelector);
			this._syncShowAllIcon(pInput);
		}
		return tmpMounted;
	}

	/** Tabular twin of _mountPicker. */
	_mountPickerTabular(pView, pInput, pValue, pRowIndex)
	{
		this._ensureHeadlightPickerCSS();
		// The tabular id helpers live on the (untyped-to-tsc) pict-section-picker base; reach them via a cast.
		const tmpSelf = /** @type {any} */ (this);
		const tmpHash = tmpSelf.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex);
		if (this._isOpenAndMounted(tmpHash)) { return true; }
		// Stash the row context so the _buildPickerConfig inside the super mount captures it into this row's
		// BaseFilter closure (plan §5.3). The arrow preserves super binding.
		const tmpMounted = this._withTabularContext(pView, pRowIndex, () => super._mountPickerTabular(pView, pInput, pValue, pRowIndex), pValue);
		if (tmpMounted)
		{
			const tmpHostSelector = tmpSelf.getTabularPickerHostID(pInput.Macro.RawHTMLID, pRowIndex);
			this._reflectDisabledState(pInput, tmpHostSelector);
			this._reflectRequiredState(pInput, tmpSelf.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex), tmpHostSelector);
			this._syncShowAllIcon(pInput, pRowIndex);
		}
		return tmpMounted;
	}
}

module.exports = PictProviderInputTypePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./_EntityDisplayName.js":133,"./_EntityOptionSource.js":135,"./_FilterToggleUI.js":136,"./_LabRouting.js":137,"./_PickerEmptyValues.js":138,"./_SharedEntityRead.js":140,"./_SpecializedSelectorMap.js":141,"./_VocabularySelectorMap.js":145,"pict-section-picker/form":604}],96:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
// R2: shared with the Picker broker so a specialized selector's provider-hardcoded Entity resolves
// identically for the Read/Print display as it does for the Edit picker.
const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');
// Managed code lists (SampleStatus, …): the Read/Print label comes from the same table the Edit picker
// reads, so a status curated by the customer is not shown as its bare code here.
const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');
const libTestResultOptions = require('./_TestResultOptions.js');
const libEntityOptionSource = require('./_EntityOptionSource.js');
// The SAME "what counts as unset" rule the EDIT picker applies — shared rather than re-derived so
// Read/Print cannot drift from Edit, the failure mode this provider family keeps hitting.
const libPickerEmptyValues = require('./_PickerEmptyValues.js');
// The SAME display-name resolution order the legacy Select2Util chain applies (dotted paths, the
// Name-less User table) — shared so flipping a forward onto this provider is a no-visual-change move.
const libEntityDisplayName = require('./_EntityDisplayName.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

/**
 * PickerDisplay — the non-interactive Read/Print display for InputType 'Picker' (and the legacy
 * InputTypes port-forwarded onto it). ONE provider serves BOTH themes: it resolves the field's stored
 * value to its display markup — a static `SelectOptions` label, or an entity's name (Entity path), with
 * an optional EntityTag badge — and paints it into the `PICKER-DISPLAY-FOR` node the Read/Print templates
 * render. Read and Print differ only in the TEMPLATE that styles that node (Read = a locked control;
 * Print = static PDF text), so no second provider is needed — mirrors how `EntityDisplay` serves both.
 *
 * This lets the Picker stack own its own read/print display, so the legacy `Option` / `EntityDisplay`
 * display providers can eventually be decommissioned (plan §9). Value resolution is kept output-identical
 * to the legacy providers so flipping the forwards is a no-visual-change move:
 *   - static: the same `SelectOptions`/`SelectOptionsPickList` lookup as `Select.handlePDFDisplay`;
 *   - entity: the entity NAME + optional EntityTag badge, matching `EntityDisplay(Multiple)`'s compound
 *     output — but resolved through pict-section-picker's `createEntityResolveValue` (NOT
 *     `Select2Util.getEntityAsync`), so this provider carries no Select2Util dependency at decommission.
 *
 * NOTE (plan §9 cleanup): the compound markup deliberately keeps the legacy `.select2-*-entity-selection`
 * / `.tag.select2-entity-tag` class names so bulma-print.scss styles it identically in Read + PDF today.
 * When select2 CSS is retired, rename those classes here AND in bulma-print.scss in lockstep (they are
 * plain strings this provider owns — there is no code dependency on Select2Util).
 */
class PickerDisplayProvider extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/** @param {string} pRawHTMLID @return {string} */
	getDisplayNodeID(pRawHTMLID)
	{
		return `#PICKER-DISPLAY-FOR-${pRawHTMLID}`;
	}

	/** @param {string} pRawHTMLID @param {number|string} pRowIndex @return {string} */
	getTabularDisplayNodeID(pRawHTMLID, pRowIndex)
	{
		return `#PICKER-DISPLAY-TABULAR-DATA-${pRawHTMLID}-${pRowIndex}`;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Fire-and-forget: the entity path is async, and the base class hook is synchronous (same shape as
		// EntityDisplay's FIXME). The node is painted whenever the resolve settles.
		this._paint(pView, pInput, pValue, null).catch((pError) => this.pict.log.error(`PickerDisplay paint error: ${pError}`));
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._paint(pView, pInput, pValue, pRowIndex).catch((pError) => this.pict.log.error(`PickerDisplay paint error: ${pError}`));
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Resolve the value → display markup and paint it into the Read/Print display node (no-op when the node
	 * is absent, e.g. the Edit theme).
	 * @param {object} pView @param {object} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 * @return {Promise<boolean>}
	 */
	async _paint(pView, pInput, pValue, pRowIndex)
	{
		const tmpNodeID = pRowIndex != null ?
			this.getTabularDisplayNodeID(pInput.Macro.RawHTMLID, pRowIndex) :
			this.getDisplayNodeID(pInput.Macro.RawHTMLID);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpNodeID);
		if (!tmpElements || tmpElements.length < 1)
		{
			return false;
		}
		const tmpHTML = await this._buildDisplayHTML(pInput, pValue, pView, pRowIndex);
		this.pict.ContentAssignment.assignContent(tmpElements[0], tmpHTML);
		return true;
	}

	/** Whether this field holds multiple values — the legacy multi InputTypes, or an explicit `Multiple`. */
	_isMulti(pPictForm)
	{
		return !!(pPictForm.Multiple || pPictForm.InputType === 'Select2Multiple' || pPictForm.InputType === 'EntitySelectorMultiple');
	}

	/** Split the stored value into parts (multi = CSV). Unset → []. */
	_valueParts(pPictForm, pValue)
	{
		if (pValue === null || pValue === undefined || pValue === '')
		{
			return [];
		}
		if (this._isMulti(pPictForm))
		{
			return String(pValue).split(',').map((pPart) => pPart.trim()).filter((pPart) => pPart !== '');
		}
		return [ pValue ];
	}

	/**
	 * The field's PictForm, augmented for a specialized selector (LabSelector, …) whose Entity is
	 * provider-hardcoded rather than descriptor-carried: inject the inferred Entity + display field from
	 * the shared map so the entity-resolve path fires exactly as it would for a descriptor that carries
	 * Entity. A descriptor naming the map's own Entity still takes the map's display config (legacy ignored
	 * the descriptor's Entity); a non-specialized InputType, or one naming a different Entity, is untouched.
	 * @param {object} pInput @return {Record<string, any>}
	 */
	_resolvedPictForm(pInput)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput);
		// Static result codes: the acceptance input stamps these in its own initialize hooks, which never
		// run in Read/Print, so without this the display prints the raw code (PEND) instead of Pending.
		libTestResultOptions.applyTestResultOptions(pInput);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType];
		if (!tmpSpecialized || (tmpPictForm.Entity && tmpPictForm.Entity !== tmpSpecialized.Entity)) { return tmpPictForm; }
		return Object.assign({}, tmpPictForm,
		{
			Entity: tmpSpecialized.Entity,
			TextField: tmpPictForm.TextField || tmpPictForm.EntityDisplayField || tmpSpecialized.TextField,
			EntityTag: tmpPictForm.EntityTag || tmpSpecialized.EntityTag,
			RecordIdentity: tmpPictForm.RecordIdentity || tmpSpecialized.RecordIdentity,
			// A multi-by-default selector (Lab/LineItem) gets Multiple from its EDIT provider's init at
			// runtime — which never runs in Read/Print, so the map carries it (?? keeps an explicit false).
			Multiple: tmpPictForm.Multiple ?? tmpSpecialized.Multiple,
		});
	}

	/**
	 * The field the committed value identifies its record by — mirrors the broker/cascade identity
	 * precedence (a GUID/Hash-identity selector like Sample or Test carries its RecordIdentity through
	 * the shared map, so the display resolves the SAME way the Edit picker committed).
	 * @param {object} pPictForm @return {string}
	 */
	_identityField(pPictForm)
	{
		return pPictForm.RecordIdentity || pPictForm.IdentityField || `ID${pPictForm.Entity || ''}`;
	}

	/**
	 * The field's `__Record` address — the broker's address scheme replicated (an explicit
	 * PictForm.RecordAddress wins; tabular composes through Informary).
	 * @param {object} pInput @param {number|string|null} pRowIndex @return {string}
	 */
	_recordAddress(pInput, pRowIndex)
	{
		if (pInput.PictForm?.RecordAddress)
		{
			return pInput.PictForm.RecordAddress;
		}
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + '__Record';
		}
		return `${pInput.DataAddress || pInput.Hash}__Record`;
	}

	/**
	 * The locally persisted `__Record` snapshot(s) for this field, always as an array (multi persists an
	 * array, single an object). Saved forms persist `__Record` beside the value, and a created-but-unsaved
	 * record exists ONLY here — so the display resolves from it first, before any fetch.
	 * @param {object} pView @param {object} pInput @param {number|string|null} pRowIndex
	 * @return {Array<Record<string, any>>}
	 */
	_localEntityRecords(pView, pInput, pRowIndex)
	{
		if (!pView || typeof pView.getMarshalDestinationObject !== 'function')
		{
			return [];
		}
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._recordAddress(pInput, pRowIndex));
		if (Array.isArray(tmpRecord))
		{
			return tmpRecord.filter((pEntry) => pEntry && typeof pEntry === 'object');
		}
		return (tmpRecord && typeof tmpRecord === 'object' && Object.keys(tmpRecord).length > 0) ? [ tmpRecord ] : [];
	}

	/**
	 *`{ name, tag }` straight off a full entity record (the `__Record` / identity-fetch paths): name from
	 * the display field, tag from EntityTag — including the legacy `<Field>:date` tag format.
	 * @param {Record<string, any>} pRecord @param {object} pPictForm @param {string} [pFieldLabel]
	 * @return {{name:string, tag:any}}
	 */
	_recordParts(pRecord, pPictForm, pFieldLabel)
	{
		// No fallback thunk: the TextField branch never calls one, so the blank case is labelled here instead.
		let tmpName = libEntityDisplayName.resolveEntityDisplayName(pPictForm.Entity, pRecord, pPictForm);
		if (tmpName === undefined || tmpName === null || String(tmpName).trim() === '')
		{
			tmpName = this._unnamedLabel(pPictForm, pRecord, undefined, pFieldLabel);
		}
		let tmpTag = null;
		if (pPictForm.EntityTag)
		{
			let tmpTagField = pPictForm.EntityTag;
			const tmpIsDate = tmpTagField.includes(':date');
			if (tmpIsDate)
			{
				tmpTagField = tmpTagField.replace(':date', '');
			}
			tmpTag = pRecord[tmpTagField];
			if (tmpIsDate && tmpTag && this.pict.Dates?.dayJS)
			{
				tmpTag = this.pict.Dates.dayJS(tmpTag).format('YYYY-MM-DD');
			}
			if (tmpTag === undefined || tmpTag === null || tmpTag === '')
			{
				tmpTag = null;
			}
		}
		return { name: (tmpName === undefined || tmpName === null) ? '' : String(tmpName), tag: tmpTag };
	}

	/**
	 * Build the display HTML for the stored value(s): plain comma-joined label(s) for static / untagged
	 * entity fields, or the compound `[tag] name` markup (comma-joined for multi) when an EntityTag is
	 * configured — output-identical to EntityDisplay(Multiple). Empty value → ''. pView/pRowIndex (when
	 * the caller has them) enable the `__Record`-first resolve.
	 * @param {object} pInput @param {any} pValue @param {object} [pView] @param {number|string|null} [pRowIndex]
	 * @return {Promise<string>}
	 */
	async _buildDisplayHTML(pInput, pValue, pView, pRowIndex)
	{
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpParts = await this._resolveParts(pInput, pValue, pView, pRowIndex);
		if (tmpParts.length < 1)
		{
			return '';
		}
		// Compound tag+name only when an EntityTag is configured (entity fields); everything else is a
		// plain, comma-joined label list (the current, verified behavior).
		if (tmpPictForm.Entity && tmpPictForm.EntityTag)
		{
			const tmpMulti = this._isMulti(tmpPictForm);
			const tmpTagLast = !!tmpPictForm.EntityTagLast;
			// A configured-but-empty tag paints no badge at all — per part, so a mixed list still tags the
			// records that have one. The bare name is exactly what an untagged entity descriptor renders,
			// which also keeps the badge-compensating print padding on .select2-single-entity-selection off
			// a field with no badge to compensate for. Every tag path normalizes ''/undefined to null, so a
			// numeric 0 stays a real tag.
			return tmpParts.map((pPart) => (pPart.tag == null) ?
				this._nameHTML(pPart.name) :
				this._compoundDisplayHTML(pPart.tag, this._nameHTML(pPart.name), tmpMulti, tmpTagLast)).join(', ');
		}
		return tmpParts.map((pPart) => this._nameHTML(pPart.name)).join(', ');
	}

	/**
	 * The name an entity record with no display name paints: `<entity label> #<record ID>` (`Document #282`),
	 * the same label the Edit picker gives it. The record's own ID column wins over pFallbackID; '' when
	 * neither is set, which leaves _nameHTML's faded marker.
	 * @param {object} pPictForm @param {Record<string, any>|undefined} pRecord @param {any} pFallbackID
	 * @param {string} [pFieldLabel] - the field's label, which names an Organization's role.
	 * @return {string}
	 */
	_unnamedLabel(pPictForm, pRecord, pFallbackID, pFieldLabel)
	{
		const tmpRecordID = pRecord ? pRecord[`ID${pPictForm.Entity}`] : undefined;
		const tmpID = (tmpRecordID === undefined || tmpRecordID === null || tmpRecordID === '') ? pFallbackID : tmpRecordID;
		return libEntityDisplayName.unnamedEntityLabel(pPictForm.Entity, tmpID, pFieldLabel);
	}

	/**
	 * A display name, substituting a faded "no text provided" marker for a blank/missing value so a
	 * user/developer can spot bad data (a static option with no text, or an entity name with no ID to label
	 * it by) rather than an invisible gap. Non-blank names pass through unchanged.
	 * @param {any} pName @return {string}
	 */
	_nameHTML(pName)
	{
		if (pName === undefined || pName === null || String(pName).trim() === '')
		{
			return '<span class="picker-display-empty">no text provided</span>';
		}
		return String(pName);
	}

	/**
	 * Resolve each stored value to `{ name, tag }`. Entity fields resolve System-1-first: the persisted
	 * `__Record` snapshot whose identity matches the value (covers created-but-unsaved records, which no
	 * fetch can serve, and costs nothing for saved forms); then a NON-simple identity (GUID/Hash — the
	 * cascade family) fetches the legacy `FBL~<identity>~INN` shape through the broker; a plain numeric
	 * identity rides pict-section-picker's `createEntityResolveValue` (the original path). Static fields
	 * resolve their option label (tag null).
	 * @param {object} pInput @param {any} pValue @param {object} [pView] @param {number|string|null} [pRowIndex]
	 * @return {Promise<Array<{name:string, tag:any}>>}
	 */
	async _resolveParts(pInput, pValue, pView, pRowIndex)
	{
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpValues = this._valueParts(tmpPictForm, pValue);
		if (tmpValues.length < 1)
		{
			return [];
		}
		// Unset sentinels (a pristine Number descriptor marshals in as manyfest's DataType default 0)
		// resolve to nothing, exactly as the edit picker paints its placeholder for them — there is no
		// entity #0 to fetch, and a bare "0" in a PDF reads as a bug. Static option lists keep the
		// widget's escape hatch below: a sentinel that IS a real option is a genuine selection.
		const tmpIsSentinel = (pValuePart) => libPickerEmptyValues.isEmptyValue(pInput, pValuePart);
		if (tmpPictForm.Entity)
		{
			const tmpEntityValues = tmpValues.filter((pValuePart) => !tmpIsSentinel(pValuePart));
			if (tmpEntityValues.length < 1)
			{
				return [];
			}
			const tmpIdentity = this._identityField(tmpPictForm);
			const tmpLocalRecords = this._localEntityRecords(pView, pInput, pRowIndex == null ? null : pRowIndex);
			const tmpResolver = (tmpIdentity === `ID${tmpPictForm.Entity}`) ? this._entityResolver(tmpPictForm) : null;
			const tmpFieldLabel = pInput && pInput.Name;
			return Promise.all(tmpEntityValues.map((pValuePart) =>
			{
				const tmpLocal = tmpLocalRecords.find((pRecord) => pRecord[tmpIdentity] == pValuePart);
				if (tmpLocal)
				{
					return Promise.resolve(this._recordParts(tmpLocal, tmpPictForm, tmpFieldLabel));
				}
				if (!tmpResolver)
				{
					return this._resolveEntityByIdentity(tmpPictForm, tmpIdentity, pValuePart, tmpFieldLabel);
				}
				return this._resolveEntity(tmpResolver, tmpPictForm, pValuePart, tmpFieldLabel);
			}));
		}
		const tmpOptions = await this._resolveStaticOptions(tmpPictForm);
		return tmpValues
			.filter((pValuePart) => !tmpIsSentinel(pValuePart) || tmpOptions.some((pOption) => String(pOption.id) === String(pValuePart)))
			.map((pValuePart) => ({ name: this._resolveOptionLabel(tmpOptions, pValuePart), tag: null }));
	}

	/**
	 * value → `{ name, tag }` by a NON-simple identity (GUID/Hash), through the broker's legacy-shape
	 * fetch (`FBL~<identity>~INN`) — getEntity/createEntityResolveValue can only look up by numeric id.
	 * No match (e.g. an unsaved GUID with no local snapshot) degrades to the raw value, like the id path.
	 * @param {object} pPictForm @param {string} pIdentityField @param {any} pValue @param {string} [pFieldLabel]
	 * @return {Promise<{name:string, tag:any}>}
	 */
	async _resolveEntityByIdentity(pPictForm, pIdentityField, pValue, pFieldLabel)
	{
		const tmpBroker = this.pict.providers.Picker;
		if (!tmpBroker || typeof tmpBroker._resolveEntityRecordByIdentity !== 'function')
		{
			this.pict.log.warn('PickerDisplay: the Picker broker is not registered; cannot resolve by identity.');
			return { name: String(pValue), tag: null };
		}
		const tmpRecord = await tmpBroker._resolveEntityRecordByIdentity(pPictForm.Entity, pIdentityField, pValue);
		if (!tmpRecord)
		{
			return { name: String(pValue), tag: null };
		}
		return this._recordParts(tmpRecord, pPictForm, pFieldLabel);
	}

	/**
	 * Build a pict-section-picker entity `ResolveValue(value) => Promise<{Text, Tag, ...}>` from the
	 * descriptor vocab (IdentityField → ValueField, EntityDisplayField → TextField, Join* / EntityTag
	 * passed through). Replaces the Select2Util.getEntityAsync resolve. Null when the picker provider
	 * isn't registered.
	 * @param {object} pPictForm @return {((pValue:any) => Promise<any>)|null}
	 */
	_entityResolver(pPictForm)
	{
		const tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpProvider || typeof tmpProvider.createEntityResolveValue !== 'function')
		{
			this.pict.log.warn('PickerDisplay: the Pict-Section-Picker provider is not registered; cannot resolve entity display names.');
			return null;
		}
		return tmpProvider.createEntityResolveValue(
		{
			Entity: pPictForm.Entity,
			ValueField: pPictForm.ValueField || pPictForm.IdentityField,
			TextField: pPictForm.TextField || pPictForm.EntityDisplayField,
			TextTemplate: pPictForm.TextTemplate,
			JoinEntity: pPictForm.JoinEntity,
			JoinField: pPictForm.JoinField,
			JoinEntityValueField: pPictForm.JoinEntityValueField,
			JoinEntityDisplayField: pPictForm.JoinEntityDisplayField,
			JoinEntityFirst: pPictForm.JoinEntityFirst,
			JoinSeparator: pPictForm.JoinSeparator,
			EntityTag: pPictForm.EntityTag,
			EntityTags: pPictForm.EntityTags,
		});
	}

	/**
	 * Whether the picker's own flat `pRecord[TextField]` provably cannot produce this descriptor's label,
	 * so the display has to resolve the name locally: a DOTTED display field, or a `User` with none
	 * configured (that table has no `Name` column, which is what the picker defaults to). Narrow on
	 * purpose — a TextTemplate or a JoinEntity compound is the picker's to compose, and recomputing
	 * locally would drop it.
	 * @param {object} pPictForm @return {boolean}
	 */
	_needsLocalNameResolution(pPictForm)
	{
		if (pPictForm.TextTemplate || pPictForm.JoinEntity)
		{
			return false;
		}
		const tmpDisplayField = pPictForm.TextField || pPictForm.EntityDisplayField;
		if (tmpDisplayField)
		{
			return tmpDisplayField.includes('.');
		}
		return pPictForm.Entity === 'User';
	}

	/**
	 * value (id) → `{ name, tag }` via the picker's ResolveValue. Missing entity, a failed read or a resolve
	 * error → the raw value as the name with no tag (never throws — the display degrades gracefully).
	 * @param {((pValue:any) => Promise<any>)|null} pResolver @param {object} pPictForm @param {any} pValue
	 * @param {string} [pFieldLabel]
	 * @return {Promise<{name:string, tag:any}>}
	 */
	async _resolveEntity(pResolver, pPictForm, pValue, pFieldLabel)
	{
		try
		{
			const tmpResolved = pResolver ? await pResolver(pValue) : null;
			if (!tmpResolved || (tmpResolved.Record && !libSharedEntityRead.isEntityRecord(pPictForm.Entity, tmpResolved.Record)))
			{
				return { name: String(pValue), tag: null };
			}
			// The picker composes its Text with a FLAT `pRecord[TextField]` (defaulting to 'Name'), which
			// cannot serve a dotted display field or the Name-less User table — so for those two shapes the
			// label is recomputed here off the record the resolve carries back. Same helper as the __Record
			// path, so all three entity paths in this provider agree.
			if (tmpResolved.Record && this._needsLocalNameResolution(pPictForm))
			{
				return this._recordParts(tmpResolved.Record, pPictForm, pFieldLabel);
			}
			const tmpName = (tmpResolved.Text !== undefined && tmpResolved.Text !== null && String(tmpResolved.Text).trim() !== '') ?
				tmpResolved.Text :
				this._unnamedLabel(pPictForm, tmpResolved.Record, pValue, pFieldLabel);
			const tmpTag = (tmpResolved.Tag !== undefined && tmpResolved.Tag !== null && tmpResolved.Tag !== '') ? tmpResolved.Tag : null;
			return { name: tmpName, tag: tmpTag };
		}
		catch (pError)
		{
			this.pict.log.warn(`PickerDisplay: could not resolve ${pPictForm.Entity} #${pValue} for display.`, pError);
			return { name: String(pValue), tag: null };
		}
	}

	/**
	 * The compound `[tag] name` markup for one entity value — output-identical to Select2Util's
	 * buildSelect2CompoundDisplayTemplate (styled by bulma-print.scss in Read + PDF), but built here so the
	 * provider carries no Select2Util code dependency. See the class NOTE re: the §9 class-name rename.
	 * @param {any} pTag @param {any} pName @param {boolean} pMultiple @param {boolean} pTagAtEnd @return {string}
	 */
	_compoundDisplayHTML(pTag, pName, pMultiple, pTagAtEnd)
	{
		const tmpName = `<span class="select2-entity-name">${pName === undefined || pName === null ? '' : pName}</span>`;
		const tmpTag = `<span class="tag select2-entity-tag">${pTag}</span>`;
		const tmpInner = pTagAtEnd ? `${tmpName}${tmpTag}` : `${tmpTag}${tmpName}`;
		return `<span class="select2-${pMultiple ? 'multiple' : 'single'}-entity-selection">${tmpInner}</span>`;
	}

	/**
	 * The option set to label a non-entity value with: a managed vocabulary's rows when the field is
	 * backed by one (falling back to its static list for a customer with no rows), else the static set.
	 * @param {object} pPictForm @return {Promise<Array<{id:any, text:string}>>}
	 */
	async _resolveStaticOptions(pPictForm)
	{
		if (pPictForm.SelectOptionsEntity)
		{
			return libEntityOptionSource.resolveOptionsAsync(this, { PictForm: pPictForm });
		}
		return this._staticOptions(pPictForm);
	}

	/**
	 * The static option set for a non-entity field: the inline `SelectOptions`, or a resolved
	 * `SelectOptionsPickList` (mirrors PictProvider-InputType-Select.handlePDFDisplay).
	 * @param {object} pPictForm @return {Array<{id:any, text:string}>}
	 */
	_staticOptions(pPictForm)
	{
		let tmpData = Array.isArray(pPictForm.SelectOptions) ? pPictForm.SelectOptions : null;
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if ((!tmpData || tmpData.length < 1) && pPictForm.SelectOptionsPickList && tmpMetaLists &&
			typeof tmpMetaLists.hasList === 'function' && tmpMetaLists.hasList(pPictForm.SelectOptionsPickList))
		{
			tmpData = tmpMetaLists.getList(pPictForm.SelectOptionsPickList);
		}
		return tmpData || [];
	}

	/** value → the matching option's text; falls back to the raw value when it isn't in the set. */
	_resolveOptionLabel(pOptions, pValue)
	{
		const tmpMatch = pOptions.find((pOption) => String(pOption.id) === String(pValue));
		return tmpMatch ? tmpMatch.text : String(pValue);
	}
}

module.exports = PickerDisplayProvider;

},{"./_EntityDisplayName.js":133,"./_EntityOptionSource.js":135,"./_PickerEmptyValues.js":138,"./_SharedEntityRead.js":140,"./_SpecializedSelectorMap.js":141,"./_TestResultOptions.js":143,"./_VocabularySelectorMap.js":145,"pict-section-form":497}],97:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PLANT-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Plant for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Plant record yet, get it and store it
			if (!this.pict.AppData.SelectedPlant || this.pict.AppData.SelectedPlant.length < 1)
			{
				const tmpResult = await this.pict.providers.PlantProvider.getPlantByID(pValue);
				this.pict.AppData.SelectedPlant = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedPlant?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],98:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PLANT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('ProductionPlant',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Plant...',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Plant for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Plant and set it as the selected Plant on the data object
			const tmpPlant = await this.pict.providers.PlantProvider.getPlantByID(pValue);
			this.pict.AppData.SelectedPlant = tmpPlant;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedPlant.IDProductionPlant;
			tmpOption.text = this.pict.AppData.SelectedPlant.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],99:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class PrecompiledFileSelectorInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getToggleInputHTMLID(pInputHTMLID)
	{
		return `#TOGGLE-FOR-${pInputHTMLID}`;
	}

	getHiddenInputHTMLID(pInputHTMLID)
	{
		return `#PREVIOUS-VALUE-${pInputHTMLID}`;
	}

	getDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	getToggleableContainerHTMLID(pInputHTMLID)
	{
		return `#TOGGLE-CONTAINER-FOR-${pInputHTMLID}`;
	}

	getClearButtonHTMLID(pInputHTMLID)
	{
		return `#CLEAR-BUTTON-FOR-${pInputHTMLID}`;
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// get current visible value
		const tmpInputElements = this.pict.ContentAssignment.getElement('#' + pInput.Macro.RawHTMLID);
		if (!Array.isArray(tmpInputElements) || tmpInputElements.length < 1)
		{
			return false;
		}
		const tmpInputElement = tmpInputElements[0];
		if (!(tmpInputElement instanceof HTMLInputElement))
		{
			return false;
		}
		const currentValue = tmpInputElement.value;
		// update hidden input value
		const tmpHiddenElements = this.pict.ContentAssignment.getElement('#' + pInput.Macro.RawHTMLID);
		if (!Array.isArray(tmpHiddenElements) || tmpHiddenElements.length < 1)
		{
			return false;
		}
		const tmpHiddenElement = tmpHiddenElements[0];
		if (!(tmpHiddenElement instanceof HTMLInputElement))
		{
			return false;
		}
		tmpInputElement.value = '0';
		if (parseInt(currentValue) > 0)
		{
			// we don't clear values here, so we can remember the previous value
			tmpHiddenElement.value = currentValue;
		}
		this.handleDisplayInputValue(pInput, currentValue);
		// update the clear button visibility
		this.handleClearButtonVisbility(pInput, currentValue);

		// update visible input value
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the visibility of the clear button based on the input value.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be set.
	 */
	handleClearButtonVisbility(pInput, pValue)
	{
		const tmpClearButtonElements = this.pict.ContentAssignment.getElement(this.getClearButtonHTMLID(pInput.Macro.RawHTMLID));
		if (Array.isArray(tmpClearButtonElements) && tmpClearButtonElements.length > 0)
		{
			const tmpClearButtonElement = tmpClearButtonElements[0];
			if (tmpClearButtonElement instanceof HTMLButtonElement)
			{
				tmpClearButtonElement.style.visibility = pValue && Number(pValue) !== 0 && !isNaN(Number(pValue)) ? 'visible' : 'hidden';
			}
		}
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be set.
	 * @param {boolean} [setInputVisibility=false] - Whether to set the input visibility.
	 */
	async handleInputValue(pInput, pValue, setInputVisibility = false)
	{
		const tmpInputElements = this.pict.ContentAssignment.getElement('#' + pInput.Macro.RawHTMLID);
		if (Array.isArray(tmpInputElements) && tmpInputElements.length > 0)
		{
			const tmpInputElement = tmpInputElements[0];
			if (tmpInputElement instanceof HTMLDivElement)
			{
				if (setInputVisibility)
				{
					this.pict.ContentAssignment.setAttribute(tmpInputElement, 'visibility', 'visible');
				}
				else
				{
					this.pict.ContentAssignment.setAttribute(tmpInputElement, 'visibility', 'hidden');
				}
				// set the input value to the ID
				this.pict.ContentAssignment.assignContent(tmpInputElement, pValue);
			}
		}
	}

	/**
	 * Handles the display of the input value in the Pict provider.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be displayed.
	 * @return {Promise<void>} - A promise that resolves when the display is updated.
	 */
	async handleDisplayInputValue(pInput, pValue)
	{
		const tmpDisplayElements = this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInput.Macro.RawHTMLID));
		if (Array.isArray(tmpDisplayElements) && tmpDisplayElements.length > 0)
		{
			const tmpDisplayElement = tmpDisplayElements[0];
			if (tmpDisplayElement instanceof HTMLDivElement)
			{
				if (pValue && Number(pValue) !== 0 && !isNaN(Number(pValue)))
				{
					// look up the observation to get the Name and Description
					const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pValue);
					if (tmpObservation)
					{
						const tmpName = tmpObservation.Name || `Unnamed Observation #${pValue}`;
						const tmpDescription = tmpObservation.Description || 'No description available';
						// set the input value to the ID and Name in a predefined format
						const tmpValue = `<span class="tag has-background-text-90 mr-2">#${pValue}</span> <strong class="mr-1">${tmpName}</strong> - <em class="ml-1">${tmpDescription}</em>`;
						this.pict.ContentAssignment.assignContent(tmpDisplayElement, tmpValue);
					}
				}
				else
				{
					this.pict.ContentAssignment.assignContent(tmpDisplayElement, '');
				}
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true);
		this.handleDisplayInputValue(pInput, pValue);
		this.handleClearButtonVisbility(pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true);
		this.handleDisplayInputValue(pInput, pValue);
		this.handleClearButtonVisbility(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputNumericValue = this.pict.ContentAssignment.readContent(pInput.Macro.RawHTMLID);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputNumericValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputNumericValue, pHTMLSelector);
	}
}

module.exports = PrecompiledFileSelectorInputHandler;

},{"pict-section-form":497}],100:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCER-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Producer for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Producer record yet, get it and store it
			if (!this.pict.AppData.SelectedProducer || this.pict.AppData.SelectedProducer.length < 1)
			{
				const tmpResult = await this.pict.providers.ProducerProvider.getProducerByID(pValue);
				this.pict.AppData.SelectedProducer = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedProducer?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],101:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCER-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Organization',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Producer...',
					GetRecordName: (pOrg) => `${pOrg.Name || ('Unnamed Producer #' + pOrg.IDOrganization)}`,
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Producer for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Producer and set it as the selected Producer on the data object
			const tmpProducer = await this.pict.providers.ProducerProvider.getProducerByID(pValue);
			this.pict.AppData.SelectedProducer = tmpProducer;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedProducer.IDOrganization;
			tmpOption.text = this.pict.AppData.SelectedProducer.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],102:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCT-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Product for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Product record yet, get it and store it
			if (!this.pict.AppData.SelectedProduct || this.pict.AppData.SelectedProduct.length < 1)
			{
				const tmpResult = await this.pict.providers.ProductProvider.getProductByID(pValue);
				this.pict.AppData.SelectedProduct = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedProduct?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],103:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Product',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Product...',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Product for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Product and set it as the selected Product on the data object
			const tmpProduct = await this.pict.providers.ProductProvider.getProductByID(pValue);
			this.pict.AppData.SelectedProduct = tmpProduct;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedProduct.IDProduct;
			tmpOption.text = this.pict.AppData.SelectedProduct.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],104:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PROJECT-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Project for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Project record yet, get it and store it
			if (!this.pict.AppData.SelectedProject || this.pict.AppData.SelectedProject.length < 1)
			{
				const tmpResult = await this.pict.providers.ProjectProvider.getProjectByID(pValue);
				this.pict.AppData.SelectedProject = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedProject?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],105:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PROJECT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 *
	 * @param {object} pInput - The input object.
	 * @param {number} [pRowIndex] - The row index for tabular data (optional).
	 */
	addLoadingSkeleton(pInput, pRowIndex)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		if (pRowIndex != null)
		{
			this.pict.ContentAssignment.getElement(this.getTabularSelectInputID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
			this.pict.ContentAssignment.addClass(this.getTabularSelectInputID(pInput.Macro.RawHTMLID), 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
			this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
		}
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Project',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Project...',
					Disabled: pInput.PictForm.Disabled || false,
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
					GetPinnedItem: () =>
					{
						const tmpMyProject = this.pict.AppData?.DocumentData?.ReportData?.Project?.IDProject;
						if (!tmpMyProject)
						{
							return null;
						}
						const pinnedItem =
						{
							id: tmpMyProject,
							text: window._Pict.AppData?.DocumentData?.ReportData?.Project?.Name || ('Unnamed Project #' + tmpMyProject),
						};
						return pinnedItem;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.Default == null)
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.Project?.IDProject;
			if (tmpProjectID != null)
			{
				pInput.Default = String(tmpProjectID);
			}
		}
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm && pInput.Default == null)
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.Project?.IDProject;
			if (tmpProjectID)
			{
				pInput.Default = String(tmpProjectID);
			}
		}
		this.addLoadingSkeleton(pInput, pRowIndex);
		// initialize the select2 plugin
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Project for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Project and set it as the selected Project on the data object
			const tmpProject = await this.pict.providers.ProjectProvider.getProjectByID(pValue);
			this.pict.AppData.SelectedProject = tmpProject;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedProject.IDProject;
			tmpOption.text = this.pict.AppData.SelectedProject.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],106:[function(require,module,exports){
// Headlight `RichText` input provider — the markdown editor from pict-section-form (edit mode) paired
// with rendered-markdown view mode, wrapped with the shared inline View/Edit presentation
// behavior (see EditorBase). PSF does not auto-register this provider (its editor dep is an opt-in), so
// the Headlight bundle registers it under the hash `Pict-Input-RichText` that the templates'
// DefaultInputExtensions reference.
const RichTextInput = require('pict-section-form').RichTextInput;
const { buildEditorInputProvider } = require('./PictProvider-InputType-EditorBase.js');
const libUserMarkdown = require('./_UserMarkdown.js');

// The markdown editor builds its CodeMirror surface from `window.CodeMirrorModules` and has no loader
// of its own — without it it renders an EMPTY slot and throws nothing, which reads as "there is no way
// to edit". The bundle is ~1.1MB, so rather than script-tag it into every document we fetch it on the
// first edit (the same lazy shape the Diagram editor uses). Override the URL per app via provider
// options; set it to null to opt out entirely when a host already loads CodeMirror.
const _DEFAULT_CODEMIRROR_URL = './codemirror-bundle.js';

/** The markdown editor's CodeMirror globals are set by the vendor bundle, so they are not on the Window type. */
const _codeMirrorLoaded = () => !!(/** @type {any} */ (globalThis).CodeMirrorModules);

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Input-RichText',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Join the app save-data lifecycle so EditorBase.onBeforeSaveDataAsync fires — it flushes an editor
	// left open at save time into FormData (the per-keystroke marshal is deferred to View, so without
	// this a Save-while-editing would persist the pre-edit value). NOT a framework default.
	AutoSaveDataWithApp: true,

	CodeMirrorVendorURL: _DEFAULT_CODEMIRROR_URL,
};

const EditorProviderBase = buildEditorInputProvider(RichTextInput, _DEFAULT_CONFIGURATION);

class PictProviderInputTypeRichText extends EditorProviderBase
{
	/**
	 * A RichText value is text a user typed (a test remark), so its View / Read / Print rendering goes
	 * through the hardened renderer, the same one LIMS and the sample panel use. PSF's own uses a plain
	 * `marked.parse`, which puts typed HTML (an `onerror` attribute, a `javascript:` link) into the
	 * page of whoever reads the remark.
	 *
	 * @param {string} pMarkdown - the stored remark.
	 * @return {string} - the rendered HTML.
	 */
	_renderMarkdown(pMarkdown)
	{
		return libUserMarkdown.renderUserMarkdown(pMarkdown, this.log);
	}

	/**
	 * The markdown editor's live preview re-renders the typed text on every keystroke through
	 * pict-section-content, which has no way to escape HTML -- so a remark carrying an `onerror`
	 * attribute ran in the browser of whoever opened it for editing. The preview is off; the View
	 * toggle shows the formatted remark through the hardened renderer above.
	 *
	 * @param {Object} pInput @param {any} pValue @param {Object} pInst
	 * @return {Object} - the markdown editor's view options.
	 */
	_buildEditorOptions(pInput, pValue, pInst)
	{
		return Object.assign(super._buildEditorOptions(pInput, pValue, pInst), { EnableRichPreview: false });
	}

	/**
	 * PSF records every keystroke's content as the instance's `lastValue`, so it is the remark as typed
	 * even after a whole-form marshal has reset the hidden input. See EditorBase._reassertHiddenInputValue.
	 *
	 * @param {Record<string, any>} pInstance
	 * @return {string|undefined}
	 */
	_getOpenEditorValue(pInstance)
	{
		return (pInstance && (typeof pInstance.lastValue === 'string')) ? pInstance.lastValue : undefined;
	}

	/**
	 * Belt-and-braces content seed for the mounted editor.
	 *
	 * PSF's own hand-off (stash the content in AppData, pass the address as `ContentDataAddress`) does
	 * work — verified live: the address resolves and carries the right content. But it only takes
	 * effect if the editor actually built a segment editor, which requires CodeMirror to be on the
	 * page (`window.CodeMirrorModules`). Writing segment 0 directly after render costs nothing and
	 * makes the content independent of that indirection.
	 *
	 * NOTE: this does NOT rescue a missing CodeMirror — with no segment editors the editor renders an
	 * empty slot and this no-ops (setSegmentContent warns "index out of range"). Serving the CodeMirror
	 * bundle is the actual requirement; see the report definition's index.html.
	 *
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {Function} fCallback
	 */
	/**
	 * Resolve `window.CodeMirrorModules`, fetching the vendor bundle once if the host has not already
	 * loaded it. The promise is cached so N fields on a page share a single fetch.
	 * @return {Promise<void>}
	 */
	_ensureCodeMirror()
	{
		if ((typeof window === 'undefined') || _codeMirrorLoaded())
		{
			return Promise.resolve();
		}
		if (this._codeMirrorLoadPromise)
		{
			return this._codeMirrorLoadPromise;
		}
		const tmpURL = (this.options && ('CodeMirrorVendorURL' in this.options)) ?
			this.options.CodeMirrorVendorURL : _DEFAULT_CODEMIRROR_URL;
		if (!tmpURL)
		{
			return Promise.resolve();
		}
		this._codeMirrorLoadPromise = new Promise((fResolve) =>
		{
			const tmpScript = document.createElement('script');
			tmpScript.src = tmpURL;
			tmpScript.async = true;
			// Resolve either way — a failed load leaves the editor empty, which the caller already
			// handles, and blocking the mount on a vendor fetch would be worse.
			tmpScript.onload = () => fResolve();
			tmpScript.onerror = () =>
			{
				if (this.log)
				{
					this.log.error(`[Pict-Input-RichText] CodeMirror bundle failed to load from ${tmpURL} — the editor will render empty.`);
				}
				fResolve();
			};
			document.head.appendChild(tmpScript);
		});
		return this._codeMirrorLoadPromise;
	}

	/**
	 * Warm the CodeMirror bundle in the BACKGROUND as soon as a field initializes, so the first click on
	 * Edit does not block on a cold ~1.1MB fetch (the "significant delay on a clean form" — once cached,
	 * later edits are instant, which is why it was not reproducible after the first). The fetch is
	 * promise-cached in `_ensureCodeMirror`, so N fields share one load and this is safe to call per
	 * field. Scheduled on idle (falling back to a short timeout) so it never competes with first paint.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if ((typeof window !== 'undefined') && !_codeMirrorLoaded())
		{
			const tmpWarm = () =>
			{
				// Fire-and-forget; a failed fetch is already handled where the editor mounts.
				this._ensureCodeMirror();
			};
			if (typeof window.requestIdleCallback === 'function')
			{
				window.requestIdleCallback(tmpWarm, { timeout: 2000 });
			}
			else
			{
				setTimeout(tmpWarm, 0);
			}
		}
		return tmpResult;
	}

	/**
	 * An empty TEST remark prints nothing, rather than an "(empty)" box. Hidden only in Print (the
	 * editor container carries `pict-editor-print` there — on screen the empty state is a hint to add
	 * remarks instead), only when empty, and only for a remarks field attached to a test acceptance
	 * input, so every other RichText field keeps its own empty state in the PDF.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._syncEmptyTestRemarkInPrint(pInput, pValue);
		return tmpResult;
	}

	/** @param {Object} pInput @param {any} pValue */
	_syncEmptyTestRemarkInPrint(pInput, pValue)
	{
		if ((typeof document === 'undefined') || !pInput || !pInput.Macro)
		{
			return;
		}
		const tmpEditor = document.getElementById(`PICT-EDITOR-FOR-${pInput.Macro.RawHTMLID}`);
		if (!tmpEditor || !tmpEditor.classList.contains('pict-editor-print') || !this._isTestRemarksField(pInput))
		{
			return;
		}
		// Same emptiness rule PSF uses to decide on its "(empty)" placeholder.
		const tmpContent = this._resolveContent(pInput, pValue);
		const tmpEmpty = !tmpContent || (String(tmpContent).trim().length < 1);
		const tmpColumn = tmpEditor.closest('.column');
		if (tmpColumn)
		{
			tmpColumn.classList.toggle('is-hidden', tmpEmpty);
		}
	}

	/**
	 * A test remarks field shares its group with a SampleTestAcceptance input. That group only ever holds
	 * the test's hidden selector, its result and its remarks, so this is exact — and it survives a
	 * container form's hash salting, because the pair's group is salted together.
	 * @param {Object} pInput @return {boolean}
	 */
	_isTestRemarksField(pInput)
	{
		const tmpGroup = pInput && pInput.PictForm && pInput.PictForm.Group;
		const tmpManifest = this.pict.views.PictFormMetacontroller && this.pict.views.PictFormMetacontroller.manifestDescription;
		if (!tmpGroup || !tmpManifest || !tmpManifest.Descriptors)
		{
			return false;
		}
		return Object.values(tmpManifest.Descriptors).some((pDescriptor) =>
			((pDescriptor.PictForm || {}).Group === tmpGroup) && ((pDescriptor.PictForm || {}).InputType === 'SampleTestAcceptance'));
	}

	_mountEdit(pView, pInput, pValue, fCallback)
	{
		// CodeMirror must be present BEFORE the editor renders — it reads window.CodeMirrorModules
		// while building its segments, and silently produces nothing when they are missing. The warm-up
		// in onInputInitialize usually has it ready by now; this awaits it only if not.
		if ((typeof window !== 'undefined') && !_codeMirrorLoaded())
		{
			this._ensureCodeMirror().then(() => this._doMountEdit(pView, pInput, pValue, fCallback));
			return;
		}
		return this._doMountEdit(pView, pInput, pValue, fCallback);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {Function} fCallback
	 */
	_doMountEdit(pView, pInput, pValue, fCallback)
	{
		const tmpContent = this._resolveContent(pInput, pValue);
		return super._mountEdit(pView, pInput, pValue, (pError) =>
		{
			if (!pError && tmpContent)
			{
				try
				{
					const tmpInstance = this._instances[pInput.Hash];
					const tmpEditorView = tmpInstance && tmpInstance.viewInstance;
					if (tmpEditorView && (typeof tmpEditorView.setSegmentContent === 'function'))
					{
						tmpEditorView.setSegmentContent(0, tmpContent);
					}
				}
				catch (pSeedError)
				{
					if (this.log)
					{
						this.log.warn('[Pict-Input-RichText] could not seed editor content',
							{ error: pSeedError.message, inputHash: pInput && pInput.Hash });
					}
				}
			}
			if (typeof fCallback === 'function')
			{
				fCallback(pError);
			}
		});
	}
}

module.exports = PictProviderInputTypeRichText;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-EditorBase.js":50,"./_UserMarkdown.js":144,"pict-section-form":497}],107:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedSample.QRCode || 'N/A',
				this.pict.AppData.SelectedSample.Name || ('Unnamed Sample #' + this.pict.AppData.SelectedSample.IDSample),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedSample.Name || ('Unnamed Sample #' + this.pict.AppData.SelectedSample.IDSample);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Build the QR Code Image and prepend it to the input element.
	 * @param {HTMLSelectElement} tmpInputSelectElement The input element.
	 */
	buildPrependedQRCodeImage(tmpInputSelectElement)
	{
		if (this.pict.AppData.SelectedSample)
		{
			const tmpCanvas = this.pict.providers.QRCodeProvider.create(this.pict.AppData.SelectedSample.QRCode);
			const tmpElement = `<figure class="image mr-2 is-64x64"><img src="${tmpCanvas}" alt="QR Code" /></figure>`;
			// find the parent .column element
			const tmpParentElement = tmpInputSelectElement.closest('.column');
			if (tmpParentElement)
			{
				// prepend the QR Code Image
				tmpParentElement.insertAdjacentHTML('afterbegin', tmpElement);
				tmpParentElement.classList.add('is-flex');
				tmpParentElement.classList.add('is-align-items-center');
			}
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the Sample for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Sample record yet, get it and store it
			if (!this.pict.AppData.SelectedSample)
			{
				const tmpResult = await this.pict.providers.SampleProvider.getSampleByID(pValue);
				this.pict.AppData.SelectedSample = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
			// for PDF view, we want to prepend the QRCode Image to the display, if we have one
			this.buildPrependedQRCodeImage(tmpInputSelectElement);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],108:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @typedef {import('./PictProvider-Select2Util.js')} Select2UtilProvider */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/** @return {Select2UtilProvider} */
	get Select2Util()
	{
		return this.pict.providers.Select2Util;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.Select2Util.getOptionsAjax('Sample',
				{
					Input: pInput,
					SearchFields: [ 'Name', 'QRCode' ],
					SearchFallbackPlaceholder: 'Select a Sample by name or code...',
					Disabled: pInput.PictForm.Disabled || false,
					GetRecordUserFacingID: (pSample) => pSample.QRCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				// TODO: Remove me later, this is a temp log for debugging
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Sample for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Sample and set it as the selected Sample on the data object
			const tmpSample = await this.pict.providers.SampleProvider.getSampleByID(pValue);
			this.pict.AppData.SelectedSample = tmpSample;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedSample.IDSample;
			tmpOption.text = `${this.pict.AppData.SelectedSample.QRCode || 'N/A'}|~|${this.pict.AppData.SelectedSample.Name || ('Unnamed Sample #' + this.pict.AppData.SelectedSample.IDSample)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
		// set the Sample selection callback for the Sample Search Panel
		this.pict.views.HeadlightPaneSamples.setSampleSelectionCallback((pSample) =>
		{
			this.pict.log.info('Sample selected:', pSample.IDSample);
			this.pict.log.info('Assigning Sample to the following input element:', pInput.Macro.RawHTMLID);
			this.pict.AppData.SelectedSample = pSample;
			// NOTE: ContentAssignment is failing to set this value for some reason, should investigate later
			document.getElementById(pInput.Macro.RawHTMLID)['value'] = pSample.IDSample;
			document.getElementById(pInput.Macro.RawHTMLID).dispatchEvent(new Event('change'));
		});
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Refresh spec-year scope when the user picks a different sample. The
	 * picker stores the IDSample value (numeric); the resolver fetches the
	 * sample by ID and walks Sample → Project to seed the scope. Resolver
	 * dedupes when the project hasn't changed and fails open on bare
	 * contracts / empty stub sets.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.providers.SpecScopeResolver?.loadForSampleByIdentifier?.(pValue, 'IDSample');
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],109:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerProvider = require('./PictProvider-InputType-Picker.js');

const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'SampleStatusPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * Sample-status picker — the Picker-stack port of the legacy SampleStatusSelector (a Select-family
 * subclass; this class mirrors it 1:1 for diff-review).
 *
 * The vocabulary comes from the customer-managed `SampleStatus` table through the base broker's
 * vocabulary source (`_VocabularySelectorMap`), which commits the status CODE — what `Sample.Status`
 * stores — and falls back to a built-in list for a customer with no rows. On top of that this class
 * carries the legacy provider's cross-widget behavior: it derives a new sample status from the test
 * results reported on the event bus, seeds from a linked sample's status, and announces its own
 * changes as `SampleStatusChanged`.
 *
 * Tracking GUIDs use the SAME `MATERIALS-ENTITY-TRACKING-GUID-…` element ids as the legacy templates,
 * so a migrated field still binds to a still-legacy sibling Sample selector during a phased rollout.
 */
class PictProviderInputTypeSampleStatusPicker extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	getTrackingGUIDID(pInputHTMLID, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}`;
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {string} pEvent @param {string} pTransactionGUID @return {boolean}
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number} pRowIndex @param {string} pEvent @param {string} pTransactionGUID @return {boolean}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		// The test-result event is bound to the TEST, so its tracking GUID cannot be validated against
		// the sample's here — the aggregate it triggers below is what carries the sample's GUID.
		if (tmpEventType === 'TestResultChanged')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
			{
				if (pInput.PictForm.Disabled !== true)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), '__TestResultAggregate', []);
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestStatusAggregate:${this._getTrackingGUID(pInput, pRowIndex)}:__TestResultAggregate`);
				}
			});
		}

		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (tmpEventType === 'TestStatusAggregate')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			const tmpStatusGroup = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!Array.isArray(tmpStatusGroup))
			{
				return;
			}
			const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pInput, pRowIndex));
			const tmpNewStatus = this._computeNewSampleStatusFromTestResults(tmpStatusGroup, tmpCurrentStatus);
			if (tmpNewStatus)
			{
				this._setValueAndCommit(pView, pInput, tmpNewStatus, pRowIndex);
			}
			return;
		}
		if (tmpEventType === 'SampleChanged')
		{
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (tmpSampleRecord && typeof tmpSampleRecord === 'object' && !Array.isArray(tmpSampleRecord) && tmpSampleRecord.Status)
			{
				const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pInput, pRowIndex));
				if (tmpCurrentStatus !== tmpSampleRecord.Status)
				{
					this._setValueAndCommit(pView, pInput, tmpSampleRecord.Status, pRowIndex);
				}
			}
			return;
		}
	}

	/**
	 * The marshal-relative address this field's status code lives at.
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string}
	 */
	_getValueAddress(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.DataAddress;
	}

	/**
	 * Derive a sample status from the statuses of its tests. A sample is never moved to a "higher"
	 * status automatically, and a manually-terminal status (voided / preauthorized / failed) is never
	 * overwritten.
	 *
	 * @param {Array<string>} pTestResultsArray @param {string} pSampleStatus @return {string | null}
	 */
	_computeNewSampleStatusFromTestResults(pTestResultsArray, pSampleStatus)
	{
		let tmpNewSampleStatus;
		let tmpSeenPendingTest = false;
		let tmpSeenFinalizedTest = false;
		let tmpSeenFailingTest = false;
		let tmpSeenPassingTest = false;
		for (const tmpTestResult of pTestResultsArray)
		{
			if (!tmpTestResult)
			{
				tmpSeenPendingTest = true;
				break;
			}
			if (tmpTestResult.startsWith('FAI'))
			{
				tmpSeenFailingTest = true;
				tmpSeenFinalizedTest = true;
			}
			if (tmpTestResult.startsWith('PAS'))
			{
				tmpSeenPassingTest = true;
				tmpSeenFinalizedTest = true;
			}
		}
		if (tmpSeenFailingTest)
		{
			tmpNewSampleStatus = 'FAIL';
			if (!pSampleStatus || pSampleStatus != 'VOID' && pSampleStatus != 'PREA' && pSampleStatus != 'FAIL' && pSampleStatus != 'FAIC')
			{
				this.pict.log.info(`SampleStatusPicker: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
				return tmpNewSampleStatus;
			}
		}
		else if (tmpSeenPendingTest)
		{
			tmpNewSampleStatus = tmpSeenFinalizedTest ? 'TEST' : 'PEND';
			if (!pSampleStatus || pSampleStatus != 'VOID' && pSampleStatus != 'PREA' && pSampleStatus != 'FAIL' && pSampleStatus != 'FAIC' && pSampleStatus != tmpNewSampleStatus)
			{
				this.pict.log.info(`SampleStatusPicker: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
				return tmpNewSampleStatus;
			}
		}
		else if (tmpSeenPassingTest)
		{
			tmpNewSampleStatus = 'PASS';
			if (!pSampleStatus || pSampleStatus == 'N/A' || pSampleStatus == 'LOGD' || pSampleStatus == 'RECV' || pSampleStatus == 'INFO' || pSampleStatus == 'PEND' || pSampleStatus == 'TEST' || pSampleStatus == 'TSTR')
			{
				this.pict.log.info(`SampleStatusPicker: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
				return tmpNewSampleStatus;
			}
		}
		return null;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
		}
		return tmpResult;
	}

	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpResult = super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
		}
		return tmpResult;
	}

	/** @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string} */
	_getTrackingGUID(pInput, pRowIndex)
	{
		if (pRowIndex == null && pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			return pInput.PictForm.SampleTrackingGUID;
		}
		return /** @type {string} */ (this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex)));
	}

	/** @param {Object} pInput @param {number|string|null} pRowIndex @param {string} pTrackingGUID */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex), pTrackingGUID);
	}

	/**
	 * Inherit the tracking GUID of the sample descriptor this status belongs to, so the sample's
	 * events reach this field. Searches the row's own group first (tabular), then the global manifest.
	 *
	 * @param {Object} pView @param {Object} pGroup @param {Object} pInput @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (pRowIndex != null)
		{
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.pict.log.error('SampleStatusPicker: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.pict.log.error('SampleStatusPicker: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.pict.log.warn('SampleStatusPicker: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = PictProviderInputTypeSampleStatusPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-Picker.js":95,"./_VocabularySelectorMap.js":145}],110:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const SelectInputTypeProvider = require('./PictProvider-InputType-Select.js');

const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');

const DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS = libVocabularySelectorMap.DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS;

/**
 * Sample-status selector. The vocabulary lives in the customer-managed `SampleStatus` table and is
 * resolved through the Select base class's entity-backed option source (Hash -> the code stored in
 * `Sample.Status`, Name -> the label, ordered by Ordinal). A customer with no SampleStatus rows falls
 * back to DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS, so the input works before any list is curated.
 */
class SampleStatusSelectorInputType extends SelectInputTypeProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Point the input at the managed SampleStatus vocabulary and install the fallback list. A schema
	 * that carries its own SelectOptions / SelectOptionsEntity keeps them.
	 *
	 * @param {Object} pInput - The input object.
	 */
	_applySampleStatusOptionSource(pInput)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
	}

	/**
	 * The option list this input is actually rendering - the managed vocabulary once it has loaded,
	 * otherwise the fallback. Used to label the non-interactive Read / PDF nodes.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {Function} [fOnLoaded] - Invoked once if the vocabulary is still loading, so the caller can repaint.
	 * @return {Array<{id: any, text: string}>} - The resolved option list.
	 */
	_getResolvedStatusOptions(pInput, fOnLoaded)
	{
		const tmpEntityOptions = this.resolveEntitySelectOptions(pInput, fOnLoaded);
		if (Array.isArray(tmpEntityOptions) && tmpEntityOptions.length > 0)
		{
			return tmpEntityOptions;
		}
		return (Array.isArray(pInput?.PictForm?.SelectOptions) && pInput.PictForm.SelectOptions.length > 0) ?
			pInput.PictForm.SelectOptions :
			DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-STATUS-SELECT-FOR-${pInputHTMLID}`;
	}

	getDisplayInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-STATUS-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-STATUS-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-STATUS-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-STATUS-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTrackingGUIDID(pInputHTMLID, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		//TODO: are there cases where we want to auto-set this based on test results? Probably based on a config flag, and only if there isn't an existing value set.
		//      Maybe put a refresh button??? Or hash things and check for the hash changing? Think about it
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		//TODO: are there cases where we want to auto-set this based on test results? Probably based on a config flag, and only if there isn't an existing value set.
		//      Maybe put a refresh button??? Or hash things and check for the hash changing? Think about it
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		//TODO: since the test reult event is bound to the test, we can't validate its tracking GUID against the sample's tracking GUID here
		//      do we want to daisy-chain this event through thest to pick up the sample tracking GUID?
		if (tmpEventType === 'TestResultChanged')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
			{
				if (pInput.PictForm.Disabled !== true)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), '__TestResultAggregate', []);
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestStatusAggregate:${this._getTrackingGUID(pInput, pRowIndex)}:__TestResultAggregate`);
				}
			});
		}

		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (tmpEventType === 'TestStatusAggregate')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			const tmpStatusGroupAddress = tmpEventPayload;
			const tmpStatusGroup = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpStatusGroupAddress);
			if (!Array.isArray(tmpStatusGroup))
			{
				return;
			}
			let tmpAddress;
			if (pRowIndex != null)
			{
				tmpAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			else
			{
				tmpAddress = pInput.DataAddress;
			}
			const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress);
			const tmpNewStatus = this._computeNewSampleStatusFromTestResults(tmpStatusGroup, tmpCurrentStatus);
			if (tmpNewStatus)
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress, tmpNewStatus);
				pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
				pView.dataChanged(pInput.Hash);
			}
			return;
		}
		if (tmpEventType === 'SampleChanged')
		{
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (tmpSampleRecord && typeof tmpSampleRecord === 'object' && !Array.isArray(tmpSampleRecord) && tmpSampleRecord.Status)
			{
				let tmpAddress;
				if (pRowIndex != null)
				{
					tmpAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
				}
				else
				{
					tmpAddress = pInput.DataAddress;
				}
				const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress);
				if (tmpCurrentStatus !== tmpSampleRecord.Status)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress, tmpSampleRecord.Status);
					pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
				}
			}
			return;
		}
	}

	/**
	 * @param {Array<string>} pTestResultsArray
	 * @param {string} pSampleStatus
	 *
	 * @return {string | null}
	 */
	_computeNewSampleStatusFromTestResults(pTestResultsArray, pSampleStatus)
	{
		let tmpNewSampleStatus;
		let tmpSeenPendingTest = false;
		let tmpSeenFinalizedTest = false;
		let tmpSeenFailingTest = false;
		let tmpSeenPassingTest = false;
		for (const tmpTestResult of pTestResultsArray)
		{
			if (!tmpTestResult)
			{
				tmpSeenPendingTest = true;
				break;
			}
			if (tmpTestResult.startsWith('FAI'))
			{
				tmpSeenFailingTest = true;
				tmpSeenFinalizedTest = true;
			}
			if (tmpTestResult.startsWith('PAS'))
			{
				tmpSeenPassingTest = true;
				tmpSeenFinalizedTest = true;
			}
		}
		// we won't move the sample to a "higher" status automatically
		if (tmpSeenFailingTest)
		{
			tmpNewSampleStatus = 'FAIL';
			if (!pSampleStatus || pSampleStatus != 'VOID' && pSampleStatus != 'PREA' && pSampleStatus != 'FAIL' && pSampleStatus != 'FAIC')
			{
				this.pict.log.info(`SampleStatusSelector: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
				return tmpNewSampleStatus;
			}
		}
		else if (tmpSeenPendingTest)
		{
			// if any test is pending, sample is pending
			tmpNewSampleStatus = tmpSeenFinalizedTest ? 'TEST' : 'PEND';
			if (!pSampleStatus || pSampleStatus != 'VOID' && pSampleStatus != 'PREA' && pSampleStatus != 'FAIL' && pSampleStatus != 'FAIC' && pSampleStatus != tmpNewSampleStatus)
			{
				this.pict.log.info(`SampleStatusSelector: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
				return tmpNewSampleStatus;
			}
		}
		else if (tmpSeenPassingTest)
		{
			tmpNewSampleStatus = 'PASS';
			if (!pSampleStatus || pSampleStatus == 'N/A' || pSampleStatus == 'LOGD' || pSampleStatus == 'RECV' || pSampleStatus == 'INFO' || pSampleStatus == 'PEND' || pSampleStatus == 'TEST' || pSampleStatus == 'TSTR')
			{
				this.pict.log.info(`SampleStatusSelector: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
				return tmpNewSampleStatus;
			}
		}
		return null;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// for PDF and locked/read-only views, we need to set the display text as well
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			const tmpPrintSelector = this.getDisplayInputHTMLID(pInput.Macro.RawHTMLID);
			const fRepaint = () => this.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
			const tmpOption = this._getResolvedStatusOptions(pInput, fRepaint).find((pOption) => pOption.id === pValue);
			const tmpDisplayText = tmpOption ? tmpOption.text : pValue;
			this.pict.ContentAssignment.assignContent(tmpPrintSelector, tmpDisplayText);
		}
		return tmpResult;
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		//TODO: plumb the test result into the configured address
		// for PDF and locked/read-only views, we need to set the display text as well
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			const tmpPrintSelector = this.getTabularDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex);
			const fRepaint = () => this.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
			const tmpOption = this._getResolvedStatusOptions(pInput, fRepaint).find((pOption) => pOption.id === pValue);
			const tmpDisplayText = tmpOption ? tmpOption.text : pValue;
			this.pict.ContentAssignment.assignContent(tmpPrintSelector, tmpDisplayText);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
		}
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
		}
	}

	_getTrackingGUID(pInput, pRowIndex)
	{
		if (pRowIndex == null && pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			return pInput.PictForm.SampleTrackingGUID;
		}
		return this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex));
	}

	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex), pTrackingGUID);
	}

	/**
	 * Searches for the sample descriptor that this test result should be bound to and inherits its tracking GUID if needed.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		// modalities:
		//
		// single global sample
		// tabular row-based tests
		// tabular row-based sample and tests

		if (pRowIndex != null)
		{
			// tabular
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('SampleStatusSelector: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		// check sibling Descriptors for a sample descriptor
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('SampleStatusSelector: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('SampleStatusSelector: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = SampleStatusSelectorInputType;

module.exports.DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS = DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS;

},{"./PictProvider-InputType-Select.js":115,"./_VocabularySelectorMap.js":145}],111:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerProvider = require('./PictProvider-InputType-Picker.js');

const libTestResultOptions = require('./_TestResultOptions.js');

/** Length of the longest shared trailing run of two strings. */
const commonSuffixLength = (pLeft, pRight) =>
{
	let tmpCount = 0;
	while (tmpCount < pLeft.length && tmpCount < pRight.length &&
		pLeft[pLeft.length - 1 - tmpCount] === pRight[pRight.length - 1 - tmpCount])
	{
		tmpCount++;
	}
	return tmpCount;
};

/**
 * The result control is deliberately partial-width: a full-bleed control reads as its own region, which
 * is the confusion this input exists to remove. `min-width: 0` keeps the picker from forcing the flex
 * row wider than its column.
 *
 * The remarks field is a SEPARATE descriptor rendering its own column below this one, so by default the
 * two stack with ~90px between the picker and the editor. The `test-acceptance-*` rules close that gap
 * and lift the editor's View/Edit switch into the result row, right-aligned: the editor is positioned,
 * and its switch is taken out of flow with `bottom: 100%` so it lands in the space just above — the
 * result row, once the padding between the two columns is removed.
 *
 * The empty-state hint replaces pict-section-form's hardcoded "(empty)" (RichText `_mountView`, no config
 * hook). It is CSS rather than a DOM swap because PSF re-renders the view on every View/Edit switch, which
 * would overwrite injected text; `::before` survives that. Scoped to test remarks, so other RichText
 * fields and the Print theme keep their own empty state.
 */
const _TEST_ACCEPTANCE_CSS = /*css*/`
.test-acceptance-result { flex: 0 1 22rem; min-width: 0; }
.test-acceptance-remarks-toggle { white-space: nowrap; }
.test-acceptance-column { padding-bottom: 0; }
.test-acceptance-remarks { padding-top: 0; }
.test-acceptance-remarks .pict-editor { position: relative; padding-top: 0.5rem; }
.test-acceptance-remarks .pict-editor-controls { position: absolute; right: 0; bottom: 100%; margin-bottom: 0.25rem; }
.test-acceptance-remarks .pict-section-form-richtext-view.is-empty { font-size: 0; }
.test-acceptance-remarks .pict-section-form-richtext-view.is-empty::before { content: "No remarks yet — choose Edit to add notes. Markdown formatting such as bold, lists and links is supported."; font-size: 0.95rem; line-height: 1.55; }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'SampleTestAcceptance',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Join the save-data lifecycle so onBeforeSaveDataAsync fires (MarkNewTestsInProgress).
	AutoSaveDataWithApp: true,
};

/**
 * Unified test acceptance input — the Picker-stack port of the legacy SampleTestResult (a Select-family
 * subclass; this class mirrors it 1:1 for diff-review) plus the remarks disclosure.
 *
 * The test result and its remark render as one control at the end of the test's own section instead of
 * an appended "Test Results" section. The remark itself stays a sibling `RichText` descriptor — the
 * markdown editor owns its own descriptor identity — and this provider owns the disclosure that shows
 * and hides it, keyed by `PictForm.RemarksInputHash`.
 *
 * Tracking GUIDs use the SAME `MATERIALS-ENTITY-TRACKING-GUID-TEST-…` element ids as the legacy
 * templates, so a migrated field still binds to a still-legacy sibling Test selector during a phased
 * rollout.
 *
 * Cross-provider contract: SampleStatusPicker / SampleStatusSelector listen for `TestResultChanged` and
 * collect values through `TestStatusAggregate` to derive the sample's status. Both must keep firing in
 * the same shape or sample status auto-derivation silently stops.
 */
class PictProviderInputTypeSampleTestAcceptance extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
		/**
		 * Explicit user choices only, so a render does not collapse an editor the user opened. Absent =
		 * no choice made, and the disclosure follows the stored remark. Never populated from a computed
		 * value: caching the first marshal's answer would freeze a transient read in place.
		 * @type {Record<string, boolean>}
		 */
		this._remarksUserOverride = {};
	}

	/**
	 * @param {string} pInputHTMLID @param {number|string|null} [pRowIndex] @param {string} [pType='TEST']
	 * @return {string}
	 */
	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType = 'TEST')
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/** Stamp the static result options unless the schema supplied its own. Shared with PickerDisplay,
	 *  which renders this field in Read and Print. */
	_applyTestResultOptions(pInput)
	{
		libTestResultOptions.applyTestResultOptions(pInput, true);
	}

	/** Register the acceptance layout CSS once (idempotent), above the Picker override block. */
	_ensureTestAcceptanceCSS()
	{
		if (this._testAcceptanceCSSInjected)
		{
			return;
		}
		const tmpCSSMap = this.pict && this.pict.CSSMap;
		if (tmpCSSMap && typeof tmpCSSMap.addCSS === 'function')
		{
			tmpCSSMap.addCSS('Headlight-SampleTestAcceptance-CSS', _TEST_ACCEPTANCE_CSS, 610);
			if (typeof tmpCSSMap.injectCSS === 'function')
			{
 tmpCSSMap.injectCSS();
			}
			this._testAcceptanceCSSInjected = true;
		}
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._ensureTestAcceptanceCSS();
		this._applyTestResultOptions(pInput);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// Also applied here, not just on marshal: the column renders visible by default, so waiting for
		// the marshal leaves a collapsed editor briefly on screen.
		this._syncRemarksDisclosure(pView, pInput, null);
		return tmpResult;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._ensureTestAcceptanceCSS();
		this._applyTestResultOptions(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._syncRemarksDisclosure(pView, pInput, pRowIndex);
		return tmpResult;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyTestResultOptions(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._syncRemarksDisclosure(pView, pInput, null);
		return tmpResult;
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyTestResultOptions(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		const tmpResult = super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._syncRemarksDisclosure(pView, pInput, pRowIndex);
		return tmpResult;
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
		return tmpResult;
	}

	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpResult = super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
		return tmpResult;
	}

	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}
		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload, tmpExtraData ] = pEvent.split(':');

		//FIXME: needs revision to work with multi-sample forms (carried over from SampleTestResult).
		if (tmpEventType === 'TestStatusAggregate')
		{
			const tmpDestination = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (Array.isArray(tmpDestination))
			{
				tmpDestination.push(this._getCommittedValue(pView, pInput, pRowIndex));
			}
		}

		if (tmpEventType === 'SetTestResultByHash')
		{
			const tmpChangedTestHash = tmpTrackingGUID;
			const tmpEvent = `GetTestHash:${this._getTrackingGUID(pInput, pRowIndex)}:_GetTestHashResponse.${pInput.Hash}`;
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent);
			const tmpMarshalDestination = pView.getMarshalDestinationObject();
			const tmpTestHash = tmpMarshalDestination._GetTestHashResponse?.[pInput.Hash];
			if (tmpTestHash)
			{
				delete tmpMarshalDestination._GetTestHashResponse[pInput.Hash];
				if (Object.keys(tmpMarshalDestination._GetTestHashResponse).length === 0)
				{
					delete tmpMarshalDestination._GetTestHashResponse;
				}
			}
			if (tmpTestHash !== tmpChangedTestHash)
			{
				return;
			}
			this._setValueAndCommit(pView, pInput, tmpEventPayload, pRowIndex);
			if (tmpExtraData)
			{
				this.pict.manifest.setValueAtAddress(this.pict, tmpExtraData, true);
			}
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${tmpEventPayload}`);
		}

		if (tmpEventType === 'MarkNewTestsInProgress' && pInput.PictForm && pInput.PictForm.MarkTestsInProgressOnSave && pInput.PictForm.MarkTestsInProgressOnSave !== 'false')
		{
			const tmpTestResult = this._getCommittedValue(pView, pInput, pRowIndex);
			if (!tmpTestResult || tmpTestResult === 'N/A')
			{
				this._setValueAndCommit(pView, pInput, 'PROG', pRowIndex);
			}
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpEvent = 'MarkNewTestsInProgress';
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/** The currently committed result code, read from the marshal destination. */
	_getCommittedValue(pView, pInput, pRowIndex)
	{
		return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pInput, pRowIndex));
	}

	/**
	 * The marshal-relative address this field's result code lives at.
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string}
	 */
	_getValueAddress(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.DataAddress;
	}

	// --- Remarks disclosure ---------------------------------------------------------------------

	/**
	 * The marshal-relative address the remark lives at. Defaults to the sibling test instance's Notes,
	 * which is where the generated TestInstanceRemarks descriptor wrote it before this input existed.
	 *
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string}
	 */
	_getRemarksAddress(pInput, pRowIndex)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (tmpPictForm.RemarksAddress)
		{
			return tmpPictForm.RemarksAddress;
		}
		const tmpRemarksInput = this._getRemarksInput(pInput);
		if (tmpRemarksInput)
		{
			if (pRowIndex != null)
			{
				return this.pict.providers.Informary.getComposedContainerAddress(tmpRemarksInput.PictForm.InformaryContainerAddress, pRowIndex, tmpRemarksInput.PictForm.InformaryDataAddress);
			}
			return tmpRemarksInput.DataAddress;
		}
		return null;
	}

	/**
	 * The sibling remarks descriptor this input's disclosure controls, named by `PictForm.RemarksInputHash`.
	 * @param {Object} pInput @return {Object|null}
	 */
	_getRemarksInput(pInput)
	{
		const tmpRemarksHash = pInput?.PictForm?.RemarksInputHash;
		if (!tmpRemarksHash)
		{
			return null;
		}
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors)
		{
			return null;
		}
		const tmpDescriptors = Object.values(tmpGlobalManifest.Descriptors);
		// Standalone form: the configured hash IS the descriptor's hash.
		for (const tmpDescriptor of tmpDescriptors)
		{
			if (tmpDescriptor.Hash === tmpRemarksHash)
			{
				return tmpDescriptor;
			}
		}
		// Container form: each test is injected through createDistinctManifest, which salts every
		// descriptor hash (SampleTestResult -> SampleTestResult_<salt>_<test>) but leaves RemarksInputHash
		// alone, since it is a plain string value and not a hash reference the salter knows about. The
		// pair still shares a group, so resolve there instead of giving up.
		const tmpGroup = pInput?.PictForm?.Group;
		if (!tmpGroup)
		{
			return null;
		}
		const tmpInGroup = tmpDescriptors.filter((pDescriptor) => ((pDescriptor.PictForm || {}).Group === tmpGroup) &&
			((pDescriptor.PictForm || {}).InputType === 'RichText'));
		if (tmpInGroup.length < 1)
		{
			return null;
		}
		const tmpPrefixed = tmpInGroup.filter((pDescriptor) => String(pDescriptor.Hash || '').startsWith(tmpRemarksHash));
		const tmpPool = (tmpPrefixed.length > 0) ? tmpPrefixed : tmpInGroup;
		if (tmpPool.length === 1)
		{
			return tmpPool[0];
		}
		// Several result/remark pairs can share one group. Both halves of a pair carry the same salt and
		// test hash, so the longest shared trailing run picks this input's own remarks field.
		let tmpBest = null;
		let tmpBestLength = -1;
		for (const tmpDescriptor of tmpPool)
		{
			const tmpLength = commonSuffixLength(String(pInput.Hash || ''), String(tmpDescriptor.Hash || ''));
			if (tmpLength > tmpBestLength)
			{
				tmpBestLength = tmpLength;
				tmpBest = tmpDescriptor;
			}
		}
		return tmpBest;
	}

	/** Stable key for one field's disclosure state (tabular rows each get their own). */
	_getRemarksStateKey(pInput, pRowIndex)
	{
		return (pRowIndex != null) ? `${pInput.Hash}-${pRowIndex}` : pInput.Hash;
	}

	/**
	 * The rendered column of the sibling remarks descriptor. Resolved through that descriptor's own
	 * hidden value input, which the editor body always emits under its RawHTMLID.
	 *
	 * @param {Object} pInput @param {number|string|null} pRowIndex @return {HTMLElement|null}
	 */
	_getRemarksColumnElement(pInput, pRowIndex)
	{
		const tmpRemarksInput = this._getRemarksInput(pInput);
		if (!tmpRemarksInput)
		{
			return null;
		}
		let tmpElement = null;
		if (tmpRemarksInput.Macro && tmpRemarksInput.Macro.RawHTMLID)
		{
			let tmpHTMLID = `#${tmpRemarksInput.Macro.RawHTMLID}`;
			if (pRowIndex != null)
			{
				tmpHTMLID = `${tmpHTMLID}-${pRowIndex}`;
			}
			const tmpFound = this.pict.ContentAssignment.getElement(tmpHTMLID);
			tmpElement = Array.isArray(tmpFound) ? tmpFound[0] : tmpFound;
		}
		if (!tmpElement)
		{
			// A container form's injected descriptors carry no Macro — that is added to the view's own
			// copies, not to the manifest the metacontroller holds. Element ids still follow the
			// `<view>-FormInput-<Hash>` convention, so fall back to matching on that.
			const tmpSuffix = (pRowIndex != null) ?
				`FormInput-${tmpRemarksInput.Hash}-${pRowIndex}` :
				`FormInput-${tmpRemarksInput.Hash}`;
			const tmpMatches = this.pict.ContentAssignment.getElement(`[id$="${tmpSuffix}"]`);
			tmpElement = Array.isArray(tmpMatches) ? tmpMatches[0] : tmpMatches;
		}
		if (!tmpElement || typeof tmpElement.closest !== 'function')
		{
			return null;
		}
		return tmpElement.closest('.column');
	}

	/**
	 * Show or hide the remarks editor. Called from the disclosure control in the template.
	 *
	 * @param {string} pInputHash - The acceptance descriptor's Hash.
	 * @param {number|string} [pRowIndex]
	 */
	toggleRemarks(pInputHash, pRowIndex)
	{
		const tmpInput = this._getInputByHash(pInputHash);
		if (!tmpInput)
		{
			this.log.warn('SampleTestAcceptance: no descriptor to toggle remarks for.', { pInputHash });
			return;
		}
		const tmpKey = this._getRemarksStateKey(tmpInput, pRowIndex);
		const tmpOpen = !this._isRemarksOpen(tmpInput, pRowIndex);
		this._remarksUserOverride[tmpKey] = tmpOpen;
		this._applyRemarksOpen(tmpInput, pRowIndex, tmpOpen);
	}

	/**
	 * Re-apply the disclosure after a marshal. A render wipes DOM classes, so the open state lives on the
	 * provider and is re-applied here rather than being read back off the element.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 */
	_syncRemarksDisclosure(pView, pInput, pRowIndex)
	{
		// Some older test schemas carry a result with no remarks field at all. A disclosure that opens
		// nothing reads as a broken control, so hide it rather than wire it to empty.
		if (!this._getRemarksInput(pInput))
		{
			this._setRemarksToggleVisible(pInput, pRowIndex, false);
			return;
		}
		const tmpKey = this._getRemarksStateKey(pInput, pRowIndex);
		// Recomputed every marshal: a user choice wins, otherwise follow the stored remark so a remark
		// that arrives later (autofill, a solver, a reloaded document) is never left hidden.
		const tmpOpen = (typeof this._remarksUserOverride[tmpKey] === 'boolean') ?
			this._remarksUserOverride[tmpKey] :
			this._shouldOpenRemarks(pView, pInput, pRowIndex);
		this._applyRemarksOpen(pInput, pRowIndex, tmpOpen);
	}

	/** Current disclosure state: the user's choice when they have made one, else the stored remark. */
	_isRemarksOpen(pInput, pRowIndex)
	{
		const tmpKey = this._getRemarksStateKey(pInput, pRowIndex);
		if (typeof this._remarksUserOverride[tmpKey] === 'boolean')
		{
			return this._remarksUserOverride[tmpKey];
		}
		const tmpColumn = this._getRemarksColumnElement(pInput, pRowIndex);
		return tmpColumn ? !tmpColumn.classList.contains('is-hidden') : false;
	}

	/**
	 * Whether the remarks editor should open on first marshal. Today: only when a remark is already
	 * stored. The "remarks required per result code" flag, when it lands, feeds this one predicate.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex @return {boolean}
	 */
	_shouldOpenRemarks(pView, pInput, pRowIndex)
	{
		const tmpRemarksAddress = this._getRemarksAddress(pInput, pRowIndex);
		if (!tmpRemarksAddress)
		{
			return false;
		}
		const tmpRemark = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRemarksAddress);
		return (typeof tmpRemark === 'string') && (tmpRemark.trim() !== '');
	}

	/** The disclosure control's element id for this field. */
	_getRemarksToggleID(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return `#TEST-ACCEPTANCE-REMARKS-TOGGLE-${pInput.Macro.RawHTMLID}-${pRowIndex}`;
		}
		return `#TEST-ACCEPTANCE-REMARKS-TOGGLE-${pInput.Macro.RawHTMLID}`;
	}

	/**
	 * The disclosure control for this field. The click path reaches the provider through
	 * `_getInputByHash`, which returns the metacontroller's descriptor — and on a container form that
	 * copy carries no Macro. Fall back to the `...-FormInput-<Hash>` id convention, as the remarks
	 * column lookup does, rather than dereferencing Macro.
	 *
	 * @param {Object} pInput @param {number|string|null} pRowIndex @return {HTMLElement|null}
	 */
	_getRemarksToggleElement(pInput, pRowIndex)
	{
		let tmpFound = null;
		if (pInput && pInput.Macro && pInput.Macro.RawHTMLID)
		{
			tmpFound = this.pict.ContentAssignment.getElement(this._getRemarksToggleID(pInput, pRowIndex));
		}
		else if (pInput && pInput.Hash)
		{
			const tmpSuffix = (pRowIndex != null) ? `FormInput-${pInput.Hash}-${pRowIndex}` : `FormInput-${pInput.Hash}`;
			tmpFound = this.pict.ContentAssignment.getElement(`[id^="TEST-ACCEPTANCE-REMARKS-TOGGLE-"][id$="${tmpSuffix}"]`);
		}
		return (Array.isArray(tmpFound) ? tmpFound[0] : tmpFound) || null;
	}

	/** @param {Object} pInput @param {number|string|null} pRowIndex @param {boolean} pVisible */
	_setRemarksToggleVisible(pInput, pRowIndex, pVisible)
	{
		const tmpToggle = this._getRemarksToggleElement(pInput, pRowIndex);
		if (tmpToggle)
		{
			tmpToggle.classList.toggle('is-hidden', !pVisible);
		}
	}

	/** @param {Object} pInput @param {number|string|null} pRowIndex @param {boolean} pOpen */
	_applyRemarksOpen(pInput, pRowIndex, pOpen)
	{
		const tmpColumn = this._getRemarksColumnElement(pInput, pRowIndex);
		const tmpToggle = this._getRemarksToggleElement(pInput, pRowIndex);
		if (tmpColumn)
		{
			tmpColumn.classList.toggle('is-hidden', !pOpen);
			// Pull the editor up under the result row and lift its View/Edit switch into it. Only under
			// the standard layout — the vertical template stacks differently and is left alone.
			const tmpOwnColumn = tmpToggle && (typeof tmpToggle.closest === 'function') ? tmpToggle.closest('.column') : null;
			if (tmpOwnColumn && tmpOwnColumn.classList.contains('test-acceptance-column'))
			{
				tmpColumn.classList.add('test-acceptance-remarks');
			}
		}
		const tmpChevron = tmpToggle && tmpToggle.querySelector('i');
		if (tmpChevron)
		{
			tmpChevron.className = pOpen ? 'fas fa-fw fa-chevron-down' : 'fas fa-fw fa-chevron-right';
		}
	}

	/** @param {string} pInputHash @return {Object|null} */
	_getInputByHash(pInputHash)
	{
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors)
		{
			return null;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.Hash === pInputHash)
			{
				return tmpDescriptor;
			}
		}
		return null;
	}

	// --- Tracking GUID binding (ported from SampleTestResult) ------------------------------------

	/**
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @param {string} [pType='TEST']
	 * @return {string|null}
	 */
	_getTrackingGUID(pInput, pRowIndex, pType = 'TEST')
	{
		if (pRowIndex == null)
		{
			if (pType === 'TEST' && pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
			{
				return pInput.PictForm.TestTrackingGUID;
			}
			if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
			{
				return pInput.PictForm.SampleTrackingGUID;
			}
		}
		const tmpGUID = this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType));
		if (typeof tmpGUID === 'string' && tmpGUID.length > 0)
		{
			return tmpGUID;
		}
		return null;
	}

	/**
	 * @param {Object} pInput @param {number|string|null} pRowIndex @param {string} pTrackingGUID
	 * @param {string} [pType='TEST']
	 */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType = 'TEST')
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	/**
	 * Inherit the tracking GUID of the test descriptor this result belongs to, so the test's events reach
	 * this field. Searches the row's own group first (tabular), then the global manifest.
	 *
	 * @param {Object} pView @param {Object} pGroup @param {Object} pInput @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (pRowIndex != null)
		{
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('SampleTestAcceptance: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}

		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('SampleTestAcceptance: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('SampleTestAcceptance: could not find sibling test descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = PictProviderInputTypeSampleTestAcceptance;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;
module.exports.DEFAULT_TEST_RESULT_OPTIONS = libTestResultOptions.DEFAULT_TEST_RESULT_OPTIONS;

},{"./PictProvider-InputType-Picker.js":95,"./_TestResultOptions.js":143}],112:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const SelectInputTypeProvider = require('./PictProvider-InputType-Select.js');

const DEFAULT_TEST_RESULT_OPTIONS = [
	{ 'id': 'N/A', 'text': 'N/A' },
	{ 'id': 'PROG', 'text': 'In Progress' },
	{ 'id': 'PEND', 'text': 'Pending' },
	{ 'id': 'FAIL', 'text': 'Failed' },
	{ 'id': 'FAIC', 'text': 'Failed with Comments' },
	{ 'id': 'PASS', 'text': 'Passed' },
	{ 'id': 'PASC', 'text': 'Passed with Comments' },
	{ 'id': 'VOID', 'text': 'Voided' },
];

class SampleTestResultInputType extends SelectInputTypeProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-TEST-RESULT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-TEST-RESULT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType)
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = {};
		}
		if (!pInput.PictForm.SelectOptions || !Array.isArray(pInput.PictForm.SelectOptions))
		{
			pInput.PictForm.SelectOptions = DEFAULT_TEST_RESULT_OPTIONS;
		}
		//TODO: any custom logic for loading test result codes / etc. here?
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = {};
		}
		if (!pInput.PictForm.SelectOptions || !Array.isArray(pInput.PictForm.SelectOptions))
		{
			pInput.PictForm.SelectOptions = DEFAULT_TEST_RESULT_OPTIONS;
		}
		//TODO: any custom logic for loading test result codes / etc. here?
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		//TODO: plumb the test result into the configured address
		return tmpResult;
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		//TODO: plumb the test result into the configured address
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload, tmpExtraData ] = pEvent.split(':');

		//FIXME: needs revision to work with multi-sample forms
		if (tmpEventType === 'TestStatusAggregate')
		{
			const tmpDestination = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (Array.isArray(tmpDestination))
			{
				let tmpTestResult;
				if (pRowIndex != null)
				{
					tmpTestResult = this.pict.ContentAssignment.readContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex));
				}
				else
				{
					tmpTestResult = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
				}
				tmpDestination.push(tmpTestResult);
			}
		}

		if (tmpEventType === 'SetTestResultByHash')
		{
			const tmpChangedTestHash = tmpTrackingGUID;
			const tmpEvent = `GetTestHash:${this._getTrackingGUID(pInput, pRowIndex)}:_GetTestHashResponse.${pInput.Hash}`;
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent);
			const tmpMarshalDestination = pView.getMarshalDestinationObject();
			const tmpTestHash = tmpMarshalDestination._GetTestHashResponse?.[pInput.Hash];
			if (tmpTestHash)
			{
				delete tmpMarshalDestination._GetTestHashResponse[pInput.Hash];
				if (Object.keys(tmpMarshalDestination._GetTestHashResponse).length === 0)
				{
					delete tmpMarshalDestination._GetTestHashResponse;
				}
			}
			if (tmpTestHash !== tmpChangedTestHash)
			{
				return;
			}
			const tmpSuccessMarkerAddress = tmpExtraData;
			if (pRowIndex != null)
			{
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpEventPayload);
				pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
			}
			else
			{
				pView.setDataByInput(pInput, tmpEventPayload);
				pView.manualMarshalDataToViewByInput(pInput);
			}
			if (tmpSuccessMarkerAddress)
			{
				this.pict.manifest.setValueAtAddress(this.pict, tmpSuccessMarkerAddress, true);
			}
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput)}:${tmpEventPayload}`);
		}

		if (tmpEventType === 'MarkNewTestsInProgress' && pInput.PictForm && pInput.PictForm.MarkTestsInProgressOnSave && pInput.PictForm.MarkTestsInProgressOnSave !== 'false')
		{
			let tmpDataAddress = pInput.DataAddress;
			if (pRowIndex != null)
			{
				tmpDataAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			let tmpTestResult = pView.sectionManifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDataAddress);
			if (pRowIndex != null)
			{
				tmpTestResult = this.pict.ContentAssignment.readContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex));
			}
			else
			{
				tmpTestResult = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
			}
			if (!tmpTestResult || tmpTestResult === 'N/A')
			{
				tmpTestResult = 'PROG';
				if (pRowIndex != null)
				{
					pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpTestResult);
					pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
				}
				else
				{
					pView.setDataByInput(pInput, tmpTestResult);
					pView.manualMarshalDataToViewByInput(pInput);
				}
			}
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpEvent = 'MarkNewTestsInProgress';
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}


	/**
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 * @param {string} [pType='TEST'] - Default to TEST since that is the only local type we care about here.
	 *
	 * @returns {string|null}
	 */
	_getTrackingGUID(pInput, pRowIndex, pType = 'TEST')
	{
		if (pRowIndex == null)
		{
			switch (pType)
			{
			case 'TEST':
				if (pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
				{
					return pInput.PictForm.TestTrackingGUID;
				}
			default:
				if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
				{
					return pInput.PictForm.SampleTrackingGUID;
				}
			}
		}
		const tmpGUID = this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType));
		if (typeof tmpGUID === 'string' && tmpGUID.length > 0)
		{
			return tmpGUID;
		}
		return null;
	}

	/**
	 * @param {Object} pInput
	 * @param {number|null} pRowIndex
	 * @param {string} pTrackingGUID
	 * @param {string} [pType='TEST'] - Default to TEST since that is the only local type we care about here.
	 *
	 * @return {void}
	 */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType = 'TEST')
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	/**
	 * Searches for the sample descriptor that this test result should be bound to and inherits its tracking GUID if needed.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		// modalities:
		//
		// single global sample
		// tabular row-based tests
		// tabular row-based sample and tests

		if (pRowIndex != null)
		{
			// tabular
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('SampleTestResultSelector: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		// check sibling Descriptors for a sample descriptor
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('SampleTestResultSelector: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('SampleTestResultSelector: could not find sibling test descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = SampleTestResultInputType;
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-InputType-Select.js":115}],113:[function(require,module,exports){
const PickerProvider = require('./PictProvider-InputType-Picker.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'SampleTypePicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * Sample-type picker (beast B1) — the Picker-stack port of the legacy SampleTypeSelector (a
 * MaterialsEntitySelector subclass; this class mirrors it 1:1 for diff-review). Reuses the base broker
 * (Entity=SampleType via the specialized-selector map) and keeps the sample's two type columns in sync
 * through the cascade seam: the modern `IDSampleType` FK (set by the standard autofill) and the legacy
 * `MaterialType` code. On forward selection it mirrors the picked type's `Hash` onto `MaterialType`;
 * when seeding from a linked sample it prefers `IDSampleType` and falls back to resolving the
 * `MaterialType` code to a SampleType so pre-backfill samples still display (and pick up the FK on the
 * next save). Declarative defaults (`Default:"ACPT"` + `DefaultField:"Hash"`) come from the base broker
 * via the map's MaterialsFamily flag.
 */
class PictProviderInputTypeSampleTypePicker extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Record<string, any>|null} Hash -> SampleType record, lazily loaded for the reverse fallback. */
		this._sampleTypesByHash = null;
		/** @type {boolean} true while the map request is in flight; kept separate from the map so an unloaded map stays null. */
		this._sampleTypeMapLoading = false;
		/** @type {Array<{View: Object, Input: Object, RowIndex: number|string|null}>} inputs that initialized mid-load and owe a seed. */
		this._sampleTypeMapWaiters = [];
		/** @type {boolean} re-entrancy guard so a fallback-driven commit does not re-seed mid-seed. */
		this._fallbackSeeding = false;
	}

	/** @param {Object} pInput @return {string} marshal-relative address of the sample's legacy MaterialType code. */
	_sampleMaterialTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleMaterialTypeAddress || 'SampleID__Record.MaterialType';
	}
	/** @param {Object} pInput @return {string} marshal-relative address of the sample's IDSampleType FK. */
	_sampleIDSampleTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleIDSampleTypeAddress || 'SampleID__Record.IDSampleType';
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._loadSampleTypeMap(pView, pInput, null);
		// The legacy seed fired via the init-time record refresh; the broker has no init-time cascade, so
		// attempt it directly — its own gates (sample already carries the FK / no legacy code) make it a no-op
		// everywhere it should not run.
		this._seedSampleTypeFromMaterialType(pView, pInput, null);
		return tmpResult;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._loadSampleTypeMap(pView, pInput, pRowIndex);
		this._seedSampleTypeFromMaterialType(pView, pInput, pRowIndex);
		return tmpResult;
	}

	/**
	 * Legacy re-ran the seed on every marshal (MES _onDataMarshalToForm → _onRecordRefresh), which is what
	 * caught a linked sample record landing after init. The seed's own gates keep it a no-op otherwise.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._seedSampleTypeFromMaterialType(pView, pInput, null);
		return tmpResult;
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		const tmpResult = super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._seedSampleTypeFromMaterialType(pView, pInput, pRowIndex);
		return tmpResult;
	}

	/**
	 * Lazily cache Hash -> SampleType for the current customer (row-level auth scopes the read).
	 *
	 * The load is async and the caller seeds immediately after calling this, so EVERY input that initializes
	 * while the request is in flight is queued and re-seeded when it lands — not just the first. The map
	 * itself stays `null` until it is real (the in-flight state is tracked separately), so the emptiness
	 * guard in `_seedSampleTypeFromMaterialType` means what it says: a seed during the window is suppressed
	 * rather than resolving against an empty map and silently giving up. The waiter carries its row index so
	 * a tabular picker replays against the row it initialized on.
	 *
	 * @param {Object} [pView] @param {Object} [pInput] the picker to re-seed once the map loads.
	 * @param {number|string|null} [pRowIndex] row the picker initialized on, for the tabular case.
	 */
	_loadSampleTypeMap(pView, pInput, pRowIndex)
	{
		if (this._sampleTypesByHash || !this.pict?.HeadlightRestClient)
		{
			return;
		}
		// The provider family is commonly instantiated via Object.create in harnesses and by the broker, so
		// do not assume the constructor ran.
		if (!Array.isArray(this._sampleTypeMapWaiters))
		{
			this._sampleTypeMapWaiters = [];
		}
		if (pView && pInput)
		{
			this._sampleTypeMapWaiters.push({ View: pView, Input: pInput, RowIndex: (pRowIndex === undefined) ? null : pRowIndex });
		}
		if (this._sampleTypeMapLoading)
		{
			return;
		}
		this._sampleTypeMapLoading = true;
		this.pict.HeadlightRestClient.getJSON('SampleTypes/FilteredTo/FSF~IDSampleType~ASC~0/0/500', (pError, pTypes) =>
		{
			this._sampleTypeMapLoading = false;
			const tmpWaiters = this._sampleTypeMapWaiters;
			this._sampleTypeMapWaiters = [];
			if (pError || !Array.isArray(pTypes))
			{
				// Reset to null (not an empty map) so the next onInputInitialize retries rather than being
				// stuck resolving against a map that will never fill.
				this._sampleTypesByHash = null;
				return;
			}
			const tmpMap = {};
			for (const tmpType of pTypes)
			{
				if (tmpType && tmpType.Hash)
				{
					tmpMap[tmpType.Hash] = tmpType;
				}
			}
			this._sampleTypesByHash = tmpMap;
			for (const tmpWaiter of tmpWaiters)
			{
				this._seedSampleTypeFromMaterialType(tmpWaiter.View, tmpWaiter.Input, tmpWaiter.RowIndex);
			}
		});
	}

	/**
	 * The cascade twin of the legacy `_onRecordRefresh`: fired after `__Record` lands (select and clear).
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
		if (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord) && pRecord.IDSampleType)
		{
			// Forward: mirror the picked type's Hash onto the sample's legacy MaterialType column.
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._sampleMaterialTypeAddress(pInput), pRecord.Hash || '');
			return;
		}
		this._seedSampleTypeFromMaterialType(pView, pInput, pRowIndex);
	}

	/**
	 * Reverse fallback: when nothing is selected and the bound sample has no IDSampleType but carries a
	 * legacy MaterialType code, resolve it to a SampleType, seed the picker, and backfill the FK in-form.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} [pRowIndex]
	 */
	_seedSampleTypeFromMaterialType(pView, pInput, pRowIndex)
	{
		if (this._fallbackSeeding || !this._sampleTypesByHash || !pView || typeof pView.getMarshalDestinationObject !== 'function')
		{
			return;
		}
		const tmpDestination = pView.getMarshalDestinationObject();
		// Only seed an EMPTY picker (found live: this seam fires from init and the async map-load too,
		// where a value may already be committed). The legacy provider reached the same outcome
		// structurally — its seed was only ever entered from a record refresh whose record had no
		// IDSampleType, and a valued picker's init refresh takes the forward-mirror branch instead —
		// so without this gate a stale legacy code would hijack a real selection on reload.
		const tmpValueAddress = this._getRecordAddress(pInput, pRowIndex).replace(/__Record$/, '');
		if (this.pict.manifest.getValueAtAddress(tmpDestination, tmpValueAddress))
		{
			return;
		}
		const tmpExistingID = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput));
		if (tmpExistingID)
		{
			return;
		}
		const tmpMaterialType = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleMaterialTypeAddress(pInput));
		const tmpResolved = tmpMaterialType ? this._sampleTypesByHash[tmpMaterialType] : null;
		if (!tmpResolved)
		{
			return;
		}
		this._fallbackSeeding = true;
		try
		{
			// Backfill the FK + pre-seed __Record synchronously from the map (offline-tolerant: the commit's
			// record refresh re-resolves the same id and, on a failed lookup, keeps this pre-seeded record),
			// then land the picker value through the value-commit primitive — model write + fenced provider
			// loop (record refresh → cascade, whose forward branch re-mirrors MaterialType idempotently) +
			// widget repaint.
			this.pict.manifest.setValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput), tmpResolved.IDSampleType);
			this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex), tmpResolved);
			this._setValueAndCommit(pView, pInput, tmpResolved.IDSampleType, pRowIndex);
		}
		finally
		{
			this._fallbackSeeding = false;
		}
	}
}

module.exports = PictProviderInputTypeSampleTypePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-Picker.js":95}],114:[function(require,module,exports){
const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

/**
 * Sample-type picker. Reuses the generic entity selector (Entity=SampleType) but keeps the sample's two
 * type columns in sync: the modern `IDSampleType` FK (set by the standard autofill) and the legacy
 * `MaterialType` code. On forward selection it mirrors the picked type's `Hash` onto `MaterialType`; when
 * seeding from a linked sample it prefers `IDSampleType` and falls back to resolving the `MaterialType`
 * code to a SampleType so pre-backfill samples still display (and pick up the FK on the next save).
 */
class SampleTypeSelectorInputType extends MaterialsEntityInputType
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = {};
		}
		if (!pOptions.Entity)
		{
 pOptions.Entity = 'SampleType';
		}
		super(pFable, pOptions, pServiceHash);
		/** @type {Record<string, any>|null} Hash -> SampleType record, lazily loaded for the reverse fallback. */
		this._sampleTypesByHash = null;
		/** @type {boolean} true while the map request is in flight; kept separate from the map so an unloaded map stays null. */
		this._sampleTypeMapLoading = false;
		/** @type {Array<{View: Object, Input: Object}>} inputs that initialized mid-load and owe a seed when the map lands. */
		this._sampleTypeMapWaiters = [];
		/** @type {boolean} re-entrancy guard so a fallback-driven re-marshal does not re-seed. */
		this._fallbackSeeding = false;
	}

	/** @param {Object} pInput @return {string} marshal-relative address of the sample's legacy MaterialType code. */
	_sampleMaterialTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleMaterialTypeAddress || 'SampleID__Record.MaterialType';
	}
	/** @param {Object} pInput @return {string} marshal-relative address of the sample's IDSampleType FK. */
	_sampleIDSampleTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleIDSampleTypeAddress || 'SampleID__Record.IDSampleType';
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._loadSampleTypeMap(pView, pInput);
		return tmpResult;
	}

	/**
	 * Lazily cache Hash -> SampleType for the current customer (row-level auth scopes the read).
	 *
	 * The load is async and the reverse-seed fires during init, so EVERY input that initializes while the
	 * request is in flight is queued and re-seeded when it lands — not just the first. The map itself stays
	 * `null` until it is real (the in-flight state is tracked separately), so the emptiness guard in
	 * `_seedSampleTypeFromMaterialType` means what it says: a seed during the window is suppressed rather
	 * than resolving against an empty map and silently giving up. An input arriving after the map is already
	 * loaded is seeded immediately — the init-time attempt that would otherwise cover it only runs off a
	 * record refresh, so a second form in the same session would never resolve.
	 *
	 * @param {Object} [pView] @param {Object} [pInput] the picker to seed once the map is available.
	 */
	_loadSampleTypeMap(pView, pInput)
	{
		if (!this.pict?.HeadlightRestClient)
		{
			return;
		}
		if (this._sampleTypesByHash)
		{
			if (pView && pInput)
			{
				this._seedSampleTypeFromMaterialType(pView, pInput);
			}
			return;
		}
		// The provider family is commonly instantiated via Object.create in harnesses and by the broker, so
		// do not assume the constructor ran.
		if (!Array.isArray(this._sampleTypeMapWaiters))
		{
			this._sampleTypeMapWaiters = [];
		}
		if (pView && pInput)
		{
			this._sampleTypeMapWaiters.push({ View: pView, Input: pInput });
		}
		if (this._sampleTypeMapLoading)
		{
			return;
		}
		this._sampleTypeMapLoading = true;
		this.pict.HeadlightRestClient.getJSON('SampleTypes/FilteredTo/FSF~IDSampleType~ASC~0/0/500', (pError, pTypes) =>
		{
			this._sampleTypeMapLoading = false;
			const tmpWaiters = this._sampleTypeMapWaiters;
			this._sampleTypeMapWaiters = [];
			if (pError || !Array.isArray(pTypes))
			{
				// Reset to null (not an empty map) so the next onInputInitialize retries rather than being
				// stuck resolving against a map that will never fill.
				this._sampleTypesByHash = null;
				return;
			}
			const tmpMap = {};
			for (const tmpType of pTypes)
			{
				if (tmpType && tmpType.Hash)
				{
					tmpMap[tmpType.Hash] = tmpType;
				}
			}
			this._sampleTypesByHash = tmpMap;
			for (const tmpWaiter of tmpWaiters)
			{
				this._seedSampleTypeFromMaterialType(tmpWaiter.View, tmpWaiter.Input);
			}
		});
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pRecord @param {string} pRecordAddress
	 * @param {string} pTransactionGUID @param {number} [pRowIndex]
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
		if (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord) && pRecord.IDSampleType)
		{
			// Forward: mirror the picked type's Hash onto the sample's legacy MaterialType column.
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._sampleMaterialTypeAddress(pInput), pRecord.Hash || '');
			return;
		}
		this._seedSampleTypeFromMaterialType(pView, pInput, pRecordAddress, pRowIndex);
	}

	/**
	 * Reverse fallback: when nothing is selected and the bound sample has no IDSampleType but carries a
	 * legacy MaterialType code, resolve it to a SampleType, seed the picker, and backfill the FK in-form.
	 * @param {Object} pView @param {Object} pInput @param {string} [pRecordAddress] @param {number} [pRowIndex]
	 */
	_seedSampleTypeFromMaterialType(pView, pInput, pRecordAddress, pRowIndex)
	{
		if (this._fallbackSeeding || !this._sampleTypesByHash)
		{
			return;
		}
		const tmpDestination = pView.getMarshalDestinationObject();
		const tmpExistingID = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput));
		if (tmpExistingID)
		{
			return;
		}
		const tmpMaterialType = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleMaterialTypeAddress(pInput));
		const tmpResolved = tmpMaterialType ? this._sampleTypesByHash[tmpMaterialType] : null;
		if (!tmpResolved)
		{
			return;
		}
		const tmpRecordAddress = pRecordAddress || this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpValueAddress = tmpRecordAddress.replace(/__Record$/, '');
		this._fallbackSeeding = true;
		try
		{
			this.pict.manifest.setValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput), tmpResolved.IDSampleType);
			this.pict.manifest.setValueAtAddress(tmpDestination, tmpValueAddress, tmpResolved.IDSampleType);
			this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, tmpResolved);
			if (typeof pView.marshalToView === 'function')
			{
				pView.marshalToView();
			}
		}
		finally
		{
			this._fallbackSeeding = false;
		}
	}
}

module.exports = SampleTypeSelectorInputType;

},{"./PictProvider-InputType-MaterialsEntitySelector.js":68}],115:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

const libEntityOptionSource = require('./_EntityOptionSource.js');

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {Record<string, {Loaded: boolean, Options: Array<{id: any, text: string}>, Callbacks: Array<Function>}>} Shared entity-backed option sets, keyed by entity + field config. */
		this._entitySelectOptionCache = {};
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			window['jQuery'].fn.select2.amd.define('select2/data/dynamicLocalPaginationAdapter',
				[
					'select2/data/array',
					'select2/utils',
				],
				function(ArrayAdapter, Utils)
				{
					function DynamicLocalPaginationAdapter($element, options)
					{
						// @ts-ignore — __super__ is injected by Select2's Utils.Extend
						DynamicLocalPaginationAdapter.__super__.constructor.call(this, $element, options);
					}
					Utils.Extend(DynamicLocalPaginationAdapter, ArrayAdapter);

					DynamicLocalPaginationAdapter.prototype.query = function(params, callback)
					{
						//TODO: customizable
						const pageSize = 100;

						if (!('page' in params))
						{
							params.page = 1;
						}
						const term = (params.term || '').toLowerCase();
						/** @type {any} */
						const tmpSelf = this;
						const results = tmpSelf.options.options.DynamicMetaLists.getList(tmpSelf.options.options.Input.PictForm.SelectOptionsPickList,
							{
								startIndex: (params.page - 1) * pageSize,
								maxResults: pageSize,
								filterString: term,
								searchFields: (tmpSelf.options.options.Input.PictForm.DistillingDisplay || '').split(',').filter((f) => f.trim() !== ''),
							});
						callback(
						{
							results,
							pagination:
							{
								more: results.length >= pageSize,
							},
						});
					};

					return DynamicLocalPaginationAdapter;
				});
		}
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} inputID The input id.
	 */
	addLoadingSkeleton(inputID, rawID)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${rawID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(inputID)[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(inputID, 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} inputID The input id.
	 */
	removeLoadingSkeleton(inputID, rawID)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${rawID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(inputID, 'is-hidden');
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a select input element in PDF display.
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element in PDF display.
	 */
	getSelectPDFDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular select input ID based on the provided input HTML ID and row index.
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular select input ID.
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select input ID for PDF display based on the provided input HTML ID and row index.
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular select input ID for PDF display.
	 */
	getTabularSelectPDFDisplayHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-TABULAR-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select dropdown ID based on the input HTML ID and row index.
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @return {string} - The generated tabular select dropdown ID.
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Resolve an entity-backed option list for this input (see `_EntityOptionSource`), kicking off the
	 * shared load on first ask. Returns null while the load is in flight, when the input is not
	 * entity-backed, and when the customer has no rows - in each case the caller keeps whatever static
	 * `PictForm.SelectOptions` fallback the input carries.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {Function} [fOnLoaded] - Invoked once, after an in-flight load resolves, so the caller can repaint.
	 * @return {Array<{id: any, text: string}>|null} - The option list, or null to fall back.
	 */
	resolveEntitySelectOptions(pInput, fOnLoaded)
	{
		return libEntityOptionSource.resolveOptions(this, pInput, fOnLoaded);
	}

	/**
	 * Build the selection list for a select input.
	 * @param {HTMLElement} pInputSelectElement - The select element.
	 * @param {Array} pListData - The list data.
	 * @param {Object} pInput - The input object.
	 * @param {Array<string>} pValues - The input value.
	 * @return {Array} - The filtered list data.
	 */
	rebuildSelectionList(pInputSelectElement, pListData, pInput, pValues)
	{
		// HAX
		pInputSelectElement.innerHTML = '';

		if (pInputSelectElement && pListData && Array.isArray(pListData))
		{
			if (pListData.length === 0)
			{
				// add the empty list option
				const pOption = document.createElement('option');
				pOption.value = '';
				pOption.text = 'No options available';
				pInputSelectElement.appendChild(pOption);
			}
			else
			{
				// add the placeholder option
				const pOption = document.createElement('option');
				pOption.value = '';
				pOption.text = this.pict.AppData.Interactive ? (pInput?.PictForm?.Placeholder || 'Select...') : '';
				pInputSelectElement.appendChild(pOption);

				for (let i = 0; i < pListData.length; i++)
				{
					// check if the passed value matches this option, and set the selected property
					pListData[i].selected = (pValues.find((v) => v == pListData[i].id) != null);
					// add the option to the select element
					const pOption = document.createElement('option');
					pOption.value = pListData[i].id;
					pOption.text = pListData[i].text;
					pOption.selected = pListData[i].selected;
					pInputSelectElement.appendChild(pOption);
				}
			}
		}
		return pListData;
	}

	/**
	 * Refreshes the select list for a dynamic input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {Array<string>|string} pValues - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {boolean} isTabular - Whether the context is tabular or not.
	 * @param {number|null} pRowIndex - The row index for tabular context (null for non-tabular context).
	 * @return {boolean|Array} - Returns false if the input element is not found, otherwise returns the filtered list data.
	 */
	refreshSelectList(pView, pGroup, pRow, pInput, pValues, pHTMLSelector, isTabular = false, pRowIndex = null)
	{
		if (typeof pValues === 'string')
		{
			pValues = pValues.split(',').filter((v) => v.trim() !== '');
		}
		const methodNameByContext = isTabular ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex));
		let tmpListData = pInput.PictForm?.SelectOptions;

		// Entity-backed vocabularies (PictForm.SelectOptionsEntity) win over the static list when the
		// customer has rows; an empty table or a failed read leaves the static SelectOptions in place.
		const tmpEntityOptions = this.resolveEntitySelectOptions(pInput, () =>
		{
			this.refreshSelectList(pView, pGroup, pRow, pInput, pValues, pHTMLSelector, isTabular, pRowIndex);
			const tmpReloadedElement = this.pict.ContentAssignment.getElement(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex));
			if (window['jQuery'] && tmpReloadedElement && tmpReloadedElement.length > 0)
			{
				window['jQuery'](tmpReloadedElement[0]).trigger('change.select2');
			}
		});
		if (Array.isArray(tmpEntityOptions) && tmpEntityOptions.length > 0)
		{
			tmpListData = tmpEntityOptions;
		}

		if (pInput.PictForm.SelectOptionsPickList)
		{
			if (this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic)
			{
				return false;
			}
			if (this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
			{
				tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
			}
		}

		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElement || tmpInputSelectElement.length < 1)
		{
			return false;
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData);

		tmpInputSelectElement = tmpInputSelectElement[0];

		return this.rebuildSelectionList(tmpInputSelectElement, tmpListData, pInput, pValues);
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, false, null);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 * NOTE: The tabular version uses a different select element/id for the dropdown selection by design.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._onInputInitialize(pView, pGroup, null, pInput, pValue, pHTMLSelector, true, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Internal method to initialize the input element for both regular and tabular contexts.
	 * @private
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object|null} pRow - The row object (null for tabular context).
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {boolean} isTabular - Whether the context is tabular or not.
	 * @param {number|null} pRowIndex - The row index for tabular context (null for non-tabular context).
	 */
	_onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, isTabular = false, pRowIndex = null)
	{
		const methodNameByContext = isTabular ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// add loading skeleton while we initialize the select2 plugin and load the options list, since this can take a moment and we want to avoid the user interacting with an uninitialized select element
		this.addLoadingSkeleton(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		// if this is a multiple select, we need to add the 'multiple' attribute to the select element and add the 'is-multiple' class to the wrapper for Bulma styling purposes
		const tmpIsMultiple = pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true;
		if (tmpIsMultiple)
		{
			this.pict.ContentAssignment.setAttribute(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex), 'multiple', 'multiple');
			// from the select tag, find the parent wrapper div with class '.control.select' so we can add the 'is-multiple' class to it (for Bulma styling purposes)
			const tmpSelectWrapper = document.querySelector(`${this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)}`)?.parentElement;
			if (tmpSelectWrapper && tmpSelectWrapper.classList.contains('select') && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
			window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).empty(); // remove placeholder
		}
		// ensure we use the right value format for multiple vs. single select inputs
		const tmpValues = tmpIsMultiple ? (pValue && typeof(pValue) === 'string' ? pValue.split(',') : []) : pValue ? [ pValue ] : [];
		// handle the case where the options list is coming from a dynamic pick list that needs to be loaded asynchronously
		this.refreshSelectList(pView, pGroup, pRow, pInput, tmpValues, pHTMLSelector, isTabular, pRowIndex);
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} [pRowIndex] The row index for tabluar rows.
	 */
	initializeSelect2(pInput, isTabular = false, pRowIndex)
	{
		if (this.pict.AppData.Interactive === false)
		{
			// if the app is not interactive, we don't need to initialize the select2 plugin
			return;
		}
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			// tabular vs. non-tabular context
			const methodNameByContext = isTabular ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			const tmpSelectElementSelector = this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex);
			// if the select2 plugin is not already initialized, initialize it now
			if (tmpSelectElementSelector && !window['jQuery'](tmpSelectElementSelector).data('select2'))
			{
				// NOTE: Select2 Option Documentation: https://select2.org/configuration/options-api
				const tmpSelectOptions = {
					allowClear: true,
					disabled: pInput.PictForm.Disabled,
					multiple: pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true,
					placeholder: this.pict.AppData.Interactive ? (pInput?.PictForm?.Placeholder || 'Select...') : '',
					width: '100%',
					tags: pInput.PictForm.AllowCustomValues,
					dropdownCssClass: pInput.PictForm.AllowCustomValues ? 'has-custom-options' : '',
					Disabled: pInput.PictForm.Disabled || false,
					createTag: function(params)
					{
						const term = params.term.trim();
						if (term === '')
						{
							return null;
						}
						return {
							id: term,
							text: term,
							newTag: true,
						};
					},
				};
				if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic)
				{
					tmpSelectOptions.ajax = {}; // necessary for custom data adapter to be used
					tmpSelectOptions.dataAdapter = $.fn.select2.amd.require('select2/data/dynamicLocalPaginationAdapter');
					// plumbing necessary context for the adapter since it doesn't have access to pict
					tmpSelectOptions.Input = pInput;
					tmpSelectOptions.DynamicMetaLists = this.pict.providers.DynamicMetaLists; //FIXME: ...
				}
				// initialize the select2 plugin on the select element
				window['jQuery'](tmpSelectElementSelector).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Handles the marshalling of data to the form for select input types, including setting the selected options on the select element and refreshing the options list if necessary.
	 * @param {object} pView The view object.
	 * @param {object} pGroup The group object.
	 * @param {object} pInput The input object.
	 * @param {string} pHTMLSelector The HTML selector.
	 * @param {number} pRowIndex The row index for tabular context.
	 * @param {boolean} isTabular Whether the context is tabular or not.
	 * @param {HTMLSelectElement} tmpInputSelectElement The select input element to set the options and values on.
	 * @param {boolean} tmpIsMultiple Whether the select input allows multiple selections or not.
	 * @param {Array<string>} tmpValues The input values to set on the select element.
	 */
	_onDataMarshalToForm(pView, pGroup, pInput, pHTMLSelector, pRowIndex, isTabular = false, tmpInputSelectElement, tmpIsMultiple, tmpValues)
	{
		// TODO: Consolidated a lot of the excess to this method so we can abstract/remove it proplery when we migrate to initalizing select2 in onInitialize and only refreshing the options list in onDataMarshalToForm,
		// but for now we need to ensure the select2 plugin is initialized before we set the options and values because of how "AllowCustomValues" works (since it relies on the "createTag" option in select2 which needs to be set at initialization),
		// and we also need to handle the case where the options list is coming from a dynamic pick list that needs to be loaded asynchronously, so we have some extra plumbing here to handle those cases for now.
		const tmpDynamicValues = pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic;
		let tmpChanged = false;
		for (const tmpValue of tmpValues)
		{
			let tmpValueSelected = false;

			//FIXME: this only works for initialization; it does nothing after select2 takes over
			for (let i = 0; i < tmpInputSelectElement.options.length; i++)
			{
				if (tmpInputSelectElement.options[i].value === tmpValue)
				{
					tmpInputSelectElement.options[i].selected = true;
					if (!tmpIsMultiple)
					{
						tmpInputSelectElement.selectedIndex = i;
						tmpChanged = true;
					}
					tmpValueSelected = true;
					break;
				}
			}

			if (tmpValue && !tmpValueSelected)
			{
				if (pInput.PictForm?.AllowCustomValues || tmpDynamicValues)
				{
					// if the value is not found in the select options, add it as a custom value
					const tmpOption = document.createElement('option');
					const tmpOptionInfo = pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList, { extractRootKey: tmpValue })[0];
					tmpOption.value = tmpOptionInfo?.id ?? tmpValue;
					tmpOption.text = tmpOptionInfo?.text ?? tmpValue;
					tmpOption.selected = true;
					tmpInputSelectElement.appendChild(tmpOption);
					tmpChanged = true;
				}
				else if (!tmpIsMultiple)
				{
					tmpInputSelectElement.selectedIndex = -1;
					tmpChanged = true;
					this.pict.log.error(`The value [${tmpValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
				}
			}
		}
		// only refresh the select list if custom values are not allowed (we don't want to lose custom values)
		if (!pInput.PictForm?.AllowCustomValues)
		{
			const tmpRow = pView.getRow(pInput.PictForm.GroupIndex, pRowIndex);
			this.refreshSelectList(pView, pGroup, tmpRow, pInput, tmpValues, pHTMLSelector, isTabular, pRowIndex);
		}
		// TODO: This needs to be moved to onInitialize and cleaned up, but for now we need to ensure the select2 plugin is initialized before we set the options and values
		// NOTE: There needs to be some adjustments to "allowCustomValues" to continue to work.
		this.initializeSelect2(pInput, isTabular, pRowIndex);
		// if we need to push change to Select2 but don't want it trigger the change event (which can cause issues with cascading selects),
		// we can trigger the 'change.select2' event which will update the Select2 UI without triggering the change event handlers
		if (tmpIsMultiple)
		{
			const tmpCurrentSelection = new Set($(tmpInputSelectElement).val() || []);
			if (tmpValues.length !== tmpCurrentSelection.size)
			{
				$(tmpInputSelectElement).val(tmpValues);
				tmpChanged = true;
			}
			else
			{
				for (const tmpValue of tmpValues)
				{
					if (!tmpCurrentSelection.has(tmpValue))
					{
						$(tmpInputSelectElement).val(tmpValues);
						tmpChanged = true;
						break;
					}
				}
			}
		}
		else
		{
			const tmpCurrentValue = $(tmpInputSelectElement).val();
			if (tmpValues.length === 0 && tmpCurrentValue != null || tmpCurrentValue != tmpValues[0])
			{
				$(tmpInputSelectElement).val(tmpValues.length > 0 ? tmpValues[0] : null);
				tmpChanged = true;
			}
		}
		if (tmpChanged)
		{
			$(tmpInputSelectElement).trigger('change.select2');
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpIsMultiple = pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true;
		const tmpValues = tmpIsMultiple ? (pValue && typeof(pValue) === 'string' ? pValue.split(',') : []) : pValue ? [ pValue ] : [];
		// When there is no live <select> to drive, render the selected option's label into
		// the static DISPLAY-FOR node instead. This covers the non-interactive PDF view AND
		// the Read (locked) theme, whose Tier-2.5 a11y treatment renders a static display node
		// rather than a `<select disabled>`. In Edit the DISPLAY-FOR id is absent, so the
		// assignContent inside handlePDFDisplay is a harmless no-op.
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (this.pict.AppData.Interactive === false || !tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			this.handlePDFDisplay(pInput, pValue, null, false, tmpValues);
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		this._onDataMarshalToForm(pView, pGroup, pInput, pHTMLSelector, null, false, tmpInputSelectElements[0], tmpIsMultiple, tmpValues);
		this.removeLoadingSkeleton(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), pInput.Macro.RawHTMLID);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpIsMultiple = pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true;
		const tmpValues = tmpIsMultiple ? (pValue && typeof(pValue) === 'string' ? pValue.split(',') : []) : pValue ? [ pValue ] : [];
		// As with the standard case: when there is no live <select> (PDF view or the Read
		// theme's static display node), render the label into the DISPLAY-TABULAR-FOR node.
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		if (this.pict.AppData.Interactive === false || !tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			this.handlePDFDisplay(pInput, pValue, pRowIndex, true, tmpValues);
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		this._onDataMarshalToForm(pView, pGroup, pInput, pHTMLSelector, pRowIndex, true, tmpInputSelectElements[0], tmpIsMultiple, tmpValues);
		this.removeLoadingSkeleton(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the display of the select input value for PDF view.
	 * TODO: This will go away when we migrate the initialization to be on the onInitialize event instead of onDataMarshalToForm, but for now,
	 * abstracting the mess to make it easier to remove later.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be displayed.
	 * @param {number} pRowIndex - The row index for tabular context.
	 * @param {boolean} isTabular - Whether the context is tabular or not.
	 * @param {Array<string>} tmpValues - The array of values to be displayed.
	 */
	handlePDFDisplay(pInput, pValue, pRowIndex, isTabular = false, tmpValues)
	{
		const methodNameByContext = isTabular ? 'getTabularSelectPDFDisplayHTMLID' : 'getSelectPDFDisplayHTMLID';
		// set the display value
		const tmpDisplayValues = [];
		let tmpDefaultData = pInput.PictForm.SelectOptions;

		// Entity-backed vocabularies label the Read / PDF nodes from the loaded rows, matching Edit. This
		// path never runs refreshSelectList, so it is usually what STARTS the load — repaint once it
		// lands, otherwise a managed-only code would be stuck showing as its raw code here.
		const tmpEntityOptions = this.resolveEntitySelectOptions(pInput, () => this.handlePDFDisplay(pInput, pValue, pRowIndex, isTabular, tmpValues));
		if (Array.isArray(tmpEntityOptions) && tmpEntityOptions.length > 0)
		{
			tmpDefaultData = tmpEntityOptions;
		}

		// When the input is backed by a dynamic picklist (SelectOptionsPickList) rather than a
		// static SelectOptions array, resolve the option set from the DynamicMetaLists provider —
		// the same source the Edit/marshal paths use. Without this the Read (locked) and PDF
		// display nodes stay blank for picklist-backed Select2 inputs, since SelectOptions is empty.
		if ((!tmpDefaultData || tmpDefaultData.length < 1) &&
			pInput.PictForm.SelectOptionsPickList &&
			this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpDefaultData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		for (let i=0; i<tmpValues.length; i++)
		{
			// find the text value for the selected value (by id)
			const tmpIndex = (tmpDefaultData && tmpDefaultData.length > 0) ?
				tmpDefaultData.findIndex((tmpSelection) => tmpSelection.id == tmpValues[i]) :
				-1;
			if (tmpIndex > -1)
			{
				tmpDisplayValues.push(tmpDefaultData[tmpIndex].text);
			}
			else if (pInput.PictForm.AllowCustomValues || pInput.PictForm.SelectOptionsEntity)
			{
				// Custom / free-entry values have no option row; show the raw value so a
				// picklist-backed or custom selection still renders in Read and PDF views. An
				// entity-backed vocabulary gets the same treatment: a stored code that has been
				// retired from the managed list still renders as its code rather than blank.
				tmpDisplayValues.push(tmpValues[i]);
			}
		}
		this.pict.ContentAssignment.assignContent(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex), tmpDisplayValues.join(', '));
		return;
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Special handling for filters inputs, do not remove.
		if (pView.Hash === 'PSRSFilterProxyView')
		{
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.InformaryDataAddress.replace('StringArrayValue', 'Values'), pValue ? pValue.split(',') : []);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"./_EntityOptionSource.js":135,"pict-section-form":497}],116:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class SignatureInputHandler extends PictSectionInputExtension
{
	/**
	 * @param {any} pFable
	 * @param {Record<string, any> | undefined} pOptions
	 * @param {string | undefined} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Modal drawing state (active only while the modal is open)
		/** @type {HTMLCanvasElement | null} */
		this._canvas = null;
		/** @type {CanvasRenderingContext2D | null} */
		this._ctx = null;
		/** @type {boolean} */
		this._isDrawing = false;
		/** @type {number} */
		this._lastX = 0;
		/** @type {number} */
		this._lastY = 0;
		/** @type {number} */
		this._strokePointCount = 0;
		/** @type {number} - current smoothed line width for pressure/velocity tapering */
		this._currentWidth = 2;
		/** @type {number} - timestamp of the last pointer move for velocity calculation */
		this._lastTime = 0;

		// Tracks whether user cleared the canvas (reset to pristine on apply)
		/** @type {boolean} */
		this._cleared = false;

		// Undo/Redo stacks (stored as canvas data URLs)
		/** @type {string[]} */
		this._undoStack = [];
		/** @type {string[]} */
		this._redoStack = [];

		// Current modal settings
		/** @type {string} */
		this._inkColor = '#000000';
		/** @type {number} */
		this._penThickness = 2;
		/** @type {boolean} */
		this._printName = true;
		/** @type {boolean} */
		this._printTitle = true;
		/** @type {boolean} */
		this._printDate = true;
		/** @type {string} */
		this._dateFormat = 'MM/DD/YYYY hh:mm A';
		/** @type {string} */
		this._timezone = 'UTC';

		// Track which input the modal is editing
		/** @type {string} */
		this._activeInputHTMLID = '';
		/** @type {string} */
		this._activeInputHash = '';
		/** @type {boolean} */
		this._activeIsTabular = false;
		/** @type {number | string | null} */
		this._activeRowIndex = null;

		// Bound event handlers (for cleanup)
		/** @type {((e: PointerEvent) => void) | null} */
		this._boundPointerDown = null;
		/** @type {((e: PointerEvent) => void) | null} */
		this._boundPointerMove = null;
		/** @type {((e: PointerEvent) => void) | null} */
		this._boundPointerUp = null;
	}

	// ── Element ID helpers ───────────────────────────────────────────

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 */
	getPreviewHTMLID(pInputHTMLID)
	{
		return `#SIGNATURE-PREVIEW-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string | number} pRowIndex - The row index if this is a tabular input
	 */
	getTabularPreviewHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-SIGNATURE-PREVIEW-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 */
	getInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string | number | undefined} pRowIndex - The row index if this is a tabular input
	 */
	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	injectCustomCSS()
	{
		if (document.getElementById('SignatureInputCustomStyles')) return;

		const style = document.createElement('style');
		style.id = 'SignatureInputCustomStyles';
		style.textContent = /*css*/`
			.signature-preview-image {
				border: 1px dashed hsl(0,0%,80%);
				border-radius: 4px;
				width: 100%;
				height: 120px;
				aspect-ratio: 5 / 1;
				object-fit: contain;
				object-position: center;
				background: transparent;
			}
			.signature-preview-image[disabled] {
				opacity: 0.6;
				cursor: not-allowed;
			}
			.signature-preview-image.print-only-signature-preview {
				border: none;
			}
			.signature-edit-button {
				position: absolute;
				top: 4px;
				right: 4px;
				z-index:1;
			}
			.signature-preview-container {
				position: relative;
				cursor: pointer;
			}
			.signature-preview-container.is-danger .signature-preview-image {
				border-color: var(--bulma-danger);
			}
			.signature-preview-container.is-success .signature-preview-image {
				border-color: var(--bulma-success);
			}
			/* Toolbar buttons intentionally inherit the default themed Bulma .button styling
			   so they follow light/dark; no hardcoded background (which didn't spin with the theme). */
		`;
		document.head.appendChild(style);
	}

	// ── Placeholder image generation ─────────────────────────────────

	/**
	 * Generates a transparent PNG with dim "add signature" text for the pristine state.
	 * @returns {string} data URL of the placeholder PNG
	 */
	generatePlaceholderImage()
	{
		const tmpCanvas = document.createElement('canvas');
		tmpCanvas.width = 400;
		tmpCanvas.height = 120;
		const tmpCtx = tmpCanvas.getContext('2d');

		if (tmpCtx)
		{
			// transparent background (default)
			tmpCtx.clearRect(0, 0, tmpCanvas.width, tmpCanvas.height);

			// dim placeholder text
			tmpCtx.fillStyle = 'rgba(180, 180, 180, 0.6)';
			tmpCtx.font = 'italic 15px sans-serif';
			tmpCtx.textAlign = 'center';
			tmpCtx.textBaseline = 'middle';
			tmpCtx.fillText('add signature', tmpCanvas.width / 2, tmpCanvas.height / 2);
		}

		return tmpCanvas.toDataURL('image/png');
	}

	// ── Preview management ───────────────────────────────────────────

	/**
	 * Sets the preview image src to either the stored value or the placeholder.
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string} pValue - base64 encoded PNG value (or empty)
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {any} [pRowIndex] - The row index if this is a tabular input
	 */
	updatePreviewImage(pInputHTMLID, pValue, isTabular = false, pRowIndex = null)
	{
		const tmpSelector = isTabular ? this.getTabularPreviewHTMLID(pInputHTMLID, pRowIndex) : this.getPreviewHTMLID(pInputHTMLID);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpSelector);

		if (Array.isArray(tmpElements) && tmpElements.length > 0)
		{
			const tmpImg = tmpElements[0];
			if (tmpImg instanceof HTMLImageElement)
			{
				if (pValue)
				{
					// Value is stored as raw base64; add the data URI prefix for display
					tmpImg.src = pValue.startsWith('data:') ? pValue : `data:image/png;base64,${pValue}`;
				}
				else
				{
					tmpImg.src = this.generatePlaceholderImage();
				}
			}
		}
	}

	/**
	 * Updates the hidden input value and dispatches a change event.
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input to update
	 * @param {string} pValue - base64 string (without data URI prefix)
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {any} [pRowIndex] - The row index if this is a tabular input
	 */
	updateHiddenInputValue(pInputHTMLID, pValue, isTabular = false, pRowIndex = null)
	{
		const tmpSelector = isTabular ? this.getTabularInputHTMLID(pInputHTMLID, pRowIndex) : this.getInputHTMLID(pInputHTMLID);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpSelector);

		if (Array.isArray(tmpElements) && tmpElements.length > 0)
		{
			const tmpInput = tmpElements[0];
			if (tmpInput instanceof HTMLInputElement)
			{
				this.pict.ContentAssignment.assignContent(tmpSelector, pValue);
				const event = new Event('change', { bubbles: true });
				tmpInput.dispatchEvent(event);
			}
		}
	}

	// ── Canvas settings from PictForm ────────────────────────────────

	/**
	 * Reads CanvasSettings from the PictForm input descriptor using direct view/input lookup.
	 * @param {string} pViewHash - The view hash for direct lookup
	 * @param {string} pInputHash - The input hash to look up
	 * @returns {{ InkColor: string, PenThickness: number, PrintName: boolean, PrintTitle: boolean, PrintDate: boolean, DateFormat: string, Timezone: string }}
	 */
	getCanvasSettings(pViewHash, pInputHash)
	{
		const tmpDefaultTimezone = this.fable.options?.Timezone || this.pict.AppData?.CurrentUser?.Timezone || new Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
		const tmpDefaults = { InkColor: '#000000', PenThickness: 2, PrintName: true, PrintTitle: true, PrintDate: true, DateFormat: 'MM/DD/YYYY hh:mm A', Timezone: tmpDefaultTimezone };

		const tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.getInputFromHash) return tmpDefaults;

		const tmpInput = tmpView.getInputFromHash(pInputHash);
		if (!tmpInput?.PictForm?.CanvasSettings) return tmpDefaults;

		return {
			InkColor: tmpInput.PictForm.CanvasSettings.InkColor || tmpDefaults.InkColor,
			PenThickness: tmpInput.PictForm.CanvasSettings.PenThickness || tmpDefaults.PenThickness,
			PrintName: tmpInput.PictForm.CanvasSettings.hasOwnProperty('PrintName') ? tmpInput.PictForm.CanvasSettings.PrintName : tmpDefaults.PrintName,
			PrintTitle: tmpInput.PictForm.CanvasSettings.hasOwnProperty('PrintTitle') ? tmpInput.PictForm.CanvasSettings.PrintTitle : tmpDefaults.PrintTitle,
			PrintDate: tmpInput.PictForm.CanvasSettings.hasOwnProperty('PrintDate') ? tmpInput.PictForm.CanvasSettings.PrintDate : tmpDefaults.PrintDate,
			DateFormat: tmpInput.PictForm.CanvasSettings.DateFormat || tmpDefaults.DateFormat,
			Timezone: tmpInput.PictForm.CanvasSettings.Timezone || tmpDefaults.Timezone,
		};
	}

	// ── Named color map ──────────────────────────────────────────────

	/**
	 * Resolves a color name or hex value to a hex code for use on the canvas.
	 * @param {string} pColor - The color name or hex code from the configuration
	 * @returns {string} hex color code (e.g. "#FF0000")
	 */
	resolveColor(pColor)
	{
		if (!pColor) return '#000000';

		// If it's already a hex code, return it directly
		if (pColor.startsWith('#')) return pColor;

		/** @type {Record<string, string>} */
		const tmpColorMap = {
			'black': '#000000',
			'blue': '#0000FF',
			'royal blue': '#4169E1',
			'royalblue': '#4169E1',
			'red': '#FF0000',
			'dark blue': '#00008B',
			'darkblue': '#00008B',
			'navy': '#000080',
			'green': '#008000',
			'dark green': '#006400',
			'purple': '#800080',
			'brown': '#8B4513',
			'gold': '#FFD700',
			'gray': '#808080',
			'grey': '#808080',
		};

		return tmpColorMap[pColor.toLowerCase()] || pColor;
	}

	// ── Modal / Canvas ───────────────────────────────────────────────

	/**
	 * Opens the signature drawing modal.
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string} pViewHash - The view hash for looking up canvas settings
	 * @param {string} pInputHash - The input hash for looking up canvas settings
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {any} [pRowIndex] - The row index if this is a tabular input
	 * @param {boolean} [pDisabled=false] - Whether the input is disabled
	 */
	openSignatureModal(pInputHTMLID, pViewHash, pInputHash, isTabular = false, pRowIndex = null, pDisabled = false)
	{
		if (pDisabled) return;

		// Store active context
		this._activeInputHTMLID = pInputHTMLID;
		this._activeInputHash = pInputHash;
		this._activeIsTabular = isTabular;
		this._activeRowIndex = pRowIndex;

		// Read configuration
		const tmpSettings = this.getCanvasSettings(pViewHash, pInputHash);
		this._inkColor = this.resolveColor(tmpSettings.InkColor);
		this._penThickness = tmpSettings.PenThickness;
		this._printName = tmpSettings.PrintName;
		this._printTitle = tmpSettings.PrintTitle;
		this._printDate = tmpSettings.PrintDate;
		this._dateFormat = tmpSettings.DateFormat;
		this._timezone = tmpSettings.Timezone;

		// Reset undo/redo stacks
		this._undoStack = [];
		this._redoStack = [];

		// Read current value so we can pre-populate the canvas
		const tmpInputSelector = isTabular ? this.getTabularInputHTMLID(pInputHTMLID, pRowIndex) : this.getInputHTMLID(pInputHTMLID);
		const tmpInputElements = this.pict.ContentAssignment.getElement(tmpInputSelector);
		let tmpCurrentValue = '';
		if (Array.isArray(tmpInputElements) && tmpInputElements.length > 0 && tmpInputElements[0] instanceof HTMLInputElement)
		{
			tmpCurrentValue = tmpInputElements[0].value || '';
		}

		// Size the modal canvas from the preview area — match its rendered height directly
		// so the signing area is visually consistent with the preview.
		const tmpPreviewSelector = isTabular ? this.getTabularPreviewHTMLID(pInputHTMLID, pRowIndex) : this.getPreviewHTMLID(pInputHTMLID);
		const tmpPreviewElements = this.pict.ContentAssignment.getElement(tmpPreviewSelector);
		let tmpCanvasWidth = 600;
		let tmpCanvasHeight = 120;
		if (Array.isArray(tmpPreviewElements) && tmpPreviewElements.length > 0 && tmpPreviewElements[0] instanceof HTMLElement)
		{
			const tmpPreviewRect = tmpPreviewElements[0].getBoundingClientRect();
			if (tmpPreviewRect.width > 0)
			{
				tmpCanvasWidth = Math.round(tmpPreviewRect.width * 2);
			}
			if (tmpPreviewRect.height > 0)
			{
				tmpCanvasHeight = Math.round(tmpPreviewRect.height);
			}
		}

		// Build watermark overlay HTML (hidden when editing an existing signature, shown after clear)
		const tmpUser = this.pict.AppData?.CurrentUser;
		let tmpWatermarkInnerHTML = '';

		// Bottom-left: title (bold) + bullet + name
		const tmpWatermarkTitle = this._printTitle ? (tmpUser?.Title || '').trim() : '';
		const tmpWatermarkName = this._printName ? ((tmpUser?.NameFirst || '') + ' ' + (tmpUser?.NameLast || '')).trim() : '';
		const tmpWatermarkParts = [];
		if (tmpWatermarkTitle) tmpWatermarkParts.push(`<strong style="color: rgba(200,200,200,0.6);">${tmpWatermarkTitle}</strong>`);
		if (tmpWatermarkName) tmpWatermarkParts.push(tmpWatermarkName);
		if (tmpWatermarkParts.length > 0)
		{
			tmpWatermarkInnerHTML += `<span style="position:absolute; bottom:8px; left:10px; font:11px sans-serif; color:rgba(200,200,200,0.6); pointer-events:none;">${tmpWatermarkParts.join(' &bull; ')}</span>`;
		}

		// Bottom-right: timestamp placeholder
		if (this._printDate)
		{
			tmpWatermarkInnerHTML += `<span style="position:absolute; bottom:8px; right:10px; font:11px sans-serif; color:rgba(200,200,200,0.6); pointer-events:none;">timestamp</span>`;
		}

		// Signature line / watermark divider
		tmpWatermarkInnerHTML += `<div style="position:absolute; bottom:25px; left:8px; right:8px; height:0; border-top:1px solid rgba(180,180,180,0.5); pointer-events:none;"></div>`;

		const tmpWatermarkHTML = `<div id="SignatureModal-WatermarkOverlay" style="pointer-events:none;${tmpCurrentValue ? ' display:none;' : ''}">${tmpWatermarkInnerHTML}</div>`;

		const tmpModalBodyTemplate = /*HTML*/`
			<div class="signature-modal-body">
				<div class="signature-toolbar level is-mobile mb-3">
					<div class="level-left">
						<div class="level-item">
							<div class="field has-addons mb-0">
								<p class="control">
									<button type="button" class="button is-small" id="SignatureModal-Undo" title="Undo" aria-label="Undo last stroke"
										onclick="_Pict.providers.SignatureProvider.handleUndo();">
										<span class="icon is-small"><i class="fas fa-undo"></i></span>
									</button>
								</p>
								<p class="control">
									<button type="button" class="button is-small" id="SignatureModal-Redo" title="Redo" aria-label="Redo last stroke"
										onclick="_Pict.providers.SignatureProvider.handleRedo();">
										<span class="icon is-small"><i class="fas fa-redo"></i></span>
									</button>
								</p>
								<p class="control">
									<button type="button" class="button is-small" id="SignatureModal-Clear" title="Clear"
										onclick="_Pict.providers.SignatureProvider.handleClear();">
										<span class="icon is-small"><i class="fas fa-eraser"></i></span>
										<span>Clear</span>
									</button>
								</p>
							</div>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">
							<label class="label is-small pr-2" for="SignatureModal-PenThickness">Thickness</label>
							<input type="range" id="SignatureModal-PenThickness" class="slider" min="1" max="8" step="1" value="${this._penThickness}"
										oninput="_Pict.providers.SignatureProvider.handleThicknessChange(this.value);" />
						</div>
						<div class="level-item">
							<label class="label is-small pr-2" for="SignatureModal-InkColor">Ink Color</label>
							<input type="color" id="SignatureModal-InkColor" class="input is-small" value="${this._inkColor}"
								style="width:36px; cursor:pointer; padding:2px;"
								oninput="_Pict.providers.SignatureProvider.handleColorChange(this.value);" />
						</div>
					</div>
				</div>
				<div style="position:relative;">
					<canvas id="SignatureModal-Canvas"
						role="img" aria-label="Signature drawing area"
						style="border:1px solid hsl(0,0%,86%); border-radius:4px; cursor:crosshair; touch-action:none; width:100%; height:${tmpCanvasHeight}px; display:block; background:#fff;"
						width="${tmpCanvasWidth}" height="${tmpCanvasHeight}">
					</canvas>
					${tmpWatermarkHTML}
				</div>
			</div>`;

		// Use the field's label text as the modal title
		const tmpLabelElement = document.querySelector(`label[for="${pInputHTMLID}"]`);
		const tmpModalTitle = (tmpLabelElement && tmpLabelElement.textContent) ? tmpLabelElement.textContent.trim() : 'Signature';

		this.fable.HeadlightModal.spawnModal(
			{
				title: tmpModalTitle,
				modalBodyTemplate: tmpModalBodyTemplate,
				confirmText: 'Apply',
				cancelText: 'Cancel',
			},
			// On Apply
			() =>
			{
				this.applySignature();
			},
			// On Cancel (discard)
			null,
		);

		// Use a short timeout to ensure the modal DOM is ready before initializing the canvas
		setTimeout(() => this.initializeCanvas(tmpCurrentValue), 100);
	}

	/**
	 * Initializes the canvas within the modal, sets up drawing events, and loads existing signature data.
	 * @param {string} pExistingValue - base64 value of an existing signature (or empty)
	 */
	initializeCanvas(pExistingValue)
	{
		const tmpCanvasElement = document.getElementById('SignatureModal-Canvas');
		if (!tmpCanvasElement || !(tmpCanvasElement instanceof HTMLCanvasElement))
		{
			this.pict.log.error('[SignatureProvider] Could not find signature canvas in modal.');
			return;
		}
		this._canvas = tmpCanvasElement;
		this._ctx = this._canvas.getContext('2d');

		if (!this._ctx)
		{
			this.pict.log.error('[SignatureProvider] Could not get 2D context from canvas.');
			return;
		}

		// Scale canvas internal resolution by devicePixelRatio for crisp rendering on retina displays
		const tmpRect = this._canvas.getBoundingClientRect();
		const tmpDPR = window.devicePixelRatio || 1;
		if (tmpRect.width > 0)
		{
			this._canvas.width = tmpRect.width * tmpDPR;
			this._canvas.height = (tmpRect.height || 200) * tmpDPR;
			this._ctx.scale(tmpDPR, tmpDPR);
		}
		// Set initial drawing style
		this._ctx.lineCap = 'round';
		this._ctx.lineJoin = 'round';
		this._ctx.strokeStyle = this._inkColor;
		this._ctx.lineWidth = this._penThickness;
		this._ctx.imageSmoothingEnabled = true;

		// Fill with white background
		this._ctx.fillStyle = '#ffffff';
		this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);

		// Load existing signature if we have one
		if (pExistingValue)
		{
			const tmpImage = new Image();
			tmpImage.onload = () =>
			{
				if (!this._ctx || !this._canvas) return;
				// Bypass the DPR scale transform to draw at native canvas resolution
				this._ctx.save();
				this._ctx.setTransform(1, 0, 0, 1, 0, 0);
				this._ctx.drawImage(tmpImage, 0, 0, this._canvas.width, this._canvas.height);
				this._ctx.restore();
				this.pushUndoState();
			};
			tmpImage.src = pExistingValue.startsWith('data:') ? pExistingValue : `data:image/png;base64,${pExistingValue}`;
		}
		else
		{
			this.pushUndoState();
		}

		// Bind pointer events for mouse and touch drawing
		this._boundPointerDown = (/** @type {PointerEvent} */ e) => this.onPointerDown(e);
		this._boundPointerMove = (/** @type {PointerEvent} */ e) => this.onPointerMove(e);
		this._boundPointerUp = (/** @type {PointerEvent} */ e) => this.onPointerUp(e);

		this._canvas.addEventListener('pointerdown', this._boundPointerDown);
		this._canvas.addEventListener('pointermove', this._boundPointerMove);
		this._canvas.addEventListener('pointerup', this._boundPointerUp);
		this._canvas.addEventListener('pointerleave', this._boundPointerUp);
	}

	// ── Drawing events ───────────────────────────────────────────────

	/**
	 * @param {PointerEvent} pEvent - The pointer event for pointerdown, used to start drawing on the canvas
	 */
	onPointerDown(pEvent)
	{
		if (!this._ctx || !this._canvas) return;
		pEvent.preventDefault();
		this._isDrawing = true;
		this._cleared = false;
		this._strokePointCount = 0;
		this._currentWidth = this._penThickness;
		this._lastTime = Date.now();
		const tmpPos = this.getCanvasPosition(pEvent);
		this._lastX = tmpPos.x;
		this._lastY = tmpPos.y;

		this._ctx.strokeStyle = this._inkColor;
		this._ctx.lineWidth = this._penThickness;
		this._ctx.beginPath();
		this._ctx.moveTo(this._lastX, this._lastY);
	}

	/**
	 * @param {PointerEvent} pEvent - The pointer event for pointermove, used to draw on the canvas.
	 * Uses quadratic Bézier curves through midpoints for smooth, natural-looking strokes.
	 */
	onPointerMove(pEvent)
	{
		if (!this._isDrawing || !this._ctx || !this._canvas) return;
		pEvent.preventDefault();

		const tmpPos = this.getCanvasPosition(pEvent);
		this._strokePointCount++;

		// ── Pressure / velocity-based width tapering ─────────────────
		const tmpMinWidth = this._penThickness * 0.3;
		const tmpMaxWidth = this._penThickness * 1.6;
		let tmpTargetWidth = this._penThickness;

		if (pEvent.pressure && pEvent.pressure > 0 && pEvent.pressure < 1)
		{
			// Hardware pressure available (stylus / Apple Pencil / pressure-capable trackpad)
			tmpTargetWidth = tmpMinWidth + (tmpMaxWidth - tmpMinWidth) * pEvent.pressure;
		}
		else
		{
			// No hardware pressure — derive from pointer velocity (faster = thinner)
			const tmpNow = Date.now();
			const tmpDt = tmpNow - this._lastTime;
			this._lastTime = tmpNow;

			if (tmpDt > 0)
			{
				const tmpDx = tmpPos.x - this._lastX;
				const tmpDy = tmpPos.y - this._lastY;
				const tmpDist = Math.sqrt(tmpDx * tmpDx + tmpDy * tmpDy);
				const tmpVelocity = tmpDist / tmpDt; // px per ms

				// Map velocity to width: slow strokes are thick, fast strokes are thin
				const tmpVelocityFactor = Math.min(tmpVelocity / 1.5, 1);
				tmpTargetWidth = tmpMaxWidth - (tmpMaxWidth - tmpMinWidth) * tmpVelocityFactor;
			}
		}

		// Smooth the width transition to avoid sudden jumps between segments
		this._currentWidth += (tmpTargetWidth - this._currentWidth) * 0.3;
		this._ctx.lineWidth = this._currentWidth;

		// ── Bézier midpoint smoothing ────────────────────────────────
		// Calculate the midpoint between the previous position and the current position
		const tmpMidX = (this._lastX + tmpPos.x) / 2;
		const tmpMidY = (this._lastY + tmpPos.y) / 2;

		// Draw a quadratic Bézier curve from the current path position to the midpoint,
		// using the previous position as the control point. This produces smooth C1-continuous
		// curves that join seamlessly at each midpoint.
		this._ctx.strokeStyle = this._inkColor;
		this._ctx.quadraticCurveTo(this._lastX, this._lastY, tmpMidX, tmpMidY);
		this._ctx.stroke();

		// Continue the path from the midpoint so the next segment connects smoothly
		this._ctx.beginPath();
		this._ctx.moveTo(tmpMidX, tmpMidY);

		this._lastX = tmpPos.x;
		this._lastY = tmpPos.y;
	}

	/**
	 * @param {PointerEvent} pEvent - The pointer event for pointerup or pointerleave
	 */
	onPointerUp(pEvent)
	{
		if (!this._isDrawing || !this._ctx) return;
		// Draw a final segment to the last known position so the stroke tip isn't clipped
		this._ctx.lineTo(this._lastX, this._lastY);
		this._ctx.stroke();
		this._isDrawing = false;
		this.pushUndoState();
	}

	/**
	 * Calculates the position relative to the canvas element.
	 * @param {PointerEvent} pEvent - The pointer event containing clientX and clientY
	 * @returns {{ x: number, y: number }}
	 */
	getCanvasPosition(pEvent)
	{
		if (!this._canvas) return { x: 0, y: 0 };
		const tmpRect = this._canvas.getBoundingClientRect();
		return {
			x: pEvent.clientX - tmpRect.left,
			y: pEvent.clientY - tmpRect.top,
		};
	}

	// ── Undo / Redo / Clear ──────────────────────────────────────────

	pushUndoState()
	{
		if (!this._canvas) return;
		this._undoStack.push(this._canvas.toDataURL('image/png'));
		// New action clears the redo stack
		this._redoStack = [];
	}

	handleUndo()
	{
		if (!this._canvas || this._undoStack.length <= 1) return;
		// Move the current state to the redo stack
		const tmpCurrent = this._undoStack.pop();
		if (tmpCurrent) this._redoStack.push(tmpCurrent);
		// Restore the previous state
		const tmpPrevious = this._undoStack[this._undoStack.length - 1];
		if (tmpPrevious) this.restoreCanvasFromDataURL(tmpPrevious);
	}

	handleRedo()
	{
		if (!this._canvas || this._redoStack.length < 1) return;
		const tmpState = this._redoStack.pop();
		if (!tmpState) return;
		this._undoStack.push(tmpState);
		this.restoreCanvasFromDataURL(tmpState);
	}

	handleClear()
	{
		if (!this._ctx || !this._canvas) return;
		this._ctx.fillStyle = '#ffffff';
		this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
		this._cleared = true;
		// Re-show the watermark overlay so the user sees the guides on the fresh canvas
		const tmpOverlay = document.getElementById('SignatureModal-WatermarkOverlay');
		if (tmpOverlay) tmpOverlay.style.display = '';
		this.pushUndoState();
	}

	/**
	 * Restores the canvas from a saved data URL.
	 * @param {string} pDataURL - The data URL to restore from
	 */
	restoreCanvasFromDataURL(pDataURL)
	{
		const tmpImage = new Image();
		tmpImage.onload = () =>
		{
			if (!this._ctx || !this._canvas) return;
			// Bypass the DPR scale transform to draw the snapshot pixel-for-pixel
			this._ctx.save();
			this._ctx.setTransform(1, 0, 0, 1, 0, 0);
			this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
			this._ctx.drawImage(tmpImage, 0, 0);
			this._ctx.restore();
		};
		tmpImage.src = pDataURL;
	}

	// ── Toolbar handlers ─────────────────────────────────────────────

	/**
	 * @param {string} pValue
	 */
	handleThicknessChange(pValue)
	{
		this._penThickness = parseInt(pValue, 10) || 2;
	}

	/**
	 * @param {string} pValue
	 */
	handleColorChange(pValue)
	{
		this._inkColor = pValue;
	}

	// ── Apply signature ──────────────────────────────────────────────

	/**
	 * Called when the user clicks "Apply" in the modal. Encodes the canvas to
	 * base64 PNG, writes it to the hidden input, and updates the preview image.
	 */
	applySignature()
	{
		if (!this._canvas || !this._ctx) return;

		// If the canvas was cleared, reset to pristine state
		if (this._cleared)
		{
			this.updateHiddenInputValue(this._activeInputHTMLID, '', this._activeIsTabular, this._activeRowIndex);
			this.updatePreviewImage(this._activeInputHTMLID, '', this._activeIsTabular, this._activeRowIndex);
			this.cleanupCanvasState();
			return;
		}

		// Use CSS-pixel dimensions for positioning (the DPR scale transform maps these to device pixels)
		const tmpDPR = window.devicePixelRatio || 1;
		const tmpW = this._canvas.width / tmpDPR;
		const tmpH = this._canvas.height / tmpDPR;

		// Draw signature line / watermark divider
		const tmpLineY = tmpH - 23;
		this._ctx.save();
		this._ctx.strokeStyle = 'rgba(180, 180, 180, 0.6)';
		this._ctx.lineWidth = 1;
		this._ctx.beginPath();
		this._ctx.moveTo(8, tmpLineY);
		this._ctx.lineTo(tmpW - 8, tmpLineY);
		this._ctx.stroke();
		this._ctx.restore();

		// Stamp identity and timestamp onto the canvas
		const tmpUser = this.pict.AppData?.CurrentUser;
		const tmpTitle = this._printTitle ? (tmpUser?.Title || '').trim() : '';
		const tmpPrintedName = this._printName ? ((tmpUser?.NameFirst || '') + ' ' + (tmpUser?.NameLast || '')).trim() : '';

		// Bottom-left: title (bold) + bullet + name
		const tmpIdentityParts = [];
		if (tmpTitle) tmpIdentityParts.push({ text: tmpTitle, bold: true });
		if (tmpPrintedName) tmpIdentityParts.push({ text: tmpPrintedName, bold: false });

		if (tmpIdentityParts.length > 0)
		{
			this._ctx.save();
			this._ctx.fillStyle = 'rgba(80, 80, 80, 0.7)';
			this._ctx.textAlign = 'left';
			this._ctx.textBaseline = 'bottom';

			let tmpX = 8;
			const tmpY = tmpH - 6;

			for (let i = 0; i < tmpIdentityParts.length; i++)
			{
				if (i > 0)
				{
					// Draw bullet divider between parts
					this._ctx.font = '11px sans-serif';
					this._ctx.fillText(' \u2022 ', tmpX, tmpY);
					tmpX += this._ctx.measureText(' \u2022 ').width;
				}
				this._ctx.font = tmpIdentityParts[i].bold ? 'bold 11px sans-serif' : '11px sans-serif';
				this._ctx.fillText(tmpIdentityParts[i].text, tmpX, tmpY);
				tmpX += this._ctx.measureText(tmpIdentityParts[i].text).width;
			}

			this._ctx.restore();
		}

		// Bottom-right: timestamp of signing
		const tmpTimestamp = this._printDate ? this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone('now', this._dateFormat, this._timezone) : '';
		if (tmpTimestamp)
		{
			this._ctx.save();
			this._ctx.font = '11px sans-serif';
			this._ctx.fillStyle = 'rgba(80, 80, 80, 0.7)';
			this._ctx.textAlign = 'right';
			this._ctx.textBaseline = 'bottom';
			this._ctx.fillText(tmpTimestamp, tmpW - 8, tmpH - 6);
			this._ctx.restore();
		}

		// Get the raw base64 data (strip the data URI prefix for storage)
		const tmpDataURL = this._canvas.toDataURL('image/png');
		const tmpBase64 = tmpDataURL.replace(/^data:image\/png;base64,/, '');
		// Write to hidden input
		this.updateHiddenInputValue(this._activeInputHTMLID, tmpBase64, this._activeIsTabular, this._activeRowIndex);
		// Update the preview image
		this.updatePreviewImage(this._activeInputHTMLID, tmpBase64, this._activeIsTabular, this._activeRowIndex);

		this.cleanupCanvasState();
	}

	/**
	 * Resets internal canvas/modal state after the modal closes.
	 */
	cleanupCanvasState()
	{
		if (this._canvas)
		{
			if (this._boundPointerDown) this._canvas.removeEventListener('pointerdown', this._boundPointerDown);
			if (this._boundPointerMove) this._canvas.removeEventListener('pointermove', this._boundPointerMove);
			if (this._boundPointerUp)
			{
				this._canvas.removeEventListener('pointerup', this._boundPointerUp);
				this._canvas.removeEventListener('pointerleave', this._boundPointerUp);
			}
		}

		this._canvas = null;
		this._ctx = null;
		this._isDrawing = false;
		this._cleared = false;
		this._undoStack = [];
		this._redoStack = [];
		this._activeInputHTMLID = '';
		this._activeInputHash = '';
		this._activeIsTabular = false;
		this._activeRowIndex = null;
	}

	// ── Standard lifecycle hooks ─────────────────────────────────────

	/**
	 * Handles displaying the signature value (or placeholder) when the form loads.
	 * @param {any} pInput - The input descriptor object
	 * @param {string} pValue - base64 encoded PNG value
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {number|string|null} [pRowIndex] - The row index if this is a tabular input
	 * @returns {void}
	 */
	handleInputValue(pInput, pValue, isTabular = false, pRowIndex = null)
	{
		this.updatePreviewImage(pInput.Macro.RawHTMLID, pValue, isTabular, pRowIndex);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pRow - The row object containing the input (if applicable)
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue 	- The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pRowIndex - The row index if this input is within a tabular section
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pRow - The row object containing the input (if applicable)
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		this.injectCustomCSS();
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pRowIndex - The row index if this input is within a tabular section
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		this.injectCustomCSS();
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(pInput.Macro.RawHTMLID);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpValue, pHTMLSelector);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {number} pRowIndex - The row index if this input is within a tabular section
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = SignatureInputHandler;

},{"pict-section-form":497}],117:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class StationInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightStationing: import('../../../../service/headlight-stationing-service/types/Headlight-Stationing') }} */
		this.fable;
		/** @type {Pict} */
		this.pict;
	}

	getStationHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getStationDisplayInputHTMLID(pInputHTMLID)
	{
		return `#STATION-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularStationHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularStationDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#STATION-TABULAR-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getValueRepresentations(pValue)
	{
		let tmpNumericValue;
		let tmpContent;
		if (isNaN(pValue))
		{
			tmpContent = pValue;
			tmpNumericValue = this.fable.HeadlightStationing.fromStationValue(pValue);
		}
		else
		{
			tmpNumericValue = pValue;
			tmpContent = this.fable.HeadlightStationing.toStationValue(tmpNumericValue);
		}
		return [ tmpNumericValue, tmpContent ];
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pValue)
		{
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(pValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		this.pict.ContentAssignment.assignContent(this.getStationDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getStationHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpNumericValue);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpNumericValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the input in the row columns.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pValue)
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(pValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpNumericValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		this.pict.ContentAssignment.assignContent(this.getTabularStationDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getTabularStationHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpNumericValue);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpNumericValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(this.getStationDisplayInputHTMLID(pInput.Macro.RawHTMLID));
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(tmpValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataRequest(pView, pInput, tmpValue, pHTMLSelector);
		}
		this.pict.ContentAssignment.assignContent(this.getStationDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getStationHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpNumericValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(this.getTabularStationDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(tmpValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataRequestTabular(pView, pInput, tmpValue, pHTMLSelector, pRowIndex);
		}
		this.pict.ContentAssignment.assignContent(this.getTabularStationDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getTabularStationHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpNumericValue);

		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = StationInputHandler;

},{"pict-section-form":497}],118:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @type {typeof import('pict-section-form').PictInputExtensionProvider} */
const PictSectionInputExtension_TabGroupSelector = require('pict-section-form/source/providers/inputs/Pict-Provider-Input-TabGroupSelector.js');

const libTabPrintHostCSS = require('./_TabPrintHostCSS.js');

class TabGroupSelectorInputHandler extends PictSectionInputExtension_TabGroupSelector
{
	/**
	 * @param {Object} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * Last tab the user actually selected, keyed `<viewHash>::<inputHash>`.
		 *
		 * WHY THIS EXISTS: the base provider restores the active tab purely from the
		 * input's DATA value, so ANY path that blanks it drops the user back to the
		 * default tab. On the LADOTD Sample Creation form that surfaced as "every time
		 * I manually add a test it switches tabs back" -- adding a test fires an
		 * AutofillTriggerGroup whose PostSolvers re-render the section, and the tab
		 * would snap to `DefaultTabGroupHash` mid-edit. It also took the select2
		 * dropdown down with it (the widget's element is detached by the re-render,
		 * so a subsequent open threw "Cannot read properties of null (reading 'query')").
		 *
		 * Deliberately in-memory only: this is UI position, not form data. It is NOT a
		 * replacement for the stored value -- selectTabByViewHash still writes that, so
		 * the tab survives a genuine reload. This only wins when the two disagree,
		 * which is exactly the re-render case.
		 *
		 * @type {Object<string, string>}
		 */
		this.SelectedTabByInput = {};

		// Shared with TabSectionSelector -- see _TabPrintHostCSS.js for why this registers here and
		// injects at init rather than doing both in the constructor.
		libTabPrintHostCSS.registerPrintHostCSS(this.pict);
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @return {string}
	 */
	getSelectedTabKey(pViewHash, pInputHash)
	{
		return `${pViewHash}::${pInputHash}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		// Before the print early-return on purpose: the print-host rule is exactly what the PDF needs.
		libTabPrintHostCSS.injectPrintHostCSS(this.pict);

		if (!this.pict.AppData.Interactive && pInput.PictForm?.Exclusive !== true)
		{
			// show all tabs in print mode unless Exclusive is set to true
			return;
		}

		// Prefer the tab the user last picked over whatever is in the data value, so a
		// re-render mid-edit cannot yank them back to the default tab. Fed in as pValue
		// so the base provider's precedence (DefaultFromData -> DefaultTabGroupHash ->
		// first tab) is untouched; it also re-writes the value, repairing the data.
		// Honours an explicit `DefaultFromData: false`, which means "always start on the
		// configured default" and is nobody's idea of a remembered tab.
		let tmpValue = pValue;
		if (pInput?.PictForm?.DefaultFromData !== false)
		{
			const tmpRemembered = this.SelectedTabByInput[this.getSelectedTabKey(pView?.Hash, pInput?.Hash)];
			// Only if it is still a real member of this input's tab set -- the manifest
			// can change under a long-lived page.
			if (tmpRemembered && Array.isArray(pInput?.PictForm?.TabGroupSet) && pInput.PictForm.TabGroupSet.includes(tmpRemembered))
			{
				tmpValue = tmpRemembered;
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpValue, pHTMLTabSelector, pTransactionGUID);
	}

	/**
	 * Tier-3 (Half A) a11y: after the base provider swaps the visible tab/group
	 * via CSS classes, mirror the same state into ARIA so assistive tech
	 * announces the tabs as a real tablist. We deliberately do NOT add roving
	 * tabindex or arrow-key navigation (Half B) — every tab stays natively
	 * Tab-focusable, which is already WCAG 2.x keyboard-operable.
	 *
	 * `role="tablist"`/`role="tab"`/`role="presentation"` are emitted statically
	 * by templates/InputType-TabGroupSelector.js; only the stateful bits
	 * (aria-selected) and the cross-element relationships (tab <-> group panel,
	 * whose id carries the runtime view formID) are set here. Idempotent: runs
	 * once on init and again on every tab switch.
	 *
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabHash
	 *
	 * @return {boolean}
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabHash)
	{
		const tmpResult = super.selectTabByViewHash(pViewHash, pInputHash, pTabHash);
		if (tmpResult === false)
		{
			return tmpResult;
		}

		// Remember the selection so a later re-render restores it (see the constructor).
		this.SelectedTabByInput[this.getSelectedTabKey(pViewHash, pInputHash)] = pTabHash;

		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView ? tmpView.getInputFromHash(pInputHash) : null;
		if (!tmpInput || !Array.isArray(tmpInput?.PictForm?.TabGroupSet))
		{
			return tmpResult;
		}

		for (let i = 0; i < tmpInput.PictForm.TabGroupSet.length; i++)
		{
			const tmpTabGroupHash = tmpInput.PictForm.TabGroupSet[i];
			const tmpTabID = `TAB-${tmpTabGroupHash}-${tmpInput.Macro.RawHTMLID}`;
			const tmpTabSelector = `#${tmpTabID} a`;
			const tmpPanelSelector = this.getGroupSelector(tmpView, tmpTabGroupHash);
			const tmpIsActive = (tmpTabGroupHash === pTabHash);

			// State: the active tab is the selected one.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-selected', tmpIsActive ? 'true' : 'false');
			// Relationship: tab controls its group panel; panel is a tabpanel labelled by its tab.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-controls', tmpPanelSelector.replace(/^#/, ''));
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'role', 'tabpanel');
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'aria-labelledby', tmpTabID);
		}

		return tmpResult;
	}
}

module.exports = TabGroupSelectorInputHandler;

},{"./_TabPrintHostCSS.js":142,"pict-section-form/source/providers/inputs/Pict-Provider-Input-TabGroupSelector.js":532}],119:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @type {typeof import('pict-section-form').PictInputExtensionProvider} */
const PictSectionInputExtension_TabSectionSelector = require('pict-section-form/source/providers/inputs/Pict-Provider-Input-TabSectionSelector.js');

const libTabPrintHostCSS = require('./_TabPrintHostCSS.js');

class TabSectionSelectorInputHandler extends PictSectionInputExtension_TabSectionSelector
{
	/**
	 * @param {Object} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Shared with TabGroupSelector -- see _TabPrintHostCSS.js for why this registers here and
		// injects at init rather than doing both in the constructor.
		libTabPrintHostCSS.registerPrintHostCSS(this.pict);
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		// Before the print early-return on purpose: the print-host rule is exactly what the PDF needs.
		libTabPrintHostCSS.injectPrintHostCSS(this.pict);

		if (!this.pict.AppData.Interactive && pInput.PictForm?.Exclusive !== true)
		{
			// show all tabs in print mode unless Exclusive is set to true
			return;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}

	/**
	 * Tier-3 (Half A) a11y: after the base provider swaps the visible tab/panel
	 * via CSS classes, mirror the same state into ARIA so assistive tech
	 * announces the tabs as a real tablist. We deliberately do NOT add roving
	 * tabindex or arrow-key navigation (Half B) — every tab stays natively
	 * Tab-focusable, which is already WCAG 2.x keyboard-operable.
	 *
	 * `role="tablist"`/`role="tab"`/`role="presentation"` are emitted statically
	 * by templates/InputType-TabSectionSelector.js; only the stateful bits
	 * (aria-selected) and the cross-element relationships (tab <-> panel, whose
	 * panel id carries the runtime metacontroller UUID) are set here. Idempotent:
	 * runs once on init and again on every tab switch.
	 *
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabViewHash
	 *
	 * @return {boolean}
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabViewHash)
	{
		const tmpResult = super.selectTabByViewHash(pViewHash, pInputHash, pTabViewHash);
		if (tmpResult === false)
		{
			return tmpResult;
		}

		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView ? tmpView.getInputFromHash(pInputHash) : null;
		if (!tmpInput || !Array.isArray(tmpInput?.PictForm?.TabSectionSet))
		{
			return tmpResult;
		}

		for (let i = 0; i < tmpInput.PictForm.TabSectionSet.length; i++)
		{
			const tmpTabSectionHash = tmpInput.PictForm.TabSectionSet[i];
			const tmpTabID = `TAB-${tmpTabSectionHash}-${tmpInput.Macro.RawHTMLID}`;
			const tmpTabSelector = `#${tmpTabID} a`;
			const tmpPanelSelector = this.getSectionSelector(tmpTabSectionHash);
			const tmpIsActive = (tmpTabSectionHash === pTabViewHash);

			// State: the active tab is the selected one.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-selected', tmpIsActive ? 'true' : 'false');
			// Relationship: tab controls its panel; panel is a tabpanel labelled by its tab.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-controls', tmpPanelSelector.replace(/^#/, ''));
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'role', 'tabpanel');
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'aria-labelledby', tmpTabID);
		}

		return tmpResult;
	}
}

module.exports = TabSectionSelectorInputHandler;

},{"./_TabPrintHostCSS.js":142,"pict-section-form/source/providers/inputs/Pict-Provider-Input-TabSectionSelector.js":533}],120:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Updates the rows attribute of the textarea based on the content.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be used for calculating rows.
	 * @param {number} [pRowIndex] - Row index when the textarea is a tabular cell; omit for standard inputs.
	 */
	updateTextAreaRows(pView, pInput, pValue, pRowIndex)
	{
		// Tabular textareas render with a per-row id suffix ("{RawHTMLID}-{rowIndex}",
		// per the InputType-TextArea tabular template); standard inputs use the bare
		// RawHTMLID. Match the suffix here or the lookup misses every tabular cell.
		const tmpHTMLID = (pRowIndex != null) ? `${pInput.Macro.RawHTMLID}-${pRowIndex}` : pInput.Macro.RawHTMLID;
		const textarea = document.getElementById(tmpHTMLID);
		if (!textarea)
		{
			// Expected during early render: a marshal can fire before a section's
			// (or row's) textarea DOM exists yet. Auto-grow re-applies on the next
			// marshal once it's present, so this is a benign skip — trace, not error.
			this.pict.log.trace(`[TextAreaProvider] Textarea [${tmpHTMLID}] not in DOM yet; skipping auto-grow.`);
			return;
		}
		const scrollHeight = textarea.scrollHeight;
		const minHeight = 50; // Minimum height in pixels (about 2 rows)
		const maxHeight = 300; // Maximum height in pixels (about 12 rows)
		const newHeight = Math.max(minHeight, Math.min(scrollHeight, maxHeight));
		textarea.setAttribute('style', `height: ${newHeight}px;`);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.updateTextAreaRows(pView, pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.updateTextAreaRows(pView, pInput, pValue, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],121:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * Class names used by the validation UI. Centralized so the consolidated
 * styling helper can target the right classes in one place.
 *
 * @readonly
 */
const VALIDATION_CLASSES = Object.freeze({
	DANGER: 'is-danger',
	SUCCESS: 'is-success',
	VALIDATION_TEXT: 'validation-text',
	HELP_DANGER_TEXT: 'has-text-danger',
});

/** Delay (ms) before fading the success state on always-active validation. */
const SUCCESS_FADE_DELAY_MS = 2500;

/**
 * CustomInputHandler — drives the UI side of input validation for any
 * dynamic input whose template wires this provider in via PictForm.
 *
 * Responsibilities:
 *   - Resolve which validation rules apply for an input from the manifest
 *     config (PictForm) and the live DOM element, and keep the element's
 *     HTML5 validation attributes (`required`, `aria-required`) in sync.
 *   - Apply / remove the success / danger styling on the control.
 *   - Inject a human-readable validation message into the help-text wrapper.
 *
 * Visibility gating:
 *   Hidden inputs (on inactive tabs, conditionally hidden by other selections,
 *   etc.) do NOT enforce validation. They get their `required` attribute
 *   cleared at runtime so the browser/framework's `checkValidity()` returns
 *   true, and any stale danger styling / validation-text is scrubbed off.
 *   "Hidden" here means CSS display:none / visibility:hidden on the element
 *   or any ancestor. Inputs scrolled below the viewport remain enforced.
 */
class CustomInputHandler extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Resolve the live HTMLInputElement for a given selector, or null if absent.
	 *
	 * @param {string} pHTMLSelector
	 * @return {HTMLInputElement|null}
	 */
	resolveInputElement(pHTMLSelector)
	{
		const tmpInputList = this.pict.ContentAssignment.getElement(pHTMLSelector);
		return (tmpInputList && tmpInputList.length > 0) ? tmpInputList[0] : null;
	}

	/**
	 * Resolve the "real" styling target for validation UI.
	 *
	 * Pict-section-form passes the *canonical* (data-bearing) input
	 * selector to our lifecycle hooks — e.g. for Station/DateTime/Date/Time
	 * that's the hidden input that holds the form value, not the visible
	 * input the user actually types into. Native `checkValidity()` on a
	 * `type="hidden"` (or otherwise CSS-hidden) input is barred and
	 * returns true even when empty, so styling against the canonical
	 * silently no-ops.
	 *
	 * This resolver returns the canonical when it's already the visible
	 * required input; otherwise it walks up to the nearest scope
	 * (`.control.control-status` → `.field` → `.column` → parent) and
	 * returns the first visible `[required]` sibling there. Signature-style
	 * inputs (hidden-only, data-validation-surface) fall back to the
	 * canonical since there is no visible required sibling to find.
	 *
	 * @param {string} pHTMLSelector
	 * @return {HTMLInputElement|null}
	 */
	resolveStylingTargetInput(pHTMLSelector)
	{
		const tmpCanonical = this.resolveInputElement(pHTMLSelector);
		if (!tmpCanonical)
		{
			return null;
		}
		// If the canonical isn't a hidden data-bearer, use it directly.
		if (!this._isHiddenDataBearer(tmpCanonical))
		{
			return tmpCanonical;
		}
		// Hidden data-bearer: walk outward looking for a visible required
		// sibling. The scope priority (control → field → column → parent)
		// matches the typical InputType template layering — most data
		// bearers live next to their visible sibling inside the same
		// control wrapper, but Station-style templates keep the hidden
		// bearer at the column level.
		if (typeof tmpCanonical.closest !== 'function')
		{
			return tmpCanonical;
		}
		const tmpScopes = [
			tmpCanonical.closest('.control.control-status'),
			tmpCanonical.closest('.field'),
			tmpCanonical.closest('.column'),
			tmpCanonical.parentElement,
		];
		const tmpSelector = 'input[required]:not([type="hidden"]):not(.is-hidden), select[required], textarea[required]';
		for (let i = 0; i < tmpScopes.length; i++)
		{
			const tmpScope = tmpScopes[i];
			if (!tmpScope || typeof tmpScope.querySelector !== 'function')
			{
				continue;
			}
			const tmpVisible = /** @type {HTMLInputElement|null} */ (tmpScope.querySelector(tmpSelector));
			if (tmpVisible && tmpVisible !== tmpCanonical)
			{
				return tmpVisible;
			}
		}
		return tmpCanonical;
	}

	/**
	 * True when the element is currently rendered to the user (i.e. not
	 * `display:none` / `visibility:hidden` on itself or any ancestor, and
	 * still attached to the DOM). Elements below the viewport count as visible.
	 *
	 * Note: this walks ancestors via getComputedStyle, which is the most
	 * robust check across tab containers, conditionally-rendered wrappers,
	 * and Bulma `is-hidden` style toggles.
	 *
	 * @param {Element|null|undefined} pElement
	 * @return {boolean}
	 */
	isInputVisibleToUser(pElement)
	{
		if (!pElement || pElement.nodeType !== 1)
		{
			return false;
		}
		if (!pElement.isConnected)
		{
			return false;
		}
		// Validation-surface indirection: an input may declare an alternate
		// user-visible element that represents it on screen (e.g. Signature
		// puts `required` on a CSS-hidden <input> while the actual visible
		// surface is a sibling <img>/<button>). When `data-validation-surface`
		// is set, check that element's visibility instead.
		const tmpSurfaceID = (pElement.getAttribute && pElement.getAttribute('data-validation-surface')) || null;
		if (tmpSurfaceID)
		{
			const tmpSurface = document.getElementById(tmpSurfaceID);
			if (tmpSurface)
			{
				return this._walkAncestorVisibility(tmpSurface);
			}
		}
		// Select2 indirection: when Select2 takes over a native <select>, it
		// hides the underlying element (aria-hidden="true", positioned
		// off-screen, class="select2-hidden-accessible") and renders its own
		// visible widget as a `.select2-container` sibling. The native select
		// is logically present and "visible to the user" — just via the
		// container surface. Without this, Pass 3 of applyFormSubmissionStyling
		// short-circuits on every Select2-managed required <select> and
		// never flags empty ones as invalid.
		if (pElement.tagName === 'SELECT' && pElement.classList && pElement.classList.contains('select2-hidden-accessible'))
		{
			const tmpContainer = this._findSelect2ContainerFor(/** @type {HTMLSelectElement} */ (pElement));
			if (tmpContainer)
			{
				return this._walkAncestorVisibility(tmpContainer);
			}
		}
		return this._walkAncestorVisibility(pElement);
	}

	/**
	 * Locate the `.select2-container` widget that Select2 injected for a
	 * given native `<select>`. Select2 normally places it as the immediate
	 * next sibling, but defensive code walks both the sibling chain and the
	 * parent's children to handle layouts that wrap the container.
	 *
	 * @param {HTMLSelectElement} pSelect
	 * @return {Element|null}
	 * @private
	 */
	_findSelect2ContainerFor(pSelect)
	{
		if (!pSelect || pSelect.nodeType !== 1)
		{
			return null;
		}
		let tmpSibling = pSelect.nextElementSibling;
		while (tmpSibling)
		{
			if (tmpSibling.classList && tmpSibling.classList.contains('select2-container'))
			{
				return tmpSibling;
			}
			tmpSibling = tmpSibling.nextElementSibling;
		}
		if (pSelect.parentElement && typeof pSelect.parentElement.querySelector === 'function')
		{
			return pSelect.parentElement.querySelector('.select2-container');
		}
		return null;
	}

	/**
	 * Internal: walk the ancestor chain checking for display:none,
	 * visibility:hidden/collapse, and aria-hidden="true". Returns false if
	 * any ancestor (or the element itself) is hidden by any of those.
	 *
	 * @param {Element} pElement
	 * @return {boolean}
	 * @private
	 */
	_walkAncestorVisibility(pElement)
	{
		let tmpCurrent = /** @type {Element|null} */ (pElement);
		while (tmpCurrent && tmpCurrent.nodeType === 1)
		{
			const tmpStyle = (typeof window !== 'undefined' && window.getComputedStyle) ? window.getComputedStyle(tmpCurrent) : null;
			if (tmpStyle)
			{
				if (tmpStyle.display === 'none')
				{
					return false;
				}
				if (tmpStyle.visibility === 'hidden' || tmpStyle.visibility === 'collapse')
				{
					return false;
				}
			}
			if (tmpCurrent.getAttribute && tmpCurrent.getAttribute('aria-hidden') === 'true')
			{
				return false;
			}
			if (tmpCurrent === document.body)
			{
				break;
			}
			tmpCurrent = tmpCurrent.parentElement;
		}
		return true;
	}

	/**
	 * Sync `required` and `aria-required` on a live DOM element so that the
	 * browser's native validity check (and any framework that consults it)
	 * matches what the user can actually see and interact with.
	 *
	 * @param {HTMLInputElement|null} pElement
	 * @param {boolean} pShouldBeRequired
	 * @return {void}
	 */
	syncRequiredAttributes(pElement, pShouldBeRequired)
	{
		if (!pElement)
		{
			return;
		}
		if (pShouldBeRequired)
		{
			if (!pElement.required)
			{
				pElement.required = true;
			}
			if (pElement.getAttribute('aria-required') !== 'true')
			{
				pElement.setAttribute('aria-required', 'true');
			}
			// Stamp the persistent marker so the pre-submit sweep can find
			// this field even after a future visibility-driven strip flips
			// `required` and `aria-required` back off.
			if (pElement.getAttribute('data-required') !== 'true')
			{
				pElement.setAttribute('data-required', 'true');
			}
		}
		else
		{
			if (pElement.required)
			{
				pElement.required = false;
			}
			if (pElement.hasAttribute('aria-required'))
			{
				pElement.removeAttribute('aria-required');
			}
			// data-required is intentionally NOT removed here — it persists
			// across visibility flips. The only place it should be cleared
			// is when the manifest itself no longer marks the field
			// required, which happens in setValidationInputAttributes when
			// PictForm explicitly says Required: false.
		}
	}

	/**
	 * Walk every "manifest says this is required" input within a form
	 * element and resync its live HTML5 / ARIA required attributes against
	 * current visibility. Strips `required` / `aria-required` /
	 * `aria-invalid` from hidden fields so the browser's checkValidity()
	 * (or any `:invalid` selector consumer) doesn't flag them, and
	 * restores `required` / `aria-required` on visible fields that may
	 * have had them stripped during an earlier hidden state.
	 *
	 * Call this immediately before `formElement.checkValidity()` or a
	 * `:invalid` query in any form-submission flow.
	 *
	 * @param {HTMLElement|null} pFormElement
	 * @return {void}
	 */
	preSubmitVisibilitySweep(pFormElement)
	{
		if (!pFormElement || typeof pFormElement.querySelectorAll !== 'function')
		{
			return;
		}
		// We query data-required (the persistent manifest marker) instead
		// of `[required]` because hidden fields may have already had their
		// `required` attribute stripped — we still need to find them to
		// decide whether to restore.
		const tmpManagedInputs = pFormElement.querySelectorAll('[data-required="true"]');
		for (let i = 0; i < tmpManagedInputs.length; i++)
		{
			const tmpInput = /** @type {HTMLInputElement} */ (tmpManagedInputs[i]);
			const tmpIsVisible = this.isInputVisibleToUser(tmpInput);
			this.syncRequiredAttributes(tmpInput, tmpIsVisible);
			if (!tmpIsVisible)
			{
				// A previously-shown error on a now-hidden field is stale —
				// clear aria-invalid + any leftover is-danger styling so it
				// doesn't lie to AT or paint a tab the user can't see.
				this.syncAriaInvalidAttribute(tmpInput, false);
				const tmpControl = this.resolveControlElement(tmpInput);
				this.clearValidationStyling(tmpControl);
				this.clearValidationHelpText(tmpControl);
			}
		}
	}

	/**
	 * Apply validation styling across an entire form after a submission
	 * attempt. Centralizes everything the validation UI needs to do:
	 *
	 *   - Walk `:invalid` inputs and stamp `is-danger` on the closest
	 *     `.control.control-status` wrapper (uses closest() so flatpickr or
	 *     other providers that wrap the input still find the right
	 *     ancestor).
	 *   - Walk `:valid` inputs and clear validity classes from the same
	 *     wrapper.
	 *   - Mirror the class onto any `.select2-container` sibling within the
	 *     wrapper — Bulma's `.is-danger` styling targets the native
	 *     `.input` / `.select` and doesn't reach Select2's replacement widget.
	 *   - Value-check any `[data-required="true"]` inputs that are CSS-
	 *     hidden or `type="hidden"` (e.g. Signature, which puts `required`
	 *     on a data-bearing input behind an `<img>` surface). Native
	 *     `:invalid` doesn't apply to these so we have to inspect `.value`
	 *     directly.
	 *   - Keep `aria-invalid` in sync on all affected inputs.
	 *
	 * Call this *after* `preSubmitVisibilitySweep()` (which has already
	 * stripped `required` from hidden fields so they don't get flagged).
	 *
	 * Returns true when every visible field passes validation (native +
	 * data-required hidden-bearer checks), so callers can use the return
	 * value as the gate decision and don't need to re-scan the form.
	 *
	 * @param {HTMLElement|null} pFormElement
	 * @return {boolean} true if form passes all visible validations.
	 */
	applyFormSubmissionStyling(pFormElement)
	{
		if (!pFormElement || typeof pFormElement.querySelectorAll !== 'function')
		{
			return true;
		}

		// Wire up the form-level live revalidation listener so subsequent
		// user edits to any input promote a previously-red wrapper to green
		// (or back to red if the user clears a required field) without
		// waiting for another submit. Idempotent — only attaches once.
		this.attachLiveRevalidation(pFormElement);

		let tmpFormIsValid = true;

		// Pass 1: anything failing native HTML5 validation. Catches required
		// fields that are empty, pattern/email/min/max mismatches, etc.
		const tmpInvalidElements = pFormElement.querySelectorAll(':invalid');
		for (let i = 0; i < tmpInvalidElements.length; i++)
		{
			this._applyValidityToWrapperAndKin(/** @type {HTMLElement} */ (tmpInvalidElements[i]), false);
			tmpFormIsValid = false;
		}

		// Pass 2: clear styling from anything that's now valid. Has to run
		// unconditionally so previously-flagged fields go back to green.
		const tmpValidElements = pFormElement.querySelectorAll(':valid');
		for (let i = 0; i < tmpValidElements.length; i++)
		{
			this._applyValidityToWrapperAndKin(/** @type {HTMLElement} */ (tmpValidElements[i]), true);
		}

		// Pass 3: walk every manifest-required input authoritatively. This
		// is the most reliable layer of the three because it doesn't rely
		// on `:valid` / `:invalid` — which silently skip
		//   - `type="hidden"` (always barred)
		//   - `readonly` inputs (flatpickr makes its bound input readonly
		//     by default, so Date/Time/DateTime never match either pseudo)
		//   - inputs with `disabled` (also barred)
		// We inspect `.value` (or `.checked` for checkboxes) directly and
		// apply styling to the right wrapper. Runs last so it overrides
		// any (mis)styling from Pass 1/2 for these fields.
		const tmpDataRequired = pFormElement.querySelectorAll('[data-required="true"]');
		for (let i = 0; i < tmpDataRequired.length; i++)
		{
			const tmpInput = /** @type {HTMLInputElement} */ (tmpDataRequired[i]);
			const tmpIsHiddenBearer = this._isHiddenDataBearer(tmpInput);

			// Visibility gate. For hidden bearers, use the surface/wrapper
			// indirection (the input itself is always CSS-hidden). For
			// visible inputs, check the input directly.
			let tmpIsVisible;
			if (tmpIsHiddenBearer)
			{
				const tmpVisibilityTarget = this._resolveVisibilityTargetForHiddenBearer(tmpInput);
				tmpIsVisible = tmpVisibilityTarget ? this._walkAncestorVisibility(tmpVisibilityTarget) : true;
			}
			else
			{
				tmpIsVisible = this.isInputVisibleToUser(tmpInput);
			}

			if (!tmpIsVisible)
			{
				// Field is on an inactive tab / conditionally hidden — scrub
				// any leftover styling, don't block submit, don't flag.
				const tmpControl = this.resolveControlElement(tmpInput);
				this.clearValidationStyling(tmpControl);
				this.clearValidationHelpText(tmpControl);
				this.syncAriaInvalidAttribute(tmpInput, false);
				continue;
			}

			// Determine "logical validity" — for checkboxes, "checked";
			// otherwise a non-empty, non-sentinel value.
			const tmpHasValue = this._hasRequiredValue(tmpInput);
			// Pass 3 is the authoritative required-field walk. Unlike
			// Pass 1/2 (which walk every :valid element including optional
			// fields), this pass only touches inputs the manifest marked as
			// required — so a non-empty value here unambiguously means
			// "requirement satisfied" and should paint green regardless of
			// prior state. Override the default "only mark success if was
			// danger" gate.
			this._applyValidityToWrapperAndKin(tmpInput, tmpHasValue, { onlyMarkSuccessIfWasDanger: false });
			if (!tmpHasValue)
			{
				tmpFormIsValid = false;
			}
		}

		return tmpFormIsValid;
	}

	/**
	 * Re-apply validity styling for a single input element using DOM state
	 * alone. Used by the form-level live revalidation listener so that the
	 * moment a user corrects a previously-flagged field, the wrapper
	 * promotes from `is-danger` back to `is-success` — without waiting for
	 * another Submit click. The "you fixed it" semantics also mean that
	 * clearing a required field that had passed before flips back to
	 * `is-danger` immediately.
	 *
	 * Validity is read from the DOM:
	 *   - Checkbox + required → `checked`
	 *   - Manifest-required (`data-required="true"`) with no native `required`
	 *     attribute on the DOM element (Select2-managed `<select>`), or a
	 *     hidden data-bearer (Signature, Picker) → a non-empty `.value` that
	 *     isn't one of its `data-empty-values`
	 *   - Anything else → `element.checkValidity()`
	 *
	 * Inputs that are not currently visible to the user (inactive tab,
	 * conditionally hidden) have their styling scrubbed and don't get
	 * flagged — the styling shouldn't lie about a field the user can't
	 * see and can't act on.
	 *
	 * @param {Element|null} pElement
	 * @return {void}
	 */
	revalidateInputElement(pElement)
	{
		if (!pElement || pElement.nodeType !== 1)
		{
			return;
		}
		if (!this.pict || !this.pict.AppData || !this.pict.AppData.Interactive)
		{
			return;
		}

		// Translate hidden data-bearer inputs (e.g. Station's hidden bearer,
		// Signature's <input type="hidden">) to their visible required
		// sibling so styling lands on the user-facing field.
		const tmpResolved = (pElement.id && typeof this.resolveStylingTargetInput === 'function') ?
			this.resolveStylingTargetInput('#' + pElement.id) :
			null;
		const tmpTarget = tmpResolved || /** @type {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} */ (pElement);
		if (!tmpTarget || !tmpTarget.tagName)
		{
			return;
		}

		if (!this.isInputVisibleToUser(tmpTarget))
		{
			const tmpControl = this.resolveControlElement(tmpTarget);
			this.clearValidationStyling(tmpControl);
			this.clearValidationHelpText(tmpControl);
			this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (tmpTarget), false);
			return;
		}

		const tmpHasNativeRequired = tmpTarget.hasAttribute && tmpTarget.hasAttribute('required');
		const tmpHasDataRequired = tmpTarget.getAttribute && tmpTarget.getAttribute('data-required') === 'true';
		let tmpIsValid;
		if (tmpTarget.type === 'checkbox' && tmpTarget.required)
		{
			tmpIsValid = !!tmpTarget.checked;
		}
		else if (tmpHasDataRequired && (!tmpHasNativeRequired || this._isHiddenDataBearer(/** @type {HTMLInputElement} */ (tmpTarget))))
		{
			// Manifest-required but native validity can't judge it: the DOM
			// doesn't carry `required` (Select2-managed <select>), or it is a
			// hidden data-bearer, which constraint validation skips. Inspect
			// the value directly — that's the authoritative signal.
			tmpIsValid = this._hasRequiredValue(/** @type {HTMLInputElement} */ (tmpTarget));
		}
		else if (typeof tmpTarget.checkValidity === 'function')
		{
			tmpIsValid = tmpTarget.checkValidity();
		}
		else
		{
			tmpIsValid = true;
		}

		this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (tmpTarget), !tmpIsValid);
		// Use the default `onlyMarkSuccessIfWasDanger: true` semantics —
		// only promote to green when the wrapper had previously been red
		// ("you fixed it"). Pass 3 of the bulk submit uses unconditional
		// promotion via an explicit option, but for live edits we don't
		// want every keystroke on an unrelated valid field to suddenly
		// paint green out of nowhere.
		this._applyValidityToWrapperAndKin(/** @type {HTMLElement} */ (tmpTarget), tmpIsValid);

		// Mirror to addon sibling (e.g. unit pill on numeric inputs) so it
		// tracks the same color as the wrapper.
		const tmpControl = this.resolveControlElement(tmpTarget);
		if (tmpControl)
		{
			const tmpAddon = tmpControl.nextElementSibling;
			if (tmpAddon && tmpAddon.classList && tmpAddon.classList.contains('addon'))
			{
				this.applyValidityClasses(/** @type {HTMLElement} */ (tmpAddon), tmpIsValid, { onlyMarkSuccessIfWasDanger: true });
			}
		}
	}

	/**
	 * Attach a delegated input/change/blur listener at the form level so
	 * every input the user touches gets revalidated against the latest
	 * state. Idempotent — re-attaching on the same form is a no-op. The
	 * handler is gated on `form.show-validation` so we don't paint
	 * validation colors on initial page load; only after the first Submit
	 * attempt (which adds `show-validation`) does live feedback kick in.
	 *
	 * Uses a single delegated listener rather than per-input wiring so any
	 * input type — including those whose templates don't list
	 * InputValidation in `DefaultInputExtensions` — gets covered. Capture
	 * phase so it runs even when child providers stop propagation.
	 *
	 * @param {HTMLElement|null} pFormElement
	 * @return {void}
	 */
	attachLiveRevalidation(pFormElement)
	{
		if (!pFormElement || pFormElement.nodeType !== 1)
		{
			return;
		}
		if (pFormElement.dataset && pFormElement.dataset.inputValidationLiveAttached === 'true')
		{
			return;
		}
		if (pFormElement.dataset)
		{
			pFormElement.dataset.inputValidationLiveAttached = 'true';
		}

		const tmpProvider = this;
		const tmpHandler = function(pEvent)
		{
			if (!pFormElement.classList || !pFormElement.classList.contains('show-validation'))
			{
				return;
			}
			const tmpTarget = pEvent.target;
			if (!tmpTarget || !tmpTarget.tagName)
			{
				return;
			}
			if (tmpTarget.tagName !== 'INPUT' && tmpTarget.tagName !== 'SELECT' && tmpTarget.tagName !== 'TEXTAREA')
			{
				return;
			}
			tmpProvider.revalidateInputElement(tmpTarget);
		};

		// Capture phase so the listener fires even if a provider on a
		// child element calls stopPropagation. `blur` doesn't bubble so we
		// listen for it on capture too (or could use focusout; capture is
		// simpler and works cross-browser).
		pFormElement.addEventListener('input', tmpHandler, true);
		pFormElement.addEventListener('change', tmpHandler, true);
		pFormElement.addEventListener('blur', tmpHandler, true);

		// Also bind via jQuery when available. Select2 dispatches selection
		// changes via `$(select).trigger('change')`, which goes through
		// jQuery's own event bus and does NOT fire native addEventListener
		// listeners. Without this jQuery hook, picking a value in a Select2
		// dropdown wouldn't trigger live revalidation. Pict-Section-Form's
		// other providers similarly trigger via jQuery for some inputs.
		const tmpJQuery = (typeof window !== 'undefined' && (window.$ || window.jQuery)) || null;
		if (tmpJQuery)
		{
			tmpJQuery(pFormElement).on('input.inputValidationLive change.inputValidationLive blur.inputValidationLive', function(pEvent)
			{
				tmpHandler(pEvent);
			});
		}
	}

	/**
	 * For a hidden data-bearer input, return the element whose visibility
	 * actually represents "is this field on screen?" — preferring an
	 * explicit `data-validation-surface` pointer, falling back to the
	 * closest `.control.control-status` wrapper, finally the parent.
	 *
	 * @param {HTMLInputElement} pInput
	 * @return {Element|null}
	 * @private
	 */
	_resolveVisibilityTargetForHiddenBearer(pInput)
	{
		if (!pInput || pInput.nodeType !== 1)
		{
			return null;
		}
		const tmpSurfaceID = pInput.getAttribute && pInput.getAttribute('data-validation-surface');
		if (tmpSurfaceID)
		{
			const tmpSurface = document.getElementById(tmpSurfaceID);
			if (tmpSurface)
			{
				return tmpSurface;
			}
		}
		if (typeof pInput.closest === 'function')
		{
			const tmpControl = pInput.closest('.control.control-status');
			if (tmpControl)
			{
				return tmpControl;
			}
		}
		return pInput.parentElement;
	}

	/**
	 * Internal: apply or clear validity classes on the input's
	 * `.control.control-status` wrapper (via its validation surface for a
	 * hidden data-bearer), mirror onto any Select2 container sibling, and sync
	 * `aria-invalid` on the input itself and any combobox in the wrapper.
	 *
	 * Two semantic modes, controlled by `pOptions.onlyMarkSuccessIfWasDanger`:
	 *
	 *   - `true` (default) — submit-style "you fixed it" semantics. Only
	 *     promotes a wrapper to `is-success` when it had been flagged
	 *     `is-danger`. Used by Pass 1/2 of `applyFormSubmissionStyling`,
	 *     which walks every `:valid` element — including non-required
	 *     fields like an empty optional input that happens to match
	 *     `:valid`. Without this gate the form would get a "generic green
	 *     tick" on every passing field, which the test at "does NOT add
	 *     is-success when the input was not previously danger" guards
	 *     against and which matches the single-input submit-style behavior
	 *     in `handleValidationInputStyling`.
	 *
	 *   - `false` — unconditional promotion. Used by Pass 3 of
	 *     `applyFormSubmissionStyling`, which walks only
	 *     `[data-required="true"]` inputs. For an authoritatively-required
	 *     field, a non-empty value IS success and the user should see green
	 *     ("you've satisfied this requirement"), regardless of whether the
	 *     wrapper had ever been red. This is the form-wide "report card"
	 *     behavior on submit: required fields are explicitly green-or-red.
	 *
	 * @param {HTMLElement} pElement
	 * @param {boolean} pIsValid
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.onlyMarkSuccessIfWasDanger] - Defaults to true.
	 * @return {void}
	 * @private
	 */
	_applyValidityToWrapperAndKin(pElement, pIsValid, pOptions)
	{
		const tmpOptions = pOptions || { onlyMarkSuccessIfWasDanger: true };
		const tmpControl = this._findControlStatusWrapper(pElement);
		const tmpTarget = tmpControl || (pElement.classList && pElement.classList.contains('input') ? pElement : null);

		if (tmpTarget)
		{
			this.applyValidityClasses(/** @type {HTMLElement} */ (tmpTarget), pIsValid, tmpOptions);
		}

		// Select2 replaces the native <select> with its own container that
		// Bulma's class-based styling doesn't reach. Mirror the validity
		// class onto every Select2 container inside this control so the
		// user-visible widget reflects the state. Same promotion semantics
		// (option flag) apply to the mirror as to the control wrapper.
		if (tmpControl && typeof tmpControl.querySelectorAll === 'function')
		{
			const tmpSelect2Containers = tmpControl.querySelectorAll('.select2-container');
			for (let i = 0; i < tmpSelect2Containers.length; i++)
			{
				this.applyValidityClasses(/** @type {HTMLElement} */ (tmpSelect2Containers[i]), pIsValid, tmpOptions);
			}
			// A custom widget's focusable combobox is what assistive tech reads, not the input behind it.
			const tmpComboboxes = tmpControl.querySelectorAll('[role="combobox"]');
			for (let i = 0; i < tmpComboboxes.length; i++)
			{
				this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (tmpComboboxes[i]), !pIsValid);
			}
		}

		// Sync aria-invalid on the input itself when applicable.
		if (pElement.tagName === 'INPUT' || pElement.tagName === 'SELECT' || pElement.tagName === 'TEXTAREA')
		{
			this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (pElement), !pIsValid);
		}
	}

	/**
	 * True when an input is functionally hidden — either `type="hidden"` or
	 * its computed style is display:none — meaning native constraint
	 * validation (`:invalid`) won't apply to it and we have to inspect its
	 * value directly for required-ness.
	 *
	 * @param {HTMLInputElement} pElement
	 * @return {boolean}
	 * @private
	 */
	_isHiddenDataBearer(pElement)
	{
		if (!pElement || pElement.tagName !== 'INPUT')
		{
			return false;
		}
		if (pElement.type === 'hidden')
		{
			return true;
		}
		// Bulma's is-hidden class sets display:none. Other CSS-driven hides
		// (custom classes, inline style) are covered by the computed style
		// check.
		const tmpStyle = (typeof window !== 'undefined' && window.getComputedStyle) ?
			window.getComputedStyle(pElement) :
			null;
		if (tmpStyle && tmpStyle.display === 'none')
		{
			return true;
		}
		return false;
	}

	/**
	 * Sync `aria-invalid` on a live DOM element. Pass `true` to mark the
	 * input as invalid (announces "invalid entry" via screen readers), or
	 * `false` to clear the attribute entirely. We intentionally remove the
	 * attribute on valid state rather than setting aria-invalid="false" — the
	 * latter announces "valid" on every keystroke for live-validation
	 * inputs, which is noisy. ARIA's default semantic when the attribute is
	 * absent is "not yet validated / no judgment", which is what we want.
	 *
	 * @param {HTMLInputElement|null} pElement
	 * @param {boolean} pIsInvalid - true → mark invalid, false → clear.
	 * @return {void}
	 */
	syncAriaInvalidAttribute(pElement, pIsInvalid)
	{
		if (!pElement)
		{
			return;
		}
		if (pIsInvalid)
		{
			if (pElement.getAttribute('aria-invalid') !== 'true')
			{
				pElement.setAttribute('aria-invalid', 'true');
			}
		}
		else if (pElement.hasAttribute('aria-invalid'))
		{
			pElement.removeAttribute('aria-invalid');
		}
	}

	/**
	 * Programmatically pair an input to its help-text wrapper via
	 * `aria-describedby`. The wrapper holds both the Description text and
	 * any injected validation-text, so screen readers announce both as part
	 * of the input. Idempotent — safe to call repeatedly.
	 *
	 * Looks up the wrapper via the same parent-of-parent traversal we use
	 * for validation-text injection, so it stays consistent with the actual
	 * markup the templates emit.
	 *
	 * @param {HTMLInputElement|null} pInputElement
	 * @return {void}
	 */
	linkInputToHelpText(pInputElement)
	{
		if (!pInputElement || !pInputElement.id)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(pInputElement);
		if (!tmpControl)
		{
			return;
		}
		const tmpHelpWrapper = tmpControl.parentElement && tmpControl.parentElement.parentElement ?
			tmpControl.parentElement.parentElement.querySelector('.help') :
			null;
		if (!tmpHelpWrapper)
		{
			return;
		}
		const tmpHelpID = tmpHelpWrapper.id || ('HELP-FOR-' + pInputElement.id);
		if (!tmpHelpWrapper.id)
		{
			tmpHelpWrapper.id = tmpHelpID;
		}
		const tmpExisting = pInputElement.getAttribute('aria-describedby') || '';
		// Preserve any other tokens an upstream template may have already set.
		if (!tmpExisting.split(/\s+/).includes(tmpHelpID))
		{
			pInputElement.setAttribute('aria-describedby', tmpExisting ? `${tmpExisting} ${tmpHelpID}`.trim() : tmpHelpID);
		}
	}

	/**
	 * Locate the "control" wrapper used for is-danger / is-success styling.
	 * Walks the ancestor chain via closest() so deeply-nested inputs (e.g.
	 * flatpickr-wrapped pickers, Station provider's masked input) still find
	 * the right wrapper rather than only checking the direct parent.
	 * Falls back to the input element itself when it carries the `input`
	 * class but has no .control.control-status ancestor.
	 *
	 * @param {HTMLInputElement} pElement
	 * @return {HTMLElement|null}
	 */
	resolveControlElement(pElement)
	{
		if (!pElement)
		{
			return null;
		}
		const tmpControl = this._findControlStatusWrapper(pElement);
		if (tmpControl)
		{
			return tmpControl;
		}
		if (pElement.classList && pElement.classList.contains('input'))
		{
			return pElement;
		}
		return null;
	}

	/**
	 * The `.control.control-status` wrapper that carries an input's validity classes: its own ancestor,
	 * or — for a hidden value input rendered apart from its visible widget — the one around its
	 * `data-validation-surface`.
	 *
	 * @param {Element} pElement
	 * @return {HTMLElement|null}
	 * @private
	 */
	_findControlStatusWrapper(pElement)
	{
		if (!pElement || typeof pElement.closest !== 'function')
		{
			return null;
		}
		const tmpOwnControl = /** @type {HTMLElement|null} */ (pElement.closest('.control.control-status'));
		if (tmpOwnControl)
		{
			return tmpOwnControl;
		}
		const tmpSurfaceID = pElement.getAttribute && pElement.getAttribute('data-validation-surface');
		const tmpSurface = tmpSurfaceID ? document.getElementById(tmpSurfaceID) : null;
		if (tmpSurface && typeof tmpSurface.closest === 'function')
		{
			return /** @type {HTMLElement|null} */ (tmpSurface.closest('.control.control-status'));
		}
		return null;
	}

	/**
	 * True when a manifest-required input holds a real value: `checked` for a checkbox, otherwise a
	 * non-empty value that is not one of the sentinels the input declares in `data-empty-values` (e.g. a
	 * picker whose unset Number value marshals in as "0").
	 *
	 * @param {HTMLInputElement} pElement
	 * @return {boolean}
	 * @private
	 */
	_hasRequiredValue(pElement)
	{
		if (pElement.type === 'checkbox')
		{
			return pElement.checked;
		}
		const tmpValue = (pElement.value == null) ? '' : String(pElement.value);
		if (tmpValue.length < 1)
		{
			return false;
		}
		return !this._readDeclaredEmptyValues(pElement).includes(tmpValue);
	}

	/**
	 * The values an input declares as "empty" through its `data-empty-values` JSON array, as strings. A
	 * missing or malformed attribute declares none.
	 *
	 * @param {Element} pElement
	 * @return {Array<string>}
	 * @private
	 */
	_readDeclaredEmptyValues(pElement)
	{
		const tmpRaw = pElement.getAttribute ? pElement.getAttribute('data-empty-values') : null;
		if (!tmpRaw)
		{
			return [];
		}
		try
		{
			const tmpParsed = JSON.parse(tmpRaw);
			return Array.isArray(tmpParsed) ? tmpParsed.map(String) : [];
		}
		catch (pError)
		{
			return [];
		}
	}

	/**
	 * Resolve the validation rules that apply to a given input, taking both
	 * the manifest config (PictForm) and any HTML attributes already on the
	 * DOM into account, and synchronize the element's `required` /
	 * `aria-required` attributes to reflect visibility.
	 *
	 * Visibility rule: if the element exists but is not visible to the user,
	 * return an empty rules object so callers treat the input as having no
	 * active validation — the field cannot fail a check the user can't see.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @return {Record<string, any>} The validation rules.
	 */
	setValidationInputAttributes(pInput, pValue, pHTMLSelector)
	{
		const tmpRules = {};
		const tmpElement = this.resolveInputElement(pHTMLSelector);
		const tmpPictForm = (pInput && pInput.PictForm) ? pInput.PictForm : null;

		// Determine what the manifest wants for this input. When PictForm is
		// present, treat it as authoritative — "required-ness is determined
		// by the manifest config" per project semantics. Only fall back to
		// inspecting the DOM when no manifest config was passed in at all.
		const tmpWantsRequired = tmpPictForm ?
			!!tmpPictForm.Required :
			!!(tmpElement && tmpElement.required);

		// Visibility short-circuit. We do this BEFORE returning rules so we
		// can also strip the DOM-level `required` attribute, which keeps the
		// browser's checkValidity() honest at submit time.
		if (tmpElement && !this.isInputVisibleToUser(tmpElement))
		{
			this.syncRequiredAttributes(tmpElement, false);
			return tmpRules;
		}

		// Keep the DOM in sync with what the manifest says about this input.
		// This also adds aria-required for accessibility on every required field.
		if (tmpElement)
		{
			this.syncRequiredAttributes(tmpElement, tmpWantsRequired);
			// Manifest is the source of truth for the persistent marker.
			// If the manifest is present AND explicitly says not required,
			// strip data-required so the pre-submit sweep doesn't try to
			// re-mark this field. (Visibility-driven syncs above preserve
			// the marker — only an explicit manifest negative clears it.)
			if (tmpPictForm && !tmpWantsRequired && tmpElement.hasAttribute('data-required'))
			{
				tmpElement.removeAttribute('data-required');
			}
		}

		if (tmpWantsRequired)
		{
			tmpRules.required = true;
		}

		// For each remaining rule, prefer the manifest value when present.
		// Fall back to the DOM value only when the element actually has the
		// attribute set — relying on the IDL property's truthiness is unsafe
		// because browsers (and JSDOM) expose non-spec defaults like 524288
		// for maxLength when the attribute isn't authored.
		const tmpMinNumber = this._pickRuleValue(tmpPictForm, 'MinNumber', tmpElement, 'min', 'min');
		if (tmpMinNumber !== undefined)
		{
		tmpRules.min = tmpMinNumber;
		}

		const tmpMaxNumber = this._pickRuleValue(tmpPictForm, 'MaxNumber', tmpElement, 'max', 'max');
		if (tmpMaxNumber !== undefined)
		{
		tmpRules.max = tmpMaxNumber;
		}

		const tmpStep = this._pickRuleValue(tmpPictForm, 'StepNumber', tmpElement, 'step', 'step');
		if (tmpStep !== undefined)
		{
		tmpRules.step = tmpStep;
		}

		const tmpMinLength = this._pickRuleValue(tmpPictForm, 'MinLength', tmpElement, 'minLength', 'minlength');
		if (tmpMinLength !== undefined)
		{
		tmpRules.minlength = tmpMinLength;
		}

		const tmpMaxLength = this._pickRuleValue(tmpPictForm, 'MaxLength', tmpElement, 'maxLength', 'maxlength');
		if (tmpMaxLength !== undefined)
		{
		tmpRules.maxlength = tmpMaxLength;
		}

		const tmpPattern = this._pickRuleValue(tmpPictForm, 'Pattern', tmpElement, 'pattern', 'pattern');
		if (tmpPattern !== undefined)
		{
		tmpRules.pattern = tmpPattern;
		}

		return tmpRules;
	}

	/**
	 * Pick a rule value, manifest first then DOM. Returns undefined when
	 * neither side has a meaningful value (so callers can omit the key
	 * entirely from the rules object).
	 *
	 * @param {object|null} pPictForm - Manifest config, if any.
	 * @param {string} pManifestKey - Key on PictForm to read.
	 * @param {HTMLInputElement|null} pElement - Live DOM element, if any.
	 * @param {string} pDomKey - IDL property name on the element.
	 * @param {string} pAttributeName - HTML attribute name (used with hasAttribute to detect "actually set").
	 * @return {any}
	 */
	_pickRuleValue(pPictForm, pManifestKey, pElement, pDomKey, pAttributeName)
	{
		if (pPictForm && pPictForm[pManifestKey] !== undefined && pPictForm[pManifestKey] !== null)
		{
			return pPictForm[pManifestKey];
		}
		if (pElement && pElement.hasAttribute && pElement.hasAttribute(pAttributeName))
		{
			return pElement[pDomKey];
		}
		return undefined;
	}

	/**
	 * True if any validation rules apply to this input right now (taking the
	 * visibility gate into account, since setValidationInputAttributes does).
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @return {boolean}
	 */
	hasInputValidation(pInput, pValue, pHTMLSelector)
	{
		const tmpRules = this.setValidationInputAttributes(pInput, pValue, pHTMLSelector);
		return Object.keys(tmpRules).length > 0;
	}

	/**
	 * Apply / remove validity classes on a control wrapper. Shared by both
	 * the submit-style and change-style validation flows so the class-swap
	 * logic lives in one place.
	 *
	 * @param {HTMLElement|null} pControl - The control wrapper or input itself.
	 * @param {boolean} pIsValid - Whether the input is currently valid.
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.clearBoth] - Strip both classes regardless of validity (e.g. empty input on change).
	 * @param {boolean} [pOptions.fadeSuccess] - Remove the success class after SUCCESS_FADE_DELAY_MS.
	 * @param {boolean} [pOptions.onlyMarkSuccessIfWasDanger] - Submit-style behavior: only add is-success when the field had been marked is-danger.
	 * @return {void}
	 */
	applyValidityClasses(pControl, pIsValid, pOptions)
	{
		if (!pControl)
		{
			return;
		}
		const tmpOptions = pOptions || {};
		if (tmpOptions.clearBoth)
		{
			pControl.classList.remove(VALIDATION_CLASSES.SUCCESS);
			pControl.classList.remove(VALIDATION_CLASSES.DANGER);
			return;
		}
		if (pIsValid)
		{
			if (tmpOptions.onlyMarkSuccessIfWasDanger)
			{
				if (pControl.classList.contains(VALIDATION_CLASSES.DANGER))
				{
					pControl.classList.add(VALIDATION_CLASSES.SUCCESS);
				}
			}
			else
			{
				pControl.classList.add(VALIDATION_CLASSES.SUCCESS);
			}
			pControl.classList.remove(VALIDATION_CLASSES.DANGER);
		}
		else
		{
			pControl.classList.remove(VALIDATION_CLASSES.SUCCESS);
			pControl.classList.add(VALIDATION_CLASSES.DANGER);
		}
		if (tmpOptions.fadeSuccess && pControl.classList.contains(VALIDATION_CLASSES.SUCCESS))
		{
			setTimeout(() =>
			{
				pControl.classList.remove(VALIDATION_CLASSES.SUCCESS);
			}, SUCCESS_FADE_DELAY_MS);
		}
	}

	/**
	 * Clear all validation styling on a control wrapper plus any addon sibling.
	 * Used when an input transitions from visible→hidden so it doesn't leave
	 * a stale red highlight behind on a tab the user can no longer see.
	 *
	 * @param {HTMLElement|null} pControl
	 * @return {void}
	 */
	clearValidationStyling(pControl)
	{
		if (!pControl)
		{
			return;
		}
		this.applyValidityClasses(pControl, true, { clearBoth: true });
		const tmpAddon = pControl.nextElementSibling;
		if (tmpAddon && tmpAddon.classList.contains('addon'))
		{
			this.applyValidityClasses(/** @type {HTMLElement} */ (tmpAddon), true, { clearBoth: true });
		}
	}

	/**
	 * Strip the validation-text node from the help wrapper, if present.
	 *
	 * @param {HTMLElement|null} pControl
	 * @return {void}
	 */
	clearValidationHelpText(pControl)
	{
		if (!pControl)
		{
			return;
		}
		// Tier 5: drop any aria-errormessage pointing at a validation-text
		// node we're clearing, so AT never references a dangling id. Scope
		// the sweep to this field so we don't disturb other inputs.
		const tmpErrorScope = (typeof pControl.closest === 'function' && pControl.closest('.field')) || pControl;
		if (tmpErrorScope && typeof tmpErrorScope.querySelectorAll === 'function')
		{
			const tmpReferers = tmpErrorScope.querySelectorAll('[aria-errormessage]');
			for (let i = 0; i < tmpReferers.length; i++)
			{
				tmpReferers[i].removeAttribute('aria-errormessage');
			}
		}
		const tmpHelpWrapper = pControl.parentElement && pControl.parentElement.parentElement ?
			pControl.parentElement.parentElement.querySelector('.help') :
			null;
		if (!tmpHelpWrapper)
		{
			return;
		}
		const tmpExisting = tmpHelpWrapper.querySelector('.' + VALIDATION_CLASSES.VALIDATION_TEXT);
		if (tmpExisting)
		{
			tmpExisting.remove();
		}
	}

	/**
	 * Handle the validation class swapping for the input (submit-style flow).
	 * If the input is not visible to the user, this no-ops and proactively
	 * scrubs any stale danger styling so a previously-visible field that
	 * got hidden doesn't leave error UI on a tab the user can't see.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @return {void}
	 */
	handleValidationInputStyling(pInput, pValue, pHTMLSelector, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			// if we're not in interactive mode, we don't want to show the validation UI
			return;
		}
		// Use the styling-target resolver so hidden data-bearer inputs
		// (Station, DateTime, Date, Time) are translated to their visible
		// required sibling. Without this, the canonical selector points at
		// a type=hidden input that's barred from native validation, and
		// styling silently no-ops on every keystroke.
		const tmpInput = this.resolveStylingTargetInput(pHTMLSelector);
		if (!tmpInput)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(tmpInput);

		if (!this.isInputVisibleToUser(tmpInput))
		{
			// Field is not currently visible to the user — clean up any prior
			// styling and bail without applying new danger state.
			this.clearValidationStyling(tmpControl);
			this.clearValidationHelpText(tmpControl);
			this.syncAriaInvalidAttribute(tmpInput, false);
			return;
		}

		// NOTE: For checkboxes, we only check validity if the field is required, otherwise an unchecked checkbox will always be invalid but that's not the desired behavior
		const tmpIsValid = (tmpInput.type === 'checkbox' && tmpInput.required) ? tmpInput.checked : tmpInput.checkValidity();

		this.syncAriaInvalidAttribute(tmpInput, !tmpIsValid);

		// if we can't find the control element, there's not much else we can do
		if (!tmpControl)
		{
			this.pict.log.warn('Could not find the control element for input validation styling.');
			return;
		}

		this.applyValidityClasses(tmpControl, tmpIsValid, { onlyMarkSuccessIfWasDanger: true });
		const tmpAddon = tmpControl.nextElementSibling;
		if (tmpAddon && tmpAddon.classList.contains('addon'))
		{
			this.applyValidityClasses(/** @type {HTMLElement} */ (tmpAddon), tmpIsValid, { onlyMarkSuccessIfWasDanger: true });
		}
	}

	/**
	 * Build the validation message text string for the input - could be more
	 * than one error, so we join them.
	 *
	 * @param {HTMLInputElement} pInputElement
	 * @return {string}
	 */
	buildValidationMessageTextString(pInputElement)
	{
		const tmpMessageParts = [];
		if (pInputElement.validity.valid)
		{
			return '';
		}
		if (pInputElement.validity.valueMissing)
		{
			tmpMessageParts.push('This field is required');
		}
		if (pInputElement.validity.typeMismatch)
		{
			tmpMessageParts.push('Please enter a value of the correct type');
		}
		if (pInputElement.validity.patternMismatch)
		{
			tmpMessageParts.push(`Please match the requested format <format>${pInputElement.pattern}</format>`);
		}
		if (pInputElement.validity.tooLong)
		{
			tmpMessageParts.push(`Please shorten this text to no more than ${pInputElement.maxLength} characters`);
		}
		if (pInputElement.validity.tooShort)
		{
			tmpMessageParts.push(`Please lengthen this text to at least ${pInputElement.minLength} characters`);
		}
		if (pInputElement.min && pInputElement.max && (pInputElement.validity.rangeUnderflow || pInputElement.validity.rangeOverflow))
		{
			tmpMessageParts.push(`Please enter a value between ${pInputElement.min} and ${pInputElement.max}`);
		}
		else if (pInputElement.validity.rangeUnderflow)
		{
			tmpMessageParts.push(`Please increase the value to at least ${pInputElement.min}`);
		}
		else if (pInputElement.validity.rangeOverflow)
		{
			tmpMessageParts.push(`Please decrease the value to less than or equal to ${pInputElement.max}`);
		}
		if (pInputElement.validity.stepMismatch)
		{
			if (pInputElement.step == '1')
			{
				tmpMessageParts.push('Please enter a valid whole number.');
			}
			else
			{
				tmpMessageParts.push('Please enter a valid value with the correct decimal precision. The allowed step value is ' + pInputElement.step);
			}
		}
		return tmpMessageParts.length ? tmpMessageParts.join('; ') : '';
	}

	/**
	 * Handle the validation UI for the input on a per-change basis (live
	 * feedback as the user types/picks). Differs from
	 * `handleValidationInputStyling` in that it trusts the caller's
	 * `pValidResult` rather than calling `checkValidity()`, and fades the
	 * success class after a short delay.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} [pRowIndex]
	 * @param {boolean} [pValidResult]
	 * @return {void}
	 */
	handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, pValidResult = false)
	{
		if (!this.pict.AppData.Interactive)
		{
			// if we're not in interactive mode, we don't want to show the validation UI
			return;
		}
		const tmpInput = this.resolveStylingTargetInput(pHTMLSelector);
		if (!tmpInput)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(tmpInput) || tmpInput;

		if (!this.isInputVisibleToUser(tmpInput))
		{
			this.clearValidationStyling(tmpControl);
			this.syncAriaInvalidAttribute(tmpInput, false);
			return;
		}

		if (!pValue)
		{
			// Empty value means no judgment yet — clear both class state and
			// aria-invalid so screen readers don't carry over a stale verdict.
			this.applyValidityClasses(tmpControl, true, { clearBoth: true });
			this.syncAriaInvalidAttribute(tmpInput, false);
			return;
		}
		this.syncAriaInvalidAttribute(tmpInput, !pValidResult);
		this.applyValidityClasses(tmpControl, !!pValidResult, { fadeSuccess: true });
	}

	/**
	 * Handle the injection of validation help text into the input's help
	 * text wrapper. No-ops + scrubs prior help text when the input is hidden.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @return {void}
	 */
	handleValidationHelpTextElementUpdate(pInput, pValue, pHTMLSelector, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			// if we're not in interactive mode, we don't want to show the validation UI
			return;
		}
		const tmpInput = this.resolveStylingTargetInput(pHTMLSelector);
		if (!tmpInput)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(tmpInput);

		if (!this.isInputVisibleToUser(tmpInput))
		{
			this.clearValidationHelpText(tmpControl);
			return;
		}

		// if we can't find the control element, there's not much else we can do
		if (!tmpControl)
		{
			this.pict.log.warn('Could not find the control element for input validation help text injection.');
			return;
		}
		const tmpHelpWrapper = tmpControl.parentElement && tmpControl.parentElement.parentElement ?
			tmpControl.parentElement.parentElement.querySelector('.help') :
			null;
		if (!tmpHelpWrapper)
		{
			return;
		}

		// Remove any previous validation-text node before injecting a fresh one.
		const tmpExisting = tmpHelpWrapper.querySelector('.' + VALIDATION_CLASSES.VALIDATION_TEXT);
		if (tmpExisting)
		{
			tmpExisting.remove();
		}

		const tmpIsValid = tmpInput.type === 'checkbox' ? tmpInput.checked : tmpInput.checkValidity();
		if (tmpIsValid)
		{
			// if the input is valid, we don't need to show any validation text.
			// Drop the aria-errormessage pointer too so AT doesn't reference a
			// node we just removed (Tier 5).
			tmpInput.removeAttribute('aria-errormessage');
			return;
		}

		const tmpValidationTextMessage = this.buildValidationMessageTextString(tmpInput);
		const tmpValidationTextElement = document.createElement('div');
		tmpValidationTextElement.classList.add(VALIDATION_CLASSES.VALIDATION_TEXT);
		tmpValidationTextElement.classList.add(VALIDATION_CLASSES.HELP_DANGER_TEXT);
		// role="alert" makes screen readers announce the message when the
		// node is inserted. assertive live region + atomic so the full
		// message reads as one unit even when parts get rewritten in place.
		tmpValidationTextElement.setAttribute('role', 'alert');
		tmpValidationTextElement.setAttribute('aria-live', 'assertive');
		tmpValidationTextElement.setAttribute('aria-atomic', 'true');
		// Tier 5: point the input at the message node via aria-errormessage.
		// The node id derives from the input's own id (which already encodes
		// the tabular row key, so rows don't collide). AT only honours
		// aria-errormessage when aria-invalid="true" is also present —
		// syncAriaInvalidAttribute manages that in the styling flow.
		if (tmpInput.id)
		{
			const tmpMessageID = 'VALIDATION-MESSAGE-FOR-' + tmpInput.id;
			tmpValidationTextElement.id = tmpMessageID;
			tmpInput.setAttribute('aria-errormessage', tmpMessageID);
		}
		tmpHelpWrapper.insertAdjacentElement('afterbegin', tmpValidationTextElement);
		tmpValidationTextElement.innerHTML = tmpValidationTextMessage || '';
	}

	/**
	 * Fires when an input is first rendered into the DOM. We use it to wire
	 * the input to its help-text wrapper via aria-describedby so screen
	 * readers announce the description (and any later-injected validation
	 * message) as part of the input.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pRow
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.linkInputToHelpText(this.resolveInputElement(pHTMLSelector));
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Fires when a tabular input is first rendered. Same aria-describedby
	 * wiring as onInputInitialize, applied per row.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.linkInputToHelpText(this.resolveInputElement(pHTMLSelector));
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.hasInputValidation(pInput, pValue, pHTMLSelector))
		{
			this.handleValidationInputStyling(pInput, pValue, pHTMLSelector, 0);
			this.handleValidationHelpTextElementUpdate(pInput, pValue, pHTMLSelector, 0);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.hasInputValidation(pInput, pValue, pHTMLSelector))
		{
			this.handleValidationInputStyling(pInput, pValue, pHTMLSelector, pRowIndex);
			this.handleValidationHelpTextElementUpdate(pInput, pValue, pHTMLSelector, pRowIndex);
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":497}],122:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const LAB_PAGE_SIZE = 500;

/**
 * @typedef {Object} LabAffinityRule
 * @property {string} LabField - the Lab column matched against (e.g. 'Name', 'ExternalLabID').
 * @property {string} Pattern - a regular expression with `{KeyName}` placeholders filled from the project keys.
 * @property {Array<string>} [Requires] - project key names that must resolve before the rule is evaluated.
 * @property {string} [Flags] - regular-expression flags (default 'i').
 */

/**
 * @typedef {Object} LabAffinityConfiguration
 * @property {Record<string, Array<string>>} ProjectKeys - key name → ordered `Project.CustomProperties` keys; first non-empty wins.
 * @property {Array<LabAffinityRule>} Rules - ordered; the order is the pin-to-top priority order.
 * @property {string} [ProjectRecordAddress] - form address of an already-loaded Project record, read before falling back to REST.
 */

/**
 * LabScopeResolver — resolves which labs a materials Sample form's lab dropdowns may offer, and which of
 * them the user most likely wants.
 *
 * The lab model is two-level: a PARENT lab is the routing destination an engineer ships a sample to, and its
 * CHILD labs are the benches that actually run tests. `ProjectLabJoin` names parents; `TestLabJoin` and
 * `LabTestDefault` name children. The two selectors therefore answer different questions:
 *
 *   - the SAMPLE-level selector offers PARENT labs (`getSampleLabIDs`) — the project's labs, else the parents
 *     of every lab that can run the selected tests.
 *   - a PER-TEST selector offers LEAF labs (`getTestLabIDs`) — a lab with no children is itself a leaf and
 *     stays selectable, while a parent named by `TestLabJoin` resolves to its children (assigning a test to a
 *     parent only defers the routing decision). Only test capability narrows it; an empty result is the
 *     honest answer ("no lab here for this test") and is recoverable through Show All.
 *
 * Everything else is a preference, and preferences rank rather than narrow. `getPreferredLabIDs` orders a
 * test's capable labs: first those in the project's own lab families — named by the manifest's `LabAffinity`
 * rules from project metadata (see {@link LabAffinityConfiguration}) and by `ProjectLabJoin`, unioned — then the
 * `LabTestDefault` labs (material + sample type), which disagree with `TestLabJoin` too often to narrow.
 * `getAutoFillLabID` fills the top of that ranking, so the value filled is the first one the dropdown pins.
 *
 * Perf: one batched prime per (project, test-set, material, sample-type). The lab catalog and the project's
 * affinity resolve once each and survive later primes. Every selector then reads the caches SYNCHRONOUSLY at
 * filter-assembly time; no per-selector network.
 *
 * Consumers:
 *   resolver.primeFromForm()                      // app load + cascade (awaited in the transport seam)
 *   resolver.getSampleLabIDs()                    // sync: Set<number> | null
 *   resolver.getTestLabIDs(pIDTest, pContext)     // sync: Set<number> | null
 *   resolver.getTestLabDefaultIDs(pIDTest)        // sync: Set<number> | null  (ranking axis)
 *   resolver.getPreferredLabIDs(pScope, pContext) // sync: Array<number>       (pin-to-top order)
 *   resolver.getAutoFillLabID(pIDTest)            // sync: number              (0 = nothing to fill)
 *   resolver.getParentLabID(pIDLab)               // sync: number              (root of, or self)
 */
class LabScopeResolver extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		/** @type {Map<number, Record<string, any>>} the customer lab catalog, by IDLab */
		this._Labs = new Map();
		/** @type {Map<number, Set<number>>} IDLab → its child IDLab set */
		this._ChildrenByParent = new Map();
		this._LabsLoaded = false;
		/** @type {Set<number>|null} the project's PARENT labs (null = not loaded / none → fail-open) */
		this._ProjectRootLabs = null;
		/** @type {Map<string, Set<number>>} per-test capable labs, keyed by IDTest string */
		this._TestLabs = new Map();
		/** @type {Map<string, Set<number>>} per-test material/sample-type default labs, keyed by IDTest string */
		this._TestLabDefaults = new Map();
		/** @type {Array<number>} affinity-matched PARENT lab ids, in rule order */
		this._AffinityRootIDs = [];
		this._AffinityProjectID = 0;
		this._Loaded = false;
		/** @type {string|null} the key of the most recent prime requested */
		this._PrimeKey = null;
		/** @type {string|null} the key whose rows the caches actually hold */
		this._LoadedKey = null;
		/** @type {Promise<void>|null} */
		this._PrimePromise = null;
		/** @type {Record<string, any>|null} */
		this._Configuration = null;
	}

	// --- configuration -------------------------------------------------------------------------------

	/**
	 * The prime-time configuration: this provider's own options layered over the first `LabScope` entry found
	 * in the loaded manifest's descriptors. Priming happens before any picker composes a filter, so the
	 * resolver reads the manifest itself rather than waiting to be handed the entry (mirrors
	 * SpecScopeResolver's descriptor walk).
	 *
	 * @return {Record<string, any>}
	 */
	_getConfiguration()
	{
		if (this._Configuration)
		{
			return this._Configuration;
		}
		const tmpConfiguration = Object.assign({}, this._findManifestLabScopeEntry() || {}, this.options || {});
		this._Configuration = tmpConfiguration;
		return tmpConfiguration;
	}

	/**
	 * The first `LabScope` DynamicFilters entry in the loaded manifest. Entries carrying a `LabAffinity`
	 * block win over those that do not, so a form whose per-test entry holds the affinity config is found
	 * regardless of descriptor order.
	 *
	 * @return {Record<string, any>|null}
	 */
	_findManifestLabScopeEntry()
	{
		const tmpManifest = this.pict?.views?.PictFormMetacontroller?.manifestDescription;
		if (!tmpManifest || !tmpManifest.Descriptors)
		{
			return null;
		}
		/** @type {Record<string, any>|null} */
		let tmpFallback = null;
		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors))
		{
			const tmpFilters = tmpDescriptor?.PictForm?.DynamicFilters;
			if (!Array.isArray(tmpFilters))
			{
				continue;
			}
			for (const tmpFilter of tmpFilters)
			{
				if (!tmpFilter || !tmpFilter.LabScope)
				{
					continue;
				}
				if (tmpFilter.LabAffinity)
				{
					return tmpFilter;
				}
				if (!tmpFallback)
				{
					tmpFallback = tmpFilter;
				}
			}
		}
		return tmpFallback;
	}

	// --- form reads ----------------------------------------------------------------------------------

	/**
	 * The form address of the sample's project id. Overridable via this provider's options.
	 * @return {number}
	 */
	_readProjectID()
	{
		const tmpAddress = this._getConfiguration().ProjectAddress || 'AppData.DocumentData.ReportData.FormData.SampleID__Record.IDProject';
		const tmpValue = this.pict.manifest.getValueAtAddress(this.pict, tmpAddress);
		const tmpID = parseInt(tmpValue, 10);
		return tmpID > 0 ? tmpID : 0;
	}

	/**
	 * The selected tests' IDTest values, read from the Test selector's TestInstance triples.
	 * @return {Array<number>}
	 */
	_readTestIDs()
	{
		const tmpAddress = this._getConfiguration().TestInstancesAddress || 'AppData.DocumentData.ReportData.FormData.SampleTestIDs__Record_Instances';
		const tmpInstances = this.pict.manifest.getValueAtAddress(this.pict, tmpAddress);
		if (!Array.isArray(tmpInstances))
		{
			return [];
		}
		const tmpSet = new Set();
		for (const tmpTriple of tmpInstances)
		{
			const tmpIDTest = parseInt(tmpTriple && tmpTriple.TestInstance && tmpTriple.TestInstance.IDTest, 10);
			if (tmpIDTest > 0)
			{
				tmpSet.add(tmpIDTest);
			}
		}
		return Array.from(tmpSet);
	}

	/**
	 * The sample's material, driving the `LabTestDefault` axis. Absent config (or an unset value) leaves that
	 * axis unloaded, which reads as "no constraint".
	 * @return {number}
	 */
	_readMaterialID()
	{
		const tmpAddress = this._getConfiguration().MaterialFromField;
		if (!tmpAddress)
		{
			return 0;
		}
		const tmpID = parseInt(this.pict.manifest.getValueByHash(this.pict, tmpAddress), 10);
		return tmpID > 0 ? tmpID : 0;
	}

	/**
	 * The sample's sample-type code (`LabTestDefault.SampleType` is a short code, not an id).
	 * @return {string}
	 */
	_readSampleType()
	{
		const tmpAddress = this._getConfiguration().SampleTypeFromField;
		if (!tmpAddress)
		{
			return '';
		}
		const tmpValue = this.pict.manifest.getValueByHash(this.pict, tmpAddress);
		return (tmpValue === null || tmpValue === undefined) ? '' : String(tmpValue).trim();
	}

	// --- lab tree ------------------------------------------------------------------------------------

	/**
	 * The parent of a lab, or the lab itself when it is already a root. A parent pointer that references a
	 * lab outside the catalog (or the lab itself) is treated as "no parent" rather than followed.
	 * @param {number|string} pIDLab
	 * @return {number}
	 */
	getParentLabID(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return 0;
		}
		const tmpLab = this._Labs.get(tmpIDLab);
		const tmpParent = tmpLab ? (parseInt(tmpLab.IDLabParent, 10) || 0) : 0;
		if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
		{
			return tmpIDLab;
		}
		return tmpParent;
	}

	/**
	 * Whether a lab is a leaf — it has no children, so a test assigned to it needs no further routing. A lab
	 * absent from the catalog counts as a leaf so an unloaded tree never hides an option.
	 * @param {number|string} pIDLab
	 * @return {boolean}
	 */
	isLeafLab(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return false;
		}
		const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
		return !tmpChildren || tmpChildren.size < 1;
	}

	/**
	 * Resolve a set of labs to the leaves a test can actually be assigned to: a leaf stays, a parent is
	 * replaced by its children. Falls back to the input when the resolution empties it (a catalog that has
	 * not loaded), so this never removes the only options a caller had.
	 * @param {Set<number>|undefined|null} pLabIDs
	 * @return {Set<number>|null}
	 */
	_resolveToLeaves(pLabIDs)
	{
		if (!pLabIDs || pLabIDs.size < 1)
		{
			return null;
		}
		const tmpLeaves = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
			if (tmpChildren && tmpChildren.size > 0)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpLeaves.add(tmpChild);
				}
				continue;
			}
			tmpLeaves.add(tmpIDLab);
		}
		return (tmpLeaves.size > 0) ? tmpLeaves : new Set(pLabIDs);
	}

	/**
	 * The parent labs this project prefers, most-preferred first: those the `LabAffinity` rules match from the
	 * project's metadata (in rule order), then those `ProjectLabJoin` names. The sources are unioned — either
	 * alone is enough, and a lab both name ranks at its first appearance.
	 * @return {Array<number>}
	 */
	_getPreferredRootIDs()
	{
		const tmpRoots = [];
		for (const tmpRoot of [ ...this._AffinityRootIDs, ...(this._ProjectRootLabs || []) ])
		{
			if (tmpRoots.indexOf(tmpRoot) < 0)
			{
				tmpRoots.push(tmpRoot);
			}
		}
		return tmpRoots;
	}

	/**
	 * Order within one preference tier: `LabTestDefault` labs first, then labs another test on this sample
	 * already uses (so the sample picks up no extra lab it does not need), then by Name, then by id.
	 * @param {Array<number>} pLabIDs
	 * @param {Set<number>} pDefaultIDs
	 * @param {Set<number>} pSelectedIDs - labs the sample's other tests are already assigned to.
	 * @return {Array<number>}
	 */
	_rankWithinTier(pLabIDs, pDefaultIDs, pSelectedIDs)
	{
		const tmpName = (pIDLab) => String((this._Labs.get(pIDLab) || {}).Name || '');
		const tmpFirst = (pSet, pLeft, pRight) => (pSet.has(pLeft) ? 0 : 1) - (pSet.has(pRight) ? 0 : 1);
		return pLabIDs.slice().sort((pLeft, pRight) =>
		{
			return tmpFirst(pDefaultIDs, pLeft, pRight) || tmpFirst(pSelectedIDs, pLeft, pRight) ||
				tmpName(pLeft).localeCompare(tmpName(pRight)) || (pLeft - pRight);
		});
	}

	/**
	 * The distinct parent labs standing over a set of labs.
	 * @param {Set<number>|Array<number>} pLabIDs
	 * @return {Set<number>}
	 */
	_rootsOf(pLabIDs)
	{
		const tmpRoots = new Set();
		for (const tmpIDLab of (pLabIDs || []))
		{
			const tmpRoot = this.getParentLabID(tmpIDLab);
			if (tmpRoot > 0)
			{
				tmpRoots.add(tmpRoot);
			}
		}
		return tmpRoots;
	}

	// --- scope getters -------------------------------------------------------------------------------

	/**
	 * Allowed labs for the SHARED / sample-level selector — PARENT labs, because a sample ships to a parent
	 * and its tests are routed to that parent's benches afterwards. The project's own labs answer when it has
	 * any; otherwise the parents of every lab that can run a selected test.
	 * @return {Set<number>|null} null when neither axis has data (fail-open).
	 */
	getSampleLabIDs()
	{
		if (!this._Loaded)
		{
			return null;
		}
		if (this._ProjectRootLabs && this._ProjectRootLabs.size > 0)
		{
			return this._ProjectRootLabs;
		}
		const tmpRoots = new Set();
		for (const tmpTestLabs of this._TestLabs.values())
		{
			for (const tmpRoot of this._rootsOf(tmpTestLabs))
			{
				tmpRoots.add(tmpRoot);
			}
		}
		return (tmpRoots.size > 0) ? tmpRoots : null;
	}

	/**
	 * Allowed labs for a per-test selector — the LEAF labs that can actually run this test (`TestLabJoin`,
	 * resolved to leaves). Capability is the ONLY mandatory axis, because it is the only one where an empty
	 * result is informative: "no lab performs this test" is a fact, where every other narrowing is a
	 * preference. Project locality and the material defaults rank instead (see getPreferredLabIDs).
	 *
	 * Leaf grain is an invariant of this selector, not a property of one axis: a test is assigned to a bench,
	 * never to a lab that would only route it onward. A lab missing from the catalog counts as a leaf, so an
	 * unloaded tree filters nothing.
	 * @param {number|string} pIDTest
	 * @return {Set<number>|null} null when this test has no capability rows at all (fail-open).
	 */
	getTestLabIDs(pIDTest)
	{
		if (!this._Loaded)
		{
			return null;
		}
		const tmpTestLabs = this._resolveToLeaves(this._TestLabs.get(String(pIDTest)));
		if (!tmpTestLabs)
		{
			return null;
		}
		return this._keepLeaves(tmpTestLabs);
	}

	/**
	 * Drop any lab that routes further — a parent with benches beneath it. Its benches, when they qualify,
	 * are already in the set beside it.
	 * @param {Set<number>} pLabIDs
	 * @return {Set<number>}
	 */
	_keepLeaves(pLabIDs)
	{
		const tmpLeaves = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			if (this.isLeafLab(tmpIDLab))
			{
				tmpLeaves.add(tmpIDLab);
			}
		}
		return tmpLeaves;
	}

	/**
	 * The material + sample-type default labs for a test (`LabTestDefault`), resolved to leaves. A RANKING
	 * axis only (see getPreferredLabIDs): it disagrees with `TestLabJoin` too often to narrow.
	 * @param {number|string} pIDTest
	 * @return {Set<number>|null} null when the axis has no rows for this test (no constraint).
	 */
	getTestLabDefaultIDs(pIDTest)
	{
		if (!this._Loaded)
		{
			return null;
		}
		return this._resolveToLeaves(this._TestLabDefaults.get(String(pIDTest)));
	}

	/**
	 * The labs to float to the top of a selector, most-preferred first. Never removes anything; callers pin,
	 * they do not filter.
	 *
	 *   'Sample' → the preferred parent labs the sample-level selector offers.
	 *   'Test'   → the capable benches in tiers: those in a preferred family, family by family in
	 *              `_getPreferredRootIDs` order, then the remaining `LabTestDefault` labs. Within a tier a
	 *              `LabTestDefault` lab leads, then a lab the sample's other tests already use, and Name
	 *              breaks ties, so the order is stable when nothing expresses a stronger preference.
	 * @param {string} [pScope] - 'Sample' (parent labs) or 'Test' (leaf labs).
	 * @param {{ IDTest?: number|string, SelectedLabIDs?: Array<number|string> }} [pContext]
	 * @return {Array<number>}
	 */
	getPreferredLabIDs(pScope, pContext)
	{
		if (!this._Loaded)
		{
			return [];
		}
		const tmpRoots = this._getPreferredRootIDs();
		if (pScope !== 'Test')
		{
			const tmpAllowedRoots = this._applySpecSetFloor(this.getSampleLabIDs());
			return tmpRoots.filter((pID) => !tmpAllowedRoots || tmpAllowedRoots.has(pID));
		}
		const tmpIDTest = pContext && pContext.IDTest;
		const tmpAllowed = this._applySpecSetFloor(this.getTestLabIDs(tmpIDTest));
		if (!tmpAllowed || tmpAllowed.size < 1)
		{
			return [];
		}
		const tmpDefaults = this.getTestLabDefaultIDs(tmpIDTest) || new Set();
		const tmpSelected = new Set(((pContext && pContext.SelectedLabIDs) || []).map((pID) => parseInt(pID, 10)));
		const tmpRanked = [];
		for (const tmpRoot of tmpRoots)
		{
			const tmpFamily = Array.from(tmpAllowed).filter((pID) => this.getParentLabID(pID) === tmpRoot && tmpRanked.indexOf(pID) < 0);
			tmpRanked.push(...this._rankWithinTier(tmpFamily, tmpDefaults, tmpSelected));
		}
		const tmpDefaultTier = Array.from(tmpAllowed).filter((pID) => tmpDefaults.has(pID) && tmpRanked.indexOf(pID) < 0);
		tmpRanked.push(...this._rankWithinTier(tmpDefaultTier, tmpDefaults, tmpSelected));
		return tmpRanked;
	}

	/**
	 * The lab to fill into an empty per-test selector, or 0 when there is nothing to fill. A test only one lab
	 * can run fills with that lab; otherwise the top of the `getPreferredLabIDs` ranking fills, so the value
	 * written is the first one the dropdown pins. A row with neither a preferred nor a `LabTestDefault`
	 * candidate stays blank.
	 *
	 * The spec-set floor is applied here even though the dropdown's filter does not carry it (the picker adds
	 * that clause itself), so the value written is one the dropdown would have offered — without it, a customer
	 * running two field-lab generations could be auto-filled into the retired one.
	 * @param {number|string} pIDTest
	 * @param {{ SelectedLabIDs?: Array<number|string> }} [pContext] - the labs the sample's other tests use.
	 * @return {number}
	 */
	getAutoFillLabID(pIDTest, pContext)
	{
		const tmpAllowed = this._applySpecSetFloor(this.getTestLabIDs(pIDTest));
		if (!tmpAllowed || tmpAllowed.size < 1)
		{
			return 0;
		}
		if (tmpAllowed.size === 1)
		{
			return Array.from(tmpAllowed)[0];
		}
		return this.getPreferredLabIDs('Test', { IDTest: pIDTest, SelectedLabIDs: pContext && pContext.SelectedLabIDs })[0] || 0;
	}

	/**
	 * The spec-set lab floor, expanded across the lab family: a lab is admitted when IT is in
	 * `LabTestSpecificationSetJoin`, when its PARENT is, or when any of its CHILDREN is.
	 *
	 * Membership is declared at the FAMILY level: the set names the parent labs and their benches come along,
	 * which is why the join is small relative to the lab catalog. Down-expansion is therefore the primary
	 * direction and the one the data is authored for. Up-expansion covers the rest: a set may also name a
	 * bench directly, and a bench-only entry must not strip the parent that the sample-level selector offers
	 * (that is the case `narrowLabsToSpecSet` in the materials app guards, noting "a parent survives whenever
	 * one of its children does, so narrowing the child labs never strips the district heading the user selects
	 * through"). Raw membership does neither, which empties whichever level the set was not authored at.
	 *
	 * The floor's real job — separating parallel lab generations mid-rename — is preserved either way, because
	 * generations differ by FAMILY: expanding within a family never reaches across to the other one.
	 *
	 * @return {Set<number>|null} null when the join has no coverage (no floor at all).
	 */
	getSpecSetLabFloor()
	{
		const tmpAdmitted = this.pict?.providers?.SpecScopeResolver?.getAllowedLabIDs?.();
		if (!tmpAdmitted || tmpAdmitted.size < 1)
		{
			return null;
		}
		const tmpFloor = new Set(tmpAdmitted);
		for (const tmpIDLab of tmpAdmitted)
		{
			const tmpParent = this.getParentLabID(tmpIDLab);
			if (tmpParent > 0)
			{
				tmpFloor.add(tmpParent);
			}
			const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
			if (tmpChildren)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpFloor.add(tmpChild);
				}
			}
		}
		return tmpFloor;
	}

	/**
	 * Narrow a candidate set to the labs the project's material specification set admits
	 * (`LabTestSpecificationSetJoin`, resolved by SpecScopeResolver).
	 *
	 * This is the ONLY thing that separates lab generations which are otherwise identical: a customer
	 * mid-rename runs two parallel field-lab trees whose members share a name stem AND an `ExternalLabID`
	 * (`District 02 Gang 202` and `District 02 Unit 202` are both coded `02-202`), so neither the naming
	 * rules nor the capability tables can tell them apart — only spec-set membership can.
	 *
	 * Applied where a lab is CHOSEN (auto-fill, pin order), not where the dropdown's filter is composed:
	 * the picker already layers the same floor as its own clause, and repeating it in the INN list would
	 * only lengthen the URL. Returns the intersection EVEN WHEN EMPTY — no admitted candidate means the
	 * caller must decline, not fall back to a lab from the retired generation.
	 *
	 * @param {Set<number>|null} pLabIDs
	 * @return {Set<number>|null}
	 */
	_applySpecSetFloor(pLabIDs)
	{
		if (!pLabIDs)
		{
			return pLabIDs;
		}
		const tmpAllowed = this.getSpecSetLabFloor();
		if (!tmpAllowed || tmpAllowed.size < 1)
		{
			return pLabIDs;
		}
		return this._intersect([ pLabIDs, tmpAllowed ]);
	}

	/**
	 * @param {Array<Set<number>>} pSets
	 * @return {Set<number>}
	 */
	_intersect(pSets)
	{
		const tmpResult = new Set(pSets[0]);
		for (let i = 1; i < pSets.length; i++)
		{
			for (const tmpValue of Array.from(tmpResult))
			{
				if (!pSets[i].has(tmpValue))
				{
					tmpResult.delete(tmpValue);
				}
			}
		}
		return tmpResult;
	}

	// --- priming -------------------------------------------------------------------------------------

	/**
	 * Prime (or re-prime) the caches from the form's current project, test set, material and sample type.
	 * Idempotent and de-duped — a no-op when the key is unchanged. Fire-and-forget; the transport awaits it
	 * before a dependent picker reads, so the getters resolve synchronously.
	 *
	 * Primes overlap whenever the test set changes faster than a prime completes, and the older one can land
	 * last. Only the current prime may write the caches or clear the in-flight marker — otherwise the newest
	 * test is dropped from the caches and the resolver reports itself settled for a key it never loaded.
	 * @return {Promise<void>}
	 */
	primeFromForm()
	{
		const tmpProject = this._readProjectID();
		const tmpTests = this._readTestIDs().sort((a, b) => a - b);
		const tmpMaterial = this._readMaterialID();
		const tmpSampleType = this._readSampleType();
		const tmpKey = `${tmpProject}|${tmpTests.join(',')}|${tmpMaterial}|${tmpSampleType}`;
		if (this._LoadedKey === tmpKey && !this._PrimePromise)
		{
			return Promise.resolve();
		}
		if (this._PrimePromise && this._PrimeKey === tmpKey)
		{
			return this._PrimePromise;
		}
		this._PrimeKey = tmpKey;
		const tmpPrime = this._load(tmpProject, tmpTests, tmpMaterial, tmpSampleType, tmpKey)
			.catch((pErr) =>
			{
				this.pict?.log?.warn(`[LabScopeResolver] prime failed (${tmpKey}): ${pErr?.message || pErr}`);
				if (this._PrimeKey === tmpKey)
				{
					this._LoadedKey = tmpKey;
				}
			})
			.finally(() =>
			{
				this._Loaded = true;
				if (this._PrimePromise === tmpPrime)
				{
					this._PrimePromise = null;
				}
			});
		this._PrimePromise = tmpPrime;
		return tmpPrime;
	}

	/**
	 * Whether a prime is still loading — the synchronous getters are answering from the previous key's caches.
	 * @return {boolean}
	 */
	isPriming()
	{
		return !!this._PrimePromise;
	}

	/**
	 * @param {number} pProjectID
	 * @param {Array<number>} pTestIDs
	 * @param {number} pMaterialID
	 * @param {string} pSampleType
	 * @param {string} pKey - the prime key this load answers; its rows are dropped if a newer prime superseded it.
	 * @return {Promise<void>}
	 */
	async _load(pProjectID, pTestIDs, pMaterialID, pSampleType, pKey)
	{
		await this._loadLabCatalog();
		// TestLabJoin rows are active-only: no DateEnd, or one still in the future.
		const tmpActiveTestLabFilter = `FBL~IDTest~INN~${pTestIDs.join(',')}~FOP~0~(~0~FBV~DateEnd~GT~${new Date().toISOString()}~FBVOR~DateEnd~EQ~~FCP~0~)~0`;
		const tmpProjectRead = (pProjectID > 0) ?
			this._readAllPages('ProjectLabJoins/Lite', `FBV~IDProject~EQ~${pProjectID}`) :
			Promise.resolve([]);
		const tmpTestLabRead = (pTestIDs.length > 0) ?
			this._readAllPages('TestLabJoins/Lite', tmpActiveTestLabFilter) :
			Promise.resolve([]);
		const [ tmpProjectRows, tmpTestLabRows, tmpLabDefaultRows ] = await Promise.all([
			tmpProjectRead,
			tmpTestLabRead,
			this._readLabTestDefaults(pTestIDs, pMaterialID, pSampleType),
		]);
		if (this._PrimeKey !== pKey)
		{
			return;
		}
		// ProjectLabJoin names PARENT labs. Normalize through the catalog anyway so a customer that joins a
		// child instead still scopes to the right family. NB: ProjectLabJoin has NO Deleted column — foxhound's
		// automatic soft-delete predicate is schema-driven, so it correctly adds nothing here, and a hand-written
		// Deleted clause would error the read (→ empty → silent fail-open).
		this._ProjectRootLabs = this._rootsOf(this._distinctPositive(tmpProjectRows.map((pRow) => pRow.IDLab)));
		this._TestLabs = this._indexByTest(tmpTestLabRows);
		this._TestLabDefaults = this._indexByTest(tmpLabDefaultRows);
		await this._loadAffinity(pProjectID);
		if (this._PrimeKey === pKey)
		{
			this._LoadedKey = pKey;
		}
	}

	/**
	 * The customer's lab catalog — read in full (not the Lite projection, which emits only `ID*`/`GUID*`
	 * columns and so carries neither the names nor the codes the affinity rules match on). Loaded once per
	 * session: the tree does not move while a form is open.
	 *
	 * The sort clause is also what makes this a legal paged read — meadow-endpoints exposes no bare
	 * `s/:Begin/:Cap`, only `s/FilteredTo/:Filter/:Begin/:Cap`, so a paged read needs a stanza.
	 * @return {Promise<void>}
	 */
	async _loadLabCatalog()
	{
		if (this._LabsLoaded)
		{
			return;
		}
		const tmpRows = await this._readAllPages('Labs', 'FSF~Name~ASC~0');
		this._Labs = new Map();
		this._ChildrenByParent = new Map();
		for (const tmpRow of tmpRows)
		{
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDLab > 0)
			{
				this._Labs.set(tmpIDLab, tmpRow);
			}
		}
		for (const tmpLab of this._Labs.values())
		{
			const tmpIDLab = parseInt(tmpLab.IDLab, 10);
			const tmpParent = parseInt(tmpLab.IDLabParent, 10) || 0;
			if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
			{
				continue;
			}
			let tmpChildren = this._ChildrenByParent.get(tmpParent);
			if (!tmpChildren)
			{
				tmpChildren = new Set();
				this._ChildrenByParent.set(tmpParent, tmpChildren);
			}
			tmpChildren.add(tmpIDLab);
		}
		this._LabsLoaded = true;
	}

	/**
	 * `LabTestDefault` rows for the sample's material and sample type, restricted to the selected tests. Skipped
	 * entirely without a material — the table is keyed on it, and an unrestricted read is tens of thousands of
	 * rows.
	 * @param {Array<number>} pTestIDs @param {number} pMaterialID @param {string} pSampleType
	 * @return {Promise<Array<any>>}
	 */
	_readLabTestDefaults(pTestIDs, pMaterialID, pSampleType)
	{
		if (!(pMaterialID > 0) || pTestIDs.length < 1)
		{
			return Promise.resolve([]);
		}
		const tmpClauses = [ `FBV~IDMaterial~EQ~${pMaterialID}`, `FBL~IDTest~INN~${pTestIDs.join(',')}` ];
		if (pSampleType)
		{
			tmpClauses.push(`FBV~SampleType~EQ~${encodeURIComponent(pSampleType)}`);
		}
		return this._readAllPages('LabTestDefaults/Lite', tmpClauses.join('~'));
	}

	/**
	 * @param {Array<any>} pRows - rows carrying IDTest + IDLab.
	 * @return {Map<string, Set<number>>}
	 */
	_indexByTest(pRows)
	{
		const tmpIndex = new Map();
		for (const tmpRow of pRows)
		{
			const tmpIDTest = (tmpRow.IDTest === null || tmpRow.IDTest === undefined) ? '' : String(tmpRow.IDTest).trim();
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDTest === '' || !(tmpIDLab > 0))
			{
				continue;
			}
			let tmpSet = tmpIndex.get(tmpIDTest);
			if (!tmpSet)
			{
				tmpSet = new Set();
				tmpIndex.set(tmpIDTest, tmpSet);
			}
			tmpSet.add(tmpIDLab);
		}
		return tmpIndex;
	}

	// --- affinity ------------------------------------------------------------------------------------

	/**
	 * Resolve which of the customer's parent labs belong to this project, from the `LabAffinity` rules. Cached
	 * per project. Every step fails open to "no affinity", which costs the pin-to-top ordering and nothing else.
	 * @param {number} pProjectID
	 * @return {Promise<void>}
	 */
	async _loadAffinity(pProjectID)
	{
		if (this._AffinityProjectID === pProjectID)
		{
			return;
		}
		this._AffinityRootIDs = [];
		this._AffinityProjectID = pProjectID;
		const tmpAffinity = this._getConfiguration().LabAffinity;
		if (!tmpAffinity || !Array.isArray(tmpAffinity.Rules) || !(pProjectID > 0))
		{
			return;
		}
		try
		{
			const tmpProject = await this._loadProjectRecord(pProjectID, tmpAffinity);
			const tmpKeys = this._resolveAffinityKeys(tmpAffinity, this._readCustomProperties(tmpProject));
			this._AffinityRootIDs = this._matchAffinityRules(tmpAffinity, tmpKeys);
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[LabScopeResolver] affinity resolve failed (fail-open): ${pError?.message || pError}`);
		}
	}

	/**
	 * The Project record carrying `CustomProperties`. Prefers a record the form already holds (the project
	 * selector's `__Record` companion) over a REST read.
	 * @param {number} pProjectID @param {LabAffinityConfiguration} pAffinity
	 * @return {Promise<Record<string, any>|null>}
	 */
	async _loadProjectRecord(pProjectID, pAffinity)
	{
		if (pAffinity.ProjectRecordAddress)
		{
			const tmpRecord = this.pict.manifest.getValueAtAddress(this.pict, pAffinity.ProjectRecordAddress);
			if (tmpRecord && typeof tmpRecord === 'object' && tmpRecord.CustomProperties)
			{
				return tmpRecord;
			}
		}
		return this._getJSON(`Project/${pProjectID}`);
	}

	/**
	 * `CustomProperties` as an object, whether it arrives parsed or as a JSON string.
	 * @param {Record<string, any>|null} pProject
	 * @return {Record<string, any>}
	 */
	_readCustomProperties(pProject)
	{
		const tmpRaw = pProject ? pProject.CustomProperties : null;
		if (!tmpRaw)
		{
			return {};
		}
		if (typeof tmpRaw !== 'string')
		{
			return tmpRaw;
		}
		try
		{
			return JSON.parse(tmpRaw) || {};
		}
		catch (pError)
		{
			return {};
		}
	}

	/**
	 * Resolve each configured affinity key to its first non-empty project value. A value that is all digits and
	 * numerically zero is the customer's "unassigned" sentinel and counts as unset.
	 * @param {LabAffinityConfiguration} pAffinity @param {Record<string, any>} pProperties
	 * @return {Record<string, string>}
	 */
	_resolveAffinityKeys(pAffinity, pProperties)
	{
		/** @type {Record<string, string>} */
		const tmpKeys = {};
		const tmpProjectKeys = pAffinity.ProjectKeys || {};
		for (const tmpName of Object.keys(tmpProjectKeys))
		{
			const tmpCandidates = Array.isArray(tmpProjectKeys[tmpName]) ? tmpProjectKeys[tmpName] : [ tmpProjectKeys[tmpName] ];
			for (const tmpCandidate of tmpCandidates)
			{
				const tmpRaw = pProperties[tmpCandidate];
				const tmpValue = (tmpRaw === null || tmpRaw === undefined) ? '' : String(tmpRaw).trim();
				if (tmpValue === '' || (/^\d+$/.test(tmpValue) && Number(tmpValue) === 0))
				{
					continue;
				}
				tmpKeys[tmpName] = tmpValue;
				break;
			}
		}
		return tmpKeys;
	}

	/**
	 * The parent labs matched by the affinity rules, in rule order (which is the pin priority order).
	 * @param {LabAffinityConfiguration} pAffinity @param {Record<string, string>} pKeys
	 * @return {Array<number>}
	 */
	_matchAffinityRules(pAffinity, pKeys)
	{
		const tmpMatched = [];
		for (const tmpRule of pAffinity.Rules)
		{
			if (!tmpRule || !tmpRule.LabField || !tmpRule.Pattern)
			{
				continue;
			}
			const tmpRequires = Array.isArray(tmpRule.Requires) ? tmpRule.Requires : Object.keys(pKeys);
			if (tmpRequires.some((pRequired) => !pKeys[pRequired]))
			{
				continue;
			}
			let tmpExpression;
			try
			{
				tmpExpression = new RegExp(this._interpolatePattern(tmpRule.Pattern, pKeys), tmpRule.Flags || 'i');
			}
			catch (pError)
			{
				this.pict?.log?.warn(`[LabScopeResolver] LabAffinity rule pattern is not a valid expression: ${tmpRule.Pattern}`);
				continue;
			}
			for (const tmpLab of this._Labs.values())
			{
				const tmpIDLab = parseInt(tmpLab.IDLab, 10);
				// Affinity names the routing destination, so only parents are matched; children inherit.
				if (this.getParentLabID(tmpIDLab) !== tmpIDLab || tmpMatched.indexOf(tmpIDLab) > -1)
				{
					continue;
				}
				if (tmpExpression.test(String(tmpLab[tmpRule.LabField] === null || tmpLab[tmpRule.LabField] === undefined ? '' : tmpLab[tmpRule.LabField])))
				{
					tmpMatched.push(tmpIDLab);
				}
			}
		}
		return tmpMatched;
	}

	/**
	 * Fill `{KeyName}` placeholders in a rule pattern. An all-digits value interpolates as `0*<digits>` with
	 * leading zeros stripped, so one pattern matches both `District 02 Lab` and `District 2 Lab` and the
	 * customer's project metadata does not have to agree with its lab names on zero-padding. Anything else is
	 * escaped and matched literally.
	 * @param {string} pPattern @param {Record<string, string>} pKeys
	 * @return {string}
	 */
	_interpolatePattern(pPattern, pKeys)
	{
		return String(pPattern).replace(/\{([A-Za-z0-9_]+)\}/g, (pMatch, pName) =>
		{
			const tmpValue = pKeys[pName];
			if (tmpValue === undefined)
			{
				return pMatch;
			}
			if (/^\d+$/.test(tmpValue))
			{
				return `0*${String(Number(tmpValue))}`;
			}
			return tmpValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		});
	}

	// --- plumbing ------------------------------------------------------------------------------------

	/**
	 * App-load hook — prime from the loaded form. PictProvider defaults AutoLoadDataWithApp true.
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			this.primeFromForm().catch(() =>
			{
				// Priming already logs its own failure and marks itself loaded (fail-open); nothing to add here.
			}).finally(() =>
			{
				fCallback();
			});
		});
	}

	/**
	 * @param {string} pEntityRoute - pluralized route incl. projection, e.g. 'TestLabJoins/Lite'.
	 * @param {string} pFilter - meadow filter stanza.
	 * @return {Promise<Array<any>>}
	 */
	async _readAllPages(pEntityRoute, pFilter)
	{
		const tmpRows = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpPage = await this._getJSON(`${pEntityRoute}/FilteredTo/${pFilter}/${tmpOffset}/${LAB_PAGE_SIZE}`);
			if (!Array.isArray(tmpPage) || tmpPage.length === 0)
			{
				break;
			}
			for (const tmpRow of tmpPage)
			{
				tmpRows.push(tmpRow);
			}
			if (tmpPage.length < LAB_PAGE_SIZE)
			{
				break;
			}
			tmpOffset += LAB_PAGE_SIZE;
		}
		return tmpRows;
	}

	/**
	 * @param {Array<any>} pValues
	 * @return {Array<number>}
	 */
	_distinctPositive(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of pValues)
		{
			const tmpNumber = parseInt(tmpValue, 10);
			if (tmpNumber > 0)
			{
				tmpSet.add(tmpNumber);
			}
		}
		return Array.from(tmpSet);
	}

	/**
	 * @param {string} pUrl
	 * @return {Promise<any>}
	 */
	_getJSON(pUrl)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pUrl, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = LabScopeResolver;

},{"pict-provider":479}],123:[function(require,module,exports){
const PictProvider = require('pict-provider');

class MediaRegistryProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.OrphanObservationList = [];
		this.DefectObservationMap = {};
		this.BridgeElementSectionMap = {};
		this.BridgeElementSectionList = [];
		// Document observations load once per page; explicit refreshes re-read them.
		this._documentObservationsLoaded = false;
		/** @type {Promise<void>|null} the in-flight server refresh, shared by concurrent callers */
		this._documentObservationsRefresh = null;

		/**
		* @type {import('pict') & import('fable') &
		* {
		*   HeadlightRestClient: import('headlight-rest-client'),
		* }}
		*/
		this.pict;
		/** @type {import('log')} */
		this.pict.log;
		/** @type {import('fable')} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {any} */
		this.AppData;

		this.AppData.MediaRegistryStore = this.AppData.DocumentData?.ReportData?.FormData?.MediaRegistryStore || { NamespaceObservationSetMap: {}, Namespaces: {} };
	}

	/**
	 * Updates the AppData Registry to match the FormData Registry.
	 */
	updateRegistryFromFormData()
	{
		this.AppData.MediaRegistryStore = this.AppData.DocumentData?.ReportData?.FormData?.MediaRegistryStore || { NamespaceObservationSetMap: {}, Namespaces: {} };
	}

	/**
	 * Updates the FormData Registry to match the AppData Registry.
	 */
	_updateFormDataRegistry()
	{
		if (!this.AppData.DocumentData?.ReportData?.FormData)
		{
			return;
		}
		this.AppData.DocumentData.ReportData.FormData.MediaRegistryStore = this.AppData.MediaRegistryStore;
	}

	/**
	 * Adds a set of observations to the media registry. Preserves any existing ordinals.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Array} observations - the observations to register.
	 */
	registerMediaSet(namespace, observations)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		if (!observations)
		{
			this.pict.log.error('No observations provided to media registry provider, returning early.');
			return;
		}

		// If the namespace is not already in the registry, add it.
		if (!this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
		}

		for (const o of observations)
		{
			if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation])
			{
				// Add an entry for the observation under the correct namespace.
				this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation] =
				{
					IDObservation: o.IDObservation,
					ObservationType: o.ObservationType,
					CreateDate: o.CreateDate,
				};
			}
			else if (o.Ordinal)
			{
				this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal = o.Ordinal;
			}
		}

		// Clear out any "old" keys that should no longer be present in the set.
		const newIDs = observations.map((o) => o.IDObservation);
		for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
		{
			if (!newIDs.includes(parseInt(id)))
			{
				delete this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id];
			}
		}

		// Update the ordinals so that any observation without an ordinal gets one.
		this._updateOrdinalsForNamespace(namespace);

		// Save the changes to the form data.
		this._updateFormDataRegistry();

		return this._getFullConstructedRegistrySetFromArray(namespace, observations);
	}

	/**
	 * Adds a set of observation ids to the media registry. Preserves any existing ordinals.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Array} observationIDs - the IDs of the observations to register.
	 */
	async registerMediaSetByIDList(namespace, observationIDs)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		if (!observationIDs)
		{
			this.pict.log.error('No observations provided to media registry provider, returning early.');
			return;
		}
		try
		{
			return this.registerMediaSet(namespace, await this.pict.providers.ObservationProvider.getObservationByIDList(observationIDs));
		}
		catch (err)
		{
			this.pict.log.error('Error fetching Observations: ', err.message);
		}
	}

	/**
	 * Adds an observation set to the media registry using its id to look up the observations. Preserves any existing ordinals.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Number} IDObservationSet - the ID of the observation set to register.
	 */
	async registerMediaSetByIDObservationSet(namespace, IDObservationSet)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		if (!IDObservationSet)
		{
			this.pict.log.error('No IDObservationSet provided to media registry provider, clearing namespace and returning early.');
			this.clearNamespace(namespace);
			return;
		}
		try
		{
			this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace] = IDObservationSet;
			return this.registerMediaSet(namespace, await this.pict.providers.ObservationSetProvider.loadSetObservations(IDObservationSet));
		}
		catch (err)
		{
			this.pict.log.error('Error fetching Observations: ', err.message);
		}
	}

	/**
	 * Updates the registry copies of any namespaces attached to a specific observation set id.
	 * @param {Number} IDObservationSet - The id of the observation set we are updating namespaces for.
	 * @param {Array} [observations] - Optional, can pass a set of observations if we already have them to prevent needing to look them up with a network call.
	 */
	async updateNamespacesByIDObservationSet(IDObservationSet, observations)
	{
		if (!IDObservationSet)
		{
			this.pict.log.error('No IDObservationSet provided to media registry provider, returning early.');
			return;
		}
		let observationList = observations || [];
		if (!observations)
		{
			try
			{
				observationList = await this.pict.providers.ObservationSetProvider.loadSetObservations(IDObservationSet);
			}
			catch (err)
			{
				this.pict.log('Error fetching observation set: ', err.message);
				return;
			}
		}
		for (const namespace of Object.keys(this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap))
		{
			if (this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace] == IDObservationSet)
			{
				return this.registerMediaSet(namespace, observationList);
			}
		}
	}

	/**
	 * Clears any registry data from this namespace.
	 * @param {String} namespace - namespace we are clearing out.
	 */
	async clearNamespace(namespace)
	{
		if (this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
		}
		if (this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace])
		{
			delete this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace];
		}
	}

	/**
	 * Adds a new single observation to a registry under a namespace.
	 * @param {String} namespace - namespace of the observation.
	 * @param {Object} observation - the observation to add to the namespace.
	 *
	 * @returns {Object} The registry entry that was created, or the existing one if it is already present.
	 */
	_addRegistryEntry(namespace, observation)
	{
		// If this observation is already registered, return the existing entry.
		if (this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace]?.[observation.IDObservation])
		{
			return this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace]?.[observation.IDObservation];
		}
		// If the namespace is not already in the registry, add it.
		if (!this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
		}

		// Add an entry for the observation under the correct namespace.
		this.pict.AppData.MediaRegistryStore.Namespaces[namespace][observation.IDObservation] =
		{
			IDObservation: observation.IDObservation,
			ObservationType: observation.ObservationType,
			CreateDate: observation.CreateDate,
		};

		// Update the ordinals so that any observation without an ordinal gets one.
		this._updateOrdinalsForNamespace(namespace);

		// Save the change to the form data.
		this._updateFormDataRegistry();

		return this.pict.AppData.MediaRegistryStore.Namespaces[namespace][observation.IDObservation];
	}

	/**
	 * Adds a new single observation to a registry under a namespace.
	 * @param {String} namespace  - namespace of the observation.
	 * @param {Number} IDObservation - the ID of the observation being added.
	 *
	 * @returns {Promise<Object>} The registry entry that was created, or the existing one if it is already present.
	 */
	async _addRegistryEntryByID(namespace, IDObservation)
	{
		try
		{
			return this._addRegistryEntry(namespace, await this.pict.providers.ObservationProvider.getObservationByID(IDObservation));
		}
		catch (err)
		{
			this.pict.log.error('Error fetching observation: ', err.message);
			return {};
		}
	}

	/**
	 * Updates the ordinals of any observations within a namespace with no ordinals (preserves existing ordinals).
	 * @param {String} namespace - namespace of the observations.
	 */
	_updateOrdinalsForNamespace(namespace)
	{
		// Get the observation array presorted by Ordinal and CreateDate.
		const observationArray = this._getConstructedRegistrySet(namespace);
		const maxOrdinalsByType = {};
		for (const o of observationArray)
		{
			if (!o.Ordinal)
			{
				if (!maxOrdinalsByType[o.ObservationType])
				{
					o.Ordinal = 1;
				}
				else
				{
					o.Ordinal = maxOrdinalsByType[o.ObservationType] + 1;
				}
				this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal = o.Ordinal;
			}
			maxOrdinalsByType[o.ObservationType] = o.Ordinal;
		}
	}

	/**
	 * Turns the object structured in the registry for a namespace into a sorted array and returns it.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Array} The sorted array of Observations.
	 */
	_getConstructedRegistrySet(namespace)
	{
		if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
			return [];
		}
		const observationArr = [];
		for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
		{
			observationArr.push(this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id]);
		}
		return observationArr.sort((a, b) =>
		{
			// Sort first based on ordinal.
			if (a.Ordinal < b.Ordinal)
			{
				return -1;
			}
			if (b.Ordinal < a.Ordinal)
			{
				return 1;
			}
			// If one doesn't have an ordinal, prefer the one that does.
			if (a.Ordinal && !b.Ordinal)
			{
				return -1;
			}
			if (!a.Ordinal && b.Ordinal)
			{
				return 1;
			}
			// Sort whatever's left based on date.
			return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
		});
	}

	/**
	 * Turns the object structured in the registry for a namespace into a sorted array and returns it. Also fetches the full observations and decorates them with the registry values.
	 * This is the non async version that can be called when you already have the observations array.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Array} observations - if we already have the observations, we don't need to fetch them again so they are passed into this method.
	 *
	 * @returns {Array} The sorted array of Observations.
	 */
	_getFullConstructedRegistrySetFromArray(namespace, observations)
	{
		if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
			return [];
		}
		const observationArr = [];
		const fullObservations = observations;
		if (!fullObservations)
		{
			this.pict.log.error('No Observations fetched as yet, returning just what is in registry.');
			for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
			{
				observationArr.push(this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id]);
			}
		}
		else
		{
			for (const o of fullObservations)
			{
				o.Ordinal = this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal;
				observationArr.push(o);
			}
		}

		return observationArr.sort((a, b) =>
		{
			// Sort first based on ordinal.
			if (a.Ordinal < b.Ordinal)
			{
				return -1;
			}
			if (b.Ordinal < a.Ordinal)
			{
				return 1;
			}
			// If one doesn't have an ordinal, prefer the one that does.
			if (a.Ordinal && !b.Ordinal)
			{
				return -1;
			}
			if (!a.Ordinal && b.Ordinal)
			{
				return 1;
			}
			// Sort whatever's left based on date.
			return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
		});
	}

	/**
	 * Turns the object structured in the registry for a namespace into a sorted array and returns it. Also fetches the full observations and decorates them with the registry values.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Promise<Array>} The sorted array of Observations.
	 */
	async _getFullConstructedRegistrySet(namespace)
	{
		if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
			return [];
		}
		const observationArr = [];
		try
		{
			const fullObservations = await this.pict.providers.ObservationProvider.getObservationByIDList(Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]) || []);
			for (const o of fullObservations)
			{
				o.Ordinal = this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal;
				observationArr.push(o);
			}
		}
		catch (err)
		{
			this.pict.log.error('Error fetching full observations, returning just what is in registry.', err.message);
			for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
			{
				observationArr.push(this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id]);
			}
		}

		return observationArr.sort((a, b) =>
		{
			// Sort first based on ordinal.
			if (a.Ordinal < b.Ordinal)
			{
				return -1;
			}
			if (b.Ordinal < a.Ordinal)
			{
				return 1;
			}
			// If one doesn't have an ordinal, prefer the one that does.
			if (a.Ordinal && !b.Ordinal)
			{
				return -1;
			}
			if (!a.Ordinal && b.Ordinal)
			{
				return 1;
			}
			// Sort whatever's left based on date.
			return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
		});
	}

	/**
	 * Fetches an entry from the media registry using its namespace and id.
	 * @param {String} namespace - namespace to look for the observation in.
	 * @param {Number} IDObservation - the observation we are looking up.
	 *
	 * @returns {Object} The matching registry entry.
	 */
	_getRegistryEntry(namespace, IDObservation)
	{
		return this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace]?.[IDObservation] || {};
	}

	/**
	 * Retrieves the ordinal that should be assigned to an observation within a given namespace. Will generate one if the registry entry does not exist.
	 * @param {String} namespace - namespace of the observation.
	 * @param {Number} IDObservation - the ID of the observation we are checking the ordinal of.
	 *
	 * @returns {Promise<Number>} The ordinal for the observation.
	 */
	async getOrdinal(namespace, IDObservation)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		const entry = this._getRegistryEntry(namespace, IDObservation);
		if (entry.Ordinal)
		{
			return entry.Ordinal;
		}
		const newEntry = await this._addRegistryEntryByID(namespace, IDObservation);
		return newEntry.Ordinal;
	}

	/**
	 * Returns the array of observations that are part of this set with the additional registry fields (like ordinal) decorated on them.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Promise<Array>} The array of observations that are part of this set with the additional registry fields (like ordinal) decorated on them.
	 */
	async getMediaSet(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}

		return await this._getFullConstructedRegistrySet(namespace);
	}

	/**
	 * Returns the id of the observation set attached to a namespace (if one exists).
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Number} The IDObservationSet for the given namespace.
	 */
	getObservationSetIDByNamespace(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		return this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace];
	}

	/**
	 * Returns the array of observations in the observation set attached to a namespace (if one exists). It will be decorated with fields from the registry and be sorted by ordinal.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Promise<Array>} The full Observation Set for the given namespace.
	 */
	async getObservationSetByNamespace(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		const IDObservationSet = this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace];
		if (!IDObservationSet)
		{
			this.pict.log.warn('No ObservationSet is registered to this namespace.');
			return [];
		}
		await this.registerMediaSetByIDObservationSet(namespace, IDObservationSet);
		return await this.getMediaSet(namespace);
	}

	/**
	 * Method for refreshing the registry namespace for the 'global' set of photos on a document.
	 * @param {Array} [pObservations] - optional, if we already have the observations we can pass them in to avoid an unnecessary network call to fetch them again (or to avoid using a cached set)
	 */
	async refreshDocumentObservations(pObservations)
	{
		if (pObservations)
		{
			// When observations are passed directly (as full objects), register them
			// without re-fetching from the API — they are already the latest state.
			this.registerMediaSet('DocumentObservations', pObservations);
			this._documentObservationsLoaded = true;
			return;
		}
		// Single-flight: several card decks marshaling at once share one document read.
		if (this._documentObservationsRefresh)
		{
			return this._documentObservationsRefresh;
		}
		this._documentObservationsRefresh = (async () =>
		{
			try
			{
				const documentRecord = await this.pict.providers.DocumentProvider.getDocument(this.AppData.DocumentData.ReportData.IDDocument);
				await this.registerMediaSetByIDList('DocumentObservations', documentRecord.Observations);
			}
			catch (err)
			{
				this.pict.log.error('Error fetching document record, will default to observations listed on the local document: ', err.message);
				this.registerMediaSet('DocumentObservations', this.AppData.DocumentData.ReportData.Observations);
			}
			this._documentObservationsLoaded = true;
		})().finally(() =>
		{
			this._documentObservationsRefresh = null;
		});
		return this._documentObservationsRefresh;
	}

	/**
	 * Load the document's observation set once. The loaded document already carries the full
	 * observation objects, so no request is needed; the server is only read when the document
	 * holds bare ids. Call refreshDocumentObservations to re-read after a change.
	 * @return {Promise<void>}
	 */
	primeDocumentObservations()
	{
		if (this._documentObservationsLoaded)
		{
			return Promise.resolve();
		}
		const tmpLocalObservations = this.AppData.DocumentData?.ReportData?.Observations;
		if (Array.isArray(tmpLocalObservations) && tmpLocalObservations.every((o) => o && (typeof o === 'object') && ('IDObservation' in o)))
		{
			return this.refreshDocumentObservations(tmpLocalObservations);
		}
		return this.refreshDocumentObservations();
	}

	/**
	 * Method that returns the 'global' set of photos on a document decorated with any fields from the registry.
	 * Loads the set on first use; mutation paths refresh it explicitly.
	 */
	async getDocumentObservations()
	{
		await this.primeDocumentObservations();
		return this.getMediaSet('DocumentObservations');
	}

	/**
	 * Method that returns the 'global' set of photos on a document decorated with any fields from the registry, excluding any that are already included in any of the namespaces attached to observation sets (like card decks that are using observation sets.)
	 * This is useful for when you want to show the user all of the photos on a document that are not already being used in a specific way on the form.
	 * @param {Array<string>} [pNamespacesToExclude] - Optional array of specific namespaces to exclude from. When provided, only observations in these namespaces are excluded. When omitted, all namespaces in NamespaceObservationSetMap are used.
	 */
	async getDocumentObservationsExcludingCurrentSets(pNamespacesToExclude)
	{
		await this.primeDocumentObservations();
		const documentObservations = await this.getMediaSet('DocumentObservations');
		const currentSetObservationIDs = new Set();
		const namespacesToCheck = pNamespacesToExclude || Object.keys(this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap);
		for (const namespace of namespacesToCheck)
		{
			const setObservations = await this.getMediaSet(namespace);
			for (const o of setObservations)
			{
				currentSetObservationIDs.add(o.IDObservation);
			}
		}
		return documentObservations.filter((o) => !currentSetObservationIDs.has(o.IDObservation));
	}

	/**
	 * Returns the array of observations that are part of this set with just the decorated registry fields (does not fetch the full observations.)
	 * @param {String} namespace - namespace of the observations.
	 * @returns {Array} The array of observations that are part of this set with only the registry fields (like ordinal) on them.
	*/
	getMediaSetPartial(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		return this._getConstructedRegistrySet(namespace);
	}
}

module.exports = MediaRegistryProvider;

},{"pict-provider":479}],124:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * NumberScrollLock - Prevents mouse wheel events from incrementing/decrementing
 * the value of number inputs. This is enabled by default for all Number and
 * PreciseNumber inputs to avoid accidental value changes while scrolling.
 *
 * To re-enable mouse wheel scrolling on a specific input, set the following
 * in the PictForm configuration for that input:
 *
 *   "AllowMouseWheelScroll": true
 */
class NumberScrollLock extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Attach a wheel event listener to the input element that prevents
	 * scroll-based value changes while the input is focused.
	 *
	 * @param {HTMLInputElement} pElement - The input element to protect.
	 */
	attachScrollLock(pElement)
	{
		if (!pElement) return;

		pElement.addEventListener('wheel', (pEvent) =>
		{
			// Only prevent the default behavior when the input is focused,
			// so that normal page scrolling is unaffected when the input
			// is not active.
			if (document.activeElement === pElement)
			{
				pEvent.preventDefault();
			}
		}, { passive: false });
	}

	/**
	 * Called when a standard (non-tabular) input is initialized.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pRow - The row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector for the input.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Allow opting back in to wheel scroll via PictForm config
		if (pInput?.PictForm?.AllowMouseWheelScroll)
		{
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}

		const tmpElement = this.pict.ContentAssignment.getElement(pHTMLSelector)?.[0];
		this.attachScrollLock(tmpElement);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Called when a tabular input is initialized.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector for the input.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// Allow opting back in to wheel scroll via PictForm config
		if (pInput?.PictForm?.AllowMouseWheelScroll)
		{
			return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}

		// Append the row-specific data attribute to the base selector.
		// The base pHTMLSelector does not include the row index, so we
		// match the pattern used by the view's dataChangedTabular flow.
		const tmpRowSelector = pHTMLSelector + `[data-i-index="${pRowIndex}"]`;
		const tmpElement = this.pict.ContentAssignment.getElement(tmpRowSelector)?.[0];
		this.attachScrollLock(tmpElement);

		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = NumberScrollLock;

},{"pict-section-form":497}],125:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const marked = require('marked');

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Converts markdown content to HTML.
	 * @param {string} pValue - The markdown content.
	 * @return {string} - The HTML content.
	 */
	convertMarkdownToQRCodeImage(pValue)
	{
		let tmpContent = '';
		if (pValue)
		{
			tmpContent = marked.parse(pValue, { async: false });
		}
		return tmpContent;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.convertMarkdownToQRCodeImage(pValue);
		this.pict.ContentAssignment.assignContent('#' + pInput.Macro.RawHTMLID, tmpContent);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.convertMarkdownToQRCodeImage(pValue);
		this.pict.ContentAssignment.assignContent(('#' + pInput.Macro.RawHTMLID + '-' + pRowIndex), tmpContent);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"marked":442,"pict-section-form":497}],126:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ResponsiveUIAdjustmentProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		this.defaultColumnCount = 12;
		// NOTE: The default column count is set to 12, which is the standard for Bulma CSS framework.
		// This can be adjusted based on the application's requirements, but Bulma supports up to 12 columns by default, so we'll need to expand the Bulma styling collection if we want to support more than that.
		this.activeColumnCount = this.defaultColumnCount;
	}

	/**
	 * Set the active column count for responsive UI adjustments
	 * @param {Number} pColumnCount - The number of columns to set
	 * @return {Number} - The active column count after setting
	 */
	setActiveColumnCount(pColumnCount)
	{
		if (typeof pColumnCount !== 'number' || pColumnCount <= 0)
		{
			this.pict.log.error('Invalid column count provided.');
			throw new Error('Invalid column count provided.');
		}
		// if the column count is greater than the default, we need to adjust it to the default until we can expand the Bulma styling collection
		if (pColumnCount > this.defaultColumnCount)
		{
			this.pict.log.warn(`Requested column count ${pColumnCount} exceeds default column count ${this.defaultColumnCount}. Adjusting to default.`);
			this.pict.log.warn(`DEVELOPER NOTE: Bulma styling collection will need to be expanded to support more than ${this.defaultColumnCount} columns.`);
			pColumnCount = this.defaultColumnCount;
		}
		this.activeColumnCount = pColumnCount;
		return this.activeColumnCount;
	}

	/**
	 * Get the current active column count for responsive UI adjustments
	 * @return {Number} - The current active column count
	 */
	getActiveColumnCount()
	{
		return this.activeColumnCount;
	}

	/**
	 * Reset the active column count to the default value
	 * @return {Number} - The active column count after reset
	 */
	resetActiveColumnCount()
	{
		this.activeColumnCount = this.defaultColumnCount;
		return this.activeColumnCount;
	}

	/**
	 * Determine whether a column should be excluded from the row layout math.
	 *
	 * An excluded column is layout-neutral: it is dropped from every width sum / normalization
	 * so the remaining visible columns fill the row as if it were not present, and the
	 * {~ColumnWidth:~} macro renders it taking no horizontal space.
	 *
	 * A column is excluded when ANY of:
	 *   - its PictForm.Width is explicitly zero (parseFloat === 0) — the deliberate "no space" signal,
	 *   - it is a hidden input type (InputType === 'Hidden' or starting with 'MaterialsHidden'), OR
	 *   - it carries a truthy PictForm.Hidden flag (the Materials input types honor this to hide a field).
	 *
	 * A column with NO Width set (undefined/null/'') is NOT excluded on the width axis — it is a
	 * normal visible column that defaults to a width of 1 elsewhere. Only an explicit zero counts.
	 *
	 * @param {Object} pColumn - The column descriptor to test
	 * @return {Boolean} - Returns true when the column should not occupy layout space
	 */
	isLayoutExcludedColumn(pColumn)
	{
		if (!pColumn || !pColumn.PictForm)
		{
			return false;
		}
		const tmpInputType = pColumn.PictForm.InputType;
		if (typeof tmpInputType === 'string' && (tmpInputType === 'Hidden' || tmpInputType.startsWith('MaterialsHidden')))
		{
			return true;
		}
		// The Materials input types honor an explicit PictForm.Hidden flag to hide a field; treat it as layout-excluded too.
		if (pColumn.PictForm.Hidden)
		{
			return true;
		}
		// Distinguish an explicit zero Width (excluded) from an unset Width (a normal, visible un-widthed column).
		const tmpWidth = pColumn.PictForm.Width;
		if (tmpWidth !== undefined && tmpWidth !== null && tmpWidth !== '' && parseFloat(tmpWidth) === 0)
		{
			return true;
		}
		return false;
	}

	/**
	 * Check if all columns in the row have an empty or undefined PictForm.Width
	 * @param {Object[]} pRowObject - The Pict row object containing columns to check
	 * @return {Boolean} - Returns true if all columns have an empty or undefined PictForm.Width
	 */
	checkRowObjectForAllEmptyWidths(pRowObject)
	{
		// check if all columns in the row have an empty or undefined PictForm.Width
		const allEmpty = pRowObject.every((column) => !column.PictForm || !column.PictForm.Width);
		if (allEmpty)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info('Row has no columns with a PictForm.Width set. Assuming Bulma classes are already balanced.');
			}
			return true;
		}
		// if any column has a PictForm.Width set, we need to check for balance with Bulma classes
		return false;
	}

	/**
	 * Check if the row has any columns with a PictForm.Width set and if they exceed the active column count
	 * @param {Object[]} pRowObject - The Pict row object containing columns to check
	 * @return {Boolean} - Returns true if the row has columns exceeding the active column count, false otherwise
	 */
	checkForOvercrowdingInRow(pRowObject)
	{
		// Check if the row has any columns with a PictForm.Width set and if they exceed the active column count
		// Layout-excluded columns (explicit zero width / hidden inputs) take no space, so they are not counted.
		const totalWidth = pRowObject.reduce((acc, column) =>
		{
			if (this.isLayoutExcludedColumn(column))
			{
				return acc;
			}
			return acc + (column.PictForm.Width ? parseFloat(column.PictForm.Width) : 1);
		}, 0);
		if (totalWidth > this.activeColumnCount)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.warn(`Row columns exceed active column count of ${this.activeColumnCount}. Will adjust columns accordingly.`);
			}
			return true;
		}
		return false;
	}

	/**
	 * Check if the row has any columns with a PictForm.Width set and if they add up to the active column count
	 * @param {Object[]} pRowObject - The Pict row object containing columns to check
	 * @return {Boolean} - Returns true if the row is balanced with Bulma classes, false otherwise
	 */
	checkForBalancedRowsWithBulmaClasses(pRowObject)
	{
		// first, we need to check if the row has any columns with a PictForm.Width set (ignoring layout-excluded columns)
		const hasWidths = pRowObject.some((column) => column.PictForm && column.PictForm.Width && !this.isLayoutExcludedColumn(column));
		if (!hasWidths)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info('Row does not have any columns with a PictForm.Width set. Assuming Bulma classes are already balanced.');
			}
			return true;
		}
		// next, we need to check if the total widths and the width offsets of the columns add up to the active column count
		// Layout-excluded columns (explicit zero width / hidden inputs) take no space, so they are not counted.
		const totalWidth = pRowObject.reduce((acc, column) =>
		{
			if (this.isLayoutExcludedColumn(column))
			{
				return acc;
			}
			return acc + (column.PictForm.Width ? parseFloat(column.PictForm.Width) : 1);
		}, 0);
		const totalOffset = pRowObject.reduce((acc, column) =>
		{
			if (this.isLayoutExcludedColumn(column))
			{
				return acc;
			}
			return acc + (column.PictForm.WidthOffset ? parseFloat(column.PictForm.WidthOffset) : 0);
		}, 0);
		if (totalWidth + totalOffset === this.activeColumnCount)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info(`Row columns add up to the active column count of ${this.activeColumnCount}. Assuming Bulma classes are already balanced.`);
			}
			return true;
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.pict.log.warn(`Row columns do not add up to the active column count of ${this.activeColumnCount}. Will adjust columns accordingly.`);
		}
		return false;
	}

	/**
	 * Balance the columns in the row with Bulma classes based on their widths
	 * @param {Object[]} pRowObject - The Pict row object containing columns to balance
	 * @return {Object[]} - The modified row object with Bulma classes applied
	 */
	balanceRowsWithBulmaClasses(pRowObject)
	{
		pRowObject.forEach((column) =>
		{
			// A layout-excluded column must never emit is-0 (invalid Bulma); mark it so the macro renders no width.
			if (this.isLayoutExcludedColumn(column))
			{
				column.PictForm._LayoutExcluded = true;
				return;
			}
			column.PictForm._BulmaColumnClasses = `is-${column.PictForm.Width}`;
			// if the column has a WidthOffset, we need to add that to the Bulma classes as well for the column offset
			if (column.PictForm.WidthOffset)
			{
				column.PictForm._BulmaColumnClasses += ` is-offset-${column.PictForm.WidthOffset}`;
			}
		});
		return pRowObject;
	}

	/**
	 * Balance the columns for a given row based on the active column count
	 * @param {Object} pRowObject - The Pict row object containing columns to balance
	 */
	balanceRowsWithCalculatedWidthPercentages(pRowObject)
	{
		const expectedColumnWidths = {};
		// first: get all the set Width values for each column in the row so what we know what the expected widths are.
		// Layout-excluded columns (explicit zero width / hidden inputs) take no space, so they contribute a width of 0.
		for (let i = 0; i < pRowObject.length; i++)
		{
			if (this.isLayoutExcludedColumn(pRowObject[i]))
			{
				expectedColumnWidths[i] = '0';
			}
			else
			{
				expectedColumnWidths[i] = pRowObject[i]?.PictForm?.Width || '1';
			}
		}
		// next: for each expected width, we need to adjust the column width based on the active column count
		const totalColumnCount = Object.keys(expectedColumnWidths).length;
		const minimumColumnPercentage = (1 / this.activeColumnCount * 100);
		// the sum of all visible widths is constant for the row; an all-excluded row sums to 0 (guard against divide-by-zero).
		const sumOfWidths = Object.values(expectedColumnWidths).reduce((acc, width) => acc + parseFloat(width), 0);
		// if the total column count is less than the active column count, we need to adjust the widths accordingly
		for (let i = 0; i < totalColumnCount; i++)
		{
			const column = pRowObject[i];
			// An excluded column must never emit is-0 (invalid Bulma) or steal a minimum-width slot; mark it for no-space render.
			if (this.isLayoutExcludedColumn(column))
			{
				column.PictForm._LayoutExcluded = true;
				continue;
			}
			if (sumOfWidths <= 0)
			{
				continue;
			}
			column.PictForm._AdjustedWidthPercentage = (parseFloat(expectedColumnWidths[i]) / sumOfWidths * 100);
			// if the adjusted width percentage is less than the minimum, we need to set it to the minimum
			if (column.PictForm._AdjustedWidthPercentage < minimumColumnPercentage)
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.pict.log.warn(`Column ${column.PictForm.Name} has an adjusted width percentage of ${column.PictForm._AdjustedWidthPercentage}%, which is less than the minimum of ${minimumColumnPercentage}%. Adjusting to minimum.`);
				}
				column.PictForm._AdjustedWidthPercentage = minimumColumnPercentage;
			}
		}
		// Return the modified row
		return pRowObject;
	}

	/**
	 * Map all rows by their sections and adjust the columns based on the active column count
	 * @return {Boolean} - Returns true if the mapping was successful
	 */
	mapAllRowsBySections(pDescriptors, pSections)
	{
		if (!pDescriptors || typeof pDescriptors !== 'object')
		{
			this.pict.log.error('Invalid descriptors provided for mapping rows by sections.');
			throw new Error('Invalid descriptors provided for mapping rows by sections.');
		}
		const tmpColumns = pDescriptors;
		// map the column by their Section and Row
		const tmpRowsBySection = {};
		Object.values(tmpColumns).forEach((column) =>
		{
			if (!column.PictForm || !column.PictForm.Section)
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.pict.log.warn(`Column ${column.Name} does not have a valid Section defined. Skipping.`);
				}
				return;
			}
			const tmpRowOrdinal = column.PictForm.Row || '1'; // default to row 1 if not defined
			// Objects, not arrays: rows are keyed by Row as written ("1.5", "8.0"), which are not array indexes.
			if (!tmpRowsBySection[column.PictForm.Section])
			{
				tmpRowsBySection[column.PictForm.Section] = {};
			}
			if (!tmpRowsBySection[column.PictForm.Section][column.PictForm.Group])
			{
				tmpRowsBySection[column.PictForm.Section][column.PictForm.Group] = {};
			}
			if (!tmpRowsBySection[column.PictForm.Section][column.PictForm.Group][tmpRowOrdinal])
			{
				tmpRowsBySection[column.PictForm.Section][column.PictForm.Group][tmpRowOrdinal] = [];
			}
			tmpRowsBySection[column.PictForm.Section][column.PictForm.Group][tmpRowOrdinal].push(column);
		});
		// now we need to adjust the columns for each row based on the active column count
		for (const section in tmpRowsBySection)
		{
			if (Object.prototype.hasOwnProperty.call(tmpRowsBySection, section))
			{
				// now we need to iterate over each row in the section and adjust the columns based on the active column count
				if (!tmpRowsBySection[section] || !Object.keys(tmpRowsBySection[section]).length)
				{
					if (this.pict.LogNoisiness > 2)
					{
						this.pict.log.warn(`Section ${section} does not have any rows defined. Skipping adjustment.`);
					}
					continue;
				}

				for (const group in tmpRowsBySection[section])
				{
					if (Object.prototype.hasOwnProperty.call(tmpRowsBySection[section], group))
					{
						const groupObject = tmpRowsBySection[section][group];

						for (const row in groupObject)
						{
							if (Object.prototype.hasOwnProperty.call(groupObject, row))
							{
								const rowObject = groupObject[row];
								// check if the row overcrowded before we do any adjustments, so we can update the parent "columns" wrapper
								if (this.checkForOvercrowdingInRow(rowObject))
								{
									if (this.pict.LogNoisiness > 2)
									{
										this.pict.log.warn(`Row ${row} in section ${section} is overcrowded. Adjusting columns.`);
									}
									// NOTE: we mark the entire group as overcrowded, so we can adjust the parent "columns" wrappers
									// This doesn't negatively impact any non-overcrowded rows, as they will be balanced with Bulma classes, however,
									// it would be better to mark the row itself as overcrowded, but that would require a change in the PictForm structure
									this.markGroupAsOvercrowded(rowObject, pSections, section, group);
								}
								// check if the row has all empty widths
								if (this.checkRowObjectForAllEmptyWidths(rowObject))
								{
									if (this.pict.LogNoisiness > 2)
									{
										this.pict.log.info(`Row ${row} in section ${section} is already balanced with Bulma classes. Skipping adjustment.`);
									}
									continue;
								}
								// check if the row is balanced with Bulma classes
								if (this.checkForBalancedRowsWithBulmaClasses(rowObject))
								{
									if (this.pict.LogNoisiness > 2)
									{
										this.pict.log.info(`Row ${row} in section ${section} is already balanced. Applying Bulma classes.`);
									}
									// just balance the row with existing Bulma classes from the PictForm.Width and PictForm.WidthOffset
									this.balanceRowsWithBulmaClasses(rowObject);
									continue;
								}
								// balance the row with calculated width percentages
								this.balanceRowsWithCalculatedWidthPercentages(rowObject);
							}
						}
						// now we need to set the adjusted rows back to the section
						tmpRowsBySection[section][group] = Object.values(groupObject).flat();
					}
				}
				// now we need to set the adjusted rows back to the section
				tmpRowsBySection[section] = Object.values(tmpRowsBySection[section]).map((group) =>
				{
					return Object.values(group).flat();
				});
			}
		}
		// temp log the adjusted rows by section
		if (this.pict.LogNoisiness > 2)
		{
			this.pict.log.info('Adjusted rows by section:', tmpRowsBySection);
		}
		return true;
	}

	/**
	 * Mark the row as overcrowded by adding a PictForm property
	 * @param {Object[]} pRowObject - The Pict row object containing columns to mark as overcrowded
	 * @param {Object} pSectionsObject - The Pict sections object containing the section information
	 * @param {String} pSectionName - The name of the section containing the row
	 * @param {String} pGroupName - The name of the group containing the row
	 * @return {Object} - The modified group object with overcrowded columns marked
	 */
	markGroupAsOvercrowded(pRowObject, pSectionsObject, pSectionName, pGroupName)
	{
		// mark the row as overcrowded by adding a PictForm property
		if (!pRowObject || !Array.isArray(pRowObject))
		{
			this.pict.log.error('Invalid row object provided for marking as overcrowded.');
			throw new Error('Invalid row object provided for marking as overcrowded.');
		}
		if (!pSectionsObject || typeof pSectionsObject !== 'object')
		{
			this.pict.log.error('Invalid sections object provided for marking as overcrowded.');
			throw new Error('Invalid sections object provided for marking as overcrowded.');
		}
		if (!pSectionName || typeof pSectionName !== 'string')
		{
			this.pict.log.error('Invalid section name provided for marking as overcrowded.');
			pSectionName = 'UNSET_SECTION'; // fallback to default section name if not provided
		}
		if (!pGroupName || typeof pGroupName !== 'string')
		{
			this.pict.log.error('Invalid group name provided for marking as overcrowded.');
			pGroupName = 'UNSET_GROUP'; // fallback to default group name if not provided
		}
		// find the section and group in the sections object
		const tmpSection = pSectionsObject.find((section) => section.Hash === pSectionName);
		if (!tmpSection)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.warn(`Section ${pSectionName} not found in sections object.`);
			}
			return {};
		}
		const pGroupObject = tmpSection.Groups.find((group) => group.Hash === pGroupName);
		if (!pGroupObject)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.warn(`Group ${pGroupName} not found in section ${pSectionName}.`);
			}
			return {};
		}
		// now we need to mark the row as overcrowded by adding a PictForm property
		if (!pGroupObject._OvercrowdedColumns)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info(`Marking group ${pGroupName} in section ${pSectionName} as overcrowded.`);
			}
			pGroupObject._OvercrowdedColumns = true;
		}
		else
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info(`Group ${pGroupName} in section ${pSectionName} is already marked as overcrowded.`);
			}
		}
		// check if the row is overcrowded and set the _OvercrowdedColumns property
		return pGroupObject;
	}

	/**
	 * Called after the provider is initialized, this method will adjust the UI based on the active column count
	 * @param {Function} [pCallback] - Optional callback to execute after initialization
	 * @return {Promise} - A promise that resolves when the initialization is complete
	 * @async
	 */
	onInitializeAsync(pCallback)
	{
		// don't break if sub-dynamic forms are using the correct pattern yet
		if (!this.pict || !this.pict.settings || !this.pict.settings.MyDefaultFormManifest || !this.pict.settings.MyDefaultFormManifest.Descriptors)
		{
			this.pict.log.warn('Pict settings or descriptors are not properly initialized to run ResponsiveUIAdjustmentProvider.');
			// if the callback is provided, we can call it to continue the initialization process
			if (typeof pCallback === 'function')
			{
				return pCallback();
			}
			return Promise.resolve();
		}
		// set the active column count based on the Pict settings, if available
		this.pict.log.info('ResponsiveUIAdjustmentProvider initialized with active column count:', this.activeColumnCount);
		// for every row in the content, we need to adjust the columns based on the active column count
		// This will add either a '_BulmaColumnClasses' or '_AdjustedWidthPercentage' value to each column, unless all widths are empty, then we let Bulma handle the widths
		this.mapAllRowsBySections(this.pict.settings?.MyDefaultFormManifest?.Descriptors, this.pict.settings?.MyDefaultFormManifest?.Sections);

		// add a resize event listener to the window to adjust the UI elements when the window is resized
		const resizeDebounce = 100; // debounce time in milliseconds
		let resizeTimeout;
		// NOTE: We use a debounce to prevent excessive calls to the resize handler, which can be expensive in terms of performance
		window.addEventListener('resize', () =>
		{
			if (resizeTimeout)
			{
				clearTimeout(resizeTimeout);
			}
			resizeTimeout = setTimeout(() =>
			{
				this.onWindowResize();
			}, resizeDebounce);
		});
		this.pict.log.info('ResponsiveUIAdjustmentProvider: Window resize event listener added.');
		// also, let's run it once to adjust the UI elements immediately
		this.onWindowResize();

		if (typeof pCallback === 'function')
		{
			return pCallback();
		}
		return Promise.resolve();
	}

	/**
	 * Called when the window is resized, this method will adjust all the labels to be a consistent height across all columns in the row
	 * @return {void}
	 */
	onWindowResize()
	{
		// go through all sections and groups, and adjust the label heights to be consistent for all columns in the row
		this.pict.log.info('ResponsiveUIAdjustmentProvider: Window resized, adjusting UI elements.');
		const allColumnRows = document.querySelectorAll('.columns:not(.is-hidden)');
		allColumnRows.forEach((row) =>
		{
			const columns = row.querySelectorAll('.column');
			if (columns.length > 0)
			{
				let maxHeight = 0;
				// find the maximum height of the labels in the columns
				columns.forEach((column) =>
				{
					const label = column.querySelector('label');
					if (label && label.offsetHeight > maxHeight)
					{
						maxHeight = label.offsetHeight;
					}
				});
				// if the maximum height is greater than 0, we can set the height of all labels to the maximum height
				if (maxHeight > 0)
				{
					columns.forEach((column) =>
					{
						const label = column.querySelector('label');
						if (label)
						{
							label.style.height = `${maxHeight}px`;
						}
					});
				}
			}
		});
		// A group can cross the "big enough to warrant an inline/modal choice"
		// threshold purely because the window got shorter, so ride this already
		// debounced resize pass rather than registering another listener.
		// NOTE: refreshEntryModeToggleVisibility must never call back into
		// prepareAnyExtraTableControls -- that would recurse through here.
		const tmpTableControls = this.pict.providers['Bulma-TableControls'];
		if (tmpTableControls && (typeof tmpTableControls.refreshEntryModeToggleVisibility === 'function'))
		{
			tmpTableControls.refreshEntryModeToggleVisibility();
		}
	}
}
module.exports = ResponsiveUIAdjustmentProvider;

},{"pict-provider":479}],127:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const EntityFilterEngineProvider = require('./PictProvider-EntityFilterEngine.js');
// The display-name resolution order, shared with the Picker stack's Read/Print display so the
// Select2 -> Picker migration cannot change what a field paints.
const libEntityDisplayName = require('./_EntityDisplayName.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

/**
 * @typedef {Object} Select2AjaxOptions
 * @property {number} [PageSize] - The number of items to get per page. Default is 50.
 * @property {Object} [Input] - The input object. Some defaults or fallbacks will be pulled from this if provided.
 * @property {string[]} [SearchFields] - The fields to search for the search term in. Default is ['Name'].
 * @property {(record: any) => string} [GetRecordID] - A function to get the record ID from the entity. Default is the database ID.
 * @property {(record: any) => string} [GetRecordName] - A function to get the record name from the entity. This is what is shown in the search results and selection. Defaults to Record.Name.
 * @property {(record: any) => string} [GetRecordUserFacingID] - A function to get the user facing record ID from the entity record. If provided, will decorate the selection with this ID (in addition to the name).
 * @property {() => Select2Item} [GetPinnedItem] - A function to get the pinned item. If provided, will be the first item in the list.
 * @property {() => Array<any>} [GetPriorityIDs] - Ids floated to the top of the first browse page, most-preferred first. Nothing is removed and a search term suppresses the reorder.
 * @property {(pFilters: string[], pParams: any, pBackoff?: string[]) => string[]} [HandleSearchFilters] - A function to handle the search filters. Return the (mandatory) filters to be used; push any back-off-able clauses into pBackoff. pParams is the Select2 params object for the search.
 * @property {string} [URLPrefix] - Optional prefix prepended to the entity REST path.
 * @property {number} [MinimumInputLengthForSearch] - The minimum input length for search. Default is from panels view, or ultimate fallback of 2.
 * @property {boolean} [Tags] - Whether or not to allow free-entry / dynamic option creation.
 * @property {boolean} [AllowClear] - Whether or not to allow clearing the selection. Default is true.
 * @property {string} [SearchPlaceholder] - The placeholder for the search input. Placeholder from input.PictForm is preferred over this.
 * @property {string} [SearchFallbackPlaceholder] - The fallback placeholder for the search input. Default is `Select ${pEntityType} records...`.
 * @property {string} [Width] - The width of the select2 input. Default is '100%'.
 * @property {boolean} [ApplySort] - Should sorting be applied to the filtering.
 * @property {string} [JoinEntity] - An Entity to Join to.
 * @property {boolean} [JoinEntityFirst] - Whether the Joined Entities name should come first. Defaults to true.
 * @property {string} [JoinField] - The field to join to on the Entity. default is ID<Entity>.
 * @property {boolean} [Disabled] - Whether the select is disabled.
 * @property {boolean} [Multiple] - Whether the select allows multiple selections.
 * @property {string} [EntityDisplayField] - An alternate field to use when displaying an entity.
 * @property {string} [JoinEntityDisplayField] - An alternate field to use when displaying the joined entity.
 * @property {boolean} [EntityTagLast] - Whether the entity tag should be displayed last in the display template, if an EntityTag is used.
 * @property {number} [RowIndex] - For a tabular column picker: this row's index, so a DynamicFilters `FromRowField` resolves against this row's sibling cell.
 * @property {Object} [View] - For a tabular column picker: the form view, providing the marshal destination a `FromRowField` reads from.
 */

/**
 * @typedef {Object} Select2Item
 * @property {string} id - The ID of the item.
 * @property {string} text - The display text of the item.
 */

/**
 * @typedef {Object} EntityDisplayResult
 * @property {Record<string, any>} Record - The entity record, exactly as the server returned it.
 * @property {string} DisplayName - The display text computed for the record.
 */

class Select2UtilProvider extends EntityFilterEngineProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * A save writes records server-side (the document's comprehension), so reads kept from before it are dropped.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		libSharedEntityRead.invalidate(this.pict);
		return super.onBeforeSaveDataAsync(fCallback);
	}

	/**
	 * Drops reads taken while the save was in flight.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		libSharedEntityRead.invalidate(this.pict);
		return super.onAfterSaveDataAsync(fCallback);
	}

	/**
	 * @typedef {Object} ReadRequest
	 * @property {string} url - The URL to issue the request against.
	 * @property {'GET'|'POST'} method - The HTTP method to use.
	 * @property {Object|null} body - The JSON body for a POST `/Query` request, or null for a GET.
	 */

	/**
	 * Convert a meadow GET read URL into either a passthrough GET or, when the URL
	 * exceeds `pThreshold`, an equivalent `POST <prefix><Entity>s/Query` request so a
	 * large IN-list filter doesn't blow the URI length limit. The POST body envelope
	 * maps onto the same GET read handlers (meadow-endpoints `/Query`); mode is selected
	 * by `{ Count, Distinct, Lite }` flags with precedence Count > Distinct > Lite > Reads.
	 *
	 * Pure: no `this.pict` / DOM / select2, so it is unit-tested directly. Short URLs pass
	 * through as GET to preserve response caching for the common case. Any URL that can't be
	 * parsed (no `/FilteredTo/` segment) falls back to a GET passthrough (fail-safe).
	 *
	 * Encoding: the GET router URL-decodes the `:Filter` / `:ExtraColumns` / `:Columns` path
	 * params once before the handler reads `params.*`, so those segments are `decodeURIComponent`'d
	 * into the body — a `LK~%25term%25` path segment becomes the `LK~%term%` the handler would see.
	 *
	 * @param {string} pURL - The meadow GET read URL (e.g. `<prefix><Entity>s/Lite/FilteredTo/<filter>/<begin>/<cap>`).
	 * @param {number} [pThreshold=1800] - URL length at/under which the GET is passed through unchanged.
	 * @return {ReadRequest} The request descriptor.
	 */
	_buildReadRequest(pURL, pThreshold)
	{
		const tmpThreshold = pThreshold ?? 1800;
		if (!pURL || pURL.length <= tmpThreshold)
		{
			return { url: pURL, method: 'GET', body: null };
		}
		// Robust parse (not one fragile regex): split on the FilteredTo delimiter; the head carries
		// the entity + read-mode segments, the tail carries the filter and optional /begin/cap.
		const tmpParts = pURL.split('/FilteredTo/');
		if (tmpParts.length !== 2)
		{
			return { url: pURL, method: 'GET', body: null };
		}
		const tmpHead = tmpParts[0];
		const tmpTail = tmpParts[1];

		// From the tail, peel a trailing /<digits>/<digits> as Begin/Cap; the remainder is the Filter
		// (meadow filters use `~`, never a literal `/`, so re-joining any interior slashes is safe).
		let tmpFilterSegment = tmpTail;
		let tmpBegin = null;
		let tmpCap = null;
		const tmpTailSegments = tmpTail.split('/').filter((pSegment) => pSegment.length > 0);
		if (tmpTailSegments.length >= 2 &&
			/^\d+$/.test(tmpTailSegments[tmpTailSegments.length - 2]) &&
			/^\d+$/.test(tmpTailSegments[tmpTailSegments.length - 1]))
		{
			tmpCap = parseInt(tmpTailSegments.pop(), 10);
			tmpBegin = parseInt(tmpTailSegments.pop(), 10);
			tmpFilterSegment = tmpTailSegments.join('/');
		}

		// From the head, peel the trailing read-mode segment(s). The head is
		// `<prefix><Entity>s` optionally followed by `/Lite`, `/LiteExtended/<cols>`,
		// `/Distinct/<cols>`, or `/Count`. Everything to the left of the mode is the
		// entity path; the POST endpoint is `<entity-path>/Query`.
		const tmpHeadSegments = tmpHead.split('/');
		const tmpBody = {};
		let tmpEntitySegmentCount = tmpHeadSegments.length;
		const tmpLast = tmpHeadSegments[tmpHeadSegments.length - 1];
		const tmpSecondLast = tmpHeadSegments[tmpHeadSegments.length - 2];
		if (tmpLast === 'Lite')
		{
			tmpBody.Lite = true;
			tmpEntitySegmentCount = tmpHeadSegments.length - 1;
		}
		else if (tmpLast === 'Count')
		{
			tmpBody.Count = true;
			tmpEntitySegmentCount = tmpHeadSegments.length - 1;
		}
		else if (tmpSecondLast === 'LiteExtended')
		{
			tmpBody.Lite = true;
			tmpBody.ExtraColumns = decodeURIComponent(tmpLast);
			tmpEntitySegmentCount = tmpHeadSegments.length - 2;
		}
		else if (tmpSecondLast === 'Distinct')
		{
			tmpBody.Distinct = true;
			tmpBody.Columns = decodeURIComponent(tmpLast);
			tmpEntitySegmentCount = tmpHeadSegments.length - 2;
		}
		const tmpEntityPath = tmpHeadSegments.slice(0, tmpEntitySegmentCount).join('/');

		tmpBody.Filter = decodeURIComponent(tmpFilterSegment);
		// Count ignores pagination (it counts the whole filtered query); every other mode forwards it.
		if (!tmpBody.Count && tmpBegin !== null)
		{
			tmpBody.Begin = tmpBegin;
			tmpBody.Cap = tmpCap;
		}

		return { url: `${tmpEntityPath}/Query`, method: 'POST', body: tmpBody };
	}

	/**
	 * Float a set of ids to the front of an option list, in the order given, leaving everything else in place.
	 * Ids absent from the page are skipped rather than synthesized — the page is already scoped, so an id that
	 * did not survive the filters must not be reintroduced by the ordering.
	 *
	 * @param {Array<{id: any}>} pOptions - the composed option list for this page.
	 * @param {Array<any>} pPriorityIDs - ids to float, most-preferred first.
	 * @return {Array<{id: any}>} The reordered list (a new array; the input is not mutated).
	 */
	applyPriorityOrder(pOptions, pPriorityIDs)
	{
		if (!Array.isArray(pOptions) || !Array.isArray(pPriorityIDs) || pPriorityIDs.length < 1)
		{
			return pOptions;
		}
		const tmpPinned = [];
		for (const tmpID of pPriorityIDs)
		{
			const tmpMatch = pOptions.find((pOption) => String(pOption.id) === String(tmpID));
			if (tmpMatch && tmpPinned.indexOf(tmpMatch) < 0)
			{
				tmpPinned.push(tmpMatch);
			}
		}
		if (tmpPinned.length < 1)
		{
			return pOptions;
		}
		return tmpPinned.concat(pOptions.filter((pOption) => tmpPinned.indexOf(pOption) < 0));
	}

	/**
	 * Helper to standardize building select2 options objects.
	 *
	 * @param {string} pEntityType - The entity type to get options for.
	 * @param {Select2AjaxOptions} pOptions - The options to use when getting the options.
	 *
	 * @return {import('select2').Options} - The options for select2.
	 */
	getOptionsAjax(pEntityType, pOptions)
	{
		const pageSize = pOptions.PageSize || 50;
		const input = pOptions.Input || {};
		const tmpProvider = this;
		// url() receives Select2 query params; transport() receives the ajax-OPTIONS object (a
		// different object). Bridge the page-1 mandatory-only fallback URL keyed by the full URL url()
		// returns (= options.url in transport), read and cleared once per request.
		const tmpBackoffFallbacks = {};
		// Set per query by url(): did a SCOPE filter (beyond the search term) apply? Drives the filter-aware
		// no-results message so the user learns a filter zeroed the picker and can reach for "Show all".
		let tmpScopeFilterApplied = false;
		const searchFields = pOptions.SearchFields || (pEntityType === 'User' ? [ 'NameFirst', 'NameLast' ] : [ 'Name' ]);
		const getUserFacingRecordID = pOptions.GetRecordUserFacingID || (() => null);
		const recordToID = pOptions.GetRecordID ?? ((pEntity) => pEntity[`ID${pEntityType}`]);
		const recordToText = pOptions.GetRecordName ?? ((pEntity) =>
		{
			let baseName = pOptions.EntityDisplayField ? pEntity[pOptions.EntityDisplayField] : pEntityType === 'User' ? `${ pEntity.NameFirst } ${ pEntity.NameLast }` : pEntity.Name || `Unnamed ${pEntityType} #${pEntity[`ID${pEntityType}`]}`;
			if (pEntity.JoinName)
			{
				baseName = pOptions.JoinEntityFirst ? `${ pEntity.JoinName } - ${ baseName }` : `${ baseName } - ${ pEntity.JoinName }`;
			}
			const recordID = getUserFacingRecordID(pEntity);
			// Suppress the tag pill when it's identical to the name (e.g. Labs whose code IS their name) —
			// the compound would render a redundant "(X) X". Fall through to the bare name (matches the PDF).
			if (recordID && String(recordID).trim() !== String(baseName).trim())
			{
				return `${recordID}|~|${baseName}`;
			}
			return baseName;
		});
		const getPinnedItem = pOptions.GetPinnedItem ?? (() => null);
		// Pin-to-top: ids floated above the rest of the first BROWSE page, in the given order. Nothing is
		// removed, and a search term defers entirely to natural relevance so a pin never hides a typed-for
		// record — the same contract pict-section-picker's PriorityValues carries on the Picker stack.
		const getPriorityIDs = pOptions.GetPriorityIDs ?? (() => []);
		const handleSearchFilters = pOptions.HandleSearchFilters ?? ((pFilters, pParams) => pFilters);
		// NOTE: Select2 Option Documentation: https://select2.org/configuration/options-api
		/** @type {import('select2').Options} */
		const tmpSelectOptions =
		{
			minimumInputLength: pOptions.MinimumInputLengthForSearch ?? this.pict.views.HeadlightPanels?.MinimumInputLengthForSearch ?? 0,
			tags: pOptions.Tags ?? false,
			allowClear: pOptions.AllowClear ?? true,
			placeholder: pOptions.SearchPlaceholder || input.PictForm?.Placeholder || pOptions.SearchFallbackPlaceholder || `Select ${pEntityType} records...`,
			width: pOptions.Width ?? '100%',
			disabled: pOptions.Disabled ?? false,
			multiple: pOptions.Multiple ?? false,
			language:
			{
				searching: function()
				{
					return 'Searching...';
				},
				noResults: function()
				{
					if (tmpScopeFilterApplied)
					{
						return input.PictForm?.FilteredNoResultsMessage ||
							(input.PictForm?.OverrideField ?
								'No matches with the current filter — turn on "Show all" to see everything.' :
								'No matches with the current filter.');
					}
					return 'No results found.';
				},
				loadingMore: function()
				{
					return 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			escapeMarkup: function(text)
			{
				if (text && text.includes('|~|'))
				{
					const tempNumber = text.split('|~|')[0]?.trim();
					const tempName = text.split('|~|')[1]?.trim();
					return _Pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(tempNumber, tempName, pOptions.Multiple, pOptions.EntityTagLast);
				}
				return text;
			},
			ajax:
			{
				cache: true,
				method: 'GET',
				url: function(params)
				{
					const page = params.page || 1;
					const tmpSortClause = searchFields.map((f) => `FSF~${ f }~ASC~0`).join('~');
					const buildURL = (pFilterList) =>
					{
						let tmpURL = `${pOptions.URLPrefix || ''}${pEntityType}s/`;
						if (pFilterList.length > 0)
						{
							tmpURL += pOptions?.ApplySort ? `FilteredTo/${pFilterList.join('~')}~${tmpSortClause}/` : `FilteredTo/${pFilterList.join('~')}/`;
						}
						else if (pOptions?.ApplySort)
						{
							tmpURL += `FilteredTo/${tmpSortClause}/`;
						}
						tmpURL += `${(page - 1) * pageSize}/${pageSize}`;
						return tmpURL;
					};
					// Mandatory filters (search term, intrinsic subclass scope, project scope) always apply.
					// Back-off-able filters (BackOff static/dynamic, spec-year) collect separately so the
					// transport can drop them on an empty-result retry, and the override drops them up-front.
					let filters = [];
					const tmpBackoff = [];
					if (params.term && searchFields.length > 0)
					{
						const tmpTerms = params.term.split(' ').map((pTerm) => pTerm.trim()).filter((pTerm) => pTerm.length > 0);
						if (tmpTerms.length > 0)
						{
							filters = tmpTerms.flatMap((tmpTerm) =>
							{
								const tmpFieldFilters = searchFields.map((pField) => `FBVOR~${pField}~LK~${encodeURIComponent(`%${tmpTerm}%`)}%25`);
								tmpFieldFilters.unshift('FOP~0~(~0');
								tmpFieldFilters.push('FCP~0~)~0');
								return tmpFieldFilters;
							});
						}
					}
					filters = handleSearchFilters(filters, params, tmpBackoff) || filters;
					tmpProvider.applyStaticFilters(filters, input, tmpBackoff);
					// pOptions.RowIndex / pOptions.View are set for tabular columns (see
					// MaterialsEntitySelector.initializeSelect2) so FromRowField narrows per-row.
					tmpProvider.applyDynamicFilters(filters, input, pOptions.RowIndex, pOptions.View, tmpBackoff);
					// pOptions.RowIndex must be threaded here too: a tabular picker persists its Show All
					// state per row (<Hash>__ShowAll_<row>), so reading the flat address left every
					// per-row toggle inert on this path.
					const tmpEffectiveBackoff = tmpProvider.isFilterOverridden(input, pOptions.RowIndex) ? [] : tmpBackoff;
					// A scope filter applied if any clause is not a search-term clause (FBVOR/FOP/FCP), or a
					// back-off clause is in effect — read by noResults to explain an empty/zeroed picker.
					tmpScopeFilterApplied = tmpEffectiveBackoff.length > 0 || filters.some((tmpClause) => tmpClause.indexOf('FBVOR~') !== 0 && tmpClause.indexOf('FOP~') !== 0 && tmpClause.indexOf('FCP~') !== 0);
					// Mandatory-only fallback the transport retries when the fully-filtered query is empty.
					// page-1 fallback is recorded against the returned full URL just below (read in transport).
					const tmpFullURL = buildURL(filters.concat(tmpEffectiveBackoff));
					if (tmpEffectiveBackoff.length > 0 && page === 1)
					{
						tmpBackoffFallbacks[tmpFullURL] = buildURL(filters);
					}
					return tmpFullURL;
				},
				xhrFields:
				{
					withCredentials: true,
				},
				dataType: 'json',
				transport: (params, success, failure) =>
				{
					let aborted = false;
					let tmpActiveRequest = null;
					const tmpFallbackURL = tmpBackoffFallbacks[params.url];
					delete tmpBackoffFallbacks[params.url];
					// Decorate a response with JoinEntity display names (when configured) and resolve.
					const finishWithResponse = async (pResponse) =>
					{
						if (pOptions?.JoinEntity && pResponse?.[0]?.hasOwnProperty(pOptions.JoinField))
						{
							const ids = [];
							for (const r of pResponse)
							{
								if (r[pOptions.JoinField])
								{
									ids.push(r[pOptions.JoinField]);
								}
							}
							if (ids.length)
							{
								try
								{
									const joinedEntities = await this.getEntitySetAsync(pOptions?.JoinEntity, `FBL~ID${ pOptions?.JoinEntity }~INN~${ ids.join(',') }`);
									if (joinedEntities?.length)
									{
										const idMap = {};
										for (const j of joinedEntities)
										{
											idMap[j[`ID${ pOptions?.JoinEntity }`]] = j;
										}
										const newResponse = [];
										for (const r of pResponse)
										{
											const joinEntityObj = idMap[r[pOptions.JoinField]];
											let joinName = null;
											if (joinEntityObj)
											{
												if (pOptions.JoinEntityDisplayField)
												{
													joinName = joinEntityObj[pOptions.JoinEntityDisplayField];
												}
												else if (pOptions.JoinEntity === 'User')
												{
													joinName = `${joinEntityObj.NameFirst} ${joinEntityObj.NameLast}`;
												}
												else
												{
													joinName = joinEntityObj.Name || '';
												}
											}
											r.JoinName = joinName;
											newResponse.push(r);
										}
										pResponse = newResponse;
									}
								}
								catch (e)
								{
									console.log(`Error fetching joined ${ pOptions?.JoinEntity }:`, e);
									return failure();
								}
							}
						}
						if (!aborted)
						{
							success(pResponse || []);
						}
					};
					const fetchURL = (pURL, fOnBody, fOnError) =>
					{
						// Oversized read URLs (large IN-list filters) fall back to POST /Query so they
						// don't blow the URI length limit; short URLs stay GET to preserve caching.
						const tmpReq = this._buildReadRequest(pURL);
						const tmpHandler = (pError, pResponse) =>
						{
							if (pError || pResponse?.Error)
							{
								console.log(`Error fetching ${ pURL }:`, pError || pResponse?.Error);
								return fOnError();
							}
							fOnBody(pResponse);
						};
						if (tmpReq.method === 'POST')
						{
							tmpActiveRequest = this.pict.HeadlightRestClient.postJSON(tmpReq.url, tmpReq.body, tmpHandler);
						}
						else
						{
							tmpActiveRequest = this.pict.HeadlightRestClient.getJSON(tmpReq.url, tmpHandler);
						}
					};
					fetchURL(params.url, (pResponse) =>
					{
						// Back-off: a fully-filtered FIRST page that returns nothing retries without the
						// back-off-able filters, so the picker shows its full set instead of an empty dropdown.
						// Only the first page backs off — on later pages an empty body means "no more results",
						// not "the filter emptied it", so retrying there would surface out-of-filter rows.
						if (Array.isArray(pResponse) && pResponse.length === 0 && tmpFallbackURL)
						{
							fetchURL(tmpFallbackURL, (pFallback) => finishWithResponse(pFallback), failure);
							return;
						}
						finishWithResponse(pResponse);
					}, failure);

					return { abort: () =>
					{
						aborted = true;
						if (tmpActiveRequest)
						{
							tmpActiveRequest.abort();
						}
					} };
				},
				processResults: function(data, params)
				{
					let formattedData = [];
					const pageSize = 50;
					params.page = params.page || 1;
					if (data && data.length > 0)
					{
						formattedData = data.map((pItem) =>
						{
							const item =
							{
								id: recordToID(pItem),
								text: recordToText(pItem),
							};
							return item;
						});
						if (params.page === 1)
						{
							if (!params.term)
							{
								formattedData = tmpProvider.applyPriorityOrder(formattedData, getPriorityIDs());
							}
							const pinnedItem = getPinnedItem();
							if (pinnedItem)
							{
								formattedData = formattedData.filter((pItem) => pItem.id != pinnedItem.id);
								formattedData.unshift(pinnedItem);
							}
						}
					}
					const pageInfo =
					{
						results: formattedData,
						pagination:
						{
							more: data.length >= pageSize,
						},
					};
					return pageInfo;
				},
			},
		};
		return tmpSelectOptions;
	}

	/**
	 * Fetch a single entity record. The record is returned exactly as the server sent it; callers that also
	 * need display text use getEntityWithDisplayAsync (record snapshots held in form data are persisted
	 * verbatim, so nothing may be decorated onto a fetched record here).
	 *
	 * Identical lookups share one request, and a found record is reused for a short window
	 * (`_SharedEntityRead`); pass `BypassCache` to skip the reuse window (a request already in flight is still shared).
	 *
	 * @param {string} pEntity - The entity type to get.
	 * @param {number|string} pIDEntity - The ID of the entity to get
	 * @param {Record<string, any>} pOptions - Options for getting the entity.
	 *
	 * @return {Promise<Record<string, any>>} - The entity record.
	 */
	async getEntityAsync(pEntity, pIDEntity, pOptions = {})
	{
		return new Promise((resolve, reject) =>
		{
			const tmpIdentityField = pOptions.IdentityField || `ID${pEntity}`;
			if (libSharedEntityRead.isEmptyIdentityValue(tmpIdentityField, pIDEntity))
			{
				return reject(new Error(`No ${pEntity} found with ${tmpIdentityField} = ${pIDEntity}`));
			}
			const tmpURL = `${pEntity}s/FilteredTo/FBV~${tmpIdentityField}~EQ~${encodeURIComponent(pIDEntity)}`;
			libSharedEntityRead.readJSON(this.pict, tmpURL, { ReuseResult: !pOptions.BypassCache }, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				if (pResult.length < 1)
				{
					return reject(new Error(`No ${pEntity} found with ${tmpIdentityField} = ${pIDEntity}`));
				}
				if (pResult.length > 1)
				{
					this.pict.log.warn(`Multiple ${pEntity} records found with ${tmpIdentityField} = ${pIDEntity}, returning the first result.`);
				}
				resolve(pResult[0]);
			});
		});
	}

	/**
	 * Fetch a single entity record along with the display text for it.
	 *
	 * @param {string} pEntity - The entity type to get.
	 * @param {number|string} pIDEntity - The ID of the entity to get
	 * @param {Record<string, any>} pOptions - Options for getting the entity.
	 *
	 * @return {Promise<EntityDisplayResult>} - The entity record and its display name.
	 */
	async getEntityWithDisplayAsync(pEntity, pIDEntity, pOptions = {})
	{
		const tmpRecord = await this.getEntityAsync(pEntity, pIDEntity, pOptions);
		return { Record: tmpRecord, DisplayName: await this.getEntityDisplayNameAsync(pEntity, tmpRecord, pOptions) };
	}

	/**
	 * Resolve the display text for an entity record, loading the configured JoinEntity when one applies.
	 *
	 * @param {string} pEntity - The entity type the record belongs to.
	 * @param {Record<string, any>} pRecord - The entity record.
	 * @param {Record<string, any>} pOptions - Options for the display name (EntityDisplayField, JoinEntity, ...).
	 *
	 * @return {Promise<string>} - The display name for the record.
	 */
	async getEntityDisplayNameAsync(pEntity, pRecord, pOptions = {})
	{
		const tmpDisplayName = this.buildEntityDisplayName(pEntity, pRecord, pOptions);
		if (pOptions.JoinEntity && pRecord?.[pOptions.JoinField])
		{
			const tmpJoinedRecord = await this.getEntityAsync(pOptions.JoinEntity, pRecord[pOptions.JoinField]);
			const tmpJoinedDisplayName = this.buildEntityDisplayName(pOptions.JoinEntity, tmpJoinedRecord, { EntityDisplayField: pOptions.JoinEntityDisplayField });
			return pOptions.JoinEntityFirst ? `${ tmpJoinedDisplayName } - ${ tmpDisplayName }` : `${ tmpDisplayName } - ${ tmpJoinedDisplayName }`;
		}
		return tmpDisplayName;
	}

	/**
	 * Compute the display text for an entity record. Pure -- the record is never written to.
	 *
	 * @param {string} pEntity - The entity type the record belongs to.
	 * @param {Record<string, any>} pRecord - The entity record.
	 * @param {Record<string, any>} pOptions - Options for the display name (EntityDisplayField).
	 *
	 * @return {string} - The display name for the record.
	 */
	buildEntityDisplayName(pEntity, pRecord, pOptions = {})
	{
		// The resolution order (dotted paths, the Name-less User table, …) lives in the shared helper so the
		// Picker stack's Read/Print display resolves identically; this chain's only addition is the legacy
		// "Unnamed <Entity> #<id>" placeholder for a record with nothing to show.
		return libEntityDisplayName.resolveEntityDisplayName(pEntity, pRecord, pOptions,
			() => `Unnamed ${pEntity} #${pRecord[`ID${pEntity}`]}`);
	}

	/**
	 * @param {string} pEntity - The entity type to get.
	 * @param {string} pFilter - The filter to apply to the entity set.
	 *
	 * @return {Promise<Array<Record<string, any>>>} - The entity record.
	 */
	async getEntitySetAsync(pEntity, pFilter)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySet(pEntity, pFilter, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pResult);
			});
		});
	}

	/**
	 * Builds a Select2 display template with tag and name. Supports both singluar and multiple displays.
	 * The tag can be placed at the start or end as an additional option.
	 *
	 * @param {string} pTag - The tag to display.
	 * @param {string} pName - The name to display.
	 * @param {boolean} [pMultiple=false] - Whether this is for multiple selection.
	 * @param {boolean} [pTagAtEnd=false] - Whether to put the tag at the end.
	 * @return {string} - The HTML template string.
	 */
	buildSelect2CompoundDisplayTemplate(pTag, pName, pMultiple = false, pTagAtEnd = false)
	{
		return (
			`<span class="select2-${pMultiple ? 'multiple' : 'single'}-entity-selection">
				${pTagAtEnd ? `<span class="select2-entity-name">${pName}</span><span class="tag select2-entity-tag">${pTag}</span>` : `<span class="tag select2-entity-tag">${pTag}</span><span class="select2-entity-name">${pName}</span>`}
			</span>`
		);
	}
}

module.exports = Select2UtilProvider;
// Joins the app save-data lifecycle so a save drops the shared entity reads (onBefore/onAfterSaveDataAsync).
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-EntityFilterEngine.js":43,"./_EntityDisplayName.js":133,"./_SharedEntityRead.js":140}],128:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const SPEC_SCOPE_PAGE_SIZE = 500;

// Resolved-scope persistence (localStorage). Bump the version segment when the
// entry shape changes — old entries are then simply never read again.
const SPEC_SCOPE_CACHE_PREFIX = 'HeadlightSpecScope:2:';
const SPEC_SCOPE_CACHE_TTL_SECONDS = 6 * 60 * 60;

/**
 * One plan entry at the grain every picker cascades over.
 * @typedef {{ SampleType: string, IDLineItem: number, IDMaterial: number, IDTest: number }} PlanEntry
 */

/**
 * The source a project's plan entries were resolved from.
 * @typedef {('Plan'|'Template'|'Union'|'None')} PlanEntrySource
 */

/**
 * SpecScopeResolver — shared Pict provider that resolves the plan entries
 * governing a project's material / test / line-item pickers, and caches the
 * result so downstream input providers can consult it without each picker
 * re-fetching.
 *
 * A plan entry is (IDLineItem, IDMaterial, IDTest, SampleType). Two tables hold
 * entries at exactly that grain, and the project picks between them:
 *
 *   - Plan     — ProjectLineItemMaterialTest for the project. What it WILL sample.
 *   - Template — PayItemMaterialTestRequirement for the contract's material spec
 *                set, joined to the project's LineItems on IDPayItem. What the
 *                specification REQUIRES. Used when the project has no plan rows.
 *
 * The choice is per project, never per line item: a half-planned project must
 * not mix sources, because a user could not tell which rule applied to which row.
 * `getSource()` reports which one answered.
 *
 * Enforcement is cascade narrowing, not membership. Choose a line item and the
 * material picker narrows; choose a material and the test picker narrows; sample
 * type narrows both. Consumed by the EntityFilterEngine `SamplePlanScope` filter
 * — see docs/Filters.md.
 *
 * Fail-open throughout: no source, no set, no plan, or a line item with
 * IDPayItem = 0 produces no narrowing, silently. Every getter returns null in
 * that state so consumers leave their list unfiltered.
 *
 * Online, the template comes from the platform endpoint
 * `TestSpecificationSet/PlanEntries/ForProject/:IDProject`. In the bundle path
 * the LineItem and PayItemMaterialTestRequirement rows are fetched directly and
 * joined client-side, because the bundle transport has no server to do it.
 *
 * The lab axis rides along here (labs joined to the material spec set via
 * LabTestSpecificationSetJoin). It is a different mechanism that happens to need
 * the same contract read.
 *
 * The RESOLVED scope persists in localStorage (plan entries per project,
 * material parent pairs per customer) so repeat loads skip the reads entirely —
 * only Project/Contract are re-fetched, and the cached entry is honored only
 * when it resolves to the same spec set and is inside the TTL (default 6h).
 * Configure via manifest/option `SpecScopeCache: { Enabled, TTLSeconds }`; call
 * clearScopeCache() to force a cold load. Storage failures and quota exhaustion
 * fail open to a normal full load.
 *
 * Consumers:
 *   resolver.loadForProject(IDProject)      // call once per view load
 *   resolver.getSamplePlanLineItemIDs(...)  // Set<number> | null
 *   resolver.getSamplePlanMaterialIDs(...)  // Set<number> | null
 *   resolver.getSamplePlanTestIDs(...)      // Set<number> | null
 *   resolver.getSource()                    // PlanEntrySource
 *   resolver.getAllowedLabIDs()             // Set<number> | null
 */
class SpecScopeResolver extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		// Customer-wide material parent map for parent/child filter expansion. Persists across
		// project loads (the tree is per-customer, not per-project) — reloads on a customer switch.
		/** @type {{ IDCustomer: number, ParentOf: Map<number, number>, ChildrenOf: Map<number, number[]> }|null} */
		this._MaterialHierarchy = null;
		this._resetScope();
	}

	_resetScope()
	{
		this._Scope =
		{
			IDProject: null,
			IDContract: null,
			MaterialSetID: 0,
			AllowedLabIDs: null,
			HasLabCoverage: false,
			SamplePlanCombos: null,
			HasSamplePlan: false,
			/** @type {PlanEntrySource} */
			Source: 'None',
			Loaded: false,
			LoadPromise: null,
		};
	}

	/**
	 * Resolve the scope for a given project. Safe to call repeatedly — returns
	 * the cached result for the same project. Caller should await this before
	 * any picker that consults the resolver renders.
	 *
	 * @param {number|string} pIDProject
	 * @return {Promise<object>} scope snapshot
	 */
	async loadForProject(pIDProject)
	{
		const IDProject = typeof pIDProject === 'number' ? pIDProject : (parseInt(String(pIDProject), 10) || 0);
		if (this._Scope.IDProject === IDProject && this._Scope.Loaded)
		{
			return this._Scope;
		}
		if (this._Scope.IDProject === IDProject && this._Scope.LoadPromise)
		{
			return this._Scope.LoadPromise;
		}
		this._resetScope();
		this._Scope.IDProject = IDProject;
		if (!(IDProject > 0))
		{
			this._Scope.Loaded = true;
			return this._Scope;
		}
		this._Scope.LoadPromise = this._doLoad(IDProject)
			.then(async (pScope) =>
			{
				// After the main resolve converges (cache / bundle / per-entity reads), floor the lab axis off the
				// resolved material spec set — one small read, independent of which path produced the scope.
				await this._loadLabScope();
				return pScope;
			})
			.catch((err) =>
			{
				this.pict?.log?.warn(`[SpecScopeResolver] Failed to resolve scope for project ${IDProject}: ${err?.message || err}`);
				return this._Scope;
			});
		return this._Scope.LoadPromise;
	}

	async _doLoad(IDProject)
	{
		const tmpNeedsSamplePlan = this._needsSamplePlan();
		const tmpCacheConfig = this._resolveCacheConfig();

		const project = await this._getJSON(`Project/${IDProject}`);
		const tmpIDCustomer = project?.IDCustomer || this.pict?.AppData?.CurrentUser?.IDCustomer || 0;
		if (project?.IDContract > 0)
		{
			const contract = await this._getJSON(`Contract/${project.IDContract}`);
			this._Scope.IDContract = contract?.IDContract || project.IDContract;
			// Two-tier resolution: direct IDTestSpecificationSet FK, else a fallback that
			// matches a set by Year. The platform endpoint applies the same rule; the two
			// must not drift.
			this._Scope.MaterialSetID = await this._resolveSetID(contract, 'MaterialIDTestSpecificationSet', 'MaterialsSpecificationYear');
		}

		if (tmpNeedsSamplePlan && !(await this._resolvePlanEntries(IDProject, tmpIDCustomer, tmpCacheConfig)))
		{
			const tmpResolved = await this._loadSamplePlan(IDProject);
			this._applyPlanEntries(tmpResolved.Combos, tmpResolved.Source);
			if (tmpCacheConfig.Enabled)
			{
				this._writeProjectScopeCache(IDProject);
			}
		}

		// Material parent map for parent/child filter expansion — loaded once per customer
		// when a material dimension is in play. The expand helpers fail open (no-op) if it
		// did not load, so the gate need not be exhaustive.
		if (this._needsMaterialHierarchy() && tmpIDCustomer > 0)
		{
			await this._loadMaterialHierarchy(tmpIDCustomer);
		}

		this._Scope.Loaded = true;
		return this._Scope;
	}

	/**
	 * Try the two cheap paths to a project's plan entries — the persisted scope cache,
	 * then one bundle execution — and report whether either answered. A bundle failure
	 * falls through to the per-entity reads, which remain the offline-proven final path.
	 *
	 * @param {number} pIDProject
	 * @param {number} pIDCustomer
	 * @param {{ Enabled: boolean, TTLSeconds: number }} pCacheConfig
	 * @return {Promise<boolean>} true when the scope now carries resolved plan entries.
	 */
	async _resolvePlanEntries(pIDProject, pIDCustomer, pCacheConfig)
	{
		const tmpCached = pCacheConfig.Enabled ? this._readProjectScopeCache(pIDProject, pCacheConfig) : null;
		if (tmpCached && tmpCached.MaterialSetID === this._Scope.MaterialSetID && tmpCached.HasSamplePlanData)
		{
			this._applySamplePlanFromCache(tmpCached);
			return true;
		}
		if (!this._resolveBundleConfig().Enabled)
		{
			return false;
		}
		const tmpBundleClient = this._getEntityBundleClient();
		if (!tmpBundleClient)
		{
			return false;
		}
		try
		{
			const tmpSteps = this._buildScopeBundleSteps(pIDProject, pIDCustomer, this._Scope.MaterialSetID);
			const tmpBundleResult = await tmpBundleClient.executeBundle(tmpSteps);
			this._applyScopeBundleData(tmpBundleResult.Data, pIDCustomer);
			if (pCacheConfig.Enabled)
			{
				this._writeProjectScopeCache(pIDProject);
			}
			return true;
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Bundle scope load failed (${pError?.message || pError}); falling back to entity reads.`);
			return false;
		}
	}

	/**
	 * Install a resolved entry list on the scope.
	 *
	 * @param {Array<PlanEntry>} pCombos
	 * @param {PlanEntrySource} pSource
	 */
	_applyPlanEntries(pCombos, pSource)
	{
		this._Scope.SamplePlanCombos = pCombos;
		this._Scope.Source = pSource;
		this._Scope.HasSamplePlan = pCombos.length > 0;
	}

	/**
	 * Load (once per customer) the material parent map used for parent/child filter expansion.
	 * Materials form a shallow tree via IDMaterialParent; the whole customer's
	 * IDMaterial->IDMaterialParent is cached so ancestor/descendant walks are sync + in-memory.
	 * Cached across project loads; reloads only on a customer switch. Lite read (two ids),
	 * offline-servable like the other resolver reads.
	 *
	 * @param {number} pIDCustomer
	 * @return {Promise<void>}
	 */
	async _loadMaterialHierarchy(pIDCustomer)
	{
		const tmpIDCustomer = parseInt(String(pIDCustomer), 10) || 0;
		if (!(tmpIDCustomer > 0) || (this._MaterialHierarchy && this._MaterialHierarchy.IDCustomer === tmpIDCustomer))
		{
			return;
		}
		if (this._primeMaterialHierarchyFromCache(tmpIDCustomer))
		{
			return;
		}
		const tmpCacheConfig = this._resolveCacheConfig();
		const tmpCacheKey = `${SPEC_SCOPE_CACHE_PREFIX}MaterialHierarchy:${tmpIDCustomer}`;
		const tmpRows = await this._readAllPages('Materials/Lite', `FBV~IDCustomer~EQ~${tmpIDCustomer}`);
		const tmpPairs = [];
		for (const tmpRow of tmpRows)
		{
			const tmpID = parseInt(tmpRow.IDMaterial, 10) || 0;
			if (tmpID > 0)
			{
				tmpPairs.push([ tmpID, parseInt(tmpRow.IDMaterialParent, 10) || 0 ]);
			}
		}
		this._MaterialHierarchy = this._buildMaterialHierarchy(tmpIDCustomer, tmpPairs);
		if (tmpCacheConfig.Enabled)
		{
			this._writeCacheEntry(tmpCacheKey, { TS: Date.now(), Pairs: tmpPairs });
		}
	}

	/**
	 * Build the hierarchy maps from [IDMaterial, IDMaterialParent] pairs.
	 *
	 * @param {number} pIDCustomer
	 * @param {Array<Array<number>>} pPairs
	 * @return {{ IDCustomer: number, ParentOf: Map<number, number>, ChildrenOf: Map<number, number[]> }}
	 */
	_buildMaterialHierarchy(pIDCustomer, pPairs)
	{
		const tmpParentOf = new Map();
		const tmpChildrenOf = new Map();
		for (const tmpPair of pPairs)
		{
			const tmpID = parseInt(String(tmpPair[0]), 10) || 0;
			if (!(tmpID > 0))
			{
				continue;
			}
			const tmpParent = parseInt(String(tmpPair[1]), 10) || 0;
			tmpParentOf.set(tmpID, tmpParent);
			if (tmpParent > 0)
			{
				const tmpSiblings = tmpChildrenOf.get(tmpParent);
				if (tmpSiblings)
				{
					tmpSiblings.push(tmpID);
				}
				else
				{
					tmpChildrenOf.set(tmpParent, [ tmpID ]);
				}
			}
		}
		return { IDCustomer: pIDCustomer, ParentOf: tmpParentOf, ChildrenOf: tmpChildrenOf };
	}

	/**
	 * Populate the in-memory hierarchy for a customer without any network:
	 * no-op when already resident, else from the persisted pairs cache.
	 *
	 * @param {number} pIDCustomer
	 * @return {boolean} true when the hierarchy is now resident for pIDCustomer.
	 */
	_primeMaterialHierarchyFromCache(pIDCustomer)
	{
		if (this._MaterialHierarchy && this._MaterialHierarchy.IDCustomer === pIDCustomer)
		{
			return true;
		}
		const tmpCacheConfig = this._resolveCacheConfig();
		if (!tmpCacheConfig.Enabled)
		{
			return false;
		}
		const tmpCached = this._readCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}MaterialHierarchy:${pIDCustomer}`, tmpCacheConfig.TTLSeconds);
		if (tmpCached && Array.isArray(tmpCached.Pairs))
		{
			this._MaterialHierarchy = this._buildMaterialHierarchy(pIDCustomer, tmpCached.Pairs);
			return true;
		}
		return false;
	}

	/**
	 * Resolve the resolved-scope cache configuration. Persistence is on by
	 * default with a conservative TTL — spec-set membership, sampling plans and
	 * the material tree change rarely. Override via manifest-level or provider
	 * option `SpecScopeCache: { Enabled, TTLSeconds }` (manifest wins). Tests
	 * and exotic hosts can inject a storage backend via
	 * `SpecScopeCache.Storage` (any localStorage-shaped object).
	 *
	 * @return {{ Enabled: boolean, TTLSeconds: number }}
	 */
	_resolveCacheConfig()
	{
		const tmpManifest = this.pict?.views?.PictFormMetacontroller?.manifestDescription;
		const tmpSources =
		[
			tmpManifest && tmpManifest.SpecScopeCache,
			(this.options || {}).SpecScopeCache,
		];
		const tmpResolveField = (pField, pType, pDefault) =>
		{
			for (const tmpSource of tmpSources)
			{
				if (tmpSource && typeof tmpSource[pField] === pType)
				{
					return tmpSource[pField];
				}
			}
			return pDefault;
		};
		return {
			Enabled: tmpResolveField('Enabled', 'boolean', true),
			TTLSeconds: tmpResolveField('TTLSeconds', 'number', SPEC_SCOPE_CACHE_TTL_SECONDS),
		};
	}

	/**
	 * @return {Storage|null} the persistence backend, or null when unavailable
	 * (non-browser host, sandboxed frame) — every cache path fails open on null.
	 */
	_cacheStorage()
	{
		const tmpInjected = this.options && this.options.SpecScopeCache && this.options.SpecScopeCache.Storage;
		if (tmpInjected)
		{
			return tmpInjected;
		}
		try
		{
			return (typeof localStorage !== 'undefined') ? localStorage : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * Read one cache entry; expired or unparsable entries are deleted and
	 * treated as a miss.
	 *
	 * @param {string} pKey
	 * @param {number} pTTLSeconds
	 * @return {Record<string, any>|null}
	 */
	_readCacheEntry(pKey, pTTLSeconds)
	{
		const tmpStorage = this._cacheStorage();
		if (!tmpStorage)
		{
			return null;
		}
		try
		{
			const tmpRaw = tmpStorage.getItem(pKey);
			if (!tmpRaw)
			{
				return null;
			}
			const tmpEntry = JSON.parse(tmpRaw);
			if (!tmpEntry || typeof tmpEntry.TS !== 'number' || (Date.now() - tmpEntry.TS) > (pTTLSeconds * 1000))
			{
				tmpStorage.removeItem(pKey);
				return null;
			}
			return tmpEntry;
		}
		catch (pError)
		{
			try
			{
				tmpStorage.removeItem(pKey);
			}
			catch (pRemoveError)
			{
				// fail open
			}
			return null;
		}
	}

	/**
	 * Write one cache entry. On a quota failure, evict all spec-scope entries
	 * and retry once; a second failure is swallowed (cache is best-effort).
	 *
	 * @param {string} pKey
	 * @param {Record<string, any>} pEntry
	 */
	_writeCacheEntry(pKey, pEntry)
	{
		const tmpStorage = this._cacheStorage();
		if (!tmpStorage)
		{
			return;
		}
		const tmpSerialized = JSON.stringify(pEntry);
		try
		{
			tmpStorage.setItem(pKey, tmpSerialized);
		}
		catch (pError)
		{
			this.clearScopeCache();
			try
			{
				tmpStorage.setItem(pKey, tmpSerialized);
			}
			catch (pRetryError)
			{
				this.pict?.log?.warn(`[SpecScopeResolver] Scope cache write failed for ${pKey}: ${pRetryError?.message || pRetryError}`);
			}
		}
	}

	/**
	 * Remove every persisted spec-scope entry (all versions' project scopes and
	 * material hierarchies). Public so QA/debug tooling can force a cold load.
	 */
	clearScopeCache()
	{
		const tmpStorage = this._cacheStorage();
		if (!tmpStorage)
		{
			return;
		}
		try
		{
			const tmpKeys = [];
			for (let i = 0; i < tmpStorage.length; i++)
			{
				const tmpKey = tmpStorage.key(i);
				if (tmpKey && tmpKey.startsWith('HeadlightSpecScope:'))
				{
					tmpKeys.push(tmpKey);
				}
			}
			for (const tmpKey of tmpKeys)
			{
				tmpStorage.removeItem(tmpKey);
			}
		}
		catch (pError)
		{
			// fail open
		}
	}

	/**
	 * @param {number} pIDProject
	 * @param {{ TTLSeconds: number }} pCacheConfig
	 * @return {Record<string, any>|null} the cached project scope entry, or null.
	 */
	_readProjectScopeCache(pIDProject, pCacheConfig)
	{
		return this._readCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}Project:${pIDProject}`, pCacheConfig.TTLSeconds);
	}

	/**
	 * Persist the currently-resolved scope for a project. Plan entries are stored as
	 * [SampleType, IDLineItem, IDMaterial, IDTest] quads; HasSamplePlanData
	 * distinguishes "entries resolved (possibly empty)" from "never loaded" so a
	 * plan-scoped form can't hit an entry-less cache row.
	 *
	 * @param {number} pIDProject
	 */
	_writeProjectScopeCache(pIDProject)
	{
		const tmpCombos = this._Scope.SamplePlanCombos;
		this._writeCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}Project:${pIDProject}`,
		{
			TS: Date.now(),
			MaterialSetID: this._Scope.MaterialSetID || 0,
			Source: this._Scope.Source,
			HasSamplePlanData: Array.isArray(tmpCombos),
			SP: Array.isArray(tmpCombos) ? tmpCombos.map((pCombo) => [ pCombo.SampleType, pCombo.IDLineItem, pCombo.IDMaterial, pCombo.IDTest ]) : null,
		});
	}

	/**
	 * @param {Record<string, any>} pCachedEntry - entry with SP quads.
	 */
	_applySamplePlanFromCache(pCachedEntry)
	{
		this._applyPlanEntries(this._planEntriesFromRows(pCachedEntry.SP || [], (pQuad) => (
			{
				SampleType: pQuad[0],
				IDLineItem: pQuad[1],
				IDMaterial: pQuad[2],
				IDTest: pQuad[3],
			})), pCachedEntry.Source || 'None');
	}

	/**
	 * Resolve the bundle-execution configuration for cold loads. On by default;
	 * `SpecScopeBundle: { Enabled: false }` (manifest wins over provider
	 * options) pins the resolver to its per-entity reads.
	 *
	 * @return {{ Enabled: boolean }}
	 */
	_resolveBundleConfig()
	{
		const tmpManifest = this.pict?.views?.PictFormMetacontroller?.manifestDescription;
		const tmpSources =
		[
			tmpManifest && tmpManifest.SpecScopeBundle,
			(this.options || {}).SpecScopeBundle,
		];
		for (const tmpSource of tmpSources)
		{
			if (tmpSource && typeof tmpSource.Enabled === 'boolean')
			{
				return { Enabled: tmpSource.Enabled };
			}
		}
		return { Enabled: true };
	}

	/**
	 * @return {import('./PictProvider-EntityBundleClient.js')|null} the shared
	 * EntityBundleClient, self-registering it when the host app hasn't.
	 */
	_getEntityBundleClient()
	{
		if (this.pict?.providers?.EntityBundleClient)
		{
			return this.pict.providers.EntityBundleClient;
		}
		if (typeof this.pict?.addProvider === 'function')
		{
			this.pict.addProvider('EntityBundleClient', {}, require('./PictProvider-EntityBundleClient.js'));
			return this.pict.providers.EntityBundleClient || null;
		}
		return null;
	}

	/**
	 * Build the bundle steps equivalent to this load's per-entity reads: the project's
	 * plan rows, and the LineItem + PayItemMaterialTestRequirement rows the template
	 * fallback joins when there are none. Both are fetched unconditionally because the
	 * bundle is one round trip and the source choice happens client-side in
	 * _applyScopeBundleData. The customer Material step is omitted when the hierarchy is
	 * already resident or primeable from cache.
	 *
	 * @param {number} pIDProject
	 * @param {number} pIDCustomer
	 * @param {number} pMaterialSetID
	 * @return {Array<Record<string, any>>}
	 */
	_buildScopeBundleSteps(pIDProject, pIDCustomer, pMaterialSetID)
	{
		const tmpSteps =
		[
			{ Entity: 'ProjectLineItemMaterialTest', Filter: `FBV~IDProject~EQ~${pIDProject}`, Destination: 'Bundle.ProjectLineItemMaterialTest', AllRecords: true, Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'SampleType' ] } },
			{ Entity: 'LineItem', Filter: `FBV~IDProject~EQ~${pIDProject}`, Destination: 'Bundle.LineItem', AllRecords: true, Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'IDPayItem' ] } },
		];
		if (pMaterialSetID > 0)
		{
			// Narrowed to the pay items this project's line items actually name (PJU-chained off the
			// step above). The requirement rows the join can never reach are 41x the ones it can —
			// 61,480 set-wide against 1,487 for a large project on set 30 — and they are fetched on
			// every cold scope load, including the offline replay. The set filter stays alongside it:
			// a pay item can be named by a requirement row belonging to another set (set 32 carries
			// 318 rows against set 30's pay items), and only the set clause excludes those.
			tmpSteps.push(
				{
					Entity: 'PayItemMaterialTestRequirement',
					Filter: `FBV~IDTestSpecificationSet~EQ~${pMaterialSetID}~FBL~IDPayItem~INN~{~PJU:,^IDPayItem^Bundle.LineItem~}`,
					Destination: 'Bundle.PayItemMaterialTestRequirement',
					AllRecords: true,
					Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'IDPayItem', 'SampleType' ] },
				});
		}
		if (this._needsMaterialHierarchy() && pIDCustomer > 0 && !this._primeMaterialHierarchyFromCache(pIDCustomer))
		{
			tmpSteps.push({ Entity: 'Material', Filter: `FBV~IDCustomer~EQ~${pIDCustomer}`, Destination: 'Bundle.Material', AllRecords: true, Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'IDMaterialParent' ] } });
		}
		return tmpSteps;
	}

	/**
	 * Marshal executed-bundle data into the scope, applying the source choice locally:
	 * the project's own plan rows when it has any, else the template joined on IDPayItem.
	 *
	 * @param {Record<string, Array<any>>} pData - executed-bundle data keyed by entity.
	 * @param {number} pIDCustomer
	 */
	_applyScopeBundleData(pData, pIDCustomer)
	{
		if (Array.isArray(pData.Material) && pIDCustomer > 0)
		{
			const tmpPairs = [];
			for (const tmpRow of pData.Material)
			{
				const tmpID = parseInt(tmpRow.IDMaterial, 10) || 0;
				if (tmpID > 0)
				{
					tmpPairs.push([ tmpID, parseInt(tmpRow.IDMaterialParent, 10) || 0 ]);
				}
			}
			this._MaterialHierarchy = this._buildMaterialHierarchy(pIDCustomer, tmpPairs);
			if (this._resolveCacheConfig().Enabled)
			{
				this._writeCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}MaterialHierarchy:${pIDCustomer}`, { TS: Date.now(), Pairs: tmpPairs });
			}
		}
		const tmpPlanRows = pData.ProjectLineItemMaterialTest || [];
		if (tmpPlanRows.length > 0)
		{
			this._applyPlanEntries(this._planEntriesFromRows(tmpPlanRows), 'Plan');
			return;
		}
		this._applyPlanEntries(
			this._joinTemplateEntries(pData.LineItem || [], pData.PayItemMaterialTestRequirement || []),
			this._Scope.MaterialSetID > 0 ? 'Template' : 'None');
	}

	/**
	 * Join specification requirements to a project's line items on IDPayItem — the
	 * client-side half of the template source, for the bundle transport that has no
	 * server to do it. Mirrors the platform endpoint's join, including its exclusions:
	 * a line item with no pay item contributes nothing (and so does not constrain
	 * itself), and a requirement with a zero material or test id is a plan defect
	 * rather than a scope fact.
	 *
	 * @param {Array<Record<string, any>>} pLineItems
	 * @param {Array<Record<string, any>>} pRequirements
	 * @return {Array<PlanEntry>} distinct on (IDLineItem, IDMaterial, IDTest, SampleType).
	 */
	_joinTemplateEntries(pLineItems, pRequirements)
	{
		/** @type {Map<number, Array<number>>} */
		const tmpLineItemIDsByPayItem = new Map();
		for (const tmpRow of pLineItems)
		{
			const tmpIDLineItem = parseInt(tmpRow.IDLineItem, 10) || 0;
			const tmpIDPayItem = parseInt(tmpRow.IDPayItem, 10) || 0;
			if (!(tmpIDLineItem > 0) || !(tmpIDPayItem > 0))
			{
				continue;
			}
			if (!tmpLineItemIDsByPayItem.has(tmpIDPayItem))
			{
				tmpLineItemIDsByPayItem.set(tmpIDPayItem, []);
			}
			tmpLineItemIDsByPayItem.get(tmpIDPayItem).push(tmpIDLineItem);
		}
		const tmpSeen = new Set();
		const tmpEntries = [];
		for (const tmpRow of pRequirements)
		{
			const tmpIDMaterial = parseInt(tmpRow.IDMaterial, 10) || 0;
			const tmpIDTest = parseInt(tmpRow.IDTest, 10) || 0;
			if (!(tmpIDMaterial > 0) || !(tmpIDTest > 0))
			{
				continue;
			}
			const tmpSampleType = tmpRow.SampleType || '';
			for (const tmpIDLineItem of (tmpLineItemIDsByPayItem.get(parseInt(tmpRow.IDPayItem, 10) || 0) || []))
			{
				const tmpKey = `${tmpIDLineItem}|${tmpIDMaterial}|${tmpIDTest}|${tmpSampleType}`;
				if (tmpSeen.has(tmpKey))
				{
					continue;
				}
				tmpSeen.add(tmpKey);
				tmpEntries.push({ SampleType: tmpSampleType, IDLineItem: tmpIDLineItem, IDMaterial: tmpIDMaterial, IDTest: tmpIDTest });
			}
		}
		return tmpEntries;
	}

	/**
	 * Ancestor material IDs (walk IDMaterialParent up), excluding self. Empty when no hierarchy
	 * is loaded (fail-open — no expansion). Cycle-guarded.
	 *
	 * @param {number|string} pIDMaterial
	 * @return {Set<number>}
	 */
	getMaterialAncestorIDs(pIDMaterial)
	{
		const tmpResult = new Set();
		if (!this._MaterialHierarchy)
		{
			return tmpResult;
		}
		let tmpCurrent = parseInt(String(pIDMaterial), 10) || 0;
		let tmpGuard = 0;
		while (tmpCurrent > 0 && tmpGuard++ < 64)
		{
			const tmpParent = this._MaterialHierarchy.ParentOf.get(tmpCurrent) || 0;
			if (!(tmpParent > 0) || tmpResult.has(tmpParent))
			{
				break;
			}
			tmpResult.add(tmpParent);
			tmpCurrent = tmpParent;
		}
		return tmpResult;
	}

	/**
	 * Descendant material IDs (walk children down, transitive), excluding self. Empty when no
	 * hierarchy is loaded (fail-open). Cycle-guarded by the visited set.
	 *
	 * @param {number|string} pIDMaterial
	 * @return {Set<number>}
	 */
	getMaterialDescendantIDs(pIDMaterial)
	{
		const tmpResult = new Set();
		if (!this._MaterialHierarchy)
		{
			return tmpResult;
		}
		const tmpStack = [ parseInt(String(pIDMaterial), 10) || 0 ];
		while (tmpStack.length > 0)
		{
			const tmpChildren = this._MaterialHierarchy.ChildrenOf.get(tmpStack.pop());
			if (!tmpChildren)
			{
				continue;
			}
			for (const tmpChild of tmpChildren)
			{
				if (!tmpResult.has(tmpChild))
				{
					tmpResult.add(tmpChild);
					tmpStack.push(tmpChild);
				}
			}
		}
		return tmpResult;
	}

	/**
	 * Expand material anchors UP: the anchors plus all their ancestors. Used when a selected
	 * material is PUSHED as a filter to another input — the parent categories match too, so a
	 * leaf selection surfaces records bound to its category. Accepts a Set, array, comma-joined
	 * id string (a Multiple selector's value), or a single id; returns the union as a Set.
	 *
	 * @param {Iterable<number|string>|string|number} pIDs
	 * @return {Set<number>}
	 */
	expandMaterialAnchorsUp(pIDs)
	{
		const tmpResult = new Set();
		for (const tmpID of this._coerceMaterialIDList(pIDs))
		{
			tmpResult.add(tmpID);
			for (const tmpAncestor of this.getMaterialAncestorIDs(tmpID))
			{
				tmpResult.add(tmpAncestor);
			}
		}
		return tmpResult;
	}

	/**
	 * Expand an allowed material set DOWN: the set plus all descendants. Used when a dropdown
	 * filters its items by a material set — an item bound to one of the materials OR any child
	 * material is allowed. Accepts a Set, array, comma-joined id string, or a single id.
	 *
	 * @param {Iterable<number|string>|string|number} pIDs
	 * @return {Set<number>}
	 */
	expandMaterialSetDown(pIDs)
	{
		const tmpResult = new Set();
		for (const tmpID of this._coerceMaterialIDList(pIDs))
		{
			tmpResult.add(tmpID);
			for (const tmpDescendant of this.getMaterialDescendantIDs(tmpID))
			{
				tmpResult.add(tmpDescendant);
			}
		}
		return tmpResult;
	}

	/**
	 * Normalize a Set / array / comma-joined string / number into an array of positive ints.
	 *
	 * @param {Iterable<number|string>|string|number} pIDs
	 * @return {number[]}
	 */
	_coerceMaterialIDList(pIDs)
	{
		if (pIDs === null || pIDs === undefined)
		{
			return [];
		}
		let tmpRaw;
		if (typeof pIDs === 'string')
		{
			tmpRaw = pIDs.split(',');
		}
		else if (typeof pIDs === 'number')
		{
			tmpRaw = [ pIDs ];
		}
		else
		{
			tmpRaw = Array.from(pIDs);
		}
		const tmpResult = [];
		for (const tmpValue of tmpRaw)
		{
			const tmpID = parseInt(String(tmpValue).trim(), 10) || 0;
			if (tmpID > 0)
			{
				tmpResult.push(tmpID);
			}
		}
		return tmpResult;
	}

	/**
	 * Whether any descriptor on the loaded form carries a DynamicFilters entry matching
	 * a predicate. Returns false when no manifest is available.
	 *
	 * @param {(pFilter: Record<string, any>) => boolean} fPredicate
	 * @return {boolean}
	 */
	_hasDynamicFilter(fPredicate)
	{
		const tmpDescriptors = this.pict?.views?.PictFormMetacontroller?.manifestDescription?.Descriptors;
		if (!tmpDescriptors)
		{
			return false;
		}
		for (const tmpDescriptor of Object.values(tmpDescriptors))
		{
			const tmpFilters = tmpDescriptor?.PictForm?.DynamicFilters;
			if (Array.isArray(tmpFilters) && tmpFilters.some((pFilter) => !!pFilter && fPredicate(pFilter)))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * Whether the loaded form has a plan-scoped selector — a descriptor with a
	 * SamplePlanScope entry in its PictForm.DynamicFilters. Gates the plan-entry reads so
	 * forms that don't use them pay nothing.
	 *
	 * @return {boolean}
	 */
	_needsSamplePlan()
	{
		return this._hasDynamicFilter((pFilter) => !!pFilter.SamplePlanScope);
	}

	/**
	 * Whether any filter on the form expands a material anchor through the material tree
	 * — the plan scopes, and a Through hop keyed on IDMaterial.
	 *
	 * @return {boolean}
	 */
	_needsMaterialHierarchy()
	{
		return this._needsSamplePlan() || this._hasDynamicFilter((pFilter) => !!pFilter.Through && pFilter.ThroughKey === 'IDMaterial');
	}

	/**
	 * Resolve the project's plan entries from the per-entity reads. The project's own
	 * ProjectLineItemMaterialTest rows win when it has any; otherwise the platform
	 * derives the template from the contract's specification set. Uses the
	 * LiteExtended/SampleType projection — Lite carries the IDs but not the SampleType
	 * Hash; LiteExtended/SampleType adds it while staying offline-servable.
	 *
	 * @param {number} pIDProject
	 * @return {Promise<{ Combos: Array<PlanEntry>, Source: PlanEntrySource }>}
	 */
	async _loadSamplePlan(pIDProject)
	{
		const tmpRows = await this._readAllPages('ProjectLineItemMaterialTests/LiteExtended/SampleType', `FBV~IDProject~EQ~${pIDProject}`);
		if (tmpRows.length > 0)
		{
			return { Combos: this._planEntriesFromRows(tmpRows), Source: 'Plan' };
		}
		return this._loadTemplateEntries(pIDProject);
	}

	/**
	 * Ask the platform for the specification template governing a project with no plan.
	 * Fails open on a missing or erroring endpoint — a client running ahead of the
	 * platform must leave its pickers unnarrowed, not blank them.
	 *
	 * @param {number} pIDProject
	 * @return {Promise<{ Combos: Array<PlanEntry>, Source: PlanEntrySource }>}
	 */
	async _loadTemplateEntries(pIDProject)
	{
		try
		{
			const tmpResponse = await this._getJSON(`TestSpecificationSet/PlanEntries/ForProject/${pIDProject}`);
			return {
				Combos: this._planEntriesFromRows(tmpResponse?.Entries || []),
				Source: tmpResponse?.Source || 'None',
			};
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Plan-entry template load failed for project ${pIDProject} (fail-open): ${pError?.message || pError}`);
			return { Combos: [], Source: 'None' };
		}
	}

	/**
	 * Normalize rows from any transport into plan entries.
	 *
	 * @param {Array<any>} pRows
	 * @param {(pRow: any) => Record<string, any>} [fPick] - maps a row onto the four fields.
	 * @return {Array<PlanEntry>}
	 */
	_planEntriesFromRows(pRows, fPick)
	{
		return pRows.map((pRow) =>
		{
			const tmpRow = fPick ? fPick(pRow) : pRow;
			return {
				SampleType: tmpRow.SampleType || '',
				IDLineItem: parseInt(tmpRow.IDLineItem, 10) || 0,
				IDMaterial: parseInt(tmpRow.IDMaterial, 10) || 0,
				IDTest: parseInt(tmpRow.IDTest, 10) || 0,
			};
		});
	}

	/**
	 * Resolve the allowed IDs for one plan axis (pField), narrowed by whatever
	 * upstream keys are supplied in pKeys. An absent / empty / zero key does not
	 * narrow on that axis (so the top of the cascade returns the whole plan set).
	 * Returns null when no plan is loaded — the fail-open signal.
	 *
	 * @param {('IDLineItem'|'IDMaterial'|'IDTest')} pField
	 * @param {{SampleType?:string, IDLineItem?:number, IDMaterial?:number, IDTest?:number}} pKeys
	 * @return {Set<number>|null}
	 */
	_samplePlanIDs(pField, pKeys)
	{
		if (!this._Scope.HasSamplePlan || !Array.isArray(this._Scope.SamplePlanCombos))
		{
			return null;
		}
		// Normalize each provided key to a Set of accepted values. A Multiple selector
		// (e.g. the LineItem picker) hands a comma-joined list like "12,34", so a key may
		// accept several values (union/IN). An absent / empty / zero key does not narrow.
		const tmpKeySets = {};
		for (const tmpKey of Object.keys(pKeys))
		{
			const tmpRaw = pKeys[tmpKey];
			if (tmpRaw === null || tmpRaw === undefined || tmpRaw === '' || tmpRaw === 0)
			{
				continue;
			}
			const tmpValues = String(tmpRaw).split(',').map((pValue) => pValue.trim()).filter((pValue) => pValue !== '' && pValue !== '0');
			if (tmpValues.length === 0)
			{
				continue;
			}
			if (tmpKey === 'SampleType')
			{
				tmpKeySets[tmpKey] = new Set(tmpValues);
				continue;
			}
			// Numeric axes (IDLineItem / IDMaterial / IDTest). A non-numeric anchor — e.g. a hash-keyed Test
			// selector handing "D5249v1" — would parseInt to NaN and match no plan combo, wrongly constraining the
			// dependent dropdown to none. Drop non-numeric values; if none remain, this axis simply does not narrow
			// (the same fail-open as an absent / empty / zero key) rather than blanking the dropdown.
			const tmpNumeric = tmpValues.map((pValue) => parseInt(pValue, 10)).filter((pValue) => !Number.isNaN(pValue));
			if (tmpNumeric.length === 0)
			{
				continue;
			}
			tmpKeySets[tmpKey] = new Set(tmpNumeric);
		}
		const tmpResult = new Set();
		for (const tmpCombo of this._Scope.SamplePlanCombos)
		{
			let tmpMatch = true;
			for (const tmpKey of Object.keys(tmpKeySets))
			{
				const tmpComboValue = (tmpKey === 'SampleType') ? String(tmpCombo.SampleType) : tmpCombo[tmpKey];
				if (!tmpKeySets[tmpKey].has(tmpComboValue))
				{
					tmpMatch = false;
					break;
				}
			}
			if (tmpMatch && tmpCombo[pField] > 0)
			{
				tmpResult.add(tmpCombo[pField]);
			}
		}
		return tmpResult;
	}

	/**
	 * Allowed LineItem IDs from the sampling plan, narrowed by SampleType and/or
	 * the selected Material / Test (bidirectional plan cross-filter). Null when no
	 * plan (fail-open).
	 *
	 * @param {string} [pSampleType]
	 * @param {number} [pIDMaterial]
	 * @param {number} [pIDTest]
	 * @return {Set<number>|null}
	 */
	getSamplePlanLineItemIDs(pSampleType, pIDMaterial, pIDTest)
	{
		return this._samplePlanIDs('IDLineItem', { SampleType: pSampleType, IDMaterial: pIDMaterial, IDTest: pIDTest });
	}

	/**
	 * Allowed Material IDs from the sampling plan, narrowed by SampleType and/or
	 * the selected LineItem / Test (bidirectional plan cross-filter). Null when no
	 * plan (fail-open).
	 *
	 * @param {string} [pSampleType]
	 * @param {number} [pIDLineItem]
	 * @param {number} [pIDTest]
	 * @return {Set<number>|null}
	 */
	getSamplePlanMaterialIDs(pSampleType, pIDLineItem, pIDTest)
	{
		return this._samplePlanIDs('IDMaterial', { SampleType: pSampleType, IDLineItem: pIDLineItem, IDTest: pIDTest });
	}

	/**
	 * Allowed Test IDs from the sampling plan, narrowed by SampleType, LineItem,
	 * and/or Material. Null when no plan (fail-open).
	 *
	 * @param {string} [pSampleType]
	 * @param {number} [pIDLineItem]
	 * @param {number} [pIDMaterial]
	 * @return {Set<number>|null}
	 */
	getSamplePlanTestIDs(pSampleType, pIDLineItem, pIDMaterial)
	{
		return this._samplePlanIDs('IDTest', { SampleType: pSampleType, IDLineItem: pIDLineItem, IDMaterial: pIDMaterial });
	}

	/**
	 * Resolve a contract's specification-set reference. Two-tiered: the direct
	 * IDTestSpecificationSet FK wins; when it's unset, fall back to matching a
	 * TestSpecificationSet by the contract's spec Year. Returns 0 when neither
	 * referent is set (the template source then does not apply).
	 *
	 * @param {Record<string, any>} pContract
	 * @param {string} pIDField - direct set-ID field, e.g. 'MaterialIDTestSpecificationSet'.
	 * @param {string} pYearField - specification-year field, e.g. 'MaterialsSpecificationYear'.
	 * @return {Promise<number>}
	 */
	async _resolveSetID(pContract, pIDField, pYearField)
	{
		const tmpDirectID = parseInt(pContract?.[pIDField], 10) || 0;
		if (tmpDirectID > 0)
		{
			return tmpDirectID;
		}
		const tmpYearValue = pContract?.[pYearField];
		if (tmpYearValue == null)
		{
			return 0;
		}
		const tmpYear = String(tmpYearValue).trim();
		if (tmpYear === '' || tmpYear === '0')
		{
			return 0;
		}
		// A year is NOT unique: a customer may run a provisional set alongside the live one for the same year.
		// Nothing on TestSpecificationSet distinguishes them, so take the lowest id — the earliest set for the
		// year — and say so when the year is ambiguous rather than resolving it silently.
		const tmpSets = await this._readAllPages('TestSpecificationSets/LiteExtended/Year', `FBV~Year~EQ~${encodeURIComponent(tmpYear)}~FSF~IDTestSpecificationSet~ASC~0`);
		if (tmpSets.length > 1)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Specification year ${tmpYear} matches ${tmpSets.length} specification sets; using the lowest id (${tmpSets[0]?.IDTestSpecificationSet}). Set the contract's ${pIDField} to resolve this explicitly.`);
		}
		return parseInt(tmpSets[0]?.IDTestSpecificationSet, 10) || 0;
	}

	/**
	 * Page through a filtered meadow read until exhausted. Plain FilteredTo
	 * reads (no Count/aggregate route) so the offline client can serve them
	 * from synced entity data.
	 *
	 * @param {string} pEntityRoute - pluralized route incl. projection, e.g. 'PayItems/Lite'.
	 * @param {string} pFilter - meadow filter stanza, e.g. 'FBV~IDTestSpecificationSet~EQ~12'.
	 * @return {Promise<Array<any>>}
	 */
	async _readAllPages(pEntityRoute, pFilter)
	{
		const tmpRows = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpPage = await this._getJSON(`${pEntityRoute}/FilteredTo/${pFilter}/${tmpOffset}/${SPEC_SCOPE_PAGE_SIZE}`);
			if (!Array.isArray(tmpPage) || tmpPage.length === 0)
			{
				break;
			}
			for (const tmpRow of tmpPage)
			{
				tmpRows.push(tmpRow);
			}
			if (tmpPage.length < SPEC_SCOPE_PAGE_SIZE)
			{
				break;
			}
			tmpOffset += SPEC_SCOPE_PAGE_SIZE;
		}
		return tmpRows;
	}

	/**
	 * @param {Array<any>} pValues
	 * @return {Array<number>} distinct positive integers.
	 */
	_distinctPositive(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of pValues)
		{
			const tmpNumber = parseInt(tmpValue, 10);
			if (tmpNumber > 0)
			{
				tmpSet.add(tmpNumber);
			}
		}
		return Array.from(tmpSet);
	}

	_getJSON(pUrl)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pUrl, (err, body) =>
			{
				if (err)
				{
					return reject(err);
				}
				resolve(body);
			});
		});
	}

	/**
	 * @return {Set<number>|null} Allowed lab IDs — labs joined to the material spec set via
	 * LabTestSpecificationSetJoin — when the set has lab-join coverage, else null (no constraint).
	 */
	getAllowedLabIDs()
	{
		return this._Scope.HasLabCoverage ? this._Scope.AllowedLabIDs : null;
	}

	/**
	 * Floor the lab axis to labs joined to the resolved material spec set (LabTestSpecificationSetJoin). Fails open:
	 * on no set, empty coverage, or a read error, getAllowedLabIDs returns null and the lab picker is unconstrained.
	 * @return {Promise<void>}
	 */
	async _loadLabScope()
	{
		const tmpSetID = this._Scope.MaterialSetID;
		if (!(tmpSetID > 0))
		{
			return;
		}
		try
		{
			const tmpRows = await this._readAllPages('LabTestSpecificationSetJoins/Lite', `FBV~IDTestSpecificationSet~EQ~${tmpSetID}`);
			this._Scope.AllowedLabIDs = new Set(this._distinctPositive(tmpRows.map((pRow) => pRow.IDLab)));
			this._Scope.HasLabCoverage = this._Scope.AllowedLabIDs.size > 0;
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Lab scope load failed (fail-open): ${pError?.message || pError}`);
		}
	}

	/**
	 * @return {PlanEntrySource} which source answered for the loaded project. No picker
	 * reads this; it is what answers "why can't I pick this".
	 */
	getSource()
	{
		return this._Scope.Source;
	}

	/**
	 * @return {boolean} True when resolver has completed its load attempt.
	 */
	isLoaded()
	{
		return this._Scope.Loaded;
	}

	/**
	 * App-load hook — auto-prime scope from whatever sample/project the
	 * loaded form points at. Fires automatically because PictProvider
	 * defaults `AutoLoadDataWithApp: true`. We don't override that flag,
	 * so we participate in the load cycle without host-app changes.
	 *
	 * Resolution strategy (mirrors Materials-Form-Manager.js:605-626 for
	 * the manifest walk, then falls back to legacy + document-level addresses):
	 *
	 *   1. Walk manifest descriptors for a sample-bearing InputType
	 *      (SampleSelector / MaterialsSampleSelector / MaterialsHiddenSampleSelector,
	 *      plus EntitySelector / EntitySelectorMultiple with Entity='Sample').
	 *   2. First match wins. If a __Record companion exists at
	 *      `<DataAddress>__Record`, forward via loadForSampleRecord (no
	 *      extra REST). Else read the bare value and forward via
	 *      loadForSampleByIdentifier with the descriptor's IdentityField.
	 *   3. Hard-coded legacy fallback: `SampleID__Record`.
	 *   4. Final fallback: `ReportData.IDProject` → loadForProject.
	 *   5. No suitable signal: silently skip (host apps that already call
	 *      loadForProject explicitly continue to work; resolver dedupes).
	 *
	 * Failure here is non-fatal — the resolver fails open and pickers
	 * see the full catalog.
	 *
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			this._resolveSpecScopeFromForm().catch((err) =>
			{
				this.pict?.log?.warn(`[SpecScopeResolver] Auto-resolve on app load failed: ${err?.message || err}`);
			}).finally(() =>
			{
				fCallback();
			});
		});
	}

	/**
	 * @return {Promise<void>}
	 */
	async _resolveSpecScopeFromForm()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		const tmpFormData = tmpReportData?.FormData;
		const tmpInfo = this._findSampleDescriptorInfo();
		if (tmpInfo && tmpFormData)
		{
			const tmpRecord = this.pict.manifest.getValueAtAddress(tmpFormData, `${tmpInfo.dataAddress}__Record`);
			if (tmpRecord && tmpRecord.IDProject > 0)
			{
				await this.loadForSampleRecord(tmpRecord);
				return;
			}
			const tmpValue = this.pict.manifest.getValueAtAddress(tmpFormData, tmpInfo.dataAddress);
			if (tmpValue)
			{
				await this.loadForSampleByIdentifier(tmpValue, tmpInfo.identityField);
				return;
			}
		}
		// Legacy fallback. Older forms without a discoverable sample-selector
		// descriptor sometimes still maintain a SampleID__Record companion.
		const tmpLegacyRecord = tmpFormData ? this.pict.manifest.getValueAtAddress(tmpFormData, 'SampleID__Record') : null;
		if (tmpLegacyRecord && tmpLegacyRecord.IDProject > 0)
		{
			await this.loadForSampleRecord(tmpLegacyRecord);
			return;
		}
		// Final fallback: document-level project. Forms with no sample concept
		// at all (e.g. document-level reports) still get scope from this path.
		const tmpDocProjectID = parseInt(tmpReportData?.IDProject, 10) || 0;
		if (tmpDocProjectID > 0)
		{
			await this.loadForProject(tmpDocProjectID);
		}
	}

	/**
	 * @return {{ dataAddress: string, identityField: string }|null}
	 */
	_findSampleDescriptorInfo()
	{
		const tmpManifest = this.pict.views?.PictFormMetacontroller?.manifestDescription;
		if (!tmpManifest || !tmpManifest.Descriptors)
		{
			return null;
		}
		const SAMPLE_INPUT_TYPES = new Set(
			[ 'SampleSelector', 'MaterialsSampleSelector', 'MaterialsHiddenSampleSelector' ]);
		// Materials* selectors store GUIDSample by default (see
		// _getDefaultRecordIdentity in PictProvider-InputType-MaterialsSampleSelector.js
		// line 28). SampleSelector and EntitySelector default to IDSample.
		const MATERIALS_SAMPLE_SELECTORS = new Set(
			[ 'MaterialsSampleSelector', 'MaterialsHiddenSampleSelector' ]);
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpManifest.Descriptors))
		{
			const tmpInputType = tmpDescriptor.PictForm?.InputType;
			const tmpEntity = tmpDescriptor.PictForm?.Entity;
			const tmpIsExplicit = SAMPLE_INPUT_TYPES.has(tmpInputType);
			const tmpIsGeneric = (tmpInputType === 'EntitySelector' || tmpInputType === 'EntitySelectorMultiple') && tmpEntity === 'Sample';
			if (tmpIsExplicit || tmpIsGeneric)
			{
				let tmpIdentityField = tmpDescriptor.PictForm?.IdentityField;
				if (!tmpIdentityField)
				{
					tmpIdentityField = MATERIALS_SAMPLE_SELECTORS.has(tmpInputType) ? 'GUIDSample' : 'IDSample';
				}
				return {
					dataAddress: tmpDescriptor.DataAddress || tmpKey,
					identityField: tmpIdentityField,
				};
			}
		}
		return null;
	}

	/**
	 * Convenience for callers that already have a Sample record in hand
	 * (e.g. MaterialsSampleSelector after _onRecordRefresh). Pulls IDProject
	 * off the record and forwards to loadForProject. No-op when the record
	 * is missing or doesn't carry a populated IDProject.
	 *
	 * @param {Record<string, any>} pSampleRecord
	 * @return {Promise<object>} the scope snapshot
	 */
	loadForSampleRecord(pSampleRecord)
	{
		const tmpIDProject = parseInt(pSampleRecord?.IDProject, 10) || 0;
		if (!(tmpIDProject > 0))
		{
			return Promise.resolve(this._Scope);
		}
		return this.loadForProject(tmpIDProject);
	}

	/**
	 * Convenience for callers that have a Sample identifier (typically
	 * IDSample, sometimes GUIDSample for not-yet-saved samples). Fetches
	 * the matching Sample row by the named identity field and forwards
	 * to loadForSampleRecord.
	 *
	 * Selectors that store IDSample (SampleSelector, EntitySelector with
	 * default IdentityField) call with `pIdentityField='IDSample'`.
	 * MaterialsSampleSelector stores GUIDSample but it has the record in
	 * hand, so it uses loadForSampleRecord directly. EntitySelector with a
	 * non-default IdentityField passes that through.
	 *
	 * @param {string|number} pSampleIdentifier
	 * @param {string} [pIdentityField='IDSample']
	 * @return {Promise<object>} the scope snapshot
	 */
	async loadForSampleByIdentifier(pSampleIdentifier, pIdentityField = 'IDSample')
	{
		if (pSampleIdentifier === null || pSampleIdentifier === undefined || pSampleIdentifier === '' || pSampleIdentifier === 'null')
		{
			return this._Scope;
		}
		try
		{
			const tmpRows = await this._getJSON(`Samples/FilteredTo/FBV~${pIdentityField}~EQ~${encodeURIComponent(pSampleIdentifier)}`);
			const tmpRecord = Array.isArray(tmpRows) ? tmpRows[0] : tmpRows;
			return this.loadForSampleRecord(tmpRecord);
		}
		catch (err)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Failed to fetch Sample (${pIdentityField}=${pSampleIdentifier}): ${err?.message || err}`);
			return this._Scope;
		}
	}
}

module.exports = SpecScopeResolver;

},{"./PictProvider-EntityBundleClient.js":42,"pict-provider":479}],129:[function(require,module,exports){

const libPictTemplate = require('pict-template');

class PictTemplateProviderHumanCount extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HumanCount:', '~}');
	}

	/**
	 * Format count as human-readable text (ex. 135k, 257M).
	 *
	 * @param {number} count - Count to summarize.
	 * @param {number} [dp] - Number of decimal places to display.
	 *
	 * @return {string} Human-readable text.
	 */
	humanFileSize(count, dp = 1)
	{
		const thresh = 1000;

		if (Math.abs(count) < thresh)
		{
			return String(count);
		}

		const units = [ 'k', 'M', 'B' ];
		let u = -1;
		const r = 10 ** dp;

		do
		{
			count /= thresh;
			++u;
		}
		while (Math.round(Math.abs(count) * r) / r >= thresh && u < units.length - 1);


		return count.toFixed(dp) + units[u];
	}

	render(pTemplateHash, pRecord, pContextArray)
	{
		const [ tmpHash, tmpPrecision ] = pTemplateHash.trim().split('^');
		const tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fHumanCount]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fHumanCount]::[${tmpHash}]`);
		}

		let tmpValue;
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray);
		}
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined'))
		{
			return '';
		}
		return this.humanFileSize(tmpValue, tmpPrecision ? parseInt(tmpPrecision) : 1);
	}
}

module.exports = PictTemplateProviderHumanCount;

},{"pict-template":691}],130:[function(require,module,exports){
// Resolver behind the `{~LinkTarget:Record~}` macro used by the Link InputType templates.
// Kept as a plain module (not a pict-template class) so the whitelist logic is unit-testable
// without standing up the bundle.

const _VALID_LINK_TARGETS = [ '_blank', '_self', '_parent', '_top' ];

/**
 * Resolve a descriptor's PictForm.LinkTarget into anchor attributes.
 *
 * The return value is spliced into raw markup, so the author's string is never echoed through --
 * only whitelisted targets are emitted. Absent or out-of-domain values yield '' (no attribute),
 * preserving the same-tab default rather than rendering target="".
 *
 * @param {any} pDescriptor - The form descriptor (the `Record` the macro resolves).
 * @return {string} The attribute fragment, or '' when no target applies.
 */
const resolveLinkTargetAttributes = (pDescriptor) =>
{
	const tmpTarget = pDescriptor?.PictForm?.LinkTarget;
	if (typeof tmpTarget !== 'string')
	{
		return '';
	}
	const tmpNormalizedTarget = tmpTarget.trim().toLowerCase();
	if (_VALID_LINK_TARGETS.indexOf(tmpNormalizedTarget) < 0)
	{
		return '';
	}
	// A new browsing context needs the rel guard against reverse tabnabbing.
	return (tmpNormalizedTarget === '_blank') ? 'target="_blank" rel="noopener noreferrer"' : `target="${tmpNormalizedTarget}"`;
};

module.exports = { resolveLinkTargetAttributes: resolveLinkTargetAttributes, VALID_LINK_TARGETS: _VALID_LINK_TARGETS };

},{}],131:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const THROUGH_PAGE_SIZE = 500;

/**
 * @typedef {object} ThroughFilterConfig
 * @property {string} Through - bridge entity (singular; the route pluralizes it), e.g. 'OrganizationMaterialJoin'.
 * @property {string} ThroughKey - bridge column matched against the live anchor value, e.g. 'IDMaterial'.
 * @property {string} ThroughSelect - bridge column projected into the IN-list, e.g. 'IDOrganization'.
 * @property {string} [FromField] - manifest address of the anchor value (the picked upstream sibling).
 * @property {string} Field - the filtered picker's own column the INN clause targets, e.g. 'IDOrganization'.
 * @property {('map'|'query')} Strategy - 'map' lazy-loads the whole bridge once; 'query' fetches per-anchor slices.
 * @property {string} [ThroughFilter] - extra static bridge scope, ANDed in. No default: soft-deleted rows are
 *   excluded server-side (foxhound adds the predicate for any schema carrying a Deleted column).
 * @property {string} [ThroughProjection] - read projection (default 'Lite').
 */

/**
 * ThroughScopeResolver — generic indirect ("chained") filter resolver. Lets a
 * picker narrow by a relationship that has no direct FK on the filtered entity,
 * by hopping through a bridge table. A DynamicFilters entry of the shape
 * {@link ThroughFilterConfig} narrows `Field` to the `ThroughSelect` values
 * found in `Through` where `ThroughKey` equals the live anchor at `FromField`.
 *
 * Both strategies resolve to a SYNCHRONOUS id-set read at filter-assembly time
 * (Select2Util.applyDynamicFilters is synchronous):
 *
 *   - 'map'   — lazy-load the whole bridge once (per Through+scope), build
 *               Map<ThroughKey → Set<ThroughSelect>> + the union of all selects,
 *               cache. For small bridge tables. Primed on app load for every
 *               map-Through on the loaded form. With no anchor, the union set is
 *               returned (the "only rows that participate at all" relevance case).
 *   - 'query' — fetch only `Through WHERE ThroughKey = anchor` on demand and
 *               cache the slice keyed by the anchor value. For large bridge
 *               tables where a wholesale load is too costly (e.g.
 *               OrganizationMaterialJoin, ~52k rows). Primed by Select2Util's
 *               transport (the async seam) right before the dependent read.
 *
 * Fail-open like SpecScopeResolver: an unloaded slice / empty result returns
 * null, so the dispatch omits the clause and the picker shows its full set
 * (recoverable via Show All regardless).
 *
 * Consumers:
 *   resolver.primeMapScope(filter)             // app load (map only)
 *   resolver.primeThroughSlice(filter, anchor) // transport, await (query only)
 *   resolver.getThroughIDs(filter, anchor)     // sync: Set<number> | null
 */
class ThroughScopeResolver extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		/** @type {Record<string, { Loaded: boolean, LoadPromise: Promise<void>|null, Forward: Map<string, Set<number>>, AllSelects: Set<number> }>} */
		this._MapScopes = {};
		/** @type {Record<string, { Slices: Map<string, Set<number>>, Pending: Map<string, Promise<void>> }>} */
		this._QueryScopes = {};
	}

	/**
	 * Cache key for a Through filter — the bridge entity, the directed key→select
	 * pair, and the static scope. Same for both strategies (a filter only uses one).
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @return {string}
	 */
	_cacheKey(pFilter)
	{
		return `${pFilter.Through}|${pFilter.ThroughKey}>${pFilter.ThroughSelect}|${pFilter.ThroughFilter || ''}`;
	}

	/**
	 * Synchronous allowed-id lookup for a Through filter at an anchor value.
	 * Returns Set<number> when resolved, or null (fail-open) when not yet loaded
	 * or the config is incomplete.
	 *
	 *   - map, no anchor  → union of all selects (relevance: rows that participate).
	 *   - map, anchor     → the anchor's select set (empty Set when the anchor maps to none).
	 *   - query, no anchor→ null (query needs an anchor to have fetched a slice).
	 *   - query, anchor   → the cached slice, or null until primeThroughSlice resolves.
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @param {string|number} pAnchorValue
	 * @return {Set<number>|null}
	 */
	getThroughIDs(pFilter, pAnchorValue)
	{
		if (!pFilter || !pFilter.Through || !pFilter.ThroughKey || !pFilter.ThroughSelect)
		{
			return null;
		}
		const tmpAnchor = (pAnchorValue === null || pAnchorValue === undefined) ? '' : String(pAnchorValue).trim();
		const tmpHasAnchor = (tmpAnchor !== '' && tmpAnchor !== '0');
		if (pFilter.Strategy === 'map')
		{
			const tmpScope = this._MapScopes[this._cacheKey(pFilter)];
			if (!tmpScope || !tmpScope.Loaded)
			{
				return null;
			}
			if (!tmpHasAnchor)
			{
				return tmpScope.AllSelects;
			}
			return tmpScope.Forward.get(tmpAnchor) || new Set();
		}
		// query
		if (!tmpHasAnchor)
		{
			return null;
		}
		const tmpScope = this._QueryScopes[this._cacheKey(pFilter)];
		const tmpSlice = tmpScope ? tmpScope.Slices.get(tmpAnchor) : undefined;
		return tmpSlice || null;
	}

	/**
	 * Ensure the query-strategy slice for (filter, anchor) is loaded + cached.
	 * Idempotent and de-duped per anchor (concurrent calls share one fetch). No-op
	 * for the map strategy (those prime on app load). Awaited by the transport
	 * before the dependent picker reads, so getThroughIDs resolves synchronously.
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @param {string|number} pAnchorValue
	 * @return {Promise<void>}
	 */
	async primeThroughSlice(pFilter, pAnchorValue)
	{
		if (!pFilter || pFilter.Strategy !== 'query' || !pFilter.Through || !pFilter.ThroughKey || !pFilter.ThroughSelect)
		{
			return;
		}
		const tmpAnchor = (pAnchorValue === null || pAnchorValue === undefined) ? '' : String(pAnchorValue).trim();
		if (tmpAnchor === '' || tmpAnchor === '0')
		{
			return;
		}
		const tmpKey = this._cacheKey(pFilter);
		const tmpScope = this._QueryScopes[tmpKey] || (this._QueryScopes[tmpKey] = { Slices: new Map(), Pending: new Map() });
		if (tmpScope.Slices.has(tmpAnchor))
		{
			return;
		}
		if (tmpScope.Pending.has(tmpAnchor))
		{
			return tmpScope.Pending.get(tmpAnchor);
		}
		const tmpPromise = this._loadSlice(pFilter, tmpAnchor)
			.then((pSet) => { tmpScope.Slices.set(tmpAnchor, pSet); })
			.catch((pErr) =>
			{
				this.pict?.log?.warn(`[ThroughScopeResolver] slice load failed ${tmpKey}=${tmpAnchor}: ${pErr?.message || pErr}`);
				tmpScope.Slices.set(tmpAnchor, new Set());
			})
			.finally(() => { tmpScope.Pending.delete(tmpAnchor); });
		tmpScope.Pending.set(tmpAnchor, tmpPromise);
		return tmpPromise;
	}

	/**
	 * @param {ThroughFilterConfig} pFilter
	 * @param {string} pAnchor
	 * @return {Promise<Set<number>>}
	 */
	async _loadSlice(pFilter, pAnchor)
	{
		const tmpRoute = `${pFilter.Through}s/${pFilter.ThroughProjection || 'Lite'}`;
		const tmpClauses = [ `FBV~${pFilter.ThroughKey}~EQ~${encodeURIComponent(pAnchor)}` ];
		if (pFilter.ThroughFilter)
		{
			tmpClauses.unshift(pFilter.ThroughFilter);
		}
		const tmpRows = await this._readAllPages(tmpRoute, tmpClauses.join('~'));
		return new Set(this._distinctPositive(tmpRows.map((pRow) => pRow[pFilter.ThroughSelect])));
	}

	/**
	 * Ensure the map-strategy scope for a filter is fully loaded + indexed. Safe
	 * to call repeatedly; de-dupes via the in-flight LoadPromise.
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @return {Promise<void>}
	 */
	async primeMapScope(pFilter)
	{
		if (!pFilter || pFilter.Strategy !== 'map' || !pFilter.Through || !pFilter.ThroughKey || !pFilter.ThroughSelect)
		{
			return;
		}
		const tmpKey = this._cacheKey(pFilter);
		const tmpExisting = this._MapScopes[tmpKey];
		if (tmpExisting && tmpExisting.Loaded)
		{
			return;
		}
		if (tmpExisting && tmpExisting.LoadPromise)
		{
			return tmpExisting.LoadPromise;
		}
		const tmpScope = this._MapScopes[tmpKey] = { Loaded: false, LoadPromise: null, Forward: new Map(), AllSelects: new Set() };
		tmpScope.LoadPromise = this._loadMap(pFilter, tmpScope)
			.then(() => { tmpScope.Loaded = true; })
			.catch((pErr) =>
			{
				this.pict?.log?.warn(`[ThroughScopeResolver] map load failed ${tmpKey}: ${pErr?.message || pErr}`);
				tmpScope.Loaded = true;
			});
		return tmpScope.LoadPromise;
	}

	/**
	 * @param {ThroughFilterConfig} pFilter
	 * @param {{ Forward: Map<string, Set<number>>, AllSelects: Set<number> }} pScope
	 * @return {Promise<void>}
	 */
	async _loadMap(pFilter, pScope)
	{
		const tmpRoute = `${pFilter.Through}s/${pFilter.ThroughProjection || 'Lite'}`;
		// Sorted, not merely scoped: this pages the WHOLE bridge, and a paged read with no ORDER BY can
		// repeat or skip rows between pages. It also supplies the filter stanza the paged route requires —
		// meadow-endpoints exposes no bare `s/:Begin/:Cap`.
		const tmpFilter = pFilter.ThroughFilter || `FSF~${pFilter.ThroughKey}~ASC~0`;
		const tmpRows = await this._readAllPages(tmpRoute, tmpFilter);
		for (const tmpRow of tmpRows)
		{
			const tmpKeyVal = (tmpRow[pFilter.ThroughKey] === null || tmpRow[pFilter.ThroughKey] === undefined) ? '' : String(tmpRow[pFilter.ThroughKey]).trim();
			const tmpSelectVal = parseInt(tmpRow[pFilter.ThroughSelect], 10);
			if (tmpKeyVal === '' || !(tmpSelectVal > 0))
			{
				continue;
			}
			let tmpSet = pScope.Forward.get(tmpKeyVal);
			if (!tmpSet)
			{
				tmpSet = new Set();
				pScope.Forward.set(tmpKeyVal, tmpSet);
			}
			tmpSet.add(tmpSelectVal);
			pScope.AllSelects.add(tmpSelectVal);
		}
	}

	/**
	 * App-load hook — prime every map-strategy Through on the loaded form so the
	 * synchronous getThroughIDs resolves on the first render. PictProvider
	 * defaults AutoLoadDataWithApp true, so this participates without host changes.
	 * Failure is non-fatal (fail-open). Query-strategy filters are not primed here
	 * (they load per-anchor in the transport).
	 *
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			this._primeScopesFromForm().catch((pErr) =>
			{
				this.pict?.log?.warn(`[ThroughScopeResolver] app-load prime failed: ${pErr?.message || pErr}`);
			}).finally(() => fCallback());
		});
	}

	/**
	 * @return {Promise<void>}
	 */
	async _primeMapScopesFromForm()
	{
		const tmpSeen = new Set();
		const tmpMapFilters = [];
		for (const tmpFilter of this._collectThroughFilters())
		{
			if (tmpFilter.Strategy !== 'map')
			{
				continue;
			}
			const tmpKey = this._cacheKey(tmpFilter);
			if (tmpSeen.has(tmpKey))
			{
				continue;
			}
			tmpSeen.add(tmpKey);
			tmpMapFilters.push(tmpFilter);
		}
		await Promise.all(tmpMapFilters.map((pFilter) => this.primeMapScope(pFilter)));
	}

	/**
	 * Prime both map and query scopes for the loaded form.
	 *
	 * @return {Promise<void>}
	 */
	async _primeScopesFromForm()
	{
		await Promise.all([ this._primeMapScopesFromForm(), this._primeQueryScopesFromForm() ]);
	}

	/**
	 * Prime the query-strategy slice for every query-Through filter on the form at
	 * its current anchor value. Called on app load (pre-filled anchors) and via
	 * primeQueryScopesFromForm whenever the cascade changes an anchor.
	 *
	 * @return {Promise<void>}
	 */
	async _primeQueryScopesFromForm()
	{
		const tmpJobs = [];
		for (const tmpFilter of this._collectThroughFilters())
		{
			if (tmpFilter.Strategy !== 'query' || !tmpFilter.FromField)
			{
				continue;
			}
			const tmpAnchor = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			tmpJobs.push(this.primeThroughSlice(tmpFilter, tmpAnchor));
		}
		await Promise.all(tmpJobs);
	}

	/**
	 * Public fire-and-forget entry the cascade calls when an anchor changes, so the
	 * dependent picker's query slice is warm before it is opened. Swallows errors.
	 *
	 * @return {Promise<void>}
	 */
	primeQueryScopesFromForm()
	{
		return this._primeQueryScopesFromForm().catch((pErr) =>
		{
			this.pict?.log?.warn(`[ThroughScopeResolver] query prime failed: ${pErr?.message || pErr}`);
		});
	}

	/**
	 * Collect every Through filter entry across the loaded form's descriptors.
	 *
	 * @return {Array<ThroughFilterConfig>}
	 */
	_collectThroughFilters()
	{
		const tmpDescriptors = this.pict?.views?.PictFormMetacontroller?.manifestDescription?.Descriptors;
		const tmpOut = [];
		if (!tmpDescriptors)
		{
			return tmpOut;
		}
		for (const tmpDescriptor of Object.values(tmpDescriptors))
		{
			const tmpFilters = tmpDescriptor?.PictForm?.DynamicFilters;
			if (!Array.isArray(tmpFilters))
			{
				continue;
			}
			for (const tmpFilter of tmpFilters)
			{
				if (tmpFilter && tmpFilter.Through && tmpFilter.ThroughKey && tmpFilter.ThroughSelect)
				{
					tmpOut.push(tmpFilter);
				}
			}
		}
		return tmpOut;
	}

	/**
	 * Page through a filtered meadow read until exhausted. Mirrors
	 * SpecScopeResolver — plain FilteredTo paging so the offline client can serve
	 * from synced entity data.
	 *
	 * @param {string} pEntityRoute - pluralized route incl. projection, e.g. 'OrganizationMaterialJoins/Lite'.
	 * @param {string} pFilter - meadow filter stanza.
	 * @return {Promise<Array<any>>}
	 */
	async _readAllPages(pEntityRoute, pFilter)
	{
		const tmpRows = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpPage = await this._getJSON(`${pEntityRoute}/FilteredTo/${pFilter}/${tmpOffset}/${THROUGH_PAGE_SIZE}`);
			if (!Array.isArray(tmpPage) || tmpPage.length === 0)
			{
				break;
			}
			for (const tmpRow of tmpPage)
			{
				tmpRows.push(tmpRow);
			}
			if (tmpPage.length < THROUGH_PAGE_SIZE)
			{
				break;
			}
			tmpOffset += THROUGH_PAGE_SIZE;
		}
		return tmpRows;
	}

	/**
	 * @param {Array<any>} pValues
	 * @return {Array<number>} distinct positive integers.
	 */
	_distinctPositive(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of pValues)
		{
			const tmpNumber = parseInt(tmpValue, 10);
			if (tmpNumber > 0)
			{
				tmpSet.add(tmpNumber);
			}
		}
		return Array.from(tmpSet);
	}

	/**
	 * @param {string} pUrl
	 * @return {Promise<any>}
	 */
	_getJSON(pUrl)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pUrl, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ThroughScopeResolver;

},{"pict-provider":479}],132:[function(require,module,exports){
/**
 * The pristine-emission baseline behind delta emission.
 *
 * The save sweep collects every participating input's `__Record` and sibling join records into a
 * `<Context>.<Entity>.<GUID>` comprehension. Historically that whole collection was emitted, which
 * asserts load-time server state with last-writer-wins semantics — a document edited offline and
 * synced days later re-asserts its load snapshot over everything written in between.
 *
 * The baseline is the same collection, taken once the load transaction has settled: the
 * comprehension the form WOULD emit with no user action. Emission is then the difference between
 * the two, so a save carries what the user changed and nothing else.
 *
 * Capturing it by re-running the sweep — rather than by watching record writes — is what makes it
 * total. Roughly 40% of record mutations are plain property assignment on an object held by
 * reference, several writers are declarative (a trigger-group receiver whose `DataAddress` is
 * inside a `__Record`) and never enter this bundle at all, and some run server-side before the form
 * renders. No interception layer sees those. The sweep sees whatever they left behind, because it
 * reads state rather than observing writers.
 *
 * @module _EntityDataBaseline
 */

const libEntityFieldClassification = require('./_EntityFieldClassification.json');
const libScopedEntityData = require('./_ScopedEntityData.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

/** Where the baseline rides. Inside FormData so it survives an offline save/reload cycle. */
const FORMDATA_ADDRESS = 'AppData.DocumentData.ReportData.FormData';
/** The FormData key the baseline lives under; the writeback walk must not rewrite its leaves. */
const BASELINE_KEY = '__EntityDataBaseline';
const BASELINE_ADDRESS = libScopedEntityData.ENTITY_DATA_BASELINE_ADDRESS;

/** Columns the database and the meadow layer own; never a user change, never emitted. */
const AUDIT_COLUMNS = new Set(libEntityFieldClassification.AuditColumns || [ ]);

/** The per-entity identity / data column lists, generated from `lib/headlight_model`. */
const ENTITY_COLUMNS = libEntityFieldClassification.Entities || { };

/**
 * The field marking a record for deletion. Tombstones bypass the change test entirely — a delete is
 * an event the form minted deliberately, never something a diff should have to infer.
 */
const DELETED_FIELD = 'Deleted';

/**
 * References an update is refused without, by entity. See `isAlwaysEmittedReference` for how each
 * entry was established; everything not listed here is emitted only when it changed.
 */
const REQUIRED_REFERENCES =
{
	DocumentPolyJoin: [ 'IDDocument' ],
	Document: [ 'IDProject' ],
};

/**
 * A field name meadow reads as a directive rather than a column (`_GUID<Entity>` for an exact GUID
 * reference, `_Dest_` to retarget a foreign key). They are not columns, so the column filter must
 * not drop them, and they are not user data, so the change test must not run over them — they ride
 * along with whatever record they qualify.
 *
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field is a meadow directive.
 */
function isDirectiveField(pFieldName)
{
	return typeof pFieldName === 'string' && (pFieldName.startsWith('_Dest_') || pFieldName.startsWith('_GUID'));
}

/**
 * A reference to ANOTHER entity's row, carried by GUID rather than by id.
 *
 * This is how a comprehension resolves a foreign key to a row that may not exist yet — the applier
 * sorts entities into dependency order by reading exactly these fields, so a `TestInstanceSampleJoin`
 * carrying `GUIDTestInstance`, or a `DocumentPolyJoin` carrying `GUIDSample`, is asserting the join's
 * subject. The model does not list them as columns of the entity they appear on, so they must be
 * recognised by shape or the column filter drops the foreign key and the row lands unattached.
 *
 * @param {string} pEntity - The entity the field appears on.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field points at another entity's row.
 */
function isCrossEntityReferenceField(pEntity, pFieldName)
{
	if (typeof pFieldName !== 'string')
	{
		return false;
	}
	if (pFieldName.indexOf('_Via_GUID') >= 0)
	{
		return true;
	}
	if (isIdentityField(pEntity, pFieldName))
	{
		return false;
	}
	return (/^GUID[A-Z]/).test(pFieldName) || (/^ID[A-Z]/).test(pFieldName);
}

/**
 * The generated column classification for an entity, or null when the model does not know it.
 *
 * @param {string} pEntity - The entity name.
 * @return {{ I: Array<string>, D: Array<string>, N?: Array<string> }|null} - The classification, or null.
 */
function getEntityClassification(pEntity)
{
	const tmpClassification = ENTITY_COLUMNS[pEntity];
	return (tmpClassification && typeof tmpClassification === 'object') ? tmpClassification : null;
}

/**
 * Is this field one of the entity's identity columns (`ID<Entity>` / `GUID<Entity>`)?
 *
 * Identity is carried on every record that survives the delta, because it is what the upsert
 * resolves the row by — it is never itself "a change the user made".
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field identifies the row.
 */
function isIdentityField(pEntity, pFieldName)
{
	const tmpClassification = getEntityClassification(pEntity);
	if (tmpClassification)
	{
		return tmpClassification.I.indexOf(pFieldName) >= 0;
	}
	return pFieldName === `ID${pEntity}` || pFieldName === `GUID${pEntity}`;
}

/**
 * Is this field an audit column?
 *
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the database owns the field.
 */
function isAuditField(pFieldName)
{
	return AUDIT_COLUMNS.has(pFieldName);
}

/**
 * Does this field participate in the change test — a real data column the user could have moved?
 *
 * Identity, audit, directives and `Deleted` are all excluded. So is any field the model does not
 * list as a column of this entity, which is how display-only stamps written onto a persisted join
 * shape (`SampleLineItemJoin.LineItemUnits` is the live case) stay out of both the diff and the
 * payload. An entity the model does not know falls back to "anything not otherwise excluded", so an
 * unmodelled projection target still emits rather than silently emitting nothing.
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field is comparable user data.
 */
function isComparableField(pEntity, pFieldName)
{
	if (typeof pFieldName !== 'string' || pFieldName.length < 1)
	{
		return false;
	}
	if (pFieldName === DELETED_FIELD || isDirectiveField(pFieldName) || isAuditField(pFieldName) || isIdentityField(pEntity, pFieldName))
	{
		return false;
	}
	if (isCrossEntityReferenceField(pEntity, pFieldName))
	{
		return true;
	}
	const tmpClassification = getEntityClassification(pEntity);
	if (!tmpClassification)
	{
		return true;
	}
	return tmpClassification.D.indexOf(pFieldName) >= 0;
}

/**
 * The references a write is refused without, by entity, even when they did not change. Everything
 * else — every other `ID<Entity>` / `GUID<Entity>` — is compared and emitted only when it moved.
 *
 * Both entries were established against QA with
 * `api/headlight/tools/probe-reference-field-requirements.js` (2026-09-23), which drove updates with
 * and without the unchanged references, at level 4 and level 1, over every entity these forms write:
 *
 * - `DocumentPolyJoin.IDDocument` — an update without it is refused, "Document not found, or you do
 *   not have rights to access this document", at both levels. The row's authorization reads it.
 * - `Document.IDProject` — an update is accepted without it; a CREATE is refused, "Cannot verify
 *   project membership: no IDProject was provided". A created record has no baseline and projects
 *   whole anyway, so this entry is belt and braces rather than load-bearing.
 *
 * Every other entity probed (`Sample`, `SampleLineItemJoin`, `SampleLabJoin`, `TestInstance`,
 * `TestInstanceSampleJoin`, `TestInstanceLabJoin`) accepted the update with no references at all.
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the reference must ride every write.
 */
function isAlwaysEmittedReference(pEntity, pFieldName)
{
	if (!isCrossEntityReferenceField(pEntity, pFieldName))
	{
		return false;
	}
	const tmpRequired = REQUIRED_REFERENCES[pEntity];
	return !!tmpRequired && (tmpRequired.indexOf(pFieldName) >= 0);
}

/**
 * Does this field survive into an emitted record at all?
 *
 * Audit columns never do. Everything else does: identity because the upsert needs it, directives
 * because they qualify the identity, and data columns when they changed.
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field may be emitted.
 */
function isEmittableField(pEntity, pFieldName)
{
	if (typeof pFieldName !== 'string' || pFieldName.length < 1)
	{
		return false;
	}
	if (isAuditField(pFieldName))
	{
		return false;
	}
	if (pFieldName === DELETED_FIELD || isDirectiveField(pFieldName) || isIdentityField(pEntity, pFieldName) || isCrossEntityReferenceField(pEntity, pFieldName))
	{
		return true;
	}
	const tmpClassification = getEntityClassification(pEntity);
	if (!tmpClassification)
	{
		return true;
	}
	return tmpClassification.D.indexOf(pFieldName) >= 0;
}

/**
 * Whether a record carries a server-assigned identity, and is therefore server state rather than
 * something this form minted.
 *
 * Only such records may seed the baseline: a freshly synthesized record that has never been saved
 * has no baseline by definition, and treating one as its own baseline would suppress the very
 * emission that creates the row.
 *
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>} pRecord - The record.
 * @return {boolean} - True when the row exists server-side.
 */
function hasServerIdentity(pEntity, pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	const tmpIdentity = pRecord[`ID${pEntity}`];
	if (tmpIdentity === null || typeof tmpIdentity === 'undefined' || tmpIdentity === '')
	{
		return false;
	}
	return Number(tmpIdentity) > 0;
}

/**
 * Is this leaf a tombstone rather than an upsert?
 *
 * @param {Record<string, any>} pRecord - The comprehension leaf.
 * @return {boolean} - True when the record asserts a delete.
 */
function isTombstoneRecord(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	const tmpDeleted = pRecord[DELETED_FIELD];
	return tmpDeleted === 1 || tmpDeleted === '1' || tmpDeleted === true;
}

/**
 * Is this field a numeric data column of the entity?
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the model stores the field as a number.
 */
function isNumericField(pEntity, pFieldName)
{
	const tmpClassification = getEntityClassification(pEntity);
	return !!(tmpClassification && Array.isArray(tmpClassification.N) && tmpClassification.N.indexOf(pFieldName) >= 0);
}

/**
 * Compare two field values the way the wire does.
 *
 * REST hands numerics back as strings often enough that a strict compare would report a change on
 * every reload, so scalars compare loosely; null, undefined and empty string are one state, because
 * the three "empty" spellings move between the marshal, the fetch and the manifest with no user
 * involvement. Objects and arrays compare structurally. A numeric column compares by value when both
 * sides parse as numbers, because a decimal comes back at its column scale (`"1.000"`) while the form
 * holds what was typed (`"1"`).
 *
 * @param {any} pLeft - The baseline value.
 * @param {any} pRight - The current value.
 * @param {string} [pEntity] - The entity the field belongs to.
 * @param {string} [pFieldName] - The field name.
 * @return {boolean} - True when the values differ.
 */
function valuesDiffer(pLeft, pRight, pEntity, pFieldName)
{
	const tmpLeftEmpty = (pLeft === null || typeof pLeft === 'undefined' || pLeft === '');
	const tmpRightEmpty = (pRight === null || typeof pRight === 'undefined' || pRight === '');
	if (tmpLeftEmpty || tmpRightEmpty)
	{
		return tmpLeftEmpty !== tmpRightEmpty;
	}
	if (typeof pLeft === 'object' || typeof pRight === 'object')
	{
		return JSON.stringify(pLeft) !== JSON.stringify(pRight);
	}
	if (pEntity && pFieldName && isNumericField(pEntity, pFieldName))
	{
		const tmpLeftNumber = Number(pLeft);
		const tmpRightNumber = Number(pRight);
		if (Number.isFinite(tmpLeftNumber) && Number.isFinite(tmpRightNumber))
		{
			return tmpLeftNumber !== tmpRightNumber;
		}
	}
	// eslint-disable-next-line eqeqeq
	return pLeft != pRight;
}

/**
 * Reduce one emitted record to the fields that actually changed, plus the identity the upsert needs.
 *
 * A record with no baseline is one the form created, and projects whole — once. After its first
 * save it has a baseline and diffs like any other.
 *
 * A reference is compared like any other column and ships only when it moved, except for the few
 * `REQUIRED_REFERENCES` a write is refused without.
 *
 * A field the baseline carries and the record no longer does is NOT read as a clear. The record
 * builders drop keys constantly as they re-key a row between its GUID and ID forms, and a rebuild
 * that returns a narrower wrapper drops keys it never owned; none of those are a user clearing a
 * value. A value the user actually cleared arrives as an empty value, which does compare as a
 * change.
 *
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>|null} pBaseline - The baseline record, or null when there is none.
 * @param {Record<string, any>} pRecord - The record as the sweep collected it.
 * @return {Record<string, any>|null} - The record to emit, or null when nothing changed.
 */
function computeRecordDelta(pEntity, pBaseline, pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return null;
	}
	// A tombstone the baseline already carries was applied by an earlier save. Re-emitting it sends
	// the applier back to delete a row that is already gone.
	if (isTombstoneRecord(pRecord))
	{
		if (isTombstoneRecord(pBaseline))
		{
			return null;
		}
		return pRecord;
	}
	// The row this GUID named was deleted, so what sits here now is a new row with no history to
	// diff against - it has to project whole, exactly as a never-saved record does.
	const tmpBaseline = isTombstoneRecord(pBaseline) ? null : pBaseline;
	const tmpIdentityFields = { };
	const tmpChangedFields = { };
	let tmpChangedCount = 0;
	for (const tmpField of Object.keys(pRecord))
	{
		if (!isEmittableField(pEntity, tmpField))
		{
			continue;
		}
		if (!isComparableField(pEntity, tmpField))
		{
			tmpIdentityFields[tmpField] = pRecord[tmpField];
			continue;
		}
		const tmpChanged = (!tmpBaseline || valuesDiffer(tmpBaseline[tmpField], pRecord[tmpField], pEntity, tmpField));
		if (isAlwaysEmittedReference(pEntity, tmpField))
		{
			tmpIdentityFields[tmpField] = pRecord[tmpField];
			if (tmpChanged)
			{
				++tmpChangedCount;
			}
			continue;
		}
		if (tmpChanged)
		{
			tmpChangedFields[tmpField] = pRecord[tmpField];
			++tmpChangedCount;
		}
	}
	if (!tmpBaseline)
	{
		return Object.assign(tmpIdentityFields, tmpChangedFields);
	}
	if (tmpChangedCount < 1)
	{
		return null;
	}
	return Object.assign(tmpIdentityFields, tmpChangedFields);
}

/**
 * Strip a record down to what may be stored as a baseline: emittable fields only, so the baseline
 * and the emission are compared on the same terms.
 *
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>} pRecord - The record to reduce.
 * @return {Record<string, any>} - The reduced record.
 */
function reduceRecordForBaseline(pEntity, pRecord)
{
	const tmpReduced = { };
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return tmpReduced;
	}
	for (const tmpField of Object.keys(pRecord))
	{
		if (isEmittableField(pEntity, tmpField))
		{
			tmpReduced[tmpField] = pRecord[tmpField];
		}
	}
	return tmpReduced;
}

/**
 * The stored baseline tree, shaped exactly like the comprehension it is compared against
 * (`<Context>.<Entity>.<GUID>`) so a bad emission can be read against it directly.
 *
 * @param {Object} pPict - The pict instance.
 * @param {boolean} [pCreate] - Create the store when it is absent.
 * @return {Record<string, any>|null} - The store, or null when it does not exist and was not created.
 */
function getBaselineStore(pPict, pCreate)
{
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpStore = pPict.manifest.getValueAtAddress(pPict, BASELINE_ADDRESS);
	if (tmpStore && typeof tmpStore === 'object' && !Array.isArray(tmpStore))
	{
		return tmpStore;
	}
	if (!pCreate || typeof pPict.manifest.setValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpCreated = { };
	pPict.manifest.setValueAtAddress(pPict, BASELINE_ADDRESS, tmpCreated);
	return tmpCreated;
}

/**
 * Read one baseline record.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {Record<string, any>|null} - The baseline record, or null when there is none.
 */
function readBaselineRecord(pPict, pContext, pEntity, pGUID)
{
	const tmpStore = getBaselineStore(pPict, false);
	if (!tmpStore)
	{
		return null;
	}
	const tmpContextNode = tmpStore[pContext];
	if (!tmpContextNode || typeof tmpContextNode !== 'object')
	{
		return null;
	}
	const tmpBucket = tmpContextNode[pEntity];
	if (!tmpBucket || typeof tmpBucket !== 'object')
	{
		return null;
	}
	const tmpRecord = tmpBucket[pGUID];
	return (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord : null;
}

/**
 * Write one baseline record.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pRecord - The record to store.
 * @return {boolean} - True when the record was stored.
 */
function writeBaselineRecord(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pContext || !pEntity || !pGUID)
	{
		return false;
	}
	const tmpStore = getBaselineStore(pPict, true);
	if (!tmpStore)
	{
		return false;
	}
	if (!tmpStore[pContext] || typeof tmpStore[pContext] !== 'object' || Array.isArray(tmpStore[pContext]))
	{
		tmpStore[pContext] = { };
	}
	if (!tmpStore[pContext][pEntity] || typeof tmpStore[pContext][pEntity] !== 'object' || Array.isArray(tmpStore[pContext][pEntity]))
	{
		tmpStore[pContext][pEntity] = { };
	}
	tmpStore[pContext][pEntity][pGUID] = reduceRecordForBaseline(pEntity, pRecord);
	return true;
}

/**
 * Seed the baseline from a settled load sweep.
 *
 * Only records carrying a server identity are stored. A record the form synthesized during the load
 * — an init auto-create, a join minted for a row that has none — is not server state; baselining it
 * would suppress the very emission that creates the row.
 *
 * The first capture of a session REPLACES the contexts the sweep produced wholesale, because at that
 * point the sweep is the authority on the server state the form loaded. Contexts it did not touch are
 * left alone. Every render transaction schedules a capture, and the sweep reads the form's live
 * records, so a later one also reads the user's unsaved edits: refreshing an existing entry from it
 * would make the next save drop the edit. Later captures therefore only add records the session has
 * never baselined, and a baselined record moves only with a save's fold.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Map<string, Record<string, any>>} pContextRoots - The `<Entity>.<GUID>` roots the sweep filled, by context.
 * @return {number} - How many records were baselined.
 */
function captureBaselineFromSweep(pPict, pContextRoots)
{
	if (!pContextRoots || typeof pContextRoots.forEach !== 'function')
	{
		return 0;
	}
	const tmpStore = getBaselineStore(pPict, true);
	if (!tmpStore)
	{
		return 0;
	}
	const tmpSession = getCaptureSession(pPict, tmpStore);
	if (tmpSession)
	{
		return addUnknownRecordsToBaseline(pPict, tmpSession, pContextRoots);
	}
	let tmpCount = 0;
	let tmpCarriedCount = 0;
	pContextRoots.forEach((pContextRoot, pContext) =>
	{
		const tmpPrevious = (tmpStore[pContext] && typeof tmpStore[pContext] === 'object') ? tmpStore[pContext] : { };
		tmpStore[pContext] = { };
		if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
		{
			return;
		}
		for (const tmpEntity of Object.keys(pContextRoot))
		{
			const tmpBucket = pContextRoot[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!hasServerIdentity(tmpEntity, tmpRecord) || isTombstoneRecord(tmpRecord))
				{
					// The sweep cannot prove this record, so it cannot refresh its baseline - but it must not
					// destroy one either. A `DocumentPolyJoin` or `TestInstanceLabJoin` is never re-fetched, so
					// the post-save fold is the only thing that will ever baseline it; wiping here would make it
					// project whole on every save for the life of the document. Carrying it forward is safe for
					// exactly these records: nothing but this form writes them.
					continue;
				}
				if (!tmpStore[pContext][tmpEntity] || typeof tmpStore[pContext][tmpEntity] !== 'object')
				{
					tmpStore[pContext][tmpEntity] = { };
				}
				tmpStore[pContext][tmpEntity][tmpGUID] = reduceRecordForBaseline(tmpEntity, tmpRecord);
				++tmpCount;
			}
		}
		// Absence from the sweep is not evidence of removal: the test-instance triple and the join
		// collections hydrate asynchronously, so a record can simply not have arrived yet. Anything the
		// sweep could not re-derive keeps the baseline it had - a stale entry for a record the form truly
		// dropped is inert, because a record the form no longer holds is never emitted either.
		for (const tmpEntity of Object.keys(tmpPrevious))
		{
			const tmpPreviousBucket = tmpPrevious[tmpEntity];
			if (!tmpPreviousBucket || typeof tmpPreviousBucket !== 'object')
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpPreviousBucket))
			{
				if (tmpStore[pContext][tmpEntity] && tmpStore[pContext][tmpEntity][tmpGUID])
				{
					continue;
				}
				if (!tmpStore[pContext][tmpEntity] || typeof tmpStore[pContext][tmpEntity] !== 'object')
				{
					tmpStore[pContext][tmpEntity] = { };
				}
				tmpStore[pContext][tmpEntity][tmpGUID] = tmpPreviousBucket[tmpGUID];
				++tmpCarriedCount;
			}
		}
	});
	const tmpNewSession = { Store: tmpStore, Known: new Set() };
	markStoredRecordsKnown(tmpNewSession, tmpStore);
	getBaselineAppState(pPict).CaptureSession = tmpNewSession;
	if (pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: capture stored ${tmpCount} record(s) and carried ${tmpCarriedCount} the sweep could not prove.`);
	}
	return tmpCount;
}

/**
 * The key a baseline record is known by within a capture session.
 *
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {string} - The key.
 */
function getBaselineRecordKey(pContext, pEntity, pGUID)
{
	return `${pContext}\n${pEntity}\n${pGUID}`;
}

/**
 * The capture session a first load capture opened on this baseline store, or null when there is none.
 *
 * Keyed on the store object: opening a document, or reopening this one, hands FormData a new store,
 * and the new store's first capture refreshes from the server state that load fetched.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>|null} pStore - The baseline store.
 * @return {{ Store: Record<string, any>, Known: Set<string> }|null} - The session, or null.
 */
function getCaptureSession(pPict, pStore)
{
	const tmpAppState = getBaselineAppState(pPict);
	const tmpSession = tmpAppState ? tmpAppState.CaptureSession : null;
	return (tmpSession && pStore && tmpSession.Store === pStore) ? tmpSession : null;
}

/**
 * Whether a first load capture has already seeded the current baseline store.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when later captures only add records.
 */
function hasCaptureSession(pPict)
{
	return !!getCaptureSession(pPict, getBaselineStore(pPict, false));
}

/**
 * Mark every record the store holds as known to the session.
 *
 * @param {{ Store: Record<string, any>, Known: Set<string> }} pSession - The capture session.
 * @param {Record<string, any>} pStore - The baseline store.
 * @return {void}
 */
function markStoredRecordsKnown(pSession, pStore)
{
	for (const tmpContext of Object.keys(pStore))
	{
		const tmpContextNode = pStore[tmpContext];
		if (!tmpContextNode || typeof tmpContextNode !== 'object' || Array.isArray(tmpContextNode))
		{
			continue;
		}
		for (const tmpEntity of Object.keys(tmpContextNode))
		{
			const tmpBucket = tmpContextNode[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				pSession.Known.add(getBaselineRecordKey(tmpContext, tmpEntity, tmpGUID));
			}
		}
	}
}

/**
 * A capture after the session's first: baseline only records the session has never known, the ones
 * that hydrated late, and leave every known record's baseline where the load or a save put it.
 *
 * A record a save released (a failed PUT clears the store; an unapplied record is dropped) stays known,
 * so it keeps projecting whole instead of being re-seeded from the form's unsaved state.
 *
 * @param {Object} pPict - The pict instance.
 * @param {{ Store: Record<string, any>, Known: Set<string> }} pSession - The capture session.
 * @param {Map<string, Record<string, any>>} pContextRoots - The `<Entity>.<GUID>` roots the sweep filled, by context.
 * @return {number} - How many records were added.
 */
function addUnknownRecordsToBaseline(pPict, pSession, pContextRoots)
{
	markStoredRecordsKnown(pSession, pSession.Store);
	let tmpAdded = 0;
	let tmpKnown = 0;
	pContextRoots.forEach((pContextRoot, pContext) =>
	{
		if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
		{
			return;
		}
		for (const tmpEntity of Object.keys(pContextRoot))
		{
			const tmpBucket = pContextRoot[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!hasServerIdentity(tmpEntity, tmpRecord) || isTombstoneRecord(tmpRecord))
				{
					continue;
				}
				const tmpKey = getBaselineRecordKey(pContext, tmpEntity, tmpGUID);
				if (pSession.Known.has(tmpKey))
				{
					++tmpKnown;
					continue;
				}
				pSession.Known.add(tmpKey);
				writeBaselineRecord(pPict, pContext, tmpEntity, tmpGUID, tmpRecord);
				++tmpAdded;
			}
		}
	});
	if (pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: later capture added ${tmpAdded} record(s) first seen after the load and left ${tmpKnown} known record(s) as the load or a save baselined them.`);
	}
	return tmpAdded;
}

/**
 * Re-baseline named records from what the form holds now, for a path that has just replaced them
 * with a fresh server row (the "out of date" refresh), so the server's own values do not read as a
 * user edit. Only those records move; every other record keeps its baseline, unsaved edits included.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The entity name.
 * @param {Array<string>} pGUIDs - The external GUIDs of the replaced records.
 * @return {number} - How many baseline records were refreshed.
 */
function refreshBaselineRecords(pPict, pEntity, pGUIDs)
{
	if (!pEntity || !Array.isArray(pGUIDs) || pGUIDs.length < 1)
	{
		return 0;
	}
	const tmpContextRoots = runProjectionSweepToScratch(pPict);
	if (!tmpContextRoots)
	{
		return 0;
	}
	const tmpStore = getBaselineStore(pPict, true);
	if (!tmpStore)
	{
		return 0;
	}
	const tmpSession = getCaptureSession(pPict, tmpStore);
	const tmpGUIDs = new Set(pGUIDs);
	let tmpCount = 0;
	tmpContextRoots.forEach((pContextRoot, pContext) =>
	{
		libScopedEntityData.sanitizeContextRoot(pContextRoot);
		const tmpBucket = (pContextRoot && typeof pContextRoot === 'object') ? pContextRoot[pEntity] : null;
		if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
		{
			return;
		}
		for (const tmpGUID of Object.keys(tmpBucket))
		{
			const tmpRecord = tmpBucket[tmpGUID];
			if (!tmpGUIDs.has(tmpGUID) || !hasServerIdentity(pEntity, tmpRecord) || isTombstoneRecord(tmpRecord))
			{
				continue;
			}
			writeBaselineRecord(pPict, pContext, pEntity, tmpGUID, tmpRecord);
			if (tmpSession)
			{
				tmpSession.Known.add(getBaselineRecordKey(pContext, pEntity, tmpGUID));
			}
			++tmpCount;
		}
	});
	if (pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: re-baselined ${tmpCount} ${pEntity} record(s) from a server refresh.`);
	}
	return tmpCount;
}

/**
 * @typedef {Object} RecordRefreshDecision
 * @property {'replace'|'adopt'|'keep'} Action - `replace`: take the row, baseline untouched. `adopt`: take
 *   the row and move `Fields` into the baseline. `keep`: hold on to the form's record.
 * @property {Array<string>} Fields - For `adopt`, the fields the server moved; for `keep`, the fields in conflict.
 * @property {string} Reason - Why, for the log line.
 */

/**
 * Decide how a server row that is about to replace a record the form holds may be taken.
 *
 * Only the load capture that opens a session may set a record's baseline. A later refresh of the same
 * record — the open-time re-fetch landing after another render already captured — would otherwise leave
 * the baseline on the snapshot the document last saved, and every field another actor moved since would
 * ship as a user edit. So the refresh reconciles the baseline itself, but never at the cost of a change
 * the server does not have yet:
 *
 * - a leaf still staged for this record under the context (an offline save, or one armed after a failed
 *   apply) or a newest logged outcome that failed: keep the held record;
 * - a field the row would overwrite where the held value differs from the baseline (an edit not yet
 *   saved): keep the held record;
 * - otherwise adopt the row, and move exactly the fields the server moved into the baseline.
 *
 * A record with no baseline has nothing stale to correct and is replaced as before.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The context the record projects under.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pHeldRecord - The record the form holds now.
 * @param {Record<string, any>} pFetchedRecord - The server row about to replace it.
 * @return {RecordRefreshDecision} - The decision.
 */
function classifyRecordRefresh(pPict, pContext, pEntity, pGUID, pHeldRecord, pFetchedRecord)
{
	/** @type {RecordRefreshDecision} */
	const tmpReplace = { Action: 'replace', Fields: [ ], Reason: 'no baseline to reconcile' };
	if (!pGUID || !pHeldRecord || typeof pHeldRecord !== 'object' || Array.isArray(pHeldRecord) || !pFetchedRecord || typeof pFetchedRecord !== 'object' || Array.isArray(pFetchedRecord))
	{
		return tmpReplace;
	}
	const tmpBaseline = readBaselineRecord(pPict, pContext, pEntity, pGUID);
	if (!tmpBaseline || isTombstoneRecord(tmpBaseline))
	{
		return tmpReplace;
	}
	const tmpDestination = libScopedEntityData.resolveDestination(pPict);
	let tmpStaged = tmpDestination;
	for (const tmpPart of `${pContext}.${pEntity}`.split('.'))
	{
		tmpStaged = (tmpStaged && typeof tmpStaged === 'object') ? tmpStaged[tmpPart] : null;
	}
	if (tmpStaged && typeof tmpStaged === 'object' && tmpStaged[pGUID])
	{
		return { Action: 'keep', Fields: [ ], Reason: `a change is still staged under ${pContext}` };
	}
	const tmpLog = (tmpDestination && Array.isArray(tmpDestination.ExecutionLog)) ? tmpDestination.ExecutionLog : [ ];
	let tmpLatestOutcome = null;
	for (const tmpEntry of tmpLog)
	{
		if (!tmpEntry || typeof tmpEntry !== 'object' || tmpEntry.TriggerKey !== pContext)
		{
			continue;
		}
		const tmpOutcome = readLogEntryOutcomes(tmpEntry).get(`${pEntity} ${pGUID}`);
		if (tmpOutcome)
		{
			tmpLatestOutcome = tmpOutcome;
		}
	}
	if (tmpLatestOutcome && tmpLatestOutcome.Failed)
	{
		return { Action: 'keep', Fields: [ ], Reason: 'the server logged its last save as not applied' };
	}
	const tmpConflicts = [ ];
	const tmpMoved = [ ];
	for (const tmpField of Object.keys(pFetchedRecord))
	{
		if (!isEmittableField(pEntity, tmpField) || !isComparableField(pEntity, tmpField))
		{
			continue;
		}
		if (!valuesDiffer(pHeldRecord[tmpField], pFetchedRecord[tmpField], pEntity, tmpField))
		{
			continue;
		}
		if (valuesDiffer(tmpBaseline[tmpField], pHeldRecord[tmpField], pEntity, tmpField))
		{
			tmpConflicts.push(tmpField);
		}
		else
		{
			tmpMoved.push(tmpField);
		}
	}
	if (tmpConflicts.length > 0)
	{
		return { Action: 'keep', Fields: tmpConflicts, Reason: `the row would overwrite unsaved changes to ${tmpConflicts.join(', ')}` };
	}
	return { Action: 'adopt', Fields: tmpMoved, Reason: tmpMoved.length > 0 ? `the server moved ${tmpMoved.join(', ')}` : 'the row matches the baseline' };
}

/**
 * Move the named fields of a server row into a record's baseline, leaving every other field as it was.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pFetchedRecord - The server row.
 * @param {Array<string>} pFields - The fields to move.
 * @return {boolean} - True when the baseline changed.
 */
function adoptRefreshedFields(pPict, pContext, pEntity, pGUID, pFetchedRecord, pFields)
{
	const tmpBaseline = readBaselineRecord(pPict, pContext, pEntity, pGUID);
	if (!tmpBaseline || !Array.isArray(pFields) || pFields.length < 1)
	{
		return false;
	}
	const tmpMerged = Object.assign({ }, tmpBaseline);
	for (const tmpField of pFields)
	{
		tmpMerged[tmpField] = pFetchedRecord[tmpField];
	}
	return writeBaselineRecord(pPict, pContext, pEntity, pGUID, tmpMerged);
}

/**
 * Fold a completed save's emission into the baseline, so the next save diffs against what was
 * actually written rather than re-asserting it.
 *
 * Called from `onAfterSaveDataAsync`, which the save waterfall only reaches when every earlier step
 * succeeded — so reaching here is the client's evidence that the document PUT carrying this
 * comprehension went through. That gate is the reason the fold is not done at prune time: advancing
 * the baseline over a save that then failed would make the retry emit nothing and lose the edit.
 *
 * Unlike the load capture this does NOT require a server identity: a record the form just created
 * has none until the document is reloaded, and it is exactly the record that must stop re-emitting
 * in full on every subsequent save.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Map<string, Record<string, any>>} pContextRoots - The emitted `<Entity>.<GUID>` roots, by context.
 * @return {number} - How many records were folded in.
 */
function foldEmissionIntoBaseline(pPict, pContextRoots)
{
	const tmpFolded = [];
	if (!pContextRoots || typeof pContextRoots.forEach !== 'function')
	{
		return 0;
	}
	let tmpCount = 0;
	pContextRoots.forEach((pContextRoot, pContext) =>
	{
		if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
		{
			return;
		}
		for (const tmpEntity of Object.keys(pContextRoot))
		{
			const tmpBucket = pContextRoot[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
				{
					continue;
				}
				if (isTombstoneRecord(tmpRecord))
				{
					writeBaselineRecord(pPict, pContext, tmpEntity, tmpGUID, reduceRecordForBaseline(tmpEntity, tmpRecord));
				tmpFolded.push(`${pContext}/${tmpEntity}#tombstone`);
				++tmpCount;
				continue;
				}
				const tmpExisting = readBaselineRecord(pPict, pContext, tmpEntity, tmpGUID);
				// A record folded over a tombstone is a re-add at the same GUID, so it replaces rather than
				// merges - carrying the tombstone's fields forward would leave `Deleted` in the baseline.
				const tmpPrior = isTombstoneRecord(tmpExisting) ? { } : (tmpExisting || { });
				const tmpMerged = Object.assign({ }, tmpPrior, reduceRecordForBaseline(tmpEntity, tmpRecord));
				writeBaselineRecord(pPict, pContext, tmpEntity, tmpGUID, tmpMerged);
				tmpFolded.push(`${pContext}/${tmpEntity}`);
				++tmpCount;
			}
		}
	});
	if (pPict && pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: folded ${tmpCount} record(s) into the baseline: ${tmpFolded.join(', ') || 'none'}.`);
	}
	return tmpCount;
}

/**
 * Forget one baseline record — a deleted row has no baseline, and a GUID re-added after a tombstone
 * must project whole again rather than diff against the row it replaced.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {boolean} - True when a record was removed.
 */
function dropBaselineRecord(pPict, pContext, pEntity, pGUID)
{
	const tmpStore = getBaselineStore(pPict, false);
	if (!tmpStore || !tmpStore[pContext] || !tmpStore[pContext][pEntity])
	{
		return false;
	}
	if (!Object.prototype.hasOwnProperty.call(tmpStore[pContext][pEntity], pGUID))
	{
		return false;
	}
	delete tmpStore[pContext][pEntity][pGUID];
	return true;
}

/** Where a save's emitted context roots accumulate between the providers and the document PUT. */
const PENDING_EMISSION_MARKER = '_EntityDataPendingEmission';

/**
 * Record a context root this save is going to carry, for the single fold that happens before the PUT.
 *
 * Every provider on the form runs its own sweep and its own prune over the SAME context root, so the
 * fold cannot live in the provider: the first provider to fold would advance the baseline, and the
 * next provider's prune would then find every record unchanged and DELETE it from the root - sending
 * an empty comprehension while the baseline claimed it had been written. The prune is only idempotent
 * across providers while the baseline stays still.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {Record<string, any>} pContextRoot - The pruned `<Entity>.<GUID>` root.
 * @return {void}
 */
function recordPendingEmission(pPict, pContext, pContextRoot)
{
	if (!pPict || typeof pPict !== 'object')
	{
		return;
	}
	if (!pPict[PENDING_EMISSION_MARKER] || typeof pPict[PENDING_EMISSION_MARKER].set !== 'function')
	{
		pPict[PENDING_EMISSION_MARKER] = new Map();
	}
	pPict[PENDING_EMISSION_MARKER].set(pContext, pContextRoot);
}

/**
 * Fold everything this save is carrying into the baseline, once, and forget it.
 *
 * Called from the document save immediately before the PUT: the baseline lives in `FormData` and
 * `FormData` is snapshotted into the PUT body, so folding afterwards leaves the new baseline in memory
 * only and a reload starts from the stale one.
 *
 * @param {Object} pPict - The pict instance.
 * @return {number} - How many records were folded.
 */
function foldPendingEmission(pPict)
{
	const tmpPending = pPict && pPict[PENDING_EMISSION_MARKER];
	if (!tmpPending || typeof tmpPending.forEach !== 'function')
	{
		return 0;
	}
	const tmpCount = foldEmissionIntoBaseline(pPict, tmpPending);
	delete pPict[PENDING_EMISSION_MARKER];
	return tmpCount;
}

/**
 * Discard the whole baseline.
 *
 * Used when a save fails. The baseline is folded forward BEFORE the PUT so it rides the same payload
 * as the comprehension it describes; if that PUT does not land, the baseline is claiming records were
 * written that may not have been. Clearing makes the retry project everything whole, which is the safe
 * direction - over-emitting costs a redundant upsert, under-emitting loses the record.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when a baseline was present and has been cleared.
 */
function clearBaseline(pPict)
{
	const tmpStore = getBaselineStore(pPict, false);
	if (!tmpStore)
	{
		return false;
	}
	for (const tmpContext of Object.keys(tmpStore))
	{
		delete tmpStore[tmpContext];
	}
	return true;
}

/**
 * Whether a baseline has been captured at all on this document.
 *
 * Until it has, every record projects whole — which is the pre-delta behaviour, and the correct
 * fallback: a missing baseline must never be read as "nothing changed".
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when a baseline exists.
 */
function hasBaseline(pPict)
{
	const tmpStore = getBaselineStore(pPict, false);
	return !!(tmpStore && Object.keys(tmpStore).length > 0);
}

/**
 * Narrow one context root from a state assertion to a change record.
 *
 * The sweep has just keyed every participating input's whole record into `pContextRoot`. This is the
 * one place that decides what actually ships, and it is the right place because it already walks
 * every projected leaf and because the decision needs the record, not the writer — sibling inputs
 * write into each other's records constantly, so dirtiness is a property of the fields, not of the
 * owning input's own events.
 *
 * Per leaf: sanitize as before, then diff against the baseline the settled load sweep captured.
 * Unchanged records are removed from the tree entirely, which is what makes an untouched save emit
 * an empty comprehension. Records with no baseline — ones this form created — project whole.
 * Tombstones pass through untouched; a delete is a minted event, not an inferred one.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The context this root hangs under.
 * @param {Record<string, any>} pContextRoot - The context root to narrow in place.
 * @return {{ Emitted: number, Suppressed: number }} - How many records shipped and how many were dropped.
 */
function pruneContextRootToDelta(pPict, pContext, pContextRoot)
{
	const tmpCounts = { Emitted: 0, Suppressed: 0 };
	const tmpEmittedDetail = [];
	if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
	{
		if (pPict && pPict.log && typeof pPict.log.trace === 'function')
		{
		pPict.log.trace(`EntityDataBaseline: ${pContext} emitting ${tmpCounts.Emitted}, suppressed ${tmpCounts.Suppressed} — ${tmpEmittedDetail.join(', ') || 'nothing'}.`);
		}
		return tmpCounts;
	}
	for (const tmpEntity of Object.keys(pContextRoot))
	{
		const tmpBucket = pContextRoot[tmpEntity];
		if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
		{
			continue;
		}
		for (const tmpGUID of Object.keys(tmpBucket))
		{
			const tmpRecord = tmpBucket[tmpGUID];
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			const tmpSanitized = libScopedEntityData.sanitizeRecord(tmpRecord);
			const tmpUnemittableReason = libScopedEntityData.getUnemittableReason(tmpEntity, tmpGUID, tmpSanitized);
			if (tmpUnemittableReason)
			{
				delete tmpBucket[tmpGUID];
				const tmpMessage = `EntityDataBaseline: dropped ${pContext}.${tmpEntity}.${tmpGUID} from the save because ${tmpUnemittableReason}.`;
				if (pPict && pPict.log && typeof pPict.log.warn === 'function')
				{
					pPict.log.warn(tmpMessage);
				}
				else
				{
					console.warn(tmpMessage);
				}
				continue;
			}
			const tmpBaseline = readBaselineRecord(pPict, pContext, tmpEntity, tmpGUID);
			const tmpDelta = computeRecordDelta(tmpEntity, tmpBaseline, tmpSanitized);
			if (!tmpDelta)
			{
				delete tmpBucket[tmpGUID];
				++tmpCounts.Suppressed;
				continue;
			}
			tmpEmittedDetail.push(`${tmpEntity}${tmpBaseline ? '(changed)' : '(NO BASELINE)'}`);
			tmpBucket[tmpGUID] = tmpDelta;
			++tmpCounts.Emitted;
		}
		if (Object.keys(tmpBucket).length < 1)
		{
			delete pContextRoot[tmpEntity];
		}
	}
	return tmpCounts;
}

/**
 * The sweep event both input families answer by projecting their records. The address half is
 * legacy-ledger vestige on the scoped path — the projectors resolve their own destination — but the
 * event string is matched whole by several subclasses, so it is reproduced verbatim.
 */
const PROJECTION_SWEEP_EVENT = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';

/** The AppData key the baseline's session state lives under: beside `DocumentData`, so the document save never carries it. */
const APP_STATE_KEY = 'EntityDataBaseline';

/**
 * The baseline's session state: the capture session, and the render transactions a load-settled
 * capture is already scheduled on (so N inputs schedule one).
 *
 * @param {Object} pPict - The pict instance.
 * @return {{ CaptureSession: ?{ Store: Record<string, any>, Known: Set<string> }, ScheduledTransactions: Record<string, boolean> }|null} - The state, or null without a pict.
 */
function getBaselineAppState(pPict)
{
	if (!pPict || typeof pPict !== 'object')
	{
		return null;
	}
	if (!pPict.AppData || typeof pPict.AppData !== 'object')
	{
		pPict.AppData = { };
	}
	const tmpState = pPict.AppData[APP_STATE_KEY];
	if (!tmpState || typeof tmpState !== 'object')
	{
		pPict.AppData[APP_STATE_KEY] = { CaptureSession: null, ScheduledTransactions: { } };
	}
	return pPict.AppData[APP_STATE_KEY];
}

/**
 * Run the save-time projection sweep into a scratch tree and hand back what it collected, without
 * touching the document's own EntityData.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Map<string, Record<string, any>>|null} - The `<Entity>.<GUID>` roots by context, or null when the sweep could not run.
 */
function runProjectionSweepToScratch(pPict)
{
	const tmpMetacontroller = pPict && pPict.views && pPict.views.PictFormMetacontroller;
	if (!tmpMetacontroller || typeof tmpMetacontroller.triggerGlobalInputEvent !== 'function')
	{
		return null;
	}
	let tmpContextRoots = null;
	libScopedEntityData.beginBaselineSweep(pPict);
	try
	{
		const tmpTransactionGUID = (typeof pPict.getUUID === 'function') ? pPict.getUUID() : `baseline-${Date.now()}`;
		if (pPict.TransactionTracking && typeof pPict.TransactionTracking.registerTransaction === 'function')
		{
			pPict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		tmpMetacontroller.triggerGlobalInputEvent(PROJECTION_SWEEP_EVENT, tmpTransactionGUID);
		if (typeof tmpMetacontroller.finalizeTransaction === 'function')
		{
			tmpMetacontroller.finalizeTransaction(tmpTransactionGUID);
		}
	}
	finally
	{
		// The sweep is synchronous for every projector in the family: each reads records already in
		// FormData and keys them into the target. Ending the redirect in `finally` guarantees the
		// document's own EntityData is never left shadowed if one of them throws.
		tmpContextRoots = libScopedEntityData.endBaselineSweep(pPict);
	}
	return tmpContextRoots || null;
}

/** How deep the identity writeback will walk FormData before giving up. */
const IDENTITY_WALK_MAX_DEPTH = 14;

/**
 * Write the row ids the server resolved back onto the records this form holds.
 *
 * The client mints GUIDs and the server resolves them to rows, so until the ids come back the form
 * has no way to know its records exist - which is what `hasServerIdentity` asks before a record may
 * seed a baseline. Without this the gate can never pass for a record the form minted and nothing
 * re-fetches, so it re-emits whole on every save forever.
 *
 * Walks `FormData` rather than re-running the projection sweep: the sweep is an event round-trip
 * through the metacontroller, and this runs inside the save lifecycle where a nested transaction is
 * not guaranteed to resolve. A record is matched on its own `GUID<Entity>`, so nesting and array
 * position do not matter, and an id already present is left alone.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, Record<string, number>>} pIdentities - Entity -> external GUID -> row id.
 * @return {number} - How many records learned their id.
 */
function applyResolvedIdentities(pPict, pIdentities)
{
	if (!pIdentities || typeof pIdentities !== 'object' || Array.isArray(pIdentities))
	{
		return 0;
	}
	const tmpEntities = Object.keys(pIdentities);
	if (tmpEntities.length < 1)
	{
		return 0;
	}
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function')
	{
		return 0;
	}
	const tmpFormData = pPict.manifest.getValueAtAddress(pPict, FORMDATA_ADDRESS);
	if (!tmpFormData || typeof tmpFormData !== 'object')
	{
		return 0;
	}

	let tmpCount = 0;
	const tmpSeen = new Set();
	const tmpStack = [ { Node: tmpFormData, Depth: 0 } ];
	while (tmpStack.length > 0)
	{
		const tmpFrame = tmpStack.pop();
		const tmpNode = tmpFrame.Node;
		if (!tmpNode || typeof tmpNode !== 'object' || tmpSeen.has(tmpNode) || tmpFrame.Depth > IDENTITY_WALK_MAX_DEPTH)
		{
			continue;
		}
		tmpSeen.add(tmpNode);

		if (!Array.isArray(tmpNode))
		{
			// A record carries a GUID for itself AND for everything it references - a DocumentPolyJoin
			// holds both `GUIDDocumentPolyJoin` and `GUIDSample`. Its own entity is the most specific
			// name it matches, because a join's name contains the names of what it joins; writing the
			// others would put a foreign id on the record and emit it as a column the table lacks.
			let tmpOwnEntity = null;
			let tmpOwnIdentity = 0;
			for (const tmpEntity of tmpEntities)
			{
				const tmpGUID = tmpNode[`GUID${tmpEntity}`];
				if (typeof tmpGUID !== 'string' || tmpGUID.length < 1)
				{
					continue;
				}
				const tmpIdentity = Number(pIdentities[tmpEntity][tmpGUID]);
				if (!(tmpIdentity > 0))
				{
					continue;
				}
				if (!tmpOwnEntity || tmpEntity.length > tmpOwnEntity.length)
				{
					tmpOwnEntity = tmpEntity;
					tmpOwnIdentity = tmpIdentity;
				}
			}
			if (tmpOwnEntity && !hasServerIdentity(tmpOwnEntity, tmpNode))
			{
				tmpNode[`ID${tmpOwnEntity}`] = tmpOwnIdentity;
				++tmpCount;
			}
		}

		for (const tmpKey of Object.keys(tmpNode))
		{
			// The baseline is a record store of its own; rewriting its leaves would change what the
			// next emission diffs against.
			if (tmpKey === BASELINE_KEY)
			{
				continue;
			}
			const tmpChild = tmpNode[tmpKey];
			if (tmpChild && typeof tmpChild === 'object')
			{
				tmpStack.push({ Node: tmpChild, Depth: tmpFrame.Depth + 1 });
			}
		}
	}
	return tmpCount;
}

/** How many held-identity reads are in flight at once. */
const HELD_IDENTITY_READ_CONCURRENCY = 4;

/** Keys a held-record walk never descends into: the legacy ledger and the baseline store. */
const HELD_RECORD_SKIPPED_KEYS = new Set([ '_EntityData', BASELINE_KEY ]);

/** The join whose table's unique key (document, remote type, remote row) makes a natural-key match unambiguous. */
const DOCUMENT_JOIN_ENTITY = 'DocumentPolyJoin';

/** Remote types a held document join may be matched to a live join by. */
const DOCUMENT_JOIN_NATURAL_KEY_TYPES = new Set([ 'Sample', 'TestInstance' ]);

/** The join whose table's unique key (TestInstance, Lab) makes a natural-key match unambiguous. */
const LAB_JOIN_ENTITY = 'TestInstanceLabJoin';

/**
 * Whether the document is frozen: rendered read-only, or locked. A frozen document keeps its saved
 * snapshot, so nothing may refresh or rewrite the records it holds.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when the document is not interactive or is locked.
 */
function isDocumentFrozen(pPict)
{
	const tmpAppData = pPict && pPict.AppData;
	if (!tmpAppData || !tmpAppData.Interactive)
	{
		return true;
	}
	const tmpDocument = tmpAppData.DocumentData && tmpAppData.DocumentData.ReportData;
	return !!(tmpDocument && tmpDocument.Locked);
}

/**
 * Whether saves go to the device's local store rather than the server, so server reads do not apply.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True on the local offline transport.
 */
function isLocalDocumentTransport(pPict)
{
	const tmpService = pPict && pPict.services && pPict.services.HeadlightDocumentService;
	return !!(tmpService && typeof tmpService.isLocalDocumentTransport === 'function' && tmpService.isLocalDocumentTransport());
}

/**
 * Every entity record the form holds in FormData, outside the legacy ledger and the baseline store,
 * each tagged with the entity it names itself as.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Array<{ Entity: string, Record: Record<string, any> }>} - The held records.
 */
function collectHeldRecords(pPict)
{
	const tmpHeld = [ ];
	const tmpFormData = pPict.manifest.getValueAtAddress(pPict, FORMDATA_ADDRESS);
	const tmpSeen = new Set();
	const tmpStack = [ { Node: tmpFormData, Depth: 0 } ];
	while (tmpStack.length > 0)
	{
		const tmpFrame = tmpStack.pop();
		const tmpNode = tmpFrame.Node;
		if (!tmpNode || typeof tmpNode !== 'object' || tmpSeen.has(tmpNode) || tmpFrame.Depth > IDENTITY_WALK_MAX_DEPTH)
		{
			continue;
		}
		tmpSeen.add(tmpNode);
		if (!Array.isArray(tmpNode))
		{
			const tmpEntity = libScopedEntityData.resolveRecordEntity(tmpNode);
			if (tmpEntity)
			{
				tmpHeld.push({ Entity: tmpEntity, Record: tmpNode });
			}
		}
		for (const tmpKey of Object.keys(tmpNode))
		{
			if (HELD_RECORD_SKIPPED_KEYS.has(tmpKey))
			{
				continue;
			}
			const tmpChild = tmpNode[tmpKey];
			if (tmpChild && typeof tmpChild === 'object')
			{
				tmpStack.push({ Node: tmpChild, Depth: tmpFrame.Depth + 1 });
			}
		}
	}
	return tmpHeld;
}

/**
 * Run callback-style tasks with at most `pLimit` in flight, then call `fDone` exactly once.
 *
 * @param {Array<(fNext: () => void) => void>} pTasks - The tasks.
 * @param {number} pLimit - The concurrency cap.
 * @param {() => void} fDone - Called once every task has settled.
 */
function runTasksWithConcurrency(pTasks, pLimit, fDone)
{
	if (pTasks.length < 1)
	{
		return fDone();
	}
	let tmpNext = 0;
	let tmpFinished = 0;
	const fLaunch = () =>
	{
		if (tmpNext >= pTasks.length)
		{
			return;
		}
		const tmpTask = pTasks[tmpNext++];
		let tmpSettled = false;
		const fSettle = () =>
		{
			if (tmpSettled)
			{
				return;
			}
			tmpSettled = true;
			tmpFinished++;
			if (tmpFinished === pTasks.length)
			{
				return fDone();
			}
			fLaunch();
		};
		try
		{
			tmpTask(fSettle);
		}
		catch (pError)
		{
			fSettle();
		}
	};
	for (let i = 0; i < Math.min(pLimit, pTasks.length); i++)
	{
		fLaunch();
	}
}

/**
 * The id of the one live row carrying a GUID, or 0 when the read failed, found nothing, or was ambiguous.
 * Render transactions settle together, so identical reads share one request (`_SharedEntityRead`).
 *
 * @param {Object} pPict - The pict instance (owns HeadlightRestClient).
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The external GUID.
 * @param {(pID: number) => void} fCallback - Called once with the id or 0.
 */
function readLiveRowID(pPict, pEntity, pGUID, fCallback)
{
	if (libSharedEntityRead.isEmptyIdentityValue(`GUID${pEntity}`, pGUID))
	{
		return fCallback(0);
	}
	libSharedEntityRead.readJSON(pPict, `${pEntity}s/FilteredTo/FBV~GUID${pEntity}~EQ~${encodeURIComponent(pGUID)}/0/2`, { ReuseResult: false }, (pError, pRows) =>
	{
		if (pError || !Array.isArray(pRows) || pRows.length !== 1)
		{
			return fCallback(0);
		}
		const tmpID = Number(pRows[0] && pRows[0][`ID${pEntity}`]);
		return fCallback(tmpID > 0 ? tmpID : 0);
	});
}

/**
 * Stamp resolved row ids onto the held records they belong to, matching each record on its OWN entity.
 *
 * A join carries the GUIDs of what it joins beside its own, so matching on any `GUID<X>` would put a
 * foreign id on it; `resolveRecordEntity` names the one entity the record is.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, Record<string, number>>} pResolved - Entity -> GUID -> row id.
 * @return {number} - How many records learned their id.
 */
function stampHeldIdentities(pPict, pResolved)
{
	let tmpCount = 0;
	for (const tmpItem of collectHeldRecords(pPict))
	{
		const tmpBucket = pResolved[tmpItem.Entity];
		const tmpGUID = tmpItem.Record[`GUID${tmpItem.Entity}`];
		if (!tmpBucket || typeof tmpGUID !== 'string' || !(tmpBucket[tmpGUID] > 0) || hasServerIdentity(tmpItem.Entity, tmpItem.Record))
		{
			continue;
		}
		tmpItem.Record[`ID${tmpItem.Entity}`] = tmpBucket[tmpGUID];
		++tmpCount;
	}
	return tmpCount;
}

/**
 * Point every held record carrying `pFromGUID` at a different row: its GUID and its id.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The entity name.
 * @param {string} pFromGUID - The GUID the held records carry now.
 * @param {string} pToGUID - The live row's GUID.
 * @param {number} pToID - The live row's id.
 * @return {number} - How many held records were rewritten.
 */
function rewriteHeldRecordIdentity(pPict, pEntity, pFromGUID, pToGUID, pToID)
{
	const tmpGUIDField = `GUID${pEntity}`;
	let tmpCount = 0;
	for (const tmpItem of collectHeldRecords(pPict))
	{
		if (tmpItem.Entity === pEntity && tmpItem.Record[tmpGUIDField] === pFromGUID)
		{
			tmpItem.Record[tmpGUIDField] = pToGUID;
			tmpItem.Record[`ID${pEntity}`] = pToID;
			++tmpCount;
		}
	}
	return tmpCount;
}

/**
 * Point held document joins whose own GUID names no row at the live join for the same document,
 * remote type and remote row. That triple is the table's unique key, so the match is the only one
 * possible; a remote row the form cannot resolve to an id, or a live join another held record already
 * carries, is left alone.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pRestClient - The REST client.
 * @param {Array<Record<string, any>>} pUnresolved - Held document joins with no live row under their GUID.
 * @param {Record<string, Record<string, number>>} pKnownIdentities - Entity -> GUID -> row id, to resolve a join's remote row.
 * @param {(pAdopted: number) => void} fCallback - Called once with how many joins were adopted.
 */
function adoptDocumentJoinsByNaturalKey(pPict, pRestClient, pUnresolved, pKnownIdentities, fCallback)
{
	const tmpDocument = pPict.AppData && pPict.AppData.DocumentData && pPict.AppData.DocumentData.ReportData;
	const tmpIDDocument = Number(tmpDocument && tmpDocument.IDDocument);
	const tmpCandidates = [ ];
	for (const tmpRecord of pUnresolved)
	{
		if (!tmpRecord || !DOCUMENT_JOIN_NATURAL_KEY_TYPES.has(tmpRecord.RemoteType))
		{
			continue;
		}
		let tmpIDRemote = Number(tmpRecord.IDRemote);
		if (!(tmpIDRemote > 0))
		{
			const tmpRemoteGUID = tmpRecord[`GUID${tmpRecord.RemoteType}`];
			const tmpKnown = pKnownIdentities[tmpRecord.RemoteType];
			tmpIDRemote = (tmpKnown && typeof tmpRemoteGUID === 'string') ? Number(tmpKnown[tmpRemoteGUID]) : 0;
		}
		if (tmpIDRemote > 0)
		{
			tmpCandidates.push({ GUID: tmpRecord[`GUID${DOCUMENT_JOIN_ENTITY}`], Key: `${tmpRecord.RemoteType}:${tmpIDRemote}` });
		}
	}
	if (!(tmpIDDocument > 0) || tmpCandidates.length < 1)
	{
		return fCallback(0);
	}
	const fSafeCallback = (pAdopted) =>
	{
		fCallback(pAdopted);
	};
	try
	{
		pRestClient.getJSON(`${DOCUMENT_JOIN_ENTITY}s/FilteredTo/FBV~IDDocument~EQ~${tmpIDDocument}/0/500`, (pError, pRows) =>
		{
			let tmpAdopted = 0;
			try
			{
				if (pError || !Array.isArray(pRows))
				{
					return;
				}
				const tmpLiveByKey = new Map();
				for (const tmpRow of pRows)
				{
					if (!tmpRow || !(Number(tmpRow.IDDocumentPolyJoin) > 0) || typeof tmpRow.GUIDDocumentPolyJoin !== 'string')
					{
						continue;
					}
					const tmpKey = `${tmpRow.RemoteType}:${Number(tmpRow.IDRemote)}`;
					tmpLiveByKey.set(tmpKey, tmpLiveByKey.has(tmpKey) ? null : tmpRow);
				}
				const tmpHeldGUIDs = new Set(collectHeldRecords(pPict)
					.filter((pItem) => pItem.Entity === DOCUMENT_JOIN_ENTITY)
					.map((pItem) => pItem.Record[`GUID${DOCUMENT_JOIN_ENTITY}`]));
				for (const tmpCandidate of tmpCandidates)
				{
					const tmpRow = tmpLiveByKey.get(tmpCandidate.Key);
					if (!tmpRow || tmpHeldGUIDs.has(tmpRow.GUIDDocumentPolyJoin))
					{
						continue;
					}
					tmpHeldGUIDs.add(tmpRow.GUIDDocumentPolyJoin);
					if (rewriteHeldRecordIdentity(pPict, DOCUMENT_JOIN_ENTITY, tmpCandidate.GUID, tmpRow.GUIDDocumentPolyJoin, Number(tmpRow.IDDocumentPolyJoin)) > 0)
					{
						++tmpAdopted;
					}
				}
			}
			finally
			{
				fSafeCallback(tmpAdopted);
			}
		});
	}
	catch (pError)
	{
		fSafeCallback(0);
	}
}

/**
 * Point held TestInstance lab joins whose own GUID names no row at the live lab join for the same
 * TestInstance and Lab. That pair is the table's unique key, so the match is the only one possible; a
 * TestInstance the form cannot resolve to an id, a live join another held record already carries, or a
 * pair with more than one live row is left alone.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pRestClient - The REST client.
 * @param {Array<Record<string, any>>} pUnresolved - Held lab joins with no live row under their GUID.
 * @param {Record<string, Record<string, number>>} pKnownIdentities - Entity -> GUID -> row id, to resolve a join's TestInstance.
 * @param {(pAdopted: number) => void} fCallback - Called once with how many lab joins were adopted.
 */
function adoptLabJoinsByNaturalKey(pPict, pRestClient, pUnresolved, pKnownIdentities, fCallback)
{
	const tmpKnownTestInstances = pKnownIdentities.TestInstance || { };
	const tmpCandidates = [ ];
	for (const tmpRecord of pUnresolved)
	{
		if (!tmpRecord)
		{
			continue;
		}
		let tmpIDTestInstance = Number(tmpRecord.IDTestInstance);
		if (!(tmpIDTestInstance > 0) && typeof tmpRecord.GUIDTestInstance === 'string')
		{
			tmpIDTestInstance = Number(tmpKnownTestInstances[tmpRecord.GUIDTestInstance]);
		}
		const tmpIDLab = Number(tmpRecord.IDLab);
		if (tmpIDTestInstance > 0 && tmpIDLab > 0)
		{
			tmpCandidates.push({ GUID: tmpRecord[`GUID${LAB_JOIN_ENTITY}`], Key: `${tmpIDTestInstance}:${tmpIDLab}`, IDTestInstance: tmpIDTestInstance });
		}
	}
	if (tmpCandidates.length < 1)
	{
		return fCallback(0);
	}
	let tmpCalled = false;
	const fSafeCallback = (pAdopted) =>
	{
		if (tmpCalled)
		{
			return;
		}
		tmpCalled = true;
		fCallback(pAdopted);
	};
	const tmpIDTestInstances = [ ...new Set(tmpCandidates.map((pCandidate) => pCandidate.IDTestInstance)) ];
	try
	{
		pRestClient.getJSON(`${LAB_JOIN_ENTITY}s/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}/0/500`, (pError, pRows) =>
		{
			let tmpAdopted = 0;
			try
			{
				if (pError || !Array.isArray(pRows))
				{
					return;
				}
				const tmpLiveByKey = new Map();
				for (const tmpRow of pRows)
				{
					if (!tmpRow || !(Number(tmpRow.IDTestInstanceLabJoin) > 0) || typeof tmpRow.GUIDTestInstanceLabJoin !== 'string')
					{
						continue;
					}
					const tmpKey = `${Number(tmpRow.IDTestInstance)}:${Number(tmpRow.IDLab)}`;
					tmpLiveByKey.set(tmpKey, tmpLiveByKey.has(tmpKey) ? null : tmpRow);
				}
				const tmpHeldGUIDs = new Set(collectHeldRecords(pPict)
					.filter((pItem) => pItem.Entity === LAB_JOIN_ENTITY)
					.map((pItem) => pItem.Record[`GUID${LAB_JOIN_ENTITY}`]));
				for (const tmpCandidate of tmpCandidates)
				{
					const tmpRow = tmpLiveByKey.get(tmpCandidate.Key);
					if (!tmpRow || tmpHeldGUIDs.has(tmpRow.GUIDTestInstanceLabJoin))
					{
						continue;
					}
					tmpHeldGUIDs.add(tmpRow.GUIDTestInstanceLabJoin);
					if (rewriteHeldRecordIdentity(pPict, LAB_JOIN_ENTITY, tmpCandidate.GUID, tmpRow.GUIDTestInstanceLabJoin, Number(tmpRow.IDTestInstanceLabJoin)) > 0)
					{
						++tmpAdopted;
					}
				}
			}
			finally
			{
				fSafeCallback(tmpAdopted);
			}
		});
	}
	catch (pError)
	{
		fSafeCallback(0);
	}
}

/**
 * Resolve the row ids of records the form holds without one, before the load baseline is captured.
 *
 * A record an earlier form version saved, or whose id never came back, carries only its GUID, so the
 * delta has no baseline for it and the first save re-sends it whole. Reading each such GUID's live row
 * and stamping the id makes it baselined like any other record. A held document join or TestInstance
 * lab join whose own GUID names no row is pointed at the live row for the same natural key. Only live
 * rows are adopted: a failed read, a missing row or a deleted one changes nothing.
 *
 * Meant to run once the load has settled, so it sees every record the loaders created or replaced.
 * Calls `fDone` exactly once: after every read has returned, or at once when there is nothing to read.
 * Skipped for a frozen document, on the local offline transport, and without a REST client.
 *
 * @param {Object} pPict - The pict instance.
 * @param {() => void} [fDone] - Called once, when the held records are settled.
 * @return {boolean} - True when reads were started.
 */
function resolveHeldIdentities(pPict, fDone)
{
	let tmpFinished = false;
	const fFinish = (pMessage) =>
	{
		if (tmpFinished)
		{
			return;
		}
		tmpFinished = true;
		if (pMessage && pPict && pPict.log && typeof pPict.log.info === 'function')
		{
			pPict.log.info(pMessage);
		}
		if (typeof fDone === 'function')
		{
			fDone();
		}
	};
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function' || isDocumentFrozen(pPict) || isLocalDocumentTransport(pPict))
	{
		fFinish(null);
		return false;
	}
	const tmpRestClient = pPict.HeadlightRestClient;
	if (!tmpRestClient || typeof tmpRestClient.getJSON !== 'function')
	{
		fFinish(null);
		return false;
	}

	const tmpKnown = { };
	const tmpPending = new Map();
	for (const tmpItem of collectHeldRecords(pPict))
	{
		const tmpGUID = tmpItem.Record[`GUID${tmpItem.Entity}`];
		if (typeof tmpGUID !== 'string' || tmpGUID.length < 1)
		{
			continue;
		}
		if (hasServerIdentity(tmpItem.Entity, tmpItem.Record))
		{
			if (!tmpKnown[tmpItem.Entity])
			{
				tmpKnown[tmpItem.Entity] = { };
			}
			tmpKnown[tmpItem.Entity][tmpGUID] = Number(tmpItem.Record[`ID${tmpItem.Entity}`]);
			continue;
		}
		const tmpKey = `${tmpItem.Entity} ${tmpGUID}`;
		if (!tmpPending.has(tmpKey))
		{
			tmpPending.set(tmpKey, { Entity: tmpItem.Entity, GUID: tmpGUID, Records: [ ] });
		}
		tmpPending.get(tmpKey).Records.push(tmpItem.Record);
	}
	if (tmpPending.size < 1)
	{
		fFinish(null);
		return false;
	}

	/** @type {Record<string, Record<string, number>>} */
	const tmpResolved = { };
	const tmpUnresolvedJoins = [ ];
	const tmpUnresolvedLabJoins = [ ];
	const tmpTasks = Array.from(tmpPending.values()).map((pItem) => (fNext) =>
	{
		readLiveRowID(pPict, pItem.Entity, pItem.GUID, (pID) =>
		{
			if (pID > 0)
			{
				if (!tmpResolved[pItem.Entity])
				{
					tmpResolved[pItem.Entity] = { };
				}
				tmpResolved[pItem.Entity][pItem.GUID] = pID;
			}
			else if (pItem.Entity === DOCUMENT_JOIN_ENTITY)
			{
				tmpUnresolvedJoins.push(...pItem.Records);
			}
			else if (pItem.Entity === LAB_JOIN_ENTITY)
			{
				tmpUnresolvedLabJoins.push(...pItem.Records);
			}
			fNext();
		});
	});
	try
	{
		runTasksWithConcurrency(tmpTasks, HELD_IDENTITY_READ_CONCURRENCY, () =>
		{
			try
			{
				const tmpStamped = stampHeldIdentities(pPict, tmpResolved);
				/** @type {Record<string, Record<string, number>>} */
				const tmpKnownIdentities = { };
				for (const tmpSource of [ tmpKnown, tmpResolved ])
				{
					for (const tmpEntity of Object.keys(tmpSource))
					{
						tmpKnownIdentities[tmpEntity] = Object.assign(tmpKnownIdentities[tmpEntity] || { }, tmpSource[tmpEntity]);
					}
				}
				adoptDocumentJoinsByNaturalKey(pPict, tmpRestClient, tmpUnresolvedJoins, tmpKnownIdentities, (pAdoptedJoins) =>
				{
					try
					{
						adoptLabJoinsByNaturalKey(pPict, tmpRestClient, tmpUnresolvedLabJoins, tmpKnownIdentities, (pAdoptedLabJoins) =>
						{
							const tmpTotal = tmpStamped + pAdoptedJoins + pAdoptedLabJoins;
							fFinish(tmpTotal > 0 ? `EntityDataBaseline: adopted the row ids of ${tmpStamped} held record(s), ${pAdoptedJoins} document join(s) and ${pAdoptedLabJoins} lab join(s) before the load baseline.` : null);
						});
					}
					catch (pError)
					{
						fFinish(`EntityDataBaseline: held-identity adoption stopped early, records keep what they held: ${pError.message || pError}`);
					}
				});
			}
			catch (pError)
			{
				fFinish(`EntityDataBaseline: held-identity adoption stopped early, records keep what they held: ${pError.message || pError}`);
			}
		});
	}
	catch (pError)
	{
		fFinish(`EntityDataBaseline: held-identity reads could not start: ${pError.message || pError}`);
	}
	return true;
}

/**
 * Capture the baseline now: sweep, sanitize, store.
 *
 * @param {Object} pPict - The pict instance.
 * @return {number} - How many records were baselined.
 */
function captureBaselineNow(pPict)
{
	const tmpContextRoots = runProjectionSweepToScratch(pPict);
	if (!tmpContextRoots)
	{
		return 0;
	}
	tmpContextRoots.forEach((pContextRoot) =>
	{
		libScopedEntityData.sanitizeContextRoot(pContextRoot);
	});
	return captureBaselineFromSweep(pPict, tmpContextRoots);
}

/**
 * Schedule the load-settled baseline capture on a render transaction, once however many inputs ask.
 *
 * The render transaction is the settle signal: `onAfterRender` opens it, every record fetch in both
 * families fences on it (`registerEventTransactionAsyncOperation`), and its completion callback runs
 * only once all of them have drained. Capturing there rather than at init is what makes the baseline
 * current server state — `PictForm.RefreshOnOpen` defaults to true, so a form open re-fetches and
 * replaces `__Record` wholesale, and a baseline taken before that lands would read every field
 * another actor changed since the last save as a user edit. The held-identity reads
 * (`resolveHeldIdentities`) start in that callback, so they see every record the loaders created or
 * replaced, and the capture waits for them.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pView - The dynamic-form view (owns the transaction API).
 * @param {string} pTransactionGUID - The render transaction.
 * @return {boolean} - True when this call scheduled the capture.
 */
function scheduleLoadBaselineCapture(pPict, pView, pTransactionGUID)
{
	if (!pPict || !pView || !pTransactionGUID || typeof pView.registerOnTransactionCompleteCallback !== 'function')
	{
		return false;
	}
	const tmpScheduled = getBaselineAppState(pPict).ScheduledTransactions;
	if (tmpScheduled[pTransactionGUID])
	{
		return false;
	}
	tmpScheduled[pTransactionGUID] = true;
	pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
	{
		delete tmpScheduled[pTransactionGUID];
		let tmpCaptured = false;
		const fCaptureAndRelease = () =>
		{
			if (tmpCaptured)
			{
				return;
			}
			tmpCaptured = true;
			try
			{
				const tmpFirstCapture = !hasCaptureSession(pPict);
				const tmpCount = captureBaselineNow(pPict);
				if (pPict.log && typeof pPict.log.trace === 'function')
				{
					pPict.log.trace(tmpFirstCapture ?
						`EntityDataBaseline: captured ${tmpCount} record(s) once the load settled.` :
						`EntityDataBaseline: captured ${tmpCount} record(s) first seen on a later render; records already baselined keep their values.`);
				}
			}
			catch (pError)
			{
				if (pPict.log && typeof pPict.log.error === 'function')
				{
					pPict.log.error(`EntityDataBaseline: load capture failed, records will project whole this session: ${pError.message || pError}`);
				}
			}
			try
			{
				releaseUnappliedRecords(pPict, pPict.manifest.getValueAtAddress(pPict, libScopedEntityData.DOCUMENT_ENTITY_DATA_ADDRESS));
			}
			catch (pError)
			{
				if (pPict.log && typeof pPict.log.error === 'function')
				{
					pPict.log.error(`EntityDataBaseline: could not read the server's unapplied records on load: ${pError.message || pError}`);
				}
			}
		};
		try
		{
			resolveHeldIdentities(pPict, fCaptureAndRelease);
		}
		catch (pError)
		{
			if (pPict.log && typeof pPict.log.error === 'function')
			{
				pPict.log.error(`EntityDataBaseline: could not start the held-identity reads: ${pError.message || pError}`);
			}
			fCaptureAndRelease();
		}
	});
	return true;
}

/**
 * The `<Entity>.<GUID>` keys of every record a log entry carried, and whether this entry failed each one.
 *
 * An error naming an entity but no record failed every record of that entity in the entry; an error naming
 * neither failed the whole entry, as a push-order abort does.
 *
 * @param {Record<string, any>} pEntry - One `ExecutionLog` entry.
 * @return {Map<string, { Entity: string, GUID: string, Failed: boolean }>} - Per-record outcome, keyed by entity and GUID.
 */
function readLogEntryOutcomes(pEntry)
{
	const tmpOutcomes = new Map();
	const tmpErrors = Array.isArray(pEntry.Errors) ? pEntry.Errors : [ ];
	const tmpFailedRecords = new Set();
	const tmpFailedEntities = new Set();
	let tmpAllFailed = false;
	for (const tmpError of tmpErrors)
	{
		if (!tmpError || typeof tmpError !== 'object')
		{
			continue;
		}
		if (tmpError.Entity && tmpError.GUID)
		{
			tmpFailedRecords.add(`${tmpError.Entity} ${tmpError.GUID}`);
		}
		else if (tmpError.Entity)
		{
			tmpFailedEntities.add(tmpError.Entity);
		}
		else
		{
			tmpAllFailed = true;
		}
	}
	const tmpComprehension = (pEntry.Comprehension && typeof pEntry.Comprehension === 'object') ? pEntry.Comprehension : { };
	for (const tmpEntity of Object.keys(tmpComprehension))
	{
		const tmpBucket = tmpComprehension[tmpEntity];
		if (!tmpBucket || typeof tmpBucket !== 'object')
		{
			continue;
		}
		const tmpGUIDs = Array.isArray(tmpBucket)
			? tmpBucket.map((pRecord) => pRecord && pRecord[`GUID${tmpEntity}`]).filter((pGUID) => !!pGUID)
			: Object.keys(tmpBucket);
		for (const tmpGUID of tmpGUIDs)
		{
			const tmpKey = `${tmpEntity} ${tmpGUID}`;
			const tmpFailed = tmpAllFailed || tmpFailedEntities.has(tmpEntity) || tmpFailedRecords.has(tmpKey);
			tmpOutcomes.set(tmpKey, { Entity: tmpEntity, GUID: String(tmpGUID), Failed: tmpFailed });
		}
	}
	for (const tmpKey of tmpFailedRecords)
	{
		if (!tmpOutcomes.has(tmpKey))
		{
			// Entity names carry no spaces; GUIDs can, so only the first space separates them.
			const tmpSeparator = tmpKey.indexOf(' ');
			tmpOutcomes.set(tmpKey, { Entity: tmpKey.substring(0, tmpSeparator), GUID: tmpKey.substring(tmpSeparator + 1), Failed: true });
		}
	}
	return tmpOutcomes;
}

/**
 * Release every record the server logged as not applied, so the next save re-emits it.
 *
 * The baseline is folded before the PUT, so a record the server then refused already reads as written.
 * The server's `ExecutionLog` is the source of record for what landed: a record counts as unapplied when
 * its newest appearance under `OnSave` is a failure. Dropping its baseline makes it project whole again on
 * the next save, whenever that is. The log is only read here, never written.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>|string} [pEntityData] - The document's `EntityData`, as an object or its JSON.
 * @return {number} - How many baseline records were released.
 */
function releaseUnappliedRecords(pPict, pEntityData)
{
	let tmpEntityData = pEntityData;
	if (typeof tmpEntityData === 'string')
	{
		try
		{
			tmpEntityData = JSON.parse(tmpEntityData);
		}
		catch (pError)
		{
			return 0;
		}
	}
	const tmpLog = (tmpEntityData && typeof tmpEntityData === 'object' && Array.isArray(tmpEntityData.ExecutionLog)) ? tmpEntityData.ExecutionLog : null;
	if (!tmpLog)
	{
		return 0;
	}
	const tmpContext = libScopedEntityData.DEFAULT_CONTEXT;
	const tmpLatest = new Map();
	for (const tmpEntry of tmpLog)
	{
		if (!tmpEntry || typeof tmpEntry !== 'object' || tmpEntry.TriggerKey !== tmpContext)
		{
			continue;
		}
		for (const [ tmpKey, tmpOutcome ] of readLogEntryOutcomes(tmpEntry))
		{
			tmpLatest.set(tmpKey, tmpOutcome);
		}
	}
	const tmpReleased = [ ];
	for (const tmpOutcome of tmpLatest.values())
	{
		if (tmpOutcome.Failed && dropBaselineRecord(pPict, tmpContext, tmpOutcome.Entity, tmpOutcome.GUID))
		{
			tmpReleased.push(`${tmpOutcome.Entity}/${tmpOutcome.GUID}`);
		}
	}
	if (tmpReleased.length > 0 && pPict && pPict.log && typeof pPict.log.info === 'function')
	{
		pPict.log.info(`EntityDataBaseline: the server did not apply ${tmpReleased.length} record(s); the next save sends them again: ${tmpReleased.join(', ')}.`);
	}
	return tmpReleased.length;
}

module.exports =
{
	BASELINE_ADDRESS,
	PROJECTION_SWEEP_EVENT,
	pruneContextRootToDelta,
	runProjectionSweepToScratch,
	captureBaselineNow,
	applyResolvedIdentities,
	isDocumentFrozen,
	resolveHeldIdentities,
	scheduleLoadBaselineCapture,
	DELETED_FIELD,
	isDirectiveField,
	isCrossEntityReferenceField,
	getEntityClassification,
	isIdentityField,
	isAuditField,
	isNumericField,
	isComparableField,
	isEmittableField,
	hasServerIdentity,
	isTombstoneRecord,
	valuesDiffer,
	computeRecordDelta,
	reduceRecordForBaseline,
	getBaselineStore,
	readBaselineRecord,
	writeBaselineRecord,
	dropBaselineRecord,
	captureBaselineFromSweep,
	refreshBaselineRecords,
	isAlwaysEmittedReference,
	classifyRecordRefresh,
	adoptRefreshedFields,
	foldEmissionIntoBaseline,
	clearBaseline,
	recordPendingEmission,
	foldPendingEmission,
	hasBaseline,
	releaseUnappliedRecords,
};

},{"./_EntityFieldClassification.json":134,"./_ScopedEntityData.js":139,"./_SharedEntityRead.js":140}],133:[function(require,module,exports){
/**
 * The ONE entity display-name resolution order, shared by the legacy Select2Util display chain and the
 * Picker stack's Read/Print display so the Select2 → Picker migration cannot change what a field paints.
 *
 * Two record shapes are why this can never be a flat `pRecord[Field]` read:
 *
 *   - **User.** The table carries no `Name` column (NameFirst, NameLast, Phone, Email, LoginID, …), so an
 *     `Entity: 'User'` descriptor with no display field — the shared LADOTD "Sampled By" / "Created By"
 *     header fields, injected into ~152 forms — reads undefined and paints blank.
 *   - **A dotted display field** (`MixMetadata.MixName`). `pRecord['MixMetadata.MixName']` is undefined;
 *     the path has to be walked hop by hop.
 *
 * The two callers differ ONLY in what they show when the record has nothing, which is what lets one
 * implementation serve both: Select2Util passes its legacy `Unnamed <Entity> #<id>` placeholder as
 * pUnnamedFallback, while PickerDisplay passes none, takes '' and paints unnamedEntityLabel's
 * `<Entity> #<id>` itself — the Picker stack's label for a record with no name, shared with the Edit
 * picker so both read the same.
 *
 * @module _EntityDisplayName
 */

/**
 * Walk a dotted path across a record, hasOwnProperty-guarded at each hop. A missing hop yields null
 * rather than throwing.
 *
 * @param {Record<string, any>} pRecord - The entity record.
 * @param {string} pPath - The dotted field path.
 * @return {any}
 */
function resolveDottedValue(pRecord, pPath)
{
	let tmpValue = /** @type {any} */ (pRecord);
	for (const tmpField of pPath.split('.'))
	{
		if (!tmpValue || !Object.prototype.hasOwnProperty.call(tmpValue, tmpField))
		{
			return null;
		}
		tmpValue = tmpValue[tmpField];
	}
	return tmpValue;
}

/**
 * A User's display name, composed from the name parts the table actually has. Joins only the parts that
 * are present, so a record missing both yields '' — and the caller's fallback — rather than the literal
 * "undefined undefined" the legacy template produced.
 *
 * @param {Record<string, any>} pRecord - The User record.
 * @return {string}
 */
function composeUserName(pRecord)
{
	return [ pRecord.NameFirst, pRecord.NameLast ]
		.filter((pPart) => (pPart !== undefined && pPart !== null && String(pPart).trim() !== ''))
		.join(' ');
}

/**
 * The display text for an entity record. Pure — the record is never written to.
 *
 * @param {string} pEntity - The entity type the record belongs to.
 * @param {Record<string, any>} pRecord - The entity record.
 * @param {Record<string, any>} [pOptions] - Display config; TextField or EntityDisplayField names the
 *   display field (a dotted path is walked).
 * @param {() => string} [pUnnamedFallback] - What to show when the record has nothing; omitted = ''.
 *
 * @return {any} - The display text.
 */
function resolveEntityDisplayName(pEntity, pRecord, pOptions = {}, pUnnamedFallback)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return '';
	}
	const fFallback = () => ((typeof pUnnamedFallback === 'function') ? pUnnamedFallback() : '');
	const tmpDisplayField = pOptions.TextField || pOptions.EntityDisplayField;
	if (tmpDisplayField && tmpDisplayField.includes('.'))
	{
		return resolveDottedValue(pRecord, tmpDisplayField) || fFallback();
	}
	if (tmpDisplayField)
	{
		// No fallback on this branch, matching the legacy chain: an explicitly named field that is empty
		// stays empty rather than being replaced by a placeholder.
		return pRecord[tmpDisplayField];
	}
	if (pEntity === 'User')
	{
		return composeUserName(pRecord) || fFallback();
	}
	return pRecord.Name || fFallback();
}

/**
 * The noun for an Organization, which plays a different role on each field (Producer, Contractor, Source, …):
 * a one-word field label names the role, a longer label that mentions a producer reads `Producer`, and
 * anything else reads `Organization`.
 *
 * @param {string} [pFieldLabel] - The label of the field showing the record.
 * @return {string}
 */
function organizationLabel(pFieldLabel)
{
	const tmpLabel = String(pFieldLabel || '').trim();
	if (/^[A-Za-z]+$/.test(tmpLabel))
	{
		return tmpLabel;
	}
	if (/producer/i.test(tmpLabel))
	{
		return 'Producer';
	}
	return 'Organization';
}

/**
 * The user-facing noun for an entity: the table name split into words (`MixSpecification` →
 * `Mix Specification`), or for an Organization the role its field label names (organizationLabel).
 *
 * @param {string} pEntity - The entity type.
 * @param {string} [pFieldLabel] - The label of the field showing the record.
 * @return {string}
 */
function entityLabel(pEntity, pFieldLabel)
{
	if (pEntity === 'Organization')
	{
		return organizationLabel(pFieldLabel);
	}
	return String(pEntity || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

/**
 * What a record with no display name shows in its place: `<entity label> #<record ID>`, e.g.
 * `Document #37945` or `Contractor #3456`. '' when there is no ID to show.
 *
 * @param {string} pEntity - The entity type.
 * @param {any} pID - The record's ID.
 * @param {string} [pFieldLabel] - The label of the field showing the record.
 * @return {string}
 */
function unnamedEntityLabel(pEntity, pID, pFieldLabel)
{
	if (pID === undefined || pID === null || String(pID).trim() === '')
	{
		return '';
	}
	return `${entityLabel(pEntity, pFieldLabel)} #${pID}`;
}

module.exports = { resolveEntityDisplayName, entityLabel, unnamedEntityLabel };

},{}],134:[function(require,module,exports){
module.exports={"AuditColumns":["CreateDate","CreatingIDUser","UpdateDate","UpdatingIDUser","DeleteDate","DeletingIDUser","ExternalSyncDate","IDCustomer"],"Entities":{"AcademyContent":{"I":["IDAcademyContent","GUIDAcademyContent"],"D":["Deleted","Hash","Title","Content"],"N":[]},"AcademyContentArchive":{"I":["IDAcademyContentArchive","GUIDAcademyContentArchive"],"D":["Deleted","Hash","Title","Content"],"N":[]},"AcademyLearningProgression":{"I":["IDAcademyLearningProgression","GUIDAcademyLearningProgression"],"D":["Deleted","Name","Description"],"N":[]},"AcademyLearningProgressionRole":{"I":["IDAcademyLearningProgressionRole","GUIDAcademyLearningProgressionRole"],"D":["Deleted","IDAcademyLearningProgression","Role"],"N":["IDAcademyLearningProgression"]},"AcademyLesson":{"I":["IDAcademyLesson","GUIDAcademyLesson"],"D":["Deleted","Hash","Address","Type","Name","Description","MinutesRequired","Difficulty"],"N":["MinutesRequired","Difficulty"]},"AcademyLessonAcademyObjectiveJoin":{"I":["IDAcademyLessonAcademyObjectiveJoin","GUIDAcademyLessonAcademyObjectiveJoin"],"D":["Deleted","IDAcademyLesson","IDAcademyObjective"],"N":["IDAcademyLesson","IDAcademyObjective"]},"AcademyLessonUserJoin":{"I":["IDAcademyLessonUserJoin","GUIDAcademyLessonUserJoin"],"D":["Deleted","IDAcademyLesson","IDUser","Completion","Completed","State"],"N":["IDAcademyLesson","IDUser","Completion"]},"AcademyObjective":{"I":["IDAcademyObjective","GUIDAcademyObjective"],"D":["Deleted","IDAcademyLearningProgression","Name","Description"],"N":["IDAcademyLearningProgression"]},"AcademySubscription":{"I":["IDAcademySubscription","GUIDAcademySubscription"],"D":["Hash","Ordinal","Title","Description","Location","ConfigurationJSON"],"N":["Ordinal"]},"AcademyTips":{"I":["IDAcademyTips","GUIDAcademyTips"],"D":["Deleted","Application","Hash","UXHash","Title","Tip"],"N":[]},"Account":{"I":["IDAccount","GUIDAccount"],"D":["Deleted","Name","Hash","Description","IDAccountType","EntityName","IDEntity","Balance","Pending"],"N":["IDAccountType","IDEntity","Balance","Pending"]},"AccountBudget":{"I":["IDAccountBudget","GUIDAccountBudget"],"D":["Deleted","Hash","BudgetedAmount","SpentAmount","IDAccount","Mapped","SourceIDAccount","PriorityGroup","PriorityWeight"],"N":["BudgetedAmount","SpentAmount","IDAccount","SourceIDAccount","PriorityWeight"]},"AccountEntityJoin":{"I":["IDAccountEntityJoin","GUIDAccountEntityJoin"],"D":["Deleted","IDAccount","EntityType","IDEntity"],"N":["IDAccount","IDEntity"]},"AccountLedger":{"I":["IDAccountLedger","GUIDAccountLedger"],"D":["Deleted","IDAccount","IDPaymentTransaction","Deposit","Withdrawal","Balance","Pending","TransactionTime","TransactionOrdinal"],"N":["IDAccount","IDPaymentTransaction","Deposit","Withdrawal","Balance","TransactionOrdinal"]},"AccountType":{"I":["IDAccountType","GUIDAccountType"],"D":["Deleted","Name","Hash","EntityName","Description"],"N":[]},"AppArtifact":{"I":["IDAppArtifact","GUIDAppArtifact"],"D":["Deleted","IDProject","Type","AppHash","IDArtifact"],"N":["IDProject","IDArtifact"]},"AppData":{"I":["IDAppData","GUIDAppData"],"D":["Deleted","IDProject","Type","Title","Description","Datum","AppHash"],"N":["IDProject"]},"AppProcessLock":{"I":["IDAppProcessLock","GUIDSession"],"D":["Name","StartDate","Locked","TimeoutInSeconds","ReleaseDate"],"N":["TimeoutInSeconds"]},"Apps":{"I":["IDApplication"],"D":["ClientID","Secret","IDUser","Name"],"N":["IDUser"]},"Artifact":{"I":["IDArtifact","GUIDArtifact"],"D":["Deleted","ArtifactType","Datum","Version","Invalid","IDDevice","Sync"],"N":["Version","IDDevice"]},"ArtifactType":{"I":["IDArtifactType","GUIDArtifactType"],"D":["Deleted","Name","Schemata"],"N":[]},"ArtifactTypeSpecification":{"I":["IDArtifactTypeSpecification","GUIDArtifactTypeSpecification"],"D":["Deleted","IDArtifactType","Name","CountMinimum","CountMaximum","Required"],"N":["IDArtifactType","CountMinimum","CountMaximum"]},"AssetClassification":{"I":["IDAssetClassification","GUIDAssetClassification"],"D":["Deleted","Name","Description"],"N":[]},"AssetType":{"I":["IDAssetType","GUIDAssetType"],"D":["Deleted","Name","Description"],"N":[]},"AssetTypeManifest":{"I":["IDAssetTypeManifest","GUIDAssetTypeManifest"],"D":["Deleted","IDAssetType","Version","ManifestJSON"],"N":["IDAssetType","Version"]},"AxiomEntitySet":{"I":["IDAxiomEntitySet","GUIDAxiomEntitySet"],"D":["Deleted","SetScope"],"N":[]},"BidItem":{"I":["IDBidItem","GUIDBidItem"],"D":["Deleted","Name","Description","Quantity","Units","CostPerUnit","IDContract","IDProject","IDPayItem","IDOrganization"],"N":["Quantity","CostPerUnit","IDContract","IDProject","IDPayItem","IDOrganization"]},"BidItemOrganizationJoin":{"I":["IDBidItemOrganizationJoin","GUIDBidItemOrganizationJoin"],"D":["DisadvantagedBusiness","IDBidItem","IDOrganization"],"N":["IDBidItem","IDOrganization"]},"Certification":{"I":["IDCertification","GUIDCertification"],"D":["Deleted","Notes","CertifiedOn","CertifiedStartDate","CertifiedEndDate","IDCertificationType","URL"],"N":["IDCertificationType"]},"CertificationEntityPolyJoin":{"I":["IDCertificationEntityPolyJoin","GUIDCertificationEntityPolyJoin"],"D":["Deleted","IDCertification","EntityType","IDEntity"],"N":["IDCertification","IDEntity"]},"CertificationType":{"I":["IDCertificationType","GUIDCertificationType"],"D":["Deleted","Name","Hash","Verb","Description"],"N":[]},"CertificationTypeCertifiedEntityPolyJoin":{"I":["IDCertificationTypeCertifiedEntityPolyJoin","GUIDCertificationTypeCertifiedEntityPolyJoin"],"D":["Deleted","IDCertificationType","EntityType","IDEntity","Note"],"N":["IDCertificationType","IDEntity"]},"ChangeOrder":{"I":["IDChangeOrder","GUIDChangeOrder"],"D":["Deleted","ChangeNumber","Amount","Description","ReasonCode","DateOfChange","ApprovedByDate","Status","AdditionalDays","FormIDDocument","Remarks","IDContract","IDProject"],"N":["Amount","AdditionalDays","FormIDDocument","IDContract","IDProject"]},"Comment":{"I":["IDComment","GUIDComment"],"D":["IDParent","Deleted","Comment","CommentHtml","Metadata"],"N":["IDParent"]},"ConfigEntry":{"I":["IDConfigEntry","GUIDConfigEntry"],"D":["NamespaceKey","NamespaceValue","LevelContext","LevelContextID","Address","ConfigValue"],"N":["LevelContextID"]},"ConfigFragment":{"I":["IDConfigFragment","GUIDConfigFragment"],"D":["Deleted","Type","Hash","FragmentJSON"],"N":[]},"Contact":{"I":["IDContact","GUIDContact"],"D":["Deleted","NameFirst","NameLast","NameFull","Title","IDOrganization","Email","Phone"],"N":["IDOrganization"]},"ContactOrganizationJoin":{"I":["IDContactOrganizationJoin","GUIDContactOrganizationJoin"],"D":["Deleted","IDContact","IDOrganization","Active"],"N":["IDContact","IDOrganization"]},"ContextDataRequirementSetJoin":{"I":["IDContextDataRequirementSetJoin","GUIDContextDataRequirementSetJoin"],"D":["Deleted","IDDataRequirementSet","Type","Context","OptionsJSON"],"N":["IDDataRequirementSet"]},"Contract":{"I":["IDContract","GUIDContract"],"D":["Deleted","Name","Description","PrimaryProjectNumber","CountyProjectNumber","StateProjectNumber","FederalProjectNumber","Status","DBEStructure","RouteNumber","HighwayNumber","PavingMaterial","StationBegin","TerminusBegin","StationEnd","TerminusEnd","TotalBidAmount","NetChangeOrderAmount","VendorAccountCode","ItemSpecificationYear","MaterialsSpecificationYear","ItemIDTestSpecificationSet","MaterialIDTestSpecificationSet","IDOrganization","ExternalContractID","IDContractType","EstimatedCompletionDate"],"N":["TotalBidAmount","NetChangeOrderAmount","ItemIDTestSpecificationSet","MaterialIDTestSpecificationSet","IDOrganization","IDContractType"]},"ContractDate":{"I":["IDContractDate","GUIDContractDate"],"D":["Deleted","Name","Hash","Date","IDContract"],"N":["IDContract"]},"ContractType":{"I":["IDContractType","GUIDContractType"],"D":["Deleted","Name","Hash","Description","SettingsJSON"],"N":[]},"ContractTypeDefaultDate":{"I":["IDContractTypeDefaultDate","GUIDContractTypeDefaultDate"],"D":["Deleted","Name","Hash","IDContractType"],"N":["IDContractType"]},"ContractTypeDefaultFunding":{"I":["IDContractTypeDefaultFunding","GUIDContractTypeDefaultFunding"],"D":["Deleted","IDFundingSource","IDFundingCategory","IDContractType"],"N":["IDFundingSource","IDFundingCategory","IDContractType"]},"Core":{"I":["IDCore","GUIDCore"],"D":["Deleted","IDLot","IDSublot","IDSample","IDContract","LPSyncDate","HLSyncDate","QRCode","SublotName"],"N":["IDLot","IDSublot","IDSample","IDContract"]},"CoreResult":{"I":["IDCoreResult","GUIDCoreResult"],"D":["Deleted","IDCore","ResultPassed","ResultData","LPSyncDate","HLSyncDate"],"N":["IDCore"]},"Customer":{"I":["IDCustomer","GUIDCustomer"],"D":["Deleted","Name","Code","Enabled","CustomProperties","Timezone"],"N":[]},"CustomerModuleJoin":{"I":["IDCustomerModuleJoin","GUIDCustomerModuleJoin"],"D":["ModuleHash","IDProgram","StartDate","EndDate","SettingsJSON"],"N":["IDProgram"]},"Dashboard":{"I":["IDDashboard","GUIDDashboard"],"D":["Deleted","Hash","Name","Description","RecordSet","Icon","Accent","CustomerVisible","Category","Ordinal","IsDefault","UserCustomized","DataSourceJSON"],"N":["Ordinal"]},"DashboardAdoptionHeatmap":{"I":["IDDashboardAdoptionHeatmap","GUIDDashboardAdoptionHeatmap"],"D":["Deleted","IDUser","PeriodMonth","ObservationCount"],"N":["IDUser","ObservationCount"]},"DashboardApprovalStat":{"I":["IDDashboardApprovalStat","GUIDDashboardApprovalStat"],"D":["Deleted","DocumentType","SubmittedCount","ApprovedCount","RejectedCount","ReturnedCount","AvgTurnaroundDays"],"N":["SubmittedCount","ApprovedCount","RejectedCount","ReturnedCount","AvgTurnaroundDays"]},"DashboardApprovalTransition":{"I":["IDDashboardApprovalTransition","GUIDDashboardApprovalTransition"],"D":["Deleted","FromStatus","ToStatus","RecordCount","AvgDays"],"N":["RecordCount","AvgDays"]},"DashboardCustomerSummary":{"I":["IDDashboardCustomerSummary","GUIDDashboardCustomerSummary"],"D":["Deleted","ProjectsActive","ProjectsTotal","UsersActive","UsersDisabled","ObservationsTotal","DocumentsTotal","DocumentsPending","DocumentsApproved","DocumentsRejected","SamplesTotal","ContractsTotal","InspectionsTotal","PhysicalAssetsTotal","CertificationsTotal","ElectronicSignatures","OrganizationsTotal","EquipmentTotal","ObsMissingGeo","StaleUsers","StuckDocuments","EmptyProjects","SessionsTotal"],"N":["ProjectsActive","ProjectsTotal","UsersActive","UsersDisabled","ObservationsTotal","DocumentsTotal","DocumentsPending","DocumentsApproved","DocumentsRejected","SamplesTotal","ContractsTotal","InspectionsTotal","PhysicalAssetsTotal","CertificationsTotal","ElectronicSignatures","OrganizationsTotal","EquipmentTotal","ObsMissingGeo","StaleUsers","StuckDocuments","EmptyProjects","SessionsTotal"]},"DashboardDailyTrend":{"I":["IDDashboardDailyTrend","GUIDDashboardDailyTrend"],"D":["Deleted","PeriodDate","MetricType","DimensionValue","RecordCount","UniqueCount"],"N":["RecordCount","UniqueCount"]},"DashboardDistribution":{"I":["IDDashboardDistribution","GUIDDashboardDistribution"],"D":["Deleted","Category","Label","Sublabel","RecordCount"],"N":["RecordCount"]},"DashboardModuleAdoption":{"I":["IDDashboardModuleAdoption","GUIDDashboardModuleAdoption"],"D":["Deleted","ModuleName","RecordCount","Active"],"N":["RecordCount"]},"DashboardPendingDocument":{"I":["IDDashboardPendingDocument","GUIDDashboardPendingDocument"],"D":["Deleted","IDDocument","Name","Status","DaysPending","DocumentCreateDate"],"N":["IDDocument","DaysPending"]},"DashboardProjectStat":{"I":["IDDashboardProjectStat","GUIDDashboardProjectStat"],"D":["Deleted","IDProject","UserCount","ObservationCount","DocumentCount","SampleCount","RecentObservations30d","ApprovedDocuments","AssignedUsers","ActiveUsers30d","ChangeOrderCount","ChangeOrderTotalAmount","TotalBidAmount"],"N":["IDProject","UserCount","ObservationCount","DocumentCount","SampleCount","RecentObservations30d","ApprovedDocuments","AssignedUsers","ActiveUsers30d","ChangeOrderCount","ChangeOrderTotalAmount","TotalBidAmount"]},"DashboardUserStat":{"I":["IDDashboardUserStat","GUIDDashboardUserStat"],"D":["Deleted","IDUser","SessionCount","SessionCount30d","ObservationCount","DocumentCount","ApprovalCount","LastLoginDate","RecencyDays"],"N":["IDUser","SessionCount","SessionCount30d","ObservationCount","DocumentCount","ApprovalCount","RecencyDays"]},"DataRequirement":{"I":["IDDataRequirement","GUIDDataRequirement"],"D":["Deleted","InputHash","Type","Value","OptionsJSON"],"N":[]},"DataRequirementOutcome":{"I":["IDDataRequirementOutcome","GUIDDataRequirementOutcome"],"D":["Deleted","IDDataRequirement","Class","Value","MessageTemplate"],"N":["IDDataRequirement"]},"DataRequirementSet":{"I":["IDDataRequirementSet","GUIDDataRequirementSet"],"D":["Deleted","Name","Description"],"N":[]},"DataRequirementSetDataRequirementJoin":{"I":["IDDataRequirementSetDataRequirementJoin","GUIDDataRequirementSetDataRequirementJoin"],"D":["Deleted","IDDataRequirementSet","IDDataRequirement"],"N":["IDDataRequirementSet","IDDataRequirement"]},"DataSet":{"I":["IDDataSet","GUIDDataSet"],"D":["Deleted","Name","Status","Description","MetadataJSON"],"N":[]},"Device":{"I":["IDDevice","GUIDDevice"],"D":["Deleted","Name","UUID","Descriptor"],"N":[]},"DeviceSynchronizationLog":{"I":["IDDeviceDeviceSynchronizationLog","GUIDDeviceDeviceSynchronizationLog"],"D":["CreateDateDeviceSynchronizationLog","IDDevice","Completed"],"N":["IDDevice"]},"Document":{"I":["IDDocument","GUIDDocument"],"D":["Deleted","Name","Description","IDDevice","IDProject","DocumentType","DocumentDate","Status","Version","AppHash","Timezone","Shift","StateName","StateStep","Locked","Form","FormDataJSON","EntityDataJSON","SequenceNumber","ExternalSyncGUID","StaleUserActions"],"N":["IDDevice","IDProject","Version","StateStep","SequenceNumber"]},"DocumentAccessJoin":{"I":["IDDocumentAccessJoin","GUIDDocumentAccessJoin"],"D":["Deleted","IDDocument","DocumentType","IDRole","IDTeam","AccessKind","GrantRule"],"N":["IDDocument","IDRole","IDTeam"]},"DocumentApprovalLog":{"I":["IDDocumentApprovalLog","GUIDDocumentApprovalLog"],"D":["Deleted","IDDocument","IDElectronicSignature","Status","Action","StateStep","AfterStatus","IsApproval","InvalidatesApproval"],"N":["IDDocument","IDElectronicSignature","StateStep"]},"DocumentApprovalState":{"I":["IDDocumentApprovalState","GUIDDocumentApprovalState"],"D":["Deleted","Hash","Name"],"N":[]},"DocumentApprovalStep":{"I":["IDDocumentApprovalStep","GUIDDocumentApprovalStep"],"D":["Deleted","IDDocumentApprovalState","Ordinal","IDProject","IDRole","IncludeHigherRoles","PerformLock"],"N":["IDDocumentApprovalState","Ordinal","IDProject","IDRole"]},"DocumentApprovalWorkflow":{"I":["IDDocumentApprovalWorkflow"],"D":["FromStatus","EdgeOptions","ToStatus","Name","IDProject"],"N":["IDProject"]},"DocumentArchive":{"I":["IDDocumentArchive","GUIDDocumentArchive","GUIDDocument"],"D":["IDDocument","Deleted","Name","Description","IDDevice","IDProject","DocumentType","DocumentDate","Status","Version","SnapshotJSON","AppHash","Timezone","Shift","StateName","StateStep","Locked","Form","FormDataJSON","SequenceNumber","ExternalSyncGUID","StaleUserActions"],"N":["IDDocument","IDDevice","IDProject","Version","StateStep","SequenceNumber"]},"DocumentArtifact":{"I":["IDDocumentArtifact","GUIDDocumentArtifact"],"D":["Deleted","Type","Version","Datum"],"N":["Version"]},"DocumentArtifactDocumentJoin":{"I":["IDDocumentArtifactDocumentJoin","GUIDDocumentArtifactDocumentJoin"],"D":["Deleted","IDDocumentArtifact","IDDocument"],"N":["IDDocumentArtifact","IDDocument"]},"DocumentCommentJoin":{"I":["IDDocumentCommentJoin","GUIDDocumentCommentJoin"],"D":["IDDocument","IDComment"],"N":["IDDocument","IDComment"]},"DocumentElectronicSignatureJoin":{"I":["IDDocumentElectronicSignatureJoin","GUIDDocumentElectronicSignatureJoin"],"D":["IDDocument","IDElectronicSignature"],"N":["IDDocument","IDElectronicSignature"]},"DocumentManifest":{"I":["IDDocumentManifest","GUIDDocumentManifest"],"D":["Deleted","Name"],"N":[]},"DocumentMetadata":{"I":["IDDocumentMetadata","GUIDDocumentMetadata"],"D":["MetadataJSON","IDDocument"],"N":["IDDocument"]},"DocumentObservationJoin":{"I":["IDDocumentObservationJoin","GUIDDocumentObservationJoin"],"D":["Deleted","IDDocument","IDObservation"],"N":["IDDocument","IDObservation"]},"DocumentPolyJoin":{"I":["IDDocumentPolyJoin","GUIDDocumentPolyJoin"],"D":["IDDocument","RemoteType","IDRemote","Ordinal","Name"],"N":["IDDocument","IDRemote","Ordinal"]},"DocumentRequirementSpecification":{"I":["IDDocumentRequirementSpecification","GUIDDocumentRequirementSpecification"],"D":["Deleted","IDDocument","IDObservationManifest","Name","CountMinimum","CountMaximum","Required"],"N":["IDDocument","IDObservationManifest","CountMinimum","CountMaximum"]},"ElectronicSignature":{"I":["IDElectronicSignature","GUIDElectronicSignature"],"D":["Deleted","Signer","IDContact","IDArtifact","SignatureType","Approved"],"N":["IDContact","IDArtifact"]},"ElectronicSignatureCommentJoin":{"I":["IDElectronicSignatureCommentJoin","GUIDElectronicSignatureCommentJoin"],"D":["IDElectronicSignature","IDComment"],"N":["IDElectronicSignature","IDComment"]},"EmailRule":{"I":["IDEmailRule","GUIDEmailRule"],"D":["IDClonedRule","Enabled","DocumentType","Projects","Status","Handler","Config"],"N":["IDClonedRule"]},"EmailRuleSchedule":{"I":["IDEmailRuleSchedule","GUIDEmailRuleSchedule"],"D":["IDEmailRule","DayOfMonth","DayOfWeek","HourOfDay"],"N":["IDEmailRule","DayOfMonth","DayOfWeek","HourOfDay"]},"EntityEntitlement":{"I":["IDEntityEntitlement","GUIDEntityEntitlement"],"D":["NamespaceKey","NamespaceValue","LevelContext","LevelContextID","Address","ConfigValue"],"N":["LevelContextID"]},"EntityLog":{"I":["IDEntityLog","GUIDEntityLog"],"D":["EntityType","IDEntity","ChangesSnapshot","ChangeSource"],"N":["IDEntity"]},"Equipment":{"I":["IDEquipment","GUIDEquipment"],"D":["Deleted","Name","Description","Notes","SpecificationYear","Code","Status","ExternalEquipmentID"],"N":["SpecificationYear"]},"EquipmentOrganizationJoin":{"I":["IDEquipmentOrganizationJoin","GUIDEquipmentOrganizationJoin"],"D":["Deleted","IDEquipment","IDOrganization","Active"],"N":["IDEquipment","IDOrganization"]},"ExclusionAxiom":{"I":["IDExclusionAxiom","GUIDExclusionAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"ExclusionAxiomAxiomEntitySetJoin":{"I":["IDExclusionAxiomAxiomEntitySetJoin","GUIDExclusionAxiomAxiomEntitySetJoin"],"D":["Deleted","IDExclusionAxiom","IDAxiomEntitySet"],"N":["IDExclusionAxiom","IDAxiomEntitySet"]},"FIPSCounty":{"I":["IDFIPSCounty","GUIDFIPSCounty"],"D":["Deleted","Code","Name","IDFIPSState"],"N":["IDFIPSState"]},"FIPSState":{"I":["IDFIPSState","GUIDFIPSState"],"D":["Deleted","Code","PostalAbbreviation","Name"],"N":[]},"Flight":{"I":["IDFlight","GUIDFlight"],"D":["Deleted","Title","Type","MetadataJSON","Processed","Confidence","UserVerification"],"N":["Confidence"]},"FlightLog":{"I":["IDFlightLog","GUIDFlightLog"],"D":["Deleted","Hash","LogEntryTime","Status","Text","IDFlight","IDObservation"],"N":["IDFlight","IDObservation"]},"FlightObservationJoin":{"I":["IDFlightObservationJoin","GUIDFlightObservationJoin"],"D":["Deleted","IDFlight","IDObservation"],"N":["IDFlight","IDObservation"]},"FlightProcessingParameter":{"I":["IDFlightProcessingParameter","GUIDFlightProcessingParameter"],"D":["Deleted","IDFlight","ParametersJSON"],"N":["IDFlight"]},"Fund":{"I":["IDFund","GUIDFund"],"D":["Deleted","Name","Hash","Description","OriginalBalance","TotalCommitted","CommittedBalance","Balance","TotalPendingCharge","ExternalAccountID","CostCenter","Active"],"N":["OriginalBalance","TotalCommitted","CommittedBalance","Balance","TotalPendingCharge"]},"FundDocumentJoin":{"I":["IDFundDocumentJoin","GUIDFundDocumentJoin"],"D":["Deleted","IDFund","Amount","PurchaseOrderNumber","IDDocument"],"N":["IDFund","Amount","IDDocument"]},"FundProjectJoin":{"I":["IDFundProjectJoin","GUIDFundProjectJoin"],"D":["Deleted","IDFund","IDProject"],"N":["IDFund","IDProject"]},"FundingCategory":{"I":["IDFundingCategory","GUIDFundingCategory"],"D":["Deleted","Name","Code","Type","Description"],"N":[]},"FundingCategoryProjectJoin":{"I":["IDFundingCategoryProjectJoin","GUIDFundingCategoryProjectJoin"],"D":["Deleted","IDFundingCategory","IDProject"],"N":["IDFundingCategory","IDProject"]},"FundingSource":{"I":["IDFundingSource","GUIDFundingSource"],"D":["Deleted","Name","Hash","Description","Balance","FundingSourceAccountCode","Type"],"N":["Balance"]},"FundingSourceFundJoin":{"I":["IDFundingSourceFundJoin","GUIDFundingSourceFundJoin"],"D":["Deleted","IDFundingSource","IDFund","Sequence","Weight","DepleteBeforeContinue","PurchaseOrderNumber"],"N":["IDFundingSource","IDFund","Weight"]},"FundingSourceFundingCategoryJoin":{"I":["IDFundingSourceFundingCategoryJoin","GUIDFundingSourceFundingCategoryJoin"],"D":["Deleted","IDFundingSource","IDFundingCategory"],"N":["IDFundingSource","IDFundingCategory"]},"FundingSourceProjectJoin":{"I":["IDFundingSourceProjectJoin","GUIDFundingSourceProjectJoin"],"D":["Deleted","IDFundingSource","IDProject","Ordinal","Sequence","Weight","Code","CategoryNumber","IDFundingCategory","ExternalAccountID","PurchaseOrderNumber","FundCap","ProjectFundCap","PendingAmountCharged","ApprovedAmountCharged"],"N":["IDFundingSource","IDProject","Ordinal","Weight","IDFundingCategory","FundCap","ProjectFundCap","PendingAmountCharged","ApprovedAmountCharged"]},"InclusionAxiom":{"I":["IDInclusionAxiom","GUIDInclusionAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"InclusionAxiomAxiomEntitySetJoin":{"I":["IDInclusionAxiomAxiomEntitySetJoin","GUIDInclusionAxiomAxiomEntitySetJoin"],"D":["Deleted","IDInclusionAxiom","IDAxiomEntitySet"],"N":["IDInclusionAxiom","IDAxiomEntitySet"]},"Inspection":{"I":["IDInspection","GUIDInspection"],"D":["Deleted","IDInspectionStatus","StatusDisplay","IDInspectionType","TypeDisplay","StartDate","EndDate","DeadlineDate","ScheduledStartDate","Name","Description","IDProject"],"N":["IDInspectionStatus","IDInspectionType","IDProject"]},"InspectionDocumentJoin":{"I":["IDInspectionDocumentJoin","GUIDInspectionDocumentJoin"],"D":["Deleted","IDInspection","IDDocument","IncludeOnDossier","Ordinal"],"N":["IDInspection","IDDocument","Ordinal"]},"InspectionEventLog":{"I":["IDInspectionEventLog","GUIDInspectionEventLog"],"D":["Deleted","IDInspection","Event","IDUser","Datum"],"N":["IDInspection","IDUser"]},"InspectionPhysicalAssetJoin":{"I":["IDInspectionPhysicalAssetJoin","GUIDInspectionPhysicalAssetJoin"],"D":["Deleted","IDInspection","IDPhysicalAsset"],"N":["IDInspection","IDPhysicalAsset"]},"InspectionStatus":{"I":["IDInspectionStatus","GUIDInspectionStatus"],"D":["Deleted","Code","Description","Ordinal"],"N":["Ordinal"]},"InspectionType":{"I":["IDInspectionType","GUIDInspectionType"],"D":["Deleted","Name","Description"],"N":[]},"InspectionTypeReportNamedInstanceJoin":{"I":["IDInspectionTypeReportNamedInstanceJoin","GUIDInspectionTypeReportNamedInstanceJoin"],"D":["Deleted","IDInspectionType","IDReportNamedInstance","Required","Ordinal"],"N":["IDInspectionType","IDReportNamedInstance","Ordinal"]},"InspectionUserJoin":{"I":["IDInspectionUserJoin","GUIDInspectionUserJoin"],"D":["Deleted","IDInspection","IDUser"],"N":["IDInspection","IDUser"]},"IntegrationAdapter":{"I":["IDIntegrationAdapter","GUIDIntegrationAdapter"],"D":["Deleted","CompletionTime","Name","Status","RecordCount","Progress","Datum"],"N":["RecordCount","Progress"]},"IntegrationAdapterEvent":{"I":["IDIntegrationAdapterEvent","GUIDIntegrationAdapterEvent"],"D":["IDIntegrationAdapter","Deleted","CompletionTime","Name","Status","RecordCount","Progress","Datum"],"N":["IDIntegrationAdapter","RecordCount","Progress"]},"InternalMessaging":{"I":["IDMessage","GUIDMessage"],"D":["Deleted","Subject","MessageText","FromID","ToID","HasRead","MetaDataJSON"],"N":["FromID","ToID"]},"Job":{"I":["IDJob","GUIDJob"],"D":["Deleted","AssignedTime","AssignedWorkerID","CompletionTime","Type","ParametersJSON","OutputJSON","OutputMetadataJSON","Logs","Status","ParentIDJob"],"N":["ParentIDJob"]},"JobDependency":{"I":["IDJobDependency","GUIDJobDependency"],"D":["AssignedTime","FromIDJob","FromJobType","ToIDJob","ToJobType"],"N":["FromIDJob","ToIDJob"]},"JobPolyJoin":{"I":["IDJobPolyJoin","GUIDJobPolyJoin"],"D":["Deleted","EntityType","IDEntity","IDJob"],"N":["IDEntity","IDJob"]},"JobType":{"I":["IDJobType","GUIDJobType"],"D":["Deleted","Hash","Name","Description","IDStage"],"N":["IDStage"]},"Lab":{"I":["IDLab","GUIDLab"],"D":["Deleted","Name","IDOrganization","IDOrganizationAddress","ExternalOrganization","Notes","IDLabParent","ExternalLabID","BypassReceived","AggregateTo"],"N":["IDOrganization","IDOrganizationAddress","IDLabParent","BypassReceived"]},"LabMaterialAssignment":{"I":["IDLabMaterialAssignment","GUIDLabMaterialAssignment"],"D":["Deleted","IDLab","IDLabParent","IDMaterial","SampleType","ProductGroup"],"N":["IDLab","IDLabParent","IDMaterial"]},"LabTeamJoin":{"I":["IDLabTeamJoin","GUIDLabTeamJoin"],"D":["Deleted","IDLab","IDTeam","IDRole","SupportKind"],"N":["IDLab","IDTeam","IDRole"]},"LabTestApproval":{"I":["IDLabTestApproval","GUIDLabTestApproval"],"D":["Deleted","IDLab","IDTest","DateStart","DateEnd","Notes"],"N":["IDLab","IDTest"]},"LabTestDefault":{"I":["IDLabTestDefault","GUIDLabTestDefault"],"D":["Deleted","IDLab","IDMaterial","IDTest","SampleType","StartStatus","RequiredAssign","Autofinalize","DefinedTest","TestRuns"],"N":["IDLab","IDMaterial","IDTest","StartStatus","TestRuns"]},"LabTestSpecificationSetJoin":{"I":["IDLabTestSpecificationSetJoin","GUIDLabTestSpecificationSetJoin"],"D":["Deleted","IDLab","IDTestSpecificationSet"],"N":["IDLab","IDTestSpecificationSet"]},"LabUserJoin":{"I":["IDLabUserJoin","GUIDLabUserJoin"],"D":["IDLab","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"],"N":["IDLab","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"]},"LabUserMaterialJoin":{"I":["IDLabUserMaterialJoin","GUIDLabUserMaterialJoin"],"D":["IDLab","IDUser","IDMaterial","IDRole","FirstContact"],"N":["IDLab","IDUser","IDMaterial","IDRole"]},"LatestSampleByLog":{"I":["GUIDSample","GUIDSampleLog"],"D":["IDSample","Deleted","SampleCreateDate","SampleCreatingIDUser","SampleUpdateDate","SampleUpdatingIDUser","SampleDeleted","SampleDeleteDate","SampleDeletingIDUser","SampleExternalSyncDate","DesignatedTime","QRCode","SampleCaptureLatitude","SampleCaptureLongitude","Name","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","Notes","Status","LabControlNumber","LabReferenceNumber","ProductName","MaterialType","IDOrganization","IDMixDesign","ManufacturerCode","IntendedUse","BuyUSA","ReceivedFrom","GeographicalArea","Station","Offset","RepresentedQuantity","SampledQuantity","SampledQuantityUnits","RepresentedQuantityUnits","Units","RequestedBy","SampleExternalSyncGUID","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser","Datum","IDSampleLog","SampleLogCreateDate","SampleLogCreatingIDUser","SampleLogUpdateDate","SampleLogUpdatingIDUser","SampleLogDeleted","SampleLogDeleteDate","SampleLogExternalSyncDate","SampleLogCaptureLatitude","SampleLogCaptureLongitude","CaptureDate","FromStatus","ToStatus","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Ordinal","Received","IDLab","SampleLogNotes","SampleLogExternalSyncGUID"],"N":["IDSample","SampleCreatingIDUser","SampleUpdatingIDUser","SampleDeletingIDUser","SampleCaptureLatitude","SampleCaptureLongitude","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","IDOrganization","IDMixDesign","RepresentedQuantity","SampledQuantity","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser","IDSampleLog","SampleLogCreatingIDUser","SampleLogUpdatingIDUser","SampleLogCaptureLatitude","SampleLogCaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Ordinal","IDLab"]},"Layer":{"I":["IDLayer","GUIDLayer"],"D":["Deleted","Name","Type","BoundingUnits","BoundingLeft","BoundingRight","BoundingTop","BoundingBottom","IDLayerSet"],"N":["BoundingLeft","BoundingRight","BoundingTop","BoundingBottom","IDLayerSet"]},"LayerSet":{"I":["IDLayerSet","GUIDLayerSet"],"D":["Deleted","Title"],"N":[]},"LineItem":{"I":["IDLineItem","GUIDLineItem"],"D":["Name","Description","Notes","Units","SpecificationYear","ItemCode","ItemNumber","CostPerUnit","ExpectedQuantity","ContractorReportedQuantity","ActualQuantity","ContractQuantity","InstalledQuantity","ChangeOrderQuantity","ChangeOrderQuantityPending","Tax","ChangeOrderNumber","FundingCategory","IDFundingCategory","Status","ProposalIdentifier","PercentComplete","CategoryNumber","Retainage","ImprovementType","DeliveryDate","Deleted","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject","FHWAEligible"],"N":["SpecificationYear","CostPerUnit","ExpectedQuantity","ContractorReportedQuantity","ActualQuantity","ContractQuantity","InstalledQuantity","ChangeOrderQuantity","ChangeOrderQuantityPending","Tax","IDFundingCategory","PercentComplete","Retainage","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject"]},"LineItemChangeOrder":{"I":["IDLineItemChangeOrder","GUIDLineItemChangeOrder"],"D":["Deleted","ChangeNumber","Name","Description","Notes","Units","Amount","CommitmentNumber","ItemNumber","Quantity","CostPerUnit","ChangeQuantity","AdditionalDays","CommitmentChangeStatus","ReasonCode","DateOfChange","ApprovedByDate","CommitmentChangeAmount","Tax","FormIDDocument","IDLineItem","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject","IDChangeOrder","IDFundingCategory","CategoryNumber"],"N":["Amount","CostPerUnit","ChangeQuantity","AdditionalDays","CommitmentChangeAmount","Tax","FormIDDocument","IDLineItem","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject","IDChangeOrder","IDFundingCategory"]},"LineItemExternalSystemMapping":{"I":["IDLineItemExternalSystemMapping","GUIDLineItemExternalSystemMapping"],"D":["Deleted","IDLineItem","ExternalSystemHash","ExternalSystemGUID","ExternalSyncDirection","IDProject"],"N":["IDLineItem","IDProject"]},"LineItemLotJoin":{"I":["IDLineItemLotJoin","GUIDLineItemLotJoin"],"D":["IDLot","IDLineItem"],"N":["IDLot","IDLineItem"]},"LineItemOrganizationJoin":{"I":["IDLineItemOrganizationJoin","GUIDLineItemOrganizationJoin"],"D":["DisadvantagedBusiness","IDLineItem","IDOrganization"],"N":["IDLineItem","IDOrganization"]},"ListDefault":{"I":["IDListDefault","GUIDListDefault"],"D":["Deleted","NamespaceKey","NamespaceValue","IDProject","Hash","Value","IDListDefaultType"],"N":["IDProject","IDListDefaultType"]},"ListDefaultListDefaultJoin":{"I":["IDListDefaultListDefaultJoin","GUIDListDefaultListDefaultJoin"],"D":["Deleted","ScopeIDListDefault","IDListDefault"],"N":["ScopeIDListDefault","IDListDefault"]},"ListDefaultType":{"I":["IDListDefaultType","GUIDListDefaultType"],"D":["Deleted","Name","Description","NamespaceKey","NamespaceValue"],"N":[]},"Location":{"I":["IDLocation","GUIDLocation"],"D":["Deleted","Type","Name","Description","QRCode","Address","ExternalLocationID","ParentIDLocation","City","State","Zip","Phone","Latitude","Longitude"],"N":["ParentIDLocation","Latitude","Longitude"]},"Lot":{"I":["IDLot","GUIDLot"],"D":["Deleted","StartDate","FormData","IDMixDesign","IDContract","ValidationSequence","LPSyncDate","HLSyncDate","Name"],"N":["IDMixDesign","IDContract","ValidationSequence"]},"ManifestSchema":{"I":["IDManifestSchema","GUIDManifestSchema"],"D":["Deleted","Hash","Type","SubType","Title","Version","Description","Manifest","IDArtifact"],"N":["Version","IDArtifact"]},"ManifestSchemaManifestSchemaPartialJoin":{"I":["IDManifestSchemaManifestSchemaPartialJoin","GUIDManifestSchemaManifestSchemaPartialJoin"],"D":["IDManifestSchema","IDManifestSchemaPartial","Ordinal"],"N":["IDManifestSchema","IDManifestSchemaPartial","Ordinal"]},"ManifestSchemaPartial":{"I":["IDManifestSchemaPartial","GUIDManifestSchemaPartial"],"D":["Deleted","Hash","Type","Title","Ordinal","Version","Description","ManifestPartial"],"N":["Ordinal","Version"]},"ManifestSet":{"I":["IDManifestSet","GUIDManifestSet"],"D":["Deleted","Hash","Type","SubType"],"N":[]},"ManifestSetManifestSchemaJoin":{"I":["IDManifestSetManifestSchemaJoin","GUIDManifestSetManifestSchemaJoin"],"D":["IDManifestSet","IDManifestSchema","Ordinal"],"N":["IDManifestSet","IDManifestSchema","Ordinal"]},"ManifestSetManifestSetJoin":{"I":["IDManifestSetManifestSetJoin","GUIDManifestSetManifestSetJoin"],"D":["IDManifestSet","IncludedIDManifestSet","Ordinal"],"N":["IDManifestSet","IncludedIDManifestSet","Ordinal"]},"Material":{"I":["IDMaterial","GUIDMaterial"],"D":["Deleted","Name","NameAbbreviated","Type","Description","CatalogCode","UnitsMetric","UnitsImperial","Active","BrandNameRequired","MaterialCode","IDMaterialParent","Category","CategoryName","ItemSection","ItemCode"],"N":["IDMaterialParent","Category"]},"MaterialLineItemJoin":{"I":["IDMaterialLineItemJoin","GUIDMaterialLineItemJoin"],"D":["Deleted","IDLineItem","IDMaterial","ConversionFactor","ApprovedSourceRequired","SpecialInstructions","Units","SampleRate","RequiredSampleCount","SampleFrequency","Quantity"],"N":["IDLineItem","IDMaterial","ConversionFactor","SampleRate","RequiredSampleCount","SampleFrequency","Quantity"]},"MaterialManifestSetJoin":{"I":["IDMaterialManifestSetJoin","GUIDMaterialManifestSetJoin"],"D":["IDMaterial","IDManifestSet","Ordinal"],"N":["IDMaterial","IDManifestSet","Ordinal"]},"MaterialPayItemJoin":{"I":["IDMaterialPayItemJoin","GUIDMaterialPayItemJoin"],"D":["Deleted","Approved","DefaultConversionFactor","DefaultRate","DefaultFrequency","SpecialInstructions","IDPayItem","IDMaterial"],"N":["DefaultConversionFactor","DefaultRate","DefaultFrequency","IDPayItem","IDMaterial"]},"MaterialRecordOfMaterialEntryJoin":{"I":["IDMaterialRecordOfMaterialEntryJoin","GUIDMaterialRecordOfMaterialEntryJoin"],"D":["Deleted","IDMaterial","IDRecordOfMaterialEntry"],"N":["IDMaterial","IDRecordOfMaterialEntry"]},"MaterializedProjection":{"I":["IDMaterializedProjection","GUIDMaterializedProjection"],"D":["Deleted","ProjectionName","PhysicalTableName","ProjectionClass","MeadowSchemaJSON","SourceType","SourceDescriptor","SourceConfigJSON","Description","SourceAddress","TargetAddress","OperationType","OperationDefHash","CompiledOperationHash","RefreshEnabled","RefreshCron","RefreshIntervalMinutes","RefreshGroup","RefreshOrdinal","LastRefreshDate","LastRefreshStatus","UserCustomized"],"N":["RefreshIntervalMinutes","RefreshOrdinal"]},"MaterializedProjectionArchive":{"I":["IDMaterializedProjectionArchive","GUIDMaterializedProjectionArchive"],"D":["Deleted","IDMaterializedProjection","IDMaterializedProjectionVersion","ArchiveSequence","SourceTableName","ArchiveTableName","SchemaHash","Status","Reason","RetentionDate","RestoredDate","PrunedDate"],"N":["IDMaterializedProjection","IDMaterializedProjectionVersion","ArchiveSequence"]},"MaterializedProjectionIngestRun":{"I":["IDMaterializedProjectionIngestRun","GUIDMaterializedProjectionIngestRun"],"D":["Deleted","IDMaterializedProjection","BeaconWorkItemGUID","StartDate","EndDate","Status","SourceType","SourceDescriptor","RowsRead","RowsWritten","RowsSkipped","RowsErrored","ErrorSummaryJSON","StatsJSON","IDMaterializedProjectionPipelineRun","StageSequence","RunHash","OperationDefHash"],"N":["IDMaterializedProjection","RowsRead","RowsWritten","RowsSkipped","RowsErrored","IDMaterializedProjectionPipelineRun","StageSequence"]},"MaterializedProjectionPipelineRun":{"I":["IDMaterializedProjectionPipelineRun","GUIDMaterializedProjectionPipelineRun"],"D":["Deleted","PipelineName","GrossStatus","StageCount","StagesSucceeded","StagesFailed","CurrentStageSequence","StopOnFailure","StartDate","EndDate","PlanJSON","FailedStage","BeaconAction","ErrorCode","Reason","StatsJSON"],"N":["StageCount","StagesSucceeded","StagesFailed","CurrentStageSequence","ErrorCode"]},"MaterializedProjectionVersion":{"I":["IDMaterializedProjectionVersion","GUIDMaterializedProjectionVersion"],"D":["Deleted","IDMaterializedProjection","VersionSequence","SchemaHash","MeadowSchemaJSON","ChangeNotes"],"N":["IDMaterializedProjection","VersionSequence"]},"MixDesign":{"I":["IDMixDesign","GUIDMixDesign"],"D":["Deleted","MixMetadata","IDMaterial","MaterialCode","IDOrganization","LPSyncDate","HLSyncDate","MixID","Name","Description","Formula","IDMixType"],"N":["IDMaterial","IDOrganization","IDMixType"]},"MixDesignApproval":{"I":["IDMixDesignApproval","GUIDMixDesignApproval"],"D":["Deleted","IDMixDesign","IDContract","IDProject","LPSyncDate","HLSyncDate"],"N":["IDMixDesign","IDContract","IDProject"]},"MixSpecification":{"I":["IDMixSpecification","GUIDMixSpecification"],"D":["Deleted","Name","Description","Code","MaterialType","EffectiveDate","ExpirationDate","ApprovalDate","ApprovingIDUser"],"N":["ApprovingIDUser"]},"MixSpecificationMaterialJoin":{"I":["IDMixSpecificationMaterialJoin","GUIDMixSpecificationMaterialJoin"],"D":["Deleted","IDMixSpecification","IDMaterial"],"N":["IDMixSpecification","IDMaterial"]},"MixSpecificationOrganizationMaterialJoin":{"I":["IDMixSpecificationOrganizationMaterialJoin","GUIDMixSpecificationOrganizationMaterialJoin"],"D":["Deleted","Approved","Comments","MaterialType","IDMixSpecification","IDMaterial","IDOrganization","StartDate","EndDate"],"N":["IDMixSpecification","IDMaterial","IDOrganization"]},"MixType":{"I":["IDMixType","GUIDMixType"],"D":["Deleted","Name","Code","Description","Active","ApprovingAgency","MetaDataJSON","IDMaterial"],"N":["IDMaterial"]},"Module":{"I":["IDModule","GUIDModule"],"D":["Deleted","Name","Ordinal","Management","ModuleHash","ModuleType","ConfigurationJSON"],"N":["Ordinal"]},"ModuleConfigurationProjectJoin":{"I":["IDModuleConfigurationProjectJoin","GUIDModuleConfigurationProjectJoin"],"D":["Deleted","IDProject","ModuleHash","ConfigurationJSON"],"N":["IDProject"]},"Notification":{"I":["IDNotification","GUIDNotification"],"D":["IDNotificationRule","RecipientIDUser","NotificationMessage","Unread","NotificationType"],"N":["IDNotificationRule","RecipientIDUser"]},"NotificationDeliveryRule":{"I":["IDNotificationDeliveryRule","GUIDNotificationDeliveryRule"],"D":["Deleted","NotificationRule","DeliveryMethod","Address"],"N":["NotificationRule"]},"NotificationRule":{"I":["IDNotificationRule","GUIDNotificationRule"],"D":["RecipientIDUser","Entity","Filter"],"N":["RecipientIDUser"]},"Observation":{"I":["IDObservation","GUIDObservation"],"D":["Deleted","Name","Description","DesignatedTime","IDDevice","ObservationType","Status","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","IDProject","Priority","Version","SpritePage","AppHash","StateName","StateStep","Locked","Transcoded","ExternalSyncGUID"],"N":["IDDevice","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","IDProject","Version","SpritePage","StateStep"]},"ObservationApprovalLog":{"I":["IDObservationApprovalLog","GUIDObservationApprovalLog"],"D":["Deleted","IDObservation","IDElectronicSignature","Status","Action","StateStep","AfterStatus","IsApproval"],"N":["IDObservation","IDElectronicSignature","StateStep"]},"ObservationApprovalState":{"I":["IDObservationApprovalState","GUIDObservationApprovalState"],"D":["Deleted","Hash","Name"],"N":[]},"ObservationApprovalStep":{"I":["IDObservationApprovalStep","GUIDObservationApprovalStep"],"D":["Deleted","IDObservationApprovalState","Ordinal","ObservationType","IDProject","IDRole","IncludeHigherRoles","PerformLock"],"N":["IDObservationApprovalState","Ordinal","IDProject","IDRole"]},"ObservationApprovalWorkflow":{"I":["IDObservationApprovalWorkflow"],"D":["FromStatus","EdgeOptions","ToStatus","Name","IDProject"],"N":["IDProject"]},"ObservationArchive":{"I":["IDObservationArchive","GUIDObservationArchive","GUIDObservation"],"D":["IDObservation","Deleted","Name","Description","DesignatedTime","IDDevice","ObservationType","Status","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","IDProject","Priority","Version","SpritePage","SnapshotJSON","AppHash","StateName","StateStep","Locked","Transcoded","ExternalSyncGUID"],"N":["IDObservation","IDDevice","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","IDProject","Version","SpritePage","StateStep"]},"ObservationArtifactJoin":{"I":["IDObservationArtifactJoin","GUIDObservationArtifactJoin"],"D":["Deleted","IDObservation","IDArtifact","IDObservationRequirementSpecification"],"N":["IDObservation","IDArtifact","IDObservationRequirementSpecification"]},"ObservationCommentJoin":{"I":["IDObservationCommentJoin","GUIDObservationCommentJoin"],"D":["IDObservation","IDComment"],"N":["IDObservation","IDComment"]},"ObservationDataSetJoin":{"I":["IDObservationDataSetJoin","GUIDObservationDataSetJoin"],"D":["Deleted","IDObservation","IDDataSet"],"N":["IDObservation","IDDataSet"]},"ObservationDocumentStatistics":{"I":["IDObservationDocumentStatistics","GUIDObservationDocumentStatistics"],"D":["IDObservation","DocumentCount","ApprovedDocumentCount","RejectedDocumentCount"],"N":["IDObservation","DocumentCount","ApprovedDocumentCount","RejectedDocumentCount"]},"ObservationElectronicSignatureJoin":{"I":["IDObservationElectronicSignatureJoin","GUIDObservationElectronicSignatureJoin"],"D":["IDObservation","IDElectronicSignature"],"N":["IDObservation","IDElectronicSignature"]},"ObservationExtraMetadata":{"I":["IDObservationExtraMetadata","GUIDObservationExtraMetadata"],"D":["Deleted","IDObservation","Hash","Value","Datum"],"N":["IDObservation"]},"ObservationExtraMetadataAggregation":{"I":["IDObservationExtraMetadataAggregation","GUIDObservationExtraMetadataAggregation"],"D":["Deleted","IDObservation","Metadata"],"N":["IDObservation"]},"ObservationExtraMetadataHashDescription":{"I":["IDObservationExtraMetadataHashDescription","GUIDObservationExtraMetadataHashDescription"],"D":["Deleted","Hash","Title","Description","Metadata"],"N":[]},"ObservationLayerJoin":{"I":["IDObservationLayerJoin","GUIDObservationLayerJoin"],"D":["Deleted","IDObservation","IDLayer"],"N":["IDObservation","IDLayer"]},"ObservationManifest":{"I":["IDObservationManifest","GUIDObservationManifest"],"D":["Deleted","Name","DisplayName","SettingsJSON","Category"],"N":[]},"ObservationOrganizationJoin":{"I":["IDObservationOrganizationJoin","GUIDObservationOrganizationJoin"],"D":["IDObservation","IDOrganization"],"N":["IDObservation","IDOrganization"]},"ObservationRequirementSpecification":{"I":["IDObservationRequirementSpecification","GUIDObservationRequirementSpecification"],"D":["Deleted","IDArtifactType","IDObservationManifest","Name","CountMinimum","CountMaximum","Required","DefaultJSON"],"N":["IDArtifactType","IDObservationManifest","CountMinimum","CountMaximum"]},"ObservationSet":{"I":["IDObservationSet","GUIDObservationSet"],"D":["Deleted","Name","Description","DesignatedTime","IDProject"],"N":["IDProject"]},"ObservationSetObservationJoin":{"I":["IDObservationSetObservationJoin","GUIDObservationSetObservationJoin"],"D":["Deleted","IDObservationSet","IDObservation"],"N":["IDObservationSet","IDObservation"]},"ObservationSyncUpdate":{"I":["IDObservationSyncUpdate"],"D":["IDObservation","OriginalUpdateDate","IDDevice"],"N":["IDObservation","IDDevice"]},"ObservationTag":{"I":["IDObservationTag","GUIDObservationTag"],"D":["Tag","TagType","Description","IDOrganization","IDBidItem","IDLineItem","Global"],"N":["IDOrganization","IDBidItem","IDLineItem"]},"ObservationTagJoin":{"I":["IDObservationTagJoin","GUIDObservationTagJoin"],"D":["IDObservation","Tag","TagType","IDObservationTag"],"N":["IDObservation","IDObservationTag"]},"ObservationTagProjectJoin":{"I":["IDObservationTagProjectJoin","GUIDObservationTagProjectJoin"],"D":["Tag","TagType","IDProject","IDObservationTag","IDOrganization"],"N":["IDProject","IDObservationTag","IDOrganization"]},"Organization":{"I":["IDOrganization","GUIDOrganization"],"D":["Deleted","Name","DisadvantagedBusiness","Approved","Address","ExternalOrganizationID","City","State","Zip","Phone","Email","Type","VendorCode","FederalTaxCode"],"N":[]},"OrganizationAddress":{"I":["IDOrganizationAddress","GUIDOrganizationAddress"],"D":["Deleted","IDOrganization","LocationName","LocationType","Address","City","State","Zip","Phone","Email","Latitude","Longitude"],"N":["IDOrganization","Latitude","Longitude"]},"OrganizationApprovedTransactions":{"I":["IDOrganizationApprovedTransactions","GUIDOrganizationApprovedTransactions"],"D":["IDOrganization","IDProject","Approved"],"N":["IDOrganization","IDProject"]},"OrganizationDisadvantagedBusinessTransactions":{"I":["IDOrganizationDisadvantagedBusinessTransactions","GUIDOrganizationDisadvantagedBusinessTransactions"],"D":["IDOrganization","DisadvantagedBusiness"],"N":["IDOrganization"]},"OrganizationMaterialJoin":{"I":["IDOrganizationMaterialJoin","GUIDOrganizationMaterialJoin"],"D":["Deleted","IDOrganization","IDMaterial","EffectiveDate","ExpirationDate","ApprovedStatusType","SourceType"],"N":["IDOrganization","IDMaterial"]},"OverrideAxiom":{"I":["IDOverrideAxiom","GUIDOverrideAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"OverrideAxiomAxiomEntitySetJoin":{"I":["IDOverrideAxiomAxiomEntitySetJoin","GUIDOverrideAxiomAxiomEntitySetJoin"],"D":["Deleted","IDOverrideAxiom","IDAxiomEntitySet"],"N":["IDOverrideAxiom","IDAxiomEntitySet"]},"PayItem":{"I":["IDPayItem","GUIDPayItem"],"D":["Deleted","Name","Description","FunctionalClass","Units","Amount","SpecificationYear","IDTestSpecificationSet","Section","ItemCode","ExtendedJSON","ExternalPayItemID","FHWAEligible"],"N":["Amount","IDTestSpecificationSet"]},"PayItemMaterialTestRequirement":{"I":["IDPayItemMaterialTestRequirement","GUIDPayItemMaterialTestRequirement"],"D":["Deleted","IDTestSpecificationSet","IDPayItem","IDMaterial","IDTest","SampleType","SampleFrequency","SampleUnit"],"N":["IDTestSpecificationSet","IDPayItem","IDMaterial","IDTest","SampleFrequency"]},"PayItemTestSpecificationSetJoin":{"I":["IDPayItemTestSpecificationSetJoin","GUIDPayItemTestSpecificationSetJoin"],"D":["Deleted","IDPayItem","IDTestSpecificationSet"],"N":["IDPayItem","IDTestSpecificationSet"]},"Payment":{"I":["IDPayment","GUIDPayment"],"D":["Deleted","Hash","Code","Name","Description","PaymentDate","EntityName","IDEntity","SourceIDAccount","DestinationIDAccount","QuantityApproved","FundingApproved","Approved"],"N":["IDEntity","SourceIDAccount","DestinationIDAccount"]},"PaymentEntry":{"I":["IDPaymentEntry","GUIDPaymentEntry"],"D":["Deleted","IDPayment","Name","Description","Quantity","Unit","PricePerUnit","PriceAdjustment","WithheldAmount","CalculatedAmount","IDPaymentTransaction","IDPaymentEntryType","EntityName","IDEntity","QuantityApproved","FundingApproved"],"N":["IDPayment","Quantity","PricePerUnit","PriceAdjustment","WithheldAmount","CalculatedAmount","IDPaymentTransaction","IDPaymentEntryType","IDEntity"]},"PaymentEntryFunding":{"I":["IDPaymentEntryFunding","GUIDPaymentEntryFunding"],"D":["Deleted","Name","Description","IDPaymentEntry","IDAccount","IDPaymentTransaction","Amount","MappingReasoning","UserComment"],"N":["IDPaymentEntry","IDAccount","IDPaymentTransaction","Amount"]},"PaymentEntryObservationJoin":{"I":["IDPaymentEntryObservationJoin","GUIDPaymentEntryObservationJoin"],"D":["Deleted","IDPaymentEntry","IDObservation"],"N":["IDPaymentEntry","IDObservation"]},"PaymentEntryType":{"I":["IDPaymentEntryType","GUIDPaymentEntryType"],"D":["Deleted","Name","Hash","Description"],"N":[]},"PaymentFundingSnapshot":{"I":["IDPaymentFundingSnapshot","GUIDPaymentFundingSnapshot"],"D":["Deleted","PartialPaymentIDDocument","ScenarioJSON"],"N":["PartialPaymentIDDocument"]},"PaymentFundingSnapshotHistory":{"I":["IDPaymentFundingSnapshotHistory","GUIDPaymentFundingSnapshotHistory","GUIDPaymentFundingSnapshot"],"D":["IDPaymentFundingSnapshot","Deleted","PartialPaymentIDDocument","ScenarioJSON"],"N":["IDPaymentFundingSnapshot","PartialPaymentIDDocument"]},"PaymentTransaction":{"I":["IDPaymentTransaction","GUIDPaymentTransaction"],"D":["Deleted","IDSourceAccount","IDDestinationAccount","IDPayment","TransactionAmount","Pending","TransactionTime","Voided","VoidTime"],"N":["IDSourceAccount","IDDestinationAccount","IDPayment","TransactionAmount"]},"PermDocumentUser":{"I":["IDPermDocumentUser","GUIDPermDocumentUser"],"D":["IDDocument","IDUser","ComputedDate"],"N":["IDDocument","IDUser"]},"PermUserRole":{"I":["IDPermUserRole","GUIDPermUserRole"],"D":["IDUser","IDRole","SourceRule","ComputedDate"],"N":["IDUser","IDRole"]},"PhysicalAsset":{"I":["IDPhysicalAsset","GUIDPhysicalAsset"],"D":["Deleted","Name","Description","OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDAssetClassification","IDAssetType","ParentIDPhysicalAsset","ManifestVersion","ExternalSyncGUID","AssetNumber","YearBuilt","IDFIPSState","IDFIPSCounty"],"N":["OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDAssetClassification","IDAssetType","ParentIDPhysicalAsset","ManifestVersion","IDFIPSState","IDFIPSCounty"]},"PhysicalAssetArtifactJoin":{"I":["IDPhysicalAssetArtifactJoin","GUIDPhysicalAssetArtifactJoin"],"D":["IDPhysicalAsset","IDArtifact"],"N":["IDPhysicalAsset","IDArtifact"]},"PhysicalAssetBridgeJoin":{"I":["IDPhysicalAssetBridgeJoin","GUIDPhysicalAssetBridgeJoin"],"D":["IDPhysicalAsset","IDBridge"],"N":["IDPhysicalAsset","IDBridge"]},"PhysicalAssetDataSnapshot":{"I":["IDPhysicalAssetDataSnapshot","GUIDPhysicalAssetDataSnapshot"],"D":["Deleted","IDPhysicalAsset","Type","SubType","EffectiveDate","PublicationDate","Source","SourceVersion","SnapshotJSON"],"N":["IDPhysicalAsset"]},"PhysicalAssetDataSummary":{"I":["IDPhysicalAssetDataSummary","GUIDPhysicalAssetDataSummary"],"D":["Deleted","IDPhysicalAsset","Type","SubType","EffectiveDate","Source","SummaryJSON","ManifestGUID"],"N":["IDPhysicalAsset"]},"PhysicalAssetDefect":{"I":["IDPhysicalAssetDefect","GUIDPhysicalAssetDefect"],"D":["Deleted","Code","Name","Description","Notes","PrimaryDocumentationURL","StateDescriptionsJSON"],"N":[]},"PhysicalAssetElement":{"I":["IDPhysicalAssetElement","GUIDPhysicalAssetElement"],"D":["Deleted","Name","Description","Quantity","Units","OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDPhysicalAsset","IDAssetType","IDPhysicalAssetMaterial","IDPhysicalAssetElementType","ManifestVersion","ExternalSyncGUID"],"N":["Quantity","OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDPhysicalAsset","IDAssetType","IDPhysicalAssetMaterial","IDPhysicalAssetElementType","ManifestVersion"]},"PhysicalAssetElementCondition":{"I":["IDPhysicalAssetElementCondition","GUIDPhysicalAssetElementCondition"],"D":["Deleted","IDPhysicalAssetElement","IDPhysicalAsset","EffectiveDate","PublicationDate","Year","Source","TotalQuantity","QuantitiesJSON"],"N":["IDPhysicalAssetElement","IDPhysicalAsset","TotalQuantity"]},"PhysicalAssetElementPhysicalAssetDefectJoin":{"I":["IDPhysicalAssetElementPhysicalAssetDefectJoin","GUIDPhysicalAssetElementPhysicalAssetDefectJoin"],"D":["IDPhysicalAssetElement","IDPhysicalAssetDefect"],"N":["IDPhysicalAssetElement","IDPhysicalAssetDefect"]},"PhysicalAssetElementType":{"I":["IDPhysicalAssetElementType","GUIDPhysicalAssetElementType"],"D":["Deleted","Code","Section","SectionCode","Name","Unit","Clarification","IDPhysicalAssetMaterial"],"N":["IDPhysicalAssetMaterial"]},"PhysicalAssetElementTypePhysicalAssetDefectJoin":{"I":["IDPhysicalAssetElementTypePhysicalAssetDefectJoin","GUIDPhysicalAssetElementTypePhysicalAssetDefectJoin"],"D":["Deleted","IDPhysicalAssetElementType","IDPhysicalAssetDefect"],"N":["IDPhysicalAssetElementType","IDPhysicalAssetDefect"]},"PhysicalAssetMaterial":{"I":["IDPhysicalAssetMaterial","GUIDPhysicalAssetMaterial"],"D":["Deleted","IDMaterial","Code","Material","Description"],"N":["IDMaterial"]},"PhysicalAssetMetadata":{"I":["IDPhysicalAssetMetadata","GUIDPhysicalAssetMetadata"],"D":["Deleted","IDPhysicalAsset","IDPhysicalAssetElement","MetadataSetGUID","DataDate","Source","Quantity","Units","Value","Address","MetadataValue"],"N":["IDPhysicalAsset","IDPhysicalAssetElement","Quantity"]},"PhysicalAssetPhysicalAssetDefectJoin":{"I":["IDPhysicalAssetPhysicalAssetDefectJoin","GUIDPhysicalAssetPhysicalAssetDefectJoin"],"D":["IDPhysicalAsset","IDPhysicalAssetDefect"],"N":["IDPhysicalAsset","IDPhysicalAssetDefect"]},"PhysicalAssetPolyJoin":{"I":["IDPhysicalAssetPolyJoin","GUIDPhysicalAssetPolyJoin"],"D":["IDPhysicalAsset","RemoteType","IDRemote"],"N":["IDPhysicalAsset","IDRemote"]},"PlantMixApproval":{"I":["IDPlantMixApproval","GUIDPlantMixApproval"],"D":["Deleted","IDMixDesign","IDOrganization","ApprovalDate","ExpirationDate","LPSyncDate","HLSyncDate"],"N":["IDMixDesign","IDOrganization"]},"Product":{"I":["IDProduct","GUIDProduct"],"D":["Deleted","Name","ManufacturerCode","AcceptanceMethod","ProductCategory","CatalogCode","EffectiveDate","ExpirationDate","Comments","MetadataJSON","IDMaterial","IDOrganization"],"N":["IDMaterial","IDOrganization"]},"ProductionPlant":{"I":["IDProductionPlant","GUIDProductionPlant"],"D":["Deleted","Name","IDOrganization","IDOrganizationAddress","Notes","ExternalProductionPlantID"],"N":["IDOrganization","IDOrganizationAddress"]},"ProductionPlantMaterialApproval":{"I":["IDProductionPlantMaterialApproval","GUIDProductionPlantMaterialApproval"],"D":["Deleted","IDMaterial","IDMixSpecification","IDProductionPlant","StartDate","EndDate","Notes"],"N":["IDMaterial","IDMixSpecification","IDProductionPlant"]},"Program":{"I":["IDProgram","GUIDProgram"],"D":["Deleted","Name","Description"],"N":[]},"Project":{"I":["IDProject","GUIDProject"],"D":["Deleted","ExternalSyncGUID","Name","Description","Latitude","Longitude","CustomProperties","IDProjectType","IDContract","Timezone","Status","ExternalProjectID","CostPerDay","OriginalContractedDays","ContractedDays","CompletedDays","PercentComplete","PercentCompleteByDays","IDOrganization","PurchaseOrderNumber","ImprovementTypeCode","InitialContractAmount","CurrentTotalContractAmount","CurrentTotalContractPaid","PaidDays"],"N":["Latitude","Longitude","IDProjectType","IDContract","CostPerDay","OriginalContractedDays","ContractedDays","CompletedDays","PercentComplete","PercentCompleteByDays","IDOrganization","InitialContractAmount","CurrentTotalContractAmount","CurrentTotalContractPaid","PaidDays"]},"ProjectContactJoin":{"I":["IDProjectContactJoin","GUIDProjectContactJoin"],"D":["IDProject","IDContact"],"N":["IDProject","IDContact"]},"ProjectDashboardJoin":{"I":["IDProjectDashboardJoin","GUIDProjectDashboardJoin"],"D":["IDProject","ConfigurationJSON"],"N":["IDProject"]},"ProjectDate":{"I":["IDProjectDate","GUIDProjectDate"],"D":["Deleted","Name","Hash","Date","IDProject"],"N":["IDProject"]},"ProjectEquipmentJoin":{"I":["IDProjectEquipmentJoin","GUIDProjectEquipmentJoin"],"D":["IDEquipment","IDOrganization","IDProject"],"N":["IDEquipment","IDOrganization","IDProject"]},"ProjectFile":{"I":["IDProjectFile","GUIDProjectFile"],"D":["Deleted","Name","Description","FileType","IDProject","IDProjectFileFolder","IDObservation","IDArtifact","ArtifactVersion"],"N":["IDProject","IDProjectFileFolder","IDObservation","IDArtifact","ArtifactVersion"]},"ProjectFileFolder":{"I":["IDProjectFileFolder","GUIDProjectFileFolder"],"D":["Deleted","Name","Description","IDProject","ParentIDProjectFileFolder"],"N":["IDProject","ParentIDProjectFileFolder"]},"ProjectLabJoin":{"I":["IDProjectLabJoin","GUIDProjectLabJoin"],"D":["IDProject","IDLab"],"N":["IDProject","IDLab"]},"ProjectLineItemMaterialTest":{"I":["IDProjectLineItemMaterialTest","GUIDProjectLineItemMaterialTest"],"D":["Deleted","IDTest","IDMaterial","IDLineItem","IDProject","Intent","ErrorOmission","ErrorOmissionDetail","TestDescription","SampleDescription","SamplingInstructions","SamplingRequirements","SampleSize","SampleUnits","Remarks","Rate","Frequency","Units","ManualUnits","ComputedRequiredSampleCount","ManualRequiredSampleCount","ComputedPlannedSampleCount","ManualPlannedSampleCount","CreatedSampleCount","PassingSampleCount","FailingSampleCount","ConversionFactor","IDLab","SampleType","SamplingPeriod","CertificateRequired","TestsNotRequired","ExternalSyncGUID"],"N":["IDTest","IDMaterial","IDLineItem","IDProject","ErrorOmission","SampleSize","Rate","Frequency","ComputedRequiredSampleCount","ManualRequiredSampleCount","ComputedPlannedSampleCount","ManualPlannedSampleCount","CreatedSampleCount","PassingSampleCount","FailingSampleCount","ConversionFactor","IDLab"]},"ProjectObservationManifestJoin":{"I":["IDProjectObservationManifestJoin","GUIDProjectObservationManifestJoin"],"D":["ObservationManifestName","Priority","Ordinal","Spreadsheet","Journal","IDProject"],"N":["Priority","Ordinal","IDProject"]},"ProjectObservationManifestModuleJoin":{"I":["IDProjectObservationManifestModuleJoin","GUIDProjectObservationManifestModuleJoin"],"D":["ModuleHash","IDProjectObservationManifestJoin","Enabled","Creatable"],"N":["IDProjectObservationManifestJoin"]},"ProjectOffice":{"I":["IDProjectOffice","GUIDProjectOffice"],"D":["Deleted","OfficeCode","Name","Address","City","State","Zip","Phone"],"N":[]},"ProjectOrganizationJoin":{"I":["IDProjectOrganizationJoin","GUIDProjectOrganizationJoin"],"D":["DisadvantagedBusiness","IDProject","IDOrganization"],"N":["IDProject","IDOrganization"]},"ProjectSelectList":{"I":["IDProjectSelectList"],"D":["Deleted","ListType","Value","IDProject"],"N":["IDProject"]},"ProjectTagType":{"I":["IDProjectTagType","GUIDProjectTagType"],"D":["TagType","Name","Ordinal","IDProject"],"N":["Ordinal","IDProject"]},"ProjectType":{"I":["IDProjectType","GUIDProjectType"],"D":["Name","Hash","Description","SettingsJSON","Ordinal","IDProgram"],"N":["Ordinal","IDProgram"]},"ProjectTypeDefaultDate":{"I":["IDProjectTypeDefaultDate","GUIDProjectTypeDefaultDate"],"D":["Deleted","Name","Hash","IDProjectType"],"N":["IDProjectType"]},"ProjectUserDeviceSync":{"I":["IDProjectUserDeviceSync","GUIDProjectUserDeviceSync"],"D":["IDProject","IDUser","IDDevice","ModuleHash","SyncBackToDate"],"N":["IDProject","IDUser","IDDevice"]},"ProjectUserJoin":{"I":["IDProjectUserJoin","GUIDProjectUserJoin"],"D":["IDProject","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"],"N":["IDProject","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"]},"RecordExtendedSchemaData":{"I":["IDRecordExtendedSchemaData","GUIDRecordExtendedSchemaData"],"D":["Deleted","EntityType","IDEntity","DataJSON"],"N":["IDEntity"]},"RecordOfMaterial":{"I":["IDRecordOfMaterial","GUIDRecordOfMaterial"],"D":["Deleted","IDProject","Notes"],"N":["IDProject"]},"RecordOfMaterialEntry":{"I":["IDRecordOfMaterialEntry","GUIDRecordOfMaterialEntry"],"D":["Deleted","IDProject","IDRecordOfMaterial","IDBidItem","IDLineItem","Notes"],"N":["IDProject","IDRecordOfMaterial","IDBidItem","IDLineItem"]},"RecordOfMaterialEntryArchive":{"I":["IDRecordOfMaterialEntryArchive","GUIDRecordOfMaterialEntryArchive"],"D":["Deleted","IDRecordOfMaterialEntry","RecordOfMaterialEntry"],"N":["IDRecordOfMaterialEntry"]},"ReportArchetype":{"I":["IDReportArchetype","GUIDReportArchetype"],"D":["Deleted","Archetype","OptionsJSON","Description"],"N":[]},"ReportNamedInstance":{"I":["IDReportNamedInstance","GUIDReportNamedInstance"],"D":["Deleted","Name","Hash","Ordinal","OptionsJSON","IDReportArchetype","DefaultReport"],"N":["Ordinal","IDReportArchetype"]},"ReportNamedInstanceManifestSchemaJoin":{"I":["IDReportNamedInstanceManifestSchemaJoin","GUIDReportNamedInstanceManifestSchemaJoin"],"D":["IDReportNamedInstance","IDManifestSchema","Ordinal"],"N":["IDReportNamedInstance","IDManifestSchema","Ordinal"]},"ReportNamedInstanceProjectJoin":{"I":["IDReportNamedInstanceProjectJoin","GUIDReportNamedInstanceProjectJoin"],"D":["IDReportNamedInstance","IDProject","Ordinal","IDProgram"],"N":["IDReportNamedInstance","IDProject","Ordinal","IDProgram"]},"Role":{"I":["IDRole","GUIDRole"],"D":["LinkedIDUser","Deleted","Name","PermissionLevel","Type","Description","LevelOrdinal"],"N":["LinkedIDUser","LevelOrdinal"]},"RoleContextMembership":{"I":["IDRoleContextMembership","GUIDRoleContextMembership"],"D":["IDRole","Context","IDContext"],"N":["IDRole","IDContext"]},"RoleEdge":{"I":["IDRoleEdge","GUIDRoleEdge"],"D":["Deleted","ParentIDRole","ChildIDRole"],"N":["ParentIDRole","ChildIDRole"]},"RoleExclusionAxiomJoin":{"I":["IDRoleExclusionAxiomJoin","GUIDRoleExclusionAxiomJoin"],"D":["Deleted","IDExclusionAxiom","IDRole"],"N":["IDExclusionAxiom","IDRole"]},"RoleInclusionAxiomJoin":{"I":["IDRolInclusioneAxiomJoin","GUIDRoleInclusionAxiomJoin"],"D":["Deleted","IDInclusionAxiom","IDRole"],"N":["IDInclusionAxiom","IDRole"]},"RoleModuleJoin":{"I":["IDRoleModuleJoin","GUIDRoleModuleJoin"],"D":["ModuleHash","IDRole"],"N":["IDRole"]},"RoleObservationManifestJoin":{"I":["IDRoleObservationManifestJoin","GUIDRoleObservationManifestJoin"],"D":["Deleted","IDRole","ObservationManifestName"],"N":["IDRole"]},"RoleOverrideAxiomJoin":{"I":["IDRolOverrideeAxiomJoin","GUIDRoleOverrideAxiomJoin"],"D":["Deleted","IDOverrideAxiom","IDRole"],"N":["IDOverrideAxiom","IDRole"]},"RolePermission":{"I":["IDRolePermission","GUIDRolePermission"],"D":["Hash","Allowed","IDRole","Context","IDContext"],"N":["IDRole","IDContext"]},"RoleReportNamedInstanceJoin":{"I":["IDRoleReportNamedInstanceJoin","GUIDRoleReportNamedInstanceJoin"],"D":["Deleted","IDRole","IDReportNamedInstance"],"N":["IDRole","IDReportNamedInstance"]},"RoleScopeAxiomJoin":{"I":["IDRoleScopeAxiomJoin","GUIDRoleScopeAxiomJoin"],"D":["Deleted","IDScopeAxiom","IDRole"],"N":["IDScopeAxiom","IDRole"]},"Sample":{"I":["IDSample","GUIDSample"],"D":["DesignatedTime","Deleted","QRCode","CaptureLatitude","CaptureLongitude","Name","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","Notes","Status","LabControlNumber","LabReferenceNumber","ProductName","MaterialType","IDOrganization","IDMixDesign","ManufacturerCode","IntendedUse","BuyUSA","ReceivedFrom","GeographicalArea","Station","Offset","RepresentedQuantity","SampledQuantity","SampledQuantityUnits","RepresentedQuantityUnits","Units","RequestedBy","ExternalSyncGUID","IDSampleType","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser","Datum","Locked","Sequenced"],"N":["CaptureLatitude","CaptureLongitude","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","IDOrganization","IDMixDesign","RepresentedQuantity","SampledQuantity","IDSampleType","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser"]},"SampleLabJoin":{"I":["IDSampleLabJoin","GUIDSampleLabJoin"],"D":["Deleted","IDLab","IDSample","Received"],"N":["IDLab","IDSample"]},"SampleLineItemJoin":{"I":["IDSampleLineItemJoin","GUIDSampleLineItemJoin"],"D":["Deleted","IDLineItem","IDSample","RepresentedQuantity"],"N":["IDLineItem","IDSample","RepresentedQuantity"]},"SampleLocationJoin":{"I":["IDSampleLocationJoin","GUIDSampleLocationJoin"],"D":["Deleted","IDSample","IDLocation"],"N":["IDSample","IDLocation"]},"SampleLog":{"I":["IDSampleLog","GUIDSampleLog"],"D":["Deleted","IDSample","CaptureDate","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Notes","Ordinal","Received","IDLab","ExternalSyncGUID","IDLocation","FromStatus","ToStatus"],"N":["IDSample","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Ordinal","IDLab","IDLocation"]},"SampleStatus":{"I":["IDSampleStatus","GUIDSampleStatus"],"D":["Deleted","Name","Hash","Description","Category","Ordinal","MetadataJSON"],"N":["Ordinal"]},"SampleType":{"I":["IDSampleType","GUIDSampleType"],"D":["Deleted","Name","Hash","Description","Category","MetadataJSON"],"N":[]},"ScopeAxiom":{"I":["IDScopeAxiom","GUIDScopeAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"ScopeAxiomAxiomEntitySetJoin":{"I":["IDScopeAxiomAxiomEntitySetJoin","GUIDScopeAxiomAxiomEntitySetJoin"],"D":["Deleted","IDScopeAxiom","IDAxiomEntitySet"],"N":["IDScopeAxiom","IDAxiomEntitySet"]},"SentEmail":{"I":["IDSentEmail"],"D":["Source","EventStreamOffset","IDEmailSource","Handler","Email","Parameters","IDMailgun"],"N":["EventStreamOffset","IDEmailSource"]},"Stage":{"I":["IDStage","GUIDStage"],"D":["Deleted","Hash","Name","Description"],"N":[]},"Stockpile":{"I":["IDStockpile","GUIDStockpile"],"D":["Deleted","Name","Hash","Description"],"N":[]},"StockpileProjectJoin":{"I":["IDStockpileProjectJoin","GUIDStockpileProjectJoin"],"D":["Deleted","IDStockpile","IDProject"],"N":["IDStockpile","IDProject"]},"SubLot":{"I":["IDSubLot","GUIDSubLot"],"D":["Deleted","SubLotMetadata","IDLot","IDCore","IDMixDesign","IDContract","LPSyncDate","HLSyncDate","Name"],"N":["IDLot","IDCore","IDMixDesign","IDContract"]},"SyncLog":{"I":["IDLog","GUIDLog"],"D":["Task","SyncDate"],"N":[]},"Team":{"I":["IDTeam","GUIDTeam"],"D":["Deleted","Name","Hash","Description","ParentIDTeam"],"N":["ParentIDTeam"]},"TeamUserJoin":{"I":["IDTeamUserJoin","GUIDTeamUserJoin"],"D":["Deleted","IDTeam","IDUser","IDRole"],"N":["IDTeam","IDUser","IDRole"]},"Test":{"I":["IDTest","GUIDTest"],"D":["Deleted","Name","Description","Hash","Notes","Active","Standalone","Injectable","Collection","SmallQuantityExempt"],"N":[]},"TestCollectionJoin":{"I":["IDTestCollectionJoin","GUIDTestCollectionJoin"],"D":["Deleted","IDTest","IncludedIDTest"],"N":["IDTest","IncludedIDTest"]},"TestData":{"I":["IDTestData","GUIDTestData"],"D":["Deleted","DisplayName","IDTest","Type","Required","Ordinal","TestLength","TestExpression"],"N":["IDTest","Ordinal"]},"TestInstance":{"I":["IDTestInstance","GUIDTestInstance"],"D":["Deleted","IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem","Name","Notes","StartDate","EstimatedCompletionDate","ActualCompletionDate","ExternalSyncGUID","Status","StatusMessage","SampleTestNumber","TestResult"],"N":["IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem"]},"TestInstanceData":{"I":["IDTestInstanceData","GUIDTestInstanceData"],"D":["Deleted","IDTestInstance","Value","Comments","Valid","ExternalSyncGUID","Ordinal"],"N":["IDTestInstance","Ordinal"]},"TestInstanceDataArchive":{"I":["IDTestInstanceDataArchive","GUIDTestInstanceDataArchive"],"D":["Deleted","IDTestInstanceData","TestInstanceData"],"N":["IDTestInstanceData"]},"TestInstanceDocumentJoin":{"I":["IDTestInstanceDocumentJoin","GUIDTestInstanceDocumentJoin"],"D":["Deleted","IDTestInstance","IDDocument"],"N":["IDTestInstance","IDDocument"]},"TestInstanceLabJoin":{"I":["IDTestInstanceLabJoin","GUIDTestInstanceLabJoin"],"D":["Deleted","IDTestInstance","IDLab"],"N":["IDTestInstance","IDLab"]},"TestInstanceSampleJoin":{"I":["IDTestInstanceSampleJoin","GUIDTestInstanceSampleJoin"],"D":["Deleted","IDTestInstance","IDSample"],"N":["IDTestInstance","IDSample"]},"TestLabJoin":{"I":["IDTestLabJoin","GUIDTestLabJoin"],"D":["Deleted","IDLab","IDLabParent","IDTest","DateEnd","QualificationType","QualificationMethod","QualificationAuthorization"],"N":["IDLab","IDLabParent","IDTest"]},"TestManifestSchemaJoin":{"I":["IDTestManifestSchemaJoin","GUIDTestManifestSchemaJoin"],"D":["Deleted","IDTest","IDManifestSchema"],"N":["IDTest","IDManifestSchema"]},"TestPlan":{"I":["IDTestPlan","GUIDTestPlan"],"D":["Deleted","IDProject","Description","DateStart","DateEnd"],"N":["IDProject"]},"TestRecordOfMaterialEntryJoin":{"I":["IDTestRecordOfMaterialEntryJoin","GUIDTestRecordOfMaterialEntryJoin"],"D":["Deleted","IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem","IDRecordOfMaterialEntry","TestCount","Name","Notes"],"N":["IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem","IDRecordOfMaterialEntry","TestCount"]},"TestSpecification":{"I":["IDTestSpecification","GUIDTestSpecification"],"D":["Deleted","Name","IDTestSpecificationSet","Description"],"N":["IDTestSpecificationSet"]},"TestSpecificationMaterialJoin":{"I":["IDTestSpecificationMaterialJoin","GUIDTestSpecificationMaterialJoin"],"D":["Deleted","IDMaterial","IDTestSpecification","MaterialCode","SpecialInstructions","Year"],"N":["IDMaterial","IDTestSpecification"]},"TestSpecificationMaterialTestJoin":{"I":["IDTestSpecificationMaterialTestJoin","GUIDTestSpecificationMaterialTestJoin"],"D":["Deleted","IDTestSpecification","IDMaterial","IDTest"],"N":["IDTestSpecification","IDMaterial","IDTest"]},"TestSpecificationRequirement":{"I":["IDTestSpecificationRequirement","GUIDTestSpecificationRequirement"],"D":["Deleted","IDTestSpecification","IDTest","Name","Ordinal","OperationType","ValueMinimum","ValueMaximum","ComputationTemplate","OutcomeType","OutcomeTargets","ComputationSuccessOutcome","ComputationFailureOutcome","PrecompiledSolver"],"N":["IDTestSpecification","IDTest"]},"TestSpecificationSet":{"I":["IDTestSpecificationSet","GUIDTestSpecificationSet"],"D":["Deleted","Name","Year"],"N":["Year"]},"TestSpecificationSetTestJoin":{"I":["IDTestSpecificationSetTestJoin","GUIDTestSpecificationSetTestJoin"],"D":["Deleted","IDTestSpecificationSet","IDTest"],"N":["IDTestSpecificationSet","IDTest"]},"TestStep":{"I":["IDTestStep","GUIDTestStep"],"D":["Deleted","Name","Notes","Computed","ComputationTemplate","Important"],"N":[]},"Tokens":{"I":["IDToken","GUIDToken"],"D":["ClientID","UserID","Type","Value","Expiration"],"N":[]},"UploadBatch":{"I":["IDUploadBatch","GUIDUploadBatch"],"D":["Deleted","Name","Status","Description","MetadataJSON"],"N":[]},"UploadFile":{"I":["IDUploadFile","GUIDUploadFile"],"D":["Name","FileType","Category","Bytes","Latitude","Longitude","UploadStartTime","UploadCompletionTime","Status","Priority","MetadataJSON","IDUploadBatch","IDDevice"],"N":["Bytes","Priority","IDUploadBatch","IDDevice"]},"UploadFileObservationJoin":{"I":["IDUploadFileObservationJoin","GUIDUploadFileObservationJoin"],"D":["IDUploadFile","IDObservation"],"N":["IDUploadFile","IDObservation"]},"UploadFileUploadBatchJoin":{"I":["IDUploadFileUploadBatchJoin","GUIDUploadFileUploadBatchJoin"],"D":["IDUploadFile","IDUploadBatch"],"N":["IDUploadFile","IDUploadBatch"]},"User":{"I":["IDUser","GUIDUser"],"D":["Deleted","ExternalSyncGUID","NameFirst","NameLast","Phone","Email","LoginID","LoginPassword","PasswordResetKey","IDRole","Title","Classification","IDProjectOffice","EmailPending","UIHash","Timezone","Shift","SettingsJSON","LastSessionID","LastLoginTime","Disabled","PersistentPassword"],"N":["IDRole","IDProjectOffice"]},"UserAction":{"I":["IDUserAction","GUIDUserAction"],"D":["Deleted","IDDevice","AppName","AppVersion","Action","ActionPayload"],"N":["IDDevice"]},"UserContextRole":{"I":["IDUserContextRole","GUIDUserContextRole"],"D":["IDUser","Context","IDContext","IDRole","ExpirationDate","ExpirationIDRole","SynthesizedIDRole"],"N":["IDUser","IDContext","IDRole","ExpirationIDRole","SynthesizedIDRole"]},"UserEntityAction":{"I":["IDUserEntityAction","GUIDUserEntityAction"],"D":["IDUser","EntityType","IDEntity","Action"],"N":["IDUser","IDEntity"]},"UserExclusionAxiomJoin":{"I":["IDUserExclusionAxiomJoin","GUIDUserExclusionAxiomJoin"],"D":["Deleted","IDExclusionAxiom","IDUser"],"N":["IDExclusionAxiom","IDUser"]},"UserInclusionAxiomJoin":{"I":["IDRolInclusioneAxiomJoin","GUIDUserInclusionAxiomJoin"],"D":["Deleted","IDInclusionAxiom","IDUser"],"N":["IDInclusionAxiom","IDUser"]},"UserOverrideAxiomJoin":{"I":["IDRolOverrideeAxiomJoin","GUIDUserOverrideAxiomJoin"],"D":["Deleted","IDOverrideAxiom","IDUser"],"N":["IDOverrideAxiom","IDUser"]},"UserPermission":{"I":["IDUserPermission","GUIDUserPermission"],"D":["Hash","Allowed","IDUser","Context","IDContext"],"N":["IDUser","IDContext"]},"UserRoleJoin":{"I":["IDUserRoleJoin","GUIDUserRoleJoin"],"D":["IDRole","IDUser","ProxyIDRole"],"N":["IDRole","IDUser","ProxyIDRole"]},"UserScopeAxiomJoin":{"I":["IDUserScopeAxiomJoin","GUIDUserScopeAxiomJoin"],"D":["Deleted","IDScopeAxiom","IDUser"],"N":["IDScopeAxiom","IDUser"]},"UserSessionHistory":{"I":["IDUserSessionHistory","GUIDUserSessionHistory"],"D":["Deleted","SessionID","IDUser","ImpersonatedIDUser","ImpersonationDate","ImpersonationChained","OriginatingSessionID"],"N":["IDUser","ImpersonatedIDUser"]},"WorkflowEdge":{"I":["IDWorkflowEdge","GUIDWorkflowEdge"],"D":["Deleted","FromJobType","ToJobType","RulesJSON"],"N":[]}}}

},{}],135:[function(require,module,exports){
/**
 * Shared loader for small, customer-managed vocabularies that render as an option list rather than a
 * searchable entity picker - `SampleStatus` is the first of these.
 *
 * A vocabulary table holds tens of rows, is read in full, and stores a short code (not a database id)
 * on the record that references it, so the remote-search entity path is the wrong shape for it. An
 * input opts in through its descriptor:
 *
 *   PictForm.SelectOptionsEntity          - the entity name (e.g. 'SampleStatus').
 *   PictForm.SelectOptionsEntityValueField - the column persisted as the value (default ID<Entity>).
 *   PictForm.SelectOptionsEntityTextField  - the column shown as the label (default Name).
 *   PictForm.SelectOptionsEntitySortField  - the column the list is ordered by (default ID<Entity>).
 *   PictForm.SelectOptionsEntityFilter     - optional extra FoxHound stanza, ANDed into the read.
 *   PictForm.SelectOptionsEntityCap        - optional row cap (default 500).
 *
 * The load is shared per (entity + field config) across every input on the page. A customer with no
 * rows - and a read that fails - resolves to null, which every caller treats as "keep the static
 * PictForm.SelectOptions fallback", so an uncurated customer still gets a working list.
 *
 * @module _EntityOptionSource
 */

/** @typedef {{ id: any, text: string }} EntityOption */

const DEFAULT_ROW_CAP = 500;

/**
 * Cache key for one entity-backed option set. Inputs sharing an entity and field config share a load.
 *
 * @param {Object} pInput - The form input descriptor.
 * @return {string|null} - The cache key, or null when the input is not entity-backed.
 */
function getCacheKey(pInput)
{
	const tmpEntity = pInput && pInput.PictForm && pInput.PictForm.SelectOptionsEntity;
	if (!tmpEntity)
	{
		return null;
	}
	const tmpPictForm = pInput.PictForm;
	return [
		tmpEntity,
		tmpPictForm.SelectOptionsEntityValueField || `ID${tmpEntity}`,
		tmpPictForm.SelectOptionsEntityTextField || 'Name',
		tmpPictForm.SelectOptionsEntitySortField || `ID${tmpEntity}`,
		tmpPictForm.SelectOptionsEntityFilter || '',
		tmpPictForm.SelectOptionsEntityCap || DEFAULT_ROW_CAP,
	].join('|');
}

/**
 * The provider-scoped cache bag, created on first use.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @return {Record<string, {Loaded: boolean, Options: Array<EntityOption>, Callbacks: Array<Function>}>}
 */
function getCache(pProvider)
{
	if (!pProvider._entitySelectOptionCache)
	{
		pProvider._entitySelectOptionCache = {};
	}
	return pProvider._entitySelectOptionCache;
}

/**
 * Start the shared read for an entity-backed vocabulary. A failed read deletes the cache entry so the
 * next ask retries rather than being pinned to an empty list forever.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @param {Object} pInput - The form input descriptor.
 * @param {string} pCacheKey - The key from {@link getCacheKey}.
 * @return {void}
 */
function startLoad(pProvider, pInput, pCacheKey)
{
	const tmpCache = getCache(pProvider);
	const tmpPictForm = pInput.PictForm;
	const tmpEntity = tmpPictForm.SelectOptionsEntity;
	const tmpValueField = tmpPictForm.SelectOptionsEntityValueField || `ID${tmpEntity}`;
	const tmpTextField = tmpPictForm.SelectOptionsEntityTextField || 'Name';
	const tmpSortField = tmpPictForm.SelectOptionsEntitySortField || `ID${tmpEntity}`;
	const tmpCap = tmpPictForm.SelectOptionsEntityCap || DEFAULT_ROW_CAP;
	const tmpFilter = tmpPictForm.SelectOptionsEntityFilter ? `${tmpPictForm.SelectOptionsEntityFilter}~` : '';

	// meadow-endpoints pluralizes a scope by appending 's' - SampleStatus is served at SampleStatuss.
	pProvider.pict.HeadlightRestClient.getJSON(`${tmpEntity}s/FilteredTo/${tmpFilter}FSF~${tmpSortField}~ASC~0/0/${tmpCap}`, (pError, pRecords) =>
	{
		const tmpEntry = tmpCache[pCacheKey];
		if (!tmpEntry)
		{
			return;
		}
		if (pError || !Array.isArray(pRecords))
		{
			// Drop the entry so the next ask retries, but still release anyone waiting - an awaiting
			// caller (the Picker's DataProvider) would otherwise hang instead of using its fallback.
			pProvider.pict.log.warn(`EntityOptionSource: option load failed for [${tmpEntity}]: ${(pError && pError.message) || pError}`);
			delete tmpCache[pCacheKey];
			for (const fFailureCallback of tmpEntry.Callbacks)
			{
				try
				{
					fFailureCallback([]);
				}
				catch (pCallbackError)
				{
					pProvider.pict.log.error(`EntityOptionSource: repaint failed for [${tmpEntity}]: ${(pCallbackError && pCallbackError.message) || pCallbackError}`);
				}
			}
			return;
		}
		tmpEntry.Options = pRecords
			.filter((pRecord) => pRecord && (pRecord[tmpValueField] !== undefined) && (pRecord[tmpValueField] !== null) && (pRecord[tmpValueField] !== ''))
			.map((pRecord) => ({ id: pRecord[tmpValueField], text: pRecord[tmpTextField] || String(pRecord[tmpValueField]) }));
		tmpEntry.Loaded = true;
		const tmpCallbacks = tmpEntry.Callbacks;
		tmpEntry.Callbacks = [];
		for (const fCallback of tmpCallbacks)
		{
			try
			{
				fCallback(tmpEntry.Options);
			}
			catch (pCallbackError)
			{
				pProvider.pict.log.error(`EntityOptionSource: repaint failed for [${tmpEntity}]: ${(pCallbackError && pCallbackError.message) || pCallbackError}`);
			}
		}
	});
}

/**
 * Synchronously resolve the entity-backed option list, kicking off the shared load on first ask.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @param {Object} pInput - The form input descriptor.
 * @param {Function} [fOnLoaded] - Invoked once with the options after an in-flight load resolves.
 * @return {Array<EntityOption>|null} - The options, or null when the caller should use its static fallback.
 */
function resolveOptions(pProvider, pInput, fOnLoaded)
{
	const tmpCacheKey = getCacheKey(pInput);
	if (!tmpCacheKey || !pProvider || !pProvider.pict || !pProvider.pict.HeadlightRestClient)
	{
		return null;
	}
	const tmpCache = getCache(pProvider);
	const tmpEntry = tmpCache[tmpCacheKey];
	if (tmpEntry && tmpEntry.Loaded)
	{
		return (tmpEntry.Options.length > 0) ? tmpEntry.Options : null;
	}
	if (tmpEntry)
	{
		if (typeof fOnLoaded === 'function')
		{
			tmpEntry.Callbacks.push(fOnLoaded);
		}
		return null;
	}
	tmpCache[tmpCacheKey] = { Loaded: false, Options: [], Callbacks: (typeof fOnLoaded === 'function') ? [ fOnLoaded ] : [] };
	startLoad(pProvider, pInput, tmpCacheKey);
	return null;
}

/**
 * Promise form for callers (the Picker's async DataProvider) that can await the vocabulary. Resolves
 * to the static `PictForm.SelectOptions` fallback when the customer has no rows or the read failed.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @param {Object} pInput - The form input descriptor.
 * @return {Promise<Array<EntityOption>>} - The vocabulary, or the descriptor's static fallback.
 */
function resolveOptionsAsync(pProvider, pInput)
{
	const tmpFallback = (pInput && pInput.PictForm && Array.isArray(pInput.PictForm.SelectOptions)) ? pInput.PictForm.SelectOptions : [];
	return new Promise((fResolve) =>
	{
		const tmpResolved = resolveOptions(pProvider, pInput, (pOptions) =>
		{
			fResolve((pOptions && pOptions.length > 0) ? pOptions : tmpFallback);
		});
		if (Array.isArray(tmpResolved))
		{
			fResolve((tmpResolved.length > 0) ? tmpResolved : tmpFallback);
			return;
		}
		// Not entity-backed at all (no cache key / no REST client) - nothing will call back.
		if (!getCacheKey(pInput) || !pProvider || !pProvider.pict || !pProvider.pict.HeadlightRestClient)
		{
			fResolve(tmpFallback);
		}
	});
}

module.exports = { getCacheKey, resolveOptions, resolveOptionsAsync, DEFAULT_ROW_CAP };

},{}],136:[function(require,module,exports){
/**
 * The one implementation of the inline "Show All" toggle's DISABLED state, shared by the two entity-selector
 * families that render the toggle: the select2 `MaterialsEntitySelector` tree and the pict-section-picker
 * `Picker` broker. Neither family shares a base class (one extends `PictInputExtensionProvider`, the other
 * `PictInputTypePicker`), so this module — not inheritance — is what keeps their behaviour identical, and
 * keeps `headlight-dynamic-form` and `materials-form` from drifting.
 *
 * Why: a read-only / disabled selector still painted a live-looking toggle. Clicking it wrote override state
 * and re-ran the whole filter composition for a field whose value cannot change — wasted round trips, and a
 * control that reads as actionable when nothing can come of it. Disabled fields now paint the toggle inert
 * and swallow the click.
 *
 * The disabled state is applied twice on purpose: the `{~FilterToggleDisabled:~}` macro paints the class at
 * first render (no enabled→disabled flash), and `syncToggleDisabledState` re-applies it at input-initialize
 * so a descriptor disabled AFTER render — `MaterialsSampleSelector`'s `DisabledOnceSaved` is the live case —
 * is still caught.
 */

const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');

/** Class the templates/macro and the runtime sync both key off. */
const DISABLED_CLASS = 'hl-filter-toggle-disabled';

/** Stashes the template's own title while disabled, so the restore doesn't hardcode it. */
const TITLE_STASH_ATTRIBUTE = 'data-filter-toggle-title';

const DISABLED_TITLE = 'Show all is unavailable — this field is read-only';

/* Inert ghost-button paint. `a.button.<class>` (0,2,1) outranks Bulma's `.button.is-ghost` (0,2,0)
   regardless of injection order, which a bare `.<class>` would lose to. Pointer events stay ON so the
   explanatory title still shows on hover — the click itself is swallowed in toggleFilterOverride. */
const _FILTER_TOGGLE_DISABLED_CSS = /*css*/`
a.button.${DISABLED_CLASS},
a.button.${DISABLED_CLASS}:hover,
a.button.${DISABLED_CLASS}:focus {
	color: var(--bulma-text-weak);
	opacity: var(--bulma-button-disabled-opacity, 0.5);
	cursor: not-allowed;
	text-decoration: none;
	box-shadow: none;
}
`;

/**
 * True when the descriptor is read-only, by either flag Headlight uses: `PictForm.Disabled` (the entity
 * selectors, and the `{~Disabled:~}` macro's own source) or `PictForm.ReadOnly` (ObjectEditor / PSP).
 * @param {Record<string, any>} pInput - the input descriptor @return {boolean}
 */
const isInputDisabled = (pInput) =>
{
	const tmpPictForm = pInput && pInput.PictForm ? pInput.PictForm : null;
	if (!tmpPictForm)
	{
		return false;
	}
	return !!(tmpPictForm.Disabled || tmpPictForm.ReadOnly);
};

/**
 * Register the inert-toggle CSS with the pict CSSMap, and write it out once the page can take it.
 *
 * Registration and injection are separate on purpose. `addCSS` only ever RAISES the CSSMap's dirty flag,
 * so registering at bundle-attach time is free; `injectCSS` LOWERS it whether or not the target style
 * element exists yet, so calling it during bootstrap could quietly drop this fragment until something
 * else re-dirtied the map. Bootstrap registers (`pInjectNow` omitted); the input-initialize sync — by
 * which point the page is built — injects.
 *
 * @param {any} pPict @param {boolean} [pInjectNow] @return {boolean} true once the CSS is registered
 */
const ensureFilterToggleCSS = (pPict, pInjectNow) =>
{
	if (!pPict)
	{
		return false;
	}
	const tmpCSSMap = pPict.CSSMap;
	if (!tmpCSSMap || typeof tmpCSSMap.addCSS !== 'function')
	{
		return false;
	}
	if (!pPict._HeadlightFilterToggleCSSRegistered)
	{
		tmpCSSMap.addCSS('Headlight-FilterToggle-Disabled-CSS', _FILTER_TOGGLE_DISABLED_CSS, 500);
		pPict._HeadlightFilterToggleCSSRegistered = true;
	}
	if (pInjectNow && !pPict._HeadlightFilterToggleCSSInjected && typeof tmpCSSMap.injectCSS === 'function')
	{
		tmpCSSMap.injectCSS();
		pPict._HeadlightFilterToggleCSSInjected = true;
	}
	return true;
};

/** Resolve the toggle anchor for a `#ID` selector, or null when it isn't rendered. */
const _getToggleElement = (pPict, pToggleSelector) =>
{
	const tmpAssignment = pPict ? pPict.ContentAssignment : null;
	if (!tmpAssignment || typeof tmpAssignment.getElement !== 'function')
	{
		return null;
	}
	const tmpElements = tmpAssignment.getElement(pToggleSelector);
	const tmpToggle = tmpElements && tmpElements[0];
	return (tmpToggle && typeof tmpToggle.setAttribute === 'function') ? tmpToggle : null;
};

/**
 * Paint the toggle anchor's disabled state. The anchor carries no `href`, so it is not keyboard-focusable
 * and needs no tabindex — `aria-disabled` is what announces it.
 * @param {any} pPict @param {string} pToggleSelector - `#SOME-FILTER-TOGGLE-ID` @param {boolean} pDisabled
 * @return {boolean} true when an anchor was found and painted
 */
const syncToggleDisabledState = (pPict, pToggleSelector, pDisabled) =>
{
	const tmpToggle = _getToggleElement(pPict, pToggleSelector);
	if (!tmpToggle)
	{
		return false;
	}
	ensureFilterToggleCSS(pPict, true);
	if (pDisabled)
	{
		if (tmpToggle.classList)
		{
			tmpToggle.classList.add(DISABLED_CLASS);
		}
		if (!tmpToggle.hasAttribute(TITLE_STASH_ATTRIBUTE))
		{
			tmpToggle.setAttribute(TITLE_STASH_ATTRIBUTE, tmpToggle.getAttribute('title') || '');
		}
		tmpToggle.setAttribute('aria-disabled', 'true');
		tmpToggle.setAttribute('title', DISABLED_TITLE);
		return true;
	}
	if (tmpToggle.classList)
	{
		tmpToggle.classList.remove(DISABLED_CLASS);
	}
	tmpToggle.removeAttribute('aria-disabled');
	if (tmpToggle.hasAttribute(TITLE_STASH_ATTRIBUTE))
	{
		tmpToggle.setAttribute('title', tmpToggle.getAttribute(TITLE_STASH_ATTRIBUTE) || '');
		tmpToggle.removeAttribute(TITLE_STASH_ATTRIBUTE);
	}
	return true;
};

/**
 * The click guard. Read off the rendered anchor rather than the descriptor because the inline `onclick`
 * hands `toggleFilterOverride` only an HTML id — and because both the render-time macro (class) and the
 * init-time sync (aria) mark the same element, so the guard holds before init has run.
 * @param {any} pPict @param {string} pToggleSelector @return {boolean}
 */
const isToggleDisabled = (pPict, pToggleSelector) =>
{
	const tmpToggle = _getToggleElement(pPict, pToggleSelector);
	if (!tmpToggle)
	{
		return false;
	}
	if (typeof tmpToggle.getAttribute === 'function' && tmpToggle.getAttribute('aria-disabled') === 'true')
	{
		return true;
	}
	return !!(tmpToggle.classList && tmpToggle.classList.contains(DISABLED_CLASS));
};

/**
 * Whether the inline "Show All" toggle shows: the descriptor's own `PictForm.ShowAllToggle`, else its
 * specialized-selector config-map entry's (MaterialSelector's top-level-only filter comes with the toggle).
 * @param {Record<string, any>} pInput - the input descriptor (the template macro passes its Record) @return {boolean}
 */
const isToggleVisible = (pInput) =>
{
	const tmpPictForm = pInput && pInput.PictForm ? pInput.PictForm : null;
	if (!tmpPictForm)
	{
		return false;
	}
	return !!(tmpPictForm.ShowAllToggle ?? _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.ShowAllToggle);
};

module.exports = { DISABLED_CLASS, DISABLED_TITLE, isInputDisabled, isToggleVisible, ensureFilterToggleCSS, syncToggleDisabledState, isToggleDisabled };

},{"./_SpecializedSelectorMap.js":141}],137:[function(require,module,exports){
/**
 * Shared lab-routing helpers for the per-test lab selectors — the Picker-stack `MaterialsTestLabPicker` and the
 * legacy select2 `MaterialsTestLabSelector`, which differ in how they mount but route labs identically.
 *
 * Two concerns live here:
 *
 *   - **promotion.** The per-test labs also tell the sample where to ship. A sample ships to a PARENT lab, so
 *     the sample-level selector holds the parent of each test's lab (a lab with no parent stands for itself).
 *     Labs held only because a test promoted them are tracked, so they leave again once no test calls for
 *     them; a lab the user chose is never removed.
 *   - **auto-fill.** A test row that arrives with no lab takes the resolver's answer — the only lab that can
 *     run the test, else the top of its preference ranking — and stays blank when there is none. Never
 *     overwrites a value that is already there.
 *
 * @module _LabRouting
 */

const SAMPLE_LAB_SYNC_EVENT = 'SampleLabSync';
const DEFAULT_TEST_INSTANCES_ADDRESS = 'AppData.DocumentData.ReportData.FormData.SampleTestIDs__Record_Instances';

/**
 * The lab id the sample-level selector should hold for a lab picked against a test: its parent, or itself when
 * it has none. Falls back to the record's own `IDLabParent` when the resolver has not primed, and to the lab
 * itself when neither answers — promotion must never drop the selection.
 *
 * @param {Object} pPict - the pict instance (reads `providers.LabScopeResolver`).
 * @param {Record<string, any>} pLab - the picked Lab record.
 * @return {number} The IDLab to promote, or 0 when there is nothing to promote.
 */
function resolveSampleLabID(pPict, pLab)
{
	const tmpIDLab = parseInt(pLab && pLab.IDLab, 10);
	if (!(tmpIDLab > 0))
	{
		return 0;
	}
	const tmpResolved = parseInt(pPict?.providers?.LabScopeResolver?.getParentLabID?.(tmpIDLab), 10);
	if (tmpResolved > 0)
	{
		return tmpResolved;
	}
	const tmpRecordParent = parseInt(pLab.IDLabParent, 10);
	return (tmpRecordParent > 0) ? tmpRecordParent : tmpIDLab;
}

/**
 * A lab selection value (csv, array or empty) as trimmed id strings, blanks dropped.
 *
 * @param {any} pValue
 * @return {Array<string>}
 */
function parseLabIDList(pValue)
{
	if (pValue === null || pValue === undefined || pValue === '')
	{
		return [];
	}
	const tmpEntries = Array.isArray(pValue) ? pValue : String(pValue).split(',');
	return tmpEntries.map((pEntry) => String(pEntry).trim()).filter((pEntry) => pEntry.length > 0);
}

/**
 * The sample-level labs the per-test labs call for right now: the parent of each row's lab, in row order.
 *
 * @param {Object} pPict - the pict instance.
 * @param {Array<Record<string, any>>} pTriples - the Test selector's TestInstance triples.
 * @return {Array<string>}
 */
function collectPromotedSampleLabIDs(pPict, pTriples)
{
	const tmpWanted = [];
	for (const tmpTriple of (Array.isArray(pTriples) ? pTriples : []))
	{
		const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
		const tmpIDLab = parseInt(tmpTestInstance && tmpTestInstance.IDLab, 10);
		if (!(tmpIDLab > 0))
		{
			continue;
		}
		const tmpRecord = tmpTestInstance.IDLab__Record;
		const tmpLab = (tmpRecord && parseInt(tmpRecord.IDLab, 10) === tmpIDLab) ? tmpRecord : { IDLab: tmpIDLab };
		const tmpSampleLabID = String(resolveSampleLabID(pPict, tmpLab));
		if (tmpWanted.indexOf(tmpSampleLabID) < 0)
		{
			tmpWanted.push(tmpSampleLabID);
		}
	}
	return tmpWanted;
}

/**
 * The labs the sample's tests are assigned to right now, in row order — the ranking prefers them so a row
 * does not add a lab to the sample when one already in use can run its test.
 *
 * @param {Object} pPict - the pict instance.
 * @return {Array<number>}
 */
function collectSelectedTestLabIDs(pPict)
{
	const tmpTriples = pPict?.manifest?.getValueAtAddress?.(pPict, DEFAULT_TEST_INSTANCES_ADDRESS);
	const tmpSelected = [];
	for (const tmpTriple of (Array.isArray(tmpTriples) ? tmpTriples : []))
	{
		const tmpIDLab = parseInt(tmpTriple && tmpTriple.TestInstance && tmpTriple.TestInstance.IDLab, 10);
		if (tmpIDLab > 0 && tmpSelected.indexOf(tmpIDLab) < 0)
		{
			tmpSelected.push(tmpIDLab);
		}
	}
	return tmpSelected;
}

/**
 * Reconcile the sample-level lab selection with the labs the tests call for. A called-for lab missing from the
 * selection is added and recorded as promoted; a promoted lab no test calls for any more is removed; a lab the
 * user chose is never touched, and one the user removed stops counting as promoted.
 *
 * @param {Array<string>} pSelection - the current selection, in order.
 * @param {Array<string>} pPromoted - the part of the selection promotion put there.
 * @param {Array<string>} pWanted - the labs the tests call for now.
 * @return {{ Selection: Array<string>, Promoted: Array<string> }}
 */
function reconcileSampleLabs(pSelection, pPromoted, pWanted)
{
	const tmpWanted = new Set(pWanted);
	const tmpPromoted = new Set(pPromoted.filter((pID) => pSelection.indexOf(pID) > -1));
	const tmpSelection = pSelection.filter((pID) => !tmpPromoted.has(pID) || tmpWanted.has(pID));
	const tmpStillPromoted = Array.from(tmpPromoted).filter((pID) => tmpWanted.has(pID));
	for (const tmpID of pWanted)
	{
		if (tmpSelection.indexOf(tmpID) < 0)
		{
			tmpSelection.push(tmpID);
			tmpStillPromoted.push(tmpID);
		}
	}
	return { Selection: tmpSelection, Promoted: tmpStillPromoted };
}

/**
 * Bring a sample-level lab selector in line with the per-test labs (see reconcileSampleLabs). Reads the test
 * triples from `PictForm.TestInstancesAddress` (default: the Test selector's) and keeps the promoted set in the
 * form data at `pPromotedAddress`, so a retraction still knows what it may remove after a reopen. A document
 * saved before that set existed carries none, so nothing on it counts as promoted and nothing is removed.
 *
 * @param {Object} pPict - the pict instance.
 * @param {Record<string, any>} pInput - the sample-level lab selector's descriptor.
 * @param {Object} pDestination - the view's marshal destination object.
 * @param {string} pPromotedAddress - where the promoted set lives, relative to pDestination.
 * @param {any} pCurrentValue - the selector's current value.
 * @return {string|null} The new selection csv, or null when it is unchanged.
 */
function syncSampleLabSelection(pPict, pInput, pDestination, pPromotedAddress, pCurrentValue)
{
	const tmpTriplesAddress = (pInput && pInput.PictForm && pInput.PictForm.TestInstancesAddress) || DEFAULT_TEST_INSTANCES_ADDRESS;
	const tmpTriples = pPict.manifest.getValueAtAddress(pPict, tmpTriplesAddress);
	const tmpSelection = parseLabIDList(pCurrentValue);
	const tmpResult = reconcileSampleLabs(tmpSelection, parseLabIDList(pPict.manifest.getValueAtAddress(pDestination, pPromotedAddress)), collectPromotedSampleLabIDs(pPict, tmpTriples));
	pPict.manifest.setValueAtAddress(pDestination, pPromotedAddress, tmpResult.Promoted.join(','));
	const tmpNextValue = tmpResult.Selection.join(',');
	return (tmpNextValue === tmpSelection.join(',')) ? null : tmpNextValue;
}

/**
 * Ask the sample-level lab selector to reconcile with the per-test labs. The per-test selectors hold no
 * reference to that input, so they broadcast; it owns its value and join array. Sent on every change to the
 * per-test labs — a clear, a re-pick or a removed test has to retract as surely as a pick promotes.
 *
 * @param {Object} pPict - the pict instance.
 * @return {void}
 */
function requestSampleLabSync(pPict)
{
	pPict?.views?.PictFormMetacontroller?.triggerGlobalInputEvent?.(SAMPLE_LAB_SYNC_EVENT);
}

/**
 * Whether a per-test lab selector should auto-fill. Opt out per descriptor with `PictForm.AutoFillLab: false`;
 * on by default, since a row whose lab is uniquely determined has nothing for the user to decide.
 *
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @return {boolean}
 */
function isAutoFillEnabled(pInput)
{
	return (pInput && pInput.PictForm) ? (pInput.PictForm.AutoFillLab !== false) : true;
}

/**
 * The descriptor's per-test `LabScope` filter entry, which carries the axis addresses the resolver needs.
 *
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @return {Record<string, any>|null}
 */
function getTestLabScopeFilter(pInput)
{
	const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
	if (!Array.isArray(tmpFilters))
	{
		return null;
	}
	for (const tmpFilter of tmpFilters)
	{
		if (tmpFilter && tmpFilter.LabScope === 'Test')
		{
			return tmpFilter;
		}
	}
	return null;
}

/**
 * The lab to fill into an empty per-test selector for a row, or 0 when there is nothing to fill. Resolves the
 * row's test through the same resolver the filters and pins use, so the auto-filled value is by construction
 * the first one the dropdown would have offered.
 *
 * @param {Object} pPict - the pict instance (reads `providers.LabScopeResolver` / `providers.EntityFilterEngine`).
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @param {number|string|null} pRowIndex - the tabular row index.
 * @param {Object} pView - the form view (provides the marshal destination for the row read).
 * @return {number}
 */
function resolveAutoFillLabID(pPict, pInput, pRowIndex, pView)
{
	const tmpResolver = pPict?.providers?.LabScopeResolver;
	const tmpEngine = pPict?.providers?.EntityFilterEngine;
	if (!tmpResolver || !tmpEngine || !isAutoFillEnabled(pInput))
	{
		return 0;
	}
	// Show All means "let me pick anything" — filling a value under it would contradict the request.
	if (tmpEngine.isFilterOverridden(pInput, pRowIndex))
	{
		return 0;
	}
	const tmpFilter = getTestLabScopeFilter(pInput);
	if (!tmpFilter)
	{
		return 0;
	}
	const tmpIDTest = tmpEngine._readLabScopeTestID(tmpFilter, pInput, pRowIndex, pView);
	if (!tmpIDTest)
	{
		return 0;
	}
	return parseInt(tmpResolver.getAutoFillLabID(tmpIDTest, { SelectedLabIDs: collectSelectedTestLabIDs(pPict) }), 10) || 0;
}

/**
 * Fill an empty per-test selector row, waiting out a resolver prime that is still loading the row's test.
 *
 * The Testing table re-renders as soon as the test set changes, while the resolver re-primes for the new set
 * asynchronously — so the newest row is evaluated against caches that do not yet know its test, and nothing
 * revisits it. When the first attempt finds nothing and a prime is in flight, retry once it lands, provided
 * the row still holds the same test and is still empty.
 *
 * @param {Object} pPict - the pict instance.
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @param {number|string} pRowIndex - the tabular row index.
 * @param {Object} pView - the form view.
 * @param {() => any} fReadRowLab - reads the row's current lab.
 * @param {(pIDLab: number) => void} fCommit - commits a lab through the selector's pick path.
 * @return {void}
 */
function autoFillTestLab(pPict, pInput, pRowIndex, pView, fReadRowLab, fCommit)
{
	const tmpIDLab = resolveAutoFillLabID(pPict, pInput, pRowIndex, pView);
	if (tmpIDLab > 0)
	{
		fCommit(tmpIDLab);
		return;
	}
	const tmpResolver = pPict?.providers?.LabScopeResolver;
	const tmpEngine = pPict?.providers?.EntityFilterEngine;
	const tmpFilter = getTestLabScopeFilter(pInput);
	if (!tmpResolver || !tmpEngine || !tmpFilter || typeof tmpResolver.primeFromForm !== 'function' || typeof tmpResolver.isPriming !== 'function')
	{
		return;
	}
	const tmpIDTest = tmpEngine._readLabScopeTestID(tmpFilter, pInput, pRowIndex, pView);
	if (!tmpIDTest)
	{
		return;
	}
	const tmpPrime = tmpResolver.primeFromForm();
	if (!tmpResolver.isPriming())
	{
		return;
	}
	tmpPrime.then(() =>
	{
		if (String(tmpEngine._readLabScopeTestID(tmpFilter, pInput, pRowIndex, pView)) !== String(tmpIDTest))
		{
			return;
		}
		if (parseInt(fReadRowLab(), 10) > 0)
		{
			return;
		}
		const tmpRetryIDLab = resolveAutoFillLabID(pPict, pInput, pRowIndex, pView);
		if (tmpRetryIDLab > 0)
		{
			fCommit(tmpRetryIDLab);
		}
	}).catch((pError) =>
	{
		pPict?.log?.warn?.(`[LabRouting] deferred lab auto-fill failed for row ${pRowIndex}: ${pError?.message || pError}`);
	});
}

/**
 * The spec-set lab floor both selector stacks apply to a Lab picker, family-expanded when the
 * LabScopeResolver is available to supply the lab tree.
 *
 * `LabTestSpecificationSetJoin` declares membership at the FAMILY level — the set names parent labs and
 * their benches are allowed through them — so raw `IDLab` membership empties any list of benches, and a
 * set that also names a bench directly empties the parent-level list. Falls back to raw membership when
 * no resolver is registered, which is the pre-existing behavior.
 *
 * @param {Object} pPict - the pict instance.
 * @return {Set<number>|null} The admitted lab ids, or null for no floor.
 */
function resolveSpecSetLabFloor(pPict)
{
	const tmpExpanded = pPict?.providers?.LabScopeResolver?.getSpecSetLabFloor?.();
	if (tmpExpanded)
	{
		return tmpExpanded;
	}
	return pPict?.providers?.SpecScopeResolver?.getAllowedLabIDs?.() || null;
}

module.exports =
{
	SAMPLE_LAB_SYNC_EVENT,
	resolveSampleLabID,
	parseLabIDList,
	collectPromotedSampleLabIDs,
	collectSelectedTestLabIDs,
	reconcileSampleLabs,
	syncSampleLabSelection,
	requestSampleLabSync,
	isAutoFillEnabled,
	getTestLabScopeFilter,
	resolveAutoFillLabID,
	autoFillTestLab,
	resolveSpecSetLabFloor,
};

},{}],138:[function(require,module,exports){
/**
 * The one rule for "which stored values does a Picker field paint as NOTHING SELECTED?", shared by the
 * edit broker, its cascade subclass, and the Read/Print display provider so they cannot drift.
 *
 * Why the rule exists: a pict-section-form marshal reads values through manyfest's getValueByHash, which
 * substitutes the descriptor default for any address the model does not hold yet — and, with no explicit
 * `Default`, that is manyfest's per-DataType default. String gets '', but Number/Integer/Float get 0. So
 * a pristine `{ DataType: 'Number', InputType: 'Picker' }` field — an entity FK, virtually always —
 * marshals in as 0, and the picker would paint a literal "0" as though the user had chosen something.
 * There is no entity #0; it reads as a bug. Treating it as unset is DISPLAY-side only: the stored value
 * is left alone, so 0-means-unset stays a valid pattern for solvers, exports, and the API.
 *
 * A descriptor overrides with `PictForm.EmptyValues` — its own sentinel list, or `[]` to opt out and
 * show the raw 0.
 *
 * pict-section-picker owns the base rule (its form adapter feeds the list to the widget as its
 * `EmptyValues` option, which is what actually suppresses the paint). Headlight extends it for the
 * Materials family, and the broker hands the result to the widget through the adapter's
 * `_resolveEmptyValues` seam, so the control, `__Record` and Read/Print all resolve it here. Requires
 * pict-section-picker >= 1.9.4.
 */
const libPSPResolveEmptyValues = require('pict-section-picker/form').resolveEmptyValues;
const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');

/**
 * The descriptor's own `PictForm.EmptyValues` wins; else a Materials-family InputType treats 0 as unset
 * whatever its DataType (legacy MES read `pValue == ''`), and the stored literals "null" / "undefined" too
 * (legacy MES skipped them; MaterialsCascadePicker._isClearedPickerValue reads them as a clear); else PSP's
 * per-DataType rule.
 * @param {Record<string, any>} pInput @return {Array<any>}
 */
const resolveEmptyValues = (pInput) =>
{
	const tmpPictForm = (pInput && pInput.PictForm) || {};
	if (!Array.isArray(tmpPictForm.EmptyValues) && _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.MaterialsFamily)
	{
		return [ 0, 'null', 'undefined' ];
	}
	return libPSPResolveEmptyValues(pInput);
};

/**
 * True when a single stored value is one of this descriptor's unset sentinels. String-compared, so the
 * numeric 0 and the "0" that comes back off the hidden informary input are the same thing.
 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
 */
const isEmptyValue = (pInput, pValue) =>
	resolveEmptyValues(pInput).some((pEmpty) => String(pEmpty) === String(pValue));

module.exports = { resolveEmptyValues, isEmptyValue };

},{"./_SpecializedSelectorMap.js":141,"pict-section-picker/form":604}],139:[function(require,module,exports){
/**
 * Scoped `Document.EntityData` comprehension emission — the shared primitives behind the
 * `UseScopedEntityData` rollout flag.
 *
 * The legacy path projects created records into `FormData._EntityData` as a flat
 * `[Entity][GUID]` ledger and lets the browser-side `FormEntityCreator` apply it. The scoped
 * path writes each record straight into the document's own `EntityData` under a trigger-context
 * key — `OnSave.<Entity>.<GUID>`, `OnEnteringState.Approved.<Entity>.<GUID>` — which the server
 * applies (api/headlight on document update, approvals on approval action). WHEN a record is
 * applied is encoded ONLY by which context it is nested under, so scheduling is configuration
 * (`PictForm.ComprehensionContext`), not provider code.
 *
 * Writes route through `DynamicFormSolverBehaviors.addComprehensionEntity` — the one shared
 * comprehension writer, also used by the solver path and `DocumentDynamicSectionManager` — so
 * every producer emits the same shape.
 *
 * @module _ScopedEntityData
 */

/** The context a save-time record lands under when an input declares none. */
const DEFAULT_CONTEXT = 'OnSave';

/**
 * The context a deferred value lands under when an input declares none.
 *
 * Keyed on the status the document enters rather than the action that took it there: a workflow whose
 * every step is `Approve` applies an action-keyed value at the FIRST step and again at each one after
 * it. Requires an API and approvals service carrying `OnEnteringState` (0.43.162 or later); an older
 * one strips the deferred value with the rest of the trigger's deny-listed columns.
 */
const DEFAULT_DEFERRED_CONTEXT = 'OnEnteringState.Approved';

/**
 * The trigger keys a comprehension nests under, and how many address parts each takes before the
 * entity buckets begin. `OnSave` stages for the next document save and is drained once applied; the
 * others stage for a workflow transition, name the action or status they fire on, and stand until
 * that transition happens — so a leaf under one of them outlives many saves.
 *
 * Every walk of the tree reads this rather than naming the keys it knows, so adding a trigger is one
 * entry here. Mirrors `SPECIAL_TABLES_KEYS` in `headlight-comprehension-processor` and its copy in
 * `api/headlight`.
 */
const TRIGGER_CONTEXT_DEPTH = Object.freeze({ OnSave: 1, OnApprovalAction: 2, OnEnteringState: 2 });

/** The trigger keys that stage for a workflow transition rather than for the next save. */
const DEFERRED_TRIGGERS = Object.freeze([ 'OnApprovalAction', 'OnEnteringState' ]);

/**
 * The deprecated deferred trigger. The server still applies it, so documents already carrying one keep
 * working; a form that stages under another trigger takes its leaves with it rather than leaving a
 * second copy that applies on the first approval step.
 */
const LEGACY_DEFERRED_TRIGGER = 'OnApprovalAction';

/** Fallback comprehension destination when the solver-behaviors provider is unavailable. */
const DOCUMENT_ENTITY_DATA_ADDRESS = 'AppData.DocumentData.ReportData.EntityData';

/**
 * Read one `UseScopedEntityData` setting. Strings are honored because the value is authored in
 * JSON form config, where a boolean often arrives quoted — and an opt-out that silently failed to
 * take would leave a form on the legacy path with no signal.
 *
 * @param {any} pValue - The configured value.
 * @return {boolean|null} - The setting, or null when the value expresses no opinion.
 */
function readFlagValue(pValue)
{
	if (typeof pValue === 'boolean')
	{
		return pValue;
	}
	if (typeof pValue === 'string')
	{
		const tmpNormalized = pValue.trim().toLowerCase();
		if (tmpNormalized === 'false')
		{
			return false;
		}
		if (tmpNormalized === 'true')
		{
			return true;
		}
	}
	return null;
}

/**
 * Whether the scoped-emission path is active. ONE flag drives both the inputs' emission target and
 * the `FormEntityCreator` skip — the two paths must never run together, so this resolves from a
 * single name: the form manifest wins (either direction) over the app-level setting. Scoped emission
 * is the DEFAULT; only an explicit `false` holds a form on the legacy
 * `FormData._EntityData` + browser-side-apply path.
 *
 * Default-on is a QA-shakedown posture, not a prod decision. It is safe here only because the
 * server-side apply now archives an applied `OnSave` subtree into `EntityData.ExecutionLog` and
 * guards re-application on a content hash; without that, a stored subtree replays on EVERY Document
 * update and reverts whatever wrote to those entities since the last form save. A branch build cut
 * for stage or release picks this default up, so the prod posture is a decision that has to be taken
 * before that cut, not inherited from this line.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when inputs should emit scoped comprehensions and FEC should stand down.
 */
function isEnabled(pPict)
{
	const tmpSettings = (pPict && pPict.settings) || { };
	const tmpManifest = tmpSettings.MyDefaultFormManifest;
	const tmpManifestFlag = readFlagValue(tmpManifest && tmpManifest.UseScopedEntityData);
	if (tmpManifestFlag !== null)
	{
		return tmpManifestFlag;
	}
	const tmpApplicationFlag = readFlagValue(tmpSettings.UseScopedEntityData);
	if (tmpApplicationFlag !== null)
	{
		return tmpApplicationFlag;
	}
	return true;
}

/**
 * The pict flag an input sets once it has actually emitted scoped, and `FormEntityCreator` reads
 * before running its legacy apply.
 *
 * The two paths must never run over the same save. Both sides resolving `isEnabled` is not enough
 * on its own: they agree only if they are the SAME module, and a second installed copy of this
 * bundle (or a stale build of one half) puts them back out of step with no signal — the ledger
 * reads empty, and the diff-delete takes that for "every document-owned record was removed".
 * This is the runtime cross-check for that.
 */
const ACTIVE_MARKER = '_ScopedEntityDataActive';

/**
 * Record that an input emitted scoped on this save.
 *
 * @param {Object} pPict - The pict instance.
 */
function markActive(pPict)
{
	if (pPict && typeof pPict === 'object')
	{
		pPict[ACTIVE_MARKER] = true;
	}
}

/**
 * Whether an input has emitted scoped comprehensions on this pict.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when the scoped path is live.
 */
function isMarkedActive(pPict)
{
	return !!(pPict && typeof pPict === 'object' && pPict[ACTIVE_MARKER]);
}

/**
 * Context roots the picker family projected into on this save, kept on the pict rather than on a
 * provider: every Materials provider's save hook can drive a sweep, and the provider that prunes last
 * must also prune what other providers' inputs projected, or its sweep re-sends their records whole.
 */
const NOTED_PROJECTION_ROOTS_MARKER = '_ScopedEntityDataNotedProjectionRoots';

/**
 * Note a context root an input projected into, for whichever provider sanitizes after the sweep.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {Record<string, any>} pContextRoot - The root the input wrote into.
 */
function noteProjectionRoot(pPict, pContext, pContextRoot)
{
	if (!pPict || typeof pPict !== 'object' || !pContextRoot || typeof pContextRoot !== 'object')
	{
		return;
	}
	if (!(pPict[NOTED_PROJECTION_ROOTS_MARKER] instanceof Map))
	{
		pPict[NOTED_PROJECTION_ROOTS_MARKER] = new Map();
	}
	pPict[NOTED_PROJECTION_ROOTS_MARKER].set(pContext, pContextRoot);
}

/**
 * Take (and clear) the context roots noted since the last sanitize pass.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Array<[string, Record<string, any>]>} - `[context, root]` pairs; empty when none were noted.
 */
function takeNotedProjectionRoots(pPict)
{
	if (!pPict || typeof pPict !== 'object' || !(pPict[NOTED_PROJECTION_ROOTS_MARKER] instanceof Map))
	{
		return [];
	}
	const tmpNoted = [ ...pPict[NOTED_PROJECTION_ROOTS_MARKER].entries() ];
	pPict[NOTED_PROJECTION_ROOTS_MARKER].clear();
	return tmpNoted;
}

/**
 * Resolve the trigger context an input emits under.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {string} [pDefaultContext] - The provider's default when the input declares none.
 * @return {string} - The comprehension context (a dotted address, e.g. `OnApprovalAction.Approve`).
 */
function resolveContext(pInput, pDefaultContext)
{
	const tmpConfigured = pInput && pInput.PictForm && pInput.PictForm.ComprehensionContext;
	if (typeof tmpConfigured === 'string' && tmpConfigured.length > 0)
	{
		return tmpConfigured;
	}
	return pDefaultContext || DEFAULT_CONTEXT;
}

/**
 * Field-name prefixes that mark a meadow directive rather than a column. `_Dest_` composes with the
 * field it redirects, so the destination directive for an exact-GUID reference is `_Dest_` +
 * `_GUID<Entity>` — `_Dest__GUID<Entity>`, a double underscore the transient-state test would
 * otherwise eat, silently retargeting the foreign key.
 */
const MEADOW_DIRECTIVE_PREFIXES = [ '_Dest_', '_GUID' ];

/**
 * Is a field transient entity-selector UI state rather than something to persist?
 *
 * Selectors marshal `<Field>__Salt` / `<Field>__Record` siblings alongside their value; carried into
 * a comprehension they reach meadow's INSERT column list and diverge the column/value counts.
 *
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field is UI state and must not be persisted.
 */
function isTransientFormField(pFieldName)
{
	if (typeof pFieldName !== 'string' || !pFieldName.includes('__'))
	{
		return false;
	}
	for (const tmpPrefix of MEADOW_DIRECTIVE_PREFIXES)
	{
		if (pFieldName.startsWith(tmpPrefix))
		{
			return false;
		}
	}
	return true;
}

/**
 * Strip transient entity-selector UI state from a record before it is persisted. Mirrors
 * `FormEntityCreator.sanitizeComprehension` at the record level.
 *
 * @param {Record<string, any>} pRecord - The record to sanitize.
 * @return {Record<string, any>} - A clone with the UI-state fields removed.
 */
/**
 * Whether a field is an id column carrying a value no id column can hold.
 *
 * The selectors use a placeholder for "the user asked for a new one" (`__NEW__`) and put it in the
 * record's own id slot until the server resolves a real one. It is interface state, not data: an
 * upsert resolves the row by GUID and then compares the id it found against the id the record
 * carries, so a placeholder that outlives the create makes every later save of that record fail with
 * `Default identifier does not match GUID record` - permanently, because the row now exists.
 *
 * Only strings that are not numbers at all are dropped. `0`, `''` and `'57004'` are left exactly as
 * they were: they reach the column as a number, and changing that would change what a save means.
 *
 * @param {string} pFieldName - the field name.
 * @param {any} pValue - the field value.
 * @return {boolean} - True when the field must not be emitted.
 */
function isUnresolvedIdentityField(pFieldName, pValue)
{
	if (typeof pFieldName !== 'string' || !(/^ID[A-Z]/).test(pFieldName))
	{
		return false;
	}
	if (typeof pValue !== 'string')
	{
		return false;
	}
	return !Number.isFinite(Number(pValue));
}

function sanitizeRecord(pRecord)
{
	const tmpSanitized = { };
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return tmpSanitized;
	}
	for (const tmpField of Object.keys(pRecord))
	{
		if (isTransientFormField(tmpField))
		{
			continue;
		}
		if (isUnresolvedIdentityField(tmpField, pRecord[tmpField]))
		{
			continue;
		}
		tmpSanitized[tmpField] = pRecord[tmpField];
	}
	return tmpSanitized;
}

/**
 * The pict-level marker naming the scratch tree a baseline sweep is collecting into.
 *
 * The baseline is captured by re-running the ordinary save sweep at load, so every projector — both
 * input families, the subclass cascades, the deferred TestResult split — must land in the scratch
 * rather than in the document. Redirecting the single destination resolver is what achieves that:
 * everything downstream (context roots, entity buckets, record writes) already routes through it.
 */
const BASELINE_SWEEP_MARKER = '_ScopedEntityDataBaselineSweep';

/**
 * Begin a baseline sweep: subsequent comprehension writes land in a fresh scratch tree instead of
 * the document's own EntityData.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Record<string, any>} - The scratch tree the sweep will fill.
 */
function beginBaselineSweep(pPict)
{
	const tmpSweep = { Scratch: { }, Contexts: new Map() };
	if (pPict && typeof pPict === 'object')
	{
		pPict[BASELINE_SWEEP_MARKER] = tmpSweep;
	}
	return tmpSweep;
}

/**
 * The in-flight baseline sweep, or null when none is running.
 *
 * @param {Object} pPict - The pict instance.
 * @return {{ Scratch: Record<string, any>, Contexts: Map<string, Record<string, any>> }|null} - The sweep, or null.
 */
function getBaselineSweepTarget(pPict)
{
	if (!pPict || typeof pPict !== 'object')
	{
		return null;
	}
	const tmpSweep = pPict[BASELINE_SWEEP_MARKER];
	return (tmpSweep && typeof tmpSweep === 'object' && tmpSweep.Scratch) ? tmpSweep : null;
}

/**
 * End a baseline sweep and hand back what it collected, as the (context -> context root) pairs the
 * projectors actually resolved. The pairs are what the caller needs: a context is a DOTTED address
 * (`OnApprovalAction.Approve`), so the collected tree cannot be walked back into contexts and entity
 * buckets by shape alone.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Map<string, Record<string, any>>|null} - The collected roots by context, or null when no sweep was running.
 */
function endBaselineSweep(pPict)
{
	const tmpSweep = getBaselineSweepTarget(pPict);
	if (pPict && typeof pPict === 'object')
	{
		delete pPict[BASELINE_SWEEP_MARKER];
	}
	return tmpSweep ? tmpSweep.Contexts : null;
}

/**
 * Resolve the object comprehensions are written into. Prefers the solver-behaviors provider's own
 * destination (configured on the metacontroller as `comprehensionDestinationAddress`, which the
 * configurable application points at `Document.EntityData`) so scoped writes and solver writes
 * always land in the same place.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Record<string, any>|null} - The destination object, or null when none can be resolved.
 */
function resolveDestination(pPict)
{
	const tmpBaselineSweep = getBaselineSweepTarget(pPict);
	if (tmpBaselineSweep)
	{
		return tmpBaselineSweep.Scratch;
	}
	const tmpBehaviors = pPict && pPict.providers && pPict.providers.DynamicFormSolverBehaviors;
	if (tmpBehaviors && typeof tmpBehaviors.resolveComprehensionDestination === 'function')
	{
		const tmpResolved = tmpBehaviors.resolveComprehensionDestination();
		if (tmpResolved && typeof tmpResolved === 'object' && !Array.isArray(tmpResolved))
		{
			return tmpResolved;
		}
	}
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpEntityData = pPict.manifest.getValueAtAddress(pPict, DOCUMENT_ENTITY_DATA_ADDRESS);
	if (tmpEntityData && typeof tmpEntityData === 'object' && !Array.isArray(tmpEntityData))
	{
		return tmpEntityData;
	}
	if (typeof pPict.manifest.setValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpCreated = { };
	pPict.manifest.setValueAtAddress(pPict, DOCUMENT_ENTITY_DATA_ADDRESS, tmpCreated);
	return tmpCreated;
}

/**
 * Walk (creating as it goes) `pNode -> <context parts>` and hand back the node the entity buckets
 * hang from.
 *
 * @param {Record<string, any>} pNode - The node to walk from.
 * @param {string} pContext - The dotted context address.
 * @return {Record<string, any>} - The context node.
 */
function walkContext(pNode, pContext)
{
	let tmpCursor = pNode;
	for (const tmpPart of String(pContext).split('.'))
	{
		if (tmpPart.length < 1)
		{
			continue;
		}
		if (!tmpCursor[tmpPart] || typeof tmpCursor[tmpPart] !== 'object' || Array.isArray(tmpCursor[tmpPart]))
		{
			tmpCursor[tmpPart] = { };
		}
		tmpCursor = tmpCursor[tmpPart];
	}
	return tmpCursor;
}

/**
 * The node a context's records are keyed under, as `<Entity>.<GUID>`.
 *
 * That is the SAME shape as the legacy flat `_EntityData` ledger, which is what makes the scoped
 * conversion a retarget rather than a rewrite: hand this node to a projector written against the
 * flat ledger and it produces a correct scoped comprehension, unchanged.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The dotted context address.
 * @return {Record<string, any>|null} - The context root, or null when no destination resolves.
 */
function resolveContextRoot(pPict, pContext)
{
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return null;
	}
	const tmpContext = pContext || DEFAULT_CONTEXT;
	const tmpRoot = walkContext(tmpDestination, tmpContext);
	const tmpBaselineSweep = getBaselineSweepTarget(pPict);
	if (tmpBaselineSweep)
	{
		tmpBaselineSweep.Contexts.set(tmpContext, tmpRoot);
	}
	return tmpRoot;
}

/**
 * Walk (creating as it goes) `Destination -> <context parts> -> <Entity>` and hand back the
 * entity bucket.
 *
 * @param {Record<string, any>} pDestination - The comprehension destination object.
 * @param {string} pContext - The dotted context address.
 * @param {string} pEntity - The entity name.
 * @return {Record<string, any>} - The entity bucket, keyed by external GUID.
 */
function resolveEntityBucket(pDestination, pContext, pEntity)
{
	const tmpCursor = walkContext(pDestination, pContext);
	if (!tmpCursor[pEntity] || typeof tmpCursor[pEntity] !== 'object' || Array.isArray(tmpCursor[pEntity]))
	{
		tmpCursor[pEntity] = { };
	}
	return tmpCursor[pEntity];
}

/**
 * Replace every `<Entity>.<GUID>` leaf under a context root with a sanitized CLONE.
 *
 * The projectors key the form's LIVE record objects into the comprehension by reference, and this
 * tree is saved with the document — so the transient `__` UI state has to come off, and it has to
 * come off a copy, because the form goes on rendering from the original. This is the scoped
 * counterpart of the pass `FormEntityCreator` used to run over the ledger at apply time.
 *
 * @param {Record<string, any>} pContextRoot - The context root to sanitize in place.
 * @return {boolean} - True when a root was walked.
 */
function sanitizeContextRoot(pContextRoot)
{
	if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
	{
		return false;
	}
	for (const tmpEntity of Object.keys(pContextRoot))
	{
		const tmpBucket = pContextRoot[tmpEntity];
		if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
		{
			continue;
		}
		for (const tmpGUID of Object.keys(tmpBucket))
		{
			const tmpRecord = tmpBucket[tmpGUID];
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			tmpBucket[tmpGUID] = sanitizeRecord(tmpRecord);
		}
	}
	return true;
}

/**
 * Write one record into `<Context>.<Entity>.<GUID>`, replacing whatever leaf was there.
 *
 * The leaf is dropped before the write because `addComprehensionEntity` ACCUMULATES properties on
 * an existing (Context, Entity, GUID) — so a re-added record would otherwise inherit the `Deleted`
 * flag from a tombstone, or fields the form has since dropped.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pRecord - The record to write (sanitized here).
 * @return {boolean} - True when the record was written.
 */
function writeRecord(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pContext || !pEntity || !pGUID)
	{
		return false;
	}
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return false;
	}
	const tmpBucket = resolveEntityBucket(tmpDestination, pContext, pEntity);
	delete tmpBucket[pGUID];

	const tmpSanitized = sanitizeRecord(pRecord);
	const tmpBehaviors = pPict && pPict.providers && pPict.providers.DynamicFormSolverBehaviors;
	if (tmpBehaviors && typeof tmpBehaviors.addComprehensionEntity === 'function' && !getBaselineSweepTarget(pPict))
	{
		for (const tmpField of Object.keys(tmpSanitized))
		{
			tmpBehaviors.addComprehensionEntity(pContext, pEntity, pGUID, tmpField, tmpSanitized[tmpField]);
		}
		return true;
	}
	tmpBucket[pGUID] = tmpSanitized;
	return true;
}

/**
 * Mint a tombstone: the minimal record the server-side pre-pass needs to resolve the row by GUID
 * and delete it. The safety property is the ORDERING on the apply path, not the adapter:
 * `applyComprehensionSubtree` runs `partitionTombstones` first and splits every `Deleted`-carrying
 * record out of the upsert subtree, so this leaf never reaches the adapter as an update. The
 * adapter itself does NOT strip `Deleted` -- it honours it as a delete, and `PerformDeletes`
 * defaults on -- so a tombstone routed anywhere that skips the partition pass still deletes.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {boolean} - True when the tombstone was written.
 */
function writeTombstone(pPict, pContext, pEntity, pGUID)
{
	const tmpRecord = { Deleted: 1 };
	tmpRecord[`GUID${pEntity}`] = pGUID;
	return writeRecord(pPict, pContext, pEntity, pGUID, tmpRecord);
}

/**
 * Whether a record is known to exist server-side, so a tombstone for it cannot delete a phantom.
 * Evidence, in order: a server-assigned `ID<Entity>` on the record itself; the legacy root ledger
 * a `FormEntityCreator`-era save left behind; a leaf a prior scoped save wrote under this context.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context the record is emitted under.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} [pRecord] - (optional) The in-memory record.
 * @return {boolean} - True when the record has been persisted.
 */
function isPersistedGUID(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pGUID)
	{
		return false;
	}
	if (pRecord && typeof pRecord === 'object' && pRecord[`ID${pEntity}`])
	{
		return true;
	}
	// A save folds every record it emitted into the baseline. Offline that is the only evidence there
	// is: no response comes back, so no row id is ever written onto the record, and the delta prune
	// takes the leaf out of the tree as soon as a later save finds it unchanged.
	if (pPict && pPict.manifest && typeof pPict.manifest.getValueAtAddress === 'function')
	{
		const tmpBaseline = pPict.manifest.getValueAtAddress(pPict, ENTITY_DATA_BASELINE_ADDRESS);
		const tmpBaselineContext = (tmpBaseline && typeof tmpBaseline === 'object') ? tmpBaseline[pContext || DEFAULT_CONTEXT] : null;
		const tmpBaselineBucket = (tmpBaselineContext && typeof tmpBaselineContext === 'object') ? tmpBaselineContext[pEntity] : null;
		if (tmpBaselineBucket && typeof tmpBaselineBucket === 'object' && tmpBaselineBucket[pGUID])
		{
			return true;
		}
	}
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return false;
	}
	const tmpRootBucket = tmpDestination[pEntity];
	if (tmpRootBucket && typeof tmpRootBucket === 'object' && tmpRootBucket[pGUID])
	{
		return true;
	}
	let tmpCursor = tmpDestination;
	for (const tmpPart of String(pContext || DEFAULT_CONTEXT).split('.'))
	{
		if (tmpPart.length < 1)
		{
			continue;
		}
		tmpCursor = tmpCursor[tmpPart];
		if (!tmpCursor || typeof tmpCursor !== 'object')
		{
			return false;
		}
	}
	const tmpScopedBucket = tmpCursor[pEntity];
	return !!(tmpScopedBucket && typeof tmpScopedBucket === 'object' && tmpScopedBucket[pGUID]);
}

/**
 * The document record the form is editing. `DOCUMENT_ENTITY_DATA_ADDRESS` is this plus `.EntityData`.
 */
const DOCUMENT_RECORD_ADDRESS = 'AppData.DocumentData.ReportData';

/**
 * Where the delta baseline rides. Inside `FormData` so it survives an offline save and reload;
 * `_EntityDataBaseline` owns the contents and reads the address from here so there is one of it.
 */
const ENTITY_DATA_BASELINE_ADDRESS = `${DOCUMENT_RECORD_ADDRESS}.FormData.__EntityDataBaseline`;

/**
 * The pict-level counter marking a PROGRAMMATIC value write — a load, an adoption, a cascade — as
 * opposed to a user edit. It is deliberately the same name the autofill-scope vet already suppresses
 * on, so a load driven by either input family is seen as a load by both.
 */
const PROGRAMMATIC_LOAD_MARKER = '_MaterialsEntityHydrationDepth';

/**
 * Mark the start of a programmatic value write. `pict-section-form`'s `setDataByInput` routes
 * straight into `onDataChange`, so a loader that seeds a value is indistinguishable from a user
 * edit at the provider seam — and the removal routes read exactly that seam. Pair with
 * `endProgrammaticLoad` in a `finally`.
 *
 * @param {Object} pPict - The pict instance.
 */
function beginProgrammaticLoad(pPict)
{
	if (pPict && typeof pPict === 'object')
	{
		pPict[PROGRAMMATIC_LOAD_MARKER] = (pPict[PROGRAMMATIC_LOAD_MARKER] || 0) + 1;
	}
}

/**
 * Close a `beginProgrammaticLoad` scope.
 *
 * @param {Object} pPict - The pict instance.
 */
function endProgrammaticLoad(pPict)
{
	if (pPict && typeof pPict === 'object' && pPict[PROGRAMMATIC_LOAD_MARKER] > 0)
	{
		pPict[PROGRAMMATIC_LOAD_MARKER]--;
	}
}

/**
 * Whether a programmatic value write is in flight.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True while a load, adoption or cascade is driving the value.
 */
function isProgrammaticLoad(pPict)
{
	return !!(pPict && typeof pPict === 'object' && pPict[PROGRAMMATIC_LOAD_MARKER]);
}

/**
 * Drop every staged leaf for one record, in every trigger context.
 *
 * A record can be staged under more than one context — a TestInstance saves under `OnSave` while its
 * `TestResult` waits under `OnEnteringState.Approved`. Tombstoning it in one context alone would leave
 * the other leaf to be applied later as an UPSERT, and an upsert creates: the row the user removed
 * would come back at approval time. The approvals path has no owner GUID, so its tombstones are
 * skipped wholesale — leaving the leaf is the only thing that can go wrong there, so it must go.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {number} - How many leaves were dropped.
 */
function dropRecordLeaves(pPict, pEntity, pGUID)
{
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination || !pEntity || !pGUID)
	{
		return 0;
	}
	let tmpDropped = 0;
	forEachContextRoot(tmpDestination, (pContextRoot) =>
	{
		const tmpBucket = pContextRoot[pEntity];
		if (tmpBucket && typeof tmpBucket === 'object' && !Array.isArray(tmpBucket) && Object.prototype.hasOwnProperty.call(tmpBucket, pGUID))
		{
			delete tmpBucket[pGUID];
			tmpDropped++;
		}
	});
	if (tmpDropped > 0)
	{
		scrubEmptyContainers(tmpDestination);
	}
	return tmpDropped;
}

/**
 * Walk every node entity buckets hang from: each trigger context, and the destination root itself,
 * which carries the legacy flat ledger.
 *
 * @param {Record<string, any>} pDestination - The comprehension destination.
 * @param {(pContextRoot: Record<string, any>, pTrigger: string|null, pContextKey: string|null) => void} fCallback - Called per node.
 * @return {void}
 */
function forEachContextRoot(pDestination, fCallback)
{
	if (!pDestination || typeof pDestination !== 'object' || Array.isArray(pDestination))
	{
		return;
	}
	fCallback(pDestination, null, null);
	for (const tmpTrigger of Object.keys(TRIGGER_CONTEXT_DEPTH))
	{
		const tmpTriggerNode = pDestination[tmpTrigger];
		if (!tmpTriggerNode || typeof tmpTriggerNode !== 'object' || Array.isArray(tmpTriggerNode))
		{
			continue;
		}
		if (TRIGGER_CONTEXT_DEPTH[tmpTrigger] === 1)
		{
			fCallback(tmpTriggerNode, tmpTrigger, null);
			continue;
		}
		for (const tmpContextKey of Object.keys(tmpTriggerNode))
		{
			const tmpContextRoot = tmpTriggerNode[tmpContextKey];
			if (tmpContextRoot && typeof tmpContextRoot === 'object' && !Array.isArray(tmpContextRoot))
			{
				fCallback(tmpContextRoot, tmpTrigger, tmpContextKey);
			}
		}
	}
}

/**
 * Drop the containers a removal emptied: an entity bucket holding no records, a context holding no
 * entities, a trigger holding no contexts. An empty bucket applies nothing, but it reads as staged
 * intent to anything that walks the tree, and it rides every save and every sync.
 *
 * The destination root is left alone — its own keys are the triggers, the execution log and the
 * legacy ledger, none of which this may prune.
 *
 * @param {Record<string, any>} pDestination - The comprehension destination.
 * @return {void}
 */
function scrubEmptyContainers(pDestination)
{
	if (!pDestination || typeof pDestination !== 'object' || Array.isArray(pDestination))
	{
		return;
	}
	for (const tmpTrigger of Object.keys(TRIGGER_CONTEXT_DEPTH))
	{
		const tmpTriggerNode = pDestination[tmpTrigger];
		if (!tmpTriggerNode || typeof tmpTriggerNode !== 'object' || Array.isArray(tmpTriggerNode))
		{
			continue;
		}
		const tmpContexts = (TRIGGER_CONTEXT_DEPTH[tmpTrigger] === 1) ? [ [ null, tmpTriggerNode ] ] : Object.entries(tmpTriggerNode);
		for (const [ tmpContextKey, tmpContextRoot ] of tmpContexts)
		{
			if (!tmpContextRoot || typeof tmpContextRoot !== 'object' || Array.isArray(tmpContextRoot))
			{
				continue;
			}
			for (const tmpEntity of Object.keys(tmpContextRoot))
			{
				const tmpBucket = tmpContextRoot[tmpEntity];
				if (tmpBucket && typeof tmpBucket === 'object' && !Array.isArray(tmpBucket) && Object.keys(tmpBucket).length < 1)
				{
					delete tmpContextRoot[tmpEntity];
				}
			}
			if (tmpContextKey !== null && Object.keys(tmpContextRoot).length < 1)
			{
				delete tmpTriggerNode[tmpContextKey];
			}
		}
		if (Object.keys(tmpTriggerNode).length < 1)
		{
			delete pDestination[tmpTrigger];
		}
	}
}

/** Why a removal did not stage a tombstone (or that it did). */
const TOMBSTONE_OUTCOME = Object.freeze(
	{
		Staged: 'staged',
		NoGUID: 'no-guid',
		Unpersisted: 'unpersisted',
		NotOwned: 'not-owned',
	});

/**
 * The rows a selector correlates to its selection, and so the only entity types a removal may delete. Each
 * selector declares its own (see `_collectRemovedDependentRecords`); this set is the assertion that none of
 * them ever hands the gate a reference record such as a Lab, Test or Material.
 */
const DOCUMENT_OWNED_ENTITIES = new Set([ 'TestInstance', 'TestInstanceSampleJoin', 'TestInstanceLabJoin', 'SampleLabJoin', 'SampleLineItemJoin', 'DocumentPolyJoin' ]);

/**
 * Stage a tombstone for a removed record.
 *
 * The record must be one of the rows a selector owns (`DOCUMENT_OWNED_ENTITIES`), and it must have been
 * written (`isPersistedGUID`): tombstoning something the server has never seen asks it to delete a phantom.
 *
 * This is the single entry point every removal route uses, so the Select2 and Picker families cannot
 * drift apart on what "removed" means.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} [pRecord] - (optional) The in-memory record.
 * @return {string} - One of `TOMBSTONE_OUTCOME`.
 */
function writeTombstoneIfDeletable(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pEntity || typeof pGUID !== 'string' || pGUID.length < 1)
	{
		return TOMBSTONE_OUTCOME.NoGUID;
	}
	if (!DOCUMENT_OWNED_ENTITIES.has(pEntity))
	{
		return TOMBSTONE_OUTCOME.NotOwned;
	}
	// Asked before the leaves go, because a leaf a prior save wrote is one of the answers.
	const tmpPersisted = isPersistedGUID(pPict, pContext, pEntity, pGUID, pRecord);
	// The leaves go either way. A record the user removed has no staged intent left, and one staged for
	// a trigger would otherwise upsert the row back the next time the document reaches it.
	dropRecordLeaves(pPict, pEntity, pGUID);
	if (!tmpPersisted)
	{
		return TOMBSTONE_OUTCOME.Unpersisted;
	}
	return writeTombstone(pPict, pContext, pEntity, pGUID) ? TOMBSTONE_OUTCOME.Staged : TOMBSTONE_OUTCOME.NoGUID;
}

/**
 * Stage tombstones for a set of removed records.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {Array<{ Entity: string, Record: Record<string, any> }>} pRemovals - The removed records.
 * @return {{ Staged: Array<string>, Unpersisted: number, Refused: Array<string> }} - What happened, for the caller to log.
 */
function tombstoneRemovedRecords(pPict, pContext, pRemovals)
{
	const tmpResult = { Staged: [ ], Unpersisted: 0, Refused: [ ] };
	if (!Array.isArray(pRemovals))
	{
		return tmpResult;
	}
	for (const tmpRemoval of pRemovals)
	{
		const tmpEntity = tmpRemoval && tmpRemoval.Entity;
		const tmpRecord = tmpRemoval && tmpRemoval.Record;
		if (!tmpEntity || !tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
		{
			continue;
		}
		const tmpGUID = tmpRecord[`GUID${tmpEntity}`];
		const tmpOutcome = writeTombstoneIfDeletable(pPict, pContext, tmpEntity, tmpGUID, tmpRecord);
		if (tmpOutcome === TOMBSTONE_OUTCOME.Staged)
		{
			tmpResult.Staged.push(`${tmpEntity}:${tmpGUID}`);
		}
		else if (tmpOutcome === TOMBSTONE_OUTCOME.Unpersisted)
		{
			tmpResult.Unpersisted++;
		}
		else if (tmpOutcome === TOMBSTONE_OUTCOME.NotOwned)
		{
			tmpResult.Refused.push(`${tmpEntity}:${tmpGUID}`);
		}
	}
	if (tmpResult.Refused.length > 0 && pPict && pPict.log && typeof pPict.log.warn === 'function')
	{
		pPict.log.warn(`ScopedEntityData: refused to delete ${tmpResult.Refused.length} record(s) the document does not own: ${tmpResult.Refused.join(', ')}.`);
	}
	return tmpResult;
}

/**
 * The entity a record names ITSELF as, from its `GUID<Entity>` fields.
 *
 * A record carries its own GUID alongside the GUIDs of the rows it points at — a
 * `TestInstanceSampleJoin` holds `GUIDTestInstanceSampleJoin`, `GUIDTestInstance` and `GUIDSample`.
 * The self field is the LONGEST such name: a join's entity name is built by concatenating the names
 * of what it joins, so it is always a superstring of the references beside it. `GUIDDocument` is
 * never a self field on these records, and a `_Dest_GUID<X>` sibling marks `GUID<X>` as a foreign-key
 * redirect rather than an identity.
 *
 * @param {Record<string, any>} pRecord - The candidate record.
 * @return {string} - The entity name, or '' when the object is not an entity record.
 */
function resolveRecordEntity(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return '';
	}
	let tmpEntity = '';
	for (const tmpField of Object.keys(pRecord))
	{
		if (!tmpField.startsWith('GUID') || tmpField.length < 5)
		{
			continue;
		}
		const tmpCandidate = tmpField.substring(4);
		if (tmpCandidate === 'Document' || Object.prototype.hasOwnProperty.call(pRecord, `_Dest_GUID${tmpCandidate}`))
		{
			continue;
		}
		if (typeof pRecord[tmpField] !== 'string' || pRecord[tmpField].length < 1)
		{
			continue;
		}
		if (tmpCandidate.length > tmpEntity.length)
		{
			tmpEntity = tmpCandidate;
		}
	}
	return tmpEntity;
}

/** The slots of a Test selection's triple that hold rows it owns, and the entity each holds. */
const TEST_INSTANCE_UNIT_SLOTS = [ [ 'TestInstance', 'TestInstance' ], [ 'TestInstanceSampleJoin', 'TestInstanceSampleJoin' ], [ 'DocumentPolyJoin', 'DocumentPolyJoin' ], [ '_TestInstanceLabJoin', 'TestInstanceLabJoin' ] ];

/**
 * The rows a Test selection owns: its TestInstance, the instance's sample join, the document's link to it, and the
 * per-test lab picker's lab join. Read from the triple's own slots, never by walking it, so the reference records
 * its pickers display (`IDLab__Record`, the Test) can never be taken for one of its rows.
 *
 * @param {Record<string, any>} pTriple - A `{ TestInstance, TestInstanceSampleJoin, DocumentPolyJoin, _TestInstanceLabJoin }` triple.
 * @return {Array<{ Entity: string, Record: Record<string, any> }>} - The owned rows the triple holds.
 */
function collectTestInstanceUnit(pTriple)
{
	const tmpUnit = [ ];
	if (!pTriple || typeof pTriple !== 'object' || Array.isArray(pTriple))
	{
		return tmpUnit;
	}
	for (const [ tmpSlot, tmpEntity ] of TEST_INSTANCE_UNIT_SLOTS)
	{
		const tmpRecord = pTriple[tmpSlot];
		if (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord))
		{
			tmpUnit.push({ Entity: tmpEntity, Record: tmpRecord });
		}
	}
	return tmpUnit;
}

/**
 * The rows the selectors in one table row own, asked of each selector rather than read off the row: the row also
 * holds the reference records its pickers display, and those are never a row delete's to remove.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pView - The dynamic-form view owning the row.
 * @param {Record<string, any>} pGroup - The tabular group descriptor.
 * @param {number|string} pRowIndex - The row about to be deleted.
 * @return {Array<{ Entity: string, Record: Record<string, any> }>} - Every selector's owned rows.
 */
function collectRowSelectorRemovals(pPict, pView, pGroup, pRowIndex)
{
	const tmpRemovals = [ ];
	const tmpDescriptors = (pGroup && pGroup.supportingManifest && pGroup.supportingManifest.elementDescriptors) || { };
	if (!pView || typeof pView.getInputProviderList !== 'function')
	{
		return tmpRemovals;
	}
	for (const tmpInput of Object.values(tmpDescriptors))
	{
		for (const tmpProviderHash of pView.getInputProviderList(tmpInput) || [ ])
		{
			const tmpProvider = pPict && pPict.providers && pPict.providers[tmpProviderHash];
			if (tmpProvider && typeof tmpProvider._collectRemovedDependentRecords === 'function')
			{
				tmpRemovals.push(...tmpProvider._collectRemovedDependentRecords(pView, tmpInput, pRowIndex, new Set()));
			}
		}
	}
	return tmpRemovals;
}

/**
 * A persisted TestInstance as a Test selector adopts it on open, in the shape its triple builder later produces
 * (the project filled from the document when the row lacks one), so a load baseline taken before the builder runs
 * already matches what the first save projects.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>} pRow - The TestInstance row as the server returned it.
 * @return {Record<string, any>} - The adopted TestInstance record.
 */
function adoptTestInstance(pPict, pRow)
{
	const tmpInstance = { IDTestInstance: pRow.IDTestInstance, GUIDTestInstance: pRow.GUIDTestInstance, IDTest: pRow.IDTest, IDLab: pRow.IDLab, Name: pRow.Name };
	const tmpIDProject = (Number(pRow.IDProject) > 0) ? pRow.IDProject : pPict?.AppData?.DocumentData?.ReportData?.IDProject;
	if (Number(tmpIDProject) > 0)
	{
		tmpInstance.IDProject = tmpIDProject;
	}
	return tmpInstance;
}

/**
 * Split a TestInstance into the part that saves now and the TestResult that must wait for the
 * approval action. A test result is a reviewed outcome: it must not reach the row when the
 * document is merely saved. Shared by both Test inputs so the Select2 and Picker families cannot
 * disagree on result timing.
 *
 * @param {Record<string, any>} pTestInstance - The TestInstance record.
 * @return {{ Record: Record<string, any>, TestResult: any }} - The save-time record and the held-back result (undefined when there is none to defer).
 */
function splitDeferredTestResult(pTestInstance)
{
	if (!pTestInstance || typeof pTestInstance !== 'object' || !Object.prototype.hasOwnProperty.call(pTestInstance, 'TestResult'))
	{
		return { Record: pTestInstance, TestResult: undefined };
	}
	const tmpProjected = Object.assign({ }, pTestInstance);
	const tmpTestResult = tmpProjected.TestResult;
	delete tmpProjected.TestResult;
	if (tmpTestResult == null || tmpTestResult === '')
	{
		return { Record: tmpProjected, TestResult: undefined };
	}
	return { Record: tmpProjected, TestResult: tmpTestResult };
}

/**
 * Whether a deferred context is one a trigger can find again.
 *
 * It must name a trigger and exactly one action or status (`OnEnteringState.Approved`). The parts are
 * split on `.` here and the server looks the status up as a single key, so a status that contains one
 * would nest into a branch nothing reads.
 *
 * @param {Object} pPict - The pict instance, for the log line.
 * @param {string} pContext - The candidate context.
 * @return {string} - The context, or '' when it may not be used.
 */
function validateDeferredContext(pPict, pContext)
{
	const tmpParts = String(pContext || '').split('.').filter((pPart) => pPart.length > 0);
	if (tmpParts.length === 2 && DEFERRED_TRIGGERS.indexOf(tmpParts[0]) >= 0)
	{
		return tmpParts.join('.');
	}
	if (pPict && pPict.log && typeof pPict.log.warn === 'function')
	{
		pPict.log.warn(`ScopedEntityData: [${pContext}] is not a usable deferred context — it must name a trigger (${DEFERRED_TRIGGERS.join(' / ')}) and one action or status, with no dot inside it.`);
	}
	return '';
}

/**
 * Resolve the context a DEFERRED value (today: a TestInstance's TestResult) is applied under.
 * `PictForm.DeferredComprehensionContext` selects it; the default stages it for the approval
 * action, which is where a reviewed outcome belongs.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {string} [pDefaultContext] - The provider's default when the input declares none.
 * @return {string} - The comprehension context, or '' when neither the configured nor the default one is usable.
 */
function resolveDeferredContext(pInput, pDefaultContext)
{
	const tmpConfigured = pInput && pInput.PictForm && pInput.PictForm.DeferredComprehensionContext;
	if (typeof tmpConfigured === 'string' && tmpConfigured.length > 0)
	{
		return validateDeferredContext(pInput, tmpConfigured);
	}
	return validateDeferredContext(pInput, pDefaultContext || DEFAULT_DEFERRED_CONTEXT);
}

/**
 * Stage one field of a record for a workflow trigger to apply, at the moment the user changed it.
 *
 * The leaf is the form's standing intent for that field: the server copies it onto the row when the
 * document reaches the trigger and leaves it in place for the next time it does. It is written here,
 * at the edit, rather than re-derived on every save sweep — which is what makes a cleared value stage
 * as a clear, and what keeps a save where the user touched nothing from re-asserting it.
 *
 * A cleared value stages as a clear rather than dropping the leaf: no result is a valid outcome to
 * push, and dropping it would leave a previously applied result standing on the row.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The dotted trigger context, e.g. `OnEnteringState.Approved`.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {string} pField - The column being staged.
 * @param {any} pValue - The value the trigger should apply; `''` for a cleared one.
 * @return {boolean} - True when the value was staged.
 */
function stageDeferredValue(pPict, pContext, pEntity, pGUID, pField, pValue)
{
	if (!pEntity || !pField || typeof pGUID !== 'string' || pGUID.length < 1)
	{
		return false;
	}
	if (isProgrammaticLoad(pPict))
	{
		return false;
	}
	const tmpContext = validateDeferredContext(pPict, pContext);
	if (!tmpContext)
	{
		return false;
	}
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return false;
	}
	const tmpBucket = resolveEntityBucket(tmpDestination, tmpContext, pEntity);
	const tmpExisting = (tmpBucket[pGUID] && typeof tmpBucket[pGUID] === 'object' && !Array.isArray(tmpBucket[pGUID])) ? tmpBucket[pGUID] : { };
	const tmpRecord = Object.assign({ }, tmpExisting);
	tmpRecord[`GUID${pEntity}`] = pGUID;
	tmpRecord[pField] = (pValue === null || typeof pValue === 'undefined') ? '' : pValue;
	if (!writeRecord(pPict, tmpContext, pEntity, pGUID, tmpRecord))
	{
		return false;
	}
	dropSupersededDeferredLeaf(pPict, tmpDestination, tmpContext, pEntity, pGUID);
	return true;
}

/**
 * Take a record's leaf out of the deprecated deferred trigger once it is staged under another one.
 *
 * A document that carries both applies the deprecated leaf on every approval ACTION and the current
 * one when the document enters the state — two writes from one intent, the earlier of them at the
 * wrong moment. The form that just staged the value owns it, so the old copy goes with it.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>} pDestination - The comprehension destination.
 * @param {string} pContext - The context just staged under.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {number} - How many superseded leaves were dropped.
 */
function dropSupersededDeferredLeaf(pPict, pDestination, pContext, pEntity, pGUID)
{
	if (String(pContext).split('.')[0] === LEGACY_DEFERRED_TRIGGER)
	{
		return 0;
	}
	const tmpLegacyRoot = pDestination[LEGACY_DEFERRED_TRIGGER];
	if (!tmpLegacyRoot || typeof tmpLegacyRoot !== 'object' || Array.isArray(tmpLegacyRoot))
	{
		return 0;
	}
	let tmpDropped = 0;
	for (const tmpKey of Object.keys(tmpLegacyRoot))
	{
		const tmpBucket = tmpLegacyRoot[tmpKey] && tmpLegacyRoot[tmpKey][pEntity];
		if (tmpBucket && typeof tmpBucket === 'object' && !Array.isArray(tmpBucket) && Object.prototype.hasOwnProperty.call(tmpBucket, pGUID))
		{
			delete tmpBucket[pGUID];
			tmpDropped++;
		}
	}
	if (tmpDropped > 0)
	{
		scrubEmptyContainers(pDestination);
		if (pPict && pPict.log && typeof pPict.log.info === 'function')
		{
			pPict.log.info(`ScopedEntityData: moved ${pEntity} ${pGUID} off the deprecated ${LEGACY_DEFERRED_TRIGGER} trigger and onto ${pContext}.`);
		}
	}
	return tmpDropped;
}

/**
 * Project a TestInstance into a save-time comprehension target with its TestResult held back.
 *
 * A test result is a reviewed outcome: it must not reach the TestInstance row when the document is
 * merely saved, only when the workflow reaches the trigger it was staged for. Everything else on the
 * record still saves normally, so the row (and its joins) are created on save as before.
 *
 * The result itself is staged by `stageDeferredValue` at the moment the user sets it. A sweep can only
 * write what the form holds, which cannot tell a result the user cleared from one that was never
 * entered, and would re-assert a standing leaf on every save the document makes.
 *
 * Shared by both Test inputs (the Select2 `MaterialsTestSelector` and the PSP
 * `MaterialsTestPicker`) so the two families cannot disagree on when a result reaches the row.
 *
 * @param {Record<string, any>} pTestInstance - The TestInstance record.
 * @param {Record<string, any>} pTargetEntityData - The save-time `<Entity>.<GUID>` target.
 * @return {boolean} - False when the record could not be projected (the caller warns).
 */
function projectTestInstanceDeferringResult(pTestInstance, pTargetEntityData)
{
	const tmpGUID = pTestInstance && pTestInstance.GUIDTestInstance;
	if (!tmpGUID || !pTargetEntityData || typeof pTargetEntityData !== 'object' || Array.isArray(pTargetEntityData))
	{
		return false;
	}
	if (!pTargetEntityData.TestInstance || typeof pTargetEntityData.TestInstance !== 'object' || Array.isArray(pTargetEntityData.TestInstance))
	{
		pTargetEntityData.TestInstance = { };
	}
	pTargetEntityData.TestInstance[tmpGUID] = splitDeferredTestResult(pTestInstance).Record;
	return true;
}

/**
 * Whether a row's `Deleted` column marks it soft-deleted.
 *
 * @param {any} pValue - The `Deleted` value as a read returned it.
 * @return {boolean} - True when set.
 */
function isSoftDeletedFlag(pValue)
{
	return pValue === 1 || pValue === true || pValue === '1' || pValue === 'true';
}

/**
 * Which held joins name a row that exists and is soft-deleted, and the selection left without them.
 *
 * Only positive evidence drops a join: its GUID read back with `includeDeleted`, and every row that came
 * back deleted. A live row, a missing row or a failed read keeps the join. A selected value is removed
 * only when no kept join still carries it.
 *
 * The joins are read once, when the call is made, and never modified. They can change while the reads
 * are in flight, so a caller that writes the outcome back applies `DeletedValues` to the joins and value
 * it holds at that point (`applySoftDeletedDrop`) instead of writing `Joins` and `Value`.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The join entity, e.g. `SampleLineItemJoin`.
 * @param {string} pValueField - The column the selection lists, e.g. `IDLineItem`.
 * @param {Array<Record<string, any>>} pJoins - The held joins.
 * @param {any} pValue - The current selection value (comma-separated ids).
 * @param {(pResult: { Dropped: Array<string>, DeletedValues: Record<string, string>, Checked: Array<string>, Joins: Array<Record<string, any>>, Value: string }) => void} fCallback - Called once.
 *   `Dropped` lists the deleted GUIDs, `DeletedValues` maps each to the `pValueField` its row held,
 *   `Checked` lists the GUIDs read, and `Joins` / `Value` are the call-time joins and value with the drop applied.
 */
function resolveSoftDeletedJoins(pPict, pEntity, pValueField, pJoins, pValue, fCallback)
{
	const tmpGUIDField = `GUID${pEntity}`;
	const tmpJoins = Array.isArray(pJoins) ? pJoins.slice() : [ ];
	const tmpValue = (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue);
	const tmpCandidates = tmpJoins.filter((pJoin) => pJoin && typeof pJoin[tmpGUIDField] === 'string' && pJoin[tmpGUIDField].length > 0);
	const tmpChecked = tmpCandidates.map((pJoin) => pJoin[tmpGUIDField]);
	const tmpRestClient = pPict && pPict.HeadlightRestClient;
	const fUnchanged = (pChecked) => fCallback({ Dropped: [ ], DeletedValues: { }, Checked: pChecked, Joins: tmpJoins, Value: tmpValue });
	if (tmpCandidates.length < 1 || !tmpRestClient || typeof tmpRestClient.getJSON !== 'function')
	{
		return fUnchanged([ ]);
	}
	/** @type {Record<string, string>} */
	const tmpDeletedValues = { };
	let tmpRemaining = tmpCandidates.length;
	const fSettle = () =>
	{
		--tmpRemaining;
		if (tmpRemaining > 0)
		{
			return;
		}
		const tmpDropped = Object.keys(tmpDeletedValues);
		if (tmpDropped.length < 1)
		{
			return fUnchanged(tmpChecked);
		}
		const tmpApplied = applySoftDeletedDrop(pEntity, pValueField, tmpJoins, tmpValue, { DeletedValues: tmpDeletedValues, Checked: tmpChecked });
		return fCallback({ Dropped: tmpDropped, DeletedValues: tmpDeletedValues, Checked: tmpChecked, Joins: tmpApplied.Joins, Value: tmpApplied.Value });
	};
	for (const tmpJoin of tmpCandidates)
	{
		const tmpGUID = tmpJoin[tmpGUIDField];
		try
		{
			tmpRestClient.getJSON(`${pEntity}s/FilteredTo/FBV~${tmpGUIDField}~EQ~${encodeURIComponent(tmpGUID)}/0/5?includeDeleted=true`, (pError, pRows) =>
			{
				if (!pError && Array.isArray(pRows) && pRows.length > 0 && pRows.every((pRow) => pRow && isSoftDeletedFlag(pRow.Deleted)))
				{
					const tmpRowValue = pRows.map((pRow) => pRow[pValueField]).find((pRowValue) => pRowValue !== null && typeof pRowValue !== 'undefined' && pRowValue !== '');
					tmpDeletedValues[tmpGUID] = String(tmpRowValue ?? tmpJoin[pValueField] ?? '');
				}
				fSettle();
			});
		}
		catch (pError)
		{
			fSettle();
		}
	}
}

/**
 * A soft-delete drop (`resolveSoftDeletedJoins`) applied to the joins and selection an input holds now.
 *
 * A join goes when its GUID was read back deleted, or when it has no row id, was not among the joins read,
 * and lists a value a deleted row held: the same link minted again under another GUID while the reads were
 * in flight, which no user action asked for. A join with a row id, or one read back live, stays. A value
 * goes when a deleted row held it and no kept join lists it. Once applied, applying it again changes nothing.
 *
 * @param {string} pEntity - The join entity, e.g. `SampleLineItemJoin`.
 * @param {string} pValueField - The column the selection lists, e.g. `IDLineItem`.
 * @param {any} pJoins - The joins held now.
 * @param {any} pValue - The selection value held now (comma-separated ids).
 * @param {{ DeletedValues: Record<string, string>, Checked?: Array<string> }} pResolved - From
 *   `resolveSoftDeletedJoins`: per deleted GUID the `pValueField` its row held, and the GUIDs that were read.
 * @return {{ Changed: boolean, ValueChanged: boolean, Removed: Array<string>, Joins: Array<Record<string, any>>, Value: string }}
 *   `Removed` lists the GUIDs of the joins taken out. When nothing changes, `Joins` is `pJoins` itself (or
 *   `[ ]`) and `Value` is `pValue` as a string.
 */
function applySoftDeletedDrop(pEntity, pValueField, pJoins, pValue, pResolved)
{
	const tmpGUIDField = `GUID${pEntity}`;
	const tmpIDField = `ID${pEntity}`;
	const tmpDeletedValueMap = (pResolved && pResolved.DeletedValues) || { };
	const tmpDeletedGUIDs = new Set(Object.keys(tmpDeletedValueMap));
	const tmpDeletedValues = new Set(Object.values(tmpDeletedValueMap).map(String).filter((pEntry) => pEntry.length > 0));
	const tmpChecked = new Set((pResolved && Array.isArray(pResolved.Checked)) ? pResolved.Checked : [ ]);
	const tmpJoins = Array.isArray(pJoins) ? pJoins : [ ];
	const tmpValue = Array.isArray(pValue) ? pValue.join(',') : String(pValue ?? '');
	const isReminted = (pJoin) => !tmpChecked.has(pJoin[tmpGUIDField]) && !(Number(pJoin[tmpIDField]) > 0) && tmpDeletedValues.has(String(pJoin[pValueField]));
	const isDropped = (pJoin) => !!(pJoin && typeof pJoin === 'object') && (tmpDeletedGUIDs.has(pJoin[tmpGUIDField]) || isReminted(pJoin));
	const tmpKept = tmpJoins.filter((pJoin) => !isDropped(pJoin));
	const tmpRemoved = tmpJoins.filter(isDropped).map((pJoin) => pJoin[tmpGUIDField]);
	const tmpKeptValues = new Set(tmpKept.map((pJoin) => String(pJoin && pJoin[pValueField])));
	const tmpParts = tmpValue.split(',').map((pPart) => pPart.trim()).filter((pPart) => pPart.length > 0);
	const tmpNextParts = tmpParts.filter((pPart) => !tmpDeletedValues.has(pPart) || tmpKeptValues.has(pPart));
	const tmpValueChanged = tmpNextParts.length !== tmpParts.length;
	if (tmpRemoved.length < 1 && !tmpValueChanged)
	{
		return { Changed: false, ValueChanged: false, Removed: [ ], Joins: tmpJoins, Value: tmpValue };
	}
	return { Changed: true, ValueChanged: tmpValueChanged, Removed: tmpRemoved, Joins: tmpKept, Value: tmpValueChanged ? tmpNextParts.join(',') : tmpValue };
}

/**
 * The held records an input may keep once its selection has narrowed: those whose `pValueField` is
 * still listed in `pValue`. The records back the value (an autofill can re-derive the value from them),
 * so a record left behind for a value that was dropped puts that value back.
 *
 * @param {any} pRecords - The held records: an array for a Multiple input, else a single record.
 * @param {string} pValueField - The field the selection lists, e.g. `IDLineItem`.
 * @param {any} pValue - The selection value (comma-separated ids).
 * @return {any} - The kept records, in the same shape; a dropped single record becomes `{ }`. When nothing
 *   is removed the very same value comes back, so a caller can skip the write.
 */
function pruneRecordsToValue(pRecords, pValueField, pValue)
{
	const tmpKept = new Set(String(pValue ?? '').split(',').map((pPart) => pPart.trim()).filter((pPart) => pPart.length > 0));
	const isKept = (pRecord) => !!(pRecord && typeof pRecord === 'object' && tmpKept.has(String(pRecord[pValueField])));
	if (Array.isArray(pRecords))
	{
		const tmpFiltered = pRecords.filter(isKept);
		return (tmpFiltered.length === pRecords.length) ? pRecords : tmpFiltered;
	}
	if (pRecords && typeof pRecords === 'object')
	{
		return isKept(pRecords) ? pRecords : { };
	}
	return pRecords;
}

/**
 * Whether a record names a sample, by server id or by the GUID of one the same save creates. Answers
 * for a selected sample and for a join that hangs from one alike.
 *
 * @param {any} pRecord - The sample, or a join carrying `IDSample` / `GUIDSample`.
 * @return {boolean} - True when a sample is named.
 */
function referencesSample(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	if (Number(pRecord.IDSample) > 0)
	{
		return true;
	}
	return (typeof pRecord.GUIDSample === 'string' && pRecord.GUIDSample.length > 0);
}

/**
 * @param {any} pValue - The value to test.
 * @return {boolean} - True for a string with something other than whitespace in it.
 */
function isNonEmptyString(pValue)
{
	return (typeof pValue === 'string' && pValue.trim().length > 0);
}

/**
 * Why a projected leaf must not ship, or '' when it may.
 *
 * The applier stamps the key onto the record as its `GUID<Entity>`, so a leaf keyed by no usable GUID
 * is inserted as a row nothing can address again. A `DocumentPolyJoin` with no `RemoteType`, or with
 * nothing naming the record it joins, is inserted as a row with no parent. A tombstone carries only its
 * GUID and the delete, so the parent rule does not apply to one.
 *
 * @param {string} pEntity - The entity bucket the leaf sits in.
 * @param {string} pGUID - The key the leaf sits under.
 * @param {Record<string, any>} pRecord - The leaf.
 * @return {string} - The reason, or '' when the leaf may be emitted.
 */
function getUnemittableReason(pEntity, pGUID, pRecord)
{
	if (!isNonEmptyString(pGUID) || pGUID === 'undefined' || pGUID === 'null')
	{
		return `it is keyed by '${pGUID}'`;
	}
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return '';
	}
	if (pEntity !== 'DocumentPolyJoin' || isSoftDeletedFlag(pRecord.Deleted))
	{
		return '';
	}
	const tmpRemoteType = pRecord.RemoteType;
	if (!isNonEmptyString(tmpRemoteType))
	{
		return 'it has no RemoteType';
	}
	if (Number(pRecord.IDRemote) > 0)
	{
		return '';
	}
	if (pRecord[`_Dest_GUID${tmpRemoteType}`] && isNonEmptyString(pRecord[`GUID${tmpRemoteType}`]))
	{
		return '';
	}
	if (pRecord[`_Dest__GUID${tmpRemoteType}`] && isNonEmptyString(pRecord[`_GUID${tmpRemoteType}`]))
	{
		return '';
	}
	return `it names no ${tmpRemoteType} to join`;
}

module.exports =
{
	DEFAULT_CONTEXT,
	DEFAULT_DEFERRED_CONTEXT,
	TRIGGER_CONTEXT_DEPTH,
	DEFERRED_TRIGGERS,
	LEGACY_DEFERRED_TRIGGER,
	DOCUMENT_ENTITY_DATA_ADDRESS,
	DOCUMENT_RECORD_ADDRESS,
	ENTITY_DATA_BASELINE_ADDRESS,
	validateDeferredContext,
	stageDeferredValue,
	forEachContextRoot,
	scrubEmptyContainers,
	TOMBSTONE_OUTCOME,
	DOCUMENT_OWNED_ENTITIES,
	readFlagValue,
	isEnabled,
	ACTIVE_MARKER,
	markActive,
	isMarkedActive,
	noteProjectionRoot,
	takeNotedProjectionRoots,
	resolveContext,
	resolveDeferredContext,
	isTransientFormField,
	sanitizeRecord,
	isUnresolvedIdentityField,
	resolveDestination,
	resolveContextRoot,
	resolveEntityBucket,
	sanitizeContextRoot,
	BASELINE_SWEEP_MARKER,
	beginBaselineSweep,
	getBaselineSweepTarget,
	endBaselineSweep,
	writeRecord,
	writeTombstone,
	writeTombstoneIfDeletable,
	tombstoneRemovedRecords,
	dropRecordLeaves,
	isPersistedGUID,
	resolveRecordEntity,
	collectTestInstanceUnit,
	collectRowSelectorRemovals,
	adoptTestInstance,
	resolveSoftDeletedJoins,
	applySoftDeletedDrop,
	pruneRecordsToValue,
	beginProgrammaticLoad,
	endProgrammaticLoad,
	isProgrammaticLoad,
	splitDeferredTestResult,
	projectTestInstanceDeferringResult,
	referencesSample,
	getUnemittableReason,
};

},{}],140:[function(require,module,exports){
/**
 * One read per URL for idempotent entity GETs issued by many inputs at once.
 *
 * A form load marshals every input several times, and every marshal re-resolves the records its inputs
 * display, so the same `<Entity>s/FilteredTo/...` URL is requested by dozens of inputs within a few
 * milliseconds. Two layers keep that to one request:
 *
 *   - In flight: a caller asking for a URL that is already being fetched waits on that request.
 *     Always on - callers issuing the same GET at the same moment would receive the same rows anyway.
 *   - Result reuse (opt-in, `ReuseResult`): a non-empty response is kept for RESULT_TTL_MS and handed
 *     to later callers. Empty responses and errors are never kept, so a record created mid-session is
 *     found on the next read.
 *
 * Every caller receives its own copy of the rows: callers write fetched records straight into form data.
 * `invalidate` drops both layers (a request already in flight still answers its own waiters); the save
 * lifecycle calls it so nothing read before a save is served after it.
 *
 * State is per pict instance.
 *
 * @module _SharedEntityRead
 */

/** Matches pict's EntityProvider record cache (Pict-Meadow-EntityProvider.js initializeCache). */
const RESULT_TTL_MS = 30000;

/**
 * @typedef {Object} SharedReadEntry
 * @property {Array<(pError: any, pBody?: any) => void>} Waiters
 * @property {number} Generation
 */

/**
 * @typedef {Object} SharedReadState
 * @property {Map<string, SharedReadEntry>} InFlight
 * @property {Map<string, { Body: any, StoredAt: number }>} Results
 * @property {number} Generation
 */

/** @type {WeakMap<Object, SharedReadState>} */
const _States = new WeakMap();

/**
 * @param {Object} pPict
 * @return {SharedReadState}
 */
function getState(pPict)
{
	let tmpState = _States.get(pPict);
	if (!tmpState)
	{
		tmpState = { InFlight: new Map(), Results: new Map(), Generation: 0 };
		_States.set(pPict, tmpState);
	}
	return tmpState;
}

/**
 * @param {any} pBody
 * @return {any}
 */
function copyBody(pBody)
{
	return (pBody && typeof pBody === 'object') ? JSON.parse(JSON.stringify(pBody)) : pBody;
}

/**
 * GET a URL through `pict.HeadlightRestClient.getJSON`, sharing the request with identical concurrent callers.
 *
 * @param {Object} pPict - The pict instance (owns HeadlightRestClient).
 * @param {string} pURL - The request URL, exactly as it would be passed to getJSON.
 * @param {{ ReuseResult?: boolean }} pOptions - ReuseResult: accept a kept response younger than RESULT_TTL_MS.
 * @param {(pError: any, pBody?: any) => void} fCallback - getJSON-shaped callback; the body is the caller's own copy.
 */
function readJSON(pPict, pURL, pOptions, fCallback)
{
	const tmpState = getState(pPict);
	if (pOptions && pOptions.ReuseResult)
	{
		const tmpKept = tmpState.Results.get(pURL);
		if (tmpKept && (Date.now() - tmpKept.StoredAt) < RESULT_TTL_MS)
		{
			return fCallback(null, copyBody(tmpKept.Body));
		}
	}
	const tmpPending = tmpState.InFlight.get(pURL);
	if (tmpPending)
	{
		tmpPending.Waiters.push(fCallback);
		return;
	}
	/** @type {SharedReadEntry} */
	const tmpEntry = { Waiters: [ fCallback ], Generation: tmpState.Generation };
	tmpState.InFlight.set(pURL, tmpEntry);
	pPict.HeadlightRestClient.getJSON(pURL, (pError, pBody) =>
	{
		if (tmpState.InFlight.get(pURL) === tmpEntry)
		{
			tmpState.InFlight.delete(pURL);
		}
		const tmpHasRows = Array.isArray(pBody) ? pBody.length > 0 : (pBody && typeof pBody === 'object');
		if (!pError && tmpHasRows && tmpEntry.Generation === tmpState.Generation)
		{
			tmpState.Results.set(pURL, { Body: copyBody(pBody), StoredAt: Date.now() });
		}
		for (const fWaiter of tmpEntry.Waiters)
		{
			fWaiter(pError, pError ? pBody : copyBody(pBody));
		}
	});
}

/**
 * Drop kept responses and detach in-flight requests, so every later read goes to the server.
 *
 * @param {Object} pPict - The pict instance.
 */
function invalidate(pPict)
{
	const tmpState = getState(pPict);
	tmpState.Results.clear();
	tmpState.InFlight.clear();
	tmpState.Generation++;
}

/** Meadow's schema default for an unset GUID column; no row is ever looked up by it. */
const PLACEHOLDER_GUID = '0x0000000000000000';

/**
 * Whether an identity value names no record: empty, a database id of 0 (ids start at 1), or the
 * placeholder GUID. A comma list is empty only when every member is.
 *
 * @param {string} pIdentityField - The column the value is matched on (e.g. IDUser, GUIDSample, Hash).
 * @param {any} pValue - The value, or a comma-separated list of values.
 * @return {boolean}
 */
function isEmptyIdentityValue(pIdentityField, pValue)
{
	if (pValue === null || pValue === undefined)
	{
		return true;
	}
	const tmpIsDatabaseID = /^ID[A-Z]/.test(String(pIdentityField || ''));
	const tmpIsGUID = /^GUID[A-Z]/.test(String(pIdentityField || ''));
	return String(pValue).split(',').every((pPart) =>
	{
		const tmpPart = pPart.trim();
		return tmpPart === '' || (tmpIsDatabaseID && Number(tmpPart) === 0) || (tmpIsGUID && tmpPart === PLACEHOLDER_GUID);
	});
}

/**
 * Whether a read by ID returned the record asked for. pict's EntityProvider.getEntity hands the server's error
 * reply (`{ Error, ErrorCode }`) back in the record's place, so a reply without its own `ID<Entity>` is a failed
 * read.
 *
 * @param {string} pEntity - The entity type that was read.
 * @param {any} pRecord - The reply.
 * @return {boolean}
 */
function isEntityRecord(pEntity, pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	const tmpIdentityField = `ID${pEntity}`;
	return !isEmptyIdentityValue(tmpIdentityField, pRecord[tmpIdentityField]);
}

module.exports = { readJSON, invalidate, isEmptyIdentityValue, isEntityRecord, RESULT_TTL_MS };

},{}],141:[function(require,module,exports){
/**
 * R2 port-forward map for the specialized per-entity selectors (LabSelector, PlantSelector, …).
 *
 * Each such InputType hardcodes its Entity (+ search/display config) in its own
 * PictProvider-InputType-<X>Selector provider (via Select2Util.getOptionsAjax), NOT the descriptor.
 * This lifts that config so the broker (Picker) and Read/Print (PickerDisplay) render it as a generic
 * entity Picker with no manifest edit. Compound (PhysicalAsset) + non-standard (ObservationType) excluded.
 * `MaterialsFamily: true` opts an entry into legacy MES behavior: defaults-on-empty (Picker._shouldApplyConfiguredDefault)
 * and a stored 0 painting as unset whatever the DataType (_PickerEmptyValues).
 */
module.exports =
{
	// Plain entity + Name display, single-field search.
	LabSelector: { Entity: 'Lab', TextField: 'Name', Placeholder: 'Select a Lab...' },
	PlantSelector: { Entity: 'ProductionPlant', TextField: 'Name', Placeholder: 'Select a Plant...' },
	ProducerSelector: { Entity: 'Organization', TextField: 'Name', Placeholder: 'Select a Producer...' },
	ProductSelector: { Entity: 'Product', TextField: 'Name', Placeholder: 'Select a Product...' },
	ProjectSelector: { Entity: 'Project', TextField: 'Name', Placeholder: 'Select a Project...' },
	// + EntityTag (the provider's user-facing ID) badge + multi-field search.
	// MaterialSelector is a generic Material picker: top-level materials only until Show All (legacy toggleMaterialFilter).
	// StaticFilters / ShowAllToggle here are descriptor defaults; a descriptor's own value wins.
	// Tag/search = MaterialCode, a DELIBERATE divergence from legacy (which used ItemCode): Doug's call, so a
	// migrated field matches the MaterialsEntitySelector Material pickers on the Test / Sample-creation forms.
	MaterialSelector: { Entity: 'Material', TextField: 'Name', SearchFields: [ 'Name', 'MaterialCode' ], EntityTag: 'MaterialCode', Placeholder: 'Select a Material...',
		StaticFilters: [ { Field: 'IDMaterialParent', Value: '0', BackOff: true } ], ShowAllToggle: true },
	SampleSelector: { Entity: 'Sample', TextField: 'Name', SearchFields: [ 'Name', 'QRCode' ], EntityTag: 'QRCode', Placeholder: 'Select a Sample by name or code...' },
	// DisableProjectFiltering: legacy LineItemSelector never project-scoped (only EntitySelector did).
	LineItemSelector: { Entity: 'LineItem', TextField: 'Name', SearchFields: [ 'ItemCode', 'Name' ], EntityTag: 'ItemCode', Placeholder: 'Select a Line Item by name or code...', DisableProjectFiltering: true },
	// BridgeSelector: never clearable, and scoped to the customer's configured state(s), as its legacy provider was.
	// Labelled by Name with a StructureNumber tag, as legacy was: bridges are named ("3648 | WAITOTARA BRIDGE"),
	// and a blank Name is rare — 0 of 400 across four ID-ordered windows of the 1,039,581-row table. (An
	// earlier pass here mislabelled the field BY StructureNumber on the strength of a sample sorted
	// `FSF~Name~ASC~0`, which puts every blank-named row first; that measured the sort, not the data.)
	BridgeSelector: { Entity: 'Bridge', TextField: 'Name', SearchFields: [ 'StructureNumber', 'Name' ], EntityTag: 'StructureNumber', Placeholder: 'Select a Bridge by name or code...',
		AllowClear: false, CustomerStateFilter: true },
	// MixSpecification tag = Code (the legacy getter read a nonexistent ItemCode -> always N/A). Label =
	// Description, as legacy's selected value and Read/PDF showed ("[Code] Description"); Name is often blank.
	MixSpecificationSelector: { Entity: 'MixSpecification', TextField: 'Description', SearchFields: [ 'Code', 'Description' ], EntityTag: 'Code', Placeholder: 'Select a Mix Specification by code or description...' },
	// MES-family cascade ports (waves 5-9): config here; the cascade/creation/projection logic lives in the
	// matching PictProvider-InputType-Materials*Picker. RecordIdentity carries the non-numeric (GUID/Hash)
	// commit identity to PickerDisplay; Multiple mirrors the Edit providers' default so Read/Print CSV-splits
	// (a descriptor-explicit Multiple still wins).
	MaterialsPlantSelector: { Entity: 'ProductionPlant', TextField: 'Name', Placeholder: 'Select a Plant...', MaterialsFamily: true },
	SampleTypeSelector: { Entity: 'SampleType', TextField: 'Name', Placeholder: 'Select a Sample Type...', MaterialsFamily: true },
	MaterialsSampleSelector: { Entity: 'Sample', TextField: 'Name', SearchFields: [ 'QRCode', 'Name' ], EntityTag: 'QRCode', Placeholder: 'Select a Sample...', MaterialsFamily: true, RecordIdentity: 'GUIDSample' },
	MaterialsTestSelector: { Entity: 'Test', TextField: 'Name', SearchFields: [ 'Hash', 'Name' ], EntityTag: 'Hash', Placeholder: 'Select a Test...', MaterialsFamily: true, RecordIdentity: 'Hash' },
	MaterialsLabSelector: { Entity: 'Lab', TextField: 'Name', Placeholder: 'Select a Lab...', MaterialsFamily: true, Multiple: true },
	// No EntityTag: Read/Print show the name only, as MaterialsLineItemDisplay did; Edit tags on ItemCode through MaterialsLineItemPicker's defaults.
	MaterialsLineItemSelector: { Entity: 'LineItem', TextField: 'Name', SearchFields: [ 'ItemCode', 'Name' ], Placeholder: 'Select a Line Item...', MaterialsFamily: true, Multiple: true },
	MaterialsTestLabSelector: { Entity: 'Lab', TextField: 'Name', Placeholder: 'Select a Lab...', MaterialsFamily: true },
	// No EntityTag: Read/Print show the test name only, as MaterialsTestDisplay did; Edit tags on Hash through MaterialsTestInjectorPicker's
	// default. Sort: Hash keeps the legacy list order (select2 sorted by the provider's SearchFields, Hash first).
	MaterialsTestInjector: { Entity: 'Test', TextField: 'Name', SearchFields: [ 'Hash', 'Name' ], Sort: 'Hash', Placeholder: 'Select a Test to add...', MaterialsFamily: true, RecordIdentity: 'Hash' },
	// The base selector: each descriptor names its own Entity and display config, so the entry carries only the family
	// flag, plus DisableProjectFiltering because the legacy base never project-scoped a LineItem.
	MaterialsEntitySelector: { MaterialsFamily: true, DisableProjectFiltering: true },
};

},{}],142:[function(require,module,exports){
/**
 * The PDF rule shared by both tab InputTypes.
 *
 * Neither Print template emits a tab strip, but the group hosting the selector still renders its
 * wrapper, so every tabbed section reserved an empty band (12-30px depending on width) above its
 * content. The Print templates mark their hidden input; this collapses the group around it -- and
 * the whole section when the tab host is all that section holds.
 *
 * `Pict-Input-TabGroupSelector` and `Pict-Input-TabSectionSelector` extend different pict-section-form
 * providers and share no base class, so a module is what keeps the two in step -- same reasoning as
 * _FilterToggleUI.js.
 *
 * The class name says "group" for the same reason it always did: it shipped that way, and the marker
 * is matched only by the rule below. It covers BOTH tab InputTypes.
 */

/** @type {String} */
const _PrintHostMarkerClass = 'pict-tab-group-print-host';

/**
 * `:only-child` twice -- on the columns row and on the input -- so this collapses a group ONLY when
 * that hidden input is the entire content. A manifest that puts other descriptors alongside the tab
 * selector keeps them. A renderer without `:has()` drops the rule and gets the old spacing back, so
 * this cannot regress a PDF.
 *
 * @type {String}
 */
const _PrintHostGroupCSS = `.pict-form-group:has(> .section-content > .columns:only-child > .${_PrintHostMarkerClass}:only-child) { display: none; }`;

/**
 * Some manifests host the selector in a section of its own -- ProjectTransition's `Tabs` section is
 * nothing but `UI.ActiveTab`. Collapsing the group there leaves the section's own `<h2>` behind, so
 * the PDF gets a heading ("Sections") with nothing under it, which is worse than the blank band.
 *
 * `:only-of-type` on the group is what keeps this narrow: it matches a section whose ONLY group is
 * the tab host. Measured both ways -- ProjectTransition's Tabs section collapses (48px -> 0), and
 * Sample Creation 391's Testing section matches ZERO because it has three groups.
 *
 * @type {String}
 */
const _PrintHostSectionCSS = `.pict-form-section:has(> .pict-form-group:only-of-type > .section-content > .columns:only-child > .${_PrintHostMarkerClass}:only-child) { display: none; }`;

/** @type {String} */
const _PrintHostCSS = `${_PrintHostGroupCSS} ${_PrintHostSectionCSS}`;

/** @type {String} */
const _PrintHostCSSHash = 'Headlight-Input-TabSelector-PrintHost';

/**
 * Register the fragment WITHOUT injecting it.
 *
 * CSSMap.addCSS raises the dirty flag while injectCSS lowers it whether or not a style element
 * exists yet, so injecting at construction can silently drop the fragment. Register early, inject
 * at init. Re-registering under the same hash is harmless, so both providers may call this.
 *
 * @param {Object} pPict - The Pict instance.
 *
 * @return {void}
 */
function registerPrintHostCSS(pPict)
{
	pPict.CSSMap.addCSS(_PrintHostCSSHash, _PrintHostCSS, 1002, 'Pict-Input-TabSelector');
}

/**
 * Inject whatever is registered. Call this ABOVE a provider's non-interactive early return -- the
 * PDF is the one path that needs this rule.
 *
 * @param {Object} pPict - The Pict instance.
 *
 * @return {void}
 */
function injectPrintHostCSS(pPict)
{
	pPict.CSSMap.injectCSS();
}

module.exports = {
	PrintHostMarkerClass: _PrintHostMarkerClass,
	PrintHostCSS: _PrintHostCSS,
	PrintHostGroupCSS: _PrintHostGroupCSS,
	PrintHostSectionCSS: _PrintHostSectionCSS,
	PrintHostCSSHash: _PrintHostCSSHash,
	registerPrintHostCSS,
	injectPrintHostCSS,
};

},{}],143:[function(require,module,exports){
/**
 * The test-result code list, in one place so the Edit and the Read/Print stacks cannot disagree.
 *
 * Test results are NOT a customer-managed vocabulary — there is no TestResult table — so they are a
 * static option array taking the Picker broker's generic (non-entity) select path, rather than an entry
 * in `_VocabularySelectorMap`.
 *
 * Both stacks must stamp it: `SampleTestAcceptance` renders the field in Edit, but `PickerDisplay`
 * renders it in Read and Print, and that provider never runs the acceptance input's initialize hooks.
 * Without the options on the descriptor, the display has nothing to map the stored code through and
 * prints the raw `PEND` instead of `Pending`.
 */

/** @type {Array<{id: string, text: string}>} */
const DEFAULT_TEST_RESULT_OPTIONS =
[
	{ 'id': 'N/A', 'text': 'N/A' },
	{ 'id': 'PROG', 'text': 'In Progress' },
	{ 'id': 'PEND', 'text': 'Pending' },
	{ 'id': 'FAIL', 'text': 'Failed' },
	{ 'id': 'FAIC', 'text': 'Failed with Comments' },
	{ 'id': 'PASS', 'text': 'Passed' },
	{ 'id': 'PASC', 'text': 'Passed with Comments' },
	{ 'id': 'VOID', 'text': 'Voided' },
];

/** InputTypes whose options this module owns. */
const TEST_RESULT_INPUT_TYPES = [ 'SampleTestAcceptance' ];

/**
 * Stamp the default result codes onto an acceptance descriptor. Never overwrites a schema-supplied
 * `SelectOptions`, and leaves every other InputType untouched.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {boolean} [pForce] - Stamp regardless of InputType (the Edit provider knows it owns the field).
 * @return {boolean} - True when this descriptor carries the test-result option set.
 */
function applyTestResultOptions(pInput, pForce)
{
	if (!pInput)
	{
		return false;
	}
	if (!pInput.PictForm)
	{
		pInput.PictForm = {};
	}
	if (!pForce && TEST_RESULT_INPUT_TYPES.indexOf(pInput.PictForm.InputType) < 0)
	{
		return false;
	}
	if (!pInput.PictForm.SelectOptions || !Array.isArray(pInput.PictForm.SelectOptions))
	{
		pInput.PictForm.SelectOptions = DEFAULT_TEST_RESULT_OPTIONS;
	}
	return true;
}

module.exports = { DEFAULT_TEST_RESULT_OPTIONS, TEST_RESULT_INPUT_TYPES, applyTestResultOptions };

},{}],144:[function(require,module,exports){
/**
 * Rendering for markdown a *user* typed -- a remark, a note, a comment -- as opposed to the markdown
 * we author ourselves in a manifest (an Instructions block) or ship in a file.
 *
 * Two differences from a plain `marked.parse()`:
 *
 * - raw HTML in the source is shown as literal text instead of being parsed as markup, so a remark
 *   cannot put a script tag or an event handler into the page of whoever reads it;
 * - links and images are limited to http(s) / mailto / tel / relative targets, and links open in a
 *   new tab so a reader is not navigated away from a form they are part way through filling in.
 *
 * marked does neither on its own: since v5 it has no sanitizer, and its `cleanUrl()` only encodes a
 * URI -- it does not reject `javascript:`.
 *
 * This lives beside the providers (and is deep-required by the web apps the same way
 * `_VocabularySelectorMap.js` is) so every screen that shows a remark renders it identically.
 */
// report_definitions reports/HeadLight-ATM/headlight-document/source/atm-user-markdown.js carries a copy of these rules for the ATM report -- change both together.

const libMarked = require('marked');

/** @type {Record<string, string>} */
const _HTMLEntityMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#039;' };

/** Protocols a user-authored remark is allowed to link to. */
const _SafeLinkProtocolPattern = /^(?:https?:\/\/|mailto:|tel:|\/|\.{1,2}\/|#)/i;

/**
 * Escapes a value for use as HTML text or as an attribute value.
 *
 * @param {any} pValue - the value to escape.
 * @return {String} - the escaped value, or an empty string for null/undefined.
 */
function escapeHTML(pValue)
{
	if ((pValue === null) || (typeof(pValue) === 'undefined'))
	{
		return '';
	}
	return String(pValue).replace(/[&<>"']/g, (pCharacter) => _HTMLEntityMap[pCharacter]);
}

/**
 * Returns the trimmed href when it points somewhere a remark is allowed to point, otherwise null.
 *
 * @param {any} pHref - the href from the markdown source.
 * @return {String|null}
 */
function safeURL(pHref)
{
	const tmpHref = (typeof(pHref) === 'string') ? pHref.trim() : '';
	return _SafeLinkProtocolPattern.test(tmpHref) ? tmpHref : null;
}

// Styling for a rendered remark. Registered with the pict CSS map rather than an app stylesheet so
// every app that loads this provider gets it without a per-app css copy (there are ten copies of
// headlight-panels.css in the tree already).
const RemarksCSS = /*css*/`
.hl-md-remarks.content > :last-child { margin-bottom: 0; }
.hl-md-remarks.content p { margin-bottom: 0.5em; }
.hl-md-remarks.content h1,
.hl-md-remarks.content h2,
.hl-md-remarks.content h3,
.hl-md-remarks.content h4,
.hl-md-remarks.content h5,
.hl-md-remarks.content h6 { font-size: 1.1em; margin-top: 0; margin-bottom: 0.25em; color: inherit; }
.hl-md-remarks.content ul,
.hl-md-remarks.content ol { margin-top: 0.25em; margin-bottom: 0.5em; }
.hl-md-remarks.content table { margin-top: 0.25em; margin-bottom: 0.5em; }
.hl-md-remarks.content img { max-width: 100%; }
/* A remark also sits on dark surfaces (the sample panel), so headings, bold text and quotes take the text color around them rather than Bulma's fixed dark ones. */
.hl-md-remarks.content strong { color: inherit; }
.hl-md-remarks.content blockquote
{
	background-color: transparent;
	color: inherit;
	border-left: 3px solid currentColor;
	border-left-color: color-mix(in srgb, currentColor 35%, transparent);
	padding: 0.25em 0 0.25em 0.75em;
	margin-bottom: 0.5em;
}
.hl-md-remarks-collapse summary { display: block; list-style: none; }
.hl-md-remarks-collapse summary::-webkit-details-marker { display: none; }
.hl-md-remarks-collapse:not([open]) .hl-md-remarks-text
{
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.hl-md-remarks-collapse.is-truncated summary { cursor: pointer; }
.hl-md-remarks-collapse.is-truncated summary::after
{
	content: "Read more";
	display: block;
	margin-top: 0.25em;
	font-size: 0.85em;
	color: var(--bulma-link, #3273dc);
}
.hl-md-remarks-collapse.is-truncated[open] summary::after { content: "Read less"; }
`;

const _CollapseSelector = '.hl-md-remarks-collapse';
const _CollapseTextSelector = '.hl-md-remarks-collapse .hl-md-remarks-text';
/** Set on a collapsible remark whose text runs past the clamp; it is what shows Read more. */
const _TruncatedClass = 'is-truncated';
/** @type {WeakSet<any>} */
const _WatchedDocuments = new WeakSet();

/**
 * Marks a collapsible remark as truncated when its clamped text runs past the clamp, so Read more
 * shows only when there is more to read.
 *
 * @param {any} pCollapse - the `details.hl-md-remarks-collapse` element.
 * @return {Boolean} - whether the remark is marked truncated afterwards.
 */
function updateRemarkTruncation(pCollapse)
{
	if (!pCollapse || !pCollapse.classList)
	{
		return false;
	}
	// An open remark is unclamped and measures as fitting, so it keeps its mark until it closes.
	if (pCollapse.open)
	{
		return pCollapse.classList.contains(_TruncatedClass);
	}
	const tmpText = pCollapse.querySelector('.hl-md-remarks-text');
	// A remark on a tab that isn't showing has no layout yet; it is measured once it gets one.
	if (!tmpText || (tmpText.clientHeight === 0))
	{
		return pCollapse.classList.contains(_TruncatedClass);
	}
	const tmpTruncated = ((tmpText.scrollHeight - tmpText.clientHeight) > 1);
	pCollapse.classList.toggle(_TruncatedClass, tmpTruncated);
	return tmpTruncated;
}

/**
 * The clamped remark text elements in and under a node.
 *
 * @param {any} pNode - a DOM node.
 * @return {Array<any>}
 */
function getRemarkTextElements(pNode)
{
	if (!pNode || (pNode.nodeType !== 1))
	{
		return [];
	}
	const tmpElements = Array.from(pNode.querySelectorAll(_CollapseTextSelector));
	if (pNode.matches(_CollapseTextSelector))
	{
		tmpElements.push(pNode);
	}
	return tmpElements;
}

/**
 * Keeps every collapsible remark in a document marked truncated or not as it renders, resizes or
 * goes from hidden to shown, and stops a click from opening a remark that already fits. Safe to
 * call more than once; does nothing where there is no DOM.
 *
 * @param {any} [pDocument] - the document to watch; defaults to the global one.
 * @return {Boolean} - true when the document is being watched.
 */
function watchRemarksTruncation(pDocument)
{
	const tmpDocument = pDocument || ((typeof(document) !== 'undefined') ? document : null);
	const tmpWindow = tmpDocument ? tmpDocument.defaultView : null;
	if (!tmpWindow || (typeof(tmpWindow.ResizeObserver) !== 'function') || (typeof(tmpWindow.MutationObserver) !== 'function'))
	{
		return false;
	}
	if (_WatchedDocuments.has(tmpDocument))
	{
		return true;
	}
	_WatchedDocuments.add(tmpDocument);

	const tmpResizeObserver = new tmpWindow.ResizeObserver((pEntries) =>
	{
		for (const tmpEntry of pEntries)
		{
			updateRemarkTruncation(tmpEntry.target.closest(_CollapseSelector));
		}
	});
	const tmpMutationObserver = new tmpWindow.MutationObserver((pRecords) =>
	{
		for (const tmpRecord of pRecords)
		{
			for (const tmpNode of Array.from(tmpRecord.removedNodes))
			{
				for (const tmpText of getRemarkTextElements(tmpNode))
				{
					tmpResizeObserver.unobserve(tmpText);
				}
			}
			for (const tmpNode of Array.from(tmpRecord.addedNodes))
			{
				for (const tmpText of getRemarkTextElements(tmpNode))
				{
					tmpResizeObserver.observe(tmpText);
				}
			}
		}
	});
	tmpMutationObserver.observe(tmpDocument.documentElement, { childList: true, subtree: true });
	for (const tmpText of getRemarkTextElements(tmpDocument.documentElement))
	{
		tmpResizeObserver.observe(tmpText);
	}

	tmpDocument.addEventListener('click', (pEvent) =>
	{
		const tmpTarget = pEvent.target;
		if (!tmpTarget || (typeof(tmpTarget.closest) !== 'function') || tmpTarget.closest('a'))
		{
			return;
		}
		const tmpSummary = tmpTarget.closest(`${ _CollapseSelector } > summary`);
		if (tmpSummary && !tmpSummary.parentElement.open && !tmpSummary.parentElement.classList.contains(_TruncatedClass))
		{
			pEvent.preventDefault();
		}
	});
	return true;
}

/** @type {any} Built on first use; marked instances are reusable and stateless across parses. */
let _UserContentMarked = null;
/** So an unusable marked is reported once, not once per remark on the page. */
let _MarkedUnusableReported = false;

/**
 * The hardened marked instance.
 *
 * @return {any}
 */
function getUserContentMarked()
{
	if (_UserContentMarked)
	{
		return _UserContentMarked;
	}
	if (typeof(libMarked.Marked) !== 'function')
	{
		// The Marked class arrived in marked 5, and the renderer overrides below are the object-argument
		// form from marked 13+. An older marked resolves here silently -- it has neither -- and every
		// remark then falls back to its escaped source, which looks like the feature simply not working.
		// marked is a transitive dependency in several places and no lockfile is committed, so the
		// version a build resolves is whatever hoisting produced: say so by name rather than throwing a
		// bare TypeError per remark.
		throw new Error('markdown remarks need marked 13 or newer (no Marked class found on the resolved marked); declare "marked": "^14.1.2" in the package this file resolves from');
	}
	_UserContentMarked = new libMarked.Marked(
		{
			gfm: true,
			// A remark is typed into a textarea or a markdown editor, where pressing Enter means a
			// line break. Sample notes in particular arrive as labelled lines ("Producer Supplier
			// Code: ...\nPlant ID: ..."), which markdown's default paragraph folding would run
			// together into one line -- worse than the raw text it replaces.
			breaks: true,
			renderer:
			{
				// `this` here is marked's renderer, so these have to be function expressions to
				// reach `this.parser`.
				html: function(pToken)
				{
					return escapeHTML(pToken.text);
				},
				link: function(pToken)
				{
					const tmpText = this.parser.parseInline(pToken.tokens);
					const tmpHref = safeURL(pToken.href);
					if (!tmpHref)
					{
						return tmpText;
					}
					const tmpTitle = pToken.title ? ` title="${ escapeHTML(pToken.title) }"` : '';
					return `<a href="${ escapeHTML(tmpHref) }"${ tmpTitle } target="_blank" rel="noopener noreferrer">${ tmpText }</a>`;
				},
				image: function(pToken)
				{
					const tmpHref = safeURL(pToken.href);
					if (!tmpHref)
					{
						return escapeHTML(pToken.text);
					}
					const tmpTitle = pToken.title ? ` title="${ escapeHTML(pToken.title) }"` : '';
					return `<img class="image" src="${ escapeHTML(tmpHref) }" alt="${ escapeHTML(pToken.text) }"${ tmpTitle }>`;
				},
			},
		});
	return _UserContentMarked;
}

/**
 * Converts markdown a user typed to display HTML. Returns an empty string when there is nothing to
 * show; falls back to the escaped source if marked throws, so a malformed remark still reads.
 *
 * @param {any} pMarkdown - the remark source.
 * @param {any} [pLog] - optional fable log to report a parse failure to.
 * @return {String}
 */
function renderUserMarkdown(pMarkdown, pLog)
{
	if ((pMarkdown === null) || (typeof(pMarkdown) === 'undefined') || (pMarkdown === ''))
	{
		return '';
	}
	const tmpMarkdown = (typeof(pMarkdown) === 'string') ? pMarkdown : String(pMarkdown);
	try
	{
		return String(getUserContentMarked().parse(tmpMarkdown));
	}
	catch (pError)
	{
		// Escaped source is a safe degradation -- the remark still reads, just unformatted -- so this
		// never takes a screen down. It is reported once so it is findable in a console full of noise.
		if (pLog && !_MarkedUnusableReported)
		{
			_MarkedUnusableReported = true;
			pLog.error(`Markdown remarks are rendering as plain text: ${pError.message}`, pError);
		}
		return escapeHTML(tmpMarkdown);
	}
}

module.exports = { renderUserMarkdown: renderUserMarkdown, escapeHTML: escapeHTML, safeURL: safeURL, RemarksCSS: RemarksCSS, updateRemarkTruncation: updateRemarkTruncation, watchRemarksTruncation: watchRemarksTruncation };

},{"marked":442}],145:[function(require,module,exports){
/**
 * Managed-vocabulary map for the specialized code-list selectors (SampleStatusSelector, …).
 *
 * A vocabulary is a small, customer-curated code list stored in its own table, whose CODE (not its
 * database id) is what the referencing record persists — `Sample.Status` holds `'PASS'`, not an
 * `IDSampleStatus`. It is read in full and rendered as an option list, so it takes neither the
 * remote-search entity path (see `_SpecializedSelectorMap`) nor a purely static option array.
 *
 * Both stacks read this one definition: the legacy Select-family provider
 * (`PictProvider-InputType-SampleStatusSelector`) and the `Picker` broker's generic option source, so
 * the two render the same list from the same table with the same fallback.
 *
 * Per entry:
 *   Entity    — the vocabulary table (also the meadow scope; the route pluralizes to `<Entity>s`).
 *   ValueField — the column persisted onto the referencing record.
 *   TextField  — the column shown as the label.
 *   SortField  — the column the list is ordered by.
 *   Fallback   — options used when the customer has curated no rows, so the input works uncurated.
 */

/**
 * Fallback sample statuses. Deliberately smaller than the SiteManager set LADOTD runs on (which also
 * carries PREA / TSTR / PASC / FAIC / N/A) — a customer needing those manages them in SampleStatus.
 * @type {Array<{id: string, text: string}>}
 */
const DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS =
[
	{ 'id': 'LOGD', 'text': 'Logged' },
	{ 'id': 'RECV', 'text': 'Received' },
	{ 'id': 'PEND', 'text': 'Pending' },
	{ 'id': 'TEST', 'text': 'In Testing' },
	{ 'id': 'PASS', 'text': 'Passed' },
	{ 'id': 'FAIL', 'text': 'Failed' },
	{ 'id': 'INFO', 'text': 'Info' },
	{ 'id': 'VOID', 'text': 'Voided' },
];

/** @type {Record<string, {Entity: string, ValueField: string, TextField: string, SortField: string, Fallback: Array<{id: string, text: string}>}>} */
const VOCABULARY_SELECTOR_MAP =
{
	SampleStatusSelector:
	{
		Entity: 'SampleStatus',
		ValueField: 'Hash',
		TextField: 'Name',
		SortField: 'Ordinal',
		Fallback: DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS,
	},
};

/**
 * Stamp an input descriptor with its vocabulary's option source, so the shared entity option loader
 * picks it up. Never overwrites a schema-supplied `SelectOptions` / `SelectOptionsEntity`.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {string} [pInputType] - InputType override; defaults to the descriptor's own.
 * @return {boolean} - True when this input is vocabulary-backed.
 */
function applyVocabularySource(pInput, pInputType)
{
	if (!pInput)
	{
		return false;
	}
	if (!pInput.PictForm)
	{
		pInput.PictForm = {};
	}
	const tmpVocabulary = VOCABULARY_SELECTOR_MAP[pInputType || pInput.PictForm.InputType];
	if (!tmpVocabulary)
	{
		return false;
	}
	if (!Array.isArray(pInput.PictForm.SelectOptions))
	{
		pInput.PictForm.SelectOptions = tmpVocabulary.Fallback;
	}
	if (!pInput.PictForm.SelectOptionsEntity)
	{
		pInput.PictForm.SelectOptionsEntity = tmpVocabulary.Entity;
		pInput.PictForm.SelectOptionsEntityValueField = pInput.PictForm.SelectOptionsEntityValueField || tmpVocabulary.ValueField;
		pInput.PictForm.SelectOptionsEntityTextField = pInput.PictForm.SelectOptionsEntityTextField || tmpVocabulary.TextField;
		pInput.PictForm.SelectOptionsEntitySortField = pInput.PictForm.SelectOptionsEntitySortField || tmpVocabulary.SortField;
	}
	return true;
}

module.exports = { VOCABULARY_SELECTOR_MAP, DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS, applyVocabularySource };

},{}],146:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="DATE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-calendar fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-calendar fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<div
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="DATE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],147:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime (using DateTimePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar-clock fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType DateTime (using DateTimePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-DateTime',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-calendar-clock fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar-clock fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType DateTime (using DateTimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-DateTime',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-calendar-clock fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<div
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType DateTime (using DateTimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-DateTime',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],148:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autocomplete="off"
							value=""
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autocomplete="off"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-InformaryAddress-Input',
			Template: /*HTML-Partial*/`
					data-i-index="{~D:Context[2].Key~}"
					onchange="_Pict.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="text"
				class="input"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
				value=""
			/>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],149:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			Template: /*HTML-Parital*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0 {~HideInPDF:Record~}">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0 {~HideInPDF:Record~}">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],150:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-PreciseNumber',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-PreciseNumber',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-PreciseNumber',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber', {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],151:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-String',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autocomplete="off"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-String',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autocomplete="off"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-String',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-String',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-String',
			Template: /*HTM-Partial*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-String',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-String',
			Template: /*HTML-Partial*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-String',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],152:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time (using TimePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="TIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-clock-desk fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-clock-desk fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Time (using TimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="TIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Time',
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="TIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-clock-desk fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="TIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-clock-desk fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-clock-desk fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Time (using TimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="TIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Time',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="TIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-clock-desk fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InputFullProperties~}
						value=""
					/>
					<div class="control">
						<div
							id="TIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Time (using TimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="TIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Time',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="TIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],153:[function(require,module,exports){
/*
	Body markup for the Diagram and RichText editor input types, assembled per presentation by the
	{~EditorBody:<Theme>~} macro (see HeadlightDynamicInputsBundle.js). Both types share this markup —
	they differ only in the display slot's class and their provider hash, both derived from the InputType.

	The field edits INLINE: a View/Edit segmented switch flips between the static view and the live
	editor in place (the provider only toggles `is-editing`; the CSS does the rest). The inactive segment
	is a soft link, the active one solid — they read as one control. Read and Print always render the
	static view (no switch, no edit affordance); Print additionally drops the view's border (see the
	`pict-editor-print` class) so the PDF is clean.

	Every editable field opens and closes through that switch, which is what makes the exported value
	reliable: the close path commits. There is deliberately no "always editing" presentation (a field
	with no close event has no natural point to export from) and no floating "compact" modal one (removed
	2026-07-22 — the inline editor has its own toolbar, so the modal was bug surface without a need). There
	is also no dedicated "Clear" control (added then removed 2026-07-22): Excalidraw's own nav menu carries
	a "reset the canvas" action, which is deliberate-and-buried where a toolbar button was easy to mis-hit.

	Two ids are load-bearing and must not change:
	  - id="DISPLAY-FOR-{RawHTMLID}" — the PSF provider mounts view/edit content there.
	  - id="PICT-EDITOR-FOR-{RawHTMLID}" — the provider toggles `is-editing` on this container.
*/

/** @param {string} pInputType @return {string} The PSF display-slot class for this editor type. */
const displayClass = (pInputType) => `pict-section-form-${pInputType.toLowerCase()}`;

/** The View | Edit segmented switch. Each segment names its target mode (not a flip), so it reads as an
 *  on-page mode switch. Both segments are `is-link is-soft`; CSS promotes the ACTIVE one to solid link
 *  (keyed off the container's `is-editing`), so the pair reads as soft-inactive / solid-active. */
const _modeSwitch = (pInputType) => /*HTML*/`
			<div class="buttons has-addons pict-editor-switch">
				<button type="button" class="button is-small is-link is-soft pict-editor-switch-view" {~Disabled:Record~}
					onclick="_Pict.providers['Pict-Input-${pInputType}'].setEditorMode('{~D:Record.Hash~}', '{~D:Record.Macro.RawHTMLID~}', 'view')">
					<span class="icon"><i class="fas fa-fw fa-eye"></i></span><span>View</span>
				</button>
				<button type="button" class="button is-small is-link is-soft pict-editor-switch-edit" {~Disabled:Record~}
					onclick="_Pict.providers['Pict-Input-${pInputType}'].setEditorMode('{~D:Record.Hash~}', '{~D:Record.Macro.RawHTMLID~}', 'edit')">
					<span class="icon"><i class="fas fa-fw fa-pen"></i></span><span>Edit</span>
				</button>
			</div>`;

/**
 * Build the body markup for one editor presentation.
 *
 * @param {object} pOptions
 * @param {string} pOptions.Theme - 'Edit' | 'Read' | 'Print'.
 * @param {string} pOptions.InputType - 'Diagram' | 'RichText'.
 * @return {string} The (unparsed) body template.
 */
function buildEditorBody(pOptions)
{
	const tmpInputType = pOptions.InputType;
	// Read/Print are always the static view — the editor chrome means nothing there.
	const tmpLocked = (pOptions.Theme !== 'Edit');
	// Print drops the view border for a clean PDF; Read keeps it (an on-screen affordance).
	const tmpContainerClass = (pOptions.Theme === 'Print') ? 'pict-editor pict-editor-print' : 'pict-editor';

	// The change handler lets informary marshal the exported value into FormData; drop it in the
	// read-only theme where nothing changes (matching the HTML/Markdown templates).
	const tmpChangeHandler = tmpLocked ? '' : '{~D:Record.Macro.InputChangeHandler~}';

	// The explicit id is REQUIRED, not decoration: the provider writes the exported value back with
	// document.getElementById(RawHTMLID) and returns silently when it finds nothing — so without it the
	// editor works, shows content, and saves absolutely nothing. InputFullProperties supplies the
	// informary binding (data-i-form / data-i-datum / name) but NOT the id.
	return /*HTML*/`
		<input type="hidden" tabindex="-1" id="{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~} ${tmpChangeHandler} value="">
		<div id="PICT-EDITOR-FOR-{~D:Record.Macro.RawHTMLID~}" class="${tmpContainerClass}">
			${tmpLocked ? '' : /*HTML*/`<div class="pict-editor-controls">${_modeSwitch(tmpInputType)}</div>`}
			<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="${displayClass(tmpInputType)}"></div>
		</div>
		${tmpLocked ? '' : /*HTML*/`<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>`}`;
}

module.exports = { buildEditorBody, displayClass };

},{}],154:[function(require,module,exports){
/*
	Template set builder for the Diagram and RichText editor input types.

	Both editors render the same wrapper — a labeled column whose body (the toggle + editor/view slot)
	is chosen per field at render time by the `{~EditorBody:<Theme>~}` macro; see EditorBodies.js for the
	markup and HeadlightDynamicInputsBundle.js for the macro that fills it in.

	STANDARD and VERTICAL only. These types have no Tabular entries on purpose: the pict-section-form
	provider throws inside a tabular row (N Excalidraw/CodeMirror instances per row is a performance
	landmine), so there is nothing to render there. RecordSet reuses the Tabular templates, so it is
	unsupported for the same reason — Standard and Vertical are the supported layouts.
*/

/** The single-record wrapper. The body macro fills in the presentation for this theme. */
const _buildStandardTemplate = (pInputType, pTheme) => /*HTML*/`
		<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
		<div class="column {~ColumnWidth:Record~}${pTheme === 'Print' ? ' {~HideInPDF:Record~}' : ''}">
			<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
			{~EditorBody:${pTheme}~}
		</div>`;

/** The label-left vertical wrapper, matching the HTML/Markdown vertical layout. */
const _buildVerticalTemplate = (pInputType, pTheme) => /*HTML*/`
		<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
		<div class="pict-form-vertical-input column ${pTheme === 'Print' ? 'pb-1 {~HideInPDF:Record~}' : 'pb-3'}">
			<div class="columns is-mobile is-vcentered">
				<div class="column">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				</div>
				<div class="column description-text">{~D:Record.Description~}</div>
				<div class="column">
					{~EditorBody:${pTheme}~}
				</div>
			</div>
		</div>`;

/**
 * Build the Edit/Read/Print template entries for an editor input type.
 * @param {string} pInputType - 'Diagram' or 'RichText'.
 * @return {{ Edit: Array<object>, Read: Array<object>, Print: Array<object> }}
 */
function buildEditorTemplates(pInputType)
{
	const tmpThemeEntries = (pTheme) => (
		[
			{
				HashPostfix: `-Template-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ `Pict-Input-${pInputType}` ],
				Template: _buildStandardTemplate(pInputType, pTheme),
			},
			{
				HashPostfix: `-VerticalTemplate-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ `Pict-Input-${pInputType}` ],
				Template: _buildVerticalTemplate(pInputType, pTheme),
			},
		]);
	return {
		Edit: tmpThemeEntries('Edit'),
		Read: tmpThemeEntries('Read'),
		Print: tmpThemeEntries('Print'),
	};
}

module.exports = { buildEditorTemplates };

},{}],155:[function(require,module,exports){
// work smarter, not harder.
const _IntentionallyIdenticalTemplatesForAllThemes =
[
	// Form Container wrapper templates
	{
		// NOTE: intentionally empty -- instead we are using FormHeader view injected at #Headlight-View-Header
		HashPostfix: '-Template-Form-Container-Header',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Form-Container-Wrap-Prefix',
		Template: /*HTML*/`
		<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`,
	},
	{
		HashPostfix: '-Template-Form-Container',
		Template: /*HTML*/`
			<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`,
	},
	{
		// NOTE: intentionally empty -- we don't use these currently, but they are overloaded to reduce template comments in the DOM
		HashPostfix: '-Template-Wrap-Prefix',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Wrap-Postfix',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Form-Container-Custom',
		Template: /*HTML*/`
			<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`,
	},
	{
		HashPostfix: '-Template-Form-Container-Wrap-Postfix',
		Template: /*HTML*/`
		</div>`,
	},
	// Form Section, Group, Row templates
	{
		HashPostfix: '-Template-Section-Prefix',
		Template: /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<section id="SECTION-{~D:Context[0].formID~}" class="pict-form-section container {~D:Record.CSSClass~}" data-i-section-hash="{~D:Record.Hash~}">
			<h2 class="section-header {~ShowSectionTitle:Record~}">{~D:Record.Name~}</h2>`,
	},
	{
		HashPostfix: '-Template-Group-Prefix',
		Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="pict-form-group container {~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-content">`,
	},
	{
		HashPostfix: '-Template-Row-Prefix',
		Template: /*HTML*/`
					<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
					<div class="columns {~ColumnsOvercrowded:Record~}">`,
	},
	{
		HashPostfix: '-Template-Row-Postfix',
		Template: /*HTML*/`
					</div>
					<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
	{
		HashPostfix: '-Template-Group-Postfix',
		Template: /*HTML*/`
				</div>
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
	{
		HashPostfix: '-Template-Section-Postfix',
		Template: /*HTML*/`
		</section>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
];

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: _IntentionallyIdenticalTemplatesForAllThemes,
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: _IntentionallyIdenticalTemplatesForAllThemes,
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [ ..._IntentionallyIdenticalTemplatesForAllThemes,
		// NOTE: optional "HideInPDF" class added for sections
		{
			HashPostfix: '-Template-Section-Prefix',
			Template: /*HTML*/`
			<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<section id="SECTION-{~D:Context[0].formID~}" class="pict-form-section container {~D:Record.CSSClass~} {~HideInPDF:Record~}" data-i-section-hash="{~D:Record.Hash~}">
				<h2 class="section-header {~ShowSectionTitle:Record~}">{~D:Record.Name~}</h2>`,
		},
		// NOTE: optional "HideInPDF" class added for groups
		{
			HashPostfix: '-Template-Group-Prefix',
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="pict-form-group container {~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-content">`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],156:[function(require,module,exports){
/*
	Body markup for both Geolocation input types, in both presentations.

	A geolocation field renders one of two presentations:

	  FULL (default)  — address search + editable lat/long + readout + labeled action buttons
	                    (plus the inline map on the WithMap variant).
	  COMPACT         — a single readout bar with icon buttons; the picker moves into an Edit modal
	                    (the inline map, on the WithMap variant, still renders below it).

	`Compact` is a PictForm option, so a Standard field and a Record Set record can each choose
	either one. A Tabular TABLE is always compact — a full picker cannot fit a table cell — which
	the `{~GeolocationBody:~}` pattern enforces before calling in here.

	Both presentations bind the SAME way, so the choice is purely presentational:
	  - Single-record: two informary-bound lat/long inputs (`LATITUDE-FOR-<id>` / `LONGITUDE-FOR-<id>`),
	    visible number inputs in full, `type="hidden"` data-bearers in compact.
	  - Tabular/Record Set: the two hidden informary inputs written by the Begin partial are the only
	    bound elements in either presentation. Full mode adds *unbound* editor inputs that the provider
	    syncs to them, so the proven tabular data path is untouched.

	Everything is keyed by an "instance id": the field's rawHTMLID for a single-record field, or
	`<rawHTMLID>-<rowKey>` for a tabular/record-set row. Keeping that one convention lets the
	address-search DOM helpers (GEO-ADDRESS-INPUT-<id> / GEO-ADDRESS-RESULTS-<id>) serve both.
*/

const GEO_PROVIDER = '_Pict.providers.GeolocationSelector';

// The ordered ids every row-aware provider method needs (view hash, group index, input index, row
// key, rawHTMLID) — mirrors the tabular action handlers' signature.
const ROW_ARGS = `'{~D:Context[0].Hash~}','{~D:Context[2].Group~}','{~D:Record.PictForm.InputIndex~}','{~D:Context[2].Key~}','{~D:Record.Macro.RawHTMLID~}'`;

/**
 * Resolve the per-context ids and provider call strings. Single-record fields address the provider
 * by instance id; tabular rows go through the row-aware methods, which also marshal the row.
 * @param {boolean} pTabular - True for a tabular/record-set cell body.
 * @param {boolean} pHasMap - True for the GeolocationSelectorWithMap variant.
 * @return {object} The id + handler fragments used to assemble a body.
 */
const _context = (pTabular, pHasMap) =>
{
	// The instance id: rawHTMLID, suffixed with the row key inside a tabular/record-set row.
	const tmpID = pTabular ?
		'{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}' :
		'{~D:Record.Macro.RawHTMLID~}';
	return {
		ID: tmpID,
		// Readout element id. Tabular reuses the id the compact cell has always used, so the Begin
		// partial's `data-validation-surface` pointer resolves in either presentation.
		DisplayID: pTabular ? `GEO-DISPLAY-TABULAR-${tmpID}` : `GEO-DISPLAY-FOR-${tmpID}`,
		// Lat/long inputs. Single-record: the informary-bound pair. Tabular: unbound editors the
		// provider syncs to the hidden bound pair written by the Begin partial.
		LatitudeID: pTabular ? `GEO-RS-LAT-${tmpID}` : `LATITUDE-FOR-${tmpID}`,
		LongitudeID: pTabular ? `GEO-RS-LONG-${tmpID}` : `LONGITUDE-FOR-${tmpID}`,
		Search: pTabular ? `${GEO_PROVIDER}.searchAddressTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.searchAddress('${tmpID}')`,
		UseMyLocation: pTabular ? `${GEO_PROVIDER}.onUseMyLocationTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.onUseMyLocation('${tmpID}')`,
		Clear: pTabular ? `${GEO_PROVIDER}.clearValueTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.clearValue('${tmpID}')`,
		EditModal: pTabular ? `${GEO_PROVIDER}.openEditModalTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.openEditModal('${tmpID}', ${pHasMap})`,
		// A tabular row's editor inputs are not informary-bound, so they need an explicit commit.
		CoordinateEdit: pTabular ? `${GEO_PROVIDER}.onRowCoordinateEdit(${ROW_ARGS})` : '',
	};
};

// --- Shared fragments ------------------------------------------------------------------------

/** Address search box + the results container the provider fills with clickable rows. */
const _searchField = (pContext) => /*HTML*/`
	<div class="field has-addons geo-search-field">
		<div class="control is-expanded">
			<input id="GEO-ADDRESS-INPUT-${pContext.ID}" class="input" type="text" placeholder="Search an address or place…" autocomplete="off" {~Disabled:Record~}
				onkeydown="if(event.key==='Enter'){event.preventDefault();${pContext.Search};}" />
		</div>
		<div class="control">
			<button type="button" class="button is-soft" {~Disabled:Record~} onclick="${pContext.Search}">
				<span class="icon"><i class="fas fa-search"></i></span><span class="is-hidden-mobile">Search</span>
			</button>
		</div>
	</div>
	<div id="GEO-ADDRESS-RESULTS-${pContext.ID}"></div>`;

/**
 * One editable coordinate column. `pAttributes` carries the informary macros for a single-record
 * field; a tabular row passes its own change handler instead (its binding lives in hidden inputs).
 */
const _coordinateColumn = (pID, pLabel, pAttributes) => /*HTML*/`
		<div class="column">
			<label for="${pID}" class="label is-small">${pLabel}</label>
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<input id="${pID}" type="number" class="input has-text-right" step="any" placeholder="0" onfocus="this.select()"
						${pAttributes} autocomplete="off" />
					<span class="icon is-small is-left"><i class="fas fa-map-marker-alt"></i></span>
				</p>
			</div>
		</div>`;

/**
 * The editable Latitude/Longitude pair. Plain `.columns` (no `is-mobile`) so Bulma stacks them into
 * full-width rows on a phone, which is what the narrow layout needs.
 */
const _coordinateColumns = (pContext, pTabular) =>
{
	// A tabular row's editors are unbound, so they commit through the provider; a single-record
	// field's inputs ARE the informary binding. `required` belongs on the bound element only — a
	// tabular row's requiredness would live on its hidden Begin-partial inputs, not on these.
	const tmpAttributes = pTabular ?
		`{~Disabled:Record~} onchange="${pContext.CoordinateEdit}"` :
		'{~Required:Record~} {~Disabled:Record~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}';
	return /*HTML*/`
	<div class="columns geo-coordinate-columns">
${_coordinateColumn(pContext.LatitudeID, 'Latitude', tmpAttributes)}
${_coordinateColumn(pContext.LongitudeID, 'Longitude', tmpAttributes)}
	</div>`;
};

/**
 * Read-only coordinate pair for a single-record field's Read/Print themes (kept side-by-side in
 * Print). Single-record only — these carry the informary binding, which a tabular row already has
 * on its hidden Begin-partial inputs.
 */
const _staticCoordinateColumns = (pContext, pPrint) =>
{
	const tmpTag = (pID, pLabel) => (pPrint ? /*HTML*/`
		<div class="column">
			<label for="${pID}" class="label is-small">${pLabel}</label>
			<div class="field mb-0">
				<div class="control">
					<div id="${pID}" class="input is-static" {~D:Record.Macro.InputFullProperties~}></div>
				</div>
			</div>
		</div>` : /*HTML*/`
		<div class="column">
			<label for="${pID}" class="label is-small">${pLabel}</label>
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<input id="${pID}" type="number" class="input has-text-right" step="any"
						{~D:Record.Macro.InputFullProperties~} readonly aria-readonly="true" />
					<span class="icon is-small is-left"><i class="fas fa-map-marker-alt"></i></span>
				</p>
			</div>
		</div>`);
	return /*HTML*/`
	<div class="columns ${pPrint ? 'is-mobile' : ''} geo-coordinate-columns">
${tmpTag(pContext.LatitudeID, 'Latitude')}
${tmpTag(pContext.LongitudeID, 'Longitude')}
	</div>`;
};

/**
 * Readout + action buttons. On a phone the CSS drops the buttons to their own full-width row and
 * splits them 50/50, which is why the readout and the buttons stay separate flex children here.
 */
const _actionLevel = (pContext) => /*HTML*/`
	<div class="level is-mobile mt-1 geo-action-level">
		<div class="level-left geo-readout">
			<span class="icon has-text-primary"><i class="fa fa-location-dot"></i></span>
			<span id="${pContext.DisplayID}" class="has-text-grey ml-1">No location set</span>
		</div>
		<div class="level-right">
			<div class="buttons are-small mb-0 geo-action-buttons">
				<button type="button" class="button is-link" {~Disabled:Record~} onclick="${pContext.UseMyLocation}">
					<span class="icon"><i class="fa fa-location-crosshairs"></i></span><span>Use My Location</span>
				</button>
				<button type="button" class="button is-link is-soft" {~Disabled:Record~} onclick="${pContext.Clear}">
					<span class="icon"><i class="fa fa-eraser"></i></span><span>Clear</span>
				</button>
			</div>
		</div>
	</div>`;

/**
 * The compact bar: a read-only readout with Get-Location / Edit / Clear icon buttons.
 *
 * For a single-record field the two informary-bound inputs live INSIDE this control as hidden
 * data-bearers pointing at the readout via `data-validation-surface` — the same arrangement
 * InputType-Signature uses, so the validation provider resolves visibility and paints is-danger on
 * a wrapper the user can actually see. A tabular row's bearers are already in the Begin partial.
 */
const _compactBar = (pContext, pTabular, pLocked) =>
{
	const tmpBearers = pTabular ? '' : /*HTML*/`
			<input id="${pContext.LatitudeID}" type="hidden" tabindex="-1"
				{~Required:Record~} {~Disabled:Record~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}
				data-validation-surface="${pContext.DisplayID}" ${pLocked ? 'readonly aria-readonly="true" ' : ''}value="" />
			<input id="${pContext.LongitudeID}" type="hidden" tabindex="-1"
				{~Required:Record~} {~Disabled:Record~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}
				data-validation-surface="${pContext.DisplayID}" ${pLocked ? 'readonly aria-readonly="true" ' : ''}value="" />`;
	// A locked readout sets the pin inline beside the coordinates, the same way the full-size
	// readout does. NOT Bulma's has-icons-left: that absolutely positions the icon and reserves room
	// with padding-left, which `.input.is-static` then zeroes out — dropping the pin on top of the
	// coordinates in the Read and Print/PDF themes.
	if (pLocked)
	{
		return /*HTML*/`
	<div class="field mb-0 geo-compact-bar">
		<div class="control">${tmpBearers}
			<span class="icon has-text-primary"><i class="fa fa-location-dot"></i></span>
			<span id="${pContext.DisplayID}" class="ml-1"></span>
		</div>
	</div>`;
	}
	return /*HTML*/`
	<div class="field has-addons mb-0 geo-compact-bar">
		<div class="control is-expanded control-status has-icons-left">${tmpBearers}
			<span class="icon is-left"><i class="fa fa-location-dot"></i></span>
			<div id="${pContext.DisplayID}" class="input" readonly></div>
		</div>
		<div class="control"><button type="button" class="button is-link" title="Use my location" aria-label="Use my location"
			{~Disabled:Record~} onclick="${pContext.UseMyLocation}"><span class="icon"><i class="fa fa-location-crosshairs"></i></span></button></div>
		<div class="control"><button type="button" class="button is-link" title="Edit location" aria-label="Edit location"
			{~Disabled:Record~} onclick="${pContext.EditModal}"><span class="icon"><i class="fa fa-pen-to-square"></i></span></button></div>
		<div class="control"><button type="button" class="button is-link is-soft" title="Clear location" aria-label="Clear location"
			{~Disabled:Record~} onclick="${pContext.Clear}"><span class="icon"><i class="fa fa-eraser"></i></span></button></div>
	</div>`;
};

// --- Map hosts -------------------------------------------------------------------------------

/**
 * Live map host. Single-record fields mount into it as soon as it scrolls into view; record-set
 * rows keep theirs hidden until the provider confirms the group really is a RecordSet (a Tabular
 * table has no room for a per-row map and uses the Edit modal's map instead).
 */
const _liveMapHost = (pContext, pTabular, pLocked) => (pTabular ? /*HTML*/`
	<div id="GEO-RS-MAP-FOR-${pContext.ID}" ${pLocked ? 'data-geo-locked="true" ' : ''}class="mt-2" style="display: none; min-height: 280px; z-index: 1;"></div>` : /*HTML*/`
	<div id="MAP-CONTAINER-FOR-${pContext.ID}" class="mt-2"></div>`);

/** Print/PDF map: a static image the renderer can wait for (a live Leaflet map under-fills the frame). */
const _staticMapImage = (pContext, pTabular) => (pTabular ? /*HTML*/`
	<img id="GEO-RS-MAPIMG-FOR-${pContext.ID}" alt="Map of the selected location" class="mt-2" style="width: 100%; height: auto; max-height: 360px; object-fit: cover; border-radius: 6px; display: none;" />` : /*HTML*/`
	<img id="MAP-IMG-FOR-${pContext.ID}" alt="Map of the selected location" class="mt-2" style="width: 100%; height: auto; max-height: 420px; object-fit: cover; border-radius: 6px; display: none;" />`);

// --- Body assembly ---------------------------------------------------------------------------

/**
 * Build the body markup for one geolocation presentation.
 *
 * @param {object} pOptions
 * @param {string} pOptions.Theme - 'Edit' | 'Read' | 'Print'.
 * @param {boolean} pOptions.Compact - True for the compact bar presentation.
 * @param {boolean} pOptions.HasMap - True for the GeolocationSelectorWithMap variant.
 * @param {boolean} pOptions.Tabular - True for a tabular/record-set cell body.
 * @return {string} The (unparsed) body template.
 */
function buildGeolocationBody(pOptions)
{
	const tmpContext = _context(pOptions.Tabular, pOptions.HasMap);
	const tmpPrint = (pOptions.Theme === 'Print');
	const tmpLocked = (pOptions.Theme !== 'Edit');
	// The compact/full choice shapes the *editable* presentation. A locked tabular row always falls
	// back to the readout bar: the picker chrome (search box, editable coordinates) means nothing in
	// Read/Print, and the readout plus the map already carry the whole value.
	const tmpUseCompactBar = pOptions.Compact || (pOptions.Tabular && tmpLocked);
	let tmpBody = '';

	if (tmpUseCompactBar)
	{
		tmpBody += _compactBar(tmpContext, pOptions.Tabular, tmpLocked);
	}
	else if (tmpLocked)
	{
		tmpBody += _staticCoordinateColumns(tmpContext, tmpPrint);
	}
	else
	{
		tmpBody += _searchField(tmpContext);
		tmpBody += _coordinateColumns(tmpContext, pOptions.Tabular);
		tmpBody += _actionLevel(tmpContext);
	}

	if (pOptions.HasMap)
	{
		tmpBody += tmpPrint ? _staticMapImage(tmpContext, pOptions.Tabular) : _liveMapHost(tmpContext, pOptions.Tabular, tmpLocked);
	}
	// The help line only makes sense next to the controls it describes.
	if (!tmpUseCompactBar && !tmpLocked)
	{
		tmpBody += /*HTML*/`
	<p class="help">Search an address, type coordinates${pOptions.HasMap ? ', or click the map / drag the marker' : ''} to set the location. It saves with the form.</p>`;
	}
	return tmpBody;
}

module.exports = { buildGeolocationBody };

},{}],157:[function(require,module,exports){
/*
	Template set builder for both Geolocation input types.

	`GeolocationSelector` and `GeolocationSelectorWithMap` render the same control — the map variant
	just adds a map — so both input types are built from this one place. The presentation (full picker
	vs compact bar) is chosen per field at render time by the `{~GeolocationBody:<Theme>~}` macro; see
	GeolocationBodies.js for the markup and HeadlightDynamicInputsBundle.js for the selection rules.

	The tabular Begin partial is the one piece that must stay literal HTML: the framework assembles a
	tabular cell as Begin + Mid + InformaryAddress + End, and the InformaryAddress partial injects
	`data-i-index` + `onchange` into whatever tag Begin leaves open. So Begin writes the two hidden
	informary inputs (latitude fully, longitude left open) and everything else lives in the body.
*/

/*
	The value binds as two informary hidden inputs with nested sub-addresses
	(<InformaryDataAddress>.Latitude / .Longitude), producing Container[row].<Field> = {Latitude,
	Longitude} — identical to the single-record shape. These stay the ONLY bound elements in a
	tabular/record-set cell in either presentation; the full picker's visible coordinate boxes are
	unbound editors the provider syncs to these.

	`data-validation-surface` points at the readout, which keeps the same id in both presentations,
	so the validation provider can resolve a visible surface for these hidden data-bearers.
*/
const _buildTabularBegin = (pInputType) => /*HTML*/`
	<!-- InputType ${pInputType} Tabular {~D:Record.Hash~} {~D:Record.DataType~} -->
	<input type="hidden" tabindex="-1"
		id="GEO-LAT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
		data-i-form="{~D:Context[0].formID~}"
		data-i-datum="{~D:Record.PictForm.InformaryDataAddress~}.Latitude"
		data-i-container="{~D:Record.PictForm.InformaryContainerAddress~}"
		data-i-index="{~D:Context[2].Key~}"
		data-validation-surface="GEO-DISPLAY-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
		value="" />
	<input type="hidden" tabindex="-1"
		id="GEO-LONG-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
		data-i-form="{~D:Context[0].formID~}"
		data-i-datum="{~D:Record.PictForm.InformaryDataAddress~}.Longitude"
		data-i-container="{~D:Record.PictForm.InformaryContainerAddress~}"
		data-validation-surface="GEO-DISPLAY-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"`;

/** The single-record wrapper. The body macro fills in the presentation for this theme. */
const _buildStandardTemplate = (pInputType, pTheme) => /*HTML*/`
	<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
	<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}${pTheme === 'Print' ? ' {~HideInPDF:Record~}' : ''} geolocation-input">
		<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
		{~GeolocationBody:${pTheme}~}
	</div>`;

/**
 * Build the Edit/Read/Print template entries for a Geolocation input type.
 * @param {string} pInputType - 'GeolocationSelector' or 'GeolocationSelectorWithMap'.
 * @return {{ Edit: Array<object>, Read: Array<object>, Print: Array<object> }}
 */
function buildGeolocationTemplates(pInputType)
{
	const tmpTabularBegin = _buildTabularBegin(pInputType);
	const tmpThemeEntries = (pTheme) => (
		[
			{
				HashPostfix: `-Template-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ 'GeolocationSelector' ],
				Template: _buildStandardTemplate(pInputType, pTheme),
			},
			{
				HashPostfix: `-TabularTemplate-Begin-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ 'GeolocationSelector' ],
				Template: tmpTabularBegin,
			},
			{
				// Closes the longitude input the Begin partial left open, then the cell body.
				HashPostfix: `-TabularTemplate-End-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ 'GeolocationSelector' ],
				Template: /*HTML*/`
		value="" />
	<div class="geolocation-input">{~GeolocationBody:${pTheme}~}</div>`,
			},
		]);
	return {
		Edit: tmpThemeEntries('Edit'),
		Read: tmpThemeEntries('Read'),
		Print: tmpThemeEntries('Print'),
	};
}

module.exports = { buildGeolocationTemplates };

},{}],158:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<p class="control control-status">
							<span class="control-status-icon"></span>
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="checkbox"
								class="is-checkbox"
								{~D:Record.Macro.ControlAttr~}
								{~Required:Record~}
								{~Disabled:Record~}
								{~D:Record.Macro.InputFullProperties~}
								{~D:Record.Macro.InputChangeHandler~}
								value=""
							/>
							<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
						</p>
					</label>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-checkbox-with-label pb-1 mb-0 mt-2 {~ColumnAlignment:Record~}">
							<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
								<p class="control control-status">
									<span class="control-status-icon"></span>
									<input
										id="{~D:Record.Macro.RawHTMLID~}"
										type="checkbox"
										class="is-checkbox"
										{~D:Record.Macro.ControlAttr~}
										{~Required:Record~}
										{~Disabled:Record~}
										{~D:Record.Macro.InputFullProperties~}
										{~D:Record.Macro.InputChangeHandler~}
										value=""
									/>
								</p>
							</label>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
							value=""
						/>
						<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
					</p>
				</label>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
							value=""
						/>
						<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
					</label>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="checkbox"
									class="is-checkbox"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
									value=""
								/>
							</label>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}
							disabled="disabled"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
							value=""
						/>
						<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
					</p>
				</label>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
					</label>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="checkbox"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
						</label>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="checkbox"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
				</label>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],159:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "BridgeSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Bridge) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "BridgeSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			// BESPOKE, not a bare reference: it reproduces the Picker Edit chrome and keeps the legacy Bridge
			// Search Panel buttons, which the truth template dropped — losing them orphans the panel, whose
			// selection callback the broker still wires (_wireBridgeSearchPanel). Two buttons, as legacy: a
			// labelled one on mobile and an icon-only one above it. No Show All toggle, because the legacy
			// BridgeSelector had none and its customer-state scope is mandatory.
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (+ bridge panel addon) -->
				<div class="column {~ColumnWidth:Record~}">
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						{~Required:Record~}
						data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
						value=""
					/>
					<div class="field">
						<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
							</p>
							<p class="control is-hidden-tablet is-fullwidth">
								<button class="button is-link addons-stack-mobile" type="button" onclick="_Pict.views.HeadlightPaneBridges.openBridgePanelFromAdvancedButton(event)">
									<span class="icon is-small">
										<i class="fas fa-bars-filter"></i>
									</span>
									<span>Search Bridges</span>
								</button>
							</p>
							<p class="control is-hidden-mobile">
								<button class="button is-link" type="button" onclick="_Pict.views.HeadlightPaneBridges.openBridgePanelFromAdvancedButton(event)">
									<span class="icon is-small">
										<i class="fas fa-bars-filter"></i>
									</span>
								</button>
							</p>
						</div>
						<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],160:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],161:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				class="input is-hidden"
				tabindex="-1"
				{~Required:Record~}
				{~Disabled:Record~}
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			/>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				class="input is-hidden"
				disabled="disabled"
				{~D:Record.Macro.InputFullProperties~}
				value=""
			/>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				class="input is-hidden"
				disabled="disabled"
				{~D:Record.Macro.InputFullProperties~}
				value=""
			/>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],162:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<style>
				input[type="color" i]::-webkit-color-swatch,
				input[type="color" i]::-moz-color-swatch {
					border: 0;
					border-radius: 0.25rem;
				}
			</style>
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="color"
							class="input py-0"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							value="#ffffff"
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-palette fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="color"
									class="input py-0"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									value="#ffffff"
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-palette fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="color"
						class="input py-0"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
						value="#ffffff"
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-palette fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							aria-readonly="true"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input"
									aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
				value="" />
			<div
				id="DISPLAY-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input"
				aria-readonly="true"
				{~D:Record.Macro.ControlAttr~}
			></div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
				value="" />
			<div
				id="DISPLAY-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],163:[function(require,module,exports){
// Headlight templates for the PSF `Diagram` (Excalidraw) InputType. Standard + Vertical across
// Edit/Read/Print; the shared builder and the {~EditorBody:~} macro own the presentation. Tabular is
// unsupported by design (the provider throws). See EditorTemplates.js / EditorBodies.js.
const { buildEditorTemplates } = require('./EditorTemplates.js');

module.exports = buildEditorTemplates('Diagram');

},{"./EditorTemplates.js":154}],164:[function(require,module,exports){
// TODO: Is this a valid input type? Should it be removed or renamed? Investigate.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			// TODO: Make a Document Date Provider to update the document object and the header date
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field mb-0">
					<label for="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value="{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}"
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value="{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}"
						/>
					</p>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						>{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],165:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="email"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-envelope fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="email"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-envelope fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EmailAddress (using EmailAddressProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="email"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EmailAddress',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-envelope fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using EmailAddressProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="email"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-envelope fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="email"
									class="input"
									readonly aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-envelope fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EmailAddress (using EmailAddressProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="email"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EmailAddress',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-envelope fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- DataType EmailAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EmailAddress (using EmailAddressProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EmailAddress',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],166:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							type="text"
							class="input {~ColumnAlignment:Record~}"
							placeholder="{~Placeholder:Record~}"
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
							autocomplete="off"
							value=""
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntityDisplay',
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
						autocomplete="off"
						value=""
					/>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<div
					id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			Template: /*HTML-Partial*/`
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],167:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "EntitySelector" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "EntitySelector" in the manifest -- no manifest edit is needed;
	the broker maps its Entity / IdentityField / EntityDisplayField onto the picker; PickerDisplay
	resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],168:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "EntitySelectorMultiple" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "EntitySelectorMultiple" in the manifest -- no manifest edit is needed;
	the broker maps its Entity descriptor and infers multi-select from the InputType name;
	PickerDisplay resolves the entity names (+ EntityTag badges) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],169:[function(require,module,exports){
// TODO: This input type only has tabular for Edit theme? Feels incomplete. Investigate later if this is actually used.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ExistingDisabledByDefault',
			DefaultInputExtensions: [ 'InputValidation', 'ExistingDisabledByDefault' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ExistingDisabledByDefault {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control control-status">
				<span class="control-status-icon"></span>
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~Required:Record~}
					{~Disabled:Record~}
					placeholder="{~Placeholder:Record~}"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ExistingDisabledByDefault',
			Template: /*HTML-Partial*/`
					value=""
				/>
			</p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		/* NOTE: Remove me and add your own templates here for the Read theme */
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		/* NOTE: Remove me and add your own templates here for the Print theme */
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],170:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="file is-link">
							<label class="file-label">
								<input
									id="FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="file-input"
									type="file"
									name="resume"
									onchange="{~P~}.providers.FileSelector.handleFileSelection('{~D:Record.Macro.RawHTMLID~}', false);"
								/>
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-upload"></i>
									</span>
									<span class="file-label"> Upload a file</span>
								</span>
							</label>
							<button type="button" class="button is-link ml-1" onclick="{~P~}.providers.FileSelector.openObservationSearchPanel('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false);">
								<span class="icon">
									<i class="fas fa-fw fa-paperclip"></i>
								</span>
								<span>Select Observation</span>
							</button>
						</div>
						<!-- the loading indicator, shown while the file is being processed -->
						<div id="LOADING-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-skeleton is-hidden" style="height: 40px;">Loading...</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status is-expanded">
					<input
						id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="file is-link">
						<label class="file-label">
							<input
								id="TABULAR-FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
								class="file-input"
								type="file"
								name="resume"
								onchange="{~P~}.providers.FileSelector.handleFileSelection('{~D:Record.Macro.RawHTMLID~}', true, {~D:Context[2].Key~});"
							/>
							<span class="file-cta">
								<span class="file-icon">
									<i class="fas fa-upload"></i>
								</span>
								<span class="file-label"> Upload a file</span>
							</span>
						</label>
						<button type="button" class="button is-link ml-1" onclick="{~P~}.providers.FileSelector.openObservationSearchPanel('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~});">
							<span class="icon">
								<i class="fas fa-fw fa-paperclip"></i>
							</span>
							<span>Select Observation</span>
						</button>
					</div>
					<!-- the loading indicator, shown while the file is being processed -->
					<div id="TABULAR-LOADING-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-skeleton is-hidden" style="height: 40px;">Loading...</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-fullwidth">
							<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
						</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control control-status is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-expanded">
						<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
					</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} (does not print) -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-fullwidth">
							<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
						</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="control control-status is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-fullwidth">
						<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
					</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],171:[function(require,module,exports){
// The no-map Geolocation variant. Markup is shared with the map variant — see GeolocationTemplates.js.
const { buildGeolocationTemplates } = require('./GeolocationTemplates.js');

module.exports = buildGeolocationTemplates('GeolocationSelector');

},{"./GeolocationTemplates.js":157}],172:[function(require,module,exports){
// The map Geolocation variant. Markup is shared with the no-map variant — see GeolocationTemplates.js.
const { buildGeolocationTemplates } = require('./GeolocationTemplates.js');

module.exports = buildGeolocationTemplates('GeolocationSelectorWithMap');

},{"./GeolocationTemplates.js":157}],173:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],174:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "LabSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Lab) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "LabSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],175:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "LineItemSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (LineItem) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "LineItemSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],176:[function(require,module,exports){
// Headlight templates for the PSF `Link` InputType. PSF ships bare defaults (no Bulma wrapper,
// no Read/Print variants); these add the house style across Edit/Read/Print for Standard, Vertical,
// and Tabular layouts. (RecordSet reuses the Tabular entries — it is not a separate template axis.)
//
// Contract preserved from pict-section-form's Link provider (Pict-Provider-Input-Link.js):
//   - Standard/Vertical: the anchor MUST carry id="INPUT-FOR-{RawHTMLID}" — onDataMarshalToForm
//     sets its `href` there. Visible text is the field Name (the Name is the link caption).
//   - Tabular: the anchor MUST carry id="TABULAR-DATA-{RawHTMLID}-{rowIndex}" — onDataMarshalToFormTabular
//     sets `href` there. `{~D:Context[2].Key~}` resolves to the row index.
//   - The hidden input carries the informary binding; Link is display-only for its URL, so there is
//     no change handler (matching PSF — the value arrives from data/solvers, not from editing the anchor).
//   - Every anchor carries {~LinkTarget:Record~}, which emits target/rel when the descriptor sets
//     PictForm.LinkTarget. Absent, it emits nothing (same-tab default). All nine anchors must keep
//     it in lockstep across Edit/Read/Print -- the template tests enforce that.
//   - The Tabular Begin/End split is deliberate: Begin opens the hidden input tag and leaves it
//     unclosed after the informary macros so the framework's Mid partial can inject binding attributes;
//     End closes it and renders the anchor. Do not close the input inside Begin.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
					<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
					<span>{~D:Record.Name~}</span>
				</a>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
							<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
							<span>{~D:Record.Name~}</span>
						</a>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Link',
			Template: /*HTML-Partial*/` value="">
			<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-link" {~D:Record.Macro.HTMLName~} {~LinkTarget:Record~}>{~D:Record.Name~}</a>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
					<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
					<span>{~D:Record.Name~}</span>
				</a>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
							<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
							<span>{~D:Record.Name~}</span>
						</a>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Link',
			Template: /*HTML-Partial*/` value="">
			<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-link" {~D:Record.Macro.HTMLName~} {~LinkTarget:Record~}>{~D:Record.Name~}</a>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
					<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
					<span>{~D:Record.Name~}</span>
				</a>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
							<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
							<span>{~D:Record.Name~}</span>
						</a>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Link',
			Template: /*HTML-Partial*/` value="">
			<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-link" {~D:Record.Macro.HTMLName~} {~LinkTarget:Record~}>{~D:Record.Name~}</a>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],177:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No Markdown content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No Markdown content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No Markdown content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No Markdown content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No Markdown content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No Markdown content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],178:[function(require,module,exports){
/**
 * InputType `MarkdownDisplay` -- a labelled, read-only field that renders the markdown held in its
 * value. Use it for a remark a user typed; use InputType `Markdown` for static markdown authored in
 * the manifest (an Instructions block), which is what that one's templates are gated for.
 *
 * Like `Markdown`, this has no Tabular templates: the display element is addressed per input, not
 * per row.
 */
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],179:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MaterialSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Material) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MaterialSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],180:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'MaterialsEntitySelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsEntitySelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsEntitySelector',
			DefaultInputExtensions: [ 'MaterialsEntitySelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsEntitySelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsEntitySelector',
			DefaultInputExtensions: [ 'MaterialsEntitySelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'MaterialsEntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsEntitySelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'MaterialsEntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsEntitySelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsEntitySelector',
			Template: /*HTML-Partial*/`
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'MaterialsEntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsEntitySelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'MaterialsEntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsEntitySelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsEntitySelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],181:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabSelector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLabSelector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],182:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemSelector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLineItemSelector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLineItemSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],183:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
				/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}
				value=""
				/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenSampleSelector',
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenSampleSelector',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],184:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestInjector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],185:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestSelector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestSelector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],186:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<p class="control">
				<input
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],187:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<p class="control">
				<input
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLineItemSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLineItemSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],188:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MaterialsPlantSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (ProductionPlant) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MaterialsPlantSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],189:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-qrcode"></i>
					</span>
					<span class="icon-text">No QR code available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">No QR code available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-qrcode"></i>
					</span>
					<span class="icon-text">No QR code available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">No QR code available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-qrcode"></i>
					</span>
					<span class="icon-text">No QR code available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">No QR code available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],190:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="control">
						<button class="button is-link" type="button" {~Disabled:Record~} onclick="_Pict.views.HeadlightPaneSamples.openSamplePanelFromAdvancedButton(event)">
							<span class="icon is-small">
								<i class="fas fa-bars-filter"></i>
							</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],191:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestInjector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
							>

							<option value="">Select...</option>
						</select>
					</p>
					<p class="control">
						<button
							id="ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-link"
							type="button"
							onclick="{~P~}.providers.MaterialsTestInjector.registerTest({~P~}.ContentAssignment.readContent('#MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}'),
								{~P~}.providers.MaterialsTestInjector._generateSaltStr())">

							<span class="icon">
								<i class="fa fa-fw fa-plus"></i>
							</span>
							<span>Add Test</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth has-addons has-addons-right">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
				<p class="control">
					<button
						id="ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
						class="button is-link"
						type="button"
						onclick="{~P~}.providers.MaterialsTestInjector.registerTest({~P~}.ContentAssignment.readContent('#MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}'),
							{~P~}.providers.MaterialsTestInjector._generateSaltStr())">

						<span class="icon">
							<i class="fa fa-fw fa-plus"></i>
						</span>
						<span>Add Test</span>
					</button>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestInjector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}

			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestInjector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],192:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'MaterialsTestLabSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsTestLabSelector',
			DefaultInputExtensions: [ 'MaterialsTestLabSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
				title="Show all (ignore filters)"
				onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
				<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
			</a>
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestLabSelector',
			DefaultInputExtensions: [ 'MaterialsTestLabSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<p class="control">
				<input
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestLabSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],193:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			DefaultInputExtensions: [ 'MaterialsTestSectionRemover' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} -->
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} pt-0 pb-0">
				<a id="SECTION-REMOVER-FOR-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost has-text-danger is-pulled-right p-0 is-size-7"
					title="Remove this test and its section from the form"
					onclick="{~P~}.providers.MaterialsTestSectionRemover.requestSectionRemoval('{~D:Record.PictForm.SectionRemovalHash~}')">
					<span class="icon"><i class="fas fa-trash-alt"></i></span><span class="icon-text">Remove Test</span>
				</a>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} (not available in read mode) -->
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} (not rendered in print mode) -->
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],194:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<p class="control">
				<input
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],195:[function(require,module,exports){
// The MediaDetailCards InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.MediaDetailCards applies the correct settings
// (deckLayout: 'details', filters for actionable observation types) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MediaDetailCards',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MediaDetailCards; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MediaDetailCards',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MediaDetailCards; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MediaDetailCards',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MediaDetailCards; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],196:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MixSpecificationSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (MixSpecification) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MixSpecificationSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],197:[function(require,module,exports){
// Themed metatemplates for InputType 'ObjectEditor' (pict-section-form's ObjectEditor input, which
// embeds pict-section-objecteditor as an interactive JSON tree). Mirrors InputType-Picker.js's Bulma
// chrome (column / field / label / help) so the editor inherits Headlight's form styling instead of the
// minimal base template, whose bare "<span>Name:</span>" sat inline-left of the tree inside the flex
// .columns row. The control is the host div the ObjectEditor provider mounts the tree into; the element
// ids + ControlAttr match what Pict-Provider-Input-ObjectEditor expects (DISPLAY-FOR-<RawHTMLID>).
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive tree for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div class="field">
							<div class="control">
								<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME — locked/read-only. The same tree renders non-editable (Editable:false via PictForm.ReadOnly). */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor (read) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME — non-interactive PDF. Same host; the tree paints read-only. */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor (print) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],198:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- set selector for non-sets use case or for when showSetSelector option is true (used instead of filters above) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-selector {~Show:Record.PictForm.CardDeckSettings.useObservationSetSelector~}">
								<div class="field has-addons has-addons-right has-addons-left is-fullwidth mr-1 mb-0">
									<p class="control">
										<button
											id="EDIT-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											class="button is-link"
											type="button"
											disabled
											onclick="_Pict.providers.ObservationCardDeckProvider.handleObservationSetEditButtonClick('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}')"
											>
											<span class="icon">
												<i class="fa fa-fw fa-cog"></i>
											</span>
										</button>
									</p>
									<p class="control control-status select is-fullwidth">
										<span class="control-status-icon"></span>
										<select
											id="CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											{~Required:Record~}
											{~Disabled:Record~}
											onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
										>
											<option value="">Select a set...</option>
										</select>
									</p>
									<p class="control">
										<button
											id="CREATE-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											class="button is-link"
											type="button"
											onclick="_Pict.providers.ObservationCardDeckProvider.handleObservationSetCreateSetButtonClick('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}')"
										>
											<span class="icon">
												<i class="fa fa-fw fa-plus"></i>
											</span>
											<span>Create New Set</span>
										</button>
									</p>
								</div>
							</div>
							<!-- Action buttons for the card deck -->
							<div id="CARD-DECK-HEADER-ACTIONS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-actions">
								<div class="buttons has-addons observation-card-deck-style-toggle mr-1 mb-0">
									<button type="button" 
										class="button is-active" 
										title="Thumbnail" 
										data-deck-style="thumbnail" 
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'thumbnail')">
										<span class="icon">
											<i class="fa fa-fw fa-th"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="List"
										data-deck-style="list"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'list')">
										<span class="icon">
											<i class="fa fa-fw fa-list"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="Details"
										data-deck-style="details"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'details')">
										<span class="icon">
											<i class="fa fa-fw fa-id-card"></i>
										</span>
									</button>
								</div>
								<div class="buttons has-addons mb-0 {~Hide:Record.PictForm.CardDeckSettings.preventAddingCards~}">
									<button type="button"
										id="CARD-DECK-HEADER-ACTIONS-ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
										class="button is-link is-skeleton" 
										title="Add" 
										data-deck-action="add" 
										onclick="_Pict.providers.ObservationCardDeckProvider.handleAddNewCardToDeckButtonEvent(event, '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false)">
										<span class="icon">
											<i class="fa fa-fw fa-plus"></i>
										</span>
										<span class="icon-text">Add</span>
									</button>
									<!-- Quick capture button - actually a file input styled as a button -->
									<label
										id="CARD-DECK-HEADER-ACTIONS-QUICK-CAPTURE-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
										class="button is-clickable is-link is-skeleton"
										style="border-left: 1px solid var(--bulma-border);"
									>
										<input
											title="Quick Capture - Take a photo with your device's camera"
											type="file"
											class="file-input"
											name="user"
											capture="environment"
											accept="image/*"
											onchange="_Pict.providers.ObservationCardDeckProvider.handleAddNewCardToDeckButtonEvent(event, '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true)"
										/>
											<div class="{~Hide:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~} mr-2">
												<i class="fas fa-fw fa-camera"></i>
											</div>
											<div class="{~Show:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~} mr-2">
												<i class="fa fa-fw {~D:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~}"></i>
											</div>
											<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}">Quick Capture</span>
											<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}">{~D:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}</span>
									</label>
								</div>
							</div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<p class="control control-status">
							<span class="control-status-icon"></span>
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}><span class="initial-loading-message"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">No items have been added to this collection.</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}</span>
								</div>
							</div>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- Action buttons for the card deck -->
							<div id="CARD-DECK-HEADER-ACTIONS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-actions">
								<div class="buttons has-addons observation-card-deck-style-toggle mr-1 mb-0">
									<button type="button" 
										class="button is-active" 
										title="Thumbnail" 
										data-deck-style="thumbnail" 
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'thumbnail')">
										<span class="icon">
											<i class="fa fa-fw fa-th"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="List"
										data-deck-style="list"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'list')">
										<span class="icon">
											<i class="fa fa-fw fa-list"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="Details"
										data-deck-style="details"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'details')">
										<span class="icon">
											<i class="fa fa-fw fa-id-card"></i>
										</span>
									</button>
								</div>
							</div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<p class="control">
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}><span class="initial-loading-message"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">No items have been added to this collection.</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}</span>
								</div>
							</div>
						</p>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} for-print-only" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<div class="control">
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage:No items have been added to this collection.~}</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],199:[function(require,module,exports){
// The ObservationImageSet InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.ObservationImageSet applies the correct settings
// (useObservationSet: true, filters for 'Legacy Image' type) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],200:[function(require,module,exports){
// The ObservationSet InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.ObservationStandardSet applies the correct settings
// (useObservationSet: true, useObservationSetSelector: true) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],201:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeSelector' ],
			Template: /*HTML*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="OBSERVATIONTYPE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="OBSERVATIONTYPE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select an observation type...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		// TODO: Build missing template for Tabular mode
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="OBSERVATIONTYPE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="OBSERVATIONTYPE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ObservationTypeSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="OBSERVATIONTYPE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="OBSERVATIONTYPE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ObservationTypeSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],202:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "Option" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "Option" in the manifest -- no manifest edit is needed;
	the broker maps its static SelectOptions / SelectOptionsPickList onto the picker, and
	PickerDisplay resolves the same option label for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Option; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],203:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="tel"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-phone fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="tel"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-phone fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="tel"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-phone fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="tel"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-phone fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="tel"
									class="input"
									readonly aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-phone fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="tel"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-phone fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- DataType PhoneNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],204:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetSelector' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<span class="control-status-icon"></span>
								<select
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									{~Required:Record~}
									{~Disabled:Record~}
									onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
								>
									<option value="">Select an asset type...</option>
								</select>
							</p>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<span class="control-status-icon"></span>
								<select
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
								>
									<option value="">Select an asset...</option>
								</select>
							</p>
						</div>
					</div>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetDisplay' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									class="input"
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
								></div>
							</p>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
								></div>
							</p>
						</div>
					</div>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetDisplay' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<div class="control">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									class="input is-static"
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<div class="control">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],205:[function(require,module,exports){
// Themed metatemplates for InputType 'Picker' (pict-section-picker via the Headlight Picker provider).
// Mirrors InputType-EntitySelectorMultiple.js's Bulma chrome (column / field / label / help) so the
// picker inherits Headlight's form styling + the row's flex alignment — only the control differs: a
// host element the picker renders into, where the <select> used to be.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
			<!-- InputType Picker {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.Picker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
			<!-- InputType Picker {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<div class="field">
							<p class="control control-status">
								<span class="control-status-icon"></span>
								<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			// Tabular (one picker per RecordSet row). Split Begin/End so the row's informary attributes
			// inject into the hidden input; the picker provider mounts into the PICKER-TABULAR host below.
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							{~Required:Record~}
							data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
							value="" />
						<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
							title="Show all (ignore filters)"
							onclick="_Pict.providers.Picker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
							<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
						</a>
						<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~} data-i-index="{~D:Context[2].Key~}"></span>
					</p>
				</div>`,
		},
	],
	/* READ THEME — locked / non-interactive in-browser state. A static resolved-value display painted by
	   the PickerDisplay provider (not the interactive picker), styled as a locked control. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType Picker (read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- InputType Picker (read display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-3">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="field">
								<p class="control">
									<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
								</p>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control">
						<div
							id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}
							disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			Template: /*HTML-Partial*/`
						></div>
					</p>
				</div>`,
		},
	],
	/* PRINT THEME — non-interactive PDF. Same resolved value, painted by PickerDisplay into a static node
	   styled for PDF output (independent of the Read theme's locked-control look). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType Picker (print display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- InputType Picker (print display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular print display) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div
					id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static wrap-selections-for-print"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],206:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "PlantSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (ProductionPlant) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "PlantSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],207:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input has-text-right pr-3"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							disabled
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input has-text-right pr-3"
									{~D:Record.Macro.ControlAttr~}
									type="text"
									tabindex="-1"
									readonly
									disabled
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input has-text-right pr-3"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						type="text"
						tabindex="-1"
						readonly
						disabled
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input has-text-right pr-3"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							disabled
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<input
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input has-text-right pr-3"
									{~D:Record.Macro.ControlAttr~}
									tabindex="-1"
									readonly
									disabled
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input has-text-right pr-3"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						type="text"
						tabindex="-1"
						readonly
						disabled
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static has-text-right"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							value=""
						/>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static has-text-right"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<div
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						class="input is-static has-text-right"
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],208:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`
			<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="PREVIOUS-VALUE-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
			 />
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
			 />
			<div class="column {~ColumnWidth:Record~}" id="PARENT-FOR-{~D:Record.Macro.RawHTMLID~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-checkbox-with-label pb-3 mb-0 has-addons has-addons-right {~ColumnAlignment:Record~}">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							style="padding-right: 40px;"
							disabled="disabled"
							placeholder="{~Placeholder:Record~}"
							autocomplete="off"
							value=""
						></div>
					</p>
					<p class="control">
						<button
							id="CLEAR-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-ghost"
							type="button"
							style="position: absolute; right: 0; width: 40px; visiblity: hidden;"
							onclick="
								const ele = {~P~}.ContentAssignment.getElement('#{~D:Record.Macro.RawHTMLID~}')[0];
								if (ele)
								{
									ele.value = '';
									{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}');
								}"
						>
							<span class="icon">
								<i class="fa fa-fw fa-times"></i>
							</span>
						</button>
					</p>
					<p class="control">
						<button
							id="EDIT-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-link"
							type="button"
							onclick="{~P~}.views.HeadlightPaneObservations.selectObservations({
								SingleSelect: true,
								FileType: 'application/pdf',
								UIFocusViewHash: '{~D:Record.Hash~}',
								UIFocusInputName: 'Precompiled PDF',
								SearchActionLabel: 'Select'
							},
							(obsInfos) =>
							{
								if (obsInfos.length > 0)
								{
									const ele = {~P~}.ContentAssignment.getElement('#{~D:Record.Macro.RawHTMLID~}')[0];
									if (ele)
									{
										ele.value = obsInfos[0].IDObservation;
										{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}');
									}
								}
							})"
						>
							<span class="icon">
								<i class="fa fa-fw fa-paperclip"></i>
							</span>
							<span>Attach PDF</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`
			<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="PREVIOUS-VALUE-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
			 />
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
			 />
			<div class="column {~ColumnWidth:Record~}" id="PARENT-FOR-{~D:Record.Macro.RawHTMLID~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-checkbox-with-label pb-2 mb-0 has-addons has-addons-right {~ColumnAlignment:Record~}">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							style="padding-right: 40px;"
							disabled="disabled"
							autocomplete="off"
							value=""
						></div>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} (does not print) -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],209:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "ProducerSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Organization) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "ProducerSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],210:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "ProductSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Product) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "ProductSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],211:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "ProjectSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Project) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "ProjectSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],212:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							{~D:Record.Macro.InputFullProperties~}
							readonly
							disabled
							tabindex="-1"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									{~D:Record.Macro.InputFullProperties~}
									readonly
									disabled
									tabindex="-1"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly
						disabled
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							class="input {~ColumnAlignment:Record~}"
							readonly
							aria-readonly="true"
							{~D:Record.Macro.InputFullProperties~}
							value=""
							tabindex="-1"
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									class="input {~ColumnAlignment:Record~}"
									readonly
									aria-readonly="true"
									{~D:Record.Macro.InputFullProperties~}
									value=""
									tabindex="-1"
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						class="input {~ColumnAlignment:Record~}"
						readonly
						aria-readonly="true"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						readonly
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],213:[function(require,module,exports){
// Headlight templates for the PSF `RichText` (markdown editor) InputType. Standard + Vertical across
// Edit/Read/Print; the shared builder and the {~EditorBody:~} macro own the presentation. Tabular is
// unsupported by design (the provider throws). See EditorTemplates.js / EditorBodies.js.
const { buildEditorTemplates } = require('./EditorTemplates.js');

module.exports = buildEditorTemplates('RichText');

},{"./EditorTemplates.js":154}],214:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleHiddenStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="SAMPLE-STATUS-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenStatusSelector',
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<div
				style="display: none;"
				id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenStatusSelector',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],215:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleHiddenTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					class="input"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenTestResult',
			Template: /*HTML-Partial*/`
					value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display:none;"
				id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenTestResult',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],216:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select a sample...</option>
						</select>
					</p>
					<p class="control">
						<button class="button is-link" type="button" onclick="_Pict.views.HeadlightPaneSamples.openSamplePanelFromAdvancedButton(event)">
							<span class="icon is-small">
								<i class="fas fa-bars-filter"></i>
							</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleSelector',
			DefaultInputExtensions: [ 'SampleSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="SAMPLE-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleSelector',
			DefaultInputExtensions: [ 'SampleSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="SAMPLE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="SAMPLE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],217:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-STATUS-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-STATUS-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="SAMPLE-STATUS-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-STATUS-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-STATUS-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-STATUS-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleStatusSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-STATUS-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleStatusSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],218:[function(require,module,exports){
// Themed metatemplates for InputType 'SampleTestAcceptance' — the unified test acceptance control.
// Mirrors InputType-Picker.js's Bulma chrome (column / field / label / help) since this IS a picker, and
// adds the Remarks disclosure that shows and hides the sibling RichText remarks field.
//
// Deliberately group-weight, not section-weight: this block closes out the test above it, so it carries
// no section header treatment. The "Test Results" heading it replaced is what read as a new test.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column test-acceptance-column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="is-flex is-align-items-flex-end">
						<p class="control control-status test-acceptance-result">
							<span class="control-status-icon"></span>
							<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
						</p>
						<a id="TEST-ACCEPTANCE-REMARKS-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
							class="button is-small is-ghost test-acceptance-remarks-toggle ml-2"
							title="Show or hide remarks"
							onclick="_Pict.providers.SampleTestAcceptance.toggleRemarks('{~D:Record.Hash~}')">
							<span class="icon"><i class="fas fa-fw fa-chevron-right"></i></span><span class="icon-text">Remarks</span>
						</a>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<div class="field">
							<div class="is-flex is-align-items-flex-end">
								<p class="control control-status test-acceptance-result">
									<span class="control-status-icon"></span>
									<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
								</p>
								<a id="TEST-ACCEPTANCE-REMARKS-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
									class="button is-small is-ghost test-acceptance-remarks-toggle ml-2"
									title="Show or hide remarks"
									onclick="_Pict.providers.SampleTestAcceptance.toggleRemarks('{~D:Record.Hash~}')">
									<span class="icon"><i class="fas fa-fw fa-chevron-right"></i></span><span class="icon-text">Remarks</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							{~Required:Record~}
							data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML-Partial*/`
							value="" />
						<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~} data-i-index="{~D:Context[2].Key~}"></span>
					</p>
				</div>`,
		},
	],
	/* READ THEME — locked in-browser state, painted by the PickerDisplay provider. The remarks field
	   renders through its own descriptor, so there is no disclosure here. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (read display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular read) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<p class="control">
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="PICKER-TABULAR-DISPLAY-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
				</p>`,
		},
	],
	/* PRINT THEME — non-interactive, for PDF documents. */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (print) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (print, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular print) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<p class="control">
					<input
						id="PICKER-TABULAR-DISPLAY-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input is-static"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
				</p>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],219:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-TEST-RESULT-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-TEST-RESULT-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-TEST-RESULT-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-TEST-RESULT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-TEST-RESULT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],220:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "SampleTypeSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the SampleTypePicker provider — the thin Picker
	subclass carrying this selector's SampleType<->legacy-MaterialType cascade (forward Hash mirror +
	reverse seed; see PictProvider-InputType-SampleTypePicker) — READ / PRINT attach PickerDisplay. Every
	theme includes the matching Picker template by reference (single source of the picker markup).
	This is a SPECIALIZED selector: its Entity (SampleType) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "SampleTypeSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],221:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "Select2" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "Select2" in the manifest -- no manifest edit is needed;
	the broker maps its static SelectOptions / SelectOptionsPickList onto the picker, and
	PickerDisplay resolves the same option label for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],222:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "Select2Multiple" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "Select2Multiple" in the manifest -- no manifest edit is needed;
	the broker maps its static SelectOptions and infers multi-select from the InputType name;
	PickerDisplay resolves the option labels for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],223:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded signature-preview-container">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							{~Disabled:Record~}
							data-validation-surface="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
							{~Disabled:Record~}
							onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
						/>
						<button
							type="button"
							class="button is-small is-link signature-edit-button"
							title="Edit Signature" aria-label="Edit signature"
							{~Disabled:Record~}
							onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
						>
							<span class="icon is-small"><i class="fas fa-pen"></i></span>
						</button>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status is-expanded signature-preview-container">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~Required:Record~}
									{~Disabled:Record~}
									data-validation-surface="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
									value=""
								/>
								<img
									id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="signature-preview-image" alt="Signature preview"
									{~Disabled:Record~}
									onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
								/>
								<button
									type="button"
									class="button is-small is-link signature-edit-button"
									title="Edit Signature" aria-label="Edit signature"
									{~Disabled:Record~}
									onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
								>
									<span class="icon is-small"><i class="fas fa-pen"></i></span>
								</button>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field mb-0">
				<p class="control control-status is-expanded signature-preview-container">
					<span class="control-status-icon"></span>
					<input
						id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						{~D:Record.Macro.InformaryTabular~}
						{~Required:Record~}
						{~Disabled:Record~}
						data-validation-surface="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
						value=""
					/>
					<img
						id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="signature-preview-image" alt="Signature preview"
						{~Disabled:Record~}
						onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~}, {~D:Record.PictForm.Disabled~});"
					/>
					<button
						type="button"
						class="button is-small is-link signature-edit-button"
						title="Edit Signature" aria-label="Edit signature"
						{~Disabled:Record~}
						onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~}, {~D:Record.PictForm.Disabled~});"
					>
						<span class="icon is-small"><i class="fas fa-pen"></i></span>
					</button>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						{~D:Record.Macro.InputFullProperties~}
						{~Required:Record~}
						{~Disabled:Record~}
						value=""
					/>
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control is-expanded">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
						/>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~Required:Record~}
							{~Disabled:Record~}
							value=""
						/>
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.InformaryTabular~}
					{~Required:Record~}
					{~Disabled:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
					value=""
				/>
				<img
					id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="signature-preview-image" alt="Signature preview"
				/>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						{~D:Record.Macro.InputFullProperties~}
						{~Required:Record~}
						{~Disabled:Record~}
						value=""
					/>
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control is-expanded">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image print-only-signature-preview" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~Required:Record~}
							{~Disabled:Record~}
							value=""
						/>
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image print-only-signature-preview" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="control is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.InformaryTabular~}
					{~Required:Record~}
					{~Disabled:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
					value=""
				/>
				<img
					id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="signature-preview-image print-only-signature-preview" alt="Signature preview"
				/>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],224:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<p class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<p class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<div class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],225:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							{~D:Record.Macro.InputFullProperties~}
							readonly
							tabindex="-1"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									{~D:Record.Macro.InputFullProperties~}
									readonly
									tabindex="-1"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="{~D:Record.DataType~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							readonly
							{~D:Record.Macro.InputFullProperties~}
							value=""
							tabindex="-1"
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="{~D:Record.DataType~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									readonly
									{~D:Record.Macro.InputFullProperties~}
									value=""
									tabindex="-1"
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="{~D:Record.DataType~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						readonly
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						readonly
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],226:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="field has-addons has-addons-right mb-0">
						<p class="control control-status has-icons-left is-expanded">
							<span class="control-status-icon"></span>
							<input
								id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								type="text"
								class="input {~ColumnAlignment:Record~}"
								{~D:Record.Macro.ControlAttr~}
								{~Required:Record~}
								{~Disabled:Record~}
								placeholder="{~Placeholder:Record~}"
								onchange="{~D:Record.Macro.DataRequestFunction~}"
								autocomplete="off"
								value=""
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-sign-post fa-xs"></i>
							</span>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									autocomplete="off"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-sign-post fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						placeholder="{~Placeholder:Record~}"
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-sign-post fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-sign-post fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-sign-post fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="STATION-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<p class="control has-icons-left">
				<input
					id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input {~ColumnAlignment:Record~}"
					{~D:Record.Macro.ControlAttr~}
					readonly aria-readonly="true"
					{~D:Record.Macro.HTMLName~}
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-sign-post fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- DataType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="text"
				class="input {~ColumnAlignment:Record~}"
				readonly aria-readonly="true"
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static {~ColumnAlignment:Record~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],227:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-building fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-building fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-building fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StreetAddress',
			Template: /*HTML*/`
			<!-- InputType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-building fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									{~D:Record.Macro.InputChangeHandler~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-building fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
			<!-- InputType StreetAddress  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-building fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StreetAddress',
			Template: /*HTML*/`
			<!-- DataType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
			<!-- InputType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],228:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="column px-0 {~ColumnWidth:Record~}">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 >
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabGroupName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="column px-0 {~ColumnWidth:Record~}">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 />
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabGroupName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<input
				class="pict-tab-group-print-host"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			 >
			<!-- NOTE: Intentionally empty in PRINT mode. The marker class lets the provider's CSS
			     collapse the host group, which would otherwise reserve an empty band in the PDF. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],229:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabSectionSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="container">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 />
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabSectionName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabSectionSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="container">
				<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabSectionName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabSectionSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<input
				class="pict-tab-group-print-host"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			 />
			<!-- NOTE: Intentionally empty in PRINT mode. The marker class lets the provider's CSS
			     collapse the host group, which would otherwise reserve an empty band in the PDF. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],230:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup', {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				 	type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}
					`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
					value="">
				<div
					id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
				></div>
			</p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
									readonly
									value=""
								></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
					value="">
				<div
					id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value="">
							<div
								id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
								{~D:Record.Macro.ControlAttr~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
				value="">
			<div
				id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],231:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<textarea
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							rows="2"
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
						></textarea>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML*/`
				<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-3">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="field">
								<p class="control control-status">
									<span class="control-status-icon"></span>
									<textarea
										id="{~D:Record.Macro.RawHTMLID~}"
										class="textarea"
										{~D:Record.Macro.ControlAttr~}
										placeholder="{~Placeholder:Record~}"
										rows="2"
										{~Required:Record~}
										{~Disabled:Record~}
										{~D:Record.Macro.InputFullProperties~}
										{~D:Record.Macro.InputChangeHandler~}
									></textarea>
								</p>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<textarea
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						rows="2"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
					></textarea>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<textarea
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							rows="2"
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
						></textarea>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<textarea
									id="{~D:Record.Macro.RawHTMLID~}"
									class="textarea"
									{~D:Record.Macro.ControlAttr~}
									rows="2"
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
								></textarea>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<textarea
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="textarea"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				rows="2"
				readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			></textarea>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<div
								id="{~D:Record.Macro.RawHTMLID~}"
								class="textarea is-static"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="textarea is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],232:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- InputType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help">{~D:Record.Description~}</p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- InputType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-UpdateAwareNumber',
			Template: /*HTML*/`
			<!-- InputType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber' ],
			Template: /*HTML*/`
			<!-- DataType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input cell pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
			<!-- UpdateAwareNumber Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-UpdateAwareNumber',
			Template: /*HTML*/`
			<!-- UpdateAwareNumber Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber' ],
			Template: /*HTML*/`
			<!-- DataType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input cell pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],233:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">
					<!-- Opt-in top add bar (Group.EntryControls.Position 'top'/'both'); renders nothing otherwise -->
					{~EntryAddBarTop:Record~}`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
					<div class="section-content has-text-right {~HideBottomEntryControls:Record~}" data-recordset-controls="add-set">
						{~EntryModeToggleButton:Record~}
						<button class="button is-link"
							id="RECORDSET-ADD-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
							data-max-sets="{~D:Record.MaximumRowCount~}"
							data-min-sets="{~D:Record.MinimumRowCount~}"
							type="button"
							onclick="_Pict.providers['Bulma-RecordSetControls'].handleAddEntryButtonClickEvents(event, '{~D:Context[0].Hash~}', '{~D:Record.GroupIndex~}');"
						>
							<span class="icon">
								<i class="fas fa-plus"></i>
							</span>
							<span>Add new set</span>
						</button>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			// Scroll anchor for "Finish and go to Record". Row-ExtraPrefix is the only
			// slot rendered against the {Value, Key, Group} row record, so it is the
			// only place Record.Key / Record.Group resolve.
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->
						<span class="recordset-entry-anchor is-sr-only" data-recordset-group-index="{~D:Record.Group~}" data-recordset-row-index="{~D:Record.Key~}"></span>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->
			<div class="PictSectionForm-RecordSet-Controls buttons is-right {~HideRecordSetControls:Record~}" data-recordset-controls="manage-set">
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('Delete', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-trash"></i>
					</span>
					<span>Delete</span>
				</a>
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('MoveUp', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-arrow-up"></i>
					</span>
					<span>Up</span>
				</a>
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('MoveDown', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-arrow-down"></i>
					</span>
					<span>Down</span>
				</a>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content" style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
							<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content" style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content"  style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],234:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-table-wrapper mb-2 {~HideTableControls:Record~}">
					<!-- Opt-in top add bar (Group.EntryControls.Position 'top'/'both'); renders nothing otherwise -->
					{~EntryAddBarTop:Record~}
					<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container"
						onscroll="_Pict.providers['Bulma-TableControls'].updateSliderFromScrollTableEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)">
						<table id="TABLE-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
							<thead>
								<tr>
									{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
									<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
									<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">
										<span class="label {~HideLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</span>
										{~UnitsTabularHeader:Record~}
									</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPostfix -->
									<th class="extra-table-column" data-table-controls="menu"></th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRowHeader-ExtraPostfix~}
								</tr>
							</thead>
							<tbody>`,
		},
		/*
		 * BEGIN Tabular Template Extra Header Rows
		 * Used for stacked/clustered headers (the Group's `Headers` config).
		 * Each entry in Headers is one ADDITIONAL header row stacked above the
		 * default column-name row. Cells carry { Label, ColumnSpan, CSSClass }.
		 */
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderRow-Prefix',
			'Template': /*HTML*/`
								<tr class="pict-tabular-extra-header-row">`,
		},
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderRow-Postfix',
			'Template': /*HTML*/`
								</tr>`,
		},
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderCell',
			'Template': /*HTML*/`
									<th colspan="{~D:Record.ColumnSpan~}" class="pict-tabular-extra-header-cell {~D:Record.CSSClass~}">{~D:Record.Label~}</th>`,
		},
		/*
		 * END Tabular Template Extra Header Rows
		 */

		/*
		 * BEGIN Tabular Template Row Label Columns
		 * Used for left-side label columns (the Group's `RowLabels` config).
		 * Header cell renders one <th> per RowLabels entry. Per-row cell renders
		 * one <td> per RowLabels entry; rowspans collapse consecutive equal
		 * values when `Cluster: true`. Skipped cells emit nothing (a real <td>
		 * upstream has already covered them via rowspan).
		 */
		{
			'HashPostfix': '-TabularTemplate-RowLabel-HeaderCell',
			'Template': /*HTML*/`
									<th class="pict-row-label-header">{~D:Record.Name~}</th>`,
		},
		{
			'HashPostfix': '-TabularTemplate-RowLabel-Cell',
			'Template': /*HTML*/`
									<td rowspan="{~D:Record.RowSpan~}" class="pict-row-label">{~D:Record.RenderedLabel~}</td>`,
		},
		{
			'HashPostfix': '-TabularTemplate-RowLabel-Cell-Skipped',
			'Template': ``,
		},
		/*
		 * END Tabular Template Row Label Columns
		 */

		/*
		 * BEGIN Entry-modal field cells
		 * Used ONLY by the opt-in "add in a dialog" flow
		 * (Group.EntryControls.Mode === 'modal'), which composes a stacked,
		 * labeled one-record template out of the SAME tabular input
		 * metatemplates the grid uses -- see
		 * PictProvider-Bulma-TableControls.buildModalRowTemplate. The grid's own
		 * cell templates emit bare <td>s, which are invalid inside the modal's
		 * <div> and carry no labels (those live in the <th>s), so they cannot be
		 * reused directly the way the RecordSet layout's can.
		 *
		 * NOTE: deliberately no {~D:Record.Macro.HTMLForID~}. That macro resolves
		 * to an id tabular inputs never emit (they use
		 * TABULAR-DATA-{RawHTMLID}-{Key}), so a `for` attribute would dangle.
		 */
		{
			HashPostfix: '-TabularTemplate-ModalCell-Prefix',
			Template: /*HTML*/`
					<div class="column {~EntryModalCellClass:Record~}">
						<label class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</label>
						{~UnitsTabularHeader:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-ModalCell-Postfix',
			Template: /*HTML*/`
						<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
					</div>`,
		},
		/*
		 * END Entry-modal field cells
		 */

		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
								<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
									{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
									<td  data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPostfix -->
									<td class="extra-table-column" data-table-controls="menu">
										<button
											id="TABLE-MENU-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Group~}-{~D:Record.Key~}"
											class="button is-link is-outlined"
											type="button"
											aria-haspopup="true"
											aria-label="Row actions"
											onmouseover="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '{~D:Context[0].UUID~}', '{~D:Context[0].Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}', event)"
											onclick="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '{~D:Context[0].UUID~}', '{~D:Context[0].Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}', event)">
											<span class="icon is-small">
												<i class="fas fa-ellipsis" aria-hidden="true"></i>
											</span>
										</button>
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix-TableMenu',
			Template: /*HTML*/`
				<!-- TabularTemplate-RowHeader-ExtraPostfix-TableMenu -->
				<ul class="list-menu">
					<li class="list-menu-item">
						<a class="delete-table-row-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('Delete', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-trash" aria-hidden="true"></i>
							</span>
							<span>Delete</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a class="move-table-row-up-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('MoveUp', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-arrow-up" aria-hidden="true"></i>
							</span>
							<span>Move Up</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a class="move-table-row-down-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('MoveDown', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-arrow-down" aria-hidden="true"></i>
							</span>
							<span>Move Down</span>
						</a>
					</li>
				</ul>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRow-ExtraPostfix~}
								</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
								<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
								<!-- empty message row - auto hidden by CSS -->
								<tr class="table-emtpy-row">
									<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
										<span class="icon">
											<i class="fa fa-fw fa-info-circle"></i>
										</span>
										<span class="icon-text">{~TabularEmptyMessage:Record:No rows have been added.~}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- NOTE: Columns are required here for the flexible scroll slider and add button -->
					<div class="columns is-vcentered is-mobile p-0 m-0 {~HideBottomEntryControls:Record~}">
						<div class="column ml-6 p-0 mb-3">
							<div id="TABLE-SLIDER-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="field is-hidden" data-table-controls="scroll-slider">
								<input
									id="TABLE-SLIDER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
									class="slider"
									type="range"
									min="0"
									max="100"
									value="0"
									oninput="_Pict.providers['Bulma-TableControls'].updateScrollTableFromSliderEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)"
									/>
							</div>
						</div>
						<div class="column mx-3 px-0 pt-0 has-text-right is-narrow">
							<button type="button" id="TABLE-TOGGLE-EXTRA-COLUMN-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
								data-table-controls="toggle-extra-column"
								class="button is-link is-outlined mr-2 {~HideMenuColumnToggle:Record~}"
								onclick="_Pict.providers['Bulma-TableControls'].handleToggleExtraColumnButtonClickEvents(event, '{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}')">
								<span class="icon">
									<i class="fas fa-eye" aria-hidden="true"></i>
								</span>
								<span> Hide Menu Column</span>
							</button>
							{~EntryModeToggleButton:Record~}
							<button type="button" id="TABLE-ADD-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
								data-table-controls="add-row"
								data-max-rows="{~D:Record.MaximumRowCount~}"
								data-min-rows="{~D:Record.MinimumRowCount~}"
								class="button is-link"
								onclick="_Pict.providers['Bulma-TableControls'].handleAddEntryButtonClickEvents(event, '{~D:Context[0].Hash~}', '{~D:Record.GroupIndex~}')">
								<span class="icon">
									<i class="fas fa-plus" aria-hidden="true"></i>
								</span>
								<span> Add new row</span>
							</button>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-table-wrapper mb-2 {~HideTableControls:Record~}">
					<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container"
						onscroll="_Pict.providers['Bulma-TableControls'].updateSliderFromScrollTableEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)">
						<table id="TABLE-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
							<thead>
								<tr>
									{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
									<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
									<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">
										<span class="label {~HideLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</span>
										{~UnitsTabularHeader:Record~}
									</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRowHeader-ExtraPostfix~}
								</tr>
							</thead>
							<tbody>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
								<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
									{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
									<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRow-ExtraPostfix~}
								</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
								<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
								<!-- empty message row - auto hidden by CSS -->
								<tr class="table-emtpy-row">
									<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
										<span class="icon">
											<i class="fa fa-fw fa-info-circle"></i>
										</span>
										<span class="icon-text">{~TabularEmptyMessage:Record:No data available.~}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- NOTE: Columns are required here for the flexible scroll slider and add button -->
					<div class="columns is-vcentered is-mobile m-0 p-0">
						<div class="column ml-6 p-0 mb-3">
							<div id="TABLE-SLIDER-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="field is-hidden">
								<input
									id="TABLE-SLIDER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
									class="slider"
									type="range"
									min="0"
									max="100"
									value="0"
									oninput="_Pict.providers['Bulma-TableControls'].updateTableControlsFromSliderEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)"
									/>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<!-- NOTE: We preserve the overflow behavior of the table container to prevent PDFs from becoming distorted - wide tables will need to provide an alternate print layout -->
				<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container mb-2">
					<table class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
						<thead>
							<tr>
								{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
								<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
								<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}" style="vertical-align: bottom">
									{~LabelWithChips:Record~}
									{~UnitsTabularHeader:Record~}
								</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
								<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
								<!-- TabularTemplateRowHeader-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
								{~T:TabularTemplateRowHeader-ExtraPostfix~}
							</tr>
						</thead>
						<tbody>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
							<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
								{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
								<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="is-vcentered {~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
								</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
								<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
								<!-- TabularTemplateRow-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
								{~T:TabularTemplateRow-ExtraPostfix~}
							</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
							<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
							<!-- empty message row - auto hidden by CSS -->
							<tr class="table-emtpy-row">
								<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text">{~TabularEmptyMessage:Record:No data available.~}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],235:[function(require,module,exports){
// TODO: Remove the need for this file by scanning the templates directory
// and generating the index automatically.

module.exports = [
	/* require('./_empty.js'), */
	require('./DataType-Date.js'),
	require('./DataType-DateTime.js'),
	require('./DataType-Default.js'),
	require('./DataType-Number.js'),
	require('./DataType-PreciseNumber.js'),
	require('./DataType-String.js'),
	require('./DataType-Time.js'),
	require('./Form-Container.js'),
	require('./InputType-Boolean.js'),
	require('./InputType-BridgeSelector.js'),
	require('./InputType-Color.js'),
	require('./InputType-Chart.js'),
	require('./InputType-EmailAddress.js'),
	require('./InputType-EntityDisplay.js'),
	require('./InputType-EntitySelector.js'),
	require('./InputType-EntitySelectorMultiple.js'),
	require('./InputType-FileSelector.js'),
	require('./InputType-GeolocationSelector.js'),
	require('./InputType-GeolocationSelectorWithMap.js'),
	require('./InputType-CloneAction.js'),
	require('./InputType-Diagram.js'),
	require('./InputType-HTML.js'),
	require('./InputType-LabSelector.js'),
	require('./InputType-Link.js'),
	require('./InputType-LineItemSelector.js'),
	require('./InputType-Markdown.js'),
	require('./InputType-MarkdownDisplay.js'),
	require('./InputType-MaterialSelector.js'),
	require('./InputType-MaterialsEntitySelector.js'),
	require('./InputType-SampleTypeSelector.js'),
	require('./InputType-MaterialsHiddenSampleSelector.js'),
	require('./InputType-MaterialsHiddenTestInjector.js'),
	require('./InputType-MaterialsHiddenTestSelector.js'),
	require('./InputType-MaterialsHiddenLineItemSelector.js'),
	require('./InputType-MaterialsSampleSelector.js'),
	require('./InputType-MaterialsQRCodeDisplay.js'),
	require('./InputType-MaterialsTestInjector.js'),
	require('./InputType-MaterialsTestSectionRemover.js'),
	require('./InputType-MaterialsTestSelector.js'),
	require('./InputType-MaterialsLineItemSelector.js'),
	require('./InputType-MaterialsLabSelector.js'),
	require('./InputType-MaterialsTestLabSelector.js'),
	require('./InputType-MaterialsPlantSelector.js'),
	require('./InputType-MaterialsHiddenLabSelector.js'),
	require('./InputType-MediaDetailCards.js'),
	require('./InputType-MixSpecificationSelector.js'),
	require('./InputType-ObjectEditor.js'),
	require('./InputType-ObservationImageSet.js'),
	require('./InputType-ObservationSet.js'),
	require('./InputType-ObservationCardDeck.js'),
	require('./InputType-ObservationTypeSelector.js'),
	require('./InputType-Option.js'),
	require('./InputType-PhoneNumber.js'),
	require('./InputType-PhysicalAssetSelector.js'),
	require('./InputType-Picker.js'),
	require('./InputType-SampleTestAcceptance.js'),
	require('./InputType-PlantSelector.js'),
	require('./InputType-PreciseNumberReadOnly.js'),
	require('./InputType-PrecompiledFileSelector.js'),
	require('./InputType-ProducerSelector.js'),
	require('./InputType-ProductSelector.js'),
	require('./InputType-ProjectSelector.js'),
	require('./InputType-ReadOnly.js'),
	require('./InputType-RichText.js'),
	require('./InputType-SampleHiddenStatusSelector.js'),
	require('./InputType-SampleHiddenTestResult.js'),
	require('./InputType-SampleSelector.js'),
	require('./InputType-SampleStatusSelector.js'),
	require('./InputType-SampleTestResult.js'),
	require('./InputType-Select2.js'),
	require('./InputType-Select2Multiple.js'),
	require('./InputType-Signature.js'),
	require('./InputType-StaticLabel.js'),
	require('./InputType-StaticText.js'),
	require('./InputType-Station.js'),
	require('./InputType-StreetAddress.js'),
	require('./InputType-TabGroupSelector.js'),
	require('./InputType-TabSectionSelector.js'),
	require('./InputType-TextArea.js'),
	require('./InputType-UpdateAwareNumber.js'),
	require('./Recordset-Group.js'),
	require('./Tabular-Group.js'),

	// questionable templates that may not be used
	require('./InputType-ExistingDisabledByDefault.js'),
	require('./InputType-DocumentDate.js'),
	require('./InputType-TemplatedEntityLookup.js'),
];

},{"./DataType-Date.js":146,"./DataType-DateTime.js":147,"./DataType-Default.js":148,"./DataType-Number.js":149,"./DataType-PreciseNumber.js":150,"./DataType-String.js":151,"./DataType-Time.js":152,"./Form-Container.js":155,"./InputType-Boolean.js":158,"./InputType-BridgeSelector.js":159,"./InputType-Chart.js":160,"./InputType-CloneAction.js":161,"./InputType-Color.js":162,"./InputType-Diagram.js":163,"./InputType-DocumentDate.js":164,"./InputType-EmailAddress.js":165,"./InputType-EntityDisplay.js":166,"./InputType-EntitySelector.js":167,"./InputType-EntitySelectorMultiple.js":168,"./InputType-ExistingDisabledByDefault.js":169,"./InputType-FileSelector.js":170,"./InputType-GeolocationSelector.js":171,"./InputType-GeolocationSelectorWithMap.js":172,"./InputType-HTML.js":173,"./InputType-LabSelector.js":174,"./InputType-LineItemSelector.js":175,"./InputType-Link.js":176,"./InputType-Markdown.js":177,"./InputType-MarkdownDisplay.js":178,"./InputType-MaterialSelector.js":179,"./InputType-MaterialsEntitySelector.js":180,"./InputType-MaterialsHiddenLabSelector.js":181,"./InputType-MaterialsHiddenLineItemSelector.js":182,"./InputType-MaterialsHiddenSampleSelector.js":183,"./InputType-MaterialsHiddenTestInjector.js":184,"./InputType-MaterialsHiddenTestSelector.js":185,"./InputType-MaterialsLabSelector.js":186,"./InputType-MaterialsLineItemSelector.js":187,"./InputType-MaterialsPlantSelector.js":188,"./InputType-MaterialsQRCodeDisplay.js":189,"./InputType-MaterialsSampleSelector.js":190,"./InputType-MaterialsTestInjector.js":191,"./InputType-MaterialsTestLabSelector.js":192,"./InputType-MaterialsTestSectionRemover.js":193,"./InputType-MaterialsTestSelector.js":194,"./InputType-MediaDetailCards.js":195,"./InputType-MixSpecificationSelector.js":196,"./InputType-ObjectEditor.js":197,"./InputType-ObservationCardDeck.js":198,"./InputType-ObservationImageSet.js":199,"./InputType-ObservationSet.js":200,"./InputType-ObservationTypeSelector.js":201,"./InputType-Option.js":202,"./InputType-PhoneNumber.js":203,"./InputType-PhysicalAssetSelector.js":204,"./InputType-Picker.js":205,"./InputType-PlantSelector.js":206,"./InputType-PreciseNumberReadOnly.js":207,"./InputType-PrecompiledFileSelector.js":208,"./InputType-ProducerSelector.js":209,"./InputType-ProductSelector.js":210,"./InputType-ProjectSelector.js":211,"./InputType-ReadOnly.js":212,"./InputType-RichText.js":213,"./InputType-SampleHiddenStatusSelector.js":214,"./InputType-SampleHiddenTestResult.js":215,"./InputType-SampleSelector.js":216,"./InputType-SampleStatusSelector.js":217,"./InputType-SampleTestAcceptance.js":218,"./InputType-SampleTestResult.js":219,"./InputType-SampleTypeSelector.js":220,"./InputType-Select2.js":221,"./InputType-Select2Multiple.js":222,"./InputType-Signature.js":223,"./InputType-StaticLabel.js":224,"./InputType-StaticText.js":225,"./InputType-Station.js":226,"./InputType-StreetAddress.js":227,"./InputType-TabGroupSelector.js":228,"./InputType-TabSectionSelector.js":229,"./InputType-TemplatedEntityLookup.js":230,"./InputType-TextArea.js":231,"./InputType-UpdateAwareNumber.js":232,"./Recordset-Group.js":233,"./Tabular-Group.js":234}],236:[function(require,module,exports){
// This is just a placeholder file for the 'Base' theme which is the Default Theme for all Pict templates.
// View source the file at `../../../../pict-section-form/source/providers/dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js`

module.exports = (
	{
		TemplatePrefix: 'Pict-MT-Base',
		Templates: [],
	}
);

},{}],237:[function(require,module,exports){
// This is just a placeholder file for the 'Edit' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Edit theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Edit',
		Templates: [],
	}
);

},{}],238:[function(require,module,exports){
// This is just a placeholder file for the 'Print' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Print theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Print',
		Templates: [],
	}
);

},{}],239:[function(require,module,exports){
// This is just a placeholder file for the 'Read' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Read theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Read',
		Templates: [],
	}
);

},{}],240:[function(require,module,exports){
/* eslint-disable quotes */
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('headlight-configurable-application').Fable} Fable */

const libPictView = require('pict-view');

// Static image assets inlined as data URIs so they work in both online
// and offline (iOS WKWebView) contexts without relying on relative paths
// that single-file capture can't resolve for dynamically-rendered templates.
//TODO: this is to support offline but is a bit hard to support - see if we can make this more robust
const HASHES_PNG_DATA_URI = 'data:image/png;base64,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';
const LOGO_GRAY_PNG_DATA_URI = 'data:image/png;base64,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';

class FormHeader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		/** @type {Fable} */
		this.fable = pFable;
	}
}

module.exports = FormHeader;

module.exports.default_configuration =
{
	ViewIdentifier: "FormHeader",
	DefaultRenderable: "Form-Header",
	DefaultDestinationAddress: "#Headlight-View-Header",
	AutoRender: false,
	CSS: /*css*/``,
	Templates: [
		// NOTE: This is the header for the entire form. It is not a section or group. It does not respect theme changes... so print view tweaks need to be done via CSS.
		{
			Hash: 'Form-Header',
			Template: /*HTML*/`
			<!-- Pict Form Header Container -->
			<div id="Headlight-Dynamic-Header-Container">
				<div id="HeadLight-Branding-ColorSwatches" class="column pt-1 pr-0 pb-0 pl-0 has-text-centered">
					<img class="image" width="300" style="margin:auto" src="${HASHES_PNG_DATA_URI}" alt="HeadLight Branding Color Swatches">
				</div>
				<section class="form-header-content">
					<div class="columns is-mobile is-vcentered">
						<div class="column" id="Document-Logo-Wrapper">
							<img class="image"
								style="max-height: 75px"
								src="/1.0/Customer/SecondaryLogo/{~D:AppData.DocumentData.ReportData.IDCustomer~}?SessionToken={~D:AppData.DocumentData.SessionToken~}"
								alt="Logo"
								onerror="this.onerror = null; this.src = '${LOGO_GRAY_PNG_DATA_URI}'" />
						</div>
						<div class="column has-col-span-3 has-text-right">
							<h1 class="title is-5">{~D:AppData.DocumentData.ReportOptions.Meta.reportTitle~}{~D:AppData.DocumentData.ReportData.Name~}</h1>
							<h2 class="subtitle is-7 mb-0">{~D:AppData.DocumentData.ReportOptions.Meta.projectTitle~}{~D:AppData.DocumentData.ReportData.Project.Name~}</h2>
							<div class="is-size-7 has-text-grey">
								<span id="Headlight-Dyanmic-Header-Shift">{~TIfAbs:Form-Header-Night-Shift:AppData:AppData.DocumentData.ReportData.Shift^==^Night~}</span>
								<span id="Headlight-Dyanmic-Header-DocumentDate">{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^dddd, MMMM Do YYYY^~}</span>
							</div>
							<div class="is-size-7 has-text-grey">Form #{~D:AppData.DocumentData.ReportData.SequenceNumber~}</div>
							<div id="Document-Program-Title" class="is-size-7 title m-0 p-0">{~D:AppData.DocumentData.ReportData.ProgramName~}</div>
						</div>
					</div>
				</section>
			</div>`,
		},
		{
			Hash: 'Form-Header-Night-Shift',
			Template: /*html*/`
			<i class="fas fa-fw fa-moon"></i> Night Shift - `,
		},
	],
	Renderables: [
		{
			RenderableHash: "Form-Header",
			TemplateHash: "Form-Header",
			DestinationAddress: "#Headlight-View-Header",
		},
	],
};

},{"pict-view":693}],241:[function(require,module,exports){
/* eslint-disable quotes */
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('headlight-configurable-application').Fable} Fable */

const libPictLeafletView = require('pict-section-leaflet');

class GeolocationSelector extends libPictLeafletView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		/** @type {Fable} */
		this.fable = pFable;
		/** @type {import('leaflet').Map} */
		this.leaflet = null;
		/** @type {any} */
		this.options;
		/** @type {string} */
		this.rawHTMLID;
	}

	/**
	 * Returns the HTML ID for the map based on the input HTML ID.
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @return {string} - The HTML ID for the map.
	 */
	getMapHTMLID(pInputHTMLID)
	{
		return `MAP-FOR-${pInputHTMLID}`;
	}

	getInitialMapLocation()
	{
		let tmpLocation = null;
		if (this.pict.AppData?.DocumentData?.ReportData?.Project?.Latitude && this.pict.AppData?.DocumentData?.ReportData?.Project?.Longitude)
		{
			const tmpLat = Number(this.pict.AppData.DocumentData.ReportData.Project.Latitude);
			const tmpLng = Number(this.pict.AppData.DocumentData.ReportData.Project.Longitude);
			tmpLocation = {
				lat: tmpLat,
				lng: tmpLng,
			};
		}
		return tmpLocation;
	}

	/**
	 * Called before the view is rendered.
	 * This method sets up options for leaflet initialization.
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		this.options.LeafletDestinationAddress = this.getMapHTMLID(this.rawHTMLID);
		const initialCenter = this.getInitialMapLocation();
		if (initialCenter)
		{
			//FIXME: need to remove state from the view (if it is shared)
			this.leafletInitialCenter = initialCenter;
		}
		// set the flag based on the input type
		//FIXME: need to address this now that the record is no longer plumbed in here
		//this.options.hideLeafletMap = pRecord.PictForm.InputType !== 'GeolocationSelectorWithMap';
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Called after the view is rendered.
	 * The method stores leaflet data after initialization for the provider to access
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		if (!this.pict.AppData.LeafletMapsData)
		{
			this.pict.AppData.LeafletMapsData = {};
		}
		this.pict.AppData.LeafletMapsData[this.rawHTMLID] = {
			map: this.leaflet,
			RawHTMLID: this.rawHTMLID,
			destinationAddress: this.options.LeafletDestinationAddress,
			hideMap: this.options.hideLeafletMap,
			marker: null,
			location: {
				Latitude: '',
				Longitude: '',
			},
		};
	}

	/**
	 * Called after the Leaflet map is initialized.
	 * This method is responsible for loading the map tiles and setting up the initial view.
	 * @return {void}
	 */
	onAfterInitializeLeaflet()
	{
		// Load tiles
		const libLeaflet = window.L;
		// using this.leaflet only works here because this is called during super.onAfterRender
		// https tiles (avoids mixed-content when the report is served over https) + the canonical host.
		this.tileLayer = libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		{
			maxZoom: 19,
			attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
		}).addTo( this.leaflet );
	}
}

module.exports = GeolocationSelector;

module.exports.default_configuration =
{
	ViewIdentifier: "GeolocationSelector",
	DefaultRenderable: "GeolocationSelector",
	DefaultDestinationAddress: "#GeolocationSelector-Container",
	AutoRender: false,
	CSS: /*css*/``,
	Templates: [
		{
			Hash: "GeolocationSelector",
			Template: /*html*/`
			<div id="MAP-FOR-{~D:Record.Macro.RawHTMLID~}" style="min-height: 320px; z-index: 1;"></div>
			`,
		},
	],
	Renderables: [
		{
			RenderableHash: "GeolocationSelector",
			TemplateHash: "GeolocationSelector",
			DestinationAddress: "#GeolocationSelector-Container",
		},
	],
};

},{"pict-section-leaflet":573}],242:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');
const libPictSectionModal = require('pict-section-modal');
const libHeadlightModalAdapter = require('./HeadlightModalAdapter.js');

/**
 * HeadlightModal
 *
 * Confirmation / dialog / loader broker for Headlight. This used to hand-build Bulma
 * `.modal` / `.modal-card` DOM; it now drives the pict-section-modal (PSM) view's
 * `show()` API, which gives the shared overlay, Escape/focus/ARIA, transitions and
 * CSS-variable theming for free.
 *
 * The public surface (spawnModal / spawnMiniModal / addLoader / dismissLoader /
 * dismissModals / freezeBodyScroll / unfreezeBodyScroll, plus the mutable
 * confirmCallback / cancelCallback slots) is preserved so the ~25 call sites and the
 * `_Pict.fable.HeadlightModal.*()` onclick strings embedded in their template HTML keep
 * working unchanged.
 *
 * Option translation lives in the pure `HeadlightModalAdapter`; everything impure — the
 * PSM call, live-DOM append + autofocus + `<style>` injection in onOpen, the
 * callback<->dismiss bridge, the body scroll-lock, and the singleton dismiss — lives here.
 */
class HeadlightModalFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment'), views: object, CSSMap: object }}
		 */
		this.fable;
		// store this for the "jump to top" issue that may occur when modals are dismissed
		this.lastScrollPosition = 0;

		this.serviceType = 'HeadlightModal';

		this.loaderActive = false;

		// Pure legacy-options -> PSM-options translator (no DOM / Fable deps).
		this._adapter = new libHeadlightModalAdapter();
		// The panel-close "MiniModal" preset, exposed on the instance so views can spread it:
		//   spawnMiniModal({ ...this.fable.HeadlightModal.MiniModalPreset, message: '...' }, cb)
		this.MiniModalPreset = libHeadlightModalAdapter.MiniModalPreset;
		// The live PSM dialog element for the current modal (singleton), or null.
		this._activeDialog = null;

		// default configuration for the modal
		this.configDefault = {
			modalId: 'Headlight-Utility-Modal',
			modalBodyId: 'Headlight-Utility-Modal-Body',
			modalHeaderId: 'Headlight-Utility-Modal-Header',
			modalFooterId: 'Headlight-Utility-Modal-Footer',
			modalCardTemplate: null,
			modalHeaderTemplate: null,
			modalBodyTemplate: null,
			modalFooterTemplate: null,
			modalCustomCSS: null,
			hideModalBackground: false,
			hideModalHeader: false,
			hideModalBody: false,
			hideModalFooter: false,
			title: 'Confirmation',
			message: 'Are you sure?',
			confirmText: 'Okay',
			confirmIcon: 'check',
			confirmColor: 'is-link',
			cancelText: 'Cancel',
			cancelIcon: 'times',
			cancelColor: 'is-link is-soft',
			style: 'small',
			enableBackgroundScrolling: false,
			disableBackgroundClickToClose: false,
		};
		this.configActive = Object.assign({}, this.configDefault);
		// default callbacks for the modal
		this.confirmCallback = () =>
		{
			this.dismissModals();
		};
		this.cancelCallback = () =>
		{
			this.dismissModals();
		};
	}

	/**
	 * Resolve the pict-section-modal view, registering it as a singleton on first use if
	 * the host app hasn't already. Tolerates both registration names in use (canonical
	 * 'Pict-Section-Modal', and the form-editor's 'PictSectionModal'). Mirrors
	 * Headlight-Popover-Service so the modal stays a drop-in service.
	 *
	 * @returns {Object|false} The PSM view instance, or false if unavailable.
	 */
	_getModal()
	{
		if (!this.fable || !this.fable.views)
		{
			this.fable.log.error('HeadlightModalFableService: pict-section-modal is unavailable (no views registry)');
			return false;
		}
		let tmpModal = this.fable.views['Pict-Section-Modal'] || this.fable.views['PictSectionModal'];
		if (!tmpModal && typeof this.fable.addViewSingleton === 'function')
		{
			this.fable.addViewSingleton('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
			tmpModal = this.fable.views['Pict-Section-Modal'];
		}
		if (!tmpModal)
		{
			this.fable.log.error('HeadlightModalFableService: could not resolve the Pict-Section-Modal view');
			return false;
		}
		return tmpModal;
	}

	/**
	 * Generic modal creation utility. Signature preserved from the legacy service; the
	 * options object is translated to a PSM `show()` call. See HeadlightModalAdapter for
	 * the option mapping.
	 *
	 * @param {object} configOptions - Behaviors/parts of the modal to customize/override.
	 * @param {function} [confirmCallback] - Called on confirm.
	 * @param {function} [cancelCallback] - Called on cancel.
	 * @return {void}
	 */
	spawnModal(configOptions = {}, confirmCallback, cancelCallback)
	{
		this._spawn(Object.assign({}, this.configDefault, configOptions), confirmCallback, cancelCallback, { mini: false });
	}

	/**
	 * Mini modal creation utility — the compact panel-close confirmation. Signature
	 * preserved. NOTE: the legacy first-arg-is-a-function misuse (three call sites passed
	 * `spawnMiniModal(() => {...})`) is normalized here so the confirm action fires.
	 *
	 * @param {object|function} pConfigOptions
	 * @param {function} [confirmCallback]
	 * @param {function} [cancelCallback]
	 * @return {void}
	 */
	spawnMiniModal(pConfigOptions = {}, confirmCallback, cancelCallback)
	{
		// Legacy bug fix: a function passed as the first arg is really the confirm callback.
		if (typeof pConfigOptions === 'function')
		{
			cancelCallback = confirmCallback;
			confirmCallback = pConfigOptions;
			pConfigOptions = {};
		}
		if (!pConfigOptions)
		{
			pConfigOptions = {};
		}

		// mini structural defaults (the brand + offset come from the caller / MiniModalPreset)
		pConfigOptions.message = pConfigOptions.message || 'Close panel?';
		pConfigOptions.subtext = pConfigOptions.subtext || 'Any unsaved changes may be lost.';
		pConfigOptions.confirmText = pConfigOptions.confirmText || 'Confirm';
		pConfigOptions.confirmIcon = pConfigOptions.confirmIcon || 'fa-check-circle';
		pConfigOptions.confirmColor = pConfigOptions.confirmColor || '';
		pConfigOptions.cancelText = pConfigOptions.cancelText || 'Cancel';
		pConfigOptions.cancelIcon = pConfigOptions.cancelIcon || 'fa-times-circle';
		pConfigOptions.cancelColor = (pConfigOptions.cancelColor !== undefined && pConfigOptions.cancelColor !== null) ? pConfigOptions.cancelColor : 'is-light';
		pConfigOptions.disableBackgroundClickToClose = true;
		// The mini is a compact colored card — no title/header bar (parity with the legacy
		// .modal-card-mini dropdown, which had none).
		if (pConfigOptions.hideModalHeader === undefined || pConfigOptions.hideModalHeader === null)
		{
			pConfigOptions.hideModalHeader = true;
		}

		this._spawn(Object.assign({}, this.configDefault, pConfigOptions), confirmCallback, cancelCallback, { mini: true });
	}

	/**
	 * Anchored, backdrop-less menu (e.g. the navbar download menu). Wraps PSM's
	 * `dropdown()` in ContentHTML mode, which gives anchor positioning, auto-flip,
	 * click-outside / Escape dismissal and viewport clamping — replacing the old
	 * `spawnModal({ modalCardTemplate, hideModalBackground })` + hand-rolled
	 * getBoundingClientRect positioning + document click-outside closer.
	 *
	 * @param {HTMLElement|string|object} pAnchor - element, selector, or rect
	 * @param {string} pContentHTML - the menu markup (onclick strings preserved verbatim)
	 * @param {object} [pOptions] - passed through to PSM dropdown (align, position, className, maxWidth, ...)
	 * @returns {Promise<*>|false}
	 */
	spawnAnchoredMenu(pAnchor, pContentHTML, pOptions)
	{
		const tmpModal = this._getModal();
		if (!tmpModal)
		{
			return false;
		}
		if (this.fable.CSSMap && typeof this.fable.CSSMap.injectCSS === 'function')
		{
			this.fable.CSSMap.injectCSS();
		}
		const tmpOptions = Object.assign({ className: 'headlight-modal-menu' }, pOptions || {});
		tmpOptions.ContentHTML = pContentHTML;
		return tmpModal.dropdown(pAnchor, tmpOptions);
	}

	/**
	 * Dismiss the open anchored menu / dropdown (e.g. to toggle it closed from its
	 * own trigger button). Modals-only — never touches toasts/tooltips.
	 * @returns {void}
	 */
	dismissAnchoredMenu()
	{
		const tmpModal = this.fable.views && (this.fable.views['Pict-Section-Modal'] || this.fable.views['PictSectionModal']);
		if (tmpModal && typeof tmpModal.dismissDropdowns === 'function')
		{
			tmpModal.dismissDropdowns();
		}
	}

	/**
	 * Shared spawn path for spawnModal / spawnMiniModal.
	 * @param {object} pConfig - fully merged config
	 * @param {function} [pConfirmCallback]
	 * @param {function} [pCancelCallback]
	 * @param {object} pContext - { mini: boolean }
	 * @private
	 */
	_spawn(pConfig, pConfirmCallback, pCancelCallback, pContext)
	{
		this.configActive = pConfig;

		// Singleton: dismiss any existing modal first.
		this.dismissModals();

		// Wire callbacks (kept as instance methods so embedded onclick strings resolve).
		if (pConfirmCallback)
		{
			this.confirmCallback = async () =>
			{
				try
				{
					await pConfirmCallback();
				}
				catch (e)
				{
					console.error('Error in modal Confirm callback: ', e);
				}
				this.dismissModals();
			};
		}
		if (pCancelCallback)
		{
			this.cancelCallback = async () =>
			{
				try
				{
					await pCancelCallback();
				}
				catch (e)
				{
					console.error('Error in modal Cancel callback: ', e);
				}
				this.dismissModals();
			};
		}

		const tmpModal = this._getModal();
		if (!tmpModal)
		{
			return;
		}

		// PSM's view CSS is registered but only injected on render; it never renders
		// through the normal cycle, so inject explicitly (mirrors Headlight-Popover).
		if (this.fable.CSSMap && typeof this.fable.CSSMap.injectCSS === 'function')
		{
			this.fable.CSSMap.injectCSS();
		}

		const tmpPlan = this._adapter.translate(pConfig, pContext);

		const tmpShowOptions =
		{
			title: tmpPlan.title,
			content: tmpPlan.content,
			// Footer buttons are Bulma .button elements inside `content` (so FontAwesome
			// icons + the onclick->confirmCallback/cancelCallback coupling survive); PSM's
			// own button array stays empty.
			buttons: [],
			closeable: tmpPlan.closeable,
			onOpen: (pDialog) => { this._onDialogOpen(pDialog, tmpPlan, pConfig); },
			onClose: () => { this._onDialogClose(); },
		};
		if (tmpPlan.width)
		{
			tmpShowOptions.width = tmpPlan.width;
		}

		// Freeze background scroll (unless the caller opted out) BEFORE showing.
		if (tmpPlan.freezeScroll)
		{
			this.freezeBodyScroll();
		}

		tmpModal.show(tmpShowOptions);
	}

	/**
	 * Post-open DOM work PSM can't do from a string `content`: stamp our classes, append
	 * any live-element templates, inject custom CSS, position a mini modal, and restore the
	 * legacy autofocus (PSM focuses the first button; forms want the first input).
	 * @private
	 */
	_onDialogOpen(pDialog, pPlan, pConfig)
	{
		this._activeDialog = pDialog;

		// Classes (z-index for panels is handled by psm-modal.scss via the body navbar
		// class; these drive the wide/mini/brand looks).
		if (pPlan.className)
		{
			let tmpClasses = pPlan.className.split(/\s+/);
			for (let i = 0; i < tmpClasses.length; i++)
			{
				if (tmpClasses[i]) { pDialog.classList.add(tmpClasses[i]); }
			}
		}

		let tmpBody = pDialog.querySelector('.pict-modal-dialog-body');

		// Live-element templates (rare — most templates are HTML strings handled in content).
		if (tmpBody)
		{
			if (pPlan.cardElement) { this._appendElement(tmpBody, pConfig.modalCardTemplate); }
			if (pPlan.headerElement) { this._appendElement(tmpBody, pConfig.modalHeaderTemplate); }
			if (pPlan.bodyElement) { this._appendElement(tmpBody, pConfig.modalBodyTemplate); }
			if (pPlan.footerElement) { this._appendElement(tmpBody, pConfig.modalFooterTemplate); }
		}

		// Default footer as a real .pict-modal-dialog-footer band — a sibling of the body,
		// so the buttons sit below the (scrollable) body instead of overlapping its content.
		if (pPlan.footerContent)
		{
			let tmpFooter = document.createElement('div');
			tmpFooter.className = 'pict-modal-dialog-footer';
			tmpFooter.innerHTML = pPlan.footerContent;
			pDialog.appendChild(tmpFooter);
		}

		// Custom CSS as a <style> (textContent, never parsed as HTML — no injection surface).
		if (pPlan.customCSS)
		{
			let tmpStyle = document.createElement('style');
			tmpStyle.textContent = pPlan.customCSS;
			pDialog.appendChild(tmpStyle);
		}

		// Mini modal: anchor top-right below the navbar. Inline styles beat PSM's centering.
		// Drop the transform transition so it fades in place instead of sliding in from the
		// centered origin (which read as a top-left slide).
		if (pPlan.topOffset)
		{
			pDialog.style.position = 'fixed';
			pDialog.style.top = pPlan.topOffset;
			pDialog.style.right = '8px';
			pDialog.style.left = 'auto';
			pDialog.style.bottom = 'auto';
			pDialog.style.transform = 'none';
			pDialog.style.margin = '0';
			pDialog.style.transition = 'opacity var(--pict-modal-transition-duration, 0.18s) ease';
		}

		// Restore legacy autofocus: first visible, enabled input/textarea in the body.
		if (pPlan.focusFirstInput && tmpBody)
		{
			let tmpInput = tmpBody.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');
			if (tmpInput)
			{
				tmpInput.focus();
				if (typeof tmpInput.select === 'function') { tmpInput.select(); }
			}
		}
	}

	/**
	 * PSM fired onClose (button click routed through our callbacks, or ×/Escape/overlay
	 * dismiss). PSM has already removed the dialog; reset our state. User callbacks are NOT
	 * run here — the footer buttons run them directly; ×/Escape/overlay are a plain dismiss
	 * (parity with the legacy background-click).
	 * @private
	 */
	_onDialogClose()
	{
		this._activeDialog = null;
		this._resetAfterClose();
	}

	/**
	 * Reset callbacks to their dismiss-only defaults and release the scroll lock.
	 * Idempotent.
	 * @private
	 */
	_resetAfterClose()
	{
		this.confirmCallback = () =>
		{
			this.dismissModals();
		};
		this.cancelCallback = () =>
		{
			this.dismissModals();
		};
		if (typeof document !== 'undefined' && document.body && document.body.style.position === 'fixed')
		{
			this.unfreezeBodyScroll();
		}
	}

	/**
	 * Append a live DOM element (nodeType 1) into a parent. String templates never reach
	 * here — the adapter folds those into `content`.
	 * @private
	 */
	_appendElement(pParent, pContent)
	{
		if (pContent && typeof pContent === 'object' && pContent.nodeType === 1)
		{
			pParent.appendChild(pContent);
		}
	}

	addLoader(message)
	{
		if (!this.loaderActive)
		{
			this.loaderActive = true;

			const tmpLoader = document.createElement('div');
			tmpLoader.id = 'modal-service-loader';
			tmpLoader.className = 'modal is-active';

			const tmpBg = document.createElement('div');
			tmpBg.className = 'modal-background delayed-fade-in-bg';
			tmpLoader.appendChild(tmpBg);

			const tmpContent = document.createElement('div');
			tmpContent.className = 'modal-content';
			tmpContent.style.backgroundColor = 'rgba(1, 1, 1, 0)';

			const tmpSplash = document.createElement('div');
			tmpSplash.className = 'is-loading-splash delayed-fade-in';
			tmpSplash.style.zIndex = '25';
			tmpSplash.style.backgroundColor = 'rgba(1, 1, 1, 0)';

			const tmpTitle = document.createElement('h1');
			tmpTitle.className = 'title';
			tmpTitle.textContent = message || 'Loading...';

			tmpSplash.appendChild(tmpTitle);
			tmpContent.appendChild(tmpSplash);
			tmpLoader.appendChild(tmpContent);
			document.body.appendChild(tmpLoader);
		}
	}

	dismissLoader()
	{
		document.querySelectorAll('#modal-service-loader')?.forEach?.(l => l.remove());
		this.loaderActive = false;
	}

	/**
	* Dismiss the currently open modal (singleton). Dismisses the PSM dialog — whose
	* onClose resets our state — and falls back to a direct reset when no dialog is tracked.
	* @return {void}
	*/
	dismissModals()
	{
		const tmpDialog = this._activeDialog;
		this._activeDialog = null;

		if (tmpDialog && typeof tmpDialog._dismiss === 'function' && !tmpDialog._dismissed)
		{
			// PSM removes the node and fires onClose -> _onDialogClose -> _resetAfterClose.
			tmpDialog._dismiss(null);
			return;
		}

		// No live dialog to dismiss (or already dismissed): reset directly.
		this._resetAfterClose();
	}

	/**
	* Fix the body background so that it's not scrollable when a modal is open.
	* @return {void}
	*/
	freezeBodyScroll()
	{
		this.lastScrollPosition = window.scrollY;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${this.lastScrollPosition}px`;
		document.body.style.overflow = 'hidden';
		document.body.style.width = '100%';
	}

	/**
	* Reset the body background so that it's scrollable when a modal is closed.
	* @return {void}
	*/
	unfreezeBodyScroll()
	{
		const tmpScrollPosition = this.lastScrollPosition;
		document.body.style.position = '';
		document.body.style.top = '';
		//this is required to ensure that sticky headers stick
		document.body.style.overflow = 'visible';
		document.body.style.width = '';
		window.scrollTo(0, tmpScrollPosition);
		// reset for next time
		this.lastScrollPosition = 0;
	}
}

module.exports = HeadlightModalFableService;
module.exports.default_configuration = {};
// Re-export so callers can `spawnMiniModal({ ...HeadlightModal.MiniModalPreset, message })`.
module.exports.MiniModalPreset = libHeadlightModalAdapter.MiniModalPreset;

},{"./HeadlightModalAdapter.js":243,"fable-serviceproviderbase":398,"pict-section-modal":590}],243:[function(require,module,exports){
/**
 * HeadlightModalAdapter
 *
 * Pure, framework-free translation between the legacy HeadlightModal option shape
 * (`spawnModal` / `spawnMiniModal` `configOptions`) and the Pict-Section-Modal (PSM)
 * `show()` API. Kept dependency-free (no Pict, no DOM) so it is unit-testable in
 * isolation — mirrors `HeadlightToastAdapter`.
 *
 * Division of labour: this class only DECIDES the PSM option shape and builds HTML
 * strings. The broker (`Headlight-Modal-Service`) owns everything impure — the PSM
 * call, live-DOM append + autofocus + `<style>` injection in `onOpen`, the
 * callback<->promise bridge, the body scroll-lock, and the singleton dismiss.
 *
 * Why the footer is built as HTML `content` (not PSM's `buttons[]`): PSM escapes
 * button labels (`Pict-Modal-Window._escapeHTML`), so FontAwesome icons cannot ride
 * in a `buttons[]` Label, and consumer-supplied footer templates already embed
 * `onclick="_Pict.fable.HeadlightModal.confirmCallback()"`. Emitting a Bulma-button
 * footer into `content` (with `buttons: []` passed to PSM) preserves the icons, the
 * onclick coupling, and the exact look — PSM still owns the shell (overlay, header,
 * ×, Escape, focus, theming). The broker keeps `confirmCallback`/`cancelCallback`
 * alive so those onclick strings resolve unchanged.
 */

// The global the embedded footer onclick strings resolve to — identical to the legacy
// service so consumer-supplied footer templates keep working verbatim.
const SERVICE_GLOBAL = '_Pict.fable.HeadlightModal';

/**
 * The panel-close "MiniModal" look + behaviour, lifted OUT of the service so each
 * calling view passes it explicitly: `spawnMiniModal({ ...MiniModalPreset, message }, ...)`.
 * (Was previously copy-pasted across the headlight_panels views.)
 */
const MiniModalPreset =
{
	modalTopOffset: '65px',
	modalBackgroundColor: 'has-background-primary-80',
	modalTextColor: 'has-text-primary-20',
	confirmColor: 'is-primary',
	cancelColor: 'is-soft is-primary',
};

class HeadlightModalAdapter
{
	/**
	 * Escape HTML special characters for safe embedding of plain-text values.
	 * @param {string} pText
	 * @returns {string}
	 */
	escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	/**
	 * True when the value is a live DOM element. Checked structurally (nodeType === 1)
	 * so this stays pure — no `document`/`HTMLElement` reference needed.
	 * @param {*} pValue
	 * @returns {boolean}
	 */
	isElement(pValue)
	{
		return !!(pValue && typeof pValue === 'object' && pValue.nodeType === 1);
	}

	/**
	 * Map a legacy Bulma button color string onto the emphasis the footer button
	 * should carry. De-emphasized markers (`is-soft`/`is-light`) win over `primary`/
	 * `link` so a "soft link" cancel stays neutral; `danger` always wins.
	 * @param {string} pColor
	 * @returns {'danger'|'primary'|null}
	 */
	mapButtonEmphasis(pColor)
	{
		let tmpColor = (typeof pColor === 'string') ? pColor : '';
		if (/(^|\s)(is-)?danger(\s|$)/.test(tmpColor))
		{
			return 'danger';
		}
		if (/(^|\s)is-(soft|light)(\s|$)/.test(tmpColor))
		{
			return null;
		}
		if (/(^|\s)(is-)?(primary|link)(\s|$)/.test(tmpColor))
		{
			return 'primary';
		}
		return null;
	}

	/**
	 * Build a single Bulma footer button whose onclick resolves to the broker's
	 * kept-alive callback method. `pIconClass` is the FontAwesome glyph class WITHOUT
	 * the `fas fa-fw ` prefix (e.g. `fa-check` or `fa-check-circle`); pass null/'' for none.
	 * @param {string} pHash - 'confirm' | 'cancel' (drives the onclick method + button id suffix)
	 * @param {string} pText
	 * @param {string} pIconClass
	 * @param {string} pColorClass - raw legacy Bulma color class(es), applied verbatim to the button
	 * @param {string} [pFooterId] - optional id prefix for the button (legacy parity)
	 * @returns {string}
	 */
	buildButtonHTML(pHash, pText, pIconClass, pColorClass, pFooterId)
	{
		let tmpMethod = (pHash === 'confirm') ? 'confirmCallback' : 'cancelCallback';
		let tmpColor = (typeof pColorClass === 'string') ? pColorClass : '';
		let tmpIdAttr = pFooterId ? ' id="' + this.escapeHTML(pFooterId) + '-Button-' + (pHash === 'confirm' ? 'Confirm' : 'Cancel') + '"' : '';
		let tmpIconHTML = '';
		if (pIconClass)
		{
			// Normalize: accept 'fa-check' or bare 'check' (legacy confirmIcon default is 'check').
			let tmpGlyph = (/^fa-/.test(pIconClass)) ? pIconClass : ('fa-' + pIconClass);
			tmpIconHTML = '<span class="icon"><i class="fas fa-fw ' + this.escapeHTML(tmpGlyph) + '"></i></span>';
		}
		return '<button type="button"' + tmpIdAttr + ' class="button ' + this.escapeHTML(tmpColor) + '"' +
			' onclick="' + SERVICE_GLOBAL + '.' + tmpMethod + '()">' +
			tmpIconHTML +
			'<span> ' + this.escapeHTML(pText) + ' </span>' +
			'</button>';
	}

	/**
	 * Build the default confirm/cancel footer buttons (cancel then confirm). Returned WITHOUT
	 * a layout wrapper — the broker drops these into a real `.pict-modal-dialog-footer` band
	 * (PSM styles it as a flex/justify-end/border-top row that sits below the scrollable body),
	 * so the legacy `.columns` negative margins that used to pull the footer up into the body
	 * are gone.
	 * @param {object} pConfig - merged config (confirmText/Icon/Color, cancelText/Icon/Color, modalFooterId)
	 * @returns {string}
	 */
	buildDefaultFooterHTML(pConfig)
	{
		let tmpCancel = this.buildButtonHTML('cancel', pConfig.cancelText, pConfig.cancelIcon, pConfig.cancelColor, pConfig.modalFooterId);
		let tmpConfirm = this.buildButtonHTML('confirm', pConfig.confirmText, pConfig.confirmIcon, pConfig.confirmColor, pConfig.modalFooterId);
		return tmpCancel + tmpConfirm;
	}

	/**
	 * Build the default message body (legacy: a div at font-size 1.3rem).
	 * @param {string} pMessage
	 * @returns {string}
	 */
	buildMessageBodyHTML(pMessage)
	{
		return '<div style="font-size:1.3rem">' + this.escapeHTML(pMessage) + '</div>';
	}

	/**
	 * Build the mini-modal body: bold message + small italic subtext.
	 * @param {string} pMessage
	 * @param {string} pSubtext
	 * @param {string} [pTextColor] - optional Bulma text-color helper class
	 * @returns {string}
	 */
	buildMiniBodyHTML(pMessage, pSubtext, pTextColor)
	{
		let tmpColor = pTextColor ? (' ' + this.escapeHTML(pTextColor)) : '';
		let tmpStrongColor = pTextColor ? (' class="' + this.escapeHTML(pTextColor) + '"') : '';
		return '<p><strong' + tmpStrongColor + '>' + this.escapeHTML(pMessage) + '</strong></p>' +
			'<p class="is-size-7' + tmpColor + '"><em>' + this.escapeHTML(pSubtext) + '</em></p>';
	}

	/**
	 * Build the mini-modal footer (legacy: `.buttons.is-right.mt-2`, cancel then confirm).
	 * @param {object} pConfig
	 * @returns {string}
	 */
	buildMiniFooterHTML(pConfig)
	{
		let tmpCancel = this.buildButtonHTML('cancel', pConfig.cancelText, pConfig.cancelIcon, pConfig.cancelColor);
		let tmpConfirm = this.buildButtonHTML('confirm', pConfig.confirmText, pConfig.confirmIcon, pConfig.confirmColor);
		return '<div class="buttons is-right mt-2">' + tmpCancel + tmpConfirm + '</div>';
	}

	/**
	 * Map the legacy `style` to a PSM dialog width + wide className.
	 * @param {string} pStyle - 'small' | 'wide'
	 * @returns {{ width: (string|undefined), wideClass: (string|null) }}
	 */
	mapStyle(pStyle)
	{
		if (pStyle === 'wide')
		{
			return { width: undefined, wideClass: 'headlight-modal-wide' };
		}
		return { width: undefined, wideClass: null };
	}

	/**
	 * Translate a merged legacy config into a PSM `show()` plan the broker executes.
	 *
	 * String templates are assembled into `content` here. Live-HTMLElement templates
	 * are only FLAGGED (bodyElement/footerElement/cardElement/headerElement) — the broker
	 * appends the actual node in `onOpen` (it has the DOM; this class must not).
	 *
	 * @param {object} pConfig - merged config (defaults already applied by the service)
	 * @param {object} [pContext] - { mini: boolean }
	 * @returns {object} plan
	 */
	translate(pConfig, pContext)
	{
		let tmpConfig = pConfig || {};
		let tmpIsMini = !!(pContext && pContext.mini);

		let tmpStyle = this.mapStyle(tmpConfig.style);
		let tmpClassNames = ['headlight-modal'];
		if (tmpStyle.wideClass) { tmpClassNames.push(tmpStyle.wideClass); }
		if (tmpIsMini) { tmpClassNames.push('headlight-mini-modal'); }
		if (tmpConfig.modalBackgroundColor) { tmpClassNames.push(tmpConfig.modalBackgroundColor); }
		if (tmpConfig.modalTextColor) { tmpClassNames.push(tmpConfig.modalTextColor); }

		let tmpPlan =
		{
			primitive: 'show',
			title: '',
			content: '',
			buttons: [],
			// closeable governs BOTH PSM's × and the overlay/Escape dismiss. Legacy
			// `disableBackgroundClickToClose` (and every mini modal) means "must click a
			// button" -> not closeable. Otherwise closeable (background-click parity).
			closeable: !tmpConfig.disableBackgroundClickToClose,
			width: tmpStyle.width,
			className: tmpClassNames.join(' '),
			freezeScroll: !tmpConfig.enableBackgroundScrolling,
			focusFirstInput: true,
			customCSS: tmpConfig.modalCustomCSS || null,
			hideBackground: !!tmpConfig.hideModalBackground,
			topOffset: tmpConfig.modalTopOffset || null,
			// Default (non-mini, non-custom) footer buttons — the broker renders these in a
			// real .pict-modal-dialog-footer band (below the body), not inside the body content.
			footerContent: '',
			// Live-element flags — the broker appends these nodes in onOpen.
			cardElement: this.isElement(tmpConfig.modalCardTemplate),
			headerElement: this.isElement(tmpConfig.modalHeaderTemplate),
			bodyElement: this.isElement(tmpConfig.modalBodyTemplate),
			footerElement: this.isElement(tmpConfig.modalFooterTemplate),
			// Bucket E: a backdrop-less positioned card is really an anchored popover.
			// Flagged so the service (or a later phase) can route it to dropdown().
			isAnchoredCard: !!(tmpConfig.hideModalBackground && tmpConfig.modalCardTemplate),
		};

		// --- Full-card override: the card owns all chrome; PSM header suppressed. ---
		if (tmpConfig.modalCardTemplate)
		{
			tmpPlan.title = '';
			tmpPlan.content = tmpPlan.cardElement ? '' : String(tmpConfig.modalCardTemplate);
			return tmpPlan;
		}

		let tmpContentParts = [];

		// --- Header: PSM title when default; custom header template goes into content. ---
		if (!tmpConfig.hideModalHeader)
		{
			if (tmpConfig.modalHeaderTemplate)
			{
				if (!tmpPlan.headerElement) { tmpContentParts.push(String(tmpConfig.modalHeaderTemplate)); }
			}
			else
			{
				tmpPlan.title = (typeof tmpConfig.title === 'string') ? tmpConfig.title : '';
			}
		}

		// --- Body ---
		if (!tmpConfig.hideModalBody)
		{
			if (tmpConfig.modalBodyTemplate)
			{
				if (!tmpPlan.bodyElement) { tmpContentParts.push(String(tmpConfig.modalBodyTemplate)); }
			}
			else if (tmpIsMini)
			{
				tmpContentParts.push(this.buildMiniBodyHTML(tmpConfig.message, tmpConfig.subtext, tmpConfig.modalTextColor));
			}
			else
			{
				tmpContentParts.push(this.buildMessageBodyHTML(tmpConfig.message));
			}
		}

		// --- Footer ---
		// Custom footer templates and the mini footer stay IN the body content (the mini's
		// footer shares the colored card; custom footers are the caller's own markup). The
		// DEFAULT footer goes into footerContent so the broker renders it as a proper band.
		if (!tmpConfig.hideModalFooter)
		{
			if (tmpConfig.modalFooterTemplate)
			{
				if (!tmpPlan.footerElement) { tmpContentParts.push(String(tmpConfig.modalFooterTemplate)); }
			}
			else if (tmpIsMini)
			{
				tmpContentParts.push(this.buildMiniFooterHTML(tmpConfig));
			}
			else
			{
				tmpPlan.footerContent = this.buildDefaultFooterHTML(tmpConfig);
			}
		}

		tmpPlan.content = tmpContentParts.join('');
		return tmpPlan;
	}
}

module.exports = HeadlightModalAdapter;
module.exports.MiniModalPreset = MiniModalPreset;
module.exports.SERVICE_GLOBAL = SERVICE_GLOBAL;

},{}],244:[function(require,module,exports){
/**
 * Headlight Popover CSS
 *
 * Re-skins the pict-section-modal dropdown surface used by the HeadlightPopover
 * service (migrated off Tippy.js). Ported from the former `bulma-tippy`
 * dropdown / dropdown-dark themes, re-scoped under the wrapper's className and
 * driven by Bulma theme tokens so it follows the active light/dark theme.
 *
 * The service opens popovers via `modal.dropdown({ ContentHTML })`, which adds
 * the `pict-modal-dropdown--content` modifier (padding: 0, max-width uncapped).
 * These rules restore the menu chrome the old Tippy `dropdown` theme provided.
 */
module.exports = /*css*/`
/* Restore the inner padding the --content modifier zeroes out, and lift the
   popover above host chrome. PSM's dropdown is position:fixed at z-index 1025,
   but Headlight-Panels' shell stacks up to ~1060 (side panels 1040, navbar
   1050, navbar+10 1060), which would occlude the menu. Tippy previously used
   9999; match it so the popover clears all panel chrome as before. */
.pict-modal-dropdown.headlight-popover
{
	padding: 0.25rem;
	z-index: 9999;
}

/* Action menus rendered inside the popover template (<ul class="list-menu">). */
.headlight-popover .list-menu
{
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.headlight-popover .list-menu-item
{
	padding: 0;
	margin: 0;
}

.headlight-popover .list-menu-item a
{
	display: flex;
	align-items: center;
	padding: 0.5rem 1rem;
	color: var(--bulma-text);
	text-decoration: none;
}

.headlight-popover .list-menu-item:hover
{
	background-color: var(--bulma-background);
}

.headlight-popover .list-menu-item:hover a
{
	color: var(--bulma-primary);
}

/* Dark variant (legacy Tippy theme 'dropdown-dark'). Overrides the dropdown
   surface tokens + the list-menu hover colors. Declared after the light rules
   so it wins at equal specificity when both classes are on the element. */
.pict-modal-dropdown.headlight-popover-dark
{
	--pict-modal-dropdown-bg: var(--bulma-black-ter);
	--pict-modal-dropdown-fg: var(--bulma-white);
	--pict-modal-dropdown-border: var(--bulma-black-ter);
}

.headlight-popover-dark .list-menu-item a
{
	color: var(--bulma-primary-85);
}

.headlight-popover-dark .list-menu-item:hover
{
	background-color: var(--bulma-primary-20);
}

.headlight-popover-dark .list-menu-item:hover a
{
	color: var(--bulma-primary-85);
}
`;

},{}],245:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');
const libPictSectionModal = require('pict-section-modal');
const libHeadlightPopoverCSS = require('./Headlight-Popover-Service-CSS.js');

/**
 * HeadlightPopover
 *
 * Anchored, click-triggered popovers rendered from a Pict template hash. This
 * used to wrap Tippy.js; it now drives the pict-section-modal (PSM) dropdown in
 * `ContentHTML` mode, which gives click-outside / Escape dismissal, auto-flip,
 * viewport clamping and scroll/resize repositioning without a third-party dep.
 *
 * The public API (createPopover / hidePopover / showPopover / hideAll) is
 * preserved so existing call sites are untouched.
 */
class HeadlightPopoverFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }}} */
		this.fable;
		this.serviceType = 'HeadlightPopover';

		// Legacy Tippy "theme" names mapped onto wrapper CSS classes that re-skin
		// the PSM dropdown surface (see Headlight-Popover-Service-CSS.js). Only
		// 'dropdown' and 'dropdown-dark' are used by consumers.
		this.themeClassMap = {
			'dropdown': 'headlight-popover',
			'dropdown-dark': 'headlight-popover headlight-popover-dark',
		};

		// Former Tippy default; used when a caller doesn't specify maxWidth.
		this.defaultMaxWidth = '350px';

		// Register the wrapper's CSS once, so the popover surface is themed even
		// in apps that never render the PSM view directly.
		if (this.fable && this.fable.CSSMap && typeof this.fable.CSSMap.addCSS === 'function')
		{
			this.fable.CSSMap.addCSS('Headlight-Popover-CSS', libHeadlightPopoverCSS, 500);
		}
	}

	/**
	 * @description Resolves the pict-section-modal view, registering it as a
	 *   singleton on first use if the host app hasn't already. Popover consumers
	 *   live in apps (e.g. headlight_panels) that don't register PSM themselves,
	 *   so the wrapper self-registers to stay a drop-in service.
	 * @returns {Object|null} The PSM view instance, or null if unavailable.
	 */
	_getModal()
	{
		if (!this.fable || !this.fable.views)
		{
			this.fable.log.error('HeadlightPopoverFableService: pict-section-modal is unavailable (no views registry)');
			return false;
		}
		let tmpModal = this.fable.views['Pict-Section-Modal'];
		if (!tmpModal && typeof this.fable.addViewSingleton === 'function')
		{
			this.fable.addViewSingleton('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
			tmpModal = this.fable.views['Pict-Section-Modal'];
		}
		if (!tmpModal)
		{
			this.fable.log.error('HeadlightPopoverFableService: could not resolve the Pict-Section-Modal view');
			return false;
		}
		return tmpModal;
	}

	/**
	 * @description Maps a legacy popover configuration onto PSM dropdown options.
	 * @param {Object} pConfiguration - The createPopover configuration.
	 * @returns {Object} Options for modal.dropdown().
	 */
	_mapDropdownOptions(pConfiguration)
	{
		const tmpTheme = pConfiguration.theme || 'dropdown';
		const tmpOptions =
		{
			className: this.themeClassMap[tmpTheme] || this.themeClassMap['dropdown'],
		};

		// maxWidth: Tippy accepted a number (px) or a CSS string.
		if (pConfiguration.maxWidth)
		{
			tmpOptions.maxWidth = (typeof pConfiguration.maxWidth === 'number')
				? pConfiguration.maxWidth + 'px'
				: pConfiguration.maxWidth;
		}
		else
		{
			tmpOptions.maxWidth = this.defaultMaxWidth;
		}

		// placement (Tippy) -> align / position (PSM), best-effort. PSM has no
		// true left/right side placement, so those fall back to auto-flip below/
		// above (documented gap). Only 'top*' forces above; everything else keeps
		// PSM's auto-flip. A trailing '-end' aligns to the anchor's right edge.
		const tmpPlacement = pConfiguration.placement || '';
		if (tmpPlacement.indexOf('top') === 0)
		{
			tmpOptions.position = 'above';
		}
		tmpOptions.align = (tmpPlacement.indexOf('-end') > -1) ? 'right' : 'left';
		if (pConfiguration.align)
		{
			tmpOptions.align = pConfiguration.align;
		}

		return tmpOptions;
	}

	/**
	 * @description Creates (and immediately opens) a popover from a Pict template.
	 * @param {Object} pConfiguration - Configuration for the popover
	 * @param {string} pConfiguration.PopoverTemplateHash - The template hash for the popover content
	 * @param {string} pConfiguration.PopoverDestinationAddress - The ID of the element to anchor the popover to
	 * @param {Object} pConfiguration.PopoverTemplateRecord - The record to use for the template
	 * @returns {boolean} - Returns true if the popover was created successfully, false otherwise
	 */
	createPopover(pConfiguration)
	{
		if (!pConfiguration)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No configuration provided');
			return false;
		}
		if (!pConfiguration.PopoverTemplateHash)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No template hash provided (should be a Pict-TemplateHash string)');
			return false;
		}
		if (!pConfiguration.PopoverDestinationAddress)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No destination address provided (should be an ID string)');
			return false;
		}
		// if they passed over an element, warn them it should be an id
		if (typeof pConfiguration.PopoverDestinationAddress === 'object')
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: PopoverDestinationAddress should be passed an ID, not an element object');
			return false;
		}
		// if they passed an id with a leading #, remove it
		if (pConfiguration.PopoverDestinationAddress.startsWith('#'))
		{
			pConfiguration.PopoverDestinationAddress = pConfiguration.PopoverDestinationAddress.substring(1);
			this.fable.log.warn('HeadlightPopoverFableService: createPopover: PopoverDestinationAddress should not have a leading #, removing it');
		}
		// find the anchor element by ID
		const tmpAnchorElement = document.getElementById(pConfiguration.PopoverDestinationAddress);
		if (!tmpAnchorElement)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No anchor element found');
			return false;
		}

		const tmpModal = this._getModal();
		if (!tmpModal)
		{
			return false;
		}

		// Render the template to HTML and hand it to the dropdown verbatim.
		const tmpRecord = pConfiguration.PopoverTemplateRecord;
		// @ts-ignore - parseTemplateByHash is provided by the pict instance
		const tmpContentHTML = this.fable.parseTemplateByHash(pConfiguration.PopoverTemplateHash, tmpRecord);

		const tmpOptions = this._mapDropdownOptions(pConfiguration);
		tmpOptions.ContentHTML = tmpContentHTML;

		// Ensure the PSM + wrapper CSS is present (the modal view is never
		// rendered through the normal cycle, so inject explicitly).
		if (this.fable.CSSMap && typeof this.fable.CSSMap.injectCSS === 'function')
		{
			this.fable.CSSMap.injectCSS();
		}

		tmpModal.dropdown(tmpAnchorElement, tmpOptions);
		return true;
	}

	/**
	 * @description Manual "show" hook. Retained for API compatibility; with the
	 *   PSM dropdown a popover opens on createPopover(), so there is no separate
	 *   show step. No external callers use this.
	 * @returns {Boolean}
	 */
	showPopover()
	{
		this.fable.log.warn('HeadlightPopoverFableService: showPopover is a no-op; popovers open on createPopover()');
		return false;
	}

	/**
	 * @description Hides the open popover (PSM keeps a single dropdown open at a
	 *   time, so this dismisses whichever popover is showing). Arguments are
	 *   accepted for API compatibility but ignored.
	 * @returns {Boolean}
	 */
	hidePopover()
	{
		const tmpModal = this.fable.views && this.fable.views['Pict-Section-Modal'];
		if (!tmpModal)
		{
			return false;
		}
		tmpModal.dismissDropdowns();
		return true;
	}

	/**
	 * @description Hides all popovers created by this service.
	 * @returns {Boolean}
	 */
	hideAll()
	{
		const tmpModal = this.fable.views && this.fable.views['Pict-Section-Modal'];
		if (!tmpModal)
		{
			return false;
		}
		tmpModal.dismissDropdowns();
		return true;
	}
}

module.exports = HeadlightPopoverFableService;
module.exports.default_configuration = {};

},{"./Headlight-Popover-Service-CSS.js":244,"fable-serviceproviderbase":398,"pict-section-modal":590}],246:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');

class HeadlightModalFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') } & { EntityProvider: any, HeadlightPopover: any, addTemplate: any, TemplateProvider: any, HeadlightRestClient: any, MetaTemplate: any, manifest: any, resolveStateFromAddress: any, ManifestPackagingService: any, parseTemplate: any }}}
		 */
		this.fable;

		this.serviceType = 'QuickSummaries';

        this.typeConfig = {};
        this.dateFormat = 'YYYY-MM-DD';
        this.decimalPrecision = 2;
        this.typeIconMap =
        {
            'LineItem': 'list-tree',
            'Project': 'folder-open',
            'Sample': 'qr-code',
            'User': 'user',
            'Document': 'file-lines',
            'TestInstance': 'microscope',
            'Test': 'clipboard-list-check',
            'Location': 'location-dot',
            'ProductionPlant': 'industry',
            'MixDesign': 'vial',
            'Material': 'boxes-packing',
            'Supplier': 'truck-fast',
            'Producer': 'tractor',
            'Bridge': 'bridge',
        };
        this.fable.MetaTemplate.addPattern('{~QuickSummary:', '~}', (pHash, pData) =>
		{
            const tokens = pHash?.split('^');
            if (tokens.length !== 2)
            {
                console.log('[QuickSummariesService] Cannot render quick summary, missing either an entity or an ID.');
                return '';
            }
			const value = !isNaN(tokens[1]) ? tokens[1] : this.fable.resolveStateFromAddress(tokens[1], pData);
            const type = tokens[0];
            const uuid = this.fable.getUUID();
            return /*html*/`
                <button
                    type="button"
                    class="button is-ghost has-text-info p-0 m-0 is-inline-block"
                    style="font-size: inherit; line-height: inherit;"
                    id="${ type }-${ uuid }"
                    aria-haspopup="true"
                    onmouseover="_Pict.fable.services.HeadlightQuickSummaries.spawnQuickSummary({ ID: ${ value }, parentID: '${ type }-${ uuid }', type: '${ type }'})"
                    onclick="_Pict.fable.services.HeadlightQuickSummaries.spawnQuickSummary({ ID: ${ value }, parentID: '${ type }-${ uuid }', type: '${ type }'})">
                    <i class="fas fa-${ this.typeIconMap[type] || 'circle-info' }" aria-hidden="true"></i>
                </button>
            `;
		});
	}

    _linkBuilder(type, field, record, template)
    {
        const baseURL = window.location.origin.includes('localhost') ? window.location.origin.replaceAll(window.location.origin.split('.')[1], 'qa.headlight.com') : window.location.origin;
        if (type == 'Document')
        {
            template = template || `https://links${ baseURL.replaceAll(baseURL.split('.')[0], '') }/document/{~D:Record.${ field }~}`;
        }
        else
        {
            template = template || `https://home${ baseURL.replaceAll(baseURL.split('.')[0], '') }/customer/{~D:Record.IDCustomer~}/master-list/${ type.toLowerCase() }/{~D:Record.${ field }~}`;
        }
        if (template)
        {
            return this.fable.parseTemplate(template, record);
        }
        return '';
    }

    applyTypeConfig(tc)
    {
        this.typeConfig = Object.assign(this.typeConfig, tc);
    }

    addManifestForType(type, manifest)
    {
        this.typeConfig[type] = manifest;
    }

    _getTypeSchema(type)
    {
		return new Promise((resolve, reject) =>
		{
			this.fable.HeadlightRestClient.getJSON(`${ type }/Schema`, (pError, pBody) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting schema: `, pError);
					return reject(pError);
				}
                if (!pBody?.MeadowSchema?.Schema)
                {
                    pBody.MeadowSchema = 
                    {
                        Schema: []
                    };
                    // If no meadow schema, jimmy the properties into the same format to make consumption easier.
                    for (const p of Object.keys(pBody.properties))
                    {
                        pBody.MeadowSchema.Schema.push(
                        {
                            Column: p,
                            Type: pBody.properties[p].type
                        });
                    }
                }
				resolve(pBody?.MeadowSchema?.Schema);
			});
		});
    }

    async _generateDefaultManifest(type)
    {
        const schema = await this._getTypeSchema(type);
        const tempManifest = 
        {
            Scope: `${ type }-Summary`,
	        TitleTemplate: this._getHumanReadableFieldName(type),
            Descriptors: {}
        };
        for (const field of schema)
        {
            const f = field.Column;
            // Ignore IDs and delete auditing fields plus any fields configured to exclude.
            if (f == `ID${ type }` || f == `GUID${ type }` || f.startsWith('Delet'))
            {
                continue;
            }

            // Resolve IDs
            else if (f.includes('ID') && f.split('ID')?.['1'] && !f.includes('GUID'))
            {
                const cleanedField = '_' + f.replaceAll('ID', '');
                tempManifest.Descriptors[cleanedField] =
                {
                    Hash: cleanedField,
                    Name: this._getHumanReadableFieldName(f)
                };
            }
            else if (f.includes('Date') || f.includes('Time') || field.Type.includes('Date') || field.Type.includes('Time'))
            {
                tempManifest.Descriptors[`${ f }_Formatted`] =
                {
                    Hash: `${ f }_Formatted`,
                    Name: this._getHumanReadableFieldName(f),
                    DataType: 'DateTime',
                    HeadlightSummary:
                    {
                        DateFormat: this.dateFormat
                    }
                };
            }
            else if (['number', 'Decimal'].includes(field.Type))
            {
                tempManifest.Descriptors[`${ f }_Formatted`] =
                {
                    Hash: `${ f }_Formatted`,
                    Name: this._getHumanReadableFieldName(f),
                    DataType: 'PreciseNumber',
                    HeadlightSummary:
                    {
                        DecimalPrecision: 2
                    }
                };
            }
            else
            {
                tempManifest.Descriptors[f] =
                {
                    Hash: f,
                    Name: this._getHumanReadableFieldName(f),
                };
            }
        }
        return tempManifest;
    }

    async _getEntity(type, ID, full, displayFields)
    {
        return await new Promise((resolve, reject) => 
        {
            this.fable.EntityProvider.getEntity(type, ID, (err, res) =>
            {
                if (err || res.Error)
                {
                    return resolve('');
                }
                if (full)
                {
                    return resolve(res);
                }
                if (displayFields)
                {
                    const displayStrings = [];
                    displayFields.forEach((f) =>
                    {
                        displayStrings.push(res[f] || '');   
                    });
                    return resolve(displayStrings.join(' '));
                }
                if (type == 'User')
                {
                    return resolve(`${ res.NameFirst || '' } ${ res.NameLast || '' }`);
                }
                resolve(res.Name || res.QRcode || res[`GUID${ type }`] || '');
            })
        });
    }

	async processRecord(type, record, action = 'Summary', typeConfig = this.typeConfig)
    {
        const decoratedRecord = {};
        if (typeConfig[type]?.Descriptors)
        {
            for (let k of Object.keys(typeConfig[type].Descriptors))
            {
                if (k.includes('JSON'))
                {
                    record[k] = 'JSON Object';
                }
            }
        }
        for (const f of Object.keys(record))
        {
            if (f == `ID${ type }`)
            {
                continue;
            }
            else if (f.includes('ID') && f.split('ID')?.['1'] && !f.includes('GUID'))
            {
                // Resolve IDs
                const cleanedField = '_' + f.replaceAll('ID', '');
                if (record[f])
                {
                    try
                    {
                        decoratedRecord[cleanedField] = await this._getEntity(f.split('ID')[1], record[f], false, typeConfig[type]?.Descriptors?.[cleanedField]?.[`Headlight${ action }`]?.DisplayFields);
                        decoratedRecord[`${ cleanedField }_Link`] = this._linkBuilder(f.split('ID')[1], f, record, typeConfig[type]?.Descriptors?.[cleanedField]?.[`Headlight${ action }`]?.LinkTemplate);
                        continue;
                    }
                    catch (e)
                    {
                        console.log('Error fetching record: ', e);
                    }
                }
                decoratedRecord[cleanedField] = 'N/A';
            }
            else if (typeConfig[type]?.Descriptors?.[`${ f }_Formatted`]?.DataType == 'DateTime')
            {
                decoratedRecord[`${ f }_Formatted`] = record[f] ? this.fable.Dates.dayJS(record[f]).format(typeConfig[type]?.Descriptors?.[f]?.[`Headlight${ action }`]?.DateFormat || this.dateFormat) : 'N/A';
            }
            else if (typeConfig[type]?.Descriptors?.[`${ f }_Formatted`]?.DataType == 'PreciseNumber')
            {

                let tmpRoundingMethod = this.fable.Math.roundHalfUp;
                if (typeConfig[type]?.Descriptors?.[f]?.[`Headlight${ action }`]?.RoundingMethod)
                {
                    try
                    {
                        tmpRoundingMethod = parseInt(typeConfig[type].Descriptors[f][`Headlight${ action }`].RoundingMethod);
                    }
                    catch(pError)
                    {
                        this.log.error(`Error parsing rounding method: `, pError);
                    }
                }
                decoratedRecord[`${ f }_Formatted`] = this.fable.Math.toFixedPrecise(record[f], typeConfig[type]?.Descriptors?.[f]?.[`Headlight${ action }`]?.DecimalPrecision || this.decimalPrecision, tmpRoundingMethod) || 0;
            }
            else if (f.includes('JSON') || (record[f] && typeof record[f] == 'object'))
            {
                decoratedRecord[f] = 'JSON Object';
            }
            else
            {
                decoratedRecord[f] = (parseInt(f) && record[f] == 0) ? 0 : (record[f] || 'N/A');
            }
        }
        return decoratedRecord;
    }

    _buildDefaultTemplate(manifest, type, record)
    {
        let outputTemplate = ``;
        for (const k of Object.keys(manifest.Descriptors))
        {
            outputTemplate += /*html*/`
                <div class="detail-wrapper px-2 py-1" style="border-bottom: 1px dashed var(--bulma-border);">
                    <div class="is-size-7 has-text-text-50">${ manifest.Descriptors[k].Name }</div>
                    <div class="is-size-6">${ k.startsWith('_') && record[`${ k }_Link`] ? `<span class="icon has-text-info"><i class="fas fa-external-link-alt"></i></span> <a target="_blank" class="p-0 has-text-info is-underlined is-inline" href="{~D:Record.${ k }_Link~}">` : '' }${ manifest.Descriptors[k]?.HeadlightSummary?.ValueTemplate || `{~D:Record.${ k }:N/A~}`}${ k.startsWith('_') ? `</a>` : '' }</div>
                </div>
            `;
        }
        return /*html*/`
        <div class="has-text-centered has-background-info has-text-info-100 p-1"><b>${ manifest.TitleTemplate || this._getHumanReadableFieldName(type) } Summary</b></div>
        <aside class="mt-1" style="max-height: 50vh; overflow-y: auto;">${ outputTemplate }</aside>`;
    }

    /**
	 * @description Creates a popover of the entity record for a particular entity
	 * @param {Object} pOptions - Options for the quick summary.
	 * @param {string} pOptions.type - The entity type being summarized.
     * @param {number} pOptions.ID - The ID of the entity, can be used instead of passing a record.
     * @param {string} pOptions.record - An entity record, can be passed instead of the ID to avoid having to look up the base record.
	 * @param {string} pOptions.parentID - The ID of the element to anchor the popover to.
     * @param {object} pOptions.popoverOptions - Options to pass on to the popover service.
	 */
    async spawnQuickSummary(pOptions)
    {
        if (!pOptions.type || !pOptions.parentID)
        {
            // Need the entity type and a parent element to continue.
            return;
        }
        if (!pOptions.ID && !pOptions.record)
        {
            // Need either a record ID or a record to continue.
            return;
        }
        // If no manifest is set, try to load the manifest from the db.
        if (!this.typeConfig[pOptions.type])
        {
            await this.fable.ManifestPackagingService.loadQuickSummaryManifests([pOptions.type]);
        }
        // If there was still no manifest in the db, create one using the schema endpoint.
        if (!this.typeConfig[pOptions.type])
        {
            this.typeConfig[pOptions.type] = await this._generateDefaultManifest(pOptions.type);
        }
        try
        {
            const localRecord = await this.processRecord(pOptions.type, pOptions.record || await this._getEntity(pOptions.type, pOptions.ID, true));
            if (this.typeConfig[pOptions.type]?.Template)
            {
                this.fable.TemplateProvider.addTemplate('Quick-Summary-Temporary-Template', this.typeConfig[pOptions.type]?.Template);
            }
            else
            {
                this.fable.TemplateProvider.addTemplate('Quick-Summary-Temporary-Template', this._buildDefaultTemplate(this.typeConfig[pOptions.type], pOptions.type, localRecord));
            }
            this.fable.HeadlightPopover.createPopover(Object.assign({
                PopoverDestinationAddress: pOptions.parentID,
                PopoverTemplateHash: 'Quick-Summary-Temporary-Template',
                PopoverTemplateRecord: localRecord,
                theme: 'dropdown',
                placement: 'left',
                maxWidth: '800px',
                delay: [ 500, 0 ], // delay showing the menu to allow for click events to propagate, avoid accidental hover displays, etc.
            }, pOptions.popoverOptions || {}));
        }
        catch (e)
        {
            console.log('Error fetching record: ', e);
            console.log('Passed Options :', pOptions);
            return;
        }
    }

	_getHumanReadableEntityName(pEntity)
	{
		return pEntity.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
	}

	_getHumanReadableFieldName(field, type)
	{
        if (field.includes('JSON'))
        {
            field = field.replaceAll('JSON', '');
        }
        if (this.typeConfig[type]?.Descriptors?.[field]?.Name)
        {
            return this.typeConfig[type].Descriptors[field].Name;
        }
		if (field === `ID${ type }`)
		{
			return `${ this._getHumanReadableEntityName(type) } Unique Database ID`;
		}
		if (field === `GUID${this.options.Entity}`)
		{
			return `${ this._getHumanReadableEntityName(type) } Unique Identifier`;
		}
		if (field === 'CreatingIDUser')
		{
			return 'Created By User';
		}
		if (field === 'CreateDate')
		{
			return 'Date Created';
		}
		if (field === 'UpdatingIDUser')
		{
			return 'Last Updated By User';
		}
		if (field === 'UpdateDate')
		{
			return 'Date Last Updated';
		}
		if (field.startsWith('ID'))
		{
			return this._getHumanReadableEntityName(field.split('ID')[1]);
		}
		if (field.startsWith('ParentID'))
		{
			return 'Parent ' + this._getHumanReadableEntityName(field.split('ID')[1]);
		}
        if (field.startsWith('ChildID'))
		{
			return 'Child ' + this._getHumanReadableEntityName(field.split('ID')[1]);
		}
		return field.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
	}
}

module.exports = HeadlightModalFableService;
module.exports.default_configuration = {};

},{"fable-serviceproviderbase":398}],247:[function(require,module,exports){
class MediaCardBuilder
{
	constructor(pOptions = {})
	{
		// Default options can be set here
		const defaultOptions = {
			cardLayouts: {
				flexible: { rows: -1, columns: 2 }, // default card layout
				full: { rows: 1, columns: 2 }, // full card layout
				half: { rows: 2, columns: 2 }, // half card layout
				quarter: { rows: 4, columns: 2 }, // quarter card layout,
				minimalist: { rows: 2, columns: 1 }, // minimalist card layout
			},
			target: 'MediaDetailCards-Container', // target container for the media cards
			landscapeMode: false, // whether to use landscape mode for PDF generation
			cardSize: 'flexible', // default card size
			cardTheme: 'default', // default card theme ('default' and 'minimalist')
			sortOrder: 'asc', // default sort order
			sortBy: 'DesignatedTime', // default sort field
			ordinalPosition: 'left', // default ordinal location (left or right)
			ordinalPrefix: 'Photo ', // default ordinal prefix
			ordinalSuffix: ' - ', // what comes after the ordinal (by default, is placed before the title)
			ordinalScope: 'local', // default ordinal scope ("global" can be used for all instances of cards across the form)
			titleAlignment: 'center', // title alignment (left, center, right)
			titlePosition: 'below', // title location (above, below)
			hideOrdinal: false, // hide ordinal option
			hideTitle: false, // hide title option
			hideId: false, // hide ID option
			hideCreator: false, // hide creator option
			hideCreateDate: false, // hide create date option
			hideDescription: false, // hide description option
			hideMiniMap: false, // hide mini map option
			hideStationOffset: false, // hide station and offset row option
			hideLabels: false, // hide labels option
			hideExternalLink: false, // hide external link option
			userRecords: [], // user records provided from an external look up (used to build the userNameMap)
			userNameMap: {}, // map of user IDs to user names for display (userRecords entries are added on top)
			isPrintView: false, // whether to format for print view (hides buttons and interactive elements)
			primaryGroupByLabelType: null, // the primary label type to group by (if grouping by label types, this determines which label type is used for the mini map and external link display in the standard card template)
			secondaryGroupByLabelType: null, // the secondary label type to group by (if grouping by multiple label types, this determines which label type is used for the mini map and external link display in the standard card template when the primary label type is not available)
			disablePrimaryGroupByLabelTypePageBreaks: false, // whether to disable page breaks between primary groups when grouping by label types (only applies to PDF generation)
		};
		// Merge default options with any provided options
		this.options = { ...defaultOptions, ...pOptions };

		// DRY CSS classes to reduce tempalate duplication
		this.sharedLabelCSS = 'title is-7 has-text-text-50'; // default label classes for styling
		this.sharedDatumCSS = 'subtitle is-7 has-text-text'; // default datum classes for styling
		this.hideMeCSS = 'style="display: none;"'; // Inline style to hide elements (avoid css classes for simplicity)
		this.customCSSInjected = false; // flag to track whether component specific CSS has been injected into the document head
	}

	/**
	 * Inject CSS styles for the media cards into the document head, using options to set dynamic values such as card and image heights based on the PDF page height and landscape mode setting
	 * @param {Object} tmpOptions - the options to use for setting dynamic CSS values
	 * @return {void}
	 */
	injectCCSS(tmpOptions = {})
	{
		// Only inject CSS once, even if buildCards is called multiple times
		if (this.customCSSInjected || document.getElementById('MediaCardBuilder-Styles')) return;

		const styleElement = document.createElement('style');
		styleElement.id = 'MediaCardBuilder-Styles';
		styleElement.innerHTML = /*CSS*/`
			:root {
				--pdf-page-height: ${tmpOptions.landscapeMode ? 700: 950}px; /* Default PDF page height */
			}
			.media-card-wrapper .media-card-image {
				width: auto;
				object-fit: contain;
				margin: 0 auto;
				max-height: calc(var(--pdf-page-height) - 2rem);
			}
			.media-card-wrapper .media-card-description-text {
				line-height: normal;
			}
			/* Card height is a fixed height based on the PDF page height divided by the number of rows */
			.card-height-is-1-out-of-1 {
				height: calc(var(--pdf-page-height) / 1);
			}
			.card-height-is-1-out-of-2 {
				height: calc(var(--pdf-page-height) / 2);
			}
			.card-height-is-1-out-of-4 {
				height: calc(var(--pdf-page-height) / 4);
			}
			/* Image height is a max-height to allow for responsive images */
			.image-height-is-1-out-of-1 {
				max-height: calc(var(--pdf-page-height) / 1);
			}
			.image-height-is-1-out-of-2 {
				max-height: calc(var(--pdf-page-height) / 2);
			}
			.image-height-is-1-out-of-4 {
				max-height: calc(var(--pdf-page-height) / 4);
			}
			/* Card heights have to be tweaked for minimalist theme card sizes */
			.media-card-wrapper.media-card-theme_minimalist .card-height-is-1-out-of-1 {
				height: calc((var(--pdf-page-height) / 1) - 2rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .card-height-is-1-out-of-2 {
				height: calc((var(--pdf-page-height) / 2) - 2rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .card-height-is-1-out-of-4 {
				height: calc((var(--pdf-page-height) / 4) - 2rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .image-height-is-1-out-of-1 {
				height: calc((var(--pdf-page-height) / 1) - ${tmpOptions.hideDescription ? 4 : 6 }rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .image-height-is-1-out-of-2 {
				height: calc((var(--pdf-page-height) / 2) - ${tmpOptions.hideDescription ? 4 : 6 }rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .image-height-is-1-out-of-4 {
				height: calc((var(--pdf-page-height) / 4) - ${tmpOptions.hideDescription ? 4 : 6 }rem);
			}`;
		document.head.appendChild(styleElement);
		this.customCSSInjected = true;
	}

	/**
	 * Build the media cards for the given observations and options
	 * @param {Array} pObservations - the observations to build the media cards for
	 * @param {Object} [pOptions] - the options to use for building the media cards (optional)
	 * @return {boolean}
	 */
	buildCards(pObservations = [], pOptions = {})
	{
		const tmpOptions = { ...this.options, ...pOptions };
		this.injectCCSS(tmpOptions);
		tmpOptions.userNameMap = this.buildUserNameMap(tmpOptions);
		let cardListTemplate = '';
		const mediaList = this.curateMediaObservationList(pObservations, tmpOptions);
		// if we have primary or secondary grouping by label types, we want to add dividers between the groups in the UI, so we need to build the HTML for the cards in a way that allows us to insert those dividers
		if ((tmpOptions.primaryGroupByLabelType || tmpOptions.secondaryGroupByLabelType) && !tmpOptions.hideGroupByLabelTypeHeaders)
		{
			// we need to keep track of the current group values as we loop through the media list to know when to insert dividers
			let currentPrimaryGroup = null;
			let currentSecondaryGroup = null;
			cardListTemplate = mediaList.map((mediaData, index) =>
			{
				// force page breaks for primary labels to ensure groups stay together in the PDF view
				let pageBreakClass = index !== 0 ? 'has-page-break-before' : '';
				let dividerTemplate = '';
				// if we have a new primary group, we need to insert a divider for the new primary group
				if (tmpOptions.primaryGroupByLabelType && mediaData._PrimaryGroupByLabel !== currentPrimaryGroup)
				{
					currentPrimaryGroup = mediaData._PrimaryGroupByLabel;
					dividerTemplate += /*HTML*/`
					<div class="cell is-col-span-full ${ pOptions?.disablePrimaryGroupByLabelTypePageBreaks ? '' : pageBreakClass}">
						<div class="notification is-primary mb-1 mt-1 p-2">
							<span class="icon">
								<i class="fa fa-fw fa-tag"></i>
							</span>
							<strong>${ tmpOptions.primaryGroupByLabelType }: ${ currentPrimaryGroup || '-None-' }</strong>
						</div>
					</div>`;
				}
				// if we have a new secondary group, we need to insert a divider for the new secondary group
				if (tmpOptions.secondaryGroupByLabelType)
				{
					const secondaryGroupValue = mediaData.Labels?.[tmpOptions.secondaryGroupByLabelType]?.[0]?.Tag || undefined;
					if (secondaryGroupValue !== currentSecondaryGroup)
					{
						currentSecondaryGroup = secondaryGroupValue;
						dividerTemplate += /*HTML*/`
						<div class="cell is-col-span-full">
							<div class="notification is-soft mb-1 mt-1 p-1">
								<span class="icon">
									<i class="fa fa-fw fa-tags"></i>
								</span>
								<strong>${ tmpOptions.secondaryGroupByLabelType }: ${ currentSecondaryGroup || '-None-' }</strong>
							</div>
						</div>`;
					}
				}
				// build the card template for the media data and add the divider template before it if necessary
				return dividerTemplate + this.buildCard(mediaData);
			}).join('');
		}
		else 
		{
			cardListTemplate = mediaList.map((mediaData) => this.buildCard(mediaData)).join('');
		}
		// insert the card list template into the target container in the DOM
		const tmpElementQuery = tmpOptions.target.startsWith('#') ? tmpOptions.target : `#${tmpOptions.target}`; // allow for target to be passed in with or without the # prefix, but default to using an ID selector for simplicity and specificity
		const containerElement = document.querySelector(tmpElementQuery);
		if (!containerElement)
		{
			console.warn(`MediaCardBuilder: Target container with ID "${tmpOptions.target}" not found.`);
			return false;
		}
		// If there are no media cards to display, show an empty message
		if (!cardListTemplate || !cardListTemplate.length)
		{
			containerElement.innerHTML =
			`<div class="notification has-text-centered empty-message">
				<span class="icon">
					<i class="fa fa-fw fa-info-circle"></i>
				</span>
				<span>No media has been added yet.</span>
			</div>`;
			return true;
		}
		containerElement.innerHTML = /*HTML*/`
		<div class="fixed-grid has-1-cols" style="wdith: 100%;">
			<div class="grid" style="gap: 0.25rem">${cardListTemplate}</div>
		</div>`;
		return true;
	}

	/**
	 * Map user IDs to display names: the caller's userNameMap, plus (overriding) any userRecords
	 * @param {Object} [pOptions] - the build options (userNameMap and/or userRecords)
	 * @return {Object} - map of IDUser to display name
	 */
	buildUserNameMap(pOptions = {})
	{
		return (pOptions.userRecords || []).reduce((acc, user) =>
		{
			acc[user.IDUser] = user.NameFirst + ' ' + user.NameLast;
			return acc;
		}, { ...pOptions.userNameMap });
	}

	/**
	 * Use a standard card template for the media card
	 * @param {Object} mediaData - the media data for the card
	 * @return {string} - the HTML string for the standard media card
	 */
	useStandardCardTemplate(mediaData)
	{
		let mediaElement;
		// If the media type is video or audio, adjust the media element accordingly
		if (mediaData._MediaType === 'video')
		{
			mediaElement = /*HTML*/`
			<figure data-observation-id="${mediaData.IDObservation}" style="padding: 1rem;">
				<video class="media-card-video ${mediaData._ImageHeightClass}" controls="" style="width: 100%;" playsinline>
					<source src="/1.0/Artifact/Media/${ mediaData._ArtifactId }/${ mediaData._Version }" type="video/mp4">
				</video>
			</figure>`;
		}
		else if (mediaData._MediaType === 'audio')
		{
			mediaElement = /*HTML*/`
			<figure data-observation-id="${mediaData.IDObservation}" style="padding: 1rem;">
				<audio class="media-card-audio ${mediaData._ImageHeightClass}" controls="" style="width: 100%;" playsinline>
					<source src="/1.0/Artifact/Media/${ mediaData._ArtifactId }/${ mediaData._Version }" type="audio/mp3">
				</audio>
			</figure>`;
		}
		else // default to image (all observations have a fallback image)
		{
			mediaElement = /*HTML*/`
			<figure data-observation-id="${mediaData.IDObservation}">
				<img class="image media-card-image ${mediaData._ImageHeightClass}"
					src="${mediaData._ImageSource || ''}" 
					alt="Observation #${mediaData.IDObservation}" 
					onerror="this.onerror = null; this.src='./images/no-image-light.png'"
				/>
			</figure>`;
		}
		return /*HTML*/`
		<!-- Standard card template for media cards -->
		<div class="cell" style="break-inside: avoid;">
			<div class="fixed-grid media-card-wrapper ${mediaData._CardColumnClass} media-card-theme_standard">
				<a class="anchor" id="MEDIA-CARD-FOR-${mediaData.IDObservation}"></a>
				<div class="grid is-gap-0 is-clipped ${mediaData._CardHeightClass}">
					<div class="cell has-background-text-soft p-0">
							${mediaElement}
						</figure>
					</div>
					<div class="cell pb-3">
						<div class="fixed-grid has-1-cols mb-3">
							<div class="grid has-background-text-soft" style="gap: 0.5rem;">
								<div class="cell">
									<p ${ mediaData._HideTitle ? this.hideMeCSS : ''} class="title is-7 mt-2 ml-2">${mediaData.Name || ''}</p>
									<p class="${this.sharedDatumCSS} mb-2 ml-2">
										<span ${ mediaData._HideId ? this.hideMeCSS : ''}>#${mediaData.IDObservation || ''}</span>
										<a ${ mediaData._HideExternalLink ? this.hideMeCSS : ''} class="is-size-7 is-pulled-right" href="${mediaData._ExternalLinkHref || ''}" target="_blank">
											<span>Open in Fieldbook</span>
										</a>
									</p>
								</div>
								<div ${ mediaData._HideMiniMap ? this.hideMeCSS : ''} class="cell is-col-from-end-1 p-0 has-background-text-85" style="align-content: center;">
									<figure class="image mini-map-image">
										<img style="width: auto; float: right" onerror="this.onerror = null; this.src='./images/no-location-data-light.png'" src="${mediaData._MiniMapImage || ''}" />
									</figure>
								</div>
							</div>
						</div>
						<div class="fixed-grid has-2-cols">
							<div class="grid pl-3 pb-3 mb-0">
								<div ${ mediaData._HideCreator ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Created by</div>
									<div class="${this.sharedDatumCSS} media-card-creator-name" data-creator-id="${mediaData.CreatingIDUser || ''}">${mediaData._CreatorName || 'N/A'}</div>
								</div>
								<div ${ mediaData._HideCreateDate ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Created on</div>
									<div class="${this.sharedDatumCSS}">${new Date(mediaData.DesignatedTime).toLocaleDateString()} at ${new Date(mediaData.DesignatedTime).toLocaleTimeString()}</div>
								</div>
								<div ${ mediaData._HideDescription ? this.hideMeCSS : ''} class="cell is-col-span-2">
									<div class="${this.sharedLabelCSS} media-card-description-text">Description</div>
									<div class="${this.sharedDatumCSS}" style="display: inline-flex; flex-wrap: wrap;">
										${mediaData.Description || '<span class="has-text-text-50">No description provided</span>'}
									</div>
								</div>
								<div ${ mediaData._HideStationOffset || !mediaData._HasStationOffsetRow ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Station</div>
									<div class="${this.sharedDatumCSS}">${mediaData.AlignmentStation || 'N/A'}</div>
								</div>
								<div ${ mediaData._HideStationOffset || !mediaData._HasStationOffsetRow ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Offset</div>
									<div class="${this.sharedDatumCSS}">${mediaData.AlignmentOffset || 'N/A'}</div>
								</div>
								${ this.buildLabelSection(mediaData) }
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>`;
	}
	
	/**
	 * Use a minimalist card layout for the media card
	 * @param {Object} mediaData - the media data for the card
	 * @return {string} - the HTML string for the minimalist media card
	 */
	useMinimalistCardTemplate(mediaData)
	{
		// Build the ordinal and it's wrapping content for the minimalist card - will be "left" or "right" positions
		const buildOrdinal = () => 
		{
			return /*HTML*/`
				<span ${ mediaData._HideOrdinal ? this.hideMeCSS : ''} class="media-card-ordinal-prefix">
					${mediaData._OrdinalPrefix || ''}
				</span>
				<span ${ mediaData._HideOrdinal || mediaData._HideGlobalOrdinal ? this.hideMeCSS : ''} class="media-card-global-ordinal">
					${mediaData._GlobalOrdinal || ''}
				</span>
				<span ${ mediaData._HideOrdinal || mediaData._HideLocalOrdinal ? this.hideMeCSS : ''} class="media-card-local-ordinal">
					${mediaData.Ordinal || ''}
				</span>
				<span ${ mediaData._HideOrdinal ? this.hideMeCSS : ''} class="media-card-ordinal-suffix">
					${mediaData._OrdinalSuffix || ''}
				</span>
			`;
		}
		// Build the header for the minimalist card which can be in two different positions - "above" or "below" the image
		const buildHeader = () => 
		{
			return /*HTML*/`
				<div class="is-flex title is-7 mt-1 mb-0 ${ tmpAlignment }">
					<div class="is-flex-grow-1">
						${ mediaData._OrdinalPosition === 'left' ? buildOrdinal() : '' }
						<span ${ mediaData._HideTitle ? this.hideMeCSS : ''} class="media-card-title">
							${mediaData.Name || ''}
						</span>
						${ mediaData._OrdinalPosition !== 'left' ? buildOrdinal() : '' }
					</div>
				</div>
			`;
		}

		// Translate the title/description alignment to a CSS class
		let tmpAlignment = '';
		switch(mediaData?._TitleAlignment?.toLowerCase()) {
			case 'left':
				tmpAlignment =  'has-text-left';
				break;
			case 'right':
				tmpAlignment =  'has-text-right';
				break;
			default:
				tmpAlignment =  'has-text-centered';
		}

		return /*HTML*/`
		<!-- Minimalist card template for media cards -->
		<div class="cell" style="break-inside: avoid;">
			<div class="fixed-grid media-card-wrapper has-1-cols media-card-theme_minimalist">
				<a class="anchor" id="MEDIA-CARD-FOR-${mediaData.IDObservation}"></a>
				<div class="grid is-gap-0 is-clipped mt-2 ${mediaData._CardHeightClass}">
					<div class="cell">
						${ mediaData._TitlePosition == 'above' ? buildHeader() : '' }
						<figure data-observation-id="${mediaData.IDObservation}">
							<img class="image media-card-image ${mediaData._ImageHeightClass}"
								src="${mediaData._ImageSource || ''}" 
								alt="Observation #${mediaData.IDObservation}" 
								onerror="this.onerror = null; this.src='./images/no-image-light.png'"
							/>
						</figure>
						${ mediaData._TitlePosition !== 'above' ? buildHeader() : '' }
						<div ${ mediaData._HideDescription ? this.hideMeCSS : ''} class="media-card-description-text is-size-7 ${tmpAlignment}">${mediaData._TrimmedDescription || ''}</div>
					</div>
				</div>
			</div>
		</div>`;
	}

	/**
	 * Build a single media card HTML structure based on the card size and media data
	 * @param {Object} mediaData - the media data for the card
	 * @return {string} - the HTML string for the media card
	 */
	buildCard(mediaData)
	{
		switch (mediaData._CardTheme) {
			case 'minimalist':
				return this.useMinimalistCardTemplate(mediaData);
			default:
				return this.useStandardCardTemplate(mediaData);
		}
	}

	/**
	 * Build the labels section for the media card
	 * @param {Object} mediaData - the media data containing labels
	 * @return {string} - the HTML string for the labels section
	 */
	buildLabelSection(mediaData)
	{
		// Build the HTML for the labels section
		if (!mediaData._HasLabelsToDisplay)
		{
			return '';
		}
		let returnHtml = '';
		const labelGroups = mediaData._LabelGroups || [];
		// If there are no label groups, return an empty string
		if (!labelGroups || !labelGroups.length)
		{
			return '';
		}
		// Map through the label groups to create the HTML for each group
		const labelHtml = labelGroups.map((group) =>
		{
			// For each group, build the HTML for the labels
			let tagGroupHtml = '';
			const valuesHtml = group.Values.map((value) => /*HTML*/`<span class="is-size-7">${value.Value}</span>`).join(', ');
			// Create the HTML for the group with its labels
			tagGroupHtml = /*HTML*/`
			<div ${ mediaData._HideLabels ? this.hideMeCSS : ''} class="column">
				<div class="${this.sharedLabelCSS}">${group.Key}</div>
				<div class="${this.sharedDatumCSS}">${valuesHtml}</div>
			</div>`;
			return tagGroupHtml;
		}).join('');
		// Wrap the labels in a fixed grid container
		returnHtml = /*HTML*/`
		<div class="cell is-col-span-2">
			<div class="columns is-multiline">
				${labelHtml}
			</div>
		</div>`;
		return returnHtml;
	}

	/**
	 * Build the mini map image URL for the observation
	 * @param {Object} pObservation - the observation data to build the mini map image
	 * @return {string} - the URL for the mini map image or 'null'
	 */
	buildMiniMapImage(pObservation)
	{
		let hasValidCaptureGeoLocation = false;
		let hasValidUserGeoLocation = false;
		// check if the observation has a valid capture or user geolocation
		if (pObservation?.CaptureLatitude && pObservation?.CaptureLongitude)
		{
			hasValidCaptureGeoLocation = this.isValidLatitude(pObservation?.CaptureLatitude) &&
			this.isValidLongitude(pObservation?.CaptureLongitude) &&
			(Number(pObservation?.CaptureLatitude) !== 0 && Number(pObservation?.CaptureLongitude) !== 0);
		}
		if (pObservation?.UserLatitude && pObservation?.UserLongitude)
		{
			hasValidUserGeoLocation = this.isValidLatitude(pObservation?.UserLatitude) && this.isValidLongitude(pObservation?.UserLongitude) && (Number(pObservation?.UserLatitude) !== 0 && Number(pObservation?.UserLongitude) !== 0);
		}
		return hasValidCaptureGeoLocation || hasValidUserGeoLocation ? `/1.0/Observation/Map/For/${pObservation.IDObservation}` : `null`;
	}

	/**
	 * Trim the text to a maximum length and add ellipsis if it exceeds the length
	 * @param {string} text - the text to trim
	 * @param {number} maxLength - the maximum length of the text
	 * @return {string} - the trimmed text with ellipsis if it exceeds the maxLength
	 */
	trimText(text, maxLength = 500)
	{
		if (!text || typeof text !== 'string' || text.length <= maxLength)
		{
			return text;
		}
		return text.substring(0, maxLength) + '...';
	}

	/**
	 * Curate a list of observations into renderable media card data. Supports Image, Video,
	 * Audio, and File observation types. File observations (PDFs, documents, etc.) are rendered
	 * as thumbnail cards using the standard observation image endpoint.
	 * @param {Array} pObservations - the observations to build media cards for
	 * @param {Object} [pOptions] - the options to use for filtering and formatting the observations (optional)
	 * @return {Array} - the curated observations ready for card rendering
	 */
	curateMediaObservationList(pObservations, pOptions)
	{
		if (!pObservations || !pObservations.length)
		{
			return [];
		}
		// filter out observations that are not images
		let tmpObservations = pObservations.reduce((pFiltered, pObs) =>
		{
			let isMediaType = false;
			// determine if the observation has an image, video, or audio artifact
			if (pObs?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video')
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.Video[0].IDArtifact; // set the artifact ID for the video
				pObs._MediaType = !pOptions.isPrintView ? 'video' : 'image'; // if in print view, treat video as image
				pObs._Version = pObs.Details.Video[0].Version;
			} 
			if (pObs?.Details?.Audio?.[0]?.ArtifactType?.toLowerCase() === 'audio')
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.Audio[0].IDArtifact; // set the artifact ID for the audio
				pObs._MediaType = !pOptions.isPrintView ? 'audio' : 'image'; // if in print view, treat audio as image
				pObs._Version = pObs.Details.Audio[0].Version;
			}
			if (pObs?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image')
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.Image[0].IDArtifact; // set the artifact ID for the image
				pObs._MediaType = 'image';
				pObs._Version = pObs.Details.Image[0].Version;
			}
			// File observations (PDFs, documents, etc.) — render as thumbnail cards using the
			// standard observation image endpoint which returns a server-generated preview image.
			// Only matched when no higher-priority media type (Video/Audio/Image) was detected,
			// so an observation that has both an Image and a File detail won't be double-counted.
			if (!isMediaType && pObs?.Details?.File?.[0])
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.File[0].IDArtifact;
				pObs._MediaType = 'image'; // always use the thumbnail representation for file types
				pObs._Version = pObs.Details.File[0].Version;
			}
			if (isMediaType)
			{
				pObs._CardSize = pOptions?.cardSize; // set the card size based on options
				pObs._CardTheme = pOptions?.cardTheme; // set the card theme based on options
				// process the extra image details for the isolated observation card view
				pObs._ImageSource = `/1.0/Observation/${ pObs.IDObservation }/Image/Standard`;
				// flags passed from the configuration options
				pObs._HideTitle = pOptions?.hideTitle;
				pObs._HideId = pOptions?.hideId;
				pObs._HideCreator = pOptions?.hideCreator;
				pObs._HideCreateDate = pOptions?.hideCreateDate;
				pObs._HideDescription = pOptions?.hideDescription;
				// if the description is not hidden, we need to trim it to a maximum length
				if (!pObs?._HideDescription && pObs?.Description)
				{
					pObs._TrimmedDescription = this.trimText(pObs.Description, 425);
				}
				pObs._HideMiniMap = pOptions?.hideMiniMap;
				// build the mini map image URL based on the observation data
				if (!pObs?._HideMiniMap)
				{
					pObs._MiniMapImage = this.buildMiniMapImage(pObs);
				}
				// look up the user name from the map we built earlier
				pObs._CreatorName = pOptions?.userNameMap?.[pObs.CreatingIDUser] || '<span class="has-text-text-50">Name not provided</span>';
				// set the column class for the card based on the template options
				pObs._CardColumnClass = `has-${ pOptions?.cardLayouts?.[pOptions?.cardSize]?.columns || 2 }-cols`;
				// set the row class for the card based on the template options
				const tmpRowsCount = pOptions?.cardLayouts?.[pOptions?.cardSize]?.rows;
				pObs._CardHeightClass = tmpRowsCount > 0 ? `card-height-is-1-out-of-${ tmpRowsCount }` : '';
				pObs._ImageHeightClass = tmpRowsCount > 0 ? `image-height-is-1-out-of-${ tmpRowsCount }` : '';
				// show the station and offset row if the configuration option is set and the values are not empty
				if (!pOptions?.hideStationOffset)
				{
					pObs._HideStationOffset = pOptions?.hideStationOffset;
					pObs._HasStationOffsetRow = (pObs?.AlignmentStation?.length && Number(pObs?.AlignmentStation) !== 0) || (pObs?.AlignmentOffset?.length && Number(pObs?.AlignmentOffset) !== 0) ? 1 : 0;
				}
				// show the labels for the observation if the configuration option is set
				if (!pOptions?.hideLabels)
				{
					// show the labels if they are available (if we have keys other than "SAVE" in the Labels object)
					pObs._HasLabelsToDisplay = Object.keys(pObs?.Labels).filter((key) => key !== 'SAVE').length > 0 ? 1 : 0;
					// if we have labels, we need to process them into a format that can be used in the view
					if (pObs._HasLabelsToDisplay)
					{
						const tmpLabelList = {};
						// loop through the labels and add them to the label list
						Object.entries(pObs.Labels || {}).forEach(([ labelTypeKey, labelObjects ]) =>
						{
							// skip the SAVE key as it is not a label we want to display
							if (labelTypeKey === 'SAVE')
							{
								return;
							}
							// if the value is not an array, we need to convert it to an array
							if (!Array.isArray(labelObjects))
							{
								labelObjects = [ labelObjects ];
							}
							// if the label type is not in the list, we need to add it
							if (!tmpLabelList[labelTypeKey])
							{
								tmpLabelList[labelTypeKey] = [];
							}
							for (const labelObject of labelObjects)
							{
								// if the label object has a value, we need to add it to the list
								if (labelObject?.Tag && labelObject.Tag.length)
								{
									tmpLabelList[labelTypeKey].push({
										Value: labelObject.Tag,
									});
								}
							}
						});
						// convert the label list to an array of objects with Key and Values properties
						pObs._LabelGroups = tmpLabelList ? Object.entries(tmpLabelList).map(([ key, values ]) => ({ Key: key, Values: values })) : [];
					}
				}
				// if the configuration option is set, we need show the external link to the observation in Fieldbook
				pObs._HideExternalLink = pOptions?.hideExternalLink;
				pObs._ExternalLinkHref = `${ this.buildLinksUrl() }/#/project/${ pObs.IDProject }/journal/list/observation/${ pObs.IDObservation }`;

				// NOTE: These config options below are limited to the "minimalist" card type for now
				pObs._HideOrdinal = pOptions?.hideOrdinal;
				pObs._HideLocalOrdinal = pOptions?.ordinalScope === 'global';
				pObs._HideGlobalOrdinal = pOptions?.ordinalScope !== 'global';
				pObs._OrdinalPrefix = pOptions?.ordinalPrefix || '';
				pObs._OrdinalSuffix = pOptions?.ordinalSuffix || '';
				pObs._OrdinalPosition = pOptions?.ordinalPosition || 'left';
				pObs._TitlePosition = pOptions?.titlePosition || 'below';
				pObs._TitleAlignment = pOptions?.titleAlignment || 'left';

				// add the observation to the filtered list
				pFiltered.push(pObs);
			}
			return pFiltered;
		}, []);
		// primary grouping (ex: Elements)
		if (pOptions?.primaryGroupByLabelType)
		{
			// set the primary label type flag on each observation for use in the card template
			tmpObservations.forEach((obs) => {
				const primaryLabel = obs.Labels?.[pOptions.primaryGroupByLabelType]?.[0];
				obs._PrimaryGroupByLabel = primaryLabel ? primaryLabel.Tag : '-None-';
				// if we have a secondary grouping, set the secondary label type flag on each observation for use in the card template
				if (pOptions?.secondaryGroupByLabelType)
				{
					const secondaryLabel = obs.Labels?.[pOptions.secondaryGroupByLabelType]?.[0];
					obs._SecondaryGroupByLabel = secondaryLabel ? secondaryLabel.Tag : '-None-';
				}
			});
			// if we are grouping by a label type, we want to sort the observations by that label first so that they are grouped together in the UI
			// we want to put '-None-' groups at the end, so we use localeCompare which will sort them after all other values
			tmpObservations.sort((a, b) => {
			 	const aPrimary = a._PrimaryGroupByLabel;
			 	const bPrimary = b._PrimaryGroupByLabel;
				// if secondary grouping is enabled, we want to sort by the secondary label within the primary groups
				if (pOptions?.secondaryGroupByLabelType) {
					const aSecondary = a._SecondaryGroupByLabel;
					const bSecondary = b._SecondaryGroupByLabel;
					if (aPrimary === bPrimary) {
						if (aSecondary === bSecondary) {
							return 0;
						}
						return aSecondary.localeCompare(bSecondary);
					}
				}
			 	return aPrimary.localeCompare(bPrimary);
			});
			// if we have '-None-' groups, we want to move them to the end of the list after sorting so that they don't break up the groups with actual labels
			const noneGroupObservations = tmpObservations.filter(obs => obs._PrimaryGroupByLabel === '-None-');
			const otherGroupObservations = tmpObservations.filter(obs => obs._PrimaryGroupByLabel !== '-None-');
			tmpObservations = [ ...otherGroupObservations, ...noneGroupObservations ];
			
			// for clarification in the configuration, we will remove the other sort options since we are grouping by a label type to avoid confusion
			pOptions.sortBy = null;
			pOptions.sortOrder = null;
			return tmpObservations;
		}
		else {
			// sort the observations by the configured sort order and field
			return this.sortObservationsByKey(tmpObservations, pOptions?.sortBy, pOptions?.sortOrder);
		}
	}

	/**
	 * This method is used to validate if a passed string is a valid latitude geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLatitude('24.034345') => '24.034345'
	 */
	isValidLatitude = (value) =>
	{
		const latReg = RegExp(/^(\+|-)?(?:90(?:(?:\.0{0,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = latReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Latitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * This method is used to validate if a passed string is a valid longitude geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLongitude('24.034345') => '24.034345'
	 */
	isValidLongitude = (value) =>
	{
		const longReg = RegExp(/^(\+|-)?(?:180(?:(?:\.0{0,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = longReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Longitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * This method builds the links URL based on the current environment.
	 * It uses the getEnvironmentSubdomainFromWindowLocation method to determine the subdomain.
	 * @return {string} - The links URL for the current environment.
	 */
	buildLinksUrl()
	{
		if (window?.location?.href?.includes('localhost') || window?.location?.href?.includes('.qa.'))
		{
			return `https://links.qa.headlight.com`;
		}
		else if (window?.location?.href?.includes('.stg.'))
		{
			return `https://links.stg.headlight.com`;
		}
		else
		{
			return `https://links.headlight.com`;
		}
	}

	/**
	 * Sorts the observations by a given key and order
	 * @param {Array} pObservations - The observations to sort
	 * @param {String} pSortBy - The key to sort by
	 * @param {String} pSortOrder - The order to sort by (asc or desc)
	 * @return {Array} - The sorted observations
	 */
	sortObservationsByKey(pObservations, pSortBy, pSortOrder)
	{
		if (!pObservations || !pObservations.length)
		{
			return pObservations;
		}
		if (!pSortBy)
		{
			console.info('No sort key provided - returning unsorted observations.');
			return pObservations;
		}
		// TODO: Add support for Labels and Datums
		const tmpSortOrder = pSortOrder && pSortOrder.toLowerCase() === 'desc' ? -1 : 1;
		const tmpSortedObservations = pObservations.sort((a, b) =>
		{
			const aValue = a[pSortBy];
			const bValue = b[pSortBy];
			if (aValue < bValue)
			{
				return -1 * tmpSortOrder;
			}
			if (aValue > bValue)
			{
				return 1 * tmpSortOrder;
			}
			return 0;
		});
		return tmpSortedObservations;
	}

	/**
	 * This function handles the global ordinal numbering for media cards on the DOM after everything is loaded.
	 */
	handleGlobalOrdinalNumbering()
	{
		// scrape the UI and reapply global ordinals from top to bottom
		$('.media-card-wrapper .media-card-global-ordinal').each((index, element) =>
		{
			$(element).text(index + 1);
		});
	}
}

module.exports = MediaCardBuilder;

},{}],248:[function(require,module,exports){
/**
 * Creates a simple deferred promise
 */
class Deferred {
	constructor() {
		this.promise = new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}
}

/**
 * A simple abstraction of sending RPC messages across an event bus and receiving responses.
 * This is intended to be used to communicate with the native side of the application.
 * Users of this class are expected to tell this how to post messages and tell it when a message was received.
 * The means in which messages are sent and received are not defined here and should be implemented by the user.
 */
class EventRPCBridge {
	/** @type {Object<string, Deferred>} */
	_callbackDefermentMap = {};
	/**
	 * @type {function({method: string, callbackId: string, payload: any}): void}
	 */
	_postMessage;

	/**
	 * A unique key to "namespace" our messages.
	 * Right now this is put in just to be sure that if there are 2 bridges on the same bus the messages don't get mixed up.
	 * It's not actually needed as of this moment, more of a safety rail for the future.
	 * @type {string}
	 * @private
	 */
	_RPCKey = Math.random().toString(36).substring(2);
	_messageId = 0;

	/**
	 *
	 * @param {{
	 *     postMessage: function({method: string, callbackId: string, payload: any}): void
	 * }} options
	 */
	constructor(
		options
	) {
		this._postMessage = options.postMessage;
	}

	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} payload
	 * @return {Promise<unknown>}
	 */
	async invokeRPCMethod(method, payload) {
		const callbackId = this._createCallbackId();
		// register our deferment on our callbacks to be called later
		const deferment = new Deferred();
		this._callbackDefermentMap[callbackId] = deferment;

		// send the message to the native side
		this._postMessage({
			method,
			callbackId,
			payload,
		});

		return deferment.promise;
	}

	/**
	 * Resolves or rejects the original caller's promise. Should be called when a method complete message is received from the other side of the bridge.
	 *
	 * @param {{
	 *    callbackId: string,
	 *    result?: any,
	 *    error?: any,
	 *    message?: string,
	 * }} message
	 */
	onRPCMethodComplete(message) {
		if(!message) {
			console.error('EventRPCBridge Received invalid message: message is falsy', message);
			return;
		}
		if(!message.callbackId) {
			console.error('EventRPCBridge Received invalid message: no callbackId', message);
			return;
		}

		const deferment = this._callbackDefermentMap[message.callbackId];
		if(!deferment) {
			console.error('EventRPCBridge Received invalid message: callbackId is not in our deferment map, unresolvable', message);
			return;
		}

		if (message.error) {
			deferment.reject(new Error(message.message || message.error));
		} else {
			deferment.resolve(message.result);
		}
		delete this._callbackDefermentMap[message.callbackId];
	}

	/**
	 * Creates a callback ID which is guaranteed to be unique in this context
	 *
	 * @return {string}
	 * @private
	 */
	_createCallbackId() {
		if(Object.keys(this._callbackDefermentMap).length > 20) {
			console.warn('There are a lot of outstanding RPC calls. This may be indicative of a problem');
		}

		this._messageId++;
		return `${this._RPCKey}-${this._messageId}`;
	}
}

module.exports = {
	EventRPCBridge
}
},{}],249:[function(require,module,exports){
const {EventRPCBridge} = require('../EventRPCBridge');


const MSG_TYPES = {
	PING: 'Cordova_RPCPing',
	PONG: 'Cordova_RPCPong',
	INVOKE: 'Cordova_RPCInvoke',
	INVOKE_COMPLETE: 'Cordova_RPCComplete',
}


let hasBridge = false;
// a cordova bridge is only possible in an iframe environment (we have a window.parent)
if(window.parent && window.self !== window.top) {
	console.log('Have window parent, waiting for parent bridge.');
	/*
	 Because we dont know if the window.parent is a native application and has a cordova bridge we need to
	 do some verification:

	 This is like a server PING -> PONG request to see if the bridge is there.

	 1. Client "connects" by listening for messages
	 2. Client sends "RPCPing" message to parent
	 3. Server listens for "RPCPing" and sends "RPCPong" message back
	 4. Client knows it's connected and can start sending messages

	 Its like sonar with a specific signature
	 */

	// listen for PONG responses
	window.addEventListener('message', function(e) {
		const type = e?.data?.type;

		// if we get a ping message from the parent or get our pong back then we know were ready
		// this is a sonar ping to see if the bridge is there
		if(type === MSG_TYPES.PING) {
			window.parent.postMessage({
				type: MSG_TYPES.PONG,
			}, '*');
			console.log('Forms cordova bridge ready');
			hasBridge = true;
		} else if(type === MSG_TYPES.PONG) {
			console.log('Forms cordova bridge ready');
			hasBridge = true;
		}
	}, false);

	// send out a PING and see if we can get a pong back, the hosting application should also send out a ping when its ready
	window.parent.postMessage({
		type: MSG_TYPES.PING,
	}, '*');
}


/**
 * CordovaNativeBridge is a class that provides a way to call native methods from a webview.
 * Communication is done through the postMessage API using the EventRPCBridge.
 */
class CordovaNativeBridge {
	/**
	 * @type {EventRPCBridge}
	 * @private
	 */
	_eventBridge;

	constructor() {
		if(!window.parent) {
			console.error('No native message message handler found but native bridge was constructed. This is likely indicative of an problem');
		}

		this._eventBridge = new EventRPCBridge({
			postMessage: this._postMessage.bind(this),
		});

		this._listenForRPCMessages();
	}

	/**
	 * Listens for messages from the native side of the bridge and forwards them to the event bridge handler
	 * @private
	 */
	_listenForRPCMessages() {
		window.addEventListener('message', (event) => {
			console.log('Message received', event);
			const detail = event.data;
			if(detail && detail.type === MSG_TYPES.INVOKE_COMPLETE) {
				this._eventBridge.onRPCMethodComplete(detail);
			}
		});
	}

	_postMessage(message) {
		if(!window.parent) {
			throw new Error('Cannot post message to parent window, no parent window found');
		}
		window.parent.postMessage({
			type: MSG_TYPES.INVOKE,
			message: message,
		}, '*');
	}



	/**
	 * Invoke the native method with the given arguments.
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	async invokeNativeMethod(method, args) {
		return this._eventBridge.invokeRPCMethod(method, args);
	}
}

CordovaNativeBridge.supported = () => {
	return Boolean(hasBridge);
}

module.exports = {
	CordovaNativeBridge
};
},{"../EventRPCBridge":248}],250:[function(require,module,exports){
const {EventRPCBridge} = require('../EventRPCBridge');

/**
 * A bridge to interact with the Webkit message handler which is used to communicate with the native side on iOS applications.
 * Applications should register a WKScriptMessageHandler called "shared" which will be used to communicate with the native side.
 * To send data back to this bridge, the native side should post a message to the window with the event name "nativeMethodComplete"
 */
class WebkitSharedNativeBridge {
	/**
	 * @type {EventRPCBridge}
	 * @private
	 */
	_eventBridge;

	constructor() {
		if(!window.webkit?.messageHandlers?.shared) {
			console.error('No native message message handler found but native bridge was constructed. This is likely indicative of an problem');
		}

		this._eventBridge = new EventRPCBridge({
			postMessage: this._postMessage.bind(this),
		});

		this._listenForRPCMessages();
	}

	/**
	 * Begins listening for the native method complete event which should be fired by the native side.
	 * This is how we know when a native method has completed and get its results
	 * @private
	 */
	_listenForRPCMessages() {
		console.log('Attaching native method complete event listener');
		window.addEventListener('nativeMethodComplete', 
		(event) => {
			const detail = event.detail;
			if(detail) {
				this._eventBridge.onRPCMethodComplete(detail);
			}
		});
	}

	_postMessage(message) {
		const messageBus = window.webkit?.messageHandlers?.shared;
		if(messageBus && messageBus.postMessage) {
			messageBus.postMessage({
				objcMethod: message.method,
				callbackId: message.callbackId,
				params: message.payload,
			});
		} else {
			throw new Error('Could not post message due to missing webkit message handler')
		}
	}


	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	async invokeNativeMethod(method, args) {
		return this._eventBridge.invokeRPCMethod(method, args);
	}
}

WebkitSharedNativeBridge.supported = () => {
	return Boolean(window.webkit?.messageHandlers?.shared?.postMessage);
}


module.exports = {
	WebkitSharedNativeBridge,
}
},{"../EventRPCBridge":248}],251:[function(require,module,exports){
const {CordovaNativeBridge} = require("./bridges/CordovaNativeBridge");
const {WebkitSharedNativeBridge} = require("./bridges/WebkitSharedNativeBridge");

/**
 * The contract of a native bridge function
 */
class NativeBridge {

	constructor(){}

	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	invokeNativeMethod(method, args) {
		throw new Error('NativeBridge not active');
	}
}

/**
 * Gets the available native bridge class
 * @return {NativeBridge|null}
 */
function getAvailableNativeBridgeClass() {
	if(CordovaNativeBridge.supported()) {
		// @ts-ignore
		return CordovaNativeBridge;
	} else if(WebkitSharedNativeBridge.supported()) {
		// @ts-ignore
		return WebkitSharedNativeBridge;
	}

	return null;
}


let cachedStatusResponse = null;
/**
 * @type {NativeBridge|null}
 */
let existingBridge = null;

/**
 *
 * @return {NativeBridge}
 */
function getBridge() {
	if(!existingBridge) {
		const BridgeClass = getAvailableNativeBridgeClass();
		if (!BridgeClass) {
			throw new Error('No native bridge available');
		}
		// @ts-ignore
		existingBridge = new BridgeClass();
	}
	return existingBridge;
}

const libFableService = require('fable-serviceproviderbase');

class NativeBridgeFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }}}
		 */
		this.fable;

		this.serviceType = 'NativeBridge';

	}

	/**
	 * Checks if native functions are available.
	 *
	 * @return {*|boolean}
	 */
	hasNativeSupport() {
		return getAvailableNativeBridgeClass() !== null;
	}

	/**
	 * Prints image
	 * @param {object} options
	 * @param {string} [options.jobName] - Title of the print job
	 * @param {string} options.base64Image - Base64 encoded image
	 * @return {Promise}
	 */
	async printImage(options) {
		const supported = await this.methodSupported('printImage');
		if(!supported) {
			window.alert('This app version does not support printing. Please update your application to the latest version.');
			return Promise.reject('Native print not supported');
		}
		return await getBridge().invokeNativeMethod('printImage', {
			jobName: options.jobName || 'Print Image',
			base64Image: options.base64Image,
		});
	}

	/**
	 * Gets the location coordinates from a native app.
	 * @return {Promise}
	 */
    async getLocation() {
		const supported = await this.methodSupported('getLocation');
		if(!supported) {
			return Promise.reject('Native location not supported');
		}
	   return await getBridge().invokeNativeMethod('getLocation', {});
    }

	/**
	 * Gets the bridge status details, once fetched they will not be fetched again.
	 * This gives you version numbers and other details about the native bridge.
	 *
	 * If the bridge doesn't exist then you get bridgeVersion: 0 and appVersion: ''
	 *
	 * @return {Promise<{
	 *     bridgeVersion: number,
	 *     appVersion: string,
	 * 	   supports: array,
	 *     intent?: {
	 *         action: string,
	 *         data: string,
	 *     }
	 * }>}
	 */
	async status() {
		if(getAvailableNativeBridgeClass() == null) {
			return {
				bridgeVersion: 0,
				appVersion: '',
				supports: ['status', 'hasNativeSupport']
			}
		}

		if(!cachedStatusResponse) {
			cachedStatusResponse = await getBridge().invokeNativeMethod('status', {});
		}

		cachedStatusResponse.supports = ['status', 'hasNativeSupport'];

		if (cachedStatusResponse.bridgeVersion >= 1)
		{
			cachedStatusResponse.supports.push('printImage');
		}
		if (cachedStatusResponse.bridgeVersion >= 2)
		{
			cachedStatusResponse.supports.push('getLocation');
		}

		return cachedStatusResponse;
	}

	/**
	 * Method to check if a method is supported by the native bridge.
	 * @param {String} method - name of the method we are checking support for. 
	 */
	async methodSupported(method)
	{
		const status = await this.status();
		return status.supports.includes(method);
	}
}

module.exports = NativeBridgeFableService;
module.exports.default_configuration = {};
},{"./bridges/CordovaNativeBridge":249,"./bridges/WebkitSharedNativeBridge":250,"fable-serviceproviderbase":398}],252:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/**
 * FIXME: figure out how to flow these types through in a more sane way...
 * @typedef {import('pict') & import('fable') &
 * {
 *   HeadlightRestClient: import('headlight-rest-client'),
 *   MetaTemplate: any, // import('fable').MetaTemplate,
 *   views: { PictFormMetacontroller: import('pict-section-form').PictFormMetacontroller },
 *   fable: import('fable'),
 * }} Pict
 */

/** @typedef {import('fable')} Fable */
/** @typedef {(pError?: (Error | String)) => void} HybridErrorCallback */

/**
 * Pict Login view.
 */
class HeadlightLogin extends libPictViewClass
{
	/**
	 * @param {import('fable')} pFable - The fable instance.
	 * @param {any} [pOptions] - The view options.
	 * @param {any} [pServiceHash] - The fable service instance hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/**
		 * FIXME: figure out how to flow these types through in a more sane way...
		 * @type {import('pict') & import('fable') &
		 * {
		 *   MetaTemplate: any, // import('fable').MetaTemplate,
		 *   views: { PictFormMetacontroller: any },
		 *   fable: import('fable'),
		 *   TransactionTracking: any, //FIXME: correct type
		 *   PictApplication: import('pict-application') & {
		 *     onBeforeLogin?: () => Promise<void>,
		 *     onBeforeLogout?: () => Promise<void>,
		 *     onInteractiveLogin?: () => Promise<void>,
		 *     onInteractiveLogout?: () => Promise<void>,
		 *     onAfterInteractiveLogin?: () => Promise<void>,
		 *   },
		 *   RestClient: any,
		 * }}
		 */
		this.pict;

		/** @type {Fable} */
		this.fable;

		/** @type {any} */
		this.options;
	}

	/**
	 * Handle view initialization.
	 *
	 * TODO: consider pre-populating the username if user selected 'Remember Me'
	 */
	onInitialize()
	{
		this.LoginUserName = '';
		this.LoginPassword = '';
		this.LoginTitle = '';
		this.LoginTitleStyles = '';
		this.LoginWallpaperStyles = 'background-color: var(--bulma-grey-darker);';
		this.LoginWallpaperImageList = [];
		this.LoginWallpaperImageListDuration = 5000;
		return super.onInitialize();
	}

	/**
	 * A method to pass in custom styles to the login modal.
	 * @param {Object} pOptions 
	 */
	customizeLoginPage(pOptions)
	{
		this.LoginTitle = pOptions?.title;
		this.LoginTitleStyles = pOptions?.titleStyles;
		this.LoginWallpaperStyles = pOptions?.wallpaperStyles;
		this.LoginWallpaperImageList = pOptions?.wallpaperImageList;

		this.renderAsync(null, null, null, () =>
		{
			this.pict.log.info('Customized login page with title and wallpaper');
		});
	}

	/**
	 * A method to pass in custom styles to the login modal.
	 * @param {Object} pOptions
	 */
	customizeLogoutPage(pOptions)
	{
		this.LoginTitle = pOptions?.title;
		this.LoginTitleStyles = pOptions?.titleStyles;
		this.LoginWallpaperStyles = pOptions?.wallpaperStyles;
		this.LoginWallpaperImageList = pOptions?.wallpaperImageList;
		if (pOptions?.closePanelsOnLogout)
		{
			this.pict.views.HeadlightPanels.closeAllPanels();
		}
		this.show();
	}

	/**
	 * Show the login view.
	 */
	show()
	{
		this.render();
		this.pict.ContentAssignment.addClass(this.options.DefaultDestinationAddress, 'active');
		this.pict.ContentAssignment.removeClass(this.options.DefaultDestinationAddress, 'is-hidden');
	}

	/**
	 * Show the result of a login attempt.
	 *
	 * @param {string} [pMessageType] - The type of message to show.
	 */
	handleLoginMessages(pMessageType)
	{
		// clear all messages first
		this.pict.ContentAssignment.addClass('#Login_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Success', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Invalid', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Failed', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Reset', 'is-hidden');

		// then turn on the type we passed
		if (pMessageType === 'login-error')
		{
			this.pict.ContentAssignment.removeClass('#Login_Error', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Invalid', 'is-hidden');
		}
		else if (pMessageType === 'password-reset-success')
		{
			this.pict.ContentAssignment.removeClass('#PasswordReset_Success', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Reset', 'is-hidden');
		}
		else if (pMessageType === 'password-reset-error')
		{
			this.pict.ContentAssignment.removeClass('#PasswordReset_Error', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Failed', 'is-hidden');
		}
		else
		{
			// do nothing for now - can be for additional statuses
		}
	}

	get loggedInStatus()
	{
		if (!this.AppData.hasOwnProperty('CurrentUser'))
		{
			return false;
		}
		if (!this.AppData.CurrentUser.hasOwnProperty('LoggedIn'))
		{
			return false;
		}
		return (this.AppData.CurrentUser.LoggedIn);
	}

	/**
	 * Check if the user is authenticated.
	 *
	 * @param {(pError: (Error | String | null), pSuccess: Boolean) => void} callback - error-first callback to notify on loggedin status (error, true|false)
	 */
	isUserLoggedIn(callback)
	{
		this.pict.RestClient.getJSON('/1.0/CheckSession', (pError, pResponse, pBody) =>
		{
			if (pError || !pBody.LoggedIn)
			{
				// this.AppData.CurrentUser = undefined;
				if (pError)
				{
					this.pict.log.error(`session check failed: ${pError.message || pError}`, { Stack: pError.stack, Response: pBody });
				}
				else
				{
					this.pict.log.trace('user not logged in, no session found', { Response: pBody });
				}
				callback(null, false);
				return;
			}
			// already logged in
			this.AppData.CurrentUser = pBody;
			callback(null, true);
		});
	}

	/**
	 * Handle the login form submission.
	 *
	 * @param {UIEvent} event - The event that triggered the login.
	 */
	login(event)
	{
		if (typeof (this.pict.PictApplication.onBeforeLogin) === 'function')
		{
			this.pict.PictApplication.onBeforeLogin();
		}
		// prevent the standard page refresh on a form > submit action
		event.preventDefault();

		const tmpHeadlightAuthenticateBody = (
			{
				UserName: this.pict.ContentAssignment.readContent('#Headlight_LoginID'),
				Password: this.pict.ContentAssignment.readContent('#Headlight_Password')
			});

		const tmpAuthenticateRequestOptions = (
			{
				url: '/1.0/Authenticate',
				body: tmpHeadlightAuthenticateBody
			});

		this.pict.RestClient.postJSON(tmpAuthenticateRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError || !pBody || !pBody.LoggedIn)
				{
					this.pict.log.error(`authentication failed: ${pError}`, pError);
					this.handleLoginMessages('login-error');

					return;
				}
				this.AppData.CurrentUser = pBody;
				this.pict.ContentAssignment.removeClass(this.options.DefaultDestinationAddress, 'is-active');
				this.pict.ContentAssignment.addClass(this.options.DefaultDestinationAddress, 'is-hidden');
				this.pict.log.info(`Authenticated: `, pBody);

				// hide modal after login
				this.pict.ContentAssignment.removeClass('#LoginModal', 'is-active');
				// clear out any messages in the modal
				this.handleLoginMessages();

				if (typeof this.pict.PictApplication.loginAsync === 'function')
				{
					this.pict.PictApplication.loginAsync((pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error in Application loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
						}
						else
						{
							this.pict.log.info(`Application loginAsync completed successfully`);
						}
					});
				}
				if (typeof (this.pict.PictApplication.onInteractiveLogin) === 'function')
				{
					const res = this.pict.PictApplication.onInteractiveLogin();
					if (res && res.then && res.catch) // Promise duck typing - this is sucky, formalize this better
					{
						// just ensure we don't crash the app if the promise fails
						res.catch((pError) =>
						{
							this.pict.log.error(`Error in Application's onInteractiveLogin: ${pError.message || pError}`, { Stack: pError.stack });
						});
					}
				}
			});
	}

	/**
	 * Lifecycle event after the view renders.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object.
	 */
	onAfterRender(pRenderable)
	{
		const eventBindings = document.querySelectorAll(pRenderable.ContentDestinationAddress + ' *[data-event-bind]');
		for (let elem of eventBindings)
		{
			const [ event, handler ] = (elem.getAttribute('data-event-bind') || '').split(':');

			if (!event)
			{
				this.pict.log.error('No event specified for event binding for element', elem);
				continue;
			}

			const handlerFn = this[handler];

			if (!handlerFn)
			{
				this.pict.log.error('No handler function found for event binding for element', elem);
				continue;
			}

			elem.addEventListener(event, handlerFn.bind(this));
		}
		// handle the login wallpaper image list transitions if a list is provided
		this.handleImageListTransistions();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * @param {UIEvent} event - the event that triggered the logout
	 */
	logout(event)
	{
		if (typeof this.pict.PictApplication.onBeforeLogout === 'function')
		{
			this.pict.PictApplication.onBeforeLogout();
		}
		this.pict.RestClient.getJSON('/1.0/Deauthenticate', (pError, pResponse, pBody) =>
		{
			if (pError || !pBody || !pBody.Success)
			{
				this.pict.log.error(`Problem logging out: ${pError.message || pError}`, { Stack: pError.stack, Response: pBody });
				return;
			}

			this.pict.log.info(`Logged out successfully.`,{ Response: pBody });
			if (typeof this.pict.PictApplication.loginAsync === 'function')
			{
				this.pict.PictApplication.loginAsync((pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error in Application loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else
					{
						this.pict.log.info(`Application loginAsync completed successfully`);
					}
				});
			}
			if (typeof (this.pict.PictApplication.onInteractiveLogout) === 'function')
			{
				// TODO: should we call this even if logout failed?
				const res = this.pict.PictApplication.onInteractiveLogout();
				if (res && res.then && res.catch) // Promise duck typing - this is sucky, formalize this better
				{
					// just ensure we don't crash the app if the promise fails
					res.catch((pError) =>
					{
						this.pict.log.error(`Error in Application onInteractiveLogout: ${pError.message || pError}`, { Stack: pError.stack });
					});
				}
			}
		});
	}

	/**
	 * Handle the image list transitions for the login wallpaper.
	 * @spec get the list of images from the context and set the background image to the element for 5 seconds, then fade/transition to the next image, in a loop
	 * @return {void}
	 */
	handleImageListTransistions()
	{
		let nextIndex = 1;
		// get the list of images from the context
		// for each image in the list, set the background image to the element for 5 seconds, then fade/transition to the next image, in a loop
		if (this.LoginWallpaperImageList && this.LoginWallpaperImageList.length > 0)
		{
			const imageElement = document.getElementById('LoginModal-Wallpaper');
			if (imageElement)
			{
				// set the initial transition effects
				imageElement.style.backgroundSize = 'cover';
				imageElement.style.backgroundPosition = 'center';
				imageElement.style.transition = 'background-image 1s ease-in-out';
				// set the next image after 5 seconds
				setInterval(() =>
				{
					// set the current image to the next image
					imageElement.style.backgroundImage = `url(${this.LoginWallpaperImageList[nextIndex]})`;
					// set the next index to the next index + 1, or 0 if it is at the end of the list
					nextIndex = (nextIndex + 1) % this.LoginWallpaperImageList.length;
				}, this.LoginWallpaperImageListDuration || 5000);
			}
			else
			{
				this.pict.log.warn('Unable to find additional image elements for wallpaper transition');
			}
		}
		else
		{
			this.pict.log.info('No additional images found for wallpaper transition');
		}
	}

	/**
	 * @spec abstraction of document object manipulation to check the 'type' attribute of the password input field
	 * @return {boolean} value of " 'type' of the password input field is 'password' "
	 */
	isPasswordFieldProtected()
	{
		return document.getElementById('Headlight_Password').getAttribute('type') === 'password';
	}

	/**
	 * Toggle the password visibility when the user clicks on the eye icon
	 */
	togglePasswordInput()
	{
		if (this.isPasswordFieldProtected())
		{
			this.pict.ContentAssignment.addClass('#Password-Toggle-Icon', 'fa-eye');
			this.pict.ContentAssignment.removeClass('#Password-Toggle-Icon', 'fa-eye-slash');
			document.getElementById('Headlight_Password').setAttribute('type', 'text');
		}
		else
		{
			this.pict.ContentAssignment.removeClass('#Password-Toggle-Icon', 'fa-eye');
			this.pict.ContentAssignment.addClass('#Password-Toggle-Icon', 'fa-eye-slash');
			document.getElementById('Headlight_Password').setAttribute('type', 'password');
		}
	}

	/**
	 * @spec take the current 'username' value and trigger a "reset password" email if the user has a match
	 */
	handleForgotPassword()
	{
		const loginName = this.pict.ContentAssignment.readContent('#Headlight_LoginID');
		const formElement = this.pict.ContentAssignment.getElement('form');
		// prompt the user to enter a user name as it can not be empty to do a reset password
		if ((formElement && formElement.length) && !loginName)
		{
			formElement[0].reportValidity();
			return;
		}
		this.pict.RestClient.getJSON('/1.0/User/ForgotPassword/' + loginName, (pError, pResponse, pBody) =>
		{
			if (pError || !pBody || !pBody.Success)
			{
				this.pict.log.error(`Problem with password recovery request for ${loginName}: ${pError?.message || pError}`, { Stack: pError?.stack, Response: pBody });
				this.handleLoginMessages('password-reset-error');
			}
			else
			{
				this.pict.log.info(`Successfully generated a reset password email for login name '${loginName}': ${pBody.length} `, { Response: pBody });
				this.handleLoginMessages('password-reset-success');
			}
		});
	}

	closeForgotPasswordMessage()
	{
		this.pict.ContentAssignment.addClass('#Login_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Success', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container', 'is-hidden');
	}
}

module.exports = HeadlightLogin;

module.exports.default_configuration = (
{
	ViewIdentifier: "HeadlightLogin",
	RenderOnLoad: false,
	AutoRender: false,
	DefaultRenderable: "HeadlightLogin-Standard",
	DefaultDestinationAddress: "#HeadlightLogin-Standard-Wrap",
	CSS: /*css*/ ``,
	Templates: [
		{
			Hash: "HeadlightLogin-Standard-Wrap",
			Template: /*html*/`
			<section id="HeadlightLogin-Standard-Wrap">
				{~T:HeadlightLogin-Standard-MaterialDesign~}
			</section>
			`			
		},
		{
			Hash: "HeadlightLogin-Standard-MaterialDesign",
			Template: /*html*/`
			<div class="modal is-active" id="LoginModal">
			  	<div id="LoginModal-Wallpaper" class="modal-background" style="{~D:Context[0].LoginWallpaperStyles~}"></div>
				<h1 id="LoginModal-Title" class="title is-size-1 has-text-white px-2" style="{~D:Context[0].LoginTitleStyles~}">{~D:Context[0].LoginTitle~}</h1>
				<form role="login-form" data-event-bind="submit:login">
					<div class="modal-content">
						<div class="box pt-0 pr-6 pb-6 pl-6">
							<div class="container has-text-centered">
								<img src="./images/hashes.png" width="350px" alt="color-hashes" />
							</div>
							<div class="container has-text-centered my-5">
								<img src="./images/HeadLight-logo_gray.png" width="300px" alt="HeadLight" />
							</div>
							<div class="field">
								<p class="control has-icons-left">
									<input id="Headlight_LoginID" required class="input" type="text" name="username" placeholder="Username" value="{~D:Context[0].LoginUserName~}">
									<span class="icon is-small is-left">
										<i class="fas fa-user"></i>
									</span>
								</p>
							</div>
							<div class="field">
								<p class="control has-icons-left has-icons-right">
									<input id="Headlight_Password" required class="input" name="password" type="password" role="input-password" autocomplete="current-password" placeholder="Password" value="{~D:Context[0].LoginPassword~}">
									<span class="icon is-small is-left">
										<i class="fas fa-lock"></i>
									</span>
									<span class="icon is-small is-right is-clickable" data-event-bind="click:togglePasswordInput">
										<i id="Password-Toggle-Icon" class="fas fa-eye-slash"></i>
									</span>
								</p>
							</div>
							<div class="container has-text-centered">
								<div id="Login_Error" class="notification is-hidden is-danger is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Invalid" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
									<i class="fas fa-exclamation-circle mr-1"></i>
										Invalid username or password
								</div>
								<div id="PasswordReset_Error" class="notification is-hidden is-danger is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Failed" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
									<i class="fas fa-exclamation-circle mr-1"></i>
										Password recovery failed
								</div>
								<div id="PasswordReset_Success" class="notification is-hidden is-warning is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Reset" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
										If an account is associated with this username, then password recovery instructions have been sent to the connected email.
								</div>
							</div>
							<div class="columns">
								<div class="column">							
									<button id="Login-ForgotPassword-Button" type="button" class="button is-ghost" data-event-bind="click:handleForgotPassword">Forgot Password?</button>
								</div>
								<div class="column">
									<div class="buttons is-right">
										<button type="submit" class="button is-link">Login</button>
									</div>
								</div>
							</div>
						</div>
						<div class="container has-text-centered has-text-white is-size-7">By clicking Login you are agreeing to our <a target="_blank" class="link has-text-warning" href="https://fieldbook.qa.headlight.com/Assets/templates/terms-of-service.html">Terms and Conditions</a>.</div>
					</div>
				</form>
			</div>`
		}
	],
	Renderables: [
		{
			RenderableHash: "HeadlightLogin-Standard",
			TemplateHash: "HeadlightLogin-Standard-MaterialDesign",
			DestinationAddress: "#HeadlightLogin-Standard-Wrap"
		}
	]
});

},{"pict-view":693}],253:[function(require,module,exports){
const PictViewClass = require('pict-view');

// Available signature font styles. Form authors pick one via
// `MyDefaultFormManifest.SignatureSectionFontStyle`. Only the font for the
// selected style is fetched at render time.
const SIGNATURE_FONT_STYLES = {
	Default: { FontFamily: 'Rock Salt', URLParam: 'Rock+Salt', CSSClass: 'hl-signature-font-default' },
	Cursive: { FontFamily: 'Corinthia', URLParam: 'Corinthia', CSSClass: 'hl-signature-font-cursive' },
	Serif: { FontFamily: 'Merriweather', URLParam: 'Merriweather', CSSClass: 'hl-signature-font-serif' },
	'Sans-serif': { FontFamily: 'Cabin', URLParam: 'Cabin', CSSClass: 'hl-signature-font-sans-serif' },
};

class HeadlightSignatures extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// TODO: Port this over to Pict, don't leave it here
		// Example: {~DateFormatTZ:AppData.Date^MM/YYYY^AppData.DocumentData.Timezone^~}
		this.pict.MetaTemplate.addPattern('{~DateFormatTZ:', '~}', (pHash, pData, fCallback) =>
		{
			let tmpHash = pHash.trim();
			let tmpData = (typeof (pData) === 'object') ? pData : {};
			let tmpDateValueSet = tmpHash.split('^');

			let date = pData.UpdateDate; // NOTE: using instead of 'tmpDataValueSet[0]' for now (needs a "Record" look up)
			let format = tmpDateValueSet[1] || '';
			let timezone = tmpDateValueSet[2] ? this.pict.resolveStateFromAddress(tmpDateValueSet[2]) : null

			let tmpDayJS = pFable.Dates.dayJS.utc(date);
			try
			{
				if (timezone)
				{
					tmpDayJS = tmpDayJS.tz(timezone);
				}
				else
				{
					try
					{
						tmpDayJS = tmpDayJS.tz(pFable.Dates.dayJS.tz.guess());
					}
					catch (pError)
					{
						this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
					}
				}
			}
			catch
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(pFable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
			return tmpDayJS.format(format);
		});

		this.SignatureData = {
			SignaturesList: [],
			IsApproved: false,
			Font: SIGNATURE_FONT_STYLES.Default,
			Options: {
				HideSectionHeader: false,
				ShowTitles: true,
				HideDates: false,
				CustomLabels: []
			}
		};
	}

	/**
	 * Resolve the configured signature font style from the manifest.
	 * Form authors set this via `MyDefaultFormManifest.SignatureSectionFontStyle`
	 * before the form is published — it is read once per render and not expected
	 * to change while a form is in active use.
	 *
	 * @returns {{ FontFamily: string, URLParam: string, CSSClass: string }}
	 */
	resolveSignatureFontStyle()
	{
		const tmpConfiguredStyle = this.pict?.settings?.MyDefaultFormManifest?.SignatureSectionFontStyle;
		if (!tmpConfiguredStyle)
		{
			return SIGNATURE_FONT_STYLES.Default;
		}
		const tmpNormalized = String(tmpConfiguredStyle).toLowerCase();
		const tmpMatchedKey = Object.keys(SIGNATURE_FONT_STYLES).find((pKey) => pKey.toLowerCase() === tmpNormalized);
		if (tmpMatchedKey)
		{
			return SIGNATURE_FONT_STYLES[tmpMatchedKey];
		}
		this.pict.log.warn(`Unknown SignatureSectionFontStyle "${tmpConfiguredStyle}"; falling back to Default. Valid options: ${Object.keys(SIGNATURE_FONT_STYLES).join(', ')}.`);
		return SIGNATURE_FONT_STYLES.Default;
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		try {
			this.SignatureData.Font = this.resolveSignatureFontStyle();
			if (!this.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				this.pict.log.error('Signature section cannot be rendered without a valid Document ID');
				return;
			}
			// NOTE: This assume the traditional Draft/Submit/Approve/Reject workflow
			// TODO: Add a way to configure the workflow and handle custom statuses

			// set the approval flag to hide/show the disclaimer
			this.SignatureData.IsApproved = this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'approved';
			// no need to show anything if we are in draft/reject
			if (this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'draft' || this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'rejected')
			{
				return;
			}
			const reversedLogList = this.AppData?.DocumentData?.ReportData?.ApprovalActions.reverse();
			// if we are approved, add the approval log to the list
			if (this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'approved') {
				const approvalLog = reversedLogList.find((l) => l.Action.toLowerCase() === 'approve');
				// set the label for the signature
				approvalLog.Label = this.formatSignatureLabel(approvalLog);
				// add the approvalLog to the list
				this.SignatureData.SignaturesList.unshift(approvalLog);
			}
			// for submitted/reviewed, we know we're not in Draft/Reject/Approved if we are here
			const submitLog = reversedLogList.find((l) => l.Action.toLowerCase() === 'submit');
			// set the label for the signature
			submitLog.Label = this.formatSignatureLabel(submitLog);
			// add the submitLog to the list
			this.SignatureData.SignaturesList.unshift(submitLog);
		}
		catch (exception)
		{
			this.pict.log.error(`Signature section cannot be rendered, ${exception}`);
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		super.onAfterRenderAsync((pError) =>
		{
			// if approved, remove the note
			if (this.SignatureData.IsApproved)
			{
				this.pict.ContentAssignment.addClass('#HeadlightSignatures-Disclaimer', 'is-hidden');
			}
			else if (this.SignatureData.SignaturesList.length)
			{
				this.pict.ContentAssignment.assignContent('#HeadlightSignatures-Disclaimer-Message', 'More signatures may appear as individuals sign this document.');
			}
			// config options to hide/show titles and dates
			if (!this.SignatureData.Options.ShowTitles)
			{
				this.pict.ContentAssignment.addClass('[data-signature-title]', 'is-hidden');
			}
			if (this.SignatureData.Options.HideDates)
			{
				this.pict.ContentAssignment.addClass('[data-signature-date]', 'is-hidden');
			}
			if (this.SignatureData.Options.HideSectionHeader)
			{
				this.pict.ContentAssignment.addClass('#HeadlightSignatures-Header', 'is-hidden');
			}
			return fCallback(pError);
		}, pRenderable);
	}

	/**
	 * Format the signature label based on the action and status
	 * @param {Object} pLogObject
	 * @returns {string}
	 * @memberof HeadlightSignatures
	 */
	formatSignatureLabel(pLogObject)
	{
		//TODO: read from config and only use this default if no config is set
		const action = pLogObject.Action
			.replace(/submit/i, 'Submitted')
			.replace(/approve/i, 'Approved')
			.replace(/reject/i, 'Rejected')
			.replace(/review/i, 'Reviewed');

		let label = `${action} By`;

		if (Object.keys(this.SignatureData.Options.CustomLabels).length > 0)
		{
			const labelObj = this.SignatureData.Options.CustomLabels.find((l) => l.status === pLogObject.Status);
			if (labelObj)
			{
				label = labelObj.label;
			}
		}
		return label;
	}

}

module.exports = HeadlightSignatures;
module.exports.default_configuration =
{
	ViewIdentifier: 'HeadlightSignatures',
	RenderOnLoad: false,
	AutoRender: false,
	DefaultRenderable: 'HeadlightSignatures',
	DefaultDestinationAddress: '#Headlight-View-Signatures',
	CSS: /*css*/`
		.hl-signature-written {
			font-optical-sizing: auto;
			font-weight: normal;
			font-style: normal;
			font-size: var(--bulma-size-4);
		}
		.hl-signature-font-default { font-family: "Rock Salt", cursive; }
		.hl-signature-font-cursive { font-family: "Corinthia", cursive; font-size: calc(var(--bulma-size-4) * 2.25); line-height: 0.75; }
		.hl-signature-font-serif { font-family: "Merriweather", serif; }
		.hl-signature-font-sans-serif { font-family: "Cabin", sans-serif; }
		.hl-signature-print {
			font-size: var(--bulma-size-7);
		}`,
	Templates:
	[
		{
			Hash: 'HeadlightSignatures',
			Template: /*html*/`
			<section style="break-inside:avoid">
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
				<link href="https://fonts.googleapis.com/css2?family={~D:Context[0].SignatureData.Font.URLParam~}&display=swap" rel="stylesheet" />
				<h2 id="HeadlightSignatures-Header" class="section-header">Signatures</h2>
				<div id="HeadlightSignatures-Content" class="container">
					{~TS:HeadlightSignatures-Row:Context[0].SignatureData.SignaturesList~}
				</div>
				<div class="columns m-2">
					<div class="column is-12">
						<div id="HeadlightSignatures-Disclaimer" class="notification has-text-centered empty-message">
							<span class="icon">
								<i class="fas fa-fw fa-signature"></i>
							</span>
							<span id="HeadlightSignatures-Disclaimer-Message" class="is-italic">Signatures will appear when individuals change the status of this document.</span>
						</div>
					</div>
				</div>
			</section>
`,
		},
		{
			Hash: 'HeadlightSignatures-Row',
			Template: /*html*/`
			<div class="columns m-5 mb-1" data-sign-key="Row" data-log-after-status="{~D:Record.AfterStatus~}">
				<div class="column" data-signature-name>
					<label class="label">{~D:Record.Label~}</label>
					<div class="hl-signature-written {~D:Context[0].SignatureData.Font.CSSClass~}" style="border-bottom: 1px solid #666;">{~E:User^Record.CreatingIDUser^HeadlightSignatures-Row-Name~}</div>
					<span class="hl-signature-print">{~E:User^Record.CreatingIDUser^HeadlightSignatures-Row-Name~}</span>
				</div>
				<div class="column" data-signature-title>
					<label class="label">Title / Qualification</label>
					<span>{~E:User^Record.CreatingIDUser^HeadlightSignatures-Row-Title~}</span>
				</div>
				<div class="column" data-signature-date>
					<label class="label">Date</label>
					<span>{~DateFormatTZ:Record.UpdateDate^MMMM DD, YYYY - hh:mm a^AppData.DocumentData.ReportData.Timezone~}</span>
				</div>
			</div>
`,
		},
		{
			Hash: 'HeadlightSignatures-Row-Name',
			Template: /*html*/`
			{~D:Record.NameFirst~} {~D:Record.NameLast~}
`,
		},
		{
			Hash: 'HeadlightSignatures-Row-Title',
			Template: /*html*/`
			{~D:Record.Title~}
`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'HeadlightSignatures',
			TemplateHash: 'HeadlightSignatures',
			DestinationAddress: '#Headlight-View-Signatures'
		},
	]
};

},{"pict-view":693}],254:[function(require,module,exports){
module.exports = require('./lib/difflib');

},{"./lib/difflib":255}],255:[function(require,module,exports){
// Generated by CoffeeScript 2.6.1
(function() {
  /*
  Module difflib -- helpers for computing deltas between objects.

  Function getCloseMatches(word, possibilities, n=3, cutoff=0.6):
      Use SequenceMatcher to return list of the best "good enough" matches.

  Function contextDiff(a, b):
      For two lists of strings, return a delta in context diff format.

  Function ndiff(a, b):
      Return a delta: the difference between `a` and `b` (lists of strings).

  Function restore(delta, which):
      Return one of the two sequences that generated an ndiff delta.

  Function unifiedDiff(a, b):
      For two lists of strings, return a delta in unified diff format.

  Class SequenceMatcher:
      A flexible class for comparing pairs of sequences of any type.

  Class Differ:
      For producing human-readable deltas from sequences of lines of text.
  */
  var Differ, Heap, IS_CHARACTER_JUNK, IS_LINE_JUNK, SequenceMatcher, _any, _arrayCmp, _calculateRatio, _countLeading, _formatRangeContext, _formatRangeUnified, _has, assert, contextDiff, floor, getCloseMatches, max, min, ndiff, restore, unifiedDiff,
    indexOf = [].indexOf;

  // Requires
  ({floor, max, min} = Math);

  Heap = require('heap');

  assert = require('assert');

  // Helper functions
  _calculateRatio = function(matches, length) {
    if (length) {
      return 2.0 * matches / length;
    } else {
      return 1.0;
    }
  };

  _arrayCmp = function(a, b) {
    var i, l, la, lb, ref;
    [la, lb] = [a.length, b.length];
    for (i = l = 0, ref = min(la, lb); (0 <= ref ? l < ref : l > ref); i = 0 <= ref ? ++l : --l) {
      if (a[i] < b[i]) {
        return -1;
      }
      if (a[i] > b[i]) {
        return 1;
      }
    }
    return la - lb;
  };

  _has = function(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  };

  _any = function(items) {
    var item, l, len;
    for (l = 0, len = items.length; l < len; l++) {
      item = items[l];
      if (item) {
        return true;
      }
    }
    return false;
  };

  SequenceMatcher = class SequenceMatcher {
    /*
    SequenceMatcher is a flexible class for comparing pairs of sequences of
    any type, so long as the sequence elements are hashable.  The basic
    algorithm predates, and is a little fancier than, an algorithm
    published in the late 1980's by Ratcliff and Obershelp under the
    hyperbolic name "gestalt pattern matching".  The basic idea is to find
    the longest contiguous matching subsequence that contains no "junk"
    elements (R-O doesn't address junk).  The same idea is then applied
    recursively to the pieces of the sequences to the left and to the right
    of the matching subsequence.  This does not yield minimal edit
    sequences, but does tend to yield matches that "look right" to people.

    SequenceMatcher tries to compute a "human-friendly diff" between two
    sequences.  Unlike e.g. UNIX(tm) diff, the fundamental notion is the
    longest *contiguous* & junk-free matching subsequence.  That's what
    catches peoples' eyes.  The Windows(tm) windiff has another interesting
    notion, pairing up elements that appear uniquely in each sequence.
    That, and the method here, appear to yield more intuitive difference
    reports than does diff.  This method appears to be the least vulnerable
    to synching up on blocks of "junk lines", though (like blank lines in
    ordinary text files, or maybe "<P>" lines in HTML files).  That may be
    because this is the only method of the 3 that has a *concept* of
    "junk" <wink>.

    Example, comparing two strings, and considering blanks to be "junk":

    >>> isjunk = (c) -> c is ' '
    >>> s = new SequenceMatcher(isjunk,
                                'private Thread currentThread;',
                                'private volatile Thread currentThread;')

    .ratio() returns a float in [0, 1], measuring the "similarity" of the
    sequences.  As a rule of thumb, a .ratio() value over 0.6 means the
    sequences are close matches:

    >>> s.ratio().toPrecision(3)
    '0.866'

    If you're only interested in where the sequences match,
    .getMatchingBlocks() is handy:

    >>> for [a, b, size] in s.getMatchingBlocks()
    ...   console.log("a[#{a}] and b[#{b}] match for #{size} elements");
    a[0] and b[0] match for 8 elements
    a[8] and b[17] match for 21 elements
    a[29] and b[38] match for 0 elements

    Note that the last tuple returned by .get_matching_blocks() is always a
    dummy, (len(a), len(b), 0), and this is the only case in which the last
    tuple element (number of elements matched) is 0.

    If you want to know how to change the first sequence into the second,
    use .get_opcodes():

    >>> for [op, a1, a2, b1, b2] in s.getOpcodes()
    ...   console.log "#{op} a[#{a1}:#{a2}] b[#{b1}:#{b2}]"
    equal a[0:8] b[0:8]
    insert a[8:8] b[8:17]
    equal a[8:29] b[17:38]

    See the Differ class for a fancy human-friendly file differencer, which
    uses SequenceMatcher both to compare sequences of lines, and to compare
    sequences of characters within similar (near-matching) lines.

    See also function getCloseMatches() in this module, which shows how
    simple code building on SequenceMatcher can be used to do useful work.

    Timing:  Basic R-O is cubic time worst case and quadratic time expected
    case.  SequenceMatcher is quadratic time for the worst case and has
    expected-case behavior dependent in a complicated way on how many
    elements the sequences have in common; best case time is linear.

    Methods:

    constructor(isjunk=null, a='', b='')
        Construct a SequenceMatcher.

    setSeqs(a, b)
        Set the two sequences to be compared.

    setSeq1(a)
        Set the first sequence to be compared.

    setSeq2(b)
        Set the second sequence to be compared.

    findLongestMatch(alo, ahi, blo, bhi)
        Find longest matching block in a[alo:ahi] and b[blo:bhi].

    getMatchingBlocks()
        Return list of triples describing matching subsequences.

    getOpcodes()
        Return list of 5-tuples describing how to turn a into b.

    ratio()
        Return a measure of the sequences' similarity (float in [0,1]).

    quickRatio()
        Return an upper bound on .ratio() relatively quickly.

    realQuickRatio()
        Return an upper bound on ratio() very quickly.
    */
    constructor(isjunk1, a = '', b = '', autojunk = true) {
      this.isjunk = isjunk1;
      this.autojunk = autojunk;
      /*
      Construct a SequenceMatcher.

      Optional arg isjunk is null (the default), or a one-argument
      function that takes a sequence element and returns true iff the
      element is junk.  Null is equivalent to passing "(x) -> 0", i.e.
      no elements are considered to be junk.  For example, pass
          (x) -> x in ' \t'
      if you're comparing lines as sequences of characters, and don't
      want to synch up on blanks or hard tabs.

      Optional arg a is the first of two sequences to be compared.  By
      default, an empty string.  The elements of a must be hashable.  See
      also .setSeqs() and .setSeq1().

      Optional arg b is the second of two sequences to be compared.  By
      default, an empty string.  The elements of b must be hashable. See
      also .setSeqs() and .setSeq2().

      Optional arg autojunk should be set to false to disable the
      "automatic junk heuristic" that treats popular elements as junk
      (see module documentation for more information).
      */
      // Members:
      // a
      //      first sequence
      // b
      //      second sequence; differences are computed as "what do
      //      we need to do to 'a' to change it into 'b'?"
      // b2j
      //      for x in b, b2j[x] is a list of the indices (into b)
      //      at which x appears; junk elements do not appear
      // fullbcount
      //      for x in b, fullbcount[x] == the number of times x
      //      appears in b; only materialized if really needed (used
      //      only for computing quickRatio())
      // matchingBlocks
      //      a list of [i, j, k] triples, where a[i...i+k] == b[j...j+k];
      //      ascending & non-overlapping in i and in j; terminated by
      //      a dummy (len(a), len(b), 0) sentinel
      // opcodes
      //      a list of [tag, i1, i2, j1, j2] tuples, where tag is
      //      one of
      //          'replace'   a[i1...i2] should be replaced by b[j1...j2]
      //          'delete'    a[i1...i2] should be deleted
      //          'insert'    b[j1...j2] should be inserted
      //          'equal'     a[i1...i2] == b[j1...j2]
      // isjunk
      //      a user-supplied function taking a sequence element and
      //      returning true iff the element is "junk" -- this has
      //      subtle but helpful effects on the algorithm, which I'll
      //      get around to writing up someday <0.9 wink>.
      //      DON'T USE!  Only __chainB uses this.  Use isbjunk.
      // isbjunk
      //      for x in b, isbjunk(x) == isjunk(x) but much faster;
      //      DOES NOT WORK for x in a!
      // isbpopular
      //      for x in b, isbpopular(x) is true iff b is reasonably long
      //      (at least 200 elements) and x accounts for more than 1 + 1% of
      //      its elements (when autojunk is enabled).
      //      DOES NOT WORK for x in a!
      this.a = this.b = null;
      this.setSeqs(a, b);
    }

    setSeqs(a, b) {
      /* 
      Set the two sequences to be compared. 

      >>> s = new SequenceMatcher()
      >>> s.setSeqs('abcd', 'bcde')
      >>> s.ratio()
      0.75
      */
      this.setSeq1(a);
      return this.setSeq2(b);
    }

    setSeq1(a) {
      /* 
      Set the first sequence to be compared. 

      The second sequence to be compared is not changed.

      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
      >>> s.ratio()
      0.75
      >>> s.setSeq1('bcde')
      >>> s.ratio()
      1.0

      SequenceMatcher computes and caches detailed information about the
      second sequence, so if you want to compare one sequence S against
      many sequences, use .setSeq2(S) once and call .setSeq1(x)
      repeatedly for each of the other sequences.

      See also setSeqs() and setSeq2().
      */
      if (a === this.a) {
        return;
      }
      this.a = a;
      return this.matchingBlocks = this.opcodes = null;
    }

    setSeq2(b) {
      /*
      Set the second sequence to be compared. 

      The first sequence to be compared is not changed.

      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
      >>> s.ratio()
      0.75
      >>> s.setSeq2('abcd')
      >>> s.ratio()
      1.0

      SequenceMatcher computes and caches detailed information about the
      second sequence, so if you want to compare one sequence S against
      many sequences, use .setSeq2(S) once and call .setSeq1(x)
      repeatedly for each of the other sequences.

      See also setSeqs() and setSeq1().
      */
      if (b === this.b) {
        return;
      }
      this.b = b;
      this.matchingBlocks = this.opcodes = null;
      this.fullbcount = null;
      return this._chainB();
    }

    // For each element x in b, set b2j[x] to a list of the indices in
    // b where x appears; the indices are in increasing order; note that
    // the number of times x appears in b is b2j[x].length ...
    // when @isjunk is defined, junk elements don't show up in this
    // map at all, which stops the central findLongestMatch method
    // from starting any matching block at a junk element ...
    // also creates the fast isbjunk function ...
    // b2j also does not contain entries for "popular" elements, meaning
    // elements that account for more than 1 + 1% of the total elements, and
    // when the sequence is reasonably large (>= 200 elements); this can
    // be viewed as an adaptive notion of semi-junk, and yields an enormous
    // speedup when, e.g., comparing program files with hundreds of
    // instances of "return null;" ...
    // note that this is only called when b changes; so for cross-product
    // kinds of matches, it's best to call setSeq2 once, then setSeq1
    // repeatedly
    _chainB() {
      var b, b2j, elt, i, indices, isjunk, junk, l, len, n, ntest, popular;
      // Because isjunk is a user-defined function, and we test
      // for junk a LOT, it's important to minimize the number of calls.
      // Before the tricks described here, __chainB was by far the most
      // time-consuming routine in the whole module!  If anyone sees
      // Jim Roskind, thank him again for profile.py -- I never would
      // have guessed that.
      // The first trick is to build b2j ignoring the possibility
      // of junk.  I.e., we don't call isjunk at all yet.  Throwing
      // out the junk later is much cheaper than building b2j "right"
      // from the start.
      b = this.b;
      this.b2j = b2j = new Map();
      for (i = l = 0, len = b.length; l < len; i = ++l) {
        elt = b[i];
        if (!b2j.has(elt)) {
          b2j.set(elt, []);
        }
        indices = b2j.get(elt);
        indices.push(i);
      }
      // Purge junk elements
      junk = new Map();
      isjunk = this.isjunk;
      if (isjunk) {
        b2j.forEach(function(idxs, elt) {
          if (isjunk(elt)) {
            junk.set(elt, true);
            return b2j.delete(elt);
          }
        });
      }
      // Purge popular elements that are not junk
      popular = new Map();
      n = b.length;
      if (this.autojunk && n >= 200) {
        ntest = floor(n / 100) + 1;
        b2j.forEach(function(idxs, elt) {
          if (idxs.length > ntest) {
            popular.set(elt, true);
            return b2j.delete(elt);
          }
        });
      }
      // Now for x in b, isjunk(x) == x in junk, but the latter is much faster.
      // Sicne the number of *unique* junk elements is probably small, the
      // memory burden of keeping this set alive is likely trivial compared to
      // the size of b2j.
      this.isbjunk = function(b) {
        return junk.has(b);
      };
      return this.isbpopular = function(b) {
        return popular.has(b);
      };
    }

    findLongestMatch(alo, ahi, blo, bhi) {
      var a, b, b2j, besti, bestj, bestsize, i, isbjunk, j, j2len, jlist, k, l, len, m, newj2len, ref, ref1;
      /* 
      Find longest matching block in a[alo...ahi] and b[blo...bhi].  

      If isjunk is not defined:

      Return [i,j,k] such that a[i...i+k] is equal to b[j...j+k], where
          alo <= i <= i+k <= ahi
          blo <= j <= j+k <= bhi
      and for all [i',j',k'] meeting those conditions,
          k >= k'
          i <= i'
          and if i == i', j <= j'

      In other words, of all maximal matching blocks, return one that
      starts earliest in a, and of all those maximal matching blocks that
      start earliest in a, return the one that starts earliest in b.

      >>> isjunk = (x) -> x is ' '
      >>> s = new SequenceMatcher(isjunk, ' abcd', 'abcd abcd')
      >>> s.findLongestMatch(0, 5, 0, 9)
      [1, 0, 4]

      >>> s = new SequenceMatcher(null, 'ab', 'c')
      >>> s.findLongestMatch(0, 2, 0, 1)
      [0, 0, 0]
      */
      // CAUTION:  stripping common prefix or suffix would be incorrect.
      // E.g.,
      //    ab
      //    acab
      // Longest matching block is "ab", but if common prefix is
      // stripped, it's "a" (tied with "b").  UNIX(tm) diff does so
      // strip, so ends up claiming that ab is changed to acab by
      // inserting "ca" in the middle.  That's minimal but unintuitive:
      // "it's obvious" that someone inserted "ac" at the front.
      // Windiff ends up at the same place as diff, but by pairing up
      // the unique 'b's and then matching the first two 'a's.
      [a, b, b2j, isbjunk] = [this.a, this.b, this.b2j, this.isbjunk];
      [besti, bestj, bestsize] = [alo, blo, 0];
      // find longest junk-free match
      // during an iteration of the loop, j2len[j] = length of longest
      // junk-free match ending with a[i-1] and b[j]
      j2len = {};
      for (i = l = ref = alo, ref1 = ahi; (ref <= ref1 ? l < ref1 : l > ref1); i = ref <= ref1 ? ++l : --l) {
        // look at all instances of a[i] in b; note that because
        // b2j has no junk keys, the loop is skipped if a[i] is junk
        newj2len = {};
        jlist = [];
        if (b2j.has(a[i])) {
          jlist = b2j.get(a[i]);
        }
        for (m = 0, len = jlist.length; m < len; m++) {
          j = jlist[m];
          if (j < blo) {
            // a[i] matches b[j]
            continue;
          }
          if (j >= bhi) {
            break;
          }
          k = newj2len[j] = (j2len[j - 1] || 0) + 1;
          if (k > bestsize) {
            [besti, bestj, bestsize] = [i - k + 1, j - k + 1, k];
          }
        }
        j2len = newj2len;
      }
      // Extend the best by non-junk elements on each end.  In particular,
      // "popular" non-junk elements aren't in b2j, which greatly speeds
      // the inner loop above, but also means "the best" match so far
      // doesn't contain any junk *or* popular non-junk elements.
      while (besti > alo && bestj > blo && !isbjunk(b[bestj - 1]) && a[besti - 1] === b[bestj - 1]) {
        [besti, bestj, bestsize] = [besti - 1, bestj - 1, bestsize + 1];
      }
      while (besti + bestsize < ahi && bestj + bestsize < bhi && !isbjunk(b[bestj + bestsize]) && a[besti + bestsize] === b[bestj + bestsize]) {
        bestsize++;
      }
      // Now that we have a wholly interesting match (albeit possibly
      // empty!), we may as well suck up the matching junk on each
      // side of it too.  Can't think of a good reason not to, and it
      // saves post-processing the (possibly considerable) expense of
      // figuring out what to do with it.  In the case of an empty
      // interesting match, this is clearly the right thing to do,
      // because no other kind of match is possible in the regions.
      while (besti > alo && bestj > blo && isbjunk(b[bestj - 1]) && a[besti - 1] === b[bestj - 1]) {
        [besti, bestj, bestsize] = [besti - 1, bestj - 1, bestsize + 1];
      }
      while (besti + bestsize < ahi && bestj + bestsize < bhi && isbjunk(b[bestj + bestsize]) && a[besti + bestsize] === b[bestj + bestsize]) {
        bestsize++;
      }
      return [besti, bestj, bestsize];
    }

    getMatchingBlocks() {
      var ahi, alo, bhi, blo, i, i1, i2, j, j1, j2, k, k1, k2, l, la, lb, len, matchingBlocks, nonAdjacent, queue, x;
      if (this.matchingBlocks) {
        /*
        Return list of triples describing matching subsequences.

        Each triple is of the form [i, j, n], and means that
        a[i...i+n] == b[j...j+n].  The triples are monotonically increasing in
        i and in j.  it's also guaranteed that if
        [i, j, n] and [i', j', n'] are adjacent triples in the list, and
        the second is not the last triple in the list, then i+n != i' or
        j+n != j'.  IOW, adjacent triples never describe adjacent equal
        blocks.

        The last triple is a dummy, [a.length, b.length, 0], and is the only
        triple with n==0.

        >>> s = new SequenceMatcher(null, 'abxcd', 'abcd')
        >>> s.getMatchingBlocks()
        [[0, 0, 2], [3, 2, 2], [5, 4, 0]]

        */
        return this.matchingBlocks;
      }
      [la, lb] = [this.a.length, this.b.length];
      // This is most naturally expressed as a recursive algorithm, but
      // at least one user bumped into extreme use cases that exceeded
      // the recursion limit on their box.  So, now we maintain a list
      // ('queue`) of blocks we still need to look at, and append partial
      // results to `matching_blocks` in a loop; the matches are sorted
      // at the end.
      queue = [[0, la, 0, lb]];
      matchingBlocks = [];
      while (queue.length) {
        [alo, ahi, blo, bhi] = queue.pop();
        [i, j, k] = x = this.findLongestMatch(alo, ahi, blo, bhi);
        // a[alo...i] vs b[blo...j] unknown
        // a[i...i+k] same as b[j...j+k]
        // a[i+k...ahi] vs b[j+k...bhi] unknown
        if (k) {
          matchingBlocks.push(x);
          if (alo < i && blo < j) {
            queue.push([alo, i, blo, j]);
          }
          if (i + k < ahi && j + k < bhi) {
            queue.push([i + k, ahi, j + k, bhi]);
          }
        }
      }
      matchingBlocks.sort(_arrayCmp);
      // It's possible that we have adjacent equal blocks in the
      // matching_blocks list now. 
      i1 = j1 = k1 = 0;
      nonAdjacent = [];
      for (l = 0, len = matchingBlocks.length; l < len; l++) {
        [i2, j2, k2] = matchingBlocks[l];
        // Is this block adjacent to i1, j1, k1?
        if (i1 + k1 === i2 && j1 + k1 === j2) {
          // Yes, so collapse them -- this just increases the length of
          // the first block by the length of the second, and the first
          // block so lengthened remains the block to compare against.
          k1 += k2;
        } else {
          // Not adjacent.  Remember the first block (k1==0 means it's
          // the dummy we started with), and make the second block the
          // new block to compare against.
          if (k1) {
            nonAdjacent.push([i1, j1, k1]);
          }
          [i1, j1, k1] = [i2, j2, k2];
        }
      }
      if (k1) {
        nonAdjacent.push([i1, j1, k1]);
      }
      nonAdjacent.push([la, lb, 0]);
      return this.matchingBlocks = nonAdjacent;
    }

    getOpcodes() {
      var ai, answer, bj, i, j, l, len, ref, size, tag;
      if (this.opcodes) {
        /* 
        Return list of 5-tuples describing how to turn a into b.

        Each tuple is of the form [tag, i1, i2, j1, j2].  The first tuple
        has i1 == j1 == 0, and remaining tuples have i1 == the i2 from the
        tuple preceding it, and likewise for j1 == the previous j2.

        The tags are strings, with these meanings:

        'replace':  a[i1...i2] should be replaced by b[j1...j2]
        'delete':   a[i1...i2] should be deleted.
                    Note that j1==j2 in this case.
        'insert':   b[j1...j2] should be inserted at a[i1...i1].
                    Note that i1==i2 in this case.
        'equal':    a[i1...i2] == b[j1...j2]

        >>> s = new SequenceMatcher(null, 'qabxcd', 'abycdf')
        >>> s.getOpcodes()
        [ [ 'delete'  , 0 , 1 , 0 , 0 ] ,
          [ 'equal'   , 1 , 3 , 0 , 2 ] ,
          [ 'replace' , 3 , 4 , 2 , 3 ] ,
          [ 'equal'   , 4 , 6 , 3 , 5 ] ,
          [ 'insert'  , 6 , 6 , 5 , 6 ] ]
        */
        return this.opcodes;
      }
      i = j = 0;
      this.opcodes = answer = [];
      ref = this.getMatchingBlocks();
      for (l = 0, len = ref.length; l < len; l++) {
        [ai, bj, size] = ref[l];
        // invariant:  we've pumped out correct diffs to change
        // a[0...i] into b[0...j], and the next matching block is
        // a[ai...ai+size] == b[bj...bj+size].  So we need to pump
        // out a diff to change a[i:ai] into b[j...bj], pump out
        // the matching block, and move [i,j] beyond the match
        tag = '';
        if (i < ai && j < bj) {
          tag = 'replace';
        } else if (i < ai) {
          tag = 'delete';
        } else if (j < bj) {
          tag = 'insert';
        }
        if (tag) {
          answer.push([tag, i, ai, j, bj]);
        }
        [i, j] = [ai + size, bj + size];
        // the list of matching blocks is terminated by a
        // sentinel with size 0
        if (size) {
          answer.push(['equal', ai, i, bj, j]);
        }
      }
      return answer;
    }

    getGroupedOpcodes(n = 3) {
      /* 
      Isolate change clusters by eliminating ranges with no changes.

      Return a list groups with upto n lines of context.
      Each group is in the same format as returned by get_opcodes().

      >>> a = [1...40].map(String)
      >>> b = a.slice()
      >>> b[8...8] = 'i'
      >>> b[20] += 'x'
      >>> b[23...28] = []
      >>> b[30] += 'y'
      >>> s = new SequenceMatcher(null, a, b)
      >>> s.getGroupedOpcodes()
      [ [ [ 'equal'  , 5 , 8  , 5 , 8 ],
          [ 'insert' , 8 , 8  , 8 , 9 ],
          [ 'equal'  , 8 , 11 , 9 , 12 ] ],
        [ [ 'equal'   , 16 , 19 , 17 , 20 ],
          [ 'replace' , 19 , 20 , 20 , 21 ],
          [ 'equal'   , 20 , 22 , 21 , 23 ],
          [ 'delete'  , 22 , 27 , 23 , 23 ],
          [ 'equal'   , 27 , 30 , 23 , 26 ] ],
        [ [ 'equal'   , 31 , 34 , 27 , 30 ],
          [ 'replace' , 34 , 35 , 30 , 31 ],
          [ 'equal'   , 35 , 38 , 31 , 34 ] ] ]
      */
      var codes, group, groups, i1, i2, j1, j2, l, len, nn, tag;
      codes = this.getOpcodes();
      if (!codes.length) {
        codes = [['equal', 0, 1, 0, 1]];
      }
      // Fixup leading and trailing groups if they show no changes.
      if (codes[0][0] === 'equal') {
        [tag, i1, i2, j1, j2] = codes[0];
        codes[0] = [tag, max(i1, i2 - n), i2, max(j1, j2 - n), j2];
      }
      if (codes[codes.length - 1][0] === 'equal') {
        [tag, i1, i2, j1, j2] = codes[codes.length - 1];
        codes[codes.length - 1] = [tag, i1, min(i2, i1 + n), j1, min(j2, j1 + n)];
      }
      nn = n + n;
      groups = [];
      group = [];
      for (l = 0, len = codes.length; l < len; l++) {
        [tag, i1, i2, j1, j2] = codes[l];
        // End the current group and start a new one whenever
        // there is a large range with no changes.
        if (tag === 'equal' && i2 - i1 > nn) {
          group.push([tag, i1, min(i2, i1 + n), j1, min(j2, j1 + n)]);
          groups.push(group);
          group = [];
          [i1, j1] = [max(i1, i2 - n), max(j1, j2 - n)];
        }
        group.push([tag, i1, i2, j1, j2]);
      }
      if (group.length && !(group.length === 1 && group[0][0] === 'equal')) {
        groups.push(group);
      }
      return groups;
    }

    ratio() {
      /*
      Return a measure of the sequences' similarity (float in [0,1]).

      Where T is the total number of elements in both sequences, and
      M is the number of matches, this is 2.0*M / T.
      Note that this is 1 if the sequences are identical, and 0 if
      they have nothing in common.

      .ratio() is expensive to compute if you haven't already computed
      .getMatchingBlocks() or .getOpcodes(), in which case you may
      want to try .quickRatio() or .realQuickRatio() first to get an
      upper bound.

      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
      >>> s.ratio()
      0.75
      >>> s.quickRatio()
      0.75
      >>> s.realQuickRatio()
      1.0
      */
      var l, len, match, matches, ref;
      matches = 0;
      ref = this.getMatchingBlocks();
      for (l = 0, len = ref.length; l < len; l++) {
        match = ref[l];
        matches += match[2];
      }
      return _calculateRatio(matches, this.a.length + this.b.length);
    }

    quickRatio() {
      var avail, elt, fullbcount, l, len, len1, m, matches, numb, ref, ref1;
      /*
      Return an upper bound on ratio() relatively quickly.

      This isn't defined beyond that it is an upper bound on .ratio(), and
      is faster to compute.
      */
      // viewing a and b as multisets, set matches to the cardinality
      // of their intersection; this counts the number of matches
      // without regard to order, so is clearly an upper bound
      if (!this.fullbcount) {
        this.fullbcount = fullbcount = {};
        ref = this.b;
        for (l = 0, len = ref.length; l < len; l++) {
          elt = ref[l];
          fullbcount[elt] = (fullbcount[elt] || 0) + 1;
        }
      }
      fullbcount = this.fullbcount;
      // avail[x] is the number of times x appears in 'b' less the
      // number of times we've seen it in 'a' so far ... kinda
      avail = {};
      matches = 0;
      ref1 = this.a;
      for (m = 0, len1 = ref1.length; m < len1; m++) {
        elt = ref1[m];
        if (_has(avail, elt)) {
          numb = avail[elt];
        } else {
          numb = fullbcount[elt] || 0;
        }
        avail[elt] = numb - 1;
        if (numb > 0) {
          matches++;
        }
      }
      return _calculateRatio(matches, this.a.length + this.b.length);
    }

    realQuickRatio() {
      /*
      Return an upper bound on ratio() very quickly.

      This isn't defined beyond that it is an upper bound on .ratio(), and
      is faster to compute than either .ratio() or .quickRatio().
      */
      var la, lb;
      [la, lb] = [this.a.length, this.b.length];
      // can't have more matches than the number of elements in the
      // shorter sequence
      return _calculateRatio(min(la, lb), la + lb);
    }

  };

  getCloseMatches = function(word, possibilities, n = 3, cutoff = 0.6) {
    var l, len, len1, m, result, results, s, score, x;
    /*
    Use SequenceMatcher to return list of the best "good enough" matches.

    word is a sequence for which close matches are desired (typically a
    string).

    possibilities is a list of sequences against which to match word
    (typically a list of strings).

    Optional arg n (default 3) is the maximum number of close matches to
    return.  n must be > 0.

    Optional arg cutoff (default 0.6) is a float in [0, 1].  Possibilities
    that don't score at least that similar to word are ignored.

    The best (no more than n) matches among the possibilities are returned
    in a list, sorted by similarity score, most similar first.

    >>> getCloseMatches('appel', ['ape', 'apple', 'peach', 'puppy'])
    ['apple', 'ape']
    >>> KEYWORDS = require('coffee-script').RESERVED
    >>> getCloseMatches('wheel', KEYWORDS)
    ['when', 'while']
    >>> getCloseMatches('accost', KEYWORDS)
    ['const']
    */
    if (!(n > 0)) {
      throw new Error(`n must be > 0: (${n})`);
    }
    if (!((0.0 <= cutoff && cutoff <= 1.0))) {
      throw new Error(`cutoff must be in [0.0, 1.0]: (${cutoff})`);
    }
    result = [];
    s = new SequenceMatcher();
    s.setSeq2(word);
    for (l = 0, len = possibilities.length; l < len; l++) {
      x = possibilities[l];
      s.setSeq1(x);
      if (s.realQuickRatio() >= cutoff && s.quickRatio() >= cutoff && s.ratio() >= cutoff) {
        result.push([s.ratio(), x]);
      }
    }
    // Move the best scorers to head of list
    result = Heap.nlargest(result, n, _arrayCmp);
    results = [];
    for (m = 0, len1 = result.length; m < len1; m++) {
      [score, x] = result[m];
      // Strip scores for the best n matches
      results.push(x);
    }
    return results;
  };

  _countLeading = function(line, ch) {
    /*
    Return number of `ch` characters at the start of `line`.

    >>> _countLeading('   abc', ' ')
    3
    */
    var i, n;
    [i, n] = [0, line.length];
    while (i < n && line[i] === ch) {
      i++;
    }
    return i;
  };

  Differ = class Differ {
    /*
    Differ is a class for comparing sequences of lines of text, and
    producing human-readable differences or deltas.  Differ uses
    SequenceMatcher both to compare sequences of lines, and to compare
    sequences of characters within similar (near-matching) lines.

    Each line of a Differ delta begins with a two-letter code:

        '- '    line unique to sequence 1
        '+ '    line unique to sequence 2
        '  '    line common to both sequences
        '? '    line not present in either input sequence

    Lines beginning with '? ' attempt to guide the eye to intraline
    differences, and were not present in either input sequence.  These lines
    can be confusing if the sequences contain tab characters.

    Note that Differ makes no claim to produce a *minimal* diff.  To the
    contrary, minimal diffs are often counter-intuitive, because they synch
    up anywhere possible, sometimes accidental matches 100 pages apart.
    Restricting synch points to contiguous matches preserves some notion of
    locality, at the occasional cost of producing a longer diff.

    Example: Comparing two texts.

    >>> text1 = ['1. Beautiful is better than ugly.\n',
    ...   '2. Explicit is better than implicit.\n',
    ...   '3. Simple is better than complex.\n',
    ...   '4. Complex is better than complicated.\n']
    >>> text1.length
    4
    >>> text2 = ['1. Beautiful is better than ugly.\n',
    ...   '3.   Simple is better than complex.\n',
    ...   '4. Complicated is better than complex.\n',
    ...   '5. Flat is better than nested.\n']

    Next we instantiate a Differ object:

    >>> d = new Differ()

    Note that when instantiating a Differ object we may pass functions to
    filter out line and character 'junk'.

    Finally, we compare the two:

    >>> result = d.compare(text1, text2)
    [ '  1. Beautiful is better than ugly.\n',
      '- 2. Explicit is better than implicit.\n',
      '- 3. Simple is better than complex.\n',
      '+ 3.   Simple is better than complex.\n',
      '?   ++\n',
      '- 4. Complex is better than complicated.\n',
      '?          ^                     ---- ^\n',
      '+ 4. Complicated is better than complex.\n',
      '?         ++++ ^                      ^\n',
      '+ 5. Flat is better than nested.\n' ]

    Methods:

    constructor(linejunk=null, charjunk=null)
        Construct a text differencer, with optional filters.
    compare(a, b)
        Compare two sequences of lines; generate the resulting delta.
    */
    constructor(linejunk1, charjunk1) {
      this.linejunk = linejunk1;
      this.charjunk = charjunk1;
    }

    /*
    Construct a text differencer, with optional filters.

    The two optional keyword parameters are for filter functions:

    - `linejunk`: A function that should accept a single string argument,
      and return true iff the string is junk. The module-level function
      `IS_LINE_JUNK` may be used to filter out lines without visible
      characters, except for at most one splat ('#').  It is recommended
      to leave linejunk null. 

    - `charjunk`: A function that should accept a string of length 1. The
      module-level function `IS_CHARACTER_JUNK` may be used to filter out
      whitespace characters (a blank or tab; **note**: bad idea to include
      newline in this!).  Use of IS_CHARACTER_JUNK is recommended.
    */
    compare(a, b) {
      /*
      Compare two sequences of lines; generate the resulting delta.

      Each sequence must contain individual single-line strings ending with
      newlines. Such sequences can be obtained from the `readlines()` method
      of file-like objects.  The delta generated also consists of newline-
      terminated strings, ready to be printed as-is via the writeline()
      method of a file-like object.

      Example:

      >>> d = new Differ
      >>> d.compare(['one\n', 'two\n', 'three\n'],
      ...           ['ore\n', 'tree\n', 'emu\n'])
      [ '- one\n',
        '?  ^\n',
        '+ ore\n',
        '?  ^\n',
        '- two\n',
        '- three\n',
        '?  -\n',
        '+ tree\n',
        '+ emu\n' ]
      */
      var ahi, alo, bhi, blo, cruncher, g, l, len, len1, line, lines, m, ref, tag;
      cruncher = new SequenceMatcher(this.linejunk, a, b);
      lines = [];
      ref = cruncher.getOpcodes();
      for (l = 0, len = ref.length; l < len; l++) {
        [tag, alo, ahi, blo, bhi] = ref[l];
        switch (tag) {
          case 'replace':
            g = this._fancyReplace(a, alo, ahi, b, blo, bhi);
            break;
          case 'delete':
            g = this._dump('-', a, alo, ahi);
            break;
          case 'insert':
            g = this._dump('+', b, blo, bhi);
            break;
          case 'equal':
            g = this._dump(' ', a, alo, ahi);
            break;
          default:
            throw new Error(`unknow tag (${tag})`);
        }
        for (m = 0, len1 = g.length; m < len1; m++) {
          line = g[m];
          lines.push(line);
        }
      }
      return lines;
    }

    _dump(tag, x, lo, hi) {
      var i, l, ref, ref1, results;
      results = [];
      for (i = l = ref = lo, ref1 = hi; (ref <= ref1 ? l < ref1 : l > ref1); i = ref <= ref1 ? ++l : --l) {
        /*
        Generate comparison results for a same-tagged range.
        */
        results.push(`${tag} ${x[i]}`);
      }
      return results;
    }

    _plainReplace(a, alo, ahi, b, blo, bhi) {
      var first, g, l, len, len1, line, lines, m, ref, second;
      assert(alo < ahi && blo < bhi);
      // dump the shorter block first -- reduces the burden on short-term
      // memory if the blocks are of very different sizes
      if (bhi - blo < ahi - alo) {
        first = this._dump('+', b, blo, bhi);
        second = this._dump('-', a, alo, ahi);
      } else {
        first = this._dump('-', a, alo, ahi);
        second = this._dump('+', b, blo, bhi);
      }
      lines = [];
      ref = [first, second];
      for (l = 0, len = ref.length; l < len; l++) {
        g = ref[l];
        for (m = 0, len1 = g.length; m < len1; m++) {
          line = g[m];
          lines.push(line);
        }
      }
      return lines;
    }

    _fancyReplace(a, alo, ahi, b, blo, bhi) {
      var aelt, ai, ai1, ai2, atags, belt, bestRatio, besti, bestj, bj, bj1, bj2, btags, cruncher, cutoff, eqi, eqj, i, j, l, la, lb, len, len1, len2, len3, len4, line, lines, m, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, t, tag;
      /*
      When replacing one block of lines with another, search the blocks
      for *similar* lines; the best-matching pair (if any) is used as a
      synch point, and intraline difference marking is done on the
      similar pair. Lots of work, but often worth it.

      Example:
      >>> d = new Differ
      >>> d._fancyReplace(['abcDefghiJkl\n'], 0, 1,
      ...                 ['abcdefGhijkl\n'], 0, 1)
      [ '- abcDefghiJkl\n',
        '?    ^  ^  ^\n',
        '+ abcdefGhijkl\n',
        '?    ^  ^  ^\n' ]
      */
      // don't synch up unless the lines have a similarity score of at
      // least cutoff; best_ratio tracks the best score seen so far
      [bestRatio, cutoff] = [0.74, 0.75];
      cruncher = new SequenceMatcher(this.charjunk);
      [eqi, eqj] = [
        null,
        null // 1st indices of equal lines (if any)
      ];
      lines = [];
// search for the pair that matches best without being identical
// (identical lines must be junk lines, & we don't want to synch up
// on junk -- unless we have to)
      for (j = l = ref = blo, ref1 = bhi; (ref <= ref1 ? l < ref1 : l > ref1); j = ref <= ref1 ? ++l : --l) {
        bj = b[j];
        cruncher.setSeq2(bj);
        for (i = m = ref2 = alo, ref3 = ahi; (ref2 <= ref3 ? m < ref3 : m > ref3); i = ref2 <= ref3 ? ++m : --m) {
          ai = a[i];
          if (ai === bj) {
            if (eqi === null) {
              [eqi, eqj] = [i, j];
            }
            continue;
          }
          cruncher.setSeq1(ai);
          // computing similarity is expensive, so use the quick
          // upper bounds first -- have seen this speed up messy
          // compares by a factor of 3.
          // note that ratio() is only expensive to compute the first
          // time it's called on a sequence pair; the expensive part
          // of the computation is cached by cruncher
          if (cruncher.realQuickRatio() > bestRatio && cruncher.quickRatio() > bestRatio && cruncher.ratio() > bestRatio) {
            [bestRatio, besti, bestj] = [cruncher.ratio(), i, j];
          }
        }
      }
      if (bestRatio < cutoff) {
        // no non-identical "pretty close" pair
        if (eqi === null) {
          ref4 = this._plainReplace(a, alo, ahi, b, blo, bhi);
          // no identical pair either -- treat it as a straight replace
          for (o = 0, len = ref4.length; o < len; o++) {
            line = ref4[o];
            lines.push(line);
          }
          return lines;
        }
        // no close pair, but an identical pair -- synch up on that
        [besti, bestj, bestRatio] = [eqi, eqj, 1.0];
      } else {
        // there's a close pair, so forget the identical pair (if any)
        eqi = null;
      }
      ref5 = this._fancyHelper(a, alo, besti, b, blo, bestj);
      // a[besti] very similar to b[bestj]; eqi is null iff they're not
      // identical

      // pump out diffs from before the synch point
      for (p = 0, len1 = ref5.length; p < len1; p++) {
        line = ref5[p];
        lines.push(line);
      }
      // do intraline marking on the synch pair
      [aelt, belt] = [a[besti], b[bestj]];
      if (eqi === null) {
        // pump out a '-', '?', '+', '?' quad for the synched lines
        atags = btags = '';
        cruncher.setSeqs(aelt, belt);
        ref6 = cruncher.getOpcodes();
        for (q = 0, len2 = ref6.length; q < len2; q++) {
          [tag, ai1, ai2, bj1, bj2] = ref6[q];
          [la, lb] = [ai2 - ai1, bj2 - bj1];
          switch (tag) {
            case 'replace':
              atags += Array(la + 1).join('^');
              btags += Array(lb + 1).join('^');
              break;
            case 'delete':
              atags += Array(la + 1).join('-');
              break;
            case 'insert':
              btags += Array(lb + 1).join('+');
              break;
            case 'equal':
              atags += Array(la + 1).join(' ');
              btags += Array(lb + 1).join(' ');
              break;
            default:
              throw new Error(`unknow tag (${tag})`);
          }
        }
        ref7 = this._qformat(aelt, belt, atags, btags);
        for (r = 0, len3 = ref7.length; r < len3; r++) {
          line = ref7[r];
          lines.push(line);
        }
      } else {
        // the synch pair is identical
        lines.push('  ' + aelt);
      }
      ref8 = this._fancyHelper(a, besti + 1, ahi, b, bestj + 1, bhi);
      // pump out diffs from after the synch point
      for (t = 0, len4 = ref8.length; t < len4; t++) {
        line = ref8[t];
        lines.push(line);
      }
      return lines;
    }

    _fancyHelper(a, alo, ahi, b, blo, bhi) {
      var g;
      g = [];
      if (alo < ahi) {
        if (blo < bhi) {
          g = this._fancyReplace(a, alo, ahi, b, blo, bhi);
        } else {
          g = this._dump('-', a, alo, ahi);
        }
      } else if (blo < bhi) {
        g = this._dump('+', b, blo, bhi);
      }
      return g;
    }

    _qformat(aline, bline, atags, btags) {
      /*
      Format "?" output and deal with leading tabs.

      Example:

      >>> d = new Differ
      >>> d._qformat('\tabcDefghiJkl\n', '\tabcdefGhijkl\n',
      [ '- \tabcDefghiJkl\n',
        '? \t ^ ^  ^\n',
        '+ \tabcdefGhijkl\n',
        '? \t ^ ^  ^\n' ]
      */
      var common, lines;
      lines = [];
      // Can hurt, but will probably help most of the time.
      common = min(_countLeading(aline, '\t'), _countLeading(bline, '\t'));
      common = min(common, _countLeading(atags.slice(0, common), ' '));
      common = min(common, _countLeading(btags.slice(0, common), ' '));
      atags = atags.slice(common).replace(/\s+$/, '');
      btags = btags.slice(common).replace(/\s+$/, '');
      lines.push('- ' + aline);
      if (atags.length) {
        lines.push(`? ${Array(common + 1).join('\t')}${atags}\n`);
      }
      lines.push('+ ' + bline);
      if (btags.length) {
        lines.push(`? ${Array(common + 1).join('\t')}${btags}\n`);
      }
      return lines;
    }

  };

  // With respect to junk, an earlier version of ndiff simply refused to
  // *start* a match with a junk element.  The result was cases like this:
  //     before: private Thread currentThread;
  //     after:  private volatile Thread currentThread;
  // If you consider whitespace to be junk, the longest contiguous match
  // not starting with junk is "e Thread currentThread".  So ndiff reported
  // that "e volatil" was inserted between the 't' and the 'e' in "private".
  // While an accurate view, to people that's absurd.  The current version
  // looks for matching blocks that are entirely junk-free, then extends the
  // longest one of those as far as possible but only with matching junk.
  // So now "currentThread" is matched, then extended to suck up the
  // preceding blank; then "private" is matched, and extended to suck up the
  // following blank; then "Thread" is matched; and finally ndiff reports
  // that "volatile " was inserted before "Thread".  The only quibble
  // remaining is that perhaps it was really the case that " volatile"
  // was inserted after "private".  I can live with that <wink>.
  IS_LINE_JUNK = function(line, pat = /^\s*#?\s*$/) {
    /*
    Return 1 for ignorable line: iff `line` is blank or contains a single '#'.

    Examples:

    >>> IS_LINE_JUNK('\n')
    true
    >>> IS_LINE_JUNK('  #   \n')
    true
    >>> IS_LINE_JUNK('hello\n')
    false
    */
    return pat.test(line);
  };

  IS_CHARACTER_JUNK = function(ch, ws = ' \t') {
    /*
    Return 1 for ignorable character: iff `ch` is a space or tab.

    Examples:
    >>> IS_CHARACTER_JUNK(' ').should.be.true
    true
    >>> IS_CHARACTER_JUNK('\t').should.be.true
    true
    >>> IS_CHARACTER_JUNK('\n').should.be.false
    false
    >>> IS_CHARACTER_JUNK('x').should.be.false
    false
    */
    return indexOf.call(ws, ch) >= 0;
  };

  _formatRangeUnified = function(start, stop) {
    var beginning, length;
    /*
    Convert range to the "ed" format'
    */
    // Per the diff spec at http://www.unix.org/single_unix_specification/
    beginning = start + 1; // lines start numbering with one
    length = stop - start;
    if (length === 1) {
      return `${beginning}`;
    }
    if (!length) { // empty ranges begin at line just before the range
      beginning--;
    }
    return `${beginning},${length}`;
  };

  unifiedDiff = function(a, b, {fromfile, tofile, fromfiledate, tofiledate, n, lineterm} = {}) {
    var file1Range, file2Range, first, fromdate, group, i1, i2, j1, j2, l, last, len, len1, len2, len3, len4, line, lines, m, o, p, q, ref, ref1, ref2, ref3, started, tag, todate;
    /*
    Compare two sequences of lines; generate the delta as a unified diff.

    Unified diffs are a compact way of showing line changes and a few
    lines of context.  The number of context lines is set by 'n' which
    defaults to three.

    By default, the diff control lines (those with ---, +++, or @@) are
    created with a trailing newline.  

    For inputs that do not have trailing newlines, set the lineterm
    argument to "" so that the output will be uniformly newline free.

    The unidiff format normally has a header for filenames and modification
    times.  Any or all of these may be specified using strings for
    'fromfile', 'tofile', 'fromfiledate', and 'tofiledate'.
    The modification times are normally expressed in the ISO 8601 format.

    Example:

    >>> unifiedDiff('one two three four'.split(' '),
    ...             'zero one tree four'.split(' '), {
    ...               fromfile: 'Original'
    ...               tofile: 'Current',
    ...               fromfiledate: '2005-01-26 23:30:50',
    ...               tofiledate: '2010-04-02 10:20:52',
    ...               lineterm: ''
    ...             })
    [ '--- Original\t2005-01-26 23:30:50',
      '+++ Current\t2010-04-02 10:20:52',
      '@@ -1,4 +1,4 @@',
      '+zero',
      ' one',
      '-two',
      '-three',
      '+tree',
      ' four' ]

    */
    if (fromfile == null) {
      fromfile = '';
    }
    if (tofile == null) {
      tofile = '';
    }
    if (fromfiledate == null) {
      fromfiledate = '';
    }
    if (tofiledate == null) {
      tofiledate = '';
    }
    if (n == null) {
      n = 3;
    }
    if (lineterm == null) {
      lineterm = '\n';
    }
    lines = [];
    started = false;
    ref = (new SequenceMatcher(null, a, b)).getGroupedOpcodes();
    for (l = 0, len = ref.length; l < len; l++) {
      group = ref[l];
      if (!started) {
        started = true;
        fromdate = fromfiledate ? `\t${fromfiledate}` : '';
        todate = tofiledate ? `\t${tofiledate}` : '';
        lines.push(`--- ${fromfile}${fromdate}${lineterm}`);
        lines.push(`+++ ${tofile}${todate}${lineterm}`);
      }
      [first, last] = [group[0], group[group.length - 1]];
      file1Range = _formatRangeUnified(first[1], last[2]);
      file2Range = _formatRangeUnified(first[3], last[4]);
      lines.push(`@@ -${file1Range} +${file2Range} @@${lineterm}`);
      for (m = 0, len1 = group.length; m < len1; m++) {
        [tag, i1, i2, j1, j2] = group[m];
        if (tag === 'equal') {
          ref1 = a.slice(i1, i2);
          for (o = 0, len2 = ref1.length; o < len2; o++) {
            line = ref1[o];
            lines.push(' ' + line);
          }
          continue;
        }
        if (tag === 'replace' || tag === 'delete') {
          ref2 = a.slice(i1, i2);
          for (p = 0, len3 = ref2.length; p < len3; p++) {
            line = ref2[p];
            lines.push('-' + line);
          }
        }
        if (tag === 'replace' || tag === 'insert') {
          ref3 = b.slice(j1, j2);
          for (q = 0, len4 = ref3.length; q < len4; q++) {
            line = ref3[q];
            lines.push('+' + line);
          }
        }
      }
    }
    return lines;
  };

  _formatRangeContext = function(start, stop) {
    var beginning, length;
    /*
    Convert range to the "ed" format'
    */
    // Per the diff spec at http://www.unix.org/single_unix_specification/
    beginning = start + 1; // lines start numbering with one
    length = stop - start;
    if (!length) { // empty ranges begin at line just before the range
      beginning--;
    }
    if (length <= 1) {
      return `${beginning}`;
    }
    return `${beginning},${beginning + length - 1}`;
  };

  // See http://www.unix.org/single_unix_specification/
  contextDiff = function(a, b, {fromfile, tofile, fromfiledate, tofiledate, n, lineterm} = {}) {
    var _, file1Range, file2Range, first, fromdate, group, i1, i2, j1, j2, l, last, len, len1, len2, len3, len4, line, lines, m, o, p, prefix, q, ref, ref1, ref2, started, tag, todate;
    /*
    Compare two sequences of lines; generate the delta as a context diff.

    Context diffs are a compact way of showing line changes and a few
    lines of context.  The number of context lines is set by 'n' which
    defaults to three.

    By default, the diff control lines (those with *** or ---) are
    created with a trailing newline.  This is helpful so that inputs
    created from file.readlines() result in diffs that are suitable for
    file.writelines() since both the inputs and outputs have trailing
    newlines.

    For inputs that do not have trailing newlines, set the lineterm
    argument to "" so that the output will be uniformly newline free.

    The context diff format normally has a header for filenames and
    modification times.  Any or all of these may be specified using
    strings for 'fromfile', 'tofile', 'fromfiledate', and 'tofiledate'.
    The modification times are normally expressed in the ISO 8601 format.
    If not specified, the strings default to blanks.

    Example:
    >>> a = ['one\n', 'two\n', 'three\n', 'four\n']
    >>> b = ['zero\n', 'one\n', 'tree\n', 'four\n']
    >>> contextDiff(a, b, {fromfile: 'Original', tofile: 'Current'})
    [ '*** Original\n',
      '--- Current\n',
      '***************\n',
      '*** 1,4 ****\n',
      '  one\n',
      '! two\n',
      '! three\n',
      '  four\n',
      '--- 1,4 ----\n',
      '+ zero\n',
      '  one\n',
      '! tree\n',
      '  four\n' ]
    */
    if (fromfile == null) {
      fromfile = '';
    }
    if (tofile == null) {
      tofile = '';
    }
    if (fromfiledate == null) {
      fromfiledate = '';
    }
    if (tofiledate == null) {
      tofiledate = '';
    }
    if (n == null) {
      n = 3;
    }
    if (lineterm == null) {
      lineterm = '\n';
    }
    prefix = {
      insert: '+ ',
      delete: '- ',
      replace: '! ',
      equal: '  '
    };
    started = false;
    lines = [];
    ref = (new SequenceMatcher(null, a, b)).getGroupedOpcodes();
    for (l = 0, len = ref.length; l < len; l++) {
      group = ref[l];
      if (!started) {
        started = true;
        fromdate = fromfiledate ? `\t${fromfiledate}` : '';
        todate = tofiledate ? `\t${tofiledate}` : '';
        lines.push(`*** ${fromfile}${fromdate}${lineterm}`);
        lines.push(`--- ${tofile}${todate}${lineterm}`);
        [first, last] = [group[0], group[group.length - 1]];
        lines.push('***************' + lineterm);
        file1Range = _formatRangeContext(first[1], last[2]);
        lines.push(`*** ${file1Range} ****${lineterm}`);
        if (_any((function() {
          var len1, m, results;
          results = [];
          for (m = 0, len1 = group.length; m < len1; m++) {
            [tag, _, _, _, _] = group[m];
            results.push(tag === 'replace' || tag === 'delete');
          }
          return results;
        })())) {
          for (m = 0, len1 = group.length; m < len1; m++) {
            [tag, i1, i2, _, _] = group[m];
            if (tag !== 'insert') {
              ref1 = a.slice(i1, i2);
              for (o = 0, len2 = ref1.length; o < len2; o++) {
                line = ref1[o];
                lines.push(prefix[tag] + line);
              }
            }
          }
        }
        file2Range = _formatRangeContext(first[3], last[4]);
        lines.push(`--- ${file2Range} ----${lineterm}`);
        if (_any((function() {
          var len3, p, results;
          results = [];
          for (p = 0, len3 = group.length; p < len3; p++) {
            [tag, _, _, _, _] = group[p];
            results.push(tag === 'replace' || tag === 'insert');
          }
          return results;
        })())) {
          for (p = 0, len3 = group.length; p < len3; p++) {
            [tag, _, _, j1, j2] = group[p];
            if (tag !== 'delete') {
              ref2 = b.slice(j1, j2);
              for (q = 0, len4 = ref2.length; q < len4; q++) {
                line = ref2[q];
                lines.push(prefix[tag] + line);
              }
            }
          }
        }
      }
    }
    return lines;
  };

  ndiff = function(a, b, linejunk, charjunk = IS_CHARACTER_JUNK) {
    /*
    Compare `a` and `b` (lists of strings); return a `Differ`-style delta.

    Optional keyword parameters `linejunk` and `charjunk` are for filter
    functions (or None):

    - linejunk: A function that should accept a single string argument, and
      return true iff the string is junk.  The default is null, and is
      recommended; 

    - charjunk: A function that should accept a string of length 1. The
      default is module-level function IS_CHARACTER_JUNK, which filters out
      whitespace characters (a blank or tab; note: bad idea to include newline
      in this!).

    Example:
    >>> a = ['one\n', 'two\n', 'three\n']
    >>> b = ['ore\n', 'tree\n', 'emu\n']
    >>> ndiff(a, b)
    [ '- one\n',
      '?  ^\n',
      '+ ore\n',
      '?  ^\n',
      '- two\n',
      '- three\n',
      '?  -\n',
      '+ tree\n',
      '+ emu\n' ]
    */
    return (new Differ(linejunk, charjunk)).compare(a, b);
  };

  restore = function(delta, which) {
    /*
    Generate one of the two sequences that generated a delta.

    Given a `delta` produced by `Differ.compare()` or `ndiff()`, extract
    lines originating from file 1 or 2 (parameter `which`), stripping off line
    prefixes.

    Examples:
    >>> a = ['one\n', 'two\n', 'three\n']
    >>> b = ['ore\n', 'tree\n', 'emu\n']
    >>> diff = ndiff(a, b)
    >>> restore(diff, 1)
    [ 'one\n',
      'two\n',
      'three\n' ]
    >>> restore(diff, 2)
    [ 'ore\n',
      'tree\n',
      'emu\n' ]
    */
    var l, len, line, lines, prefixes, ref, tag;
    tag = {
      1: '- ',
      2: '+ '
    }[which];
    if (!tag) {
      throw new Error(`unknow delta choice (must be 1 or 2): ${which}`);
    }
    prefixes = ['  ', tag];
    lines = [];
    for (l = 0, len = delta.length; l < len; l++) {
      line = delta[l];
      if (ref = line.slice(0, 2), indexOf.call(prefixes, ref) >= 0) {
        lines.push(line.slice(2));
      }
    }
    return lines;
  };

  // exports to global
  exports._arrayCmp = _arrayCmp;

  exports.SequenceMatcher = SequenceMatcher;

  exports.getCloseMatches = getCloseMatches;

  exports._countLeading = _countLeading;

  exports.Differ = Differ;

  exports.IS_LINE_JUNK = IS_LINE_JUNK;

  exports.IS_CHARACTER_JUNK = IS_CHARACTER_JUNK;

  exports._formatRangeUnified = _formatRangeUnified;

  exports.unifiedDiff = unifiedDiff;

  exports._formatRangeContext = _formatRangeContext;

  exports.contextDiff = contextDiff;

  exports.ndiff = ndiff;

  exports.restore = restore;

}).call(this);

},{"assert":271,"heap":427}],256:[function(require,module,exports){
var asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');

},{"./asn1/api":257,"./asn1/base":259,"./asn1/constants":263,"./asn1/decoders":265,"./asn1/encoders":268,"bn.js":270}],257:[function(require,module,exports){
var asn1 = require('../asn1');
var inherits = require('inherits');

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = require('vm').runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

},{"../asn1":256,"inherits":431,"vm":756}],258:[function(require,module,exports){
var inherits = require('inherits');
var Reporter = require('../base').Reporter;
var Buffer = require('buffer').Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

},{"../base":259,"buffer":322,"inherits":431}],259:[function(require,module,exports){
var base = exports;

base.Reporter = require('./reporter').Reporter;
base.DecoderBuffer = require('./buffer').DecoderBuffer;
base.EncoderBuffer = require('./buffer').EncoderBuffer;
base.Node = require('./node');

},{"./buffer":258,"./node":260,"./reporter":261}],260:[function(require,module,exports){
var Reporter = require('../base').Reporter;
var EncoderBuffer = require('../base').EncoderBuffer;
var DecoderBuffer = require('../base').DecoderBuffer;
var assert = require('minimalistic-assert');

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"../base":259,"minimalistic-assert":454}],261:[function(require,module,exports){
var inherits = require('inherits');

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

},{"inherits":431}],262:[function(require,module,exports){
var constants = require('../constants');

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);

},{"../constants":263}],263:[function(require,module,exports){
var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');

},{"./der":262}],264:[function(require,module,exports){
var inherits = require('inherits');

var asn1 = require('../../asn1');
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}

},{"../../asn1":256,"inherits":431}],265:[function(require,module,exports){
var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');

},{"./der":264,"./pem":266}],266:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var DERDecoder = require('./der');

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

},{"./der":264,"buffer":322,"inherits":431}],267:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var asn1 = require('../../asn1');
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}

},{"../../asn1":256,"buffer":322,"inherits":431}],268:[function(require,module,exports){
var encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');

},{"./der":267,"./pem":269}],269:[function(require,module,exports){
var inherits = require('inherits');

var DEREncoder = require('./der');

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

},{"./der":267,"inherits":431}],270:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
      i++;
    }

    // Clear words above the requested width so the result stays below 2 ** width
    for (; i < this.length; i++) {
      this.words[i] = 0;
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    if (num === 0) {
      this.length = 1;
      this._normSign();
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.mod.abs();

    var half = num.abs().iushrn(1);
    var r2 = num.words[0] & 1;
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up, away from zero
    var up = new BN(1);
    up.negative = this.negative ^ num.negative;
    return dm.div.iadd(up);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":280}],271:[function(require,module,exports){
(function (global){(function (){
'use strict';

var objectAssign = require('object.assign/polyfill')();

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = require('util/');
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"object.assign/polyfill":461,"util/":274}],272:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],273:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],274:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./support/isBuffer":273,"_process":696,"inherits":272}],275:[function(require,module,exports){
(function (process,setImmediate){(function (){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.async = {}));
})(this, (function (exports) { 'use strict';

    /**
     * Creates a continuation function with some arguments already applied.
     *
     * Useful as a shorthand when combined with other control flow functions. Any
     * arguments passed to the returned function are added to the arguments
     * originally passed to apply.
     *
     * @name apply
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {Function} fn - The function you want to eventually apply all
     * arguments to. Invokes with (arguments...).
     * @param {...*} arguments... - Any number of arguments to automatically apply
     * when the continuation is called.
     * @returns {Function} the partially-applied function
     * @example
     *
     * // using apply
     * async.parallel([
     *     async.apply(fs.writeFile, 'testfile1', 'test1'),
     *     async.apply(fs.writeFile, 'testfile2', 'test2')
     * ]);
     *
     *
     * // the same process without using apply
     * async.parallel([
     *     function(callback) {
     *         fs.writeFile('testfile1', 'test1', callback);
     *     },
     *     function(callback) {
     *         fs.writeFile('testfile2', 'test2', callback);
     *     }
     * ]);
     *
     * // It's possible to pass any number of additional arguments when calling the
     * // continuation:
     *
     * node> var fn = async.apply(sys.puts, 'one');
     * node> fn('two', 'three');
     * one
     * two
     * three
     */
    function apply(fn, ...args) {
        return (...callArgs) => fn(...args,...callArgs);
    }

    function initialParams (fn) {
        return function (...args/*, callback*/) {
            var callback = args.pop();
            return fn.call(this, args, callback);
        };
    }

    /* istanbul ignore file */

    var hasQueueMicrotask = typeof queueMicrotask === 'function' && queueMicrotask;
    var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
    var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

    function fallback(fn) {
        setTimeout(fn, 0);
    }

    function wrap(defer) {
        return (fn, ...args) => defer(() => fn(...args));
    }

    var _defer$1;

    if (hasQueueMicrotask) {
        _defer$1 = queueMicrotask;
    } else if (hasSetImmediate) {
        _defer$1 = setImmediate;
    } else if (hasNextTick) {
        _defer$1 = process.nextTick;
    } else {
        _defer$1 = fallback;
    }

    var setImmediate$1 = wrap(_defer$1);

    /**
     * Take a sync function and make it async, passing its return value to a
     * callback. This is useful for plugging sync functions into a waterfall,
     * series, or other async functions. Any arguments passed to the generated
     * function will be passed to the wrapped function (except for the final
     * callback argument). Errors thrown will be passed to the callback.
     *
     * If the function passed to `asyncify` returns a Promise, that promises's
     * resolved/rejected state will be used to call the callback, rather than simply
     * the synchronous return value.
     *
     * This also means you can asyncify ES2017 `async` functions.
     *
     * @name asyncify
     * @static
     * @memberOf module:Utils
     * @method
     * @alias wrapSync
     * @category Util
     * @param {Function} func - The synchronous function, or Promise-returning
     * function to convert to an {@link AsyncFunction}.
     * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
     * invoked with `(args..., callback)`.
     * @example
     *
     * // passing a regular synchronous function
     * async.waterfall([
     *     async.apply(fs.readFile, filename, "utf8"),
     *     async.asyncify(JSON.parse),
     *     function (data, next) {
     *         // data is the result of parsing the text.
     *         // If there was a parsing error, it would have been caught.
     *     }
     * ], callback);
     *
     * // passing a function returning a promise
     * async.waterfall([
     *     async.apply(fs.readFile, filename, "utf8"),
     *     async.asyncify(function (contents) {
     *         return db.model.create(contents);
     *     }),
     *     function (model, next) {
     *         // `model` is the instantiated model object.
     *         // If there was an error, this function would be skipped.
     *     }
     * ], callback);
     *
     * // es2017 example, though `asyncify` is not needed if your JS environment
     * // supports async functions out of the box
     * var q = async.queue(async.asyncify(async function(file) {
     *     var intermediateStep = await processFile(file);
     *     return await somePromise(intermediateStep)
     * }));
     *
     * q.push(files);
     */
    function asyncify(func) {
        if (isAsync(func)) {
            return function (...args/*, callback*/) {
                const callback = args.pop();
                const promise = func.apply(this, args);
                return handlePromise(promise, callback)
            }
        }

        return initialParams(function (args, callback) {
            var result;
            try {
                result = func.apply(this, args);
            } catch (e) {
                return callback(e);
            }
            // if result is Promise object
            if (result && typeof result.then === 'function') {
                return handlePromise(result, callback)
            } else {
                callback(null, result);
            }
        });
    }

    function handlePromise(promise, callback) {
        return promise.then(value => {
            invokeCallback(callback, null, value);
        }, err => {
            invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
        });
    }

    function invokeCallback(callback, error, value) {
        try {
            callback(error, value);
        } catch (err) {
            setImmediate$1(e => { throw e }, err);
        }
    }

    function isAsync(fn) {
        return fn[Symbol.toStringTag] === 'AsyncFunction';
    }

    function isAsyncGenerator(fn) {
        return fn[Symbol.toStringTag] === 'AsyncGenerator';
    }

    function isAsyncIterable(obj) {
        return typeof obj[Symbol.asyncIterator] === 'function';
    }

    function wrapAsync(asyncFn) {
        if (typeof asyncFn !== 'function') throw new Error('expected a function')
        return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
    }

    // conditionally promisify a function.
    // only return a promise if a callback is omitted
    function awaitify (asyncFn, arity) {
        if (!arity) arity = asyncFn.length;
        if (!arity) throw new Error('arity is undefined')
        function awaitable (...args) {
            if (typeof args[arity - 1] === 'function') {
                return asyncFn.apply(this, args)
            }

            return new Promise((resolve, reject) => {
                args[arity - 1] = (err, ...cbArgs) => {
                    if (err) return reject(err)
                    resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
                };
                asyncFn.apply(this, args);
            })
        }

        return awaitable
    }

    function applyEach$1 (eachfn) {
        return function applyEach(fns, ...callArgs) {
            const go = awaitify(function (callback) {
                var that = this;
                return eachfn(fns, (fn, cb) => {
                    wrapAsync(fn).apply(that, callArgs.concat(cb));
                }, callback);
            });
            return go;
        };
    }

    function _asyncMap(eachfn, arr, iteratee, callback) {
        arr = arr || [];
        var results = [];
        var counter = 0;
        var _iteratee = wrapAsync(iteratee);

        return eachfn(arr, (value, _, iterCb) => {
            var index = counter++;
            _iteratee(value, (err, v) => {
                results[index] = v;
                iterCb(err);
            });
        }, err => {
            callback(err, results);
        });
    }

    function isArrayLike(value) {
        return value &&
            typeof value.length === 'number' &&
            value.length >= 0 &&
            value.length % 1 === 0;
    }

    // A temporary value used to identify if the loop should be broken.
    // See #1064, #1293
    const breakLoop = {};

    function once(fn) {
        function wrapper (...args) {
            if (fn === null) return;
            var callFn = fn;
            fn = null;
            callFn.apply(this, args);
        }
        Object.assign(wrapper, fn);
        return wrapper
    }

    function getIterator (coll) {
        return coll[Symbol.iterator] && coll[Symbol.iterator]();
    }

    function createArrayIterator(coll) {
        var i = -1;
        var len = coll.length;
        return function next() {
            return ++i < len ? {value: coll[i], key: i} : null;
        }
    }

    function createES2015Iterator(iterator) {
        var i = -1;
        return function next() {
            var item = iterator.next();
            if (item.done)
                return null;
            i++;
            return {value: item.value, key: i};
        }
    }

    function createObjectIterator(obj) {
        var okeys = obj ? Object.keys(obj) : [];
        var i = -1;
        var len = okeys.length;
        return function next() {
            var key = okeys[++i];
            if (key === '__proto__') {
                return next();
            }
            return i < len ? {value: obj[key], key} : null;
        };
    }

    function createIterator(coll) {
        if (isArrayLike(coll)) {
            return createArrayIterator(coll);
        }

        var iterator = getIterator(coll);
        return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
    }

    function onlyOnce(fn) {
        return function (...args) {
            if (fn === null) throw new Error("Callback was already called.");
            var callFn = fn;
            fn = null;
            callFn.apply(this, args);
        };
    }

    // for async generators
    function asyncEachOfLimit(generator, limit, iteratee, callback) {
        let done = false;
        let canceled = false;
        let awaiting = false;
        let running = 0;
        let idx = 0;

        function replenish() {
            //console.log('replenish')
            if (running >= limit || awaiting || done) return
            //console.log('replenish awaiting')
            awaiting = true;
            generator.next().then(({value, done: iterDone}) => {
                //console.log('got value', value)
                if (canceled || done) return
                awaiting = false;
                if (iterDone) {
                    done = true;
                    if (running <= 0) {
                        //console.log('done nextCb')
                        callback(null);
                    }
                    return;
                }
                running++;
                iteratee(value, idx, iterateeCallback);
                idx++;
                replenish();
            }).catch(handleError);
        }

        function iterateeCallback(err, result) {
            //console.log('iterateeCallback')
            running -= 1;
            if (canceled) return
            if (err) return handleError(err)

            if (err === false) {
                done = true;
                canceled = true;
                return
            }

            if (result === breakLoop || (done && running <= 0)) {
                done = true;
                //console.log('done iterCb')
                return callback(null);
            }
            replenish();
        }

        function handleError(err) {
            if (canceled) return
            awaiting = false;
            done = true;
            callback(err);
        }

        replenish();
    }

    var eachOfLimit$2 = (limit) => {
        return (obj, iteratee, callback) => {
            callback = once(callback);
            if (limit <= 0) {
                throw new RangeError('concurrency limit cannot be less than 1')
            }
            if (!obj) {
                return callback(null);
            }
            if (isAsyncGenerator(obj)) {
                return asyncEachOfLimit(obj, limit, iteratee, callback)
            }
            if (isAsyncIterable(obj)) {
                return asyncEachOfLimit(obj[Symbol.asyncIterator](), limit, iteratee, callback)
            }
            var nextElem = createIterator(obj);
            var done = false;
            var canceled = false;
            var running = 0;
            var looping = false;

            function iterateeCallback(err, value) {
                if (canceled) return
                running -= 1;
                if (err) {
                    done = true;
                    callback(err);
                }
                else if (err === false) {
                    done = true;
                    canceled = true;
                }
                else if (value === breakLoop || (done && running <= 0)) {
                    done = true;
                    return callback(null);
                }
                else if (!looping) {
                    replenish();
                }
            }

            function replenish () {
                looping = true;
                while (running < limit && !done) {
                    var elem = nextElem();
                    if (elem === null) {
                        done = true;
                        if (running <= 0) {
                            callback(null);
                        }
                        return;
                    }
                    running += 1;
                    iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
                }
                looping = false;
            }

            replenish();
        };
    };

    /**
     * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name eachOfLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.eachOf]{@link module:Collections.eachOf}
     * @alias forEachOfLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each
     * item in `coll`. The `key` is the item's key, or index in the case of an
     * array.
     * Invoked with (item, key, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachOfLimit(coll, limit, iteratee, callback) {
        return eachOfLimit$2(limit)(coll, wrapAsync(iteratee), callback);
    }

    var eachOfLimit$1 = awaitify(eachOfLimit, 4);

    // eachOf implementation optimized for array-likes
    function eachOfArrayLike(coll, iteratee, callback) {
        callback = once(callback);
        var index = 0,
            completed = 0,
            {length} = coll,
            canceled = false;
        if (length === 0) {
            callback(null);
        }

        function iteratorCallback(err, value) {
            if (err === false) {
                canceled = true;
            }
            if (canceled === true) return
            if (err) {
                callback(err);
            } else if ((++completed === length) || value === breakLoop) {
                callback(null);
            }
        }

        for (; index < length; index++) {
            iteratee(coll[index], index, onlyOnce(iteratorCallback));
        }
    }

    // a generic version of eachOf which can handle array, object, and iterator cases.
    function eachOfGeneric (coll, iteratee, callback) {
        return eachOfLimit$1(coll, Infinity, iteratee, callback);
    }

    /**
     * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
     * to the iteratee.
     *
     * @name eachOf
     * @static
     * @memberOf module:Collections
     * @method
     * @alias forEachOf
     * @category Collection
     * @see [async.each]{@link module:Collections.each}
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each
     * item in `coll`.
     * The `key` is the item's key, or index in the case of an array.
     * Invoked with (item, key, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * // dev.json is a file containing a valid json object config for dev environment
     * // dev.json is a file containing a valid json object config for test environment
     * // prod.json is a file containing a valid json object config for prod environment
     * // invalid.json is a file with a malformed json object
     *
     * let configs = {}; //global variable
     * let validConfigFileMap = {dev: 'dev.json', test: 'test.json', prod: 'prod.json'};
     * let invalidConfigFileMap = {dev: 'dev.json', test: 'test.json', invalid: 'invalid.json'};
     *
     * // asynchronous function that reads a json file and parses the contents as json object
     * function parseFile(file, key, callback) {
     *     fs.readFile(file, "utf8", function(err, data) {
     *         if (err) return calback(err);
     *         try {
     *             configs[key] = JSON.parse(data);
     *         } catch (e) {
     *             return callback(e);
     *         }
     *         callback();
     *     });
     * }
     *
     * // Using callbacks
     * async.forEachOf(validConfigFileMap, parseFile, function (err) {
     *     if (err) {
     *         console.error(err);
     *     } else {
     *         console.log(configs);
     *         // configs is now a map of JSON data, e.g.
     *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
     *     }
     * });
     *
     * //Error handing
     * async.forEachOf(invalidConfigFileMap, parseFile, function (err) {
     *     if (err) {
     *         console.error(err);
     *         // JSON parse error exception
     *     } else {
     *         console.log(configs);
     *     }
     * });
     *
     * // Using Promises
     * async.forEachOf(validConfigFileMap, parseFile)
     * .then( () => {
     *     console.log(configs);
     *     // configs is now a map of JSON data, e.g.
     *     // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
     * }).catch( err => {
     *     console.error(err);
     * });
     *
     * //Error handing
     * async.forEachOf(invalidConfigFileMap, parseFile)
     * .then( () => {
     *     console.log(configs);
     * }).catch( err => {
     *     console.error(err);
     *     // JSON parse error exception
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.forEachOf(validConfigFileMap, parseFile);
     *         console.log(configs);
     *         // configs is now a map of JSON data, e.g.
     *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * //Error handing
     * async () => {
     *     try {
     *         let result = await async.forEachOf(invalidConfigFileMap, parseFile);
     *         console.log(configs);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // JSON parse error exception
     *     }
     * }
     *
     */
    function eachOf(coll, iteratee, callback) {
        var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
        return eachOfImplementation(coll, wrapAsync(iteratee), callback);
    }

    var eachOf$1 = awaitify(eachOf, 3);

    /**
     * Produces a new collection of values by mapping each value in `coll` through
     * the `iteratee` function. The `iteratee` is called with an item from `coll`
     * and a callback for when it has finished processing. Each of these callbacks
     * takes 2 arguments: an `error`, and the transformed item from `coll`. If
     * `iteratee` passes an error to its callback, the main `callback` (for the
     * `map` function) is immediately called with the error.
     *
     * Note, that since this function applies the `iteratee` to each item in
     * parallel, there is no guarantee that the `iteratee` functions will complete
     * in order. However, the results array will be in the same order as the
     * original `coll`.
     *
     * If `map` is passed an Object, the results will be an Array.  The results
     * will roughly be in the order of the original Objects' keys (but this can
     * vary across JavaScript engines).
     *
     * @name map
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with the transformed item.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Results is an Array of the
     * transformed items from the `coll`. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     * // file4.txt does not exist
     *
     * const fileList = ['file1.txt','file2.txt','file3.txt'];
     * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
     *
     * // asynchronous function that returns the file size in bytes
     * function getFileSizeInBytes(file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.map(fileList, getFileSizeInBytes, function(err, results) {
     *     if (err) {
     *         console.log(err);
     *     } else {
     *         console.log(results);
     *         // results is now an array of the file size in bytes for each file, e.g.
     *         // [ 1000, 2000, 3000]
     *     }
     * });
     *
     * // Error Handling
     * async.map(withMissingFileList, getFileSizeInBytes, function(err, results) {
     *     if (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     } else {
     *         console.log(results);
     *     }
     * });
     *
     * // Using Promises
     * async.map(fileList, getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     *     // results is now an array of the file size in bytes for each file, e.g.
     *     // [ 1000, 2000, 3000]
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.map(withMissingFileList, getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.map(fileList, getFileSizeInBytes);
     *         console.log(results);
     *         // results is now an array of the file size in bytes for each file, e.g.
     *         // [ 1000, 2000, 3000]
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let results = await async.map(withMissingFileList, getFileSizeInBytes);
     *         console.log(results);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function map (coll, iteratee, callback) {
        return _asyncMap(eachOf$1, coll, iteratee, callback)
    }
    var map$1 = awaitify(map, 3);

    /**
     * Applies the provided arguments to each function in the array, calling
     * `callback` after all functions have completed. If you only provide the first
     * argument, `fns`, then it will return a function which lets you pass in the
     * arguments as if it were a single function call. If more arguments are
     * provided, `callback` is required while `args` is still optional. The results
     * for each of the applied async functions are passed to the final callback
     * as an array.
     *
     * @name applyEach
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s
     * to all call with the same arguments
     * @param {...*} [args] - any number of separate arguments to pass to the
     * function.
     * @param {Function} [callback] - the final argument should be the callback,
     * called when all functions have completed processing.
     * @returns {AsyncFunction} - Returns a function that takes no args other than
     * an optional callback, that is the result of applying the `args` to each
     * of the functions.
     * @example
     *
     * const appliedFn = async.applyEach([enableSearch, updateSchema], 'bucket')
     *
     * appliedFn((err, results) => {
     *     // results[0] is the results for `enableSearch`
     *     // results[1] is the results for `updateSchema`
     * });
     *
     * // partial application example:
     * async.each(
     *     buckets,
     *     async (bucket) => async.applyEach([enableSearch, updateSchema], bucket)(),
     *     callback
     * );
     */
    var applyEach = applyEach$1(map$1);

    /**
     * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
     *
     * @name eachOfSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.eachOf]{@link module:Collections.eachOf}
     * @alias forEachOfSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * Invoked with (item, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachOfSeries(coll, iteratee, callback) {
        return eachOfLimit$1(coll, 1, iteratee, callback)
    }
    var eachOfSeries$1 = awaitify(eachOfSeries, 3);

    /**
     * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
     *
     * @name mapSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.map]{@link module:Collections.map}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with the transformed item.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Results is an array of the
     * transformed items from the `coll`. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapSeries (coll, iteratee, callback) {
        return _asyncMap(eachOfSeries$1, coll, iteratee, callback)
    }
    var mapSeries$1 = awaitify(mapSeries, 3);

    /**
     * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
     *
     * @name applyEachSeries
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.applyEach]{@link module:ControlFlow.applyEach}
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s to all
     * call with the same arguments
     * @param {...*} [args] - any number of separate arguments to pass to the
     * function.
     * @param {Function} [callback] - the final argument should be the callback,
     * called when all functions have completed processing.
     * @returns {AsyncFunction} - A function, that when called, is the result of
     * appling the `args` to the list of functions.  It takes no args, other than
     * a callback.
     */
    var applyEachSeries = applyEach$1(mapSeries$1);

    const PROMISE_SYMBOL = Symbol('promiseCallback');

    function promiseCallback () {
        let resolve, reject;
        function callback (err, ...args) {
            if (err) return reject(err)
            resolve(args.length > 1 ? args : args[0]);
        }

        callback[PROMISE_SYMBOL] = new Promise((res, rej) => {
            resolve = res,
            reject = rej;
        });

        return callback
    }

    /**
     * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
     * their requirements. Each function can optionally depend on other functions
     * being completed first, and each function is run as soon as its requirements
     * are satisfied.
     *
     * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
     * will stop. Further tasks will not execute (so any other functions depending
     * on it will not run), and the main `callback` is immediately called with the
     * error.
     *
     * {@link AsyncFunction}s also receive an object containing the results of functions which
     * have completed so far as the first argument, if they have dependencies. If a
     * task function has no dependencies, it will only be passed a callback.
     *
     * @name auto
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Object} tasks - An object. Each of its properties is either a
     * function or an array of requirements, with the {@link AsyncFunction} itself the last item
     * in the array. The object's key of a property serves as the name of the task
     * defined by that property, i.e. can be used when specifying requirements for
     * other tasks. The function receives one or two arguments:
     * * a `results` object, containing the results of the previously executed
     *   functions, only passed if the task has any dependencies,
     * * a `callback(err, result)` function, which must be called when finished,
     *   passing an `error` (which can be `null`) and the result of the function's
     *   execution.
     * @param {number} [concurrency=Infinity] - An optional `integer` for
     * determining the maximum number of tasks that can be run in parallel. By
     * default, as many as possible.
     * @param {Function} [callback] - An optional callback which is called when all
     * the tasks have been completed. It receives the `err` argument if any `tasks`
     * pass an error to their callback. Results are always returned; however, if an
     * error occurs, no further `tasks` will be performed, and the results object
     * will only contain partial results. Invoked with (err, results).
     * @returns {Promise} a promise, if a callback is not passed
     * @example
     *
     * //Using Callbacks
     * async.auto({
     *     get_data: function(callback) {
     *         // async code to get some data
     *         callback(null, 'data', 'converted to array');
     *     },
     *     make_folder: function(callback) {
     *         // async code to create a directory to store a file in
     *         // this is run at the same time as getting the data
     *         callback(null, 'folder');
     *     },
     *     write_file: ['get_data', 'make_folder', function(results, callback) {
     *         // once there is some data and the directory exists,
     *         // write the data to a file in the directory
     *         callback(null, 'filename');
     *     }],
     *     email_link: ['write_file', function(results, callback) {
     *         // once the file is written let's email a link to it...
     *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
     *     }]
     * }, function(err, results) {
     *     if (err) {
     *         console.log('err = ', err);
     *     }
     *     console.log('results = ', results);
     *     // results = {
     *     //     get_data: ['data', 'converted to array']
     *     //     make_folder; 'folder',
     *     //     write_file: 'filename'
     *     //     email_link: { file: 'filename', email: 'user@example.com' }
     *     // }
     * });
     *
     * //Using Promises
     * async.auto({
     *     get_data: function(callback) {
     *         console.log('in get_data');
     *         // async code to get some data
     *         callback(null, 'data', 'converted to array');
     *     },
     *     make_folder: function(callback) {
     *         console.log('in make_folder');
     *         // async code to create a directory to store a file in
     *         // this is run at the same time as getting the data
     *         callback(null, 'folder');
     *     },
     *     write_file: ['get_data', 'make_folder', function(results, callback) {
     *         // once there is some data and the directory exists,
     *         // write the data to a file in the directory
     *         callback(null, 'filename');
     *     }],
     *     email_link: ['write_file', function(results, callback) {
     *         // once the file is written let's email a link to it...
     *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
     *     }]
     * }).then(results => {
     *     console.log('results = ', results);
     *     // results = {
     *     //     get_data: ['data', 'converted to array']
     *     //     make_folder; 'folder',
     *     //     write_file: 'filename'
     *     //     email_link: { file: 'filename', email: 'user@example.com' }
     *     // }
     * }).catch(err => {
     *     console.log('err = ', err);
     * });
     *
     * //Using async/await
     * async () => {
     *     try {
     *         let results = await async.auto({
     *             get_data: function(callback) {
     *                 // async code to get some data
     *                 callback(null, 'data', 'converted to array');
     *             },
     *             make_folder: function(callback) {
     *                 // async code to create a directory to store a file in
     *                 // this is run at the same time as getting the data
     *                 callback(null, 'folder');
     *             },
     *             write_file: ['get_data', 'make_folder', function(results, callback) {
     *                 // once there is some data and the directory exists,
     *                 // write the data to a file in the directory
     *                 callback(null, 'filename');
     *             }],
     *             email_link: ['write_file', function(results, callback) {
     *                 // once the file is written let's email a link to it...
     *                 callback(null, {'file':results.write_file, 'email':'user@example.com'});
     *             }]
     *         });
     *         console.log('results = ', results);
     *         // results = {
     *         //     get_data: ['data', 'converted to array']
     *         //     make_folder; 'folder',
     *         //     write_file: 'filename'
     *         //     email_link: { file: 'filename', email: 'user@example.com' }
     *         // }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function auto(tasks, concurrency, callback) {
        if (typeof concurrency !== 'number') {
            // concurrency is optional, shift the args.
            callback = concurrency;
            concurrency = null;
        }
        callback = once(callback || promiseCallback());
        var numTasks = Object.keys(tasks).length;
        if (!numTasks) {
            return callback(null);
        }
        if (!concurrency) {
            concurrency = numTasks;
        }

        var results = {};
        var runningTasks = 0;
        var canceled = false;
        var hasError = false;

        var listeners = Object.create(null);

        var readyTasks = [];

        // for cycle detection:
        var readyToCheck = []; // tasks that have been identified as reachable
        // without the possibility of returning to an ancestor task
        var uncheckedDependencies = {};

        Object.keys(tasks).forEach(key => {
            var task = tasks[key];
            if (!Array.isArray(task)) {
                // no dependencies
                enqueueTask(key, [task]);
                readyToCheck.push(key);
                return;
            }

            var dependencies = task.slice(0, task.length - 1);
            var remainingDependencies = dependencies.length;
            if (remainingDependencies === 0) {
                enqueueTask(key, task);
                readyToCheck.push(key);
                return;
            }
            uncheckedDependencies[key] = remainingDependencies;

            dependencies.forEach(dependencyName => {
                if (!tasks[dependencyName]) {
                    throw new Error('async.auto task `' + key +
                        '` has a non-existent dependency `' +
                        dependencyName + '` in ' +
                        dependencies.join(', '));
                }
                addListener(dependencyName, () => {
                    remainingDependencies--;
                    if (remainingDependencies === 0) {
                        enqueueTask(key, task);
                    }
                });
            });
        });

        checkForDeadlocks();
        processQueue();

        function enqueueTask(key, task) {
            readyTasks.push(() => runTask(key, task));
        }

        function processQueue() {
            if (canceled) return
            if (readyTasks.length === 0 && runningTasks === 0) {
                return callback(null, results);
            }
            while(readyTasks.length && runningTasks < concurrency) {
                var run = readyTasks.shift();
                run();
            }

        }

        function addListener(taskName, fn) {
            var taskListeners = listeners[taskName];
            if (!taskListeners) {
                taskListeners = listeners[taskName] = [];
            }

            taskListeners.push(fn);
        }

        function taskComplete(taskName) {
            var taskListeners = listeners[taskName] || [];
            taskListeners.forEach(fn => fn());
            processQueue();
        }


        function runTask(key, task) {
            if (hasError) return;

            var taskCallback = onlyOnce((err, ...result) => {
                runningTasks--;
                if (err === false) {
                    canceled = true;
                    return
                }
                if (result.length < 2) {
                    [result] = result;
                }
                if (err) {
                    var safeResults = {};
                    Object.keys(results).forEach(rkey => {
                        safeResults[rkey] = results[rkey];
                    });
                    safeResults[key] = result;
                    hasError = true;
                    listeners = Object.create(null);
                    if (canceled) return
                    callback(err, safeResults);
                } else {
                    results[key] = result;
                    taskComplete(key);
                }
            });

            runningTasks++;
            var taskFn = wrapAsync(task[task.length - 1]);
            if (task.length > 1) {
                taskFn(results, taskCallback);
            } else {
                taskFn(taskCallback);
            }
        }

        function checkForDeadlocks() {
            // Kahn's algorithm
            // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
            // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
            var currentTask;
            var counter = 0;
            while (readyToCheck.length) {
                currentTask = readyToCheck.pop();
                counter++;
                getDependents(currentTask).forEach(dependent => {
                    if (--uncheckedDependencies[dependent] === 0) {
                        readyToCheck.push(dependent);
                    }
                });
            }

            if (counter !== numTasks) {
                throw new Error(
                    'async.auto cannot execute tasks due to a recursive dependency'
                );
            }
        }

        function getDependents(taskName) {
            var result = [];
            Object.keys(tasks).forEach(key => {
                const task = tasks[key];
                if (Array.isArray(task) && task.indexOf(taskName) >= 0) {
                    result.push(key);
                }
            });
            return result;
        }

        return callback[PROMISE_SYMBOL]
    }

    var FN_ARGS = /^(?:async\s)?(?:function)?\s*(?:\w+\s*)?\(([^)]+)\)(?:\s*{)/;
    var ARROW_FN_ARGS = /^(?:async\s)?\s*(?:\(\s*)?((?:[^)=\s]\s*)*)(?:\)\s*)?=>/;
    var FN_ARG_SPLIT = /,/;
    var FN_ARG = /(=.+)?(\s*)$/;

    function stripComments(string) {
        let stripped = '';
        let index = 0;
        let endBlockComment = string.indexOf('*/');
        while (index < string.length) {
            if (string[index] === '/' && string[index+1] === '/') {
                // inline comment
                let endIndex = string.indexOf('\n', index);
                index = (endIndex === -1) ? string.length : endIndex;
            } else if ((endBlockComment !== -1) && (string[index] === '/') && (string[index+1] === '*')) {
                // block comment
                let endIndex = string.indexOf('*/', index);
                if (endIndex !== -1) {
                    index = endIndex + 2;
                    endBlockComment = string.indexOf('*/', index);
                } else {
                    stripped += string[index];
                    index++;
                }
            } else {
                stripped += string[index];
                index++;
            }
        }
        return stripped;
    }

    function parseParams(func) {
        const src = stripComments(func.toString());
        let match = src.match(FN_ARGS);
        if (!match) {
            match = src.match(ARROW_FN_ARGS);
        }
        if (!match) throw new Error('could not parse args in autoInject\nSource:\n' + src)
        let [, args] = match;
        return args
            .replace(/\s/g, '')
            .split(FN_ARG_SPLIT)
            .map((arg) => arg.replace(FN_ARG, '').trim());
    }

    /**
     * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
     * tasks are specified as parameters to the function, after the usual callback
     * parameter, with the parameter names matching the names of the tasks it
     * depends on. This can provide even more readable task graphs which can be
     * easier to maintain.
     *
     * If a final callback is specified, the task results are similarly injected,
     * specified as named parameters after the initial error parameter.
     *
     * The autoInject function is purely syntactic sugar and its semantics are
     * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
     *
     * @name autoInject
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.auto]{@link module:ControlFlow.auto}
     * @category Control Flow
     * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
     * the form 'func([dependencies...], callback). The object's key of a property
     * serves as the name of the task defined by that property, i.e. can be used
     * when specifying requirements for other tasks.
     * * The `callback` parameter is a `callback(err, result)` which must be called
     *   when finished, passing an `error` (which can be `null`) and the result of
     *   the function's execution. The remaining parameters name other tasks on
     *   which the task is dependent, and the results from those tasks are the
     *   arguments of those parameters.
     * @param {Function} [callback] - An optional callback which is called when all
     * the tasks have been completed. It receives the `err` argument if any `tasks`
     * pass an error to their callback, and a `results` object with any completed
     * task results, similar to `auto`.
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * //  The example from `auto` can be rewritten as follows:
     * async.autoInject({
     *     get_data: function(callback) {
     *         // async code to get some data
     *         callback(null, 'data', 'converted to array');
     *     },
     *     make_folder: function(callback) {
     *         // async code to create a directory to store a file in
     *         // this is run at the same time as getting the data
     *         callback(null, 'folder');
     *     },
     *     write_file: function(get_data, make_folder, callback) {
     *         // once there is some data and the directory exists,
     *         // write the data to a file in the directory
     *         callback(null, 'filename');
     *     },
     *     email_link: function(write_file, callback) {
     *         // once the file is written let's email a link to it...
     *         // write_file contains the filename returned by write_file.
     *         callback(null, {'file':write_file, 'email':'user@example.com'});
     *     }
     * }, function(err, results) {
     *     console.log('err = ', err);
     *     console.log('email_link = ', results.email_link);
     * });
     *
     * // If you are using a JS minifier that mangles parameter names, `autoInject`
     * // will not work with plain functions, since the parameter names will be
     * // collapsed to a single letter identifier.  To work around this, you can
     * // explicitly specify the names of the parameters your task function needs
     * // in an array, similar to Angular.js dependency injection.
     *
     * // This still has an advantage over plain `auto`, since the results a task
     * // depends on are still spread into arguments.
     * async.autoInject({
     *     //...
     *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
     *         callback(null, 'filename');
     *     }],
     *     email_link: ['write_file', function(write_file, callback) {
     *         callback(null, {'file':write_file, 'email':'user@example.com'});
     *     }]
     *     //...
     * }, function(err, results) {
     *     console.log('err = ', err);
     *     console.log('email_link = ', results.email_link);
     * });
     */
    function autoInject(tasks, callback) {
        var newTasks = {};

        Object.keys(tasks).forEach(key => {
            var taskFn = tasks[key];
            var params;
            var fnIsAsync = isAsync(taskFn);
            var hasNoDeps =
                (!fnIsAsync && taskFn.length === 1) ||
                (fnIsAsync && taskFn.length === 0);

            if (Array.isArray(taskFn)) {
                params = [...taskFn];
                taskFn = params.pop();

                newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
            } else if (hasNoDeps) {
                // no dependencies, use the function as-is
                newTasks[key] = taskFn;
            } else {
                params = parseParams(taskFn);
                if ((taskFn.length === 0 && !fnIsAsync) && params.length === 0) {
                    throw new Error("autoInject task functions require explicit parameters.");
                }

                // remove callback param
                if (!fnIsAsync) params.pop();

                newTasks[key] = params.concat(newTask);
            }

            function newTask(results, taskCb) {
                var newArgs = params.map(name => results[name]);
                newArgs.push(taskCb);
                wrapAsync(taskFn)(...newArgs);
            }
        });

        return auto(newTasks, callback);
    }

    // Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
    // used for queues. This implementation assumes that the node provided by the user can be modified
    // to adjust the next and last properties. We implement only the minimal functionality
    // for queue support.
    class DLL {
        constructor() {
            this.head = this.tail = null;
            this.length = 0;
        }

        removeLink(node) {
            if (node.prev) node.prev.next = node.next;
            else this.head = node.next;
            if (node.next) node.next.prev = node.prev;
            else this.tail = node.prev;

            node.prev = node.next = null;
            this.length -= 1;
            return node;
        }

        empty () {
            while(this.head) this.shift();
            return this;
        }

        insertAfter(node, newNode) {
            newNode.prev = node;
            newNode.next = node.next;
            if (node.next) node.next.prev = newNode;
            else this.tail = newNode;
            node.next = newNode;
            this.length += 1;
        }

        insertBefore(node, newNode) {
            newNode.prev = node.prev;
            newNode.next = node;
            if (node.prev) node.prev.next = newNode;
            else this.head = newNode;
            node.prev = newNode;
            this.length += 1;
        }

        unshift(node) {
            if (this.head) this.insertBefore(this.head, node);
            else setInitial(this, node);
        }

        push(node) {
            if (this.tail) this.insertAfter(this.tail, node);
            else setInitial(this, node);
        }

        shift() {
            return this.head && this.removeLink(this.head);
        }

        pop() {
            return this.tail && this.removeLink(this.tail);
        }

        toArray() {
            return [...this]
        }

        *[Symbol.iterator] () {
            var cur = this.head;
            while (cur) {
                yield cur.data;
                cur = cur.next;
            }
        }

        remove (testFn) {
            var curr = this.head;
            while(curr) {
                var {next} = curr;
                if (testFn(curr)) {
                    this.removeLink(curr);
                }
                curr = next;
            }
            return this;
        }
    }

    function setInitial(dll, node) {
        dll.length = 1;
        dll.head = dll.tail = node;
    }

    function queue$1(worker, concurrency, payload) {
        if (concurrency == null) {
            concurrency = 1;
        }
        else if(concurrency === 0) {
            throw new RangeError('Concurrency must not be zero');
        }

        var _worker = wrapAsync(worker);
        var numRunning = 0;
        var workersList = [];
        const events = {
            error: [],
            drain: [],
            saturated: [],
            unsaturated: [],
            empty: []
        };

        function on (event, handler) {
            events[event].push(handler);
        }

        function once (event, handler) {
            const handleAndRemove = (...args) => {
                off(event, handleAndRemove);
                handler(...args);
            };
            events[event].push(handleAndRemove);
        }

        function off (event, handler) {
            if (!event) return Object.keys(events).forEach(ev => events[ev] = [])
            if (!handler) return events[event] = []
            events[event] = events[event].filter(ev => ev !== handler);
        }

        function trigger (event, ...args) {
            events[event].forEach(handler => handler(...args));
        }

        var processingScheduled = false;
        function _insert(data, insertAtFront, rejectOnError, callback) {
            if (callback != null && typeof callback !== 'function') {
                throw new Error('task callback must be a function');
            }
            q.started = true;

            var res, rej;
            function promiseCallback (err, ...args) {
                // we don't care about the error, let the global error handler
                // deal with it
                if (err) return rejectOnError ? rej(err) : res()
                if (args.length <= 1) return res(args[0])
                res(args);
            }

            var item = q._createTaskItem(
                data,
                rejectOnError ? promiseCallback :
                    (callback || promiseCallback)
            );

            if (insertAtFront) {
                q._tasks.unshift(item);
            } else {
                q._tasks.push(item);
            }

            if (!processingScheduled) {
                processingScheduled = true;
                setImmediate$1(() => {
                    processingScheduled = false;
                    q.process();
                });
            }

            if (rejectOnError || !callback) {
                return new Promise((resolve, reject) => {
                    res = resolve;
                    rej = reject;
                })
            }
        }

        function _createCB(tasks) {
            return function (err, ...args) {
                numRunning -= 1;

                for (var i = 0, l = tasks.length; i < l; i++) {
                    var task = tasks[i];

                    var index = workersList.indexOf(task);
                    if (index === 0) {
                        workersList.shift();
                    } else if (index > 0) {
                        workersList.splice(index, 1);
                    }

                    task.callback(err, ...args);

                    if (err != null) {
                        trigger('error', err, task.data);
                    }
                }

                if (numRunning <= (q.concurrency - q.buffer) ) {
                    trigger('unsaturated');
                }

                if (q.idle()) {
                    trigger('drain');
                }
                q.process();
            };
        }

        function _maybeDrain(data) {
            if (data.length === 0 && q.idle()) {
                // call drain immediately if there are no tasks
                setImmediate$1(() => trigger('drain'));
                return true
            }
            return false
        }

        const eventMethod = (name) => (handler) => {
            if (!handler) {
                return new Promise((resolve, reject) => {
                    once(name, (err, data) => {
                        if (err) return reject(err)
                        resolve(data);
                    });
                })
            }
            off(name);
            on(name, handler);

        };

        var isProcessing = false;
        var q = {
            _tasks: new DLL(),
            _createTaskItem (data, callback) {
                return {
                    data,
                    callback
                };
            },
            *[Symbol.iterator] () {
                yield* q._tasks[Symbol.iterator]();
            },
            concurrency,
            payload,
            buffer: concurrency / 4,
            started: false,
            paused: false,
            push (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, false, false, callback))
                }
                return _insert(data, false, false, callback);
            },
            pushAsync (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, false, true, callback))
                }
                return _insert(data, false, true, callback);
            },
            kill () {
                off();
                q._tasks.empty();
            },
            unshift (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, true, false, callback))
                }
                return _insert(data, true, false, callback);
            },
            unshiftAsync (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, true, true, callback))
                }
                return _insert(data, true, true, callback);
            },
            remove (testFn) {
                q._tasks.remove(testFn);
            },
            process () {
                // Avoid trying to start too many processing operations. This can occur
                // when callbacks resolve synchronously (#1267).
                if (isProcessing) {
                    return;
                }
                isProcessing = true;
                while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                    var tasks = [], data = [];
                    var l = q._tasks.length;
                    if (q.payload) l = Math.min(l, q.payload);
                    for (var i = 0; i < l; i++) {
                        var node = q._tasks.shift();
                        tasks.push(node);
                        workersList.push(node);
                        data.push(node.data);
                    }

                    numRunning += 1;

                    if (q._tasks.length === 0) {
                        trigger('empty');
                    }

                    if (numRunning === q.concurrency) {
                        trigger('saturated');
                    }

                    var cb = onlyOnce(_createCB(tasks));
                    _worker(data, cb);
                }
                isProcessing = false;
            },
            length () {
                return q._tasks.length;
            },
            running () {
                return numRunning;
            },
            workersList () {
                return workersList;
            },
            idle() {
                return q._tasks.length + numRunning === 0;
            },
            pause () {
                q.paused = true;
            },
            resume () {
                if (q.paused === false) { return; }
                q.paused = false;
                setImmediate$1(q.process);
            }
        };
        // define these as fixed properties, so people get useful errors when updating
        Object.defineProperties(q, {
            saturated: {
                writable: false,
                value: eventMethod('saturated')
            },
            unsaturated: {
                writable: false,
                value: eventMethod('unsaturated')
            },
            empty: {
                writable: false,
                value: eventMethod('empty')
            },
            drain: {
                writable: false,
                value: eventMethod('drain')
            },
            error: {
                writable: false,
                value: eventMethod('error')
            },
        });
        return q;
    }

    /**
     * Creates a `cargo` object with the specified payload. Tasks added to the
     * cargo will be processed altogether (up to the `payload` limit). If the
     * `worker` is in progress, the task is queued until it becomes available. Once
     * the `worker` has completed some tasks, each callback of those tasks is
     * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
     * for how `cargo` and `queue` work.
     *
     * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
     * at a time, cargo passes an array of tasks to a single worker, repeating
     * when the worker is finished.
     *
     * @name cargo
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.queue]{@link module:ControlFlow.queue}
     * @category Control Flow
     * @param {AsyncFunction} worker - An asynchronous function for processing an array
     * of queued tasks. Invoked with `(tasks, callback)`.
     * @param {number} [payload=Infinity] - An optional `integer` for determining
     * how many tasks should be processed per round; if omitted, the default is
     * unlimited.
     * @returns {module:ControlFlow.QueueObject} A cargo object to manage the tasks. Callbacks can
     * attached as certain properties to listen for specific events during the
     * lifecycle of the cargo and inner queue.
     * @example
     *
     * // create a cargo object with payload 2
     * var cargo = async.cargo(function(tasks, callback) {
     *     for (var i=0; i<tasks.length; i++) {
     *         console.log('hello ' + tasks[i].name);
     *     }
     *     callback();
     * }, 2);
     *
     * // add some items
     * cargo.push({name: 'foo'}, function(err) {
     *     console.log('finished processing foo');
     * });
     * cargo.push({name: 'bar'}, function(err) {
     *     console.log('finished processing bar');
     * });
     * await cargo.push({name: 'baz'});
     * console.log('finished processing baz');
     */
    function cargo$1(worker, payload) {
        return queue$1(worker, 1, payload);
    }

    /**
     * Creates a `cargoQueue` object with the specified payload. Tasks added to the
     * cargoQueue will be processed together (up to the `payload` limit) in `concurrency` parallel workers.
     * If the all `workers` are in progress, the task is queued until one becomes available. Once
     * a `worker` has completed some tasks, each callback of those tasks is
     * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
     * for how `cargo` and `queue` work.
     *
     * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
     * at a time, and [`cargo`]{@link module:ControlFlow.cargo} passes an array of tasks to a single worker,
     * the cargoQueue passes an array of tasks to multiple parallel workers.
     *
     * @name cargoQueue
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.queue]{@link module:ControlFlow.queue}
     * @see [async.cargo]{@link module:ControlFLow.cargo}
     * @category Control Flow
     * @param {AsyncFunction} worker - An asynchronous function for processing an array
     * of queued tasks. Invoked with `(tasks, callback)`.
     * @param {number} [concurrency=1] - An `integer` for determining how many
     * `worker` functions should be run in parallel.  If omitted, the concurrency
     * defaults to `1`.  If the concurrency is `0`, an error is thrown.
     * @param {number} [payload=Infinity] - An optional `integer` for determining
     * how many tasks should be processed per round; if omitted, the default is
     * unlimited.
     * @returns {module:ControlFlow.QueueObject} A cargoQueue object to manage the tasks. Callbacks can
     * attached as certain properties to listen for specific events during the
     * lifecycle of the cargoQueue and inner queue.
     * @example
     *
     * // create a cargoQueue object with payload 2 and concurrency 2
     * var cargoQueue = async.cargoQueue(function(tasks, callback) {
     *     for (var i=0; i<tasks.length; i++) {
     *         console.log('hello ' + tasks[i].name);
     *     }
     *     callback();
     * }, 2, 2);
     *
     * // add some items
     * cargoQueue.push({name: 'foo'}, function(err) {
     *     console.log('finished processing foo');
     * });
     * cargoQueue.push({name: 'bar'}, function(err) {
     *     console.log('finished processing bar');
     * });
     * cargoQueue.push({name: 'baz'}, function(err) {
     *     console.log('finished processing baz');
     * });
     * cargoQueue.push({name: 'boo'}, function(err) {
     *     console.log('finished processing boo');
     * });
     */
    function cargo(worker, concurrency, payload) {
        return queue$1(worker, concurrency, payload);
    }

    /**
     * Reduces `coll` into a single value using an async `iteratee` to return each
     * successive step. `memo` is the initial state of the reduction. This function
     * only operates in series.
     *
     * For performance reasons, it may make sense to split a call to this function
     * into a parallel map, and then use the normal `Array.prototype.reduce` on the
     * results. This function is for situations where each step in the reduction
     * needs to be async; if you can get the data before reducing it, then it's
     * probably a good idea to do so.
     *
     * @name reduce
     * @static
     * @memberOf module:Collections
     * @method
     * @alias inject
     * @alias foldl
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {*} memo - The initial state of the reduction.
     * @param {AsyncFunction} iteratee - A function applied to each item in the
     * array to produce the next step in the reduction.
     * The `iteratee` should complete with the next state of the reduction.
     * If the iteratee completes with an error, the reduction is stopped and the
     * main `callback` is immediately called with the error.
     * Invoked with (memo, item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result is the reduced value. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     * // file4.txt does not exist
     *
     * const fileList = ['file1.txt','file2.txt','file3.txt'];
     * const withMissingFileList = ['file1.txt','file2.txt','file3.txt', 'file4.txt'];
     *
     * // asynchronous function that computes the file size in bytes
     * // file size is added to the memoized value, then returned
     * function getFileSizeInBytes(memo, file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, memo + stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.reduce(fileList, 0, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // 6000
     *         // which is the sum of the file sizes of the three files
     *     }
     * });
     *
     * // Error Handling
     * async.reduce(withMissingFileList, 0, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     } else {
     *         console.log(result);
     *     }
     * });
     *
     * // Using Promises
     * async.reduce(fileList, 0, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     *     // 6000
     *     // which is the sum of the file sizes of the three files
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.reduce(withMissingFileList, 0, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.reduce(fileList, 0, getFileSizeInBytes);
     *         console.log(result);
     *         // 6000
     *         // which is the sum of the file sizes of the three files
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let result = await async.reduce(withMissingFileList, 0, getFileSizeInBytes);
     *         console.log(result);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function reduce(coll, memo, iteratee, callback) {
        callback = once(callback);
        var _iteratee = wrapAsync(iteratee);
        return eachOfSeries$1(coll, (x, i, iterCb) => {
            _iteratee(memo, x, (err, v) => {
                memo = v;
                iterCb(err);
            });
        }, err => callback(err, memo));
    }
    var reduce$1 = awaitify(reduce, 4);

    /**
     * Version of the compose function that is more natural to read. Each function
     * consumes the return value of the previous function. It is the equivalent of
     * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
     *
     * Each function is executed with the `this` binding of the composed function.
     *
     * @name seq
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.compose]{@link module:ControlFlow.compose}
     * @category Control Flow
     * @param {...AsyncFunction} functions - the asynchronous functions to compose
     * @returns {Function} a function that composes the `functions` in order
     * @example
     *
     * // Requires lodash (or underscore), express3 and dresende's orm2.
     * // Part of an app, that fetches cats of the logged user.
     * // This example uses `seq` function to avoid overnesting and error
     * // handling clutter.
     * app.get('/cats', function(request, response) {
     *     var User = request.models.User;
     *     async.seq(
     *         User.get.bind(User),  // 'User.get' has signature (id, callback(err, data))
     *         function(user, fn) {
     *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
     *         }
     *     )(req.session.user_id, function (err, cats) {
     *         if (err) {
     *             console.error(err);
     *             response.json({ status: 'error', message: err.message });
     *         } else {
     *             response.json({ status: 'ok', message: 'Cats found', data: cats });
     *         }
     *     });
     * });
     */
    function seq(...functions) {
        var _functions = functions.map(wrapAsync);
        return function (...args) {
            var that = this;

            var cb = args[args.length - 1];
            if (typeof cb == 'function') {
                args.pop();
            } else {
                cb = promiseCallback();
            }

            reduce$1(_functions, args, (newargs, fn, iterCb) => {
                fn.apply(that, newargs.concat((err, ...nextargs) => {
                    iterCb(err, nextargs);
                }));
            },
            (err, results) => cb(err, ...results));

            return cb[PROMISE_SYMBOL]
        };
    }

    /**
     * Creates a function which is a composition of the passed asynchronous
     * functions. Each function consumes the return value of the function that
     * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
     * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
     *
     * If the last argument to the composed function is not a function, a promise
     * is returned when you call it.
     *
     * Each function is executed with the `this` binding of the composed function.
     *
     * @name compose
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {...AsyncFunction} functions - the asynchronous functions to compose
     * @returns {Function} an asynchronous function that is the composed
     * asynchronous `functions`
     * @example
     *
     * function add1(n, callback) {
     *     setTimeout(function () {
     *         callback(null, n + 1);
     *     }, 10);
     * }
     *
     * function mul3(n, callback) {
     *     setTimeout(function () {
     *         callback(null, n * 3);
     *     }, 10);
     * }
     *
     * var add1mul3 = async.compose(mul3, add1);
     * add1mul3(4, function (err, result) {
     *     // result now equals 15
     * });
     */
    function compose(...args) {
        return seq(...args.reverse());
    }

    /**
     * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
     *
     * @name mapLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.map]{@link module:Collections.map}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with the transformed item.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Results is an array of the
     * transformed items from the `coll`. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapLimit (coll, limit, iteratee, callback) {
        return _asyncMap(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var mapLimit$1 = awaitify(mapLimit, 4);

    /**
     * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
     *
     * @name concatLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.concat]{@link module:Collections.concat}
     * @category Collection
     * @alias flatMapLimit
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
     * which should use an array as its result. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is an array
     * containing the concatenated results of the `iteratee` function. Invoked with
     * (err, results).
     * @returns A Promise, if no callback is passed
     */
    function concatLimit(coll, limit, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return mapLimit$1(coll, limit, (val, iterCb) => {
            _iteratee(val, (err, ...args) => {
                if (err) return iterCb(err);
                return iterCb(err, args);
            });
        }, (err, mapResults) => {
            var result = [];
            for (var i = 0; i < mapResults.length; i++) {
                if (mapResults[i]) {
                    result = result.concat(...mapResults[i]);
                }
            }

            return callback(err, result);
        });
    }
    var concatLimit$1 = awaitify(concatLimit, 4);

    /**
     * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
     * the concatenated list. The `iteratee`s are called in parallel, and the
     * results are concatenated as they return. The results array will be returned in
     * the original order of `coll` passed to the `iteratee` function.
     *
     * @name concat
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @alias flatMap
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
     * which should use an array as its result. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is an array
     * containing the concatenated results of the `iteratee` function. Invoked with
     * (err, results).
     * @returns A Promise, if no callback is passed
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * let directoryList = ['dir1','dir2','dir3'];
     * let withMissingDirectoryList = ['dir1','dir2','dir3', 'dir4'];
     *
     * // Using callbacks
     * async.concat(directoryList, fs.readdir, function(err, results) {
     *    if (err) {
     *        console.log(err);
     *    } else {
     *        console.log(results);
     *        // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
     *    }
     * });
     *
     * // Error Handling
     * async.concat(withMissingDirectoryList, fs.readdir, function(err, results) {
     *    if (err) {
     *        console.log(err);
     *        // [ Error: ENOENT: no such file or directory ]
     *        // since dir4 does not exist
     *    } else {
     *        console.log(results);
     *    }
     * });
     *
     * // Using Promises
     * async.concat(directoryList, fs.readdir)
     * .then(results => {
     *     console.log(results);
     *     // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
     * }).catch(err => {
     *      console.log(err);
     * });
     *
     * // Error Handling
     * async.concat(withMissingDirectoryList, fs.readdir)
     * .then(results => {
     *     console.log(results);
     * }).catch(err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     *     // since dir4 does not exist
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.concat(directoryList, fs.readdir);
     *         console.log(results);
     *         // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
     *     } catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let results = await async.concat(withMissingDirectoryList, fs.readdir);
     *         console.log(results);
     *     } catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *         // since dir4 does not exist
     *     }
     * }
     *
     */
    function concat(coll, iteratee, callback) {
        return concatLimit$1(coll, Infinity, iteratee, callback)
    }
    var concat$1 = awaitify(concat, 3);

    /**
     * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
     *
     * @name concatSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.concat]{@link module:Collections.concat}
     * @category Collection
     * @alias flatMapSeries
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
     * The iteratee should complete with an array an array of results.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is an array
     * containing the concatenated results of the `iteratee` function. Invoked with
     * (err, results).
     * @returns A Promise, if no callback is passed
     */
    function concatSeries(coll, iteratee, callback) {
        return concatLimit$1(coll, 1, iteratee, callback)
    }
    var concatSeries$1 = awaitify(concatSeries, 3);

    /**
     * Returns a function that when called, calls-back with the values provided.
     * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
     * [`auto`]{@link module:ControlFlow.auto}.
     *
     * @name constant
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {...*} arguments... - Any number of arguments to automatically invoke
     * callback with.
     * @returns {AsyncFunction} Returns a function that when invoked, automatically
     * invokes the callback with the previous given arguments.
     * @example
     *
     * async.waterfall([
     *     async.constant(42),
     *     function (value, next) {
     *         // value === 42
     *     },
     *     //...
     * ], callback);
     *
     * async.waterfall([
     *     async.constant(filename, "utf8"),
     *     fs.readFile,
     *     function (fileData, next) {
     *         //...
     *     }
     *     //...
     * ], callback);
     *
     * async.auto({
     *     hostname: async.constant("https://server.net/"),
     *     port: findFreePort,
     *     launchServer: ["hostname", "port", function (options, cb) {
     *         startServer(options, cb);
     *     }],
     *     //...
     * }, callback);
     */
    function constant$1(...args) {
        return function (...ignoredArgs/*, callback*/) {
            var callback = ignoredArgs.pop();
            return callback(null, ...args);
        };
    }

    function _createTester(check, getResult) {
        return (eachfn, arr, _iteratee, cb) => {
            var testPassed = false;
            var testResult;
            const iteratee = wrapAsync(_iteratee);
            eachfn(arr, (value, _, callback) => {
                iteratee(value, (err, result) => {
                    if (err || err === false) return callback(err);

                    if (check(result) && !testResult) {
                        testPassed = true;
                        testResult = getResult(true, value);
                        return callback(null, breakLoop);
                    }
                    callback();
                });
            }, err => {
                if (err) return cb(err);
                cb(null, testPassed ? testResult : getResult(false));
            });
        };
    }

    /**
     * Returns the first value in `coll` that passes an async truth test. The
     * `iteratee` is applied in parallel, meaning the first iteratee to return
     * `true` will fire the detect `callback` with that result. That means the
     * result might not be the first item in the original `coll` (in terms of order)
     * that passes the test.

     * If order within the original `coll` is important, then look at
     * [`detectSeries`]{@link module:Collections.detectSeries}.
     *
     * @name detect
     * @static
     * @memberOf module:Collections
     * @method
     * @alias find
     * @category Collections
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
     * The iteratee must complete with a boolean value as its result.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the `iteratee` functions have finished.
     * Result will be the first item in the array that passes the truth test
     * (iteratee) or the value `undefined` if none passed. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists,
     *    function(err, result) {
     *        console.log(result);
     *        // dir1/file1.txt
     *        // result now equals the first file in the list that exists
     *    }
     *);
     *
     * // Using Promises
     * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists)
     * .then(result => {
     *     console.log(result);
     *     // dir1/file1.txt
     *     // result now equals the first file in the list that exists
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists);
     *         console.log(result);
     *         // dir1/file1.txt
     *         // result now equals the file in the list that exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function detect(coll, iteratee, callback) {
        return _createTester(bool => bool, (res, item) => item)(eachOf$1, coll, iteratee, callback)
    }
    var detect$1 = awaitify(detect, 3);

    /**
     * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name detectLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.detect]{@link module:Collections.detect}
     * @alias findLimit
     * @category Collections
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
     * The iteratee must complete with a boolean value as its result.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the `iteratee` functions have finished.
     * Result will be the first item in the array that passes the truth test
     * (iteratee) or the value `undefined` if none passed. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function detectLimit(coll, limit, iteratee, callback) {
        return _createTester(bool => bool, (res, item) => item)(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var detectLimit$1 = awaitify(detectLimit, 4);

    /**
     * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
     *
     * @name detectSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.detect]{@link module:Collections.detect}
     * @alias findSeries
     * @category Collections
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
     * The iteratee must complete with a boolean value as its result.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the `iteratee` functions have finished.
     * Result will be the first item in the array that passes the truth test
     * (iteratee) or the value `undefined` if none passed. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function detectSeries(coll, iteratee, callback) {
        return _createTester(bool => bool, (res, item) => item)(eachOfLimit$2(1), coll, iteratee, callback)
    }

    var detectSeries$1 = awaitify(detectSeries, 3);

    function consoleFunc(name) {
        return (fn, ...args) => wrapAsync(fn)(...args, (err, ...resultArgs) => {
            /* istanbul ignore else */
            if (typeof console === 'object') {
                /* istanbul ignore else */
                if (err) {
                    /* istanbul ignore else */
                    if (console.error) {
                        console.error(err);
                    }
                } else if (console[name]) { /* istanbul ignore else */
                    resultArgs.forEach(x => console[name](x));
                }
            }
        })
    }

    /**
     * Logs the result of an [`async` function]{@link AsyncFunction} to the
     * `console` using `console.dir` to display the properties of the resulting object.
     * Only works in Node.js or in browsers that support `console.dir` and
     * `console.error` (such as FF and Chrome).
     * If multiple arguments are returned from the async function,
     * `console.dir` is called on each argument in order.
     *
     * @name dir
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} function - The function you want to eventually apply
     * all arguments to.
     * @param {...*} arguments... - Any number of arguments to apply to the function.
     * @example
     *
     * // in a module
     * var hello = function(name, callback) {
     *     setTimeout(function() {
     *         callback(null, {hello: name});
     *     }, 1000);
     * };
     *
     * // in the node repl
     * node> async.dir(hello, 'world');
     * {hello: 'world'}
     */
    var dir = consoleFunc('dir');

    /**
     * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
     * the order of operations, the arguments `test` and `iteratee` are switched.
     *
     * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
     *
     * @name doWhilst
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.whilst]{@link module:ControlFlow.whilst}
     * @category Control Flow
     * @param {AsyncFunction} iteratee - A function which is called each time `test`
     * passes. Invoked with (callback).
     * @param {AsyncFunction} test - asynchronous truth test to perform after each
     * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
     * non-error args from the previous callback of `iteratee`.
     * @param {Function} [callback] - A callback which is called after the test
     * function has failed and repeated execution of `iteratee` has stopped.
     * `callback` will be passed an error and any arguments passed to the final
     * `iteratee`'s callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if no callback is passed
     */
    function doWhilst(iteratee, test, callback) {
        callback = onlyOnce(callback);
        var _fn = wrapAsync(iteratee);
        var _test = wrapAsync(test);
        var results;

        function next(err, ...args) {
            if (err) return callback(err);
            if (err === false) return;
            results = args;
            _test(...args, check);
        }

        function check(err, truth) {
            if (err) return callback(err);
            if (err === false) return;
            if (!truth) return callback(null, ...results);
            _fn(next);
        }

        return check(null, true);
    }

    var doWhilst$1 = awaitify(doWhilst, 3);

    /**
     * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
     * argument ordering differs from `until`.
     *
     * @name doUntil
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
     * @category Control Flow
     * @param {AsyncFunction} iteratee - An async function which is called each time
     * `test` fails. Invoked with (callback).
     * @param {AsyncFunction} test - asynchronous truth test to perform after each
     * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
     * non-error args from the previous callback of `iteratee`
     * @param {Function} [callback] - A callback which is called after the test
     * function has passed and repeated execution of `iteratee` has stopped. `callback`
     * will be passed an error and any arguments passed to the final `iteratee`'s
     * callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if no callback is passed
     */
    function doUntil(iteratee, test, callback) {
        const _test = wrapAsync(test);
        return doWhilst$1(iteratee, (...args) => {
            const cb = args.pop();
            _test(...args, (err, truth) => cb (err, !truth));
        }, callback);
    }

    function _withoutIndex(iteratee) {
        return (value, index, callback) => iteratee(value, callback);
    }

    /**
     * Applies the function `iteratee` to each item in `coll`, in parallel.
     * The `iteratee` is called with an item from the list, and a callback for when
     * it has finished. If the `iteratee` passes an error to its `callback`, the
     * main `callback` (for the `each` function) is immediately called with the
     * error.
     *
     * Note, that since this function applies `iteratee` to each item in parallel,
     * there is no guarantee that the iteratee functions will complete in order.
     *
     * @name each
     * @static
     * @memberOf module:Collections
     * @method
     * @alias forEach
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to
     * each item in `coll`. Invoked with (item, callback).
     * The array index is not passed to the iteratee.
     * If you need the index, use `eachOf`.
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * const fileList = [ 'dir1/file2.txt', 'dir2/file3.txt', 'dir/file5.txt'];
     * const withMissingFileList = ['dir1/file1.txt', 'dir4/file2.txt'];
     *
     * // asynchronous function that deletes a file
     * const deleteFile = function(file, callback) {
     *     fs.unlink(file, callback);
     * };
     *
     * // Using callbacks
     * async.each(fileList, deleteFile, function(err) {
     *     if( err ) {
     *         console.log(err);
     *     } else {
     *         console.log('All files have been deleted successfully');
     *     }
     * });
     *
     * // Error Handling
     * async.each(withMissingFileList, deleteFile, function(err){
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     *     // since dir4/file2.txt does not exist
     *     // dir1/file1.txt could have been deleted
     * });
     *
     * // Using Promises
     * async.each(fileList, deleteFile)
     * .then( () => {
     *     console.log('All files have been deleted successfully');
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.each(fileList, deleteFile)
     * .then( () => {
     *     console.log('All files have been deleted successfully');
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     *     // since dir4/file2.txt does not exist
     *     // dir1/file1.txt could have been deleted
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         await async.each(files, deleteFile);
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         await async.each(withMissingFileList, deleteFile);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *         // since dir4/file2.txt does not exist
     *         // dir1/file1.txt could have been deleted
     *     }
     * }
     *
     */
    function eachLimit$2(coll, iteratee, callback) {
        return eachOf$1(coll, _withoutIndex(wrapAsync(iteratee)), callback);
    }

    var each = awaitify(eachLimit$2, 3);

    /**
     * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
     *
     * @name eachLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.each]{@link module:Collections.each}
     * @alias forEachLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The array index is not passed to the iteratee.
     * If you need the index, use `eachOfLimit`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachLimit(coll, limit, iteratee, callback) {
        return eachOfLimit$2(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
    }
    var eachLimit$1 = awaitify(eachLimit, 4);

    /**
     * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
     *
     * Note, that unlike [`each`]{@link module:Collections.each}, this function applies iteratee to each item
     * in series and therefore the iteratee functions will complete in order.

     * @name eachSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.each]{@link module:Collections.each}
     * @alias forEachSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each
     * item in `coll`.
     * The array index is not passed to the iteratee.
     * If you need the index, use `eachOfSeries`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachSeries(coll, iteratee, callback) {
        return eachLimit$1(coll, 1, iteratee, callback)
    }
    var eachSeries$1 = awaitify(eachSeries, 3);

    /**
     * Wrap an async function and ensure it calls its callback on a later tick of
     * the event loop.  If the function already calls its callback on a next tick,
     * no extra deferral is added. This is useful for preventing stack overflows
     * (`RangeError: Maximum call stack size exceeded`) and generally keeping
     * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
     * contained. ES2017 `async` functions are returned as-is -- they are immune
     * to Zalgo's corrupting influences, as they always resolve on a later tick.
     *
     * @name ensureAsync
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} fn - an async function, one that expects a node-style
     * callback as its last argument.
     * @returns {AsyncFunction} Returns a wrapped function with the exact same call
     * signature as the function passed in.
     * @example
     *
     * function sometimesAsync(arg, callback) {
     *     if (cache[arg]) {
     *         return callback(null, cache[arg]); // this would be synchronous!!
     *     } else {
     *         doSomeIO(arg, callback); // this IO would be asynchronous
     *     }
     * }
     *
     * // this has a risk of stack overflows if many results are cached in a row
     * async.mapSeries(args, sometimesAsync, done);
     *
     * // this will defer sometimesAsync's callback if necessary,
     * // preventing stack overflows
     * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
     */
    function ensureAsync(fn) {
        if (isAsync(fn)) return fn;
        return function (...args/*, callback*/) {
            var callback = args.pop();
            var sync = true;
            args.push((...innerArgs) => {
                if (sync) {
                    setImmediate$1(() => callback(...innerArgs));
                } else {
                    callback(...innerArgs);
                }
            });
            fn.apply(this, args);
            sync = false;
        };
    }

    /**
     * Returns `true` if every element in `coll` satisfies an async test. If any
     * iteratee call returns `false`, the main `callback` is immediately called.
     *
     * @name every
     * @static
     * @memberOf module:Collections
     * @method
     * @alias all
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collection in parallel.
     * The iteratee must complete with a boolean result value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result will be either `true` or `false`
     * depending on the values of the async tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file5.txt'];
     * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.every(fileList, fileExists, function(err, result) {
     *     console.log(result);
     *     // true
     *     // result is true since every file exists
     * });
     *
     * async.every(withMissingFileList, fileExists, function(err, result) {
     *     console.log(result);
     *     // false
     *     // result is false since NOT every file exists
     * });
     *
     * // Using Promises
     * async.every(fileList, fileExists)
     * .then( result => {
     *     console.log(result);
     *     // true
     *     // result is true since every file exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * async.every(withMissingFileList, fileExists)
     * .then( result => {
     *     console.log(result);
     *     // false
     *     // result is false since NOT every file exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.every(fileList, fileExists);
     *         console.log(result);
     *         // true
     *         // result is true since every file exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * async () => {
     *     try {
     *         let result = await async.every(withMissingFileList, fileExists);
     *         console.log(result);
     *         // false
     *         // result is false since NOT every file exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function every(coll, iteratee, callback) {
        return _createTester(bool => !bool, res => !res)(eachOf$1, coll, iteratee, callback)
    }
    var every$1 = awaitify(every, 3);

    /**
     * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
     *
     * @name everyLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.every]{@link module:Collections.every}
     * @alias allLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collection in parallel.
     * The iteratee must complete with a boolean result value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result will be either `true` or `false`
     * depending on the values of the async tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function everyLimit(coll, limit, iteratee, callback) {
        return _createTester(bool => !bool, res => !res)(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var everyLimit$1 = awaitify(everyLimit, 4);

    /**
     * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
     *
     * @name everySeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.every]{@link module:Collections.every}
     * @alias allSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collection in series.
     * The iteratee must complete with a boolean result value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result will be either `true` or `false`
     * depending on the values of the async tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function everySeries(coll, iteratee, callback) {
        return _createTester(bool => !bool, res => !res)(eachOfSeries$1, coll, iteratee, callback)
    }
    var everySeries$1 = awaitify(everySeries, 3);

    function filterArray(eachfn, arr, iteratee, callback) {
        var truthValues = new Array(arr.length);
        eachfn(arr, (x, index, iterCb) => {
            iteratee(x, (err, v) => {
                truthValues[index] = !!v;
                iterCb(err);
            });
        }, err => {
            if (err) return callback(err);
            var results = [];
            for (var i = 0; i < arr.length; i++) {
                if (truthValues[i]) results.push(arr[i]);
            }
            callback(null, results);
        });
    }

    function filterGeneric(eachfn, coll, iteratee, callback) {
        var results = [];
        eachfn(coll, (x, index, iterCb) => {
            iteratee(x, (err, v) => {
                if (err) return iterCb(err);
                if (v) {
                    results.push({index, value: x});
                }
                iterCb(err);
            });
        }, err => {
            if (err) return callback(err);
            callback(null, results
                .sort((a, b) => a.index - b.index)
                .map(v => v.value));
        });
    }

    function _filter(eachfn, coll, iteratee, callback) {
        var filter = isArrayLike(coll) ? filterArray : filterGeneric;
        return filter(eachfn, coll, wrapAsync(iteratee), callback);
    }

    /**
     * Returns a new array of all the values in `coll` which pass an async truth
     * test. This operation is performed in parallel, but the results array will be
     * in the same order as the original.
     *
     * @name filter
     * @static
     * @memberOf module:Collections
     * @method
     * @alias select
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
     * with a boolean argument once it has completed. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     *
     * const files = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.filter(files, fileExists, function(err, results) {
     *    if(err) {
     *        console.log(err);
     *    } else {
     *        console.log(results);
     *        // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
     *        // results is now an array of the existing files
     *    }
     * });
     *
     * // Using Promises
     * async.filter(files, fileExists)
     * .then(results => {
     *     console.log(results);
     *     // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
     *     // results is now an array of the existing files
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.filter(files, fileExists);
     *         console.log(results);
     *         // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
     *         // results is now an array of the existing files
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function filter (coll, iteratee, callback) {
        return _filter(eachOf$1, coll, iteratee, callback)
    }
    var filter$1 = awaitify(filter, 3);

    /**
     * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name filterLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.filter]{@link module:Collections.filter}
     * @alias selectLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
     * with a boolean argument once it has completed. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback provided
     */
    function filterLimit (coll, limit, iteratee, callback) {
        return _filter(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var filterLimit$1 = awaitify(filterLimit, 4);

    /**
     * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
     *
     * @name filterSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.filter]{@link module:Collections.filter}
     * @alias selectSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
     * with a boolean argument once it has completed. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results)
     * @returns {Promise} a promise, if no callback provided
     */
    function filterSeries (coll, iteratee, callback) {
        return _filter(eachOfSeries$1, coll, iteratee, callback)
    }
    var filterSeries$1 = awaitify(filterSeries, 3);

    /**
     * Calls the asynchronous function `fn` with a callback parameter that allows it
     * to call itself again, in series, indefinitely.

     * If an error is passed to the callback then `errback` is called with the
     * error, and execution stops, otherwise it will never be called.
     *
     * @name forever
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {AsyncFunction} fn - an async function to call repeatedly.
     * Invoked with (next).
     * @param {Function} [errback] - when `fn` passes an error to it's callback,
     * this function will be called, and execution stops. Invoked with (err).
     * @returns {Promise} a promise that rejects if an error occurs and an errback
     * is not passed
     * @example
     *
     * async.forever(
     *     function(next) {
     *         // next is suitable for passing to things that need a callback(err [, whatever]);
     *         // it will result in this function being called again.
     *     },
     *     function(err) {
     *         // if next is called with a value in its first parameter, it will appear
     *         // in here as 'err', and execution will stop.
     *     }
     * );
     */
    function forever(fn, errback) {
        var done = onlyOnce(errback);
        var task = wrapAsync(ensureAsync(fn));

        function next(err) {
            if (err) return done(err);
            if (err === false) return;
            task(next);
        }
        return next();
    }
    var forever$1 = awaitify(forever, 2);

    /**
     * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
     *
     * @name groupByLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.groupBy]{@link module:Collections.groupBy}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a `key` to group the value under.
     * Invoked with (value, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Result is an `Object` whoses
     * properties are arrays of values which returned the corresponding key.
     * @returns {Promise} a promise, if no callback is passed
     */
    function groupByLimit(coll, limit, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return mapLimit$1(coll, limit, (val, iterCb) => {
            _iteratee(val, (err, key) => {
                if (err) return iterCb(err);
                return iterCb(err, {key, val});
            });
        }, (err, mapResults) => {
            var result = {};
            // from MDN, handle object having an `hasOwnProperty` prop
            var {hasOwnProperty} = Object.prototype;

            for (var i = 0; i < mapResults.length; i++) {
                if (mapResults[i]) {
                    var {key} = mapResults[i];
                    var {val} = mapResults[i];

                    if (hasOwnProperty.call(result, key)) {
                        result[key].push(val);
                    } else {
                        result[key] = [val];
                    }
                }
            }

            return callback(err, result);
        });
    }

    var groupByLimit$1 = awaitify(groupByLimit, 4);

    /**
     * Returns a new object, where each value corresponds to an array of items, from
     * `coll`, that returned the corresponding key. That is, the keys of the object
     * correspond to the values passed to the `iteratee` callback.
     *
     * Note: Since this function applies the `iteratee` to each item in parallel,
     * there is no guarantee that the `iteratee` functions will complete in order.
     * However, the values for each key in the `result` will be in the same order as
     * the original `coll`. For Objects, the values will roughly be in the order of
     * the original Objects' keys (but this can vary across JavaScript engines).
     *
     * @name groupBy
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a `key` to group the value under.
     * Invoked with (value, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Result is an `Object` whoses
     * properties are arrays of values which returned the corresponding key.
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * const files = ['dir1/file1.txt','dir2','dir4']
     *
     * // asynchronous function that detects file type as none, file, or directory
     * function detectFile(file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(null, 'none');
     *         }
     *         callback(null, stat.isDirectory() ? 'directory' : 'file');
     *     });
     * }
     *
     * //Using callbacks
     * async.groupBy(files, detectFile, function(err, result) {
     *     if(err) {
     *         console.log(err);
     *     } else {
     *	       console.log(result);
     *         // {
     *         //     file: [ 'dir1/file1.txt' ],
     *         //     none: [ 'dir4' ],
     *         //     directory: [ 'dir2']
     *         // }
     *         // result is object containing the files grouped by type
     *     }
     * });
     *
     * // Using Promises
     * async.groupBy(files, detectFile)
     * .then( result => {
     *     console.log(result);
     *     // {
     *     //     file: [ 'dir1/file1.txt' ],
     *     //     none: [ 'dir4' ],
     *     //     directory: [ 'dir2']
     *     // }
     *     // result is object containing the files grouped by type
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.groupBy(files, detectFile);
     *         console.log(result);
     *         // {
     *         //     file: [ 'dir1/file1.txt' ],
     *         //     none: [ 'dir4' ],
     *         //     directory: [ 'dir2']
     *         // }
     *         // result is object containing the files grouped by type
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function groupBy (coll, iteratee, callback) {
        return groupByLimit$1(coll, Infinity, iteratee, callback)
    }

    /**
     * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
     *
     * @name groupBySeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.groupBy]{@link module:Collections.groupBy}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a `key` to group the value under.
     * Invoked with (value, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Result is an `Object` whose
     * properties are arrays of values which returned the corresponding key.
     * @returns {Promise} a promise, if no callback is passed
     */
    function groupBySeries (coll, iteratee, callback) {
        return groupByLimit$1(coll, 1, iteratee, callback)
    }

    /**
     * Logs the result of an `async` function to the `console`. Only works in
     * Node.js or in browsers that support `console.log` and `console.error` (such
     * as FF and Chrome). If multiple arguments are returned from the async
     * function, `console.log` is called on each argument in order.
     *
     * @name log
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} function - The function you want to eventually apply
     * all arguments to.
     * @param {...*} arguments... - Any number of arguments to apply to the function.
     * @example
     *
     * // in a module
     * var hello = function(name, callback) {
     *     setTimeout(function() {
     *         callback(null, 'hello ' + name);
     *     }, 1000);
     * };
     *
     * // in the node repl
     * node> async.log(hello, 'world');
     * 'hello world'
     */
    var log = consoleFunc('log');

    /**
     * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name mapValuesLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.mapValues]{@link module:Collections.mapValues}
     * @category Collection
     * @param {Object} obj - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - A function to apply to each value and key
     * in `coll`.
     * The iteratee should complete with the transformed value as its result.
     * Invoked with (value, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. `result` is a new object consisting
     * of each key from `obj`, with each transformed value on the right-hand side.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapValuesLimit(obj, limit, iteratee, callback) {
        callback = once(callback);
        var newObj = {};
        var _iteratee = wrapAsync(iteratee);
        return eachOfLimit$2(limit)(obj, (val, key, next) => {
            _iteratee(val, key, (err, result) => {
                if (err) return next(err);
                newObj[key] = result;
                next(err);
            });
        }, err => callback(err, newObj));
    }

    var mapValuesLimit$1 = awaitify(mapValuesLimit, 4);

    /**
     * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
     *
     * Produces a new Object by mapping each value of `obj` through the `iteratee`
     * function. The `iteratee` is called each `value` and `key` from `obj` and a
     * callback for when it has finished processing. Each of these callbacks takes
     * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
     * passes an error to its callback, the main `callback` (for the `mapValues`
     * function) is immediately called with the error.
     *
     * Note, the order of the keys in the result is not guaranteed.  The keys will
     * be roughly in the order they complete, (but this is very engine-specific)
     *
     * @name mapValues
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Object} obj - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each value and key
     * in `coll`.
     * The iteratee should complete with the transformed value as its result.
     * Invoked with (value, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. `result` is a new object consisting
     * of each key from `obj`, with each transformed value on the right-hand side.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     * // file4.txt does not exist
     *
     * const fileMap = {
     *     f1: 'file1.txt',
     *     f2: 'file2.txt',
     *     f3: 'file3.txt'
     * };
     *
     * const withMissingFileMap = {
     *     f1: 'file1.txt',
     *     f2: 'file2.txt',
     *     f3: 'file4.txt'
     * };
     *
     * // asynchronous function that returns the file size in bytes
     * function getFileSizeInBytes(file, key, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.mapValues(fileMap, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // result is now a map of file size in bytes for each file, e.g.
     *         // {
     *         //     f1: 1000,
     *         //     f2: 2000,
     *         //     f3: 3000
     *         // }
     *     }
     * });
     *
     * // Error handling
     * async.mapValues(withMissingFileMap, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     } else {
     *         console.log(result);
     *     }
     * });
     *
     * // Using Promises
     * async.mapValues(fileMap, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     *     // result is now a map of file size in bytes for each file, e.g.
     *     // {
     *     //     f1: 1000,
     *     //     f2: 2000,
     *     //     f3: 3000
     *     // }
     * }).catch (err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.mapValues(withMissingFileMap, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     * }).catch (err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.mapValues(fileMap, getFileSizeInBytes);
     *         console.log(result);
     *         // result is now a map of file size in bytes for each file, e.g.
     *         // {
     *         //     f1: 1000,
     *         //     f2: 2000,
     *         //     f3: 3000
     *         // }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let result = await async.mapValues(withMissingFileMap, getFileSizeInBytes);
     *         console.log(result);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function mapValues(obj, iteratee, callback) {
        return mapValuesLimit$1(obj, Infinity, iteratee, callback)
    }

    /**
     * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
     *
     * @name mapValuesSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.mapValues]{@link module:Collections.mapValues}
     * @category Collection
     * @param {Object} obj - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each value and key
     * in `coll`.
     * The iteratee should complete with the transformed value as its result.
     * Invoked with (value, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. `result` is a new object consisting
     * of each key from `obj`, with each transformed value on the right-hand side.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapValuesSeries(obj, iteratee, callback) {
        return mapValuesLimit$1(obj, 1, iteratee, callback)
    }

    /**
     * Caches the results of an async function. When creating a hash to store
     * function results against, the callback is omitted from the hash and an
     * optional hash function can be used.
     *
     * **Note: if the async function errs, the result will not be cached and
     * subsequent calls will call the wrapped function.**
     *
     * If no hash function is specified, the first argument is used as a hash key,
     * which may work reasonably if it is a string or a data type that converts to a
     * distinct string. Note that objects and arrays will not behave reasonably.
     * Neither will cases where the other arguments are significant. In such cases,
     * specify your own hash function.
     *
     * The cache of results is exposed as the `memo` property of the function
     * returned by `memoize`.
     *
     * @name memoize
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} fn - The async function to proxy and cache results from.
     * @param {Function} hasher - An optional function for generating a custom hash
     * for storing results. It has all the arguments applied to it apart from the
     * callback, and must be synchronous.
     * @returns {AsyncFunction} a memoized version of `fn`
     * @example
     *
     * var slow_fn = function(name, callback) {
     *     // do something
     *     callback(null, result);
     * };
     * var fn = async.memoize(slow_fn);
     *
     * // fn can now be used as if it were slow_fn
     * fn('some name', function() {
     *     // callback
     * });
     */
    function memoize(fn, hasher = v => v) {
        var memo = Object.create(null);
        var queues = Object.create(null);
        var _fn = wrapAsync(fn);
        var memoized = initialParams((args, callback) => {
            var key = hasher(...args);
            if (key in memo) {
                setImmediate$1(() => callback(null, ...memo[key]));
            } else if (key in queues) {
                queues[key].push(callback);
            } else {
                queues[key] = [callback];
                _fn(...args, (err, ...resultArgs) => {
                    // #1465 don't memoize if an error occurred
                    if (!err) {
                        memo[key] = resultArgs;
                    }
                    var q = queues[key];
                    delete queues[key];
                    for (var i = 0, l = q.length; i < l; i++) {
                        q[i](err, ...resultArgs);
                    }
                });
            }
        });
        memoized.memo = memo;
        memoized.unmemoized = fn;
        return memoized;
    }

    /* istanbul ignore file */

    /**
     * Calls `callback` on a later loop around the event loop. In Node.js this just
     * calls `process.nextTick`.  In the browser it will use `setImmediate` if
     * available, otherwise `setTimeout(callback, 0)`, which means other higher
     * priority events may precede the execution of `callback`.
     *
     * This is used internally for browser-compatibility purposes.
     *
     * @name nextTick
     * @static
     * @memberOf module:Utils
     * @method
     * @see [async.setImmediate]{@link module:Utils.setImmediate}
     * @category Util
     * @param {Function} callback - The function to call on a later loop around
     * the event loop. Invoked with (args...).
     * @param {...*} args... - any number of additional arguments to pass to the
     * callback on the next tick.
     * @example
     *
     * var call_order = [];
     * async.nextTick(function() {
     *     call_order.push('two');
     *     // call_order now equals ['one','two']
     * });
     * call_order.push('one');
     *
     * async.setImmediate(function (a, b, c) {
     *     // a, b, and c equal 1, 2, and 3
     * }, 1, 2, 3);
     */
    var _defer;

    if (hasNextTick) {
        _defer = process.nextTick;
    } else if (hasSetImmediate) {
        _defer = setImmediate;
    } else {
        _defer = fallback;
    }

    var nextTick = wrap(_defer);

    var _parallel = awaitify((eachfn, tasks, callback) => {
        var results = isArrayLike(tasks) ? [] : {};

        eachfn(tasks, (task, key, taskCb) => {
            wrapAsync(task)((err, ...result) => {
                if (result.length < 2) {
                    [result] = result;
                }
                results[key] = result;
                taskCb(err);
            });
        }, err => callback(err, results));
    }, 3);

    /**
     * Run the `tasks` collection of functions in parallel, without waiting until
     * the previous function has completed. If any of the functions pass an error to
     * its callback, the main `callback` is immediately called with the value of the
     * error. Once the `tasks` have completed, the results are passed to the final
     * `callback` as an array.
     *
     * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
     * parallel execution of code.  If your tasks do not use any timers or perform
     * any I/O, they will actually be executed in series.  Any synchronous setup
     * sections for each task will happen one after the other.  JavaScript remains
     * single-threaded.
     *
     * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
     * execution of other tasks when a task fails.
     *
     * It is also possible to use an object instead of an array. Each property will
     * be run as a function and the results will be passed to the final `callback`
     * as an object instead of an array. This can be a more readable way of handling
     * results from {@link async.parallel}.
     *
     * @name parallel
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
     * [async functions]{@link AsyncFunction} to run.
     * Each async function can complete with any number of optional `result` values.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed successfully. This function gets a results array
     * (or object) containing all the result arguments passed to the task callbacks.
     * Invoked with (err, results).
     * @returns {Promise} a promise, if a callback is not passed
     *
     * @example
     *
     * //Using Callbacks
     * async.parallel([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ], function(err, results) {
     *     console.log(results);
     *     // results is equal to ['one','two'] even though
     *     // the second function had a shorter timeout.
     * });
     *
     * // an example using an object instead of an array
     * async.parallel({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }, function(err, results) {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * });
     *
     * //Using Promises
     * async.parallel([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ]).then(results => {
     *     console.log(results);
     *     // results is equal to ['one','two'] even though
     *     // the second function had a shorter timeout.
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // an example using an object instead of an array
     * async.parallel({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }).then(results => {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * //Using async/await
     * async () => {
     *     try {
     *         let results = await async.parallel([
     *             function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 'one');
     *                 }, 200);
     *             },
     *             function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 'two');
     *                 }, 100);
     *             }
     *         ]);
     *         console.log(results);
     *         // results is equal to ['one','two'] even though
     *         // the second function had a shorter timeout.
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // an example using an object instead of an array
     * async () => {
     *     try {
     *         let results = await async.parallel({
     *             one: function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 1);
     *                 }, 200);
     *             },
     *            two: function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 2);
     *                 }, 100);
     *            }
     *         });
     *         console.log(results);
     *         // results is equal to: { one: 1, two: 2 }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function parallel(tasks, callback) {
        return _parallel(eachOf$1, tasks, callback);
    }

    /**
     * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name parallelLimit
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.parallel]{@link module:ControlFlow.parallel}
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
     * [async functions]{@link AsyncFunction} to run.
     * Each async function can complete with any number of optional `result` values.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed successfully. This function gets a results array
     * (or object) containing all the result arguments passed to the task callbacks.
     * Invoked with (err, results).
     * @returns {Promise} a promise, if a callback is not passed
     */
    function parallelLimit(tasks, limit, callback) {
        return _parallel(eachOfLimit$2(limit), tasks, callback);
    }

    /**
     * A queue of tasks for the worker function to complete.
     * @typedef {Iterable} QueueObject
     * @memberOf module:ControlFlow
     * @property {Function} length - a function returning the number of items
     * waiting to be processed. Invoke with `queue.length()`.
     * @property {boolean} started - a boolean indicating whether or not any
     * items have been pushed and processed by the queue.
     * @property {Function} running - a function returning the number of items
     * currently being processed. Invoke with `queue.running()`.
     * @property {Function} workersList - a function returning the array of items
     * currently being processed. Invoke with `queue.workersList()`.
     * @property {Function} idle - a function returning false if there are items
     * waiting or being processed, or true if not. Invoke with `queue.idle()`.
     * @property {number} concurrency - an integer for determining how many `worker`
     * functions should be run in parallel. This property can be changed after a
     * `queue` is created to alter the concurrency on-the-fly.
     * @property {number} payload - an integer that specifies how many items are
     * passed to the worker function at a time. only applies if this is a
     * [cargo]{@link module:ControlFlow.cargo} object
     * @property {AsyncFunction} push - add a new task to the `queue`. Calls `callback`
     * once the `worker` has finished processing the task. Instead of a single task,
     * a `tasks` array can be submitted. The respective callback is used for every
     * task in the list. Invoke with `queue.push(task, [callback])`,
     * @property {AsyncFunction} unshift - add a new task to the front of the `queue`.
     * Invoke with `queue.unshift(task, [callback])`.
     * @property {AsyncFunction} pushAsync - the same as `q.push`, except this returns
     * a promise that rejects if an error occurs.
     * @property {AsyncFunction} unshiftAsync - the same as `q.unshift`, except this returns
     * a promise that rejects if an error occurs.
     * @property {Function} remove - remove items from the queue that match a test
     * function.  The test function will be passed an object with a `data` property,
     * and a `priority` property, if this is a
     * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
     * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
     * `function ({data, priority}) {}` and returns a Boolean.
     * @property {Function} saturated - a function that sets a callback that is
     * called when the number of running workers hits the `concurrency` limit, and
     * further tasks will be queued.  If the callback is omitted, `q.saturated()`
     * returns a promise for the next occurrence.
     * @property {Function} unsaturated - a function that sets a callback that is
     * called when the number of running workers is less than the `concurrency` &
     * `buffer` limits, and further tasks will not be queued. If the callback is
     * omitted, `q.unsaturated()` returns a promise for the next occurrence.
     * @property {number} buffer - A minimum threshold buffer in order to say that
     * the `queue` is `unsaturated`.
     * @property {Function} empty - a function that sets a callback that is called
     * when the last item from the `queue` is given to a `worker`. If the callback
     * is omitted, `q.empty()` returns a promise for the next occurrence.
     * @property {Function} drain - a function that sets a callback that is called
     * when the last item from the `queue` has returned from the `worker`. If the
     * callback is omitted, `q.drain()` returns a promise for the next occurrence.
     * @property {Function} error - a function that sets a callback that is called
     * when a task errors. Has the signature `function(error, task)`. If the
     * callback is omitted, `error()` returns a promise that rejects on the next
     * error.
     * @property {boolean} paused - a boolean for determining whether the queue is
     * in a paused state.
     * @property {Function} pause - a function that pauses the processing of tasks
     * until `resume()` is called. Invoke with `queue.pause()`.
     * @property {Function} resume - a function that resumes the processing of
     * queued tasks when the queue is paused. Invoke with `queue.resume()`.
     * @property {Function} kill - a function that removes the `drain` callback and
     * empties remaining tasks from the queue forcing it to go idle. No more tasks
     * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
     *
     * @example
     * const q = async.queue(worker, 2)
     * q.push(item1)
     * q.push(item2)
     * q.push(item3)
     * // queues are iterable, spread into an array to inspect
     * const items = [...q] // [item1, item2, item3]
     * // or use for of
     * for (let item of q) {
     *     console.log(item)
     * }
     *
     * q.drain(() => {
     *     console.log('all done')
     * })
     * // or
     * await q.drain()
     */

    /**
     * Creates a `queue` object with the specified `concurrency`. Tasks added to the
     * `queue` are processed in parallel (up to the `concurrency` limit). If all
     * `worker`s are in progress, the task is queued until one becomes available.
     * Once a `worker` completes a `task`, that `task`'s callback is called.
     *
     * @name queue
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {AsyncFunction} worker - An async function for processing a queued task.
     * If you want to handle errors from an individual task, pass a callback to
     * `q.push()`. Invoked with (task, callback).
     * @param {number} [concurrency=1] - An `integer` for determining how many
     * `worker` functions should be run in parallel.  If omitted, the concurrency
     * defaults to `1`.  If the concurrency is `0`, an error is thrown.
     * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can be
     * attached as certain properties to listen for specific events during the
     * lifecycle of the queue.
     * @example
     *
     * // create a queue object with concurrency 2
     * var q = async.queue(function(task, callback) {
     *     console.log('hello ' + task.name);
     *     callback();
     * }, 2);
     *
     * // assign a callback
     * q.drain(function() {
     *     console.log('all items have been processed');
     * });
     * // or await the end
     * await q.drain()
     *
     * // assign an error callback
     * q.error(function(err, task) {
     *     console.error('task experienced an error');
     * });
     *
     * // add some items to the queue
     * q.push({name: 'foo'}, function(err) {
     *     console.log('finished processing foo');
     * });
     * // callback is optional
     * q.push({name: 'bar'});
     *
     * // add some items to the queue (batch-wise)
     * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
     *     console.log('finished processing item');
     * });
     *
     * // add some items to the front of the queue
     * q.unshift({name: 'bar'}, function (err) {
     *     console.log('finished processing bar');
     * });
     */
    function queue (worker, concurrency) {
        var _worker = wrapAsync(worker);
        return queue$1((items, cb) => {
            _worker(items[0], cb);
        }, concurrency, 1);
    }

    // Binary min-heap implementation used for priority queue.
    // Implementation is stable, i.e. push time is considered for equal priorities
    class Heap {
        constructor() {
            this.heap = [];
            this.pushCount = Number.MIN_SAFE_INTEGER;
        }

        get length() {
            return this.heap.length;
        }

        empty () {
            this.heap = [];
            return this;
        }

        percUp(index) {
            let p;

            while (index > 0 && smaller(this.heap[index], this.heap[p=parent(index)])) {
                let t = this.heap[index];
                this.heap[index] = this.heap[p];
                this.heap[p] = t;

                index = p;
            }
        }

        percDown(index) {
            let l;

            while ((l=leftChi(index)) < this.heap.length) {
                if (l+1 < this.heap.length && smaller(this.heap[l+1], this.heap[l])) {
                    l = l+1;
                }

                if (smaller(this.heap[index], this.heap[l])) {
                    break;
                }

                let t = this.heap[index];
                this.heap[index] = this.heap[l];
                this.heap[l] = t;

                index = l;
            }
        }

        push(node) {
            node.pushCount = ++this.pushCount;
            this.heap.push(node);
            this.percUp(this.heap.length-1);
        }

        unshift(node) {
            return this.heap.push(node);
        }

        shift() {
            let [top] = this.heap;

            this.heap[0] = this.heap[this.heap.length-1];
            this.heap.pop();
            this.percDown(0);

            return top;
        }

        toArray() {
            return [...this];
        }

        *[Symbol.iterator] () {
            for (let i = 0; i < this.heap.length; i++) {
                yield this.heap[i].data;
            }
        }

        remove (testFn) {
            let j = 0;
            for (let i = 0; i < this.heap.length; i++) {
                if (!testFn(this.heap[i])) {
                    this.heap[j] = this.heap[i];
                    j++;
                }
            }

            this.heap.splice(j);

            for (let i = parent(this.heap.length-1); i >= 0; i--) {
                this.percDown(i);
            }

            return this;
        }
    }

    function leftChi(i) {
        return (i<<1)+1;
    }

    function parent(i) {
        return ((i+1)>>1)-1;
    }

    function smaller(x, y) {
        if (x.priority !== y.priority) {
            return x.priority < y.priority;
        }
        else {
            return x.pushCount < y.pushCount;
        }
    }

    /**
     * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
     * completed in ascending priority order.
     *
     * @name priorityQueue
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.queue]{@link module:ControlFlow.queue}
     * @category Control Flow
     * @param {AsyncFunction} worker - An async function for processing a queued task.
     * If you want to handle errors from an individual task, pass a callback to
     * `q.push()`.
     * Invoked with (task, callback).
     * @param {number} concurrency - An `integer` for determining how many `worker`
     * functions should be run in parallel.  If omitted, the concurrency defaults to
     * `1`.  If the concurrency is `0`, an error is thrown.
     * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are three
     * differences between `queue` and `priorityQueue` objects:
     * * `push(task, priority, [callback])` - `priority` should be a number. If an
     *   array of `tasks` is given, all tasks will be assigned the same priority.
     * * `pushAsync(task, priority, [callback])` - the same as `priorityQueue.push`,
     *   except this returns a promise that rejects if an error occurs.
     * * The `unshift` and `unshiftAsync` methods were removed.
     */
    function priorityQueue(worker, concurrency) {
        // Start with a normal queue
        var q = queue(worker, concurrency);

        var {
            push,
            pushAsync
        } = q;

        q._tasks = new Heap();
        q._createTaskItem = ({data, priority}, callback) => {
            return {
                data,
                priority,
                callback
            };
        };

        function createDataItems(tasks, priority) {
            if (!Array.isArray(tasks)) {
                return {data: tasks, priority};
            }
            return tasks.map(data => { return {data, priority}; });
        }

        // Override push to accept second parameter representing priority
        q.push = function(data, priority = 0, callback) {
            return push(createDataItems(data, priority), callback);
        };

        q.pushAsync = function(data, priority = 0, callback) {
            return pushAsync(createDataItems(data, priority), callback);
        };

        // Remove unshift functions
        delete q.unshift;
        delete q.unshiftAsync;

        return q;
    }

    /**
     * Runs the `tasks` array of functions in parallel, without waiting until the
     * previous function has completed. Once any of the `tasks` complete or pass an
     * error to its callback, the main `callback` is immediately called. It's
     * equivalent to `Promise.race()`.
     *
     * @name race
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
     * to run. Each function can complete with an optional `result` value.
     * @param {Function} callback - A callback to run once any of the functions have
     * completed. This function gets an error or result from the first function that
     * completed. Invoked with (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * async.race([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ],
     * // main callback
     * function(err, result) {
     *     // the result will be equal to 'two' as it finishes earlier
     * });
     */
    function race(tasks, callback) {
        callback = once(callback);
        if (!Array.isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
        if (!tasks.length) return callback();
        for (var i = 0, l = tasks.length; i < l; i++) {
            wrapAsync(tasks[i])(callback);
        }
    }

    var race$1 = awaitify(race, 2);

    /**
     * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
     *
     * @name reduceRight
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.reduce]{@link module:Collections.reduce}
     * @alias foldr
     * @category Collection
     * @param {Array} array - A collection to iterate over.
     * @param {*} memo - The initial state of the reduction.
     * @param {AsyncFunction} iteratee - A function applied to each item in the
     * array to produce the next step in the reduction.
     * The `iteratee` should complete with the next state of the reduction.
     * If the iteratee completes with an error, the reduction is stopped and the
     * main `callback` is immediately called with the error.
     * Invoked with (memo, item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result is the reduced value. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if no callback is passed
     */
    function reduceRight (array, memo, iteratee, callback) {
        var reversed = [...array].reverse();
        return reduce$1(reversed, memo, iteratee, callback);
    }

    /**
     * Wraps the async function in another function that always completes with a
     * result object, even when it errors.
     *
     * The result object has either the property `error` or `value`.
     *
     * @name reflect
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} fn - The async function you want to wrap
     * @returns {Function} - A function that always passes null to it's callback as
     * the error. The second argument to the callback will be an `object` with
     * either an `error` or a `value` property.
     * @example
     *
     * async.parallel([
     *     async.reflect(function(callback) {
     *         // do some stuff ...
     *         callback(null, 'one');
     *     }),
     *     async.reflect(function(callback) {
     *         // do some more stuff but error ...
     *         callback('bad stuff happened');
     *     }),
     *     async.reflect(function(callback) {
     *         // do some more stuff ...
     *         callback(null, 'two');
     *     })
     * ],
     * // optional callback
     * function(err, results) {
     *     // values
     *     // results[0].value = 'one'
     *     // results[1].error = 'bad stuff happened'
     *     // results[2].value = 'two'
     * });
     */
    function reflect(fn) {
        var _fn = wrapAsync(fn);
        return initialParams(function reflectOn(args, reflectCallback) {
            args.push((error, ...cbArgs) => {
                let retVal = {};
                if (error) {
                    retVal.error = error;
                }
                if (cbArgs.length > 0){
                    var value = cbArgs;
                    if (cbArgs.length <= 1) {
                        [value] = cbArgs;
                    }
                    retVal.value = value;
                }
                reflectCallback(null, retVal);
            });

            return _fn.apply(this, args);
        });
    }

    /**
     * A helper function that wraps an array or an object of functions with `reflect`.
     *
     * @name reflectAll
     * @static
     * @memberOf module:Utils
     * @method
     * @see [async.reflect]{@link module:Utils.reflect}
     * @category Util
     * @param {Array|Object|Iterable} tasks - The collection of
     * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
     * @returns {Array} Returns an array of async functions, each wrapped in
     * `async.reflect`
     * @example
     *
     * let tasks = [
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         // do some more stuff but error ...
     *         callback(new Error('bad stuff happened'));
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ];
     *
     * async.parallel(async.reflectAll(tasks),
     * // optional callback
     * function(err, results) {
     *     // values
     *     // results[0].value = 'one'
     *     // results[1].error = Error('bad stuff happened')
     *     // results[2].value = 'two'
     * });
     *
     * // an example using an object instead of an array
     * let tasks = {
     *     one: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         callback('two');
     *     },
     *     three: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'three');
     *         }, 100);
     *     }
     * };
     *
     * async.parallel(async.reflectAll(tasks),
     * // optional callback
     * function(err, results) {
     *     // values
     *     // results.one.value = 'one'
     *     // results.two.error = 'two'
     *     // results.three.value = 'three'
     * });
     */
    function reflectAll(tasks) {
        var results;
        if (Array.isArray(tasks)) {
            results = tasks.map(reflect);
        } else {
            results = {};
            Object.keys(tasks).forEach(key => {
                results[key] = reflect.call(this, tasks[key]);
            });
        }
        return results;
    }

    function reject$2(eachfn, arr, _iteratee, callback) {
        const iteratee = wrapAsync(_iteratee);
        return _filter(eachfn, arr, (value, cb) => {
            iteratee(value, (err, v) => {
                cb(err, !v);
            });
        }, callback);
    }

    /**
     * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
     *
     * @name reject
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.filter]{@link module:Collections.filter}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - An async truth test to apply to each item in
     * `coll`.
     * The should complete with a boolean value as its `result`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     *
     * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.reject(fileList, fileExists, function(err, results) {
     *    // [ 'dir3/file6.txt' ]
     *    // results now equals an array of the non-existing files
     * });
     *
     * // Using Promises
     * async.reject(fileList, fileExists)
     * .then( results => {
     *     console.log(results);
     *     // [ 'dir3/file6.txt' ]
     *     // results now equals an array of the non-existing files
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.reject(fileList, fileExists);
     *         console.log(results);
     *         // [ 'dir3/file6.txt' ]
     *         // results now equals an array of the non-existing files
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function reject (coll, iteratee, callback) {
        return reject$2(eachOf$1, coll, iteratee, callback)
    }
    var reject$1 = awaitify(reject, 3);

    /**
     * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name rejectLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.reject]{@link module:Collections.reject}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {Function} iteratee - An async truth test to apply to each item in
     * `coll`.
     * The should complete with a boolean value as its `result`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function rejectLimit (coll, limit, iteratee, callback) {
        return reject$2(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var rejectLimit$1 = awaitify(rejectLimit, 4);

    /**
     * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
     *
     * @name rejectSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.reject]{@link module:Collections.reject}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - An async truth test to apply to each item in
     * `coll`.
     * The should complete with a boolean value as its `result`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function rejectSeries (coll, iteratee, callback) {
        return reject$2(eachOfSeries$1, coll, iteratee, callback)
    }
    var rejectSeries$1 = awaitify(rejectSeries, 3);

    function constant(value) {
        return function () {
            return value;
        }
    }

    /**
     * Attempts to get a successful response from `task` no more than `times` times
     * before returning an error. If the task is successful, the `callback` will be
     * passed the result of the successful task. If all attempts fail, the callback
     * will be passed the error and result (if any) of the final attempt.
     *
     * @name retry
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @see [async.retryable]{@link module:ControlFlow.retryable}
     * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
     * object with `times` and `interval` or a number.
     * * `times` - The number of attempts to make before giving up.  The default
     *   is `5`.
     * * `interval` - The time to wait between retries, in milliseconds.  The
     *   default is `0`. The interval may also be specified as a function of the
     *   retry count (see example).
     * * `errorFilter` - An optional synchronous function that is invoked on
     *   erroneous result. If it returns `true` the retry attempts will continue;
     *   if the function returns `false` the retry flow is aborted with the current
     *   attempt's error and result being returned to the final callback.
     *   Invoked with (err).
     * * If `opts` is a number, the number specifies the number of times to retry,
     *   with the default interval of `0`.
     * @param {AsyncFunction} task - An async function to retry.
     * Invoked with (callback).
     * @param {Function} [callback] - An optional callback which is called when the
     * task has succeeded, or after the final failed attempt. It receives the `err`
     * and `result` arguments of the last attempt at completing the `task`. Invoked
     * with (err, results).
     * @returns {Promise} a promise if no callback provided
     *
     * @example
     *
     * // The `retry` function can be used as a stand-alone control flow by passing
     * // a callback, as shown below:
     *
     * // try calling apiMethod 3 times
     * async.retry(3, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod 3 times, waiting 200 ms between each retry
     * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod 10 times with exponential backoff
     * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
     * async.retry({
     *   times: 10,
     *   interval: function(retryCount) {
     *     return 50 * Math.pow(2, retryCount);
     *   }
     * }, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod the default 5 times no delay between each retry
     * async.retry(apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod only when error condition satisfies, all other
     * // errors will abort the retry control flow and return to final callback
     * async.retry({
     *   errorFilter: function(err) {
     *     return err.message === 'Temporary error'; // only retry on a specific error
     *   }
     * }, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // to retry individual methods that are not as reliable within other
     * // control flow functions, use the `retryable` wrapper:
     * async.auto({
     *     users: api.getUsers.bind(api),
     *     payments: async.retryable(3, api.getPayments.bind(api))
     * }, function(err, results) {
     *     // do something with the results
     * });
     *
     */
    const DEFAULT_TIMES = 5;
    const DEFAULT_INTERVAL = 0;

    function retry(opts, task, callback) {
        var options = {
            times: DEFAULT_TIMES,
            intervalFunc: constant(DEFAULT_INTERVAL)
        };

        if (arguments.length < 3 && typeof opts === 'function') {
            callback = task || promiseCallback();
            task = opts;
        } else {
            parseTimes(options, opts);
            callback = callback || promiseCallback();
        }

        if (typeof task !== 'function') {
            throw new Error("Invalid arguments for async.retry");
        }

        var _task = wrapAsync(task);

        var attempt = 1;
        function retryAttempt() {
            _task((err, ...args) => {
                if (err === false) return
                if (err && attempt++ < options.times &&
                    (typeof options.errorFilter != 'function' ||
                        options.errorFilter(err))) {
                    setTimeout(retryAttempt, options.intervalFunc(attempt - 1));
                } else {
                    callback(err, ...args);
                }
            });
        }

        retryAttempt();
        return callback[PROMISE_SYMBOL]
    }

    function parseTimes(acc, t) {
        if (typeof t === 'object') {
            acc.times = +t.times || DEFAULT_TIMES;

            acc.intervalFunc = typeof t.interval === 'function' ?
                t.interval :
                constant(+t.interval || DEFAULT_INTERVAL);

            acc.errorFilter = t.errorFilter;
        } else if (typeof t === 'number' || typeof t === 'string') {
            acc.times = +t || DEFAULT_TIMES;
        } else {
            throw new Error("Invalid arguments for async.retry");
        }
    }

    /**
     * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
     * wraps a task and makes it retryable, rather than immediately calling it
     * with retries.
     *
     * @name retryable
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.retry]{@link module:ControlFlow.retry}
     * @category Control Flow
     * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
     * options, exactly the same as from `retry`, except for a `opts.arity` that
     * is the arity of the `task` function, defaulting to `task.length`
     * @param {AsyncFunction} task - the asynchronous function to wrap.
     * This function will be passed any arguments passed to the returned wrapper.
     * Invoked with (...args, callback).
     * @returns {AsyncFunction} The wrapped function, which when invoked, will
     * retry on an error, based on the parameters specified in `opts`.
     * This function will accept the same parameters as `task`.
     * @example
     *
     * async.auto({
     *     dep1: async.retryable(3, getFromFlakyService),
     *     process: ["dep1", async.retryable(3, function (results, cb) {
     *         maybeProcessData(results.dep1, cb);
     *     })]
     * }, callback);
     */
    function retryable (opts, task) {
        if (!task) {
            task = opts;
            opts = null;
        }
        let arity = (opts && opts.arity) || task.length;
        if (isAsync(task)) {
            arity += 1;
        }
        var _task = wrapAsync(task);
        return initialParams((args, callback) => {
            if (args.length < arity - 1 || callback == null) {
                args.push(callback);
                callback = promiseCallback();
            }
            function taskFn(cb) {
                _task(...args, cb);
            }

            if (opts) retry(opts, taskFn, callback);
            else retry(taskFn, callback);

            return callback[PROMISE_SYMBOL]
        });
    }

    /**
     * Run the functions in the `tasks` collection in series, each one running once
     * the previous function has completed. If any functions in the series pass an
     * error to its callback, no more functions are run, and `callback` is
     * immediately called with the value of the error. Otherwise, `callback`
     * receives an array of results when `tasks` have completed.
     *
     * It is also possible to use an object instead of an array. Each property will
     * be run as a function, and the results will be passed to the final `callback`
     * as an object instead of an array. This can be a more readable way of handling
     *  results from {@link async.series}.
     *
     * **Note** that while many implementations preserve the order of object
     * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
     * explicitly states that
     *
     * > The mechanics and order of enumerating the properties is not specified.
     *
     * So if you rely on the order in which your series of functions are executed,
     * and want this to work on all platforms, consider using an array.
     *
     * @name series
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
     * [async functions]{@link AsyncFunction} to run in series.
     * Each function can complete with any number of optional `result` values.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed. This function gets a results array (or object)
     * containing all the result arguments passed to the `task` callbacks. Invoked
     * with (err, result).
     * @return {Promise} a promise, if no callback is passed
     * @example
     *
     * //Using Callbacks
     * async.series([
     *     function(callback) {
     *         setTimeout(function() {
     *             // do some async task
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             // then do another async task
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ], function(err, results) {
     *     console.log(results);
     *     // results is equal to ['one','two']
     * });
     *
     * // an example using objects instead of arrays
     * async.series({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             // do some async task
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             // then do another async task
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }, function(err, results) {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * });
     *
     * //Using Promises
     * async.series([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ]).then(results => {
     *     console.log(results);
     *     // results is equal to ['one','two']
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // an example using an object instead of an array
     * async.series({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             // do some async task
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             // then do another async task
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }).then(results => {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * //Using async/await
     * async () => {
     *     try {
     *         let results = await async.series([
     *             function(callback) {
     *                 setTimeout(function() {
     *                     // do some async task
     *                     callback(null, 'one');
     *                 }, 200);
     *             },
     *             function(callback) {
     *                 setTimeout(function() {
     *                     // then do another async task
     *                     callback(null, 'two');
     *                 }, 100);
     *             }
     *         ]);
     *         console.log(results);
     *         // results is equal to ['one','two']
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // an example using an object instead of an array
     * async () => {
     *     try {
     *         let results = await async.parallel({
     *             one: function(callback) {
     *                 setTimeout(function() {
     *                     // do some async task
     *                     callback(null, 1);
     *                 }, 200);
     *             },
     *            two: function(callback) {
     *                 setTimeout(function() {
     *                     // then do another async task
     *                     callback(null, 2);
     *                 }, 100);
     *            }
     *         });
     *         console.log(results);
     *         // results is equal to: { one: 1, two: 2 }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function series(tasks, callback) {
        return _parallel(eachOfSeries$1, tasks, callback);
    }

    /**
     * Returns `true` if at least one element in the `coll` satisfies an async test.
     * If any iteratee call returns `true`, the main `callback` is immediately
     * called.
     *
     * @name some
     * @static
     * @memberOf module:Collections
     * @method
     * @alias any
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collections in parallel.
     * The iteratee should complete with a boolean `result` value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the iteratee functions have finished.
     * Result will be either `true` or `false` depending on the values of the async
     * tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists,
     *    function(err, result) {
     *        console.log(result);
     *        // true
     *        // result is true since some file in the list exists
     *    }
     *);
     *
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists,
     *    function(err, result) {
     *        console.log(result);
     *        // false
     *        // result is false since none of the files exists
     *    }
     *);
     *
     * // Using Promises
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists)
     * .then( result => {
     *     console.log(result);
     *     // true
     *     // result is true since some file in the list exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists)
     * .then( result => {
     *     console.log(result);
     *     // false
     *     // result is false since none of the files exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists);
     *         console.log(result);
     *         // true
     *         // result is true since some file in the list exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * async () => {
     *     try {
     *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists);
     *         console.log(result);
     *         // false
     *         // result is false since none of the files exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function some(coll, iteratee, callback) {
        return _createTester(Boolean, res => res)(eachOf$1, coll, iteratee, callback)
    }
    var some$1 = awaitify(some, 3);

    /**
     * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
     *
     * @name someLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.some]{@link module:Collections.some}
     * @alias anyLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collections in parallel.
     * The iteratee should complete with a boolean `result` value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the iteratee functions have finished.
     * Result will be either `true` or `false` depending on the values of the async
     * tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function someLimit(coll, limit, iteratee, callback) {
        return _createTester(Boolean, res => res)(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var someLimit$1 = awaitify(someLimit, 4);

    /**
     * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
     *
     * @name someSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.some]{@link module:Collections.some}
     * @alias anySeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collections in series.
     * The iteratee should complete with a boolean `result` value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the iteratee functions have finished.
     * Result will be either `true` or `false` depending on the values of the async
     * tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function someSeries(coll, iteratee, callback) {
        return _createTester(Boolean, res => res)(eachOfSeries$1, coll, iteratee, callback)
    }
    var someSeries$1 = awaitify(someSeries, 3);

    /**
     * Sorts a list by the results of running each `coll` value through an async
     * `iteratee`.
     *
     * @name sortBy
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a value to use as the sort criteria as
     * its `result`.
     * Invoked with (item, callback).
     * @param {Function} callback - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is the items
     * from the original `coll` sorted by the values returned by the `iteratee`
     * calls. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback passed
     * @example
     *
     * // bigfile.txt is a file that is 251100 bytes in size
     * // mediumfile.txt is a file that is 11000 bytes in size
     * // smallfile.txt is a file that is 121 bytes in size
     *
     * // asynchronous function that returns the file size in bytes
     * function getFileSizeInBytes(file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes,
     *     function(err, results) {
     *         if (err) {
     *             console.log(err);
     *         } else {
     *             console.log(results);
     *             // results is now the original array of files sorted by
     *             // file size (ascending by default), e.g.
     *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     *         }
     *     }
     * );
     *
     * // By modifying the callback parameter the
     * // sorting order can be influenced:
     *
     * // ascending order
     * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], function(file, callback) {
     *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
     *         if (getFileSizeErr) return callback(getFileSizeErr);
     *         callback(null, fileSize);
     *     });
     * }, function(err, results) {
     *         if (err) {
     *             console.log(err);
     *         } else {
     *             console.log(results);
     *             // results is now the original array of files sorted by
     *             // file size (ascending by default), e.g.
     *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     *         }
     *     }
     * );
     *
     * // descending order
     * async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], function(file, callback) {
     *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
     *         if (getFileSizeErr) {
     *             return callback(getFileSizeErr);
     *         }
     *         callback(null, fileSize * -1);
     *     });
     * }, function(err, results) {
     *         if (err) {
     *             console.log(err);
     *         } else {
     *             console.log(results);
     *             // results is now the original array of files sorted by
     *             // file size (ascending by default), e.g.
     *             // [ 'bigfile.txt', 'mediumfile.txt', 'smallfile.txt']
     *         }
     *     }
     * );
     *
     * // Error handling
     * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes,
     *     function(err, results) {
     *         if (err) {
     *             console.log(err);
     *             // [ Error: ENOENT: no such file or directory ]
     *         } else {
     *             console.log(results);
     *         }
     *     }
     * );
     *
     * // Using Promises
     * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     *     // results is now the original array of files sorted by
     *     // file size (ascending by default), e.g.
     *     // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error handling
     * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * (async () => {
     *     try {
     *         let results = await async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
     *         console.log(results);
     *         // results is now the original array of files sorted by
     *         // file size (ascending by default), e.g.
     *         // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * })();
     *
     * // Error handling
     * async () => {
     *     try {
     *         let results = await async.sortBy(['missingfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
     *         console.log(results);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function sortBy (coll, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return map$1(coll, (x, iterCb) => {
            _iteratee(x, (err, criteria) => {
                if (err) return iterCb(err);
                iterCb(err, {value: x, criteria});
            });
        }, (err, results) => {
            if (err) return callback(err);
            callback(null, results.sort(comparator).map(v => v.value));
        });

        function comparator(left, right) {
            var a = left.criteria, b = right.criteria;
            return a < b ? -1 : a > b ? 1 : 0;
        }
    }
    var sortBy$1 = awaitify(sortBy, 3);

    /**
     * Sets a time limit on an asynchronous function. If the function does not call
     * its callback within the specified milliseconds, it will be called with a
     * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
     *
     * @name timeout
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} asyncFn - The async function to limit in time.
     * @param {number} milliseconds - The specified time limit.
     * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
     * to timeout Error for more information..
     * @returns {AsyncFunction} Returns a wrapped function that can be used with any
     * of the control flow functions.
     * Invoke this function with the same parameters as you would `asyncFunc`.
     * @example
     *
     * function myFunction(foo, callback) {
     *     doAsyncTask(foo, function(err, data) {
     *         // handle errors
     *         if (err) return callback(err);
     *
     *         // do some stuff ...
     *
     *         // return processed data
     *         return callback(null, data);
     *     });
     * }
     *
     * var wrapped = async.timeout(myFunction, 1000);
     *
     * // call `wrapped` as you would `myFunction`
     * wrapped({ bar: 'bar' }, function(err, data) {
     *     // if `myFunction` takes < 1000 ms to execute, `err`
     *     // and `data` will have their expected values
     *
     *     // else `err` will be an Error with the code 'ETIMEDOUT'
     * });
     */
    function timeout(asyncFn, milliseconds, info) {
        var fn = wrapAsync(asyncFn);

        return initialParams((args, callback) => {
            var timedOut = false;
            var timer;

            function timeoutCallback() {
                var name = asyncFn.name || 'anonymous';
                var error  = new Error('Callback function "' + name + '" timed out.');
                error.code = 'ETIMEDOUT';
                if (info) {
                    error.info = info;
                }
                timedOut = true;
                callback(error);
            }

            args.push((...cbArgs) => {
                if (!timedOut) {
                    callback(...cbArgs);
                    clearTimeout(timer);
                }
            });

            // setup timer and call original function
            timer = setTimeout(timeoutCallback, milliseconds);
            fn(...args);
        });
    }

    function range(size) {
        var result = Array(size);
        while (size--) {
            result[size] = size;
        }
        return result;
    }

    /**
     * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name timesLimit
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.times]{@link module:ControlFlow.times}
     * @category Control Flow
     * @param {number} count - The number of times to run the function.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - The async function to call `n` times.
     * Invoked with the iteration index and a callback: (n, next).
     * @param {Function} callback - see [async.map]{@link module:Collections.map}.
     * @returns {Promise} a promise, if no callback is provided
     */
    function timesLimit(count, limit, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return mapLimit$1(range(count), limit, _iteratee, callback);
    }

    /**
     * Calls the `iteratee` function `n` times, and accumulates results in the same
     * manner you would use with [map]{@link module:Collections.map}.
     *
     * @name times
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.map]{@link module:Collections.map}
     * @category Control Flow
     * @param {number} n - The number of times to run the function.
     * @param {AsyncFunction} iteratee - The async function to call `n` times.
     * Invoked with the iteration index and a callback: (n, next).
     * @param {Function} callback - see {@link module:Collections.map}.
     * @returns {Promise} a promise, if no callback is provided
     * @example
     *
     * // Pretend this is some complicated async factory
     * var createUser = function(id, callback) {
     *     callback(null, {
     *         id: 'user' + id
     *     });
     * };
     *
     * // generate 5 users
     * async.times(5, function(n, next) {
     *     createUser(n, function(err, user) {
     *         next(err, user);
     *     });
     * }, function(err, users) {
     *     // we should now have 5 users
     * });
     */
    function times (n, iteratee, callback) {
        return timesLimit(n, Infinity, iteratee, callback)
    }

    /**
     * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
     *
     * @name timesSeries
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.times]{@link module:ControlFlow.times}
     * @category Control Flow
     * @param {number} n - The number of times to run the function.
     * @param {AsyncFunction} iteratee - The async function to call `n` times.
     * Invoked with the iteration index and a callback: (n, next).
     * @param {Function} callback - see {@link module:Collections.map}.
     * @returns {Promise} a promise, if no callback is provided
     */
    function timesSeries (n, iteratee, callback) {
        return timesLimit(n, 1, iteratee, callback)
    }

    /**
     * A relative of `reduce`.  Takes an Object or Array, and iterates over each
     * element in parallel, each step potentially mutating an `accumulator` value.
     * The type of the accumulator defaults to the type of collection passed in.
     *
     * @name transform
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {*} [accumulator] - The initial state of the transform.  If omitted,
     * it will default to an empty Object or Array, depending on the type of `coll`
     * @param {AsyncFunction} iteratee - A function applied to each item in the
     * collection that potentially modifies the accumulator.
     * Invoked with (accumulator, item, key, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result is the transformed accumulator.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     *
     * // helper function that returns human-readable size format from bytes
     * function formatBytes(bytes, decimals = 2) {
     *   // implementation not included for brevity
     *   return humanReadbleFilesize;
     * }
     *
     * const fileList = ['file1.txt','file2.txt','file3.txt'];
     *
     * // asynchronous function that returns the file size, transformed to human-readable format
     * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
     * function transformFileSize(acc, value, key, callback) {
     *     fs.stat(value, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         acc[key] = formatBytes(stat.size);
     *         callback(null);
     *     });
     * }
     *
     * // Using callbacks
     * async.transform(fileList, transformFileSize, function(err, result) {
     *     if(err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
     *     }
     * });
     *
     * // Using Promises
     * async.transform(fileList, transformFileSize)
     * .then(result => {
     *     console.log(result);
     *     // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * (async () => {
     *     try {
     *         let result = await async.transform(fileList, transformFileSize);
     *         console.log(result);
     *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * })();
     *
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     *
     * // helper function that returns human-readable size format from bytes
     * function formatBytes(bytes, decimals = 2) {
     *   // implementation not included for brevity
     *   return humanReadbleFilesize;
     * }
     *
     * const fileMap = { f1: 'file1.txt', f2: 'file2.txt', f3: 'file3.txt' };
     *
     * // asynchronous function that returns the file size, transformed to human-readable format
     * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
     * function transformFileSize(acc, value, key, callback) {
     *     fs.stat(value, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         acc[key] = formatBytes(stat.size);
     *         callback(null);
     *     });
     * }
     *
     * // Using callbacks
     * async.transform(fileMap, transformFileSize, function(err, result) {
     *     if(err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
     *     }
     * });
     *
     * // Using Promises
     * async.transform(fileMap, transformFileSize)
     * .then(result => {
     *     console.log(result);
     *     // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.transform(fileMap, transformFileSize);
     *         console.log(result);
     *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function transform (coll, accumulator, iteratee, callback) {
        if (arguments.length <= 3 && typeof accumulator === 'function') {
            callback = iteratee;
            iteratee = accumulator;
            accumulator = Array.isArray(coll) ? [] : {};
        }
        callback = once(callback || promiseCallback());
        var _iteratee = wrapAsync(iteratee);

        eachOf$1(coll, (v, k, cb) => {
            _iteratee(accumulator, v, k, cb);
        }, err => callback(err, accumulator));
        return callback[PROMISE_SYMBOL]
    }

    /**
     * It runs each task in series but stops whenever any of the functions were
     * successful. If one of the tasks were successful, the `callback` will be
     * passed the result of the successful task. If all tasks fail, the callback
     * will be passed the error and result (if any) of the final attempt.
     *
     * @name tryEach
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing functions to
     * run, each function is passed a `callback(err, result)` it must call on
     * completion with an error `err` (which can be `null`) and an optional `result`
     * value.
     * @param {Function} [callback] - An optional callback which is called when one
     * of the tasks has succeeded, or all have failed. It receives the `err` and
     * `result` arguments of the last attempt at completing the `task`. Invoked with
     * (err, results).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     * async.tryEach([
     *     function getDataFromFirstWebsite(callback) {
     *         // Try getting the data from the first website
     *         callback(err, data);
     *     },
     *     function getDataFromSecondWebsite(callback) {
     *         // First website failed,
     *         // Try getting the data from the backup website
     *         callback(err, data);
     *     }
     * ],
     * // optional callback
     * function(err, results) {
     *     Now do something with the data.
     * });
     *
     */
    function tryEach(tasks, callback) {
        var error = null;
        var result;
        return eachSeries$1(tasks, (task, taskCb) => {
            wrapAsync(task)((err, ...args) => {
                if (err === false) return taskCb(err);

                if (args.length < 2) {
                    [result] = args;
                } else {
                    result = args;
                }
                error = err;
                taskCb(err ? null : {});
            });
        }, () => callback(error, result));
    }

    var tryEach$1 = awaitify(tryEach);

    /**
     * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
     * unmemoized form. Handy for testing.
     *
     * @name unmemoize
     * @static
     * @memberOf module:Utils
     * @method
     * @see [async.memoize]{@link module:Utils.memoize}
     * @category Util
     * @param {AsyncFunction} fn - the memoized function
     * @returns {AsyncFunction} a function that calls the original unmemoized function
     */
    function unmemoize(fn) {
        return (...args) => {
            return (fn.unmemoized || fn)(...args);
        };
    }

    /**
     * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
     * stopped, or an error occurs.
     *
     * @name whilst
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {AsyncFunction} test - asynchronous truth test to perform before each
     * execution of `iteratee`. Invoked with (callback).
     * @param {AsyncFunction} iteratee - An async function which is called each time
     * `test` passes. Invoked with (callback).
     * @param {Function} [callback] - A callback which is called after the test
     * function has failed and repeated execution of `iteratee` has stopped. `callback`
     * will be passed an error and any arguments passed to the final `iteratee`'s
     * callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * var count = 0;
     * async.whilst(
     *     function test(cb) { cb(null, count < 5); },
     *     function iter(callback) {
     *         count++;
     *         setTimeout(function() {
     *             callback(null, count);
     *         }, 1000);
     *     },
     *     function (err, n) {
     *         // 5 seconds have passed, n = 5
     *     }
     * );
     */
    function whilst(test, iteratee, callback) {
        callback = onlyOnce(callback);
        var _fn = wrapAsync(iteratee);
        var _test = wrapAsync(test);
        var results = [];

        function next(err, ...rest) {
            if (err) return callback(err);
            results = rest;
            if (err === false) return;
            _test(check);
        }

        function check(err, truth) {
            if (err) return callback(err);
            if (err === false) return;
            if (!truth) return callback(null, ...results);
            _fn(next);
        }

        return _test(check);
    }
    var whilst$1 = awaitify(whilst, 3);

    /**
     * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
     * stopped, or an error occurs. `callback` will be passed an error and any
     * arguments passed to the final `iteratee`'s callback.
     *
     * The inverse of [whilst]{@link module:ControlFlow.whilst}.
     *
     * @name until
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.whilst]{@link module:ControlFlow.whilst}
     * @category Control Flow
     * @param {AsyncFunction} test - asynchronous truth test to perform before each
     * execution of `iteratee`. Invoked with (callback).
     * @param {AsyncFunction} iteratee - An async function which is called each time
     * `test` fails. Invoked with (callback).
     * @param {Function} [callback] - A callback which is called after the test
     * function has passed and repeated execution of `iteratee` has stopped. `callback`
     * will be passed an error and any arguments passed to the final `iteratee`'s
     * callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if a callback is not passed
     *
     * @example
     * const results = []
     * let finished = false
     * async.until(function test(cb) {
     *     cb(null, finished)
     * }, function iter(next) {
     *     fetchPage(url, (err, body) => {
     *         if (err) return next(err)
     *         results = results.concat(body.objects)
     *         finished = !!body.next
     *         next(err)
     *     })
     * }, function done (err) {
     *     // all pages have been fetched
     * })
     */
    function until(test, iteratee, callback) {
        const _test = wrapAsync(test);
        return whilst$1((cb) => _test((err, truth) => cb (err, !truth)), iteratee, callback);
    }

    /**
     * Runs the `tasks` array of functions in series, each passing their results to
     * the next in the array. However, if any of the `tasks` pass an error to their
     * own callback, the next function is not executed, and the main `callback` is
     * immediately called with the error.
     *
     * @name waterfall
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
     * to run.
     * Each function should complete with any number of `result` values.
     * The `result` values will be passed as arguments, in order, to the next task.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed. This will be passed the results of the last task's
     * callback. Invoked with (err, [results]).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * async.waterfall([
     *     function(callback) {
     *         callback(null, 'one', 'two');
     *     },
     *     function(arg1, arg2, callback) {
     *         // arg1 now equals 'one' and arg2 now equals 'two'
     *         callback(null, 'three');
     *     },
     *     function(arg1, callback) {
     *         // arg1 now equals 'three'
     *         callback(null, 'done');
     *     }
     * ], function (err, result) {
     *     // result now equals 'done'
     * });
     *
     * // Or, with named functions:
     * async.waterfall([
     *     myFirstFunction,
     *     mySecondFunction,
     *     myLastFunction,
     * ], function (err, result) {
     *     // result now equals 'done'
     * });
     * function myFirstFunction(callback) {
     *     callback(null, 'one', 'two');
     * }
     * function mySecondFunction(arg1, arg2, callback) {
     *     // arg1 now equals 'one' and arg2 now equals 'two'
     *     callback(null, 'three');
     * }
     * function myLastFunction(arg1, callback) {
     *     // arg1 now equals 'three'
     *     callback(null, 'done');
     * }
     */
    function waterfall (tasks, callback) {
        callback = once(callback);
        if (!Array.isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
        if (!tasks.length) return callback();
        var taskIndex = 0;

        function nextTask(args) {
            var task = wrapAsync(tasks[taskIndex++]);
            task(...args, onlyOnce(next));
        }

        function next(err, ...args) {
            if (err === false) return
            if (err || taskIndex === tasks.length) {
                return callback(err, ...args);
            }
            nextTask(args);
        }

        nextTask([]);
    }

    var waterfall$1 = awaitify(waterfall);

    /**
     * An "async function" in the context of Async is an asynchronous function with
     * a variable number of parameters, with the final parameter being a callback.
     * (`function (arg1, arg2, ..., callback) {}`)
     * The final callback is of the form `callback(err, results...)`, which must be
     * called once the function is completed.  The callback should be called with a
     * Error as its first argument to signal that an error occurred.
     * Otherwise, if no error occurred, it should be called with `null` as the first
     * argument, and any additional `result` arguments that may apply, to signal
     * successful completion.
     * The callback must be called exactly once, ideally on a later tick of the
     * JavaScript event loop.
     *
     * This type of function is also referred to as a "Node-style async function",
     * or a "continuation passing-style function" (CPS). Most of the methods of this
     * library are themselves CPS/Node-style async functions, or functions that
     * return CPS/Node-style async functions.
     *
     * Wherever we accept a Node-style async function, we also directly accept an
     * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
     * In this case, the `async` function will not be passed a final callback
     * argument, and any thrown error will be used as the `err` argument of the
     * implicit callback, and the return value will be used as the `result` value.
     * (i.e. a `rejected` of the returned Promise becomes the `err` callback
     * argument, and a `resolved` value becomes the `result`.)
     *
     * Note, due to JavaScript limitations, we can only detect native `async`
     * functions and not transpilied implementations.
     * Your environment must have `async`/`await` support for this to work.
     * (e.g. Node > v7.6, or a recent version of a modern browser).
     * If you are using `async` functions through a transpiler (e.g. Babel), you
     * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
     * because the `async function` will be compiled to an ordinary function that
     * returns a promise.
     *
     * @typedef {Function} AsyncFunction
     * @static
     */


    var index = {
        apply,
        applyEach,
        applyEachSeries,
        asyncify,
        auto,
        autoInject,
        cargo: cargo$1,
        cargoQueue: cargo,
        compose,
        concat: concat$1,
        concatLimit: concatLimit$1,
        concatSeries: concatSeries$1,
        constant: constant$1,
        detect: detect$1,
        detectLimit: detectLimit$1,
        detectSeries: detectSeries$1,
        dir,
        doUntil,
        doWhilst: doWhilst$1,
        each,
        eachLimit: eachLimit$1,
        eachOf: eachOf$1,
        eachOfLimit: eachOfLimit$1,
        eachOfSeries: eachOfSeries$1,
        eachSeries: eachSeries$1,
        ensureAsync,
        every: every$1,
        everyLimit: everyLimit$1,
        everySeries: everySeries$1,
        filter: filter$1,
        filterLimit: filterLimit$1,
        filterSeries: filterSeries$1,
        forever: forever$1,
        groupBy,
        groupByLimit: groupByLimit$1,
        groupBySeries,
        log,
        map: map$1,
        mapLimit: mapLimit$1,
        mapSeries: mapSeries$1,
        mapValues,
        mapValuesLimit: mapValuesLimit$1,
        mapValuesSeries,
        memoize,
        nextTick,
        parallel,
        parallelLimit,
        priorityQueue,
        queue,
        race: race$1,
        reduce: reduce$1,
        reduceRight,
        reflect,
        reflectAll,
        reject: reject$1,
        rejectLimit: rejectLimit$1,
        rejectSeries: rejectSeries$1,
        retry,
        retryable,
        seq,
        series,
        setImmediate: setImmediate$1,
        some: some$1,
        someLimit: someLimit$1,
        someSeries: someSeries$1,
        sortBy: sortBy$1,
        timeout,
        times,
        timesLimit,
        timesSeries,
        transform,
        tryEach: tryEach$1,
        unmemoize,
        until,
        waterfall: waterfall$1,
        whilst: whilst$1,

        // aliases
        all: every$1,
        allLimit: everyLimit$1,
        allSeries: everySeries$1,
        any: some$1,
        anyLimit: someLimit$1,
        anySeries: someSeries$1,
        find: detect$1,
        findLimit: detectLimit$1,
        findSeries: detectSeries$1,
        flatMap: concat$1,
        flatMapLimit: concatLimit$1,
        flatMapSeries: concatSeries$1,
        forEach: each,
        forEachSeries: eachSeries$1,
        forEachLimit: eachLimit$1,
        forEachOf: eachOf$1,
        forEachOfSeries: eachOfSeries$1,
        forEachOfLimit: eachOfLimit$1,
        inject: reduce$1,
        foldl: reduce$1,
        foldr: reduceRight,
        select: filter$1,
        selectLimit: filterLimit$1,
        selectSeries: filterSeries$1,
        wrapSync: asyncify,
        during: whilst$1,
        doDuring: doWhilst$1
    };

    exports.all = every$1;
    exports.allLimit = everyLimit$1;
    exports.allSeries = everySeries$1;
    exports.any = some$1;
    exports.anyLimit = someLimit$1;
    exports.anySeries = someSeries$1;
    exports.apply = apply;
    exports.applyEach = applyEach;
    exports.applyEachSeries = applyEachSeries;
    exports.asyncify = asyncify;
    exports.auto = auto;
    exports.autoInject = autoInject;
    exports.cargo = cargo$1;
    exports.cargoQueue = cargo;
    exports.compose = compose;
    exports.concat = concat$1;
    exports.concatLimit = concatLimit$1;
    exports.concatSeries = concatSeries$1;
    exports.constant = constant$1;
    exports.default = index;
    exports.detect = detect$1;
    exports.detectLimit = detectLimit$1;
    exports.detectSeries = detectSeries$1;
    exports.dir = dir;
    exports.doDuring = doWhilst$1;
    exports.doUntil = doUntil;
    exports.doWhilst = doWhilst$1;
    exports.during = whilst$1;
    exports.each = each;
    exports.eachLimit = eachLimit$1;
    exports.eachOf = eachOf$1;
    exports.eachOfLimit = eachOfLimit$1;
    exports.eachOfSeries = eachOfSeries$1;
    exports.eachSeries = eachSeries$1;
    exports.ensureAsync = ensureAsync;
    exports.every = every$1;
    exports.everyLimit = everyLimit$1;
    exports.everySeries = everySeries$1;
    exports.filter = filter$1;
    exports.filterLimit = filterLimit$1;
    exports.filterSeries = filterSeries$1;
    exports.find = detect$1;
    exports.findLimit = detectLimit$1;
    exports.findSeries = detectSeries$1;
    exports.flatMap = concat$1;
    exports.flatMapLimit = concatLimit$1;
    exports.flatMapSeries = concatSeries$1;
    exports.foldl = reduce$1;
    exports.foldr = reduceRight;
    exports.forEach = each;
    exports.forEachLimit = eachLimit$1;
    exports.forEachOf = eachOf$1;
    exports.forEachOfLimit = eachOfLimit$1;
    exports.forEachOfSeries = eachOfSeries$1;
    exports.forEachSeries = eachSeries$1;
    exports.forever = forever$1;
    exports.groupBy = groupBy;
    exports.groupByLimit = groupByLimit$1;
    exports.groupBySeries = groupBySeries;
    exports.inject = reduce$1;
    exports.log = log;
    exports.map = map$1;
    exports.mapLimit = mapLimit$1;
    exports.mapSeries = mapSeries$1;
    exports.mapValues = mapValues;
    exports.mapValuesLimit = mapValuesLimit$1;
    exports.mapValuesSeries = mapValuesSeries;
    exports.memoize = memoize;
    exports.nextTick = nextTick;
    exports.parallel = parallel;
    exports.parallelLimit = parallelLimit;
    exports.priorityQueue = priorityQueue;
    exports.queue = queue;
    exports.race = race$1;
    exports.reduce = reduce$1;
    exports.reduceRight = reduceRight;
    exports.reflect = reflect;
    exports.reflectAll = reflectAll;
    exports.reject = reject$1;
    exports.rejectLimit = rejectLimit$1;
    exports.rejectSeries = rejectSeries$1;
    exports.retry = retry;
    exports.retryable = retryable;
    exports.select = filter$1;
    exports.selectLimit = filterLimit$1;
    exports.selectSeries = filterSeries$1;
    exports.seq = seq;
    exports.series = series;
    exports.setImmediate = setImmediate$1;
    exports.some = some$1;
    exports.someLimit = someLimit$1;
    exports.someSeries = someSeries$1;
    exports.sortBy = sortBy$1;
    exports.timeout = timeout;
    exports.times = times;
    exports.timesLimit = timesLimit;
    exports.timesSeries = timesSeries;
    exports.transform = transform;
    exports.tryEach = tryEach$1;
    exports.unmemoize = unmemoize;
    exports.until = until;
    exports.waterfall = waterfall$1;
    exports.whilst = whilst$1;
    exports.wrapSync = asyncify;

    Object.defineProperty(exports, '__esModule', { value: true });

}));

}).call(this)}).call(this,require('_process'),require("timers").setImmediate)

},{"_process":696,"timers":749}],276:[function(require,module,exports){
(function (global){(function (){
'use strict';

var possibleNames = require('possible-typed-array-names');

var g = typeof globalThis === 'undefined' ? global : globalThis;

/** @type {import('.')} */
module.exports = function availableTypedArrays() {
	var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			// @ts-expect-error
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"possible-typed-array-names":694}],277:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],278:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
      i++;
    }

    // Clear words above the requested width so the result stays below 2 ** width
    for (; i < this.length; i++) {
      this.words[i] = 0;
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    if (num === 0) {
      this.length = 1;
      this._normSign();
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.mod.abs();

    var half = num.abs().iushrn(1);
    var r2 = num.words[0] & 1;
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up, away from zero
    var up = new BN(1);
    up.negative = this.negative ^ num.negative;
    return dm.div.iadd(up);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":280}],279:[function(require,module,exports){
var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = require('crypto');
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}

},{"crypto":280}],280:[function(require,module,exports){

},{}],281:[function(require,module,exports){
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = require('safe-buffer').Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES

},{"safe-buffer":736}],282:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')
var GHASH = require('./ghash')
var xor = require('buffer-xor')
var incr32 = require('./incr32')

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher

},{"./aes":281,"./ghash":286,"./incr32":287,"buffer-xor":325,"cipher-base":334,"inherits":431,"safe-buffer":736}],283:[function(require,module,exports){
var ciphers = require('./encrypter')
var deciphers = require('./decrypter')
var modes = require('./modes/list.json')

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"./decrypter":284,"./encrypter":285,"./modes/list.json":295}],284:[function(require,module,exports){
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var MODES = require('./modes')
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

},{"./aes":281,"./authCipher":282,"./modes":294,"./streamCipher":297,"cipher-base":334,"evp_bytestokey":396,"inherits":431,"safe-buffer":736}],285:[function(require,module,exports){
var MODES = require('./modes')
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

},{"./aes":281,"./authCipher":282,"./modes":294,"./streamCipher":297,"cipher-base":334,"evp_bytestokey":396,"inherits":431,"safe-buffer":736}],286:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH

},{"safe-buffer":736}],287:[function(require,module,exports){
function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32

},{}],288:[function(require,module,exports){
var xor = require('buffer-xor')

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}

},{"buffer-xor":325}],289:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var xor = require('buffer-xor')

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}

},{"buffer-xor":325,"safe-buffer":736}],290:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":736}],291:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":736}],292:[function(require,module,exports){
var xor = require('buffer-xor')
var Buffer = require('safe-buffer').Buffer
var incr32 = require('../incr32')

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

},{"../incr32":287,"buffer-xor":325,"safe-buffer":736}],293:[function(require,module,exports){
exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}

},{}],294:[function(require,module,exports){
var modeModules = {
  ECB: require('./ecb'),
  CBC: require('./cbc'),
  CFB: require('./cfb'),
  CFB8: require('./cfb8'),
  CFB1: require('./cfb1'),
  OFB: require('./ofb'),
  CTR: require('./ctr'),
  GCM: require('./ctr')
}

var modes = require('./list.json')

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes

},{"./cbc":288,"./cfb":289,"./cfb1":290,"./cfb8":291,"./ctr":292,"./ecb":293,"./list.json":295,"./ofb":296}],295:[function(require,module,exports){
module.exports={
  "aes-128-ecb": {
    "cipher": "AES",
    "key": 128,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-192-ecb": {
    "cipher": "AES",
    "key": 192,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-256-ecb": {
    "cipher": "AES",
    "key": 256,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-128-cbc": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-192-cbc": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-256-cbc": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes128": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes192": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes256": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-128-cfb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-192-cfb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-256-cfb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-128-cfb8": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-192-cfb8": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-256-cfb8": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-128-cfb1": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-192-cfb1": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-256-cfb1": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-128-ofb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-192-ofb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-256-ofb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-128-ctr": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-192-ctr": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-256-ctr": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-128-gcm": {
    "cipher": "AES",
    "key": 128,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-192-gcm": {
    "cipher": "AES",
    "key": 192,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-256-gcm": {
    "cipher": "AES",
    "key": 256,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  }
}

},{}],296:[function(require,module,exports){
(function (Buffer){(function (){
var xor = require('buffer-xor')

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":322,"buffer-xor":325}],297:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher

},{"./aes":281,"cipher-base":334,"inherits":431,"safe-buffer":736}],298:[function(require,module,exports){
var DES = require('browserify-des')
var aes = require('browserify-aes/browser')
var aesModes = require('browserify-aes/modes')
var desModes = require('browserify-des/modes')
var ebtk = require('evp_bytestokey')

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"browserify-aes/browser":283,"browserify-aes/modes":294,"browserify-des":299,"browserify-des/modes":300,"evp_bytestokey":396}],299:[function(require,module,exports){
var CipherBase = require('cipher-base')
var des = require('des.js')
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}

},{"cipher-base":334,"des.js":357,"inherits":431,"safe-buffer":736}],300:[function(require,module,exports){
exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}

},{}],301:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var randomBytes = require('randombytes');
var Buffer = require('safe-buffer').Buffer;

function getr(priv) {
	var len = priv.modulus.byteLength();
	var r;
	do {
		r = new BN(randomBytes(len));
	} while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
	return r;
}

function blind(priv) {
	var r = getr(priv);
	var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
	return { blinder: blinder, unblinder: r.invm(priv.modulus) };
}

function crt(msg, priv) {
	var blinds = blind(priv);
	var len = priv.modulus.byteLength();
	var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
	var c1 = blinded.toRed(BN.mont(priv.prime1));
	var c2 = blinded.toRed(BN.mont(priv.prime2));
	var qinv = priv.coefficient;
	var p = priv.prime1;
	var q = priv.prime2;
	var m1 = c1.redPow(priv.exponent1).fromRed();
	var m2 = c2.redPow(priv.exponent2).fromRed();
	var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
	return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len);
}
crt.getr = getr;

module.exports = crt;

},{"bn.js":278,"randombytes":704,"safe-buffer":736}],302:[function(require,module,exports){
'use strict';

module.exports = require('./browser/algorithms.json');

},{"./browser/algorithms.json":303}],303:[function(require,module,exports){
module.exports={
  "sha224WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "RSA-SHA224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha256WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "RSA-SHA256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha384WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "RSA-SHA384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    "sign": "rsa",
    "hash": "sha1",
    "id": "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    "sign": "ecdsa",
    "hash": "sha1",
    "id": ""
  },
  "sha256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "DSA-SHA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-SHA1": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-WITH-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-WITH-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-WITH-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-WITH-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-RIPEMD160": {
    "sign": "dsa",
    "hash": "rmd160",
    "id": ""
  },
  "ripemd160WithRSA": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "RSA-RIPEMD160": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "md5WithRSAEncryption": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  },
  "RSA-MD5": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  }
}

},{}],304:[function(require,module,exports){
module.exports={
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
}

},{}],305:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var createHash = require('create-hash');
var stream = require('readable-stream');
var inherits = require('inherits');
var sign = require('./sign');
var verify = require('./verify');

var algorithms = require('./algorithms.json');
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex');
  algorithms[key.toLowerCase()] = algorithms[key];
});

function Sign(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hashType = data.hash;
  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Sign, stream.Writable);

Sign.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Sign.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Sign.prototype.sign = function signMethod(key, enc) {
  this.end();
  var hash = this._hash.digest();
  var sig = sign(hash, key, this._hashType, this._signType, this._tag);

  return enc ? sig.toString(enc) : sig;
};

function Verify(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Verify, stream.Writable);

Verify.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Verify.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Verify.prototype.verify = function verifyMethod(key, sig, enc) {
  var sigBuffer = typeof sig === 'string' ? Buffer.from(sig, enc) : sig;

  this.end();
  var hash = this._hash.digest();
  return verify(sigBuffer, hash, key, this._signType, this._tag);
};

function createSign(algorithm) {
  return new Sign(algorithm);
}

function createVerify(algorithm) {
  return new Verify(algorithm);
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
};

},{"./algorithms.json":303,"./sign":306,"./verify":307,"create-hash":349,"inherits":431,"readable-stream":318,"safe-buffer":736}],306:[function(require,module,exports){
'use strict';

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer;
var createHmac = require('create-hmac');
var crt = require('browserify-rsa');
var EC = require('elliptic').ec;
var BN = require('bn.js');
var parseKeys = require('parse-asn1');
var curves = require('./curves.json');

var RSA_PKCS1_PADDING = 1;

function sign(hash, key, hashType, signType, tag) {
  var priv = parseKeys(key);
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
    return ecSign(hash, priv);
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong private key type'); }
    return dsaSign(hash, priv, hashType);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
  if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) { throw new Error('illegal or unsupported padding mode'); }

  hash = Buffer.concat([tag, hash]);
  var len = priv.modulus.byteLength();
  var pad = [0, 1];
  while (hash.length + pad.length + 1 < len) { pad.push(0xff); }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) { pad.push(hash[i]); }

  var out = crt(pad, priv);
  return out;
}

function ecSign(hash, priv) {
  var curveId = curves[priv.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + priv.curve.join('.')); }

  var curve = new EC(curveId);
  var key = curve.keyFromPrivate(priv.privateKey);
  var out = key.sign(hash);

  return Buffer.from(out.toDER());
}

function dsaSign(hash, priv, algo) {
  var x = priv.params.priv_key;
  var p = priv.params.p;
  var q = priv.params.q;
  var g = priv.params.g;
  var r = new BN(0);
  var k;
  var H = bits2int(hash, q).mod(q);
  var s = false;
  var kv = getKey(x, q, hash, algo);
  while (s === false) {
    k = makeKey(q, kv, algo);
    r = makeR(g, k, p, q);
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
    if (s.cmpn(0) === 0) {
      s = false;
      r = new BN(0);
    }
  }
  return toDER(r, s);
}

function toDER(r, s) {
  r = r.toArray();
  s = s.toArray();

  // Pad values
  if (r[0] & 0x80) { r = [0].concat(r); }
  if (s[0] & 0x80) { s = [0].concat(s); }

  var total = r.length + s.length + 4;
  var res = [
    0x30, total, 0x02, r.length
  ];
  res = res.concat(r, [0x02, s.length], s);
  return Buffer.from(res);
}

function getKey(x, q, hash, algo) {
  x = Buffer.from(x.toArray());
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length);
    x = Buffer.concat([zeros, x]);
  }
  var hlen = hash.length;
  var hbits = bits2octets(hash, q);
  var v = Buffer.alloc(hlen);
  v.fill(1);
  var k = Buffer.alloc(hlen);
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  return { k: k, v: v };
}

function bits2int(obits, q) {
  var bits = new BN(obits);
  var shift = (obits.length << 3) - q.bitLength();
  if (shift > 0) { bits.ishrn(shift); }
  return bits;
}

function bits2octets(bits, q) {
  bits = bits2int(bits, q);
  bits = bits.mod(q);
  var out = Buffer.from(bits.toArray());
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length);
    out = Buffer.concat([zeros, out]);
  }
  return out;
}

function makeKey(q, kv, algo) {
  var t;
  var k;

  do {
    t = Buffer.alloc(0);

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest();
      t = Buffer.concat([t, kv.v]);
    }

    k = bits2int(t, q);
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest();
    kv.v = createHmac(algo, kv.k).update(kv.v).digest();
  } while (k.cmp(q) !== -1);

  return k;
}

function makeR(g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}

module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;

},{"./curves.json":304,"bn.js":278,"browserify-rsa":301,"create-hmac":351,"elliptic":369,"parse-asn1":467,"safe-buffer":736}],307:[function(require,module,exports){
'use strict';

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer;
var BN = require('bn.js');
var EC = require('elliptic').ec;
var parseKeys = require('parse-asn1');
var curves = require('./curves.json');

function verify(sig, hash, key, signType, tag) {
  var pub = parseKeys(key);
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }
    return ecVerify(sig, hash, pub);
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong public key type'); }
    return dsaVerify(sig, hash, pub);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }

  hash = Buffer.concat([tag, hash]);
  var len = pub.modulus.byteLength();
  var pad = [1];
  var padNum = 0;
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff);
    padNum += 1;
  }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) {
    pad.push(hash[i]);
  }
  pad = Buffer.from(pad);
  var red = BN.mont(pub.modulus);
  sig = new BN(sig).toRed(red);

  sig = sig.redPow(new BN(pub.publicExponent));
  sig = Buffer.from(sig.fromRed().toArray());
  var out = padNum < 8 ? 1 : 0;
  len = Math.min(sig.length, pad.length);
  if (sig.length !== pad.length) { out = 1; }

  i = -1;
  while (++i < len) { out |= sig[i] ^ pad[i]; }
  return out === 0;
}

function ecVerify(sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.')); }

  var curve = new EC(curveId);
  var pubkey = pub.data.subjectPrivateKey.data;

  return curve.verify(hash, sig, pubkey);
}

function dsaVerify(sig, hash, pub) {
  var p = pub.data.p;
  var q = pub.data.q;
  var g = pub.data.g;
  var y = pub.data.pub_key;
  var unpacked = parseKeys.signature.decode(sig, 'der');
  var s = unpacked.s;
  var r = unpacked.r;
  checkValue(s, q);
  checkValue(r, q);
  var montp = BN.mont(p);
  var w = s.invm(q);
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q);
  return v.cmp(r) === 0;
}

function checkValue(b, q) {
  if (b.cmpn(0) <= 0) { throw new Error('invalid sig'); }
  if (b.cmp(q) >= 0) { throw new Error('invalid sig'); }
}

module.exports = verify;

},{"./curves.json":304,"bn.js":278,"elliptic":369,"parse-asn1":467,"safe-buffer":736}],308:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],309:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};
},{"./_stream_readable":311,"./_stream_writable":313,"core-util-is":346,"inherits":431,"process-nextick-args":695}],310:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":312,"core-util-is":346,"inherits":431}],311:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./_stream_duplex":309,"./internal/streams/BufferList":314,"./internal/streams/destroy":315,"./internal/streams/stream":316,"_process":696,"core-util-is":346,"events":395,"inherits":431,"isarray":308,"process-nextick-args":695,"safe-buffer":317,"string_decoder/":319,"util":280}],312:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":309,"core-util-is":346,"inherits":431}],313:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"./_stream_duplex":309,"./internal/streams/destroy":315,"./internal/streams/stream":316,"_process":696,"core-util-is":346,"inherits":431,"process-nextick-args":695,"safe-buffer":317,"timers":749,"util-deprecate":752}],314:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = require('safe-buffer').Buffer;
var util = require('util');

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
},{"safe-buffer":317,"util":280}],315:[function(require,module,exports){
'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};
},{"process-nextick-args":695}],316:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":395}],317:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":322}],318:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":309,"./lib/_stream_passthrough.js":310,"./lib/_stream_readable.js":311,"./lib/_stream_transform.js":312,"./lib/_stream_writable.js":313}],319:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":320}],320:[function(require,module,exports){
arguments[4][317][0].apply(exports,arguments)
},{"buffer":322,"dup":317}],321:[function(require,module,exports){
arguments[4][280][0].apply(exports,arguments)
},{"dup":280}],322:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"base64-js":277,"buffer":322,"ieee754":430}],323:[function(require,module,exports){
arguments[4][317][0].apply(exports,arguments)
},{"buffer":322,"dup":317}],324:[function(require,module,exports){
arguments[4][319][0].apply(exports,arguments)
},{"dup":319,"safe-buffer":323}],325:[function(require,module,exports){
(function (Buffer){(function (){
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":322}],326:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);

},{"./functionApply":328,"./functionCall":329,"./reflectApply":331,"function-bind":401}],327:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $apply = require('./functionApply');
var actualApply = require('./actualApply');

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};

},{"./actualApply":326,"./functionApply":328,"function-bind":401}],328:[function(require,module,exports){
'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;

},{}],329:[function(require,module,exports){
'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;

},{}],330:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $TypeError = require('es-errors/type');

var $call = require('./functionCall');
var $actualApply = require('./actualApply');

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};

},{"./actualApply":326,"./functionCall":329,"es-errors/type":392,"function-bind":401}],331:[function(require,module,exports){
'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],332:[function(require,module,exports){
'use strict';

var setFunctionLength = require('set-function-length');

var $defineProperty = require('es-define-property');

var callBindBasic = require('call-bind-apply-helpers');
var applyBind = require('call-bind-apply-helpers/applyBind');

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		adjustedLength > 0 ? adjustedLength : 0,
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"call-bind-apply-helpers":330,"call-bind-apply-helpers/applyBind":327,"es-define-property":386,"set-function-length":738}],333:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBindBasic = require('call-bind-apply-helpers');

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};

},{"call-bind-apply-helpers":330,"get-intrinsic":403}],334:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var Transform = require('stream').Transform;
var StringDecoder = require('string_decoder').StringDecoder;
var inherits = require('inherits');
var toBuffer = require('to-buffer');

function CipherBase(hashMode) {
	Transform.call(this);
	this.hashMode = typeof hashMode === 'string';
	if (this.hashMode) {
		this[hashMode] = this._finalOrDigest;
	} else {
		this['final'] = this._finalOrDigest;
	}
	if (this._final) {
		this.__final = this._final;
		this._final = null;
	}
	this._decoder = null;
	this._encoding = null;
}
inherits(CipherBase, Transform);

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	var bufferData = toBuffer(data, inputEnc); // asserts correct input type
	var outData = this._update(bufferData);
	if (this.hashMode) {
		return this;
	}

	if (outputEnc) {
		outData = this._toString(outData, outputEnc);
	}

	return outData;
};

CipherBase.prototype.setAutoPadding = function () {};
CipherBase.prototype.getAuthTag = function () {
	throw new Error('trying to get auth tag in unsupported state');
};

CipherBase.prototype.setAuthTag = function () {
	throw new Error('trying to set auth tag in unsupported state');
};

CipherBase.prototype.setAAD = function () {
	throw new Error('trying to set aad in unsupported state');
};

CipherBase.prototype._transform = function (data, _, next) {
	var err;
	try {
		if (this.hashMode) {
			this._update(data);
		} else {
			this.push(this._update(data));
		}
	} catch (e) {
		err = e;
	} finally {
		next(err);
	}
};
CipherBase.prototype._flush = function (done) {
	var err;
	try {
		this.push(this.__final());
	} catch (e) {
		err = e;
	}

	done(err);
};
CipherBase.prototype._finalOrDigest = function (outputEnc) {
	var outData = this.__final() || Buffer.alloc(0);
	if (outputEnc) {
		outData = this._toString(outData, outputEnc, true);
	}
	return outData;
};

CipherBase.prototype._toString = function (value, enc, fin) {
	if (!this._decoder) {
		this._decoder = new StringDecoder(enc);
		this._encoding = enc;
	}

	if (this._encoding !== enc) {
		throw new Error('can’t switch encodings');
	}

	var out = this._decoder.write(value);
	if (fin) {
		out += this._decoder.end();
	}

	return out;
};

module.exports = CipherBase;

},{"inherits":431,"safe-buffer":736,"stream":747,"string_decoder":324,"to-buffer":750}],335:[function(require,module,exports){
/*

The MIT License (MIT)

Original Library
  - Copyright (c) Marak Squires

Additional functionality
 - Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var colors = {};
module['exports'] = colors;

colors.themes = {};

var util = require('util');
var ansiStyles = colors.styles = require('./styles');
var defineProps = Object.defineProperties;
var newLineRegex = new RegExp(/[\r\n]+/g);

colors.supportsColor = require('./system/supports-colors').supportsColor;

if (typeof colors.enabled === 'undefined') {
  colors.enabled = colors.supportsColor() !== false;
}

colors.enable = function() {
  colors.enabled = true;
};

colors.disable = function() {
  colors.enabled = false;
};

colors.stripColors = colors.strip = function(str) {
  return ('' + str).replace(/\x1B\[\d+m/g, '');
};

// eslint-disable-next-line no-unused-vars
var stylize = colors.stylize = function stylize(str, style) {
  if (!colors.enabled) {
    return str+'';
  }

  var styleMap = ansiStyles[style];

  // Stylize should work for non-ANSI styles, too
  if(!styleMap && style in colors){
    // Style maps like trap operate as functions on strings;
    // they don't have properties like open or close.
    return colors[style](str);
  }

  return styleMap.open + str + styleMap.close;
};

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
var escapeStringRegexp = function(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }
  return str.replace(matchOperatorsRe, '\\$&');
};

function build(_styles) {
  var builder = function builder() {
    return applyStyle.apply(builder, arguments);
  };
  builder._styles = _styles;
  // __proto__ is used because we must return a function, but there is
  // no way to create a function with a different prototype.
  builder.__proto__ = proto;
  return builder;
}

var styles = (function() {
  var ret = {};
  ansiStyles.grey = ansiStyles.gray;
  Object.keys(ansiStyles).forEach(function(key) {
    ansiStyles[key].closeRe =
      new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
    ret[key] = {
      get: function() {
        return build(this._styles.concat(key));
      },
    };
  });
  return ret;
})();

var proto = defineProps(function colors() {}, styles);

function applyStyle() {
  var args = Array.prototype.slice.call(arguments);

  var str = args.map(function(arg) {
    // Use weak equality check so we can colorize null/undefined in safe mode
    if (arg != null && arg.constructor === String) {
      return arg;
    } else {
      return util.inspect(arg);
    }
  }).join(' ');

  if (!colors.enabled || !str) {
    return str;
  }

  var newLinesPresent = str.indexOf('\n') != -1;

  var nestedStyles = this._styles;

  var i = nestedStyles.length;
  while (i--) {
    var code = ansiStyles[nestedStyles[i]];
    str = code.open + str.replace(code.closeRe, code.open) + code.close;
    if (newLinesPresent) {
      str = str.replace(newLineRegex, function(match) {
        return code.close + match + code.open;
      });
    }
  }

  return str;
}

colors.setTheme = function(theme) {
  if (typeof theme === 'string') {
    console.log('colors.setTheme now only accepts an object, not a string.  ' +
      'If you are trying to set a theme from a file, it is now your (the ' +
      'caller\'s) responsibility to require the file.  The old syntax ' +
      'looked like colors.setTheme(__dirname + ' +
      '\'/../themes/generic-logging.js\'); The new syntax looks like '+
      'colors.setTheme(require(__dirname + ' +
      '\'/../themes/generic-logging.js\'));');
    return;
  }
  for (var style in theme) {
    (function(style) {
      colors[style] = function(str) {
        if (typeof theme[style] === 'object') {
          var out = str;
          for (var i in theme[style]) {
            out = colors[theme[style][i]](out);
          }
          return out;
        }
        return colors[theme[style]](str);
      };
    })(style);
  }
};

function init() {
  var ret = {};
  Object.keys(styles).forEach(function(name) {
    ret[name] = {
      get: function() {
        return build([name]);
      },
    };
  });
  return ret;
}

var sequencer = function sequencer(map, str) {
  var exploded = str.split('');
  exploded = exploded.map(map);
  return exploded.join('');
};

// custom formatter methods
colors.trap = require('./custom/trap');
colors.zalgo = require('./custom/zalgo');

// maps
colors.maps = {};
colors.maps.america = require('./maps/america')(colors);
colors.maps.zebra = require('./maps/zebra')(colors);
colors.maps.rainbow = require('./maps/rainbow')(colors);
colors.maps.random = require('./maps/random')(colors);

for (var map in colors.maps) {
  (function(map) {
    colors[map] = function(str) {
      return sequencer(colors.maps[map], str);
    };
  })(map);
}

defineProps(colors, init());

},{"./custom/trap":336,"./custom/zalgo":337,"./maps/america":338,"./maps/rainbow":339,"./maps/random":340,"./maps/zebra":341,"./styles":342,"./system/supports-colors":344,"util":755}],336:[function(require,module,exports){
module['exports'] = function runTheTrap(text, options) {
  var result = '';
  text = text || 'Run the trap, drop the bass';
  text = text.split('');
  var trap = {
    a: ['\u0040', '\u0104', '\u023a', '\u0245', '\u0394', '\u039b', '\u0414'],
    b: ['\u00df', '\u0181', '\u0243', '\u026e', '\u03b2', '\u0e3f'],
    c: ['\u00a9', '\u023b', '\u03fe'],
    d: ['\u00d0', '\u018a', '\u0500', '\u0501', '\u0502', '\u0503'],
    e: ['\u00cb', '\u0115', '\u018e', '\u0258', '\u03a3', '\u03be', '\u04bc',
      '\u0a6c'],
    f: ['\u04fa'],
    g: ['\u0262'],
    h: ['\u0126', '\u0195', '\u04a2', '\u04ba', '\u04c7', '\u050a'],
    i: ['\u0f0f'],
    j: ['\u0134'],
    k: ['\u0138', '\u04a0', '\u04c3', '\u051e'],
    l: ['\u0139'],
    m: ['\u028d', '\u04cd', '\u04ce', '\u0520', '\u0521', '\u0d69'],
    n: ['\u00d1', '\u014b', '\u019d', '\u0376', '\u03a0', '\u048a'],
    o: ['\u00d8', '\u00f5', '\u00f8', '\u01fe', '\u0298', '\u047a', '\u05dd',
      '\u06dd', '\u0e4f'],
    p: ['\u01f7', '\u048e'],
    q: ['\u09cd'],
    r: ['\u00ae', '\u01a6', '\u0210', '\u024c', '\u0280', '\u042f'],
    s: ['\u00a7', '\u03de', '\u03df', '\u03e8'],
    t: ['\u0141', '\u0166', '\u0373'],
    u: ['\u01b1', '\u054d'],
    v: ['\u05d8'],
    w: ['\u0428', '\u0460', '\u047c', '\u0d70'],
    x: ['\u04b2', '\u04fe', '\u04fc', '\u04fd'],
    y: ['\u00a5', '\u04b0', '\u04cb'],
    z: ['\u01b5', '\u0240'],
  };
  text.forEach(function(c) {
    c = c.toLowerCase();
    var chars = trap[c] || [' '];
    var rand = Math.floor(Math.random() * chars.length);
    if (typeof trap[c] !== 'undefined') {
      result += trap[c][rand];
    } else {
      result += c;
    }
  });
  return result;
};

},{}],337:[function(require,module,exports){
// please no
module['exports'] = function zalgo(text, options) {
  text = text || '   he is here   ';
  var soul = {
    'up': [
      '̍', '̎', '̄', '̅',
      '̿', '̑', '̆', '̐',
      '͒', '͗', '͑', '̇',
      '̈', '̊', '͂', '̓',
      '̈', '͊', '͋', '͌',
      '̃', '̂', '̌', '͐',
      '̀', '́', '̋', '̏',
      '̒', '̓', '̔', '̽',
      '̉', 'ͣ', 'ͤ', 'ͥ',
      'ͦ', 'ͧ', 'ͨ', 'ͩ',
      'ͪ', 'ͫ', 'ͬ', 'ͭ',
      'ͮ', 'ͯ', '̾', '͛',
      '͆', '̚',
    ],
    'down': [
      '̖', '̗', '̘', '̙',
      '̜', '̝', '̞', '̟',
      '̠', '̤', '̥', '̦',
      '̩', '̪', '̫', '̬',
      '̭', '̮', '̯', '̰',
      '̱', '̲', '̳', '̹',
      '̺', '̻', '̼', 'ͅ',
      '͇', '͈', '͉', '͍',
      '͎', '͓', '͔', '͕',
      '͖', '͙', '͚', '̣',
    ],
    'mid': [
      '̕', '̛', '̀', '́',
      '͘', '̡', '̢', '̧',
      '̨', '̴', '̵', '̶',
      '͜', '͝', '͞',
      '͟', '͠', '͢', '̸',
      '̷', '͡', ' ҉',
    ],
  };
  var all = [].concat(soul.up, soul.down, soul.mid);

  function randomNumber(range) {
    var r = Math.floor(Math.random() * range);
    return r;
  }

  function isChar(character) {
    var bool = false;
    all.filter(function(i) {
      bool = (i === character);
    });
    return bool;
  }


  function heComes(text, options) {
    var result = '';
    var counts;
    var l;
    options = options || {};
    options['up'] =
      typeof options['up'] !== 'undefined' ? options['up'] : true;
    options['mid'] =
      typeof options['mid'] !== 'undefined' ? options['mid'] : true;
    options['down'] =
      typeof options['down'] !== 'undefined' ? options['down'] : true;
    options['size'] =
      typeof options['size'] !== 'undefined' ? options['size'] : 'maxi';
    text = text.split('');
    for (l in text) {
      if (isChar(l)) {
        continue;
      }
      result = result + text[l];
      counts = {'up': 0, 'down': 0, 'mid': 0};
      switch (options.size) {
        case 'mini':
          counts.up = randomNumber(8);
          counts.mid = randomNumber(2);
          counts.down = randomNumber(8);
          break;
        case 'maxi':
          counts.up = randomNumber(16) + 3;
          counts.mid = randomNumber(4) + 1;
          counts.down = randomNumber(64) + 3;
          break;
        default:
          counts.up = randomNumber(8) + 1;
          counts.mid = randomNumber(6) / 2;
          counts.down = randomNumber(8) + 1;
          break;
      }

      var arr = ['up', 'mid', 'down'];
      for (var d in arr) {
        var index = arr[d];
        for (var i = 0; i <= counts[index]; i++) {
          if (options[index]) {
            result = result + soul[index][randomNumber(soul[index].length)];
          }
        }
      }
    }
    return result;
  }
  // don't summon him
  return heComes(text, options);
};


},{}],338:[function(require,module,exports){
module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    if (letter === ' ') return letter;
    switch (i%3) {
      case 0: return colors.red(letter);
      case 1: return colors.white(letter);
      case 2: return colors.blue(letter);
    }
  };
};

},{}],339:[function(require,module,exports){
module['exports'] = function(colors) {
  // RoY G BiV
  var rainbowColors = ['red', 'yellow', 'green', 'blue', 'magenta'];
  return function(letter, i, exploded) {
    if (letter === ' ') {
      return letter;
    } else {
      return colors[rainbowColors[i++ % rainbowColors.length]](letter);
    }
  };
};


},{}],340:[function(require,module,exports){
module['exports'] = function(colors) {
  var available = ['underline', 'inverse', 'grey', 'yellow', 'red', 'green',
    'blue', 'white', 'cyan', 'magenta', 'brightYellow', 'brightRed',
    'brightGreen', 'brightBlue', 'brightWhite', 'brightCyan', 'brightMagenta'];
  return function(letter, i, exploded) {
    return letter === ' ' ? letter :
      colors[
          available[Math.round(Math.random() * (available.length - 2))]
      ](letter);
  };
};

},{}],341:[function(require,module,exports){
module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    return i % 2 === 0 ? letter : colors.inverse(letter);
  };
};

},{}],342:[function(require,module,exports){
/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var styles = {};
module['exports'] = styles;

var codes = {
  reset: [0, 0],

  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],

  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  grey: [90, 39],

  brightRed: [91, 39],
  brightGreen: [92, 39],
  brightYellow: [93, 39],
  brightBlue: [94, 39],
  brightMagenta: [95, 39],
  brightCyan: [96, 39],
  brightWhite: [97, 39],

  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgGray: [100, 49],
  bgGrey: [100, 49],

  bgBrightRed: [101, 49],
  bgBrightGreen: [102, 49],
  bgBrightYellow: [103, 49],
  bgBrightBlue: [104, 49],
  bgBrightMagenta: [105, 49],
  bgBrightCyan: [106, 49],
  bgBrightWhite: [107, 49],

  // legacy styles for colors pre v1.0.0
  blackBG: [40, 49],
  redBG: [41, 49],
  greenBG: [42, 49],
  yellowBG: [43, 49],
  blueBG: [44, 49],
  magentaBG: [45, 49],
  cyanBG: [46, 49],
  whiteBG: [47, 49],

};

Object.keys(codes).forEach(function(key) {
  var val = codes[key];
  var style = styles[key] = [];
  style.open = '\u001b[' + val[0] + 'm';
  style.close = '\u001b[' + val[1] + 'm';
});

},{}],343:[function(require,module,exports){
(function (process){(function (){
/*
MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

'use strict';

module.exports = function(flag, argv) {
  argv = argv || process.argv;

  var terminatorPos = argv.indexOf('--');
  var prefix = /^-{1,2}/.test(flag) ? '' : '--';
  var pos = argv.indexOf(prefix + flag);

  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

}).call(this)}).call(this,require('_process'))

},{"_process":696}],344:[function(require,module,exports){
(function (process){(function (){
/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

'use strict';

var os = require('os');
var hasFlag = require('./has-flag.js');

var env = process.env;

var forceColor = void 0;
if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false')) {
  forceColor = false;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true')
           || hasFlag('color=always')) {
  forceColor = true;
}
if ('FORCE_COLOR' in env) {
  forceColor = env.FORCE_COLOR.length === 0
    || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3,
  };
}

function supportsColor(stream) {
  if (forceColor === false) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full')
      || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor !== true) {
    return 0;
  }

  var min = forceColor ? 1 : 0;

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first
    // Windows release that supports 256 colors. Windows 10 build 14931 is the
    // first release that supports 16m/TrueColor.
    var osRelease = os.release().split('.');
    if (Number(process.versions.node.split('.')[0]) >= 8
        && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function(sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return (/^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0
    );
  }

  if ('TERM_PROGRAM' in env) {
    var version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return version >= 3 ? 3 : 2;
      case 'Hyper':
        return 3;
      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  if (env.TERM === 'dumb') {
    return min;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

module.exports = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr),
};

}).call(this)}).call(this,require('_process'))

},{"./has-flag.js":343,"_process":696,"os":462}],345:[function(require,module,exports){
//
// Remark: Requiring this file will use the "safe" colors API,
// which will not touch String.prototype.
//
//   var colors = require('colors/safe');
//   colors.red("foo")
//
//
var colors = require('./lib/colors');
module['exports'] = colors;

},{"./lib/colors":335}],346:[function(require,module,exports){
(function (Buffer){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

}).call(this)}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":433}],347:[function(require,module,exports){
(function (Buffer){(function (){
var elliptic = require('elliptic')
var BN = require('bn.js')

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"bn.js":348,"buffer":322,"elliptic":369}],348:[function(require,module,exports){
arguments[4][270][0].apply(exports,arguments)
},{"buffer":280,"dup":270}],349:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var MD5 = require('md5.js')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Base = require('cipher-base')

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}

},{"cipher-base":334,"inherits":431,"md5.js":451,"ripemd160":720,"sha.js":740}],350:[function(require,module,exports){
var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}

},{"md5.js":451}],351:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Legacy = require('./legacy')
var Base = require('cipher-base')
var Buffer = require('safe-buffer').Buffer
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')

var sha = require('sha.js')

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}

},{"./legacy":352,"cipher-base":334,"create-hash/md5":350,"inherits":431,"ripemd160":720,"safe-buffer":736,"sha.js":740}],352:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var Base = require('cipher-base')

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac

},{"cipher-base":334,"inherits":431,"safe-buffer":736}],353:[function(require,module,exports){
'use strict';

// eslint-disable-next-line no-multi-assign
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require('randombytes');

// eslint-disable-next-line no-multi-assign
exports.createHash = exports.Hash = require('create-hash');

// eslint-disable-next-line no-multi-assign
exports.createHmac = exports.Hmac = require('create-hmac');

var algos = require('browserify-sign/algos');
var algoKeys = Object.keys(algos);
var hashes = [
	'sha1',
	'sha224',
	'sha256',
	'sha384',
	'sha512',
	'md5',
	'rmd160'
].concat(algoKeys);

exports.getHashes = function () {
	return hashes;
};

var p = require('pbkdf2');
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;

var aes = require('browserify-cipher');

exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;

var dh = require('diffie-hellman');

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;

var sign = require('browserify-sign');

exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;

exports.createECDH = require('create-ecdh');

var publicEncrypt = require('public-encrypt');

exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;

// the least I can do is make error messages for the rest of the node.js/crypto api.
// [
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error('sorry, ' + name + ' is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
//   };
// });

var rf = require('randomfill');

exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;

exports.createCredentials = function () {
	throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};

exports.constants = {
	DH_CHECK_P_NOT_SAFE_PRIME: 2,
	DH_CHECK_P_NOT_PRIME: 1,
	DH_UNABLE_TO_CHECK_GENERATOR: 4,
	DH_NOT_SUITABLE_GENERATOR: 8,
	NPN_ENABLED: 1,
	ALPN_ENABLED: 1,
	RSA_PKCS1_PADDING: 1,
	RSA_SSLV23_PADDING: 2,
	RSA_NO_PADDING: 3,
	RSA_PKCS1_OAEP_PADDING: 4,
	RSA_X931_PADDING: 5,
	RSA_PKCS1_PSS_PADDING: 6,
	POINT_CONVERSION_COMPRESSED: 2,
	POINT_CONVERSION_UNCOMPRESSED: 4,
	POINT_CONVERSION_HYBRID: 6
};

},{"browserify-cipher":298,"browserify-sign":305,"browserify-sign/algos":302,"create-ecdh":347,"create-hash":349,"create-hmac":351,"diffie-hellman":363,"pbkdf2":469,"public-encrypt":697,"randombytes":704,"randomfill":705}],354:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),Y=_.prototype;return O.prototype=Y,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){Y[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));
},{}],355:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_customParseFormat=t()}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d/,r=/\d\d/,i=/\d\d?/,o=/\d*[^-_:/,()\s\d]+/,s={},a=function(e){return(e=+e)+(e>68?1900:2e3)};var f=function(e){return function(t){this[e]=+t}},h=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],u=function(e){var t=s[e];return t&&(t.indexOf?t:t.s.concat(t.f))},d=function(e,t){var n,r=s.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},c={A:[o,function(e){this.afternoon=d(e,!1)}],a:[o,function(e){this.afternoon=d(e,!0)}],Q:[n,function(e){this.month=3*(e-1)+1}],S:[n,function(e){this.milliseconds=100*+e}],SS:[r,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[i,f("seconds")],ss:[i,f("seconds")],m:[i,f("minutes")],mm:[i,f("minutes")],H:[i,f("hours")],h:[i,f("hours")],HH:[i,f("hours")],hh:[i,f("hours")],D:[i,f("day")],DD:[r,f("day")],Do:[o,function(e){var t=s.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],w:[i,f("week")],ww:[r,f("week")],M:[i,f("month")],MM:[r,f("month")],MMM:[o,function(e){var t=u("months"),n=(u("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[o,function(e){var t=u("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,f("year")],YY:[r,function(e){this.year=a(e)}],YYYY:[/\d{4}/,f("year")],Z:h,ZZ:h};function l(n){var r,i;r=n,i=s&&s.formats;for(var o=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=o.length,f=0;f<a;f+=1){var h=o[f],u=c[h],d=u&&u[0],l=u&&u[1];o[f]=l?{regex:d,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=o[n];if("string"==typeof i)r+=i.length;else{var s=i.regex,f=i.parser,h=e.slice(r),u=s.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(a=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,o=e.args;this.$u=r;var a=o[1];if("string"==typeof a){var f=!0===o[2],h=!0===o[3],u=f||h,d=o[2];h&&(d=o[2]),s=this.$locale(),!f&&d&&(s=n.Ls[d]),this.$d=function(e,t,n,r){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var i=l(t)(e),o=i.year,s=i.month,a=i.day,f=i.hours,h=i.minutes,u=i.seconds,d=i.milliseconds,c=i.zone,m=i.week,M=new Date,Y=a||(o||s?1:M.getDate()),p=o||M.getFullYear(),v=0;o&&!s||(v=s>0?s-1:M.getMonth());var D,w=f||0,g=h||0,y=u||0,L=d||0;return c?new Date(Date.UTC(p,v,Y,w,g,y,L+60*c.offset*1e3)):n?new Date(Date.UTC(p,v,Y,w,g,y,L)):(D=new Date(p,v,Y,w,g,y,L),m&&(D=r(D).week(m).toDate()),D)}catch(e){return new Date("")}}(t,a,r,n),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),s={}}else if(a instanceof Array)for(var c=a.length,m=1;m<=c;m+=1){o[1]=a[m-1];var M=n.apply(this,o);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===c&&(this.$d=new Date(""))}else i.call(this,e)}}}));
},{}],356:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');

var gopd = require('gopd');

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

},{"es-define-property":386,"es-errors/syntax":391,"es-errors/type":392,"gopd":408}],357:[function(require,module,exports){
'use strict';

exports.utils = require('./des/utils');
exports.Cipher = require('./des/cipher');
exports.DES = require('./des/des');
exports.CBC = require('./des/cbc');
exports.EDE = require('./des/ede');

},{"./des/cbc":358,"./des/cipher":359,"./des/des":360,"./des/ede":361,"./des/utils":362}],358:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};

},{"inherits":431,"minimalistic-assert":454}],359:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
  this.padding = options.padding !== false
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};

},{"minimalistic-assert":454}],360:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var utils = require('./utils');
var Cipher = require('./cipher');

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  if (this.padding === false) {
    return false;
  }

  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  if (this.padding === false) {
    return buffer;
  }

  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};

},{"./cipher":359,"./utils":362,"inherits":431,"minimalistic-assert":454}],361:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var Cipher = require('./cipher');
var DES = require('./des');

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"./cipher":359,"./des":360,"inherits":431,"minimalistic-assert":454}],362:[function(require,module,exports){
'use strict';

exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};

},{}],363:[function(require,module,exports){
(function (Buffer){(function (){
var generatePrime = require('./lib/generatePrime')
var primes = require('./lib/primes.json')

var DH = require('./lib/dh')

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

}).call(this)}).call(this,require("buffer").Buffer)

},{"./lib/dh":364,"./lib/generatePrime":365,"./lib/primes.json":366,"buffer":322}],364:[function(require,module,exports){
(function (Buffer){(function (){
var BN = require('bn.js');
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require('./generatePrime');
var randomBytes = require('randombytes');
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"./generatePrime":365,"bn.js":367,"buffer":322,"miller-rabin":452,"randombytes":704}],365:[function(require,module,exports){
var randomBytes = require('randombytes');
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require('bn.js');
var TWENTYFOUR = new BN(24);
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}

},{"bn.js":367,"miller-rabin":452,"randombytes":704}],366:[function(require,module,exports){
module.exports={
    "modp1": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
    },
    "modp2": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
    },
    "modp5": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
    },
    "modp14": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
    },
    "modp15": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
    },
    "modp16": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
    },
    "modp17": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
    },
    "modp18": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"
    }
}
},{}],367:[function(require,module,exports){
arguments[4][270][0].apply(exports,arguments)
},{"buffer":280,"dup":270}],368:[function(require,module,exports){
'use strict';

var callBind = require('call-bind-apply-helpers');
var gOPD = require('gopd');

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;

},{"call-bind-apply-helpers":330,"gopd":408}],369:[function(require,module,exports){
'use strict';

var elliptic = exports;

elliptic.version = require('../package.json').version;
elliptic.utils = require('./elliptic/utils');
elliptic.rand = require('brorand');
elliptic.curve = require('./elliptic/curve');
elliptic.curves = require('./elliptic/curves');

// Protocols
elliptic.ec = require('./elliptic/ec');
elliptic.eddsa = require('./elliptic/eddsa');

},{"../package.json":385,"./elliptic/curve":372,"./elliptic/curves":375,"./elliptic/ec":376,"./elliptic/eddsa":379,"./elliptic/utils":383,"brorand":279}],370:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

},{"../utils":383,"bn.js":384}],371:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"../utils":383,"./base":370,"bn.js":384,"inherits":431}],372:[function(require,module,exports){
'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');

},{"./base":370,"./edwards":371,"./mont":373,"./short":374}],373:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var utils = require('../utils');

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};

},{"../utils":383,"./base":370,"bn.js":384,"inherits":431}],374:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

},{"../utils":383,"./base":370,"bn.js":384,"inherits":431}],375:[function(require,module,exports){
'use strict';

var curves = exports;

var hash = require('hash.js');
var curve = require('./curve');
var utils = require('./utils');

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = require('./precomputed/secp256k1');
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});

},{"./curve":372,"./precomputed/secp256k1":382,"./utils":383,"hash.js":414}],376:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var HmacDRBG = require('hmac-drbg');
var utils = require('../utils');
var curves = require('../curves');
var rand = require('brorand');
var assert = utils.assert;

var KeyPair = require('./key');
var Signature = require('./signature');

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
  var byteLength;
  if (BN.isBN(msg) || typeof msg === 'number') {
    msg = new BN(msg, 16);
    byteLength = msg.byteLength();
  } else if (typeof msg === 'object') {
    // BN assumes an array-like input and asserts length
    byteLength = msg.length;
    msg = new BN(msg, 16);
  } else {
    // BN converts the value to string
    var str = msg.toString();
    // HEX encoding
    byteLength = (str.length + 1) >>> 1;
    msg = new BN(str, 16);
  }
  // Allow overriding
  if (typeof bitLength !== 'number') {
    bitLength = byteLength * 8;
  }
  var delta = bitLength - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
    assert(typeof msg === 'object' && msg && typeof msg.length === 'number',
      'Expected message to be an array-like, a hex string, or a BN instance');
    assert((msg.length >>> 0) === msg.length); // non-negative 32-bit integer
    for (var i = 0; i < msg.length; i++) assert((msg[i] & 255) === msg[i]);
  }

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(msg, false, options.msgBitLength);

  // Would fail further checks, but let's make the error message clear
  assert(!msg.isNeg(), 'Can not sign a negative message');

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Recheck nonce to be bijective to msg
  assert((new BN(nonce)).eq(msg), 'Can not sign message');

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc, options) {
  if (!options)
    options = {};

  msg = this._truncateToN(msg, false, options.msgBitLength);
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

},{"../curves":375,"../utils":383,"./key":377,"./signature":378,"bn.js":384,"brorand":279,"hmac-drbg":429}],377:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature, options) {
  return this.ec.verify(msg, signature, this, undefined, options);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

},{"../utils":383,"bn.js":384}],378:[function(require,module,exports){
'use strict';

var BN = require('bn.js');

var utils = require('../utils');
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  if(buf[p.place] === 0x00) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};

},{"../utils":383,"bn.js":384}],379:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var curves = require('../curves');
var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require('./key');
var Signature = require('./signature');

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) {
    return false;
  }
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};

},{"../curves":375,"../utils":383,"./key":380,"./signature":381,"hash.js":414}],380:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;

},{"../utils":383}],381:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;

},{"../utils":383,"bn.js":384}],382:[function(require,module,exports){
module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};

},{}],383:[function(require,module,exports){
'use strict';

var utils = exports;
var BN = require('bn.js');
var minAssert = require('minimalistic-assert');
var minUtils = require('minimalistic-crypto-utils');

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  var i;
  for (i = 0; i < naf.length; i += 1) {
    naf[i] = 0;
  }

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;


},{"bn.js":384,"minimalistic-assert":454,"minimalistic-crypto-utils":455}],384:[function(require,module,exports){
arguments[4][270][0].apply(exports,arguments)
},{"buffer":280,"dup":270}],385:[function(require,module,exports){
module.exports={
  "name": "elliptic",
  "version": "6.6.1",
  "description": "EC cryptography",
  "main": "lib/elliptic.js",
  "files": [
    "lib"
  ],
  "scripts": {
    "lint": "eslint lib test",
    "lint:fix": "npm run lint -- --fix",
    "unit": "istanbul test _mocha --reporter=spec test/index.js",
    "test": "npm run lint && npm run unit",
    "version": "grunt dist && git add dist/"
  },
  "repository": {
    "type": "git",
    "url": "git@github.com:indutny/elliptic"
  },
  "keywords": [
    "EC",
    "Elliptic",
    "curve",
    "Cryptography"
  ],
  "author": "Fedor Indutny <fedor@indutny.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/indutny/elliptic/issues"
  },
  "homepage": "https://github.com/indutny/elliptic",
  "devDependencies": {
    "brfs": "^2.0.2",
    "coveralls": "^3.1.0",
    "eslint": "^7.6.0",
    "grunt": "^1.2.1",
    "grunt-browserify": "^5.3.0",
    "grunt-cli": "^1.3.2",
    "grunt-contrib-connect": "^3.0.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-uglify": "^5.0.0",
    "grunt-mocha-istanbul": "^5.0.2",
    "grunt-saucelabs": "^9.0.1",
    "istanbul": "^0.4.5",
    "mocha": "^8.0.1"
  },
  "dependencies": {
    "bn.js": "^4.11.9",
    "brorand": "^1.1.0",
    "hash.js": "^1.0.0",
    "hmac-drbg": "^1.0.1",
    "inherits": "^2.0.4",
    "minimalistic-assert": "^1.0.1",
    "minimalistic-crypto-utils": "^1.0.1"
  }
}

},{}],386:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{}],387:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],388:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],389:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],390:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],391:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],392:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],393:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],394:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Object;

},{}],395:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

},{}],396:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var MD5 = require('md5.js')

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey

},{"md5.js":451,"safe-buffer":736}],397:[function(require,module,exports){
module.exports={
    "name": "fable-serviceproviderbase",
    "version": "3.0.19",
    "description": "Simple base classes for fable services.",
    "main": "source/Fable-ServiceProviderBase.js",
    "scripts": {
        "start": "node source/Fable-ServiceProviderBase.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p . --noEmit"
    },
    "types": "types/source/Fable-ServiceProviderBase.d.ts",
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase.git"
    },
    "keywords": [
        "entity",
        "behavior"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
    "devDependencies": {
        "@types/mocha": "^10.0.10",
        "fable": "^3.1.62",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    }
}

},{}],398:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":397}],399:[function(require,module,exports){
'use strict';

var isCallable = require('is-callable');

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */
var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */
var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */
var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

/** @type {(x: unknown) => x is readonly unknown[]} */
function isArray(x) {
    return toStr.call(x) === '[object Array]';
}

/** @type {import('.')._internal} */
module.exports = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (isArray(list)) {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

},{"is-callable":434}],400:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],401:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":400}],402:[function(require,module,exports){
'use strict';

/** @type {GeneratorFunctionConstructor | false} */
var cached;

/** @type {import('./index.js')} */
module.exports = function getGeneratorFunction() {
	if (typeof cached === 'undefined') {
		try {
			// eslint-disable-next-line no-new-func
			cached = Function('return function* () {}')().constructor;
		} catch (e) {
			cached = false;
		}
	}
	return cached;
};


},{}],403:[function(require,module,exports){
'use strict';

var undefined;

var $Object = require('es-object-atoms');

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var abs = require('math-intrinsics/abs');
var floor = require('math-intrinsics/floor');
var max = require('math-intrinsics/max');
var min = require('math-intrinsics/min');
var pow = require('math-intrinsics/pow');
var round = require('math-intrinsics/round');
var sign = require('math-intrinsics/sign');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = require('gopd');
var $defineProperty = require('es-define-property');

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = require('get-proto');
var $ObjectGPO = require('get-proto/Object.getPrototypeOf');
var $ReflectGPO = require('get-proto/Reflect.getPrototypeOf');

var $apply = require('call-bind-apply-helpers/functionApply');
var $call = require('call-bind-apply-helpers/functionCall');

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"call-bind-apply-helpers/functionApply":328,"call-bind-apply-helpers/functionCall":329,"es-define-property":386,"es-errors":388,"es-errors/eval":387,"es-errors/range":389,"es-errors/ref":390,"es-errors/syntax":391,"es-errors/type":392,"es-errors/uri":393,"es-object-atoms":394,"function-bind":401,"get-proto":406,"get-proto/Object.getPrototypeOf":404,"get-proto/Reflect.getPrototypeOf":405,"gopd":408,"has-symbols":410,"hasown":426,"math-intrinsics/abs":443,"math-intrinsics/floor":444,"math-intrinsics/max":446,"math-intrinsics/min":447,"math-intrinsics/pow":448,"math-intrinsics/round":449,"math-intrinsics/sign":450}],404:[function(require,module,exports){
'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;

},{"es-object-atoms":394}],405:[function(require,module,exports){
'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;

},{}],406:[function(require,module,exports){
'use strict';

var reflectGetProto = require('./Reflect.getPrototypeOf');
var originalGetProto = require('./Object.getPrototypeOf');

var getDunderProto = require('dunder-proto/get');

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;

},{"./Object.getPrototypeOf":404,"./Reflect.getPrototypeOf":405,"dunder-proto/get":368}],407:[function(require,module,exports){
'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;

},{}],408:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"./gOPD":407}],409:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;

},{"es-define-property":386}],410:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":411}],411:[function(require,module,exports){
'use strict';

/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],412:[function(require,module,exports){
'use strict';

var hasSymbols = require('has-symbols/shams');

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

},{"has-symbols/shams":411}],413:[function(require,module,exports){
'use strict'
var Buffer = require('safe-buffer').Buffer
var Transform = require('stream').Transform
var inherits = require('inherits')

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

var useUint8Array = typeof Uint8Array !== 'undefined'
var useArrayBuffer = typeof ArrayBuffer !== 'undefined' &&
  typeof Uint8Array !== 'undefined' &&
  ArrayBuffer.isView &&
  (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT)

function toBuffer (data, encoding) {
  // No need to do anything for exact instance
  // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
  if (data instanceof Buffer) return data

  // Convert strings to Buffer
  if (typeof data === 'string') return Buffer.from(data, encoding)

  /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */
  if (useArrayBuffer && ArrayBuffer.isView(data)) {
    if (data.byteLength === 0) return Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
    var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength)
    // Recheck result size, as offset/length doesn't work on Node.js <5.10
    // We just go to Uint8Array case if this fails
    if (res.byteLength === data.byteLength) return res
  }

  /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */
  if (useUint8Array && data instanceof Uint8Array) return Buffer.from(data)

  /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */
  if (
    Buffer.isBuffer(data) &&
    data.constructor &&
    typeof data.constructor.isBuffer === 'function' &&
    data.constructor.isBuffer(data)
  ) {
    return Buffer.from(data)
  }

  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.')
}

HashBase.prototype.update = function (data, encoding) {
  if (this._finalized) throw new Error('Digest already called')

  data = toBuffer(data, encoding) // asserts correct input type

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase

},{"inherits":431,"safe-buffer":736,"stream":747}],414:[function(require,module,exports){
var hash = exports;

hash.utils = require('./hash/utils');
hash.common = require('./hash/common');
hash.sha = require('./hash/sha');
hash.ripemd = require('./hash/ripemd');
hash.hmac = require('./hash/hmac');

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"./hash/common":415,"./hash/hmac":416,"./hash/ripemd":417,"./hash/sha":418,"./hash/utils":425}],415:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};

},{"./utils":425,"minimalistic-assert":454}],416:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

},{"./utils":425,"minimalistic-assert":454}],417:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var common = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

},{"./common":415,"./utils":425}],418:[function(require,module,exports){
'use strict';

exports.sha1 = require('./sha/1');
exports.sha224 = require('./sha/224');
exports.sha256 = require('./sha/256');
exports.sha384 = require('./sha/384');
exports.sha512 = require('./sha/512');

},{"./sha/1":419,"./sha/224":420,"./sha/256":421,"./sha/384":422,"./sha/512":423}],419:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":415,"../utils":425,"./common":424}],420:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var SHA256 = require('./256');

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};


},{"../utils":425,"./256":421}],421:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');
var assert = require('minimalistic-assert');

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":415,"../utils":425,"./common":424,"minimalistic-assert":454}],422:[function(require,module,exports){
'use strict';

var utils = require('../utils');

var SHA512 = require('./512');

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

},{"../utils":425,"./512":423}],423:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var assert = require('minimalistic-assert');

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

},{"../common":415,"../utils":425,"minimalistic-assert":454}],424:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;

},{"../utils":425}],425:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"inherits":431,"minimalistic-assert":454}],426:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":401}],427:[function(require,module,exports){
module.exports = require('./lib/heap');

},{"./lib/heap":428}],428:[function(require,module,exports){
// Generated by CoffeeScript 1.8.0
(function() {
  var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;

  floor = Math.floor, min = Math.min;


  /*
  Default comparison function to be used
   */

  defaultCmp = function(x, y) {
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  };


  /*
  Insert item x in list a, and keep it sorted assuming a is sorted.
  
  If x is already in a, insert it to the right of the rightmost x.
  
  Optional args lo (default 0) and hi (default a.length) bound the slice
  of a to be searched.
   */

  insort = function(a, x, lo, hi, cmp) {
    var mid;
    if (lo == null) {
      lo = 0;
    }
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (lo < 0) {
      throw new Error('lo must be non-negative');
    }
    if (hi == null) {
      hi = a.length;
    }
    while (lo < hi) {
      mid = floor((lo + hi) / 2);
      if (cmp(x, a[mid]) < 0) {
        hi = mid;
      } else {
        lo = mid + 1;
      }
    }
    return ([].splice.apply(a, [lo, lo - lo].concat(x)), x);
  };


  /*
  Push item onto heap, maintaining the heap invariant.
   */

  heappush = function(array, item, cmp) {
    if (cmp == null) {
      cmp = defaultCmp;
    }
    array.push(item);
    return _siftdown(array, 0, array.length - 1, cmp);
  };


  /*
  Pop the smallest item off the heap, maintaining the heap invariant.
   */

  heappop = function(array, cmp) {
    var lastelt, returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    lastelt = array.pop();
    if (array.length) {
      returnitem = array[0];
      array[0] = lastelt;
      _siftup(array, 0, cmp);
    } else {
      returnitem = lastelt;
    }
    return returnitem;
  };


  /*
  Pop and return the current smallest value, and add the new item.
  
  This is more efficient than heappop() followed by heappush(), and can be
  more appropriate when using a fixed size heap. Note that the value
  returned may be larger than item! That constrains reasonable use of
  this routine unless written as part of a conditional replacement:
      if item > array[0]
        item = heapreplace(array, item)
   */

  heapreplace = function(array, item, cmp) {
    var returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    returnitem = array[0];
    array[0] = item;
    _siftup(array, 0, cmp);
    return returnitem;
  };


  /*
  Fast version of a heappush followed by a heappop.
   */

  heappushpop = function(array, item, cmp) {
    var _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (array.length && cmp(array[0], item) < 0) {
      _ref = [array[0], item], item = _ref[0], array[0] = _ref[1];
      _siftup(array, 0, cmp);
    }
    return item;
  };


  /*
  Transform list into a heap, in-place, in O(array.length) time.
   */

  heapify = function(array, cmp) {
    var i, _i, _j, _len, _ref, _ref1, _results, _results1;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    _ref1 = (function() {
      _results1 = [];
      for (var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--){ _results1.push(_j); }
      return _results1;
    }).apply(this).reverse();
    _results = [];
    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
      i = _ref1[_i];
      _results.push(_siftup(array, i, cmp));
    }
    return _results;
  };


  /*
  Update the position of the given item in the heap.
  This function should be called every time the item is being modified.
   */

  updateItem = function(array, item, cmp) {
    var pos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    pos = array.indexOf(item);
    if (pos === -1) {
      return;
    }
    _siftdown(array, 0, pos, cmp);
    return _siftup(array, pos, cmp);
  };


  /*
  Find the n largest elements in a dataset.
   */

  nlargest = function(array, n, cmp) {
    var elem, result, _i, _len, _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    result = array.slice(0, n);
    if (!result.length) {
      return result;
    }
    heapify(result, cmp);
    _ref = array.slice(n);
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      elem = _ref[_i];
      heappushpop(result, elem, cmp);
    }
    return result.sort(cmp).reverse();
  };


  /*
  Find the n smallest elements in a dataset.
   */

  nsmallest = function(array, n, cmp) {
    var elem, i, los, result, _i, _j, _len, _ref, _ref1, _results;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (n * 10 <= array.length) {
      result = array.slice(0, n).sort(cmp);
      if (!result.length) {
        return result;
      }
      los = result[result.length - 1];
      _ref = array.slice(n);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elem = _ref[_i];
        if (cmp(elem, los) < 0) {
          insort(result, elem, 0, null, cmp);
          result.pop();
          los = result[result.length - 1];
        }
      }
      return result;
    }
    heapify(array, cmp);
    _results = [];
    for (i = _j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; i = 0 <= _ref1 ? ++_j : --_j) {
      _results.push(heappop(array, cmp));
    }
    return _results;
  };

  _siftdown = function(array, startpos, pos, cmp) {
    var newitem, parent, parentpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    newitem = array[pos];
    while (pos > startpos) {
      parentpos = (pos - 1) >> 1;
      parent = array[parentpos];
      if (cmp(newitem, parent) < 0) {
        array[pos] = parent;
        pos = parentpos;
        continue;
      }
      break;
    }
    return array[pos] = newitem;
  };

  _siftup = function(array, pos, cmp) {
    var childpos, endpos, newitem, rightpos, startpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    endpos = array.length;
    startpos = pos;
    newitem = array[pos];
    childpos = 2 * pos + 1;
    while (childpos < endpos) {
      rightpos = childpos + 1;
      if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) {
        childpos = rightpos;
      }
      array[pos] = array[childpos];
      pos = childpos;
      childpos = 2 * pos + 1;
    }
    array[pos] = newitem;
    return _siftdown(array, startpos, pos, cmp);
  };

  Heap = (function() {
    Heap.push = heappush;

    Heap.pop = heappop;

    Heap.replace = heapreplace;

    Heap.pushpop = heappushpop;

    Heap.heapify = heapify;

    Heap.updateItem = updateItem;

    Heap.nlargest = nlargest;

    Heap.nsmallest = nsmallest;

    function Heap(cmp) {
      this.cmp = cmp != null ? cmp : defaultCmp;
      this.nodes = [];
    }

    Heap.prototype.push = function(x) {
      return heappush(this.nodes, x, this.cmp);
    };

    Heap.prototype.pop = function() {
      return heappop(this.nodes, this.cmp);
    };

    Heap.prototype.peek = function() {
      return this.nodes[0];
    };

    Heap.prototype.contains = function(x) {
      return this.nodes.indexOf(x) !== -1;
    };

    Heap.prototype.replace = function(x) {
      return heapreplace(this.nodes, x, this.cmp);
    };

    Heap.prototype.pushpop = function(x) {
      return heappushpop(this.nodes, x, this.cmp);
    };

    Heap.prototype.heapify = function() {
      return heapify(this.nodes, this.cmp);
    };

    Heap.prototype.updateItem = function(x) {
      return updateItem(this.nodes, x, this.cmp);
    };

    Heap.prototype.clear = function() {
      return this.nodes = [];
    };

    Heap.prototype.empty = function() {
      return this.nodes.length === 0;
    };

    Heap.prototype.size = function() {
      return this.nodes.length;
    };

    Heap.prototype.clone = function() {
      var heap;
      heap = new Heap();
      heap.nodes = this.nodes.slice(0);
      return heap;
    };

    Heap.prototype.toArray = function() {
      return this.nodes.slice(0);
    };

    Heap.prototype.insert = Heap.prototype.push;

    Heap.prototype.top = Heap.prototype.peek;

    Heap.prototype.front = Heap.prototype.peek;

    Heap.prototype.has = Heap.prototype.contains;

    Heap.prototype.copy = Heap.prototype.clone;

    return Heap;

  })();

  (function(root, factory) {
    if (typeof define === 'function' && define.amd) {
      return define([], factory);
    } else if (typeof exports === 'object') {
      return module.exports = factory();
    } else {
      return root.Heap = factory();
    }
  })(this, function() {
    return Heap;
  });

}).call(this);

},{}],429:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var utils = require('minimalistic-crypto-utils');
var assert = require('minimalistic-assert');

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};

},{"hash.js":414,"minimalistic-assert":454,"minimalistic-crypto-utils":455}],430:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],431:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],432:[function(require,module,exports){
'use strict';

var hasToStringTag = require('has-tostringtag/shams')();
var callBound = require('call-bound');

var $toString = callBound('Object.prototype.toString');

/** @type {import('.')} */
var isStandardArguments = function isArguments(value) {
	if (
		hasToStringTag
		&& value
		&& typeof value === 'object'
		&& Symbol.toStringTag in value
	) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

/** @type {import('.')} */
var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null
		&& typeof value === 'object'
		&& 'length' in value
		&& typeof value.length === 'number'
		&& value.length >= 0
		&& $toString(value) !== '[object Array]'
		&& 'callee' in value
		&& $toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

/** @type {import('.')} */
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"call-bound":333,"has-tostringtag/shams":412}],433:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],434:[function(require,module,exports){
'use strict';

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};

},{}],435:[function(require,module,exports){
'use strict';

var callBound = require('call-bound');
var safeRegexTest = require('safe-regex-test');
var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
var hasToStringTag = require('has-tostringtag/shams')();
var getProto = require('get-proto');

var toStr = callBound('Object.prototype.toString');
var fnToStr = callBound('Function.prototype.toString');

var getGeneratorFunction = require('generator-function');

/** @type {import('.')} */
module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex(fnToStr(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	var GeneratorFunction = getGeneratorFunction();
	return GeneratorFunction && getProto(fn) === GeneratorFunction.prototype;
};

},{"call-bound":333,"generator-function":402,"get-proto":406,"has-tostringtag/shams":412,"safe-regex-test":737}],436:[function(require,module,exports){
'use strict';

var callBound = require('call-bound');
var hasToStringTag = require('has-tostringtag/shams')();
var hasOwn = require('hasown');
var gOPD = require('gopd');

/** @type {import('.')} */
var fn;

if (hasToStringTag) {
	/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
	var $exec = callBound('RegExp.prototype.exec');
	/** @type {object} */
	var isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
	var badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}

	/** @type {import('.')} */
	// @ts-expect-error TS can't figure out that the $exec call always throws
	// eslint-disable-next-line consistent-return
	fn = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			// eslint-disable-next-line no-extra-parens
			$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
		} catch (e) {
			return e === isRegexMarker;
		}
	};
} else {
	/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
	var $toString = callBound('Object.prototype.toString');
	/** @const @type {'[object RegExp]'} */
	var regexClass = '[object RegExp]';

	/** @type {import('.')} */
	fn = function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};
}

module.exports = fn;

},{"call-bound":333,"gopd":408,"has-tostringtag/shams":412,"hasown":426}],437:[function(require,module,exports){
'use strict';

var whichTypedArray = require('which-typed-array');

/** @type {import('.')} */
module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};

},{"which-typed-array":757}],438:[function(require,module,exports){
arguments[4][308][0].apply(exports,arguments)
},{"dup":308}],439:[function(require,module,exports){
const color = require('colors/safe')

const { extendedTypeOf } = require('./util')

const Theme = {
  ' ' (s) { return s },
  '+': color.green,
  '-': color.red
}

const subcolorizeToCallback = function (options, key, diff, output, color, indent) {
  let subvalue
  const prefix = key ? `${key}: ` : ''
  const subindent = indent + '  '

  const outputElisions = (n) => {
    const maxElisions = options.maxElisions === undefined ? Infinity : options.maxElisions
    if (n < maxElisions) {
      for (let i = 0; i < n; i++) {
        output(' ', subindent + '...')
      }
    } else {
      output(' ', subindent + `... (${n} entries)`)
    }
  }

  switch (extendedTypeOf(diff)) {
    case 'object':
      if (('__old' in diff) && ('__new' in diff) && (Object.keys(diff).length === 2)) {
        subcolorizeToCallback(options, key, diff.__old, output, '-', indent)
        return subcolorizeToCallback(options, key, diff.__new, output, '+', indent)
      } else {
        output(color, `${indent}${prefix}{`)
        for (const subkey of Object.keys(diff)) {
          let m
          subvalue = diff[subkey]
          if ((m = subkey.match(/^(.*)__deleted$/))) {
            subcolorizeToCallback(options, m[1], subvalue, output, '-', subindent)
          } else if ((m = subkey.match(/^(.*)__added$/))) {
            subcolorizeToCallback(options, m[1], subvalue, output, '+', subindent)
          } else {
            subcolorizeToCallback(options, subkey, subvalue, output, color, subindent)
          }
        }
        return output(color, `${indent}}`)
      }

    case 'array': {
      output(color, `${indent}${prefix}[`)

      let looksLikeDiff = true
      for (const item of diff) {
        if ((extendedTypeOf(item) !== 'array') || !((item.length === 2) || ((item.length === 1) && (item[0] === ' '))) || !(typeof (item[0]) === 'string') || (item[0].length !== 1) || !([' ', '-', '+', '~'].includes(item[0]))) {
          looksLikeDiff = false
        }
      }

      if (looksLikeDiff) {
        let op
        let elisionCount = 0
        for ([op, subvalue] of diff) {
          if (op === ' ' && subvalue == null) {
            elisionCount++
          } else {
            if (elisionCount > 0) {
              outputElisions(elisionCount)
            }
            elisionCount = 0

            if (![' ', '~', '+', '-'].includes(op)) {
              throw new Error(`Unexpected op '${op}' in ${JSON.stringify(diff, null, 2)}`)
            }
            if (op === '~') { op = ' ' }
            subcolorizeToCallback(options, '', subvalue, output, op, subindent)
          }
        }
        if (elisionCount > 0) {
          outputElisions(elisionCount)
        }
      } else {
        for (subvalue of diff) {
          subcolorizeToCallback(options, '', subvalue, output, color, subindent)
        }
      }

      return output(color, `${indent}]`)
    }

    default:
      if (diff === 0 || diff === null || diff === false || diff === '' || diff) {
        return output(color, indent + prefix + JSON.stringify(diff))
      }
  }
}

const colorizeToCallback = (diff, options, output) =>
  subcolorizeToCallback(options, '', diff, output, ' ', '')

const colorizeToArray = function (diff, options = {}) {
  const output = []
  colorizeToCallback(diff, options, (color, line) => output.push(`${color}${line}`))
  return output
}

const colorize = function (diff, options = {}) {
  const output = []
  colorizeToCallback(diff, options, function (color, line) {
    if (options.color != null ? options.color : true) {
      return output.push(((options.theme != null ? options.theme[color] : undefined) != null ? (options.theme != null ? options.theme[color] : undefined) : Theme[color])(`${color}${line}`) + '\n')
    } else {
      return output.push(`${color}${line}\n`)
    }
  })
  return output.join('')
}

module.exports = { colorize, colorizeToArray, colorizeToCallback }

},{"./util":441,"colors/safe":345}],440:[function(require,module,exports){
const { SequenceMatcher } = require('@ewoudenberg/difflib')
const { extendedTypeOf, roundObj } = require('./util')
const { colorize, colorizeToCallback } = require('./colorize')

class JsonDiff {
  constructor (options) {
    options.outputKeys = options.outputKeys || []
    options.excludeKeys = options.excludeKeys || []
    this.options = options
  }

  isScalar (obj) {
    return typeof obj !== 'object' || obj === null
  }

  objectDiff (obj1, obj2) {
    let result = {}
    let score = 0
    let equal = true

    for (const [key, value] of Object.entries(obj1)) {
      if (!this.options.outputNewOnly) {
        const postfix = '__deleted'

        if (!(key in obj2) && !(this.options.excludeKeys.includes(key))) {
          result[`${key}${postfix}`] = value
          score -= 30
          equal = false
        }
      }
    }

    for (const [key, value] of Object.entries(obj2)) {
      const postfix = !this.options.outputNewOnly ? '__added' : ''

      if (!(key in obj1) && !(this.options.excludeKeys.includes(key))) {
        result[`${key}${postfix}`] = value
        score -= 30
        equal = false
      }
    }

    for (const [key, value1] of Object.entries(obj1)) {
      if (key in obj2) {
        if (this.options.excludeKeys.includes(key)) {
          continue
        }
        score += 20
        const value2 = obj2[key]
        const change = this.diff(value1, value2)
        if (!change.equal) {
          result[key] = change.result
          equal = false
        } else if (this.options.full || this.options.outputKeys.includes(key)) {
          result[key] = value1
        }
        // console.log(`key ${key} change.score=${change.score} ${change.result}`)
        score += Math.min(20, Math.max(-10, change.score / 5)) // BATMAN!
      }
    }

    if (equal) {
      score = 100 * Math.max(Object.keys(obj1).length, 0.5)
      if (!this.options.full) {
        result = undefined
      }
    } else {
      score = Math.max(0, score)
    }

    // console.log(`objectDiff(${JSON.stringify(obj1, null, 2)} <=> ${JSON.stringify(obj2, null, 2)}) == ${JSON.stringify({score, result, equal})}`)
    return { score, result, equal }
  }

  findMatchingObject (item, index, fuzzyOriginals) {
    // console.log('findMatchingObject: ' + JSON.stringify({item, fuzzyOriginals}, null, 2))
    let bestMatch = null

    for (const [key, { item: candidate, index: matchIndex }] of Object.entries(fuzzyOriginals)) {
      if (key !== '__next') {
        const indexDistance = Math.abs(matchIndex - index)
        if (extendedTypeOf(item) === extendedTypeOf(candidate)) {
          const { score } = this.diff(item, candidate)
          if (
            !bestMatch ||
            score > bestMatch.score ||
            (score === bestMatch.score &&
              indexDistance < bestMatch.indexDistance)
          ) {
            bestMatch = { score, key, indexDistance }
          }
        }
      }
    }

    // console.log('findMatchingObject result = ' + JSON.stringify(bestMatch, null, 2));
    return bestMatch
  }

  scalarize (array, originals, fuzzyOriginals) {
    // console.log('scalarize', array, originals, fuzzyOriginals);
    const fuzzyMatches = []
    if (fuzzyOriginals) {
      // Find best fuzzy match for each object in the array
      const keyScores = {}
      for (let index = 0; index < array.length; index++) {
        const item = array[index]
        if (this.isScalar(item)) {
          continue
        }
        const bestMatch = this.findMatchingObject(item, index, fuzzyOriginals)
        if (bestMatch && (!keyScores[bestMatch.key] || bestMatch.score > keyScores[bestMatch.key].score)) {
          keyScores[bestMatch.key] = { score: bestMatch.score, index }
        }
      }
      for (const [key, match] of Object.entries(keyScores)) {
        fuzzyMatches[match.index] = key
      }
    }

    const result = []
    for (let index = 0; index < array.length; index++) {
      const item = array[index]
      if (this.isScalar(item)) {
        result.push(item)
      } else {
        const key = fuzzyMatches[index] || '__$!SCALAR' + originals.__next++
        originals[key] = { item, index }
        result.push(key)
      }
    }
    // console.log('Scalarize result', result);
    return result
  }

  isScalarized (item, originals) {
    return typeof item === 'string' && item in originals
  }

  descalarize (item, originals) {
    if (this.isScalarized(item, originals)) {
      return originals[item].item
    } else {
      return item
    }
  }

  arrayDiff (obj1, obj2) {
    const originals1 = { __next: 1 }
    const seq1 = this.scalarize(obj1, originals1)
    const originals2 = { __next: originals1.__next }
    const seq2 = this.scalarize(obj2, originals2, originals1)

    if (this.options.sort) {
      seq1.sort()
      seq2.sort()
    }
    const opcodes = new SequenceMatcher(null, seq1, seq2).getOpcodes()

    // console.log(`arrayDiff:\nobj1 = ${JSON.stringify(obj1, null, 2)}\nobj2 = ${JSON.stringify(obj2, null, 2)}\nseq1 = ${JSON.stringify(seq1, null, 2)}\nseq2 = ${JSON.stringify(seq2, null, 2)}\nopcodes = ${JSON.stringify(opcodes, null, 2)}`)

    let result = []
    let score = 0
    let equal = true

    for (const [op, i1, i2, j1, j2] of opcodes) {
      let i, j
      let asc, end
      let asc1, end1
      let asc2, end2
      if (!(op === 'equal' || (this.options.keysOnly && op === 'replace'))) {
        equal = false
      }

      switch (op) {
        case 'equal':
          for (
            i = i1, end = i2, asc = i1 <= end;
            asc ? i < end : i > end;
            asc ? i++ : i--
          ) {
            const item = seq1[i]
            if (this.isScalarized(item, originals1)) {
              if (!this.isScalarized(item, originals2)) {
                throw new Error(
                  `internal bug: isScalarized(item, originals1) != isScalarized(item, originals2) for item ${JSON.stringify(
                    item
                  )}`
                )
              }
              const item1 = this.descalarize(item, originals1)
              const item2 = this.descalarize(item, originals2)
              const change = this.diff(item1, item2)
              if (!change.equal) {
                result.push(['~', change.result])
                equal = false
              } else {
                if (this.options.full || this.options.keepUnchangedValues) {
                  result.push([' ', item1])
                } else {
                  result.push([' '])
                }
              }
            } else {
              if (this.options.full || this.options.keepUnchangedValues) {
                result.push([' ', item])
              } else {
                result.push([' '])
              }
            }
            score += 10
          }
          break
        case 'delete':
          for (
            i = i1, end1 = i2, asc1 = i1 <= end1;
            asc1 ? i < end1 : i > end1;
            asc1 ? i++ : i--
          ) {
            result.push(['-', this.descalarize(seq1[i], originals1)])
            score -= 5
          }
          break
        case 'insert':
          for (
            j = j1, end2 = j2, asc2 = j1 <= end2;
            asc2 ? j < end2 : j > end2;
            asc2 ? j++ : j--
          ) {
            result.push(['+', this.descalarize(seq2[j], originals2)])
            score -= 5
          }
          break
        case 'replace':
          if (!this.options.keysOnly) {
            let asc3, end3
            let asc4, end4
            for (
              i = i1, end3 = i2, asc3 = i1 <= end3;
              asc3 ? i < end3 : i > end3;
              asc3 ? i++ : i--
            ) {
              result.push(['-', this.descalarize(seq1[i], originals1)])
              score -= 5
            }
            for (
              j = j1, end4 = j2, asc4 = j1 <= end4;
              asc4 ? j < end4 : j > end4;
              asc4 ? j++ : j--
            ) {
              result.push(['+', this.descalarize(seq2[j], originals2)])
              score -= 5
            }
          } else {
            let asc5, end5
            for (
              i = i1, end5 = i2, asc5 = i1 <= end5;
              asc5 ? i < end5 : i > end5;
              asc5 ? i++ : i--
            ) {
              const change = this.diff(
                this.descalarize(seq1[i], originals1),
                this.descalarize(seq2[i - i1 + j1], originals2)
              )
              if (!change.equal) {
                result.push(['~', change.result])
                equal = false
              } else {
                result.push([' '])
              }
            }
          }
          break
      }
    }

    if (equal || opcodes.length === 0) {
      if (!this.options.full) {
        result = undefined
      } else {
        result = obj1
      }
      score = 100
    } else {
      score = Math.max(0, score)
    }

    return { score, result, equal }
  }

  diff (obj1, obj2) {
    const type1 = extendedTypeOf(obj1)
    const type2 = extendedTypeOf(obj2)

    if (type1 === type2) {
      switch (type1) {
        case 'object':
          return this.objectDiff(obj1, obj2)

        case 'array':
          return this.arrayDiff(obj1, obj2)
      }
    }

    // Compare primitives or complex objects of different types
    let score = 100
    let result = obj1
    let equal
    if (!this.options.keysOnly) {
      if (type1 === 'date' && type2 === 'date') {
        equal = obj1.getTime() === obj2.getTime()
      } else {
        equal = obj1 === obj2
      }
      if (!equal) {
        score = 0

        if (this.options.outputNewOnly) {
          result = obj2
        } else {
          result = { __old: obj1, __new: obj2 }
        }
      } else if (!this.options.full) {
        result = undefined
      }
    } else {
      equal = true
      result = undefined
    }

    // console.log(`diff: equal ${equal} obj1 ${obj1} obj2 ${obj2} score ${score} ${result || ''}`)

    return { score, result, equal }
  }
}

function diff (obj1, obj2, options = {}) {
  if (options.precision !== undefined) {
    obj1 = roundObj(obj1, options.precision)
    obj2 = roundObj(obj2, options.precision)
  }
  return new JsonDiff(options).diff(obj1, obj2).result
}

function diffString (obj1, obj2, options = {}) {
  return colorize(diff(obj1, obj2, options), options)
}

module.exports = { diff, diffString, colorize, colorizeToCallback }

},{"./colorize":439,"./util":441,"@ewoudenberg/difflib":254}],441:[function(require,module,exports){
const extendedTypeOf = function (obj) {
  const result = typeof obj
  if (obj == null) {
    return 'null'
  } else if (result === 'object' && obj.constructor === Array) {
    return 'array'
  } else if (result === 'object' && obj instanceof Date) {
    return 'date'
  } else {
    return result
  }
}

const roundObj = function (data, precision) {
  const type = typeof data
  if (type === 'array') {
    return data.map((x) => roundObj(x, precision))
  } else if (type === 'object') {
    for (const key in data) {
      data[key] = roundObj(data[key], precision)
    }
    return data
  } else if (
    type === 'number' &&
    Number.isFinite(data) &&
    !Number.isInteger(data)
  ) {
    return +data.toFixed(precision)
  } else {
    return data
  }
}

module.exports = { extendedTypeOf, roundObj }

},{}],442:[function(require,module,exports){
/**
 * marked v14.1.4 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

    /**
     * Gets the original marked default options.
     */
    function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null,
        };
    }
    exports.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports.defaults = newDefaults;
    }

    /**
     * Helpers
     */
    const escapeTest = /[&<>"']/;
    const escapeReplace = new RegExp(escapeTest.source, 'g');
    const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
    const escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    };
    const getEscapeReplacement = (ch) => escapeReplacements[ch];
    function escape$1(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) {
                return html.replace(escapeReplace, getEscapeReplacement);
            }
        }
        else {
            if (escapeTestNoEncode.test(html)) {
                return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
            }
        }
        return html;
    }
    const caret = /(^|[^\[])\^/g;
    function edit(regex, opt) {
        let source = typeof regex === 'string' ? regex : regex.source;
        opt = opt || '';
        const obj = {
            replace: (name, val) => {
                let valSource = typeof val === 'string' ? val : val.source;
                valSource = valSource.replace(caret, '$1');
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: () => {
                return new RegExp(source, opt);
            },
        };
        return obj;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(/%25/g, '%');
        }
        catch {
            return null;
        }
        return href;
    }
    const noopTest = { exec: () => null };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(/\|/g, (match, offset, str) => {
            let escaped = false;
            let curr = offset;
            while (--curr >= 0 && str[curr] === '\\')
                escaped = !escaped;
            if (escaped) {
                // odd number of slashes means | is escaped
                // so we leave it alone
                return '|';
            }
            else {
                // add space before unescaped |
                return ' |';
            }
        }), cells = row.split(/ \|/);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) {
            cells.shift();
        }
        if (cells.length > 0 && !cells[cells.length - 1].trim()) {
            cells.pop();
        }
        if (count) {
            if (cells.length > count) {
                cells.splice(count);
            }
            else {
                while (cells.length < count)
                    cells.push('');
            }
        }
        for (; i < cells.length; i++) {
            // leading or trailing whitespace is ignored per the gfm spec
            cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        }
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */
    function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) {
            return '';
        }
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while (suffLen < l) {
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) {
                suffLen++;
            }
            else if (currChar !== c && invert) {
                suffLen++;
            }
            else {
                break;
            }
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) {
            return -1;
        }
        let level = 0;
        for (let i = 0; i < str.length; i++) {
            if (str[i] === '\\') {
                i++;
            }
            else if (str[i] === b[0]) {
                level++;
            }
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) {
                    return i;
                }
            }
        }
        return -1;
    }

    function outputLink(cap, link, raw, lexer) {
        const href = link.href;
        const title = link.title ? escape$1(link.title) : null;
        const text = cap[1].replace(/\\([\[\]])/g, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            const token = {
                type: 'link',
                raw,
                href,
                title,
                text,
                tokens: lexer.inlineTokens(text),
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw,
            href,
            title,
            text: escape$1(text),
        };
    }
    function indentCodeCompensation(raw, text) {
        const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) {
            return text;
        }
        const indentToCode = matchIndentToCode[1];
        return text
            .split('\n')
            .map(node => {
            const matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) {
                return node;
            }
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) {
                return node.slice(indentToCode.length);
            }
            return node;
        })
            .join('\n');
    }
    /**
     * Tokenizer
     */
    class _Tokenizer {
        options;
        rules; // set by the lexer
        lexer; // set by the lexer
        constructor(options) {
            this.options = options || exports.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) {
                return {
                    type: 'space',
                    raw: cap[0],
                };
            }
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(/^(?: {1,4}| {0,3}\t)/gm, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic
                        ? rtrim(text, '\n')
                        : text,
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || '');
                return {
                    type: 'code',
                    raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                    text,
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    const trimmed = rtrim(text, '#');
                    if (this.options.pedantic) {
                        text = trimmed.trim();
                    }
                    else if (!trimmed || / $/.test(trimmed)) {
                        // CommonMark requires space before trailing #s
                        text = trimmed.trim();
                    }
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text,
                    tokens: this.lexer.inline(text),
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) {
                return {
                    type: 'hr',
                    raw: rtrim(cap[0], '\n'),
                };
            }
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], '\n').split('\n');
                let raw = '';
                let text = '';
                const tokens = [];
                while (lines.length > 0) {
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for (i = 0; i < lines.length; i++) {
                        // get lines up to a continuation
                        if (/^ {0,3}>/.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        }
                        else if (!inBlockquote) {
                            currentLines.push(lines[i]);
                        }
                        else {
                            break;
                        }
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join('\n');
                    const currentText = currentRaw
                        // precede setext continuation with 4 spaces so it isn't a setext
                        .replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, '\n    $1')
                        .replace(/^ {0,3}>[ \t]?/gm, '');
                    raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                    text = text ? `${text}\n${currentText}` : currentText;
                    // parse blockquote lines as top level tokens
                    // merge paragraphs if this is a continuation
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    // if there is no continuation then we are done
                    if (lines.length === 0) {
                        break;
                    }
                    const lastToken = tokens[tokens.length - 1];
                    if (lastToken?.type === 'code') {
                        // blockquote continuation cannot be preceded by a code block
                        break;
                    }
                    else if (lastToken?.type === 'blockquote') {
                        // include continuation in nested blockquote
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    }
                    else if (lastToken?.type === 'list') {
                        // include continuation in nested list
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens[tokens.length - 1].raw.length).split('\n');
                        continue;
                    }
                }
                return {
                    type: 'blockquote',
                    raw,
                    tokens,
                    text,
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: [],
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) {
                    bull = isordered ? bull : '[*+-]';
                }
                // Get next list item
                const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while (src) {
                    let endEarly = false;
                    let raw = '';
                    let itemContents = '';
                    if (!(cap = itemRegex.exec(src))) {
                        break;
                    }
                    if (this.rules.block.hr.test(src)) { // End list if bullet was actually HR (possibly move into itemRegex?)
                        break;
                    }
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split('\n', 1)[0].replace(/^\t+/, (t) => ' '.repeat(3 * t.length));
                    let nextLine = src.split('\n', 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    }
                    else if (blankLine) {
                        indent = cap[1].length + 1;
                    }
                    else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && /^[ \t]*$/.test(nextLine)) { // Items begin with at most one blank line
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                        const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                        const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                        const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                        const htmlBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, 'i');
                        // Check if following lines should be included in List Item
                        while (src) {
                            const rawLine = src.split('\n', 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                                nextLineWithoutTabs = nextLine;
                            }
                            else {
                                nextLineWithoutTabs = nextLine.replace(/\t/g, '    ');
                            }
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) {
                                break;
                            }
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) {
                                break;
                            }
                            // End list item if found start of html block
                            if (htmlBeginRegex.test(nextLine)) {
                                break;
                            }
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) {
                                break;
                            }
                            // Horizontal rule found
                            if (hrRegex.test(nextLine)) {
                                break;
                            }
                            if (nextLineWithoutTabs.search(/[^ ]/) >= indent || !nextLine.trim()) { // Dedent if possible
                                itemContents += '\n' + nextLineWithoutTabs.slice(indent);
                            }
                            else {
                                // not enough indentation
                                if (blankLine) {
                                    break;
                                }
                                // paragraph continuation unless last line was a different block level element
                                if (line.replace(/\t/g, '    ').search(/[^ ]/) >= 4) { // indented code block
                                    break;
                                }
                                if (fencesBeginRegex.test(line)) {
                                    break;
                                }
                                if (headingBeginRegex.test(line)) {
                                    break;
                                }
                                if (hrRegex.test(line)) {
                                    break;
                                }
                                itemContents += '\n' + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) { // Check if current line is blank
                                blankLine = true;
                            }
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) {
                            list.loose = true;
                        }
                        else if (/\n[ \t]*\n[ \t]*$/.test(raw)) {
                            endsWithBlankLine = true;
                        }
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: [],
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = list.items[list.items.length - 1].raw.trimEnd();
                list.items[list.items.length - 1].text = list.items[list.items.length - 1].text.trimEnd();
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for (let i = 0; i < list.items.length; i++) {
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter(t => t.type === 'space');
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some(t => /\n.*\n/.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) {
                    for (let i = 0; i < list.items.length; i++) {
                        list.items[i].loose = true;
                    }
                }
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: 'html',
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                    text: cap[0],
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
                const href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
                return {
                    type: 'def',
                    tag,
                    raw: cap[0],
                    href,
                    title,
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) {
                return;
            }
            if (!/[:|]/.test(cap[2])) {
                // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
                return;
            }
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(/^\||\| *$/g, '').split('|');
            const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : [];
            const item = {
                type: 'table',
                raw: cap[0],
                header: [],
                align: [],
                rows: [],
            };
            if (headers.length !== aligns.length) {
                // header and align columns must be equal, rows can be different.
                return;
            }
            for (const align of aligns) {
                if (/^ *-+: *$/.test(align)) {
                    item.align.push('right');
                }
                else if (/^ *:-+: *$/.test(align)) {
                    item.align.push('center');
                }
                else if (/^ *:-+ *$/.test(align)) {
                    item.align.push('left');
                }
                else {
                    item.align.push(null);
                }
            }
            for (let i = 0; i < headers.length; i++) {
                item.header.push({
                    text: headers[i],
                    tokens: this.lexer.inline(headers[i]),
                    header: true,
                    align: item.align[i],
                });
            }
            for (const row of rows) {
                item.rows.push(splitCells(row, item.header.length).map((cell, i) => {
                    return {
                        text: cell,
                        tokens: this.lexer.inline(cell),
                        header: false,
                        align: item.align[i],
                    };
                }));
            }
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) {
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[2].charAt(0) === '=' ? 1 : 2,
                    text: cap[1],
                    tokens: this.lexer.inline(cap[1]),
                };
            }
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === '\n'
                    ? cap[1].slice(0, -1)
                    : cap[1];
                return {
                    type: 'paragraph',
                    raw: cap[0],
                    text,
                    tokens: this.lexer.inline(text),
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) {
                return {
                    type: 'text',
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0]),
                };
            }
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) {
                return {
                    type: 'escape',
                    raw: cap[0],
                    text: escape$1(cap[1]),
                };
            }
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
                    this.lexer.state.inLink = true;
                }
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
                    this.lexer.state.inLink = false;
                }
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
                    this.lexer.state.inRawBlock = true;
                }
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
                    this.lexer.state.inRawBlock = false;
                }
                return {
                    type: 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0],
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!(/>$/.test(trimmedUrl))) {
                        return;
                    }
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
                        return;
                    }
                }
                else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                let href = cap[2];
                let title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                }
                else {
                    title = cap[3] ? cap[3].slice(1, -1) : '';
                }
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !(/>$/.test(trimmedUrl))) {
                        // pedantic allows starting angle bracket without ending angle bracket
                        href = href.slice(1);
                    }
                    else {
                        href = href.slice(1, -1);
                    }
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title,
                }, cap[0], this.lexer);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src))
                || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text,
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        }
        emStrong(src, maskedSrc, prevChar = '') {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match)
                return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/[\p{L}\p{N}]/u))
                return;
            const nextChar = match[1] || match[2] || '';
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [...match[0]].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while ((match = endReg.exec(maskedSrc)) != null) {
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim)
                        continue; // skip single * in __abc*abc__
                    rLength = [...rDelim].length;
                    if (match[3] || match[4]) { // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    }
                    else if (match[5] || match[6]) { // either Left or Right Delim
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0)
                        continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [...match[0]][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: 'em',
                            raw,
                            text,
                            tokens: this.lexer.inlineTokens(text),
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: 'strong',
                        raw,
                        text,
                        tokens: this.lexer.inlineTokens(text),
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(/\n/g, ' ');
                const hasNonSpaceChars = /[^ ]/.test(text);
                const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
                    text = text.substring(1, text.length - 1);
                }
                text = escape$1(text, true);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text,
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) {
                return {
                    type: 'br',
                    raw: cap[0],
                };
            }
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) {
                return {
                    type: 'del',
                    raw: cap[0],
                    text: cap[2],
                    tokens: this.lexer.inlineTokens(cap[2]),
                };
            }
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === '@') {
                    text = escape$1(cap[1]);
                    href = 'mailto:' + text;
                }
                else {
                    text = escape$1(cap[1]);
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text,
                    href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text,
                        },
                    ],
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === '@') {
                    text = escape$1(cap[0]);
                    href = 'mailto:' + text;
                }
                else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                    } while (prevCapZero !== cap[0]);
                    text = escape$1(cap[0]);
                    if (cap[1] === 'www.') {
                        href = 'http://' + cap[0];
                    }
                    else {
                        href = cap[0];
                    }
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text,
                    href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text,
                        },
                    ],
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                let text;
                if (this.lexer.state.inRawBlock) {
                    text = cap[0];
                }
                else {
                    text = escape$1(cap[0]);
                }
                return {
                    type: 'text',
                    raw: cap[0],
                    text,
                };
            }
        }
    }

    /**
     * Block-Level Grammar
     */
    const newline = /^(?:[ \t]*(?:\n|$))+/;
    const blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/)
        .replace(/bull/g, bullet) // lists can interrupt
        .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
        .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
        .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
        .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
        .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
        .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/)
        .replace('label', _blockLabel)
        .replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/)
        .getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/)
        .replace(/bull/g, bullet)
        .getRegex();
    const _tag = 'address|article|aside|base|basefont|blockquote|body|caption'
        + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
        + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
        + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
        + '|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title'
        + '|tr|track|ul';
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit('^ {0,3}(?:' // optional indentation
        + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
        + '|comment[^\\n]*(\\n+|$)' // (2)
        + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
        + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
        + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
        + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ \t]*)+\\n|$)' // (6)
        + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ \t]*)+\\n|$)' // (7) open tag
        + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ \t]*)+\\n|$)' // (7) closing tag
        + ')', 'i')
        .replace('comment', _comment)
        .replace('tag', _tag)
        .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
        .getRegex();
    const paragraph = edit(_paragraph)
        .replace('hr', hr)
        .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
        .replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
        .replace('|table', '')
        .replace('blockquote', ' {0,3}>')
        .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
        .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
        .replace('tag', _tag) // pars can be interrupted by type (6) html blocks
        .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/)
        .replace('paragraph', paragraph)
        .getRegex();
    /**
     * Normal Block Grammar
     */
    const blockNormal = {
        blockquote,
        code: blockCode,
        def,
        fences,
        heading,
        hr,
        html,
        lheading,
        list,
        newline,
        paragraph,
        table: noopTest,
        text: blockText,
    };
    /**
     * GFM Block Grammar
     */
    const gfmTable = edit('^ *([^\\n ].*)\\n' // Header
        + ' {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)' // Align
        + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)') // Cells
        .replace('hr', hr)
        .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
        .replace('blockquote', ' {0,3}>')
        .replace('code', '(?: {4}| {0,3}\t)[^\\n]')
        .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
        .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
        .replace('tag', _tag) // tables can be interrupted by type (6) html blocks
        .getRegex();
    const blockGfm = {
        ...blockNormal,
        table: gfmTable,
        paragraph: edit(_paragraph)
            .replace('hr', hr)
            .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
            .replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
            .replace('table', gfmTable) // interrupt paragraphs with table
            .replace('blockquote', ' {0,3}>')
            .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
            .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
            .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
            .replace('tag', _tag) // pars can be interrupted by type (6) html blocks
            .getRegex(),
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */
    const blockPedantic = {
        ...blockNormal,
        html: edit('^ *(?:comment *(?:\\n|\\s*$)'
            + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
            + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
            .replace('comment', _comment)
            .replace(/tag/g, '(?!(?:'
            + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
            + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
            + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
            .getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest, // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph)
            .replace('hr', hr)
            .replace('heading', ' *#{1,6} *[^\n]')
            .replace('lheading', lheading)
            .replace('|table', '')
            .replace('blockquote', ' {0,3}>')
            .replace('|fences', '')
            .replace('|list', '')
            .replace('|html', '')
            .replace('|tag', '')
            .getRegex(),
    };
    /**
     * Inline-Level Grammar
     */
    const escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = '\\p{P}\\p{S}';
    const punctuation = edit(/^((?![*_])[\spunctuation])/, 'u')
        .replace(/punctuation/g, _punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, 'u')
        .replace(/punct/g, _punctuation)
        .getRegex();
    const emStrongRDelimAst = edit('^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)' // Skip orphan inside strong
        + '|[^*]+(?=[^*])' // Consume to delim
        + '|(?!\\*)[punct](\\*+)(?=[\\s]|$)' // (1) #*** can only be a Right Delimiter
        + '|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)' // (2) a***#, a*** can only be a Right Delimiter
        + '|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])' // (3) #***a, ***a can only be Left Delimiter
        + '|[\\s](\\*+)(?!\\*)(?=[punct])' // (4) ***# can only be Left Delimiter
        + '|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])' // (5) #***# can be either Left or Right Delimiter
        + '|[^punct\\s](\\*+)(?=[^punct\\s])', 'gu') // (6) a***a can be either Left or Right Delimiter
        .replace(/punct/g, _punctuation)
        .getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit('^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)' // Skip orphan inside strong
        + '|[^_]+(?=[^_])' // Consume to delim
        + '|(?!_)[punct](_+)(?=[\\s]|$)' // (1) #___ can only be a Right Delimiter
        + '|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)' // (2) a___#, a___ can only be a Right Delimiter
        + '|(?!_)[punct\\s](_+)(?=[^punct\\s])' // (3) #___a, ___a can only be Left Delimiter
        + '|[\\s](_+)(?!_)(?=[punct])' // (4) ___# can only be Left Delimiter
        + '|(?!_)[punct](_+)(?!_)(?=[punct])', 'gu') // (5) #___# can be either Left or Right Delimiter
        .replace(/punct/g, _punctuation)
        .getRegex();
    const anyPunctuation = edit(/\\([punct])/, 'gu')
        .replace(/punct/g, _punctuation)
        .getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/)
        .replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/)
        .replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/)
        .getRegex();
    const _inlineComment = edit(_comment).replace('(?:-->|$)', '-->').getRegex();
    const tag = edit('^comment'
        + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
        + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
        + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
        + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
        + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>') // CDATA section
        .replace('comment', _inlineComment)
        .replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/)
        .getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/)
        .replace('label', _inlineLabel)
        .replace('href', /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/)
        .replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/)
        .getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/)
        .replace('label', _inlineLabel)
        .replace('ref', _blockLabel)
        .getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/)
        .replace('ref', _blockLabel)
        .getRegex();
    const reflinkSearch = edit('reflink|nolink(?!\\()', 'g')
        .replace('reflink', reflink)
        .replace('nolink', nolink)
        .getRegex();
    /**
     * Normal Inline Grammar
     */
    const inlineNormal = {
        _backpedal: noopTest, // only used for GFM url
        anyPunctuation,
        autolink,
        blockSkip,
        br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim,
        emStrongRDelimAst,
        emStrongRDelimUnd,
        escape,
        link,
        nolink,
        punctuation,
        reflink,
        reflinkSearch,
        tag,
        text: inlineText,
        url: noopTest,
    };
    /**
     * Pedantic Inline Grammar
     */
    const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/)
            .replace('label', _inlineLabel)
            .getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
            .replace('label', _inlineLabel)
            .getRegex(),
    };
    /**
     * GFM Inline Grammar
     */
    const inlineGfm = {
        ...inlineNormal,
        escape: edit(escape).replace('])', '~|])').getRegex(),
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i')
            .replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/)
            .getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/,
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */
    const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace('{2,}', '*').getRegex(),
        text: edit(inlineGfm.text)
            .replace('\\b_', '\\b_| {2,}\\n')
            .replace(/\{2,\}/g, '*')
            .getRegex(),
    };
    /**
     * exports
     */
    const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic,
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic,
    };

    /**
     * Block Lexer
     */
    class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options) {
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true,
            };
            const rules = {
                block: block.normal,
                inline: inline.normal,
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            }
            else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) {
                    rules.inline = inline.breaks;
                }
                else {
                    rules.inline = inline.gfm;
                }
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */
        static get rules() {
            return {
                block,
                inline,
            };
        }
        /**
         * Static Lex Method
         */
        static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */
        static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */
        lex(src) {
            src = src
                .replace(/\r\n|\r/g, '\n');
            this.blockTokens(src, this.tokens);
            for (let i = 0; i < this.inlineQueue.length; i++) {
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) {
                src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
            }
            let token;
            let lastToken;
            let cutSrc;
            while (src) {
                if (this.options.extensions
                    && this.options.extensions.block
                    && this.options.extensions.block.some((extTokenizer) => {
                        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) {
                    continue;
                }
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) {
                        // if there's a single \n as a spacer, it's terminating the last line,
                        // so move it there so that we don't get unnecessary paragraph tags
                        tokens[tokens.length - 1].raw += '\n';
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else if (!this.tokens.links[token.tag]) {
                        this.tokens.links[token.tag] = {
                            href: token.href,
                            title: token.title,
                        };
                    }
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex) => {
                        tempStart = getStartIndex.call({ lexer: this }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) {
                            startIndex = Math.min(startIndex, tempStart);
                        }
                    });
                    if (startIndex < Infinity && startIndex >= 0) {
                        cutSrc = src.substring(0, startIndex + 1);
                    }
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken?.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    lastParagraphClipped = (cutSrc.length !== src.length);
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    }
                    else {
                        throw new Error(errMsg);
                    }
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({ src, tokens });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */
        inlineTokens(src, tokens = []) {
            let token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match;
            let keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
                        if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
                            maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                        }
                    }
                }
            }
            // Mask out other blocks
            while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
                maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            }
            // Mask out escaped characters
            while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
                maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            }
            while (src) {
                if (!keepPrevChar) {
                    prevChar = '';
                }
                keepPrevChar = false;
                // extensions
                if (this.options.extensions
                    && this.options.extensions.inline
                    && this.options.extensions.inline.some((extTokenizer) => {
                        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) {
                    continue;
                }
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex) => {
                        tempStart = getStartIndex.call({ lexer: this }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) {
                            startIndex = Math.min(startIndex, tempStart);
                        }
                    });
                    if (startIndex < Infinity && startIndex >= 0) {
                        cutSrc = src.substring(0, startIndex + 1);
                    }
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') { // Track prevChar before string of ____ started
                        prevChar = token.raw.slice(-1);
                    }
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    }
                    else {
                        throw new Error(errMsg);
                    }
                }
            }
            return tokens;
        }
    }

    /**
     * Renderer
     */
    class _Renderer {
        options;
        parser; // set by the parser
        constructor(options) {
            this.options = options || exports.defaults;
        }
        space(token) {
            return '';
        }
        code({ text, lang, escaped }) {
            const langString = (lang || '').match(/^\S*/)?.[0];
            const code = text.replace(/\n$/, '') + '\n';
            if (!langString) {
                return '<pre><code>'
                    + (escaped ? code : escape$1(code, true))
                    + '</code></pre>\n';
            }
            return '<pre><code class="language-'
                + escape$1(langString)
                + '">'
                + (escaped ? code : escape$1(code, true))
                + '</code></pre>\n';
        }
        blockquote({ tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>\n${body}</blockquote>\n`;
        }
        html({ text }) {
            return text;
        }
        heading({ tokens, depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
        }
        hr(token) {
            return '<hr>\n';
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = '';
            for (let j = 0; j < token.items.length; j++) {
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? 'ol' : 'ul';
            const startAttr = (ordered && start !== 1) ? (' start="' + start + '"') : '';
            return '<' + type + startAttr + '>\n' + body + '</' + type + '>\n';
        }
        listitem(item) {
            let itemBody = '';
            if (item.task) {
                const checkbox = this.checkbox({ checked: !!item.checked });
                if (item.loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                            item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                        }
                    }
                    else {
                        item.tokens.unshift({
                            type: 'text',
                            raw: checkbox + ' ',
                            text: checkbox + ' ',
                        });
                    }
                }
                else {
                    itemBody += checkbox + ' ';
                }
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>\n`;
        }
        checkbox({ checked }) {
            return '<input '
                + (checked ? 'checked="" ' : '')
                + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>\n`;
        }
        table(token) {
            let header = '';
            // header
            let cell = '';
            for (let j = 0; j < token.header.length; j++) {
                cell += this.tablecell(token.header[j]);
            }
            header += this.tablerow({ text: cell });
            let body = '';
            for (let j = 0; j < token.rows.length; j++) {
                const row = token.rows[j];
                cell = '';
                for (let k = 0; k < row.length; k++) {
                    cell += this.tablecell(row[k]);
                }
                body += this.tablerow({ text: cell });
            }
            if (body)
                body = `<tbody>${body}</tbody>`;
            return '<table>\n'
                + '<thead>\n'
                + header
                + '</thead>\n'
                + body
                + '</table>\n';
        }
        tablerow({ text }) {
            return `<tr>\n${text}</tr>\n`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? 'th' : 'td';
            const tag = token.align
                ? `<${type} align="${token.align}">`
                : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */
        strong({ tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text }) {
            return `<code>${text}</code>`;
        }
        br(token) {
            return '<br>';
        }
        del({ tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href, title, tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) {
                return text;
            }
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) {
                out += ' title="' + title + '"';
            }
            out += '>' + text + '</a>';
            return out;
        }
        image({ href, title, text }) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) {
                return text;
            }
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) {
                out += ` title="${title}"`;
            }
            out += '>';
            return out;
        }
        text(token) {
            return 'tokens' in token && token.tokens ? this.parser.parseInline(token.tokens) : token.text;
        }
    }

    /**
     * TextRenderer
     * returns only the textual part of the token
     */
    class _TextRenderer {
        // no need for block level renderers
        strong({ text }) {
            return text;
        }
        em({ text }) {
            return text;
        }
        codespan({ text }) {
            return text;
        }
        del({ text }) {
            return text;
        }
        html({ text }) {
            return text;
        }
        text({ text }) {
            return text;
        }
        link({ text }) {
            return '' + text;
        }
        image({ text }) {
            return '' + text;
        }
        br() {
            return '';
        }
    }

    /**
     * Parsing & Compiling
     */
    class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options) {
            this.options = options || exports.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */
        static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */
        static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */
        parse(tokens, top = true) {
            let out = '';
            for (let i = 0; i < tokens.length; i++) {
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({ parser: this }, genericToken);
                    if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(genericToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch (token.type) {
                    case 'space': {
                        out += this.renderer.space(token);
                        continue;
                    }
                    case 'hr': {
                        out += this.renderer.hr(token);
                        continue;
                    }
                    case 'heading': {
                        out += this.renderer.heading(token);
                        continue;
                    }
                    case 'code': {
                        out += this.renderer.code(token);
                        continue;
                    }
                    case 'table': {
                        out += this.renderer.table(token);
                        continue;
                    }
                    case 'blockquote': {
                        out += this.renderer.blockquote(token);
                        continue;
                    }
                    case 'list': {
                        out += this.renderer.list(token);
                        continue;
                    }
                    case 'html': {
                        out += this.renderer.html(token);
                        continue;
                    }
                    case 'paragraph': {
                        out += this.renderer.paragraph(token);
                        continue;
                    }
                    case 'text': {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while (i + 1 < tokens.length && tokens[i + 1].type === 'text') {
                            textToken = tokens[++i];
                            body += '\n' + this.renderer.text(textToken);
                        }
                        if (top) {
                            out += this.renderer.paragraph({
                                type: 'paragraph',
                                raw: body,
                                text: body,
                                tokens: [{ type: 'text', raw: body, text: body }],
                            });
                        }
                        else {
                            out += body;
                        }
                        continue;
                    }
                    default: {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        }
                        else {
                            throw new Error(errMsg);
                        }
                    }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */
        parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            let out = '';
            for (let i = 0; i < tokens.length; i++) {
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({ parser: this }, anyToken);
                    if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(anyToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch (token.type) {
                    case 'escape': {
                        out += renderer.text(token);
                        break;
                    }
                    case 'html': {
                        out += renderer.html(token);
                        break;
                    }
                    case 'link': {
                        out += renderer.link(token);
                        break;
                    }
                    case 'image': {
                        out += renderer.image(token);
                        break;
                    }
                    case 'strong': {
                        out += renderer.strong(token);
                        break;
                    }
                    case 'em': {
                        out += renderer.em(token);
                        break;
                    }
                    case 'codespan': {
                        out += renderer.codespan(token);
                        break;
                    }
                    case 'br': {
                        out += renderer.br(token);
                        break;
                    }
                    case 'del': {
                        out += renderer.del(token);
                        break;
                    }
                    case 'text': {
                        out += renderer.text(token);
                        break;
                    }
                    default: {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        }
                        else {
                            throw new Error(errMsg);
                        }
                    }
                }
            }
            return out;
        }
    }

    class _Hooks {
        options;
        block;
        constructor(options) {
            this.options = options || exports.defaults;
        }
        static passThroughHooks = new Set([
            'preprocess',
            'postprocess',
            'processAllTokens',
        ]);
        /**
         * Process markdown before marked
         */
        preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */
        postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */
        processAllTokens(tokens) {
            return tokens;
        }
        /**
         * Provide function to tokenize markdown
         */
        provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
         * Provide function to parse tokens
         */
        provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    }

    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args) {
            this.use(...args);
        }
        /**
         * Run callback for every token
         */
        walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens) {
                values = values.concat(callback.call(this, token));
                switch (token.type) {
                    case 'table': {
                        const tableToken = token;
                        for (const cell of tableToken.header) {
                            values = values.concat(this.walkTokens(cell.tokens, callback));
                        }
                        for (const row of tableToken.rows) {
                            for (const cell of row) {
                                values = values.concat(this.walkTokens(cell.tokens, callback));
                            }
                        }
                        break;
                    }
                    case 'list': {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                    default: {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) {
                            this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens) => {
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                        }
                        else if (genericToken.tokens) {
                            values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                    }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || { renderers: {}, childTokens: {} };
            args.forEach((pack) => {
                // copy options to new object
                const opts = { ...pack };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext) => {
                        if (!ext.name) {
                            throw new Error('extension name required');
                        }
                        if ('renderer' in ext) { // Renderer extensions
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) {
                                // Replace extension with func to run new extension but fall back if false
                                extensions.renderers[ext.name] = function (...args) {
                                    let ret = ext.renderer.apply(this, args);
                                    if (ret === false) {
                                        ret = prevRenderer.apply(this, args);
                                    }
                                    return ret;
                                };
                            }
                            else {
                                extensions.renderers[ext.name] = ext.renderer;
                            }
                        }
                        if ('tokenizer' in ext) { // Tokenizer Extensions
                            if (!ext.level || (ext.level !== 'block' && ext.level !== 'inline')) {
                                throw new Error("extension level must be 'block' or 'inline'");
                            }
                            const extLevel = extensions[ext.level];
                            if (extLevel) {
                                extLevel.unshift(ext.tokenizer);
                            }
                            else {
                                extensions[ext.level] = [ext.tokenizer];
                            }
                            if (ext.start) { // Function to check for start of token
                                if (ext.level === 'block') {
                                    if (extensions.startBlock) {
                                        extensions.startBlock.push(ext.start);
                                    }
                                    else {
                                        extensions.startBlock = [ext.start];
                                    }
                                }
                                else if (ext.level === 'inline') {
                                    if (extensions.startInline) {
                                        extensions.startInline.push(ext.start);
                                    }
                                    else {
                                        extensions.startInline = [ext.start];
                                    }
                                }
                            }
                        }
                        if ('childTokens' in ext && ext.childTokens) { // Child tokens to be visited by walkTokens
                            extensions.childTokens[ext.name] = ext.childTokens;
                        }
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for (const prop in pack.renderer) {
                        if (!(prop in renderer)) {
                            throw new Error(`renderer '${prop}' does not exist`);
                        }
                        if (['options', 'parser'].includes(prop)) {
                            // ignore options property
                            continue;
                        }
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args) => {
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) {
                                ret = prevRenderer.apply(renderer, args);
                            }
                            return ret || '';
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for (const prop in pack.tokenizer) {
                        if (!(prop in tokenizer)) {
                            throw new Error(`tokenizer '${prop}' does not exist`);
                        }
                        if (['options', 'rules', 'lexer'].includes(prop)) {
                            // ignore options, rules, and lexer properties
                            continue;
                        }
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args) => {
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) {
                                ret = prevTokenizer.apply(tokenizer, args);
                            }
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for (const prop in pack.hooks) {
                        if (!(prop in hooks)) {
                            throw new Error(`hook '${prop}' does not exist`);
                        }
                        if (['options', 'block'].includes(prop)) {
                            // ignore options and block properties
                            continue;
                        }
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) {
                            // @ts-expect-error cannot type hook function dynamically
                            hooks[hooksProp] = (arg) => {
                                if (this.defaults.async) {
                                    return Promise.resolve(hooksFunc.call(hooks, arg)).then(ret => {
                                        return prevHook.call(hooks, ret);
                                    });
                                }
                                const ret = hooksFunc.call(hooks, arg);
                                return prevHook.call(hooks, ret);
                            };
                        }
                        else {
                            // @ts-expect-error cannot type hook function dynamically
                            hooks[hooksProp] = (...args) => {
                                let ret = hooksFunc.apply(hooks, args);
                                if (ret === false) {
                                    ret = prevHook.apply(hooks, args);
                                }
                                return ret;
                            };
                        }
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function (token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) {
                            values = values.concat(walkTokens.call(this, token));
                        }
                        return values;
                    };
                }
                this.defaults = { ...this.defaults, ...opts };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = { ...this.defaults, ...opt };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        parseMarkdown(blockType) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parse = (src, options) => {
                const origOpt = { ...options };
                const opt = { ...this.defaults, ...origOpt };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                // throw error if an extension set async to true but parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) {
                    return throwError(new Error('marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.'));
                }
                // throw error in case of non string input
                if (typeof src === 'undefined' || src === null) {
                    return throwError(new Error('marked(): input parameter is undefined or null'));
                }
                if (typeof src !== 'string') {
                    return throwError(new Error('marked(): input parameter is of type '
                        + Object.prototype.toString.call(src) + ', string expected'));
                }
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer = opt.hooks ? opt.hooks.provideLexer() : (blockType ? _Lexer.lex : _Lexer.lexInline);
                const parser = opt.hooks ? opt.hooks.provideParser() : (blockType ? _Parser.parse : _Parser.parseInline);
                if (opt.async) {
                    return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src)
                        .then(src => lexer(src, opt))
                        .then(tokens => opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens)
                        .then(tokens => opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens)
                        .then(tokens => parser(tokens, opt))
                        .then(html => opt.hooks ? opt.hooks.postprocess(html) : html)
                        .catch(throwError);
                }
                try {
                    if (opt.hooks) {
                        src = opt.hooks.preprocess(src);
                    }
                    let tokens = lexer(src, opt);
                    if (opt.hooks) {
                        tokens = opt.hooks.processAllTokens(tokens);
                    }
                    if (opt.walkTokens) {
                        this.walkTokens(tokens, opt.walkTokens);
                    }
                    let html = parser(tokens, opt);
                    if (opt.hooks) {
                        html = opt.hooks.postprocess(html);
                    }
                    return html;
                }
                catch (e) {
                    return throwError(e);
                }
            };
            return parse;
        }
        onError(silent, async) {
            return (e) => {
                e.message += '\nPlease report this to https://github.com/markedjs/marked.';
                if (silent) {
                    const msg = '<p>An error occurred:</p><pre>'
                        + escape$1(e.message + '', true)
                        + '</pre>';
                    if (async) {
                        return Promise.resolve(msg);
                    }
                    return msg;
                }
                if (async) {
                    return Promise.reject(e);
                }
                throw e;
            };
        }
    }

    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */
    marked.options =
        marked.setOptions = function (options) {
            markedInstance.setOptions(options);
            marked.defaults = markedInstance.defaults;
            changeDefaults(marked.defaults);
            return marked;
        };
    /**
     * Gets the original marked default options.
     */
    marked.getDefaults = _getDefaults;
    marked.defaults = exports.defaults;
    /**
     * Use Extension
     */
    marked.use = function (...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */
    marked.walkTokens = function (tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */
    marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */
    marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;

    exports.Hooks = _Hooks;
    exports.Lexer = _Lexer;
    exports.Marked = Marked;
    exports.Parser = _Parser;
    exports.Renderer = _Renderer;
    exports.TextRenderer = _TextRenderer;
    exports.Tokenizer = _Tokenizer;
    exports.getDefaults = _getDefaults;
    exports.lexer = lexer;
    exports.marked = marked;
    exports.options = options;
    exports.parse = parse;
    exports.parseInline = parseInline;
    exports.parser = parser;
    exports.setOptions = setOptions;
    exports.use = use;
    exports.walkTokens = walkTokens;

}));


},{}],443:[function(require,module,exports){
'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;

},{}],444:[function(require,module,exports){
'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;

},{}],445:[function(require,module,exports){
'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

},{}],446:[function(require,module,exports){
'use strict';

/** @type {import('./max')} */
module.exports = Math.max;

},{}],447:[function(require,module,exports){
'use strict';

/** @type {import('./min')} */
module.exports = Math.min;

},{}],448:[function(require,module,exports){
'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;

},{}],449:[function(require,module,exports){
'use strict';

/** @type {import('./round')} */
module.exports = Math.round;

},{}],450:[function(require,module,exports){
'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};

},{"./isNaN":445}],451:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var HashBase = require('hash-base')
var Buffer = require('safe-buffer').Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

},{"hash-base":413,"inherits":431,"safe-buffer":736}],452:[function(require,module,exports){
var bn = require('bn.js');
var brorand = require('brorand');

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};

},{"bn.js":453,"brorand":279}],453:[function(require,module,exports){
arguments[4][270][0].apply(exports,arguments)
},{"buffer":280,"dup":270}],454:[function(require,module,exports){
module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

},{}],455:[function(require,module,exports){
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};

},{}],456:[function(require,module,exports){
!function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define("Navigo",[],n):"object"==typeof exports?exports.Navigo=n():t.Navigo=n()}("undefined"!=typeof self?self:this,(function(){return function(){"use strict";var t={407:function(t,n,e){e.d(n,{default:function(){return N}});var o=/([:*])(\w+)/g,r=/\*/g,i=/\/\?/g;function a(t){return void 0===t&&(t="/"),v()?location.pathname+location.search+location.hash:t}function s(t){return t.replace(/\/+$/,"").replace(/^\/+/,"")}function c(t){return"string"==typeof t}function u(t){return t&&t.indexOf("#")>=0&&t.split("#").pop()||""}function h(t){var n=s(t).split(/\?(.*)?$/);return[s(n[0]),n.slice(1).join("")]}function f(t){for(var n={},e=t.split("&"),o=0;o<e.length;o++){var r=e[o].split("=");if(""!==r[0]){var i=decodeURIComponent(r[0]);n[i]?(Array.isArray(n[i])||(n[i]=[n[i]]),n[i].push(decodeURIComponent(r[1]||""))):n[i]=decodeURIComponent(r[1]||"")}}return n}function l(t,n){var e,a=h(s(t.currentLocationPath)),l=a[0],p=a[1],d=""===p?null:f(p),v=[];if(c(n.path)){if(e="(?:/^|^)"+s(n.path).replace(o,(function(t,n,e){return v.push(e),"([^/]+)"})).replace(r,"?(?:.*)").replace(i,"/?([^/]+|)")+"$",""===s(n.path)&&""===s(l))return{url:l,queryString:p,hashString:u(t.to),route:n,data:null,params:d}}else e=n.path;var g=new RegExp(e,""),m=l.match(g);if(m){var y=c(n.path)?function(t,n){return 0===n.length?null:t?t.slice(1,t.length).reduce((function(t,e,o){return null===t&&(t={}),t[n[o]]=decodeURIComponent(e),t}),null):null}(m,v):m.groups?m.groups:m.slice(1);return{url:s(l.replace(new RegExp("^"+t.instance.root),"")),queryString:p,hashString:u(t.to),route:n,data:y,params:d}}return!1}function p(){return!("undefined"==typeof window||!window.history||!window.history.pushState)}function d(t,n){return void 0===t[n]||!0===t[n]}function v(){return"undefined"!=typeof window}function g(t,n){return void 0===t&&(t=[]),void 0===n&&(n={}),t.filter((function(t){return t})).forEach((function(t){["before","after","already","leave"].forEach((function(e){t[e]&&(n[e]||(n[e]=[]),n[e].push(t[e]))}))})),n}function m(t,n,e){var o=n||{},r=0;!function n(){t[r]?Array.isArray(t[r])?(t.splice.apply(t,[r,1].concat(t[r][0](o)?t[r][1]:t[r][2])),n()):t[r](o,(function(t){void 0===t||!0===t?(r+=1,n()):e&&e(o)})):e&&e(o)}()}function y(t,n){void 0===t.currentLocationPath&&(t.currentLocationPath=t.to=a(t.instance.root)),t.currentLocationPath=t.instance._checkForAHash(t.currentLocationPath),n()}function _(t,n){for(var e=0;e<t.instance.routes.length;e++){var o=l(t,t.instance.routes[e]);if(o&&(t.matches||(t.matches=[]),t.matches.push(o),"ONE"===t.resolveOptions.strategy))return void n()}n()}function k(t,n){t.navigateOptions&&(void 0!==t.navigateOptions.shouldResolve&&console.warn('"shouldResolve" is deprecated. Please check the documentation.'),void 0!==t.navigateOptions.silent&&console.warn('"silent" is deprecated. Please check the documentation.')),n()}function O(t,n){!0===t.navigateOptions.force?(t.instance._setCurrent([t.instance._pathToMatchObject(t.to)]),n(!1)):n()}m.if=function(t,n,e){return Array.isArray(n)||(n=[n]),Array.isArray(e)||(e=[e]),[t,n,e]};var w=v(),L=p();function b(t,n){if(d(t.navigateOptions,"updateBrowserURL")){var e=("/"+t.to).replace(/\/\//g,"/"),o=w&&t.resolveOptions&&!0===t.resolveOptions.hash;L?(history[t.navigateOptions.historyAPIMethod||"pushState"](t.navigateOptions.stateObj||{},t.navigateOptions.title||"",o?"#"+e:e),location&&location.hash&&(t.instance.__freezeListening=!0,setTimeout((function(){if(!o){var n=location.hash;location.hash="",location.hash=n}t.instance.__freezeListening=!1}),1))):w&&(window.location.href=t.to)}n()}function A(t,n){var e=t.instance;e.lastResolved()?m(e.lastResolved().map((function(n){return function(e,o){if(n.route.hooks&&n.route.hooks.leave){var r=!1,i=t.instance.matchLocation(n.route.path,t.currentLocationPath,!1);r="*"!==n.route.path?!i:!(t.matches&&t.matches.find((function(t){return n.route.path===t.route.path}))),d(t.navigateOptions,"callHooks")&&r?m(n.route.hooks.leave.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.matches&&t.matches.length>0?1===t.matches.length?t.matches[0]:t.matches:void 0)}})).concat([function(){return o()}])):o()}else o()}})),{},(function(){return n()})):n()}function P(t,n){d(t.navigateOptions,"updateState")&&t.instance._setCurrent(t.matches),n()}var R=[function(t,n){var e=t.instance.lastResolved();if(e&&e[0]&&e[0].route===t.match.route&&e[0].url===t.match.url&&e[0].queryString===t.match.queryString)return e.forEach((function(n){n.route.hooks&&n.route.hooks.already&&d(t.navigateOptions,"callHooks")&&n.route.hooks.already.forEach((function(n){return n(t.match)}))})),void n(!1);n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.before&&d(t.navigateOptions,"callHooks")?m(t.match.route.hooks.before.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.match)}})).concat([function(){return n()}])):n()},function(t,n){d(t.navigateOptions,"callHandler")&&t.match.route.handler(t.match),t.instance.updatePageLinks(),n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.after&&d(t.navigateOptions,"callHooks")&&t.match.route.hooks.after.forEach((function(n){return n(t.match)})),n()}],S=[A,function(t,n){var e=t.instance._notFoundRoute;if(e){t.notFoundHandled=!0;var o=h(t.currentLocationPath),r=o[0],i=o[1],a=u(t.to);e.path=s(r);var c={url:e.path,queryString:i,hashString:a,data:null,route:e,params:""!==i?f(i):null};t.matches=[c],t.match=c}n()},m.if((function(t){return t.notFoundHandled}),R.concat([P]),[function(t,n){t.resolveOptions&&!1!==t.resolveOptions.noMatchWarning&&void 0!==t.resolveOptions.noMatchWarning||console.warn('Navigo: "'+t.currentLocationPath+"\" didn't match any of the registered routes."),n()},function(t,n){t.instance._setCurrent(null),n()}])];function E(){return(E=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}function x(t,n){var e=0;A(t,(function o(){e!==t.matches.length?m(R,E({},t,{match:t.matches[e]}),(function(){e+=1,o()})):P(t,n)}))}function H(t){t.instance.__markAsClean(t)}function j(){return(j=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}var C="[data-navigo]";function N(t,n){var e,o=n||{strategy:"ONE",hash:!1,noMatchWarning:!1,linksSelector:C},r=this,i="/",d=null,w=[],L=!1,A=p(),P=v();function R(t){return t.indexOf("#")>=0&&(t=!0===o.hash?t.split("#")[1]||"/":t.split("#")[0]),t}function E(t){return s(i+"/"+s(t))}function N(t,n,e,o){return t=c(t)?E(t):t,{name:o||s(String(t)),path:t,handler:n,hooks:g(e)}}function U(t,n){if(!r.__dirty){r.__dirty=!0,t=t?s(i)+"/"+s(t):void 0;var e={instance:r,to:t,currentLocationPath:t,navigateOptions:{},resolveOptions:j({},o,n)};return m([y,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S)],e,H),!!e.matches&&e.matches}r.__waiting.push((function(){return r.resolve(t,n)}))}function q(t,n){if(r.__dirty)r.__waiting.push((function(){return r.navigate(t,n)}));else{r.__dirty=!0,t=s(i)+"/"+s(t);var e={instance:r,to:t,navigateOptions:n||{},resolveOptions:n&&n.resolveOptions?n.resolveOptions:o,currentLocationPath:R(t)};m([k,O,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S),b,H],e,H)}}function F(){if(P)return(P?[].slice.call(document.querySelectorAll(o.linksSelector||C)):[]).forEach((function(t){"false"!==t.getAttribute("data-navigo")&&"_blank"!==t.getAttribute("target")?t.hasListenerAttached||(t.hasListenerAttached=!0,t.navigoHandler=function(n){if((n.ctrlKey||n.metaKey)&&"a"===n.target.tagName.toLowerCase())return!1;var e=t.getAttribute("href");if(null==e)return!1;if(e.match(/^(http|https)/)&&"undefined"!=typeof URL)try{var o=new URL(e);e=o.pathname+o.search}catch(t){}var i=function(t){if(!t)return{};var n,e=t.split(","),o={};return e.forEach((function(t){var e=t.split(":").map((function(t){return t.replace(/(^ +| +$)/g,"")}));switch(e[0]){case"historyAPIMethod":o.historyAPIMethod=e[1];break;case"resolveOptionsStrategy":n||(n={}),n.strategy=e[1];break;case"resolveOptionsHash":n||(n={}),n.hash="true"===e[1];break;case"updateBrowserURL":case"callHandler":case"updateState":case"force":o[e[0]]="true"===e[1]}})),n&&(o.resolveOptions=n),o}(t.getAttribute("data-navigo-options"));L||(n.preventDefault(),n.stopPropagation(),r.navigate(s(e),i))},t.addEventListener("click",t.navigoHandler)):t.hasListenerAttached&&t.removeEventListener("click",t.navigoHandler)})),r}function I(t,n,e){var o=w.find((function(n){return n.name===t})),r=null;if(o){if(r=o.path,n)for(var a in n)r=r.replace(":"+a,n[a]);r=r.match(/^\//)?r:"/"+r}return r&&e&&!e.includeRoot&&(r=r.replace(new RegExp("^/"+i),"")),r}function M(t){var n=h(s(t)),o=n[0],r=n[1],i=""===r?null:f(r);return{url:o,queryString:r,hashString:u(t),route:N(o,(function(){}),[e],o),data:null,params:i}}function T(t,n,e){return"string"==typeof n&&(n=z(n)),n?(n.hooks[t]||(n.hooks[t]=[]),n.hooks[t].push(e),function(){n.hooks[t]=n.hooks[t].filter((function(t){return t!==e}))}):(console.warn("Route doesn't exists: "+n),function(){})}function z(t){return"string"==typeof t?w.find((function(n){return n.name===E(t)})):w.find((function(n){return n.handler===t}))}t?i=s(t):console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'),this.root=i,this.routes=w,this.destroyed=L,this.current=d,this.__freezeListening=!1,this.__waiting=[],this.__dirty=!1,this.__markAsClean=function(t){t.instance.__dirty=!1,t.instance.__waiting.length>0&&t.instance.__waiting.shift()()},this.on=function(t,n,o){var r=this;return"object"!=typeof t||t instanceof RegExp?("function"==typeof t&&(o=n,n=t,t=i),w.push(N(t,n,[e,o])),this):(Object.keys(t).forEach((function(n){if("function"==typeof t[n])r.on(n,t[n]);else{var o=t[n],i=o.uses,a=o.as,s=o.hooks;w.push(N(n,i,[e,s],a))}})),this)},this.off=function(t){return this.routes=w=w.filter((function(n){return c(t)?s(n.path)!==s(t):"function"==typeof t?t!==n.handler:String(n.path)!==String(t)})),this},this.resolve=U,this.navigate=q,this.navigateByName=function(t,n,e){var o=I(t,n);return null!==o&&(q(o.replace(new RegExp("^/?"+i),""),e),!0)},this.destroy=function(){this.routes=w=[],A&&window.removeEventListener("popstate",this.__popstateListener),this.destroyed=L=!0},this.notFound=function(t,n){return r._notFoundRoute=N("*",t,[e,n],"__NOT_FOUND__"),this},this.updatePageLinks=F,this.link=function(t){return"/"+i+"/"+s(t)},this.hooks=function(t){return e=t,this},this.extractGETParameters=function(t){return h(R(t))},this.lastResolved=function(){return d},this.generate=I,this.getLinkPath=function(t){return t.getAttribute("href")},this.match=function(t){var n={instance:r,currentLocationPath:t,to:t,navigateOptions:{},resolveOptions:o};return _(n,(function(){})),!!n.matches&&n.matches},this.matchLocation=function(t,n,e){void 0===n||void 0!==e&&!e||(n=E(n));var o={instance:r,to:n,currentLocationPath:n};return y(o,(function(){})),"string"==typeof t&&(t=void 0===e||e?E(t):t),l(o,{name:String(t),path:t,handler:function(){},hooks:{}})||!1},this.getCurrentLocation=function(){return M(s(a(i)).replace(new RegExp("^"+i),""))},this.addBeforeHook=T.bind(this,"before"),this.addAfterHook=T.bind(this,"after"),this.addAlreadyHook=T.bind(this,"already"),this.addLeaveHook=T.bind(this,"leave"),this.getRoute=z,this._pathToMatchObject=M,this._clean=s,this._checkForAHash=R,this._setCurrent=function(t){return d=r.current=t},function(){A&&(this.__popstateListener=function(){r.__freezeListening||U()},window.addEventListener("popstate",this.__popstateListener))}.call(this),F.call(this)}}},n={};function e(o){if(n[o])return n[o].exports;var r=n[o]={exports:{}};return t[o](r,r.exports,e),r.exports}return e.d=function(t,n){for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]})},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e(407)}().default}));

},{}],457:[function(require,module,exports){
'use strict';

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = require('./isArguments'); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

},{"./isArguments":459}],458:[function(require,module,exports){
'use strict';

var slice = Array.prototype.slice;
var isArgs = require('./isArguments');

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : require('./implementation');

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

},{"./implementation":457,"./isArguments":459}],459:[function(require,module,exports){
'use strict';

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

},{}],460:[function(require,module,exports){
'use strict';

// modified from https://github.com/es-shims/es6-shim
var objectKeys = require('object-keys');
var hasSymbols = require('has-symbols/shams')();
var callBound = require('call-bound');
var $Object = require('es-object-atoms');
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = $Object(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = $Object(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys(from);
		var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};

},{"call-bound":333,"es-object-atoms":394,"has-symbols/shams":411,"object-keys":458}],461:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};

},{"./implementation":460}],462:[function(require,module,exports){
exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};

},{}],463:[function(require,module,exports){
module.exports={"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
}
},{}],464:[function(require,module,exports){
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.

'use strict';

var asn1 = require('asn1.js');

exports.certificate = require('./certificate');

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('modulus')['int'](),
		this.key('publicExponent')['int'](),
		this.key('privateExponent')['int'](),
		this.key('prime1')['int'](),
		this.key('prime2')['int'](),
		this.key('exponent1')['int'](),
		this.key('exponent2')['int'](),
		this.key('coefficient')['int']()
	);
});
exports.RSAPrivateKey = RSAPrivateKey;

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
	this.seq().obj(
		this.key('modulus')['int'](),
		this.key('publicExponent')['int']()
	);
});
exports.RSAPublicKey = RSAPublicKey;

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('none').null_().optional(),
		this.key('curve').objid().optional(),
		this.key('params').seq().obj(
			this.key('p')['int'](),
			this.key('q')['int'](),
			this.key('g')['int']()
		).optional()
	);
});

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});
exports.PublicKey = PublicKey;

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPrivateKey').octstr()
	);
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').seq().obj(
			this.key('id').objid(),
			this.key('decrypt').seq().obj(
				this.key('kde').seq().obj(
					this.key('id').objid(),
					this.key('kdeparams').seq().obj(
						this.key('salt').octstr(),
						this.key('iters')['int']()
					)
				),
				this.key('cipher').seq().obj(
					this.key('algo').objid(),
					this.key('iv').octstr()
				)
			)
		),
		this.key('subjectPrivateKey').octstr()
	);
});

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('p')['int'](),
		this.key('q')['int'](),
		this.key('g')['int'](),
		this.key('pub_key')['int'](),
		this.key('priv_key')['int']()
	);
});
exports.DSAPrivateKey = DSAPrivateKey;

exports.DSAparam = asn1.define('DSAparam', function () {
	this['int']();
});

var ECParameters = asn1.define('ECParameters', function () {
	this.choice({
		namedCurve: this.objid()
	});
});

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('privateKey').octstr(),
		this.key('parameters').optional().explicit(0).use(ECParameters),
		this.key('publicKey').optional().explicit(1).bitstr()
	);
});
exports.ECPrivateKey = ECPrivateKey;

exports.signature = asn1.define('signature', function () {
	this.seq().obj(
		this.key('r')['int'](),
		this.key('s')['int']()
	);
});

},{"./certificate":465,"asn1.js":256}],465:[function(require,module,exports){
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen

'use strict';

var asn = require('asn1.js');

var Time = asn.define('Time', function () {
	this.choice({
		utcTime: this.utctime(),
		generalTime: this.gentime()
	});
});

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
	this.seq().obj(
		this.key('type').objid(),
		this.key('value').any()
	);
});

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('parameters').optional(),
		this.key('curve').objid().optional()
	);
});

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
	this.setof(AttributeTypeValue);
});

var RDNSequence = asn.define('RDNSequence', function () {
	this.seqof(RelativeDistinguishedName);
});

var Name = asn.define('Name', function () {
	this.choice({
		rdnSequence: this.use(RDNSequence)
	});
});

var Validity = asn.define('Validity', function () {
	this.seq().obj(
		this.key('notBefore').use(Time),
		this.key('notAfter').use(Time)
	);
});

var Extension = asn.define('Extension', function () {
	this.seq().obj(
		this.key('extnID').objid(),
		this.key('critical').bool().def(false),
		this.key('extnValue').octstr()
	);
});

var TBSCertificate = asn.define('TBSCertificate', function () {
	this.seq().obj(
		this.key('version').explicit(0)['int']().optional(),
		this.key('serialNumber')['int'](),
		this.key('signature').use(AlgorithmIdentifier),
		this.key('issuer').use(Name),
		this.key('validity').use(Validity),
		this.key('subject').use(Name),
		this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
		this.key('issuerUniqueID').implicit(1).bitstr().optional(),
		this.key('subjectUniqueID').implicit(2).bitstr().optional(),
		this.key('extensions').explicit(3).seqof(Extension).optional()
	);
});

var X509Certificate = asn.define('X509Certificate', function () {
	this.seq().obj(
		this.key('tbsCertificate').use(TBSCertificate),
		this.key('signatureAlgorithm').use(AlgorithmIdentifier),
		this.key('signatureValue').bitstr()
	);
});

module.exports = X509Certificate;

},{"asn1.js":256}],466:[function(require,module,exports){
'use strict';

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = require('evp_bytestokey');
var ciphers = require('browserify-aes');
var Buffer = require('safe-buffer').Buffer;
module.exports = function (okey, password) {
	var key = okey.toString();
	var match = key.match(findProc);
	var decrypted;
	if (!match) {
		var match2 = key.match(fullRegex);
		decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
	} else {
		var suite = 'aes' + match[1];
		var iv = Buffer.from(match[2], 'hex');
		var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
		var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
		var out = [];
		var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
		out.push(cipher.update(cipherText));
		out.push(cipher['final']());
		decrypted = Buffer.concat(out);
	}
	var tag = key.match(startRegex)[1];
	return {
		tag: tag,
		data: decrypted
	};
};

},{"browserify-aes":283,"evp_bytestokey":396,"safe-buffer":736}],467:[function(require,module,exports){
'use strict';

var asn1 = require('./asn1');
var aesid = require('./aesid.json');
var fixProc = require('./fixProc');
var ciphers = require('browserify-aes');
var pbkdf2Sync = require('pbkdf2').pbkdf2Sync;
var Buffer = require('safe-buffer').Buffer;

function decrypt(data, password) {
	var salt = data.algorithm.decrypt.kde.kdeparams.salt;
	var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
	var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
	var iv = data.algorithm.decrypt.cipher.iv;
	var cipherText = data.subjectPrivateKey;
	var keylen = parseInt(algo.split('-')[1], 10) / 8;
	var key = pbkdf2Sync(password, salt, iters, keylen, 'sha1');
	var cipher = ciphers.createDecipheriv(algo, key, iv);
	var out = [];
	out.push(cipher.update(cipherText));
	out.push(cipher['final']());
	return Buffer.concat(out);
}

function parseKeys(buffer) {
	var password;
	if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
		password = buffer.passphrase;
		buffer = buffer.key;
	}
	if (typeof buffer === 'string') {
		buffer = Buffer.from(buffer);
	}

	var stripped = fixProc(buffer, password);

	var type = stripped.tag;
	var data = stripped.data;
	var subtype, ndata;
	switch (type) {
		case 'CERTIFICATE':
			ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
			// falls through
		case 'PUBLIC KEY':
			if (!ndata) {
				ndata = asn1.PublicKey.decode(data, 'der');
			}
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
				case '1.2.840.10045.2.1':
					ndata.subjectPrivateKey = ndata.subjectPublicKey;
					return {
						type: 'ec',
						data: ndata
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
					return {
						type: 'dsa',
						data: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'ENCRYPTED PRIVATE KEY':
			data = asn1.EncryptedPrivateKey.decode(data, 'der');
			data = decrypt(data, password);
			// falls through
		case 'PRIVATE KEY':
			ndata = asn1.PrivateKey.decode(data, 'der');
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
				case '1.2.840.10045.2.1':
					return {
						curve: ndata.algorithm.curve,
						privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
					return {
						type: 'dsa',
						params: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'RSA PUBLIC KEY':
			return asn1.RSAPublicKey.decode(data, 'der');
		case 'RSA PRIVATE KEY':
			return asn1.RSAPrivateKey.decode(data, 'der');
		case 'DSA PRIVATE KEY':
			return {
				type: 'dsa',
				params: asn1.DSAPrivateKey.decode(data, 'der')
			};
		case 'EC PRIVATE KEY':
			data = asn1.ECPrivateKey.decode(data, 'der');
			return {
				curve: data.parameters.value,
				privateKey: data.privateKey
			};
		default: throw new Error('unknown key type ' + type);
	}
}
parseKeys.signature = asn1.signature;

module.exports = parseKeys;

},{"./aesid.json":463,"./asn1":464,"./fixProc":466,"browserify-aes":283,"pbkdf2":469,"safe-buffer":736}],468:[function(require,module,exports){
(function (process){(function (){
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;

}).call(this)}).call(this,require('_process'))

},{"_process":696}],469:[function(require,module,exports){
'use strict';

exports.pbkdf2 = require('./lib/async');
exports.pbkdf2Sync = require('./lib/sync');

},{"./lib/async":470,"./lib/sync":473}],470:[function(require,module,exports){
(function (global){(function (){
'use strict';

var Buffer = require('safe-buffer').Buffer;

var checkParameters = require('./precondition');
var defaultEncoding = require('./default-encoding');
var sync = require('./sync');
var toBuffer = require('./to-buffer');

var ZERO_BUF;
var subtle = global.crypto && global.crypto.subtle;
var toBrowser = {
	sha: 'SHA-1',
	'sha-1': 'SHA-1',
	sha1: 'SHA-1',
	sha256: 'SHA-256',
	'sha-256': 'SHA-256',
	sha384: 'SHA-384',
	'sha-384': 'SHA-384',
	'sha-512': 'SHA-512',
	sha512: 'SHA-512'
};
var checks = [];
var nextTick;
function getNextTick() {
	if (nextTick) {
		return nextTick;
	}
	if (global.process && global.process.nextTick) {
		nextTick = global.process.nextTick;
	} else if (global.queueMicrotask) {
		nextTick = global.queueMicrotask;
	} else if (global.setImmediate) {
		nextTick = global.setImmediate;
	} else {
		nextTick = global.setTimeout;
	}
	return nextTick;
}
function browserPbkdf2(password, salt, iterations, length, algo) {
	return subtle.importKey('raw', password, { name: 'PBKDF2' }, false, ['deriveBits']).then(function (key) {
		return subtle.deriveBits({
			name: 'PBKDF2',
			salt: salt,
			iterations: iterations,
			hash: {
				name: algo
			}
		}, key, length << 3);
	}).then(function (res) {
		return Buffer.from(res);
	});
}
function checkNative(algo) {
	if (global.process && !global.process.browser) {
		return Promise.resolve(false);
	}
	if (!subtle || !subtle.importKey || !subtle.deriveBits) {
		return Promise.resolve(false);
	}
	if (checks[algo] !== undefined) {
		return checks[algo];
	}
	ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
	var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
		.then(
			function () { return true; },
			function () { return false; }
		);
	checks[algo] = prom;
	return prom;
}

function resolvePromise(promise, callback) {
	promise.then(function (out) {
		getNextTick()(function () {
			callback(null, out);
		});
	}, function (e) {
		getNextTick()(function () {
			callback(e);
		});
	});
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
	if (typeof digest === 'function') {
		callback = digest;
		digest = undefined;
	}

	keylen = checkParameters(iterations, keylen);
	password = toBuffer(password, defaultEncoding, 'Password');
	salt = toBuffer(salt, defaultEncoding, 'Salt');
	if (typeof callback !== 'function') {
		throw new Error('No callback provided to pbkdf2');
	}

	digest = digest || 'sha1';
	var algo = toBrowser[digest.toLowerCase()];

	if (!algo || typeof global.Promise !== 'function') {
		getNextTick()(function () {
			var out;
			try {
				out = sync(password, salt, iterations, keylen, digest);
			} catch (e) {
				callback(e);
				return;
			}
			callback(null, out);
		});
		return;
	}

	resolvePromise(checkNative(algo).then(function (resp) {
		if (resp) {
			return browserPbkdf2(password, salt, iterations, keylen, algo);
		}

		return sync(password, salt, iterations, keylen, digest);
	}), callback);
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./default-encoding":471,"./precondition":472,"./sync":473,"./to-buffer":474,"safe-buffer":736}],471:[function(require,module,exports){
(function (process,global){(function (){
'use strict';

var defaultEncoding;
/* istanbul ignore next */
if (global.process && global.process.browser) {
	defaultEncoding = 'utf-8';
} else if (global.process && global.process.version) {
	var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);

	defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else {
	defaultEncoding = 'utf-8';
}
module.exports = defaultEncoding;

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":696}],472:[function(require,module,exports){
'use strict';

var $isFinite = isFinite;
var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs

module.exports = function (iterations, keylen) {
	if (typeof iterations !== 'number') {
		throw new TypeError('Iterations not a number');
	}

	if (iterations < 0 || !$isFinite(iterations)) {
		throw new TypeError('Bad iterations');
	}

	if (typeof keylen !== 'number') {
		throw new TypeError('Key length not a number');
	}

	if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
		throw new TypeError('Bad key length');
	}

	// `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
	// the native binding requires a true Int32; `-0` is held as a double and
	// aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
	return keylen + 0;
};

},{}],473:[function(require,module,exports){
'use strict';

var md5 = require('create-hash/md5');
var RIPEMD160 = require('ripemd160');
var sha = require('sha.js');
var Buffer = require('safe-buffer').Buffer;

var checkParameters = require('./precondition');
var defaultEncoding = require('./default-encoding');
var toBuffer = require('./to-buffer');

var ZEROS = Buffer.alloc(128);
var sizes = {
	__proto__: null,
	md5: 16,
	sha1: 20,
	sha224: 28,
	sha256: 32,
	sha384: 48,
	sha512: 64,
	'sha512-256': 32,
	ripemd160: 20,
	rmd160: 20
};

var mapping = {
	__proto__: null,
	'sha-1': 'sha1',
	'sha-224': 'sha224',
	'sha-256': 'sha256',
	'sha-384': 'sha384',
	'sha-512': 'sha512',
	'ripemd-160': 'ripemd160'
};

function rmd160Func(data) {
	return new RIPEMD160().update(data).digest();
}

function getDigest(alg) {
	function shaFunc(data) {
		return sha(alg).update(data).digest();
	}

	if (alg === 'rmd160' || alg === 'ripemd160') {
		return rmd160Func;
	}
	if (alg === 'md5') {
		return md5;
	}
	return shaFunc;
}

function Hmac(alg, key, saltLen) {
	var hash = getDigest(alg);
	var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;

	if (key.length > blocksize) {
		key = hash(key);
	} else if (key.length < blocksize) {
		key = Buffer.concat([key, ZEROS], blocksize);
	}

	var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
	var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
	for (var i = 0; i < blocksize; i++) {
		ipad[i] = key[i] ^ 0x36;
		opad[i] = key[i] ^ 0x5C;
	}

	var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
	ipad.copy(ipad1, 0, 0, blocksize);
	this.ipad1 = ipad1;
	this.ipad2 = ipad;
	this.opad = opad;
	this.alg = alg;
	this.blocksize = blocksize;
	this.hash = hash;
	this.size = sizes[alg];
}

Hmac.prototype.run = function (data, ipad) {
	data.copy(ipad, this.blocksize);
	var h = this.hash(ipad);
	h.copy(this.opad, this.blocksize);
	return this.hash(this.opad);
};

function pbkdf2(password, salt, iterations, keylen, digest) {
	keylen = checkParameters(iterations, keylen);
	password = toBuffer(password, defaultEncoding, 'Password');
	salt = toBuffer(salt, defaultEncoding, 'Salt');

	var lowerDigest = (digest || 'sha1').toLowerCase();
	var mappedDigest = mapping[lowerDigest] || lowerDigest;
	var size = sizes[mappedDigest];
	if (typeof size !== 'number' || !size) {
		throw new TypeError('Digest algorithm not supported: ' + digest);
	}

	var hmac = new Hmac(mappedDigest, password, salt.length);

	var DK = Buffer.allocUnsafe(keylen);
	var block1 = Buffer.allocUnsafe(salt.length + 4);
	salt.copy(block1, 0, 0, salt.length);

	var destPos = 0;
	var hLen = size;
	var l = Math.ceil(keylen / hLen);

	for (var i = 1; i <= l; i++) {
		block1.writeUInt32BE(i, salt.length);

		var T = hmac.run(block1, hmac.ipad1);
		var U = T;

		for (var j = 1; j < iterations; j++) {
			U = hmac.run(U, hmac.ipad2);
			for (var k = 0; k < hLen; k++) {
				T[k] ^= U[k];
			}
		}

		T.copy(DK, destPos);
		destPos += hLen;
	}

	return DK;
}

module.exports = pbkdf2;

},{"./default-encoding":471,"./precondition":472,"./to-buffer":474,"create-hash/md5":350,"ripemd160":720,"safe-buffer":736,"sha.js":740}],474:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('to-buffer');

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = useUint8Array && typeof ArrayBuffer !== 'undefined';
var isView = useArrayBuffer && ArrayBuffer.isView;

module.exports = function (thing, encoding, name) {
	if (
		typeof thing === 'string'
		|| Buffer.isBuffer(thing)
		|| (useUint8Array && thing instanceof Uint8Array)
		|| (isView && isView(thing))
	) {
		return toBuffer(thing, encoding);
	}
	throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

},{"safe-buffer":736,"to-buffer":750}],475:[function(require,module,exports){
module.exports={
    "name": "pict-application",
    "version": "1.0.34",
    "description": "Application base class for a pict view-based application",
    "main": "source/Pict-Application.js",
    "scripts": {
        "test": "npx quack test",
        "start": "node source/Pict-Application.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
        "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
        "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
        "tests": "npx quack test -g",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Application.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-application.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-application/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-application#readme",
    "devDependencies": {
        "@eslint/js": "^9.28.0",
        "browser-env": "^3.3.0",
        "eslint": "^9.28.0",
        "pict": "^1.0.348",
        "pict-docuserve": "^0.1.5",
        "pict-provider": "^1.0.10",
        "pict-view": "^1.0.66",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],476:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":475,"fable-serviceproviderbase":398}],477:[function(require,module,exports){
/**
 * Theme Diagram Adapter
 *
 * Helper utilities for plugging diagram renderers (Mermaid today,
 * Excalidraw / chart libraries next) into the pict-provider-theme
 * lifecycle.
 *
 * Why this exists:
 *   Diagram engines like Mermaid bake colors into the SVG at render
 *   time. Once rendered, CSS alone cannot recolor node fills, cluster
 *   backgrounds, or edge stroke ends — those are inline attributes on
 *   <rect>, <path>, <polygon>, etc.  Switching light/dark requires
 *   the engine to re-render with a fresh themeVariables block.
 *
 *   Pre-adapter, every view that hosted a Mermaid block had to:
 *     - read every CSS custom property by hand
 *     - mirror a 20+ key themeVariables object
 *     - wire its own onApply subscription
 *     - stash diagram source on the DOM
 *     - clear data-processed + re-run on theme change
 *
 *   The adapter centralizes all of that.  Section views call
 *   `adapter.adaptMermaid(mermaid, options)` and stop caring about the
 *   token list, the listener, and the refresh dance.
 *
 *  Public API:
 *     buildMermaidThemeVariables(pOverrides)        - read fresh tokens, return mermaid themeVariables
 *     getMermaidTokenMap()                          - canonical {mermaidKey: cssVarName} map
 *     initializeMermaid(mermaid, pOverrides)        - mermaid.initialize() with the right base + themeVariables
 *     refreshMermaidDiagrams(pSelectorOrRoot)       - restore source, clear data-processed, re-run mermaid.run
 *     stashMermaidSource(pNodes)                    - cache source on data-mermaid-source before first run
 *     adaptMermaid(provider, mermaid, pOptions)     - one-shot: initialize + subscribe + return handle
 *     readCSSVar(pName, pFallback, pRoot)           - fresh getComputedStyle read with fallback
 *
 *  All helpers are stateless and safe to call repeatedly.  Subscriptions
 *  return a dispose function the caller can hold onto for teardown.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// Canonical mapping: mermaid themeVariables key -> CSS custom property name -> fallback.
// Fallbacks match the pict-default LIGHT palette so unthemed apps look like
// the default theme rather than a third unrelated palette.
const MERMAID_TOKEN_MAP =
[
	// Primary surfaces (node fills + cluster background)
	{ Key: 'primaryColor',         Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'primaryTextColor',     Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'primaryBorderColor',   Var: '--theme-color-brand-primary',        Fallback: '#3357c7' },
	// Secondary (alt rows, alternate nodes, sequence actor bg)
	{ Key: 'secondaryColor',       Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'secondaryTextColor',   Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'secondaryBorderColor', Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Tertiary (clusters, accent groups)
	{ Key: 'tertiaryColor',        Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'tertiaryTextColor',    Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'tertiaryBorderColor',  Var: '--theme-color-border-light',         Fallback: '#e9e9e9' },
	// Page-level + line + note
	{ Key: 'background',           Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'mainBkg',              Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'secondBkg',            Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'lineColor',            Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'textColor',            Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBkgColor',         Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'noteTextColor',        Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBorderColor',      Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Status (Mermaid uses these for error/warning highlights)
	{ Key: 'errorBkgColor',        Var: '--theme-color-status-error',         Fallback: '#b62828' },
	{ Key: 'errorTextColor',       Var: '--theme-color-text-on-brand',        Fallback: '#ffffff' },
	// Typography
	{ Key: 'fontFamily',           Var: '--theme-typography-family-sans',     Fallback: 'inherit' }
];

/**
 * Read a CSS custom property off pRoot (default: documentElement).
 * Always issues a fresh getComputedStyle so the value reflects the
 * current class state on <html> (theme-light / theme-dark).
 *
 * @param {string} pName     - variable name including '--' prefix
 * @param {string} [pFallback] - returned when the variable is unset/empty
 * @param {Element} [pRoot]  - element to compute style against
 * @returns {string}
 */
function readCSSVar(pName, pFallback, pRoot)
{
	if (typeof window === 'undefined' || typeof document === 'undefined')
	{
		return pFallback || '';
	}
	let tmpRoot = pRoot || document.documentElement;
	if (!tmpRoot)
	{
		return pFallback || '';
	}
	let tmpVal = (getComputedStyle(tmpRoot).getPropertyValue(pName) || '').trim();
	return tmpVal || pFallback || '';
}

/**
 * Returns the canonical {mermaidKey: cssVarName} mapping.  Useful for
 * apps that need to inspect or extend the token list (e.g. to add
 * gantt / sequence / pie-specific tokens for a custom diagram type).
 *
 * @returns {Array<{Key, Var, Fallback}>}
 */
function getMermaidTokenMap()
{
	// Defensive copy so callers can't mutate the canonical list.
	return MERMAID_TOKEN_MAP.map((tmpEntry) => ({ Key: tmpEntry.Key, Var: tmpEntry.Var, Fallback: tmpEntry.Fallback }));
}

/**
 * Read every token in the mermaid map off the current document and
 * return an object suitable for mermaid.initialize({themeVariables}).
 *
 * @param {object} [pOverrides] - extra themeVariables keys to merge on top
 * @returns {object}
 */
function buildMermaidThemeVariables(pOverrides)
{
	let tmpVars = {};
	for (let i = 0; i < MERMAID_TOKEN_MAP.length; i++)
	{
		let tmpEntry = MERMAID_TOKEN_MAP[i];
		tmpVars[tmpEntry.Key] = readCSSVar(tmpEntry.Var, tmpEntry.Fallback);
	}
	if (pOverrides && typeof pOverrides === 'object')
	{
		let tmpKeys = Object.keys(pOverrides);
		for (let j = 0; j < tmpKeys.length; j++)
		{
			tmpVars[tmpKeys[j]] = pOverrides[tmpKeys[j]];
		}
	}
	return tmpVars;
}

/**
 * Call mermaid.initialize() with the canonical pict theme bindings.
 * Safe to call repeatedly; mermaid simply merges new config.
 *
 * @param {object} mermaid - the mermaid module / global
 * @param {object} [pOverrides] - extra themeVariables keys, or { config: ... }
 *                                to override startOnLoad / securityLevel / theme
 * @returns {boolean} true if initialize ran, false if no mermaid available
 */
function initializeMermaid(mermaid, pOverrides)
{
	if (!mermaid || typeof mermaid.initialize !== 'function') { return false; }
	let tmpOverrides = pOverrides || {};
	let tmpThemeOverrides = tmpOverrides.themeVariables;
	let tmpConfigOverrides = tmpOverrides.config || {};
	let tmpVars = buildMermaidThemeVariables(tmpThemeOverrides);
	let tmpConfig = Object.assign(
	{
		startOnLoad: false,
		theme: 'base',
		securityLevel: 'loose'
	}, tmpConfigOverrides,
	{
		themeVariables: tmpVars
	});
	mermaid.initialize(tmpConfig);
	return true;
}

/**
 * Cache each diagram's source text on data-mermaid-source so a later
 * refresh can restore it.  Mermaid replaces textContent with the
 * rendered SVG during run(); without this stash there's no way to
 * re-run.
 *
 * @param {NodeList|Array<Element>} pNodes
 */
function stashMermaidSource(pNodes)
{
	if (!pNodes || pNodes.length < 1) { return; }
	for (let i = 0; i < pNodes.length; i++)
	{
		let tmpEl = pNodes[i];
		if (!tmpEl || typeof tmpEl.getAttribute !== 'function') { continue; }
		if (!tmpEl.hasAttribute('data-mermaid-source'))
		{
			tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
		}
	}
}

/**
 * Restore each pre.mermaid[data-mermaid-source] element to its source
 * text, drop the data-processed flag (mermaid skips elements with that
 * flag set), strip the mermaid-rendered helper class if present, and
 * re-run mermaid against them.
 *
 * @param {string|Element|Document} [pSelectorOrRoot]
 *   - string: querySelectorAll target (defaults to whole document)
 *   - Element: scoped root to search inside
 *   - omitted: whole document
 * @returns {Promise|null} the mermaid.run() promise, or null if no work
 */
function refreshMermaidDiagrams(pSelectorOrRoot)
{
	if (typeof document === 'undefined') { return null; }
	let tmpMermaid = (typeof mermaid !== 'undefined') ? mermaid : null;
	if (!tmpMermaid || typeof tmpMermaid.run !== 'function') { return null; }

	let tmpRendered = _resolveMermaidNodes(pSelectorOrRoot);
	if (!tmpRendered || tmpRendered.length < 1) { return null; }

	for (let i = 0; i < tmpRendered.length; i++)
	{
		let tmpEl = tmpRendered[i];
		let tmpSrc = tmpEl.getAttribute('data-mermaid-source');
		if (tmpSrc !== null) { tmpEl.textContent = tmpSrc; }
		tmpEl.removeAttribute('data-processed');
		if (tmpEl.classList && typeof tmpEl.classList.remove === 'function')
		{
			tmpEl.classList.remove('mermaid-rendered');
		}
	}

	try
	{
		let tmpResult = tmpMermaid.run({ nodes: tmpRendered });
		// After mermaid finishes drawing, strip the !important flags it
		// bakes into per-node inline fill/stroke styles. See
		// stripMermaidStyleImportance() docs for the why.
		if (tmpResult && typeof tmpResult.then === 'function')
		{
			return tmpResult.then(function ()
			{
				stripMermaidStyleImportance(tmpRendered);
				return tmpResult;
			});
		}
		// Synchronous fallback (older mermaid versions).
		stripMermaidStyleImportance(tmpRendered);
		return tmpResult;
	}
	catch (pError)
	{
		// Surface to the caller; they're already wrapping in try/catch in
		// most cases.  Return a rejected promise so .catch() consumers fire.
		return Promise.reject(pError);
	}
}

/**
 * Mermaid 11's flowchart `style X fill:#...` directive emits the fill
 * and stroke inline with `!important`:
 *
 *   <rect class="basic label-container"
 *         style="fill:#e8f5e9 !important;stroke:#43a047 !important"/>
 *
 * Inline `!important` beats external `!important` via specificity, so
 * any theme-aware CSS we write (e.g. `.theme-dark ... { fill: theme-bg
 * !important }`) silently loses no matter how strong its selector.
 * Diagrams keep their Material pastels even in dark themes — light
 * fills with light text = unreadable.
 *
 * Strip just the `!important` flag off mermaid-emitted inline styles
 * after every render.  The fill/stroke values themselves stay intact,
 * so light mode keeps the author-intended palette; in dark mode the
 * external `.theme-dark` CSS now reaches the rect and recolors to a
 * theme-aware background.
 *
 * Must run after every mermaid render — initial + every re-render
 * triggered by a theme change.  `refreshMermaidDiagrams` calls it on
 * re-renders; the initial render in pict-section-content's view calls
 * it via the provider's `diagram.stripMermaidStyleImportance` handle.
 *
 * @param {string|Element|NodeList|Array} [pTarget]
 *   - omitted: scan the whole document
 *   - string: querySelector scope (e.g. '#Pict-Content-Body')
 *   - Element: scan within this element
 *   - NodeList/Array of `pre.mermaid` elements: scan within each
 * @returns {number} count of shapes that had !important stripped
 */
function stripMermaidStyleImportance(pTarget)
{
	if (typeof document === 'undefined') { return 0; }

	let tmpMermaids;
	if (!pTarget)
	{
		tmpMermaids = document.querySelectorAll('pre.mermaid');
	}
	else if (typeof pTarget === 'string')
	{
		let tmpScope = document.querySelector(pTarget);
		tmpMermaids = tmpScope ? tmpScope.querySelectorAll('pre.mermaid') : [];
	}
	else if (pTarget.length !== undefined)
	{
		// NodeList or Array of pre.mermaid elements
		tmpMermaids = pTarget;
	}
	else if (pTarget.querySelectorAll)
	{
		tmpMermaids = pTarget.querySelectorAll('pre.mermaid');
	}
	else
	{
		return 0;
	}

	let tmpStripped = 0;
	for (let i = 0; i < tmpMermaids.length; i++)
	{
		let tmpMerm = tmpMermaids[i];
		if (!tmpMerm || !tmpMerm.querySelectorAll) { continue; }
		let tmpShapes = tmpMerm.querySelectorAll(
			'.node rect[style*="!important"], ' +
			'.node polygon[style*="!important"], ' +
			'.node circle[style*="!important"], ' +
			'.node ellipse[style*="!important"], ' +
			'.node path[style*="!important"], ' +
			'.cluster rect[style*="!important"]'
		);
		for (let j = 0; j < tmpShapes.length; j++)
		{
			let tmpEl = tmpShapes[j];
			let tmpStyle = tmpEl.getAttribute('style') || '';
			if (tmpStyle.indexOf('!important') < 0) { continue; }
			tmpEl.setAttribute('style', tmpStyle.replace(/\s*!important\s*/gi, ''));
			tmpStripped++;
		}
	}
	return tmpStripped;
}

function _resolveMermaidNodes(pSelectorOrRoot)
{
	let tmpSelector = 'pre.mermaid[data-mermaid-source]';
	if (!pSelectorOrRoot)
	{
		return document.querySelectorAll(tmpSelector);
	}
	if (typeof pSelectorOrRoot === 'string')
	{
		// Treat the string as a scope selector; collect mermaid nodes inside it.
		let tmpScope = document.querySelector(pSelectorOrRoot);
		if (!tmpScope) { return []; }
		return tmpScope.querySelectorAll(tmpSelector);
	}
	if (pSelectorOrRoot.querySelectorAll)
	{
		return pSelectorOrRoot.querySelectorAll(tmpSelector);
	}
	return [];
}

/**
 * One-shot: initialize mermaid against the active theme, subscribe to
 * theme apply events, and return a handle the caller can use for
 * teardown / manual refresh.
 *
 *   let tmpHandle = adaptMermaid(pict.providers.Theme, mermaid, {
 *       refreshScope: '#Pict-Content-Body'
 *   });
 *   // ... later, on unload:
 *   tmpHandle.dispose();
 *
 * @param {object} pProvider - pict-provider-theme instance
 * @param {object} pMermaid  - the mermaid module / global
 * @param {object} [pOptions]
 *   @param {string|Element} [pOptions.refreshScope] - passed to refreshMermaidDiagrams
 *   @param {object} [pOptions.themeOverrides]       - extra themeVariables keys
 *   @param {object} [pOptions.configOverrides]      - extra mermaid.initialize() top-level keys
 *   @param {function} [pOptions.onBeforeRefresh]    - called before each refresh; signature (pContext)
 *   @param {function} [pOptions.onAfterRefresh]     - called after each refresh resolves; signature (pContext)
 * @returns {{ dispose: function, refresh: function, reinitialize: function, subscribed: boolean }}
 */
function adaptMermaid(pProvider, pMermaid, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpInitOverrides =
	{
		themeVariables: tmpOptions.themeOverrides,
		config: tmpOptions.configOverrides
	};

	// Always initialize, even if no provider — the static base theme should
	// still pick up whatever CSS variables the page does have.
	initializeMermaid(pMermaid, tmpInitOverrides);

	let tmpRefresh = function (pContext)
	{
		if (typeof tmpOptions.onBeforeRefresh === 'function')
		{
			try { tmpOptions.onBeforeRefresh(pContext || {}); }
			catch (e) { /* swallow; refresh must not be gated on listener errors */ }
		}
		initializeMermaid(pMermaid, tmpInitOverrides);
		let tmpResult = refreshMermaidDiagrams(tmpOptions.refreshScope);
		if (tmpResult && typeof tmpResult.then === 'function' && typeof tmpOptions.onAfterRefresh === 'function')
		{
			tmpResult.then(
				() => { try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ } },
				() => { /* error path: onAfterRefresh still fires so the UI can drop spinners */
					try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ }
				}
			);
		}
		return tmpResult;
	};

	let tmpDispose = function () {};
	let tmpSubscribed = false;
	if (pProvider && typeof pProvider.onApply === 'function')
	{
		tmpDispose = pProvider.onApply(function (pBundle, pContext)
		{
			tmpRefresh(pContext || {});
		});
		tmpSubscribed = true;
	}

	return {
		dispose: function ()
		{
			if (typeof tmpDispose === 'function') { tmpDispose(); }
		},
		refresh: tmpRefresh,
		reinitialize: function () { initializeMermaid(pMermaid, tmpInitOverrides); },
		subscribed: tmpSubscribed
	};
}

module.exports =
{
	MERMAID_TOKEN_MAP: MERMAID_TOKEN_MAP,
	readCSSVar: readCSSVar,
	getMermaidTokenMap: getMermaidTokenMap,
	buildMermaidThemeVariables: buildMermaidThemeVariables,
	initializeMermaid: initializeMermaid,
	stashMermaidSource: stashMermaidSource,
	refreshMermaidDiagrams: refreshMermaidDiagrams,
	stripMermaidStyleImportance: stripMermaidStyleImportance,
	adaptMermaid: adaptMermaid
};

},{}],478:[function(require,module,exports){
module.exports={
    "name": "pict-provider",
    "version": "1.0.13",
    "description": "Pict Provider Base Class",
    "main": "source/Pict-Provider.js",
    "scripts": {
        "start": "node source/Pict-Provider.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
        "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
        "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Provider.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-provider.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-provider/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "eslint": "^9.39.1",
        "pict": "^1.0.351",
        "pict-docuserve": "^0.1.5",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],479:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":478,"fable-serviceproviderbase":398}],480:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libNavigo = require('navigo');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Router',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// When true, addRoute() will NOT auto-resolve after each route is added.
	// This is useful in auth-gated SPAs where routes should only resolve after
	// the DOM is ready (e.g. after login).  Can also be set globally via
	// pict.settings.RouterSkipRouteResolveOnAdd — either one enables the skip.
	SkipRouteResolveOnAdd: false,

	// Document title management.  When a DefaultTitle is set (or a per-route title
	// is passed to addRoute), the router keeps document.title in step with the
	// current route: a route with a title renders `<title><TitleSuffix>`, a route
	// without one falls back to DefaultTitle so a title never lingers from the
	// previous page.  All three are empty by default, so with no configuration the
	// router does not touch document.title (fully backward compatible).
	DefaultTitle: '',
	TitleSuffix: ''
}

class PictRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Initialize the navigo router and set the base path to '/'
		this.router = new libNavigo('/', { strategy: 'ONE', hash: true });

		// BEFORE the Routes option is processed below, because that calls addRoute, which writes here.
		// Route pattern -> handler, so renavigate()/reenter() can run a route the router is already on.
		this._routeHandlers = {};
		// Set by the `already` hook every route carries; read by navigate() to report whether the
		// router actually resolved.  See navigate().
		this._lastNavigateDeclined = false;

		if (this.options.Routes)
		{
			for (let i = 0; i < this.options.Routes.length; i++)
			{
				if (this.options.Routes[i].path && this.options.Routes[i].template)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].template);
				}
				else if (this.options.Routes[i].path && this.options.Routes[i].render)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].render);
				}
				else
				{
					this.pict.log.warn(`Route ${i} is missing a render function or template string.`);
				}
			}
		}

		// This is the route to render after load
		this.afterPersistView = '/Manyfest/Overview';

	}

	get currentScope()
	{
		return this.AppData?.ManyfestRecord?.Scope ?? 'Default';
	}

	forwardToScopedRoute(pData)
	{
		this.navigate(`${pData.url}/${this.currentScope}`);
	}

	onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	/**
	 * Compose a document title from a page title and the configured suffix.  An empty page title
	 * falls back to DefaultTitle so a titleless route never inherits the previous page's title.
	 *
	 * @param {string} pTitle - the page-specific title (may be empty)
	 * @returns {string}
	 */
	composeTitle(pTitle)
	{
		let tmpTitle = (typeof pTitle === 'string') ? pTitle : '';
		if (!tmpTitle) { return this.options.DefaultTitle || ''; }
		let tmpSuffix = this.options.TitleSuffix || '';
		return tmpSuffix ? (tmpTitle + tmpSuffix) : tmpTitle;
	}

	/**
	 * Set document.title from a page title (applying the configured suffix).  Public so async / entity
	 * pages can set their title once the record loads, after the route handler has already run.
	 *
	 * @param {string} pTitle - the page-specific title
	 */
	setDocumentTitle(pTitle)
	{
		if (typeof document === 'undefined') { return; }
		document.title = this.composeTitle(pTitle);
	}

	// Whether the router should manage document.title at all: only once a DefaultTitle or TitleSuffix is
	// configured, or a per-route title is supplied.  Keeps the no-configuration path from touching the DOM.
	_managesTitle(pTitle)
	{
		return (pTitle !== undefined) || !!this.options.DefaultTitle || !!this.options.TitleSuffix;
	}

	// Apply a route's title on match.  A per-route title (string or (pData)=>string) wins; a route with no
	// title resets to DefaultTitle so the previous page's title does not linger.
	_applyRouteTitle(pTitle, pData)
	{
		if (typeof document === 'undefined' || !this._managesTitle(pTitle)) { return; }
		let tmpResolved = (typeof pTitle === 'function') ? pTitle(pData) : pTitle;
		document.title = this.composeTitle(tmpResolved);
	}

	/**
	 * Add a route to the router.
	 *
	 * @param {string} pRoute - the route pattern
	 * @param {function|string} pRenderable - a handler function or a template string
	 * @param {string|function} [pTitle] - optional document title for this route: a string, or a
	 *        (pData)=>string resolved on match.  Requires DefaultTitle/TitleSuffix configured (or this
	 *        arg present) for the router to touch document.title.
	 */
	addRoute(pRoute, pRenderable, pTitle, pHooks)
	{
		let tmpHandler = null;
		if (typeof(pRenderable) === 'function')
		{
			tmpHandler = (pData) =>
				{
					this._applyRouteTitle(pTitle, pData);
					return pRenderable(pData);
				};
		}
		else if (typeof(pRenderable) === 'string')
		{
			// Run this as a template, allowing some whack things with functions in template expressions.
			tmpHandler = (pData) =>
				{
					this._applyRouteTitle(pTitle, pData);
					this.pict.parseTemplate(pRenderable, pData, null, this.pict)
				};
		}
		if (tmpHandler)
		{
			// Remember the handler so renavigate() can run it for a route the router is already on.
			// Keyed WITHOUT the leading slash, which is how the underlying router reports a matched
			// route's path -- so a lookup by pattern and a lookup off a live match agree.
			this._routeHandlers[this._routeKey(pRoute)] = tmpHandler;
			this.router.on(pRoute, tmpHandler, this._composeHooks(pRoute, pHooks));
		}
		else
		{
			// renderable isn't usable!
			this.pict.log.warn(`Route ${pRoute} has an invalid renderable.`);
			return;
		}

		// By default, resolve after each route is added (legacy behavior).
		// Applications can skip this by setting SkipRouteResolveOnAdd: true in
		// the provider config JSON, or globally via
		// pict.settings.RouterSkipRouteResolveOnAdd.  Either one will prevent
		// premature route resolution before views are rendered.
		if (!this.options.SkipRouteResolveOnAdd && !this.pict.settings.RouterSkipRouteResolveOnAdd)
		{
			this.resolve();
		}
	}

	/**
	 * Navigate to a given route (set the browser URL string, add to history, trigger router)
	 *
	 * RETURNS WHETHER THE ROUTE ACTUALLY RESOLVED.  Navigating to the route you are already on is a
	 * no-op by design -- the underlying router declines to run the handler again -- and that is usually
	 * right.  What was missing is any way to KNOW: navigate() returned nothing, so a caller could not
	 * tell "went there" from "did nothing", and code that assumed it had moved would leave whatever was
	 * on screen exactly where it was.  This does not change the behaviour, only reports it.
	 *
	 * The answer comes from the router's own signal rather than by comparing URL strings: every route
	 * carries an internal `already` hook (see _composeHooks) that the router fires when it declines.
	 *
	 * Note for asynchronous route hooks: if an application's before-hook resolves asynchronously the
	 * router has not finished by the time this returns, and this reports true (it did not decline).
	 * That is the same answer callers effectively assumed before this existed.
	 *
	 * @param {string} pRoute - The route to navigate to
	 * @param {object} [pOptions] - options for the underlying router (for example
	 *        { updateBrowserURL: false } for an application that writes the URL itself)
	 * @returns {boolean} true when the route resolved, false when the router was already on it
	 */
	navigate(pRoute, pOptions)
	{
		this._lastNavigateDeclined = false;
		if (pOptions) { this.router.navigate(pRoute, pOptions); }
		else { this.router.navigate(pRoute); }
		return !this._lastNavigateDeclined;
	}

	/**
	 * Navigate to a route, and run its handler even if the router is already on it.
	 *
	 * For the legitimate "enter this route again" case: something has rendered over the route without
	 * telling the router (a form opened in place, a modal took the pane), so the router's idea of what
	 * is on screen and what is actually on screen have come apart, and asking to go there again has to
	 * mean something.  Prefer giving that state a route of its own where you can; use this where you
	 * cannot.
	 *
	 * @param {string} pRoute - The route to navigate to
	 * @param {object} [pOptions] - options for the underlying router, as navigate()
	 * @returns {boolean} true when the handler ran, either by navigation or by re-entry
	 */
	renavigate(pRoute, pOptions)
	{
		if (this.navigate(pRoute, pOptions)) { return true; }
		return this.reenter(pRoute);
	}

	/**
	 * Run the handler for the route the router is currently on, without touching history.
	 *
	 * @param {string} [pRoute] - the route pattern to re-enter; defaults to the last resolved route
	 * @returns {boolean} true when a handler was found and run
	 */
	reenter(pRoute)
	{
		let tmpMatch = this.lastMatch();
		let tmpHandler = pRoute ? this._routeHandlers[this._routeKey(pRoute)] : null;
		// A caller re-entering by the URL it navigated to ('/thing/12') is not naming the pattern the
		// handler is stored under ('/thing/:id'), so fall back to whatever the router actually
		// resolved. That is also the no-argument case: re-enter wherever we are.
		if (!tmpHandler && tmpMatch && tmpMatch.route)
		{
			tmpHandler = this._routeHandlers[this._routeKey(tmpMatch.route.path)];
		}
		if (typeof tmpHandler !== 'function') { return false; }
		tmpHandler(tmpMatch || {});
		return true;
	}

	/**
	 * The router's last resolved match, or null.  Handy for a caller that wants to know where it is
	 * without reaching into the underlying router.
	 *
	 * @returns {object|null}
	 */
	lastMatch()
	{
		if (!this.router || typeof this.router.lastResolved !== 'function') { return null; }
		let tmpResolved = this.router.lastResolved();
		return (tmpResolved && tmpResolved[0]) ? tmpResolved[0] : null;
	}

	/**
	 * Build the hook set handed to the underlying router for one route.
	 *
	 * Always installs an `already` hook, which the router fires when it declines to re-run a handler
	 * for the route it is already on.  An application's own `already` hook still runs, after ours.
	 *
	 * @param {string} pRoute - the route pattern
	 * @param {object} [pHooks] - optional before / after / leave / already hooks from the caller
	 * @returns {object}
	 */
	// One spelling for a route, so a pattern given as '/x' and a match reporting 'x' agree.
	_routeKey(pRoute) { return String(pRoute || '').replace(/^\/+/, ''); }

	_composeHooks(pRoute, pHooks)
	{
		let tmpHooks = Object.assign({}, pHooks || {});
		let fCallerAlready = tmpHooks.already;
		tmpHooks.already = (pMatch) =>
		{
			this._lastNavigateDeclined = true;
			if (typeof fCallerAlready === 'function') { fCallerAlready(pMatch); }
		};
		return tmpHooks;
	}

	/**
	 * Navigate to the route currently in the browser's location hash.
	 *
	 * This is useful in auth-gated SPAs: when the user pastes a deep-link
	 * (e.g. #/Books) and then logs in, calling navigateCurrent() will force
	 * the router to fire the handler for whatever hash is already in the URL.
	 * Unlike resolve(), navigate() always triggers the handler even if Navigo
	 * has already "consumed" that URL.
	 *
	 * If the hash is empty or just "#/", this is a no-op and returns false.
	 *
	 * @returns {boolean} true if a route was navigated to, false otherwise
	 */
	navigateCurrent()
	{
		let tmpHash = (typeof (window) !== 'undefined' && window.location) ? window.location.hash : '';
		if (tmpHash && tmpHash.length > 2 && tmpHash !== '#/')
		{
			let tmpRoute = tmpHash.replace(/^#/, '');
			this.navigate(tmpRoute);
			return true;
		}
		return false;
	}

	/**
	 * Trigger the router resolving logic; this is expected to be called after all routes are added (to go to the default route).
	 *
	 */
	resolve()
	{
		this.router.resolve();
	}
}

module.exports = PictRouter;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;
},{"navigo":456,"pict-provider":479}],481:[function(require,module,exports){
/**
 * Simple syntax highlighter for use with CodeJar.
 *
 * Provides basic keyword/string/number/comment highlighting for common languages.
 * Can be replaced with Prism.js or highlight.js for more sophisticated highlighting
 * by passing a custom highlight function to the view options.
 *
 * @module Pict-Code-Highlighter
 */

// Language definition map
const _LanguageDefinitions = (
{
	'javascript':
	{
		// Combined regex to tokenize: comments, strings, template literals, regex, then everything else
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2|(`(?:[^`\\]|\\.)*?`)|(\/(?![/*])(?:\\.|\[(?:\\.|[^\]])*\]|[^/\\\n])+\/[gimsuvy]*)/g,
		keywords: /\b(async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|export|extends|finally|for|from|function|get|if|import|in|instanceof|let|new|of|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/g,
		builtins: /\b(true|false|null|undefined|NaN|Infinity|console|window|document|Math|JSON|Array|Object|String|Number|Boolean|Date|RegExp|Map|Set|Promise|Error|Symbol|parseInt|parseFloat|require|module|exports)\b/g,
		numbers: /\b(\d+\.?\d*(?:e[+-]?\d+)?|0x[0-9a-fA-F]+|0b[01]+|0o[0-7]+)\b/g
	},
	'json':
	{
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:[^"\\]|\\.)*")/g,
		keywords: /\b(true|false|null)\b/g,
		numbers: /-?\b\d+\.?\d*(?:e[+-]?\d+)?\b/g
	},
	'html':
	{
		// Tokenizer captures: (1) comments, (2) strings, (3) tags with attributes
		tokenizer: /(<!--[\s\S]*?-->)|(["'])(?:(?!\2|\\).|\\.)*?\2|(<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s+[a-zA-Z-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*))?)*\s*\/?>)/g,
		// tagToken group index for identifying tag matches
		tagGroupIndex: 3
	},
	'css':
	{
		tokenizer: /(\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		selectors: /([.#]?[a-zA-Z_][\w-]*(?:\s*[>+~]\s*[.#]?[a-zA-Z_][\w-]*)*)\s*\{/g,
		properties: /\b([a-zA-Z-]+)\s*:/g,
		numbers: /\b(\d+\.?\d*)(px|em|rem|%|vh|vw|s|ms|deg|fr)?\b/g,
		keywords: /\b(important|inherit|initial|unset|none|auto|block|inline|flex|grid)\b/g
	},
	'sql':
	{
		tokenizer: /(--[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		keywords: /\b(SELECT|FROM|WHERE|AND|OR|INSERT|INTO|VALUES|UPDATE|SET|DELETE|CREATE|TABLE|DROP|ALTER|ADD|COLUMN|INDEX|JOIN|LEFT|RIGHT|INNER|OUTER|ON|AS|ORDER|BY|GROUP|HAVING|LIMIT|OFFSET|UNION|ALL|DISTINCT|COUNT|SUM|AVG|MIN|MAX|NOT|NULL|IS|IN|BETWEEN|LIKE|EXISTS|CASE|WHEN|THEN|ELSE|END|PRIMARY|KEY|FOREIGN|REFERENCES|CONSTRAINT|DEFAULT|CHECK|UNIQUE|CASCADE|GRANT|REVOKE|COMMIT|ROLLBACK|BEGIN|TRANSACTION|INT|VARCHAR|DATETIME|AUTO_INCREMENT|CURRENT_TIMESTAMP)\b/gi,
		numbers: /\b\d+\.?\d*\b/g
	}
});

// Alias some common language names
_LanguageDefinitions['js'] = _LanguageDefinitions['javascript'];
_LanguageDefinitions['htm'] = _LanguageDefinitions['html'];

/**
 * Escape HTML special characters to prevent XSS when inserting into innerHTML.
 *
 * @param {string} pString - The string to escape
 * @returns {string} The escaped string
 */
function escapeHTML(pString)
{
	return pString
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Highlight a segment of code that is NOT inside a string or comment.
 * This applies keyword, number, and structural highlighting.
 *
 * @param {string} pCode - The code segment to highlight (already HTML-escaped)
 * @param {object} pLanguageDef - The language definition
 * @returns {string} The highlighted HTML
 */
function highlightCodeSegment(pCode, pLanguageDef)
{
	let tmpResult = pCode;

	// CSS selectors
	if (pLanguageDef.selectors)
	{
		pLanguageDef.selectors.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.selectors, '<span class="function-name">$1</span>{');
	}

	// CSS properties
	if (pLanguageDef.properties)
	{
		pLanguageDef.properties.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.properties, '<span class="property">$1</span>:');
	}

	// Keywords
	if (pLanguageDef.keywords)
	{
		pLanguageDef.keywords.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.keywords, '<span class="keyword">$1</span>');
	}

	// Builtins
	if (pLanguageDef.builtins)
	{
		pLanguageDef.builtins.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.builtins, '<span class="keyword">$1</span>');
	}

	// Numbers (CSS numbers may have units as a capture group, others do not)
	if (pLanguageDef.numbers)
	{
		pLanguageDef.numbers.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.numbers, (pMatch) =>
		{
			return `<span class="number">${pMatch}</span>`;
		});
	}

	return tmpResult;
}

/**
 * Highlight an HTML tag token, applying tag name, attribute name, and attribute value colors.
 *
 * The approach: parse the raw tag into structured pieces first, then build the
 * highlighted output from those pieces. This avoids mixing raw text with HTML span
 * tags, which would cause regex replacements to match span attributes on subsequent passes.
 *
 * @param {string} pTag - The raw (unescaped) tag string
 * @returns {string} The highlighted HTML
 */
function highlightHTMLTag(pTag)
{
	let tmpResult = '';
	let tmpRest = pTag;

	// 1. Extract the opening bracket and tag name: < or </  followed by tagname
	let tmpTagNameMatch = tmpRest.match(/^(<\/?)([a-zA-Z][a-zA-Z0-9-]*)/);
	if (!tmpTagNameMatch)
	{
		// Not a recognizable tag, just escape the whole thing
		return escapeHTML(pTag);
	}

	tmpResult += escapeHTML(tmpTagNameMatch[1]);
	tmpResult += '<span class="tag">' + escapeHTML(tmpTagNameMatch[2]) + '</span>';
	tmpRest = tmpRest.substring(tmpTagNameMatch[0].length);

	// 2. Parse attributes from the remaining text (before the closing > or />)
	// Repeatedly match: whitespace + attr-name + optional =value
	let tmpAttrRegex = /^(\s+)([a-zA-Z-]+)(?:(\s*=\s*)(["'])([^"']*?)\4)?/;
	let tmpAttrMatch;

	while ((tmpAttrMatch = tmpRest.match(tmpAttrRegex)) !== null)
	{
		// Whitespace before the attribute
		tmpResult += tmpAttrMatch[1];
		// Attribute name
		tmpResult += '<span class="attr-name">' + escapeHTML(tmpAttrMatch[2]) + '</span>';

		// If there's an = value part
		if (tmpAttrMatch[3])
		{
			tmpResult += escapeHTML(tmpAttrMatch[3]);
			tmpResult += '<span class="attr-value">' + escapeHTML(tmpAttrMatch[4]) + escapeHTML(tmpAttrMatch[5]) + escapeHTML(tmpAttrMatch[4]) + '</span>';
		}

		tmpRest = tmpRest.substring(tmpAttrMatch[0].length);
	}

	// 3. Whatever remains (whitespace, />, >) — escape it all
	tmpResult += escapeHTML(tmpRest);

	return tmpResult;
}

/**
 * Create a highlight function for a given language.
 *
 * The approach: use a single tokenizer regex to split the code into protected tokens
 * (comments, strings) and code segments. Process each segment independently.
 * This avoids placeholder/sentinel issues entirely.
 *
 * @param {string} pLanguage - The language identifier (e.g. "javascript", "json", "html")
 * @returns {function} A function that takes an element and highlights its textContent
 */
function createHighlighter(pLanguage)
{
	return function highlightElement(pElement)
	{
		let tmpCode = pElement.textContent;
		let tmpLanguageName = (typeof (pLanguage) === 'string') ? pLanguage.toLowerCase() : 'javascript';
		let tmpLanguageDef = _LanguageDefinitions[tmpLanguageName];

		if (!tmpLanguageDef)
		{
			// No highlighting rules for this language; just escape and return
			pElement.innerHTML = escapeHTML(tmpCode);
			return;
		}

		if (!tmpLanguageDef.tokenizer)
		{
			// No tokenizer; just escape and apply keyword highlighting
			pElement.innerHTML = highlightCodeSegment(escapeHTML(tmpCode), tmpLanguageDef);
			return;
		}

		// Split the code into tokens using the tokenizer regex.
		// The tokenizer captures comments and strings as groups.
		// We process everything between matches as code.
		let tmpResult = '';
		let tmpLastIndex = 0;
		let tmpTagGroupIndex = tmpLanguageDef.tagGroupIndex || 0;

		tmpLanguageDef.tokenizer.lastIndex = 0;
		let tmpMatch;

		while ((tmpMatch = tmpLanguageDef.tokenizer.exec(tmpCode)) !== null)
		{
			// Add the code segment before this match
			if (tmpMatch.index > tmpLastIndex)
			{
				let tmpSegment = tmpCode.substring(tmpLastIndex, tmpMatch.index);
				tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
			}

			let tmpFullMatch = tmpMatch[0];

			// Determine token type from capture groups
			// Group 1 is always comments, Group 2+ are strings/template literals/regex
			if (tmpMatch[1])
			{
				// Comment
				tmpResult += `<span class="comment">${escapeHTML(tmpFullMatch)}</span>`;
			}
			else if (tmpTagGroupIndex > 0 && tmpMatch[tmpTagGroupIndex])
			{
				// HTML tag — highlight tag name, attributes, and values
				tmpResult += highlightHTMLTag(tmpFullMatch);
			}
			else
			{
				// String, template literal, or regex
				tmpResult += `<span class="string">${escapeHTML(tmpFullMatch)}</span>`;
			}

			tmpLastIndex = tmpLanguageDef.tokenizer.lastIndex;
		}

		// Add any remaining code after the last match
		if (tmpLastIndex < tmpCode.length)
		{
			let tmpSegment = tmpCode.substring(tmpLastIndex);
			tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
		}

		pElement.innerHTML = tmpResult;
	};
}

module.exports = createHighlighter;
module.exports.LanguageDefinitions = _LanguageDefinitions;

},{}],482:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "CodeEditor-Wrap",
	"DefaultDestinationAddress": "#CodeEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "CodeEditor-Container",
			"Template": "<!-- CodeEditor-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "CodeEditor-Wrap",
			"TemplateHash": "CodeEditor-Container",
			"DestinationAddress": "#CodeEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#CodeEditor-Container-Div",

	// Address in AppData or other Pict address space to read/write code content
	"CodeDataAddress": false,

	// The language for syntax highlighting (e.g. "javascript", "html", "css", "json")
	"Language": "javascript",

	// Whether the editor is read-only
	"ReadOnly": false,

	// Tab character: use tab or spaces
	"Tab": "\t",

	// Whether to indent with the same whitespace as the previous line
	"IndentOn": /[({[]$/,

	// Whether to add a closing bracket/paren/brace
	"MoveToNewLine": /^[)}\]]/,

	// Whether to handle the closing character
	"AddClosing": true,

	// Whether to preserve indentation on new lines
	"CatchTab": true,

	// Whether to show line numbers
	"LineNumbers": true,

	// Default code content if no address is provided
	"DefaultCode": "// Enter your code here\n",

	// CSS for the code editor.
	//
	// Every color/font is wired through pict-provider-theme tokens so apps
	// using pict-provider-theme get themed code editor automatically.  Each
	// var() carries its original ATOM-One-Light hex as the fallback so apps
	// without pict-provider-theme installed look exactly as before.
	"CSS": `.pict-code-editor-wrap
{
	display: flex;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.5;
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
}
.pict-code-editor-wrap .pict-code-line-numbers
{
	width: 40px;
	min-width: 40px;
	/* padding-top/bottom are stamped at runtime from the editor's
	   computed padding so row 1 of the gutter aligns with row 1 of
	   the code; only horizontal padding is stylesheet-owned. */
	padding: 0;
	text-align: right;
	background: var(--theme-color-editor-linenumber-background, var(--theme-color-background-secondary, #F5F5F5));
	border-right: 1px solid var(--theme-color-editor-gutter-border, var(--theme-color-border-default, #D0D0D0));
	color: var(--theme-color-editor-linenumber-text, var(--theme-color-text-muted, #999));
	font-size: 13px;
	/* line-height, padding-top, padding-bottom, and font-family are
	   intentionally NOT declared here.  PictSectionCode._syncGutterMetrics()
	   copies them from the editor's computed styles at init and on every
	   editor resize, so the gutter is guaranteed to track the editor.
	   Declaring them in CSS would either be redundant (when matching) or
	   actively wrong (when the editor's metrics diverge — e.g. theme scale
	   changes the editor's font-size).  See codejar-linenumbers for the
	   canonical version of this pattern. */
	user-select: none;
	pointer-events: none;
	box-sizing: border-box;
}
.pict-code-editor-wrap .pict-code-line-numbers span
{
	display: block;
	padding: 0 8px 0 0;
}
.pict-code-editor-wrap .pict-code-editor
{
	margin: 0;
	padding: 10px 10px 10px 8px;
	min-height: 100px;
	flex: 1;
	min-width: 0;
	outline: none;
	tab-size: 4;
	white-space: pre;
	overflow-wrap: normal;
	color: var(--theme-color-text-primary, #383A42);
	background: var(--theme-color-background-panel, #FAFAFA);
	caret-color: var(--theme-color-brand-primary, #526FFF);
	border-radius: 0 4px 4px 0;
}
.pict-code-editor-wrap .pict-code-editor.pict-code-no-line-numbers
{
	padding-left: 10px;
	border-radius: 4px;
}
.pict-code-editor-wrap .pict-code-editor::selection,
.pict-code-editor-wrap .pict-code-editor *::selection
{
	background: var(--theme-color-editor-selection-background, var(--theme-color-selection-background, #B3D4FC));
}
/* Syntax token colors — each class binds to a Color.Syntax.* token from
   pict-provider-theme. Fallback hexes match the One Light palette so apps
   that don't install the theme provider look the same as before. */
.pict-code-editor-wrap .pict-code-editor .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
.pict-code-editor-wrap .pict-code-editor .string        { color: var(--theme-color-syntax-string,      #50A14F); }
.pict-code-editor-wrap .pict-code-editor .number        { color: var(--theme-color-syntax-number,      #986801); }
.pict-code-editor-wrap .pict-code-editor .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
.pict-code-editor-wrap .pict-code-editor .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
.pict-code-editor-wrap .pict-code-editor .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
.pict-code-editor-wrap .pict-code-editor .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
.pict-code-editor-wrap .pict-code-editor .property      { color: var(--theme-color-syntax-property,    #E45649); }
.pict-code-editor-wrap .pict-code-editor .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
.pict-code-editor-wrap .pict-code-editor .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
.pict-code-editor-wrap .pict-code-editor .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
.pict-code-editor-wrap .pict-code-editor .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
.pict-code-editor-wrap .pict-code-editor .type          { color: var(--theme-color-syntax-type,        #C18401); }
.pict-code-editor-wrap .pict-code-editor .variable      { color: var(--theme-color-syntax-variable,    #383A42); }

/* highlight.js class aliases — when host apps render code blocks with
   highlight.js (e.g. markdown previews via CodeJar's hljs integration),
   the output uses .hljs / .hljs-* classes rather than the bare token
   classes pict-section-code emits. Mapping them here lets one stylesheet
   theme both editor surfaces (bare classes) and hljs-rendered surfaces
   without the host needing a separate per-app github.css. Rules are
   intentionally unscoped (no .pict-code-editor-wrap parent) so they
   apply globally wherever hljs paints. */
.hljs                  { color: var(--theme-color-text-primary,         #383A42); background: transparent; }
.hljs-keyword,
.hljs-keyword.hljs-typeof,
.hljs-selector-tag,
.hljs-literal          { color: var(--theme-color-syntax-keyword,       #A626A4); }
.hljs-string,
.hljs-regexp,
.hljs-template-tag,
.hljs-template-variable { color: var(--theme-color-syntax-string,       #50A14F); }
.hljs-number,
.hljs-meta             { color: var(--theme-color-syntax-number,        #986801); }
.hljs-comment,
.hljs-quote            { color: var(--theme-color-syntax-comment,       #A0A1A7); font-style: italic; }
.hljs-operator,
.hljs-link             { color: var(--theme-color-syntax-operator,      #0184BC); }
.hljs-punctuation      { color: var(--theme-color-syntax-punctuation,   #383A42); }
.hljs-function .hljs-title,
.hljs-title.function_,
.hljs-title.class_     { color: var(--theme-color-syntax-function,      #4078F2); }
.hljs-variable,
.hljs-variable.language_,
.hljs-params           { color: var(--theme-color-syntax-variable,      #383A42); }
.hljs-type,
.hljs-class .hljs-title { color: var(--theme-color-syntax-type,         #C18401); }
.hljs-built_in,
.hljs-builtin-name     { color: var(--theme-color-syntax-builtin,       #986801); }
.hljs-attr,
.hljs-property         { color: var(--theme-color-syntax-property,      #E45649); }
.hljs-tag,
.hljs-name             { color: var(--theme-color-syntax-tag,           #E45649); }
.hljs-attribute        { color: var(--theme-color-syntax-attrname,      #986801); }
.hljs-symbol           { color: var(--theme-color-syntax-attrvalue,     #50A14F); }
.hljs-emphasis         { font-style: italic; }
.hljs-strong           { font-weight: bold; }
.hljs-deletion         { color: var(--theme-color-status-error,         #B62828); background: rgba(220, 50, 47, 0.08); }
.hljs-addition         { color: var(--theme-color-status-success,       #2E7A3A); background: rgba(80, 161, 79, 0.10); }
`
});

},{}],483:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libCreateHighlighter = require('./Pict-Code-Highlighter.js');
const _DefaultConfiguration = require('./Pict-Section-Code-DefaultConfiguration.js');

class PictSectionCode extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// The CodeJar instance
		this.codeJar = null;

		// The highlight function (can be overridden)
		this._highlightFunction = null;

		// The current language
		this._language = this.options.Language || 'javascript';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._codeJarPrototype = null;
		this.targetElement = false;

		// Build the default highlight function for the configured language
		this._highlightFunction = libCreateHighlighter(this._language);

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeJar prototype.  If not passed explicitly, try to find it
	 * as a global (window.CodeJar) or require it from the npm package.
	 *
	 * @param {function} [pCodeJarPrototype] - The CodeJar constructor function
	 * @returns {boolean|void}
	 */
	connectCodeJarPrototype(pCodeJarPrototype)
	{
		if (typeof (pCodeJarPrototype) === 'function')
		{
			this._codeJarPrototype = pCodeJarPrototype;
			return;
		}

		// Try to find CodeJar in global scope
		if (typeof (window) !== 'undefined')
		{
			if (typeof (window.CodeJar) === 'function')
			{
				this.log.trace(`PICT-Code Found CodeJar in window.CodeJar.`);
				this._codeJarPrototype = window.CodeJar;
				return;
			}
		}

		this.log.error(`PICT-Code No CodeJar prototype found. Include codejar via script tag or call connectCodeJarPrototype(CodeJar) explicitly.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Resolve the CodeJar prototype if not already set
		if (!this._codeJarPrototype)
		{
			this.connectCodeJarPrototype();
		}

		if (!this._codeJarPrototype)
		{
			this.log.error(`PICT-Code Cannot initialize editor; no CodeJar prototype available.`);
			return false;
		}

		if (this.codeJar)
		{
			this.log.error(`PICT-Code editor is already initialized!`);
			return false;
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-Code Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Build the editor DOM structure
		this._buildEditorDOM();

		// Get initial code content
		let tmpCode = this._resolveCodeContent();

		// Create the CodeJar options
		let tmpCodeJarOptions = {};
		if (this.options.Tab)
		{
			tmpCodeJarOptions.tab = this.options.Tab;
		}
		if (this.options.IndentOn)
		{
			tmpCodeJarOptions.indentOn = this.options.IndentOn;
		}
		if (this.options.MoveToNewLine)
		{
			tmpCodeJarOptions.moveToNewLine = this.options.MoveToNewLine;
		}
		if (typeof (this.options.AddClosing) !== 'undefined')
		{
			tmpCodeJarOptions.addClosing = this.options.AddClosing;
		}
		if (typeof (this.options.CatchTab) !== 'undefined')
		{
			tmpCodeJarOptions.catchTab = this.options.CatchTab;
		}

		this.customConfigureEditorOptions(tmpCodeJarOptions);

		// Instantiate CodeJar on the editor element
		let tmpEditorElement = this._editorElement;
		this.codeJar = this._codeJarPrototype(tmpEditorElement, this._highlightFunction, tmpCodeJarOptions);

		// CodeJar forces white-space:pre-wrap and overflow-wrap:break-word
		// via inline styles, which causes line wrapping that breaks the
		// line-number alignment.  Override back to non-wrapping so the
		// wrap container scrolls horizontally instead.
		this._resetEditorWrapStyles();

		// Set the initial code
		if (tmpCode)
		{
			this.codeJar.updateCode(tmpCode);
		}

		// Wire up the change handler
		this.codeJar.onUpdate((pCode) =>
		{
			this._updateLineNumbers();
			this.onCodeChange(pCode);
		});

		// Initial line number render
		this._updateLineNumbers();

		// Sync line-numbers vertical position with the editor's scroll.
		//
		// The editor element scrolls internally (CodeJar uses
		// contenteditable + overflow:auto for long content), but the
		// line-numbers div is a sibling with overflow:visible — without
		// this sync the line-numbers content stays glued at the top of
		// the wrap while the editor scrolls underneath it, so "line 1"
		// appears next to whatever line is actually showing.
		//
		// Using `transform: translateY(...)` instead of scrollTop keeps
		// the sync compositor-only (no reflow per scroll event) and
		// avoids needing to change the line-numbers element's overflow
		// from visible.  Passive listener so we don't block scrolling.
		if (this._lineNumbersElement)
		{
			let tmpLineNumbersEl = this._lineNumbersElement;
			tmpEditorElement.addEventListener('scroll', function ()
			{
				tmpLineNumbersEl.style.transform = 'translateY(-' + tmpEditorElement.scrollTop + 'px)';
			}, { passive: true });
		}

		// Sync gutter typographic metrics from the editor.  The gutter
		// must use the editor's exact line-height (and matching padding)
		// or rows drift apart cumulatively.  See _syncGutterMetrics().
		this._syncGutterMetrics();

		// Watch the editor for size changes (window resize affecting
		// flex layout, container resize) and re-sync the gutter so it
		// continues to track the editor.  ResizeObserver fires once per
		// frame at most, so the cost is negligible.
		if (this._lineNumbersElement && typeof (ResizeObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorResizeObserver = new ResizeObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorResizeObserver.observe(tmpEditorElement);
		}

		// Watch for direct style/class mutations on the editor.  Theme
		// providers that toggle scale by swapping a class on the editor,
		// or host code that adjusts editor typography via inline styles,
		// don't necessarily change the editor's box size — so the
		// ResizeObserver above wouldn't see them.  MutationObserver on
		// the attributes catches these cases.
		if (this._lineNumbersElement && typeof (MutationObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorStyleObserver = new MutationObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorStyleObserver.observe(tmpEditorElement,
				{ attributes: true, attributeFilter: ['style', 'class'] });
		}

		// Handle read-only
		if (this.options.ReadOnly)
		{
			tmpEditorElement.setAttribute('contenteditable', 'false');
		}
	}

	/**
	 * Build the editor DOM elements inside the target container.
	 */
	_buildEditorDOM()
	{
		// Clear the target
		this.targetElement.innerHTML = '';

		// Create wrapper
		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-code-editor-wrap';

		// Create line numbers container
		if (this.options.LineNumbers)
		{
			let tmpLineNumbers = document.createElement('div');
			tmpLineNumbers.className = 'pict-code-line-numbers';
			tmpWrap.appendChild(tmpLineNumbers);
			this._lineNumbersElement = tmpLineNumbers;
		}

		// Create the editor element (CodeJar needs a pre or div)
		let tmpEditor = document.createElement('div');
		tmpEditor.className = 'pict-code-editor language-' + this._language;
		if (!this.options.LineNumbers)
		{
			tmpEditor.className += ' pict-code-no-line-numbers';
		}
		tmpWrap.appendChild(tmpEditor);

		this.targetElement.appendChild(tmpWrap);
		this._editorElement = tmpEditor;
		this._wrapElement = tmpWrap;
	}

	/**
	 * Update the line numbers display based on current code content.
	 */
	_updateLineNumbers()
	{
		if (!this.options.LineNumbers || !this._lineNumbersElement || !this._editorElement)
		{
			return;
		}

		let tmpCode = this._editorElement.textContent || '';
		let tmpLineCount = tmpCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += `<span>${i}</span>`;
		}

		this._lineNumbersElement.innerHTML = tmpHTML;

		// Defense-in-depth: every line-count rebuild is also a natural
		// re-sync point.  Cheap (one getComputedStyle + a handful of
		// style writes) and guarantees newly-added spans use the same
		// metrics as the editor at the moment of the rebuild.
		this._syncGutterMetrics();
	}

	/**
	 * Copy typographic metrics from the editor element to the line-numbers
	 * gutter so every gutter row lines up with its corresponding code row.
	 *
	 * The gutter is a sibling element with its own font/line-height
	 * declarations — if any one diverges from the editor (unitless
	 * line-height resolving against a different font-size, host CSS
	 * overriding font-family, theme scale changing the editor's metrics),
	 * the two desync and the drift accumulates with every line.
	 *
	 * The pattern is borrowed from the canonical `codejar-linenumbers`
	 * library (julianpoemp/codejar-linenumbers), which solves the same
	 * class of bug by reading the editor's computed styles at init and
	 * stamping them onto the gutter.  We extend that here by also
	 * re-stamping whenever the editor resizes (see the ResizeObserver in
	 * onAfterInitialRender), so theme scale changes self-heal too.
	 *
	 * Public callers can invoke {@link syncMetrics} to force a re-sync
	 * after any external change that affects editor typography.
	 */
	_syncGutterMetrics()
	{
		if (!this._lineNumbersElement || !this._editorElement)
		{
			return;
		}
		if (typeof (window) === 'undefined' || typeof (window.getComputedStyle) !== 'function')
		{
			return;
		}

		let tmpEditorStyle = window.getComputedStyle(this._editorElement);
		let tmpLineHeight = tmpEditorStyle.lineHeight;

		// `normal` is the spec default — leave the gutter untouched so the
		// stylesheet's declaration wins (we have no number to copy).
		if (tmpLineHeight && tmpLineHeight !== 'normal')
		{
			this._lineNumbersElement.style.lineHeight = tmpLineHeight;
		}

		// Match the editor's vertical padding so row 1 of the gutter sits
		// at the same y-offset as row 1 of the code.
		if (tmpEditorStyle.paddingTop)
		{
			this._lineNumbersElement.style.paddingTop = tmpEditorStyle.paddingTop;
		}
		if (tmpEditorStyle.paddingBottom)
		{
			this._lineNumbersElement.style.paddingBottom = tmpEditorStyle.paddingBottom;
		}

		// Font-family must match so the visual baseline of the digits
		// aligns with the code (different monospace fonts can have
		// different x-heights even at identical line-heights).
		if (tmpEditorStyle.fontFamily)
		{
			this._lineNumbersElement.style.fontFamily = tmpEditorStyle.fontFamily;
		}

		// Dev-time sanity check.  If the gutter's resolved row height
		// disagrees with the editor's, alignment will drift cumulatively.
		// Warn loudly so the regression is caught at the next reload
		// instead of silently accumulating pixels per line.
		if (typeof (console) !== 'undefined' && console.warn)
		{
			let tmpFirstSpan = this._lineNumbersElement.querySelector('span');
			if (tmpFirstSpan)
			{
				let tmpGutterRow = tmpFirstSpan.getBoundingClientRect().height;
				let tmpEditorRow = parseFloat(tmpLineHeight);
				if (tmpGutterRow && tmpEditorRow && Math.abs(tmpGutterRow - tmpEditorRow) > 0.5)
				{
					console.warn('[pict-section-code] gutter/editor row-height mismatch: ' +
						'gutter ' + tmpGutterRow + 'px vs editor ' + tmpEditorRow + 'px — ' +
						'line numbers will drift. Check for CSS overriding ' +
						'.pict-code-line-numbers line-height.');
				}
			}
		}
	}

	/**
	 * Public hook for hosts to force a gutter metrics re-sync after
	 * external typography changes (theme scale, font-size swap, etc.).
	 * The ResizeObserver attached at init handles most cases, but call
	 * this from an app's post-theme-change hook for belt-and-suspenders
	 * coverage.
	 */
	syncMetrics()
	{
		this._syncGutterMetrics();
	}

	/**
	 * Reset inline styles that CodeJar sets on the editor element.
	 *
	 * CodeJar forces white-space:pre-wrap and overflow-wrap:break-word so
	 * long lines wrap visually.  That breaks line-number alignment because
	 * each wrapped visual row is not a logical line.  Resetting to pre /
	 * normal makes the outer .pict-code-editor-wrap scroll horizontally.
	 */
	_resetEditorWrapStyles()
	{
		if (!this._editorElement)
		{
			return;
		}
		this._editorElement.style.whiteSpace = 'pre';
		this._editorElement.style.overflowWrap = 'normal';
	}

	/**
	 * Resolve the initial code content from address or default.
	 *
	 * @returns {string} The code content
	 */
	_resolveCodeContent()
	{
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.CodeDataAddress);
			if (typeof (tmpAddressedData) === 'string')
			{
				return tmpAddressedData;
			}
			else
			{
				this.log.warn(`PICT-Code Address [${this.options.CodeDataAddress}] did not return a string; it was ${typeof (tmpAddressedData)}.`);
			}
		}

		return this.options.DefaultCode || '';
	}

	/**
	 * Hook for subclasses to customize CodeJar options before instantiation.
	 *
	 * @param {object} pOptions - The CodeJar options object to modify
	 */
	customConfigureEditorOptions(pOptions)
	{
		// Override in subclass to tweak options
	}

	/**
	 * Called when the code content changes.  Override in subclasses to handle changes.
	 *
	 * @param {string} pCode - The new code content
	 */
	onCodeChange(pCode)
	{
		// Write back to data address if configured
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.CodeDataAddress, pCode);
		}
	}

	// -- Public API Methods --

	/**
	 * Get the current code content.
	 *
	 * @returns {string} The current code
	 */
	getCode()
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code getCode called before editor initialized.');
			return '';
		}
		return this.codeJar.toString();
	}

	/**
	 * Set the code content.
	 *
	 * @param {string} pCode - The code to set
	 */
	setCode(pCode)
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code setCode called before editor initialized.');
			return;
		}
		this.codeJar.updateCode(pCode);
		this._updateLineNumbers();
	}

	/**
	 * Change the editor language and re-highlight.
	 *
	 * @param {string} pLanguage - The language identifier
	 */
	setLanguage(pLanguage)
	{
		this._language = pLanguage;
		this._highlightFunction = libCreateHighlighter(pLanguage);

		if (this._editorElement)
		{
			// Update the class
			this._editorElement.className = 'pict-code-editor language-' + pLanguage;
			if (!this.options.LineNumbers)
			{
				this._editorElement.className += ' pict-code-no-line-numbers';
			}
		}

		if (this.codeJar)
		{
			// Re-create the editor with the new highlight function
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set a custom highlight function to replace the built-in highlighter.
	 * Useful for integrating Prism.js, highlight.js, or any other library.
	 *
	 * @param {function} pHighlightFunction - A function that takes a DOM element and highlights its textContent
	 */
	setHighlightFunction(pHighlightFunction)
	{
		if (typeof (pHighlightFunction) !== 'function')
		{
			this.log.error('PICT-Code setHighlightFunction requires a function.');
			return;
		}
		this._highlightFunction = pHighlightFunction;

		if (this.codeJar)
		{
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set the read-only state of the editor.
	 *
	 * @param {boolean} pReadOnly - Whether the editor should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this._editorElement)
		{
			this._editorElement.setAttribute('contenteditable', pReadOnly ? 'false' : 'true');
		}
	}

	/**
	 * Destroy the editor and clean up.
	 */
	destroy()
	{
		if (this._editorResizeObserver)
		{
			this._editorResizeObserver.disconnect();
			this._editorResizeObserver = null;
		}
		if (this._editorStyleObserver)
		{
			this._editorStyleObserver.disconnect();
			this._editorStyleObserver = null;
		}
		if (this.codeJar)
		{
			this.codeJar.destroy();
			this.codeJar = null;
		}
	}

	/**
	 * Marshal code content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			let tmpCode = this._resolveCodeContent();
			if (typeof (tmpCode) === 'string')
			{
				this.codeJar.updateCode(tmpCode);
				this._updateLineNumbers();
			}
		}
	}

	/**
	 * Marshal the current code content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			this.onCodeChange(this.codeJar.toString());
		}
	}
}

module.exports = PictSectionCode;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.createHighlighter = libCreateHighlighter;

// Demo bundle for pict-docuserve.  Host apps that embed docuserve and
// want pict-section-code's demos visible in their docs site call
// `require('pict-section-code').registerWithDocuserve(pict)` once at
// app boot.  Silent no-op when Docuserve-Demos isn't installed.
//
// The require here is intentionally eager: browserify needs a static
// `require()` at module-toplevel to trace and bundle the demos source.
// The apparent circular dep (demos/index.js requires THIS module to
// reach the PictSectionCode class) is benign — by the time demos/
// index.js runs, `module.exports = PictSectionCode` has already
// executed, so it sees a usable class.  The `.demos` and
// `.registerWithDocuserve` attachments below run after the require
// returns, so demos/index.js never observes them being undefined.
const libCodeDemos = require('./demos');
module.exports.demos                = libCodeDemos.demos;
module.exports.registerWithDocuserve = libCodeDemos.registerWithDocuserve;

},{"./Pict-Code-Highlighter.js":481,"./Pict-Section-Code-DefaultConfiguration.js":482,"./demos":484,"pict-view":693}],484:[function(require,module,exports){
/**
 * pict-section-code demos
 *
 * Each entry is consumed by pict-docuserve's `Docuserve-Demos` provider.
 * Hosts that want these demos to appear in their docs site call
 * `require('pict-section-code/source/demos').registerWithDocuserve(pict)`
 * once at app boot (typically inside their DocuserveApplication subclass
 * after `super(...)`).
 *
 * Each demo's Mount(pict, container, spec) signature creates a fresh
 * pict-section-code view instance inside the supplied container.  Spec
 * fields are passed through to the view config so a single demo template
 * can express "JavaScript with line numbers", "JSON read-only no
 * gutter", etc. without duplicating the wiring.
 */

const libPictSectionCode = require('../Pict-Section-Code.js');

/**
 * Internal helper: mount a pict-section-code instance into a host
 * container according to the demo spec.  Each call registers a uniquely
 * identified view so multiple demos on the same page coexist cleanly.
 */
function mountCodeEditor(pPict, pContainer, pSpec)
{
	// Tag this mount with an id we can target as the destination.
	let tmpDestId = 'demo-code-' + (pSpec.Hash || 'unnamed') + '-' + Date.now();
	pContainer.innerHTML = '<div id="' + tmpDestId + '"></div>';

	let tmpConfig =
	{
		ViewIdentifier:            'Demo-Code-' + tmpDestId,
		DefaultDestinationAddress: '#' + tmpDestId,
		Templates:
		[
			{ Hash: 'CodeEditor-Container', Template: '<!-- demo code editor renders here -->' }
		],
		Renderables:
		[
			{ RenderableHash: 'CodeEditor-Wrap', TemplateHash: 'CodeEditor-Container', DestinationAddress: '#' + tmpDestId }
		],
		TargetElementAddress: '#' + tmpDestId,
		Language:    pSpec.Language    || 'javascript',
		ReadOnly:    !!pSpec.ReadOnly,
		LineNumbers: pSpec.LineNumbers !== false,
		Tab:         pSpec.Tab         || '\t',
		AddClosing:  pSpec.AddClosing !== false,
		CatchTab:    pSpec.CatchTab   !== false,
		DefaultCode: pSpec.Code        || '// example code\n',
		// AutoRender is intentionally OFF so we can pre-wire CodeJar
		// before the first render fires.  pict-section-code looks for
		// window.CodeJar by default; most hosts bundle CodeJar under
		// window.CodeJarModules.CodeJar (e.g. retold-content-system's
		// codejar-bundle.js), so we wire it explicitly here.
		AutoRender:  false,
		RenderOnLoad: false
	};

	let tmpView = pPict.addView(tmpConfig.ViewIdentifier, tmpConfig, libPictSectionCode);
	if (!tmpView) { return null; }

	// Connect the CodeJar prototype + highlight function from the
	// CodeJarModules global if it's loaded.  Falls back to bare CodeJar
	// if the host published the prototype directly.
	if (typeof window !== 'undefined')
	{
		if (window.CodeJarModules && typeof window.CodeJarModules.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJarModules.CodeJar);
		}
		else if (typeof window.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJar);
		}

		// Wire highlight.js highlighting if the bundle exposes it.
		if (window.CodeJarModules && window.CodeJarModules.hljs)
		{
			let tmpHljs = window.CodeJarModules.hljs;
			let tmpLanguage = tmpConfig.Language;
			tmpView._highlightFunction = function (pElement)
			{
				pElement.removeAttribute('data-highlighted');
				delete pElement.dataset.highlighted;
				pElement.className = pElement.className
					.replace(/\bhljs\b/g, '')
					.replace(/\blanguage-\S+/g, '')
					.trim();
				pElement.classList.add('language-' + tmpLanguage);
				try { tmpHljs.highlightElement(pElement); }
				catch (pErr) { /* swallow — highlighting is best-effort */ }
			};
		}
	}

	try { tmpView.render(); }
	catch (pError) { /* pict-section-code logs its own errors */ }
	return tmpView;
}

const _Demos =
[
	{
		DemoSchemaVersion: 1,
		Hash:        'javascript-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JavaScript editor',
		Description: 'Default pict-section-code configuration — line numbers on, highlight.js for JavaScript, two-space tab.',
		Spec:
		{
			Hash: 'javascript-editor',
			Language: 'javascript',
			LineNumbers: true,
			Tab: '  ',
			Code:
				'// A small example — try editing me.\n' +
				'function fibonacci(n) {\n' +
				'  if (n <= 1) return n;\n' +
				'  return fibonacci(n - 1) + fibonacci(n - 2);\n' +
				'}\n' +
				'\n' +
				'for (let i = 0; i < 10; i++) {\n' +
				'  console.log(`fib(${i}) =`, fibonacci(i));\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "javascript",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "  ",\n' +
					'  "Code": "function fibonacci(n) { … }"\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'json-readonly',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JSON viewer (read-only)',
		Description: 'Read-only mode with line numbers off — useful for embedded "show me the payload" surfaces in dashboards.',
		Spec:
		{
			Hash: 'json-readonly',
			Language: 'json',
			ReadOnly: true,
			LineNumbers: false,
			Code:
				'{\n' +
				'  "version": "1.0.7",\n' +
				'  "syntax": {\n' +
				'    "keyword":  "#A626A4",\n' +
				'    "string":   "#50A14F",\n' +
				'    "number":   "#986801",\n' +
				'    "function": "#4078F2"\n' +
				'  },\n' +
				'  "features": ["highlighting", "line-numbers", "readonly", "themed"]\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "json",\n' +
					'  "ReadOnly": true,\n' +
					'  "LineNumbers": false\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'css-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'CSS editor (4-space tab)',
		Description: 'CSS-flavoured highlighting with a 4-space tab and bracket auto-close turned off — leaner editing for stylesheet snippets.',
		Spec:
		{
			Hash: 'css-editor',
			Language: 'css',
			LineNumbers: true,
			Tab: '    ',
			AddClosing: false,
			Code:
				'/* Theme-aware token usage */\n' +
				'.docuserve-demo-title {\n' +
				'    color: var(--theme-color-text-primary, #3D3229);\n' +
				'    font-size: 1.5em;\n' +
				'    font-weight: 600;\n' +
				'}\n' +
				'\n' +
				'.docuserve-demo-description {\n' +
				'    color: var(--theme-color-text-secondary, #5E5549);\n' +
				'    line-height: 1.55;\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "css",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "    ",\n' +
					'  "AddClosing": false\n' +
					'}'
			}
		]
	}
];

/**
 * Register every pict-section-code demo with the host docuserve app.
 *
 * @param {object} pPict - The Pict instance (typically `this.pict` inside
 *                        a DocuserveApplication subclass).
 * @returns {number} count of demos registered (0 if Docuserve-Demos
 *                   provider isn't present — silent no-op).
 */
function registerWithDocuserve(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers['Docuserve-Demos'])
	{
		return 0;
	}
	return pPict.providers['Docuserve-Demos'].registerAll(_Demos);
}

module.exports = _Demos;
module.exports.demos = _Demos;
module.exports.registerWithDocuserve = registerWithDocuserve;

},{"../Pict-Section-Code.js":483}],485:[function(require,module,exports){
'use strict';

/**
 * Shared CSS for pict-section-content. Registered by BOTH the provider (so any consumer
 * using parseMarkdown gets code-block + content styling, even without instantiating the view)
 * and the view, under one hash so it injects once. This is the lower-layer home for the
 * code-block line-number gutter layout (.pict-content-code-wrap is a flex row) that used to
 * only ship with the view -- fixing the recurring "line numbers render above the code" bug.
 */
module.exports = /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.75em 0;
		}
		.pict-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		/* ─── Code blocks ─────────────────────────────────────
		   Background, text color, line-number gutter, and every
		   syntax token route through pict-provider-theme tokens —
		   the same set pict-section-code (the live editor) uses.
		   This way the rendered-preview code blocks look identical
		   to the live editor and re-skin together when the theme
		   switches.  Previous version used the text-primary token
		   as the code background (a TEXT token used as BACKGROUND),
		   which broke in dark mode and any palette where text and
		   background-tertiary diverge.
		*/
		.pict-content pre {
			background:    var(--theme-color-background-tertiary, #F0ECE4);
			color:         var(--theme-color-text-primary,        #3D3229);
			border:        1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
		}
		/* Inline code (single backtick) — slightly differentiated
		   from block code so it doesn't disappear into prose. */
		.pict-content code {
			background:    var(--theme-color-background-secondary, #FAF8F4);
			color:         var(--theme-color-text-primary,         #3D3229);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
		}
		.pict-content-code-wrap {
			display: flex;
			flex-direction: row;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
			font-size: 14px;
			line-height: 1.5;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			overflow: hidden;
			margin: 1em 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			width: 40px;
			min-width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background:    var(--theme-color-background-secondary, #FAF8F4);
			border-right:  1px solid var(--theme-color-border-default, #DDD6CA);
			color:         var(--theme-color-text-muted,           #8A7F72);
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
			color:      var(--theme-color-text-primary,        #3D3229);
			border: none;
			padding: 1.25em 1.25em 1.25em 8px;
			border-radius: 0 6px 6px 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			flex: 1;
			min-width: 0;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		/* Syntax token colors — every class binds to a --theme-color-syntax-*
		   variable, the same tokens pict-section-code (the live editor) uses.
		   Each var() carries an Atom One Light hex as fallback for hosts
		   without a theme provider; themes that DO ship syntax tokens
		   (pict-default, retold-content-system, etc.) drive everything
		   coherently. */
		.pict-content-code-wrap .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
		.pict-content-code-wrap .string        { color: var(--theme-color-syntax-string,      #50A14F); }
		.pict-content-code-wrap .number        { color: var(--theme-color-syntax-number,      #986801); }
		.pict-content-code-wrap .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
		.pict-content-code-wrap .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
		.pict-content-code-wrap .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
		.pict-content-code-wrap .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
		.pict-content-code-wrap .property      { color: var(--theme-color-syntax-property,    #E45649); }
		.pict-content-code-wrap .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
		.pict-content-code-wrap .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
		.pict-content-code-wrap .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
		.pict-content-code-wrap .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
		.pict-content-code-wrap .type          { color: var(--theme-color-syntax-type,        #C18401); }
		.pict-content-code-wrap .variable      { color: var(--theme-color-syntax-variable,    #383A42); }
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.8em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2A241E);
			text-align: center;
			padding: 1em;
		}
		.pict-content pre.mermaid text,
		.pict-content pre.mermaid .nodeLabel,
		.pict-content pre.mermaid .edgeLabel,
		.pict-content pre.mermaid .label,
		.pict-content pre.mermaid .cluster-label,
		.pict-content pre.mermaid span,
		.pict-content pre.mermaid foreignObject p,
		.pict-content pre.mermaid foreignObject div,
		.pict-content pre.mermaid foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-content pre.mermaid .edgePath .path {
			stroke: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content pre.mermaid .arrowheadPath {
			fill: var(--theme-color-text-secondary, #5E5549) !important;
		}
		/* Dark-mode override for handcrafted mermaid diagrams that bake
		   per-node inline fill colors via 'style X fill:#...' directives
		   (common in architecture / module docs, where pastel layer
		   colors mark visual hierarchy). Mermaid renders those as inline
		   style="fill:#..." SVG attributes — highest specificity, so
		   neither themeVariables nor unflagged CSS can reach them.
		   In light mode the Material pastels read fine; in dark mode the
		   same light fills become a high-contrast island on the dark
		   page with unreadable text. Force the fills back to a theme
		   background so dark-mode reads; light mode is intentionally
		   unmodified so the per-layer hierarchy is preserved there. */
		.theme-dark .pict-content pre.mermaid .node rect,
		.theme-dark .pict-content pre.mermaid .node polygon,
		.theme-dark .pict-content pre.mermaid .node circle,
		.theme-dark .pict-content pre.mermaid .node ellipse,
		.theme-dark .pict-content pre.mermaid .node path,
		.theme-dark .pict-content pre.mermaid .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		/* Mirror of the above for theme mode 'system' — when the user
		   hasn't explicitly picked light or dark, the theme provider
		   leaves <html> without .theme-light/.theme-dark and the CSS
		   variables follow prefers-color-scheme. The .theme-dark-prefixed
		   block above doesn't match in that case, so light pastels would
		   win again on dark OSes. Mirror the rule under the media query,
		   gated by :not(.theme-light) so an explicit light override on a
		   dark OS still wins. */
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-content pre.mermaid .node rect,
			html:not(.theme-light) .pict-content pre.mermaid .node polygon,
			html:not(.theme-light) .pict-content pre.mermaid .node circle,
			html:not(.theme-light) .pict-content pre.mermaid .node ellipse,
			html:not(.theme-light) .pict-content pre.mermaid .node path,
			html:not(.theme-light) .pict-content pre.mermaid .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* Excalidraw fence placeholders + rendered SVGs */
		.pict-content .pict-excalidraw-fence {
			display: block;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			padding: 1em;
			margin: 1em 0;
			text-align: center;
		}
		.pict-content .pict-excalidraw-fence svg {
			max-width: 100%;
			height: auto;
		}
		.pict-content .pict-excalidraw-fence-loading {
			color: var(--theme-color-text-secondary, #5E5549);
			font-style: italic;
			font-size: 0.9em;
			padding: 1em;
		}
		.pict-content .pict-excalidraw-fence-error {
			border-color: var(--theme-color-status-error, #D9534F);
			background: var(--theme-color-background-secondary, #FFF5F5);
		}
		.pict-content .pict-excalidraw-fence-error-message {
			color: var(--theme-color-status-error, #D9534F);
			font-family: var(--theme-typography-family-mono, monospace);
			font-size: 0.85em;
			text-align: left;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}

		/* Fullscreen viewer for images and mermaid diagrams (click-to-zoom) */
		.pict-content [data-fullscreen-source] {
			cursor: zoom-in;
			outline: 1px solid transparent;
			outline-offset: 3px;
			border-radius: 4px;
			transition: outline-color 0.15s ease;
		}
		.pict-content [data-fullscreen-source]:hover {
			outline-color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Code block container with hover-revealed action buttons */
		.pict-content-code-container {
			position: relative;
			display: flex;
			align-items: flex-start;
			gap: 8px;
			margin: 1em 0;
		}
		.pict-content-code-container > .pict-content-code-wrap {
			margin: 0;
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-muted, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
		}
		.pict-content-code-action-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copy-failed {
			background: var(--theme-color-status-error, #B23A3A);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-status-error, #B23A3A);
		}
		.pict-fullscreen-overlay {
			position: fixed;
			inset: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			background: rgba(0, 0, 0, 0.62);
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			color: var(--theme-color-text-primary, #2A241E);
		}
		.pict-fullscreen-overlay[hidden] {
			display: none;
		}
		.pict-fullscreen-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1em;
			height: 48px;
			padding: 0 1em;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-primary, #1A1612);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			flex: 0 0 auto;
		}
		.pict-fullscreen-title {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 0.95em;
			font-weight: 600;
			letter-spacing: 0.01em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-controls {
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.pict-fullscreen-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			padding: 0;
			background: transparent;
			border: 1px solid transparent;
			border-radius: 6px;
			color: var(--theme-color-text-muted, #5E5549);
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}
		.pict-fullscreen-btn svg {
			display: block;
			width: 16px;
			height: 16px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.75;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-fullscreen-btn:hover {
			background: var(--theme-color-border-light, #EAE3D8);
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-fullscreen-close:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
		}
		.pict-fullscreen-stage {
			flex: 1 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			padding: 1.5em;
			cursor: zoom-in;
			touch-action: none;
		}
		.pict-fullscreen-stage.is-zoomed {
			cursor: grab;
		}
		.pict-fullscreen-stage.is-panning {
			cursor: grabbing;
		}
		.pict-fullscreen-content {
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			max-height: 100%;
			transform-origin: center center;
			transition: transform 0.05s linear;
			will-change: transform;
		}
		.pict-fullscreen-content > * {
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
		.pict-fullscreen-content .pict-fullscreen-img {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			width: auto;
			height: auto;
			object-fit: contain;
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 12px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 16px;
			border-radius: 6px;
		}
		/* Bespoke inline-SVG diagrams (pict-renderer-graph / excalidraw).  Backdrop
		   uses the diagram's own --diagram-paper so the zoomed copy keeps the same
		   theme as the inline one (the host defines --diagram-* on the overlay). */
		.pict-fullscreen-content .pict-fullscreen-diagram-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--diagram-paper, var(--theme-color-background-panel, #FFFFFF));
			padding: 16px;
			border-radius: 6px;
		}
		/* Same dark-mode fill/stroke override as for inline diagrams, but
		   scoped to the fullscreen-overlay clone — which lives under
		   <body>, NOT inside .pict-content, so the pre.mermaid-scoped
		   rules above don't reach it. */
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* ---- video (the video fence, and video files written with the image form) ---- */
		.pict-content-video { margin: 18px 0; }
		.pict-content-video figcaption {
			font-size: 13px;
			color: var(--theme-color-text-secondary, #6B6255);
			margin-top: 6px;
		}
		.pict-content-video-file video,
		video.pict-content-video-inline {
			display: block;
			width: 100%;
			max-width: 100%;
			border-radius: 8px;
			background: #000;
		}
		/* The click-to-load card. It carries the whole clickable area, so a reader is never hunting for a
		   small play button, and it looks like a player rather than a link so nobody wonders what it is. */
		.pict-content-video-card {
			position: relative;
			display: flex;
			align-items: center;
			gap: 14px;
			padding: 16px 18px;
			min-height: 96px;
			text-decoration: none;
			border-radius: 8px;
			overflow: hidden;
			background: var(--theme-color-background-tertiary, #211C17);
			border: 1px solid var(--theme-color-border-default, #5E5549);
			color: var(--theme-color-text-primary, #F0EAE0);
		}
		.pict-content-video-card:hover { border-color: var(--theme-color-brand-primary, #C89B3C); }
		.pict-content-video-poster {
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			opacity: 0.45;
		}
		.pict-content-video-play { position: relative; flex: 0 0 auto; line-height: 0; }
		.pict-content-video-play-bg { fill: #212121; opacity: 0.85; }
		.pict-content-video-card:hover .pict-content-video-play-bg { fill: #cc0000; opacity: 1; }
		.pict-content-video-label { position: relative; display: flex; flex-direction: column; gap: 3px; min-width: 0; }
		.pict-content-video-title {
			font-weight: 600;
			font-size: 15px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.pict-content-video-source { font-size: 12px; color: var(--theme-color-text-secondary, #A69B8B); }
		.pict-content-video-frame {
			display: block;
			width: 100%;
			aspect-ratio: 16 / 9;
			border: 0;
			border-radius: 8px;
			background: #000;
		}
		.pict-content-video-empty figcaption {
			padding: 12px 14px;
			border: 1px dashed var(--theme-color-border-default, #5E5549);
			border-radius: 8px;
			margin-top: 0;
		}
		.pict-fullscreen-content .pict-fullscreen-codewrap {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			margin: 0;
			overflow: auto;
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
	`;

},{}],486:[function(require,module,exports){
// The container for all the Pict-Section-Content related code.

// The main content view class
module.exports = require('./views/Pict-View-Content.js');

// The content provider (markdown parsing, HTML escaping)
module.exports.PictContentProvider = require('./providers/Pict-Provider-Content.js');

// A thin demo view that auto-registers the provider, reads markdown
// from an AppData address, and pushes parsed HTML through the base
// view's displayContent pipeline.  Used by the docuserve playground;
// host applications can pick it up too if they just want "render this
// markdown blob" without writing the parse-and-display glue.
module.exports.PictContentDemoView = require('./views/PictView-Content-Demo.js');

},{"./providers/Pict-Provider-Content.js":487,"./views/Pict-View-Content.js":488,"./views/PictView-Content-Demo.js":489}],487:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libCreateHighlighter = require('pict-section-code').createHighlighter;

const libContentCSS = require('../Pict-Content-CSS.js');

/**
 * Content Provider for Pict Section Content
 *
 * A general-purpose markdown-to-HTML parser with support for:
 * - Headings, paragraphs, lists, blockquotes, horizontal rules
 * - Fenced code blocks with language tags (nested fence support)
 * - Syntax highlighting and line numbers for code blocks (via pict-section-code)
 * - Tables (GFM pipe syntax)
 * - Mermaid diagram blocks
 * - KaTeX math (inline and display)
 * - Bold, italic, inline code, links, images
 *
 * Link resolution is customizable via an optional callback.
 */
class PictContentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Register the content CSS at the PROVIDER layer. parseMarkdown emits the
		// .pict-content-code-wrap markup (a line-number gutter + a <pre>), and that CSS makes the
		// wrap a flex row so the numbers sit to the LEFT of the code. Consumers like the
		// inline-documentation reader use this provider WITHOUT instantiating the view, so the
		// view's CSS never shipped and the numbers stacked ABOVE the code -- the recurring bug.
		// Registering here fixes it for every consumer; the view uses the same hash, so it still
		// injects only once. (pict CLAUDE.md: providers must addCSS() themselves.)
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Content-CSS', libContentCSS, 500);
		}
	}

	/**
	 * Highlight a code string using pict-section-code's syntax highlighter.
	 * Uses a mock element to interface with the highlighter's DOM-based API.
	 *
	 * @param {string} pCode - The raw code string
	 * @param {string} pLanguage - The language identifier (e.g. "javascript", "html")
	 * @returns {string} The syntax-highlighted HTML
	 */
	highlightCode(pCode, pLanguage)
	{
		if (!pCode)
		{
			return '';
		}

		let tmpHighlighter = libCreateHighlighter(pLanguage);
		// Create a mock element to interface with the highlighter
		let tmpMockElement = { textContent: pCode, innerHTML: '' };
		tmpHighlighter(tmpMockElement);
		return tmpMockElement.innerHTML;
	}

	/**
	 * Generate line number HTML for a code block.
	 *
	 * @param {string} pCode - The raw code string
	 * @returns {string} HTML string with line number spans
	 */
	generateLineNumbers(pCode)
	{
		if (!pCode)
		{
			return '<span>1</span>';
		}

		let tmpLineCount = pCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += '<span>' + i + '</span>';
		}

		return tmpHTML;
	}

	/**
	 * Parse a markdown string into HTML.
	 *
	 * @param {string} pMarkdown - The raw markdown text
	 * @param {Function} [pLinkResolver] - Optional callback for link resolution: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback for image URL resolution: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. Passed through to parseInline() for vocabulary term auto-linking.
	 * @returns {string} The parsed HTML
	 */
	parseMarkdown(pMarkdown, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pMarkdown)
		{
			return '';
		}

		let tmpLines = pMarkdown.split('\n');
		let tmpHTML = [];
		let tmpInCodeBlock = false;
		let tmpCodeFenceLength = 0;
		let tmpCodeLang = '';
		let tmpCodeLines = [];
		let tmpInList = false;
		let tmpListType = '';
		let tmpInBlockquote = false;
		let tmpBlockquoteLines = [];
		let tmpInMathBlock = false;
		let tmpMathLines = [];
		let tmpParagraphLines = [];

		// Helper to flush accumulated paragraph lines into a single <p> tag
		let fFlushParagraph = () =>
		{
			if (tmpParagraphLines.length > 0)
			{
				tmpHTML.push('<p>' + tmpParagraphLines.map((pLine) => { return this.parseInline(pLine, pLinkResolver, pImageResolver, pVocabularyResolver); }).join(' ') + '</p>');
				tmpParagraphLines = [];
			}
		};

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			// Display math blocks ($$...$$) — skip if inside a code block
			if (!tmpInCodeBlock && tmpLine.trim().match(/^\$\$/))
			{
				if (tmpInMathBlock)
				{
					// End math block
					tmpHTML.push('<div class="pict-content-katex-display">' + tmpMathLines.join('\n') + '</div>');
					tmpInMathBlock = false;
					tmpMathLines = [];
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					tmpInMathBlock = true;
				}
				continue;
			}

			if (tmpInMathBlock)
			{
				tmpMathLines.push(tmpLine);
				continue;
			}

			// Code blocks (fenced) — track fence length so ````x```` nests around ```y```
			let tmpFenceMatch = tmpLine.match(/^(`{3,})/);
			if (tmpFenceMatch)
			{
				let tmpFenceLen = tmpFenceMatch[1].length;

				if (tmpInCodeBlock)
				{
					// Only close if the closing fence is at least as long as the opening
					if (tmpFenceLen >= tmpCodeFenceLength && tmpLine.trim() === tmpFenceMatch[1])
					{
						// End code block
						if (tmpCodeLang === 'mermaid')
						{
							// Mermaid diagrams: output raw content for client-side rendering
							tmpHTML.push('<pre class="mermaid">' + tmpCodeLines.join('\n') + '</pre>');
						}
						else if (tmpCodeLang === 'video')
						{
							// Video: one fence, two outcomes, decided by where the video lives.
							// Self-hosted (a relative URL, or a file with a video extension) plays inline;
							// a third-party watch page becomes a click-to-load card. See videoEmbedHTML.
							tmpHTML.push(this.videoEmbedHTML(tmpCodeLines.join('\n')));
						}
						else if (tmpCodeLang === 'excalidraw')
						{
							// Excalidraw scenes: emit a placeholder div with the
							// scene JSON URI-component encoded into a data
							// attribute.  Pict-View-Content's
							// renderExcalidrawDiagrams() swaps these for rendered
							// SVGs once the wrapper bundle is ready.  We don't
							// validate the JSON here — invalid fences just stay
							// as the loading placeholder until the runtime
							// reports the error.
							let tmpRawScene = tmpCodeLines.join('\n');
							let tmpEncoded;
							try { tmpEncoded = encodeURIComponent(tmpRawScene); }
							catch (pErr) { tmpEncoded = ''; }
							tmpHTML.push('<div class="pict-excalidraw-fence" data-scene="' + tmpEncoded + '">' +
								'<div class="pict-excalidraw-fence-loading">Rendering Excalidraw diagram…</div>' +
								'</div>');
						}
						else
						{
							let tmpCodeText = tmpCodeLines.join('\n');
						let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
						let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
						tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code class="language-' + this.escapeHTML(tmpCodeLang) + '">' + tmpHighlightedCode + '</code></pre></div>');
						}
						tmpInCodeBlock = false;
						tmpCodeFenceLength = 0;
						tmpCodeLang = '';
						tmpCodeLines = [];
						continue;
					}
					else
					{
						// Inner fence with fewer backticks — treat as content
						tmpCodeLines.push(tmpLine);
						continue;
					}
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					// Start code block — record fence length
					tmpCodeFenceLength = tmpFenceLen;
					tmpCodeLang = tmpLine.replace(/^`{3,}/, '').trim();
					tmpInCodeBlock = true;
					continue;
				}
			}

			if (tmpInCodeBlock)
			{
				tmpCodeLines.push(tmpLine);
				continue;
			}

			// Blockquotes
			if (tmpLine.match(/^>\s?/))
			{
				if (!tmpInBlockquote)
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					tmpInBlockquote = true;
					tmpBlockquoteLines = [];
				}
				tmpBlockquoteLines.push(tmpLine.replace(/^>\s?/, ''));
				continue;
			}
			else if (tmpInBlockquote)
			{
				tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
				tmpInBlockquote = false;
				tmpBlockquoteLines = [];
			}

			// Horizontal rule
			if (tmpLine.match(/^(-{3,}|\*{3,}|_{3,})\s*$/))
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				tmpHTML.push('<hr>');
				continue;
			}

			// Headings
			let tmpHeadingMatch = tmpLine.match(/^(#{1,6})\s+(.+)/);
			if (tmpHeadingMatch)
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				let tmpLevel = tmpHeadingMatch[1].length;
				let tmpText = this.parseInline(tmpHeadingMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver);
				let tmpID = tmpHeadingMatch[2].toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
				tmpHTML.push('<h' + tmpLevel + ' id="' + tmpID + '">' + tmpText + '</h' + tmpLevel + '>');
				continue;
			}

			// Unordered list items
			let tmpULMatch = tmpLine.match(/^(\s*)[-*+]\s+(.*)/);
			if (tmpULMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ul')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ul>');
					tmpInList = true;
					tmpListType = 'ul';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpULMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Ordered list items
			let tmpOLMatch = tmpLine.match(/^(\s*)\d+\.\s+(.*)/);
			if (tmpOLMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ol')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ol>');
					tmpInList = true;
					tmpListType = 'ol';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpOLMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Indented continuation line of a wrapped list item — fold its
			// content into the last <li> instead of closing the list. Closing
			// here would split a real <ol>/<ul>, and each fragment restarts
			// ordered numbering. A non-indented non-marker line still closes
			// the list (handled below); blank lines never reach this branch.
			if (tmpInList && tmpLine.match(/^\s+\S/) && tmpHTML.length > 0 && tmpHTML[tmpHTML.length - 1].endsWith('</li>'))
			{
				let tmpLastIndex = tmpHTML.length - 1;
				let tmpListItemBody = tmpHTML[tmpLastIndex].slice(0, -'</li>'.length);
				tmpHTML[tmpLastIndex] = tmpListItemBody + ' ' + this.parseInline(tmpLine.trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>';
				continue;
			}

			// Close list if we've left list items
			if (tmpInList && tmpLine.trim() !== '')
			{
				tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
				tmpInList = false;
			}

			// Empty line — flush any accumulated paragraph
			if (tmpLine.trim() === '')
			{
				fFlushParagraph();
				continue;
			}

			// Table detection
			if (tmpLine.match(/^\|/) && i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|[\s-:|]+\|/))
			{
				fFlushParagraph();
				// Close any open list
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}

				let tmpTableHTML = '<table>';

				// Header row
				let tmpHeaders = tmpLine.split('|').filter((pCell) => { return pCell.trim() !== ''; });
				tmpTableHTML += '<thead><tr>';
				for (let h = 0; h < tmpHeaders.length; h++)
				{
					tmpTableHTML += '<th>' + this.parseInline(tmpHeaders[h].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</th>';
				}
				tmpTableHTML += '</tr></thead>';

				// Skip separator row
				i++;

				// Body rows
				tmpTableHTML += '<tbody>';
				while (i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|/))
				{
					i++;
					let tmpCells = tmpLines[i].split('|').filter((pCell) => { return pCell.trim() !== ''; });
					tmpTableHTML += '<tr>';
					for (let c = 0; c < tmpCells.length; c++)
					{
						tmpTableHTML += '<td>' + this.parseInline(tmpCells[c].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</td>';
					}
					tmpTableHTML += '</tr>';
				}
				tmpTableHTML += '</tbody></table>';
				tmpHTML.push(tmpTableHTML);
				continue;
			}

			// Accumulate paragraph lines — consecutive non-blank text lines
			// will be joined into a single <p> tag when flushed
			tmpParagraphLines.push(tmpLine);
		}

		// Flush any remaining accumulated paragraph
		fFlushParagraph();

		// Close any trailing open elements
		if (tmpInList)
		{
			tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
		}
		if (tmpInBlockquote)
		{
			tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
		}
		if (tmpInCodeBlock)
		{
			let tmpCodeText = tmpCodeLines.join('\n');
			let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
			let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
			tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code>' + tmpHighlightedCode + '</code></pre></div>');
		}

		return tmpHTML.join('\n');
	}

	/**
	 * Parse inline markdown elements (bold, italic, code, links, images, KaTeX).
	 *
	 * @param {string} pText - The text to parse
	 * @param {Function} [pLinkResolver] - Optional callback: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. When provided, known vocabulary terms in the rendered text are wrapped in <span class="pict-vocab-term"> with data attributes carrying the popover content.
	 * @returns {string} HTML with inline elements
	 */
	parseInline(pText, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pText)
		{
			return '';
		}

		let tmpResult = pText;

		// Extract inline code spans into placeholders so bold/italic regexes don't mangle their contents
		let tmpCodeSpans = [];
		tmpResult = tmpResult.replace(/`([^`]+)`/g, (pMatch, pCode) =>
		{
			let tmpIndex = tmpCodeSpans.length;
			tmpCodeSpans.push('<code>' + pCode + '</code>');
			return '\x00CODEINLINE' + tmpIndex + '\x00';
		});

		// Inline LaTeX equations ($...$) — must be processed before other inline patterns
		// Match single $ delimiters that aren't adjacent to spaces (to avoid false positives with currency)
		tmpResult = tmpResult.replace(/\$([^\$\s][^\$]*?[^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');
		// Also match single-character inline math like $x$
		tmpResult = tmpResult.replace(/\$([^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');

		// Images
		tmpResult = tmpResult.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (pMatch, pAlt, pSrc) =>
		{
			let tmpSrc = pSrc;
			if (typeof pImageResolver === 'function')
			{
				let tmpResolved = pImageResolver(pSrc, pAlt);
				if (tmpResolved)
				{
					tmpSrc = tmpResolved;
				}
			}
			// A video file written with the image form. Authors reach for `![clip](demo.mp4)` because it is
			// the syntax their fingers know, and an <img> pointed at an mp4 is a broken image icon -- so it
			// renders a player instead. Only a real video EXTENSION qualifies; see hasVideoExtension.
			if (this.hasVideoExtension(tmpSrc) && this.isSafeMediaURL(tmpSrc))
			{
				return '<video class="pict-content-video-inline" controls preload="metadata" src="' + this.escapeHTML(tmpSrc) + '">' +
					'<a href="' + this.escapeHTML(tmpSrc) + '">' + this.escapeHTML(pAlt || 'Download the video') + '</a></video>';
			}
			return '<img src="' + tmpSrc + '" alt="' + pAlt + '">';
		});

		// Links
		tmpResult = tmpResult.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (pMatch, pLinkText, pHref) =>
		{
			if (typeof pLinkResolver === 'function')
			{
				let tmpResolved = pLinkResolver(pHref, pLinkText);
				if (tmpResolved)
				{
					let tmpTarget = tmpResolved.target ? ' target="' + tmpResolved.target + '"' : '';
					let tmpRel = tmpResolved.rel ? ' rel="' + tmpResolved.rel + '"' : '';
					return '<a href="' + tmpResolved.href + '"' + tmpTarget + tmpRel + '>' + pLinkText + '</a>';
				}
			}
			// Default behavior: external links open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return '<a href="' + pHref + '" target="_blank" rel="noopener">' + pLinkText + '</a>';
			}
			return '<a href="' + pHref + '">' + pLinkText + '</a>';
		});

		// Bold
		tmpResult = tmpResult.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
		// Underscore strong only at word boundaries (CommonMark intraword rule) so
		// identifiers / URLs like a__b or foo__bar aren't treated as emphasis.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])__([^_]+?)__(?![A-Za-z0-9_])/g, '$1<strong>$2</strong>');

		// Italic
		tmpResult = tmpResult.replace(/\*([^*]+)\*/g, '<em>$1</em>');
		// Underscore italic only at word boundaries — a single underscore inside a
		// word or a URL (e.g. hello_world in a link href) must NOT become <em>.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])_([^_]+?)_(?![A-Za-z0-9_])/g, '$1<em>$2</em>');

		// Restore inline code spans from placeholders
		tmpResult = tmpResult.replace(/\x00CODEINLINE(\d+)\x00/g, (pMatch, pIndex) =>
		{
			return tmpCodeSpans[parseInt(pIndex)];
		});

		// Vocabulary term auto-linking: scan the rendered text for
		// known vocabulary terms and wrap each first occurrence in a
		// span with data attributes for the popover system. Skips
		// content inside <code>, <a>, <pre>, and <strong> tags to
		// avoid mangling links, code, or already-emphasized text.
		if (typeof pVocabularyResolver === 'function')
		{
			tmpResult = this._applyVocabularyLinks(tmpResult, pVocabularyResolver);
		}

		return tmpResult;
	}

	/**
	 * Scan HTML for vocabulary terms and wrap the first occurrence
	 * of each in a <span class="pict-vocab-term"> element. The
	 * resolver callback is called for each candidate word/phrase
	 * and returns { slug, title, short } if it's a known term.
	 *
	 * Skips content inside HTML tags to avoid breaking links,
	 * code spans, and other markup.
	 *
	 * @param {string} pHTML
	 * @param {Function} pResolver - (word) => {slug, title, short} | null
	 * @returns {string}
	 */
	_applyVocabularyLinks(pHTML, pResolver)
	{
		if (!pHTML || typeof pResolver !== 'function')
		{
			return pHTML;
		}

		// Track which terms we've already linked to avoid duplicate
		// links for the same term appearing multiple times.
		let tmpLinked = {};

		// Split the HTML into segments: tags vs text nodes. We only
		// scan text nodes for vocabulary terms; tags pass through.
		// This regex captures HTML tags as separators.
		let tmpParts = pHTML.split(/(<[^>]+>)/g);

		// Track whether we're inside a tag that should be skipped
		let tmpSkipDepth = 0;
		let tmpSkipTags = ['code', 'a', 'pre', 'span'];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];

			// Check if this is an HTML tag
			if (tmpPart.charAt(0) === '<')
			{
				// Opening tag?
				let tmpOpenMatch = tmpPart.match(/^<(\w+)/);
				if (tmpOpenMatch && tmpSkipTags.indexOf(tmpOpenMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth++;
				}
				// Closing tag?
				let tmpCloseMatch = tmpPart.match(/^<\/(\w+)/);
				if (tmpCloseMatch && tmpSkipTags.indexOf(tmpCloseMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth = Math.max(0, tmpSkipDepth - 1);
				}
				continue; // Don't modify tags
			}

			// Skip text inside protected elements
			if (tmpSkipDepth > 0) continue;

			// Scan this text node for vocabulary terms. Use word
			// boundary regex to match whole words only.
			tmpParts[i] = tmpPart.replace(/\b([A-Za-z][A-Za-z0-9_-]{1,30})\b/g, (pMatch, pWord) =>
			{
				// Skip very short words and common English words
				if (pWord.length < 3) return pMatch;

				let tmpLower = pWord.toLowerCase();
				if (tmpLinked[tmpLower]) return pMatch; // already linked

				let tmpResult = pResolver(tmpLower);
				if (!tmpResult) return pMatch;

				tmpLinked[tmpLower] = true;
				let tmpShortEsc = (tmpResult.short || '').replace(/"/g, '&quot;');
				return '<span class="pict-vocab-term" data-vocab-slug="' + tmpResult.slug +
					'" data-vocab-title="' + (tmpResult.title || '').replace(/"/g, '&quot;') +
					'" data-vocab-short="' + tmpShortEsc + '">' + pMatch + '</span>';
			});
		}

		return tmpParts.join('');
	}

	/**
	 * The file extensions that mean "these bytes ARE the video", as opposed to a page about one.
	 */
	static get VIDEO_EXTENSIONS()
	{
		return ['mp4', 'webm', 'ogv', 'ogg', 'mov', 'm4v'];
	}

	/**
	 * Recognize a third-party video URL and return { Provider, Embed, Watch }, or null when the URL is not
	 * one this knows how to embed.
	 *
	 * Only YouTube and Vimeo are recognized on purpose: an embed is a third party running code in the
	 * reader's page, so the set of parties allowed to do that is a list, not a guess.
	 *
	 * @param {string} pURL
	 * @returns {Object|null}
	 */
	videoProviderFor(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		let tmpYouTube = tmpURL.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
		if (tmpYouTube)
		{
			// youtube-nocookie.com is the same player without the tracking cookies it would otherwise set
			// the moment the frame loads.
			return {
				Provider: 'YouTube',
				Embed: 'https://www.youtube-nocookie.com/embed/' + tmpYouTube[1] + '?autoplay=1&rel=0',
				Watch: 'https://www.youtube.com/watch?v=' + tmpYouTube[1]
			};
		}
		let tmpVimeo = tmpURL.match(/vimeo\.com\/(?:video\/)?(\d{6,})/);
		if (tmpVimeo)
		{
			return {
				Provider: 'Vimeo',
				Embed: 'https://player.vimeo.com/video/' + tmpVimeo[1] + '?autoplay=1',
				Watch: 'https://vimeo.com/' + tmpVimeo[1]
			};
		}
		return null;
	}

	/**
	 * Is this URL safe to put in an href or a src? Only http(s) and same-document relative URLs are, which
	 * is what keeps a javascript: or data: URL in a document from becoming script when a reader clicks it.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	isSafeMediaURL(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		if (!tmpURL) { return false; }
		if (/^https?:\/\//i.test(tmpURL)) { return true; }
		// A relative or root-relative path: same origin by construction, so it carries the document's own
		// trust. Anything with a scheme that is not http(s) is refused.
		return !/^[A-Za-z][A-Za-z0-9+.-]*:/.test(tmpURL);
	}

	/**
	 * Does this URL end in a video file extension? Strictly the extension, nothing inferred.
	 *
	 * The inline image form uses THIS rather than isDirectVideoURL: in a ```video fence the author has
	 * already said the thing is a video, so a relative URL can be taken at its word, but `![logo](/img/x)`
	 * is an image and treating every extensionless relative source as video would turn the whole media
	 * library into broken players.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	hasVideoExtension(pURL)
	{
		let tmpPath = String(pURL || '').trim().split('?')[0].split('#')[0];
		return PictContentProvider.VIDEO_EXTENSIONS.indexOf((tmpPath.split('.').pop() || '').toLowerCase()) >= 0;
	}

	/**
	 * Does this URL point at video BYTES rather than a page about a video?
	 *
	 * A known video extension says yes. So does any relative URL: those are served by the application
	 * itself, which is how an uploaded recording is addressed (a blob route often carries no extension at
	 * all), and the application does not serve watch pages to its own markdown.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	isDirectVideoURL(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		if (!tmpURL) { return false; }
		if (this.hasVideoExtension(tmpURL)) { return true; }
		return !/^https?:\/\//i.test(tmpURL);
	}

	/**
	 * The HTML for a ```video fence.
	 *
	 * Body shape: the URL on the first non-empty line, then optional `key: value` lines (title, poster).
	 *
	 *     ```video
	 *     https://www.youtube.com/watch?v=abc123
	 *     title: How the deploy pipeline works
	 *     poster: /1.0/Media/42/Blob
	 *     ```
	 *
	 * Two outcomes, decided by where the video lives:
	 *
	 * - Self-hosted (relative URL, or a file with a video extension) renders a plain <video controls
	 *   preload="metadata">. The bytes come from the same place the page did, so there is nothing to
	 *   consent to, and preload="metadata" paints the real first frame as its own thumbnail.
	 * - A third-party watch page renders a CLICK-TO-LOAD card. Nothing is fetched from that party until the
	 *   reader asks for it -- not the player, and not the poster image either, since fetching a thumbnail
	 *   from the provider would leak the reader to them exactly as the player does. A poster is shown only
	 *   when the author supplied one. Without JavaScript the card is still a working link to the video,
	 *   which is what a server-rendered or printed copy of the document falls back to.
	 *
	 * @param {string} pBody - The fence contents
	 * @returns {string} The HTML
	 */
	videoEmbedHTML(pBody)
	{
		let tmpLines = String(pBody || '').split('\n').map((pLine) => { return pLine.trim(); }).filter((pLine) => { return pLine.length > 0; });
		if (!tmpLines.length)
		{
			return '<figure class="pict-content-video pict-content-video-empty"><figcaption>No video URL was given.</figcaption></figure>';
		}
		let tmpURL = tmpLines[0];
		let tmpOptions = {};
		for (let i = 1; i < tmpLines.length; i++)
		{
			let tmpMatch = tmpLines[i].match(/^([A-Za-z][A-Za-z0-9_-]*)\s*:\s*(.*)$/);
			if (tmpMatch) { tmpOptions[tmpMatch[1].toLowerCase()] = tmpMatch[2].trim(); }
		}
		if (!this.isSafeMediaURL(tmpURL))
		{
			return '<figure class="pict-content-video pict-content-video-empty"><figcaption>That video link was not a http(s) or relative URL.</figcaption></figure>';
		}

		let tmpTitle = tmpOptions.title || '';
		let tmpPoster = (tmpOptions.poster && this.isSafeMediaURL(tmpOptions.poster)) ? tmpOptions.poster : '';
		// The caption belongs under a PLAYER, which has nowhere else to say what it is. A card already
		// carries the title inside it, so captioning that one prints the same sentence twice.
		let tmpCaption = tmpTitle ? ('<figcaption>' + this.escapeHTML(tmpTitle) + '</figcaption>') : '';

		if (this.isDirectVideoURL(tmpURL))
		{
			return '<figure class="pict-content-video pict-content-video-file">' +
				'<video controls preload="metadata" src="' + this.escapeHTML(tmpURL) + '"' +
				(tmpPoster ? (' poster="' + this.escapeHTML(tmpPoster) + '"') : '') + '>' +
				'<a href="' + this.escapeHTML(tmpURL) + '">' + this.escapeHTML(tmpTitle || 'Download the video') + '</a>' +
				'</video>' + tmpCaption + '</figure>';
		}

		let tmpProvider = this.videoProviderFor(tmpURL);
		let tmpWatch = tmpProvider ? tmpProvider.Watch : tmpURL;
		let tmpLabel = tmpProvider
			? (tmpProvider.Provider + ' - plays from ' + tmpProvider.Provider + ' when you start it')
			: 'Opens in a new tab';
		// data-embed is what the view swaps in on click. A card with no data-embed (an unrecognized site)
		// stays a link, which is the honest outcome: this cannot promise to embed a page it does not know.
		return '<figure class="pict-content-video pict-content-video-embed"' +
			(tmpProvider ? (' data-embed="' + this.escapeHTML(tmpProvider.Embed) + '"') : '') +
			' data-provider="' + this.escapeHTML(tmpProvider ? tmpProvider.Provider : 'link') + '">' +
			'<a class="pict-content-video-card" href="' + this.escapeHTML(tmpWatch) + '" target="_blank" rel="noopener noreferrer">' +
			(tmpPoster ? ('<img class="pict-content-video-poster" src="' + this.escapeHTML(tmpPoster) + '" alt="">') : '') +
			'<span class="pict-content-video-play" aria-hidden="true">' +
			'<svg viewBox="0 0 68 48" width="54" height="38"><path class="pict-content-video-play-bg" d="M66.5 7.7a8 8 0 0 0-5.6-5.7C55.9.6 34 .6 34 .6s-21.9 0-26.9 1.4a8 8 0 0 0-5.6 5.7A83 83 0 0 0 .1 24a83 83 0 0 0 1.4 16.3 8 8 0 0 0 5.6 5.7c5 1.4 26.9 1.4 26.9 1.4s21.9 0 26.9-1.4a8 8 0 0 0 5.6-5.7A83 83 0 0 0 67.9 24a83 83 0 0 0-1.4-16.3z"/><path d="M27 34V14l18 10z" fill="#fff"/></svg>' +
			'</span>' +
			'<span class="pict-content-video-label">' +
			'<span class="pict-content-video-title">' + this.escapeHTML(tmpTitle || tmpWatch) + '</span>' +
			'<span class="pict-content-video-source">' + this.escapeHTML(tmpLabel) + '</span>' +
			'</span></a></figure>';
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = PictContentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Pict-Content",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"../Pict-Content-CSS.js":485,"pict-provider":479,"pict-section-code":483}],488:[function(require,module,exports){
const libPictView = require('pict-view');

const libContentCSS = require('../Pict-Content-CSS.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	// Shared with the provider under one hash so the CSS injects once whether the view, the
	// provider (parseMarkdown), or both are used.
	CSS: libContentCSS,
	CSSHash: 'Pict-Section-Content-CSS',

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Ensure the container carries the `.pict-content` class so the
		// 30+ theme-scoped CSS rules below (`.pict-content a`, `.pict-content
		// h1`, `.pict-content pre`, ...) actually match when a host passes
		// a custom container ID.  Idempotent — re-adding the class is a
		// no-op if it's already there from the host's markup.
		if (tmpContentContainer && !tmpContentContainer.classList.contains('pict-content'))
		{
			tmpContentContainer.classList.add('pict-content');
		}

		// Tag images and code blocks immediately so they're clickable.
		// Mermaid blocks are tagged after mermaid.run() resolves (see below).
		this.enableFullscreenViewers(tmpContainerID, { skipMermaid: true });

		// Post-render: initialize Mermaid diagrams if mermaid is available.
		// Once mermaid finishes, retag so the rendered SVGs are also clickable.
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render ```excalidraw fenced scenes if the
		// pict-section-excalidraw wrapper bundle is loaded.  Each fence
		// becomes a static SVG (with the scene embedded for re-edit by
		// retold-content-system).
		this.renderExcalidrawDiagrams(tmpContainerID);

		// Post-render: make ```video cards for third-party players click-to-load.
		this.hydrateVideoEmbeds(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Wire the click-to-load video cards the markdown parser emitted for third-party players.
	 *
	 * Until a reader clicks, nothing has been requested from the provider: no player, no cookies, no
	 * thumbnail, no record that this document was opened. The click is the consent, and only then is the
	 * iframe created. This is the whole reason the card exists rather than an iframe -- an embed that loads
	 * with the page has already told a third party who is reading before anyone chose anything.
	 *
	 * Degrades to a link. With no JavaScript, or before this runs, the card is an anchor to the video, which
	 * is what a server-rendered or printed copy of a document is left with.
	 *
	 * Idempotent: a hydrated figure carries data-hydrated, so a re-render does not double-bind.
	 *
	 * @param {string} [pContainerID]
	 */
	hydrateVideoEmbeds(pContainerID)
	{
		if (typeof document === 'undefined') { return; }
		let tmpContainer = pContainerID ? document.getElementById(String(pContainerID).replace(/^#/, '')) : document;
		if (!tmpContainer) { return; }
		let tmpFigures = tmpContainer.querySelectorAll('.pict-content-video-embed[data-embed]:not([data-hydrated])');
		for (let i = 0; i < tmpFigures.length; i++)
		{
			let tmpFigure = tmpFigures[i];
			tmpFigure.setAttribute('data-hydrated', 'true');
			let tmpCard = tmpFigure.querySelector('.pict-content-video-card');
			if (!tmpCard) { continue; }
			tmpCard.addEventListener('click', (pEvent) =>
			{
				// A modified click is the reader asking for a new tab; leave the anchor to do that.
				if (pEvent.metaKey || pEvent.ctrlKey || pEvent.shiftKey || pEvent.altKey || pEvent.button > 0) { return; }
				pEvent.preventDefault();
				let tmpEmbed = tmpFigure.getAttribute('data-embed') || '';
				if (!tmpEmbed) { return; }
				let tmpFrame = document.createElement('iframe');
				tmpFrame.setAttribute('src', tmpEmbed);
				tmpFrame.setAttribute('title', (tmpFigure.querySelector('.pict-content-video-title') || {}).textContent || 'Video');
				tmpFrame.setAttribute('frameborder', '0');
				tmpFrame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
				tmpFrame.setAttribute('allowfullscreen', 'allowfullscreen');
				// The player gets no referrer: which document someone watched a video from is not the
				// provider's business, and nothing about playback needs it.
				tmpFrame.setAttribute('referrerpolicy', 'no-referrer');
				tmpFrame.className = 'pict-content-video-frame';
				tmpCard.parentNode.replaceChild(tmpFrame, tmpCard);
			});
		}
	}

	/**
	 * Render any `.pict-excalidraw-fence` placeholders inside the container
	 * as static SVGs using the pict-section-excalidraw wrapper bundle's
	 * exportToSvg helper.  Each fence's scene JSON travels through a
	 * URI-component-encoded data-scene attribute (placed there by the
	 * markdown parser in Pict-Provider-Content).
	 *
	 * Gracefully degrades when the wrapper bundle isn't on the page:
	 * leaves the loading placeholder visible with a one-time console hint.
	 * Idempotent — placeholders carry `data-rendered="true"` after the
	 * first pass so re-renders don't double-emit.
	 *
	 * @param {string} [pContainerID]
	 */
	renderExcalidrawDiagrams(pContainerID)
	{
		if (typeof document === 'undefined') return;

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody) return;

		let tmpFences = tmpContentBody.querySelectorAll('.pict-excalidraw-fence:not([data-rendered])');
		if (tmpFences.length < 1) return;

		let tmpVendor = (typeof window !== 'undefined') ? window.PictSectionExcalidrawVendor : null;
		if (!tmpVendor || typeof tmpVendor.exportToSvg !== 'function')
		{
			// Bundle not loaded — leave the placeholder visible.  The host
			// can load the wrapper bundle and call renderExcalidrawDiagrams
			// again, or include the script tag in its HTML shell.
			if (this.log && this.log.warn && !this._excalidrawBundleWarnLogged)
			{
				this.log.warn('pict-excalidraw fence(s) found but pict-section-excalidraw wrapper bundle is not loaded — leaving as placeholders.');
				this._excalidrawBundleWarnLogged = true;
			}
			return;
		}

		for (let i = 0; i < tmpFences.length; i++)
		{
			let tmpFence = tmpFences[i];
			let tmpEncoded = tmpFence.getAttribute('data-scene') || '';
			let tmpJson = '';
			try { tmpJson = decodeURIComponent(tmpEncoded); }
			catch (pErr) { tmpJson = ''; }

			let tmpScene;
			try { tmpScene = JSON.parse(tmpJson); }
			catch (pErr)
			{
				this._renderExcalidrawFenceError(tmpFence, 'Invalid scene JSON: ' + pErr.message);
				continue;
			}

			let tmpExportArgs = {
				elements: tmpScene.elements || [],
				appState: Object.assign({ exportEmbedScene: true }, tmpScene.appState || {}),
				files:    tmpScene.files    || {}
			};

			tmpVendor.exportToSvg(tmpExportArgs).then((pSvgEl) =>
			{
				if (!pSvgEl) return;
				// Style the SVG to fit the fence's content width while preserving aspect.
				pSvgEl.removeAttribute('width');
				pSvgEl.removeAttribute('height');
				pSvgEl.setAttribute('style', 'max-width: 100%; height: auto;');
				tmpFence.innerHTML = '';
				tmpFence.appendChild(pSvgEl);
				tmpFence.setAttribute('data-rendered', 'true');
			}).catch((pErr) =>
			{
				this._renderExcalidrawFenceError(tmpFence,
					'Excalidraw render failed: ' + (pErr && pErr.message ? pErr.message : pErr));
			});
		}
	}

	_renderExcalidrawFenceError(pFence, pMessage)
	{
		pFence.setAttribute('data-rendered', 'true');
		pFence.classList.add('pict-excalidraw-fence-error');
		pFence.innerHTML = '<div class="pict-excalidraw-fence-error-message"></div>';
		// Use textContent on the inner div so any user-supplied error
		// substrings (e.g. parser error positions) can't introduce HTML.
		let tmpMsg = pFence.querySelector('.pict-excalidraw-fence-error-message');
		if (tmpMsg) tmpMsg.textContent = pMessage;
		if (this.log && this.log.warn) this.log.warn('pict-excalidraw fence: ' + pMessage);
	}

	/**
	 * Lazily wire mermaid into the active pict-provider-theme via the
	 * shared Theme-Diagram-Adapter. The adapter handles:
	 *   - mermaid.initialize() with the canonical pict token map
	 *   - onApply subscription (re-init + re-render on theme/mode change)
	 *   - source stashing + data-processed reset for refresh
	 *
	 * Idempotent: the first call binds the adapter, subsequent calls are
	 * no-ops.  When the provider isn't installed, mermaid still gets
	 * initialized once against whatever CSS variables happen to exist.
	 */
	_ensureMermaidAdapter()
	{
		if (this._mermaidAdapter) { return this._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				this._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				// No provider: lazy-require the adapter directly so the
				// static base theme still picks up any CSS vars on :root.
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				this._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			if (this.log && this.log.warn) { this.log.warn('Mermaid theme adapter init failed: ' + pError.message); }
			this._mermaidAdapter = null;
		}
		return this._mermaidAdapter;
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the Theme-Diagram-Adapter, which initializes
		// mermaid against the active palette and subscribes to onApply so a
		// theme/mode change triggers re-render of every pre.mermaid on the page.
		this._ensureMermaidAdapter();

		// Cache each diagram's source on the element so theme-change
		// re-renders can restore it. Mermaid replaces textContent with
		// the rendered SVG during run(), so we lose the source unless
		// we stash it here first.
		let tmpProviderForStash = this.pict && this.pict.providers && this.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		// mermaid.run() will process all pre.mermaid elements in the container.
		// It returns a promise; once it resolves the inner SVG exists and we
		// can tag the diagrams as fullscreen-clickable.
		try
		{
			let tmpResult = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(() =>
				{
					// Strip mermaid 11's inline !important fill/stroke flags
					// so the view's theme-aware .theme-dark CSS rules can win
					// against the per-node colors mermaid bakes inline.  The
					// adapter strips on every re-render; the initial render
					// runs through mermaid.run() directly so we have to call
					// the strip here too.  Without this the dark-mode rect
					// fill override silently loses to inline `!important`.
					let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
					if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
					{
						tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
					}
					this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
				}).catch((pError) =>
				{
					this.log.error('Mermaid rendering error: ' + (pError && pError.message ? pError.message : pError));
				});
			}
			else
			{
				// Synchronous fallback (older mermaid)
				let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
				if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
				{
					tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
				}
				this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
			}
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Walk the freshly-rendered content and tag images, mermaid diagrams,
	 * and fenced code blocks so they're click-to-fullscreen.  Also installs
	 * a single delegated click listener on the container the first time it
	 * is called for that container.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 * @param {Object} [pOptions] - { skipMermaid: bool, onlyMermaid: bool }
	 */
	enableFullscreenViewers(pContainerID, pOptions)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}
		let tmpOptions = pOptions || {};

		if (!tmpOptions.onlyMermaid)
		{
			// Images
			let tmpImages = tmpContentBody.querySelectorAll('img:not([data-fullscreen-source])');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpImg = tmpImages[i];
				tmpImg.setAttribute('data-fullscreen-source', 'image');
				let tmpAlt = tmpImg.getAttribute('alt');
				if (!tmpAlt)
				{
					let tmpSrc = tmpImg.getAttribute('src') || '';
					tmpAlt = tmpSrc.split('/').pop().split('?')[0] || 'Image';
				}
				tmpImg.setAttribute('data-fullscreen-title', tmpAlt);
			}

			// Code wraps (fenced blocks): do NOT tag for click-to-fullscreen —
			// that would conflict with text selection for copy/paste.
			// Instead wrap each in a container with hover-revealed action
			// buttons (fullscreen + copy) floating to the right.
			let tmpCodeWraps = tmpContentBody.querySelectorAll('.pict-content-code-wrap:not([data-code-actions-wired])');
			for (let i = 0; i < tmpCodeWraps.length; i++)
			{
				this._wireCodeActions(tmpCodeWraps[i]);
			}
		}

		if (!tmpOptions.skipMermaid)
		{
			// Mermaid diagrams (after mermaid.run() has replaced the inner pre)
			let tmpMermaid = tmpContentBody.querySelectorAll('pre.mermaid:not([data-fullscreen-source])');
			for (let i = 0; i < tmpMermaid.length; i++)
			{
				let tmpPre = tmpMermaid[i];
				// Only tag once mermaid has actually rendered an svg into it
				if (tmpPre.querySelector('svg'))
				{
					tmpPre.setAttribute('data-fullscreen-source', 'mermaid');
					tmpPre.setAttribute('data-fullscreen-title', 'Mermaid Diagram');
				}
			}
		}

		// Install delegated click listener once per container.
		if (!tmpContentBody.__pictFullscreenWired)
		{
			tmpContentBody.__pictFullscreenWired = true;
			tmpContentBody.addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				while (tmpTarget && tmpTarget !== tmpContentBody && !tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					tmpTarget = tmpTarget.parentElement;
				}
				if (tmpTarget && tmpTarget !== tmpContentBody && tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					pEvent.preventDefault();
					this._openFullscreen(tmpTarget);
				}
			});
		}
	}

	/**
	 * Wrap a fenced code block in a container that holds the existing
	 * .pict-content-code-wrap plus a hover-revealed action column with
	 * fullscreen + copy buttons.  The action column is sticky-positioned
	 * so it follows the page scroll while the user is alongside a long
	 * code block.
	 *
	 * @param {HTMLElement} pCodeWrap - The .pict-content-code-wrap element
	 */
	_wireCodeActions(pCodeWrap)
	{
		if (!pCodeWrap || pCodeWrap.hasAttribute('data-code-actions-wired'))
		{
			return;
		}
		pCodeWrap.setAttribute('data-code-actions-wired', 'true');

		// Determine the fullscreen title from the language tag, if any.
		let tmpCodeEl = pCodeWrap.querySelector('code[class*="language-"]');
		let tmpLang = 'Code';
		if (tmpCodeEl)
		{
			let tmpMatch = (tmpCodeEl.getAttribute('class') || '').match(/language-(\S+)/);
			if (tmpMatch)
			{
				tmpLang = tmpMatch[1] + ' code';
			}
		}
		pCodeWrap.setAttribute('data-code-language', tmpLang);

		// Build the wrapping container.
		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-content-code-container';

		let tmpActions = document.createElement('div');
		tmpActions.className = 'pict-content-code-actions';
		tmpActions.setAttribute('aria-hidden', 'false');

		let tmpFullscreenBtn = document.createElement('button');
		tmpFullscreenBtn.type = 'button';
		tmpFullscreenBtn.className = 'pict-content-code-action-btn';
		tmpFullscreenBtn.setAttribute('aria-label', 'Open code in fullscreen');
		tmpFullscreenBtn.setAttribute('title', 'Open in fullscreen');
		tmpFullscreenBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><polyline points="3 6 3 3 6 3"></polyline><polyline points="13 6 13 3 10 3"></polyline><polyline points="3 10 3 13 6 13"></polyline><polyline points="13 10 13 13 10 13"></polyline></svg>';

		let tmpCopyBtn = document.createElement('button');
		tmpCopyBtn.type = 'button';
		tmpCopyBtn.className = 'pict-content-code-action-btn';
		tmpCopyBtn.setAttribute('aria-label', 'Copy code to clipboard');
		tmpCopyBtn.setAttribute('title', 'Copy code');
		tmpCopyBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1.25"></rect><path d="M11 5V3.25A1.25 1.25 0 0 0 9.75 2H3.25A1.25 1.25 0 0 0 2 3.25v6.5A1.25 1.25 0 0 0 3.25 11H5"></path></svg>';

		tmpActions.appendChild(tmpFullscreenBtn);
		tmpActions.appendChild(tmpCopyBtn);

		// Insert the container in the place of the code wrap, then move the
		// code wrap inside it followed by the actions column.
		let tmpParent = pCodeWrap.parentNode;
		tmpParent.insertBefore(tmpContainer, pCodeWrap);
		tmpContainer.appendChild(pCodeWrap);
		tmpContainer.appendChild(tmpActions);

		// Click handlers
		tmpFullscreenBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._openCodeFullscreen(pCodeWrap);
		});
		tmpCopyBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._copyCodeToClipboard(pCodeWrap, tmpCopyBtn);
		});
	}

	/**
	 * Open the fullscreen overlay for a fenced code block.  Reuses the
	 * same overlay singleton as image / mermaid.
	 */
	_openCodeFullscreen(pCodeWrap)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		// Stamp the source attributes the overlay's open() expects.
		pCodeWrap.setAttribute('data-fullscreen-source', 'code');
		pCodeWrap.setAttribute('data-fullscreen-title', pCodeWrap.getAttribute('data-code-language') || 'Code');
		tmpOverlay.open(pCodeWrap);
	}

	/**
	 * Copy the raw text of a code block to the clipboard and briefly flash
	 * a "Copied!" state on the trigger button.
	 */
	_copyCodeToClipboard(pCodeWrap, pButton)
	{
		let tmpCodeEl = pCodeWrap.querySelector('code');
		let tmpText = tmpCodeEl ? tmpCodeEl.textContent : pCodeWrap.textContent;

		let fFlashOk = () =>
		{
			pButton.classList.add('is-copied');
			pButton.setAttribute('title', 'Copied!');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copied');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};
		let fFlashFail = () =>
		{
			pButton.classList.add('is-copy-failed');
			pButton.setAttribute('title', 'Copy failed');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copy-failed');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};

		try
		{
			if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
			{
				navigator.clipboard.writeText(tmpText).then(fFlashOk).catch(fFlashFail);
				return;
			}
		}
		catch (e)
		{
			// fall through to legacy fallback
		}

		// Legacy fallback for non-secure contexts.
		try
		{
			let tmpTextarea = document.createElement('textarea');
			tmpTextarea.value = tmpText;
			tmpTextarea.style.position = 'fixed';
			tmpTextarea.style.opacity = '0';
			document.body.appendChild(tmpTextarea);
			tmpTextarea.select();
			let tmpOk = document.execCommand('copy');
			document.body.removeChild(tmpTextarea);
			if (tmpOk) { fFlashOk(); } else { fFlashFail(); }
		}
		catch (e)
		{
			fFlashFail();
		}
	}

	/**
	 * Lazily build the singleton fullscreen overlay element and attach it
	 * to <body>.  Returns the existing instance if already built.
	 */
	_buildFullscreenOverlay()
	{
		if (PictContentView._FullscreenOverlay)
		{
			return PictContentView._FullscreenOverlay;
		}

		let tmpOverlay = document.createElement('div');
		tmpOverlay.className = 'pict-fullscreen-overlay';
		tmpOverlay.setAttribute('role', 'dialog');
		tmpOverlay.setAttribute('aria-modal', 'true');
		tmpOverlay.setAttribute('aria-labelledby', 'pict-fullscreen-title');
		tmpOverlay.setAttribute('hidden', '');
		tmpOverlay.innerHTML = ''
			+ '<div class="pict-fullscreen-titlebar">'
			+   '<span class="pict-fullscreen-title" id="pict-fullscreen-title"></span>'
			+   '<div class="pict-fullscreen-controls">'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-out" aria-label="Zoom out" title="Zoom out"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-reset" aria-label="Reset zoom" title="Reset zoom"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="5"></circle><line x1="8" y1="5" x2="8" y2="11"></line><line x1="5" y1="8" x2="11" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-in" aria-label="Zoom in" title="Zoom in"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line><line x1="8" y1="3" x2="8" y2="13"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn pict-fullscreen-close" data-action="close" aria-label="Close" title="Close (Esc)"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="4" y1="4" x2="12" y2="12"></line><line x1="12" y1="4" x2="4" y2="12"></line></svg></button>'
			+   '</div>'
			+ '</div>'
			+ '<div class="pict-fullscreen-stage">'
			+   '<div class="pict-fullscreen-content"></div>'
			+ '</div>';
		document.body.appendChild(tmpOverlay);

		let tmpState = {
			scale: 1,
			translateX: 0,
			translateY: 0,
			isPanning: false,
			didPan: false,
			currentKind: '',
			panStartX: 0,
			panStartY: 0,
			panOrigX: 0,
			panOrigY: 0,
			pinchInitialDistance: 0,
			pinchInitialScale: 1
		};

		let tmpStage = tmpOverlay.querySelector('.pict-fullscreen-stage');
		let tmpContent = tmpOverlay.querySelector('.pict-fullscreen-content');
		let tmpTitleEl = tmpOverlay.querySelector('.pict-fullscreen-title');

		let fApplyTransform = () =>
		{
			tmpContent.style.transform = 'translate(' + tmpState.translateX + 'px, ' + tmpState.translateY + 'px) scale(' + tmpState.scale + ')';
			tmpStage.classList.toggle('is-zoomed', tmpState.scale > 1.001);
		};

		let fClampScale = (pValue) =>
		{
			if (pValue < 0.5) return 0.5;
			if (pValue > 8) return 8;
			return pValue;
		};

		let fZoomAt = (pNewScale, pAnchorClientX, pAnchorClientY) =>
		{
			let tmpClamped = fClampScale(pNewScale);
			let tmpStageRect = tmpStage.getBoundingClientRect();
			let tmpAnchorX = (pAnchorClientX !== undefined) ? pAnchorClientX : (tmpStageRect.left + tmpStageRect.width / 2);
			let tmpAnchorY = (pAnchorClientY !== undefined) ? pAnchorClientY : (tmpStageRect.top + tmpStageRect.height / 2);
			// Convert anchor into the local coordinate of the content (which is centered)
			let tmpCenterX = tmpStageRect.left + tmpStageRect.width / 2;
			let tmpCenterY = tmpStageRect.top + tmpStageRect.height / 2;
			let tmpDX = tmpAnchorX - tmpCenterX;
			let tmpDY = tmpAnchorY - tmpCenterY;
			let tmpRatio = tmpClamped / tmpState.scale;
			tmpState.translateX = tmpDX - tmpRatio * (tmpDX - tmpState.translateX);
			tmpState.translateY = tmpDY - tmpRatio * (tmpDY - tmpState.translateY);
			tmpState.scale = tmpClamped;
			fApplyTransform();
		};

		let fResetTransform = () =>
		{
			tmpState.scale = 1;
			tmpState.translateX = 0;
			tmpState.translateY = 0;
			fApplyTransform();
		};

		let fClose = () =>
		{
			tmpOverlay.setAttribute('hidden', '');
			tmpContent.innerHTML = '';
			fResetTransform();
			document.documentElement.style.removeProperty('overflow');
			document.removeEventListener('keydown', fKeydown);
		};

		let fKeydown = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pEvent.preventDefault();
				fClose();
			}
			else if (pEvent.key === '+' || pEvent.key === '=')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale + 0.25);
			}
			else if (pEvent.key === '-' || pEvent.key === '_')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale - 0.25);
			}
			else if (pEvent.key === '0')
			{
				pEvent.preventDefault();
				fResetTransform();
			}
		};

		// Backdrop click closes (only when clicking the backdrop itself or
		// the stage area, not the inner content).  Suppress if a
		// drag-to-pan just finished — the pointerup that ended the pan
		// also fires a click event which we must ignore.
		tmpOverlay.addEventListener('click', (pEvent) =>
		{
			if (tmpState.didPan)
			{
				tmpState.didPan = false;
				return;
			}
			if (pEvent.target === tmpOverlay || pEvent.target === tmpStage)
			{
				fClose();
			}
		});

		// Toolbar buttons
		tmpOverlay.querySelectorAll('[data-action]').forEach((pBtn) =>
		{
			pBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpAction = pBtn.getAttribute('data-action');
				if (tmpAction === 'close')
				{
					fClose();
				}
				else if (tmpAction === 'zoom-in')
				{
					fZoomAt(tmpState.scale + 0.25);
				}
				else if (tmpAction === 'zoom-out')
				{
					fZoomAt(tmpState.scale - 0.25);
				}
				else if (tmpAction === 'zoom-reset')
				{
					fResetTransform();
				}
			});
		});

		// Wheel zoom — for images and mermaid diagrams.
		// For code blocks, let the browser handle native scrolling
		// so the user can scroll through long code.
		tmpStage.addEventListener('wheel', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			pEvent.preventDefault();
			let tmpDelta = -pEvent.deltaY;
			let tmpStep = (tmpDelta > 0 ? 1 : -1) * 0.15;
			fZoomAt(tmpState.scale + tmpStep, pEvent.clientX, pEvent.clientY);
		}, { passive: false });

		// Drag-to-pan when zoomed (not for code blocks — they scroll natively)
		tmpStage.addEventListener('pointerdown', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			if (tmpState.scale <= 1.001)
			{
				return;
			}
			if (pEvent.target.closest('.pict-fullscreen-controls'))
			{
				return;
			}
			tmpState.isPanning = true;
			tmpState.panStartX = pEvent.clientX;
			tmpState.panStartY = pEvent.clientY;
			tmpState.panOrigX = tmpState.translateX;
			tmpState.panOrigY = tmpState.translateY;
			tmpStage.setPointerCapture(pEvent.pointerId);
			tmpStage.classList.add('is-panning');
		});
		tmpStage.addEventListener('pointermove', (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.translateX = tmpState.panOrigX + (pEvent.clientX - tmpState.panStartX);
			tmpState.translateY = tmpState.panOrigY + (pEvent.clientY - tmpState.panStartY);
			fApplyTransform();
		});
		let fEndPan = (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.isPanning = false;
			// Flag that a pan just ended so the subsequent click event
			// (which the browser fires after pointerup) does not close
			// the overlay via the backdrop-close handler.
			tmpState.didPan = true;
			tmpStage.classList.remove('is-panning');
			try { tmpStage.releasePointerCapture(pEvent.pointerId); } catch (e) {}
		};
		tmpStage.addEventListener('pointerup', fEndPan);
		tmpStage.addEventListener('pointercancel', fEndPan);

		// Touch pinch zoom
		let tmpActiveTouches = {};
		tmpStage.addEventListener('touchstart', (pEvent) =>
		{
			for (let i = 0; i < pEvent.touches.length; i++)
			{
				let tmpT = pEvent.touches[i];
				tmpActiveTouches[tmpT.identifier] = { x: tmpT.clientX, y: tmpT.clientY };
			}
			if (pEvent.touches.length === 2)
			{
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				tmpState.pinchInitialDistance = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				tmpState.pinchInitialScale = tmpState.scale;
			}
		}, { passive: true });
		tmpStage.addEventListener('touchmove', (pEvent) =>
		{
			if (pEvent.touches.length === 2 && tmpState.pinchInitialDistance > 0)
			{
				pEvent.preventDefault();
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				let tmpRatio = tmpDist / tmpState.pinchInitialDistance;
				let tmpMidX = (tmpA.clientX + tmpB.clientX) / 2;
				let tmpMidY = (tmpA.clientY + tmpB.clientY) / 2;
				fZoomAt(tmpState.pinchInitialScale * tmpRatio, tmpMidX, tmpMidY);
			}
		}, { passive: false });
		tmpStage.addEventListener('touchend', () =>
		{
			tmpActiveTouches = {};
			tmpState.pinchInitialDistance = 0;
		});

		PictContentView._FullscreenOverlay = {
			element: tmpOverlay,
			content: tmpContent,
			titleEl: tmpTitleEl,
			state: tmpState,
			open: (pSourceEl) =>
			{
				let tmpTitle = pSourceEl.getAttribute('data-fullscreen-title') || '';
				tmpTitleEl.textContent = tmpTitle;
				tmpContent.innerHTML = '';

				let tmpKind = pSourceEl.getAttribute('data-fullscreen-source');
				tmpState.currentKind = tmpKind || '';
				let tmpClone;
				if (tmpKind === 'mermaid')
				{
					let tmpSvg = pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-mermaid-svg');
						// Drop mermaid's inline max-width / width / height style so the
						// fullscreen CSS rule actually controls the size.
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'diagram')
				{
					// Inline SVG diagram (bespoke pict-renderer-graph / excalidraw):
					// clone the <svg> and drop its intrinsic sizing so the fullscreen
					// stage controls the dimensions -- same approach as mermaid, but
					// the source element may BE the svg or a wrapper around it.
					let tmpSvg = (String(pSourceEl.tagName).toLowerCase() === 'svg') ? pSourceEl : pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-diagram-svg');
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'image')
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-img');
				}
				else
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-codewrap');
				}
				tmpContent.appendChild(tmpClone);

				// Hide zoom controls for code blocks (they scroll natively)
				let tmpZoomBtns = tmpOverlay.querySelectorAll('[data-action="zoom-in"], [data-action="zoom-out"], [data-action="zoom-reset"]');
				for (let i = 0; i < tmpZoomBtns.length; i++)
				{
					tmpZoomBtns[i].style.display = (tmpKind === 'code') ? 'none' : '';
				}

				fResetTransform();
				tmpOverlay.removeAttribute('hidden');
				document.documentElement.style.overflow = 'hidden';
				document.addEventListener('keydown', fKeydown);
			},
			close: fClose
		};
		return PictContentView._FullscreenOverlay;
	}

	/**
	 * Open the fullscreen overlay for a tagged source element.
	 */
	_openFullscreen(pSourceEl)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		tmpOverlay.open(pSourceEl);
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"../Pict-Content-CSS.js":485,"pict-provider-theme/source/Theme-Diagram-Adapter.js":477,"pict-view":693}],489:[function(require,module,exports){
// Pict-Section-Content — Demo view
//
// A thin renderable wrapper around the canonical Pict-View-Content view.
// The base view is "lazy" — it shows a Loading placeholder until its host
// application explicitly calls `displayContent(parsedHTML)`.  That works
// fine when an application has its own page logic, but it's awkward for
// the docuserve playground (which doesn't know anything about
// markdown / parseMarkdown).
//
// This demo view bridges that gap:
//   1. Ensures the PictContentProvider is registered with `pict`.
//   2. Reads markdown text from an AppData address (configurable via
//      `MarkdownDataAddress`, e.g. "AppData.ContentDemo.Markdown").
//   3. On every render, parses the markdown via the provider and calls
//      the parent view's `displayContent` to push HTML into the DOM.
//
// Host applications that need anything more elaborate (navigation,
// multiple documents, link resolvers) should keep using the canonical
// Pict-View-Content view directly.  This demo view exists for the
// playground and other "just render this markdown blob" surfaces.

const libPictViewContent = require('./Pict-View-Content.js');
const libPictContentProvider = require('../providers/Pict-Provider-Content.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content-Demo",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	// Where to read the markdown source from. Resolved against the
	// pict instance with simple dot-walking — "AppData.X.Y.Z".
	MarkdownDataAddress: "AppData.ContentDemo.Markdown",

	// AutoRender on, so the playground's wrapper just instantiates the
	// view and the markdown shows up on next tick.
	AutoRender: true,

	// Inherit CSS / Templates / Renderables from the base view so we
	// render into the same #Pict-Content-Container with the same shell.
	CSS: libPictViewContent.default_configuration.CSS,
	Templates: libPictViewContent.default_configuration.Templates,
	Renderables: libPictViewContent.default_configuration.Renderables
};

class PictContentDemoView extends libPictViewContent
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Ensure the content provider is registered. Use a stable hash
		// so repeat instantiation is a no-op.
		let tmpProviderHash = 'Pict-Content';
		if (!this.pict.providers[tmpProviderHash])
		{
			this.pict.addProvider(tmpProviderHash, libPictContentProvider.default_configuration, libPictContentProvider);
		}
	}

	/**
	 * Walk a dotted address ("AppData.X.Y.Z") against the pict instance
	 * and return the value, or null if any segment is missing.
	 */
	_readMarkdownFromAddress()
	{
		let tmpAddress = this.options.MarkdownDataAddress;
		if (!tmpAddress || typeof tmpAddress !== 'string')
		{
			return null;
		}
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.pict;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}
		return (typeof tmpCurrent === 'string') ? tmpCurrent : null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		// Pull markdown from AppData and push parsed HTML through the
		// parent view's pipeline (which also wires Mermaid / KaTeX /
		// fullscreen viewers).
		let tmpMarkdown = this._readMarkdownFromAddress();
		let tmpProvider = this.pict.providers['Pict-Content'];
		if (tmpProvider && typeof tmpMarkdown === 'string')
		{
			let tmpHTML = tmpProvider.parseMarkdown(tmpMarkdown);
			this.displayContent(tmpHTML);
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictContentDemoView;

module.exports.default_configuration = _ViewConfiguration;

},{"../providers/Pict-Provider-Content.js":487,"./Pict-View-Content.js":488}],490:[function(require,module,exports){
/**
 * Default configuration for pict-section-excalidraw.
 *
 * Lives in its own file (mirrors pict-section-code) so the configuration —
 * including the (substantial) CSS — can be reasoned about without scrolling
 * past the view's lifecycle code.
 */

// CSS for the excalidraw wrapper.  All colors flow through pict-section-theme
// CSS custom properties (var(--theme-color-*, fallback)) so the control re-tints
// automatically when the app switches themes.  Layout values are local —
// Excalidraw's own chrome owns its internal sizing.
/* The 320px floor is a var so a host that sizes the control itself (a form field with a resize grip,
   say) can drop below it; without that, the floor silently wins and the control refuses to shrink. */
const _CSS = `.pict-excalidraw-wrap
{
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: var(--pict-excalidraw-min-height, 320px);
	background: var(--theme-color-background-panel, #FFFFFF);
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
	font-family: var(--theme-typography-family-base, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
	color: var(--theme-color-text-primary, #1A1A1A);
}

/* Theme bridge: forward pict tokens into the variables Excalidraw's own
   stylesheet reads.  See vendor/excalidraw/packages/excalidraw/css/ for the
   token names.  We default to the official light palette so Excalidraw renders
   correctly even before a pict theme overrides anything. */
.pict-excalidraw-wrap
{
	--default-bg-color:       var(--theme-color-background-panel,    #FFFFFF);
	--island-bg-color:        var(--theme-color-background-secondary, #FFFFFF);
	--input-bg-color:         var(--theme-color-background-primary,   #FFFFFF);
	--input-border-color:     var(--theme-color-border-default,       #D0D0D0);
	--text-primary-color:     var(--theme-color-text-primary,         #1A1A1A);
	--color-primary:          var(--theme-color-brand-primary,        #6965DB);
	--color-primary-darker:   var(--theme-color-brand-primary-hover,  #5754C4);
	--color-primary-darkest:  var(--theme-color-brand-primary-hover,  #4642B7);
	--color-on-primary-container: var(--theme-color-background-panel, #FFFFFF);
	--button-hover-bg:        var(--theme-color-background-hover,     #F1F0FF);
	--button-active-bg:       var(--theme-color-background-selected,  #E3E2FE);
	--button-active-border:   var(--theme-color-brand-primary,        #6965DB);
	--popup-bg-color:         var(--theme-color-background-panel,     #FFFFFF);
	--popup-border-color:     var(--theme-color-border-default,       #D0D0D0);
	--icon-fill-color:        var(--theme-color-text-primary,         #1A1A1A);
	--shadow-island:          0 0 0 1px var(--theme-color-border-light, rgba(0,0,0,0.06)), 0 2px 6px 0 var(--theme-color-shadow-color, rgba(0,0,0,0.08));
}

/* iframe mode: the iframe element itself owns the entire wrap surface */
.pict-excalidraw-iframe
{
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: var(--pict-excalidraw-min-height, 320px);
	border: 0;
	background: var(--theme-color-background-panel, #FFFFFF);
}

/* react mode: a single inner div that Excalidraw mounts into via createRoot */
.pict-excalidraw-mount
{
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: var(--pict-excalidraw-min-height, 320px);
	position: relative;
}

/* Status / error overlay used by both modes before the third-party lib is
   wired up, or when bundling failed. */
.pict-excalidraw-status
{
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
	background: var(--theme-color-background-panel, #FFFFFF);
	color: var(--theme-color-text-secondary, #4A4A4A);
	text-align: center;
	font-size: 14px;
	line-height: 1.4;
	z-index: 1;
}
.pict-excalidraw-status code
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace);
	font-size: 12px;
	padding: 2px 6px;
	background: var(--theme-color-background-secondary, #F4F4F4);
	border: 1px solid var(--theme-color-border-light, rgba(0,0,0,0.06));
	border-radius: 3px;
}
.pict-excalidraw-status.error
{
	color: var(--theme-color-status-error, #B43B3B);
}
`;

module.exports = ({
	"RenderOnLoad": true,

	"DefaultRenderable": "Excalidraw-Wrap",
	"DefaultDestinationAddress": "#Excalidraw-Container-Div",
	"TargetElementAddress": "#Excalidraw-Container-Div",

	// 'react' or 'iframe'.  React is cleanest for theme conformance; iframe is
	// the right choice if the host app's global CSS is aggressive enough to
	// bleed into Excalidraw and you'd rather pay the postMessage tax than fight
	// it.
	"EmbedMode": "react",

	// Address in AppData (dot-notation) to two-way bind the scene JSON into.
	// Set to false to opt out.
	"DrawingDataAddress": false,

	// 'light' | 'dark' | 'auto'.  'auto' follows the pict-section-theme mode
	// when the provider is present.
	"Theme": "light",

	// How Excalidraw should classify the editor for UI density.  Excalidraw's own answer comes from
	// the CONTAINER's box, which misreads a small embed on a large desktop as a phone and hides the
	// shape properties behind a popover.
	//   'auto'    - Excalidraw decides (its stock behavior)
	//   'pointer' - desktop chrome for a mouse; Excalidraw's own answer on a touch screen
	//   'desktop' | 'tablet' | 'phone' - pin it
	"FormFactor": "auto",

	"ViewModeEnabled": false,
	"ZenModeEnabled":  false,
	"GridModeEnabled": false,
	"LangCode":        "en",

	// Forwarded verbatim to <Excalidraw UIOptions={...}>.  See:
	// https://docs.excalidraw.com/docs/@excalidraw/excalidraw/api/props/ui-options
	"UIOptions": {},

	// Initial scene used when no OnLoad callback / DrawingDataAddress yields
	// anything.
	"InitialData":
	{
		"elements": [],
		"appState": {},
		"files":    {}
	},

	// Base URL the iframe / wrapper looks under for fonts + locales.  Set this
	// to wherever you copied vendor/excalidraw-built/assets/ at deploy time.
	"AssetBaseURL": "./excalidraw-assets/",

	// URL of the iframe host page (iframe mode only).  Defaults to
	// excalidraw-iframe-host.html sitting next to the page that loaded the
	// wrapper bundle.
	"IframeHostURL": "./excalidraw-iframe-host.html",

	// Lazy-loading: if the wrapper bundle isn't already on the page when the
	// view first mounts, fetch it on demand from these URLs.  Saves first-
	// paint cost for pages that don't have a diagram.  Leave null to require
	// the host to load the scripts via <script> tags (default — preserves
	// the existing eager-load behavior).
	//
	//   LazyLoadReactVendorURL: URL to react-vendor.min.js (or any script
	//                            that sets window.React + window.ReactDOM).
	//                            Skip if the host already loads React.
	//   LazyLoadWrapperURL:      URL to excalidraw-wrapper.min.js (or any
	//                            script that sets
	//                            window.PictSectionExcalidrawVendor).
	"LazyLoadReactVendorURL": null,
	"LazyLoadWrapperURL":     null,

	// Callback hooks — see README.  Signatures intentionally use Node-style
	// fCallback(err, value) so they compose with the rest of the Fable/Pict
	// async patterns.
	"OnLoad":   null,
	"OnSave":   null,
	"OnChange": null,

	// Throttle (ms) for the OnChange callback fired during active editing.
	// Excalidraw fires onChange on every pointer move; the wrapper batches.
	"OnChangeThrottleMs": 250,

	"Templates":
	[
		{
			"Hash": "Excalidraw-Container",
			"Template": "<!-- Excalidraw-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "Excalidraw-Wrap",
			"TemplateHash": "Excalidraw-Container",
			"DestinationAddress": "#Excalidraw-Container-Div"
		}
	],

	"CSS": _CSS
});

},{}],491:[function(require,module,exports){
/**
 * pict-section-excalidraw — main entry.
 *
 * Exports a single dispatch view class that picks between the React-mount and
 * iframe implementations at construction time based on the EmbedMode option.
 *
 * Consumers can either:
 *   1. Use the default export and pass EmbedMode in the configuration
 *   2. Pull the explicit implementation classes directly:
 *        const { ReactView, IframeView } = require('pict-section-excalidraw');
 */

const libPictViewClass            = require('pict-view');
const libExcalidrawReactView      = require('./views/PictView-Excalidraw-React.js');
const libExcalidrawIframeView     = require('./views/PictView-Excalidraw-Iframe.js');
const _DefaultConfiguration       = require('./Pict-Section-Excalidraw-DefaultConfiguration.js');

/**
 * Resolve which implementation class the consumer wants based on the merged
 * configuration.  Exposed so the dispatch view and any framework registration
 * helpers can agree on the same selection logic.
 */
function selectImplementation(pOptions)
{
	let tmpMode = ((pOptions && pOptions.EmbedMode) || _DefaultConfiguration.EmbedMode || 'react').toLowerCase();
	if (tmpMode === 'iframe')
	{
		return libExcalidrawIframeView;
	}
	return libExcalidrawReactView;
}

/**
 * PictSectionExcalidraw — thin dispatcher.  Constructs the chosen
 * implementation as a sibling pict-view on the same fable and proxies the
 * public surface onto it.  We don't extend either implementation directly
 * because the embed mode is a runtime decision, not a class-level one.
 */
class PictSectionExcalidraw extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._ImplementationClass = selectImplementation(tmpOptions);

		// Instantiate the actual implementation view as a peer pict-view.  It
		// gets its own ViewIdentifier (suffixed) so AppData/template scopes
		// don't clash with the dispatcher.
		let tmpImplOptions = Object.assign({}, tmpOptions);
		tmpImplOptions.ViewIdentifier = (tmpOptions.ViewIdentifier || 'PictSectionExcalidraw') + '-Impl';

		this._Implementation = new this._ImplementationClass(pFable, tmpImplOptions, pServiceHash);

		// Public-API proxy: forward every method the implementations expose so
		// consumers can hold a reference to the dispatcher and not care which
		// mode is active.
		let tmpForwardedMethods =
		[
			'getScene', 'setScene', 'exportSvg', 'exportBlob', 'serialize',
			'setTheme', 'setReadOnly', 'load', 'save', 'destroy',
			'getApi', 'connectExcalidrawGlobal', 'isDestroyed',
			'convertMermaidToExcalidraw'
		];
		for (let i = 0; i < tmpForwardedMethods.length; i++)
		{
			let tmpName = tmpForwardedMethods[i];
			this[tmpName] = (...pArgs) =>
			{
				if (typeof this._Implementation[tmpName] === 'function')
				{
					return this._Implementation[tmpName].apply(this._Implementation, pArgs);
				}
				return undefined;
			};
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// The implementation is what actually owns the destination div.  We
		// render it once the dispatcher's own render cycle has fired so the
		// outer container exists.
		if (this._Implementation && typeof this._Implementation.render === 'function')
		{
			if (!this._dispatchedRender)
			{
				this._dispatchedRender = true;
				this._Implementation.render();
			}
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictSectionExcalidraw;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.ReactView             = libExcalidrawReactView;
module.exports.IframeView            = libExcalidrawIframeView;
module.exports.selectImplementation  = selectImplementation;

// Form-side integration: the `Diagram` InputType (and its provider class) lives
// in pict-section-form under `providers/inputs/Pict-Provider-Input-Diagram.js`,
// not here. The provider lazy-requires this module on the first setMode('edit')
// so consumers that never edit don't pull the Excalidraw vendor bundle.
//
//   const libDiagramInput = require('pict-section-form').DiagramInput;
//   pict.addProvider('Pict-Input-Diagram',
//       libDiagramInput.default_configuration, libDiagramInput);
//
// The Themeify-SVG utility (used to rewrite Excalidraw hex colors to CSS
// variables on save) is now exposed as `require('pict-section-form').themeifySVG`.

},{"./Pict-Section-Excalidraw-DefaultConfiguration.js":490,"./views/PictView-Excalidraw-Iframe.js":493,"./views/PictView-Excalidraw-React.js":494,"pict-view":693}],492:[function(require,module,exports){
/**
 * Excalidraw-Form-Factor.js
 *
 * Excalidraw decides how dense its UI should be from the size of the CONTAINER it is mounted in:
 * roughly `width <= 599 || (height < 500 && width < 1000)` reads as a phone, and a phone gets the
 * mobile styles panel — shape properties collapse behind a dismissable popover instead of the
 * left-hand island.
 *
 * That heuristic is right for excalidraw.com, where the container IS the viewport, and wrong for an
 * embed, where the container is a box on a page that may be a few hundred pixels tall on a 27"
 * monitor with a mouse. Excalidraw exposes `UIOptions.getFormFactor(width, height)` for exactly this
 * case; returning `undefined` from it falls back to Excalidraw's own detection.
 *
 * NOTE: the iframe host (source/iframe-host/excalidraw-iframe-host.js) carries its own copy of this
 * logic — a function cannot cross postMessage, so the parent sends the MODE STRING and the host
 * rebuilds the resolver inside the frame. Keep the two in step.
 */

const FORM_FACTORS = ['desktop', 'tablet', 'phone'];

/**
 * Does this device drive the pointer with a finger rather than a mouse?
 *
 * @return {boolean} True when the primary pointer is coarse (touch).
 */
function isCoarsePointer()
{
	if ((typeof window === 'undefined') || (typeof window.matchMedia !== 'function')) return false;
	try { return window.matchMedia('(pointer: coarse)').matches; }
	catch (pErr) { return false; }
}

/**
 * Build the `UIOptions.getFormFactor` hook for a configured FormFactor mode.
 *
 * @param {string} pMode - 'auto' | 'pointer' | 'desktop' | 'tablet' | 'phone'.
 * @return {Function} The hook, or null when Excalidraw should decide for itself.
 */
function buildFormFactorResolver(pMode)
{
	let tmpMode = (typeof pMode === 'string') ? pMode.toLowerCase() : 'auto';

	if (tmpMode === 'pointer')
	{
		// Classify by input device, not by the size of the box we happen to be embedded in. A touch
		// screen still gets Excalidraw's own answer — the mobile UI is genuinely better with a finger.
		return function () { return isCoarsePointer() ? undefined : 'desktop'; };
	}

	if (FORM_FACTORS.indexOf(tmpMode) > -1)
	{
		return function () { return tmpMode; };
	}

	// 'auto' and anything unrecognized: don't install the hook at all.
	return null;
}

module.exports = { buildFormFactorResolver, isCoarsePointer, FORM_FACTORS };

},{}],493:[function(require,module,exports){
/**
 * PictView-Excalidraw-Iframe — iframe embedding of Excalidraw.
 *
 * The destination div hosts an <iframe> pointing at our vendored
 * excalidraw-iframe-host.html.  Communication happens through window.postMessage
 * with a small protocol:
 *
 *   parent -> iframe :  { type: 'pict-excalidraw:init',  payload: { initialData, theme, langCode, viewModeEnabled, ... } }
 *   parent -> iframe :  { type: 'pict-excalidraw:setScene',  payload: { elements, appState, files } }
 *   parent -> iframe :  { type: 'pict-excalidraw:setTheme',  payload: 'light' | 'dark' }
 *   parent -> iframe :  { type: 'pict-excalidraw:setReadOnly', payload: bool }
 *   parent -> iframe :  { type: 'pict-excalidraw:setThemeTokens', payload: { '--theme-color-...': '#xxx', ... } }
 *   parent -> iframe :  { type: 'pict-excalidraw:requestScene', requestId }
 *   parent -> iframe :  { type: 'pict-excalidraw:requestSvg',   requestId, exportOptions }
 *
 *   iframe -> parent :  { type: 'pict-excalidraw:ready' }
 *   iframe -> parent :  { type: 'pict-excalidraw:change',     payload: { elements, appState, files } }
 *   iframe -> parent :  { type: 'pict-excalidraw:sceneReply', requestId, payload }
 *   iframe -> parent :  { type: 'pict-excalidraw:svgReply',   requestId, payload }
 *
 * The iframe runs the same wrapper bundle as the React-mount mode — see
 * excalidraw-iframe-host.html.
 */

const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('../Pict-Section-Excalidraw-DefaultConfiguration.js');

class PictViewExcalidrawIframe extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;
		this.targetElement = false;
		this._iframeElement = null;
		this._wrapElement   = null;
		this._statusElement = null;
		this._iframeReady   = false;

		this._pendingRequests   = Object.create(null);
		this._nextRequestId     = 1;
		this._lastSceneSnapshot = null;
		this._messageListener   = null;

		this._onChangeThrottleHandle = null;
		this._lastSeenChangeSnapshot = null;
		this._currentTheme = this.options.Theme || 'light';

		// Set true by destroy(); gates public API methods + the throttle
		// callback against post-teardown state mutations.
		this._destroyed = false;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpTargetSet = this.pict.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetSet || tmpTargetSet.length < 1)
		{
			this.log.error(`PICT-Excalidraw (iframe) could not find target [${this.options.TargetElementAddress}].`);
			return false;
		}
		this.targetElement = tmpTargetSet[0];

		this._buildContainerDOM();
		this._wireMessageListener();
		this._mountIframe();
	}

	_buildContainerDOM()
	{
		this.targetElement.innerHTML = '';

		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-excalidraw-wrap pict-excalidraw-wrap-iframe';

		let tmpStatus = document.createElement('div');
		tmpStatus.className = 'pict-excalidraw-status';
		tmpStatus.innerHTML = 'Loading Excalidraw…';
		tmpWrap.appendChild(tmpStatus);

		let tmpIframe = document.createElement('iframe');
		tmpIframe.className = 'pict-excalidraw-iframe';
		tmpIframe.setAttribute('title', 'Excalidraw drawing');
		tmpIframe.setAttribute('allow', 'clipboard-read; clipboard-write');
		tmpWrap.appendChild(tmpIframe);

		this.targetElement.appendChild(tmpWrap);

		this._wrapElement   = tmpWrap;
		this._iframeElement = tmpIframe;
		this._statusElement = tmpStatus;
	}

	_wireMessageListener()
	{
		// MessageEvent is one of the few cases where addEventListener is
		// legitimate — window-level events don't have an inline-handler
		// equivalent.  See pict CLAUDE.md "legitimate exceptions".
		this._messageListener = (pEvent) =>
		{
			if (!pEvent || !pEvent.data || typeof pEvent.data !== 'object') return;
			if (pEvent.source !== (this._iframeElement && this._iframeElement.contentWindow)) return;
			this._handleIframeMessage(pEvent.data);
		};
		window.addEventListener('message', this._messageListener);
	}

	_mountIframe()
	{
		let tmpUrl = this.options.IframeHostURL || './excalidraw-iframe-host.html';
		this._iframeElement.src = tmpUrl;
	}

	_postToIframe(pMessage)
	{
		if (!this._iframeElement || !this._iframeElement.contentWindow) return false;
		this._iframeElement.contentWindow.postMessage(pMessage, '*');
		return true;
	}

	_handleIframeMessage(pData)
	{
		switch (pData.type)
		{
			case 'pict-excalidraw:ready':
				this._iframeReady = true;
				if (this._statusElement) this._statusElement.style.display = 'none';
				this._sendInitMessage();
				return;

			case 'pict-excalidraw:change':
				this._handleChange(pData.payload);
				return;

			case 'pict-excalidraw:sceneReply':
			case 'pict-excalidraw:svgReply':
			case 'pict-excalidraw:blobReply':
			{
				let tmpReq = this._pendingRequests[pData.requestId];
				if (tmpReq)
				{
					clearTimeout(tmpReq.timeout);
					delete this._pendingRequests[pData.requestId];
					tmpReq.resolve(pData.payload);
				}
				return;
			}

			case 'pict-excalidraw:error':
			{
				let tmpReq = pData.requestId && this._pendingRequests[pData.requestId];
				if (tmpReq)
				{
					clearTimeout(tmpReq.timeout);
					delete this._pendingRequests[pData.requestId];
					tmpReq.reject(new Error(pData.message || 'iframe error'));
				}
				else
				{
					this.log.error(`PICT-Excalidraw (iframe) error: ${pData.message}`);
				}
				return;
			}

			default:
				// Unknown message — ignored
				return;
		}
	}

	_sendInitMessage()
	{
		let tmpInitial = this._resolveInitialData();
		this._postToIframe({
			type: 'pict-excalidraw:init',
			payload:
			{
				initialData:     tmpInitial,
				theme:           this._resolveTheme(this._currentTheme),
				langCode:        this.options.LangCode || 'en',
				viewModeEnabled: !!this.options.ViewModeEnabled,
				zenModeEnabled:  !!this.options.ZenModeEnabled,
				gridModeEnabled: !!this.options.GridModeEnabled,
				UIOptions:       this.options.UIOptions || {},
				// The MODE STRING, not a resolver: postMessage structured-clones its payload and a
				// function would throw a DataCloneError.  The host rebuilds the hook inside the frame.
				formFactor:      this.options.FormFactor || 'auto',
				assetBaseURL:    this.options.AssetBaseURL
			}
		});

		// Push theme tokens into the iframe so its CSS variables resolve.
		this._pushThemeTokens();

		// Deferred OnLoad fires now that the iframe is ready.
		if (typeof this.options.OnLoad === 'function')
		{
			this.load();
		}
	}

	_pushThemeTokens()
	{
		if (typeof document === 'undefined' || !document.documentElement) return;
		// Snapshot the theme variables off documentElement's computed style.
		// We only forward variables we know Excalidraw consumes (the bridge
		// vars baked into the wrap CSS), not the entire theme catalog.
		let tmpVars = [
			'--theme-color-background-panel',
			'--theme-color-background-primary',
			'--theme-color-background-secondary',
			'--theme-color-background-hover',
			'--theme-color-background-selected',
			'--theme-color-border-default',
			'--theme-color-border-light',
			'--theme-color-text-primary',
			'--theme-color-text-secondary',
			'--theme-color-brand-primary',
			'--theme-color-brand-primary-hover',
			'--theme-color-status-error',
			'--theme-color-shadow-color'
		];
		let tmpStyle = window.getComputedStyle(document.documentElement);
		let tmpPayload = {};
		for (let i = 0; i < tmpVars.length; i++)
		{
			let tmpVal = tmpStyle.getPropertyValue(tmpVars[i]).trim();
			if (tmpVal) tmpPayload[tmpVars[i]] = tmpVal;
		}
		this._postToIframe({ type: 'pict-excalidraw:setThemeTokens', payload: tmpPayload });
	}

	_resolveInitialData()
	{
		if (this.options.DrawingDataAddress)
		{
			let tmpFromAppData = this._readAppData(this.options.DrawingDataAddress);
			if (tmpFromAppData && tmpFromAppData.elements) return tmpFromAppData;
		}
		return this.options.InitialData || { elements: [], appState: {}, files: {} };
	}

	_resolveTheme(pTheme)
	{
		if (pTheme === 'auto')
		{
			if (typeof document !== 'undefined' && document.documentElement)
			{
				if (document.documentElement.classList && document.documentElement.classList.contains('theme-mode-dark'))
				{
					return 'dark';
				}
			}
			let tmpThemeProvider = this.pict && this.pict.providers && this.pict.providers.ThemeSection;
			if (tmpThemeProvider && tmpThemeProvider.getCurrentMode)
			{
				let tmpMode = tmpThemeProvider.getCurrentMode();
				if (tmpMode === 'dark') return 'dark';
				if (tmpMode === 'light') return 'light';
			}
			return 'light';
		}
		return (pTheme === 'dark') ? 'dark' : 'light';
	}

	_handleChange(pSnap)
	{
		if (this._destroyed) return;
		this._lastSceneSnapshot = pSnap;
		this._lastSeenChangeSnapshot = pSnap;
		if (this._onChangeThrottleHandle) return;

		let tmpDelay = this.options.OnChangeThrottleMs || 250;
		this._onChangeThrottleHandle = setTimeout(() =>
		{
			this._onChangeThrottleHandle = null;
			if (this._destroyed) return;
			let tmpFinal = this._lastSeenChangeSnapshot;
			if (!tmpFinal) return;

			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, tmpFinal);
			}
			if (typeof this.options.OnChange === 'function')
			{
				try { this.options.OnChange(this, tmpFinal); }
				catch (pErr) { this.log.error(`PICT-Excalidraw OnChange threw: ${pErr && pErr.message}`); }
			}
		}, tmpDelay);
	}

	_readAppData(pAddress)
	{
		if (!pAddress) return null;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.getValueByHash)
			{
				return this.fable.manifest.getValueByHash(this.pict.AppData, tmpRelative);
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length; i++)
			{
				if (tmpCursor == null) return null;
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			return tmpCursor;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw read AppData failed: ${pErr && pErr.message}`);
			return null;
		}
	}

	_writeAppData(pAddress, pValue)
	{
		if (!pAddress) return false;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.setValueByHash)
			{
				this.fable.manifest.setValueByHash(this.pict.AppData, tmpRelative, pValue);
				return true;
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if (tmpCursor[tmpParts[i]] == null) tmpCursor[tmpParts[i]] = {};
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
			return true;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw write AppData failed: ${pErr && pErr.message}`);
			return false;
		}
	}

	_request(pType, pExtra)
	{
		let tmpId = (this._nextRequestId++);
		return new Promise((fResolve, fReject) =>
		{
			this._pendingRequests[tmpId] = { resolve: fResolve, reject: fReject };
			this._postToIframe(Object.assign({ type: pType, requestId: tmpId }, pExtra || {}));
			// Safety timeout — 30s (cleared on reply / destroy)
			this._pendingRequests[tmpId].timeout = setTimeout(() =>
			{
				if (this._pendingRequests[tmpId])
				{
					delete this._pendingRequests[tmpId];
					fReject(new Error('iframe request timed out'));
				}
			}, 30000);
		});
	}

	// ---- Public API ---------------------------------------------------------

	getApi() { return null; /* iframe mode hides the live API behind postMessage */ }

	/**
	 * Iframe mode returns the most recent change snapshot synchronously, and
	 * the live scene asynchronously via requestScene().  Most callers want the
	 * sync snapshot — for the freshest one, await requestScene().
	 */
	getScene() { return this._lastSceneSnapshot; }

	requestScene() { return this._request('pict-excalidraw:requestScene'); }

	setScene(pSceneData)
	{
		if (!pSceneData) return false;
		this._postToIframe({ type: 'pict-excalidraw:setScene', payload: pSceneData });
		return true;
	}

	exportSvg(pOpts)
	{
		return this._request('pict-excalidraw:requestSvg', { exportOptions: pOpts || {} });
	}

	exportBlob(pOpts)
	{
		return this._request('pict-excalidraw:requestBlob', { exportOptions: pOpts || {} });
	}

	serialize()
	{
		let tmpScene = this._lastSceneSnapshot;
		if (!tmpScene) return null;
		return JSON.stringify({
			type: 'excalidraw',
			version: 2,
			source: 'pict-section-excalidraw',
			elements: tmpScene.elements || [],
			appState: tmpScene.appState || {},
			files:    tmpScene.files    || {}
		});
	}

	setTheme(pTheme)
	{
		this._currentTheme = pTheme || 'light';
		let tmpResolved = this._resolveTheme(this._currentTheme);
		this._postToIframe({ type: 'pict-excalidraw:setTheme', payload: tmpResolved });
		this._pushThemeTokens();
	}

	setReadOnly(pReadOnly)
	{
		this.options.ViewModeEnabled = !!pReadOnly;
		this._postToIframe({ type: 'pict-excalidraw:setReadOnly', payload: !!pReadOnly });
	}

	load()
	{
		if (typeof this.options.OnLoad === 'function')
		{
			this.options.OnLoad(this, (pErr, pSceneData) =>
			{
				if (pErr) { this.log.error(`PICT-Excalidraw OnLoad error: ${pErr.message || pErr}`); return; }
				if (pSceneData) this.setScene(pSceneData);
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			let tmpScene = this._readAppData(this.options.DrawingDataAddress);
			if (tmpScene) this.setScene(tmpScene);
		}
	}

	save()
	{
		// Iframe mode: prefer the snapshot, but freshen via requestScene if we
		// don't have one yet.
		let tmpResolveAndSave = (pScene) =>
		{
			if (!pScene) return;
			if (typeof this.options.OnSave === 'function')
			{
				this.options.OnSave(this, pScene, (pErr) =>
				{
					if (pErr) this.log.error(`PICT-Excalidraw OnSave error: ${pErr.message || pErr}`);
				});
				return;
			}
			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, pScene);
			}
		};
		if (this._lastSceneSnapshot)
		{
			tmpResolveAndSave(this._lastSceneSnapshot);
			return;
		}
		this.requestScene().then(tmpResolveAndSave).catch((pErr) =>
		{
			this.log.error(`PICT-Excalidraw save scene fetch failed: ${pErr.message || pErr}`);
		});
	}

	/**
	 * Tear down the iframe + message listener + pending request promises.
	 * Idempotent.  After destroy(), public API methods short-circuit so
	 * post-teardown calls don't crash.
	 */
	destroy()
	{
		if (this._destroyed) return;
		this._destroyed = true;

		if (this._onChangeThrottleHandle)
		{
			clearTimeout(this._onChangeThrottleHandle);
			this._onChangeThrottleHandle = null;
		}
		this._lastSeenChangeSnapshot = null;

		if (this._messageListener)
		{
			try { window.removeEventListener('message', this._messageListener); }
			catch (pErr) { /* ignore */ }
			this._messageListener = null;
		}

		// Reject any in-flight request promises so awaiters get a real
		// error instead of waiting 30s for the safety timeout.
		let tmpReqKeys = Object.keys(this._pendingRequests);
		for (let i = 0; i < tmpReqKeys.length; i++)
		{
			let tmpReq = this._pendingRequests[tmpReqKeys[i]];
			if (tmpReq && typeof tmpReq.reject === 'function')
			{
				clearTimeout(tmpReq.timeout);
					try { tmpReq.reject(new Error('view destroyed')); }
				catch (pErr) { /* ignore */ }
			}
		}
		this._pendingRequests = Object.create(null);

		// Force-stop the iframe.  Navigating to about:blank unmounts the
		// React tree inside it cleanly; just nulling our reference would
		// leave the page running until GC.
		if (this._iframeElement)
		{
			try { this._iframeElement.src = 'about:blank'; }
			catch (pErr) { /* ignore */ }
		}

		// Clear the destination DOM so a subsequent re-render starts clean.
		if (this.targetElement && this.targetElement.innerHTML !== undefined)
		{
			try { this.targetElement.innerHTML = ''; }
			catch (pErr) { /* ignore */ }
		}

		this._iframeReady = false;
		this._lastSceneSnapshot = null;
		this._iframeElement = null;
		this._statusElement = null;
		this._wrapElement = null;
		this.targetElement = false;
		this.initialRenderComplete = false;
	}

	/** Whether destroy() has been called. */
	isDestroyed()
	{
		return !!this._destroyed;
	}
}

module.exports = PictViewExcalidrawIframe;
module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":490,"pict-view":693}],494:[function(require,module,exports){
/**
 * PictView-Excalidraw-React — React-mount embedding of Excalidraw.
 *
 * Mirrors the pict-section-code <-> CodeJar pattern: a wrapper script is loaded
 * via <script> tag in the HTML shell that puts React, ReactDOM, and Excalidraw
 * on the window as PictSectionExcalidrawVendor.  This view picks those up at
 * onAfterInitialRender, calls ReactDOM.createRoot on the destination div, and
 * mounts <Excalidraw> with our merged props.
 *
 * Lifecycle:
 *   onBeforeInitialize  -> seed instance fields
 *   onAfterRender       -> inject CSS, run initial-render hook once
 *   onAfterInitialRender-> resolve vendor globals, mount root, fire OnLoad
 *   destroy             -> unmount root, drop references
 *
 * AppData binding mirrors pict-section-code: if DrawingDataAddress is set we
 * read it on load and write it on change (via the OnChange throttle).
 */

const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('../Pict-Section-Excalidraw-DefaultConfiguration.js');
const { buildFormFactorResolver } = require('../utils/Excalidraw-Form-Factor.js');

class PictViewExcalidrawReact extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// Vendor globals are resolved lazily on first render so the consumer
		// can either load them via a <script> tag (preferred) or hand them in
		// explicitly via connectExcalidrawGlobal().
		this._vendor = null;

		// React root + the live Excalidraw API handle, both populated on mount.
		this._reactRoot       = null;
		this._excalidrawAPI   = null;
		this.targetElement    = false;
		this._wrapElement     = null;
		this._mountElement    = null;
		this._statusElement   = null;

		// Throttle bookkeeping for the OnChange callback.
		this._onChangeThrottleHandle = null;
		this._lastSeenChangeSnapshot = null;

		// Set when InitialData isn't directly available and we want OnLoad
		// to fire once the excalidrawAPI callback runs.
		this._pendingDeferredLoad = false;

		// Set true by destroy(); gates public methods that touch DOM/React.
		this._destroyed = false;

		// Current theme mirror.  Updated by setTheme() so re-mounts on resize
		// pick the most recent value rather than the original option.
		this._currentTheme = this.options.Theme || 'light';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();
		return super.onBeforeInitialize();
	}

	/**
	 * Connect the vendor globals explicitly.  If not called, the view will
	 * look for window.PictSectionExcalidrawVendor at first render.
	 *
	 * @param {{ React: any, ReactDOM: any, Excalidraw: any,
	 *           exportToSvg?: Function, exportToBlob?: Function,
	 *           serializeAsJSON?: Function }} pVendor
	 */
	connectExcalidrawGlobal(pVendor)
	{
		if (pVendor && pVendor.Excalidraw && pVendor.React && pVendor.ReactDOM)
		{
			this._vendor = pVendor;
			return true;
		}
		return false;
	}

	_resolveVendor()
	{
		if (this._vendor) return this._vendor;
		if (typeof window !== 'undefined' && window.PictSectionExcalidrawVendor)
		{
			let tmpV = window.PictSectionExcalidrawVendor;
			if (tmpV.Excalidraw && tmpV.React && tmpV.ReactDOM)
			{
				this._vendor = tmpV;
				return tmpV;
			}
		}
		return null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		// Locate the container.  We expect the consumer to have placed a div
		// at TargetElementAddress that we own from here on.
		let tmpTargetSet = this.pict.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetSet || tmpTargetSet.length < 1)
		{
			this.log.error(`PICT-Excalidraw could not find target element [${this.options.TargetElementAddress}].`);
			return false;
		}
		this.targetElement = tmpTargetSet[0];

		this._buildContainerDOM();

		let tmpVendor = this._resolveVendor();
		if (tmpVendor)
		{
			this._mountReact(tmpVendor);
			return;
		}

		// No vendor globals on the page yet.  If lazy-load URLs are configured,
		// inject the scripts on demand; otherwise fail loudly with a status
		// message and a console error so the developer knows what's missing.
		if (this.options.LazyLoadWrapperURL)
		{
			this._renderStatus('Loading Excalidraw…', /* isError */ false);
			this._lazyLoadVendor().then(() =>
			{
				if (this._destroyed) return;
				let tmpReVendor = this._resolveVendor();
				if (tmpReVendor)
				{
					this._mountReact(tmpReVendor);
				}
				else
				{
					this._renderStatus(
						'Excalidraw failed to lazy-load.  Check the network tab for ' +
						'<code>excalidraw-wrapper.min.js</code>.',
						/* isError */ true
					);
				}
			}).catch((pErr) =>
			{
				this.log.error(`PICT-Excalidraw lazy-load failed: ${pErr && pErr.message}`);
				this._renderStatus('Excalidraw lazy-load failed: <code>' +
					((pErr && pErr.message) || 'unknown error') + '</code>',
					/* isError */ true);
			});
			return;
		}

		this._renderStatus(
			'Excalidraw wrapper bundle not loaded.  Include ' +
			'<code>excalidraw-wrapper.min.js</code> via a script tag, set ' +
			'<code>LazyLoadWrapperURL</code> in the view options, or call ' +
			'<code>connectExcalidrawGlobal({React, ReactDOM, Excalidraw})</code>.',
			/* isError */ true
		);
		this.log.error('PICT-Excalidraw vendor bundle not found; cannot mount.');
		return false;
	}

	/**
	 * Inject the configured react-vendor + wrapper scripts and resolve once
	 * window.PictSectionExcalidrawVendor exists.  Idempotent — multiple
	 * views mounting at the same time share a single in-flight load.
	 */
	_lazyLoadVendor()
	{
		if (typeof window === 'undefined') return Promise.reject(new Error('no window'));

		// Already loaded (a previous view kicked it off and it finished).
		if (window.PictSectionExcalidrawVendor) return Promise.resolve();

		// Shared in-flight load.  Stash the promise on window so concurrent
		// view mounts reuse it instead of injecting duplicate <script> tags.
		if (window.__pictExcalidrawLazyLoadPromise)
		{
			return window.__pictExcalidrawLazyLoadPromise;
		}

		let tmpReactURL   = this.options.LazyLoadReactVendorURL;
		let tmpWrapperURL = this.options.LazyLoadWrapperURL;

		let tmpInjectScript = (pUrl) => new Promise((fResolve, fReject) =>
		{
			let tmpScript = document.createElement('script');
			tmpScript.src   = pUrl;
			tmpScript.async = false;
			tmpScript.onload  = () => fResolve();
			tmpScript.onerror = () => fReject(new Error('failed to load ' + pUrl));
			document.head.appendChild(tmpScript);
		});

		let tmpChain = Promise.resolve();
		if (tmpReactURL && !window.React)
		{
			tmpChain = tmpChain.then(() => tmpInjectScript(tmpReactURL));
		}
		tmpChain = tmpChain.then(() => tmpInjectScript(tmpWrapperURL));
		tmpChain = tmpChain.then(() =>
		{
			if (!window.PictSectionExcalidrawVendor)
			{
				throw new Error('wrapper loaded but window.PictSectionExcalidrawVendor was not set');
			}
		}).finally(() =>
		{
			// Clear the in-flight handle whether we succeeded or failed —
			// subsequent retries get a fresh attempt instead of latching on
			// to a rejected promise.
			window.__pictExcalidrawLazyLoadPromise = null;
		});

		window.__pictExcalidrawLazyLoadPromise = tmpChain;
		return tmpChain;
	}

	_buildContainerDOM()
	{
		this.targetElement.innerHTML = '';

		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-excalidraw-wrap pict-excalidraw-wrap-react';

		let tmpMount = document.createElement('div');
		tmpMount.className = 'pict-excalidraw-mount';
		tmpWrap.appendChild(tmpMount);

		let tmpStatus = document.createElement('div');
		tmpStatus.className = 'pict-excalidraw-status';
		tmpStatus.style.display = 'none';
		tmpWrap.appendChild(tmpStatus);

		this.targetElement.appendChild(tmpWrap);

		this._wrapElement   = tmpWrap;
		this._mountElement  = tmpMount;
		this._statusElement = tmpStatus;
	}

	_renderStatus(pMessageHTML, pIsError)
	{
		if (!this._statusElement) return;
		this._statusElement.style.display = 'flex';
		this._statusElement.classList.toggle('error', !!pIsError);
		this._statusElement.innerHTML = pMessageHTML;
	}

	_hideStatus()
	{
		if (!this._statusElement) return;
		this._statusElement.style.display = 'none';
	}

	/**
	 * UIOptions as handed to <Excalidraw>, with our FormFactor override folded in when one is
	 * configured.  Excalidraw deliberately excludes getFormFactor from its props memo, so passing a
	 * fresh function per render is safe.
	 *
	 * @return {Object} The UIOptions object.
	 */
	_buildUIOptions()
	{
		let tmpUIOptions = Object.assign({}, this.options.UIOptions || {});
		if (!tmpUIOptions.getFormFactor)
		{
			let tmpResolver = buildFormFactorResolver(this.options.FormFactor);
			if (tmpResolver) tmpUIOptions.getFormFactor = tmpResolver;
		}
		return tmpUIOptions;
	}

	_mountReact(pVendor)
	{
		let tmpReact     = pVendor.React;
		let tmpReactDOM  = pVendor.ReactDOM;
		let tmpExcalidraw = pVendor.Excalidraw;

		let tmpInitialData = this._resolveInitialData();

		// Resolve theme — 'auto' follows the pict theme provider if present.
		let tmpResolvedTheme = this._resolveTheme(this._currentTheme);

		let tmpProps =
		{
			initialData:     tmpInitialData,
			theme:           tmpResolvedTheme,
			langCode:        this.options.LangCode || 'en',
			viewModeEnabled: !!this.options.ViewModeEnabled,
			zenModeEnabled:  !!this.options.ZenModeEnabled,
			gridModeEnabled: !!this.options.GridModeEnabled,
			UIOptions:       this._buildUIOptions(),
			// NOTE: the public prop in @excalidraw/excalidraw is
			// `onExcalidrawAPI` (despite some older docs / community
			// wrappers referring to `excalidrawAPI`).  See
			// packages/excalidraw/index.tsx — `excalidrawAPI` is just the
			// shape of the mountPayload object passed through the context.
			onExcalidrawAPI: (pApi) =>
			{
				this._excalidrawAPI = pApi;
				// Now that the API exists, we can satisfy any deferred load.
				if (this._pendingDeferredLoad)
				{
					this._pendingDeferredLoad = false;
					this.load();
				}
			},
			onChange: (pElements, pAppState, pFiles) =>
			{
				this._handleChange(pElements, pAppState, pFiles);
			}
		};

		// Set the EXCALIDRAW_ASSET_PATH global if the bundle hasn't already.
		// Excalidraw uses this to locate fonts + locale chunks.
		if (typeof window !== 'undefined' && this.options.AssetBaseURL && !window.EXCALIDRAW_ASSET_PATH)
		{
			window.EXCALIDRAW_ASSET_PATH = this.options.AssetBaseURL;
		}

		try
		{
			this._reactRoot = tmpReactDOM.createRoot(this._mountElement);
			this._reactRoot.render(
				tmpReact.createElement(tmpExcalidraw, tmpProps)
			);
			this._hideStatus();
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw mount failed: ${pErr && pErr.message}`);
			this._renderStatus('Excalidraw failed to mount: <code>' +
				(pErr && pErr.message ? pErr.message : 'unknown error') +
				'</code>', /* isError */ true);
		}
	}

	_resolveInitialData()
	{
		// 1. Explicit InitialData in options wins for the synchronous mount.
		//    OnLoad fires asynchronously and replaces the scene via setScene
		//    once it resolves.
		// 2. DrawingDataAddress in AppData is read synchronously.
		// 3. The default empty scene falls through otherwise.
		if (this.options.DrawingDataAddress)
		{
			let tmpFromAppData = this._readAppData(this.options.DrawingDataAddress);
			if (tmpFromAppData && tmpFromAppData.elements)
			{
				return tmpFromAppData;
			}
		}

		// Defer OnLoad call until after the API resolves.  We don't have a
		// scene to push synchronously here, so use the InitialData fallback.
		if (typeof this.options.OnLoad === 'function')
		{
			this._pendingDeferredLoad = true;
		}

		return this.options.InitialData ||
			{ elements: [], appState: {}, files: {} };
	}

	_resolveTheme(pTheme)
	{
		if (pTheme === 'auto')
		{
			// Try pict-section-theme's mode (if installed).  The theme
			// provider exposes a current mode via either a provider service
			// or as a CSS class on documentElement — both are tolerated.
			if (typeof document !== 'undefined' && document.documentElement)
			{
				let tmpRoot = document.documentElement;
				if (tmpRoot.classList && tmpRoot.classList.contains('theme-mode-dark'))
				{
					return 'dark';
				}
			}
			let tmpThemeProvider = this.pict && this.pict.providers && this.pict.providers.ThemeSection;
			if (tmpThemeProvider && tmpThemeProvider.getCurrentMode)
			{
				let tmpMode = tmpThemeProvider.getCurrentMode();
				if (tmpMode === 'dark') return 'dark';
				if (tmpMode === 'light') return 'light';
			}
			return 'light';
		}
		return (pTheme === 'dark') ? 'dark' : 'light';
	}

	_handleChange(pElements, pAppState, pFiles)
	{
		// Guard: if we've been torn down, drop the change on the floor.
		// React can fire onChange briefly after unmount in dev mode + once
		// or twice in production during the final flush.
		if (this._destroyed) return;

		// Excalidraw fires onChange on every pointer move.  We throttle the
		// downstream callback + AppData write so consumers see a steady,
		// reasonable rate.
		this._lastSeenChangeSnapshot = { elements: pElements, appState: pAppState, files: pFiles };

		if (this._onChangeThrottleHandle) return;

		let tmpDelay = this.options.OnChangeThrottleMs || 250;
		this._onChangeThrottleHandle = setTimeout(() =>
		{
			this._onChangeThrottleHandle = null;
			if (this._destroyed) return;
			let tmpSnap = this._lastSeenChangeSnapshot;
			if (!tmpSnap) return;

			// Write to AppData if bound
			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, this._cloneScene(tmpSnap));
			}

			// Notify consumer
			if (typeof this.options.OnChange === 'function')
			{
				try { this.options.OnChange(this, this._cloneScene(tmpSnap)); }
				catch (pErr) { this.log.error(`PICT-Excalidraw OnChange threw: ${pErr && pErr.message}`); }
			}
		}, tmpDelay);
	}

	_cloneScene(pSnap)
	{
		// Excalidraw exposes the live arrays — we shallow-clone the shape so
		// consumers can stash a snapshot without seeing it mutate.
		return {
			elements: pSnap.elements ? pSnap.elements.slice() : [],
			appState: pSnap.appState ? Object.assign({}, pSnap.appState) : {},
			files:    pSnap.files    ? Object.assign({}, pSnap.files)    : {}
		};
	}

	_readAppData(pAddress)
	{
		if (!pAddress) return null;
		try
		{
			// Strip the AppData. prefix so the address is relative to the
			// AppData object that we (or fable.manifest) walk into.  Passing
			// "AppData.Drawing" directly with pict.AppData as base would
			// resolve to pict.AppData.AppData.Drawing, which is wrong.
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.getValueByHash)
			{
				return this.fable.manifest.getValueByHash(this.pict.AppData, tmpRelative);
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length; i++)
			{
				if (tmpCursor == null) return null;
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			return tmpCursor;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw read AppData failed: ${pErr && pErr.message}`);
			return null;
		}
	}

	_writeAppData(pAddress, pValue)
	{
		if (!pAddress) return false;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.setValueByHash)
			{
				this.fable.manifest.setValueByHash(this.pict.AppData, tmpRelative, pValue);
				return true;
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if (tmpCursor[tmpParts[i]] == null) tmpCursor[tmpParts[i]] = {};
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
			return true;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw write AppData failed: ${pErr && pErr.message}`);
			return false;
		}
	}

	// ---- Public API ---------------------------------------------------------

	/** Return the live Excalidraw imperative API (or null if not yet mounted). */
	getApi()
	{
		return this._excalidrawAPI;
	}

	/** Return the current scene as a plain { elements, appState, files } object. */
	getScene()
	{
		if (!this._excalidrawAPI) return null;
		return {
			elements: this._excalidrawAPI.getSceneElements(),
			appState: this._excalidrawAPI.getAppState(),
			files:    this._excalidrawAPI.getFiles ? this._excalidrawAPI.getFiles() : {}
		};
	}

	/**
	 * Replace the current scene with the supplied data.  Accepts either the
	 * full { elements, appState, files } object or just an elements array.
	 */
	setScene(pSceneData)
	{
		if (!this._excalidrawAPI) return false;
		if (!pSceneData) return false;

		let tmpScene = Array.isArray(pSceneData)
			? { elements: pSceneData, appState: {}, files: {} }
			: pSceneData;

		this._excalidrawAPI.updateScene({
			elements: tmpScene.elements || [],
			appState: tmpScene.appState || {},
			collaborators: new Map()
		});
		if (tmpScene.files && this._excalidrawAPI.addFiles)
		{
			let tmpFilesArr = [];
			let tmpKeys = Object.keys(tmpScene.files);
			for (let i = 0; i < tmpKeys.length; i++) tmpFilesArr.push(tmpScene.files[tmpKeys[i]]);
			if (tmpFilesArr.length) this._excalidrawAPI.addFiles(tmpFilesArr);
		}
		return true;
	}

	/**
	 * Export the current scene as an SVGElement.  Returns a Promise.
	 *
	 * Per-export overrides accept both top-level keys (passed through to
	 * Excalidraw's exportToSvg opts) and the appState-resident export flags
	 * that Excalidraw expects to find on appState (exportEmbedScene,
	 * exportBackground, exportPadding, exportScale, exportWithDarkMode).
	 * We auto-promote the appState ones so callers can write
	 * `view.exportSvg({ exportEmbedScene: true })` without remembering
	 * which key lives where.
	 */
	exportSvg(pOpts)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.exportToSvg) return Promise.reject(new Error('exportToSvg unavailable'));
		let tmpScene = this.getScene();
		if (!tmpScene) return Promise.reject(new Error('Excalidraw not mounted'));
		let tmpOpts = pOpts || {};
		let tmpAppStateOverrides = this._promoteAppStateExportKeys(tmpOpts);
		return tmpVendor.exportToSvg(Object.assign({
			elements: tmpScene.elements,
			appState: Object.assign({}, tmpScene.appState, tmpAppStateOverrides),
			files:    tmpScene.files
		}, tmpOpts));
	}

	/** Export the current scene as a PNG blob.  Returns a Promise. */
	exportBlob(pOpts)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.exportToBlob) return Promise.reject(new Error('exportToBlob unavailable'));
		let tmpScene = this.getScene();
		if (!tmpScene) return Promise.reject(new Error('Excalidraw not mounted'));
		let tmpOpts = pOpts || {};
		let tmpAppStateOverrides = this._promoteAppStateExportKeys(tmpOpts);
		return tmpVendor.exportToBlob(Object.assign({
			elements: tmpScene.elements,
			appState: Object.assign({}, tmpScene.appState, tmpAppStateOverrides),
			files:    tmpScene.files,
			mimeType: 'image/png'
		}, tmpOpts));
	}

	/**
	 * Pull out the export-control flags that Excalidraw expects on
	 * appState and return them as a separate object.  Mutates the input
	 * to remove the promoted keys (so they don't double-apply at top level).
	 */
	_promoteAppStateExportKeys(pOpts)
	{
		let tmpKeys = [
			'exportEmbedScene', 'exportBackground', 'exportPadding',
			'exportScale', 'exportWithDarkMode'
		];
		let tmpOut = {};
		for (let i = 0; i < tmpKeys.length; i++)
		{
			if (Object.prototype.hasOwnProperty.call(pOpts, tmpKeys[i]))
			{
				tmpOut[tmpKeys[i]] = pOpts[tmpKeys[i]];
				delete pOpts[tmpKeys[i]];
			}
		}
		return tmpOut;
	}

	/**
	 * Convert a mermaid diagram source string into Excalidraw scene elements,
	 * optionally applying them to the live canvas.
	 *
	 * Uses Excalidraw's bundled @excalidraw/mermaid-to-excalidraw +
	 * convertToExcalidrawElements helpers via the wrapper bundle.
	 *
	 * @param {string} pMermaid - Mermaid source (flowchart, sequence, class, …)
	 * @param {object} [pOpts]
	 * @param {boolean} [pOpts.apply=true] - When true, replaces the current scene
	 *                                        with the converted elements via
	 *                                        setScene().  When false, just
	 *                                        returns the elements without
	 *                                        touching the canvas.
	 * @param {object}  [pOpts.mermaidOptions] - Forwarded to parseMermaidToExcalidraw
	 *                                            (e.g. { fontSize: 16 }).
	 * @returns {Promise<{elements: any[], files: object}>}
	 */
	convertMermaidToExcalidraw(pMermaid, pOpts)
	{
		let tmpOpts = pOpts || {};
		let tmpApply = (tmpOpts.apply !== false);
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.parseMermaidToExcalidraw || !tmpVendor.convertToExcalidrawElements)
		{
			return Promise.reject(new Error('mermaid helpers not available — wrapper bundle out of date?'));
		}
		return tmpVendor.parseMermaidToExcalidraw(pMermaid, tmpOpts.mermaidOptions || {}).then((pParsed) =>
		{
			let tmpSkeleton = (pParsed && pParsed.elements) || [];
			let tmpFiles    = (pParsed && pParsed.files)    || {};
			let tmpElements = tmpVendor.convertToExcalidrawElements(tmpSkeleton);
			if (tmpApply)
			{
				this.setScene({ elements: tmpElements, appState: {}, files: tmpFiles });
			}
			return { elements: tmpElements, files: tmpFiles };
		});
	}

	/** Serialize the current scene as a JSON string compatible with .excalidraw files. */
	serialize()
	{
		let tmpVendor = this._resolveVendor();
		let tmpScene = this.getScene();
		if (!tmpScene) return null;
		if (tmpVendor && tmpVendor.serializeAsJSON)
		{
			return tmpVendor.serializeAsJSON(tmpScene.elements, tmpScene.appState, tmpScene.files, 'local');
		}
		return JSON.stringify({
			type: 'excalidraw',
			version: 2,
			source: 'pict-section-excalidraw',
			elements: tmpScene.elements,
			appState: tmpScene.appState,
			files:    tmpScene.files
		});
	}

	/**
	 * Switch theme.  Accepts 'light', 'dark', or 'auto'.  Re-mounts the React
	 * tree with the new theme prop — Excalidraw doesn't expose a runtime
	 * theme switch on the API.
	 */
	setTheme(pTheme)
	{
		this._currentTheme = pTheme || 'light';
		if (this._excalidrawAPI && this._excalidrawAPI.updateScene)
		{
			let tmpResolved = this._resolveTheme(this._currentTheme);
			this._excalidrawAPI.updateScene({ appState: { theme: tmpResolved } });
		}
	}

	/** Toggle the Excalidraw view-mode flag (read-only). */
	setReadOnly(pReadOnly)
	{
		this.options.ViewModeEnabled = !!pReadOnly;
		if (this._excalidrawAPI && this._excalidrawAPI.updateScene)
		{
			this._excalidrawAPI.updateScene({ appState: { viewModeEnabled: !!pReadOnly } });
		}
	}

	/**
	 * Invoke OnLoad if registered, or read from DrawingDataAddress otherwise,
	 * and apply the result.
	 */
	load()
	{
		if (typeof this.options.OnLoad === 'function')
		{
			this.options.OnLoad(this, (pErr, pSceneData) =>
			{
				if (pErr)
				{
					this.log.error(`PICT-Excalidraw OnLoad error: ${pErr.message || pErr}`);
					return;
				}
				if (pSceneData)
				{
					this.setScene(pSceneData);
				}
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			let tmpScene = this._readAppData(this.options.DrawingDataAddress);
			if (tmpScene) this.setScene(tmpScene);
		}
	}

	/** Invoke OnSave with the current scene, or just write to AppData. */
	save()
	{
		let tmpScene = this.getScene();
		if (!tmpScene) return;
		if (typeof this.options.OnSave === 'function')
		{
			this.options.OnSave(this, tmpScene, (pErr) =>
			{
				if (pErr) this.log.error(`PICT-Excalidraw OnSave error: ${pErr.message || pErr}`);
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			this._writeAppData(this.options.DrawingDataAddress, this._cloneScene(tmpScene));
		}
	}

	/**
	 * Tear down React root + flush pending throttles + clear the destination
	 * DOM.  Idempotent — safe to call twice.  After destroy(), public API
	 * methods that touch DOM/React (getScene, setScene, exportSvg, save,
	 * load, setTheme, setReadOnly) become no-ops via the _destroyed gate.
	 */
	destroy()
	{
		if (this._destroyed) return;
		this._destroyed = true;

		if (this._onChangeThrottleHandle)
		{
			clearTimeout(this._onChangeThrottleHandle);
			this._onChangeThrottleHandle = null;
		}
		this._lastSeenChangeSnapshot = null;
		this._pendingDeferredLoad = false;

		if (this._reactRoot)
		{
			try { this._reactRoot.unmount(); }
			catch (pErr) { this.log.error(`PICT-Excalidraw unmount failed: ${pErr && pErr.message}`); }
			this._reactRoot = null;
		}

		// Clear the destination so a subsequent re-render starts clean.  We
		// own the contents of targetElement from onAfterInitialRender on.
		if (this.targetElement && this.targetElement.innerHTML !== undefined)
		{
			try { this.targetElement.innerHTML = ''; }
			catch (pErr) { /* ignore */ }
		}

		this._excalidrawAPI = null;
		this._wrapElement   = null;
		this._mountElement  = null;
		this._statusElement = null;
		this.targetElement  = false;
		this._vendor        = null;
		this.initialRenderComplete = false;
	}

	/** Whether destroy() has been called. */
	isDestroyed()
	{
		return !!this._destroyed;
	}
}

module.exports = PictViewExcalidrawReact;
module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":490,"../utils/Excalidraw-Form-Factor.js":492,"pict-view":693}],495:[function(require,module,exports){
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  function getDefaults() {
    return {
      async: false,
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      hooks: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }
  exports.defaults = getDefaults();
  function changeDefaults(newDefaults) {
    exports.defaults = newDefaults;
  }

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = new RegExp(escapeTest.source, 'g');
  var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
  var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };
  function escape(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }
    return html;
  }
  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  /**
   * @param {string} html
   */
  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }
  var caret = /(^|[^\[])\^/g;

  /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */
  function edit(regex, opt) {
    regex = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }
  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */
  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      var prot;
      try {
        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }
  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  /**
   * @param {string} base
   * @param {string} href
   */
  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;
    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }
      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }
      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }
  var noopTest = {
    exec: function noopTest() {}
  };
  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
          curr = offset;
        while (--curr >= 0 && str[curr] === '\\') {
          escaped = !escaped;
        }
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/);
    var i = 0;

    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
      cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
      cells.pop();
    }
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) {
        cells.push('');
      }
    }
    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */
  function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }
    return str.slice(0, l - suffLen);
  }
  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var l = str.length;
    var level = 0,
      i = 0;
    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }
  function checkSanitizeDeprecation(opt) {
    if (opt && opt.sanitize && !opt.silent) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
  }

  // copied from https://stackoverflow.com/a/5450113/806777
  /**
   * @param {string} pattern
   * @param {number} count
   */
  function repeatString(pattern, count) {
    if (count < 1) {
      return '';
    }
    var result = '';
    while (count > 1) {
      if (count & 1) {
        result += pattern;
      }
      count >>= 1;
      pattern += pattern;
    }
    return result + pattern;
  }

  function outputLink(cap, link, raw, lexer) {
    var href = link.href;
    var title = link.title ? escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
      lexer.state.inLink = true;
      var token = {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
      };
      lexer.state.inLink = false;
      return token;
    }
    return {
      type: 'image',
      raw: raw,
      href: href,
      title: title,
      text: escape(text)
    };
  }
  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
      return text;
    }
    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }
      var indentInNode = matchIndentInNode[0];
      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }
      return node;
    }).join('\n');
  }

  /**
   * Tokenizer
   */
  var Tokenizer = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Tokenizer.prototype;
    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);
      if (cap && cap[0].length > 0) {
        return {
          type: 'space',
          raw: cap[0]
        };
      }
    };
    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };
    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);
      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
          text: text
        };
      }
    };
    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);
      if (cap) {
        var text = cap[2].trim();

        // remove trailing #s
        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');
          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);
      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };
    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ *>[ \t]?/gm, '');
        var top = this.lexer.state.top;
        this.lexer.state.top = true;
        var tokens = this.lexer.blockTokens(text);
        this.lexer.state.top = top;
        return {
          type: 'blockquote',
          raw: cap[0],
          tokens: tokens,
          text: text
        };
      }
    };
    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);
      if (cap) {
        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
        var bull = cap[1].trim();
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: '',
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        };
        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
        if (this.options.pedantic) {
          bull = isordered ? bull : '[*+-]';
        }

        // Get next list item
        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");

        // Check if current bullet point can start a new List Item
        while (src) {
          endEarly = false;
          if (!(cap = itemRegex.exec(src))) {
            break;
          }
          if (this.rules.block.hr.test(src)) {
            // End list if bullet was actually HR (possibly move into itemRegex?)
            break;
          }
          raw = cap[0];
          src = src.substring(raw.length);
          line = cap[2].split('\n', 1)[0].replace(/^\t+/, function (t) {
            return ' '.repeat(3 * t.length);
          });
          nextLine = src.split('\n', 1)[0];
          if (this.options.pedantic) {
            indent = 2;
            itemContents = line.trimLeft();
          } else {
            indent = cap[2].search(/[^ ]/); // Find first non-space char
            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
            itemContents = line.slice(indent);
            indent += cap[1].length;
          }
          blankLine = false;
          if (!line && /^ *$/.test(nextLine)) {
            // Items begin with at most one blank line
            raw += nextLine + '\n';
            src = src.substring(nextLine.length + 1);
            endEarly = true;
          }
          if (!endEarly) {
            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
            var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
            var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
            var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");

            // Check if following lines should be included in List Item
            while (src) {
              rawLine = src.split('\n', 1)[0];
              nextLine = rawLine;

              // Re-align to follow commonmark nesting rules
              if (this.options.pedantic) {
                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
              }

              // End list item if found code fences
              if (fencesBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new heading
              if (headingBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new bullet
              if (nextBulletRegex.test(nextLine)) {
                break;
              }

              // Horizontal rule found
              if (hrRegex.test(src)) {
                break;
              }
              if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) {
                // Dedent if possible
                itemContents += '\n' + nextLine.slice(indent);
              } else {
                // not enough indentation
                if (blankLine) {
                  break;
                }

                // paragraph continuation unless last line was a different block level element
                if (line.search(/[^ ]/) >= 4) {
                  // indented code block
                  break;
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(line)) {
                  break;
                }
                itemContents += '\n' + nextLine;
              }
              if (!blankLine && !nextLine.trim()) {
                // Check if current line is blank
                blankLine = true;
              }
              raw += rawLine + '\n';
              src = src.substring(rawLine.length + 1);
              line = nextLine.slice(indent);
            }
          }
          if (!list.loose) {
            // If the previous item ended with a blank line, the list is loose
            if (endsWithBlankLine) {
              list.loose = true;
            } else if (/\n *\n *$/.test(raw)) {
              endsWithBlankLine = true;
            }
          }

          // Check for task list items
          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.exec(itemContents);
            if (istask) {
              ischecked = istask[0] !== '[ ] ';
              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
            }
          }
          list.items.push({
            type: 'list_item',
            raw: raw,
            task: !!istask,
            checked: ischecked,
            loose: false,
            text: itemContents
          });
          list.raw += raw;
        }

        // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
        list.items[list.items.length - 1].raw = raw.trimRight();
        list.items[list.items.length - 1].text = itemContents.trimRight();
        list.raw = list.raw.trimRight();
        var l = list.items.length;

        // Item child tokens handled here at end because we needed to have the final item to trim it first
        for (i = 0; i < l; i++) {
          this.lexer.state.top = false;
          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
          if (!list.loose) {
            // Check if list should be loose
            var spacers = list.items[i].tokens.filter(function (t) {
              return t.type === 'space';
            });
            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function (t) {
              return /\n.*\n/.test(t.raw);
            });
            list.loose = hasMultipleLineBreaks;
          }
        }

        // Set all items to loose if list is loose
        if (list.loose) {
          for (i = 0; i < l; i++) {
            list.items[i].loose = true;
          }
        }
        return list;
      }
    };
    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);
      if (cap) {
        var token = {
          type: 'html',
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        };
        if (this.options.sanitize) {
          var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
          token.type = 'paragraph';
          token.text = text;
          token.tokens = this.lexer.inline(text);
        }
        return token;
      }
    };
    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);
      if (cap) {
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
        var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: href,
          title: title
        };
      }
    };
    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);
      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1]).map(function (c) {
            return {
              text: c
            };
          }),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
        };
        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i, j, k, row;
          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }
          l = item.rows.length;
          for (i = 0; i < l; i++) {
            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
              return {
                text: c
              };
            });
          }

          // parse child tokens inside headers and cells

          // header child tokens
          l = item.header.length;
          for (j = 0; j < l; j++) {
            item.header[j].tokens = this.lexer.inline(item.header[j].text);
          }

          // cell child tokens
          l = item.rows.length;
          for (j = 0; j < l; j++) {
            row = item.rows[j];
            for (k = 0; k < row.length; k++) {
              row[k].tokens = this.lexer.inline(row[k].text);
            }
          }
          return item;
        }
      }
    };
    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);
      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1],
          tokens: this.lexer.inline(cap[1])
        };
      }
    };
    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);
      if (cap) {
        var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
        return {
          type: 'paragraph',
          raw: cap[0],
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);
      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0],
          tokens: this.lexer.inline(cap[0])
        };
      }
    };
    _proto.escape = function escape$1(src) {
      var cap = this.rules.inline.escape.exec(src);
      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: escape(cap[1])
        };
      }
    };
    _proto.tag = function tag(src) {
      var cap = this.rules.inline.tag.exec(src);
      if (cap) {
        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
          this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
          this.lexer.state.inLink = false;
        }
        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = true;
        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = false;
        }
        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        };
      }
    };
    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);
      if (cap) {
        var trimmedUrl = cap[2].trim();
        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          }

          // ending angle bracket cannot be escaped
          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');
          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }
        var href = cap[2];
        var title = '';
        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim();
        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }
        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0], this.lexer);
      }
    };
    _proto.reflink = function reflink(src, links) {
      var cap;
      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];
        if (!link) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }
        return outputLink(cap, link, cap[0], this.lexer);
      }
    };
    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }
      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return;

      // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
      var nextChar = match[1] || match[2] || '';
      if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
        var lLength = match[0].length - 1;
        var rDelim,
          rLength,
          delimTotal = lLength,
          midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0;

        // Clip maskedSrc to same section of string as src (move to lexer?)
        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;
          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters

          // Remove extra characters. *a*** -> *a*
          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
          var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);

          // Create `em` if smallest delimiter has odd char count. *a***
          if (Math.min(lLength, rLength) % 2) {
            var _text = raw.slice(1, -1);
            return {
              type: 'em',
              raw: raw,
              text: _text,
              tokens: this.lexer.inlineTokens(_text)
            };
          }

          // Create 'strong' if smallest delimiter has even char count. **a***
          var text = raw.slice(2, -2);
          return {
            type: 'strong',
            raw: raw,
            text: text,
            tokens: this.lexer.inlineTokens(text)
          };
        }
      }
    };
    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);
      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }
        text = escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };
    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);
      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };
    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);
      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2],
          tokens: this.lexer.inlineTokens(cap[2])
        };
      }
    };
    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);
      if (cap) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.url = function url(src, mangle) {
      var cap;
      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
          } else {
            href = cap[0];
          }
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.inlineText = function inlineText(src, smartypants) {
      var cap = this.rules.inline.text.exec(src);
      if (cap) {
        var text;
        if (this.lexer.state.inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        } else {
          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }
        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };
    return Tokenizer;
  }();

  /**
   * Block-Level Grammar
   */
  var block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = _extends({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = _extends({}, block.normal, {
    table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
  });

  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = _extends({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Inline-Level Grammar
   */
  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
      //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
      rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
      rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
    },

    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
  };

  // list of punctuation marks from CommonMark spec
  // without * and _ to handle the different emphasis markers * and _
  inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
  inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

  // sequences em should skip over [title](link), `code`, <html>
  inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
  // lookbehind is not available on Safari as of version 16
  // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
  inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
  inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = _extends({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = _extends({}, inline.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = _extends({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = _extends({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * smartypants text replacement
   * @param {string} text
   */
  function smartypants(text) {
    return text
    // em-dashes
    .replace(/---/g, "\u2014")
    // en-dashes
    .replace(/--/g, "\u2013")
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")
    // closing singles & apostrophes
    .replace(/'/g, "\u2019")
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")
    // closing doubles
    .replace(/"/g, "\u201D")
    // ellipses
    .replace(/\.{3}/g, "\u2026");
  }

  /**
   * mangle email addresses
   * @param {string} text
   */
  function mangle(text) {
    var out = '',
      i,
      ch;
    var l = text.length;
    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }
    return out;
  }

  /**
   * Block Lexer
   */
  var Lexer = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || exports.defaults;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      this.tokenizer.lexer = this;
      this.inlineQueue = [];
      this.state = {
        inLink: false,
        inRawBlock: false,
        top: true
      };
      var rules = {
        block: block.normal,
        inline: inline.normal
      };
      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;
        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }
      this.tokenizer.rules = rules;
    }

    /**
     * Expose Rules
     */
    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }

    /**
     * Static Lex Inline Method
     */;
    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }

    /**
     * Preprocessing
     */;
    var _proto = Lexer.prototype;
    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n');
      this.blockTokens(src, this.tokens);
      var next;
      while (next = this.inlineQueue.shift()) {
        this.inlineTokens(next.src, next.tokens);
      }
      return this.tokens;
    }

    /**
     * Lexing
     */;
    _proto.blockTokens = function blockTokens(src, tokens) {
      var _this = this;
      if (tokens === void 0) {
        tokens = [];
      }
      if (this.options.pedantic) {
        src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
      } else {
        src = src.replace(/^( *)(\t+)/gm, function (_, leading, tabs) {
          return leading + '    '.repeat(tabs.length);
        });
      }
      var token, lastToken, cutSrc, lastParagraphClipped;
      while (src) {
        if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // newline
        if (token = this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);
          if (token.raw.length === 1 && tokens.length > 0) {
            // if there's a single \n as a spacer, it's terminating the last line,
            // so move it there so that we don't get unecessary paragraph tags
            tokens[tokens.length - 1].raw += '\n';
          } else {
            tokens.push(token);
          }
          continue;
        }

        // code
        if (token = this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          // An indented code block cannot interrupt a paragraph.
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // fences
        if (token = this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // heading
        if (token = this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // hr
        if (token = this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // blockquote
        if (token = this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // list
        if (token = this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // html
        if (token = this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // def
        if (token = this.tokenizer.def(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.raw;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else if (!this.tokens.links[token.tag]) {
            this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }
          continue;
        }

        // table (gfm)
        if (token = this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // lheading
        if (token = this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startBlock) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this.options.extensions.startBlock.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];
          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          continue;
        }

        // text
        if (token = this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      this.state.top = true;
      return tokens;
    };
    _proto.inline = function inline(src, tokens) {
      if (tokens === void 0) {
        tokens = [];
      }
      this.inlineQueue.push({
        src: src,
        tokens: tokens
      });
      return tokens;
    }

    /**
     * Lexing/Compiling
     */;
    _proto.inlineTokens = function inlineTokens(src, tokens) {
      var _this2 = this;
      if (tokens === void 0) {
        tokens = [];
      }
      var token, lastToken, cutSrc;

      // String with links masked to avoid interference with em and strong
      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar;

      // Mask out reflinks
      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);
        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      }
      // Mask out other blocks
      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      }

      // Mask out escaped em & strong delimiters
      while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
      }
      while (src) {
        if (!keepPrevChar) {
          prevChar = '';
        }
        keepPrevChar = false;

        // extensions
        if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this2
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // escape
        if (token = this.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // tag
        if (token = this.tokenizer.tag(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // link
        if (token = this.tokenizer.link(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // reflink, nolink
        if (token = this.tokenizer.reflink(src, this.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // em & strong
        if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // code
        if (token = this.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // br
        if (token = this.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // del (gfm)
        if (token = this.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // autolink
        if (token = this.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // url (gfm)
        if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startInline) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this2.options.extensions.startInline.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
          src = src.substring(token.raw.length);
          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }
          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      return tokens;
    };
    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);
    return Lexer;
  }();

  /**
   * Renderer
   */
  var Renderer = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Renderer.prototype;
    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];
      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);
        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }
      _code = _code.replace(/\n$/, '') + '\n';
      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
      }
      return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
    }

    /**
     * @param {string} quote
     */;
    _proto.blockquote = function blockquote(quote) {
      return "<blockquote>\n" + quote + "</blockquote>\n";
    };
    _proto.html = function html(_html) {
      return _html;
    }

    /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */;
    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        var id = this.options.headerPrefix + slugger.slug(raw);
        return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
      }

      // ignore IDs
      return "<h" + level + ">" + text + "</h" + level + ">\n";
    };
    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }

    /**
     * @param {string} text
     */;
    _proto.listitem = function listitem(text) {
      return "<li>" + text + "</li>\n";
    };
    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    }

    /**
     * @param {string} text
     */;
    _proto.paragraph = function paragraph(text) {
      return "<p>" + text + "</p>\n";
    }

    /**
     * @param {string} header
     * @param {string} body
     */;
    _proto.table = function table(header, body) {
      if (body) body = "<tbody>" + body + "</tbody>";
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    }

    /**
     * @param {string} content
     */;
    _proto.tablerow = function tablerow(content) {
      return "<tr>\n" + content + "</tr>\n";
    };
    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
      return tag + content + ("</" + type + ">\n");
    }

    /**
     * span level renderer
     * @param {string} text
     */;
    _proto.strong = function strong(text) {
      return "<strong>" + text + "</strong>";
    }

    /**
     * @param {string} text
     */;
    _proto.em = function em(text) {
      return "<em>" + text + "</em>";
    }

    /**
     * @param {string} text
     */;
    _proto.codespan = function codespan(text) {
      return "<code>" + text + "</code>";
    };
    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    }

    /**
     * @param {string} text
     */;
    _proto.del = function del(text) {
      return "<del>" + text + "</del>";
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = '<a href="' + href + '"';
      if (title) {
        out += ' title="' + title + '"';
      }
      out += '>' + text + '</a>';
      return out;
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
      if (title) {
        out += " title=\"" + title + "\"";
      }
      out += this.options.xhtml ? '/>' : '>';
      return out;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */
  var TextRenderer = /*#__PURE__*/function () {
    function TextRenderer() {}
    var _proto = TextRenderer.prototype;
    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };
    _proto.em = function em(text) {
      return text;
    };
    _proto.codespan = function codespan(text) {
      return text;
    };
    _proto.del = function del(text) {
      return text;
    };
    _proto.html = function html(text) {
      return text;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    _proto.link = function link(href, title, text) {
      return '' + text;
    };
    _proto.image = function image(href, title, text) {
      return '' + text;
    };
    _proto.br = function br() {
      return '';
    };
    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */
  var Slugger = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    /**
     * @param {string} value
     */
    var _proto = Slugger.prototype;
    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }

    /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */;
    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;
      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];
        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }
      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }
      return slug;
    }

    /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */;
    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }
      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };
    return Slugger;
  }();

  /**
   * Parsing & Compiling
   */
  var Parser = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || exports.defaults;
      this.options.renderer = this.options.renderer || new Renderer();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer();
      this.slugger = new Slugger();
    }

    /**
     * Static Parse Method
     */
    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }

    /**
     * Static Parse Inline Method
     */;
    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }

    /**
     * Parse Loop
     */;
    var _proto = Parser.prototype;
    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }
      var out = '',
        i,
        j,
        k,
        l2,
        l3,
        row,
        cell,
        header,
        body,
        token,
        ordered,
        start,
        loose,
        itemBody,
        item,
        checked,
        task,
        checkbox,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'space':
            {
              continue;
            }
          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }
          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
          case 'table':
            {
              header = '';

              // header
              cell = '';
              l2 = token.header.length;
              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                  header: true,
                  align: token.align[j]
                });
              }
              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.rows.length;
              for (j = 0; j < l2; j++) {
                row = token.rows[j];
                cell = '';
                l3 = row.length;
                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                    header: false,
                    align: token.align[k]
                  });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';
              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
          case 'html':
            {
              // TODO parse inline content if parameter markdown=1
              out += this.renderer.html(token.text);
              continue;
            }
          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    }

    /**
     * Parse Inline Tokens
     */;
    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
        i,
        token,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }
          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }
          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }
          case 'br':
            {
              out += renderer.br();
              break;
            }
          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    };
    return Parser;
  }();

  var Hooks = /*#__PURE__*/function () {
    function Hooks(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Hooks.prototype;
    /**
     * Process markdown before marked
     */
    _proto.preprocess = function preprocess(markdown) {
      return markdown;
    }

    /**
     * Process HTML after marked is finished
     */;
    _proto.postprocess = function postprocess(html) {
      return html;
    };
    return Hooks;
  }();
  Hooks.passThroughHooks = new Set(['preprocess', 'postprocess']);

  function onError(silent, async, callback) {
    return function (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if (silent) {
        var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
        if (async) {
          return Promise.resolve(msg);
        }
        if (callback) {
          callback(null, msg);
          return;
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      if (callback) {
        callback(e);
        return;
      }
      throw e;
    };
  }
  function parseMarkdown(lexer, parser) {
    return function (src, opt, callback) {
      if (typeof opt === 'function') {
        callback = opt;
        opt = null;
      }
      var origOpt = _extends({}, opt);
      opt = _extends({}, marked.defaults, origOpt);
      var throwError = onError(opt.silent, opt.async, callback);

      // throw error in case of non string input
      if (typeof src === 'undefined' || src === null) {
        return throwError(new Error('marked(): input parameter is undefined or null'));
      }
      if (typeof src !== 'string') {
        return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
      }
      checkSanitizeDeprecation(opt);
      if (opt.hooks) {
        opt.hooks.options = opt;
      }
      if (callback) {
        var highlight = opt.highlight;
        var tokens;
        try {
          if (opt.hooks) {
            src = opt.hooks.preprocess(src);
          }
          tokens = lexer(src, opt);
        } catch (e) {
          return throwError(e);
        }
        var done = function done(err) {
          var out;
          if (!err) {
            try {
              if (opt.walkTokens) {
                marked.walkTokens(tokens, opt.walkTokens);
              }
              out = parser(tokens, opt);
              if (opt.hooks) {
                out = opt.hooks.postprocess(out);
              }
            } catch (e) {
              err = e;
            }
          }
          opt.highlight = highlight;
          return err ? throwError(err) : callback(null, out);
        };
        if (!highlight || highlight.length < 3) {
          return done();
        }
        delete opt.highlight;
        if (!tokens.length) return done();
        var pending = 0;
        marked.walkTokens(tokens, function (token) {
          if (token.type === 'code') {
            pending++;
            setTimeout(function () {
              highlight(token.text, token.lang, function (err, code) {
                if (err) {
                  return done(err);
                }
                if (code != null && code !== token.text) {
                  token.text = code;
                  token.escaped = true;
                }
                pending--;
                if (pending === 0) {
                  done();
                }
              });
            }, 0);
          }
        });
        if (pending === 0) {
          done();
        }
        return;
      }
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function (src) {
          return lexer(src, opt);
        }).then(function (tokens) {
          return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function () {
            return tokens;
          }) : tokens;
        }).then(function (tokens) {
          return parser(tokens, opt);
        }).then(function (html) {
          return opt.hooks ? opt.hooks.postprocess(html) : html;
        })["catch"](throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        var _tokens = lexer(src, opt);
        if (opt.walkTokens) {
          marked.walkTokens(_tokens, opt.walkTokens);
        }
        var html = parser(_tokens, opt);
        if (opt.hooks) {
          html = opt.hooks.postprocess(html);
        }
        return html;
      } catch (e) {
        return throwError(e);
      }
    };
  }

  /**
   * Marked
   */
  function marked(src, opt, callback) {
    return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    marked.defaults = _extends({}, marked.defaults, opt);
    changeDefaults(marked.defaults);
    return marked;
  };
  marked.getDefaults = getDefaults;
  marked.defaults = exports.defaults;

  /**
   * Use Extension
   */

  marked.use = function () {
    var extensions = marked.defaults.extensions || {
      renderers: {},
      childTokens: {}
    };
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    args.forEach(function (pack) {
      // copy options to new object
      var opts = _extends({}, pack);

      // set async to true if it was set to true before
      opts.async = marked.defaults.async || opts.async || false;

      // ==-- Parse "addon" extensions --== //
      if (pack.extensions) {
        pack.extensions.forEach(function (ext) {
          if (!ext.name) {
            throw new Error('extension name required');
          }
          if (ext.renderer) {
            // Renderer extensions
            var prevRenderer = extensions.renderers[ext.name];
            if (prevRenderer) {
              // Replace extension with func to run new extension but fall back if false
              extensions.renderers[ext.name] = function () {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }
                var ret = ext.renderer.apply(this, args);
                if (ret === false) {
                  ret = prevRenderer.apply(this, args);
                }
                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }
          if (ext.tokenizer) {
            // Tokenizer Extensions
            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
              throw new Error("extension level must be 'block' or 'inline'");
            }
            if (extensions[ext.level]) {
              extensions[ext.level].unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }
            if (ext.start) {
              // Function to check for start of token
              if (ext.level === 'block') {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === 'inline') {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }
          if (ext.childTokens) {
            // Child tokens to be visited by walkTokens
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
        opts.extensions = extensions;
      }

      // ==-- Parse "overwrite" extensions --== //
      if (pack.renderer) {
        (function () {
          var renderer = marked.defaults.renderer || new Renderer();
          var _loop = function _loop(prop) {
            var prevRenderer = renderer[prop];
            // Replace renderer with func to run extension, but fall back if false
            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var ret = pack.renderer[prop].apply(renderer, args);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.renderer) {
            _loop(prop);
          }
          opts.renderer = renderer;
        })();
      }
      if (pack.tokenizer) {
        (function () {
          var tokenizer = marked.defaults.tokenizer || new Tokenizer();
          var _loop2 = function _loop2(prop) {
            var prevTokenizer = tokenizer[prop];
            // Replace tokenizer with func to run extension, but fall back if false
            tokenizer[prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              var ret = pack.tokenizer[prop].apply(tokenizer, args);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.tokenizer) {
            _loop2(prop);
          }
          opts.tokenizer = tokenizer;
        })();
      }

      // ==-- Parse Hooks extensions --== //
      if (pack.hooks) {
        (function () {
          var hooks = marked.defaults.hooks || new Hooks();
          var _loop3 = function _loop3(prop) {
            var prevHook = hooks[prop];
            if (Hooks.passThroughHooks.has(prop)) {
              hooks[prop] = function (arg) {
                if (marked.defaults.async) {
                  return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function (ret) {
                    return prevHook.call(hooks, ret);
                  });
                }
                var ret = pack.hooks[prop].call(hooks, arg);
                return prevHook.call(hooks, ret);
              };
            } else {
              hooks[prop] = function () {
                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                var ret = pack.hooks[prop].apply(hooks, args);
                if (ret === false) {
                  ret = prevHook.apply(hooks, args);
                }
                return ret;
              };
            }
          };
          for (var prop in pack.hooks) {
            _loop3(prop);
          }
          opts.hooks = hooks;
        })();
      }

      // ==-- Parse WalkTokens extensions --== //
      if (pack.walkTokens) {
        var _walkTokens = marked.defaults.walkTokens;
        opts.walkTokens = function (token) {
          var values = [];
          values.push(pack.walkTokens.call(this, token));
          if (_walkTokens) {
            values = values.concat(_walkTokens.call(this, token));
          }
          return values;
        };
      }
      marked.setOptions(opts);
    });
  };

  /**
   * Run callback for every token
   */

  marked.walkTokens = function (tokens, callback) {
    var values = [];
    var _loop4 = function _loop4() {
      var token = _step.value;
      values = values.concat(callback.call(marked, token));
      switch (token.type) {
        case 'table':
          {
            for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
              var cell = _step2.value;
              values = values.concat(marked.walkTokens(cell.tokens, callback));
            }
            for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
              var row = _step3.value;
              for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                var _cell = _step4.value;
                values = values.concat(marked.walkTokens(_cell.tokens, callback));
              }
            }
            break;
          }
        case 'list':
          {
            values = values.concat(marked.walkTokens(token.items, callback));
            break;
          }
        default:
          {
            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
              // Walk any extensions
              marked.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                values = values.concat(marked.walkTokens(token[childTokens], callback));
              });
            } else if (token.tokens) {
              values = values.concat(marked.walkTokens(token.tokens, callback));
            }
          }
      }
    };
    for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
      _loop4();
    }
    return values;
  };

  /**
   * Parse Inline
   * @param {string} src
   */
  marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);

  /**
   * Expose
   */
  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.Hooks = Hooks;
  marked.parse = marked;
  var options = marked.options;
  var setOptions = marked.setOptions;
  var use = marked.use;
  var walkTokens = marked.walkTokens;
  var parseInline = marked.parseInline;
  var parse = marked;
  var parser = Parser.parse;
  var lexer = Lexer.lex;

  exports.Hooks = Hooks;
  exports.Lexer = Lexer;
  exports.Parser = Parser;
  exports.Renderer = Renderer;
  exports.Slugger = Slugger;
  exports.TextRenderer = TextRenderer;
  exports.Tokenizer = Tokenizer;
  exports.getDefaults = getDefaults;
  exports.lexer = lexer;
  exports.marked = marked;
  exports.options = options;
  exports.parse = parse;
  exports.parseInline = parseInline;
  exports.parser = parser;
  exports.setOptions = setOptions;
  exports.use = use;
  exports.walkTokens = walkTokens;

}));

},{}],496:[function(require,module,exports){
module.exports={
    "name": "pict-section-form",
    "version": "1.3.17",
    "description": "Pict dynamic forms",
    "main": "source/Pict-Section-Form.js",
    "directories": {
        "test": "test"
    },
    "repository": {
        "type": "git",
        "url": "git+https://github.com/fable-retold/pict-section-form.git"
    },
    "bugs": {
        "url": "https://github.com/fable-retold/pict-section-form/issues"
    },
    "homepage": "https://github.com/fable-retold/pict-section-form#readme",
    "scripts": {
        "start": "node source/Pict-Section-Form.js",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "test": "npx quack test",
        "test:injection": "node test/browser/Injection-Conformance-Harness-Runner.js",
        "lint": "eslint source/**",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p ./tsconfig.json --noEmit",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-section-form-image:local",
        "docker-dev-run": "docker run -it -d --name pict-section-form-dev -p 48888:8080 -p 49999:9999 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-section-form\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-section-form-image:local",
        "docker-dev-shell": "docker exec -it pict-section-form-dev /bin/bash"
    },
    "types": "types/source/Pict-Section-Form.d.ts",
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "devDependencies": {
        "@eslint/js": "^9.39.2",
        "@types/chai": "^4.3.20",
        "@types/mocha": "^10.0.10",
        "@types/node": "^22.19.21",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.2",
        "jquery": "^4.0.0",
        "pict": "^1.0.401",
        "pict-application": "^1.0.34",
        "pict-docuserve": "^1.4.19",
        "pict-service-commandlineutility": "^1.0.20",
        "quackage": "^1.3.0",
        "tui-grid": "^4.21.22",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "chart.js": "^4.5.1",
        "fable-serviceproviderbase": "^3.0.19",
        "marked": "^4.3.0",
        "pict-provider": "^1.0.13",
        "pict-section-excalidraw": "^1.0.6",
        "pict-section-markdowneditor": "^1.0.21",
        "pict-section-objecteditor": "^1.0.3",
        "pict-section-tuigrid": "^1.0.32",
        "pict-template": "^1.0.15",
        "pict-view": "^1.0.68"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],497:[function(require,module,exports){
// The container for all the Pict-Section-Form related code.

// The main dynamic view class
module.exports = require('./views/Pict-View-DynamicForm.js');
//module.exports.default_configuration = require('./views/Pict-View-DynamicForm-DefaultConfiguration.json');

// The dynamic application dependencies
module.exports.PictDynamicFormDependencyManager = require('./services/Pict-Service-DynamicFormDependencyManager.js');

// The base provider class for form section templates; meant to be subclassed
module.exports.PictFormTemplateProvider = require('./providers/Pict-Provider-DynamicTemplates.js');

// The base provider class for Input Extensions
module.exports.PictInputExtensionProvider = require('./providers/Pict-Provider-InputExtension.js');

// The metacontroller view
module.exports.PictFormMetacontroller = require('./views/Pict-View-Form-Metacontroller.js');

// The application container
module.exports.PictFormApplication = require('./application/Pict-Application-Form.js');

// The dynamic layout provider
module.exports.PictDynamicLayoutProvider = require('./providers/Pict-Provider-DynamicLayout.js');

// The ManifestFactory, for when we want to convert tabular data to configuration
module.exports.ManifestFactory = require('./services/ManifestFactory.js');
module.exports.ManifestConversionToCSV = require('./services/ManifestConversionToCSV.js');

// Reveal the support base class
module.exports.PictFormSupportBase = require('./views/support/Pict-View-PSF-SupportBase.js');

// The optional form persistence provider for offline data storage
module.exports.PictFormPersistenceProvider = require('./providers/Pict-Provider-FormPersistence.js');


// The extension views
module.exports.ExtensionViews = (
	{
		LifecycleVisualization: require('./views/support/Pict-View-PSF-LifeCycle-Visualization.js'),
		DebugViewer: require('./views/support/Pict-View-PSF-DebugViewer.js')
	});

// Complex InputTypes — heavy editor deps (markdowneditor, excalidraw) are
// lazy-required by the providers themselves on first setMode('edit'). The
// require below is just for the provider class; nothing heavy loads here.
module.exports.RichTextInput = require('./providers/inputs/Pict-Provider-Input-RichText.js');
module.exports.DiagramInput  = require('./providers/inputs/Pict-Provider-Input-Diagram.js');

// SVG palette → theme-CSS-variable rewriter. Re-exported so consumers can
// theme stored SVGs without needing pict-section-excalidraw.
module.exports.themeifySVG = require('./providers/inputs/util/Themeify-SVG.js').themeifySVG;
},{"./application/Pict-Application-Form.js":498,"./providers/Pict-Provider-DynamicLayout.js":502,"./providers/Pict-Provider-DynamicTemplates.js":506,"./providers/Pict-Provider-FormPersistence.js":507,"./providers/Pict-Provider-InputExtension.js":509,"./providers/inputs/Pict-Provider-Input-Diagram.js":521,"./providers/inputs/Pict-Provider-Input-RichText.js":530,"./providers/inputs/util/Themeify-SVG.js":537,"./services/ManifestConversionToCSV.js":546,"./services/ManifestFactory.js":547,"./services/Pict-Service-DynamicFormDependencyManager.js":548,"./views/Pict-View-DynamicForm.js":563,"./views/Pict-View-Form-Metacontroller.js":564,"./views/support/Pict-View-PSF-DebugViewer.js":567,"./views/support/Pict-View-PSF-LifeCycle-Visualization.js":568,"./views/support/Pict-View-PSF-SupportBase.js":571}],498:[function(require,module,exports){
const libPictApplication = require('pict-application');

const libPictSectionForm = require('../Pict-Section-Form.js');

/**
 * Represents a PictSectionFormApplication.
 *
 * This is the automagic controller for a dyncamic form application.
 *
 * @class
 * @extends libPictApplication
 */
class PictSectionFormApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & import('fable')} */
		this.pict;
		// Add the pict form service
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);

		// Add the pict form metacontroller service, which provides programmaatic view construction from manifests and render/marshal methods.
		this.pict.addView('PictFormMetacontroller', {}, libPictSectionForm.PictFormMetacontroller);
	}

	/**
	 * Marshals data from any rendered dynamic views to application data.
	 */
	marshalDataFromDynamicViewsToAppData()
	{
		this.pict.views.PictFormMetacontroller.marshalFromView();
	}

	/**
	 * Marshals data from the application data to any rendered dynamic views.
	 */
	marshalDataFromAppDataToDynamicViews()
	{
		this.pict.views.PictFormMetacontroller.marshalToView();
	}
};

module.exports = PictSectionFormApplication

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"Name": "A Simple Pict Forms Application",
	"Hash": "PictFormsApp",

	"MainViewportViewIdentifier": "PictFormMetacontroller",
	"AutoSolveAfterInitialize": false,

	"pict_configuration":
		{
			"Product": "PictDefaultFormsApp"
		}
});

},{"../Pict-Section-Form.js":497,"pict-application":476}],499:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// TODO: Pull this back to pict as a core service once we are happy with the shape.
/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-SolverBehaviors",

	"AutoInitialize": false,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

/**
 * Provides functions available in the solver for manipulating the form.
 * Such as showing/hiding sections, inputs, groups.  Coloring inputs,
 * sections, groups.  Applying styles to inputs, sections, groups.
 * Extends the `libPictProvider` class.
 */
class PictDynamicFormsSolverBehaviors extends libPictProvider
{
	/**
	 * Creates an instance of the `PictDynamicFormsInformary` class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { newManyfest: (options: any) => import('manyfest') }} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideSectionClass = 'pict-section-form-hidden-section';
		this.cssHideGroupClass = 'pict-section-form-hidden-group';

		// #SECTION-<formID> and #GROUP-<formID>-<hash> are both emitted by the section template, so a
		// render() regenerates them without the hide class and the hide silently reverts. Record what
		// was asked for so reapplySectionVisibility can restore it after a render.
		/** @type {Record<string, boolean>} */
		this.sectionVisibilityState = {};
		/** @type {Record<string, boolean>} */
		this.groupVisibilityState = {};

		// Same story for every solver that decorates the DOM -- highlight classes and inline background
		// colors all land on markup the section template regenerates. Keyed by what the decoration
		// targets so re-applying one overwrites rather than accumulating.
		/** @type {Record<string, {Section: string, Method: string, Arguments: Array<any>}>} */
		this.decorationState = {};
		/** @type {boolean} */
		this.decorationReplayInProgress = false;
		/** @type {string} */
		this.cssTabularRowHighlightClass = 'pict-tabular-row-highlight';
		/** @type {string} */
		this.cssTabularColumnHighlightClass = 'pict-tabular-column-highlight';
		this.cssSnippet = '.pict-section-form-hidden-section { display: none; } .pict-section-form-hidden-group { display: none; }'
			// Row/column highlight classes used by the highlighttabularrow / highlighttabularcolumn solvers.
			// !important so the highlight beats host table-striping CSS; the color solvers set
			// inline-important styles which in turn beat these (inline-important > stylesheet-important).
			+ ' .pict-tabular-row-highlight > td, .pict-tabular-row-highlight > th { background-color: var(--pict-tabular-highlight-color, #FFF3CD) !important; }'
			+ ' td.pict-tabular-column-highlight, th.pict-tabular-column-highlight { background-color: var(--pict-tabular-highlight-color, #FFF3CD) !important; }';

		this.solverOrdinalMap = {};
		// An injected copy gating an ordinal must not gate the same ordinal in a sibling copy, so a gate set
		// while solving a copy is recorded against that copy. A gate set by the form itself stays global,
		// which is what a form that gates its own ordinals has always relied on.
		/** @type {Record<string, Record<string, boolean>>} */
		this.scopedSolverOrdinalMap = {};
		/** @type {string} */
		this.activeSolverScope = '';

		this.setCSSSnippets();
	}

	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;
		this.pict.CSSMap.addCSS('Pict-Section-Form-SolverBehaviors', this.cssSnippet, 1001, 'Pict-DynamicForm-SolverBehaviors');
		this.pict.CSSMap.injectCSS();
	}

	addSolverFunction(pExpressionParser, pFunctionName, pFunctionAddress, pFunctionComment, pAddressParameterIndices)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		if (pExpressionParser.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`PictDynamicFormsInformary: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		let tmpFunctionEntry = (
		{
			Name: pFunctionComment || `Autogenerated function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});
		if (Array.isArray(pAddressParameterIndices) && pAddressParameterIndices.length > 0)
		{
			tmpFunctionEntry.AddressParameterIndices = pAddressParameterIndices;
		}
		pExpressionParser.functionMap[tmpFunctionName] = tmpFunctionEntry;
	}

	runSolvers()
	{
		const tmpViewHashes = this.pict.providers.DynamicSolver.solveViews(undefined, true);
		/* TODO: since this is always run from a solve, I don't think we need to do an extra marshal here
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			for (let i = 0; i < tmpViewHashes.length; i++)
			{
				const tmpViewHash = tmpViewHashes[i];
				this.pict.views[tmpViewHash]?.marshalToView?.();
			}
		}
		*/
	}

	injectBehaviors(pExpressionParser)
	{
		// Wire up the solver functions.
		this.addSolverFunction(pExpressionParser, 'logvalues', 'fable.providers.DynamicFormSolverBehaviors.logValues', 'Logs a set of values to the console and returns the last one.');

		this.addSolverFunction(pExpressionParser, 'unionarrays', 'fable.providers.DynamicFormSolverBehaviors.unionArrays', 'Return the union of two arrays.');
		this.addSolverFunction(pExpressionParser, 'differencearrays', 'fable.providers.DynamicFormSolverBehaviors.differenceArrays', 'Return the difference of two arrays.');
		this.addSolverFunction(pExpressionParser, 'uniquearray', 'fable.providers.DynamicFormSolverBehaviors.uniqueArray', 'Return a new array with only unique values from the input array.');
		this.addSolverFunction(pExpressionParser, 'sortarray', 'fable.providers.DynamicFormSolverBehaviors.sortArray', 'Returns a sorted array from the input array.');

		this.addSolverFunction(pExpressionParser, 'showsections', 'fable.providers.DynamicFormSolverBehaviors.showSections', 'Shows sections based on hashes in an array.', [0]);
		this.addSolverFunction(pExpressionParser, 'hidesections', 'fable.providers.DynamicFormSolverBehaviors.hideSections', 'Hides sections based on hashes in an array.', [0]);

		this.addSolverFunction(pExpressionParser, 'setsectionvisibility', 'fable.providers.DynamicFormSolverBehaviors.setSectionVisibility', 'Sets a sections visiblity to true or fales based on the second parameter.', [0]);
		this.addSolverFunction(pExpressionParser, 'setgroupvisibility', 'fable.providers.DynamicFormSolverBehaviors.setGroupVisibility', 'Sets a group visiblity to true or fales based on the third parameter.', [0, 1]);

		this.addSolverFunction(pExpressionParser, 'generatehtmlhexcolor', 'fable.providers.DynamicFormSolverBehaviors.generateHTMLHexColor', 'Generates a HTML hex color from three integer parameters (red, green, blue).');

		this.addSolverFunction(pExpressionParser, 'colorsectionbackground', 'fable.providers.DynamicFormSolverBehaviors.colorSectionBackground', 'Colors a section background with a HTML hex color (e.g. #FF0000 for red).', [0]);
		this.addSolverFunction(pExpressionParser, 'colorgroupbackground', 'fable.providers.DynamicFormSolverBehaviors.colorGroupBackground', 'Colors a group background with a HTML hex color (e.g. #FF0000 for red).', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colorinputbackground', 'fable.providers.DynamicFormSolverBehaviors.colorInputBackground', 'Colors an input background with a HTML hex color (e.g. #FF0000 for red).', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colorinputbackgroundtabular', 'fable.providers.DynamicFormSolverBehaviors.colorInputBackgroundTabular', 'Colors a tabular input background with a HTML hex color (e.g. #FF0000 for red).', [0, 1, 2]);

		// Whole-row and whole-column highlight/color for tabular groups. The highlight pair toggles a
		// CSS class across every cell of a row/column based on a 1/0 flag; the color pair sets (1) or
		// clears (0) an inline background color. None of these touch form data -- purely presentational.
		this.addSolverFunction(pExpressionParser, 'highlighttabularrow', 'fable.providers.DynamicFormSolverBehaviors.highlightTabularRow', 'Adds (1) or removes (0) a highlight class on every cell of a tabular row.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'highlighttabularcolumn', 'fable.providers.DynamicFormSolverBehaviors.highlightTabularColumn', 'Adds (1) or removes (0) a highlight class on every cell of a tabular column.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colortabularrow', 'fable.providers.DynamicFormSolverBehaviors.colorTabularRow', 'Sets (1) or clears (0) the background color on every cell of a tabular row.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colortabularcolumn', 'fable.providers.DynamicFormSolverBehaviors.colorTabularColumn', 'Sets (1) or clears (0) the background color on every cell of a tabular column.', [0, 1]);

		this.addSolverFunction(pExpressionParser, 'setsolverordinalenabled', 'fable.providers.DynamicFormSolverBehaviors.setSolverOrdinalEnabled', 'Enables or disabled a solver ordinal to determine if it should run.');
		this.addSolverFunction(pExpressionParser, 'enablesolverordinal', 'fable.providers.DynamicFormSolverBehaviors.enableSolverOrdinal', 'Enables a solver ordinal so that it can run.');
		this.addSolverFunction(pExpressionParser, 'disablesolverordinall', 'fable.providers.DynamicFormSolverBehaviors.disableSolverOrdinal', 'Disables a solver ordinal so that it will not run.');

		this.addSolverFunction(pExpressionParser, 'settabularrowlength', 'fable.providers.DynamicFormSolverBehaviors.setTabularRowLength', 'Sets the length of a tabular data set.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'runsolvers', 'fable.providers.DynamicFormSolverBehaviors.runSolvers', 'Solves all views.');
		this.addSolverFunction(pExpressionParser, 'refreshtabularsection', 'fable.providers.DynamicFormSolverBehaviors.refreshTabularSection', 'Causes a tabular section to refresh its display.', [0, 1]);

		// Scope data access functions for cross-section and global data resolution
		this.addSolverFunction(pExpressionParser, 'getglobalformdata', 'fable.providers.DynamicFormSolverBehaviors.getGlobalFormData', 'Gets a value from the global form data by hash.');
		this.addSolverFunction(pExpressionParser, 'resolveglobalformdata', 'fable.providers.DynamicFormSolverBehaviors.resolveGlobalFormData', 'Resolves a value from the global form data by manyfest address.');
		this.addSolverFunction(pExpressionParser, 'getsectionformdata', 'fable.providers.DynamicFormSolverBehaviors.getSectionFormData', 'Gets a value from a specific section by hash or address.', [0]);
		this.addSolverFunction(pExpressionParser, 'getsectiontabularformdata', 'fable.providers.DynamicFormSolverBehaviors.getSectionTabularFormData', 'Gets a value from a specific tabular section row by hash or address.', [0, 1]);

		// Comprehension generation -- writes a single Property/Value into the configured comprehension destination
		// nested as Context -> Entity -> GUID -> Property.  Context is treated as a manyfest address so dotted
		// contexts like "OnApprovalAction.Approve" produce nested context branches.  See docs/Comprehensions.md.
		this.addSolverFunction(pExpressionParser, 'addcomprehensionentity', 'fable.providers.DynamicFormSolverBehaviors.addComprehensionEntity', 'Writes a property/value into the configured comprehension destination, nested as Context -> Entity -> GUID -> Property.');

		return false;
	}

	// TODO: These array functions probably belong in fable as core utilities; move them back later
	/**
	 * Returns a new array containing the union of two input arrays, removing duplicate values.
	 *
	 * @param {Array} pArrayA - The first array to union.
	 * @param {Array} pArrayB - The second array to union.
	 * @returns {Array} A new array containing unique elements from both input arrays.
	 */
	unionArrays(pArrayA, pArrayB)
	{
		let tmpSet = new Set();

		if (Array.isArray(pArrayA))
		{
			for (let i = 0; i < pArrayA.length; i++)
			{
				tmpSet.add(pArrayA[i]);
			}
		}

		if (Array.isArray(pArrayB))
		{
			for (let i = 0; i < pArrayB.length; i++)
			{
				tmpSet.add(pArrayB[i]);
			}
		}

		return Array.from(tmpSet);
	}

	/**
	 * Returns an array containing the elements that are present in the first array but not in the second array.
	 *
	 * @param {Array} pArrayA - The array from which to subtract elements.
	 * @param {Array} pArrayB - The array containing elements to exclude from the first array.
	 * @returns {Array} An array of elements found in pArrayA but not in pArrayB.
	 */
	differenceArrays(pArrayA, pArrayB)
	{
		let tmpSetA = new Set();
		let tmpSetB = new Set();

		if (Array.isArray(pArrayA))
		{
			for (let i = 0; i < pArrayA.length; i++)
			{
				tmpSetA.add(pArrayA[i]);
			}
		}

		if (Array.isArray(pArrayB))
		{
			for (let i = 0; i < pArrayB.length; i++)
			{
				tmpSetB.add(pArrayB[i]);
			}
		}

		let tmpResultSet = new Set();

		tmpSetA.forEach(
			(pValue) =>
			{
				if (!tmpSetB.has(pValue))
				{
					tmpResultSet.add(pValue);
				}
			}
		);

		return Array.from(tmpResultSet);
	}

	/**
	 * Returns a new array containing only the unique elements from the input array.
	 *
	 * @param {Array} pArray - The array from which to extract unique elements.
	 * @returns {Array} A new array with duplicate values removed.
	 */
	uniqueArray(pArray)
	{
		let tmpSet = new Set();

		if (Array.isArray(pArray))
		{
			for (let i = 0; i < pArray.length; i++)
			{
				tmpSet.add(pArray[i]);
			}
		}

		return Array.from(tmpSet);
	}

	/**
	 * Sorts the given array in place using the default sort order.
	 * If the input is not an array, returns an empty array.
	 *
	 * @param {Array} pArray - The array to be sorted.
	 * @returns {Array} The sorted array, or an empty array if input is not an array.
	 */
	sortArray(pArray)
	{
		if (!Array.isArray(pArray))
		{
			return [];
		}

		return pArray.sort();
	}

	/**
	 * The copy a view belongs to: the salt createDistinctManifest appended to its section hash, or an empty
	 * string for a section the form declares itself.
	 *
	 * @param {any} pView - A dynamic form view.
	 *
	 * @return {string} The scope gates set while solving that view are recorded against.
	 */
	getViewSolverScope(pView)
	{
		const tmpSection = pView ? pView.sectionDefinition : undefined;
		if (!tmpSection || !tmpSection.OriginalHash || !tmpSection.Hash || (tmpSection.Hash === tmpSection.OriginalHash))
		{
			return '';
		}
		return tmpSection.Hash.substring(tmpSection.OriginalHash.length + 1);
	}

	/**
	 * Records which copy's solvers are running, so a gate one of them sets lands on that copy.
	 *
	 * @param {string} pScope - A scope from getViewSolverScope.
	 *
	 * @return {string} The scope that was active before, to restore afterwards.
	 */
	setActiveSolverScope(pScope)
	{
		const tmpPreviousScope = this.activeSolverScope;
		this.activeSolverScope = pScope || '';
		return tmpPreviousScope;
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 * @param {boolean} pEnabled
	 */
	writeSolverOrdinalGate(pSolverOrdinal, pEnabled)
	{
		const tmpOrdinalKey = `ORD-${pSolverOrdinal}`;
		if (!this.activeSolverScope)
		{
			this.solverOrdinalMap[tmpOrdinalKey] = pEnabled;
			return;
		}
		if (!this.scopedSolverOrdinalMap[this.activeSolverScope])
		{
			this.scopedSolverOrdinalMap[this.activeSolverScope] = {};
		}
		this.scopedSolverOrdinalMap[this.activeSolverScope][tmpOrdinalKey] = pEnabled;
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 * @param {boolean|string|number} pEnabled
	 */
	setSolverOrdinalEnabled(pSolverOrdinal, pEnabled)
	{
		this.writeSolverOrdinalGate(pSolverOrdinal, pEnabled == true || pEnabled == '1');
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 */
	enableSolverOrdinal(pSolverOrdinal)
	{
		this.writeSolverOrdinalGate(pSolverOrdinal, true);
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 */
	disableSolverOrdinal(pSolverOrdinal)
	{
		this.writeSolverOrdinalGate(pSolverOrdinal, false);
	}

	/**
	 * @param {number|string} pSolveOrdinal
	 * @param {string} [pScope] - The copy being solved; without one only the form's own gates apply.
	 *
	 * @return {boolean}
	 */
	checkSolverOrdinalEnabled(pSolveOrdinal, pScope)
	{
		let tmpOrdinalKey = `ORD-${pSolveOrdinal}`;
		if ((tmpOrdinalKey in this.solverOrdinalMap) && (this.solverOrdinalMap[tmpOrdinalKey] !== true))
		{
			return false;
		}
		const tmpScopedGates = pScope ? this.scopedSolverOrdinalMap[pScope] : undefined;
		if (tmpScopedGates && (tmpOrdinalKey in tmpScopedGates) && (tmpScopedGates[tmpOrdinalKey] !== true))
		{
			return false;
		}
		return true;
	}

	getSectionSelector(pSectionFormID)
	{
		return `#SECTION-${pSectionFormID}`;
	}

	setSectionVisibility(pSectionHash, pVisible)
	{
		if (pVisible != "0")
		{
			return this.showSection(pSectionHash);
		}
		else
		{
			return this.hideSection(pSectionHash);
		}
	}

	/**
	 * Shows multiple sections by their hash identifiers.
	 *
	 * Iterates over the provided array of section hash values and calls `showSection`
	 * for each one to display the corresponding section.
	 *
	 * @param {string | Array<string>} pSectionHashArray - An array of section hash strings to be shown.
	 */
	showSections(pSectionHashArray)
	{
		const tmpSectionHashArray = Array.isArray(pSectionHashArray) ? pSectionHashArray : [pSectionHashArray];
		for (let i = 0; i < tmpSectionHashArray.length; i++)
		{
			this.showSection(tmpSectionHashArray[i]);
		}
	}

	/**
	 * Hides multiple sections specified by their hash values.
	 *
	 * Iterates over the provided array of section hashes and hides each section
	 * by calling the `hideSection` method for each hash.
	 *
	 * @param {string | Array<string>} pSectionHashArray - An array of section hash strings to be hidden.
	 */
	hideSections(pSectionHashArray)
	{
		const tmpSectionHashArray = Array.isArray(pSectionHashArray) ? pSectionHashArray : [pSectionHashArray];
		for (let i = 0; i < tmpSectionHashArray.length; i++)
		{
			this.hideSection(tmpSectionHashArray[i]);
		}
	}

	/* THESE DO NOT BELONG HERE BUT THIS WORKS FOR NOW */
	hideSection(pSectionHash)
	{
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: hideSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		// Record BEFORE the DOM guard below: the guard short-circuits when the DOM already matches, and
		// the state map has to stay accurate even then so a later render can restore it.
		this.sectionVisibilityState[pSectionHash] = false;

		if (this.pict.ContentAssignment.hasClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass))
		{
			// Already hidden.
			return true;
		}

		this.pict.ContentAssignment.addClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass);
		return true;
	}

	showSection(pSectionHash)
	{
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: showSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		this.sectionVisibilityState[pSectionHash] = true;

		if (!this.pict.ContentAssignment.hasClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass))
		{
			// Already visible.
			return true;
		}

		this.pict.ContentAssignment.removeClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass);
		return true;
	}

	getGroupSelector(pSectionFormID, pGroupHash)
	{
		return `#GROUP-${pSectionFormID}-${pGroupHash}`;
	}

	setGroupVisibility(pSectionHash, pGroupHash, pVisible)
	{
		if (pVisible != "0")
		{
			return this.showGroup(pSectionHash, pGroupHash);
		}
		else
		{
			return this.hideGroup(pSectionHash, pGroupHash);
		}
	}

	hideGroup(pSectionHash, pGroupHash)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: hideGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		this.groupVisibilityState[this.getGroupVisibilityStateKey(pSectionHash, pGroupHash)] = false;

		if (this.pict.ContentAssignment.hasClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass))
		{
			// Already hidden.
			return true;
		}

		this.pict.ContentAssignment.addClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass);
		return true;
	}

	showGroup(pSectionHash, pGroupHash)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		this.groupVisibilityState[this.getGroupVisibilityStateKey(pSectionHash, pGroupHash)] = true;

		if (!this.pict.ContentAssignment.hasClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass))
		{
			// Already visible.
			return true;
		}

		this.pict.ContentAssignment.removeClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass);
		return true;
	}

	/**
	 * @param {string} pSectionHash
	 * @param {string} pGroupHash
	 *
	 * @return {string} - The groupVisibilityState key for a section/group pair.
	 */
	getGroupVisibilityStateKey(pSectionHash, pGroupHash)
	{
		return `${pSectionHash}::${pGroupHash}`;
	}

	/**
	 * Re-apply a section's recorded visibility (and that of its groups) after a render regenerated its DOM.
	 *
	 * Every render path -- DynamicColumns rebuild, dependent-view rebuild, row add/delete/move, the
	 * group-scoped swap in renderGroupInPlace -- repaints those elements with only their manifest
	 * CSSClass, and solvers run BEFORE the marshal that triggers them, so nothing else puts the hide
	 * back. Called from the view's onAfterRender so one restore covers them all. A section with no
	 * recorded state is left as the template rendered it.
	 *
	 * @param {string} pSectionHash - The section that was just rendered.
	 *
	 * @return {void}
	 */
	reapplySectionVisibility(pSectionHash)
	{
		if (typeof pSectionHash !== 'string' || pSectionHash.length < 1)
		{
			return;
		}

		if (pSectionHash in this.sectionVisibilityState)
		{
			this.setSectionVisibility(pSectionHash, this.sectionVisibilityState[pSectionHash] ? 1 : 0);
		}

		const tmpGroupKeyPrefix = `${pSectionHash}::`;
		const tmpGroupKeys = Object.keys(this.groupVisibilityState);
		for (let i = 0; i < tmpGroupKeys.length; i++)
		{
			if (tmpGroupKeys[i].indexOf(tmpGroupKeyPrefix) !== 0)
			{
				continue;
			}
			const tmpGroupHash = tmpGroupKeys[i].substring(tmpGroupKeyPrefix.length);
			this.setGroupVisibility(pSectionHash, tmpGroupHash, this.groupVisibilityState[tmpGroupKeys[i]] ? 1 : 0);
		}
	}

	/**
	 * Remember a DOM decoration a solver just applied so it can be replayed after a render.
	 *
	 * @param {string} pSectionHash - The section the decoration targets.
	 * @param {string} pKey - Stable identity for what is decorated; a repeat overwrites it.
	 * @param {string} pMethod - The method on this provider that applies it.
	 * @param {Array<any>} pArguments - The arguments to replay it with.
	 *
	 * @return {void}
	 */
	recordDecoration(pSectionHash, pKey, pMethod, pArguments)
	{
		if (this.decorationReplayInProgress)
		{
			return;
		}
		this.decorationState[`${pSectionHash}::${pKey}`] = { Section: pSectionHash, Method: pMethod, Arguments: pArguments };
	}

	/**
	 * Replay every decoration recorded against a section after a render repainted its markup.
	 *
	 * Highlight classes and inline colors live on rows, cells and containers that the section
	 * template regenerates, exactly like the hide classes. Replay is idempotent: each entry is
	 * keyed by its target, and a recorded "remove" simply re-runs a removal against fresh markup.
	 *
	 * @param {string} pSectionHash - The section that was just rendered.
	 *
	 * @return {void}
	 */
	reapplySectionDecorations(pSectionHash)
	{
		if (typeof pSectionHash !== 'string' || pSectionHash.length < 1)
		{
			return;
		}

		const tmpKeys = Object.keys(this.decorationState);
		this.decorationReplayInProgress = true;
		try
		{
			for (let i = 0; i < tmpKeys.length; i++)
			{
				const tmpEntry = this.decorationState[tmpKeys[i]];
				if (!tmpEntry || (tmpEntry.Section !== pSectionHash) || (typeof this[tmpEntry.Method] !== 'function'))
				{
					continue;
				}
				this[tmpEntry.Method].apply(this, tmpEntry.Arguments);
			}
		}
		finally
		{
			this.decorationReplayInProgress = false;
		}
	}

	/**
	 * Restore everything a solver put on this section's DOM that a render just wiped -- visibility
	 * first, then decorations. This is what the section view calls from its own onAfterRender.
	 *
	 * @param {string} pSectionHash - The section that was just rendered.
	 *
	 * @return {void}
	 */
	reapplySectionDOMState(pSectionHash)
	{
		this.reapplySectionVisibility(pSectionHash);
		this.reapplySectionDecorations(pSectionHash);
	}

	/**
	 * Re-render a single group in place, leaving the rest of the section's DOM untouched.
	 *
	 * The section template is one string (wrap/section prefixes + every group's
	 * generateGroupLayoutTemplate + postfixes), so a normal render rebuilds all of it.
	 * This regenerates just the requested group's slice and swaps that one element.
	 *
	 * Init is then run the normal way (the view's own post-render pass) rather than being
	 * hand-scoped: input providers guard their own re-initialization (a select2 picker
	 * checks for an existing instance before creating one), so untouched groups no-op and
	 * only the freshly-rendered group actually initializes.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The section view.
	 * @param {string} pGroupHash - The group to re-render.
	 * @return {boolean} - True if the group was rendered in place; false to fall back to a full render.
	 */
	renderGroupInPlace(pView, pGroupHash)
	{
		try
		{
			if (!pView || !pView.formID || (typeof pView.getGroupIndexFromHash !== 'function'))
			{
				return false;
			}
			const tmpGroupIndex = pView.getGroupIndexFromHash(pGroupHash);
			if (tmpGroupIndex < 0)
			{
				return false;
			}
			const tmpGroup = pView.getGroup(tmpGroupIndex);
			const tmpGenerator = this.pict.providers.MetatemplateGenerator;
			if (!tmpGroup || !tmpGenerator || (typeof tmpGenerator.getGroupLayoutProvider !== 'function'))
			{
				return false;
			}
			const tmpLayout = tmpGenerator.getGroupLayoutProvider(pView, tmpGroup);
			if (!tmpLayout || (typeof tmpLayout.generateGroupLayoutTemplate !== 'function'))
			{
				return false;
			}
			const tmpElements = this.pict.ContentAssignment.getElement(`#GROUP-${pView.formID}-${tmpGroup.Hash}`);
			const tmpElement = (tmpElements && tmpElements.length) ? tmpElements[0] : null;
			if (!tmpElement || (typeof tmpElement.outerHTML !== 'string'))
			{
				return false;
			}

			// Same parse shape the view uses for the whole section: the view is Context[0],
			// which the group templates reference for formID/UUID/Hash.
			const tmpTemplateHash = `Pict-Form-Template-Group-InPlace-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;
			this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpLayout.generateGroupLayoutTemplate(pView, tmpGroup));
			const tmpRecordAddress = pView.options.DefaultTemplateRecordAddress;
			const tmpRecord = (typeof tmpRecordAddress === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
			const tmpContent = this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, [ pView ]);
			if (typeof tmpContent !== 'string' || !tmpContent.length)
			{
				return false;
			}

			tmpElement.outerHTML = tmpContent;
			pView.onAfterRender({ RenderableHash: `GroupInPlace-${tmpGroup.Hash}` });
			return true;
		}
		catch (pError)
		{
			this.log.warn(`renderGroupInPlace failed for group [${pGroupHash}]; falling back to a full section render: ${pError.message || pError}`);
			return false;
		}
	}

	/**
	 * Causes a tabular section to refresh its display
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group
	 * @param {string} pGroupHash - The hash of the tabular group
	 *
	 * @return {void}
	 */
	refreshTabularSection(pSectionHash, pGroupHash)
	{
		const tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return;
		}
		const tmpGroupIndex = tmpGroupView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return;
		}
		const tmpGroup = tmpGroupView.getGroup(tmpGroupIndex);

		if (tmpGroup)
		{
			// Also render any other views that have this as the RecordSetAddress
			// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
			const tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
				/** @param {import('../views/Pict-View-DynamicForm.js')} pViewToTestForGroup */
				(pViewToTestForGroup) =>
				{
					if (!pViewToTestForGroup.isPictSectionForm)
					{
						return false;
					}
					const tmpGroupsToTest = pViewToTestForGroup.getGroups();
					for (let i = 0; i < tmpGroupsToTest.length; i++)
					{
						if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
						{
							return true;
						}
					}
					return false;
				}
			)
			// We expect this view to be in the set.
			for (let i = 0; i < tmpViewsToRender.length; i++)
			{
				// Re-render ONLY the group that actually changed when we can. A full
				// section render replaces every group's DOM, which destroys any widget
				// the user is mid-interaction with (select2 pickers blank for ~700ms) and
				// drops layout state. Falls back to the full render when the group-scoped
				// path is not possible, so behaviour is unchanged for anything it cannot handle.
				if (!this.renderGroupInPlace(tmpViewsToRender[i], pGroupHash))
				{
					tmpViewsToRender[i].render();
				}
			}

			//NOTE: not running a solve, since this is run from the solver; if you need a solve, call runSolvers()

			// We've re-rendered but we don't know what needs to be marshaled
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
	}

	/**
	 * Set the length of a tabular set
	 * @param {string} pSectionHash - The hash of the section containing the tabular group
	 * @param {string} pGroupHash - The hash of the tabular group
	 * @param {number|string} pLength - The desired length of the tabular set
	 * @param {boolean|string} pDeleteExtraRows - If true, will delete extra rows from the end if the length is less than current 
	 * @returns 
	 */
	setTabularRowLength(pSectionHash, pGroupHash, pLength, pDeleteExtraRows = false)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}
		let tmpGroupIndex = tmpGroupView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}
		let tmpTabularRecordSet = tmpGroupView.getTabularRecordSet(tmpGroupIndex);
		if (!tmpTabularRecordSet || !Array.isArray(tmpTabularRecordSet))
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find a valid tabular record set with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		let tmpLength = parseInt(pLength.toString());
		if (isNaN(tmpLength) || tmpLength < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength was given an invalid length [${pLength}] with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		// See if the length is less than what we have
		let tmpCurrentLength = tmpTabularRecordSet.length;

		let tmpDeleteExtraRows = (pDeleteExtraRows == true || pDeleteExtraRows == '1');

		if (tmpLength > tmpCurrentLength)
		{
			// Add rows until we are at the expected length
			for (let i = tmpCurrentLength; i < tmpLength; i++)
			{
				tmpGroupView.createDynamicTableRow(tmpGroupIndex);
			}
		}
		else if (tmpLength < tmpCurrentLength && tmpDeleteExtraRows)
		{
			// Remove rows from the end until we are at the expected length
			for (let i = tmpCurrentLength - 1; i >= tmpLength; i--)
			{
				tmpGroupView.deleteDynamicTableRow(tmpGroupIndex, i);
			}
		}
	}


	generateHTMLHexColor(pRed, pGreen, pBlue)
	{
		let tmpRed = (parseInt(pRed) || 0);
		let tmpGreen = (parseInt(pGreen) || 0);
		let tmpBlue = (parseInt(pBlue) || 0);

		if (tmpRed < 0) { tmpRed = 0; }
		if (tmpRed > 255) { tmpRed = 255; }
		if (tmpGreen < 0) { tmpGreen = 0; }
		if (tmpGreen > 255) { tmpGreen = 255; }
		if (tmpBlue < 0) { tmpBlue = 0; }
		if (tmpBlue > 255) { tmpBlue = 255; }

		let tmpRedHex = tmpRed.toString(16).toUpperCase();
		if (tmpRedHex.length < 2) { tmpRedHex = `0${tmpRedHex}`; }
		let tmpGreenHex = tmpGreen.toString(16).toUpperCase();
		if (tmpGreenHex.length < 2) { tmpGreenHex = `0${tmpGreenHex}`; }
		let tmpBlueHex = tmpBlue.toString(16).toUpperCase();
		if (tmpBlueHex.length < 2) { tmpBlueHex = `0${tmpBlueHex}`; }

		return `#${tmpRedHex}${tmpGreenHex}${tmpBlueHex}`;
	}

	colorSectionBackground(pSectionHash, pColor, pApplyChange)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, 'sectionbackground', 'colorSectionBackground', [ pSectionHash, pColor, pApplyChange ]);

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(this.getSectionSelector(tmpSectionView.formID));

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorSection could not find section element with hash [${pSectionHash}] selector [${this.getSectionSelector(tmpSectionView.formID)}].`);
			return false;
		}

		let tmpElement = tmpElementSet[0];

		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	colorGroupBackground(pSectionHash, pGroupHash, pColor, pApplyChange)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, `${pGroupHash}::groupbackground`, 'colorGroupBackground', [ pSectionHash, pGroupHash, pColor, pApplyChange ]);

		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(this.getGroupSelector(tmpGroupView.formID, pGroupHash));

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorGroup could not find group element with section hash [${pSectionHash}] group [${pGroupHash}] selector [${this.getGroupSelector(tmpGroupView.formID, pGroupHash)}].`);
			return false;
		}

		let tmpElement = tmpElementSet[0];
		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	/**
	 * Colors an input background or its container with a HTML hex color (e.g. #FF0000 for red).
	 * @param {string} pSectionHash - The hash of the section containing the input.
	 * @param {string} pInputHash - The hash of the input to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} pApplyChange - If "0", the change will not be applied.
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 * @returns {boolean} - Returns true if the color was applied successfully or if the change was skipped for pApplyChange equal to "0", false otherwise.
	 */
	colorInputBackground(pSectionHash, pInputHash, pColor, pApplyChange, pCSSSelector)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, `input::${pInputHash}`, 'colorInputBackground', [ pSectionHash, pInputHash, pColor, pApplyChange, pCSSSelector ]);

		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		let tmpInputView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);

		if (!tmpInputView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input with section hash [${pSectionHash}] input [${pInputHash}].`);
			return false;
		}

		let tmpInput = tmpInputView.getInputFromHash(pInputHash);

		if (!tmpInput)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input with section hash [${pSectionHash}] input [${pInputHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(tmpInput.Macro.HTMLSelectorControl);

		if (tmpElementSet.length < 1)
		{
			tmpElementSet = this.pict.ContentAssignment.getElement(`#${tmpInput.Macro.RawHTMLID}`);
		}

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input element with section hash [${pSectionHash}] input [${pInputHash}] selector [#${tmpInput.Macro.RawHTMLID}].`);
			return false;
		}

		return this.colorElementBackground(tmpElementSet, pColor, pCSSSelector);
	}

	/**
	 * Colors an input background or its container with a HTML hex color (e.g. #FF0000 for red).
	 * @param {string} pSectionHash - The hash of the section containing the input.
	 * @param {string} pGroupHash - The hash of the group containing the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pInputHash - The hash of the input to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} pApplyChange - If "0", the change will not be applied.
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 * @param {string} [pElementIDPrefix] - Optional. The prefix for the tabular element ID. Default is 'TABULAR-DATA-'.
	 * @returns {boolean} - Returns true if the color was applied successfully or if the change was skipped for pApplyChange equal to "0", false otherwise.
	 */
	colorInputBackgroundTabular(pSectionHash, pGroupHash, pInputHash, pRowIndex, pColor, pApplyChange, pCSSSelector, pElementIDPrefix = 'TABULAR-DATA-')
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, `${pGroupHash}::inputcell::${pInputHash}::${pRowIndex}`, 'colorInputBackgroundTabular',
			[ pSectionHash, pGroupHash, pInputHash, pRowIndex, pColor, pApplyChange, pCSSSelector, pElementIDPrefix ]);

		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		let tmpInputView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);

		if (!tmpInputView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}].`);
			return false;
		}

		let tmpInput = tmpInputView.getTabularRecordInputByHash(pGroupHash, pInputHash);

		if (!tmpInput)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}].`);
			return false;
		}

		if (!tmpInput.Macro)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}] is missing Macro data.`);
			return false;
		}

		//FIXME: how do we get the input decorated with the index?
		const tmpControlHTMLSelector = tmpInput.Macro.HTMLSelectorControlTabular + `[data-i-index="${pRowIndex}"]`;
		let tmpElementSet = this.pict.ContentAssignment.getElement(tmpControlHTMLSelector);

		if (tmpElementSet.length < 1)
		{
			//FIXME: is this reliable for all input types? (no)
			tmpElementSet = this.pict.ContentAssignment.getElement(`#${pElementIDPrefix}${tmpInput.Macro.RawHTMLID}-${pRowIndex}`);
		}

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input element with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}] row index [${pRowIndex}] selector [#${tmpInput.Macro.RawHTMLID}-${pRowIndex}].`);
			return false;
		}

		return this.colorElementBackground(tmpElementSet, pColor, pCSSSelector);
	}

	/**
	 * @param {Array<HTMLElement>} pElementSet - The element to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 *
	 * @returns {boolean}
	 */
	colorElementBackground(pElementSet, pColor, pCSSSelector)
	{
		/** @type {HTMLElement} */
		let tmpElement = pElementSet[0];

		// if we passed a class target, find the closest element with that class and apply the color to it
		// otherwise, just apply it to the input element itself
		if (pCSSSelector)
		{
			// find closest target by class name and if we find it, immediately break out of the loop
			for (let i = 0; i < pElementSet.length; i++)
			{
				const element = pElementSet[i];
				const closest = element.closest(`${pCSSSelector}`);
				if (closest && closest instanceof HTMLElement)
				{
					tmpElement = closest;
					break;
				}
			}
		}

		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	/**
	 * Interprets a solver-supplied 1/0 (or true/false) flag.
	 *
	 * Solver numbers arrive as arbitrary-precision strings, so a plain truthiness
	 * check would treat the string "0" as true. This normalizes the common
	 * "off" representations to false and everything else to true.
	 *
	 * @param {any} pFlag
	 * @returns {boolean}
	 */
	isSolverFlagEnabled(pFlag)
	{
		return (pFlag != null)
			&& (pFlag !== false)
			&& (pFlag !== 0)
			&& (pFlag !== '0')
			&& (pFlag !== '')
			&& (pFlag !== 'false');
	}

	/**
	 * Resolves the DOM selector for a tabular group's container div.
	 *
	 * The tabular group div carries `id="GROUP-<formID>-<groupHash>"` (the same
	 * convention the non-tabular group layout uses), so highlight/color solvers
	 * can scope their cell queries to a single group.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @returns {string|null} A CSS selector for the group container, or null if unresolved.
	 */
	getTabularGroupSelector(pSectionHash, pGroupHash)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('PictDynamicFormsSolverBehaviors: getTabularGroupSelector has no PictFormMetacontroller.');
			return null;
		}
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsSolverBehaviors: getTabularGroupSelector could not find section view with hash [${pSectionHash}].`);
			return null;
		}
		return `#GROUP-${tmpSectionView.formID}-${pGroupHash}`;
	}

	/**
	 * Adds (pApplyFlag truthy) or removes (pApplyFlag falsy) a highlight class on
	 * every cell of a tabular row -- the row labels, editing controls and data
	 * cells all get the class because it lands on the row's `<tr>`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The zero-based row index.
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- add or remove the class.
	 * @param {string} [pHighlightClass] - Optional override for the class name.
	 * @returns {boolean}
	 */
	highlightTabularRow(pSectionHash, pGroupHash, pRowIndex, pApplyFlag, pHighlightClass)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpClass = (typeof pHighlightClass === 'string' && pHighlightClass.length > 0) ? pHighlightClass : this.cssTabularRowHighlightClass;
		this.recordDecoration(pSectionHash, `${pGroupHash}::row::${pRowIndex}::${tmpClass}`, 'highlightTabularRow',
			[ pSectionHash, pGroupHash, pRowIndex, pApplyFlag, pHighlightClass ]);
		let tmpRowSelector = `${tmpGroupSelector} tr[data-tabular-row-index="${pRowIndex}"]`;
		if (this.isSolverFlagEnabled(pApplyFlag))
		{
			this.pict.ContentAssignment.addClass(tmpRowSelector, tmpClass);
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpRowSelector, tmpClass);
		}
		return true;
	}

	/**
	 * Adds (pApplyFlag truthy) or removes (pApplyFlag falsy) a highlight class on
	 * every cell of a tabular column -- both the `<th>` header cell and every
	 * `<td>` data cell that carries the matching `data-tabular-column-index`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pColumnIndex - The column's input index (descriptor InputIndex).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- add or remove the class.
	 * @param {string} [pHighlightClass] - Optional override for the class name.
	 * @returns {boolean}
	 */
	highlightTabularColumn(pSectionHash, pGroupHash, pColumnIndex, pApplyFlag, pHighlightClass)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpClass = (typeof pHighlightClass === 'string' && pHighlightClass.length > 0) ? pHighlightClass : this.cssTabularColumnHighlightClass;
		this.recordDecoration(pSectionHash, `${pGroupHash}::column::${pColumnIndex}::${tmpClass}`, 'highlightTabularColumn',
			[ pSectionHash, pGroupHash, pColumnIndex, pApplyFlag, pHighlightClass ]);
		let tmpColumnSelector = `${tmpGroupSelector} [data-tabular-column-index="${pColumnIndex}"]`;
		if (this.isSolverFlagEnabled(pApplyFlag))
		{
			this.pict.ContentAssignment.addClass(tmpColumnSelector, tmpClass);
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpColumnSelector, tmpClass);
		}
		return true;
	}

	/**
	 * Sets (pApplyFlag truthy) or clears (pApplyFlag falsy) an inline background
	 * color on every data cell of a tabular row.
	 *
	 * The color is applied with `important` priority so it beats both host
	 * table-striping CSS and the highlight classes.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The zero-based row index.
	 * @param {string} pColor - The HTML color to apply (e.g. #FF0000).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- apply or clear the color.
	 * @returns {boolean}
	 */
	colorTabularRow(pSectionHash, pGroupHash, pRowIndex, pColor, pApplyFlag)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpApply = this.isSolverFlagEnabled(pApplyFlag) && (typeof pColor === 'string') && (pColor.length > 0);
		this.recordDecoration(pSectionHash, `${pGroupHash}::rowcolor::${pRowIndex}`, 'colorTabularRow',
			[ pSectionHash, pGroupHash, pRowIndex, pColor, pApplyFlag ]);
		let tmpElementSet = this.pict.ContentAssignment.getElement(`${tmpGroupSelector} tr[data-tabular-row-index="${pRowIndex}"] td`);
		for (let i = 0; i < tmpElementSet.length; i++)
		{
			if (tmpApply)
			{
				tmpElementSet[i].style.setProperty('background-color', pColor, 'important');
			}
			else
			{
				tmpElementSet[i].style.removeProperty('background-color');
			}
		}
		return true;
	}

	/**
	 * Sets (pApplyFlag truthy) or clears (pApplyFlag falsy) an inline background
	 * color on every cell of a tabular column -- header `<th>` plus all data `<td>`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pColumnIndex - The column's input index (descriptor InputIndex).
	 * @param {string} pColor - The HTML color to apply (e.g. #FF0000).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- apply or clear the color.
	 * @returns {boolean}
	 */
	colorTabularColumn(pSectionHash, pGroupHash, pColumnIndex, pColor, pApplyFlag)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpApply = this.isSolverFlagEnabled(pApplyFlag) && (typeof pColor === 'string') && (pColor.length > 0);
		this.recordDecoration(pSectionHash, `${pGroupHash}::columncolor::${pColumnIndex}`, 'colorTabularColumn',
			[ pSectionHash, pGroupHash, pColumnIndex, pColor, pApplyFlag ]);
		let tmpElementSet = this.pict.ContentAssignment.getElement(`${tmpGroupSelector} [data-tabular-column-index="${pColumnIndex}"]`);
		for (let i = 0; i < tmpElementSet.length; i++)
		{
			if (tmpApply)
			{
				tmpElementSet[i].style.setProperty('background-color', pColor, 'important');
			}
			else
			{
				tmpElementSet[i].style.removeProperty('background-color');
			}
		}
		return true;
	}

	/**
	 * Gets a value from the global form data by hash, falling back to address resolution
	 * using the global manyfest from the metacontroller.
	 *
	 * @param {string} pHash - The hash to resolve from the global form data.
	 * @returns {any} The value at the hash, or undefined if not found.
	 */
	getGlobalFormData(pHash)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getGlobalFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpMarshalDestination = this.pict.views.PictFormMetacontroller.viewMarshalDestination;
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestination);

		if ((typeof(tmpMarshalDestinationObject) !== 'object') || (tmpMarshalDestinationObject === null))
		{
			tmpMarshalDestinationObject = this.pict.AppData;
		}

		// Use the global pict manifest which has all descriptors added during bootstrapPictFormViewsFromManifest
		return this.pict.manifest.getValueByHash(tmpMarshalDestinationObject, pHash);
	}

	/**
	 * Resolves a value from the global form data by manyfest address,
	 * using the global manyfest from the metacontroller and the viewMarshalDestination.
	 *
	 * @param {string} pAddress - The manyfest address to resolve from the global form data.
	 * @returns {any} The value at the address, or undefined if not found.
	 */
	resolveGlobalFormData(pAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('resolveGlobalFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpMarshalDestination = this.pict.views.PictFormMetacontroller.viewMarshalDestination;
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestination);

		if ((typeof(tmpMarshalDestinationObject) !== 'object') || (tmpMarshalDestinationObject === null))
		{
			tmpMarshalDestinationObject = this.pict.AppData;
		}

		// Use the global pict manifest to resolve the address
		return this.pict.manifest.getValueAtAddress(tmpMarshalDestinationObject, pAddress);
	}

	/**
	 * Gets a value from a specific section's form data by hash or address.
	 *
	 * Uses the section view's sectionManifest and getMarshalDestinationObject
	 * to properly resolve the value within the section's scope.
	 *
	 * @param {string} pSectionHash - The hash of the section to get data from.
	 * @param {string} pHashOrAddress - The hash or address to resolve within the section.
	 * @returns {any} The value at the hash/address, or undefined if not found.
	 */
	getSectionFormData(pSectionHash, pHashOrAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getSectionFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`getSectionFormData: Could not find section view with hash [${pSectionHash}].`);
			return undefined;
		}

		return tmpSectionView.getValueByHash(pHashOrAddress);
	}

	/**
	 * Gets a value from a specific tabular section's row data by hash or address.
	 *
	 * Resolves the tabular record set from the section view, then gets the specific
	 * row's value using the group's supportingManifest.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The index of the row (may be string due to arbitrary precision).
	 * @param {string} pHashOrAddress - The hash or address to resolve within the row.
	 * @returns {any} The value at the hash/address in the row, or undefined if not found.
	 */
	getSectionTabularFormData(pSectionHash, pGroupHash, pRowIndex, pHashOrAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getSectionTabularFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`getSectionTabularFormData: Could not find section view with hash [${pSectionHash}].`);
			return undefined;
		}

		let tmpGroupIndex = tmpSectionView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`getSectionTabularFormData: Could not find group with hash [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		let tmpGroup = tmpSectionView.getGroup(tmpGroupIndex);
		if (!tmpGroup)
		{
			this.log.warn(`getSectionTabularFormData: Could not get group at index ${tmpGroupIndex} in section [${pSectionHash}].`);
			return undefined;
		}

		let tmpTabularRecordSet = tmpSectionView.getTabularRecordSet(tmpGroupIndex);
		if (!tmpTabularRecordSet)
		{
			this.log.warn(`getSectionTabularFormData: Could not find tabular record set for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		// RowIndex may be passed as a string due to arbitrary precision numbers in the solver
		let tmpRowIndex = parseInt(pRowIndex.toString());
		if (isNaN(tmpRowIndex) || tmpRowIndex < 0)
		{
			this.log.warn(`getSectionTabularFormData: Invalid row index [${pRowIndex}] for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		if (tmpRowIndex >= tmpTabularRecordSet.length)
		{
			this.log.warn(`getSectionTabularFormData: Row index [${tmpRowIndex}] out of bounds for group [${pGroupHash}] in section [${pSectionHash}] (length ${tmpTabularRecordSet.length}).`);
			return undefined;
		}
		let tmpRecord = tmpTabularRecordSet[tmpRowIndex];

		if (!tmpRecord || typeof(tmpRecord) !== 'object')
		{
			this.log.warn(`getSectionTabularFormData: No valid record at row index [${tmpRowIndex}] for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		// Use the group's supporting manifest to resolve the value
		if (tmpGroup.supportingManifest)
		{
			return tmpGroup.supportingManifest.getValueByHash(tmpRecord, pHashOrAddress);
		}

		// Fallback to direct property access if no supporting manifest
		if (pHashOrAddress in tmpRecord)
		{
			return tmpRecord[pHashOrAddress];
		}

		return undefined;
	}

	logValues()
	{
		let tmpLastValue = null;
		let tmpLogLine = 'Solver logvalues call: ';
		for (let i = 0; i < arguments.length; i++)
		{
			tmpLastValue = arguments[i];
			tmpLogLine += `  [${i}]=[${tmpLastValue}]`;
		}
		this.log.info(tmpLogLine);
		return tmpLastValue;
	}

	/**
	 * Resolves the comprehension destination object, creating intermediate objects along the configured
	 * address if they don't exist.  The address is read from
	 * `PictFormMetacontroller.comprehensionDestinationAddress` (default `AppData.FormEntityComprehensions`)
	 * and resolved against the pict instance, so callers can target any subtree (`AppData.*`, `Bundle.*`, ...).
	 *
	 * @returns {Record<string, any>|null} The destination object (mutable), or null if the address resolves
	 * to a non-object value the function can't safely write into (e.g. a number).
	 */
	resolveComprehensionDestination()
	{
		let tmpAddress = 'AppData.FormEntityComprehensions';
		if (this.pict.views.PictFormMetacontroller && typeof this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress === 'string'
			&& this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress.length > 0)
		{
			tmpAddress = this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress;
		}

		let tmpExisting = this.pict.resolveStateFromAddress(tmpAddress);
		if (tmpExisting && typeof tmpExisting === 'object')
		{
			return tmpExisting;
		}
		if (tmpExisting != null && typeof tmpExisting !== 'object')
		{
			this.log.warn(`addComprehensionEntity: comprehension destination [${tmpAddress}] resolves to a non-object value; refusing to overwrite.`);
			return null;
		}

		// The address is empty -- materialize an object there.  setStateValueAtAddress walks the
		// address creating intermediate objects on the way.
		this.pict.setStateValueAtAddress(tmpAddress, null, {});
		return this.pict.resolveStateFromAddress(tmpAddress);
	}

	/**
	 * Writes a single property/value into the configured comprehension destination, nested as
	 * `Context -> Entity -> GUID -> Property = Value`.
	 *
	 * `Context` is a manyfest address (dot-separated) so dotted contexts like
	 * `OnApprovalAction.Approve` produce nested context branches.  `Entity`, `GUID`, and `Property`
	 * are treated as opaque property names -- dots in them are NOT interpreted as nesting (so an
	 * entity GUID like `0x73278432987` lands as a single key).
	 *
	 * Successive calls to the same `(Context, Entity, GUID)` accumulate properties on the same
	 * record.  Successive calls to the same `(Context, Entity, GUID, Property)` overwrite.
	 *
	 * The destination address is configured on the metacontroller via
	 * `comprehensionDestinationAddress` (default `AppData.FormEntityComprehensions`) -- see
	 * `docs/Comprehensions.md`.
	 *
	 * @param {string} pContext - The comprehension context address (e.g. `"OnSave"`, `"OnApprovalAction.Approve"`).
	 * @param {string} pEntity - The entity name (e.g. `"Book"`).
	 * @param {string} pGUID - The external GUID for the record (e.g. `"0x73278432987"`).
	 * @param {string} pProperty - The property to set on the record (e.g. `"Title"`).
	 * @param {any} pValue - The value to write.
	 *
	 * @returns {any} `pValue` on success, `undefined` if the call was a no-op (invalid args / unwritable destination).
	 */
	addComprehensionEntity(pContext, pEntity, pGUID, pProperty, pValue)
	{
		// Every part of the path must be a non-empty stringifiable identifier -- silently swallowing
		// missing parts would write the comprehension into the wrong place under a literal "undefined"
		// key.  Warn and bail instead.
		if (pContext == null || pEntity == null || pGUID == null || pProperty == null)
		{
			this.log.warn(`addComprehensionEntity: ignoring call with null/undefined parts (Context=[${pContext}], Entity=[${pEntity}], GUID=[${pGUID}], Property=[${pProperty}]).`);
			return undefined;
		}

		let tmpContext = String(pContext);
		let tmpEntity = String(pEntity);
		let tmpGUID = String(pGUID);
		let tmpProperty = String(pProperty);

		if (tmpContext.length < 1 || tmpEntity.length < 1 || tmpGUID.length < 1 || tmpProperty.length < 1)
		{
			this.log.warn(`addComprehensionEntity: ignoring call with empty parts (Context=[${tmpContext}], Entity=[${tmpEntity}], GUID=[${tmpGUID}], Property=[${tmpProperty}]).`);
			return undefined;
		}

		let tmpDestination = this.resolveComprehensionDestination();
		if (!tmpDestination)
		{
			return undefined;
		}

		// Walk the context path manually so we don't have to worry about manyfest's address parsing
		// for the entity/GUID/property keys (which may contain characters like '0x...' that are fine
		// as keys but unusual as addresses).
		let tmpContextParts = tmpContext.split('.');
		let tmpCursor = tmpDestination;
		for (let i = 0; i < tmpContextParts.length; i++)
		{
			let tmpKey = tmpContextParts[i];
			if (tmpKey.length < 1)
			{
				continue;
			}
			if (!tmpCursor[tmpKey] || typeof tmpCursor[tmpKey] !== 'object')
			{
				tmpCursor[tmpKey] = {};
			}
			tmpCursor = tmpCursor[tmpKey];
		}

		if (!tmpCursor[tmpEntity] || typeof tmpCursor[tmpEntity] !== 'object')
		{
			tmpCursor[tmpEntity] = {};
		}
		let tmpEntityBucket = tmpCursor[tmpEntity];

		if (!tmpEntityBucket[tmpGUID] || typeof tmpEntityBucket[tmpGUID] !== 'object')
		{
			tmpEntityBucket[tmpGUID] = {};
		}
		tmpEntityBucket[tmpGUID][tmpProperty] = pValue;

		return pValue;
	}
}

module.exports = PictDynamicFormsSolverBehaviors;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],500:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Input",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicInput class is a provider that manages data brokering and provider mappings for dynamic inputs.
 */
class PictDynamicInput extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicInput class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		// A map of strings for each input template, mapping it to arrays of default providers.
		this.templateProviderMap = {};
		/** @type {Record<string, boolean>} */
		this.ignoredEventHashes = {};
	}

	/**
	 * @param {string} pEventHash
	 */
	registerIgnoredEventHash(pEventHash)
	{
		this.ignoredEventHashes[pEventHash] = true;
	}

	/**
	 * Retrieves the template hash for the input based on the provided view and input.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {any} pInput - The input object.
	 * @returns {string|boolean} - The template hash if found, otherwise false.
	 */
	getInputTemplateHash(pView, pInput)
	{
		if (pInput.IsTabular)
		{
			let tmpTemplateBeginInputTypePostfix = `-TabularTemplate-Begin-Input-InputType-${pInput.PictForm.InputType}`;
			let tmpTemplateEndInputTypePostfix = `-TabularTemplate-End-Input-InputType-${pInput.PictForm.InputType}`;

			let tmpTemplateBeginDataTypePostfix = `-TabularTemplate-Begin-Input-DataType-${pInput.DataType}`;
			let tmpTemplateEndDataTypePostfix = `-TabularTemplate-End-Input-DataType-${pInput.DataType}`;
			if (pView.checkViewSpecificTemplate(tmpTemplateBeginInputTypePostfix) && pView.checkViewSpecificTemplate(tmpTemplateEndInputTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateBeginInputTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateBeginInputTypePostfix) && pView.checkThemeSpecificTemplate(tmpTemplateEndInputTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateBeginInputTypePostfix);
			}
			else if (pView.checkViewSpecificTemplate(tmpTemplateBeginDataTypePostfix) && pView.checkViewSpecificTemplate(tmpTemplateEndDataTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateBeginDataTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateBeginDataTypePostfix) && pView.checkThemeSpecificTemplate(tmpTemplateEndDataTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateBeginDataTypePostfix);
			}
		}
		else
		{
			let tmpTemplateInputTypePostfix = `-Template-Input-InputType-${pInput.PictForm.InputType}`;
			let tmpTemplateDataTypePostfix = `-Template-Input-DataType-${pInput.DataType}`;
			if (pView.checkViewSpecificTemplate(tmpTemplateInputTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateInputTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateInputTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateInputTypePostfix);
			}
			else if (pView.checkViewSpecificTemplate(tmpTemplateDataTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateDataTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateDataTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateDataTypePostfix);
			}
		}
		return false;
	}

	/**
	 * Adds a default input provider for a given template full hash.
	 *
	 * @param {string} pTemplateFullHash - The full hash of the template.
	 * @param {any} pProvider - The provider to be added.
	 */
	addDefaultInputProvider(pTemplateFullHash, pProvider)
	{
		if (!(pTemplateFullHash in this.templateProviderMap))
		{
			this.templateProviderMap[pTemplateFullHash] = [];
		}
		if (this.templateProviderMap[pTemplateFullHash].indexOf(pProvider) < 0)
		{
			this.templateProviderMap[pTemplateFullHash].push(pProvider);
		}
	}

	/**
	 * Retrieves the default input providers based on the given view and input.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {string} pInput - The input to retrieve input providers for.
	 * @returns {Array} An array of default input providers.
	 */
	getDefaultInputProviders(pView, pInput)
	{
		let tmpTemplateHash = this.getInputTemplateHash(pView, pInput);
		if (tmpTemplateHash && this.templateProviderMap[tmpTemplateHash])
		{
			return this.templateProviderMap[tmpTemplateHash];
		}
		return [];
	}
}

module.exports = PictDynamicInput;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],501:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-InputEvents",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicInputEvents class is a provider that manages data brokering and provider mappings for dynamic inputs.
 */
class PictDynamicInputEvents extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicInputEvents class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Requests input data from the view based on the provided input hash.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pInputHash - The input hash.
	 * @param {any} [pEvent] - The input event.
	 */
	inputDataRequest(pView, pInputHash, pEvent)
	{
		if (pInputHash)
		{
			let tmpInput = pView.getInputFromHash(pInputHash);
			if (pEvent)
			{
				let tmpFormattedEvent;
				if (typeof pEvent === 'string')
				{
					tmpFormattedEvent = pEvent;
				}
				else
				{
					if (pEvent.namespace)
					{
						tmpFormattedEvent = `${pEvent.type}.${pEvent.namespace}`;
					}
					else
					{
						tmpFormattedEvent = pEvent.type;
					}
				}
				if (this.pict.providers.DynamicInput.ignoredEventHashes[tmpFormattedEvent])
				{
					return;
				}
			}
			let tmpHashAddress = pView.sectionManifest.resolveHashAddress(pInputHash);
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onDataRequest(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector);
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] inputDataRequest cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error running inputDataRequest specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find input hash [${pInputHash}] for inputDataRequest event.`);
		}
	}

	/**
	 * Handles the input event for a dynamic form.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pInputHash - The input hash.
	 * @param {string} pEvent - The input event.
	 * @param {string} [pTransactionGUID] - (optional) The active transaction GUID.
	 */
	inputEvent(pView, pInputHash, pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof pTransactionGUID === 'string') ? pTransactionGUID : this.pict.getUUID();
		let tmpInput = pView.getInputFromHash(pInputHash);
		if (pInputHash)
		{
			let tmpHashAddress = pView.sectionManifest.resolveHashAddress(pInputHash);
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						// we may find uninitialized inputs here, so we do not send events to those
						if (tmpInput.Macro)
						{
							pView.pict.providers[tmpInputProviderList[i]].onEvent(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, pEvent, tmpTransactionGUID);
							pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
							{
								pView.pict.providers[tmpInputProviderList[i]].onAfterEventCompletion(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, pEvent, tmpTransactionGUID);
							});
						}
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] inputEvent ${pEvent} cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
				if (pTransactionGUID !== tmpTransactionGUID)
				{
					// since we synthesized this transaction, finalize it
					pView.finalizeTransaction(tmpTransactionGUID);
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error running inputEvent ${pEvent} specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find input hash [${pInputHash}] for inputEvent ${pEvent} event.`);
		}
	}

	/**
	 * Requests input data for a tabular record.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} [pEvent] - The input event.
	 */
	inputDataRequestTabular(pView, pGroupIndex, pInputIndex, pRowIndex, pEvent)
	{
		let tmpInput = pView.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (pGroupIndex && pInputIndex && pRowIndex && tmpInput)
		{
			if (pEvent)
			{
				let tmpFormattedEvent;
				if (typeof pEvent === 'string')
				{
					tmpFormattedEvent = pEvent;
				}
				else
				{
					if (pEvent.namespace)
					{
						tmpFormattedEvent = `${pEvent.type}.${pEvent.namespace}`;
					}
					else
					{
						tmpFormattedEvent = pEvent.type;
					}
				}
				if (this.pict.providers.DynamicInput.ignoredEventHashes[tmpFormattedEvent])
				{
					return;
				}
			}
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				// TODO: Can we simplify pView?
				let tmpValueAddress = pView.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);

				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular+`[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onDataRequestTabular(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex);
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error marshaling specific (${pGroupIndex} | ${pInputIndex} | ${pRowIndex}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			// pView is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.
			pView.marshalFromView();
		}
	}

	/**
	 * Handles the tabular input event.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pEvent - The input event.
	 * @param {string} [pTransactionGUID] - (optional) The active transaction GUID.
	 */
	inputEventTabular(pView, pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof pTransactionGUID === 'string') ? pTransactionGUID : this.pict.getUUID();
		let tmpInput = pView.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (pGroupIndex != null && pInputIndex != null && pRowIndex != null && tmpInput)
		{
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();

				// TODO: Can we simplify pView?
				let tmpValueAddress = pView.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);

				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular+`[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onEventTabular(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, pEvent, tmpTransactionGUID);
						pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
						{
							pView.pict.providers[tmpInputProviderList[i]].onAfterEventTabularCompletion(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, pEvent, tmpTransactionGUID);
						});
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex} calling inputEvent ${pEvent}.`);
					}
				}
				if (pTransactionGUID !== tmpTransactionGUID)
				{
					// since we synthesized this transaction, finalize it
					pView.finalizeTransaction(tmpTransactionGUID);
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error marshaling specific (${pGroupIndex} | ${pInputIndex} | ${pRowIndex}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in calling inputEvent ${pEvent}: ${pError}`);
			}
		}
	}
}

module.exports = PictDynamicInputEvents;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],502:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Layout",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicLayout class is a provider that generates dynamic layouts based on configuration.
 */
class PictDynamicLayout extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicLayout class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Generate a group layout template for the Dynamically Generated views.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		return '';
	}

	/**
	 * After a group template has been rendered, this lets a layout initialize any controls that
	 * are necessary (e.g. a custom input type or such).
	 *
	 * @param {object} pView  - The view to initialize the newly rendered control for
	 * @param {object} pGroup - The group to initialize the newly rendered control for
	 * @returns
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		return true;
	}

	/**
	 * This fires after data has been marshaled to the form from the model.
	 *
	 * @param {object} pView  - The view to initialize the newly rendered control for
	 * @param {object} pGroup - The group to initialize the newly rendered control for
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		return true;
	}
}

module.exports = PictDynamicLayout;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],503:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-RecordSet",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictRecordSet class is a provider to read and write record sets.
 *
 * Record sets are bodies of records that are larger than what we would want to
 * be projected into a view.
 */
class PictRecordSet extends libPictProvider
{
	/**
	 * Creates an instance of the PictRecordSet class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.recordProviders = {};
	}

	/**
	 * Returns the count for a specific dynamic record set.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the count is returned.
	 * @returns {any} - The result of the callback function.
	 */
	count(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Reads a record list.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the record list is read.
	 * @returns {any} - The result of the callback function.
	 */
	readRecordList(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Reads a record.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the record is read.
	 * @returns {any} - The result of the callback function.
	 */
	readRecord(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Writes a record.
	 *
	 * @param {Object} pRecord - The record to be written.
	 * @param {Function} fCallback - The callback function to be called after the record is written.
	 * @returns {any} - The result of the callback function.
	 */
	writeRecord(pRecord, fCallback)
	{
		return fCallback();
	}

	/**
	 * Deletes a record.
	 *
	 * @param {Object} pRecord - The record to be deleted.
	 * @param {Function} fCallback - The callback function to be called after the record is deleted.
	 * @returns {any} - The result of the callback function.
	 */
	deleteRecord(pRecord, fCallback)
	{
		return fCallback();
	}
}

module.exports = PictRecordSet;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],504:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libDynamicFormSolverBehaviors = require('./Pict-Provider-DynamicFormSolverBehaviors.js');

const libListDistilling = require('./Pict-Provider-ListDistilling.js');
const libDynamicMetaLists = require('./Pict-Provider-MetaLists.js');

const libInputSelect = require('./inputs/Pict-Provider-Input-Select.js');
const libInputDateTime = require('./inputs/Pict-Provider-Input-DateTime.js');
const libInputTabGroupSelector = require('./inputs/Pict-Provider-Input-TabGroupSelector.js');
const libInputTabSectionSelector = require('./inputs/Pict-Provider-Input-TabSectionSelector.js');
const libInputEntityBundleRequest = require('./inputs/Pict-Provider-Input-EntityBundleRequest.js');
const libInputAutofillTriggerGroup = require('./inputs/Pict-Provider-Input-AutofillTriggerGroup.js');
const libInputMarkdown = require('./inputs/Pict-Provider-Input-Markdown.js');
const libInputHTML = require('./inputs/Pict-Provider-Input-HTML.js');
const libInputTemplated = require('./inputs/Pict-Provider-Input-Templated.js');
const libInputPreciseNumber = require('./inputs/Pict-Provider-Input-PreciseNumber.js');
const libInputLink = require('./inputs/Pict-Provider-Input-Link.js');
const libInputTemplatedEntityLookup = require('./inputs/Pict-Provider-Input-TemplatedEntityLookup.js');
const libInputChart = require('./inputs/Pict-Provider-Input-Chart.js');
const libInputTabularTriggerGroup = require('./inputs/Pict-Provider-Input-TabularTriggerGroup.js');
const libInputObjectEditor = require('./inputs/Pict-Provider-Input-ObjectEditor.js');
const libInputFacetFilter = require('./inputs/Pict-Provider-Input-FacetFilter.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Solver",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicSolver class is a provider that solves configuration-generated dynamic views.
 */
class PictDynamicSolver extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicSolver class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { ExpressionParser: any }} */
		this.pict;
		/** @type {import('pict') & { instantiateServiceProviderIfNotExists: (hash: string) => any, ExpressionParser: any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this._RunSolversRegex = /\brunsolvers\b/gi;

		// Initialize the solver service if it isn't up
		this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');

		this.pict.addProviderSingleton('DynamicFormSolverBehaviors', libDynamicFormSolverBehaviors.default_configuration, libDynamicFormSolverBehaviors);
		this.pict.providers.DynamicFormSolverBehaviors.injectBehaviors(this.fable.ExpressionParser);
		this.pict.addProviderSingleton('DynamicMetaLists', libDynamicMetaLists.default_configuration, libDynamicMetaLists);
		this.pict.addProviderSingleton('ListDistilling', libListDistilling.default_configuration, libListDistilling);
		this.pict.addProviderSingleton('Pict-Input-Select', libInputSelect.default_configuration, libInputSelect);
		this.pict.addProviderSingleton('Pict-Input-DateTime', libInputDateTime.default_configuration, libInputDateTime);
		this.pict.addProviderSingleton('Pict-Input-TabGroupSelector', libInputTabGroupSelector.default_configuration, libInputTabGroupSelector);
		this.pict.addProviderSingleton('Pict-Input-TabSectionSelector', libInputTabSectionSelector.default_configuration, libInputTabSectionSelector);
		this.pict.addProviderSingleton('Pict-Input-EntityBundleRequest', libInputEntityBundleRequest.default_configuration, libInputEntityBundleRequest);
		this.pict.addProviderSingleton('Pict-Input-AutofillTriggerGroup', libInputAutofillTriggerGroup.default_configuration, libInputAutofillTriggerGroup);
		this.pict.addProviderSingleton('Pict-Input-Markdown', libInputMarkdown.default_configuration, libInputMarkdown);
		this.pict.addProviderSingleton('Pict-Input-HTML', libInputHTML.default_configuration, libInputHTML);
		this.pict.addProviderSingleton('Pict-Input-Templated', libInputTemplated.default_configuration, libInputTemplated);
		this.pict.addProviderSingleton('Pict-Input-PreciseNumber', libInputPreciseNumber.default_configuration, libInputPreciseNumber);
		this.pict.addProviderSingleton('Pict-Input-TemplatedEntityLookup', libInputTemplatedEntityLookup.default_configuration, libInputTemplatedEntityLookup);
		this.pict.addProviderSingleton('Pict-Input-Link', libInputLink.default_configuration, libInputLink);
		this.pict.addProviderSingleton('Pict-Input-Chart', libInputChart.default_configuration, libInputChart);
		this.pict.addProviderSingleton('Pict-Input-TabularTriggerGroup', libInputTabularTriggerGroup.default_configuration, libInputTabularTriggerGroup);
		this.pict.addProviderSingleton('Pict-Input-ObjectEditor', libInputObjectEditor.default_configuration, libInputObjectEditor);
		this.pict.addProviderSingleton('Pict-Input-FacetFilter', libInputFacetFilter.default_configuration, libInputFacetFilter);
	}

	logSolveOutcome(pSolveOutcome)
	{
		let tmpSolveOutcome = pSolveOutcome;
		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			tmpSolveOutcome = this.lastSolveOutcome;
		}
		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			this.log.error(`DynamicSolver [${this.UUID}]::[${this.Hash}] No solve outcome available to log.`);
			return;
		}

		let tmpSolversRun = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length;

		this.log.info(`DynamicSolver completed solving ${tmpSolversRun} solvers in ${tmpSolveOutcome.EndTimeStamp - tmpSolveOutcome.StartTimeStamp} ms.`);

		for (let i = 0; i < tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length; i++)
		{
			let tmpSolver = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers[i];
			this.log.info(`  Solver [${tmpSolver.Hash}] Ordinal ${tmpSolver.Ordinal} executed in ${tmpSolver.EndTimeStamp - tmpSolver.StartTimeStamp}ms solving for [${tmpSolver?.ResultsObject?.PostfixedAssignmentAddress}] expression [${tmpSolver.Expression}]`);
		}
	}

	/**
	 * Prepares the solver results map by ensuring it has the necessary structure.
	 *
	 * @param {Object} pSolverResultsMap - The solver results map to prepare.
	 * @returns {Object} - The prepared solver results map.
	*/
	prepareSolverResultsMap(pSolverResultsMap)
	{
		let tmpSolverResultsMap = pSolverResultsMap;
		if (typeof(tmpSolverResultsMap) !== 'object' || tmpSolverResultsMap === null)
		{
			tmpSolverResultsMap = {};
		}
		if (!('ExecutedSolvers' in tmpSolverResultsMap))
		{
			tmpSolverResultsMap.ExecutedSolvers = [];
		}
		if (!('SolverResolutionMap' in tmpSolverResultsMap))
		{
			tmpSolverResultsMap.SolverResolutionMap = {};
		}
		return tmpSolverResultsMap;
	}

	/**
	 * Backfills solver dependencies into the solve outcome.
	 *
	 * @param {Object} pSolveOutcome - The solve outcome object.
	 * @returns {Object} - The updated solve outcome with backfilled dependencies.
	 */
	backfillSolverDependencies(pSolveOutcome)
	{
		let tmpSolveOutcome = pSolveOutcome;

		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			tmpSolveOutcome = this.lastSolveOutcome;
		}

		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			this.log.error(`DynamicSolver [${this.UUID}]::[${this.Hash}] No solve outcome available to backfill solver dependencies.`);
			return;
		}

		for (let i = 0; i < tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length; i++)
		{
			let tmpSolver = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers[i];
			if (('ResultsObject' in tmpSolver) && (typeof(tmpSolver.ResultsObject) === 'object') && (tmpSolver.ResultsObject !== null))
			{
				// Now fill any dependencies from the results object
				// If the Postfixed Assignment Address is "Result" it hasn't been set and we will ignore it.
				if (tmpSolver.ResultsObject.PostfixedAssignmentAddress && (tmpSolver.ResultsObject.PostfixedAssignmentAddress != 'Result'))
				{
					if (typeof(tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress]) !== 'object')
					{
						tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress] = {};
					}
					// Go through the postfixed list and pull out any symbols being assigned
					for (let j = 0; j < tmpSolver.ResultsObject.PostfixTokenObjects.length; j++)
					{
						let tmpTokenObject = tmpSolver.ResultsObject.PostfixTokenObjects[j];
						if (tmpTokenObject.Type == 'Token.Symbol')
						{
							if (!(tmpTokenObject.Token in tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress]))
							{
								tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] = 0;
							}
							tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] = tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] + 1;
						}
					}
				}
			}
		}

		return tmpSolveOutcome;
	}

	/**
	 * Runs a manual solver expression against the dynamic view marshal destination or the application data.
	 *
	 * @param {string} pSolverExpression - The solver expression to run.
	 * @param {boolean} [pSilent=false] - Whether to suppress debug logging output.
	 * @returns {any} - The result of the solver expression.
	 */
	runSolver(pSolverExpression, pSilent = false)
	{
		let tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);

		if ((typeof(tmpViewMarshalDestinationObject) !== 'object') || (tmpViewMarshalDestinationObject === null))
		{
			tmpViewMarshalDestinationObject = this.pict.AppData;
		}

		let tmpResultsObject = {};
		let tmpSolutionValue = this.fable.ExpressionParser.solve(pSolverExpression, tmpViewMarshalDestinationObject, tmpResultsObject, this.pict.manifest);

		if (tmpResultsObject.fable)
		{
			delete tmpResultsObject.fable;
		}

		if (!pSilent)
		{
			this.pict.log.trace(`Manual solve executed for expression: ${pSolverExpression}`, tmpResultsObject);
		}

		return tmpSolutionValue;
	}

	/**
	 * Checks the solver and returns the solver object if it passes the checks.
	 *
	 * Automatically converts string solvers to have an Ordinal of 1.
	 *
	 * @param {string|object} pSolver - The solver to be checked. It can be either a string or an object.
	 * @param {boolean} [pFiltered=false] - Indicates whether the solvers should be filtered.
	 * @param {number} [pOrdinal] - The ordinal value to compare with the solver's ordinal value when filtered.
	 * @returns {object|undefined} - The solver object if it passes the checks, otherwise undefined.
	 */
	checkSolver(pSolver, pFiltered, pOrdinal)
	{
		let tmpSolver = pSolver;
		if (tmpSolver === undefined)
		{
			return;
		}
		if (typeof(tmpSolver) === 'string')
		{
			tmpSolver = {Expression:tmpSolver, Ordinal:1};
		}
		if (!('Expression' in tmpSolver))
		{
			this.log.error(`Dynamic View solver ${pOrdinal} is missing the Expression property.`, { Solver: pSolver });
			return;
		}
		if (!(`Ordinal` in tmpSolver))
		{
			tmpSolver.Ordinal = 1;
		}

		// This filters the solvers
		if (pFiltered && (tmpSolver.Ordinal != pOrdinal))
		{
			return;
		}

		return tmpSolver;
	}

	/** @typedef {{ Ordinal: number, Expression: string } | string} Solver */

	/**
	 * Execute a set of adhoc solvers.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The dynamic view to execute the solvers against.
	 * @param {Array<Solver>} pSolvers - An array of solvers to execute.
	 * @param {string} pReason - The reason for executing the solvers.
	 */
	executeSolvers(pView, pSolvers, pReason)
	{
		const tmpSolvers = Array.isArray(pSolvers) ? pSolvers : [];
		let tmpSolveOutcome = {};
		tmpSolveOutcome.SolverResultsMap = {};
		tmpSolveOutcome.StartTimeStamp = +new Date();

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		for (let i = 0; i < tmpSolvers.length; i++)
		{
			const tmpSolver = this.checkSolver(tmpSolvers[i]);
			if (tmpSolver)
			{
				let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
				tmpOrdinalContainer.AdhocSolvers.push(tmpSolver);
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort((a, b) =>
		{
			if (isNaN(Number(a)) || isNaN(Number(b)))
			{
				return a.localeCompare(b);
			}
			return Number(a) - Number(b);
		});

		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicSolver [${this.UUID}]::[${this.Hash}] [${pReason}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			const tmpAdhocScope = this.pict.providers.DynamicFormSolverBehaviors.getViewSolverScope(pView);
			let tmpExecuteOrdinal = this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpOrdinalKeys[i], tmpAdhocScope);
			if (tmpExecuteOrdinal)
			{
				const tmpPreviousScope = this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpAdhocScope);
				this.executeAdhocSolvers(pView, tmpOrdinalContainer.AdhocSolvers, pReason, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap);
				this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpPreviousScope);
			}
		}

		tmpSolveOutcome.EndTimeStamp = +new Date();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastAdhocSolveOutcome = tmpSolveOutcome;
	}

	/**
	 * Runs each Adhoc solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The dynamic view to execute the solvers against.
	 * @param {Array<string>} pAdhocSolverArray - An array of Solvers from the groups to solve.
	 * @param {string} pReason - The reason for executing the solvers.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeAdhocSolvers(pView, pAdhocSolverArray, pReason, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pAdhocSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pAdhocSolverArray[i], tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					pView.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] [${pReason}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = +new Date();
			tmpSolver.Hash = `AdhocSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`Dynamic View [${pView.UUID}]::[${pView.Hash}] [${pReason}] solving equation ${i} ordinal ${tmpSolver.Ordinal} [${pView.options.Solvers[i]}]`);
			}
			tmpSolver.ResultsObject = {};
			let tmpSolutionValue = this.fable.ExpressionParser.solve(tmpSolver.Expression, pView.getMarshalDestinationObject(), tmpSolver.ResultsObject, this.pict.manifest, pView.getMarshalDestinationObject());
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`[${tmpSolver.Expression}] [${pReason}] result was ${tmpSolutionValue}`);
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Runs each RecordSet solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {array} pGroupSolverArray - An array of Solvers from the groups to solve.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeGroupSolvers(pGroupSolverArray, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		// This is purely for readability of the code below ... uglify optimizes it out.
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		// Solve the group RecordSet solvers first
		for (let j = 0; j < pGroupSolverArray.length; j++)
		{
			let tmpView = this.pict.views[pGroupSolverArray[j].ViewHash];
			let tmpGroup = tmpView.getGroup(pGroupSolverArray[j].GroupIndex);
			let tmpSolver = this.checkSolver(pGroupSolverArray[j].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			const tmpGroupScope = this.pict.providers.DynamicFormSolverBehaviors.getViewSolverScope(tmpView);
			if (tmpGroupScope && !this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpSolver.Ordinal, tmpGroupScope))
			{
				continue;
			}
			this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpGroupScope);

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					tmpView.log.warn(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `${pGroupSolverArray[j].ViewHash}-GroupSolver-${j}`;

			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] solving RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}

			let tmpRecordSet = tmpView.getTabularRecordSet(tmpGroup.GroupIndex);

			if (Array.isArray(tmpRecordSet))
			{
				for (let l = 0; l < tmpRecordSet.length; l++)
				{
					let tmpRecord = tmpRecordSet[l];
					tmpSolver.ResultsObject = {};
					let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, tmpGroup.supportingManifest, tmpRecord);
					if (this.pict.LogNoisiness > 1)
					{
						tmpView.log.trace(`Group ${tmpGroup.Hash} [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
					}
				}
			}
			else if (typeof(tmpRecordSet) == 'object')
			{
				let tmpRecordSetKeys = Object.keys(tmpRecordSet);
				for (let l = 0; l < tmpRecordSetKeys.length; l++)
				{
					let tmpRecord = tmpRecordSet[tmpRecordSetKeys[l]];
					tmpSolver.ResultsObject = {};
					let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, tmpGroup.supportingManifest, tmpRecord);
					if (this.pict.LogNoisiness > 1)
					{
						tmpView.log.trace(`Group ${tmpGroup.Hash} [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
					}
				}
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = Date.now();
		}
		this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope('');
	}

	/**
	 * Executes the section solvers at a given ordinal (or all if no ordinal is passed).
	 *
	 * @param {Array} pViewSectionSolverArray - The array of view section solvers.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeSectionSolvers(pViewSectionSolverArray, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pViewSectionSolverArray.length; i++)
		{
			let tmpView = this.pict.views[pViewSectionSolverArray[i].ViewHash];
			let tmpSolver = this.checkSolver(pViewSectionSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			// A gate an injected copy set applies to that copy's solvers, not to a sibling's at the same ordinal.
			const tmpSectionScope = this.pict.providers.DynamicFormSolverBehaviors.getViewSolverScope(tmpView);
			if (tmpSectionScope && !this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpSolver.Ordinal, tmpSectionScope))
			{
				continue;
			}
			this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpSectionScope);

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					tmpView.log.warn(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = +new Date();
			tmpSolver.Hash = `${pViewSectionSolverArray[i].ViewHash}-SectionSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] solving equation ${i} ordinal ${tmpSolver.Ordinal} [${tmpView.options.Solvers[i]}]`);
			}
			tmpSolver.ResultsObject = {};
			let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpView.getMarshalDestinationObject(), tmpSolver.ResultsObject, this.pict.manifest, tmpView.getMarshalDestinationObject());
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`[${tmpSolver.Expression}] result was ${tmpSolutionValue}`);
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
		this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope('');
	}

	/**
	 * Executes the view solvers for the given array of view hashes.
	 *
	 * @param {Array} pViewSolverArray - The array of view solvers to execute.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 */
	executeViewSolvers(pViewSolverArray, pOrdinal, pSolverResultsMap)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pViewSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pViewSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			tmpSolver.Hash = `${pViewSolverArray[i].ViewHash}-ViewSolve-${i}`;
			tmpSolver.StartTimeStamp = +new Date();
			let tmpView = this.pict.views[pViewSolverArray[i].ViewHash];
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] running solve() on view [${pViewSolverArray[i].ViewHash}`);
			}
			// Solve with the normal view solve() pipeline
			tmpView.solve();
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Executes any validation solvers defined in the form manifest.
	 *
	 * @param {Object} pSolverResultsMap - The solver results map to use for executing validation solvers.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles when executing validation solvers.
	 */
	executeValidationSolvers(pSolverResultsMap, pPreventSolverCycles = false)
	{
		const tmpValidationSolvers = this.pict.views.PictFormMetacontroller?.manifestDescription?.ValidationSolvers;
		if (!Array.isArray(tmpValidationSolvers))
		{
			return;
		}
		const tmpMarshalDestination = this.pict.views.PictFormMetacontroller && this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination) || this.pict.AppData;
		for (let i = 0; i < tmpValidationSolvers.length; i++)
		{
			const tmpSolver = this.checkSolver(tmpValidationSolvers[i]);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.warn(`Skipping Validation Solver ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`Running validation solver ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}
			this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpMarshalDestination, pSolverResultsMap, this.pict.manifest, tmpMarshalDestination);
		}
	}

	/**
	 * Checks if the given ordinal exists in the provided ordinal set.
	 *
	 * If not, it adds the ordinal to the set.
	 *
	 * @param {number} pOrdinal - The ordinal to check.
	 * @param {Object} pOrdinalSet - The ordinal set to check against.
	 * @returns {Object} - The ordinal object from the ordinal set.
	 */
	checkAutoSolveOrdinal (pOrdinal, pOrdinalSet)
	{
		if (!(pOrdinal.toString() in pOrdinalSet))
		{
			pOrdinalSet[pOrdinal.toString()] = { ViewSolvers:[], SectionSolvers:[], GroupSolvers:[], AdhocSolvers:[] };
		}
		return pOrdinalSet[pOrdinal];
	}

	/**
	 * Solves the views based on the provided view hashes or all views in pict.
	 *
	 * If non-dynamic views are also passed in, they are solved as well.
	 *
	 * This algorithm is particularly complex because it solves views in
	 * order across two dimensions:
	 *
	 * 1. The order of the views in the view hash array.
	 * 2. Precedence order (based on Ordinal)
	 *
	 * The way it manages the precedence order solving is by enumerating the
	 * view hash array multiple times until it exhausts the solution set.
	 *
	 * In dynamic views, when there are collisions in precedence order between
	 * Section Solvers and Group RecordSet Solvers, it prefers the RecordSet
	 * solvers first.  The thinking behind this is that a RecordSet solver is
	 * a "tier down" from the core Section it resides within.  These are
	 * leaves on the tree.

	 * @param {Array|string[]} [pViewHashes] - An optional array of view hashes to solve. If not provided, all views in the fable will be solved.
	 * @param {boolean} [pPreventSolverCycles] - An optional context string for the solve operation.
	 * TODO: make sure you can't cycle with the same solve context - new solver method to invoke this
	 *
	 * @return {Array<string>} - An array of view hashes that were solved.
	 */
	solveViews(pViewHashes, pPreventSolverCycles)
	{
		//this.log.trace(`Dynamic View Provider [${this.UUID}]::[${this.Hash}] solving views.`);
		let tmpViewHashes = Array.isArray(pViewHashes) ? pViewHashes : Object.keys(this.fable.views);
		const tmpPreventSolverCycles = pPreventSolverCycles === true;

		let tmpSolveOutcome = {};
		tmpSolveOutcome.SolverResultsMap = {};
		tmpSolveOutcome.StartTimeStamp = +new Date();
		tmpSolveOutcome.ViewHashes = tmpViewHashes;

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			let tmpView = this.fable.views[tmpViewHashes[i]];
			if (tmpView.isPictView && !tmpView.isPictSectionForm && !tmpView.isPictMetacontroller)
			{
				// This is just a normal view.  We will solve it at the appropriate ordinal.
				let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpView.options.AutoSolveOrdinal, tmpOrdinalsToSolve);
				tmpOrdinalContainer.ViewSolvers.push({ViewHash:tmpViewHashes[i]});
			}
			else if (tmpView.isPictSectionForm)
			{
				// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
				for (let j = 0; j < tmpView.sectionDefinition.Groups.length; j++)
				{
					let tmpGroup = tmpView.getGroup(j);
					if (`RecordSetSolvers` in tmpGroup)
					{
						for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
						{
							let tmpSolver = this.checkSolver(tmpGroup.RecordSetSolvers[k]);
							if (tmpSolver)
							{
								let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
								tmpOrdinalContainer.GroupSolvers.push({ViewHash:tmpViewHashes[i], GroupIndex:j, Solver:tmpSolver});
							}
						}
					}
				}
				if (Array.isArray(tmpView.options.Solvers))
				{
					// Add thje section solver(s)
					for (let j = 0; j < tmpView.options.Solvers.length; j++)
					{
						let tmpSolver = this.checkSolver(tmpView.options.Solvers[j]);
						if (tmpSolver)
						{
							let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
							tmpOrdinalContainer.SectionSolvers.push({ViewHash:tmpViewHashes[i], Solver:tmpSolver});
						}
					}
				}
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort((a, b) =>
		{
			if (isNaN(Number(a)) || isNaN(Number(b)))
			{
				return a.localeCompare(b);
			}
			return Number(a) - Number(b);
		});

		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicSolver [${this.UUID}]::[${this.Hash}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			let tmpExecuteOrdinal = this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpOrdinalKeys[i]);
			if (tmpExecuteOrdinal)
			{
				this.executeGroupSolvers(tmpOrdinalContainer.GroupSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);
				this.executeSectionSolvers(tmpOrdinalContainer.SectionSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);
				this.executeViewSolvers(tmpOrdinalContainer.ViewSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap);
			}
		}

		this.executeValidationSolvers(tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);

		// Now regenerate the metalists .. after the solve has happened.
		this.pict.providers.DynamicMetaLists.buildViewSpecificLists(tmpViewHashes);

		tmpSolveOutcome.EndTimeStamp = +new Date();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastSolveOutcome = tmpSolveOutcome;
		return tmpViewHashes;
	}
}

module.exports = PictDynamicSolver;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./Pict-Provider-DynamicFormSolverBehaviors.js":499,"./Pict-Provider-ListDistilling.js":510,"./Pict-Provider-MetaLists.js":511,"./inputs/Pict-Provider-Input-AutofillTriggerGroup.js":516,"./inputs/Pict-Provider-Input-Chart.js":518,"./inputs/Pict-Provider-Input-DateTime.js":519,"./inputs/Pict-Provider-Input-EntityBundleRequest.js":522,"./inputs/Pict-Provider-Input-FacetFilter.js":523,"./inputs/Pict-Provider-Input-HTML.js":524,"./inputs/Pict-Provider-Input-Link.js":525,"./inputs/Pict-Provider-Input-Markdown.js":526,"./inputs/Pict-Provider-Input-ObjectEditor.js":527,"./inputs/Pict-Provider-Input-PreciseNumber.js":528,"./inputs/Pict-Provider-Input-Select.js":531,"./inputs/Pict-Provider-Input-TabGroupSelector.js":532,"./inputs/Pict-Provider-Input-TabSectionSelector.js":533,"./inputs/Pict-Provider-Input-TabularTriggerGroup.js":534,"./inputs/Pict-Provider-Input-Templated.js":535,"./inputs/Pict-Provider-Input-TemplatedEntityLookup.js":536,"pict-provider":479}],505:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-DynamicTabularData",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * @typedef {Object} ElementDescriptor
 * @property {string} Hash - The hash of the element.
 */

/**
 * The DynamicTabularData class is a provider that translates simple list entries into arrays of entries ready to use in drop-down lists and such
 */
class DynamicTabularData extends libPictProvider
{
	/**
	 * Creates an instance of the DynamicTabularData class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Retrieves the tabular record set from the specified view and group index.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @returns {Array|Object|boolean} - The tabular record set if it exists, otherwise false.
	 */
	getTabularRecordSet(pView, pGroupIndex)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);
		if (!tmpGroup || !tmpGroup?.RecordSetAddress)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordSet ${pGroupIndex} was not a valid group or did not have a valid RecordSetAddress.`);
			return false;
		}

		let tmpRowSource = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		return tmpRowSource;
	}

	/**
	 * Retrieves the tabular record input from the specified view, group, and input indexes.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns {ElementDescriptor|boolean} The tabular record input or false if the group is invalid.
	 */
	getTabularRecordInput(pView, pGroupIndex, pInputIndex)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInput ${pGroupIndex} was not a valid group.`);
			return false;
		}

		// Now get the supporting manifest and the input element
		// This needs more guards
		let tmpSupportingManifestHash = tmpGroup.supportingManifest.elementAddresses[pInputIndex];
		return tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
	}

	/**
	 * Retrieves the tabular record input from the specified view, group, and input indexes.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupHash - The index of the group.
	 * @param {number} pInputHash - The index of the input.
	 * @returns {ElementDescriptor|boolean} The tabular record input or false if the group is invalid.
	 */
	getTabularRecordInputByHash(pView, pGroupHash, pInputHash)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroups().find((pGroup) => pGroup.Hash === pGroupHash);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} was not a valid group.`);
			return false;
		}

		if (!tmpGroup.supportingManifest)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} s not a tabular group.`);
			return false;
		}

		// Now get the supporting manifest and the input element
		// This needs more guards
		for (const tmpDescriptor of Object.values(tmpGroup.supportingManifest.elementDescriptors))
		{
			if (tmpDescriptor.Hash === pInputHash)
			{
				return tmpDescriptor;
			}
		}

		this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} could not find input ${pInputHash}.`);
		return false;
	}

	/**
	 * Retrieves tabular record data based on the provided parameters.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pRowIdentifier - The identifier of the row.
	 * @returns {boolean|Object} - The tabular record data or false if not found.
	 */
	getTabularRecordData(pView, pGroupIndex, pRowIdentifier)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} was not a valid group.`);
			return false;
		}

		// Now identify the group
		let tmpRowSourceRecord =  pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		if (!tmpRowSourceRecord)
		{
			// Try the address
			tmpRowSourceRecord = pView.sectionManifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		}

		if (!tmpRowSourceRecord)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} could not find the record set for ${tmpGroup.RecordSetAddress}.`);
			return false;
		}

		// Now we have the source record let's see what it is
		try
		{
			if (Array.isArray(tmpRowSourceRecord))
			{
				return tmpRowSourceRecord[pRowIdentifier];
			}
			else if (typeof(tmpRowSourceRecord) === 'object')
			{
				return tmpRowSourceRecord[pRowIdentifier];
			}
			else
			{
				this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} could not determine the type of the record set for ${tmpGroup.RecordSetAddress}.`);
				return false;
			}
		}
		catch (pError)
		{
			this.log.error(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} encountered an error: ${pError}`);
			return false;
		}
	}

	/**
	 * Creates a dynamic table row for the given view and group index.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 */
	createDynamicTableRow(pView, pGroupIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MaximumRowCount && (tmpDestinationObject.length >= tmpGroup.MaximumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to add a row but the maximum rows ${tmpGroup.MaximumRowCount} has been reached.`);
					return;
				}
				let tmpRowPrototype = {};
				if (tmpGroup.DefaultRows && tmpDestinationObject.length < tmpGroup.DefaultRows.length)
				{
					tmpRowPrototype = JSON.parse(JSON.stringify(tmpGroup.DefaultRows[tmpDestinationObject.length]));
				}
				tmpDestinationObject.push(tmpGroup.supportingManifest.populateDefaults(tmpRowPrototype));

				// Also render any other views that have this as the RecordSetAddress
				// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
				let tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
					/** @param {import('../views/Pict-View-DynamicForm.js')} pViewToTestForGroup */
					(pViewToTestForGroup) =>
					{
						if (!pViewToTestForGroup.isPictSectionForm)
						{
							return false;
						}
						let tmpGroupsToTest = pViewToTestForGroup.getGroups();
						for (let i = 0; i < tmpGroupsToTest.length; i++)
						{
							if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
							{
								return true;
							}
						}
						return false;
					}
				)
				// We expect this view to be in the set. Re-rendering an entity-selector
				// table clobbers its selected values in the model, so preserve them.
				this._renderViewsPreservingRecordSet(tmpGroup.RecordSetAddress, tmpViewsToRender);

				// Rebuild any OTHER views whose DynamicColumns are sourced from this record set
				// (e.g. a "% Passing" table whose columns are generated from this "Products" table)
				// HERE, in the render phase -- BEFORE the marshal below -- so the column DOM is
				// correct when the marshal fills it. Previously these dependent tables were only
				// rebuilt from inside the Tabular layout's onDataMarshalToForm hook (mid-marshal),
				// which left the freshly rebuilt cells unpopulated until a later edit/marshal --
				// the "dependent table blanks out on row add/delete until you edit a field" bug.
				this._rebuildDependentDynamicColumnViews(tmpGroup.RecordSetAddress);

				// Run the solver
				this.pict.providers.DynamicSolver.solveViews();

				//pView.render();
				//pView.marshalToView();
				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}


	/**
	 * Creates a dynamic table row for the given view and group index without firing render or marshal events.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 */
	createDynamicTableRowWithoutEvents(pView, pGroupIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MaximumRowCount && (tmpDestinationObject.length >= tmpGroup.MaximumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to add a row but the maximum rows ${tmpGroup.MaximumRowCount} has been reached.`);
					return;
				}
				let tmpRowPrototype = {};
				if (tmpGroup.DefaultRows && tmpDestinationObject.length < tmpGroup.DefaultRows.length)
				{
					tmpRowPrototype = JSON.parse(JSON.stringify(tmpGroup.DefaultRows[tmpDestinationObject.length]));
				}
				tmpDestinationObject.push(tmpGroup.supportingManifest.populateDefaults(tmpRowPrototype))
			}
		}
	}

	/**
	 * Sets the index of a dynamic table row in a view.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number|string} pRowIndex - The current index of the row.
	 * @param {number} pNewRowIndex - The new index to move the row to.
	 * @returns {boolean} - Returns false if the index is out of bounds, otherwise returns undefined.
	 */
	setDynamicTableRowIndex(pView, pGroupIndex, pRowIndex, pNewRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				let tmpNewRowIndex = parseInt(String(pNewRowIndex), 10);
				if ((tmpDestinationObject.length <= tmpRowIndex) || (tmpRowIndex < 0))
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] to [${pNewRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so a source reorder must apply the same permutation to every
				// dependent row's positional cells -- otherwise user-entered values stay put while
				// their column re-labels to a different source row. Must run BEFORE the dependent
				// views re-resolve their columns below. No-op for value-keyed generators.
				this._moveDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpNewRowIndex, tmpOriginalLength);

				// Render (source + dependent views) BEFORE solving so dependent DynamicColumns tables
				// don't blank until the next edit, and the solve's DOM side effects survive. Matches
				// the add/delete handlers' order.
				this._repaintAfterRowReorder(pView, tmpGroup);
			}
		}
	}

	/**
	 * Moves a dynamic table row down within a view.
	 *
	 * @param {Object} pView - The view containing the dynamic table.
	 * @param {number} pGroupIndex - The index of the group containing the row.
	 * @param {number|string} pRowIndex - The index of the row to be moved.
	 * @returns {boolean} - Returns true if the row was successfully moved, false otherwise.
	 */
	moveDynamicTableRowDown(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] down but it's already at the bottom.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				let tmpNewRowIndex = tmpRowIndex + 1;
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so a source reorder must apply the same permutation to every
				// dependent row's positional cells -- otherwise user-entered values stay put while
				// their column re-labels to a different source row. Must run BEFORE the dependent
				// views re-resolve their columns below. No-op for value-keyed generators.
				this._moveDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpNewRowIndex, tmpOriginalLength);

				// Render (source + dependent views) BEFORE solving so the solve's DOM side effects
				// (e.g. SetGroupVisibility hiding a validation message) act on the freshly rebuilt
				// DOM and survive, and so dependent DynamicColumns tables don't blank until the next
				// edit. Matches the add/delete handlers' order.
				this._repaintAfterRowReorder(pView, tmpGroup);
			}
		}
	}

	/**
	 * Moves a dynamic table row up.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number|string} pRowIndex - The index of the row to be moved.
	 * @returns {boolean} Returns true if the row was moved successfully, false otherwise.
	 */
	moveDynamicTableRowUp(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == 0)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] up but it's already at the top.`);
					return false;
				}
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				let tmpNewRowIndex = tmpRowIndex - 1;
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so a source reorder must apply the same permutation to every
				// dependent row's positional cells -- otherwise user-entered values stay put while
				// their column re-labels to a different source row. Must run BEFORE the dependent
				// views re-resolve their columns below. No-op for value-keyed generators.
				this._moveDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpNewRowIndex, tmpOriginalLength);

				// Render (source + dependent views) BEFORE solving so the solve's DOM side effects
				// (e.g. SetGroupVisibility hiding a validation message) act on the freshly rebuilt
				// DOM and survive, and so dependent DynamicColumns tables don't blank until the next
				// edit. Matches the add/delete handlers' order.
				this._repaintAfterRowReorder(pView, tmpGroup);
			}
		}
	}


	/**
	 * Deletes a dynamic table row from the specified view.
	 *
	 * @param {Object} pView - The view from which to delete the row.
	 * @param {number} pGroupIndex - The index of the group containing the row.
	 * @param {number|string} pRowIndex - The index or key of the row to delete.
	 * @returns {boolean} - Returns true if the row was successfully deleted, false otherwise.
	 */
	deleteDynamicTableRow(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to delete a row but the minimum rows ${tmpGroup.MinimumRowCount} has been reached.`);
					return false;
				}

				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to delete row [${pRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				tmpDestinationObject.splice(tmpRowIndex, 1);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so deleting a source row must shift every dependent row's
				// positional cells down past the removed index -- otherwise the values below it
				// re-associate to the wrong column. (Solver-filled cells re-derive on the next
				// solve; user-entered cells would shift without this.) Must run BEFORE the
				// dependent views re-resolve their columns below. No-op for value-keyed generators.
				this._spliceDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpOriginalLength);

				// Also render any other views that have this as the RecordSetAddress
				// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
				let tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
					(pViewToTestForGroup) =>
					{
						if (!pViewToTestForGroup.isPictSectionForm)
						{
							return false;
						}
						let tmpGroupsToTest = pViewToTestForGroup.getGroups();
						for (let i = 0; i < tmpGroupsToTest.length; i++)
						{
							if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
							{
								return true;
							}
						}
						return false;
					}
				)
				// We expect this view to be in the set. Re-rendering an entity-selector
				// table clobbers its selected values in the model, so preserve them.
				this._renderViewsPreservingRecordSet(tmpGroup.RecordSetAddress, tmpViewsToRender);

				// Rebuild any OTHER views whose DynamicColumns are sourced from this record set
				// (e.g. a "% Passing" table whose columns are generated from this "Products" table)
				// HERE, in the render phase -- BEFORE the marshal below -- so the column DOM is
				// correct when the marshal fills it. Previously these dependent tables were only
				// rebuilt from inside the Tabular layout's onDataMarshalToForm hook (mid-marshal),
				// which left the freshly rebuilt cells unpopulated until a later edit/marshal --
				// the "dependent table blanks out on row add/delete until you edit a field" bug.
				this._rebuildDependentDynamicColumnViews(tmpGroup.RecordSetAddress);

				// Run the solver
				this.pict.providers.DynamicSolver.solveViews();

				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}

	/**
	 * Render every view in pViewsToRender while preserving pRecordSetAddress's data in
	 * the model. Re-rendering a table that contains entity-selector cells (Material /
	 * Organization / Product / etc.) destroys and recreates their select2 widgets; the
	 * transient empty widget gets read back into the model and wipes the selected value
	 * AND its resolved __Record for EVERY row -- the "selected Source / Name disappears
	 * after adding or deleting a row" data-loss bug. Because it clobbers the saved
	 * FormData, the value is then also missing from the exported PDF. A render() must be
	 * model-non-destructive, so snapshot the record set before rendering and restore any
	 * cleared fields afterward. No-op for plain (non-entity) tables, where render never
	 * changes the model (snapshot == post-render state, restore is a no-op).
	 *
	 * @param {string} pRecordSetAddress - RecordSetAddress of the table being re-rendered.
	 * @param {Array<Object>} pViewsToRender - Views bound to that record set to render.
	 */
	_renderViewsPreservingRecordSet(pRecordSetAddress, pViewsToRender)
	{
		if (!Array.isArray(pViewsToRender) || (pViewsToRender.length < 1))
		{
			return;
		}
		// Snapshot the record set (deep clone each row) from a view that owns it.
		let tmpRecordSet = false;
		let tmpSnapshot = false;
		for (let i = 0; i < pViewsToRender.length; i++)
		{
			let tmpCandidate = pViewsToRender[i].sectionManifest.getValueByHash(pViewsToRender[i].getMarshalDestinationObject(), pRecordSetAddress);
			if (Array.isArray(tmpCandidate))
			{
				tmpRecordSet = tmpCandidate;
				tmpSnapshot = tmpCandidate.map((pRow) => (pRow && (typeof pRow === 'object')) ? JSON.parse(JSON.stringify(pRow)) : pRow);
				break;
			}
		}
		for (let i = 0; i < pViewsToRender.length; i++)
		{
			pViewsToRender[i].render();
		}
		// Restore any model fields a destructive re-render cleared (entity value + __Record).
		if (Array.isArray(tmpRecordSet) && Array.isArray(tmpSnapshot))
		{
			for (let i = 0; i < tmpRecordSet.length; i++)
			{
				if (tmpRecordSet[i] && (typeof tmpRecordSet[i] === 'object') && tmpSnapshot[i] && (typeof tmpSnapshot[i] === 'object'))
				{
					Object.assign(tmpRecordSet[i], tmpSnapshot[i]);
				}
			}
		}
	}

	/**
	 * Rebuild every OTHER section-form view whose DynamicColumns are sourced from
	 * pSourceRecordSetAddress: re-resolve their generated columns and rebuild their
	 * template + DOM. Call this in the RENDER phase (after a source row was added or
	 * removed, before solving + marshaling) so dependent tables paint their column
	 * changes up front instead of mid-marshal. Idempotent and safe when there are no
	 * dependent views (it simply finds none).
	 *
	 * @param {string} pSourceRecordSetAddress - RecordSetAddress whose rows drive the columns.
	 */
	_rebuildDependentDynamicColumnViews(pSourceRecordSetAddress)
	{
		if ((typeof pSourceRecordSetAddress !== 'string') || (pSourceRecordSetAddress.length < 1))
		{
			return;
		}
		if (!this.pict.views.PictFormMetacontroller)
		{
			return;
		}
		let tmpDependentViews = this.pict.views.PictFormMetacontroller.filterViews(
			(pViewToTest) =>
			{
				if (!pViewToTest.isPictSectionForm)
				{
					return false;
				}
				let tmpGroups = pViewToTest.getGroups();
				for (let i = 0; i < tmpGroups.length; i++)
				{
					let tmpDynamicColumns = tmpGroups[i].DynamicColumns;
					if (!Array.isArray(tmpDynamicColumns))
					{
						continue;
					}
					for (let g = 0; g < tmpDynamicColumns.length; g++)
					{
						if (tmpDynamicColumns[g] && (tmpDynamicColumns[g].SourceAddress === pSourceRecordSetAddress))
						{
							return true;
						}
					}
				}
				return false;
			});
		for (let i = 0; i < tmpDependentViews.length; i++)
		{
			let tmpView = tmpDependentViews[i];
			let tmpGroups = tmpView.getGroups();
			for (let g = 0; g < tmpGroups.length; g++)
			{
				let tmpGroup = tmpGroups[g];
				if (Array.isArray(tmpGroup.DynamicColumns) && (tmpGroup.DynamicColumns.length > 0) &&
					this.fable.ManifestFactory && (typeof this.fable.ManifestFactory._resolveDynamicColumns === 'function'))
				{
					this.fable.ManifestFactory._resolveDynamicColumns(tmpView, tmpGroup);
				}
			}
			tmpView.rebuildCustomTemplate();
			tmpView.render();
		}
	}

	/**
	 * For position-keyed DynamicColumns (KeyBy: "Position") sourced from
	 * pSourceRecordSetAddress, shift each dependent row's positional cells down past
	 * a just-removed source index so values stay aligned with their column. Cells are
	 * addressed by resolving the generator's InformaryDataAddressTemplate with the
	 * synthetic { __Index } record, the same way columns are generated. No-op for
	 * value-keyed generators (their data stays attached to the stable value).
	 *
	 * @param {string} pSourceRecordSetAddress - RecordSetAddress of the deleted-from source.
	 * @param {number} pDeletedIndex - Index of the source row that was removed.
	 * @param {number} pOriginalLength - Source row count BEFORE the removal.
	 */
	_spliceDependentPositionalColumns(pSourceRecordSetAddress, pDeletedIndex, pOriginalLength)
	{
		if ((typeof pSourceRecordSetAddress !== 'string') || (pSourceRecordSetAddress.length < 1))
		{
			return;
		}
		if (!this.pict.views.PictFormMetacontroller)
		{
			return;
		}
		let tmpManifestFactory = this.fable.ManifestFactory;
		if (!tmpManifestFactory || (typeof tmpManifestFactory._parseDynamicColumnTemplate !== 'function'))
		{
			return;
		}
		let tmpViews = this.pict.views.PictFormMetacontroller.filterViews((pViewToTest) => { return pViewToTest.isPictSectionForm; });
		for (let v = 0; v < tmpViews.length; v++)
		{
			let tmpView = tmpViews[v];
			let tmpGroups = tmpView.getGroups();
			for (let g = 0; g < tmpGroups.length; g++)
			{
				let tmpGroup = tmpGroups[g];
				if (!Array.isArray(tmpGroup.DynamicColumns) || (tmpGroup.DynamicColumns.length < 1))
				{
					continue;
				}
				let tmpDependentRows = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
				if (!Array.isArray(tmpDependentRows) || (tmpDependentRows.length < 1))
				{
					continue;
				}
				for (let c = 0; c < tmpGroup.DynamicColumns.length; c++)
				{
					let tmpGenerator = tmpGroup.DynamicColumns[c];
					if (!tmpGenerator || (tmpGenerator.SourceAddress !== pSourceRecordSetAddress))
					{
						continue;
					}
					// Only position-keyed generators store data by index; value-keyed columns keep
					// their data attached to the (stable) value, so they need no shifting.
					if (tmpGenerator.KeyBy !== 'Position')
					{
						continue;
					}
					if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string')
					{
						continue;
					}
					// Resolve the positional cell address for each original column index once.
					let tmpAddresses = [];
					for (let k = 0; k < pOriginalLength; k++)
					{
						tmpAddresses[k] = tmpManifestFactory._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, { __Index: k, __RowNumber: k + 1 });
					}
					for (let r = 0; r < tmpDependentRows.length; r++)
					{
						let tmpRow = tmpDependentRows[r];
						if (!tmpRow || (typeof tmpRow !== 'object'))
						{
							continue;
						}
						// Shift every cell below the deleted index down by one.
						for (let k = pDeletedIndex; k < (pOriginalLength - 1); k++)
						{
							if (!tmpAddresses[k] || !tmpAddresses[k + 1])
							{
								continue;
							}
							let tmpNextValue = tmpView.sectionManifest.getValueByHash(tmpRow, tmpAddresses[k + 1]);
							tmpView.sectionManifest.setValueByHash(tmpRow, tmpAddresses[k], tmpNextValue);
						}
						// Clear the now-orphaned final positional cell.
						let tmpLastAddress = tmpAddresses[pOriginalLength - 1];
						if (tmpLastAddress)
						{
							tmpView.sectionManifest.setValueByHash(tmpRow, tmpLastAddress, undefined);
						}
					}
				}
			}
		}
	}

	/**
	 * For position-keyed DynamicColumns (KeyBy: "Position") sourced from
	 * pSourceRecordSetAddress, REORDER each dependent row's positional cells to
	 * mirror a source row that moved from pOldIndex to pNewIndex. The source array
	 * was already spliced (remove at pOldIndex, insert at pNewIndex); this applies
	 * the identical permutation to every dependent row's positional cell VALUES so
	 * the data stays attached to its column when the columns re-resolve to the new
	 * source order. Without it, a reorder leaves user-entered cells under the wrong
	 * (renamed) column. Solver-filled rows re-derive on the next solve regardless;
	 * applying the move to them too is harmless (the solve overwrites them). No-op
	 * for value-keyed generators (their data stays attached to the stable value).
	 *
	 * Must run AFTER the source splice and BEFORE the dependent views re-resolve +
	 * the marshal repaints them. Symmetric with _spliceDependentPositionalColumns.
	 *
	 * @param {string} pSourceRecordSetAddress - RecordSetAddress of the moved-within source.
	 * @param {number} pOldIndex - Source row's index before the move.
	 * @param {number} pNewIndex - Source row's index after the move.
	 * @param {number} pLength - Source row count (unchanged by a move).
	 */
	_moveDependentPositionalColumns(pSourceRecordSetAddress, pOldIndex, pNewIndex, pLength)
	{
		if ((typeof pSourceRecordSetAddress !== 'string') || (pSourceRecordSetAddress.length < 1))
		{
			return;
		}
		if (pOldIndex === pNewIndex)
		{
			return;
		}
		if (!this.pict.views.PictFormMetacontroller)
		{
			return;
		}
		let tmpManifestFactory = this.fable.ManifestFactory;
		if (!tmpManifestFactory || (typeof tmpManifestFactory._parseDynamicColumnTemplate !== 'function'))
		{
			return;
		}
		let tmpViews = this.pict.views.PictFormMetacontroller.filterViews((pViewToTest) => { return pViewToTest.isPictSectionForm; });
		for (let v = 0; v < tmpViews.length; v++)
		{
			let tmpView = tmpViews[v];
			let tmpGroups = tmpView.getGroups();
			for (let g = 0; g < tmpGroups.length; g++)
			{
				let tmpGroup = tmpGroups[g];
				if (!Array.isArray(tmpGroup.DynamicColumns) || (tmpGroup.DynamicColumns.length < 1))
				{
					continue;
				}
				let tmpDependentRows = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
				if (!Array.isArray(tmpDependentRows) || (tmpDependentRows.length < 1))
				{
					continue;
				}
				for (let c = 0; c < tmpGroup.DynamicColumns.length; c++)
				{
					let tmpGenerator = tmpGroup.DynamicColumns[c];
					if (!tmpGenerator || (tmpGenerator.SourceAddress !== pSourceRecordSetAddress))
					{
						continue;
					}
					// Only position-keyed generators store data by index; value-keyed columns keep
					// their data attached to the (stable) value, so they need no reordering.
					if (tmpGenerator.KeyBy !== 'Position')
					{
						continue;
					}
					if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string')
					{
						continue;
					}
					// Resolve the positional cell address for each column index once.
					let tmpAddresses = [];
					for (let k = 0; k < pLength; k++)
					{
						tmpAddresses[k] = tmpManifestFactory._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, { __Index: k, __RowNumber: k + 1 });
					}
					for (let r = 0; r < tmpDependentRows.length; r++)
					{
						let tmpRow = tmpDependentRows[r];
						if (!tmpRow || (typeof tmpRow !== 'object'))
						{
							continue;
						}
						// Read the current positional cell values, apply the identical
						// remove-at-old / insert-at-new permutation, then write them back.
						let tmpValues = [];
						for (let k = 0; k < pLength; k++)
						{
							tmpValues[k] = tmpAddresses[k] ? tmpView.sectionManifest.getValueByHash(tmpRow, tmpAddresses[k]) : undefined;
						}
						let tmpMoved = tmpValues.splice(pOldIndex, 1);
						tmpValues.splice(pNewIndex, 0, tmpMoved[0]);
						for (let k = 0; k < pLength; k++)
						{
							if (tmpAddresses[k])
							{
								tmpView.sectionManifest.setValueByHash(tmpRow, tmpAddresses[k], tmpValues[k]);
							}
						}
					}
				}
			}
		}
	}

	/**
	 * Shared tail for the row-reorder handlers (move up / move down / set index).
	 * Repaints the moved source table and every dependent view, in the RENDER phase
	 * BEFORE solving + marshaling, then solves and marshals. Mirrors what the add /
	 * delete handlers do so a reorder doesn't blank dependent DynamicColumns tables
	 * (or the rest of their section) until the next edit. Render happens before the
	 * solve so the solve's DOM side effects (e.g. SetGroupVisibility) land on the
	 * freshly rebuilt DOM and survive.
	 *
	 * @param {Object} pGroup - The reordered group (its RecordSetAddress drives dependents).
	 */
	_repaintAfterRowReorder(pView, pGroup)
	{
		// A reorder (move up/down/set-index) preserves the row COUNT -- the source table's DOM rows
		// already exist; only which row holds which value changes. A full source-view render() would
		// tear down and re-create every cell widget, and each entity-selector select2 re-init costs
		// roughly O(document size), so on a large form that is SECONDS per move. Skip the source
		// render and let the marshal below push the reordered model values into the existing DOM rows
		// in place. (Add/delete change the row count and still render via their own paths.) Skipping
		// the render also removes the need for the snapshot/restore in _renderViewsPreservingRecordSet:
		// with no destructive render, the entity values are never clobbered.

		// Dependent DynamicColumns views still need their generated column labels re-resolved for the
		// new order (cheap -- those tables carry no entity widgets).
		this._rebuildDependentDynamicColumnViews(pGroup.RecordSetAddress);

		// Run the solver, then marshal the model back out to the existing form DOM.
		this.pict.providers.DynamicSolver.solveViews();
		this.pict.views.PictFormMetacontroller.marshalFormSections();

		// marshalFormSections updates simple cells in place, but a stateful widget (an entity
		// selector's select2) will not switch to a reordered value whose <option> isn't the one it
		// currently shows. Ask each input provider to repaint its display for the new row order:
		// entity selectors force their select2 to the row's current value, everything else no-ops.
		// Cheap (in-place value set, no widget teardown) versus the full re-render this replaced.
		if (pView && (typeof pView.runInputProviderFunctions === 'function'))
		{
			pView.runInputProviderFunctions('onTabularRowReorderRepaint', null, null, this.fable.getUUID());
		}
	}
}

module.exports = DynamicTabularData;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],506:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libDynamicInput = require('../providers/Pict-Provider-DynamicInput.js');

const templateSetDefaultFormTemplates = require('./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js');
const templateSetReadOnlyTemplates = require('./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js');

const libTemplateValueSetWithGroup = require('../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js');
const libTemplateDynamicInput = require('../templates/Pict-Template-Metatemplate-Input.js');
const libTemplateDynamicInputWithHashAddress = require('../templates/Pict-Template-Metatemplate-InputWithHashAddress.js');
const libTemplateDynamicInputWithView = require('../templates/Pict-Template-Metatemplate-InputWithView.js');
const libTemplateDynamicInputWithViewAndHashAddress = require('../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js');
const libTemplateDynamicInputWithViewAndDescriptorAddress = require('../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js');
const libTemplateControlFromDynamicManifest = require('../templates/Pict-Template-ControlFromDynamicManifest.js');
const libTemplateControlFromDynamicManifestForHash = require('../templates/Pict-Template-ControlFromDynamicManifestForHash.js');
const libTemplateGetViewSchemaValue = require('../templates/Pict-Template-DyanmicView-Value.js');
const libTemplateGetViewSchemaValueByHash = require('../templates/Pict-Template-DyanmicView-ValueByHash.js');
const libTemplateTabularRowLabels = require('../templates/Pict-Template-TabularRowLabels.js');
const libTemplateTabularEditingControls = require('../templates/Pict-Template-TabularEditingControls.js');


// TODO: This is temporary until we publish new pict
const libTemplatePluckJoinUnique = require('../templates/Pict-Template-Proxy-PluckJoinUnique.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetaTemplates-Basic",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a class that provides dynamic templates for the Pict form section provider.
 * @extends libPictProvider
 */
class PictDynamicFormsTemplates extends libPictProvider
{
	/**
	 * Constructs a new instance of the PictProviderDynamicTemplates class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		this.pict.addProviderSingleton('DynamicInput', libDynamicInput.default_configuration, libDynamicInput);

		this.pict.addTemplate(libTemplateValueSetWithGroup);
		this.pict.addTemplate(libTemplateDynamicInput);
		this.pict.addTemplate(libTemplateDynamicInputWithHashAddress);
		this.pict.addTemplate(libTemplateDynamicInputWithView);
		this.pict.addTemplate(libTemplateDynamicInputWithViewAndHashAddress);
		this.pict.addTemplate(libTemplateDynamicInputWithViewAndDescriptorAddress);
		this.pict.addTemplate(libTemplatePluckJoinUnique);
		this.pict.addTemplate(libTemplateControlFromDynamicManifest);
		this.pict.addTemplate(libTemplateControlFromDynamicManifestForHash);
		this.pict.addTemplate(libTemplateGetViewSchemaValue);
		this.pict.addTemplate(libTemplateGetViewSchemaValueByHash);
		this.pict.addTemplate(libTemplateTabularRowLabels);
		this.pict.addTemplate(libTemplateTabularEditingControls);

		if (this.options?.MetaTemplateSet && typeof(this.options.MetaTemplateSet) === 'object')
		{
			this.injectTemplateSet(this.options.MetaTemplateSet);
		}
		else
		{
			this.injectTemplateSet(templateSetDefaultFormTemplates);
		}
		this.injectTemplateSet(templateSetReadOnlyTemplates);
	}

	/**
	 * Injects a template set into Pict for the Dynamic Form Section Provider.
	 *
	 * The TemplateSet object expects to have a `TemplatePrefix` and `Templates` property.
	 *
	 * The `TemplatePrefix` is used to prefix the hash of the template.
	 *
	 * The `Templates` property is an array of objects with the following properties:
	 * - `HashPostfix` - The postfix to be added to the template hash.  This defines which dynamic template in the Layout it represents.
	 * - `Template` - The template string to be injected.
	 * - `DefaultInputExtensions` - An optional array of default input extensions to be added to the Dynamic Input provider.
	 *
	 * The context of the template *is not the data*.  The template context is one of these five things depending on the layout layer:
	 * - `Form` - The form object.
	 * - `Section` - The section object.
	 * - `Group` - The group object.
	 * - `Row` - The row object.
	 * - `Input` - The input object.
	 *
	 * @param {Object} pTemplateSet - The template set to be injected.
	 */
	injectTemplateSet(pTemplateSet)
	{
		let tmpTemplatePrefix = 'PictFormsUnknown';
		let tmpTemplates = [];
		let tmpTemplateSet = {};

		tmpTemplatePrefix = this.options?.MetaTemplateSet ?? tmpTemplatePrefix;
		tmpTemplates = this.options?.MetaTemplateSet?.Templates ?? tmpTemplates;

		tmpTemplatePrefix = pTemplateSet?.TemplatePrefix ?? tmpTemplatePrefix;
		tmpTemplates = pTemplateSet?.Templates ?? tmpTemplates;

		for (let i = 0; i < tmpTemplates.length; i++)
		{
			let tmpMetaTemplate = tmpTemplates[i];
			let tmpMetaTemplateHash = `${tmpTemplatePrefix}${tmpMetaTemplate.HashPostfix}`;
			tmpTemplateSet[tmpMetaTemplateHash] = (
				{
					Hash: tmpMetaTemplateHash,
					Template: tmpMetaTemplate.Template
				});
			if (tmpMetaTemplate.hasOwnProperty('DefaultInputExtensions'))
			{
				tmpTemplateSet[tmpMetaTemplateHash].DefaultInputExtensions = JSON.parse(JSON.stringify(tmpMetaTemplate.DefaultInputExtensions));
			}
		}

		for (let i = 0; i < templateSetDefaultFormTemplates.Templates.length; i++)
		{
			let tmpTemplate = templateSetDefaultFormTemplates.Templates[i];
			let tmpTemplateHash = `${tmpTemplatePrefix}${tmpTemplate.HashPostfix}`;
			// Only load default templates if they are not already defined in the options
			if (!(tmpTemplateHash in tmpTemplateSet))
			{
				tmpTemplateSet[tmpTemplateHash] = (
					{
						Hash: tmpTemplateHash,
						Template: tmpTemplate.Template
					});
				if (tmpTemplate.hasOwnProperty('DefaultInputExtensions'))
				{
					tmpTemplateSet[tmpTemplateHash].DefaultInputExtensions = JSON.parse(JSON.stringify(tmpTemplate.DefaultInputExtensions));
				}
			}
		}

		let tmpTemplateList = Object.keys(tmpTemplateSet);
		this.log.info(`Pict Form Section Provider for [${tmpTemplatePrefix}] Loaded ${tmpTemplateList.length} templates.`);
		for (let i = 0; i < tmpTemplateList.length; i++)
		{
			let tmpMetaTemplate = tmpTemplateSet[tmpTemplateList[i]];
			this.pict.TemplateProvider.addTemplate(tmpMetaTemplate.Hash, tmpMetaTemplate.Template);
			if (tmpMetaTemplate.hasOwnProperty('DefaultInputExtensions'))
			{
				for (let i = 0; i < tmpMetaTemplate.DefaultInputExtensions.length; i++)
				{
					this.pict.providers.DynamicInput.addDefaultInputProvider(tmpMetaTemplate.Hash, tmpMetaTemplate.DefaultInputExtensions[i]);
				}
			}
		}
	}
}

module.exports = PictDynamicFormsTemplates;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../providers/Pict-Provider-DynamicInput.js":500,"../templates/Pict-Template-ControlFromDynamicManifest.js":549,"../templates/Pict-Template-ControlFromDynamicManifestForHash.js":550,"../templates/Pict-Template-DyanmicView-Value.js":551,"../templates/Pict-Template-DyanmicView-ValueByHash.js":552,"../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js":553,"../templates/Pict-Template-Metatemplate-Input.js":554,"../templates/Pict-Template-Metatemplate-InputWithHashAddress.js":555,"../templates/Pict-Template-Metatemplate-InputWithView.js":556,"../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js":557,"../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js":558,"../templates/Pict-Template-Proxy-PluckJoinUnique.js":559,"../templates/Pict-Template-TabularEditingControls.js":560,"../templates/Pict-Template-TabularRowLabels.js":561,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js":514,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js":515,"pict-provider":479}],507:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Provider-FormPersistence",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false,

	// Scoping configuration
	// Override the app identifier; defaults to pict.settings.Product
	"AppIdentifier": false,
	// Override the form type identifier; defaults to "DefaultForm"
	"FormTypeIdentifier": false,

	// Auto-persistence settings
	// When true, the provider will automatically persist the active form on data changes
	// triggered from DynamicForm views (dataChanged / dataChangedTabular).
	"AutoPersistOnDataChange": false,
	"AutoPersistDebounceMs": 2000,
	// When true, bundle data is also saved alongside form data during autosave
	// if the active form record has a BundleContextIdentifier.
	"AutoPersistBundleWithForm": true,

	// Storage key prefix
	"StorageKeyPrefix": "PSF",

	// The address to resolve bundle data from (e.g. "Bundle")
	"BundleSourceAddress": "Bundle",
	// The address to resolve form data from; false means use DataBroker.marshalDestination
	"FormDataSourceAddress": false
});

/**
 * Provider for offline form data persistence.
 *
 * Stores form data and bundle data in scoped records (localStorage by default).
 * The wrapping application can override the storage backend by calling setStorageAdapter().
 *
 * This provider is opt-in; the wrapping application registers it when needed.
 *
 * @extends libPictProvider
 */
class PictFormPersistence extends libPictProvider
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {string|null} */
		this._activeFormGUID = null;

		/** @type {any} */
		this._persistTimerHandle = null;

		// Initialize the default localStorage adapter
		this.storageAdapter = this.createLocalStorageAdapter();
	}

	// ========================================================================
	// Storage Adapter
	// ========================================================================

	/**
	 * Creates the default localStorage adapter.
	 *
	 * @returns {object} An adapter object with setItem, getItem, removeItem, getKeysWithPrefix methods.
	 */
	createLocalStorageAdapter()
	{
		let tmpSelf = this;

		return (
		{
			setItem: function (pKey, pValue)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						window.localStorage.setItem(pKey, pValue);
						return true;
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return false;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage setItem error: ${pError.message}`);
					return false;
				}
			},

			getItem: function (pKey)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						return window.localStorage.getItem(pKey);
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return null;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage getItem error: ${pError.message}`);
					return null;
				}
			},

			removeItem: function (pKey)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						window.localStorage.removeItem(pKey);
						return true;
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return false;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage removeItem error: ${pError.message}`);
					return false;
				}
			},

			getKeysWithPrefix: function (pPrefix)
			{
				let tmpKeys = [];
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						for (let i = 0; i < window.localStorage.length; i++)
						{
							let tmpKey = window.localStorage.key(i);
							if (tmpKey && tmpKey.startsWith(pPrefix))
							{
								tmpKeys.push(tmpKey);
							}
						}
					}
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage getKeysWithPrefix error: ${pError.message}`);
				}
				return tmpKeys;
			}
		});
	}

	/**
	 * Replace the storage adapter with a custom implementation.
	 *
	 * The adapter must implement: setItem(key, value), getItem(key), removeItem(key), getKeysWithPrefix(prefix).
	 *
	 * @param {object} pAdapter - The storage adapter to use.
	 * @returns {boolean} True if the adapter was accepted.
	 */
	setStorageAdapter(pAdapter)
	{
		if (typeof (pAdapter) !== 'object' || pAdapter === null)
		{
			this.log.error('FormPersistence setStorageAdapter called with an invalid adapter.');
			return false;
		}

		let tmpRequiredMethods = ['setItem', 'getItem', 'removeItem', 'getKeysWithPrefix'];

		for (let i = 0; i < tmpRequiredMethods.length; i++)
		{
			if (typeof (pAdapter[tmpRequiredMethods[i]]) !== 'function')
			{
				this.log.error(`FormPersistence setStorageAdapter: adapter is missing required method [${tmpRequiredMethods[i]}].`);
				return false;
			}
		}

		this.storageAdapter = pAdapter;
		return true;
	}

	// ========================================================================
	// Key Generation
	// ========================================================================

	/**
	 * Returns the application identifier for storage key scoping.
	 *
	 * @returns {string}
	 */
	getAppIdentifier()
	{
		if (this.options.AppIdentifier)
		{
			return this.options.AppIdentifier;
		}
		if (this.pict && this.pict.settings && this.pict.settings.Product)
		{
			return this.pict.settings.Product;
		}
		return 'DefaultApp';
	}

	/**
	 * Returns the form type identifier for storage key scoping.
	 *
	 * @returns {string}
	 */
	getFormTypeIdentifier()
	{
		if (this.options.FormTypeIdentifier)
		{
			return this.options.FormTypeIdentifier;
		}
		return 'DefaultForm';
	}

	/**
	 * Builds a storage key for a specific record type and identifier.
	 *
	 * @param {string} pRecordType - The record type (e.g. "Form", "Bundle", "Index").
	 * @param {string} [pIdentifier] - The specific record identifier (e.g. GUID or context ID).
	 * @returns {string} The fully qualified storage key.
	 */
	getStorageKey(pRecordType, pIdentifier)
	{
		let tmpPrefix = `${this.options.StorageKeyPrefix}:${this.getAppIdentifier()}:${this.getFormTypeIdentifier()}`;

		if (pIdentifier)
		{
			return `${tmpPrefix}:${pRecordType}:${pIdentifier}`;
		}
		return `${tmpPrefix}:${pRecordType}`;
	}

	/**
	 * Returns the storage key for the form index.
	 *
	 * @returns {string}
	 */
	getIndexKey()
	{
		return this.getStorageKey('Index');
	}

	// ========================================================================
	// Index Management
	// ========================================================================

	/**
	 * Retrieves the form index from storage.
	 *
	 * The index contains metadata for all persisted form records.
	 *
	 * @returns {object} The index object with a Records property.
	 */
	getFormIndex()
	{
		let tmpIndexKey = this.getIndexKey();
		let tmpRawIndex = this.storageAdapter.getItem(tmpIndexKey);

		if (tmpRawIndex)
		{
			try
			{
				let tmpIndex = JSON.parse(tmpRawIndex);
				if (typeof (tmpIndex) === 'object' && tmpIndex !== null && ('Records' in tmpIndex))
				{
					return tmpIndex;
				}
			}
			catch (pError)
			{
				this.log.error(`FormPersistence getFormIndex: failed to parse index: ${pError.message}`);
			}
		}

		// Return a fresh empty index
		return { Records: {} };
	}

	/**
	 * Saves the form index to storage.
	 *
	 * @param {object} pIndex - The index object to persist.
	 * @returns {boolean} True if saved successfully.
	 */
	_saveFormIndex(pIndex)
	{
		let tmpIndexKey = this.getIndexKey();
		return this.storageAdapter.setItem(tmpIndexKey, JSON.stringify(pIndex));
	}

	// ========================================================================
	// Form Data CRUD
	// ========================================================================

	/**
	 * Creates a new form record in the index and returns its GUID.
	 *
	 * This does not save any form data yet; it only creates the index entry.
	 * Call saveFormData() to persist the actual form content.
	 *
	 * @param {string} [pBundleContextIdentifier] - An optional context identifier linking this form to a bundle (e.g. a project ID).
	 * @param {string} [pLabel] - An optional human-readable label for this form instance.
	 * @returns {string} The GUID assigned to the new form record.
	 */
	newFormRecord(pBundleContextIdentifier, pLabel)
	{
		let tmpGUID = this.fable.getUUID();
		let tmpNow = new Date().toISOString();

		let tmpFormIndex = this.getFormIndex();

		tmpFormIndex.Records[tmpGUID] = (
		{
			GUID: tmpGUID,
			Created: tmpNow,
			Modified: tmpNow,
			BundleContextIdentifier: pBundleContextIdentifier || null,
			Synced: false,
			SyncedTimestamp: null,
			Label: pLabel || null
		});

		this._saveFormIndex(tmpFormIndex);

		this.log.info(`FormPersistence: created new form record [${tmpGUID}]${pLabel ? ` labeled "${pLabel}"` : ''}.`);

		return tmpGUID;
	}

	/**
	 * Saves the current in-memory form data to storage for a specific instance GUID.
	 *
	 * Reads from the DataBroker marshal destination (or the configured FormDataSourceAddress).
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to save.
	 * @returns {boolean} True if saved successfully.
	 */
	saveFormData(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence saveFormData called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();
		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.error(`FormPersistence saveFormData called for unknown GUID [${pInstanceGUID}].`);
			return false;
		}

		let tmpFormDataSource;
		try
		{
			if (this.options.FormDataSourceAddress)
			{
				tmpFormDataSource = this.pict.resolveStateFromAddress(this.options.FormDataSourceAddress);
			}
			else
			{
				tmpFormDataSource = this.pict.providers.DataBroker.marshalDestinationObject;
			}
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveFormData: failed to resolve form data source: ${pError.message}`);
			return false;
		}

		let tmpSerializedData;
		try
		{
			tmpSerializedData = JSON.stringify(tmpFormDataSource);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveFormData: failed to serialize form data: ${pError.message}`);
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		let tmpResult = this.storageAdapter.setItem(tmpStorageKey, tmpSerializedData);

		if (tmpResult)
		{
			// Update index metadata
			tmpFormIndex.Records[pInstanceGUID].Modified = new Date().toISOString();
			tmpFormIndex.Records[pInstanceGUID].Synced = false;
			this._saveFormIndex(tmpFormIndex);
		}

		return tmpResult;
	}

	/**
	 * Returns the raw serialized form data string for a given GUID without loading it into memory.
	 *
	 * Useful for synchronization -- the wrapping app can send this directly to the server.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {string|null} The raw JSON string, or null if not found.
	 */
	getFormDataRaw(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence getFormDataRaw called without an instance GUID.');
			return null;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		return this.storageAdapter.getItem(tmpStorageKey);
	}

	/**
	 * Loads form data from storage and applies it to the in-memory marshal destination.
	 *
	 * After loading, calls marshalToView() on the metacontroller if available.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to load.
	 * @returns {boolean} True if loaded successfully.
	 */
	loadFormData(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence loadFormData called without an instance GUID.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		let tmpSerializedData = this.storageAdapter.getItem(tmpStorageKey);

		if (tmpSerializedData === null)
		{
			this.log.warn(`FormPersistence loadFormData: no data found for GUID [${pInstanceGUID}].`);
			return false;
		}

		let tmpFormData;
		try
		{
			tmpFormData = JSON.parse(tmpSerializedData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadFormData: failed to parse stored data for GUID [${pInstanceGUID}]: ${pError.message}`);
			return false;
		}

		// Resolve the destination object
		let tmpDestinationObject;
		try
		{
			if (this.options.FormDataSourceAddress)
			{
				tmpDestinationObject = this.pict.resolveStateFromAddress(this.options.FormDataSourceAddress);
			}
			else
			{
				tmpDestinationObject = this.pict.providers.DataBroker.marshalDestinationObject;
			}
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadFormData: failed to resolve destination object: ${pError.message}`);
			return false;
		}

		// Clear existing data and apply loaded data
		let tmpExistingKeys = Object.keys(tmpDestinationObject);
		for (let i = 0; i < tmpExistingKeys.length; i++)
		{
			delete tmpDestinationObject[tmpExistingKeys[i]];
		}
		Object.assign(tmpDestinationObject, tmpFormData);

		// Marshal to view if the metacontroller is available
		if (this.pict.views && this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalToView();
		}

		this.log.info(`FormPersistence: loaded form data for GUID [${pInstanceGUID}].`);
		return true;
	}

	/**
	 * Deletes a form record from storage and removes it from the index.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to delete.
	 * @returns {boolean} True if deleted successfully.
	 */
	deleteFormRecord(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence deleteFormRecord called without an instance GUID.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		this.storageAdapter.removeItem(tmpStorageKey);

		let tmpFormIndex = this.getFormIndex();
		if (pInstanceGUID in tmpFormIndex.Records)
		{
			delete tmpFormIndex.Records[pInstanceGUID];
			this._saveFormIndex(tmpFormIndex);
		}

		this.log.info(`FormPersistence: deleted form record [${pInstanceGUID}].`);
		return true;
	}

	// ========================================================================
	// Bundle Data
	// ========================================================================

	/**
	 * Saves bundle data for a given context identifier.
	 *
	 * Reads from the configured BundleSourceAddress (default: "Bundle").
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier (e.g. a project ID).
	 * @returns {boolean} True if saved successfully.
	 */
	saveBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence saveBundleData called without a context identifier.');
			return false;
		}

		let tmpBundleData;
		try
		{
			tmpBundleData = this.pict.resolveStateFromAddress(this.options.BundleSourceAddress);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveBundleData: failed to resolve bundle data source: ${pError.message}`);
			return false;
		}

		let tmpSerializedData;
		try
		{
			tmpSerializedData = JSON.stringify(tmpBundleData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveBundleData: failed to serialize bundle data: ${pError.message}`);
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		return this.storageAdapter.setItem(tmpStorageKey, tmpSerializedData);
	}

	/**
	 * Loads bundle data for a given context identifier into the bundle source address.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier (e.g. a project ID).
	 * @returns {boolean} True if loaded successfully.
	 */
	loadBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence loadBundleData called without a context identifier.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		let tmpSerializedData = this.storageAdapter.getItem(tmpStorageKey);

		if (tmpSerializedData === null)
		{
			this.log.warn(`FormPersistence loadBundleData: no data found for context [${pContextIdentifier}].`);
			return false;
		}

		let tmpBundleData;
		try
		{
			tmpBundleData = JSON.parse(tmpSerializedData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadBundleData: failed to parse stored data for context [${pContextIdentifier}]: ${pError.message}`);
			return false;
		}

		// Resolve the bundle destination
		let tmpBundleDestination;
		try
		{
			tmpBundleDestination = this.pict.resolveStateFromAddress(this.options.BundleSourceAddress);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadBundleData: failed to resolve bundle destination: ${pError.message}`);
			return false;
		}

		// Clear existing bundle data and apply loaded data
		let tmpExistingKeys = Object.keys(tmpBundleDestination);
		for (let i = 0; i < tmpExistingKeys.length; i++)
		{
			delete tmpBundleDestination[tmpExistingKeys[i]];
		}
		Object.assign(tmpBundleDestination, tmpBundleData);

		this.log.info(`FormPersistence: loaded bundle data for context [${pContextIdentifier}].`);
		return true;
	}

	/**
	 * Deletes bundle data for a given context identifier.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier.
	 * @returns {boolean} True if deleted successfully.
	 */
	deleteBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence deleteBundleData called without a context identifier.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		this.storageAdapter.removeItem(tmpStorageKey);

		this.log.info(`FormPersistence: deleted bundle data for context [${pContextIdentifier}].`);
		return true;
	}

	// ========================================================================
	// Listing
	// ========================================================================

	/**
	 * Returns an array of all form record metadata objects from the index.
	 *
	 * @returns {Array<object>} An array of form record metadata.
	 */
	listFormRecords()
	{
		let tmpFormIndex = this.getFormIndex();
		return Object.values(tmpFormIndex.Records);
	}

	/**
	 * Returns an array of form records that have not been marked as synced.
	 *
	 * @returns {Array<object>} An array of unsynced form record metadata.
	 */
	listUnsyncedFormRecords()
	{
		let tmpRecords = this.listFormRecords();
		let tmpUnsynced = [];

		for (let i = 0; i < tmpRecords.length; i++)
		{
			if (!tmpRecords[i].Synced)
			{
				tmpUnsynced.push(tmpRecords[i]);
			}
		}

		return tmpUnsynced;
	}

	/**
	 * Returns an array of form records associated with a specific bundle context.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier.
	 * @returns {Array<object>} An array of matching form record metadata.
	 */
	listFormRecordsForContext(pContextIdentifier)
	{
		let tmpRecords = this.listFormRecords();
		let tmpMatching = [];

		for (let i = 0; i < tmpRecords.length; i++)
		{
			if (tmpRecords[i].BundleContextIdentifier === pContextIdentifier)
			{
				tmpMatching.push(tmpRecords[i]);
			}
		}

		return tmpMatching;
	}

	// ========================================================================
	// Sync Support
	// ========================================================================

	/**
	 * Marks a form record as synced.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {boolean} True if the record was found and updated.
	 */
	markFormSynced(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence markFormSynced called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();

		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.warn(`FormPersistence markFormSynced: GUID [${pInstanceGUID}] not found in index.`);
			return false;
		}

		tmpFormIndex.Records[pInstanceGUID].Synced = true;
		tmpFormIndex.Records[pInstanceGUID].SyncedTimestamp = new Date().toISOString();
		this._saveFormIndex(tmpFormIndex);

		return true;
	}

	/**
	 * Marks a form record as dirty (unsynced).
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {boolean} True if the record was found and updated.
	 */
	markFormDirty(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence markFormDirty called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();

		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.warn(`FormPersistence markFormDirty: GUID [${pInstanceGUID}] not found in index.`);
			return false;
		}

		tmpFormIndex.Records[pInstanceGUID].Synced = false;
		this._saveFormIndex(tmpFormIndex);

		return true;
	}

	// ========================================================================
	// Active Form Management
	// ========================================================================

	/**
	 * Gets the currently active form instance GUID.
	 *
	 * @returns {string|null} The active form GUID, or null if none is set.
	 */
	getActiveFormGUID()
	{
		return this._activeFormGUID;
	}

	/**
	 * Sets the active form instance GUID.
	 *
	 * This is used by persistActiveForm() and triggerDebouncedPersist().
	 *
	 * @param {string} pInstanceGUID - The GUID to set as active.
	 */
	setActiveFormGUID(pInstanceGUID)
	{
		this._activeFormGUID = pInstanceGUID || null;
	}

	/**
	 * Saves the currently active form's data to storage.
	 *
	 * When AutoPersistBundleWithForm is true and the active form record has
	 * a BundleContextIdentifier, the bundle data is also persisted.
	 *
	 * @returns {boolean} True if persisted successfully, false if no active form or save failed.
	 */
	persistActiveForm()
	{
		if (!this._activeFormGUID)
		{
			this.log.warn('FormPersistence persistActiveForm: no active form GUID set.');
			return false;
		}

		let tmpResult = this.saveFormData(this._activeFormGUID);

		// Also persist the associated bundle context if configured
		if (tmpResult && this.options.AutoPersistBundleWithForm)
		{
			let tmpFormIndex = this.getFormIndex();
			let tmpRecord = tmpFormIndex.Records[this._activeFormGUID];
			if (tmpRecord && tmpRecord.BundleContextIdentifier)
			{
				this.saveBundleData(tmpRecord.BundleContextIdentifier);
			}
		}

		return tmpResult;
	}

	/**
	 * Triggers a debounced persist of the active form.
	 *
	 * Call this from a dataChanged handler to avoid persisting on every keystroke.
	 * The persist fires after AutoPersistDebounceMs of inactivity.
	 */
	triggerDebouncedPersist()
	{
		if (!this._activeFormGUID)
		{
			return;
		}

		if (this._persistTimerHandle)
		{
			clearTimeout(this._persistTimerHandle);
		}

		let tmpSelf = this;
		this._persistTimerHandle = setTimeout(
			function ()
			{
				tmpSelf.persistActiveForm();
				tmpSelf._persistTimerHandle = null;
			},
			this.options.AutoPersistDebounceMs);
	}

	/**
	 * Called by DynamicForm views when data changes (dataChanged or dataChangedTabular).
	 *
	 * When AutoPersistOnDataChange is enabled, triggers a debounced persist.
	 * This method exists as the integration hook between the form lifecycle and
	 * the persistence provider -- the DynamicForm view calls this if the provider exists.
	 */
	onFormDataChanged()
	{
		if (this.options.AutoPersistOnDataChange)
		{
			this.triggerDebouncedPersist();
		}
	}
}

module.exports = PictFormPersistence;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],508:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// TODO: Pull this back to pict as a core service once we are happy with the shape.
/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Informary",

	"AutoInitialize": false,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a provider for dynamic forms in the PICT system.
 * Extends the `libPictProvider` class.
 */
class PictDynamicFormsInformary extends libPictProvider
{
	/**
	 * Creates an instance of the `PictDynamicFormsInformary` class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { newManyfest: (options: any) => import('manyfest') }} */
		this.pict;
		/** @type {any} */
		this.log;

		this.genericManifest = this.pict.newManyfest({Scope:'GenericInformary'});
	}

	/**
	 * Retrieves all form elements for a given form hash.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @returns {HTMLElement[]} - An array of HTML elements representing the form elements.
	 */
	getFormElements(pFormHash)
	{
		let tmpSelector = `[data-i-form="${pFormHash}"]`;
		//this.log.trace(`Getting form elements for form hash selector: ${tmpSelector}`);
		return this.pict.ContentAssignment.getElement(tmpSelector);
	}

	/**
	 * Get a full content browser address based on the form, datum and optionally the container and index.
	 *
	 * This can be used in getDomElementByAddress or jquery selectors to return the element.
	 *
	 * @param {string} pFormHash - The form hash.
	 * @param {string} pDatumHash - The datum hash.
	 * @param {string|null} pContainer - The container (optional).
	 * @param {string|number} pIndex - The index.
	 * @returns {string} The content browser address.
	 */
	getContentBrowserAddress(pFormHash, pDatumHash, pContainer, pIndex)
	{
		// TODO: Need some guards, yo
		if (pContainer)
		{
			return `[data-i-form="${pFormHash}"][data-i-datum="${pDatumHash}"][data-i-container="${pContainer}"][data-i-index="${pIndex}"]`;
		}
		else
		{
			return `[data-i-form="${pFormHash}"][data-i-datum="${pDatumHash}"]`;
		}
	}

	/**
	 * Returns the composed container address string for a given container, index, and datum hash.
	 *
	 * @param {string} pContainer - The container name.
	 * @param {string|number} pIndex - The index of the container.
	 * @param {string} pDatumHash - The datum hash.
	 * @returns {string} The composed container address.
	 */
	getComposedContainerAddress(pContainer, pIndex, pDatumHash)
	{
		return `${pContainer}[${pIndex}].${pDatumHash}`;
	}

	/**
	 * Marshals form data to the provided application state data object using the given form hash and manifest.
	 *
	 * @param {object} pAppStateData - The application state data object to marshal the form data to.
	 * @param {string} pFormHash - The form hash representing the form elements.
	 * @param {import('manyfest')} pManifest - The manifest object used to map form data to the application state data.
	 * @param {string} [pDatum] - The datum hash to pull in.  If not provided, all data is marshalled.
	 * @param {number|string} [pRecordIndex] - The record index to pull in.  If not provided, all data is marshalled.
	 */
	marshalFormToData(pAppStateData, pFormHash, pManifest, pDatum, pRecordIndex)
	{
		const tmpManifest = typeof(pManifest) === 'object' ? pManifest : this.genericManifest;
		const tmpFormElements = this.getFormElements(pFormHash);

		// Optional Filters (so we don't just blindly do the whole form)
		const tmpDatum = (pDatum != null) ? false : pDatum;
		const tmpRecordIndex = (typeof(pRecordIndex) === 'number') ? String(pRecordIndex) : pRecordIndex;

		// Enumerate the form elements, and put data in them for each address
		for (const tmpFormElement of tmpFormElements)
		{
			this.marshalSpecicificFormElementToData(pFormHash, tmpFormElement, tmpManifest, pAppStateData, tmpDatum, tmpRecordIndex);
		}
	}

	/**
	 * Marshals a specific form element's data to the application state data.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @param {HTMLElement} pFormElement - The form element to marshal.
	 * @param {import('manyfest')} pManifest - The manifest object to set values.
	 * @param {Object} pAppStateData - The application state data object.
	 * @param {any} [pDatumFilter] - Optional filter for datum address.
	 * @param {any} [pRecordIndexFilter] - Optional filter for record index.
	 * @returns {boolean} - Returns false if the element falls outside the filters or if the browser value is null.
	 */
	marshalSpecicificFormElementToData(pFormHash, pFormElement, pManifest, pAppStateData, pDatumFilter, pRecordIndexFilter)
	{
		const tmpDatumAddress = pFormElement.getAttribute('data-i-datum');

		const tmpContainerAddress = pFormElement.getAttribute('data-i-container');
		const tmpIndex = pFormElement.getAttribute('data-i-index');

		// Process the filters
		// TODO: Now that this is a function, having these filters here is not good.  We need to move this to the caller.  But the above getAttribute is required... rethink filtering?
		if (pDatumFilter && (pDatumFilter !== tmpDatumAddress))
		{
			// Falls outside the filter, continue on
			return false;
		}
		if (pRecordIndexFilter && tmpIndex && pRecordIndexFilter !== tmpIndex)
		{
			// Falls outside the filter, continue on
			return false;
		}

		let tmpBrowserValue = this.pict.ContentAssignment.readContent(this.getContentBrowserAddress(pFormHash, tmpDatumAddress, tmpContainerAddress, tmpIndex));
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`Informary marshalling BrowserForm Data ${tmpBrowserValue} from form element [${tmpDatumAddress}] in container [${tmpContainerAddress}] at index [${tmpIndex}] to the datum address [${tmpDatumAddress}].`);
		}

		if (tmpBrowserValue == null)
		{
			return false;
		}

		if (!tmpContainerAddress)
		{
			pManifest.setValueAtAddress(pAppStateData, tmpDatumAddress, tmpBrowserValue);
		}
		else
		{
			// Compose the address .. right now only arrays
			pManifest.setValueAtAddress(pAppStateData, this.getComposedContainerAddress(tmpContainerAddress, tmpIndex, tmpDatumAddress), tmpBrowserValue);
		}
		return true;
	}

	/**
	 * Marshals data from some application state object to a specific subset of browser form elements.
	 *
	 * @param {object} pAppStateData - The application state data to marshal into the form.  Usually AppData but can be other objects.
	 * @param {string} pFormHash - The hash of the form to marshal data into.  This is the data-i-form attribute.
	 * @param {import('manyfest')} pManifest - The manifest object.  If not provided, the generic manifest is used.
	 */
	marshalDataToForm(pAppStateData, pFormHash, pManifest)
	{
		// TODO: Take a list of hashes and/or index addresses to marshal in, preventing OVERMARSHAL from taking control
		let tmpManifest = typeof(pManifest) === 'object' ? pManifest : this.genericManifest;
		let tmpFormElements = this.getFormElements(pFormHash);

		// Enumerate the form elements, and put data in them for each address
		for (let i = 0; i < tmpFormElements.length; i++)
		{
			this.marshalSpecificElementDataToForm(tmpFormElements[i], tmpManifest, pAppStateData);
		}
	}

	/**
	 * Marshals specific element data to a form.
	 *
	 * @param {HTMLElement} pFormElement - The form element to marshal data to.
	 * @param {import('manyfest')} pManifest - The manifest object containing data retrieval methods.
	 * @param {Record<string, any>} pAppStateData - The application state data.
	 * @returns {boolean} Returns false if the form element does not have a datum address.
	 */
	marshalSpecificElementDataToForm(pFormElement, pManifest, pAppStateData)
	{
		let tmpDatumAddress = pFormElement.getAttribute('data-i-datum');

		let tmpContainerAddress = pFormElement.getAttribute('data-i-container');
		let tmpIndex = Number(pFormElement.getAttribute('data-i-index'));

		if (!tmpDatumAddress)
		{
			this.log.warn(`Informary found a form element without a datum address.  Skipping.`);
			return false;
		}

		if (!tmpContainerAddress)
		{
			let tmpAppStateValue = pManifest.getValueAtAddress(pAppStateData, tmpDatumAddress);

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`Informary marshalling App State data ${tmpAppStateValue} to Browser Form element [${tmpDatumAddress}].`);
			}

			if (tmpAppStateValue != null)
			{
				this.pict.ContentAssignment.assignContent(pFormElement, tmpAppStateValue);
			}
		}
		else
		{
			let tmpAppStateValue = pManifest.getValueAtAddress(pAppStateData, this.getComposedContainerAddress(tmpContainerAddress, tmpIndex, tmpDatumAddress));

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`Informary marshalling App State data ${tmpAppStateValue} to Browser Form element [${tmpDatumAddress}] in container [${tmpContainerAddress}] at index [${tmpIndex}].`);
			}

			if (tmpAppStateValue != null)
			{
				this.pict.ContentAssignment.assignContent(pFormElement, tmpAppStateValue);
			}
		}
		return true;
	}

	/**
	 * Manually marshals data to a form by assigning content based on context in the descriptor.
	 * @param {Record<string, any>} pInput - The input manifest descriptor to marshal data to form from.
	 * @returns boolean if assignment was successful
	 */
	manualMarshalDataToFormByInput(pInput)
	{
		if (typeof(pInput) !== 'object')
		{
			this.log.error(`Informary failed to marshal data to form because the input is not an object.`);
			return false;
		}
		if (!('Hash' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a hash.`);
			return false;
		}
		if (!('PictForm' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a PictForm object.`);
			return false;
		}
		let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
		if (!tmpInputView)
		{
			this.log.error(`Informary failed to marshal data to form because the input view is missing.`);
			return false;
		}
		return this.pict.ContentAssignment.assignContent(pInput.Macro.HTMLSelector, tmpInputView.getValueByHash(pInput.Hash));
	}

	/**
	 * Manually marshals tabular data to a form by assigning content based on context in the descriptor.
	 * @param {object} pInput - The input manifest descriptor to marshal data to form from.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns boolean if assignment was successful
	 */
	manualMarshalTabularDataToFormByInput(pInput, pRowIndex)
	{
		if (typeof(pInput) !== 'object')
		{
			this.log.error(`Informary failed to marshal data to form because the input is not an object.`);
			return false;
		}
		if (!('Hash' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a hash.`);
			return false;
		}
		if (!('PictForm' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a PictForm object.`);
			return false;
		}
		let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
		if (!tmpInputView)
		{
			this.log.error(`Informary failed to marshal data to form because the input view is missing.`);
			return false;
		}
		return this.pict.ContentAssignment.assignContent(`${pInput.Macro.HTMLSelectorTabular}[data-i-index="${pRowIndex}"]`,
			tmpInputView.getTabularValueByHash(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex));
	}

	/**
	 * Manually marshals data to a form by assigning content to a specified HTML address.
	 *
	 * @param {string} pHTMLAddress - The HTML address where the content should be assigned.
	 * @param {string} pValue - The value to be assigned to the specified HTML address.
	 */
	manualMarshalDataToForm(pHTMLAddress, pValue)
	{
		return this.pict.ContentAssignment.assignContent(pHTMLAddress, pValue);
	}

	/**
	 * Manually marshals tabular data to a form.
	 *
	 * @param {string} pHTMLAddress - The HTML address where the data should be assigned.
	 * @param {string} pValue - The value to be assigned to the form element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 */
	manualMarshalTabularDataToForm(pHTMLAddress, pValue, pRowIndex)
	{
		return this.pict.ContentAssignment.assignContent(`${pHTMLAddress}[data-i-index="${pRowIndex}"]`, pValue);
	}
}

module.exports = PictDynamicFormsInformary;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],509:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-InputExtension",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictInputExtensionProvider class is a provider that allows extensions to the input fields of a form.
 *
 * Can be mapped in via the PictForm property of a descriptor.
 */
class PictInputExtensionProvider extends libPictProvider
{
	/**
	 * Creates an instance of the PictInputExtensionProvider class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}


	/**
	 * Generates the HTML ID for a custom input element based on the given input HTML ID.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @returns {string} The generated input HTML ID.
	 */
	getInputHTMLID(pInputHTMLID)
	{
		return `#INPUT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a hidden input element in a tabular data provider.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns {string} - The generated HTML ID for the hidden input element.
	 */
	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * An input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {number} pRowIndex - The row index of the tabular data
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the input in the row columns.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Repaint this input's rendered display from the model after a tabular row REORDER
	 * (move up/down/set-index), which preserves the row count but changes which row holds
	 * which value. A plain marshal updates simple inputs in place, but stateful widgets
	 * (e.g. an entity-selector's select2) will not switch to a value whose option isn't the
	 * one currently shown; those providers override this to force their display to the row's
	 * current value. Default is a no-op.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to display.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true.
	 */
	onTabularRowReorderRepaint(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Tabular sibling of onTabularRowReorderRepaint. Default is a no-op.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to display.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true.
	 */
	onTabularRowReorderRepaintTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean} - Returns true.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @returns {boolean} - Returns true.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return true;
	}


	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		return true;
	}
}

module.exports = PictInputExtensionProvider;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],510:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-ListDistilling",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictListDistilling class is a provider that filters lists based on input rules.
 */
class PictListDistilling extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/*
	  * This is a sidecar just for making filtration simpler.
	  *
	  * Types of Filtration:
	  * 1. Filter by an explicit value list (union of a set of values)
	  *   Example (explicit:
	  *		{ FilterType: "Explicit", FilterList: ["B", "C"] }
	  *   Example (implicit):
	  * 	{ FilterType: "Explicit", FilterListAddress: 'AppData.Bundle.Colors' }
	  * 2. Filter by a cross-map to a "join" list
	  *   Example (explicit):
	  * 	{ FilterType: "CrossMap", FilterValue:10, FilterValueAddress:'IDColor', FilterValueLookupAddress:'AppData.CurrentSelections.IDColor', FilterMap: [{IDColor:10, IDFruit:20}, {IDColor:10, IDFruit:30, {IDColor:20, IDFruit:30}] }
	  *   Example (implicit):
	  * 	{ FilterType: "CrossMap", FilterValue:10, FilterValueAddress:'IDColor', FilterValueLookupAddress:'AppData.CurrentSelections.IDColor', FilterMapAddress: 'AppData.Bundle.ColorFruitJoin' }
	  * 3. Filter by a string match (from an address?!  Would be cool)
	  *   Example:
	  * 	{ FilterType: "StringMatch", StringMatch: '*Apple* }
	  */
	/**
	  * Filter a list of options based on the filtering rules in a dynamic form input.
	  *
	  * Example Configuration:
	  * ...
			"ListFilterRules": [
					{
						"Filter": "Colour Entry Filter",
						"FilterType": "Explicit",
						"FilterValueComparison": "==",
						"FilterValueAddress": "Listopia.Filters.Colour",
						"IgnoreEmptyValue": true
					},
					{
						"Filter": "Colour List Distilling Filter",
						"FilterType": "CrossMap",
						"JoinListAddress": "View.sectionDefinition.Intersections.Colors.FruitSelectionColorsJoin",
						"JoinListAddressGlobal": true,
						"JoinListValueAddress": "GUIDColors",
						"ExternalValueAddress": "GUIDFruitSelection",
						"FilterToValueAddress": "Listopia.Fruit",
						"IgnoreEmpty": true
					}
				],
	  * ...
	  *
	  * @param {Object} pView - The pict view the list is within
	  * @param {*} pInput - The input within the dynamic forms view
	  * @param {*} pList - The raw list of options to filter
	  * @param {number} [pRowIndex] - The tabular row the list is for; Facet rules read sibling values from this row
	  * @returns
	  */
	filterList(pView, pInput, pList, pRowIndex)
	{
		// The list is expected to be an array of objects with "id" and "text" properties.  This is because of Select2.
		if (typeof(pInput) != 'object')
		{
			this.log.warn(`FilterList failed because the input is not an object.`);
			return pList;
		}
		if (!('PictForm' in pInput))
		{
			this.log.warn(`FilterList failed because the input does not have a PictForm stanza object.`);
			return pList;
		}
		if (!Array.isArray(pList))
		{
			this.log.warn(`FilterList for input [${pInput.Hash}] failed because the list is not an array.`);
			return [];
		}
		let tmpFilterRules = pInput.PictForm.ListFilterRules;
		if ((!tmpFilterRules) || (tmpFilterRules.length == 0) || (!Array.isArray(tmpFilterRules)))
		{
			return pList;
		}

		// Facet rules resolve to a set of allowed values once per list build rather than once per option.
		const tmpFacetAllowedValues = tmpFilterRules.map((pRule) => (pRule && (pRule.FilterType === 'Facet')) ? this.getFacetOfferedValues(pView, pInput, pRule, pRowIndex) : null);

		// Make a copy of the incoming list of options
		let tmpFilteredList = pList.slice(0);
		// We walk backwards so we can remove items from the end without breaking this loop.
		for (let h = pList.length - 1; h >= 0; h--)
		{
			let tmpListEntry = pList[h];
			let tmpEntryAllowed = true;
			for (let i = 0; i < tmpFilterRules.length; i++)
			{
				let tmpFilterRule = tmpFilterRules[i];

				// Remember that options are objects with "id" and "text" properties.  Because of Select2.
				// Genericising this with templating.  Most users will not leverage this technology.
				let tmpRecordComparisonValueAddress = ('FilteredRecordComparisonValue' in tmpFilterRule) ? tmpFilterRule.FilteredRecordComparisonValueAddress : false;
				let tmpComparisonValue;
				if (!tmpRecordComparisonValueAddress)
				{
					// Presume it's filtering on 'id'
					tmpComparisonValue = tmpListEntry.id;
				}
				else
				{
					tmpComparisonValue = pView.getValueByHash(tmpRecordComparisonValueAddress);
				}

				switch(tmpFilterRule.FilterType)
				{
					case 'Explicit':
						let tmpExplicitFilterValueAddress = tmpFilterRule.FilterValueAddress;
						let tmpExplicitFilterValueComparison = ('FilterValueComparison' in tmpFilterRule) ? tmpFilterRule.FilterValueComparison : '==';
						let tmpExplicitFilterIgnoreEmpty = ('IgnoreEmptyValue' in tmpFilterRule) ? tmpFilterRule.IgnoreEmptyValue : false;

						// TODO: This can be massively optimized by only solving this when something changes in the data location.
						//       Cache invalidation will be a PITA on this one.
						let tmpExplicitFilterValue = pView.getValueByHash(tmpExplicitFilterValueAddress);

						if (tmpExplicitFilterIgnoreEmpty && ((!tmpExplicitFilterValue) || (tmpExplicitFilterValue == '')))
						{
							// The comparison value is empty, so ignore it.
							break;
						}

						// Now check each value in the list to see if it matches the filter.
						switch(tmpExplicitFilterValueComparison.toLowerCase())
						{
							// Equal To
							case '=':
							case '==':
							case 'eq':
								if (tmpComparisonValue != tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} != ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;

							// Not Equal
							case '!=':
							case 'ne':
								if (tmpComparisonValue == tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} == ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;

							// Approximately Equal
							case '~=':
							case 'ae':
								if (tmpComparisonValue == tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} == ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;
						}
						break;

					case 'CrossMap':
						// Filter based on a list of "join" records, with:
						// A "JoinListAddress" address - where to find the list of joins in the application state
						// A "JoinListAddressGlobal" boolean - if the list is global or not (global means scoped to pict vs appdata/state location)
						// A "JoinListValueAddress" address - the address within the record that maps to the ID of the list value
						// A "ExternalValueAddress" address - the address of the external value we are comparing to
						// A "FilterToValueAddress" address - the external address to use to see if the ExternalValue matches
						// A "IgnoreEmpty" boolean - makes the tech ignore empty ExternalValue (including undefined etc.)
						//
						// So for example, if you had a list of Colors with id: "Red", "Green", "Blue"
						/*
							...And you had a list of joins they would be something like:
							AppData.BrandList [
								{ Brand: "Santa", DominantColor: "Red"},
								{ Brand: "Subaru", DominantColor: "Off White"},
								{ Brand: "Subaru", DominantColor: "Green"},
								{ Brand: "IBM", DominantColor: "Blue"},
								{ .... }
							]

							...And somewhere else we had the following state:

							AppData.SelectedBrand: "Subaru"
						*/
						/*
							The values would be:
								-> JoinListAddress: "AppData.BrandList"
								-> JoinListAddressGlobal: false
								-> JoinListValueAddress: "Record.Color"          <-- (this maps to the id in the select list)
								-> ExternalValueAddress: "Record.Brand"          <-- (this maps to the id for the external lookup)
								-> FilterToValueAddress: "AppData.SelectedBrand"
								-> IgnoreEmpty: true                             <-- Don't filter if the AppData.SelectedBrand is an empty string or such
						*/
						let tmpJoinListAddress = tmpFilterRule.JoinListAddress;
						let tmpJoinListAddressGlobal = ('JoinListAddressGlobal' in tmpFilterRule) ? tmpFilterRule.JoinListAddressGlobal : false;
						let tmpJoinListValueAddress = tmpFilterRule.JoinListValueAddress;
						let tmpExternalValueAddress = tmpFilterRule.ExternalValueAddress;
						let tmpFilterToValueAddress = tmpFilterRule.FilterToValueAddress;
						let tmpIgnoreEmpty = ('IgnoreEmpty' in tmpFilterRule) ? tmpFilterRule.IgnoreEmpty : false;

						let tmpJoinList;

						if (tmpJoinListAddressGlobal)
						{
							const tmpAddressSpace =
							{
								Fable: this.pict,
								Pict: this.pict,
								AppData: this.pict.AppData,
								Bundle: this.pict.Bundle,
								View: pView,
							};

							tmpJoinList = this.pict.manifest.getValueAtAddress(tmpAddressSpace, tmpJoinListAddress);
						}
						else
						{
							tmpJoinList = pView.getValueByHash(tmpJoinListAddress);
						}
						let tmpFilterToValueAddressValue = pView.getValueByHash(tmpFilterToValueAddress);

						if (tmpIgnoreEmpty && ((!tmpFilterToValueAddressValue) || (tmpFilterToValueAddressValue == '')))
						{
							// The comparison value is empty, so ignore it.
							break;
						}
						if ((!Array.isArray(tmpJoinList)) && (tmpJoinList != null) && (typeof(tmpJoinList) == 'object'))
						{
							let tmpJoinListKeys = Object.keys(tmpJoinList);
							let tmpNewJoinList = [];
							for (let i = 0; i < tmpJoinListKeys.length; i++)
							{
								tmpNewJoinList.push(tmpJoinList[tmpJoinListKeys[i]]);
							}
							tmpJoinList = tmpNewJoinList;
						}

						if ((!Array.isArray(tmpJoinList)) || (tmpJoinList.length == 0))
						{
							// The join list is not an array.  We can't filter it.
							break;
						}

						//this.pict.log.trace(`FilterList: CrossMap: JoinListAddress[${tmpJoinListAddress}](${tmpJoinList.length})->${tmpJoinListValueAddress} ExternalValueAddress[${tmpExternalValueAddress}] FilterToValueAddress[${tmpFilterToValueAddress}]`);

						// TODO: This is not industrial grade, yo.  Small lists only please.  O(n^2) is not cool.
						let tmpPossiblyAllowed = false;
						for (let i = 0; i < tmpJoinList.length; i++)
						{
							let tmpJoinListValue = this.pict.manifest.getValueAtAddress(tmpJoinList[i], tmpJoinListValueAddress);
							let tmpExternalValue = this.pict.manifest.getValueAtAddress(tmpJoinList[i], tmpExternalValueAddress);

							if (tmpIgnoreEmpty && ((!tmpJoinListValue) || (tmpJoinListValue == '')))
							{
								// The comparison value is empty, so ignore it.
								continue;
							}

							//this.pict.log.trace(`          CrossMap Test: JoinListValue[${tmpJoinListValue}]<==>ComparisonValue[${tmpComparisonValue}] ExternalValue[${tmpExternalValue}]<==>FilterToValue[${tmpFilterToValueAddressValue}]`);
							if ((tmpFilterToValueAddressValue == tmpExternalValue) && (tmpJoinListValue == tmpComparisonValue))
							{
								//this.pict.log.trace(`   !!! CrossMap: Matched: ${tmpJoinListValue} == ${tmpComparisonValue} && ${tmpExternalValue} == ${tmpFilterToValueAddressValue}`);
								tmpPossiblyAllowed = true;
								break;
							}
						}
						tmpEntryAllowed = tmpPossiblyAllowed && tmpEntryAllowed;

						break;

					case 'Facet':
						if (tmpFacetAllowedValues[i] && !tmpFacetAllowedValues[i].has(String(tmpComparisonValue)))
						{
							tmpEntryAllowed = false;
						}
						break;

					default:
						// See if there is a provider for it
						let tmpProvider = this.pict.providers[tmpFilterRule.FilterType];
						if (tmpProvider)
						{
							// Your provider could do anything here.
							// We may want a second place to bolt one of these on
							tmpEntryAllowed = tmpProvider.filterList(pView, pInput, pList, tmpListEntry);
						}
						break;
				}
			}

			if (!tmpEntryAllowed)
			{
				tmpFilteredList.splice(h,1);
			}
		}

		//this.log.trace(`FilterList: Input [${pInput.Hash}] has [${pList.length}] options to filter with [${tmpFilterRules.length}] rules.`);

		return tmpFilteredList;
	}

	/**
	 * @param {Record<string, any>} pInput
	 * @return {Record<string, any>|null} the input's Facet rule, if it has one
	 */
	getFacetRule(pInput)
	{
		const tmpRules = pInput && pInput.PictForm && pInput.PictForm.ListFilterRules;
		if (!Array.isArray(tmpRules))
		{
			return null;
		}
		return tmpRules.find((pRule) => pRule && (pRule.FilterType === 'Facet')) || null;
	}

	/**
	 * @param {Object} pView
	 * @param {Record<string, any>} pRule
	 * @return {Array<any>} the join list a Facet rule distills, as an array
	 */
	getFacetJoinList(pView, pRule)
	{
		let tmpJoinList;
		if (pRule.JoinListAddressGlobal)
		{
			const tmpAddressSpace = { Fable: this.pict, Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle, View: pView };
			tmpJoinList = this.pict.manifest.getValueAtAddress(tmpAddressSpace, pRule.JoinListAddress);
		}
		else
		{
			tmpJoinList = pView.getValueByHash(pRule.JoinListAddress);
		}
		if (Array.isArray(tmpJoinList))
		{
			return tmpJoinList;
		}
		if (tmpJoinList && (typeof(tmpJoinList) === 'object'))
		{
			return Object.values(tmpJoinList);
		}
		return [];
	}

	/**
	 * Every input that shares a Facet rule's join list with pInput, in the same tabular row (or the same
	 * view, outside a table), with the value it currently holds.  pInput itself is included.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {number} [pRowIndex]
	 * @return {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>}
	 */
	getFacetSiblings(pView, pInput, pRowIndex)
	{
		const tmpRule = this.getFacetRule(pInput);
		if (!tmpRule)
		{
			return [];
		}
		const tmpSiblings = [];
		const fAdd = (pSiblingInput, fGetValue) =>
		{
			const tmpSiblingRule = this.getFacetRule(pSiblingInput);
			if (tmpSiblingRule && (tmpSiblingRule.JoinListAddress === tmpRule.JoinListAddress))
			{
				tmpSiblings.push({ Input: pSiblingInput, Rule: tmpSiblingRule, Value: fGetValue(pSiblingInput) });
			}
		};
		const tmpIsTabular = (typeof(pRowIndex) === 'number') || ((typeof(pRowIndex) === 'string') && (pRowIndex !== ''));
		if (tmpIsTabular)
		{
			const tmpGroupIndex = pInput.PictForm.GroupIndex;
			const tmpGroup = pView.getGroup(tmpGroupIndex);
			const tmpRecord = pView.getTabularRecordData(tmpGroupIndex, pRowIndex) || {};
			const tmpAddresses = (tmpGroup && tmpGroup.supportingManifest) ? tmpGroup.supportingManifest.elementAddresses : [];
			for (let i = 0; i < tmpAddresses.length; i++)
			{
				const tmpSiblingInput = pView.getTabularRecordInput(tmpGroupIndex, i);
				if (tmpSiblingInput)
				{
					fAdd(tmpSiblingInput, (pSibling) => tmpGroup.supportingManifest.getValueByHash(tmpRecord, pSibling.DataAddress || tmpAddresses[i]));
				}
			}
			return tmpSiblings;
		}
		const tmpDescriptors = (pView.sectionManifest && pView.sectionManifest.elementDescriptors) ? pView.sectionManifest.elementDescriptors : {};
		for (const tmpAddress of Object.keys(tmpDescriptors))
		{
			const tmpSiblingInput = tmpDescriptors[tmpAddress];
			if (tmpSiblingInput && tmpSiblingInput.PictForm && !tmpSiblingInput.IsTabular)
			{
				fAdd(tmpSiblingInput, (pSibling) => pView.getValueByHash(pSibling.Hash));
			}
		}
		return tmpSiblings;
	}

	/**
	 * @param {any} pValue
	 * @return {boolean}
	 */
	isEmptyFacetValue(pValue)
	{
		return (pValue === undefined) || (pValue === null) || (pValue === '');
	}

	/**
	 * The values a Facet rule's dropdown offers: the allowed values (narrowed per the rule's NarrowBy), plus
	 * the input's own current value unless KeepCurrentValue is false, so a filter never hides what the row
	 * already stores (a saved choice that has since fallen out of scope still shows).
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {Record<string, any>} pRule - the input's Facet rule
	 * @param {number} [pRowIndex]
	 * @return {Set<string>}
	 */
	getFacetOfferedValues(pView, pInput, pRule, pRowIndex)
	{
		const tmpSiblings = this.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpOffered = this.getFacetAllowedValues(pView, pInput, pRule, pRowIndex, tmpSiblings, pRule.NarrowBy);
		const tmpSelf = tmpSiblings.find((pSibling) => pSibling.Input === pInput);
		if ((pRule.KeepCurrentValue !== false) && tmpSelf && !this.isEmptyFacetValue(tmpSelf.Value))
		{
			tmpOffered.add(String(tmpSelf.Value));
		}
		return tmpOffered;
	}

	/**
	 * @param {any} pJoinValue - the value on the join record
	 * @param {string} pOperator - EQ (default), NE, LT, LE, GT or GE
	 * @param {string} pValue - the constraint value
	 * @return {boolean}
	 */
	compareFacetValue(pJoinValue, pOperator, pValue)
	{
		if (!pOperator || (pOperator === 'EQ'))
		{
			return String(pJoinValue) === pValue;
		}
		if (pOperator === 'NE')
		{
			return String(pJoinValue) !== pValue;
		}
		if (this.isEmptyFacetValue(pJoinValue))
		{
			return false;
		}
		// Numbers compare as numbers; anything else compares as text, and a bare YYYY-MM-DD compares against
		// only the date part of an ISO timestamp so a record dated that day is on the day, not after it.
		const tmpNumeric = (pJoinValue !== '') && (pValue !== '') && !isNaN(Number(pJoinValue)) && !isNaN(Number(pValue));
		let tmpLeft = tmpNumeric ? Number(pJoinValue) : String(pJoinValue);
		if (!tmpNumeric && /^\d{4}-\d{2}-\d{2}$/.test(pValue) && /^\d{4}-\d{2}-\d{2}T/.test(tmpLeft))
		{
			tmpLeft = tmpLeft.substring(0, 10);
		}
		const tmpRight = tmpNumeric ? Number(pValue) : pValue;
		switch (pOperator)
		{
			case 'LT':
				return tmpLeft < tmpRight;
			case 'LE':
				return tmpLeft <= tmpRight;
			case 'GT':
				return tmpLeft > tmpRight;
			case 'GE':
				return tmpLeft >= tmpRight;
			default:
				this.log.warn(`Facet constraint operator [${pOperator}] is not supported; the constraint is ignored.`);
				return true;
		}
	}

	/**
	 * The values a Facet rule's input may hold, given what its siblings hold: the distinct
	 * JoinListValueAddress values of the join records that agree with every constraining non-empty sibling
	 * value and every explicit facet.  Empty siblings do not constrain.
	 *
	 * pNarrowBy picks the constraining siblings: 'All' (default) is every sibling; 'Preceding' is only the
	 * siblings before this input (column order in a table), so a list offers every value its upstream
	 * choices allow and picking one never needs a downstream value cleared first.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {Record<string, any>} pRule - the input's Facet rule
	 * @param {number} [pRowIndex]
	 * @param {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>} [pSiblings] - precomputed siblings (values may be overridden by the caller)
	 * @param {string} [pNarrowBy] - 'All' or 'Preceding'
	 * @return {Set<string>}
	 */
	getFacetAllowedValues(pView, pInput, pRule, pRowIndex, pSiblings, pNarrowBy)
	{
		const tmpAllowed = new Set();
		for (const tmpJoinRecord of this.getFacetMatchingRecords(pView, pInput, pRule, pRowIndex, pSiblings, pNarrowBy))
		{
			const tmpCandidate = this.pict.manifest.getValueAtAddress(tmpJoinRecord, pRule.JoinListValueAddress);
			if (!this.isEmptyFacetValue(tmpCandidate))
			{
				tmpAllowed.add(String(tmpCandidate));
			}
		}
		return tmpAllowed;
	}

	/**
	 * The join records that agree with every constraining non-empty sibling value and every explicit facet;
	 * see getFacetAllowedValues for pNarrowBy.  pInput's own value does not constrain.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {Record<string, any>} pRule - the input's Facet rule
	 * @param {number} [pRowIndex]
	 * @param {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>} [pSiblings]
	 * @param {string} [pNarrowBy] - 'All' or 'Preceding'
	 * @return {Array<Record<string, any>>}
	 */
	getFacetMatchingRecords(pView, pInput, pRule, pRowIndex, pSiblings, pNarrowBy)
	{
		const tmpConstraints = [];
		const tmpSiblings = pSiblings || this.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpOwnIndex = tmpSiblings.findIndex((pSibling) => pSibling.Input === pInput);
		for (let i = 0; i < tmpSiblings.length; i++)
		{
			const tmpSibling = tmpSiblings[i];
			if ((pNarrowBy === 'Preceding') && (tmpOwnIndex >= 0) && (i > tmpOwnIndex))
			{
				continue;
			}
			if ((tmpSibling.Input !== pInput) && !this.isEmptyFacetValue(tmpSibling.Value))
			{
				tmpConstraints.push({ Address: tmpSibling.Rule.JoinListValueAddress, Value: String(tmpSibling.Value) });
			}
		}
		for (const tmpFacet of (Array.isArray(pRule.Facets) ? pRule.Facets : []))
		{
			const tmpValue = ('ValueAddress' in tmpFacet) ? pView.getValueByHash(tmpFacet.ValueAddress) : tmpFacet.Value;
			if (!this.isEmptyFacetValue(tmpValue))
			{
				tmpConstraints.push({ Address: tmpFacet.JoinListValueAddress, Value: String(tmpValue), Operator: tmpFacet.Operator });
			}
		}
		return this.getFacetJoinList(pView, pRule).filter((pJoinRecord) =>
		{
			for (const tmpConstraint of tmpConstraints)
			{
				if (!this.compareFacetValue(this.pict.manifest.getValueAtAddress(pJoinRecord, tmpConstraint.Address), tmpConstraint.Operator, tmpConstraint.Value))
				{
					return false;
				}
			}
			return true;
		});
	}
}

module.exports = PictListDistilling;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],511:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetaList",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictMetalist class is a provider that translates simple list entries into arrays of entries ready to use in drop-down lists and such
 */
class PictMetalist extends libPictProvider
{
	/**
	 * Creates an instance of the PictMetalist class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.computedLists = {};
		this.listDefinitions = {};
	}
	/** @typedef {{ id: string, text: string }} PickListItem */

	/**
	 * Retrieves a list based on the provided view hash and list hash.
	 *
	 * @param {string} pListHash - The list hash.
	 * @param {Object} [pOptions={}] - (optional) Additional options for retrieving the list. (ex. search term)
	 *
	 * @returns {Array<PickListItem>} - The retrieved list.
	 */
	getList(pListHash, pOptions = {})
	{
		if (this.listDefinitions[pListHash].Dynamic)
		{
			const tmpList = [];
			const tmpTransactionGUID = this.pict.getUUID();
			const tmpHash = tmpTransactionGUID.substring(0, 8);
			const tmpAddress = `AppData._MetaLists.${tmpHash}`;
			this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpList);
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`GetPickList:${pListHash}:${tmpAddress}:${JSON.stringify(pOptions)}`, tmpTransactionGUID);
			this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
			delete this.pict.AppData._MetaLists[tmpHash];
			return tmpList;
		}
		if (pListHash in this.computedLists)
		{
			return this.computedLists[pListHash];
		}
		return [];
	}

	/**
	 * Checks if a list exists in the Pict Provider MetaLists.
	 *
	 * @param {string} pListHash - The hash of the list.
	 * @returns {boolean} - Returns true if the list exists, otherwise false.
	 */
	hasList(pListHash)
	{
		return (pListHash in this.computedLists);
	}

	/**
	 * Rebuilds any lists defined in specific views
	 * @param {Array} pViewHashes - An array of strings representing the view hashes to rebuild lists for.
	 */
	buildViewSpecificLists(pViewHashes)
	{
		// this.log.trace(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] pulling Metalists.`);
		let tmpViewHashes = Array.isArray(pViewHashes) ? pViewHashes : Object.keys(this.fable.views);

		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			let tmpViewHash = tmpViewHashes[i];
			let tmpView = this.fable.views[tmpViewHash];
			if (tmpView.isPictSectionForm)
			{
				let tmpSection = tmpView.sectionDefinition;
				if (('PickLists' in tmpSection) && Array.isArray(tmpSection.PickLists))
				{
					for (let j = 0; j < tmpSection.PickLists.length; j++)
					{
						let tmpPickList = tmpSection.PickLists[j];
						this.buildList(tmpPickList);
					}
				}
			}
		}
	}

	/**
	 * Rebuilds a list based on the provided hash.
	 *
	 * @param {string} pListHash - The hash of the list to be rebuilt.
	 */
	rebuildListByHash(pListHash)
	{
		if (pListHash in this.listDefinitions)
		{
			this.buildList(this.listDefinitions[pListHash]);
		}
	}

	/**
	 * Builds a list based on the provided list object.  Stores it internally for use in dropdowns and list boxes.
	 * @param {Object} pListObject - The List definition object
	 * @returns boolean
	 */
	buildList(pListObject)
	{
		// Basic list validation
		if (typeof(pListObject) !== 'object')
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList that is not an object. Skipping.`);
			return false;
		}
		if (!('Hash' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a Hash. Skipping.`);
			return false;
		}

		// Lazily add it if it doesn't exist
		if (!(pListObject.Hash in this.listDefinitions))
		{
			this.listDefinitions[pListObject.Hash] = pListObject;
			this.computedLists[pListObject.Hash] = [];
		}

		// Now try to build the list!
		let tmpResultingList = [];

		// Advanced list validation
		if (!('ListAddress' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a ListAddress. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		if (!('ListSourceAddress' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a ListSourceAddress. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		// TODO: Research easy ways to infer this...
		if (!('TextTemplate' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a TextTemplate. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		if (!('IDTemplate' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a IDTemplate. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] requires PictFormMetacontroller but not found. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		// Now try to fetch the list data; a global source reads application state rather than the form data.
		let tmpListData;
		if (pListObject.ListSourceAddressGlobal)
		{
			const tmpAddressSpace = { Fable: this.pict, Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle };
			tmpListData = this.pict.manifest.getValueAtAddress(tmpAddressSpace, pListObject.ListSourceAddress);
		}
		else
		{
			tmpListData = this.pict.providers.DataBroker.getValueByHash(pListObject.ListSourceAddress);
		}
		if (!tmpListData)
		{
			//this.log.warn(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to fetch the list data for PickList [${pListObject.Hash}]. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		// Use this for the unique feature
		let tmpListHashes = {};

		if (Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpListEntry = tmpListData[i];
				if (tmpListEntry && (typeof tmpListEntry === 'object'))
				{
					let tmpTextString = this.pict.parseTemplate(pListObject.TextTemplate, tmpListEntry);
					let tmpIDString = this.pict.parseTemplate(pListObject.IDTemplate, tmpListEntry);

					if (!tmpTextString || !tmpIDString)
					{
						// A list over an optional field (SkipEmpty) expects records without it.
						if (pListObject.SkipEmpty)
						{
							continue;
						}
						this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to generate the Text or ID for PickList [${pListObject.Hash}]. Skipping.`);
//						this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to generate the Text or ID for PickList [${pListObject.Hash}]. Skipping.`, {"Text": tmpTextString, "ID": tmpIDString, "Entry": tmpListEntry});
						continue;
					}

					if (pListObject.Unique && (tmpIDString in tmpListHashes))
					{
						continue;
					}
					tmpListHashes[tmpIDString] = true;
					tmpResultingList.push({"id": tmpIDString, "text": tmpTextString});
				}
			}
		}

		if (pListObject.Sorted)
		{
			tmpResultingList.sort((pLeft, pRight) => pLeft.text.localeCompare(pRight.text));
		}

		// Now store the list
		this.computedLists[pListObject.Hash] = tmpResultingList;
	}
}

module.exports = PictMetalist;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],512:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewDynamicForm = require('../views/Pict-View-DynamicForm.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Provider-MetatemplateGenerator",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

const _DynamicInputViewSection = (
		{
			"Hash": "DynamicInputs",
			"Name": "Dynamic Inputs",
			"ViewHash": "PictFormMetacontroller-DynamicInputs",

			"IncludeInMetatemplateSectionGeneration": false,

			"Manifests": {
				"Section": {
					"Scope": "MetaTemplate",
					"Sections": [
						{
							"Hash": "DynamicInputs",
							"Name": "Dynamic Inputs"
						}
					],
					"Descriptors": {
						"MetaTemplate.DynamicInputPlaceholder": {
							"Name": "DynamicInputPlaceholder",
							"Hash": "DynamicInputPlaceholder",
							"DataType": "String",
							"Macro": {
								"HTMLSelector": ""
							},
							"PictForm": {
								"Section": "DynamicInputs"
							}
						}
					}
				}
			}
		});

/**
 * Class representing a Pict Metatemplate Generator.
 * @extends libPictProvider
 */
class PictMetatemplateGenerator extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {libPictViewDynamicForm} */
		this.dynamicInputView;

		this.baseTemplatePrefix = "Pict-MT-Base";
	}

	onInitializeAsync(fCallback)
	{
		this.createOnDemandMetatemplateView();
		return super.onInitializeAsync(fCallback);
	}

	createOnDemandMetatemplateView()
	{
		const tmpViewConfiguration = JSON.parse(JSON.stringify(_DynamicInputViewSection));

		if (tmpViewConfiguration.ViewHash in this.pict.views)
		{
			this.dynamicInputView = this.pict.views[tmpViewConfiguration.ViewHash];
		}
		else
		{
			this.dynamicInputView = this.pict.addView(tmpViewConfiguration.ViewHash, tmpViewConfiguration, libPictViewDynamicForm);
		}
	}

	/**
	 * Retrieves the metatemplate template reference in raw format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pTemplatePostfix - The template postfix.
	 * @param {string} pRawTemplateDataAddress - The raw template data address.
	 * @returns {string} The metatemplate template reference in raw format, or false if it doesn't exist.
	 */
	getMetatemplateTemplateReferenceRaw(pView, pTemplatePostfix, pRawTemplateDataAddress)
	{
		// 1. Check if there is a section-specific template loaded
		if (pView.checkViewSpecificTemplate(pTemplatePostfix))
		{
			return `\n{~T:${pView.formsTemplateSetPrefix}${pTemplatePostfix}:${pRawTemplateDataAddress}~}`;
		}
		// 2. Check if there is a theme-specific template loaded for this postfix
		else if (pView.checkThemeSpecificTemplate(pTemplatePostfix))
		{
			return `\n{~T:${pView.defaultTemplatePrefix}${pTemplatePostfix}:${pRawTemplateDataAddress}~}`;
		}
		// 3. This shouldn't happen if the template is based on the base class.
		else
		{
			return '';
		}
	}

	/**
	 * Retrieves the metatemplate template reference.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pTemplatePostfix - The template postfix.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getMetatemplateTemplateReference(pView, pTemplatePostfix, pViewDataAddress)
	{
		return this.getMetatemplateTemplateReferenceRaw(pView, pTemplatePostfix, `Pict.views["${pView.Hash}"].${pViewDataAddress}`);
	}

	/**
	 * Retrieves the metatemplate template reference for the given input view, data type, input type, and view data address.
	 *
	 * @param {Object} pView - The input view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateInputTypePostfix = `-Template-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateDataTypePostfix = `-Template-Input-DataType-${pDataType}`;

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateInputTypePostfix, pViewDataAddress);
			if (tmpTemplate)
			{
				return tmpTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateDataTypePostfix, pViewDataAddress);
		if (tmpTemplate)
		{
			return tmpTemplate;
		}

		// There wasn't an input type specific or data type specific template, so fall back to the generic input template.
		return this.getMetatemplateTemplateReference(pView, '-Template-Input', pViewDataAddress);
	}

	/**
	 * Generates a tabular input metatemplate template reference.
	 *
	 * @param {Object} pView - The view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @param {number} pGroupIndex - The group index.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} The tabular input metatemplate template reference.
	 */
	getTabularInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress, pGroupIndex, pRowIndex)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateBeginInputTypePostfix = `-TabularTemplate-Begin-Input-InputType-${pInputType}`;
		let tmpTemplateMidInputTypePostfix = `-TabularTemplate-Mid-Input-InputType-${pInputType}`;
		let tmpTemplateEndInputTypePostfix = `-TabularTemplate-End-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateBeginDataTypePostfix = `-TabularTemplate-Begin-Input-DataType-${pDataType}`;
		let tmpTemplateMidDataTypePostfix = `-TabularTemplate-Mid-Input-DataType-${pDataType}`;
		let tmpTemplateEndDataTypePostfix = `-TabularTemplate-End-Input-DataType-${pDataType}`;

		// Tabular inputs are done in three parts -- the "begin", the "address" of the data and the "end".

		// This means it is easily extensible to work on JSON objects as well as arrays.
		let tmpMidTemplate = this.getMetatemplateTemplateReference(pView, '-TabularTemplate-Mid-Input', pViewDataAddress);
		let tmpInformaryDataAddressTemplate = this.getMetatemplateTemplateReference(pView, '-TabularTemplate-InformaryAddress-Input', pViewDataAddress);

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateBeginInputTypePostfix, pViewDataAddress);
			let tmpEndTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateEndInputTypePostfix, pViewDataAddress);
			let tmpCustomMidTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateMidInputTypePostfix, pViewDataAddress);
			tmpMidTemplate = (tmpCustomMidTemplate) ? tmpCustomMidTemplate : tmpMidTemplate;
			if (tmpBeginTemplate && tmpEndTemplate)
			{
				return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateBeginDataTypePostfix, pViewDataAddress);
		let tmpEndTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateEndDataTypePostfix, pViewDataAddress);
		if (tmpBeginTemplate && tmpEndTemplate)
		{
			let tmpCustomMidTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateMidDataTypePostfix, pViewDataAddress);
			tmpMidTemplate = (tmpCustomMidTemplate) ? tmpCustomMidTemplate : tmpMidTemplate;
			return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
		}

		// If we didn't find the template for the "input type", or the "data type", fall back to the default
		tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, 'TabularTemplate-Begin-Input', pViewDataAddress);
		tmpEndTemplate = this.getMetatemplateTemplateReference(pView, 'TabularTemplate-End-Input', pViewDataAddress);
		if (tmpBeginTemplate && tmpEndTemplate)
		{
			return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
		}

		// There was some kind of catastrophic failure -- the above templates should always be loaded.
		this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] catastrophic error generating tabular metatemplate: missing input template for Data Type ${pDataType} and Input Type ${pInputType}, Data Address ${pViewDataAddress}, Group Index ${pGroupIndex} and Record Subaddress ${pRowIndex}.`)
		return '';
	}

	/**
	 * Retrieves the metatemplate template reference for the given vertical input view, data type, input type, and view data address.
	 *
	 * @param {Object} pView - The input view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getVerticalInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateInputTypePostfix = `-VerticalTemplate-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateDataTypePostfix = `-VerticalTemplate-Input-DataType-${pDataType}`;

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateInputTypePostfix, pViewDataAddress);
			if (tmpTemplate)
			{
				return tmpTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateDataTypePostfix, pViewDataAddress);
		if (tmpTemplate)
		{
			return tmpTemplate;
		}

		// There wasn't an input type specific or data type specific template, so fall back to the generic input template.
		return this.getMetatemplateTemplateReference(pView, '-Template-Input', pViewDataAddress);
	}

	/**
	 * Retrieves the group layout provider based on the given view and group.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {Object} The group layout provider.
	 */
	getGroupLayoutProvider(pView, pGroup)
	{
		let tmpGroupLayout = (typeof(pGroup.Layout) === 'string') ? pGroup.Layout :
								(typeof(pView.sectionDefinition.DefaultGroupLayout) === 'string') ? pView.sectionDefinition.DefaultGroupLayout :
								'Record';
		// This switch is unnecessary but meant to be illustrative of what this function does.
		// It could technically be as simple as the default stanza.
		switch(tmpGroupLayout)
		{
			case 'Tabular':
				return this.pict.providers['Pict-Layout-Tabular'];
			case 'Record':
				return this.pict.providers['Pict-Layout-Record'];
			case 'Vertical':
				return this.pict.providers['Pict-Layout-VerticalRecord'];
			case 'Default':
			default:
				// Try to load a custom layout, then fall back to the Record layout if it doesn't exist
				if (`Pict-Layout-${tmpGroupLayout}` in this.pict.providers)
				{
					return this.pict.providers[`Pict-Layout-${tmpGroupLayout}`];
				}
				else
				{
					return this.pict.providers['Pict-Layout-Record'];
				}
		}
	}

	/**
	 * Rebuilds the custom template for the given view.
	 *
	 * This uses the layout providers for each group.
	 *
	 * @param {Object} pView - The view object.
	 */
	rebuildCustomTemplate(pView)
	{
		let tmpTemplate = ``;

		if (this.pict.views.PictFormMetacontroller && ('formTemplatePrefix' in this.pict.views.PictFormMetacontroller) && (!('defaultTemplatePrefix' in pView)))
		{
				pView.defaultTemplatePrefix = this.pict.views.PictFormMetacontroller.formTemplatePrefix;
		}

		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Wrap-Prefix`, `sectionDefinition`);
		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Section-Prefix`, `sectionDefinition`);

		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];

			tmpGroup.GroupIndex = i;

			tmpGroup.SectionTabularRowVirtualTemplateHash = `Pict-Form-Template-TabularRow-Virtual-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;
			tmpGroup.SectionTabularRowTemplateHash = `Pict-Form-Template-TabularRow-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;

			tmpTemplate += this.getGroupLayoutProvider(pView, tmpGroup).generateGroupLayoutTemplate(pView, tmpGroup);
		}

		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Section-Postfix`, `sectionDefinition`);
		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Wrap-Postfix`, `sectionDefinition`);

		this.pict.providers.MetatemplateMacros.rebuildMacros(pView);

		this.pict.TemplateProvider.addTemplate(pView.options.SectionTemplateHash, tmpTemplate);
	}
}

module.exports = PictMetatemplateGenerator;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../views/Pict-View-DynamicForm.js":563,"pict-provider":479}],513:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetatemplateMacros",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
})

/**
 * Class representing PictMetatemplateMacros.
 * @extends libPictProvider
 */
class PictMetatemplateMacros extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { settings: any }} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.additionalInputMacros = {};
		if ('AdditionalInputMacros' in this.options)
		{
			this.additionalInputMacros = Object.assign(this.additionalInputMacros, this.options.AdditionalInputMacros);
		}
		if ('CustomInputMacros' in this.pict.settings)
		{
			this.AdditionalInputMacros = Object.assign(this.additionalInputMacros, this.pict.settings.CustomInputMacros);
		}

		this.additionalGroupMacros = {};
		if ('AdditionalGroupMacros' in this.options)
		{
			this.additionalGroupMacros = Object.assign(this.additionalGroupMacros, this.options.AdditionalGroupMacros);
		}
		if ('CustomGroupMacros' in this.pict.settings)
		{
			this.additionalGroupMacros = Object.assign(this.additionalGroupMacros, this.pict.settings.CustomGroupMacros);
		}

		this.additionalSectionMacros = {};
		if ('AdditionalSectionMacros' in this.options)
		{
			this.additionalSectionMacros = Object.assign(this.additionalSectionMacros, this.options.AdditionalSectionMacros);
		}
		if ('CustomSectionMacros' in this.pict.settings)
		{
			this.additionalSectionMacros = Object.assign(this.additionalSectionMacros, this.pict.settings.CustomSectionMacros);
		}
	}

	/**
	 * Builds macros for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 */
	buildInputMacros(pView, pInput)
	{
		let tmpInputMacroKeys = Object.keys(pView.options.MacroTemplates.Input);
		let tmpAdditionalInputMacroKeys = Object.keys(this.additionalInputMacros);
		if (!('Macro' in pInput))
		{
			pInput.Macro = {};
		}
		for (let n = 0; n < tmpInputMacroKeys.length; n++)
		{
			pInput.Macro[tmpInputMacroKeys[n]] = pView.pict.parseTemplate(pView.options.MacroTemplates.Input[tmpInputMacroKeys[n]], pInput, null, [pView]);
		}
		for (let n = 0; n < tmpAdditionalInputMacroKeys.length; n++)
		{
			pInput.Macro[tmpAdditionalInputMacroKeys[n]] = pView.pict.parseTemplate(this.additionalInputMacros[tmpAdditionalInputMacroKeys[n]], pInput, null, [pView]);
		}
	}

	/**
	 * Rebuilds macros for the given view.
	 *
	 * @param {Object} pView - The view object.
	 * @returns {boolean} - Returns false if MacroTemplates is not present in pView.options.
	 */
	rebuildMacros(pView)
	{
		if (!('MacroTemplates' in pView.options))
		{
			return false;
		}

		// Section macros
		let tmpSectionMacroKeys = Object.keys(pView.options.MacroTemplates.Section);
		let tmpAdditionalSectionMacroKeys = Object.keys(this.additionalSectionMacros);
		if (typeof(pView.sectionDefinition.Macro) !== 'object')
		{
			pView.sectionDefinition.Macro = {};
		}
		for (let n = 0; n < tmpSectionMacroKeys.length; n++)
		{
			pView.sectionDefinition.Macro[tmpSectionMacroKeys[n]] = pView.pict.parseTemplate (pView.options.MacroTemplates.Section[tmpSectionMacroKeys[n]], pView.sectionDefinition, null, [pView]);
		}
		for (let n = 0; n < tmpAdditionalSectionMacroKeys.length; n++)
		{
			pView.sectionDefinition.Macro[tmpAdditionalSectionMacroKeys[n]] = pView.pict.parseTemplate (this.additionalSectionMacros[tmpAdditionalSectionMacroKeys[n]], pView.sectionDefinition, null, [pView]);
		}
		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];

			// Group Macros
			let tmpGroupMacroKeys = Object.keys(pView.options.MacroTemplates.Group);
			let tmpAdditionalGroupMacroKeys = Object.keys(this.additionalGroupMacros);
			if (!('Macro'  in tmpGroup))
			{
				tmpGroup.Macro = {};
			}
			for (let n = 0; n < tmpGroupMacroKeys.length; n++)
			{
				tmpGroup.Macro[tmpGroupMacroKeys[n]] = pView.pict.parseTemplate(pView.options.MacroTemplates.Group[tmpGroupMacroKeys[n]], tmpGroup, null, [pView]);
			}
			for (let n = 0; n < tmpAdditionalGroupMacroKeys.length; n++)
			{
				tmpGroup.Macro[tmpAdditionalGroupMacroKeys[n]] = pView.pict.parseTemplate(this.additionalGroupMacros[tmpAdditionalGroupMacroKeys[n]], tmpGroup, null, [pView]);
			}

			if (!Array.isArray(tmpGroup.Rows))
			{
				tmpGroup.Rows = [];
			}
			for (let j = 0; j < tmpGroup.Rows.length; j++)
			{
				// TODO: Do we want row macros?  Let's be still and find out.
				let tmpRow = tmpGroup.Rows[j];
				for (let k = 0; k < tmpRow.Inputs.length; k++)
				{
					this.buildInputMacros(pView, tmpRow.Inputs[k]);
				}
			}

			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					this.buildInputMacros(pView, tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]]);
				}
			}
		}
	}
}

module.exports = PictMetatemplateMacros;
module.exports.default_configuration = _DefaultProviderConfiguration;



},{"pict-provider":479}],514:[function(require,module,exports){
module.exports = (
{
	"TemplatePrefix": "Pict-Forms-ReadOnly",

	"Templates":
	[
		/*
		 *
		 * [ Metacontroller Templates ]
		 *
		 */
		// the form "Header", rendered once before the dynamic views, after which come the section(s), then their group(s)
		{
			"HashPostfix": "-Template-Form-Container-Header",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container Header

  ;,//;,    ,;/
 o:::::::;;///
>::::::::;;\\\
  ''\\\\'" ';\

Glug glug glug Oo... -->
<div id="Pict-{~D:Context[0].UUID~}-FormContainer" class="pict-form">`
		},
		//
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Prefix",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`
		},
		// the container div into which the actual view renders.
		// if you overwrite this template, make sure this ID is available on a container somewhere or auto rendering won't work
		{
			"HashPostfix": "-Template-Form-Container",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`
		},
		{
			"HashPostfix": "-Template-Form-Container-Custom",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`
		},

		// -Form-Container-Wrap-Postfix
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Postfix",
			"Template": /*HTML*/`
</div>
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
`
		},


		/*
		 *
		 * [ Basic Form Templates START ]
		 *
		 */
		// the wrapping container for a view which is a collection of form section(s)...
		{
			"HashPostfix": "-Template-Wrap-Prefix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		{
			"HashPostfix": "-Template-Wrap-Postfix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		// the wrapping container for each specific section in a form... for legends and the like
		{
			"HashPostfix": "-Template-Section-Prefix",
			"Template": /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<div class="pict-form-section">
		<h2>{~D:Record.Name~}</h2>
`
		},
		// -Form-Template-Section-Postfix
		{
			"HashPostfix": "-Template-Section-Postfix",
			"Template": /*HTML*/`
		</div>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Group and Row Templates (default)
		 */
		// a "group" is a cluster of inputs that are further categorized into row(s)
		{
			"HashPostfix": "-Template-Group-Prefix",
			"Template": /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<h3>Group: {~D:Record.Name~}</h3>
`
		},
		// row(s) are useful when our form has multiple inputs on some lines and a single on another...
		// like city, state and zip all in the same "row" of an address form
		{
			"HashPostfix": "-Template-Row-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div>
`
		},
		{
			"HashPostfix": "-Template-Row-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-Group-Postfix",
			"Template": /*HTML*/`
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		/*
		 * END Group and Row Templates (default)
		 */

		/*
		 * BEGIN Input Templates (default)
		 */
		{
			"HashPostfix": "-Template-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <textarea disabled {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span> <select disabled {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span> <input disabled {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ObjectEditor",
			"DefaultInputExtensions": ["Pict-Input-ObjectEditor"],
			"Template": /*HTML*/`
					<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
`
		},
		/*
		 * END Input Templates (default)
		 */
		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		/*
		 * Tab Groups are sets of Groups within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...
			"UI.StatisticsTabState": {
				Name: "Statistics Tab State",
				Hash: "StatisticsTabState",
				DataType: "String",
				PictForm: { Section: "Recipe", Group: "StatisticsTabs", 
					InputType: "TabGroupSelector",
					// The default when there is no state is the first entry here.
					// If you want to set a default, you can just do it in the state address though.
					TabGroupSet: ["Statistics", "FruitStatistics"] }
			},
		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector",
			"DefaultInputExtensions": ["Pict-Input-TabGroupSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<a href="#" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}')">{~D:Context[1].TabGroupHash~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</p>
`
		},		/*
		 * END View Management Templates (default)
		 */
		/*
		 *
		 * [ Basic Form Templates END ]
		 *
		 */

		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TuiGrid-Container",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.ControlAttr~} id="{~D:Record.TuiGridHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-TuiGrid-Controls",
			"Template": /*HTML*/`
			<div>[ <a href="#" onclick="{~P~}.providers['Pict-Layout-TuiGrid'].addRow('{~D:Context[0].Hash~}', {~D:Record.GroupIndex~})">create</a> ]</div>
`
		},
		/*
		 *
		 * [ External Control Templates END ]
		 *
		 */


		/*
		 *
		 * [ Tabular Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TabularTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<table>
					<tbody>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Group-Postfix",
			"Template": /*HTML*/`
				</tbody>
			</table>
			<div><a href="#" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Tabular Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPrefix -->`
		},
		// because the row extension template below adds an extra column, we need to make our header have parity
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPostfix -->
						<th style="min-width:100px;"></th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a tabular templateset
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPostfix-->
					<td><a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
					<a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
					<a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a></td>
`
		},
		/*
		 * END Tabular Template "Extra" Columns
		 */

		/*
		 * BEGIN Tabular Template Header Columns
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Prefix",
			"Template": /*HTML*/`
				<thead>
					<tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-HeaderCell",
			"Template": /*HTML*/`
						<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
						<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}">{~D:Record.Name~}</th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Postfix",
			"Template": /*HTML*/`
					</tr>
				</thead>
				<tbody>
`
		},
		/*
		 * END Tabular Template Header Columns
		 */

		/*
		 * BEGIN Tabular TemplateSet Templates (row and cell prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-TabularTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">{~T:TabularTemplateRow-ExtraPrefix~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}"><!-- {~D:Record.Name~}  -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Postfix",
			"Template": /*HTML*/`
						</td>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-Postfix",
			"Template": /*HTML*/`
					{~T:TabularTemplateRow-ExtraPostfix~}</tr>`
		},
		/*
		 * END Tabular TemplateSet Templates
		 */


		/*
		 * BEGIN Tabular Input Templates
		 */
		{
			"HashPostfix": "-TabularTemplate-Begin-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Mid-Input",
			"Template": /*HTML*/`  `
		},
		{
			"HashPostfix": "-TabularTemplate-InformaryAddress-Input",
			"Template": /*HTML*/` data-i-index="{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"  `
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-String",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-Number",
			"Template": /*HTML*/` value="">
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<textarea disabled {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TextArea",
			"Template": /*HTML*/` ></textarea>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" id="SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Option",
			"Template": /*HTML*/` value="">
					<select disabled {~D:Record.Macro.ControlAttr~} id="SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"></select>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Boolean",
			"Template": /*HTML*/` value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-DateTime",
			"Template": /*HTML*/` value="">
					<input disabled {~D:Record.Macro.ControlAttr~} id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} {~D:Record.Macro.InformaryTabular~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Hidden",
			"Template": /*HTML*/` value="">
`
		},

		/*
		 * END Tabular Input Templates
		 */
		/*
		 *
		 * [ Tabular Templates END ]
		 *
		 */
	]
});

},{}],515:[function(require,module,exports){
module.exports = (
{
	"TemplatePrefix": "Pict-MT-Base",
	"Templates":
	[
		/*
		 *
		 * [ Metacontroller Templates ]
		 *
		 */
		// the form "Header", rendered once before the dynamic views, after which come the section(s), then their group(s)
		{
			"HashPostfix": "-Template-Form-Container-Header",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container Header

  ;,//;,    ,;/
 o:::::::;;///
>::::::::;;\\\
  ''\\\\'" ';\

Glug glug glug Oo... -->
<div id="Pict-{~D:Context[0].UUID~}-FormContainer" class="pict-form">`
		},
		//
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Prefix",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`
		},
		// the container div into which the actual view renders.
		// if you overwrite this template, make sure this ID is available on a container somewhere or auto rendering won't work
		{
			"HashPostfix": "-Template-Form-Container",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`
		},
		{
			"HashPostfix": "-Template-Form-Container-Custom",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`
		},

		// -Form-Container-Wrap-Postfix
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Postfix",
			"Template": /*HTML*/`
</div>
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
`
		},


		/*
		 *
		 * [ Basic Form Templates START ]
		 *
		 */
		// the wrapping container for a view which is a collection of form section(s)...
		{
			"HashPostfix": "-Template-Wrap-Prefix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		{
			"HashPostfix": "-Template-Wrap-Postfix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		// the wrapping container for each specific section in a form... for legends and the like
		{
			"HashPostfix": "-Template-Section-Prefix",
			"Template": /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<div id="SECTION-{~D:Context[0].formID~}" class="pict-form-section {~D:Record.CSSClass~}">
		<h2>{~D:Record.Name~}</h2>
`
		},
		// -Form-Template-Section-Postfix
		{
			"HashPostfix": "-Template-Section-Postfix",
			"Template": /*HTML*/`
		</div>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Group and Row Templates (default)
		 */
		// a "group" is a cluster of inputs that are further categorized into row(s)
		{
			"HashPostfix": "-Template-Group-Prefix",
			"Template": /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
			<h3>Group: {~D:Record.Name~}</h3>
`
		},
		// row(s) are useful when our form has multiple inputs on some lines and a single on another...
		// like city, state and zip all in the same "row" of an address form
		{
			"HashPostfix": "-Template-Row-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div>
`
		},
		{
			"HashPostfix": "-Template-Row-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-VerticalRow-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Vertical Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div class="pict-form-vertical-group">
`
		},
		{
			"HashPostfix": "-Template-VerticalRow-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Vertical Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-Group-Postfix",
			"Template": /*HTML*/`
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		/*
		 * END Group and Row Templates (default)
		 */

		/*
		 * BEGIN Input Templates (default)
		 */
		{
			"HashPostfix": "-Template-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span>
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<input type="text" {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" value="" readonly="readonly">
`
		},

		{
			"HashPostfix": "-Template-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span> <select {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span> <input {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></span>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" readonly {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></input>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}">{~D:Record.Name~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Chart",
			"DefaultInputExtensions": ["Pict-Input-Chart"],
			"Template": /*HTML*/`
					<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
					<div style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; display:inline-block;">
						<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
						<h3><span>{~D:Record.Name~}:</span></h3>
						<!-- ChartHeight (pixels) sets the plot area. It is min-height rather than height so the
					     default of 0 is a true no-op for every chart that never sets it: Chart.js keeps sizing
					     the canvas by its 2:1 aspect ratio exactly as before. When it IS set, the provider turns
					     maintainAspectRatio off so the canvas fills this box instead of ignoring it. -->
						<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;"><canvas id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></canvas></div>
					</div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Markdown",
			"DefaultInputExtensions": ["Pict-Input-Markdown"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-HTML",
			"DefaultInputExtensions": ["Pict-Input-HTML"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Templated",
			"DefaultInputExtensions": ["Pict-Input-Templated"],
			"Template": /*HTML*/`
					<!-- InputType Templated {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-templated"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TemplatedEntityLookup",
			"DefaultInputExtensions": ["Pict-Input-TemplatedEntityLookup"],
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-RichText",
			"DefaultInputExtensions": ["Pict-Input-RichText"],
			"Template": /*HTML*/`
					<!-- InputType RichText {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-richtext"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Diagram",
			"DefaultInputExtensions": ["Pict-Input-Diagram"],
			"Template": /*HTML*/`
					<!-- InputType Diagram {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-diagram"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ObjectEditor",
			"DefaultInputExtensions": ["Pict-Input-ObjectEditor"],
			"Template": /*HTML*/`
					<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
`
		},
		/*
		 * END Input Templates (default)
		 */
		/*
		 * BEGIN Vertical Input Templates
		 */
		{
			"HashPostfix": "-VerticalTemplate-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<div class="pict-form-vertical-input">
						<span>{~D:Record.Name~}:</span>
						<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
						<input type="text" {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" value="" readonly="readonly">
					</div>

`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<select {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} />
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></span>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" readonly {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></input>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<a {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}>{~D:Record.Name~}</a>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Markdown",
			"DefaultInputExtensions": ["Pict-Input-Markdown"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-HTML",
			"DefaultInputExtensions": ["Pict-Input-HTML"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Templated",
			"DefaultInputExtensions": ["Pict-Input-Templated"],
			"Template": /*HTML*/`
				<!-- InputType Templated {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-templated"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-TemplatedEntityLookup",
			"DefaultInputExtensions": ["Pict-Input-TemplatedEntityLookup"],
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-RichText",
			"DefaultInputExtensions": ["Pict-Input-RichText"],
			"Template": /*HTML*/`
					<!-- InputType RichText {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<label class="pict-form-label">{~D:Record.Name~}</label>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-richtext"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Diagram",
			"DefaultInputExtensions": ["Pict-Input-Diagram"],
			"Template": /*HTML*/`
					<!-- InputType Diagram {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<label class="pict-form-label">{~D:Record.Name~}</label>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-diagram"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-ObjectEditor",
			"DefaultInputExtensions": ["Pict-Input-ObjectEditor"],
			"Template": /*HTML*/`
					<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<label class="pict-form-label">{~D:Record.Name~}</label>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
				</div>
`
		},
		/*
		 * END Vertical Input Templates (default)
		 */
		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		/*
		 * Tab Groups are sets of Groups within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...
			"UI.StatisticsTabState": {
				Name: "Statistics Tab State",
				Hash: "StatisticsTabState",
				DataType: "String",
				PictForm: { Section: "Recipe", Group: "StatisticsTabs", 
					InputType: "TabGroupSelector",
					// The default when there is no state is the first entry here.
					// If you want to set a default, you can just do it in the state address though.
					TabGroupSet: ["Statistics", "FruitStatistics"] }
			},
		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector",
			"DefaultInputExtensions": ["Pict-Input-TabGroupSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<a href="#/" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}')">{~D:Context[1].TabGroupName~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</p>
`
		},
		/*
		 * Tab Sections are sets of Sections within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...

		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector",
			"DefaultInputExtensions": ["Pict-Input-TabSectionSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<a href="#/" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}')">{~D:Context[1].TabSectionName~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</p>
`
		},
		/*
		 * END View Management Templates (default)
		 */
		/*
		 *
		 * [ Basic Form Templates END ]
		 *
		 */

		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TuiGrid-Container",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.ControlAttr~} id="{~D:Record.TuiGridHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-TuiGrid-Controls",
			"Template": /*HTML*/`
			<div>[ <a href="#/" onclick="{~P~}.providers['Pict-Layout-TuiGrid'].addRow('{~D:Context[0].Hash~}', {~D:Record.GroupIndex~})">create</a> ]</div>
`
		},
		/*
		 *
		 * [ External Control Templates END ]
		 *
		 */


		/*
		 *
		 * [ RecordSet Templates START ]
		 *
		 */
		{
			"HashPostfix": "-RecordSetTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.PictFormLayout~}>
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Group-Postfix",
			"Template": /*HTML*/`
			<div><a href="#/" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},


		/*
		 * BEGIN RecordSet Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */

		{
			"HashPostfix": "-RecordSetTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a RecordSet Templateset
		{
			"HashPostfix": "-RecordSetTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->
					<div class="PictSectionForm-RecordSet-Controls">
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a>
					</div>
`
		},
		/*
		 * END RecordSet Template "Extra" Columns
		 */

		/*
		 * BEGIN RecordSet TemplateSet Templates ("row" and "cell" prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-RecordSetTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<div class="RecordSetEntry">
					<!-- RecordSetTemplateRow-Prefix -->
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<div style="display:inline;">
							<!-- RecordSetTemplateCell-Prefix -->
							<span class="RecordSetInputLabel">{~D:Record.Name~}</span>
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Cell-Postfix",
			"Template": /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Row-Postfix",
			"Template": /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`
		},
		/*
		 * END RecordSet TemplateSet Templates
		 */



		/*
		 *
		 * [ Tabular Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TabularTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<table>
					<tbody>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Group-Postfix",
			"Template": /*HTML*/`
				</tbody>
			</table>
			<div><a href="#/" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Tabular Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPrefix -->`
		},
		// because the row extension template below adds an extra column, we need to make our header have parity
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPostfix -->
						<th style="min-width:100px;"></th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a tabular templateset
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPostfix-->
					<td><a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
					<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
					<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a></td>
`
		},
		/*
		 * END Tabular Template "Extra" Columns
		 */

		/*
		 * BEGIN Tabular Template Header Columns
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Prefix",
			"Template": /*HTML*/`
				<thead>
					<tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-HeaderCell",
			"Template": /*HTML*/`
						<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
						<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}">{~D:Record.Name~}</th>
`
		},
		{
			// The column label only (no <th> wrapper). Used by the ColumnSorting
			// header cell so the label resolves dynamically on every render -- the
			// same way the default HeaderCell above does -- instead of being baked
			// as a static string when the template is built. This lets DynamicColumns
			// name changes (e.g. via refreshtabularsection) update the visible header
			// without a full rebuildCustomTemplate.
			"HashPostfix": "-TabularTemplate-HeaderCellLabel",
			"Template": /*HTML*/`{~D:Record.Name~}`
		},
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Postfix",
			"Template": /*HTML*/`
					</tr>
				</thead>
				<tbody>
`
		},
		/*
		 * END Tabular Template Header Columns
		 */

		/*
		 * BEGIN Tabular Template Extra Header Rows
		 * Used for stacked/clustered headers (the Group's `Headers` config).
		 * Each entry in Headers is one ADDITIONAL header row stacked above the
		 * default column-name row. Cells carry { Label, ColumnSpan, CSSClass }.
		 */
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderRow-Prefix",
			"Template": /*HTML*/`
					<tr class="pict-tabular-extra-header-row">
`
		},
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderRow-Postfix",
			"Template": /*HTML*/`
					</tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderCell",
			"Template": /*HTML*/`<th colspan="{~D:Record.ColumnSpan~}" class="pict-tabular-extra-header-cell {~D:Record.CSSClass~}">{~D:Record.Label~}</th>`
		},
		/*
		 * END Tabular Template Extra Header Rows
		 */

		/*
		 * BEGIN Tabular Template Row Label Columns
		 * Used for left-side label columns (the Group's `RowLabels` config).
		 * Header cell renders one <th> per RowLabels entry. Per-row cell renders
		 * one <td> per RowLabels entry; rowspans collapse consecutive equal
		 * values when `Cluster: true`. Skipped cells emit nothing (a real <td>
		 * upstream has already covered them via rowspan).
		 */
		{
			"HashPostfix": "-TabularTemplate-RowLabel-HeaderCell",
			"Template": /*HTML*/`<th class="pict-row-label-header">{~D:Record.Name~}</th>`
		},
		{
			"HashPostfix": "-TabularTemplate-RowLabel-Cell",
			"Template": /*HTML*/`<td rowspan="{~D:Record.RowSpan~}" class="pict-row-label">{~D:Record.RenderedLabel~}</td>`
		},
		{
			"HashPostfix": "-TabularTemplate-RowLabel-Cell-Skipped",
			"Template": ``
		},
		/*
		 * END Tabular Template Row Label Columns
		 */

		/*
		 * BEGIN Tabular TemplateSet Templates (row and cell prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-TabularTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">{~T:TabularTemplateRow-ExtraPrefix~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}"><!-- {~D:Record.Name~}  -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Postfix",
			"Template": /*HTML*/`
						</td>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-Postfix",
			"Template": /*HTML*/`
					{~T:TabularTemplateRow-ExtraPostfix~}</tr>`
		},
		/*
		 * END Tabular TemplateSet Templates
		 */


		/*
		 * BEGIN Tabular Input Templates
		 */
		{
			"HashPostfix": "-TabularTemplate-Begin-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Mid-Input",
			"Template": /*HTML*/`  `
		},
		{
			"HashPostfix": "-TabularTemplate-InformaryAddress-Input",
			"Template": /*HTML*/` data-i-index="{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"  `
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-String",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-Number",
			"Template": /*HTML*/` value="">
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-PreciseNumber",
			"Template": /*HTML*/` value="">
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly",
			"Template": /*HTML*/`
						value="">
					<input type="text" {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} value="" readonly="readonly">
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TextArea",
			"Template": /*HTML*/` ></textarea>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Option",
			"Template": /*HTML*/` value="">
					<select {~D:Record.Macro.ControlAttr~} id="SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"></select>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Boolean",
			"Template": /*HTML*/` value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-DateTime",
			"Template": /*HTML*/` value="">
					<input {~D:Record.Macro.ControlAttr~} id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~}
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Hidden",
			"Template": /*HTML*/`></span>`,
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} {~D:Record.Macro.InformaryTabular~}`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Color",
			"Template": /*HTML*/` />
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InformaryTabular~}`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-DisplayOnly",
			"Template": /*HTML*/` ></span>
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input readonly type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-ReadOnly",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Link",
			"Template": /*HTML*/` value="">
					<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~}>{~D:Record.Name~}</a>`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup",
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TemplatedEntityLookup",
			"Template": /*HTML*/` value="">`
		},

		/*
		 * END Tabular Input Templates
		 */
		/*
		 *
		 * [ Tabular Templates END ]
		 *
		 */
	]
});

},{}],516:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class for the Autofill Trigger Group
 *
 * Autofill Trigger Groups have three parameters:
 *  - the group hash
 *  - a boolean defining whether the input triggers all inputs on the group
 *    to autofill themselves
 *  - an address (either in Pict or AppData) to pull data from
 *  - whether or not to marshal values if the result is empty/null/undefined
 *
 * In practice this looks like this:
 *
	Providers: ["Pict-Input-AutofillTriggerGroup"],
	AutofillTriggerGroup:
		{
			TriggerGroupHash: "Author",
			TriggerAddress: "AppData.CurrentAuthor.Name",
			MarshalEmptyValues: true
		}
 *
 *
 * The group is cavalier about clearing data when
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	getTriggerGroupConfigurationArray(pInput)
	{
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups)
		{
			return [];
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		return tmpAutoFillTriggerGroups;
	}

	autoFillFromAddressList(pView, pInput, pTriggerGroupInfo, pHTMLSelector)
	{
		// First sanity check the triggergroupinfo
		if (!('TriggerGroupHash' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerGroupHash) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerGroupHash string is not present.`);
			return false;
		}
		if (!('TriggerAddress' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerAddress) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerAddress string is not present.`);
			return false;
		}

		let tmpValue = this.pict.manifest.getValueByHash(this.pict, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}
		// Maybe this just works!
		pView.setDataByInput(pInput, tmpValue);
		pView.manualMarshalDataToViewByInput(pInput);
		return true;
	}

	autoFillFromAddressListTabular(pView, pInput, pTriggerGroupInfo, pHTMLSelector, pRowIndex)
	{
		// First sanity check the triggergroupinfo
		if (!('TriggerGroupHash' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerGroupHash) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerGroupHash string is not present.`);
			return false;
		}
		if (!('TriggerAddress' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerAddress) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerAddress string is not present.`);
			return false;
		}

		let tmpValue = this.pict.manifest.getValueByHash(this.pict, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}
		// Setting data is in the view intentionally, to allow triggered events.  Probabbly needs to be a separate provider.
		pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpValue);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
		return true;
	}

	// Trigger the group if it's flagged as a triggering input
	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpTriggerGroupConfigurations = this.getTriggerGroupConfigurationArray(pInput);
		if (Array.isArray(tmpTriggerGroupConfigurations) && this.pict.views.PictFormMetacontroller)
		{
			for (let i = 0; i < tmpTriggerGroupConfigurations.length; i++)
			{
				const tmpGroupConfig = tmpTriggerGroupConfigurations[i];
				if (tmpGroupConfig.TriggerAllInputs)
				{
					if (Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} pre-trigger`);
					}
					pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
					{
						if (Array.isArray(tmpGroupConfig.PostSolvers))
						{
							this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} post-trigger`);
							const tmpMarshalScope = tmpGroupConfig.MarshalOnComplete;
							if (tmpMarshalScope === true)
							{
								this.pict.views.PictFormMetacontroller.marshalToView();
							}
							else if (tmpMarshalScope)
							{
								this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
								this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
							}
						}
					});
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TriggerGroup:${tmpGroupConfig.TriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpTriggerGroupConfigurations = this.getTriggerGroupConfigurationArray(pInput);
		if (Array.isArray(tmpTriggerGroupConfigurations) && this.pict.views.PictFormMetacontroller)
		{
			for (let i = 0; i < tmpTriggerGroupConfigurations.length; i++)
			{
				const tmpGroupConfig = tmpTriggerGroupConfigurations[i];
				if (tmpGroupConfig.TriggerAllInputs)
				{
					if (Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular pre-trigger`);
					}
					pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
					{
						if (Array.isArray(tmpGroupConfig.PostSolvers))
						{
							this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular post-trigger`);
							const tmpMarshalScope = tmpGroupConfig.MarshalOnComplete;
							if (tmpMarshalScope === true)
							{
								this.pict.views.PictFormMetacontroller.marshalToView();
							}
							else if (tmpMarshalScope)
							{
								this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
								this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
							}
						}
					});
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TriggerGroup:${tmpGroupConfig.TriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}
			}
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups || tmpType !== 'TriggerGroup' || (pInput.Hash || pInput.DataAddress) == tmpInputHash)
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		for (let i = 0; i < tmpAutoFillTriggerGroups.length; i++)
		{
			let tmpAutoFillTriggerGroup = tmpAutoFillTriggerGroups[i];
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			if (Array.isArray(tmpAutoFillTriggerGroup.PreSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PreSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} pre-autofill`);
			}

			//FIXME: why is this check here? revisit
			if ('TriggerAddress' in tmpAutoFillTriggerGroup)
			{
				// Autofill based on the address list as it isn't a select option
				this.autoFillFromAddressList(pView, pInput, tmpAutoFillTriggerGroup, pHTMLSelector);
			}
			
			if (tmpAutoFillTriggerGroup.SelectOptionsRefresh)
			{
				// Regenerate the picklist
				// Because the pick lists are view specific, we need to lookup the view the input is in
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
				this.pict.providers['Pict-Input-Select'].refreshSelectList(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector);
				tmpInputView.manualMarshalDataToViewByInput(pInput, tmpEventGUID);
			}

			if (Array.isArray(tmpAutoFillTriggerGroup.PostSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PostSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} post-autofill`);
				const tmpMarshalScope = tmpAutoFillTriggerGroup.MarshalOnComplete;
				if (tmpMarshalScope === true)
				{
					this.pict.views.PictFormMetacontroller.marshalToView();
				}
				else if (tmpMarshalScope)
				{
					this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
					this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
				}
			}
		}

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.AutofillTriggerGroup || tmpType !== 'TriggerGroup' || (pInput.Hash || pInput.DataAddress) == tmpInputHash)
		{
			// Do nothing for now -- this is the triggering element
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		for (const tmpAutoFillTriggerGroup of tmpAutoFillTriggerGroups)
		{
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}
			/*
			 * FIXME: for large tables, do we want to run this for every row?
			if (Array.isArray(tmpAutoFillTriggerGroup.PreSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PreSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} pre-autofill`);
			}
			*/

			//FIXME: why is this flow different from non-tabular? revisit
			if (!tmpAutoFillTriggerGroup.SelectOptionsRefresh)
			{
				// Autofill based on the address list as it isn't a select option
				this.autoFillFromAddressListTabular(pView, pInput, tmpAutoFillTriggerGroup, pHTMLSelector, pRowIndex);
			}
			else if (!pInput.PictForm.SelectOptionsPickList)
			{
				// There is no select options picklist so we can't auto refresh it.
			}
			else
			{
				// Regenerate the picklist
				// TODO: This is inefficient -- it regenerates the list for every single row.  Easy optimization.
				// Use the transaction stuff at some point, now that we have it in the event.
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
				this.pict.providers['Pict-Input-Select'].refreshSelectListTabular(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector, pRowIndex);
				tmpInputView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex, tmpEventGUID);
			}
			/*
			 * TODO: for large tables, do we want to run this for every row?
			if (Array.isArray(tmpAutoFillTriggerGroup.PostSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PostSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} post-autofill`);
			}
			*/
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],517:[function(require,module,exports){
'use strict';
/**
 * Scoped CSS for the chart input's grouped legend. Registered once by
 * Pict-Provider-Input-Chart via
 * `pict.CSSMap.addCSS('Pict-Input-Chart-CSS', libCSS, 500)`.
 *
 * Chart.js's own legend is a single flow-wrapped row of swatches. On a control
 * chart that is eight entries of near-identical colour, with the limit lines
 * indistinguishable from the readings, wrapping into an unreadable block. This
 * legend is a vertical list, grouped, with each group toggleable as a unit.
 *
 * Everything is themeable through the --theme-color-* tokens; the hardcoded
 * values are fallbacks.
 */
const libCSS = /*css*/`
.pict-chart-shell { display: flex; align-items: stretch; gap: 0.75rem; width: 100%; }
.pict-chart-shell.pict-chart-legend-top { flex-direction: column-reverse; }
.pict-chart-shell.pict-chart-legend-bottom { flex-direction: column; }
.pict-chart-shell .pict-chart-canvas-area { flex: 1 1 auto; min-width: 0; position: relative; }

.pict-chart-legend { flex: 0 0 auto; max-width: 15rem; font-size: 0.78rem; line-height: 1.35;
	color: var(--theme-color-text-primary, #1f2733); user-select: none; }
.pict-chart-legend-top .pict-chart-legend,
.pict-chart-legend-bottom .pict-chart-legend { max-width: none; }

.pict-chart-legend-group + .pict-chart-legend-group { margin-top: 0.5rem; }
.pict-chart-legend-group-header { display: flex; align-items: center; gap: 0.35rem; cursor: pointer;
	font-size: 0.68rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0; }
.pict-chart-legend-group-header:hover { color: var(--theme-color-text-primary, #1f2733); }
.pict-chart-legend-group-caret { font-size: 0.6rem; transition: transform 0.12s ease; }
.pict-chart-legend-group.pict-collapsed .pict-chart-legend-group-caret { transform: rotate(-90deg); }
.pict-chart-legend-group.pict-collapsed .pict-chart-legend-items { display: none; }
/* A group whose series are ALL hidden is dimmed as a whole, so the group toggle
   reads as a control rather than decoration. */
.pict-chart-legend-group.pict-group-off .pict-chart-legend-group-header { opacity: 0.45; }

.pict-chart-legend-items { display: flex; flex-direction: column; gap: 0.1rem; }
.pict-chart-legend-top .pict-chart-legend-items,
.pict-chart-legend-bottom .pict-chart-legend-items { flex-direction: row; flex-wrap: wrap; gap: 0.1rem 0.75rem; }

.pict-chart-legend-item { display: flex; align-items: center; gap: 0.4rem; cursor: pointer;
	padding: 0.1rem 0.2rem; border-radius: 4px; }
.pict-chart-legend-item:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.04)); }
.pict-chart-legend-item.pict-hidden { opacity: 0.4; }
.pict-chart-legend-item.pict-hidden .pict-chart-legend-label { text-decoration: line-through; }
.pict-chart-legend-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* The swatch carries the series' identity: colour, and whether it is a solid
   line, a dashed one, or unconnected markers. A legend that shows every entry
   as the same solid block cannot distinguish a reading from its control limit. */
.pict-chart-legend-swatch { flex: 0 0 auto; width: 1.4rem; height: 0.7rem; position: relative; }
.pict-chart-legend-swatch::before { content: ''; position: absolute; left: 0; right: 0; top: 50%;
	transform: translateY(-50%); height: 0.15rem; border-radius: 1px; background: currentColor; }
.pict-chart-legend-swatch.pict-swatch-dashed::before {
	background: repeating-linear-gradient(to right, currentColor 0 0.28rem, transparent 0.28rem 0.5rem); }
.pict-chart-legend-swatch.pict-swatch-dotted::before {
	background: repeating-linear-gradient(to right, currentColor 0 0.12rem, transparent 0.12rem 0.28rem); }
.pict-chart-legend-swatch.pict-swatch-markers::before { display: none; }
.pict-chart-legend-swatch.pict-swatch-markers::after { content: ''; position: absolute; left: 50%; top: 50%;
	transform: translate(-50%, -50%); width: 0.45rem; height: 0.45rem; border-radius: 50%; background: currentColor; }

.pict-chart-legend-toggle { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer;
	font-size: 0.68rem; color: var(--theme-color-text-muted, #6b7686);
	background: none; border: 1px solid var(--theme-color-border-light, #e8ebf0);
	border-radius: 5px; padding: 0.1rem 0.4rem; margin-bottom: 0.35rem; }
.pict-chart-legend-toggle:hover { color: var(--theme-color-text-primary, #1f2733);
	border-color: var(--theme-color-border-strong, #c2c9d2); }

/* ---------------------------------------------------------------------------
   PRINT
   ---------------------------------------------------------------------------
   Three things break when a Chart.js chart is printed from the browser, and none
   of them is "canvas does not print" -- the canvas rasterises fine.

   1. CLIPPING. Chart.js writes an INLINE style.width/height on the canvas taken
      from the SCREEN layout, and only corrects it from a ResizeObserver whose
      callback runs in requestAnimationFrame -- which never fires inside the
      synchronous print snapshot. So a canvas laid out at ~930px keeps that width
      on a page box narrower than it, and the right-hand side is simply cut off.
      max-width:100% overrides the inline width; height:auto keeps the ratio.

   2. VANISHING SWATCHES. The legend swatches are painted with background and
      ::before/::after gradients, and browsers drop backgrounds in print unless
      the reader happens to tick "Background graphics". Without these the legend
      prints as a column of empty boxes and nothing can be matched to a line --
      on a control chart, where telling the reading from the limits is the entire
      point, that is worse than printing no legend at all.

   3. INTERACTIVE AFFORDANCES. A hide-legend button and a collapse caret are
      meaningless on paper, and a group a reader happened to collapse on screen
      must still print -- collapsing is a space affordance, not a statement about
      the data.
*/
@media print
{
	.pict-input-chart canvas { max-width: 100% !important; height: auto !important; }
	.pict-input-chart { break-inside: avoid; page-break-inside: avoid; }

	/* Legend under the plot so the plot gets the full page width. */
	.pict-chart-shell { display: block; break-inside: avoid; page-break-inside: avoid; }
	.pict-chart-canvas-area { width: 100%; }
	.pict-chart-legend { max-width: none; width: 100%; margin-top: 0.35rem; }
	.pict-chart-legend-items { flex-direction: row; flex-wrap: wrap; gap: 0.1rem 0.75rem; }

	.pict-chart-legend-toggle { display: none !important; }

	.pict-chart-legend-group.pict-collapsed .pict-chart-legend-items { display: flex !important; }

	.pict-chart-legend-swatch,
	.pict-chart-legend-swatch::before,
	.pict-chart-legend-swatch::after
	{
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
}
`;

module.exports = libCSS;

},{}],518:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libChartCSS = require('./Pict-Provider-Input-Chart-CSS.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		// Manage the the configuration parsing configurations -- these can be overridden in the object or even per-input
		if (!this.options.DefaultCoreParsingConfiguration || !Array.isArray(this.options.DefaultCoreParsingConfiguration))
		{
			this.options.DefaultCoreParsingConfiguration = (
				{
					AddressInObject: '',
					ObjectType: 'object',
					MergeMethod: 'Object',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartConfigCorePrototypeRaw',
							Method: `Raw`,
							Merge: true
						},
						{
							InputProperty: 'PictForm.ChartConfigCorePrototypeAddress',
							Method: `Address`,
							Merge: true
						},
						{
							InputProperty: `PictForm.ChartConfigCorePrototype`,
							Method: 'SingleSolver',
							Merge: true
						}
					]
				});
		}
		this.defaultCoreParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultCoreParsingConfiguration));

		if (typeof (this.options.DefaultLabelParsingConfiguration) !== 'object' || !Array.isArray(this.options.DefaultLabelParsingConfiguration.Steps))
		{
			this.options.DefaultLabelParsingConfiguration = (
				{
					AddressInObject: 'data.labels',
					ObjectType: 'array',
					MergeMethod: 'Array',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartLabelsRaw',
							Method: `Raw`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartLabelsAddress',
							Method: `Address`,
							Merge: false
						},
						{
							InputProperty: `PictForm.ChartLabelsSolver`,
							Method: 'SingleSolver',
							Merge: false
						}
					]
				});
		}
		this.defaultLabelParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultLabelParsingConfiguration));

		if (typeof (this.options.DefaultDataParsingConfiguration) !== 'object' || !Array.isArray(this.options.DefaultDataParsingConfiguration.Steps))
		{
			this.options.DefaultDataParsingConfiguration = (
				{
					AddressInObject: 'data.datasets',
					ObjectType: 'array',
					MergeMethod: 'Array',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsRaw',
							Method: `Raw`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsAddress',
							Method: `Address`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsSolvers',
							Method: `ArrayOfSolvers`,
							Merge: true
						}
					]
				});
		}
		this.defaultDataParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultDataParsingConfiguration));

		this.currentChartObjects = {};
		this.currentChartDataObjects = {};
		// Legend visibility + collapsed groups, per input hash, so a redraw does not
		// undo what the user toggled.
		this.currentChartLegendState = {};

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Input-Chart-CSS', libChartCSS, 500);
		}
	}

	/**
	 * Classify a dataset's line style for its legend swatch, so a reading, a
	 * dashed control limit and an unconnected marker series are told apart at a
	 * glance. Chart.js's own legend draws every entry as the same block.
	 *
	 * @param {Object} pDataset - The Chart.js dataset.
	 * @return {string} A swatch modifier class.
	 */
	_legendSwatchClass(pDataset)
	{
		if (pDataset.showLine === false) { return 'pict-swatch-markers'; }
		const tmpDash = Array.isArray(pDataset.borderDash) ? pDataset.borderDash : null;
		if (!tmpDash || tmpDash.length < 1) { return ''; }
		// A short first segment reads as dotted, a long one as dashed.
		return (Number(tmpDash[0]) <= 3) ? 'pict-swatch-dotted' : 'pict-swatch-dashed';
	}

	/**
	 * Group the datasets for the legend. A dataset declares its group with
	 * `LegendGroup` on the solver entry (carried onto the dataset as
	 * `pictLegendGroup`); anything that does not is "Data". Group ORDER follows
	 * first appearance, so configuration controls it rather than sort order.
	 *
	 * @param {Object} pChart - The Chart.js instance.
	 * @return {Array<{Key: string, Items: Array<{Index: number, Dataset: Object}>}>}
	 */
	_legendGroups(pChart)
	{
		const tmpGroups = [];
		const tmpIndex = {};
		const tmpDatasets = (pChart && pChart.data && pChart.data.datasets) || [];
		for (let i = 0; i < tmpDatasets.length; i++)
		{
			const tmpKey = tmpDatasets[i].pictLegendGroup || 'Data';
			if (!(tmpKey in tmpIndex))
			{
				tmpIndex[tmpKey] = tmpGroups.length;
				tmpGroups.push({ Key: tmpKey, Items: [] });
			}
			tmpGroups[tmpIndex[tmpKey]].Items.push({ Index: i, Dataset: tmpDatasets[i] });
		}
		return tmpGroups;
	}

	/**
	 * Build (or rebuild) the grouped HTML legend beside a chart's canvas.
	 *
	 * The legend is created in the DOM rather than in the template because there
	 * are several chart templates (the base set plus per-theme copies) and a
	 * legend added to only some of them is the kind of divergence that goes
	 * unnoticed. Chart.js's built-in legend is switched off whenever this runs.
	 *
	 * @param {string} pRawHTMLID - The input's Macro.RawHTMLID.
	 * @param {Object} pChart - The Chart.js instance.
	 * @param {Object} pLegendConfiguration - The resolved ChartLegend config.
	 */
	renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration)
	{
		if (typeof (document) === 'undefined' || !pChart || !pChart.canvas) { return false; }
		const tmpCanvas = pChart.canvas;
		const tmpContainer = tmpCanvas.parentElement;
		if (!tmpContainer) { return false; }

		const tmpState = this.currentChartLegendState[pRawHTMLID] = this.currentChartLegendState[pRawHTMLID] || { Hidden: false, Collapsed: {} };
		const tmpPosition = pLegendConfiguration.Position || 'right';

		// Wrap the canvas ONCE: shell > (canvas area | legend).
		//
		// After the first wrap the container's parent is the canvas AREA, not the
		// shell, so testing the immediate parent for 'pict-chart-shell' never matches
		// again and every re-render nests another shell inside the last -- 14 shells
		// and 14 legends for 3 charts after a handful of toggles. Detect the wrapped
		// shape by its own marker and climb to the shell.
		let tmpShell = null;
		const tmpExistingArea = tmpContainer.parentElement;
		if (tmpExistingArea && tmpExistingArea.classList.contains('pict-chart-canvas-area')
			&& tmpExistingArea.parentElement && tmpExistingArea.parentElement.classList.contains('pict-chart-shell'))
		{
			tmpShell = tmpExistingArea.parentElement;
		}
		if (!tmpShell)
		{
			tmpShell = document.createElement('div');
			tmpShell.className = 'pict-chart-shell';
			tmpContainer.parentNode.insertBefore(tmpShell, tmpContainer);
			const tmpArea = document.createElement('div');
			tmpArea.className = 'pict-chart-canvas-area';
			tmpShell.appendChild(tmpArea);
			tmpArea.appendChild(tmpContainer);
		}
		tmpShell.classList.remove('pict-chart-legend-top', 'pict-chart-legend-bottom');
		if (tmpPosition === 'top') { tmpShell.classList.add('pict-chart-legend-top'); }
		if (tmpPosition === 'bottom') { tmpShell.classList.add('pict-chart-legend-bottom'); }

		let tmpLegend = tmpShell.querySelector(':scope > .pict-chart-legend');
		if (!tmpLegend)
		{
			tmpLegend = document.createElement('div');
			tmpLegend.className = 'pict-chart-legend';
			tmpShell.appendChild(tmpLegend);
		}
		tmpLegend.innerHTML = '';

		// Show/hide the whole legend. Charts differ in how much room they have,
		// so this is per-chart and remembered for the session.
		if (pLegendConfiguration.AllowHide !== false)
		{
			const tmpToggle = document.createElement('button');
			tmpToggle.type = 'button';
			tmpToggle.className = 'pict-chart-legend-toggle';
			tmpToggle.textContent = tmpState.Hidden ? 'Show legend' : 'Hide legend';
			tmpToggle.addEventListener('click', () =>
			{
				tmpState.Hidden = !tmpState.Hidden;
				this.renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration);
			});
			tmpLegend.appendChild(tmpToggle);
		}
		if (tmpState.Hidden) { return true; }

		const tmpGroups = this._legendGroups(pChart);
		for (const tmpGroup of tmpGroups)
		{
			const tmpGroupElement = document.createElement('div');
			tmpGroupElement.className = 'pict-chart-legend-group';
			const tmpAllHidden = tmpGroup.Items.every((pItem) => pChart.getDatasetMeta(pItem.Index).hidden === true);
			if (tmpAllHidden) { tmpGroupElement.classList.add('pict-group-off'); }
			if (tmpState.Collapsed[tmpGroup.Key]) { tmpGroupElement.classList.add('pict-collapsed'); }

			const tmpHeader = document.createElement('div');
			tmpHeader.className = 'pict-chart-legend-group-header';
			const tmpCaret = document.createElement('span');
			tmpCaret.className = 'pict-chart-legend-group-caret';
			tmpCaret.textContent = '▾';
			tmpHeader.appendChild(tmpCaret);
			const tmpHeaderLabel = document.createElement('span');
			tmpHeaderLabel.textContent = tmpGroup.Key;
			tmpHeader.appendChild(tmpHeaderLabel);
			// Header click toggles the GROUP's series on/off; the caret collapses it.
			tmpHeader.addEventListener('click', (pEvent) =>
			{
				if (pEvent.target === tmpCaret)
				{
					tmpState.Collapsed[tmpGroup.Key] = !tmpState.Collapsed[tmpGroup.Key];
				}
				else
				{
					const tmpTurnOn = tmpAllHidden;
					for (const tmpItem of tmpGroup.Items)
					{
						pChart.getDatasetMeta(tmpItem.Index).hidden = tmpTurnOn ? false : true;
					}
					pChart.update();
				}
				this.renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration);
			});
			tmpGroupElement.appendChild(tmpHeader);

			const tmpItems = document.createElement('div');
			tmpItems.className = 'pict-chart-legend-items';
			for (const tmpItem of tmpGroup.Items)
			{
				const tmpHidden = pChart.getDatasetMeta(tmpItem.Index).hidden === true;
				const tmpItemElement = document.createElement('div');
				tmpItemElement.className = 'pict-chart-legend-item' + (tmpHidden ? ' pict-hidden' : '');
				const tmpSwatch = document.createElement('span');
				tmpSwatch.className = ('pict-chart-legend-swatch ' + this._legendSwatchClass(tmpItem.Dataset)).trim();
				tmpSwatch.style.color = tmpItem.Dataset.borderColor || tmpItem.Dataset.backgroundColor || '#868E96';
				tmpItemElement.appendChild(tmpSwatch);
				const tmpLabel = document.createElement('span');
				tmpLabel.className = 'pict-chart-legend-label';
				tmpLabel.textContent = tmpItem.Dataset.label || `Series ${tmpItem.Index + 1}`;
				tmpLabel.title = tmpLabel.textContent;
				tmpItemElement.appendChild(tmpLabel);
				tmpItemElement.addEventListener('click', () =>
				{
					pChart.getDatasetMeta(tmpItem.Index).hidden = !tmpHidden;
					pChart.update();
					this.renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration);
				});
				tmpItems.appendChild(tmpItemElement);
			}
			tmpGroupElement.appendChild(tmpItems);
			tmpLegend.appendChild(tmpGroupElement);
		}
		return true;
	}

	/**
	 * Resolve the ChartLegend configuration for an input. Returns null when the
	 * grouped legend is not in use, in which case Chart.js's own legend stands.
	 *
	 * @param {Object} pInput - The PictForm input object.
	 * @return {Object|null}
	 */
	resolveChartLegendConfiguration(pInput)
	{
		const tmpPictform = (pInput && pInput.PictForm) || {};
		const tmpLegend = tmpPictform.ChartLegend;
		if (!tmpLegend) { return null; }
		if (tmpLegend === true) { return { Position: 'right' }; }
		if (typeof (tmpLegend) !== 'object') { return null; }
		if (tmpLegend.Enabled === false) { return null; }
		return tmpLegend;
	}

	/**
	 * 
	 * @param {Object} pInput - The PictForm input object
	 * @param {*} pChartConfiguration - The current configuration object for the form
	 * @param {*} pParsingConfiguration - The parsing configuration to apply
	 * @param {*} pInputParsingConfigurationScope - The input-specific parsing configuration string address for additional configuration
	 * @returns 
	 */
	applyInputParsingConfiguration(pInput, pChartConfiguration, pParsingConfiguration, pInputParsingConfigurationScope)
	{
		// TODO: There is a ton of DRY to be had in this function when we break it out to the base class
		let tmpInput = pInput;
		let tmpInputParsingConfigurationScope = pInputParsingConfigurationScope;

		let tmpChartConfiguration = pChartConfiguration;
		let tmpParsingConfiguration = pParsingConfiguration;

		if (typeof (pInput) !== 'object')
		{
			return false;
		}
		if (typeof (pInputParsingConfigurationScope) !== 'string' || (pInputParsingConfigurationScope.length < 1))
		{
			return false;
		}
		if (typeof (tmpParsingConfiguration) !== 'object')
		{
			return false;
		}

		if (typeof (tmpChartConfiguration) !== 'object')
		{
			tmpChartConfiguration = {};
		}

		// 1. Check if there is any custom configurtion for how to parse the config for this input (dynamic dynamic)
		let tmpInputCustomConfiguration = this.pict.manifest.getValueByHash(tmpInput, tmpInputParsingConfigurationScope);
		if (typeof (tmpInputCustomConfiguration) === 'object')
		{
			// Merge the custom configuration into the base configuration
			tmpParsingConfiguration = Object.assign(tmpParsingConfiguration, tmpInputCustomConfiguration);
		}

		// Get existing data
		let tmpExistingData;
		if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
		{
			tmpExistingData = tmpChartConfiguration;
		}
		else
		{
			tmpExistingData = this.pict.manifest.getValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject);
		}

		// 2. Enumerate through each step and apply them consistently
		for (let i = 0; i < tmpParsingConfiguration.Steps.length; i++)
		{
			let tmpCurrentStep = tmpParsingConfiguration.Steps[i];

			switch (tmpCurrentStep.Method)
			{
				case 'Initialize':
					// Do nothing, already initialized
					if (tmpParsingConfiguration.AddressInObject && (typeof (tmpParsingConfiguration.AddressInObject) === 'string') && (tmpParsingConfiguration.AddressInObject.length > 0))
					{
						let tmpCurrentStepData = this.pict.manifest.getValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject);
						// see if the address exists and if it's the type we expect
						if (tmpParsingConfiguration.ObjectType === 'array')
						{
							if (!tmpCurrentStepData || !Array.isArray(tmpCurrentStepData))
							{
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, []);
							}
						}
						else if (tmpParsingConfiguration.ObjectType === 'object')
						{
							if (!tmpCurrentStepData || (typeof (tmpCurrentStepData) !== 'object'))
							{
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, {});
							}
						}
						else
						{
							this.pict.log.warn(`Unsupported ObjectType ${tmpParsingConfiguration.ObjectType} parsing chart Initialize configuration for input ${tmpInput.Macro.RawHTMLID}`);
						}
					}
					break;
				case 'Raw':
					// Check if the Raw is in there
					let tmpRawDataExists = this.pict.manifest.checkAddressExists(tmpInput, tmpCurrentStep.InputProperty);
					if (!tmpRawDataExists)
					{
						break;
					}

					// Get the raw data from the input
					let tmpRawData = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					let tmpRawDataType = typeof(tmpRawData);

					// We only support objects as configuration
					if (tmpRawDataType !== 'object')
					{
						break;
					}

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpRawData))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpRawData);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpRawData);
								}
								else
								{
									tmpChartConfiguration = tmpRawData;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpRawData);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;
				case 'Address':
					let tmpAddress = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					// Input is the Record in the resolution chain
					if (!tmpAddress)
					{
						break;
					}

					let tmpPotentialConfigurationObject = this.pict.resolveStateFromAddress(tmpAddress, pInput);

					if (typeof (tmpPotentialConfigurationObject) !== 'object')
					{
						break;
					}

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpRawData))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpRawData);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpRawData);
								}
								else
								{
									tmpChartConfiguration = tmpRawData;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpRawData);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;
				case 'SingleSolver':
					let tmpSolverExpression = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					// Check that the expression is a string
					if (typeof (tmpSolverExpression) !== 'string')
					{
						break;
					}

					let tmpSolvedConfiguration = this.pict.providers.DynamicSolver.runSolver(tmpSolverExpression, true);

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpSolvedConfiguration))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpSolvedConfiguration);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedConfiguration);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpSolvedConfiguration);
								}
								else
								{
									tmpChartConfiguration = tmpSolvedConfiguration;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpSolvedConfiguration);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;

				case 'ArrayOfSolvers':
					let tmpSolverExpressionList = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);

					// Check that the expression is a string
					if (!Array.isArray(tmpSolverExpressionList))
					{
						break;
					}

					for (let i = 0; i < tmpSolverExpressionList.length; i++)
					{
						let tmpCurrentSolverExpression = tmpSolverExpressionList[i];
						if (typeof(tmpCurrentSolverExpression) !== 'object')
						{
							continue;
						}

						let tmpSolverLabel = tmpCurrentSolverExpression.Label;
						let tmpSolverExpression = tmpCurrentSolverExpression.DataSolver;
						let tmpSolvedDataSet = this.pict.providers.DynamicSolver.runSolver(tmpSolverExpression, true);

						let tmpDataObject = (
							{
								label: tmpSolverLabel,
								data: (Array.isArray(tmpSolvedDataSet)) ? tmpSolvedDataSet : []
							});

						if (tmpCurrentSolverExpression.ChartType)
						{
							tmpDataObject.type = tmpCurrentSolverExpression.ChartType;
						}

						// Add in any custom Y axis ID
						if (tmpCurrentSolverExpression.CustomYAxisID)
						{
							tmpDataObject.yAxisID = tmpCurrentSolverExpression.CustomYAxisID;
						}

						// Add in any custom X axis ID
						if (tmpCurrentSolverExpression.CustomXAxisID)
						{
							tmpDataObject.xAxisID = tmpCurrentSolverExpression.CustomXAxisID;
						}

						// Add in a custom Tension
						if (tmpCurrentSolverExpression.Tension)
						{
							tmpDataObject.tension = tmpCurrentSolverExpression.Tension;
						}
						
						// Add in a custom pointRadius
						if (tmpCurrentSolverExpression.PointRadius)
						{
							tmpDataObject.pointRadius = tmpCurrentSolverExpression.PointRadius;
						}

						// Check if this has a stack defined (for stacked bar charts and such)
						if (tmpCurrentSolverExpression.StackGroup)
						{
							tmpDataObject.stack = tmpCurrentSolverExpression.StackGroup;
						}

						// DatasetOptions is the general escape hatch: every key is merged onto
						// the Chart.js dataset as-is. Without it a dataset could only carry the
						// handful of properties named above, so a series could not be given a
						// colour, a dash pattern, or told not to join its points -- the config
						// was silently dropped and the chart drew in default colours. It is
						// applied last, so it wins over the named options above.
						if (tmpCurrentSolverExpression.DatasetOptions && (typeof(tmpCurrentSolverExpression.DatasetOptions) === 'object'))
						{
							Object.assign(tmpDataObject, tmpCurrentSolverExpression.DatasetOptions);
						}

						// Which legend group this series belongs to ("Data", "Limits", …).
						// Carried as a pict-prefixed key so it cannot collide with a Chart.js
						// dataset property.
						if (tmpCurrentSolverExpression.LegendGroup)
						{
							tmpDataObject.pictLegendGroup = tmpCurrentSolverExpression.LegendGroup;
						}

						if (tmpParsingConfiguration.ObjectType === 'array')
						{
							if (Array.isArray(tmpSolvedDataSet))
							{
								if (tmpCurrentStep.Merge)
								{
									// Get existing data
									if (!Array.isArray(tmpExistingData))
									{
										tmpExistingData = [];
									}
									tmpExistingData.push(tmpDataObject);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpExistingData);
								}
								else
								{
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, [tmpDataObject]);
								}
							}
						}
						else if (tmpParsingConfiguration.ObjectType === 'object')
						{
							if (tmpCurrentStep.Merge)
							{
								if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
								{
									// This is the "root" object, so we need to merge or set directly
									if (tmpCurrentStep.Merge)
									{
										tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpSolvedDataSet);
									}
									else
									{
										tmpChartConfiguration = tmpSolvedDataSet;
									}
								}
								else
								{
									if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
									{
										tmpExistingData = {};
									}
									if (tmpCurrentStep.Merge)
									{
										// Merge the objects
										let tmpMergedData = Object.assign(tmpExistingData, tmpSolvedDataSet);
										this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
									}
									else
									{
										// Just set the value
										this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
									}
								}
							}
							else
							{
								// Just set the value?
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					break;
			}
		}
	}

	getInputChartConfiguration(pView, pInput, pValue)
	{
		let tmpView = pView;
		let tmpInput = pInput;
		let tmpValue = pValue;

		if (!('PictForm' in tmpInput))
		{
			return false;
		}

		let tmpPictform = pInput.PictForm;

		let tmpChartConfiguration = (typeof (tmpPictform.ChartJSOptionsCorePrototype) === 'object') ? tmpPictform.ChartJSOptionsCorePrototype : {};

		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultCoreParsingConfiguration, 'PictForm.ChartConfigCoreParsingConfigurationOverride');
		if (!('type' in tmpChartConfiguration))
		{
			tmpChartConfiguration.type = (typeof (tmpPictform.ChartType) === 'string') ? tmpPictform.ChartType : 'bar';
		}
		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultLabelParsingConfiguration, 'PictForm.ChartLabelsParsingConfigurationOverride');
		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultDataParsingConfiguration, 'PictForm.ChartDataParsingConfigurationOverride');

		// A blank is a MISSING reading, not a zero one. Solver-built series routinely carry "" for
		// "this measure has no value here" -- a control limit the agency does not publish, a sample
		// the lab never ran -- and Chart.js coerces that empty string to 0, drawing a line that dives
		// to the axis and reads as a real measurement of zero. Chart.js's own convention for a gap is
		// null, so blanks are normalized to it and the series simply breaks. Set ChartPlotBlanksAsZero
		// to keep the old coercion for a chart that genuinely means zero.
		if (!tmpPictform.ChartPlotBlanksAsZero)
		{
			const tmpDatasets = tmpChartConfiguration?.data?.datasets;
			if (Array.isArray(tmpDatasets))
			{
				for (let i = 0; i < tmpDatasets.length; i++)
				{
					if (!tmpDatasets[i] || !Array.isArray(tmpDatasets[i].data)) { continue; }
					tmpDatasets[i].data = tmpDatasets[i].data.map(
						(pPoint) => ((pPoint === '') || (pPoint === null) || (typeof (pPoint) === 'undefined')) ? null : pPoint);
				}
			}
		}

		// ChartHeight is one knob with two halves: the template gives the canvas container a min-height,
		// and Chart.js has to be told to stop deriving its own height from the width or it will ignore
		// that box entirely. Requiring a caller to set maintainAspectRatio by hand alongside the height
		// would make a single intent ("make this chart taller") into two coupled settings that are wrong
		// in isolation, so it is derived here. An explicit maintainAspectRatio in the core prototype still
		// wins -- this only fills in the value the caller did not state.
		// The grouped legend replaces Chart.js's own, which is a single wrapped row
		// of identical swatches -- unreadable once a chart carries a reading, a
		// running average and three pairs of control limits.
		if (this.resolveChartLegendConfiguration(pInput))
		{
			if (typeof (tmpChartConfiguration.options) !== 'object' || tmpChartConfiguration.options === null)
			{
				tmpChartConfiguration.options = {};
			}
			if (typeof (tmpChartConfiguration.options.plugins) !== 'object' || tmpChartConfiguration.options.plugins === null)
			{
				tmpChartConfiguration.options.plugins = {};
			}
			tmpChartConfiguration.options.plugins.legend = Object.assign({}, tmpChartConfiguration.options.plugins.legend, { display: false });
		}

		const tmpChartHeight = parseFloat(tmpPictform.ChartHeight);
		if (isFinite(tmpChartHeight) && (tmpChartHeight > 0))
		{
			if (typeof (tmpChartConfiguration.options) !== 'object' || tmpChartConfiguration.options === null)
			{
				tmpChartConfiguration.options = {};
			}
			if (!('maintainAspectRatio' in tmpChartConfiguration.options))
			{
				tmpChartConfiguration.options.maintainAspectRatio = false;
			}
			if (!('responsive' in tmpChartConfiguration.options))
			{
				tmpChartConfiguration.options.responsive = true;
			}
		}

		return tmpChartConfiguration;
	}

	initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Stuff the config into a hidden element for reference
		let tmpConfigStorageLocation = `#CONFIG-FOR-${pInput.Macro.RawHTMLID}`;
		let tmpChartConfiguration = this.getInputChartConfiguration(pView, pInput, pValue);
		this.pict.ContentAssignment.assignContent(tmpConfigStorageLocation, JSON.stringify(tmpChartConfiguration));

		let tmpChartCanvasElementSelector = `#CANVAS-FOR-${pInput.Macro.RawHTMLID}`;
		let tmpChartCanvasElement = this.pict.ContentAssignment.getElement(tmpChartCanvasElementSelector);
		if ((!Array.isArray(tmpChartCanvasElement)) || (tmpChartCanvasElement.length < 1))
		{
			this.log.warn(`Chart canvas element not found for input ${tmpChartCanvasElementSelector}`);
			return false;
		}
		tmpChartCanvasElement = tmpChartCanvasElement[0]

		// Check if there is a window.Chart which is the Chart.js library
		if (typeof (window.Chart) !== 'function')
		{
			this.log.warn(`Chart.js library not loaded for input ${tmpChartCanvasElementSelector}`);
		}
		else
		{
			this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`] = new window.Chart(tmpChartCanvasElement, tmpChartConfiguration);
			// TODO: Make this invalidation better.
			this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] = JSON.stringify(tmpChartConfiguration.data);

			const tmpLegendConfiguration = this.resolveChartLegendConfiguration(pInput);
			if (tmpLegendConfiguration)
			{
				this.renderChartLegend(pInput.Macro.RawHTMLID, this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`], tmpLegendConfiguration);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`])
		{
			this.initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		}
		else
		{
			let tmpChartConfiguration = this.getInputChartConfiguration(pView, pInput, pValue);
			let tmpNewChartDataString = JSON.stringify(tmpChartConfiguration.data);
			if (this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] !== tmpNewChartDataString)
			{
				this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`].data = tmpChartConfiguration.data;
				this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`].update();
				const tmpUpdatedLegendConfiguration = this.resolveChartLegendConfiguration(pInput);
				if (tmpUpdatedLegendConfiguration)
				{
					this.renderChartLegend(pInput.Macro.RawHTMLID, this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`], tmpUpdatedLegendConfiguration);
				}
				this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] = tmpNewChartDataString;
			}
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @returns {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509,"./Pict-Provider-Input-Chart-CSS.js":517}],519:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 * Represents a custom input handler for a Pict section form.
 * @extends libPictSectionInputExtension
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a DateTime input element based on the given input HTML ID.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @returns {string} The generated DateTime input HTML ID.
	 */
	getDateTimeInputHTMLID(pInputHTMLID)
	{
		return `#DATETIME-INPUT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a hidden input element in a tabular datetime data provider.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns {string} - The generated HTML ID for the hidden input element.
	 */
	getTabularDateTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular date-time input HTML ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} The tabular date-time input HTML ID.
	 */
	getTabularDateTimeInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Fires after data has been marshaled to the form.
	 *
	 * This is important because the DateTime has a "shadow" hidden input that stores the value for the date control.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method call.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form in a tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for the specified input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean} - Returns true if the data request is successful, otherwise false.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		// TODO: Should this be opinionated about time zone?  If so, this is the start of it.
		// let tmpDateTimeElement = this.pict.ContentAssignment.getElement(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID));
		// if (tmpDateTimeElement && tmpDateTimeElement.length > 0)
		// {
		// 	tmpDateTimeElement = tmpDateTimeElement[0];
		// }
		// else
		// {
		// 	return false;
		// }
		//let tmpDateValue = this.fable.Dates.dayJS(tmpDateTimeElement.value);

		let tmpInputSelectValue;
		try
		{
			tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID));
			this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
			pView.dataChanged(pInput.Hash);
		}
		catch
		{
			this.log.error(`The value [${tmpInputSelectValue}] is not a valid date; skipping parsing for [#${pInput.Macro.RawHTMLID}].`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for the specified input when in a tabular section.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {boolean} - Returns true if the data request is successful, otherwise false.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// TODO: If we decide to be opinionated about time zone, use the above here as well
		let tmpInputSelectValue;
		try
		{
			tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
			pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		}
		catch
		{
			this.log.error(`The value [${tmpInputSelectValue}] is not a valid date; skipping parsing for [#${pInput.Macro.RawHTMLID}].`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],520:[function(require,module,exports){
/**
 * Pict-Provider-Input-Diagram-CSS.js
 *
 * Scoped CSS for the Diagram form-input slot. Registered via
 * `pict.CSSMap.addCSS('Pict-Input-Diagram-CSS', libCSS, 500)` from the
 * provider's constructor.
 *
 * SVG content rendered into the view-mode slot uses palette CSS variables
 * (`--diagram-ink`, `--diagram-accent`, etc.) emitted by Themeify-SVG. The
 * SVG carries hex fallbacks inline, so the diagram looks correct even when no
 * theme variables are defined.
 *
 * Class names:
 *
 *   .pict-section-form-diagram        the outer slot the form template emits
 *   .pict-section-form-diagram-view   the inline-SVG container (view mode)
 *   .pict-section-form-diagram-edit   the Excalidraw container (edit mode)
 *   .pict-section-form-diagram-toggle "Edit" / "Done" affordance chip
 */

module.exports = /*css*/`
.pict-section-form-diagram
{
	display: block;
	width: 100%;
	min-height: 120px;
	border: 1px solid var(--theme-color-border-primary, #D4C4A8);
	border-radius: 4px;
	background: var(--theme-color-background-primary, #FFFFFF);
	color: var(--theme-color-text-primary, #2A2520);
	box-sizing: border-box;
	position: relative;
}

.pict-section-form-diagram-view
{
	padding: 12px;
	min-height: 96px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: auto;
}

.pict-section-form-diagram-view.is-empty
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-style: italic;
	font-size: 0.9rem;
}

.pict-section-form-diagram-view svg
{
	display: block;
	max-width: 100%;
	height: auto;
}

/* Open-editor sizing.
 *
 * The height is a variable so the provider can drive it from the descriptor's Diagram.Height (and
 * from a height the user dragged to) without inlining a whole style block. The default clears
 * Excalidraw's own 500px "this is a phone" breakpoint AND leaves the shape-properties island room to
 * render unscrolled — below that the island is clipped to a scrolling sliver and the property
 * buttons become miserable to hit.
 *
 * The resize:vertical rule is the drag grip, the same affordance a textarea has; it needs a
 * non-visible overflow to show up at all. The floor is deliberately a small absolute value rather than the
 * configured height, or the grip could not drag below whatever the field was configured to. */
.pict-section-form-diagram-edit
{
	padding: 0;
	height: var(--pict-diagram-height, 560px);
	min-height: 180px;
	display: flex;
	resize: vertical;
	overflow: hidden;
}

/* The Excalidraw view brings its own chrome inside the slot. Force the wrap and the Excalidraw root
 * to FILL rather than to floor: a min-height in here would fight the grip on the way down and pin
 * the canvas taller than the box the user just dragged. */
.pict-section-form-diagram-edit > .pict-excalidraw-wrap,
.pict-section-form-diagram-edit > .pict-excalidraw-wrap > .pict-excalidraw-mount
{
	flex: 1 1 auto;
	min-height: 0;
	height: 100%;
}

.pict-section-form-diagram-edit .excalidraw
{
	width: 100%;
	height: 100%;
	min-height: 0;
}

.pict-section-form-diagram-toggle
{
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 2;
	padding: 3px 9px;
	font-size: 0.72rem;
	font-weight: 600;
	color: var(--theme-color-text-secondary, #5A4A3C);
	background: var(--theme-color-background-tertiary, #F4EEE2);
	border: 1px solid var(--theme-color-border-secondary, #D4C4A8);
	border-radius: 3px;
	cursor: pointer;
	user-select: none;
}

.pict-section-form-diagram-toggle:hover
{
	color: var(--theme-color-text-primary, #2A2520);
	background: var(--theme-color-background-primary, #FFFFFF);
	border-color: var(--theme-color-accent, #2E7D74);
}

.pict-section-form-diagram.mode-edit .pict-section-form-diagram-toggle::after { content: 'Done'; }
.pict-section-form-diagram.mode-view .pict-section-form-diagram-toggle::after { content: 'Edit'; }
`;

},{}],521:[function(require,module,exports){
/**
 * Pict-Provider-Input-Diagram.js
 *
 * A pict-section-form input provider that pairs Excalidraw (edit mode) with
 * an inline SVG (view mode). Boots in VIEW mode — the heavy Excalidraw bundle
 * isn't pulled until the host UI calls
 * `provider.setMode(pInputHash, 'edit')`.
 *
 * The stored value is an Excalidraw-exported SVG carrying the embedded scene
 * in its <metadata>. View mode writes that SVG verbatim into the slot. Edit
 * mode parses the embedded scene back out (via the wrapper's loadFromBlob)
 * and seeds Excalidraw with it.
 *
 * Descriptor shape:
 *
 *   {
 *     "Name": "Architecture",
 *     "Hash": "ArchDiagram",
 *     "DataType": "String",
 *     "PictForm": {
 *       "InputType": "Diagram",
 *       "Diagram": {
 *         "ThemeColors":           true,
 *         "Height":                "640px",
 *         "FormFactor":            "pointer",
 *         "EditorImplementation":  "react",
 *         "EditorOptions":         { ... }
 *       }
 *     }
 *   }
 *
 * Runtime API:
 *
 *   provider.setMode(inputHash, 'edit' | 'view', fCallback)
 *   provider.getMode(inputHash)
 *   provider.toggleMode(inputHash)
 *   provider.commit(inputHash, fCallback)
 */

const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libPictSectionExcalidraw     = require('pict-section-excalidraw');

// Form templates live in pict-section-form's default-template set, so no
// runtime template injection is needed here. CSS still needs registering.
const libCSS      = require('./Pict-Provider-Input-Diagram-CSS.js');
const libThemeify = require('./util/Themeify-SVG.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Input-Diagram',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	AutoSolveWithApp: false
};

/**
 * @typedef {Object} Instance
 * @property {string} mode - 'edit' or 'view'
 * @property {string} slotID - The HTML ID of the content slot for this input
 * @property {string} lastValue - The last known value (SVG string)
 * @property {Object} viewInstance - The editor view instance (if in edit mode)
 * @property {string} viewHash - The hash of the editor view (if in edit mode)
 * @property {Object} input - The input definition object
 */

class PictInputDiagram extends libPictSectionInputExtension
{
	/**
	 * Creates an instance of the PictInputExtensionProvider class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */ this.pict;
		/** @type {any}            */ this.log;

		// inputHash → { mode, slotID, lastValue (SVG string), viewInstance?, viewHash?, input }
		/** @type {Record<String, Instance>} */
		this._instances = {};

		// Register the scoped CSS.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Input-Diagram-CSS', libCSS, 500);
		}
	}

	// ----------------------------------------------------------------------------
	// Helpers
	// ----------------------------------------------------------------------------

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @returns {string} The HTML ID selector for the content display slot corresponding to the input.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @param {number} pRowIndex - The row index for tabular inputs.
	 * @returns {string} The HTML ID selector for the content display slot corresponding to the tabular input.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Resolve the value to use for display/editing, following this precedence:
	 * 1. The provided pValue (if a non-empty string)
	 * 2. The input's Content property (if a non-empty string)
	 * 3. The input's Default property (if a non-empty string)
	 * 4. An empty string if none of the above are valid
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {any} pValue - The value provided for the input.
	 * @returns {string} The resolved value to use for display/editing.
	 */
	_resolveValue(pInput, pValue)
	{
		if (typeof pValue === 'string' && pValue.length > 0) return pValue;
		if (pInput && pInput.Content && typeof pInput.Content === 'string') return pInput.Content;
		if (pInput && pInput.Default && typeof pInput.Default === 'string') return pInput.Default;
		return '';
	}

	/**
	 * @param {any} pValue - The value to check.
	 * @return {boolean} True if the value is a string that appears to contain an <svg> element, false otherwise.
	 */
	_isLikelySvg(pValue)
	{
		return (typeof pValue === 'string') && /<svg[\s>]/i.test(pValue);
	}

	/**
	 * @param {string} pSlotID - The HTML ID of the content slot to assign.
	 * @param {string} pHTML - The HTML string to assign to the slot.
	 * @returns {boolean} True if the assignment was successful, false otherwise.
	 */
	_assignSlotContent(pSlotID, pHTML)
	{
		if (this.pict && this.pict.ContentAssignment &&
			typeof this.pict.ContentAssignment.assignContent === 'function')
		{
			this.pict.ContentAssignment.assignContent(pSlotID, pHTML);
			return true;
		}
		return false;
	}

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input whose hidden value field should be updated.
	 * @param {string} pValue - The SVG string to set as the value of the hidden input field.
	 * @returns {boolean} True if the value was successfully written and a change event dispatched, false otherwise.
	 */
	_writeHiddenInputValue(pInputHTMLID, pValue)
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pInputHTMLID) : null;
		if (!tmpEl) return false;
		tmpEl.value = (pValue == null) ? '' : String(pValue);
		try { tmpEl.dispatchEvent(new Event('change', { bubbles: true })); }
		catch (pErr) { /* jsdom may lack Event */ }
		return true;
	}

	_resolveVendor()
	{
		if (typeof window === 'undefined') return null;
		return window.PictSectionExcalidrawVendor || null;
	}

	/**
	 * Wrap an SVG string in a thin <div> for the view-mode slot. If the value
	 * is empty or not an SVG, show an "(empty)" placeholder.
	 *
	 * @param {string} pValue - The SVG string to wrap for display.
	 * @returns {string} The HTML string to assign to the view slot.
	 */
	_buildViewHTML(pValue)
	{
		if (this._isLikelySvg(pValue))
		{
			return `<div class="pict-section-form-diagram-view">${pValue}</div>`;
		}
		return `<div class="pict-section-form-diagram-view is-empty">(empty diagram)</div>`;
	}

	/**
	 * Flag edit/view mode on the DISPLAY SLOT so the scoped CSS (sizing, the resize grip, the toggle
	 * chip pseudo) has something to key off.
	 *
	 * The slot is resolved FIRST and the RawHTMLID element is only a fallback. That order is
	 * load-bearing: a host template is free to put `id="{RawHTMLID}"` on the hidden <input> (it has
	 * to, if it wants the provider's value write-back to find it), and when it does,
	 * `getElementById(RawHTMLID)` returns that hidden input — so every mode class, and with it every
	 * sizing rule keyed off `.pict-section-form-diagram-edit`, lands on an invisible element and the
	 * editor silently falls back to the embed's own min-height. Our own default template omits that
	 * id, so this reordering is a no-op there.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {string} pMode - The mode to set ('edit' or 'view').
	 */
	_setSlotModeClass(pInput, pMode)
	{
		if (typeof document === 'undefined') return;
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpOuter = document.querySelector(this.getContentDisplayHTMLID(tmpRawHTMLID)) ||
			document.getElementById(tmpRawHTMLID);
		if (!tmpOuter || !tmpOuter.classList) return;
		tmpOuter.classList.remove('mode-edit', 'mode-view', 'pict-section-form-diagram-edit');
		if (pMode === 'edit')
		{
			tmpOuter.classList.add('mode-edit', 'pict-section-form-diagram-edit');
		}
		else
		{
			tmpOuter.classList.add('mode-view');
		}
	}

	// ----------------------------------------------------------------------------
	// Editor height
	// ----------------------------------------------------------------------------

	/**
	 * @param {Object} pInput - The input definition object.
	 * @returns {Element} The display slot element for this input, or null when it isn't in the DOM.
	 */
	_getSlotElement(pInput)
	{
		if ((typeof document === 'undefined') || !pInput || !pInput.Macro) return null;
		return document.querySelector(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID));
	}

	/**
	 * Coerce a configured height into a CSS length. Bare numbers (and numeric strings) are treated as
	 * pixels so a descriptor can say 640 or "640" as readily as "640px".
	 *
	 * @param {any} pValue - The configured height.
	 * @returns {string} A CSS length, or '' when the value isn't usable.
	 */
	_normalizeHeight(pValue)
	{
		if (typeof pValue === 'number')
		{
			return (isFinite(pValue) && pValue > 0) ? `${pValue}px` : '';
		}
		if (typeof pValue !== 'string') return '';
		let tmpValue = pValue.trim();
		if (tmpValue.length < 1) return '';
		if (/^[0-9]+(\.[0-9]+)?$/.test(tmpValue)) return `${tmpValue}px`;
		// Anything else is passed through as authored (px/rem/vh/calc()/…) — the browser ignores a
		// value it can't parse, which degrades to the stylesheet default rather than breaking layout.
		return tmpValue;
	}

	/**
	 * @param {Object} pInput - The input definition object.
	 * @returns {string} The localStorage key this input's user-dragged height is remembered under.
	 */
	_heightStorageKey(pInput)
	{
		return `pict-input-diagram:height:${(pInput && pInput.Hash) || ''}`;
	}

	/**
	 * @param {Object} pInput - The input definition object.
	 * @returns {string} The remembered height for this input, or '' if there isn't one.
	 */
	_readStoredHeight(pInput)
	{
		try
		{
			if ((typeof window === 'undefined') || !window.localStorage) return '';
			return this._normalizeHeight(window.localStorage.getItem(this._heightStorageKey(pInput)));
		}
		catch (pErr)
		{
			// Storage can throw outright (Safari private mode, blocked site data) — a forgotten height
			// is not worth a broken editor.
			return '';
		}
	}

	/**
	 * @param {Object} pInput - The input definition object.
	 * @param {string} pHeight - The height to remember.
	 * @returns {boolean} True if it was written.
	 */
	_writeStoredHeight(pInput, pHeight)
	{
		try
		{
			if ((typeof window === 'undefined') || !window.localStorage) return false;
			window.localStorage.setItem(this._heightStorageKey(pInput), pHeight);
			return true;
		}
		catch (pErr)
		{
			return false;
		}
	}

	/**
	 * Resolve the editor height for an input: a height the user dragged to wins over the descriptor's
	 * configured Height, which wins over the stylesheet default (signalled by '').
	 *
	 * @param {Object} pInput - The input definition object.
	 * @returns {string} A CSS length, or '' to leave the stylesheet in charge.
	 */
	_resolveEditorHeight(pInput)
	{
		let tmpStored = this._readStoredHeight(pInput);
		if (tmpStored) return tmpStored;
		let tmpDiagramOpts = (pInput.PictForm && pInput.PictForm.Diagram) || {};
		return this._normalizeHeight(tmpDiagramOpts.Height);
	}

	/**
	 * Push the resolved height onto the slot as `--pict-diagram-height`, which the scoped CSS reads.
	 * Any inline height left behind by an earlier drag is dropped first so the variable is what
	 * actually applies on a fresh mount.
	 *
	 * @param {Object} pInput - The input definition object.
	 */
	_applyEditorHeight(pInput)
	{
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || !tmpSlot.style) return;
		tmpSlot.style.removeProperty('height');
		let tmpHeight = this._resolveEditorHeight(pInput);
		if (tmpHeight)
		{
			tmpSlot.style.setProperty('--pict-diagram-height', tmpHeight);
		}
		else
		{
			tmpSlot.style.removeProperty('--pict-diagram-height');
		}
	}

	/**
	 * Strip the edit-mode sizing when dropping back to view. The resize grip writes an INLINE height
	 * onto the slot, and that would otherwise pin the static SVG view to whatever the canvas was
	 * dragged to.
	 *
	 * @param {Object} pInput - The input definition object.
	 */
	_clearEditorHeight(pInput)
	{
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || !tmpSlot.style) return;
		tmpSlot.style.removeProperty('height');
		tmpSlot.style.removeProperty('width');
		tmpSlot.style.removeProperty('--pict-diagram-height');
	}

	/**
	 * Remember whatever height the slot is currently sitting at. Only an INLINE height counts — that is
	 * what the native resize grip writes; a height coming from the stylesheet or the descriptor is not
	 * a user decision and must not be frozen into storage.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @returns {boolean} True if a height was remembered.
	 */
	_captureEditorHeight(pInput)
	{
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || !tmpSlot.style || !tmpSlot.style.height) return false;
		return this._writeStoredHeight(pInput, tmpSlot.style.height);
	}

	/**
	 * Watch the slot so a height the user drags to is remembered for next time. The grip is native CSS
	 * `resize` (no drag handling of our own), so a ResizeObserver is the only signal that it moved.
	 * Debounced — a drag fires continuously.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {Object} pInstance - The instance record to hang the observer off.
	 */
	_observeEditorResize(pInput, pInstance)
	{
		if (typeof ResizeObserver === 'undefined') return;
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || pInstance.resizeObserver) return;
		let tmpProvider = this;
		pInstance.resizeObserver = new ResizeObserver(() =>
		{
			if (pInstance.resizeTimer) clearTimeout(pInstance.resizeTimer);
			pInstance.resizeTimer = setTimeout(() =>
			{
				pInstance.resizeTimer = null;
				tmpProvider._captureEditorHeight(pInput);
			}, 300);
		});
		try { pInstance.resizeObserver.observe(tmpSlot); }
		catch (pErr) { pInstance.resizeObserver = null; }
	}

	/**
	 * @param {Object} pInstance - The instance record whose resize watcher should be torn down.
	 */
	_unobserveEditorResize(pInstance)
	{
		if (!pInstance) return;
		if (pInstance.resizeTimer)
		{
			clearTimeout(pInstance.resizeTimer);
			pInstance.resizeTimer = null;
		}
		if (pInstance.resizeObserver)
		{
			try { pInstance.resizeObserver.disconnect(); }
			catch (pErr) { /* already gone */ }
			pInstance.resizeObserver = null;
		}
	}

	// ----------------------------------------------------------------------------
	// View mode
	// ----------------------------------------------------------------------------

	_mountView(pView, pInput, pValue)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpValue     = this._resolveValue(pInput, pValue);

		this._assignSlotContent(tmpSlotID, this._buildViewHTML(tmpValue));
		this._setSlotModeClass(pInput, 'view');
		this._clearEditorHeight(pInput);

		let tmpInst = this._instances[pInput.Hash] || {};
		tmpInst.mode         = 'view';
		tmpInst.slotID       = tmpSlotID;
		tmpInst.lastValue    = tmpValue;
		tmpInst.input        = pInput;
		tmpInst.viewInstance = null;
		this._instances[pInput.Hash] = tmpInst;
	}

	// ----------------------------------------------------------------------------
	// Edit mode
	// ----------------------------------------------------------------------------

	_extractSceneFromSvg(pSVG, fCallback)
	{
		// Convert the SVG string into a Blob/File and pass through the wrapper's
		// loadFromBlob, which extracts the embedded scene from the metadata.
		if (!this._isLikelySvg(pSVG))
		{
			return fCallback(null, null);
		}

		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.loadFromBlob)
		{
			if (this.log) this.log.warn('[Pict-Input-Diagram] vendor.loadFromBlob unavailable — falling back to empty scene');
			return fCallback(null, null);
		}

		try
		{
			// Browser-side construction of a Blob; pass null/null per the
			// vendor's signature (localAppState, localElements).
			let tmpBlob = new window.Blob([pSVG], { type: 'image/svg+xml' });
			let tmpPromise = tmpVendor.loadFromBlob(tmpBlob, null, null);
			Promise.resolve(tmpPromise).then(
				(pScene) => { fCallback(null, pScene || null); },
				(pErr)   => { fCallback(pErr, null); }
			);
		}
		catch (pErr)
		{
			fCallback(pErr, null);
		}
	}

	_buildEditorOptions(pInput, pValue, pInst)
	{
		let tmpDiagramOpts = (pInput.PictForm && pInput.PictForm.Diagram) || {};
		let tmpEditorOpts  = tmpDiagramOpts.EditorOptions || {};
		let tmpRawHTMLID   = pInput.Macro.RawHTMLID;

		// Per-input AppData stash for the scene (so re-renders don't lose it
		// when the editor unmounts).
		if (!this.pict.AppData._PictInputDiagram) this.pict.AppData._PictInputDiagram = {};
		if (!this.pict.AppData._PictInputDiagram[pInput.Hash])
		{
			this.pict.AppData._PictInputDiagram[pInput.Hash] = { Scene: null };
		}
		let tmpDrawingAddr = `AppData._PictInputDiagram.${pInput.Hash}.Scene`;

		// Pin a Provider to register Excalidraw's resources (icons, etc.) once
		// on the host pict — done by Pict-Section-Excalidraw's own provider.
		let tmpOptions = Object.assign({}, tmpEditorOpts,
		{
			ViewIdentifier:       `Pict-Input-Diagram-Editor-${pInput.Hash}`,
			TargetElementAddress: this.getContentDisplayHTMLID(tmpRawHTMLID),
			DrawingDataAddress:   tmpDrawingAddr,
			EditorImplementation: tmpDiagramOpts.EditorImplementation || 'react',
			// Excalidraw picks its UI density from the CONTAINER's box, so an embedded canvas — which is
			// short by definition — reads as a phone and buries the shape properties behind a popover.
			// 'pointer' asks the embed to classify by input device instead: desktop chrome for a mouse,
			// Excalidraw's own detection on a touch screen. See pict-section-excalidraw's FormFactor.
			FormFactor:           tmpDiagramOpts.FormFactor || 'pointer'
		});

		return tmpOptions;
	}

	_mountEdit(pView, pInput, pValue, fCallback)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpValue     = this._resolveValue(pInput, pValue);
		let tmpInst      = this._instances[pInput.Hash] || {};
		tmpInst.input    = pInput;
		let tmpDiagramOpts = (pInput.PictForm && pInput.PictForm.Diagram) || {};
		let tmpThemeColors = (tmpDiagramOpts.ThemeColors !== false);

		// Clear view-mode content.
		this._assignSlotContent(tmpSlotID, '');

		this._extractSceneFromSvg(tmpValue, (pExtractErr, pScene) =>
		{
			let tmpEditorOpts  = this._buildEditorOptions(pInput, tmpValue, tmpInst);
			let tmpViewHash    = tmpEditorOpts.ViewIdentifier;
			let tmpProvider    = this;

			// Inject the parsed scene into the per-input AppData stash so the
			// editor's _resolveInitialData picks it up.
			if (pScene && this.pict.AppData._PictInputDiagram &&
				this.pict.AppData._PictInputDiagram[pInput.Hash])
			{
				this.pict.AppData._PictInputDiagram[pInput.Hash].Scene =
				{
					elements: pScene.elements || [],
					appState: pScene.appState || {},
					files:    pScene.files    || {}
				};
			}

			// OnChange handler — debounced inside the editor view itself; we
			// just trigger an SVG export and stamp into the form-data input.
			tmpEditorOpts.OnChange = (pEditorView, pSceneSnap) =>
			{
				try
				{
					let tmpExportPromise = pEditorView.exportSvg({ exportEmbedScene: true, exportBackground: false });
					Promise.resolve(tmpExportPromise).then(
						(pSvgEl) =>
						{
							let tmpSvgStr = (pSvgEl && typeof pSvgEl.outerHTML === 'string') ? pSvgEl.outerHTML :
								(typeof pSvgEl === 'string') ? pSvgEl : null;
							if (!tmpSvgStr) return;

							if (tmpThemeColors)
							{
								tmpSvgStr = libThemeify.themeifySVG(tmpSvgStr);
							}

							tmpProvider._writeHiddenInputValue(tmpRawHTMLID, tmpSvgStr);
							let tmpLatest = tmpProvider._instances[pInput.Hash];
							if (tmpLatest) tmpLatest.lastValue = tmpSvgStr;
						},
						(pExpErr) =>
						{
							if (tmpProvider.log)
							{
								tmpProvider.log.warn('[Pict-Input-Diagram] exportSvg failed in OnChange',
									{ error: pExpErr.message, inputHash: pInput.Hash });
							}
						}
					);
				}
				catch (pErr)
				{
					if (tmpProvider.log)
					{
						tmpProvider.log.warn('[Pict-Input-Diagram] OnChange handler threw',
							{ error: pErr.message, inputHash: pInput.Hash });
					}
				}
			};

			this.pict.addView(tmpViewHash, tmpEditorOpts, libPictSectionExcalidraw);
			let tmpEditorView = this.pict.views[tmpViewHash];
			if (!tmpEditorView)
			{
				let tmpErr = new Error('Failed to instantiate Diagram editor view ' + tmpViewHash);
				if (this.log) this.log.error('[Pict-Input-Diagram] addView returned nothing', { viewHash: tmpViewHash });
				if (typeof fCallback === 'function') fCallback(tmpErr);
				return;
			}

			this._setSlotModeClass(pInput, 'edit');
			this._applyEditorHeight(pInput);
			this._observeEditorResize(pInput, tmpInst);

			tmpInst.mode         = 'edit';
			tmpInst.slotID       = tmpSlotID;
			tmpInst.lastValue    = tmpValue;
			tmpInst.viewInstance = tmpEditorView;
			tmpInst.viewHash     = tmpViewHash;
			tmpInst.themeColors  = tmpThemeColors;
			this._instances[pInput.Hash] = tmpInst;

			try
			{
				let tmpResult = tmpEditorView.render();
				if (tmpResult && typeof tmpResult.then === 'function')
				{
					tmpResult.then(
						() => { if (typeof fCallback === 'function') fCallback(null); },
						(pRenderErr) => { if (typeof fCallback === 'function') fCallback(pRenderErr); }
					);
				}
				else
				{
					if (typeof fCallback === 'function') fCallback(null);
				}
			}
			catch (pErr)
			{
				if (this.log) this.log.error('[Pict-Input-Diagram] editor.render threw', { error: pErr.message });
				if (typeof fCallback === 'function') fCallback(pErr);
			}
		});
	}

	_destroyEdit(pInput)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst) return;
		// Capture BEFORE teardown: ResizeObserver is frame-driven and never fires in a backgrounded or
		// headless context, so closing the editor is the one commit point we can rely on.
		this._captureEditorHeight(pInput);
		// Ahead of the viewInstance guard — a slot can be watched without a live editor view (a mount
		// that failed part way), and a leaked ResizeObserver would keep the detached slot alive.
		this._unobserveEditorResize(tmpInst);
		if (!tmpInst.viewInstance) return;

		let tmpView = tmpInst.viewInstance;
		try
		{
			if (typeof tmpView.destroy === 'function') tmpView.destroy();
		}
		catch (pErr)
		{
			if (this.log) this.log.warn('[Pict-Input-Diagram] editor.destroy threw', { error: pErr.message });
		}

		if (this.pict.AppData._PictInputDiagram &&
			this.pict.AppData._PictInputDiagram[pInput.Hash])
		{
			delete this.pict.AppData._PictInputDiagram[pInput.Hash];
		}

		if (tmpInst.viewHash && this.pict.views && this.pict.views[tmpInst.viewHash])
		{
			try { delete this.pict.views[tmpInst.viewHash]; }
			catch (pErr) { /* not all envs allow delete */ }
		}

		tmpInst.viewInstance = null;
		tmpInst.viewHash     = null;
	}

	// ----------------------------------------------------------------------------
	// Public runtime API
	// ----------------------------------------------------------------------------

	getMode(pInputHash)
	{
		let tmpInst = this._instances[pInputHash];
		return tmpInst ? tmpInst.mode : null;
	}

	setMode(pInputHash, pMode, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			let tmpErr = new Error('Cannot setMode — input is not mounted: ' + pInputHash);
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		if (pMode !== 'edit' && pMode !== 'view')
		{
			let tmpErr = new Error('setMode: unknown mode "' + pMode + '" (use "edit" or "view")');
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		if (tmpInst.mode === pMode)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}

		if (pMode === 'edit')
		{
			this._mountEdit(null, tmpInst.input, tmpInst.lastValue, fCallback);
			return;
		}

		this._destroyEdit(tmpInst.input);
		this._mountView(null, tmpInst.input, tmpInst.lastValue);
		if (typeof fCallback === 'function') fCallback(null);
	}

	toggleMode(pInputHash, fCallback)
	{
		let tmpMode = this.getMode(pInputHash);
		let tmpNext = (tmpMode === 'edit') ? 'view' : 'edit';
		this.setMode(pInputHash, tmpNext, fCallback);
	}

	commit(pInputHash, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst || tmpInst.mode !== 'edit' || !tmpInst.viewInstance)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}
		// Force a synchronous export so the form value reflects the latest
		// scene even if the throttled OnChange hasn't fired yet.
		let tmpThemeColors = tmpInst.themeColors !== false;
		let tmpProvider    = this;
		let tmpRawHTMLID   = tmpInst.input.Macro.RawHTMLID;
		try
		{
			let tmpExportPromise = tmpInst.viewInstance.exportSvg({ exportEmbedScene: true, exportBackground: false });
			Promise.resolve(tmpExportPromise).then(
				(pSvgEl) =>
				{
					let tmpSvgStr = (pSvgEl && typeof pSvgEl.outerHTML === 'string') ? pSvgEl.outerHTML : null;
					if (tmpSvgStr)
					{
						if (tmpThemeColors) tmpSvgStr = libThemeify.themeifySVG(tmpSvgStr);
						tmpProvider._writeHiddenInputValue(tmpRawHTMLID, tmpSvgStr);
						tmpInst.lastValue = tmpSvgStr;
					}
					if (typeof fCallback === 'function') fCallback(null);
				},
				(pErr) =>
				{
					if (typeof fCallback === 'function') fCallback(pErr);
				}
			);
		}
		catch (pErr)
		{
			if (typeof fCallback === 'function') fCallback(pErr);
		}
	}

	// ----------------------------------------------------------------------------
	// Lifecycle hooks
	// ----------------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._mountView(pView, pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 *
	 * @return {boolean}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		let tmpErr = new Error('Diagram InputType is not supported inside Tabular rows in Phase 1.');
		if (this.log) this.log.warn('[Pict-Input-Diagram] tabular not supported', { inputHash: pInput && pInput.Hash });
		throw tmpErr;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst)
		{
			this._mountView(pView, pInput, pValue);
		}
		else if (tmpInst.mode === 'view')
		{
			this._mountView(pView, pInput, pValue);
		}
		else
		{
			// Edit mode: hot-replace the editor's scene.
			tmpInst.lastValue = (typeof pValue === 'string') ? pValue : tmpInst.lastValue;
			this._extractSceneFromSvg(tmpInst.lastValue, (pErr, pScene) =>
			{
				if (pErr || !pScene) return;
				if (tmpInst.viewInstance && typeof tmpInst.viewInstance.setScene === 'function')
				{
					try { tmpInst.viewInstance.setScene(pScene); }
					catch (pSetErr)
					{
						if (this.log) this.log.warn('[Pict-Input-Diagram] setScene threw after marshal',
							{ error: pSetErr.message });
					}
				}
			});
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = PictInputDiagram;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../Pict-Provider-InputExtension.js":509,"./Pict-Provider-Input-Diagram-CSS.js":520,"./util/Themeify-SVG.js":537,"pict-section-excalidraw":491}],522:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class for Entity Bundle Requests.
 *
 * When an input is flagged as an EntityBundleRequest entity, it will go pull a
 * sequential list of records on data selection.
 *
 * Paired with the AutofillTriggerGroup, this allows other values to be filled
 * when a record is selected and fetched.

Providers: ["Pict-Input-EntityBundleRequest", "Pict-Input-TriggerGroup"],
		EntitiesBundle: [
		{
			"Entity": "Author",
			"Filter": "FBV~IDAuthor~EQ~{~D:Record.Value~}",
			"Destination": "AppData.CurrentAuthor",
			// This marshals a single record
			"SingleRecord": true
		},
		{
			"Entity": "BookAuthorJoin",
			"Filter": "FBV~IDAuthor~EQ~{~D:Appdata.CurrentAuthor.IDAuthor~}",
			"Destination": "AppData.BookAuthorJoins"
		},
		{
			"Entity": "Book",
			"Filter": "FBL~IDBook~LK~{PJU~:,^IDBook^Appdata.BookAuthorJoins~}",
			"Destination": "AppData.BookAuthorJoins"
		}
	],
	EntityBundleTriggerGroup: "BookTriggerGroup"

 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	gatherEntitySet(fCallback, pEntityInformation, pView, pInput, pValue)
	{
		// First sanity check the pEntityInformation
		if (!('Entity' in pEntityInformation) || (typeof(pEntityInformation.Entity) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain an Entity string.`);
			return fCallback();
		}
		if (!('Filter' in pEntityInformation) || (typeof(pEntityInformation.Filter) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Filter string.`);
			return fCallback();
		}
		if (!('Destination' in pEntityInformation) || (typeof(pEntityInformation.Destination) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Destination string.`);
			return fCallback();
		}

		const tmpFilterTemplateRecord = { Value:pValue, Input:pInput, View:pView };
		let tmpRecordStartCursor = null;
		let tmpRecordCount = null;
		if (pEntityInformation.RecordCount)
		{
			tmpRecordStartCursor = pEntityInformation.RecordStartCursor != null ? pEntityInformation.RecordStartCursor : 0;
			tmpRecordCount = pEntityInformation.RecordCount != null ? pEntityInformation.RecordCount : null;
		}
		// Parse the filter template
		const tmpFilterString = this.pict.parseTemplate(pEntityInformation.Filter, tmpFilterTemplateRecord);
		if (tmpFilterString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity Filter did not return a string for FilterBy`)
		}

		// Now get the records
		const callback = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting entity set for [${pEntityInformation.Entity}] with filter [${tmpFilterString}]: ${pError}`, pError);
				return fCallback(pError, '');
			}

			this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]`);

			// Now assign it back to the destination; because this is not view specific it doesn't use the manifests from them (to deal with scope overlap with subgrids).
			if (pEntityInformation.SingleRecord)
			{
				if (pRecordSet.length > 1)
				{
					this.log.warn(`EntityBundleRequest found more than one record for ${pEntityInformation.Entity} filtered to [${tmpFilterString}] but SingleRecord is true; setting the first record.`);
				}
				if (pRecordSet.length < 1)
				{
					this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, false);
				}
				this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, pRecordSet[0]);
			}
			else
			{
				this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, pRecordSet);
			}

			return fCallback();
		};
		if (tmpRecordCount)
		{
			this.pict.EntityProvider.getEntitySetPage(pEntityInformation.Entity, tmpFilterString, tmpRecordStartCursor, tmpRecordCount, callback);
		}
		else
		{
			this.pict.EntityProvider.getEntitySet(pEntityInformation.Entity, tmpFilterString, callback);
		}
	}

	gatherCustomDataSet(fCallback, pCustomRequestInformation, pView, pInput, pValue)
	{
		// First sanity check the pCustomRequestInformation
		if (!('URL' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URL) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the stanza did not contain a URL string.`);
			return fCallback();
		}

		const tmpURLTemplateRecord = { Value:pValue, Input:pInput, View:pView };
		// Parse the filter template
		const tmpURLTemplateString = this.pict.parseTemplate(pCustomRequestInformation.URL, tmpURLTemplateRecord);
		if (tmpURLTemplateString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the entity Filter did not return a string for FilterBy`)
		}

		let tmpURLPrefix = '';
		// This will only be true if the "Host" is set.
		const tmpCustomURIHost = pCustomRequestInformation.Host ? pCustomRequestInformation.Host : false;
		// If "Host" is set, protocol and port are optional.
		const tmpCustomURIProtocol = pCustomRequestInformation.Protocol ? pCustomRequestInformation.Protocol : 'https';
		const tmpCustomURIPort = pCustomRequestInformation.Port ? pCustomRequestInformation.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.pict.EntityProvider.options.urlPrefix;
		}

		// Now get the records
		const callback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting data set for [${pCustomRequestInformation.Entity}] with filter [${tmpURLTemplateString}]: ${pError}`, pError);
				return fCallback(pError, '');
			}

			this.log.trace(`EntityBundleRequest completed request for ${pCustomRequestInformation.Entity} filtered to [${tmpURLTemplateString}]`);

			// Since this is a templated endpoint it can be used for logging etc.
			if (pCustomRequestInformation.Destination)
			{
				this.pict.manifest.setValueByHash(this.pict, pCustomRequestInformation.Destination, pData);
			}

			return fCallback();
		};

		let tmpOptions = (
			{
				url: `${tmpURLPrefix}${tmpURLTemplateString}`
			});
		tmpOptions = this.pict.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.pict.EntityProvider.restClient.getJSON(tmpOptions, callback);
	}

	/**
	 * TODO: I added a proise return here to know when this data load is done for the dashboard usecase. Could use a revisit.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} [pTransactionGUID] - (optional) The transaction GUID for the event dispatch.
	 *
	 * @return {Promise<Error?>} - Returns a promise that resolves when the data has been gathered.
	 */
	async gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Gather data from the server
		// These have to date not been asyncronous.  Now they will be...
		if ((typeof(pInput) !== 'object') || !('PictForm' in pInput) || !('EntitiesBundle' in pInput.PictForm) || !Array.isArray(pInput.PictForm.EntitiesBundle))
		{
			this.log.warn(`Input at ${pHTMLSelector} is set as an EntityBundleRequest input but no array of entity requests was found`);
			return null;
		}

		const tmpLoadGUID = `BundleLoad-${this.pict.getUUID()}`;
		if (pTransactionGUID)
		{
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpLoadGUID);
		}
		let tmpInput = pInput;
		let tmpValue = pValue;
		let tmpAnticipate = this.fable.newAnticipate();

		if (tmpInput.PictForm.EntitiesBundle.length > 0 && tmpInput.PictForm.EntitiesBundle[0].PictMode)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.pict.EntityProvider.gatherDataFromServer(tmpInput.PictForm.EntitiesBundle, (pError) =>
				{
					// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
					setTimeout(() => fNext(pError), 0);
				});
			});
		}
		else
		{
			const tmpStateStack = [];
			/** @type {Record<string, any>} */
			let tmpState = { Value: tmpValue, Input: tmpInput, View: pView };
			for (let i = 0; i < tmpInput.PictForm.EntitiesBundle.length; i++)
			{
				let tmpEntityBundleEntry = tmpInput.PictForm.EntitiesBundle[i];
				tmpAnticipate.anticipate(
					(fNext) =>
					{
						try
						{
							switch (tmpEntityBundleEntry.Type)
							{
								case 'Custom':
									return this.gatherCustomDataSet(fNext, tmpEntityBundleEntry, pView, tmpInput, tmpValue);
								case 'SetStateAddress':
									tmpStateStack.push(tmpState);
									tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
									if (typeof tmpState === 'undefined')
									{
										tmpState = {};
										this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
									}
									break;
								case 'PopState':
									if (tmpStateStack.length > 0)
									{
										tmpState = tmpStateStack.pop();
									}
									else
									{
										this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
									}
									break;
								case 'MapJoin':
									this.pict.EntityProvider.mapJoin(tmpEntityBundleEntry, this.pict.EntityProvider.prepareState(tmpState, tmpEntityBundleEntry));
									break;
								case 'ProjectDataset':
									this.pict.EntityProvider.projectDataset(tmpEntityBundleEntry, this.pict.EntityProvider.prepareState(tmpState, tmpEntityBundleEntry));
									break;
								// This is the default case, for a meadow entity set or single entity
								case 'MeadowEntity':
								default:
									return this.gatherEntitySet(fNext, tmpEntityBundleEntry, pView, tmpInput, tmpValue);
							}
						}
						catch (pError)
						{
							this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, pError);
						}
						return fNext();
					});
			}
			// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
			tmpAnticipate.anticipate((fNext) => setTimeout(fNext, 0));
		}

		tmpAnticipate.anticipate(
			(fNext) =>
			{
				if (tmpInput.PictForm.EntityBundleTriggerGroup && this.pict.views.PictFormMetacontroller)
				{
					const tmpGroupConfig = this.getTriggerGroupConfigurationArray(tmpInput, tmpInput.PictForm.EntityBundleTriggerGroup)[0];
					if (tmpGroupConfig && Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `EntityBundleTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} pre-trigger`);
					}
					let tmpTransactionGUID;
					if (tmpGroupConfig && Array.isArray(tmpGroupConfig.PostSolvers))
					{
						tmpTransactionGUID = pTransactionGUID || this.pict.getUUID();
						if (tmpTransactionGUID !== pTransactionGUID)
						{
							this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
						}
						pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
						{
							if (Array.isArray(tmpGroupConfig.PostSolvers))
							{
								this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `EntityBundleTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} post-trigger`);
								const tmpMarshalScope = tmpGroupConfig.MarshalOnComplete;
								if (tmpMarshalScope === true)
								{
									this.pict.views.PictFormMetacontroller.marshalToView();
								}
								else if (tmpMarshalScope)
								{
									this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
									this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
								}
							}
						});
					}
					// Trigger the autofill global event
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${tmpInput.PictForm.EntityBundleTriggerGroup}:BundleLoad:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`, pTransactionGUID);
					if (tmpTransactionGUID && tmpTransactionGUID !== pTransactionGUID)
					{
						pView.finalizeTransaction(tmpTransactionGUID);
					}
				}
				if (tmpInput.PictForm.EntityBundleTriggerMetacontrollerSolve && this.pict.views.PictFormMetacontroller)
				{
					// Trigger the solve global event
					this.pict.views.PictFormMetacontroller.solve();
				}
				if (tmpInput.PictForm.EntityBundleTriggerMetacontrollerRender && this.pict.views.PictFormMetacontroller)
				{
					// Trigger the render
					this.pict.views.PictFormMetacontroller.render();
				}
				fNext();
			});

		return new Promise((pResolve, pReject) =>
		{
			// Now fire the "autofilldata" event for the groups.
			tmpAnticipate.wait(
				(pError) =>
				{
					//FIXME: should we be ignoring this error? rejecting here is unsafe since the result isn't guaranteed to be handled, so will crash stuff currently
					if (pError)
					{
						this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, pError);
					}
					//TODO: close the async operation if we have a transaction GUID
					if (pTransactionGUID)
					{
						pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpLoadGUID);
					}

					return pResolve(pError);
				});
		});
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 * @return {Array<Record<string, any>>} - An array of trigger group configurations.
	 */
	getTriggerGroupConfigurationArray(pInput, pTriggerGroupHash)
	{
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups)
		{
			return [];
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		if (pTriggerGroupHash == null)
		{
			return tmpAutoFillTriggerGroups;
		}
		return tmpAutoFillTriggerGroups.filter((pGroup) => pGroup.TriggerGroupHash === pTriggerGroupHash);
	}


	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Try to get the input element
		if (pInput.PictForm && (pValue || pInput.PictForm.EntityBundleTriggerWithoutValue) && pInput.PictForm.EntityBundleTriggerOnInitialize)
		{
			// This is a request on initial load
			this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		// This is in case we need to do a request on initial load!
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.log.error(`EntityBundleRequest for input [${pInput.Hash}] Tabular support is intentionally not supported.`);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.PictForm && (pValue || pInput.PictForm.EntityBundleTriggerWithoutValue) && pInput.PictForm.EntityBundleTriggerOnDataChange !== false)
		{
			this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		const [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup' || !tmpGroupHash || pInput.PictForm.TriggerGroupHash !== tmpGroupHash)
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],523:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * FacetFilter input provider.
 *
 * Keeps a set of inputs that choose from one shared join list (their `Facet` ListFilterRules name the same
 * `JoinListAddress`) mutually consistent when one of them changes.  In a tabular group the set is the
 * facet inputs in the changed row only; outside a table it is the facet inputs in the same view.
 *
 * On a change it runs, before the form solves:
 *   1. ClearInvalid (default true): walking the siblings in column order, a sibling whose value no longer
 *      appears in any join record agreeing with the changed value (and the siblings already kept) is cleared.
 *   2. AutoFillSingle (default true): an empty sibling left with exactly one allowed value takes it, repeated
 *      until nothing changes.  The changed input itself is never filled, so clearing it sticks.
 *   3. CarryFields ({ "<row address>": "<join record address>" }): on a sibling that holds a value, the join
 *      record its facet set now identifies (exactly one agreeing record) is copied into the row; with no value,
 *      or no single record, those row fields are cleared.
 *
 * It only acts on a user change, never on load or marshal, so a saved value -- carried fields included -- is
 * never rewritten by opening a document or by the join list changing later.  Narrowing the offered options
 * is the `Facet` rule's job in ListDistilling.filterList.
 *
 *   ListFilterRules: [ { FilterType: "Facet", JoinListAddress: "AppData.Graph", JoinListAddressGlobal: true, JoinListValueAddress: "Colour" } ],
 *   Providers: [ "Pict-Input-FacetFilter" ]
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class FacetFilterInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		// Writing a sibling runs that sibling's change providers (this one included); only the user's change reconciles.
		this.reconciling = false;
	}

	/**
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {number|undefined} pRowIndex - undefined outside a table
	 * @param {any} pValue
	 */
	setFacetValue(pView, pInput, pRowIndex, pValue)
	{
		if ((typeof(pRowIndex) === 'number') || ((typeof(pRowIndex) === 'string') && (pRowIndex !== '')))
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pValue);
			return;
		}
		pView.setDataByInput(pInput, pValue);
	}

	/**
	 * Reconciles the changed input's facet siblings; see the class description.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput - the input the user changed
	 * @param {number} [pRowIndex]
	 * @return {Array<string>} hashes of the siblings whose value was changed
	 */
	reconcileFacets(pView, pInput, pRowIndex)
	{
		if (this.reconciling)
		{
			return [];
		}
		this.reconciling = true;
		try
		{
			return this.reconcileFacetSiblings(pView, pInput, pRowIndex);
		}
		finally
		{
			this.reconciling = false;
		}
	}

	/**
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput - the input the user changed
	 * @param {number} [pRowIndex]
	 * @return {Array<string>} hashes of the siblings whose value was changed
	 */
	reconcileFacetSiblings(pView, pInput, pRowIndex)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpSiblings = tmpDistilling.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpChanged = [];
		if (tmpSiblings.length < 2)
		{
			return tmpChanged;
		}

		const tmpKept = tmpSiblings.map((pSibling) => (pSibling.Input === pInput));
		for (let i = 0; i < tmpSiblings.length; i++)
		{
			const tmpSibling = tmpSiblings[i];
			if (tmpKept[i] || tmpDistilling.isEmptyFacetValue(tmpSibling.Value))
			{
				tmpKept[i] = true;
				continue;
			}
			const tmpConstraining = tmpSiblings.map((pOther, pIndex) => ({ Input: pOther.Input, Rule: pOther.Rule, Value: tmpKept[pIndex] ? pOther.Value : '' }));
			const tmpAllowed = tmpDistilling.getFacetAllowedValues(pView, tmpSibling.Input, tmpSibling.Rule, pRowIndex, tmpConstraining);
			if (tmpAllowed.has(String(tmpSibling.Value)) || (tmpSibling.Rule.ClearInvalid === false))
			{
				tmpKept[i] = true;
				continue;
			}
			tmpSibling.Value = '';
			this.setFacetValue(pView, tmpSibling.Input, pRowIndex, '');
			tmpChanged.push(tmpSibling.Input.Hash);
			tmpKept[i] = true;
		}

		for (let tmpPass = 0; tmpPass < tmpSiblings.length; tmpPass++)
		{
			let tmpFilled = false;
			for (const tmpSibling of tmpSiblings)
			{
				if ((tmpSibling.Input === pInput) || !tmpDistilling.isEmptyFacetValue(tmpSibling.Value) || (tmpSibling.Rule.AutoFillSingle === false))
				{
					continue;
				}
				const tmpAllowed = tmpDistilling.getFacetAllowedValues(pView, tmpSibling.Input, tmpSibling.Rule, pRowIndex, tmpSiblings);
				if (tmpAllowed.size === 1)
				{
					tmpSibling.Value = tmpAllowed.values().next().value;
					this.setFacetValue(pView, tmpSibling.Input, pRowIndex, tmpSibling.Value);
					tmpChanged.push(tmpSibling.Input.Hash);
					tmpFilled = true;
				}
			}
			if (!tmpFilled)
			{
				break;
			}
		}

		for (const tmpSibling of tmpSiblings)
		{
			if (tmpSibling.Rule.CarryFields && (typeof(tmpSibling.Rule.CarryFields) === 'object'))
			{
				this.carryFields(pView, tmpSibling, pRowIndex, tmpSiblings);
			}
		}
		return tmpChanged;
	}

	/**
	 * Copies a sibling's CarryFields from the one join record its facet set identifies, or clears them.
	 *
	 * @param {Object} pView
	 * @param {{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }} pSibling
	 * @param {number|undefined} pRowIndex
	 * @param {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>} pSiblings
	 */
	carryFields(pView, pSibling, pRowIndex, pSiblings)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		let tmpRecord = null;
		if (!tmpDistilling.isEmptyFacetValue(pSibling.Value))
		{
			const tmpMatches = tmpDistilling.getFacetMatchingRecords(pView, pSibling.Input, pSibling.Rule, pRowIndex, pSiblings)
				.filter((pJoinRecord) => String(this.pict.manifest.getValueAtAddress(pJoinRecord, pSibling.Rule.JoinListValueAddress)) === String(pSibling.Value));
			tmpRecord = (tmpMatches.length === 1) ? tmpMatches[0] : null;
		}
		const tmpIsTabular = (typeof(pRowIndex) === 'number') || ((typeof(pRowIndex) === 'string') && (pRowIndex !== ''));
		const tmpTarget = tmpIsTabular ? pView.getTabularRecordData(pSibling.Input.PictForm.GroupIndex, pRowIndex) : pView.getMarshalDestinationObject();
		if (!tmpTarget)
		{
			return;
		}
		for (const tmpRowAddress of Object.keys(pSibling.Rule.CarryFields))
		{
			const tmpValue = tmpRecord ? this.pict.manifest.getValueAtAddress(tmpRecord, pSibling.Rule.CarryFields[tmpRowAddress]) : '';
			this.pict.manifest.setValueAtAddress(tmpTarget, tmpRowAddress, (tmpValue === undefined) ? '' : tmpValue);
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any}
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.reconcileFacets(pView, pInput);
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.reconcileFacets(pView, pInput, pRowIndex);
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = FacetFilterInputHandler;

module.exports.default_configuration = (
{
	"ProviderIdentifier": "Pict-Input-FacetFilter",
	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

},{"../Pict-Provider-InputExtension.js":509}],524:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		return tmpContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],525:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class LinkInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { Math: any } & { DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.setAttribute(this.getInputHTMLID(pInput.Macro.RawHTMLID), 'href', pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.setAttribute(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), 'href', pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = LinkInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],526:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (tmpContent)
		{
			tmpContent = libMarked.parse(tmpContent);
		}
		return tmpContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509,"marked":495}],527:[function(require,module,exports){
/**
 * Pict-Provider-Input-ObjectEditor.js
 *
 * A pict-section-form input provider that embeds pict-section-objecteditor as
 * an interactive JSON-object editor. In edit mode the tree is editable
 * (Editable:true); in view / read-only mode the same tree renders read-only
 * (Editable:false). Unlike the Diagram input, the object editor is a light,
 * pure-JS view, so there is no lazy heavy-bundle split — both modes mount the
 * same view and only the Editable flag differs.
 *
 * The object the editor mutates lives in a per-input AppData stash at
 *
 *   AppData._PictInputObjectEditor.<InputHash>.Data
 *
 * The object editor mutates that object in place. On a data request (the form
 * gathering its values for a save) the stash is serialized to JSON and written
 * into the input's hidden field, so the form marshals it like any other value.
 *
 * Incoming values may be a live object OR a JSON string — both are accepted.
 *
 * Descriptor shape:
 *
 *   {
 *     "Name": "Custom Properties",
 *     "Hash": "CustomProperties",
 *     "DataType": "Object",
 *     "PictForm": {
 *       "InputType": "ObjectEditor",
 *       "ReadOnly": false,                 // true renders a read-only tree
 *       "ObjectEditor": {                  // all optional
 *         "Editable":           true,      // explicit override of ReadOnly
 *         "InitialExpandDepth": 2
 *       }
 *     }
 *   }
 *
 * Runtime API (parity with the other section inputs):
 *
 *   provider.setMode(inputHash, 'edit' | 'view', fCallback)
 *   provider.getMode(inputHash)
 *   provider.toggleMode(inputHash)
 *   provider.commit(inputHash, fCallback)
 */

const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libPictSectionObjectEditor   = require('pict-section-objecteditor');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Input-ObjectEditor',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	AutoSolveWithApp: false
};

/**
 * @typedef {Object} Instance
 * @property {string} mode - 'edit' or 'view'
 * @property {string} slotID - The HTML ID selector of the content slot for this input
 * @property {Object} viewInstance - The object editor view instance
 * @property {string} viewHash - The hash of the object editor view
 * @property {Object} input - The input definition object
 */

class PictInputObjectEditor extends libPictSectionInputExtension
{
	/**
	 * Creates an instance of the PictInputObjectEditor class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */ this.pict;
		/** @type {any}            */ this.log;

		// inputHash -> Instance
		/** @type {Record<String, Instance>} */
		this._instances = {};
	}

	// ----------------------------------------------------------------------------
	// Helpers
	// ----------------------------------------------------------------------------

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @returns {string} The HTML ID selector for the content display slot.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * The AppData address where this input's editable object is stashed.
	 *
	 * @param {string} pInputHash - The input Hash.
	 * @returns {string} The dotted AppData address the object editor binds to.
	 */
	getObjectDataAddress(pInputHash)
	{
		return `AppData._PictInputObjectEditor.${pInputHash}.Data`;
	}

	/**
	 * Resolve the incoming value to a plain object, accepting either a live
	 * object or a JSON string. Falls back to the input's Content / Default /
	 * an empty object.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {any} pValue - The value provided for the input.
	 * @returns {Object} The resolved object to edit/display.
	 */
	_resolveValue(pInput, pValue)
	{
		let tmpCandidate = pValue;
		if (tmpCandidate === null || typeof tmpCandidate === 'undefined' || tmpCandidate === '')
		{
			if (pInput && typeof pInput.Content !== 'undefined' && pInput.Content !== null && pInput.Content !== '')
			{
				tmpCandidate = pInput.Content;
			}
			else if (pInput && typeof pInput.Default !== 'undefined' && pInput.Default !== null && pInput.Default !== '')
			{
				tmpCandidate = pInput.Default;
			}
		}

		if (typeof tmpCandidate === 'string')
		{
			let tmpTrimmed = tmpCandidate.trim();
			if (tmpTrimmed.length < 1)
			{
				return {};
			}
			try
			{
				let tmpParsed = JSON.parse(tmpTrimmed);
				return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : { Value: tmpParsed };
			}
			catch (pErr)
			{
				if (this.log)
				{
					this.log.warn('[Pict-Input-ObjectEditor] value was a non-JSON string; wrapping as { Value }',
						{ error: pErr.message });
				}
				return { Value: tmpCandidate };
			}
		}

		if (tmpCandidate && typeof tmpCandidate === 'object')
		{
			return tmpCandidate;
		}

		return {};
	}

	/**
	 * Determine whether the editor should be editable for this input. An
	 * explicit PictForm.ObjectEditor.Editable boolean wins; otherwise the tree
	 * is editable unless PictForm.ReadOnly is true.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @returns {boolean} True if the tree should be editable.
	 */
	_resolveEditable(pInput)
	{
		let tmpPictForm = (pInput && pInput.PictForm) || {};
		if (tmpPictForm.ObjectEditor && typeof tmpPictForm.ObjectEditor.Editable === 'boolean')
		{
			return tmpPictForm.ObjectEditor.Editable;
		}
		return (tmpPictForm.ReadOnly !== true);
	}

	/**
	 * Ensure the per-input AppData stash exists and return its wrapper.
	 *
	 * @param {string} pInputHash - The input Hash.
	 * @returns {Object} The stash wrapper { Data }.
	 */
	_ensureStash(pInputHash)
	{
		if (!this.pict.AppData._PictInputObjectEditor)
		{
			this.pict.AppData._PictInputObjectEditor = {};
		}
		if (!this.pict.AppData._PictInputObjectEditor[pInputHash])
		{
			this.pict.AppData._PictInputObjectEditor[pInputHash] = { Data: {} };
		}
		return this.pict.AppData._PictInputObjectEditor[pInputHash];
	}

	/**
	 * @param {string} pInputHash - The input Hash.
	 * @returns {Object} The current edited object from the stash.
	 */
	_currentObject(pInputHash)
	{
		return this._ensureStash(pInputHash).Data;
	}

	/**
	 * Serialize an object into the input's hidden field.
	 *
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @param {Object} pObject - The object to serialize.
	 * @param {boolean} [pDispatchChange] - When true, dispatch a DOM change event.
	 * @returns {boolean} True if the value was written.
	 */
	_writeHiddenInputValue(pInputHTMLID, pObject, pDispatchChange)
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pInputHTMLID) : null;
		if (!tmpEl) return false;

		let tmpString = '';
		try
		{
			tmpString = (pObject === null || typeof pObject === 'undefined') ? '' : JSON.stringify(pObject);
		}
		catch (pErr)
		{
			if (this.log)
			{
				this.log.warn('[Pict-Input-ObjectEditor] could not stringify object for hidden input',
					{ error: pErr.message });
			}
			tmpString = '';
		}
		tmpEl.value = tmpString;

		if (pDispatchChange)
		{
			try { tmpEl.dispatchEvent(new Event('change', { bubbles: true })); }
			catch (pErr) { /* jsdom may lack Event */ }
		}
		return true;
	}

	// ----------------------------------------------------------------------------
	// Mount / render
	// ----------------------------------------------------------------------------

	/**
	 * Mount (or re-render) the object editor for an input. Re-uses the view
	 * instance across re-renders, re-painting into the (possibly fresh) slot.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {any} pValue - The value to edit/display.
	 * @param {boolean} pEditable - Whether the tree is editable.
	 * @param {Function} [fCallback] - Optional completion callback.
	 */
	_mount(pInput, pValue, pEditable, fCallback)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpViewHash  = `Pict-Input-ObjectEditor-${pInput.Hash}`;

		// Seed the per-input stash with the resolved object (the editor mutates
		// this object in place).
		let tmpStash = this._ensureStash(pInput.Hash);
		tmpStash.Data = this._resolveValue(pInput, pValue);

		let tmpView = this.pict.views[tmpViewHash];
		if (!tmpView)
		{
			let tmpOverrides = (pInput.PictForm && pInput.PictForm.ObjectEditor) || {};
			let tmpEditorOptions =
			{
				ViewIdentifier:    tmpViewHash,
				AutoRender:        false,
				Editable:          pEditable,
				ObjectDataAddress: this.getObjectDataAddress(pInput.Hash),
				// Point this instance's container renderable at our own slot so
				// multiple editors on a page never share a destination.
				Renderables:
				[
					{
						RenderableHash:     'ObjectEditor-Container',
						TemplateHash:       'ObjectEditor-Container-Template',
						// pict-view resolves a renderable's destination from ContentDestinationAddress
						// (see Pict-View.buildRenderOptions). A bare DestinationAddress is ignored, so the
						// container template never painted into the slot and the tree had nowhere to mount.
						ContentDestinationAddress: tmpSlotID,
						RenderMethod:       'replace'
					}
				]
			};
			if (typeof tmpOverrides.InitialExpandDepth === 'number')
			{
				tmpEditorOptions.InitialExpandDepth = tmpOverrides.InitialExpandDepth;
			}

			this.pict.addView(tmpViewHash, tmpEditorOptions, libPictSectionObjectEditor);
			tmpView = this.pict.views[tmpViewHash];
			// The object editor builds its per-type node renderers in onBeforeInitialize; a view added
			// after the boot cycle isn't initialized automatically, so initialize it before first render.
			if (tmpView && typeof tmpView.initialize === 'function') { tmpView.initialize(); }
		}
		else
		{
			// Re-use: update the mutable option before re-rendering into the slot.
			tmpView.options.Editable = pEditable;
		}

		if (!tmpView)
		{
			let tmpErr = new Error('Failed to instantiate ObjectEditor view ' + tmpViewHash);
			if (this.log) this.log.error('[Pict-Input-ObjectEditor] addView returned nothing', { viewHash: tmpViewHash });
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		let tmpInst = this._instances[pInput.Hash] || {};
		tmpInst.mode         = pEditable ? 'edit' : 'view';
		tmpInst.slotID       = tmpSlotID;
		tmpInst.viewInstance = tmpView;
		tmpInst.viewHash     = tmpViewHash;
		tmpInst.input        = pInput;
		this._instances[pInput.Hash] = tmpInst;

		try
		{
			// Render the container into the CURRENT slot explicitly. The host slot's RawHTMLID is
			// regenerated on every form re-render, so a re-used view instance would otherwise paint into
			// its original (now-removed) slot; passing the destination here re-points it every mount.
			let tmpResult = tmpView.render('ObjectEditor-Container', tmpSlotID);
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(
					() => { if (typeof fCallback === 'function') fCallback(null); },
					(pErr) => { if (typeof fCallback === 'function') fCallback(pErr); }
				);
			}
			else if (typeof fCallback === 'function')
			{
				fCallback(null);
			}
		}
		catch (pErr)
		{
			if (this.log) this.log.error('[Pict-Input-ObjectEditor] render threw', { error: pErr.message });
			if (typeof fCallback === 'function') fCallback(pErr);
		}
	}

	// ----------------------------------------------------------------------------
	// Public runtime API
	// ----------------------------------------------------------------------------

	getMode(pInputHash)
	{
		let tmpInst = this._instances[pInputHash];
		return tmpInst ? tmpInst.mode : null;
	}

	setMode(pInputHash, pMode, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			let tmpErr = new Error('Cannot setMode — input is not mounted: ' + pInputHash);
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		if (pMode !== 'edit' && pMode !== 'view')
		{
			let tmpErr = new Error('setMode: unknown mode "' + pMode + '" (use "edit" or "view")');
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		this._mount(tmpInst.input, this._currentObject(pInputHash), (pMode === 'edit'), fCallback);
	}

	toggleMode(pInputHash, fCallback)
	{
		let tmpMode = this.getMode(pInputHash);
		let tmpNext = (tmpMode === 'edit') ? 'view' : 'edit';
		this.setMode(pInputHash, tmpNext, fCallback);
	}

	/**
	 * Flush the current edited object to the input's hidden field.
	 *
	 * @param {string} pInputHash - The input Hash.
	 * @param {Function} [fCallback] - Optional completion callback.
	 */
	commit(pInputHash, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}
		this._writeHiddenInputValue(tmpInst.input.Macro.RawHTMLID, this._currentObject(pInputHash), true);
		if (typeof fCallback === 'function') fCallback(null);
	}

	// ----------------------------------------------------------------------------
	// Lifecycle hooks
	// ----------------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._mount(pInput, pValue, this._resolveEditable(pInput));
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * The ObjectEditor InputType is not supported inside Tabular rows.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object.
	 * @param {string} pHTMLSelector - The HTML selector for the input object.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		let tmpErr = new Error('ObjectEditor InputType is not supported inside Tabular rows.');
		if (this.log) this.log.warn('[Pict-Input-ObjectEditor] tabular not supported', { inputHash: pInput && pInput.Hash });
		throw tmpErr;
	}

	/**
	 * Fires when data is marshaled to the form for this input — re-seed the
	 * stash with the fresh value and re-paint, preserving the current mode.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpInst = this._instances[pInput.Hash];
		let tmpEditable = tmpInst ? (tmpInst.mode === 'edit') : this._resolveEditable(pInput);
		this._mount(pInput, pValue, tmpEditable);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Fires when the form gathers this input's value (the save direction).
	 * Serialize the (in-place-mutated) stash into the hidden field so the form
	 * marshals the latest object. No change dispatch — this is a read.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean}
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		if (this._instances[pInput.Hash])
		{
			this._writeHiddenInputValue(pInput.Macro.RawHTMLID, this._currentObject(pInput.Hash), false);
		}
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}
}

module.exports = PictInputObjectEditor;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../Pict-Provider-InputExtension.js":509,"pict-section-objecteditor":592}],528:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { Math: any } & { DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	roundValue(pInput, pValue)
	{
		// A value that is not a number must render BLANK, never a formatted stand-in.
		// Formatting one produced "NaN" in a tabular cell (from a null return) and
		// "0.00" from undefined -- both of which read as real measurements. A
		// running average is legitimately empty until its window fills, so this is
		// the common case, not an edge case.
		if ((pValue === null) || (typeof (pValue) === 'undefined') || (String(pValue).trim() === ''))
		{
			return '';
		}

		let tmpValue = pValue;

		if ('DecimalPrecision' in pInput.PictForm)
		{
			let tmpRoundingMethod = this.fable.Math.roundHalfUp;
			if ('RoundingMethod' in pInput.PictForm)
			{
				try
				{
					tmpRoundingMethod = parseInt(pInput.PictForm.RoundingMethod);
				}
				catch(pError)
				{
					this.log.error(`Error parsing rounding method onDataMarshalToForm for input ${pInput.Hash}`, pError);
				}
			}
			tmpValue = this.fable.Math.toFixedPrecise(tmpValue, pInput.PictForm.DecimalPrecision, tmpRoundingMethod);
		}

		if (('AddCommas' in pInput.PictForm) && pInput.PictForm.AddCommas)
		{
			tmpValue = this.fable.DataFormat.formatterAddCommasToNumber(tmpValue);
		}

		if ('DigitsPrefix' in pInput.PictForm)
		{
			tmpValue = pInput.PictForm.DigitsPrefix + tmpValue;
		}
		if ('DigitsPostfix' in pInput.PictForm)
		{
			tmpValue = tmpValue + pInput.PictForm.DigitsPostfix;
		}

		return tmpValue;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getInputHTMLID(pInput.Macro.RawHTMLID), this.roundValue(pInput, pValue));
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent('#PRECISE-' + this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex).substring(1), pValue);
		this.pict.ContentAssignment.assignContent(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), this.roundValue(pInput, pValue));
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],529:[function(require,module,exports){
/**
 * Pict-Provider-Input-RichText-CSS.js
 *
 * Scoped CSS for the RichText form-input slot. Registered via
 * `pict.CSSMap.addCSS('Pict-Input-RichText-CSS', libCSS, 500)` from the
 * provider's constructor.
 *
 * All colors flow through theme tokens with hex fallbacks so the input looks
 * correct standalone (no theme provider) and adapts when a theme provider is
 * mounted. Three font-stack tokens (`--theme-font-body`, `--theme-font-mono`)
 * are pulled the same way.
 *
 * Class names:
 *
 *   .pict-section-form-richtext        the outer slot the form template emits
 *   .pict-section-form-richtext-view   the rendered-markdown container (view mode)
 *   .pict-section-form-richtext-edit   the editor container (edit mode)
 *   .pict-section-form-richtext-toggle "Edit" / "Done" affordance the consumer
 *                                      can render inside the slot if they want
 *                                      a built-in mode-switch chip
 */

module.exports = /*css*/`
.pict-section-form-richtext
{
	display: block;
	width: 100%;
	min-height: 64px;
	border: 1px solid var(--theme-color-border-primary, #D4C4A8);
	border-radius: 4px;
	background: var(--theme-color-background-primary, #FFFFFF);
	color: var(--theme-color-text-primary, #2A2520);
	font-family: var(--theme-font-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
	font-size: 0.95rem;
	line-height: 1.55;
	box-sizing: border-box;
}

.pict-section-form-richtext-view
{
	padding: 10px 14px;
	min-height: 48px;
}

.pict-section-form-richtext-view.is-empty
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-style: italic;
}

.pict-section-form-richtext-view :first-child { margin-top: 0; }
.pict-section-form-richtext-view :last-child  { margin-bottom: 0; }

.pict-section-form-richtext-view h1,
.pict-section-form-richtext-view h2,
.pict-section-form-richtext-view h3,
.pict-section-form-richtext-view h4
{
	color: var(--theme-color-text-heading, var(--theme-color-text-primary, #2A2520));
	margin: 0.6em 0 0.3em 0;
	line-height: 1.25;
}

.pict-section-form-richtext-view code
{
	font-family: var(--theme-font-mono, 'SFMono-Regular', Menlo, monospace);
	font-size: 0.9em;
	padding: 1px 5px;
	background: var(--theme-color-background-tertiary, #F4EEE2);
	border-radius: 3px;
}

.pict-section-form-richtext-view pre
{
	font-family: var(--theme-font-mono, 'SFMono-Regular', Menlo, monospace);
	background: var(--theme-color-background-tertiary, #F4EEE2);
	padding: 10px 12px;
	border-radius: 4px;
	overflow: auto;
}

.pict-section-form-richtext-view blockquote
{
	margin: 0.5em 0;
	padding: 4px 12px;
	border-left: 3px solid var(--theme-color-accent, #2E7D74);
	color: var(--theme-color-text-secondary, #5A4A3C);
	background: var(--theme-color-background-secondary, #FBF7EE);
}

.pict-section-form-richtext-view img
{
	max-width: 100%;
	height: auto;
	border-radius: 3px;
}

.pict-section-form-richtext-edit
{
	padding: 0;
	min-height: 220px;
}

/*
 * The editor (pict-section-markdowneditor) brings its own chrome inside the
 * slot. We just provide a container border + sane min-height; CodeMirror takes
 * over from there.
 */

/* Optional mode-toggle affordance — render inside the slot from the host UI
 * via _Pict.providers['Pict-Input-RichText'].toggleMode('<hash>'). The chip is
 * absolutely positioned in the top-right corner so it doesn't take a column
 * from the form layout. */
.pict-section-form-richtext { position: relative; }

.pict-section-form-richtext-toggle
{
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 2;
	padding: 3px 9px;
	font-size: 0.72rem;
	font-weight: 600;
	color: var(--theme-color-text-secondary, #5A4A3C);
	background: var(--theme-color-background-tertiary, #F4EEE2);
	border: 1px solid var(--theme-color-border-secondary, #D4C4A8);
	border-radius: 3px;
	cursor: pointer;
	user-select: none;
}

.pict-section-form-richtext-toggle:hover
{
	color: var(--theme-color-text-primary, #2A2520);
	background: var(--theme-color-background-primary, #FFFFFF);
	border-color: var(--theme-color-accent, #2E7D74);
}

.pict-section-form-richtext.mode-edit  .pict-section-form-richtext-toggle::after { content: 'Done'; }
.pict-section-form-richtext.mode-view  .pict-section-form-richtext-toggle::after { content: 'Edit'; }
`;

},{}],530:[function(require,module,exports){
/**
 * Pict-Provider-Input-RichText.js
 *
 * A pict-section-form input provider that pairs the markdown editor
 * (edit mode) with rendered markdown (view mode). Boots in VIEW mode —
 * the heavy CodeMirror bundle isn't pulled until the host UI calls
 * `provider.setMode(pInputHash, 'edit')`.
 *
 * Descriptor shape:
 *
 *   {
 *     "Name": "Body",
 *     "Hash": "PostBody",
 *     "DataType": "String",
 *     "PictForm": {
 *       "InputType": "RichText",
 *       "RichText": {
 *         "AllowImages": true,
 *         "ImageUploader": "uploadImage",     // method on pict.PictApplication
 *         "Height": "400px",                  // applied to the slot in edit mode
 *         "EditorOptions": { ... },           // pass-through to markdowneditor
 *         "ViewerOptions": { ... }            // reserved for future use
 *       }
 *     }
 *   }
 *
 * Runtime API:
 *
 *   provider.setMode(inputHash, 'edit' | 'view', fCallback)
 *   provider.getMode(inputHash)            // 'edit' | 'view' | null (not mounted)
 *   provider.toggleMode(inputHash)         // convenience for buttons
 *   provider.commit(inputHash, fCallback)  // force-save edit-mode editor → form
 */

const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libMarked                    = require('marked');
const libMarkdownEditor            = require('pict-section-markdowneditor');

// Form templates live in pict-section-form's default-template set, so no
// runtime template injection is needed here. CSS still needs registering
// — the scoped slot styling lives next to the provider.
const libCSS = require('./Pict-Provider-Input-RichText-CSS.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Input-RichText',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	AutoSolveWithApp: false
};

class PictInputRichText extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */ this.pict;
		/** @type {any}            */ this.log;

		// inputHash → { mode: 'view'|'edit', slotID, lastValue, viewInstance?: Pict-Section-MarkdownEditor, input }
		this._instances = {};

		// Register the scoped CSS for the slot.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Input-RichText-CSS', libCSS, 500);
		}
	}

	// ----------------------------------------------------------------------------
	// Helpers
	// ----------------------------------------------------------------------------

	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Resolve a string value from various places the form may stash content.
	 */
	_resolveContent(pInput, pValue)
	{
		if (typeof pValue === 'string' && pValue.length > 0) return pValue;
		if (pInput && pInput.Content && typeof pInput.Content === 'string') return pInput.Content;
		if (pInput && pInput.Default && typeof pInput.Default === 'string') return pInput.Default;
		return '';
	}

	/**
	 * Render markdown to HTML. Falls back to escaping if marked throws.
	 */
	_renderMarkdown(pMarkdown)
	{
		try
		{
			return libMarked.parse(pMarkdown || '');
		}
		catch (pErr)
		{
			if (this.log) this.log.warn('[Pict-Input-RichText] marked.parse failed', { error: pErr.message });
			let tmpEscaped = String(pMarkdown || '').replace(/[&<>"]/g, (c) =>
				({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
			return `<pre>${tmpEscaped}</pre>`;
		}
	}

	_writeHiddenInputValue(pInputHTMLID, pValue)
	{
		// The hidden <input> the form template emits — referenced as just the
		// raw HTML ID (no #DISPLAY-FOR- prefix). Inform Informary of the change
		// via a dispatched event so the form's AppData updates downstream.
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pInputHTMLID) : null;
		if (!tmpEl) return false;
		tmpEl.value = (pValue == null) ? '' : String(pValue);
		try
		{
			tmpEl.dispatchEvent(new Event('change', { bubbles: true }));
		}
		catch (pErr)
		{
			// jsdom-in-test sometimes lacks Event constructor; harmless in browser.
		}
		return true;
	}

	_assignSlotContent(pSlotID, pHTML)
	{
		if (this.pict && this.pict.ContentAssignment &&
			typeof this.pict.ContentAssignment.assignContent === 'function')
		{
			this.pict.ContentAssignment.assignContent(pSlotID, pHTML);
			return true;
		}
		return false;
	}

	// ----------------------------------------------------------------------------
	// View mode
	// ----------------------------------------------------------------------------

	_mountView(pView, pInput, pValue)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpContent   = this._resolveContent(pInput, pValue);

		let tmpInnerHTML;
		if (tmpContent && tmpContent.length > 0)
		{
			tmpInnerHTML =
				`<div class="pict-section-form-richtext-view">${this._renderMarkdown(tmpContent)}</div>`;
		}
		else
		{
			tmpInnerHTML =
				`<div class="pict-section-form-richtext-view is-empty">(empty)</div>`;
		}

		this._assignSlotContent(tmpSlotID, tmpInnerHTML);

		// Mode flag on the outer slot so the optional toggle chip can pick the
		// right "Edit" / "Done" label via the ::after pseudo selector.
		if (typeof document !== 'undefined')
		{
			let tmpOuter = document.getElementById(tmpRawHTMLID + '-CONTAINER') ||
				document.querySelector(tmpSlotID);
			if (tmpOuter && tmpOuter.classList)
			{
				tmpOuter.classList.remove('mode-edit');
				tmpOuter.classList.add('mode-view');
			}
		}

		let tmpInst = this._instances[pInput.Hash] || {};
		tmpInst.mode      = 'view';
		tmpInst.slotID    = tmpSlotID;
		tmpInst.lastValue = tmpContent;
		tmpInst.input     = pInput;
		// If we previously held an editor, it's already been torn down by caller.
		tmpInst.viewInstance = null;
		this._instances[pInput.Hash] = tmpInst;
	}

	// ----------------------------------------------------------------------------
	// Edit mode
	// ----------------------------------------------------------------------------

	_buildEditorOptions(pInput, pValue, pInst)
	{
		let tmpRichTextOpts = (pInput.PictForm && pInput.PictForm.RichText) || {};
		let tmpEditorOpts   = tmpRichTextOpts.EditorOptions || {};
		let tmpRawHTMLID    = pInput.Macro.RawHTMLID;

		// Per-input AppData address for segments. Picked to be unlikely to collide
		// with anything a host app puts in AppData.
		let tmpSegmentsAddr = `AppData._PictInputRichText.${pInput.Hash}.Segments`;

		// Ensure the segments array exists at that address. Single segment per
		// editor — multi-segment is a power-feature the markdown editor itself
		// supports, but inside a single form field one segment is the right
		// surface.
		if (!this.pict.AppData._PictInputRichText)
		{
			this.pict.AppData._PictInputRichText = {};
		}
		this.pict.AppData._PictInputRichText[pInput.Hash] =
		{
			Segments: [{ Content: (pValue || '') }]
		};

		let tmpOptions = Object.assign({}, tmpEditorOpts,
		{
			ViewIdentifier:      `Pict-Input-RichText-Editor-${pInput.Hash}`,
			TargetElementAddress: this.getContentDisplayHTMLID(tmpRawHTMLID),
			ContentDataAddress:   tmpSegmentsAddr,
			ReadOnly:             false
		});

		return tmpOptions;
	}

	_mountEdit(pView, pInput, pValue, fCallback)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpContent   = this._resolveContent(pInput, pValue);
		let tmpInst      = this._instances[pInput.Hash] || {};
		tmpInst.input    = pInput;

		// Clear view-mode content so the editor mounts into a clean slot.
		this._assignSlotContent(tmpSlotID, '');

		let tmpEditorOpts  = this._buildEditorOptions(pInput, tmpContent, tmpInst);
		let tmpViewHash    = tmpEditorOpts.ViewIdentifier;
		let tmpRichTextOpts = (pInput.PictForm && pInput.PictForm.RichText) || {};

		// Build a subclass that captures content changes back to the form's
		// hidden input. Subclassing is how pict-section-markdowneditor itself
		// is meant to be extended (its constructor accepts options + the parent
		// view class is libPictViewClass).
		let tmpProvider = this;

		class RichTextFormEditor extends libMarkdownEditor
		{
			constructor(pSubFable, pSubOptions, pSubServiceHash)
			{
				super(pSubFable, pSubOptions, pSubServiceHash);
			}

			onContentChange(pSegmentIndex, pContent)
			{
				try
				{
					// Single-segment editor — every change replaces the value.
					tmpProvider._writeHiddenInputValue(tmpRawHTMLID, pContent);
					let tmpLatest = tmpProvider._instances[pInput.Hash];
					if (tmpLatest) tmpLatest.lastValue = pContent;
				}
				catch (pErr)
				{
					if (tmpProvider.log)
					{
						tmpProvider.log.warn('[Pict-Input-RichText] onContentChange handler failed',
							{ error: pErr.message, inputHash: pInput.Hash });
					}
				}
				if (super.onContentChange) super.onContentChange(pSegmentIndex, pContent);
			}

			onImageUpload(pFile, pSegmentIndex, fImgCallback)
			{
				if (!tmpRichTextOpts.AllowImages)
				{
					if (tmpProvider.log)
					{
						tmpProvider.log.info('[Pict-Input-RichText] image upload rejected (AllowImages=false)',
							{ inputHash: pInput.Hash, fileName: pFile && pFile.name });
					}
					// Returning false lets the base markdown editor fall through to
					// its default base64 inline; we *don't* want that when text-only,
					// so we eat the file by calling back with an error.
					fImgCallback('Image uploads are disabled for this field.');
					return true;
				}

				let tmpUploaderName = tmpRichTextOpts.ImageUploader;
				if (tmpUploaderName &&
					tmpProvider.pict && tmpProvider.pict.PictApplication &&
					typeof tmpProvider.pict.PictApplication[tmpUploaderName] === 'function')
				{
					try
					{
						return tmpProvider.pict.PictApplication[tmpUploaderName](pFile, pInput, fImgCallback);
					}
					catch (pErr)
					{
						if (tmpProvider.log)
						{
							tmpProvider.log.warn('[Pict-Input-RichText] ImageUploader threw',
								{ error: pErr.message, inputHash: pInput.Hash });
						}
						fImgCallback(pErr.message);
						return true;
					}
				}

				// No uploader configured + AllowImages=true → default base64 inline.
				return false;
			}

			/**
			 * Push CodeMirror extensions before the editor mounts. We enable
			 * line wrapping by default so long markdown paragraphs flow to
			 * the next visual line instead of horizontally scrolling — the
			 * almost-always-correct default for prose. Opt out via
			 * `PictForm.RichText.WordWrap: false` in the descriptor.
			 */
			customConfigureExtensions(pExtensions, pSegmentIndex)
			{
				let tmpWantWrap = (tmpRichTextOpts.WordWrap !== false);
				if (tmpWantWrap)
				{
					let tmpCM = this._codeMirrorModules;
					if (tmpCM && tmpCM.EditorView && tmpCM.EditorView.lineWrapping)
					{
						pExtensions.push(tmpCM.EditorView.lineWrapping);
					}
				}
				return pExtensions;
			}
		}

		this.pict.addView(tmpViewHash, tmpEditorOpts, RichTextFormEditor);
		let tmpEditorView = this.pict.views[tmpViewHash];

		if (!tmpEditorView)
		{
			let tmpErr = new Error('Failed to instantiate RichText editor view ' + tmpViewHash);
			if (this.log) this.log.error('[Pict-Input-RichText] addView returned nothing', { viewHash: tmpViewHash });
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		// Surface mode on the outer slot for the optional toggle-chip pseudo.
		if (typeof document !== 'undefined')
		{
			let tmpOuter = document.querySelector(tmpSlotID);
			if (tmpOuter && tmpOuter.classList)
			{
				tmpOuter.classList.remove('mode-view');
				tmpOuter.classList.add('mode-edit', 'pict-section-form-richtext-edit');
			}
		}

		tmpInst.mode         = 'edit';
		tmpInst.slotID       = tmpSlotID;
		tmpInst.lastValue    = tmpContent;
		tmpInst.viewInstance = tmpEditorView;
		tmpInst.viewHash     = tmpViewHash;
		this._instances[pInput.Hash] = tmpInst;

		// Render the editor. The view's render() resolves TargetElementAddress
		// against ContentAssignment and paints into the slot.
		try
		{
			let tmpResult = tmpEditorView.render();
			// Some renders are async (Promise-returning) and some are sync.
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(
					() => { if (typeof fCallback === 'function') fCallback(null); },
					(pRenderErr) => { if (typeof fCallback === 'function') fCallback(pRenderErr); }
				);
			}
			else
			{
				if (typeof fCallback === 'function') fCallback(null);
			}
		}
		catch (pErr)
		{
			if (this.log) this.log.error('[Pict-Input-RichText] editor.render threw', { error: pErr.message });
			if (typeof fCallback === 'function') fCallback(pErr);
		}
	}

	_destroyEdit(pInput)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst || !tmpInst.viewInstance) return;

		let tmpView = tmpInst.viewInstance;

		try
		{
			if (typeof tmpView.destroy === 'function')
			{
				tmpView.destroy();
			}
		}
		catch (pErr)
		{
			if (this.log) this.log.warn('[Pict-Input-RichText] editor.destroy threw', { error: pErr.message });
		}

		// Drop the per-input AppData branch (we re-seed on next edit-mode mount).
		if (this.pict.AppData._PictInputRichText &&
			this.pict.AppData._PictInputRichText[pInput.Hash])
		{
			delete this.pict.AppData._PictInputRichText[pInput.Hash];
		}

		// Remove the view registration so subsequent mounts re-register cleanly.
		if (tmpInst.viewHash && this.pict.views && this.pict.views[tmpInst.viewHash])
		{
			try { delete this.pict.views[tmpInst.viewHash]; }
			catch (pErr) { /* not all environments allow delete on this collection */ }
		}

		tmpInst.viewInstance = null;
		tmpInst.viewHash     = null;
	}

	// ----------------------------------------------------------------------------
	// Public runtime API
	// ----------------------------------------------------------------------------

	getMode(pInputHash)
	{
		let tmpInst = this._instances[pInputHash];
		return tmpInst ? tmpInst.mode : null;
	}

	setMode(pInputHash, pMode, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			let tmpErr = new Error('Cannot setMode — input is not mounted: ' + pInputHash);
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		if (pMode !== 'edit' && pMode !== 'view')
		{
			let tmpErr = new Error('setMode: unknown mode "' + pMode + '" (use "edit" or "view")');
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		if (tmpInst.mode === pMode)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}

		if (pMode === 'edit')
		{
			this._mountEdit(null, tmpInst.input, tmpInst.lastValue, fCallback);
			return;
		}

		// pMode === 'view': pull the latest, tear down editor, re-render view.
		this._destroyEdit(tmpInst.input);
		this._mountView(null, tmpInst.input, tmpInst.lastValue);
		if (typeof fCallback === 'function') fCallback(null);
	}

	toggleMode(pInputHash, fCallback)
	{
		let tmpMode = this.getMode(pInputHash);
		let tmpNext = (tmpMode === 'edit') ? 'view' : 'edit';
		this.setMode(pInputHash, tmpNext, fCallback);
	}

	commit(pInputHash, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst || tmpInst.mode !== 'edit' || !tmpInst.viewInstance)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}
		// The editor writes through onContentChange on every keystroke, so the
		// hidden input is already up to date. We just confirm.
		if (typeof fCallback === 'function') fCallback(null);
	}

	// ----------------------------------------------------------------------------
	// Lifecycle hooks (called by pict-section-form during form rendering)
	// ----------------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._mountView(pView, pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpErr = new Error('RichText InputType is not supported inside Tabular rows in Phase 1.');
		if (this.log) this.log.warn('[Pict-Input-RichText] tabular not supported', { inputHash: pInput && pInput.Hash });
		throw tmpErr;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst)
		{
			// First time seeing this input — boot in view mode.
			this._mountView(pView, pInput, pValue);
		}
		else if (tmpInst.mode === 'view')
		{
			this._mountView(pView, pInput, pValue);
		}
		else
		{
			// Edit mode: push the new value into the editor's segment store.
			tmpInst.lastValue = (typeof pValue === 'string') ? pValue : tmpInst.lastValue;
			if (this.pict.AppData._PictInputRichText &&
				this.pict.AppData._PictInputRichText[pInput.Hash])
			{
				this.pict.AppData._PictInputRichText[pInput.Hash].Segments =
					[{ Content: tmpInst.lastValue }];
				// Re-render the editor so it picks up the new segments.
				if (tmpInst.viewInstance && typeof tmpInst.viewInstance.render === 'function')
				{
					try { tmpInst.viewInstance.render(); }
					catch (pErr)
					{
						if (this.log) this.log.warn('[Pict-Input-RichText] re-render after marshal threw',
							{ error: pErr.message });
					}
				}
			}
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// Tabular is unsupported — silent no-op (the initialize step already threw).
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = PictInputRichText;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../Pict-Provider-InputExtension.js":509,"./Pict-Provider-Input-RichText-CSS.js":529,"marked":495,"pict-section-markdowneditor":580}],531:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the select input element.
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular select input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular select input ID.
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select dropdown ID based on the input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {string} - The generated tabular select dropdown ID.
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Records the option ids on the element and reports whether they differ from what it last rendered,
	 * so a refresh on every marshal does not rebuild (and blur) a dropdown whose options are unchanged.
	 *
	 * @param {HTMLElement} pSelectElement
	 * @param {Array<{ id: string, text: string }>} pListData
	 * @return {boolean}
	 */
	optionsChanged(pSelectElement, pListData)
	{
		if (!pSelectElement || !pSelectElement.setAttribute)
		{
			return true;
		}
		const tmpSignature = Array.isArray(pListData) ? pListData.map((pEntry) => `${pEntry.id}\u0001${pEntry.text}`).join('\u0002') : '';
		if (pSelectElement.getAttribute('data-pict-options') === tmpSignature)
		{
			return false;
		}
		pSelectElement.setAttribute('data-pict-options', tmpSignature);
		return true;
	}

	/**
	 * Refreshes the select list for a dynamic input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 */
	refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		let tmpListData = pInput.PictForm?.SelectOptions;

		if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElement || tmpInputSelectElement.length < 1)
		{
			return false;
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData);

		tmpInputSelectElement = tmpInputSelectElement[0];
		if (!this.optionsChanged(tmpInputSelectElement, tmpListData))
		{
			return;
		}
		// HAX
		tmpInputSelectElement.innerHTML = '';

		if (tmpInputSelectElement && tmpListData && Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpOption = document.createElement('option');
				tmpOption.value = tmpListData[i].id;
				tmpOption.text = tmpListData[i].text;
				tmpInputSelectElement.appendChild(tmpOption);
			}
		}
	}

	/**
	 * Refreshes the select list for a tabular input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex 
	 */
	refreshSelectListTabular(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		let tmpListData = pInput.PictForm?.SelectOptions;

		if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData, pRowIndex);

		// TODO: Determine later if this should ever be an array.
		if (!Array.isArray(tmpInputSelectElement) || tmpInputSelectElement.length < 1)
		{
			return;
		}

		tmpInputSelectElement = tmpInputSelectElement[0];

		if (!this.optionsChanged(tmpInputSelectElement, tmpListData))
		{
			return;
		}

		// HAX
		tmpInputSelectElement.innerHTML = '';

		if (tmpInputSelectElement && tmpListData && Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpOption = document.createElement('option');
				tmpOption.value = tmpListData[i].id;
				tmpOption.text = tmpListData[i].text;
				tmpInputSelectElement.appendChild(tmpOption);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.refreshSelectListTabular(pView, pGroup, pView.getRow(pInput.PictForm.GroupIndex, pRowIndex), pInput, pValue, pHTMLSelector, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.ListDistilling.getFacetRule(pInput))
		{
			this.refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		}
		/** @type {Array<HTMLElement>|HTMLElement} */
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		const tmpInputSelectElement = tmpInputSelectElements[0];
		if (!(tmpInputSelectElement instanceof HTMLSelectElement))
		{
			return false;
		}

		let tmpValueSelected = false;

		for (let i = 0; i < tmpInputSelectElement.options.length; i++)
		{
			if (tmpInputSelectElement.options[i].value === pValue)
			{
				tmpInputSelectElement.selectedIndex = i;
				tmpValueSelected = true;
				break;
			}
		}

		if (!tmpValueSelected)
		{
			tmpInputSelectElement.selectedIndex = -1;
			//this.log.error(`The value [${pValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
		}

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.pict.providers.ListDistilling.getFacetRule(pInput))
		{
			this.refreshSelectListTabular(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex);
		}
		/** @type {Array<HTMLElement>|HTMLElement} */
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		const tmpInputSelectElement = tmpInputSelectElements[0];
		if (!(tmpInputSelectElement instanceof HTMLSelectElement))
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}

		let tmpValueSelected = false;

		for (let i = 0; i < tmpInputSelectElement.options.length; i++)
		{
			if (tmpInputSelectElement.options[i].value === pValue)
			{
				tmpInputSelectElement.selectedIndex = i;
				tmpValueSelected = true;
				break;
			}
		}

		if (!tmpValueSelected)
		{
			tmpInputSelectElement.selectedIndex = -1;
			//this.log.error(`The value [${pValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
		}

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @returns {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		let tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		let tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],532:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideClass = 'pict-tab-group-hidden';
		this.cssSelectedTabClass = 'pict-tab-group-selectedtab';
		this.cssSnippet = '.pict-tab-group-hidden { display: none; } .pict-tab-group-selectedtab { font-weight: bold; }';

		this.setCSSSnippets();
	}

	/**
	 * @param {string} [pCSSHideClass]
	 * @param {string} [pCSSSnippet]
	 */
	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;

		this.pict.CSSMap.addCSS('Pict-Section-Form-Input-Group-TabSelector', this.cssSnippet, 1001, 'Pict-Input-TabSelector');
		this.pict.CSSMap.injectCSS();
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pGroupHash - The group hash.
	 *
	 * @return {string}
	 */
	getTabSelector(pView, pInput, pGroupHash)
	{
		return `#TAB-${pGroupHash}-${pInput.Macro.RawHTMLID}`;
	}


	/**
	 * @param {Object} pView - The view object.
	 * @param {string} pGroupHash - The group hash.
	 *
	 * @return {string}
	 */
	getGroupSelector(pView, pGroupHash)
	{
		return `#GROUP-${pView.formID}-${pGroupHash}`;
	}

	/**
	 * Is this tab group hash actually one of the input's tabs?
	 *
	 * @param {Object} pInput - The input object.
	 * @param {string} pTabGroupHash - The tab group hash to test.
	 *
	 * @return {boolean}
	 */
	isTabInSet(pInput, pTabGroupHash)
	{
		let tmpTabSet = pInput?.PictForm?.TabGroupSet;
		return !!pTabGroupHash && Array.isArray(tmpTabSet) && (tmpTabSet.indexOf(pTabGroupHash) > -1);
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabHash
	 *
	 * @return {boolean} - true once the tab is shown; false (nothing changed) if the view, input or tab hash is not valid.
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabHash)
	{
		// First get the view
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the view did not exist!`)
			return false;
		}
		// Then the input
		let tmpInput = tmpView.getInputFromHash(pInputHash)
		if (!tmpInput)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the input did not exist!`)
			return false;
		}
		// Now enumerate the tabs and hide the others, then show this one.
		// TODO: This could be made more elegant by testing which ones are shown and swapping them faster.
		if (!(tmpInput?.PictForm?.TabGroupSet) || !Array.isArray(tmpInput.PictForm.TabGroupSet))
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the input did not have a valid TabGroupSet array in the PictForm object!`)
			return false;
		}

		// A hash that is not in the set matches nothing below, so it would hide EVERY group and leave no
		// tab selected. Refuse it without touching anything; false already means "did not switch".
		if (!this.isTabInSet(tmpInput, pTabHash))
		{
			this.pict.log.warn(`TabSelector input provider was asked for tab [${pTabHash}] on view [${pViewHash}] input [${pInputHash}] but it is not in the TabGroupSet; leaving the current tab selected.`);
			return false;
		}

		for (let i = 0; i < tmpInput.PictForm.TabGroupSet.length; i++)
		{
			let tmpTabGroupHash = tmpInput.PictForm.TabGroupSet[i];
			if (tmpTabGroupHash != pTabHash)
			{
				// Hide this tab group if it isn't the "expected to be visible" group
				this.pict.ContentAssignment.addClass(this.getGroupSelector(tmpView, tmpTabGroupHash), this.cssHideClass);
				this.pict.ContentAssignment.removeClass(this.getTabSelector(tmpView, tmpInput, tmpTabGroupHash), this.cssSelectedTabClass);
			}
			else
			{
				// Show this tab group if it is the "expected to be visible" group
				this.pict.ContentAssignment.removeClass(this.getGroupSelector(tmpView, tmpTabGroupHash), this.cssHideClass);
				this.pict.ContentAssignment.addClass(this.getTabSelector(tmpView, tmpInput, tmpTabGroupHash), this.cssSelectedTabClass);
			}
		}
		tmpView.setDataByInput(tmpInput, pTabHash);
		return true;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the select input element.
	 */
	getTabSelectorInputHTMLID(pInputHTMLID)
	{
		return `#TAB-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		let tmpTabSet = pInput.PictForm?.TabGroupSet;

		if (!tmpTabSet || !Array.isArray(tmpTabSet) || tmpTabSet.length < 1)
		{
			this.pict.log.error(`TabSelector input provider tried to initialize Tab Group Set for HTML ID [${pInput.Macro.RawHTMLID}] but there were no valid entries in the tmpInput.PictForm.TabGroupSet array!`)
			return false;
		}

		let tmpEntryMetatemplateHash = this.pict.providers.DynamicInput.getInputTemplateHash(pView, { PictForm: { InputType: 'TabGroupSelector-TabElement', DataType: 'String' } });

		let tmpTabGroupSetEntries = '';
		// If there are tab group names, use them, otherwise use the hash
		let tempTabSetNames = pInput.PictForm?.TabGroupNames || [];

		for (let i = 0; i < tmpTabSet.length; i++)
		{
			tmpTabGroupSetEntries += this.pict.parseTemplateByHash(tmpEntryMetatemplateHash, pInput, null, [pView, {TabGroupHash: tmpTabSet[i], TabGroupName: (tempTabSetNames[i] || tmpTabSet[i])}]);
		}

		// TODO: Fix typescript types so this function has an optional rather than required fourth parameter.
		this.pict.ContentAssignment.projectContent('replace', this.getTabSelectorInputHTMLID(pInput.Macro.RawHTMLID), tmpTabGroupSetEntries, 'FixTheTypescriptTypes');

		// Now set the default tab (or first one). Take the first candidate that is actually one of this
		// input's tabs, since selectTabByViewHash refuses anything else: a stored value can name a group
		// since renamed or dropped from the manifest, and DefaultTabGroupHash can simply be a typo.
		const tmpTabCandidates = [];
		if (pInput.PictForm?.DefaultFromData !== false)
		{
			tmpTabCandidates.push(pValue);
		}
		tmpTabCandidates.push(pInput.PictForm?.DefaultTabGroupHash);

		let tmpDefaultTabGroupHash = tmpTabSet[0];
		for (let i = 0; i < tmpTabCandidates.length; i++)
		{
			if (this.isTabInSet(pInput, tmpTabCandidates[i]))
			{
				tmpDefaultTabGroupHash = tmpTabCandidates[i];
				break;
			}
		}

		this.selectTabByViewHash(pView.Hash, pInput.Hash, tmpDefaultTabGroupHash);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],533:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideClass = 'pict-tab-section-hidden';
		this.cssSelectedTabClass = 'pict-tab-section-selectedtab';
		this.cssSnippet = '.pict-tab-section-hidden { display: none; } .pict-tab-section-selectedtab { font-weight: bold; }';

		this.setCSSSnippets();
	}

	/**
	 * @param {string} [pCSSHideClass]
	 * @param {string} [pCSSSnippet]
	 */
	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;
		this.pict.CSSMap.addCSS('Pict-Section-Form-Input-Section-TabSelector', this.cssSnippet, 1001, 'Pict-Input-TabSelector');
	}

	/**
	 * @param {string} pManifestSectionHash
	 *
	 * @return {string}
	 */
	getViewHash(pManifestSectionHash)
	{
		return `PictSectionForm-${pManifestSectionHash}`;
	}

	/**
	 * @param {string} pTabSectionHash
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	getTabSelector(pTabSectionHash, pInput)
	{
		return `#TAB-${pTabSectionHash}-${pInput.Macro.RawHTMLID}`;
	}

	/**
	 * @param {string} pTabViewSectionHash
	 *
	 * @return {string}
	 */
	getSectionSelector(pTabViewSectionHash)
	{
		const metaController = this.pict.views.PictFormMetacontroller;
		return `#Pict-${metaController ? metaController.UUID : this.UUID}-${pTabViewSectionHash}-Wrap`;
	}

	/**
	 * Is this tab section hash actually one of the input's tabs?
	 *
	 * @param {Object} pInput - The input object.
	 * @param {string} pTabSectionHash - The tab section hash to test.
	 *
	 * @return {boolean}
	 */
	isTabInSet(pInput, pTabSectionHash)
	{
		let tmpTabSet = pInput?.PictForm?.TabSectionSet;
		return !!pTabSectionHash && Array.isArray(tmpTabSet) && (tmpTabSet.indexOf(pTabSectionHash) > -1);
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabViewHash
	 *
	 * @return {boolean} - true once the section is shown; false (nothing changed) if the view, input or tab hash is not valid.
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabViewHash)
	{
		// First get the view
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the view did not exist!`)
			return false;
		}
		// Then the input
		let tmpInput = tmpView.getInputFromHash(pInputHash)
		if (!tmpInput)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the input did not exist!`)
			return false;
		}
		// Now enumerate the tabs and hide the others, then show this one.
		// TODO: This could be made more elegant by testing which ones are shown and swapping them faster.
		if (!(tmpInput?.PictForm?.TabSectionSet) || !Array.isArray(tmpInput.PictForm.TabSectionSet))
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the input did not have a valid TabSectionSet array in the PictForm object!`)
			return false;
		}
		// A hash that is not in the set matches nothing below, so it would hide EVERY section and leave no
		// tab selected. Refuse it without touching anything; false already means "did not switch".
		if (!this.isTabInSet(tmpInput, pTabViewHash))
		{
			this.pict.log.warn(`TabSelector input provider was asked for tab [${pTabViewHash}] on view [${pViewHash}] input [${pInputHash}] but it is not in the TabSectionSet; leaving the current tab selected.`);
			return false;
		}
		let tmpTabView = this.pict.views[this.getViewHash(pTabViewHash)];
		if (!tmpTabView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the tab view did not exist!`)
			return false;
		}

		for (let i = 0; i < tmpInput.PictForm.TabSectionSet.length; i++)
		{
			let tmpTabSectionHash = tmpInput.PictForm.TabSectionSet[i];
			if (tmpTabSectionHash != pTabViewHash)
			{
				// Hide this tab group if it isn't the "expected to be visible" group
				this.pict.ContentAssignment.addClass(this.getSectionSelector(tmpTabSectionHash), this.cssHideClass);
				this.pict.ContentAssignment.removeClass(this.getTabSelector(tmpTabSectionHash, tmpInput), this.cssSelectedTabClass);
			}
			else
			{
				// Show this tab group if it is the "expected to be visible" group
				this.pict.ContentAssignment.removeClass(this.getSectionSelector(tmpTabSectionHash), this.cssHideClass);
				this.pict.ContentAssignment.addClass(this.getTabSelector(tmpTabSectionHash, tmpInput), this.cssSelectedTabClass);
			}
		}
		tmpView.setDataByInput(tmpInput, pTabViewHash);
		return true;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 *
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getTabSelectorInputHTMLID(pInputHTMLID)
	{
		return `#TAB-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		let tmpTabSet = pInput.PictForm?.TabSectionSet;

		if (!tmpTabSet || !Array.isArray(tmpTabSet) || tmpTabSet.length < 1)
		{
			this.pict.log.error(`TabSelector input provider tried to initialize Tab Group Set for HTML ID [${pInput.Macro.RawHTMLID}] but there were no valid entries in the tmpInput.PictForm.TabSectionSet array!`)
			return false;
		}

		let tmpEntryMetatemplateHash = this.pict.providers.DynamicInput.getInputTemplateHash(pView, { PictForm: { InputType: 'TabSectionSelector-TabElement', DataType: 'String' } });

		let tmpTabSectionSetEntries = '';
		// If there are tab group names, use them, otherwise use the hash
		let tempTabSetNames = pInput.PictForm?.TabSectionNames || [];

		for (let i = 0; i < tmpTabSet.length; i++)
		{
			tmpTabSectionSetEntries += this.pict.parseTemplateByHash(tmpEntryMetatemplateHash, pInput, null, [pView, {TabSectionHash: tmpTabSet[i], TabSectionName: (tempTabSetNames[i] || tmpTabSet[i])}]);
		}

		// TODO: Fix typescript types so this function has an optional rather than required fourth parameter.
		this.pict.ContentAssignment.projectContent('replace', this.getTabSelectorInputHTMLID(pInput.Macro.RawHTMLID), tmpTabSectionSetEntries, 'FixTheTypescriptTypes');

		// Now set the default tab (or first one). Take the first candidate that is actually one of this
		// input's tabs, since selectTabByViewHash refuses anything else: a stored value can name a section
		// since renamed or dropped from the manifest, and DefaultTabSectionHash can simply be a typo.
		const tmpTabCandidates = [];
		if (pInput.PictForm?.DefaultFromData !== false)
		{
			tmpTabCandidates.push(pValue);
		}
		tmpTabCandidates.push(pInput.PictForm?.DefaultTabSectionHash);

		let tmpDefaultTabSectionHash = tmpTabSet[0];
		for (let i = 0; i < tmpTabCandidates.length; i++)
		{
			if (this.isTabInSet(pInput, tmpTabCandidates[i]))
			{
				tmpDefaultTabSectionHash = tmpTabCandidates[i];
				break;
			}
		}

		this.selectTabByViewHash(pView.Hash, pInput.Hash, tmpDefaultTabSectionHash);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509}],534:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * TabularTriggerGroup input provider.
 *
 * This provider enables per-row trigger group behavior in tabular layouts.
 * Unlike the global AutofillTriggerGroup (which fills ALL rows with the same
 * data), this provider fetches entity data scoped to a specific row and only
 * updates inputs within that same row.
 *
 * It combines the entity-fetching capability of EntityBundleRequest with
 * the autofill behavior of AutofillTriggerGroup, but scoped to individual
 * tabular rows.
 *
 * Triggering input configuration:
 *
 *   Providers: ["Pict-Input-TabularTriggerGroup"],
 *   TabularTriggerGroup:
 *     {
 *       TriggerGroupHash: "AuthorRowTrigger",
 *       TriggerAllInputs: true,
 *       EntitiesBundle: [
 *         {
 *           "Entity": "Author",
 *           "Filter": "FBV~IDAuthor~EQ~{~D:Record.Value~}",
 *           "Destination": "CurrentAuthor",
 *           "SingleRecord": true
 *         }
 *       ]
 *     }
 *
 * Receiving input configuration:
 *
 *   Providers: ["Pict-Input-TabularTriggerGroup"],
 *   TabularTriggerGroup:
 *     {
 *       TriggerGroupHash: "AuthorRowTrigger",
 *       TriggerAddress: "CurrentAuthor.Name",
 *       MarshalEmptyValues: true
 *     }
 *
 * The provider stores fetched entity data in a per-row cache at:
 *   AppData._TabularTriggerCache.{TriggerGroupHash}[{RowIndex}]
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class TabularTriggerGroupInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Get the trigger group configuration, normalizing to an array.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @returns {Array<Record<string, any>>}
	 */
	getTriggerGroupConfigurationArray(pInput)
	{
		let tmpConfigs = pInput.PictForm.TabularTriggerGroup;
		if (!tmpConfigs)
		{
			return [];
		}
		if (!Array.isArray(tmpConfigs))
		{
			tmpConfigs = [tmpConfigs];
		}
		return tmpConfigs;
	}

	/**
	 * Ensure the per-row cache structure exists.
	 *
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 * @param {number} pRowIndex - The row index.
	 * @returns {Object} The cache object for this row.
	 */
	ensureRowCache(pTriggerGroupHash, pRowIndex)
	{
		if (!this.pict.AppData._TabularTriggerCache)
		{
			this.pict.AppData._TabularTriggerCache = {};
		}
		if (!this.pict.AppData._TabularTriggerCache[pTriggerGroupHash])
		{
			this.pict.AppData._TabularTriggerCache[pTriggerGroupHash] = {};
		}
		if (!this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex])
		{
			this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex] = {};
		}
		return this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex];
	}

	/**
	 * Gather a single entity set from the server.
	 *
	 * @param {Function} fCallback - Callback when done.
	 * @param {Object} pEntityInfo - The entity bundle entry.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value of the triggering input.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 */
	gatherEntitySet(fCallback, pEntityInfo, pView, pInput, pValue, pRowIndex, pTriggerGroupHash)
	{
		if (!pEntityInfo.Entity || typeof(pEntityInfo.Entity) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Entity string.`);
			return fCallback();
		}
		if (!pEntityInfo.Filter || typeof(pEntityInfo.Filter) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Filter string.`);
			return fCallback();
		}
		if (!pEntityInfo.Destination || typeof(pEntityInfo.Destination) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Destination string.`);
			return fCallback();
		}

		let tmpFilterTemplateRecord = { Value: pValue, Input: pInput, View: pView };
		let tmpFilterString = this.pict.parseTemplate(pEntityInfo.Filter, tmpFilterTemplateRecord);

		if (tmpFilterString === '')
		{
			this.log.warn(`TabularTriggerGroup: entity Filter did not return a string for FilterBy`);
		}

		let tmpRecordStartCursor = null;
		let tmpRecordCount = null;
		if (pEntityInfo.RecordCount)
		{
			tmpRecordStartCursor = pEntityInfo.RecordStartCursor != null ? pEntityInfo.RecordStartCursor : 0;
			tmpRecordCount = pEntityInfo.RecordCount != null ? pEntityInfo.RecordCount : null;
		}

		let tmpCallback = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`TabularTriggerGroup error getting entity set for [${pEntityInfo.Entity}] row ${pRowIndex}: ${pError}`, pError);
				return fCallback(pError);
			}

			this.log.trace(`TabularTriggerGroup found ${pRecordSet.length} records for ${pEntityInfo.Entity} row ${pRowIndex}`);

			let tmpRowCache = this.ensureRowCache(pTriggerGroupHash, pRowIndex);

			if (pEntityInfo.SingleRecord)
			{
				if (pRecordSet.length < 1)
				{
					this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, false);
				}
				else
				{
					this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, pRecordSet[0]);
				}
			}
			else
			{
				this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, pRecordSet);
			}

			return fCallback();
		};

		if (tmpRecordCount)
		{
			this.pict.EntityProvider.getEntitySetPage(pEntityInfo.Entity, tmpFilterString, tmpRecordStartCursor, tmpRecordCount, tmpCallback);
		}
		else
		{
			this.pict.EntityProvider.getEntitySet(pEntityInfo.Entity, tmpFilterString, tmpCallback);
		}
	}

	/**
	 * Gather a custom data set from the server.
	 *
	 * @param {Function} fCallback - Callback when done.
	 * @param {Object} pRequestInfo - The custom request info.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 */
	gatherCustomDataSet(fCallback, pRequestInfo, pView, pInput, pValue, pRowIndex, pTriggerGroupHash)
	{
		if (!pRequestInfo.URL || typeof(pRequestInfo.URL) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse custom request: missing URL string.`);
			return fCallback();
		}

		let tmpURLTemplateRecord = { Value: pValue, Input: pInput, View: pView };
		let tmpURLTemplateString = this.pict.parseTemplate(pRequestInfo.URL, tmpURLTemplateRecord);

		let tmpURLPrefix = '';
		let tmpCustomURIHost = pRequestInfo.Host ? pRequestInfo.Host : false;
		let tmpCustomURIProtocol = pRequestInfo.Protocol ? pRequestInfo.Protocol : 'https';
		let tmpCustomURIPort = pRequestInfo.Port ? pRequestInfo.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.pict.EntityProvider.options.urlPrefix;
		}

		let tmpCallback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`TabularTriggerGroup error getting custom data for row ${pRowIndex}: ${pError}`, pError);
				return fCallback(pError);
			}

			if (pRequestInfo.Destination)
			{
				let tmpRowCache = this.ensureRowCache(pTriggerGroupHash, pRowIndex);
				this.pict.manifest.setValueByHash(tmpRowCache, pRequestInfo.Destination, pData);
			}

			return fCallback();
		};

		let tmpOptions = { url: `${tmpURLPrefix}${tmpURLTemplateString}` };
		tmpOptions = this.pict.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.pict.EntityProvider.restClient.getJSON(tmpOptions, tmpCallback);
	}

	/**
	 * Fetch entity data for a specific tabular row.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {Object} pGroupConfig - The trigger group configuration.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {Promise}
	 */
	async gatherDataForRow(pView, pInput, pValue, pHTMLSelector, pRowIndex, pGroupConfig, pTransactionGUID)
	{
		if (!Array.isArray(pGroupConfig.EntitiesBundle) || pGroupConfig.EntitiesBundle.length < 1)
		{
			this.log.warn(`TabularTriggerGroup: no EntitiesBundle array found for triggering input [${pInput.Hash}] row ${pRowIndex}`);
			return null;
		}

		let tmpTriggerGroupHash = pGroupConfig.TriggerGroupHash;
		let tmpLoadGUID = `TabularBundleLoad-${this.pict.getUUID()}`;

		if (pTransactionGUID)
		{
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpLoadGUID);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		for (let i = 0; i < pGroupConfig.EntitiesBundle.length; i++)
		{
			let tmpEntityBundleEntry = pGroupConfig.EntitiesBundle[i];
			tmpAnticipate.anticipate(
				(fNext) =>
				{
					try
					{
						switch (tmpEntityBundleEntry.Type)
						{
							case 'Custom':
								return this.gatherCustomDataSet(fNext, tmpEntityBundleEntry, pView, pInput, pValue, pRowIndex, tmpTriggerGroupHash);
							case 'MeadowEntity':
							default:
								return this.gatherEntitySet(fNext, tmpEntityBundleEntry, pView, pInput, pValue, pRowIndex, tmpTriggerGroupHash);
						}
					}
					catch (pError)
					{
						this.log.error(`TabularTriggerGroup error gathering entity set for row ${pRowIndex}: ${pError}`, pError);
					}
					return fNext();
				});
		}

		// Ensure we wait at least one tick for event ordering
		tmpAnticipate.anticipate((fNext) => setTimeout(fNext, 0));

		// After all data is gathered, fire the row-scoped trigger event
		tmpAnticipate.anticipate(
			(fNext) =>
			{
				if (this.pict.views.PictFormMetacontroller)
				{
					// Fire row-scoped event: TabularTriggerGroup:{GroupHash}:DataChange:{InputHash}:{RowIndex}:{UUID}
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TabularTriggerGroup:${tmpTriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${pRowIndex}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}

				if (pGroupConfig.PostSolvers && Array.isArray(pGroupConfig.PostSolvers))
				{
					this.pict.providers.DynamicSolver.executeSolvers(pView, pGroupConfig.PostSolvers, `TabularTriggerGroup hash ${tmpTriggerGroupHash} row ${pRowIndex} post-trigger`);
				}

				fNext();
			});

		return new Promise((pResolve, pReject) =>
		{
			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`TabularTriggerGroup error gathering data for row ${pRowIndex}: ${pError}`, pError);
					}
					if (pTransactionGUID)
					{
						pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpLoadGUID);
					}
					return pResolve(pError);
				});
		});
	}

	/**
	 * Autofill a tabular input from the row cache.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {Object} pTriggerGroupInfo - The trigger group configuration.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {boolean}
	 */
	autoFillFromRowCache(pView, pInput, pTriggerGroupInfo, pHTMLSelector, pRowIndex)
	{
		if (!pTriggerGroupInfo.TriggerGroupHash || typeof(pTriggerGroupInfo.TriggerGroupHash) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to autofill: missing TriggerGroupHash string.`);
			return false;
		}
		if (!pTriggerGroupInfo.TriggerAddress || typeof(pTriggerGroupInfo.TriggerAddress) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to autofill: missing TriggerAddress string.`);
			return false;
		}

		let tmpRowCache = this.ensureRowCache(pTriggerGroupInfo.TriggerGroupHash, pRowIndex);
		let tmpValue = this.pict.manifest.getValueByHash(tmpRowCache, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}

		pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpValue);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
		return true;
	}

	/**
	 * Handle data changes in tabular inputs.
	 * If this is a triggering input, fetch data and fire row-scoped event.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpConfigs = this.getTriggerGroupConfigurationArray(pInput);

		for (let i = 0; i < tmpConfigs.length; i++)
		{
			let tmpConfig = tmpConfigs[i];
			if (tmpConfig.TriggerAllInputs)
			{
				if (tmpConfig.PreSolvers && Array.isArray(tmpConfig.PreSolvers))
				{
					this.pict.providers.DynamicSolver.executeSolvers(pView, tmpConfig.PreSolvers, `TabularTriggerGroup hash ${tmpConfig.TriggerGroupHash} row ${pRowIndex} pre-trigger`);
				}

				this.gatherDataForRow(pView, pInput, pValue, pHTMLSelector, pRowIndex, tmpConfig, pTransactionGUID);
			}
		}

		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handle events after completion for tabular inputs.
	 * If this is a receiving input, autofill from the row cache only if the
	 * event's row index matches.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of this input.
	 * @param {string} pEvent - The event string.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {boolean}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		let tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let tmpParts = tmpPayload.split(':');
		// Expected format: TabularTriggerGroup:{GroupHash}:DataChange:{InputHash}:{RowIndex}:{UUID}
		let tmpType = tmpParts[0];
		let tmpGroupHash = tmpParts[1];
		let tmpEventType = tmpParts[2];
		let tmpInputHash = tmpParts[3];
		let tmpEventRowIndex = parseInt(tmpParts[4], 10);

		if (tmpType !== 'TabularTriggerGroup')
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		// Skip if this is the triggering input itself
		if ((pInput.Hash || pInput.DataAddress) === tmpInputHash)
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		// Only process if the row index matches
		if (pRowIndex !== tmpEventRowIndex)
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		let tmpConfigs = this.getTriggerGroupConfigurationArray(pInput);

		for (let i = 0; i < tmpConfigs.length; i++)
		{
			let tmpConfig = tmpConfigs[i];
			if (tmpConfig.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			if (tmpConfig.TriggerAddress)
			{
				this.autoFillFromRowCache(pView, pInput, tmpConfig, pHTMLSelector, pRowIndex);
			}

			if (tmpConfig.SelectOptionsRefresh)
			{
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				if (tmpInputView && pInput.PictForm.SelectOptionsPickList)
				{
					this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
					this.pict.providers['Pict-Input-Select'].refreshSelectListTabular(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector, pRowIndex);
					tmpInputView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
				}
			}
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Non-tabular data change handler.
	 * TabularTriggerGroup is designed for tabular use, but we support non-tabular
	 * as a pass-through for flexibility.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Non-tabular event handler.
	 * TabularTriggerGroup events are scoped to tabular, so non-tabular events
	 * are ignored.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = TabularTriggerGroupInputHandler;

module.exports.default_configuration = (
{
	"ProviderIdentifier": "Pict-Input-TabularTriggerGroup",
	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

},{"../Pict-Provider-InputExtension.js":509}],535:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * Input provider for simple templated content display.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class TemplatedInputProvider extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {number} [pRowIndex] - (optional) The row index for tabular data.
	 *
	 * @return {void}
	 */
	handleContentUpdate(pView, pInput, pValue, pRowIndex)
	{
		let tmpContent = '';
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		let tmpIsLocked = false;
		//TODO: support more templates
		//TODO: support "locked" content?
		if (!tmpIsLocked && pInput.PictForm && pInput.PictForm.Template && (typeof(pInput.PictForm.Template) === 'string'))
		{
			tmpContent = this.pict.parseTemplate(pInput.PictForm.Template, Object.assign({}, this.pict, { Data: pView.getMarshalDestinationObject() }), null, [this], this);
		}
		if (!tmpContent && !tmpIsLocked && pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (pRowIndex != null)
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpContent);
		}
		else
		{
			pView.setDataByInput(pInput, tmpContent);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, null, pTransactionGUID);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleInitialize(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object|null} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number|null} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	_handleInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm && pInput.PictForm.Templates && typeof pInput.PictForm.Templates === 'object' && !Array.isArray(pInput.PictForm.Templates))
		{
			for (const [ tmpTemplateHash, tmpTemplate ] of Object.entries(pInput.PictForm.Templates))
			{
				if (this.pict.TemplateProvider.templates[tmpTemplateHash])
				{
					this.pict.log.error(`[Pict-Input-Templated] Attempt to override template with hash: ${tmpTemplateHash}; skipping.`);
					continue;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpTemplate, `Templated Input hash: ${pInput.Hash}`);
			}
		}
		this.handleContentUpdate(pView, pInput, pValue);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup')
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}

		const tmpTriggerGroupHashes = Array.isArray(pInput.PictForm?.TriggerGroupHash) ? pInput.PictForm.TriggerGroupHash : [pInput.PictForm?.TriggerGroupHash];
		if (!pInput.PictForm || !pInput.PictForm.TriggerGroupHash || !tmpTriggerGroupHashes.includes(tmpGroupHash))
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		this.handleContentUpdate(pView, pInput, pValue);
		pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup')
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		const tmpTriggerGroupHashes = Array.isArray(pInput.PictForm?.TriggerGroupHash) ? pInput.PictForm.TriggerGroupHash : [pInput.PictForm?.TriggerGroupHash];
		if (!pInput.PictForm || !pInput.PictForm.TriggerGroupHash || !tmpTriggerGroupHashes.includes(tmpGroupHash))
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		this.handleContentUpdate(pView, pInput, pValue, pRowIndex);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = TemplatedInputProvider;

},{"../Pict-Provider-InputExtension.js":509}],536:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * 
	 * @param {String} pDisplayID 
	 * @param {Object} pInput - The PictForm Input Object
	 * @param {any} pValue 
	 */
	assignDisplayEntityData(pDisplayID, pInput, pValue)
	{
		// 0. Manage state
		let tmpDisplayTemplate = (typeof(pInput.PictForm.TemplatedEntityLookup.Template) === "string") ? pInput.PictForm.TemplatedEntityLookup.Template : "";
		let tmpDisplayContent = '';

		if (typeof(pInput) != "object")
		{
			this.log.error("Error in assignDisplayEntityData: pInput is not an object");
			return;
		}
		if (!(`PictForm` in pInput))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm is not an object");
			return;
		}
		if (!(`TemplatedEntityLookup` in pInput.PictForm))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm.TemplatedEntityLookup is not in the PictForm object");
			return;
		}
		if (!Array.isArray(pInput.PictForm.TemplatedEntityLookup.EntitiesBundle))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm.TemplatedEntityLookup.EntitiesBundle is not an array");
			return;
		}

		const tmpAnticipate = this.fable.newAnticipate();

		// 1. Get the entities
		tmpAnticipate.anticipate(
			function (fNext)
			{
				this.pict.EntityProvider.gatherDataFromServer(pInput.PictForm.TemplatedEntityLookup.EntitiesBundle, (pError) =>
				{
					// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
					setTimeout(() => fNext(pError), 0);
				});
			}.bind(this));

		// 2. Check the Empty Value Test List

		// 3. Render the Template
		tmpAnticipate.anticipate(
			function (fNext)
			{
				this.pict.parseTemplate(tmpDisplayTemplate, {Value: pValue},
					function (pError, pResult)
					{
						if (pError)
						{
							this.log.error("Error rendering template in assignDisplayEntityData", pError);
							return;
						}
						tmpDisplayContent = pResult;
						return fNext();
					}.bind(this));
			}.bind(this));

		// 4. Assign the Content to the display element
		tmpAnticipate.wait(
			function (pError)
			{
				if (pError)
				{
					this.log.error("Error in assignDisplayEntityData", pError);
					return;
				}
				this.pict.ContentAssignment.assignContent(pDisplayID, tmpDisplayContent);
			}.bind(this));
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.assignDisplayEntityData(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.assignDisplayEntityData(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput, pValue);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.TemplatedEntityLookup || !('TriggerGroupHash' in pInput.PictForm.TemplatedEntityLookup))
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = [pInput.PictForm.TemplatedEntityLookup];

		for (let i = 0; i < tmpAutoFillTriggerGroups.length; i++)
		{
			let tmpAutoFillTriggerGroup = tmpAutoFillTriggerGroups[i];
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			this.assignDisplayEntityData(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pInput, pValue);
		}

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.TemplatedEntityLookup || !('TriggerGroupHash' in pInput.PictForm.TemplatedEntityLookup))
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = [pInput.PictForm.TemplatedEntityLookup];
		for (const tmpAutoFillTriggerGroup of tmpAutoFillTriggerGroups)
		{
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			this.assignDisplayEntityData(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput, pValue);
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":509,"marked":495}],537:[function(require,module,exports){
/**
 * Themeify-SVG.js
 *
 * Rewrite an exported Excalidraw SVG so its palette colors become CSS custom
 * properties with hex fallbacks:
 *
 *     stroke="#1B1F23"  ->  stroke="var(--diagram-ink, #1B1F23)"
 *
 * With no variables set, the hex fallback renders the original look, so the
 * SVG is correct standalone (in an <img>, a file viewer, etc.). When an
 * embedder that inlines the SVG sets `--diagram-ink` and the other tokens
 * per active theme, the same single SVG adapts live, light/dark.
 *
 * The embedded <metadata> block (base64 Excalidraw scene) is protected and
 * left byte-for-byte intact so the scene still round-trips into
 * pict-section-excalidraw for hand-editing.
 *
 * Token names (all under the --diagram- namespace):
 *   ink, paper, accent, highlight, deemphasis, link
 *
 * This file mirrors the canonical implementation at
 * `pict-renderer-graph/source/Pict-Renderer-Graph-Theme-SVG.js`. The two are
 * kept in sync by hand. If you edit the regex pass here, update the other.
 * The reason for the duplication: this section module renders directly into
 * a browser DOM, and we don't want to pull pict-renderer-graph (which spins
 * up Chromium) in as a runtime dependency.
 */

const _PaletteTokens = ['ink', 'paper', 'accent', 'highlight', 'deemphasis', 'link'];

// The default Excalidraw notebook palette we map TO theme tokens. Callers can
// pass their own palette via the second arg; this is the fallback so callers
// who just want the standard mapping don't have to specify anything.
const _DefaultPalette =
{
	ink:        '#1B1F23',
	paper:      '#FDFCF7',
	accent:     '#E66C2C',
	highlight:  '#FFD966',
	deemphasis: '#A0A0A0',
	link:       '#2E7D74'
};

function escapeRegExp(pStr)
{
	return pStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Rewrite the palette colors in an SVG to CSS variables with hex fallbacks.
 *
 * @param {string} pSVG - The exported SVG string.
 * @param {object} [pPaletteOrProfile] - Either a flat palette
 *   `{ink, paper, accent, ...}` OR a style profile carrying `.Palette`. When
 *   omitted, the standard notebook palette is used.
 * @returns {string} The SVG with palette colors rewritten to CSS variables.
 */
function themeifySVG(pSVG, pPaletteOrProfile)
{
	if (typeof pSVG !== 'string')
	{
		return pSVG;
	}

	let tmpPalette = _DefaultPalette;
	if (pPaletteOrProfile && typeof pPaletteOrProfile === 'object')
	{
		// Accept either a profile-shaped object (has .Palette) or a bare palette.
		tmpPalette = pPaletteOrProfile.Palette || pPaletteOrProfile;
	}

	// Protect the metadata block — it carries the embedded scene verbatim.
	let tmpMetaMatch   = pSVG.match(/<metadata[\s\S]*?<\/metadata>/i);
	let tmpMeta        = tmpMetaMatch ? tmpMetaMatch[0] : '';
	let tmpPlaceholder = ' PICT-SECTION-EXCALIDRAW-METADATA ';
	let tmpBody        = tmpMeta ? pSVG.replace(tmpMeta, tmpPlaceholder) : pSVG;

	for (let i = 0; i < _PaletteTokens.length; i++)
	{
		let tmpToken = _PaletteTokens[i];
		let tmpHex   = tmpPalette[tmpToken];
		if ((typeof tmpHex !== 'string') || !/^#[0-9a-fA-F]{6}$/.test(tmpHex))
		{
			continue;
		}
		// Match the hex only where it's used as a color: a stroke= / fill=
		// attribute, or a stroke: / fill: inside a style string. The property
		// must be immediately followed by =" or : so we never catch
		// "strokeColor" in the source JSON (followed by ").
		let tmpRegExp = new RegExp('(stroke|fill)(="|:\\s*)(' + escapeRegExp(tmpHex) + ')(?=["\\s;)])', 'gi');
		tmpBody = tmpBody.replace(tmpRegExp, (pWhole, pProp, pSep, pHex) =>
		{
			return pProp + pSep + 'var(--diagram-' + tmpToken + ', ' + pHex + ')';
		});
	}

	return tmpMeta ? tmpBody.replace(tmpPlaceholder, tmpMeta) : tmpBody;
}

module.exports =
{
	themeifySVG:    themeifySVG,
	paletteTokens:  _PaletteTokens,
	defaultPalette: _DefaultPalette
};

},{}],538:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class ChartLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a Configuration-based Chart.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		// Chart Parameters!!!
		tmpTemplate += 'No really... this is a chart.';
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = ChartLayout;

},{"../Pict-Provider-DynamicLayout.js":502}],539:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		pGroup.Rows.sort((rowA, rowB) =>
		{
			if (rowA.RowNumber && rowB.RowNumber)
			{
				return rowA.RowNumber >= rowB.RowNumber ? 1 : -1;
			}
			if (!rowA.RowNumber && !rowB.RowNumber)
			{
				return rowA.Hash >= rowB.Hash ? 1 : -1;
			}
			return rowA.RowNumber ? 1 : -1;
		});

		// loop over descriptors that have my group set?
		// set their GroupIndex from pGroup
		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			let tmpRow = pGroup.Rows[j];

			// There are three row layouts: Record, Tabular and Columnar
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;
			}
		}
		const hash = pGroup.CustomLayoutTemplateHash;
		if (hash)
		{
			const template = this.pict.TemplateProvider.getTemplate(hash);
			if (template)
			{
				return template;
			}
			this.log.warn(`Custom layout template not found for hash: ${hash}`);
		}
		return pGroup.CustomLayoutTemplate || '';
	}
}

module.exports = RecordLayout;

},{"../Pict-Provider-DynamicLayout.js":502}],540:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		pGroup.Rows.sort((rowA, rowB) =>
		{
			if (rowA.RowNumber && rowB.RowNumber)
			{
				return rowA.RowNumber >= rowB.RowNumber ? 1 : -1;
			}
			if (!rowA.RowNumber && !rowB.RowNumber)
			{
				return rowA.Hash >= rowB.Hash ? 1 : -1;
			}
			return rowA.RowNumber ? 1 : -1;
		});

		if (!('Rows' in pGroup))
		{
			pGroup.Rows = [];
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			// TODO: Validate that the row exists?  Bootstrap seems to have it here.
			let tmpRow = pGroup.Rows[j]
			tmpRow.WidthTotalRaw = 0;

			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;
				let tmpInputWidth = 1;
				try
				{
					tmpInputWidth = Math.abs(parseFloat(tmpInput.PictForm.Width));
				}
				catch (pParseError)
				{
					tmpInputWidth = 1;
				}
				if (!tmpInputWidth || isNaN(tmpInputWidth) || tmpInputWidth <= 0)
				{
					tmpInputWidth = 1;
				}
				tmpInput.PictForm.RawWidth = tmpInputWidth;
				tmpRow.WidthTotalRaw += tmpInputWidth;

				//tmpTemplate += tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}
			// Now that we've gotten all the raw widths for the row, quantize them properly.
			// Default by quantizing to 99 percentage units wide
			let tmpGroupQuantizedWidth = 95;
			if ('WidthQuantization' in pGroup)
			{
				try
				{
					tmpGroupQuantizedWidth = Math.abs(parseInt(pGroup.WidthQuantization));
					if (!tmpGroupQuantizedWidth || isNaN(tmpGroupQuantizedWidth) || tmpGroupQuantizedWidth <= 0)
					{
						tmpGroupQuantizedWidth = 95;
					}
				}
				catch(pParseError)
				{
					// TODO: UGH THIS IS NaN at the moment.......
					tmpGroupQuantizedWidth = 95;
				}
			}
			else if ('WidthQuantization' in this.pict.PictApplication.options)
			{
				tmpGroupQuantizedWidth = this.pict.PictApplication.options.WidthQuantization;
			}
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				tmpInput.PictForm.QuantizedWidth = Math.round((tmpInput.PictForm.RawWidth / tmpRow.WidthTotalRaw) * tmpGroupQuantizedWidth);
				//this.fable.log.trace(`Quantized input width for Group ${pGroup.GroupIndex} Row ${j} Input ${k} (${tmpInput.Name}) to ${tmpInput.PictForm.QuantizedWidth} (Raw: ${tmpInput.PictForm.RawWidth} / Total Raw: ${tmpRow.WidthTotalRaw} / Group Quantization: ${tmpGroupQuantizedWidth})`);

				tmpTemplate += tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}

			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = RecordLayout;

},{"../Pict-Provider-DynamicLayout.js":502}],541:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordSetLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a complex multi-record repeated form view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such, only, it will render itself once for each element in a set.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// TODO: We cheated and this is still tabular.  Gotta change it up!
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';
		let tmpTemplateSetRecordRowTemplate = '';
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		let tmpMaxRowIndex = 0;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			if (tmpInput.PictForm.Row)
			{
				tmpInput.PictForm.RowIndex = tmpInput.PictForm.Row;
				if (tmpInput.PictForm.RowIndex > tmpMaxRowIndex)
				{
					tmpMaxRowIndex = tmpInput.PictForm.RowIndex;
				}
			}
		}

		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			if (!tmpInput.PictForm.RowIndex)
			{
				tmpInput.PictForm.RowIndex = tmpMaxRowIndex + 1;
			}
		}

		for (let d = 0; d < tmpMaxRowIndex + 1; d++)
		{
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
				// Update the InputIndex to match the current render config
				if (tmpInput.PictForm.TabularHidden)
				{
					continue;
				}

				// tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-HeaderCell`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				if (tmpInput.PictForm.RowIndex == d)
				{
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Cell-Prefix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
					let tmpInputType = (('PictForm' in tmpInput) && tmpInput.PictForm.InputType) ? tmpInput.PictForm.InputType : 'Default';
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInputType, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`, pGroup.GroupIndex, k);
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Cell-Postfix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				}
			}
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}

		// This is the template by which the tabular template includes the rows.
		// The template recursion here is difficult to envision without drawing it.
		// TODO: Consider making this function available in manyfest in some fashion it seems dope.
		let tmpTemplateSetVirtualRowTemplate = '';
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-RecordSetTemplate-Row-ExtraPrefix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += `\n\n{~T:${pGroup.SectionTabularRowTemplateHash}:Record~}\n`;
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-RecordSetTemplate-Row-ExtraPostfix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// This is a custom template expression
		tmpTemplate += `\n\n{~MTVS:${pGroup.SectionTabularRowVirtualTemplateHash}:${pGroup.GroupIndex}:${pView.getMarshalDestinationAddress()}.${pGroup.RecordSetAddress}~}\n`;

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		// Add the TemplateSetTemplate
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowVirtualTemplateHash, tmpTemplateSetVirtualRowTemplate);
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowTemplateHash, tmpTemplateSetRecordRowTemplate);

		return tmpTemplate;
	}
}

module.exports = RecordSetLayout;

},{"../Pict-Provider-DynamicLayout.js":502}],542:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

// The resolved --theme-color-* tokens carried onto a column-chooser popover when it is portaled to
// <body>: off its scoped container it would otherwise fall back to the stylesheet's hex defaults.
// Mirrors pict-section-picker's PictView-Picker `_THEME_TOKENS`.
const _COLCHOOSER_THEME_TOKENS =
[
	'--theme-color-text-primary', '--theme-color-text-secondary', '--theme-color-text-muted',
	'--theme-color-border-default', '--theme-color-border-light', '--theme-color-background-panel',
	'--theme-color-background-tertiary',
];

class TabularLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		// Register the sort glyphs used by the optional ColumnSorting feature, through
		// pict's built-in icon registry (so they theme + scale like every other glyph).
		if (this.pict && this.pict.providers && this.pict.providers.Icon
			&& typeof this.pict.providers.Icon.registerSet === 'function')
		{
			this.pict.providers.Icon.registerSet(
				{
					Outline:
					{
						Sort: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 20V5"/><path d="M5.5 8.5L9 5L12.5 8.5"/><path d="M15 4V19"/><path d="M11.5 15.5L15 19L18.5 15.5"/></svg>',
						SortAscending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V5"/><path d="M6 11L12 5L18 11"/></svg>',
						SortDescending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4V19"/><path d="M6 13L12 19L18 13"/></svg>'
					}
				});
		}

		// CSS for the clickable sort control. Inactive glyphs are faded; the
		// actively-sorted column's glyph is full opacity.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Layout-Tabular-Sort-CSS',
				'.pict-tabular-sort-control { cursor: pointer; display: inline-flex; vertical-align: middle; margin-left: 0.3em; opacity: 0.4; }'
				+ ' .pict-tabular-sort-control:hover { opacity: 0.75; }'
				+ ' .pict-tabular-sort-control.pict-tabular-sort-asc, .pict-tabular-sort-control.pict-tabular-sort-desc { opacity: 1; }',
				500);

			// CSS for the optional ColumnChooser feature: a right-aligned trigger button above the
			// table plus a checkbox popover. Anchored the same listener-free way as pict-section-picker:
			// the popover is position:absolute under the (position:relative) bar so it rides page scroll
			// for free, and is portaled to <body> in DOCUMENT coords only when a clipping ancestor would
			// otherwise cut it -- no scroll/resize handlers. The transparent backdrop catches outside
			// clicks. Dark-mode blocks (below, with DARK var() fallbacks) let the widget theme correctly
			// even where the host has not defined the --theme-color-* tokens; a host that HAS defined
			// them still wins, and the token values are carried across when the popover is portaled.
			let tmpColumnChooserBaseCSS = /*css*/`
	.pict-tabular-colchooser-bar { position: relative; display: flex; justify-content: flex-end; margin: 0 0 0.35rem; }
	.pict-tabular-colchooser-trigger { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.88rem;
		padding: 0.3rem 0.65rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px;
		background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
	.pict-tabular-colchooser-trigger:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
	.pict-tabular-colchooser-count { font-size: 0.8em; color: var(--theme-color-text-muted, #6b7686); }
	.pict-tabular-colchooser-pop { position: absolute; top: calc(100% + 6px); right: 0; z-index: 30; min-width: 220px; max-width: 320px; display: none; }
	.pict-tabular-colchooser-pop.open { display: block; }
	.pict-tabular-colchooser-pop.pict-tabular-colchooser-pop-portal { right: auto; }
	.pict-tabular-colchooser-backdrop { position: fixed; inset: 0; z-index: 0; }
	.pict-tabular-colchooser-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(70vh, 420px);
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
		border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
	.pict-tabular-colchooser-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem 0; }
	.pict-tabular-colchooser-row { display: flex; align-items: center; gap: 0.5rem; font-size: 0.9rem; cursor: pointer;
		padding: 0.32rem 0.8rem; color: var(--theme-color-text-primary, #1f2733); }
	.pict-tabular-colchooser-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
	.pict-tabular-colchooser-row input { flex: 0 0 auto; margin: 0; cursor: pointer; }
	.pict-tabular-colchooser-footer { flex: 0 0 auto; display: flex; justify-content: flex-end; padding: 0.45rem 0.7rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.pict-tabular-colchooser-reset { font: inherit; font-size: 0.84rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
	.pict-tabular-colchooser-reset:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eceef2); }
`;
			// Dark-mode overrides: re-declare only the color-bearing rules with DARK var() fallbacks under
			// each of the app's dark signals. Duplicated per selector (explicit [data-theme=dark] and
			// .theme-dark, plus the system preference guarded by html:not([data-theme=light]) so an
			// explicit light choice still wins) exactly as headlight-styles' bulma-*.scss does. Higher
			// specificity than the base rules, so dark wins whenever its selector matches; the [data-theme]
			// signal lives on <html>, so these still apply after a popover is portaled to <body>.
			let fColumnChooserDarkRules = (pScope) => /*css*/`
	${pScope} .pict-tabular-colchooser-trigger { border-color: var(--theme-color-border-default, #3a4250); background: var(--theme-color-background-panel, #242b36); color: var(--theme-color-text-secondary, #c3cad4); }
	${pScope} .pict-tabular-colchooser-trigger:hover { background: var(--theme-color-background-tertiary, #2c3542); color: var(--theme-color-text-primary, #e6e9ee); }
	${pScope} .pict-tabular-colchooser-count { color: var(--theme-color-text-muted, #8b95a4); }
	${pScope} .pict-tabular-colchooser-panel { background: var(--theme-color-background-panel, #242b36); border-color: var(--theme-color-border-default, #3a4250); }
	${pScope} .pict-tabular-colchooser-row { color: var(--theme-color-text-primary, #e6e9ee); }
	${pScope} .pict-tabular-colchooser-row:hover { background: var(--theme-color-background-tertiary, #2c3542); }
	${pScope} .pict-tabular-colchooser-footer { border-top-color: var(--theme-color-border-light, #333b47); }
	${pScope} .pict-tabular-colchooser-reset { color: var(--theme-color-text-muted, #8b95a4); }
	${pScope} .pict-tabular-colchooser-reset:hover { color: var(--theme-color-text-primary, #e6e9ee); background: var(--theme-color-background-tertiary, #2c3542); }
`;
			this.pict.CSSMap.addCSS('Pict-Layout-Tabular-ColumnChooser-CSS',
				tmpColumnChooserBaseCSS
				+ fColumnChooserDarkRules('[data-theme="dark"]')
				+ fColumnChooserDarkRules('.theme-dark')
				+ `@media (prefers-color-scheme: dark) {` + fColumnChooserDarkRules('html:not([data-theme="light"])') + `}`,
				500);
		}
	}

	/**
	 * Builds one prime-header `<th>` with an injected, clickable sort control
	 * `<span>` carrying the sort SVG glyph. Used when the group has
	 * `ColumnSorting: true`. The glyph reflects the current sort state of the
	 * column (neutral / ascending / descending).
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pDescriptor - The column's descriptor.
	 * @param {number} pColumnIndex - The descriptor's InputIndex.
	 * @returns {string}
	 */
	_buildSortableHeaderCell(pView, pGroup, pDescriptor, pColumnIndex)
	{
		let tmpSortState = pGroup._SortState || { ColumnIndex: -1, Direction: 'none' };
		let tmpIsActive = (tmpSortState.ColumnIndex === pColumnIndex) && (tmpSortState.Direction !== 'none');
		let tmpIconName = 'Sort';
		let tmpStateClass = 'pict-tabular-sort-none';
		if (tmpIsActive && tmpSortState.Direction === 'asc')
		{
			tmpIconName = 'SortAscending';
			tmpStateClass = 'pict-tabular-sort-asc';
		}
		else if (tmpIsActive && tmpSortState.Direction === 'desc')
		{
			tmpIconName = 'SortDescending';
			tmpStateClass = 'pict-tabular-sort-desc';
		}
		let tmpGlyph = (typeof this.pict.icon === 'function') ? this.pict.icon(tmpIconName) : '';
		// Resolve the column label through a metatemplate reference (not a baked
		// literal) so it re-resolves on every render -- this keeps the sortable
		// header in lock-step with the descriptor Name the same way the default
		// (non-sorting) header does. The sort-control glyph/state below is baked,
		// which is fine: it only changes on a sort click, which rebuilds anyway.
		let tmpLabelReference = this.pict.providers.MetatemplateGenerator.getMetatemplateTemplateReference(
			pView, `-TabularTemplate-HeaderCellLabel`, `getTabularRecordInput("${pGroup.GroupIndex}","${pColumnIndex}")`);
		return `\n\t\t\t\t\t\t<th data-tabular-column-index="${pColumnIndex}">${tmpLabelReference} `
			+ `<span class="pict-tabular-sort-control ${tmpStateClass}" `
			+ `onclick="_Pict.providers['Pict-Layout-Tabular'].sortTabularColumn('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumnIndex})">`
			+ `${tmpGlyph}</span></th>\n`;
	}

	/**
	 * Resolves one row's value for a column descriptor. Dynamic columns store
	 * their value at the descriptor's InformaryDataAddress (a nested path);
	 * static columns resolve by hash.
	 *
	 * @param {Object} pGroup
	 * @param {Object} pDescriptor
	 * @param {Object} pRecord
	 * @returns {any}
	 */
	_getTabularCellValue(pGroup, pDescriptor, pRecord)
	{
		if (!pDescriptor || !pRecord || !pGroup.supportingManifest)
		{
			return undefined;
		}
		let tmpKey = (pDescriptor.PictForm && typeof pDescriptor.PictForm.InformaryDataAddress === 'string'
			&& pDescriptor.PictForm.InformaryDataAddress.length > 0)
			? pDescriptor.PictForm.InformaryDataAddress
			: pDescriptor.Hash;
		try
		{
			return pGroup.supportingManifest.getValueByHash(pRecord, tmpKey);
		}
		catch (pError)
		{
			return undefined;
		}
	}

	/**
	 * Comparator for tabular sort. Numeric when both values parse as numbers,
	 * otherwise a locale string comparison. Null/undefined sort as empty.
	 *
	 * @param {any} pValueA
	 * @param {any} pValueB
	 * @returns {number}
	 */
	_compareTabularValues(pValueA, pValueB)
	{
		let tmpA = (pValueA == null) ? '' : pValueA;
		let tmpB = (pValueB == null) ? '' : pValueB;
		let tmpNumberA = Number(tmpA);
		let tmpNumberB = Number(tmpB);
		if ((tmpA !== '') && (tmpB !== '') && !isNaN(tmpNumberA) && !isNaN(tmpNumberB))
		{
			if (tmpNumberA < tmpNumberB) { return -1; }
			if (tmpNumberA > tmpNumberB) { return 1; }
			return 0;
		}
		return String(tmpA).localeCompare(String(tmpB));
	}

	/**
	 * Inline-handler entry point: sorts a tabular group's record set by a column.
	 * A fresh column starts ascending; clicking the active column toggles
	 * ascending -> descending. Rebuilds so the header glyph re-bakes, then
	 * re-renders and re-marshals.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex
	 * @returns {boolean}
	 */
	sortTabularColumn(pViewHash, pGroupIndex, pColumnIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || tmpGroup.ColumnSorting !== true)
		{
			return false;
		}
		let tmpColumnIndex = Number(pColumnIndex);
		if (isNaN(tmpColumnIndex) || tmpColumnIndex < 0)
		{
			return false;
		}

		// Cycle the direction: a new column starts ascending, the active column toggles.
		if (!tmpGroup._SortState)
		{
			tmpGroup._SortState = { ColumnIndex: -1, Direction: 'none' };
		}
		if (tmpGroup._SortState.ColumnIndex === tmpColumnIndex && tmpGroup._SortState.Direction === 'asc')
		{
			tmpGroup._SortState.Direction = 'desc';
		}
		else
		{
			tmpGroup._SortState.ColumnIndex = tmpColumnIndex;
			tmpGroup._SortState.Direction = 'asc';
		}

		// Resolve the descriptor + record set and sort the record set in place.
		let tmpDescriptor = null;
		if (tmpGroup.supportingManifest && Array.isArray(tmpGroup.supportingManifest.elementAddresses))
		{
			let tmpHash = tmpGroup.supportingManifest.elementAddresses[tmpColumnIndex];
			tmpDescriptor = tmpGroup.supportingManifest.elementDescriptors[tmpHash];
		}
		let tmpRecordSet = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		if (tmpDescriptor && Array.isArray(tmpRecordSet))
		{
			let tmpDirection = (tmpGroup._SortState.Direction === 'desc') ? -1 : 1;
			tmpRecordSet.sort((pRecordA, pRecordB) =>
			{
				return this._compareTabularValues(
					this._getTabularCellValue(tmpGroup, tmpDescriptor, pRecordA),
					this._getTabularCellValue(tmpGroup, tmpDescriptor, pRecordB)) * tmpDirection;
			});
		}

		// Rebuild so the header re-bakes with the updated glyph, then re-render + marshal.
		tmpView.rebuildCustomTemplate();
		tmpView.render();
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			tmpView.marshalToView();
		}
		return true;
	}

	/**
	 * Resolve a template string against a record. Returns '' on failure.
	 *
	 * @param {string} pTemplate
	 * @param {Object} pRecord
	 * @returns {string}
	 */
	_parseTabularTemplate(pTemplate, pRecord)
	{
		if (typeof pTemplate !== 'string')
		{
			return '';
		}
		if (pTemplate.indexOf('{') === -1)
		{
			return pTemplate;
		}
		try
		{
			let tmpResult = this.pict.parseTemplate(pTemplate, pRecord, null);
			return (typeof tmpResult === 'string') ? tmpResult : '';
		}
		catch (pError)
		{
			this.log.warn(`PICT Form Tabular template parse failed: ${pError && pError.message}`);
			return '';
		}
	}

	/**
	 * Build the expanded Headers config for a group.
	 *
	 * Returns the user-provided pGroup.Headers (each row = array of cells) plus
	 * a synthesized "header group" row prepended at the front when any DynamicColumns
	 * generator declares a HeaderGroupTemplate. The synthesized row clusters
	 * consecutive descriptors with the same _DynamicColumnHeaderGroup value into
	 * a single cell with ColumnSpan.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Array<Array<{Label: string, ColumnSpan: number, CSSClass: string}>>}
	 */
	_buildExpandedHeadersConfig(pView, pGroup)
	{
		let tmpExpanded = [];

		// When the column chooser has hidden columns, each user-provided header
		// cell's ColumnSpan shrinks by the hidden columns it covers (cells reduced
		// to zero drop out), so the stacked headers stay aligned with the columns
		// that actually render. The spans partition the configured (non-
		// TabularHidden) data columns in manifest order — same contract the
		// span-total warning in generateGroupLayoutTemplate enforces.
		let tmpChooserHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		let tmpConfiguredColumnVisibility = [];
		if (tmpChooserHiddenSet && pGroup.supportingManifest && Array.isArray(pGroup.supportingManifest.elementAddresses))
		{
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
				if (!tmpDescriptor || (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden))
				{
					continue;
				}
				tmpConfiguredColumnVisibility.push(!tmpChooserHiddenSet.has(String(pGroup.supportingManifest.elementAddresses[k])));
			}
		}

		// Render user-provided Headers config first (at the top of the table).
		if (Array.isArray(pGroup.Headers))
		{
			for (let r = 0; r < pGroup.Headers.length; r++)
			{
				let tmpRowConfig = pGroup.Headers[r];
				if (!Array.isArray(tmpRowConfig))
				{
					continue;
				}
				let tmpNormalizedRow = [];
				// Walks the configured-column visibility list as spans consume columns.
				let tmpColumnCursor = 0;
				for (let c = 0; c < tmpRowConfig.length; c++)
				{
					let tmpCell = tmpRowConfig[c];
					if (!tmpCell || typeof tmpCell !== 'object')
					{
						continue;
					}
					let tmpColumnSpan = (Number(tmpCell.ColumnSpan) > 0) ? Number(tmpCell.ColumnSpan) : 1;
					if (tmpChooserHiddenSet)
					{
						let tmpVisibleSpan = 0;
						for (let s = 0; s < tmpColumnSpan; s++)
						{
							// Columns past the configured set keep their span (the
							// misalignment warning will already have fired for that).
							if ((tmpColumnCursor >= tmpConfiguredColumnVisibility.length) || tmpConfiguredColumnVisibility[tmpColumnCursor])
							{
								tmpVisibleSpan++;
							}
							tmpColumnCursor++;
						}
						if (tmpVisibleSpan === 0)
						{
							continue;
						}
						tmpColumnSpan = tmpVisibleSpan;
					}
					tmpNormalizedRow.push({
						Label: (typeof tmpCell.Label === 'string') ? tmpCell.Label : '',
						ColumnSpan: tmpColumnSpan,
						CSSClass: (typeof tmpCell.CSSClass === 'string') ? tmpCell.CSSClass : ''
					});
				}
				tmpExpanded.push(tmpNormalizedRow);
			}
		}

		// Then synthesize a clustered super-header row from any DynamicColumns generator
		// that declared a HeaderGroupTemplate. This row sits JUST ABOVE the default
		// column-name row so the visual cluster lines up with the columns it groups.
		// Walk the supportingManifest in order and group adjacent descriptors that
		// share both _DynamicColumnGeneratorIndex and _DynamicColumnHeaderGroup; static
		// descriptors get blank "spacer" cells.
		let tmpHasHeaderGroups = false;
		if (Array.isArray(pGroup.DynamicColumns))
		{
			for (let g = 0; g < pGroup.DynamicColumns.length; g++)
			{
				if (pGroup.DynamicColumns[g] && pGroup.DynamicColumns[g].HeaderGroupTemplate)
				{
					tmpHasHeaderGroups = true;
					break;
				}
			}
		}
		if (tmpHasHeaderGroups && pGroup.supportingManifest)
		{
			let tmpSynthRow = [];
			let tmpCurrentRun = null;
			let tmpAddresses = pGroup.supportingManifest.elementAddresses;
			for (let k = 0; k < tmpAddresses.length; k++)
			{
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpAddresses[k]];
				if (!tmpDescriptor)
				{
					continue;
				}
				if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden)
				{
					continue;
				}
				if (tmpChooserHiddenSet && tmpChooserHiddenSet.has(String(tmpAddresses[k])))
				{
					continue;
				}
				let tmpIsDynamic = (typeof tmpDescriptor._DynamicColumnGeneratorIndex === 'number');
				let tmpGroupLabel = (tmpIsDynamic && typeof tmpDescriptor._DynamicColumnHeaderGroup === 'string')
					? tmpDescriptor._DynamicColumnHeaderGroup
					: '';
				let tmpRunKey = tmpIsDynamic ? `D${tmpDescriptor._DynamicColumnGeneratorIndex}|${tmpGroupLabel}` : `S|${k}`;
				if (tmpCurrentRun && tmpCurrentRun.RunKey === tmpRunKey)
				{
					tmpCurrentRun.Cell.ColumnSpan += 1;
				}
				else
				{
					tmpCurrentRun = {
						RunKey: tmpRunKey,
						Cell: {
							Label: tmpIsDynamic ? tmpGroupLabel : '',
							ColumnSpan: 1,
							CSSClass: tmpIsDynamic ? 'pict-tabular-dynamic-header-group' : 'pict-tabular-static-header-spacer'
						}
					};
					tmpSynthRow.push(tmpCurrentRun.Cell);
				}
			}
			tmpExpanded.push(tmpSynthRow);
		}

		return tmpExpanded;
	}

	/**
	 * Compute per-row label metadata for a tabular group with RowLabels config.
	 *
	 * Walks the current RecordSetAddress array. For each row, resolves the
	 * label value for each RowLabels entry (Template / RowNumber / SourceAddress).
	 * For Cluster:true columns, consecutive equal values collapse into a single
	 * cell on the first row of the run, with continuation rows marked Skip:true.
	 *
	 * Writes the result to pGroup.RowLabelMetadata as an array index-aligned
	 * with the record set. Idempotent — safe to call on every marshal.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_computeRowLabelMetadata(pView, pGroup)
	{
		if (!Array.isArray(pGroup.RowLabels) || pGroup.RowLabels.length === 0)
		{
			pGroup.RowLabelMetadata = [];
			return;
		}
		let tmpRecordSet = [];
		if (typeof pGroup.RecordSetAddress === 'string' && pGroup.RecordSetAddress.length > 0)
		{
			let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
			let tmpFetched = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, pGroup.RecordSetAddress);
			if (Array.isArray(tmpFetched))
			{
				tmpRecordSet = tmpFetched;
			}
		}

		let tmpMetadata = [];
		for (let i = 0; i < tmpRecordSet.length; i++)
		{
			let tmpRow = tmpRecordSet[i];
			let tmpCells = [];
			for (let l = 0; l < pGroup.RowLabels.length; l++)
			{
				let tmpLabelConfig = pGroup.RowLabels[l];
				let tmpRenderedLabel = '';
				if (tmpLabelConfig.RowNumber === true)
				{
					tmpRenderedLabel = String(i + 1);
				}
				else if (typeof tmpLabelConfig.SourceAddress === 'string' && tmpLabelConfig.SourceAddress.length > 0)
				{
					let tmpLabelSource = this.pict.resolveStateFromAddress(tmpLabelConfig.SourceAddress, null);
					if (Array.isArray(tmpLabelSource) && i < tmpLabelSource.length)
					{
						let tmpItem = tmpLabelSource[i];
						tmpRenderedLabel = (typeof tmpItem === 'string') ? tmpItem : (tmpItem == null ? '' : String(tmpItem));
					}
				}
				else if (typeof tmpLabelConfig.Template === 'string')
				{
					// Templates can reference Record.Value.X (the row record) or AppData.X.
					tmpRenderedLabel = this._parseTabularTemplate(tmpLabelConfig.Template, { Value: tmpRow, Key: i });
				}
				tmpCells.push({
					Label: tmpLabelConfig.Name || '',
					RenderedLabel: tmpRenderedLabel,
					RowSpan: 1,
					Skip: false,
					Cluster: tmpLabelConfig.Cluster === true,
					CSSClass: (typeof tmpLabelConfig.CSSClass === 'string') ? tmpLabelConfig.CSSClass : ''
				});
			}
			tmpMetadata.push({ Cells: tmpCells });
		}

		// Pass 2: apply clustering (rowspan collapse for consecutive equal values).
		for (let l = 0; l < pGroup.RowLabels.length; l++)
		{
			if (!pGroup.RowLabels[l].Cluster)
			{
				continue;
			}
			let tmpRunStart = 0;
			for (let i = 1; i <= tmpMetadata.length; i++)
			{
				let tmpAtEnd = (i === tmpMetadata.length);
				let tmpMatches = !tmpAtEnd
					&& tmpMetadata[i].Cells[l].RenderedLabel === tmpMetadata[tmpRunStart].Cells[l].RenderedLabel;
				if (tmpMatches)
				{
					tmpMetadata[i].Cells[l].Skip = true;
				}
				else
				{
					let tmpRunLength = i - tmpRunStart;
					tmpMetadata[tmpRunStart].Cells[l].RowSpan = tmpRunLength;
					tmpRunStart = i;
				}
			}
		}

		pGroup.RowLabelMetadata = tmpMetadata;
	}

	/**
	 * Called from the row template via the {~TRL:...~} tag. Returns the HTML for
	 * the leading cells of one tabular row: an optional row-selection checkbox
	 * cell followed by the configured row-label cells.
	 *
	 * @param {Object} pView
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @returns {string}
	 */
	_renderTabularRowLabelsHTML(pView, pGroupIndex, pRowKey)
	{
		if (!pView || !pView.sectionDefinition || !Array.isArray(pView.sectionDefinition.Groups))
		{
			return '';
		}
		let tmpGroupIdx = Number(pGroupIndex);
		if (isNaN(tmpGroupIdx) || tmpGroupIdx < 0 || tmpGroupIdx >= pView.sectionDefinition.Groups.length)
		{
			return '';
		}
		let tmpGroup = pView.sectionDefinition.Groups[tmpGroupIdx];
		let tmpRowKeyNum = Number(pRowKey);

		// The {~TRL:~} tag runs once per row, in row order, during a render pass.
		// Recompute the label metadata when the first row renders so a render()
		// that was not preceded by a fresh marshal (e.g. a row move / add / delete)
		// still shows correct, current row labels rather than the previous order.
		if (tmpRowKeyNum === 0)
		{
			this._computeRowLabelMetadata(pView, tmpGroup);
		}

		let tmpHTML = '';

		// Leading row-selection checkbox cell.
		if (tmpGroup._RowSelectionConfig && !isNaN(tmpRowKeyNum) && tmpRowKeyNum >= 0)
		{
			let tmpSelected = this._getTabularSelectionArray(pView, tmpGroup._RowSelectionConfig);
			let tmpCheckedAttr = tmpSelected[tmpRowKeyNum] ? ' checked="checked"' : '';
			tmpHTML += `<td class="pict-tabular-row-select">`
				+ `<input type="checkbox"${tmpCheckedAttr} onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularRowSelection('${pView.Hash}', ${tmpGroupIdx}, '${tmpRowKeyNum}', this.checked)">`
				+ `</td>`;
		}

		// Row-label cells.
		if (Array.isArray(tmpGroup.RowLabelMetadata)
			&& !isNaN(tmpRowKeyNum) && tmpRowKeyNum >= 0 && tmpRowKeyNum < tmpGroup.RowLabelMetadata.length)
		{
			let tmpCells = tmpGroup.RowLabelMetadata[tmpRowKeyNum].Cells;
			for (let c = 0; c < tmpCells.length; c++)
			{
				let tmpCell = tmpCells[c];
				if (tmpCell.Skip)
				{
					continue;
				}
				let tmpRowSpanAttr = (tmpCell.RowSpan > 1) ? ` rowspan="${tmpCell.RowSpan}"` : '';
				let tmpClassAttr = `pict-row-label${tmpCell.Cluster ? ' pict-row-label-clustered' : ''}${tmpCell.CSSClass ? ' ' + tmpCell.CSSClass : ''}`;
				tmpHTML += `<td${tmpRowSpanAttr} class="${tmpClassAttr}">${this._escapeHTML(tmpCell.RenderedLabel)}</td>`;
			}
		}
		return tmpHTML;
	}

	/**
	 * Called from the row template via {~F:...~} to emit the editing controls
	 * (del/up/down) for a row. Used when EditingControlsPosition === 'left'.
	 * For EditingControlsPosition === 'right' the existing default
	 * -TabularTemplate-Row-ExtraPostfix template handles this.
	 *
	 * @param {Object} pView
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @returns {string}
	 */
	_renderTabularEditingControlsHTML(pView, pGroupIndex, pRowKey)
	{
		if (!pView)
		{
			return '';
		}
		let tmpViewHash = pView.Hash;
		return `<td class="pict-tabular-editing-controls"><a href="#/" onClick="_Pict.views['${tmpViewHash}'].deleteDynamicTableRow(${pGroupIndex},'${pRowKey}')">del</a> <a href="#/" onClick="_Pict.views['${tmpViewHash}'].moveDynamicTableRowUp(${pGroupIndex},'${pRowKey}')">up</a> <a href="#/" onClick="_Pict.views['${tmpViewHash}'].moveDynamicTableRowDown(${pGroupIndex},'${pRowKey}')">down</a></td>`;
	}

	_escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	/**
	 * Normalize a Group.RowSelection / Group.ColumnSelection config value.
	 *
	 * Accepts `true` (use all defaults) or an object
	 * `{ Enabled, DataAddress, HighlightClass, HeaderLabel }`. Returns null when
	 * selection is not enabled.
	 *
	 * - `DataAddress` — address (relative to the form's marshal destination) where
	 *   the boolean selection array is stored, so it persists with the form data.
	 * - `HighlightClass` — class auto-applied to selected rows/columns. Set to an
	 *   empty string to make selection purely data-driven (solver-applied only).
	 * - `HeaderLabel` — text for the selection column's header cell.
	 *
	 * @param {boolean|Object} pConfigValue
	 * @param {string} pDefaultDataAddress
	 * @param {string} pDefaultHighlightClass
	 * @returns {{DataAddress: string, HighlightClass: string, HeaderLabel: string}|null}
	 */
	_normalizeSelectionConfig(pConfigValue, pDefaultDataAddress, pDefaultHighlightClass)
	{
		if (pConfigValue !== true && (typeof pConfigValue !== 'object' || pConfigValue === null))
		{
			return null;
		}
		let tmpConfig = (typeof pConfigValue === 'object') ? pConfigValue : {};
		if (tmpConfig.Enabled === false)
		{
			return null;
		}
		return {
			DataAddress: (typeof tmpConfig.DataAddress === 'string' && tmpConfig.DataAddress.length > 0)
				? tmpConfig.DataAddress
				: pDefaultDataAddress,
			HighlightClass: ('HighlightClass' in tmpConfig)
				? (tmpConfig.HighlightClass || '')
				: pDefaultHighlightClass,
			HeaderLabel: (typeof tmpConfig.HeaderLabel === 'string') ? tmpConfig.HeaderLabel : ''
		};
	}

	/**
	 * The absolute address (within the form's marshal destination) of a selection
	 * config's boolean array.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @returns {string}
	 */
	_getTabularSelectionAddress(pView, pSelectionConfig)
	{
		return `${pView.getMarshalDestinationAddress()}.${pSelectionConfig.DataAddress}`;
	}

	/**
	 * Reads the boolean selection array for a row/column selection config.
	 * Always returns an array (empty when nothing has been selected yet).
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @returns {Array<boolean>}
	 */
	_getTabularSelectionArray(pView, pSelectionConfig)
	{
		let tmpValue = this.pict.resolveStateFromAddress(this._getTabularSelectionAddress(pView, pSelectionConfig));
		return Array.isArray(tmpValue) ? tmpValue : [];
	}

	/**
	 * Sets one flag in a selection array and writes it back into the form data.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @param {number|string} pIndex
	 * @param {boolean} pSelected
	 * @returns {Array<boolean>}
	 */
	_setTabularSelectionFlag(pView, pSelectionConfig, pIndex, pSelected)
	{
		let tmpArray = this._getTabularSelectionArray(pView, pSelectionConfig);
		let tmpIndex = Number(pIndex);
		if (!isNaN(tmpIndex) && tmpIndex >= 0)
		{
			tmpArray[tmpIndex] = !!pSelected;
		}
		this.pict.setStateValueAtAddress(this._getTabularSelectionAddress(pView, pSelectionConfig), null, tmpArray);
		return tmpArray;
	}

	/**
	 * Inline-handler entry point: toggles a row's selection state. Called by the
	 * checkbox rendered in the row-selection column. Writes the new state into the
	 * form data, optionally applies the highlight class, then re-solves so any
	 * user solvers that read the selection state can react.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @param {boolean} pChecked
	 * @returns {boolean}
	 */
	toggleTabularRowSelection(pViewHash, pGroupIndex, pRowKey, pChecked)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !tmpGroup._RowSelectionConfig)
		{
			return false;
		}
		this._setTabularSelectionFlag(tmpView, tmpGroup._RowSelectionConfig, pRowKey, pChecked);
		if (tmpGroup._RowSelectionConfig.HighlightClass && this.pict.providers.DynamicFormSolverBehaviors)
		{
			this.pict.providers.DynamicFormSolverBehaviors.highlightTabularRow(
				tmpView.sectionDefinition.Hash, tmpGroup.Hash, pRowKey, pChecked ? 1 : 0, tmpGroup._RowSelectionConfig.HighlightClass);
		}
		this.pict.PictApplication.solve();
		return true;
	}

	/**
	 * Inline-handler entry point: toggles a column's selection state. Called by the
	 * checkbox rendered in the column-selection header row.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex
	 * @param {boolean} pChecked
	 * @returns {boolean}
	 */
	toggleTabularColumnSelection(pViewHash, pGroupIndex, pColumnIndex, pChecked)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !tmpGroup._ColumnSelectionConfig)
		{
			return false;
		}
		this._setTabularSelectionFlag(tmpView, tmpGroup._ColumnSelectionConfig, pColumnIndex, pChecked);
		if (tmpGroup._ColumnSelectionConfig.HighlightClass && this.pict.providers.DynamicFormSolverBehaviors)
		{
			this.pict.providers.DynamicFormSolverBehaviors.highlightTabularColumn(
				tmpView.sectionDefinition.Hash, tmpGroup.Hash, pColumnIndex, pChecked ? 1 : 0, tmpGroup._ColumnSelectionConfig.HighlightClass);
		}
		this.pict.PictApplication.solve();
		return true;
	}

	/**
	 * Re-applies selection highlight classes from the stored selection arrays.
	 * Run after a (re)render rebuilds the table DOM and the classes would
	 * otherwise be lost. No-op when no highlight class is configured.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_reapplyTabularSelectionHighlights(pView, pGroup)
	{
		let tmpBehaviors = this.pict.providers.DynamicFormSolverBehaviors;
		if (!tmpBehaviors || !pView.sectionDefinition)
		{
			return;
		}
		let tmpSectionHash = pView.sectionDefinition.Hash;
		if (pGroup._RowSelectionConfig && pGroup._RowSelectionConfig.HighlightClass)
		{
			let tmpRows = this._getTabularSelectionArray(pView, pGroup._RowSelectionConfig);
			for (let i = 0; i < tmpRows.length; i++)
			{
				tmpBehaviors.highlightTabularRow(tmpSectionHash, pGroup.Hash, i, tmpRows[i] ? 1 : 0, pGroup._RowSelectionConfig.HighlightClass);
			}
		}
		if (pGroup._ColumnSelectionConfig && pGroup._ColumnSelectionConfig.HighlightClass)
		{
			let tmpColumns = this._getTabularSelectionArray(pView, pGroup._ColumnSelectionConfig);
			for (let i = 0; i < tmpColumns.length; i++)
			{
				tmpBehaviors.highlightTabularColumn(tmpSectionHash, pGroup.Hash, i, tmpColumns[i] ? 1 : 0, pGroup._ColumnSelectionConfig.HighlightClass);
			}
		}
	}

	/**
	 * Normalize a Group.ColumnChooser config value.
	 *
	 * Accepts `true` (use all defaults) or an object
	 * `{ Enabled, DataAddress, ButtonLabel, DefaultHiddenColumns }`. Returns null
	 * when the chooser is not enabled (the feature is strictly opt-in).
	 *
	 * - `DataAddress` — address (relative to the form's marshal destination) where
	 *   the array of hidden column hashes is stored, so it persists with the form data.
	 * - `ButtonLabel` — text for the trigger button above the table.
	 * - `DefaultHiddenColumns` — column hashes hidden until the user changes them
	 *   (merged with any descriptor-level `PictForm.TabularDefaultHidden` flags).
	 *
	 * @param {boolean|Object} pConfigValue
	 * @param {string} pDefaultDataAddress
	 * @returns {{DataAddress: string, ButtonLabel: string, DefaultHiddenColumns: Array<string>}|null}
	 */
	_normalizeColumnChooserConfig(pConfigValue, pDefaultDataAddress)
	{
		if (pConfigValue !== true && (typeof pConfigValue !== 'object' || pConfigValue === null))
		{
			return null;
		}
		let tmpConfig = (typeof pConfigValue === 'object') ? pConfigValue : {};
		if (tmpConfig.Enabled === false)
		{
			return null;
		}
		return {
			DataAddress: (typeof tmpConfig.DataAddress === 'string' && tmpConfig.DataAddress.length > 0)
				? tmpConfig.DataAddress
				: pDefaultDataAddress,
			ButtonLabel: (typeof tmpConfig.ButtonLabel === 'string' && tmpConfig.ButtonLabel.length > 0)
				? tmpConfig.ButtonLabel
				: 'Columns',
			DefaultHiddenColumns: Array.isArray(tmpConfig.DefaultHiddenColumns)
				? tmpConfig.DefaultHiddenColumns.map((pHash) => String(pHash))
				: []
		};
	}

	/**
	 * Lazily normalize (and cache on the group) the ColumnChooser config. The
	 * template bake re-normalizes each pass; this accessor covers code paths
	 * (marshal hooks, inline handlers) that may run against a group whose
	 * template hasn't been baked yet.
	 *
	 * @param {Object} pGroup
	 * @returns {{DataAddress: string, ButtonLabel: string, DefaultHiddenColumns: Array<string>}|null}
	 */
	_ensureTabularColumnChooserConfig(pGroup)
	{
		if (pGroup._ColumnChooserConfig === undefined)
		{
			pGroup._ColumnChooserConfig = this._normalizeColumnChooserConfig(pGroup.ColumnChooser, `${pGroup.Hash}_HiddenColumns`);
		}
		return pGroup._ColumnChooserConfig;
	}

	/**
	 * The absolute address (within the form's marshal destination) of the
	 * chooser's hidden-column-hash array.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pChooserConfig
	 * @returns {string}
	 */
	_getTabularHiddenColumnsAddress(pView, pChooserConfig)
	{
		return `${pView.getMarshalDestinationAddress()}.${pChooserConfig.DataAddress}`;
	}

	/**
	 * The set of column hashes hidden BY DEFAULT for a group: the chooser
	 * config's DefaultHiddenColumns plus every descriptor flagged
	 * `PictForm.TabularDefaultHidden`. These apply only until the user changes
	 * column visibility (which writes an explicit array into the form data).
	 *
	 * @param {Object} pGroup
	 * @returns {Array<string>}
	 */
	_getTabularColumnChooserDefaultHidden(pGroup)
	{
		let tmpConfig = pGroup._ColumnChooserConfig;
		if (!tmpConfig)
		{
			return [];
		}
		let tmpDefaultHidden = {};
		for (let i = 0; i < tmpConfig.DefaultHiddenColumns.length; i++)
		{
			tmpDefaultHidden[tmpConfig.DefaultHiddenColumns[i]] = true;
		}
		if (pGroup.supportingManifest && Array.isArray(pGroup.supportingManifest.elementAddresses))
		{
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpHash];
				if (tmpDescriptor && tmpDescriptor.PictForm
					&& !tmpDescriptor.PictForm.TabularHidden
					&& tmpDescriptor.PictForm.TabularDefaultHidden === true)
				{
					tmpDefaultHidden[String(tmpHash)] = true;
				}
			}
		}
		return Object.keys(tmpDefaultHidden);
	}

	/**
	 * The EFFECTIVE set of chooser-hidden column hashes for a group: the array
	 * stored in the form data when the user has made choices, otherwise the
	 * configured defaults. Returns null when the chooser is not enabled, so
	 * callers can use a single falsy check to keep the legacy code path intact.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Set<string>|null}
	 */
	_getTabularColumnChooserHiddenSet(pView, pGroup)
	{
		let tmpConfig = this._ensureTabularColumnChooserConfig(pGroup);
		if (!tmpConfig)
		{
			return null;
		}
		let tmpStored = this.pict.resolveStateFromAddress(this._getTabularHiddenColumnsAddress(pView, tmpConfig));
		let tmpHiddenList = Array.isArray(tmpStored)
			? tmpStored
			: this._getTabularColumnChooserDefaultHidden(pGroup);
		let tmpHiddenSet = new Set();
		for (let i = 0; i < tmpHiddenList.length; i++)
		{
			tmpHiddenSet.add(String(tmpHiddenList[i]));
		}
		return tmpHiddenSet;
	}

	/**
	 * A canonical string for the group's effective hidden-column set, used to
	 * detect (on marshal) that loaded form data carries different column
	 * visibility than the table template was baked with.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {string}
	 */
	_getTabularColumnChooserStateKey(pView, pGroup)
	{
		let tmpHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		if (!tmpHiddenSet)
		{
			return '';
		}
		return Array.from(tmpHiddenSet).sort().join('|');
	}

	/**
	 * The columns the chooser can manage, in manifest order. Statically hidden
	 * descriptors (`PictForm.TabularHidden`) are never choosable and never
	 * listed. Each entry carries the descriptor's manifest index so inline
	 * handlers can address it without string-escaping concerns.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Array<{Key: string, Name: string, ColumnIndex: number, Visible: boolean}>}
	 */
	_getTabularChoosableColumns(pView, pGroup)
	{
		let tmpColumns = [];
		if (!pGroup.supportingManifest || !Array.isArray(pGroup.supportingManifest.elementAddresses))
		{
			return tmpColumns;
		}
		let tmpHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpHash = String(pGroup.supportingManifest.elementAddresses[k]);
			let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpHash];
			if (!tmpDescriptor || (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden))
			{
				continue;
			}
			tmpColumns.push(
				{
					Key: tmpHash,
					Name: (tmpDescriptor.Name != null && String(tmpDescriptor.Name).length > 0) ? String(tmpDescriptor.Name) : tmpHash,
					ColumnIndex: k,
					Visible: !(tmpHiddenSet && tmpHiddenSet.has(tmpHash))
				});
		}
		return tmpColumns;
	}

	/**
	 * DOM element id for one of the chooser's baked elements (TRIGGER / POPOVER),
	 * namespaced by form and group so multiple tabular groups can each carry
	 * their own chooser.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {string} pElement
	 * @returns {string}
	 */
	_getTabularColumnChooserElementId(pView, pGroup, pElement)
	{
		return `PICTFORM-COLCHOOSER-${pElement}-${pView.formID}-${pGroup.Hash}`;
	}

	/**
	 * Builds the chooser bar baked above the table: a right-aligned trigger
	 * button (with a "n hidden" hint when columns are hidden) plus the empty
	 * popover container the open action renders into.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {string}
	 */
	_buildTabularColumnChooserBarHTML(pView, pGroup)
	{
		let tmpColumns = this._getTabularChoosableColumns(pView, pGroup);
		let tmpHiddenCount = tmpColumns.filter((pColumn) => !pColumn.Visible).length;
		let tmpGlyph = (typeof this.pict.icon === 'function') ? this.pict.icon('Settings') : '';
		let tmpCountHint = (tmpHiddenCount > 0)
			? ` <span class="pict-tabular-colchooser-count">(${tmpHiddenCount} hidden)</span>`
			: '';
		return `<div class="pict-tabular-colchooser-bar">`
			+ `<button type="button" class="pict-tabular-colchooser-trigger" id="${this._getTabularColumnChooserElementId(pView, pGroup, 'TRIGGER')}" `
			+ `title="Choose which columns to show" `
			+ `onclick="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnChooser('${pView.Hash}', ${pGroup.GroupIndex})">`
			+ `${tmpGlyph} ${this._escapeHTML(pGroup._ColumnChooserConfig.ButtonLabel)}${tmpCountHint}</button>`
			+ `<div class="pict-tabular-colchooser-pop" id="${this._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}"></div>`
			+ `</div>`;
	}

	/**
	 * Renders the chooser popover's content (backdrop + panel of checkbox rows +
	 * reset footer) into its baked container. Runs on open and after each toggle
	 * (the table re-render replaces the popover element, so its content must be
	 * repainted to keep the menu open across toggles).
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_renderTabularColumnChooserPopover(pView, pGroup)
	{
		let tmpColumns = this._getTabularChoosableColumns(pView, pGroup);
		let tmpRowsHTML = '';
		for (let i = 0; i < tmpColumns.length; i++)
		{
			let tmpColumn = tmpColumns[i];
			tmpRowsHTML += `<label class="pict-tabular-colchooser-row">`
				+ `<input type="checkbox"${tmpColumn.Visible ? ' checked="checked"' : ''} `
				+ `onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex}, ${tmpColumn.ColumnIndex}, this.checked)">`
				+ `<span>${this._escapeHTML(tmpColumn.Name)}</span>`
				+ `</label>`;
		}
		let tmpPopoverHTML = `<div class="pict-tabular-colchooser-backdrop" onclick="_Pict.providers['Pict-Layout-Tabular'].closeTabularColumnChooser('${pView.Hash}', ${pGroup.GroupIndex})"></div>`
			+ `<div class="pict-tabular-colchooser-panel">`
			+ `<div class="pict-tabular-colchooser-list">${tmpRowsHTML}</div>`
			+ `<div class="pict-tabular-colchooser-footer">`
			+ `<button type="button" class="pict-tabular-colchooser-reset" onclick="_Pict.providers['Pict-Layout-Tabular'].resetTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex})">Reset to defaults</button>`
			+ `</div>`
			+ `</div>`;
		this.pict.ContentAssignment.assignContent(`#${this._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}`, tmpPopoverHTML);
	}

	/**
	 * Reflect the chooser popover's open/closed state on its container element,
	 * positioning it against the trigger when opening.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {boolean} pOpen
	 */
	_paintTabularColumnChooserOpenState(pView, pGroup, pOpen)
	{
		let tmpPopoverElements = this.pict.ContentAssignment.getElement(`#${this._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}`);
		if (!tmpPopoverElements.length)
		{
			return;
		}
		tmpPopoverElements[0].classList.toggle('open', !!pOpen);
		if (pOpen)
		{
			this._applyTabularColumnChooserAnchor(pView, pGroup, tmpPopoverElements[0]);
		}
		else
		{
			// Bring a portaled popover home on close so a closed chooser never strands a node on <body>.
			this._restoreTabularColumnChooserPopover(pView, pGroup, tmpPopoverElements[0]);
		}
	}

	/**
	 * Anchor the (open) chooser popover to its trigger with the same listener-free strategy as
	 * pict-section-picker: keep it in the DOM and CSS-absolute under the (position:relative) bar --
	 * which rides page scroll for free -- UNLESS a clipping ancestor would cut it, in which case
	 * portal it to <body> and place it in document coords. No scroll/resize handlers: an absolute
	 * (not fixed) panel tracks the document as it scrolls, so one placement holds.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {HTMLElement} pPopover
	 */
	_applyTabularColumnChooserAnchor(pView, pGroup, pPopover)
	{
		if (!pPopover || (typeof document === 'undefined') || (typeof window === 'undefined'))
		{
			return;
		}
		let tmpTrigger = document.getElementById(this._getTabularColumnChooserElementId(pView, pGroup, 'TRIGGER'));
		if (!tmpTrigger)
		{
			return;
		}
		// Judge from the trigger (it never moves); a portaled panel has no clipping ancestors, so
		// testing the panel itself would flip-flop.
		if (this._tabularColumnChooserShouldPortal(tmpTrigger, pPopover))
		{
			this._portalTabularColumnChooserPopover(pPopover, tmpTrigger);
		}
		else
		{
			this._restoreTabularColumnChooserPopover(pView, pGroup, pPopover);
		}
	}

	/**
	 * Move the popover to <body> and place it against the trigger in document coords (viewport rect +
	 * scroll), flipping above when the room below is genuinely cramped. Carries the resolved
	 * --theme-color-* tokens across so the panel stays themed off its scoped container.
	 *
	 * @param {HTMLElement} pPopover
	 * @param {HTMLElement} pTrigger
	 */
	_portalTabularColumnChooserPopover(pPopover, pTrigger)
	{
		if (!pPopover || !pTrigger || (typeof document === 'undefined') || (typeof window === 'undefined'))
		{
			return;
		}
		// Adopt this popover onto <body>, sweeping any stale same-id copy a prior re-render left behind.
		this._sweepPortaledColchooserOrphans(pPopover.getAttribute('id'), pPopover);
		if (pPopover.parentElement !== document.body)
		{
			document.body.appendChild(pPopover);
		}
		pPopover.classList.add('pict-tabular-colchooser-pop-portal');
		// Carry the resolved --theme-color-* tokens across: off its scoped container the panel would
		// otherwise fall back to the stylesheet hex defaults. Skip empty reads so a token the host never
		// defined keeps its own var(--token, #hex) fallback (matches pict-section-picker's _portalPop).
		if (typeof window.getComputedStyle === 'function')
		{
			let tmpComputed = window.getComputedStyle(pTrigger);
			_COLCHOOSER_THEME_TOKENS.forEach((pToken) =>
			{
				let tmpValue = tmpComputed.getPropertyValue(pToken);
				if (tmpValue && tmpValue.trim() !== '')
				{
					pPopover.style.setProperty(pToken, tmpValue.trim());
				}
			});
		}
		let tmpPanel = pPopover.querySelector('.pict-tabular-colchooser-panel');
		let tmpRect = pTrigger.getBoundingClientRect();
		let tmpGap = 6;
		let tmpMargin = 8;
		let tmpWidth = pPopover.offsetWidth || 240;
		let tmpViewportHeight = window.innerHeight;
		let tmpViewportWidth = window.innerWidth;
		let tmpSpaceBelow = tmpViewportHeight - tmpRect.bottom - tmpGap - tmpMargin;
		let tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		let tmpBelow = (tmpSpaceBelow >= 220) || (tmpSpaceBelow >= tmpSpaceAbove);
		// Document coords (viewport rect + scroll): absolute against <body>, so the panel rides page
		// scroll with no listener. Right-aligned to the trigger, clamped into the viewport.
		pPopover.style.right = 'auto';
		pPopover.style.bottom = 'auto';
		pPopover.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.right - tmpWidth, tmpViewportWidth - tmpWidth - tmpMargin)) + window.scrollX)}px`;
		if (tmpBelow)
		{
			pPopover.style.top = `${Math.round(tmpRect.bottom + tmpGap + window.scrollY)}px`;
			pPopover.style.transform = '';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceBelow, 420))}px`; }
		}
		else
		{
			pPopover.style.top = `${Math.round(tmpRect.top - tmpGap + window.scrollY)}px`;
			pPopover.style.transform = 'translateY(-100%)';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceAbove, 420))}px`; }
		}
	}

	/**
	 * Re-home a portaled popover into its bar and drop everything the portal wrote. Doubles as the
	 * orphan sweeper: if a re-render already baked a fresh in-bar popover, the portaled one is stale
	 * and gets discarded rather than duplicated.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {HTMLElement} pPopover
	 */
	_restoreTabularColumnChooserPopover(pView, pGroup, pPopover)
	{
		if (!pPopover || (typeof document === 'undefined'))
		{
			return;
		}
		// Discard any OTHER portaled copy of this popover a prior re-render may have left on <body>.
		this._sweepPortaledColchooserOrphans(pPopover.getAttribute('id'), pPopover);
		if (pPopover.parentElement === document.body)
		{
			let tmpTrigger = document.getElementById(this._getTabularColumnChooserElementId(pView, pGroup, 'TRIGGER'));
			let tmpBar = tmpTrigger ? tmpTrigger.parentElement : null;
			let tmpFreshInBar = tmpBar ? tmpBar.querySelector('.pict-tabular-colchooser-pop') : null;
			if (tmpBar && (!tmpFreshInBar || tmpFreshInBar === pPopover))
			{
				// Re-home the popover next to its trigger, inside the bar.
				tmpBar.appendChild(pPopover);
			}
			else
			{
				// A re-render already baked a fresh in-bar popover; this portaled one is a leftover.
				pPopover.remove();
				return;
			}
		}
		pPopover.classList.remove('pict-tabular-colchooser-pop-portal');
		// Clear the inline offsets/transform, or they'd override the stylesheet and strand the panel.
		pPopover.style.top = '';
		pPopover.style.left = '';
		pPopover.style.right = '';
		pPopover.style.bottom = '';
		pPopover.style.transform = '';
		// Drop the copied tokens so back in the bar it inherits them live again.
		_COLCHOOSER_THEME_TOKENS.forEach((pToken) => pPopover.style.removeProperty(pToken));
		let tmpPanel = pPopover.querySelector('.pict-tabular-colchooser-panel');
		if (tmpPanel) { tmpPanel.style.maxHeight = ''; }
	}

	/**
	 * Remove any portaled copies of a chooser popover (matched by element id) that are direct children
	 * of <body>, except the one to keep. Iterates body children so no attribute-selector escaping of
	 * the id is needed, and is scoped by id so it never touches another table's portaled popover.
	 *
	 * @param {string} pElementId
	 * @param {HTMLElement} pKeep
	 */
	_sweepPortaledColchooserOrphans(pElementId, pKeep)
	{
		if (!pElementId || (typeof document === 'undefined') || !document.body)
		{
			return;
		}
		Array.prototype.slice.call(document.body.children).forEach((pNode) =>
		{
			if (pNode !== pKeep && pNode.id === pElementId
				&& pNode.classList && pNode.classList.contains('pict-tabular-colchooser-pop'))
			{
				pNode.remove();
			}
		});
	}

	/**
	 * Portal when ANY clipping ancestor of the trigger would actually cut the popover -- an overflow
	 * ancestor alone isn't enough, but a roomy inner clipper doesn't excuse a tighter one further out.
	 *
	 * @param {HTMLElement} pTrigger
	 * @param {HTMLElement} pPopover
	 * @returns {boolean}
	 */
	_tabularColumnChooserShouldPortal(pTrigger, pPopover)
	{
		let tmpWidth = (pPopover && pPopover.offsetWidth) ? pPopover.offsetWidth : 240;
		let tmpClipper = this._tabularColumnChooserClippingAncestor(pTrigger);
		while (tmpClipper)
		{
			if (this._tabularColumnChooserClipBites(pTrigger, tmpClipper, tmpWidth))
			{
				return true;
			}
			tmpClipper = this._tabularColumnChooserClippingAncestor(tmpClipper);
		}
		return false;
	}

	/**
	 * Nearest ancestor (up to, not including, <body>) with an overflow clip on any axis, or null.
	 * Stops at <body> because the document's own scroll is what the absolute anchoring rides on.
	 *
	 * @param {HTMLElement} pElement
	 * @returns {HTMLElement|null}
	 */
	_tabularColumnChooserClippingAncestor(pElement)
	{
		if ((typeof window === 'undefined') || (typeof window.getComputedStyle !== 'function'))
		{
			return null;
		}
		let tmpNode = pElement ? pElement.parentElement : null;
		while (tmpNode && tmpNode.nodeType === 1 && tmpNode !== document.body)
		{
			let tmpStyle = window.getComputedStyle(tmpNode);
			if (tmpStyle && [ tmpStyle.overflow, tmpStyle.overflowX, tmpStyle.overflowY ].some((pValue) => pValue && pValue !== 'visible'))
			{
				return tmpNode;
			}
			tmpNode = tmpNode.parentElement;
		}
		return null;
	}

	/**
	 * Would the clipper cut the popover if it opened in place? The CSS path opens downward, right-
	 * aligned to the trigger; project that worst-case box (trigger bottom + gap, up to the max height)
	 * and test whether any edge falls outside the clipper. 1px slack avoids a needless portal on a
	 * flush edge.
	 *
	 * @param {HTMLElement} pTrigger
	 * @param {HTMLElement} pClipper
	 * @param {number} pWidth
	 * @returns {boolean}
	 */
	_tabularColumnChooserClipBites(pTrigger, pClipper, pWidth)
	{
		if (!pTrigger || !pClipper || (typeof pTrigger.getBoundingClientRect !== 'function')
			|| (typeof pClipper.getBoundingClientRect !== 'function'))
		{
			return true;
		}
		let tmpTriggerRect = pTrigger.getBoundingClientRect();
		let tmpClipRect = pClipper.getBoundingClientRect();
		let tmpGap = 6;
		let tmpIdeal = 420;
		let tmpSlack = 1;
		let tmpWidthResolved = Math.max(220, pWidth || 220);
		let tmpPanelTop = tmpTriggerRect.bottom + tmpGap;
		let tmpPanelBottom = tmpPanelTop + tmpIdeal;
		let tmpPanelRight = tmpTriggerRect.right;
		let tmpPanelLeft = tmpTriggerRect.right - tmpWidthResolved;
		return (tmpPanelBottom > tmpClipRect.bottom + tmpSlack)
			|| (tmpPanelTop < tmpClipRect.top - tmpSlack)
			|| (tmpPanelLeft < tmpClipRect.left - tmpSlack)
			|| (tmpPanelRight > tmpClipRect.right + tmpSlack);
	}

	/**
	 * Rebuild + re-render a tabular view and re-marshal the form data into it.
	 * Same tail as sortTabularColumn: the rebuild re-bakes the table template
	 * (column set, headers, chooser bar), the render repaints, the marshal
	 * pushes current values back into the freshly built inputs.
	 *
	 * @param {Object} pView
	 */
	_rebuildTabularGroupView(pView)
	{
		pView.rebuildCustomTemplate();
		pView.render();
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			pView.marshalToView();
		}
	}

	/**
	 * Inline-handler entry point: opens/closes a group's column chooser popover
	 * (the trigger button's handler). Open/closed is derived from the popover's
	 * DOM class, not an instance flag — a re-render replaces the popover element
	 * (visually closed), so a flag would go stale and demand a double-click.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @returns {boolean}
	 */
	toggleTabularColumnChooser(pViewHash, pGroupIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !this._ensureTabularColumnChooserConfig(tmpGroup))
		{
			return false;
		}
		let tmpPopoverElements = this.pict.ContentAssignment.getElement(`#${this._getTabularColumnChooserElementId(tmpView, tmpGroup, 'POPOVER')}`);
		if (tmpPopoverElements.length && tmpPopoverElements[0].classList.contains('open'))
		{
			this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, false);
			return true;
		}
		this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
		return true;
	}

	/**
	 * Inline-handler entry point: closes a group's column chooser popover (the
	 * backdrop's handler).
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @returns {boolean}
	 */
	closeTabularColumnChooser(pViewHash, pGroupIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup)
		{
			return false;
		}
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, false);
		return true;
	}

	/**
	 * Inline-handler entry point: shows/hides one column (a chooser checkbox's
	 * handler). Writes the updated hidden-hash array into the form data (so it
	 * persists with a save), rebuilds the table template without the column,
	 * re-renders, re-marshals, then re-opens the popover the re-render closed.
	 *
	 * Hiding never touches the underlying record data — the column's values
	 * stay in the record set and reappear when the column is shown again.
	 *
	 * Refuses to hide the last visible column (the checkbox snaps back).
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex - The column's manifest index (stable within a bake).
	 * @param {boolean} pVisible - true to show the column, false to hide it.
	 * @returns {boolean}
	 */
	toggleTabularColumnVisibility(pViewHash, pGroupIndex, pColumnIndex, pVisible)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup)
		{
			return false;
		}
		let tmpConfig = this._ensureTabularColumnChooserConfig(tmpGroup);
		if (!tmpConfig)
		{
			return false;
		}
		let tmpColumns = this._getTabularChoosableColumns(tmpView, tmpGroup);
		let tmpColumn = tmpColumns.find((pCandidate) => pCandidate.ColumnIndex === Number(pColumnIndex));
		if (!tmpColumn)
		{
			return false;
		}
		let tmpHiddenSet = this._getTabularColumnChooserHiddenSet(tmpView, tmpGroup);
		if (pVisible)
		{
			tmpHiddenSet.delete(tmpColumn.Key);
		}
		else
		{
			let tmpVisibleCount = tmpColumns.filter((pCandidate) => pCandidate.Visible).length;
			if (tmpVisibleCount <= 1 && tmpColumn.Visible)
			{
				this.log.warn(`PICT Form Tabular column chooser on group [${tmpGroup.Hash}] refused to hide the last visible column [${tmpColumn.Key}].`);
				// Repaint the popover so the refused checkbox snaps back to checked.
				this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
				this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
				return false;
			}
			tmpHiddenSet.add(tmpColumn.Key);
		}
		this.pict.setStateValueAtAddress(this._getTabularHiddenColumnsAddress(tmpView, tmpConfig), null, Array.from(tmpHiddenSet));
		this._rebuildTabularGroupView(tmpView);
		// The re-render replaced the popover element (closed); keep the menu open
		// so the user can toggle several columns in one visit.
		this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
		return true;
	}

	/**
	 * Inline-handler entry point: resets a group's column visibility to its
	 * configured defaults (the reset footer button's handler). Writes the
	 * default hidden set into the form data explicitly — the user interacted,
	 * so the state should serialize deterministically with a save.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @returns {boolean}
	 */
	resetTabularColumnVisibility(pViewHash, pGroupIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup)
		{
			return false;
		}
		let tmpConfig = this._ensureTabularColumnChooserConfig(tmpGroup);
		if (!tmpConfig)
		{
			return false;
		}
		this.pict.setStateValueAtAddress(this._getTabularHiddenColumnsAddress(tmpView, tmpConfig), null, this._getTabularColumnChooserDefaultHidden(tmpGroup));
		this._rebuildTabularGroupView(tmpView);
		this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
		return true;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';
		let tmpTemplateSetRecordRowTemplate = '';

		// Read new optional configuration.
		let tmpEditingControlsPosition = (typeof pGroup.EditingControlsPosition === 'string') ? pGroup.EditingControlsPosition : 'right';
		let tmpRowLabels = Array.isArray(pGroup.RowLabels) ? pGroup.RowLabels : [];
		let tmpSuppressDefaultColumnHeaderRow = (pGroup.SuppressDefaultColumnHeaderRow === true);
		// ColumnSorting (off by default): injects a clickable sort-glyph span into every prime header cell.
		let tmpColumnSortingEnabled = (pGroup.ColumnSorting === true);
		if (tmpColumnSortingEnabled && !pGroup._SortState)
		{
			pGroup._SortState = { ColumnIndex: -1, Direction: 'none' };
		}
		// ColumnChooser (off by default): a menu of checkboxes above the table that
		// shows/hides columns, with the hidden set stored in the form data. Normalized
		// BEFORE the headers expand so chooser-hidden columns adjust header spans.
		pGroup._ColumnChooserConfig = this._normalizeColumnChooserConfig(pGroup.ColumnChooser, `${pGroup.Hash}_HiddenColumns`);
		let tmpChooserHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		// Remember what visibility this bake used, so a marshal carrying different
		// (e.g. freshly loaded) state knows to trigger a rebuild.
		pGroup._ColumnChooserBakedStateKey = tmpChooserHiddenSet ? Array.from(tmpChooserHiddenSet).sort().join('|') : '';
		let tmpExpandedHeaders = this._buildExpandedHeadersConfig(pView, pGroup);

		// Stash the structures referenced by the templates below.
		pGroup.ExpandedHeaders = tmpExpandedHeaders;
		pGroup.RowLabelHeaderCells = tmpRowLabels.map((pLabel) =>
			({
				Name: pLabel.Name || '',
				CSSClass: (typeof pLabel.CSSClass === 'string') ? pLabel.CSSClass : ''
			}));

		// Selectable rows / columns. When enabled, a checkbox column / header row is
		// rendered and the boolean selection state is stored in the form data so it
		// persists with a save. Solvers can read that state; selection optionally
		// auto-applies a highlight class.
		pGroup._RowSelectionConfig = this._normalizeSelectionConfig(pGroup.RowSelection, `${pGroup.Hash}_RowSelection`, 'pict-tabular-row-highlight');
		pGroup._ColumnSelectionConfig = this._normalizeSelectionConfig(pGroup.ColumnSelection, `${pGroup.Hash}_ColumnSelection`, 'pict-tabular-column-highlight');
		let tmpRowSelectionEnabled = (pGroup._RowSelectionConfig != null);
		let tmpColumnSelectionEnabled = (pGroup._ColumnSelectionConfig != null);
		let tmpEditingLeft = (tmpEditingControlsPosition === 'left');
		let tmpEditingRight = (tmpEditingControlsPosition === 'right');
		// Leading (non-data) columns that precede the data cells: row-select, row labels, left controls.
		let tmpLeadingColumnCount = (tmpRowSelectionEnabled ? 1 : 0) + tmpRowLabels.length + (tmpEditingLeft ? 1 : 0);

		// When EditingControlsPosition isn't 'right' (the default), the right-side editing-
		// controls slots are suppressed PER GROUP by gating their emission on tmpEditingRight
		// below (the RowHeader-ExtraPostfix parity cell and the per-row Row-ExtraPostfix cell).
		//
		// We must NOT suppress by registering an empty view-specific override here:
		// getViewSpecificTemplateHash() is keyed by the view's formsTemplateSetPrefix, which is
		// shared by EVERY tabular group in the section. A single 'hidden'/'left' group registering
		// the empty override would shadow the default editing-controls template for sibling groups
		// that DO want controls ('right'), deleting their menu column from the DOM entirely. The
		// gate is the group's own EditingControlsPosition, so each group is independent and a
		// view-specific override (if a host registers one) still applies to the groups that emit.

		// The chooser bar sits ABOVE the group's table container (a div can't live
		// inside <table> without the browser foster-parenting it out anyway).
		if (pGroup._ColumnChooserConfig)
		{
			tmpTemplate += this._buildTabularColumnChooserBarHTML(pView, pGroup);
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Header section
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Emit additional header rows (above the default column-name row).
		// Each row gets its own <tr>; leading non-data columns get blank <th>s
		// prepended (and a trailing one for right-side editing controls) for alignment.
		for (let r = 0; r < tmpExpandedHeaders.length; r++)
		{
			let tmpHeaderRow = tmpExpandedHeaders[r];
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderRow-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
			for (let l = 0; l < tmpLeadingColumnCount; l++)
			{
				tmpTemplate += `<th class="pict-row-label-spacer"></th>`;
			}
			for (let c = 0; c < tmpHeaderRow.length; c++)
			{
				let tmpCellAddress = `getGroup("${pGroup.GroupIndex}").ExpandedHeaders.${r}.${c}`;
				tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderCell`, tmpCellAddress);
			}
			if (tmpEditingRight)
			{
				// Parity cell for the right-side editing-controls column. Tag it with the same
				// pict-tabular-editing-controls-header class as the left-controls header (below)
				// so host CSS sizes it like the controls column AND collapses it in lockstep when
				// that column is hidden -- otherwise it lingers as an empty phantom column and the
				// stacked-header rule's bottom border overshoots the data columns.
				tmpTemplate += `<th class="pict-row-label-spacer pict-tabular-editing-controls-header"></th>`;
			}
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderRow-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}

		// Column-selection header row -- a <tr> of checkboxes, one per visible data
		// column, plus leading/trailing spacers to line up with the data columns.
		if (tmpColumnSelectionEnabled)
		{
			let tmpColumnSelectionState = this._getTabularSelectionArray(pView, pGroup._ColumnSelectionConfig);
			let tmpColumnSelectRow = `<tr class="pict-tabular-column-select-row">`;
			for (let l = 0; l < tmpLeadingColumnCount; l++)
			{
				tmpColumnSelectRow += `<th class="pict-row-label-spacer"></th>`;
			}
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpColumnDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
				if (!tmpColumnDescriptor || (tmpColumnDescriptor.PictForm && tmpColumnDescriptor.PictForm.TabularHidden))
				{
					continue;
				}
				if (tmpChooserHiddenSet && tmpChooserHiddenSet.has(String(pGroup.supportingManifest.elementAddresses[k])))
				{
					continue;
				}
				let tmpColumnCheckedAttr = tmpColumnSelectionState[k] ? ' checked="checked"' : '';
				tmpColumnSelectRow += `<th class="pict-tabular-column-select">`
					+ `<input type="checkbox"${tmpColumnCheckedAttr} onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnSelection('${pView.Hash}', ${pGroup.GroupIndex}, ${k}, this.checked)">`
					+ `</th>`;
			}
			if (tmpEditingRight)
			{
				// Parity cell for the right-side editing-controls column (mirrors the extra-header
				// row above) -- collapses with the column via pict-tabular-editing-controls-header.
				tmpColumnSelectRow += `<th class="pict-row-label-spacer pict-tabular-editing-controls-header"></th>`;
			}
			tmpColumnSelectRow += `</tr>`;
			tmpTemplate += tmpColumnSelectRow;
		}

		// Existing ExtraPrefix slot (preserved for host overrides)
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-ExtraPrefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Row-selection header cell.
		if (tmpRowSelectionEnabled)
		{
			tmpTemplate += `<th class="pict-row-label-header pict-tabular-row-select-header">${this._escapeHTML(pGroup._RowSelectionConfig.HeaderLabel)}</th>`;
		}

		// Row label header cells in the default header row.
		for (let l = 0; l < tmpRowLabels.length; l++)
		{
			let tmpLabelHeaderAddress = `getGroup("${pGroup.GroupIndex}").RowLabelHeaderCells.${l}`;
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowLabel-HeaderCell`, tmpLabelHeaderAddress);
		}

		// Header cell matching the left-side editing controls column, if configured.
		if (tmpEditingLeft)
		{
			tmpTemplate += `<th class="pict-row-label-header pict-tabular-editing-controls-header"></th>`;
		}

		// Per-descriptor header cells + the per-descriptor row body template.
		let tmpDataColumnCount = 0;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			// Chooser-hidden columns are skipped at bake time (neither header nor row
			// cells render) but their record data is never touched — showing the
			// column again restores it intact, same invariant as DynamicColumns.
			if (tmpChooserHiddenSet && tmpChooserHiddenSet.has(String(tmpSupportingManifestHash)))
			{
				continue;
			}
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			tmpInput.PictForm.RowIndex = 0;

			if (!tmpSuppressDefaultColumnHeaderRow)
			{
				if (tmpColumnSortingEnabled)
				{
					tmpTemplate += this._buildSortableHeaderCell(pView, pGroup, tmpInput, k);
				}
				else
				{
					tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-HeaderCell`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				}
			}

			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Cell-Prefix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
			let tmpInputType = (('PictForm' in tmpInput) && tmpInput.PictForm.InputType) ? tmpInput.PictForm.InputType : 'Default';
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInputType, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`, pGroup.GroupIndex, k);
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Cell-Postfix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
			tmpDataColumnCount++;
		}

		// Right-side editing-controls header parity cell -- only when this group keeps its
		// controls on the right. Gated per group (matches the extra-header-row parity above).
		if (tmpEditingRight)
		{
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-ExtraPostfix`, `getGroup("${pGroup.GroupIndex}")`);
		}
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// Warn on header alignment mismatches (data-column count must equal each extra-header
		// row's total ColumnSpan).
		for (let r = 0; r < tmpExpandedHeaders.length; r++)
		{
			let tmpSpanTotal = 0;
			for (let c = 0; c < tmpExpandedHeaders[r].length; c++)
			{
				tmpSpanTotal += tmpExpandedHeaders[r][c].ColumnSpan || 1;
			}
			if (tmpSpanTotal !== tmpDataColumnCount)
			{
				this.log.warn(`PICT Form [${pView.UUID}]::[${pView.Hash}] tabular group [${pGroup.Hash}] header row ${r} total ColumnSpan (${tmpSpanTotal}) does not match data column count (${tmpDataColumnCount}). Header will visually misalign.`);
			}
		}

		// Compute initial row label metadata; recomputed on every marshal in onDataMarshalToForm.
		this._computeRowLabelMetadata(pView, pGroup);

		// This is the template by which the tabular template includes the rows.
		// The template recursion here is difficult to envision without drawing it.
		// TODO: Consider making this function available in manyfest in some fashion it seems dope.
		let tmpTemplateSetVirtualRowTemplate = '';
		// Row-Prefix references the per-row MTVS record (not the group) so the <tr>
		// can carry data-tabular-row-index for the highlight/color/selection features.
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-Prefix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-ExtraPrefix`, `Record`);

		// Leading cells: the row-selection checkbox and the row-label columns
		// (both emitted by the {~TRL:~} tag), followed by left-side editing controls.
		if (tmpRowLabels.length > 0 || tmpRowSelectionEnabled)
		{
			tmpTemplateSetVirtualRowTemplate += `{~TRL:${pView.Hash}~}`;
		}
		if (tmpEditingLeft)
		{
			tmpTemplateSetVirtualRowTemplate += `{~TEC:${pView.Hash}~}`;
		}

		tmpTemplateSetVirtualRowTemplate += `\n\n{~T:${pGroup.SectionTabularRowTemplateHash}:Record~}\n`;
		// Right-side editing-controls cell (del/up/down) -- only when this group keeps its
		// controls on the right. Gated per group so a sibling group's 'hidden'/'left' setting
		// can't suppress this group's column. 'left' emits its controls via {~TEC:~} above.
		if (tmpEditingRight)
		{
			tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-ExtraPostfix`, `Record`);
		}
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// This is a custom template expression
		tmpTemplate += `\n\n{~MTVS:${pGroup.SectionTabularRowVirtualTemplateHash}:${pGroup.GroupIndex}:${pView.getMarshalDestinationAddress()}.${pGroup.RecordSetAddress}~}\n`;

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		// Add the TemplateSetTemplate
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowVirtualTemplateHash, tmpTemplateSetVirtualRowTemplate);
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowTemplateHash, tmpTemplateSetRecordRowTemplate);

		return tmpTemplate;
	}

	/**
	 * Called after the tabular group template has been (re)rendered into the DOM.
	 * Re-applies the selection highlight classes from the stored selection arrays so
	 * a freshly rendered table shows its checked rows/columns highlighted without
	 * waiting for a marshal or a solve. The render just rebuilt the row/cell DOM, so
	 * any classes a previous pass applied are gone and must be restored here.
	 *
	 * This is what makes a solve-free load (e.g. a read-only form that must not run
	 * solvers because they can mutate data) show its saved highlights immediately.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {boolean}
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		if (!pGroup)
		{
			return true;
		}
		this._reapplyTabularSelectionHighlights(pView, pGroup);
		return true;
	}

	/**
	 * Called after data is marshaled to the form. Re-runs DynamicColumns
	 * resolution and row-label clustering so additions/removals of source
	 * data flow into the rendered table without manual refresh calls.
	 *
	 * Loop guard: only triggers a template rebuild + re-render when the
	 * desired set of dynamic descriptor hashes ACTUALLY changes from the
	 * cached state, so steady state is a no-op (just a row-label recompute).
	 * A label-only change (same columns, a source row renamed) takes the
	 * lighter render()-only path so the header text re-bakes without a rebuild.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		if (!pGroup)
		{
			return true;
		}
		// Avoid recursion when this hook itself triggers a render -> marshal cycle.
		if (pGroup._RebuildInProgress)
		{
			return true;
		}

		let tmpHasDynamicColumns = Array.isArray(pGroup.DynamicColumns) && pGroup.DynamicColumns.length > 0;
		if (tmpHasDynamicColumns && this.fable.ManifestFactory && typeof this.fable.ManifestFactory._resolveDynamicColumns === 'function')
		{
			let tmpResult = this.fable.ManifestFactory._resolveDynamicColumns(pView, pGroup);
			if (tmpResult && tmpResult.changed)
			{
				pGroup._RebuildInProgress = true;
				try
				{
					pView.rebuildCustomTemplate();
					pView.render();
					// Refill the freshly rebuilt table DOM in this same marshal cycle.
					this._refillAfterDynamicColumnRebuild(pView);
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				// The re-render rebuilt the table DOM -- restore selection highlights.
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
			if (tmpResult && tmpResult.namesChanged)
			{
				// The column SET is unchanged but an existing column's display label was
				// refreshed (e.g. a source row renamed). _resolveDynamicColumns already
				// updated the descriptor Name in place; a render() re-bakes the header
				// labels from it -- no structural template rebuild required.
				pGroup._RebuildInProgress = true;
				try
				{
					pView.render();
					// Same-cycle refill: a label-only re-render still repaints the cell DOM.
					this._refillAfterDynamicColumnRebuild(pView);
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
		}

		// When the chooser's effective hidden-column set differs from the one the
		// current table template was baked with (e.g. the host just loaded saved
		// form data carrying a <GroupHash>_HiddenColumns array), rebuild so the
		// table reflects the loaded visibility. Steady state is a no-op — the
		// bake stamped _ColumnChooserBakedStateKey from the same form data.
		if (this._ensureTabularColumnChooserConfig(pGroup))
		{
			let tmpCurrentStateKey = this._getTabularColumnChooserStateKey(pView, pGroup);
			if (tmpCurrentStateKey !== pGroup._ColumnChooserBakedStateKey)
			{
				pGroup._RebuildInProgress = true;
				try
				{
					pView.rebuildCustomTemplate();
					pView.render();
					// Refill the freshly rebuilt table DOM in this same marshal cycle.
					this._refillAfterDynamicColumnRebuild(pView);
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
		}

		this._computeRowLabelMetadata(pView, pGroup);
		// Keep selection highlights in sync with the (possibly reloaded) selection data.
		this._reapplyTabularSelectionHighlights(pView, pGroup);
		return true;
	}

	/**
	 * After a mid-marshal DynamicColumns rebuild/re-render, the freshly painted table DOM
	 * is empty: the enclosing onMarshalToView already ran its marshalDataToForm BEFORE this
	 * hook re-rendered, so the dynamic cells lost the values that pass had just written and
	 * would only refill on the NEXT marshal -- the "% Passing table blanks on row add/delete
	 * or Source/Name select until another action brings it back" bug. Re-marshal the view's
	 * data into the new DOM here so the cells repopulate within the SAME cycle. This is safe
	 * to call from inside onDataMarshalToForm: marshalDataToForm only writes model values into
	 * the inputs and does NOT itself invoke onDataMarshalToForm, so it cannot recurse here.
	 *
	 * @param {Object} pView
	 */
	_refillAfterDynamicColumnRebuild(pView)
	{
		try
		{
			this.pict.providers.Informary.marshalDataToForm(pView.getMarshalDestinationObject(), pView.formID, pView.sectionManifest);
		}
		catch (pError)
		{
			this.log.error(`Error refilling tabular dynamic-column cells after rebuild: ${pError}`);
		}
	}
}

module.exports = TabularLayout;

},{"../Pict-Provider-DynamicLayout.js":502}],543:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

const libPictSectionTuiGridLayout = require('./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js');

class TuiGridLayout extends libPictSectionGroupLayout
{
	/**
	 * @param {import('pict')} pFable - The Fable instance.
	 * @param {any} [pOptions={}] - The options for the TuiGrid layout.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		this.viewGridConfigurations = {};

		this.viewTuiGrids = {};
		this.viewGridState = {};
	}

	/**
	 * Generates the HTML ID for a TuiGrid group within a specific view.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {string} - The generated HTML ID.
	 */
	getGridHtmlID(pView, pGroup)
	{
		return `View-${pView.UUID}-GroupTuiGrid-${pGroup.GroupIndex}`;
	}

	/**
	 * Returns the HTML ID of the Tui view in the specified group.
	 *
	 * @param {string} pView - The Tui view.
	 * @param {string} pGroup - The group.
	 * @returns {string} - The HTML ID of the Tui view.
	 */
	getViewTuiHtmlID(pView, pGroup)
	{
		return `#${this.getGridHtmlID(pView, pGroup)}`;
	}

	/**
	 * Retrieves the TuiGrid view for a given view and group.
	 *
	 * @param {string} pView - The view name.
	 * @param {string} pGroup - The group name.
	 * @returns {libPictSectionTuiGridLayout} - The TuiGrid view if it exists, otherwise false.
	 */
	getViewGrid(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		if (!this.viewTuiGrids.hasOwnProperty(tmpGridUUID))
		{
			return null;
		}
		return this.viewTuiGrids[tmpGridUUID];
	}

	/**
	 * Creates a TuiGrid view for the specified view and group.
	 *
	 * @param {any} pView - The view object.
	 * @param {any} pGroup - The group object.
	 * @return {libPictSectionTuiGridLayout} - The created TuiGrid view.
	 */
	createViewTuiGrid(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		if (this.viewTuiGrids.hasOwnProperty(tmpGridUUID))
		{
			// Purely for information for now.
			this.log.info(`Dynamic TuiGrid view [${pView.UUID}]::[${pView.Hash}] is reinitializing a TuiGrid in group ${pGroup.GroupIndex} TuiGrid UUID [${tmpGridUUID}].`);
			// ...we need to clear out the littered tuiGrid views probably.
		}
		// Generate the pict view
		let tmpGridConfiguration = this.getViewTuiConfiguration(pView, pGroup);
		/** @type {libPictSectionTuiGridLayout} */
		let tmpGridView = this.pict.addView(tmpGridUUID, tmpGridConfiguration, libPictSectionTuiGridLayout);
		// Manually initialize the view
		tmpGridView.cachedGridData = this.generateDataRepresentation(pView, pGroup);

		tmpGridView.initialize();

		this.viewTuiGrids[tmpGridUUID] = tmpGridView;
		return tmpGridView;
	}

	/**
	 * Retrieves the TuiGrid configuration for a specific view and group.
	 *
	 * @param {any} pView - The view identifier.
	 * @param {any} pGroup - The group identifier.
	 * @returns {object} - The TuiGrid configuration for the specified view and group.
	 */
	getViewTuiConfiguration(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		// If there isn't yet a tui configuration, make a new one.
		if (!this.viewGridConfigurations.hasOwnProperty(tmpGridUUID))
		{
			// Generate a unique destination for the TuiGrid
			let tmpGroupTuiGridConfiguration = JSON.parse(JSON.stringify(libPictSectionTuiGridLayout.default_configuration));
			this.viewGridConfigurations[tmpGridUUID] = tmpGroupTuiGridConfiguration;

			tmpGroupTuiGridConfiguration.DefaultDestinationAddress = this.getViewTuiHtmlID(pView, pGroup);
			tmpGroupTuiGridConfiguration.TargetElementAddress = this.getViewTuiHtmlID(pView, pGroup);
			tmpGroupTuiGridConfiguration.TuiColumnSchema = [];
			/*
				{
					"header": "IDRecord",
					"name": "idrecord",
					"PictTriggerSolveOnChange": true
				},
				{
					"header": "Description",
					"name": "description",
					"editor": "text"
				}
			*/

			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
				// Update the InputIndex to match the current render config
				if (!('PictForm' in tmpInput))
				{
					tmpInput.PictForm = {};
				}
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = 0;

				let tmpTuiGridInput = {
					"header": tmpInput.Name,
					"name": tmpInput.Hash,
					// TODO: Should these all trigger solves?  Seems pretty expensive?
					"PictTriggerSolveOnChange": true,
					"PictSectionFormInput": tmpInput
				};
				switch (tmpInput.DataType)
				{
					case 'Number':
					case 'PreciseNumber':
						tmpTuiGridInput.editor = (
							{
								"type": "EditorNumber",
								"options": {}
							});
						tmpTuiGridInput.editor.options.decimalPrecision = tmpInput?.PictForm?.DecimalPrecision ?? 10;
						break;
					case 'String':
						tmpTuiGridInput.editor = 'text';
						break;
					case 'DateTime':
						tmpTuiGridInput.editor = {
							type: 'datePicker',
							options: {
								format: 'yyyy-MM-dd'
							}
						};
						break;
				}
				switch (tmpInput.PictForm.InputType)
				{
					case 'Option':
					{
						tmpTuiGridInput.editor = (
							{
								"type": "select",
								"options": {
									"listItems": []
								}
							});
						let tmpDefaultData = tmpInput.PictForm.SelectOptions;
						if (tmpInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pView.Hash, tmpInput.PictForm.SelectOptionsPickList))
						{
							tmpDefaultData = this.pict.providers.DynamicMetaLists.getList(pView.Hash, tmpInput.PictForm.SelectOptionsPickList);
						}
						if (tmpDefaultData && Array.isArray(tmpDefaultData))
						{
							for (let i = 0; i < tmpDefaultData.length; i++)
							{
								let tmpOption = (
									{
										"value": tmpDefaultData[i].id,
										"text": tmpDefaultData[i].text
									});
								tmpTuiGridInput.editor.options.listItems.push(tmpOption);
							}
						}
						break;
					}
				}
				tmpGroupTuiGridConfiguration.TuiColumnSchema.push(tmpTuiGridInput);
			}
		}

		return this.viewGridConfigurations[tmpGridUUID];
	}

	/**
	 * Generate a group layout template for a TuiGrid dynamically generated group view.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		pGroup.TuiGridHTMLID = this.getGridHtmlID(pView, pGroup);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TuiGrid-Container`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TuiGrid-Controls`, `getGroup("${pGroup.GroupIndex}")`);
		//tmpTemplate += `<div id="${this.getGridHtmlID(pView, pGroup)}"></div>`;
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}

	/**
	 * Generates a data representation for the given view and group.
	 *
	 * @param {any} pView - The view object.
	 * @param {any} pGroup - The group object.
	 * @returns {Array<any>} - The generated data representation.
	 */
	generateDataRepresentation(pView, pGroup)
	{
		let tmpData = [];
		this.viewGridState[this.getGridHtmlID(pView, pGroup)] = tmpData;

		let tmpTabularRecordSet = pView.getTabularRecordSet(pGroup.GroupIndex);

		if (Array.isArray(tmpTabularRecordSet))
		{
			for (let j = 0; j < tmpTabularRecordSet.length; j++)
			{
				let tmpTuiRowData = { RecordIndex: j };
				let tmpTabularRecord = tmpTabularRecordSet[j];
				for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
				{
					let tmpElementDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
					if (tmpElementDescriptor)
					{
						pGroup.supportingManifest.setValueAtAddress(tmpTuiRowData, tmpElementDescriptor.Hash, pGroup.supportingManifest.getValueByHash(tmpTabularRecord, tmpElementDescriptor.Hash));
					}
				}
				tmpData.push(tmpTuiRowData);
			}
		}
		return tmpData;
	}

	/**
	 * Initialize the TuiGrid!
	 *
	 * @param {any} pView  - The view to initialize the newly rendered control for
	 * @param {any} pGroup - The group to initialize the newly rendered control for
	 * @returns {boolean} - Returns true if the initialization is successful, false otherwise.
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		// We do this at the last minute to avoid extraneous creation of these.
		let tmpTuiGridView = this.createViewTuiGrid(pView, pGroup);

		// TODO: Guard?
		tmpTuiGridView.render();

		if (tmpTuiGridView.tuiGrid)
		{
			//FIXME: masking the type from the underlying tui-grid so we can decorate it here
			//       would be better to decorate the type from the upstream package.
			/** @type {any} */
			const tmpControl = tmpTuiGridView.tuiGrid;
			tmpControl.View = pView;
			tmpControl.Group = pGroup;
		}

		return true;
	}

	/**
	 * Marshals data from a view to a form in the TuiGrid layout.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {boolean} - Returns true if the data marshaling is successful, false otherwise.
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		let tmpTuiGridView = this.getViewGrid(pView, pGroup);

		if (!tmpTuiGridView)
		{
			this.log.error(`PICT Form TuiGrid [${pView.UUID}]::[${pView.Hash}] error marshalling data to form: missing TuiGrid for group ${pGroup.GroupIndex}; skipping marshal.`);
			return false;
		}

		// painstakingly compare each value for now.
		let tmpTabularRecordSet = pView.getTabularRecordSet(pGroup.GroupIndex);
		let tmpBrowserRecordSet = tmpTuiGridView.tuiGrid.getData();

		if (Array.isArray(tmpTabularRecordSet))
		{
			for (let j = 0; j < tmpTabularRecordSet.length; j++)
			{
				try
				{
					let tmpStoredRowData = tmpTabularRecordSet[j];
					// Get the tuigrid row that represents AppData
					let tmpBrowserRowData = tmpBrowserRecordSet[j];
					// Enumerate each entry in the manifest and see if changes happened
					for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
					{
						let tmpElementDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
						if (tmpElementDescriptor)
						{
							let tmpBrowserValue = pGroup.supportingManifest.getValueAtAddress(tmpBrowserRowData, tmpElementDescriptor.Hash);
							let tmpAppStateValue = pGroup.supportingManifest.getValueByHash(tmpStoredRowData, tmpElementDescriptor.Hash);
							if (tmpBrowserValue !== tmpAppStateValue)
							{
								this.log.trace(`PICT Form TuiGrid Dynamic View [${pView.UUID}]::[${pView.Hash}] updating tabular record ${j} element ${tmpElementDescriptor.Hash} from [${tmpBrowserValue}] to [${tmpAppStateValue}].`);
								tmpTuiGridView.tuiGrid.setValue(j, tmpElementDescriptor.Hash, tmpAppStateValue);
							}
						}
					}
				}
				catch (pError)
				{
					this.log.error(`PICT Form TuiGrid [${pView.UUID}]::[${pView.Hash}] gross error marshalling data to form: ${pError}`);
				}
			}
		}

		return true;
	}

	/**
	 * Adds a new row to the Pict-Layout-TuiGrid.
	 *
	 * @param {string} pViewHash - The hash of the PICT form view.
	 * @param {number} pGroupIndex - The index of the group in the view.
	 * @returns {boolean} Returns false if there is an error adding the row, otherwise returns true.
	 */
	addRow(pViewHash, pGroupIndex)
	{
		if (!(pViewHash in this.pict.views))
		{
			this.log.error(`PICT Form View [${pViewHash}] error adding row: no matching view found in pict.`);
			return false;
		}
		let tmpView = this.pict.views[pViewHash];
		let tmpGroup = tmpView.getGroup(pGroupIndex);
		if (!tmpGroup)
		{
			this.log.error(`PICT Form View [${pViewHash}] error adding row: no matching group index ${pGroupIndex} found in view.`);
			return false;
		}

		let tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		let tmpNewObject = tmpGroup.supportingManifest.populateDefaults({});

		if (Array.isArray(tmpDestinationObject))
		{
			tmpDestinationObject.push(tmpNewObject);
		}
		else if (typeof(tmpDestinationObject) === 'object')
		{
			let tmpRowIndex = tmpView.fable.getUUID();
			tmpDestinationObject[tmpRowIndex] = tmpNewObject;
		}

		// Add it to the TUIGrid
		let tmpTuiGridView = this.getViewGrid(tmpView, tmpGroup);
		if (tmpTuiGridView)
		{
			tmpTuiGridView.tuiGrid.appendRow(JSON.parse(JSON.stringify(tmpNewObject)));
		}
	}
}

module.exports = TuiGridLayout;

},{"../Pict-Provider-DynamicLayout.js":502,"./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js":544}],544:[function(require,module,exports){
const libPictSectionTuiGrid = require('pict-section-tuigrid');

/**
 * TuiGridLayout class represents a layout for TuiGrid in the Pict-Layout-TuiGrid module.
 * @extends libPictSectionTuiGrid
 */
class TuiGridLayout extends libPictSectionTuiGrid
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.viewGridConfigurations = {};

		this.cachedGridData = [];
	}

	/**
	 * Custom configuration for the grid settings -- fires when
	 *
	 * Sets the grid data to the cached grid data for the tuigrid.
	 *
	 * @returns {any} The result of the super.customConfigureGridSettings() method.
	 */
	customConfigureGridSettings()
	{
		// Set the grid data to the cached grid data
		this.gridSettings.data = this.cachedGridData;
		return super.customConfigureGridSettings();
	}

	/**
	 * Handles the change event in the Pict-Section-TuiGrid component.
	 *
	 * Updates the state in the model based on the grid changes.  This is
	 *
	 * @param {Object} pChangeData - The change data object.
	 * @returns {any} - The result of the super changeHandler method.
	 */
	changeHandler(pChangeData)
	{
		// Update the state in our model based on the grid

		for (let i = 0; i < pChangeData.changes.length; i++)
		{
			let tmpChange = pChangeData.changes[i];
			let tmpRowIndex = pChangeData.instance.getValue(tmpChange.rowKey, 'RecordIndex');
			// TODO: Right now each of these calls runs a solve() on the entire form.  This is not ideal.
			pChangeData.instance.View.setDataTabularByHash(pChangeData.instance.Group.GroupIndex, tmpChange.columnName, tmpRowIndex, tmpChange.value);
		}

		return super.changeHandler(pChangeData);
	}
}

module.exports = TuiGridLayout;

},{"pict-section-tuigrid":683}],545:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class VerticalRecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		if (!('Rows' in pGroup))
		{
			pGroup.Rows = [];
		}

		pGroup.Rows.sort((rowA, rowB) =>
		{
			if (rowA.RowNumber && rowB.RowNumber)
			{
				return rowA.RowNumber >= rowB.RowNumber ? 1 : -1;
			}
			if (!rowA.RowNumber && !rowB.RowNumber)
			{
				return rowA.Hash >= rowB.Hash ? 1 : -1;
			}
			return rowA.RowNumber ? 1 : -1;
		});

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		// Every input has its own "row" in the vertical layout
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-VerticalRow-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			let tmpRow = pGroup.Rows[j];
			// There are three row layouts: Record, Tabular and Columnar
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{	
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;

				tmpTemplate += tmpMetatemplateGenerator.getVerticalInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}
		}

		// Close every input that has its own "row" in the vertical layout
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-VerticalRow-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = VerticalRecordLayout;

},{"../Pict-Provider-DynamicLayout.js":502}],546:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class ManifestConversionToCSV extends libFableServiceProviderBase
{
    constructor(pFable, pOptions, pServiceHash)
    {
        super(pFable, pOptions, pServiceHash);

        /** @type {import('pict') & { instantiateServiceProviderWithoutRegistration: (hash: string, options?: any, uuid?: string) => any }} */
        this.fable;
        /** @type {any} */
        this.log;
        /** @type {string} */
        this.UUID;

        this.CSV_HEADER = [
            "Form",
            "Form Name",
            "SubManifest",
			"HideTabularEditingControls",
			"GroupRecordSetAddress",
            "DataOnly",
            "Section Name",
            "Section Hash",
            "Group Name",
            "Group Hash",
            "Group Layout",
            "Group CSS",
            "Group Show Title",
            "Row",
            "Width",
            "Minimum Row Count",
            "Maximum Row Count",
            "Input Address",
            "Input Name",
            "Input Hash",
            "Input Extra",
            "Units",
            "DataType",
            "Decimal Precision",
            "InputType",
            "Equation",
            "Equation Ordinal",
            "Default",
            "Description",
            "Tooltip",
            "Input Notes",
            "Entity",
            "EntityColumnFilter",
            "EntityDestination",
            "EntitySingleRecord",
            "TriggerGroup",
            "TriggerAddress",
            "TriggerAllInputs",
            "MarshalEmptyValues",
            "ChartType",
            "ChartLabelsAddress",
            "ChartLabelsSolver",
            "ChartDatasetsAddress",
            "ChartDatasetsLabel",
            "ChartDatasetsSolvers"
        ];

        // Generate the header to column mapping
        this.CSV_COLUMN_MAP = {};
        for (let i = 0; i < this.CSV_HEADER.length; i++)
        {
            let tmpColumnName = this.CSV_HEADER[i];
            this.CSV_COLUMN_MAP[tmpColumnName] = i;
        }
    }

    getRowFromDescriptor(pForm, pDescriptorKey, pDescriptor)
    {
        let tmpRow = new Array(this.CSV_HEADER.length).fill('');

        if ((!pDescriptor) || (typeof(pDescriptor) !== 'object') || !pDescriptorKey || (typeof(pDescriptorKey) !== 'string'))
        {
            return false;
        }

        let tmpPictForm = pDescriptor.PictForm;

        tmpRow[this.CSV_COLUMN_MAP["Form"]] = pForm;
        tmpRow[this.CSV_COLUMN_MAP["Form Name"]] = pDescriptor.FormName || '';
        tmpRow[this.CSV_COLUMN_MAP["SubManifest"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["DataOnly"]] = (typeof(tmpPictForm) === 'undefined') ? '1' : '';
        tmpRow[this.CSV_COLUMN_MAP["Section Name"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Section Hash"]] = (tmpPictForm && tmpPictForm.Section) ? tmpPictForm.Section
														: (pDescriptor.FormSection) ? pDescriptor.FormSection
														: '';
        tmpRow[this.CSV_COLUMN_MAP["Group Name"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group Hash"]] = (tmpPictForm && tmpPictForm.Group) ? tmpPictForm.Group
														: (pDescriptor.FormGroup) ? pDescriptor.FormGroup
														: '';
        tmpRow[this.CSV_COLUMN_MAP["Group Layout"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group CSS"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group Show Title"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Row"]] = (tmpPictForm && tmpPictForm.Row) ? tmpPictForm.Row : '';
        tmpRow[this.CSV_COLUMN_MAP["Width"]] = (tmpPictForm && tmpPictForm.Width) ? tmpPictForm.Width : '';
        tmpRow[this.CSV_COLUMN_MAP["Minimum Row Count"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Maximum Row Count"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Input Address"]] = (pDescriptor.DataAddress) ? pDescriptor.DataAddress : pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Name"]] = pDescriptor.Name || pDescriptor.DataAddress || pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Hash"]] = pDescriptor.Hash || pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Extra"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Units"]] = (tmpPictForm && tmpPictForm.Units) ? tmpPictForm.Units : '';
        tmpRow[this.CSV_COLUMN_MAP["DataType"]] = pDescriptor.DataType || 'String';
        tmpRow[this.CSV_COLUMN_MAP["Decimal Precision"]] = (tmpPictForm && tmpPictForm.DecimalPrecision) ? tmpPictForm.DecimalPrecision : '';
        tmpRow[this.CSV_COLUMN_MAP["InputType"]] = (tmpPictForm && tmpPictForm.InputType) ? tmpPictForm.InputType : '';
        tmpRow[this.CSV_COLUMN_MAP["Equation"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Default"]] = (pDescriptor.Default !== undefined) ? pDescriptor.Default : '';
        tmpRow[this.CSV_COLUMN_MAP["Description"]] = (pDescriptor.Description) ? pDescriptor.Description : '';
        tmpRow[this.CSV_COLUMN_MAP["Tooltip"]] = (tmpPictForm && tmpPictForm.Tooltip) ? tmpPictForm.Tooltip : '';
        tmpRow[this.CSV_COLUMN_MAP["Input Notes"]] = (tmpPictForm && tmpPictForm.SpreadsheetNotes) ? tmpPictForm.SpreadsheetNotes : '';

        tmpRow[this.CSV_COLUMN_MAP["Entity"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntityColumnFilter"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntityDestination"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntitySingleRecord"]] = '';
		/**
		tmpDescriptor.PictForm.EntitiesBundle = [
				{
					"Entity": tmpRecord.Entity,
					"Filter": `FBV~${tmpRecord.EntityColumnFilter}~EQ~{~D:Record.Value~}`,
					"Destination": tmpRecord.EntityDestination,
					// This marshals a single record
					"SingleRecord": tmpRecord.EntitySingleRecord ? true : false
				}
			]
		 */
		if (tmpPictForm && tmpPictForm.EntitiesBundle && Array.isArray(tmpPictForm.EntitiesBundle) && tmpPictForm.EntitiesBundle.length > 0)
		{
			let tmpEntityBundle = tmpPictForm.EntitiesBundle[0];
			if (tmpEntityBundle.Entity)
			{
				tmpRow[this.CSV_COLUMN_MAP["Entity"]] = tmpEntityBundle.Entity;
			}
			// Pull the filter column out if we can; we only want what's between "FBV~" and "~EQ~"
			if (tmpEntityBundle.Filter)
			{
				let tmpFilter = tmpEntityBundle.Filter;
				let tmpFilterStart = tmpFilter.indexOf('FBV~');
				let tmpFilterEnd = tmpFilter.indexOf('~EQ~');
				if ((tmpFilterStart >= 0) && (tmpFilterEnd > tmpFilterStart))
				{
					let tmpColumnFilter = tmpFilter.substring(tmpFilterStart + 4, tmpFilterEnd);
					tmpRow[this.CSV_COLUMN_MAP["EntityColumnFilter"]] = tmpColumnFilter;
				}
			}
			if (tmpEntityBundle.Destination)
			{
				tmpRow[this.CSV_COLUMN_MAP["EntityDestination"]] = tmpEntityBundle.Destination;
			}
			if (tmpEntityBundle.SingleRecord)
			{
				tmpRow[this.CSV_COLUMN_MAP["EntitySingleRecord"]] = 'true';
			}
		}

        tmpRow[this.CSV_COLUMN_MAP["TriggerGroup"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["TriggerAddress"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["TriggerAllInputs"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["MarshalEmptyValues"]] = '';
		if (tmpPictForm && tmpPictForm.AutofillTriggerGroup)
		{
			// Grab the first trigger group and put it in here.
			let tmpTriggerGroup;
			if (Array.isArray(tmpPictForm.AutofillTriggerGroup) && tmpPictForm.AutofillTriggerGroup.length > 0)
			{
				tmpTriggerGroup = tmpPictForm.AutofillTriggerGroup[0];
			}
			else if (typeof(tmpPictForm.AutofillTriggerGroup) === 'object')
			{
				tmpTriggerGroup = tmpPictForm.AutofillTriggerGroup;
			}
			if (tmpTriggerGroup)
			{
				if (tmpTriggerGroup.TriggerGroupHash)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerGroup"]] = tmpTriggerGroup.TriggerGroupHash;
				}
				if (tmpTriggerGroup.TriggerAllInputs)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerAllInputs"]] = 'true';
				}
				if (tmpTriggerGroup.TriggerAddress)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerAddress"]] = tmpTriggerGroup.TriggerAddress;
				}
				if (tmpTriggerGroup.MarshalEmptyValues)
				{
					tmpRow[this.CSV_COLUMN_MAP["MarshalEmptyValues"]] = 'true';
				}
			}
		}
        tmpRow[this.CSV_COLUMN_MAP["ChartType"]] = (tmpPictForm && tmpPictForm.ChartType) ? tmpPictForm.ChartType : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartLabelsAddress"]] = (tmpPictForm && tmpPictForm.ChartLabelsAddress) ? tmpPictForm.ChartLabelsAddress : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartLabelsSolver"]] = (tmpPictForm && tmpPictForm.ChartLabelsSolver) ? tmpPictForm.ChartLabelsSolver : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsAddress"]] = (tmpPictForm && tmpPictForm.ChartDatasetsAddress) ? tmpPictForm.ChartDatasetsAddress : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsLabel"]] = (tmpPictForm && tmpPictForm.ChartDatasetsSolvers && Array.isArray(tmpPictForm.ChartDatasetsSolvers) && tmpPictForm.ChartDatasetsSolvers.length > 0) ? tmpPictForm.ChartDatasetsSolvers[0].Label : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsSolvers"]] = (tmpPictForm && tmpPictForm.ChartDatasetsSolvers && Array.isArray(tmpPictForm.ChartDatasetsSolvers) && tmpPictForm.ChartDatasetsSolvers.length > 0) ? tmpPictForm.ChartDatasetsSolvers[0].DataSolver : '';

		if (tmpPictForm && (tmpPictForm.InputType == 'Option') && tmpPictForm.SelectOptions && Array.isArray(tmpPictForm.SelectOptions))
		{
			// Pull the select options into the Input Extra field as a comma-delimited list
			let tmpInputExtraOptions = '';

			for (let i = 0; i < tmpPictForm.SelectOptions.length; i++)
			{
				let tmpOption = tmpPictForm.SelectOptions[i];

				if (tmpOption.id && tmpOption.text)
				{
					if (tmpInputExtraOptions.length > 0)
					{
						tmpInputExtraOptions += ',';
					}
					tmpInputExtraOptions += `${tmpOption.id}^${tmpOption.text}`;
				}
			}

            tmpRow[this.CSV_COLUMN_MAP["Input Extra"]] = tmpInputExtraOptions;
		}

        return tmpRow;
    }

    createTabularArrayFromManifests(pManifest)
    {
        // CSV_COLUMN_MAP is already initialized in constructor

        // Convert the manifest to an array of CSV rows
        let tmpCSVRows = [];

        // Figure out the form
        let tmpForm = 'Default';
        if ((pManifest) && (pManifest.Scope) && (typeof(pManifest.Scope) === 'string'))
        {
            tmpForm = pManifest.Scope;
        }
        if ((pManifest) && (pManifest.Form) && (typeof(pManifest.Form) === 'string'))
        {
            tmpForm = pManifest.Form;
        }

        // Add the header row
        tmpCSVRows.push(this.CSV_HEADER);

        if (typeof(pManifest) !== 'object')
        {
            this.log.error('ManifestConversionToCSV: Provided manifest is not an object; cannot convert to CSV.');
            return tmpCSVRows;
        }

        if (!pManifest.Descriptors || (typeof(pManifest.Descriptors) !== 'object'))
        {
            this.log.error('ManifestConversionToCSV: Provided manifest does not have a valid Descriptors property; cannot convert to CSV.');
            return tmpCSVRows;
        }

        let tmpDescriptorKeys = Object.keys(pManifest.Descriptors);
        for (let i = 0; i < tmpDescriptorKeys.length; i++)
        {
            let tmpDescriptorKey = tmpDescriptorKeys[i];
            let tmpDescriptor = pManifest.Descriptors[tmpDescriptorKey];

            if ((!tmpDescriptor) || (typeof(tmpDescriptor) !== 'object'))
            {
                continue;
            }

            let tmpCSVRow = this.getRowFromDescriptor(tmpForm, tmpDescriptorKey, tmpDescriptor);
            if (tmpCSVRow)
            {
                tmpCSVRows.push(tmpCSVRow);
            }
        }

        for (let i = 0; i < pManifest.Sections.length; i++)
        {
            let tmpSection = pManifest.Sections[i];
            let tmpSectionHash = tmpSection.Hash || 'DEFAULT_SECTION_HASH';

            if ((!tmpSection) || (typeof(tmpSection) !== 'object'))
            {
                continue;
            }

            // See if the group has a name and decorate the manifest entry with the group name
            if (tmpSection.Groups && Array.isArray(tmpSection.Groups))
            {
                for (let j = 0; j < tmpSection.Groups.length; j++)
                {
                    let tmpGroup = tmpSection.Groups[j];
                    let tmpGroupHash = tmpGroup.Hash;

					if ((tmpGroup.Layout == 'Tabular') || (tmpGroup.Layout == 'RecordSet'))
					{
						// Pull in the reference manifest for this tabular set
						/*
							{
								"Name": "Boxes",
								"Hash": "BoxCollGrp",
								"Rows": [],
								"RecordSetSolvers": [
									"BoxFloorspace = BoxWidth * BoxDepth",
									"BoxVolume = BoxFloorspace * BoxHeight"
								],
								"MinimumRowCount": 3,
								"MaximumRowCount": 10,
								"ShowTitle": true,
								"Layout": "Tabular",
								"RecordSetAddress": "Boxes",
								"RecordManifest": "BoxCollectionData"
							}
						*/
			   			// Validate there is a RecordSetAddress and RecordManifest
						if (tmpGroup.RecordSetAddress && tmpGroup.RecordManifest)
						{
							// Find the Array placeholder in the CSV
							let tmpGroupArrayPlaceholderIndex = -1;
							for (let k = 0; k < tmpCSVRows.length; k++)
							{
								let tmpRow = tmpCSVRows[k];
								if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
								{
									let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
									let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
									if ((tmpRowSectionHash === tmpSectionHash) && (tmpRowGroupHash === tmpGroupHash))
									{
										// This is the row for this group
										tmpGroupArrayPlaceholderIndex = k;
										break;
									}

									// Try to match on the Input Address as a fallback
									let tmpRowInputAddress = tmpRow[this.CSV_COLUMN_MAP["Input Address"]];
									if (tmpRowInputAddress === tmpGroup.RecordSetAddress)
									{
										// Set the section and group hash here, this is an old manifest
										tmpRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
										tmpRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;
										tmpGroupArrayPlaceholderIndex = k;
										break;
									}
								}
							}
							if (tmpGroupArrayPlaceholderIndex >= 0)
							{
								let tmpRow = tmpCSVRows[tmpGroupArrayPlaceholderIndex];

								// Set the SubManifest on the placeholder row
								tmpRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;
								tmpRow[this.CSV_COLUMN_MAP["GroupRecordSetAddress"]] = tmpGroup.RecordSetAddress;
								tmpRow[this.CSV_COLUMN_MAP["HideTabularEditingControls"]] = tmpGroup.HideTabularEditingControls;

								// Now set the Minimum and Maximum Row Counts
								if (tmpGroup.MinimumRowCount)
								{
									tmpRow[this.CSV_COLUMN_MAP["Minimum Row Count"]] = tmpGroup.MinimumRowCount;
								}
								if (tmpGroup.MaximumRowCount)
								{
									tmpRow[this.CSV_COLUMN_MAP["Maximum Row Count"]] = tmpGroup.MaximumRowCount;
								}

								// Find the reference manifest, pull in the descriptors, and create rows for each
								let tmpReferenceManifest = pManifest.ReferenceManifests[tmpGroup.RecordManifest];
								let tmpReferenceManifestDescriptorKeys = Object.keys(tmpReferenceManifest.Descriptors);
								for (let m = 0; m < tmpReferenceManifestDescriptorKeys.length; m++)
								{
									let tmpReferenceDescriptorKey = tmpReferenceManifestDescriptorKeys[m];
									let tmpReferenceDescriptor = tmpReferenceManifest.Descriptors[tmpReferenceDescriptorKey];

									if ((!tmpReferenceDescriptor) || (typeof(tmpReferenceDescriptor) !== 'object'))
									{
										continue;
									}

									let tmpReferenceCSVRow = this.getRowFromDescriptor(tmpForm, tmpReferenceDescriptorKey, tmpReferenceDescriptor);
									if (tmpReferenceCSVRow)
									{
										// Set the Section and Group Hashes on this row
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;

										// Set the SubManifest on this row
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;

										// Insert this row after the placeholder
										tmpCSVRows.splice(tmpGroupArrayPlaceholderIndex + 1, 0, tmpReferenceCSVRow);
									}
								}
							}
						}
					}

                    if (tmpGroupHash)
                    {
                        for (let k = 0; k < tmpCSVRows.length; k++)
                        {
                            let tmpRow = tmpCSVRows[k];
                            if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
                            {
                                let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
                                if (tmpRowGroupHash === tmpGroupHash)
                                {
                                    // This is the row for this group
                                    tmpRow[this.CSV_COLUMN_MAP["Group Name"]] = tmpGroup.Name || tmpGroupHash;
									if (tmpGroup.Layout)
									{
										tmpRow[this.CSV_COLUMN_MAP["Group Layout"]] = tmpGroup.Layout;
									}
									if (tmpGroup.hasOwnProperty('ShowTitle'))
									{
										tmpRow[this.CSV_COLUMN_MAP["Group Show Title"]] = tmpGroup.ShowTitle;
									}
									if (tmpGroup.hasOwnProperty('CSSClass'))
									{
										tmpRow[this.CSV_COLUMN_MAP["Group CSS"]] = tmpGroup.CSSClass;
									}
                                }
                            }
                        }
                    }
                }
            }

			// See if there is a section name and decorate the manifest entries with the name
            for (let j = 0; j < tmpCSVRows.length; j++)
            {
                let tmpRow = tmpCSVRows[j];
                if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
                {
                    let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
                    if (tmpRowSectionHash === tmpSectionHash)
                    {
                        // This is the row for this section
                        tmpRow[this.CSV_COLUMN_MAP["Section Name"]] = tmpSection.Name || tmpSectionHash;
                    }
                }
            }

			// Now go through the section and group solvers, and decorate the appropriate rows
			if (tmpSection.Solvers && Array.isArray(tmpSection.Solvers))
			{
				for (let j = 0; j < tmpSection.Solvers.length; j++)
				{
					let tmpSolver = tmpSection.Solvers[j];
					let tmpSolverAssigned = false;

					// find an unused row in this section to decorate
					for (let k = 0; k < tmpCSVRows.length; k++)
					{
						let tmpRow = tmpCSVRows[k];
						if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
						{
							let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
							let tmpRowEquation = tmpRow[this.CSV_COLUMN_MAP["Equation"]];
							let tmpRowSubManifest = tmpRow[this.CSV_COLUMN_MAP["SubManifest"]];
							// If it's in the section
							if ((tmpRowSectionHash === tmpSectionHash)
									// And it isn't a tabular row
									&& (!tmpRowSubManifest || (tmpRowSubManifest == ''))
									// And an equation hasn't been set already
									&& (!tmpRowEquation || (tmpRowEquation.length == 0)))
							{
								// This is an unused row for this section
								if (typeof(tmpSolver) === 'string')
								{
									tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
									tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
								}
								else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
								{
									tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
									tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
								}
								tmpSolverAssigned = true;
								break;
							}
						}
					}
					// If the solver wasn't assigned, we have to create a hidden data only row for it and splice it in
					if (!tmpSolverAssigned)
					{
						let tmpHiddenSolverRow = new Array(this.CSV_HEADER.length).fill('');
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Form"]] = tmpForm;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
						// Set DataOnly
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataOnly"]] = '1';
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataType"]] = 'String';
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["InputType"]] = 'Hidden';
						// Generate an input hash and name that show its for a solver
						let tmpSolverInputHash = `Solver_for_${tmpSectionHash}_${j + 1}`;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Hash"]] = tmpSolverInputHash;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Name"]] = `Auto gen hidden solver entry for ${tmpSection.Name || tmpSectionHash} #${j + 1}`;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Address"]] = tmpSolverInputHash;
						if (typeof(tmpSolver) === 'string')
						{
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
						}
						else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
						{
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
						}
						// Splice this row after the last row for this section
						let tmpLastSectionRowIndex = -1;
						for (let k = 0; k < tmpCSVRows.length; k++)
						{
							let tmpRow = tmpCSVRows[k];
							if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
							{
								let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
								if (tmpRowSectionHash === tmpSectionHash)
								{
									tmpLastSectionRowIndex = k;
								}
							}
						}
						if (tmpLastSectionRowIndex >= 0)
						{
							tmpCSVRows.splice(tmpLastSectionRowIndex + 1, 0, tmpHiddenSolverRow);
						}
						else
						{
							// Just push it on the end
							tmpCSVRows.push(tmpHiddenSolverRow);
						}
					}
				}
			}

			// Lastly enumerate the group solvers
			if (tmpSection.Groups && Array.isArray(tmpSection.Groups))
			{
				for (let j = 0; j < tmpSection.Groups.length; j++)
				{
					let tmpGroup = tmpSection.Groups[j];
					let tmpGroupHash = tmpGroup.Hash;

					if (tmpGroup.RecordSetSolvers && Array.isArray(tmpGroup.RecordSetSolvers))
					{
						for (let m = 0; m < tmpGroup.RecordSetSolvers.length; m++)
						{
							let tmpSolver = tmpGroup.RecordSetSolvers[m];
							let tmpSolverAssigned = false;

							// find an unused row in this group to decorate
							for (let k = 0; k < tmpCSVRows.length; k++)
							{
								let tmpRow = tmpCSVRows[k];
								if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
								{
									let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
									let tmpRowEquation = tmpRow[this.CSV_COLUMN_MAP["Equation"]];
									let tmpRowSubManifest = tmpRow[this.CSV_COLUMN_MAP["SubManifest"]];
									// If it's in the group
									if ((tmpRowGroupHash === tmpGroupHash)
											// And it is a tabular row
											&& (tmpRowSubManifest == tmpGroup.RecordManifest)
											// And an equation hasn't been set already
											&& (!tmpRowEquation || (tmpRowEquation.length == 0)))
									{
										// This is an unused row for this group
										if (typeof(tmpSolver) === 'string')
										{
											tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
											tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
										}
										else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
										{
											tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
											tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
										}
										tmpSolverAssigned = true;
										break;
									}
								}
							}
							// If the solver wasn't assigned, we have to create a hidden data only row for it and splice it in
							if (!tmpSolverAssigned)
							{
								let tmpHiddenSolverRow = new Array(this.CSV_HEADER.length).fill('');
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Form"]] = tmpForm;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;
								// Set the submanifest on the row
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;
								// Set DataOnly
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataOnly"]] = '1';
								// Generate an input hash and name that show its for a solver
								let tmpSolverInputHash = `Solver_for_${tmpGroupHash}_${m + 1}`;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Hash"]] = tmpSolverInputHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Name"]] = `Auto gen hidden solver entry for ${tmpGroup.Name || tmpGroupHash} #${m + 1}`;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Address"]] = tmpSolverInputHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataType"]] = 'String';
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["InputType"]] = 'Hidden';
								if (typeof(tmpSolver) === 'string')
								{
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
								}
								else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
								{
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
								}
								// Splice this row after the last row for this group
								let tmpLastGroupRowIndex = -1;
								for (let k = 0; k < tmpCSVRows.length; k++)
								{
									let tmpRow = tmpCSVRows[k];
									if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
									{
										let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
										if (tmpRowGroupHash === tmpGroupHash)
										{
											tmpLastGroupRowIndex = k;
										}
									}
								}
								if (tmpLastGroupRowIndex >= 0)
								{
									tmpCSVRows.splice(tmpLastGroupRowIndex + 1, 0, tmpHiddenSolverRow);
								}
								else
								{
									// Just push it on the end
									tmpCSVRows.push(tmpHiddenSolverRow);
								}
							}
						}
					}
				}
			}
        }

		if (tmpCSVRows.length > 1)
		{
			// Add the FormName from the root of the manifest to the first row Form Name column
			let tmpFirstDataRow = tmpCSVRows[1];
			if (tmpFirstDataRow && pManifest.FormName)
			{
				tmpFirstDataRow[this.CSV_COLUMN_MAP["Form Name"]] = pManifest.FormName || tmpFirstDataRow[this.CSV_COLUMN_MAP["Form Name"]];
			}
		}

        return tmpCSVRows;
    }
}

module.exports = ManifestConversionToCSV;

},{"fable-serviceproviderbase":398}],547:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _DefaultManifestSettings = (
	{
		Manifest: { Scope: 'Default' }
	});

class ManifestFactory extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultManifestSettings)), pOptions);
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { instantiateServiceProviderWithoutRegistration: (hash: string, options?: any, uuid?: string) => any, newManyfest: () => import('manyfest') }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		this.manifest = tmpOptions.Manifest;

		if (!('Descriptors' in this.manifest))
		{
			this.manifest.Descriptors = {};
		}
		if (!('Sections' in this.manifest))
		{
			this.manifest.Sections = [];
		}
		if (!('ReferenceManifests' in this.manifest))
		{
			this.manifest.ReferenceManifests = {};
		}
		this.referenceManifestFactories = {};

		this.sectionHashLookup = {};
		this.groupHashLookup = {};

		let tmpReferenceManifestKeys = Object.keys(this.manifest.ReferenceManifests);
		for (let i = 0; i < tmpReferenceManifestKeys.length; i++)
		{
			this.referenceManifestFactories[tmpReferenceManifestKeys[i]] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory', this.manifest.ReferenceManifests[tmpReferenceManifestKeys[i]], `${this.UUID}-${tmpReferenceManifestKeys[i]}`);
		}

		// Keep track of a numeric index that's unique to this form, for autogenerating identifiers.
		this.defaultHashCounter = 0;

		this._SanitizeObjectKeyRegex = /[^a-zA-Z0-9_]/gi;
		this._SanitizeObjectKeyReplacement = '_';
		this._SanitizeObjectKeyInvalid = 'INVALID';
	}

	/**
	 * Clean a string of any characters to create a consistent object key.
	 *
	 * @param {string} pString = The string to clean.
	 * @return {string} the cleaned string, or a placeholder if the input is invalid
	 */
	sanitizeObjectKey(pString)
	{
		if (typeof pString !== 'string' || pString.length < 1)
		{
			return this._SanitizeObjectKeyInvalid;
		}
		return pString.replace(this._SanitizeObjectKeyRegex, this._SanitizeObjectKeyReplacement);
	}

	/**
	 * Initialize the form groups.
	 *
	 * This function will initialize the form groups of a view based on the manifest.
	 *
	 * TODO: Figure out if this is the best place for this.  It *is* pretty useful for
	 * inferring manifests, so has uses outside of the view lifecycle.
	 *
	 * @param {Object} pView - The view to initialize form groups for
	 */
	initializeFormGroups(pView)
	{
		// Enumerate the manifest and make sure a group exists for each group in the section definition
		let tmpDescriptorKeys = Object.keys(pView.options.Manifests.Section.Descriptors);
		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			// TODO: Change this to use the parsed sectionManifest rather than parsing the manifest itself
			let tmpDescriptor = pView.options.Manifests.Section.Descriptors[tmpDescriptorKeys[i]];

			if (
				// If there is an obect in the descriptor
				typeof (tmpDescriptor) == 'object' &&
				// AND it has a PictForm property
				('PictForm' in tmpDescriptor) &&
				// AND the PictForm property is an object
				typeof (tmpDescriptor.PictForm) == 'object' &&
				// AND the PictForm object has a Section property
				('Section' in tmpDescriptor.PictForm) &&
				// AND the Section property matches our section hash
				tmpDescriptor.PictForm.Section == pView.sectionDefinition.Hash
			)
			{
				tmpDescriptor.PictForm.InformaryDataAddress = tmpDescriptorKeys[i];

				// Decorate the view hash for reverse lookup
				tmpDescriptor.PictForm.ViewHash = pView.Hash;

				let tmpGroupHash = (typeof (tmpDescriptor.PictForm.Group) == 'string') ? tmpDescriptor.PictForm.Group : 'Default';

				if (!('Groups' in pView.sectionDefinition))
				{
					pView.sectionDefinition.Groups = [];
				}
				let tmpGroup = pView.sectionDefinition.Groups.find((pGroup) => { return pGroup.Hash == tmpGroupHash; });
				if (!tmpGroup)
				{
					tmpGroup = { Hash: tmpGroupHash, Name: tmpGroupHash, Description: false, Rows: [] };
					pView.sectionDefinition.Groups.push(tmpGroup);
				}
				else if (!Array.isArray(tmpGroup.Rows))
				{
					tmpGroup.Rows = [];
				}

				if (Number(tmpDescriptor.PictForm.Row))
				{
					tmpDescriptor.PictForm.Row = Number(tmpDescriptor.PictForm.Row);
				}
				let tmpRowHash = (typeof (tmpDescriptor.PictForm.Row) == 'string') ? tmpDescriptor.PictForm.Row :
					(typeof (tmpDescriptor.PictForm.Row) == 'number') ? `Row_${tmpDescriptor.PictForm.Row.toString()}` :
						'Row_Default';

				tmpDescriptor.PictForm.RowHash = tmpRowHash;

				let tmpRow = tmpGroup.Rows.find((pRow) => { return pRow.Hash == tmpRowHash; });

				if (!tmpRow)
				{
					tmpRow = { Hash: tmpRowHash, Name: tmpRowHash, Inputs: [] };
					if (typeof (tmpDescriptor.PictForm.Row) == 'number')
					{
						tmpRow.RowNumber = tmpDescriptor.PictForm.Row
					}
					tmpGroup.Rows.push(tmpRow);
					tmpRow.Inputs.push(tmpDescriptor);
				}
				else
				{
					tmpRow.Inputs.push(tmpDescriptor);
				}
			}
		}

		// Now check to see if we need to build group
		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];
			tmpGroup.GroupIndex = i;
			if ('HideTitle' in tmpGroup)
			{
				tmpGroup.HideTitle = false;
			}
			if (!tmpGroup.hasOwnProperty('Layout'))
			{
				tmpGroup.Layout = 'Record';
			}
			// Check if the group has a Rows array.
			// TODO: Is no rows valid?  Maaaaaybe?  Layouts makes this compelling.
			if (!tmpGroup.hasOwnProperty('Rows') || !Array.isArray(tmpGroup.Rows))
			{
				tmpGroup.Rows = [];
			}

			// Check if the group has a supporting manifest and load it.
			if ('RecordManifest' in tmpGroup)
			{
				tmpGroup.supportingManifest = pView.fable.instantiateServiceProviderWithoutRegistration('Manifest', pView.options.Manifests.Section.ReferenceManifests[tmpGroup.RecordManifest]);
			}
			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					let tmpInput = tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]];
					tmpInput.IsTabular = true;

					if (!('PictForm' in tmpInput))
					{
						tmpInput.PictForm = {};
					}
					tmpInput.PictForm.ViewHash = pView.Hash;

					tmpInput.PictForm.InformaryDataAddress = tmpSupportingManifestDescriptorKeys[k];
					if (typeof (tmpGroup.RecordSetAddress) == 'string')
					{
						tmpInput.PictForm.InformaryContainerAddress = tmpGroup.RecordSetAddress;
					}
					tmpInput.RowIdentifierTemplateHash = '{~D:Record.RowID~}';
				}

				// Resolve DynamicColumns generators once at init so the supporting manifest
				// is fully populated before the layout template is generated.
				if (Array.isArray(tmpGroup.DynamicColumns) && tmpGroup.DynamicColumns.length > 0)
				{
					this._resolveDynamicColumns(pView, tmpGroup);
				}
			}

			// Check if there is a record set address; initialize it if it doesn't exist
			if (tmpGroup.RecordSetAddress)
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpRecordSetDataObjectExists = pView.sectionManifest.checkAddressExistsByHash(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress);
				let tmpRecordSetDataObject = pView.sectionManifest.getValueAtAddress(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress);
				if (!tmpRecordSetDataObjectExists)
				{
					pView.log.warn(`Automatically setting an empty array at [${tmpGroup.RecordSetAddress}].`);
					pView.sectionManifest.setValueByHash(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress, []);
				}
				else if (Array.isArray(tmpRecordSetDataObject))
				{
					pView.log.trace(`RecordSetAddress is an Array for [${tmpGroup.Hash}]`);
				}
				else if (typeof (tmpRecordSetDataObject) === 'object')
				{
					pView.log.trace(`RecordSetAddress is an Object for [${tmpGroup.Hash}]`);
				}
				else
				{
					pView.log.error(`RecordSetAddress is not an Array or Object for [${tmpGroup.Hash}]; it is a [${typeof (tmpRecordSetDataObject)}] -- likely the data shape will cause erratic problems.`);
				}

				// Check if there are default rows to add
				if (tmpGroup.MinimumRowCount)
				{
					if (!tmpRecordSetDataObject)
					{
						pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress, []);
						tmpRecordSetDataObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
					}
					for (let i = tmpRecordSetDataObject.length; i < tmpGroup.MinimumRowCount; i++)
					{
						pView.pict.providers.DynamicTabularData.createDynamicTableRowWithoutEvents(pView, tmpGroup.GroupIndex);
					}
				}
			}
		}
	}

	/**
	 * Resolve a single template string against a record context.
	 *
	 * @param {string} pTemplate - The template string to resolve.
	 * @param {Object} pRecord - The record context to resolve against.
	 * @returns {string} The resolved string, or '' on failure.
	 */
	_parseDynamicColumnTemplate(pTemplate, pRecord)
	{
		if (typeof pTemplate !== 'string')
		{
			return '';
		}
		if (pTemplate.indexOf('{') === -1)
		{
			return pTemplate;
		}
		try
		{
			let tmpResult = this.fable.parseTemplate(pTemplate, pRecord, null);
			return (typeof tmpResult === 'string') ? tmpResult : '';
		}
		catch (pError)
		{
			this.log.warn(`PICT Form Tabular DynamicColumns template parse failed: ${pError && pError.message}`);
			return '';
		}
	}

	/**
	 * Resolve a Tabular Group's DynamicColumns generators into descriptors on its supportingManifest.
	 *
	 * NON-DESTRUCTIVE: descriptor pruning is structural only -- row record data at
	 * removed InformaryDataAddresses is never touched, so hidden data persists for
	 * later restoration if the source row reappears.
	 *
	 * InformaryDataAddressTemplate is resolved ONCE at descriptor generation time
	 * (Informary itself is a pure string concat at marshal time -- see
	 * Pict-Provider-Informary.getComposedContainerAddress).
	 *
	 * @param {Object} pView - The view containing the group.
	 * @param {Object} pGroup - The group object (must already have supportingManifest).
	 * @returns {{added: Array<string>, removed: Array<string>, unchanged: Array<string>, changed: boolean, namesChanged: boolean}}
	 */
	_resolveDynamicColumns(pView, pGroup)
	{
		let tmpEmpty = { added: [], removed: [], unchanged: [], changed: false, namesChanged: false };
		if (!pGroup || !Array.isArray(pGroup.DynamicColumns) || pGroup.DynamicColumns.length === 0)
		{
			return tmpEmpty;
		}
		if (!pGroup.supportingManifest)
		{
			this.log.warn(`PICT Form Tabular DynamicColumns on group [${pGroup.Hash}] skipped: no supportingManifest.`);
			return tmpEmpty;
		}
		if (!Array.isArray(pGroup.DynamicColumnsState))
		{
			pGroup.DynamicColumnsState = [];
		}

		let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
		let tmpSupportingManifest = pGroup.supportingManifest;

		let tmpAggregateAdded = [];
		let tmpAggregateRemoved = [];
		let tmpAggregateUnchanged = [];
		let tmpAggregateChanged = false;
		let tmpAggregateNamesChanged = false;

		for (let i = 0; i < pGroup.DynamicColumns.length; i++)
		{
			let tmpGenerator = pGroup.DynamicColumns[i];
			if (!pGroup.DynamicColumnsState[i])
			{
				pGroup.DynamicColumnsState[i] = { LastHashes: [], LastHeaderGroups: [] };
			}
			let tmpState = pGroup.DynamicColumnsState[i];

			if (typeof tmpGenerator.SourceAddress !== 'string' || tmpGenerator.SourceAddress.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing SourceAddress.`);
				continue;
			}
			if (typeof tmpGenerator.HashTemplate !== 'string' || tmpGenerator.HashTemplate.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing HashTemplate.`);
				continue;
			}
			if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string' || tmpGenerator.InformaryDataAddressTemplate.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing InformaryDataAddressTemplate.`);
				continue;
			}

			let tmpSourceArray = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpGenerator.SourceAddress);
			if (!Array.isArray(tmpSourceArray))
			{
				tmpSourceArray = [];
			}

			// Build the desired descriptor set from the current source array.
			let tmpDesiredHashes = [];
			let tmpDesiredDescriptors = {};
			let tmpDesiredHeaderGroups = [];
			let tmpSeenHashes = {};
			for (let k = 0; k < tmpSourceArray.length; k++)
			{
				let tmpSourceRow = tmpSourceArray[k];
				// Expose the source-row position to the generator templates WITHOUT mutating the
				// stored row: a shallow copy carries __Index (0-based) and __RowNumber (1-based)
				// alongside the row's own fields. This lets a generator key its columns by
				// POSITION (KeyBy: "Position") -- e.g. HashTemplate "Col_{~D:Record.__Index~}",
				// NameTemplate "Product {~D:Record.__RowNumber~}" -- so adding/removing a source
				// row never collides on a stored identity value (no markers in the saved data).
				let tmpTemplateRecord = (tmpSourceRow && (typeof tmpSourceRow === 'object'))
					? Object.assign({}, tmpSourceRow, { __Index: k, __RowNumber: k + 1 })
					: { Value: tmpSourceRow, __Index: k, __RowNumber: k + 1 };
				let tmpHash = this._parseDynamicColumnTemplate(tmpGenerator.HashTemplate, tmpTemplateRecord);
				if (!tmpHash)
				{
					continue;
				}
				if (tmpSeenHashes[tmpHash])
				{
					this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} produced duplicate Hash [${tmpHash}] on group [${pGroup.Hash}]; later row wins.`);
				}
				tmpSeenHashes[tmpHash] = true;

				let tmpName = tmpGenerator.NameTemplate
					? this._parseDynamicColumnTemplate(tmpGenerator.NameTemplate, tmpTemplateRecord)
					: tmpHash;
				let tmpInformaryDataAddress = this._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, tmpTemplateRecord);
				if (!tmpInformaryDataAddress)
				{
					this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} produced empty InformaryDataAddress for row ${k} on group [${pGroup.Hash}]; skipping.`);
					continue;
				}
				let tmpHeaderGroup = tmpGenerator.HeaderGroupTemplate
					? this._parseDynamicColumnTemplate(tmpGenerator.HeaderGroupTemplate, tmpTemplateRecord)
					: '';

				let tmpDescriptor = {
					Hash: tmpHash,
					Name: tmpName || tmpHash,
					DataType: tmpGenerator.DataType || 'String',
					IsTabular: true,
					_DynamicColumnGeneratorIndex: i,
					_DynamicColumnHeaderGroup: tmpHeaderGroup,
					PictForm: Object.assign({}, tmpGenerator.PictForm || {}, {
						ViewHash: pView.Hash,
						InformaryContainerAddress: pGroup.RecordSetAddress,
						InformaryDataAddress: tmpInformaryDataAddress
					})
				};

				tmpDesiredHashes.push(tmpHash);
				tmpDesiredDescriptors[tmpHash] = tmpDescriptor;
				tmpDesiredHeaderGroups.push(tmpHeaderGroup);
			}

			// Diff against the cached last state.
			let tmpLastHashes = Array.isArray(tmpState.LastHashes) ? tmpState.LastHashes : [];
			let tmpDesiredSet = {};
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				tmpDesiredSet[tmpDesiredHashes[h]] = true;
			}
			let tmpRemoved = tmpLastHashes.filter((pHash) => { return !tmpDesiredSet[pHash]; });
			let tmpLastSet = {};
			for (let h = 0; h < tmpLastHashes.length; h++)
			{
				tmpLastSet[tmpLastHashes[h]] = true;
			}
			let tmpAdded = tmpDesiredHashes.filter((pHash) => { return !tmpLastSet[pHash]; });
			let tmpUnchanged = tmpDesiredHashes.filter((pHash) => { return tmpLastSet[pHash]; });
			let tmpHeaderGroupsChanged = JSON.stringify(tmpDesiredHeaderGroups) !== JSON.stringify(tmpState.LastHeaderGroups || []);
			let tmpOrderChanged = JSON.stringify(tmpDesiredHashes) !== JSON.stringify(tmpLastHashes);

			// Remove dropped descriptors from the supportingManifest entirely.
			for (let r = 0; r < tmpRemoved.length; r++)
			{
				let tmpHashToRemove = tmpRemoved[r];
				let tmpAddrIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpHashToRemove);
				if (tmpAddrIdx >= 0)
				{
					tmpSupportingManifest.elementAddresses.splice(tmpAddrIdx, 1);
				}
				delete tmpSupportingManifest.elementDescriptors[tmpHashToRemove];
				if (tmpSupportingManifest.elementHashes && (tmpHashToRemove in tmpSupportingManifest.elementHashes))
				{
					delete tmpSupportingManifest.elementHashes[tmpHashToRemove];
				}
			}

			// Re-place all descriptors for this generator in the desired order at the InsertAt position.
			// First, pull them out so we can splice them back in as a contiguous block.
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				let tmpAddr = tmpDesiredHashes[h];
				let tmpExistingIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpAddr);
				if (tmpExistingIdx >= 0)
				{
					tmpSupportingManifest.elementAddresses.splice(tmpExistingIdx, 1);
				}
				// Preserve an already-registered descriptor OBJECT rather than swapping in a
				// fresh one. The live descriptor carries the generated Macro (informary HTML
				// bindings) and InputIndex stamped during the last template build. Replacing
				// it with a fresh, Macro-less object silently breaks marshaling on any later
				// render() that is NOT accompanied by a template rebuild -- e.g. moving,
				// adding or deleting a row. Refresh only the data-derived fields in place.
				let tmpExistingDescriptor = tmpSupportingManifest.elementDescriptors[tmpAddr];
				if (tmpExistingDescriptor)
				{
					let tmpFreshDescriptor = tmpDesiredDescriptors[tmpAddr];
					// A column whose hash is UNCHANGED can still have a refreshed display label
					// or header group when the source row's name-driving field is edited (e.g.
					// renaming a product). The structural diff above only tracks the hash SET, so
					// flag a label-only change separately -- the layout uses it to re-bake header
					// text via a render() without a full (and costlier) template rebuild.
					if (tmpExistingDescriptor.Name !== tmpFreshDescriptor.Name
						|| tmpExistingDescriptor._DynamicColumnHeaderGroup !== tmpFreshDescriptor._DynamicColumnHeaderGroup)
					{
						tmpAggregateNamesChanged = true;
					}
					tmpExistingDescriptor.Name = tmpFreshDescriptor.Name;
					tmpExistingDescriptor.DataType = tmpFreshDescriptor.DataType;
					tmpExistingDescriptor.IsTabular = tmpFreshDescriptor.IsTabular;
					tmpExistingDescriptor._DynamicColumnGeneratorIndex = tmpFreshDescriptor._DynamicColumnGeneratorIndex;
					tmpExistingDescriptor._DynamicColumnHeaderGroup = tmpFreshDescriptor._DynamicColumnHeaderGroup;
					if (!tmpExistingDescriptor.PictForm)
					{
						tmpExistingDescriptor.PictForm = {};
					}
					Object.assign(tmpExistingDescriptor.PictForm, tmpFreshDescriptor.PictForm);
					tmpDesiredDescriptors[tmpAddr] = tmpExistingDescriptor;
				}
				else
				{
					tmpSupportingManifest.elementDescriptors[tmpAddr] = tmpDesiredDescriptors[tmpAddr];
				}
				if (!tmpSupportingManifest.elementHashes)
				{
					tmpSupportingManifest.elementHashes = {};
				}
				tmpSupportingManifest.elementHashes[tmpAddr] = tmpAddr;
			}

			// Compute insertion index.
			let tmpInsertAt = tmpGenerator.InsertAt || 'End';
			let tmpInsertionIndex;
			if (tmpInsertAt === 'Start')
			{
				tmpInsertionIndex = 0;
			}
			else if (typeof tmpInsertAt === 'object' && tmpInsertAt !== null && typeof tmpInsertAt.After === 'string')
			{
				let tmpAfterIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpInsertAt.After);
				tmpInsertionIndex = (tmpAfterIdx < 0) ? tmpSupportingManifest.elementAddresses.length : tmpAfterIdx + 1;
			}
			else
			{
				tmpInsertionIndex = tmpSupportingManifest.elementAddresses.length;
			}
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				tmpSupportingManifest.elementAddresses.splice(tmpInsertionIndex + h, 0, tmpDesiredHashes[h]);
			}

			tmpState.LastHashes = tmpDesiredHashes.slice();
			tmpState.LastHeaderGroups = tmpDesiredHeaderGroups.slice();

			if (tmpAdded.length || tmpRemoved.length || tmpHeaderGroupsChanged || tmpOrderChanged)
			{
				tmpAggregateChanged = true;
			}
			tmpAggregateAdded.push.apply(tmpAggregateAdded, tmpAdded);
			tmpAggregateRemoved.push.apply(tmpAggregateRemoved, tmpRemoved);
			tmpAggregateUnchanged.push.apply(tmpAggregateUnchanged, tmpUnchanged);
		}

		return {
			added: tmpAggregateAdded,
			removed: tmpAggregateRemoved,
			unchanged: tmpAggregateUnchanged,
			changed: tmpAggregateChanged,
			namesChanged: tmpAggregateNamesChanged
		};
	}

	/**
	 * Adds a manifest descriptor to the manifest.
	 *
	 * @param {Object} pManifestDescriptor - The manifest descriptor to add.
	 */
	addDescriptor(pManifestDescriptor)
	{
		if (pManifestDescriptor.DataAddress in this.manifest.Descriptors)
		{
			this.log.info('[ERROR] Duplicate descriptor hash found:', pManifestDescriptor);
		}
		this.manifest.Descriptors[pManifestDescriptor.DataAddress] = pManifestDescriptor;
	}

	/**
	 * Get a section from the manifest.
	 *
	 * @param {string} pSectionHash - The section Hash
	 *
	 * @return {Object} The manifest section object
	 */
	getManifestSection(pSectionHash)
	{
		for (const tmpSection of this.manifest.Sections)
		{
			if (tmpSection.Hash === pSectionHash)
			{
				return tmpSection;
			}
		}
		// Add the section if it do no exist
		const tmpSection = { Name: pSectionHash, Hash: pSectionHash, Solvers: [], Groups: [] };
		this.manifest.Sections.push(tmpSection);
		return tmpSection;
	}

	/**
	 * Get a group from a section.
	 *
	 * @param {string|Object} pManifestSection - The manifest Section -- either a Hash string or the object itself
	 * @param {string} pGroupHash - The group Hash
	 *
	 * @return {Object} The group object
	 */
	getManifestGroup(pManifestSection, pGroupHash)
	{
		let tmpManifestSection = (typeof (pManifestSection) === 'string') ? this.getManifestSection(pManifestSection) : pManifestSection;
		for (const tmpGroup of tmpManifestSection.Groups)
		{
			if (tmpGroup.Hash === pGroupHash)
			{
				return tmpGroup;
			}
		}
		// Add the group if it do no exist
		const tmpGroup = { Name: pGroupHash, Hash: pGroupHash, Rows: [], RecordSetSolvers: [] };
		tmpManifestSection.Groups.push(tmpGroup);
		return tmpGroup;
	}

	/**
	 * Lints a manifest record row.
	 * @param {Object} pRecord - The record to be linted.
	 * @returns {boolean} - Returns true if the record is valid, false otherwise.
	 */
	tabularRowLint(pRecord)
	{
		if (!pRecord)
		{
			this.log.error('Record is missing from record:', pRecord);
			return false;
		}
		if (!pRecord.Form)
		{
			this.log.error('Form is missing from record:', pRecord);
			return false;
		}
		return true;
	}

	decorateChartDescriptorFromTabularRow(pRecord, pDescriptor, pPostfix)
	{
		let tmpRecord = pRecord;
		let tmpDescriptor = pDescriptor;
		let tmpPostfix = pPostfix || '';

		// Log out the data coming in
		//this.log.debug(`Decorating chart descriptor from tabular row for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`,{ Record: tmpRecord, Descriptor: tmpDescriptor });

		// Charts will pull in five extra pieces of config if they exist: ChartType, ChartLabelsAddress, ChartLabelsSolver, ChartDatasetsAddress, ChartDatasetsSolver
		if (tmpRecord.ChartType)
		{
			tmpDescriptor.PictForm.ChartType = tmpRecord.ChartType;
		}
		if (tmpPostfix == '')
		{
			// Maybe later this gets more advanced.
			if (tmpRecord.ChartLabelsAddress)
			{
				tmpDescriptor.PictForm.ChartLabelsAddress = tmpRecord.ChartLabelsAddress;
			}
			if (tmpRecord.ChartLabelsSolver)
			{
				tmpDescriptor.PictForm.ChartLabelsSolver = tmpRecord.ChartLabelsSolver;
			}
			if (tmpRecord.ChartDatasetsAddress)
			{
				tmpDescriptor.PictForm.ChartDatasetsAddress = tmpRecord.ChartDatasetsAddress;
			}
		}
		
		if (tmpRecord[`ChartDatasetsSolver${tmpPostfix}`])
		{
			let tmpSolverEntry = { DataSolver: tmpRecord[`ChartDatasetsSolver${tmpPostfix}`] };
			//this.log.debug(`Adding chart dataset solver for descriptor ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpSolverEntry);
			if (!tmpRecord[`ChartDatasetsLabel${tmpPostfix}`])
			{
				tmpSolverEntry.Label = 'Data';
			}
			else
			{
				tmpSolverEntry.Label = tmpRecord[`ChartDatasetsLabel${tmpPostfix}`];
			}
			if (tmpRecord[`ChartDataSetsSolverChartType${tmpPostfix}`])
			{
				tmpSolverEntry.ChartType = tmpRecord[`ChartDataSetsSolverChartType${tmpPostfix}`];
			}
			if (!tmpDescriptor.PictForm.ChartDatasetsSolvers || !Array.isArray(tmpDescriptor.PictForm.ChartDatasetsSolvers))
			{
				tmpDescriptor.PictForm.ChartDatasetsSolvers = [];
			}
			// Log and add the solver entry
			//this.log.debug(`Adding chart dataset solver entry for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpSolverEntry);
			tmpDescriptor.PictForm.ChartDatasetsSolvers.push(tmpSolverEntry);
		}
		// Log the descripter going out
		//this.log.debug(`Decorated chart descriptor from tabular row for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpDescriptor);
	}

	/**
	 * Add a manifest descriptor from a tabular row.
	 *
	 * @param {Object} pManifestFactory - The manifest factory
	 * @param {Object} pRecord - The tabular row record -- expected to have at least a 'Form'
	 *
	 * @return {Object} the descriptor
	 */
	tabularRowAddDescriptor(pManifestFactory, pRecord)
	{
		if (typeof (pRecord) !== 'object')
		{
			this.log.error(`Invalid record passed to addManifestDescriptor: ${pRecord}`);
			return false;
		}

		let tmpRecord = JSON.parse(JSON.stringify(pRecord));

		// Fill out required defaults on the row
		tmpRecord['Input Hash'] = tmpRecord['Input Hash']?.trim?.() || `DefaultHash${this.defaultHashCounter++}`;
		tmpRecord['Input Address'] = tmpRecord['Input Address']?.trim?.() || `DefaultData.InputHash_${tmpRecord['Input Hash']}`;
		tmpRecord['Input Name'] = tmpRecord['Input Name']?.trim?.() || `Auto Input ${tmpRecord['Input Hash']}`;
		tmpRecord.DataType = tmpRecord.DataType?.trim?.() || 'String';

		const tmpDescriptor = (
			{
				Hash: tmpRecord['Input Hash'],
				Name: tmpRecord['Input Name'],
				DataAddress: tmpRecord['Input Address'],
				DataType: tmpRecord.DataType,
				PictForm: {},
			});

		if (tmpRecord.Default)
		{
			tmpDescriptor.Default = tmpRecord.Default;
		}

		// Set the optional settings if they are present on the record
		if (tmpRecord.InputType)
		{
			tmpDescriptor.PictForm.InputType = tmpRecord.InputType;
		}
		if (tmpRecord.Row)
		{
			tmpDescriptor.PictForm.Row = tmpRecord.Row;
		}
		if (tmpRecord.Width)
		{
			tmpDescriptor.PictForm.Width = tmpRecord.Width;
		}

		if (tmpRecord['Input Notes'])
		{
			tmpDescriptor.PictForm.SpreadsheetNotes = tmpRecord['Input Notes'];
		}

		if (tmpRecord['Description'])
		{
			tmpDescriptor.Description = tmpRecord['Description'];
		}

		if (tmpRecord['Units'])
		{
			tmpDescriptor.PictForm.Units = tmpRecord['Units'];
		}

		if (tmpRecord['Tooltip'])
		{
			tmpDescriptor.PictForm.Tooltip = tmpRecord['Tooltip'];
		}

		if ((tmpDescriptor.PictForm.InputType == 'Option') && (tmpRecord['Input Extra']))
		{
			let tmpOptionSet = [];
			let tmpOptionSetValues = tmpRecord['Input Extra'].split(',');

			for (let i = 0; i < tmpOptionSetValues.length; i++)
			{
				if (tmpOptionSetValues[i].trim() != '')
				{
					let tmpOptionSetValuePair = tmpOptionSetValues[i].split('^');
					if (tmpOptionSetValuePair.length == 2)
					{
						tmpOptionSet.push({ id: tmpOptionSetValuePair[0].trim(), text: tmpOptionSetValuePair[1].trim() });
					}
					else
					{
						tmpOptionSet.push({ id: tmpOptionSetValues[i].trim(), text: tmpOptionSetValues[i].trim() });
					}
				}
			}

			if (tmpOptionSet.length > 0)
			{
				tmpDescriptor.PictForm.SelectOptions = tmpOptionSet;
			}
		}

		if (((tmpDescriptor.PictForm.InputType == 'TabSectionSelector') || (tmpDescriptor.PictForm.InputType == 'TabGroupSelector')) && (tmpRecord['Input Extra']))
		{
			let tmpTabSet = [];
			let tmpTabSetNames = [];
			let tmpTabSetConfiguredValues = tmpRecord['Input Extra'].split(',');

			for (let i = 0; i < tmpTabSetConfiguredValues.length; i++)
			{
				if (tmpTabSetConfiguredValues[i].trim() != '')
				{
					let tmpTabSetValuePair = tmpTabSetConfiguredValues[i].split('^');
					if (tmpTabSetValuePair.length >= 2)
					{
						tmpTabSet.push(tmpTabSetValuePair[0].trim());
						tmpTabSetNames.push(tmpTabSetValuePair[1].trim());
					}
					else
					{
						tmpTabSet.push(tmpTabSetValuePair[0].trim());
						tmpTabSetNames.push(tmpTabSetValuePair[0].trim());
					}
				}
			}

			if (tmpTabSet.length > 0)
			{
				if (tmpDescriptor.PictForm.InputType == 'TabSectionSelector')
				{
					tmpDescriptor.PictForm.TabSectionSet = tmpTabSet;
					tmpDescriptor.PictForm.TabSectionNames = tmpTabSetNames;
				}
				else if (tmpDescriptor.PictForm.InputType == 'TabGroupSelector')
				{
					tmpDescriptor.PictForm.TabGroupSet = tmpTabSet;
					tmpDescriptor.PictForm.TabGroupNames = tmpTabSetNames;
				}
			}
		}

		// Verbose obtuse data validation.
		if ((`TriggerGroup` in tmpRecord) && (typeof (tmpRecord.TriggerGroup) === 'string') && (tmpRecord.TriggerGroup != ''))
		{
			if (!Array.isArray(tmpDescriptor.PictForm.Providers))
			{
				tmpDescriptor.PictForm.Providers = [];
			}

			tmpDescriptor.PictForm.Providers.push('Pict-Input-AutofillTriggerGroup');
			if (!Array.isArray(tmpDescriptor.PictForm.AutofillTriggerGroup))
			{
				const tmpPreviousTriggerGroup = tmpDescriptor.PictForm.AutofillTriggerGroup;
				tmpDescriptor.PictForm.AutofillTriggerGroup = [];
				if (tmpPreviousTriggerGroup)
				{
					tmpDescriptor.PictForm.AutofillTriggerGroup.push(tmpPreviousTriggerGroup);
				}
			}
			const tmpTriggerGroupHashes = tmpRecord.TriggerGroup.split(',');
			const tmpTriggerAddresses = (`TriggerAddress` in tmpRecord) ? tmpRecord.TriggerAddress.split(',') : [];
			const tmpTriggerAllInputs = (`TriggerAllInputs` in tmpRecord) ? tmpRecord.TriggerAllInputs.split(',') : [];

			for (let i = 0; i < tmpTriggerGroupHashes.length; i++)
			{
				const tmpTriggerGroup =
				{
					TriggerGroupHash: tmpTriggerGroupHashes[i].trim(),
					MarshalEmptyValues: tmpRecord.MarshalEmptyValues ? true : false,
				};

				const tmpTriggerAddress = tmpTriggerAddresses[i]?.trim?.();
				if (tmpTriggerAddress)
				{
					tmpTriggerGroup.TriggerAddress = tmpTriggerAddress;
				}
				const tmpTriggerAllInput = tmpTriggerAllInputs[i]?.trim?.();
				if (tmpTriggerAllInput != null && (tmpTriggerAllInput.toLowerCase() == 'true' || tmpTriggerAllInput.toLowerCase() == 'x' || tmpTriggerAllInput.toLowerCase() == '1'))
				{
					tmpTriggerGroup.TriggerAllInputs = true;
				}
				// TODO: Ugh
				if (tmpDescriptor.PictForm.InputType == 'Option')
				{
					tmpTriggerGroup.SelectOptionsRefresh = true;
				}
				tmpDescriptor.PictForm.AutofillTriggerGroup.push(tmpTriggerGroup);
			}
		}

		if (typeof tmpRecord.Entity === 'string' && tmpRecord.Entity.trim() &&
			(
				(typeof tmpRecord.EntityColumnFilter === 'string' && tmpRecord.EntityColumnFilter.trim()) ||
				(typeof tmpRecord.EntityFilterTemplate === 'string' && tmpRecord.EntityFilterTemplate.trim())
			) &&
			typeof tmpRecord.EntityDestination === 'string' && tmpRecord.EntityDestination.trim())
		{
			if (!Array.isArray(tmpDescriptor.PictForm.Providers))
			{
				tmpDescriptor.PictForm.Providers = [];
			}

			if (!tmpDescriptor.PictForm.Providers.includes('Pict-Input-EntityBundleRequest'))
			{
				tmpDescriptor.PictForm.Providers.push('Pict-Input-EntityBundleRequest')
			}
			tmpDescriptor.PictForm.EntitiesBundle = [
				{
					"Entity": tmpRecord.Entity,
					"Filter": (tmpRecord.EntityFilterTemplate && tmpRecord.EntityFilterTemplate.trim()) || `FBV~${tmpRecord.EntityColumnFilter.trim()}~EQ~{~D:Record.Value~}`,
					"Destination": tmpRecord.EntityDestination,
					// This marshals a single record
					"SingleRecord": tmpRecord.EntitySingleRecord && tmpRecord.EntitySingleRecord !== 'false',
				}
			]
		}

		// This is used for Section and Group, regardless of where the Descriptor goes.
		let tmpCoreManifestFactory = pManifestFactory;
		if ((`SubManifest` in tmpRecord) && (tmpRecord.SubManifest) && (tmpRecord.InputType != 'TabularAddress'))
		{
			tmpDescriptor.IsTabular = true;
			// Below is what amounts to complex pointer arithmatic.
			if (!(tmpRecord.SubManifest in pManifestFactory.manifest.ReferenceManifests))
			{
				// Build a reference manifest if it doesn't exist
				pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory', { Manifest: { Scope: tmpRecord.SubManifest } }, `${this.UUID}-${tmpRecord.SubManifest}`);
				pManifestFactory.manifest.ReferenceManifests[tmpRecord.SubManifest] = pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest].manifest;
			}
			pManifestFactory = pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest];
		}

		if ('Decimal Precision' in tmpRecord)
		{
			// See if the Decimal Precision is set
			if (tmpRecord['Decimal Precision'] && (tmpRecord['Decimal Precision'] != ''))
			{
				try
				{
					tmpDescriptor.PictForm.DecimalPrecision = parseInt(tmpRecord['Decimal Precision']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Decimal Precision for ${tmpRecord['Input Hash']}: ${pError}`);
				}
			}
		}

		// Setup the Section and the Group
		const tmpSectionName = tmpRecord['Section Name']?.trim?.();

		let tmpSectionHash = this.sanitizeObjectKey(tmpSectionName || 'Default_Section');
		// Note: The section name part is laissez-faire about whether it needs to be there or not.  The Hash is required on each column if we want to customize.
		if (tmpRecord['Section Hash'] && tmpRecord['Section Hash'] != '')
		{
			tmpSectionHash = this.sanitizeObjectKey(tmpRecord['Section Hash']);
		}

		tmpDescriptor.PictForm.Section = tmpSectionHash;
		const tmpSection = tmpCoreManifestFactory.getManifestSection(tmpSectionHash);
		if (tmpSectionName)
		{
			tmpSection.Name = tmpSectionName;
		}

		if (tmpRecord['Section CSS'])
		{
			tmpSection.CSSClass = tmpRecord['Section CSS'];
		}

		const tmpGroupName = tmpRecord['Group Name']?.trim?.();
		let tmpGroupHash = this.sanitizeObjectKey(tmpGroupName || 'Default_Group');
		// Note: The group name part is laissez-faire about whether it needs to be there or not.  The Hash is required on each column if we want to customize.
		if (tmpRecord['Group Hash'] && tmpRecord['Group Hash'] != '')
		{
			tmpGroupHash = this.sanitizeObjectKey(tmpRecord['Group Hash']);
		}

		tmpDescriptor.PictForm.Group = tmpGroupHash;
		const tmpGroup = tmpCoreManifestFactory.getManifestGroup(tmpSection, tmpGroupHash);
		tmpGroup.Name = tmpGroupName || ''; // by default, the new group with have a name with the hash, but avoid that to support default groups without ugly forms

		if (tmpRecord['Group CSS'])
		{
			tmpGroup.CSSClass = tmpRecord['Group CSS'];
		}
		if (tmpRecord['Group Layout'])
		{
			tmpGroup.Layout = tmpRecord['Group Layout'];
		}
		if (tmpRecord['Minimum Row Count'])
		{
			try
			{
				tmpGroup.MinimumRowCount = parseInt(tmpRecord['Minimum Row Count']);
			}
			catch (pError)
			{
				this.log.error(`Failed to parse Minimum Row Count for ${tmpRecord['Input Hash']}: ${pError}`);
			}
		}
		if (tmpRecord['Maximum Row Count'])
		{
			try
			{
				tmpGroup.MaximumRowCount = parseInt(tmpRecord['Maximum Row Count']);
			}
			catch (pError)
			{
				this.log.error(`Failed to parse Maximum Row Count for ${tmpRecord['Input Hash']}: ${pError}`);
			}
		}
		if (tmpRecord['HideTabularEditingControls'] && ((tmpRecord['HideTabularEditingControls'] == '1') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 'true') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 't') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 'y')))
		{
			tmpGroup.HideTabularEditingControls = true;
		}
		if (tmpRecord['Group Show Title'] && (tmpRecord['Group Show Title'] != ''))
		{
			switch (tmpRecord['Group Show Title'].toLowerCase())
			{
				case 1:
				case '1':
				case 'true':
					tmpGroup.ShowTitle = true;
					break;
				case 0:
				case '0':
				case 'false':
					tmpGroup.ShowTitle = false;
					break;
			}
		}
		if (tmpDescriptor.Hash in pManifestFactory.manifest.Descriptors)
		{
			this.log.info(`[ERROR] Duplicate descriptor hash found ${tmpDescriptor.Hash}.  This will overwrite the original descriptor.`);
		}

		// Now checking if the group is Tabular -- if it is we need to set some extra values on the Group and have solvers occur inline
		// Layout: "Tabular",
		// RecordSetSolvers: [
		// 	{
		// 		Ordinal: 0,
		// 		Expression: "PercentTotalFat = (Fat * 9) / Calories",
		// 	},
		// ],
		// RecordSetAddress: "FruitData.FruityVice",
		// RecordManifest: "FruitEditor",
		if (tmpRecord.InputType == 'TabularAddress')
		{
			tmpGroup.Layout = 'Tabular';
			// If the csv defines the GroupRecordSetAddress, use that explicitly
			this.log.info(`Group ${tmpGroup.Hash} RSA ${tmpRecord['GroupRecordSetAddress']} -> Descriptor ${tmpDescriptor.DataAddress}`);
			if (tmpRecord['GroupRecordSetAddress'] && (typeof (tmpRecord.GroupRecordSetAddress == 'string')) && (tmpRecord.GroupRecordSetAddress.length > 0))
			{
				tmpGroup.RecordSetAddress = tmpRecord.GroupRecordSetAddress;
			}
			else
			{
				tmpGroup.RecordSetAddress = tmpDescriptor.DataAddress;
			}
			// Otherwise fall back to the DataAddress
			tmpGroup.RecordManifest = tmpRecord.SubManifest;
		}

		if (tmpRecord['Equation'] && !this._isTrue(tmpRecord['Validator']))
		{
			// Clean up the equation a bit to remove any leading/trailing spaces and replace HTML quotes
			// that may have been added by the CSV or other source.
			const tmpCleanEquation = tmpRecord['Equation'].trim();
			let tmpEquationOrdinal = 1;
			if (tmpRecord['Equation Ordinal'])
			{
				try
				{
					tmpEquationOrdinal = parseInt(tmpRecord['Equation Ordinal']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Equation Ordinal for ${tmpRecord['Input Hash']}: ${pError}`);
				}
			}
			this.log.trace(`Adding solver to ${tmpRecord.Form} --> ${tmpGroup.Name} for ${tmpRecord['Input Hash']} Ordinal ${tmpEquationOrdinal}: ${tmpRecord['Equation']}`);
			if ((tmpGroup.Layout == 'Tabular') || (tmpGroup.Layout == 'RecordSet'))
			{
				if (tmpEquationOrdinal == 1)
				{
					tmpGroup.RecordSetSolvers.push(tmpCleanEquation);
				}
				else
				{
					tmpGroup.RecordSetSolvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
				}
			}
			else
			{
				if (tmpEquationOrdinal == 1)
				{
					tmpSection.Solvers.push(tmpCleanEquation);
				}
				else
				{
					tmpSection.Solvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
				}
			}
		}

		this.onTabularRowAddDescriptor(tmpRecord, tmpSection, tmpGroup, tmpDescriptor);

		if (tmpRecord.DataOnly && tmpDescriptor.PictForm)
		{
			if (tmpDescriptor.PictForm.Group)
			{
				tmpDescriptor.FormGroup = tmpDescriptor.PictForm.Group;
			}
			if (tmpDescriptor.PictForm.Section)
			{
				tmpDescriptor.FormSection = tmpDescriptor.PictForm.Section;
			}
			delete tmpDescriptor.PictForm;
		}

		if ((tmpRecord.InputType == 'Chart') && (tmpDescriptor.PictForm))
		{
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '1');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '2');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '3');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '4');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '5');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '6');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '7');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '8');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '9');
		}

		// Finally add any `Descriptor_Extension_* properties
		const tmpDescriptorKeys = Object.keys(tmpRecord);
		let tmpDescriptorManifest = this.fable.newManyfest();
		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			let tmpKey = tmpDescriptorKeys[i];
			if (tmpKey.startsWith('Descriptor_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpValue = tmpRecord[tmpKey];

					// Use the manifest to put it on the descriptor
					if (tmpValue)
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Float_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Float_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue = parseFloat(tmpRawValue);

					// Use the manifest to put it on the descriptor
					if (!isNaN(tmpValue))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
						this.log.trace(`Set Float Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}] to value [${tmpValue}]`);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Float Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Integer_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Integer_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue = parseInt(tmpRawValue);

					// Use the manifest to put it on the descriptor
					if (!isNaN(tmpValue))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Integer Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Boolean_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Boolean_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue;

					if ((tmpRawValue.toLowerCase() == 'x') || (tmpRawValue.toLowerCase() == 'y') || (tmpRawValue.toLowerCase() == 'yes') || (tmpRawValue.toLowerCase() == 't') || (tmpRawValue.toLowerCase() == 'true') || (tmpRawValue == '1'))
					{
						tmpValue = true;
					}
					if ((tmpRawValue.toLowerCase() == 'n') || (tmpRawValue.toLowerCase() == 'no') || (tmpRawValue.toLowerCase() == 'f') || (tmpRawValue.toLowerCase() == 'false') || (tmpRawValue == '0'))
					{
						tmpValue = false;
					}

					// Use the manifest to put it on the descriptor
					if ((tmpValue === true) || (tmpValue === false))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
					else if (tmpRawValue)
					{
						this.log.warn(`Could not parse Boolean value [${tmpRawValue}] for Descriptor Boolean Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]`);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Boolean Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}
		}

		if (tmpRecord.InputType != 'TabularAddress')
		{
			pManifestFactory.addDescriptor(tmpDescriptor);
		}
		else
		{
			tmpCoreManifestFactory.addDescriptor(tmpDescriptor);
		}

		return tmpDescriptor;
	}

	/**
	 * Add a validation solver to a manifest from a tabular row.
	 *
	 * @param {Record<string, any>} pManifest - The manifest being built
	 * @param {Record<string, any>} pRecord - The tabular row record -- expected to have at least a 'Form'
	 */
	tabularRowAddValidator(pManifest, pRecord)
	{
		if (pRecord['Equation'])
		{
			// Clean up the equation a bit to remove any leading/trailing spaces and replace HTML quotes
			// that may have been added by the CSV or other source.
			const tmpCleanEquation = pRecord['Equation'].trim();
			let tmpEquationOrdinal = 1;
			if (pRecord['Equation Ordinal'])
			{
				try
				{
					tmpEquationOrdinal = parseInt(pRecord['Equation Ordinal']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Equation Ordinal for ${pRecord['Input Hash']}: ${pError}`);
				}
			}
			this.log.trace(`Adding solver to ${pRecord.Form} Validation Solvers Ordinal ${tmpEquationOrdinal}: ${pRecord['Equation']}`);
			if (!Array.isArray(pManifest.ValidationSolvers))
			{
				pManifest.ValidationSolvers = [];
			}
			if (tmpEquationOrdinal == 1)
			{
				pManifest.ValidationSolvers.push(tmpCleanEquation);
			}
			else
			{
				pManifest.ValidationSolvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
			}
		}
	}

	/**
	 * This fires whenever a Tabular Row is adding a Descriptor to the Manifest.
	 *
	 * If you want to extend how descriptors are built, the code belongs in here.
	 *
	 * @param {Object} pIncomingDescriptor - The record for the descriptor being added (from a CSV or other source)
	 * @param {Object} pSection - The section object
	 * @param {Object} pGroup - The group object
	 * @param {Object} pNewDescriptor - The descriptor object
	 */
	onTabularRowAddDescriptor(pIncomingDescriptor, pSection, pGroup, pNewDescriptor)
	{
		// This is meant to be overloaded by the parent class
	}

	migrateAutofillTriggerGroupSolvers(pManifests)
	{
		for (const tmpManifestFactory of Object.values(pManifests))
		{
			const tmpManifest = tmpManifestFactory.manifest;

			const tmpGatheredSolverExpressions = [];

			for (const tmpSection of tmpManifest.Sections || [])
			{
				if (Array.isArray(tmpSection.Solvers))
				{
					for (let i = 0; i < tmpSection.Solvers.length; i++)
					{
						const tmpSolverEntry = tmpSection.Solvers[i];
						const tmpSolverExpression = (typeof (tmpSolverEntry) === 'string') ? tmpSolverEntry : tmpSolverEntry.Expression;
						if (typeof tmpSolverExpression === 'string' && tmpSolverExpression.startsWith('TriggerGroup:'))
						{
							tmpGatheredSolverExpressions.push(tmpSolverEntry);
							// Remove it from the section solvers
							tmpSection.Solvers.splice(i, 1);
							--i;
						}
					}
				}
				for (const tmpGroup of tmpSection.Groups || [])
				{
					if (Array.isArray(tmpGroup.RecordSetSolvers))
					{
						for (let i = 0; i < tmpGroup.RecordSetSolvers.length; i++)
						{
							const tmpSolverEntry = tmpGroup.RecordSetSolvers[i];
							const tmpSolverExpression = (typeof (tmpSolverEntry) === 'string') ? tmpSolverEntry : tmpSolverEntry.Expression;
							if (typeof tmpSolverExpression === 'string' && tmpSolverExpression.startsWith('TriggerGroup:'))
							{
								tmpGatheredSolverExpressions.push(tmpSolverEntry);
								// Remove it from the group solvers
								tmpGroup.RecordSetSolvers.splice(i, 1);
								--i;
							}
						}
					}
				}
			}
			for (const tmpTriggerGroupSolverEntry of tmpGatheredSolverExpressions)
			{
				const tmpSolverExpression = (typeof (tmpTriggerGroupSolverEntry) === 'string') ? tmpTriggerGroupSolverEntry : tmpTriggerGroupSolverEntry.Expression;
				let [ tmpType, tmpTriggerGroupHash, tmpPrePost, tmpSimpleSolverExpression ] = tmpSolverExpression.split(':');
				if (!tmpSimpleSolverExpression)
				{
					tmpSimpleSolverExpression = tmpPrePost;
					tmpPrePost = 'post';
				}

				if (!tmpSimpleSolverExpression || tmpSimpleSolverExpression.trim() === '')
				{
					this.log.error(`Skipping migration of empty TriggerGroup solver expression in manifest [${tmpManifest.Scope}] for TriggerGroup [${tmpTriggerGroupHash}]`);
					continue;
				}
				const tmpTriggerGroupDescriptor = Object.values(tmpManifest.Descriptors).find((pDescriptor) =>
				{
					if (!pDescriptor.PictForm?.AutofillTriggerGroup)
					{
						return false;
					}
					/** @type {Array<any>} */
					const tmpTriggerGroups = Array.isArray(pDescriptor.PictForm.AutofillTriggerGroup) ? pDescriptor.PictForm.AutofillTriggerGroup : [pDescriptor.PictForm.AutofillTriggerGroup];
					return tmpTriggerGroups.some((pTriggerGroup) => pTriggerGroup.TriggerGroupHash === tmpTriggerGroupHash);
				});
				if (!tmpTriggerGroupDescriptor)
				{
					this.log.error(`Could not find descriptor for TriggerGroup [${tmpTriggerGroupHash}] in manifest [${tmpManifest.Scope}] while migrating solver expression: ${tmpSolverExpression}`);
					continue;
				}
				const tmpTriggerGroups = Array.isArray(tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup) ? tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup : [tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup];
				const tmpTriggerGroup = tmpTriggerGroups.find((pTriggerGroup) => pTriggerGroup.TriggerGroupHash === tmpTriggerGroupHash);
				if (!tmpTriggerGroup)
				{
					this.log.error(`Could not find TriggerGroup entry for TriggerGroup [${tmpTriggerGroupHash}] in descriptor [${tmpTriggerGroupDescriptor.Hash}] while migrating solver expression: ${tmpSolverExpression}`);
					continue;
				}
				let tmpUpdatedTriggerGroupSolverEntry = tmpTriggerGroupSolverEntry;
				if (typeof tmpTriggerGroupSolverEntry === 'string')
				{
					tmpUpdatedTriggerGroupSolverEntry = tmpSimpleSolverExpression;
				}
				else
				{
					tmpTriggerGroupSolverEntry.Expression = tmpSimpleSolverExpression;
				}
				if (tmpPrePost.toLowerCase() === 'pre')
				{
					tmpTriggerGroup.PreSolvers = tmpTriggerGroup.PreSolvers || [];
					tmpTriggerGroup.PreSolvers.push(tmpUpdatedTriggerGroupSolverEntry);
				}
				else
				{
					tmpTriggerGroup.PostSolvers = tmpTriggerGroup.PostSolvers || [];
					tmpTriggerGroup.PostSolvers.push(tmpUpdatedTriggerGroupSolverEntry);
				}
			}
		}
	}

	/**
	 * Helper function to determine if a value is "truthy" in the context of dynamic configuration.
	 *
	 * @param {any} pValue - The value to be evaluated
	 *
	 * @return {boolean} whether the value is considered true
	 */
	_isTrue(pValue)
	{
		if (typeof pValue === 'boolean')
		{
			return pValue;
		}
		if (typeof pValue === 'string')
		{
			const tmpValue = pValue.trim().toLowerCase();
			return tmpValue === 'true' || tmpValue === 't' || tmpValue === 'yes' || tmpValue === 'y' || tmpValue === '1';
		}
		return pValue == true || pValue == 1;
	}

	/**
	 * Create some manifests with a "factory" pattern.
	 *
	 * @param {any} pRecords - The records as an array of objects
	 *
	 * @return {any} the manifests
	 */
	createManifestsFromTabularArray(pRecords)
	{
		if (!pRecords || !Array.isArray(pRecords))
		{
			this.log.info('Invalid records passed to generateManifests.');
			return {};
		}

		const tmpManifestFactories = {};

		for (let i = 0; i < pRecords.length; i++)
		{
			let tmpRecord = pRecords[i];

			// Lint the row we are parsing
			if (!this.tabularRowLint(tmpRecord))
			{
				continue;
			}

			if (!tmpManifestFactories[tmpRecord.Form])
			{
				// Create the manifest if one doesn't exist
				tmpManifestFactories[tmpRecord.Form] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory',
					{
						Manifest:
						{
							Form: tmpRecord.Form
						}
					}, `${this.UUID}-${tmpRecord.Form}`);
			}

			const tmpManifestFactory = tmpManifestFactories[tmpRecord.Form];

			// Check if there is a Form Name to be set
			if (tmpRecord['Form Name'])
			{
				tmpManifestFactory.manifest.FormName = tmpRecord['Form Name'];
			}
			if (tmpRecord['Input Hash'])
			{
				this.tabularRowAddDescriptor(tmpManifestFactory, tmpRecord);
			}
			if (this._isTrue(tmpRecord['Validator']))
			{
				this.log.trace(`Adding validator from tabular row on form ${tmpRecord.Form}: ${tmpRecord.Equation}`);
				this.tabularRowAddValidator(tmpManifestFactory.manifest, tmpRecord);
			}
		}
		this.migrateAutofillTriggerGroupSolvers(tmpManifestFactories);

		this.log.info(`Generated ${Object.keys(tmpManifestFactories).length} manifests.`);

		let tmpManifestKeys = Object.keys(tmpManifestFactories);
		let tmpOutputManifests = {};
		for (let i = 0; i < tmpManifestKeys.length; i++)
		{
			tmpOutputManifests[tmpManifestKeys[i]] = tmpManifestFactories[tmpManifestKeys[i]].manifest;
		}
		return tmpOutputManifests;
	}
}

module.exports = ManifestFactory;
/** @type {Record<string, any>} */
ManifestFactory.default_configuration = {};

},{"fable-serviceproviderbase":398}],548:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libManifestFactory = require('../services/ManifestFactory.js');

const libDynamicSolver = require('../providers/Pict-Provider-DynamicSolver.js');
const libDynamicInput = require('../providers/Pict-Provider-DynamicInput.js');
const libDynamicInputEvents = require('../providers/Pict-Provider-DynamicInputEvents.js');
const libDynamicTabularData = require('../providers/Pict-Provider-DynamicTabularData.js');
const libDynamicRecordSet = require('../providers/Pict-Provider-DynamicRecordSet.js');

const libFormsTemplateProvider = require('../providers/Pict-Provider-DynamicTemplates.js');

const libMetatemplateGenerator = require('../providers/Pict-Provider-MetatemplateGenerator.js');
const libMetatemplateMacros = require('../providers/Pict-Provider-MetatemplateMacros.js');

const libPictLayoutRecord = require('../providers/layouts/Pict-Layout-Record.js');
const libPictLayoutVerticalRecord = require('../providers/layouts/Pict-Layout-VerticalRecord.js');
const libPictLayoutTabular = require('../providers/layouts/Pict-Layout-Tabular.js');
const libPictLayoutRecordSet = require('../providers/layouts/Pict-Layout-RecordSet.js');
const libPictLayoutChart = require('../providers/layouts/Pict-Layout-Chart.js');
const libPictLayoutTuiGrid = require('../providers/layouts/Pict-Layout-TuiGrid.js');
const libPictLayoutCustom = require('../providers/layouts/Pict-Layout-Custom.js');

const libInformary = require('../providers/Pict-Provider-Informary.js');

class PictDynamicFormDependencyManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		//let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultManifestSettings)), pOptions);
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		this.fable.addAndInstantiateSingletonService('ManifestFactory', libManifestFactory.default_configuration, libManifestFactory);

		this.fable.addProviderSingleton('DynamicInput', libDynamicInput.default_configuration, libDynamicInput);
		this.fable.addProviderSingleton('DynamicInputEvents', libDynamicInputEvents.default_configuration, libDynamicInputEvents);
		this.fable.addProviderSingleton('DynamicSolver', libDynamicSolver.default_configuration, libDynamicSolver);
		this.fable.addProviderSingleton('DynamicTabularData', libDynamicTabularData.default_configuration, libDynamicTabularData);
		this.fable.addProviderSingleton('DynamicRecordSet', libDynamicRecordSet.default_configuration, libDynamicRecordSet);

		this.fable.addProviderSingleton('PictFormSectionDefaultTemplateProvider', libFormsTemplateProvider.default_configuration, libFormsTemplateProvider);

		this.fable.addProviderSingleton('MetatemplateGenerator', libMetatemplateGenerator.default_configuration, libMetatemplateGenerator);
		this.fable.addProviderSingleton('MetatemplateMacros', libMetatemplateMacros.default_configuration, libMetatemplateMacros);

		this.fable.addProviderSingleton('Pict-Layout-Record', libPictLayoutRecord.default_configuration, libPictLayoutRecord);
		this.fable.addProviderSingleton('Pict-Layout-VerticalRecord', libPictLayoutVerticalRecord.default_configuration, libPictLayoutVerticalRecord);
		this.fable.addProviderSingleton('Pict-Layout-Tabular', libPictLayoutTabular.default_configuration, libPictLayoutTabular);
		this.fable.addProviderSingleton('Pict-Layout-RecordSet', libPictLayoutRecordSet.default_configuration, libPictLayoutRecordSet);
		this.fable.addProviderSingleton('Pict-Layout-Chart', libPictLayoutChart.default_configuration, libPictLayoutChart);
		this.fable.addProviderSingleton('Pict-Layout-TuiGrid', libPictLayoutTuiGrid.default_configuration, libPictLayoutTuiGrid);
		this.fable.addProviderSingleton('Pict-Layout-Custom', libPictLayoutCustom.default_configuration, libPictLayoutCustom);

		this.fable.addProviderSingleton('Informary', libInformary.default_configuration, libInformary);
	}
}

module.exports = PictDynamicFormDependencyManager;

/** @type {Record<string, any>} */
PictDynamicFormDependencyManager.default_configuration = { };

},{"../providers/Pict-Provider-DynamicInput.js":500,"../providers/Pict-Provider-DynamicInputEvents.js":501,"../providers/Pict-Provider-DynamicRecordSet.js":503,"../providers/Pict-Provider-DynamicSolver.js":504,"../providers/Pict-Provider-DynamicTabularData.js":505,"../providers/Pict-Provider-DynamicTemplates.js":506,"../providers/Pict-Provider-Informary.js":508,"../providers/Pict-Provider-MetatemplateGenerator.js":512,"../providers/Pict-Provider-MetatemplateMacros.js":513,"../providers/layouts/Pict-Layout-Chart.js":538,"../providers/layouts/Pict-Layout-Custom.js":539,"../providers/layouts/Pict-Layout-Record.js":540,"../providers/layouts/Pict-Layout-RecordSet.js":541,"../providers/layouts/Pict-Layout-Tabular.js":542,"../providers/layouts/Pict-Layout-TuiGrid.js":543,"../providers/layouts/Pict-Layout-VerticalRecord.js":545,"../services/ManifestFactory.js":547,"fable-serviceproviderbase":398}],549:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * @typedef {{
       reset: () => void,
       clone: () => Manyfest,
       deserialize: (pManifestString: string) => void,
       loadManifest: (pManifest: any) => void,
       serialize: () => string,
       getManifest: () => { Scope: string, Descriptors: any, HashTranslations: any, },
       addDescriptor: (pAddress: string, pDescriptor: any) => void,
       getDescriptorByHash: (pHash: string) => any,
       getDescriptor: (pAddress: string) => any,
       eachDescriptor: (fAction: (pDescriptor: any) => void) => void,
       checkAddressExistsByHash : (pObject: any, pHash: string) => boolean,
       checkAddressExists : (pObject: any, pAddress: string) => boolean,
       resolveHashAddress: (pHash: string) => any,
       getValueByHash : (pObject: any, pHash: string) => any,
       getValueAtAddress : (pObject: any, pAddress: string) => any,
       setValueByHash: (pObject: any, pHash: string, pValue: any) => boolean,
       setValueAtAddress : (pObject: any, pAddress: string, pValue: any) => void,
       deleteValueByHash: (pObject: any, pHash: string, pValue: any) => void,
       deleteValueAtAddress : (pObject: any, pAddress: string, pValue: any) => void,
       validate: (pObject: any) => boolean,
       getDefaultValue: (pDescriptor: any) => any,
       populateDefaults: (pObject: any, pOverwriteProperties: boolean) => void,
       populateObject: (pObject: any, pOverwriteProperties: boolean, fFilter: (pDescriptor: any) => boolean) => void,
       serviceType: string,
       options: any,
       scope?: string,
       elementAddresses: Array<string>,
       elementHashes: Object,
       elementDescriptors: Object,
 * }} Manyfest
 */


/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateControlFromDynamicManifest extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~DynamicInput:', '~}');
		this.addPattern('{~DI:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpHash = pTemplateHash.trim();
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptor(tmpHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateControlFromDynamicManifest: Cannot find descriptor for address [${tmpHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];
		const tmpScope = tmpView || pScope;
		const tmpContextArray = tmpScope ? [ tmpScope ] : (pContextArray || [ this.pict ]);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpView, descriptor);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpView, descriptor.DataType, descriptor.PictForm.InputType,
			`getInput("${descriptor.PictForm.GroupIndex}","${descriptor.PictForm.RowIndex}","${descriptor.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, descriptor, fCallback, tmpContextArray, tmpScope, pState);
	}
}

module.exports = PictTemplateControlFromDynamicManifest;

},{"pict-template":691}],550:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateControlFromDynamicManifest extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~DynamicInputForHash:', '~}');
		this.addPattern('{~DIH:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema hash.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema hash.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpHash = pTemplateHash.trim();
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptorByHash(tmpHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateControlFromDynamicManifest: Cannot find descriptor for hash [${tmpHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];
		const tmpScope = tmpView || pScope;
		const tmpContextArray = tmpScope ? [ tmpScope ] : (pContextArray || [ this.pict ]);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpView, descriptor);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpView, descriptor.DataType, descriptor.PictForm.InputType,
			`getInput("${descriptor.PictForm.GroupIndex}","${descriptor.PictForm.RowIndex}","${descriptor.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, descriptor, fCallback, tmpContextArray, tmpScope, pState);
	}
}

module.exports = PictTemplateControlFromDynamicManifest;

},{"pict-template":691}],551:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateGetViewSchemaValue extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~SchemaValue:', '~}');
		this.addPattern('{~SV:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const [ tmpSchemaAddress, tmpTemplateHash ] = pTemplateHash.trim().split('^');
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptor(tmpSchemaAddress);
		if (!descriptor)
		{
			this.log.error(`PictTemplateGetViewSchemaValue: Cannot find descriptor for address [${tmpSchemaAddress}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];

		const value = tmpView.getValueByHash(tmpSchemaAddress);

		if (tmpTemplateHash)
		{
			const tmpRecord = { Value: value, ParentRecord: pRecord, View: tmpView, Descriptor: descriptor };
			if (typeof fCallback !== 'function')
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
			}
			return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return fCallback(pError, '');
					}
					return fCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}

		if (typeof(fCallback) === 'function')
		{
			fCallback(null, value ? String(value) : '');
		}
		else
		{
			return value ? String(value) : '';
		}
	}
}

module.exports = PictTemplateGetViewSchemaValue;

},{"pict-template":691}],552:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateGetViewSchemaValueByHash extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~SchemaValueForHash:', '~}');
		this.addPattern('{~SVH:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const [ tmpSchemaHash, tmpTemplateHash ] = pTemplateHash.trim().split('^');
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptorByHash(tmpSchemaHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateGetViewSchemaValueByHash: Cannot find descriptor for address [${tmpSchemaHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];

		const value = tmpView.getValueByHash(tmpSchemaHash);

		if (tmpTemplateHash)
		{
			const tmpRecord = { Value: value, ParentRecord: pRecord, View: tmpView, Descriptor: descriptor };
			if (typeof fCallback !== 'function')
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
			}
			return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return fCallback(pError, '');
					}
					return fCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}

		if (typeof(fCallback) === 'function')
		{
			fCallback(null, value ? String(value) : '');
		}
		else
		{
			return value ? String(value) : '';
		}
	}
}

module.exports = PictTemplateGetViewSchemaValueByHash;

},{"pict-template":691}],553:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will take a value set and render a template for each value in the set.
 *
 * It passes along additional context (the metacontroller group) for dynamic programming tables.
 */
class PictTemplateMetacontrollerValueSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetacontrollerTemplateValueSet:', '~}');
		this.addPattern('{~MTVS:', '~}');
	}

	/**
	 * Renders the PICT Metacontroller Template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Metacontroller Template [MetacontrollerTemplateValueSet]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetacontrollerTemplateValueSet]::[${tmpHash}]`);
		}

		let tmpGroupIndex;
		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`Metacontroller template requires 3 parameters [${tmpHash}]`);
			return '';
		}
		tmpTemplateHash = tmpHashTemplateSeparator[0];
		tmpGroupIndex = tmpHashTemplateSeparator[1];
		tmpAddressOfData = tmpHashTemplateSeparator[2];

		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i, Group: tmpGroupIndex });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i], Group: tmpGroupIndex });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Asynchronously renders a template with the provided template hash, record, callback, and context array.
	 *
	 * @param {string} pTemplateHash - The template hash to render.
	 * @param {object} pRecord - The record object to use for rendering the template.
	 * @param {function} fCallback - The callback function to invoke after rendering the template.
	 * @param {array} pContextArray - The context array to use for resolving the data.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i, });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
			return;
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
			return;
		}
	}
}

module.exports = PictTemplateMetacontrollerValueSet;

},{"pict-template":691}],554:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateMetatemplateInputTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetaTemplateInput:', '~}');
		this.addPattern('{~MTI:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		tmpInputAddress = tmpHashTemplateSeparator[1];
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		tmpInputAddress = tmpHashTemplateSeparator[1];
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
		return;
	}
}

module.exports = PictTemplateMetatemplateInputTemplate;

},{"pict-template":691}],555:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateMetatemplateInputTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetaTemplateInputWithHashAddress:', '~}');
		this.addPattern('{~MTIWHA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[1], pRecord, pContextArray, null, pScope, pState);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`MetaTemplateInput template requires a valid Address for an Address in the second parameter [${tmpHash}]`);
			return '';
		}
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		const tmpInput =
		{
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm:
			{
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			},
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				const tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the Address and the DataType)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[1], pRecord, pContextArray, null, pScope, pState);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`MetaTemplateInput template requires a valid Address for an Address in the second parameter [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
		return;
	}
}

module.exports = PictTemplateMetatemplateInputTemplate;

},{"pict-template":691}],556:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash)
 */
class PictTemplateInputWithViewTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithView:', '~}');
		this.addPattern('{~IWV:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithView]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithView template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		tmpInputAddress = tmpHashTemplateSeparator[2];
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithView template requires a valid dynamic View hash [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithView]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithView template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		tmpInputAddress = tmpHashTemplateSeparator[2];
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithView template requires a valid dynamic View hash [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}
}

module.exports = PictTemplateInputWithViewTemplate;

},{"pict-template":691}],557:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash)
 */
class PictTemplateInputWithViewAndDescriptorAddressTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js'), DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithViewAndDescriptorAddress:', '~}');
		this.addPattern('{~IWVDA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndDescriptorAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpDescriptorAddress;

		// This is just a simple 2 part hash (the view hash and the descriptor address)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires two parameters (ViewHash and DescriptorAddress) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpDescriptorAddress = tmpHashTemplateSeparator[1];

		const tmpInput = this.resolveStateFromAddress(tmpDescriptorAddress, pRecord, pContextArray, null, pScope, pState);

		if (!tmpInput || typeof tmpInput !== 'object' || Array.isArray(tmpInput) || !tmpInput.Address)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid input object at address [${tmpDescriptorAddress}]`);
			return '';
		}

		this._shoreUpDescriptor(tmpInput);

		this.currentInputIndex++;

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid dynamic View hash [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndDescriptorAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpDescriptorAddress;

		// This is just a simple 2 part hash (the view hash and the descriptor address)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires two parameters (ViewHash and DescriptorAddress) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpDescriptorAddress = tmpHashTemplateSeparator[1];

		const tmpInput = this.resolveStateFromAddress(tmpDescriptorAddress, pRecord, pContextArray, null, pScope, pState);

		this._shoreUpDescriptor(tmpInput);

		this.currentInputIndex++;

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid dynamic View hash [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}

	_shoreUpDescriptor(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object' || Array.isArray(pDescriptor))
		{
			throw new Error('Invalid descriptor object provided to shoreUpDescriptor');
		}
		if (!pDescriptor.DataAddress)
		{
			pDescriptor.DataAddress = pDescriptor.Address;
		}
		if (!pDescriptor.Hash)
		{
			pDescriptor.Hash = this.fable.DataFormat.sanitizeObjectKey(pDescriptor.Address);
		}
		if (!pDescriptor.Name)
		{
			pDescriptor.Name = pDescriptor.Hash;
		}
		if (!pDescriptor.DataType)
		{
			pDescriptor.DataType = 'String';
		}
		if (!pDescriptor.PictForm)
		{
			pDescriptor.PictForm = { };
		}
		if (!pDescriptor.PictForm.InformaryDataAddress)
		{
			pDescriptor.PictForm.InformaryDataAddress = pDescriptor.DataAddress;
		}
		if (pDescriptor.PictForm.GroupIndex == null)
		{
			pDescriptor.PictForm.GroupIndex = 0;
		}
		if (pDescriptor.PictForm.Row == null)
		{
			pDescriptor.PictForm.Row = 0;
		}
	}
}

module.exports = PictTemplateInputWithViewAndDescriptorAddressTemplate;

},{"pict-template":691}],558:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash) and a hash address.
 */
class PictTemplateInputWithViewAndHashAddressTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithViewAndHashAddress:', '~}');
		this.addPattern('{~IWVHA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndHashAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[2], pRecord, pContextArray, null, pScope);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid Address for an Address in the third parameter [${tmpHash}]`);
			return '';
		}
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		const tmpInput =
		{
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm:
			{
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			},
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash]; //tmpMetatemplateGenerator.dynamicInputView;

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid dynamic View hash as the first parameter [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				const tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndHashAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[2], pRecord, pContextArray, null, pScope);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid Address for an Address in the third parameter [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash]; //tmpMetatemplateGenerator.dynamicInputView;

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid View hash as the first parameter [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}
}

module.exports = PictTemplateInputWithViewAndHashAddressTemplate;

},{"pict-template":691}],559:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPluckJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~PluckJoinUnique:', '~}');
		this.addPattern('{~PJU:', '~}');
	}

	/**
	 * Renders the PICT Metacontroller Template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 3)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();
		let tmpAddress = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				// This one only works on arrays of objects.
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if ((tmpValueSet[j] === null) || (typeof(tmpValueSet) !== 'object'))
					{
						continue;
					}
					let tmpValue = this.pict.manifest.getValueByHash(tmpValueSet[j], tmpAddress);
					if (!(tmpValue in tmpValueMap))
					{
						tmpValueMap[tmpValue] = true;
						tmpValueList.push(tmpValue);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderPluckJoinUnique;

},{"pict-template":691}],560:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Template tag that renders the editing-controls <td> (del / up / down) for
 * one row of a tabular group when EditingControlsPosition is "left".
 *
 * Usage in a tabular row template:
 *
 *   {~TabularEditingControls:<ViewHash>~}
 *   {~TEC:<ViewHash>~}
 *
 * Reads Record.Group and Record.Key from the MTVS row wrapper, then calls
 * the layout provider's `_renderTabularEditingControlsHTML(view, gi, rk)`.
 *
 * Implemented as a dedicated tag (rather than `{~F:~}`) so it works on the
 * older pict versions some hosts ship with.
 */
class PictTemplateTabularEditingControls extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~TabularEditingControls:', '~}');
		this.addPattern('{~TEC:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		if (!tmpHash || !pRecord)
		{
			return '';
		}
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return '';
		}
		let tmpGroupIndex = pRecord.Group;
		let tmpRowKey = pRecord.Key;
		let tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || typeof tmpLayout._renderTabularEditingControlsHTML !== 'function')
		{
			return '';
		}
		return tmpLayout._renderTabularEditingControlsHTML(tmpView, tmpGroupIndex, tmpRowKey);
	}
}

module.exports = PictTemplateTabularEditingControls;

},{"pict-template":691}],561:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Template tag that renders the left-side row-label <td> cells for one row
 * of a tabular group with `RowLabels` configured.
 *
 * Usage in a tabular row template:
 *
 *   {~TabularRowLabels:<ViewHash>~}
 *   {~TRL:<ViewHash>~}
 *
 * The current Record context is expected to be the MTVS wrapper
 * (`{ Value, Key, Group }`); the tag reads `Record.Group` and `Record.Key`
 * to look up the group's precomputed `RowLabelMetadata[Record.Key].Cells`
 * and renders one `<td rowspan>` per non-skipped cell.
 *
 * This is implemented as a dedicated tag (rather than `{~F:~}`) so it works
 * on the older pict versions some hosts ship with.
 */
class PictTemplateTabularRowLabels extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~TabularRowLabels:', '~}');
		this.addPattern('{~TRL:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		if (!tmpHash || !pRecord)
		{
			return '';
		}
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return '';
		}
		let tmpGroupIndex = pRecord.Group;
		let tmpRowKey = pRecord.Key;
		let tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || typeof tmpLayout._renderTabularRowLabelsHTML !== 'function')
		{
			return '';
		}
		return tmpLayout._renderTabularRowLabelsHTML(tmpView, tmpGroupIndex, tmpRowKey);
	}
}

module.exports = PictTemplateTabularRowLabels;

},{"pict-template":691}],562:[function(require,module,exports){
module.exports={
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ExecuteSolversWithoutMetacontroller": false,
	"IncludeInMetatemplateSectionGeneration": true,
	"IncludeInDefaultDynamicRender": true,

	"DefaultRenderable": "Form-Main",
	"DefaultDestinationAddress": "#Pict-Form-Container",

	"Renderables": [],

	"Templates": [],

	"MacroTemplates": {
		"Section": {
			"HTMLID": " id=\"Section-{~D:Context[0].UUID~}\" "
		},
		"Group": {
			"HTMLID": " id=\"Group-{~D:Context[0].UUID~}\" ",

			"PictFormLayout": " data-i-pictdynamiclayout=\"true\" data-i-pictgroupindex=\"{~D:Record.GroupIndex~}\" data-i-pictlayout=\"{~D:Record.Layout~}\" ",

			"TabularCreateRowFunctionCall": "{~P~}.views['{~D:Context[0].Hash~}'].createDynamicTableRow({~D:Record.GroupIndex~})"
		},
		"Input": {
			"Informary": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\" ",
			"InformaryTabular": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\" data-i-container=\"{~D:Record.PictForm.InformaryContainerAddress~}\" ",

			"ControlAttr": " data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",

			"HTMLSelector": "[data-i-form=\"{~D:Context[0].formID~}\"][data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"]",
			"HTMLSelectorTabular": "[data-i-form=\"{~D:Context[0].formID~}\"][data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"][data-i-container=\"{~D:Record.PictForm.InformaryContainerAddress~}\"]",
			"HTMLSelectorControl": "[data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\"]",
			"HTMLSelectorControlTabular": "[data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\"]",

			"RawHTMLID": "{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}",

			"HTMLName": " name=\"{~D:Record.Name~}\" ",
			"HTMLIDAddress": "#{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}",
			"HTMLID": " id=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",
			"HTMLForID": " for=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",

			"InputFullProperties": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"  name=\"{~D:Record.Name~}\" ",
			"InputChangeHandler": " onchange=\"{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}')\" ",

			"DataRequestFunction": " {~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}'); "
		}
	},

	"TargetElementAddress": "#Form-Container-Div"
}

},{}],563:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/** @type {Record<string, any>} */
const libPackage = require('../../package.json');

/** @type {Record<string, any>} */
const _DefaultConfiguration = require('./Pict-View-DynamicForm-DefaultConfiguration.json');

const PENDING_ASYNC_OPERATION_TYPE = 'PendingAsyncOperation';
const TRANSACTION_COMPLETE_CALLBACK_TYPE = 'onTransactionComplete';
const READY_TO_FINALIZE_TYPE = 'ReadyToFinalize';

/**
 * Represents a dynamic form view for the Pict application.
 *
 * This is the code that maintains the lifecycle with the Pict application and
 * the data handling methods for a dynamic forms view (or set of views).
 *
 * @extends libPictViewClass
 */
class PictViewDynamicForm extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);

		if (!tmpOptions.Manifests)
		{
			throw new Error('PictSectionForm instantiation attempt without a Manifests in pOptions.Manifest -- cannot instantiate.');
		}
		if (!('Section' in tmpOptions.Manifests))
		{
			throw new Error('PictSectionForm instantiation attempt without a Section manifest in pOptions.Manifests -- cannot instantiate.');
		}
		// Set the default destination address to be based on the section hash if it hasn't been overridden by the manifest section definition
		if (tmpOptions.DefaultDestinationAddress === '#Pict-Form-Container')
		{
			tmpOptions.DefaultDestinationAddress = `#Pict-Form-Container-${tmpOptions.Hash}`;
		}
		// Set the default renderable to be based on the section hash if it hasn't been overridden by the manifest section definition
		if (tmpOptions.DefaultRenderable === 'Form-Main')
		{
			tmpOptions.DefaultRenderable = `Form-${tmpOptions.Hash}`;
		}
		// Set the template hash (which is the section-specific template prefix) if it hasn't been overridden by the manifest section definition
		if (!tmpOptions.SectionTemplateHash)
		{
			tmpOptions.SectionTemplateHash = `Pict-Form-Template-${tmpOptions.Hash}`;
		}

		// Create a renderable if none exist
		if (tmpOptions.Renderables.length < 1)
		{
			tmpOptions.Renderables.push(
				{
					RenderableHash: tmpOptions.DefaultRenderable,
					TemplateHash: tmpOptions.SectionTemplateHash,
					RenderMethod: 'replace'
				});
		}

		// Now construct the view.
		super(pFable, tmpOptions, pServiceHash);

		if (!this.fable.PictDynamicFormDependencyManager)
		{
			throw new Error('PictSectionForm instantiation attempt without a PictDynamicFormDependencyManager service in fable -- cannot instantiate.');
		}

		// Use this to manage transactions
		//FIXME: should we have these sioled??
		//this.transactionTracking = this.pict.newTransactionTracker();

		/** @type {Record<string, any>} */
		this._PackagePictView = this._Package;
		this._Package = libPackage;

		// Pull in the section definition
		this.sectionDefinition = this.options;

		// Initialize the section manifest -- instantiated to live only the lifecycle of this view
		this.sectionManifest = this.fable.instantiateServiceProviderWithoutRegistration('Manifest', this.options.Manifests.Section);

		// Shift solvers to an array of tasks
		this.sectionSolvers = [];
		// Pull in solvers
		if (('Solvers' in this.options) && Array.isArray(this.options.Solvers))
		{
			for (let i = 0; i < this.options.Solvers.length; i++)
			{
				if (typeof (this.options.Solvers[i]) === 'string')
				{
					this.sectionSolvers.push(this.options.Solvers[i]);
				}
			}
		}

		// Load any view section-specific templates
		this.formsTemplateSetPrefix = `PFT-${this.Hash}-${this.UUID}`;
		if (('MetaTemplates' in this.options) && Array.isArray(this.options.MetaTemplates))
		{
			for (let i = 0; i < this.options.MetaTemplates.length; i++)
			{
				let tmpMetaTemplate = this.options.MetaTemplates[i];

				if (('HashPostfix' in tmpMetaTemplate) && ('Template' in tmpMetaTemplate))
				{
					let tmpTemplateHash = `${this.formsTemplateSetPrefix}${tmpMetaTemplate.HashPostfix}`;
					this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpMetaTemplate.Template);
				}
				else
				{
					this.log.warn(`MetaTemplate entry ${i} in PictSectionForm [${this.UUID}]::[${this.Hash}] does not have a Hash and Template property; custom template skipped.`);
				}
			}
		}
		// The default template prefix
		this.customDefaultTemplatePrefix = null;

		this.formID = `Pict-Form-${this.Hash}-${this.UUID}`;

		this.viewMarshalDestination = null;
		this.initialBundleLoaded = false;

		this.fable.ManifestFactory.initializeFormGroups(this);

		this._LoopDetectionData = {};
	}

	/**
	 * Returns the default template prefix.
	 *
	 * @returns {string} The default template prefix.
	 */
	get defaultTemplatePrefix()
	{
		if (this.customDefaultTemplatePrefix)
		{
			return this.customDefaultTemplatePrefix;
		}
		else if (this.pict.views.PictFormMetacontroller)
		{
			return this.pict.views.PictFormMetacontroller.formTemplatePrefix;
		}
		else
		{
			return this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}
	}

	/**
	 * This method is called whenever data is changed within an input.
	 *
	 * It handles the data marshaling from the view to the data model,
	 * runs any providers connected to the input, solves the Pict application,
	 * then marshals data back to the view.
	 *
	 * @param {string} pInputHash - The hash of the input that triggered the data change.
	 */
	dataChanged(pInputHash)
	{
		let tmpInput = this.getInputFromHash(pInputHash);
		// This is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.

		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] dataChanged event for input [${pInputHash}].`);
		}
		if (pInputHash)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			let tmpHashAddress = this.sectionManifest.resolveHashAddress(pInputHash);
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest, tmpHashAddress);
				// Now run any providers connected to this input
				let tmpValue = this.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);

				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChange(this, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form dataChanged [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
		else
		{
			this.marshalFromView();
		}
		// Run any dynamic input providers for the input hash.
		this.pict.PictApplication.solve();
		if (this.pict.views.PictFormMetacontroller)
		{
			// since the solver may have changed data in other secitons, remarshal all sections
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			this.marshalToView();
		}
		// Notify the FormPersistence provider if it exists, for autosave
		if (this.pict.providers.FormPersistence)
		{
			this.pict.providers.FormPersistence.onFormDataChanged();
		}
	}


	/**
	 * Called whenever tabular data is changed.
	 *
	 * @param {number} pGroupIndex - the index of the group
	 * @param {number} pInputIndex - the index of the input
	 * @param {number} pRowIndex - the index of the row where the data was changed
	 */
	dataChangedTabular(pGroupIndex, pInputIndex, pRowIndex)
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] dataChangedTabular event for group ${pGroupIndex} input ${pInputIndex} row ${pRowIndex}.`);
		}
		let tmpInput = this.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (
			(typeof (pGroupIndex) != 'undefined')
			&& (typeof (pInputIndex) != 'undefined')
			&& (typeof (pRowIndex) != 'undefined')
			&& (typeof (tmpInput) == 'object')
		)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			let tmpHashAddress = tmpInput.Address;
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest, tmpHashAddress, pRowIndex);

				// TODO: Can we simplify this?
				let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = this.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);
				// Each row has a distinct address!
				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular + `[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChangeTabular(this, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form dataChangedTabular [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${tmpInput.Hash}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
		else
		{
			// This is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.
			this.marshalFromView();
		}
		// Run any dynamic input providers for the input hash.
		this.pict.PictApplication.solve();
		if (this.pict.views.PictFormMetacontroller)
		{
			// since the solver may have changed data in other secitons, remarshal all sections
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			this.marshalToView();
		}
		// Notify the FormPersistence provider if it exists, for autosave
		if (this.pict.providers.FormPersistence)
		{
			this.pict.providers.FormPersistence.onFormDataChanged();
		}
	}

	/**
	 * Sets the data in a specific form input based on the provided input object
	 *
	 * FIXME: does this need to have a transaction GUID passed in?
	 *
	 * @param {object} pInput - The input object.
	 * @param {any} pValue - The value to set.
	 * @returns {boolean} Returns true if the data was set successfully, false otherwise.
	 */
	setDataByInput(pInput, pValue)
	{
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.sectionManifest.setValueByHash(this.getMarshalDestinationObject(), pInput.Hash, pValue);

			// TODO: DRY TIME, excellent.
			let tmpValue = pValue;
			// Each row has a distinct address!
			let tmpVirtualInformaryHTMLSelector = pInput.Macro.HTMLSelector;
			let tmpInputProviderList = this.getInputProviderList(pInput);
			for (let i = 0; i < tmpInputProviderList.length; i++)
			{
				if (this.pict.providers[tmpInputProviderList[i]])
				{
					this.pict.providers[tmpInputProviderList[i]].onDataChange(this, pInput, tmpValue, tmpVirtualInformaryHTMLSelector, tmpTransactionGUID);
				}
				else
				{
					this.log.error(`Dynamic form setDataByInput [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${pInput.Hash}].`);
				}
			}
		}
		catch (pError)
		{
			this.log.error(`Dynamic form setDataByInput [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInput.Hash}) from view in dataChanged event: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}

		return false;
	}

	/**
	 * Sets the data in a specific tabular form input based on the provided hash, group and row.
	 *
	 * FIXME: does this need to have a transaction GUID passed in?
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pInputHash - The hash of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} pValue - The value to set.
	 * @returns {boolean} Returns true if the data was set successfully, false otherwise.
	 */
	setDataTabularByHash(pGroupIndex, pInputHash, pRowIndex, pValue)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = this.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper setDataTabularByHash ${pGroupIndex} was not a valid group.`);
			return false;
		}

		let tmpInputIndex = -1;
		let tmpElementDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
		for (let i = 0; i < tmpElementDescriptorKeys.length; i++)
		{
			if (tmpGroup.supportingManifest.elementDescriptors[tmpElementDescriptorKeys[i]].Hash === pInputHash)
			{
				tmpInputIndex = i;
				break;
			}
		}
		if (tmpInputIndex < 0)
		{
			this.log.warn(`PICT View Metatemplate Helper setDataTabularByHash Group ${pGroupIndex} did not have hash [${pInputHash}].`);
			return false;
		}

		let tmpInput = this.getTabularRecordInput(pGroupIndex, tmpInputIndex);
		if (
			(typeof (pGroupIndex) != 'undefined')
			&& (typeof (pRowIndex) != 'undefined')
			&& (typeof (tmpInput) == 'object')
		)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				this.sectionManifest.setValueByHash(tmpMarshalDestinationObject, tmpValueAddress, pValue)

				// TODO: DRY TIME, excellent.
				let tmpValue = pValue;
				// Each row has a distinct address!
				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular + `[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChangeTabular(this, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form setDataTabularByHash [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form setDataTabularByHash [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInputHash}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}

		return false;
	}

	/**
	 * Retrieves the marshal destination address.
	 *
	 * @returns {string} The marshal destination address.
	 */
	getMarshalDestinationAddress()
	{
		return this.viewMarshalDestination || this.pict.providers.DataBroker.marshalDestination;
	}

	/**
	 * Retrieves the marshal destination object.  This is where the model data is stored.
	 *
	 * @return {Record<string, any>} The marshal destination object.
	 */
	getMarshalDestinationObject()
	{
		return this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.viewMarshalDestination);
	}

	/**
	 * Gets a value by hash address.
	 *
	 * @param {string} pHashAddress
	 * @return {any} The value at the specified hash address.
	 */
	getValueByHash(pHashAddress)
	{
		return this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), pHashAddress);
	}

	/**
	 * Gets a value by hash address.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pInputIndex
	 * @param {number} pRowIndex
	 * @return {any} The value at the specified hash address.
	 */
	getTabularValueByHash(pGroupIndex, pInputIndex, pRowIndex)
	{
		const tmpInput = this.getTabularRecordInput(pGroupIndex, pInputIndex);
		const tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
		return this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpAddress);
	}

	/**
	 * Marshals data to the view.
	 *
	 * @returns {any} The result of calling the superclass's onMarshalToView method.
	 */
	onMarshalToView()
	{
		// TODO: Only marshal data that has changed since the last marshal.  Thought experiment: who decides what changes happened?
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
			// TODO: Add optional transaction awareness to informary
			this.pict.providers.Informary.marshalDataToForm(tmpMarshalDestinationObject, this.formID, this.sectionManifest);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', null, null, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data to view: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
		return super.onMarshalToView();
	}

	manualMarshalDataToViewByInput(pInput, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) == 'string') ? pTransactionGUID : this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.pict.providers.Informary.manualMarshalDataToFormByInput(pInput);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', pInput.Hash, null, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data to view: ${pError}`);
		}
		finally
		{
			if (tmpTransactionGUID !== pTransactionGUID)
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
	}

	manualMarshalTabularDataToViewByInput(pInput, pRowIndex, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) == 'string') ? pTransactionGUID : this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.pict.providers.Informary.manualMarshalTabularDataToFormByInput(pInput, pRowIndex);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', pInput.Hash, pRowIndex, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling tabular data to view: ${pError}`);
		}
		finally
		{
			if (tmpTransactionGUID !== pTransactionGUID)
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
	}

	/**
	 * Marshals data from the view to the destination object.
	 * @returns {any} The result of calling the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		try
		{
			let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
			this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data from view: ${pError}`);
		}
		return super.onMarshalFromView();
	}

	/**
	 * Executes after marshaling the data to the form.
	 * Checks if there are any hooks set from the input providers (from custom InputType handler hooks) and runs them.
	 */
	onAfterMarshalToForm()
	{
		// Check to see if there are any hooks set from the input templates
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.runInputProviderFunctions('onAfterMarshalToForm', null, null, tmpTransactionGUID);

		}
		catch (pError)
		{
			this.log.error(`Gross error running after marshal to form: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Executes the solve operation for the dynamic views.
	 *
	 * @returns {any} The result of the solve operation.
	 */
	onSolve()
	{
		// Usually the metacontroller runs this for the views
		if (this.options.ExecuteSolversWithoutMetacontroller)
		{
			this.pict.providers.DynamicSolver.solveViews([this.Hash]);
		}
		return super.onSolve();
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		if (!this.initialBundleLoaded)
		{
			if (Array.isArray(this.sectionDefinition.InitialBundle))
			{
				this.pict.EntityProvider.processBundle(this.sectionDefinition.InitialBundle);
			}
			this.initialBundleLoaded = true;
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {(error?: Error) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync((pError) =>
		{
			if (!this.initialBundleLoaded)
			{
				if (Array.isArray(this.sectionDefinition.InitialBundle))
				{
					this.pict.EntityProvider.gatherDataFromServer(this.sectionDefinition.InitialBundle, (pInnerError) =>
					{
						if (pInnerError)
						{
							this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to load initial bundle: ${pInnerError}`);
						}
						// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
						setTimeout(() => fCallback(pError), 0);
					});
					return;
				}
				this.initialBundleLoaded = true;
			}
			return fCallback(pError);
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		let tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		try
		{
			this.runLayoutProviderFunctions('onGroupLayoutInitialize', tmpTransactionGUID);
			this.runInputProviderFunctions('onInputInitialize', null, null, tmpTransactionGUID, true);
		}
		catch (pError)
		{
			this.log.error(`Gross error running after render: ${pError.message || pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}

		// The render that just happened repainted this section's markup without anything the solvers put
		// on it -- the setsectionvisibility / setgroupvisibility hide classes, and any highlight class or
		// inline color. Solvers run before the marshal that triggers most renders, so nothing else puts
		// them back: restore them here, once, for every render path.
		if (this.pict.providers.DynamicFormSolverBehaviors && this.sectionDefinition)
		{
			this.pict.providers.DynamicFormSolverBehaviors.reapplySectionDOMState(this.sectionDefinition.Hash);
		}

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Executes layout provider functions based on the given function name.
	 *
	 * These were TODO items that are now done but..  leaving them here to document complexity of why it works this way.
	 *
	 * --> This happens based on markers in the DOM, since we don't know which layout providers are active for which groups.
	 *
	 * --> This is easy to make happen with a macro on groups that gives us the data.
	 *
	 * --> THIS IS NOW SCOPED TO A PARTICULAR GROUP.  That is ... only one layout for a group at a time.
	 *
	 * The easiest way (and a speed up for other queries as such) is to scope it within the view container element
	 *
	 * @param {string} pFunctionName - The name of the function to execute.
	 * @param {string} [pTransactionGUID] - The transaction GUID to use for logging.
	 */
	runLayoutProviderFunctions(pFunctionName, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpTransaction = this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		// Check to see if there are any hooks set from the input templates
		let tmpLayoutProviders = this.pict.ContentAssignment.getElement(`${this.sectionDefinition.DefaultDestinationAddress} [data-i-pictdynamiclayout="true"]`);

		// Slightly more code for getting the active layout providers but provides TRUE DYNAMISM.
		for (let i = 0; i < tmpLayoutProviders.length; i++)
		{
			let tmpGroupIndex = tmpLayoutProviders[0].getAttribute('data-i-pictgroupindex');
			let tmpLayout = tmpLayoutProviders[0].getAttribute('data-i-pictlayout');

			if (isNaN(tmpGroupIndex) || (tmpGroupIndex < 0))
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions ${tmpGroupIndex} was not a valid group index.`);
				continue;
			}
			let tmpGroup = this.getGroup(tmpGroupIndex);
			if (!tmpGroup)
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions for group ${tmpGroupIndex} was not a valid group.`);
				continue;
			}
			if (!tmpLayout || typeof (tmpLayout) !== 'string')
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions for group ${tmpGroup} layout [${tmpLayout}] was not a valid layout.`);
				continue;
			}

			let tmpLayoutProvider = this.pict.providers.MetatemplateGenerator.getGroupLayoutProvider(this, tmpGroup);
			if (tmpLayoutProvider && (pFunctionName in tmpLayoutProvider))
			{
				let tmpFunction = tmpLayoutProvider[pFunctionName];
				if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `G${tmpGroupIndex}-L${tmpLayout}`, pFunctionName))
				{
					tmpFunction.call(tmpLayoutProvider, this, tmpGroup);
				}
			}
		}
		if (tmpTransactionGUID !== pTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * @private
	 * @param {string} pFunctionName
	 * @param {string} [pInputHash]
	 * @param {number} [pRowIndex]
	 */
	_trackInfiniteLoop(pFunctionName, pInputHash, pRowIndex)
	{
		this._LoopDetectionData[pFunctionName] = this._LoopDetectionData[pFunctionName] || {};
		const tmpInputSignature = `${pInputHash ?? ''}::${pRowIndex ?? ''}`;
		const tmpNowEpochMS = Date.now();
		this._LoopDetectionData[pFunctionName][tmpInputSignature] = this._LoopDetectionData[pFunctionName][tmpInputSignature] || { Count: 0, Timestamp: tmpNowEpochMS };
		if (tmpNowEpochMS - this._LoopDetectionData[pFunctionName][tmpInputSignature].Timestamp > 1000)
		{
			// only track events within a 1 second window
			this._LoopDetectionData[pFunctionName][tmpInputSignature].Count = 0;
			this._LoopDetectionData[pFunctionName][tmpInputSignature].Timestamp = tmpNowEpochMS;
		}
		this._LoopDetectionData[pFunctionName][tmpInputSignature].Count += 1;
		return this._LoopDetectionData[pFunctionName][tmpInputSignature];
	}

	/**
	 * Runs the input provider functions.
	 *
	 * @param {string} pFunctionName - The name of the function to run for each input provider.
	 * @param {string} [pInputHash] - The hash of the input to run the function for.
	 * @param {number} [pRowIndex] - The index of the row to run the
	 * @param {string} [pTransactionGUID] - The transaction GUID to use for logging.
	 * @param {boolean} [pLoopDetection] - Whether to enable loop detection.
	 */
	runInputProviderFunctions(pFunctionName, pInputHash, pRowIndex, pTransactionGUID, pLoopDetection)
	{
		const tmpLoopData = this._trackInfiniteLoop(pFunctionName, pInputHash, pRowIndex);
		if (pLoopDetection && tmpLoopData.Count > 10) // seems like a reasonable threshold for now (10 inits in a second)
		{
			this.log.fatal(` !!!!!! Infinite loop detected in runInputProviderFunctions for function [${pFunctionName}] on input [${pInputHash}] row [${pRowIndex}] in form [${this.Hash}]::[${this.UUID}].  Aborting further processing.`, { Stack: new Error().stack });
			return;
		}
		const tmpTransactionGUID = (typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpTransaction = this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		// Check to see if there are any hooks set from the input templates
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = this.sectionDefinition.Groups[i];

			if (Array.isArray(tmpGroup.Rows))
			{
				for (let j = 0; j < tmpGroup.Rows.length; j++)
				{
					// TODO: Do we want row macros?  Let's be still and find out.
					let tmpRow = tmpGroup.Rows[j];
					for (let k = 0; k < tmpRow.Inputs.length; k++)
					{
						let tmpInput = tmpRow.Inputs[k];
						// Now run any providers connected to this input
						if (tmpInput && tmpInput.PictForm
							&& (!pInputHash || (pInputHash === tmpInput.Hash)))
						{
							let tmpInputProviderList = this.getInputProviderList(tmpInput);
							for (let l = 0; l < tmpInputProviderList.length; l++)
							{
								if (this.pict.providers[tmpInputProviderList[l]])
								{
									let tmpHashAddress = this.sectionManifest.resolveHashAddress(tmpInput.Hash);
									let tmpValue = this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpHashAddress);
									try
									{
										if (this.pict.LogNoisiness > 2)
										{
											this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] running provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}].`);
										}
										// TODO: Right now the Option input requires this bug to work
										//if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `I${tmpInput.Hash}-P${tmpInputProviderList[l]}`, pFunctionName))
										if ((tmpInput.PictForm.InputType == 'Option') || this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `I${tmpInput.Hash}-P${tmpInputProviderList[l]}`, pFunctionName))
										{
											this.pict.providers[tmpInputProviderList[l]][pFunctionName](this, tmpGroup, j, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, tmpTransactionGUID);
										}
									}
									catch (pError)
									{
										this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to run provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}] with error: ${pError}`);
									}
								}
								else
								{
									this.log.error(`Dynamic form runInputProviderFunctions core [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[l]}] for input [${tmpInput.Hash}].`);
								}
							}
						}
					}
				}
			}

			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					let tmpTabularRecordSet = this.getTabularRecordSet(tmpGroup.GroupIndex);
					// No data in the record set, no events to push to providers.
					if (!tmpTabularRecordSet)
					{
						continue;
					}

					if (Array.isArray(tmpTabularRecordSet))
					{
						let tmpInput = tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]];
						// Now run any providers connected to this input
						if (tmpInput && tmpInput.PictForm
							&& (!pInputHash || (pInputHash === tmpInput.Hash)))
						{
							let tmpInputProviderList = this.getInputProviderList(tmpInput);
							for (let l = 0; l < tmpInputProviderList.length; l++)
							{
								let tmpRowsToExecute = [];
								if (pRowIndex != null)
								{
									if (pRowIndex < tmpTabularRecordSet.length)
									{
										tmpRowsToExecute.push(pRowIndex);
									}
									else
									{
										this.log.error(`Dynamic form runInputProviderFunctions [${this.Hash}]::[${this.UUID}] row index ${pRowIndex} is out of bounds for input [${tmpInput.Hash}] with ${tmpTabularRecordSet.length} rows.`);
									}
								}
								else
								{
									for (let r = 0; r < tmpTabularRecordSet.length; r++)
									{
										tmpRowsToExecute.push(r);
									}
								}
								for (const r of tmpRowsToExecute)
								{
									if (this.pict.providers[tmpInputProviderList[l]] &&
										(pRowIndex === undefined || pRowIndex === null || pRowIndex === r))
									{
										// There is a provider, we have an input and it is supposed to be run through for a record
										let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, r, tmpInput.PictForm.InformaryDataAddress);
										let tmpValue = this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpValueAddress);
										try
										{
											if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `TI${tmpInput.Hash}-P${tmpInputProviderList[l]}-R${r}`, pFunctionName))
											{
												this.pict.providers[tmpInputProviderList[l]][pFunctionName + 'Tabular'](this, tmpGroup, tmpInput, tmpValue, tmpInput.Macro.HTMLSelectorTabular, r, tmpTransactionGUID);
											}
										}
										catch (pError)
										{
											this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to run provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}] with error: ${pError}`);
										}
									}
									else
									{
										this.log.error(`Dynamic form runInputProviderFunctions supporting [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[l]}] for input [${tmpInput.Hash}]${pRowIndex != null ? ` in row ${pRowIndex}` : ''}.`);
									}
								}
							}
						}
					}
				}
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Checks if a view-specific template exists based on the given template postfix.
	 * @param {string} pTemplatePostfix - The postfix of the template to check.
	 * @returns {boolean} - Returns true if the view-specific template exists, otherwise false.
	 */
	checkViewSpecificTemplate(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return (this.getViewSpecificTemplateHash(pTemplatePostfix) in this.pict.TemplateProvider.templates);
	}

	/**
	 * Returns the template hash for the view specific template.
	 *
	 * @param {string} pTemplatePostfix - The postfix for the template.
	 * @returns {string} The template hash for the view specific template.
	 */
	getViewSpecificTemplateHash(pTemplatePostfix)
	{
		return `${this.formsTemplateSetPrefix}${pTemplatePostfix}`;
	}

	/**
	 * Checks if a theme-specific template exists.
	 *
	 * @param {string} pTemplatePostfix - The postfix of the template.
	 * @returns {boolean} - Returns true if the theme-specific template exists, otherwise false.
	 */
	checkThemeSpecificTemplate(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return (this.getThemeSpecificTemplateHash(pTemplatePostfix) in this.pict.TemplateProvider.templates);
	}

	/**
	 * Returns the theme-specific template hash based on the given template postfix.
	 *
	 * @param {string} pTemplatePostfix - The postfix to be appended to the default template prefix.
	 * @returns {string} The theme-specific template hash.
	 */
	getThemeSpecificTemplateHash(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return `${this.defaultTemplatePrefix}${pTemplatePostfix}`;
	}

	/**
	 * Rebuilds the custom template fore the dynamic form..
	 */
	rebuildCustomTemplate()
	{
		this.pict.providers.MetatemplateGenerator.rebuildCustomTemplate(this);
	}

	/**
	 * Returns the index of a group within the sectionDefinition.Groups array that matches the provided hash.
	 *
	 * @param {string} pGroupHash - The hash value of the group to find.
	 * @returns {number} The index of the group if found; otherwise, -1.
	 */
	getGroupIndexFromHash(pGroupHash)
	{
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			if (this.sectionDefinition.Groups[i].Hash === pGroupHash)
			{
				return i;
			}
		}
		this.log.warn(`PICT View Metatemplate Helper getGroupIndexByHash could not find group with hash [${pGroupHash}].`);
		return -1;
	}

	/**
	 * Get a group by its hash
	 * @param {string} pGroupHash - The hash of the group to retrieve.
	 * @returns {object|boolean} - The group object if found, or false if the group hash is not found.
	 */
	getGroupFromHash(pGroupHash)
	{
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			if (this.sectionDefinition.Groups[i].Hash === pGroupHash)
			{
				return this.sectionDefinition.Groups[i];
			}
		}
		this.log.warn(`PICT View Metatemplate Helper getGroupByHash could not find group with hash [${pGroupHash}].`);
		return false;
	}

	/**
	 * Retrieves a group from the PICT View Metatemplate Helper based on the provided group index.
	 *
	 * @param {number} pGroupIndex - The index of the group to retrieve.
	 * @returns {object|boolean} - The group object if found, or false if the group index is invalid.
	 */
	getGroup(pGroupIndex)
	{
		if (isNaN(pGroupIndex))
		{
			this.log.warn(`PICT View Metatemplate Helper getGroup ${pGroupIndex} was expecting a number.`);
			return false;
		}
		if (pGroupIndex > this.sectionDefinition.Groups.length)
		{
			this.log.warn(`PICT View Metatemplate Helper getGroup ${pGroupIndex} was out of bounds.`);
			return false;
		}

		return this.sectionDefinition.Groups[pGroupIndex];
	}

	/**
	 * Returns all groups in the section.
	 * @returns {Array}
	 */
	getGroups()
	{
		if (!Array.isArray(this.sectionDefinition.Groups))
		{
			return [];
		}
		return this.sectionDefinition.Groups;
	}

	/**
	 * Get a row for an input form group.
	 *
	 * Rows are a horizontal collection of inputs.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pRowIndex
	 * @returns
	 */
	getRow(pGroupIndex, pRowIndex)
	{
		let tmpGroup = this.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			if (isNaN(pRowIndex))
			{
				this.log.warn(`PICT View Metatemplate Helper getRow ${pRowIndex} was expecting a number.`);
				return false;
			}
			if (pRowIndex > tmpGroup.Rows.length)
			{
				//this.log.warn(`PICT View Metatemplate Helper getRow ${pRowIndex} was out of bounds.`);
				return [];
			}
			return tmpGroup.Rows[pRowIndex];
		}
		else
		{
			return false;
		}
	}

	/**
	 * Get a customized key value pair object for a specific row.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {Object} a key value pair for a specific row, used in metatemplating.
	 */
	getRowKeyValuePair(pGroupIndex, pRowIndex)
	{
		return { Key: pGroupIndex, Value: this.getRow(pGroupIndex, pRowIndex), Group: this.getGroup(pGroupIndex) };
	}

	/**
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns {Object|boolean} The input object if found, or false if the input index is invalid.
	 */
	getInput(pGroupIndex, pRowIndex, pInputIndex)
	{
		let tmpRow = this.getRow(pGroupIndex, pRowIndex);

		if (tmpRow)
		{
			if (isNaN(pInputIndex))
			{
				this.log.warn(`PICT View Metatemplate Helper getInput ${pInputIndex} was expecting a number.`);
				return false;
			}
			if (pInputIndex > tmpRow.Inputs.length)
			{
				this.log.warn(`PICT View Metatemplate Helper getInput ${pInputIndex} was out of bounds.`);
				return false;
			}
			return tmpRow.Inputs[pInputIndex];
		}
		else
		{
			return false;
		}
	}

	/**
	 * Retrieves the input provider list for the given input object.
	 *
	 * @param {Object} pInput - The input object.
	 * @returns {Array} The input provider list.
	 */
	getInputProviderList(pInput)
	{
		if (!('PictForm' in pInput))
		{
			return [];
		}
		if (('Providers' in pInput.PictForm) && Array.isArray(pInput.PictForm.Providers))
		{
			let tmpDefaultProviders = this.pict.providers.DynamicInput.getDefaultInputProviders(this, pInput);

			if (tmpDefaultProviders.length > 0)
			{
				return tmpDefaultProviders.concat(pInput.PictForm.Providers);
			}
			return pInput.PictForm.Providers;
		}
		else
		{
			return this.pict.providers.DynamicInput.getDefaultInputProviders(this, pInput);
		}
	}

	/**
	 * Retrieves the input object for a specific hash.
	 *
	 * @param {string} pInputHash - The string hash for an input (not the address).
	 * @returns {Object} The input Object for the given hash.
	 */
	getInputFromHash(pInputHash)
	{
		return this.sectionManifest.getDescriptorByHash(pInputHash);
	}

	/**
	 * Triggers a DataRequest event for an Input Provider
	 *
	 * @param {String} pInputHash - The input hash.
	 * @param {any} [pEvent] - The input event.
	 * @returns {boolean} Whether or not the data request was successful.
	 */
	inputDataRequest(pInputHash, pEvent)
	{
		return this.pict.providers.DynamicInputEvents.inputDataRequest(this, pInputHash, pEvent);
	}

	/**
	 * Handles the generic Input Event for an Input Provider
	 *
	 * @param {String} pInputHash - The input hash object.
	 * @param {string} pEvent - The input event string.
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 * @returns {any} - The result of the input event handling.
	 */
	inputEvent(pInputHash, pEvent, pTransactionGUID)
	{
		return this.pict.providers.DynamicInputEvents.inputEvent(this, pInputHash, pEvent, pTransactionGUID);
	}

	/**
	 * @deprecated
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	globalInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		this.manifestInputEvent(pEvent, pCompletedHashes, pTransactionGUID);
	}

	/**
	 *
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	manifestInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpInputHashes = Object.keys(this.sectionManifest.elementHashes);

		for (let i = 0; i < tmpInputHashes.length; i++)
		{
			if (!(tmpInputHashes[i] in pCompletedHashes))
			{
				pCompletedHashes[tmpInputHashes[i]] = true;
				this.inputEvent(tmpInputHashes[i], pEvent, pTransactionGUID);
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			// We created a transaction, so finalize it.
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Triggers a DataRequest event for an Input Provider
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} [pEvent] - The input event.
	 * @returns {Promise<any>} A promise that resolves with the input data.
	 */
	inputDataRequestTabular(pGroupIndex, pInputIndex, pRowIndex, pEvent)
	{
		return this.pict.providers.DynamicInputEvents.inputDataRequestTabular(this, pGroupIndex, pInputIndex, pRowIndex, pEvent);
	}

	/**
	 * Handles the generic Tabular Input Event for an Input Provider
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pEvent - The input event object.
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 * @returns {any} - The result of the input event handling.
	 */
	inputEventTabular(pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID)
	{
		return this.pict.providers.DynamicInputEvents.inputEventTabular(this, pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 */
	registerEventTransactionAsyncOperation(pTransactionGUID, pAsyncOperationHash)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, pAsyncOperationHash, PENDING_ASYNC_OPERATION_TYPE);
	}

	/**
	 * FIXME: consolidate with same functions(s) in the metacontroller
	 *
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 *
	 * @return {boolean} - Returns true if the async operation was found and marked as complete, otherwise false.
	 */
	eventTransactionAsyncOperationComplete(pTransactionGUID, pAsyncOperationHash)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpMarkedOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				if (tmpQueueItem.Data === pAsyncOperationHash)
				{
					tmpQueue.splice(i, 1);
					++tmpMarkedOperationCount;
					--i;
				}
				else
				{
					++tmpPendingAsyncOperationCount;
				}
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpMarkedOperationCount === 0)
		{
			this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete ${pTransactionGUID} could not find async operation with hash ${pAsyncOperationHash}.`);
			return;
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			for (let i = 0; i < tmpQueue.length; i++)
			{
				const tmpQueueItem = tmpQueue[i];
				if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
				{
					tmpQueue.splice(i, 1);
					--i;
					if (typeof tmpQueueItem.Data !== 'function')
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback was not a function.`);
						continue;
					}
					try
					{
						tmpQueueItem.Data();
					}
					catch (pError)
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback error: ${pError}`, { Stack: pError.stack });
					}
				}
			}
			delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		}
		return tmpMarkedOperationCount > 0;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 *
	 * @return {boolean} - Returns true if the transaction was found and able to be finalized, otherwise false.
	 */
	finalizeTransaction(pTransactionGUID)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, null, READY_TO_FINALIZE_TYPE);

		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
		}
		if (tmpPendingAsyncOperationCount > 0)
		{
			this.pict.log.info(`PICT View Metatemplate Helper finalizeTransaction ${pTransactionGUID} is waiting on ${tmpPendingAsyncOperationCount} pending async operations.`);
			return false;
		}
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
			{
				tmpQueue.splice(i, 1);
				--i;
				if (typeof tmpQueueItem.Data !== 'function')
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback was not a function.`);
					continue;
				}
				try
				{
					tmpQueueItem.Data();
				}
				catch (pError)
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback error: ${pError}`, { Stack: pError.stack });
				}
			}
		}
		delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		return true;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Function} fCallback - The callback to call when the transaction is complete.
	 */
	registerOnTransactionCompleteCallback(pTransactionGUID, fCallback)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			fCallback();
		}
		else
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, fCallback, TRANSACTION_COMPLETE_CALLBACK_TYPE);
		}
	}

	/**
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	groupInputEvent(pGroupIndex, pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpGroup = this.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper subManifestInputEvent ${pGroupIndex} is not a valid group index.`);
			return;
		}

		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		if (tmpGroup.Rows.length < 1)
		{
			// tabular
			const tmpRecordSetRows = this.getTabularRecordSet(pGroupIndex);
			if (!Array.isArray(tmpRecordSetRows))
			{
				return;
			}
			for (let i = 0; i < tmpRecordSetRows.length; i++)
			{
				for (const tmpInput of Object.values(tmpGroup.supportingManifest.elementDescriptors))
				{
					const tmpInputSignature = `${this.Hash}-${tmpGroup.Hash}-${tmpInput.Hash}-${i}`;
					if (!(tmpInputSignature in pCompletedHashes))
					{
						pCompletedHashes[tmpInputSignature] = true;
						this.inputEventTabular(pGroupIndex, tmpInput.PictForm.InputIndex, i, pEvent, tmpTransactionGUID);
					}
				}
			}
		}
		for (const tmpRow of tmpGroup.Rows || [])
		{
			for (const tmpInput of tmpRow.Inputs || [])
			{
				const tmpInputSignature = `${this.Hash}-${tmpGroup.Hash}-${tmpInput.Hash}-${tmpRow.Hash}`;
				if (!(tmpInputSignature in pCompletedHashes))
				{
					pCompletedHashes[tmpInputSignature] = true;
					this.inputEvent(tmpInput.Hash, pEvent, tmpTransactionGUID);
				}
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			// We created a transaction, so finalize it.
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 *
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	sectionInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpGroupCount = this.sectionDefinition.Groups.length;
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}

		for (let i = 0; i < tmpGroupCount; i++)
		{
			this.groupInputEvent(i, pEvent, pCompletedHashes, pTransactionGUID);
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Get the input object for a specific tabular record group and index.
	 *
	 * Input objects are not distinct among rows.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns
	 */
	getTabularRecordInput(pGroupIndex, pInputIndex)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordInput(this, pGroupIndex, pInputIndex);
	}

	/**
	 * Get the input object for a specific tabular record group and index.
	 *
	 * Input objects are not distinct among rows.
	 *
	 * @param {string} pGroupHash - The hash of the group.
	 * @param {string} pInputHash - The hash of the input.
	 *
	 * @return {Object} The input object.
	 */
	getTabularRecordInputByHash(pGroupHash, pInputHash)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordInputByHash(this, pGroupHash, pInputHash);
	}

	/**
	 * Get the tabular record object for a particular row in a group.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pRowIdentifier - The row number
	 * @returns {Object} The record for the particular row
	 */
	getTabularRecordData(pGroupIndex, pRowIdentifier)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordData(this, pGroupIndex, pRowIdentifier);
	}

	/**
	 * Get the tabular record set for a particular group.
	 *
	 * @param {number} pGroupIndex
	 * @returns {Array} The record set for the group.
	 */
	getTabularRecordSet(pGroupIndex)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordSet(this, pGroupIndex);
	}

	/**
	 * Add a new data row to the end of a dynamic tabular group.
	 *
	 * This will generate any defaults in the SubManifest.
	 *
	 * @param {number} pGroupIndex
	 * @returns
	 */
	createDynamicTableRow(pGroupIndex)
	{
		return this.pict.providers.DynamicTabularData.createDynamicTableRow(this, pGroupIndex);
	}

	/**
	 * Move a dynamic table row to an arbitrary position in the array.
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move
	 * @param {number} pNewRowIndex - The new position for the row
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	setDynamicTableRowIndex(pGroupIndex, pRowIndex, pNewRowIndex)
	{
		return this.pict.providers.DynamicTabularData.setDynamicTableRowIndex(this, pGroupIndex, pRowIndex, pNewRowIndex);
	}

	/**
	 * Move a dynamic table row down
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move down
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	moveDynamicTableRowDown(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.moveDynamicTableRowDown(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Move a dynamic table row up
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move up
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	moveDynamicTableRowUp(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.moveDynamicTableRowUp(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Deletes a dynamic table row.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {Promise} A promise that resolves when the row is deleted.
	 */
	deleteDynamicTableRow(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.deleteDynamicTableRow(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Returns whether the current form is a Pict Section form.
	 * @returns {boolean} True if the form is a Pict Section form, false otherwise.
	 */
	get isPictSectionForm()
	{
		return true;
	}
}

module.exports = PictViewDynamicForm;

module.exports.default_configuration = _DefaultConfiguration;

},{"../../package.json":496,"./Pict-View-DynamicForm-DefaultConfiguration.json":562,"pict-view":693}],564:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictDynamicFormDependencyManager = require(`../services/Pict-Service-DynamicFormDependencyManager.js`);
const libPictViewDynamicForm = require('./Pict-View-DynamicForm.js');

// TODO: Potentially create an internalized list of views for this to manage, separate from the pict.views object
// TODO: Manage view lifecycle internally, including destruction of views if they are flagged to not be needed.
// Why?  This allows us to dynamically add and remove sections without having to reload the application.

// Solver directives iterate: their headers name addresses to iterate over, and declare iteration variables
// that are locals of the expression rather than anything the manifest owns.
const SOLVER_DIRECTIVE_CODES = new Set([ 'SERIES', 'MONTECARLO', 'MAP', 'MULTIROWMAP' ]);

// Everything an injected copy of a manifest can say about itself, grouped by how createDistinctManifest has
// to translate it. These drive the translation below and are exported as the checklist the injection
// conformance tests measure fixture coverage against, so a new construct cannot be added in one place only.
const INJECTION_INPUT_SECTION_HASH_PROPERTIES = [ 'TabSectionSet', 'DefaultTabSectionHash' ];
const INJECTION_INPUT_GROUP_HASH_PROPERTIES = [ 'TabGroupSet', 'DefaultTabGroupHash' ];
const INJECTION_INPUT_SOLVER_PROPERTIES = [ 'ChartLabelsSolver', 'ChartConfigCorePrototype' ];
const INJECTION_INPUT_SOLVER_SET_PROPERTIES = [ { Property: 'ChartDatasetsSolvers', SolverProperty: 'DataSolver' } ];
const INJECTION_INPUT_ADDRESS_PROPERTIES = [ 'ChartLabelsAddress', 'ChartDatasetsAddress', 'ChartConfigCorePrototypeAddress' ];
const INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES = [ 'AutofillTriggerGroup', 'TemplatedEntityLookup', 'TabularTriggerGroup' ];
// A trigger group hash held on its own rather than inside a trigger group configuration. Both sides of a
// trigger read the hash from their own configuration, so salting every carrier keeps a copy's triggers
// inside that copy.
const INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES = [ 'TriggerGroupHash', 'EntityBundleTriggerGroup' ];
const INJECTION_INPUT_TEMPLATE_PROPERTIES = [ 'Template' ];
const INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES = [ 'EntitiesBundle' ];
const INJECTION_ENTITY_BUNDLE_ADDRESS_PROPERTIES = [ 'Destination' ];
const INJECTION_ENTITY_BUNDLE_TEMPLATE_PROPERTIES = [ 'Filter', 'EntityFilterTemplate' ];
const INJECTION_TRIGGER_GROUP_SOLVER_PROPERTIES = [ 'PreSolvers', 'PostSolvers' ];
const INJECTION_MANIFEST_CONSTRUCTS = [ 'Sections.Solvers', 'Sections.Groups.RecordSetAddress', 'Sections.Groups.RecordSetSolvers', 'ReferenceManifests', 'ValidationSolvers', 'Descriptors.DataAddress', 'Descriptors.Hash', 'Descriptors.PictForm.Section', 'Descriptors.PictForm.Group' ];

const PENDING_ASYNC_OPERATION_TYPE = 'PendingAsyncOperation';
const TRANSACTION_COMPLETE_CALLBACK_TYPE = 'onTransactionComplete';
const READY_TO_FINALIZE_TYPE = 'ReadyToFinalize';

/**
 * @typedef {(a: any, b: any) => number} SortFunction
 * @typedef {import('manyfest').ManifestDescriptor} ManifestDescriptor
 */

/**
 * Class representing a PictFormMetacontroller.
 *
 * The metacontroller creates, manages and runs dynamic views and their lifecycle events.
 *
 * @extends libPictViewClass
 */
class PictFormMetacontroller extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictFormMetacontroller';

		// Load the dynamic application dependencies if they don't exist
		this.fable.addAndInstantiateSingletonService('PictDynamicFormDependencyManager', libPictDynamicFormDependencyManager.default_configuration, libPictDynamicFormDependencyManager);

		this.lastRenderedViews = [];

		this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;

		this.manifest = this.pict.manifest;

		this.AutoSolveOnFirstRender = true;
		this.FirstRenderCompleted = false;

		// The PictForm properties an injected manifest can carry a trigger group in, and those that carry a
		// bare trigger group hash. A host that ships input providers of its own pushes its own carriers onto
		// these, so they are salted along with the rest when a manifest is injected.
		this.injectionTriggerGroupProperties = INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES.slice();
		this.injectionTriggerGroupHashProperties = INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES.slice();

		// Destination address for entity comprehensions generated by the addComprehensionEntity solver
		// function.  Resolves relative to the pict instance (so `AppData.X`, `Bundle.X`, etc. all work).
		// Override in code (`this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress = '...'`)
		// or via the view options (`ComprehensionDestinationAddress`).
		this.comprehensionDestinationAddress = (this.options && typeof this.options.ComprehensionDestinationAddress === 'string' && this.options.ComprehensionDestinationAddress.length > 0)
			? this.options.ComprehensionDestinationAddress
			: 'AppData.FormEntityComprehensions';

		this.SupportViewPrototypes = (
		{
			LifecycleVisualization: require('./support/Pict-View-PSF-LifeCycle-Visualization.js'),
			DebugViewer: require('./support/Pict-View-PSF-DebugViewer.js'),
			AppDataViewer: require('./support/Pict-View-PSF-AppData-Visualization.js'),
			SolverVisualization: require('./support/Pict-View-PSF-Solver-Visualization.js'),
			SpecificSolveVisualization: require('./support/Pict-View-PSF-SpecificSolve-Visualization.js'),
		});
	}

	get viewMarshalDestination()
	{
		return this.pict.providers.DataBroker.marshalDestination;
	}

	set viewMarshalDestination(pValue)
	{
		this.pict.providers.DataBroker.marshalDestination = pValue;
	}

	/**
	 * Marshals data from the view to the model, usually AppData (or configured data store).
	 *
	 * @returns {any} The result of the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalFromView();
			}
		}
		return super.onMarshalFromView();
	}

	/**
	 * Marshals the data to the view from the model, usually AppData (or configured data store).
	 *
	 * @returns {any} The result of the super.onMarshalToView() method.
	 */
	onMarshalToView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalToView();
			}
		}
		return super.onMarshalToView();
	}

	gatherInitialBundle(fCallback)
	{
		// Runs before bootstrap has set manifestDescription, so fall back to the manifest bootstrap will use.
		const tmpManifestDescription = this.manifestDescription || this.fable.settings.DefaultFormManifest;
		if (tmpManifestDescription && Array.isArray(tmpManifestDescription.InitialBundle))
		{
			this.log.info(`Gathering initial bundle for ${tmpManifestDescription.InitialBundle.length} entities.`);
			return this.pict.EntityProvider.gatherDataFromServer(tmpManifestDescription.InitialBundle, (pError) =>
			{
				// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
				setTimeout(() => fCallback(pError), 0);
			});
		}
		else
		{
			this.log.info('No initial bundle to gather.');
			return fCallback();
		}
	}

	/**
	 * Executes after the initialization of the object.
	 *
	 * @param {ErrorCallback} fCallback - The callback function to be executed after the initialization.
	 * @returns {void}
	 */
	onAfterInitializeAsync(fCallback)
	{

		return super.onAfterInitializeAsync(
			function (pError)
			{
				if (pError)
				{
					return fCallback(pError);
				}
				this.gatherInitialBundle((pError) =>
				{
					// This is safe -- if there is no settings.DefaultFormManifest configuration, it just doesn't do anything
					this.bootstrapPictFormViewsFromManifest();
					// Generate the metatemplate (the container for each section)
					this.generateMetatemplate();

					return fCallback(pError);
				});
			}.bind(this));
	}

	/**
	 * Executes after the view is rendered.
	 * It regenerates the form section templates, renders the form sections,
	 * and optionally populates the form with data.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 *
	 * @return {boolean} The result of the superclass's onAfterRender method.
	 */
	onAfterRender(pRenderable)
	{
		const res = super.onAfterRender(pRenderable);
		this.regenerateFormSectionTemplates();
		this.renderFormSections();

		if (this.AutoSolveOnFirstRender && !this.FirstRenderCompleted)
		{
			this.FirstRenderCompleted = true;
			this.pict.providers.DynamicSolver.solveViews();
		}

		if (this.options.AutoPopulateAfterRender)
		{
			this.marshalToView();
		}
		return res;
	}

	/**
	 * Executes the solve operation -- automatically solves all dynamic views that are present.
	 *
	 * @returns {any} The result of the solve operation.
	 */
	onSolve()
	{
		this.pict.providers.DynamicSolver.solveViews();
		return super.onSolve();
	}

	runSolver(pExpression, pSilent)
	{
		this.pict.providers.DynamicSolver.runSolver(pExpression, pSilent);
	}

	onBeforeFilterViews(pViewFilterState)
	{
		return pViewFilterState;
	}

	onAfterFilterViews(pViewFilterState)
	{
		return pViewFilterState;
	}

	/**
	 * @param {string} pSectionManifestHash - The hash of the section to find.
	 *
	 * @return {Record<string, any>} The section definition object, or undefined if not found.
	 */
	findDynamicSectionManifestDefinition(pSectionManifestHash)
	{
		const sectionManifest = this.manifestDescription?.ReferenceManifests?.[pSectionManifestHash];
		if (typeof(sectionManifest) !== 'object')
		{
			this.log.error(`findDynamicSectionManifestDefinition() could not find a section manifest with hash [${pSectionManifestHash}]`);
			return null;
		}
		return sectionManifest;
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to add
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 *
	 * @return {Array<import('./Pict-View-DynamicForm.js')>} the views that correspond to the newly added sections
	 */
	injectManifestAndRender(pManifest, pAfterSectionHash, pUUID)
	{
		const tmpManifest = pUUID ? this.createDistinctManifest(pManifest, pUUID) : pManifest;
		const tmpViewsToRender = this.injectManifest(tmpManifest, pAfterSectionHash);
		this.updateMetatemplateInDOM();
		//FIXME: for some reason, DOM append is not synchronous, so we need to delay the render....................?
		setTimeout(() =>
		{
			for (const tmpViewToRender of tmpViewsToRender)
			{
				tmpViewToRender.render();
			}
			if (this.options.AutoPopulateAfterRender)
			{
				for (const tmpViewToRender of tmpViewsToRender)
				{
					tmpViewToRender.marshalToView();
				}
			}
		}, 0);

		return tmpViewsToRender;
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to add
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 *
	 * @return {Array<import('./Pict-View-DynamicForm.js')>} the views that correspond to the newly added sections; note that these views are NOT rendered yet
	 */
	injectManifest(pManifest, pAfterSectionHash)
	{
		const tmpAfterSectionHash = pAfterSectionHash ? (pAfterSectionHash.startsWith('PictSectionForm-') ? pAfterSectionHash : `PictSectionForm-${pAfterSectionHash}`) : null;
		const tmpAllViewKeys = Object.keys(this.pict.views);
		const tmpReferenceManifestViewIndex = tmpAfterSectionHash ? tmpAllViewKeys.indexOf(tmpAfterSectionHash) : -1;
		const tmpViewsToShift = [];
		if (tmpReferenceManifestViewIndex >= 0)
		{
			// reorder views (hacky - add layer to do this more directly)
			for (let i = tmpReferenceManifestViewIndex + 1; i < tmpAllViewKeys.length; i++)
			{
				const tmpKey = tmpAllViewKeys[i];
				tmpViewsToShift.push({ key: tmpKey, view: this.pict.views[tmpKey] });
				delete this.pict.views[tmpKey];
			}
		}
		const tmpViewsToRender = this.bootstrapAdditiveManifest(pManifest, tmpAfterSectionHash);
		for (const tmpViewToShift of tmpViewsToShift)
		{
			this.pict.views[tmpViewToShift.key] = tmpViewToShift.view;
		}
		// this ensures if we re-render everything, we have the new sections in the template
		this.generateMetatemplate();
		for (const tmpViewToRender of tmpViewsToRender)
		{
			tmpViewToRender.rebuildCustomTemplate();
		}
		this.pict.CSSMap.injectCSS();

		return tmpViewsToRender;
	}

	/**
	 * Builds translation maps for addresses and hashes based on the manifest. This is used for rewriting solver expressions to map them to distinct manifests.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to build translations from.
	 *
	 * @return {{ AddressTranslation: Record<string, string>, HashTranslation: Record<string, string> }} The translation maps for addresses and hashes.
	 */
	buildManifestTranslations(pManifest)
	{
		/** @type {Record<string, string>} */
		const tmpAddressTranslation = {};
		/** @type {Record<string, string>} */
		const tmpHashTranslation = {};
		/** @type {Array<string>} */
		const tmpCollisions = [];
		/**
		 * @param {Record<string, string>} pTranslation - The map being filled.
		 * @param {string} pOriginal - What the reference was called before the copy was salted.
		 * @param {string} pTranslated - What it is called in this copy.
		 */
		const addTranslation = (pTranslation, pOriginal, pTranslated) =>
		{
			if ((pOriginal in pTranslation) && (pTranslation[pOriginal] !== pTranslated))
			{
				tmpCollisions.push(`${pOriginal} -> ${pTranslation[pOriginal]} | ${pTranslated}`);
			}
			pTranslation[pOriginal] = pTranslated;
		};
		for (const tmpSection of pManifest.Sections || [])
		{
			if (tmpSection.OriginalHash)
			{
				addTranslation(tmpAddressTranslation, tmpSection.OriginalHash, tmpSection.Hash);
			}
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (tmpGroup.OriginalHash)
				{
					addTranslation(tmpAddressTranslation, tmpGroup.OriginalHash, tmpGroup.Hash);
				}
			}
		}
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				addTranslation(tmpAddressTranslation, tmpDescriptor.OriginalDataAddress, tmpDescriptor.DataAddress);
			}
			if (tmpDescriptor.OriginalHash)
			{
				addTranslation(tmpHashTranslation, tmpDescriptor.OriginalHash, tmpDescriptor.Hash);
			}
		}
		if (tmpCollisions.length > 0)
		{
			// More than one copy of the same manifest is in here, so no single map can say what a name became.
			// Build the translation from each copy as it is salted instead of from the form they were merged into.
			this.pict.log.warn(`PictFormMetacontroller.buildManifestTranslations: ${tmpCollisions.length} reference(s) translate to more than one destination, so the last one wins. This manifest holds more than one injected copy.`, { Collisions: tmpCollisions.slice(0, 10) });
		}
		return { AddressTranslation: tmpAddressTranslation, HashTranslation: tmpHashTranslation };
	}

	/**
	 * Translates a reference to something the manifest owns -- an exact hash or address, or a reference that
	 * only starts with one (`Rows.length`, `Rows[0].Line`, `Crate.Items.length`), where the longest address
	 * the reference starts with wins.
	 *
	 * @param {string} pReference - The reference to translate.
	 * @param {Record<string, string>} pPrimaryTranslation - Consulted first: hashes for symbols, addresses for address-shaped references.
	 * @param {Record<string, string>} pSecondaryTranslation - Consulted second.
	 * @param {Record<string, string>} [pPrefixTranslation] - Addresses that a partial reference may start with.
	 *
	 * @return {string|null} The translated reference, or null when the manifest does not own it.
	 */
	translateManifestReference(pReference, pPrimaryTranslation, pSecondaryTranslation, pPrefixTranslation)
	{
		if ((typeof(pReference) !== 'string') || (pReference.length === 0))
		{
			return null;
		}
		const tmpPrefixTranslation = pPrefixTranslation || { };
		if (pReference in pPrimaryTranslation)
		{
			return pPrimaryTranslation[pReference];
		}
		if (pReference in pSecondaryTranslation)
		{
			return pSecondaryTranslation[pReference];
		}
		if (pReference in tmpPrefixTranslation)
		{
			return tmpPrefixTranslation[pReference];
		}
		for (let i = pReference.length - 1; i > 0; i--)
		{
			if ((pReference[i] !== '.') && (pReference[i] !== '['))
			{
				continue;
			}
			const tmpPrefix = pReference.substring(0, i);
			if (tmpPrefix in tmpPrefixTranslation)
			{
				return `${tmpPrefixTranslation[tmpPrefix]}${pReference.substring(i)}`;
			}
		}
		return null;
	}

	/**
	 * Finds the SERIES / MAP / MULTIROWMAP / MONTECARLO directive in a tokenized solver expression, if there
	 * is one, and reads its header the way the expression parser does: which header positions hold an address
	 * to iterate over (everything else in a header, keyword or not, is not a reference to translate -- notably
	 * the per-row property a MULTIROWMAP variable reads), and which names the body sees as iteration variables
	 * rather than as addresses.
	 *
	 * @param {Array<string>} pTokens - The raw tokens of the expression.
	 *
	 * @return {{ Code: string, HeaderStart: number, HeaderEnd: number, TranslateIndices: Set<number>, Locals: Set<string> }|null} null when the expression has no directive.
	 */
	parseSolverDirectiveScope(pTokens)
	{
		let tmpDirectiveIndex = -1;
		for (let i = 0; i < pTokens.length; i++)
		{
			if (SOLVER_DIRECTIVE_CODES.has(String(pTokens[i]).toUpperCase()) && ((i === 0) || (pTokens[i - 1] === '=') || (pTokens[i - 1] === '?=')))
			{
				tmpDirectiveIndex = i;
				break;
			}
		}
		if (tmpDirectiveIndex < 0)
		{
			return null;
		}
		const tmpHeaderEnd = pTokens.indexOf(':', tmpDirectiveIndex + 1);
		if (tmpHeaderEnd < 0)
		{
			return null;
		}
		const tmpCode = String(pTokens[tmpDirectiveIndex]).toUpperCase();
		const tmpTranslateIndices = new Set();
		const tmpLocals = new Set([ 'stepIndex' ]);
		if (tmpCode === 'SERIES')
		{
			tmpLocals.add('n');
			tmpLocals.add('prev_n');
		}
		if (tmpCode === 'MULTIROWMAP')
		{
			tmpLocals.add('rowIndex');
		}
		for (let i = tmpDirectiveIndex + 1; i < tmpHeaderEnd; i++)
		{
			const tmpToken = String(pTokens[i]).toUpperCase();
			const tmpPreviousToken = String(pTokens[i - 1]).toUpperCase();
			if ((tmpCode === 'SERIES') && ((tmpPreviousToken === 'FROM') || (tmpPreviousToken === 'TO') || (tmpPreviousToken === 'STEP')))
			{
				tmpTranslateIndices.add(i);
				continue;
			}
			if ((tmpToken !== 'VAR') && (tmpToken !== 'VARIABLE') && (tmpToken !== 'V'))
			{
				if ((tmpCode === 'MULTIROWMAP') && (tmpToken === 'ROWS') && (String(pTokens[i + 1]).toUpperCase() === 'FROM') && ((i + 2) < tmpHeaderEnd))
				{
					tmpTranslateIndices.add(i + 2);
				}
				continue;
			}
			const tmpVariableIndex = i + 1;
			if (tmpVariableIndex >= tmpHeaderEnd)
			{
				continue;
			}
			tmpLocals.add(String(pTokens[tmpVariableIndex]));
			if (tmpCode === 'MAP')
			{
				tmpLocals.add(`prev_${pTokens[tmpVariableIndex]}`);
				if ((String(pTokens[tmpVariableIndex + 1]).toUpperCase() === 'FROM') && ((tmpVariableIndex + 2) < tmpHeaderEnd))
				{
					tmpTranslateIndices.add(tmpVariableIndex + 2);
				}
			}
		}
		return { Code: tmpCode, HeaderStart: tmpDirectiveIndex, HeaderEnd: tmpHeaderEnd, TranslateIndices: tmpTranslateIndices, Locals: tmpLocals };
	}

	/**
	 * Collects every trigger group an injected manifest declares and maps it onto a salted hash, so a change
	 * in one copy does not run the matching trigger group in another copy of the same manifest.
	 *
	 * A manifest that means to hear the form it is injected into lists those hashes in `SharedTriggerGroups`
	 * at its root; those are left alone.
	 *
	 * @param {Record<string, any>} pManifest - The manifest being copied.
	 * @param {string} pUUID - The salt appended to each hash.
	 *
	 * @return {Record<string, string>} Original trigger group hash to salted hash.
	 */
	buildTriggerGroupTranslation(pManifest, pUUID)
	{
		/** @type {Record<string, string>} */
		const tmpTriggerGroupTranslation = {};
		const tmpSharedTriggerGroups = Array.isArray(pManifest.SharedTriggerGroups) ? pManifest.SharedTriggerGroups : [];
		const tmpTriggerGroupProperties = this.injectionTriggerGroupProperties || INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES;
		const tmpTriggerGroupHashProperties = this.injectionTriggerGroupHashProperties || INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES;
		/**
		 * @param {any} pHash - A trigger group hash, or an array of them.
		 */
		const addTriggerGroupHash = (pHash) =>
		{
			if (Array.isArray(pHash))
			{
				for (const tmpHash of pHash)
				{
					addTriggerGroupHash(tmpHash);
				}
				return;
			}
			if ((typeof(pHash) !== 'string') || (pHash.length === 0) || tmpSharedTriggerGroups.includes(pHash))
			{
				return;
			}
			tmpTriggerGroupTranslation[pHash] = `${pHash}_${pUUID}`;
		};
		/**
		 * @param {any} pPictForm - The PictForm configuration of an input.
		 */
		const addInputTriggerGroupHashes = (pPictForm) =>
		{
			if (!pPictForm || (typeof(pPictForm) !== 'object'))
			{
				return;
			}
			for (const tmpTriggerGroupProperty of tmpTriggerGroupProperties)
			{
				const tmpTriggerGroupConfiguration = pPictForm[tmpTriggerGroupProperty];
				const tmpTriggerGroups = Array.isArray(tmpTriggerGroupConfiguration) ? tmpTriggerGroupConfiguration : [ tmpTriggerGroupConfiguration ];
				for (const tmpTriggerGroup of tmpTriggerGroups)
				{
					if (tmpTriggerGroup && (typeof(tmpTriggerGroup) === 'object'))
					{
						addTriggerGroupHash(tmpTriggerGroup.TriggerGroupHash);
					}
				}
			}
			for (const tmpTriggerGroupHashProperty of tmpTriggerGroupHashProperties)
			{
				addTriggerGroupHash(pPictForm[tmpTriggerGroupHashProperty]);
			}
		};
		for (const tmpDescriptor of Object.values(pManifest.Descriptors || {}))
		{
			addInputTriggerGroupHashes(tmpDescriptor.PictForm);
		}
		for (const tmpReferenceManifest of Object.values(pManifest.ReferenceManifests || {}))
		{
			for (const tmpColumnDescriptor of Object.values(tmpReferenceManifest.Descriptors || {}))
			{
				addInputTriggerGroupHashes(tmpColumnDescriptor.PictForm);
			}
		}
		return tmpTriggerGroupTranslation;
	}

	/**
	 * Rewrite a solver expression by tokenizing, replacing address/hash tokens, and recomposing.
	 *
	 * @param {string} pExpression - The solver expression string.
	 * @param {Record<string, string>} pHashTranslation - A mapping of original hashes to new hashes for replacement.
	 * @param {Record<string, string>} pAddressTranslation - A mapping of original addresses to new addresses for replacement.
	 * @param {{ PrefixAddressTranslation?: Record<string, string>, RowRelative?: boolean }} [pOptions] - PrefixAddressTranslation holds the addresses a partial reference may start with (defaults to pAddressTranslation); RowRelative marks an expression solved against a record of a record set rather than against the manifest.
	 *
	 * @return {string} The rewritten expression, or the original if no changes were made.
	 */
	rewriteSolverExpression(pExpression, pHashTranslation, pAddressTranslation, pOptions)
	{
		const tmpHashTranslation = pHashTranslation || { };
		const tmpAddressTranslation = pAddressTranslation || { };
		const tmpOptions = pOptions || { };
		const tmpPrefixAddressTranslation = tmpOptions.PrefixAddressTranslation || tmpAddressTranslation;
		// A record set solver is solved against one record of the set, so a bare reference in it names a column
		// of that record; only references that are absolute can be ours to translate.
		const tmpRowRelative = Boolean(tmpOptions.RowRelative);

		// Use the expression parser tokenizer for discrete token-based solver rewriting.
		// This avoids the regex word-boundary issues when hash and address are the same string.
		const tmpExpressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpMarshalDestination = this.viewMarshalDestination;

		if (typeof(pExpression) !== 'string' || pExpression.length === 0)
		{
			return pExpression;
		}

		/**
		 * @param {string} pReference - The reference held by the token.
		 * @param {boolean} pPreferHash - Whether a hash translation wins over an address translation.
		 * @param {boolean} pManifestRelative - Whether a bare reference resolves against the manifest.
		 *
		 * @return {string|null} The translated reference, or null when nothing matched.
		 */
		const translateReference = (pReference, pPreferHash, pManifestRelative) =>
		{
			if (pManifestRelative)
			{
				const tmpTranslated = this.translateManifestReference(pReference, pPreferHash ? tmpHashTranslation : tmpAddressTranslation, pPreferHash ? tmpAddressTranslation : tmpHashTranslation, tmpPrefixAddressTranslation);
				if (tmpTranslated !== null)
				{
					return tmpTranslated;
				}
			}
			if (tmpMarshalDestination && pReference.startsWith(`${tmpMarshalDestination}.`))
			{
				// Behind the marshal destination the reference is an address, so addresses win over hashes.
				const tmpTranslated = this.translateManifestReference(pReference.substring(tmpMarshalDestination.length + 1), tmpAddressTranslation, tmpHashTranslation, tmpPrefixAddressTranslation);
				if (tmpTranslated !== null)
				{
					return `${tmpMarshalDestination}.${tmpTranslated}`;
				}
			}
			return null;
		};

		let tmpResultObject = {};
		tmpExpressionParser.tokenize(pExpression, tmpResultObject);

		let tmpTokens = Array.from(tmpResultObject.OriginalRawTokens);
		let tmpModified = false;
		const tmpDirectiveScope = this.parseSolverDirectiveScope(tmpTokens);

		// Function context stack for tracking string parameters inside annotated functions
		let tmpFunctionStack = [];
		let tmpParenDepth = 0;

		for (let i = 0; i < tmpTokens.length; i++)
		{
			let tmpToken = tmpTokens[i];
			let tmpTokenType = tmpExpressionParser.Tokenizer.getTokenType(tmpToken);

			if (tmpDirectiveScope)
			{
				if ((i >= tmpDirectiveScope.HeaderStart) && (i <= tmpDirectiveScope.HeaderEnd) && !tmpDirectiveScope.TranslateIndices.has(i))
				{
					continue;
				}
				if ((i > tmpDirectiveScope.HeaderEnd) && tmpDirectiveScope.Locals.has(String(tmpToken).replace(/^\{|\}$/g, '').split(/[.[]/)[0]))
				{
					continue;
				}
			}

			// Track parenthesis depth and function context
			if (tmpToken === '(')
			{
				// Check if the previous token is a known function name
				if (i > 0)
				{
					let tmpPrevToken = tmpTokens[i - 1].toLowerCase();
					if (tmpPrevToken in tmpExpressionParser.functionMap)
					{
						tmpFunctionStack.push({ name: tmpPrevToken, paramIndex: 0, depth: tmpParenDepth });
					}
				}
				tmpParenDepth++;
				continue;
			}
			if (tmpToken === ')')
			{
				tmpParenDepth--;
				if (tmpFunctionStack.length > 0 && tmpFunctionStack[tmpFunctionStack.length - 1].depth === tmpParenDepth)
				{
					tmpFunctionStack.pop();
				}
				continue;
			}
			if (tmpToken === ',')
			{
				if (tmpFunctionStack.length > 0 && tmpFunctionStack[tmpFunctionStack.length - 1].depth === tmpParenDepth - 1)
				{
					tmpFunctionStack[tmpFunctionStack.length - 1].paramIndex++;
				}
				continue;
			}

			// Token.Symbol -- check hash mappings then address mappings
			if (tmpTokenType === 'Token.Symbol')
			{
				const tmpReplacement = translateReference(tmpToken, true, !tmpRowRelative);

				if (tmpReplacement !== null)
				{
					tmpTokens[i] = tmpReplacement;
					tmpModified = true;
				}
			}
			// Token.StateAddress -- extract inner address, check mappings with and without marshal prefix
			else if (tmpTokenType === 'Token.StateAddress')
			{
				const tmpReplacement = translateReference(tmpToken.substring(1, tmpToken.length - 1), false, !tmpRowRelative);

				if (tmpReplacement !== null)
				{
					tmpTokens[i] = `{${tmpReplacement}}`;
					tmpModified = true;
				}
			}
			// Token.String inside an annotated function -- check if this parameter index has addresses
			else if (tmpTokenType === 'Token.String' && tmpFunctionStack.length > 0)
			{
				let tmpCurrentFunc = tmpFunctionStack[tmpFunctionStack.length - 1];
				let tmpFuncEntry = tmpExpressionParser.functionMap[tmpCurrentFunc.name];

				if (tmpFuncEntry && Array.isArray(tmpFuncEntry.AddressParameterIndices) && tmpFuncEntry.AddressParameterIndices.includes(tmpCurrentFunc.paramIndex))
				{
					// String parameters name a hash or an absolute address, never a column of a record.
					const tmpReplacement = translateReference(tmpToken.substring(1, tmpToken.length - 1), true, true);

					if (tmpReplacement !== null)
					{
						tmpTokens[i] = `"${tmpReplacement}"`;
						tmpModified = true;
					}
				}
			}
		}

		if (!tmpModified)
		{
			return pExpression;
		}

		return tmpExpressionParser.recompose(tmpTokens);
	}

	/**
	 * Changes:
	 *   * The hashes of each section+group to be globally unique.
	 *   * The data address of each element to map to a unique location.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to create a distinct copy of.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 *
	 * @return {Record<string, any>} A distinct copy of the manifest.
	 */
	createDistinctManifest(pManifest, pUUID)
	{
		const tmpUUID = pUUID != null ? pUUID : this.pict.getUUID().replace(/-/g, '');
		const tmpManifest = JSON.parse(JSON.stringify(pManifest));
		/** @type {Record<string, string>} */
		const tmpAddressTranslation = {};
		/** @type {Record<string, string>} */
		const tmpSectionTranslation = {};
		/** @type {Record<string, string>} */
		const tmpGroupTranslation = {};
		/** @type {Record<string, string>} */
		const tmpRecordSetTranslation = {};
		/** @type {Record<string, string>} */
		const tmpTriggerGroupTranslation = this.buildTriggerGroupTranslation(tmpManifest, tmpUUID);
		for (const tmpSection of tmpManifest.Sections || [])
		{
			if (!tmpSection.Hash)
			{
				tmpSection.Hash = `${this.fable.getUUID()}`;
			}
			tmpSection.OriginalHash = tmpSection.Hash;
			tmpSection.Hash = `${tmpSection.Hash}_${tmpUUID}`;
			tmpAddressTranslation[tmpSection.OriginalHash] = tmpSection.Hash;
			tmpSectionTranslation[tmpSection.OriginalHash] = tmpSection.Hash;
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (!tmpGroup.Hash)
				{
					tmpGroup.Hash = `${this.fable.getUUID()}`;
				}
				tmpGroup.OriginalHash = tmpGroup.Hash;
				tmpGroup.Hash = `${tmpGroup.Hash}_${tmpUUID}`;
				tmpAddressTranslation[tmpGroup.OriginalHash] = tmpGroup.Hash;
				tmpGroupTranslation[tmpGroup.OriginalHash] = tmpGroup.Hash;
				if (tmpGroup.RecordSetAddress)
				{
					const tmpRecordSetAddress = `${tmpUUID}.${tmpGroup.RecordSetAddress}`;
					this.pict.log.info(`PictFormMetacontroller.createDistinctManifest: Updated group record set address from "${tmpGroup.RecordSetAddress}" to "${tmpRecordSetAddress}".`);
					tmpRecordSetTranslation[tmpGroup.RecordSetAddress] = tmpRecordSetAddress;
					tmpGroup.RecordSetAddress = tmpRecordSetAddress;
				}
			}
		}
		/** @type {Record<string, ManifestDescriptor>} */
		const tmpDescriptors = tmpManifest.Descriptors || {};
		/** @type {Record<string, ManifestDescriptor>} */
		const tmpNewDescriptors = {};
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDescriptors))
		{
			if (!tmpDescriptor.DataAddress)
			{
				tmpDescriptor.DataAddress = tmpKey;
			}
			tmpDescriptor.OriginalDataAddress = tmpDescriptor.DataAddress;
			// we only make distinct top level properties to keep things as tidy as possible so do a split to isoloate that
			//TODO: if we have .. dereferences (for example) in the data address, this may not work properly

			// nest the data addresses inside a container that is unique to this injection
			tmpDescriptor.DataAddress = `${tmpUUID}.${tmpDescriptor.OriginalDataAddress}`;
			if (tmpDescriptor.Address != null)
			{
				tmpDescriptor.Address = tmpDescriptor.DataAddress;
			}
			// nesting doesn't work for hashes, so we append instead for input, section and group hashes
			if (tmpDescriptor.Hash)
			{
				tmpDescriptor.OriginalHash = tmpDescriptor.Hash;
				tmpDescriptor.Hash = `${tmpDescriptor.Hash}_${tmpUUID}`;
			}
			if (tmpDescriptor.PictForm)
			{
				if (tmpDescriptor.PictForm.Section)
				{
					tmpDescriptor.PictForm.Section = `${tmpDescriptor.PictForm.Section}_${tmpUUID}`;
				}
				if (tmpDescriptor.PictForm.Group)
				{
					tmpDescriptor.PictForm.Group = `${tmpDescriptor.PictForm.Group}_${tmpUUID}`;
				}
			}
			tmpNewDescriptors[tmpDescriptor.DataAddress] = tmpDescriptor;
		}
		tmpManifest.Descriptors = tmpNewDescriptors;
		/** @type {Record<string, string>} */
		const tmpHashTranslation = {};
		for (const tmpDescriptor of Object.values(tmpManifest?.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				tmpAddressTranslation[tmpDescriptor.OriginalDataAddress] = tmpDescriptor.DataAddress;
			}
			if (tmpDescriptor.OriginalHash)
			{
				tmpHashTranslation[tmpDescriptor.OriginalHash] = tmpDescriptor.Hash;
			}
		}
		const escapeRegExp =
		/**
		 * @param {string} str - the string to match
		 * @return {string} - the escaped string
		 */
		(str) =>
		{
			return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		}
		for (const [ tmpOriginalAddress, tmpUpdatedAddress ] of Object.entries(tmpAddressTranslation))
		{
			for (const tmpIterAddress of Object.keys(tmpAddressTranslation))
			{
				if (tmpIterAddress === tmpOriginalAddress)
				{
					continue;
				}
				const tmpTranslatedAddress = tmpAddressTranslation[tmpIterAddress].replace(new RegExp(`^${escapeRegExp(tmpOriginalAddress)}\\b`, 'g'), tmpUpdatedAddress);
				if (tmpTranslatedAddress !== tmpAddressTranslation[tmpIterAddress])
				{
					this.pict.log.info(`PictFormMetacontroller.createDistinctManifest: Updated address translation for "${tmpIterAddress}" from "${tmpAddressTranslation[tmpIterAddress]}" to "${tmpTranslatedAddress}".`);
					tmpAddressTranslation[tmpIterAddress] = tmpTranslatedAddress;
					const [ tmpCurrentKey, tmpOriginalDescriptor ] = Object.entries(tmpManifest.Descriptors).find(([ pKey, pDescriptor ]) => pDescriptor.OriginalDataAddress === tmpIterAddress);
					tmpManifest.Descriptors[tmpCurrentKey].DataAddress = tmpTranslatedAddress;
					if (tmpManifest.Descriptors[tmpCurrentKey].Address != null)
					{
						tmpManifest.Descriptors[tmpCurrentKey].Address = tmpManifest.Descriptors[tmpCurrentKey].DataAddress;
					}
					tmpManifest.Descriptors[tmpTranslatedAddress] = tmpManifest.Descriptors[tmpCurrentKey];
					delete tmpManifest.Descriptors[tmpCurrentKey];
				}
			}
		}
		// The addresses a partial reference (`Rows.length`, `Crate.Items[0]`) may start with: every address the
		// manifest declares, plus the record set addresses, which have no descriptor of their own.
		/** @type {Record<string, string>} */
		const tmpPrefixAddressTranslation = Object.assign({}, tmpRecordSetTranslation);
		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				tmpPrefixAddressTranslation[tmpDescriptor.OriginalDataAddress] = tmpDescriptor.DataAddress;
			}
		}

		/**
		 * Rewrite a single solver entry (string or object with Expression property).
		 *
		 * @param {Array} pSolverArray - The array of solvers to rewrite in.
		 * @param {number} pIndex - The index of the solver to rewrite.
		 * @param {string} pLogPrefix - Logging prefix for identification.
		 * @param {{ RowRelative?: boolean }} [pSolverOptions] - Passed through to rewriteSolverExpression.
		 */
		const rewriteSolverEntry = (pSolverArray, pIndex, pLogPrefix, pSolverOptions) =>
		{
			const tmpSolver = pSolverArray[pIndex];
			const tmpSolverExpression = typeof tmpSolver === 'string' ? tmpSolver : tmpSolver.Expression;
			if (!tmpSolverExpression)
			{
				return;
			}
			const tmpUpdatedSolver = this.rewriteSolverExpression(tmpSolverExpression, tmpHashTranslation, tmpAddressTranslation, Object.assign({ PrefixAddressTranslation: tmpPrefixAddressTranslation }, pSolverOptions));
			if (tmpUpdatedSolver !== tmpSolverExpression)
			{
				this.pict.log.info(`PictFormMetacontroller.createDistinctManifest: Updated ${pLogPrefix} ${pIndex} from "${tmpSolverExpression}" to "${tmpUpdatedSolver}".`);
				if (typeof tmpSolver === 'string')
				{
					pSolverArray[pIndex] = tmpUpdatedSolver;
				}
				else
				{
					pSolverArray[pIndex].Expression = tmpUpdatedSolver;
				}
			}
		};

		for (const tmpSection of tmpManifest.Sections || [])
		{
			if (Array.isArray(tmpSection.Solvers) && tmpSection.Solvers.length > 0)
			{
				for (let i = 0; i < tmpSection.Solvers.length; i++)
				{
					rewriteSolverEntry(tmpSection.Solvers, i, 'section solver reference');
				}
			}
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (Array.isArray(tmpGroup.RecordSetSolvers) && tmpGroup.RecordSetSolvers.length > 0)
				{
					for (let i = 0; i < tmpGroup.RecordSetSolvers.length; i++)
					{
						rewriteSolverEntry(tmpGroup.RecordSetSolvers, i, 'group solver reference', { RowRelative: true });
					}
				}
			}
		}

		/**
		 * @param {any} pValue - A hash, or an array of hashes.
		 * @param {Record<string, string>} pTranslation - The hashes this manifest owns.
		 *
		 * @return {any} The value, with any hash the manifest owns translated.
		 */
		const translateHashReference = (pValue, pTranslation) =>
		{
			if (typeof(pValue) === 'string')
			{
				return (pValue in pTranslation) ? pTranslation[pValue] : pValue;
			}
			if (Array.isArray(pValue))
			{
				return pValue.map((pHash) => (((typeof(pHash) === 'string') && (pHash in pTranslation)) ? pTranslation[pHash] : pHash));
			}
			return pValue;
		};

		/**
		 * Configuration addresses resolve from the application root, so they are only ours when they point
		 * into the marshal destination.
		 *
		 * @param {any} pAddress - The configured address.
		 *
		 * @return {any} The address, nested into this injection when the manifest owns it.
		 */
		const rewriteAbsoluteAddress = (pAddress) =>
		{
			const tmpMarshalDestination = this.viewMarshalDestination;
			if ((typeof(pAddress) !== 'string') || !tmpMarshalDestination || !pAddress.startsWith(`${tmpMarshalDestination}.`))
			{
				return pAddress;
			}
			const tmpTranslated = this.translateManifestReference(pAddress.substring(tmpMarshalDestination.length + 1), tmpAddressTranslation, tmpHashTranslation, tmpPrefixAddressTranslation);
			return (tmpTranslated === null) ? pAddress : `${tmpMarshalDestination}.${tmpTranslated}`;
		};

		/**
		 * @param {any} pSolverExpression - A solver expression configured on an input.
		 * @param {string} pLogPrefix - Logging prefix for identification.
		 *
		 * @return {any} The rewritten expression.
		 */
		const rewriteSolverValue = (pSolverExpression, pLogPrefix) =>
		{
			if (typeof(pSolverExpression) !== 'string')
			{
				return pSolverExpression;
			}
			const tmpSolverContainer = [ pSolverExpression ];
			rewriteSolverEntry(tmpSolverContainer, 0, pLogPrefix);
			return tmpSolverContainer[0];
		};

		/**
		 * Input templates render against the marshal destination, so the addresses they reference are ours.
		 *
		 * @param {any} pTemplate - The configured template.
		 *
		 * @return {any} The template, with local addresses nested into this injection.
		 */
		const rewriteTemplateAddresses = (pTemplate) =>
		{
			if (typeof(pTemplate) !== 'string')
			{
				return pTemplate;
			}
			const tmpMarshalDestination = this.viewMarshalDestination;
			const tmpTemplateRoots = [ 'Record.Data.' ];
			if (tmpMarshalDestination)
			{
				tmpTemplateRoots.push(`${tmpMarshalDestination}.`);
			}
			let tmpTemplate = pTemplate;
			for (const tmpTemplateRoot of tmpTemplateRoots)
			{
				tmpTemplate = tmpTemplate.replace(new RegExp(`${escapeRegExp(tmpTemplateRoot)}([A-Za-z0-9_$.[\\]]+)`, 'g'),
					(pMatch, pAddress) =>
					{
						const tmpTranslated = this.translateManifestReference(pAddress, tmpAddressTranslation, tmpHashTranslation, tmpPrefixAddressTranslation);
						return (tmpTranslated === null) ? pMatch : `${tmpTemplateRoot}${tmpTranslated}`;
					});
			}
			return tmpTemplate;
		};

		/**
		 * Entity bundles gather server data into an address, filtered by a template; both can point at
		 * something this manifest owns.
		 *
		 * @param {any} pEntitiesBundle - The configured entity bundle array.
		 */
		const rewriteEntitiesBundle = (pEntitiesBundle) =>
		{
			if (!Array.isArray(pEntitiesBundle))
			{
				return;
			}
			for (const tmpEntityBundle of pEntitiesBundle)
			{
				if (!tmpEntityBundle || (typeof(tmpEntityBundle) !== 'object'))
				{
					continue;
				}
				for (const tmpAddressProperty of INJECTION_ENTITY_BUNDLE_ADDRESS_PROPERTIES)
				{
					if (tmpEntityBundle[tmpAddressProperty])
					{
						tmpEntityBundle[tmpAddressProperty] = rewriteAbsoluteAddress(tmpEntityBundle[tmpAddressProperty]);
					}
				}
				for (const tmpTemplateProperty of INJECTION_ENTITY_BUNDLE_TEMPLATE_PROPERTIES)
				{
					if (tmpEntityBundle[tmpTemplateProperty])
					{
						tmpEntityBundle[tmpTemplateProperty] = rewriteTemplateAddresses(tmpEntityBundle[tmpTemplateProperty]);
					}
				}
			}
		};

		/**
		 * @param {any} pTriggerGroup - A trigger group configuration.
		 */
		const rewriteTriggerGroup = (pTriggerGroup) =>
		{
			if (!pTriggerGroup || (typeof(pTriggerGroup) !== 'object'))
			{
				return;
			}
			for (const tmpTemplateProperty of INJECTION_INPUT_TEMPLATE_PROPERTIES)
			{
				if (pTriggerGroup[tmpTemplateProperty])
				{
					pTriggerGroup[tmpTemplateProperty] = rewriteTemplateAddresses(pTriggerGroup[tmpTemplateProperty]);
				}
			}
			for (const tmpEntityBundleProperty of INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES)
			{
				rewriteEntitiesBundle(pTriggerGroup[tmpEntityBundleProperty]);
			}
			for (const tmpSolverProperty of INJECTION_TRIGGER_GROUP_SOLVER_PROPERTIES)
			{
				if (Array.isArray(pTriggerGroup[tmpSolverProperty]))
				{
					for (let i = 0; i < pTriggerGroup[tmpSolverProperty].length; i++)
					{
						rewriteSolverEntry(pTriggerGroup[tmpSolverProperty], i, `trigger group ${tmpSolverProperty} reference`);
					}
				}
			}
			if (pTriggerGroup.TriggerAddress)
			{
				pTriggerGroup.TriggerAddress = rewriteAbsoluteAddress(pTriggerGroup.TriggerAddress);
			}
			if (pTriggerGroup.MarshalOnComplete && (typeof(pTriggerGroup.MarshalOnComplete) === 'object'))
			{
				pTriggerGroup.MarshalOnComplete.Section = translateHashReference(pTriggerGroup.MarshalOnComplete.Section, tmpSectionTranslation);
				pTriggerGroup.MarshalOnComplete.Input = translateHashReference(pTriggerGroup.MarshalOnComplete.Input, tmpHashTranslation);
			}
			pTriggerGroup.TriggerGroupHash = translateHashReference(pTriggerGroup.TriggerGroupHash, tmpTriggerGroupTranslation);
		};

		/**
		 * Trigger groups and entity bundles resolve against the section view and the application, so they name
		 * things this manifest owns wherever the input carrying them lives.
		 *
		 * @param {any} pPictForm - The PictForm configuration of an input.
		 */
		const rewriteInputTriggerConfiguration = (pPictForm) =>
		{
			for (const tmpTriggerGroupHashProperty of (this.injectionTriggerGroupHashProperties || INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES))
			{
				if (pPictForm[tmpTriggerGroupHashProperty])
				{
					pPictForm[tmpTriggerGroupHashProperty] = translateHashReference(pPictForm[tmpTriggerGroupHashProperty], tmpTriggerGroupTranslation);
				}
			}
			for (const tmpTriggerGroupProperty of (this.injectionTriggerGroupProperties || INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES))
			{
				const tmpTriggerGroupConfiguration = pPictForm[tmpTriggerGroupProperty];
				if (Array.isArray(tmpTriggerGroupConfiguration))
				{
					for (const tmpTriggerGroup of tmpTriggerGroupConfiguration)
					{
						rewriteTriggerGroup(tmpTriggerGroup);
					}
				}
				else if (tmpTriggerGroupConfiguration)
				{
					rewriteTriggerGroup(tmpTriggerGroupConfiguration);
				}
			}
			for (const tmpEntityBundleProperty of INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES)
			{
				rewriteEntitiesBundle(pPictForm[tmpEntityBundleProperty]);
			}
		};

		// A record set column can carry a trigger group of its own, and those solvers are run against the
		// section view rather than against a record, so they name what this manifest owns. The column's hash
		// and address are relative to a record of the set, so they stay as they are.
		for (const tmpReferenceManifest of Object.values(tmpManifest.ReferenceManifests || {}))
		{
			for (const tmpColumnDescriptor of Object.values(tmpReferenceManifest.Descriptors || {}))
			{
				if (tmpColumnDescriptor.PictForm && (typeof(tmpColumnDescriptor.PictForm) === 'object'))
				{
					rewriteInputTriggerConfiguration(tmpColumnDescriptor.PictForm);
				}
			}
		}

		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors || {}))
		{
			const tmpPictForm = tmpDescriptor.PictForm;
			if (!tmpPictForm || (typeof(tmpPictForm) !== 'object'))
			{
				continue;
			}
			for (const tmpSectionHashProperty of INJECTION_INPUT_SECTION_HASH_PROPERTIES)
			{
				if (tmpPictForm[tmpSectionHashProperty])
				{
					tmpPictForm[tmpSectionHashProperty] = translateHashReference(tmpPictForm[tmpSectionHashProperty], tmpSectionTranslation);
					// A tab selector stores the hash of the tab it is on, so its default is one too.
					tmpDescriptor.Default = translateHashReference(tmpDescriptor.Default, tmpSectionTranslation);
				}
			}
			for (const tmpGroupHashProperty of INJECTION_INPUT_GROUP_HASH_PROPERTIES)
			{
				if (tmpPictForm[tmpGroupHashProperty])
				{
					tmpPictForm[tmpGroupHashProperty] = translateHashReference(tmpPictForm[tmpGroupHashProperty], tmpGroupTranslation);
					tmpDescriptor.Default = translateHashReference(tmpDescriptor.Default, tmpGroupTranslation);
				}
			}
			for (const tmpSolverProperty of INJECTION_INPUT_SOLVER_PROPERTIES)
			{
				if (tmpPictForm[tmpSolverProperty])
				{
					tmpPictForm[tmpSolverProperty] = rewriteSolverValue(tmpPictForm[tmpSolverProperty], `input ${tmpSolverProperty} reference`);
				}
			}
			for (const tmpSolverSetProperty of INJECTION_INPUT_SOLVER_SET_PROPERTIES)
			{
				if (Array.isArray(tmpPictForm[tmpSolverSetProperty.Property]))
				{
					for (const tmpSolverEntry of tmpPictForm[tmpSolverSetProperty.Property])
					{
						if (tmpSolverEntry && (typeof(tmpSolverEntry) === 'object') && tmpSolverEntry[tmpSolverSetProperty.SolverProperty])
						{
							tmpSolverEntry[tmpSolverSetProperty.SolverProperty] = rewriteSolverValue(tmpSolverEntry[tmpSolverSetProperty.SolverProperty], `input ${tmpSolverSetProperty.Property} reference`);
						}
					}
				}
			}
			for (const tmpAddressProperty of INJECTION_INPUT_ADDRESS_PROPERTIES)
			{
				if (tmpPictForm[tmpAddressProperty])
				{
					tmpPictForm[tmpAddressProperty] = rewriteAbsoluteAddress(tmpPictForm[tmpAddressProperty]);
				}
			}
			rewriteInputTriggerConfiguration(tmpPictForm);
			for (const tmpTemplateProperty of INJECTION_INPUT_TEMPLATE_PROPERTIES)
			{
				if (tmpPictForm[tmpTemplateProperty])
				{
					tmpPictForm[tmpTemplateProperty] = rewriteTemplateAddresses(tmpPictForm[tmpTemplateProperty]);
				}
			}
		}
		if (Array.isArray(tmpManifest.ValidationSolvers))
		{
			for (let i = 0; i < tmpManifest.ValidationSolvers.length; i++)
			{
				rewriteSolverEntry(tmpManifest.ValidationSolvers, i, 'validation solver reference');
			}
		}
		return tmpManifest;
	}

	/**
	 * @param {Array<string>} pManifestHashes - The hashes of the manifests to add.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 */
	injectManifestsByHash(pManifestHashes, pAfterSectionHash, pUUID)
	{
		let tmpViewsToRender = [];
		for (const tmpManifestHash of pManifestHashes)
		{
			const tmpManifest = this.findDynamicSectionManifestDefinition(tmpManifestHash);
			if (tmpManifest)
			{
				const tmpUniqueManifest = this.createDistinctManifest(tmpManifest, pUUID);
				const tmpViews = this.injectManifest(tmpUniqueManifest, pAfterSectionHash);
				tmpViewsToRender = tmpViewsToRender.concat(tmpViews);
			}
		}
		this.updateMetatemplateInDOM();
		setTimeout(() =>
		{
			for (const tmpViewToRender of tmpViewsToRender)
			{
				tmpViewToRender.render();
			}
		}, 0);
	}

	/**
	 * @param {Record<string, any>} pSectionsManifest - The section definition object.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 */
	bootstrapAdditiveManifest(pSectionsManifest, pAfterSectionHash)
	{
		const tmpViewsToRender = [];
		const tmpNewSectionDefinitions = this.bootstrapPictFormViewsFromManifest(pSectionsManifest, pAfterSectionHash);
		for (const tmpNewSectionDefinition of tmpNewSectionDefinitions)
		{
			const tmpView = this.pict.views[`PictSectionForm-${tmpNewSectionDefinition.Hash}`];
			if (tmpView)
			{
				tmpViewsToRender.push(tmpView);
			}
		}
		return tmpViewsToRender;
	}

	/**
	 * Filters the views based on the provided filter and sort functions.
	 *
	 * By default, filters views based on the provided filter function and sorts them based on the provided sort function.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to determine if a view should be included.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the filtered views.
	 * @returns {Array} - The filtered and sorted views.
	 */
	filterViews(fFilterFunction, fSortFunction)
	{
		// Generate the filter state object
		let tmpViewFilterState = (
			{
				//FIXME: need to be able to control this order better - adding dynamic sections will always put them at the end, which is rarely what you want
				ViewHashList: Object.keys(this.pict.views),
				// If there is no customization to the filter or sort, just render the last set.
				RenderLastRenderedViewsWithoutCustomization: true,
				// The last rendered views that were rendered
				LastRenderedViews: this.lastRenderedViews,
				// True or false, if the view should be included in the render.
				FilterFunction: fFilterFunction,
				// The sort function to apply to the views (it is sorting OBJECTS, not strings)
				SortFunction: fSortFunction,
				// The final outcome view list
				FilteredViewList: []
			});

		// Execute the customization function
		tmpViewFilterState = this.onBeforeFilterViews(tmpViewFilterState);

		// Filter the views based on the filter function and type
		for (let i = 0; i < tmpViewFilterState.ViewHashList.length; i++)
		{
			let tmpView = this.fable.views[tmpViewFilterState.ViewHashList[i]];
			// If the filter function returns false, skip this view.
			if (tmpViewFilterState.FilterFunction && !tmpViewFilterState.FilterFunction(tmpView))
			{
				continue;
			}
			if (tmpView.isPictSectionForm)
			{
				if (
					// If you don't pass in a filter and it's a dynamic section but set to not be included in the dynamic render, skip it
					(typeof(tmpViewFilterState.FilterFunction) != 'function')
					&& (!tmpView.sectionDefinition.IncludeInDefaultDynamicRender))
				{
					continue;
				}
				tmpViewFilterState.FilteredViewList.push(tmpView);
			}
			else if (!this.options.OnlyRenderDynamicSections || tmpView.options.IncludeInMetacontrollerOperations)
			{
				// If the OnlyRenderDynamicSections option is false, we will render all views in the array..
				// This is great when the app is small and simple.  And DANGEROUS if it isn't.  Take care!
				tmpViewFilterState.FilteredViewList.push(tmpView);
			}
		}

		// Auto-position any views marked with DynamicPlacementMode or DynamicAnchor - this is to assist with mixing configuration driven forms with
		// custom views.
		const tmpViewsToAutoPosition = tmpViewFilterState.FilteredViewList.filter((v) => v.options.DynamicPlacementMode || v.options.DynamicAnchor);
		for (const tmpView of tmpViewsToAutoPosition)
		{
			const tmpMode = tmpView.options.DynamicPlacementMode || 'After';
			const tmpAnchor = tmpView.options.DynamicAnchor;
			let tmpMovingViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v === tmpView);
			let tmpAnchorViewIndex;

			switch (tmpMode)
			{
			case 'First':
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				tmpViewFilterState.FilteredViewList.unshift(tmpView);
				break;
			case 'Last':
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				tmpViewFilterState.FilteredViewList.push(tmpView);
				break;
			case 'Before':
			case 'After':
				tmpAnchorViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v.Hash == tmpAnchor);
				if (tmpAnchorViewIndex < 0)
				{
					// for convenience, also check for dynamic prefixed views if an exact match is not found
					const tmpDynamicAnchor = `PictSectionForm-${tmpAnchor}`;
					tmpAnchorViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v.Hash == tmpDynamicAnchor);
				}
				if (tmpAnchorViewIndex < 0)
				{
					this.log.error(`No anchor view [${tmpAnchor}] found to position view [${tmpView.Hash}] [${tmpMode}].`);
					break;
				}
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				if (tmpMovingViewIndex < tmpAnchorViewIndex)
				{
					// we just removed the element before the target, so we need to adjust
					--tmpAnchorViewIndex;
				}
				if (tmpMode === 'After')
				{
					// this lets us share most of the code for Before and After
					++tmpAnchorViewIndex;
				}
				tmpViewFilterState.FilteredViewList.splice(tmpAnchorViewIndex, 0, tmpView);
				break;
			default:
				this.log.error(`Not auto-positioning view with unknown DynamicPlacementMode: ${tmpMode}`);
			}
		}

		// Sort the views based on the sort function
		// This is to allow dynamic forms sections to have their own sorting criteria before rendering.
		if (typeof(tmpViewFilterState.SortFunction) == 'function')
		{
			tmpViewFilterState.FilteredViewList.sort(tmpViewFilterState.SortFunction);
		}

		// Execute the after filter customization function
		tmpViewFilterState = this.onAfterFilterViews(tmpViewFilterState);

		return tmpViewFilterState.FilteredViewList;
	}

	/**
	 * Renders a specific dynamic form section based on the provided form section hash.
	 *
	 * For this to work, we need the container for the section to be available on the form.
	 *
	 * @param {string} pFormSectionHash - The hash of the form section to render.
	 * @returns {void}
	 */
	renderSpecificFormSection(pFormSectionHash)
	{
		let fViewFilter = (pView) => { return pView.Hash == pFormSectionHash; };
		this.lastRenderedViews = this.filterViews(fViewFilter);
		this.regenerateFormSectionTemplates();
		this.generateMetatemplate();
		this.render();
	}

	/**
	 * Renders the default dynamic form sections based on the provided form section hash.
	 *
	 * @returns {void}
	 */
	renderDefaultFormSections()
	{
		this.lastRenderedViews = this.filterViews((pView) => { return pView?.sectionDefinition?.IncludeInDefaultDynamicRender ?? false; });
		this.regenerateFormSectionTemplates();
		this.generateMetatemplate();
		this.render();
	}

	/**
	 * Renders the form sections based on the provided filter and sort functions.
	 *
	 * If no filter and sort functions are provided, render all form sections.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to filter the views.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the views.
	 */
	renderFormSections(fFilterFunction, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFilterFunction, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (tmpViewList[i] === this)
			{
				continue;
			}
			tmpViewList[i].render();
		}
	}

	/**
	 * Marshals data to the form sections based on the provided filter and sort functions
	 *
	 * If no filter and sort functions are provided, render all form sections.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to filter the views.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the views.
	 */
	marshalFormSections(fFilterFunction, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFilterFunction, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (tmpViewList[i] === this)
			{
				continue;
			}
			tmpViewList[i].marshalToView();
		}
	}

	/**
	 * Regenerates the DyunamicForm section templates based on the provided filter and sort function.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function used to determine which views to include in the regeneration.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function used to determine the order of the views in the regeneration.
	 */
	regenerateFormSectionTemplates(fFormSectionFilter, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			const tmpView = tmpViewList[i];
			if (tmpView === this)
			{
				continue;
			}
			if (tmpView.isPictSectionForm)
			{
				tmpView.rebuildCustomTemplate();
			}
		}
		// Make sure any form-specific CSS is injected properly.
		this.pict.CSSMap.injectCSS();
	}

	/**
	 * Generates a meta template for the DynamicForm views managed by this Metacontroller.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function to apply on the form section.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function to apply on the form section.
	 * @returns {void}
	 */
	generateMetatemplate(fFormSectionFilter, fSortFunction)
	{
		let tmpTemplate = ``;

		if (!this.formTemplatePrefix)
		{
			this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}

		// Add the Form Prefix stuff
		tmpTemplate += `{~T:${this.formTemplatePrefix}-Template-Form-Container-Header:Pict.views["${this.Hash}"]~}`;

		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);

		for (let i = 0; i < tmpViewList.length; i++)
		{
			let tmpFormView = tmpViewList[i];
			if (tmpFormView === this)
			{
				continue;
			}
			if (tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				if (tmpFormView.isPictSectionForm)
				{
					tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				else
				{
					//NOTE: For now, requiring the destination address to be an ID for this case
					tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
					tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			else if (!tmpFormView.isPictSectionForm)
			{
				//NOTE: For now, requiring the destination address to be an ID for this case
				tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
		}
		tmpTemplate += `{~T:${this.formTemplatePrefix}-Template-Form-Container-Footer:Pict.views["${this.Hash}"]~}`;

		this.pict.TemplateProvider.addTemplate(this.options.MetaTemplateHash, tmpTemplate);
	}

	/**
	 * Generates a meta template for the DynamicForm views managed by this Metacontroller.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function to apply on the form section.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function to apply on the form section.
	 *
	 * @return {void}
	 */
	updateMetatemplateInDOM(fFormSectionFilter, fSortFunction)
	{
		if (!this.formTemplatePrefix)
		{
			this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}

		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);
		let tmpPrevDiv = null;
		let tmpDeferredDivContent;
		let tmpDeferredDivID = null;

		for (let i = 0; i < tmpViewList.length; i++)
		{
			let tmpFormView = tmpViewList[i];
			if (tmpFormView === this)
			{
				continue;
			}
			if (!tmpFormView.isPictSectionForm)
			{
				continue;
			}
			if (!tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				continue;
			}
			const tmpFormDivID = tmpFormView.options.CustomTargetID || `Pict-${this.UUID}-${tmpFormView.options.Hash}-Wrap`;
			let tmpFormDivs = this.pict.ContentAssignment.getElement(`#${tmpFormDivID}`);
			if (tmpFormDivs.length > 0)
			{
				const tmpFormDiv = tmpFormDivs[0];
				if (tmpDeferredDivID)
				{
					// We have a deferred div ID, so we need to insert it before this one
					this.pict.ContentAssignment.insertContentBefore(`#${tmpFormDivID}`, tmpDeferredDivContent);
					tmpDeferredDivID = null;
					tmpDeferredDivContent = null;
				}
				tmpPrevDiv = tmpFormDiv;
				continue;
			}
			let tmpFormDivTemplate = '';
			if (tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				if (tmpFormView.isPictSectionForm)
				{
					tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				else
				{
					//NOTE: For now, requiring the destination address to be an ID for this case
					tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
					tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			else if (!tmpFormView.isPictSectionForm)
			{
				//NOTE: For now, requiring the destination address to be an ID for this case
				tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			const tmpFormDivContent = this.pict.parseTemplate(tmpFormDivTemplate, tmpFormView, null, [this]);
			if (tmpPrevDiv)
			{
				this.pict.ContentAssignment.insertContentAfter(`#${tmpPrevDiv.id}`, tmpFormDivContent);
				tmpFormDivs = this.pict.ContentAssignment.getElement(`#${tmpFormDivID}`);
				tmpPrevDiv = tmpFormDivs[0];
				continue;
			}
			tmpDeferredDivID = tmpFormDivID;
			tmpDeferredDivContent = tmpFormDivContent;
		}
		if (tmpDeferredDivID)
		{
			// this means the container was empty, so just add it to the end
			this.pict.ContentAssignment.appendContent(`#Pict-${this.UUID}-FormContainer`, tmpDeferredDivContent);
			tmpDeferredDivID = null;
			tmpDeferredDivContent = null;
		}
	}

	/**
	 * Retrieves a safe clone of the section definition for a given manyfest section description object.
	 *
	 * @param {object} pSectionObject - The section object.
	 * @returns {object|boolean} - The section definition if successful, otherwise false.
	 */
	getSectionDefinition(pSectionObject)
	{
		if (typeof(pSectionObject) != 'object')
		{
			this.log.error('getSectionDefinition() called without a valid section object.');
			return false;
		}

		if (!('Hash' in pSectionObject))
		{
			this.log.error('getSectionDefinition() called without a valid section object hash.');
			return false;
		}

		try
		{
			let tmpSectionDefinition = JSON.parse(JSON.stringify(pSectionObject));

			if (!('Name' in tmpSectionDefinition))
			{
				// If there isn't a name, use the hash
				tmpSectionDefinition.Name = tmpSectionDefinition.Hash;
			}
			if (!('Description' in tmpSectionDefinition))
			{
				// If there isn't a description, use the name
				tmpSectionDefinition.Description = `PICT Section [${tmpSectionDefinition.Name}].`;
			}
			if (!('Groups' in tmpSectionDefinition))
			{
				// If there isn't a groups array, create an empty one
				tmpSectionDefinition.Groups = [];
			}

			return tmpSectionDefinition;
		}
		catch(pError)
		{
			this.log.error(`getSectionDefinition() failed to parse the section object with error: ${pError.message || pError}`);
			return false;
		}
	}

	getSectionViewFromHash(pSectionHash)
	{
		let tmpSectionHash = (typeof(pSectionHash) === 'string') ? pSectionHash : false;
		if (!tmpSectionHash)
		{
			this.log.error('getSectionViewFromHash() called without a valid section hash.');
			return false;
		}
		let tmpViewHash = `PictSectionForm-${tmpSectionHash}`;
		if (tmpViewHash in this.fable.views)
		{
			return this.fable.views[tmpViewHash];
		}
		this.log.error(`getSectionViewFromHash() could not find a view for section hash [${tmpSectionHash}].`);
		return false;
	}

	/**
	 * Marshal one or more section views' data to the DOM.
	 *
	 * For values written outside the normal solve -> marshal cycle (e.g. a trigger group's `PostSolvers`
	 * running in an EntityBundleRequest transaction-complete callback). The global equivalent is
	 * `marshalToView()`; this is the section-scoped, cheaper option.
	 *
	 * @param {string|string[]} pSectionHashes - a section hash, or an array of section hashes
	 * @returns {void}
	 */
	marshalSectionToView(pSectionHashes)
	{
		const tmpSectionHashes = (Array.isArray(pSectionHashes) ? pSectionHashes : [ pSectionHashes ]).filter((pHash) => typeof pHash === 'string' && pHash.length > 0);
		for (const tmpSectionHash of tmpSectionHashes)
		{
			const tmpSectionView = this.getSectionViewFromHash(tmpSectionHash);
			if (tmpSectionView)
			{
				tmpSectionView.marshalToView();
			}
		}
	}

	/**
	 * Marshal one or more inputs' data to the DOM, wherever they live (finds the owning section view).
	 *
	 * The single-input equivalent of {@link marshalSectionToView}; use it when only specific fields
	 * changed (e.g. a trigger group that computed one read-only attribute).
	 *
	 * @param {string|string[]} pInputHashes - an input hash, or an array of input hashes
	 * @returns {void}
	 */
	marshalInputToView(pInputHashes)
	{
		const tmpInputHashes = (Array.isArray(pInputHashes) ? pInputHashes : [ pInputHashes ]).filter((pHash) => typeof pHash === 'string' && pHash.length > 0);
		if (tmpInputHashes.length < 1)
		{
			return;
		}
		const tmpSectionViews = this.filterViews();
		for (const tmpInputHash of tmpInputHashes)
		{
			for (let i = 0; i < tmpSectionViews.length; i++)
			{
				const tmpSectionView = tmpSectionViews[i];
				if (tmpSectionView === this || typeof tmpSectionView.getInputFromHash !== 'function')
				{
					continue;
				}
				const tmpInput = tmpSectionView.getInputFromHash(tmpInputHash);
				if (tmpInput)
				{
					tmpSectionView.manualMarshalDataToViewByInput(tmpInput);
					break;
				}
			}
		}
	}

	/**
	 * Appends the validation solvers of a manifest being added to the form onto the form's own, in order,
	 * skipping any the form already holds so adding the same manifest again does not run its solvers twice.
	 *
	 * @param {Record<string, any>} pTargetManifest - The form's manifest description, which receives the solvers.
	 * @param {Record<string, any>} pSourceManifest - The manifest being added to the form.
	 *
	 * @return {number} The number of validation solvers added.
	 */
	mergeValidationSolvers(pTargetManifest, pSourceManifest)
	{
		if (!pTargetManifest || !pSourceManifest || !Array.isArray(pSourceManifest.ValidationSolvers) || (pSourceManifest.ValidationSolvers.length < 1))
		{
			return 0;
		}
		if (!Array.isArray(pTargetManifest.ValidationSolvers))
		{
			pTargetManifest.ValidationSolvers = [];
		}
		const tmpExistingSolvers = new Set(pTargetManifest.ValidationSolvers.map((pSolver) => JSON.stringify(pSolver)));
		let tmpAddedCount = 0;
		for (const tmpSolver of pSourceManifest.ValidationSolvers)
		{
			const tmpSolverKey = JSON.stringify(tmpSolver);
			if (tmpExistingSolvers.has(tmpSolverKey))
			{
				continue;
			}
			tmpExistingSolvers.add(tmpSolverKey);
			pTargetManifest.ValidationSolvers.push(JSON.parse(tmpSolverKey));
			++tmpAddedCount;
		}
		return tmpAddedCount;
	}

	/**
	 * Clears out the manifest description set on the meta controller.
	 */
	clearManifestDescription()
	{
		this.manifestDescription = null;
	}

	/**
	 * Bootstraps Pict DynamicForm views from a Manyfest description JSON object.
	 *
	 * @param {Object} pManifestDescription - The manifest description object.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 *
	 * @returns {Array<Record<string, any>>} - An array of section definitions added.
	 */
	bootstrapPictFormViewsFromManifest(pManifestDescription, pAfterSectionHash)
	{
		let tmpManifestDescription = (typeof(pManifestDescription) === 'object') ? pManifestDescription : false;
		let tmpSectionList = [];

		if (typeof(tmpManifestDescription) != 'object')
		{
			// Check and see if there is a DefaultFormManifest in the settings
			if (('DefaultFormManifest' in this.fable.settings)
				&& typeof(this.fable.settings.DefaultFormManifest) == 'object'
				&& ('Descriptors' in this.fable.settings.DefaultFormManifest))
			{
				tmpManifestDescription = this.fable.settings.DefaultFormManifest;
			}
			else
			{
				this.log.error('PictFormMetacontroller.bootstrapPictFormViewsFromManifest() called without a valid manifest, and no settings.DefaultFormManifest was provided.');
				return tmpSectionList;
			}
		}
		if (this.manifestDescription)
		{
			this.stashedManifestDescription = this.manifestDescription;
			this.manifestDescription = tmpManifestDescription;
			//FIXME: merge manifests more fully... should this be an external capability?
			for (const [ tmpKey, tmpDescriptor ] of Object.entries(this.manifestDescription.Descriptors || {}))
			{
				if (this.stashedManifestDescription.Descriptors[tmpKey])
				{
					this.log.error(`PictFormMetacontroller.bootstrapPictFormViewsFromManifest() found a duplicate descriptor key [${tmpKey}] when merging manifests. The new descriptor will be skipped.`);
					continue;
				}
				this.stashedManifestDescription.Descriptors[tmpKey] = JSON.parse(JSON.stringify(tmpDescriptor));
			}
			for (const tmpKey of Object.keys(this.manifestDescription.ReferenceManifests || {}))
			{
				if (this.stashedManifestDescription.ReferenceManifests[tmpKey])
				{
					this.log.warn(`PictFormMetacontroller.bootstrapPictFormViewsFromManifest() found a duplicate reference manifest key [${tmpKey}] when merging manifests. The new reference manifest will be skipped.`);
					continue;
				}
				this.stashedManifestDescription.ReferenceManifests[tmpKey] = JSON.parse(JSON.stringify(this.manifestDescription.ReferenceManifests[tmpKey]));
			}
			this.mergeValidationSolvers(this.stashedManifestDescription, this.manifestDescription);
			let tmpInsertAtIndex = this.stashedManifestDescription.Sections.findIndex((pSection) => pSection.Hash == pAfterSectionHash);
			if (tmpInsertAtIndex < 0)
			{
				tmpInsertAtIndex = 0;
			}
			else
			{
				// We want to insert AFTER the found index, so increment by 1
				++tmpInsertAtIndex;
			}
			for (const tmpSection of this.manifestDescription.Sections || [])
			{
				const tmpClonedSection = JSON.parse(JSON.stringify(tmpSection));
				this.stashedManifestDescription.Sections.splice(tmpInsertAtIndex, 0, tmpClonedSection);
				++tmpInsertAtIndex;
			}
		}
		else
		{
			this.manifestDescription = tmpManifestDescription;
		}
		let tmpManifest = this.fable.instantiateServiceProviderWithoutRegistration('Manifest', this.manifestDescription);

		if (this.options.AutoPopulateDefaultObject)
		{
			// Fill out the defaults at the marshal location if it doesn't exist
			const tmpMarshalDestinationObject = this.pict.providers.DataBroker.marshalDestinationObject;
			if (typeof(tmpMarshalDestinationObject) === 'object')
			{
				tmpManifest.populateDefaults(tmpMarshalDestinationObject);
			}
		}

		// Get the list of Explicitly Defined section hashes from the Sections property of the manifest
		if (('Sections' in this.manifestDescription) && Array.isArray(this.manifestDescription.Sections))
		{
			for (let i = 0; i < this.manifestDescription.Sections.length; i++)
			{
				let tmpSectionDefinition = this.getSectionDefinition(this.manifestDescription.Sections[i]);

				if (tmpSectionDefinition)
				{
					tmpSectionList.push(tmpSectionDefinition);
				}
			}
		}

		let tmpImplicitSectionHashes = {};

		let tmpDescriptorKeys = Object.keys(tmpManifest.elementDescriptors);

		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			let tmpDescriptor = tmpManifest.elementDescriptors[tmpDescriptorKeys[i]];

			if (tmpDescriptor)
			{
				this.pict.manifest.addDescriptor(tmpDescriptorKeys[i], tmpDescriptor);
			}

			if (
					// If there is an object in the descriptor
					typeof(tmpDescriptor) == 'object' &&
					// AND it has a PictForm property
					('PictForm' in tmpDescriptor) &&
					// AND the PictForm property is an object
					typeof(tmpDescriptor.PictForm) == 'object' &&
					// AND the PictForm object has a Section property
					('Section' in tmpDescriptor.PictForm) &&
					// AND the Section property is a string
					typeof(tmpDescriptor.PictForm.Section) == 'string'
				)
			{
				tmpImplicitSectionHashes[tmpDescriptor.PictForm.Section] = true;
			}
		}

		let tmpImplicitSectionKeys = Object.keys(tmpImplicitSectionHashes);

		for (let i = 0; i < tmpImplicitSectionKeys.length; i++)
		{
			let tmpExistingSection = tmpSectionList.find((pSection) => { return pSection.Hash == tmpImplicitSectionKeys[i]; });

			if (!tmpExistingSection)
			{
				tmpSectionList.push(this.getSectionDefinition({Hash: tmpImplicitSectionKeys[i]}));
			}
		}

		// Now load a section view for each section
		for (let i = 0; i < tmpSectionList.length; i++)
		{
			let tmpViewHash = `PictSectionForm-${tmpSectionList[i].Hash}`;

			if (tmpViewHash in this.fable.views)
			{
				this.log.info(`getSectionList() found an existing view for section [${tmpSectionList[i].Hash}] so will be skipped.`);
				continue;
			}
			let tmpViewConfiguration = JSON.parse(JSON.stringify(tmpSectionList[i]));
			if (!('Manifests' in tmpViewConfiguration))
			{
				tmpViewConfiguration.Manifests = {};
			}
			tmpViewConfiguration.Manifests.Section = this.manifestDescription;
			this.pict.addView(tmpViewHash, tmpViewConfiguration, libPictViewDynamicForm);
		}

		if ('PickLists' in this.manifestDescription)
		{
			let tmpPickListKeys = Object.keys(this.manifestDescription.PickLists);
			for (let i = 0; i < tmpPickListKeys.length; i++)
			{
				let tmpPickList = this.manifestDescription.PickLists[tmpPickListKeys[i]];
				this.pict.providers.DynamicMetaLists.buildList(tmpPickList);
			}
		}

		// Now see if there is custom CSS
		for (let i = 0; i < tmpSectionList.length; i++)
		{
			let tmpSection = tmpSectionList[i];
			if (('CustomCSS' in tmpSection) && (typeof(tmpSection.CustomCSS) == 'string'))
			{
				this.pict.CSSMap.addCSS(`PSF-SectionCSS-${tmpSection.Hash}`, tmpSection.CustomCSS);
			}
		}

		if (this.stashedManifestDescription)
		{
			this.manifestDescription = this.stashedManifestDescription;
			delete this.stashedManifestDescription;
		}
		return tmpSectionList;
	}

	/**
	 * Trigger an event on all inputs on all views.
	 * @param {string} pEvent - The event to trigger
	 * @param {string} [pTransactionGUID] - (optional) The transaction GUID to use for the event.
	 */
	triggerGlobalInputEvent(pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		let tmpEvent = (typeof(pEvent) === 'string') ? pEvent : this.fable.getUUID();
		let tmpViewHashes = Object.keys(this.pict.views);
		let tmpCompletedHashes = {};
		/** @type {import('./Pict-View-DynamicForm.js')} */
		let tmpFinalizeView = null;
		// Filter the views based on the filter function and type
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			/** @type {import('./Pict-View-DynamicForm.js')} */
			let tmpView = this.pict.views[tmpViewHashes[i]];
			if (tmpView.isPictSectionForm)
			{
				tmpFinalizeView = tmpView;
				tmpView.sectionInputEvent(tmpEvent, tmpCompletedHashes, tmpTransactionGUID);
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID && tmpFinalizeView)
		{
			// If we created the transaction GUID, we need to finalize it
			tmpFinalizeView.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 */
	registerEventTransactionAsyncOperation(pTransactionGUID, pAsyncOperationHash)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, pAsyncOperationHash, PENDING_ASYNC_OPERATION_TYPE);
	}

	/**
	 * FIXME: consolidate with same functions(s) in the dynamic view class
	 *
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 *
	 * @return {boolean} - Returns true if the async operation was found and marked as complete, otherwise false.
	 */
	eventTransactionAsyncOperationComplete(pTransactionGUID, pAsyncOperationHash)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpMarkedOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				if (tmpQueueItem.Data === pAsyncOperationHash)
				{
					tmpQueue.splice(i, 1);
					++tmpMarkedOperationCount;
					--i;
				}
				else
				{
					++tmpPendingAsyncOperationCount;
				}
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpMarkedOperationCount === 0)
		{
			this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete ${pTransactionGUID} could not find async operation with hash ${pAsyncOperationHash}.`);
			return;
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			for (let i = 0; i < tmpQueue.length; i++)
			{
				const tmpQueueItem = tmpQueue[i];
				if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
				{
					tmpQueue.splice(i, 1);
					--i;
					if (typeof tmpQueueItem.Data !== 'function')
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback was not a function.`);
						continue;
					}
					try
					{
						tmpQueueItem.Data();
					}
					catch (pError)
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback error: ${pError}`, { Stack: pError.stack });
					}
				}
			}
			delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		}
		return tmpMarkedOperationCount > 0;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 *
	 * @return {boolean} - Returns true if the transaction was found and able to be finalized, otherwise false.
	 */
	finalizeTransaction(pTransactionGUID)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, null, READY_TO_FINALIZE_TYPE);

		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
		}
		if (tmpPendingAsyncOperationCount > 0)
		{
			this.pict.log.info(`PICT View Metatemplate Helper finalizeTransaction ${pTransactionGUID} is waiting on ${tmpPendingAsyncOperationCount} pending async operations.`);
			return false;
		}
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
			{
				tmpQueue.splice(i, 1);
				--i;
				if (typeof tmpQueueItem.Data !== 'function')
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback was not a function.`);
					continue;
				}
				try
				{
					tmpQueueItem.Data();
				}
				catch (pError)
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback error: ${pError}`, { Stack: pError.stack });
				}
			}
		}
		delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		return true;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Function} fCallback - The callback to call when the transaction is complete.
	 */
	registerOnTransactionCompleteCallback(pTransactionGUID, fCallback)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			fCallback();
		}
		else
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, fCallback, TRANSACTION_COMPLETE_CALLBACK_TYPE);
		}
	}

	showSupportViewInlineEditor()
	{
		// 1. See if the Support views are loaded
		// 2. Load the support view if it isn't
		this.pict.addViewSingleton("Pict-Form-DebugViewer", {}, this.SupportViewPrototypes.DebugViewer);
		this.pict.addViewSingleton("Pict-Form-AppDataViewer", {}, this.SupportViewPrototypes.AppDataViewer);
//		this.pict.addViewSingleton("Pict-Form-LifecycleVisualization", {}, this.SupportViewPrototypes.LifecycleVisualization);
		this.pict.addViewSingleton("Pict-Form-SolverVisualization", {}, this.SupportViewPrototypes.SolverVisualization);
//		this.pict.addViewSingleton("Pict-Form-SpecificSolveVisualization", {}, this.SupportViewPrototypes.SpecificSolveVisualization);
	
		// 3. See if the container for the support view is loaded
		// 4. Render the container for the support view if it isn't loaded
		this.pict.views["Pict-Form-DebugViewer"].bootstrapContainer();
	
		// 5. Render the support view into the container
		this.pict.views["Pict-Form-DebugViewer"].render();
	}

	/**
	 * Returns whether the object is a Pict Metacontroller.
	 *
	 * @returns {boolean} True if the object is a Pict Metacontroller, false otherwise.
	 */
	get isPictMetacontroller()
	{
		return true;
	}
}

module.exports = PictFormMetacontroller;

/**
 * What createDistinctManifest translates when a manifest is injected, by kind. The injection conformance
 * tests measure fixture coverage against this, so adding a construct here without a fixture case fails.
 *
 * @type {Record<string, any>}
 */
module.exports.InjectionTranslation = (
{
	"InputSectionHashProperties": INJECTION_INPUT_SECTION_HASH_PROPERTIES,
	"InputGroupHashProperties": INJECTION_INPUT_GROUP_HASH_PROPERTIES,
	"InputSolverProperties": INJECTION_INPUT_SOLVER_PROPERTIES,
	"InputSolverSetProperties": INJECTION_INPUT_SOLVER_SET_PROPERTIES,
	"InputAddressProperties": INJECTION_INPUT_ADDRESS_PROPERTIES,
	"InputTriggerGroupProperties": INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES,
	"InputTriggerGroupHashProperties": INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES,
	"InputTemplateProperties": INJECTION_INPUT_TEMPLATE_PROPERTIES,
	"InputEntityBundleProperties": INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES,
	"EntityBundleAddressProperties": INJECTION_ENTITY_BUNDLE_ADDRESS_PROPERTIES,
	"EntityBundleTemplateProperties": INJECTION_ENTITY_BUNDLE_TEMPLATE_PROPERTIES,
	"TriggerGroupSolverProperties": INJECTION_TRIGGER_GROUP_SOLVER_PROPERTIES,
	"ManifestConstructs": INJECTION_MANIFEST_CONSTRUCTS,
	"SolverDirectiveCodes": Array.from(SOLVER_DIRECTIVE_CODES),
});

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"AutoRender": true,

	"AutoPopulateDefaultObject": true,
	"AutoSolveBeforeRender": true,
	"AutoPopulateAfterRender": true,

	"DefaultRenderable": "Pict-Forms-Metacontainer",
	"DefaultDestinationAddress": "#Pict-Form-Container",

	"OnlyRenderDynamicSections": true,

	"MetaTemplateHash": "Pict-Forms-Metatemplate",

	"Templates": [
		{
			"Hash": "Pict-Forms-Metatemplate",
			"Template": "<!-- Pict-Forms-Metatemplate HAS NOT BEEN GENERATED; call pict.views.PictFormsMetatemplate.generateMetatemplate() to build the containers -->"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "Pict-Forms-Metacontainer",
			"TemplateHash": "Pict-Forms-Metatemplate",
			"DestinationAddress": "#Pict-Form-Container"
		}
	]
});

},{"../services/Pict-Service-DynamicFormDependencyManager.js":548,"./Pict-View-DynamicForm.js":563,"./support/Pict-View-PSF-AppData-Visualization.js":566,"./support/Pict-View-PSF-DebugViewer.js":567,"./support/Pict-View-PSF-LifeCycle-Visualization.js":568,"./support/Pict-View-PSF-Solver-Visualization.js":569,"./support/Pict-View-PSF-SpecificSolve-Visualization.js":570,"pict-view":693}],565:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-Form-SupportExtensions",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a class that provides dynamic templates for the Pict form section provider.
 * @extends libPictProvider
 */
class PictSupportExtension extends libPictProvider
{
	/**
	 * Constructs a new instance of the PictProviderDynamicTemplates class.
	 * @param {Object} pFable - The pFable object.
	 * @param {Object} pOptions - The options object.
	 * @param {Object} pServiceHash - The service hash object.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		// These next blocks of code manually do what views often do, to support sharing of this across multiple views.

		// Only add this css if it doesn't exist already in the css map
		if (!('Pict-Support' in this.pict.CSSMap.inlineCSSMap))
		{
			this.pict.CSSMap.addCSS('Pict-Support',
				/*css*/`
					:root{
						--PSF-Global-background-color: #dcdce5;
						--PSF-Global-text-color: var(--theme-color-text-primary, #333333);

						--PSFExt-gutter-size: 5px;
						--PSFExt-indentation-size: calc(2 * var(--PSFExt-gutter-size));
						--PSFExt-Global-background-color: #dedede;
						--PSFExt-Global-text-color: var(--theme-color-text-primary, #333333);
						--PSFExt-Section-background-color: var(--theme-color-background-tertiary, #efefef);
						--PSFExt-Section-button-color: #5A52A3;
						--PSFExt-Section-button-text-color: #D8D7E5;
						--PSFExt-Section-token-color: #eAf3a2;
						--PSFExt-Section-label-color: var(--theme-color-text-muted, #999);
						--PSFExt-Section-Data-background-color: var(--theme-color-background-secondary, #fafafa);
						--PSFExt-Section-Group-Header-background-color: #ebebff;
						--PSFExt-Section-Group-Row-Header-background-color: #dcf0f0;
						--PSFExt-Solver-Entry-text-color: #bb4a9c;
						--PSFExt-Section-DynamicInput-background-color: #a3ccd8;
						--PSFExt-Section-DynamicInput-button-color: #2b89a4;
						--PSFExt-Section-DynamicInput-button-text-color: #D8D7E5;
					}

					/** Wrapping container	*/
					#Pict-Form-Extensions-Wrap {
						display:flex;
						flex-direction: column;
						height: 75vh;
						overflow: hidden;
						position: absolute;
						left: 50%;
						top: 0px;
						width: 20vw;
						min-width: 340px;
						min-height: 200px;
					}
					#Pict-Form-Extension-DragControl {
						background-color: #eae;
						cursor: move;
						padding: 4px 6px;
						border-radius: 3px;
						border: 1px solid var(--theme-color-text-primary, #111);
					}
					#Pict-Form-Extensions-Container { 
						flex-grow: 1;
						overflow: auto;
						margin-top: 2px;
						color: var(--PSF-Global-text-color);
						background-color: var(--PSF-Global-background-color);
						padding: 10px;
						border: 4px double var(--theme-color-text-primary, #111);
						border-radius: 8px;
						box-shadow: 2px 2px 10px rgba(0,0,0,0.5);
						font-size: 14px;
						font-family: Arial, sans-serif;
						font-size: 14px;
					}
					#Pict-Form-Extension-ResizeControl {
						background-color: #eae;
						cursor: move;
						padding: 4px 4px;
						border-radius: 3px;
						border: 1px solid var(--theme-color-text-primary, #111);
					}
					.PSFExt-Extension-Footer {
						text-align: right;
						font-size: 10px;
						font-weight: bold;
						margin-top: 8px;
					}

					/** Headers	*/
					.PSFExt-Extension-Header {
						font-size: 10px;
						font-weight: bold;
						margin-bottom: var(--PSFExt-gutter-size);
					}
					.PSFExt-Global-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
					}
					.PSFExt-Section-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
					}
					.PSFExt-Content-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
						background-color: var(--PSFExt-Section-background-color);
					}
					.PSFExt-Data-Header {
						font-weight: bold;
						border-bottom: 1px dotted var(--theme-color-border-default, #ccc);
						padding: var(--PSFExt-gutter-size);
					}
					/** Section content */
					.PSFExt-Section { 
						margin: var(--PSFExt-gutter-size);
						padding: var(--PSFExt-gutter-size);
						background-color: var(--PSFExt-Section-background-color);
						border-radius: 4px;
					}
					.PSFExt-Section-Descriptors { 
						padding: var(--PSFExt-gutter-size) 0;
					}
					.PSFExt-Section-Group { 
						padding: var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Buttons {
						list-style-type: none;
						padding: 0;
						padding-bottom: var(--PSFExt-gutter-size);
						margin: calc(var(--PSFExt-gutter-size) * 2) var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Button { 
						display: inline;
						margin-right: calc(var(--PSFExt-gutter-size) * 0.25);
						text-decoration: none;
						background-color: var(--PSFExt-Section-button-color);
						padding: var(--PSFExt-gutter-size);
						border-radius: var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Button a { 
						text-decoration: none;
						color: var(--PSFExt-Section-button-text-color);
					}
					.PSFExt-Section-Button a:hover { 
						text-decoration: underline;
					}
					.PSFExt-Section-Solver-Entry:not(:last-child) {
						border-bottom: 1px solid var(--theme-color-border-default, #ccc);
					}
					.PSFExt-Solver-Entry { 
						font-family: "Courier New", "Lucida Console", monospace;
						font-weight: bold;
						margin-top: var(--PSFExt-gutter-size);
						padding: var(--PSFExt-gutter-size);
						line-height: 1.2;
						color: var(--PSFExt-Solver-Entry-text-color);
						border-bottom: 1px dotted var(--theme-color-border-default, #ccc);
					}
					.PSFExt-Solver-Result { 
						font-family: "Courier New", "Lucida Console", monospace;
						font-weight: bold;
						margin-top: var(--PSFExt-gutter-size);
						padding: 0 var(--PSFExt-gutter-size);
						line-height: 1.2;
					}
					.PSFExt-Section-ExtraData {
						padding-top: calc(var(--PSFExt-gutter-size) / 2);
						padding-bottom: calc(var(--PSFExt-gutter-size) / 2);
						background-color: var(--PSFExt-Section-Data-background-color);
					}
					.PSFExt-Section-Group .PSFExt-Content-Header.PSFExt-Section-Group-Header {
						background-color: var(--PSFExt-Section-Group-Header-background-color);
					}
					.PSFExt-Section-Group .PSFExt-Content-Header.PSFExt-Section-Group-Row-Header {
						background-color: var(--PSFExt-Section-Group-Row-Header-background-color);
					}
					.PSFExt-DeEmphasize { 
						color: var(--PSFExt-Section-label-color);
						font-size: smaller;
					}
					.PSFExt-Data { 
						margin-left: var(--PSFExt-indentation-size);
						line-height: 0.85;
						font-size: smaller;
					}
					.PSFExt-Data-Table {
						width: 100%;
						border-collapse: collapse;
						margin-left: var(--PSFExt-indentation-size);
						margin-top: var(--PSFExt-gutter-size);
						margin-bottom: var(--PSFExt-gutter-size);
						overflow-x: auto;
					}
					.PSFExt-Label { 
						min-width: 15%;
						color: var(--PSFExt-Section-label-color);
						margin: var(--PSFExt-gutter-size) 0;
					}
					.PSFExt-Label::after {
						content: ": ";
					}
					.PSFExt-Hidden { 
						display: none;
					}
					.PSFExt-Section-Solver-DynamicInput {
						background-color: var(--theme-color-background-panel, #ffffff);
					}
					
					/** empty states */
					.PSFExt-Section-Solvers:empty::before {
						content: "No Section Solvers Defined";
						font-style: italic;
						color: var(--PSFExt-Section-label-color);
						margin-left: var(--PSFExt-indentation-size);
						text-align: center;
						padding: var(--PSFExt-gutter-size);
						display: block;
						font-size: smaller;
					}
					.PSFExt-Group-Solvers:empty::before {
						content: "No Group/RecordSet Solvers Defined";
						font-style: italic;
						color: var(--PSFExt-Section-label-color);
						margin-left: var(--PSFExt-indentation-size);
						text-align: center;
						padding: var(--PSFExt-gutter-size);
						display: block;
						font-size: smaller;
					}
					.PSFExt-ExpressionEditbox {
						width: calc(100% - 20px);
						resize: vertical;
						min-height: 80px;
						font-family: monospace;
						font-size: 0.9em;
					}
					.PSFExt-Token {
						background-color: var(--PSFExt-Section-token-color);
					}
				`, 1000, 'Pict-Form-SupportBase');
		}

		// Only add these templates if they doesn't exist
		if (this.pict.TemplateProvider.getTemplate('Pict-Form-Support-Container') == null)
		{
			this.pict.TemplateProvider.addTemplate('Pict-Form-Support-Container',
				/*html*/`
			<div id="Pict-Form-Extensions-Wrap">
				<p class="PSFExt-Extension-Header"><span id="Pict-Form-Extension-DragControl" class="PSDV-Extension-Header-Controlbar">Pict.Extensions {~TS:Pict-Form-Support-Container-Link:Pict.providers[Pict-Form-SupportExtensions].getSupportViewLinks()~} <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#Pict-Form-Extensions-Container', 'PSFExt-Hidden');{~P~}.ContentAssignment.toggleClass('#Pict-Form-Extensions-Footer', 'PSFExt-Hidden');">toggle</a></span></p>
				<div id="Pict-Form-Extensions-Container"></div>
				<p id="Pict-Form-Extensions-Footer" class="PSFExt-Extension-Footer"><span id="Pict-Form-Extension-ResizeControl">Pict.Extensions Resize</span></p>
			</div>
				`);
		}
		if (this.pict.TemplateProvider.getTemplate('Pict-Form-Support-Container-Link') == null)
		{
			this.pict.TemplateProvider.addTemplate('Pict-Form-Support-Container-Link',
				/*html*/` [ <a href="{~D:Record.Link~}" onclick="{~D:Record.OnClick~}" data-shortname="{~D:Record.ShortName~}" data-longname="{~D:Record.LongName~}">{~D:Record.ShortName~}</a> ] `);
		}


		this.SupportViews = {};
	}

	registerSupportView(pView)
	{
		this.pict.log.info(`Registering support view ${pView.Hash} with Pict Support Extension provider.`);
		this.SupportViews[pView.Hash] = pView;
	}

	getSupportViewLinks()
	{
		let tmpLinks = [];
		let tmpSupportViewHashes = Object.keys(this.SupportViews);
		for (let i = 0; i < tmpSupportViewHashes.length; i++)
		{
			let tmpViewHash = tmpSupportViewHashes[i];
			let tmpView = this.SupportViews[tmpViewHash];
			tmpLinks.push(
				{
					Hash: tmpView.Hash,
					Link: `javascript:void(0);`,
					ShortName: tmpView.DisplayShortName,
					LongName: tmpView.DisplayLongName,
					OnClick: `${this.pict.browserAddress}.views['${tmpView.Hash}'].render()`
				}
			);
		}
		return tmpLinks;
	}
}

module.exports = PictSupportExtension;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],566:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-AppData",

	DefaultRenderable: 'Pict-Form-AppData-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-AppData-Content",
			Template: /*html*/`
<div id="Pict-Form-AppData-Content">
	<h2 class="PSFAD-Global-Header">Pict Form Data Visualization</h2>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Form Marshal Destination</span> {~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Form Data</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">AppData</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.AppData')">Download AppData JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Fable Settings</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.settings')">Download fable settings JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Application Options</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.PictApplication.options')">Download Application options JSON</a>]
	</p>
	<div id="PSFExt-Data-Browser" class="PSFExt-Section">
		{~TVS:Pict-Form-AppData:Context[0].flattenMarshalDestination()~}
	</div>
`
		},
		{
			Hash: "Pict-Form-AppData",
			Template: /*html*/`
	<div class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header"><span class="PSFExt-DeEmphasize">Address:</span> 
			{~D:Record.Key~}
		</h3>
		<div id="PSFExt-AD-{~D:Record.Key~}-Extra" class="PSFExt-Section-ExtraData">
			{~TIfAbs:Pict-Form-AppData-ObjectValueDisplay:Record:Record.Value.DataType^==^Object~}
			{~TIfAbs:Pict-Form-AppData-NotObjectValueDisplay:Record:Record.Value.DataType^!=^Object~}
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-AppData-NotObjectValueDisplay",
			Template: /*html*/`
				<!-- Not Object Value Display -->
				{~TIfAbs:Pict-Form-AppData-ArrayValueDisplay:Record:Record.Value.DataType^==^Array~}
				{~TIfAbs:Pict-Form-AppData-PrimitiveValueDisplay:Record:Record.Value.DataType^!=^Array~}
`
		},
		{
			Hash: "Pict-Form-AppData-ObjectValueDisplay",
			Template: /*html*/`
			<!-- Object Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Type</span> Javascript Object {~T:Pict-Form-AppData-ObjectDownloadLink~}
			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-ArrayValueDisplay",
			Template: /*html*/`
			<!-- Array Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Type</span> Array {~TIfAbs:Pict-Form-AppData-ArrayDownloadLink~}

			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-PrimitiveValueDisplay",
			Template: /*html*/`
			<!-- Primitive Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Value</span> {~D:Record.Value.Default~}
			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-ObjectDownloadLink",
			Template: /*html*/`[<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download JSON</a>]`
		},
		{
			Hash: "Pict-Form-AppData-ArrayDownloadLink",
			Template: /*html*/`[<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download Array</a>]`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-AppData-Renderable",
			TemplateHash: "Pict-Form-AppData-Content"
		}
	]
});

class PictFormsAppData extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'FDT';
		this.DisplayLongName = 'FormData';
	}

	flattenMarshalDestination()
	{
		return this.flattenAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
	}

	flattenAppData()
	{
		return this.flattenAddress('AppData');
	}

	flattenAddress(pAddress)
	{
		let tmpData = this.pict.resolveStateFromAddress(pAddress);
		// Now flatten the entire data structure...
		return this.pict.manifest.objectAddressGeneration.generateAddressses(tmpData);
	}
}

module.exports = PictFormsAppData;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":571}],567:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-DebugViewer",

	DefaultRenderable: 'Pict-Form-DebugViewer-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/`
	/** Dynamic Input Section Overrides */
	#PSFExt-DynamicInputSection .PSFExt-Section { 
		margin: var(--PSFExt-gutter-size);
		padding: var(--PSFExt-gutter-size);
		background-color: var(--PSFExt-Section-DynamicInput-background-color);
	}

	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Section-Button { 
		background-color: var(--PSFExt-Section-DynamicInput-button-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Section-Button a { 
		color: var(--PSFExt-Section-DynamicInput-button-text-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Label,
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-DeEmphasize { 
		color: var(--PSFExt-Section-DynamicInput-button-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section-Descriptors { 
		border-left: 5px solid var(--PSFExt-Section-DynamicInput-background-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section-Group { 
		border-left: 5px solid var(--PSFExt-Section-DynamicInput-button-color);
	}
`,

	Templates: [
		{
			Hash: "Pict-Form-DebugViewer-Content",
			Template: /*html*/`
<div id="Pict-Form-DebugViewer-Content">
	<h2 class="PSFExt-Global-Header">Pict Inline Form Editing Tool</h2>
	{~T:Pict-Form-DebugViewer-MetacontrollerContainer~}
</div>`
		},
		{
			Hash: "Pict-Form-DebugViewer-MetacontrollerContainer",
			Template: /*html*/`
	<p class="PSFExt-Data"><span class="PSFExt-Label">Scope:</span> {~D:Context[0].getDynamicState().Scope~}</p>
	<ul class="PSFExt-Section-Buttons">
	</ul>
	<div id="PSFExt-SectionList">
		{~TS:Pict-Form-DebugViewer-SectionContainer:Context[0].getDynamicState().SectionViews~}
	</div>
	<hr>
	<div id="PSFExt-DynamicInputSection">
		{~T:Pict-Form-DebugViewer-SectionContainer:Context[0].getDynamicState().DynamicInputView~}
	</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-SectionContainer",
			Template: /*html*/`
	<div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header"><span class="PSFExt-DeEmphasize">Section:</span> {~D:Record.sectionDefinition.Name~}</h3>
		<ul class="PSFExt-Section-Buttons">
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views['{~D:Record.View.Hash~}'].render()">Render</a></li>
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.assignContent('{~D:Record.View.options.DefaultDestinationAddress~}','')">Clear</a></li>
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.removeClass('#PSFExt-{~D:Record.View.Hash~}-Extra', 'PSFExt-Hidden')">Extra Data</a></li>
		</ul>
		<div id="PSFExt-{~D:Record.View.Hash~}-Extra" class="PSFExt-Hidden PSFExt-Section-ExtraData">
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Description</span> {~D:Record.sectionDefinition.Description~}
			</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Hash</span> {~D:Record.View.Hash~}
			</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">HTML ID</span> {~D:Record.View.sectionDefinition.Macro.HTMLID~}
			</p>
			<h4 class="PSFExt-Content-Header">Section Solvers:</h4>
			<div class="PSFExt-Section-Solvers">{~TS:Pict-Form-DebugViewer-SolverEntry:Record.Solvers[]<<~?ExpressionScope,==,Section?~>>~}</div>
			<h4 class="PSFExt-Content-Header">Tabular/RecordSet Solvers:</h4>
			<div class="PSFExt-Group-Solvers">{~TS:Pict-Form-DebugViewer-SolverEntry:Record.Solvers[]<<~?ExpressionScope,==,Group?~>>~}</div>
			<h4 class="PSFExt-Content-Header">Inputs:</h4>
			<div class="PSFExt-Section-Solver-DynamicInput">
				{~TS:Pict-Form-DebugViewer-GroupContainer:Record.View.sectionDefinition.Groups~}
			</div>
			<ul class="PSFExt-Section-Buttons">
				<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.View.Hash~}-Extra', 'PSFExt-Hidden')">Hide Extra Data for {~D:Record.View.Hash~}</a></li>
			</ul>
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-SolverEntry",
			Template: /*html*/`
			<div class="PSFExt-Section-Solver-Entry">
				<p class="PSFExt-Solver-Entry">{~D:Record.Expression~}</p>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Last Result</span> <span class="PSFExt-Solver-Result">{~D:Record.LastResult~}</span></p>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Sequence</span> Ordinal [{~D:Record.Ordinal~}] Index [{~D:Record.Index~}]</p>
			</div>
			`
		},
		{
			Hash: "Pict-Form-DebugViewer-GroupContainer",
			Template: /*html*/`
			<div class="PSFExt-Section-Group">
				<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">
					<span class="PSFExt-DeEmphasize">Group:</span> {~D:Record.Name~} [idx <em>{~D:Record.GroupIndex~}</em>]
				</h5>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Layout</span> {~D:Record.Layout~}</p>
				<div class="PSFExt-Section-Rows">
					{~TS:Pict-Form-DebugViewer-RowContainer:Record.Rows~}
				</div>
			</div>
			`
		},
		{
			Hash: "Pict-Form-DebugViewer-RowContainer",
			Template: /*html*/`
					<div class="PSFExt-Section-Descriptors">
						<h6 class="PSFExt-Content-Header PSFExt-Section-Group-Row-Header">
							<span class="PSFExt-DeEmphasize">Row:</span> {~D:Record.Hash~}
						</h6>
						{~TS:Pict-Form-DebugViewer-DescriptorContainer:Record.Inputs~}
					</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-DescriptorContainer",
			Template: /*html*/`
						<div class="PSFExt-Section-Descriptor">
							<p class="PSFExt-Data-Header"><span class="PSFExt-DeEmphasize">Input:</span> {~D:Record.Name~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Hash</span> {~D:Record.Hash~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">DataType</span> {~D:Record.DataType~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">InputType</span> {~D:Record.PictForm.InputType~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Informary Data Address</span> {~D:Record.PictForm.InformaryDataAddress~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Input Index</span> {~D:Record.PictForm.InputIndex~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">HTML ID</span> {~D:Record.PictForm.Macro.HTMLID~}</p>
						</div>
					`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-DebugViewer-Renderable",
			TemplateHash: "Pict-Form-DebugViewer-Content"
		}
	]
});

class PictFormsInlineEditor extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'ILE';
		this.DisplayLongName = 'InlineEditor';
	}
}

module.exports = PictFormsInlineEditor;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":571}],568:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-LifeCycle",

	DefaultRenderable: 'Pict-Form-LifeCycle-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-LifeCycle-Content",
			Template: /*html*/`
<div id="Pict-Form-LifeCycle-Content">
	<h2 class="PSFLC-Global-Header">Pict LifeCycle Visualization</h2>
</div>
`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-LifeCycle-Renderable",
			TemplateHash: "Pict-Form-LifeCycle-Content"
		}
	]
});

class PictFormsLifeCycle extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'LCV';
		this.DisplayLongName = 'LifecycleVisulization';
	}
}

module.exports = PictFormsLifeCycle;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":571}],569:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-Solver",

	DefaultRenderable: 'Pict-Form-Solver-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-Solver-Content",
			Template: /*html*/`
<div id="Pict-Form-Solver-Content">
	<h2 class="PSFS-Global-Header">Pict Solver Visualization</h2>
	<ul class="PSFExt-Section-Buttons">
		<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views.PictFormMetacontroller.solve(); {~P~}.views.PictFormMetacontroller.marshalFormSections(); {~P~}.views['{~D:Context[0].Hash~}'].render();">Solve</a></li>
	</ul>
	{~TS:Pict-Form-Solver-Entries:Context[0].getDynamicState().Solvers~}
</div>
`
		},
		{
			Hash: "Pict-Form-Solver-Entries",
			Template: /*html*/`
	<div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header">
			<span class="PSFExt-DeEmphasize">{~D:Record.ExpressionScope~} {~D:Record.SectionOrdinal~}.G.{~D:Record.GroupOrdinal~}</span> Ord</span>{~D:Record.Ordinal~} <span class="PSFExt-DeEmphasize">Ind</span>{~D:Record.Index~}
			[ <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">Edit</a> ]
			[ <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer', 'PSFExt-Hidden');">More</a> ]
		</h3>
		
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer" class="PSFExt-Hidden">
			<p class="PSFExt-Data">
				<textarea id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox" class="PSFExt-ExpressionEditbox">{~D:Record.Expression~}</textarea>
			</p>
			<ul class="PSFExt-Section-Buttons">
				<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].updateExpressionFromElement('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox', '{~D:Record.ExpressionScope~}', '{~D:Record.ViewHash~}', {~D:Record.SectionOrdinal~}, {~D:Record.Index~}, '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display'); {~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">Apply</a></li>
			</ul>
		</div>
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Extra" class="PSFExt-Section-ExtraData">
			<p class="PSFExt-Solver-Entry" id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display">{~D:Record.Expression~}</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Value</span> {~TBT:Record.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record:Pict-Form-RecordValueDisplaySimple~}
			</p>
		</div>
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer" class="PSFExt-Section-ExtraData PSFExt-Hidden">
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Tokens</h5>
			{~TS:Pict-Form-Solver-PostfixToken:Record.LastResultsObject.PostfixTokenObjects~}
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">Virtual Symbols</h5>
			{~TVS:Pict-Form-Solver-VirtualSymbols:Record.LastResultsObject.VirtualSymbols~}
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Solve List</h5>
			{~TVS:Pict-Form-Solver-PostFixSolveEntry:Record.LastResultsObject.PostfixSolveList~}
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-Solver-PostfixToken",
			Template: /*html*/`
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">{~D:Record.Type~}</span> <span class="PSFExt-Token">{~D:Record.Token~}</span>
			</p>
`
		},
		{
			Hash: "Pict-Form-Solver-VirtualSymbols",
			Template: /*html*/`
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">{~D:Record.Key~}</span> {~TBT:Record.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record:Pict-Form-RecordValueDisplaySimple~}
			</p>
`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayComplex",
			Template: /*html*/`
			<!-- Complex Value -->
			{~TBT:Record.Value:array:Pict-Form-RecordValueDisplayArray:Record:Pict-Form-RecordValueDisplayObject~}
`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayObject",
			Template: /*html*/`JSON Object
			<!-- RAW Object
{~DJ:Record.Value~}
			-->`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayArray",
			Template: /*html*/`JSON Array ({~D:Record.Value.length~} items)
			<!-- RAW Array
{~DJ:Record.Value~}
			-->`
		},
		{
			Hash: "Pict-Form-RecordValueDisplaySimple",
			Template: /*html*/`{~D:Record.Value~}`
		},
		{
			Hash: "Pict-Form-Solver-PostFixSolveEntry",
			Template: /*html*/`
			<div>
				<h6 class="PSFExt-Content-Header PSFExt-Data-Header">Postfix Solve Entry #{~D:Record.Key~} Symbol <span class="PSFExt-Token">{~D:Record.Value.VirtualSymbolName~}</span></h6>
				<table class="PSFExt-Data-Table">
					<th>
						<tr><td></td><td>Left</td><td>Operation</td><td>Right</td></tr>
					</th>
					<tr>
						<td>Virtual Symbol</td>
						<td> {~D:Record.Value.LeftValue.VirtualSymbolName~} </td>
						<td> {~D:Record.Value.Operation.VirtualSymbolName~} </td>
						<td> {~D:Record.Value.RightValue.VirtualSymbolName~} </td>
					</tr>
					<tr>
						<td>Value</td>
						<td> {~TBT:Record.Value.LeftValue.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record.Value.LeftValue:Pict-Form-RecordValueDisplaySimple~} </td>
						<td></td>
						<td> {~TBT:Record.Value.RightValue.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record.Value.RightValue:Pict-Form-RecordValueDisplaySimple~} </td>
					</tr>
					<tr>
						<td>Tokens</td>
						<td> {~D:Record.Value.LeftValue.Token~} </td>
						<td> {~D:Record.Value.Operation.Token~} </td>
						<td> {~D:Record.Value.RightValue.Token~} </td>
					</tr>
					<tr>
						<td>Type</td>
						<td> {~D:Record.Value.LeftValue.Type~} </td>
						<td> {~D:Record.Value.Operation.Type~} </td>
						<td> {~D:Record.Value.RightValue.Type~} </td>
					</tr>
					<tr>
						<td>Solve Layer</td>
						<td> {~D:Record.Value.LeftValue.SolveLayerStack~} </td>
						<td></td>
						<td> {~D:Record.Value.RightValue.SolveLayerStack~} </td>
					</tr>
				</table>
			</div>
`
		},
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-Solver-Renderable",
			TemplateHash: "Pict-Form-Solver-Content"
		}
	]
});

class PictFormsSolver extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'SLV';
		this.DisplayLongName = 'SolverVisualization';
	}
}

module.exports = PictFormsSolver;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":571}],570:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-SpecificSolve",

	DefaultRenderable: 'Pict-Form-SpecificSolve-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-SpecificSolve-Content",
			Template: /*html*/`
<div id="Pict-Form-SpecificSolve-Content">
	<h2 class="PSFSS-Global-Header">Pict Specific Solve Timing Visualization</h2>
</div>
`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-SpecificSolve-Renderable",
			TemplateHash: "Pict-Form-SpecificSolve-Content"
		}
	]
});

class PictFormsSpecificSolve extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'STV';
		this.DisplayLongName = 'SpecificSolveTimingVisualization';
	}
}

module.exports = PictFormsSpecificSolve;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":571}],571:[function(require,module,exports){
const libPictView = require(`pict-view`);

const libPictSupportProvider = require('./Pict-Provider-PSF-Support.js');

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-SupportBase",

	DefaultRenderable: 'Pict-Form-SUPPORT-BASE',

	RenderOnLoad: false,

	Templates: [],
	Renderables: [
		{
			RenderableHash: "Pict-Form-SUPPORT-BASE",
			TemplateHash: "Pict-Form-SUPPORT-BASE-NOTEMPLATE"
		}
	]
});

class PictFormsSupportBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Add the support provider if it doesn't exist
		this.pict.addProviderSingleton("Pict-Form-SupportExtensions", {}, libPictSupportProvider);

		this.DisplayShortName = 'U';
		this.DisplayLongName = 'UNDEFINED';

		// Register this with the support provider
		this.pict.providers["Pict-Form-SupportExtensions"].registerSupportView(this);
	}

	getDynamicState()
	{
		if (!('PictFormMetacontroller' in this.pict.views))
		{
			this.pict.log.warn(`Pict Forms Inline Editor tried to initialize but no metacontroller was found.`);
			return (
				{
					"Scope": `ERR_NO_METACONTROLLER`,
					"Description": `Error initializing inline editor -- no metacontroller found.`,
					"Manifest": this.fable.newManyfest(),
					"Sections": []
				});
		}
		let tmpMetacontroller = this.pict.views.PictFormMetacontroller;
		let tmpDynamicState = (
			{
				// TODO: The way the metacontroller pulls in the manifest and bootstraps the description is putting "DEFAULT" into the actual manifest; fix this.
				"Scope": tmpMetacontroller.manifestDescription.Scope,
				"Description": ``,
				"Manifest": tmpMetacontroller.manifest,
				"ManifestDescription": tmpMetacontroller.manifestDescription,
				"AllViews": tmpMetacontroller.filterViews(),
				"SectionViews": [],
				"DynamicInputView": false,
				"Solvers": []
			});

		for (let i = 0; i < tmpDynamicState.AllViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.AllViews[i];
			if (tmpSectionView.isPictSectionForm && (tmpSectionView.Hash == 'PictFormMetacontroller-DynamicInputs'))
			{
				// This is the special Dynamic Input section -- it goes in its own place.
				tmpDynamicState.DynamicInputView = tmpSectionView;
			}
			else if (tmpSectionView.isPictSectionForm)
			{
				tmpDynamicState.SectionViews.push(
					{
						View: tmpSectionView,
						sectionDefinition: tmpSectionView.sectionDefinition,
						Solvers: []
					});
			}
		}

		// Now get the solvers for each section view
		for (let i = 0; i < tmpDynamicState.SectionViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.SectionViews[i].View;
			let tmpSectionViewSolvers = tmpDynamicState.SectionViews[i].Solvers;
			// Find the view representation in the 
			if (tmpSectionView.isPictSectionForm && Array.isArray(tmpSectionView.sectionDefinition.Solvers))
			{
				for (let j = 0; j < tmpSectionView.sectionDefinition.Solvers.length; j++)
				{
					let tmpSolver = tmpSectionView.sectionDefinition.Solvers[j];

					let tmpSolverEntry = { ViewHash: tmpSectionView.Hash, SectionOrdinal: i, GroupOrdinal: -1, Ordinal: 1, Index: j, Expression: '', ExpressionType: 'Unknown', ExpressionScope: 'Section'}
					if (typeof(tmpSolver) === 'string')
					{
						tmpSolverEntry.Expression = tmpSolver;
						tmpSolverEntry.ExpressionType = 'Simple';
					}
					else if (typeof(tmpSolver) === 'object')
					{
						// When the solvers are in this format:
						// {
						// 	Ordinal: 0,
						// 	Expression: "PercentTotalFat = (Fat * 9) / Calories",
						// }
						tmpSolverEntry.Expression = tmpSolver.Expression;
						tmpSolverEntry.Ordinal = tmpSolver.Ordinal;
						tmpSolverEntry.ExpressionType = 'Complex';
					}
					tmpDynamicState.Solvers.push(tmpSolverEntry);
					tmpSectionViewSolvers.push(tmpSolverEntry);
				}
			}

			// Now get all the Group solvers
			// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
			for (let j = 0; j < tmpSectionView.sectionDefinition.Groups.length; j++)
			{
				let tmpGroup = tmpSectionView.getGroup(j);
				if (`RecordSetSolvers` in tmpGroup)
				{
					for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
					{
						let tmpSolver = tmpGroup.RecordSetSolvers[k];
	
						let tmpSolverEntry = { ViewHash: tmpSectionView.Hash, SectionOrdinal: i, GroupOrdinal: j, Ordinal: 1, Index: k, Expression: '', ExpressionType: 'Unknown', ExpressionScope: 'Group'}
						if (tmpSolver)
						{
							if (typeof(tmpSolver) === 'string')
							{
								tmpSolverEntry.Expression = tmpSolver;
								tmpSolverEntry.ExpressionType = 'Simple';
							}
							else if (typeof(tmpSolver) === 'object')
							{
								// When the solvers are in this format:
								// {
								// 	Ordinal: 0,
								// 	Expression: "PercentTotalFat = (Fat * 9) / Calories",
								// }
								tmpSolverEntry.Expression = tmpSolver.Expression;
								tmpSolverEntry.Ordinal = tmpSolver.Ordinal;
								tmpSolverEntry.ExpressionType = 'Complex';
							}
						}
						tmpDynamicState.Solvers.push(tmpSolverEntry);
						tmpSectionViewSolvers.push(tmpSolverEntry);
					}
				}
			}

			// Now sort the solvers by Ordinal, then Group/Section and then Index
			tmpSectionViewSolvers.sort((pLeftValue, pRightValue) => 
			{
				if (pLeftValue.Ordinal < pRightValue.Ordinal) return -1;
				if (pLeftValue.Ordinal > pRightValue.Ordinal) return 1;
				if (pLeftValue.ExpressionScope == 'Group' && pRightValue.ExpressionScope == 'Section') return -1;
				if (pLeftValue.ExpressionScope == 'Section' && pRightValue.ExpressionScope == 'Group') return 1;
				if (pLeftValue.Index < pRightValue.Index) return -1;
				if (pLeftValue.Index > pRightValue.Index) return 1;
				return 0;
			});
		}

		tmpDynamicState.Solvers.sort((pLeftValue, pRightValue) => 
			{
				if (pLeftValue.Ordinal < pRightValue.Ordinal) return -1;
				if (pLeftValue.Ordinal > pRightValue.Ordinal) return 1;
				if (pLeftValue.ExpressionScope == 'Group' && pRightValue.ExpressionScope == 'Section') return -1;
				if (pLeftValue.ExpressionScope == 'Section' && pRightValue.ExpressionScope == 'Group') return 1;
				if (pLeftValue.Index < pRightValue.Index) return -1;
				if (pLeftValue.Index > pRightValue.Index) return 1;
				return 0;
			});
		// Get the *full* last solve outcome object
		tmpDynamicState.LastSolveOutcome = this.pict.providers.DynamicSolver.lastSolveOutcome;

		// Now walk through the solvers and see if the outcome has a result for it.
		if (typeof(tmpDynamicState.LastSolveOutcome) == 'object')
		{
			for (let i = 0; i < tmpDynamicState.Solvers.length; i++)
			{
				let tmpSolverEntry = tmpDynamicState.Solvers[i];

				if (tmpSolverEntry.Ordinal in tmpDynamicState.LastSolveOutcome.SolveOrdinals)
				{
					if (tmpSolverEntry.ExpressionScope == 'Section')
					{
						let tmpSolveResultSet = tmpDynamicState.LastSolveOutcome.SolveOrdinals[tmpSolverEntry.Ordinal].SectionSolvers;
						if (Array.isArray(tmpSolveResultSet))
						{
							for (let j = 0; j < tmpSolveResultSet.length; j++)
							{
								let tmpPotentialResultEntry =	tmpSolveResultSet[j];
								if ((tmpPotentialResultEntry.ViewHash == tmpSolverEntry.ViewHash) && (tmpPotentialResultEntry.Solver.Expression == tmpSolverEntry.Expression))
								{
									// We have a match -- assign the result to the solver entry
									tmpSolverEntry.LastResult = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									tmpSolverEntry.Value = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									tmpSolverEntry.LastResultsObject = tmpPotentialResultEntry.Solver.ResultsObject;
								}
							}
						}
					}
					else if ((tmpSolverEntry.ExpressionScope == 'Group'))
					{
						let tmpSolveResultSet = tmpDynamicState.LastSolveOutcome.SolveOrdinals[tmpSolverEntry.Ordinal].GroupSolvers;
						if (Array.isArray(tmpSolveResultSet))
						{
							for (let j = 0; j < tmpSolveResultSet.length; j++)
							{
								let tmpPotentialResultEntry =	tmpSolveResultSet[j];
								if ((tmpPotentialResultEntry.ViewHash == tmpSolverEntry.ViewHash) && (tmpPotentialResultEntry.Solver.Expression == tmpSolverEntry.Expression))
								{
									// We have a match -- assign the result to the solver entry
									if (tmpPotentialResultEntry.Solver && ('ResultsObject' in tmpPotentialResultEntry.Solver))
									{
										tmpSolverEntry.LastResult = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									}
									if (tmpPotentialResultEntry.Solver && ('ResultsObject' in tmpPotentialResultEntry.Solver))
									{
										tmpSolverEntry.LastResultsObject = tmpPotentialResultEntry.Solver.ResultsObject;
									}
								}
							}
						}
					}
				}
			}
		}

		return tmpDynamicState;
	}

	getSectionSolvers(pSectionViewHash)
	{
		let tmpDynamicState = this.getDynamicState();
		let tmpSectionSolvers = tmpDynamicState.Solvers.map((pSolverEntry) => { if (pSolverEntry.ViewHash === pSectionViewHash) return pSolverEntry; });
		return tmpSectionSolvers;
	}


	downloadJSONObjectAsFile(pAddress)
	{
		try
		{
			const tmpJSONData = this.pict.resolveStateFromAddress(pAddress);
			const tmpJSONFileName = `PICT_JSON_${pAddress.replace('.','_')}.json`;
			const tmpJSONString = JSON.stringify(tmpJSONData, null, 4);

			if (!URL || !Blob)
			{
				this.pict.log.error(`Browser does not support required features for downloading JSON object from address ${pAddress}.`);
				return;
			}

			// Synthesize a file, URL and link to facilitate a file download
			const tmpAbstractFileBlob = new Blob([tmpJSONString], { type: "application/json" });
			const tmpAbstractFileURL = URL.createObjectURL(tmpAbstractFileBlob);
			const tmpAbstractAnchorElement = document.createElement("a");
			tmpAbstractAnchorElement.href = tmpAbstractFileURL;
			tmpAbstractAnchorElement.download = tmpJSONFileName;
			// Trigger the download
			tmpAbstractAnchorElement.click();
			// Clean up the URL from memory
			URL.revokeObjectURL(tmpAbstractFileURL);
		}
		catch (pError)
		{
			this.pict.log.error(`Error downloading JSON object from address ${pAddress}: ${pError.message}`);
		}
	}

	updateExpressionFromElement(pExpressionElementAddress, pExpressionScope, pSectionViewHash, pSectionOrdinal, pSolverIndex, pExpressionElementRepresentationAddress)
	{
		// 1. Get the expression from the element
		let tmpExpressionElementValue = this.pict.ContentAssignment.readContent(pExpressionElementAddress);

		if (!tmpExpressionElementValue)
		{
			this.pict.log.warn(`No expression found in element at address ${pExpressionElementAddress}; cannot update ${pExpressionScope} solver Ordinal ${pSectionOrdinal} Index ${pSolverIndex}.`);
			return;
		}
		// 2. Go through the enumeration of solvers to find if this expression exists
		let tmpMetacontroller = this.pict.views.PictFormMetacontroller;
		let tmpDynamicState = (
			{
				// TODO: The way the metacontroller pulls in the manifest and bootstraps the description is putting "DEFAULT" into the actual manifest; fix this.
				"Scope": tmpMetacontroller.manifestDescription.Scope,
				"Description": ``,
				"Manifest": tmpMetacontroller.manifest,
				"ManifestDescription": tmpMetacontroller.manifestDescription,
				"AllViews": tmpMetacontroller.filterViews(),
				"SectionViews": [],
				"DynamicInputView": false,
				"Solvers": []
			});

		for (let i = 0; i < tmpDynamicState.AllViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.AllViews[i];
			if (tmpSectionView.isPictSectionForm && (tmpSectionView.Hash == 'PictFormMetacontroller-DynamicInputs'))
			{
				// This is the special Dynamic Input section -- it goes in its own place.
				tmpDynamicState.DynamicInputView = tmpSectionView;
			}
			else if (tmpSectionView.isPictSectionForm)
			{
				tmpDynamicState.SectionViews.push(
					{
						View: tmpSectionView,
						sectionDefinition: tmpSectionView.sectionDefinition,
						Solvers: []
					});
			}
		}

		// Now get the solvers for each section view
		for (let i = 0; i < tmpDynamicState.SectionViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.SectionViews[i].View;
			let tmpSectionViewSolvers = tmpDynamicState.SectionViews[i].Solvers;
			// Find the view representation in the 
			if (tmpSectionView.isPictSectionForm && Array.isArray(tmpSectionView.sectionDefinition.Solvers))
			{
				for (let j = 0; j < tmpSectionView.sectionDefinition.Solvers.length; j++)
				{
					let tmpSolver = tmpSectionView.sectionDefinition.Solvers[j];

					// 3a. Update the expression in the solver definition
					if (pExpressionScope == 'Section' && i == pSectionOrdinal && j == pSolverIndex && tmpSectionView.Hash == pSectionViewHash)
					{
						// This is the solver we are updating
						if (typeof(tmpSolver) === 'string')
						{
							// Simple solver -- just a string
							tmpSectionView.sectionDefinition.Solvers[j] = tmpExpressionElementValue;
						}
						else if (typeof(tmpSolver) === 'object')
						{
							// Complex solver -- update the expression property
							tmpSectionView.sectionDefinition.Solvers[j].Expression = tmpExpressionElementValue;
						}
					}
				}
			}

			// Now get all the Group solvers
			// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
			for (let j = 0; j < tmpSectionView.sectionDefinition.Groups.length; j++)
			{
				let tmpGroup = tmpSectionView.getGroup(j);
				if (`RecordSetSolvers` in tmpGroup)
				{
					for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
					{
						let tmpSolver = tmpGroup.RecordSetSolvers[k];
	
						// 3b. Update the expression in the solver definition
						if (pExpressionScope == 'Group' && i == pSectionOrdinal && j == pSolverIndex && tmpSectionView.Hash == pSectionViewHash)
						{
							// This is the solver we are updating
							if (typeof(tmpSolver) === 'string')
							{
								// Simple solver -- just a string
								tmpSectionView.sectionDefinition.Solvers[j] = tmpExpressionElementValue;
							}
							else if (typeof(tmpSolver) === 'object')
							{
								// Complex solver -- update the expression property
								tmpSectionView.sectionDefinition.Solvers[j].Expression = tmpExpressionElementValue;
							}
						}
					}
				}
			}
		}

		// 4. Write the updated expression to it's representation element, if provided
		if (pExpressionElementRepresentationAddress)
		{
			this.pict.ContentAssignment.assignContent(pExpressionElementRepresentationAddress, tmpExpressionElementValue);
		}
	}

	bootstrapContainer()
	{
		// 3. See if the container for the support view is loaded
		let tmpContainerTest = this.options.DefaultDestinationAddress;

		let tmpContainerElement = this.pict.ContentAssignment.getElement(this.options.DefaultDestinationAddress);
		if (tmpContainerElement.length > 0)
		{
			return true;
		}

		// 4. Render the container for the support view if it isn't loaded
		let tmpContainerRenderableHash = 'Pict-Form-Support-Container';

		// Check if the renderable exists -- if not, create it dynamically
		// This just appends itself to the body once, and creates a simple container for extensions to load into.
		if (!(tmpContainerRenderableHash in this.renderables))
		{
			this.renderables[tmpContainerRenderableHash] = (
				{
					RenderableHash: "Pict-Form-Support-Container",
					TemplateHash: "Pict-Form-Support-Container",
					ContentDestinationAddress: 'body',
					RenderMethod: 'append_once',
					TestAddress: "#Pict-Form-Extensions-Container",
				});
		}

		this.renderables[tmpContainerRenderableHash].TestAddress = tmpContainerTest;
		this.pict.CSSMap.injectCSS();

		this.render(tmpContainerRenderableHash);

		// 5. Make the container draggable
		// Setup the draggable behavior for the window
		let tmpDraggableElement = document.getElementById('Pict-Form-Extensions-Wrap'); // What we are dragging
		let tmpDragInteractiveControl = document.getElementById('Pict-Form-Extension-DragControl'); // The control you click on to drag
		if (tmpDraggableElement && tmpDragInteractiveControl)
		{
			tmpDragInteractiveControl.addEventListener('mousedown',
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				* BEGIN of browser event code block
				*
				* The below code is meant to run in response to a browser event.
				* --> Therefore the "this" context is the element that fired the event.
				* --> Happy trails.
				*/
				function (pEvent)
				{
					let tmpOffsetX = pEvent.offsetX + tmpDragInteractiveControl.clientLeft;
					let tmpOffsetY = pEvent.offsetY + tmpDragInteractiveControl.clientTop;
					function dragHandler(pEvent)
					{
						pEvent.stopPropagation();
						
						tmpDraggableElement.style.left = (pEvent.clientX - tmpOffsetX) + 'px';
						tmpDraggableElement.style.top = (pEvent.clientY - tmpOffsetY) + 'px';
					}
					function dragStop(pEvent)
					{
						window.removeEventListener('pointermove', dragHandler);
						window.removeEventListener('pointerup', dragStop);
					}
					window.addEventListener('pointermove', dragHandler);
					window.addEventListener('pointerup', dragStop);

					// Prevent janky selection behaviors in the browser
					pEvent.preventDefault();
				});
				/*
				* END of browser event code block
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
		}

		// 6. Make the container resizable
		// Setup the draggable behavior for the window
		let tmpResizableElement = document.getElementById('Pict-Form-Extensions-Wrap'); // What we are resizing
		let tmpResizableControl = document.getElementById('Pict-Form-Extension-ResizeControl'); // The control you click on to drag
		if (tmpResizableElement && tmpResizableControl)
		{
			tmpResizableControl.addEventListener('mousedown',
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				* BEGIN of browser event code block
				*
				* The below code is meant to run in response to a browser event.
				* --> Therefore the "this" context is the element that fired the event.
				* --> Happy trails.
				*/
				function (pEvent)
				{
					function dragResizeHandler(pEvent)
					{
						pEvent.stopPropagation();
						
						let tmpNewWidth = pEvent.clientX - tmpResizableElement.getBoundingClientRect().left;
						let tmpNewHeight = pEvent.clientY - tmpResizableElement.getBoundingClientRect().top;

						// Check the CSS for minimum width and height, and set these to those if we go under
						let tmpComputedStyle = getComputedStyle(tmpResizableElement);
						let tmpMinWidth = parseInt(tmpComputedStyle.minWidth, 10);
						let tmpMinHeight = parseInt(tmpComputedStyle.minHeight, 10);

						if (tmpNewWidth < tmpMinWidth)
						{
							tmpNewWidth = tmpMinWidth;
						}
						if (tmpNewHeight < tmpMinHeight)
						{
							tmpNewHeight = tmpMinHeight;
						}
						tmpResizableElement.style.width = tmpNewWidth + 'px';
						tmpResizableElement.style.height = tmpNewHeight + 'px';
					}
					function dragResizeStop(pEvent)
					{
						window.removeEventListener('pointermove', dragResizeHandler);
						window.removeEventListener('pointerup', dragResizeStop);
					}
					window.addEventListener('pointermove', dragResizeHandler);
					window.addEventListener('pointerup', dragResizeStop);

					// Prevent janky selection behaviors in the browser
					pEvent.preventDefault();
				});
				/*
				* END of browser event code block
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
		}

	}
}

module.exports = PictFormsSupportBase;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-Provider-PSF-Support.js":565,"pict-view":693}],572:[function(require,module,exports){
module.exports={
	"RenderOnLoad": true,

	"DefaultRenderable": "Leaflet-Wrap",
	"DefaultDestinationAddress": "#Pict-Leaflet-Container-Div",

	"LeafletDestinationAddress": "Leaflet-Map-Container-Div",
	"LeafletInitialZoom": 13,
	"LeafletInitialCenter": [ 21.315603, -157.858093 ],

	"Templates": [
		{
			"Hash": "Leaflet-Container",
			"Template": "<div id=\"Leaflet-Map-Container-Div\"></div>"
		}
	],

	"Renderables": [
		{
			"RenderableHash": "Leaflet-Wrap",
			"TemplateHash": "Leaflet-Container",
			"DestinationAddress": "#Pict-Leaflet-Container-Div"
		}
	]
}
},{}],573:[function(require,module,exports){
const libPictViewClass = require('pict-view');

class PictSectionLeaflet extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, require('./Pict-Section-Leaflet-DefaultConfiguration.json'), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		this.leafletInitialCenter = this.options.LeafletInitialCenter;
		this.leafletInitialZoom = this.options.LeafletInitialZoom;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._leafletPrototype = false;

		this.leaflet = false;
	}

	connectLeafletPrototype(pLeafletPrototype)
	{
		if (typeof (pLeafletPrototype) != 'undefined')
		{
			this._leafletPrototype = pLeafletPrototype;
		}
		else
		{
			this.log.trace(`PICT-Leaflet No Leaflet Prototype defined or explicitly set; looking for it in the window object.`);
			if (typeof (window) != 'undefined')
			{
				if (typeof (window.L) != 'undefined')
				{
					this.log.trace(`PICT-Leaflet Found Leaflet Prototype in window.L.`);
					this.connectLeafletPrototype(window.L);
				}
				else
				{
					this.log.error(`PICT-Leaflet No Leaflet Prototype found in window.L.`);
					return false;
				}
			}
			else
			{
				this.log.error(`PICT-Leaflet No Leaflet Prototype found in window.leaflet -- window object unavailable.  The map will not function.`);
				return false;
			}
		}
	}

	onAfterRender()
	{
		if (this.leaflet)
		{
			delete this.leaflet;
		}
		// This is where we wire up and initialize the leaflet control.
		this.connectLeafletPrototype();
		if (this.leaflet)
		{
			// The map is already initialized.
			this.log.error(`Leaflet going to ${this.options.LeafletDestinationAddress} is already initialized!`);
			return false;
		}

		let libLeaflet = this._leafletPrototype;
		// Note the leaflet destination address is not a browser address but just the text of the ID
		this.leaflet = libLeaflet.map(this.options.LeafletDestinationAddress);

		this.leaflet.setView(this.leafletInitialCenter, this.leafletInitialZoom);

		this.onAfterInitializeLeaflet();

		return true;
	}

	onAfterInitializeLeaflet()
	{

	}
}

module.exports = PictSectionLeaflet;

module.exports.default_configuration = require('./Pict-Section-Leaflet-DefaultConfiguration.json');
},{"./Pict-Section-Leaflet-DefaultConfiguration.json":572,"pict-view":693}],574:[function(require,module,exports){
/**
 * Pict-MDE-CodeMirror: Helper module for PictSectionMarkdownEditor
 *
 * Handles CodeMirror editor instance creation, extension configuration,
 * keyboard shortcuts, paste handling, and the data URI collapse extension.
 */

/**
 * Attach CodeMirror editor creation methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Create a CodeMirror editor instance inside a container element.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to mount the editor in
	 * @param {number} pSegmentIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	pView._createEditorInContainer = function _createEditorInContainer(pContainer, pSegmentIndex, pContent)
	{
		let tmpCM = pView._codeMirrorModules;

		// Build the extensions array
		let tmpExtensions = [];

		// Keyboard shortcuts for formatting, inter-segment navigation, and image paste handling
		// IMPORTANT: Must be added BEFORE consumer extensions (e.g. basicSetup) so that
		// our domEventHandlers fire before CM6's internal keymap handlers.
		tmpExtensions.push(
			tmpCM.EditorView.domEventHandlers(
			{
				keydown: (pEvent, pEditorView) =>
				{
					// Ctrl/Cmd + B = bold
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'b')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'bold');
						return true;
					}
					// Ctrl/Cmd + I = italic
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'i')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'italic');
						return true;
					}
					// Ctrl/Cmd + E = inline code
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'e')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'code');
						return true;
					}

				},
				paste: (pEvent, pEditorView) =>
				{
					// Check clipboard for image data
					let tmpItems = pEvent.clipboardData && pEvent.clipboardData.items;
					if (!tmpItems)
					{
						return false;
					}
					for (let i = 0; i < tmpItems.length; i++)
					{
						// Paste: a clipboard item is not a File yet, so the type is tested directly.
						if (tmpItems[i].type.startsWith('image/') || tmpItems[i].type.startsWith('video/'))
						{
							pEvent.preventDefault();
							let tmpFile = tmpItems[i].getAsFile();
							if (tmpFile)
							{
								pView._processImageFile(tmpFile, pSegmentIndex);
							}
							return true;
						}
					}
					return false;
				},
				drop: (pEvent, pEditorView) =>
				{
					// Intercept image file drops at the CodeMirror level to prevent
					// the browser from inserting the image as a raw DOM element.
					// Without this, both CodeMirror's default drop behavior AND the
					// container-level handler fire, causing rendering artifacts.
					if (pView._dragSourceIndex >= 0)
					{
						return false; // segment-reorder drag, not a file drop
					}
					if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
					{
						return false;
					}
					let tmpFile = pEvent.dataTransfer.files[0];
					if (pView._isEmbeddableFile(tmpFile))
					{
						pEvent.preventDefault();
						pEvent.stopPropagation();
						pView._processImageFile(tmpFile, pSegmentIndex);
						// Clean up the dragover visual indicator on the container
						let tmpContainer = pEditorView.dom.closest('.pict-mde-segment-editor');
						if (tmpContainer)
						{
							tmpContainer.classList.remove('pict-mde-image-dragover');
						}
						return true;
					}
					return false;
				}
			})
		);

		// Add consumer-provided extensions (e.g. basicSetup, markdown())
		if (tmpCM.extensions && Array.isArray(tmpCM.extensions))
		{
			tmpExtensions = tmpExtensions.concat(tmpCM.extensions);
		}

		// Wrap long lines instead of scrolling horizontally. Markdown is prose, and
		// a horizontally-scrolling editor in a narrow pane is unusable. On by
		// default; a consumer can disable it with LineWrapping: false.
		if (pView.options.LineWrapping !== false)
		{
			tmpExtensions.push(tmpCM.EditorView.lineWrapping);
		}

		// Update listener for content changes, focus, and cursor tracking
		tmpExtensions.push(
			tmpCM.EditorView.updateListener.of((pUpdate) =>
			{
				if (pUpdate.docChanged)
				{
					pView._onSegmentContentChange(pSegmentIndex, pUpdate.state.doc.toString());
				}

				// Track focus changes to toggle the active class
				if (pUpdate.focusChanged)
				{
					if (pUpdate.view.hasFocus)
					{
						pView._setActiveSegment(pSegmentIndex);
						// Position sidebar at cursor on focus
						pView._updateSidebarPosition(pSegmentIndex);
					}
					else
					{
						// Small delay so clicking a sidebar button doesn't immediately deactivate
						setTimeout(() =>
						{
							if (pView._activeSegmentIndex === pSegmentIndex)
							{
								// Check if focus moved to another segment or truly left
								let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
								if (tmpSegEl && !tmpSegEl.contains(document.activeElement))
								{
									pView._clearActiveSegment(pSegmentIndex);
									pView._resetSidebarPosition(pSegmentIndex);
								}
							}
						}, 100);
					}
				}

				// Track cursor/selection changes to move the sidebar
				if (pUpdate.selectionSet && pUpdate.view.hasFocus)
				{
					pView._updateSidebarPosition(pSegmentIndex);
				}
			})
		);

		// Collapse long data URIs in image markdown so the editor is readable
		let tmpCollapseExtension = pView._buildDataURICollapseExtension();
		if (tmpCollapseExtension)
		{
			tmpExtensions.push(tmpCollapseExtension);
		}

		// Make read-only if configured
		if (pView.options.ReadOnly)
		{
			tmpExtensions.push(tmpCM.EditorState.readOnly.of(true));
			tmpExtensions.push(tmpCM.EditorView.editable.of(false));
		}

		// Allow consumer to customize extensions
		tmpExtensions = pView.customConfigureExtensions(tmpExtensions, pSegmentIndex);

		let tmpState = tmpCM.EditorState.create(
		{
			doc: pContent || '',
			extensions: tmpExtensions
		});

		let tmpEditorView = new tmpCM.EditorView(
		{
			state: tmpState,
			parent: pContainer
		});

		pView._segmentEditors[pSegmentIndex] = tmpEditorView;

		// -- Inter-segment arrow-key navigation --
		// Use a capture-phase DOM listener so we intercept ArrowDown/ArrowUp
		// BEFORE CodeMirror's internal keymap handlers process them.
		tmpEditorView.contentDOM.addEventListener('keydown', function (pEvent)
		{
			if (pEvent.key !== 'ArrowDown' && pEvent.key !== 'ArrowUp')
			{
				return;
			}
			// Don't interfere if a modifier key is held (selection, etc.)
			if (pEvent.shiftKey || pEvent.ctrlKey || pEvent.metaKey || pEvent.altKey)
			{
				return;
			}

			let tmpState = tmpEditorView.state;
			let tmpCursorPos = tmpState.selection.main.head;
			let tmpLine = tmpState.doc.lineAt(tmpCursorPos);
			let tmpColumnOffset = tmpCursorPos - tmpLine.from;

			if (pEvent.key === 'ArrowDown')
			{
				// Only navigate when cursor is on the very last line
				if (tmpLine.to < tmpState.doc.length)
				{
					return; // not on last line — let CM handle it
				}

				// Find next segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpOrderedIndices.length - 1)
				{
					return; // last segment — nowhere to go
				}

				let tmpNextInternalIndex = tmpOrderedIndices[tmpLogicalIndex + 1];
				let tmpNextEditor = pView._segmentEditors[tmpNextInternalIndex];
				if (!tmpNextEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the next editor and place cursor on the first line
				let tmpFirstLine = tmpNextEditor.state.doc.line(1);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpFirstLine.to - tmpFirstLine.from);
				tmpNextEditor.focus();
				tmpNextEditor.dispatch({ selection: { anchor: tmpFirstLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpNextInternalIndex);
			}
			else if (pEvent.key === 'ArrowUp')
			{
				// Only navigate when cursor is on the very first line
				if (tmpLine.number > 1)
				{
					return; // not on first line — let CM handle it
				}

				// Find previous segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex <= 0)
				{
					return; // first segment — nowhere to go
				}

				let tmpPrevInternalIndex = tmpOrderedIndices[tmpLogicalIndex - 1];
				let tmpPrevEditor = pView._segmentEditors[tmpPrevInternalIndex];
				if (!tmpPrevEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the previous editor and place cursor on the last line
				let tmpLastLine = tmpPrevEditor.state.doc.line(tmpPrevEditor.state.doc.lines);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpLastLine.to - tmpLastLine.from);
				tmpPrevEditor.focus();
				tmpPrevEditor.dispatch({ selection: { anchor: tmpLastLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpPrevInternalIndex);
			}
		}, true); // <-- capture phase

		// -- Capture-phase drop listener for image files --
		// Safari processes native contenteditable drops before CodeMirror's
		// bubble-phase domEventHandlers fire, which can insert a raw <img>
		// element into the editor DOM.  A capture-phase listener fires first
		// and lets us preventDefault() before the browser acts.
		tmpEditorView.contentDOM.addEventListener('drop', function (pEvent)
		{
			if (pView._dragSourceIndex >= 0)
			{
				return; // segment-reorder drag
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}
			let tmpFile = pEvent.dataTransfer.files[0];
			if (pView._isEmbeddableFile(tmpFile))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
				// Clean up the dragover visual indicator
				let tmpEditorEl = pView._resolveInstanceElement(`PictMDE-SegmentEditor-${pSegmentIndex}`);
				if (tmpEditorEl)
				{
					tmpEditorEl.classList.remove('pict-mde-image-dragover');
				}
			}
		}, true); // <-- capture phase
	};

	/**
	 * Build a CodeMirror extension that visually collapses long data URIs
	 * inside markdown image syntax.
	 *
	 * The extension uses Decoration.replace() to hide the long base64 portion
	 * and show a compact widget instead, e.g. "data:image/jpeg;base64...28KB".
	 * The actual document content is unchanged -- only the visual display
	 * is affected.
	 *
	 * Returns null if the required CodeMirror modules (Decoration, ViewPlugin,
	 * WidgetType) are not available.
	 *
	 * @returns {object|null} A CodeMirror ViewPlugin extension, or null
	 */
	pView._buildDataURICollapseExtension = function _buildDataURICollapseExtension()
	{
		let tmpCM = pView._codeMirrorModules;

		// All three classes are required -- degrade gracefully if not available
		if (!tmpCM || !tmpCM.Decoration || !tmpCM.ViewPlugin || !tmpCM.WidgetType)
		{
			return null;
		}

		let tmpDecoration = tmpCM.Decoration;
		let tmpViewPlugin = tmpCM.ViewPlugin;
		let tmpWidgetType = tmpCM.WidgetType;

		// Minimum data URI length before collapsing (short URIs are left alone)
		let tmpMinLength = 200;

		// Widget class: renders the collapsed placeholder inline
		class DataURIWidget extends tmpWidgetType
		{
			constructor(pLabel)
			{
				super();
				this.label = pLabel;
			}

			toDOM()
			{
				let tmpSpan = document.createElement('span');
				tmpSpan.className = 'pict-mde-data-uri-collapsed';
				tmpSpan.textContent = this.label;
				tmpSpan.title = 'Data URI (click to expand in image preview below)';
				return tmpSpan;
			}

			eq(pOther)
			{
				return this.label === pOther.label;
			}
		}

		/**
		 * Scan the visible ranges of the document for data URIs inside image
		 * markdown and build a DecorationSet that replaces the long portion.
		 *
		 * Pattern:  ![alt](data:image/TYPE;base64,LONGSTRING)
		 *
		 * We keep "![alt](data:image/TYPE;base64," visible and replace only the
		 * long base64 payload plus the closing ")" with a compact widget.
		 */
		function buildDecorations(pEditorView)
		{
			let tmpDecorations = [];
			let tmpDoc = pEditorView.state.doc;

			for (let tmpVisRange of pEditorView.visibleRanges)
			{
				let tmpFrom = tmpVisRange.from;
				let tmpTo = tmpVisRange.to;
				let tmpText = tmpDoc.sliceString(tmpFrom, tmpTo);

				// Match: ![...](data:image/...;base64,...) -- we need positions of the base64 payload
				let tmpRegex = /!\[[^\]]*\]\(data:([^;]+);base64,/g;
				let tmpMatch;

				while ((tmpMatch = tmpRegex.exec(tmpText)) !== null)
				{
					// tmpMatch[0] is "![alt](data:image/png;base64,"
					// tmpMatch[1] is the MIME subtype, e.g. "image/png"
					let tmpPayloadStart = tmpFrom + tmpMatch.index + tmpMatch[0].length;

					// Find the closing parenthesis -- scan forward from payloadStart
					let tmpPayloadEnd = -1;
					let tmpSearchFrom = tmpPayloadStart;
					let tmpDocLength = tmpDoc.length;

					// Scan character by character in the document for the closing ')'
					// We need to handle this carefully since the payload could be huge
					// and span beyond the visible range.
					// Search up to 5MB worth of characters (way more than any realistic image).
					let tmpMaxScan = Math.min(tmpDocLength, tmpSearchFrom + 5 * 1024 * 1024);
					let tmpChunkSize = 4096;

					for (let tmpPos = tmpSearchFrom; tmpPos < tmpMaxScan; tmpPos += tmpChunkSize)
					{
						let tmpEnd = Math.min(tmpPos + tmpChunkSize, tmpMaxScan);
						let tmpChunk = tmpDoc.sliceString(tmpPos, tmpEnd);
						let tmpParenIdx = tmpChunk.indexOf(')');
						if (tmpParenIdx >= 0)
						{
							tmpPayloadEnd = tmpPos + tmpParenIdx;
							break;
						}
					}

					if (tmpPayloadEnd < 0)
					{
						// No closing paren found -- skip this match
						continue;
					}

					// Calculate the payload length (base64 data between comma and closing paren)
					let tmpPayloadLength = tmpPayloadEnd - tmpPayloadStart;

					if (tmpPayloadLength < tmpMinLength)
					{
						// Too short to bother collapsing
						continue;
					}

					// Build a human-readable size label
					let tmpSizeBytes = Math.round(tmpPayloadLength * 0.75); // base64 to bytes approx
					let tmpSizeLabel;
					if (tmpSizeBytes >= 1024 * 1024)
					{
						tmpSizeLabel = (tmpSizeBytes / (1024 * 1024)).toFixed(1) + 'MB';
					}
					else if (tmpSizeBytes >= 1024)
					{
						tmpSizeLabel = Math.round(tmpSizeBytes / 1024) + 'KB';
					}
					else
					{
						tmpSizeLabel = tmpSizeBytes + 'B';
					}

					let tmpMimeType = tmpMatch[1] || 'image';
					let tmpWidgetLabel = `\u2026${tmpSizeLabel})`;

					// Replace from the start of the base64 payload to after the closing paren
					let tmpWidget = tmpDecoration.replace(
					{
						widget: new DataURIWidget(tmpWidgetLabel)
					});

					tmpDecorations.push(tmpWidget.range(tmpPayloadStart, tmpPayloadEnd + 1));
				}
			}

			return tmpDecoration.set(tmpDecorations, true);
		}

		// Create the ViewPlugin
		let tmpPlugin = tmpViewPlugin.fromClass(
			class
			{
				constructor(pEditorView)
				{
					this.decorations = buildDecorations(pEditorView);
				}

				update(pUpdate)
				{
					if (pUpdate.docChanged || pUpdate.viewportChanged)
					{
						this.decorations = buildDecorations(pUpdate.view);
					}
				}
			},
			{
				decorations: (pPlugin) => pPlugin.decorations
			}
		);

		return tmpPlugin;
	};
};

},{}],575:[function(require,module,exports){
/**
 * Pict-MDE-DragAndReorder: Helper module for PictSectionMarkdownEditor
 *
 * Handles segment drag-and-drop reordering, active segment management,
 * sidebar cursor-tracking positioning, and hidden-preview state maintenance
 * across reorder operations.
 */

/**
 * Attach drag/reorder and active-segment methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Wire drag-and-drop events on a segment element for reorder via the drag handle.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireSegmentDragEvents = function _wireSegmentDragEvents(pSegmentElement, pSegmentIndex)
	{
		let tmpHandle = pSegmentElement.querySelector('.pict-mde-drag-handle');
		if (!tmpHandle)
		{
			return;
		}

		// The drag handle is the draggable element
		tmpHandle.addEventListener('dragstart', (pEvent) =>
		{
			pView._dragSourceIndex = pSegmentIndex;
			pEvent.dataTransfer.effectAllowed = 'move';
			pEvent.dataTransfer.setData('text/plain', String(pSegmentIndex));
			// Add a dragging class to the container so CSS can disable pointer-events
			// on CodeMirror editors (preventing them from intercepting the drop event)
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.add('pict-mde-dragging');
			}
			setTimeout(() =>
			{
				pSegmentElement.style.opacity = '0.4';
			}, 0);
		});

		tmpHandle.addEventListener('dragend', () =>
		{
			pSegmentElement.style.opacity = '';
			pView._dragSourceIndex = -1;
			pView._clearAllDropIndicators();
			// Remove the dragging class from the container
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.remove('pict-mde-dragging');
			}
		});

		// Drop target: the whole segment row. We determine above/below from mouse Y.
		pSegmentElement.addEventListener('dragover', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'move';

			// Clear all indicators first, then set the correct one
			pView._clearAllDropIndicators();

			// Determine if cursor is in the top or bottom half of this segment
			let tmpRect = pSegmentElement.getBoundingClientRect();
			let tmpMidY = tmpRect.top + (tmpRect.height / 2);
			if (pEvent.clientY < tmpMidY)
			{
				pSegmentElement.classList.add('pict-mde-drag-over-top');
			}
			else
			{
				pSegmentElement.classList.add('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if we're actually leaving the element (not entering a child)
			if (!pSegmentElement.contains(pEvent.relatedTarget))
			{
				pSegmentElement.classList.remove('pict-mde-drag-over-top');
				pSegmentElement.classList.remove('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('drop', (pEvent) =>
		{
			pEvent.preventDefault();

			let tmpDropBelow = pSegmentElement.classList.contains('pict-mde-drag-over-bottom');
			pView._clearAllDropIndicators();

			let tmpSourceIndex = pView._dragSourceIndex;
			if (tmpSourceIndex < 0 || tmpSourceIndex === pSegmentIndex)
			{
				return;
			}

			pView._reorderSegment(tmpSourceIndex, pSegmentIndex, tmpDropBelow);
		});
	};

	/**
	 * Clear all drop indicator classes from all segments.
	 */
	pView._clearAllDropIndicators = function _clearAllDropIndicators()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}
		let tmpAllSegments = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpAllSegments.length; i++)
		{
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-top');
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-bottom');
		}
	};

	/**
	 * Reorder a segment from one position to another via drag.
	 *
	 * @param {number} pFromInternalIndex - The internal index of the dragged segment
	 * @param {number} pToInternalIndex - The internal index of the drop target
	 * @param {boolean} pDropBelow - Whether the drop was on the bottom half of the target
	 */
	pView._reorderSegment = function _reorderSegment(pFromInternalIndex, pToInternalIndex, pDropBelow)
	{
		let tmpFromLogical = pView._getLogicalIndex(pFromInternalIndex);
		let tmpToLogical = pView._getLogicalIndex(pToInternalIndex);

		if (tmpFromLogical < 0 || tmpToLogical < 0)
		{
			pView.log.warn(`PICT-MarkdownEditor _reorderSegment: could not resolve logical indices (from=${tmpFromLogical}, to=${tmpToLogical}).`);
			return;
		}

		if (tmpFromLogical === tmpToLogical)
		{
			return;
		}

		// Marshal all editor content back to data before manipulating the array
		pView._marshalAllEditorsToData();

		let tmpSegments = pView._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length < 2)
		{
			return;
		}

		// Calculate the target insertion index
		let tmpInsertAt = pDropBelow ? tmpToLogical + 1 : tmpToLogical;

		// Adjust for the removal shifting indices down
		if (tmpFromLogical < tmpInsertAt)
		{
			tmpInsertAt--;
		}

		// If the insert position equals the source, no move needed
		if (tmpInsertAt === tmpFromLogical)
		{
			return;
		}

		// Perform the reorder: remove from old position, insert at new
		let tmpMoved = tmpSegments.splice(tmpFromLogical, 1)[0];
		tmpSegments.splice(tmpInsertAt, 0, tmpMoved);

		// Explicitly write the reordered array back to the data address
		pView._setSegmentsToData(tmpSegments);

		// Reorder per-segment hidden preview state to follow the moved segment
		pView._reorderHiddenPreviewState(tmpFromLogical, tmpInsertAt);

		// Reorder per-segment tab states to follow the moved segment
		pView._reorderSegmentTabStates(tmpFromLogical, tmpInsertAt);

		pView._buildEditorUI();
	};

	/**
	 * Reorder the hidden preview state after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderHiddenPreviewState = function _reorderHiddenPreviewState(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		// Build an ordered array of hidden-state booleans
		let tmpKeys = Object.keys(pView._hiddenPreviewSegments).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(!!pView._hiddenPreviewSegments[i]);
		}

		// Perform the same splice on the states array
		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		// Rebuild the hidden map
		pView._hiddenPreviewSegments = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i])
			{
				pView._hiddenPreviewSegments[i] = true;
			}
		}
	};

	/**
	 * Swap the hidden preview state of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapHiddenPreviewState = function _swapHiddenPreviewState(pIndexA, pIndexB)
	{
		let tmpAHidden = !!pView._hiddenPreviewSegments[pIndexA];
		let tmpBHidden = !!pView._hiddenPreviewSegments[pIndexB];

		if (tmpBHidden) { pView._hiddenPreviewSegments[pIndexA] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexA]; }

		if (tmpAHidden) { pView._hiddenPreviewSegments[pIndexB] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexB]; }
	};

	/**
	 * Reorder the segment tab states after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderSegmentTabStates = function _reorderSegmentTabStates(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		let tmpKeys = Object.keys(pView._segmentTabStates).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(pView._segmentTabStates[i] || 'editor');
		}

		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		pView._segmentTabStates = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i] !== 'editor')
			{
				pView._segmentTabStates[i] = tmpStates[i];
			}
		}
	};

	/**
	 * Swap the segment tab states of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapSegmentTabStates = function _swapSegmentTabStates(pIndexA, pIndexB)
	{
		let tmpA = pView._segmentTabStates[pIndexA] || 'editor';
		let tmpB = pView._segmentTabStates[pIndexB] || 'editor';

		if (tmpB !== 'editor') { pView._segmentTabStates[pIndexA] = tmpB; }
		else { delete pView._segmentTabStates[pIndexA]; }

		if (tmpA !== 'editor') { pView._segmentTabStates[pIndexB] = tmpA; }
		else { delete pView._segmentTabStates[pIndexB]; }
	};

	// -- Active Segment Management --

	/**
	 * Set a segment as the active (focused) segment.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._setActiveSegment = function _setActiveSegment(pSegmentIndex)
	{
		// Clear previous active
		if (pView._activeSegmentIndex >= 0 && pView._activeSegmentIndex !== pSegmentIndex)
		{
			let tmpPrevEl = pView._resolveInstanceElement(`PictMDE-Segment-${pView._activeSegmentIndex}`);
			if (tmpPrevEl)
			{
				tmpPrevEl.classList.remove('pict-mde-active');
			}
		}

		pView._activeSegmentIndex = pSegmentIndex;

		let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.add('pict-mde-active');
		}
	};

	/**
	 * Clear the active state from a segment (on blur).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._clearActiveSegment = function _clearActiveSegment(pSegmentIndex)
	{
		if (pView._activeSegmentIndex === pSegmentIndex)
		{
			pView._activeSegmentIndex = -1;
		}

		let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.remove('pict-mde-active');
		}

		// Reset sidebar back to sticky when segment is no longer active
		pView._resetSidebarPosition(pSegmentIndex);
	};

	// -- Sidebar Cursor Tracking --

	/**
	 * Update the sidebar formatting-buttons position so they float next to the
	 * cursor / selection in the active segment.
	 *
	 * When a segment is active and has a cursor, we switch the sidebar-actions
	 * from sticky positioning to absolute, offset to align with the cursor line.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateSidebarPosition = function _updateSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			return;
		}

		// Get the cursor position in the editor
		let tmpCursorPos = tmpEditor.state.selection.main.head;
		let tmpCursorCoords = tmpEditor.coordsAtPos(tmpCursorPos);
		if (!tmpCursorCoords)
		{
			// If we can't get coords, revert to sticky
			pView._resetSidebarPosition(pSegmentIndex);
			return;
		}

		// Calculate the offset relative to the segment element
		let tmpSegmentRect = tmpSegmentEl.getBoundingClientRect();
		let tmpOffsetTop = tmpCursorCoords.top - tmpSegmentRect.top;

		// Clamp so the sidebar buttons don't go above the segment or below it
		let tmpSidebarHeight = tmpQuadrantTR.offsetHeight || 0;
		let tmpSegmentHeight = tmpSegmentEl.offsetHeight || 0;
		let tmpMaxOffset = Math.max(0, tmpSegmentHeight - tmpSidebarHeight);
		tmpOffsetTop = Math.max(0, Math.min(tmpOffsetTop, tmpMaxOffset));

		// Apply the cursor-relative positioning
		tmpQuadrantTR.classList.add('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.setProperty('--pict-mde-sidebar-top', `${tmpOffsetTop}px`);
	};

	/**
	 * Reset the sidebar back to default sticky positioning (no cursor tracking).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._resetSidebarPosition = function _resetSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		tmpQuadrantTR.classList.remove('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.removeProperty('--pict-mde-sidebar-top');
	};
};

},{}],576:[function(require,module,exports){
/**
 * Pict-MDE-Formatting: Helper module for PictSectionMarkdownEditor
 *
 * Handles markdown formatting operations (bold, italic, code, heading, link)
 * applied to selections or at the cursor position in CodeMirror editors.
 */

// Markdown formatting definitions: wrapper characters for toggle-style formatting
const _FormattingMap =
{
	bold: { wrap: '**' },
	italic: { wrap: '*' },
	code: { wrap: '`' },
	heading: { prefix: '# ' },
	link: { before: '[', after: '](url)' }
};

/**
 * Attach formatting methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Apply markdown formatting to the selection (or insert formatting at cursor)
	 * in a specific segment.
	 *
	 * If text is selected, wraps it.  If no selection, inserts the formatting
	 * markers and places the cursor between them.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pFormatType - One of: 'bold', 'italic', 'code', 'heading', 'link'
	 */
	pView.applyFormatting = function applyFormatting(pSegmentIndex, pFormatType)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpFormat = _FormattingMap[pFormatType];
		if (!tmpFormat)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: unknown format type "${pFormatType}".`);
			return;
		}

		let tmpState = tmpEditor.state;
		let tmpSelection = tmpState.selection.main;
		let tmpFrom = tmpSelection.from;
		let tmpTo = tmpSelection.to;
		let tmpHasSelection = (tmpFrom !== tmpTo);
		let tmpSelectedText = tmpHasSelection ? tmpState.sliceDoc(tmpFrom, tmpTo) : '';

		let tmpChanges;
		let tmpCursorPos;

		if (tmpFormat.wrap)
		{
			// Toggle-style: wrap selection or insert empty wrapper
			let tmpWrap = tmpFormat.wrap;
			if (tmpHasSelection)
			{
				// Check if already wrapped — if so, unwrap
				let tmpBefore = tmpState.sliceDoc(Math.max(0, tmpFrom - tmpWrap.length), tmpFrom);
				let tmpAfter = tmpState.sliceDoc(tmpTo, Math.min(tmpState.doc.length, tmpTo + tmpWrap.length));

				if (tmpBefore === tmpWrap && tmpAfter === tmpWrap)
				{
					// Unwrap
					tmpChanges = [
						{ from: tmpFrom - tmpWrap.length, to: tmpFrom, insert: '' },
						{ from: tmpTo, to: tmpTo + tmpWrap.length, insert: '' }
					];
					tmpCursorPos = tmpFrom - tmpWrap.length;
					tmpEditor.dispatch(
					{
						changes: tmpChanges,
						selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
					});
					return;
				}

				// Wrap the selection
				let tmpInsert = tmpWrap + tmpSelectedText + tmpWrap;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
				});
			}
			else
			{
				// No selection: insert empty wrapper and place cursor inside
				let tmpInsert = tmpWrap + tmpWrap;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}
		else if (tmpFormat.prefix)
		{
			// Line-prefix style (headings)
			let tmpLine = tmpState.doc.lineAt(tmpFrom);
			let tmpLineText = tmpLine.text;

			// Toggle: if line already starts with the prefix, remove it; otherwise add
			if (tmpLineText.startsWith(tmpFormat.prefix))
			{
				tmpChanges = { from: tmpLine.from, to: tmpLine.from + tmpFormat.prefix.length, insert: '' };
			}
			else
			{
				tmpChanges = { from: tmpLine.from, insert: tmpFormat.prefix };
			}
			tmpEditor.dispatch({ changes: tmpChanges });
		}
		else if (tmpFormat.before && tmpFormat.after)
		{
			// Surround style (links)
			if (tmpHasSelection)
			{
				let tmpInsert = tmpFormat.before + tmpSelectedText + tmpFormat.after;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				// Place cursor on the "url" part
				tmpCursorPos = tmpFrom + tmpFormat.before.length + tmpSelectedText.length + 2;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + 3 }
				});
			}
			else
			{
				let tmpInsert = tmpFormat.before + tmpFormat.after;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpFormat.before.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}

		// Re-focus the editor after clicking a sidebar button
		tmpEditor.focus();
	};
};

},{}],577:[function(require,module,exports){
/**
 * Pict-MDE-ImageHandling: Helper module for PictSectionMarkdownEditor
 *
 * Handles image operations: file picker, file processing (hook or base64
 * fallback), markdown insertion, preview thumbnail rendering, and
 * drag-and-drop for image files onto the editor.
 */

/**
 * Attach image handling methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Open a file picker to select an image for insertion into a segment.
	 * Called by the sidebar image button onclick handler.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView.openImagePicker = function openImagePicker(pSegmentIndex)
	{
		let tmpFileInput = pView._resolveInstanceElement(`PictMDE-ImageInput-${pSegmentIndex}`);
		if (!tmpFileInput)
		{
			pView.log.warn(`PICT-MarkdownEditor openImagePicker: file input not found for segment ${pSegmentIndex}.`);
			return;
		}

		// Wire the change handler fresh each time (in case it was already used)
		tmpFileInput.onchange = () =>
		{
			if (tmpFileInput.files && tmpFileInput.files.length > 0)
			{
				pView._processImageFile(tmpFileInput.files[0], pSegmentIndex);
			}
			// Reset the input so the same file can be re-selected
			tmpFileInput.value = '';
		};

		tmpFileInput.click();
	};

	/**
	 * Is this a file the editor can put into a document -- an image or a video?
	 *
	 * One test, used by every entry point (picker, drag, paste), so a file that can be dropped can also be
	 * pasted and vice versa. Anything else is ignored: a dropped PDF is not something markdown can show.
	 *
	 * @param {File} pFile
	 * @returns {boolean}
	 */
	pView._isEmbeddableFile = function _isEmbeddableFile(pFile)
	{
		if (!pFile || !pFile.type) { return false; }
		return pFile.type.startsWith('image/') || pFile.type.startsWith('video/');
	};

	/**
	 * Process an image or video File object from any input method (picker, drag, paste).
	 *
	 * If the consumer has overridden onImageUpload and it returns true, the consumer handles the upload and
	 * calls the callback with a URL. Otherwise the file is converted to a base64 data URI inline.
	 *
	 * NOTE for consumers: onImageUpload now receives VIDEO files as well as images. It always had the File,
	 * so a consumer that cares can branch on pFile.type; the hook was not split in two because a second hook
	 * would mean video silently doing nothing until every consumer implemented it.
	 *
	 * A video is inserted as a `video` fence rather than the image form, because an uploaded file is usually
	 * addressed by a blob route with no extension -- and the renderer can only read "this is a video" off an
	 * extension. The fence says it outright.
	 *
	 * @param {File} pFile - The image or video File object
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._processImageFile = function _processImageFile(pFile, pSegmentIndex)
	{
		if (!pView._isEmbeddableFile(pFile))
		{
			pView.log.warn(`PICT-MarkdownEditor _processImageFile: not an image or video file (type: ${pFile ? pFile.type : 'null'}).`);
			return;
		}

		let tmpIsVideo = pFile.type.startsWith('video/');
		let tmpAltText = pFile.name ? pFile.name.replace(/\.[^.]+$/, '') : (tmpIsVideo ? 'video' : 'image');

		// Check if the consumer wants to handle the upload
		let tmpCallback = (pError, pURL) =>
		{
			if (pError)
			{
				pView.log.error(`PICT-MarkdownEditor image upload error: ${pError}`);
				return;
			}
			if (pURL)
			{
				if (tmpIsVideo) { pView._insertVideoMarkdown(pSegmentIndex, pURL, tmpAltText); }
				else { pView._insertImageMarkdown(pSegmentIndex, pURL, tmpAltText); }
			}
		};

		let tmpHandled = pView.onImageUpload(pFile, pSegmentIndex, tmpCallback);

		if (tmpHandled)
		{
			// Consumer is handling the upload asynchronously
			return;
		}

		// Default: convert to base64 data URI
		if (typeof (FileReader) === 'undefined')
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader not available in this environment.`);
			return;
		}

		// A video has no inline fallback worth having: a base64 data URI of a recording is megabytes of text
		// pasted into the document, which bloats every save and read of it from then on. Without a consumer
		// upload handler there is nowhere to put it, so say so rather than wedging the document.
		if (tmpIsVideo)
		{
			pView.log.warn('PICT-MarkdownEditor: a video needs an upload handler (onImageUpload) -- inlining one as a data URI would embed megabytes of base64 in the document.');
			return;
		}

		let tmpReader = new FileReader();
		tmpReader.onload = () =>
		{
			pView._insertImageMarkdown(pSegmentIndex, tmpReader.result, tmpAltText);
		};
		tmpReader.onerror = () =>
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader error.`);
		};
		tmpReader.readAsDataURL(pFile);
	};

	/**
	 * Insert a `video` fence at the cursor position in a segment editor.
	 *
	 * The fence rather than the image form: an uploaded recording is usually addressed by a blob route with
	 * no file extension, and the renderer reads "this is a video" off the extension. The fence states it.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The video URL
	 * @param {string} [pTitle] - The title line (default: 'video')
	 */
	pView._insertVideoMarkdown = function _insertVideoMarkdown(pSegmentIndex, pURL, pTitle)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertVideoMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpTitle = pTitle || 'video';
		// Sits on its own lines: a fence has to start at the beginning of a line to be a fence at all.
		let tmpInsert = '\n```video\n' + pURL + '\ntitle: ' + tmpTitle + '\n```\n';

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});
		tmpEditor.focus();
	};

	/**
	 * Insert markdown image syntax at the cursor position in a segment editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The image URL (data URI or remote URL)
	 * @param {string} [pAltText] - The alt text (default: 'image')
	 */
	pView._insertImageMarkdown = function _insertImageMarkdown(pSegmentIndex, pURL, pAltText)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertImageMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpAlt = pAltText || 'image';
		let tmpInsert = `![${tmpAlt}](${pURL})`;

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});

		tmpEditor.focus();

		// Update the image preview area for this segment
		pView._updateImagePreviews(pSegmentIndex);
	};

	/**
	 * Scan the content of a segment for markdown image references and render
	 * preview thumbnails in the preview area below the editor.
	 *
	 * Matches the pattern ![alt](url) and creates <img> elements for each.
	 * The preview area is hidden when there are no images.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateImagePreviews = function _updateImagePreviews(pSegmentIndex)
	{
		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-ImagePreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		// Match markdown image syntax: ![alt text](url)
		let tmpImageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
		let tmpMatches = [];
		let tmpMatch;
		while ((tmpMatch = tmpImageRegex.exec(tmpContent)) !== null)
		{
			tmpMatches.push(
			{
				alt: tmpMatch[1] || 'image',
				url: tmpMatch[2]
			});
		}

		if (tmpMatches.length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		// Build preview HTML
		let tmpHTML = '';
		for (let i = 0; i < tmpMatches.length; i++)
		{
			let tmpAlt = tmpMatches[i].alt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			let tmpResolvedURL = pView._resolveImageURL(tmpMatches[i].url);
			let tmpURL = tmpResolvedURL.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
			tmpHTML += `<div class="pict-mde-image-preview-item"><img src="${tmpURL}" alt="${tmpAlt}" /><span class="pict-mde-image-preview-label">${tmpAlt}</span></div>`;
		}

		tmpPreviewEl.innerHTML = tmpHTML;
		tmpPreviewEl.classList.add('pict-mde-has-images');
	};

	/**
	 * Wire drag-and-drop events for image files on a segment editor container.
	 *
	 * These events are separate from the segment-reorder drag events.
	 * File drags are distinguished from segment reorder drags by checking
	 * dataTransfer.types for 'Files' and ensuring _dragSourceIndex is -1.
	 *
	 * @param {HTMLElement} pEditorContainer - The .pict-mde-segment-editor element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireImageDragEvents = function _wireImageDragEvents(pEditorContainer, pSegmentIndex)
	{
		pEditorContainer.addEventListener('dragover', (pEvent) =>
		{
			// Only handle file drags, not segment-reorder drags
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.types || pEvent.dataTransfer.types.indexOf('Files') < 0)
			{
				return;
			}
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'copy';
			pEditorContainer.classList.add('pict-mde-image-dragover');
		});

		pEditorContainer.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if actually leaving the element
			if (!pEditorContainer.contains(pEvent.relatedTarget))
			{
				pEditorContainer.classList.remove('pict-mde-image-dragover');
			}
		});

		pEditorContainer.addEventListener('drop', (pEvent) =>
		{
			pEditorContainer.classList.remove('pict-mde-image-dragover');

			// Only handle file drops, not segment-reorder drops
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}

			let tmpFile = pEvent.dataTransfer.files[0];
			if (pView._isEmbeddableFile(tmpFile))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
			}
		});
	};
};

},{}],578:[function(require,module,exports){
/**
 * Pict-MDE-RichPreview: Helper module for PictSectionMarkdownEditor
 *
 * Handles rich content preview rendering via pict-section-content:
 * markdown-to-HTML parsing, mermaid diagram rendering, KaTeX math
 * rendering, and the full rendered-view toggle.
 */

const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;

/**
 * Attach rich preview methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Get the pict-section-content provider instance for markdown parsing.
	 * Lazily instantiated on first use.
	 *
	 * @returns {object} The PictContentProvider instance
	 */
	pView._getContentProvider = function _getContentProvider()
	{
		if (!pView._contentProvider)
		{
			pView._contentProvider = new libPictContentProvider(pView.fable, {}, 'Pict-Content-Provider-MDE');
		}
		return pView._contentProvider;
	};

	/**
	 * Render the raw markdown content of a segment into the rich preview area
	 * using pict-section-content's parseMarkdown() provider method.
	 *
	 * The rendered HTML includes syntax-highlighted code blocks, mermaid diagram
	 * placeholders, KaTeX math placeholders, headings, lists, tables, etc.
	 *
	 * After setting innerHTML, post-render hooks call mermaid.run() and
	 * katex.render() to activate diagrams and equations (if those libraries
	 * are available on window -- loaded by the consumer via CDN).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateRichPreviews = function _updateRichPreviews(pSegmentIndex)
	{
		if (!pView.options.EnableRichPreview)
		{
			return;
		}

		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-RichPreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		if (!tmpContent || tmpContent.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Use pict-section-content's provider to parse the raw markdown into HTML.
		// If a Vocabulary provider is registered on the pict instance,
		// pass its resolver so vocabulary terms auto-link in the preview.
		let tmpProvider = pView._getContentProvider();
		let tmpVocabResolver = null;
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.getResolver === 'function')
		{
			tmpVocabResolver = pView.pict.providers.Vocabulary.getResolver();
		}
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpContent, null, null, tmpVocabResolver);

		if (!tmpRenderedHTML || tmpRenderedHTML.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Wrap the rendered HTML in a pict-content container so that
		// pict-section-content's CSS classes take effect
		let tmpPreviewID = `PictMDE-RichPreviewBody-${pSegmentIndex}`;
		tmpPreviewEl.innerHTML = `<div class="pict-content" id="${tmpPreviewID}">${tmpRenderedHTML}</div>`;
		tmpPreviewEl.classList.add('pict-mde-has-rich-preview');

		// Wire vocabulary popover hover handlers if the provider is available
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.wirePopovers === 'function')
		{
			pView.pict.providers.Vocabulary.wirePopovers('#' + tmpPreviewID);
		}

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpPreviewEl.querySelectorAll('img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation counter for stale-render protection (mermaid is async)
		let tmpGeneration = (pView._richPreviewGenerations[pSegmentIndex] || 0) + 1;
		pView._richPreviewGenerations[pSegmentIndex] = tmpGeneration;

		// Post-render: call mermaid.run() for mermaid diagram elements
		pView._postRenderMermaid(tmpPreviewID, pSegmentIndex, tmpGeneration);

		// Post-render: call katex.render() for KaTeX math elements
		pView._postRenderKaTeX(tmpPreviewID);
	};

	/**
	 * Lazily bind the shared Theme-Diagram-Adapter for mermaid.  The
	 * adapter handles mermaid.initialize() against the active pict
	 * theme, subscribes to onApply, and re-renders existing diagrams
	 * when the theme/mode changes.  Idempotent.
	 *
	 * Falls back to a direct-require path when no theme provider is
	 * installed — the static base theme still picks up any CSS
	 * variables on :root.
	 */
	pView._ensureMermaidAdapter = function _ensureMermaidAdapter()
	{
		if (pView._mermaidAdapter) { return pView._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				pView._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				pView._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid theme adapter init failed: ${pError.message || pError}`);
			pView._mermaidAdapter = null;
		}
		return pView._mermaidAdapter;
	};

	/**
	 * Post-render hook: render Mermaid diagrams in the preview container.
	 * Uses the same approach as pict-section-content's renderMermaidDiagrams().
	 *
	 * @param {string} pContainerID - The container element ID
	 * @param {number} pSegmentIndex - The segment index (for stale-render protection)
	 * @param {number} pGeneration - The generation counter value
	 */
	pView._postRenderMermaid = function _postRenderMermaid(pContainerID, pSegmentIndex, pGeneration)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainer = pView._resolveInstanceElement(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		let tmpMermaidElements = tmpContainer.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the shared Theme-Diagram-Adapter so mermaid
		// follows the active palette and re-renders when the theme/mode
		// changes (manual toggle or OS-driven via prefers-color-scheme).
		pView._ensureMermaidAdapter();

		// Cache each diagram's source on the element. mermaid.run()
		// replaces textContent with the rendered SVG; the cache lets
		// the adapter's refresh re-run without re-parsing markdown.
		let tmpProviderForStash = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		try
		{
			let tmpPromise = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpPromise && typeof tmpPromise.catch === 'function')
			{
				tmpPromise.catch((pError) =>
				{
					// Check stale-render: rendered view uses _renderedViewGeneration,
					// per-segment previews use _richPreviewGenerations
					let tmpCurrentGen = (pSegmentIndex === -1)
						? pView._renderedViewGeneration
						: pView._richPreviewGenerations[pSegmentIndex];
					if (tmpCurrentGen !== pGeneration)
					{
						return; // stale render -- a newer update has replaced us
					}
					pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
				});
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
		}
	};

	/**
	 * Post-render hook: render KaTeX inline and display math in the preview container.
	 * Uses the same approach as pict-section-content's renderKaTeXEquations().
	 *
	 * @param {string} pContainerID - The container element ID
	 */
	pView._postRenderKaTeX = function _postRenderKaTeX(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainer = pView._resolveInstanceElement(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		// Render inline math: <span class="pict-content-katex-inline">
		let tmpInlineElements = tmpContainer.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX inline error: ${pError.message || pError}`);
			}
		}

		// Render display math: <div class="pict-content-katex-display">
		let tmpDisplayElements = tmpContainer.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX display error: ${pError.message || pError}`);
			}
		}
	};

	/**
	 * Simple HTML escape for error messages in the rich preview.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string}
	 */
	pView._escapeHTMLForPreview = function _escapeHTMLForPreview(pText)
	{
		return pText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	};

	// -- Rendered View (full document preview) --

	/**
	 * Toggle between the editing view (CodeMirror segments) and a fully rendered
	 * view of the combined markdown output using pict-section-content.
	 *
	 * @param {boolean} [pRendered] - If provided, set to this value; otherwise toggle
	 */
	pView.toggleRenderedView = function toggleRenderedView(pRendered)
	{
		if (typeof (pRendered) === 'boolean')
		{
			pView._renderedViewActive = pRendered;
		}
		else
		{
			pView._renderedViewActive = !pView._renderedViewActive;
		}

		if (pView._renderedViewActive)
		{
			pView._renderRenderedView();
		}
		else
		{
			pView._restoreEditingView();
		}
	};

	/**
	 * Switch to the rendered view: marshal all editors, combine all segment
	 * content, render to HTML via pict-section-content, and replace the
	 * container contents with the rendered output.
	 */
	pView._renderRenderedView = function _renderRenderedView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		// Marshal current editor content back to data before switching
		pView._marshalAllEditorsToData();

		// Combine all segments into a single markdown document
		let tmpSegments = pView._getSegmentsFromData();
		let tmpCombinedContent = '';
		if (tmpSegments && tmpSegments.length > 0)
		{
			let tmpParts = [];
			for (let i = 0; i < tmpSegments.length; i++)
			{
				tmpParts.push(tmpSegments[i].Content || '');
			}
			tmpCombinedContent = tmpParts.join('\n\n');
		}

		// Destroy existing CodeMirror editors
		for (let tmpIdx in pView._segmentEditors)
		{
			if (pView._segmentEditors[tmpIdx])
			{
				pView._segmentEditors[tmpIdx].destroy();
			}
		}
		pView._segmentEditors = {};

		// Render the combined markdown via pict-section-content
		let tmpProvider = pView._getContentProvider();
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpCombinedContent);

		// Build the rendered view container
		let tmpRenderedViewID = 'PictMDE-RenderedView';
		tmpContainer.innerHTML = `<div class="pict-mde-rendered-view" id="${tmpRenderedViewID}"><div class="pict-content">${tmpRenderedHTML || ''}</div></div>`;
		tmpContainer.classList.add('pict-mde-rendered-mode');

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpContainer.querySelectorAll('.pict-mde-rendered-view img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation for stale-render protection
		pView._renderedViewGeneration++;
		let tmpGeneration = pView._renderedViewGeneration;

		// Post-render hooks for mermaid diagrams and KaTeX equations
		let tmpContentContainer = tmpContainer.querySelector(`#${tmpRenderedViewID} .pict-content`);
		if (tmpContentContainer)
		{
			let tmpContentID = 'PictMDE-RenderedViewContent';
			tmpContentContainer.id = tmpContentID;

			pView._postRenderMermaid(tmpContentID, -1, tmpGeneration);
			pView._postRenderKaTeX(tmpContentID);
		}
	};

	/**
	 * Switch back from rendered view to the editing view: rebuild the
	 * full editor UI from the data.
	 */
	pView._restoreEditingView = function _restoreEditingView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		tmpContainer.classList.remove('pict-mde-rendered-mode');
		pView._buildEditorUI();
	};
};

},{"pict-provider-theme/source/Theme-Diagram-Adapter.js":477,"pict-section-content":486}],579:[function(require,module,exports){
module.exports = (
{
	"DefaultRenderable": "MarkdownEditor-Wrap",
	"DefaultDestinationAddress": "#MarkdownEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "MarkdownEditor-Container",
			"Template": /*html*/`<div class="pict-mde" id="PictMDE-Container"></div>`
		},
		{
			"Hash": "MarkdownEditor-Segment",
			"Template": /*html*/`<div class="pict-mde-segment" id="PictMDE-Segment-{~D:Record.SegmentIndex~}" data-segment-index="{~D:Record.SegmentIndex~}">
	<div class="pict-mde-left-controls">
		<div class="pict-mde-quadrant-tl"></div>
		<div class="pict-mde-quadrant-bl"></div>
	</div>
	<div class="pict-mde-drag-handle" draggable="true" title="Drag to reorder"></div>
	<div class="pict-mde-segment-body">
		<div class="pict-mde-tab-bar" id="PictMDE-TabBar-{~D:Record.SegmentIndex~}">
			<button type="button" class="pict-mde-tab pict-mde-tab-active" data-tab="editor" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'editor')">Edit</button>
			<button type="button" class="pict-mde-tab" data-tab="preview" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'preview')">Preview</button>
		</div>
		<div class="pict-mde-segment-editor" id="PictMDE-SegmentEditor-{~D:Record.SegmentIndex~}"></div>
		<div class="pict-mde-preview-pane" id="PictMDE-PreviewPane-{~D:Record.SegmentIndex~}">
			<div class="pict-mde-image-preview" id="PictMDE-ImagePreview-{~D:Record.SegmentIndex~}"></div>
			<div class="pict-mde-rich-preview" id="PictMDE-RichPreview-{~D:Record.SegmentIndex~}"></div>
		</div>
	</div>
	<div class="pict-mde-sidebar" id="PictMDE-Sidebar-{~D:Record.SegmentIndex~}">
		<div class="pict-mde-quadrant-tr"></div>
		<div class="pict-mde-quadrant-br"></div>
		<input type="file" accept="image/*" class="pict-mde-image-input" id="PictMDE-ImageInput-{~D:Record.SegmentIndex~}" style="display:none" />
	</div>
</div>`
		},
		{
			"Hash": "MarkdownEditor-AddSegment",
			"Template": /*html*/`<div class="pict-mde-add-segment">
	<button type="button" class="pict-mde-btn-add" onclick="{~D:Record.ViewIdentifier~}.addSegment()">+ Add Segment</button>
</div>`
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "MarkdownEditor-Wrap",
			"TemplateHash": "MarkdownEditor-Container",
			"DestinationAddress": "#MarkdownEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#MarkdownEditor-Container-Div",

	// Address in AppData to read/write the segments array
	// The data at this address should be an array of objects, each with a "Content" property
	// e.g. AppData.Document.Segments = [ { Content: "# Hello" }, { Content: "Some text" } ]
	"ContentDataAddress": false,

	// Whether the editor should be read-only
	"ReadOnly": false,

	// Whether to show rich content previews (rendered markdown with syntax-highlighted
	// code, mermaid diagrams, KaTeX equations, tables, etc. via pict-section-content).
	// Requires the consumer to load the mermaid and/or katex libraries via CDN
	// for diagram/equation rendering; code highlighting works without CDN scripts.
	"EnableRichPreview": true,

	// Default preview layout mode: "off", "bottom", "side", "tabbed"
	//   off       — no preview (default)
	//   bottom    — preview below the editor
	//   side      — editor and preview side-by-side
	//   tabbed    — per-segment tabs switching between editor and preview
	"DefaultPreviewMode": "off",

	// Base URL prepended to relative image URLs in image and rich previews.
	// Set this to the directory-level path (e.g. "/content/") so that images
	// referenced by filename in the markdown resolve correctly.
	// Absolute URLs (starting with /, http://, https://, data:) are left as-is.
	"ImageBaseURL": "",

	// ---- Quadrant button definitions ----
	// Each quadrant is an array of button objects:
	//   HTML   — innerHTML for the button
	//   Action — method name, optionally "method:arg" (receives segment index as first param)
	//   Class  — additional CSS class(es) appended to the base class
	//   Title  — tooltip text
	//
	// Consumers can override any quadrant to add, remove, or reorder buttons.
	// Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	// Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.

	// Quadrant button HTML is parsed through Pict's template engine before
	// being assigned as innerHTML, so `{~I:Name~}` template tags resolve
	// to themable SVG icons from pict.providers.Icon.  Typographic
	// formatting buttons (Bold / Italic / Inline-code / Heading / Link)
	// stay as stylized letters — that's the markdown-editor convention.
	"ButtonsTL":
	[
		{ "HTML": "{~I:Close~}",    "Action": "removeSegment",    "Class": "pict-mde-btn-remove",    "Title": "Remove Segment" }
	],

	"ButtonsBL":
	[
		{ "HTML": "{~I:ArrowUp~}",   "Action": "moveSegmentUp",     "Class": "pict-mde-btn-move",     "Title": "Move Up" },
		{ "HTML": "{~I:ArrowDown~}", "Action": "moveSegmentDown",   "Class": "pict-mde-btn-move",     "Title": "Move Down" },
		{ "HTML": "{~I:Settings~}",  "Action": "toggleControls",    "Class": "pict-mde-btn-linenums", "Title": "Toggle Controls" },
		{ "HTML": "{~I:Eye~}",       "Action": "cyclePreviewMode",  "Class": "pict-mde-btn-preview",  "Title": "Cycle Preview Mode" }
	],

	"ButtonsTR":
	[
		{ "HTML": "<b>B</b>",            "Action": "applyFormatting:bold",     "Class": "", "Title": "Bold (Ctrl+B)" },
		{ "HTML": "<i>I</i>",            "Action": "applyFormatting:italic",   "Class": "", "Title": "Italic (Ctrl+I)" },
		{ "HTML": "<code>&lt;&gt;</code>","Action": "applyFormatting:code",    "Class": "", "Title": "Inline Code (Ctrl+E)" },
		{ "HTML": "#",                   "Action": "applyFormatting:heading",  "Class": "", "Title": "Heading" },
		{ "HTML": "[&thinsp;]",          "Action": "applyFormatting:link",     "Class": "", "Title": "Link" },
		{ "HTML": "{~I:Image~}",         "Action": "openImagePicker",          "Class": "pict-mde-sidebar-btn-image", "Title": "Insert Image" }
	],

	"ButtonsBR":
	[
	],

	// CSS for the markdown editor
	"CSS": /*css*/`
/* ---- Container ---- */
.pict-mde
{
	font-family: var(--theme-typography-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif);
	font-size: 14px;
}

/* ---- Segment row: left-controls | drag-handle | editor body | sidebar ---- */
.pict-mde-segment
{
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	margin-bottom: 6px;
	min-height: 48px;
	transition: background-color 0.15s ease;
}

/* ---- Left controls column ---- */
.pict-mde-left-controls
{
	flex: 0 0 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 2px 0;
}

/* ---- Left-side quadrants ---- */
.pict-mde-quadrant-tl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	position: sticky;
	top: 2px;
	z-index: 2;
}
.pict-mde-quadrant-bl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	position: sticky;
	bottom: 2px;
	z-index: 2;
}

/* ---- Left-side buttons (shared base) ---- */
.pict-mde-left-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	color: var(--theme-color-text-muted, #888);
	line-height: 1;
	font-family: inherit;
	opacity: 0;
	transition: opacity 0.15s ease;
}
.pict-mde-segment:hover .pict-mde-left-btn,
.pict-mde-segment.pict-mde-active .pict-mde-left-btn
{
	opacity: 1;
}
.pict-mde-left-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-btn-remove:hover
{
	color: var(--theme-color-status-error, #CC3333);
}
.pict-mde-btn-linenums
{
	font-size: 11px;
	font-weight: 600;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}
/* Highlight when controls are active */
.pict-mde.pict-mde-controls-on .pict-mde-btn-linenums
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-btn-preview
{
	font-size: 11px;
}
/* Preview button: highlight when any preview mode is active */
.pict-mde.pict-mde-preview-bottom .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-side .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-tabbed .pict-mde-btn-preview
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
/* Dim preview button when mode is off */
.pict-mde.pict-mde-preview-off .pict-mde-btn-preview
{
	color: var(--theme-color-border-default, #CCC);
}

/* ---- Drag handle (simple grey bar) ---- */
.pict-mde-drag-handle
{
	flex: 0 0 8px;
	cursor: grab;
	background: var(--theme-color-background-tertiary, #EDEDED);
	transition: background-color 0.15s ease;
	user-select: none;
}
.pict-mde-drag-handle:active
{
	cursor: grabbing;
}
.pict-mde-drag-handle:hover
{
	background: var(--theme-color-border-default, #C8C8C8);
}

/* ---- Editor body (middle column) ---- */
.pict-mde-segment-body
{
	flex: 1 1 0%;
	min-width: 0;
	overflow: hidden;
	background: var(--theme-color-background-panel, #FFFFFF);
	transition: background-color 0.15s ease;
}
.pict-mde-segment-editor
{
	min-height: 48px;
}

/* ---- Image preview area below the editor ---- */
.pict-mde-image-preview
{
	display: none;
}
.pict-mde-image-preview.pict-mde-has-images
{
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 12px;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
}
.pict-mde-image-preview img
{
	max-width: 200px;
	max-height: 150px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	object-fit: contain;
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-image-preview-item
{
	position: relative;
	display: inline-block;
}
.pict-mde-image-preview-label
{
	display: block;
	font-size: 10px;
	color: var(--theme-color-text-muted, #999);
	margin-top: 2px;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ---- Rich content preview area (rendered via pict-section-content) ---- */
.pict-mde-rich-preview
{
	display: none;
}
.pict-mde-rich-preview.pict-mde-has-rich-preview
{
	display: block;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-panel, #FCFCFC);
	overflow: hidden;
}
/* Constrain images in the rich preview even if pict-section-content CSS loads late */
.pict-mde-rich-preview img
{
	max-width: 100%;
	height: auto;
}
/* ---- Preview layout modes ---- */

/* Tab bar: hidden by default, shown only in tabbed mode */
.pict-mde-tab-bar
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-tab-bar
{
	display: flex;
	gap: 0;
	border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-tab
{
	padding: 4px 12px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #888);
	border-bottom: 2px solid transparent;
	font-family: inherit;
}
.pict-mde-tab:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-tab.pict-mde-tab-active
{
	color: var(--theme-color-brand-primary, #4A90D9);
	border-bottom-color: var(--theme-color-brand-primary, #4A90D9);
}

/* Off mode: hide all preview panes and tab bars */
.pict-mde.pict-mde-preview-off .pict-mde-preview-pane
{
	display: none;
}
.pict-mde.pict-mde-preview-off .pict-mde-tab-bar
{
	display: none;
}
/* Legacy class alias for backward compatibility */
.pict-mde.pict-mde-previews-hidden .pict-mde-preview-pane
{
	display: none;
}

/* Bottom mode: vertical stacking (default flex-column behavior) */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}

/* Side-by-side mode: editor and preview side by side */
.pict-mde.pict-mde-preview-side .pict-mde-segment-body
{
	display: flex;
	flex-direction: row;
}
.pict-mde.pict-mde-preview-side .pict-mde-segment-editor
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: hidden;
}
.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: auto;
	border-left: 1px solid var(--theme-color-border-light, #EDEDED);
}
/* Side-by-side: remove top borders since preview is beside, not below */
.pict-mde.pict-mde-preview-side .pict-mde-rich-preview.pict-mde-has-rich-preview
{
	border-top: none;
}
.pict-mde.pict-mde-preview-side .pict-mde-image-preview.pict-mde-has-images
{
	border-top: none;
}

/* Tabbed mode: default hides preview, shows editor */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-preview-pane
{
	display: none;
}
/* Tabbed mode: when showing preview, hide editor and show preview */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-segment-editor
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-preview-pane
{
	display: block;
}

/* Per-segment preview hide: only applies in bottom and side modes */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane,
.pict-mde.pict-mde-preview-side .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane
{
	display: none;
}
/* Constrain the pict-content inside the preview to fit the segment */
.pict-mde-rich-preview .pict-content
{
	padding: 12px;
	max-width: none;
	margin: 0;
	font-size: 13px;
}
/* Reduce heading sizes in the preview to be proportional */
.pict-mde-rich-preview .pict-content h1
{
	font-size: 1.4em;
	margin-top: 0;
}
.pict-mde-rich-preview .pict-content h2
{
	font-size: 1.2em;
	margin-top: 0.75em;
}
.pict-mde-rich-preview .pict-content h3
{
	font-size: 1.1em;
	margin-top: 0.6em;
}

/* ---- Rendered view (full document preview mode) ---- */
.pict-mde-rendered-view
{
	padding: 16px 20px;
	background: var(--theme-color-background-panel, #FFFFFF);
	min-height: 120px;
}
.pict-mde-rendered-view .pict-content
{
	max-width: none;
	margin: 0;
}
/* Hide the add-segment button in rendered mode */
.pict-mde.pict-mde-rendered-mode .pict-mde-add-segment
{
	display: none;
}

/* Focused / active editor gets subtle warm background */
.pict-mde-segment.pict-mde-active .pict-mde-segment-body
{
	background: var(--theme-color-background-secondary, #FAFAF5);
}
.pict-mde-segment.pict-mde-active .pict-mde-drag-handle
{
	background: var(--theme-color-border-strong, #9CB4C8);
}

/* ---- Right sidebar column ---- */
.pict-mde-sidebar
{
	flex: 0 0 30px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
}

/* ---- Right-side quadrants ---- */
.pict-mde-quadrant-tr
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease, top 0.1s ease;
	position: sticky;
	top: 0;
}
.pict-mde-quadrant-br
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease;
	position: sticky;
	bottom: 0;
}

/* Active segment always shows its right-side quadrants */
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 1;
}
/* When no segment is active, hovering shows both left + right controls */
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 1;
}

/* ---- Controls-hidden mode: right quadrants show faintly on hover ---- */
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-br
{
	opacity: 0;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 0.3;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 0.3;
}

/* When JS sets a cursor-relative offset, switch TR from sticky to absolute positioning */
.pict-mde-quadrant-tr.pict-mde-sidebar-at-cursor
{
	position: absolute;
	top: var(--pict-mde-sidebar-top, 0px);
}

/* ---- Right-side buttons (shared base) ---- */
.pict-mde-sidebar-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 22px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	border-radius: 3px;
	color: var(--theme-color-text-secondary, #666);
	line-height: 1;
	font-family: inherit;
}
.pict-mde-sidebar-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-sidebar-btn b
{
	font-size: 13px;
	font-weight: 700;
}
.pict-mde-sidebar-btn i
{
	font-size: 13px;
	font-style: italic;
}
.pict-mde-sidebar-btn code
{
	font-size: 10px;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}

/* ---- Add segment button ---- */
.pict-mde-add-segment
{
	margin-top: 6px;
	padding-left: 30px;
}
.pict-mde-btn-add
{
	display: block;
	width: 100%;
	padding: 7px;
	border: 2px dashed var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	background: transparent;
	color: var(--theme-color-text-muted, #999);
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
}
.pict-mde-btn-add:hover
{
	border-color: var(--theme-color-brand-primary, #4A90D9);
	color: var(--theme-color-brand-primary, #4A90D9);
	background: rgba(74, 144, 217, 0.04);
}

/* ---- Image drag-over indicator ---- */
.pict-mde-segment-editor.pict-mde-image-dragover
{
	outline: 2px dashed var(--theme-color-brand-primary, #4A90D9);
	outline-offset: -2px;
}

/* ---- Drag-in-progress: prevent CodeMirror from intercepting drop events ---- */
.pict-mde.pict-mde-dragging .pict-mde-segment-editor
{
	pointer-events: none;
}

/* ---- Drop target indicators for drag reorder ---- */
.pict-mde-segment.pict-mde-drag-over-top
{
	box-shadow: 0 -2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-segment.pict-mde-drag-over-bottom
{
	box-shadow: 0 2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}

/* ---- CodeMirror overrides inside segments ---- */
.pict-mde-segment-editor .cm-editor
{
	border: none;
}
.pict-mde-segment-editor .cm-editor .cm-scroller
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.6;
}
.pict-mde-segment-editor .cm-editor.cm-focused
{
	outline: none;
}
.pict-mde-segment-editor .cm-editor .cm-content
{
	padding: 8px 12px;
	min-height: 36px;
}
.pict-mde-segment-editor .cm-editor .cm-gutters
{
	background: var(--theme-color-background-secondary, #F8F8F8);
	border-right: 1px solid var(--theme-color-border-light, #E8E8E8);
	color: var(--theme-color-text-muted, #BBB);
}

/* ---- Collapsed data URI widget ---- */
.pict-mde-data-uri-collapsed
{
	display: inline;
	background: var(--theme-color-background-tertiary, #F0F0F0);
	color: var(--theme-color-text-muted, #888);
	font-size: 11px;
	padding: 1px 4px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
	cursor: default;
	white-space: nowrap;
}

/* ---- Line number / controls toggle: gutters hidden by default ---- */
.pict-mde .cm-editor .cm-gutters
{
	display: none;
}
.pict-mde.pict-mde-controls-on .cm-editor .cm-gutters
{
	display: flex;
}

/* ============================================
   RESPONSIVE: Tablet / Phone (max-width: 768px)
   ============================================ */
@media (max-width: 768px)
{
	/* Prevent any horizontal overflow in the editor */
	.pict-mde
	{
		overflow-x: hidden;
		max-width: 100%;
	}

	/* Reduce the left controls column width */
	.pict-mde-left-controls
	{
		flex: 0 0 16px;
	}
	.pict-mde-left-btn
	{
		width: 16px;
		height: 18px;
		font-size: 10px;
	}

	/* Make left-side buttons always visible on touch (no hover) */
	.pict-mde-left-btn
	{
		opacity: 0.6;
	}

	/* Narrow the drag handle */
	.pict-mde-drag-handle
	{
		flex: 0 0 5px;
	}

	/* Shrink the right sidebar column */
	.pict-mde-sidebar
	{
		flex: 0 0 24px;
	}
	.pict-mde-sidebar-btn
	{
		width: 20px;
		height: 20px;
		font-size: 11px;
	}

	/* Make right sidebar buttons always visible (touch devices) */
	.pict-mde-quadrant-tr,
	.pict-mde-quadrant-br
	{
		opacity: 0.7;
	}
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
	{
		opacity: 1;
	}

	/* Reduce CodeMirror content padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 6px 6px;
	}

	/* Reduce font size slightly for more content on screen */
	.pict-mde-segment-editor .cm-editor .cm-scroller
	{
		font-size: 13px;
	}

	/* Add segment button: reduce left margin */
	.pict-mde-add-segment
	{
		padding-left: 21px;
	}

	/* Side-by-side: fall back to vertical stacking on narrow screens */
	.pict-mde.pict-mde-preview-side .pict-mde-segment-body
	{
		flex-direction: column;
	}
	.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
	{
		border-left: none;
		border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	}

	/* Tab bar: smaller on tablet */
	.pict-mde-tab
	{
		padding: 3px 8px;
		font-size: 11px;
	}

	/* Rich preview: less padding */
	.pict-mde-rich-preview .pict-content
	{
		padding: 8px;
		font-size: 12px;
	}

	/* Image previews: smaller max dimensions */
	.pict-mde-image-preview img
	{
		max-width: 120px;
		max-height: 100px;
	}

	/* Rendered view: less padding */
	.pict-mde-rendered-view
	{
		padding: 10px 8px;
	}
}

/* ============================================
   RESPONSIVE: Small phone (max-width: 480px)
   ============================================ */
@media (max-width: 480px)
{
	/* Wrap segment so left controls flow to the top as a horizontal bar */
	.pict-mde-segment
	{
		flex-wrap: wrap;
	}

	/* Left controls become a horizontal toolbar at the top of the segment */
	.pict-mde-left-controls
	{
		flex: 0 0 100%;
		flex-direction: row;
		justify-content: flex-start;
		gap: 2px;
		padding: 3px 4px;
		order: -1;
		background: var(--theme-color-background-secondary, #F5F5F5);
		border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	}
	.pict-mde-left-btn
	{
		width: 24px;
		height: 24px;
		font-size: 12px;
		opacity: 0.7;
	}

	/* Left quadrants flow horizontally */
	.pict-mde-quadrant-tl,
	.pict-mde-quadrant-bl
	{
		flex-direction: row;
		gap: 2px;
		position: static;
	}

	/* Segment body: explicit basis so it fills the wrapped row */
	.pict-mde-segment-body
	{
		flex: 1 1 calc(100% - 20px);
	}

	/* Hide drag handle on very small screens */
	.pict-mde-drag-handle
	{
		display: none;
	}

	/* Right sidebar: further shrink */
	.pict-mde-sidebar
	{
		flex: 0 0 20px;
	}
	.pict-mde-sidebar-btn
	{
		width: 18px;
		height: 18px;
		font-size: 10px;
	}

	/* Add segment: no left offset since controls are at top */
	.pict-mde-add-segment
	{
		padding-left: 0;
	}

	/* Even tighter CodeMirror padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 4px 4px;
	}
}
`
});

},{}],580:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libPictSectionContent = require('pict-section-content');
const _DefaultConfiguration = require('./Pict-Section-MarkdownEditor-DefaultConfiguration.js');

// Helper modules
const libFormatting = require('./Pict-MDE-Formatting.js');
const libImageHandling = require('./Pict-MDE-ImageHandling.js');
const libDragAndReorder = require('./Pict-MDE-DragAndReorder.js');
const libRichPreview = require('./Pict-MDE-RichPreview.js');
const libCodeMirror = require('./Pict-MDE-CodeMirror.js');

class PictSectionMarkdownEditor extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// CodeMirror prototype references (injected by consumer or found on window)
		this._codeMirrorModules = null;

		// Map of segment index to CodeMirror EditorView instance
		this._segmentEditors = {};

		// Internal segment counter (monotonically increasing for unique IDs)
		this._segmentCounter = 0;

		// The view identifier used for onclick handlers in templates
		this._viewCallIdentifier = false;

		// Currently active (focused) segment index, or -1
		this._activeSegmentIndex = -1;

		// Drag state for reorder
		this._dragSourceIndex = -1;

		// Whether controls (line numbers + right sidebar) are currently visible
		this._controlsVisible = true;

		// Current preview layout mode: "off", "bottom", "side", "tabbed"
		this._previewMode = this.options.DefaultPreviewMode || 'off';

		// Last non-off preview layout, for togglePreview() backward compatibility
		this._lastPreviewLayout = 'bottom';

		// Per-segment tab state in tabbed mode (keyed by logical index; "editor" or "preview")
		this._segmentTabStates = {};

		// Set of logical segment indices where preview has been individually hidden
		this._hiddenPreviewSegments = {};

		// Debounce timers for image preview updates (keyed by segment index)
		this._imagePreviewTimers = {};

		// Debounce timers for rich content preview updates (keyed by segment index)
		this._richPreviewTimers = {};

		// Generation counters for mermaid async rendering (keyed by segment index)
		this._richPreviewGenerations = {};

		// Content provider for markdown-to-HTML rendering in rich previews
		// (pict-section-content provides parseMarkdown, code highlighting, etc.)
		this._contentProvider = null;

		// Whether the rendered (read-mode) view is currently active
		this._renderedViewActive = false;

		// Generation counter for rendered view mermaid async rendering
		this._renderedViewGeneration = 0;

		// Attach helper modules
		libFormatting.attach(this);
		libImageHandling.attach(this);
		libDragAndReorder.attach(this);
		libRichPreview.attach(this);
		libCodeMirror.attach(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElement = false;

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeMirror modules.  The consumer must pass an object with:
	 *   - EditorView: the EditorView class
	 *   - EditorState: the EditorState class
	 *   - extensions: an array of extensions to use (e.g. basicSetup, markdown(), etc.)
	 *
	 * If not called explicitly, the view will attempt to find them on window.CodeMirrorModules.
	 *
	 * @param {object} [pCodeMirrorModules] - The CodeMirror modules object
	 * @returns {boolean|void}
	 */
	connectCodeMirrorModules(pCodeMirrorModules)
	{
		if (pCodeMirrorModules && typeof (pCodeMirrorModules) === 'object')
		{
			if (typeof (pCodeMirrorModules.EditorView) === 'function' && typeof (pCodeMirrorModules.EditorState) === 'function')
			{
				this._codeMirrorModules = pCodeMirrorModules;
				return;
			}
		}

		// Try to find CodeMirror modules in global scope
		if (typeof (window) !== 'undefined')
		{
			if (window.CodeMirrorModules && typeof (window.CodeMirrorModules.EditorView) === 'function')
			{
				this.log.trace(`PICT-MarkdownEditor Found CodeMirror modules on window.CodeMirrorModules.`);
				this._codeMirrorModules = window.CodeMirrorModules;
				return;
			}
		}

		this.log.error(`PICT-MarkdownEditor No CodeMirror modules found. Provide them via connectCodeMirrorModules() or set window.CodeMirrorModules.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		else
		{
			// A re-render means the host re-created our destination element (an
			// editor shown/hidden, or remounted into a fresh container). The
			// targetElement cached on the first render is now detached, so a
			// rebuild would write segments into an orphaned node. Re-resolve the
			// live target and rebuild into it from the current segment data.
			this._remountEditorUI();
		}

		// Inject CSS from all registered views (after onAfterInitialRender so
		// that pict-section-content's CSS is registered before injection)
		this.pict.CSSMap.injectCSS();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Re-resolve the target element from TargetElementAddress and rebuild the
	 * editor UI into it. Called on re-render so the editor survives the host
	 * replacing its destination element (which would otherwise leave
	 * this.targetElement pointing at a detached node and the live container empty).
	 */
	_remountEditorUI()
	{
		if (!this._codeMirrorModules)
		{
			return;
		}

		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			return;
		}

		this.targetElement = tmpTargetElementSet[0];
		this._buildEditorUI();
	}

	onAfterInitialRender()
	{
		// Resolve CodeMirror modules if not already set
		if (!this._codeMirrorModules)
		{
			this.connectCodeMirrorModules();
		}

		if (!this._codeMirrorModules)
		{
			this.log.error(`PICT-MarkdownEditor Cannot initialize; no CodeMirror modules available.`);
			return false;
		}

		// Register pict-section-content's CSS for rich preview rendering.
		// This ensures the rendered markdown (headings, code blocks, tables, etc.)
		// is styled correctly inside the preview area.
		if (this.options.EnableRichPreview)
		{
			let tmpContentViewConfig = libPictSectionContent.default_configuration;
			if (tmpContentViewConfig && tmpContentViewConfig.CSS)
			{
				this.pict.CSSMap.addCSS('Pict-Content-View', tmpContentViewConfig.CSS);
			}
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-MarkdownEditor Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Determine the view call identifier for onclick handlers
		this._viewCallIdentifier = this._resolveViewCallIdentifier();

		// Build the editor UI
		this._buildEditorUI();
	}

	/**
	 * Resolve how the view can be referenced from global onclick handlers.
	 * Returns a string like "_Pict.views['MyViewHash']" — bracket syntax
	 * is required so view hashes containing hyphens (e.g.
	 * "ContentEditor-MarkdownEditor") parse correctly. Dot access
	 * (`_Pict.views.X-Y`) is read as subtraction by the JS parser and
	 * the onclick silently no-ops.
	 *
	 * @returns {string}
	 */
	_resolveViewCallIdentifier()
	{
		let tmpViews = this.pict.views;
		for (let tmpViewHash in tmpViews)
		{
			if (tmpViews[tmpViewHash] === this)
			{
				return `_Pict.views['${tmpViewHash}']`;
			}
		}
		return `_Pict.servicesMap.PictView['${this.Hash}']`;
	}

	/**
	 * Get the .pict-mde container element.  Always does a fresh DOM lookup
	 * because pict's async render pipeline can replace the element between calls.
	 *
	 * @returns {HTMLElement|null}
	 */
	_getContainerElement()
	{
		if (this.targetElement)
		{
			let tmpContainer = this.targetElement.querySelector('.pict-mde');
			if (tmpContainer)
			{
				return tmpContainer;
			}
		}
		return this.targetElement || null;
	}

	/**
	 * Resolve one of THIS editor instance's elements by its raw PictMDE id, scoped to this
	 * instance's container.
	 *
	 * The segment/preview/editor elements all carry fixed ids (PictMDE-Segment-0, ...). Several
	 * markdown editors can share one page -- the Drafting Kit loops editor mounts three at once, one
	 * per loop -- and they all emit that same id space, so a document-wide getElementById would
	 * resolve the FIRST instance's element and the editors would bleed into each other. Scoping every
	 * lookup to the instance's own .pict-mde container keeps the instances independent without
	 * needing to make the ids globally unique.
	 *
	 * Falls back to a document-wide lookup only when no container is resolved yet (e.g. pre-mount),
	 * which preserves the original single-instance behavior for the entity-form and Docs Lake editors.
	 *
	 * @param {string} pElementID - the element id, e.g. `PictMDE-Segment-3`
	 * @returns {HTMLElement|null}
	 */
	_resolveInstanceElement(pElementID)
	{
		let tmpContainer = this._getContainerElement();
		if (tmpContainer && typeof tmpContainer.querySelector === 'function')
		{
			return tmpContainer.querySelector('#' + pElementID);
		}
		return document.getElementById(pElementID);
	}

	/**
	 * Resolve a URL relative to the configured ImageBaseURL.
	 *
	 * Absolute URLs (starting with /, http://, https://, data:) are returned
	 * unchanged.  Relative URLs are prepended with this.options.ImageBaseURL.
	 *
	 * @param {string} pURL - The URL to resolve
	 * @returns {string} The resolved URL
	 */
	_resolveImageURL(pURL)
	{
		if (!pURL || !this.options.ImageBaseURL)
		{
			return pURL;
		}

		// Leave absolute URLs alone
		if (pURL.startsWith('/') || pURL.startsWith('http://') || pURL.startsWith('https://') || pURL.startsWith('data:'))
		{
			return pURL;
		}

		let tmpBase = this.options.ImageBaseURL;
		// Ensure base ends with /
		if (tmpBase && !tmpBase.endsWith('/'))
		{
			tmpBase += '/';
		}

		return tmpBase + pURL;
	}

	/**
	 * Build the full editor UI: render existing segments from data and the add-segment button.
	 */
	_buildEditorUI()
	{
		let tmpContainer = this._getContainerElement();

		// Ensure the container has the pict-mde class (the template's wrapper
		// may have been replaced by pict's async render pipeline)
		if (tmpContainer && !tmpContainer.classList.contains('pict-mde'))
		{
			tmpContainer.classList.add('pict-mde');
		}

		// Destroy existing editors before clearing
		for (let tmpIdx in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIdx])
			{
				this._segmentEditors[tmpIdx].destroy();
			}
		}

		tmpContainer.innerHTML = '';

		// Restore toggle states on the container after clearing
		tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
		tmpContainer.classList.add('pict-mde-preview-' + this._previewMode);
		if (this._controlsVisible)
		{
			tmpContainer.classList.add('pict-mde-controls-on');
		}
		else
		{
			tmpContainer.classList.add('pict-mde-controls-hidden');
		}

		// Load existing segments from data address, or start with one empty segment
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length === 0)
		{
			tmpSegments = [{ Content: '' }];
			this._setSegmentsToData(tmpSegments);
		}

		this._segmentCounter = 0;
		this._segmentEditors = {};

		for (let i = 0; i < tmpSegments.length; i++)
		{
			this._renderSegment(tmpContainer, i, tmpSegments[i].Content || '');
		}

		this._renderAddButton(tmpContainer);
	}

	/**
	 * Render a single segment into the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 * @param {number} pIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	_renderSegment(pContainer, pIndex, pContent)
	{
		let tmpSegmentIndex = this._segmentCounter++;

		let tmpRecord =
		{
			SegmentIndex: tmpSegmentIndex,
			SegmentDisplayIndex: pIndex + 1,
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-Segment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpSegmentElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpSegmentElement);

		// Build quadrant buttons from configuration arrays
		this._buildQuadrantButtons(tmpSegmentElement, tmpSegmentIndex);

		// Restore per-segment preview hidden state (tracked by logical index)
		if (this._hiddenPreviewSegments[pIndex])
		{
			tmpSegmentElement.classList.add('pict-mde-preview-hidden');
		}

		// Restore per-segment tab state in tabbed mode
		if (this._previewMode === 'tabbed' && this._segmentTabStates[pIndex] === 'preview')
		{
			tmpSegmentElement.classList.add('pict-mde-tab-showing-preview');
			let tmpTabBar = tmpSegmentElement.querySelector('.pict-mde-tab-bar');
			if (tmpTabBar)
			{
				let tmpEditorTab = tmpTabBar.querySelector('[data-tab="editor"]');
				let tmpPreviewTab = tmpTabBar.querySelector('[data-tab="preview"]');
				if (tmpEditorTab) { tmpEditorTab.classList.remove('pict-mde-tab-active'); }
				if (tmpPreviewTab) { tmpPreviewTab.classList.add('pict-mde-tab-active'); }
			}
		}

		// Wire up drag-and-drop on the drag handle
		this._wireSegmentDragEvents(tmpSegmentElement, tmpSegmentIndex);

		// Create the CodeMirror editor in the segment editor container
		let tmpEditorContainer = this._resolveInstanceElement(`PictMDE-SegmentEditor-${tmpSegmentIndex}`);
		if (tmpEditorContainer)
		{
			this._createEditorInContainer(tmpEditorContainer, tmpSegmentIndex, pContent);

			// Wire image drag-and-drop on the editor container
			this._wireImageDragEvents(tmpEditorContainer, tmpSegmentIndex);

			// Render image previews for existing content
			if (pContent)
			{
				this._updateImagePreviews(tmpSegmentIndex);
				this._updateRichPreviews(tmpSegmentIndex);
			}
		}
	}

	/**
	 * Build buttons in all four quadrants (TL, BL, TR, BR) from the
	 * configuration arrays.  Each button config has:
	 *   HTML   — innerHTML
	 *   Action — "methodName" or "methodName:arg"
	 *   Class  — additional CSS class(es)
	 *   Title  — tooltip text
	 *
	 * Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	 * Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	_buildQuadrantButtons(pSegmentElement, pSegmentIndex)
	{
		let tmpQuadrants =
		[
			{ key: 'ButtonsTL', selector: '.pict-mde-quadrant-tl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsBL', selector: '.pict-mde-quadrant-bl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsTR', selector: '.pict-mde-quadrant-tr', baseClass: 'pict-mde-sidebar-btn' },
			{ key: 'ButtonsBR', selector: '.pict-mde-quadrant-br', baseClass: 'pict-mde-sidebar-btn' }
		];

		let tmpSelf = this;

		for (let q = 0; q < tmpQuadrants.length; q++)
		{
			let tmpQuadrant = tmpQuadrants[q];
			let tmpContainer = pSegmentElement.querySelector(tmpQuadrant.selector);
			if (!tmpContainer)
			{
				continue;
			}

			let tmpButtons = this.options[tmpQuadrant.key];
			if (!Array.isArray(tmpButtons))
			{
				continue;
			}

			for (let b = 0; b < tmpButtons.length; b++)
			{
				let tmpBtnConfig = tmpButtons[b];

				let tmpButton = document.createElement('button');
				tmpButton.type = 'button';
				tmpButton.className = tmpQuadrant.baseClass;
				if (tmpBtnConfig.Class)
				{
					tmpButton.className += ' ' + tmpBtnConfig.Class;
				}
				// Run the button HTML through Pict's template engine so
				// `{~I:Name~}` tags expand into themable SVG icons from
				// pict.providers.Icon.  Plain HTML strings (e.g. the
				// stylized `<b>B</b>` formatting buttons) pass through
				// unchanged — the parser is a no-op when no template tags
				// are present.
				let tmpHTML = tmpBtnConfig.HTML || '';
				if (tmpHTML && typeof (this.pict.parseTemplate) === 'function')
				{
					tmpHTML = this.pict.parseTemplate(tmpHTML, {});
				}
				tmpButton.innerHTML = tmpHTML;
				tmpButton.title = tmpBtnConfig.Title || '';

				// Parse the action string: "methodName" or "methodName:arg"
				let tmpAction = tmpBtnConfig.Action || '';
				let tmpMethod = tmpAction;
				let tmpArg = null;
				let tmpColonIndex = tmpAction.indexOf(':');
				if (tmpColonIndex >= 0)
				{
					tmpMethod = tmpAction.substring(0, tmpColonIndex);
					tmpArg = tmpAction.substring(tmpColonIndex + 1);
				}

				// Build the click handler
				(function (pMethod, pArg, pSegIdx)
				{
					tmpButton.addEventListener('click', () =>
					{
						if (typeof (tmpSelf[pMethod]) === 'function')
						{
							if (pArg !== null)
							{
								tmpSelf[pMethod](pSegIdx, pArg);
							}
							else
							{
								tmpSelf[pMethod](pSegIdx);
							}
						}
						else
						{
							tmpSelf.log.warn(`PICT-MarkdownEditor _buildQuadrantButtons: method "${pMethod}" not found.`);
						}
					});
				})(tmpMethod, tmpArg, pSegmentIndex);

				tmpContainer.appendChild(tmpButton);
			}
		}
	}


	/**
	 * Hook for subclasses to customize the CodeMirror extensions before editor creation.
	 *
	 * @param {Array} pExtensions - The extensions array to modify
	 * @param {number} pSegmentIndex - The segment index
	 * @returns {Array} The modified extensions array
	 */
	customConfigureExtensions(pExtensions, pSegmentIndex)
	{
		return pExtensions;
	}

	/**
	 * Render the "Add Segment" button at the bottom of the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 */
	_renderAddButton(pContainer)
	{
		let tmpRecord =
		{
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-AddSegment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpButtonElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpButtonElement);
	}

	/**
	 * Hook for consumers to handle image uploads.
	 *
	 * Override this in a subclass or consumer to upload images to a server/CDN.
	 * Return true to indicate you are handling the upload asynchronously.
	 * Call fCallback(null, url) on success, or fCallback(error) on failure.
	 * Return false/undefined to fall back to base64 data URI inline.
	 *
	 * @param {File} pFile - The image File object
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {function} fCallback - Callback: fCallback(pError, pURL)
	 * @returns {boolean} true if handling the upload, false to use base64 default
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		// Override in subclass or consumer
		return false;
	}

	// -- Controls Toggle (line numbers + right sidebar) --

	/**
	 * Toggle controls (line number gutters and right sidebar formatting
	 * buttons) on or off for all segments.
	 *
	 * When controls are hidden the right-side quadrants (TR, BR) appear
	 * faintly on hover but are otherwise invisible, and CodeMirror line
	 * number gutters are hidden.
	 *
	 * This method is called by the quadrant button system with the segment
	 * index as the first argument — it ignores that argument and uses only
	 * the optional boolean.
	 *
	 * @param {number|boolean} [pSegmentIndexOrVisible] - Segment index (ignored) or boolean
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleControls(pSegmentIndexOrVisible, pVisible)
	{
		// When called from a quadrant button, first arg is segment index (number).
		// When called programmatically, first arg may be a boolean.
		let tmpVisible = pVisible;
		if (typeof (pSegmentIndexOrVisible) === 'boolean')
		{
			tmpVisible = pSegmentIndexOrVisible;
		}

		if (typeof (tmpVisible) === 'boolean')
		{
			this._controlsVisible = tmpVisible;
		}
		else
		{
			this._controlsVisible = !this._controlsVisible;
		}

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			if (this._controlsVisible)
			{
				tmpContainer.classList.add('pict-mde-controls-on');
				tmpContainer.classList.remove('pict-mde-controls-hidden');
			}
			else
			{
				tmpContainer.classList.remove('pict-mde-controls-on');
				tmpContainer.classList.add('pict-mde-controls-hidden');
			}
		}
	}

	/**
	 * Toggle line numbers on or off for all segments.
	 * Backward-compatible alias for toggleControls().
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleLineNumbers(pVisible)
	{
		this.toggleControls(pVisible);
	}

	// -- Preview Toggle --

	/**
	 * Toggle rich previews on or off for all segments globally.
	 *
	 * When hidden globally, individual segment overrides are preserved
	 * so that restoring global visibility returns to the per-segment state.
	 *
	 * Backward compatible: toggles between "off" and the last-used preview layout.
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	togglePreview(pVisible)
	{
		if (typeof (pVisible) === 'boolean')
		{
			if (pVisible)
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
		else
		{
			if (this._previewMode === 'off')
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
	}

	/**
	 * Set the preview layout mode.
	 *
	 * @param {string} pMode - One of "off", "bottom", "side", "tabbed"
	 */
	setPreviewMode(pMode)
	{
		let tmpValidModes = ['off', 'bottom', 'side', 'tabbed'];
		if (tmpValidModes.indexOf(pMode) < 0)
		{
			this.log.warn(`PICT-MarkdownEditor setPreviewMode: unknown mode "${pMode}".`);
			return;
		}

		// Remember the last non-off mode for toggle restore
		if (pMode !== 'off')
		{
			this._lastPreviewLayout = pMode;
		}

		this._previewMode = pMode;

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
			tmpContainer.classList.add('pict-mde-preview-' + pMode);
		}

		// When switching to a visible preview mode, trigger preview renders
		// for all segments to ensure they are up to date
		if (pMode !== 'off')
		{
			let tmpOrderedIndices = this._getOrderedSegmentIndices();
			for (let i = 0; i < tmpOrderedIndices.length; i++)
			{
				this._updateRichPreviews(tmpOrderedIndices[i]);
				this._updateImagePreviews(tmpOrderedIndices[i]);
			}
		}
	}

	/**
	 * Cycle through preview layout modes: off → bottom → side → tabbed → off.
	 *
	 * Accepts a segment index as first argument (ignored) for compatibility
	 * with the quadrant button system.
	 *
	 * @param {number} [pSegmentIndex] - Ignored; present for quadrant button compat
	 */
	cyclePreviewMode(pSegmentIndex)
	{
		let tmpModeOrder = ['off', 'bottom', 'side', 'tabbed'];
		let tmpCurrentIndex = tmpModeOrder.indexOf(this._previewMode);
		let tmpNextIndex = (tmpCurrentIndex + 1) % tmpModeOrder.length;
		this.setPreviewMode(tmpModeOrder[tmpNextIndex]);
	}

	/**
	 * Switch a segment between editor and preview tabs (tabbed mode).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pTab - "editor" or "preview"
	 */
	switchSegmentTab(pSegmentIndex, pTab)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		this._segmentTabStates[tmpLogicalIndex] = pTab;

		let tmpSegmentEl = this._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		// Toggle the preview-showing class on the segment
		if (pTab === 'preview')
		{
			tmpSegmentEl.classList.add('pict-mde-tab-showing-preview');
			// Trigger preview render when switching to preview tab
			this._updateRichPreviews(pSegmentIndex);
			this._updateImagePreviews(pSegmentIndex);
		}
		else
		{
			tmpSegmentEl.classList.remove('pict-mde-tab-showing-preview');
		}

		// Update tab bar active state
		let tmpTabBar = this._resolveInstanceElement(`PictMDE-TabBar-${pSegmentIndex}`);
		if (tmpTabBar)
		{
			let tmpTabs = tmpTabBar.querySelectorAll('.pict-mde-tab');
			for (let i = 0; i < tmpTabs.length; i++)
			{
				if (tmpTabs[i].getAttribute('data-tab') === pTab)
				{
					tmpTabs[i].classList.add('pict-mde-tab-active');
				}
				else
				{
					tmpTabs[i].classList.remove('pict-mde-tab-active');
				}
			}
		}
	}

	/**
	 * Toggle the rich preview for a single segment.
	 *
	 * This adds/removes the .pict-mde-preview-hidden class on the
	 * individual segment element, independent of the global toggle.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleSegmentPreview(pSegmentIndex, pVisible)
	{
		// Convert internal index to logical index for persistent tracking
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpCurrentlyHidden = !!this._hiddenPreviewSegments[tmpLogicalIndex];

		if (typeof (pVisible) === 'boolean')
		{
			tmpCurrentlyHidden = !pVisible;
		}
		else
		{
			tmpCurrentlyHidden = !tmpCurrentlyHidden;
		}

		if (tmpCurrentlyHidden)
		{
			this._hiddenPreviewSegments[tmpLogicalIndex] = true;
		}
		else
		{
			delete this._hiddenPreviewSegments[tmpLogicalIndex];
		}

		let tmpSegmentEl = this._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegmentEl)
		{
			if (tmpCurrentlyHidden)
			{
				tmpSegmentEl.classList.add('pict-mde-preview-hidden');
			}
			else
			{
				tmpSegmentEl.classList.remove('pict-mde-preview-hidden');
				// Render preview content when making it visible
				this._updateRichPreviews(pSegmentIndex);
				this._updateImagePreviews(pSegmentIndex);
			}
		}
	}

	// -- Segment Data Management --

	/**
	 * Get the segments array from the configured data address.
	 *
	 * @returns {Array|null}
	 */
	_getSegmentsFromData()
	{
		if (!this.options.ContentDataAddress)
		{
			return null;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		let tmpData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.ContentDataAddress);

		if (Array.isArray(tmpData))
		{
			return tmpData;
		}

		return null;
	}

	/**
	 * Write the segments array to the configured data address.
	 *
	 * @param {Array} pSegments - The segments array
	 */
	_setSegmentsToData(pSegments)
	{
		if (!this.options.ContentDataAddress)
		{
			return;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.ContentDataAddress, pSegments);
	}

	/**
	 * Called when a segment's content changes in the CodeMirror editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pContent - The new content
	 */
	_onSegmentContentChange(pSegmentIndex, pContent)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		if (tmpLogicalIndex < tmpSegments.length)
		{
			tmpSegments[tmpLogicalIndex].Content = pContent;
		}

		this.onContentChange(tmpLogicalIndex, pContent);

		// Debounce image preview updates (500ms) to avoid thrashing on every keystroke
		let tmpSelf = this;
		if (this._imagePreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._imagePreviewTimers[pSegmentIndex]);
		}
		this._imagePreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateImagePreviews(pSegmentIndex);
			delete tmpSelf._imagePreviewTimers[pSegmentIndex];
		}, 500);

		// Debounce rich content preview updates (mermaid / KaTeX) at 500ms
		if (this._richPreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._richPreviewTimers[pSegmentIndex]);
		}
		this._richPreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateRichPreviews(pSegmentIndex);
			delete tmpSelf._richPreviewTimers[pSegmentIndex];
		}, 500);
	}

	/**
	 * Hook for subclasses to respond to content changes.
	 *
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {string} pContent - The new content
	 */
	onContentChange(pSegmentIndex, pContent)
	{
		// Override in subclass
	}

	/**
	 * Get the logical (ordered) index for an internal segment index.
	 *
	 * @param {number} pInternalIndex - The internal segment index
	 * @returns {number} The logical index, or -1 if not found
	 */
	_getLogicalIndex(pInternalIndex)
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return -1;
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			let tmpIndex = parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10);
			if (tmpIndex === pInternalIndex)
			{
				return i;
			}
		}

		return -1;
	}

	/**
	 * Get the ordered list of internal segment indices from the DOM.
	 *
	 * @returns {Array<number>}
	 */
	_getOrderedSegmentIndices()
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return [];
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		let tmpIndices = [];
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			tmpIndices.push(parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10));
		}
		return tmpIndices;
	}

	// -- Public API --

	/**
	 * Add a new empty segment at the end.
	 *
	 * @param {string} [pContent] - Optional initial content for the new segment
	 */
	addSegment(pContent)
	{
		let tmpContent = (typeof (pContent) === 'string') ? pContent : '';

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			tmpSegments = [];
		}
		tmpSegments.push({ Content: tmpContent });
		this._setSegmentsToData(tmpSegments);

		this._buildEditorUI();
	}

	/**
	 * Remove a segment by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	removeSegment(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: segment index ${pSegmentIndex} not found.`);
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length <= 1)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: cannot remove the last segment.`);
			return;
		}

		if (this._segmentEditors[pSegmentIndex])
		{
			this._segmentEditors[pSegmentIndex].destroy();
			delete this._segmentEditors[pSegmentIndex];
		}

		tmpSegments.splice(tmpLogicalIndex, 1);
		this._setSegmentsToData(tmpSegments);

		// Update per-segment hidden preview state after removal
		let tmpNewHidden = {};
		for (let tmpKey in this._hiddenPreviewSegments)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx] = true;
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx - 1] = true;
			}
			// tmpIdx === tmpLogicalIndex is the removed segment; skip it
		}
		this._hiddenPreviewSegments = tmpNewHidden;

		// Update per-segment tab states after removal
		let tmpNewTabStates = {};
		for (let tmpKey in this._segmentTabStates)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx] = this._segmentTabStates[tmpKey];
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx - 1] = this._segmentTabStates[tmpKey];
			}
		}
		this._segmentTabStates = tmpNewTabStates;

		this._buildEditorUI();
	}

	/**
	 * Move a segment up by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentUp(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex <= 0)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex - 1];
		tmpSegments[tmpLogicalIndex - 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex - 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex - 1);

		this._buildEditorUI();
	}

	/**
	 * Move a segment down by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentDown(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpSegments.length - 1)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex + 1];
		tmpSegments[tmpLogicalIndex + 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex + 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex + 1);

		this._buildEditorUI();
	}

	/**
	 * Get the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @returns {string} The segment content
	 */
	getSegmentContent(pLogicalIndex)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			return '';
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			return tmpEditor.state.doc.toString();
		}

		return '';
	}

	/**
	 * Set the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @param {string} pContent - The content to set
	 */
	setSegmentContent(pLogicalIndex, pContent)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			this.log.warn(`PICT-MarkdownEditor setSegmentContent: index ${pLogicalIndex} out of range.`);
			return;
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			tmpEditor.dispatch(
			{
				changes:
				{
					from: 0,
					to: tmpEditor.state.doc.length,
					insert: pContent
				}
			});
		}
	}

	/**
	 * Get the total number of segments.
	 *
	 * @returns {number}
	 */
	getSegmentCount()
	{
		return this._getOrderedSegmentIndices().length;
	}

	/**
	 * Get all content from all segments joined together.
	 *
	 * @param {string} [pSeparator] - The separator between segments (default: "\n\n")
	 * @returns {string}
	 */
	getAllContent(pSeparator)
	{
		let tmpSeparator = (typeof (pSeparator) === 'string') ? pSeparator : '\n\n';
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		let tmpParts = [];

		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor)
			{
				tmpParts.push(tmpEditor.state.doc.toString());
			}
		}

		return tmpParts.join(tmpSeparator);
	}

	/**
	 * Marshal all editor contents back into the data address.
	 */
	_marshalAllEditorsToData()
	{
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor && i < tmpSegments.length)
			{
				tmpSegments[i].Content = tmpEditor.state.doc.toString();
			}
		}
	}

	/**
	 * Set the read-only state of all editors.
	 *
	 * @param {boolean} pReadOnly - Whether editors should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this.initialRenderComplete)
		{
			this._marshalAllEditorsToData();
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.initialRenderComplete && this.options.ContentDataAddress)
		{
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal the current editor content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		this._marshalAllEditorsToData();
	}

	/**
	 * Destroy all editors and clean up.
	 */
	destroy()
	{
		for (let tmpIndex in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIndex])
			{
				this._segmentEditors[tmpIndex].destroy();
			}
		}
		this._segmentEditors = {};

		// Clear rich preview debounce timers
		for (let tmpIndex in this._richPreviewTimers)
		{
			clearTimeout(this._richPreviewTimers[tmpIndex]);
		}
		this._richPreviewTimers = {};
		this._richPreviewGenerations = {};
		this._segmentTabStates = {};
	}
}

module.exports = PictSectionMarkdownEditor;

module.exports.default_configuration = _DefaultConfiguration;

// Form-side integration: the `RichText` InputType (and its provider class) lives
// in pict-section-form under `providers/inputs/Pict-Provider-Input-RichText.js`,
// not here. The provider lazy-requires this module on the first setMode('edit')
// so consumers that never edit don't pull CodeMirror.
//
//   const libRichTextInput = require('pict-section-form').RichTextInput;
//   pict.addProvider('Pict-Input-RichText',
//       libRichTextInput.default_configuration, libRichTextInput);

},{"./Pict-MDE-CodeMirror.js":574,"./Pict-MDE-DragAndReorder.js":575,"./Pict-MDE-Formatting.js":576,"./Pict-MDE-ImageHandling.js":577,"./Pict-MDE-RichPreview.js":578,"./Pict-Section-MarkdownEditor-DefaultConfiguration.js":579,"pict-section-content":486,"pict-view":693}],581:[function(require,module,exports){
/**
 * Pict-Modal-Confirm
 *
 * Builds confirm and double-confirm dialog DOM, returns Promises.
 */
class PictModalConfirm
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a single-step confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmLabel, cancelLabel, dangerous)
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is provided, user must type it to enable the confirm button.
	 * Otherwise, first click changes button text, second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel)
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultDoubleConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDoubleConfirmDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Build a standard confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpBtnStyle = pOptions.dangerous ? 'danger' : 'primary';

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				'<p>' + this._escapeHTML(pMessage) + '</p>' +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--' + tmpBtnStyle + '" data-action="confirm">' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpConfirmBtn.addEventListener('click', () => { tmpDismiss(true); });

		tmpDialog._dismiss = tmpDismiss;
		tmpDialog._focusTarget = tmpCancelBtn;

		return tmpDialog;
	}

	/**
	 * Build a double-confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDoubleConfirmDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpHasPhrase = (typeof pOptions.confirmPhrase === 'string') && (pOptions.confirmPhrase.length > 0);

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		let tmpBodyContent = '<p>' + this._escapeHTML(pMessage) + '</p>';

		if (tmpHasPhrase)
		{
			let tmpPromptText = pOptions.phrasePrompt.replace('{phrase}', pOptions.confirmPhrase);
			tmpBodyContent +=
				'<div class="pict-modal-confirm-prompt">' + this._escapeHTML(tmpPromptText) + '</div>' +
				'<input type="text" class="pict-modal-confirm-input" autocomplete="off" spellcheck="false" />';
		}

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				tmpBodyContent +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--danger" data-action="confirm" disabled>' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });

		if (tmpHasPhrase)
		{
			// Phrase-based: enable confirm button when input matches
			let tmpInput = tmpDialog.querySelector('.pict-modal-confirm-input');
			tmpInput.addEventListener('input', () =>
			{
				tmpConfirmBtn.disabled = (tmpInput.value !== pOptions.confirmPhrase);
			});
			tmpConfirmBtn.addEventListener('click', () =>
			{
				if (!tmpConfirmBtn.disabled)
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpInput;
		}
		else
		{
			// Two-click: first click changes label, second click confirms
			let tmpClickCount = 0;
			let tmpOriginalLabel = pOptions.confirmLabel;
			tmpConfirmBtn.disabled = false;

			tmpConfirmBtn.addEventListener('click', () =>
			{
				tmpClickCount++;
				if (tmpClickCount === 1)
				{
					tmpConfirmBtn.textContent = 'Click again to confirm';
				}
				else
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpCancelBtn;
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show a dialog element: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {function} fResolve - Promise resolver (for overlay click dismiss)
	 */
	_showDialog(pDialog, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'confirm'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(false); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track active modal
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus
		if (pDialog._focusTarget)
		{
			pDialog._focusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pDialog._dismiss(false);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);
	}

	/**
	 * Dismiss a dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult - Value to resolve the promise with
	 * @param {function} fResolve - Promise resolver
	 */
	_dismissDialog(pDialog, pResult, fResolve)
	{
		// Prevent double-dismiss
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		// Remove keyboard handler
		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		// Animate out
		pDialog.classList.remove('pict-modal-visible');

		// Remove from active modals
		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		// Update overlay click handler to point to new topmost modal
		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		// Hide overlay
		this._modal._overlay.hide();

		// Remove from DOM after transition
		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		// Resolve promise
		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalConfirm;

},{}],582:[function(require,module,exports){
/**
 * Pict-Modal-Dropdown
 *
 * Anchor-positioned menu that behaves like a dropdown / popover. Handy for:
 *   - nav menus that hang off a header link or button
 *   - "split button" style addenda (a primary action paired with a chevron
 *     that opens a list of related/alternate actions)
 *   - any "more options" affordance where a full modal would be heavy
 *
 * Differences from the modal Window helper:
 *   - No backdrop overlay — the rest of the page stays interactive.
 *   - Positioned next to the anchor element, not centered.
 *   - Auto-flips above when there isn't room below; clamps inside the viewport.
 *   - Click outside or Escape dismisses (matches native menu conventions).
 *
 * Usage:
 *     modal.dropdown(anchorEl, {
 *         items:
 *         [
 *             { Hash: 'edit',   Label: 'Edit'                    },
 *             { Hash: 'rename', Label: 'Rename...'                },
 *             { Separator: true                                   },
 *             { Hash: 'delete', Label: 'Delete', Style: 'danger'  },
 *             { Hash: 'archive',Label: 'Archive', Disabled: true,
 *               Tooltip: 'Already archived'                       }
 *         ],
 *         align: 'left'        // 'left' | 'right' (relative to anchor)
 *     }).then((pChoice) => { ... });
 *
 * Returns a Promise that resolves with `{ Hash, Item }` on selection or
 * `null` on dismiss.
 */
class PictModalDropdown
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._activeMenu = null;
	}

	/**
	 * Open a dropdown menu anchored to an element.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   a rect-like { left, top, width, height } anchor (handy for context menus).
	 * @param {object} pOptions
	 * @param {Array}    pOptions.items     - [{ Hash, Label, Style?, Disabled?, Tooltip?, Icon?, Separator? }]
	 * @param {string}   [pOptions.ContentHTML] - Free-form HTML body for the popover, rendered
	 *   verbatim via innerHTML INSTEAD of building a menu from items[]. When set, the element is
	 *   a plain anchored popover (no role=menu / keyboard item nav); outside-click, Escape,
	 *   auto-flip and reposition still apply. Sanitize untrusted content. items is ignored.
	 * @param {string}   [pOptions.align]   - 'left'|'right'|'center' (default 'left')
	 * @param {string}   [pOptions.position]- 'auto'|'below'|'above' (default 'auto')
	 * @param {string}   [pOptions.minWidth]- CSS minWidth (default: anchor width if known, else '160px')
	 * @param {string}   [pOptions.maxWidth]- CSS maxWidth (default unset; the base menu caps at 360px,
	 *   the --content variant uncaps — set this for wide rich-content popovers)
	 * @param {string}   [pOptions.maxHeight]- CSS maxHeight (default '60vh')
	 * @param {string}   [pOptions.className]- extra class(es) for the menu element
	 * @param {boolean}  [pOptions.closeOnSelect] - default true (no-op in ContentHTML mode)
	 * @param {function} [pOptions.onSelect]- called with (Hash, Item) on selection
	 * @param {function} [pOptions.onClose] - called after dismiss
	 * @returns {Promise<{Hash: string, Item: object}|null>}
	 */
	dropdown(pAnchor, pOptions)
	{
		let tmpOptions = Object.assign(
			{
				align:         'left',
				position:      'auto',
				maxHeight:     '60vh',
				closeOnSelect: true,
			},
			pOptions || {});

		let tmpAnchorEl = this._resolveAnchor(pAnchor);
		let tmpAnchorRect = this._anchorRect(pAnchor, tmpAnchorEl);
		if (!tmpAnchorRect) { return Promise.resolve(null); }

		// Re-opening the same menu is a no-op; closing-then-reopening is a
		// caller decision (just call dismissDropdown() first).
		if (this._activeMenu && this._activeMenu.anchor === tmpAnchorEl)
		{
			return this._activeMenu.promise;
		}

		// Only one dropdown at a time keeps focus / keyboard handling sane.
		this.dismissAll();

		let tmpItems = Array.isArray(tmpOptions.items) ? tmpOptions.items : [];

		let tmpResolveOuter;
		let tmpPromise = new Promise((fResolve) => { tmpResolveOuter = fResolve; });

		let tmpMenu = this._buildMenu(tmpItems, tmpOptions);
		document.body.appendChild(tmpMenu);
		this._positionMenu(tmpMenu, tmpAnchorRect, tmpOptions);

		// Animate in on the next frame.
		void tmpMenu.offsetHeight;
		tmpMenu.classList.add('pict-modal-visible');

		let tmpDismiss = (pResult) =>
		{
			if (tmpMenu._dismissed) { return; }
			tmpMenu._dismissed = true;
			document.removeEventListener('mousedown', tmpOutsideHandler, true);
			document.removeEventListener('keydown', tmpKeyHandler, true);
			window.removeEventListener('resize', tmpRepositionHandler);
			window.removeEventListener('scroll', tmpRepositionHandler, true);
			tmpMenu.classList.remove('pict-modal-visible');
			setTimeout(() =>
				{
					if (tmpMenu.parentNode) { tmpMenu.parentNode.removeChild(tmpMenu); }
				}, 180);
			if (this._activeMenu && this._activeMenu.element === tmpMenu) { this._activeMenu = null; }
			if (typeof tmpOptions.onClose === 'function') { tmpOptions.onClose(pResult); }
			tmpResolveOuter(pResult);
		};

		// Wire item clicks (each item element carries a data-hash; separators
		// and disabled items are skipped).
		let tmpItemEls = tmpMenu.querySelectorAll('[data-pict-modal-dropdown-item]');
		for (let i = 0; i < tmpItemEls.length; i++)
		{
			let tmpEl = tmpItemEls[i];
			tmpEl.addEventListener('click', (pEvent) =>
				{
					if (tmpEl.hasAttribute('data-disabled')) { return; }
					pEvent.stopPropagation();
					let tmpIdx = parseInt(tmpEl.getAttribute('data-index'), 10);
					let tmpItem = tmpItems[tmpIdx];
					let tmpHash = tmpEl.getAttribute('data-hash');
					if (typeof tmpOptions.onSelect === 'function')
					{
						tmpOptions.onSelect(tmpHash, tmpItem);
					}
					if (tmpOptions.closeOnSelect !== false) { tmpDismiss({ Hash: tmpHash, Item: tmpItem }); }
				});
		}

		// Click anywhere outside the menu (and outside the anchor) → dismiss.
		// Use mousedown/capture so we beat any per-element click handlers.
		let tmpOutsideHandler = (pEvent) =>
		{
			if (tmpMenu.contains(pEvent.target)) { return; }
			if (tmpAnchorEl && tmpAnchorEl.contains && tmpAnchorEl.contains(pEvent.target)) { return; }
			tmpDismiss(null);
		};
		document.addEventListener('mousedown', tmpOutsideHandler, true);

		// Esc dismisses; arrow keys navigate items (skipping disabled/separator).
		let tmpKeyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape') { pEvent.stopPropagation(); tmpDismiss(null); return; }
			if (pEvent.key === 'ArrowDown' || pEvent.key === 'ArrowUp')
			{
				pEvent.preventDefault();
				this._focusNeighbor(tmpMenu, pEvent.key === 'ArrowDown' ? 1 : -1);
			}
			else if (pEvent.key === 'Enter' || pEvent.key === ' ')
			{
				let tmpFocused = document.activeElement;
				if (tmpFocused && tmpMenu.contains(tmpFocused) && tmpFocused.hasAttribute('data-pict-modal-dropdown-item'))
				{
					pEvent.preventDefault();
					tmpFocused.click();
				}
			}
		};
		document.addEventListener('keydown', tmpKeyHandler, true);

		// Reposition on viewport resize / scroll so the menu doesn't drift
		// off the anchor.
		let tmpRepositionHandler = () =>
		{
			let tmpRect = this._anchorRect(pAnchor, tmpAnchorEl);
			if (tmpRect) { this._positionMenu(tmpMenu, tmpRect, tmpOptions); }
		};
		window.addEventListener('resize', tmpRepositionHandler);
		window.addEventListener('scroll', tmpRepositionHandler, true);

		// Move keyboard focus to the first enabled item so arrows / Enter work
		// without an extra click.
		setTimeout(() => { this._focusFirstEnabled(tmpMenu); }, 0);

		this._activeMenu = { element: tmpMenu, anchor: tmpAnchorEl, promise: tmpPromise, dismiss: tmpDismiss };

		return tmpPromise;
	}

	/**
	 * Dismiss the currently-open dropdown (if any).
	 */
	dismissAll()
	{
		if (this._activeMenu)
		{
			let tmpDismiss = this._activeMenu.dismiss;
			this._activeMenu = null;
			tmpDismiss(null);
		}
	}

	// ─────────────────────────────────────────────
	//  Internals
	// ─────────────────────────────────────────────

	_resolveAnchor(pAnchor)
	{
		if (!pAnchor) { return null; }
		if (typeof pAnchor === 'string') { return document.querySelector(pAnchor); }
		if (pAnchor.nodeType === 1) { return pAnchor; }
		// rect-like — no element to attach focus / outside-click ignore to,
		// but that's fine, the caller knows what they're doing.
		return null;
	}

	_anchorRect(pAnchor, pAnchorEl)
	{
		if (pAnchorEl && typeof pAnchorEl.getBoundingClientRect === 'function')
		{
			return pAnchorEl.getBoundingClientRect();
		}
		if (pAnchor && typeof pAnchor === 'object'
			&& typeof pAnchor.left === 'number' && typeof pAnchor.top === 'number')
		{
			return {
				left:   pAnchor.left,
				top:    pAnchor.top,
				width:  pAnchor.width  || 0,
				height: pAnchor.height || 0,
				right:  pAnchor.left + (pAnchor.width  || 0),
				bottom: pAnchor.top  + (pAnchor.height || 0),
			};
		}
		return null;
	}

	/**
	 * True when the value is usable as ContentHTML — a primitive string or a
	 * boxed String object (some template engines hand back `new String(...)`,
	 * which is `typeof 'object'` and would otherwise slip past the guard).
	 *
	 * @param {*} pValue
	 * @returns {boolean}
	 */
	_isContentHTML(pValue)
	{
		return (typeof pValue === 'string') || (pValue instanceof String);
	}

	_buildMenu(pItems, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-modal-dropdown';
		// Free-form content popovers carry a modifier so the host can reset the
		// menu-item chrome (padding / max-width) and style the body itself.
		if (this._isContentHTML(pOptions.ContentHTML)) { tmpMenu.className += ' pict-modal-dropdown--content'; }
		if (pOptions.className) { tmpMenu.className += ' ' + pOptions.className; }
		tmpMenu.id = 'pict-modal-dropdown-' + tmpId;
		tmpMenu.style.maxHeight = pOptions.maxHeight;
		if (pOptions.maxWidth) { tmpMenu.style.maxWidth = pOptions.maxWidth; }

		// ContentHTML mode: render the caller's HTML verbatim instead of building
		// a menu from items[]. This is a free-form anchored popover (e.g. a rich
		// info card, or a pre-rendered template menu) — not a role=menu list, so
		// we skip the menu role and the per-item keyboard semantics. Outside-click
		// / Escape / auto-flip / reposition all still apply from dropdown().
		if (this._isContentHTML(pOptions.ContentHTML))
		{
			tmpMenu.innerHTML = pOptions.ContentHTML;
			return tmpMenu;
		}

		tmpMenu.setAttribute('role', 'menu');

		let tmpHtml = '';
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpItem = pItems[i];
			if (tmpItem.Separator)
			{
				tmpHtml += '<div class="pict-modal-dropdown-separator" role="separator"></div>';
				continue;
			}
			if (tmpItem.Header)
			{
				tmpHtml += '<div class="pict-modal-dropdown-header">'
					+ this._escapeHTML(tmpItem.Header) + '</div>';
				continue;
			}
			let tmpCls = 'pict-modal-dropdown-item';
			if (tmpItem.Style)    { tmpCls += ' pict-modal-dropdown-item--' + tmpItem.Style; }
			if (tmpItem.Disabled) { tmpCls += ' pict-modal-dropdown-item--disabled'; }
			let tmpAttrs = ''
				+ ' data-pict-modal-dropdown-item'
				+ ' data-index="' + i + '"'
				+ ' data-hash="'  + this._escapeHTML(tmpItem.Hash || '') + '"'
				+ ' role="menuitem"'
				+ ' tabindex="-1"';
			if (tmpItem.Disabled) { tmpAttrs += ' aria-disabled="true" data-disabled'; }
			if (tmpItem.Tooltip)  { tmpAttrs += ' title="' + this._escapeHTML(tmpItem.Tooltip) + '"'; }
			let tmpIcon = tmpItem.Icon ? '<span class="pict-modal-dropdown-item-icon">' + tmpItem.Icon + '</span>' : '';
			let tmpHint = tmpItem.Hint ? '<span class="pict-modal-dropdown-item-hint">' + this._escapeHTML(tmpItem.Hint) + '</span>' : '';
			tmpHtml += '<div class="' + tmpCls + '"' + tmpAttrs + '>'
				+ tmpIcon
				+ '<span class="pict-modal-dropdown-item-label">' + this._escapeHTML(tmpItem.Label || '') + '</span>'
				+ tmpHint
				+ '</div>';
		}

		tmpMenu.innerHTML = tmpHtml;
		return tmpMenu;
	}

	_positionMenu(pMenu, pAnchorRect, pOptions)
	{
		// Apply min-width before measuring so the menu's natural size accounts
		// for the constraint.
		let tmpMinWidth = pOptions.minWidth
			|| (pAnchorRect.width >= 80 ? Math.ceil(pAnchorRect.width) + 'px' : '160px');
		pMenu.style.minWidth = tmpMinWidth;

		// Measure after attaching.
		let tmpMenuRect = pMenu.getBoundingClientRect();
		let tmpVw = window.innerWidth || document.documentElement.clientWidth;
		let tmpVh = window.innerHeight || document.documentElement.clientHeight;
		let tmpGap = 4; // breathing room between anchor and menu

		// Vertical: prefer below; flip above when not enough room and there's
		// more above. 'below'/'above' overrides force the side.
		let tmpRoomBelow = tmpVh - pAnchorRect.bottom - tmpGap;
		let tmpRoomAbove = pAnchorRect.top - tmpGap;
		let tmpPlaceAbove;
		if      (pOptions.position === 'above') { tmpPlaceAbove = true; }
		else if (pOptions.position === 'below') { tmpPlaceAbove = false; }
		else { tmpPlaceAbove = (tmpMenuRect.height > tmpRoomBelow) && (tmpRoomAbove > tmpRoomBelow); }

		// Cap height to whichever side we landed on so the menu can scroll
		// internally instead of running off the screen.
		let tmpCap = Math.max(80, (tmpPlaceAbove ? tmpRoomAbove : tmpRoomBelow) - 8);
		pMenu.style.maxHeight = tmpCap + 'px';

		// Horizontal alignment to the anchor, then clamp inside the viewport.
		let tmpLeft;
		if (pOptions.align === 'right')
		{
			tmpLeft = pAnchorRect.right - tmpMenuRect.width;
		}
		else if (pOptions.align === 'center')
		{
			tmpLeft = pAnchorRect.left + (pAnchorRect.width - tmpMenuRect.width) / 2;
		}
		else
		{
			tmpLeft = pAnchorRect.left;
		}
		tmpLeft = Math.min(tmpLeft, tmpVw - tmpMenuRect.width - 4);
		tmpLeft = Math.max(4, tmpLeft);

		let tmpTop;
		if (tmpPlaceAbove)
		{
			tmpTop = Math.max(4, pAnchorRect.top - tmpMenuRect.height - tmpGap);
			pMenu.classList.add('pict-modal-dropdown--above');
		}
		else
		{
			tmpTop = pAnchorRect.bottom + tmpGap;
			pMenu.classList.remove('pict-modal-dropdown--above');
		}

		pMenu.style.left = Math.round(tmpLeft) + 'px';
		pMenu.style.top  = Math.round(tmpTop)  + 'px';
	}

	_focusFirstEnabled(pMenu)
	{
		let tmpItems = pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])');
		if (tmpItems.length) { tmpItems[0].focus(); }
	}

	_focusNeighbor(pMenu, pDirection)
	{
		let tmpItems = Array.prototype.slice.call(
			pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])'));
		if (!tmpItems.length) { return; }
		let tmpActive = document.activeElement;
		let tmpIdx = tmpItems.indexOf(tmpActive);
		let tmpNext = (tmpIdx === -1)
			? (pDirection > 0 ? 0 : tmpItems.length - 1)
			: (tmpIdx + pDirection + tmpItems.length) % tmpItems.length;
		tmpItems[tmpNext].focus();
	}

	_escapeHTML(pText)
	{
		if (typeof pText !== 'string') { return ''; }
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalDropdown;

},{}],583:[function(require,module,exports){
/**
 * Pict-Modal-Overlay
 *
 * Manages a shared backdrop overlay element appended to document.body.
 * Reference-counted — created on first modal open, removed when last closes.
 */
class PictModalOverlay
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._element = null;
		this._refCount = 0;
	}

	/**
	 * Show the overlay (incrementing reference count).
	 * Creates the DOM element on first call.
	 *
	 * @param {function} [fOnClick] - Optional click handler (e.g. dismiss topmost modal)
	 */
	show(fOnClick)
	{
		this._refCount++;

		if (!this._element)
		{
			this._element = document.createElement('div');
			this._element.className = 'pict-modal-overlay';
			document.body.appendChild(this._element);

			// Force reflow so the transition animates
			void this._element.offsetHeight;
			this._element.classList.add('pict-modal-visible');
		}

		if (fOnClick)
		{
			// Store the latest click handler (for the topmost modal)
			this._currentClickHandler = fOnClick;
			this._element.onclick = (pEvent) =>
			{
				if (pEvent.target === this._element && this._currentClickHandler)
				{
					this._currentClickHandler();
				}
			};
		}
	}

	/**
	 * Update the overlay click handler (e.g. when topmost modal changes).
	 *
	 * @param {function} [fOnClick] - New click handler
	 */
	updateClickHandler(fOnClick)
	{
		this._currentClickHandler = fOnClick || null;
	}

	/**
	 * Hide the overlay (decrementing reference count).
	 * Removes the DOM element when reference count reaches zero.
	 */
	hide()
	{
		this._refCount--;

		if (this._refCount <= 0)
		{
			this._refCount = 0;
			if (this._element)
			{
				this._element.classList.remove('pict-modal-visible');
				let tmpElement = this._element;
				// Remove after transition
				setTimeout(() =>
				{
					if (tmpElement.parentNode)
					{
						tmpElement.parentNode.removeChild(tmpElement);
					}
				}, 220);
				this._element = null;
				this._currentClickHandler = null;
			}
		}
	}

	/**
	 * Force-remove the overlay regardless of reference count.
	 */
	destroy()
	{
		this._refCount = 0;
		if (this._element && this._element.parentNode)
		{
			this._element.parentNode.removeChild(this._element);
		}
		this._element = null;
		this._currentClickHandler = null;
	}
}

module.exports = PictModalOverlay;

},{}],584:[function(require,module,exports){
/**
 * Pict-Modal-Panel
 *
 * Adds resizable and collapsible panel behavior to any DOM element.
 * Follows the handler composition pattern used by the other modal
 * handlers (confirm, window, toast, tooltip).
 *
 * Usage:
 *   let handle = modal.panel('#my-panel', { position: 'right', width: 340 });
 *   handle.toggle();
 *   handle.destroy();
 */
class PictModalPanel
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._panels = [];
	}

	/**
	 * Attach resizable/collapsible panel behavior to an element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Panel options
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	create(pTargetSelector, pOptions)
	{
		let tmpDefaults = (this._modal && this._modal.options && this._modal.options.DefaultPanelOptions) || {};
		let tmpOptions = Object.assign({},
			{
				position: 'right',
				width: 340,
				minWidth: 200,
				maxWidth: 600,
				collapsible: true,
				collapsed: false,
				persist: false,
				persistKey: '',
				onResize: null,
				onToggle: null
			},
			tmpDefaults,
			pOptions);

		if (typeof document === 'undefined') return this._nullHandle();

		let tmpTarget = document.querySelector(pTargetSelector);
		if (!tmpTarget) return this._nullHandle();

		let tmpId = this._modal._nextId();
		let tmpIsRight = tmpOptions.position === 'right';
		let tmpIsCollapsed = false;
		let tmpCurrentWidth = tmpOptions.width;
		let tmpDestroyed = false;

		// Restore persisted state
		if (tmpOptions.persist && tmpOptions.persistKey)
		{
			try
			{
				let tmpStored = localStorage.getItem('pict-panel-' + tmpOptions.persistKey);
				if (tmpStored)
				{
					let tmpParsed = JSON.parse(tmpStored);
					if (typeof tmpParsed.width === 'number') tmpCurrentWidth = tmpParsed.width;
					if (typeof tmpParsed.collapsed === 'boolean') tmpOptions.collapsed = tmpParsed.collapsed;
				}
			}
			catch (e) { /* ignore */ }
		}

		// Apply classes and initial width
		tmpTarget.classList.add('pict-panel');
		tmpTarget.classList.add(tmpIsRight ? 'pict-panel-right' : 'pict-panel-left');
		tmpTarget.style.width = tmpCurrentWidth + 'px';

		// Remove display:none if present — panel uses width collapse instead
		if (tmpTarget.style.display === 'none')
		{
			tmpTarget.style.display = '';
		}

		// ── Create the edge container ───────────────────────
		let tmpEdge = document.createElement('div');
		tmpEdge.className = 'pict-panel-edge ' + (tmpIsRight ? 'pict-panel-edge-right' : 'pict-panel-edge-left');

		// Resize handle
		let tmpResize = document.createElement('div');
		tmpResize.className = 'pict-panel-resize';
		tmpEdge.appendChild(tmpResize);

		// Collapse tab (chevron SVG)
		let tmpTab = null;
		if (tmpOptions.collapsible)
		{
			tmpTab = document.createElement('div');
			tmpTab.className = 'pict-panel-tab';
			tmpTab.title = 'Toggle panel';
			tmpEdge.appendChild(tmpTab);
		}

		// Insert edge as a sibling so it is not clipped by the
		// panel's own overflow (e.g. overflow-y: auto for scrolling).
		// Right panels: edge goes BEFORE the panel (left side).
		// Left panels: edge goes AFTER the panel (right side).
		if (tmpTarget.parentNode)
		{
			if (tmpIsRight)
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget);
			}
			else
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget.nextSibling);
			}
		}
		else
		{
			tmpTarget.insertBefore(tmpEdge, tmpTarget.firstChild);
		}

		// ── Chevron lookup via pict.providers.Icon ──────────
		// Both directions come from the core registry (`{~I:ChevronLeft~}`
		// / `{~I:ChevronRight~}`).  Resolved per-render so a theme that
		// re-registers the chevron variant picks up automatically.  Empty
		// fallback in the unlikely case pict is missing the Icon provider
		// (very old pict versions; current minimum is 1.0.368).
		let tmpPictHandle = (typeof (window) !== 'undefined' && window.pict) ? window.pict : null;
		let tmpIcon = (pName) => (tmpPictHandle && typeof (tmpPictHandle.icon) === 'function')
			? tmpPictHandle.icon(pName)
			: '';

		let tmpUpdateChevron = () =>
		{
			if (!tmpTab) return;
			let tmpChevronRight = tmpIcon('ChevronRight');
			let tmpChevronLeft  = tmpIcon('ChevronLeft');
			if (tmpIsRight)
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronLeft : tmpChevronRight;
			}
			else
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronRight : tmpChevronLeft;
			}
		};

		// ── Persist helper ──────────────────────────────────
		let tmpPersist = () =>
		{
			if (!tmpOptions.persist || !tmpOptions.persistKey) return;
			try
			{
				localStorage.setItem('pict-panel-' + tmpOptions.persistKey,
					JSON.stringify({ width: tmpCurrentWidth, collapsed: tmpIsCollapsed }));
			}
			catch (e) { /* ignore */ }
		};

		// ── Collapse / expand ───────────────────────────────
		let tmpCollapse = () =>
		{
			if (tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(true);
		};

		let tmpExpand = () =>
		{
			if (!tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = false;
			tmpEdge.classList.remove('pict-panel-edge-collapsed');
			tmpTarget.classList.remove('pict-panel-collapsed');
			tmpTarget.style.width = tmpCurrentWidth + 'px';
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(false);
		};

		let tmpToggle = () =>
		{
			if (tmpIsCollapsed) tmpExpand();
			else tmpCollapse();
		};

		let tmpSetWidth = (pWidth) =>
		{
			if (tmpDestroyed) return;
			let tmpWidth = Math.max(tmpOptions.minWidth, Math.min(tmpOptions.maxWidth, pWidth));
			tmpCurrentWidth = tmpWidth;
			if (!tmpIsCollapsed)
			{
				tmpTarget.style.width = tmpWidth + 'px';
			}
			tmpPersist();
			if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpWidth);
		};

		// ── Tab click ───────────────────────────────────────
		if (tmpTab)
		{
			tmpTab.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpToggle();
			});
		}

		// ── Resize drag ─────────────────────────────────────
		let tmpOnMouseDown = (pEvent) =>
		{
			if (tmpIsCollapsed) return;
			pEvent.preventDefault();

			let tmpStartX = pEvent.clientX;
			let tmpStartWidth = tmpTarget.offsetWidth;

			tmpResize.classList.add('dragging');
			tmpTarget.style.transition = 'none';
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			let tmpOnMouseMove = (pMoveEvent) =>
			{
				let tmpDelta = tmpIsRight
					? (tmpStartX - pMoveEvent.clientX)
					: (pMoveEvent.clientX - tmpStartX);
				let tmpNewWidth = Math.max(tmpOptions.minWidth,
					Math.min(tmpOptions.maxWidth, tmpStartWidth + tmpDelta));
				tmpTarget.style.width = tmpNewWidth + 'px';
			};

			let tmpOnMouseUp = (pUpEvent) =>
			{
				document.removeEventListener('mousemove', tmpOnMouseMove);
				document.removeEventListener('mouseup', tmpOnMouseUp);

				tmpResize.classList.remove('dragging');
				tmpTarget.style.transition = '';
				document.body.style.userSelect = '';
				document.body.style.cursor = '';

				// Capture the final width
				tmpCurrentWidth = tmpTarget.offsetWidth;
				tmpPersist();
				if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpCurrentWidth);
			};

			document.addEventListener('mousemove', tmpOnMouseMove);
			document.addEventListener('mouseup', tmpOnMouseUp);
		};

		tmpResize.addEventListener('mousedown', tmpOnMouseDown);

		// ── Initial state ───────────────────────────────────
		tmpUpdateChevron();

		if (tmpOptions.collapsed)
		{
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
		}

		// ── Destroy ─────────────────────────────────────────
		let tmpDestroy = () =>
		{
			if (tmpDestroyed) return;
			tmpDestroyed = true;

			tmpResize.removeEventListener('mousedown', tmpOnMouseDown);
			if (tmpEdge.parentNode) tmpEdge.remove();
			tmpTarget.classList.remove('pict-panel', 'pict-panel-right', 'pict-panel-left', 'pict-panel-collapsed');
			tmpTarget.style.width = '';
			tmpTarget.style.transition = '';

			let tmpIdx = this._panels.indexOf(tmpHandle);
			if (tmpIdx >= 0) this._panels.splice(tmpIdx, 1);
		};

		// ── Return handle ───────────────────────────────────
		let tmpHandle =
		{
			id: tmpId,
			collapse: tmpCollapse,
			expand: tmpExpand,
			toggle: tmpToggle,
			setWidth: tmpSetWidth,
			destroy: tmpDestroy
		};

		this._panels.push(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Return a no-op handle for server-side or missing-element cases.
	 */
	_nullHandle()
	{
		return {
			id: 0,
			collapse: () => {},
			expand: () => {},
			toggle: () => {},
			setWidth: () => {},
			destroy: () => {}
		};
	}

	/**
	 * Destroy all active panels.
	 */
	destroyAll()
	{
		let tmpPanels = this._panels.slice();
		for (let i = 0; i < tmpPanels.length; i++)
		{
			tmpPanels[i].destroy();
		}
	}
}

module.exports = PictModalPanel;

},{}],585:[function(require,module,exports){
/**
 * Pict-Modal-Shell — viewport-managing layout system for top / right /
 * bottom / left panels around a center.
 *
 * # What this is for
 *
 * Most apps grow a chrome of stacked bars: a topbar, sometimes a
 * sub-nav, sometimes a bottom status bar, often a left sidebar, maybe
 * a right inspector. Each one has its own collapse / resize / persist
 * concerns, and apps end up reinventing the layout glue + the chrome
 * controls per-app.
 *
 * The Shell solves this once. The host calls `modal.shell(viewport)`,
 * adds panels in the order they should stack from each edge, and the
 * Shell manages:
 *
 *   - DOM structure (a flex tree wrapping the viewport)
 *   - Layout placement (multiple panels per side, each in registration order)
 *   - Collapse / expand chrome (a thin tab strip when collapsed)
 *   - Resize chrome (drag handle on the inner edge)
 *   - Pinned (in-flow) vs overlay (absolutely-positioned) panels
 *   - Persistence (per-panel collapsed + size, scoped by host or custom key)
 *   - Center destination (the workspace area between all panels)
 *
 * # Usage
 *
 *   let tmpShell = modal.shell('#App-Container', { PersistenceKey: 'my-app' });
 *
 *   tmpShell.addPanel({
 *       Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 60,
 *       ContentDestinationId: 'App-TopBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'statusbar', Side: 'bottom', Mode: 'fixed', Size: 28,
 *       ContentDestinationId: 'App-StatusBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'sidebar', Side: 'left', Mode: 'resizable', Size: 280,
 *       MinSize: 180, MaxSize: 480, Title: 'Modules',
 *       ContentDestinationId: 'App-Sidebar'
 *   });
 *
 *   let tmpCenter = tmpShell.center({ ContentDestinationId: 'App-Workspace' });
 *
 *   // Render into the destinations the same way as any other Pict view.
 *   pict.ContentAssignment.assignContent('#App-Sidebar', tmpHTML);
 *
 * # Panel options
 *
 *   Hash:                 unique id within the shell (auto-generated if omitted).
 *                         Used as the localStorage key suffix and for getPanel().
 *   Side:                 'top' | 'right' | 'bottom' | 'left'.
 *   Mode:                 'fixed' (no chrome), 'collapsible' (collapse tab),
 *                         'resizable' (collapse tab + drag handle).
 *   Position:             'pinned' (default; takes layout space) or 'overlay'
 *                         (absolutely positioned over the center / siblings).
 *   Scope:                'shell' (default) | 'center'.
 *                         When 'shell', the panel mounts in one of the
 *                         outer rows / side stacks (Side decides which).
 *                         When 'center', the panel mounts INSIDE the
 *                         center column instead — useful for bars that
 *                         should align with the content area only, not
 *                         span across the sidebars.  Only Side='top' and
 *                         Side='bottom' are supported with Scope='center'.
 *                         The center auto-switches to a flex-column
 *                         layout so the content destination + inner
 *                         panels stack vertically.
 *   Size:                 initial px (height for top/bottom, width for left/right).
 *                         Default: 200 for sides, 60 for top/bottom.
 *   MinSize, MaxSize:     drag clamp for resizable panels.
 *   Collapsed:            initial state. Persisted state overrides this.
 *   CollapsedSize:        px the panel becomes when collapsed (default 24).
 *   Title:                shown in the collapse tab.
 *   Icon:                 optional inline SVG / HTML for the collapse tab.
 *   ContentDestinationId: id given to the inner content div so the host can
 *                         reach it via #ContentDestinationId selectors.
 *   ContentView:          ViewIdentifier (string) of a registered Pict view
 *                         that owns this panel's content. When set, the
 *                         shell auto-renders the view once at panel creation
 *                         (so the destination is filled before the user
 *                         opens the panel) AND again on every expand
 *                         transition (so freshly-streamed state shows up).
 *                         Centralises the "I created a panel — now I have
 *                         to remember to render the view into it" boilerplate.
 *   Persist:              default true; pass false to skip save/load for this
 *                         panel even when the shell has persistence enabled.
 *   Hidden:               default false. When true, the collapsed state has
 *                         NO visible chrome — no collapse tab, no edge
 *                         affordance, the panel root is display: none. The
 *                         only way to reveal it is a programmatic
 *                         expand()/toggle() from elsewhere (e.g. a topbar
 *                         gear). Mode still controls the EXPANDED chrome —
 *                         pass Mode: 'resizable' to keep the drag handle
 *                         while open, then vanish on collapse.
 *   OnExpand, OnCollapse: callbacks that fire ONLY on transitions
 *                         (collapsed→expanded or expanded→collapsed).
 *                         Cleaner than OnToggle which fires for both
 *                         directions and forces callers to inspect the
 *                         bool. OnToggle is kept for back-compat.
 *
 * # Persistence
 *
 *   Storage key:  'pict-modal-shell:' + <PersistenceKey or hostname or 'default'>
 *   Value shape:  { Version: 1, Panels: { <hash>: { Collapsed: bool, Size: number } } }
 */

const STORAGE_PREFIX = 'pict-modal-shell:';
const SCHEMA_VERSION = 1;
const DEFAULT_COLLAPSED_SIZE = 24;
const DEFAULT_SIZE_SIDE = 240;
const DEFAULT_SIZE_TOPBOTTOM = 60;

class PictModalShell
{
	constructor(pModalSection, pViewportEl, pOptions)
	{
		this._modal = pModalSection;
		this._viewport = pViewportEl;
		this._options = pOptions || {};
		this._panels = [];
		this._panelsByHash = {};
		this._centerDestinationEl = null;
		this._idCounter = 0;
		this._activeDrag = null;
		this._persistenceEnabled = (this._options.Persistence !== false);
		this._persistenceKey = this._persistenceEnabled
			? this._resolvePersistenceKey(this._options.PersistenceKey)
			: null;

		// Build the wrapper DOM inside the viewport.
		this._buildSkeleton();
	}

	// ────────────────────────────────────────────────────────────────
	//  Public API
	// ────────────────────────────────────────────────────────────────

	addPanel(pConfig)
	{
		let tmpPanel = new ShellPanel(this, pConfig || {});
		this._panels.push(tmpPanel);
		this._panelsByHash[tmpPanel.Hash] = tmpPanel;
		this._mountPanel(tmpPanel);
		// Render the bound ContentView once now so the destination has
		// content even before the user opens the panel. This is the
		// "create" half of the unified create-and-popup pattern — hosts
		// no longer need to chase down each panel and call view.render()
		// manually after addPanel().
		tmpPanel._renderContentView();
		return tmpPanel;
	}

	getPanel(pHash) { return this._panelsByHash[pHash] || null; }

	getPanels() { return this._panels.slice(); }

	/**
	 * Convenience for cross-view popup triggers. Equivalent to
	 * `shell.getPanel(hash).popup()`. Silently no-ops when the hash
	 * doesn't match a registered panel (so callers don't have to
	 * null-check during boot races).
	 */
	openPanel(pHash)
	{
		let tmpPanel = this._panelsByHash[pHash];
		if (tmpPanel) { tmpPanel.popup(); }
		return tmpPanel || null;
	}

	/**
	 * Configure the center area. Optional; if never called, the center
	 * still exists but has no host-supplied destination id (host can
	 * still reach it via .pict-modal-shell-center).
	 */
	center(pOptions)
	{
		pOptions = pOptions || {};
		if (pOptions.ContentDestinationId)
		{
			// Remove any previously-created destination so center() is
			// idempotent across reconfigurations.  We don't blow away
			// the whole center via innerHTML='' anymore: Scope:'center'
			// panels mounted by earlier addPanel() calls need to stay
			// in place.  Find the right insertion point so the
			// destination sits between any top-scoped panels and any
			// bottom-scoped panels.
			if (this._centerDestinationEl && this._centerDestinationEl.parentNode === this._centerEl)
			{
				this._centerEl.removeChild(this._centerDestinationEl);
			}
			let tmpInner = document.createElement('div');
			tmpInner.id = pOptions.ContentDestinationId;
			tmpInner.className = 'pict-modal-shell-center-content';
			let tmpFirstBottomScoped = null;
			let tmpChildren = this._centerEl.children;
			for (let i = 0; i < tmpChildren.length; i++)
			{
				let tmpCandidate = tmpChildren[i];
				if (tmpCandidate.classList && tmpCandidate.classList.contains('pict-modal-shell-panel-bottom'))
				{
					tmpFirstBottomScoped = tmpCandidate;
					break;
				}
			}
			if (tmpFirstBottomScoped)
			{
				this._centerEl.insertBefore(tmpInner, tmpFirstBottomScoped);
			}
			else
			{
				this._centerEl.appendChild(tmpInner);
			}
			this._centerDestinationEl = tmpInner;
		}
		return this._centerEl;
	}

	getCenterEl() { return this._centerEl; }

	destroy()
	{
		for (let i = 0; i < this._panels.length; i++) { this._panels[i].destroy(true); }
		this._panels = [];
		this._panelsByHash = {};
		if (this._wrapperEl && this._wrapperEl.parentNode)
		{
			this._wrapperEl.parentNode.removeChild(this._wrapperEl);
		}
		this._detachDragHandlers();
	}

	// ────────────────────────────────────────────────────────────────
	//  Persistence
	// ────────────────────────────────────────────────────────────────

	_resolvePersistenceKey(pUserKey)
	{
		if (typeof pUserKey === 'string' && pUserKey.length > 0) return STORAGE_PREFIX + pUserKey;
		try
		{
			if (typeof window !== 'undefined' && window.location && window.location.hostname)
			{
				return STORAGE_PREFIX + window.location.hostname;
			}
		}
		catch (pErr) { /* fall through */ }
		return STORAGE_PREFIX + 'default';
	}

	_loadState()
	{
		if (!this._persistenceKey) return null;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return null;
			let tmpRaw = tmpStore.getItem(this._persistenceKey);
			if (!tmpRaw) return null;
			let tmpParsed = JSON.parse(tmpRaw);
			if (!tmpParsed || tmpParsed.Version !== SCHEMA_VERSION) return null;
			return (tmpParsed.Panels && typeof tmpParsed.Panels === 'object') ? tmpParsed.Panels : {};
		}
		catch (pErr) { return null; }
	}

	_loadPanelState(pHash)
	{
		let tmpAll = this._loadState();
		if (!tmpAll) return null;
		return tmpAll[pHash] || null;
	}

	_savePanelState(pHash, pState)
	{
		if (!this._persistenceKey) return;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return;
			let tmpAll = this._loadState() || {};
			tmpAll[pHash] = pState;
			tmpStore.setItem(this._persistenceKey, JSON.stringify(
			{
				Version: SCHEMA_VERSION,
				Panels: tmpAll,
				SavedAt: new Date().toISOString()
			}));
		}
		catch (pErr) { /* swallow */ }
	}

	// ────────────────────────────────────────────────────────────────
	//  DOM scaffolding
	// ────────────────────────────────────────────────────────────────

	_buildSkeleton()
	{
		// Wipe whatever was inside the viewport — the host opted into
		// the shell taking ownership of layout.
		this._viewport.innerHTML = '';
		this._viewport.classList.add('pict-modal-shell-host');

		this._wrapperEl = document.createElement('div');
		this._wrapperEl.className = 'pict-modal-shell';

		this._topRow = document.createElement('div');
		this._topRow.className = 'pict-modal-shell-row pict-modal-shell-row-top';
		this._wrapperEl.appendChild(this._topRow);

		this._middleRow = document.createElement('div');
		this._middleRow.className = 'pict-modal-shell-row pict-modal-shell-row-middle';
		this._wrapperEl.appendChild(this._middleRow);

		this._leftStack = document.createElement('div');
		this._leftStack.className = 'pict-modal-shell-side pict-modal-shell-side-left';
		this._middleRow.appendChild(this._leftStack);

		this._centerEl = document.createElement('div');
		this._centerEl.className = 'pict-modal-shell-center';
		this._middleRow.appendChild(this._centerEl);

		this._rightStack = document.createElement('div');
		this._rightStack.className = 'pict-modal-shell-side pict-modal-shell-side-right';
		this._middleRow.appendChild(this._rightStack);

		this._bottomRow = document.createElement('div');
		this._bottomRow.className = 'pict-modal-shell-row pict-modal-shell-row-bottom';
		this._wrapperEl.appendChild(this._bottomRow);

		// Overlay layer for overlay-position panels (absolute over middle row)
		this._overlayLayer = document.createElement('div');
		this._overlayLayer.className = 'pict-modal-shell-overlay-layer';
		this._middleRow.appendChild(this._overlayLayer);

		this._viewport.appendChild(this._wrapperEl);
	}

	_mountPanel(pPanel)
	{
		if (pPanel.Position === 'overlay')
		{
			this._overlayLayer.appendChild(pPanel.El);
			return;
		}
		if (pPanel.Scope === 'center')
		{
			// Center-scoped panels mount inside the center column.
			// The column switches to flex-column so the content
			// destination + the panel(s) stack vertically.
			this._centerEl.classList.add('pict-modal-shell-center-with-inner-panel');
			if (pPanel.Side === 'top')
			{
				// Top-scoped panels go above the content destination.
				// If center() hasn't run yet, this still works — we
				// insert before whatever's first (or just append to an
				// empty center, which leaves us above any subsequent
				// content destination).
				this._centerEl.insertBefore(pPanel.El, this._centerEl.firstChild);
			}
			else
			{
				// Side === 'bottom' (the Scope guard already filtered
				// left/right).  Append to the bottom of the center.
				this._centerEl.appendChild(pPanel.El);
			}
			return;
		}
		let tmpHost;
		if      (pPanel.Side === 'top')    tmpHost = this._topRow;
		else if (pPanel.Side === 'bottom') tmpHost = this._bottomRow;
		else if (pPanel.Side === 'left')   tmpHost = this._leftStack;
		else if (pPanel.Side === 'right')  tmpHost = this._rightStack;
		else                               tmpHost = this._wrapperEl;
		tmpHost.appendChild(pPanel.El);
	}

	// ────────────────────────────────────────────────────────────────
	//  Drag (resize) machinery — shared across all resizable panels.
	// ────────────────────────────────────────────────────────────────

	_attachDragStart(pPanel, pEvent)
	{
		pEvent.preventDefault();
		let tmpAxis = (pPanel.Side === 'top' || pPanel.Side === 'bottom') ? 'y' : 'x';
		this._activeDrag =
		{
			Panel:       pPanel,
			Axis:        tmpAxis,
			StartCoord:  (tmpAxis === 'x') ? pEvent.clientX : pEvent.clientY,
			StartSize:   pPanel.Size,
			Direction:   (pPanel.Side === 'left' || pPanel.Side === 'top') ? 1 : -1,
			PendingSize: null,
			RAFId:       0
		};
		document.body.classList.add(tmpAxis === 'x' ? 'pict-modal-shell-dragging-x' : 'pict-modal-shell-dragging-y');
		// Suppress the panel's collapse/expand width/height transition for
		// the duration of the drag — without this, every pointermove kicks
		// off a fresh 140ms transition that stacks up and renders the
		// resize as visibly laggy ("choppy"). With the transition off the
		// panel snaps to each new size in the same frame as the pointer.
		pPanel.El.classList.add('pict-modal-shell-panel-resizing');
		// Capture the pointer so dragging works even when the cursor leaves
		// the resize handle (otherwise the user has to keep the cursor
		// exactly on the 6 px strip — feels twitchy).
		try { pEvent.target.setPointerCapture && pEvent.target.setPointerCapture(pEvent.pointerId); }
		catch (pErr) { /* not supported in old browsers — fine */ }
		document.addEventListener('pointermove', this._onDragMove);
		document.addEventListener('pointerup',   this._onDragEnd);
	}

	// Pointer events fire at the device's input rate (often 240 Hz+ on
	// modern trackpads / mice) but we only paint at the display's refresh
	// rate (60–120 Hz). Coalesce multiple pointermoves per frame into a
	// single setSize() call via requestAnimationFrame — this drops the
	// per-frame work to one DOM mutation regardless of pointer rate.
	_onDragMove = (pEvent) =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		let tmpCoord = (tmpD.Axis === 'x') ? pEvent.clientX : pEvent.clientY;
		let tmpDelta = (tmpCoord - tmpD.StartCoord) * tmpD.Direction;
		tmpD.PendingSize = tmpD.StartSize + tmpDelta;
		if (!tmpD.RAFId)
		{
			let tmpSelf = this;
			tmpD.RAFId = (typeof window !== 'undefined' && window.requestAnimationFrame)
				? window.requestAnimationFrame(function () { tmpSelf._flushDrag(); })
				: setTimeout(function () { tmpSelf._flushDrag(); }, 16);
		}
	};

	_flushDrag()
	{
		let tmpD = this._activeDrag;
		if (!tmpD) return;
		tmpD.RAFId = 0;
		if (tmpD.PendingSize !== null)
		{
			tmpD.Panel.setSize(tmpD.PendingSize);
			tmpD.PendingSize = null;
		}
	}

	_onDragEnd = () =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		// Flush any pending pointermove that hadn't painted yet so the
		// final size matches the actual cursor position, not the last
		// rAF-aligned value.
		if (tmpD.PendingSize !== null) { this._flushDrag(); }
		if (tmpD.RAFId && typeof window !== 'undefined' && window.cancelAnimationFrame)
		{
			window.cancelAnimationFrame(tmpD.RAFId);
		}
		document.body.classList.remove('pict-modal-shell-dragging-x');
		document.body.classList.remove('pict-modal-shell-dragging-y');
		tmpD.Panel.El.classList.remove('pict-modal-shell-panel-resizing');
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
		// Persist final size.
		tmpD.Panel._persist();
		this._activeDrag = null;
	};

	_detachDragHandlers()
	{
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
	}
}

// ════════════════════════════════════════════════════════════════════
//  ShellPanel — one panel within a Shell
// ════════════════════════════════════════════════════════════════════

class ShellPanel
{
	constructor(pShell, pConfig)
	{
		this._shell = pShell;
		this._config = pConfig;

		this.Hash = pConfig.Hash || ('panel-' + ++pShell._idCounter);
		this.Side = (pConfig.Side === 'right' || pConfig.Side === 'bottom' || pConfig.Side === 'left') ? pConfig.Side : 'top';
		this.Mode = (pConfig.Mode === 'collapsible' || pConfig.Mode === 'resizable') ? pConfig.Mode : 'fixed';
		this.Position = (pConfig.Position === 'overlay') ? 'overlay' : 'pinned';
		// Scope: 'center' opts the panel into the center column instead
		// of the shell's outer rows.  Only valid for Side='top'/'bottom'
		// (left/right inside center would need a separate axis we don't
		// support).  Invalid combinations silently fall back to 'shell'.
		this.Scope = (pConfig.Scope === 'center'
				&& (this.Side === 'top' || this.Side === 'bottom'))
			? 'center'
			: 'shell';
		this.Title = pConfig.Title || '';
		this.Icon  = pConfig.Icon  || '';
		this.MinSize = (typeof pConfig.MinSize === 'number') ? pConfig.MinSize : 40;
		this.MaxSize = (typeof pConfig.MaxSize === 'number') ? pConfig.MaxSize : 1200;
		// `Hidden: true` is a panel that has NO visible chrome in its collapsed
		// state — no collapse tab sliver, no resize handle, no edge marker, and
		// (via CSS) display: none on the panel root. The only way to reveal it
		// is a programmatic expand()/toggle() called from elsewhere in the app
		// (e.g. a gear button in the topbar). Useful when the host wants a
		// fully-shaped panel but doesn't want an always-visible affordance for
		// discovering it. The Mode is still honoured for the EXPANDED state —
		// pass Mode: 'resizable' to keep the drag handle while the panel is
		// open, while still vanishing entirely when collapsed.
		this.Hidden = !!pConfig.Hidden;
		this.CollapsedSize = (typeof pConfig.CollapsedSize === 'number')
			? pConfig.CollapsedSize
			: (this.Hidden ? 0 : DEFAULT_COLLAPSED_SIZE);
		this.PersistEnabled = pShell._persistenceEnabled && (pConfig.Persist !== false);

		let tmpDefaultSize = (this.Side === 'left' || this.Side === 'right') ? DEFAULT_SIZE_SIDE : DEFAULT_SIZE_TOPBOTTOM;
		this.Size = (typeof pConfig.Size === 'number') ? pConfig.Size : tmpDefaultSize;
		this.Collapsed = !!pConfig.Collapsed;

		// Persisted state overrides initial Size/Collapsed.
		if (this.PersistEnabled)
		{
			let tmpSaved = pShell._loadPanelState(this.Hash);
			if (tmpSaved)
			{
				if (typeof tmpSaved.Size === 'number') this.Size = tmpSaved.Size;
				if (typeof tmpSaved.Collapsed === 'boolean') this.Collapsed = tmpSaved.Collapsed;
			}
		}
		this._clampSize();

		// Build the panel DOM.
		this._buildEl(pConfig);
		this._applySize();
		this._applyCollapsedClass();

		// Responsive drawer — at narrow viewports, flip a docked side
		// panel into a "top drawer" by adding a class to the middle row
		// that toggles flex-direction from row to column. The panel
		// stretches to full width and trades its inline `width` for a
		// configurable drawer `height`. The user's collapse/expand
		// keeps working: collapsed in drawer mode just gives the panel
		// height: 0 (so only the collapse tab remains visible at the
		// top of the content), expanded restores the drawer height.
		// Pass `0` or omit to disable. Mirrors retold-remote's
		// `.content-editor-body { flex-direction: column }` pattern.
		this.ResponsiveDrawer = (typeof pConfig.ResponsiveDrawer === 'number'
			&& pConfig.ResponsiveDrawer > 0)
				? pConfig.ResponsiveDrawer : 0;
		// Drawer height — applied as `height` to the panel in drawer
		// mode. CSS units (px / vh / %) accepted. Default 33vh which
		// gives the panel roughly a third of the viewport height and
		// leaves comfortable room for the workspace below.
		this.DrawerHeight = (typeof pConfig.DrawerHeight === 'string' && pConfig.DrawerHeight)
			? pConfig.DrawerHeight : '33vh';
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
		if (this.ResponsiveDrawer > 0)
		{
			this._wireResponsiveDrawer();
		}
	}

	// ───────────── public ─────────────

	getContentEl() { return this._contentEl; }

	/**
	 * Returns the currently-bound ContentView Pict view instance, or
	 * null if no ContentView is configured / the view isn't registered
	 * yet.
	 */
	getContentView()
	{
		if (!this._config.ContentView) return null;
		let tmpPict = this._shell._modal && this._shell._modal.pict;
		if (!tmpPict || !tmpPict.views) return null;
		return tmpPict.views[this._config.ContentView] || null;
	}

	collapse() { this._setCollapsed(true);  }
	expand()   { this._setCollapsed(false); }
	toggle()   { this._setCollapsed(!this.Collapsed); }

	/**
	 * Unified "show this panel" affordance — this is the shared
	 * codepath every popup trigger should funnel through. Behavior:
	 *
	 *   - If collapsed → expand (which fires OnExpand + re-renders the
	 *     ContentView via the shared transition machinery).
	 *   - If already open → re-render the ContentView (so any newly-
	 *     streamed state is visible) AND briefly flash the panel
	 *     border so the user notices that the existing panel just
	 *     received attention. Avoids the "I clicked a button but
	 *     nothing happened" feeling when the panel was already open.
	 *
	 * Idempotent — safe to call from any number of triggers without
	 * stacking effects.
	 */
	popup()
	{
		if (this.Collapsed)
		{
			this._setCollapsed(false);
		}
		else
		{
			// Already open — refresh content + flash for attention.
			this._renderContentView();
			this._flash();
		}
	}

	setSize(pSize)
	{
		if (typeof pSize !== 'number' || !isFinite(pSize)) return;
		this.Size = pSize;
		this._clampSize();
		this._applySize();
	}

	destroy(pSkipFromShell)
	{
		this._unwireResponsiveDrawer();
		if (this.El && this.El.parentNode) this.El.parentNode.removeChild(this.El);
		if (!pSkipFromShell)
		{
			let tmpIdx = this._shell._panels.indexOf(this);
			if (tmpIdx >= 0) this._shell._panels.splice(tmpIdx, 1);
			delete this._shell._panelsByHash[this.Hash];
		}
	}

	// ───────────── internals ─────────────

	_clampSize()
	{
		if (this.Size < this.MinSize) this.Size = this.MinSize;
		if (this.Size > this.MaxSize) this.Size = this.MaxSize;
	}

	// Responsive drawer — sets up a matchMedia listener for
	// `(max-width: <ResponsiveDrawer>px)`. Each crossing flips the
	// shell's middle row between row layout (wide) and column layout
	// (narrow) by toggling the `pict-modal-shell-drawer-active` class
	// on the middle row. The matching CSS makes side panels expand to
	// full width with a fixed `DrawerHeight`, becoming top/bottom
	// drawers above/below the workspace center. Collapsed in drawer
	// mode collapses to height: 0, leaving only the collapse tab.
	//
	// This pattern is the conventional "responsive sidebar" approach
	// (used by retold-remote's content editor) — the user keeps their
	// sidebar accessible at narrow widths but it gives the workspace
	// room to breathe.
	_wireResponsiveDrawer()
	{
		if (typeof window === 'undefined' || !window.matchMedia) return;

		this._mediaQuery = window.matchMedia('(max-width: ' + this.ResponsiveDrawer + 'px)');

		// Apply the drawer height as a CSS variable on the panel
		// element so the static CSS rules can read it. Doing this once
		// here avoids per-event JS style writes.
		if (this.El) { this.El.style.setProperty('--pict-modal-drawer-height', this.DrawerHeight); }

		let tmpSelf = this;
		this._mediaQueryHandler = function (pEvent)
		{
			let tmpNarrow = (pEvent && typeof pEvent.matches === 'boolean')
				? pEvent.matches
				: tmpSelf._mediaQuery.matches;
			tmpSelf._setDrawerMode(tmpNarrow);
		};

		// Apply the current state immediately (handles the case where the
		// page loads already-narrow). Newer browsers use addEventListener;
		// older ones use addListener.
		if (this._mediaQuery.addEventListener)
		{
			this._mediaQuery.addEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.addListener)
		{
			this._mediaQuery.addListener(this._mediaQueryHandler);
		}
		this._mediaQueryHandler({ matches: this._mediaQuery.matches });

		// Belt + suspenders: also listen to window resize and re-sync.
		// `matchMedia.change` is supposed to be reliable on every
		// boundary crossing, but in real-world testing (esp. when the
		// user is dragging DevTools to resize the inner viewport, or
		// going through fast successive crossings) we've seen the
		// change event silently miss. A plain resize listener is
		// cheap and the handler is idempotent — if matches state
		// hasn't actually changed the body of `_setDrawerMode` is a
		// no-op (it short-circuits when classes are already correct).
		this._resizeHandler = function ()
		{
			tmpSelf._setDrawerMode(tmpSelf._mediaQuery.matches);
		};
		window.addEventListener('resize', this._resizeHandler);
	}

	_unwireResponsiveDrawer()
	{
		if (this._resizeHandler && typeof window !== 'undefined')
		{
			window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (!this._mediaQuery || !this._mediaQueryHandler) return;
		if (this._mediaQuery.removeEventListener)
		{
			this._mediaQuery.removeEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.removeListener)
		{
			this._mediaQuery.removeListener(this._mediaQueryHandler);
		}
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
	}

	// Toggle drawer mode by adding / removing a class on the shell's
	// middle row. The CSS rule for `.pict-modal-shell-drawer-active`
	// flips flex-direction column, makes side panels full-width, and
	// applies the panel's `--pict-modal-drawer-height` for sizing.
	// Also tags the panel itself so per-panel CSS can target it.
	// Re-applies the inline size at the end so the wide-mode crossing
	// gets a clean width back (drawer mode forced width: 100% via CSS
	// !important; the inline style was stale).
	_setDrawerMode(pDrawer)
	{
		if (!this._shell || !this._shell._middleRow) return;
		// Idempotent — short-circuit when the panel's drawer state
		// already matches the target. Keeps the resize-event fallback
		// (which fires constantly during drag-resize) from doing
		// pointless DOM thrash + style re-application every frame.
		let tmpCurrentlyDrawer = !!(this.El
			&& this.El.classList.contains('pict-modal-shell-panel-drawer'));
		if (tmpCurrentlyDrawer === !!pDrawer) return;
		if (pDrawer)
		{
			this._shell._middleRow.classList.add('pict-modal-shell-drawer-active');
			if (this.El) { this.El.classList.add('pict-modal-shell-panel-drawer'); }
		}
		else
		{
			// Only remove the row-level class if NO other panel still
			// wants drawer mode. Multi-panel hosts can safely each opt
			// in independently this way.
			let tmpStillNarrow = false;
			let tmpPanels = this._shell._panels || [];
			for (let i = 0; i < tmpPanels.length; i++)
			{
				let tmpP = tmpPanels[i];
				if (tmpP !== this
					&& tmpP._mediaQuery
					&& tmpP._mediaQuery.matches
					&& tmpP.ResponsiveDrawer > 0)
				{
					tmpStillNarrow = true;
					break;
				}
			}
			if (!tmpStillNarrow)
			{
				this._shell._middleRow.classList.remove('pict-modal-shell-drawer-active');
			}
			if (this.El) { this.El.classList.remove('pict-modal-shell-panel-drawer'); }
		}
		// Re-apply inline size. In drawer mode the CSS !important
		// rule overrides this anyway, but on the wide crossing we
		// need the inline width to be correct so the panel shows up
		// at its proper docked / collapsed-docked size rather than
		// inheriting any stale state.
		this._applySize();
	}

	_buildEl(pConfig)
	{
		let tmpRoot = document.createElement('div');
		tmpRoot.className = 'pict-modal-shell-panel pict-modal-shell-panel-' + this.Side
			+ ' pict-modal-shell-panel-mode-' + this.Mode
			+ (this.Position === 'overlay' ? ' pict-modal-shell-panel-overlay' : '')
			+ (this.Hidden ? ' pict-modal-shell-panel-hidden' : '');
		tmpRoot.setAttribute('data-shell-panel-hash', this.Hash);
		tmpRoot.setAttribute('data-shell-panel-side', this.Side);
		tmpRoot.setAttribute('data-shell-panel-mode', this.Mode);

		// Content area — hosts render their stuff into the inner #id div.
		let tmpContentWrap = document.createElement('div');
		tmpContentWrap.className = 'pict-modal-shell-panel-content';
		this._contentEl = document.createElement('div');
		if (pConfig.ContentDestinationId)
		{
			this._contentEl.id = pConfig.ContentDestinationId;
		}
		this._contentEl.className = 'pict-modal-shell-panel-content-inner';
		tmpContentWrap.appendChild(this._contentEl);
		tmpRoot.appendChild(tmpContentWrap);

		// Collapse tab — shown when collapsible / resizable. Lives at the
		// inner edge so it's always reachable when the panel is collapsed.
		// Hidden panels skip the tab entirely — the only path back from
		// collapsed → expanded is a programmatic expand() / toggle() call
		// from the host (e.g. a topbar gear button).
		if ((this.Mode === 'collapsible' || this.Mode === 'resizable') && !this.Hidden)
		{
			this._collapseTab = document.createElement('button');
			this._collapseTab.type = 'button';
			this._collapseTab.className = 'pict-modal-shell-panel-collapse-tab';
			this._collapseTab.setAttribute('aria-label',
				(this.Title ? 'Toggle ' + this.Title : 'Toggle panel'));
			this._collapseTab.title = this.Title || 'Toggle';
			this._collapseTab.innerHTML = ''
				+ (this.Icon ? '<span class="pict-modal-shell-panel-collapse-tab-icon">' + this.Icon + '</span>' : '')
				+ (this.Title ? '<span class="pict-modal-shell-panel-collapse-tab-title">' + this._escape(this.Title) + '</span>' : '');
			let tmpSelf = this;
			this._collapseTab.addEventListener('click', function () { tmpSelf.toggle(); });
			tmpRoot.appendChild(this._collapseTab);
		}

		// Resize handle — only when resizable. Positioned via CSS based
		// on side.
		if (this.Mode === 'resizable')
		{
			this._resizeHandle = document.createElement('div');
			this._resizeHandle.className = 'pict-modal-shell-panel-resize-handle';
			this._resizeHandle.setAttribute('aria-hidden', 'true');
			let tmpSelf = this;
			this._resizeHandle.addEventListener('pointerdown', function (pEvent)
			{
				if (tmpSelf.Collapsed) return;
				tmpSelf._shell._attachDragStart(tmpSelf, pEvent);
			});
			tmpRoot.appendChild(this._resizeHandle);
		}

		this.El = tmpRoot;
	}

	_applySize()
	{
		let tmpEffective = this.Collapsed ? this.CollapsedSize : this.Size;
		if (this.Side === 'left' || this.Side === 'right')
		{
			this.El.style.width = tmpEffective + 'px';
			this.El.style.height = '';
		}
		else
		{
			this.El.style.height = tmpEffective + 'px';
			this.El.style.width = '';
		}
	}

	_applyCollapsedClass()
	{
		if (this.Collapsed) this.El.classList.add('pict-modal-shell-panel-collapsed');
		else this.El.classList.remove('pict-modal-shell-panel-collapsed');
	}

	_setCollapsed(pBool)
	{
		if (this.Collapsed === !!pBool) return;
		let tmpWasCollapsed = this.Collapsed;
		this.Collapsed = !!pBool;
		this._applyCollapsedClass();
		this._applySize();
		this._persist();

		// Transition-specific hooks fire BEFORE OnToggle so OnExpand
		// callers can mutate state (e.g. set focus, re-fetch data) and
		// have it reflected by any OnToggle observer that runs after.
		if (tmpWasCollapsed && !this.Collapsed)
		{
			// collapsed → expanded. Render the bound ContentView so
			// freshly-streamed state shows up the moment the panel
			// becomes visible (replaces the manual view.render() dance
			// hosts used to do in their own runAction-style helpers).
			this._renderContentView();
			this._fireHook('OnExpand');
		}
		else if (!tmpWasCollapsed && this.Collapsed)
		{
			this._fireHook('OnCollapse');
		}

		// Back-compat: OnToggle still fires for both directions.
		this._fireHook('OnToggle', this.Collapsed);
	}

	_fireHook(pName, pArg)
	{
		let tmpFn = this._config[pName];
		if (typeof tmpFn !== 'function') return;
		try
		{
			if (typeof pArg !== 'undefined') { tmpFn(pArg, this); }
			else                             { tmpFn(this); }
		}
		catch (pErr) { /* host hook failure must not break the panel */ }
	}

	/**
	 * Render the bound ContentView (if any) into this panel's
	 * destination. Called by the shell on panel creation + on every
	 * collapsed→expanded transition + by popup() when re-flashing an
	 * already-open panel. Silently no-ops when no ContentView is
	 * configured or the view isn't registered yet (boot races).
	 */
	_renderContentView()
	{
		let tmpView = this.getContentView();
		if (tmpView && typeof tmpView.render === 'function')
		{
			try { tmpView.render(); }
			catch (pErr) { /* view render failure shouldn't break the panel chrome */ }
		}
	}

	/**
	 * Briefly highlight the panel — used by popup() when called on an
	 * already-open panel so the user sees that their click landed.
	 * The class is removed after the CSS animation completes; safe to
	 * re-trigger (timeouts overlap, last one wins on the trailing edge).
	 */
	_flash()
	{
		if (!this.El) return;
		this.El.classList.add('pict-modal-shell-panel-flash');
		let tmpSelf = this;
		clearTimeout(this._flashTimer);
		this._flashTimer = setTimeout(function ()
		{
			if (tmpSelf.El) tmpSelf.El.classList.remove('pict-modal-shell-panel-flash');
		}, 700);
	}

	_persist()
	{
		if (!this.PersistEnabled) return;
		this._shell._savePanelState(this.Hash,
		{
			Collapsed: this.Collapsed,
			Size: this.Size
		});
	}

	_escape(pStr)
	{
		return String(pStr || '')
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

// ════════════════════════════════════════════════════════════════════
//  Module exports — used internally by Pict-Section-Modal.shell()
// ════════════════════════════════════════════════════════════════════

class PictModalShellManager
{
	constructor(pModalSection)
	{
		this._modal = pModalSection;
		this._shellsByViewport = new WeakMap();
	}

	/**
	 * Idempotent — calling shell() twice with the same viewport returns
	 * the same instance.
	 */
	shell(pViewportSelectorOrEl, pOptions)
	{
		let tmpEl = (typeof pViewportSelectorOrEl === 'string')
			? document.querySelector(pViewportSelectorOrEl)
			: pViewportSelectorOrEl;
		if (!tmpEl)
		{
			throw new Error('Pict-Modal-Shell.shell: viewport not found for ' + pViewportSelectorOrEl);
		}
		let tmpExisting = this._shellsByViewport.get(tmpEl);
		if (tmpExisting) return tmpExisting;
		let tmpShell = new PictModalShell(this._modal, tmpEl, pOptions);
		this._shellsByViewport.set(tmpEl, tmpShell);
		return tmpShell;
	}
}

module.exports = PictModalShellManager;
module.exports.PictModalShell = PictModalShell;
module.exports.ShellPanel = ShellPanel;
module.exports.STORAGE_PREFIX = STORAGE_PREFIX;
module.exports.SCHEMA_VERSION = SCHEMA_VERSION;

},{}],586:[function(require,module,exports){
/**
 * Pict-Modal-Toast
 *
 * Manages toast notification elements with auto-dismiss and stacking.
 */
class PictModalToast
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._containers = {};
	}

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message text
	 * @param {object} [pOptions] - Options (type, duration, position, dismissible, allowHTML)
	 * @param {boolean} [pOptions.allowHTML=false] - When true, render pMessage as raw HTML instead of escaping it. Only pass trusted markup.
	 * @returns {{ dismiss: function }} Handle with dismiss method
	 */
	toast(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultToastOptions, pOptions);
		let tmpContainer = this._getContainer(tmpOptions.position);
		let tmpId = this._modal._nextId();

		let tmpToast = document.createElement('div');
		tmpToast.className = 'pict-modal-toast pict-modal-toast--' + tmpOptions.type;
		tmpToast.id = 'pict-modal-toast-' + tmpId;

		// Escape by default; render raw markup only when the caller opts in with allowHTML (trusted content).
		let tmpMessageMarkup = (tmpOptions.allowHTML === true) ? pMessage : this._escapeHTML(pMessage);
		let tmpContent = '<span class="pict-modal-toast-message">' + tmpMessageMarkup + '</span>';

		if (tmpOptions.dismissible)
		{
			tmpContent += '<button class="pict-modal-toast-dismiss" aria-label="Dismiss">&times;</button>';
		}

		tmpToast.innerHTML = tmpContent;

		// Create handle
		let tmpDismissed = false;
		let tmpTimeoutHandle = null;

		let tmpDismiss = () =>
		{
			if (tmpDismissed)
			{
				return;
			}
			tmpDismissed = true;

			if (tmpTimeoutHandle)
			{
				clearTimeout(tmpTimeoutHandle);
			}

			// Exit animation
			tmpToast.classList.remove('pict-modal-visible');
			tmpToast.classList.add('pict-modal-toast-exit');

			// Remove from active list
			this._modal._activeToasts = this._modal._activeToasts.filter(
				(pEntry) => { return pEntry.element !== tmpToast; }
			);

			// Remove from DOM after transition
			setTimeout(() =>
			{
				if (tmpToast.parentNode)
				{
					tmpToast.parentNode.removeChild(tmpToast);
				}
				this._cleanupContainer(tmpOptions.position);
			}, 220);
		};

		let tmpHandle = { dismiss: tmpDismiss };

		// Wire dismiss button
		if (tmpOptions.dismissible)
		{
			let tmpDismissBtn = tmpToast.querySelector('.pict-modal-toast-dismiss');
			if (tmpDismissBtn)
			{
				tmpDismissBtn.addEventListener('click', tmpDismiss);
			}
		}

		// Append to container
		tmpContainer.appendChild(tmpToast);

		// Track
		let tmpEntry =
		{
			element: tmpToast,
			dismiss: tmpDismiss,
			handle: tmpHandle
		};
		this._modal._activeToasts.push(tmpEntry);

		// Animate in
		void tmpToast.offsetHeight;
		tmpToast.classList.add('pict-modal-visible');

		// Auto-dismiss
		if (tmpOptions.duration > 0)
		{
			tmpTimeoutHandle = setTimeout(tmpDismiss, tmpOptions.duration);
		}

		return tmpHandle;
	}

	/**
	 * Get or create a toast container for the given position.
	 *
	 * @param {string} pPosition - Position key (e.g. 'top-right')
	 * @returns {HTMLElement}
	 */
	_getContainer(pPosition)
	{
		if (this._containers[pPosition])
		{
			return this._containers[pPosition];
		}

		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-modal-toast-container pict-modal-toast-container--' + pPosition;
		document.body.appendChild(tmpContainer);
		this._containers[pPosition] = tmpContainer;

		return tmpContainer;
	}

	/**
	 * Remove a container if it has no more toasts.
	 *
	 * @param {string} pPosition
	 */
	_cleanupContainer(pPosition)
	{
		let tmpContainer = this._containers[pPosition];
		if (tmpContainer && tmpContainer.children.length === 0)
		{
			if (tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
			delete this._containers[pPosition];
		}
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissAll()
	{
		let tmpToasts = this._modal._activeToasts.slice();
		for (let i = 0; i < tmpToasts.length; i++)
		{
			tmpToasts[i].dismiss();
		}
	}

	/**
	 * Destroy all containers.
	 */
	destroy()
	{
		this.dismissAll();
		let tmpPositions = Object.keys(this._containers);
		for (let i = 0; i < tmpPositions.length; i++)
		{
			let tmpContainer = this._containers[tmpPositions[i]];
			if (tmpContainer && tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
		}
		this._containers = {};
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalToast;

},{}],587:[function(require,module,exports){
/**
 * Pict-Modal-Tooltip
 *
 * Manages simple text and rich HTML tooltips with positioning and auto-flip.
 */
class PictModalTooltip
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options (position, delay, maxWidth)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	tooltip(pElement, pText, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pText, false, tmpOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Attach a pinnable rich HTML tooltip to an element.
	 *
	 * Behaves like richTooltip() on hover/focus, but a click on the element
	 * toggles a pinned state: while pinned the tooltip stays open (it does not
	 * hide on mouseleave/focusout) and follows its anchor on scroll/resize.
	 * This is opt-in sugar over richTooltip() with `{ pinnable: true }` — the
	 * default tooltip()/richTooltip() behavior is unchanged.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive, startPinned, onPinChange)
	 * @returns {{ destroy: function, pin: function, unpin: function, isPinned: function }} Handle
	 */
	pinnableTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions, { pinnable: true });
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Internal: attach tooltip event listeners to an element.
	 *
	 * @param {HTMLElement} pElement
	 * @param {string} pContent
	 * @param {boolean} pIsHTML
	 * @param {object} pOptions
	 * @returns {{ destroy: function }}
	 */
	_attachTooltip(pElement, pContent, pIsHTML, pOptions)
	{
		let tmpTooltipElement = null;
		let tmpShowTimeout = null;
		let tmpHideTimeout = null;
		let tmpDestroyed = false;
		let tmpId = this._modal._nextId();

		// Pin state — only meaningful when pOptions.pinnable is set. A pinned
		// tooltip stays visible (transient hide is suppressed) and follows its
		// anchor on scroll/resize.
		let tmpPinned = false;

		let tmpShow = () =>
		{
			if (tmpDestroyed || tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement = document.createElement('div');
			tmpTooltipElement.className = 'pict-modal-tooltip pict-modal-tooltip--' + pOptions.position;
			tmpTooltipElement.id = 'pict-modal-tooltip-' + tmpId;
			tmpTooltipElement.setAttribute('role', 'tooltip');
			tmpTooltipElement.style.maxWidth = pOptions.maxWidth;

			if (pOptions.interactive)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-interactive');
			}

			// Optional consumer-supplied class(es) on the tooltip element, e.g.
			// to theme the bubble + arrow by overriding the --pict-modal-tooltip-*
			// custom properties for a specific tooltip.
			if (pOptions.className)
			{
				let tmpExtraClasses = String(pOptions.className).split(/\s+/);
				for (let i = 0; i < tmpExtraClasses.length; i++)
				{
					if (tmpExtraClasses[i])
					{
						tmpTooltipElement.classList.add(tmpExtraClasses[i]);
					}
				}
			}

			// Arrow
			let tmpArrow = document.createElement('div');
			tmpArrow.className = 'pict-modal-tooltip-arrow';

			// Content
			let tmpContentDiv = document.createElement('div');
			if (pIsHTML)
			{
				tmpContentDiv.innerHTML = pContent;
			}
			else
			{
				tmpContentDiv.textContent = pContent;
			}

			tmpTooltipElement.appendChild(tmpArrow);
			tmpTooltipElement.appendChild(tmpContentDiv);
			document.body.appendChild(tmpTooltipElement);

			// Set aria-describedby on target
			pElement.setAttribute('aria-describedby', tmpTooltipElement.id);

			// Position
			this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);

			// Animate in — but only paint when the anchor is actually rendered.
			// A pinned / startPinned tooltip whose anchor lives in a hidden
			// container (e.g. an inactive tab panel) would otherwise show at the
			// clamped corner as an orphan. It is revealed later by tmpReposition
			// once the anchor gains a layout box (see the ResizeObserver below).
			void tmpTooltipElement.offsetHeight;
			if (this._isElementRendered(pElement))
			{
				tmpTooltipElement.classList.add('pict-modal-visible');
			}

			// Track
			this._modal._activeTooltips.push(
			{
				element: tmpTooltipElement,
				targetElement: pElement,
				destroy: tmpDestroy
			});

			// For interactive tooltips, allow hovering over the tooltip itself
			if (pOptions.interactive && tmpTooltipElement)
			{
				tmpTooltipElement.addEventListener('mouseenter', () =>
				{
					if (tmpHideTimeout)
					{
						clearTimeout(tmpHideTimeout);
						tmpHideTimeout = null;
					}
				});
				tmpTooltipElement.addEventListener('mouseleave', () =>
				{
					if (!tmpPinned)
					{
						tmpHide();
					}
				});
			}

			// Reflect pinned state on a freshly-(re)created element.
			if (tmpPinned && tmpTooltipElement)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-pinned');
			}
		};

		let tmpHide = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement.classList.remove('pict-modal-visible');
			let tmpEl = tmpTooltipElement;
			tmpTooltipElement = null;

			// Remove aria
			pElement.removeAttribute('aria-describedby');

			// Remove from tracking
			this._modal._activeTooltips = this._modal._activeTooltips.filter(
				(pEntry) => { return pEntry.element !== tmpEl; }
			);

			setTimeout(() =>
			{
				if (tmpEl.parentNode)
				{
					tmpEl.parentNode.removeChild(tmpEl);
				}
			}, 220);
		};

		let tmpOnMouseEnter = () =>
		{
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
				tmpHideTimeout = null;
			}
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnMouseLeave = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// A pinned tooltip stays open regardless of pointer.
			if (tmpPinned)
			{
				return;
			}
			// Small delay before hiding to allow moving to interactive tooltip
			if (pOptions.interactive)
			{
				tmpHideTimeout = setTimeout(tmpHide, 100);
			}
			else
			{
				tmpHide();
			}
		};

		let tmpOnFocusIn = () =>
		{
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnFocusOut = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// A pinned tooltip stays open regardless of focus.
			if (tmpPinned)
			{
				return;
			}
			tmpHide();
		};

		// -- Pin lifecycle (opt-in via pOptions.pinnable) --

		// Keep a pinned tooltip glued to its anchor as the page scrolls/resizes.
		// The element is position:fixed and portaled to <body>, so it does not
		// move with the document on its own. When the anchor scrolls out of the
		// viewport we fade the tooltip out (without dropping the pin) and bring
		// it back when the anchor returns.
		let tmpResizeObserver = null;
		let tmpReposition = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}
			let tmpRect = pElement.getBoundingClientRect();
			// Rendered (has a layout box) AND within the viewport. A hidden anchor
			// (display:none, or inside a hidden tab panel) has no box, so the
			// tooltip is hidden rather than stranded at the clamped corner.
			let tmpInView = this._isElementRendered(pElement)
				&& (tmpRect.bottom > 0) && (tmpRect.top < window.innerHeight)
				&& (tmpRect.right > 0) && (tmpRect.left < window.innerWidth);
			if (tmpInView)
			{
				this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);
				tmpTooltipElement.classList.add('pict-modal-visible');
			}
			else
			{
				tmpTooltipElement.classList.remove('pict-modal-visible');
			}
		};

		let tmpAddRepositionListeners = () =>
		{
			// `true` (capture) so scrolls inside any nested container reposition too.
			window.addEventListener('scroll', tmpReposition, true);
			window.addEventListener('resize', tmpReposition);
			// A ResizeObserver on the anchor catches it being shown/hidden (e.g. a
			// tab panel toggling display) — transitions the window scroll/resize
			// listeners miss — so a pinned tooltip appears the moment its anchor
			// gains a layout box and hides again when it loses one.
			if (typeof ResizeObserver !== 'undefined')
			{
				tmpResizeObserver = new ResizeObserver(() => tmpReposition());
				tmpResizeObserver.observe(pElement);
			}
		};

		let tmpRemoveRepositionListeners = () =>
		{
			window.removeEventListener('scroll', tmpReposition, true);
			window.removeEventListener('resize', tmpReposition);
			if (tmpResizeObserver)
			{
				tmpResizeObserver.disconnect();
				tmpResizeObserver = null;
			}
		};

		let tmpPin = () =>
		{
			if (tmpPinned || tmpDestroyed)
			{
				return;
			}
			tmpPinned = true;
			if (!tmpTooltipElement)
			{
				tmpShow();
			}
			if (tmpTooltipElement)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-pinned');
			}
			tmpAddRepositionListeners();
			if (typeof pOptions.onPinChange === 'function')
			{
				pOptions.onPinChange(true, pElement);
			}
		};

		let tmpUnpin = () =>
		{
			if (!tmpPinned)
			{
				return;
			}
			tmpPinned = false;
			tmpRemoveRepositionListeners();
			if (tmpTooltipElement)
			{
				tmpTooltipElement.classList.remove('pict-modal-tooltip-pinned');
			}
			tmpHide();
			if (typeof pOptions.onPinChange === 'function')
			{
				pOptions.onPinChange(false, pElement);
			}
		};

		let tmpOnClick = (pEvent) =>
		{
			if (pEvent)
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
			}
			if (tmpPinned)
			{
				tmpUnpin();
			}
			else
			{
				tmpPin();
			}
		};

		// Attach listeners
		pElement.addEventListener('mouseenter', tmpOnMouseEnter);
		pElement.addEventListener('mouseleave', tmpOnMouseLeave);
		pElement.addEventListener('focusin', tmpOnFocusIn);
		pElement.addEventListener('focusout', tmpOnFocusOut);
		if (pOptions.pinnable)
		{
			pElement.addEventListener('click', tmpOnClick);
		}

		let tmpDestroy = () =>
		{
			if (tmpDestroyed)
			{
				return;
			}
			tmpDestroyed = true;

			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
			}
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
			}

			tmpRemoveRepositionListeners();
			tmpPinned = false;
			tmpHide();

			pElement.removeEventListener('mouseenter', tmpOnMouseEnter);
			pElement.removeEventListener('mouseleave', tmpOnMouseLeave);
			pElement.removeEventListener('focusin', tmpOnFocusIn);
			pElement.removeEventListener('focusout', tmpOnFocusOut);
			if (pOptions.pinnable)
			{
				pElement.removeEventListener('click', tmpOnClick);
			}
		};

		// Optionally render already-pinned (explicit consumer opt-in).
		if (pOptions.pinnable && pOptions.startPinned)
		{
			tmpPin();
		}

		return {
			destroy: tmpDestroy,
			pin: tmpPin,
			unpin: tmpUnpin,
			isPinned: () => { return tmpPinned; }
		};
	}

	/**
	 * Position a tooltip element relative to the target element.
	 * Flips direction if the tooltip would overflow the viewport.
	 *
	 * @param {HTMLElement} pTooltip
	 * @param {HTMLElement} pTarget
	 * @param {string} pPosition - 'top', 'bottom', 'left', 'right'
	 */
	_positionTooltip(pTooltip, pTarget, pPosition)
	{
		let tmpTargetRect = pTarget.getBoundingClientRect();
		let tmpTooltipRect = pTooltip.getBoundingClientRect();
		let tmpGap = 8;

		let tmpPosition = pPosition;

		// Flip if needed
		if (tmpPosition === 'top' && tmpTargetRect.top < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'bottom';
		}
		else if (tmpPosition === 'bottom' && (window.innerHeight - tmpTargetRect.bottom) < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'top';
		}
		else if (tmpPosition === 'left' && tmpTargetRect.left < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'right';
		}
		else if (tmpPosition === 'right' && (window.innerWidth - tmpTargetRect.right) < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'left';
		}

		// Update class for arrow direction
		pTooltip.className = pTooltip.className.replace(/pict-modal-tooltip--\w+/, 'pict-modal-tooltip--' + tmpPosition);

		let tmpTop = 0;
		let tmpLeft = 0;

		switch (tmpPosition)
		{
			case 'top':
				tmpTop = tmpTargetRect.top - tmpTooltipRect.height - tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'bottom':
				tmpTop = tmpTargetRect.bottom + tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'left':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.left - tmpTooltipRect.width - tmpGap;
				break;
			case 'right':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.right + tmpGap;
				break;
		}

		// Clamp to viewport
		tmpLeft = Math.max(4, Math.min(tmpLeft, window.innerWidth - tmpTooltipRect.width - 4));
		tmpTop = Math.max(4, Math.min(tmpTop, window.innerHeight - tmpTooltipRect.height - 4));

		pTooltip.style.top = tmpTop + 'px';
		pTooltip.style.left = tmpLeft + 'px';
	}

	/**
	 * Whether an element is currently rendered (has a layout box). Returns false
	 * for a display:none element or one inside a display:none ancestor (e.g. an
	 * inactive tab panel) — in which case a pinned tooltip should stay hidden
	 * until the anchor reappears.
	 *
	 * @param {HTMLElement} pElement
	 * @returns {boolean}
	 */
	_isElementRendered(pElement)
	{
		return !!(pElement && typeof pElement.getClientRects === 'function' && pElement.getClientRects().length > 0);
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissAll()
	{
		let tmpTooltips = this._modal._activeTooltips.slice();
		for (let i = 0; i < tmpTooltips.length; i++)
		{
			tmpTooltips[i].destroy();
		}
	}
}

module.exports = PictModalTooltip;

},{}],588:[function(require,module,exports){
/**
 * Pict-Modal-Window
 *
 * Builds custom floating modal windows with arbitrary content and buttons.
 */
class PictModalWindow
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options
	 * @param {string} [pOptions.title] - Dialog title
	 * @param {string} [pOptions.content] - HTML content for the body
	 * @param {Array} [pOptions.buttons] - Array of { Hash, Label, Style }
	 * @param {boolean} [pOptions.closeable] - Whether the close button and overlay dismiss are enabled
	 * @param {string} [pOptions.width] - CSS width value
	 * @param {boolean} [pOptions.unbounded] - If true, removes the default 90vh/90vw viewport cap. The dialog will grow with its content and may extend beyond the viewport.
	 * @param {function} [pOptions.onOpen] - Called after dialog is shown, receives dialog element
	 * @param {function} [pOptions.onClose] - Called after dialog is dismissed
	 * @returns {Promise<string|null>} Resolves with clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultModalOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions, fResolve);
			this._showDialog(tmpDialog, tmpOptions, fResolve);
		});
	}

	/**
	 * Build the modal dialog element.
	 *
	 * @param {object} pOptions
	 * @param {function} fResolve
	 * @returns {HTMLElement}
	 */
	_buildDialog(pOptions, fResolve)
	{
		let tmpId = this._modal._nextId();

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = pOptions.width;

		// Header
		let tmpHeaderHTML = '';
		if (pOptions.title || pOptions.closeable)
		{
			tmpHeaderHTML = '<div class="pict-modal-dialog-header">';
			tmpHeaderHTML += '<span class="pict-modal-dialog-title">' + this._escapeHTML(pOptions.title) + '</span>';
			if (pOptions.closeable)
			{
				tmpHeaderHTML += '<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>';
			}
			tmpHeaderHTML += '</div>';
		}

		// Body
		let tmpBodyHTML = '<div class="pict-modal-dialog-body">' + (pOptions.content || '') + '</div>';

		// Footer with buttons
		let tmpFooterHTML = '';
		if (pOptions.buttons && pOptions.buttons.length > 0)
		{
			tmpFooterHTML = '<div class="pict-modal-dialog-footer">';
			for (let i = 0; i < pOptions.buttons.length; i++)
			{
				let tmpButton = pOptions.buttons[i];
				let tmpBtnClass = 'pict-modal-btn';
				if (tmpButton.Style)
				{
					tmpBtnClass += ' pict-modal-btn--' + tmpButton.Style;
				}
				tmpFooterHTML += '<button class="' + tmpBtnClass + '" data-hash="' + this._escapeHTML(tmpButton.Hash) + '">' +
					this._escapeHTML(tmpButton.Label) + '</button>';
			}
			tmpFooterHTML += '</div>';
		}

		tmpDialog.innerHTML = tmpHeaderHTML + tmpBodyHTML + tmpFooterHTML;

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve, pOptions);
		};

		// Wire close button
		if (pOptions.closeable)
		{
			let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
			if (tmpCloseBtn)
			{
				tmpCloseBtn.addEventListener('click', () => { tmpDismiss(null); });
			}
		}

		// Wire action buttons
		let tmpActionButtons = tmpDialog.querySelectorAll('[data-hash]');
		for (let i = 0; i < tmpActionButtons.length; i++)
		{
			let tmpBtn = tmpActionButtons[i];
			tmpBtn.addEventListener('click', () =>
			{
				tmpDismiss(tmpBtn.getAttribute('data-hash'));
			});
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show the dialog: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {object} pOptions
	 * @param {function} fResolve
	 */
	_showDialog(pDialog, pOptions, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'window'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses && pOptions.closeable)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(null); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus first button or close button
		let tmpFocusTarget = pDialog.querySelector('.pict-modal-btn') || pDialog.querySelector('.pict-modal-dialog-close');
		if (tmpFocusTarget)
		{
			tmpFocusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape' && pOptions.closeable)
			{
				pDialog._dismiss(null);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);

		// onOpen callback
		if (typeof pOptions.onOpen === 'function')
		{
			pOptions.onOpen(pDialog);
		}
	}

	/**
	 * Dismiss the dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult
	 * @param {function} fResolve
	 * @param {object} pOptions
	 */
	_dismissDialog(pDialog, pResult, fResolve, pOptions)
	{
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		pDialog.classList.remove('pict-modal-visible');

		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		this._modal._overlay.hide();

		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		if (typeof pOptions.onClose === 'function')
		{
			pOptions.onClose(pResult);
		}

		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalWindow;

},{}],589:[function(require,module,exports){
module.exports = (
{
	"AutoInitialize": true,
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ViewIdentifier": "Pict-Section-Modal",

	"OverlayClickDismisses": true,

	"DefaultConfirmOptions":
	{
		"title": "Confirm",
		"confirmLabel": "OK",
		"cancelLabel": "Cancel",
		"dangerous": false,
		"unbounded": false
	},

	"DefaultDoubleConfirmOptions":
	{
		"title": "Are you sure?",
		"confirmLabel": "Confirm",
		"cancelLabel": "Cancel",
		"phrasePrompt": "Type \"{phrase}\" to confirm:",
		"confirmPhrase": "",
		"unbounded": false
	},

	"DefaultModalOptions":
	{
		"title": "",
		"content": "",
		"buttons": [],
		"closeable": true,
		"width": "480px",
		"unbounded": false
	},

	"DefaultTooltipOptions":
	{
		"position": "top",
		"delay": 200,
		"maxWidth": "300px",
		"interactive": false,
		"pinnable": false,
		"startPinned": false
	},

	"DefaultToastOptions":
	{
		"type": "info",
		"duration": 3000,
		"position": "top-right",
		"dismissible": true,
		"allowHTML": false
	},

	"DefaultPanelOptions":
	{
		"position": "right",
		"width": 340,
		"minWidth": 200,
		"maxWidth": 600,
		"collapsible": true,
		"collapsed": false,
		"persist": false,
		"persistKey": ""
	},

	"Templates": [],
	"Renderables": [],

	"CSS": /*css*/`
/* pict-section-modal */
.pict-modal-root
{
	/* Defaults are routed through pict-provider-theme tokens so apps
	   using the theme provider get themed modals automatically.  Each
	   var() carries its original hex as the fallback so apps that don't
	   install pict-provider-theme look exactly as before.  Apps may
	   still override any --pict-modal-* var directly to layer over the
	   theme-driven defaults. */

	/* Overlay */
	--pict-modal-overlay-bg: rgba(0, 0, 0, 0.5);

	/* Dialog */
	--pict-modal-bg:                  var(--theme-color-background-panel,  #ffffff);
	--pict-modal-fg:                  var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-border:              var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-border-radius:       8px;
	--pict-modal-shadow:              0 4px 24px rgba(0, 0, 0, 0.15);
	--pict-modal-header-bg:           var(--theme-color-background-secondary, #f5f5f5);
	--pict-modal-header-fg:           var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-header-border:       var(--theme-color-border-default,    #e0e0e0);

	/* Buttons */
	--pict-modal-btn-bg:              var(--theme-color-background-secondary, #e0e0e0);
	--pict-modal-btn-fg:              var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-btn-hover-bg:        var(--theme-color-background-hover,  #d0d0d0);
	--pict-modal-btn-primary-bg:      var(--theme-color-brand-primary,     #2563eb);
	--pict-modal-btn-primary-fg:      var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-primary-hover-bg:var(--theme-color-brand-primary-hover,#1d4ed8);
	--pict-modal-btn-danger-bg:       var(--theme-color-status-error,      #dc2626);
	--pict-modal-btn-danger-fg:       var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-danger-hover-bg: var(--theme-color-status-error,      #b91c1c);
	--pict-modal-btn-border-radius:   4px;

	/* Toast */
	--pict-modal-toast-bg:            var(--theme-color-background-panel,  #333333);
	--pict-modal-toast-fg:            var(--theme-color-text-primary,      #ffffff);
	--pict-modal-toast-success-bg:    var(--theme-color-status-success,    #16a34a);
	--pict-modal-toast-warning-bg:    var(--theme-color-status-warning,    #d97706);
	--pict-modal-toast-error-bg:      var(--theme-color-status-error,      #dc2626);
	--pict-modal-toast-info-bg:       var(--theme-color-status-info,       #2563eb);
	--pict-modal-toast-border-radius: 6px;
	--pict-modal-toast-shadow:        0 2px 12px rgba(0, 0, 0, 0.15);

	/* Tooltip */
	--pict-modal-tooltip-bg:          var(--theme-color-background-tertiary,#1a1a1a);
	--pict-modal-tooltip-fg:          var(--theme-color-text-primary,      #ffffff);
	--pict-modal-tooltip-border-radius:4px;
	--pict-modal-tooltip-shadow:      0 2px 8px rgba(0, 0, 0, 0.15);
	--pict-modal-tooltip-pinned-ring: var(--theme-color-brand-primary, #2E7D74);

	/* Dropdown */
	--pict-modal-dropdown-bg:                 var(--theme-color-background-panel,  #ffffff);
	--pict-modal-dropdown-fg:                 var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-border:             var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-dropdown-border-radius:      6px;
	--pict-modal-dropdown-shadow:             0 6px 18px rgba(0, 0, 0, 0.18);
	--pict-modal-dropdown-item-hover-bg:      var(--theme-color-background-hover,  rgba(37, 99, 235, 0.10));
	--pict-modal-dropdown-item-hover-fg:      var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-item-disabled-fg:   var(--theme-color-text-muted,        #9aa0a6);
	--pict-modal-dropdown-separator:          var(--theme-color-border-light,      #e8e8e8);
	--pict-modal-dropdown-header-fg:          var(--theme-color-text-secondary,    #6b7280);
	--pict-modal-dropdown-danger-fg:          var(--theme-color-status-error,      #dc2626);
	--pict-modal-dropdown-primary-fg:         var(--theme-color-brand-primary,     #2563eb);

	/* Typography */
	--pict-modal-font-family:         var(--theme-typography-family-sans,  system-ui, -apple-system, sans-serif);
	--pict-modal-font-size:           14px;
	--pict-modal-title-font-size:     16px;

	/* Animation */
	--pict-modal-transition-duration: 200ms;
}

/* Overlay */
.pict-modal-overlay
{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--pict-modal-overlay-bg);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
}

.pict-modal-overlay.pict-modal-visible
{
	opacity: 1;
}

/* Dialog */
.pict-modal-dialog
{
	position: fixed;
	z-index: 1010;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) translateY(-20px);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;

	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;

	background: var(--pict-modal-bg);
	color: var(--pict-modal-fg);
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-border-radius);
	box-shadow: var(--pict-modal-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
}

.pict-modal-dialog.pict-modal-visible
{
	opacity: 1;
	transform: translate(-50%, -50%) translateY(0);
}

/* Unbounded modifier — lets callers opt out of the 90vh/90vw viewport cap.
   Use with caution: content taller than the viewport will push buttons
   below the fold. */
.pict-modal-dialog.pict-modal-dialog--unbounded
{
	max-height: none;
	max-width: none;
}

.pict-modal-dialog-header
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: var(--pict-modal-header-bg);
	color: var(--pict-modal-header-fg);
	border-bottom: 1px solid var(--pict-modal-header-border);
	border-radius: var(--pict-modal-border-radius) var(--pict-modal-border-radius) 0 0;
}

.pict-modal-dialog-title
{
	font-size: var(--pict-modal-title-font-size);
	font-weight: 600;
}

.pict-modal-dialog-close
{
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--pict-modal-fg);
	padding: 0 4px;
	line-height: 1;
	opacity: 0.6;
}

.pict-modal-dialog-close:hover
{
	opacity: 1;
}

.pict-modal-dialog-body
{
	padding: 16px;
	overflow-y: auto;
	flex: 1;
}

.pict-modal-dialog-footer
{
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid var(--pict-modal-border);
}

/* Buttons */
.pict-modal-btn
{
	padding: 8px 16px;
	border: none;
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	cursor: pointer;
	background: var(--pict-modal-btn-bg);
	color: var(--pict-modal-btn-fg);
	transition: background var(--pict-modal-transition-duration) ease;
}

.pict-modal-btn:hover
{
	background: var(--pict-modal-btn-hover-bg);
}

.pict-modal-btn:disabled
{
	opacity: 0.5;
	cursor: not-allowed;
}

.pict-modal-btn--primary
{
	background: var(--pict-modal-btn-primary-bg);
	color: var(--pict-modal-btn-primary-fg);
}

.pict-modal-btn--primary:hover
{
	background: var(--pict-modal-btn-primary-hover-bg);
}

.pict-modal-btn--danger
{
	background: var(--pict-modal-btn-danger-bg);
	color: var(--pict-modal-btn-danger-fg);
}

.pict-modal-btn--danger:hover
{
	background: var(--pict-modal-btn-danger-hover-bg);
}

/* Double confirm input */
.pict-modal-confirm-input
{
	width: 100%;
	padding: 8px 12px;
	margin-top: 12px;
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	box-sizing: border-box;
}

.pict-modal-confirm-input:focus
{
	outline: 2px solid var(--pict-modal-btn-primary-bg);
	outline-offset: -1px;
}

.pict-modal-confirm-prompt
{
	margin-top: 12px;
	font-size: 13px;
	color: var(--pict-modal-fg);
	opacity: 0.7;
}

/* Toast container */
.pict-modal-toast-container
{
	position: fixed;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	gap: 8px;
	pointer-events: none;
	max-width: 400px;
}

.pict-modal-toast-container--top-right
{
	top: 16px;
	right: 16px;
}

.pict-modal-toast-container--top-left
{
	top: 16px;
	left: 16px;
}

.pict-modal-toast-container--bottom-right
{
	bottom: 16px;
	right: 16px;
}

.pict-modal-toast-container--bottom-left
{
	bottom: 16px;
	left: 16px;
}

.pict-modal-toast-container--top-center
{
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
}

.pict-modal-toast-container--bottom-center
{
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
}

/* Toast */
.pict-modal-toast
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: var(--pict-modal-toast-border-radius);
	box-shadow: var(--pict-modal-toast-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	background: var(--pict-modal-toast-bg);
	color: var(--pict-modal-toast-fg);
	pointer-events: auto;
	opacity: 0;
	transform: translateX(100%);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-toast.pict-modal-visible
{
	opacity: 1;
	transform: translateX(0);
}

.pict-modal-toast.pict-modal-toast-exit
{
	opacity: 0;
	transform: translateX(100%);
}

.pict-modal-toast--info
{
	background: var(--pict-modal-toast-info-bg);
}

.pict-modal-toast--success
{
	background: var(--pict-modal-toast-success-bg);
}

.pict-modal-toast--warning
{
	background: var(--pict-modal-toast-warning-bg);
}

.pict-modal-toast--error
{
	background: var(--pict-modal-toast-error-bg);
}

.pict-modal-toast-message
{
	flex: 1;
}

.pict-modal-toast-dismiss
{
	background: none;
	border: none;
	color: inherit;
	font-size: 18px;
	cursor: pointer;
	padding: 0 2px;
	line-height: 1;
	opacity: 0.7;
}

.pict-modal-toast-dismiss:hover
{
	opacity: 1;
}

/* Tooltip */
.pict-modal-tooltip
{
	position: fixed;
	z-index: 1020;
	padding: 6px 10px;
	border-radius: var(--pict-modal-tooltip-border-radius);
	box-shadow: var(--pict-modal-tooltip-shadow);
	background: var(--pict-modal-tooltip-bg);
	color: var(--pict-modal-tooltip-fg);
	font-family: var(--pict-modal-font-family);
	font-size: 13px;
	pointer-events: none;
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
	white-space: normal;
	word-wrap: break-word;
}

.pict-modal-tooltip.pict-modal-tooltip-interactive
{
	pointer-events: auto;
}

.pict-modal-tooltip.pict-modal-visible
{
	opacity: 1;
}

/* Pinned tooltips stay open and can be interacted with; a subtle ring
   distinguishes a pinned tooltip from a transient hover tooltip. */
.pict-modal-tooltip.pict-modal-tooltip-pinned
{
	pointer-events: auto;
	box-shadow: var(--pict-modal-tooltip-shadow), 0 0 0 1px var(--pict-modal-tooltip-pinned-ring);
}

.pict-modal-tooltip-arrow
{
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--pict-modal-tooltip-bg);
	transform: rotate(45deg);
}

.pict-modal-tooltip--top .pict-modal-tooltip-arrow
{
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow
{
	top: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--left .pict-modal-tooltip-arrow
{
	right: -4px;
	top: 50%;
	margin-top: -4px;
}

.pict-modal-tooltip--right .pict-modal-tooltip-arrow
{
	left: -4px;
	top: 50%;
	margin-top: -4px;
}

/* ── Dropdown ─────────────────────────────────────────────────────────
   Anchor-positioned menu (no overlay). Used for nav menus and
   "split button" addenda — see Pict-Modal-Dropdown.js.
*/
.pict-modal-dropdown
{
	position: fixed;
	z-index: 1025;
	min-width: 160px;
	max-width: 360px;
	max-height: 60vh;
	overflow-y: auto;
	background: var(--pict-modal-dropdown-bg);
	color: var(--pict-modal-dropdown-fg);
	border: 1px solid var(--pict-modal-dropdown-border);
	border-radius: var(--pict-modal-dropdown-border-radius);
	box-shadow: var(--pict-modal-dropdown-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	padding: 4px 0;
	opacity: 0;
	transform: translateY(-4px);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

/* Free-form content popovers keep the dropdown chrome (bg / border / shadow /
   flip / dismiss) but hand sizing + inner padding to the injected content, so a
   pre-rendered template menu or a wide rich card isn't boxed by the menu
   defaults. Cap width per-call via the maxWidth option. */
.pict-modal-dropdown.pict-modal-dropdown--content
{
	max-width: none;
	padding: 0;
}

.pict-modal-dropdown.pict-modal-dropdown--above { transform: translateY(4px); }

.pict-modal-dropdown.pict-modal-visible
{
	opacity: 1;
	transform: translateY(0);
}

.pict-modal-dropdown-item
{
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	cursor: pointer;
	user-select: none;
	color: inherit;
	outline: none;
}

.pict-modal-dropdown-item:hover,
.pict-modal-dropdown-item:focus
{
	background: var(--pict-modal-dropdown-item-hover-bg);
	color: var(--pict-modal-dropdown-item-hover-fg);
}

.pict-modal-dropdown-item--disabled
{
	cursor: not-allowed;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--disabled:hover,
.pict-modal-dropdown-item--disabled:focus
{
	background: transparent;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--primary { color: var(--pict-modal-dropdown-primary-fg); }
.pict-modal-dropdown-item--danger  { color: var(--pict-modal-dropdown-danger-fg); }

.pict-modal-dropdown-item-icon
{
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.pict-modal-dropdown-item-icon svg { width: 100%; height: 100%; display: block; }

.pict-modal-dropdown-item-label { flex: 1 1 auto; min-width: 0; }

.pict-modal-dropdown-item-hint
{
	flex: 0 0 auto;
	font-size: 11px;
	opacity: 0.6;
	margin-left: 12px;
}

.pict-modal-dropdown-separator
{
	height: 1px;
	background: var(--pict-modal-dropdown-separator);
	margin: 4px 0;
}

.pict-modal-dropdown-header
{
	padding: 6px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--pict-modal-dropdown-header-fg);
}

/* ── Resizable / Collapsible Panels ──────────────── */
.pict-panel
{
	position: relative;
	transition: width 0.2s ease;
	flex-shrink: 0;
	overflow: visible;
}
.pict-panel-collapsed
{
	width: 0 !important;
	min-width: 0 !important;
	overflow: visible;
}
.pict-panel-collapsed > *:not(.pict-panel-edge)
{
	display: none;
}

/* Edge container — zero-width flex sibling of the panel.
   Sits next to the panel in the flex layout; children
   use absolute positioning to overlap the panel boundary. */
.pict-panel-edge
{
	position: relative;
	width: 0;
	flex-shrink: 0;
	z-index: 50;
	overflow: visible;
}

/* Resize handle — thin strip on the panel boundary */
.pict-panel-resize
{
	position: absolute;
	top: 0;
	bottom: 0;
	width: 4px;
	cursor: col-resize;
	background: transparent;
	transition: background 0.15s, width 0.15s;
}
.pict-panel-edge-right .pict-panel-resize
{
	right: 0;
	border-right: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-edge-left .pict-panel-resize
{
	left: 0;
	border-left: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-resize:hover,
.pict-panel-edge:hover .pict-panel-resize
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 0.5;
}
.pict-panel-resize.dragging
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 1;
	transition: none;
}
.pict-panel-edge-collapsed .pict-panel-resize
{
	display: none;
}

/* Collapse tab — tucked sliver at rest, slides out on hover */
.pict-panel-tab
{
	position: absolute;
	top: 8px;
	width: 8px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: var(--pict-panel-border, #DDD6CA);
	border: 1px solid var(--pict-panel-border, #DDD6CA);
	cursor: pointer;
	color: var(--pict-panel-fg, #8A7F72);
	font-size: 10px;
	line-height: 1;
	opacity: 0.5;
	transition: opacity 0.25s, width 0.2s ease, height 0.2s ease, left 0.2s ease, right 0.2s ease, background 0.2s;
	z-index: 51;
}
.pict-panel-edge:hover .pict-panel-tab,
.pict-panel-tab:hover
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}
/* Right panel: tab to the left of the edge */
.pict-panel-edge-right .pict-panel-tab
{
	right: 0;
	border-right: none;
	border-radius: 4px 0 0 4px;
}
.pict-panel-edge-right:hover .pict-panel-tab,
.pict-panel-edge-right .pict-panel-tab:hover
{
	right: 0;
}
/* Left panel: tab to the right of the edge */
.pict-panel-edge-left .pict-panel-tab
{
	left: 0;
	border-left: none;
	border-radius: 0 4px 4px 0;
}
.pict-panel-edge-left:hover .pict-panel-tab,
.pict-panel-edge-left .pict-panel-tab:hover
{
	left: 0;
}
/* When collapsed — more visible */
.pict-panel-edge-collapsed .pict-panel-tab
{
	width: 10px;
	height: 28px;
	opacity: 0.6;
}
.pict-panel-edge-collapsed .pict-panel-tab:hover,
.pict-panel-edge-collapsed:hover .pict-panel-tab
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}

/* ───────────────────────────────────────────────────────────────────
 *  Pict-Modal-Shell — viewport-managing layout for top / right /
 *  bottom / left panels around a center.
 * ───────────────────────────────────────────────────────────────── */

.pict-modal-shell-host { display: block; height: 100%; min-height: 0; }
.pict-modal-shell
{
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	position: relative;
	color: var(--pict-modal-fg, var(--theme-color-text-primary, #1a1a1a));
	background: var(--theme-color-background-primary, transparent);
}
.pict-modal-shell-row { display: flex; min-width: 0; min-height: 0; }
/* "First added = at the edge" convention is held by reversing the
   flex-direction on the bottom row + right side. That way, for ALL
   four sides, calling addPanel() N times stacks panel #1 against
   the viewport edge, panel #2 just inside it, panel #3 further in,
   and so on. Without these reverses, top + left worked that way but
   bottom + right inverted (first-added at content side, last-added
   at edge), which surprised callers. */
.pict-modal-shell-row-top    { flex: 0 0 auto; flex-direction: column; }
.pict-modal-shell-row-bottom { flex: 0 0 auto; flex-direction: column-reverse; }
.pict-modal-shell-row-middle
{
	flex: 1 1 0;
	flex-direction: row;
	min-height: 0;
	position: relative;
}
.pict-modal-shell-side
{
	display: flex;
	flex: 0 0 auto;
	min-height: 0;
}
.pict-modal-shell-side-left  { flex-direction: row; }
.pict-modal-shell-side-right { flex-direction: row-reverse; }
.pict-modal-shell-center
{
	flex: 1 1 0;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
}
.pict-modal-shell-center-content
{
	min-height: 100%;
}
/* Center column gains this class when at least one Scope:'center'
   panel is added.  The center stops scrolling internally — that job
   moves to the content destination — and switches to a vertical flex
   so the destination and any inner panels stack cleanly. */
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel
{
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-center-content
{
	flex: 1 1 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-panel
{
	flex: 0 0 auto;
	width: 100%;
}

/* Panels — base */
.pict-modal-shell-panel
{
	/* How far the collapse-tab's panel-bg "merge bar" extends INTO
	   the panel past the tab's geometric edge. Painted via box-shadow
	   on the tab (no DOM impact), it masks any 1px theme border on an
	   inner element, content padding offset, or resize-handle hover
	   bleed in the strip between the tab's panel-facing edge and the
	   first real pixel of panel content. Consumers can bump this for
	   themes with thicker (2+px) inner borders. */
	--pict-modal-collapse-tab-merge: 2px;
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: inherit;
	min-width: 0;
	min-height: 0;
	transition: width 140ms ease, height 140ms ease;
}
.pict-modal-shell-panel-content
{
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
}
/* Fixed-mode panels are pure chrome (topbars, status rows). Their
   content should fit the configured Size exactly — never scroll. The
   1px border that .pict-modal-shell-panel-mode-fixed adds on the
   inner edge shaves 1px off the content's available height, which
   then triggers a sliver-scrollbar on any inner widget with
   min-height matching the panel Size. overflow:hidden here suppresses
   that without affecting resizable/collapsible panels (sidebars,
   drawers) where scrollable content is the whole point. */
.pict-modal-shell-panel-mode-fixed > .pict-modal-shell-panel-content
{
	overflow: hidden;
}
.pict-modal-shell-panel-content-inner
{
	min-height: 100%;
}
/* Panel boundary — fixed-mode panels get a hairline border for explicit
   demarcation. Collapsible / resizable panels DROP the boundary border
   (background contrast separates them from the center anyway) so the
   collapse tab can pull out cleanly without a hairline cutting across
   it. The host stylesheet still gets full control via the panel's own
   background. */
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-top    { border-bottom: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-bottom { border-top:    1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-left   { border-right:  1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-right  { border-left:   1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }

/* Resize handle — absolute on the inner edge of each panel. */
.pict-modal-shell-panel-resize-handle
{
	position: absolute;
	background: transparent;
	z-index: 5;
	transition: background-color 120ms ease;
}
/* Resize handle hover — use the active brand's mode-aware primary
   color (set by pict-section-theme's Brand provider as
   --brand-color-primary-mode) so the resize affordance picks up the
   app's wordmark color. Falls back to the theme's brand-primary
   token if no brand is registered. */
.pict-modal-shell-panel-resize-handle:hover
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.4;
}
.pict-modal-shell-panel-left   .pict-modal-shell-panel-resize-handle { right: -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-right  .pict-modal-shell-panel-resize-handle { left:  -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-top    .pict-modal-shell-panel-resize-handle { bottom:-3px; left: 0; right: 0; height: 6px; cursor: row-resize; }
.pict-modal-shell-panel-bottom .pict-modal-shell-panel-resize-handle { top:   -3px; left: 0; right: 0; height: 6px; cursor: row-resize; }

/* Collapse tab — slim sliver flush on the panel's OUTER boundary
   (where the resize handle sits), modelled on retold-content-system's
   sidebar tab. At rest it's a 6×28 px sliver; hover expands to
   18×36 px without overlapping the panel's own content. The tab is
   positioned with its center on the boundary so half pokes into the
   adjacent area — the only place we can safely take over without
   stepping on app UI inside the panel. Title text only renders in the
   collapsed state where there's room for it. */
.pict-modal-shell-panel-collapse-tab
{
	position: absolute;
	display: flex;            /* not inline-flex — avoids baseline alignment quirks */
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #d0d7de));
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: var(--theme-color-text-muted, #6b7280);
	font: inherit;
	font-size: 10px;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	cursor: pointer;
	z-index: 50;
	opacity: 0.55;
	padding: 0;
	box-sizing: border-box;
	line-height: 0;          /* keep child boxes from inflating around the rotated chevron */
	/* Geometry (width/height/right/left) is intentionally NOT animated.
	   Sliding the tab's outer edge inward on hover-out makes it look like
	   the tab is "sliding into" the panel content — weird visual.
	   Snapping the size change instead, and animating only the appearance
	   (opacity/color/shadow), gives a clean fade-in/out with no boundary
	   weirdness. */
	transition: opacity 160ms ease,
	            background-color 160ms ease, color 160ms ease,
	            border-color 160ms ease, box-shadow 160ms ease;
}
/* Hover state pulls accent color from the active brand (mode-aware,
   so it's legible in both light + dark) with theme brand-primary as
   fallback. The whole point of brand colors is that they show up
   across the app's chrome. */
.pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab
{
	opacity: 1;
	color:        var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Drop shadow casts AWAY from the panel so the tab feels pulled out
   (extension of the panel) rather than floating across the boundary.
   The tab itself is now positioned fully OUTSIDE the panel boundary
   (see the per-side rules below), so we don't need a merge-bar shadow
   to mask any in-panel overlap — only the drop shadow remains. */
.pict-modal-shell-panel-left:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left    > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-right:hover   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right   > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: -3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-top:hover     > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top     > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-bottom:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom  > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.18);
}

/* Per-side base positioning — the tab lives entirely OUTSIDE the
   panel's outer boundary.  Its panel-facing edge touches the boundary
   (offset = -tabThickness) and the rest of the tab pokes out into the
   adjacent area (center / sibling panel).  Border on the panel-facing
   edge is dropped so the tab looks attached to the panel rather than
   floating beside it.
   Why fully-outside?  Earlier iterations had the tab straddling the
   boundary (1px inside + 4px outside) with a panel-bg-colored merge-bar
   masking the in-panel half — that worked geometrically but visually
   read as "tab pinned into the panel," and any rendering inside the
   panel (especially custom borders or hover bleeds) could clip against
   the in-panel half.  Fully-external positioning eliminates the overlap
   class of bugs and lets the tab live entirely in the adjacent area
   where there's no app content to step on. */
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab
{
	right: -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 0 4px 4px 0;
	border-left: 0;
}
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab
{
	left:  -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 4px 0 0 4px;
	border-right: 0;
}
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab
{
	bottom: -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 0 0 4px 4px;
	border-top: 0;
}
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab
{
	top:    -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 4px 4px 0 0;
	border-bottom: 0;
}

/* Hover: tab grows OUTWARD into the adjacent area.  The panel-facing
   edge stays glued to the boundary (offset = -tabThickness), so the
   tab still looks attached on hover — only its outer dimension grows.
   For side panels the height also grows (28 → 36) downward; for top
   /bottom panels the width grows (28 → 36) — see the next block for
   the perpendicular-axis offsets. */
.pict-modal-shell-panel-left:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; right: -18px;
}
.pict-modal-shell-panel-right:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; left: -18px;
}
.pict-modal-shell-panel-top:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; bottom: -18px;
}
.pict-modal-shell-panel-bottom:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; top: -18px;
}

.pict-modal-shell-panel-collapse-tab-title { display: none; white-space: nowrap; }

/* Auto-generated chevron glyph inside the tab — only visible once the
   tab is wide / tall enough to show it (i.e. hover state, or when the
   panel is collapsed). Direction follows side + state.
   Sized 5×5 (down from 6) so even with rotation the visual stays
   well clear of the tab's overflow:hidden bounds at 18×36 hover and
   the 24px collapsed tab strip width. flex-shrink:0 ensures the
   pseudo never collapses to zero in tight tab dimensions. */
.pict-modal-shell-panel-collapse-tab::before
{
	content: '';
	display: block;
	width: 5px; height: 5px;
	flex-shrink: 0;
	opacity: 0;
	border-right: 1.5px solid currentColor;
	border-bottom: 1.5px solid currentColor;
	transform: rotate(135deg);
	transform-origin: center center;
	transition: opacity 160ms ease, transform 160ms ease;
}
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab::before,
.pict-modal-shell-panel-collapse-tab:hover::before,
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	opacity: 1;
}
.pict-modal-shell-panel-right                                       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-top                                         > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }
.pict-modal-shell-panel-bottom                                      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(135deg); }
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed        > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed     > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }

/* Collapsed state — content disappears, only the collapse tab remains. */
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-content
{
	display: none;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed
{
	/* When collapsed, side panels rotate the title for vertical reading. */
	overflow: hidden;
}
/* When collapsed: the entire panel becomes the tab strip — full width
   for sides, full height for top/bottom — with the title visible
   vertically (sides) or horizontally (top/bottom). The little sliver
   tab on the boundary disappears (we don't need it anymore — clicking
   anywhere on the panel toggles it back open). */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed
{
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	/* Promote the tab to FILL the collapsed panel (not just hug its
	   content) so the centered chevron + title group sits in the middle
	   of the panel. Without explicit width/height: 100%, the position:
	   absolute element shrinks to its natural content size and the
	   group ends up flush at the top of the panel — where the chevron
	   gets clipped by the topbar. */
	position: absolute !important;
	top: 0 !important; right: 0 !important; bottom: 0 !important; left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	border: 0;
	border-radius: 0;
	background: transparent;
	opacity: 0.85;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 4px;        /* keeps chevron + title clear of edges */
	box-shadow: none;
	color: var(--theme-color-text-muted, #6b7280);
	box-sizing: border-box;
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	background: var(--theme-color-background-hover, var(--pict-modal-bg, #fff));
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: none;
}
/* Side panels (collapsed): rotate the title for vertical reading. */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed  > .pict-modal-shell-panel-collapse-tab
{
	writing-mode: vertical-rl;
	text-orientation: mixed;
}
.pict-modal-shell-panel-collapsed .pict-modal-shell-panel-collapse-tab-title
{
	display: inline;
}

/* Hidden panels — when Hidden:true is passed to addPanel, the collapsed
   state has zero footprint: no collapse tab (the tab is never built),
   the panel root is display:none, and the resize handle vanishes. The
   only path to the open state is a programmatic expand()/toggle() from
   somewhere else in the app (e.g. a topbar gear button). When expanded,
   the panel renders normally — so resize/drag handles continue to work
   while the panel is open. */
.pict-modal-shell-panel-hidden.pict-modal-shell-panel-collapsed
{
	display: none !important;
}

/* Overlay panels — float over the middle row instead of taking layout
   space. The overlay layer is positioned absolutely inside the middle
   row; individual overlay panels stack with positive z-index. */
.pict-modal-shell-overlay-layer
{
	position: absolute;
	inset: 0;
	pointer-events: none;
	z-index: 10;
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel
{
	pointer-events: auto;
	position: absolute;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-left   { left:   0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-right  { right:  0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-top    { top:    0; left: 0; right: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-bottom { bottom: 0; left: 0; right: 0; }

/* ─────────────────────────────────────────────────────────────────
   Responsive drawer mode — .pict-modal-shell-drawer-active toggles
   onto the middle row when any panel with ResponsiveDrawer crosses
   below its breakpoint. Flips the row's flex-direction from row to
   column, stacking side panels above the center and stretching them
   to full width. Each opted-in panel itself gets the
   .pict-modal-shell-panel-drawer class so per-panel rules below
   target only the drawer-mode panels (right + non-drawer panels in
   the same row are unaffected). The drawer height is read from a
   per-panel --pict-modal-drawer-height CSS variable (default
   33vh, set in JS from the DrawerHeight option).
   ───────────────────────────────────────────────────────────────── */
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active
{
	flex-direction: column;
	/* The drawer tab lives outside the drawer's bottom edge — ancestor
	   chain MUST allow it to escape clip. */
	overflow: visible;
}
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active .pict-modal-shell-side
{
	/* Side stacks stretch full-width and lay out their panels as a
	   horizontal row of stacked drawers (so two drawers from the same
	   side don't end up overlapping). overflow: visible so the
	   per-panel tab can extend below the side stack into the workspace. */
	width: 100% !important;
	flex-direction: column;
	overflow: visible;
}
/* The drawer-tagged panel itself: kill the inline width set by
   _applySize (we override with !important since the inline style has
   higher specificity than a class selector), then size by height
   from the CSS variable. Resize handle is hidden in drawer mode
   because horizontal dragging doesn't translate to vertical sizing
   and the user already has the collapse tab to dismiss / restore.

   padding-bottom reserves an 18px strip at the bottom of the panel
   for the tab. The tab sits INSIDE the drawer's footprint — never
   below it — so the workspace header below the drawer is never in
   the same vertical band as the tab. (Previously the tab hung
   below the drawer's bottom edge into the workspace's top padding;
   that made the tab visually compete with the workspace header,
   even when the tab box-model bounds technically cleared the
   header.) box-sizing: border-box so the padding eats from the
   33vh, not adding to it. */
.pict-modal-shell-panel-drawer
{
	width: 100% !important;
	max-width: 100% !important;
	height: var(--pict-modal-drawer-height, 33vh);
	transition: height 140ms ease;
	padding-bottom: 18px;
	box-sizing: border-box;
	overflow: visible !important;
	/* Clip the panel bg to its CONTENT area only — the 18px
	   padding-bottom reserve (where the tab lives) becomes
	   transparent, so the middle row's primary background shows
	   through. Without this the reserve would render with the
	   panel's chrome bg, creating a visible "strip" between the
	   drawer content above and the workspace below — the tab would
	   look like it's sitting on its own miscoloured band rather
	   than at the seam between drawer and workspace. */
	background-clip: content-box;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed
{
	/* Collapsed = "just the tab strip is visible". 18px matches the
	   panel's tab reserve so the height is consistent across states.
	   When this is 0 the tab would have nowhere to render and the
	   user couldn't reopen the drawer. */
	height: 18px !important;
	padding-bottom: 0 !important;
	/* Drop the panel's bg in collapsed state — without this the 18px
	   strip shows the --pict-modal-bg (panel chrome) which doesn't
	   match the workspace --theme-color-background-primary below it,
	   creating a visible "drawer band" around the tab that breaks the
	   illusion of the tab belonging to the workspace area. With
	   transparent bg the middle row's primary background shows
	   through, the strip blends with the workspace, and the tab pill
	   reads as a free-floating handle. */
	background: transparent !important;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
/* The drawer's collapse tab is a horizontal pill protruding from the
   bottom of the drawer (rather than the inner edge of a side panel).
   Override the side-panel positioning rules from above so the tab
   always sits at the drawer's bottom-center seam, in both expanded
   and collapsed states. The expand-from-zero affordance: when
   collapsed (height: 0), the tab still hangs below "where the
   drawer would be" — a small handle the user can click to pull
   the drawer back down. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	position: absolute !important;
	/* Anchored to the panel's BOTTOM edge — the tab lives INSIDE the
	   drawer's footprint (in the 18px reserve at the bottom), never
	   below it into the workspace. This means the workspace below
	   the drawer is never sharing a vertical band with the tab, so
	   the workspace header doesn't optically compete with it.
	   bottom: 4px aligns the tab's top edge exactly with the panel's
	   CONTENT-AREA bottom (panel.height − padding-bottom 18px). With
	   border-top: 0 on the tab, the seam between the drawer content
	   above and the tab body is invisible — they share --pict-modal-bg
	   and merge into one shape, the tab reading as a labelled
	   extension of the drawer hanging downward. Collapsed state
	   keeps the smaller offset (overridden below) because its panel
	   has no padding-bottom, so the math doesn't apply. */
	top: auto !important;
	bottom: 4px !important;
	left: 50% !important;
	right: auto !important;
	transform: translate(-50%, 0) !important;
	width: 64px !important;
	height: 14px !important;
	/* CRITICAL: border-box + padding: 0 — the collapsed-state base
	   rule inherits "padding: 12px 4px" (so the chevron clears the
	   edges of a tab that fills a 24px-wide side strip). In drawer
	   mode the tab is a 14px tall pill, NOT a strip-fill, so that
	   12px vertical padding would balloon the tab's outer height to
	   ~38px and crash into the workspace header text. The chevron
	   is centered via flex anyway. */
	box-sizing: border-box !important;
	padding: 0 !important;
	/* Rounded BOTTOM corners + no top border — the tab looks like a
	   traditional drawer-handle/tab hanging from above. Its rounded
	   bottom curves face the workspace (the "open downward" affordance
	   for a top drawer). border-top: 0 lets the tab visually merge
	   with whatever's directly above it inside the panel (sidebar
	   content when expanded, the panel background when collapsed). */
	border-radius: 0 0 8px 8px;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #cfd5dd));
	border-top: 0;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #fff));
	opacity: 0.95;
	z-index: 20;
	/* The default side-panel hover-grow values would yank the tab off
	   to the wrong spot in drawer mode — neutralise. */
	display: flex;
	align-items: center;
	justify-content: center;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	opacity: 1;
	width: 96px !important;
	/* height stays at 14px — the tab is anchored with bottom, so any
	   height growth would push the tab's TOP edge UPWARD past the
	   space available above it. In EXPANDED state that crashes into
	   the drawer content above; in COLLAPSED state it crashes into
	   the topbar's brand stripes. Width-only growth (64 to 96, +50%)
	   still gives the "tab is reaching toward me" affordance without
	   the encroachment. */
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
/* Collapsed-state bottom-offset override. Expanded panels have an
   18px padding-bottom reserve, and "bottom: 4px" anchors the tab's
   top edge exactly at the content-area boundary (so it merges
   visually with the drawer above). Collapsed panels have
   padding-bottom: 0 and a total height of 18px — "bottom: 4px"
   there would put the tab's top at the panel's actual top edge,
   crashing the (border-top: 0) tab into the topbar. The smaller
   "bottom: 2px" keeps the 14px tab vertically centered in the 18px
   strip with 2px margins on either side. */
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	bottom: 2px !important;
}
/* Chevron inside the tab: point UP when expanded (the drawer
   collapses UP / out of view, so the arrow indicates "click me to
   send the drawer up"), DOWN when collapsed (the drawer expands DOWN
   into view). Rotations come from the existing top-panel chevron
   table: rotate(-135deg) → UP arrow, rotate(45deg) → DOWN arrow. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(-135deg) !important;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(45deg) !important;
}
/* The collapse tab's existing title-text span is hidden when reduced
   to a pill — there's no horizontal room. The chevron alone reads
   correctly. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-title,
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-icon
{
	display: none;
}

/* Drag-active state — disable text selection + change cursor globally
   so resize feels solid even when the cursor briefly leaves the handle. */
.pict-modal-shell-dragging-x, .pict-modal-shell-dragging-y { user-select: none; }
.pict-modal-shell-dragging-x * { cursor: col-resize !important; }
.pict-modal-shell-dragging-y * { cursor: row-resize !important; }

/* Per-panel resize-active state — kills the panel's collapse/expand
   width/height transition for the duration of a drag. Without this,
   every pointermove starts a fresh 140 ms transition and the resize
   visibly lags behind the cursor ("choppy"). With it disabled the
   panel snaps to the new size on the same frame as the pointer, which
   feels native. */
.pict-modal-shell-panel-resizing { transition: none !important; }
.pict-modal-shell-panel-resizing > .pict-modal-shell-panel-resize-handle
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.5;
}

/* Panel popup-attention flash — fires when popup() is called on an
   already-open panel. Brief brand-colored inset glow so the user sees
   that their click landed even though the panel didn't change shape.
   Class is added by the shell, auto-removed after ~700 ms. */
@keyframes pict-modal-shell-panel-flash
{
	0%   { box-shadow: inset 0 0 0 0 transparent; }
	30%  { box-shadow: inset 0 0 0 3px var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)); }
	100% { box-shadow: inset 0 0 0 0 transparent; }
}
.pict-modal-shell-panel-flash
{
	animation: pict-modal-shell-panel-flash 600ms ease-out;
}
`
});

},{}],590:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictModalOverlay = require('./Pict-Modal-Overlay.js');
const libPictModalConfirm = require('./Pict-Modal-Confirm.js');
const libPictModalWindow = require('./Pict-Modal-Window.js');
const libPictModalToast = require('./Pict-Modal-Toast.js');
const libPictModalTooltip = require('./Pict-Modal-Tooltip.js');
const libPictModalPanel = require('./Pict-Modal-Panel.js');
const libPictModalDropdown = require('./Pict-Modal-Dropdown.js');
const libPictModalShell = require('./Pict-Modal-Shell.js');

const _DefaultConfiguration = require('./Pict-Section-Modal-DefaultConfiguration.js');

class PictSectionModal extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this._activeModals = [];
		this._activeTooltips = [];
		this._activeToasts = [];
		this._idCounter = 0;

		this._overlay = new libPictModalOverlay(this);
		this._confirm = new libPictModalConfirm(this);
		this._window = new libPictModalWindow(this);
		this._toast = new libPictModalToast(this);
		this._tooltip = new libPictModalTooltip(this);
		this._panel = new libPictModalPanel(this);
		this._dropdown = new libPictModalDropdown(this);
		this._shell = new libPictModalShell(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Ensure the root class is on the body for CSS variable scoping
		if (typeof document !== 'undefined' && document.body)
		{
			if (!document.body.classList.contains('pict-modal-root'))
			{
				document.body.classList.add('pict-modal-root');
			}
		}

		return super.onBeforeInitialize();
	}

	/**
	 * Generate a unique ID for DOM elements.
	 *
	 * @returns {number}
	 */
	_nextId()
	{
		this._idCounter++;
		return this._idCounter;
	}

	// -- Confirm API --

	/**
	 * Show a confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmLabel, cancelLabel, dangerous }
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		return this._confirm.confirm(pMessage, pOptions);
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is set, the user must type it to enable the confirm button.
	 * If no confirmPhrase, the first click changes the button text and the second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel }
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		return this._confirm.doubleConfirm(pMessage, pOptions);
	}

	// -- Modal Window API --

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options { title, content, buttons, closeable, width, onOpen, onClose }
	 * @returns {Promise<string|null>} Resolves with the clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		return this._window.show(pOptions);
	}

	// -- Tooltip API --

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options { position, delay, maxWidth }
	 * @returns {{ destroy: function }}
	 */
	tooltip(pElement, pText, pOptions)
	{
		return this._tooltip.tooltip(pElement, pText, pOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive }
	 * @returns {{ destroy: function }}
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.richTooltip(pElement, pHTMLContent, pOptions);
	}

	/**
	 * Attach a pinnable rich HTML tooltip to an element. Hover/focus behaves
	 * like richTooltip(); a click on the element toggles a pinned state that
	 * keeps the tooltip open and follows the anchor on scroll/resize.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive, startPinned, onPinChange }
	 * @returns {{ destroy: function, pin: function, unpin: function, isPinned: function }}
	 */
	pinnableTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.pinnableTooltip(pElement, pHTMLContent, pOptions);
	}

	// -- Toast API --

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message
	 * @param {object} [pOptions] - Options { type, duration, position, dismissible }
	 * @returns {{ dismiss: function }}
	 */
	toast(pMessage, pOptions)
	{
		return this._toast.toast(pMessage, pOptions);
	}

	// -- Dropdown API --

	/**
	 * Open an anchor-positioned dropdown menu (no backdrop, click-outside
	 * dismisses). Useful for nav menus and split-button addenda. Pass
	 * `ContentHTML` instead of `items` to render a free-form anchored popover
	 * (rich card, pre-rendered template menu) with the same dismiss/flip behavior.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   { left, top, width, height } rect for context-menu style anchoring.
	 * @param {object} pOptions - { items | ContentHTML, align, position, minWidth,
	 *   maxWidth, maxHeight, className, closeOnSelect, onSelect, onClose }
	 * @returns {Promise<{Hash, Item}|null>} Selection or null on dismiss
	 *   (always resolves null in ContentHTML mode).
	 */
	dropdown(pAnchor, pOptions)
	{
		return this._dropdown.dropdown(pAnchor, pOptions);
	}

	/**
	 * Dismiss any open dropdown.
	 */
	dismissDropdowns()
	{
		this._dropdown.dismissAll();
	}

	// -- Panel API --

	/**
	 * Attach resizable/collapsible panel behavior to a DOM element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Options { position, width, minWidth, maxWidth, collapsible, collapsed, persist, persistKey, onResize, onToggle }
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	panel(pTargetSelector, pOptions)
	{
		return this._panel.create(pTargetSelector, pOptions);
	}

	// -- Shell API --

	/**
	 * Get (or create) a layout shell for a viewport. Idempotent.
	 *
	 * The shell takes ownership of the viewport's contents and manages
	 * top / right / bottom / left panel placement plus a center area.
	 * See Pict-Modal-Shell.js for full panel-config semantics.
	 *
	 * @param {string|HTMLElement} pViewport - selector or element of the
	 *   container the shell should fill (commonly the app's root div).
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.Persistence=true]   - autosave panel state to localStorage
	 * @param {string}  [pOptions.PersistenceKey=null]- override scope (default: hostname)
	 * @returns {PictModalShell}
	 */
	shell(pViewport, pOptions)
	{
		return this._shell.shell(pViewport, pOptions);
	}

	// -- Cleanup API --

	/**
	 * Dismiss all open modals.
	 */
	dismissModals()
	{
		let tmpModals = this._activeModals.slice();
		for (let i = tmpModals.length - 1; i >= 0; i--)
		{
			tmpModals[i].dismiss(null);
		}
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissTooltips()
	{
		this._tooltip.dismissAll();
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissToasts()
	{
		this._toast.dismissAll();
	}

	/**
	 * Dismiss everything: modals, tooltips, and toasts.
	 */
	dismissAll()
	{
		this.dismissModals();
		this.dismissTooltips();
		this.dismissToasts();
		this.dismissDropdowns();
	}

	/**
	 * Clean up all DOM elements when the view is destroyed.
	 */
	/**
	 * Destroy all active panels.
	 */
	destroyPanels()
	{
		this._panel.destroyAll();
	}

	destroy()
	{
		this.dismissAll();
		this.destroyPanels();
		this._overlay.destroy();
		this._toast.destroy();
		if (typeof super.destroy === 'function') { return super.destroy(); }
	}
}

module.exports = PictSectionModal;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Modal-Confirm.js":581,"./Pict-Modal-Dropdown.js":582,"./Pict-Modal-Overlay.js":583,"./Pict-Modal-Panel.js":584,"./Pict-Modal-Shell.js":585,"./Pict-Modal-Toast.js":586,"./Pict-Modal-Tooltip.js":587,"./Pict-Modal-Window.js":588,"./Pict-Section-Modal-DefaultConfiguration.js":589,"pict-view":693}],591:[function(require,module,exports){
module.exports = (
{
	ViewIdentifier: 'Pict-ObjectEditor',

	DefaultRenderable: 'ObjectEditor-Container',
	DefaultDestinationAddress: '#ObjectEditor-Container',

	AutoRender: false,

	// Address in AppData where the JSON object lives
	ObjectDataAddress: false,

	// Maximum depth to auto-expand on initial load
	InitialExpandDepth: 1,

	// Whether editing is enabled (vs read-only inspector mode)
	Editable: true,

	// Whether to show type indicator badges
	ShowTypeIndicators: true,

	// Indentation pixels per depth level
	IndentPixels: 20,

	CSS: /*css*/`
.pict-objecteditor
{
	font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', 'JetBrains Mono', Consolas, monospace;
	font-size: 13px;
	line-height: 1.5;
	color: var(--theme-color-text-primary, #3D3229);
	background: var(--theme-color-background-panel, #FDFCFA);
	border: 1px solid var(--theme-color-border-default, #E8E3DA);
	border-radius: 6px;
	padding: 8px 0;
	overflow: auto;
}
.pict-oe-row
{
	display: flex;
	align-items: center;
	padding: 2px 12px 2px 0;
	min-height: 26px;
	cursor: default;
	border-radius: 3px;
}
.pict-oe-row:hover
{
	background: var(--theme-color-background-hover, #F5F0E8);
}
.pict-oe-toggle
{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	cursor: pointer;
	color: var(--theme-color-text-muted, #8A7F72);
	font-size: 10px;
	flex-shrink: 0;
	user-select: none;
	border-radius: 3px;
	transition: color 0.1s;
}
.pict-oe-toggle:hover
{
	background: var(--theme-color-border-default, #E8E3DA);
	color: var(--theme-color-text-primary, #3D3229);
}
.pict-oe-spacer
{
	display: inline-block;
	width: 16px;
	flex-shrink: 0;
}
.pict-oe-key
{
	color: var(--theme-color-syntax-property, #9E6B47);
	flex-shrink: 0;
}
.pict-oe-separator
{
	color: var(--theme-color-text-muted, #8A7F72);
	margin: 0 8px;
	flex-shrink: 0;
}
.pict-oe-value
{
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-oe-value-string
{
	color: var(--theme-color-syntax-string, #2E7D74);
}
.pict-oe-value-string::before
{
	content: '"';
	color: var(--theme-color-syntax-string, #A8CFC9);
}
.pict-oe-value-string::after
{
	content: '"';
	color: var(--theme-color-syntax-string, #A8CFC9);
}
.pict-oe-value-number
{
	color: var(--theme-color-syntax-number, #3B6DAA);
}
.pict-oe-value-boolean
{
	color: var(--theme-color-syntax-keyword, #8B5E3C);
	font-weight: 600;
}
.pict-oe-value-null
{
	color: var(--theme-color-syntax-keyword, #B0A89E);
	font-style: italic;
}
.pict-oe-summary
{
	color: var(--theme-color-text-placeholder, #B0A89E);
	margin-left: 6px;
	font-size: 12px;
}
.pict-oe-type-badge
{
	display: inline-block;
	font-size: 9px;
	padding: 0 4px;
	border-radius: 3px;
	background: var(--theme-color-background-tertiary, #F0ECE4);
	color: var(--theme-color-text-muted, #8A7F72);
	margin-left: 6px;
	line-height: 16px;
	vertical-align: middle;
}
.pict-oe-value-input
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-syntax-string, #2E7D74);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: inherit;
	outline: none;
	min-width: 80px;
}
.pict-oe-value-input:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-array-index
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-size: 11px;
}
.pict-oe-empty
{
	color: var(--theme-color-text-placeholder, #B0A89E);
	font-style: italic;
	padding: 8px 12px;
}
.pict-oe-actions
{
	margin-left: auto;
	padding-left: 12px;
	padding-right: 4px;
	opacity: 0.4;
	transition: opacity 0.15s;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 5px;
}
.pict-oe-row:hover .pict-oe-actions
{
	opacity: 1;
}
.pict-oe-action-btn
{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 22px;
	height: 22px;
	padding: 0 5px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #DDD8CF);
	background: var(--theme-color-background-hover, #F5F0E8);
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #8A7F72);
	user-select: none;
	box-sizing: border-box;
}
.pict-oe-action-btn:hover
{
	background: var(--theme-color-background-hover, #E8E3DA);
	border-color: var(--theme-color-border-default, #C5BFAE);
	color: var(--theme-color-text-primary, #3D3229);
}
.pict-oe-action-remove
{
	border-color: var(--theme-color-status-error, #E8C8C8);
	background: var(--theme-color-background-hover, #FAF0F0);
	color: var(--theme-color-status-error, #A04040);
}
.pict-oe-action-remove:hover
{
	background: var(--theme-color-background-hover, #F0D6D6);
	border-color: var(--theme-color-status-error, #D4A0A0);
	color: var(--theme-color-status-error, #A04040);
}
.pict-oe-action-move
{
	font-size: 9px;
}
.pict-oe-action-move:hover
{
	background: var(--theme-color-background-hover, #D6E4F0);
	border-color: var(--theme-color-status-info, #A8C4DA);
	color: var(--theme-color-status-info, #3B6DAA);
}
.pict-oe-action-add
{
	border-color: var(--theme-color-status-success, #C8D8C8);
	background: var(--theme-color-background-hover, #F0F5F0);
	color: var(--theme-color-status-success, #5A7A5A);
}
.pict-oe-action-add:hover
{
	background: var(--theme-color-background-hover, #D6E8D6);
	border-color: var(--theme-color-status-success, #A0C0A0);
	color: var(--theme-color-status-success, #3D5C3D);
}
.pict-oe-key-input
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-syntax-property, #9E6B47);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: var(--theme-color-syntax-property, #9E6B47);
	outline: none;
	min-width: 60px;
	margin-left: 6px;
}
.pict-oe-key-input:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-type-select
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-border-default, #C5BFAE);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: var(--theme-color-text-primary, #3D3229);
	outline: none;
	margin-left: 6px;
	cursor: pointer;
}
.pict-oe-type-select:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-root-add
{
	display: flex;
	align-items: center;
	padding: 4px 12px;
	min-height: 26px;
	cursor: default;
}
.pict-oe-root-add .pict-oe-action-btn
{
	width: auto;
	white-space: nowrap;
	padding: 0 8px;
}
`,

	MacroTemplates:
	{
		Node:
		{
			RowOpen: '<div class="pict-oe-row" style="padding-left:{~D:Record.PaddingLeft~}px" data-path="{~D:Record.EscapedPath~}">',
			RowClose: '</div>',
			Toggle: '<span class="pict-oe-toggle" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].toggleNode(\'{~D:Record.EscapedPath~}\')">{~D:Record.ToggleArrow~}</span>',
			Spacer: '<span class="pict-oe-spacer"></span>',
			KeyName: '<span class="pict-oe-key">{~D:Record.EscapedKey~}</span>',
			KeyIndex: '<span class="pict-oe-key"><span class="pict-oe-array-index">{~D:Record.ArrayIndex~}</span></span>',
			Separator: '<span class="pict-oe-separator">:</span>',
			TypeBadge: '<span class="pict-oe-type-badge">{~D:Record.TypeLabel~}</span>',
			Summary: '<span class="pict-oe-summary">{~D:Record.SummaryText~}</span>',
			ValueStringEditable: '<span class="pict-oe-value pict-oe-value-string" ondblclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginEdit(\'{~D:Record.EscapedPath~}\', \'string\')" title="{~D:Record.EscapedTitle~}">{~D:Record.EscapedValue~}</span>',
			ValueStringReadOnly: '<span class="pict-oe-value pict-oe-value-string" title="{~D:Record.EscapedTitle~}">{~D:Record.EscapedValue~}</span>',
			ValueNumberEditable: '<span class="pict-oe-value pict-oe-value-number" ondblclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginEdit(\'{~D:Record.EscapedPath~}\', \'number\')">{~D:Record.EscapedValue~}</span>',
			ValueNumberReadOnly: '<span class="pict-oe-value pict-oe-value-number">{~D:Record.EscapedValue~}</span>',
			ValueBooleanEditable: '<span class="pict-oe-value pict-oe-value-boolean" style="cursor:pointer" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].toggleBoolean(\'{~D:Record.EscapedPath~}\')">{~D:Record.DisplayValue~}</span>',
			ValueBooleanReadOnly: '<span class="pict-oe-value pict-oe-value-boolean">{~D:Record.DisplayValue~}</span>',
			ValueNull: '<span class="pict-oe-value pict-oe-value-null">null</span>',
			ActionsOpen: '<span class="pict-oe-actions">',
			ActionsClose: '</span>',
			ButtonRemove: '<span class="pict-oe-action-btn pict-oe-action-remove" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].removeNode(\'{~D:Record.EscapedPath~}\')" title="Remove">\u00D7</span>',
			ButtonAddObject: '<span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToObject(\'{~D:Record.EscapedPath~}\')" title="Add">+</span>',
			ButtonAddArray: '<span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToArray(\'{~D:Record.EscapedPath~}\')" title="Add">+</span>',
			ButtonMoveUp: '<span class="pict-oe-action-btn pict-oe-action-move" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].moveArrayElementUp(\'{~D:Record.EscapedArrayPath~}\', {~D:Record.ArrayIndex~})" title="Move up">\u25B2</span>',
			ButtonMoveDown: '<span class="pict-oe-action-btn pict-oe-action-move" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].moveArrayElementDown(\'{~D:Record.EscapedArrayPath~}\', {~D:Record.ArrayIndex~})" title="Move down">\u25BC</span>',
			RootAddObject: '<div class="pict-oe-root-add" data-path=""><span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToObject(\'\')" title="Add property">+ add property</span></div>',
			RootAddArray: '<div class="pict-oe-root-add" data-path=""><span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToArray(\'\')" title="Add element">+ add element</span></div>'
		}
	},

	Templates:
	[
		{
			Hash: 'ObjectEditor-Container-Template',
			Template: '<div class="pict-objecteditor" id="ObjectEditor-Tree-{~D:Context[0].Hash~}"></div>'
		},
		{
			Hash: 'ObjectEditor-Node-String',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Number',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Boolean',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Null',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Object',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Toggle~}{~D:Record.Macro.Key~}{~D:Record.Macro.TypeBadge~}{~D:Record.Macro.Summary~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Array',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Toggle~}{~D:Record.Macro.Key~}{~D:Record.Macro.TypeBadge~}{~D:Record.Macro.Summary~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'ObjectEditor-Container',
			TemplateHash: 'ObjectEditor-Container-Template',
			DestinationAddress: '#ObjectEditor-Container',
			RenderMethod: 'replace'
		}
	]
});

},{}],592:[function(require,module,exports){
// Pict Section: Object Editor
// A tree-based JSON object viewer and editor for Pict applications.

// The main object editor view class
module.exports = require('./views/PictView-ObjectEditor.js');

// Node type views
module.exports.PictViewObjectEditorNode = require('./views/PictView-ObjectEditor-Node.js');
module.exports.PictViewObjectEditorNodeString = require('./views/PictView-ObjectEditor-NodeString.js');
module.exports.PictViewObjectEditorNodeNumber = require('./views/PictView-ObjectEditor-NodeNumber.js');
module.exports.PictViewObjectEditorNodeBoolean = require('./views/PictView-ObjectEditor-NodeBoolean.js');
module.exports.PictViewObjectEditorNodeNull = require('./views/PictView-ObjectEditor-NodeNull.js');
module.exports.PictViewObjectEditorNodeObject = require('./views/PictView-ObjectEditor-NodeObject.js');
module.exports.PictViewObjectEditorNodeArray = require('./views/PictView-ObjectEditor-NodeArray.js');

// Default configuration
module.exports.default_configuration = require('./Pict-Section-ObjectEditor-DefaultConfiguration.js');

},{"./Pict-Section-ObjectEditor-DefaultConfiguration.js":591,"./views/PictView-ObjectEditor-Node.js":593,"./views/PictView-ObjectEditor-NodeArray.js":594,"./views/PictView-ObjectEditor-NodeBoolean.js":595,"./views/PictView-ObjectEditor-NodeNull.js":596,"./views/PictView-ObjectEditor-NodeNumber.js":597,"./views/PictView-ObjectEditor-NodeObject.js":598,"./views/PictView-ObjectEditor-NodeString.js":599,"./views/PictView-ObjectEditor.js":600}],593:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Base class for all object editor node type renderers.
 *
 * Each subclass implements renderNodeHTML() to return an HTML string
 * for a single tree row.  One instance per type, not per node.
 *
 * Rendering uses the Pict template system with MacroTemplates defined
 * in the view configuration.  Each macro is a Jellyfish template string
 * compiled against the node descriptor (Record) and the ObjectEditor
 * view (Context[0]).  Subclasses set type-specific properties on the
 * node descriptor, call compileMacros(), then resolve a per-type
 * template that references the compiled macros.
 */
class PictViewObjectEditorNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNode';

		// Reference to the parent ObjectEditor view; set by the orchestrator
		this._ObjectEditorView = null;
	}

	/**
	 * Render a single tree node row as an HTML string.
	 *
	 * @param {Object} pNode - Node descriptor { Path, Key, Depth, DataType, HasChildren, ChildCount, IsExpanded, IsArrayElement, ArrayIndex }
	 * @param {*} pValue - The actual value at this node's path
	 * @param {Object} pOptions - Editor options { Editable, ShowTypeIndicators, IndentPixels, ViewHash }
	 *
	 * @return {string} HTML string for this row
	 */
	renderNodeHTML(pNode, pValue, pOptions)
	{
		return '';
	}

	// --- Macro compilation ---

	/**
	 * Compile all MacroTemplates onto pNode.Macro.
	 *
	 * This sets computed display properties on the node descriptor,
	 * then resolves every MacroTemplate from the view configuration
	 * against the node (as Record) and the ObjectEditor view (as Context[0]).
	 *
	 * After this call, pNode.Macro contains the compiled HTML fragments
	 * ready to be composed by a per-type template.
	 */
	compileMacros(pNode, pValue, pOptions)
	{
		// Compute derived display properties on the node descriptor
		pNode.PaddingLeft = (pNode.Depth * pOptions.IndentPixels) + 12;
		pNode.EscapedPath = this.escapeAttribute(pNode.Path);
		pNode.EscapedKey = this.escapeHTML(String(pNode.Key));
		pNode.ToggleArrow = pNode.IsExpanded ? '\u25BC' : '\u25B6';

		// Parse out parent array path for move buttons
		let tmpBracketMatch = pNode.Path.match(/^(.*)\[(\d+)\]$/);
		if (tmpBracketMatch)
		{
			pNode.EscapedArrayPath = this.escapeAttribute(tmpBracketMatch[1]);
		}
		else
		{
			pNode.EscapedArrayPath = '';
		}

		// Compile each MacroTemplate onto pNode.Macro
		let tmpMacroTemplates = this._ObjectEditorView.options.MacroTemplates.Node;
		let tmpMacroKeys = Object.keys(tmpMacroTemplates);
		pNode.Macro = {};

		for (let i = 0; i < tmpMacroKeys.length; i++)
		{
			let tmpKey = tmpMacroKeys[i];
			pNode.Macro[tmpKey] = this.pict.parseTemplate(
				tmpMacroTemplates[tmpKey],
				pNode,
				null,
				[this._ObjectEditorView]
			);
		}

		// Set the Key macro conditionally: array index or key name
		if (pNode.IsArrayElement)
		{
			pNode.Macro.Key = pNode.Macro.KeyIndex;
		}
		else
		{
			pNode.Macro.Key = pNode.Macro.KeyName;
		}

		// Set TypeBadge to empty if ShowTypeIndicators is false
		if (!pOptions.ShowTypeIndicators)
		{
			pNode.Macro.TypeBadge = '';
		}
	}

	/**
	 * Compose action button macros for leaf nodes.
	 * Returns a compiled HTML string for the actions area.
	 */
	compileActions(pNode, pOptions)
	{
		if (!pOptions.Editable)
		{
			return '';
		}
		let tmpHTML = pNode.Macro.ActionsOpen;
		if (pNode.IsArrayElement)
		{
			tmpHTML += pNode.Macro.ButtonMoveUp + pNode.Macro.ButtonMoveDown;
		}
		tmpHTML += pNode.Macro.ButtonRemove;
		tmpHTML += pNode.Macro.ActionsClose;
		return tmpHTML;
	}

	/**
	 * Compose action button macros for container nodes (object/array).
	 * Includes an add button in addition to move and remove.
	 */
	compileContainerActions(pNode, pOptions, pContainerType)
	{
		if (!pOptions.Editable)
		{
			return '';
		}
		let tmpHTML = pNode.Macro.ActionsOpen;
		tmpHTML += (pContainerType === 'array') ? pNode.Macro.ButtonAddArray : pNode.Macro.ButtonAddObject;
		if (pNode.IsArrayElement)
		{
			tmpHTML += pNode.Macro.ButtonMoveUp + pNode.Macro.ButtonMoveDown;
		}
		tmpHTML += pNode.Macro.ButtonRemove;
		tmpHTML += pNode.Macro.ActionsClose;
		return tmpHTML;
	}

	/**
	 * Escape a string for safe use in HTML attributes.
	 */
	escapeAttribute(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	/**
	 * Escape a string for safe use in HTML content.
	 */
	escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

module.exports = PictViewObjectEditorNode;

},{"pict-view":693}],594:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeArray extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeArray';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpLength = Array.isArray(pValue) ? pValue.length : 0;

		pNode.TypeLabel = 'Array';
		let tmpNoun = (tmpLength === 1) ? 'item' : 'items';
		pNode.SummaryText = '[' + tmpLength + ' ' + tmpNoun + ']';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Compose container actions (includes add button)
		pNode.Macro.Actions = this.compileContainerActions(pNode, pOptions, 'array');

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Array'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeArray;

},{"./PictView-ObjectEditor-Node.js":593}],595:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeBoolean extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeBoolean';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		pNode.DisplayValue = pValue ? 'true' : 'false';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueBooleanEditable : pNode.Macro.ValueBooleanReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Boolean'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeBoolean;

},{"./PictView-ObjectEditor-Node.js":593}],596:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeNull extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeNull';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Null always uses the static ValueNull macro
		pNode.Macro.Value = pNode.Macro.ValueNull;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Null'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeNull;

},{"./PictView-ObjectEditor-Node.js":593}],597:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeNumber extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeNumber';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		pNode.EscapedValue = this.escapeHTML(String(pValue));

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueNumberEditable : pNode.Macro.ValueNumberReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Number'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeNumber;

},{"./PictView-ObjectEditor-Node.js":593}],598:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeObject extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeObject';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpKeyCount = 0;
		if (pValue && typeof pValue === 'object' && !Array.isArray(pValue))
		{
			tmpKeyCount = Object.keys(pValue).length;
		}

		pNode.TypeLabel = 'Object';
		let tmpNoun = (tmpKeyCount === 1) ? 'key' : 'keys';
		pNode.SummaryText = '{' + tmpKeyCount + ' ' + tmpNoun + '}';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Compose container actions (includes add button)
		pNode.Macro.Actions = this.compileContainerActions(pNode, pOptions, 'object');

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Object'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeObject;

},{"./PictView-ObjectEditor-Node.js":593}],599:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeString extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeString';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpDisplayValue = (typeof pValue === 'string') ? pValue : '';
		// Truncate long strings for display
		let tmpTruncated = tmpDisplayValue.length > 120 ? tmpDisplayValue.substring(0, 120) + '\u2026' : tmpDisplayValue;
		pNode.EscapedValue = this.escapeHTML(tmpTruncated);
		pNode.EscapedTitle = this.escapeAttribute(tmpDisplayValue);

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueStringEditable : pNode.Macro.ValueStringReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-String'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeString;

},{"./PictView-ObjectEditor-Node.js":593}],600:[function(require,module,exports){
const libPictView = require('pict-view');

const libNodeString = require('./PictView-ObjectEditor-NodeString.js');
const libNodeNumber = require('./PictView-ObjectEditor-NodeNumber.js');
const libNodeBoolean = require('./PictView-ObjectEditor-NodeBoolean.js');
const libNodeNull = require('./PictView-ObjectEditor-NodeNull.js');
const libNodeObject = require('./PictView-ObjectEditor-NodeObject.js');
const libNodeArray = require('./PictView-ObjectEditor-NodeArray.js');

const _DefaultConfiguration = require('../Pict-Section-ObjectEditor-DefaultConfiguration.js');

class PictViewObjectEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// Set of expanded path strings
		this._ExpandedPaths = new Set();

		// Map of data type -> node renderer instance
		this._NodeRenderers = {};
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Register node type service types if they aren't already present
		let tmpNodeTypes =
		{
			'PictViewObjectEditorNodeString': libNodeString,
			'PictViewObjectEditorNodeNumber': libNodeNumber,
			'PictViewObjectEditorNodeBoolean': libNodeBoolean,
			'PictViewObjectEditorNodeNull': libNodeNull,
			'PictViewObjectEditorNodeObject': libNodeObject,
			'PictViewObjectEditorNodeArray': libNodeArray
		};

		let tmpNodeTypeKeys = Object.keys(tmpNodeTypes);
		for (let i = 0; i < tmpNodeTypeKeys.length; i++)
		{
			let tmpKey = tmpNodeTypeKeys[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpKey))
			{
				this.fable.addServiceType(tmpKey, tmpNodeTypes[tmpKey]);
			}
		}

		// Instantiate one renderer per data type
		this._NodeRenderers.string = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeString');
		this._NodeRenderers.number = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeNumber');
		this._NodeRenderers.boolean = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeBoolean');
		this._NodeRenderers.null = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeNull');
		this._NodeRenderers.object = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeObject');
		this._NodeRenderers.array = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeArray');

		// Set back-references on each renderer
		let tmpRendererKeys = Object.keys(this._NodeRenderers);
		for (let i = 0; i < tmpRendererKeys.length; i++)
		{
			this._NodeRenderers[tmpRendererKeys[i]]._ObjectEditorView = this;
		}

		return super.onBeforeInitialize();
	}

	onAfterRender()
	{
		super.onAfterRender();

		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.initialRenderComplete = true;
			this.onAfterInitialRender();
		}

		// Always re-populate the tree after any render, since the container
		// template may have been re-rendered (e.g., by the application auto-render).
		this.renderTree();
	}

	onAfterInitialRender()
	{
		// Expand to the configured initial depth
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, this.options.InitialExpandDepth);
		}
	}

	// --- Public API ---

	/**
	 * Toggle expand/collapse on a node path.
	 */
	toggleNode(pPath)
	{
		if (this._ExpandedPaths.has(pPath))
		{
			this._ExpandedPaths.delete(pPath);
		}
		else
		{
			this._ExpandedPaths.add(pPath);
		}
		this.renderTree();
	}

	/**
	 * Toggle a boolean value at a path.
	 */
	toggleBoolean(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}
		let tmpCurrentValue = this._getValueAtPath(tmpData, pPath);
		this._setValueAtPath(tmpData, pPath, !tmpCurrentValue);
		this.renderTree();
	}

	/**
	 * Begin inline editing of a leaf node.
	 */
	beginEdit(pPath, pType)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpCurrentValue = this._getValueAtPath(tmpData, pPath);
		let tmpRowElement = this._getTreeElement().querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		let tmpValueSpan = tmpRowElement.querySelector('.pict-oe-value');
		if (!tmpValueSpan)
		{
			return;
		}

		let tmpInputType = (pType === 'number') ? 'number' : 'text';
		let tmpInputValue = (tmpCurrentValue === null || tmpCurrentValue === undefined) ? '' : String(tmpCurrentValue);
		let tmpEscapedPath = tmpInputValue.replace(/"/g, '&quot;');

		let tmpInput = document.createElement('input');
		tmpInput.type = tmpInputType;
		tmpInput.className = 'pict-oe-value-input';
		tmpInput.value = tmpInputValue;

		let tmpSelf = this;
		let tmpCommit = function()
		{
			let tmpNewValue = tmpInput.value;
			if (pType === 'number')
			{
				tmpNewValue = Number(tmpNewValue);
				if (isNaN(tmpNewValue))
				{
					tmpNewValue = 0;
				}
			}
			tmpSelf._setValueAtPath(tmpData, pPath, tmpNewValue);
			tmpSelf.renderTree();
		};

		tmpInput.addEventListener('blur', tmpCommit);
		tmpInput.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpInput.blur();
			}
			else if (pEvent.key === 'Escape')
			{
				// Cancel edit, just re-render
				tmpInput.removeEventListener('blur', tmpCommit);
				tmpSelf.renderTree();
			}
		});

		tmpValueSpan.innerHTML = '';
		tmpValueSpan.appendChild(tmpInput);
		tmpInput.focus();
		tmpInput.select();
	}

	/**
	 * Set a value at a dot-path in the object data and re-render.
	 */
	setValueAtPath(pPath, pValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}
		this._setValueAtPath(tmpData, pPath, pValue);
		this.renderTree();
	}

	/**
	 * Expand all nodes to a given depth.
	 */
	expandToDepth(pDepth)
	{
		this._ExpandedPaths.clear();
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, pDepth);
		}
		this.renderTree();
	}

	/**
	 * Expand all nodes in the tree.
	 */
	expandAll()
	{
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, Infinity);
		}
		this.renderTree();
	}

	/**
	 * Collapse all nodes in the tree.
	 */
	collapseAll()
	{
		this._ExpandedPaths.clear();
		this.renderTree();
	}

	// --- Add/Remove API ---

	/**
	 * Add a property to an object at a given path.
	 */
	addObjectProperty(pPath, pKey, pDefaultValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (tmpTarget === null || tmpTarget === undefined || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpValue = (pDefaultValue !== undefined) ? pDefaultValue : '';
		tmpTarget[pKey] = tmpValue;

		// Auto-expand the parent so the new property is visible
		if (pPath)
		{
			this._ExpandedPaths.add(pPath);
		}

		this.renderTree();
	}

	/**
	 * Remove a property from an object at a given path.
	 */
	removeObjectProperty(pPath, pKey)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (tmpTarget === null || tmpTarget === undefined || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpChildPath = pPath ? (pPath + '.' + pKey) : pKey;
		this._cleanupExpandedPaths(tmpChildPath);
		delete tmpTarget[pKey];

		this.renderTree();
	}

	/**
	 * Add an element to the end of an array at a given path.
	 */
	addArrayElement(pPath, pDefaultValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpValue = (pDefaultValue !== undefined) ? pDefaultValue : '';
		tmpTarget.push(tmpValue);

		// Auto-expand the parent so the new element is visible
		if (pPath)
		{
			this._ExpandedPaths.add(pPath);
		}

		this.renderTree();
	}

	/**
	 * Remove an element from an array at a given path by index.
	 */
	removeArrayElement(pPath, pIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex < 0 || tmpIntIndex >= tmpTarget.length)
		{
			return;
		}

		// Clean up expanded paths for the removed element and shift higher indices
		let tmpRemovedPath = pPath ? (pPath + '[' + tmpIntIndex + ']') : ('[' + tmpIntIndex + ']');
		this._cleanupExpandedPaths(tmpRemovedPath);
		this._shiftArrayExpandedPaths(pPath, tmpIntIndex, tmpTarget.length);

		tmpTarget.splice(tmpIntIndex, 1);

		this.renderTree();
	}

	/**
	 * Remove a node from its parent, auto-detecting whether parent is object or array.
	 * Works by parsing the path to find the parent and key/index.
	 */
	removeNode(pPath)
	{
		if (!pPath)
		{
			return;
		}

		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		// Determine if the last segment is a bracket index or a dot key
		let tmpBracketMatch = pPath.match(/^(.*)\[(\d+)\]$/);
		if (tmpBracketMatch)
		{
			// Array element: parent path is the part before [N]
			let tmpParentPath = tmpBracketMatch[1];
			let tmpIndex = parseInt(tmpBracketMatch[2], 10);
			this.removeArrayElement(tmpParentPath, tmpIndex);
		}
		else
		{
			// Object property: parent path is everything before the last dot
			let tmpLastDot = pPath.lastIndexOf('.');
			if (tmpLastDot === -1)
			{
				// Top-level key — parent is root
				let tmpKey = pPath;
				this.removeObjectProperty('', tmpKey);
			}
			else
			{
				let tmpParentPath = pPath.substring(0, tmpLastDot);
				let tmpKey = pPath.substring(tmpLastDot + 1);
				this.removeObjectProperty(tmpParentPath, tmpKey);
			}
		}
	}

	// --- Array Reorder API ---

	/**
	 * Move an array element up by one position (swap with the element before it).
	 * If already at index 0 this is a no-op.
	 */
	moveArrayElementUp(pPath, pIndex)
	{
		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex <= 0)
		{
			return;
		}
		this.moveArrayElementToIndex(pPath, tmpIntIndex, tmpIntIndex - 1);
	}

	/**
	 * Move an array element down by one position (swap with the element after it).
	 * If already at the last index this is a no-op.
	 */
	moveArrayElementDown(pPath, pIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex < 0 || tmpIntIndex >= tmpTarget.length - 1)
		{
			return;
		}
		this.moveArrayElementToIndex(pPath, tmpIntIndex, tmpIntIndex + 1);
	}

	/**
	 * Move an array element from one index to another.
	 * If pNewIndex is out of bounds it is clamped to [0, length-1].
	 */
	moveArrayElementToIndex(pPath, pFromIndex, pToIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpFrom = parseInt(pFromIndex, 10);
		if (isNaN(tmpFrom) || tmpFrom < 0 || tmpFrom >= tmpTarget.length)
		{
			return;
		}

		let tmpTo = parseInt(pToIndex, 10);
		if (isNaN(tmpTo))
		{
			return;
		}
		// Clamp to valid range
		if (tmpTo < 0)
		{
			tmpTo = 0;
		}
		if (tmpTo >= tmpTarget.length)
		{
			tmpTo = tmpTarget.length - 1;
		}

		if (tmpFrom === tmpTo)
		{
			return;
		}

		// Update expanded paths before mutating the array
		this._moveArrayExpandedPaths(pPath, tmpFrom, tmpTo, tmpTarget.length);

		// Splice the element out and insert at the new position
		let tmpElement = tmpTarget.splice(tmpFrom, 1)[0];
		tmpTarget.splice(tmpTo, 0, tmpElement);

		this.renderTree();
	}

	/**
	 * Begin adding a new property to an object by showing an inline key input
	 * and a type selector dropdown.
	 */
	beginAddToObject(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		let tmpRowElement = tmpTreeElement.querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		// Create an inline input for the key name
		let tmpInput = document.createElement('input');
		tmpInput.type = 'text';
		tmpInput.className = 'pict-oe-key-input';
		tmpInput.placeholder = 'key';

		// Create a type selector dropdown
		let tmpSelect = this._createTypeSelect();

		let tmpSelf = this;
		let tmpCommitted = false;
		let tmpCommit = function()
		{
			if (tmpCommitted)
			{
				return;
			}
			tmpCommitted = true;
			let tmpKey = tmpInput.value.trim();
			if (tmpKey)
			{
				let tmpDefaultValue = tmpSelf._getDefaultValueForType(tmpSelect.value);
				tmpSelf.addObjectProperty(pPath, tmpKey, tmpDefaultValue);
			}
			else
			{
				tmpSelf.renderTree();
			}
		};

		tmpInput.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		tmpSelect.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		// Commit when focus leaves both elements
		let tmpBlurTimeout = null;
		let tmpHandleBlur = function()
		{
			clearTimeout(tmpBlurTimeout);
			tmpBlurTimeout = setTimeout(function()
			{
				// Check if focus moved to the other element in the pair
				if (document.activeElement !== tmpInput && document.activeElement !== tmpSelect)
				{
					tmpCommit();
				}
			}, 150);
		};

		tmpInput.addEventListener('blur', tmpHandleBlur);
		tmpSelect.addEventListener('blur', tmpHandleBlur);

		// Insert before the actions container
		let tmpActionsSpan = tmpRowElement.querySelector('.pict-oe-actions');
		if (tmpActionsSpan)
		{
			tmpRowElement.insertBefore(tmpInput, tmpActionsSpan);
			tmpRowElement.insertBefore(tmpSelect, tmpActionsSpan);
		}
		else
		{
			tmpRowElement.appendChild(tmpInput);
			tmpRowElement.appendChild(tmpSelect);
		}
		tmpInput.focus();
	}

	/**
	 * Begin adding a new element to an array by showing a type selector dropdown.
	 */
	beginAddToArray(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		let tmpRowElement = tmpTreeElement.querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		// Create a type selector dropdown
		let tmpSelect = this._createTypeSelect();

		let tmpSelf = this;
		let tmpCommitted = false;
		let tmpCommit = function()
		{
			if (tmpCommitted)
			{
				return;
			}
			tmpCommitted = true;
			let tmpDefaultValue = tmpSelf._getDefaultValueForType(tmpSelect.value);
			tmpSelf.addArrayElement(pPath, tmpDefaultValue);
		};

		tmpSelect.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		tmpSelect.addEventListener('blur', function()
		{
			setTimeout(function()
			{
				tmpCommit();
			}, 100);
		});

		// Insert before the actions container
		let tmpActionsSpan = tmpRowElement.querySelector('.pict-oe-actions');
		if (tmpActionsSpan)
		{
			tmpRowElement.insertBefore(tmpSelect, tmpActionsSpan);
		}
		else
		{
			tmpRowElement.appendChild(tmpSelect);
		}
		tmpSelect.focus();
	}

	/**
	 * Create a type selector <select> element for choosing the type of a new entry.
	 */
	_createTypeSelect()
	{
		let tmpSelect = document.createElement('select');
		tmpSelect.className = 'pict-oe-type-select';

		let tmpTypes = ['String', 'Number', 'Boolean', 'Null', 'Object', 'Array'];
		for (let i = 0; i < tmpTypes.length; i++)
		{
			let tmpOption = document.createElement('option');
			tmpOption.value = tmpTypes[i];
			tmpOption.textContent = tmpTypes[i];
			tmpSelect.appendChild(tmpOption);
		}

		return tmpSelect;
	}

	/**
	 * Return the default value for a given type name.
	 */
	_getDefaultValueForType(pTypeName)
	{
		switch (pTypeName)
		{
			case 'Number':
				return 0;
			case 'Boolean':
				return false;
			case 'Null':
				return null;
			case 'Object':
				return {};
			case 'Array':
				return [];
			case 'String':
			default:
				return '';
		}
	}

	// --- Marshal lifecycle ---

	marshalToView()
	{
		this.renderTree();
		return super.marshalToView();
	}

	// --- Tree rendering ---

	/**
	 * Render the visible tree into the container element.
	 */
	renderTree()
	{
		let tmpData = this._resolveObjectData();
		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		if (tmpData === null || tmpData === undefined)
		{
			this.pict.ContentAssignment.assignContent(tmpTreeElement, '<div class="pict-oe-empty">No data</div>');
			return;
		}

		let tmpOptions =
		{
			Editable: this.options.Editable,
			ShowTypeIndicators: this.options.ShowTypeIndicators,
			IndentPixels: this.options.IndentPixels,
			ViewHash: this.Hash
		};

		let tmpHTML = '';

		if (typeof tmpData === 'object' && !Array.isArray(tmpData))
		{
			// Render top-level object keys without a root wrapper node
			tmpHTML = this._walkObject(tmpData, '', 0, tmpOptions, true);
			// Add a root-level "add property" button when editable
			if (tmpOptions.Editable)
			{
				tmpHTML += this.pict.parseTemplate(
					this.options.MacroTemplates.Node.RootAddObject,
					{},
					null,
					[this]
				);
			}
		}
		else if (Array.isArray(tmpData))
		{
			// Render top-level array elements without a root wrapper node
			tmpHTML = this._walkArray(tmpData, '', 0, tmpOptions, true);
			// Add a root-level "add element" button when editable
			if (tmpOptions.Editable)
			{
				tmpHTML += this.pict.parseTemplate(
					this.options.MacroTemplates.Node.RootAddArray,
					{},
					null,
					[this]
				);
			}
		}
		else
		{
			// Single primitive value at root
			let tmpNode =
			{
				Path: '',
				Key: '(root)',
				Depth: 0,
				DataType: this._getJsonType(tmpData),
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: false,
				ArrayIndex: -1
			};
			let tmpRenderer = this._NodeRenderers[tmpNode.DataType];
			if (tmpRenderer)
			{
				tmpHTML = tmpRenderer.renderNodeHTML(tmpNode, tmpData, tmpOptions);
			}
		}

		if (!tmpHTML)
		{
			tmpHTML = '<div class="pict-oe-empty">Empty object</div>';
		}

		this.pict.ContentAssignment.assignContent(tmpTreeElement, tmpHTML);
	}

	// --- Internal tree walking ---

	_walkObject(pValue, pBasePath, pDepth, pOptions, pIsRoot)
	{
		let tmpHTML = '';
		let tmpKeys = Object.keys(pValue);

		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pBasePath ? (pBasePath + '.' + tmpKey) : tmpKey;
			let tmpChildValue = pValue[tmpKey];
			let tmpType = this._getJsonType(tmpChildValue);

			let tmpNode =
			{
				Path: tmpChildPath,
				Key: tmpKey,
				Depth: pDepth,
				DataType: tmpType,
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: false,
				ArrayIndex: -1
			};

			if (tmpType === 'object')
			{
				let tmpChildKeys = (tmpChildValue !== null) ? Object.keys(tmpChildValue) : [];
				tmpNode.HasChildren = tmpChildKeys.length > 0;
				tmpNode.ChildCount = tmpChildKeys.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.object;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkObject(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else if (tmpType === 'array')
			{
				tmpNode.HasChildren = tmpChildValue.length > 0;
				tmpNode.ChildCount = tmpChildValue.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.array;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkArray(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else
			{
				let tmpRenderer = this._NodeRenderers[tmpType];
				if (tmpRenderer)
				{
					tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);
				}
			}
		}

		return tmpHTML;
	}

	_walkArray(pValue, pBasePath, pDepth, pOptions, pIsRoot)
	{
		let tmpHTML = '';

		for (let i = 0; i < pValue.length; i++)
		{
			let tmpChildPath = pBasePath ? (pBasePath + '[' + i + ']') : ('[' + i + ']');
			let tmpChildValue = pValue[i];
			let tmpType = this._getJsonType(tmpChildValue);

			let tmpNode =
			{
				Path: tmpChildPath,
				Key: String(i),
				Depth: pDepth,
				DataType: tmpType,
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: true,
				ArrayIndex: i
			};

			if (tmpType === 'object')
			{
				let tmpChildKeys = (tmpChildValue !== null) ? Object.keys(tmpChildValue) : [];
				tmpNode.HasChildren = tmpChildKeys.length > 0;
				tmpNode.ChildCount = tmpChildKeys.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.object;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkObject(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else if (tmpType === 'array')
			{
				tmpNode.HasChildren = tmpChildValue.length > 0;
				tmpNode.ChildCount = tmpChildValue.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.array;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkArray(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else
			{
				let tmpRenderer = this._NodeRenderers[tmpType];
				if (tmpRenderer)
				{
					tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);
				}
			}
		}

		return tmpHTML;
	}

	// --- Utility methods ---

	_getJsonType(pValue)
	{
		if (pValue === null || pValue === undefined)
		{
			return 'null';
		}
		if (Array.isArray(pValue))
		{
			return 'array';
		}
		let tmpType = typeof pValue;
		if (tmpType === 'object')
		{
			return 'object';
		}
		if (tmpType === 'number')
		{
			return 'number';
		}
		if (tmpType === 'boolean')
		{
			return 'boolean';
		}
		return 'string';
	}

	_resolveObjectData()
	{
		if (!this.options.ObjectDataAddress)
		{
			return null;
		}

		// Support "AppData.SomeKey" style addresses
		let tmpAddress = this.options.ObjectDataAddress;
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.fable;

		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}

		return tmpCurrent;
	}

	_getTreeElement()
	{
		let tmpElementId = 'ObjectEditor-Tree-' + this.Hash;
		let tmpElements = this.pict.ContentAssignment.getElement('#' + tmpElementId);
		if (tmpElements && tmpElements.length > 0)
		{
			return tmpElements[0];
		}
		return null;
	}

	_getValueAtPath(pObject, pPath)
	{
		if (!pPath)
		{
			return pObject;
		}

		let tmpSegments = this._parsePath(pPath);
		let tmpCurrent = pObject;

		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return undefined;
			}
			tmpCurrent = tmpCurrent[tmpSegments[i]];
		}

		return tmpCurrent;
	}

	_setValueAtPath(pObject, pPath, pValue)
	{
		if (!pPath)
		{
			return;
		}

		let tmpSegments = this._parsePath(pPath);
		let tmpCurrent = pObject;

		for (let i = 0; i < tmpSegments.length - 1; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return;
			}
			tmpCurrent = tmpCurrent[tmpSegments[i]];
		}

		if (tmpCurrent !== null && tmpCurrent !== undefined)
		{
			tmpCurrent[tmpSegments[tmpSegments.length - 1]] = pValue;
		}
	}

	/**
	 * Parse a dotted path with bracket notation into segments.
	 * e.g., "config.items[2].name" -> ["config", "items", 2, "name"]
	 */
	_parsePath(pPath)
	{
		let tmpSegments = [];
		let tmpParts = pPath.split('.');

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];
			// Check for bracket notation
			let tmpBracketMatch = tmpPart.match(/^([^\[]*)\[(\d+)\]$/);
			if (tmpBracketMatch)
			{
				if (tmpBracketMatch[1])
				{
					tmpSegments.push(tmpBracketMatch[1]);
				}
				tmpSegments.push(parseInt(tmpBracketMatch[2], 10));
			}
			else if (tmpPart)
			{
				tmpSegments.push(tmpPart);
			}
		}

		return tmpSegments;
	}

	/**
	 * Remove all expanded paths that reference a deleted subtree.
	 */
	_cleanupExpandedPaths(pRemovedPath)
	{
		let tmpToRemove = [];
		this._ExpandedPaths.forEach(function(tmpPath)
		{
			if (tmpPath === pRemovedPath || tmpPath.indexOf(pRemovedPath + '.') === 0 || tmpPath.indexOf(pRemovedPath + '[') === 0)
			{
				tmpToRemove.push(tmpPath);
			}
		});

		for (let i = 0; i < tmpToRemove.length; i++)
		{
			this._ExpandedPaths.delete(tmpToRemove[i]);
		}
	}

	/**
	 * After removing an array element, shift expanded paths for higher indices down by one.
	 * e.g., if we removed items[2], then items[3] becomes items[2], items[4] becomes items[3], etc.
	 */
	_shiftArrayExpandedPaths(pArrayPath, pRemovedIndex, pOriginalLength)
	{
		let tmpPrefix = pArrayPath ? pArrayPath : '';

		for (let i = pRemovedIndex + 1; i < pOriginalLength; i++)
		{
			let tmpOldPath = tmpPrefix + '[' + i + ']';
			let tmpNewPath = tmpPrefix + '[' + (i - 1) + ']';

			// Collect all expanded paths that start with the old path
			let tmpToRename = [];
			this._ExpandedPaths.forEach(function(tmpPath)
			{
				if (tmpPath === tmpOldPath)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath });
				}
				else if (tmpPath.indexOf(tmpOldPath + '.') === 0)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath + tmpPath.substring(tmpOldPath.length) });
				}
				else if (tmpPath.indexOf(tmpOldPath + '[') === 0)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath + tmpPath.substring(tmpOldPath.length) });
				}
			});

			for (let j = 0; j < tmpToRename.length; j++)
			{
				this._ExpandedPaths.delete(tmpToRename[j].old);
				this._ExpandedPaths.add(tmpToRename[j].replacement);
			}
		}
	}

	/**
	 * Update expanded paths when an array element moves from one index to another.
	 * Works by collecting all paths for every index in the affected range,
	 * then remapping them to their new positions.
	 */
	_moveArrayExpandedPaths(pArrayPath, pFromIndex, pToIndex, pLength)
	{
		let tmpPrefix = pArrayPath ? pArrayPath : '';

		// Determine the range of indices affected by the move
		let tmpMinIndex = Math.min(pFromIndex, pToIndex);
		let tmpMaxIndex = Math.max(pFromIndex, pToIndex);

		// Collect all expanded paths for every index in the affected range
		// Map: index -> array of { suffix } (the part after the [N])
		let tmpPathsByIndex = {};
		for (let i = tmpMinIndex; i <= tmpMaxIndex; i++)
		{
			tmpPathsByIndex[i] = [];
		}

		let tmpToRemove = [];
		let tmpSelf = this;

		this._ExpandedPaths.forEach(function(tmpPath)
		{
			for (let i = tmpMinIndex; i <= tmpMaxIndex; i++)
			{
				let tmpIndexPath = tmpPrefix + '[' + i + ']';
				if (tmpPath === tmpIndexPath)
				{
					tmpPathsByIndex[i].push('');
					tmpToRemove.push(tmpPath);
				}
				else if (tmpPath.indexOf(tmpIndexPath + '.') === 0)
				{
					tmpPathsByIndex[i].push(tmpPath.substring(tmpIndexPath.length));
					tmpToRemove.push(tmpPath);
				}
				else if (tmpPath.indexOf(tmpIndexPath + '[') === 0)
				{
					tmpPathsByIndex[i].push(tmpPath.substring(tmpIndexPath.length));
					tmpToRemove.push(tmpPath);
				}
			}
		});

		// Remove old paths
		for (let i = 0; i < tmpToRemove.length; i++)
		{
			this._ExpandedPaths.delete(tmpToRemove[i]);
		}

		// Compute new index mapping:
		// When moving from -> to, the element at pFromIndex goes to pToIndex,
		// and all elements between shift by 1 in the opposite direction.
		let tmpNewIndexMap = {};
		if (pFromIndex < pToIndex)
		{
			// Moving forward: elements between (from+1..to) shift down by 1
			tmpNewIndexMap[pFromIndex] = pToIndex;
			for (let i = pFromIndex + 1; i <= pToIndex; i++)
			{
				tmpNewIndexMap[i] = i - 1;
			}
		}
		else
		{
			// Moving backward: elements between (to..from-1) shift up by 1
			tmpNewIndexMap[pFromIndex] = pToIndex;
			for (let i = pToIndex; i < pFromIndex; i++)
			{
				tmpNewIndexMap[i] = i + 1;
			}
		}

		// Re-add paths at their new indices
		let tmpOldIndices = Object.keys(tmpPathsByIndex);
		for (let i = 0; i < tmpOldIndices.length; i++)
		{
			let tmpOldIndex = parseInt(tmpOldIndices[i], 10);
			let tmpNewIndex = tmpNewIndexMap[tmpOldIndex];
			let tmpSuffixes = tmpPathsByIndex[tmpOldIndex];
			for (let j = 0; j < tmpSuffixes.length; j++)
			{
				this._ExpandedPaths.add(tmpPrefix + '[' + tmpNewIndex + ']' + tmpSuffixes[j]);
			}
		}
	}

	/**
	 * Recursively expand paths up to a given depth.
	 */
	_expandToDepth(pValue, pBasePath, pCurrentDepth, pMaxDepth)
	{
		if (pValue === null || pValue === undefined || typeof pValue !== 'object')
		{
			return;
		}

		if (Array.isArray(pValue))
		{
			for (let i = 0; i < pValue.length; i++)
			{
				let tmpChildPath = pBasePath ? (pBasePath + '[' + i + ']') : ('[' + i + ']');
				if (typeof pValue[i] === 'object' && pValue[i] !== null)
				{
					// Mark this child as expanded (it's an object or array that can be toggled)
					this._ExpandedPaths.add(tmpChildPath);
					if (pCurrentDepth + 1 < pMaxDepth)
					{
						this._expandToDepth(pValue[i], tmpChildPath, pCurrentDepth + 1, pMaxDepth);
					}
				}
			}
		}
		else
		{
			let tmpKeys = Object.keys(pValue);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpKey = tmpKeys[i];
				let tmpChildPath = pBasePath ? (pBasePath + '.' + tmpKey) : tmpKey;
				let tmpChildValue = pValue[tmpKey];
				if (typeof tmpChildValue === 'object' && tmpChildValue !== null)
				{
					// Mark this child as expanded (it's an object or array that can be toggled)
					this._ExpandedPaths.add(tmpChildPath);
					if (pCurrentDepth + 1 < pMaxDepth)
					{
						this._expandToDepth(tmpChildValue, tmpChildPath, pCurrentDepth + 1, pMaxDepth);
					}
				}
			}
		}
	}
}

module.exports = PictViewObjectEditor;

module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-ObjectEditor-DefaultConfiguration.js":591,"./PictView-ObjectEditor-NodeArray.js":594,"./PictView-ObjectEditor-NodeBoolean.js":595,"./PictView-ObjectEditor-NodeNull.js":596,"./PictView-ObjectEditor-NodeNumber.js":597,"./PictView-ObjectEditor-NodeObject.js":598,"./PictView-ObjectEditor-NodeString.js":599,"pict-view":693}],601:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;
const css = String.raw;

const hatchScale = 1000;

function buildHatchPattern(color, bounds)
{
	const scaleFactor = bounds.x > bounds.y ? bounds.x : bounds.y;
	const scale = scaleFactor / hatchScale;
	const svg = /*html*/`
		<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
			<pattern id="hatch" width="9" height="1" patternUnits="userSpaceOnUse" patternTransform="rotate(45) scale(${ scale })">
				<rect x="0" y="0" width="3" height="1" fill="${ color }" fill-opacity="30%"/>
			</pattern>
		</svg>
	`;
	return "url('data:image/svg+xml;utf8, " + encodeURIComponent(svg) + "#hatch') !important;";
}

const default_configuration = 
{
	"RenderOnLoad": true,
	"DefaultRenderable": "OpenSeaDragon-Wrap",
	"DefaultDestinationAddress": "#OpenSeaDragon-Container-Div",
	"EnableAnnotation": false,
	"DisableFullscreen": true,
	"DisableButtons": false,
	"PrefixUrl": '/',
	"TileSources": {},
	"ViewAddress": 'PictSectionOpenSeaDragon',
	"OSDASViewAddress": 'PictSectionOpenSeaDragonAnnotationSelector',
	"Colors": {
		"red": "red",
		"green": "green",
		"blue": "blue"
	},
	"Annotations": [],
	"DrawModeLabel": "Annotation",
	"HatchModeLabel": "Hatching",
	"Templates": [
		{
			"Hash": "OpenSeaDragon-Container",
			"Template": html`
				<div class="osd-container-wrapper" id="OSD-Containers-Wrapper">
					<div id="OpenSeaDragon-Element" class="osd-default"></div>
					<div id="OSD-Toolbar" class="osd-height-zero osd-toolbar">
						<div id="DrawingToolbar" class="osd-drawing-toolbar"></div>
						<div id="ColorPickerToolbar" class="osd-color-picker-toolbar"></div>
					</div>
					<div id="DrawingModeToggle" class="osd-height-zero osd-drawmode-toggle-box">
					</div>
				</div>
				<div id="OSD-SVG-Sandbox" class="osd-sandbox"></div>
				<style id="ColorOverrides"></style>
				<style id="SelectedColorOverride"></style>
				<style id="OSDGeneralStyling">
					.osd-drawmode-toggle-box {
						display: flex;
					}
					.osd-drawmode-text {
						font-size: 17px;
						font-family: Lato,sans-serif;
						margin-left: 5px;
						margin-right: 5px;
					}
					.osd-drawmode-switch {
						position: relative;
						display: inline-block;
						width: 40px;
						height: 20px;
						background-color: rgba(0, 0, 0, 0.25);
						border-radius: 20px;
						transition: all 0.3s;
						cursor: pointer;
					}
					.osd-drawmode-switch::after {
						content: '';
						position: absolute;
						width: 18px;
						height: 18px;
						border-radius:50%;
						background-color: white;
						top: 1px;
						left: 1px;
						transition: all 0.3s;
					}
					.osd-drawmode-checkbox:checked + .osd-drawmode-switch::after {
						left : 20px;
					}
					.osd-drawmode-checkbox:checked + .osd-drawmode-switch {
						background-color: var(--theme-color-brand-primary, #7983ff);
					}
					.osd-drawmode-checkbox {
						display : none;
					}
					.osd-hatchmode-toggle-box {
						display: flex;
					}
					.osd-hatchmode-text {
						font-size: 17px;
						font-family: Lato,sans-serif;
						margin-left: 5px;
						margin-right: 5px;
					}
					.osd-hatchmode-switch {
						position: relative;
						display: inline-block;
						width: 40px;
						height: 20px;
						background-color: rgba(0, 0, 0, 0.25);
						border-radius: 20px;
						transition: all 0.3s;
						cursor: pointer;
						margin-left: 20px;
					}
					.osd-hatchmode-switch::after {
						content: '';
						position: absolute;
						width: 18px;
						height: 18px;
						border-radius:50%;
						background-color: white;
						top: 1px;
						left: 1px;
						transition: all 0.3s;
					}
					.osd-hatchmode-checkbox:checked + .osd-hatchmode-switch::after {
						left : 20px;
					}
					.osd-hatchmode-checkbox:checked + .osd-hatchmode-switch {
						background-color: var(--theme-color-brand-primary, #7983ff);
					}
					.osd-hatchmode-checkbox {
						display : none;
					}
					.osd-sandbox {
						pointer-events: none; 
						width: 100vw; 
						height: 100vh; 
						top:0; left:0; 
						background-color: transparent; 
						position: absolute;
					}
					.osd-container-wrapper {
						width: 100%; 
						height: 100%; 
						display: flex; 
						flex-direction: column;
					}
					.osd-drawing-toolbar {
						min-width: 320px;
					}
					.osd-color-picker-toolbar {
						display: flex; 
						flex-direction: row;
					}
					.osd-default {
						margin-left: 20px; 
						height: 100%;
						width: calc(100% - 25px);
					}
					.osd-color-active {
						background-color: rgba(0, 0, 0, 0.3) !important;
					}
					.osd-with-annotations {
						height: calc(100% - 55px) !important;
					}
					.osd-height-zero {
						height: 0px !important;
					}
					.osd-width-zero {
						width: 0px !important;
					}
					.osd-color-button-class {
						margin:4px 4px 4px 0;
						background-color: transparent;
						cursor: pointer;
						border-radius: 4px;
						padding: 8px;
						width: 45px;
						height: 45px;
						border: 0px;
					}
					.osd-color-button-class:hover {
						background-color:rgba(0,0,0,0.05);
					}
					.osd-toolbar {
						height: 55px;
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
					}
					.osd-annotations-panel-open {
						width: 80% !important
					}
					.osd-color-subcircle {
						display: block;
						height: 20px;
						width: 20px;
						border: 1px solid black;
						border-radius: 50%;
						margin: auto;
					}
				</style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "OpenSeaDragon-Wrap",
			"TemplateHash": "OpenSeaDragon-Container",
			"DestinationAddress": "#OpenSeaDragon-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#OpenSeaDragon-Container-Div"
};

class PictSectionOpenSeaDragon extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.triggerRender = false;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElementAddress = false;
	}

	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		this.hatchMode = false;
		let tmpTargetElementSet = this.services.ContentAssignment.getElement('#OpenSeaDragon-Element');
		if (tmpTargetElementSet.length < 1)
		{
			this.log.error(`Could not find target element [#OpenSeaDragon-Element] for OpenSeaDragon!  Rendering won't function properly.`);
			this.targetElement = false;
			return false;
		}
		else
		{
			this.targetElement = tmpTargetElementSet[0];
		}
		let tmpToolbarElementSet = this.services.ContentAssignment.getElement('#DrawingToolbar');
		if (tmpToolbarElementSet.length < 1)
		{
			this.log.error(`Could not find target element [#DrawingToolbar] for Annotator Toolbar!  Annotations won't function properly.`);
			this.toolbarElement = false;
			return false;
		}
		else
		{
			this.toolbarElement = tmpToolbarElementSet[0];
		}

		// Settings for configuring OpenSeaDragon.
		this.osdSettings = 
		{
			element: this.targetElement,
			prefixUrl: this.options.PrefixUrl,
			tileSources: this.options.TileSources,
			showFullPageControl: !this.options.DisableFullscreen,
			showZoomControl: !this.options.DisableButtons,
			showHomeControl: !this.options.DisableButtons
		};

		// Color formatter for Annotorious. Works with the styleClass attribute and the color class system which is config based.
		this.format = (annotation) => {
			return 'pict-osd-' + (annotation?.underlying?.target?.styleClass || (this.hatchMode ? this.color + '-hatched' : this.color) || 'red');
		};

		this.customConfigureViewerSettings();

		// Instantiate the OpenSeaDragon element.
		if (this.viewer)
		{
			this.viewer.destroy();
		}

		// Annotorious (and its plugin globals: Annotorious, SelectorPack, BetterPolygon, ...) is required by
		// default. Pass { Annotorious: false } in the view options to run as a plain OpenSeaDragon deep-zoom
		// viewer with no annotation layer, so a host need not load the Annotorious globals at all. Existing
		// consumers that do not set the flag are unaffected.
		this.annotoriousEnabled = (this.options.Annotorious !== false);
		// We only need to instantiate Annotorious if a set of annotations were passed in, or annotation editing is enabled.
		this.editingEnabled = this.annotoriousEnabled && this.options.EnableAnnotation && this.toolbarElement;

		this.viewer = OpenSeadragon(this.osdSettings);
		this.viewer.addHandler('open', () => {
			// Inject a stylesheet based on the set of colors passed into the component.
			let colorStyles = '';
			if (Object.keys(this.options?.Colors)?.length)
			{
				this.colorSet = this.options.Colors;
				for (let color of Object.keys(this.colorSet))
				{
					colorStyles += css`
						.pict-osd-${ color } > * {
							stroke: ${ this.colorSet[color] } !important;
							stroke-width: 2 !important;
						}
						.pict-osd-fill-${ color } {
							fill: ${ this.colorSet[color] } !important;
						}
						.pict-osd-${ color }-hatched > * {
							stroke: ${ this.colorSet[color] } !important;
							stroke-width: 2 !important;
							fill: ${ buildHatchPattern(this.colorSet[color], this.viewer?.world?.getItemAt(0)?.getContentSize() || { x: hatchScale, y: hatchScale }) }
						}
					`;
				}
			}
			else
			{
				this.assignColor('red');
				colorStyles += css`
					.pict-osd-red > * {
						stroke: red !important;
						stroke-width: 2 !important;
					}
				`;
			}
			this.pict.ContentAssignment.assignContent('#ColorOverrides', colorStyles);
			// If a custom color set was passed via config, add those custom colors to the toolbar if editing is enabled.
			if (this.colorSet && this.editingEnabled)
			{
				let colorSelectorTemplate = ``;
				for (let color of Object.keys(this.colorSet))
				{
					colorSelectorTemplate += html`
						<button type="button" class="osd-color-button-class" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.assignColor('${ color }')" id="ColorSelector${ color }">
							<div title="Color ${ color }" style="background-color: ${ this.colorSet[color] };" class="osd-color-subcircle"></div>
						</button>
					`;
				}
				this.pict.ContentAssignment.assignContent('#ColorPickerToolbar', `
					${ colorSelectorTemplate }
				`);
				this.assignColor(Object.keys(this.colorSet)[0]);
			}
			else
			{
				this.assignColor('red');
			}
		});

		if (this.annotoriousEnabled && (this.editingEnabled || this.options.Annotations?.length))
		{
			this.AnnotationsPanel = this.pict.views?.[this.options.OSDASViewAddress];
			if (!this.AnnotationsPanel)
			{
				this.triggerRender = true;
			}
			if (this.AnnotationsPanel && this.triggerRender)
			{
				this.triggerRender = false;
				this.AnnotationsPanel.render();
			}

			// Settings for configuring Annotorious.
			this.annoSettings = {
				allowEmpty: true,
				disableEditor: !this.editingEnabled,
				disableSelect: !this.editingEnabled
			};

			if (this.annotator){
				this.annotator.destroy();
			}

			// Instantiate Annotorious.
			this.annotator = OpenSeadragon.Annotorious(this.viewer, this.annoSettings);	

			// Apply the custom color formatter.
			this.annotator.formatters = [this.format];

			// Instantiate Annotorious Plugins.
			Annotorious.SelectorPack(this.annotator, 
			{
				tools: ['circle', 'ellipse', 'rect', 'freehand', 'polygon', 'line']
			});
			Annotorious.BetterPolygon(this.annotator);
			
			if (Annotorious.PictPack)
			{
				Annotorious.PictPack(this.annotator);
			}

			// If editing is enabled, reflow the ui to include the editing toolbar.
			if (this.editingEnabled)
			{
				this.pict.ContentAssignment.addClass('#OpenSeaDragon-Element', 'osd-with-annotations');
				this.pict.ContentAssignment.removeClass('#OSD-Toolbar', 'osd-height-zero');
				this.pict.ContentAssignment.removeClass('#DrawingModeToggle', 'osd-height-zero');
				Annotorious.Toolbar(this.annotator, this.toolbarElement, { withMouse: true, withTooltip:false });
			}

			//Inject any annotations passed via config.
			if (this.options.Annotations?.length)
			{
				for (let a of this.options.Annotations)
				{
					this.annotator.addAnnotation(a);
				}
				this.AnnotationsPanel?.updateAnnotationsPanel();
			}

			// Apply hooks for the annotation events.
			this.annotator.on('createAnnotation', (annotation, overrideID) => { this.annotationCreationHook(annotation, overrideID) });
			this.annotator.on('selectAnnotation', (annotation, element) => { this.annotationSelectionHook(annotation, element); });
			this.annotator.on('updateAnnotation', (annotation, previousState) => { this.annotationUpdateHook(annotation, previousState); });
			this.annotator.on('deleteAnnotation', (annotation) => { this.annotationDeleteHook(annotation); });
			this.annotator.on('createSelection', async (selection) => { this.selectionCreateHook(selection) });
			this.viewer.addHandler('canvas-double-click', (event) => { this.canvasDoubleClickHook(event); });

			if (this.editingEnabled)
			{
				const drawingModeTemplate = html`
					<input title="Toggle ${ this.options?.DrawModeLabel || 'Annotation' }" type="checkbox" id="osd-drawmode-toggle" class="osd-drawmode-checkbox" checked onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.toggleDrawingMode()"/>  
					<label for="osd-drawmode-toggle" class="osd-drawmode-switch"></label>
			 		<span title="Toggle ${ this.options?.DrawModeLabel || 'Annotation' }" class="osd-drawmode-text"> ${ this.options?.DrawModeLabel || 'Annotation' } </span>
					<input title="Toggle ${ this.options?.HatchModeLabel || 'Hatching' }" type="checkbox" id="osd-hatchmode-toggle" class="osd-hatchmode-checkbox" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.toggleHatchMode()"/>  
					<label for="osd-hatchmode-toggle" class="osd-hatchmode-switch"></label>
			 		<span title="Toggle ${ this.options?.HatchModeLabel || 'Hatching' }" class="osd-hatchmode-text"> ${ this.options?.HatchModeLabel || 'Hatching' } </span>`;
				this.pict.ContentAssignment.assignContent('#DrawingModeToggle', `
					${ drawingModeTemplate }
				`);
				const arrowToolButton = html`
					<button type="button" class="a9s-toolbar-btn arrow" title="Arrow" aria-label="Create a Arrow annotation" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.selectDrawingTool(event, 'arrow')">
						<span class="a9s-toolbar-btn-inner">
							<svg viewBox="0 0 70 50">
								<g>
									<path d="M 12 47 L 55 14 L 52 10 L 60 10 L 60 18 L 55 14 Z"></path>
									<g class="handles">
										<circle cx="12" cy="47" r="5"></circle>
									</g>
								</g>
							</svg>
						</span>
					</button>`;
				this.pict.ContentAssignment.appendContent('#DrawingToolbar .a9s-toolbar', arrowToolButton);
				this.annotator.disableEditor = false;
			}
		}
		else if (this.annotoriousEnabled)
		{
			// Instantiate Annotorious then destroy it in case there's any left over state that needs to be cleared.
			this.annotator = OpenSeadragon.Annotorious(this.viewer, {
				disableEditor: true,
				disableSelect: true
			});	
			this.annotator.destroy();
		}
	}

	// Set a new tile source. Can optionally rerender the component as well.
	setTileSources(tileSources, reRender)
	{
		this.options.TileSources = tileSources;
		if (reRender)
		{
			this.render();
		}
	}

	// Set an Annotation set. Can optionally rerender component as well.
	setAnnotations(annotations, reRender)
	{
		if (this.annotator) { this.annotator.clearAnnotations(); }
		this.options.Annotations = annotations;
		if (reRender)
		{
			this.render();
		}
	}

	/**
	 * This is expected to be overloaded with anything that needs to be added to the OpenSeaDragon configuration.
	 */
	customConfigureViewerSettings ()
	{
		// This can be overloaded to tweak this.osdSettings and this.annoSettings.
	}

	// Sets the current drawing color for annotations.
	assignColor (color)
	{
		this.color = color;
		if (this.colorSet)
		{
			for (let tempColor of Object.keys(this.colorSet))
			{
				this.pict.ContentAssignment.removeClass(`#ColorSelector${ tempColor }`, 'osd-color-active');
			}
		}

		// Set the active color in the toolbar.
		this.pict.ContentAssignment.addClass(`#ColorSelector${ color }`, 'osd-color-active');

		// Override the annotator drawing styles based on the selected color.
		this.pict.ContentAssignment.assignContent('#SelectedColorOverride', css`
			.a9s-annotation.editable.selected > g > * {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
			.a9s-selection > g > path {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
			.a9s-selection > * {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
		`);
	}

	/**
	 * @spec focuses the viewport on the referenced annotation, if one exists
	 * @param { number | string } annotationID - the id of an annotation
	 * @returns {void}
	 */
	focusOnAnnotation(annotationID)
	{
		this.log.debug(`[focusOnAnnotation] id[${annotationID}]`);
		if (!annotationID)
		{
			this.log.warn('[focusOnAnnotation] no id provided, cannot focus on the associated element');
			return;
		}
		this.annotator.fitBoundsWithConstraints(annotationID);
	}

	/**
	 * @param {object} point - something like an OpenSeaDragon.Point, anything with an x and y property
	 */
	focusOnPoint(point)
	{
		let vp = this.viewer.viewport.viewerElementToViewportCoordinates(point);
		this.viewer.viewport.panTo(vp);
		// TODO should we re-apply constraints here? Not sure it's needed...
	}

	// Hook that runs when an annotation gets selected. By default, this just stores the style of the annotation element as part of the annotation.
	annotationCreationHook (annotation, overrideID)
	{
		if (annotation?.target){
			annotation.stylesheet = this.hatchMode ? 
			{
				"type": "CssStylesheet",
				"value": css`
					.${ this.color }-hatched > * { 
						stroke: ${ this.colorSet?.[this.color] } !important;
						stroke-width: 2 !important; 
						fill: ${ buildHatchPattern(this.colorSet?.[this.color], this.viewer?.world?.getItemAt(0)?.getContentSize() || { x: hatchScale, y: hatchScale }) }
					}
				`
			} :
			{
				"type": "CssStylesheet",
				"value": css`
					.${ this.color } > * { 
						stroke: ${ this.colorSet?.[this.color] } !important;
						stroke-width: 2 !important; 
					}
				`
			};
			annotation.target.styleClass = this.hatchMode ? `${ this.color }-hatched` : this.color;
		}
		this.AnnotationsPanel?.updateAnnotationsPanel();
	}

	// Hook that runs when an annotation gets selected. By default, this just sets the current color to whatever the selected annotation is.
	annotationSelectionHook (annotation, element)
	{
		this.assignColor(annotation?.target?.styleClass?.replace('-hatched', '') || 'red');
		if (annotation?.target?.styleClass?.includes('hatched'))
		{
			document.querySelector('#osd-hatchmode-toggle').checked = true;
			this.hatchMode = true;
		}
		else
		{
			document.querySelector('#osd-hatchmode-toggle').checked = false;
			this.hatchMode = false;
		}
		this.releaseAnnotations();
		this.focusOnAnnotation(annotation.id);
	}

	// Hook that runs when an annotation gets updated. By default this is used for updating the state of the comments side bar.
	annotationUpdateHook (annotation, previousState)
	{
		if (this.annotator?.disableEditor)
		{
			setTimeout(()=>
			{
				this.AnnotationsPanel?.updateAnnotationsPanel();
			}, 10);
		}
		else
		{
			this.AnnotationsPanel?.updateAnnotationsPanel();
		}
	}

	// Hook that runs when an annotation gets delete. By default this is used for updating the state of the comments side bar.
	annotationDeleteHook (annotation)
	{
		this.AnnotationsPanel?.updateAnnotationsPanel();
	}

	/**
	 * @spec handles the createSelection event.
	 * @param {object} selection - selection object from Annotorious API
	 */
	async selectionCreateHook (selection)
	{
		if (this.annotator.disableEditor)
		{
			// note: this updateSelected is async
			this.annotator.updateSelected(selection, true);
		}
		/**
		 * ideal: focus on selection so user can better interact with it in the viewport.
		 * Issue is, the selection doesn't yet have an ID, so cannot tell
		 * Annotorious to adjust the viewport for us.
		 * this.focusOnAnnotation(selection.id);
		 */
	}

	/**
	 *
	 * @returns {boolean} value of "current zoom >= max zoom (configured for osd)"
	 */
	maxZoomReached ()
	{
		const maxZoom = this.viewer.viewport.getMaxZoom();
		const zoom = this.viewer.viewport.getZoom(true);
		return zoom >= maxZoom;
	}

	/**
	 * @spec focuses on the point where the user double clicked.
	 * @spec we only refocus when maxZoom has been reached to avoid clashing with single click zoom behavior
	 * @param {object} event
	 */
	canvasDoubleClickHook (event)
	{
		if (this.maxZoomReached())
		{
			this.focusOnPoint(event.position);
		}
	}

	// Toggles the annotator between "drawing only" mode and "commenting" mode.
	toggleDrawingMode ()
	{
		if (this.annotator)
		{
			this.annotator.disableEditor = !this.annotator.disableEditor;
		}
	}

	// Toggle on/off the hatch fill mode.
	toggleHatchMode ()
	{
		this.hatchMode = !this.hatchMode;
	}

	selectDrawingTool(event, id)
	{
		this.toolbarElement.querySelector('.a9s-toolbar-btn.active')?.classList.remove('active');
		const button = event.target.closest('button');
		if (!button?.classList.contains('active'))
		{
			button.classList.add('active');
		}
		this.annotator.setDrawingTool(id);
      	this.annotator.setDrawingEnabled(true);
	}

	// Passes an annotation selection event onto the annotator plus does some extra handling to scroll it into view.
	selectAnnotation(id)
	{
		if (this.editingEnabled)
		{
			this.annotator.selectAnnotation(id);
		}
		for (let a of this.captureAnnotations())
		{
			if (a.id === id)
			{
				this.annotationSelectionHook(a);
			}
		}

		// Pan/Zoom the OSD controller to the annotation that is being selected.
		this.annotator.fitBoundsWithConstraints(id);
	}

	// Adds a connecting line between a comment and an element.
	connectAnnotation(id)
	{
		let isSelectionOpen = this.annotator.getSelected();
		if (isSelectionOpen) {
			this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
			return;
		}
		const safeID = id.replaceAll('#', '');
		this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
		const commentElement = this.pict.ContentAssignment.getElement(`#OSD-Comment-${ safeID }`);
		const annotationElement = this.pict.ContentAssignment.getElement(`[data-id="${ id }"]`);
		if (!commentElement?.[0] || !annotationElement?.[0])
		{
			this.log.warn('An expected element was missing, cannot render annotation connection with id: ', id);
			return;
		}
		const osdElementPosition = this?.viewer?.element?.getBoundingClientRect();
		const commentPosition = commentElement?.[0]?.getBoundingClientRect();
		let annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
		const isInView = () => 
		{
			return annotationPosition.top >= osdElementPosition.top &&
				   annotationPosition.left >= osdElementPosition.left &&
				   annotationPosition.left + annotationPosition.width <= osdElementPosition.left + osdElementPosition.width &&
				   annotationPosition.height + annotationPosition.height <= osdElementPosition.height + osdElementPosition.height;
		};
		const performGraphics = () => 
		{
			annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
			let colorClass = '';
			let fillClass = '';
			for (let a of this.captureAnnotations())
			{
				if (a.id === id)
				{
					colorClass = 'pict-osd-' + a?.target?.styleClass;
					fillClass = 'pict-osd-fill-' + a?.target?.styleClass;
				}
			}
			const lineTemplate = html`
				<style>
					.osd-connector-svg {
						z-index: 9999999;
						width: 100%;
						height: 100%;
					}
					.osd-connector-rect.osd-connector-specific {
						stroke: transparent !important;
					}
					.osd-connector-line.osd-connector-specific {
						stroke-width: 2.5 !important;
					}
				</style>
				<svg class="${ colorClass } osd-connector-svg">
					<rect class="osd-connector-rect osd-connector-specific" fill="rgb(255, 234, 0, 0.2)" x="${ annotationPosition.left }" y="${ annotationPosition.top }" width="${ annotationPosition.width }" height="${ annotationPosition.height }" />
					<line class="osd-connector-line osd-connector-specific" x1="${ commentPosition.left + 5  }" y1="${ commentPosition.top + 5 }" x2="${ annotationPosition.left + annotationPosition.width/2 }" y2="${ annotationPosition.top + annotationPosition.height/2 }" id="line1"/>
					<circle class="${ fillClass }" cx="${ annotationPosition.left + annotationPosition.width/2 }" cy="${ annotationPosition.top + annotationPosition.height/2 }" r="5" />
				</svg>`;

			const triggeringElement = this.pict.ContentAssignment.getElement(`#OSD-Comment-Outer-${ safeID }`);
			isSelectionOpen = this.annotator.getSelected();
			// Only render the svg elements if the user is still hovering and selection is not being edited.
			if (triggeringElement?.[0]?.matches(':hover') && !isSelectionOpen) {
				this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, lineTemplate);
			}
			else if (isSelectionOpen)
			{
				this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
			}
		}
		if (!isInView())
		{
			this.annotator.panTo(id);
			setTimeout(()=>
			{
				annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
				if (!isInView())
				{
					this.annotator.fitBoundsWithConstraints(id);
					setTimeout(()=>
					{
						performGraphics();
					}, 500);
				}
				else
				{
					performGraphics();
				}
			}, 1000)
		}
		else
		{
			performGraphics();
		}
	}

	// Removes any connecting lines between a comments and annotations.
	releaseAnnotations()
	{
		this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
	}

	/*
	 * Captures the current viewport relative to the overall image.
	 */
	captureViewport ()
	{
		if (this.viewer){
			return this.viewer.viewport.getBounds();
		}
		this.log.error('OpenSeaDragon is not initialized for some reason, giving back null.');
		return null;
	}

	/*
	 * Captures the annotation objects for the currently annotated image.
	 */
	captureAnnotations ()
	{
		if (this.annotator){
			return this.annotator.getAnnotations();
		}
		return [];
	}
		
}

module.exports = PictSectionOpenSeaDragon;
module.exports.default_configuration = default_configuration;


},{"pict-view":693}],602:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;
const css = String.raw;

const default_configuration = 
{
	"RenderOnLoad": true,
	"DefaultRenderable": "OpenSeaDragonAnnotationSelector-Wrap",
	"DefaultDestinationAddress": "#OpenSeaDragonAnnotationSelector-Container-Div",
	"ViewAddress": 'PictSectionOpenSeaDragonAnnotationSelector',
	"OSDViewAddress": "PictSectionOpenSeaDragon",
	"Colors": {
		"red": "red",
		"green": "green",
		"blue": "blue"
	},
	"Templates": [
		{
			"Hash": "OpenSeaDragonAnnotationSelector-Container",
			"Template": html`
				<div class="osd-scrollable-comments" id="OSD-Scrollable-Comments">
				</div>
				<style id="OSDASGeneralStyling">
					.osd-scrollable-comments {
						height: 100%;
						width: 100%;
						overflow-y: auto;
						padding: 5px;
						background-color: lightgrey;
					}
					.osd-editable-text {
						border-top: 1px solid lightgrey; 
						max-height: fit-content;
					}
					.osd-editor-inner {
						-webkit-box-shadow: none !important; 
						-moz-box-shadow: none !important; 
						box-shadow: none !important; 
						border-radius: 6px !important; 
						border: 1px solid lightgrey;
					}
					.osd-comment-holder {
						z-index: auto; 
						line-height: normal; 
						cursor: pointer; 
						max-width: 100%; 
						opacity: 1; 
						position: relative !important; 
						margin: 10px 0px 10px 0px;
						width: 100% !important;
					}
					.osd-comment-color-flag {
						height: 12px;
						width: 60%;
						border-bottom: 3px solid lightgrey;
						border-right: 3px solid lightgrey;
						display: block;
						border-radius: 6px 0px 25px 0px;
					}
					.osd-editor-inner:hover > span.osd-comment-color-flag{
						transform: translate(-2px, -2px);
						border-bottom: 5px solid lightgrey;
						border-right: 5px solid lightgrey;
					}
					.osdas-taglist {
						display: flex;
    					flex-wrap: wrap;
					}
					.osdas-widget {
						display: block !important;
					}
				</style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "OpenSeaDragonAnnotationSelector-Wrap",
			"TemplateHash": "OpenSeaDragonAnnotationSelector-Container",
			"DestinationAddress": "#OpenSeaDragonAnnotationSelector-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#OpenSeaDragonAnnotationSelector-Container-Div"
}

class PictSectionOpenSeaDragonAnnotationSelector extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.triggerRender = false;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElementAddress = false;
	}

	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		this.OSDSection = this.pict.views?.[this.options.OSDViewAddress];
		if (!this.OSDSection)
		{
			this.triggerRender = true;
		}
		if (this.OSDSection)
		{
			if (this.triggerRender)
			{
				this.triggerRender = false;
				this.OSDSection.render();
			}
			this.updateAnnotationsPanel();
		}
	}

	// Update the annotations side panel to include any annotation comments/tags, should be called anytime the annotation list gets changed (create/update/delete).
	updateAnnotationsPanel(annotations) {
		const annotationSet = annotations || this.OSDSection?.captureAnnotations() || [];
		annotationSet.sort((a,b)=>
		{
			if ( a.id < b.id ){
				return -1;
			}
			if ( a.id > b.id ){
				return 1;
			}
			return 0;
		});

		this.pict.ContentAssignment.assignContent('#OSD-Scrollable-Comments', '');
		let commentsTemplate = '';

		// Loop through the annotations and add any with comments or tags to the panel ui.
		for (let a of annotationSet)
		{
			let bodyCommentTemplate = '';
			let bodyTagTemplate = '';
			for (let b of a.body)
			{
				if (b.purpose === 'commenting' || b.purpose === 'replying')
				{
					bodyCommentTemplate += html`
						<div class="r6o-editable-text osd-editable-text">
							${ b.value }
						</div>
					`;
				}
				if (b.purpose === 'tagging')
				{
					bodyTagTemplate += html`
						<li>
							<span class="r6o-label">
								${ b.value }
							</span>
						</li>
					`;
				}
			}
			if (bodyCommentTemplate || bodyTagTemplate)
			{
				if (bodyCommentTemplate)
				{
					bodyCommentTemplate = html`
						<div disabled class="r6o-widget comment">
							${ bodyCommentTemplate }
						</div>
					`;
				}
				if (bodyTagTemplate)
				{
					bodyTagTemplate = html`
						<div class="r6o-widget r6o-tag osdas-widget">
							<ul class="r6o-taglist osdas-taglist">
								${ bodyTagTemplate }
							</ul>
						</div>
					`;
				}
				commentsTemplate += html`
					<div id="OSD-Comment-Outer-${ a.id.replaceAll('#', '') }" class="osd-comment-holder r6o-editor r6o-arrow-top r6o-arrow-left pushed right" onmouseover="_Pict.views.${ this.options.OSDViewAddress || 'PictSectionOpenSeaDragon' }.connectAnnotation('${ a.id }')" onmouseout="_Pict.views.${ this.options.OSDViewAddress || 'PictSectionOpenSeaDragon' }.releaseAnnotations()" onclick="_Pict.views.${ this.options.OSDViewAddress || 'PictSectionOpenSeaDragon' }.selectAnnotation('${ a.id }')">
						<div class="r6o-editor-inner osd-editor-inner">
							<span class="osd-comment-color-flag" id="OSD-Comment-${ a.id.replaceAll('#', '') }" style="background-color: ${ this.options.Colors[a?.target?.styleClass?.replace('-hatched', '')] || 'transparent' };"></span>
							${ bodyCommentTemplate }
							${ bodyTagTemplate }
						</div>
					</div>
				`;
			}
		}

		// If anything was added to the panel template, inject it back into the section and ensure the panel is open.
		if (commentsTemplate)
		{
			this.pict.ContentAssignment.assignContent('#OSD-Scrollable-Comments', commentsTemplate);
			this.pict.ContentAssignment.removeClass('#OSD-Container-Right', 'osd-width-zero');
			this.pict.ContentAssignment.addClass('#OSD-Container-Left', 'osd-annotations-panel-open');
		}
		else
		{
			// Otherwise, close the panel ui.
			this.pict.ContentAssignment.addClass('#OSD-Container-Right', 'osd-width-zero');
			this.pict.ContentAssignment.removeClass('#OSD-Container-Left', 'osd-annotations-panel-open');
		}
	}
}

module.exports = PictSectionOpenSeaDragonAnnotationSelector;
module.exports.default_configuration = default_configuration;


},{"pict-view":693}],603:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const default_configuration = 
{
	"RenderOnLoad": true,
	"DefaultRenderable": "PDFJS-Wrap",
	"DefaultDestinationAddress": "#PDFJS-Container-Div",
	"ViewAddress": 'PictSectionPDFJS',
	"theme": "dark",
	"styles": /*css*/``,
    "pdfUrl": "",
    "pdfjsPath": "./pdfjs-dist",
	"Templates": [
		{
			"Hash": "PDFJS-Container",
			"Template": /*html*/`
				<div id="pdfjs-info-banner" class="pdfjs-banner-container">
				</div>
                <div id="pdfjs-injectable" class="injectable-size">
                </div>
                <style>
                    .injectable-size {
                        height: 100%;
                    }
					.pdfjs-info-banner {
						display: inline-block;
						font-family: sans-serif;
						font-size: 1rem;
						align-content: center;
						padding-left: 10px;
						line-height: 100%;
						height: 30px;
						color: hsl(221deg, 14%, 29%);
					}
					.pdfjs-banner-close {
						display: inline-block;
						align-content: center;
						padding-right: 10px;
						line-height: 100%;
						height: 30px;
						font-weight: bold;
						cursor: pointer;
						color: hsl(221deg, 14%, 29%);
					}
					.pdfjs-banner-container {
						display: flex;
						background-color: hsl(45deg, 100%, 48%);
						width: 100%;
						justify-content: space-between;
					}
                </style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "PDFJS-Wrap",
			"TemplateHash": "PDFJS-Container",
			"DestinationAddress": "#PDFJS-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#PDFJS-Container-Div"
}

class PictSectionPDFJS extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
	}

	onBeforeInitialize()
	{
		this.pdfjsInstance = {};
		super.onBeforeInitialize();
	}

	onAfterRender()
	{
		const viewerEl = /*html*/`<pdfjs-viewer-element 
                                    class="injectable-size"
                                    src="${ this.options.pdfUrl }"
                                    viewer-path="${ this.options.pdfjsPath }"
									viewer-css-theme="${ this.options?.theme?.toUpperCase() || 'DARK' }"
									viewer-extra-styles="${ this.options?.styles }
															#editorStampButton {
																display: none;
															}
															#editorInkButton {
																display: none;
															}
															#editorFreeTextButton {
																display: none;
															}
															#editorHighlightButton {
																display: none;
															}
														"
									>
                                </pdfjs-viewer-element>`;
        this.pict.ContentAssignment.assignContent(`${ this.options?.DefaultDestinationAddress } > #pdfjs-injectable`, viewerEl);
		
		// Waits for the pdfjs lib to instantiate itself before checking if it should show the info banner and setting a local instance reference.
		let timer = 0;
		const setpdfjsReference = () =>
		{
			const pdfjsObj = document.querySelector('pdfjs-viewer-element')?.shadowRoot?.querySelector('iframe')?.contentWindow?.PDFViewerApplication;
			if (pdfjsObj && pdfjsObj?.pdfDocument)
			{
				const bannerInjectionEl = document.querySelector('#pdfjs-info-banner');
				if (bannerInjectionEl)
				{
					bannerInjectionEl.innerHTML = '';
				}
				this.pdfjsInstance = pdfjsObj;
				this.getStartingPageLabel().then((page) =>
				{
					if (page !== 1)
					{
						if (bannerInjectionEl)
						{
							bannerInjectionEl.innerHTML = this.options?.pageInfoTemplate ? this.options.pageInfoTemplate : /*html*/`
								<div class="pdfjs-info-banner">
									Note: This pdf does not start on page 1.
								</div>
								<div class="pdfjs-banner-close" onclick="
									if (document.querySelector('#pdfjs-info-banner')?.innerHTML)
									{ 
										document.querySelector('#pdfjs-info-banner').innerHTML = ''; 
									}
								">&times;</div>
							`;
						}
					}
				});
			}
			else if (timer < 30)
			{
				timer += 1;
				setTimeout(setpdfjsReference, 100);
			}
		}
		setpdfjsReference();
	}

	/*
		Gets the current active page of the pdf viewer. 
		This is the "absolute" page number rather than being based on altered numbering in the page labels metadata.
	*/
	getCurrentPage()
	{
		return this.pdfjsInstance?.page || 1;
	}

	/*
		Sets the current active page of the pdf viewer. 
		This is the "absolute" page number rather than being based on altered numbering in the page labels metadata.
	*/
	setCurrentPage(pageNumber)
	{
		if (!this.pdfjsInstance?.page)
		{
			return;
		}
		this.pdfjsInstance.page = pageNumber;
	}

	/*
		Gets the current active page of the pdf viewer. 
		This is the "relative" page number, i.e. defined by the pdfs metadata rather than the absolute number of pages.
		Note that this function is async.
	*/
	async getCurrentPageLabel()
	{
		const labels = await this.pdfjsInstance?.pdfDocument?.getPageLabels();
		const currentPage = this.getCurrentPage();
		if (!labels || !currentPage)
		{
			return currentPage;
		}
		else
		{
			// If the page is not parseable as a number, just return the string (example: pages labeled with roman numerals, like "ii").
			return Number(labels[this.getCurrentPage() - 1]) || labels[this.getCurrentPage() - 1];
		}
	}

	/*
		Gets the first page number of the pdf with whatever relative/offset label it may have.
		Note that this function is also async.
	*/
	async getStartingPageLabel()
	{
		const labels = await this.pdfjsInstance?.pdfDocument?.getPageLabels();
		if (!labels)
		{
			return 1;
		}
		else
		{
			// If the page is not parseable as a number, just return the string (example: pages labeled with roman numerals, like "ii").
			return Number(labels[0]) || labels[0];
		}
	}
}

module.exports = PictSectionPDFJS;
module.exports.default_configuration = default_configuration;


},{"pict-view":693}],604:[function(require,module,exports){
// Sub-path entry: `require('pict-section-picker/form')`.
//
// The pict-section-form input-type adapter — kept off the package's main entry so the picker core
// stays usable without pict-section-form (which is an OPTIONAL peer dependency, required only here).
module.exports = require('./source/form/Pict-Section-Picker-FormInput.js');

},{"./source/form/Pict-Section-Picker-FormInput.js":606}],605:[function(require,module,exports){
// The container for all the Pict-Section-Picker related code.
//
// pict-section-picker is a themeable, pict-native searchable select / combobox: a jQuery- and
// select2-free widget supporting single & multi select, search, server pagination, categorized
// groups and creatable entries. It is driven by a host-agnostic async DataProvider, and ships a
// built-in adapter for the pict EntityProvider (Meadow entities) for the common case.

// The picker provider (primary API surface — registers the widget view + CSS, and exposes
// createPicker() / data-source adapters).
const PictProviderPicker = require('./providers/Pict-Provider-Picker.js');

// The widget view (also auto-registered by the provider).
const PictViewPicker = require('./views/PictView-Picker.js');

module.exports = PictProviderPicker;

module.exports.PictProviderPicker = PictProviderPicker;
module.exports.PictViewPicker = PictViewPicker;

module.exports.default_configuration = PictProviderPicker.default_configuration;

},{"./providers/Pict-Provider-Picker.js":607,"./views/PictView-Picker.js":608}],606:[function(require,module,exports){
/**
 * pict-section-form input-type adapter for pict-section-picker.
 *
 * Renders a picker widget into a dynamic-form cell — the host-agnostic replacement for a select2
 * entity input. Registered as a pict-section-form InputType (default name `Picker`); a host opts a
 * field in with `PictForm.InputType: 'Picker'` (+ Entity / SearchFields / Multiple / …). Used by the
 * pict-section-recordset entity filters and by document forms alike.
 *
 * Contextual scoping (project / spec-year / tenant / …) stays host configuration: the descriptor may
 * carry a `PictForm.GetContextScopeFilter()` hook, OR a host subclass overrides
 * `getContextualSearchFilters(pInput)`. Either way the module never learns what the context means.
 *
 * Requires `pict-section-form` (an OPTIONAL peer dependency — only loaded when you require this file)
 * and the `Pict-Section-Picker` provider registered on the pict instance.
 */
const libPictInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * The picker "nothing selected" sentinel per numeric descriptor DataType.
 *
 * A pict-section-form marshal reads values with manyfest's getValueByHash, which substitutes the
 * DESCRIPTOR DEFAULT whenever the address is undefined — and, absent an explicit `Default`, that is
 * manyfest's per-DataType default: '' for String but 0 for Number/Integer/Float. So a pristine
 * `{ DataType: 'Number', InputType: 'Picker' }` field (an entity FK, virtually always) marshals in as
 * 0, which the widget would otherwise paint as a literal "0" selection instead of the placeholder.
 * Mapping the type to its sentinel makes the picker render empty for it. Display only — the model is
 * untouched, so 0-means-unset stays a valid data pattern for solvers and exports.
 *
 * PreciseNumber ('0.0') is deliberately absent: it is a decimal-measurement type, not an id type.
 * @type {Record<string, Array<any>>}
 */
const _NUMERIC_UNSET_SENTINELS =
{
	Number: [ 0 ],
	Integer: [ 0 ],
	Float: [ 0 ],
};

/**
 * The values a descriptor's picker should PAINT as empty (see _NUMERIC_UNSET_SENTINELS). A descriptor
 * overrides with `PictForm.EmptyValues` — its own sentinel list, or `[]` to opt out and show the raw 0.
 *
 * Exported because a host's READ/PRINT display provider must agree with the edit widget about what
 * counts as unset; sharing the one function is what stops the two from drifting.
 * @param {Record<string, any>} pInput - the pict-section-form input descriptor.
 * @return {Array<any>}
 */
const resolveEmptyValues = (pInput) =>
{
	const tmpPictForm = (pInput && pInput.PictForm) || {};
	if (Array.isArray(tmpPictForm.EmptyValues)) { return tmpPictForm.EmptyValues; }
	return _NUMERIC_UNSET_SENTINELS[pInput && pInput.DataType] || [];
};

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Input-Picker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * Build the InputType metatemplate entries (a hidden informary input + a host element the picker
 * renders into) for a given InputType name + provider hash. Injected via injectTemplateSet.
 *
 * @param {string} pInputTypeName - e.g. 'Picker'.
 * @param {string} pProviderHash - the input-extension provider service hash to auto-attach.
 * @return {Array<Record<string, any>>}
 */
const buildPickerInputTemplates = (pInputTypeName, pProviderHash) =>
[
	{
		// Mirror the host's DEFAULT input metatemplate structure exactly — a label span + the control
		// where the <input>/<select> would be — so the picker inherits the host's filter/form chrome
		// (label style, spacing, and the row's flex-end trash alignment) instead of inventing its own.
		HashPostfix: `-Template-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			<!-- InputType ${pInputTypeName} {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" id="{~D:Record.Macro.RawHTMLID~}" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="" />
			<span>{~D:Record.Name~}:</span> <div class="pps-form-host" id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"></div>`,
	},
	{
		HashPostfix: `-VerticalTemplate-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			<!-- InputType ${pInputTypeName} {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" id="{~D:Record.Macro.RawHTMLID~}" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="" />
			<span>{~D:Record.Name~}:</span> <div class="pps-form-host" id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"></div>`,
	},
	{
		HashPostfix: `-TabularTemplate-Begin-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			<input type="hidden" id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" tabindex="-1" {~D:Record.Macro.InformaryTabular~} `,
	},
	{
		HashPostfix: `-TabularTemplate-End-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			value="" />
			<div class="pps-form-host" id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"></div>`,
	},
];

class PictInputTypePicker extends libPictInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
	}

	// Visible host + picker-view-hash ids. Must match the metatemplate element ids above.
	getPickerHostID(pRawHTMLID) { return `#PICKER-FOR-${pRawHTMLID}`; }
	getPickerHash(pRawHTMLID) { return `Picker-${pRawHTMLID}`; }
	getTabularPickerHostID(pRawHTMLID, pRowIndex) { return `#PICKER-TABULAR-${pRawHTMLID}-${pRowIndex}`; }
	getTabularPickerHash(pRawHTMLID, pRowIndex) { return `Picker-${pRawHTMLID}-${pRowIndex}`; }
	getTabularHiddenID(pRawHTMLID, pRowIndex) { return `#PICKER-TABULAR-DATA-${pRawHTMLID}-${pRowIndex}`; }

	/**
	 * Overridable: extra FoxHound scope stanza(s) AND-applied to the entity search. Default reads the
	 * descriptor's `GetContextScopeFilter()` hook (set by the host / recordset filter base), else its
	 * static `BaseFilter`. Host subclasses override this to read app state (project / spec-year / …).
	 *
	 * @param {Record<string, any>} pInput @return {string|Array<string>}
	 */
	getContextualSearchFilters(pInput)
	{
		const tmpHook = pInput && pInput.PictForm && pInput.PictForm.GetContextScopeFilter;
		if (typeof tmpHook === 'function')
		{
			try { return tmpHook() || ''; }
			catch (pError) { this.pict.log.warn(`Pict-Input-Picker: GetContextScopeFilter threw.`, pError); return ''; }
		}
		return (pInput && pInput.PictForm && pInput.PictForm.BaseFilter) || '';
	}

	/** Overridable seam onto the shared {@link resolveEmptyValues}. @param {Record<string, any>} pInput @return {Array<any>} */
	_resolveEmptyValues(pInput)
	{
		return resolveEmptyValues(pInput);
	}

	/** Build the picker config from a form input descriptor. */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpPF = pInput.PictForm || {};
		return {
			DestinationAddress: pHostSelector,
			Mode: tmpPF.Multiple ? 'multi' : 'single',
			Placeholder: tmpPF.Placeholder || (tmpPF.Entity ? `Select ${tmpPF.Entity}…` : 'Select…'),
			Searchable: (tmpPF.Searchable !== false),
			ReadOnly: !!tmpPF.ReadOnly,
			Entity: tmpPF.Entity,
			SearchFields: tmpPF.SearchFields,
			ValueField: tmpPF.ValueField,
			TextField: tmpPF.TextField,
			// Optional composed-display template (overrides TextField); see the picker's TextTemplate option.
			TextTemplate: tmpPF.TextTemplate,
			PageSize: tmpPF.PageSize || 20,
			Options: tmpPF.Options || [],
			// JoinEntity compound display (1:1 / 1:many parent-entity context) — passed straight through
			// to the picker's entity adapter, which fetch-then-merges the join. No-op when JoinEntity unset.
			JoinEntity: tmpPF.JoinEntity,
			JoinField: tmpPF.JoinField,
			JoinEntityValueField: tmpPF.JoinEntityValueField,
			JoinEntityDisplayField: tmpPF.JoinEntityDisplayField,
			JoinEntityFirst: tmpPF.JoinEntityFirst,
			JoinSeparator: tmpPF.JoinSeparator,
			// EntityTag badge: the record field whose value becomes a Tag pill, ordered by EntityTagLast.
			EntityTag: tmpPF.EntityTag,
			TagLast: tmpPF.EntityTagLast,
			// Numeric-descriptor "unset" sentinel(s) rendered as the placeholder rather than as a value.
			EmptyValues: this._resolveEmptyValues(pInput),
			// Per-search contextual scope — the generic hook the host fills.
			BaseFilter: () => this.getContextualSearchFilters(pInput),
			OnChange: fOnChange,
		};
	}

	/** Instantiate (or reuse) the picker view for a config — entity-backed when Entity is set. */
	_instantiatePicker(pPickerHash, pConfig)
	{
		const tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpProvider)
		{
			this.pict.log.warn('Pict-Input-Picker: the Pict-Section-Picker provider is not registered.');
			return null;
		}
		return pConfig.Entity
			? tmpProvider.createEntityPicker(pPickerHash, pConfig)
			: tmpProvider.createPicker(pPickerHash, pConfig);
	}

	/**
	 * Write a picker value into the form: csv to the hidden informary input (+ dataChanged), plus the
	 * raw array to `PictForm.ValueArrayAddress` when set (the recordset filter reads Values as an
	 * array). The csv-vs-array bridge lives HERE (generic) instead of in each host.
	 */
	_commit(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpCSV = Array.isArray(pValue) ? pValue.join(',') : (pValue === undefined || pValue === null ? '' : pValue);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpCSV);
		if (pInput.PictForm && pInput.PictForm.ValueArrayAddress && pView.Bundle)
		{
			const tmpArray = Array.isArray(pValue) ? pValue : (tmpCSV === '' ? [] : String(tmpCSV).split(','));
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.ValueArrayAddress, tmpArray);
		}
		pView.dataChanged(pInput.Hash);
	}

	_commitTabular(pView, pInput, pValue, pHiddenID, pRowIndex)
	{
		const tmpCSV = Array.isArray(pValue) ? pValue.join(',') : (pValue === undefined || pValue === null ? '' : pValue);
		this.pict.ContentAssignment.assignContent(pHiddenID, tmpCSV);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
	}

	/**
	 * Idempotently mount (or reuse) the picker into its host element + seed its value. Called from both
	 * onInputInitialize and onDataMarshalToForm because, in the async-virtual filter render, the host
	 * element only exists in the real DOM by the marshal pass — whichever hook fires post-DOM wins, and
	 * re-calls are harmless (the picker view is reused by hash).
	 *
	 * setValue does the work: it builds the widget on the first call and, once the widget is live, re-seeds
	 * the value WITHOUT a full render — so a marshal (which re-runs this on every solve) no longer rebuilds
	 * the search box or orphans a portaled dropdown. That is why there is no explicit render() here.
	 * @return {boolean} true if the picker is mounted.
	 */
	_mountPicker(pView, pInput, pValue, pHostSelector, pPickerHash, fOnChange)
	{
		if (!this.pict.ContentAssignment.getElement(pHostSelector)?.[0]) { return false; }
		const tmpView = this._instantiatePicker(pPickerHash, this._buildPickerConfig(pInput, pHostSelector, fOnChange));
		if (!tmpView) { return false; }
		tmpView.setValue(pValue);
		return true;
	}

	// --- non-tabular lifecycle ---

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpRaw = pInput.Macro.RawHTMLID;
		this._mountPicker(pView, pInput, pValue, this.getPickerHostID(tmpRaw), this.getPickerHash(tmpRaw),
			(pNewValue) => this._commit(pView, pInput, pNewValue, pInput.Macro.HTMLSelector));
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpRaw = pInput.Macro.RawHTMLID;
		const tmpPickerHash = this.getPickerHash(tmpRaw);
		// Mount if it isn't already (post-DOM hook), else just re-seed the value.
		if (!this._mountPicker(pView, pInput, pValue, this.getPickerHostID(tmpRaw), tmpPickerHash,
			(pNewValue) => this._commit(pView, pInput, pNewValue, pInput.Macro.HTMLSelector)))
		{
			const tmpView = this.pict.views[tmpPickerHash];
			if (tmpView) { tmpView.setValue(pValue); }
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpView = this.pict.views[this.getPickerHash(pInput.Macro.RawHTMLID)];
		const tmpVal = tmpView ? tmpView.getValue() : pValue;
		this._commit(pView, pInput, tmpVal, pHTMLSelector);
		return super.onDataRequest(pView, pInput, tmpVal, pHTMLSelector);
	}

	// --- tabular lifecycle (one picker view instance per (input, row)) ---

	/** Idempotent tabular mount (see _mountPicker). @return {boolean} */
	_mountPickerTabular(pView, pInput, pValue, pRowIndex)
	{
		const tmpRaw = pInput.Macro.RawHTMLID;
		const tmpHostSelector = this.getTabularPickerHostID(tmpRaw, pRowIndex);
		if (!this.pict.ContentAssignment.getElement(tmpHostSelector)?.[0]) { return false; }
		const tmpHiddenID = this.getTabularHiddenID(tmpRaw, pRowIndex);
		const tmpView = this._instantiatePicker(this.getTabularPickerHash(tmpRaw, pRowIndex),
			this._buildPickerConfig(pInput, tmpHostSelector, (pNewValue) => this._commitTabular(pView, pInput, pNewValue, tmpHiddenID, pRowIndex)));
		if (!tmpView) { return false; }
		// setValue builds on the first call and re-seeds targeted once live — no explicit render (see _mountPicker).
		tmpView.setValue(pValue);
		return true;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._mountPickerTabular(pView, pInput, pValue, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!this._mountPickerTabular(pView, pInput, pValue, pRowIndex))
		{
			const tmpView = this.pict.views[this.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex)];
			if (tmpView) { tmpView.setValue(pValue); }
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpView = this.pict.views[this.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex)];
		const tmpVal = tmpView ? tmpView.getValue() : pValue;
		this._commitTabular(pView, pInput, tmpVal, this.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex), pRowIndex);
		return super.onDataRequestTabular(pView, pInput, tmpVal, pHTMLSelector, pRowIndex);
	}
}

/**
 * Register the Picker InputType on a pict instance: the input-extension provider + its metatemplate(s).
 * Idempotent. Requires `pict-section-form` loaded (PictFormSectionDefaultTemplateProvider present) and
 * the `Pict-Section-Picker` provider registered.
 *
 * @param {any} pPict - the pict instance.
 * @param {Record<string, any>} [pOptions]
 *   - InputTypeName {string} - the InputType string (default 'Picker').
 *   - ProviderHash {string} - the input-extension provider service hash (default 'Pict-Input-Picker').
 *   - ProviderClass {Function} - provider class to register (default PictInputTypePicker; a host
 *     passes a subclass that overrides getContextualSearchFilters for its scoping).
 *   - TemplatePrefix {string|Array<string>} - the form template prefix(es) to inject the metatemplate
 *     under (default 'Pict-MT-Base'; Headlight uses its theme prefixes).
 * @return {boolean} true if registered.
 */
const registerPickerInputType = (pPict, pOptions) =>
{
	const tmpOptions = pOptions || {};
	const tmpInputTypeName = tmpOptions.InputTypeName || 'Picker';
	const tmpProviderHash = tmpOptions.ProviderHash || 'Pict-Input-Picker';
	const tmpProviderClass = tmpOptions.ProviderClass || PictInputTypePicker;
	const tmpPrefixes = Array.isArray(tmpOptions.TemplatePrefix) ? tmpOptions.TemplatePrefix : [ tmpOptions.TemplatePrefix || 'Pict-MT-Base' ];

	if (!pPict.providers[tmpProviderHash])
	{
		pPict.addProvider(tmpProviderHash, Object.assign({}, _DEFAULT_CONFIGURATION, { ProviderIdentifier: tmpProviderHash }), tmpProviderClass);
	}

	const tmpTemplateProvider = pPict.providers.PictFormSectionDefaultTemplateProvider;
	if (!tmpTemplateProvider || typeof tmpTemplateProvider.injectTemplateSet !== 'function')
	{
		pPict.log.warn('Pict-Input-Picker: PictFormSectionDefaultTemplateProvider not available; cannot register the Picker metatemplate (is pict-section-form loaded?).');
		return false;
	}
	const tmpTemplates = buildPickerInputTemplates(tmpInputTypeName, tmpProviderHash);
	tmpPrefixes.forEach((pPrefix) => tmpTemplateProvider.injectTemplateSet({ TemplatePrefix: pPrefix, Templates: tmpTemplates }));
	return true;
};

module.exports = PictInputTypePicker;

module.exports.PictInputTypePicker = PictInputTypePicker;
module.exports.registerPickerInputType = registerPickerInputType;
module.exports.buildPickerInputTemplates = buildPickerInputTemplates;
module.exports.resolveEmptyValues = resolveEmptyValues;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-section-form":497}],607:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewPicker = require('../views/PictView-Picker.js');

// Themeable widget CSS. Registered once (by hash) regardless of how many picker instances exist.
// Host apps brand by defining the --theme-color-* tokens; the hardcoded values are fallbacks.
const _PickerCSS = /*css*/`
.pps { position: relative; width: 100%; box-sizing: border-box; }
.pps *, .pps *::before, .pps *::after { box-sizing: border-box; }
.pps-control { display: flex; align-items: center; gap: 0.5rem; width: 100%; cursor: pointer; font: inherit; font-size: 0.92rem;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); text-align: left; }
.pps-control:hover { border-color: var(--theme-color-border-strong, #c2c9d2); }
.pps.pps-open .pps-control { border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.pps-valuearea { flex: 1 1 auto; min-width: 0; }
.pps-value { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-value.pps-placeholder { color: var(--theme-color-text-muted, #6b7686); }
.pps-chevron { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; transition: transform 0.15s ease; }
.pps.pps-open .pps-chevron { transform: rotate(180deg); }
/* Read-only: render the resolved selection as plain, non-interactive text (no border / chevron / clear /
   dropdown). Used by read-only form views; the value text inherits the surrounding field styling. */
.pps-readonly .pps-control { border-color: transparent; background: transparent; padding-left: 0; padding-right: 0; cursor: default; pointer-events: none; }
.pps-readonly .pps-control:hover { border-color: transparent; box-shadow: none; }
.pps-readonly .pps-chevron, .pps-readonly .pps-clear, .pps-readonly .pps-chip-x { display: none; }
.pps-readonly .pps-pop, .pps-readonly .pps-backdrop { display: none; }
/* Clearable (AllowClear): the inline × next to the value (mirrors the chip ×) and the pinned "Any" row. */
.pps-clear { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.78rem; border-radius: 4px; padding: 0.1rem;
	color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.pps-clear:hover { opacity: 1; background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 22%, transparent); }
.pps-clear-option { border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pps-clear-option .pps-option-label { color: var(--theme-color-text-muted, #6b7686); font-style: italic; }

/* Multi-select chips. The control hosts a wrapping row of removable tags + a muted placeholder. */
.pps-multi .pps-control { align-items: flex-start; }
.pps-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem; min-width: 0; }
.pps-chips-ph { color: var(--theme-color-text-muted, #6b7686);
	/* The placeholder is the ONLY chips-row child that is free text, so it is the one thing that can
	   force the control taller than a line. Single-select truncates (.pps-value above); multi did not,
	   so a long label wrapped and knocked neighbouring filters out of vertical alignment. Truncate to
	   match: min-width:0 lets it shrink inside the flex row, and it never wraps. */
	min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-chip { display: inline-flex; align-items: center; gap: 0.3rem; max-width: 100%; font-size: 0.82rem; line-height: 1.4;
	padding: 0.1rem 0.2rem 0.1rem 0.5rem; border-radius: 6px;
	background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent);
	color: var(--theme-color-brand-primary, #156dd1); }
.pps-chip-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-chip-x { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.78rem; border-radius: 4px; padding: 0.1rem; opacity: 0.7; }
.pps-chip-x:hover { opacity: 1; background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 22%, transparent); }

/* Preview-card ⓘ — the opt-in affordance next to a selected value / chip. Stays clickable in
   read-only mode (where the control itself has pointer-events: none). */
.pps-card-info { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.82rem; padding: 0 0.1rem; opacity: 0.5; color: var(--theme-color-text-muted, #6b7686); }
.pps-card-info:hover { opacity: 1; color: var(--theme-color-brand-primary, #156dd1); }
.pps-readonly .pps-card-info { pointer-events: auto; }

/* EntityTag badge — a small code/number pill shown next to an option / chip / selected value (the
   select2 EntitySelector "tag" parity). Ordering (before/after the label) is driven by the TagLast
   option in the view's render state. */
.pps-tag { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.74rem; font-weight: 600; line-height: 1.25;
	padding: 0.05rem 0.4rem; border-radius: 5px; white-space: nowrap;
	background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
.pps-valuebox { display: flex; align-items: center; gap: 0.4rem; min-width: 0; }
.pps-valuebox .pps-value { min-width: 0; }
.pps-option-label { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Transparent full-viewport backdrop: closes on outside click (no document listener). Only present
   while OPEN — otherwise a fixed full-viewport layer would swallow every click on the page. When open,
   the control is raised above it so its chips/× stay clickable; the dropdown sits above both. */
.pps-backdrop { position: fixed; inset: 0; z-index: 0; display: none; }
.pps.pps-open .pps-backdrop { display: block; }
.pps.pps-open .pps-control { position: relative; z-index: 1; }
/* Default anchoring: absolute against the control's own box (.pps is position:relative), so the panel
   rides page scroll for free — no measuring, no listeners. Works because a typical form row sets no
   overflow to clip it. */
.pps-pop { position: absolute; z-index: 40; top: calc(100% + 0.3rem); left: 0; right: 0; min-width: 200px; display: none; }
.pps.pps-open .pps-pop { display: block; }
/* Portal fallback, applied by the view when a clipping ancestor would cut the panel: it moves the pop to
   <body> and places it in DOCUMENT coords. Still absolute (not fixed) so it rides scroll like the
   default. On <body> it's outside the .pps.pps-open rule, so visibility keys off pps-pop-open — which
   also keeps a stray/orphaned portaled pop hidden. */
.pps-pop.pps-pop-portal { position: absolute; right: auto; display: none; }
.pps-pop.pps-pop-portal.pps-pop-open { display: block; }
.pps-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(60vh, 360px);
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
.pps-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pps-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
.pps-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.pps-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem; }
.pps-option { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.9rem;
	padding: 0.45rem 0.6rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.pps-option:hover, .pps-option.pps-highlight { background: var(--theme-color-background-tertiary, #eceef2); }
.pps-option.pps-selected { color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
.pps-option-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); }
.pps-option-check.pps-hidden { visibility: hidden; }
.pps-empty { padding: 0.7rem 0.6rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; text-align: center; }
.pps-loading { padding: 0.6rem; text-align: center; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; }
.pps-more { display: block; width: calc(100% - 0.5rem); margin: 0.25rem; padding: 0.4rem; cursor: pointer; font: inherit; font-size: 0.85rem;
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #156dd1); }
.pps-more:hover { background: var(--theme-color-background-tertiary, #eceef2); }

/* Category header (groups) + creatable "Create …" row. */
.pps-group { padding: 0.45rem 0.6rem 0.2rem; font-size: 0.72rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); }
.pps-create { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.9rem;
	padding: 0.45rem 0.6rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
.pps-create:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pps-create-ic { flex: 0 0 auto; display: inline-flex; }

/* Field decoration (opt-in): the ⚙ toggle in the search row + the field chooser panel between search and
   list. The chooser mount stays empty (collapsed) until opened. */
.pps-decorate-btn { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.82rem;
	padding: 0.15rem; border: none; border-radius: 5px; background: transparent; color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.pps-decorate-btn:hover { opacity: 1; background: var(--theme-color-background-tertiary, #eceef2); }
.pps-decorate-btn.pps-decorate-on { color: var(--theme-color-brand-primary, #156dd1); opacity: 1; }
.pps-decorate-btn.pps-decorate-open { background: var(--theme-color-background-tertiary, #eceef2); opacity: 1; }
.pps-decorate-panel:empty { display: none; }
.pps-decorate { flex: 0 0 auto; max-height: 11rem; overflow-y: auto; padding: 0.5rem 0.7rem;
	border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-tertiary, #f4f6f9); }
.pps-decorate-title { font-size: 0.7rem; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.4rem; }
.pps-decorate-list { display: flex; flex-direction: column; gap: 0.05rem; }
.pps-decorate-opt { display: flex; align-items: center; gap: 0.45rem; cursor: pointer; font-size: 0.86rem; color: var(--theme-color-text-primary, #1f2733); padding: 0.15rem 0.1rem; }
.pps-decorate-opt:hover { color: var(--theme-color-brand-primary, #156dd1); }
.pps-decorate-opt input { flex: 0 0 auto; cursor: pointer; margin: 0; }
.pps-decorate-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-decorate-empty { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.1rem; }

/* Form-input adapter (pict-section-picker/form): the picker host fills its row like the host's
   native inputs (width:100% forces it to wrap below the label span + fill, matching a scalar input). */
.pps-form-host { flex: 1 1 100%; min-width: 0; width: 100%; }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Section-Picker',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Opt-in fleet default: when true, every picker this provider creates closes any open sibling on
	// open (at most one dropdown on the page — select2 parity). Off by default so existing hosts see
	// no behavior change; a per-picker SingleActivePicker in createPicker's config overrides it.
	SingleActivePicker: false,
};

/**
 * The pict-section-picker provider — the primary API surface. Registers the widget CSS once and
 * creates/manages picker view instances.
 */
class PictProviderPicker extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Back-off bookkeeping, keyed by picker hash. On the provider (page-lived), not the DataProvider
		// closure, which createEntityPicker rebuilds on every marshal-driven re-mount.
		/** @type {Record<string, {Dropped: boolean, Term: string|null}>} */
		this.backOffState = {};

		// Hash of the picker whose dropdown is open (opt-in SingleActivePicker). A hash, not a view, and
		// provider-scoped so two pict instances on a page can't cross-close.
		/** @type {string|false} */
		this.currentOpenPickerHash = false;

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Picker-CSS', _PickerCSS, 500);
		}
	}

	/**
	 * Create (or reconfigure + reuse) a picker widget instance.
	 *
	 * @param {string} pPickerHash - A unique hash/id for this picker; the widget renders its control
	 *   into the DOM element `#<pPickerHash>` unless a DestinationAddress is given.
	 * @param {Record<string, any>} pConfig - Picker configuration:
	 *   - DestinationAddress {string} - CSS selector to render into (default `#<pPickerHash>`).
	 *   - ValueAddress {string} - AppData address the selection is read from / written to.
	 *   - Mode {'single'} - selection mode (multi/categories/creatable land in later phases).
	 *   - Placeholder {string} - text shown when nothing is selected.
	 *   - Searchable {boolean} - show the search box (default true).
	 *   - Options {Array<{Value:any, Text:string}>} - static option list.
	 *   - OnChange {function} - optional callback invoked with the new value after a selection.
	 *   - SingleActivePicker {boolean} - opt-in: opening this picker closes any open sibling
	 *     (defaults from the provider's own SingleActivePicker option).
	 * @return {any} The picker view instance.
	 */
	createPicker(pPickerHash, pConfig)
	{
		const tmpConfig = Object.assign(
			{
				DestinationAddress: `#${pPickerHash}`,
				Mode: 'single',
				Searchable: true,
				Placeholder: 'Select…',
				Options: [],
				// Seed the provider-level fleet default; an explicit per-picker value overrides it.
				SingleActivePicker: !!this.options.SingleActivePicker,
			},
			pConfig || {},
			// PickerProvider lets the view reach provider-scoped bookkeeping (the single-active slot)
			// without guessing the service hash this provider was registered under.
			{ PickerHash: pPickerHash, PickerProvider: this });

		if (this.pict.views[pPickerHash])
		{
			Object.assign(this.pict.views[pPickerHash].options, tmpConfig);
			return this.pict.views[pPickerHash];
		}
		return this.pict.addView(pPickerHash, tmpConfig, libPictViewPicker);
	}

	/**
	 * Build the Meadow FoxHound filter for a search term across one or more fields.
	 *
	 * The term is tokenized on whitespace and the per-token clauses are AND'd (concatenated) — so
	 * "john smith" matches a record with those words in any order / across fields, mirroring the
	 * legacy select2 behavior. Per token: single field → `FBV~Field~LK~%token%`; multiple fields →
	 * the LIKEs are OR'd inside a paren group (`FOP…FCP`) so the OR can't bleed into a sibling AND
	 * base filter. Each token is `encodeURIComponent`-wrapped exactly as pict-section-recordset does,
	 * so the structural `~` separators stay literal in the URL path while the value is escaped.
	 *
	 * @param {Array<string>} pSearchFields - The entity fields to LIKE-match.
	 * @param {string} pTerm - The (raw) search term; whitespace-delimited into AND'd tokens.
	 * @return {string} The FoxHound filter stanza(s), or '' for an all-whitespace/empty term.
	 */
	buildSearchFilter(pSearchFields, pTerm)
	{
		const tmpTokens = String(pTerm == null ? '' : pTerm).split(/\s+/).map((pToken) => pToken.trim()).filter((pToken) => pToken.length > 0);
		if (tmpTokens.length === 0) { return ''; }
		const fTokenClause = (pToken) =>
		{
			const tmpEncoded = encodeURIComponent(`%${pToken}%`);
			if (pSearchFields.length === 1)
			{
				return `FBV~${pSearchFields[0]}~LK~${tmpEncoded}`;
			}
			const tmpInner = pSearchFields.map((pField, pIndex) => `${pIndex === 0 ? 'FBV' : 'FBVOR'}~${pField}~LK~${tmpEncoded}`).join('~');
			return `FOP~0~(~0~${tmpInner}~FCP~0~)~0`;
		};
		// Concatenated stanzas AND together, so every token must match somewhere.
		return tmpTokens.map(fTokenClause).join('~');
	}

	/**
	 * Build an async picker DataProvider backed by a Meadow entity (via `pict.EntityProvider`).
	 * Returns a `(searchTerm, page) => Promise<{ results:[{Value,Text,Record}], hasMore }>` function —
	 * the exact contract PictViewPicker consumes for server search + pagination.
	 *
	 * @param {Record<string, any>} pConfig - Entity source configuration:
	 *   - Entity {string} (required) - the Meadow entity name (e.g. `Author`).
	 *   - SearchFields {Array<string>} - fields to LIKE-search (default `['Name']`).
	 *   - ValueField {string} - record field used as the option Value (default `ID<Entity>`).
	 *   - TextField {string} - record field used as the option Text (default `Name`).
	 *   - TextTemplate {string} - optional pict template rendered against the whole record for the option
	 *       Text (overrides TextField; composes with JoinEntity). Lets a host show a composed, disambiguated
	 *       label, e.g. `{~DWTF:Record.NameFull:...~} ({~D:Record.Email~})`.
	 *   - PageSize {number} - records per page (default 20).
	 *   - Sort {string} - optional field to sort ascending (adds `FSF~<field>~ASC~0`).
	 *   - PriorityValues {Array<any>|function} - optional pin-to-top: value-ids (or a `() => ids |
	 *       Promise<ids>` resolver) to float to the top of the FIRST unfiltered page, in the given order.
	 *       BROWSE-only — a search term defers entirely to natural relevance so a pin never hides a typed-for
	 *       record. The resolver is memoized per provider instance (it may hit the network — e.g. "this line
	 *       item's project's prime contractor"); pinned ids are held out of the natural flow (NIN) so they
	 *       never double on a later page, and pinned rows are fetched + composed under the same scope + cull.
	 *   - BaseFilter {string|Array<string>|Object|function} - optional always-applied FoxHound filter
	 *     (AND), e.g. `FBV~IDCustomer~EQ~1`. May be a **function** `(searchTerm, page) => string|string[]|Object`
	 *     evaluated on every search — the generic hook for host-injected CONTEXTUAL scoping (project,
	 *     tenant, spec-year, …). The module stays agnostic; the host supplies the closure.
	 *     The object form `{ Filters, BackOffFilters }` (each a string or array of stanzas) splits the
	 *     scope into a MANDATORY set and a BACK-OFF set: both are applied together first, and when the
	 *     first page of a search comes back EMPTY the request is retried once WITHOUT the back-off set —
	 *     so a host can narrow aggressively ("this project's items") yet auto-widen instead of showing
	 *     "No matches" when the narrow scope has none. Later pages of the same search stay widened so
	 *     "Load more" pages the set the user is actually looking at.
	 *   - MapRecord {function} - optional `(record) => {Value, Text}` mapper (overrides Value/TextField).
	 *   - JoinEntity {string} - optional second entity to JOIN for a compound display (e.g. a `LineItem`
	 *     shown with its `Project`). Each searched row must carry the FK (`JoinField`). Because Meadow
	 *     can't join in one read, this is fetch-then-merge: after the primary page resolves, the unique
	 *     FK ids drive ONE `FBL~ID{JoinEntity}~INN~<ids>` request, and the joined display field is
	 *     stitched onto each row (as `Record.JoinName` / `Record.JoinRecord`) + composed into the Text.
	 *   - JoinField {string} - the FK column ON THE SEARCHED ROW pointing at JoinEntity (default `ID{JoinEntity}`).
	 *   - JoinEntityValueField {string} - the PK column on JoinEntity to match (default `ID{JoinEntity}`).
	 *   - JoinEntityDisplayField {string} - the JoinEntity field to display (default `Name`).
	 *   - JoinEntityFirst {boolean} - put the joined value first in the compound (default `true`):
	 *     `JoinName - baseText`; when `false`, `baseText - JoinName`.
	 *   - JoinSeparator {string} - the compound separator (default `' - '`).
	 *   - EntityTag {string} - optional record field whose value becomes a `Tag` badge on each option
	 *     (e.g. a `LineItem`'s `ItemNumber`). The picker view renders it as a styled badge alongside the
	 *     label (ordering via the picker's `TagLast` option). Composes with JoinEntity (tag is outermost).
	 *   - EntityTags {Array<string|{Field:string, Label?:string, Template?:string}>} - a SET of extra
	 *     fields rendered as multiple disambiguation chips (e.g. `['ISBN', { Field: 'PublicationYear',
	 *     Label: 'Year' }]`). A string spec shows the raw value; an object spec can prefix a `Label`
	 *     (`"Year: 2000"`) or render a `Template` against the whole record. Renders as `Tags` (an array)
	 *     alongside the optional single `Tag`.
	 * @param {string} [pStateKey] - Key (the picker hash) under which the back-off bookkeeping is held on
	 *   the provider, so it survives this closure being rebuilt on re-mount. Omit for closure-local state.
	 * @return {(pSearchTerm: string, pPage: number) => Promise<{results: Array<any>, hasMore: boolean}>}
	 */
	createEntityDataProvider(pConfig, pStateKey)
	{
		const tmpEntity = pConfig.Entity;
		const tmpSearchFields = (Array.isArray(pConfig.SearchFields) && pConfig.SearchFields.length > 0) ? pConfig.SearchFields : [ 'Name' ];
		const tmpValueField = pConfig.ValueField || `ID${tmpEntity}`;
		const tmpTextField = pConfig.TextField || 'Name';
		const tmpPageSize = pConfig.PageSize || 20;
		const tmpSort = pConfig.Sort || false;
		const tmpBaseFilterConfig = pConfig.BaseFilter || '';
		const tmpMapRecord = (typeof pConfig.MapRecord === 'function') ? pConfig.MapRecord : false;
		const tmpJoinConfig = this._resolveJoinConfig(pConfig);
		const tmpEntityTagField = pConfig.EntityTag || false;
		const tmpEntityTagFields = Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false;
		const tmpTextTemplate = pConfig.TextTemplate || false;

		// Back-off state: after a page-0 search comes back empty and is retried without the back-off set,
		// later pages of the SAME term stay widened (a new page-0 resets it). Held on the provider by hash
		// so it survives this closure's marshal-time rebuild; no key (direct API use) = closure-local.
		const tmpBackOff = pStateKey
			? (this.backOffState[pStateKey] = this.backOffState[pStateKey] || { Dropped: false, Term: null })
			: { Dropped: false, Term: null };

		// Pin-to-top: an optional set of value-ids — or a `() => ids | Promise<ids>` resolver — that float
		// to the top of the FIRST unfiltered page. A BROWSE-only affordance: with a search term, the query
		// defers entirely to natural relevance so the pin never hides a typed-for record. The pinned ids are
		// resolved ONCE per provider instance (the resolver may hit the network — e.g. "this line item's
		// project's prime contractor"), kept OUT of the natural flow (NIN) so they never double on a later
		// page, and their rows are fetched + composed exactly like the rest (honoring the scope + cull).
		const tmpPriorityConfig = pConfig.PriorityValues || false;
		let tmpPriorityIDsPromise = null;
		const fResolvePriorityIDs = () =>
		{
			if (tmpPriorityIDsPromise) { return tmpPriorityIDsPromise; }
			let tmpResolved = [];
			try { tmpResolved = (typeof tmpPriorityConfig === 'function') ? tmpPriorityConfig() : tmpPriorityConfig; }
			catch (pError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] PriorityValues resolver threw; ignoring pin-to-top.`, pError); tmpResolved = []; }
			tmpPriorityIDsPromise = Promise.resolve(tmpResolved)
				.then((pIDs) => (Array.isArray(pIDs) ? pIDs : []).filter((pID) => (pID !== undefined) && (pID !== null) && (pID !== '')))
				.catch((pError) => { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] PriorityValues resolver rejected; ignoring pin-to-top.`, pError); return []; });
			return tmpPriorityIDsPromise;
		};
		// Fetch + compose the pinned rows themselves — one INN read under the mandatory scope (so an
		// out-of-scope or already-culled pin never appears), ordered by the resolver's id order.
		const fFetchPriorityOptions = (pPriorityIDs, pScopeFilter) => new Promise((resolve) =>
		{
			const tmpStanzas = [];
			if (pScopeFilter) { tmpStanzas.push(pScopeFilter); }
			tmpStanzas.push(`FBL~${tmpValueField}~INN~${pPriorityIDs.map((pID) => encodeURIComponent(pID)).join(',')}`);
			if (tmpSort) { tmpStanzas.push(`FSF~${tmpSort}~ASC~0`); }
			this.pict.EntityProvider.getEntitySetPage(tmpEntity, tmpStanzas.filter(Boolean).join('~'), 0, pPriorityIDs.length,
				(pError, pRecords) =>
				{
					if (pError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] pin-to-top fetch failed; skipping.`, pError); return resolve([]); }
					this._decorateRecordsWithJoin(Array.isArray(pRecords) ? pRecords : [], tmpJoinConfig).then((pDecorated) =>
					{
						const tmpByID = {};
						for (let i = 0; i < pDecorated.length; i++) { tmpByID[String(pDecorated[i][tmpValueField])] = pDecorated[i]; }
						const tmpOptions = pPriorityIDs
							.map((pID) => tmpByID[String(pID)])
							.filter((pRecord) => !!pRecord)
							.map((pRecord) => tmpMapRecord
								? tmpMapRecord(pRecord)
								: this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields));
						return resolve(tmpOptions);
					});
				});
		});

		// One page of the natural (non-pinned) query. `pPriorityIDs` is empty except on an unfiltered browse
		// with a pin configured — where those ids are excluded here (NIN) and prepended in fFinish.
		const fRunQuery = (pSearchTerm, pPage, pPriorityIDs) => new Promise((resolve, reject) =>
		{
			if (!this.pict.EntityProvider || typeof this.pict.EntityProvider.getEntitySetPage !== 'function')
			{
				return reject(new Error('Pict-Section-Picker: pict.EntityProvider is not available for entity-backed pickers.'));
			}

			// Resolve the base filter at SEARCH time. A function form lets the host inject contextual
			// scoping (e.g. "only this project's line items") without the module knowing the context;
			// it can return a single stanza, an array of stanzas, a `{ Filters, BackOffFilters }` split,
			// or nothing.
			let tmpBaseFilter = tmpBaseFilterConfig;
			if (typeof tmpBaseFilterConfig === 'function')
			{
				try { tmpBaseFilter = tmpBaseFilterConfig(pSearchTerm, pPage); }
				catch (pScopeError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] BaseFilter() threw; ignoring contextual scope.`, pScopeError); tmpBaseFilter = ''; }
			}
			const tmpScope = this._normalizeBaseFilter(tmpBaseFilter);

			const tmpPageIndex = (pPage || 0);
			if (tmpPageIndex === 0) { tmpBackOff.Dropped = false; tmpBackOff.Term = null; }
			const tmpCarryWidened = tmpBackOff.Dropped && (tmpBackOff.Term === (pSearchTerm || ''));
			const tmpApplyBackOff = !!tmpScope.BackOffFilter && !tmpCarryWidened;

			const fComposeFilter = (pIncludeBackOff) =>
			{
				const tmpStanzas = [];
				if (tmpScope.Filter) { tmpStanzas.push(tmpScope.Filter); }
				if (pIncludeBackOff && tmpScope.BackOffFilter) { tmpStanzas.push(tmpScope.BackOffFilter); }
				if (pSearchTerm) { tmpStanzas.push(this.buildSearchFilter(tmpSearchFields, pSearchTerm)); }
				// Pin-to-top: keep the pinned rows OUT of the natural flow so they appear only at the top
				// (prepended in fFinish), never doubled on a later page.
				if (pPriorityIDs.length > 0) { tmpStanzas.push(`FBL~${tmpValueField}~NIN~${pPriorityIDs.map((pID) => encodeURIComponent(pID)).join(',')}`); }
				if (tmpSort) { tmpStanzas.push(`FSF~${tmpSort}~ASC~0`); }
				return tmpStanzas.filter(Boolean).join('~');
			};

			const fFinish = (pRecords) =>
			{
				const tmpList = Array.isArray(pRecords) ? pRecords : [];
				// JoinEntity (when configured): one INN fetch for the joined rows, stitched onto each
				// searched row, before mapping — so the option Text can show the compound display.
				this._decorateRecordsWithJoin(tmpList, tmpJoinConfig).then((pDecorated) =>
				{
					const tmpResults = pDecorated.map((pRecord) => tmpMapRecord
						? tmpMapRecord(pRecord)
						: this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields));
					// hasMore: a full page came back, so there is (probably) another. Avoids a Count round-trip.
					// Pin-to-top: on the first browse page, prepend the pinned options ahead of the natural
					// results (which excluded them via NIN above).
					if (pPriorityIDs.length < 1 || tmpPageIndex !== 0)
					{
						return resolve({ results: tmpResults, hasMore: (tmpList.length >= tmpPageSize) });
					}
					return fFetchPriorityOptions(pPriorityIDs, tmpScope.Filter).then((pPinned) =>
						resolve({ results: pPinned.concat(tmpResults), hasMore: (tmpList.length >= tmpPageSize) }));
				});
			};

			const tmpCursor = tmpPageIndex * tmpPageSize;
			this.pict.EntityProvider.getEntitySetPage(tmpEntity, fComposeFilter(tmpApplyBackOff), tmpCursor, tmpPageSize,
				(pError, pRecords) =>
				{
					if (pError) { return reject(pError); }
					const tmpList = Array.isArray(pRecords) ? pRecords : [];
					// Back-off retry: an EMPTY first page under the back-off set means the narrow scope has
					// nothing — auto-widen by retrying once without it, instead of stranding the user on
					// "No matches" for options that exist just outside the preferred scope.
					if (tmpList.length < 1 && tmpApplyBackOff && tmpPageIndex === 0)
					{
						tmpBackOff.Dropped = true;
						tmpBackOff.Term = (pSearchTerm || '');
						return this.pict.EntityProvider.getEntitySetPage(tmpEntity, fComposeFilter(false), tmpCursor, tmpPageSize,
							(pRetryError, pRetryRecords) =>
							{
								if (pRetryError) { return reject(pRetryError); }
								return fFinish(pRetryRecords);
							});
					}
					return fFinish(tmpList);
				});
		});

		// No pin configured → the plain per-page provider. Otherwise resolve the pinned ids first (browse
		// only — a search term defers entirely to natural relevance) and run the query with them.
		if (!tmpPriorityConfig)
		{
			return (pSearchTerm, pPage) => fRunQuery(pSearchTerm, pPage, []);
		}
		return (pSearchTerm, pPage) =>
		{
			if (pSearchTerm) { return fRunQuery(pSearchTerm, pPage, []); }
			return fResolvePriorityIDs().then((pIDs) => fRunQuery(pSearchTerm, pPage, pIDs));
		};
	}

	/**
	 * Normalize a resolved BaseFilter value into `{ Filter, BackOffFilter }` joined-stanza strings.
	 * Accepts the historical string / array forms (all-mandatory, no back-off) and the object form
	 * `{ Filters, BackOffFilters }` where each side is itself a string or array of stanzas.
	 *
	 * @param {any} pResolved - The BaseFilter config value, or a BaseFilter function's return value.
	 * @return {{Filter: string, BackOffFilter: string}}
	 */
	_normalizeBaseFilter(pResolved)
	{
		const fJoin = (pValue) => Array.isArray(pValue) ? pValue.filter(Boolean).join('~') : (pValue || '');
		if (pResolved && typeof pResolved === 'object' && !Array.isArray(pResolved))
		{
			return { Filter: fJoin(pResolved.Filters), BackOffFilter: fJoin(pResolved.BackOffFilters) };
		}
		return { Filter: fJoin(pResolved), BackOffFilter: '' };
	}

	/**
	 * Resolve the JoinEntity options off an entity-source config into a normalized internal shape, or
	 * `false` when no JoinEntity is configured. Centralizes the defaults so the DataProvider and the
	 * ResolveValue builders agree.
	 *
	 * @param {Record<string, any>} pConfig
	 * @return {false | {Entity:string, FKColumn:string, PKColumn:string, DisplayField:string, First:boolean, Separator:string}}
	 */
	_resolveJoinConfig(pConfig)
	{
		if (!pConfig || !pConfig.JoinEntity) { return false; }
		return {
			Entity: pConfig.JoinEntity,
			// The FK on the SEARCHED row, and the PK it points at on the join entity (the INN column).
			FKColumn: pConfig.JoinField || `ID${pConfig.JoinEntity}`,
			PKColumn: pConfig.JoinEntityValueField || `ID${pConfig.JoinEntity}`,
			DisplayField: pConfig.JoinEntityDisplayField || 'Name',
			// Default join-first (mirrors the documented select2 EntitySelector default).
			First: (pConfig.JoinEntityFirst !== false),
			Separator: (typeof pConfig.JoinSeparator === 'string') ? pConfig.JoinSeparator : ' - ',
		};
	}

	/**
	 * Compose a compound display from a base text + a joined value, honoring ordering + separator.
	 * Falls back to just the base text when there is no joined value.
	 *
	 * @param {any} pBaseText @param {any} pJoinText @param {boolean} pFirst @param {string} pSeparator
	 * @return {any}
	 */
	_composeJoinedText(pBaseText, pJoinText, pFirst, pSeparator)
	{
		if (pJoinText === undefined || pJoinText === null || pJoinText === '') { return pBaseText; }
		const tmpBase = (pBaseText === undefined || pBaseText === null) ? '' : pBaseText;
		return pFirst ? `${pJoinText}${pSeparator}${tmpBase}` : `${tmpBase}${pSeparator}${pJoinText}`;
	}

	/**
	 * Build the picker option `{ Value, Text, Record[, Tag] }` from a (possibly join-decorated) record:
	 * the Text honors any JoinEntity compound, and a Tag badge is added from `pTagField` when set. Shared
	 * by the DataProvider (per page row) and the ResolveValue (pre-bound value) so they stay consistent.
	 *
	 * @param {any} pRecord @param {string} pValueField @param {string} pTextField
	 * @param {false | Record<string, any>} pJoinConfig @param {string|false} pTagField
	 * @return {{Value:any, Text:any, Record:any, Tag?:any}}
	 */
	_composeOption(pRecord, pValueField, pTextField, pJoinConfig, pTagField, pTextTemplate, pTagFields)
	{
		// The option label is either a single field (pTextField) or — when a TextTemplate is configured — a
		// template rendered against the whole record, so a host can show a composed, disambiguated display
		// (e.g. "Brian Smith (brian@…)") instead of one ambiguous column. JoinEntity still wraps the result.
		const tmpBaseText = pTextTemplate
			? this.pict.parseTemplate(pTextTemplate, pRecord)
			: pRecord[pTextField];
		const tmpText = pJoinConfig
			? this._composeJoinedText(tmpBaseText, pRecord.JoinName, pJoinConfig.First, pJoinConfig.Separator)
			: tmpBaseText;
		const tmpOption = { Value: pRecord[pValueField], Text: tmpText, Record: pRecord };
		if (pTagField) { tmpOption.Tag = pRecord[pTagField]; }
		// EntityTags: a set of extra fields rendered as disambiguation chips (e.g. a book's ISBN + Year).
		if (Array.isArray(pTagFields) && pTagFields.length > 0)
		{
			tmpOption.Tags = pTagFields
				.map((pSpec) => this._composeTagValue(pSpec, pRecord))
				.filter((pTag) => (pTag !== undefined && pTag !== null && pTag !== ''));
		}
		return tmpOption;
	}

	/**
	 * Resolve one EntityTags spec to a chip string. A spec is either a field name (`'ISBN'` → the raw
	 * value) or an object `{ Field, Label, Template }`: `Template` renders against the whole record;
	 * `Label` prefixes the value (`"Year: 2000"`) — useful when several numeric chips would be ambiguous.
	 *
	 * @param {string|Record<string, any>} pSpec @param {any} pRecord
	 * @return {any}
	 */
	_composeTagValue(pSpec, pRecord)
	{
		if (typeof pSpec === 'string')
		{
			return pRecord[pSpec];
		}
		if (pSpec && typeof pSpec === 'object')
		{
			let tmpValue = pSpec.Template ? this.pict.parseTemplate(pSpec.Template, pRecord) : pRecord[pSpec.Field];
			if (tmpValue === undefined || tmpValue === null || tmpValue === '') { return ''; }
			return pSpec.Label ? `${pSpec.Label}: ${tmpValue}` : tmpValue;
		}
		return '';
	}

	/**
	 * Fetch-then-merge the join entity for a page of searched records. Collects the unique FK ids the
	 * rows carry (`JoinConfig.FKColumn`), issues ONE `FBL~{PKColumn}~INN~<ids>` request against the join
	 * entity, and stitches `JoinRecord` + `JoinName` onto each searched row. Resolves the (mutated) same
	 * array; on any error or when there's nothing to join, resolves the records un-decorated (the Text
	 * gracefully degrades to the base field).
	 *
	 * @param {Array<any>} pRecords @param {false | Record<string, any>} pJoinConfig
	 * @return {Promise<Array<any>>}
	 */
	_decorateRecordsWithJoin(pRecords, pJoinConfig)
	{
		return new Promise((resolve) =>
		{
			if (!pJoinConfig || !Array.isArray(pRecords) || pRecords.length < 1 || !this.pict.EntityProvider) { return resolve(pRecords); }
			const tmpIDs = [];
			const tmpSeen = {};
			for (let i = 0; i < pRecords.length; i++)
			{
				const tmpID = pRecords[i][pJoinConfig.FKColumn];
				if (tmpID !== undefined && tmpID !== null && tmpID !== '' && !tmpSeen[tmpID]) { tmpSeen[tmpID] = true; tmpIDs.push(tmpID); }
			}
			if (tmpIDs.length < 1) { return resolve(pRecords); }
			const tmpFilter = `FBL~${pJoinConfig.PKColumn}~INN~${tmpIDs.join(',')}`;
			this.pict.EntityProvider.getEntitySetPage(pJoinConfig.Entity, tmpFilter, 0, tmpIDs.length,
				(pError, pJoinRecords) =>
				{
					if (pError)
					{
						this.pict.log.warn(`Pict-Section-Picker [${pJoinConfig.Entity}] join fetch failed; showing un-joined text.`, pError);
						return resolve(pRecords);
					}
					const tmpMap = {};
					const tmpJoinList = Array.isArray(pJoinRecords) ? pJoinRecords : [];
					for (let i = 0; i < tmpJoinList.length; i++) { tmpMap[tmpJoinList[i][pJoinConfig.PKColumn]] = tmpJoinList[i]; }
					for (let i = 0; i < pRecords.length; i++)
					{
						const tmpJoinRecord = tmpMap[pRecords[i][pJoinConfig.FKColumn]];
						if (tmpJoinRecord) { pRecords[i].JoinRecord = tmpJoinRecord; pRecords[i].JoinName = tmpJoinRecord[pJoinConfig.DisplayField]; }
					}
					return resolve(pRecords);
				});
		});
	}

	/**
	 * Build a `ResolveValue(value) => Promise<{Value,Text}>` for an entity-backed picker, so a
	 * pre-bound ID resolves to its display text on first render (fetched + cached by `getEntity`).
	 *
	 * @param {Record<string, any>} pConfig - Same shape as {@link createEntityDataProvider}.
	 * @return {(pValue: any) => Promise<any>}
	 */
	createEntityResolveValue(pConfig)
	{
		const tmpEntity = pConfig.Entity;
		const tmpValueField = pConfig.ValueField || `ID${tmpEntity}`;
		const tmpTextField = pConfig.TextField || 'Name';
		const tmpMapRecord = (typeof pConfig.MapRecord === 'function') ? pConfig.MapRecord : false;
		const tmpJoinConfig = this._resolveJoinConfig(pConfig);
		const tmpEntityTagField = pConfig.EntityTag || false;
		const tmpEntityTagFields = Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false;
		const tmpTextTemplate = pConfig.TextTemplate || false;

		return (pValue) => new Promise((resolve) =>
		{
			if (pValue === undefined || pValue === null || pValue === '' || !this.pict.EntityProvider)
			{
				return resolve(null);
			}
			this.pict.EntityProvider.getEntity(tmpEntity, pValue,
				(pError, pRecord) =>
				{
					if (pError || !pRecord) { return resolve(null); }
					const fFinish = () =>
					{
						if (tmpMapRecord) { return resolve(tmpMapRecord(pRecord)); }
						return resolve(this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields));
					};
					// JoinEntity: resolve the single joined record (cached getEntity) for the compound label.
					const tmpFK = tmpJoinConfig ? pRecord[tmpJoinConfig.FKColumn] : null;
					if (!tmpJoinConfig || tmpFK === undefined || tmpFK === null || tmpFK === '') { return fFinish(); }
					this.pict.EntityProvider.getEntity(tmpJoinConfig.Entity, tmpFK,
						(pJoinError, pJoinRecord) =>
						{
							if (!pJoinError && pJoinRecord) { pRecord.JoinRecord = pJoinRecord; pRecord.JoinName = pJoinRecord[tmpJoinConfig.DisplayField]; }
							return fFinish();
						});
				});
		});
	}

	/**
	 * Create a picker backed by a Meadow entity — the high-level entry point for the real
	 * lims/config/bridge entity pickers. Wires a server DataProvider + ResolveValue from `pConfig`
	 * and delegates to {@link createPicker}. Any picker option (DestinationAddress, ValueAddress,
	 * Placeholder, OnChange, …) may also be supplied and is passed through.
	 *
	 * @param {string} pPickerHash - Unique hash/id for this picker.
	 * @param {Record<string, any>} pConfig - {@link createEntityDataProvider} config + picker options.
	 * @return {any} The picker view instance.
	 */
	createEntityPicker(pPickerHash, pConfig)
	{
		const tmpConfig = Object.assign({}, pConfig);
		// Key the back-off state by picker hash so it survives this rebuild (hosts re-mount every marshal).
		tmpConfig.DataProvider = this.createEntityDataProvider(pConfig, pPickerHash);
		if (!tmpConfig.ResolveValue) { tmpConfig.ResolveValue = this.createEntityResolveValue(pConfig); }
		return this.createPicker(pPickerHash, tmpConfig);
	}
}

module.exports = PictProviderPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../views/PictView-Picker.js":608,"pict-provider":479}],608:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * HTML-escape a value so it is safe both inside a double-quoted attribute and as element text content.
 * Option values / labels can carry characters like the inch mark (`1"`) or an apostrophe that would
 * otherwise terminate an attribute or an inline handler string. Every user value the templates drop into
 * an attribute or a text node is passed through this; the value a handler actually operates on is read
 * back — the browser decodes it — from a `data-` attribute rather than being inlined into the onclick.
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	return String((pValue === null || pValue === undefined) ? '' : pValue)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * The theme custom properties the widget paints from. Copied onto a portaled panel so it keeps the
 * host's theme after it stops inheriting from a scoped container (see _portalPop / _restorePop).
 * @type {Array<string>}
 */
const _THEME_TOKENS =
[
	'--theme-color-brand-primary', '--theme-color-text-primary', '--theme-color-text-secondary',
	'--theme-color-text-muted', '--theme-color-border-default', '--theme-color-border-light',
	'--theme-color-border-strong', '--theme-color-background-primary', '--theme-color-background-panel',
	'--theme-color-background-tertiary',
];

/**
 * Record columns never offered as field-decoration choices — the common Meadow audit/system columns. The
 * value + text fields and any host `DecorationIgnoreFields` are layered on top of these at runtime.
 * @type {Array<string>}
 */
const _DECORATION_IGNORE_DEFAULT =
[
	'Deleted', 'DeleteDate', 'DeletingIDUser', 'CreateDate', 'CreatingIDUser',
	'UpdateDate', 'UpdatingIDUser', 'ExternalSyncDate',
];
/** localStorage key prefix for the per-entity field-decoration choice (client-only, no server state). */
const _DECORATION_KEY_PREFIX = 'PictSectionPicker.Decoration.';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-Section-Picker-View',

	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,

	DefaultRenderable: 'Pict-Section-Picker-Renderable',

	// Per-instance options (supplied by PictProviderPicker.createPicker):
	PickerHash: false,
	DestinationAddress: false,
	ValueAddress: false,
	// 'single' (scalar value) or 'multi' (array of values, rendered as removable chips).
	Mode: 'single',
	Placeholder: 'Select…',
	Searchable: true,
	Options: [],
	// EntityTag badge ordering: false → badge before the label (the select2 default), true → after.
	// The per-option Tag value rides on each source row (`{Value, Text, Tag}`); the entity adapter
	// stamps it from an `EntityTag` field name. With no Tag on a row, no badge renders.
	TagLast: false,
	// Async data source (Phase 2): DataProvider(searchTerm, page) => Promise<{ results:[{Value,Text}], hasMore }>.
	// When a function, the widget searches + paginates through it instead of the static Options list.
	DataProvider: false,
	PageSize: 20,
	// Async only: minimum trimmed search length before a server query fires (browse-on-open + new
	// search). 0 = always query (the common default). >0 suppresses the request below the threshold.
	MinimumSearchLength: 0,
	// Optional ResolveValue(value) => Promise<{Value,Text}> to resolve the display text of a pre-set
	// value in async mode (e.g. fetch the entity for a bound ID so the control shows its name).
	ResolveValue: false,
	// Multi mode extra bindings (the EntitySelectorMultiple contract). All optional; ValueAddress
	// always holds the array of values. These mirror it as a csv string and as the full record list.
	StringArrayValueAddress: false,
	SelectedValuesAddress: false,
	// Creatable (Phase 4): OnCreate(searchTerm) => {Value,Text} | Promise<{Value,Text}>. When set, a
	// "Create …" row appears for a non-empty search term that doesn't exactly match an existing option.
	OnCreate: false,
	// Clearable (single mode): when true, the dropdown gets a pinned "Any" row at the top and the
	// control grows an inline × while a value is selected — either empties the selection and fires
	// OnChange(null, null). Filters are the natural fit ("Any" = no constraint); multi mode already
	// clears via its chips, so the option is ignored there.
	AllowClear: false,
	ClearLabel: 'Any',
	// The text shown when the list has no options for the current search. A string, or a function
	// (searchTerm) => string asked again on every empty render, so a host can say why the list is empty
	// (e.g. its own scope narrowed it). Rendered as text; an empty result or a throw falls back to the default.
	EmptyLabel: 'No matches',

	// When true, render the resolved selection as plain, non-interactive text (no dropdown / chevron /
	// clear) — for read-only form views. The host sets PictForm.ReadOnly; the form-input passes it through.
	ReadOnly: false,

	// Opt-in: opening this picker closes any other open picker that ALSO opted in (at most one dropdown
	// on the page — select2-style). Off by default so hosts that tolerate stacked dropdowns see no
	// behavior change, and a picker left off is neither closed by nor closes a participant. Usually
	// enabled fleet-wide via the provider's SingleActivePicker option (createPicker seeds it).
	SingleActivePicker: false,

	// The Meadow entity this picker selects from. Set automatically by createEntityPicker; a custom-
	// DataProvider host may pass it to opt into entity-aware affordances (preview cards, field decoration).
	Entity: false,
	// Field decoration (opt-in). When true AND the picker is entity-aware — an `Entity` name is set and its
	// result rows carry a full `Record` — a small ⚙ in the search row lets the user pin extra record fields
	// onto every option row as tag badges ("VendorCode: 12345"), to tell same-named entities apart. The
	// choice is remembered in localStorage keyed by Entity (so it follows the user to every picker of that
	// entity) and never leaves the browser. `DecorationIgnoreFields` drops fields from the chooser, on top
	// of the value/text fields and the common audit columns, which are always hidden.
	AllowFieldDecoration: false,
	DecorationIgnoreFields: [],

	// Values that mean "nothing is selected" for DISPLAY, on top of undefined/null/''. The widget still
	// stores and returns whatever it was given — this only decides whether the control paints the
	// placeholder instead of the raw value, so a host's sentinel never has to become a data change.
	// The pict-section-form adapter seeds it with [0] for a Number/Integer/Float descriptor, whose
	// pristine marshal value is manyfest's DataType default 0 rather than ''. A sentinel that DOES
	// resolve to a real source row (a static option literally valued 0) is a genuine selection and is
	// shown normally.
	EmptyValues: [],

	Templates:
	[
		{
			// The whole widget: control box + (transparent) backdrop + dropdown. The dropdown lives in
			// the DOM whether open or closed (toggled by the .pps-open class) so open/close needs no
			// re-render. The option list re-renders on its own for search (keeps the input focused).
			// The control is a div (role=combobox) not a button so multi-mode chips can carry their own
			// remove buttons without nesting <button> elements.
			Hash: 'Pict-Section-Picker-Control',
			Template: /*html*/`
	<div class="pps{~NE:Record.IsMulti^ pps-multi~}{~NE:Record.ReadOnly^ pps-readonly~}" id="PPS_{~D:Record.PickerHash~}">
		<div class="pps-control" role="combobox" tabindex="0" aria-haspopup="listbox" onclick="_Pict.views['{~D:Record.PickerHash~}'].toggle(event)" onkeydown="_Pict.views['{~D:Record.PickerHash~}'].onControlKey(event)">
			<div class="pps-valuearea" id="PPS_Value_{~D:Record.PickerHash~}">{~T:Pict-Section-Picker-ValueArea~}</div>
			{~TS:Pict-Section-Picker-ClearX:Record.ClearSlot~}
			<span class="pps-chevron">{~I:ChevronDown~}</span>
		</div>
		<div class="pps-backdrop" onclick="_Pict.views['{~D:Record.PickerHash~}'].closeFromBackdrop(event)"></div>
		<div class="pps-pop" id="PPS_Pop_{~D:Record.PickerHash~}">
			<div class="pps-panel">
				{~TS:Pict-Section-Picker-Search:Record.SearchSlot~}
				<div class="pps-decorate-panel" id="PPS_Decorate_{~D:Record.PickerHash~}">{~T:Pict-Section-Picker-DecoratePanel~}</div>
				<div class="pps-list" id="PPS_List_{~D:Record.PickerHash~}">
					{~T:Pict-Section-Picker-List~}
				</div>
			</div>
		</div>
	</div>
`
		},
		{
			// The control's value display: single-mode value span OR multi-mode chips, chosen by the
			// single-element-array slots so we never render both.
			Hash: 'Pict-Section-Picker-ValueArea',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-Single:Record.SingleSlot~}
	{~TS:Pict-Section-Picker-Multi:Record.MultiSlot~}
`
		},
		{
			// The inline clear × (AllowClear) — a control-level adornment between the value area and
			// the chevron, so it centers next to the text (the value area's children stack as blocks).
			// It sits OUTSIDE #PPS_Value_, so the targeted repaint can't refresh it — and its presence
			// tracks the VALUE. _shapeSignature() therefore includes it, which forces setValue onto a
			// full render whenever it would appear or disappear. stopPropagation so clearing
			// never bubbles into the control's open/close toggle — mirrors the multi-chip remove ×.
			Hash: 'Pict-Section-Picker-ClearX',
			Template: /*html*/`
	<span class="pps-clear" title="Clear" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].clearValue()">{~I:Close~}</span>
`
		},
		{
			Hash: 'Pict-Section-Picker-Single',
			Template: /*html*/`
	<span class="pps-valuebox">{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-value{~NE:Record.NoValue^ pps-placeholder~}">{~D:Record.DisplayTextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-CardInfo:Record.CardSlot~}</span>
`
		},
		{
			// Multi-mode: the selected chips, plus a placeholder slot when nothing is selected.
			Hash: 'Pict-Section-Picker-Multi',
			Template: /*html*/`
	<span class="pps-chips">{~TS:Pict-Section-Picker-Chip:Record.Chips~}{~TS:Pict-Section-Picker-Placeholder:Record.PlaceholderSlot~}</span>
`
		},
		{
			Hash: 'Pict-Section-Picker-Placeholder',
			Template: /*html*/`
	<span class="pps-chips-ph">{~D:Record.Placeholder~}</span>
`
		},
		{
			// One selected chip with an inline remove button. stopPropagation on the × so removing a
			// chip never bubbles up to the control's open/close toggle.
			Hash: 'Pict-Section-Picker-Chip',
			Template: /*html*/`
	<span class="pps-chip">{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-chip-text" title="{~D:Record.TextAttr~}">{~D:Record.TextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-CardInfo:Record.CardSlot~}<span class="pps-chip-x" data-pps-valuekey="{~D:Record.ValueKeyAttr~}" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].removeChipFromElement(this)">{~I:Close~}</span></span>
`
		},
		{
			// Search box — its own template (gated by the single-element-array SearchSlot) because
			// {~NE:~} does not recursively parse nested {~I:~}/{~D:~} tags.
			Hash: 'Pict-Section-Picker-Search',
			Template: /*html*/`
	<div class="pps-search">
		<span class="pps-search-ic">{~I:Search~}</span>
		<input type="text" id="PPS_Search_{~D:Record.PickerHash~}" placeholder="Search…" autocomplete="off" oninput="_Pict.views['{~D:Record.PickerHash~}'].search(this.value)" onkeydown="_Pict.views['{~D:Record.PickerHash~}'].onSearchKey(event)">
		{~TS:Pict-Section-Picker-DecorateToggle:Record.DecorateSlot~}
	</div>
`
		},
		{
			Hash: 'Pict-Section-Picker-List',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-ClearOption:Record.ClearOptionSlot~}
	{~TS:Pict-Section-Picker-Create:Record.CreateSlot~}
	{~TS:Pict-Section-Picker-Group:Record.Groups~}
	{~TS:Pict-Section-Picker-Empty:Record.EmptySlot~}
	{~NE:Record.Loading^<div class="pps-loading">Loading…</div>~}
	{~TS:Pict-Section-Picker-More:Record.MoreSlot~}
`
		},
		{
			Hash: 'Pict-Section-Picker-Empty',
			Template: /*html*/`<div class="pps-empty">{~D:Record.Label~}</div>`
		},
		{
			// The pinned "Any" row (AllowClear, single mode) — selecting it empties the selection.
			// It shows the check when nothing is selected (i.e. "Any" is the active state).
			Hash: 'Pict-Section-Picker-ClearOption',
			Template: /*html*/`
	<button type="button" class="pps-option pps-clear-option{~NE:Record.Selected^ pps-selected~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].clearValue()">
		<span class="pps-option-check{~NE:Record.NotSelected^ pps-hidden~}">{~I:Check~}</span>
		<span class="pps-option-label">{~D:Record.Label~}</span>
	</button>
`
		},
		{
			// A category: an optional header (single-element-array HeaderSlot) followed by its options.
			// With no categories everything lands in one unlabeled group, so the list path is uniform.
			Hash: 'Pict-Section-Picker-Group',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-GroupHeader:Record.HeaderSlot~}
	{~TS:Pict-Section-Picker-Option:Record.Options~}
`
		},
		{
			Hash: 'Pict-Section-Picker-GroupHeader',
			Template: /*html*/`
	<div class="pps-group">{~D:Record.Label~}</div>
`
		},
		{
			// "Create <term>" row — its own template (single-element-array CreateSlot), so the nested
			// {~I:~}/{~D:~} tags parse (unlike inside an {~NE:~}).
			Hash: 'Pict-Section-Picker-Create',
			Template: /*html*/`
	<button type="button" class="pps-create" onclick="_Pict.views['{~D:Record.PickerHash~}'].createFromSearch()"><span class="pps-create-ic">{~I:Plus~}</span><span>Create &ldquo;{~D:Record.TermAttr~}&rdquo;</span></button>
`
		},
		{
			// "Load more" — its own template (single-element-array MoreSlot) for the same nested-tag
			// reason as the search box.
			Hash: 'Pict-Section-Picker-More',
			Template: /*html*/`
	<button type="button" class="pps-more" onclick="_Pict.views['{~D:Record.PickerHash~}'].loadMore()">Load more</button>
`
		},
		{
			Hash: 'Pict-Section-Picker-Option',
			Template: /*html*/`
	<button type="button" class="pps-option{~NE:Record.Selected^ pps-selected~}{~NE:Record.Highlight^ pps-highlight~}" data-pps-valuekey="{~D:Record.ValueKeyAttr~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].selectFromElement(this)">
		<span class="pps-option-check{~NE:Record.NotSelected^ pps-hidden~}">{~I:Check~}</span>
		{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-option-label" title="{~D:Record.TextAttr~}">{~D:Record.TextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}
	</button>
`
		},
		{
			// EntityTag badge — a small code/number pill rendered before or after the label via the
			// TagBeforeSlot / TagAfterSlot single-element-array slots on each option / chip / value record.
			Hash: 'Pict-Section-Picker-Tag',
			Template: /*html*/`
		<span class="pps-tag">{~D:Record.Tag~}</span>
`
		},
		{
			// Preview-card ⓘ trigger — a small affordance next to a selected value / chip that opens the
			// entity's registered preview card (RecordSetCardManager, a soft dependency). Gated to a
			// single-element-array CardSlot so it renders only when a card exists for the picker's Entity;
			// stopPropagation so it never toggles the control or removes a chip.
			Hash: 'Pict-Section-Picker-CardInfo',
			Template: /*html*/`
		<span class="pps-card-info" title="Preview" data-pps-entity="{~D:Record.EntityAttr~}" data-pps-value="{~D:Record.ValueAttr~}" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].openCardFromElement(this)">{~I:Info~}</span>
`
		},
		{
			// Field-decoration ⚙ (AllowFieldDecoration) — a trailing button in the search row that opens the
			// field chooser. Rendered via the single-element-array DecorateSlot so it appears only when the
			// feature is enabled + eligible. stopPropagation so it never bubbles into the control toggle.
			Hash: 'Pict-Section-Picker-DecorateToggle',
			Template: /*html*/`<button type="button" id="PPS_DecorateBtn_{~D:Record.PickerHash~}" class="pps-decorate-btn{~NE:Record.HasFields^ pps-decorate-on~}{~NE:Record.Open^ pps-decorate-open~}" title="Show extra fields on each row" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].toggleDecorate(event)">{~I:Settings~}</button>`
		},
		{
			// The field chooser — rendered into #PPS_Decorate_ between the search row and the list. Empty
			// (collapsed) unless the chooser is open; DecoratePanelSlot carries the candidate fields.
			Hash: 'Pict-Section-Picker-DecoratePanel',
			Template: /*html*/`{~TS:Pict-Section-Picker-DecorateInner:Record.DecoratePanelSlot~}`
		},
		{
			Hash: 'Pict-Section-Picker-DecorateInner',
			Template: /*html*/`
		<div class="pps-decorate">
			<div class="pps-decorate-title">Show extra fields on each row</div>
			<div class="pps-decorate-list">{~TS:Pict-Section-Picker-DecorateField:Record.Fields~}{~NE:Record.NoFields^<div class="pps-decorate-empty">No extra fields to show yet.</div>~}</div>
		</div>
`
		},
		{
			// One checkbox row in the chooser. The label wraps the input so a click anywhere toggles it.
			Hash: 'Pict-Section-Picker-DecorateField',
			Template: /*html*/`<label class="pps-decorate-opt"><input type="checkbox"{~NE:Record.Checked^ checked~} data-pps-field="{~D:Record.FieldAttr~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].toggleDecorateFieldFromElement(this)"><span class="pps-decorate-name">{~D:Record.FieldAttr~}</span></label>`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'Pict-Section-Picker-Renderable',
			TemplateHash: 'Pict-Section-Picker-Control',
			RenderMethod: 'replace',
		},
	],
};

class PictViewPicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Render the control into the host-supplied destination, and read state from this picker's
		// AppData slot (keyed by hash so many pickers can share the global templates).
		this.options.DefaultDestinationAddress = this.options.DestinationAddress || `#${this.options.PickerHash}`;
		this._StateAddress = `AppData.PictSectionPicker.${this.options.PickerHash}`;
		this.options.DefaultTemplateRecordAddress = this._StateAddress;
		if (Array.isArray(this.options.Renderables) && this.options.Renderables[0])
		{
			this.options.Renderables[0].ContentDestinationAddress = this.options.DefaultDestinationAddress;
		}

		// Transient UI state (the data lives in AppData; these drive a single picker's interaction).
		this._open = false;
		this._search = '';
		this._highlight = -1;
		// Async-mode state (Phase 2): accumulated results across pages + paging/loading flags.
		this._loadedResults = [];
		this._page = 0;
		this._hasMore = false;
		this._loading = false;
		this._loaded = false;
		this._searchTimer = null;
		this._selectedText = null;
		// Anchoring: true while portaled to <body>, false while CSS-anchored. Decided per open (see the
		// "Dropdown anchoring & render states" note below).
		this._portaled = false;
		// _shapeSignature() of the current paint, stamped by onAfterRender (null until first render).
		this._renderedShape = null;
		// Multi-mode state: the authoritative {Value,Text} for each selected value, keyed by String(Value),
		// so a chip keeps its label even after the search results that produced it have scrolled away.
		this._values = [];
		this._selectedRecords = {};

		// Field-decoration (opt-in) state: the chosen extra fields (loaded from localStorage) + the chooser's
		// open flag + a lazily-resolved storage backend. Load before the first _buildState so the initial
		// paint already carries any remembered decorations.
		this._decorationOpen = false;
		this._decorationFields = [];
		this._decorationStore = null;
		this._loadDecorationFields();

		// Populate the AppData state slot now so the template Record (resolved from
		// DefaultTemplateRecordAddress) reflects it on the very first render — pict resolves the
		// Record before onBeforeRender runs.
		try { this._buildState(); } catch (pError) { /* AppData/value not ready — onBeforeRender will build it */ }

		// Async mode: resolve the display text of pre-set bound value(s) (e.g. fetch the entity for an ID).
		if (this._isAsync() && typeof this.options.ResolveValue === 'function')
		{
			this._resolveInitialValues();
		}
	}

	/** @return {boolean} True when a DataProvider function is configured (async/server mode). */
	_isAsync()
	{
		return (typeof this.options.DataProvider === 'function');
	}

	/** @return {boolean} True when the picker is in multi-select (chips) mode. */
	_isMulti()
	{
		return (this.options.Mode === 'multi');
	}

	/** @return {Record<string, any>} The AppData state slot for this picker. */
	_state()
	{
		this.pict.AppData.PictSectionPicker = this.pict.AppData.PictSectionPicker || {};
		this.pict.AppData.PictSectionPicker[this.options.PickerHash] = this.pict.AppData.PictSectionPicker[this.options.PickerHash] || {};
		return this.pict.AppData.PictSectionPicker[this.options.PickerHash];
	}

	/**
	 * True when a value should be PAINTED as "nothing selected" — undefined/null/'', or one of the
	 * host's configured `EmptyValues` sentinels. Display-only: `_value` / getValue() keep the raw value,
	 * so nothing here rewrites the host's model.
	 *
	 * The sentinel yields to reality: one that matches a real source row (a static option literally
	 * valued 0, say) is a genuine selection and renders normally. Entity pickers skip the async resolve
	 * for a sentinel entirely — there is no entity #0 to fetch.
	 * @param {any} pValue @return {boolean}
	 */
	_isEmptyValue(pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '') { return true; }
		const tmpEmptyValues = this.options.EmptyValues;
		if (!Array.isArray(tmpEmptyValues) || tmpEmptyValues.length < 1) { return false; }
		if (!tmpEmptyValues.some((pEmpty) => String(pEmpty) === String(pValue))) { return false; }
		return !this._lookupRecord(pValue);
	}

	/** Resolve display text for any pre-bound value(s) via the async ResolveValue hook, then repaint. */
	_resolveInitialValues()
	{
		const tmpResolveOne = (pValue) =>
		{
			if (this._isEmptyValue(pValue)) { return; }
			Promise.resolve(this.options.ResolveValue(pValue)).then((pResolved) =>
			{
				if (pResolved && pResolved.Text)
				{
					if (this._isMulti())
					{
						this._selectedRecords[String(pValue)] = { Value: pResolved.Value !== undefined ? pResolved.Value : pValue, Text: pResolved.Text, Tag: pResolved.Tag, Tags: pResolved.Tags };
						this._renderValue();
					}
					else
					{
						this._selectedText = pResolved.Text;
						this.render();
					}
				}
			}).catch(() => { /* leave the raw value showing */ });
		};

		if (this._isMulti())
		{
			this.getValue().forEach(tmpResolveOne);
		}
		else
		{
			tmpResolveOne(this.getValue());
		}
	}

	/**
	 * @return {any} The current selection: a scalar in single mode, or an array of values in multi mode
	 *   (normalizing a csv string or scalar at the bound address into an array).
	 */
	getValue()
	{
		const tmpRaw = this.options.ValueAddress
			? this.pict.manifest.getValueAtAddress(this.pict, this.options.ValueAddress)
			: (this._isMulti() ? this._values : this._value);
		if (!this._isMulti())
		{
			return tmpRaw;
		}
		if (tmpRaw === undefined || tmpRaw === null || tmpRaw === '') { return []; }
		if (Array.isArray(tmpRaw)) { return tmpRaw; }
		if (typeof tmpRaw === 'string') { return tmpRaw.split(',').filter((pPart) => pPart !== ''); }
		return [ tmpRaw ];
	}

	/**
	 * Persist the selection to the bound address(es). Single mode writes the scalar; multi mode writes
	 * the array to ValueAddress and mirrors it to the optional csv / records addresses.
	 * @param {any} pValue - The new value (scalar in single mode, array in multi mode).
	 */
	_setValue(pValue)
	{
		if (!this._isMulti())
		{
			this._value = pValue;
			if (this.options.ValueAddress)
			{
				this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, pValue);
			}
			return;
		}

		const tmpArray = Array.isArray(pValue) ? pValue : [];
		this._values = tmpArray;
		if (this.options.ValueAddress)
		{
			this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, tmpArray);
		}
		if (this.options.StringArrayValueAddress)
		{
			this.pict.manifest.setValueAtAddress(this.pict, this.options.StringArrayValueAddress, tmpArray.join(','));
		}
		if (this.options.SelectedValuesAddress)
		{
			const tmpRecords = tmpArray.map((pVal) => this._selectedRecords[String(pVal)] || { Value: pVal, Text: String(pVal) });
			this.pict.manifest.setValueAtAddress(this.pict, this.options.SelectedValuesAddress, tmpRecords);
		}
	}

	/**
	 * Public: set the picker's value programmatically (e.g. when a host form marshals data into it).
	 * Accepts a scalar (single mode) or an array / csv string (multi mode), seeds display text for any
	 * unknown values (from the source rows, else async ResolveValue), then repaints.
	 * @param {any} pValue
	 * @return {PictViewPicker} this
	 */
	setValue(pValue)
	{
		if (this._isMulti())
		{
			let tmpArray = pValue;
			if (tmpArray === undefined || tmpArray === null || tmpArray === '') { tmpArray = []; }
			else if (typeof tmpArray === 'string') { tmpArray = tmpArray.split(',').filter((pPart) => pPart !== ''); }
			else if (!Array.isArray(tmpArray)) { tmpArray = [ tmpArray ]; }
			// Seed the {Value,Text} records BEFORE persisting, so the SelectedValuesAddress mirror that
			// _setValue writes carries real labels (not String(value) fallbacks). Mirrors select()'s
			// seed-then-persist order.
			this._seedSelectedRecords(tmpArray);
			this._setValue(tmpArray);
		}
		else
		{
			this._setValue(pValue);
			this._selectedText = null;
			this._seedSelectedRecords(this._isEmptyValue(pValue) ? [] : [ pValue ]);
		}
		this._reflectValue();
		return this;
	}

	/**
	 * Reflect a programmatic setValue into the DOM. Full render when the widget isn't live yet, or when
	 * _shapeSignature() shows something outside the value area / list changed; otherwise just repaint
	 * those two (the list's checkmark tracks the value). The targeted path is what lets a form marshal
	 * re-seed on every solve without tearing down the search box (losing focus) or orphaning a portal.
	 * select()/clearValue() keep their own full renders — this is only the setValue path.
	 */
	_reflectValue()
	{
		const tmpLive = (typeof document !== 'undefined') && !!document.getElementById(`PPS_${this.options.PickerHash}`);
		if (!tmpLive || (this._shapeSignature() !== this._renderedShape)) { this.render(); return; }
		this._renderValue();
		this._renderList();
	}

	/**
	 * Signature of the render-affecting state the targeted refresh CANNOT repaint — the three things that
	 * render outside #PPS_Value_ / #PPS_List_: the root's pps-multi/pps-readonly classes, the search box,
	 * and the inline clear × (gated on value presence, so it moves with no config change). _reflectValue
	 * full-renders when this changes. Extend it if the control template grows another such slot.
	 * @return {string}
	 */
	_shapeSignature()
	{
		const tmpMulti = this._isMulti();
		const tmpValue = tmpMulti ? undefined : this.getValue();
		const tmpHasValue = !this._isEmptyValue(tmpValue);
		return [
			tmpMulti,
			!!this.options.ReadOnly,
			!!this.options.Searchable,
			(!tmpMulti && this.options.AllowClear === true && tmpHasValue),
		].join('|');
	}

	/**
	 * Ensure each value has a {Value,Text} in _selectedRecords — from the current source rows when
	 * present, else (async mode) fetched via ResolveValue and painted in when it resolves.
	 * @param {Array<any>} pValues
	 */
	_seedSelectedRecords(pValues)
	{
		pValues.forEach((pVal) =>
		{
			if (this._isEmptyValue(pVal) || this._selectedRecords[String(pVal)]) { return; }
			const tmpRow = this._sourceRows().find((pRow) => String(pRow.Value) === String(pVal));
			if (tmpRow)
			{
				this._selectedRecords[String(pVal)] = { Value: tmpRow.Value, Text: tmpRow.Text, Tag: tmpRow.Tag, Tags: tmpRow.Tags };
				return;
			}
			if (this._isAsync() && typeof this.options.ResolveValue === 'function')
			{
				Promise.resolve(this.options.ResolveValue(pVal)).then((pResolved) =>
				{
					if (pResolved && pResolved.Text)
					{
						this._selectedRecords[String(pVal)] = { Value: pResolved.Value !== undefined ? pResolved.Value : pVal, Text: pResolved.Text, Tag: pResolved.Tag, Tags: pResolved.Tags };
						if (!this._isMulti()) { this._selectedText = pResolved.Text; }
						this._renderValue();
					}
				}).catch(() => { /* leave the raw value showing */ });
			}
		});
	}

	/** @return {Array<{Value:any, Text:string, Tag?:any}>} The current option source rows (async results or static Options). */
	_sourceRows()
	{
		if (this._isAsync()) { return this._loadedResults; }
		return Array.isArray(this.options.Options) ? this.options.Options : [];
	}

	/**
	 * Build the EntityTag before/after render slots for a record. Accepts a single tag value OR an array
	 * of them (the `Tags` multi-badge form), so a record can carry several disambiguation chips (e.g. a
	 * book's ISBN + year). Empty/blank entries are dropped; a tag-less record renders no badge. The slot
	 * is a per-tag `{Tag}` array, and the value/chip/option templates already iterate it with `{~TS:~}`.
	 * @param {any} pTags - a tag value, or an array of tag values.
	 * @param {boolean} pTagLast
	 * @return {{TagBeforeSlot:Array<any>, TagAfterSlot:Array<any>}}
	 */
	_tagSlots(pTags, pTagLast)
	{
		const tmpList = Array.isArray(pTags)
			? pTags
			: ((pTags !== undefined && pTags !== null && pTags !== '') ? [ pTags ] : []);
		const tmpSlot = tmpList
			.filter((pTag) => (pTag !== undefined && pTag !== null && pTag !== ''))
			.map((pTag) => ({ Tag: pTag }));
		return {
			TagBeforeSlot: (tmpSlot.length > 0 && !pTagLast) ? tmpSlot : [],
			TagAfterSlot: (tmpSlot.length > 0 && pTagLast) ? tmpSlot : [],
		};
	}

	/**
	 * The tag(s) to render for a record — the multi-badge `Tags` array when present, else the single
	 * `Tag` (back-compat). Centralizes the precedence used by every `_tagSlots` call site.
	 * @param {any} pRecord
	 * @return {any}
	 */
	_recordTags(pRecord)
	{
		if (!pRecord) { return undefined; }
		return (pRecord.Tags !== undefined) ? pRecord.Tags : pRecord.Tag;
	}

	// --- Field decoration (opt-in): let the user pin extra record fields onto each option row ---

	/** @return {boolean} The decoration affordance is available: opted in, interactive, and namespaced. */
	_decorationEnabled()
	{
		return (this.options.AllowFieldDecoration === true) && !this.options.ReadOnly && !!this._decorationKey();
	}

	/** localStorage key — per Entity, so a field pinned on one Organization picker shows on them all;
	 *  falls back to the picker hash when no Entity is set. @return {string} */
	_decorationKey()
	{
		if (this.options.Entity) { return `${_DECORATION_KEY_PREFIX}${this.options.Entity}`; }
		return this.options.PickerHash ? `${_DECORATION_KEY_PREFIX}${this.options.PickerHash}` : '';
	}

	/** Lazily resolve a storage backend: window.localStorage in a browser, an in-memory shim otherwise
	 *  (unit tests / SSR), mirroring the pict-section-recordset persistence idiom. */
	_decorationStorage()
	{
		if (this._decorationStore) { return this._decorationStore; }
		if ((typeof window === 'object') && window && (typeof window.localStorage === 'object') && window.localStorage)
		{
			this._decorationStore = window.localStorage;
		}
		else
		{
			const tmpMemory = {};
			this._decorationStore = {
				getItem: (pKey) => ((pKey in tmpMemory) ? tmpMemory[pKey] : null),
				setItem: (pKey, pValue) => { tmpMemory[pKey] = String(pValue); },
				removeItem: (pKey) => { delete tmpMemory[pKey]; },
			};
		}
		return this._decorationStore;
	}

	/** Read the persisted decoration field list for this picker's entity into _decorationFields. */
	_loadDecorationFields()
	{
		this._decorationFields = [];
		if (this.options.AllowFieldDecoration !== true) { return; }
		const tmpKey = this._decorationKey();
		if (!tmpKey) { return; }
		try
		{
			const tmpRaw = this._decorationStorage().getItem(tmpKey);
			const tmpParsed = tmpRaw ? JSON.parse(tmpRaw) : [];
			if (Array.isArray(tmpParsed)) { this._decorationFields = tmpParsed.filter((pField) => ((typeof pField === 'string') && pField)); }
		}
		catch (pError) { this._decorationFields = []; }
	}

	/** Persist the current decoration field list under this picker's entity key. */
	_saveDecorationFields()
	{
		const tmpKey = this._decorationKey();
		if (!tmpKey) { return; }
		try { this._decorationStorage().setItem(tmpKey, JSON.stringify(this._decorationFields)); }
		catch (pError) { /* storage full / disabled — the in-session choice still applies */ }
	}

	/** Field names hidden from the chooser: the common audit columns + the host's DecorationIgnoreFields +
	 *  the value/text fields (already shown as the row's value + label). @return {Set<string>} */
	_decorationIgnoreSet()
	{
		const tmpSet = new Set(_DECORATION_IGNORE_DEFAULT);
		const tmpHostIgnore = Array.isArray(this.options.DecorationIgnoreFields) ? this.options.DecorationIgnoreFields : [];
		tmpHostIgnore.forEach((pField) => { if (pField) { tmpSet.add(String(pField)); } });
		if (this.options.ValueField) { tmpSet.add(String(this.options.ValueField)); }
		else if (this.options.Entity) { tmpSet.add(`ID${this.options.Entity}`); }
		tmpSet.add(this.options.TextField ? String(this.options.TextField) : 'Name');
		return tmpSet;
	}

	/** Candidate decoration fields: the union of keys across the loaded rows' `Record` objects, minus the
	 *  ignore set, sorted. Empty until a result page carries records. @return {Array<string>} */
	_decorationCandidateFields()
	{
		const tmpKeys = {};
		this._sourceRows().forEach((pRow) =>
		{
			const tmpRecord = pRow && pRow.Record;
			if (tmpRecord && (typeof tmpRecord === 'object')) { Object.keys(tmpRecord).forEach((pKey) => { tmpKeys[pKey] = true; }); }
		});
		const tmpIgnore = this._decorationIgnoreSet();
		return Object.keys(tmpKeys).filter((pKey) => !tmpIgnore.has(pKey)).sort();
	}

	/** The decoration chips for an option: "Field: value" for each chosen field present on its `Record`.
	 *  @param {any} pOption @return {Array<string>|null} */
	_decorationTagsFor(pOption)
	{
		if (!this._decorationEnabled() || (this._decorationFields.length === 0)) { return null; }
		const tmpRecord = pOption && pOption.Record;
		if (!tmpRecord || (typeof tmpRecord !== 'object')) { return null; }
		const tmpTags = this._decorationFields
			.map((pField) => { const tmpValue = tmpRecord[pField]; return ((tmpValue !== undefined && tmpValue !== null && tmpValue !== '') ? `${pField}: ${tmpValue}` : null); })
			.filter((pTag) => (pTag !== null));
		return (tmpTags.length > 0) ? tmpTags : null;
	}

	/** The row's own EntityTag(s) plus the user's decoration chips (decorations last). @param {any} pOption */
	_combinedTags(pOption)
	{
		const tmpBase = this._recordTags(pOption);
		const tmpDecoration = this._decorationTagsFor(pOption);
		if (!tmpDecoration) { return tmpBase; }
		const tmpBaseList = Array.isArray(tmpBase) ? tmpBase : ((tmpBase !== undefined && tmpBase !== null && tmpBase !== '') ? [ tmpBase ] : []);
		return tmpBaseList.concat(tmpDecoration);
	}

	/** Toggle the field chooser open/closed (the ⚙ in the search row); repaints just the chooser + button. */
	toggleDecorate(pEvent)
	{
		if (pEvent && (typeof pEvent.stopPropagation === 'function')) { pEvent.stopPropagation(); }
		if (!this._decorationEnabled()) { return; }
		this._decorationOpen = !this._decorationOpen;
		this._renderDecorate();
		this._syncDecorateToggle();
	}

	/** Add/remove a field from the decoration set, persist, and repaint the option list + chooser. */
	toggleDecorateField(pField)
	{
		if (!pField) { return; }
		const tmpIndex = this._decorationFields.indexOf(pField);
		if (tmpIndex >= 0) { this._decorationFields.splice(tmpIndex, 1); }
		else { this._decorationFields.push(pField); }
		this._saveDecorationFields();
		this._renderList();
		this._renderDecorate();
		this._syncDecorateToggle();
	}

	/** Re-render only the chooser panel (mirrors _renderList — targeted, keeps the search input focused). */
	_renderDecorate()
	{
		if (typeof document === 'undefined') { return; }
		if (!document.getElementById(`PPS_Decorate_${this.options.PickerHash}`)) { return; }
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-DecoratePanel', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_Decorate_${this.options.PickerHash}`, tmpHTML);
	}

	/** Reflect the on/open state onto the ⚙ button without rebuilding the search row (which holds focus). */
	_syncDecorateToggle()
	{
		if (typeof document === 'undefined') { return; }
		const tmpBtn = document.getElementById(`PPS_DecorateBtn_${this.options.PickerHash}`);
		if (!tmpBtn) { return; }
		tmpBtn.classList.toggle('pps-decorate-on', (this._decorationFields.length > 0));
		tmpBtn.classList.toggle('pps-decorate-open', !!this._decorationOpen);
	}

	/**
	 * The empty-list text for the current search: the EmptyLabel string, or what an EmptyLabel function
	 * returns for the search term. A blank result or a throw falls back to the default.
	 *
	 * @return {string} The label, unescaped.
	 */
	_resolveEmptyLabel()
	{
		const tmpDefault = 'No matches';
		let tmpLabel = this.options.EmptyLabel;
		if (typeof tmpLabel === 'function')
		{
			try
			{
				tmpLabel = tmpLabel(this._search || '');
			}
			catch (pError)
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] EmptyLabel() threw; showing the default.`, pError);
				tmpLabel = '';
			}
		}
		return (typeof tmpLabel === 'string' && tmpLabel.length > 0) ? tmpLabel : tmpDefault;
	}

	/**
	 * (Re)compute the picker's render state into AppData: the displayed value / chips + the
	 * (search-filtered) option list with selected/highlight flags.
	 */
	_buildState()
	{
		const tmpState = this._state();
		const tmpAsync = this._isAsync();
		const tmpMulti = this._isMulti();
		const tmpSearch = (this._search || '').toLowerCase();

		// Source rows: async = the accumulated server results (already filtered server-side);
		// static = the configured Options, filtered locally by the search term.
		const tmpStatic = Array.isArray(this.options.Options) ? this.options.Options : [];
		const tmpSource = tmpAsync
			? this._loadedResults
			: tmpStatic.filter((pOption) => !tmpSearch || String(pOption.Text).toLowerCase().includes(tmpSearch));

		// Membership set used to flag options as selected (multi: every value; single: the one value).
		const tmpSelectedKeys = new Set((tmpMulti ? this.getValue() : [ this.getValue() ])
			.filter((pVal) => !this._isEmptyValue(pVal))
			.map((pVal) => String(pVal)));

		const tmpTagLast = !!this.options.TagLast;
		tmpState.Options = tmpSource.map((pOption, pIndex) =>
		{
			const tmpIsSelected = tmpSelectedKeys.has(String(pOption.Value));
			return Object.assign({
				PickerHash: this.options.PickerHash,
				ValueKey: String(pOption.Value),
				ValueKeyAttr: escapeHTML(String(pOption.Value)),
				Text: pOption.Text,
				TextAttr: escapeHTML(pOption.Text),
				Selected: tmpIsSelected,
				NotSelected: !tmpIsSelected,
				Highlight: (pIndex === this._highlight),
			}, this._tagSlots(this._combinedTags(pOption), tmpTagLast));
		});

		// Cluster options into categories (preserving order), keyed by each source row's optional Group.
		// With no Group fields everything lands in one unlabeled group, so the renderer has one path.
		const tmpGroups = [];
		const tmpGroupIndex = {};
		tmpState.Options.forEach((pOption, pIndex) =>
		{
			const tmpLabel = (tmpSource[pIndex] && tmpSource[pIndex].Group) ? String(tmpSource[pIndex].Group) : '';
			if (!(tmpLabel in tmpGroupIndex))
			{
				tmpGroupIndex[tmpLabel] = tmpGroups.length;
				tmpGroups.push({ Label: tmpLabel, HeaderSlot: tmpLabel ? [ { Label: tmpLabel } ] : [], Options: [] });
			}
			tmpGroups[tmpGroupIndex[tmpLabel]].Options.push(pOption);
		});
		tmpState.Groups = tmpGroups;

		// Creatable: offer "Create <term>" for a non-empty search that doesn't exactly match a known row.
		const tmpTerm = (this._search || '').trim();
		const tmpCanCreate = (typeof this.options.OnCreate === 'function') && tmpTerm.length > 0
			&& !this._sourceRows().some((pRow) => String(pRow.Text).trim().toLowerCase() === tmpTerm.toLowerCase());
		tmpState.CreateSlot = tmpCanCreate ? [ { PickerHash: this.options.PickerHash, Term: tmpTerm, TermAttr: escapeHTML(tmpTerm) } ] : [];

		tmpState.PickerHash = this.options.PickerHash;
		tmpState.IsMulti = tmpMulti;
		tmpState.Placeholder = this.options.Placeholder;
		tmpState.Searchable = !!this.options.Searchable;
		tmpState.ReadOnly = !!this.options.ReadOnly;

		// Clearable (AllowClear, single mode): the pinned "Any" dropdown row — checked when nothing is
		// selected ("Any" is the active state) — and the control's inline × while a value is selected.
		const tmpAllowClear = (!tmpMulti && this.options.AllowClear === true);
		const tmpClearableValue = tmpMulti ? undefined : this.getValue();
		const tmpClearableHasValue = !this._isEmptyValue(tmpClearableValue);
		tmpState.ClearOptionSlot = tmpAllowClear
			? [ { PickerHash: this.options.PickerHash, Label: this.options.ClearLabel || 'Any', Selected: !tmpClearableHasValue, NotSelected: tmpClearableHasValue } ]
			: [];
		tmpState.ClearSlot = (tmpAllowClear && tmpClearableHasValue) ? [ { PickerHash: this.options.PickerHash } ] : [];
		// Field decoration (opt-in): the ⚙ toggle rides in the search row; the chooser panel renders between
		// search and list. Both are single-element-array slots gated on the feature being enabled + eligible.
		const tmpDecorate = this._decorationEnabled();
		const tmpDecorateFields = (tmpDecorate && this._decorationOpen) ? this._decorationCandidateFields() : [];
		tmpState.DecoratePanelSlot = (tmpDecorate && this._decorationOpen)
			? [ {
				PickerHash: this.options.PickerHash,
				Fields: tmpDecorateFields.map((pField) => ({ PickerHash: this.options.PickerHash, Field: pField, FieldAttr: escapeHTML(pField), Checked: (this._decorationFields.indexOf(pField) >= 0) })),
				NoFields: (tmpDecorateFields.length === 0),
			} ]
			: [];
		// Single-element-array conditionals (render the search box / "Load more" only when applicable).
		tmpState.SearchSlot = this.options.Searchable
			? [ {
				PickerHash: this.options.PickerHash,
				DecorateSlot: tmpDecorate ? [ { PickerHash: this.options.PickerHash, HasFields: (this._decorationFields.length > 0), Open: !!this._decorationOpen } ] : [],
			} ]
			: [];
		tmpState.Loading = !!this._loading;
		tmpState.IsEmpty = (tmpState.Options.length === 0 && !this._loading && !tmpCanCreate);
		tmpState.EmptySlot = tmpState.IsEmpty ? [ { Label: escapeHTML(this._resolveEmptyLabel()) } ] : [];
		tmpState.HasMore = !!(tmpAsync && this._hasMore && !this._loading);
		tmpState.MoreSlot = tmpState.HasMore ? [ { PickerHash: this.options.PickerHash } ] : [];

		// Preview-card affordance (opt-in): a small ⓘ next to the selected value / chips that opens the
		// entity's registered preview card. Active only when the host registered a RecordSetCardManager
		// (soft dependency) that has a card for this picker's Entity, and the picker didn't opt out
		// (RecordCard !== false). Otherwise the picker renders exactly as before.
		const tmpCardManager = this.pict.providers.RecordSetCardManager;
		const tmpCardEntity = this.options.Entity;
		const tmpCardEnabled = !!(tmpCardManager && tmpCardEntity && (this.options.RecordCard !== false) && (typeof tmpCardManager.hasCard === 'function') && tmpCardManager.hasCard(tmpCardEntity));

		// The single/multi value-area is rendered via single-element-array slots; each slot's element
		// IS the Record for its sub-template, so it must carry everything that template references.
		if (tmpMulti)
		{
			// A sentinel inside the array is dropped from the chip list, so a Number-typed multi picker
			// marshalling in as a lone 0 shows the placeholder rather than a "0" chip.
			const tmpValues = this.getValue().filter((pVal) => !this._isEmptyValue(pVal));
			const tmpNoValue = (tmpValues.length === 0);
			const tmpChips = tmpValues.map((pVal) =>
			{
				const tmpRecord = this._lookupRecord(pVal);
				return Object.assign(
					{ PickerHash: this.options.PickerHash, ValueKey: String(pVal), ValueKeyAttr: escapeHTML(String(pVal)), Text: tmpRecord ? tmpRecord.Text : String(pVal), TextAttr: escapeHTML(tmpRecord ? tmpRecord.Text : String(pVal)), CardSlot: tmpCardEnabled ? [ { PickerHash: this.options.PickerHash, Entity: tmpCardEntity, EntityAttr: escapeHTML(tmpCardEntity), Value: String(pVal), ValueAttr: escapeHTML(String(pVal)) } ] : [] },
					this._tagSlots(this._recordTags(tmpRecord), tmpTagLast));
			});
			tmpState.SingleSlot = [];
			tmpState.MultiSlot = [ {
				PickerHash: this.options.PickerHash,
				Chips: tmpChips,
				PlaceholderSlot: tmpNoValue ? [ { Placeholder: this.options.Placeholder } ] : [],
			} ];
		}
		else
		{
			const tmpValue = this.getValue();
			const tmpHasValue = !this._isEmptyValue(tmpValue);
			const tmpSelected = tmpHasValue ? this._lookupRecord(tmpValue) : null;
			// No value → the placeholder, never a stale _selectedText left over from a prior selection.
			const tmpDisplayText = !tmpHasValue ? this.options.Placeholder
				: (tmpSelected ? tmpSelected.Text : (this._selectedText || String(tmpValue)));
			tmpState.SingleSlot = [ Object.assign({
				PickerHash: this.options.PickerHash,
				DisplayText: tmpDisplayText,
				DisplayTextAttr: escapeHTML(tmpDisplayText),
				NoValue: !tmpHasValue,
				CardSlot: (tmpCardEnabled && tmpHasValue) ? [ { PickerHash: this.options.PickerHash, Entity: tmpCardEntity, EntityAttr: escapeHTML(tmpCardEntity), Value: String(tmpValue), ValueAttr: escapeHTML(String(tmpValue)) } ] : [],
			}, this._tagSlots(this._recordTags(tmpSelected), tmpTagLast)) ];
			tmpState.MultiSlot = [];
		}
		return tmpState;
	}

	/**
	 * Find the {Value,Text} record for a value: the stored selection record (authoritative for chips /
	 * async), else a row in the current source (static Options or loaded results).
	 * @param {any} pValue
	 * @return {{Value:any, Text:string, Tag?:any}|null}
	 */
	_lookupRecord(pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '') { return null; }
		const tmpStored = this._selectedRecords[String(pValue)];
		if (tmpStored) { return tmpStored; }
		return this._sourceRows().find((pOption) => String(pOption.Value) === String(pValue)) || null;
	}

	/**
	 * Load a page of results from the async DataProvider, accumulating (append) or replacing the list.
	 * @param {number} pPage - zero-based page index.
	 * @param {boolean} pAppend - true to append (Load more), false to replace (new search / first open).
	 */
	_loadPage(pPage, pAppend)
	{
		if (!this._isAsync()) { return; }
		// Minimum-search-length gate: below the threshold, don't hit the server. First page only
		// (browse-on-open + new search); "Load more" always already has an at-length term.
		const tmpMinLength = this.options.MinimumSearchLength || 0;
		if (tmpMinLength > 0 && !pAppend && pPage === 0 && (this._search || '').trim().length < tmpMinLength)
		{
			this._loadedResults = [];
			this._hasMore = false;
			this._page = 0;
			this._loaded = true;
			this._loading = false;
			this._renderList();
			return;
		}
		this._loading = true;
		this._renderList();
		const tmpSearchAtRequest = this._search;
		Promise.resolve()
			.then(() => this.options.DataProvider(this._search, pPage))
			.then((pResult) =>
			{
				// Drop a stale first-page response if the search term changed while it was in flight.
				if (!pAppend && pPage === 0 && tmpSearchAtRequest !== this._search) { return; }
				const tmpResults = (pResult && Array.isArray(pResult.results)) ? pResult.results : [];
				this._loadedResults = pAppend ? this._loadedResults.concat(tmpResults) : tmpResults;
				this._hasMore = !!(pResult && pResult.hasMore);
				this._page = pPage;
				this._loaded = true;
				this._loading = false;
				this._renderList();
			})
			.catch((pError) =>
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] DataProvider error.`, pError);
				this._loading = false;
				this._renderList();
			});
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		// A closed picker's full render paints an empty search box, and the view outlives a mount (the same
		// PickerHash hands this instance back), so a term kept from before would filter unseen.
		if (!this._open)
		{
			this._search = '';
		}
		this._buildState();
		return super.onBeforeRender(pRenderable);
	}

	/** Toggle the dropdown open/closed. */
	toggle(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		return this._open ? this.close() : this.open();
	}

	/** Keyboard on the control: open the dropdown on Enter / Space / ArrowDown. */
	onControlKey(pEvent)
	{
		if (pEvent.key === 'Enter' || pEvent.key === ' ' || pEvent.key === 'ArrowDown')
		{
			pEvent.preventDefault();
			if (!this._open) { this.open(); }
		}
		else if (pEvent.key === 'Escape')
		{
			this.close();
		}
	}

	/** Open the dropdown and focus the search box. With the opt-in SingleActivePicker option, closes
	 *  any open sibling picker first — one active dropdown per page. */
	open()
	{
		this._claimActivePicker();
		this._open = true;
		this._highlight = -1;
		this._paintOpen();
		this._applyAnchorMode();
		if (this._isAsync() && !this._loaded) { this._loadPage(0, false); }
		const tmpSearch = /** @type {HTMLInputElement} */ (document.getElementById(`PPS_Search_${this.options.PickerHash}`));
		if (tmpSearch) { tmpSearch.focus(); tmpSearch.select(); }
	}

	/** Take the provider's single-active slot, closing whichever sibling holds it. Opt-in only (an off
	 *  picker neither claims nor is closed). The slot holds a hash on the provider, so two pict instances
	 *  sharing this module can't cross-close. */
	_claimActivePicker()
	{
		const tmpProvider = this.options.PickerProvider;
		if (!this.options.SingleActivePicker || !tmpProvider) { return; }
		const tmpOpenHash = tmpProvider.currentOpenPickerHash;
		if (tmpOpenHash && tmpOpenHash !== this.options.PickerHash)
		{
			const tmpOpenView = this.pict.views[tmpOpenHash];
			if (tmpOpenView && typeof tmpOpenView.close === 'function') { tmpOpenView.close(); }
		}
		tmpProvider.currentOpenPickerHash = this.options.PickerHash;
	}

	/*
	 * Dropdown anchoring & render states
	 * ----------------------------------
	 * Anchoring (picked per open by _applyAnchorMode -> _shouldPortal):
	 *   CSS      : .pps-pop is absolute inside the widget and rides page scroll for free. Default.
	 *   Portaled : moved to <body> in document coords when a clipping ancestor (overflow != visible)
	 *              would actually cut it. Still absolute, so it rides scroll too; carries the control's
	 *              --theme-color-* across since it left any scoped container.
	 * Open  : _open -> pps-open on the root, pps-pop-open on the pop (a portaled pop is outside the
	 *         root's .pps-open rule, so it needs its own class to show).
	 * Render: full render() rebuilds the widget; setValue uses the targeted _reflectValue (value area +
	 *         list only) unless _shapeSignature() shows something outside them changed.
	 * _popElement finds the pop in either place; _markClosed is the single close funnel.
	 */

	/** The pop wherever it lives (in-widget or portaled). By position not id: a re-render can briefly
	 *  leave two sharing the id, and the in-widget copy is the live one. @return {HTMLElement|null} */
	_popElement()
	{
		if (typeof document === 'undefined') { return null; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpInWidget = tmpRoot ? /** @type {HTMLElement} */ (tmpRoot.querySelector('.pps-pop')) : null;
		if (tmpInWidget) { return tmpInWidget; }
		return /** @type {HTMLElement} */ (document.querySelector(`body > [id="PPS_Pop_${this.options.PickerHash}"]`));
	}

	/** Pick this open's anchoring (see states above): portal when _shouldPortal finds a clipping ancestor
	 *  that would cut the panel, else CSS. Judged from the control, which never moves — a portaled panel
	 *  has no clipping ancestors, so testing it would flip-flop. */
	_applyAnchorMode()
	{
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpPop = this._popElement();
		if (!tmpPop) { return; }
		const tmpControl = tmpRoot ? /** @type {HTMLElement} */ (tmpRoot.querySelector('.pps-control')) : null;
		this._portaled = !!tmpControl && this._shouldPortal(tmpControl);
		if (this._portaled) { this._portalPop(tmpPop); }
		else { this._restorePop(tmpPop); }
		// A portaled pop is hidden until pps-pop-open is set (it's outside the root's .pps-open rule).
		tmpPop.classList.toggle('pps-pop-open', !!this._open);
	}

	/** Move the panel to <body> and place it against the control in document coords (viewport rect +
	 *  scroll), flipping above when room below is short. Width is pinned since it no longer inherits the
	 *  widget's. @param {HTMLElement} pPop */
	_portalPop(pPop)
	{
		if (typeof document === 'undefined') { return; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpControl = tmpRoot ? tmpRoot.querySelector('.pps-control') : null;
		if (!tmpControl) { return; }
		// Sweep any stale portaled copy a prior re-render left on <body> (same id) before adopting this one.
		document.querySelectorAll(`body > [id="PPS_Pop_${this.options.PickerHash}"]`)
			.forEach((pNode) => { if (pNode !== pPop) { pNode.remove(); } });
		if (pPop.parentElement !== document.body) { document.body.appendChild(pPop); }
		pPop.classList.add('pps-pop-portal');

		// Carry the resolved --theme-color-* across: on <body> the panel has left any scoped container, so
		// without this it would fall back to the hex defaults. Skip empty reads — pinning "" would defeat
		// the var(--token, #hex) fallback for tokens the host never defined.
		if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function')
		{
			const tmpComputed = window.getComputedStyle(tmpControl);
			_THEME_TOKENS.forEach((pToken) =>
			{
				const tmpValue = tmpComputed.getPropertyValue(pToken);
				if (tmpValue && tmpValue.trim() !== '') { pPop.style.setProperty(pToken, tmpValue.trim()); }
			});
		}

		const tmpRect = tmpControl.getBoundingClientRect();
		const tmpGap = 5;
		const tmpMargin = 8;
		const tmpIdeal = 360;
		const tmpWidth = Math.max(200, Math.round(tmpRect.width));
		const tmpSpaceBelow = window.innerHeight - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		const tmpBelow = (tmpSpaceBelow >= tmpIdeal) || (tmpSpaceBelow >= tmpSpaceAbove);
		const tmpPanel = /** @type {HTMLElement} */ (pPop.querySelector('.pps-panel'));

		pPop.style.width = `${tmpWidth}px`;
		pPop.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.left, window.innerWidth - tmpWidth - tmpMargin)) + window.scrollX)}px`;
		pPop.style.bottom = 'auto';
		// Document coords (viewport rect + scroll): absolute against <body>, so one placement is enough.
		pPop.style.top = tmpBelow
			? `${Math.round(tmpRect.bottom + tmpGap + window.scrollY)}px`
			: `${Math.round(tmpRect.top - tmpGap + window.scrollY)}px`;
		if (!tmpBelow) { pPop.style.transform = 'translateY(-100%)'; }
		else { pPop.style.transform = ''; }
		if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(0, Math.round(Math.min(tmpBelow ? tmpSpaceBelow : tmpSpaceAbove, tmpIdeal)))}px`; }
	}

	/** Re-home a portaled panel and drop everything the portal wrote. Doubles as the orphan sweeper: if a
	 *  re-render already put a fresh panel in the widget, the portaled one is stale and gets discarded.
	 *  @param {HTMLElement} pPop */
	_restorePop(pPop)
	{
		if (typeof document === 'undefined' || !pPop) { return; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		if (pPop.parentElement === document.body)
		{
			if (!tmpRoot) { pPop.remove(); return; }
			// A re-render already put a fresh panel in the widget — this portaled one is a leftover.
			if (tmpRoot.querySelector('.pps-pop') && tmpRoot.querySelector('.pps-pop') !== pPop) { pPop.remove(); return; }
			tmpRoot.appendChild(pPop);
		}
		pPop.classList.remove('pps-pop-portal');
		// Clear the inline offsets, or they'd override the stylesheet and strand the panel.
		pPop.style.top = '';
		pPop.style.left = '';
		pPop.style.right = '';
		pPop.style.bottom = '';
		pPop.style.width = '';
		pPop.style.transform = '';
		// Drop the copied tokens so back in the widget it inherits them live again.
		_THEME_TOKENS.forEach((pToken) => pPop.style.removeProperty(pToken));
		const tmpPanel = /** @type {HTMLElement} */ (pPop.querySelector('.pps-panel'));
		if (tmpPanel) { tmpPanel.style.maxHeight = ''; }
	}

	/** Portal when ANY clipping ancestor would actually cut the panel (_clipBites) — an overflow ancestor
	 *  alone isn't enough, but a roomy inner clipper doesn't excuse a tighter one further out.
	 *  @param {HTMLElement} pControl @return {boolean} */
	_shouldPortal(pControl)
	{
		// Walk every clipper outward, not just the nearest: _clippingAncestor starts from parentElement,
		// so re-feeding it the clipper it returned continues the walk.
		let tmpClipper = this._clippingAncestor(pControl);
		while (tmpClipper)
		{
			if (this._clipBites(pControl, tmpClipper)) { return true; }
			tmpClipper = this._clippingAncestor(tmpClipper);
		}
		return false;
	}

	/** Nearest ancestor (up to, not including, body) with an overflow clip on any axis, or null. Stops at
	 *  body because the document's own scroll is what the absolute anchoring rides on, not a clip.
	 *  @param {HTMLElement} pElement @return {HTMLElement|null} */
	_clippingAncestor(pElement)
	{
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') { return null; }
		let tmpNode = pElement ? pElement.parentElement : null;
		while (tmpNode && tmpNode.nodeType === 1 && tmpNode !== document.body)
		{
			const tmpStyle = window.getComputedStyle(tmpNode);
			if (tmpStyle && [ tmpStyle.overflow, tmpStyle.overflowX, tmpStyle.overflowY ].some((pValue) => pValue && pValue !== 'visible'))
			{
				return /** @type {HTMLElement} */ (tmpNode);
			}
			tmpNode = tmpNode.parentElement;
		}
		return null;
	}

	/** True when the control has any overflow-clipping ancestor. Thin boolean over _clippingAncestor;
	 *  the anchor decision uses _shouldPortal, which also weighs whether the clip reaches the panel.
	 *  @param {HTMLElement} pElement @return {boolean} */
	_hasClippingAncestor(pElement) { return !!this._clippingAncestor(pElement); }

	/** Would the clipper cut the panel if it opened in place? The CSS path always opens downward and never
	 *  flips, so project that worst-case box (control bottom + gap, up to max height) and test whether any
	 *  edge falls outside the clipper. 1px slack avoids a needless portal on a flush edge.
	 *  @param {HTMLElement} pControl @param {HTMLElement} pClipper @return {boolean} */
	_clipBites(pControl, pClipper)
	{
		if (!pControl || !pClipper || typeof pControl.getBoundingClientRect !== 'function'
			|| typeof pClipper.getBoundingClientRect !== 'function') { return true; }
		const tmpControlRect = pControl.getBoundingClientRect();
		const tmpClipRect = pClipper.getBoundingClientRect();
		const tmpGap = 5;
		const tmpIdeal = 360;
		const tmpSlack = 1;
		const tmpPanelTop = tmpControlRect.bottom + tmpGap;
		const tmpPanelBottom = tmpPanelTop + tmpIdeal;
		const tmpWidth = Math.max(200, tmpControlRect.width);
		const tmpPanelLeft = tmpControlRect.left;
		const tmpPanelRight = tmpControlRect.left + tmpWidth;
		return (tmpPanelBottom > tmpClipRect.bottom + tmpSlack)
			|| (tmpPanelTop < tmpClipRect.top - tmpSlack)
			|| (tmpPanelLeft < tmpClipRect.left - tmpSlack)
			|| (tmpPanelRight > tmpClipRect.right + tmpSlack);
	}

	/** The single close funnel (close, single-mode select, clearValue, createFromSearch): clears open
	 *  state, the provider's active-picker slot, and the results cache so nothing leaks a stale reference. */
	_markClosed()
	{
		this._open = false;
		this._highlight = -1;
		this._decorationOpen = false;
		const tmpProvider = this.options.PickerProvider;
		if (tmpProvider && tmpProvider.currentOpenPickerHash === this.options.PickerHash) { tmpProvider.currentOpenPickerHash = false; }
		// Bring a portaled panel home, so a closed picker never leaves a stray on <body>.
		if (this._portaled) { this._restorePop(this._popElement()); this._portaled = false; }
		// Drop the accumulated pages so the next open re-queries — BaseFilter is resolved per query
		// because the host's scope shifts underneath the picker (a "Show All" toggle, a dependent pick),
		// so caching across a close would serve the old scope. Matches the legacy select2 re-query.
		this._loaded = false;
		this._loadedResults = [];
		this._page = 0;
		this._hasMore = false;
		// Back-off state spans only page 0 -> "load more" in one session, so release it here too.
		if (tmpProvider && tmpProvider.backOffState) { delete tmpProvider.backOffState[this.options.PickerHash]; }
	}


	/** Async mode: load + append the next page of results. */
	loadMore()
	{
		if (this._isAsync() && this._hasMore && !this._loading)
		{
			this._loadPage(this._page + 1, true);
		}
	}

	/** Close the dropdown. */
	close()
	{
		this._markClosed();
		this._paintOpen();
	}

	/**
	 * Close from the transparent backdrop, and pass the click through to whatever
	 * the user actually aimed at.
	 *
	 * The backdrop is a full-viewport layer, so while a picker is open EVERY click
	 * elsewhere on the page lands on it and is consumed closing the dropdown. The
	 * button underneath never sees it, and the interaction reads as "the first
	 * click did nothing" — measured on a filter bar, the Apply handler recorded
	 * zero calls on the first click and one on the second. A dropdown dismissing
	 * itself should not also cost the click that dismissed it.
	 *
	 * The backdrop is display:none the moment the widget is painted closed, so
	 * elementFromPoint then returns the real target rather than the backdrop.
	 *
	 * @param {MouseEvent} pEvent - The backdrop click.
	 */
	closeFromBackdrop(pEvent)
	{
		this.close();
		if (!pEvent || (typeof document === 'undefined') || (typeof document.elementFromPoint !== 'function'))
		{
			return;
		}
		const tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		// Nothing meaningful under the cursor (or the backdrop somehow survived) —
		// closing was the whole intent.
		if (!tmpTarget || tmpTarget === document.body || tmpTarget === document.documentElement
			|| (tmpTarget.classList && tmpTarget.classList.contains('pps-backdrop')))
		{
			return;
		}
		if (typeof tmpTarget.click === 'function') { tmpTarget.click(); }
	}

	/** Opt-in teardown for a host that drops the view (pict-view has no destroy hook). _markClosed already
	 *  releases the single-active slot, re-homes/removes a portaled panel, and clears the back-off entry;
	 *  the un-destroyed case is harmless since a stray portaled pop stays hidden without pps-pop-open. */
	destroy()
	{
		this._markClosed();
		this._paintOpen();
		// Belt-and-suspenders: if the widget root was detached mid-teardown, take any stray pop with us.
		if (typeof document !== 'undefined')
		{
			const tmpStray = document.querySelector(`body > [id="PPS_Pop_${this.options.PickerHash}"]`);
			if (tmpStray) { tmpStray.remove(); }
		}
	}

	/** Reflect open/closed on the root (pps-open) and on the pop (pps-pop-open) — a portaled pop is outside
	 *  the root's rule, so it needs the class directly, which also keeps a stray one hidden. */
	_paintOpen()
	{
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		if (tmpRoot) { tmpRoot.classList.toggle('pps-open', !!this._open); }
		const tmpPop = this._popElement();
		if (tmpPop) { tmpPop.classList.toggle('pps-pop-open', !!this._open); }
	}

	/** Re-render only the option list (keeps the search input + its focus intact). */
	_renderList()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-List', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_List_${this.options.PickerHash}`, tmpHTML);
	}

	/** Re-render only the control's value area (the value span or the chips) — used in multi mode so
	 *  toggling a selection updates the chips without tearing down the open dropdown + search box. */
	_renderValue()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-ValueArea', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_Value_${this.options.PickerHash}`, tmpHTML);
	}

	/** @param {string} pValue - Filter the option list by this search term. */
	search(pValue)
	{
		this._search = pValue || '';
		this._highlight = -1;
		if (this._isAsync())
		{
			// Debounce server searches; reset to page 0.
			if (this._searchTimer) { clearTimeout(this._searchTimer); }
			this._searchTimer = setTimeout(() => { this._loadPage(0, false); }, 220);
		}
		else
		{
			this._renderList();
		}
	}

	/** Keyboard navigation within the search box: arrows highlight, Enter selects, Escape closes. */
	onSearchKey(pEvent)
	{
		const tmpOptions = this._state().Options || [];
		if (pEvent.key === 'ArrowDown')
		{
			pEvent.preventDefault();
			this._highlight = Math.min(this._highlight + 1, tmpOptions.length - 1);
			this._renderList();
		}
		else if (pEvent.key === 'ArrowUp')
		{
			pEvent.preventDefault();
			this._highlight = Math.max(this._highlight - 1, 0);
			this._renderList();
		}
		else if (pEvent.key === 'Enter')
		{
			pEvent.preventDefault();
			if (this._highlight >= 0 && tmpOptions[this._highlight])
			{
				this.select(tmpOptions[this._highlight].ValueKey);
			}
			else if ((this._state().CreateSlot || []).length > 0)
			{
				this.createFromSearch();
			}
		}
		else if (pEvent.key === 'Escape')
		{
			pEvent.preventDefault();
			this.close();
		}
	}

	/**
	 * Read a `data-` attribute off a clicked element. The option / chip / card / decorate handlers carry
	 * the value they operate on in a data attribute instead of inlining it into the onclick string, so a
	 * value containing a quote (e.g. `1"`) can never break the attribute or the handler; the browser has
	 * already decoded the attribute back to the raw value by the time we read it here.
	 * @param {any} pElement - the clicked DOM element (`this` inside the inline handler).
	 * @param {string} pAttribute - the data attribute to read.
	 * @return {string|null}
	 */
	_readElementData(pElement, pAttribute)
	{
		return (pElement && typeof pElement.getAttribute === 'function') ? pElement.getAttribute(pAttribute) : null;
	}

	/** Option-row click shim: select the value carried in `data-pps-valuekey`. @param {any} pElement */
	selectFromElement(pElement)
	{
		const tmpValueKey = this._readElementData(pElement, 'data-pps-valuekey');
		if (tmpValueKey !== null) { this.select(tmpValueKey); }
	}

	/** Chip-× click shim: remove the value carried in `data-pps-valuekey`. @param {any} pElement */
	removeChipFromElement(pElement)
	{
		const tmpValueKey = this._readElementData(pElement, 'data-pps-valuekey');
		if (tmpValueKey !== null) { this.removeChip(tmpValueKey); }
	}

	/** Preview-card ⓘ click shim: open the card for the entity/value carried in data attributes. @param {any} pElement */
	openCardFromElement(pElement)
	{
		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpManager || typeof tmpManager.openCard !== 'function') { return; }
		tmpManager.openCard(this._readElementData(pElement, 'data-pps-entity'), this._readElementData(pElement, 'data-pps-value'), pElement);
	}

	/** Field-decoration checkbox click shim: toggle the field carried in `data-pps-field`. @param {any} pElement */
	toggleDecorateFieldFromElement(pElement)
	{
		const tmpField = this._readElementData(pElement, 'data-pps-field');
		if (tmpField !== null) { this.toggleDecorateField(tmpField); }
	}

	/**
	 * Select an option. Single mode: set the value + close. Multi mode: toggle the value in/out of the
	 * selection, keep the dropdown open, and refocus the search box for rapid multi-pick.
	 * @param {string} pValueKey - String(Value) of the option.
	 */
	select(pValueKey)
	{
		const tmpOption = this._sourceRows().find((pOption) => String(pOption.Value) === String(pValueKey));
		if (!tmpOption) { return; }

		if (!this._isMulti())
		{
			this._selectedText = tmpOption.Text;
			this._selectedRecords[String(tmpOption.Value)] = { Value: tmpOption.Value, Text: tmpOption.Text, Tag: tmpOption.Tag, Tags: tmpOption.Tags };
			this._setValue(tmpOption.Value);
			this._search = '';
			this._markClosed();
			this.render();
			if (typeof this.options.OnChange === 'function')
			{
				this.options.OnChange(tmpOption.Value, tmpOption);
			}
			return;
		}

		// Multi: toggle membership.
		const tmpValues = this.getValue().slice();
		const tmpIndex = tmpValues.findIndex((pVal) => String(pVal) === String(pValueKey));
		if (tmpIndex >= 0)
		{
			tmpValues.splice(tmpIndex, 1);
			delete this._selectedRecords[String(pValueKey)];
		}
		else
		{
			tmpValues.push(tmpOption.Value);
			this._selectedRecords[String(pValueKey)] = { Value: tmpOption.Value, Text: tmpOption.Text, Tag: tmpOption.Tag, Tags: tmpOption.Tags };
		}
		this._setValue(tmpValues);
		this._renderValue();
		this._renderList();
		if (typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(tmpValues, this.getSelectedRecords());
		}
		// Focus AFTER OnChange: a host that re-marshals inside its handler re-renders the widget and would
		// blow away a focus set before it. onAfterRender also restores focus while open, covering the
		// re-render that does happen; this covers the common case where it does not.
		const tmpSearch = document.getElementById(`PPS_Search_${this.options.PickerHash}`);
		if (tmpSearch) { tmpSearch.focus(); }
	}

	/**
	 * Clearable (AllowClear, single mode): empty the selection — from the control's inline × or the
	 * pinned "Any" dropdown row. Closing mirrors select() (clearing IS a selection: "Any"), and
	 * OnChange(null, null) fires only when there was a value to clear, so clicking "Any" while
	 * already empty just closes the dropdown.
	 */
	clearValue()
	{
		if (this._isMulti()) { return; }
		const tmpValue = this.getValue();
		const tmpHadValue = !this._isEmptyValue(tmpValue);
		this._selectedText = null;
		this._setValue(null);
		this._search = '';
		this._markClosed();
		this.render();
		if (tmpHadValue && typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(null, null);
		}
	}

	/** @return {Array<{Value:any, Text:string}>} The full record list for the current multi selection. */
	getSelectedRecords()
	{
		return this.getValue().map((pVal) => this._selectedRecords[String(pVal)] || { Value: pVal, Text: String(pVal) });
	}

	/**
	 * Creatable: build a new option from the current search term via OnCreate, then select it (single:
	 * set + close; multi: add a chip). The created record is inserted into the source list so it shows
	 * as a normal, checked option.
	 */
	createFromSearch()
	{
		const tmpTerm = (this._search || '').trim();
		if (!tmpTerm || typeof this.options.OnCreate !== 'function') { return; }
		Promise.resolve(this.options.OnCreate(tmpTerm)).then((pRecord) =>
		{
			if (!pRecord || pRecord.Value === undefined || pRecord.Value === null) { return; }
			// Make the new record part of the source so the list can render it like any other option.
			if (this._isAsync())
			{
				if (!this._loadedResults.some((pRow) => String(pRow.Value) === String(pRecord.Value))) { this._loadedResults.unshift(pRecord); }
			}
			else if (Array.isArray(this.options.Options) && !this.options.Options.some((pRow) => String(pRow.Value) === String(pRecord.Value)))
			{
				this.options.Options.unshift(pRecord);
			}
			this._selectedRecords[String(pRecord.Value)] = { Value: pRecord.Value, Text: pRecord.Text, Tag: pRecord.Tag };

			if (this._isMulti())
			{
				const tmpValues = this.getValue().slice();
				if (!tmpValues.some((pVal) => String(pVal) === String(pRecord.Value))) { tmpValues.push(pRecord.Value); }
				this._setValue(tmpValues);
				this._search = '';
				this._highlight = -1;
				this._renderValue();
				this._renderList();
				const tmpSearchBox = /** @type {HTMLInputElement} */ (document.getElementById(`PPS_Search_${this.options.PickerHash}`));
				if (tmpSearchBox) { tmpSearchBox.value = ''; tmpSearchBox.focus(); }
				if (typeof this.options.OnChange === 'function') { this.options.OnChange(tmpValues, this.getSelectedRecords()); }
			}
			else
			{
				this._selectedText = pRecord.Text;
				this._setValue(pRecord.Value);
				this._search = '';
				this._markClosed();
				this.render();
				if (typeof this.options.OnChange === 'function') { this.options.OnChange(pRecord.Value, pRecord); }
			}
		}).catch((pError) =>
		{
			this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] OnCreate error.`, pError);
		});
	}

	/** Multi mode: remove a selected value (chip ×). Keeps the dropdown state as-is. */
	removeChip(pValueKey)
	{
		const tmpValues = this.getValue().filter((pVal) => String(pVal) !== String(pValueKey));
		delete this._selectedRecords[String(pValueKey)];
		this._setValue(tmpValues);
		this._renderValue();
		if (this._open) { this._renderList(); }
		if (typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(tmpValues, this.getSelectedRecords());
		}
	}

	/** @param {import('pict-view').Renderable} pRenderable */
	onAfterRender(pRenderable)
	{
		if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		// Stamp the painted shape so a later setValue knows if a targeted refresh still fits (_reflectValue).
		this._renderedShape = this._shapeSignature();
		this._paintOpen();
		// A render while open rebuilds a fresh in-widget pop and orphans any portaled one; re-anchoring
		// sweeps the orphan and re-portals, then we restore the search focus the render dropped.
		if (this._open)
		{
			this._applyAnchorMode();
			const tmpSearch = document.getElementById(`PPS_Search_${this.options.PickerHash}`);
			if (tmpSearch && document.activeElement !== tmpSearch) { tmpSearch.focus(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PictViewPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":693}],609:[function(require,module,exports){
// The container for all the Pict-Section-Form related code.

// The main dynamic view class
module.exports = require('./services/RecordsSet-MetaController.js');
//module.exports.default_configuration = require('./views/Pict-View-DynamicForm-DefaultConfiguration.json');

// The application container
module.exports.PictRecordSetApplication = require('./application/Pict-Application-RecordSet.js');

// Export the providers
module.exports.RecordSetProviderBase = require('./providers/RecordSet-RecordProvider-Base.js');
module.exports.RecordSetProviderMeadowEndpoints = require('./providers/RecordSet-RecordProvider-MeadowEndpoints.js');
module.exports.ColumnDataProvider = require('./providers/Column-Data-Provider.js');
module.exports.AssociationManager = require('./providers/RecordSet-AssociationManager.js');
module.exports.DependentManager = require('./providers/RecordSet-DependentManager.js');
module.exports.CardManager = require('./providers/RecordSet-CardManager.js');

// Joined-entity association views (embeddable read-tab editor + bulk associate screen)
module.exports.AssociationEditorView = require('./views/associate/RecordSet-AssociationEditor.js');
module.exports.AssociateBulkView = require('./views/associate/RecordSet-AssociateBulk.js');
module.exports.AssociateMatrixView = require('./views/associate/RecordSet-AssociateMatrix.js');
module.exports.AssociateUnlinkView = require('./views/associate/RecordSet-AssociateUnlink.js');

// Bulk delete screen (batch delete, with optional advanced reassociation of relationships)
module.exports.BulkDeleteView = require('./views/delete/RecordSet-BulkDelete.js');

},{"./application/Pict-Application-RecordSet.js":610,"./providers/Column-Data-Provider.js":611,"./providers/RecordSet-AssociationManager.js":613,"./providers/RecordSet-CardManager.js":614,"./providers/RecordSet-DependentManager.js":615,"./providers/RecordSet-RecordProvider-Base.js":618,"./providers/RecordSet-RecordProvider-MeadowEndpoints.js":619,"./services/RecordsSet-MetaController.js":621,"./views/associate/RecordSet-AssociateBulk.js":628,"./views/associate/RecordSet-AssociateMatrix.js":629,"./views/associate/RecordSet-AssociateUnlink.js":630,"./views/associate/RecordSet-AssociationEditor.js":631,"./views/delete/RecordSet-BulkDelete.js":641}],610:[function(require,module,exports){
const libPictApplication = require('pict-application');
const libPictSectionForm = require('pict-section-form');

const libPictSectionRecordSet = require('../Pict-Section-RecordSet.js');
const libDynamicSolver = require('../providers/RecordSet-DynamicRecordsetSolver.js');
const libFilterDataProvider = require('../providers/Filter-Data-Provider.js');
const libFilterPersistenceView = require('../views/Filter-PersistenceView.js');
const libPictDynamicFormDependencyManager = require('pict-section-form').PictDynamicFormDependencyManager;

/**
 * Represents a PictSectionRecordSetApplication.
 *
 * This is the automagic controller for a dynamic record set application.
 *
 * @class
 * @extends libPictApplication
 */
class PictSectionRecordSetApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & import('fable')} */
		this.pict;
		// Add the pict recordset meta controller service
		this.pict.addServiceType('PictSectionRecordSet', libPictSectionRecordSet);
		//FIXME: this is probably wrong, but needed for now?
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);

		this.pict.addView('PictFormMetacontroller', {}, libPictSectionForm.PictFormMetacontroller);

		this.fable.addProviderSingleton('DynamicRecordsetSolver', libDynamicSolver.default_configuration, libDynamicSolver);

		// for filter data/persistence management
		this.fable.addProviderSingleton('FilterDataProvider', libFilterDataProvider.default_configuration, libFilterDataProvider);
		this.pict.addView('FilterPersistenceView', libFilterPersistenceView.default_configuration, libFilterPersistenceView);

		// add the dependencies for dynamic controls
		this.fable.addAndInstantiateSingletonService('PictDynamicFormDependencyManager', libPictDynamicFormDependencyManager.default_configuration, libPictDynamicFormDependencyManager);
	}

	onInitialize()
	{
		// Add the PictSectionRecordSet service
		this.pict.instantiateServiceProvider('PictSectionRecordSet', this.options);
		// Initialize the views for the foundation metacontroller service
		this.pict.PictSectionRecordSet.initialize();

		// Initialize the parent class
		return super.onInitialize();
	}

	onAfterInitialize()
	{
		if (this.pict.CSSMap)
		{
			this.pict.CSSMap.injectCSS();
		}
		// Now add the routes
		this.pict.providers.RecordSetRouter.addRoutes(this.fable.providers.RecordSetRouter.pictRouter);

		return super.onAfterInitialize();
	}
};

module.exports = PictSectionRecordSetApplication

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"Name": "A Simple Pict RecordSet Application",
	"Hash": "PictRecordSetApplication",

	//"MainViewportViewIdentifier": "PictRecordSetPrimaryView",

	"pict_configuration":
		{
			"Product": "DefaultPictRecordSetApplication",
		}
});

},{"../Pict-Section-RecordSet.js":609,"../providers/Filter-Data-Provider.js":612,"../providers/RecordSet-DynamicRecordsetSolver.js":616,"../views/Filter-PersistenceView.js":625,"pict-application":476,"pict-section-form":497}],611:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'ColumnDataProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/** Terminology for Column Data Provider (to avoid confusion):
 * A "Record Set" is a collection of records rendered as a list with columns.
 * A "Column Visibility Override" is a per-column user choice (true = show, false = hide)
 *   that overrides the column's default visibility (visible unless DefaultHidden).
 * Columns with no override entry render at their default visibility.

 * Behavior Summary:
 * - Save the per-recordset override map to LocalStorage under a key derived from
 *   Record Set and View Context.
 * - Mirror the override map into pict.Bundle._ActiveColumnState[RecordSet] so reads
 *   are synchronous and consistent within a session (the Meadow record provider reads
 *   this at fetch time to widen Lite projections before the list view composes columns).
 * - Clear both on "Reset to defaults".

 * Storage Key Structure:
 * - Column_Meta_{RecordSet}_{ViewContext} : stores the Column Meta JSON.

 * Object Shape for Column Meta:
 * {
 *   RecordSet: string, (auto-filled on save)
 *   ViewContext: string, (auto-filled on save; 'List' for the list view)
 *   Overrides: { [ColumnKey: string]: boolean },
 *   LastModifiedDate: string (ISO date) (auto-filled on save)
 * }

 * Host override contract:
 * - To persist column choices somewhere other than LocalStorage (e.g. a per-user
 *   server-side preference), register your own provider AS 'ColumnDataProvider'
 *   BEFORE PictSectionRecordSet.initialize() runs — the section only registers this
 *   one when no provider with that hash exists yet. Load remote prefs at app start
 *   and seed them through setColumnVisibilityOverride (or write the Bundle mirror
 *   directly); the read methods here must stay synchronous.
*/

class ColumnDataProvider extends libPictProvider
{
	/**
	 * @param {import('pict')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - The options for the provider
	 * @param {string} [pServiceHash] - The service hash for the provider
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// This allows unit tests to run
		this.storageProvider = this;
		this.keyCache = {};
		if ((typeof(window) === 'object') && (typeof(window.localStorage) === 'object'))
		{
			this.storageProvider = window.localStorage;
		}
	}

	/**
	 * Resolve the LocalStorage key for a record set's column visibility overrides.
	 *
	 * @param {string} pRecordSet - The record set the overrides belong to
	 * @param {string} [pViewContext] - The view context (defaults to 'List')
	 * @return {string} The storage key for the column meta record.
	 */
	getColumnStorageKey(pRecordSet, pViewContext)
	{
		return `Column_Meta_${pRecordSet}_${pViewContext || 'List'}`;
	}

	/**
	 * Get the column visibility override map for a record set.
	 *
	 * Bundle-first: the session mirror in pict.Bundle._ActiveColumnState wins; on a
	 * miss the stored meta is read and seeded into the Bundle so every later read
	 * (including the Meadow provider's fetch-time read) is synchronous and consistent.
	 *
	 * @param {string} pRecordSet - The record set to get overrides for
	 * @param {string} [pViewContext] - The view context (defaults to 'List')
	 * @return {Record<string, boolean>} The override map (empty object when none).
	 */
	getColumnVisibilityOverrides(pRecordSet, pViewContext)
	{
		if (!pRecordSet)
		{
			return {};
		}
		const tmpActiveColumnState = this.pict.Bundle._ActiveColumnState;
		if (tmpActiveColumnState && tmpActiveColumnState[pRecordSet] && tmpActiveColumnState[pRecordSet].Overrides)
		{
			return tmpActiveColumnState[pRecordSet].Overrides;
		}
		/** @type {Record<string, boolean>} */
		let tmpOverrides = {};
		const tmpColumnMetaJSON = this.storageProvider.getItem(this.getColumnStorageKey(pRecordSet, pViewContext));
		if (tmpColumnMetaJSON)
		{
			try
			{
				const tmpColumnMeta = JSON.parse(tmpColumnMetaJSON);
				if (tmpColumnMeta && typeof(tmpColumnMeta.Overrides) === 'object' && tmpColumnMeta.Overrides !== null)
				{
					tmpOverrides = tmpColumnMeta.Overrides;
				}
			}
			catch (pError)
			{
				this.pict.log.warn(`ColumnDataProvider: could not parse stored column meta for [${pRecordSet}]: ${pError.message}`);
			}
		}
		this._seedBundleColumnState(pRecordSet, tmpOverrides);
		return tmpOverrides;
	}

	/**
	 * Set (and persist) a single column visibility override for a record set.
	 *
	 * @param {string} pRecordSet - The record set the column belongs to
	 * @param {string} pViewContext - The view context ('List' for the list view; falsy defaults to 'List')
	 * @param {string} pKey - The column key
	 * @param {boolean} pVisible - Whether the column should be visible
	 * @return {Record<string, boolean>} The updated override map.
	 */
	setColumnVisibilityOverride(pRecordSet, pViewContext, pKey, pVisible)
	{
		const tmpOverrides = this.getColumnVisibilityOverrides(pRecordSet, pViewContext);
		tmpOverrides[pKey] = (pVisible === true);
		this._seedBundleColumnState(pRecordSet, tmpOverrides);
		const tmpColumnMeta =
		{
			RecordSet: pRecordSet,
			ViewContext: pViewContext || 'List',
			Overrides: tmpOverrides,
			LastModifiedDate: new Date().toISOString(),
		};
		this.storageProvider.setItem(this.getColumnStorageKey(pRecordSet, pViewContext), JSON.stringify(tmpColumnMeta));
		return tmpOverrides;
	}

	/**
	 * Clear all column visibility overrides for a record set (Reset to defaults).
	 *
	 * @param {string} pRecordSet - The record set to clear overrides for
	 * @param {string} [pViewContext] - The view context (defaults to 'List')
	 * @return {boolean} True when the overrides have been cleared.
	 */
	clearColumnVisibilityOverrides(pRecordSet, pViewContext)
	{
		this.storageProvider.removeItem(this.getColumnStorageKey(pRecordSet, pViewContext));
		if (this.pict.Bundle._ActiveColumnState && this.pict.Bundle._ActiveColumnState[pRecordSet])
		{
			delete this.pict.Bundle._ActiveColumnState[pRecordSet];
		}
		return true;
	}

	/**
	 * Write the session mirror of a record set's override map into the Bundle.
	 *
	 * @param {string} pRecordSet - The record set the overrides belong to
	 * @param {Record<string, boolean>} pOverrides - The override map to mirror
	 */
	_seedBundleColumnState(pRecordSet, pOverrides)
	{
		if (!this.pict.Bundle._ActiveColumnState)
		{
			this.pict.Bundle._ActiveColumnState = {};
		}
		this.pict.Bundle._ActiveColumnState[pRecordSet] = { Overrides: pOverrides };
	}

	/** ===== SIMPLE KEY-VALUE CACHE ============= */

	/**
	 * @param {string} pKey - The key to get from the cache
	 * @return {any} - The value associated with the key, or null if not found
	 */
	getItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			return this.keyCache[pKey];
		}
		return null;
	}

	/**
	 * @param {string} pKey - The key to set in the cache
	 * @param {any} pValue - The value to associate with the key
	 */
	setItem(pKey, pValue)
	{
		this.keyCache[pKey] = pValue;
		return true;
	}

	/**
	 * @param {string} pKey - The key to remove from the cache
	 * @return {boolean} - True if the item was removed, false if it was not found
	 */
	removeItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			delete this.keyCache[pKey];
			return true;
		}
		return false;
	}
}

module.exports = ColumnDataProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],612:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'FilterDataProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/** Terminology for Filter Data Provider (to avoid confusion):
 * A "Record Set" is a collection of records that can be filtered.
 * A "Filter Experience" is a saved state of filters for a given record set.
 * A "Filter Experience Hash" is a unique identifier for a Filter Experience (display name converted to a hash).
 * A "Filter Experience Encoded URL Param" is the URL-encoded representation of the filter state for a Filter Experience.
 * A "Filter Display Name" is a user-friendly name for a Filter Experience to select/view in the UI.
 * A "Filter Clauses" is a list of all saved filters in the "Filter Experience" for a given Record Set.
 * A "Filter Meta" is the metadata associated with a Filter Experience, including the Filter Clauses and Filter Display Name.

 * Behavior Summary:
 * - Save Filter Meta to LocalStorage under a key derived from Record Set, View Context, and Filter Experience Hash.
 * - Load Filter Meta from LocalStorage using the same key.
 * - Remove Filter Meta from LocalStorage when requested.
 * - List all Filter Experiences for a given Record Set by scanning LocalStorage keys.
 * - Manage default and last used Filter Experiences for each Record Set and View Context. (last used takes priority over default on load, if the check is enabled)

 * Storage Key Structure:
 * - Filter_Meta_{RecordSet}_{ViewContext}_{FilterExperienceHash} : stores the Filter Meta JSON.

 * Object Shape for Filter Meta (filter experience):
 * {
 *   RecordSet: string, (auto-filled on save)
 *   ViewContext: string, (auto-filled on save)
 *   LastModifiedDate: string (ISO date) (auto-filled on save)
 *   FilterClauses: Array<{ Label: string, ExactMatch: boolean, Value: string }>,
 *   FilterDisplayName: string,
 *   FilterExperienceHash: string, (display name converted to hash)
 *   FilterExperienceEncodedURLParam: string, (URL-encoded filter state)
 
 * Object Shape for Filter Experience Settings:
 * {
 *   ExcludedFromSelection: boolean,
 *   RememberLastUsedFilterExperience: boolean,
 *   LastUsedFilterExperienceHash: string | null,
 *   LastUsedFilterExperienceURLParam: string | null,
 *   DefaultFilterExperienceHash: string | null,
 *   DefaultFilterExperienceURLParam: string | null,
 *   FallbackDefaultExperienceURLParam: string | null,
 * }
*/

// TODO: would nice to convert the comments above to actual types for better clarity and enforcement, but could use help on how to do that.

class FilterDataProvider extends libPictProvider
{
	/**
	 * @param {import('pict')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - The options for the provider
	 * @param {string} [pServiceHash] - The service hash for the provider
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// This allows unit tests to run
		this.storageProvider = this;
		this.keyCache = {};
		if ((typeof(window) === 'object') && (typeof(window.localStorage) === 'object'))
		{
			this.storageProvider = window.localStorage;
		}
		// use this to track if we have unapplied filter changes
		this.filterExperienceModifiedFromURLHash = false;
	}

	onBeforeInitialize()
	{
		return super.onBeforeInitialize();
	}

	/** ===== UTILITY for Filter Experience ============= */

	/**
	 * Using the information in the FilterClauses, try to generate a contextual default filter name for the display name of the current experience.
	 *
	 * @param {object} pFilterExperience - The filter experience to generate the default filter name for
	 * @param {string} [pRecordSet] - The current record set
	 * @param {string} [pViewContext] - The current view context
	 * @return {string} - The generated default filter name
	 */
	generateContextualDefaultFilterName(pFilterExperience, pRecordSet, pViewContext)
	{	
		// if there is a display name, use that
		if (pFilterExperience && pFilterExperience.FilterDisplayName && pFilterExperience.FilterDisplayName.length > 0)
		{
			return pFilterExperience.FilterDisplayName;
		}
		// otherwise, generate one based on the clauses
		const tmpDisplayClauseLimit = 3;
		const tmpRecordSet = pFilterExperience?.RecordSet || pRecordSet || '';
		const tmpClauses = pFilterExperience?.FilterClauses || this.pict.Bundle._ActiveFilterState[tmpRecordSet]?.FilterClauses || [];
		const displayClauses = tmpClauses.length > tmpDisplayClauseLimit ? tmpClauses.slice(0, tmpDisplayClauseLimit) : tmpClauses;
		if (tmpClauses && tmpClauses.length > 0)
		{
			let tmpStringSuffix = '';
			if (tmpClauses.length > tmpDisplayClauseLimit)
			{
				
				tmpStringSuffix = `... (${tmpClauses.length} total filters)`;
			}
			const clauseSummaries = displayClauses.map((clause) => {
				return `${clause.Label || clause.FilterByColumn}`;
				// TODO: We could provide exact values, but we need to account for all the internal/external entity look ups, plus selection handlers on each filter to update the value entered
				// 		 For now, let's just show the column/label since this is a generated suggestion name and will likely to be edited by the user to something more meaningful before saving, but this is an area we could enhance in the future to make the generated names more descriptive
				//return `${clause.Label || clause.FilterByColumn} ${clause.ExactMatch ? 'IS' : 'CONTAINS'} ${clause.Value || clause?.Values?.join(',') || '(unset)'}`;
			});
			return `${clauseSummaries.join(' AND ')}${ tmpStringSuffix }`;
		}
		// give up, fall back to default name
		return `New ${pRecordSet} ${pViewContext} Filter`;
	}

	/**
	 * Re-render all views affected by a filter change.
	 * @param {object} tmpFilterExperience - The filter meta record that was changed/added.
	 * @param {string} pRecordSet - The record set to check.
	 * @param {string} pViewContext - The current view context
	 */
	navigateToFilterExperienceRoute(tmpFilterExperience, pRecordSet, pViewContext)
	{
		// The search term (the /FilteredTo/ segment) is part of the saved experience — restore
		// it alongside the structured filter clauses.
		const tmpSearchSegment = (tmpFilterExperience && tmpFilterExperience.SearchFilterURLParam) ? `/FilteredTo/${tmpFilterExperience.SearchFilterURLParam}` : '';
		// go to the new url with the search segment + the filter experience encoded param
		if (tmpFilterExperience?.FilterExperienceEncodedURLParam && tmpFilterExperience?.FilterExperienceEncodedURLParam?.length > 0)
		{
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}${tmpSearchSegment}/FilterExperience/${tmpFilterExperience.FilterExperienceEncodedURLParam}`);
		}
		else if (tmpSearchSegment)
		{
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}${tmpSearchSegment}`);
		}
		else
		{
			console.info('No FilterExperienceEncodedURLParam found for the current filter experience; navigating to base record set URL.');
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}`);
		}
	}

	/**
	 * Apply the expected filter experience to load on application load for a given record set and view context. Last Used takes priority over Default. 
	 * This is the main entry point to set the default/latest filter experience on app load for a given record set and view context.
	 * @param {string} pRecordSet - The record set to set the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the default filter experience has been set
	 */
	applyExpectedFilterExperience(pRecordSet, pViewContext)
	{
		const applyLastUsed = this.getRememberLastUsedFilterExperience(pRecordSet, pViewContext);
		const tmpDefaultFilterExperience = this.getDefaultFilterExperience(pRecordSet, pViewContext);
		const tmpFallbackDefaultExperienceURLParam = this.getFallbackDefaultFilterExperienceSettings(pRecordSet, pViewContext);
		if (applyLastUsed)
		{
			// first try to set last used filter experience as default on load
			const tmpLastUsedFilterExperience = this.getLastUsedFilterExperience(pRecordSet, pViewContext);
			if (tmpLastUsedFilterExperience)
			{
				this.pict.log.info(`Applying last used filter experience on load for record set: ${pRecordSet} with view context: ${pViewContext}`);
				// if we are already on the last used filter experience by URL, skip loading it again
				if (this.isCurrentFilterExperience(pRecordSet, pViewContext, tmpLastUsedFilterExperience.FilterExperienceHash))
				{
					return true;
				}
				this.loadFilterMeta(pRecordSet, pViewContext, tmpLastUsedFilterExperience.FilterExperienceHash, true);
				return true;
			}
		} 
		// if no last used filter experience, fall back to default filter experience on load
		else if (tmpDefaultFilterExperience && tmpDefaultFilterExperience.FilterExperienceHash)
		{
			this.pict.log.info(`Applying default filter experience on load for record set: ${pRecordSet} with view context: ${pViewContext}`);
			// if we are already on the default filter experience by URL, skip loading it again
			if (this.isCurrentFilterExperience(pRecordSet, pViewContext, tmpDefaultFilterExperience.FilterExperienceHash))
			{
				return true;
			}
			this.loadFilterMeta(pRecordSet, pViewContext, tmpDefaultFilterExperience.FilterExperienceHash, true);
			return true;
		}
		// finally, check for a fallback default experience URL param to load (could be server/customer provided)
		else if (tmpFallbackDefaultExperienceURLParam && tmpFallbackDefaultExperienceURLParam.length > 0)
		{
			this.pict.log.info(`Applying fallback default filter experience URL param on load for record set: ${pRecordSet} with view context: ${pViewContext}`);
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}/FilterExperience/${tmpFallbackDefaultExperienceURLParam}`);
			return true;
		}
		// no filter experience to apply
		return false;
	}

	/** ===== CRUD Filter Experiences ============= */

	/**
	 * Initialize the filter experience settings for a given record set and view context if they do not already exist.
	 * @param {string} pRecordSet - The record set to initialize the settings for
	 * @param {string} pViewContext - The current view context
	 * @param {object} [pAdditionalSettings] - Additional settings to initialize with (pass through for future use)
	 * @return {string} - The filter experience settings object stringifyed (as if it was just read from storage).
	 */
	initializeFilterExperienceSettings(pRecordSet, pViewContext, pAdditionalSettings)
	{
		for (const recordSet in this.storageProvider)
		{
			if (recordSet.startsWith(`Filter_Meta_${pRecordSet}_${pViewContext}_` ) && recordSet.endsWith(`_SETTINGS`))
			{
				return this.storageProvider.getItem(recordSet);
			}
		}
		const defaultSettings = {
			ExcludedFromSelection: true, // this one is excluded from the selection list (it's just settings, not a real filter experience)
			RememberLastUsedFilterExperience: false,
			LastUsedFilterExperienceHash: null,
			LastUsedFilterExperienceURLParam: null,
			DefaultFilterExperienceHash: null,
			DefaultFilterExperienceURLParam: null,
			FallbackDefaultExperienceURLParam: null, // in case the default filter experience is deleted, what URL param to fall back to (could be a server/customer provided fallback)
		};
		// if additional settings were provided, merge them in
		if (pAdditionalSettings && typeof(pAdditionalSettings) === 'object')
		{
			Object.assign(defaultSettings, pAdditionalSettings);
			// ex: set 'FallbackDefaultExperienceURLParam' here for future use
		}
		// save the default settings to storage
		this.storageProvider.setItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`, JSON.stringify(defaultSettings));
		return JSON.stringify(defaultSettings);
	}

	/**
	 * Set options like Last Used / Default hashes, which are stored in the settings object for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the setting for
	 * @param {string} pViewContext - The current view context
	 * @param {object} pSettings - The settings to update
	 * @return {object} - The filter experience settings object
	 */
	updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, pSettings)
	{
		let tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		let tmpSettings = tmpSavedSettings ? JSON.parse(tmpSavedSettings) : {};
		// if we've never saved settings before, initialize them first
		if (!tmpSettings)
		{
			tmpSavedSettings = this.initializeFilterExperienceSettings(pRecordSet, pViewContext);
			tmpSettings = tmpSavedSettings ? JSON.parse(tmpSavedSettings) : {};
		}
		// always update the last modified date, recordSet, and viewContext for tracking
		pSettings.RecordSet = pRecordSet ? pRecordSet : tmpSettings.RecordSet;
		pSettings.ViewContext = pViewContext ? pViewContext : tmpSettings.ViewContext;
		pSettings.LastModifiedDate = new Date().toISOString();
		// merge in the new settings
		tmpSettings = Object.assign({}, tmpSettings, pSettings);
		this.storageProvider.setItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`, JSON.stringify(tmpSettings));
		return tmpSettings;
	}	

	/**
	 * Get a single filter experience by its hash for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the filter experience for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to get
	 * @return {object} - The filter experience object
	 */
	getFilterExperienceByHash(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		if (!pRecordSet || !pViewContext)
		{
			console.error('No record set or view context provided to get filter experience.');
			return null;
		}
		if (!pFilterExperienceHash || pFilterExperienceHash.length === 0)
		{
			console.warn('No filter experience hash provided to get filter experience.');
			return null;
		}
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		return tmpFilterExperience;
	}

	/**
	 * List all available filter experiences (from the Filter Meta data) for a given record set and return them as an array of filter meta objects.
	 * @param {string} pRecordSet - the record set to list the filter experiences for
	 * @param {string} pViewContext - the current view context	 
	 * @return {Array<object>} - An array of filter meta objects for the given record set.
	 */
	getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext)
	{
		let tmpFilterExperiences = [];
		for (const recordSet in this.storageProvider)
		{
			if (recordSet.startsWith(`Filter_Meta_${pRecordSet}_${pViewContext}_`))
			{
				const tmpFilterMetaJSON = this.storageProvider.getItem(recordSet);
				if (tmpFilterMetaJSON)
				{
					const tmpFilterMeta = JSON.parse(tmpFilterMetaJSON);
					tmpFilterExperiences.push(tmpFilterMeta);
				}
			}
		}
		return tmpFilterExperiences;
	}

	/**
	 * Resolve a key in the LocalStorage keyspace for a filter experience for a given record set.
	 * @param {string} pRecordSet - The record set to resolve a key for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The scope to resolve a key for
	 *
	 * @return {string} A string that points to the record.
	 */
	getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		let tmpFilterExperienceHash = (typeof(pFilterExperienceHash) === 'string') ? pFilterExperienceHash : null;
		if (!tmpFilterExperienceHash || tmpFilterExperienceHash.length === 0)
		{
			console.warn('No filter experience hash provided to resolve storage key.');
			return '';
		}
		return `Filter_Meta_${pRecordSet}_${pViewContext}_${tmpFilterExperienceHash}`;
	}

	/**
	 * Check if a filter experience exists for a given record set and filter experience hash.
	 * @param {string} pRecordSet - The record set to check.
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to check.
	 * @return {boolean} - True if the filter experience exists, false otherwise.
	 */
	checkIfFilterExperienceExists(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterMetaJSON = this.storageProvider.getItem(tmpKey);
		return (tmpFilterMetaJSON !== null);
	}

	/**
	 * Save the application metadata (list of Filters, last loaded FilterExperienceHash, etc.)
	 * @param {string} pRecordSet - The record set to save the filter for; 
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The name of the filter to load
	 * @param {boolean} pSkipSaveAsLastUsed - Whether to skip saving this as the last used filter experience - useful when loading last used filter itself
	 * @return {boolean} - Returns true when the filter experience has been loaded.
	 */
	loadFilterMeta(pRecordSet, pViewContext, pFilterExperienceHash, pSkipSaveAsLastUsed)
	{
		// We get this every time in case the user has multiple tabs open
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		if (!tmpFilterExperience)
		{
			// check if this is the "last used" filter experience, since that one is special and we can have the URL param stored separately for unsaved searches
			const tmpLastUsedAndUnsavedExperience = this.isLastUsedFilterExperienceHash(pRecordSet, pViewContext, pFilterExperienceHash);
			if (tmpLastUsedAndUnsavedExperience)
			{
				const tmpLastUsedFilterExperience = this.getLastUsedFilterExperience(pRecordSet, pViewContext);
				this.setCurrentFilterName(tmpLastUsedFilterExperience, pRecordSet, pViewContext, 'My Last Used Filter Experience');
				this.navigateToFilterExperienceRoute(tmpLastUsedFilterExperience, pRecordSet, pViewContext);
				// clear the unapplied changes flag since we just loaded a filter experience
				this.filterExperienceModifiedFromURLHash = false;
				return true;
			}

			this.pict.log.warn(`No filter experience available to remove for record set: ${pRecordSet} with filter experience hash: ${pFilterExperienceHash}`);
			return false;
		}
		// update the current filter name in the UI
		this.setCurrentFilterName(tmpFilterExperience, pRecordSet, pViewContext);
		// re-render views if needed
		this.navigateToFilterExperienceRoute(tmpFilterExperience, pRecordSet, pViewContext);
		// update the last used filter experience
		if (!pSkipSaveAsLastUsed)
		{
			this.setLastUsedFilterExperience(tmpFilterExperience, pRecordSet, pViewContext);
		}
		// clear the unapplied changes flag since we just loaded a filter experience
		this.filterExperienceModifiedFromURLHash = false;
		
		return true;
	}

	/**
	 * Remove a filter meta from storage for a given record set and filter experience hash.
	 * @param {string} pRecordSet - The record set to remove the filter for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to remove
	 * @return {boolean} - Returns true when the filter meta has been removed.
	 */
	removeFilterMeta(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		// TODO: add confirmation dialog in the UI before removing?
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		if (!tmpFilterExperience)
		{
			this.pict.log.warn(`No filter experience available to remove for record set: ${pRecordSet} with filter experience hash: ${pFilterExperienceHash}`);
			return false;
		}
		// check if the filter being removed is set as last used or default; if so, clear those settings too
		if (this.isLastUsedFilterExperienceHash(pRecordSet, pViewContext, pFilterExperienceHash))
		{
			this.pict.log.info(`The filter experience being removed is set as the last used filter experience. Clearing last used filter experience settings.`);
			this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { LastUsedFilterExperienceHash: null, LastUsedFilterExperienceURLParam: null });
		}
		if (this.isDefaultFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash))
		{
			this.pict.log.info(`The filter experience being removed is set as the default filter experience. Clearing default filter experience settings.`);
			this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { DefaultFilterExperienceHash: null, DefaultFilterExperienceURLParam: null });
		}
		if (this.isCurrentFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash))
		{
			this.pict.log.info(`The filter experience being removed is the current active filter. Navigating to base record set URL.`);
			this.pict.views['PRSP-Filters'].handleReset(null, pRecordSet, pViewContext);
		}
		// remove the filter meta from localStorage
		this.storageProvider.removeItem(tmpKey);
		// NOTE: I think we want to keep the last used filter experience even if the user deletes it from the list? (so they can undo)

		return true;
	}

	/**
	 * Save the application metadata (list of Filters, last loaded FilterExperienceHash, etc.)
	 * @param {string} pRecordSet - The record set to save the filter for; TODO: should this have a default?
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the settings have been saved.
	 */
	saveFilterMeta(pRecordSet, pViewContext, pSilent, pDisplayNameOverride)
	{
		const activeFilterExperienceClauses = this.pict.Bundle._ActiveFilterState[pRecordSet]?.FilterClauses || [];
		const filterDisplayName = (pDisplayNameOverride && String(pDisplayNameOverride).trim())
			? String(pDisplayNameOverride).trim()
			: this.getCurrentFilterName({ FilterClauses: activeFilterExperienceClauses }, pRecordSet, pViewContext);
		const tmpFilterExperienceHash = filterDisplayName.replace(/[^a-zA-Z0-9_-]/g, '');

		if (this.checkIfFilterExperienceExists(pRecordSet, pViewContext, tmpFilterExperienceHash))
		{
			this.pict.log.info(`Filter experience with hash 'Filter_Meta_${pRecordSet}_${pViewContext}_${tmpFilterExperienceHash}' already exists for record set ${pRecordSet}. Overwriting.`);
			// TODO: add a confirmation dialog in the UI and compare before overwriting?
		}

		// TODO: BUG: Gotta have a more complex merge happen here for multiple tabs
		const newFilterExperience = {
			RecordSet: pRecordSet,
			ViewContext: pViewContext,
			FilterClauses: activeFilterExperienceClauses,
			FilterDisplayName: filterDisplayName,
			FilterExperienceHash: tmpFilterExperienceHash,
			FilterExperienceEncodedURLParam: window.location.hash.split('/FilterExperience/')?.[1] || '',
			// The search term (the /FilteredTo/ segment) is part of the saved experience too.
			SearchFilterURLParam: window.location.hash.split('/FilteredTo/')?.[1]?.split('/FilterExperience/')?.[0] || '',
			LastModifiedDate: new Date().toISOString(),
		}
		// Save the specific filter metadata to localStorage
		this.storageProvider.setItem(`Filter_Meta_${pRecordSet}_${pViewContext}_${tmpFilterExperienceHash}`, JSON.stringify(newFilterExperience));
		// Also set the last used filter experience (this one is reserved and continually updated)
		this.setLastUsedFilterExperience(newFilterExperience, pRecordSet, pViewContext);
		// they should never get here if they have unsaved changes and navigate away since we check for that in the router, but just in case, we can clear the flag that tracks whether there are unapplied changes since we just saved
		this.filterExperienceModifiedFromURLHash = false;

		return true;
	}

	/** ===== LAST USED Filter Experience ============= */

	/**
	 * Save the application metadata as the last used filter experience (continually updated).
	 * @param {object} pFilterExperience - The new filter experience object to save as last used
	 * @param {string} pRecordSet - The record set to save the filter for;
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the filter experience has been saved.
	 */
	setLastUsedFilterExperience(pFilterExperience, pRecordSet, pViewContext)
	{
		const activeFilterExperienceClauses = this.pict.Bundle._ActiveFilterState[pRecordSet]?.FilterClauses || [];
		const filterDisplayName = this.getCurrentFilterName({ FilterClauses: activeFilterExperienceClauses }, pRecordSet, pViewContext);
		const tmpFilterExperienceHash = filterDisplayName.replace(/[^a-zA-Z0-9_-]/g, '');

		// NOTE: We probably don't want to save EVERY. SINGLE. SEARCH. so if no filter experience is provided (new unsaved search), we can just redirect to the url param rather than create a new saved filter experience
		const filterMetaSettings = { 
			LastUsedFilterExperienceHash: pFilterExperience?.FilterExperienceHash || tmpFilterExperienceHash,
			LastUsedFilterExperienceURLParam: pFilterExperience?.FilterExperienceEncodedURLParam || window.location.hash.split('/FilterExperience/')?.[1] || '',
		}
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, filterMetaSettings);

		return true;
	}

	/**
	 * Remove the last used filter experience for a given record set and view context. (used on "Clear" action to get back to empty filter state)
	 * @param {string} pRecordSet - The record set to remove the last used filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the last used filter experience has been removed.
	 */
	removeLastUsedFilterExperience(pRecordSet, pViewContext)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { LastUsedFilterExperienceHash: null, LastUsedFilterExperienceURLParam: null });
		return true;
	}

	/**
	 * Get the last used filter experience for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the last used filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {object} - The last used filter experience (takes priority over default if both exist)
	 */
	getLastUsedFilterExperience(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		if (!tmpSettings.RememberLastUsedFilterExperience)
		{
			return null;
		}
		const lastUsedFilterExperienceHash = tmpSettings.LastUsedFilterExperienceHash;
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, lastUsedFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		return tmpFilterExperience;
	}

	/**
	 * Check if the given filter experience is the last used filter experience for the given record set and view context.
	 * @param {string} pRecordSet - The record set to check
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to check
	 * @return {boolean} - True if the given filter experience is the last used filter experience, false otherwise
	 */
	isLastUsedFilterExperienceHash(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		const tmpLastUsedFilter = this.getLastUsedFilterExperience(pRecordSet, pViewContext);
		if (!tmpLastUsedFilter)
		{
			return false;
		}
		return (tmpLastUsedFilter.FilterExperienceHash === pFilterExperienceHash);
	}

	/**
	 * Set whether to remember the last used filter experience across sessions.
	 * @param {string} pRecordSet - The record set to set the setting for
	 * @param {string} pViewContext - The current view context
	 * @param {boolean} pRemember - Whether to remember the last used filter experience
	 */
	setRememberLastUsedFilterExperience(pRecordSet, pViewContext, pRemember)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { RememberLastUsedFilterExperience: pRemember });
		return true;
	}

	/**
	 * Get whether to remember the last used filter experience across sessions.
	 * @param {string} pRecordSet - The record set to get the setting for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Whether to remember the last used filter experience
	 */
	getRememberLastUsedFilterExperience(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		return tmpSettings.RememberLastUsedFilterExperience;
	}

	/** ===== CURRENT Filter Experience ============= */

	/**
	 * Check if the given filter experience hash is the current active filter for the given record set.
	 * @param {string} pRecordSet - The record set to check.
	 * @param {string} pViewContext - The current view context.
	 * @param {string} pFilterExperienceHash - The filter experience hash to check.
	 * @return {boolean} - True if the given filter experience hash is the current active filter, false otherwise.
	 */
	isCurrentFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		// NOTE: Could be an confusing issue if we have the same URL param with different display names
		const tmpExperienceURLParam = window.location.hash.split('/FilterExperience/')?.[1] || '';
		// look in the map for the filter experience with the given hash
		const filterExperiences = this.getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext) || [];
		const matchingExperience = filterExperiences.find((pExperience) => pExperience.FilterExperienceHash === pFilterExperienceHash);
		if (matchingExperience && (matchingExperience.FilterExperienceEncodedURLParam === tmpExperienceURLParam))
		{
			return true;
		}
		return false;
	}
	
	/**
	 * Get the current filter name from the UI input (or generate a default one)
	 * @param {object} pFilterExperience - The filter experience to get the current filter name for
	 * @param {string} pRecordSet - The record set to get the filter name for
	 * @param {string} pViewContext - The current view context
	 * @return {string} - The current filter name
	 */
	getCurrentFilterName(pFilterExperience, pRecordSet, pViewContext)
	{
		/* @type {HTMLInputElement} */
		const tmpValue = this.pict.ContentAssignment.readContent('#FilterPersistenceView-CurrentFilterNameInput');
		if (tmpValue && tmpValue.trim().length > 0)
		{
			return tmpValue.trim();
		}
		return this.generateContextualDefaultFilterName(pFilterExperience, pRecordSet, pViewContext);
	}

	/**
	 * Set the current filter name in the UI input
	 * @param {object} [pFilterExperience] - The filter experience to set the current filter name for
	 * @param {string} [pRecordSet] - The record set to set the filter name for
	 * @param {string} [pViewContext] - The current view context
	 * @param {string} [pNewName] - The new name to set
	 * @return {boolean} - Returns true when the name has been set
	 */
	setCurrentFilterName(pFilterExperience, pRecordSet, pViewContext, pNewName)
	{
		const tmpDisplayName = pNewName || this.generateContextualDefaultFilterName(pFilterExperience, pRecordSet, pViewContext);
		this.pict.ContentAssignment.assignContent('#FilterPersistenceView-CurrentFilterNameInput', tmpDisplayName);
		return true;
	}

	/** ===== DEFAULT Filter Experience ============= */

	/**
	 * Set the default filter experience to load on application load for a given record set and filter experience hash.
	 * @param {string} pRecordSet - The record set to set the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to set as default on load
	 * @param {boolean} pSetAsDefault - Whether to set as default or not
	 * @return {boolean} - Returns true when the default filter experience has been set
	 */
	setDefaultFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash, pSetAsDefault)
	{
		const tmpStorageKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpStorageKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		if (!tmpFilterExperience)
		{
			this.pict.log.warn(`No filter experience available to set as default for record set: ${pRecordSet} with filter experience hash: ${pFilterExperienceHash}`);
			return false;
		}
		// if already default, do nothing
		if (pSetAsDefault && this.isDefaultFilterExperience(pRecordSet, pViewContext, tmpFilterExperience.FilterExperienceHash))
		{
			this.pict.log.info(`Filter experience 'Filter_Meta_${pRecordSet}_${pViewContext}_${pFilterExperienceHash}' is already set as default on load. No action taken.`);
			return true;
		}
		// if unsetting default, but not currently default, do nothing
		if (!pSetAsDefault && !this.isDefaultFilterExperience(pRecordSet, pViewContext, tmpFilterExperience.FilterExperienceHash))
		{
			this.pict.log.info(`Filter experience 'Filter_Meta_${pRecordSet}_${pViewContext}_${pFilterExperienceHash}' is not currently set as default on load. No action taken.`);
			return true;
		}
		// update the settings
		// NOTE: We may probably want an customer-based fallback is there user default settings are cleared. For now, we will just clear it until we know that pattern.
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { DefaultFilterExperienceHash: pSetAsDefault ? pFilterExperienceHash : null });
		return true;
	}

	/**
	 * Remove the default filter experience for a given record set and view context. (used on "Clear" action to get back to empty filter state)
	 * @param {string} pRecordSet - The record set to remove the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the default filter experience has been removed.
	 */
	removeDefaultFilterExperience(pRecordSet, pViewContext)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { DefaultFilterExperienceHash: null });
		return true;
	}

	/**
	 * Get the default filter experience to load on application load for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {object} - The default filter experience to load on application load (used if no last used filter experience is found or they clear filters back to default)
	 */
	getDefaultFilterExperience(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		const tmpExpectedHash = tmpSettings.DefaultFilterExperienceHash;
		if (!tmpExpectedHash || tmpExpectedHash.length === 0)
		{
			return null;
		}
		// look up the filter experience by hash (it's expected all Default hashes are saved filter experiences)
		return this.getFilterExperienceByHash(pRecordSet, pViewContext, tmpExpectedHash);
	}

	/**
	 * Check if the given filter experience is the default filter experience to load on application load for the given record set and view context.
	 * @param {string} pRecordSet - The record set to check
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to check
	 * @return {boolean} - True if the given filter experience is the default filter experience on load, false otherwise
	 */
	isDefaultFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return false;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		return (tmpSettings.DefaultFilterExperienceHash === pFilterExperienceHash);
	}

	/**
	 * Get the fallback default filter experience URL param to load on application load for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the fallback default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {string|null} - The fallback default filter experience URL param to load on application load (could be server/customer provided)
	 */
	getFallbackDefaultFilterExperienceSettings(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		return tmpSettings.FallbackDefaultExperienceURLParam || null;
	}

	/**
	 * Set the fallback default filter experience URL param to load on application load for a given record set and view context. Expected to be used for server/customer provided fallbacks.
	 * @param {string} pRecordSet - The record set to set the fallback default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pURLParam - The fallback default filter experience URL param to set
	 * @return {boolean} - Returns true when the fallback default filter experience URL param has been set
	 */
	setFallbackDefaultFilterExperienceSettings(pRecordSet, pViewContext, pURLParam)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { FallbackDefaultExperienceURLParam: pURLParam });
		return true;
	}

	/** ===== SIMPLE KEY-VALUE CACHE ============= */

	/**
	 * @param {string} pKey - The key to get from the cache
	 * @return {any} - The value associated with the key, or false if not found
	 */
	getItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			return this.keyCache[pKey];
		}
		return false;
	}

	/**
	 * @param {string} pKey - The key to set in the cache
	 * @param {any} pValue - The value to associate with the key
	 */
	setItem(pKey, pValue)
	{
		this.keyCache[pKey] = pValue;
		return true;
	}

	/**
	 * @param {string} pKey - The key to remove from the cache
	 * @return {boolean} - True if the item was removed, false if it was not found
	 */
	removeItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			delete this.keyCache[pKey];
			return true;
		}
		return false;
	}
}

module.exports = FilterDataProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],613:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-AssociationManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

/**
 * Central registry + data layer for joined-entity ASSOCIATIONS (the `XxxYyyJoin` convention: a join
 * row carrying its own `ID<Join>` plus an `ID<X>` and an `ID<Y>` pointing at either side).
 *
 * One `Association` is defined ONCE, symmetrically, with a `SideA` and a `SideB`. The UI (the
 * read-tab Association Editor and the Bulk Associate screen) resolves which side is "this side" by
 * matching the rendering recordset's name against the two sides — so opting Book→Authors and
 * Author→Books in are independent, light-config decisions.
 *
 * All join + display reads/writes go through the shared, cached `pict.EntityProvider` (the same one
 * the picker uses), so there is no bespoke REST plumbing and lookups de-duplicate across the app.
 */
class PictRecordSetAssociationManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.pict;

		/** @type {Record<string, Record<string, any>>} - Registered associations keyed by hash. */
		this.associations = {};

		/** @type {Record<string, any>} - Lazily-created EntityProviders scoped to a non-default URL prefix. */
		this._scopedEntityProviders = {};

		/** @type {string} - EntityProvider cache scope for join-list reads; cleared on every join write so
		 * the editor and pickers never show a stale (cached) association list after an add or remove. */
		this._cacheScope = 'RecordSetAssociation';
	}

	/**
	 * Invalidate the cached join-list reads after a write so the next list reflects it immediately
	 * (pict's EntityProvider caches getEntitySet by filter for ~10s; clearScope no-ops on the default
	 * empty scope, which is why join reads run under a dedicated scope).
	 * @param {Record<string, any>} pEntityProvider - the (scoped) EntityProvider used for the join.
	 */
	_clearAssociationCache(pEntityProvider)
	{
		try
		{
			if (pEntityProvider && (typeof pEntityProvider.clearScope === 'function'))
			{
				pEntityProvider.clearScope(this._cacheScope);
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`AssociationManager: association cache clear failed: ${pError.message || pError}`);
		}
	}

	/**
	 * Normalize one side definition, filling the light-config defaults: `Entity` falls back to
	 * `RecordSet`, `IDField` to `ID<Entity>`, `DisplayField` to `Name`, `SearchFields` to
	 * `[DisplayField]`, and `Sort` to `DisplayField`.
	 *
	 * @param {Record<string, any>} pSide
	 * @return {Record<string, any>}
	 */
	_normalizeSide(pSide)
	{
		const tmpSide = pSide || {};
		const tmpEntity = tmpSide.Entity || tmpSide.RecordSet;
		const tmpDisplayField = tmpSide.DisplayField || 'Name';
		const tmpIDField = tmpSide.IDField || `ID${tmpEntity}`;
		return {
			RecordSet: tmpSide.RecordSet || tmpEntity,
			Entity: tmpEntity,
			// The field on THIS SIDE's record that identifies it for association purposes — the picker
			// value, the display lookup key, and (by default) the value stored in the join. Usually the
			// primary key (`ID<Entity>`), but can be any unique field (e.g. ObservationManifest is keyed
			// by 'Name' on its join, so its side is { IDField: 'Name' }).
			IDField: tmpIDField,
			// The column on the JOIN ENTITY that references this side. Defaults to IDField — the common
			// case where the join column has the same name as the side's id field. Set it when the join
			// names this side differently: ProjectObservationManifestJoin stores the manifest by
			// 'ObservationManifestName', so the manifest side is { IDField: 'Name', JoinField: 'ObservationManifestName' }.
			JoinField: tmpSide.JoinField || tmpIDField,
			DisplayField: tmpDisplayField,
			SearchFields: (Array.isArray(tmpSide.SearchFields) && tmpSide.SearchFields.length > 0) ? tmpSide.SearchFields : [ tmpDisplayField ],
			// No default sort: alphabetical-by-display sorts empty values first (blank rows). The picker's
			// natural (PK) order is predictable; a host can opt into a Sort column explicitly.
			Sort: tmpSide.Sort || false,
			Title: tmpSide.Title || false,
			URLPrefix: tmpSide.URLPrefix || '',
			// Extra fields rendered as disambiguation chips in the picker (and the editor list), e.g.
			// ['ISBN'] or [{ Field: 'PublicationYear', Label: 'Year' }]. Passed to the picker as EntityTags.
			ChipFields: Array.isArray(tmpSide.ChipFields) ? tmpSide.ChipFields : [],
			// Pin-to-top: value-ids (or a `(context) => ids | Promise<ids>` resolver) for THIS side's records
			// to float to the top of the add-picker's first browse page. Forwarded to the picker as
			// PriorityValues; a function form receives the anchor context (which record is being associated to)
			// so a host can pin a runtime-derived record — e.g. an Organization side pinning the anchor line
			// item's project Prime Contractor. Only meaningful on the OTHER (picked) side.
			PriorityValues: tmpSide.PriorityValues || false,
			// Columns for the matrix screen's record table — for picking complex records by several fields.
			TableColumns: this._normalizeColumns(tmpSide.TableColumns, tmpDisplayField),
		};
	}

	/**
	 * Normalize a side's TableColumns into `{ Key, DisplayName, Template? }` entries (string shorthand →
	 * `{ Key, DisplayName: Key }`). Defaults to a single column on the DisplayField when unset.
	 *
	 * @param {Array<string|Record<string, any>>|undefined} pColumns @param {string} pDisplayField
	 * @return {Array<Record<string, any>>}
	 */
	_normalizeColumns(pColumns, pDisplayField)
	{
		if (!Array.isArray(pColumns) || pColumns.length < 1)
		{
			return [ { Key: pDisplayField, DisplayName: pDisplayField } ];
		}
		return pColumns.map((pColumn) =>
		{
			if (typeof pColumn === 'string') { return { Key: pColumn, DisplayName: pColumn, DefaultHidden: false }; }
			return { Key: pColumn.Key, DisplayName: pColumn.DisplayName || pColumn.Key, Template: pColumn.Template || false, DefaultHidden: (pColumn.DefaultHidden === true) };
		});
	}

	/**
	 * Build a FoxHound LIKE filter for a search term across one or more fields (single → AND, multiple →
	 * OR'd in a paren group), mirroring the picker's entity search. Used by the matrix table fetch.
	 *
	 * @param {Array<string>} pSearchFields @param {string} pTerm
	 * @return {string}
	 */
	_buildSearchFilter(pSearchFields, pTerm)
	{
		const tmpEncoded = encodeURIComponent(`%${pTerm}%`);
		if (pSearchFields.length === 1)
		{
			return `FBV~${pSearchFields[0]}~LK~${tmpEncoded}`;
		}
		const tmpInner = pSearchFields.map((pField, pIndex) => `${pIndex === 0 ? 'FBV' : 'FBVOR'}~${pField}~LK~${tmpEncoded}`).join('~');
		return `FOP~0~(~0~${tmpInner}~FCP~0~)~0`;
	}

	/**
	 * URL-encode each value and comma-join, for `INN`/`NIN` filter lists. Numeric ids pass through; this
	 * keeps string keys (e.g. manifest names with spaces) intact when a side is keyed by a name column.
	 * @param {Array<string|number>} pValues
	 * @return {string}
	 */
	_encodeList(pValues)
	{
		return (Array.isArray(pValues) ? pValues : []).map((pValue) => encodeURIComponent(pValue)).join(',');
	}

	/**
	 * Fetch one page of a side's records for the matrix table (search across its SearchFields + optional
	 * Sort, offset/limit paging). Returns the raw records + a `hasMore` flag.
	 *
	 * @param {string} pAssociationHash @param {string} pRecordSetName
	 * @param {string} pSearch @param {number} pCursor @param {number} pPageSize
	 * @return {Promise<{records: Array<Record<string, any>>, hasMore: boolean}>}
	 */
	fetchSidePage(pAssociationHash, pRecordSetName, pSearch, pCursor, pPageSize)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pRecordSetName);
		if (!tmpSides)
		{
			return Promise.resolve({ records: [], hasMore: false });
		}
		const tmpSide = tmpSides.thisSide;
		const tmpEntityProvider = this._entityProvider(tmpSide.URLPrefix);
		const tmpStanzas = [];
		if (pSearch) { tmpStanzas.push(this._buildSearchFilter(tmpSide.SearchFields, pSearch)); }
		if (tmpSide.Sort) { tmpStanzas.push(`FSF~${tmpSide.Sort}~ASC~0`); }
		const tmpFilter = tmpStanzas.filter(Boolean).join('~');
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySetPage(tmpSide.Entity, tmpFilter, pCursor, pPageSize, (pError, pRecords) =>
			{
				const tmpList = (!pError && Array.isArray(pRecords)) ? pRecords : [];
				if (pError) { this.pict.log.warn(`AssociationManager: matrix fetch failed for ${tmpSide.Entity}.`, pError); }
				return resolve({ records: tmpList, hasMore: (tmpList.length >= pPageSize) });
			});
		});
	}

	/**
	 * Register (or replace) an association definition.
	 *
	 * @param {string} pHash - Unique association hash (the `Association` key hosts reference).
	 * @param {Record<string, any>} pDefinition - `{ JoinEntity, JoinURLPrefix?, DefaultJoinValues?, SideA, SideB }`.
	 * @return {Record<string, any>|false} The normalized association, or false on invalid input.
	 */
	addAssociation(pHash, pDefinition)
	{
		if (!pHash || !pDefinition || !pDefinition.JoinEntity || !pDefinition.SideA || !pDefinition.SideB)
		{
			this.pict.log.error(`AssociationManager: addAssociation called with invalid definition for [${pHash}].`, pDefinition);
			return false;
		}
		const tmpAssociation = {
			Hash: pHash,
			JoinEntity: pDefinition.JoinEntity,
			JoinURLPrefix: pDefinition.JoinURLPrefix || '',
			DefaultJoinValues: pDefinition.DefaultJoinValues || {},
			// Per-join config columns the editor renders as inline-editable on each association row — for
			// "rich" joins that carry settings (e.g. Journal/Spreadsheet/Ordinal). Each entry:
			// { Field, Label?, Type? ('checkbox'|'number'|'text'|'select'), Options?, Width? }.
			JoinEditableFields: Array.isArray(pDefinition.JoinEditableFields) ? pDefinition.JoinEditableFields : [],
			// The defaults lifecycle hook — the overridable seam the host implements. An async
			// `(context) => Array<{ value, joinValues? }>` returning the OTHER side's key values (+ optional
			// per-join config) to seed for an anchor record. PSRS owns APPLYING them (dedupe + createJoin),
			// so every association synthesizes defaults the same way; the host only decides what they are.
			SynthesizeDefaults: (typeof pDefinition.SynthesizeDefaults === 'function') ? pDefinition.SynthesizeDefaults : false,
			// Opt-in: auto-run synthesizeDefaults the first time the editor opens an anchor with zero joins.
			AutoSynthesizeWhenEmpty: (pDefinition.AutoSynthesizeWhenEmpty === true),
			SideA: this._normalizeSide(pDefinition.SideA),
			SideB: this._normalizeSide(pDefinition.SideB),
		};
		this.associations[pHash] = tmpAssociation;
		return tmpAssociation;
	}

	/**
	 * @param {string} pHash
	 * @return {Record<string, any>|undefined}
	 */
	getAssociation(pHash)
	{
		return this.associations[pHash];
	}

	/**
	 * The hashes of every registered association that has the given recordset on either side (matched by
	 * RecordSet or Entity, the same way resolveSides matches). Drives reassociation-on-delete: to reassign
	 * a record's relationships before deleting it, we need every many-to-many join it participates in.
	 *
	 * @param {string} pRecordSetName
	 * @return {Array<string>}
	 */
	getAssociationsForRecordSet(pRecordSetName)
	{
		const tmpHashes = [];
		for (const tmpHash of Object.keys(this.associations))
		{
			const tmpAssociation = this.associations[tmpHash];
			if (tmpAssociation.SideA.RecordSet === pRecordSetName || tmpAssociation.SideA.Entity === pRecordSetName
				|| tmpAssociation.SideB.RecordSet === pRecordSetName || tmpAssociation.SideB.Entity === pRecordSetName)
			{
				tmpHashes.push(tmpHash);
			}
		}
		return tmpHashes;
	}

	/**
	 * Resolve which side of an association is "this side" (the rendering recordset) vs the "other side"
	 * (the one being associated). Matches on `RecordSet` first, then `Entity`.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @return {{ association: Record<string, any>, thisSide: Record<string, any>, otherSide: Record<string, any> }|false}
	 */
	resolveSides(pAssociationHash, pThisRecordSetName)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		if (!tmpAssociation)
		{
			this.pict.log.warn(`AssociationManager: no association registered for hash [${pAssociationHash}].`);
			return false;
		}
		if (tmpAssociation.SideA.RecordSet === pThisRecordSetName || tmpAssociation.SideA.Entity === pThisRecordSetName)
		{
			return { association: tmpAssociation, thisSide: tmpAssociation.SideA, otherSide: tmpAssociation.SideB };
		}
		if (tmpAssociation.SideB.RecordSet === pThisRecordSetName || tmpAssociation.SideB.Entity === pThisRecordSetName)
		{
			return { association: tmpAssociation, thisSide: tmpAssociation.SideB, otherSide: tmpAssociation.SideA };
		}
		this.pict.log.warn(`AssociationManager: recordset [${pThisRecordSetName}] is neither side of association [${pAssociationHash}].`);
		return false;
	}

	/**
	 * The EntityProvider to use for a given URL prefix. The shared (cached) `pict.EntityProvider` for the
	 * default prefix; a lazily-created, prefix-scoped instance otherwise (mirrors the recordset provider).
	 *
	 * @param {string} [pURLPrefix]
	 * @return {any}
	 */
	_entityProvider(pURLPrefix)
	{
		if (!pURLPrefix)
		{
			return this.pict.EntityProvider;
		}
		if (!this._scopedEntityProviders[pURLPrefix])
		{
			const tmpProvider = this.pict.instantiateServiceProviderWithoutRegistration('EntityProvider');
			tmpProvider.options.urlPrefix = pURLPrefix;
			this._scopedEntityProviders[pURLPrefix] = tmpProvider;
		}
		return this._scopedEntityProviders[pURLPrefix];
	}

	/**
	 * The join entity's identity column for an association (`ID<JoinEntity>`).
	 * @param {Record<string, any>} pAssociation
	 * @return {string}
	 */
	getJoinIDField(pAssociation)
	{
		return `ID${pAssociation.JoinEntity}`;
	}

	/**
	 * Compose a side's ChipFields into display chip strings for a record — the same `ISBN` / `{Field,
	 * Label, Template}` spec the picker's EntityTags uses, so the editor's current-associations list shows
	 * the same disambiguation chips as the add picker.
	 *
	 * @param {Array<string|Record<string, any>>} pChipFields
	 * @param {Record<string, any>} pRecord
	 * @return {Array<any>}
	 */
	composeChips(pChipFields, pRecord)
	{
		if (!Array.isArray(pChipFields) || pChipFields.length < 1 || !pRecord)
		{
			return [];
		}
		return pChipFields
			.map((pSpec) =>
			{
				if (typeof pSpec === 'string') { return pRecord[pSpec]; }
				if (pSpec && typeof pSpec === 'object')
				{
					const tmpValue = pSpec.Template ? this.pict.parseTemplate(pSpec.Template, pRecord) : pRecord[pSpec.Field];
					if (tmpValue === undefined || tmpValue === null || tmpValue === '') { return ''; }
					return pSpec.Label ? `${pSpec.Label}: ${tmpValue}` : tmpValue;
				}
				return '';
			})
			.filter((pChip) => (pChip !== undefined && pChip !== null && pChip !== ''));
	}

	/**
	 * Fetch the raw join rows for one anchor record (this side's id).
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || pThisID === undefined || pThisID === null || pThisID === '')
		{
			return Promise.resolve([]);
		}
		const tmpEntityProvider = this._entityProvider(tmpSides.association.JoinURLPrefix);
		const tmpFilter = `FBV~${tmpSides.thisSide.JoinField}~EQ~${encodeURIComponent(pThisID)}`;
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySet(tmpSides.association.JoinEntity, tmpFilter, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`AssociationManager: failed to list ${tmpSides.association.JoinEntity} for ${tmpSides.thisSide.IDField}=${pThisID}.`, pError);
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, '', { Scope: this._cacheScope, NoCount: true });
		});
	}

	/**
	 * Fetch the join rows for MANY "this side" ids at once (`FBL~<thisIDField>~INN~<ids>`). Drives the
	 * dual-column matrix screen's existing-pair dedup, so cross-linking never creates duplicate joins.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {Array<string|number>} pThisIDs
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	listJoinRecordsForIDs(pAssociationHash, pThisRecordSetName, pThisIDs)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || !Array.isArray(pThisIDs) || pThisIDs.length < 1)
		{
			return Promise.resolve([]);
		}
		const tmpEntityProvider = this._entityProvider(tmpSides.association.JoinURLPrefix);
		const tmpFilter = `FBL~${tmpSides.thisSide.JoinField}~INN~${this._encodeList(pThisIDs)}`;
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySet(tmpSides.association.JoinEntity, tmpFilter, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`AssociationManager: failed to list ${tmpSides.association.JoinEntity} for ${tmpSides.thisSide.IDField} IN (${pThisIDs.join(',')}).`, pError);
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, '', { Scope: this._cacheScope, NoCount: true });
		});
	}

	/**
	 * The other-side ids currently associated with one anchor record (for culling the picker).
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<Array<any>>}
	 */
	/**
	 * Does this join row reference a real other-side record? An unset key (undefined / null / '') is
	 * not an association; nor is 0 / '0' on an id-keyed side, where 0 is never a real auto-increment id
	 * (Meadow ids start at 1). Some hosts park sentinel rows in the join table — e.g. a "default set"
	 * keyed by IDProject = 0 that a SynthesizeDefaults hook reads — and those must not surface as broken
	 * "#0" rows in the editor. The 0-guard is gated to id-keyed sides (JoinField === IDField) so a
	 * name-keyed side, where '0' could pathologically be a real key, is never affected.
	 *
	 * @param {Record<string, any>} pJoin - a join row.
	 * @param {Record<string, any>} pOtherSide - the resolved other side.
	 * @return {Boolean}
	 */
	_joinReferencesRealRecord(pJoin, pOtherSide)
	{
		const tmpValue = pJoin[pOtherSide.JoinField];
		if ((tmpValue === undefined) || (tmpValue === null) || (tmpValue === ''))
		{
			return false;
		}
		if ((pOtherSide.JoinField === pOtherSide.IDField) && ((tmpValue === 0) || (tmpValue === '0')))
		{
			return false;
		}
		return true;
	}

	async listAssociatedIDs(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return [];
		}
		const tmpJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID);
		return tmpJoins
			.filter((pJoin) => this._joinReferencesRealRecord(pJoin, tmpSides.otherSide))
			.map((pJoin) => pJoin[tmpSides.otherSide.JoinField]);
	}

	/**
	 * Resolve the other-side records currently associated with one anchor, decorated for the list UI:
	 * `{ JoinID, OtherID, Display, OtherRecord, JoinRecord }`. One join row per item (so the remove
	 * button can delete the exact join record), with the other-side display resolved in a single
	 * `FBL~<otherIDField>~INN~<ids>` fetch.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	async listAssociatedRecords(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return [];
		}
		const tmpJoinIDField = this.getJoinIDField(tmpSides.association);
		const tmpJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID);
		// Drop sentinel / unset rows (e.g. a "default set" keyed by other-side id 0) so they don't
		// surface as broken "#0" rows; everything downstream works off the real-association set.
		const tmpRealJoins = tmpJoins.filter((pJoin) => this._joinReferencesRealRecord(pJoin, tmpSides.otherSide));
		const tmpOtherIDs = tmpRealJoins.map((pJoin) => pJoin[tmpSides.otherSide.JoinField]);

		let tmpByID = {};
		if (tmpOtherIDs.length > 0)
		{
			const tmpEntityProvider = this._entityProvider(tmpSides.otherSide.URLPrefix);
			const tmpFilter = `FBL~${tmpSides.otherSide.IDField}~INN~${this._encodeList(tmpOtherIDs)}`;
			const tmpOthers = await new Promise((resolve) =>
			{
				tmpEntityProvider.getEntitySet(tmpSides.otherSide.Entity, tmpFilter, (pError, pRecords) =>
				{
					if (pError)
					{
						this.pict.log.warn(`AssociationManager: failed to resolve ${tmpSides.otherSide.Entity} display records.`, pError);
						return resolve([]);
					}
					return resolve(Array.isArray(pRecords) ? pRecords : []);
				});
			});
			for (let i = 0; i < tmpOthers.length; i++)
			{
				tmpByID[tmpOthers[i][tmpSides.otherSide.IDField]] = tmpOthers[i];
			}
		}

		return tmpRealJoins
			.map((pJoin) =>
			{
				const tmpOtherID = pJoin[tmpSides.otherSide.JoinField];
				const tmpOtherRecord = tmpByID[tmpOtherID] || {};
				const tmpDisplay = (tmpOtherRecord[tmpSides.otherSide.DisplayField] !== undefined && tmpOtherRecord[tmpSides.otherSide.DisplayField] !== null && tmpOtherRecord[tmpSides.otherSide.DisplayField] !== '')
					? tmpOtherRecord[tmpSides.otherSide.DisplayField]
					: `#${tmpOtherID}`;
				return {
					JoinID: pJoin[tmpJoinIDField],
					OtherID: tmpOtherID,
					Display: tmpDisplay,
					Chips: this.composeChips(tmpSides.otherSide.ChipFields, tmpOtherRecord).map((pChip) => ({ Text: pChip })),
					OtherRecord: tmpOtherRecord,
					JoinRecord: pJoin,
				};
			});
	}

	/**
	 * Create one join row linking an anchor record to an other-side record. Stamps any configured
	 * `DefaultJoinValues` (e.g. a constant tenant id). The join's GUID is auto-generated server-side.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @param {string|number} pOtherID
	 * @param {Record<string, any>} [pJoinValues] - Optional extra columns to stamp on the join row (e.g.
	 *   per-association config like { Journal: 1, Ordinal: 3 } from a synthesized default).
	 * @return {Promise<Record<string, any>>}
	 */
	createJoin(pAssociationHash, pThisRecordSetName, pThisID, pOtherID, pJoinValues)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return Promise.reject(new Error(`AssociationManager: cannot create join for [${pAssociationHash}] from [${pThisRecordSetName}].`));
		}
		const tmpRecord = Object.assign({}, tmpSides.association.DefaultJoinValues, pJoinValues || {});
		tmpRecord[tmpSides.thisSide.JoinField] = pThisID;
		tmpRecord[tmpSides.otherSide.JoinField] = pOtherID;
		const tmpEntityProvider = this._entityProvider(tmpSides.association.JoinURLPrefix);
		return new Promise((resolve, reject) =>
		{
			tmpEntityProvider.createEntity(tmpSides.association.JoinEntity, tmpRecord, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				this._clearAssociationCache(tmpEntityProvider);
				return resolve(pBody);
			});
		});
	}

	/**
	 * Delete one join row (the row a list item carries as `JoinRecord`, or any record with the join id).
	 *
	 * @param {string} pAssociationHash
	 * @param {Record<string, any>} pJoinRecord
	 * @return {Promise<Record<string, any>>}
	 */
	removeJoin(pAssociationHash, pJoinRecord)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		if (!tmpAssociation || !pJoinRecord)
		{
			return Promise.reject(new Error(`AssociationManager: cannot remove join for [${pAssociationHash}].`));
		}
		const tmpJoinID = pJoinRecord[this.getJoinIDField(tmpAssociation)];
		const tmpEntityProvider = this._entityProvider(tmpAssociation.JoinURLPrefix);
		return new Promise((resolve, reject) =>
		{
			tmpEntityProvider.deleteEntity(tmpAssociation.JoinEntity, tmpJoinID, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				this._clearAssociationCache(tmpEntityProvider);
				return resolve(pBody);
			});
		});
	}

	/**
	 * Update the config columns of an existing join row (a "rich" join's per-association settings, e.g.
	 * Journal / Spreadsheet / Ordinal). Merges pValues over the join record and PUTs it.
	 *
	 * @param {string} pAssociationHash
	 * @param {Record<string, any>} pJoinRecord - the full join row (as carried by listAssociatedRecords).
	 * @param {Record<string, any>} pValues - the columns to change.
	 * @return {Promise<Record<string, any>>}
	 */
	updateJoin(pAssociationHash, pJoinRecord, pValues)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		if (!tmpAssociation || !pJoinRecord)
		{
			return Promise.reject(new Error(`AssociationManager: cannot update join for [${pAssociationHash}].`));
		}
		// Minimal update — the join id + only the changed columns. The read-decorated join row can carry
		// derived, non-column fields (e.g. a joined ModuleConfig) that the server rejects on write; Meadow
		// updates only the fields provided, so a minimal record is both correct and safe.
		const tmpJoinIDField = this.getJoinIDField(tmpAssociation);
		const tmpRecord = Object.assign({ [tmpJoinIDField]: pJoinRecord[tmpJoinIDField] }, pValues || {});
		const tmpEntityProvider = this._entityProvider(tmpAssociation.JoinURLPrefix);
		return new Promise((resolve, reject) =>
		{
			tmpEntityProvider.updateEntity(tmpAssociation.JoinEntity, tmpRecord, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				// Meadow returns a non-2xx error in the body (not the callback) — surface it as a failure.
				if (pBody && pBody.ErrorCode)
				{
					return reject(new Error(`AssociationManager: join update rejected (ErrorCode ${pBody.ErrorCode}).`));
				}
				this._clearAssociationCache(tmpEntityProvider);
				return resolve(pBody);
			});
		});
	}

	/**
	 * Repoint every join row that references `pFromID` (on the given recordset's side) so it references
	 * `pToID` instead — the many-to-many half of reassociation-on-delete ("this author's books now belong
	 * to that author"). For each of the from-record's joins: if `pToID` is ALREADY joined to the same
	 * other-side record, the from-join is deleted (repointing it would create a duplicate pair); otherwise
	 * the join's this-side column is repointed via a minimal update, which preserves any rich-join config
	 * columns (Journal/Ordinal/…). `pToID`'s existing joins are snapshotted up front so the dedup read is
	 * clean, and each repoint extends the dedup set so two from-joins to the same other-side record can't
	 * duplicate either.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName - the recordset being deleted-from (pFromID and pToID are ids on THIS side).
	 * @param {string|number} pFromID - the id being removed; its joins move away.
	 * @param {string|number} pToID - the replacement id; the joins move to it.
	 * @return {Promise<{ repointed: number, deletedDuplicate: number, failed: number }>}
	 */
	async repointJoins(pAssociationHash, pThisRecordSetName, pFromID, pToID)
	{
		const tmpResult = { repointed: 0, deletedDuplicate: 0, failed: 0 };
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || pFromID === undefined || pFromID === null || pFromID === '' || pToID === undefined || pToID === null || pToID === '')
		{
			return tmpResult;
		}
		// Self-repoint is a no-op: moving a record's joins onto itself changes nothing, and a later delete
		// of pFromID would then strand exactly the joins we thought we "kept".
		if (String(pFromID) === String(pToID))
		{
			return tmpResult;
		}

		const tmpFromJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pFromID);
		const tmpToJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pToID);

		// The other-side ids pToID already links — repointing a from-join onto any of these would duplicate
		// the pair, so those from-joins are dropped instead.
		const tmpToOtherIDs = {};
		for (let i = 0; i < tmpToJoins.length; i++)
		{
			const tmpOtherID = tmpToJoins[i][tmpSides.otherSide.JoinField];
			if (tmpOtherID !== undefined && tmpOtherID !== null && tmpOtherID !== '')
			{
				tmpToOtherIDs[`${tmpOtherID}`] = true;
			}
		}

		for (let i = 0; i < tmpFromJoins.length; i++)
		{
			const tmpJoin = tmpFromJoins[i];
			const tmpOtherID = tmpJoin[tmpSides.otherSide.JoinField];
			const tmpReal = (tmpOtherID !== undefined) && (tmpOtherID !== null) && (tmpOtherID !== '');
			try
			{
				if (tmpReal && tmpToOtherIDs[`${tmpOtherID}`])
				{
					// pToID already links this other-side record — drop the would-be duplicate join.
					await this.removeJoin(pAssociationHash, tmpJoin);
					tmpResult.deletedDuplicate++;
				}
				else
				{
					// Repoint this side's column on the join row to pToID.
					await this.updateJoin(pAssociationHash, tmpJoin, { [tmpSides.thisSide.JoinField]: pToID });
					if (tmpReal) { tmpToOtherIDs[`${tmpOtherID}`] = true; }
					tmpResult.repointed++;
				}
			}
			catch (pError)
			{
				tmpResult.failed++;
				this.pict.log.error(`AssociationManager: repointJoins failed for a [${pAssociationHash}] join (${pThisRecordSetName} ${pFromID} -> ${pToID}): ${pError.message || pError}`);
			}
		}
		return tmpResult;
	}

	/**
	 * The per-join config columns an association exposes as inline-editable (empty for a plain join).
	 * @param {string} pAssociationHash
	 * @return {Array<Record<string, any>>}
	 */
	getJoinEditableFields(pAssociationHash)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		return (tmpAssociation && Array.isArray(tmpAssociation.JoinEditableFields)) ? tmpAssociation.JoinEditableFields : [];
	}

	/**
	 * Whether an association has a host-provided defaults synthesizer registered.
	 * @param {string} pAssociationHash
	 * @return {boolean}
	 */
	hasDefaultSynthesizer(pAssociationHash)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		return !!(tmpAssociation && (typeof tmpAssociation.SynthesizeDefaults === 'function'));
	}

	/**
	 * Synthesize default associations for one anchor record — THE consistent defaults lifecycle function.
	 * PSRS owns the "apply" half (dedupe against existing joins, then createJoin each new one with its
	 * config); the host owns only WHAT the defaults are, via the association's overridable
	 * `SynthesizeDefaults(context)` hook. No-op when no hook is registered.
	 *
	 * The hook receives `{ association, thisSide, otherSide, thisID, existingJoins, manager, pict }` and
	 * returns `Array<{ value, joinValues? }>` — `value` is the OTHER side's key value (what goes in the
	 * join's other JoinField), `joinValues` is optional extra config to stamp on that join row.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<{ created: number, skipped: number }>}
	 */
	async synthesizeDefaults(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || !this.hasDefaultSynthesizer(pAssociationHash) || pThisID === undefined || pThisID === null || pThisID === '')
		{
			return { created: 0, skipped: 0 };
		}
		const tmpExistingJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID);
		const tmpExisting = {};
		tmpExistingJoins.forEach((pJoin) =>
		{
			const tmpValue = pJoin[tmpSides.otherSide.JoinField];
			if (tmpValue !== undefined && tmpValue !== null && tmpValue !== '') { tmpExisting[`${tmpValue}`] = true; }
		});

		let tmpDefaults = [];
		try
		{
			tmpDefaults = await tmpSides.association.SynthesizeDefaults(
				{
					association: tmpSides.association,
					thisSide: tmpSides.thisSide,
					otherSide: tmpSides.otherSide,
					thisID: pThisID,
					existingJoins: tmpExistingJoins,
					manager: this,
					pict: this.pict,
				});
		}
		catch (pError)
		{
			this.pict.log.error(`AssociationManager: SynthesizeDefaults hook for [${pAssociationHash}] threw: ${pError.message || pError}`);
			return { created: 0, skipped: 0 };
		}

		let tmpCreated = 0;
		let tmpSkipped = 0;
		const tmpList = Array.isArray(tmpDefaults) ? tmpDefaults : [];
		for (let i = 0; i < tmpList.length; i++)
		{
			const tmpDefault = tmpList[i] || {};
			const tmpValue = (tmpDefault.value !== undefined) ? tmpDefault.value : tmpDefault.Value;
			if (tmpValue === undefined || tmpValue === null || tmpValue === '' || tmpExisting[`${tmpValue}`])
			{
				tmpSkipped++;
				continue;
			}
			try
			{
				await this.createJoin(pAssociationHash, pThisRecordSetName, pThisID, tmpValue, tmpDefault.joinValues || tmpDefault.JoinValues || {});
				tmpExisting[`${tmpValue}`] = true;
				tmpCreated++;
			}
			catch (pError)
			{
				this.pict.log.warn(`AssociationManager: synthesize createJoin failed for [${pAssociationHash}] value [${tmpValue}]: ${pError.message || pError}`);
				tmpSkipped++;
			}
		}
		return { created: tmpCreated, skipped: tmpSkipped };
	}

	/**
	 * Build a `createEntityPicker` config for one side, optionally culling a live set of ids (a function
	 * so the cull re-evaluates on every search as associations change).
	 *
	 * @param {Record<string, any>} pSide - A normalized side.
	 * @param {(() => Array<any>)|false} pGetExcludedIDsFn - Returns ids to exclude (NIN), or falsy for none.
	 * @param {Record<string, any>} [pOverrides] - Extra picker options (DestinationAddress, ValueAddress, Mode, OnChange, …).
	 * @param {Record<string, any>} [pPriorityContext] - Anchor context merged into a function-form PriorityValues
	 *   resolver's argument (e.g. `{ ThisID, ThisRecordSet }`), so a host pin can be derived from the anchor record.
	 * @return {Record<string, any>}
	 */
	_pickerConfigForSide(pSide, pGetExcludedIDsFn, pOverrides, pPriorityContext)
	{
		const tmpConfig = {
			Entity: pSide.Entity,
			ValueField: pSide.IDField,
			TextField: pSide.DisplayField,
			SearchFields: pSide.SearchFields,
			Sort: pSide.Sort,
		};
		// Disambiguation chips (ISBN, year, …) — the picker renders these as badges on each option/chip.
		// TagLast so they sit AFTER the label ("Title  ISBN  Year"), matching the editor list rows.
		if (Array.isArray(pSide.ChipFields) && pSide.ChipFields.length > 0)
		{
			tmpConfig.EntityTags = pSide.ChipFields;
			tmpConfig.TagLast = true;
		}
		// Pin-to-top (module policy): forward the side's PriorityValues to the picker's DataProvider. A
		// function form is wrapped so the host resolver receives the anchor context (which record we're
		// associating to) — the prime-contractor-at-top case needs the anchor to resolve its project.
		if (pSide.PriorityValues)
		{
			tmpConfig.PriorityValues = (typeof pSide.PriorityValues === 'function')
				? (() => pSide.PriorityValues(Object.assign({ side: pSide, manager: this, pict: this.pict }, pPriorityContext || {})))
				: pSide.PriorityValues;
		}
		if (typeof pGetExcludedIDsFn === 'function')
		{
			tmpConfig.BaseFilter = () =>
			{
				const tmpIDs = pGetExcludedIDsFn();
				return (Array.isArray(tmpIDs) && tmpIDs.length > 0) ? `FBL~${pSide.IDField}~NIN~${this._encodeList(tmpIDs)}` : '';
			};
		}
		// Field decoration (module policy, resolved per entity by the metacontroller): when this side's
		// entity is opted in, the picker offers a ⚙ to pin an extra column onto each row (the "six
		// Volkerts" disambiguation). Caller overrides still win in the Object.assign below.
		if (this.pict.PictSectionRecordSet)
		{
			this.pict.PictSectionRecordSet.applyFieldDecoration(tmpConfig, pSide.Entity);
		}
		return Object.assign(tmpConfig, pOverrides || {});
	}

	/**
	 * Picker config for the OTHER side of an association (the records being associated), culling the
	 * currently-associated ids.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {(() => Array<any>)|false} pGetExcludedIDsFn
	 * @param {Record<string, any>} [pOverrides]
	 * @param {Record<string, any>} [pAnchorContext] - The anchor record context (e.g. `{ ThisID, ThisRecordSet }`),
	 *   passed to a function-form PriorityValues resolver on the other side so a pin can be derived from the anchor.
	 * @return {Record<string, any>|false}
	 */
	buildOtherPickerConfig(pAssociationHash, pThisRecordSetName, pGetExcludedIDsFn, pOverrides, pAnchorContext)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return false;
		}
		const tmpPriorityContext = Object.assign(
			{ association: tmpSides.association, thisSide: tmpSides.thisSide, otherSide: tmpSides.otherSide },
			pAnchorContext || {});
		return this._pickerConfigForSide(tmpSides.otherSide, pGetExcludedIDsFn, pOverrides, tmpPriorityContext);
	}

	/**
	 * Picker config for the ANCHOR side of an association (the bulk screen's "pick a record to associate
	 * to" control). No cull.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pAnchorRecordSetName
	 * @param {Record<string, any>} [pOverrides]
	 * @return {Record<string, any>|false}
	 */
	buildAnchorPickerConfig(pAssociationHash, pAnchorRecordSetName, pOverrides)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pAnchorRecordSetName);
		if (!tmpSides)
		{
			return false;
		}
		return this._pickerConfigForSide(tmpSides.thisSide, false, pOverrides);
	}
}

module.exports = PictRecordSetAssociationManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],614:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'RecordSetCardManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	CSS: /*css*/`
	.psrs-card-trigger { display: inline-flex; align-items: center; gap: 0.25rem; cursor: pointer; }
	.psrs-card-trigger-label { text-decoration: underline; text-decoration-style: dotted; text-underline-offset: 0.15em; }
	.psrs-card-trigger:hover .psrs-card-trigger-label { text-decoration-style: solid; color: var(--theme-color-brand-primary, #156dd1); }
	.psrs-card-trigger-icon { display: inline-flex; font-size: 0.82em; color: var(--theme-color-text-muted, #6b7686); }
	.psrs-card-trigger:hover .psrs-card-trigger-icon { color: var(--theme-color-brand-primary, #156dd1); }

	.psrs-card-popover { position: absolute; z-index: 4000; min-width: 16rem; max-width: 22rem; max-height: 70vh; overflow-y: auto;
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
		border-radius: 12px; box-shadow: 0 16px 40px rgba(15, 23, 42, 0.20); padding: 0.95rem 1.05rem;
		opacity: 0; transform: translateY(-4px); transition: opacity 0.12s ease, transform 0.12s ease; pointer-events: none; }
	.psrs-card-popover.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }
	.psrs-card-head { display: flex; align-items: flex-start; gap: 0.7rem; margin: 0 0 0.6rem; }
	.psrs-card-img { flex: 0 0 auto; width: 2.6rem; height: 2.6rem; border-radius: 8px; overflow: hidden;
		background: var(--theme-color-background-tertiary, #f1f3f6); display: flex; align-items: center; justify-content: center; }
	.psrs-card-img img { width: 100%; height: 100%; object-fit: cover; }
	.psrs-card-title { font-size: 1.02rem; font-weight: 700; line-height: 1.2; color: var(--theme-color-text-primary, #1f2733); }
	.psrs-card-subtitle { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 0.1rem; }
	.psrs-card-fields { display: grid; grid-template-columns: auto 1fr; gap: 0.3rem 0.85rem; align-items: baseline; margin: 0.2rem 0 0; }
	.psrs-card-label { font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; }
	.psrs-card-value { font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); word-break: break-word; }
	.psrs-card-bool { display: inline-flex; align-items: center; justify-content: center; width: 1.05rem; height: 1.05rem; border-radius: 4px;
		border: 1.5px solid var(--theme-color-border-default, #c7cdd6); color: #fff; vertical-align: middle; }
	.psrs-card-bool-on { background: var(--theme-color-brand-primary, #156dd1); border-color: var(--theme-color-brand-primary, #156dd1); }
	.psrs-card-bool .pict-icon { font-size: 0.8em; }
	.psrs-card-custom { font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); }
	.psrs-card-actions { display: flex; flex-wrap: wrap; gap: 0.4rem; margin-top: 0.85rem; padding-top: 0.7rem; border-top: 1px solid var(--theme-color-border-light, #eef1f5); }
	.psrs-card-action { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.82rem; font-weight: 600;
		text-decoration: none; padding: 0.3rem 0.7rem; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d7dce3);
		background: var(--theme-color-background-secondary, #f5f6f8); color: var(--theme-color-text-secondary, #45505f); }
	.psrs-card-action:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); }
	.psrs-card-action .pict-icon { font-size: 0.9em; }
	/* Audit stripe — a thin Created/Updated line + ID/GUID copy buttons, shown above the actions when on. */
	.psrs-card-audit { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem 0.8rem; margin-top: 0.7rem; padding-top: 0.55rem;
		border-top: 1px dashed var(--theme-color-border-light, #eef1f5); font-size: 0.7rem; line-height: 1.35; color: var(--theme-color-text-muted, #6b7686); }
	.psrs-card-audit-info { display: flex; flex-wrap: wrap; align-items: center; gap: 0.15rem 0.5rem; }
	.psrs-card-audit-info b { font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
	.psrs-card-audit-sep { opacity: 0.45; }
	.psrs-card-audit-copy { display: inline-flex; gap: 0.3rem; margin-left: auto; }
	.psrs-card-copy { display: inline-flex; align-items: center; gap: 0.2rem; cursor: pointer; font: inherit; font-size: 0.68rem; font-weight: 600;
		border: 1px solid var(--theme-color-border-light, #e1e6ec); border-radius: 6px; padding: 0.08rem 0.4rem;
		background: var(--theme-color-background-secondary, #f5f6f8); color: var(--theme-color-text-muted, #6b7686); }
	.psrs-card-copy:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
	.psrs-card-copy.psrs-card-copied { border-color: #2e9e5b; color: #2e9e5b; }
	.psrs-card-copy .pict-icon { font-size: 0.85em; }
	.psrs-card-audit-toggle { display: inline-flex; align-items: center; gap: 0.3rem; margin-left: auto; font-size: 0.74rem; font-weight: 600;
		color: var(--theme-color-text-muted, #6b7686); cursor: pointer; white-space: nowrap; }
	.psrs-card-audit-toggle input { cursor: pointer; margin: 0; }
	`,
	CSSPriority: 600,
};

/**
 * RecordSetCardManager — a global registry of "record preview cards". A card is a small, meaningful
 * view of one record plus links to its most important actions, defined entirely in CONFIGURATION per
 * recordset (no code). Any list, record view, or dashboard can drop a trigger (`{~RecordCard:~}` tag or
 * `triggerHTML()`); clicking it fetches the record (cached EntityProvider) and shows an anchored popover
 * card next to the trigger.
 *
 * Config shape (registered via settings.RecordCards or registerCard()):
 *   {
 *     Entity: 'Author',                              // Meadow entity to fetch (default: the recordset name)
 *     Title: 'Name',                                 // a field name OR a '{~...~}' template
 *     Subtitle: '{~D:Record.City~}, {~D:Record.Country~}',
 *     Image: 'PhotoURL',                             // optional image field/template
 *     Fields: [ { Label: 'Books', Value: 'BookCount' }, ... ],   // labeled values (field OR template)
 *     Template: '<custom markup with {~D:Record.X~}>',          // alternative to Fields (full control)
 *     Actions: [ { Label:'View', Icon:'Eye', Route:'#/PSRS/Author/View/{~D:Record.GUIDAuthor~}' },
 *                { Label:'Download', Icon:'Download', URL:'{~D:Record.FileURL~}' } ]   // Route | URL | Handler
 *   }
 */
class RecordSetCardManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// recordset name -> normalized card config
		this._cards = {};
		this._popoverElementID = 'PSRS-RecordCard-Popover';
		this._dismissBound = false;
		this._openForKey = null;

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('PSRS-RecordCard-CSS', this.options.CSS, this.options.CSSPriority);
		}
	}

	/**
	 * Register a card layout for a recordset. Pre-compiles the config into a pict template so render is a
	 * single parseTemplateByHash against the fetched record.
	 * @param {String} pRecordSetName
	 * @param {Object} pCardConfig
	 */
	registerCard(pRecordSetName, pCardConfig)
	{
		if (!pRecordSetName || !pCardConfig || (typeof pCardConfig !== 'object'))
		{
			this.log.warn(`RecordSetCardManager: ignoring invalid card config for [${pRecordSetName}].`);
			return;
		}
		const tmpConfig =
		{
			Entity: pCardConfig.Entity || pRecordSetName,
			IDField: pCardConfig.IDField || `ID${pRecordSetName}`,
			GUIDField: pCardConfig.GUIDField || `GUID${pCardConfig.Entity || pRecordSetName}`,
			TemplateHash: `PSRS-RecordCard-${pRecordSetName}`,
			Config: pCardConfig,
		};
		this._cards[pRecordSetName] = tmpConfig;
		this.pict.TemplateProvider.addTemplate(tmpConfig.TemplateHash, this._buildCardTemplate(pCardConfig));
	}

	hasCard(pRecordSetName)
	{
		return !!this._cards[pRecordSetName];
	}

	/** A config value is a field name unless it already contains a template expression. */
	_valueTemplate(pValue)
	{
		if (pValue == null) { return ''; }
		const tmpValue = String(pValue);
		return (tmpValue.indexOf('{~') !== -1) ? tmpValue : `{~D:Record.${tmpValue}~}`;
	}

	/** Compile a card config into a pict template string (resolved against the record at render time). */
	_buildCardTemplate(pConfig)
	{
		let tmpHead = '<div class="psrs-card-head">';
		if (pConfig.Image)
		{
			tmpHead += `<div class="psrs-card-img"><img src="${this._valueTemplate(pConfig.Image)}" alt="" /></div>`;
		}
		tmpHead += `<div><div class="psrs-card-title">${this._valueTemplate(pConfig.Title || `ID${''}`)}</div>`;
		if (pConfig.Subtitle)
		{
			tmpHead += `<div class="psrs-card-subtitle">${this._valueTemplate(pConfig.Subtitle)}</div>`;
		}
		tmpHead += '</div></div>';

		let tmpBody = '';
		if (pConfig.Template)
		{
			tmpBody = `<div class="psrs-card-custom">${pConfig.Template}</div>`;
		}
		else if (Array.isArray(pConfig.Fields) && (pConfig.Fields.length > 0))
		{
			tmpBody = '<div class="psrs-card-fields">';
			pConfig.Fields.forEach((pField) =>
			{
				tmpBody += `<span class="psrs-card-label">${pField.Label || ''}</span><span class="psrs-card-value">${this._valueTemplate(pField.Value)}</span>`;
			});
			tmpBody += '</div>';
		}

		let tmpActions = '';
		if (Array.isArray(pConfig.Actions) && (pConfig.Actions.length > 0))
		{
			tmpActions = '<div class="psrs-card-actions">';
			pConfig.Actions.forEach((pAction) =>
			{
				const tmpIcon = pAction.Icon ? `<span class="psrs-card-action-icon">{~I:${pAction.Icon}~}</span>` : '';
				const tmpLabel = `${tmpIcon}<span>${pAction.Label || 'Open'}</span>`;
				if (pAction.URL)
				{
					tmpActions += `<a class="psrs-card-action" href="${this._valueTemplate(pAction.URL)}" target="_blank" rel="noopener" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
				}
				else if (pAction.Route)
				{
					tmpActions += `<a class="psrs-card-action" href="${this._valueTemplate(pAction.Route)}" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
				}
				else if (pAction.Handler)
				{
					tmpActions += `<button type="button" class="psrs-card-action" onclick="_Pict.providers.RecordSetCardManager.closeCard(); ${pAction.Handler}">${tmpLabel}</button>`;
				}
			});
			tmpActions += '</div>';
		}

		return `<div class="psrs-card">${tmpHead}${tmpBody}${tmpActions}</div>`;
	}

	// --- Trigger HTML (used by the {~RecordCard:~} template tag and by callers directly) ---

	/**
	 * The clickable inline trigger: a label + a small preview icon. Degrades to plain text when no card is
	 * registered for the recordset.
	 * @param {String} pRecordSetName
	 * @param {String|Number} pID
	 * @param {String} pLabel
	 * @return {String}
	 */
	triggerHTML(pRecordSetName, pID, pLabel)
	{
		const tmpLabel = (pLabel == null) ? '' : String(pLabel);
		if (!this.hasCard(pRecordSetName) || pID == null || pID === '')
		{
			return tmpLabel;
		}
		const tmpIcon = (typeof this.pict.icon === 'function') ? this.pict.icon('Info', { ariaLabel: 'Preview' }) : '';
		const tmpSafeID = String(pID).replace(/'/g, '');
		return `<span class="psrs-card-trigger" onclick="event.stopPropagation();_Pict.providers.RecordSetCardManager.openCard('${pRecordSetName}','${tmpSafeID}',this)">`
			+ `<span class="psrs-card-trigger-label">${tmpLabel}</span><span class="psrs-card-trigger-icon">${tmpIcon}</span></span>`;
	}

	// --- Open / render / position ---

	/**
	 * Open the preview card for a record next to an anchor element. The record is fetched through the
	 * cached EntityProvider unless a full record object is passed.
	 * @param {String} pRecordSetName
	 * @param {String|Number|Object} pIDOrRecord
	 * @param {HTMLElement} pAnchorElement
	 */
	openCard(pRecordSetName, pIDOrRecord, pAnchorElement, pOptions)
	{
		const tmpOptions = pOptions || {};
		// A registered card, or a synthesized default card so any entity gets a preview (rich callers).
		let tmpCard = this._cards[pRecordSetName];
		if (!tmpCard) { tmpCard = this._defaultCard(pRecordSetName, tmpOptions); }
		if (!tmpCard) { return; }

		const tmpKeyID = (pIDOrRecord && (typeof pIDOrRecord === 'object'))
			? ((pIDOrRecord[tmpCard.IDField] != null) ? pIDOrRecord[tmpCard.IDField] : '')
			: pIDOrRecord;
		const tmpKey = `${pRecordSetName}:${tmpKeyID}`;
		if (this._openForKey === tmpKey && this._isOpen())
		{
			this.closeCard();
			return;
		}

		// The audit stripe + the "more data" body both need the FULL record (the explorer passes only the few
		// Lite columns). Only RICH cards render those, so only rich cards fetch — a normal recordset card keeps
		// its exact existing behavior (no extra fetch) even when the global audit toggle is on.
		const tmpWantFull = !!tmpOptions.Rich;
		if (pIDOrRecord && (typeof pIDOrRecord === 'object'))
		{
			const tmpID = pIDOrRecord[tmpCard.IDField];
			if (tmpWantFull && (tmpID != null) && this.pict.EntityProvider)
			{
				return this._fetchAndShow(tmpCard, tmpID, pAnchorElement, tmpKey, tmpOptions, pIDOrRecord);
			}
			return this._renderAndShow(tmpCard, pIDOrRecord, pAnchorElement, tmpKey, tmpOptions);
		}
		if (!this.pict.EntityProvider) { return; }
		return this._fetchAndShow(tmpCard, pIDOrRecord, pAnchorElement, tmpKey, tmpOptions, null);
	}

	/** Fetch the full record (and, when the audit stripe is on, its creating/updating user names) then show. */
	_fetchAndShow(pCard, pID, pAnchorElement, pKey, pOptions, pFallbackRecord)
	{
		this.pict.EntityProvider.getEntity(pCard.Entity, pID, (pError, pRecord) =>
		{
			const tmpRecord = (pError || !pRecord) ? pFallbackRecord : pRecord;
			if (!tmpRecord)
			{
				this.log.warn(`RecordSetCardManager: could not load ${pCard.Entity} ${pID} for its preview card.`, pError);
				return;
			}
			const fRender = () =>
			{
				if (this.getAuditEnabled())
				{
					return this._resolveAuditUsers(tmpRecord, () => this._renderAndShow(pCard, tmpRecord, pAnchorElement, pKey, pOptions));
				}
				return this._renderAndShow(pCard, tmpRecord, pAnchorElement, pKey, pOptions);
			};
			// Rich cards checkbox-render schema booleans → ensure the entity's (cached) schema first.
			if (pOptions && pOptions.Rich) { return this._ensureSchema(pCard.Entity, fRender); }
			return fRender();
		});
	}

	/**
	 * Resolve + cache the set of BOOLEAN columns for an entity (so rich cards show 0/1 bits as checkboxes).
	 * Uses the host-supplied `SchemaSource(entity, cb) -> (err, schema)` — meadow JSON-schema (`properties[].type`)
	 * or Stricture (`Columns[].DataType`). No source / fetch failure → no booleans (values render verbatim).
	 */
	_ensureSchema(pEntity, fComplete)
	{
		if (!this._schemaBooleans) { this._schemaBooleans = {}; }
		if (this._schemaBooleans[pEntity]) { return fComplete(); }
		if (typeof this.SchemaSource !== 'function') { this._schemaBooleans[pEntity] = {}; return fComplete(); }
		let tmpSettled = false;
		const fDone = (pSchema) =>
		{
			if (tmpSettled) { return; }
			tmpSettled = true;
			const tmpBooleans = {};
			if (pSchema && pSchema.properties)
			{
				Object.keys(pSchema.properties).forEach((pKey) => { if (pSchema.properties[pKey] && (pSchema.properties[pKey].type === 'boolean')) { tmpBooleans[pKey] = true; } });
			}
			else if (pSchema && Array.isArray(pSchema.Columns))
			{
				pSchema.Columns.forEach((pColumn) => { if (pColumn && (pColumn.DataType === 'Boolean')) { tmpBooleans[pColumn.Column] = true; } });
			}
			this._schemaBooleans[pEntity] = tmpBooleans;
			fComplete();
		};
		try { this.SchemaSource(pEntity, (pError, pSchema) => fDone(pError ? null : pSchema)); }
		catch (pError) { fDone(null); }
	}

	/** Synthesize a card for an entity that has none registered, so every record still gets a preview. */
	_defaultCard(pRecordSetName, pOptions)
	{
		const tmpEntityConfig = (pOptions && pOptions.EntityConfig) || {};
		const tmpEntity = tmpEntityConfig.Entity || pRecordSetName;
		return {
			Entity: tmpEntity,
			IDField: tmpEntityConfig.IDField || `ID${pRecordSetName}`,
			GUIDField: tmpEntityConfig.GUIDField || `GUID${tmpEntity}`,
			TemplateHash: null,   // no pre-compiled template — default cards always render the rich (dynamic) body
			Config: { _Default: true, Title: (tmpEntityConfig.Display && tmpEntityConfig.Display.Title) || null, Actions: [] },
		};
	}

	/** Resolve creating/updating user display names onto the record (cached lookups) before a sync render. */
	_resolveAuditUsers(pRecord, fComplete)
	{
		const tmpEntityProvider = this.pict.EntityProvider;
		if (!tmpEntityProvider || (typeof tmpEntityProvider.getEntity !== 'function')) { return fComplete(); }
		const tmpJobs = [];
		if (pRecord.CreatingIDUser) { tmpJobs.push({ Field: 'CreatingUserName', ID: pRecord.CreatingIDUser }); }
		if (pRecord.UpdatingIDUser) { tmpJobs.push({ Field: 'UpdatingUserName', ID: pRecord.UpdatingIDUser }); }
		if (tmpJobs.length < 1) { return fComplete(); }
		let tmpPending = tmpJobs.length;
		tmpJobs.forEach((pJob) =>
		{
			tmpEntityProvider.getEntity('User', pJob.ID, (pError, pUser) =>
			{
				if (!pError && pUser)
				{
					pRecord[pJob.Field] = [ pUser.NameFirst, pUser.NameLast ].filter((pPart) => (typeof pPart === 'string') && pPart.trim().length > 0).join(' ')
						|| pUser.FullName || pUser.Name || pUser.LoginID || `User ${pJob.ID}`;
				}
				tmpPending--;
				if (tmpPending <= 0) { fComplete(); }
			});
		});
	}

	_renderAndShow(pCard, pRecord, pAnchorElement, pKey, pOptions)
	{
		const tmpOptions = pOptions || {};
		// A default card (no pre-compiled template) or a rich caller renders the dynamic body (all columns +
		// audit stripe). Otherwise the existing pre-compiled card template renders verbatim (no behavior change).
		const tmpRich = !!tmpOptions.Rich || !pCard.TemplateHash;
		let tmpHTML = '';
		if (!tmpRich)
		{
			// Cards use synchronous template tags ({~D:~}, {~I:~}, formatters) so a sync parse is correct and
			// avoids a flash; the record is already in hand here.
			try { tmpHTML = this.pict.parseTemplateByHash(pCard.TemplateHash, pRecord); }
			catch (pError) { this.log.error(`RecordSetCardManager: card render failed for ${pCard.TemplateHash}.`, pError); return; }
		}
		else
		{
			tmpHTML = this._buildRichCardHTML(pCard, pRecord, tmpOptions);
		}
		const tmpPopover = this._ensurePopover();
		if (!tmpPopover) { return; }
		tmpPopover.innerHTML = tmpHTML;
		if (!tmpRich)
		{
			// Drop any field whose value rendered empty so a card never shows a "LABEL: (blank)" row — the
			// configured Fields are static, but which ones have data varies per record. (The rich body skips
			// empties as it builds, so this only applies to the pre-compiled path.)
			const tmpValueCells = tmpPopover.querySelectorAll('.psrs-card-fields .psrs-card-value');
			for (let i = 0; i < tmpValueCells.length; i++)
			{
				if (String(tmpValueCells[i].textContent || '').trim() !== '') { continue; }
				const tmpLabelCell = tmpValueCells[i].previousElementSibling;
				if (tmpLabelCell && tmpLabelCell.classList.contains('psrs-card-label')) { tmpLabelCell.remove(); }
				tmpValueCells[i].remove();
			}
			const tmpFieldsBox = tmpPopover.querySelector('.psrs-card-fields');
			if (tmpFieldsBox && (tmpFieldsBox.children.length === 0)) { tmpFieldsBox.remove(); }
		}
		this.pict.CSSMap.injectCSS();
		this._openForKey = pKey;
		this._lastShow = { Card: pCard, Record: pRecord, Anchor: pAnchorElement, Key: pKey, Options: tmpOptions };   // for the audit re-render
		this._position(tmpPopover, pAnchorElement);
		tmpPopover.classList.add('is-open');
		this._bindDismiss();
	}

	// --- Rich card body (all columns + audit stripe) + the audit/copy actions ---

	/** Build the dynamic card HTML: head + all meaningful columns + (when on) the audit stripe + actions. */
	_buildRichCardHTML(pCard, pRecord, pOptions)
	{
		const tmpConfig = pCard.Config || {};
		const tmpTitle = (tmpConfig.Title ? this._resolveText(tmpConfig.Title, pRecord) : '') || this._deriveTitle(pRecord, pCard);
		let tmpHead = `<div class="psrs-card-head"><div><div class="psrs-card-title">${this._escapeHTML(tmpTitle)}</div>`;
		const tmpSubtitle = tmpConfig.Subtitle ? this._resolveText(tmpConfig.Subtitle, pRecord) : '';
		if (tmpSubtitle) { tmpHead += `<div class="psrs-card-subtitle">${this._escapeHTML(tmpSubtitle)}</div>`; }
		tmpHead += '</div></div>';

		// Skip the field the title already shows, so the body doesn't repeat it as a "Name: …" row.
		let tmpSkipField = null;
		if (tmpConfig.Title && (String(tmpConfig.Title).indexOf('{~') < 0)) { tmpSkipField = tmpConfig.Title; }
		else if (!tmpConfig.Title && pRecord.Name) { tmpSkipField = 'Name'; }
		let tmpBody = '';
		const tmpBooleanFields = (this._schemaBooleans && this._schemaBooleans[pCard.Entity]) || {};
		const tmpFields = this._richFields(pRecord, tmpSkipField, tmpBooleanFields);
		if (tmpFields.length > 0)
		{
			tmpBody = '<div class="psrs-card-fields">';
			tmpFields.forEach((pField) =>
			{
				const tmpValueCell = pField.IsBoolean ? this._boolHTML(pField.BoolOn) : this._escapeHTML(pField.Value);
				tmpBody += `<span class="psrs-card-label">${this._escapeHTML(pField.Label)}</span><span class="psrs-card-value">${tmpValueCell}</span>`;
			});
			tmpBody += '</div>';
		}

		const tmpAudit = this.getAuditEnabled() ? this._auditStripeHTML(pCard, pRecord) : '';
		const tmpActions = this._richActionsHTML(tmpConfig, pRecord, pOptions);
		return `<div class="psrs-card">${tmpHead}${tmpBody}${tmpAudit}${tmpActions}</div>`;
	}

	/** Every real data column (skipping id/guid — surfaced via copy buttons — audit, nulls + objects). */
	_richFields(pRecord, pSkipField, pBooleanFields)
	{
		const tmpBooleans = pBooleanFields || {};
		const tmpFields = [];
		Object.keys(pRecord || {}).forEach((pKey) =>
		{
			if (pKey === pSkipField) { return; }
			if (/^(ID|GUID)/.test(pKey)) { return; }
			if (/^(CreateDate|UpdateDate|CreatingIDUser|UpdatingIDUser|DeletingIDUser|DeleteDate|Deleted|CreatingUserName|UpdatingUserName)$/.test(pKey)) { return; }
			const tmpValue = pRecord[pKey];
			if ((tmpValue == null) || (tmpValue === '') || (typeof tmpValue === 'object')) { return; }
			// Schema booleans render as a checkbox glyph, not their raw 0/1.
			if (tmpBooleans[pKey])
			{
				tmpFields.push({ Label: this._humanizeLabel(pKey), IsBoolean: true, BoolOn: ((tmpValue === 1) || (tmpValue === '1') || (tmpValue === true) || (String(tmpValue).toLowerCase() === 'true')) });
				return;
			}
			let tmpDisplay = String(tmpValue);
			// Hide values that are only null/undefined tokens (e.g. a "null null" address from concatenated
			// empty parts) — they shouldn't reach the user looking like broken software.
			if (/^(null|undefined|nan)(\s+(null|undefined|nan))*$/i.test(tmpDisplay.trim())) { return; }
			// Humanize ISO timestamps instead of dumping the raw `2026-06-21T05:47:01.000Z`.
			if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(tmpDisplay)) { tmpDisplay = this._fmtDate(tmpDisplay); }
			tmpFields.push({ Label: this._humanizeLabel(pKey), Value: tmpDisplay });
		});
		return tmpFields;
	}

	/** A checkbox glyph for a schema-boolean value — filled when on, an empty box when off. */
	_boolHTML(pOn)
	{
		const tmpCheck = (pOn && (typeof this.pict.icon === 'function')) ? this.pict.icon('Check') : '';
		return `<span class="psrs-card-bool${pOn ? ' psrs-card-bool-on' : ''}">${pOn ? tmpCheck : ''}</span>`;
	}

	/** The thin audit stripe: Created/Updated date + user, plus ID/GUID copy buttons (value shown on hover). */
	_auditStripeHTML(pCard, pRecord)
	{
		const tmpInfo = [];
		if (pRecord.CreateDate) { tmpInfo.push(`<span>Created <b>${this._escapeHTML(this._fmtDate(pRecord.CreateDate))}</b>${pRecord.CreatingUserName ? ` by <b>${this._escapeHTML(pRecord.CreatingUserName)}</b>` : ''}</span>`); }
		if (pRecord.UpdateDate) { tmpInfo.push(`<span>Updated <b>${this._escapeHTML(this._fmtDate(pRecord.UpdateDate))}</b>${pRecord.UpdatingUserName ? ` by <b>${this._escapeHTML(pRecord.UpdatingUserName)}</b>` : ''}</span>`); }
		const tmpIcon = (typeof this.pict.icon === 'function') ? this.pict.icon('Copy') : '';
		let tmpCopies = '';
		const tmpID = pRecord[pCard.IDField];
		const tmpGUID = pRecord[pCard.GUIDField];
		if ((tmpID != null) && (tmpID !== '')) { tmpCopies += this._copyButtonHTML('ID', tmpID, tmpIcon); }
		if (tmpGUID) { tmpCopies += this._copyButtonHTML('GUID', tmpGUID, tmpIcon); }
		if ((tmpInfo.length < 1) && !tmpCopies) { return ''; }
		return `<div class="psrs-card-audit"><div class="psrs-card-audit-info">${tmpInfo.join('<span class="psrs-card-audit-sep">·</span>')}</div>`
			+ `<div class="psrs-card-audit-copy">${tmpCopies}</div></div>`;
	}

	_copyButtonHTML(pLabel, pValue, pIcon)
	{
		const tmpValue = this._escapeAttribute(String(pValue));
		return `<button type="button" class="psrs-card-copy" title="${tmpValue}" data-copy="${tmpValue}" onclick="event.stopPropagation();_Pict.providers.RecordSetCardManager.copyValue(this.getAttribute('data-copy'),this)">${pIcon}<span>${this._escapeHTML(pLabel)}</span></button>`;
	}

	/** The card's configured actions (View, …) + the global Audit toggle pushed to the right. */
	_richActionsHTML(pConfig, pRecord, pOptions)
	{
		let tmpActions = '';
		(Array.isArray(pConfig.Actions) ? pConfig.Actions : []).forEach((pAction) => { tmpActions += this._actionHTML(pAction, pRecord); });
		const tmpAuditToggle = (pOptions && (pOptions.Audit === false)) ? ''
			: `<label class="psrs-card-audit-toggle"><input type="checkbox" ${this.getAuditEnabled() ? 'checked ' : ''}onclick="event.stopPropagation();_Pict.providers.RecordSetCardManager.toggleAudit()" /><span>Audit</span></label>`;
		if (!tmpActions && !tmpAuditToggle) { return ''; }
		return `<div class="psrs-card-actions">${tmpActions}${tmpAuditToggle}</div>`;
	}

	/** Build one action anchor/button, resolving its Route/URL template + icon against the record. */
	_actionHTML(pAction, pRecord)
	{
		const tmpIcon = (pAction.Icon && (typeof this.pict.icon === 'function')) ? this.pict.icon(pAction.Icon) : '';
		const tmpLabel = `${tmpIcon}<span>${this._escapeHTML(pAction.Label || 'Open')}</span>`;
		if (pAction.URL)
		{
			return `<a class="psrs-card-action" href="${this._escapeAttribute(this._resolveText(pAction.URL, pRecord))}" target="_blank" rel="noopener" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
		}
		if (pAction.Route)
		{
			return `<a class="psrs-card-action" href="${this._escapeAttribute(this._resolveText(pAction.Route, pRecord))}" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
		}
		if (pAction.Handler)
		{
			return `<button type="button" class="psrs-card-action" onclick="_Pict.providers.RecordSetCardManager.closeCard(); ${pAction.Handler}">${tmpLabel}</button>`;
		}
		return '';
	}

	/** Resolve a field-name-or-template config value against a record into a plain string. */
	_resolveText(pValue, pRecord)
	{
		try { return this.pict.parseTemplate(this._valueTemplate(pValue), pRecord); }
		catch (pError) { return ''; }
	}

	_deriveTitle(pRecord, pCard)
	{
		return pRecord.Name || pRecord.Title || pRecord.DisplayName
			|| `${pCard.Entity} #${(pRecord[pCard.IDField] != null) ? pRecord[pCard.IDField] : ''}`;
	}

	/** `MaterialCode` → `Material Code`, `mix_id` → `mix id`. */
	_humanizeLabel(pKey)
	{
		return String(pKey).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
	}

	/** Human-readable date — `Jun 21, 2026 05:47` (or `Jun 21, 2026` with no time) from an ISO string. */
	_fmtDate(pDate)
	{
		const tmpString = String((pDate == null) ? '' : pDate);
		const tmpMatch = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(tmpString);
		if (!tmpMatch) { return tmpString; }
		const tmpMonths = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
		const tmpMonth = tmpMonths[parseInt(tmpMatch[2], 10) - 1] || tmpMatch[2];
		let tmpResult = `${tmpMonth} ${parseInt(tmpMatch[3], 10)}, ${tmpMatch[1]}`;
		if (tmpMatch[4]) { tmpResult += ` ${tmpMatch[4]}:${tmpMatch[5]}`; }
		return tmpResult;
	}

	_escapeHTML(pValue)
	{
		return String((pValue == null) ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	_escapeAttribute(pValue)
	{
		return String((pValue == null) ? '' : pValue).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	// --- Audit toggle (global, persisted) + clipboard copy ---

	/** Whether the audit stripe is globally enabled (localStorage, with an in-memory fallback). */
	getAuditEnabled()
	{
		try
		{
			if (typeof window !== 'undefined' && window.localStorage) { return window.localStorage.getItem('RecordSetCardManager.AuditStripe') === 'true'; }
		}
		catch (pError) { /* fall through to the in-memory copy */ }
		return !!this._auditEnabled;
	}

	setAuditEnabled(pEnabled)
	{
		this._auditEnabled = !!pEnabled;
		try
		{
			if (typeof window !== 'undefined' && window.localStorage) { window.localStorage.setItem('RecordSetCardManager.AuditStripe', String(!!pEnabled)); }
		}
		catch (pError) { /* in-memory only */ }
	}

	/** Flip the global audit setting and repaint the open card so its stripe shows/hides immediately. */
	toggleAudit()
	{
		this.setAuditEnabled(!this.getAuditEnabled());
		if (!this._lastShow) { return; }
		const tmpLast = this._lastShow;
		if (this.getAuditEnabled())
		{
			return this._resolveAuditUsers(tmpLast.Record, () => this._renderAndShow(tmpLast.Card, tmpLast.Record, tmpLast.Anchor, tmpLast.Key, tmpLast.Options));
		}
		return this._renderAndShow(tmpLast.Card, tmpLast.Record, tmpLast.Anchor, tmpLast.Key, tmpLast.Options);
	}

	/** Copy a value (an ID / GUID) to the clipboard with a brief confirmation on the button. */
	copyValue(pValue, pButton)
	{
		try
		{
			if ((typeof navigator !== 'undefined') && navigator.clipboard && (typeof navigator.clipboard.writeText === 'function'))
			{
				navigator.clipboard.writeText(String((pValue == null) ? '' : pValue));
			}
		}
		catch (pError) { /* clipboard unavailable */ }
		if (pButton && pButton.classList)
		{
			pButton.classList.add('psrs-card-copied');
			setTimeout(() => { if (pButton.classList) { pButton.classList.remove('psrs-card-copied'); } }, 1100);
		}
	}

	_ensurePopover()
	{
		if (typeof document === 'undefined') { return null; }
		let tmpPopover = document.getElementById(this._popoverElementID);
		if (!tmpPopover)
		{
			tmpPopover = document.createElement('div');
			tmpPopover.id = this._popoverElementID;
			tmpPopover.className = 'psrs-card-popover';
			document.body.appendChild(tmpPopover);
		}
		return tmpPopover;
	}

	/** Anchor the popover under the trigger, flipping above / clamping horizontally near the viewport edge. */
	_position(pPopover, pAnchorElement)
	{
		if (!pAnchorElement || (typeof pAnchorElement.getBoundingClientRect !== 'function')) { return; }
		const tmpRect = pAnchorElement.getBoundingClientRect();
		// Measure with the card laid out but invisible.
		pPopover.style.top = '-9999px';
		pPopover.style.left = '0px';
		const tmpWidth = pPopover.offsetWidth;
		const tmpHeight = pPopover.offsetHeight;
		const tmpScrollX = window.scrollX || window.pageXOffset || 0;
		const tmpScrollY = window.scrollY || window.pageYOffset || 0;
		const tmpGap = 6;

		let tmpLeft = tmpRect.left + tmpScrollX;
		const tmpMaxLeft = tmpScrollX + window.innerWidth - tmpWidth - 8;
		if (tmpLeft > tmpMaxLeft) { tmpLeft = Math.max(tmpScrollX + 8, tmpMaxLeft); }

		let tmpTop = tmpRect.bottom + tmpScrollY + tmpGap;
		// Flip above when there's not enough room below.
		if ((tmpRect.bottom + tmpHeight + tmpGap > window.innerHeight) && (tmpRect.top - tmpHeight - tmpGap > 0))
		{
			tmpTop = tmpRect.top + tmpScrollY - tmpHeight - tmpGap;
		}
		// Clamp vertically so a tall (rich) card never runs off-screen — it scrolls internally past max-height.
		const tmpBottomLimit = tmpScrollY + window.innerHeight - 8;
		if (tmpTop + tmpHeight > tmpBottomLimit) { tmpTop = Math.max(tmpScrollY + 8, tmpBottomLimit - tmpHeight); }
		pPopover.style.left = `${Math.round(tmpLeft)}px`;
		pPopover.style.top = `${Math.round(tmpTop)}px`;
	}

	_isOpen()
	{
		const tmpPopover = (typeof document !== 'undefined') ? document.getElementById(this._popoverElementID) : null;
		return !!(tmpPopover && tmpPopover.classList.contains('is-open'));
	}

	closeCard()
	{
		const tmpPopover = (typeof document !== 'undefined') ? document.getElementById(this._popoverElementID) : null;
		if (tmpPopover) { tmpPopover.classList.remove('is-open'); }
		this._openForKey = null;
	}

	/**
	 * One-time document handlers that dismiss the card on an outside click or Escape. Browser-level events
	 * with no inline-handler equivalent — bound once, guarded so they never stack.
	 */
	_bindDismiss()
	{
		if (this._dismissBound || (typeof document === 'undefined')) { return; }
		this._dismissBound = true;
		document.addEventListener('click', (pEvent) =>
		{
			if (!this._isOpen()) { return; }
			const tmpPopover = document.getElementById(this._popoverElementID);
			if (tmpPopover && tmpPopover.contains(pEvent.target)) { return; }
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('.psrs-card-trigger')) { return; }
			this.closeCard();
		});
		document.addEventListener('keydown', (pEvent) =>
		{
			if ((pEvent.key === 'Escape') && this._isOpen()) { this.closeCard(); }
		});
	}
}

module.exports = RecordSetCardManager;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-provider":479}],615:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-DependentManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

/**
 * Registry + data layer for ONE-TO-MANY dependents: child entities that carry a foreign-key column
 * pointing back at a recordset's id (e.g. a `Sample` row with an `IDItem` column pointing at the `Item`
 * it belongs to). This is the one-to-many counterpart to the many-to-many `RecordSetAssociationManager`,
 * and it exists for reassociation-on-delete: when a duplicate parent record is deleted, its dependent
 * children are repointed to a replacement parent FIRST so they are never orphaned.
 *
 * Declared per recordset via `RecordSetDependents: [{ Entity, FKField, Title?, DisplayField?, SearchFields?,
 * ChildIDField?, URLPrefix? }]` and registered by the metacontroller. All reads/writes flow through the
 * shared, cached `pict.EntityProvider` (the same one associations + the recordset providers use).
 */
class PictRecordSetDependentManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.pict;

		/** @type {Record<string, Array<Record<string, any>>>} - Normalized dependents keyed by recordset name. */
		this.dependents = {};

		/** @type {Record<string, any>} - Lazily-created EntityProviders scoped to a non-default URL prefix. */
		this._scopedEntityProviders = {};

		/** @type {string} - EntityProvider cache scope for dependent-list reads; cleared after every repoint. */
		this._cacheScope = 'RecordSetDependent';
	}

	/**
	 * The EntityProvider for a URL prefix — the shared cached one for the default prefix, else a lazily
	 * created prefix-scoped instance (mirrors the association manager + recordset provider).
	 * @param {string} [pURLPrefix]
	 * @return {any}
	 */
	_entityProvider(pURLPrefix)
	{
		if (!pURLPrefix)
		{
			return this.pict.EntityProvider;
		}
		if (!this._scopedEntityProviders[pURLPrefix])
		{
			const tmpProvider = this.pict.instantiateServiceProviderWithoutRegistration('EntityProvider');
			tmpProvider.options.urlPrefix = pURLPrefix;
			this._scopedEntityProviders[pURLPrefix] = tmpProvider;
		}
		return this._scopedEntityProviders[pURLPrefix];
	}

	/**
	 * Invalidate the cached dependent-list reads after a write so a subsequent list reflects it immediately.
	 * @param {Record<string, any>} pEntityProvider
	 */
	_clearDependentCache(pEntityProvider)
	{
		try
		{
			if (pEntityProvider && (typeof pEntityProvider.clearScope === 'function'))
			{
				pEntityProvider.clearScope(this._cacheScope);
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`DependentManager: dependent cache clear failed: ${pError.message || pError}`);
		}
	}

	/**
	 * Normalize one dependent definition, filling the light-config defaults: `ChildIDField` falls back to
	 * `ID<Entity>`, `DisplayField` to `Name`, `SearchFields` to `[DisplayField]`, `Title` to `Entity`.
	 *
	 * @param {Record<string, any>} pDependent
	 * @return {Record<string, any>|false} The normalized dependent, or false when it is missing Entity/FKField.
	 */
	_normalizeDependent(pDependent)
	{
		if (!pDependent || !pDependent.Entity || !pDependent.FKField)
		{
			return false;
		}
		const tmpDisplayField = pDependent.DisplayField || 'Name';
		return {
			Entity: pDependent.Entity,
			// The column on the CHILD entity that references this recordset's id (e.g. Sample.IDItem).
			FKField: pDependent.FKField,
			// The child's own identity column, needed to address it on update. Defaults to ID<Entity>.
			ChildIDField: pDependent.ChildIDField || `ID${pDependent.Entity}`,
			DisplayField: tmpDisplayField,
			SearchFields: (Array.isArray(pDependent.SearchFields) && pDependent.SearchFields.length > 0) ? pDependent.SearchFields : [ tmpDisplayField ],
			Title: pDependent.Title || pDependent.Entity,
			URLPrefix: pDependent.URLPrefix || '',
		};
	}

	/**
	 * Register the one-to-many dependents for a recordset (replaces any previously registered set).
	 *
	 * @param {string} pRecordSetName
	 * @param {Array<Record<string, any>>} pDependents
	 * @return {Array<Record<string, any>>} The normalized, registered dependents.
	 */
	addDependents(pRecordSetName, pDependents)
	{
		if (!pRecordSetName || !Array.isArray(pDependents))
		{
			this.pict.log.error(`DependentManager: addDependents called with invalid arguments for [${pRecordSetName}].`, pDependents);
			return [];
		}
		const tmpNormalized = [];
		for (let i = 0; i < pDependents.length; i++)
		{
			const tmpDependent = this._normalizeDependent(pDependents[i]);
			if (!tmpDependent)
			{
				this.pict.log.error(`DependentManager: skipping invalid dependent (needs Entity + FKField) for [${pRecordSetName}].`, pDependents[i]);
				continue;
			}
			tmpNormalized.push(tmpDependent);
		}
		this.dependents[pRecordSetName] = tmpNormalized;
		return tmpNormalized;
	}

	/**
	 * The normalized dependents registered for a recordset (empty when none).
	 * @param {string} pRecordSetName
	 * @return {Array<Record<string, any>>}
	 */
	getDependentsForRecordSet(pRecordSetName)
	{
		return Array.isArray(this.dependents[pRecordSetName]) ? this.dependents[pRecordSetName] : [];
	}

	/**
	 * Fetch the child records currently pointing at an id through a dependent's FK column.
	 *
	 * @param {Record<string, any>} pDependent - a normalized dependent.
	 * @param {string|number} pParentID
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	listDependentRecords(pDependent, pParentID)
	{
		if (!pDependent || pParentID === undefined || pParentID === null || pParentID === '')
		{
			return Promise.resolve([]);
		}
		const tmpEntityProvider = this._entityProvider(pDependent.URLPrefix);
		const tmpFilter = `FBV~${pDependent.FKField}~EQ~${encodeURIComponent(pParentID)}`;
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySet(pDependent.Entity, tmpFilter, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`DependentManager: failed to list ${pDependent.Entity} for ${pDependent.FKField}=${pParentID}.`, pError);
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, '', { Scope: this._cacheScope, NoCount: true });
		});
	}

	/**
	 * Repoint every child of `pFromID` (through the dependent's FK column) to `pToID` — the one-to-many
	 * half of reassociation-on-delete. Each child gets a MINIMAL update (`{ childID, FKField: toID }`);
	 * this relies on Meadow-endpoints treating a partial body as a partial update, the same assumption the
	 * association manager's `updateJoin` makes. No dedup is needed — a foreign key simply repoints.
	 *
	 * @param {Record<string, any>} pDependent - a normalized dependent.
	 * @param {string|number} pFromID
	 * @param {string|number} pToID
	 * @return {Promise<{ repointed: number, failed: number }>}
	 */
	async repointDependent(pDependent, pFromID, pToID)
	{
		const tmpResult = { repointed: 0, failed: 0 };
		if (!pDependent || pFromID === undefined || pFromID === null || pFromID === '' || pToID === undefined || pToID === null || pToID === '')
		{
			return tmpResult;
		}
		// Self-repoint is a no-op (and a later delete of pFromID would then strand the children we "kept").
		if (String(pFromID) === String(pToID))
		{
			return tmpResult;
		}
		const tmpEntityProvider = this._entityProvider(pDependent.URLPrefix);
		const tmpChildren = await this.listDependentRecords(pDependent, pFromID);
		for (let i = 0; i < tmpChildren.length; i++)
		{
			const tmpChild = tmpChildren[i];
			const tmpUpdate = { [pDependent.ChildIDField]: tmpChild[pDependent.ChildIDField], [pDependent.FKField]: pToID };
			try
			{
				await new Promise((resolve, reject) =>
				{
					tmpEntityProvider.updateEntity(pDependent.Entity, tmpUpdate, (pError, pBody) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						// Meadow returns a non-2xx error in the body (not the callback) — surface it as a failure.
						if (pBody && pBody.ErrorCode)
						{
							return reject(new Error(`DependentManager: ${pDependent.Entity} update rejected (ErrorCode ${pBody.ErrorCode}).`));
						}
						return resolve(pBody);
					});
				});
				tmpResult.repointed++;
			}
			catch (pError)
			{
				tmpResult.failed++;
				this.pict.log.error(`DependentManager: repointDependent failed for ${pDependent.Entity}.${pDependent.FKField} (${pFromID} -> ${pToID}): ${pError.message || pError}`);
			}
		}
		this._clearDependentCache(tmpEntityProvider);
		return tmpResult;
	}
}

module.exports = PictRecordSetDependentManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],616:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Solver",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicSolver class is a provider that solves configuration-generated dynamic views.
 */
class RecordSetDynamicRecordsetSolver extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicSolver class.
	 *
	 * @param {object} pFable - The fable object.
	 * @param {object} pOptions - The options object.
	 * @param {object} pServiceHash - The service hash object.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & {
		 *		instantiateServiceProviderIfNotExists: (hash: string) => any,
		 *		ExpressionParser: any,
		 *		PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>
		 *	}} */
		this.pict;
		/** @type {import('pict') & { instantiateServiceProviderIfNotExists: (hash: string) => any, ExpressionParser: any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		// Initialize the solver service if it isn't up
		this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
	}

	/**
	 * Checks the solver and returns the solver object if it passes the checks.
	 *
	 * Automatically converts string solvers to have an Ordinal of 1.
	 *
	 * @param {string|object} pSolver - The solver to be checked. It can be either a string or an object.
	 * @param {boolean} [pFiltered=false] - Indicates whether the solvers should be filtered.
	 * @param {number} [pOrdinal] - The ordinal value to compare with the solver's ordinal value when filtered.
	 * @returns {object|undefined} - The solver object if it passes the checks, otherwise undefined.
	 */
	checkSolver(pSolver, pFiltered, pOrdinal)
	{
		let tmpSolver = pSolver;
		if (tmpSolver === undefined)
		{
			return;
		}
		if (typeof(tmpSolver) === 'string')
		{
			tmpSolver = {Expression:tmpSolver, Ordinal:1};
		}
		if (!('Expression' in tmpSolver))
		{
			this.log.error(`Dashboard solver ${pOrdinal} is missing the Expression property.`, { Solver: pSolver });
			return;
		}
		if (!(`Ordinal` in tmpSolver))
		{
			tmpSolver.Ordinal = 1;
		}

		// This filters the solvers
		if (pFiltered && (tmpSolver.Ordinal != pOrdinal))
		{
			return;
		}

		return tmpSolver;
	}

	/**
	 * Runs each RecordSet solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 * @param {array} pCellSolverArray - An array of Solvers from the groups to solve.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Array<Record<string, any>>} pRecords - The records to solve against.
	 */
	executeCellSolvers(pManifest, pCellSolverArray, pOrdinal, pRecords)
	{
		// This is purely for readability of the code below ... uglify optimizes it out.
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;

			// Solve the group RecordSet solvers first
		for (let j = 0; j < pCellSolverArray.length; j++)
		{
			let tmpSolver = this.checkSolver(pCellSolverArray[j].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `CellSolver-${j}`;

			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`Cell solving RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}

			const tmpRecords = Array.isArray(pRecords) ? pRecords : pRecords ? Object.values(pRecords) : [];
			for (let l = 0; l < tmpRecords.length; l++)
			{
				let tmpRecord = tmpRecords[l];
				tmpSolver.ResultsObject = {};
				const tmpSolverRecord = this.buildCellContextRecord(tmpRecord, pRecords, pManifest);
				let tmpSolutionValue = this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpSolverRecord, tmpSolver.ResultsObject,
					pManifest, tmpRecord);
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`Cell solver [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
				}
			}
			tmpSolver.EndTimeStamp = Date.now();
		}
	}

	/**
	 * @param {Record<string, any>} pRecord - The record to build the context for.
	 * @param {Array<Record<string, any>>} pRecords - The records to build the context from.
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 */
	buildCellContextRecord(pRecord, pRecords, pManifest)
	{
		return Object.assign({}, pRecord, this.buildGlobalContextRecord(pRecords, pManifest));
	}

	/**
	 * @param {Array<Record<string, any>>} pRecords - The records to build the context from.
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 */
	buildGlobalContextRecord(pRecords, pManifest)
	{
		return {
			Pict: this.pict,
			AppData: this.pict.AppData,
			Bundle: this.pict.Bundle,
			RecordSubset: pRecords,
			Manifest: pManifest,
		};
	}

	/**
	 * Executes the section solvers at a given ordinal (or all if no ordinal is passed).
	 *
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 * @param {Array} pGlobalSolverArray - The array of view section solvers.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Array<Record<string, any>>} pRecords - The records to solve against.
	 */
	executeDashboardSolvers(pManifest, pGlobalSolverArray, pOrdinal, pRecords)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;

		for (let i = 0; i < pGlobalSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pGlobalSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `DashboardSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`Dashboard solving equation ${i} ordinal ${tmpSolver.Ordinal}`);
			}
			tmpSolver.ResultsObject = {};
			const tmpRecord = this.buildGlobalContextRecord(pRecords, pManifest);
			let tmpSolutionValue = this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, pManifest, tmpRecord);
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`[${tmpSolver.Expression}] result was ${tmpSolutionValue}`);
			}
			tmpSolver.EndTimeStamp = Date.now();
		}
	}

	/**
	 * Checks if the given ordinal exists in the provided ordinal set.
	 *
	 * If not, it adds the ordinal to the set.
	 *
	 * @param {number} pOrdinal - The ordinal to check.
	 * @param {Object} pOrdinalSet - The ordinal set to check against.
	 * @returns {Object} - The ordinal object from the ordinal set.
	 */
	checkAutoSolveOrdinal(pOrdinal, pOrdinalSet)
	{
		if (!(pOrdinal.toString() in pOrdinalSet))
		{
			pOrdinalSet[pOrdinal.toString()] = { DashboardSolvers:[], CellSolvers:[] };
		}
		return pOrdinalSet[pOrdinal];
	}

	/**
	 * Solves the views based on the provided view hashes or all views in pict.
	 *
	 * If non-dynamic views are also passed in, they are solved as well.
	 *
	 * This algorithm is particularly complex because it solves views in
	 * order across two dimensions:
	 *
	 * 1. The order of the views in the view hash array.
	 * 2. Precedence order (based on Ordinal)
	 *
	 * The way it manages the precedence order solving is by enumerating the
	 * view hash array multiple times until it exhausts the solution set.
	 *
	 * In dynamic views, when there are collisions in precedence order between
	 * Section Solvers and Group RecordSet Solvers, it prefers the RecordSet
	 * solvers first.  The thinking behind this is that a RecordSet solver is
	 * a "tier down" from the core Section it resides within.  These are
	 * leaves on the tree.
	 *
	 * @param {Record<string, any>} pManifestDefinition
	 * @param {Array<Record<string, any>>} pRecords - The records to solve against.
	 */
	solveDashboard(pManifestDefinition, pRecords)
	{
		let tmpSolveOutcome = {};
		tmpSolveOutcome.StartTimeStamp = Date.now();

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		const tmpCellDefinitions = Object.values(pManifestDefinition.Descriptors);
		for (const tmpCell of tmpCellDefinitions)
		{
			if (!Array.isArray(tmpCell?.PictDashboard?.Solvers))
			{
				continue;
			}
			for (const tmpRawSolver of tmpCell.PictDashboard.Solvers)
			{
				if (tmpRawSolver)
				{
					const tmpSolver = this.checkSolver(tmpRawSolver, false);
					const tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
					tmpOrdinalContainer.CellSolvers.push({ CellHash: tmpCell.Hash, Solver:tmpSolver });
				}
			}
		}
		if (Array.isArray(pManifestDefinition.GlobalSolvers))
		{
			// Add the section solver(s)
			for (const tmpRawSolver of pManifestDefinition.GlobalSolvers)
			{
				if (tmpRawSolver)
				{
					const tmpSolver = this.checkSolver(tmpRawSolver, false);
					let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
					tmpOrdinalContainer.DashboardSolvers.push({ Solver: tmpSolver });
				}
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort();
		const tmpManifest = this.pict.PictSectionRecordSet.getManifest(pManifestDefinition.Scope);
		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicRecordsetSolver [${this.UUID}]::[${this.Hash}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			this.executeCellSolvers(tmpManifest, tmpOrdinalContainer.CellSolvers, Number(tmpOrdinalKeys[i]), pRecords);
			this.executeDashboardSolvers(tmpManifest, tmpOrdinalContainer.DashboardSolvers, Number(tmpOrdinalKeys[i]), pRecords);
		}

		tmpSolveOutcome.EndTimeStamp = Date.now();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastSolveOutcome = tmpSolveOutcome;
	}
}

module.exports = RecordSetDynamicRecordsetSolver;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],617:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-LinkManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictRecordSetLinkManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.pict;

		// An array of link templates with a hash, name template and uri template.
		// Format:
		// {
		//   Name: "View Record",
		//   URL: "#/PSRS/{~D:Record.Payload.RecordSet~}/View/{~DVBK:Record.Data:Record.Payload.GUIDAddress~}",
		//   Default: true
		// }
		this.linkTemplates = [];
	}

	/**
	 * TODO: Add the ability to add routes that are scoped to particular entity types
	 *
	 * @param {string} pNameTemplate - The name template for the record link.
	 * @param {string} pURLTemplate - The URL template for the record link.
	 * @param {boolean} pDefault - Whether this is a default link template.
	 *
	 * @return {Record<string, any>} - The link template object that was added.
	 */
	addRecordLinkTemplate(pNameTemplate, pURLTemplate, pDefault)
	{
		let tmpDefaultAction = (typeof(pDefault) !== 'undefined') ? pDefault : false;

		const tmpLinkTemplateObject = (
			{
				Name: pNameTemplate,
				URL: pURLTemplate,
				Default: tmpDefaultAction
			});

		this.linkTemplates.push(tmpLinkTemplateObject);

		return tmpLinkTemplateObject;
	}
}

module.exports = PictRecordSetLinkManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],618:[function(require,module,exports){

const libPictProvider = require('pict-provider');

/**
 * Default configuration for the RecordSetProvider provider.
 * @type {Record<string, any>}
 */
const _DefaultProviderConfiguration = {
	ProviderIdentifier: 'Pict-RecordSetProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 1, // initialize after other providers if initialized during app init
	AutoSolveWithApp: false,
};

/**
 * @typedef {Object} RecordSetSearchRangeFacet
 * @property {string} Field - The field to facet on. Only indexed fields can be faceted.
 * @property {any} Start - The start of the range. (ex. 1900)
 * @property {any} End - The end of the range. (ex. 2025)
 * @property {any} Gap - The gap between range values. (ex. 25)
 * TODO: Support auto-generating ranges based on the data at rest?
 */

/**
 * @typedef {Object} RecordSetSearchFacetPayload
 * @property {boolean} [ReturnRecords] - If false, search will return facets only, not records.
 * @property {Array<string>} Fields - Requests to facet on all unique values of the given fields.
 * @property {Array<RecordSetSearchRangeFacet>} Ranges - Requests to facet on given ranges of field values.
 * TODO: support facet on custom query?
 */

/**
 * @typedef {Object} RecordSetResult
 * @property {Array<Record<string, any>>} Records - The records returned from the provider.
 * @property {Record<string, Record<string, number>> & { ByRange?: Record<string, number> }} Facets - The facets returned from the provider.
 */

/**
 * @typedef {Object} RecordSetFilter
 * @property {string} [Entity] - The entity name. Can be used as an override to achieve LiteExtended, etc.
 * @property {string} [FilterString] - A meadow endpoint style filter to apply.
 * @property {number} [Offset] - The starting record number for pagination.
 * @property {number} [PageSize] - The starting record number for pagination.
 * @property {RecordSetSearchFacetPayload} [Facets] - The faceting config for the search.
 */

/**
 * Base record set provider.
 * @extends libPictProvider
 */
class RecordSetProviderBase extends libPictProvider
{
	/**
	 * Creates an instance of RecordSetProvider.
	 * @param {import('pict')} pFable - The Fable object.
	 * @param {Record<string, any>} [pOptions] - Custom options for the provider.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.fable;
		/** @type {import('pict')} */
		this.pict;

		/** @type {Record<string, any>} */
		this._FilterSchema = { };
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async getRecord(pIDOrGuid)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecord(${pIDOrGuid})`);
		return { };
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pGuid - The ID or GUID of the record.
	 */
	async getRecordByGUID(pGuid)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecordByGUID(${pGuid})`);
		return { };
	}

	/*
	get availableFilters()
	{
		return { IDBook: [ 'NumericMatch', 'NumericRange', 'ExternalJoinBookByAuthor' ], Title: [ 'StringMatch', 'StringRange' ] };
	}
	*/

	getGUIDField()
	{ 
		return `GUID${ this.options.Entity }`;
	}

	getIDField()
	{ 
		return `ID${ this.options.Entity }`;
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecords(pOptions)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecords(${JSON.stringify(pOptions)})`);
		return { Records: [], Facets: { } };
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 *
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getDecoratedRecords(pOptions)
	{
		const tmpRecords = await this.getRecords(pOptions);
		await this.decorateCoreRecords(tmpRecords.Records);
		return tmpRecords;
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {string} [pFilterString] - The filter string to apply.
	 * @param {number} [pOffset] - The starting record number for pagination.
	 * @param {number} [pPageSize] - The number of records to return.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecordsInline(pFilterString = '', pOffset = 0, pPageSize = 250)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecordsInline(${pFilterString}, ${pOffset}, ${pPageSize})`);
		return { Records: [], Facets: { } };
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 */
	async getRecordSetCount(pOptions)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecordSetCount(${JSON.stringify(pOptions)})`);
		return { Count: 0 };
	}

	/**
	 * Create a new record.
	 *
	 * @param {Record<string, any>} pRecord - The record to create.
	 * @return {Promise<Record<string, any>>} - The created record.
	 */
	async createRecord(pRecord)
	{
		this.pict.log.info(`RecordSetProviderBase.createRecord(${JSON.stringify(pRecord)})`);
		return pRecord;
	}

	/**
	 * Update a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to update.
	 * @return {Promise<Record<string, any>>} - The updated record.
	 */
	async updateRecord(pRecord)
	{
		this.pict.log.info(`RecordSetProviderBase.updateRecord(${JSON.stringify(pRecord)})`);
		return pRecord;
	}

	/**
	 * Delete a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to delete.
	 * @return {Promise<void>}
	 */
	async deleteRecord(pRecord)
	{
		this.pict.log.info(`RecordSetProviderBase.deleteRecord(${JSON.stringify(pRecord)})`);
	}

	/**
	 * Read a record.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async readRecord(pIDOrGuid)
	{
		this.pict.log.info(`RecordSetProviderBase.readRecord(${pIDOrGuid})`);
		return { };
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async readRecords(pOptions)
	{
		this.pict.log.info(`RecordSetProviderBase.readRecords(${JSON.stringify(pOptions)})`);
		return { Records: [], Facets: { } };
	}

	/**
	 * Clone a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clone.
	 * @return {Promise<Record<string, any>>} - The cloned record.
	 */
	async cloneRecord(pRecord)
	{
		return this.createRecord(this.cleanRecord(pRecord));
	}

	/**
	 * Remove any intrinsic identifiers from a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clean.
	 */
	cleanRecord(pRecord)
	{
		return pRecord;
	}

	/**
	 * @return {Record<string, any>} The schema of the record.
	 */
	get recordSchema()
	{
		return { };
	}

	/**
	 * Abstract decoration method for core records. Subclasses should implement this method to decorate records with additional information.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The records to decorate.
	 * @return {Promise<void>}
	 */
	async decorateCoreRecords(pRecords)
	{
	}

	/**
	 * @return {Promise<Record<string, any>>} The schema of the record.
	 */
	async getRecordSchema()
	{
		throw new Error(`getRecordSchema must be implemented in a sub-class`);
	}

	/**
	 * @return {Array<string>} The keys of the filter schema.
	 */
	getFilterSchemaKeys()
	{
		return Object.keys(this._FilterSchema);
	}

	/**
	 * @param {string} pFilterKey - The filter key to get the schema for.
	 *
	 * @return {Record<string, any>} The schema for the filter clause.
	 */
	getFilterClauseSchemaForKey(pFilterKey)
	{
		return this._FilterSchema?.[pFilterKey];
	}

	/**
	 * @return {Record<string, Record<string, any>>} The schema for the filter clauses.
	 */
	getFilterSchema()
	{
		//FIXME: risk here that the schema hasn't been loaded - but don't want to make this async...
		/** @type {Record<string, Record<string, any>>} */
		const tmpSchema = {};
		for (const tmpKey of this.getFilterSchemaKeys())
		{
			tmpSchema[tmpKey] = this.getFilterClauseSchemaForKey(tmpKey);
		}
		return tmpSchema;
	}

	/**
	 * @param {string} pFilterKey - The filter key to add the clause for.
	 * @param {string} pClauseKey - The clause key to add.
	 */
	addFilterClause(pFilterKey, pClauseKey)
	{
		let tmpClause = this.getFilterClauseSchemaForKey(pFilterKey)?.AvailableClauses?.find?.((c) => c.ClauseKey == pClauseKey);
		if (!tmpClause)
		{
			this.pict.log.error(`RecordSetProviderBase.addFilterClause() - No filter clause schema found for key ${pFilterKey} and clause ${pClauseKey}.`);
			return;
		}
		tmpClause = JSON.parse(JSON.stringify(tmpClause));
		tmpClause.Hash = `${pFilterKey}-${pClauseKey}-${this.pict.getUUID()}`;
		tmpClause.Label = tmpClause.Label || tmpClause.DisplayName;
		// Stamp the owning recordset so per-clause re-renders (which rebuild the render record
		// from the live clause alone) can still resolve their provider and remove control.
		if (!tmpClause.RecordSet && this.options.RecordSet)
		{
			tmpClause.RecordSet = this.options.RecordSet;
		}
		const tmpClauses = this.getFilterClauses();
		tmpClauses.push(tmpClause);
	}

	/**
	 */
	clearFilterClauses()
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			return;
		}
		tmpClauses.length = 0; // Clear the array
	}

	/**
	 * @param {string} pSpecificFilterClauseHash - The hash of the specific filter clause to remove.
	 */
	removeFilterClause(pSpecificFilterClauseHash)
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			this.pict.log.error('RecordSetProviderBase.removeFilterClause() - No filter clauses found.');
			return;
		}
		const tmpClauseIndex = tmpClauses.findIndex((c) => pSpecificFilterClauseHash == c.Hash);
		if (tmpClauseIndex < 0)
		{
			this.pict.log.error(`RecordSetProviderBase.removeFilterClause() - Filter clause with hash ${pSpecificFilterClauseHash} not found.`);
			return;
		}
		tmpClauses.splice(tmpClauseIndex, 1);
	}

	/**
	 * @return {Array<Record<string, any>>} The filter clauses.
	 */
	getFilterClauses()
	{
		let tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			tmpClauses = [];
			this.pict.Bundle._ActiveFilterState = this.pict.Bundle._ActiveFilterState || {};
			this.pict.Bundle._ActiveFilterState[this.options.RecordSet] = this.pict.Bundle._ActiveFilterState[this.options.RecordSet] || {};
			this.pict.Bundle._ActiveFilterState[this.options.RecordSet].FilterClauses = tmpClauses;
		}
		return tmpClauses;
	}

	// --- Quick Filters -----------------------------------------------------------------------------
	// A curated, one-interaction set of filters surfaced at the top of the drawer (fuzzy-search Title,
	// Created range, Created-by, …) so common filtering skips the "Add filter → pick field → pick type"
	// hunt. Each quick filter reuses a real clause descriptor from the field's AvailableClauses; its live
	// clause lives in the same FilterClauses array (tagged `QuickFilter:true`, keyed by `QuickFilterKey`)
	// so it serializes / applies / clears like any other clause — the drawer's clause list just skips it.

	/**
	 * Resolve the quick-filter definitions for this record set. Precedence: a `QuickFilters` array config
	 * (curated) → those; `QuickFilters: false` → none (explicit per-record-set opt-out); otherwise clever
	 * defaults derived from the schema — UNLESS `pAllowCleverDefaults` is false (the host put quick filters
	 * in opt-in-only mode, so a record set shows the bar only when it sets an explicit `QuickFilters`
	 * array). Each definition resolves to a concrete clause descriptor from the field's `AvailableClauses`.
	 *
	 * @param {boolean} [pAllowCleverDefaults] - false → no clever defaults (opt-in only). Default true.
	 * @return {Array<{Field:string, Label:string, Control:string, ClauseKey:string}>}
	 */
	getQuickFilterDefinitions(pAllowCleverDefaults)
	{
		const tmpConfig = this.options.QuickFilters;
		if (tmpConfig === false) { return []; }
		let tmpEntries;
		if (Array.isArray(tmpConfig)) { tmpEntries = tmpConfig; }
		else if (pAllowCleverDefaults === false) { tmpEntries = []; }
		else { tmpEntries = this._deriveDefaultQuickFilters(); }
		const tmpDefinitions = [];
		for (let i = 0; i < tmpEntries.length; i++)
		{
			const tmpEntry = (typeof tmpEntries[i] === 'string') ? { Field: tmpEntries[i] } : (tmpEntries[i] || {});
			const tmpDefinition = this._resolveQuickFilterDefinition(tmpEntry);
			if (tmpDefinition) { tmpDefinitions.push(tmpDefinition); }
		}
		this._seedRelativeDateDefaults(tmpDefinitions);
		return tmpDefinitions;
	}

	/**
	 * Seed a date-range quick filter to a trailing window on FIRST use.
	 *
	 * A clause can only hold literal bounds, so "default to the last year" cannot
	 * be stored as configuration — a date baked in when the dashboard was authored
	 * silently means "365 days before the day someone generated this", and rots.
	 * `DefaultRelativeDays: 365` on the clause descriptor instead resolves against
	 * TODAY, here, every time the bar is built.
	 *
	 * Seeds ONLY when the user has no value of their own: an explicit pick, a
	 * cleared filter, or a restored filter experience all win, because overriding
	 * those would make the control feel broken. That is also why it seeds the
	 * clause rather than forcing it on every render.
	 *
	 * @param {Array<Record<string, any>>} pDefinitions - Resolved quick-filter definitions.
	 * @private
	 */
	_seedRelativeDateDefaults(pDefinitions)
	{
		if (!Array.isArray(pDefinitions)) { return; }
		this._SeededRelativeDates = this._SeededRelativeDates || {};
		for (const tmpDefinition of pDefinitions)
		{
			if (tmpDefinition.Control !== 'daterange') { continue; }
			if (this._SeededRelativeDates[tmpDefinition.Field]) { continue; }
			const tmpSchema = this.getFilterClauseSchemaForKey(tmpDefinition.Field);
			const tmpClause = (tmpSchema && Array.isArray(tmpSchema.AvailableClauses))
				? tmpSchema.AvailableClauses.find((pClause) => pClause.ClauseKey === tmpDefinition.ClauseKey) : null;
			const tmpDays = tmpClause ? parseInt(tmpClause.DefaultRelativeDays, 10) : NaN;
			if (!(tmpDays > 0)) { continue; }
			// Mark it seeded BEFORE the bounds check: a user who clears the filter
			// must not have it re-seeded from under them on the next render.
			this._SeededRelativeDates[tmpDefinition.Field] = true;
			const tmpCurrent = this.getQuickFilterDateRangeValue(tmpDefinition.Field);
			if (tmpCurrent.Start || tmpCurrent.End) { continue; }
			const tmpStart = new Date();
			tmpStart.setDate(tmpStart.getDate() - tmpDays);
			this.upsertQuickFilterDateRange(tmpDefinition.Field, tmpDefinition.ClauseKey, 'start', tmpStart.toISOString().slice(0, 10));
		}
	}

	/**
	 * Clever defaults (zero config): the common things people filter on, detected by canonical Meadow
	 * column names on the fetched schema. Primary text (Title→Name), the audit date ranges, the audit
	 * user references. Absent `_Schema` (non-Meadow provider) → no defaults.
	 *
	 * @return {Array<{Field:string, Label?:string}>}
	 */
	_deriveDefaultQuickFilters()
	{
		const tmpProperties = (this._Schema && this._Schema.properties) || null;
		if (!tmpProperties) { return []; }
		const fHas = (pField) => Object.prototype.hasOwnProperty.call(tmpProperties, pField);
		const tmpDefaults = [];
		// `RequireControl` pins a default to its intended control: a "Created" default is only useful as
		// a date range, a "Created by" only as an entity picker. If the field can't offer that (e.g. a
		// schema that types its dates as plain strings), the default is dropped rather than degrading to
		// an odd text-search-a-timestamp. Host-configured QuickFilters carry no RequireControl, so they
		// take whatever clause the field offers.
		if (fHas('Title')) { tmpDefaults.push({ Field: 'Title' }); }
		else if (fHas('Name')) { tmpDefaults.push({ Field: 'Name' }); }
		if (fHas('CreateDate')) { tmpDefaults.push({ Field: 'CreateDate', Label: 'Created', RequireControl: 'daterange' }); }
		if (fHas('UpdateDate')) { tmpDefaults.push({ Field: 'UpdateDate', Label: 'Updated', RequireControl: 'daterange' }); }
		if (fHas('CreatingIDUser')) { tmpDefaults.push({ Field: 'CreatingIDUser', Label: 'Created by', RequireControl: 'entity' }); }
		if (fHas('UpdatingIDUser')) { tmpDefaults.push({ Field: 'UpdatingIDUser', Label: 'Updated by', RequireControl: 'entity' }); }
		return tmpDefaults;
	}

	/**
	 * Resolve one quick-filter config entry to a renderable definition: pick the clause (explicit
	 * `ClauseKey`, else the best for a quick filter) from the field's AvailableClauses + classify it to a
	 * control type. Returns null when the field has no usable clause.
	 *
	 * @param {Record<string, any>} pEntry @return {{Field:string, Label:string, Control:string, ClauseKey:string}|null}
	 */
	_resolveQuickFilterDefinition(pEntry)
	{
		if (!pEntry || !pEntry.Field) { return null; }
		const tmpFieldSchema = this.getFilterClauseSchemaForKey(pEntry.Field);
		const tmpAvailableClauses = tmpFieldSchema && Array.isArray(tmpFieldSchema.AvailableClauses) ? tmpFieldSchema.AvailableClauses : null;
		if (!tmpAvailableClauses || tmpAvailableClauses.length < 1) { return null; }
		const tmpClause = pEntry.ClauseKey
			? tmpAvailableClauses.find((pClause) => pClause.ClauseKey === pEntry.ClauseKey)
			: this._pickQuickClause(tmpAvailableClauses);
		if (!tmpClause) { return null; }
		const tmpControl = this._controlForClauseType(tmpClause.Type);
		if (!tmpControl) { return null; }
		// A default that demands a specific control (e.g. date range) is dropped when the field can't offer it.
		if (pEntry.RequireControl && tmpControl !== pEntry.RequireControl) { return null; }
		return {
			Field: pEntry.Field,
			Label: pEntry.Label || tmpFieldSchema.DisplayName || pEntry.Field,
			Control: tmpControl,
			ClauseKey: tmpClause.ClauseKey,
		};
	}

	/**
	 * Choose the clause a quick filter should drive for a field: an entity selected-value, else a fuzzy
	 * string match, else a range — i.e. the simplest one-interaction clause the field offers.
	 *
	 * @param {Array<Record<string, any>>} pAvailableClauses @return {Record<string, any>|undefined}
	 */
	_pickQuickClause(pAvailableClauses)
	{
		return pAvailableClauses.find((pClause) => pClause.Type === 'DistinctSelectedValueList')
			|| pAvailableClauses.find((pClause) => pClause.Type === 'InternalJoinSelectedValue' || pClause.Type === 'InternalJoinSelectedValueList')
			|| pAvailableClauses.find((pClause) => pClause.Type === 'StringMatch' && pClause.ExactMatch === false)
			|| pAvailableClauses.find((pClause) => pClause.Type === 'DateRange')
			|| pAvailableClauses.find((pClause) => pClause.Type === 'NumericRange')
			|| pAvailableClauses[0];
	}

	/**
	 * Map a clause Type to the quick-bar control that drives it.
	 * @param {string} pType @return {string|null}
	 */
	_controlForClauseType(pType)
	{
		switch (pType)
		{
			case 'StringMatch': return 'text';
			case 'DateRange': return 'daterange';
			case 'DistinctSelectedValueList': return 'distinct';
			case 'InternalJoinSelectedValue':
			case 'InternalJoinSelectedValueList': return 'entity';
			default: return null;
		}
	}

	/**
	 * The entity's soft-delete column name. Subclasses with schema access override this
	 * (the Meadow provider resolves the column whose Type is 'Deleted').
	 * @return {string}
	 */
	getDeletedField()
	{
		return 'Deleted';
	}

	/** @return {boolean} Whether the show-deleted clause is currently active for this record set. */
	getShowDeletedFilterValue()
	{
		return this.getFilterClauses().some((pClause) => pClause.ShowDeletedKey === 'ShowDeleted');
	}

	/**
	 * Toggle the show-deleted clause: a RawFilter stanza that references the Deleted column
	 * explicitly, which suppresses the automatic `Deleted = 0` delete tracking so soft-deleted
	 * rows enumerate. It is a real clause in the active filter state, so it serializes into the
	 * filter experience (and the route URL) and clears with Clear like any other clause. The
	 * clause list UI skips it (no filter view for RawFilter) — the drawer checkbox is its face.
	 *
	 * @param {boolean} pOn - Whether deleted records should be included.
	 * @return {boolean} The resulting state.
	 */
	setShowDeletedFilterValue(pOn)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpIndex = tmpClauses.findIndex((pClause) => pClause.ShowDeletedKey === 'ShowDeleted');
		if (pOn === true)
		{
			if (tmpIndex < 0)
			{
				tmpClauses.push(
					{
						Type: 'RawFilter',
						ShowDeletedKey: 'ShowDeleted',
						Label: 'Show deleted',
						Value: `FBL~${this.getDeletedField()}~INN~0,1`,
					});
			}
			return true;
		}
		if (tmpIndex >= 0)
		{
			tmpClauses.splice(tmpIndex, 1);
		}
		return false;
	}

	/** @param {string} pField @return {any} The current value of a field's quick-filter clause, or ''. */
	getQuickFilterClauseValue(pField)
	{
		const tmpClause = this.getFilterClauses().find((pClause) => pClause.QuickFilterKey === `Quick-${pField}`);
		return tmpClause ? tmpClause.Value : '';
	}

	/**
	 * Upsert (or, when the value is empty, remove) a field's quick-filter clause with a scalar value.
	 * Creates the clause from the field's descriptor on first use, tagged so it renders in the quick bar
	 * and serializes/applies like any clause.
	 *
	 * @param {string} pField @param {string} pClauseKey @param {any} pValue
	 */
	upsertQuickFilterClauseValue(pField, pClauseKey, pValue)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpQuickFilterKey = `Quick-${pField}`;
		const tmpExistingIndex = tmpClauses.findIndex((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
		const tmpEmpty = (pValue === undefined || pValue === null || pValue === '');
		if (tmpEmpty)
		{
			if (tmpExistingIndex >= 0) { tmpClauses.splice(tmpExistingIndex, 1); }
			return;
		}
		if (tmpExistingIndex >= 0)
		{
			tmpClauses[tmpExistingIndex].Value = pValue;
			return;
		}
		const tmpClause = this._createQuickFilterClause(pField, pClauseKey, tmpQuickFilterKey);
		if (!tmpClause) { return; }
		tmpClause.Value = pValue;
		tmpClauses.push(tmpClause);
	}

	/** @param {string} pField @return {{Start:any, End:any}} The current DateRange quick-filter bounds. */
	getQuickFilterDateRangeValue(pField)
	{
		const tmpClause = this.getFilterClauses().find((pClause) => pClause.QuickFilterKey === `Quick-${pField}`);
		const tmpValues = (tmpClause && tmpClause.Values && typeof tmpClause.Values === 'object' && !Array.isArray(tmpClause.Values)) ? tmpClause.Values : {};
		return { Start: tmpValues.Start || '', End: tmpValues.End || '' };
	}

	/**
	 * Set one bound of a field's DateRange quick-filter clause (create on first use, remove when BOTH
	 * bounds are empty). Bounds live at `clause.Values.Start` / `.End` (the DateRange contract).
	 *
	 * @param {string} pField @param {string} pClauseKey @param {'start'|'end'} pWhich @param {any} pValue
	 */
	upsertQuickFilterDateRange(pField, pClauseKey, pWhich, pValue)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpQuickFilterKey = `Quick-${pField}`;
		let tmpClause = tmpClauses.find((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
		const tmpValue = (pValue === undefined || pValue === null) ? '' : pValue;
		if (!tmpClause)
		{
			if (tmpValue === '') { return; }
			tmpClause = this._createQuickFilterClause(pField, pClauseKey, tmpQuickFilterKey);
			if (!tmpClause) { return; }
			tmpClause.Values = {};
			tmpClauses.push(tmpClause);
		}
		if (!tmpClause.Values || typeof tmpClause.Values !== 'object' || Array.isArray(tmpClause.Values)) { tmpClause.Values = {}; }
		// Case-INSENSITIVE on purpose. This was `pWhich === 'start'`, so a caller
		// passing 'Start' fell through to the else and wrote the END bound -- which
		// inverts the filter: a "last 365 days" default became "everything before
		// 365 days ago". Nothing about the parameter says it is case-sensitive, so
		// the comparison is forgiving rather than the callers being careful.
		if (String(pWhich).toLowerCase() === 'start') { tmpClause.Values.Start = tmpValue; }
		else { tmpClause.Values.End = tmpValue; }
		const fEmpty = (pVal) => (pVal === undefined || pVal === null || pVal === '');
		if (fEmpty(tmpClause.Values.Start) && fEmpty(tmpClause.Values.End))
		{
			const tmpIndex = tmpClauses.findIndex((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
			if (tmpIndex >= 0) { tmpClauses.splice(tmpIndex, 1); }
		}
	}

	/** @param {string} pField @return {Array<any>} The current entity quick-filter selected value(s). */
	getQuickFilterEntityValue(pField)
	{
		const tmpClause = this.getFilterClauses().find((pClause) => pClause.QuickFilterKey === `Quick-${pField}`);
		return (tmpClause && Array.isArray(tmpClause.Values)) ? tmpClause.Values : [];
	}

	/**
	 * Set a field's entity quick-filter clause to the picked value(s) (create on first use, remove when
	 * empty). Selected ids live at `clause.Values` (the entity-reference contract).
	 *
	 * @param {string} pField @param {string} pClauseKey @param {any} pValue scalar or array
	 */
	upsertQuickFilterEntity(pField, pClauseKey, pValue)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpQuickFilterKey = `Quick-${pField}`;
		const tmpArray = (Array.isArray(pValue) ? pValue : ((pValue === undefined || pValue === null || pValue === '') ? [] : [ pValue ]))
			.filter((pVal) => pVal !== undefined && pVal !== null && pVal !== '');
		const tmpIndex = tmpClauses.findIndex((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
		if (tmpArray.length === 0)
		{
			if (tmpIndex >= 0) { tmpClauses.splice(tmpIndex, 1); }
			return;
		}
		if (tmpIndex >= 0) { tmpClauses[tmpIndex].Values = tmpArray; return; }
		const tmpClause = this._createQuickFilterClause(pField, pClauseKey, tmpQuickFilterKey);
		if (!tmpClause) { return; }
		tmpClause.Values = tmpArray;
		tmpClauses.push(tmpClause);
	}

	/**
	 * Clone a field's clause descriptor into a fresh, tagged quick-filter clause (no value set yet), or
	 * null when the descriptor is missing. Shared by the text / date / entity upserts.
	 *
	 * @param {string} pField @param {string} pClauseKey @param {string} pQuickFilterKey
	 * @return {Record<string, any>|null}
	 */
	_createQuickFilterClause(pField, pClauseKey, pQuickFilterKey)
	{
		const tmpDescriptor = this.getFilterClauseSchemaForKey(pField)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pClauseKey);
		if (!tmpDescriptor)
		{
			this.pict.log.error(`RecordSetProviderBase quick filter: no clause schema for field ${pField} / clause ${pClauseKey}.`);
			return null;
		}
		const tmpClause = JSON.parse(JSON.stringify(tmpDescriptor));
		tmpClause.Hash = `${pField}-${pClauseKey}-${this.pict.getUUID()}`;
		tmpClause.Label = tmpClause.Label || tmpClause.DisplayName;
		tmpClause.QuickFilter = true;
		tmpClause.QuickFilterKey = pQuickFilterKey;
		if (!tmpClause.RecordSet && this.options.RecordSet)
		{
			tmpClause.RecordSet = this.options.RecordSet;
		}
		return tmpClause;
	}

	/**
	 * @param {string} pSpecificFilterClauseHash - The hash of the specific filter clause to move.
	 * @param {number} pOrdinal - The ordinal position to move the filter clause to.
	 */
	moveFilterClauseTo(pSpecificFilterClauseHash, pOrdinal)
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			this.pict.log.error('RecordSetProviderBase.moveFilterClauseTo() - No filter clauses found.');
			return;
		}
		if (pOrdinal < 0 || pOrdinal >= tmpClauses.length)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseTo() - Invalid ordinal ${pOrdinal}.`);
			return;
		}
		const tmpClauseIndex = tmpClauses.indexOf((c) => pSpecificFilterClauseHash == c.Hash);
		if (tmpClauseIndex < 0)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseTo() - Filter clause with hash ${pSpecificFilterClauseHash} not found.`);
			return;
		}
		const tmpClause = tmpClauses.splice(tmpClauseIndex, 1)[0];
		tmpClauses.splice(pOrdinal, 0, tmpClause);
	}

	/**
	 * @param {string} pSpecificFilterClauseHash - The hash of the specific filter clause to move.
	 * @param {number} pOrdinalOffset - The ordinal offset to move the filter clause by.
	 */
	moveFilterClauseBy(pSpecificFilterClauseHash, pOrdinalOffset)
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			this.pict.log.error('RecordSetProviderBase.moveFilterClauseBy() - No filter clauses found.');
			return;
		}
		const tmpClauseIndex = tmpClauses.indexOf((c) => pSpecificFilterClauseHash == c.Hash);
		if (tmpClauseIndex < 0)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseBy() - Filter clause with hash ${pSpecificFilterClauseHash} not found.`);
			return;
		}
		const tmpNewOrdinal = tmpClauseIndex + pOrdinalOffset;
		if (tmpNewOrdinal < 0 || tmpNewOrdinal >= tmpClauses.length)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseBy() - Invalid new ordinal ${tmpNewOrdinal} (offset of ${pOrdinalOffset} for original ordinal ${tmpClauseIndex}).`);
			return;
		}
		const tmpClause = tmpClauses.splice(tmpClauseIndex, 1)[0];
		tmpClauses.splice(tmpNewOrdinal, 0, tmpClause);
	}
}

module.exports = RecordSetProviderBase;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":479}],619:[function(require,module,exports){

const libRecordSetProviderBase = require('./RecordSet-RecordProvider-Base.js');

/**
 * @typedef {import('./RecordSet-RecordProvider-Base.js').RecordSetFilter} RecordSetFilter
 * @typedef {import('./RecordSet-RecordProvider-Base.js').RecordSetResult} RecordSetResult
 */

/**
 * Class representing a data change detection provider for Pict dynamic forms.
 * @extends libRecordSetProviderBase
 */
class MeadowEndpointsRecordSetProvider extends libRecordSetProviderBase
{
	/**
	 * Creates an instance of RecordSetProvider.
	 * @param {import('pict')} pFable - The Fable object.
	 * @param {Record<string, any>} [pOptions] - Custom options for the provider.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict') & {
		 *      log: any,
		 *      services:
		 *      {
		 *			PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>,
		 *			[key: string]: any,
		 *		},
		 *      instantiateServiceProviderWithoutRegistration: (hash: String) => any,
		 *      PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>
		 *  }} */
		this.pict;
		this.fable = this.pict;
		/** @type {string} */
		this.Hash;
		/** @type {string} */
		this.UUID;
		//TODO: make this typedef better
		/** @type {Record<string, any>} */
		this._Schema;
		/**
		 * Single-flight handle for the deferred `<Entity>/Schema` load, so the
		 * background load kicked off at initialization and any on-demand
		 * `getRecordSchema()` share one network round-trip (and one filter-schema
		 * build). Null when idle / not yet loaded.
		 * @type {Promise<Record<string, any> | null> | null}
		 */
		this._SchemaInitPromise = null;
		/** @type {Record<string, Record<string, any>>} */
		this._Experiences = { };
		/** @type {Record<string, Record<string, any>>} */
		this._FiltersByField = { };
	}

	/** @return {import('pict/types/source/Pict-Meadow-EntityProvider.js')} */
	get entityProvider()
	{
		if (!this._EntityProvider)
		{
			/** @type {import('pict/types/source/Pict-Meadow-EntityProvider.js')} */
			//TODO: figure out a pattern to share this with other consumers, to consolidate cache
			this._EntityProvider = this.pict.instantiateServiceProviderWithoutRegistration('EntityProvider');
			if (this.options.URLPrefix)
			{
				this._EntityProvider.options.urlPrefix = this.options.URLPrefix;
			}
		}

		return this._EntityProvider;
	}

	/**
	 * Fetch (and cache) the DISTINCT values of a column present in this recordset's data, via
	 * Meadow's `<Entity>s/Distinct/<Column>` endpoint. Drives the `ScopeToRecordSet` filter knob
	 * (an entity picker limited to `FBL~<Column>~INN~<these values>`) and the
	 * `DistinctSelectedValueList` filter type (a dropdown whose options ARE these values).
	 * Cached per column; the cache is cleared on create/update/delete through this provider.
	 *
	 * @param {string} pColumn
	 * @param {{ Filter?: string } | ((pError: Error|null, pValues: Array<any>) => void)} [pOptions] - Optional; `Filter` is a FoxHound stanza appended as `/FilteredTo/<Filter>` on the distinct query.
	 * @param {(pError: Error|null, pValues: Array<any>) => void} [fCallback]
	 */
	getRecordSetColumnDistinct(pColumn, pOptions, fCallback)
	{
		// Back-compat: (pColumn, fCallback)
		let tmpOptions = pOptions;
		let tmpCallback = fCallback;
		if (typeof tmpOptions === 'function')
		{
			tmpCallback = tmpOptions;
			tmpOptions = {};
		}
		tmpOptions = tmpOptions || {};
		// Unfiltered fetches keep the bare-column key (synchronous peeks elsewhere read it);
		// filtered fetches get their own key so the two never cross-pollinate.
		const tmpCacheKey = tmpOptions.Filter ? `${pColumn}::${tmpOptions.Filter}` : pColumn;
		this._scopeDistinctCache = this._scopeDistinctCache || {};
		if (Array.isArray(this._scopeDistinctCache[tmpCacheKey]))
		{
			return tmpCallback(null, this._scopeDistinctCache[tmpCacheKey]);
		}
		if (!this.options.Entity || !this.entityProvider || !this.entityProvider.restClient)
		{
			return tmpCallback(new Error('RecordSet provider cannot resolve a distinct request (missing Entity or rest client).'), []);
		}
		// De-duplicate CONCURRENT fetches for the same key. The cache above is only
		// written when a response lands, so callers that re-check it while a request
		// is still in flight all miss and each issue their own identical request.
		// The quick-filter views remount on every render epoch and re-check exactly
		// that way, so one filter apply fanned out into a dozen duplicate distinct
		// queries -- the bulk of the delay between clicking Apply and seeing rows.
		// Queue the extra callbacks against the outstanding request instead.
		this._scopeDistinctInFlight = this._scopeDistinctInFlight || {};
		if (Array.isArray(this._scopeDistinctInFlight[tmpCacheKey]))
		{
			this._scopeDistinctInFlight[tmpCacheKey].push(tmpCallback);
			return;
		}
		this._scopeDistinctInFlight[tmpCacheKey] = [];
		const tmpURL = `${this.options.URLPrefix || ''}${this.options.Entity}s/Distinct/${pColumn}${tmpOptions.Filter ? `/FilteredTo/${tmpOptions.Filter}` : ''}`;
		const tmpEntityProvider = this.entityProvider;
		/**
		 * Settle this key: cache the outcome, then notify the caller that issued the
		 * request plus everyone who asked for the same key while it was in flight.
		 *
		 * @param {Error|null} pSettleError
		 * @param {Array<any>} pValues
		 */
		const fSettleDistinct = (pSettleError, pValues) =>
		{
			// A create/update/delete may have reset the cache while this was in
			// flight; re-seat it rather than throwing on a null.
			this._scopeDistinctCache = this._scopeDistinctCache || {};
			this._scopeDistinctCache[tmpCacheKey] = pValues;
			const tmpWaiting = (this._scopeDistinctInFlight || {})[tmpCacheKey] || [];
			if (this._scopeDistinctInFlight) { delete this._scopeDistinctInFlight[tmpCacheKey]; }
			tmpCallback(pSettleError, pValues);
			for (let i = 0; i < tmpWaiting.length; i++)
			{
				tmpWaiting[i](pSettleError, pValues);
			}
		};
		const fHandleDistinctResult = (pError, pResponse, pBody) =>
		{
			if (pError || (pResponse && pResponse.statusCode > 299) || !Array.isArray(pBody))
			{
				this.pict.log.warn(`RecordSet [${this.options.RecordSet || this.options.Entity}] distinct fetch for [${pColumn}] failed; the scoped filter falls back to unscoped.`, { Error: pError && pError.message, URL: tmpURL });
				return fSettleDistinct(pError || new Error('distinct fetch returned a non-array'), []);
			}
			const tmpValues = [ ...new Set(pBody.map((pRecord) => pRecord && pRecord[pColumn]).filter((pValue) => pValue != null)) ];
			return fSettleDistinct(null, tmpValues);
		};
		// Route through POST /:Entity/Query (Distinct mode) when the endpoint
		// supports it — a long /FilteredTo/ stanza on the Distinct GET is the same
		// URI-length hazard the Query route exists to sidestep. Falls back to GET.
		const fResolveSupport = (typeof tmpEntityProvider.resolveEntityQuerySupport === 'function')
			? tmpEntityProvider.resolveEntityQuerySupport.bind(tmpEntityProvider)
			: (pEntity, pPrefix, fCb) => { return fCb(null, false); };
		fResolveSupport(this.options.Entity, this.options.URLPrefix, (pSupportError, pSupportsQuery) =>
		{
			if (pSupportsQuery)
			{
				const tmpBody = { Distinct: true, Columns: pColumn };
				if (tmpOptions.Filter)
				{
					tmpBody.Filter = tmpOptions.Filter;
				}
				return tmpEntityProvider.restClient.postJSON({ url: `${this.options.URLPrefix || ''}${this.options.Entity}s/Query`, body: tmpBody }, fHandleDistinctResult);
			}
			return tmpEntityProvider.restClient.getJSON(tmpURL, fHandleDistinctResult);
		});
	}

	/**
	 * @return {Array<string>} - The fields to ignore for filter availability.
	 */
	get ignoreFilterFields()
	{
		if (Array.isArray(this.options.IgnoreFilterFields))
		{
			return this.options.IgnoreFilterFields;
		}
		return [];
	}

	/**
	 * Columns that look like foreign keys but must NOT be prefetched as connected
	 * entities. Configure with `IgnoreConnectedEntityFields`.
	 *
	 * @return {Array<string>} - The field names to skip when inferring connected entities.
	 */
	get ignoreConnectedEntityFields()
	{
		if (Array.isArray(this.options.IgnoreConnectedEntityFields))
		{
			return this.options.IgnoreConnectedEntityFields;
		}
		return [];
	}

	/**
	 * Infer which columns are foreign keys worth prefetching as connected entities.
	 *
	 * Any `ID*` column other than the recordset's own primary key is treated as a
	 * reference. That inference is right for a normalized table and wrong for a
	 * DENORMALIZED one: a reporting/lake table routinely carries a source id
	 * (`IDDocument`, `IDProject`) as plain data, and prefetching it bulk-reads the
	 * DECORATED entity endpoint with an INN list of every distinct value on the
	 * page — a slow, paged fan-out that blocks the record bind and fetches records
	 * nothing renders.
	 *
	 * Two exclusions:
	 *   - `IgnoreConnectedEntityFields`, per recordset, for denormalized columns.
	 *   - Lake physical primary keys (`IDC<customer>_<Table>`), always: they do not
	 *     name an entity, so the read 404s and aborts the bind.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The page of records just read.
	 * @param {string} pEntity - The recordset's own entity name (its PK is never a reference).
	 * @return {Array<string>} - The ID columns to hand to the connected-entity cache.
	 */
	inferConnectedEntityIDFields(pRecords, pEntity)
	{
		const tmpIDFields = [ 'CreatingIDUser', 'UpdatingIDUser' ];
		if (!Array.isArray(pRecords) || !pRecords.length)
		{
			return tmpIDFields;
		}
		const tmpIgnored = this.ignoreConnectedEntityFields;
		for (const tmpColumn of Object.keys(pRecords[0]))
		{
			if (!tmpColumn.startsWith('ID') || tmpColumn === `ID${pEntity}`)
			{
				continue;
			}
			if (tmpIgnored.indexOf(tmpColumn) > -1)
			{
				continue;
			}
			// Lake physical PK (IDC182_PD_HmaMixSieveWide) — not an entity name.
			if (/^IDC\d+_/.test(tmpColumn))
			{
				continue;
			}
			tmpIDFields.push(tmpColumn);
		}
		return tmpIDFields;
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async getRecord(pIDOrGuid)
	{
		if (!this.options.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		// FIXME: The GUIDS are returning false to isNaN so this doesn't work
		if (typeof pIDOrGuid === 'string' && isNaN(parseInt(pIDOrGuid)))
		{
			return this.getRecordByGUID(pIDOrGuid);
		}
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Reading ${this.options.Entity} record by ID`, { ID: pIDOrGuid });
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.getEntity(this.options.Entity, pIDOrGuid, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pResult);
			});
		});
	}

	getGUIDField()
	{ 
		if (this._Schema?.MeadowSchema?.Schema?.length)
		{
			for (let field of this._Schema.MeadowSchema.Schema)
			{
				if (field.Type == 'AutoGUID')
				{
					return field.Column;
				}
			}
		}
		return `GUID${ this.options.Entity }`;
	}

	getIDField()
	{
		if (this._Schema?.MeadowSchema?.Schema?.length)
		{
			for (let field of this._Schema.MeadowSchema.Schema)
			{
				if (field.Type == 'AutoIdentity')
				{
					return field.Column;
				}
			}
		}
		return `ID${ this.options.Entity }`;
	}

	getDeletedField()
	{
		if (this._Schema?.MeadowSchema?.Schema?.length)
		{
			for (let field of this._Schema.MeadowSchema.Schema)
			{
				if (field.Type == 'Deleted')
				{
					return field.Column;
				}
			}
		}
		return 'Deleted';
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pGuid - The ID or GUID of the record.
	 * @param {boolean} [pIncludeDeleted] - When true, also match soft-deleted records (the explicit
	 *                                      Deleted filter suppresses the automatic `Deleted = 0`).
	 */
	async getRecordByGUID(pGuid, pIncludeDeleted)
	{
		if (!this.options.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Reading ${this.options.Entity} record by GUID`, { GUID: pGuid });
		}
		let tmpFilterString = `FBV~${ this.getGUIDField() }~EQ~${encodeURIComponent(pGuid)}`;
		if (pIncludeDeleted === true)
		{
			tmpFilterString += `~FBL~${ this.getDeletedField() }~INN~0,1`;
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.getEntitySet(this.options.Entity, tmpFilterString, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				if (pResult.length > 1)
				{
					this.pict.log.error(`Multiple ${this.options.Entity} records found for GUID ${pGuid}`, { Records: pResult });
				}
				resolve(pResult[0]);
			});
		});
	}

	_prepareFilterState(pEntity, pOptions, pFilterExperienceResultAddress = 'Records')
	{
		const tmpClauses = [].concat(this.pict.Bundle._ActiveFilterState?.[pOptions.RecordSet || pOptions.Entity || this.options.Entity]?.FilterClauses || []);
		const tmpExperience = Object.assign({}, this.pict.Bundle._ActiveFilterState?.[pOptions.Entity || this.options.Entity]?.Experience || {});
		if (!tmpExperience.ResultDestinationAddress)
		{
			tmpExperience.ResultDestinationAddress = `Bundle._ActiveFilterState[\`${this.options.RecordSet}\`].${pFilterExperienceResultAddress}`;
		}
		if (!tmpExperience.Entity)
		{
			tmpExperience.Entity = pEntity;
		}
		if (pOptions.FilterString && typeof pOptions.FilterString === 'string' && pOptions.FilterString.trim().length > 0)
		{
			tmpClauses.push({ Type: 'RawFilter', Value: pOptions.FilterString });
		}
		// (The show-deleted switch needs no special handling here: it is a real RawFilter clause in
		// the active filter state — see setShowDeletedFilterValue on the base provider — so it rides
		// the FilterClauses concat above into both the records and count fetches.)
		return [ tmpClauses, tmpExperience ];
	}

	/**
	 * Derive the Lite `ExtraColumns` for a list fetch from the manifest's displayed
	 * columns. Lite already returns the ID-prefixed, GUID-prefixed, CreatingIDUser and
	 * UpdateDate fields plus a computed Value, so we only request the remaining scalar
	 * display columns — and only ones that are real, non-blob schema columns. Returns
	 * [] (caller then does a safe full fetch) if the manifest columns or schema are
	 * unavailable.
	 * @param {string} pEntity - The entity being listed.
	 * @param {Record<string, any>} pOptions - The list options (carries RecordSetConfiguration).
	 * @return {Array<string>} The ExtraColumns to request.
	 */
	_deriveLiteExtraColumns(pEntity, pOptions)
	{
		const tmpConfig = pOptions && pOptions.RecordSetConfiguration;
		let tmpDescriptors = null;
		if (tmpConfig && this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.manifestDefinitions)
		{
			const tmpManifestHash = tmpConfig.RecordSetListDefaultManifest || (Array.isArray(tmpConfig.RecordSetListManifests) ? tmpConfig.RecordSetListManifests[0] : null);
			const tmpManifest = tmpManifestHash ? this.pict.PictSectionRecordSet.manifestDefinitions[tmpManifestHash] : null;
			tmpDescriptors = (tmpManifest && tmpManifest.Descriptors) || null;
		}
		const tmpSchemaColumns = (this._Schema && this._Schema.MeadowSchema && Array.isArray(this._Schema.MeadowSchema.Schema)) ? this._Schema.MeadowSchema.Schema : [];
		if (!tmpDescriptors || tmpSchemaColumns.length < 1)
		{
			return [];
		}
		const tmpColumnType = {};
		for (const tmpColumn of tmpSchemaColumns)
		{
			if (tmpColumn && tmpColumn.Column)
			{
				tmpColumnType[tmpColumn.Column] = tmpColumn.Type;
			}
		}
		const tmpBlobTypes = { 'Text': true, 'JSON': true };
		const tmpColumns = [];
		for (const tmpKey of Object.keys(tmpDescriptors))
		{
			// ID*/GUID*/owner/update come back in every Lite record for free.
			if (tmpKey.startsWith('ID') || tmpKey.startsWith('GUID') || tmpKey === 'CreatingIDUser' || tmpKey === 'UpdateDate')
			{
				continue;
			}
			// Only request real, non-blob columns (a computed/templated manifest column
			// that is not a DB column would otherwise error the query).
			if (!(tmpKey in tmpColumnType) || tmpBlobTypes[tmpColumnType[tmpKey]])
			{
				continue;
			}
			if (!tmpColumns.includes(tmpKey))
			{
				tmpColumns.push(tmpKey);
			}
		}
		// Column chooser: union in user-shown schema-tier columns so a toggled-on column's data is
		// actually fetched. Same gauntlet as the descriptors; gated on the config flag so stale
		// stored overrides can never widen queries for lists that don't use the chooser.
		if (tmpConfig && tmpConfig.RecordSetListColumnChooser === true && this.pict.providers.ColumnDataProvider)
		{
			const tmpRecordSet = (pOptions && pOptions.RecordSet) || tmpConfig.RecordSet || pEntity;
			const tmpOverrides = this.pict.providers.ColumnDataProvider.getColumnVisibilityOverrides(tmpRecordSet, 'List');
			for (const tmpKey of Object.keys(tmpOverrides))
			{
				if (tmpOverrides[tmpKey] !== true)
				{
					continue;
				}
				if (tmpKey.startsWith('ID') || tmpKey.startsWith('GUID') || tmpKey === 'CreatingIDUser' || tmpKey === 'UpdateDate')
				{
					continue;
				}
				if (!(tmpKey in tmpColumnType) || tmpBlobTypes[tmpColumnType[tmpKey]])
				{
					continue;
				}
				if (!tmpColumns.includes(tmpKey))
				{
					tmpColumns.push(tmpKey);
				}
			}
		}
		return tmpColumns;
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecords(pOptions)
	{
		if (!this.options.Entity && !pOptions.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		const tmpEntity = pOptions.Entity || this.options.Entity;

		// Lite projection (opt-in via RecordSetListLiteFetch): request only the columns
		// the manifest displays so the list stops pulling blob columns (FormData, etc.).
		// Lite (partial) records are NOT written to the entity cache (see getEntitySetPage) —
		// the list renders them straight from state — so they can never poison the global
		// cache that full-record consumers (row-click View, {~E:~}) rely on. The list's
		// reference entities (Project/User) are full records and stay in the global cache,
		// batched reliably by the connected-entity prefetch + the stale-read prune fix.
		const tmpLiteFetch = (this.options.RecordSetListLiteFetch === true) || !!(pOptions && pOptions.RecordSetConfiguration && pOptions.RecordSetConfiguration.RecordSetListLiteFetch);
		let tmpProjection = null;
		if (tmpLiteFetch)
		{
			// Ensure the entity schema is loaded so we only request real, non-blob columns.
			if (!this._Schema)
			{
				await this.getRecordSchema();
			}
			const tmpExtraColumns = this._deriveLiteExtraColumns(tmpEntity, pOptions);
			if (tmpExtraColumns.length > 0)
			{
				tmpProjection = { Mode: 'LiteExtended', ExtraColumns: tmpExtraColumns };
			}
		}

		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Reading ${tmpEntity} records`, { Options: pOptions });
		}
		return new Promise((resolve, reject) =>
		{
			const [ tmpClauses, tmpExperience ] = this._prepareFilterState(tmpEntity, pOptions);
			if (tmpProjection)
			{
				tmpExperience.Projection = tmpProjection;
			}
			if (this.options.FilterEndpointOverride)
			{
				// Call the filtering endpoint with the clauses and experience.
				this.entityProvider.restClient.postJSON({
					url: `${ this.options.URLPrefix }${ this.options.FilterEndpointOverride }/${ pOptions.Offset || 0 }/${ pOptions.PageSize || 250 }`,
					body: { Clauses: tmpClauses, Experience: tmpExperience },
				}, (pError, response, result) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					this.fable.manifest.setValueByHash(this.pict, tmpExperience.ResultDestinationAddress, result);
					const recordsReturn = result;
					const IDFields = this.inferConnectedEntityIDFields(recordsReturn, tmpEntity);
					this.pict.EntityProvider.cacheConnectedEntityRecordsWithoutCount(recordsReturn, IDFields, ['User', 'User'], false, () =>
					{
						resolve({ Records: recordsReturn, Facets: { } });
					});
				});
				return;
			}
			this.pict.providers.FilterManager.loadRecordPageByFilterUsingProvider(this.entityProvider, tmpClauses, tmpExperience, pOptions.Offset || 0, pOptions.PageSize || 250, (pError) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				const recordsReturn = this.pict.resolveStateFromAddress(tmpExperience.ResultDestinationAddress);
				const IDFields = this.inferConnectedEntityIDFields(recordsReturn, tmpEntity);
				// Use the NoCount (lazy-page) batch: counts are very costly in this MySQL,
				// and the count-based variant serializes one slow COUNT per reference entity,
				// stalling the queue so later entities (e.g. Project) never batch and fall
				// back to per-row fetches. NoCount fetches each batch in one paged request
				// with real concurrency (maxOperations).
				this.pict.EntityProvider.cacheConnectedEntityRecordsWithoutCount(recordsReturn, IDFields, ['User', 'User'], false, () =>
				{
					resolve({ Records: recordsReturn, Facets: { } });
				});
			});
			// using a space here, otherwise you get a `//` in the URL which breaks some stuff
		});
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {string} [pFilterString] - The filter string to apply.
	 * @param {number} [pOffset] - The starting record number for pagination.
	 * @param {number} [pPageSize] - The number of records to return.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecordsInline(pFilterString = '', pOffset = 0, pPageSize = 250)
	{
		return this.getRecords({ FilterString: pFilterString, Offset: pOffset, PageSize: pPageSize });
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 */
	async getRecordSetCount(pOptions)
	{
		if (!this.options.Entity && !pOptions.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		const tmpEntity = pOptions.Entity || this.options.Entity;
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Counting ${tmpEntity} records`, { Options: pOptions });
		}
		//TODO: lite support / other variants?
		return new Promise((resolve, reject) =>
		{
			const [ tmpClauses, tmpExperience ] = this._prepareFilterState(tmpEntity, pOptions, 'Count');
			// The record count is identical for every page of the same filter, yet the list re-counts on each
			// pagination click. A COUNT is expensive on some database engines, so cache it keyed by the compiled
			// filter signature: same filter -> serve the cached count (no request); changed filter -> re-count.
			// Mutations through this provider clear the cache (see createRecord / updateRecord / deleteRecord).
			const tmpCountCacheKey = `${ tmpEntity }::${ JSON.stringify(tmpClauses) }`;
			if (this._RecordSetCountCache && this._RecordSetCountCache.Key === tmpCountCacheKey)
			{
				// Publish the cached count to the result address so downstream consumers behave identically to a fetch.
				this.fable.manifest.setValueByHash(this.pict, tmpExperience.ResultDestinationAddress, this._RecordSetCountCache.Count);
				return resolve({ Count: this._RecordSetCountCache.Count });
			}
			if (this.options.FilterEndpointOverride)
			{
				// Call the filtering endpoint with the clauses and experience.
				this.entityProvider.restClient.postJSON({
					url: `${ this.options.URLPrefix }${ this.options.FilterEndpointOverride }/Count`,
					body: { Clauses: tmpClauses, Experience: tmpExperience },
				}, (error, response, result) =>
				{
					if (error)
					{
						return reject(error);
					}
					const tmpCount = result?.Count || 0;
					this.fable.manifest.setValueByHash(this.pict, tmpExperience.ResultDestinationAddress, tmpCount);
					this._RecordSetCountCache = { Key: tmpCountCacheKey, Count: tmpCount };
					resolve(result);
				});
				return;
			}
			this.pict.providers.FilterManager.countRecordsByFilterUsingProivider(this.entityProvider, tmpClauses, tmpExperience, (pError) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				const tmpCount = this.pict.resolveStateFromAddress(tmpExperience.ResultDestinationAddress);
				this._RecordSetCountCache = { Key: tmpCountCacheKey, Count: tmpCount };
				resolve({ Count: tmpCount });
			});
		});
	}

	/**
	 * Create a new record.
	 *
	 * @param {Record<string, any>} pRecord - The record to create.
	 */
	async createRecord(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.info(`Creating record ${this.options.Entity}`, { Record: pRecord });
			}
			this.entityProvider.restClient.postJSON({
				url: `${this.options.URLPrefix}${this.options.Entity}`,
				body: pRecord,
			}, (error, response, result) =>
			{
				if (error)
				{
					return reject(error);
				}
				// A new record changes the total; drop the cached count so the next render re-counts.
				this._RecordSetCountCache = null;
				// Mutations can introduce/retire column values; drop the distinct cache so
				// ScopeToRecordSet scoping and DistinctSelectedValueList dropdowns refresh.
				this._scopeDistinctCache = null;
				this._scopeDistinctInFlight = null;
				// Drop this list's scoped cache too, so the next render re-fetches fresh.
				if (typeof this.pict.EntityProvider.clearScope === 'function')
				{
					this.pict.EntityProvider.clearScope(`RSList::${ this.options.RecordSet || this.options.Entity }`);
				}
				resolve(result);
			});
		});
	}

	/**
	 * Update a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to update.
	 */
	async updateRecord(pRecord)
	{
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Updating record ${this.options.Entity} ${pRecord[this.getIDField()]}`);
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.restClient.putJSON({
				url: `${this.options.URLPrefix}${this.options.Entity}`,
				body: pRecord,
			}, (error, response, result) =>
			{
				if (error)
				{
					return reject(error);
				}
				// An edit can move a record in or out of the active filter; drop the cached count to be safe.
				this._RecordSetCountCache = null;
				// Mutations can introduce/retire column values; drop the distinct cache so
				// ScopeToRecordSet scoping and DistinctSelectedValueList dropdowns refresh.
				this._scopeDistinctCache = null;
				this._scopeDistinctInFlight = null;
				// Drop this list's scoped cache too, so the next render re-fetches fresh.
				if (typeof this.pict.EntityProvider.clearScope === 'function')
				{
					this.pict.EntityProvider.clearScope(`RSList::${ this.options.RecordSet || this.options.Entity }`);
				}
				resolve(result);
			});
		});
	}

	/**
	 * Delete a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to delete.
	 */
	async deleteRecord(pRecord)
	{
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Deleting record ${this.options.Entity} ${pRecord[this.getIDField()]}`);
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.restClient.delJSON({
				url: `${this.options.URLPrefix}${this.options.Entity}/${pRecord[this.getIDField()]}`,
				body: pRecord,
			}, (error, response, result) =>
			{
				if (error)
				{
					return reject(error);
				}
				// A delete changes the total; drop the cached count so the next render re-counts.
				this._RecordSetCountCache = null;
				// Mutations can introduce/retire column values; drop the distinct cache so
				// ScopeToRecordSet scoping and DistinctSelectedValueList dropdowns refresh.
				this._scopeDistinctCache = null;
				this._scopeDistinctInFlight = null;
				// Drop this list's scoped cache too, so the next render re-fetches fresh.
				if (typeof this.pict.EntityProvider.clearScope === 'function')
				{
					this.pict.EntityProvider.clearScope(`RSList::${ this.options.RecordSet || this.options.Entity }`);
				}
				resolve(result);
			});
		});
	}

	/**
	 * Read a record.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async readRecord(pIDOrGuid)
	{
		return this.getRecord(pIDOrGuid);
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async readRecords(pOptions)
	{
		return this.getRecords(pOptions);
	}

	/**
	 * Clone a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clone.
	 */
	async cloneRecord(pRecord)
	{
		return this.createRecord(this.cleanRecord(pRecord));
	}

	/**
	 * Remove any intrinsic identifiers from a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clean.
	 */
	cleanRecord(pRecord)
	{
		delete pRecord[this.getIDField()];
		delete pRecord[this.getGUIDField()];
		return pRecord;
	}

	/**
	 * The "list entry" display template for an entity — how one of its records should read as a single line
	 * in a picker option / selected chip. Returns a pict template string (rendered against the raw record by
	 * the picker's TextTemplate), or null to fall back to a single display field.
	 *
	 * This is deliberately a small, overridable seam: today it hard-knows `User` (whose name lives across
	 * NameFull / NameFirst+NameLast and needs an Email/LoginID disambiguator), but the intent is that this
	 * eventually reads a per-entity template off the Stricture schema instead of branching here.
	 *
	 * @param {string} pEntityName - The entity (e.g. 'User').
	 * @return {string|null}
	 */
	getEntityListEntryTemplate(pEntityName)
	{
		// Register the User branching fall-backs once. addTemplate is idempotent (keyed by hash), so the
		// guard is just to avoid the churn of re-registering on every descriptor build.
		if (!this._entityListEntryTemplatesRegistered)
		{
			this._entityListEntryTemplatesRegistered = true;
			// Name fallback: when NameFull is empty, compose it from the parts.
			this.pict.TemplateProvider.addTemplate('RSP-EntityListEntry-User-NameParts', '{~D:Record.NameFirst~} {~D:Record.NameLast~}');
			// Disambiguator fallback: when Email is empty, use the LoginID.
			this.pict.TemplateProvider.addTemplate('RSP-EntityListEntry-User-Login', '{~D:Record.LoginID~}');
		}

		switch (pEntityName)
		{
			case 'User':
				// "<name> (<email>)" — name is NameFull, else NameFirst+NameLast; the parenthetical is Email,
				// else LoginID. Stable across the three name-field variations and unique enough to tell apart
				// many same-named users.
				return '{~DWTF:Record.NameFull:RSP-EntityListEntry-User-NameParts~} ({~DWTF:Record.Email:RSP-EntityListEntry-User-Login~})';
			default:
				return null;
		}
	}

	/**
	 * @param {string} pSchemaField - The schema field name.
	 * @param {Record<string, any>} pColumn - The full column definition from the schema.
	 * @param {Record<string, any>} [pMeadowSchemaField] - The meadow schema field definition.
	 */
	getFieldFilterClauses(pSchemaField, pColumn, pMeadowSchemaField)
	{
		/** @type {Record<string, any>} */
		let tmpRangeClause;
		let tmpFieldFilterClauses = this.options.FieldFilterClauses?.[pSchemaField];
		if (!Array.isArray(tmpFieldFilterClauses))
		{
			let tmpFieldType = pColumn.type;
			if (pMeadowSchemaField && typeof pMeadowSchemaField.Type === 'string')
			{
				tmpFieldType = pMeadowSchemaField.Type.toLowerCase();
			}
			tmpFieldFilterClauses = [];
			const tmpFieldHumanName = this.getHumanReadableFieldName(pSchemaField);
			const isUserAuditField = ['CreatingIDUser', 'DeletingIDUser', 'UpdatingIDUser'].includes(pSchemaField);
			const customFilterClauses = this.options.Filters?.[pSchemaField];
			// The entity's own identity column (AutoIdentity / AutoGUID) — i.e. the primary key.
			const isOwnIdentityField = pMeadowSchemaField && (pMeadowSchemaField.Type === 'AutoIdentity' || pMeadowSchemaField.Type === 'AutoGUID');
			const isForeignKeyLike = pSchemaField.startsWith('ID') || pSchemaField.startsWith('ParentID') || isUserAuditField || customFilterClauses;
			if (isForeignKeyLike)
			{
				for (const customField of Array.isArray(customFilterClauses) ? customFilterClauses : [customFilterClauses])
				{
					// The table the picker pulls from: an explicit RemoteTable, else this
					// recordset's declared Entity when the column is our own primary key (the PK
					// references our own records), else the name peeled from the column for a
					// plain foreign key. Peeling alone is the defect — a lake PK like
					// `IDC182_HMA_MixDesign` peels to a table name that is not the entity name.
					const remoteTableName = customField?.RemoteTable || (isOwnIdentityField ? this.options.Entity : pSchemaField.split('ID')[1]);
					const fieldName = this.getHumanReadableFieldName(pSchemaField);
					tmpFieldFilterClauses.push(Object.assign(
					{
						"Label": `${ fieldName }`,
						"Type": "InternalJoinSelectedValueList",
						"ExternalFilterByColumns": remoteTableName === 'User' ? [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ] : [ 'Name' ],
						"ExternalRecordDisplayTemplate": remoteTableName === 'User' ? '{~D:Record.Data.NameFirst~} {~D:Record.Data.NameLast~}' : '{~D:Record.Name~}',
						// The picker's option/selected display: a per-entity "list entry" template (the seam that
						// will eventually live on the Stricture schema). Disambiguates beyond a single column.
						"EntityListEntryTemplate": this.getEntityListEntryTemplate(remoteTableName),
						"CoreConnectionColumn": pSchemaField,
						"RemoteTable": `${ remoteTableName }`,
						"URLPrefix": this.options.URLPrefix,
						"JoinExternalConnectionColumn": `ID${ remoteTableName }`,
						"JoinInternalConnectionColumn": pSchemaField,
						'DisplayName': `Selected Records`,
						'Ordinal': tmpFieldFilterClauses.length + 1,
						'FilterKey': pSchemaField,
						'ClauseKey': `${pSchemaField}_Selected`
					}, customField));
				}
			}
			// The primary key is also a plain integer key, so it ALSO falls through to the
			// Exact / In Range clauses below. A real foreign key gets only the picker; ordinary
			// columns are matched by type.
			if (!isForeignKeyLike || isOwnIdentityField)
			{
				switch (tmpFieldType)
				{
					case 'string':
					case 'autoguid':
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Exact`, Label: `${tmpFieldHumanName} Exact Match`, DisplayName: `Exact Match`, Type: 'StringMatch', FilterByColumn: pSchemaField, ExactMatch: true, Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Fuzzy`, Label: `${tmpFieldHumanName} Partial Match`, DisplayName: `Partial Match`, Type: 'StringMatch', FilterByColumn: pSchemaField, ExactMatch: false , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpRangeClause = { FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Range`, Label: `${tmpFieldHumanName} In Range`, DisplayName: `In Range`, Type: 'StringRange', FilterByColumn: pSchemaField , Ordinal: tmpFieldFilterClauses.length + 1 };
						tmpRangeClause.MinimumLabel = `Minimum ${tmpFieldHumanName}`;
						tmpRangeClause.MaximumLabel = `Maximum ${tmpFieldHumanName}`;
						tmpFieldFilterClauses.push(tmpRangeClause);
						break;
					case 'date':
					case 'datetime':
					case 'createdate':
					case 'updatedate':
					case 'deletedate':
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Exact`, Label: `${tmpFieldHumanName} Exact Match`, DisplayName: `Exact Match`, Type: 'DateMatch', FilterByColumn: pSchemaField, ExactMatch: true , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Fuzzy`, Label: `${tmpFieldHumanName} Partial Match`, DisplayName: `Partial Match`, Type: 'DateMatch', FilterByColumn: pSchemaField, ExactMatch: false , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpRangeClause = { FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Range`, Label: `${tmpFieldHumanName} In Range`, DisplayName: `In Range`, Type: 'DateRange', FilterByColumn: pSchemaField , Ordinal: tmpFieldFilterClauses.length + 1 };
						tmpRangeClause.MinimumLabel = `Minimum ${tmpFieldHumanName}`;
						tmpRangeClause.MaximumLabel = `Maximum ${tmpFieldHumanName}`;
						tmpFieldFilterClauses.push(tmpRangeClause);
						break;
					case 'boolean':
						// A boolean is stored 0/1 — offer ONE Yes/No control, not the Exact/Partial/In-Range
						// set that made booleans confusing to filter. It COMPILES as an exact NumericMatch
						// (EQ 0/1), so no new pict Filter.js type is needed; `FilterRenderType` routes it to
						// the Yes/No <select> view (RecordSet-Filter-BooleanMatch).
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Boolean`, Label: `${tmpFieldHumanName}`, DisplayName: `Yes / No`, Type: 'NumericMatch', FilterRenderType: 'BooleanMatch', FilterByColumn: pSchemaField, ExactMatch: true, Ordinal: tmpFieldFilterClauses.length + 1 });
						break;
					case 'deleted':
					case 'integer':
					case 'decimal':
					case 'autoidentity':
					case 'createiduser':
					case 'updateiduser':
					case 'deleteiduser':
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Exact`, Label: `${tmpFieldHumanName} Exact Match`, DisplayName: `Exact Match`, Type: 'NumericMatch', FilterByColumn: pSchemaField, ExactMatch: true , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Fuzzy`, Label: `${tmpFieldHumanName} Partial Match`, DisplayName: `Partial Match`, Type: 'NumericMatch', FilterByColumn: pSchemaField, ExactMatch: false , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpRangeClause = { FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Range`, Label: `${tmpFieldHumanName} In Range`, DisplayName: `In Range`, Type: 'NumericRange', FilterByColumn: pSchemaField , Ordinal: tmpFieldFilterClauses.length + 1 };
						tmpRangeClause.MinimumLabel = `Minimum ${tmpFieldHumanName}`;
						tmpRangeClause.MaximumLabel = `Maximum ${tmpFieldHumanName}`;
						tmpFieldFilterClauses.push(tmpRangeClause);
						break;
					default:
						this.pict.log.warn(`Unsupported field type ${pColumn.type} for field ${pSchemaField}`, { Schema: pColumn });
				}
			}
		}
		return tmpFieldFilterClauses;
	}

	/**
	 * @param {(error?: Error) => void} fCallback - The callback function.
	 */
	onInitializeAsync(fCallback)
	{
		super.onInitializeAsync((pError) =>
		{
			//FIXME: load the most recent experience from local storage using the other provider
			//       how do we control the initialization order of the providers?
			if (this.options.FilterExperiences && typeof this.options.FilterExperiences === 'object' && !Array.isArray(this.options.FilterExperiences))
			{
				this.pict.Bundle._ActiveFilterState = this.pict.Bundle._ActiveFilterState || {};
				this.pict.Bundle._ActiveFilterState[this.options.RecordSet] = this.pict.Bundle._ActiveFilterState[this.options.RecordSet] || {};
				const tmpEntityFilterState = this.pict.Bundle._ActiveFilterState[this.options.RecordSet];
				tmpEntityFilterState.Experience = tmpEntityFilterState.Experience || {};
				for (const tmpKey of Object.keys(this.options.FilterExperiences))
				{
					const tmpExperience = this.options.FilterExperiences[tmpKey];
					if (!tmpExperience.FilterCriteriaHash && !Array.isArray(tmpExperience.FilterClauses))
					{
						this.log.warn(`Filter experience ${tmpKey} has invalid Criteria`, { Experience: tmpExperience });
						continue;
					}
					if (tmpExperience.FilterCriteriaHash)
					{
						// load from hash
						const tmpClauses = this.pict.providers.FilterManager.getFilterCriteria(tmpExperience.FilterCriteriaHash);
						if (!tmpClauses)
						{
							this.pict.log.warn(`Filter experience ${tmpKey} filter criteria hash ${tmpExperience.FilterCriteriaHash} not found`, { Experience: tmpExperience });
							continue;
						}
						//TODO: handle Ordinal / generate if missing
						this._Experiences[tmpKey] = JSON.parse(JSON.stringify(tmpExperience));
						this._Experiences[tmpKey].FilterClauses = JSON.parse(JSON.stringify(tmpClauses));
						for (const tmpClause of this._Experiences[tmpKey].FilterClauses)
						{
							tmpClause.FilterCriteriaHash = tmpExperience.FilterCriteriaHash;
							if (!tmpClause.FilterByColumn && !tmpClause.CoreConnectionColumn && !tmpClause.JoinInternalConnectionColumn)
							{
								this.log.warn(`Filter experience ${tmpKey} clause does not have filter by column configured`, { Clause: tmpClause });
								continue;
							}
							if (tmpClause.FilterDefinitionHash)
							{
								const tmpFilter = this.pict.providers.FilterManager.getFilter(tmpClause.FilterDefinitionHash);
								if (!tmpFilter)
								{
									this.pict.log.warn(`Filter experience ${tmpKey} filter criteria hash ${tmpClause.FilterDefinitionHash} not found`, { Experience: tmpExperience });
									continue;
								}
								Object.assign(tmpClause, tmpFilter); //TODO: is there a risk of leakage here?
								if (tmpClause.FilterByColumn && typeof tmpClause.Type === 'string')
								{
									if (tmpClause.Type.startsWith('InternalJoin'))
									{
										tmpClause.JoinInternalConnectionColumn = tmpClause.FilterByColumn;
									}
									else if (tmpClause.Type.startsWith('ExternalJoin'))
									{
										tmpClause.CoreConnectionColumn = tmpClause.FilterByColumn;
									}
								}
							}
						}
						if (tmpExperience.Default && !tmpEntityFilterState.FilterClauses)
						{
							tmpEntityFilterState.FilterClauses = JSON.parse(JSON.stringify(this._Experiences[tmpKey].FilterClauses));
							for (const tmpClause of tmpEntityFilterState.FilterClauses)
							{
								tmpClause.Hash = `${tmpClause.FilterByColumn}-${tmpClause.Type}-${this.pict.getUUID()}`;
							}
						}
						continue;
					}
					this._Experiences[tmpKey] = JSON.parse(JSON.stringify(tmpExperience));
					if (tmpExperience.Default && !tmpEntityFilterState.FilterClauses)
					{
						tmpEntityFilterState.FilterClauses = JSON.parse(JSON.stringify(tmpExperience.FilterClauses));
					}
				}
			}
			if (pError)
			{
				return fCallback(pError);
			}
			// Do NOT fetch the per-entity `<Entity>/Schema` at initialization. The
			// application initializes EVERY registered record-set provider (an app
			// can register dozens), so fetching here — even non-blocking — makes boot
			// fire one `<Entity>/Schema` round-trip per record set, whether or not
			// that record set is ever viewed (tens of round-trips against a remote
			// API on a landing page that shows no lists). Defer entirely: the
			// List/Read/Create/Dashboard views each `await getRecordSchema()` before
			// rendering, so the schema loads lazily for the record sets actually
			// viewed. The one exception is a manifest-provided schema, which costs no
			// round-trip — prime that eagerly so filters are ready with zero latency.
			if (this.options.ProvidedSchema && typeof this.options.ProvidedSchema === 'object')
			{
				this._ensureEntitySchemaAsync().catch((pSchemaError) =>
				{
					this.fable.log.error(`Error initializing entity schema for ${this.options.Entity}: ${pSchemaError?.message || pSchemaError}`, { Stack: pSchemaError?.stack });
				});
			}
			return fCallback();
		});
	}

	/**
	 * @param {string} pEntity - The schema field name.
	 * @return {string} - The human-readable name for the entity.
	 */
	_getHumanReadableEntityName(pEntity)
	{
		return pEntity.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
	}

	/**
	 * @param {string} pSchemaField - The schema field name.
	 * @return {string} - The human-readable name for the schema field.
	 */
	getHumanReadableFieldName(pSchemaField)
	{
		if (!this._Schema || !this._Schema.properties || !this._Schema.properties[pSchemaField])
		{
			return pSchemaField;
		}
		if (pSchemaField === this.getIDField())
		{
			return `${this._getHumanReadableEntityName(this.options.Entity)} Unique Database ID`;
		}
		if (pSchemaField === this.getGUIDField())
		{
			return `${this._getHumanReadableEntityName(this.options.Entity)} Unique Identifier`;
		}
		if (pSchemaField === 'CreatingIDUser')
		{
			return 'Created By User';
		}
		if (pSchemaField === 'CreateDate')
		{
			return 'Date Created';
		}
		if (pSchemaField === 'UpdatingIDUser')
		{
			return 'Last Updated By User';
		}
		if (pSchemaField === 'UpdateDate')
		{
			return 'Date Last Updated';
		}
		if (pSchemaField.startsWith('ID'))
		{
			return this._getHumanReadableEntityName(pSchemaField.split('ID')[1]);
		}
		if (pSchemaField.startsWith('ParentID'))
		{
			return 'Parent ' + this._getHumanReadableEntityName(pSchemaField.split('ID')[1]);
		}
		return pSchemaField.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
	}

	/**
	 * Load the entity schema (and derive the filter schema from it) exactly once,
	 * sharing a single in-flight network round-trip across every caller.
	 *
	 * The `<Entity>/Schema` fetch used to run inline in `onInitializeAsync`,
	 * blocking each provider's init callback; against the serial provider-init
	 * queue that turned N record sets into N back-to-back round-trips at startup.
	 * The fetch is now deferred and pulled in on demand by `getRecordSchema()`.
	 * Caching the promise here guarantees the deferred background load and any
	 * on-demand call never double-fetch — nor double-run the append-only
	 * `initializeFilterSchema()`. A manifest can still hand the schema over up
	 * front via `options.ProvidedSchema` (resolves synchronously, no round-trip).
	 * Resolves with the schema (or null when the endpoint does not support a
	 * Schema capability); a failed/unsupported load clears the cached handle so a
	 * later attempt can retry.
	 *
	 * @return {Promise<Record<string, any> | null>} the loaded entity schema
	 */
	_ensureEntitySchemaAsync()
	{
		if (this._Schema)
		{
			return Promise.resolve(this._Schema);
		}
		// A caller can hand this provider its schema up front (options.ProvidedSchema) -- the app
		// manifest bundles each entity's schema so boot skips the per-entity /Schema round trip. It
		// is the same object the /Schema endpoint returns, so every downstream reader behaves
		// identically. When it is absent we fall through to the (deferred) network fetch.
		if (this.options.ProvidedSchema && typeof this.options.ProvidedSchema === 'object')
		{
			this._Schema = this.options.ProvidedSchema;
			// Seed the entity provider's capability cache from the supplied schema, the same as the
			// fetch path below, so reads still detect POST /Query support without a probe.
			if (this.entityProvider && typeof this.entityProvider.primeEntityCapabilityFromSchema === 'function')
			{
				this.entityProvider.primeEntityCapabilityFromSchema(this.options.Entity, this._Schema, this.options.URLPrefix);
			}
			this.initializeFilterSchema();
			return Promise.resolve(this._Schema);
		}
		if (this._SchemaInitPromise)
		{
			return this._SchemaInitPromise;
		}
		this._SchemaInitPromise = (async () =>
		{
			this.fable.log.info('Initializing RecordSetProvider-MeadowEndpoints');
			const tmpCheckSession = this.pict.services.PictSectionRecordSet ? this.pict.services.PictSectionRecordSet.checkSession.bind(this.pict.services.PictSectionRecordSet) : async () => true;
			const tmpSupported = await tmpCheckSession('Schema');
			if (!tmpSupported)
			{
				return null;
			}
			// Go through the entity provider's SHARED schema cache rather than
			// fetching the URL ourselves. The capability probe reads the same
			// `<Entity>/Schema`, and when each side had its own single-flight the
			// identical schema was fetched twice per recordset. Requires
			// pict >= the release that adds getEntitySchema; older builds fall
			// back to the direct read.
			const tmpSchema = await new Promise((resolve, reject) =>
			{
				if (typeof this.entityProvider.getEntitySchema === 'function')
				{
					return this.entityProvider.getEntitySchema(this.options.Entity, this.options.URLPrefix, (pError, pResult) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						return resolve(pResult);
					});
				}
				this.entityProvider.restClient.getJSON(`${this.options.URLPrefix}${this.options.Entity}/Schema`, (pError, pResponse, pResult) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					return resolve(pResult);
				});
			});
			this._Schema = tmpSchema;
			// The schema response carries the endpoint's version/capability
			// metadata; seed the entity provider's capability cache from it so
			// reads avoid a redundant capability probe.
			if (this.entityProvider && typeof this.entityProvider.primeEntityCapabilityFromSchema === 'function')
			{
				this.entityProvider.primeEntityCapabilityFromSchema(this.options.Entity, tmpSchema, this.options.URLPrefix);
			}
			// Derive the filter schema from the entity schema now that it is loaded.
			// This is append-only, so the single-flight promise keeps it to one run.
			this.initializeFilterSchema();
			return this._Schema;
		})()
			.then((pSchema) =>
			{
				// A no-op (unsupported) load leaves `_Schema` null; drop the cached
				// handle so a subsequent call can retry the capability probe.
				if (!this._Schema)
				{
					this._SchemaInitPromise = null;
				}
				return pSchema;
			})
			.catch((pError) =>
			{
				this.fable.log.error(`Error fetching schema: ${pError?.message || pError}`, { Stack: pError?.stack });
				this._Schema = null;
				this._SchemaInitPromise = null;
				throw pError;
			});
		return this._SchemaInitPromise;
	}

	/**
	 * Backwards-compatible callback wrapper around {@link _ensureEntitySchemaAsync}.
	 * @param {(error?: Error) => void} fCallback - The callback function.
	 */
	initializeEntitySchema(fCallback)
	{
		this._ensureEntitySchemaAsync().then(() => fCallback(null)).catch((pError) => fCallback(pError));
	}

	initializeFilterSchema()
	{
		const tmpSchema = this._Schema;
		if (!tmpSchema || !tmpSchema.properties)
		{
			return;
		}
		const tmpProperties = tmpSchema?.properties;
		// loop through the schema and add the columns to the tableCells
		let tmpOrdinal = 0;
		for (const tmpSchemaField in tmpProperties)
		{
			if (this.ignoreFilterFields.includes(tmpSchemaField))
			{
				continue;
			}
			++tmpOrdinal;
			const tmpColumn = tmpProperties[tmpSchemaField];
			// The Meadow schema endpoint nests its canonical column array (the one carrying each column's
			// semantic Type — CreateDate/UpdateDate/CreateIDUser/… — which is what distinguishes a date
			// column from a plain string; the JSON-schema `type` flattens both to "string"). Read the
			// nested path, falling back to the legacy flat path for older endpoints.
			const tmpMeadowSchemaArray = tmpSchema.MeadowSchema?.MeadowSchema?.Schema || tmpSchema.MeadowSchema?.Schema;
			const tmpMeadowSchemaField = Array.isArray(tmpMeadowSchemaArray) ? tmpMeadowSchemaArray.find((f) => f.Column === tmpSchemaField) : undefined;
			let tmpFieldFilterSchema = this._FilterSchema[tmpSchemaField];
			if (!tmpFieldFilterSchema)
			{
				this._FilterSchema[tmpSchemaField] = tmpFieldFilterSchema = { };
			}
			if (!tmpFieldFilterSchema.FilterKey)
			{
				tmpFieldFilterSchema.FilterKey = tmpSchemaField;
			}
			if (!tmpFieldFilterSchema.RecordSet)
			{
				tmpFieldFilterSchema.RecordSet = this.options.RecordSet;
			}
			if (!tmpFieldFilterSchema.DisplayName)
			{
				tmpFieldFilterSchema.DisplayName = this.getHumanReadableFieldName(tmpSchemaField);
			}
			if (!tmpFieldFilterSchema.Description)
			{
				tmpFieldFilterSchema.Description = `Filter by ${tmpFieldFilterSchema.DisplayName}`;
			}
			if (!tmpFieldFilterSchema.HelpText)
			{
				tmpFieldFilterSchema.HelpText = `Filter by ${tmpFieldFilterSchema.DisplayName} for the ${this._getHumanReadableEntityName(this.options.Entity)} entity.`;
			}
			if (tmpFieldFilterSchema.Ordinal == null)
			{
				tmpFieldFilterSchema.Ordinal = tmpOrdinal;
			}
			if (!Array.isArray(tmpFieldFilterSchema.AvailableClauses))
			{
				tmpFieldFilterSchema.AvailableClauses = [];
			}
			const tmpFieldFilterClauses = this.getFieldFilterClauses(tmpSchemaField, tmpColumn, tmpMeadowSchemaField);
			if (Array.isArray(tmpFieldFilterClauses) && tmpFieldFilterClauses.length > 0)
			{
				for (const tmpFilterClause of tmpFieldFilterClauses)
				{
					//TODO: allow customization of filter order
					tmpFilterClause.Ordinal = tmpFieldFilterSchema.AvailableClauses.length + 1;
					tmpFieldFilterSchema.AvailableClauses.push(tmpFilterClause);
				}
			}
		}
		if (typeof this.pict.providers.FilterManager.filters === 'object')
		{
			for (const tmpFilterKey of Object.keys(this.pict.providers.FilterManager.filters))
			{
				const tmpFilterClause = this.pict.providers.FilterManager.filters[tmpFilterKey];
				// Two recognised host-declared filter shapes:
				//   (1) Foreign-key join — `CoreConnectionColumn` equals this recordset's
				//       PK (e.g. a Sample filter whose data flow joins on IDSample). Folded
				//       into `_FilterSchema[FilterKey]` for back-compat with the existing
				//       behaviour.
				//   (2) Plain column filter — declares `FilterByColumn` and wants to surface
				//       as the column's filter entry. Folded into
				//       `_FilterSchema[FilterByColumn]` so the Add Filter popover / Quick
				//       Filter resolver find it under the same slot the schema-derived
				//       entries use.
				// Optional per-recordset scoping: when the filter clause declares a
				// `RecordSet`, only fold into providers whose `options.RecordSet` matches.
				// Lets a host register the same `FilterByColumn` under different definitions
				// per dashboard without cross-pollination.
				if (tmpFilterClause.RecordSet && tmpFilterClause.RecordSet !== this.options.RecordSet)
				{
					continue;
				}
				const tmpIsCoreConnection = (tmpFilterClause.CoreConnectionColumn === this.getIDField());
				const tmpHasFilterByColumn = !!tmpFilterClause.FilterByColumn;
				if (!tmpIsCoreConnection && !tmpHasFilterByColumn)
				{
					continue;
				}
				const tmpSlotKey = tmpIsCoreConnection ? tmpFilterKey : tmpFilterClause.FilterByColumn;
				if (this.ignoreFilterFields.includes(tmpSlotKey))
				{
					continue;
				}
				let tmpFieldFilterSchema = this._FilterSchema[tmpSlotKey];
				if (!tmpFieldFilterSchema)
				{
					this._FilterSchema[tmpSlotKey] = tmpFieldFilterSchema = { };
				}
				if (!tmpFieldFilterSchema.FilterKey)
				{
					tmpFieldFilterSchema.FilterKey = tmpSlotKey;
				}
				if (!tmpFieldFilterSchema.RecordSet)
				{
					tmpFieldFilterSchema.RecordSet = this.options.RecordSet;
				}
				const tmpFieldHumanName = this.getHumanReadableFieldName(tmpSlotKey);
				if (tmpFilterClause.DisplayName)
				{
					tmpFieldFilterSchema.DisplayName = tmpFilterClause.DisplayName;
				}
				if (!tmpFieldFilterSchema.DisplayName)
				{
					tmpFieldFilterSchema.DisplayName = tmpFieldHumanName;
				}
				if (!tmpFieldFilterSchema.Description)
				{
					tmpFieldFilterSchema.Description = tmpFilterClause.Description || `Filter by ${tmpFieldFilterSchema.DisplayName}`;
				}
				if (!tmpFieldFilterSchema.HelpText)
				{
					tmpFieldFilterSchema.HelpText = tmpFilterClause.HelpText || `Filter by ${tmpFieldFilterSchema.DisplayName} for the ${this._getHumanReadableEntityName(this.options.Entity)} entity.`;
				}
				if (tmpFieldFilterSchema.Ordinal == null)
				{
					tmpFieldFilterSchema.Ordinal = tmpOrdinal;
				}
				if (!Array.isArray(tmpFieldFilterSchema.AvailableClauses))
				{
					tmpFieldFilterSchema.AvailableClauses = [];
				}
				tmpFieldFilterSchema.AvailableClauses.push(tmpFilterClause.ClauseName ? Object.assign(tmpFilterClause, { DisplayName: tmpFilterClause.ClauseName }) : tmpFilterClause);
				if (!tmpFilterClause.FilterKey)
				{
					tmpFilterClause.FilterKey = tmpSlotKey;
				}
				if (!tmpFilterClause.ClauseKey)
				{
					tmpFilterClause.ClauseKey = tmpFilterKey;
				}
				if (!tmpFilterClause.DisplayName)
				{
					tmpFilterClause.DisplayName = tmpFieldHumanName;
				}
				tmpFilterClause.Ordinal = tmpFieldFilterSchema.AvailableClauses.length + 1;
			}
		}
	}

	/**
	 * @return {Promise<Record<string, any>>} The schema of the record.
	 */
	async getRecordSchema()
	{
		if (!this._Schema)
		{
			await this._ensureEntitySchemaAsync();
		}
		return this._Schema;
	}

	/**
	 * Abstract decoration method for core records. Subclasses should implement this method to decorate records with additional information.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The records to decorate.
	 * @return {Promise<void>}
	 */
	async decorateCoreRecords(pRecords)
	{
		if (!this.options.RecordDecorationConfiguration)
		{
			return;
		}
		if (!Array.isArray(this.options.RecordDecorationConfiguration))
		{
			this.pict.log.error('RecordDecorationConfiguration is not an array', { RecordDecorationConfiguration: this.options.RecordDecorationConfiguration });
			return;
		}
		this.pict.Bundle[this.Hash] = { CoreEntityRecordSubset: pRecords };
		const config = [{ Type: 'SetStateAddress', StateAddress: `Bundle[${this.Hash}]` }].concat(this.options.RecordDecorationConfiguration);

		try
		{
			await new Promise((resolve, reject) => this.pict.EntityProvider.gatherDataFromServer(config, (err) =>
			{
				if (err)
				{
					return reject(err);
				}
				resolve();
			}));
		}
		catch (error)
		{
			this.pict.log.error(`MeadowEndpointsRecordSetProvider: Error gathering data from server for record decoration: ${error.message}`, { Stack: error.stack });
		}
	}
}

module.exports = MeadowEndpointsRecordSetProvider;

},{"./RecordSet-RecordProvider-Base.js":618}],620:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libPictRouter = require('pict-router');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-Router',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictRecordSetRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict') & { PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')> }} */
		this.pict;

		this.pictRouter = null;
	}

	onInitialize()
	{
		if (!('PictRouter' in this.pict.providers))
		{
			this.pictRouter = this.pict.addProvider('PictRouter', { RouterMode: 'memory' }, libPictRouter);
		}
		else
		{
			this.pictRouter = this.pict.providers.PictRouter;
		}
		return super.onInitialize();
	}

	addRoutes(pRouter)
	{
		//FIXME: not working
		this.pictRouter.addRoute('/PSRS/404', '{~D:Pict.views[RSP-RecordSet-Error-NotFound].render()~}');
		// TODO: Create some kind of state tracking to see if these routes have already been added
		//this.pictRouter.addRoute('/PSRS/:RecordSet/List/:Begin/:Cap', "{~LV:Record~}");
		this.pict.views['RSP-RecordSet-List'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Read'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Create'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Dashboard'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Associate'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-AssociateMatrix'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-AssociateUnlink'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-BulkDelete'].addRoutes(pRouter);

		this.pict.PictSectionRecordSet.addRoutes(pRouter);
	}

	/**
	 * Navigate to a given route (set the browser URL string, add to history, trigger router)
	 * 
	 * @param {string} pRoute - The route to navigate to
	 */
	navigate(pRoute)
	{
		this.pictRouter.navigate(pRoute);
	}
}

module.exports = PictRecordSetRouter;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479,"pict-router":480}],621:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const ViewDefinitionRecordSetErrorNotFound = require('../views/error/RecordSet-Error-NotFound.json');
const ViewRecordSetList = require('../views/list/RecordSet-List.js');
const ViewRecordSetRead = require('../views/read/RecordSet-Read.js');
const ViewRecordSetCreate = require('../views/create/RecordSet-Create.js');
const ViewRecordSetDashboard = require('../views/dashboard/RecordSet-Dashboard.js');
const ViewRecordSetAssociate = require('../views/associate/RecordSet-AssociateBulk.js');
const ViewRecordSetAssociateMatrix = require('../views/associate/RecordSet-AssociateMatrix.js');
const ViewRecordSetAssociateUnlink = require('../views/associate/RecordSet-AssociateUnlink.js');
const ViewRecordSetBulkDelete = require('../views/delete/RecordSet-BulkDelete.js');

//_Pict.addProvider('BooksProvider', { Entity: 'Book', URLPrefix: 'http://www.datadebase.com:8086/1.0/' }, require('../source/providers/RecordSet-RecordProvider-MeadowEndpoints.js'));
const ProviderBase = require('../providers/RecordSet-RecordProvider-Base.js');
const ProviderMeadowEndpoints = require('../providers/RecordSet-RecordProvider-MeadowEndpoints.js');

const ProviderLinkManager = require('../providers/RecordSet-Link-Manager.js');
const ProviderAssociationManager = require('../providers/RecordSet-AssociationManager.js');
const ProviderDependentManager = require('../providers/RecordSet-DependentManager.js');
const ProviderCardManager = require('../providers/RecordSet-CardManager.js');
const libProviderColumnData = require('../providers/Column-Data-Provider.js');

const ProviderRouter = require('../providers/RecordSet-Router.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
	{
		DefaultMeadowURLPrefix: '/1.0/',
		// Field-decoration policy for the entity pickers this module builds (the association editors, the
		// entity quick-filters, and the bulk-delete replacement picker). Opt-in: a decorated picker grows a
		// ⚙ that lets a user pin an extra record column (e.g. VendorCode) onto each dropdown row, to tell
		// same-named records apart. `Global` decorates every entity; `Entities` keys it per entity (a value
		// of true / false, or an object { IgnoreFields:[…] }); `IgnoreFields` hides business-noise columns on
		// every decorated picker. Resolved per entity by resolveFieldDecoration(); the app overrides the
		// whole object via fable.settings.FieldDecoration.
		FieldDecoration: { Global: false, Entities: {}, IgnoreFields: [] }
	};

const libFormsTemplateProvider = require('pict-section-form').PictFormTemplateProvider;

class RecordSetMetacontroller extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any, addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any, newManyfest: (rec: any) => any }} */
		this.fable;
		this.pict = this.fable;
		/** @type {any} */
		this.log;
		/** @type {any} */
		this.options;
		/** @type {string} */
		this.UUID;

		this.childViews = {
			list: null,
			create: null,
			read: null,
			dashboard: null
		};

		/** @type {Record<string, import('pict-provider')>} */
		this.recordSetProviders = {};
		/** @type {Record<string, Record<string, any>>} */
		this.recordSetProviderConfigurations = {};

		/** @type {Record<string, Record<string, any>>} */
		this.dashboardConfigurations = {};

		/** @type {Array<(pCapability: string) => Promise<boolean>>} */
		this.sessionProviders = [];

		/** @type {Record<string, Record<string, any>>} */
		this.manifestDefinitions = {};
		/** @type {Record<string, import('manyfest')>} */
		this.manifests = { Default: this.pict.manifest };

		this.has_initialized = false;

		//FIXME: this duplicates a behavior in pict-section-form - figure out how we want this coupled dependency to work.
		this.fable.addProviderSingleton('PictFormSectionDefaultTemplateProvider', libFormsTemplateProvider.default_configuration, libFormsTemplateProvider);

		this.pict.MetaTemplate.addPatternBoth('{~ProcessCell:', '~}', (pHash, pData, fCallback)=>
		{ 
			const field = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return fCallback(null, this.pict.manifest.getValueByHash(pData.Payload, field));
		}, async (pHash, pData, fCallback) =>
		{
			const field = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let value = this.pict.manifest.getValueByHash(pData.Payload, field);
			const IDPrefixes = ['Parent', 'Child', 'Creating', 'Updating', 'Deleting'];
			let sanitizedField = field;
			for (let p of IDPrefixes)
			{
				sanitizedField = sanitizedField.replace(`${ p }ID`, 'ID');
			}
			if (sanitizedField?.startsWith('ID'))
			{
				if (!value)
				{
					return fCallback(null, '');
				}
				const remote = field.split('ID')[1];
				// Capture the raw foreign-key id before `value` is overwritten with the resolved name —
				// a registered preview card opens on the id, not the display string.
				const tmpForeignID = value;
				try
				{
					const entity = await new Promise((resolve, reject) =>
					{
						this.pict.EntityProvider.getEntity(remote, value, (pError, pResult) =>
						{
							if (pError)
							{
								return reject(pError);
							}
							resolve(pResult);
						});
					});
					// A dangling reference (the target row no longer exists — e.g. a system user id that
					// was never seeded) comes back as the endpoint's error body rather than an entity.
					// Render the raw id, unlinked: it carries more information than a blank cell, and
					// matches how a found-but-nameless entity already renders.
					if (!entity || (entity.Error && entity.StatusCode))
					{
						return fCallback(null, value);
					}
					if (remote === 'User')
					{
						// Compose what the user record actually has; fall back through the common
						// name fields rather than printing "undefined undefined".
						const tmpUserName = [ entity.NameFirst, entity.NameLast ].filter((pPart) => (typeof(pPart) === 'string') && pPart.trim().length > 0).join(' ');
						value = tmpUserName || entity.FullName || entity.Name || entity.LoginID || value;
					}
					else if (entity?.Name)
					{
						value = entity.Name;
					}
					else if (entity?.Title)
					{
						value = entity.Title;
					}
					else if (entity?.Hash)
					{
						value = entity.Hash;
					}
					if (this.pict.PictSectionRecordSet.recordSetProviderConfigurations[remote])
					{
						// A registered preview card supersedes the plain link: the trigger opens the anchored
						// mini-card (which carries its own "view" action/route). Degrades to the link when no
						// card is registered for the referenced record-set.
						const tmpCardManager = this.pict.providers.RecordSetCardManager;
						if (tmpCardManager && tmpCardManager.hasCard(remote))
						{
							value = tmpCardManager.triggerHTML(remote, tmpForeignID, value);
						}
						else
						{
							const url = this.pict.parseTemplateByHash('PRSP-Read-Link-URL-Template', { Payload: { Payload: { RecordSet: remote, GUIDAddress: `GUID${ remote }` }, Data: entity }});
							value = `<a href="${ url }">${ value }</a>`;
						}
					}
				}
				catch (e)
				{
					this.pict.log.error(`[RecordSet-MetaController]  Unable to fetch entity: ${ e }`);
					return fCallback(e, '');
				}
			}
			return fCallback(null, value);
		});
	}

	/*
		"DefaultRecordSetConfigurations":
			[
				{
					"RecordSet": "Book",

					"RecordSetType": "MeadowEndpoint", // Could be "Custom" which would require a provider to already be created for the record set.
					"RecordSetMeadowEntity": "Book",   // This leverages the /Schema endpoint to get the record set columns.

					"RecordSetURLPrefix": "http://www.datadebase.com:8086/1.0/"
				},
				{
					"RecordSet": "Author",

					"RecordSetType": "MeadowEndpoint",
					"RecordSetMeadowEntity": "Author",

					"RecordSetURLPrefix": "http://www.datadebase.com:8086/1.0/"
				},
				{
					"RecordSet": "RandomizedValues",

					"RecordSetType": "Custom" // This means the `PS-RSP-RandomizedValues` provider will be checked for to get records.
				}
			]
	 */

	/**
	 * @param {string} pRecordSet - The RecordSet name to get the configuration for.
	 *
	 * @return {Record<string, any>} - The registered configuration for the RecordSet
	 */
	getRecordSetConfiguration(pRecordSet)
	{
		return this.recordSetProviderConfigurations[pRecordSet];
	}

	/**
	 * Resolve a column name to the record-set it references, so a form can mount an entity Picker and the
	 * read view can resolve the name. Two sources, in order:
	 *
	 *   1. The record-set config's explicit `ForeignKeyEntities` map ({ ColumnName: EntityName }). This is
	 *      how non-conventional references are declared — prefixed/suffixed columns (ParentIDSample,
	 *      ItemIDTestSpecificationSet, LinkedIDUser, IDMaterialParent, …) and any override. Mapping a
	 *      column to a falsy value explicitly opts it OUT (keeps it a plain input).
	 *   2. The plain `ID<Entity>` convention — a column named exactly `ID` + an entity that is a
	 *      registered record-set (IDOrganization → Organization). No prefix heuristics; anything that
	 *      isn't a clean `ID<Entity>` must be declared in the map above.
	 *
	 * Returns false for the row's own id, IDCustomer, non-references, and references this app doesn't
	 * manage as a record-set (which then stay plain inputs).
	 *
	 * @param {string} pFieldName - the schema column name.
	 * @param {Record<string, any>} [pRecordSetConfiguration] - the owning record-set's configuration.
	 * @param {string} [pOwnIDField] - the row's own id field, excluded (e.g. 'IDTestSpecification').
	 * @return {string|false} the referenced record-set name, or false.
	 */
	resolveForeignEntity(pFieldName, pRecordSetConfiguration, pOwnIDField)
	{
		if (!pFieldName || (typeof pFieldName !== 'string')) { return false; }
		// 1. Explicit per-record-set mapping wins (declares exceptions; a falsy value opts a column out).
		const tmpMap = pRecordSetConfiguration && pRecordSetConfiguration.ForeignKeyEntities;
		if (tmpMap && Object.prototype.hasOwnProperty.call(tmpMap, pFieldName))
		{
			return tmpMap[pFieldName] || false;
		}
		// 2. Plain ID<Entity> convention, validated against the registered record-sets.
		if ((pFieldName === pOwnIDField) || (pFieldName === 'IDCustomer')) { return false; }
		if (!pFieldName.startsWith('ID')) { return false; }
		const tmpRemote = pFieldName.slice(2);
		if (!tmpRemote) { return false; }
		return this.recordSetProviderConfigurations[tmpRemote] ? tmpRemote : false;
	}

	/**
	 * @param {Record<string, any>} pRecordSetConfiguration - The RecordSet configuration to load.
	 */
	loadRecordSetConfiguration(pRecordSetConfiguration)
	{
		if (typeof pRecordSetConfiguration !== 'object')
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfiguration called with invalid configuration.`);
			return false;
		}
		if ((!('RecordSet' in pRecordSetConfiguration)) || (pRecordSetConfiguration.RecordSet === ''))
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfiguration called with invalid configuration. Missing RecordSet.`);
			return false;
		}

		// Normalize the whole-row-click opt-in to a STRICT boolean. The action-cell and column-header
		// templates branch on it with TIfAbs's TRUE/FALSE operators, which test `=== true` / `=== false`.
		// An absent (undefined) or loose ('true') value would satisfy neither branch, leaving the actions
		// column empty — so coerce it to a real true/false here, once, for every render path.
		pRecordSetConfiguration.RowClickOpensRecord = (pRecordSetConfiguration.RowClickOpensRecord === true || pRecordSetConfiguration.RowClickOpensRecord === 'true');

		// Bulk-delete opt-ins, normalized to STRICT booleans (the List title-bar button and the delete
		// screen branch on them the same way RowClickOpensRecord does, via TIfAbs TRUE/FALSE operators).
		pRecordSetConfiguration.RecordSetAllowBulkDelete = (pRecordSetConfiguration.RecordSetAllowBulkDelete === true || pRecordSetConfiguration.RecordSetAllowBulkDelete === 'true');
		// Advanced delete — reassign a record's relationships to a replacement before deleting it.
		pRecordSetConfiguration.RecordSetAdvancedDelete = (pRecordSetConfiguration.RecordSetAdvancedDelete === true || pRecordSetConfiguration.RecordSetAdvancedDelete === 'true');

		// The bulk-delete screen reuses the recordset filter experience under the 'BulkDelete' view context.
		// The filter search box builds its navigation URL from RecordSetFilterURLTemplate-<Context>; inject a
		// BulkDelete template so a filter search navigates to the bulk-delete filtered route rather than the
		// filter view's hardcoded List fallback. A host-provided template always wins.
		if (pRecordSetConfiguration.RecordSetAllowBulkDelete && !pRecordSetConfiguration['RecordSetFilterURLTemplate-BulkDelete'])
		{
			pRecordSetConfiguration['RecordSetFilterURLTemplate-BulkDelete'] = `/PSRS/${pRecordSetConfiguration.RecordSet}/BulkDelete/FilteredTo/{~D:Record.FilterString~}`;
		}

		// One-to-many dependents (child entities with an FK back at this recordset) drive advanced-delete
		// reassociation. Register them with the DependentManager now — the provider is registered in
		// initialize() before any config loads, and this path also covers runtime loadRecordSetDynamically.
		if (Array.isArray(pRecordSetConfiguration.RecordSetDependents) && this.pict.providers.RecordSetDependentManager)
		{
			this.pict.providers.RecordSetDependentManager.addDependents(pRecordSetConfiguration.RecordSet, pRecordSetConfiguration.RecordSetDependents);
		}

		let tmpExtraColumnHeaderTemplateHash = `RecordSet-List-ExtraColumnHeader-${pRecordSetConfiguration.RecordSet}`;
		pRecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash = tmpExtraColumnHeaderTemplateHash;
		let tmpExtraColumnRowTemplateHash = `RecordSet-List-ExtraColumnRow-${pRecordSetConfiguration.RecordSet}`;
		pRecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash = tmpExtraColumnRowTemplateHash;
		if (pRecordSetConfiguration.RecordSetListHasExtraColumns)
		{
			let tmpRecordSetExtraColumnHeaderTemplate = pRecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplate;
			if (tmpRecordSetExtraColumnHeaderTemplate === undefined)
			{
				tmpRecordSetExtraColumnHeaderTemplate = '';
			}
			let tmpRecordSetExtraColumnRowTemplate = pRecordSetConfiguration.RecordSetListExtraColumnRowTemplate;
			if (tmpRecordSetExtraColumnRowTemplate === undefined)
			{
				tmpRecordSetExtraColumnRowTemplate = '';
			}
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnHeaderTemplateHash, tmpRecordSetExtraColumnHeaderTemplate);
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnRowTemplateHash, tmpRecordSetExtraColumnRowTemplate);
		}
		else
		{
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnHeaderTemplateHash, '');
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnRowTemplateHash, '');
		}

		let tmpProvider = false;

		const providerConfiguration = Object.assign({}, {Hash: `RSP-Provider-${pRecordSetConfiguration.RecordSet}`}, pRecordSetConfiguration);
		this.recordSetProviderConfigurations[providerConfiguration.RecordSet] = providerConfiguration;

		switch (pRecordSetConfiguration.RecordSetType)
		{
			case 'MeadowEndpoint':
				// Create a Meadow Endpoints provider
				// Allow the Record Set to optionally point to a different entity
				if (`RecordSetMeadowEntity` in pRecordSetConfiguration)
				{
					providerConfiguration.Entity = pRecordSetConfiguration.RecordSetMeadowEntity;
				}
				else
				{
					providerConfiguration.Entity = pRecordSetConfiguration.RecordSet;
				}
				if (`FilterEndpointOverride` in pRecordSetConfiguration)
				{
					providerConfiguration.FilterEndpointOverride = pRecordSetConfiguration.FilterEndpointOverride;
				}
				else
				{
					providerConfiguration.FilterEndpointOverride = null;
				}
				// Default the URLPrefix to the base URLPrefix
				if (`RecordSetURLPrefix` in pRecordSetConfiguration)
				{
					providerConfiguration.URLPrefix = pRecordSetConfiguration.RecordSetURLPrefix;
				}
				else
				{
					providerConfiguration.URLPrefix = '/1.0/';
				}
				if (`RecordSetIgnoreFilterFields` in pRecordSetConfiguration)
				{
					providerConfiguration.IgnoreFilterFields = pRecordSetConfiguration.RecordSetIgnoreFilterFields;
				}
				else
				{
					providerConfiguration.IgnoreFilterFields = [ 'Deleted', 'DeletingIDUser', 'DeleteDate' ];
				}
				// Columns that look like foreign keys but are denormalized data, so the
				// provider must not bulk-prefetch them as connected entities.
				if (`RecordSetIgnoreConnectedEntityFields` in pRecordSetConfiguration)
				{
					providerConfiguration.IgnoreConnectedEntityFields = pRecordSetConfiguration.RecordSetIgnoreConnectedEntityFields;
				}
				if (`RecordSetFieldFilterClauses` in pRecordSetConfiguration)
				{
					providerConfiguration.FieldFilterClauses = pRecordSetConfiguration.RecordSetFieldFilterClauses;
				}
				// A pre-supplied schema (e.g. bundled into an app manifest) lets the provider skip
				// the per-entity /Schema fetch at initialization. Absent, the provider fetches as before.
				if (`RecordSetSchema` in pRecordSetConfiguration)
				{
					providerConfiguration.ProvidedSchema = pRecordSetConfiguration.RecordSetSchema;
				}

				tmpProvider = this.recordSetProviders[pRecordSetConfiguration.RecordSet] = this.fable.addProvider(providerConfiguration.Hash, providerConfiguration, ProviderMeadowEndpoints);
				break;
			default:
			case 'Custom':
				// Create a custom provider
				if (`ProviderHash` in providerConfiguration)
				{
					if (!(providerConfiguration.ProviderHash in this.fable.servicesMap))
					{
						this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfiguration called with invalid configuration. ProviderHash ${providerConfiguration.ProviderHash} not found.  Falling back to base.`);
						tmpProvider = this.recordSetProviders[providerConfiguration.RecordSet] = this.fable.servicesMap[providerConfiguration.ProviderHash];
					}
					else
					{
						tmpProvider = this.recordSetProviders[providerConfiguration.RecordSet] = this.fable.addProvider(providerConfiguration.Hash, providerConfiguration, ProviderBase);
					}
				}
				else
				{
					tmpProvider = this.recordSetProviders[providerConfiguration.RecordSet] = this.fable.addProvider(providerConfiguration.Hash, providerConfiguration, ProviderBase);
				}
				break;
		}

		return tmpProvider;
	}

	/**
	 * @param {Array<Record<string, any>>} pRecordSetConfigurationArray - An array of RecordSet configurations to load.
	 */
	loadRecordSetConfigurationArray(pRecordSetConfigurationArray)
	{
		if (!Array.isArray(pRecordSetConfigurationArray))
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfigurationArray called with invalid configuration.`);
			return false;
		}
		if (pRecordSetConfigurationArray.length === 0)
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfigurationArray called with empty configuration.`);
			return false;
		}
		for (let i = 0; i < pRecordSetConfigurationArray.length; i++)
		{
			if (!this.loadRecordSetConfiguration(pRecordSetConfigurationArray[i]))
			{
				this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfigurationArray called with invalid configuration:`,pRecordSetConfigurationArray[i]);
			}
		}
	}

	/**
	 * @param {Record<string, any> | string} pRecordSet - The RecordSet configuration or hash to load dynamically.
	 * @param {string} [pEntity] - (optional) The Entity type to use (defaults to the RecordSet name if not provided).
	 * @param {string} [pDefaultFilter] - (optional) The default filter to use.
	 */
	loadRecordSetDynamically(pRecordSet, pEntity, pDefaultFilter)
	{
		if (typeof(pRecordSet) === 'object')
		{
			const tmpRecordSetProviderHash = `RSP-Provider-${pRecordSet.RecordSet}`;
			this.loadRecordSetConfiguration(pRecordSet);

			return this.fable.providers[tmpRecordSetProviderHash].initializeAsync((pError) =>
				{
					if (pError)
					{
						this.log.error(`RecordSet [${pRecordSet.RecordSet}] dynamically loaded with error: ${pError.message || pError}`, { Stack: pError.stack });
						return;
					}
					this.log.trace(`RecordSet [${pRecordSet.RecordSet} dynamically loaded.`);
				})
		}

		if (typeof(pRecordSet) === 'string')
		{
			const tmpRecordSet = pRecordSet;
			const tmpRecordSetProviderHash = `RSP-Provider-${tmpRecordSet}`;

			const tmpEntity = (typeof(pEntity) === 'string') ? pEntity : tmpRecordSet;
			const tmpDefaultFilter = (typeof(pDefaultFilter) === 'string') ? pDefaultFilter : '';
			const tmpRecordSetConfiguration = {
				"RecordSet": tmpRecordSet,


				"RecordSetType": "MeadowEndpoint",
				"RecordSetMeadowEntity": tmpEntity,
				"RecordSetDefaultFilter": tmpDefaultFilter,

				"RecordSetURLPrefix": "/1.0/"
			};

			this.loadRecordSetConfiguration(tmpRecordSetConfiguration);
			return this.fable.providers[tmpRecordSetProviderHash].initializeAsync(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`RecordSet [${tmpRecordSet}] dynamically loaded with error: ${pError.message || pError}`, { Stack: pError.stack });
						return;
					}
					this.log.trace(`RecordSet [${tmpRecordSetConfiguration.RecordSet} dynamically loaded.`);
				});
		}

		this.log.error(`RecordSet MetaController loadRecordSetDynamically called with invalid parameter (expected an Object or String - parameter was ${typeof(pRecordSet)}.`);
		return false;
	}

	/**
	 * @param {Record<string, any>} pRoutePayload - The route payload containing the RecordSet and optional Entity and DefaultFilter.
	 */
	handleLoadDynamicRecordSetRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet List view route handler called with invalid route payload.`);
		}

		const tmpRecordSet = pRoutePayload.data.RecordSet;

		const tmpEntity = pRoutePayload.data.Entity ? pRoutePayload.data.Entity : tmpRecordSet;
		const tmpDefaultFilter = pRoutePayload.data.DefaultFilter ? pRoutePayload.data.DefaultFilter : '';

		return this.loadRecordSetDynamically(tmpRecordSet, tmpEntity, tmpDefaultFilter);
	}

	/**
	 * @param {import('pict-router')} pPictRouter - The Pict Router to add the routes to.
	 */
	addRoutes(pPictRouter)
	{
		pPictRouter.addRoute('/PSRS/:RecordSet/LoadDynamic', this.handleLoadDynamicRecordSetRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/LoadDynamic/:Entity', this.handleLoadDynamicRecordSetRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/LoadDynamic/:Entity/:DefaultFilter', this.handleLoadDynamicRecordSetRoute.bind(this));
		return true;
	}

	/**
	 * @param {string} pCapability - The capability to check for.
	 */
	async checkSession(pCapability)
	{
		for (const sessionProvider of this.sessionProviders)
		{
			if (!await sessionProvider(pCapability))
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * @param {string} pNameTemplate - The name template for the record link.
	 * @param {string} pURLTemplate - The URL template for the record link.
	 * @param {boolean} pDefault - Whether this is a default link template.
	 *
	 * @return {Record<string, any>} - The link template object that was added.
	 */
	addRecordLinkTemplate(pNameTemplate, pURLTemplate, pDefault)
	{
		return this.fable.providers.RecordSetLinkManager.addRecordLinkTemplate(pNameTemplate, pURLTemplate, pDefault);
	}

	/**
	 * Reassociation-on-delete: repoint every relationship that references `pFromID` in `pRecordSet` so it
	 * references `pToID` instead — both many-to-many joins (via the AssociationManager) and one-to-many
	 * dependent children (via the DependentManager). Returns per-relationship results plus an aggregate
	 * `failed` count. The CALLER must not delete `pFromID` unless `failed === 0`: there are no DB
	 * transactions, so deleting before a clean repoint would orphan the children/joins we just moved.
	 *
	 * @param {string} pRecordSet
	 * @param {string|number} pFromID - the record being deleted (its relationships move away).
	 * @param {string|number} pToID - the replacement record the relationships move to.
	 * @return {Promise<{ associations: Array<Record<string, any>>, dependents: Array<Record<string, any>>, repointed: number, deletedDuplicate: number, failed: number, selfRepoint: boolean }>}
	 */
	async repointRecordRelationships(pRecordSet, pFromID, pToID)
	{
		const tmpResult = { associations: [], dependents: [], repointed: 0, deletedDuplicate: 0, failed: 0, selfRepoint: false };
		if (pFromID === undefined || pFromID === null || pFromID === '' || pToID === undefined || pToID === null || pToID === '' || String(pFromID) === String(pToID))
		{
			tmpResult.selfRepoint = (String(pFromID) === String(pToID));
			return tmpResult;
		}

		const tmpAssociationManager = this.pict.providers.RecordSetAssociationManager;
		if (tmpAssociationManager)
		{
			const tmpHashes = tmpAssociationManager.getAssociationsForRecordSet(pRecordSet);
			for (let i = 0; i < tmpHashes.length; i++)
			{
				const tmpRepoint = await tmpAssociationManager.repointJoins(tmpHashes[i], pRecordSet, pFromID, pToID);
				tmpResult.associations.push(Object.assign({ Association: tmpHashes[i] }, tmpRepoint));
				tmpResult.repointed += tmpRepoint.repointed;
				tmpResult.deletedDuplicate += tmpRepoint.deletedDuplicate;
				tmpResult.failed += tmpRepoint.failed;
			}
		}

		const tmpDependentManager = this.pict.providers.RecordSetDependentManager;
		if (tmpDependentManager)
		{
			const tmpDependents = tmpDependentManager.getDependentsForRecordSet(pRecordSet);
			for (let i = 0; i < tmpDependents.length; i++)
			{
				const tmpRepoint = await tmpDependentManager.repointDependent(tmpDependents[i], pFromID, pToID);
				tmpResult.dependents.push(Object.assign({ Entity: tmpDependents[i].Entity, FKField: tmpDependents[i].FKField }, tmpRepoint));
				tmpResult.repointed += tmpRepoint.repointed;
				tmpResult.failed += tmpRepoint.failed;
			}
		}

		return tmpResult;
	}

	initialize()
	{
		if (this.has_initialized)
		{
			this.fable.log.warn(`RecordSetMetacontroller: ${this.UUID} already initialized and initialized was called a second time.`);
			return this;
		}

		this.fable.addProvider('RecordSetLinkManager', {}, ProviderLinkManager);

		// Joined-entity association manager — the registry + data layer behind the Association read-tab
		// and the Bulk Associate screen. Associations are parsed from settings.Associations below.
		this.fable.addProvider('RecordSetAssociationManager', {}, ProviderAssociationManager);

		// One-to-many dependent manager — the registry + data layer for child entities that carry a foreign
		// key back at a recordset (RecordSetDependents). Drives advanced-delete reassociation. Registered
		// before any recordset config loads so loadRecordSetConfiguration can register dependents inline.
		this.fable.addProvider('RecordSetDependentManager', {}, ProviderDependentManager);

		// Record preview cards — a global registry of small, config-driven record cards (popover on a
		// trigger). Layouts are parsed from settings.RecordCards below.
		this.fable.addProvider('RecordSetCardManager', {}, ProviderCardManager);

		// Column visibility persistence — only register the built-in localStorage provider when the
		// host hasn't supplied its own (the documented seam for server-side per-user persistence).
		if (!('ColumnDataProvider' in this.fable.providers))
		{
			this.fable.addProvider('ColumnDataProvider', libProviderColumnData.default_configuration, libProviderColumnData);
		}

		// Add the subviews internally and externally
		this.pict.addTemplate(require('../templates/Pict-Template-FilterView.js'));
		this.pict.addTemplate(require('../templates/Pict-Template-FilterInstanceViews.js'));
		this.pict.addTemplate(require('../templates/Pict-Template-RecordCard.js'));
		this.pict.addTemplate(require('../views/filters').Base);
		this.childViews.errorNotFound = this.fable.addView('RSP-RecordSet-Error-NotFound', ViewDefinitionRecordSetErrorNotFound);
		this.childViews.list = this.fable.addView('RSP-RecordSet-List', this.options, ViewRecordSetList);
		this.childViews.read = this.fable.addView('RSP-RecordSet-Read', this.options, ViewRecordSetRead);
		this.childViews.create = this.fable.addView('RSP-RecordSet-Create', this.options, ViewRecordSetCreate);
		this.childViews.dashboard = this.fable.addView('RSP-RecordSet-Dashboard', this.options, ViewRecordSetDashboard);
		this.childViews.associate = this.fable.addView('RSP-RecordSet-Associate', this.options, ViewRecordSetAssociate);
		this.childViews.associateMatrix = this.fable.addView('RSP-RecordSet-AssociateMatrix', this.options, ViewRecordSetAssociateMatrix);
		this.childViews.associateUnlink = this.fable.addView('RSP-RecordSet-AssociateUnlink', this.options, ViewRecordSetAssociateUnlink);
		this.childViews.bulkDelete = this.fable.addView('RSP-RecordSet-BulkDelete', this.options, ViewRecordSetBulkDelete);

		// Initialize the subviews
		this.childViews.list.initialize();
		this.childViews.read.initialize();
		this.childViews.create.initialize();
		this.childViews.dashboard.initialize();
		this.childViews.associate.initialize();
		this.childViews.associateMatrix.initialize();
		this.childViews.associateUnlink.initialize();
		this.childViews.bulkDelete.initialize();

		// Now initialize the router

		if (this.fable.settings.hasOwnProperty('Filters') && typeof this.fable.settings.Filters === 'object')
		{
			for (const tmpFilterKey of Object.keys(this.fable.settings.Filters))
			{
				const filterArray = Array.isArray(this.fable.settings.Filters[tmpFilterKey]) ? this.fable.settings.Filters[tmpFilterKey] : [this.fable.settings.Filters[tmpFilterKey]];
				for (let x = 0; x < filterArray.length; x++)
				{
					if (!filterArray[x].DisplayName)
					{
						filterArray[x].DisplayName = filterArray[x].Label || tmpFilterKey;
					}
					this.pict.providers.FilterManager.addFilter(filterArray[x].FilterKey || `${ tmpFilterKey }${ x ? `_${ x }` : '' }`, filterArray[x]);
				}
			}
		}

		if (this.fable.settings.hasOwnProperty('FilterCriteria') && typeof this.fable.settings.FilterCriteria === 'object')
		{
			for (const tmpFilterCriterionKey of Object.keys(this.fable.settings.FilterCriteria))
			{
				this.pict.providers.FilterManager.addFilterCriteria(tmpFilterCriterionKey, this.fable.settings.FilterCriteria[tmpFilterCriterionKey]);
			}
		}

		if (this.fable.settings.hasOwnProperty('Associations') && typeof this.fable.settings.Associations === 'object')
		{
			for (const tmpAssociationKey of Object.keys(this.fable.settings.Associations))
			{
				this.pict.providers.RecordSetAssociationManager.addAssociation(tmpAssociationKey, this.fable.settings.Associations[tmpAssociationKey]);
			}
		}

		if (this.fable.settings.hasOwnProperty('RecordCards') && typeof this.fable.settings.RecordCards === 'object')
		{
			for (const tmpRecordCardKey of Object.keys(this.fable.settings.RecordCards))
			{
				this.pict.providers.RecordSetCardManager.registerCard(tmpRecordCardKey, this.fable.settings.RecordCards[tmpRecordCardKey]);
			}
		}

		if (this.fable.settings.hasOwnProperty('DefaultRecordSetConfigurations'))
		{
			this.loadRecordSetConfigurationArray(this.fable.settings.DefaultRecordSetConfigurations);
		}

		for (const [ tmpManifestKey, tmpManifest ] of Object.entries(this.fable.settings.Manifests || {}))
		{
			if (!tmpManifest || !tmpManifest.Scope || !tmpManifest.Descriptors)
			{
				this.pict.log.error(`RecordSetDashboard: Invalid manifest: ${tmpManifestKey}.`, tmpManifest);
				continue;
			}
			if (tmpManifestKey !== tmpManifest.Scope)
			{
				this.pict.log.error(`RecordSetDashboard: Manifest key ${tmpManifestKey} does not match manifest scope ${tmpManifest.Scope}.  This is bad.  Fix it.`);
			}
			if (!tmpManifest.Form)
			{
				this.generateManifestTableCells(tmpManifest);
			}
			this.manifestDefinitions[tmpManifest.Scope] = tmpManifest;
			this.manifests[tmpManifest.Scope] = tmpManifest.Form ? tmpManifest : this.pict.newManyfest(tmpManifest);
		}

		// App-level field-decoration policy overlays the module default (see _DEFAULT_CONFIGURATION /
		// resolveFieldDecoration). One object drives the whole fleet of entity pickers this module builds.
		if (this.fable.settings.hasOwnProperty('FieldDecoration') && typeof this.fable.settings.FieldDecoration === 'object')
		{
			this.options.FieldDecoration = Object.assign({}, this.options.FieldDecoration, this.fable.settings.FieldDecoration);
		}

		this.has_initialized = true;

		// Load pict-router if it isn't loaded
		if (!('RecordSetRouter' in this.fable.providers))
		{
			this.fable.addProvider('RecordSetRouter', {}, ProviderRouter);
			this.fable.providers.RecordSetRouter.initialize();
		}

		return true;
	}

	getManifest(pScope)
	{
		return this.manifests[pScope];
	}

	/**
	 * Resolve the field-decoration policy for one entity into the two flags the picker widget consumes.
	 *
	 * Policy shape (this.options.FieldDecoration, overridable via fable.settings.FieldDecoration):
	 *   {
	 *     Global: false,                                  // decorate every entity picker
	 *     Entities: { Organization: true, Contract: { IgnoreFields: [ 'IDVendor' ] }, Foo: false },
	 *     IgnoreFields: [ 'IDCustomer' ]                  // hidden on every decorated picker (business noise)
	 *   }
	 * An entity value of `true` opts it in, `false` opts it out (even when Global is on), and an object opts
	 * it in and contributes its own IgnoreFields. The picker widget already hides the audit / value / text
	 * columns itself; here we add the policy's IgnoreFields, the entity's IgnoreFields, and GUID<Entity>
	 * (the picker does not auto-hide the GUID column).
	 *
	 * @param {string} pEntity - The entity the picker searches (e.g. 'Organization').
	 * @return {{ Enabled: boolean, IgnoreFields: Array<string> }}
	 */
	resolveFieldDecoration(pEntity)
	{
		const tmpPolicy = (this.options && typeof this.options.FieldDecoration === 'object' && this.options.FieldDecoration) || {};
		let tmpEnabled = (tmpPolicy.Global === true);
		let tmpEntityIgnore = [];
		const tmpEntityPolicy = (tmpPolicy.Entities && pEntity) ? tmpPolicy.Entities[pEntity] : undefined;
		if (tmpEntityPolicy === true)
		{
			tmpEnabled = true;
		}
		else if (tmpEntityPolicy === false)
		{
			tmpEnabled = false;
		}
		else if (tmpEntityPolicy && typeof tmpEntityPolicy === 'object')
		{
			tmpEnabled = (tmpEntityPolicy.Enabled !== false);
			if (Array.isArray(tmpEntityPolicy.IgnoreFields))
			{
				tmpEntityIgnore = tmpEntityPolicy.IgnoreFields;
			}
		}
		if (!tmpEnabled)
		{
			return { Enabled: false, IgnoreFields: [] };
		}
		const tmpIgnoreFields = [].concat(
			Array.isArray(tmpPolicy.IgnoreFields) ? tmpPolicy.IgnoreFields : [],
			tmpEntityIgnore);
		if (pEntity)
		{
			tmpIgnoreFields.push(`GUID${pEntity}`);
		}
		return { Enabled: true, IgnoreFields: tmpIgnoreFields };
	}

	/**
	 * Stamp the resolved field-decoration flags onto a picker config, in place. The single call every
	 * picker-creation site in this module uses so the policy is applied identically everywhere.
	 *
	 * @param {Record<string, any>} pConfig - A picker config (createPicker / createEntityPicker).
	 * @param {string} pEntity - The entity the picker searches.
	 * @return {Record<string, any>} The same config, decorated when the entity is opted in.
	 */
	applyFieldDecoration(pConfig, pEntity)
	{
		if (!pConfig)
		{
			return pConfig;
		}
		const tmpDecoration = this.resolveFieldDecoration(pEntity);
		if (tmpDecoration.Enabled)
		{
			pConfig.AllowFieldDecoration = true;
			pConfig.DecorationIgnoreFields = tmpDecoration.IgnoreFields;
		}
		return pConfig;
	}

	/**
	 * Register a manifest at runtime, after initialization. This is the
	 * equivalent of adding a manifest to `fable.settings.Manifests` before
	 * init, but callable after the fact.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to register. Must have `Scope` and `Descriptors`.
	 */
	addManifest(pManifest)
	{
		if (!pManifest || !pManifest.Scope || !pManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetMetacontroller: addManifest called with invalid manifest.`, pManifest);
			return;
		}
		if (!pManifest.Form)
		{
			this.generateManifestTableCells(pManifest);
		}
		this.manifestDefinitions[pManifest.Scope] = pManifest;
		this.manifests[pManifest.Scope] = pManifest.Form ? pManifest : this.pict.newManyfest(pManifest);
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to generate table cells for.
	 */
	generateManifestTableCells(pManifest)
	{
		if (!pManifest || !pManifest.Descriptors || !pManifest.Scope)
		{
			this.pict.log.error(`RecordSetDashboard: No manifest or descriptors found for ${pManifest}.  Cannot generate table cells.`);
			if (pManifest)
			{
				pManifest.TableCells = [];
			}
			return;
		}
		const tmpTableCells = Object.entries(pManifest.Descriptors || {}).filter(([ key, descriptor ]) => descriptor.PictDashboard).map(([ key, descriptor ]) =>
		{
			const tmpPictDashboard = descriptor.PictDashboard;
			if (tmpPictDashboard?.Equation && !tmpPictDashboard.ValueTemplate)
			{
				//FIXME: is this the right mapping?
				if (tmpPictDashboard.EquationNamespaceScope === 'Full')
				{
					tmpPictDashboard.ValueTemplate = '{~SBR:Record.Data.PictDashboard.Equation::Pict.PictSectionRecordSet.getManifest(Record.Data.ManifestHash)~}';
				}
				else
				{
					tmpPictDashboard.ValueTemplate = '{~SBR:Record.Data.PictDashboard.Equation:Record.Payload:Pict.PictSectionRecordSet.getManifest(Record.Data.ManifestHash)~}';
				}
			}
			if (!tmpPictDashboard.ValueTemplate)
			{
				tmpPictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
			}
			return {
				Key: key,
				DisplayName: descriptor.Name || key,
				ManifestHash: pManifest.Scope,
				PictDashboard: tmpPictDashboard,
				// Column-chooser default visibility: a descriptor can ship hidden-by-default and be
				// turned on by the user (when the recordset enables RecordSetListColumnChooser).
				DefaultHidden: (descriptor.DefaultHidden === true),
			};
		});
		pManifest.TableCells = tmpTableCells;
	}

}

module.exports = RecordSetMetacontroller;

RecordSetMetacontroller.default_configuration = _DEFAULT_CONFIGURATION;

},{"../providers/Column-Data-Provider.js":611,"../providers/RecordSet-AssociationManager.js":613,"../providers/RecordSet-CardManager.js":614,"../providers/RecordSet-DependentManager.js":615,"../providers/RecordSet-Link-Manager.js":617,"../providers/RecordSet-RecordProvider-Base.js":618,"../providers/RecordSet-RecordProvider-MeadowEndpoints.js":619,"../providers/RecordSet-Router.js":620,"../templates/Pict-Template-FilterInstanceViews.js":622,"../templates/Pict-Template-FilterView.js":623,"../templates/Pict-Template-RecordCard.js":624,"../views/associate/RecordSet-AssociateBulk.js":628,"../views/associate/RecordSet-AssociateMatrix.js":629,"../views/associate/RecordSet-AssociateUnlink.js":630,"../views/create/RecordSet-Create.js":632,"../views/dashboard/RecordSet-Dashboard.js":640,"../views/delete/RecordSet-BulkDelete.js":641,"../views/error/RecordSet-Error-NotFound.json":642,"../views/filters":670,"../views/list/RecordSet-List.js":680,"../views/read/RecordSet-Read.js":681,"fable-serviceproviderbase":398,"pict-section-form":497}],622:[function(require,module,exports){
const libPictTemplate = require('pict-template');
const libFilterViews = require('../views/filters/index.js');

/**
 * Specialized instruction for rendering the filter view and plumbing in required context.
 *
 * Based on the Pict base {~V:...~} template instruction.
 *
 * ## Async render architecture (see renderAsync below)
 *
 * The async path is tuned to get the dashboard records list painted before any
 * speculative filter-list REST lookups complete. Three things collaborate to
 * make that happen:
 *
 * 1. **Parallel filter fan-out.** Every filter clause starts its own
 *    `renderWithScopeAsync` in a single pass, instead of chaining through a
 *    sequential `Anticipate` queue. Template parsing, `onBefore*`/`onProject*`
 *    microtask hops, and the synchronous DOM walks done inside each filter's
 *    `onAfterRender` all happen concurrently rather than serialized across N
 *    filters. Results are collected into an indexed array so final output
 *    order still matches the clause order.
 *
 * 2. **Per-filter transaction isolation.** Each filter render gets its own
 *    synthetic `RootRenderable` carrying a fresh `TransactionHash`. Any
 *    `virtual-assignment` sub-renders that the filter's dynamic form spawns
 *    (notably `PSRSFilterProxyView`, which pict-section-form uses to host
 *    each filter's input) push into THIS transaction's queue, not the
 *    dashboard's. The dashboard's outer `renderAsync` callback fires as soon
 *    as every filter has its template string - without waiting on any of
 *    the nested input-initialize work.
 *
 * 3. **Deferred post-render drain.** The filter's post-render pipeline
 *    (`onAfterRenderAsync`, which is what runs pict-section-form's
 *    `runInputProviderFunctions('onInputInitialize', ...)` and therefore
 *    triggers `EntityBundleRequest.gatherDataFromServer` for any
 *    speculative-load inputs) is intentionally NOT run inline. It is queued
 *    via `setTimeout(..., 0)` so it fires on the next macrotask, giving the
 *    browser a tick to paint the dashboard first.
 *
 * ### Render-epoch race guard
 *
 * Between the dashboard callback firing and the setTimeout actually running,
 * the user may have navigated away / applied a different filter experience /
 * cleared filters. The `PRSP-Filters` view owns a monotonic `_renderEpoch`
 * counter that gets bumped on every mutating action (`performSearch`,
 * `handleClear`, `handleReset`, `addFilter`, `removeFilter`). Each scheduled
 * drain captures the epoch at schedule time and bails out if a newer render
 * has invalidated it, so a stale REST response can never clobber a filter
 * container that now belongs to a different experience.
 */
class PictTemplateFilterInstanceViewInstruction extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~FIV:', '~}');
		this.addPattern('{~FilterInstanceViews:', '~}');


		if (!('__TemplateOutputCache' in this.pict))
		{
			this.pict.__TemplateOutputCache = {};
		}
	}

	_getViewForFilterClause(pClause)
	{
		// Quick-filter clauses are surfaced in the Quick Filters bar (RecordSet-Filters._renderQuickFilters),
		// not the drawer's clause list — skip them here so they aren't rendered twice. Both the sync and
		// async render loops treat a null view as "skip this clause".
		if (pClause && pClause.QuickFilter) { return null; }
		// The show-deleted switch is a RawFilter clause whose face is the drawer-footer checkbox
		// (RecordSet-Filters._renderShowDeletedControl) — without this skip it would fall through to
		// the Base filter card, which renders a debug dump for types with no real filter view.
		if (pClause && pClause.ShowDeletedKey) { return null; }
		// A clause may render as a different type than it compiles as: `FilterRenderType` picks the
		// filter VIEW while `Type` still drives pict's Filter.js compile. Boolean columns use this —
		// they compile as an exact NumericMatch (EQ 0/1) but render the Yes/No BooleanMatch control.
		const tmpRenderType = pClause.FilterRenderType || pClause.Type;
		let tmpViewHash = `PRSP-FilterType-${tmpRenderType}`;
		const tmpCustomViewHash = `${tmpViewHash}-${pClause.CustomFilterViewHash}`;
		if (tmpCustomViewHash in this.pict.views)
		{
			tmpViewHash = tmpCustomViewHash;
		}
		/** @type {import('../views/filters/RecordSet-Filter-Base.js')} */
		let tmpView = this.pict.views[tmpViewHash];
		if (!tmpView)
		{
			const tmpViewPrototype = libFilterViews[tmpRenderType] || libFilterViews.Base;
			if (!tmpViewPrototype)
			{
				this.pict.log.error(`Pict: Filter Instance Views Template Render: No view prototype found for filter type [${pClause.Type}]`);
				return null;
			}
			//FIXME: is this safe? will this view get rendered at other times?
			tmpView = this.pict.addView(tmpViewHash, { }, tmpViewPrototype);
		}
		return tmpView;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set specified in record`);
			return '';
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set configuration found for [${tmpRecordSet}]`);
			return '';
		}
		let tmpViewContext = pRecord.ViewContext;
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}
		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}

		let tmpRenderGUID = this.pict.getUUID();
		let tmpResult = '';

		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[pRecord.RecordSet]?.FilterClauses || [];
		//FIXME: lookup by hash instead?
		for (let i = 0; i < tmpClauses.length; i++)
		{
			const tmpClause = tmpClauses[i];
			/** @type {import('../views/filters/RecordSet-Filter-Base.js')} */
			const tmpView = this._getViewForFilterClause(tmpClause);
			if (!tmpView)
			{
				continue;
			}

			const tmpRecord = Object.assign({}, pRecord, tmpClause);
			//tmpRecord.ClauseAddress = `Bundle._ActiveFilterState['${pRecord.RecordSet}'].FilterClauses[${i}]`;
			tmpRecord.ClauseAddress = `_ActiveFilterState[\`${pRecord.RecordSet}\`].FilterClauses[${i}]`;
			tmpView.prepareRecord(tmpRecord);
			tmpView.renderWithScope(tmpClause, '__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, tmpRecord, pState && pState.RootRenderable);

			tmpResult += this.pict.__TemplateOutputCache[tmpRenderGUID];
			// TODO: Uncomment this when we like how it's working
			//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

		}
		return tmpResult;
	}

	/**
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to call with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set specified in record`);
			return fCallback(null, '');
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set configuration found for [${tmpRecordSet}]`);
			return fCallback(null, '');
		}
		let tmpViewContext = pRecord.ViewContext;
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}

		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}

		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[pRecord.RecordSet]?.FilterClauses || [];
		if (tmpClauses.length === 0)
		{
			return fCallback(null, '');
		}

		// Snapshot the current render epoch so the deferred drain below can
		// detect a filter re-render that happened between schedule time and
		// now (see class doc-comment, "Render-epoch race guard").
		const tmpFiltersView = this.pict.views['PRSP-Filters'];
		const tmpRenderEpoch = tmpFiltersView ? tmpFiltersView._renderEpoch : 0;

		const tmpResults = new Array(tmpClauses.length).fill('');
		const tmpDeferredDrains = [];
		let tmpRemaining = tmpClauses.length;
		let tmpCallbackFired = false;

		const tmpFinalize = () =>
		{
			if (tmpCallbackFired || tmpRemaining > 0)
			{
				return;
			}
			tmpCallbackFired = true;
			// Fire the dashboard callback first so the paint lands on the
			// current tick, then defer the filters' onAfterRender work (which
			// runs pict-section-form's input-initialize pass and fires any
			// EntityBundleRequest REST calls) to the next macrotask.
			fCallback(null, tmpResults.join(''));
			if (tmpDeferredDrains.length === 0)
			{
				return;
			}
			setTimeout(() =>
			{
				// Epoch guard: bail out if a newer render has invalidated us.
				if (tmpFiltersView && tmpFiltersView._renderEpoch !== tmpRenderEpoch)
				{
					return;
				}
				for (let d = 0; d < tmpDeferredDrains.length; d++)
				{
					try
					{
						tmpDeferredDrains[d]();
					}
					catch (pError)
					{
						this.log.warn(`Pict: Filter Instance Views Template Render: Error draining deferred filter transaction`, pError);
					}
				}
			}, 0);
		};

		//FIXME: lookup by hash instead?
		for (let i = 0; i < tmpClauses.length; i++)
		{
			const tmpClause = tmpClauses[i];
			/** @type {import('../views/filters/RecordSet-Filter-Base.js')} */
			const tmpView = this._getViewForFilterClause(tmpClause);
			if (!tmpView)
			{
				tmpRemaining--;
				continue;
			}

			const tmpRenderGUID = this.pict.getUUID();
			const tmpRecord = Object.assign({}, pRecord, tmpClause);
			tmpRecord.ClauseAddress = `_ActiveFilterState[${pRecord.RecordSet}].FilterClauses[${i}]`;
			tmpView.prepareRecord(tmpRecord);

			// Synthetic per-filter root renderable: nested virtual-assignment
			// renders from this filter's subtree push into the filter's own
			// transaction queue instead of the dashboard's.
			const tmpFilterTransactionHash = `FilterInstance-${tmpView.Hash}-${tmpRenderGUID}`;
			this.pict.TransactionTracking.registerTransaction(tmpFilterTransactionHash);
			/** @type {import('pict-view').Renderable} */
			const tmpFilterRootRenderable =
			{
				RenderableHash: '__Virtual',
				TemplateHash: null,
				ContentDestinationAddress: null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: tmpFilterTransactionHash,
				RootRenderableViewHash: tmpView.Hash,
			};

			tmpDeferredDrains.push(() =>
			{
				tmpView.onAfterRenderAsync(() =>
				{
					// Remove the per-filter transaction we registered above
					// once its drain completes. Pict-View will also attempt
					// to unregister during its own onAfterRenderAsync chain;
					// whichever call hits first wins, the other is a no-op.
					this.pict.TransactionTracking.unregisterTransaction(tmpFilterTransactionHash);
				}, tmpFilterRootRenderable);
			});

			tmpView.renderWithScopeAsync(tmpClause, '__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, tmpRecord, tmpFilterRootRenderable,
				(pError) =>
				{
					if (pError)
					{
						this.log.warn(`Pict: Filter Instance Views Template Render: Error rendering view [${tmpView.Hash}]`, pError);
						//TODO: should we fail the whole render?
						tmpResults[i] = '';
					}
					else
					{
						tmpResults[i] = this.pict.__TemplateOutputCache[tmpRenderGUID] || '';
						// TODO: Uncomment this when we like how it's working
						//delete this.pict.__TemplateOutputCache[tmpRenderGUID];
					}
					tmpRemaining--;
					tmpFinalize();
				});
		}
		// Handle the case where every filter was skipped synchronously (no valid view).
		tmpFinalize();
	}
}

module.exports = PictTemplateFilterInstanceViewInstruction;

},{"../views/filters/index.js":670,"pict-template":691}],623:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Specialized instruction for rendering the filter view and plumbing in required context.
 *
 * Based on the Pict base {~V:...~} template instruction.
 */
class PictTemplateFilterViewInstruction extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~FV:', '~}');
		this.addPattern('{~FilterView:', '~}');


		if (!('__TemplateOutputCache' in this.pict))
		{
			this.pict.__TemplateOutputCache = {};
		}
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let [ tmpViewHash, tmpViewContext ] = pTemplateHash.split(':');
		tmpViewHash = tmpViewHash.trim();
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set specified in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return '';
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set configuration found for [${tmpRecordSet}] in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return '';
		}
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: Filter View Template Render: View not found for [${tmpViewHash}]`);
			return '';
		}

		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}

		let tmpRenderGUID = this.pict.getUUID();

		/** @type {import('pict-view')} */
		const tmpView = this.pict.views[tmpViewHash];

		tmpView.render('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState && pState.RootRenderable);

		let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
		// TODO: Uncomment this when we like how it's working
		//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

		return tmpResult;
	}

	/**
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to call with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let [ tmpViewHash, tmpViewContext ] = pTemplateHash.split(':');
		tmpViewHash = tmpViewHash.trim();
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set specified in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return fCallback(null, '');
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set configuration found for [${tmpRecordSet}] in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return fCallback(null, '');
		}
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: Filter View Template Render: View not found for [${tmpViewHash}]`);
			return fCallback(null, '');
		}

		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}
		let tmpRenderGUID = this.pict.getUUID();

		/** @type {import('pict-view')} */
		const tmpView = this.pict.views[tmpViewHash];

		return tmpView.renderAsync('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState && pState.RootRenderable,
			(pError, pResult) =>
			{
				if (pError)
				{
					this.log.warn(`Pict: Filter View Template Render: Error rendering view [${tmpViewHash}]`, pError);
					return fCallback(pError, '');
				}

				let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
				// TODO: Uncomment this when we like how it's working
				//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

				return fCallback(null, tmpResult);
			});
	}
}

module.exports = PictTemplateFilterViewInstruction;

},{"pict-template":691}],624:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * The `{~RecordCard:RecordSet^IDAddress^Label~}` template tag — drops an inline preview-card trigger
 * (a label + a small icon) anywhere a record is referenced (lists, record views, dashboards). Clicking
 * it opens the recordset's configured preview card in an anchored popover (see RecordSet-CardManager).
 *
 * Three `^`-separated parts (the third is optional):
 *   1. RecordSet name (literal, e.g. `Author`).
 *   2. The record id — a literal number OR an address resolved against the current data (`Record.IDAuthor`).
 *   3. The visible label — an address (`Record.Name`) OR a literal string. Defaults to the id.
 *
 * Unlike `{~E:~}` this renders synchronously (no fetch): it only emits the trigger; the record is fetched
 * lazily on click. When no card is registered for the recordset it degrades to the plain label.
 */
class PictTemplateProviderRecordCard extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~RecordCard:', '~}');
		this.addPattern('{~RC:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		const tmpParts = String(pTemplateHash).trim().split('^');
		if (tmpParts.length < 2)
		{
			this.log.warn(`Pict: RecordCard tag needs at least RecordSet^id — got [${pTemplateHash}].`);
			return '';
		}

		let tmpRecordSet = tmpParts[0].trim();
		let tmpID = tmpParts[1].trim();
		let tmpLabel = (tmpParts.length > 2) ? tmpParts[2].trim() : '';

		// Resolve the recordset: a literal name stays, an address (Record./AppData.) is looked up. This
		// lets a shared template (e.g. an association row) drive the card's recordset from data — an empty
		// result degrades to the plain label.
		if (/^(Record|AppData)[.[]/.test(tmpRecordSet))
		{
			tmpRecordSet = this.resolveStateFromAddress(tmpRecordSet, pRecord, pContextArray, null, pScope, pState);
		}

		// Resolve the id: a literal number stays, otherwise it is an address into the data.
		if (isNaN(Number(tmpID)))
		{
			tmpID = this.resolveStateFromAddress(tmpID, pRecord, pContextArray, null, pScope, pState);
		}

		// Resolve the label: an address (Record./AppData.) is looked up, otherwise it is a literal.
		if (tmpLabel && /^(Record|AppData)[.[]/.test(tmpLabel))
		{
			tmpLabel = this.resolveStateFromAddress(tmpLabel, pRecord, pContextArray, null, pScope, pState);
		}
		if (tmpLabel == null || tmpLabel === '')
		{
			tmpLabel = (tmpID == null) ? '' : String(tmpID);
		}

		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpManager)
		{
			return String(tmpLabel);
		}
		return tmpManager.triggerHTML(tmpRecordSet, tmpID, tmpLabel);
	}

	/** Async entry just defers to the synchronous render (no fetch happens here — it is click-driven). */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : () => '';
		return tmpCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}
}

module.exports = PictTemplateProviderRecordCard;

},{"pict-template":691}],625:[function(require,module,exports){
const libPictView = require('pict-view');

const _DEFAULT_CONFIGURATION_FilterPersistenceView = (
{
	ViewIdentifier: 'FilterPersistenceView',

	DefaultRenderable: 'FilterPersistenceView-Container',
	DefaultDestinationAddress: '#FilterPersistenceView-Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: /*css*/`
.prsp-exp { display: flex; flex-direction: column; gap: 0.4rem; }
.prsp-exp-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
.prsp-exp-row { display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem; }
.prsp-exp-row > span:empty { display: none; }
.prsp-exp-select, .prsp-exp-name { font: inherit; font-size: 0.9rem; padding: 0.42rem 0.6rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-exp-select { flex: 0 0 auto; width: 230px; min-width: 0; max-width: 100%; }
/* When a host layers select2 (or a similar widget) on the stored-filter <select>, its container
   defaults to display:block at the row's full width, pushing Save/Delete onto a second line. Pin it to
   a fixed-width inline flex item so the controls stay on one row. */
.prsp-exp-row .select2-container { flex: 0 0 auto !important; display: inline-block !important; width: 230px !important; max-width: 100%; vertical-align: middle; }
.prsp-exp-select:focus, .prsp-exp-name:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.prsp-exp-btn { flex: 0 0 auto; white-space: nowrap; }
.prsp-exp-validation { font-size: 0.8rem; color: var(--theme-color-status-error, #cf5b5b); }
.prsp-exp-validation:empty { display: none; }
`,
	CSSPriority: 500,

	Templates:
		[
			{
			Hash: 'FilterPersistenceView-Container',
			Template: /*html*/`
<!-- DefaultPackage pict view template: [FilterPersistenceView-Container] -->
<div id="FilterPersistenceView-Content" class="prsp-exp">
	<span class="prsp-exp-label">Filter experience</span>
	<div class="prsp-exp-row">
		<select id="FilterPersistenceView-StoredFiltersSelect" class="prsp-exp-select" name="StoredFilterName" title="Load a saved filter experience"
			onchange="_Pict.views['FilterPersistenceView'].setFilterExperienceToSelection(event); _Pict.views['FilterPersistenceView'].loadFilterPersistenceSettings(event);">
			<!-- Options populated dynamically -->
		</select>
		<button type="button" class="prsp-filters-btn-text prsp-exp-btn" id="FilterPersistenceView-SaveFilterButton" title="Save the current search + filters as a named experience" onclick="_Pict.views['FilterPersistenceView'].promptSaveFilterExperience(event)">Save</button>
		<button type="button" class="prsp-filters-btn-text prsp-exp-btn" id="FilterPersistenceView-DeleteFilterButton" title="Delete the selected experience" onclick="_Pict.views['FilterPersistenceView'].deleteFilterPersistenceSettings(event)">Delete</button>
	</div>
	<span id="FilterPersistenceView-CurrentFilterNameInput-ValidationMessage" class="prsp-exp-validation"></span>
</div>
<!-- DefaultPackage end view template:  [FilterPersistenceView-Container] -->
		`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'FilterPersistenceView-Renderable',
				TemplateHash: 'FilterPersistenceView-Container',
				DestinationAddress: '#FilterPersistenceView-Container',
				RenderMethod: 'replace'
			},

		],

	Manifests: {}
});

class viewFilterPersistenceView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_FilterPersistenceView, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.currentRecordSet = null;
		this.currentViewContext = null;
		this.filterExperienceSelection = null;
		this.filterExperienceInitialized = false;
	}

	/**
	 * Re-assert this view's own template before rendering so a host/server template override
	 * doesn't replace the slimmed experiences control (mirrors RecordSet-Filters).
	 *
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		if (this.pict.TemplateProvider && Array.isArray(_DEFAULT_CONFIGURATION_FilterPersistenceView.Templates))
		{
			for (const tmpTemplate of _DEFAULT_CONFIGURATION_FilterPersistenceView.Templates)
			{
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template);
			}
		}
		return super.onBeforeRender(pRenderable);
	}
	

	/**
	 * Initializes the filter persistence view UI for a given record set and view context. This will render the UI and populate it with the relevant filter experiences for the given context.
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {function} pCallback - A callback function to be executed after initializing the UI.
	 * @returns {boolean} - Returns true when the UI has been initialized.
	 */
	initializeFilterPersistenceViewUI(pRecordSet, pViewContext, pCallback)
	{
		if (!pRecordSet || !pViewContext)
		{
			this.pict.log.error('RecordSet and ViewContext are required to open the Filter Persistence UI.');
			return false;
		}

		if (!this.filterExperienceInitialized)
		{
			this.pict.providers.FilterDataProvider.initializeFilterExperienceSettings(pRecordSet, pViewContext);
			this.filterExperienceInitialized = true;
		}
		this.currentRecordSet = pRecordSet;
		this.currentViewContext = pViewContext;
		// Implement the logic for toggling filter persistence UI here
		this.render('FilterPersistenceView-Renderable', undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		
		// set checkbox for "Remember Last Used Filter Experience" based on provider setting
		const checkboxElement = document.getElementById('OptionalSettings-RememberLastUsed');
		if (checkboxElement)
		{
			// @ts-ignore
			checkboxElement.checked = this.pict.providers.FilterDataProvider.getRememberLastUsedFilterExperience(this.currentRecordSet, this.currentViewContext);
		}
		// build the select options for available filter experiences
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.handleModifiedFiltersState();

		// if a callback function was provided, execute it after the UI has been generated
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		};
		return true;
	}

	/**
	 * Updates the current filter experience name in the input field based on the current filter experience applied for the given record set and view context. This is used to ensure that if the filter experience was modified outside of the UI (ex: through the URL hash), we can reflect that in the input field and also handle the button states accordingly to prevent unintended consequences of saving in an invalid state.
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {boolean} pIgnoreCurrentExperienceURLParam - Whether to ignore the current experience when updating the input field, use this when in a modified state and the url is now outdated, to generate a new name.
	 */
	updateDisplayNameInputWithCurrentFilterExperience(pRecordSet, pViewContext, pIgnoreCurrentExperienceURLParam = false)
	{
		const tmpFilterExperienceList = this.pict.providers.FilterDataProvider.getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext);
		// get the current filter experience hash from the URL
		const tmpExperienceURLParam = this.pict.providers.PictRouter?.router?.current?.[0].hashString?.split?.('/FilterExperience/')?.[1] || '';
		// look in the map for the filter experience with the given hash
		const filterExperiences = this.pict.providers.FilterDataProvider.getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext);
		// BUG?: We are doing a double lookup here to match both the name and the encoded URL param, because just looking up by URL param alone can lead to issues if there are multiple experiences with the same URL param but different names.
		const matchingExperience = filterExperiences.find((pExperience) => pExperience.FilterExperienceHash === tmpFilterExperienceList.find((exp) => exp.FilterExperienceEncodedURLParam === tmpExperienceURLParam)?.FilterExperienceHash);
		// If we found a matching experience (both name and encoded URL param), set it as the current filter name and the active selection in the selector	
		if (!pIgnoreCurrentExperienceURLParam && matchingExperience && (matchingExperience.FilterExperienceEncodedURLParam === tmpExperienceURLParam))
		{
			this.pict.providers.FilterDataProvider.setCurrentFilterName(matchingExperience, pRecordSet, pViewContext);
			this.filterExperienceSelection = matchingExperience.FilterExperienceHash;
			// check if the current filter experience is set as default on load, so we can set the button states accordingly
			const isDefault = this.pict.providers.FilterDataProvider.isDefaultFilterExperience(pRecordSet, pViewContext, this.filterExperienceSelection);
			this.handleSelectionButtonStates(isDefault);
		}
		else
		{
			this.pict.providers.FilterDataProvider.setCurrentFilterName(null, pRecordSet, pViewContext, null);
			this.filterExperienceSelection = null;
			this.handleSelectionButtonStates(null);
		}
	}

	/**
	 * Toggles the filter persistence UI for a given record set and view context
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {function} pCallback - A callback function to be executed after toggling the UI.
	 * @returns {boolean} - Returns true when the UI has been toggled.
	 */
	openFilterPersistenceUI(pRecordSet, pViewContext, pCallback)
	{
		// hide the button that was just clicked on (will use a different button to close the UI)
		if (document.getElementById('PRSP_Filter_Button_Manage'))
		{
			document.getElementById('PRSP_Filter_Button_Manage').style.display = 'none';
		}
		// render the UI for managing filter persistence settings
		this.initializeFilterPersistenceViewUI(pRecordSet, pViewContext, pCallback);
		return true;
	}
	
	/**
	 * Handles the state of the filter experience when it has been modified from the URL hash instead of through the UI, which can lead to an invalid state for saving if the user tries to save without realizing the current experience was modified outside of the UI.
	 * This method will show a warning message and disable the save/set as default/remove as default/delete buttons to prevent unintended consequences of saving in that state, and will prompt the user to load a filter experience through the UI or refresh the page to reset the state before they can save. It will also disable the current filter name input and set a warning message in it to indicate that the user needs to apply or reset filters changes to be able to save settings. If the filter experience is not in that modified state, it will ensure the buttons are enabled and the current filter name input is enabled and populated with the current filter experience name for better visibility when saving.
	 */
	handleModifiedFiltersState()
	{
		// if the current filter experience was modified from the URL hash, show a warning toast to the user that they need to load a filter experience through the UI or refresh the page to reset the state before they can save, since saving in that state could lead to unintended consequences of saving an unintended filter experience as the default or overwriting an existing filter experience without realizing it
		if (this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash)
		{
			// disable the save and set as default buttons to prevent saving in this state
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SaveFilterButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-DeleteFilterButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-CurrentFilterNameInput-ValidationMessage', 'Please apply or reset filter changes to enable saving settings.');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'title', 'The current filter experience has been modified. Please apply or reset filter changes to enable saving settings and set a default filter experience.');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'disabled', 'disabled');
		}
		else
		{
			// re-enable the buttons in case they were disabled from being in a modified state, to allow saving and setting default again
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-SaveFilterButton', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-SetAsDefaultButton', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-DeleteFilterButton', 'disabled');
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-CurrentFilterNameInput-ValidationMessage', '');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'title', '');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'disabled');
		}
		// regardless of the modified state, update the current filter name input to match the current filter experience for better visibility when saving and to ensure it reflects any changes that may have happened to the filter experience from the URL hash or elsewhere
		this.updateDisplayNameInputWithCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash);
	}

	/**
	 * Updates the filter experience settings for a given record set and view context.
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {object} pSettings - The settings to update.
	 * @returns {boolean} - Returns true when the settings have been updated.
	 */
	updateFilterExperienceSettings(pRecordSet, pViewContext, pSettings)
	{
		if (pRecordSet && pViewContext)
		{
			this.pict.providers.FilterDataProvider.initializeFilterExperienceSettings(pRecordSet, pViewContext);
			this.currentRecordSet = pRecordSet;
			this.currentViewContext = pViewContext;
			// for any settings that may have changed, update those without replacing the whole settings object
			this.pict.providers.FilterDataProvider.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, pSettings);
			// build the select options for available filter experiences
			this.buildSelectOptionsForAvailableFilterExperiences();
		}
		return true;
	}

	/**
	 * Sets the filter experience to load based on user selection.
	 * @param {Event} event - The event object.
	 * @returns {boolean} - Returns true when the filter experience has been set.
	 */
	setFilterExperienceToSelection(event)
	{
		event.preventDefault();
		event.stopPropagation();

		this.filterExperienceSelection = this.pict.ContentAssignment.readContent('#FilterPersistenceView-StoredFiltersSelect');
		// check if the selected filter experience is set as default on load, so we can set the button states accordingly
		const isDefault = this.pict.providers.FilterDataProvider.isDefaultFilterExperience(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection);
		this.handleSelectionButtonStates(isDefault);
		// set the current filter name in the provider to match the selection
		const tmpSelectedFilterExperience = this.pict.providers.FilterDataProvider.getFilterExperienceByHash(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection);
		let tmpBackupDisplayName = '';
		if (!tmpSelectedFilterExperience)
		{
			tmpBackupDisplayName = `New ${this.currentRecordSet} ${this.currentViewContext} Filter`;
		}
		this.pict.providers.FilterDataProvider.setCurrentFilterName(tmpSelectedFilterExperience, this.currentRecordSet, this.currentViewContext, tmpBackupDisplayName);
		// update the save button to text to be "Update" instead of "Save" if the selected filter experience is the current one, to indicate that clicking it will update the existing filter experience instead of creating a new one
		if (this.filterExperienceSelection && this.pict.providers.FilterDataProvider.isCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection))
		{	
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonTextText', 'Update');
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonTextText', 'Save');
		}
		return true;
	}

	/**
	 * Closes the filter persistence UI.
	 * @returns {boolean} - Returns true when the UI has been closed.
	 */
	closeFilterPersistenceUI()
	{
		this.currentRecordSet = null;
		this.currentViewContext = null;
		this.filterExperienceSelection = null;
		this.handleSelectionButtonStates(null);
		// show the button that was hidden when opening the UI
		if (document.getElementById('PRSP_Filter_Button_Manage'))
		{
			document.getElementById('PRSP_Filter_Button_Manage').style.display = 'inline-block';
		}
		// Clear the content of the Filter Persistence View (if it's still on the DOM - it will re-render next time it's opened either way, but this is to ensure we don't have stale content if the view is still around in the DOM)
		if (document.getElementById('FilterPersistenceView-Content'))
		{
			document.getElementById('FilterPersistenceView-Content').innerHTML = '';
		}
		return true;
	}

	/**
	 * Builds the select options for available filter experiences. Sets the current filter as selected and indicates it in the option text.
	 * @returns {boolean} - Returns true when the options have been built.
	 */
	buildSelectOptionsForAvailableFilterExperiences()
	{
		let optionList = []
		const filterExperienceList = this.pict.providers.FilterDataProvider.getAllFiltersExperiencesForRecordSet(this.currentRecordSet, this.currentViewContext);
		// add a default option at the top
		optionList.push('<option value="">-- Select a stored Filter Experience --</option>');
		// iterate through the filter experiences and build the option elements
		for (const key in filterExperienceList)
		{ 
			// skip excluded ones (if needed for hidden/internal use)
			if (filterExperienceList[key].ExcludedFromSelection) 
			{
				continue;
			}
			// if the current filter is the active/default one, mention that in the option text for clarity
			const isCurrent = this.pict.providers.FilterDataProvider.isCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, filterExperienceList[key].FilterExperienceHash);
			const isDefault = this.pict.providers.FilterDataProvider.isDefaultFilterExperience(this.currentRecordSet, this.currentViewContext, filterExperienceList[key].FilterExperienceHash);
			let addOnText = '';
			if (isCurrent)
			{
				addOnText += ' (Current)';
			}
			if (isDefault)
			{
				addOnText += ' (Default)';
			}
			const optionElement = `<option ${ isCurrent ? 'selected' : ''} value="${filterExperienceList[key].FilterExperienceHash}">${filterExperienceList[key].FilterDisplayName || filterExperienceList[key].FilterExperienceHash}${addOnText}</option>`;
			optionList.push(optionElement);
		}
		/* @type {HTMLSelectElement} */
		const storedFiltersSelect = document.getElementById('FilterPersistenceView-StoredFiltersSelect');
		if (storedFiltersSelect)
		{
			storedFiltersSelect.innerHTML = optionList.join('\n');
		}
		// after rebuilding the options, if there is a current selection, ensure the save button text is correct based on whether the current selection is the active filter experience or not
		if (this.filterExperienceSelection && this.pict.providers.FilterDataProvider.isCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection))
		{	
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonText', 'Update');
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonText', 'Save');
		}
		return true;
	}

	/**
	 * Toggles the "Remember Last Used Filter Experience" setting in the Filter Data Provider.
	 * @param {Event} event - The event object.
	 * @returns {boolean} - Returns true when the setting has been toggled.
	 */
	toggleRememberLastUsedFilterExperience(event)
	{
		event.preventDefault();
		event.stopPropagation();

		const checkboxElement = document.getElementById('OptionalSettings-RememberLastUsed');
		// @ts-ignore
		const rememberLastUsed = checkboxElement ? checkboxElement.checked : false;

		this.pict.providers.FilterDataProvider.setRememberLastUsedFilterExperience(this.currentRecordSet, this.currentViewContext, rememberLastUsed);
		this.pict.log.info(`Remember Last Used Filter Experience has been ${rememberLastUsed ? 'enabled' : 'disabled'}.`);
		return true;
	}

	/**
	 * Loads the filter persistence settings for the current selection of filter experiences.
	 * @param {Event} event - The event object.
	 * @returns {boolean} - Returns true when the settings have been loaded.
	 */
	loadFilterPersistenceSettings(event, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();
		const selectedFilterExperienceHash = this.filterExperienceSelection;
		if (!selectedFilterExperienceHash)
		{
			this.pict.log.warn('No filter experience selected to load.');
			return false;
		}
		this.pict.providers.FilterDataProvider.loadFilterMeta(this.currentRecordSet, this.currentViewContext, selectedFilterExperienceHash);
		this.pict.log.info(`Filter persistence settings have been loaded for filter: ${selectedFilterExperienceHash}`);
		this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = false;
		// if a callback function was provided, execute it after loading the settings (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}

	/**
	 * Saves the filter persistence settings for the current selection of filter experiences.
	 * @param {Event} event - The event object.
	 * @param {function} [pCallback] - A callback function to be executed after saving the settings.
	 * @returns {boolean} - Returns true when the settings have been saved.
	 */
	/** HTML-escape a value for safe display in the modal. */
	_escapeHTML(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	/** Describe a single active filter clause in plain English (e.g. "Date Created between A and B"). */
	_describeFilterClause(pClause)
	{
		const tmpLabel = pClause.Label || pClause.FilterByColumn || 'Filter';
		const tmpType = String(pClause.Type || '');
		const tmpValues = Array.isArray(pClause.Values) ? pClause.Values.filter((v) => v !== null && v !== undefined && v !== '') : [];
		const tmpValue = (pClause.Value !== null && pClause.Value !== undefined && pClause.Value !== '') ? pClause.Value : null;
		if (/Range/i.test(tmpType))
		{
			const tmpLow = (tmpValues.length > 0) ? tmpValues[0] : (tmpValue != null ? tmpValue : '…');
			const tmpHigh = (tmpValues.length > 1) ? tmpValues[1] : '…';
			return `${tmpLabel} between ${tmpLow} and ${tmpHigh}`;
		}
		if (/Select/i.test(tmpType))
		{
			const tmpList = tmpValues.length ? tmpValues : (tmpValue != null ? [ tmpValue ] : []);
			return tmpList.length ? `${tmpLabel} is ${tmpList.join(', ')}` : `${tmpLabel} is set`;
		}
		const tmpSingle = (tmpValue != null) ? tmpValue : (tmpValues.length ? tmpValues.join(', ') : null);
		const tmpOp = pClause.ExactMatch ? 'is' : 'contains';
		return (tmpSingle != null) ? `${tmpLabel} ${tmpOp} "${tmpSingle}"` : `${tmpLabel} is set`;
	}

	/**
	 * @returns {{ summary: string, count: string }} A plain-English summary of the current
	 * search + filter clauses, and the matched record count (from the rendered list total).
	 */
	_describeCurrentFilter()
	{
		const tmpParts = [];
		const tmpFilterView = this.pict.views['PRSP-Filters'];
		const tmpSearchTerm = (tmpFilterView && typeof tmpFilterView._searchTermFromURL === 'function') ? tmpFilterView._searchTermFromURL() : '';
		if (tmpSearchTerm)
		{
			const tmpCfg = this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.recordSetProviderConfigurations
				? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this.currentRecordSet] : null;
			const tmpFields = (tmpCfg && Array.isArray(tmpCfg.SearchFields) && tmpCfg.SearchFields.length) ? tmpCfg.SearchFields : [ 'Name' ];
			tmpParts.push(`${tmpFields.join(' / ')} like "${tmpSearchTerm}"`);
		}
		const tmpClauses = (this.pict.Bundle._ActiveFilterState[this.currentRecordSet] || {}).FilterClauses || [];
		for (const tmpClause of tmpClauses) { tmpParts.push(this._describeFilterClause(tmpClause)); }
		const tmpSummary = tmpParts.length ? (tmpParts.join('. ') + '.') : 'No filters — matches all records.';
		const tmpCountEl = document.getElementById('PRSP_Pagination_Description_Records_Total');
		const tmpCount = (tmpCountEl && tmpCountEl.textContent) ? tmpCountEl.textContent.trim() : '';
		return { summary: tmpSummary, count: tmpCount };
	}

	/**
	 * Prompt for a name (via pict-section-modal when available) and save the current search +
	 * filters as a named experience. The modal previews the filter in plain English and the
	 * number of records it matches. Falls back to the generated name with no prompt if the
	 * modal section is not registered in the host app.
	 *
	 * @param {Event} pEvent
	 */
	promptSaveFilterExperience(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); pEvent.stopPropagation(); }
		if (!this.currentRecordSet || !this.currentViewContext) { return false; }
		const tmpProvider = this.pict.providers.FilterDataProvider;
		if (tmpProvider.filterExperienceModifiedFromURLHash)
		{
			this.pict.log.warn('The current filter experience was modified from the URL hash; apply or reset before saving.');
			return false;
		}
		const tmpClauses = (this.pict.Bundle._ActiveFilterState[this.currentRecordSet] || {}).FilterClauses || [];
		const tmpCurrent = this.filterExperienceSelection ? tmpProvider.getFilterExperienceByHash(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection) : null;
		const tmpSuggested = (tmpCurrent && tmpCurrent.FilterDisplayName) || tmpProvider.generateContextualDefaultFilterName({ FilterClauses: tmpClauses }, this.currentRecordSet, this.currentViewContext);

		const fSave = (pName) =>
		{
			tmpProvider.saveFilterMeta(this.currentRecordSet, this.currentViewContext, false, pName);
			this.buildSelectOptionsForAvailableFilterExperiences();
			this.pict.log.info(`Filter experience '${pName}' saved.`);
		};

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			fSave(tmpSuggested);
			return true;
		}
		const tmpEscaped = this._escapeHTML(tmpSuggested);
		const tmpDescription = this._describeCurrentFilter();
		const tmpCountLine = tmpDescription.count
			? `<p style="margin:0 0 0.8rem;color:var(--theme-color-text-secondary,#45505f);">Matches <strong>${this._escapeHTML(tmpDescription.count)}</strong> record${tmpDescription.count === '1' ? '' : 's'}.</p>`
			: '';
		tmpModal.show(
			{
				title: 'Save filter experience',
				content: `<p style="margin:0 0 0.75rem;color:var(--theme-color-text-secondary,#45505f);font-size:0.9rem;line-height:1.45;">Give this filter a name to save it, then load it again any time to come back to these records, or whatever matches it down the road.</p><div style="margin-bottom:0.6rem;padding:0.6rem 0.8rem;border-radius:8px;background:var(--theme-color-background-tertiary,#eceef2);font-size:0.9rem;line-height:1.4;color:var(--theme-color-text-primary,#1f2733);">${this._escapeHTML(tmpDescription.summary)}</div>${tmpCountLine}<p style="margin-bottom:0.4rem;">Name this filter experience:</p><input type="text" id="prsp-exp-name-input" class="pict-input" style="width:100%;" value="${tmpEscaped}" autofocus>`,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Save', Style: 'primary' } ],
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				const tmpEl = document.getElementById('prsp-exp-name-input');
				const tmpName = (tmpEl && tmpEl.value && tmpEl.value.trim()) ? tmpEl.value.trim() : tmpSuggested;
				fSave(tmpName);
			});
		return true;
	}

	saveFilterPersistenceSettings(event, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();

		if (!this.currentRecordSet || !this.currentViewContext)
		{
			this.pict.log.warn('Missing a record set or view context to save filter persistence settings. Skipping save. CurrentRecordSet: ' + this.currentRecordSet + ', CurrentViewContext: ' + this.currentViewContext + ')');
			return false;
		}

		if (this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash)
		{
			this.pict.log.warn('The current filter experience has been modified from the URL hash and not through the UI, so it may not be in a valid state to save. Please load a filter experience through the UI or refresh the page to reset the state before saving.');
			return false;
		}

		this.pict.providers.FilterDataProvider.saveFilterMeta(this.currentRecordSet, this.currentViewContext, false);
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.pict.log.info('Filter persistence settings have been saved.');
		// if a callback function was provided, execute it after saving the settings (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}

	/**
	 * Sets the filter experience as the default for the current record set and view context.
	 * @param {Event} event - The event object.
	 * @param {boolean} isDefault - Whether to set as default or not.
	 * @param {function} [pCallback] - A callback function to be executed after toggling the default setting.
	 * @returns {boolean} - Returns true when the settings have been set as default.
	 */
	toggleFilterExperienceAsTheDefault(event, isDefault, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();

		const selectedFilterExperienceHash = this.filterExperienceSelection;
		if (!selectedFilterExperienceHash)
		{
			this.pict.log.warn('No filter experience selected to set as default.');
			return false;
		}
		// set or unset the default filter experience on load in the provider
		this.pict.providers.FilterDataProvider.setDefaultFilterExperience(this.currentRecordSet, this.currentViewContext, selectedFilterExperienceHash, isDefault);
		this.handleSelectionButtonStates(isDefault);
		
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.pict.log.info(`Filter experience ${selectedFilterExperienceHash} has been ${isDefault ? 'set' : 'unset'} as the default on load.`);
		// if a callback function was provided, execute it after setting the default (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}

	/**
	 * Handles the button states for the filter experience selection.
	 * @param {boolean} isDefault - Whether the filter experience is set as default or not.
	 */
	handleSelectionButtonStates(isDefault)
	{
		if (!this.filterExperienceSelection)
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-LoadFilterButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-DeleteFilterButton', 'style', 'display: none;');
			return;
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-LoadFilterButton', 'style', 'display: inline-block;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-DeleteFilterButton', 'style', 'display: inline-block;');
		}
		// handle the set/remove default buttons separately when we have a selection
		if (isDefault)
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'style', 'display: inline-block;');
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'style', 'display: inline-block;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'style', 'display: none;');
		}
	}

	/**
	 * Deletes the filter persistence settings for the current selection of filter experiences.
	 * @param {Event} event - The event object.
	 * @param {function} [pCallback] - A callback function to be executed after deleting the settings.
	 * @returns {boolean} - Returns true when the settings have been deleted.
	 */
	deleteFilterPersistenceSettings(event, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();

		const selectedFilterExperienceHash = this.filterExperienceSelection;
		if (!selectedFilterExperienceHash)
		{
			this.pict.log.warn('No filter experience selected to delete.');
			return false;
		}
		this.pict.providers.FilterDataProvider.removeFilterMeta(this.currentRecordSet, this.currentViewContext, selectedFilterExperienceHash);
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.pict.log.info(`Filter persistence settings have been deleted for filter: ${selectedFilterExperienceHash}`);
		// if a callback function was provided, execute it after deleting the settings (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}
}

module.exports = viewFilterPersistenceView;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_FilterPersistenceView;
},{"pict-view":693}],626:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_SUBSET_Filter =
{
	ViewIdentifier: 'PRSP-SUBSET-Filters',

	DefaultRenderable: 'PRSP_Renderable_Filters',
	DefaultDestinationAddress: '#PRSP_Filters_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: /*css*/`
.prsp-filters { width: 100%; }
.prsp-filters *, .prsp-filters *::before, .prsp-filters *::after { box-sizing: border-box; }
.prsp-filters-bar { display: flex; align-items: center; gap: 0.5rem; margin: 0; }
.prsp-filters-search { position: relative; flex: 1 1 auto; display: flex; align-items: center; min-width: 0; }
.prsp-filters-search-ic { position: absolute; left: 0.75rem; display: inline-flex; align-items: center; color: var(--theme-color-text-muted, #6b7686); pointer-events: none; font-size: 0.95rem; }
.prsp-filters-input { width: 100%; font: inherit; font-size: 0.95rem; padding: 0.5rem 0.85rem 0.5rem 2.2rem;
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px;
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-filters-input:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.prsp-filters-toggle { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.4rem; font: inherit; cursor: pointer;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-secondary, #45505f); }
.prsp-filters-toggle:hover { border-color: var(--theme-color-brand-primary, #156dd1); }
.prsp-filters.has-filters .prsp-filters-toggle { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
.prsp-filters.drawer-open .prsp-filters-toggle { background: var(--theme-color-background-tertiary, #eceef2); }
.prsp-filters-toggle-ic { display: inline-flex; align-items: center; }
.prsp-filters-toggle-ic svg { width: 1.05em; height: 1.05em; display: block; }
.prsp-filters-toggle-count { display: none; align-items: center; justify-content: center; min-width: 1.3em; height: 1.3em;
	padding: 0 0.35em; border-radius: 999px; font-size: 0.74rem; font-weight: 700;
	background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-on-brand, #fff); }
.prsp-filters.has-filters .prsp-filters-toggle-count { display: inline-flex; }
.prsp-filters-apply { flex: 0 0 auto; font: inherit; font-weight: 650; cursor: pointer; padding: 0.5rem 1.15rem; border-radius: 8px;
	border: 1px solid var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-on-brand, #fff); }
.prsp-filters-apply:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 88%, #000); }
.prsp-filters-btn-text { font: inherit; cursor: pointer; padding: 0.4rem 0.85rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: transparent; color: var(--theme-color-text-secondary, #45505f); }
.prsp-filters-btn-text:hover { background: var(--theme-color-background-tertiary, #eceef2); }

/* Slide-out drawer (CSS grid trick: 0fr -> 1fr animates height). The inner is a *pure* clip box; all the
   visible card chrome lives on .prsp-filters-drawer-card inside it. That way, on collapse the chrome shrinks
   *with* the animating height instead of vanishing instantly — the old rule gated padding/border/background
   on .drawer-open, so closing the drawer stripped the card in one frame while the height still animated for
   0.18s, making the quick-filters bar look like it popped out of the panel before disappearing. */
.prsp-filters-drawer { display: grid; grid-template-rows: 0fr; transition: grid-template-rows 0.18s ease; }
.prsp-filters.drawer-open .prsp-filters-drawer { grid-template-rows: 1fr; }
.prsp-filters-drawer-inner { overflow: hidden; min-height: 0; }
.prsp-filters-drawer-card { margin-top: 0.6rem; padding: 0.95rem 1.1rem;
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; background: var(--theme-color-background-panel, #fff); }
.prsp-filters-add { position: relative; margin: 0.4rem 0 0.2rem; }
.prsp-addfilter-trigger { display: inline-flex; align-items: center; gap: 0.35rem; }
/* Drawer footer: filter experience on the left, Clear/Reset/Apply on the right. */
.prsp-filters-footer { display: flex; align-items: flex-end; justify-content: space-between; gap: 1.5rem; flex-wrap: wrap;
	margin-top: 0.85rem; padding-top: 0.75rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
.prsp-filters-experiences { flex: 0 1 auto; min-width: 0; }
.prsp-filters-actions { flex: 0 0 auto; display: flex; align-items: center; gap: 0.5rem; }

/* Quick Filters — a curated, one-interaction bar at the top of the drawer (above the clause list).
   Painted post-render into #PRSP_QuickFilters; hidden via :empty when the record set has none. */
.prsp-quickfilters { display: flex; align-items: center; flex-wrap: wrap; gap: 0.55rem 0.9rem;
	margin-bottom: 0.7rem; padding-bottom: 0.75rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.prsp-quickfilters:empty { display: none; }
.prsp-quickfilters-label { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b7686); }
.prsp-quickfilter { display: inline-flex; flex-direction: column; gap: 0.2rem; min-width: 0; }
.prsp-quickfilter-name { font-size: 0.72rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
.prsp-quickfilter-input { font: inherit; font-size: 0.9rem; width: 13rem; max-width: 100%; padding: 0.4rem 0.7rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-quickfilter-input:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.prsp-quickfilter-daterange { display: inline-flex; align-items: center; gap: 0.35rem; }
.prsp-quickfilter-date { width: 9.5rem; }
.prsp-quickfilter-dash { color: var(--theme-color-text-muted, #6b7686); }
/* Entity quick control: the pict-section-picker mounts into this host (its own .pps chrome themes it). */
.prsp-quickfilter-entityhost { display: inline-block; width: 14rem; max-width: 100%; vertical-align: middle; }
/* Show-deleted switch (RecordSetListShowDeletedFilter): a labeled checkbox in the drawer actions row.
   Painted post-render into the host label; :empty hides it for record sets that haven't opted in. */
.prsp-filters-showdeleted { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; user-select: none;
	font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); margin-right: 0.35rem; }
.prsp-filters-showdeleted:empty { display: none; }
.prsp-filters-showdeleted-checkbox { width: 1.05rem; height: 1.05rem; cursor: pointer; accent-color: var(--theme-color-brand-primary, #156dd1); }

/* Module-owned "Add filter" popover (replaces the old native <select> pickers). */
/* Fixed (viewport-anchored) + JS-positioned on open, so no ancestor overflow:hidden — the filter card,
   the slide-out drawer — can clip it, whatever the host's layout. */
.prsp-addfilter-pop { position: fixed; z-index: 30; min-width: 280px; max-width: 360px; display: none; }
.prsp-addfilter-pop.open { display: block; }
/* Transparent full-viewport backdrop: catches outside clicks to close (no document listener). */
.prsp-addfilter-backdrop { position: fixed; inset: 0; z-index: 0; }
.prsp-addfilter-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(70vh, 460px);
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
.prsp-addfilter-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.prsp-addfilter-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
.prsp-addfilter-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.prsp-addfilter-list { flex: 1 1 auto; overflow-y: auto; }
.prsp-addfilter-empty { padding: 0.7rem 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; }
.prsp-addfilter-field { border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
.prsp-addfilter-field:last-child { border-bottom: none; }
.prsp-addfilter-field-btn { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; width: 100%;
	font: inherit; font-size: 0.9rem; text-align: left; cursor: pointer; padding: 0.5rem 0.75rem; border: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.prsp-addfilter-field-btn:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.prsp-addfilter-chev { display: inline-flex; flex: 0 0 auto; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; transition: transform 0.15s ease; }
.prsp-addfilter-field.is-expanded .prsp-addfilter-chev { transform: rotate(90deg); }
.prsp-addfilter-clauses { display: flex; flex-direction: column; }
.prsp-addfilter-clause { display: flex; align-items: center; gap: 0.4rem; width: 100%; text-align: left; cursor: pointer;
	font: inherit; font-size: 0.85rem; padding: 0.4rem 0.8rem 0.4rem 1.6rem; border: none; background: transparent; color: var(--theme-color-text-secondary, #45505f); }
.prsp-addfilter-clause:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 10%, transparent); color: var(--theme-color-brand-primary, #156dd1); }
.prsp-addfilter-clause-ic { display: inline-flex; font-size: 0.8rem; }
`,
	CSSPriority: 500,

	Templates:
	[
		{
			// One coherent control: a search row (search input + a filters icon button that
			// shows the active-filter count and toggles the drawer + a Search button), and a
			// slide-out drawer beneath it holding the filter clauses, "add filter", the saved
			// Filter Experiences dropdown, and Clear / Reset / Apply. Search, Apply and Enter
			// all submit the form -> handleSearch (apply search + current filters).
			Hash: 'PRSP-SUBSET-Filters-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template] -->
	<div class="prsp-filters" id="PRSP_FilterBar">
		<form id="PRSP_Filter_Form" class="prsp-filters-bar" onsubmit="_Pict.views['PRSP-Filters'].handleSearch(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}'); return false;">
			{~T:PRSP-SUBSET-Filters-Template-Input-Fieldset~}
			{~T:PRSP-SUBSET-Filters-Template-Button-Fieldset~}
		</form>
		<div class="prsp-filters-drawer" id="PRSP_Filter_Drawer">
			<div class="prsp-filters-drawer-inner">
				<!-- The card carries all the panel chrome and lives *inside* the clip box, so it collapses
				     together with the animating height (see .prsp-filters-drawer-card in CSS). -->
				<div class="prsp-filters-drawer-card">
					<!-- Quick Filters: a curated, one-interaction bar painted post-render into this host
					     (empty when the record set has no quick filters → CSS :empty hides it). -->
					<div class="prsp-quickfilters" id="PRSP_QuickFilters"></div>
					<div id="PRSP_Filter_Instances" class="prsp-filters-clauses" onkeydown="if (event.key === 'Enter' &amp;&amp; !event.target.closest('.pps')) { event.preventDefault(); _Pict.views['PRSP-Filters'].handleSearch(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}'); }">
						{~FIV:Record~}
					</div>
					{~T:PRSP-SUBSET-Filters-Template-AddFilter-Fieldset~}
					<div class="prsp-filters-footer">
						{~T:PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset~}
						{~T:PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset~}
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-Input-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-Input-Fieldset] -->
	<span class="prsp-filters-search">
		<span class="prsp-filters-search-ic">{~I:Search~}</span>
		<input id="search_filter" class="prsp-filters-input" type="text" name="filter" placeholder="Search…" autocomplete="off" aria-label="Search">
	</span>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-Input-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-Button-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-Button-Fieldset] -->
	<button type="button" class="prsp-filters-toggle" id="PRSP_Filter_Toggle" title="Filters" aria-label="Filters" onclick="_Pict.views['PRSP-Filters'].toggleFilterDrawer()">
		<span class="prsp-filters-toggle-ic" id="PRSP_Filter_Icon"></span>
		<span class="prsp-filters-toggle-count" id="PRSP_Filter_Count"></span>
	</button>
	<button type="submit" class="prsp-filters-apply prsp-filters-apply-search" id="PRSP_Filter_Button_Apply">Search</button>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-Button-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset] -->
	<div class="prsp-filters-experiences">
		<div id="FilterPersistenceView-Container"></div>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset] -->
	<div class="prsp-filters-actions">
		<label class="prsp-filters-showdeleted" id="PRSP_ShowDeleted_Host" title="Include soft-deleted records in the results"></label>
		<button type="button" class="prsp-filters-btn-text" id="PRSP_Filter_Button_Clear" title="Clear all filters to a blank state" onclick="_Pict.views['PRSP-Filters'].handleClear(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">Clear</button>
		<button type="button" class="prsp-filters-btn-text" id="PRSP_Filter_Button_Reset" title="Reset all filters to the last saved/defaulted state" onclick="_Pict.views['PRSP-Filters'].handleReset(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">Reset</button>
		<button type="button" class="prsp-filters-apply" id="PRSP_Filter_Button_ApplyDrawer" onclick="_Pict.views['PRSP-Filters'].handleSearch(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">Apply</button>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-AddFilter-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-AddFilter-Fieldset] -->
	<div class="prsp-filters-add">
		<button type="button" class="prsp-filters-btn-text prsp-addfilter-trigger" id="PRSP_Filter_Button_Add" title="Add a new filter clause" onclick="_Pict.views['PRSP-Filters'].toggleAddFilterPopover(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">{~I:Plus~} Add filter</button>
		<div class="prsp-addfilter-pop" id="PRSP_AddFilter_Popover"></div>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-AddFilter-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-Popover',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-Popover] -->
	<div class="prsp-addfilter-backdrop" onclick="_Pict.views['PRSP-Filters'].closeAddFilterPopover()"></div>
	<div class="prsp-addfilter-panel">
		<div class="prsp-addfilter-search">
			<span class="prsp-addfilter-search-ic">{~I:Search~}</span>
			<input type="text" id="PRSP_AddFilter_Search" placeholder="Search filters…" autocomplete="off" value="{~D:AppData.PRSPAddFilter.Search~}" oninput="_Pict.views['PRSP-Filters'].searchAddFilter(this.value)" onkeydown="if (event.key === 'Escape') { event.preventDefault(); _Pict.views['PRSP-Filters'].closeAddFilterPopover(); }">
		</div>
		<div class="prsp-addfilter-list" id="PRSP_AddFilter_List">
			{~T:PRSP-AddFilter-List~}
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-AddFilter-Popover] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-List',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-List] -->
	{~TS:PRSP-AddFilter-Field:AppData.PRSPAddFilter.Fields~}
	{~NE:AppData.PRSPAddFilter.IsEmpty^<div class="prsp-addfilter-empty">No filters found.</div>~}
	<!-- DefaultPackage end view template: [PRSP-AddFilter-List] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-Field',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-Field] -->
	<div class="prsp-addfilter-field {~D:Record.ExpandedClass~}">
		<button type="button" class="prsp-addfilter-field-btn" onclick="_Pict.views['PRSP-Filters'].toggleAddFilterField('{~D:Record.FilterKey~}')">
			<span class="prsp-addfilter-field-name">{~D:Record.DisplayName~}</span>
			<span class="prsp-addfilter-chev">{~I:ChevronRight~}</span>
		</button>
		<div class="prsp-addfilter-clauses">
			{~TS:PRSP-AddFilter-Clause:Record.ClausesToShow~}
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-AddFilter-Field] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-Clause',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-Clause] -->
	<button type="button" class="prsp-addfilter-clause" onclick="_Pict.views['PRSP-Filters'].addFilter(event, '{~D:AppData.PRSPAddFilter.RecordSet~}', '{~D:AppData.PRSPAddFilter.ViewContext~}', '{~D:Record.FilterKey~}', '{~D:Record.ClauseKey~}')">
		<span class="prsp-addfilter-clause-ic">{~I:Plus~}</span>
		<span>{~D:Record.DisplayName~}</span>
	</button>
	<!-- DefaultPackage end view template: [PRSP-AddFilter-Clause] -->
`
		},
		{
			// Quick Filters bar contents (painted into #PRSP_QuickFilters post-render). A small label +
			// one compact control per definition; each control drives a real, tagged clause.
			Hash: 'PRSP-QuickFilters-Bar',
			Template: /*html*/`
		<span class="prsp-quickfilters-label">Quick filters</span>
		{~TS:PRSP-QuickFilter-Item:Record.Filters~}
`
		},
		{
			// One quick filter: a name + exactly one control, chosen by the single-element-array slot
			// (text / date range / entity picker) populated for this item's control type.
			Hash: 'PRSP-QuickFilter-Item',
			Template: /*html*/`
		<div class="prsp-quickfilter">
			<span class="prsp-quickfilter-name">{~D:Record.Label~}</span>
			{~TS:PRSP-QuickFilter-Text:Record.TextSlot~}
			{~TS:PRSP-QuickFilter-Date:Record.DateSlot~}
			{~TS:PRSP-QuickFilter-Entity:Record.EntitySlot~}
			{~TS:PRSP-QuickFilter-Distinct:Record.DistinctSlot~}
		</div>
`
		},
		{
			// Text control (fuzzy match) — commits on blur / Enter (never per-keystroke, so the
			// re-render that an apply triggers can't steal focus mid-type).
			Hash: 'PRSP-QuickFilter-Text',
			Template: /*html*/`
		<input class="prsp-quickfilter-input" type="text" value="{~D:Record.Value~}" placeholder="{~D:Record.Placeholder~}" autocomplete="off"
			onkeydown="if (event.key === 'Enter') { event.preventDefault(); this.blur(); }"
			onchange="_Pict.views['PRSP-Filters'].applyQuickFilterText('{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Field~}', '{~D:Record.ClauseKey~}', this.value)">
`
		},
		{
			// Date-range control — a from/to pair driving one DateRange clause (Values.Start / .End).
			Hash: 'PRSP-QuickFilter-Date',
			Template: /*html*/`
		<span class="prsp-quickfilter-daterange">
			<input type="date" class="prsp-quickfilter-input prsp-quickfilter-date" value="{~D:Record.StartValue~}" aria-label="{~D:Record.Label~} from"
				onchange="_Pict.views['PRSP-Filters'].applyQuickFilterDate('{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Field~}', '{~D:Record.ClauseKey~}', 'start', this.value)">
			<span class="prsp-quickfilter-dash">–</span>
			<input type="date" class="prsp-quickfilter-input prsp-quickfilter-date" value="{~D:Record.EndValue~}" aria-label="{~D:Record.Label~} to"
				onchange="_Pict.views['PRSP-Filters'].applyQuickFilterDate('{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Field~}', '{~D:Record.ClauseKey~}', 'end', this.value)">
		</span>
`
		},
		{
			// Entity control — a pict-section-picker mounts into this host (post-render, in
			// _mountQuickFilterEntity), so the quick filter reuses the real entity picker.
			Hash: 'PRSP-QuickFilter-Entity',
			Template: /*html*/`
		<span class="prsp-quickfilter-entityhost" id="{~D:Record.HostID~}"></span>
`
		},
		{
			// Distinct-values control — a multi-select pict-section-picker mounts into this host
			// (post-render, in _mountQuickFilterDistinct), its options the column's distinct values.
			Hash: 'PRSP-QuickFilter-Distinct',
			Template: /*html*/`
		<span class="prsp-quickfilter-entityhost" id="{~D:Record.HostID~}"></span>
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Filters',
			TemplateHash: 'PRSP-SUBSET-Filters-Template',
			DestinationAddress: '#PRSP_Filters_Container',
			RenderMethod: 'replace'
		},
		{
			RenderableHash: 'PRSP_AddFilter_Popover',
			TemplateHash: 'PRSP-AddFilter-Popover',
			ContentDestinationAddress: '#PRSP_AddFilter_Popover',
			RenderMethod: 'replace',
		},
		{
			RenderableHash: 'PRSP_AddFilter_List',
			TemplateHash: 'PRSP-AddFilter-List',
			ContentDestinationAddress: '#PRSP_AddFilter_List',
			RenderMethod: 'replace',
		},
	],

	Manifests: {},
};

//FIXME: export this from PSF?
const libPictViewDynamicForm = require('pict-section-form/source/views/Pict-View-DynamicForm.js');

const DynamicInputViewSectionDefinition = (
{
	"Hash": "PSRSDynamicInputs",
	"Name": "Custom Dynamic Inputs",
	"ViewHash": "PSRSFilterProxyView",

	"AutoMarshalDataOnSolve": true,
	"IncludeInMetatemplateSectionGeneration": false,

	"Manifests":
	{
		"Section":
		{
			"Scope": "PSRSDynamic",
			"Sections":
			[
				{
					"Hash": "PSRSDynamicInputs",
					"Name": "Dynamic Inputs"
				}
			],
			"Descriptors":
			{
				"PSRS.DynamicInputPlaceholder":
				{
					"Name": "DynamicInputPlaceholder",
					"Hash": "DynamicInputPlaceholder",
					"DataType": "String",
					"Macro":
					{
						"HTMLSelector": ""
					},
					"PictForm":
					{
						"Section": "PSRSDynamicInputs"
					}
				}
			}
		}
	}
});
class ViewRecordSetSUBSETFilters extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_SUBSET_Filter, pOptions);
		super(pFable, tmpOptions, pServiceHash);
		/** @type {import('fable') & import('pict') & { PictSectionRecordSet: import('../Pict-Section-RecordSet.js') }} */
		this.pict;

		if (!this.pict.views[DynamicInputViewSectionDefinition.ViewHash])
		{
			const tmpViewConfiguration = Object.assign({}, DynamicInputViewSectionDefinition);
			this.pict.addView(tmpViewConfiguration.ViewHash, tmpViewConfiguration, libPictViewDynamicForm);
			this.pict.views[DynamicInputViewSectionDefinition.ViewHash].viewMarshalDestination = 'Bundle';
		}
		for (const tmpView of Object.values(require('./filters')))
		{
			if (tmpView.default_configuration.ViewIdentifier && !this.pict.views[tmpView.default_configuration.ViewIdentifier])
			{
				this.pict.addView(tmpView.default_configuration.ViewIdentifier, {}, tmpView);
			}
		}
		this.chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

		// Use a lookup table to find the index.
		this.lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
		for (let i = 0; i < this.chars.length; i++)
		{
			this.lookup[this.chars.charCodeAt(i)] = i;
		}
		this.newFilterSearchApplied = false;
		this.addFilterCallback = null;
		this.removeFilterCallback = null;
		// Consolidated filter control state: drawer open/closed, and the last-applied search
		// string per record set (so a search no longer clears the search box on re-render).
		this._drawerOpen = false;
		this._searchString = {};
		// Render-epoch counter, bumped any time the filter list is re-rendered
		// or a new filter experience is applied. Deferred filter post-render
		// work (e.g. the setTimeout-scheduled transaction drain in
		// Pict-Template-FilterInstanceViews) captures the epoch at schedule
		// time and compares against the current value before running, so a
		// stale callback doesn't clobber DOM that now belongs to a different
		// filter experience.
		this._renderEpoch = 0;
		// Add-filter popover state (module-owned, replaces the old native <select> pickers).
		this._addFilterOpen = false;
		this._addFilterRecordSet = null;
		this._addFilterViewContext = null;
		this._addFilterSearch = '';
		this._addFilterExpandedKey = null;
		// FilterKeys to hide from the add-filter popover (e.g. internal/audit columns). Host apps
		// set this; it is merged with a per-record-set config `FilterFieldBlacklist`.
		this.filterFieldBlacklist = [];
	}

	/**
	 * Bump the render epoch. Call this whenever the active filter clauses are
	 * about to change in a way that would invalidate in-flight filter renders.
	 *
	 * @return {number} The new epoch value.
	 */
	bumpRenderEpoch()
	{
		this._renderEpoch++;
		return this._renderEpoch;
	}

	/**
	 * Sets a callback function to be executed after a filter is added.
	 * @param {function} pCallback - The callback function to be executed after a filter is added.
	 */
	setAddFilterCallback(pCallback)
	{
		this.addFilterCallback = pCallback;
	}

	/**
	 * Sets a callback function to be executed after a filter is removed.
	 * @param {function} pCallback - The callback function to be executed after a filter is removed.
	 */
	setRemoveFilterCallback(pCallback)
	{
		this.removeFilterCallback = pCallback;
	}

	/**
	 * Removes the callback function for adding a filter.
	 */
	removeAddFilterCallback()
	{
		this.addFilterCallback = null;
	}

	/**
	 * Removes the callback function for removing a filter.
	 */
	removeRemoveFilterCallback()
	{
		this.removeFilterCallback = null;
	}

	/**
	 * @return {string} - The marshalling prefix configured for filters. Usually 'Bundle.'
	 */
	getInformaryAddressPrefix()
	{
		return `${this.pict.views[DynamicInputViewSectionDefinition.ViewHash].viewMarshalDestination}.`;
	}

	/**
	 * @param {string} pAddress - The address of the informary to get the value from.
	 *
	 * @return {any} - The value at the given address, using the informary marshalling prefix.
	 */
	getInformaryScopedValue(pAddress)
	{
		const tmpCompositeAddress = `${this.getInformaryAddressPrefix()}${pAddress}`;
		return this.pict.resolveStateFromAddress(tmpCompositeAddress);
	}

	//NOTE: two methods below copied from the pict-section-form metacontroller
	//TODO: consider subclassing the dynamic view to somehow mark these as filter views so we can only operate on those views

	/**
	 * Marshals data from the view to the model, usually AppData (or configured data store).
	 * @returns {any} The result of the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalFromView();
			}
		}
		return super.onMarshalFromView();
	}

	/**
	 * Marshals the data to the view from the model, usually AppData (or configured data store).
	 * @returns {any} The result of the super.onMarshalToView() method.
	 */
	onMarshalToView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalToView();
			}
		}
		return super.onMarshalToView();
	}

	/** Toggle the slide-out filter drawer beneath the search bar. */
	toggleFilterDrawer()
	{
		this._drawerOpen = !this._drawerOpen;
		const tmpBar = document.getElementById('PRSP_FilterBar');
		if (tmpBar) { tmpBar.classList.toggle('drawer-open', this._drawerOpen); }
		return this._drawerOpen;
	}

	/**
	 * The current search term, read back from the active route URL (the source of truth) so
	 * the search box stays populated across re-renders and reflects bookmarked/filtered URLs.
	 * performSearch builds `.../FilteredTo/FBVOR~<field>~LK~<encoded %term%>~...` from the
	 * SearchFields, so the term is the first LK value in the FilteredTo segment.
	 *
	 * @return {string}
	 */
	_searchTermFromURL()
	{
		const tmpCurrent = this.pict.providers.PictRouter && this.pict.providers.PictRouter.router && this.pict.providers.PictRouter.router.current
			? this.pict.providers.PictRouter.router.current[0] : null;
		const tmpUrl = (tmpCurrent && (tmpCurrent.url || tmpCurrent.hashString)) || '';
		if (tmpUrl.indexOf('FilteredTo/') < 0) { return ''; }
		const tmpFilteredPart = (tmpUrl.split('FilteredTo/')[1] || '').split('/FilterExperience')[0];
		// A free-text search builds one `LK~%token%` clause PER token PER search field. Pull EVERY token value
		// (matching only the first truncated a multi-word search like "bridge over stream" to "bridge"), strip the
		// % wildcards, and drop the consecutive per-field repeat of each token, to rebuild the full search term.
		const tmpMatches = tmpFilteredPart.match(/LK~([^~/]+)/g);
		if (!tmpMatches) { return ''; }
		const tmpTokens = [];
		for (const tmpRawMatch of tmpMatches)
		{
			let tmpValue = tmpRawMatch.replace(/^LK~/, '');
			try { tmpValue = decodeURIComponent(tmpValue); } catch (pError) { /* leave raw */ }
			tmpValue = tmpValue.replace(/^%+|%+$/g, '');
			if (tmpValue.length > 0 && tmpValue !== tmpTokens[tmpTokens.length - 1]) { tmpTokens.push(tmpValue); }
		}
		return tmpTokens.join(' ');
	}

	/** The number of active (structured) filter clauses for a record set. */
	getActiveFilterCount(pRecordSet)
	{
		const tmpClauses = this.pict && this.pict.Bundle && this.pict.Bundle._ActiveFilterState && this.pict.Bundle._ActiveFilterState[pRecordSet]
			? this.pict.Bundle._ActiveFilterState[pRecordSet].FilterClauses : null;
		return Array.isArray(tmpClauses) ? tmpClauses.length : 0;
	}

	/**
	 * Repaint the filter-bar chrome after a (re)render: the filters icon (outline vs filled
	 * + count badge), the active-filter highlight, the persisted drawer-open state, and the
	 * search input value (so applying a search no longer clears the search box).
	 *
	 * @param {string} pRecordSet
	 */
	_paintFilterControls(pRecordSet)
	{
		const tmpBar = document.getElementById('PRSP_FilterBar');
		if (!tmpBar) { return; }
		const tmpCount = this.getActiveFilterCount(pRecordSet);
		tmpBar.classList.toggle('has-filters', tmpCount > 0);
		tmpBar.classList.toggle('drawer-open', !!this._drawerOpen);
		const tmpIcon = document.getElementById('PRSP_Filter_Icon');
		if (tmpIcon) { tmpIcon.innerHTML = (tmpCount > 0) ? ViewRecordSetSUBSETFilters.FilterIconFilled : ViewRecordSetSUBSETFilters.FilterIconOutline; }
		const tmpCountEl = document.getElementById('PRSP_Filter_Count');
		if (tmpCountEl) { tmpCountEl.textContent = (tmpCount > 0) ? String(tmpCount) : ''; }
		const tmpInput = document.getElementById('search_filter');
		if (tmpInput) { tmpInput.value = this._searchTermFromURL(); }
	}

	/**
	 * Paint the Quick Filters bar into #PRSP_QuickFilters from the record set's quick-filter definitions
	 * (host config or clever defaults), each control seeded with its clause's current value. Phase 1
	 * renders the text controls; date/entity controls follow. Empty → the bar's :empty CSS hides it.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext
	 */
	_renderQuickFilters(pRecordSet, pViewContext)
	{
		if (!document.getElementById('PRSP_QuickFilters')) { return; }
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || typeof tmpProvider.getQuickFilterDefinitions !== 'function')
		{
			this.pict.ContentAssignment.assignContent('#PRSP_QuickFilters', '');
			return;
		}
		// Build one item per definition, populating exactly one control slot (text / date / entity).
		// `quickFiltersAutoDefault` (host-settable, default on) gates the clever schema defaults: a host
		// can set it false to make quick filters opt-in (only record sets with an explicit config show).
		const tmpEntityMounts = [];
		const tmpDistinctMounts = [];
		const tmpItems = tmpProvider.getQuickFilterDefinitions(this.quickFiltersAutoDefault).map((pDefinition) =>
		{
			const tmpBase = { Field: pDefinition.Field, ClauseKey: pDefinition.ClauseKey, Label: pDefinition.Label, RecordSet: pRecordSet, ViewContext: pViewContext };
			const tmpItem = { Label: pDefinition.Label, TextSlot: [], DateSlot: [], EntitySlot: [], DistinctSlot: [] };
			if (pDefinition.Control === 'text')
			{
				tmpItem.TextSlot = [ Object.assign({}, tmpBase, { Value: tmpProvider.getQuickFilterClauseValue(pDefinition.Field), Placeholder: `Search ${pDefinition.Label}…` }) ];
			}
			else if (pDefinition.Control === 'daterange')
			{
				const tmpRange = tmpProvider.getQuickFilterDateRangeValue(pDefinition.Field);
				tmpItem.DateSlot = [ Object.assign({}, tmpBase, { StartValue: tmpRange.Start, EndValue: tmpRange.End }) ];
			}
			else if (pDefinition.Control === 'entity')
			{
				const tmpHostID = `PRSP_QuickEntity_${pRecordSet}_${pDefinition.Field}`;
				tmpItem.EntitySlot = [ Object.assign({}, tmpBase, { HostID: tmpHostID }) ];
				tmpEntityMounts.push(Object.assign({}, tmpBase, { HostID: tmpHostID }));
			}
			else if (pDefinition.Control === 'distinct')
			{
				const tmpHostID = `PRSP_QuickDistinct_${pRecordSet}_${pDefinition.Field}`;
				tmpItem.DistinctSlot = [ Object.assign({}, tmpBase, { HostID: tmpHostID }) ];
				tmpDistinctMounts.push(Object.assign({}, tmpBase, { HostID: tmpHostID }));
			}
			return tmpItem;
		});
		const tmpHTML = (tmpItems.length > 0) ? this.pict.parseTemplateByHash('PRSP-QuickFilters-Bar', { Filters: tmpItems }) : '';
		this.pict.ContentAssignment.assignContent('#PRSP_QuickFilters', tmpHTML);
		// Entity / distinct controls: mount (or re-mount) a picker into each host after the wholesale re-render.
		tmpEntityMounts.forEach((pMount) => this._mountQuickFilterEntity(pRecordSet, pViewContext, pMount));
		tmpDistinctMounts.forEach((pMount) => this._mountQuickFilterDistinct(pRecordSet, pViewContext, pMount));
	}

	/**
	 * Mount (idempotently) a pict-section-picker into a quick-filter entity host, configured from the
	 * field's entity clause descriptor (RemoteTable / search columns / value column), single-select.
	 * On change it upserts the clause + applies. Re-runs after each render (the bar repaints wholesale),
	 * mirroring the form adapter's re-mount pattern. No-op if the picker module isn't registered.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {Record<string, any>} pMount
	 */
	_mountQuickFilterEntity(pRecordSet, pViewContext, pMount)
	{
		if (!document.getElementById(pMount.HostID)) { return; }
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpPickerProvider || typeof tmpPickerProvider.createEntityPicker !== 'function' || !tmpProvider) { return; }
		const tmpDescriptor = tmpProvider.getFilterClauseSchemaForKey(pMount.Field)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pMount.ClauseKey);
		if (!tmpDescriptor || !tmpDescriptor.RemoteTable) { return; }
		const tmpSearchFields = Array.isArray(tmpDescriptor.ExternalFilterByColumns) && tmpDescriptor.ExternalFilterByColumns.length > 0 ? tmpDescriptor.ExternalFilterByColumns : [ 'Name' ];
		// ScopeToRecordSet knob: limit the picker to the values present in this recordset's data
		// (FBL~<col>~INN~<distinct>) so it doesn't list the whole remote table. Pre-fetch the
		// distinct set, then re-mount once it resolves so the first open is already scoped.
		let tmpScopeBaseFilter = undefined;
		if (tmpDescriptor.ScopeToRecordSet && tmpDescriptor.FilterByColumn && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
		{
			const tmpScopeColumn = tmpDescriptor.FilterByColumn;
			if (!tmpProvider._scopeDistinctCache || !Array.isArray(tmpProvider._scopeDistinctCache[tmpScopeColumn]))
			{
				tmpProvider.getRecordSetColumnDistinct(tmpScopeColumn, () => this._mountQuickFilterEntity(pRecordSet, pViewContext, pMount));
			}
			tmpScopeBaseFilter = () =>
			{
				const tmpVals = (tmpProvider._scopeDistinctCache || {})[tmpScopeColumn];
				return (Array.isArray(tmpVals) && tmpVals.length > 0) ? `FBL~${tmpScopeColumn}~INN~${tmpVals.join(',')}` : '';
			};
		}
		const tmpPickerConfig =
		{
			DestinationAddress: `#${pMount.HostID}`,
			// Quick filters stay single-select for a fast pick (the full drawer entity filter can be multi).
			Mode: 'single',
			Entity: tmpDescriptor.RemoteTable,
			ValueField: tmpDescriptor.JoinExternalConnectionColumn || `ID${tmpDescriptor.RemoteTable}`,
			SearchFields: tmpSearchFields,
			TextField: tmpSearchFields[0],
			// Composed, disambiguated option/chip label (e.g. "Brian Smith (brian@…)") — falls back to
			// TextField when the entity has no list-entry template.
			TextTemplate: tmpDescriptor.EntityListEntryTemplate || undefined,
			Placeholder: `Select ${pMount.Label}…`,
			// A filter's natural zero state is "Any" — the pinned clear row / inline × empty the
			// selection, OnChange(null) flows through the upsert, and the clause is removed.
			AllowClear: true,
			ClearLabel: 'Any',
			OnChange: (pValue) => this.applyQuickFilterEntity(pRecordSet, pViewContext, pMount.Field, pMount.ClauseKey, pValue),
			BaseFilter: tmpScopeBaseFilter,
		};
		// Field decoration (module policy): when this entity is opted in, the picker offers a ⚙ to pin an
		// extra column onto each row to tell same-named records apart. Resolved per entity by the
		// metacontroller; GUID / audit / value / text columns are hidden.
		if (this.pict.PictSectionRecordSet)
		{
			this.pict.PictSectionRecordSet.applyFieldDecoration(tmpPickerConfig, tmpDescriptor.RemoteTable);
		}
		const tmpView = tmpPickerProvider.createEntityPicker(`Quick-Picker-${pRecordSet}-${pMount.Field}`, tmpPickerConfig);
		if (!tmpView) { return; }
		tmpView.render();
		const tmpCurrent = (typeof tmpProvider.getQuickFilterEntityValue === 'function') ? tmpProvider.getQuickFilterEntityValue(pMount.Field) : [];
		tmpView.setValue((Array.isArray(tmpCurrent) && tmpCurrent.length > 0) ? tmpCurrent[0] : '');
	}

	/**
	 * Create any filter clauses a record set DEFAULTS to, before its first fetch runs.
	 *
	 * `DefaultRelativeDays` seeds a trailing date window, but the seed only ever ran as a
	 * side effect of `getQuickFilterDefinitions`, and the only thing that calls that is this
	 * view's own `onAfterRender` -- which happens AFTER the records have already come back.
	 * So the date landed in the input box while the grid showed everything, and the customer's
	 * "default to the last year" quietly meant "last year, once you press Apply". There is no
	 * staged-vs-applied split to respect here: the seed writes into the same
	 * `_ActiveFilterState[...].FilterClauses` array the fetch reads, so the fix is purely a
	 * matter of running it earlier.
	 *
	 * Seeding is safe to force: `_seedRelativeDateDefaults` is once-per-field, refuses to
	 * write over a bound that already has a value, and can only ever create a clause for a
	 * field that configured `DefaultRelativeDays`. Call this AFTER any URL / filter-experience
	 * hydration so a shared link still wins.
	 *
	 * The schema must resolve first -- `DefaultRelativeDays` is read off the filter schema,
	 * which is only built once the entity schema returns.
	 *
	 * @param {string} pRecordSet - The record set whose defaults should be seeded.
	 * @return {Promise<void>}
	 */
	async seedDefaultFilterClauses(pRecordSet)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || (typeof tmpProvider.getQuickFilterDefinitions !== 'function'))
		{
			return;
		}
		try
		{
			if (typeof tmpProvider.getRecordSchema === 'function')
			{
				await tmpProvider.getRecordSchema();
			}
			// Asking for the definitions performs the seed; everything else it does is a read.
			tmpProvider.getQuickFilterDefinitions(this.quickFiltersAutoDefault);
		}
		catch (pError)
		{
			// A default that cannot be resolved must never block the page from loading.
			this.pict.log.warn(`[PRSP-Filters] Could not seed default filter clauses for [${pRecordSet}]: ${pError.message}`);
		}
	}

	/**
	 * The distinct-value filter a clause should actually fetch with: its static `DistinctFilter`
	 * narrowed by the CURRENT selection of every field named in `CascadeFrom`.
	 *
	 * This is what makes one quick filter depend on another — pick a Site and the Product list
	 * collapses to the products that Site actually has. A parent with nothing picked narrows
	 * nothing, so the child lists everything, which is the right zero state for a filter.
	 *
	 * `CascadeFrom` names FIELDS, and every filter definition's key equals its `FilterByColumn`,
	 * so a field name is also the column to constrain. The returned string feeds both the fetch
	 * and the provider's distinct cache key, so each distinct parent selection caches separately
	 * and switching back to a previous Site is instant.
	 *
	 * @param {Record<string, any>} pProvider - The recordset provider (`RSP-Provider-<RecordSet>`).
	 * @param {Record<string, any>} pDescriptor - The clause descriptor.
	 * @return {string} The FoxHound filter stanza chain, or '' for no filter.
	 */
	resolveCascadedDistinctFilter(pProvider, pDescriptor)
	{
		let tmpFilter = pDescriptor.DistinctFilter || '';
		const tmpParentFields = Array.isArray(pDescriptor.CascadeFrom) ? pDescriptor.CascadeFrom : [];
		if ((tmpParentFields.length === 0) || !pProvider || (typeof pProvider.getQuickFilterEntityValue !== 'function'))
		{
			return tmpFilter;
		}
		for (const tmpParentField of tmpParentFields)
		{
			const tmpValues = pProvider.getQuickFilterEntityValue(tmpParentField);
			if (!Array.isArray(tmpValues) || (tmpValues.length === 0)) { continue; }
			// A value carrying a comma would split the IN list, so those are skipped rather
			// than silently widening the child list to the wrong set.
			const tmpUsable = tmpValues.filter((pValue) => String(pValue).indexOf(',') === -1);
			if (tmpUsable.length === 0) { continue; }
			tmpFilter += `${tmpFilter ? '~' : ''}FBL~${tmpParentField}~INN~${tmpUsable.join(',')}`;
		}
		return tmpFilter;
	}

	/**
	 * The quick-filter fields that declare `CascadeFrom` containing `pParentField`.
	 *
	 * @param {Record<string, any>} pProvider @param {string} pParentField
	 * @return {Array<Record<string, any>>} Quick-filter definitions that depend on the parent.
	 */
	resolveCascadeChildren(pProvider, pParentField)
	{
		if (!pProvider || (typeof pProvider.getQuickFilterDefinitions !== 'function')) { return []; }
		return pProvider.getQuickFilterDefinitions(this.quickFiltersAutoDefault).filter((pDefinition) =>
		{
			if (pDefinition.Control !== 'distinct') { return false; }
			const tmpDescriptor = pProvider.getFilterClauseSchemaForKey(pDefinition.Field)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pDefinition.ClauseKey);
			return !!tmpDescriptor && Array.isArray(tmpDescriptor.CascadeFrom) && tmpDescriptor.CascadeFrom.indexOf(pParentField) !== -1;
		});
	}

	/**
	 * After a parent selection changes, DROP each dependent child's staged selection and re-mount
	 * its picker against the newly narrowed option list.
	 *
	 * The selection is dropped rather than kept because a child value that the new parent does not
	 * have would otherwise stay staged and commit an unsatisfiable filter — the user picks a
	 * different Site and the grid comes back empty with no visible reason why.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pParentField
	 */
	refreshCascadeChildren(pRecordSet, pViewContext, pParentField)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider) { return; }
		for (const tmpChild of this.resolveCascadeChildren(tmpProvider, pParentField))
		{
			if (typeof tmpProvider.upsertQuickFilterEntity === 'function')
			{
				tmpProvider.upsertQuickFilterEntity(tmpChild.Field, tmpChild.ClauseKey, []);
			}
			this._mountQuickFilterDistinct(pRecordSet, pViewContext,
				{
					Field: tmpChild.Field, ClauseKey: tmpChild.ClauseKey, Label: tmpChild.Label,
					RecordSet: pRecordSet, ViewContext: pViewContext,
					HostID: `PRSP_QuickDistinct_${pRecordSet}_${tmpChild.Field}`,
				});
		}
	}

	/**
	 * Mount (idempotently) a multi-select pict-section-picker into a quick-filter distinct host,
	 * its options the clause's static `Options` or the column's distinct values (fetched + cached
	 * on the recordset provider; re-mounted once the fetch resolves so the options fill in). The
	 * picker substring-filters static options client-side, so search works without a server trip.
	 * On change it STAGES the clause (Values array) — Apply / Search commits. No-op if the picker
	 * module isn't registered.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {Record<string, any>} pMount
	 */
	_mountQuickFilterDistinct(pRecordSet, pViewContext, pMount)
	{
		if (!document.getElementById(pMount.HostID)) { return; }
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpPickerProvider || typeof tmpPickerProvider.createPicker !== 'function' || !tmpProvider) { return; }
		const tmpDescriptor = tmpProvider.getFilterClauseSchemaForKey(pMount.Field)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pMount.ClauseKey);
		if (!tmpDescriptor || !tmpDescriptor.FilterByColumn) { return; }
		let tmpValues;
		if (Array.isArray(tmpDescriptor.Options) && tmpDescriptor.Options.length > 0)
		{
			tmpValues = tmpDescriptor.Options;
		}
		else
		{
			// CascadeFrom narrows this list by whatever its parent filters currently hold, so the
			// filter is resolved per mount rather than read straight off the descriptor.
			const tmpDistinctFilter = this.resolveCascadedDistinctFilter(tmpProvider, tmpDescriptor);
			const tmpCacheKey = tmpDistinctFilter ? `${tmpDescriptor.FilterByColumn}::${tmpDistinctFilter}` : tmpDescriptor.FilterByColumn;
			tmpValues = (tmpProvider._scopeDistinctCache || {})[tmpCacheKey];
			if (!Array.isArray(tmpValues) && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
			{
				tmpProvider.getRecordSetColumnDistinct(tmpDescriptor.FilterByColumn, { Filter: tmpDistinctFilter },
					() => this._mountQuickFilterDistinct(pRecordSet, pViewContext, pMount));
				tmpValues = [];
			}
		}
		const tmpOptions = (Array.isArray(tmpValues) ? tmpValues : []).map((pValue) => ({ Value: pValue, Text: String(pValue) }));
		const tmpView = tmpPickerProvider.createPicker(`Quick-Distinct-${pRecordSet}-${pMount.Field}`,
		{
			DestinationAddress: `#${pMount.HostID}`,
			// Multi-select: "any of the checked values" is the natural distinct-filter semantic.
			Mode: 'multi',
			Options: tmpOptions,
			Placeholder: `Select ${pMount.Label}…`,
			OnChange: (pValuesArray) => this.applyQuickFilterDistinct(pRecordSet, pViewContext, pMount.Field, pMount.ClauseKey, pValuesArray),
		});
		if (!tmpView) { return; }
		tmpView.render();
		const tmpCurrent = (typeof tmpProvider.getQuickFilterEntityValue === 'function') ? tmpProvider.getQuickFilterEntityValue(pMount.Field) : [];
		tmpView.setValue(Array.isArray(tmpCurrent) ? tmpCurrent : []);
	}

	/**
	 * Apply a text quick filter: upsert (or clear) its tagged clause, then run the standard search +
	 * serialize path. Commits on blur / Enter (not per-keystroke) so the re-render never steals focus.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {string} pValue
	 */
	/**
	 * Flip the show-deleted switch (the drawer-footer checkbox, RecordSetListShowDeletedFilter
	 * recordsets). The switch is a REAL clause — a RawFilter referencing the Deleted column, which
	 * suppresses the automatic `Deleted = 0` so soft-deleted rows enumerate — upserted into the
	 * active filter state and applied through the normal search flow. Because the clause changes
	 * the serialized filter experience, the route URL always changes: the fetch reliably fires,
	 * and the state survives reloads and shared links. Clear/Reset drop it like any clause.
	 *
	 * @param {string} pRecordSet - The record set the toggle belongs to
	 * @param {string} pViewContext - The view context (List, Dashboard)
	 * @param {boolean} pChecked - Whether deleted records should be included
	 */
	toggleShowDeletedFilter(pRecordSet, pViewContext, pChecked)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || typeof tmpProvider.setShowDeletedFilterValue !== 'function')
		{
			return;
		}
		tmpProvider.setShowDeletedFilterValue(pChecked === true);
		this.handleSearch(null, pRecordSet, pViewContext);
	}

	/**
	 * Paint the show-deleted checkbox into its drawer-footer host (next to Clear/Reset/Apply),
	 * seeded from the clause's presence. Painted post-render like the quick bar; empty when the
	 * record set hasn't opted in via RecordSetListShowDeletedFilter.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext
	 */
	_renderShowDeletedControl(pRecordSet, pViewContext)
	{
		if (!document.getElementById('PRSP_ShowDeleted_Host')) { return; }
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet?.recordSetProviderConfigurations?.[pRecordSet] || {};
		if (tmpRecordSetConfiguration.RecordSetListShowDeletedFilter !== true)
		{
			this.pict.ContentAssignment.assignContent('#PRSP_ShowDeleted_Host', '');
			return;
		}
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		const tmpChecked = (tmpProvider && typeof tmpProvider.getShowDeletedFilterValue === 'function' && tmpProvider.getShowDeletedFilterValue()) ? 'checked' : '';
		this.pict.ContentAssignment.assignContent('#PRSP_ShowDeleted_Host',
			`<input class="prsp-filters-showdeleted-checkbox" type="checkbox" ${tmpChecked} onchange="_Pict.views['PRSP-Filters'].toggleShowDeletedFilter('${pRecordSet}', '${pViewContext}', this.checked)"> Show deleted`);
	}

	applyQuickFilterText(pRecordSet, pViewContext, pField, pClauseKey, pValue)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterClauseValue === 'function')
		{
			tmpProvider.upsertQuickFilterClauseValue(pField, pClauseKey, (pValue === undefined || pValue === null) ? '' : String(pValue).trim());
		}
		// Stage the clause into the active filter state but DON'T fetch — the
		// user explicitly clicks Apply / Search to commit. Avoids two URL fetches
		// (one stale, one not) when adjacent inputs change in quick succession
		// (e.g. the From / To dates of a DateRange both fire `change` events
		// within ~50ms — the GE-only fetch finishes after the GE+LE fetch and
		// overwrites the recordset state with stale data).
	}

	/**
	 * Stage one bound (`start`/`end`) of a field's DateRange quick-filter clause.
	 * Doesn't fire the search — that waits for the user to click Apply / Search,
	 * so the From and To inputs change once each without racing the fetch.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {'start'|'end'} pWhich @param {string} pValue
	 */
	applyQuickFilterDate(pRecordSet, pViewContext, pField, pClauseKey, pWhich, pValue)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterDateRange === 'function')
		{
			tmpProvider.upsertQuickFilterDateRange(pField, pClauseKey, pWhich, (pValue === undefined || pValue === null) ? '' : pValue);
		}
	}

	/**
	 * Stage a field's entity quick-filter selection. Doesn't fire the search —
	 * commit happens on Apply / Search.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {any} pValue
	 */
	applyQuickFilterEntity(pRecordSet, pViewContext, pField, pClauseKey, pValue)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterEntity === 'function')
		{
			tmpProvider.upsertQuickFilterEntity(pField, pClauseKey, pValue);
		}
		// An entity filter can be a cascade parent too (pick a Project, narrow the Mix Designs).
		this.refreshCascadeChildren(pRecordSet, pViewContext, pField);
	}

	/**
	 * Stage a field's distinct quick-filter selection (the Values array of its
	 * DistinctSelectedValueList clause). Doesn't fire the search — commit happens
	 * on Apply / Search.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {Array<any>} pValues
	 */
	applyQuickFilterDistinct(pRecordSet, pViewContext, pField, pClauseKey, pValues)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterEntity === 'function')
		{
			tmpProvider.upsertQuickFilterEntity(pField, pClauseKey, pValues);
		}
		// Anything declaring CascadeFrom on this field now has a different option list.
		this.refreshCascadeChildren(pRecordSet, pViewContext, pField);
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	handleSearch(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) { pEvent.preventDefault(); pEvent.stopPropagation(); } // don't submit the form
		this.newFilterSearchApplied = true;
		const tmpSearchString = this.pict.ContentAssignment.readContent(`input[name="filter"]`);
		// Remember the applied search so the re-render below doesn't blank the search box.
		this._searchString[pRecordSet] = tmpSearchString ? String(tmpSearchString) : '';
		this.performSearch(pRecordSet, pViewContext, this._searchString[pRecordSet]);
	}

	/**
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @param {string} [pFilterString] - The filter string to apply, defaults to a single space if not provided
	 */
	performSearch(pRecordSet, pViewContext, pFilterString)
	{
		this.bumpRenderEpoch();
		const tmpPictRouter = this.pict.providers.PictRouter;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRecordSet];
		let filterExpr = '';
		if (pFilterString)
		{
			/** @type {Array<string>} */
			const searchFields = tmpProviderConfiguration?.SearchFields ?? [ 'Name' ];
			// Tokenize the query on whitespace: AND one clause per token, and within each token OR across the
			// search fields inside a parenthesized group (FOP..FCP). This lets a value split across columns —
			// e.g. a person's NameFirst + NameLast — still match a multi-word query like "Derek Woods" (no single
			// column ever contains the whole phrase, so the old whole-phrase-per-field chain returned nothing).
			// Each token's OR group is self-contained by its paren, so the group is anchored (no unconstrained
			// all-FBVOR match-everything bug) AND the tokens AND cleanly with each other and any other clauses.
			const tmpSearchTokens = String(pFilterString).split(/\s+/).map((pToken) => pToken.trim()).filter((pToken) => pToken.length > 0);
			filterExpr = tmpSearchTokens.map((pToken) =>
			{
				const tmpEncoded = encodeURIComponent(`%${pToken}%`);
				if (searchFields.length === 1) { return `FBV~${searchFields[0]}~LK~${tmpEncoded}`; }
				const tmpTokenClause = searchFields.map((filterField, filterIndex) => `${filterIndex === 0 ? 'FBV' : 'FBVOR'}~${filterField}~LK~${tmpEncoded}`).join('~');
				return `FOP~0~(~0~${tmpTokenClause}~FCP~0~)~0`;
			}).join('~');
		}
		let tmpURLTemplate = tmpProviderConfiguration[`RecordSetFilterURLTemplate-${pViewContext}`] || tmpProviderConfiguration[`RecordSetFilterURLTemplate-Default`];
		if (!tmpURLTemplate)
		{
			if (pViewContext === 'Dashboard' || pViewContext === 'List')
			{
				tmpURLTemplate = `/PSRS/${pRecordSet}/${pViewContext}/FilteredTo/{~D:Record.FilterString~}`;
			}
		}
		let tmpURL;
		if (tmpURLTemplate)
		{
			tmpURL = this.pict.parseTemplate(tmpURLTemplate,
				{
					RecordSet: pRecordSet,
					FilterString: filterExpr,
				});
		}
		else
		{
			tmpURL = `/PSRS/${pRecordSet}/List/FilteredTo/${filterExpr}`;
		}
		if (tmpURL.endsWith('FilteredTo/') || tmpURL.includes('FilteredTo//'))
		{
			tmpURL = tmpURL.replace(/\/FilteredTo\//, '');
		}
		this.render(undefined, undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		this.serializeFilterExperience(this.pict.Bundle._ActiveFilterState[pRecordSet]?.FilterClauses).then((pFilterExperienceSerialized) =>
		{
			if (pFilterExperienceSerialized)
			{
				tmpURL += `/FilterExperience/${encodeURIComponent(pFilterExperienceSerialized)}`;
			}
			//FIXME: this doesn't force a re-render if other filters have changes, but aren't in the URL - so we either need to put them in the URL, or force a re-render based on the filter states
			tmpPictRouter.router.navigate(tmpURL);
			// always store the last used filter experience search, even if they don't save it
			this.pict.providers.FilterDataProvider.setLastUsedFilterExperience(null, pRecordSet, pViewContext);
		});
		// new search means this can't be out of date anymore
		this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = false;
		this.newFilterSearchApplied = false;
	}

	/**
	 * Clear all filter clauses for the given record set and view context.
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	handleClear(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.ContentAssignment.assignContent('input[name="filter"]', '');
		this._searchString[pRecordSet] = '';
		this.pict.Bundle._ActiveFilterState[pRecordSet].FilterClauses = [];
		this.pict.providers.FilterDataProvider.removeDefaultFilterExperience(pRecordSet, pViewContext);
		this.performSearch(pRecordSet, pViewContext, '');
	}

	// NOTE: Reset means to default state, Clear means to no filters at all
	/**
	 * Reset the filters to default state or fallback to to clear everything if no default exist for the given record set and view context.
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	handleReset(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.providers.FilterDataProvider.removeLastUsedFilterExperience(pRecordSet, pViewContext);
		this.pict.log.info(`Clearing filters for record set: ${pRecordSet} in view context: ${pViewContext}`);
		// Apply default filter experience if it exists, otherwise just clear
		const tmpDefaultFilterExperience = this.pict.providers.FilterDataProvider.getDefaultFilterExperience(pRecordSet, pViewContext);
		if (tmpDefaultFilterExperience)
		{
			this.pict.log.info(`Applying default filter experience for record set: ${pRecordSet} in view context: ${pViewContext}`);
			this.pict.providers.FilterDataProvider.applyExpectedFilterExperience(pRecordSet, pViewContext, tmpDefaultFilterExperience.FilterExperienceHash, false);
			this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = false;
		}
		else 
		{
			this.handleClear(pEvent, pRecordSet, pViewContext);
		}
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @returns {boolean} - Always returns false to prevent default action
	*/
	handleManage(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) pEvent.preventDefault();
		this.pict.log.info(`Managing filters for record set: ${pRecordSet} in view context: ${pViewContext}`);
		this.pict.views.FilterPersistenceView.openFilterPersistenceUI(pRecordSet, pViewContext);
		return false;
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	toggleAddFilterPopover(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) { pEvent.preventDefault(); }
		if (this._addFilterOpen)
		{
			return this.closeAddFilterPopover();
		}
		this._addFilterOpen = true;
		this._addFilterRecordSet = pRecordSet;
		this._addFilterViewContext = pViewContext;
		this._addFilterSearch = '';
		this._addFilterExpandedKey = null;
		this._buildAddFilterFields(pRecordSet);
		this.render('PRSP_AddFilter_Popover', undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		this._paintAddFilterOpenState();
	}

	/** Close the add-filter popover. */
	closeAddFilterPopover()
	{
		this._addFilterOpen = false;
		this._addFilterExpandedKey = null;
		this._paintAddFilterOpenState();
	}

	/**
	 * Filter the add-filter field list by a search term, re-rendering only the list so the
	 * search input keeps focus.
	 * @param {string} pValue - The search term.
	 */
	searchAddFilter(pValue)
	{
		this._addFilterSearch = pValue || '';
		this._buildAddFilterFields(this._addFilterRecordSet);
		this.render('PRSP_AddFilter_List', undefined, { RecordSet: this._addFilterRecordSet, ViewContext: this._addFilterViewContext });
	}

	/**
	 * Expand or collapse a field's available clauses in the add-filter popover.
	 * @param {string} pFilterKey - The field whose clauses to toggle.
	 */
	toggleAddFilterField(pFilterKey)
	{
		this._addFilterExpandedKey = (this._addFilterExpandedKey === pFilterKey) ? null : pFilterKey;
		this._buildAddFilterFields(this._addFilterRecordSet);
		this.render('PRSP_AddFilter_List', undefined, { RecordSet: this._addFilterRecordSet, ViewContext: this._addFilterViewContext });
	}

	/**
	 * (Re)build the add-filter popover's field list into AppData from the record set's filter
	 * schema, honouring the current search term and the expanded field.
	 * @param {string} pRecordSet - The record set whose filter schema to read.
	 */
	_buildAddFilterFields(pRecordSet)
	{
		const tmpProvider = this.pict.providers[`RSP-Provider-${pRecordSet}`];
		const tmpSchema = (tmpProvider && typeof tmpProvider.getFilterSchema === 'function') ? tmpProvider.getFilterSchema() : {};
		const tmpRecordSetConfig = this.pict.PictSectionRecordSet?.recordSetProviderConfigurations?.[pRecordSet] || {};
		const tmpBlacklist = [].concat(this.filterFieldBlacklist || [], Array.isArray(tmpRecordSetConfig.FilterFieldBlacklist) ? tmpRecordSetConfig.FilterFieldBlacklist : []);
		const tmpSearch = (this._addFilterSearch || '').toLowerCase();
		const tmpFields = Object.values(tmpSchema)
			.filter((pField) => Array.isArray(pField.AvailableClauses) && pField.AvailableClauses.length > 0)
			.filter((pField) => !tmpBlacklist.includes(pField.FilterKey))
			.filter((pField) => !tmpSearch || String(pField.DisplayName || pField.FilterKey).toLowerCase().includes(tmpSearch))
			.sort((pA, pB) => String(pA.DisplayName || pA.FilterKey).localeCompare(String(pB.DisplayName || pB.FilterKey)))
			.map((pField) =>
			{
				const tmpExpanded = (pField.FilterKey === this._addFilterExpandedKey);
				return {
					FilterKey: pField.FilterKey,
					DisplayName: pField.DisplayName || pField.FilterKey,
					ExpandedClass: tmpExpanded ? 'is-expanded' : '',
					ClausesToShow: tmpExpanded ? pField.AvailableClauses : [],
				};
			});
		this.pict.AppData.PRSPAddFilter =
		{
			RecordSet: pRecordSet,
			ViewContext: this._addFilterViewContext,
			Search: this._addFilterSearch || '',
			IsEmpty: tmpFields.length === 0,
			Fields: tmpFields,
		};
	}

	/** Reflect the add-filter popover's open/closed state on its container element. */
	_paintAddFilterOpenState()
	{
		const tmpPopover = document.getElementById('PRSP_AddFilter_Popover');
		if (!tmpPopover) { return; }
		tmpPopover.classList.toggle('open', !!this._addFilterOpen);
		if (this._addFilterOpen) { this._positionAddFilterPopover(tmpPopover); }
	}

	/**
	 * Position the (fixed) add-filter popover against its trigger button, flipping above when there's
	 * more room there. Fixed positioning means no ancestor overflow:hidden (the host's filter card, the
	 * slide-out drawer) can clip it — the price is we set its top/left from the trigger's rect here.
	 *
	 * @param {HTMLElement} pPopover - the #PRSP_AddFilter_Popover element (already display:block).
	 */
	_positionAddFilterPopover(pPopover)
	{
		const tmpTrigger = document.getElementById('PRSP_Filter_Button_Add');
		if (!tmpTrigger) { return; }
		const tmpPanel = /** @type {HTMLElement} */ (pPopover.querySelector('.prsp-addfilter-panel'));
		const tmpRect = tmpTrigger.getBoundingClientRect();
		const tmpGap = 6;
		const tmpMargin = 8;
		const tmpVH = window.innerHeight;
		const tmpVW = window.innerWidth;
		const tmpWidth = pPopover.offsetWidth || 300;
		pPopover.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.left, tmpVW - tmpWidth - tmpMargin)))}px`;
		pPopover.style.right = 'auto';
		const tmpSpaceBelow = tmpVH - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		// Prefer the natural downward direction; only flip above when the room below is genuinely cramped.
		if (tmpSpaceBelow >= 220 || tmpSpaceBelow >= tmpSpaceAbove)
		{
			pPopover.style.top = `${Math.round(tmpRect.bottom + tmpGap)}px`;
			pPopover.style.bottom = 'auto';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceBelow, 460))}px`; }
		}
		else
		{
			pPopover.style.top = 'auto';
			pPopover.style.bottom = `${Math.round(tmpVH - tmpRect.top + tmpGap)}px`;
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceAbove, 460))}px`; }
		}
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @param {string} pFilterKey - The key of the filter to add
	 * @param {string} pClauseKey - The key of the clause to add
	 */
	addFilter(pEvent, pRecordSet, pViewContext, pFilterKey, pClauseKey)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.log.info(`Adding filter: ${pFilterKey} with clause: ${pClauseKey} to record set: ${pRecordSet} in view context: ${pViewContext}`);
		this.pict.providers[`RSP-Provider-${pRecordSet}`].addFilterClause(pFilterKey, pClauseKey);
		//FIXME: we need the record from the original render here but no longer have it...
		this.render(undefined, undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		if (this.addFilterCallback) this.addFilterCallback();
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @param {string} pSpecificFilterKey - The key of the specific filter to remove
	 */
	removeFilter(pEvent, pRecordSet, pViewContext, pSpecificFilterKey)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.log.info(`Removing filter: ${pSpecificFilterKey} from record set: ${pRecordSet} in view context: ${pViewContext}`);
		this.pict.providers[`RSP-Provider-${pRecordSet}`].removeFilterClause(pSpecificFilterKey);
		//FIXME: we need the record from the original render here but no longer have it...
		this.render(undefined, undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		if (this.removeFilterCallback) this.removeFilterCallback();
	}

	/**
	 * Gets the filter schema for the given record set.
	 * @param {string} pRecordSet - The record set to get the filter schema for
	 * @return {Array<any>} - The filter schema for the given record set
	 */
	getFilterSchema(pRecordSet)
	{
		const tmpRecordsetProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		return Object.values(tmpRecordsetProvider.getFilterSchema()).flatMap((pFilter) => pFilter.AvailableClauses || []);
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered. The consolidated filter
	 * control's markup is owned by this module now, so re-assert its templates here — this
	 * neutralizes any host/server template override that previously replaced the filter UI,
	 * letting apps brand the control via CSS (theme tokens) rather than by swapping markup.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable about to be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Re-assert ONLY the consolidated-control chrome (the wrapper, search row, filter toggle +
		// Search button, the Filter Experiences container, and Clear/Reset/Apply) so the module owns
		// that markup. Deliberately NOT the add-filter dropdown or per-clause templates: host apps
		// (e.g. Headlight) layer their own styled add-filter popover and clause UI on top, and
		// re-asserting those clobbers them — re-exposing bare native <select> dropdowns and a dead
		// remove button. Those host overrides register at init and must survive each re-render.
		const tmpChromeTemplateHashes =
		[
			'PRSP-SUBSET-Filters-Template',
			'PRSP-SUBSET-Filters-Template-Input-Fieldset',
			'PRSP-SUBSET-Filters-Template-Button-Fieldset',
			'PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset',
			'PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset'
		];
		if (this.pict.TemplateProvider && Array.isArray(_DEFAULT_CONFIGURATION_SUBSET_Filter.Templates))
		{
			for (const tmpTemplateHash of tmpChromeTemplateHashes)
			{
				const tmpTemplate = _DEFAULT_CONFIGURATION_SUBSET_Filter.Templates.find((pTemplate) => pTemplate.Hash === tmpTemplateHash);
				if (tmpTemplate)
				{
					this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template);
				}
			}
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const res = super.onAfterRender(pRenderable);
		// Add-filter popover sub-renders (the panel + its list) only repaint that widget — skip the
		// heavy post-render pass below and just keep the open/closed class in sync.
		if (pRenderable?.RenderableHash === 'PRSP_AddFilter_Popover' || pRenderable?.RenderableHash === 'PRSP_AddFilter_List')
		{
			this._paintAddFilterOpenState();
			return res;
		}
		// Any full re-render rebuilds the add-filter slot, so the popover is closed — reset its state.
		this._addFilterOpen = false;
		this.onMarshalToView();

		// NOTE: This is where we ensure the filter experience is applied after a render.
		const tmpRouteUrl = this.pict.providers.PictRouter?.router?.current[0]?.url || this.pict.providers.PictRouter?.router?.current[0]?.hashString;
		const tmpRecordSet = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[0];
		const tmpViewContext = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[1];
		if (tmpRecordSet && tmpViewContext)
		{
			this.pict.providers.FilterDataProvider.applyExpectedFilterExperience(tmpRecordSet, tmpViewContext);
		}

		// Consolidated filter control: whenever the search row is in the DOM, refresh the
		// search box, the filters icon/count + drawer state, and surface the saved Filter
		// Experiences dropdown in the drawer. (Guarded on the DOM element rather than the
		// renderable hash because the list embeds this view via {~FV:~}.)
		if (document.getElementById('PRSP_Filter_Icon'))
		{
			let tmpFilterRecordSet = tmpRecordSet;
			let tmpFilterViewContext = tmpViewContext || 'List';
			if (!tmpFilterRecordSet && this.pict.Bundle && this.pict.Bundle._ActiveFilterState)
			{
				tmpFilterRecordSet = Object.keys(this.pict.Bundle._ActiveFilterState)[0];
			}
			if (tmpFilterRecordSet)
			{
				this._paintFilterControls(tmpFilterRecordSet);
				this._renderQuickFilters(tmpFilterRecordSet, tmpFilterViewContext);
				this._renderShowDeletedControl(tmpFilterRecordSet, tmpFilterViewContext);
				// (Re)render the experiences dropdown only when its container is empty — i.e. on
				// a fresh filter render — not on every sub-render (add-filter dropdown, etc.).
				const tmpExpContainer = document.getElementById('FilterPersistenceView-Container');
				if (this.pict.views.FilterPersistenceView && tmpExpContainer && !tmpExpContainer.querySelector('#FilterPersistenceView-Content'))
				{
					this.pict.views.FilterPersistenceView.initializeFilterPersistenceViewUI(tmpFilterRecordSet, tmpFilterViewContext);
				}
			}
			if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		}

		return res;
	}

	/**
	 * Encodes the filter experience to a string.
	 * @param {Record<string, any>} pExperience - The filter experience to serialize.
	 * @return {Promise<string>} - The serialized filter experience as a string.
	 */
	async serializeFilterExperience(pExperience)
	{
		if (!pExperience || typeof pExperience !== 'object')
		{
			return '';
		}
		const tmpExperience = JSON.parse(JSON.stringify(pExperience));
		for (const tmpClause of tmpExperience)
		{
			//FIXME: avoiding saving search results to the URL but this pattern isn't ideal
			delete tmpClause.SearchResults;
			delete tmpClause.SearchResultsOffset;
			delete tmpClause.LoadMoreEnabled;
		}
		return this.encode(await this.compress(JSON.stringify(tmpExperience)));
	}

	/**
	 * Decodes the filter experience from a string.
	 * @param {string} pExperience - The serialized filter experience as a string.
	 * @return {Promise<Record<string, any>>} - The serialized filter experience as a string.
	 */
	async deserializeFilterExperience(pExperience)
	{
		if (!pExperience || typeof pExperience !== 'string')
		{
			//TODO: if the default filters expand, how we wanna handle that?
			return null;
		}
		return JSON.parse(await this.decompress(new Uint8Array(this.decode(pExperience))));
	}

	/**
	 * @param {string} string - The string to compress.
	 * @param {CompressionFormat} [encoding='gzip'] - The encoding to use for compression, defaults to 'gzip'.
	 * @return {Promise<ArrayBuffer>} - The compressed byte array.
	 */
	async compress(string, encoding = 'gzip')
	{
		const byteArray = new TextEncoder().encode(string);
		const cs = new CompressionStream(encoding);
		const writer = cs.writable.getWriter();
		writer.write(byteArray);
		writer.close();
		return new Response(cs.readable).arrayBuffer();
	}

	/**
	 * @param {Uint8Array} byteArray - The byte array to decompress.
	 * @param {CompressionFormat} [encoding='gzip'] - The encoding to use for compression, defaults to 'gzip'.
	 */
	async decompress(byteArray, encoding = 'gzip')
	{
		const cs = new DecompressionStream(encoding);
		const writer = cs.writable.getWriter();
		// @ts-ignore
		writer.write(byteArray);
		writer.close();
		return new Response(cs.readable).arrayBuffer().then((arrayBuffer) =>
		{
			return new TextDecoder().decode(arrayBuffer);
		});
	}

	/**
	 * @param {ArrayBuffer} arraybuffer - The ArrayBuffer to encode to Base64.
	 * @return {string} - The Base64 encoded string.
	 */
	encode(arraybuffer)
	{
		let bytes = new Uint8Array(arraybuffer),
			i,
			len = bytes.length,
			base64 = '';

		for (i = 0; i < len; i += 3)
		{
			base64 += this.chars[bytes[i] >> 2];
			base64 += this.chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
			base64 += this.chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
			base64 += this.chars[bytes[i + 2] & 63];
		}

		if (len % 3 === 2)
		{
			base64 = base64.substring(0, base64.length - 1) + '=';
		}
		else if (len % 3 === 1)
		{
			base64 = base64.substring(0, base64.length - 2) + '==';
		}

		return base64;
	};

	/**
	 * @param {string} base64 - The Base64 encoded string to decode to an ArrayBuffer.
	 * @return {ArrayBuffer} - The decoded ArrayBuffer.
	 */
	decode(base64)
	{
		let bufferLength = base64.length * 0.75,
			len = base64.length,
			i,
			p = 0,
			encoded1,
			encoded2,
			encoded3,
			encoded4;

		if (base64[base64.length - 1] === '=')
		{
			bufferLength--;
			if (base64[base64.length - 2] === '=')
			{
				bufferLength--;
			}
		}

		const arraybuffer = new ArrayBuffer(bufferLength),
			bytes = new Uint8Array(arraybuffer);

		for (i = 0; i < len; i += 4)
		{
			encoded1 = this.lookup[base64.charCodeAt(i)];
			encoded2 = this.lookup[base64.charCodeAt(i + 1)];
			encoded3 = this.lookup[base64.charCodeAt(i + 2)];
			encoded4 = this.lookup[base64.charCodeAt(i + 3)];

			bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
			bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
			bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
		}

		return arraybuffer;
	};
}

// Funnel icons for the filters toggle — outline when no filters are set, filled when set.
// currentColor so they follow the (themeable) toggle text color.
ViewRecordSetSUBSETFilters.FilterIconOutline = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 5.5h17l-6.6 7.8v4.7l-3.8 2v-6.7z"/></svg>';
ViewRecordSetSUBSETFilters.FilterIconFilled = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.5 5.5h17l-6.6 7.8v4.7l-3.8 2v-6.7z"/></svg>';

module.exports = ViewRecordSetSUBSETFilters;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_SUBSET_Filter;


},{"./filters":670,"pict-section-form/source/views/Pict-View-DynamicForm.js":563,"pict-view":693}],627:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Base_View = (
{
	ViewIdentifier: 'PRSP-RecordSet-View-Base',

	DefaultRenderable: 'PRSP_Base_Recordset',
	DefaultDestinationAddress: '#PictRecordSetContainer',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
		[
			{
			Hash: 'PRSP-Base-View-Template',
			Template: /*html*/`
<!-- DefaultPackage pict view template: [PRSP-Base-View-Template] -->
<!--
	If this is being rendered, the RecordSet view has not taken control of its render function.
	While the view may not need custom templating it is strongly encouraged to still override 
	the template and put informative messaging into an HTML comment.

Record JSON:
\`\`\`json
{~DataJson:Record~}
\`\`\`
-->
<!-- DefaultPackage end view template:  [PRSP-Base-View-Template] -->
		`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Base_Recordset',
				TemplateHash: 'PRSP-Base-View-Template',
				DestinationAddress: '#PictRecordSetContainer',
				RenderMethod: 'replace'
			}
		],

	Manifests: {}
});

class viewPictSectionRecordSetViewBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_Base_View, pOptions);
		super(pFable, tmpOptions, pServiceHash);
		/** @type {import('pict') & {
		 *   log: any,
		 *   instantiateServiceProviderWithoutRegistration: (hash: String) => any,
		 *   instantiateServiceProviderIfNotExists: (hash: string) => any,
		 *   TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking'),
		 *   PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>,
		 * }} */
		this.pict;
	}

	addRoutes(pPictRouter)
	{
		this.pict.log.trace(`View [${this.options.ViewIdentifier}]::[${this.Hash}] addRoutes called.`);
		return true;
	}

	/**
	 * Custom-view override hook. A record set can replace the built-in List / View / Edit / Create
	 * screen with an entirely custom pict view by setting `RecordSetConfiguration.RecordSetCustomViews`,
	 * e.g. `{ View: 'MyViewHash', Edit: 'MyViewHash', Create: 'MyViewHash', List: 'MyViewHash' }`.
	 *
	 * When a route for `pAction` fires and a custom view is configured (and registered), the route
	 * context is stashed at `AppData.PictRecordSetCustomView` = `{ Action, RecordSet, GUIDRecord }` and
	 * the custom view is driven: its `onRecordSetCustomView(context)` is called if present, else it is
	 * `render()`ed. Returns true when it handled the route (the caller must then return without
	 * rendering the generic screen); false to fall through to the built-in rendering.
	 *
	 * @param {string} pAction - 'List' | 'View' | 'Edit' | 'Create'
	 * @param {Record<string, any>} pProviderConfiguration
	 * @param {Record<string, any>} [pRoutePayload]
	 * @return {boolean}
	 */
	delegateToCustomView(pAction, pProviderConfiguration, pRoutePayload)
	{
		const tmpCustomViews = pProviderConfiguration && pProviderConfiguration.RecordSetCustomViews;
		const tmpViewHash = tmpCustomViews && tmpCustomViews[pAction];
		if (!tmpViewHash || !this.pict.views[tmpViewHash])
		{
			if (tmpViewHash && !this.pict.views[tmpViewHash])
			{
				this.pict.log.warn(`RecordSet [${pProviderConfiguration && pProviderConfiguration.RecordSet}] configures a custom ${pAction} view [${tmpViewHash}] but no such view is registered; falling back to the built-in screen.`);
			}
			return false;
		}
		const tmpContext =
		{
			Action: pAction,
			RecordSet: (pRoutePayload && pRoutePayload.data && pRoutePayload.data.RecordSet) || (pProviderConfiguration && pProviderConfiguration.RecordSet) || '',
			GUIDRecord: (pRoutePayload && pRoutePayload.data && pRoutePayload.data.GUIDRecord) || '',
			RoutePayload: pRoutePayload || null,
		};
		this.pict.AppData.PictRecordSetCustomView = tmpContext;
		const tmpView = this.pict.views[tmpViewHash];
		if (typeof tmpView.onRecordSetCustomView === 'function')
		{
			tmpView.onRecordSetCustomView(tmpContext);
		}
		else
		{
			tmpView.render();
		}
		return true;
	}
}

module.exports = viewPictSectionRecordSetViewBase;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_Base_View;

},{"pict-view":693}],628:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Bulk Associate screen — a purpose-built page for reconciling one anchor's joins in a single pass
 * ("which books belong to THIS store?"). The anchor recordset (the route's `:RecordSet`) is one side of
 * the association; the user picks an anchor record, then sees a searchable, paged table of the OTHER
 * side's records with a checkbox each. The rows currently joined to the anchor are PRE-CHECKED; checking a
 * new row stages an add, unchecking a linked row stages a remove, and "Apply changes" commits both at once
 * (create the newly-checked joins, delete the newly-unchecked ones). This makes the screen reflect the
 * current associations as one editable whole rather than an add-only picker.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-Associate` and parameterized by route:
 *   /PSRS/:RecordSet/Associate/:Association
 *   /PSRS/:RecordSet/Associate/:Association/:AnchorID
 *
 * Light opt-in: a recordset advertises the screen in its nav by listing `RecordSetBulkAssociations`, but
 * the route works for any association whose side matches `:RecordSet`. Data flows through the shared
 * `RecordSetAssociationManager` (listAssociatedRecords + fetchSidePage + createJoin/removeJoin); the anchor
 * picker comes from `pict-section-picker` (soft dependency); column visibility persists through the
 * `ColumnDataProvider`. The other-side table needs no picker — a nice robustness win over the old cull-picker.
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociateBulk = (
	{
		ViewIdentifier: 'PRSP-AssociateBulk',

		DefaultRenderable: 'PRSP_Renderable_AssociateBulk',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		// The other-side page size for the reconcile table (record offset paging via "Load more").
		ReconcilePageSize: 50,

		CSS: /*css*/`
		.prsp-bulk { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-bulk-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-bulk-card { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); display: flex; flex-direction: column; gap: 0.6rem; }
		.prsp-bulk-card-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bulk-picker-host { max-width: 520px; }
		.prsp-bulk-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		.prsp-bulk-hint { color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; font-style: italic; padding: 0.5rem 0.2rem; }
		.prsp-bulk-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-bulk-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bulk-stats strong { color: var(--theme-color-brand-primary, #156dd1); font-size: 1.05rem; }
		.prsp-bulk-apply { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
			background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.prsp-bulk-apply:hover { background: var(--theme-color-brand-primary-hover, #1259ad); }
		.prsp-bulk-apply[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-bulk-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; flex-wrap: wrap; }
		.prsp-bulk-search { flex: 1 1 220px; display: flex; align-items: center; gap: 0.4rem; padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }
		.prsp-bulk-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
		.prsp-bulk-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-tools { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-bulk-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bulk-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-colchooser-wrap { position: relative; }
		.prsp-bulk-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-bulk-colchooser-wrap.is-open .prsp-bulk-colchooser-backdrop { display: block; }
		.prsp-bulk-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-bulk-colchooser-wrap.is-open .prsp-bulk-colchooser { display: block; }
		.prsp-bulk-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-bulk-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-bulk-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-bulk-colrow.is-on .prsp-bulk-colrow-check { visibility: visible; }
		.prsp-bulk-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-bulk-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-bulk-tablewrap { max-height: 56vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-rtbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-rtbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-rtbl-th-check { width: 1.8rem; text-align: center; cursor: pointer; }
		.prsp-rtbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-rtbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-rtbl-row.is-selected { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 9%, transparent); }
		.prsp-rtbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-rtbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-rtbl-check { display: inline-flex; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-rtbl-row.is-selected .prsp-rtbl-check { visibility: visible; }
		.prsp-rtbl-headcheck { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bulk-more { display: block; width: 100%; padding: 0.45rem; cursor: pointer; font: inherit; font-size: 0.85rem; border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0);
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bulk-more:hover { background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); }
		.prsp-bulk-empty { padding: 0.9rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; font-style: italic; text-align: center; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociateBulk-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociateBulk-Template] -->
		<div class="prsp-bulk">
			<div class="prsp-bulk-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-bulk-sub">{~D:Record.Subtitle~}</p>
			</div>
			<div class="prsp-bulk-card">
				<span class="prsp-bulk-card-label">{~D:Record.AnchorLabel~}</span>
				<div class="prsp-bulk-picker-host" id="{~D:Record.AnchorPickerHostID~}"></div>
				{~NE:Record.PickerMissing^<div class="prsp-bulk-note">The entity picker (pict-section-picker) is not registered, so the anchor cannot be chosen.</div>~}
			</div>
			{~TS:PRSP-AssociateBulk-Hint:Record.HintSlot~}
			{~TS:PRSP-AssociateBulk-Body:Record.BodySlot~}
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociateBulk-Template] -->
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-Hint',
				Template: /*html*/`<div class="prsp-bulk-hint">{~D:Record.Hint~}</div>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Body',
				Template: /*html*/`
		<div class="prsp-bulk-bar">
			<div class="prsp-bulk-stats" id="{~D:Record.StatsID~}"></div>
			<button type="button" class="prsp-bulk-apply" id="{~D:Record.ApplyButtonID~}" onclick="_Pict.views['RSP-RecordSet-Associate'].applyReconcile()">{~I:Check~} Apply changes</button>
		</div>
		<div class="prsp-bulk-card">
			<div class="prsp-bulk-toolbar">
				<div class="prsp-bulk-search">
					<span class="prsp-bulk-search-ic">{~I:Search~}</span>
					<input type="text" placeholder="Search {~D:Record.OtherLabel~}…" autocomplete="off" oninput="_Pict.views['RSP-RecordSet-Associate'].searchSide(this.value)">
				</div>
				<div class="prsp-bulk-tools">
					<div class="prsp-bulk-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-bulk-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleColumnChooser()">{~I:Settings~} Columns</button>
						<div class="prsp-bulk-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-Associate'].closeColumnChooser()"></div>
						<div class="prsp-bulk-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<div class="prsp-bulk-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-Table',
				Template: /*html*/`
		<table class="prsp-rtbl">
			<thead><tr><th class="prsp-rtbl-th-check" title="Select all loaded" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleSelectAll()"><span class="prsp-rtbl-headcheck">{~D:Record.SelectAllIcon~}</span></th>{~TS:PRSP-AssociateBulk-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-AssociateBulk-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-AssociateBulk-Empty:Record.EmptySlot~}
		{~TS:PRSP-AssociateBulk-More:Record.MoreSlot~}
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-rtbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleRow('{~D:Record.OtherID~}')"><td class="prsp-rtbl-td-check"><span class="prsp-rtbl-check">{~I:Check~}</span></td>{~TS:PRSP-AssociateBulk-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Empty',
				Template: /*html*/`<div class="prsp-bulk-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociateBulk-More',
				Template: /*html*/`<button type="button" class="prsp-bulk-more" onclick="_Pict.views['RSP-RecordSet-Associate'].loadMore()">Load more</button>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Chooser',
				Template: /*html*/`
		<div class="prsp-bulk-colchooser-list">{~TS:PRSP-AssociateBulk-ColRow:Record.Rows~}</div>
		<div class="prsp-bulk-colchooser-foot"><button type="button" class="prsp-bulk-colreset" onclick="_Pict.views['RSP-RecordSet-Associate'].resetColumns()">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-ColRow',
				Template: /*html*/`<button type="button" class="prsp-bulk-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleColumn('{~D:Record.Key~}')"><span class="prsp-bulk-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociateBulk',
				TemplateHash: 'PRSP-AssociateBulk-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociateBulk extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociateBulk, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._anchorRecordSet = null;
		this._associationHash = null;
		this._anchorID = null;
		this._thisSide = null;
		this._otherSide = null;
		this._otherRecords = [];    // the loaded page(s) of other-side records to reconcile
		this._cursor = 0;           // record offset for paging
		this._hasMore = false;
		this._search = '';
		this._searchTimer = null;
		this._selected = {};        // String(OtherID) -> true : the CURRENT checked state, spans pages
		this._originalLinked = {};  // String(OtherID) -> joinRecord : snapshot of what was linked at load
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/** @return {number} The other-side page size for the reconcile table. */
	_pageSize()
	{
		return this.options.ReconcilePageSize || 50;
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/Associate/:Association/:AnchorID', this.handleAssociateRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Associate/:Association', this.handleAssociateRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — parse the anchor recordset, association, and optional preset anchor id, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleAssociateRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Associate route handler called with invalid route payload.`);
		}
		this._anchorRecordSet = pRoutePayload.data.RecordSet;
		this._associationHash = pRoutePayload.data.Association;
		this._anchorID = (pRoutePayload.data.AnchorID !== undefined && pRoutePayload.data.AnchorID !== '') ? pRoutePayload.data.AnchorID : null;

		// Use the recordset's RecordSetBulkAssociations Title (the opt-in label) as the screen title.
		this.options.ScreenTitle = false;
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet
			? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this._anchorRecordSet] : null;
		const tmpBulkConfiguration = (tmpRecordSetConfiguration && Array.isArray(tmpRecordSetConfiguration.RecordSetBulkAssociations))
			? tmpRecordSetConfiguration.RecordSetBulkAssociations.find((pEntry) => pEntry.Association === this._associationHash) : null;
		if (tmpBulkConfiguration && tmpBulkConfiguration.Title)
		{
			this.options.ScreenTitle = tmpBulkConfiguration.Title;
		}

		return this.renderScreen();
	}

	/** A DOM/address-safe key for this screen's pickers + table. */
	get safeKey()
	{
		return `${String(this._anchorRecordSet)}_${String(this._associationHash)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	/** @return {string} */
	_anchorLabel() { return this._thisSide ? (this._thisSide.Title || this._thisSide.RecordSet || this._thisSide.Entity) : ''; }
	/** @return {string} */
	_otherLabel() { return this._otherSide ? (this._otherSide.Title || this._otherSide.RecordSet || this._otherSide.Entity) : ''; }

	/** Persistence scope for this association's other-side column visibility (distinct from list/matrix). */
	_columnScope() { return `Reconcile_${this._associationHash}_${this._otherSide && this._otherSide.RecordSet}`; }

	/**
	 * Load the anchor's current links (seeding the checked state + link snapshot), fetch the first page of
	 * the other side, paint the screen, and mount the anchor picker + reconcile table.
	 * @return {Promise<boolean>}
	 */
	async renderScreen()
	{
		const tmpSides = this.manager ? this.manager.resolveSides(this._associationHash, this._anchorRecordSet) : false;
		if (!tmpSides)
		{
			this.pict.log.warn(`AssociateBulk: association [${this._associationHash}] could not be resolved for [${this._anchorRecordSet}].`);
			return false;
		}
		this._thisSide = tmpSides.thisSide;
		this._otherSide = tmpSides.otherSide;
		// A fresh shell renders an empty search box, so start from an empty search term to stay in sync.
		this._search = '';

		const tmpHasAnchor = (this._anchorID !== undefined && this._anchorID !== null && this._anchorID !== '');

		// Seed the checked state + link snapshot from the anchor's current associations (ALL of them, not
		// just the first page), so a linked record on a page the user never scrolls to is still handled.
		this._selected = {};
		this._originalLinked = {};
		this._otherRecords = [];
		this._cursor = 0;
		this._hasMore = false;
		if (tmpHasAnchor)
		{
			const tmpItems = await this.manager.listAssociatedRecords(this._associationHash, this._anchorRecordSet, this._anchorID);
			for (let i = 0; i < tmpItems.length; i++)
			{
				const tmpKey = String(tmpItems[i].OtherID);
				this._originalLinked[tmpKey] = tmpItems[i].JoinRecord;
				this._selected[tmpKey] = true;
			}
			await this._fetchPage(true);
		}

		const tmpAnchorLabel = this._anchorLabel();
		const tmpOtherLabel = this._otherLabel();

		const tmpBodyData = {
			OtherLabel: tmpOtherLabel,
			StatsID: `${this.safeKey}_Stats`,
			ApplyButtonID: `${this.safeKey}_Apply`,
			ChooserID: `${this.safeKey}_Chooser`,
			TableID: `${this.safeKey}_Table`,
		};

		const tmpRecord =
		{
			Title: this.options.ScreenTitle || `Assign ${tmpOtherLabel} to a ${this._singular(tmpAnchorLabel)}`,
			Subtitle: `Pick one of the ${tmpAnchorLabel}, then check the ${tmpOtherLabel} it should be linked to. Applying adds the newly-checked and removes the unchecked.`,
			AnchorLabel: `${tmpAnchorLabel}`,
			AnchorPickerHostID: `${this.safeKey}_Anchor`,
			PickerMissing: !this.pict.providers['Pict-Section-Picker'],
			HintSlot: tmpHasAnchor ? [] : [ { Hint: `Choose one of the ${tmpAnchorLabel} above to begin.` } ],
			BodySlot: tmpHasAnchor ? [ tmpBodyData ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociateBulk: render error.`, pError);
						return resolve(false);
					}
					this._mountAnchorPicker(tmpSides, tmpRecord.AnchorPickerHostID);
					if (tmpHasAnchor)
					{
						this._renderTable();
						this.updateStats();
					}
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/**
	 * Fetch one page of the OTHER side's records (search + offset paging). Reuses fetchSidePage by passing
	 * the OTHER side's RecordSet name so it resolves that side as "this side".
	 * @param {boolean} pReset - reset the offset + replace the loaded records (vs append the next page).
	 * @return {Promise<void>}
	 */
	async _fetchPage(pReset)
	{
		if (pReset) { this._cursor = 0; }
		const tmpResult = await this.manager.fetchSidePage(this._associationHash, this._otherSide.RecordSet, this._search, this._cursor, this._pageSize());
		this._otherRecords = pReset ? tmpResult.records : this._otherRecords.concat(tmpResult.records);
		this._hasMore = tmpResult.hasMore;
	}

	/**
	 * Mount the anchor (this side) picker — single select, preselected to the current anchor.
	 * @param {Record<string, any>} pSides @param {string} pHostID
	 */
	_mountAnchorPicker(pSides, pHostID)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpPickerHash = `${this.safeKey}_AnchorPicker`;
		const tmpValueAddress = `AppData.PRSPBulkAnchor.${this.safeKey}`;

		const tmpConfig = this.manager.buildAnchorPickerConfig(this._associationHash, this._anchorRecordSet,
			{
				DestinationAddress: `#${pHostID}`,
				ValueAddress: tmpValueAddress,
				Placeholder: `Search ${pSides.thisSide.Title || pSides.thisSide.RecordSet || pSides.thisSide.Entity}…`,
				OnChange: (pValue) => { this.selectAnchor(pValue); },
			});
		if (!tmpConfig)
		{
			return;
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		// setValue (not render) so the picker (re)seeds + resolves the preset anchor's display without
		// firing OnChange (which would loop back into selectAnchor).
		this.pict.views[tmpPickerHash].setValue((this._anchorID !== undefined && this._anchorID !== null) ? this._anchorID : null);
	}

	/**
	 * The anchor picker's OnChange — switch the anchor and repaint (loads its current links + first page).
	 * @param {string|number} pAnchorID
	 * @return {Promise<void>}
	 */
	async selectAnchor(pAnchorID)
	{
		this._anchorID = (pAnchorID !== undefined && pAnchorID !== '') ? pAnchorID : null;
		await this.renderScreen();
	}

	/** Effective visibility for a column (stored override wins, else `!DefaultHidden`). */
	_isColumnVisible(pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(), 'Reconcile') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @return {Array<Record<string, any>>} The currently-visible other-side columns. */
	_visibleColumns()
	{
		return this._otherSide.TableColumns.filter((pCol) => this._isColumnVisible(pCol));
	}

	/** Build the row models for the loaded other-side records (pre-checking current links) and render the table. */
	_renderTable()
	{
		const tmpColumns = this._visibleColumns();
		const tmpIDField = this._otherSide.IDField;
		const tmpRows = this._otherRecords.map((pRecord) =>
		{
			const tmpID = pRecord[tmpIDField];
			return {
				OtherID: tmpID,
				RowID: `${this.safeKey}_row_${tmpID}`,
				Selected: !!this._selected[String(tmpID)],
				Cells: tmpColumns.map((pCol) => ({ Value: pCol.Template ? this.pict.parseTemplate(pCol.Template, pRecord) : pRecord[pCol.Key] })),
			};
		});
		const tmpAllSelected = (tmpRows.length > 0 && tmpRows.every((pRow) => pRow.Selected));
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			SelectAllIcon: this.pict.icon(tmpAllSelected ? 'Check' : 'Minus'),
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: this._search ? `No ${this._otherLabel()} match the search.` : `No ${this._otherLabel()} found.` } ] : [],
			MoreSlot: this._hasMore ? [ {} ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateBulk-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Table`, tmpHTML);
	}

	/** Debounced server-side search of the other side (resets to page 0). @param {string} pTerm */
	searchSide(pTerm)
	{
		this._search = pTerm;
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(async () =>
		{
			await this._fetchPage(true);
			this._renderTable();
		}, 250);
	}

	/** Load the next page of the other side and append it. @return {Promise<void>} */
	async loadMore()
	{
		this._cursor += this._pageSize();
		await this._fetchPage(false);
		this._renderTable();
	}

	/**
	 * Toggle a row's checked state (the row click). Updates the selection map + row class + stats.
	 * @param {string|number} pOtherID
	 */
	toggleRow(pOtherID)
	{
		const tmpKey = String(pOtherID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; }
		else { this._selected[tmpKey] = true; }
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_row_${pOtherID}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!this._selected[tmpKey]);
		}
		this.updateStats();
	}

	/**
	 * Select / clear all the LOADED rows (the header checkbox). Only affects records currently loaded — a
	 * linked record on an un-loaded page is left untouched (it stays in the selection/link maps), so this
	 * never silently unlinks something off-screen.
	 */
	toggleSelectAll()
	{
		const tmpIDField = this._otherSide.IDField;
		const tmpAllSelected = (this._otherRecords.length > 0 && this._otherRecords.every((pRecord) => this._selected[String(pRecord[tmpIDField])]));
		for (let i = 0; i < this._otherRecords.length; i++)
		{
			const tmpKey = String(this._otherRecords[i][tmpIDField]);
			if (tmpAllSelected) { delete this._selected[tmpKey]; }
			else { this._selected[tmpKey] = true; }
		}
		this._renderTable();
		this.updateStats();
	}

	/**
	 * Diff the current checked state against the link snapshot: `toCreate` are ids checked now but not
	 * originally linked; `toRemove` are the join records originally linked but now unchecked. Iterating the
	 * MAPS (not the rendered rows) is what makes an off-screen linked row a correct no-op.
	 * @return {{ toCreate: Array<string>, toRemove: Array<Record<string, any>> }}
	 */
	_computeReconcileDiff()
	{
		const tmpToCreate = [];
		const tmpToRemove = [];
		for (const tmpKey of Object.keys(this._selected))
		{
			if (this._selected[tmpKey] && !this._originalLinked[tmpKey]) { tmpToCreate.push(tmpKey); }
		}
		for (const tmpKey of Object.keys(this._originalLinked))
		{
			if (!this._selected[tmpKey]) { tmpToRemove.push(this._originalLinked[tmpKey]); }
		}
		return { toCreate: tmpToCreate, toRemove: tmpToRemove };
	}

	/** Recompute the pending-change stats line + the Apply button's enabled state. */
	updateStats()
	{
		const tmpDiff = this._computeReconcileDiff();
		const tmpAdd = tmpDiff.toCreate.length;
		const tmpRemove = tmpDiff.toRemove.length;
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`,
			`<strong>${tmpAdd}</strong> to add &middot; <strong>${tmpRemove}</strong> to remove`);
		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Apply`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = ((tmpAdd + tmpRemove) < 1);
		}
	}

	/**
	 * Apply the staged changes — create the newly-checked joins and remove the newly-unchecked ones (confirm
	 * via the host modal), then repaint (which re-seeds from the now-current links, self-healing any partial
	 * failure).
	 * @return {Promise<void>}
	 */
	async applyReconcile()
	{
		if (this._anchorID === undefined || this._anchorID === null || this._anchorID === '')
		{
			return;
		}
		const tmpDiff = this._computeReconcileDiff();
		if (tmpDiff.toCreate.length < 1 && tmpDiff.toRemove.length < 1)
		{
			this._toast('No changes to apply.', 'info');
			return;
		}

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`Add ${tmpDiff.toCreate.length} and remove ${tmpDiff.toRemove.length} ${this._otherLabel()}?`,
				{ title: 'Apply changes', confirmLabel: 'Apply', cancelLabel: 'Cancel', dangerous: (tmpDiff.toRemove.length > 0) });
			if (!tmpOk)
			{
				return;
			}
		}

		let tmpCreated = 0;
		let tmpRemoved = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpDiff.toCreate.length; i++)
		{
			try
			{
				await this.manager.createJoin(this._associationHash, this._anchorRecordSet, this._anchorID, tmpDiff.toCreate[i]);
				tmpCreated++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`AssociateBulk: failed to create join for ${tmpDiff.toCreate[i]}.`, pError);
			}
		}
		for (let i = 0; i < tmpDiff.toRemove.length; i++)
		{
			try
			{
				await this.manager.removeJoin(this._associationHash, tmpDiff.toRemove[i]);
				tmpRemoved++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`AssociateBulk: failed to remove a join.`, pError);
			}
		}
		this._toast(`Added ${tmpCreated}, removed ${tmpRemoved}${tmpFailed > 0 ? `, ${tmpFailed} failed` : ''}.`, tmpFailed > 0 ? 'error' : 'success');

		await this.renderScreen();
	}

	// --- Column chooser (mirrors the unlink/matrix screens, scoped per association's other side) ---

	/** Open/close the column chooser. */
	toggleColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1) { return; }
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser();
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close the column chooser (backdrop outside-click). */
	closeColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render the chooser rows. */
	_renderColumnChooser()
	{
		const tmpRows = this._otherSide.TableColumns.map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName, Visible: this._isColumnVisible(pCol) }));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateBulk-Chooser', { Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Chooser`, tmpHTML);
	}

	/** Toggle one column's visibility (persisted; refuses to hide the last visible column). @param {string} pKey */
	toggleColumn(pKey)
	{
		if (!this.columnProvider) { return; }
		const tmpCol = this._otherSide.TableColumns.find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol) { return; }
		const tmpVisible = this._isColumnVisible(tmpCol);
		if (tmpVisible && this._visibleColumns().length <= 1) { return; }
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(), 'Reconcile', pKey, !tmpVisible);
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Clear column overrides — back to developer defaults. */
	resetColumns()
	{
		if (this.columnProvider) { this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(), 'Reconcile'); }
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Crude singularizer ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/**
	 * Non-blocking notification via the host modal's toast, when available.
	 * @param {string} pMessage @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociateBulk;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociateBulk;

},{"pict-view":693}],629:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Matrix Associate screen — a dual-TABLE bulk-link tool for one association. Unlike the chip-picker
 * screens, each side is a full record table with configurable columns (per-side `TableColumns`) and a
 * checkbox per row — built for connecting complex records (Materials ↔ Pay Items, with several codes
 * and data points on both sides) where a single label can't disambiguate. Multi-select rows on BOTH
 * sides; a live stats line shows the pending count; "Link selected" creates the CROSS-PRODUCT of joins
 * (every left record × every right record), skipping pairs that already exist.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-AssociateMatrix` and parameterized by route:
 *   /PSRS/AssociateMatrix/:Association                 (left = the association's SideA)
 *   /PSRS/AssociateMatrix/:Association/:LeftRecordSet  (left = the named side)
 *
 * Records + columns flow through the shared `RecordSetAssociationManager` (fetchSidePage + TableColumns).
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociateMatrix = (
	{
		ViewIdentifier: 'PRSP-AssociateMatrix',

		DefaultRenderable: 'PRSP_Renderable_AssociateMatrix',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		MatrixPageSize: 25,

		CSS: /*css*/`
		.prsp-matrix { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-matrix-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-matrix-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap; position: sticky; top: 0; z-index: 2;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-matrix-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-matrix-stats strong { color: var(--theme-color-brand-primary, #156dd1); font-size: 1.05rem; }
		.prsp-matrix-stats .prsp-matrix-eq { color: var(--theme-color-text-muted, #6b7686); margin: 0 0.15rem; }
		.prsp-matrix-link { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
			background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.prsp-matrix-link:hover { background: var(--theme-color-brand-primary-hover, #1259ad); }
		.prsp-matrix-link[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-matrix-cols { display: flex; gap: 1rem; align-items: flex-start; }
		.prsp-matrix-col { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 0.5rem;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); }
		.prsp-matrix-col-head { display: flex; align-items: baseline; justify-content: space-between; gap: 0.5rem; }
		.prsp-matrix-col-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-matrix-col-count { font-size: 0.78rem; color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
		.prsp-matrix-col-head-right { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-matrix-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-matrix-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-colchooser-wrap { position: relative; }
		/* Transparent full-viewport backdrop catches the outside click to dismiss (no document listener);
		   only present while open, with the popover stacked above it. */
		.prsp-matrix-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-matrix-colchooser-wrap.is-open .prsp-matrix-colchooser-backdrop { display: block; }
		.prsp-matrix-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-matrix-colchooser-wrap.is-open .prsp-matrix-colchooser { display: block; }
		.prsp-matrix-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-matrix-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-matrix-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-matrix-colrow.is-on .prsp-matrix-colrow-check { visibility: visible; }
		.prsp-matrix-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-matrix-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-matrix-colreset:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-matrix-search { display: flex; align-items: center; gap: 0.4rem; padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }
		.prsp-matrix-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
		.prsp-matrix-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-tablewrap { max-height: 56vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-mtbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-mtbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-mtbl-th-check { width: 1.8rem; }
		.prsp-mtbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-mtbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-mtbl-row.is-selected { background: var(--theme-color-background-selected, #e3edfb); }
		.prsp-mtbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-mtbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-mtbl-check { display: inline-flex; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-mtbl-row.is-selected .prsp-mtbl-check { visibility: visible; }
		.prsp-matrix-empty { padding: 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.88rem; font-style: italic; text-align: center; }
		.prsp-matrix-more { display: block; width: 100%; padding: 0.45rem; cursor: pointer; font: inherit; font-size: 0.85rem; border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0);
			background: transparent; color: var(--theme-color-brand-primary, #156dd1); }
		.prsp-matrix-more:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-matrix-cross { flex: 0 0 auto; display: flex; align-items: center; align-self: center; color: var(--theme-color-text-muted, #6b7686); font-size: 1.4rem; }
		.prsp-matrix-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		@media (max-width: 820px) { .prsp-matrix-cols { flex-direction: column; } .prsp-matrix-cross { align-self: center; transform: rotate(90deg); } }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociateMatrix-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociateMatrix-Template] -->
		<div class="prsp-matrix">
			<div class="prsp-matrix-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-matrix-sub">{~D:Record.Subtitle~}</p>
			</div>
			<div class="prsp-matrix-bar">
				<div class="prsp-matrix-stats" id="{~D:Record.StatsID~}">{~T:PRSP-AssociateMatrix-Stats:Record~}</div>
				<button type="button" class="prsp-matrix-link" id="{~D:Record.LinkButtonID~}" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].associateMatrix()">{~I:Plus~} Link selected</button>
			</div>
			{~NE:Record.PickerMissing^<div class="prsp-matrix-note">The entity provider is not available, so this screen cannot run.</div>~}
			<div class="prsp-matrix-cols">
				{~T:PRSP-AssociateMatrix-Panel:Record.Left~}
				<div class="prsp-matrix-cross">{~I:Plus~}</div>
				{~T:PRSP-AssociateMatrix-Panel:Record.Right~}
			</div>
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociateMatrix-Template] -->
	`
			},
			{
				// One side's panel shell: head + search (rendered once) + an empty table container the
				// table sub-render targets, so searching/paging never disturbs the search input's focus.
				Hash: 'PRSP-AssociateMatrix-Panel',
				Template: /*html*/`
		<div class="prsp-matrix-col">
			<div class="prsp-matrix-col-head">
				<span class="prsp-matrix-col-label">{~D:Record.Label~}</span>
				<div class="prsp-matrix-col-head-right">
					<span class="prsp-matrix-col-count" id="{~D:Record.CountID~}"></span>
					<div class="prsp-matrix-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-matrix-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].toggleColumnChooser('{~D:Record.Column~}')">{~I:Settings~} Columns</button>
						<div class="prsp-matrix-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].closeColumnChooser('{~D:Record.Column~}')"></div>
						<div class="prsp-matrix-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<div class="prsp-matrix-search">
				<span class="prsp-matrix-search-ic">{~I:Search~}</span>
				<input type="text" placeholder="Search {~D:Record.Label~}…" autocomplete="off" oninput="_Pict.views['RSP-RecordSet-AssociateMatrix'].searchSide('{~D:Record.Column~}', this.value)">
			</div>
			<div class="prsp-matrix-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Chooser',
				Template: /*html*/`
		<div class="prsp-matrix-colchooser-list">{~TS:PRSP-AssociateMatrix-ColRow:Record.Rows~}</div>
		<div class="prsp-matrix-colchooser-foot"><button type="button" class="prsp-matrix-colreset" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].resetColumns('{~D:Record.Column~}')">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-AssociateMatrix-ColRow',
				Template: /*html*/`<button type="button" class="prsp-matrix-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].toggleColumn('{~D:Record.Column~}','{~D:Record.Key~}')"><span class="prsp-matrix-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Table',
				Template: /*html*/`
		<table class="prsp-mtbl">
			<thead><tr><th class="prsp-mtbl-th-check"></th>{~TS:PRSP-AssociateMatrix-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-AssociateMatrix-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-AssociateMatrix-Empty:Record.EmptySlot~}
		{~TS:PRSP-AssociateMatrix-More:Record.MoreSlot~}
	`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Empty',
				Template: /*html*/`<div class="prsp-matrix-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-mtbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].toggleRow('{~D:Record.Column~}','{~D:Record.Value~}')"><td class="prsp-mtbl-td-check"><span class="prsp-mtbl-check">{~I:Check~}</span></td>{~TS:PRSP-AssociateMatrix-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-More',
				Template: /*html*/`<button type="button" class="prsp-matrix-more" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].loadMoreSide('{~D:Record.Column~}')">Load more</button>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Stats',
				Template: /*html*/`<strong>{~D:Record.LeftCount~}</strong> {~D:Record.LeftLabel~} <span class="prsp-matrix-eq">×</span> <strong>{~D:Record.RightCount~}</strong> {~D:Record.RightLabel~} <span class="prsp-matrix-eq">=</span> <strong>{~D:Record.PairCount~}</strong> link{~D:Record.PairPlural~}`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociateMatrix',
				TemplateHash: 'PRSP-AssociateMatrix-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociateMatrix extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociateMatrix, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._associationHash = null;
		// Per-column state (Left / Right): the resolved side, loaded records, paging, search, selection.
		this._side = { Left: this._blankSide('Left'), Right: this._blankSide('Right') };
		this._searchTimers = { Left: null, Right: null };
	}

	/** @param {'Left'|'Right'} pColumn @return {Record<string, any>} A blank per-side state. */
	_blankSide(pColumn)
	{
		return { Column: pColumn, side: null, records: [], cursor: 0, hasMore: false, search: '', selected: {} };
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** A DOM/address-safe key for this screen. */
	get safeKey()
	{
		return `${String(this._associationHash)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/AssociateMatrix/:Association/:LeftRecordSet', this.handleMatrixRoute.bind(this));
		pPictRouter.router.on('/PSRS/AssociateMatrix/:Association', this.handleMatrixRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — resolve the association + which side is on the left, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleMatrixRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet AssociateMatrix route handler called with invalid route payload.`);
		}
		this._associationHash = pRoutePayload.data.Association;
		this._side = { Left: this._blankSide('Left'), Right: this._blankSide('Right') };
		const tmpAssociation = this.manager ? this.manager.getAssociation(this._associationHash) : null;
		if (!tmpAssociation)
		{
			this.pict.log.warn(`AssociateMatrix: association [${this._associationHash}] is not registered.`);
			return this.renderMatrix();
		}
		// Left side: the named :LeftRecordSet, else the association's SideA. The other side goes right.
		const tmpLeftRecordSet = pRoutePayload.data.LeftRecordSet || tmpAssociation.SideA.RecordSet;
		const tmpSides = this.manager.resolveSides(this._associationHash, tmpLeftRecordSet);
		this._side.Left.side = tmpSides ? tmpSides.thisSide : tmpAssociation.SideA;
		this._side.Right.side = tmpSides ? tmpSides.otherSide : tmpAssociation.SideB;
		return this.renderMatrix();
	}

	/**
	 * Paint the screen shell, then fetch + render both tables.
	 * @return {Promise<boolean>}
	 */
	renderMatrix()
	{
		if (!this._side.Left.side || !this._side.Right.side)
		{
			this.pict.log.warn(`AssociateMatrix: could not resolve sides for [${this._associationHash}].`);
			return Promise.resolve(false);
		}
		const tmpLeftLabel = this._sideLabel('Left');
		const tmpRightLabel = this._sideLabel('Right');

		const tmpRecord =
		{
			Title: this.options.ScreenTitle || `Bulk-link ${tmpLeftLabel} & ${tmpRightLabel}`,
			Subtitle: `Check ${tmpLeftLabel} on the left and ${tmpRightLabel} on the right, then link every selected ${this._singular(tmpLeftLabel)} to every selected ${this._singular(tmpRightLabel)}.`,
			StatsID: `${this.safeKey}_Stats`,
			LinkButtonID: `${this.safeKey}_Link`,
			PickerMissing: !this.pict.EntityProvider,
			Left: this._panelRecord('Left'),
			Right: this._panelRecord('Right'),
			// Initial stats (zero selected).
			LeftCount: 0, RightCount: 0, PairCount: 0, PairPlural: 's', LeftLabel: tmpLeftLabel, RightLabel: tmpRightLabel,
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociateMatrix: render error.`, pError);
						return resolve(false);
					}
					this.pict.CSSMap.injectCSS();
					this.updateStats();
					Promise.all([ this._fetchSide('Left'), this._fetchSide('Right') ]).then(() => resolve(true));
				});
		});
	}

	/** @param {'Left'|'Right'} pColumn @return {Record<string, any>} The panel shell record. */
	_panelRecord(pColumn)
	{
		return {
			Column: pColumn,
			Label: this._sideLabel(pColumn),
			CountID: `${this.safeKey}_${pColumn}_Count`,
			TableID: `${this.safeKey}_${pColumn}_Table`,
			ChooserID: `${this.safeKey}_${pColumn}_Chooser`,
		};
	}

	/** The ColumnDataProvider persistence scope for a side (distinct from the List view's per-entity scope). */
	_columnScope(pColumn)
	{
		return `Matrix_${this._associationHash}_${pColumn}`;
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/**
	 * Effective visibility for a column: a stored user override wins, else the developer default
	 * (visible unless `DefaultHidden`).
	 * @param {'Left'|'Right'} pColumn @param {Record<string, any>} pCol
	 * @return {boolean}
	 */
	_isColumnVisible(pColumn, pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(pColumn), 'Matrix') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @param {'Left'|'Right'} pColumn @return {Array<Record<string, any>>} The currently-visible columns. */
	_visibleColumns(pColumn)
	{
		return this._side[pColumn].side.TableColumns.filter((pCol) => this._isColumnVisible(pColumn, pCol));
	}

	/** @param {'Left'|'Right'} pColumn @return {string} */
	_sideLabel(pColumn)
	{
		const tmpSide = this._side[pColumn].side;
		return tmpSide ? (tmpSide.Title || tmpSide.RecordSet || tmpSide.Entity) : '';
	}

	/**
	 * Fetch page 0 for a side (fresh search / first load), store the records, and render its table.
	 * @param {'Left'|'Right'} pColumn @return {Promise<void>}
	 */
	async _fetchSide(pColumn)
	{
		const tmpState = this._side[pColumn];
		tmpState.cursor = 0;
		const tmpResult = await this.manager.fetchSidePage(this._associationHash, tmpState.side.RecordSet, tmpState.search, 0, this.options.MatrixPageSize);
		tmpState.records = tmpResult.records;
		tmpState.hasMore = tmpResult.hasMore;
		this._renderSideTable(pColumn);
	}

	/**
	 * Fetch + append the next page for a side ("Load more").
	 * @param {'Left'|'Right'} pColumn @return {Promise<void>}
	 */
	async loadMoreSide(pColumn)
	{
		const tmpState = this._side[pColumn];
		tmpState.cursor += this.options.MatrixPageSize;
		const tmpResult = await this.manager.fetchSidePage(this._associationHash, tmpState.side.RecordSet, tmpState.search, tmpState.cursor, this.options.MatrixPageSize);
		tmpState.records = tmpState.records.concat(tmpResult.records);
		tmpState.hasMore = tmpResult.hasMore;
		this._renderSideTable(pColumn);
	}

	/**
	 * Debounced search for a side — re-fetches page 0. Only the table container repaints, so the search
	 * input keeps focus.
	 * @param {'Left'|'Right'} pColumn @param {string} pTerm
	 */
	searchSide(pColumn, pTerm)
	{
		this._side[pColumn].search = pTerm;
		if (this._searchTimers[pColumn])
		{
			clearTimeout(this._searchTimers[pColumn]);
		}
		this._searchTimers[pColumn] = setTimeout(() => { this._fetchSide(pColumn); }, 250);
	}

	/**
	 * Build the row models for a side and render its table into the panel's table container.
	 * @param {'Left'|'Right'} pColumn
	 */
	_renderSideTable(pColumn)
	{
		const tmpState = this._side[pColumn];
		const tmpColumns = this._visibleColumns(pColumn);
		const tmpIDField = tmpState.side.IDField;
		const tmpRows = tmpState.records.map((pRecord) =>
		{
			const tmpID = pRecord[tmpIDField];
			return {
				Column: pColumn,
				Value: tmpID,
				RowID: `${this.safeKey}_${pColumn}_row_${tmpID}`,
				Selected: !!tmpState.selected[String(tmpID)],
				Cells: tmpColumns.map((pCol) => ({ Value: pCol.Template ? this.pict.parseTemplate(pCol.Template, pRecord) : pRecord[pCol.Key] })),
			};
		});
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			// One-or-zero-element slot drives the empty-state line (TS parses inner tags; NE would not).
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: `No ${this._sideLabel(pColumn)} found.` } ] : [],
			MoreSlot: tmpState.hasMore ? [ { Column: pColumn } ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateMatrix-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Table`, tmpHTML);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Count`, this._selectedCount(pColumn) ? `${this._selectedCount(pColumn)} selected` : '');
	}

	/**
	 * Open/close a side's column chooser popover (the "Columns" button). Re-renders its rows on open.
	 * @param {'Left'|'Right'} pColumn
	 */
	toggleColumnChooser(pColumn)
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_${pColumn}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1)
		{
			return;
		}
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser(pColumn);
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close a side's column chooser (the backdrop's outside-click handler). @param {'Left'|'Right'} pColumn */
	closeColumnChooser(pColumn)
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_${pColumn}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render a side's column-chooser rows (every declared column, checked when effectively visible). */
	_renderColumnChooser(pColumn)
	{
		const tmpRows = this._side[pColumn].side.TableColumns.map((pCol) => (
			{
				Column: pColumn,
				Key: pCol.Key,
				DisplayName: pCol.DisplayName,
				Visible: this._isColumnVisible(pColumn, pCol),
			}));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateMatrix-Chooser', { Column: pColumn, Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Chooser`, tmpHTML);
	}

	/**
	 * Toggle one column's visibility — persisted through the ColumnDataProvider (localStorage; a host can
	 * register its own provider for server-side prefs). Refuses to hide the last visible column.
	 * @param {'Left'|'Right'} pColumn @param {string} pKey
	 */
	toggleColumn(pColumn, pKey)
	{
		if (!this.columnProvider)
		{
			return;
		}
		const tmpCol = this._side[pColumn].side.TableColumns.find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol)
		{
			return;
		}
		const tmpCurrentlyVisible = this._isColumnVisible(pColumn, tmpCol);
		if (tmpCurrentlyVisible && this._visibleColumns(pColumn).length <= 1)
		{
			return;
		}
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(pColumn), 'Matrix', pKey, !tmpCurrentlyVisible);
		this._renderSideTable(pColumn);
		this._renderColumnChooser(pColumn);
	}

	/** Clear a side's column overrides — back to the developer defaults. */
	resetColumns(pColumn)
	{
		if (this.columnProvider)
		{
			this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(pColumn), 'Matrix');
		}
		this._renderSideTable(pColumn);
		this._renderColumnChooser(pColumn);
	}

	/**
	 * Toggle a row's selection (the row click). Updates the selection set + the row's visual state + the
	 * stats, without re-rendering the whole table (so scroll + focus are preserved).
	 * @param {'Left'|'Right'} pColumn @param {string|number} pValue
	 */
	toggleRow(pColumn, pValue)
	{
		const tmpState = this._side[pColumn];
		const tmpKey = String(pValue);
		if (tmpState.selected[tmpKey])
		{
			delete tmpState.selected[tmpKey];
		}
		else
		{
			tmpState.selected[tmpKey] = true;
		}
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_${pColumn}_row_${pValue}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!tmpState.selected[tmpKey]);
		}
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Count`, this._selectedCount(pColumn) ? `${this._selectedCount(pColumn)} selected` : '');
		this.updateStats();
	}

	/** @param {'Left'|'Right'} pColumn @return {number} */
	_selectedCount(pColumn)
	{
		return Object.keys(this._side[pColumn].selected).length;
	}

	/** Recompute the live stats line + the link button's enabled state. */
	updateStats()
	{
		const tmpLeft = this._selectedCount('Left');
		const tmpRight = this._selectedCount('Right');
		const tmpPairs = tmpLeft * tmpRight;
		const tmpStatsHTML = this.pict.parseTemplateByHash('PRSP-AssociateMatrix-Stats',
			{ LeftCount: tmpLeft, RightCount: tmpRight, PairCount: tmpPairs, PairPlural: (tmpPairs === 1) ? '' : 's', LeftLabel: this._sideLabel('Left'), RightLabel: this._sideLabel('Right') });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`, tmpStatsHTML);

		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Link`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = (tmpPairs < 1);
		}
	}

	/**
	 * Create the cross-product of joins for the checked rows — every left record linked to every right
	 * record — skipping pairs that already exist (one INN lookup). Confirms first for large sets.
	 * @return {Promise<void>}
	 */
	async associateMatrix()
	{
		const tmpLeftIDs = Object.keys(this._side.Left.selected);
		const tmpRightIDs = Object.keys(this._side.Right.selected);
		if (tmpLeftIDs.length < 1 || tmpRightIDs.length < 1)
		{
			this._toast('Check records on both sides first.', 'info');
			return;
		}
		const tmpTotal = tmpLeftIDs.length * tmpRightIDs.length;
		const tmpLeftSide = this._side.Left.side;
		const tmpRightSide = this._side.Right.side;

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpTotal > 100 && tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`This will create up to ${tmpTotal} links. Continue?`,
				{ title: 'Bulk link', confirmLabel: `Link ${tmpTotal}`, cancelLabel: 'Cancel' });
			if (!tmpOk)
			{
				return;
			}
		}

		// Existing pairs (one INN lookup over the checked left ids) so we never duplicate a join.
		const tmpExisting = await this.manager.listJoinRecordsForIDs(this._associationHash, tmpLeftSide.RecordSet, tmpLeftIDs);
		const tmpExistingSet = {};
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExistingSet[`${tmpExisting[i][tmpLeftSide.IDField]}|${tmpExisting[i][tmpRightSide.IDField]}`] = true;
		}

		let tmpCreated = 0;
		let tmpSkipped = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpLeftIDs.length; i++)
		{
			for (let j = 0; j < tmpRightIDs.length; j++)
			{
				if (tmpExistingSet[`${tmpLeftIDs[i]}|${tmpRightIDs[j]}`])
				{
					tmpSkipped++;
					continue;
				}
				try
				{
					await this.manager.createJoin(this._associationHash, tmpLeftSide.RecordSet, tmpLeftIDs[i], tmpRightIDs[j]);
					tmpCreated++;
				}
				catch (pError)
				{
					tmpFailed++;
					this.pict.log.error(`AssociateMatrix: failed to link ${tmpLeftIDs[i]} <-> ${tmpRightIDs[j]}.`, pError);
				}
			}
		}

		const tmpParts = [];
		if (tmpCreated > 0) { tmpParts.push(`${tmpCreated} link${tmpCreated === 1 ? '' : 's'} created`); }
		if (tmpSkipped > 0) { tmpParts.push(`${tmpSkipped} already existed`); }
		if (tmpFailed > 0) { tmpParts.push(`${tmpFailed} failed`); }
		this._toast(tmpParts.length ? tmpParts.join(', ') + '.' : 'Nothing to link.', tmpFailed > 0 ? 'error' : 'success');

		// Clear both selections and repaint the tables so the next batch starts clean.
		this._side.Left.selected = {};
		this._side.Right.selected = {};
		this._renderSideTable('Left');
		this._renderSideTable('Right');
		this.updateStats();
	}

	/** Crude singularizer for the subtitle copy ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/**
	 * Non-blocking notification via the host modal's toast, when available.
	 * @param {string} pMessage @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociateMatrix;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociateMatrix;

},{"pict-view":693}],630:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Bulk Unlink screen — the removal counterpart to Assign/Matrix. Pick one anchor record (a specific
 * book OR a specific store), see ALL of its current associations in a selectable record table
 * (configurable columns + a column chooser + search), check the ones to drop, and "Unlink selected"
 * deletes those join rows at once. The anchor side is the route's `:AnchorRecordSet`, so the same screen
 * unlinks from either side.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-AssociateUnlink` and parameterized by route:
 *   /PSRS/AssociateUnlink/:Association/:AnchorRecordSet
 *   /PSRS/AssociateUnlink/:Association/:AnchorRecordSet/:AnchorID
 *
 * Data flows through the shared `RecordSetAssociationManager` (listAssociatedRecords + removeJoin);
 * column visibility persists through the `ColumnDataProvider` (the same host-overridable seam).
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociateUnlink = (
	{
		ViewIdentifier: 'PRSP-AssociateUnlink',

		DefaultRenderable: 'PRSP_Renderable_AssociateUnlink',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
		.prsp-unlink { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-unlink-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-unlink-card { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); display: flex; flex-direction: column; gap: 0.6rem; }
		.prsp-unlink-card-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-unlink-anchor-host { max-width: 520px; }
		.prsp-unlink-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-unlink-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-unlink-stats strong { color: var(--theme-color-status-error, #b62828); font-size: 1.05rem; }
		.prsp-unlink-btn { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-status-error, #b62828);
			background: var(--theme-color-status-error, #b62828); color: #fff; }
		.prsp-unlink-btn:hover { background: var(--theme-color-status-error-hover, #9c2020); }
		.prsp-unlink-btn[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-unlink-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; flex-wrap: wrap; }
		.prsp-unlink-search { flex: 1 1 220px; display: flex; align-items: center; gap: 0.4rem; padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }
		.prsp-unlink-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
		.prsp-unlink-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-tools { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-unlink-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-unlink-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-colchooser-wrap { position: relative; }
		.prsp-unlink-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-unlink-colchooser-wrap.is-open .prsp-unlink-colchooser-backdrop { display: block; }
		.prsp-unlink-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-unlink-colchooser-wrap.is-open .prsp-unlink-colchooser { display: block; }
		.prsp-unlink-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-unlink-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-unlink-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-unlink-colrow.is-on .prsp-unlink-colrow-check { visibility: visible; }
		.prsp-unlink-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-unlink-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-unlink-tablewrap { max-height: 56vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-utbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-utbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-utbl-th-check { width: 1.8rem; text-align: center; cursor: pointer; }
		.prsp-utbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-utbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-utbl-row.is-selected { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 9%, transparent); }
		.prsp-utbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-utbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-utbl-check { display: inline-flex; color: var(--theme-color-status-error, #b62828); visibility: hidden; }
		.prsp-utbl-row.is-selected .prsp-utbl-check { visibility: visible; }
		.prsp-utbl-headcheck { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-unlink-empty { padding: 0.9rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; font-style: italic; text-align: center; }
		.prsp-unlink-hint { color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; font-style: italic; padding: 0.5rem 0.2rem; }
		.prsp-unlink-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociateUnlink-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociateUnlink-Template] -->
		<div class="prsp-unlink">
			<div class="prsp-unlink-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-unlink-sub">{~D:Record.Subtitle~}</p>
			</div>
			<div class="prsp-unlink-card">
				<span class="prsp-unlink-card-label">{~D:Record.AnchorLabel~}</span>
				<div class="prsp-unlink-anchor-host" id="{~D:Record.AnchorPickerHostID~}"></div>
				{~NE:Record.PickerMissing^<div class="prsp-unlink-note">The entity picker (pict-section-picker) is not registered, so this screen cannot run.</div>~}
			</div>
			{~TS:PRSP-AssociateUnlink-Hint:Record.HintSlot~}
			{~TS:PRSP-AssociateUnlink-Body:Record.BodySlot~}
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociateUnlink-Template] -->
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Hint',
				Template: /*html*/`<div class="prsp-unlink-hint">{~D:Record.Hint~}</div>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Body',
				Template: /*html*/`
		<div class="prsp-unlink-bar">
			<div class="prsp-unlink-stats" id="{~D:Record.StatsID~}"></div>
			<button type="button" class="prsp-unlink-btn" id="{~D:Record.UnlinkButtonID~}" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].unlinkSelected()">{~I:Trash~} Unlink selected</button>
		</div>
		<div class="prsp-unlink-card">
			<div class="prsp-unlink-toolbar">
				<div class="prsp-unlink-search">
					<span class="prsp-unlink-search-ic">{~I:Search~}</span>
					<input type="text" placeholder="Filter {~D:Record.OtherLabel~}…" autocomplete="off" oninput="_Pict.views['RSP-RecordSet-AssociateUnlink'].searchItems(this.value)">
				</div>
				<div class="prsp-unlink-tools">
					<div class="prsp-unlink-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-unlink-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleColumnChooser()">{~I:Settings~} Columns</button>
						<div class="prsp-unlink-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].closeColumnChooser()"></div>
						<div class="prsp-unlink-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<div class="prsp-unlink-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Table',
				Template: /*html*/`
		<table class="prsp-utbl">
			<thead><tr><th class="prsp-utbl-th-check" title="Select all" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleSelectAll()"><span class="prsp-utbl-headcheck">{~D:Record.SelectAllIcon~}</span></th>{~TS:PRSP-AssociateUnlink-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-AssociateUnlink-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-AssociateUnlink-Empty:Record.EmptySlot~}
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-utbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleRow('{~D:Record.JoinID~}')"><td class="prsp-utbl-td-check"><span class="prsp-utbl-check">{~I:Check~}</span></td>{~TS:PRSP-AssociateUnlink-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Empty',
				Template: /*html*/`<div class="prsp-unlink-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Chooser',
				Template: /*html*/`
		<div class="prsp-unlink-colchooser-list">{~TS:PRSP-AssociateUnlink-ColRow:Record.Rows~}</div>
		<div class="prsp-unlink-colchooser-foot"><button type="button" class="prsp-unlink-colreset" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].resetColumns()">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-ColRow',
				Template: /*html*/`<button type="button" class="prsp-unlink-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleColumn('{~D:Record.Key~}')"><span class="prsp-unlink-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociateUnlink',
				TemplateHash: 'PRSP-AssociateUnlink-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociateUnlink extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociateUnlink, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._associationHash = null;
		this._anchorSide = null;
		this._otherSide = null;
		this._anchorID = null;
		this._items = [];           // current associations: { JoinID, OtherID, Display, OtherRecord, JoinRecord, Chips }
		this._selected = {};        // selected JoinIDs to remove
		this._search = '';
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/** A DOM/address-safe key for this screen. */
	get safeKey()
	{
		return `${String(this._associationHash)}_${String(this._anchorSide && this._anchorSide.RecordSet)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/AssociateUnlink/:Association/:AnchorRecordSet/:AnchorID', this.handleUnlinkRoute.bind(this));
		pPictRouter.router.on('/PSRS/AssociateUnlink/:Association/:AnchorRecordSet', this.handleUnlinkRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — resolve the association + anchor side, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleUnlinkRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet AssociateUnlink route handler called with invalid route payload.`);
		}
		this._associationHash = pRoutePayload.data.Association;
		this._items = [];
		this._selected = {};
		this._search = '';
		const tmpAssociation = this.manager ? this.manager.getAssociation(this._associationHash) : null;
		if (!tmpAssociation)
		{
			this.pict.log.warn(`AssociateUnlink: association [${this._associationHash}] is not registered.`);
			this._anchorSide = null;
			this._otherSide = null;
			return this.renderUnlink();
		}
		const tmpAnchorRecordSet = pRoutePayload.data.AnchorRecordSet || tmpAssociation.SideA.RecordSet;
		const tmpSides = this.manager.resolveSides(this._associationHash, tmpAnchorRecordSet);
		this._anchorSide = tmpSides ? tmpSides.thisSide : tmpAssociation.SideA;
		this._otherSide = tmpSides ? tmpSides.otherSide : tmpAssociation.SideB;
		this._anchorID = (pRoutePayload.data.AnchorID !== undefined && pRoutePayload.data.AnchorID !== '') ? pRoutePayload.data.AnchorID : null;
		return this.renderUnlink();
	}

	/** @return {string} */
	_anchorLabel() { return this._anchorSide ? (this._anchorSide.Title || this._anchorSide.RecordSet || this._anchorSide.Entity) : ''; }
	/** @return {string} */
	_otherLabel() { return this._otherSide ? (this._otherSide.Title || this._otherSide.RecordSet || this._otherSide.Entity) : ''; }

	/** Persistence scope for this anchor side's column visibility (distinct from list/matrix scopes). */
	_columnScope() { return `Unlink_${this._associationHash}_${this._anchorSide && this._anchorSide.RecordSet}`; }

	/**
	 * Paint the screen shell and mount the anchor picker; load + render the table when an anchor is set.
	 * @return {Promise<boolean>}
	 */
	async renderUnlink()
	{
		if (!this._anchorSide || !this._otherSide)
		{
			this.pict.log.warn(`AssociateUnlink: could not resolve sides for [${this._associationHash}].`);
			return false;
		}
		const tmpHasAnchor = (this._anchorID !== undefined && this._anchorID !== null && this._anchorID !== '');
		if (tmpHasAnchor)
		{
			this._items = await this.manager.listAssociatedRecords(this._associationHash, this._anchorSide.RecordSet, this._anchorID);
		}

		const tmpBodyData = {
			OtherLabel: this._otherLabel(),
			StatsID: `${this.safeKey}_Stats`,
			UnlinkButtonID: `${this.safeKey}_Unlink`,
			ChooserID: `${this.safeKey}_Chooser`,
			TableID: `${this.safeKey}_Table`,
		};
		const tmpRecord = {
			Title: this.options.ScreenTitle || `Unlink ${this._otherLabel()} from a ${this._singular(this._anchorLabel())}`,
			Subtitle: `Pick a ${this._singular(this._anchorLabel())}, then check the ${this._otherLabel()} to unlink and remove them together.`,
			AnchorLabel: this._anchorLabel(),
			AnchorPickerHostID: `${this.safeKey}_Anchor`,
			PickerMissing: !this.pict.providers['Pict-Section-Picker'],
			HintSlot: tmpHasAnchor ? [] : [ { Hint: `Select a ${this._singular(this._anchorLabel())} above to see its current links.` } ],
			BodySlot: tmpHasAnchor ? [ tmpBodyData ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociateUnlink: render error.`, pError);
						return resolve(false);
					}
					this._mountAnchorPicker(tmpRecord.AnchorPickerHostID);
					if (tmpHasAnchor)
					{
						this._renderTable();
						this.updateStats();
					}
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/** Mount the anchor (this side) picker — single select, preselected to the current anchor. */
	_mountAnchorPicker(pHostID)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpPickerHash = `${this.safeKey}_AnchorPicker`;
		const tmpValueAddress = `AppData.PRSPUnlinkAnchor.${this.safeKey}`;
		if (!this.pict.AppData.PRSPUnlinkAnchor) { this.pict.AppData.PRSPUnlinkAnchor = {}; }
		this.pict.AppData.PRSPUnlinkAnchor[this.safeKey] = (this._anchorID !== undefined && this._anchorID !== null) ? this._anchorID : null;

		const tmpConfig = this.manager.buildAnchorPickerConfig(this._associationHash, this._anchorSide.RecordSet,
			{
				DestinationAddress: `#${pHostID}`,
				ValueAddress: tmpValueAddress,
				Placeholder: `Search ${this._anchorLabel()}…`,
				OnChange: (pValue) => { this.selectAnchor(pValue); },
			});
		if (!tmpConfig)
		{
			return;
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		this.pict.views[tmpPickerHash].setValue((this._anchorID !== undefined && this._anchorID !== null) ? this._anchorID : null);
	}

	/**
	 * The anchor picker's OnChange — load that anchor's links and repaint.
	 * @param {string|number} pAnchorID @return {Promise<void>}
	 */
	async selectAnchor(pAnchorID)
	{
		this._anchorID = (pAnchorID !== undefined && pAnchorID !== '') ? pAnchorID : null;
		this._selected = {};
		this._search = '';
		await this.renderUnlink();
	}

	/** Effective visibility for a column (stored override wins, else `!DefaultHidden`). */
	_isColumnVisible(pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(), 'Unlink') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @return {Array<Record<string, any>>} The currently-visible other-side columns. */
	_visibleColumns()
	{
		return this._otherSide.TableColumns.filter((pCol) => this._isColumnVisible(pCol));
	}

	/** @return {Array<Record<string, any>>} The items matching the current search filter (client-side). */
	_filteredItems()
	{
		const tmpTerm = (this._search || '').trim().toLowerCase();
		if (!tmpTerm)
		{
			return this._items;
		}
		const tmpColumns = this._visibleColumns();
		return this._items.filter((pItem) =>
		{
			if (String(pItem.Display).toLowerCase().includes(tmpTerm)) { return true; }
			return tmpColumns.some((pCol) =>
			{
				const tmpValue = pCol.Template ? this.pict.parseTemplate(pCol.Template, pItem.OtherRecord) : pItem.OtherRecord[pCol.Key];
				return (tmpValue !== undefined && tmpValue !== null) && String(tmpValue).toLowerCase().includes(tmpTerm);
			});
		});
	}

	/** Build the row models for the (filtered) current associations and render the table. */
	_renderTable()
	{
		const tmpColumns = this._visibleColumns();
		const tmpItems = this._filteredItems();
		const tmpRows = tmpItems.map((pItem) => (
			{
				JoinID: pItem.JoinID,
				RowID: `${this.safeKey}_row_${pItem.JoinID}`,
				Selected: !!this._selected[String(pItem.JoinID)],
				Cells: tmpColumns.map((pCol) => ({ Value: pCol.Template ? this.pict.parseTemplate(pCol.Template, pItem.OtherRecord) : pItem.OtherRecord[pCol.Key] })),
			}));
		const tmpAllSelected = (tmpRows.length > 0 && tmpRows.every((pRow) => pRow.Selected));
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			SelectAllIcon: this.pict.icon(tmpAllSelected ? 'Check' : 'Minus'),
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: this._search ? `No ${this._otherLabel()} match the filter.` : `This ${this._singular(this._anchorLabel())} has no ${this._otherLabel()} linked.` } ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateUnlink-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Table`, tmpHTML);
	}

	/** Debounced client-side filter of the loaded links. @param {string} pTerm */
	searchItems(pTerm)
	{
		this._search = pTerm;
		this._renderTable();
		this.updateStats();
	}

	/**
	 * Toggle a link's selection (the row click). Updates the set + row state + stats.
	 * @param {string|number} pJoinID
	 */
	toggleRow(pJoinID)
	{
		const tmpKey = String(pJoinID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; }
		else { this._selected[tmpKey] = true; }
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_row_${pJoinID}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!this._selected[tmpKey]);
		}
		this.updateStats();
	}

	/** Select-all / clear-all the currently-filtered rows (the header checkbox). */
	toggleSelectAll()
	{
		const tmpFiltered = this._filteredItems();
		const tmpAllSelected = (tmpFiltered.length > 0 && tmpFiltered.every((pItem) => this._selected[String(pItem.JoinID)]));
		this._selected = {};
		if (!tmpAllSelected)
		{
			for (let i = 0; i < tmpFiltered.length; i++) { this._selected[String(tmpFiltered[i].JoinID)] = true; }
		}
		this._renderTable();
		this.updateStats();
	}

	/** @return {number} */
	_selectedCount() { return Object.keys(this._selected).length; }

	/** Recompute the stats line + the unlink button's enabled state. */
	updateStats()
	{
		const tmpSelected = this._selectedCount();
		const tmpTotal = this._items.length;
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`,
			`<strong>${tmpSelected}</strong> of ${tmpTotal} ${this._otherLabel()} selected to unlink`);
		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Unlink`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = (tmpSelected < 1);
		}
	}

	/**
	 * Remove every selected link (confirm via the host modal), then reload the anchor's links + repaint.
	 * @return {Promise<void>}
	 */
	async unlinkSelected()
	{
		const tmpSelectedJoinIDs = Object.keys(this._selected);
		if (tmpSelectedJoinIDs.length < 1)
		{
			return;
		}
		const tmpItemsByJoin = {};
		for (let i = 0; i < this._items.length; i++) { tmpItemsByJoin[String(this._items[i].JoinID)] = this._items[i]; }

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`Unlink ${tmpSelectedJoinIDs.length} ${this._otherLabel()} from this ${this._singular(this._anchorLabel())}?`,
				{ title: 'Unlink', confirmLabel: `Unlink ${tmpSelectedJoinIDs.length}`, cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}

		let tmpRemoved = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpSelectedJoinIDs.length; i++)
		{
			const tmpItem = tmpItemsByJoin[tmpSelectedJoinIDs[i]];
			if (!tmpItem) { continue; }
			try
			{
				await this.manager.removeJoin(this._associationHash, tmpItem.JoinRecord);
				tmpRemoved++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`AssociateUnlink: failed to remove join ${tmpItem.JoinID}.`, pError);
			}
		}
		this._toast(`${tmpRemoved} unlinked${tmpFailed > 0 ? `, ${tmpFailed} failed` : ''}.`, tmpFailed > 0 ? 'error' : 'success');

		this._selected = {};
		await this.renderUnlink();
	}

	// --- Column chooser (mirrors the matrix's, scoped per anchor side) ---

	/** Open/close the column chooser. */
	toggleColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1) { return; }
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser();
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close the column chooser (backdrop outside-click). */
	closeColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render the chooser rows. */
	_renderColumnChooser()
	{
		const tmpRows = this._otherSide.TableColumns.map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName, Visible: this._isColumnVisible(pCol) }));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateUnlink-Chooser', { Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Chooser`, tmpHTML);
	}

	/** Toggle one column's visibility (persisted; refuses to hide the last visible column). @param {string} pKey */
	toggleColumn(pKey)
	{
		if (!this.columnProvider) { return; }
		const tmpCol = this._otherSide.TableColumns.find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol) { return; }
		const tmpVisible = this._isColumnVisible(tmpCol);
		if (tmpVisible && this._visibleColumns().length <= 1) { return; }
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(), 'Unlink', pKey, !tmpVisible);
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Clear column overrides — back to developer defaults. */
	resetColumns()
	{
		if (this.columnProvider) { this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(), 'Unlink'); }
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Crude singularizer ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/** Non-blocking notification via the host modal's toast, when available. */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociateUnlink;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociateUnlink;

},{"pict-view":693}],631:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Association Editor — a small, embeddable widget that manages one many-to-many association from
 * the perspective of a single anchor record (e.g. the Authors of THIS book). It renders:
 *   - a searchable entity picker of the OTHER side, with the currently-associated rows culled out, and
 *   - a list of the current associations, each with a remove button.
 *
 * It is instantiated once per (anchor recordset, association) by the read view's Association tab, with
 * a unique Hash. All join + display data flows through the shared `RecordSetAssociationManager`; the
 * picker comes from `pict-section-picker` (a soft dependency — the host registers it as
 * `Pict-Section-Picker`). Instance-specific state is passed via the render Record (not a per-instance
 * AppData address), so the shared templates stay address-stable across instances.
 *
 * Configuration (set by the read view when it creates the instance):
 *   - AssociationHash {string}  - the association to manage.
 *   - ThisRecordSet {string}    - the anchor recordset name (resolves which side is "this side").
 *   - ThisID {string|number}    - the anchor record's id (re-set before each render).
 *   - DefaultDestinationAddress - the tab body to render into.
 *   - PickerMode {'single'|'multi'} - the add control: 'single' (default) stages one pick that an
 *       explicit Add button (or Enter) commits; 'multi' stages chips that one Add commits together.
 *       Driven from the RecordSetReadTabs Association entry's PickerMode.
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociationEditor = (
	{
		ViewIdentifier: 'PRSP-AssociationEditor',

		DefaultRenderable: 'PRSP_Renderable_AssociationEditor',
		DefaultDestinationAddress: '#PRSP_AssociationEditor_Container',
		DefaultTemplateRecordAddress: false,

		// Show the "Add defaults" affordance when the association has a defaults synthesizer. Set false
		// on an instance where synthesis is directionally meaningless (e.g. anchored on the type side of
		// a "seed a project with default types" synthesizer) — the synthesizer stays registered for the
		// side it applies to; this just hides the button on the side it does not.
		AllowSynthesize: true,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
		.prsp-assoc { display: flex; flex-direction: column; gap: 0.85rem; padding: 0.25rem 0 0.5rem; }
		.prsp-assoc-add { display: flex; flex-direction: column; gap: 0.35rem; }
		.prsp-assoc-add-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-assoc-add-row { display: flex; align-items: flex-start; gap: 0.5rem; }
		.prsp-assoc-picker-host { flex: 1 1 auto; min-width: 0; max-width: 460px; }
		.prsp-assoc-add-btn { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.9rem; font-weight: 600;
			padding: 0.45rem 0.85rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
			background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.prsp-assoc-add-btn:hover { background: var(--theme-color-brand-primary-hover, #1259ad); }
		.prsp-assoc-list { display: flex; flex-direction: column; gap: 0.3rem; }
		.prsp-assoc-list-head { display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; }
		.prsp-assoc-list-title { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-assoc-count { font-size: 0.78rem; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-assoc-row { display: flex; align-items: center; gap: 0.6rem; padding: 0.45rem 0.6rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px;
			background: var(--theme-color-background-primary, #fff); }
		.prsp-assoc-row:hover { border-color: var(--theme-color-border-default, #d7dce3); }
		.prsp-assoc-row-name { flex: 0 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1f2733); font-size: 0.92rem; }
		.prsp-assoc-row-chips { flex: 1 1 auto; display: flex; flex-wrap: wrap; gap: 0.3rem; min-width: 0; }
		.prsp-assoc-chip { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 600; line-height: 1.25;
			padding: 0.05rem 0.4rem; border-radius: 5px; white-space: nowrap;
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
		.prsp-assoc-status { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.68rem; font-weight: 700; line-height: 1.2; text-transform: uppercase; letter-spacing: 0.03em;
			padding: 0.08rem 0.42rem; border-radius: 999px; white-space: nowrap; }
		.prsp-assoc-status.is-expired { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 14%, transparent); color: var(--theme-color-status-error, #b62828); }
		.prsp-assoc-status.is-pending { background: color-mix(in srgb, var(--theme-color-status-warning, #b7791f) 16%, transparent); color: var(--theme-color-status-warning, #97650f); }
		.prsp-assoc-row-id { flex: 0 0 auto; font-size: 0.74rem; color: var(--theme-color-text-muted, #6b7686); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.prsp-assoc-remove { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.2rem; border-radius: 5px; font: inherit; }
		.prsp-assoc-remove:hover { color: var(--theme-color-status-error, #b62828); background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 10%, transparent); }
		.prsp-assoc-empty { padding: 0.7rem 0.2rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.88rem; font-style: italic; }
		.prsp-assoc-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		.prsp-assoc-head-right { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-assoc-synth-btn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.76rem; font-weight: 600;
			padding: 0.2rem 0.55rem; border-radius: 6px; border: 1px solid var(--theme-color-border-default, #d7dce3);
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
		.prsp-assoc-synth-btn:hover { background: var(--theme-color-background-secondary, #e2e6ec); }
		.prsp-assoc-row-cfg { flex: 0 0 auto; display: flex; align-items: center; gap: 0.65rem; }
		.prsp-assoc-cfg { display: inline-flex; align-items: center; gap: 0.25rem; font-size: 0.78rem; color: var(--theme-color-text-secondary, #45596b); white-space: nowrap; cursor: default; }
		.prsp-assoc-cfg input[type="checkbox"] { cursor: pointer; }
		.prsp-assoc-cfg-num { width: 3.4rem; font: inherit; font-size: 0.8rem; padding: 0.1rem 0.3rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 5px; }
		.prsp-assoc-cfg-sel { font: inherit; font-size: 0.8rem; padding: 0.05rem 0.2rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 5px; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociationEditor-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociationEditor-Template] -->
		<div class="prsp-assoc">
			<div class="prsp-assoc-add">
				<span class="prsp-assoc-add-label">{~D:Record.AddLabel~}</span>
				<div class="prsp-assoc-add-row">
					<div class="prsp-assoc-picker-host" id="{~D:Record.PickerHostID~}"></div>
					<button type="button" class="prsp-assoc-add-btn" id="{~D:Record.AddButtonID~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].addStaged()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.views['{~D:Record.ViewHash~}'].addStaged(); }">{~I:Plus~} {~D:Record.AddButtonLabel~}</button>
				</div>
				{~NE:Record.PickerMissing^<div class="prsp-assoc-note">The entity picker (pict-section-picker) is not registered, so associations cannot be added here.</div>~}
			</div>
			<div class="prsp-assoc-list">
				<div class="prsp-assoc-list-head">
					<span class="prsp-assoc-list-title">{~D:Record.ListLabel~}</span>
					<span class="prsp-assoc-head-right">
						<span class="prsp-assoc-count">{~D:Record.Count~}</span>
						{~TS:PRSP-AssociationEditor-SynthBtn:Record.SynthesizeSlot~}
					</span>
				</div>
				{~TS:PRSP-AssociationEditor-Row:Record.Items~}
				{~TS:PRSP-AssociationEditor-Empty:Record.EmptySlot~}
			</div>
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociationEditor-Template] -->
	`
			},
			{
				Hash: 'PRSP-AssociationEditor-Empty',
				Template: /*html*/`<div class="prsp-assoc-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociationEditor-Row',
				Template: /*html*/`
		<div class="prsp-assoc-row">
			<span class="prsp-assoc-row-name">{~RecordCard:Record.CardRecordSet^Record.OtherID^Record.Display~}</span>
			{~TS:PRSP-AssociationEditor-Status:Record.StatusBadgeSlot~}
			<span class="prsp-assoc-row-chips">{~TS:PRSP-AssociationEditor-Chip:Record.Chips~}</span>
			<span class="prsp-assoc-row-cfg">{~TS:PRSP-AssociationEditor-EditField:Record.EditFields~}</span>
			<span class="prsp-assoc-row-id">#{~D:Record.OtherID~}</span>
			<button type="button" class="prsp-assoc-remove" title="Remove association" onclick="_Pict.views['{~D:Record.ViewHash~}'].removeItem({~D:Record.JoinID~})">{~I:Trash~}</button>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociationEditor-Chip',
				Template: /*html*/`<span class="prsp-assoc-chip">{~D:Record.Text~}</span>`
			},
			{
				// A read-only status pill derived from the join record's lifecycle dates (Expired /
				// Not yet effective). Present only when a date column signals it — see _computeStatusBadge.
				Hash: 'PRSP-AssociationEditor-Status',
				Template: /*html*/`<span class="prsp-assoc-status {~D:Record.Class~}" title="{~D:Record.Title~}">{~D:Record.Text~}</span>`
			},
			{
				Hash: 'PRSP-AssociationEditor-SynthBtn',
				Template: /*html*/`<button type="button" class="prsp-assoc-synth-btn" title="Pull the inherited default associations in so you can customize them" onclick="_Pict.views['{~D:Record.ViewHash~}'].synthesizeDefaults()">{~I:Download~} Customize Defaults</button>`
			},
			{
				// One editable per-join config control (a "rich" join's settings, e.g. Journal / Spreadsheet
				// / Ordinal). The kind flags pick the input; onchange writes through to the join row.
				Hash: 'PRSP-AssociationEditor-EditField',
				Template: /*html*/`{~TIfAbs:PRSP-AssociationEditor-EditCheckbox:Record:Record.IsCheckbox^TRUE^~}{~TIfAbs:PRSP-AssociationEditor-EditNumber:Record:Record.IsNumber^TRUE^~}{~TIfAbs:PRSP-AssociationEditor-EditSelect:Record:Record.IsSelect^TRUE^~}{~TIfAbs:PRSP-AssociationEditor-EditText:Record:Record.IsText^TRUE^~}`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditCheckbox',
				Template: /*html*/`<label class="prsp-assoc-cfg"><input type="checkbox" {~D:Record.CheckedAttr~} onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.checked)" />{~D:Record.Label~}</label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditNumber',
				Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<input type="number" class="prsp-assoc-cfg-num" value="{~D:Record.Value~}" onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.value)" /></label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditSelect',
				Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<select class="prsp-assoc-cfg-sel" onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.value)">{~TS:PRSP-AssociationEditor-EditOption:Record.Options~}</select></label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditText',
				Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<input type="text" class="prsp-assoc-cfg-sel" value="{~D:Record.Value~}" onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.value)" /></label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditOption',
				Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociationEditor',
				TemplateHash: 'PRSP-AssociationEditor-Template',
				ContentDestinationAddress: '#PRSP_AssociationEditor_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociationEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociationEditor, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;

		// The other-side ids currently associated (the live cull set the picker reads via a closure).
		this._otherIDs = [];
		// The current list items (so removeItem/updateField can find the exact join record by JoinID).
		this._lastItems = [];
		// Guard so AutoSynthesizeWhenEmpty runs at most once per anchor (no re-synthesize loop).
		this._autoSynthesizedFor = null;
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** @return {string} A DOM/address-safe key derived from this instance's Hash. */
	get safeKey()
	{
		return String(this.Hash).replace(/[^A-Za-z0-9]/g, '_');
	}

	/**
	 * Load the current associations and (re)paint the whole widget, then mount the picker. This is the
	 * editor's entry point — the read view's Association tab calls it (not the framework `render()`),
	 * so the async data load happens before the template renders (the read-view pattern).
	 *
	 * @return {Promise<boolean>}
	 */
	async renderEditor()
	{
		const tmpSides = this.manager ? this.manager.resolveSides(this.options.AssociationHash, this.options.ThisRecordSet) : false;
		if (!tmpSides)
		{
			this.pict.log.warn(`AssociationEditor [${this.Hash}]: association [${this.options.AssociationHash}] could not be resolved for [${this.options.ThisRecordSet}].`);
			return false;
		}

		const tmpThisID = this.options.ThisID;
		let tmpItems = [];
		if (tmpThisID !== undefined && tmpThisID !== null && tmpThisID !== '')
		{
			tmpItems = await this.manager.listAssociatedRecords(this.options.AssociationHash, this.options.ThisRecordSet, tmpThisID);

			// Opt-in: synthesize the default associations the first time an empty anchor is opened.
			const tmpAssociation = this.manager.getAssociation(this.options.AssociationHash);
			if (tmpAssociation && tmpAssociation.AutoSynthesizeWhenEmpty && (tmpItems.length === 0)
				&& this.manager.hasDefaultSynthesizer(this.options.AssociationHash) && (this._autoSynthesizedFor !== `${tmpThisID}`))
			{
				this._autoSynthesizedFor = `${tmpThisID}`;
				const tmpSynth = await this.manager.synthesizeDefaults(this.options.AssociationHash, this.options.ThisRecordSet, tmpThisID);
				if (tmpSynth && (tmpSynth.created > 0))
				{
					tmpItems = await this.manager.listAssociatedRecords(this.options.AssociationHash, this.options.ThisRecordSet, tmpThisID);
				}
			}
		}

		// Per-join editable config controls (for "rich" joins) — empty array for a plain link.
		const tmpEditableFields = this.manager.getJoinEditableFields(this.options.AssociationHash);
		// Auto record-preview-card: when a card is registered for the other side, each row's name becomes a
		// preview-card trigger (the {~RecordCard:~} tag degrades to the plain name when CardRecordSet is '').
		const tmpCardManager = this.pict.providers.RecordSetCardManager;
		const tmpCardRecordSet = (tmpCardManager && tmpCardManager.hasCard(tmpSides.otherSide.RecordSet)) ? tmpSides.otherSide.RecordSet : '';
		// Stamp the view hash + the editable controls on each row.
		for (let i = 0; i < tmpItems.length; i++)
		{
			tmpItems[i].ViewHash = this.Hash;
			tmpItems[i].EditFields = this._buildEditFields(tmpEditableFields, tmpItems[i]);
			tmpItems[i].CardRecordSet = tmpCardRecordSet;
			tmpItems[i].StatusBadgeSlot = this._computeStatusBadge(tmpItems[i].JoinRecord);
		}
		this._lastItems = tmpItems;
		this._otherIDs = tmpItems.map((pItem) => pItem.OtherID);

		const tmpOtherLabel = tmpSides.otherSide.Title || tmpSides.otherSide.RecordSet || tmpSides.otherSide.Entity;
		const tmpPickerPresent = !!this.pict.providers['Pict-Section-Picker'];
		const tmpRecord =
		{
			ViewHash: this.Hash,
			PickerHostID: `${this.safeKey}_Picker`,
			AddButtonID: `${this.safeKey}_AddBtn`,
			AddButtonLabel: (this.options.PickerMode === 'multi') ? 'Add selected' : 'Add',
			AddLabel: `Add ${tmpOtherLabel}`,
			ListLabel: `Current ${tmpOtherLabel}`,
			Count: `${tmpItems.length} ${tmpItems.length === 1 ? 'record' : 'records'}`,
			Items: tmpItems,
			// One-or-zero-element slot drives the empty-state line (TS parses inner tags; NE would not).
			EmptySlot: (tmpItems.length === 0) ? [ { EmptyText: `No ${tmpOtherLabel} associated yet — use the search above to add some.` } ] : [],
			PickerMissing: !tmpPickerPresent,
			// The "Add defaults" button shows only when the host registered a defaults synthesizer AND this
			// instance opts in (AllowSynthesize, default true) — an embedding anchored on the side the
			// synthesizer does not apply to sets AllowSynthesize:false to hide it.
			SynthesizeSlot: ((this.options.AllowSynthesize !== false) && this.manager.hasDefaultSynthesizer(this.options.AssociationHash)) ? [ { ViewHash: this.Hash } ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociationEditor [${this.Hash}]: render error.`, pError);
						return resolve(false);
					}
					this._mountPicker(tmpSides, tmpRecord.PickerHostID);
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/**
	 * Create (or reconfigure) the other-side entity picker into its host element and render it. The
	 * picker's BaseFilter culls the currently-associated ids via a closure over `this._otherIDs`, so it
	 * re-evaluates on every search as associations change.
	 *
	 * @param {Record<string, any>} pSides - resolved sides from the manager.
	 * @param {string} pPickerHostID - the picker host element id.
	 */
	_mountPicker(pSides, pPickerHostID)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpPickerHash = `${this.safeKey}_PickerView`;
		const tmpValueAddress = `AppData.PRSPAssocPicker.${this.safeKey}`;
		const tmpMulti = (this.options.PickerMode === 'multi');
		// Reset the scratch value so the picker mounts empty (and re-culls) after each add.
		if (!this.pict.AppData.PRSPAssocPicker) { this.pict.AppData.PRSPAssocPicker = {}; }
		this.pict.AppData.PRSPAssocPicker[this.safeKey] = tmpMulti ? [] : null;

		const tmpConfig = this.manager.buildOtherPickerConfig(this.options.AssociationHash, this.options.ThisRecordSet, () => this._otherIDs,
			{
				Mode: tmpMulti ? 'multi' : 'single',
				DestinationAddress: `#${pPickerHostID}`,
				ValueAddress: tmpValueAddress,
				Placeholder: `Search ${pSides.otherSide.Title || pSides.otherSide.RecordSet || pSides.otherSide.Entity}…`,
				// No add-on-select: a single-select pick just stages the value and moves focus to the Add
				// button (so Enter commits). Multi mode stages chips; the Add button commits them.
				OnChange: tmpMulti ? undefined : (() => this._focusAddButton()),
			},
			// Anchor context for a function-form PriorityValues resolver on the other side — lets a pin be
			// derived from the record we're associating to (e.g. a line item's project prime contractor).
			{ ThisID: this.options.ThisID, ThisRecordSet: this.options.ThisRecordSet });
		if (!tmpConfig)
		{
			return;
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		this.pict.views[tmpPickerHash].render();
	}

	/** Move focus to the Add button so a single-select pick can be committed by pressing Enter. */
	_focusAddButton()
	{
		const tmpButton = document.getElementById(`${this.safeKey}_AddBtn`);
		if (tmpButton)
		{
			tmpButton.focus();
		}
	}

	/**
	 * Commit the staged selection(s) — the Add button (and Enter). Reads the picker's value: a single
	 * scalar, or (multi mode) an array of ids. Creates a join for each, then reloads + repaints so the
	 * new rows appear and are culled from the picker.
	 *
	 * @return {Promise<void>}
	 */
	async addStaged()
	{
		const tmpStaged = this.pict.AppData.PRSPAssocPicker ? this.pict.AppData.PRSPAssocPicker[this.safeKey] : null;
		const tmpIDs = (this.options.PickerMode === 'multi')
			? (Array.isArray(tmpStaged) ? tmpStaged.slice() : [])
			: ((tmpStaged === undefined || tmpStaged === null || tmpStaged === '') ? [] : [ tmpStaged ]);
		if (tmpIDs.length < 1)
		{
			return;
		}
		// Seed-on-first-customize: while this anchor is inheriting the default set (no associations of its own)
		// and the association has a defaults synthesizer, materialize those defaults FIRST — otherwise adding the
		// first item breaks inheritance and the rest of the inherited set silently disappears. Any staged id the
		// synthesizer already created is then skipped so it is not duplicated. Best-effort (never blocks the add).
		let tmpPresent = null;
		if (((this._otherIDs || []).length === 0) && this.manager.hasDefaultSynthesizer(this.options.AssociationHash))
		{
			try
			{
				const tmpSynth = await this.manager.synthesizeDefaults(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID);
				if (tmpSynth && (tmpSynth.created > 0))
				{
					const tmpSeeded = await this.manager.listAssociatedRecords(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID);
					tmpPresent = new Set((tmpSeeded || []).map((pItem) => `${pItem.OtherID}`));
				}
			}
			catch (pError)
			{
				this.pict.log.warn(`AssociationEditor [${this.Hash}]: seed-on-add synthesize failed.`, pError);
			}
		}
		let tmpFailures = 0;
		for (let i = 0; i < tmpIDs.length; i++)
		{
			if (tmpPresent && tmpPresent.has(`${tmpIDs[i]}`)) { continue; }
			try
			{
				await this.manager.createJoin(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID, tmpIDs[i]);
			}
			catch (pError)
			{
				tmpFailures++;
				this.pict.log.error(`AssociationEditor [${this.Hash}]: failed to create association for ${tmpIDs[i]}.`, pError);
			}
		}
		if (tmpFailures > 0)
		{
			this._toast(`${tmpFailures} association(s) could not be added.`, 'error');
		}
		await this.renderEditor();
	}

	/**
	 * Remove one association (a list row's remove handler). Confirms via the host modal, deletes the
	 * join, then reloads + repaints.
	 *
	 * @param {string|number} pJoinID - the join record id to delete.
	 * @return {Promise<void>}
	 */
	async removeItem(pJoinID)
	{
		const tmpItem = this._lastItems.find((pItem) => String(pItem.JoinID) === String(pJoinID));
		if (!tmpItem)
		{
			return;
		}
		const fRemove = async () =>
		{
			try
			{
				await this.manager.removeJoin(this.options.AssociationHash, tmpItem.JoinRecord);
			}
			catch (pError)
			{
				this.pict.log.error(`AssociationEditor [${this.Hash}]: failed to remove association.`, pError);
				this._toast('Could not remove the association.', 'error');
				return;
			}
			await this.renderEditor();
		};

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`Remove the association with "${tmpItem.Display}"?`,
				{ title: 'Remove association', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}
		return fRemove();
	}

	/**
	 * Derive a read-only lifecycle badge from a join record's conventional date columns, so an expired
	 * (or not-yet-effective) association is obvious at a glance — e.g. an expired material↔producer link
	 * where the row would otherwise look identical to an active one. Zero-config: it keys off the
	 * `ExpirationDate` / `EffectiveDate` columns when present. Returns a one-or-zero-element slot.
	 * @param {Record<string, any>} pJoinRecord
	 * @return {Array<Record<string, any>>}
	 */
	_computeStatusBadge(pJoinRecord)
	{
		const tmpJoin = pJoinRecord || {};
		const fParseDate = (pValue) =>
		{
			if (!pValue) { return null; }
			const tmpString = String(pValue);
			if (tmpString.indexOf('0000-00-00') === 0) { return null; }
			const tmpDate = new Date(tmpString);
			return Number.isNaN(tmpDate.getTime()) ? null : tmpDate;
		};
		const tmpNow = new Date();
		const tmpExpiration = fParseDate(tmpJoin.ExpirationDate);
		if (tmpExpiration && (tmpExpiration.getTime() < tmpNow.getTime()))
		{
			return [ { Text: 'Expired', Class: 'is-expired', Title: `Expired ${ tmpExpiration.toLocaleDateString('en-US') }` } ];
		}
		const tmpEffective = fParseDate(tmpJoin.EffectiveDate);
		if (tmpEffective && (tmpEffective.getTime() > tmpNow.getTime()))
		{
			return [ { Text: 'Not yet effective', Class: 'is-pending', Title: `Effective ${ tmpEffective.toLocaleDateString('en-US') }` } ];
		}
		return [];
	}

	/**
	 * Shape an association's editable join-config fields into per-row render data (current value + the
	 * kind flags the row template dispatches on).
	 * @param {Array<Record<string, any>>} pFields - the association's JoinEditableFields.
	 * @param {Record<string, any>} pItem - one decorated association row (carries its JoinRecord).
	 * @return {Array<Record<string, any>>}
	 */
	_buildEditFields(pFields, pItem)
	{
		if (!Array.isArray(pFields) || pFields.length < 1)
		{
			return [];
		}
		const tmpJoin = pItem.JoinRecord || {};
		return pFields.map((pField) =>
		{
			const tmpType = pField.Type || 'text';
			const tmpRaw = tmpJoin[pField.Field];
			return {
				ViewHash: this.Hash,
				JoinID: pItem.JoinID,
				Field: pField.Field,
				Label: pField.Label || pField.Field,
				IsCheckbox: (tmpType === 'checkbox'),
				IsNumber: (tmpType === 'number'),
				IsSelect: (tmpType === 'select'),
				IsText: (tmpType === 'text'),
				CheckedAttr: ((tmpType === 'checkbox') && (tmpRaw === 1 || tmpRaw === true || tmpRaw === '1')) ? 'checked' : '',
				Value: (tmpRaw === undefined || tmpRaw === null) ? '' : tmpRaw,
				Options: (Array.isArray(pField.Options) ? pField.Options : []).map((pOption) =>
				{
					const tmpValue = (pOption && typeof pOption === 'object') ? pOption.Value : pOption;
					return { Value: tmpValue, Label: (pOption && typeof pOption === 'object') ? (pOption.Label || pOption.Value) : pOption, SelectedAttr: (`${tmpRaw}` === `${tmpValue}`) ? 'selected' : '' };
				}),
			};
		});
	}

	/**
	 * Persist one per-join config change (a "rich" join's editable column). Writes through to the join
	 * row in place so focus is kept; reverts to the server state on failure.
	 * @param {string|number} pJoinID @param {string} pField @param {any} pValue
	 * @return {Promise<void>}
	 */
	async updateField(pJoinID, pField, pValue)
	{
		const tmpItem = this._lastItems.find((pItem) => String(pItem.JoinID) === String(pJoinID));
		if (!tmpItem || !tmpItem.JoinRecord)
		{
			return;
		}
		// Meadow booleans are 1/0.
		const tmpValue = (pValue === true) ? 1 : ((pValue === false) ? 0 : pValue);
		try
		{
			await this.manager.updateJoin(this.options.AssociationHash, tmpItem.JoinRecord, { [pField]: tmpValue });
			tmpItem.JoinRecord[pField] = tmpValue;
		}
		catch (pError)
		{
			this.pict.log.error(`AssociationEditor [${this.Hash}]: failed to update join field ${pField}.`, pError);
			this._toast('Could not save the change.', 'error');
			await this.renderEditor();
		}
	}

	/**
	 * Seed the default associations for this anchor via the association's `SynthesizeDefaults` hook (the
	 * "Add defaults" button). PSRS dedupes + creates; the host decides what the defaults are. Reloads after.
	 * @return {Promise<void>}
	 */
	async synthesizeDefaults()
	{
		if (!this.manager.hasDefaultSynthesizer(this.options.AssociationHash))
		{
			return;
		}
		let tmpResult = { created: 0, skipped: 0 };
		try
		{
			tmpResult = await this.manager.synthesizeDefaults(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID);
		}
		catch (pError)
		{
			this.pict.log.error(`AssociationEditor [${this.Hash}]: synthesize defaults failed.`, pError);
			this._toast('Could not add the defaults.', 'error');
			return;
		}
		this._toast((tmpResult.created > 0) ? `Added ${tmpResult.created} default${tmpResult.created === 1 ? '' : 's'}.` : 'No new defaults to add.', (tmpResult.created > 0) ? 'success' : 'info');
		await this.renderEditor();
	}

	/**
	 * Non-blocking notification via the host modal's toast, when available.
	 * @param {string} pMessage @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociationEditor;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociationEditor;

},{"pict-view":693}],632:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__Create =
{
	ViewIdentifier: 'PRSP-Create',

	DefaultRenderable: 'PRSP_Renderable_Create',
	DefaultDestinationAddress: '#PRSP_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Create-Basic-Template',
			Template: /*html*/`
				<!-- DefaultPackage pict view template: [PRSP-Create-Basic-Template] -->
				<h1>{~D:Record.RecordSet~} Create</h1>
				<div>
					{~T:PRSP-Create-RecordCreate-Template~}
				</div>
				{~T:PRSP-Create-RecordButtonBar-Template~}
				<!-- DefaultPackage end view template:  [PRSP-Create-Basic-Template] -->
				`
		},
		{
			Hash: 'PRSP-Create-RecordButtonBar-Template',
			Template: /*html*/`
				<style>
					.record-button-bar-hidden
					{
						display: none;
					}
					.record-button-bar
					{
						display: flex;
						margin-top: 15px;
					}
					.record-button-bar > button
					{
						margin-right: 10px;
					}
				</style>
				<div class="record-button-bar">
					<button id="PRSP-Create-ClearButton" type="button" onclick="_Pict.views['RSP-RecordSet-Create'].clear()">Clear</button>
					<button id="PRSP-Create-SaveButton" type="button" onclick="_Pict.views['RSP-RecordSet-Create'].save()">Save</button>
				</div>
			`
		},
		{
			Hash: 'PRSP-Create-Link-Name-Template',
			Template: `Create`
		},
		{
			Hash: 'PRSP-Create-Link-URL-Template',
			Template: `#/PSRS/{~D:Record.Payload.Payload.RecordSet~}/Create`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Create_Basic',
			TemplateHash: 'PRSP-Create-Basic-Template',
			DestinationAddress: '#PRSP_Container',
			RenderMethod: 'replace'
		}
	],

	Manifests: {},
};

class viewRecordSetCreate extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__Create, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.RecordSet = null;
		this.providerHash = null;
		this.manifest = null;
		this.defaultManifest = null;
	}

	handleRecordSetCreateRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Create view route handler called with invalid route payload.`);
		}

		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;

		if (this.delegateToCustomView('Create', tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderCreate(tmpProviderConfiguration, tmpProviderHash);
	}

	async clear()
	{
		await this.onBeforeClear();
		this.renderCreate(this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this.RecordSet], this.providerHash);
	}

	async save()
	{
		await this.onBeforeSave();
		const resultingRecord = await this.pict.providers[this.providerHash].createRecord(this.pict.AppData[`${ this.RecordSet }Details`]);

		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/View/${ resultingRecord[this.pict.providers[this.providerHash].getGUIDField()] }`);
	}

	async onBeforeClear()
	{
		// Hook that gets called before clear.
	}

	async onBeforeSave()
	{
		// Hook that gets called before save.
	}

	async onBeforeRenderCreate(pRecordConfiguration, pProviderHash)
	{
		// Hook that gets called before "renderCreate".
	}

	async renderCreate(pRecordConfiguration, pProviderHash)
	{
		await this.onBeforeRenderCreate(pRecordConfiguration, pProviderHash);
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetCreate: No provider found for ${pProviderHash} in ${pRecordConfiguration.RecordSet}.  Create Render failed.`);
			return false;
		}

		let tmpRecordCreateData =
		{
			"RecordSet": pRecordConfiguration.RecordSet,

			"RecordConfiguration": pRecordConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,
		};

		if (pRecordConfiguration.RecordSet !== this.RecordSet)
		{
			this.RecordSet = pRecordConfiguration.RecordSet;
		}

		this.pict.AppData[`${ this.RecordSet }Details`] = {};

		this.providerHash = pProviderHash;
		tmpRecordCreateData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();

		if (pRecordConfiguration.RecordSetCreateManifestOnly)
		{
			this.pict.TemplateProvider.addTemplate(`PRSP-Create-RecordCreate-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Create-RecordCreate-Template] -->
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordCreate') }</div>
				<!-- Manifest dynamic pict end template: [PRSP-Create-RecordCreate-Template] -->
			`);
		}
		else
		{
			// Construct a default manifest based on the RecordSchema:
			this.defaultManifest = 
			{
				"Form": "DefaultManifest",
				"Scope": "Default",
				"Descriptors": {},
				"Sections": 
				[
					{
						"Name": "",
						"Hash": "DefaultSection",
						"Solvers": [],
						"ShowTitle": false,
						"Groups": [
							{
								"Name": "",
								"Hash": "DefaultGroup",
								"Rows": [],
								"RecordSetSolvers": [],
								"ShowTitle": false
							}
						]
					}
				]
			}
			let rowCounter = 1;
			for (const p of Object.keys(tmpRecordCreateData.RecordSchema.properties))
			{
				const exclusionSet = [this.pict.providers[this.providerHash].getIDField(), this.pict.providers[this.providerHash].getGUIDField(), 'CreatingIDUser', 'UpdatingIDUser', 'DeletingIDUser', 'Deleted', 'CreateDate', 'UpdateDate', 'DeleteDate', 'Deleted', 'IDCustomer', 'ExternalSyncDate', 'ExternalSyncGUID']; // IDCustomer: meadow-endpoints/retold tenancy discriminator — server-managed, never settable via the API
				if (exclusionSet.includes(p))
				{
					continue;
				}
				const tmpDescriptor =
				{
					"Name": `${ this.pict.providers[pProviderHash].getHumanReadableFieldName?.(p) || p }`,
					"Hash": `${ tmpRecordCreateData.RecordSet }-${ p }`,
					"DataType": "String",
					"PictForm": 
					{
						"Row": `${ rowCounter }`,
						"Section": "DefaultSection",
						"Group": "DefaultGroup"
					}
				};
				rowCounter += 1;
				switch (tmpRecordCreateData.RecordSchema.properties[p].type)
				{
					case 'string':
					case 'autoguid':
						tmpDescriptor.DataType = 'String';
						break;
					case 'datetime':
					case 'date':
					case 'createdate':
					case 'updatedate':
						tmpDescriptor.DataType = 'String';
						tmpDescriptor.PictForm.InputType = 'DateTime'
						break;
					case 'boolean':
					case 'deleted':
						tmpDescriptor.DataType = 'Boolean';
					case 'integer':
					case 'decimal':
					case 'autoidentity':
					case 'createiduser':
					case 'updateiduser':
					case 'deleteiduser':
						tmpDescriptor.DataType = 'Number';
						break;
					default:
						tmpDescriptor.DataType = 'String';
				}

				const tmpForeignEntity = this.pict.PictSectionRecordSet.resolveForeignEntity(p, pRecordConfiguration, this.pict.providers[this.providerHash].getIDField());
				if (tmpForeignEntity && this.pict.providers['Pict-Section-Picker'])
				{
					// Foreign-key column → searchable entity Picker (edit) + resolved name (read).
					tmpDescriptor.PictForm.InputType = 'Picker';
					tmpDescriptor.PictForm.Entity = tmpForeignEntity;
					const tmpForeignConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpForeignEntity];
					if (tmpForeignConfig && tmpForeignConfig.SearchFields) { tmpDescriptor.PictForm.SearchFields = tmpForeignConfig.SearchFields; }
				}
				// Per-record-set label override (e.g. Contract/Project IDOrganization → "Prime Contractor").
				if (pRecordConfiguration.FieldLabels && pRecordConfiguration.FieldLabels[p]) { tmpDescriptor.Name = pRecordConfiguration.FieldLabels[p]; }
				this.defaultManifest.Descriptors[`${ tmpRecordCreateData.RecordSet }Details.${ p }`] = tmpDescriptor;
			}
			this.pict.TemplateProvider.addTemplate(`PRSP-Create-RecordCreate-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Create-RecordCreate-Template] -->
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordCreate', true) }</div>
				<!-- Manifest dynamic pict end template: [PRSP-Create-RecordCreate-Template] -->
			`);
		}

		this.renderAsync(`PRSP_Renderable_Create_Basic`, tmpRecordCreateData.RenderDestination, tmpRecordCreateData,
			async function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetCreate: Error rendering create ${pError}`, tmpRecordCreateData);
					return false;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetCreate: Rendered create ${tmpRecordCreateData.RecordSet}`, tmpRecordCreateData);
				}
				else
				{
					this.pict.log.info(`RecordSetCreate: Rendered create ${tmpRecordCreateData.RecordSet}`);
				}
				for (const s of this.manifest?.Sections || [])
				{
					this.pict.views[`PictSectionForm-${ s.Hash }`].render();
					this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
				}
				return true;
			}.bind(this));
	}

	_generateManifestTemplate(config, section, useDefaultManifest)
	{
		const tmpManifestHash = config.RecordSetCreateDefaultManifest || config.RecordSetCreateManifests?.[0];
		const tmpManifest = JSON.parse(JSON.stringify(useDefaultManifest ? this.defaultManifest : this.pict.PictSectionRecordSet.getManifest(tmpManifestHash)));
		if (!tmpManifest)
		{
			this.pict.log.error(`RecordSetCreate: No manifest found for ${ config.RecordSet }. Create Render failed.`);
			return '';
		}
		if (!tmpManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetCreate: No manifest descriptors found for manifest ${ tmpManifestHash }. Create Render failed.`);
			return '';
		}

		this.manifest = tmpManifest;
		let sectionsTemplate = '';
		for (const s of tmpManifest?.Sections || [])
		{
			delete this.pict.views[`PictSectionForm-${ s.Hash }`]
		}
		this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(tmpManifest);

		for (const pickList of tmpManifest?.PickLists || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
		}

		for (const s of tmpManifest?.Sections || [])
		{
			const viewSectionID = `PSRS-Create-${ section }-Section-${ s.Hash }`;
			sectionsTemplate += /*html*/`<div id="${ viewSectionID }"></div>`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].viewMarshalDestination = 'AppData';
			this.pict.views[`PictSectionForm-${ s.Hash }`].options.DefaultDestinationAddress = `#${ viewSectionID }`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].rebuildCustomTemplate();
		}
		return sectionsTemplate
	}


	addRoutes(pPictRouter)
	{
		pPictRouter.addRoute('/PSRS/:RecordSet/Create', this.handleRecordSetCreateRoute.bind(this));
		return true;
	}
}

module.exports = viewRecordSetCreate;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__Create;


},{"../RecordSet-RecordBaseView.js":627}],633:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Dashboard_HeaderList =
{
	ViewIdentifier: 'PRSP-Dashboard-HeaderList',

	DefaultRenderable: 'PRSP_Renderable_HeaderList',
	DefaultDestinationAddress: '#PRSP_HeaderList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Dashboard-HeaderList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-HeaderList-Template] -->
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-HeaderList-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_HeaderList',
			TemplateHash: 'PRSP-Dashboard-HeaderList-Template',
			DestinationAddress: '#PRSP_HeaderList_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetDashboardHeaderList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_Dashboard_HeaderList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardHeaderList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_Dashboard_HeaderList;


},{"pict-view":693}],634:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationBottom = (
	{
		ViewIdentifier: 'PRSP-Dashboard-PaginationBottom',

		DefaultRenderable: 'PRSP_Renderable_PaginationBottom',
		DefaultDestinationAddress: '#PRSP_PaginationBottom_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-PaginationBottom-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-PaginationBottom-Template] -->
	<nav id="RSP_Lower_Pagination_Container">
	{~T:PRSP-Dashboard-Pagination-Template-Description~}
		{~T:PRSP-Dashboard-Pagination-Template-Buttons~}
	</nav>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-PaginationBottom-Template] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationBottom',
					TemplateHash: 'PRSP-Dashboard-PaginationBottom-Template',
					DestinationAddress: '#PRSP_PaginationBottom_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardPaginationBottom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationBottom, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardPaginationBottom;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationBottom;


},{"pict-view":693}],635:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationTop = (
	{
		ViewIdentifier: 'PRSP-Dashboard-PaginationTop',

		DefaultRenderable: 'PRSP_Renderable_PaginationTop',
		DefaultDestinationAddress: '#PRSP_PaginationTop_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-PaginationTop-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-PaginationTop-Template] -->
	<nav id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
		{~T:PRSP-Dashboard-Pagination-Template-Description~}
		{~T:PRSP-Dashboard-Pagination-Template-Buttons~}
	</nav>
	<div>
		{~TS:PRSP-Dashboard-Pagination-Template-Pages:Record.PageLinksLimited~}
	</div>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-PaginationTop-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Description',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Description] -->
	<div>
		Showing
		<span id="PRSP_Pagination_Description_Records_Start">{~D:Record.PageStart~}</span> to
		<span id="PRSP_Pagination_Description_Records_End">{~D:Record.PageEnd~}</span> of
		<span id="PRSP_Pagination_Description_Records_Total">{~D:Record.TotalRecordCount.Count~}</span> total records.
	</div>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Description] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Buttons',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Buttons] -->
	<ul style="list-style-type: none; padding: 0; display: flex; justify-content: center;">
		{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
		{~TS:PRSP-Dashboard-Pagination-Template-Button-Page~}
		{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
	</ul>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Buttons] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Button-Previous',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Previous] -->
	<li><a href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">&laquo; Previous</a></li>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Previous] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Button-Next',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Next] -->
	<li style="margin-left: 15px;"><a href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next &raquo;</a></li>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Next] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Button-Page',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Page] -->
	<li><a href="#" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Page] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Pages',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Pages] -->
	<a href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}" class="page-offset_{~D:Record.RelativeOffset~}">{~D:Record.Page~}</a>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Pages] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationTop',
					TemplateHash: 'PRSP-Dashboard-PaginationTop-Template',
					DestinationAddress: '#PRSP_PaginationTop_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardPaginationTop extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationTop, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardPaginationTop;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationTop;


},{"pict-view":693}],636:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Dashboard_RecordList =
{
	ViewIdentifier: 'PRSP-Dashboard-RecordList',

	DefaultRenderable: 'PRSP_Renderable_RecordList',
	DefaultDestinationAddress: '#PRSP_RecordList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Dashboard-RecordList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordList-Template] -->
	<section id="PRSP_List_Container">
		{~T:PRSP-Dashboard-RecordList-Template-Table~}
	</section>
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-RecordList-Template] -->
`
		},
		{
			Hash: 'PRSP-Dashboard-RecordList-Template-Table',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordList-Template-Table] -->
	<table id="PRSP_List_Table" tablespacing="0" cellpadding="0" cellspacing="0" style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
		<thead>{~T:PRSP-Dashboard-RecordListHeader-Template~}</thead>
		<tbody id="PRSP_RecordList_Container_Entries">
			{~T:PRSP-Dashboard-RecordListEntry-Template~}
		</tbody>
	</table>
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-RecordList-Template-Table] -->
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_RecordList',
			TemplateHash: 'PRSP-Dashboard-RecordList-Template',
			DestinationAddress: '#PRSP_RecordList_Container',
			RenderMethod: 'replace'
		}
	],

	Manifests: {}
};

class viewRecordSetDashboardRecordList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_Dashboard_RecordList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardRecordList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_Dashboard_RecordList;


},{"pict-view":693}],637:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListEntry = (
	{
		ViewIdentifier: 'PRSP-Dashboard-RecordListEntry',

		DefaultRenderable: 'PRSP_Renderable_RecordListEntry',
		DefaultDestinationAddress: '#PRSP_RecordListEntry_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					// TODO: Add extras template here; it's in the header but not here yet.
					Hash: 'PRSP-Dashboard-RecordListEntry-Template',
					Template: /*html*/`
		{~TSWP:PRSP-Dashboard-RecordListEntry-Template-Row:Record.Records.Records:Record~}
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListEntry-Template-Row',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListEntry-Template] -->
	<tr>
		{~TSWP:PRSP-Dashboard-RecordListEntry-Template-Row-Cell:Record.Payload.TableCells:Record.Data~}
		{~T:PRSP-Dashboard-RecordListHeader-Template-Extra-Row~}
		{~T:PRSP-Dashboard-RecordListAction-Template-Cell~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListEntry-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template-Extra-Row',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template-Extra-Row] -->
	{~TBR:Record.Payload.RecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash~}
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Extra-Row] -->
	`
//	{~TBR:Record.Payload.RecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash~}

				},
				{
					Hash: 'PRSP-Dashboard-RecordListEntry-Template-Row-Cell',
					Template: /*html*/`
		<td style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
			{~TBDA:Record.Data.PictDashboard.ValueTemplate~}
		</td>
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListEntry-Template-Entry-Cell-Datum',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListEntry-Template-Entry-Cell-Datum] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListAction-Template-Cell',
					// FIXME: Needs a better way of getting the appropriate link templates in (likely requiring piping the RecordSet to the link manager)
					Template: /*html*/`
		<td style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
			<ul>
			{~TSWP:PRSP-Dashboard-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
			</ul>
		</td>
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListAction-Template-Cell-Datum',
					// These use the new TemplateByReference template expression, which uses the values in these addresses to lookup the template hash then renders those template with the current Record state.
					// This is part one of refactoring to include metatemplate resolution ase a core behavior pict itself rather than a pict-section-form capability
					Template: /*html*/`
					<li><a href="{~TBR:Record.Data.URL~}">{~TBR:Record.Data.Name~}</a></li>
	`

				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListEntry',
					TemplateHash: 'PRSP-Dashboard-RecordListEntry-Template',
					DestinationAddress: '#PRSP_RecordListEntry_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardRecordListEntry extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListEntry, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardRecordListEntry;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListEntry;


},{"pict-view":693}],638:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListHeader = (
	{
		ViewIdentifier: 'PRSP-Dashboard-RecordListHeader',

		DefaultRenderable: 'PRSP_Renderable_RecordListHeader',
		DefaultDestinationAddress: '#PRSP_RecordListHeader_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template] -->
	<tr>
		{~TS:PRSP-Dashboard-RecordListHeader-Template-Header:Record.TableCells~}
		{~T:PRSP-Dashboard-RecordListHeader-Template-Extra-Header~}
		{~T:PRSP-Dashboard-RecordListActions-Template-Header~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Manifest-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template] -->
	<tr>
		{~TS:PRSP-Dashboard-RecordListHeader-Template-Header:Record.ManifestOhz~}
		{~T:PRSP-Dashboard-RecordListHeader-Template-Extra-Header~}
		{~T:PRSP-Dashboard-RecordListActions-Template-Header~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template-Header] -->
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333);">
		{~D:Record.DisplayName~}
	</th>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Template-Header] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template-Extra-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template-Extra-Header] -->
{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Extra-Header] -->
	`
//	{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}

				},
				{
					Hash: 'PRSP-Dashboard-RecordListActions-Template-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListActions-Template-Header] -->
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333);">
		Actions
	</th>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListActions-Template-Header] -->
	`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListHeader',
					TemplateHash: 'PRSP-Dashboard-RecordListHeader-Template',
					DestinationAddress: '#PRSP_RecordListHeader_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardRecordListHeader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListHeader, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardRecordListHeader;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListHeader;


},{"pict-view":693}],639:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_Title =
{
	ViewIdentifier: 'PRSP-Dashboard-Title',

	DefaultRenderable: 'PRSP_Renderable_Title',
	DefaultDestinationAddress: '#PRSP_Title_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Dashboard-Title-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Title-Template] -->
	<header id="PRSP_Title_Container">
		<h1 id="PRSP_Title">{~D:Record.Title~}</h1>
		<h2 id="PRSP_Subtitle">{~D:Record.Subtitle~}</h2>
	</header>
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-Title-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Title',
			TemplateHash: 'PRSP-Dashboard-Title-Template',
			DestinationAddress: '#PRSP_Title_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetDashboardTitle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_Title, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardTitle;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_Title;

},{"pict-view":693}],640:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');

const viewHeaderDashboard = require('./RecordSet-Dashboard-HeaderDashboard.js');
const viewTitle = require('./RecordSet-Dashboard-Title.js');
const viewFilters = require('../RecordSet-Filters.js');
const viewPaginationTop = require('./RecordSet-Dashboard-PaginationTop.js');
const viewRecordList = require('./RecordSet-Dashboard-RecordList.js');
const viewRecordListHeader = require('./RecordSet-Dashboard-RecordListHeader.js');
const viewRecordListEntry = require('./RecordSet-Dashboard-RecordListEntry.js');
const viewPaginationBottom = require('./RecordSet-Dashboard-PaginationBottom.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__Dashboard = (
	{
		ViewIdentifier: 'PRSP-List',

		DefaultRenderable: 'PRSP_Renderable_List',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Template] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-Dashboard-Title~}
		{~V:PRSP-Dashboard-HeaderDashboard~}
		<section id="PRSP_Filters_Container">
			{~FV:PRSP-Filters:Dashboard~}
		</section>
		{~V:PRSP-Dashboard-PaginationTop~}
		{~V:PRSP-Dashboard-RecordList~}
		{~V:PRSP-Dashboard-PaginationBottom~}
	</section>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Template-Form-With-Recordset-Data',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Template-Form-With-Recordset-Data] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-Dashboard-Title~}
		{~V:PRSP-Dashboard-HeaderDashboard~}
		<section id="PRSP_Filters_Container">
			{~FV:PRSP-Filters:Dashboard~}
		</section>
		{~V:PRSP-Dashboard-PaginationTop~}
		{~T:PRSP-Dashboard-RecordDashboard-Template~}
		{~V:PRSP-Dashboard-PaginationBottom~}
	</section>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template-Form-With-Recordset-Data] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Template-Form',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Template-Form] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-Dashboard-Title~}
		{~V:PRSP-Dashboard-HeaderDashboard~}
		{~T:PRSP-Dashboard-RecordDashboard-Template~}
	</section>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template-Form] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Template-Record',
					Template: /*html*/`
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_List',
					TemplateHash: 'PRSP-Dashboard-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Form_With_Recordset_Data',
					TemplateHash: 'PRSP-Dashboard-Template-Form-With-Recordset-Data',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Form',
					TemplateHash: 'PRSP-Dashboard-Template-Form',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboard extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__Dashboard, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.childViews = {
			headerList: null,
			title: null,
			paginationTop: null,
			recordList: null,
			recordListHeader: null,
			recordListEntry: null,
			paginationBottom: null
		};
	}

	handleRecordSetDashboardRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			return;
			//throw new Error(`Pict RecordSet List view route handler called with invalid route payload.`);
		}
		if (!pRoutePayload.data || !pRoutePayload.data.RecordSet)
		{
			return;
		}

		//_Pict.PictSectionRecordSet.recordSetProviderConfigurations['Book'], 'RSP-Provider-Book'
		// FIXME: Not in love with this but good enough to start.
		// FIXME: Typescript mumbo jumbo
		// if (!('PictSectionRecordSet' in this.pict))
		// {
		// 	return false;
		// }
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		if (!tmpProviderConfiguration)
		{
			this.pict.log.error(`RecordSetDashboard: No record set configuration found for ${pRoutePayload.data.RecordSet}.  List Render failed.`);
			this.fable.providers.RecordSetRouter.pictRouter.navigate('/PSRS/404');
			return;
		}
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		const tmpFilterString = pRoutePayload.data.FilterString || '';
		const tmpSerializedFilterExperience = pRoutePayload.data.FilterExperience || '';

		const tmpOffset = pRoutePayload.data.Offset ? pRoutePayload.data.Offset : 0;
		const tmpPageSize = pRoutePayload.data.PageSize ? pRoutePayload.data.PageSize : 100;

		if (pRoutePayload.data.DashboardHash)
		{
			return this.renderSpecificDashboard(pRoutePayload.data.DashboardHash, tmpProviderConfiguration, tmpProviderHash, tmpFilterString, tmpSerializedFilterExperience, tmpOffset, tmpPageSize);
		}
		return this.renderDashboard(tmpProviderConfiguration, tmpProviderHash, tmpFilterString, tmpSerializedFilterExperience, tmpOffset, tmpPageSize);
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/:Offset', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard', this.handleRecordSetDashboardRoute.bind(this));

		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/:Offset', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.resolve();
		return true;
	}

	onBeforeRenderList(pRecordListData)
	{
		return pRecordListData;
	}

	dynamicallyGenerateColumns(pRecordListData)
	{
		pRecordListData.TableCells = [];
		const tmpEntity = pRecordListData.RecordSetConfiguration.Entity;
		this.excludedByDefaultCells = [
			'ID' + tmpEntity,
			'GUID' + tmpEntity,
			'CreateDate',
			'CreatingIDUser',
			'DeleteDate',
			'Deleted',
			'DeletingIDUser',
			'UpdateDate',
			'UpdatingIDUser',
			'IDCustomer', // meadow-endpoints/retold tenancy discriminator — server-managed, hidden from every record view
			'ExternalSyncDate', 'ExternalSyncGUID', // external-sync auditing stamps (Headlight integration sync)
		];

		const tmpSchema = pRecordListData.RecordSchema;
		const tmpProperties = tmpSchema?.properties;
		// loop throught the schema and add the columns to the tableCells
		for (const tmpColumn in tmpProperties)
		{
			if (tmpProperties.hasOwnProperty(tmpColumn))
			{
				// Check if the column is excluded by the default list of columns (or is not a GUID/ID)
				if (this.excludedByDefaultCells.includes(tmpColumn) === false)
				{
					pRecordListData.TableCells.push({
						Key: tmpColumn,
						DisplayName: tmpProperties?.[tmpColumn].title || tmpColumn,
						ManifestHash: 'Default',
						PictDashboard:
						{
							ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
						},
					});
				}
			}
		}
		return pRecordListData;
	}

	/**
	 * @param {string} pDashboardHash
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 *
	 * @return {Promise<void>}
	 */
	async renderSpecificDashboard(pDashboardHash, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize)
	{
		if (!pRecordSetConfiguration)
		{
			this.pict.log.error(`RecordSetDashboard: No record set configuration found for ${pDashboardHash}.  List Render failed.`);
			return;
		}
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetDashboard: No provider found for ${pProviderHash} in ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			return;
		}

		let tmpManifestDefinition;
		if (pDashboardHash)
		{
			tmpManifestDefinition = this.pict.PictSectionRecordSet.manifestDefinitions[pDashboardHash];
		}
		let tmpTitle = pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet;
		if (tmpManifestDefinition && tmpManifestDefinition.TitleTemplate)
		{
			tmpTitle = this.pict.parseTemplate(tmpManifestDefinition.TitleTemplate, pRecordSetConfiguration);
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordDashboardData =
		{
			"Title": tmpTitle,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
			"DashboardHash": pDashboardHash,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordDashboardData.RecordSet);
		}
		// Fetch the records
		tmpRecordDashboardData.Records = await this.pict.providers[pProviderHash].getDecoratedRecords(tmpRecordDashboardData);
		// Get the total record count
		tmpRecordDashboardData.TotalRecordCount = await this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordDashboardData);
		// Get the record schema
		tmpRecordDashboardData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordDashboardData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		const tmpOffset = Number(tmpRecordDashboardData.Offset);
		tmpRecordDashboardData.PageEnd = tmpOffset + tmpRecordDashboardData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordDashboardData.PageStart = (tmpRecordDashboardData.Records.Records.length > 0) ? (tmpOffset + 1) : 0;

		// Compute the number of pages total
		tmpRecordDashboardData.PageCount = Math.ceil(tmpRecordDashboardData.TotalRecordCount.Count / tmpRecordDashboardData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordDashboardData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordDashboardData.Offset / tmpRecordDashboardData.PageSize)
			});
		tmpRecordDashboardData.PageLinks = [];
		for (let i = 0; i < tmpRecordDashboardData.PageCount; i++)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/FilteredTo/${tmpRecordDashboardData.FilterString}/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordDashboardData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordDashboardData.PageLinks.length, tmpRecordDashboardData.PageLinkBookmarks.Current + 10);
		tmpRecordDashboardData.PageLinksLimited = tmpRecordDashboardData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/FilteredTo/${tmpRecordDashboardData.FilterString}/0/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/0/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordDashboardData.PageLinks.length)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/FilteredTo/${tmpRecordDashboardData.FilterString}/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordDashboardData.PageLinkBookmarks.Previous = tmpRecordDashboardData.PageLinkBookmarks.Current - 1;
		tmpRecordDashboardData.PageLinkBookmarks.Next = tmpRecordDashboardData.PageLinkBookmarks.Current + 1;
		tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordDashboardData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordDashboardData.PageLinkBookmarks.Next >= tmpRecordDashboardData.PageLinks.length)
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Next];
		}

		if (pDashboardHash && !tmpManifestDefinition.Form)
		{
			tmpRecordDashboardData.TableCells = tmpManifestDefinition?.TableCells;
		}
		if (!tmpRecordDashboardData.TableCells && !tmpManifestDefinition.Form)
		{
			// Put code here to preprocess columns into other data parts.
			/*
				"RecordSetDashboardManifestOnly": false,

				"RecordSetListManifests": [ "Bestsellers", "Underdogs", "NewReleases" ],
				"RecordSetDashboardManifests": [ "Bestsellers" ],
			 */
			if (pRecordSetConfiguration.RecordSetDashboardManifestOnly)
			{
				const tmpManifestHash = pRecordSetConfiguration.RecordSetDashboardDefaultManifest || pRecordSetConfiguration.RecordSetDashboardManifests?.[0];
				const tmpManifest = this.pict.PictSectionRecordSet.getManifest(tmpManifestHash);
				if (!tmpManifest)
				{
					this.pict.log.error(`RecordSetDashboard: No manifest found for ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
				}
				else
				{
					// @ts-ignore
					tmpRecordDashboardData.TableCells = tmpManifest.TableCells;
				}
			}
			if (!tmpRecordDashboardData.TableCells)
			{
				if (tmpRecordDashboardData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
				{
					tmpRecordDashboardData.TableCells = tmpRecordDashboardData.RecordSetConfiguration.RecordSetListColumns.map((key) =>
						{
							if (typeof key === 'object')
							{
								if (!key.DisplayName)
								{
									key.DisplayName = key.Key; //FIXME: use schema?
								}
								if (!key.ManifestHash)
								{
									key.ManifestHash = 'Default';
								}
								if (key.PictDashboard && !key.PictDashboard.ValueTemplate)
								{
									key.PictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
								}
								return key;
							}
							return {
								Key: key,
								DisplayName: key, //FIXME: use schema?
								ManifestHash: 'Default',
								PictDashboard:
								{
									ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
								},
							};
						});
				}
				else
				{
					this.dynamicallyGenerateColumns(tmpRecordDashboardData);
				}
			}
		}

		tmpRecordDashboardData = this.onBeforeRenderList(tmpRecordDashboardData);

		if (!tmpManifestDefinition.Form)
		{
			this.pict.providers.DynamicRecordsetSolver.solveDashboard(tmpManifestDefinition, tmpRecordDashboardData.Records.Records);
		}
		else
		{
			this.pict.AppData['PSRS-Dashboard-Data'] = tmpRecordDashboardData.Records.Records;
			this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordDashboard-Template', /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Dashboard-RecordDashboard-Template] -->
				<div>${ this._generateFormManifestTemplate(tmpManifestDefinition, 'RecordDashboard') }</div>
				<!-- Manifest dynamic pict end template: [PRSP-Dashboard-RecordDashboard-Template] -->
			`);
		}

		this.renderAsync(tmpManifestDefinition.Form ? (tmpManifestDefinition.WithRecordsetData ? 'PRSP_Renderable_Form_With_Recordset_Data' : 'PRSP_Renderable_Form') : 'PRSP_Renderable_List', tmpRecordDashboardData.RenderDestination, tmpRecordDashboardData,
			function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetDashboard: Error rendering list ${pError}`, tmpRecordDashboardData);
					return;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`, tmpRecordDashboardData);
				}
				else
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`);
				}
				for (const s of tmpManifestDefinition?.Sections || [])
				{
					this.pict.views[`PictSectionForm-${ s.Hash }`].render();
					this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
				}
			}.bind(this));
	}

	_generateFormManifestTemplate(tmpManifest, section)
	{
		if (!tmpManifest)
		{
			this.pict.log.error(`RecordSetDashboard: No manifest found for dashboard. Render failed.`);
			return '';
		}
		if (!tmpManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetDashboard: No manifest descriptors found for manifest. Render failed.`);
			return '';
		}

		this.manifest = tmpManifest;
		let sectionsTemplate = '';
		for (const s of tmpManifest?.Sections || [])
		{
			delete this.pict.views[`PictSectionForm-${ s.Hash }`]
		}
		this.pict.views.PictFormMetacontroller.clearManifestDescription();
		this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(tmpManifest);

		for (const pickList of tmpManifest?.PickLists || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
		}

		for (const s of tmpManifest?.Sections || [])
		{
			const viewSectionID = `PSRS-Dashboard-${ section }-Section-${ s.Hash }`;
			sectionsTemplate += /*html*/`<div id="${ viewSectionID }"></div>`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].viewMarshalDestination = 'AppData';
			this.pict.views[`PictSectionForm-${ s.Hash }`].options.DefaultDestinationAddress = `#${ viewSectionID }`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].rebuildCustomTemplate();
		}
		return sectionsTemplate
	}

	/**
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 *
	 * @return {Promise<void>}
	 */
	async renderDashboard(pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize)
	{
		if (!pRecordSetConfiguration)
		{
			this.pict.log.error(`RecordSetDashboard: No record set configuration found.  List Render failed.`);
			return;
		}
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetDashboard: No provider found for ${pProviderHash} in ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			return;
		}
		if (pRecordSetConfiguration.RecordSetDashboardManifestOnly)
		{
			const tmpManifestHash = pRecordSetConfiguration.RecordSetDashboardDefaultManifest || pRecordSetConfiguration.RecordSetDashboardManifests?.[0];
			const tmpManifest = this.pict.PictSectionRecordSet.getManifest(tmpManifestHash);
			if (!tmpManifest)
			{
				this.pict.log.error(`RecordSetDashboard: No manifest found for ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			}
			else
			{
				return this.renderSpecificDashboard(tmpManifestHash, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize);
			}
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordDashboardData =
		{
			"Title": pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Fetch the records
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordDashboardData.RecordSet);
		}
		const [ tmpRecords, tmpTotalRecordCount, tmpRecordSchema ] = await Promise.all([
			this.pict.providers[pProviderHash].getDecoratedRecords(tmpRecordDashboardData),
			this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordDashboardData),
			this.pict.providers[pProviderHash].getRecordSchema(),
		]);
		tmpRecordDashboardData.Records = tmpRecords;
		// Get the total record count
		tmpRecordDashboardData.TotalRecordCount = tmpTotalRecordCount;
		// Get the record schema
		tmpRecordDashboardData.RecordSchema = tmpRecordSchema;

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordDashboardData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		const tmpOffset = Number(tmpRecordDashboardData.Offset);
		tmpRecordDashboardData.PageEnd = tmpOffset + tmpRecordDashboardData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordDashboardData.PageStart = (tmpRecordDashboardData.Records.Records.length > 0) ? (tmpOffset + 1) : 0;

		// Compute the number of pages total
		tmpRecordDashboardData.PageCount = Math.ceil(tmpRecordDashboardData.TotalRecordCount.Count / tmpRecordDashboardData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordDashboardData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordDashboardData.Offset / tmpRecordDashboardData.PageSize)
			});
		tmpRecordDashboardData.PageLinks = [];
		for (let i = 0; i < tmpRecordDashboardData.PageCount; i++)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/FilteredTo/${tmpRecordDashboardData.FilterString}/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordDashboardData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordDashboardData.PageLinks.length, tmpRecordDashboardData.PageLinkBookmarks.Current + 10);
		tmpRecordDashboardData.PageLinksLimited = tmpRecordDashboardData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/FilteredTo/${tmpRecordDashboardData.FilterString}/${tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/${0}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordDashboardData.PageLinks.length)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/FilteredTo/${tmpRecordDashboardData.FilterString}/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordDashboardData.PageLinkBookmarks.Previous = tmpRecordDashboardData.PageLinkBookmarks.Current - 1;
		tmpRecordDashboardData.PageLinkBookmarks.Next = tmpRecordDashboardData.PageLinkBookmarks.Current + 1;
		tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordDashboardData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordDashboardData.PageLinkBookmarks.Next >= tmpRecordDashboardData.PageLinks.length)
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Next];
		}

		// Put code here to preprocess columns into other data parts.
		/*
			"RecordSetDashboardManifestOnly": false,

			"RecordSetListManifests": [ "Bestsellers", "Underdogs", "NewReleases" ],
			"RecordSetDashboardManifests": [ "Bestsellers" ],
		 */
		if (tmpRecordDashboardData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
		{
			tmpRecordDashboardData.TableCells = tmpRecordDashboardData.RecordSetConfiguration.RecordSetListColumns.map((pKey) =>
				{
					if (typeof pKey === 'object')
					{
						const tmpTableCell = pKey;
						if (!tmpTableCell.DisplayName)
						{
							tmpTableCell.DisplayName = tmpTableCell.Key; //FIXME: use schema?
						}
						if (!tmpTableCell.ManifestHash)
						{
							tmpTableCell.ManifestHash = 'Default';
						}
						if (!tmpTableCell.PictDashboard)
						{
							tmpTableCell.PictDashboard = {};
						}
						if (!tmpTableCell.PictDashboard.ValueTemplate)
						{
							tmpTableCell.PictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
						}
						return tmpTableCell;
					}
					return {
						Key: pKey,
						DisplayName: pKey, //FIXME: use schema?
						ManifestHash: 'Default',
						PictDashboard:
						{
							ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
						},
					};
				});
		}
		else
		{
			this.dynamicallyGenerateColumns(tmpRecordDashboardData);
		}

		tmpRecordDashboardData = this.onBeforeRenderList(tmpRecordDashboardData);

		const tmpManifest = { Scope: 'Default', Descriptors: { }, TableCells: tmpRecordDashboardData.TableCells };
		for (const tmpCell of tmpRecordDashboardData.TableCells)
		{
			tmpManifest.Descriptors[tmpCell.Key] = { Hash: tmpCell.Key, PictDashboard: tmpCell.PictDashboard };
		}
		this.pict.providers.DynamicRecordsetSolver.solveDashboard(tmpManifest, tmpRecordDashboardData.Records.Records);

		this.renderAsync('PRSP_Renderable_List', tmpRecordDashboardData.RenderDestination, tmpRecordDashboardData,
			function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetDashboard: Error rendering list ${pError}`, tmpRecordDashboardData);
					return;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`, tmpRecordDashboardData);
				}
				else
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`);
				}
			}.bind(this));
	}

	onInitialize()
	{
		this.childViews.headerList = this.pict.addView('PRSP-Dashboard-HeaderDashboard', viewHeaderDashboard.default_configuration, viewHeaderDashboard);
		this.childViews.title = this.pict.addView('PRSP-Dashboard-Title', viewTitle.default_configuration, viewTitle);
		this.childViews.filters = this.pict.views['PRSP-Filters'] || this.pict.addView('PRSP-Filters', { }, viewFilters);
		this.childViews.paginationTop = this.pict.addView('PRSP-Dashboard-PaginationTop', viewPaginationTop.default_configuration, viewPaginationTop);
		this.childViews.recordList = this.pict.addView('PRSP-Dashboard-RecordList', viewRecordList.default_configuration, viewRecordList);
		this.childViews.recordListHeader = this.pict.addView('PRSP-Dashboard-RecordListHeader', viewRecordListHeader.default_configuration, viewRecordListHeader);
		this.childViews.recordListEntry = this.pict.addView('PRSP-Dashboard-RecordListEntry', viewRecordListEntry.default_configuration, viewRecordListEntry);
		this.childViews.paginationBottom = this.pict.addView('PRSP-Dashboard-PaginationBottom', viewPaginationBottom.default_configuration, viewPaginationBottom);

		// Initialize the subviews
		this.childViews.headerList.initialize();
		this.childViews.title.initialize();
		this.childViews.paginationTop.initialize();
		this.childViews.recordList.initialize();
		this.childViews.recordListHeader.initialize();
		this.childViews.recordListEntry.initialize();
		this.childViews.paginationBottom.initialize();

		return super.onInitialize();
	}
}

module.exports = viewRecordSetDashboard;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__Dashboard;


},{"../RecordSet-Filters.js":626,"../RecordSet-RecordBaseView.js":627,"./RecordSet-Dashboard-HeaderDashboard.js":633,"./RecordSet-Dashboard-PaginationBottom.js":634,"./RecordSet-Dashboard-PaginationTop.js":635,"./RecordSet-Dashboard-RecordList.js":636,"./RecordSet-Dashboard-RecordListEntry.js":637,"./RecordSet-Dashboard-RecordListHeader.js":638,"./RecordSet-Dashboard-Title.js":639}],641:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Bulk Delete screen — select a batch of a recordset's records and delete them together (to clean up
 * duplicates / bad imports). A searchable, paged record table with a checkbox per row + select-all; "Delete
 * selected" removes them all after a confirm.
 *
 * Two modes:
 *   - Basic: just delete the checked records.
 *   - Advanced (opt in per recordset via `RecordSetAdvancedDelete`): for each record being deleted, pick ONE
 *     replacement record (same recordset); all of that record's many-to-many joins and one-to-many
 *     dependents are REPOINTED to the replacement first (via the metacontroller's reassociation
 *     orchestrator), and the record is only deleted when its repoint succeeds cleanly. This is the "delete
 *     the misspelled Author, move his books to the correct one" workflow.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-BulkDelete` and parameterized by route:
 *   /PSRS/:RecordSet/BulkDelete                       (bulk selection)
 *   /PSRS/:RecordSet/BulkDelete/Record/:RecordID      (single record, Advanced — the Read view's advanced path)
 *
 * Data flows through the registered recordset provider (getRecords + deleteRecord) and the reassociation
 * orchestrator on `pict.PictSectionRecordSet`. The replacement picker comes from `pict-section-picker`
 * (soft dependency); confirm/toast come from `pict-section-modal`; column visibility persists through the
 * `ColumnDataProvider`.
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_BulkDelete = (
	{
		ViewIdentifier: 'PRSP-BulkDelete',

		DefaultRenderable: 'PRSP_Renderable_BulkDelete',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		BulkDeletePageSize: 50,

		CSS: /*css*/`
		.prsp-bdel { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-bdel-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-bdel-card { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); display: flex; flex-direction: column; gap: 0.6rem; }
		.prsp-bdel-card.is-hidden { display: none; }
		.prsp-bdel-card-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bdel-modes { display: inline-flex; gap: 0.35rem; }
		.prsp-bdel-mode { padding: 0.4rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; cursor: pointer; font: inherit; font-size: 0.86rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-panel, #fff); user-select: none; }
		.prsp-bdel-mode:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-mode.is-active { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
		.prsp-bdel-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-bdel-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bdel-stats strong { color: var(--theme-color-status-error, #b62828); font-size: 1.05rem; }
		.prsp-bdel-btn { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-status-error, #b62828);
			background: var(--theme-color-status-error, #b62828); color: #fff; }
		.prsp-bdel-btn:hover { background: var(--theme-color-status-error-hover, #9c2020); }
		.prsp-bdel-btn[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-bdel-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; flex-wrap: wrap; }
		.prsp-bdel-filters:empty { display: none; }
		.prsp-bdel-tools { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-bdel-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bdel-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-colchooser-wrap { position: relative; }
		.prsp-bdel-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-bdel-colchooser-wrap.is-open .prsp-bdel-colchooser-backdrop { display: block; }
		.prsp-bdel-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-bdel-colchooser-wrap.is-open .prsp-bdel-colchooser { display: block; }
		.prsp-bdel-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-bdel-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-bdel-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-bdel-colrow.is-on .prsp-bdel-colrow-check { visibility: visible; }
		.prsp-bdel-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-bdel-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-bdel-tablewrap { max-height: 52vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-btbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-btbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-btbl-th-check { width: 1.8rem; text-align: center; cursor: pointer; }
		.prsp-btbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-btbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-btbl-row.is-selected { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 9%, transparent); }
		.prsp-btbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-btbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-btbl-check { display: inline-flex; color: var(--theme-color-status-error, #b62828); visibility: hidden; }
		.prsp-btbl-row.is-selected .prsp-btbl-check { visibility: visible; }
		.prsp-btbl-headcheck { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bdel-more { display: block; width: 100%; padding: 0.45rem; cursor: pointer; font: inherit; font-size: 0.85rem; border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0);
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bdel-more:hover { background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); }
		.prsp-bdel-empty { padding: 0.9rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; font-style: italic; text-align: center; }
		.prsp-bdel-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		.prsp-bdel-reassign-row { display: flex; align-items: center; gap: 0.8rem; padding: 0.5rem 0.2rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-bdel-reassign-row:first-child { border-top: none; }
		.prsp-bdel-reassign-name { flex: 0 0 40%; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1f2733); font-size: 0.92rem; }
		.prsp-bdel-reassign-arrow { flex: 0 0 auto; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bdel-reassign-picker { flex: 1 1 auto; min-width: 0; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-BulkDelete-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-BulkDelete-Template] -->
		<div class="prsp-bdel">
			<div class="prsp-bdel-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-bdel-sub">{~D:Record.Subtitle~}</p>
			</div>
			{~TS:PRSP-BulkDelete-ModeCard:Record.ModeSlot~}
			<div class="prsp-bdel-bar">
				<div class="prsp-bdel-stats" id="{~D:Record.StatsID~}"></div>
				<button type="button" class="prsp-bdel-btn" id="{~D:Record.DeleteButtonID~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].confirmBulkDelete()">{~I:Trash~} Delete selected</button>
			</div>
			{~TS:PRSP-BulkDelete-Toolbar:Record.ToolbarSlot~}
			<div class="prsp-bdel-card">
				<div class="prsp-bdel-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
			</div>
			{~TS:PRSP-BulkDelete-ReassignCard:Record.ReassignSlot~}
			{~NE:Record.PickerMissing^<div class="prsp-bdel-note">The entity picker (pict-section-picker) is not registered, so replacement selection is unavailable.</div>~}
		</div>
		<!-- DefaultPackage end view template:  [PRSP-BulkDelete-Template] -->
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ModeCard',
				Template: /*html*/`
		<div class="prsp-bdel-card">
			<span class="prsp-bdel-card-label">Mode</span>
			<div class="prsp-bdel-modes" id="{~D:Record.ModeToggleID~}">{~T:PRSP-BulkDelete-ModeToggle:Record~}</div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ModeToggle',
				Template: /*html*/`
		<div class="prsp-bdel-mode{~NE:Record.BasicActive^ is-active~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].setMode('Basic')">Delete only</div>
		<div class="prsp-bdel-mode{~NE:Record.AdvancedActive^ is-active~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].setMode('Advanced')">Reassign &amp; delete</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-Toolbar',
				Template: /*html*/`
		<div class="prsp-bdel-card">
			<div class="prsp-bdel-toolbar">
				<span class="prsp-bdel-card-label">Filter {~D:Record.RecordLabel~}</span>
				<div class="prsp-bdel-tools">
					<div class="prsp-bdel-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-bdel-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleColumnChooser()">{~I:Settings~} Columns</button>
						<div class="prsp-bdel-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].closeColumnChooser()"></div>
						<div class="prsp-bdel-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<!-- The recordset's own filter experience (quick filters + Add filter) renders here; applying a
			     filter navigates to /BulkDelete/FilteredTo/... which re-lists through the same provider path. -->
			<div class="prsp-bdel-filters" id="PRSP_Filters_Container"></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-Table',
				Template: /*html*/`
		<table class="prsp-btbl">
			<thead><tr><th class="prsp-btbl-th-check" title="Select all loaded" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleSelectAll()"><span class="prsp-btbl-headcheck">{~D:Record.SelectAllIcon~}</span></th>{~TS:PRSP-BulkDelete-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-BulkDelete-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-BulkDelete-Empty:Record.EmptySlot~}
		{~TS:PRSP-BulkDelete-More:Record.MoreSlot~}
	`
			},
			{
				Hash: 'PRSP-BulkDelete-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-BulkDelete-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-btbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleRow('{~D:Record.RecordID~}')"><td class="prsp-btbl-td-check"><span class="prsp-btbl-check">{~I:Check~}</span></td>{~TS:PRSP-BulkDelete-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-BulkDelete-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-BulkDelete-Empty',
				Template: /*html*/`<div class="prsp-bdel-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-BulkDelete-More',
				Template: /*html*/`<button type="button" class="prsp-bdel-more" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].loadMore()">Load more</button>`
			},
			{
				Hash: 'PRSP-BulkDelete-Chooser',
				Template: /*html*/`
		<div class="prsp-bdel-colchooser-list">{~TS:PRSP-BulkDelete-ColRow:Record.Rows~}</div>
		<div class="prsp-bdel-colchooser-foot"><button type="button" class="prsp-bdel-colreset" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].resetColumns()">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ColRow',
				Template: /*html*/`<button type="button" class="prsp-bdel-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleColumn('{~D:Record.Key~}')"><span class="prsp-bdel-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			},
			{
				Hash: 'PRSP-BulkDelete-ReassignCard',
				Template: /*html*/`
		<div class="prsp-bdel-card{~NE:Record.Hidden^ is-hidden~}" id="{~D:Record.ReassignCardID~}">
			<span class="prsp-bdel-card-label">Reassign related records to</span>
			<div id="{~D:Record.ReassignID~}"></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-Reassign',
				Template: /*html*/`
		{~TS:PRSP-BulkDelete-ReassignRow:Record.Rows~}
		{~TS:PRSP-BulkDelete-ReassignEmpty:Record.EmptySlot~}
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ReassignRow',
				Template: /*html*/`
		<div class="prsp-bdel-reassign-row">
			<span class="prsp-bdel-reassign-name" title="{~D:Record.Display~}">{~D:Record.Display~}</span>
			<span class="prsp-bdel-reassign-arrow">{~I:ArrowRight~}</span>
			<div class="prsp-bdel-reassign-picker" id="{~D:Record.PickerHostID~}"></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ReassignEmpty',
				Template: /*html*/`<div class="prsp-bdel-empty">{~D:Record.EmptyText~}</div>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_BulkDelete',
				TemplateHash: 'PRSP-BulkDelete-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetBulkDelete extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_BulkDelete, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._recordSet = null;
		this._config = null;
		this._presetRecordID = null;    // single-record advanced entry (from the Read view)
		this._records = [];             // the loaded page(s)
		this._recordsByID = {};         // String(id) -> record (accumulates across pages, for confirm lookups)
		this._cursor = 0;
		this._hasMore = false;
		this._filterString = '';        // the FilteredTo route segment (the recordset filter search string)
		this._filterExperience = '';    // the serialized filter experience from the route
		this._selected = {};            // String(recordID) -> true
		this._mode = 'Basic';           // 'Basic' | 'Advanced'
		this._replacement = {};         // String(recordID) -> replacementID
	}

	/** @return {any} The registered recordset provider. */
	get provider()
	{
		return this.pict.providers[`RSP-Provider-${this._recordSet}`];
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/** @return {number} */
	_pageSize() { return this.options.BulkDeletePageSize || 50; }

	/** @return {boolean} Whether advanced (reassign) delete is enabled for this recordset. */
	_advancedEnabled() { return !!(this._config && this._config.RecordSetAdvancedDelete === true); }

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/Record/:RecordID', this.handleBulkDeleteRoute.bind(this));
		// Filtered variants (the recordset filter experience navigates here, ViewContext = 'BulkDelete').
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleBulkDeleteRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/FilteredTo/:FilterString', this.handleBulkDeleteRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/FilterExperience/:FilterExperience', this.handleBulkDeleteRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete', this.handleBulkDeleteRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — parse the recordset + optional single record, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleBulkDeleteRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet BulkDelete route handler called with invalid route payload.`);
		}
		this._recordSet = pRoutePayload.data.RecordSet;
		this._presetRecordID = (pRoutePayload.data.RecordID !== undefined && pRoutePayload.data.RecordID !== '') ? pRoutePayload.data.RecordID : null;
		this._filterString = pRoutePayload.data.FilterString || '';
		this._filterExperience = pRoutePayload.data.FilterExperience || '';
		this._config = this.pict.PictSectionRecordSet ? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this._recordSet] : null;
		this._records = [];
		this._recordsByID = {};
		this._cursor = 0;
		this._hasMore = false;
		this._selected = {};
		this._replacement = {};
		// The Read view's advanced path deep-links a single record; force Advanced + preselect it.
		this._mode = this._presetRecordID ? 'Advanced' : 'Basic';
		if (this._presetRecordID) { this._selected[String(this._presetRecordID)] = true; }
		return this.renderScreen();
	}

	/** A DOM/address-safe key for this screen. */
	get safeKey()
	{
		return `${String(this._recordSet)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	/** @return {string} A label for the records being deleted. */
	_recordLabel() { return (this._config && this._config.Title) || this._recordSet || 'records'; }

	/** @return {Array<string>} The recordset's search fields (config, else the display field). */
	_searchFields()
	{
		if (this._config && Array.isArray(this._config.SearchFields) && this._config.SearchFields.length > 0) { return this._config.SearchFields; }
		return [ this._displayField() ];
	}

	/** @return {string} The best display field for a record (config override, else a common name column). */
	_displayField()
	{
		if (this._config && this._config.RecordSetBulkDeleteDisplayField) { return this._config.RecordSetBulkDeleteDisplayField; }
		if (this._config && Array.isArray(this._config.SearchFields) && this._config.SearchFields.length > 0) { return this._config.SearchFields[0]; }
		return 'Name';
	}

	/** Column persistence scope for the bulk-delete table. */
	_columnScope() { return `BulkDelete_${this._recordSet}`; }

	/** @return {Array<Record<string, any>>} The table columns (RecordSetListColumns, else a single display column). */
	_columns()
	{
		if (this._config && Array.isArray(this._config.RecordSetListColumns) && this._config.RecordSetListColumns.length > 0)
		{
			return this._config.RecordSetListColumns.map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName || pCol.Key, DefaultHidden: (pCol.DefaultHidden === true) }));
		}
		return [ { Key: '__display', DisplayName: this._recordLabel(), DefaultHidden: false } ];
	}

	/**
	 * Fetch one page of the recordset's records (or the single preset record). The FilterString is encoded
	 * the same way the List view encodes it before handing it to the provider.
	 * @param {boolean} pReset
	 * @return {Promise<void>}
	 */
	async _fetchPage(pReset)
	{
		if (pReset) { this._cursor = 0; }
		const tmpIDField = this.provider.getIDField();
		let tmpRecords = [];
		if (this._presetRecordID)
		{
			// The single-record advanced flow fetches exactly that record (documented raw-filter read).
			const tmpResult = await this.provider.getRecordsInline(`FBV~${tmpIDField}~EQ~${encodeURIComponent(this._presetRecordID)}`, 0, 1);
			tmpRecords = (tmpResult && Array.isArray(tmpResult.Records)) ? tmpResult.Records : [];
			this._hasMore = false;
		}
		else
		{
			// Reuse the recordset's filter machinery: getRecords composes the route FilterString (encoded the
			// same way the List encodes it) over the recordset's active filter clauses + default filter +
			// delete suppression. So the bulk-delete list respects the same filters as the List.
			const tmpOptions = { RecordSet: this._recordSet, RecordSetConfiguration: this._config, Offset: this._cursor, PageSize: this._pageSize() };
			if (this._filterString) { tmpOptions.FilterString = encodeURIComponent(this._filterString); }
			const tmpResult = await this.provider.getRecords(tmpOptions);
			tmpRecords = (tmpResult && Array.isArray(tmpResult.Records)) ? tmpResult.Records : [];
			this._hasMore = (tmpRecords.length >= this._pageSize());
		}
		this._records = pReset ? tmpRecords : this._records.concat(tmpRecords);
		// Index every loaded record so confirm can find a selected record even after it scrolls off (paging
		// is client-side "Load more", so selection survives; a filter change re-lists via the route).
		for (let i = 0; i < tmpRecords.length; i++)
		{
			this._recordsByID[String(tmpRecords[i][tmpIDField])] = tmpRecords[i];
		}
	}

	/**
	 * Paint the screen shell, load the first page, render the table (+ the reassign section in Advanced mode).
	 * @return {Promise<boolean>}
	 */
	async renderScreen()
	{
		if (!this.provider)
		{
			this.pict.log.error(`BulkDelete: no provider registered for recordset [${this._recordSet}].`);
			return false;
		}
		// Rehydrate the filter experience from the route into the recordset's active filter state (so the
		// same clauses drive the fetch), mirroring how the List view rehydrates filters from the URL.
		if (this._filterExperience && this.pict.views['PRSP-Filters'])
		{
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(this._filterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${this._recordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}
		await this._fetchPage(true);

		const tmpAdvanced = (this._mode === 'Advanced');
		const tmpModeData = {
			ModeToggleID: `${this.safeKey}_ModeToggle`,
			BasicActive: !tmpAdvanced,
			AdvancedActive: tmpAdvanced,
		};
		const tmpToolbarData = {
			RecordLabel: this._recordLabel(),
			ChooserID: `${this.safeKey}_Chooser`,
		};
		const tmpReassignData = {
			ReassignCardID: `${this.safeKey}_ReassignCard`,
			ReassignID: `${this.safeKey}_Reassign`,
			Hidden: !tmpAdvanced,
		};

		const tmpRecord =
		{
			Title: this._presetRecordID ? `Reassign & delete this ${this._singular(this._recordLabel())}` : `Delete ${this._recordLabel()}`,
			Subtitle: this._presetRecordID
				? `Choose a replacement for each related record, then delete.`
				: `Select the ${this._recordLabel()} to delete, then remove them together.${this._advancedEnabled() ? ' Use "Reassign & delete" to move related records to a replacement first.' : ''}`,
			StatsID: `${this.safeKey}_Stats`,
			DeleteButtonID: `${this.safeKey}_Delete`,
			TableID: `${this.safeKey}_Table`,
			PickerMissing: (this._advancedEnabled() && !this.pict.providers['Pict-Section-Picker']),
			// Mode toggle only when advanced is enabled AND this is not the single-record preset flow.
			ModeSlot: (this._advancedEnabled() && !this._presetRecordID) ? [ tmpModeData ] : [],
			// The search/columns toolbar is not useful for the single-record preset flow.
			ToolbarSlot: this._presetRecordID ? [] : [ tmpToolbarData ],
			// The reassign card exists whenever advanced is enabled (hidden until Advanced mode).
			ReassignSlot: this._advancedEnabled() ? [ tmpReassignData ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`BulkDelete: render error.`, pError);
						return resolve(false);
					}
					this._renderTable();
					if (!this._presetRecordID && this.pict.views['PRSP-Filters'])
					{
						// Render the recordset's filter experience into #PRSP_Filters_Container (ViewContext
						// 'BulkDelete', so its apply navigates back to /BulkDelete/FilteredTo/...). Mirrors the
						// filter view's own in-place re-render call.
						this.pict.views['PRSP-Filters'].render(undefined, undefined, { RecordSet: this._recordSet, ViewContext: 'BulkDelete' });
					}
					if (tmpAdvanced) { this._renderReassign(); }
					this.updateStats();
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/** Effective visibility for a column (stored override wins, else `!DefaultHidden`). */
	_isColumnVisible(pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(), 'BulkDelete') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @return {Array<Record<string, any>>} The currently-visible columns. */
	_visibleColumns()
	{
		return this._columns().filter((pCol) => this._isColumnVisible(pCol));
	}

	/** Resolve a cell value for a column on a record (the synthetic __display column uses the name heuristic). */
	_cellValue(pRecord, pColumn)
	{
		if (pColumn.Key === '__display') { return this._displayName(pRecord); }
		return pRecord[pColumn.Key];
	}

	/** A human-friendly display name for a record (first present of the common name columns, else #id). */
	_displayName(pRecord)
	{
		if (!pRecord || typeof pRecord !== 'object') { return ''; }
		const tmpFields = [ this._displayField(), 'Name', 'Title', 'FullName', 'DisplayName', 'Label', 'Description', 'Code' ];
		for (let i = 0; i < tmpFields.length; i++)
		{
			const tmpValue = pRecord[tmpFields[i]];
			if (tmpValue !== undefined && tmpValue !== null && String(tmpValue).trim() !== '') { return String(tmpValue).trim(); }
		}
		return `#${pRecord[this.provider.getIDField()]}`;
	}

	/** Build the row models for the loaded records and render the table. */
	_renderTable()
	{
		const tmpColumns = this._visibleColumns();
		const tmpIDField = this.provider.getIDField();
		const tmpRows = this._records.map((pRecord) =>
		{
			const tmpID = pRecord[tmpIDField];
			return {
				RecordID: tmpID,
				RowID: `${this.safeKey}_row_${tmpID}`,
				Selected: !!this._selected[String(tmpID)],
				Cells: tmpColumns.map((pCol) => ({ Value: this._cellValue(pRecord, pCol) })),
			};
		});
		const tmpAllSelected = (tmpRows.length > 0 && tmpRows.every((pRow) => pRow.Selected));
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			SelectAllIcon: this.pict.icon(tmpAllSelected ? 'Check' : 'Minus'),
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: this._filterString ? `No ${this._recordLabel()} match the filter.` : `No ${this._recordLabel()} found.` } ] : [],
			MoreSlot: this._hasMore ? [ {} ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Table`, tmpHTML);
	}

	/** Load the next page of records and append it. @return {Promise<void>} */
	async loadMore()
	{
		this._cursor += this._pageSize();
		await this._fetchPage(false);
		this._renderTable();
	}

	/**
	 * Toggle a record's selection (the row click). Re-renders the reassign section in Advanced mode so its
	 * per-record replacement pickers track the selection.
	 * @param {string|number} pRecordID
	 */
	toggleRow(pRecordID)
	{
		const tmpKey = String(pRecordID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; delete this._replacement[tmpKey]; }
		else { this._selected[tmpKey] = true; }
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_row_${pRecordID}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!this._selected[tmpKey]);
		}
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	/** Select / clear all the LOADED rows (the header checkbox). */
	toggleSelectAll()
	{
		const tmpIDField = this.provider.getIDField();
		const tmpAllSelected = (this._records.length > 0 && this._records.every((pRecord) => this._selected[String(pRecord[tmpIDField])]));
		for (let i = 0; i < this._records.length; i++)
		{
			const tmpKey = String(this._records[i][tmpIDField]);
			if (tmpAllSelected) { delete this._selected[tmpKey]; delete this._replacement[tmpKey]; }
			else { this._selected[tmpKey] = true; }
		}
		this._renderTable();
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	/** Switch Basic/Advanced mode (show/hide the reassign card + repaint the toggle). @param {string} pMode */
	setMode(pMode)
	{
		this._mode = (pMode === 'Advanced') ? 'Advanced' : 'Basic';
		const tmpToggleElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_ModeToggle`);
		if (tmpToggleElements && tmpToggleElements.length > 0)
		{
			const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-ModeToggle', { BasicActive: (this._mode !== 'Advanced'), AdvancedActive: (this._mode === 'Advanced') });
			this.pict.ContentAssignment.assignContent(`#${this.safeKey}_ModeToggle`, tmpHTML);
		}
		const tmpCardElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_ReassignCard`);
		if (tmpCardElements && tmpCardElements.length > 0)
		{
			tmpCardElements[0].classList.toggle('is-hidden', (this._mode !== 'Advanced'));
		}
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	/** Render the reassign section (a replacement picker per selected record) + mount the pickers. */
	_renderReassign()
	{
		const tmpIDField = this.provider.getIDField();
		const tmpSelectedIDs = Object.keys(this._selected).filter((pKey) => this._selected[pKey]);
		const tmpRows = tmpSelectedIDs.map((pID) => (
			{
				RecordID: pID,
				Display: this._displayName(this._recordsByID[pID] || {}),
				PickerHostID: `${this.safeKey}_repl_${String(pID).replace(/[^A-Za-z0-9]/g, '_')}`,
			}));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-Reassign',
			{
				Rows: tmpRows,
				EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: `Select ${this._recordLabel()} above to choose replacements.` } ] : [],
			});
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Reassign`, tmpHTML);
		for (let i = 0; i < tmpRows.length; i++)
		{
			this._mountReplacementPicker(tmpRows[i].RecordID, tmpRows[i].PickerHostID, tmpSelectedIDs);
		}
	}

	/**
	 * Mount a single-select replacement picker over the same recordset entity, culling every id selected
	 * for deletion (so a record can't be its own or another victim's replacement).
	 * @param {string|number} pRecordID @param {string} pHostID @param {Array<string>} pExcludeIDs
	 */
	_mountReplacementPicker(pRecordID, pHostID, pExcludeIDs)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpIDField = this.provider.getIDField();
		const tmpSafeID = String(pRecordID).replace(/[^A-Za-z0-9]/g, '_');
		const tmpPickerHash = `${this.safeKey}_ReplPicker_${tmpSafeID}`;
		const tmpValueAddress = `AppData.PRSPBulkDeleteRepl.${this.safeKey}.R${tmpSafeID}`;
		if (!this.pict.AppData.PRSPBulkDeleteRepl) { this.pict.AppData.PRSPBulkDeleteRepl = {}; }
		if (!this.pict.AppData.PRSPBulkDeleteRepl[this.safeKey]) { this.pict.AppData.PRSPBulkDeleteRepl[this.safeKey] = {}; }

		const tmpConfig = {
			Entity: this.provider.options.Entity,
			ValueField: tmpIDField,
			TextField: this._displayField(),
			SearchFields: this._searchFields(),
			DestinationAddress: `#${pHostID}`,
			ValueAddress: tmpValueAddress,
			Placeholder: `Search a replacement ${this._singular(this._recordLabel())}…`,
			BaseFilter: () => `FBL~${tmpIDField}~NIN~${(pExcludeIDs || []).map((pValue) => encodeURIComponent(pValue)).join(',')}`,
			OnChange: (pValue) => { this._replacement[String(pRecordID)] = pValue; this.updateStats(); },
		};
		// Field decoration (module policy): opt-in ⚙ to pin an extra column onto each replacement row so
		// same-named candidates are distinguishable. Resolved per entity by the metacontroller.
		if (this.pict.PictSectionRecordSet)
		{
			this.pict.PictSectionRecordSet.applyFieldDecoration(tmpConfig, this.provider.options.Entity);
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		// createEntityPicker builds the picker view but does not paint it into the host — render it, then
		// restore any prior choice (a fresh row has none, so setValue is conditional).
		this.pict.views[tmpPickerHash].render();
		if (this._replacement[String(pRecordID)] !== undefined)
		{
			this.pict.views[tmpPickerHash].setValue(this._replacement[String(pRecordID)]);
		}
	}

	/** @return {number} */
	_selectedCount() { return Object.keys(this._selected).filter((pKey) => this._selected[pKey]).length; }

	/** Recompute the stats line + the Delete button's enabled state. */
	updateStats()
	{
		const tmpSelectedIDs = Object.keys(this._selected).filter((pKey) => this._selected[pKey]);
		const tmpCount = tmpSelectedIDs.length;
		let tmpStats = `<strong>${tmpCount}</strong> selected to delete`;
		if (this._mode === 'Advanced')
		{
			const tmpMissing = tmpSelectedIDs.filter((pKey) => (this._replacement[pKey] === undefined || this._replacement[pKey] === null || this._replacement[pKey] === '')).length;
			if (tmpMissing > 0) { tmpStats += ` &middot; ${tmpMissing} still need a replacement`; }
		}
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`, tmpStats);
		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Delete`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = (tmpCount < 1);
		}
	}

	/**
	 * Delete the selected records (confirm via the host modal). In Advanced mode, each record's
	 * relationships are repointed to its chosen replacement first, and the record is deleted only when the
	 * repoint has zero failures (there are no DB transactions, so a partial repoint must not orphan rows).
	 * @return {Promise<void>}
	 */
	async confirmBulkDelete()
	{
		const tmpSelectedIDs = Object.keys(this._selected).filter((pKey) => this._selected[pKey]);
		if (tmpSelectedIDs.length < 1)
		{
			return;
		}
		const tmpAdvanced = (this._mode === 'Advanced');

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpMessage = tmpAdvanced
				? `Reassign related records and delete ${tmpSelectedIDs.length} ${this._recordLabel()}? This cannot be undone.`
				: `Delete ${tmpSelectedIDs.length} ${this._recordLabel()}? This cannot be undone.`;
			const tmpOk = await tmpModal.confirm(tmpMessage,
				{ title: 'Delete', confirmLabel: `Delete ${tmpSelectedIDs.length}`, cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}

		let tmpDeleted = 0;
		let tmpFailed = 0;
		let tmpBlocked = 0;
		for (let i = 0; i < tmpSelectedIDs.length; i++)
		{
			const tmpID = tmpSelectedIDs[i];
			const tmpRecord = this._recordsByID[tmpID];
			if (!tmpRecord)
			{
				tmpFailed++;
				continue;
			}
			if (tmpAdvanced)
			{
				const tmpTo = this._replacement[tmpID];
				if (tmpTo === undefined || tmpTo === null || tmpTo === '' || String(tmpTo) === String(tmpID))
				{
					// No (usable) replacement chosen — skip rather than silently orphan or delete unremapped.
					tmpBlocked++;
					continue;
				}
				const tmpRepoint = await this.pict.PictSectionRecordSet.repointRecordRelationships(this._recordSet, tmpID, tmpTo);
				if (tmpRepoint.failed > 0)
				{
					// A relationship failed to move — do NOT delete (it would orphan the un-moved rows).
					tmpFailed++;
					this.pict.log.error(`BulkDelete: repoint for ${this._recordSet} ${tmpID} -> ${tmpTo} had ${tmpRepoint.failed} failure(s); skipping delete.`);
					continue;
				}
			}
			try
			{
				await this.provider.deleteRecord(tmpRecord);
				delete this._selected[tmpID];
				delete this._replacement[tmpID];
				tmpDeleted++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`BulkDelete: delete failed for ${this._recordSet} ${tmpID}.`, pError);
			}
		}

		this._toast(`Deleted ${tmpDeleted}${tmpFailed > 0 ? `, ${tmpFailed} failed` : ''}${tmpBlocked > 0 ? `, ${tmpBlocked} skipped (no replacement)` : ''}.`,
			(tmpFailed > 0 || tmpBlocked > 0) ? 'error' : 'success');

		// The single-record advanced flow returns to the list once its record is gone.
		if (this._presetRecordID && tmpDeleted > 0)
		{
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${this._recordSet}/List`);
			return;
		}

		await this._fetchPage(true);
		this._renderTable();
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	// --- Column chooser (mirrors the associate screens) ---

	/** Open/close the column chooser. */
	toggleColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1) { return; }
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser();
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close the column chooser (backdrop outside-click). */
	closeColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render the chooser rows. */
	_renderColumnChooser()
	{
		const tmpRows = this._columns().map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName, Visible: this._isColumnVisible(pCol) }));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-Chooser', { Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Chooser`, tmpHTML);
	}

	/** Toggle one column's visibility (persisted; refuses to hide the last visible column). @param {string} pKey */
	toggleColumn(pKey)
	{
		if (!this.columnProvider) { return; }
		const tmpCol = this._columns().find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol) { return; }
		const tmpVisible = this._isColumnVisible(tmpCol);
		if (tmpVisible && this._visibleColumns().length <= 1) { return; }
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(), 'BulkDelete', pKey, !tmpVisible);
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Clear column overrides — back to developer defaults. */
	resetColumns()
	{
		if (this.columnProvider) { this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(), 'BulkDelete'); }
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Crude singularizer ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/** Non-blocking notification via the host modal's toast, when available. */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetBulkDelete;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_BulkDelete;

},{"pict-view":693}],642:[function(require,module,exports){
module.exports={
	"ViewIdentifier": "RecordSet-Error-NotFound-View",

	"DefaultRenderable": "RecordSet-Error-NotFound",
	"DefaultDestinationAddress": "#PRSP_Container",

	"AutoRender": false,

	"Templates":
	[
		{
			"Hash": "RecordSet-Error-NotFound-Content",
			"Template": "<div class=\"header\"><h1>404 - Our Legal Contract is <em>Your</em> Legal Contract</h1><h2>Feel safe in a space where nobody breaks the rules.</h2></div> <div class=\"content\"> <h2 class=\"content-subhead\">A Binding Agreement</h2><p>By using our postcard sending site, you agree to abide by the following terms and conditions:</p> <h2 class=\"content-subhead\">Intellectual Property Rights</h2><p>All content, including but not limited to text, images, graphics, logos, and software, provided on our site is the property of our company or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, or otherwise use any content without the prior written consent of the respective owners.</p> <h2 class=\"content-subhead\">User Content</h2><p>By uploading or submitting any content (such as text, images, or personal information) to our site, you grant us a worldwide, royalty-free, non-exclusive license to use, reproduce, modify, adapt, publish, translate, and distribute such content for the purpose of providing our services. You represent and warrant that you have the necessary rights to grant us this license.</p> <h2 class=\"content-subhead\">Privacy Policy</h2><p> We are committed to protecting your privacy. Our Privacy Policy outlines how we collect, use, and disclose your personal information. By using our site, you consent to the collection, use, and disclosure of your information as described in our Privacy Policy.</p> <h2 class=\"content-subhead\">Limitation of Liability</h2><p> We make every effort to ensure the accuracy and reliability of the information provided on our site. However, we cannot guarantee that our site will be error-free, uninterrupted, or free of viruses or other harmful components. In no event shall we be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with your use of our site.</p> <h2 class=\"content-subhead\">Governing Law</h2><p> These terms and conditions shall be governed by and construed in accordance with the laws of the world, without regard to its conflict of law provisions. Any disputes arising out of or relating to these terms and conditions shall be subject to the exclusive jurisdiction of the courts of the world.</p> <p>By using our postcard sending site, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. If you do not agree to these terms and conditions, please refrain from using our site.</p></div>"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "RecordSet-Error-NotFound",
			"TemplateHash": "RecordSet-Error-NotFound-Content"
		}
	]
}

},{}],643:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

class ViewRecordSetSUBSETFilterBaseRange extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseAddress = pRecord.ClauseValuesAddress + '.Start';
		pRecord.EndClauseAddress = pRecord.ClauseValuesAddress + '.End';

		pRecord.StartClauseDescriptor =
		{
			Hash: this.fable.DataFormat.sanitizeObjectKey(`${pRecord.Hash}_Start`),
			Address: pRecord.StartClauseAddress,
			//TODO: figure out a nice pattern for extracting a name for the field from the filter - and allow the filter author to provide the label here
			Name: pRecord.MinimumLabel || `Minimum ${pRecord.ExternalFilterByColumn || pRecord.ExternalFilterByColumns?.[0] || pRecord.FilterByColumn || pRecord.FilterByColumns?.[0] || 'Value'}`,
			DataType: pRecord.DataType || 'String',
			PictForm: pRecord.PictForm || {},
		};

		pRecord.EndClauseDescriptor =
		{
			Hash: this.fable.DataFormat.sanitizeObjectKey(`${pRecord.Hash}_End`),
			Address: pRecord.EndClauseAddress,
			Name: pRecord.MaximumLabel || `Maximum ${pRecord.ExternalFilterByColumn || pRecord.ExternalFilterByColumns?.[0] || pRecord.FilterByColumn || pRecord.FilterByColumns?.[0] || 'Value'}`,
			DataType: pRecord.DataType || 'String',
			PictForm: pRecord.PictForm || {},
		};
	}
}

module.exports = ViewRecordSetSUBSETFilterBaseRange;

},{"./RecordSet-Filter-Base":644}],644:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_SUBSET_Filter =
{
	ViewIdentifier: 'PRSP-FilterType-Base',

	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	// Themeable filter-clause chrome. Every filter type renders through the shared
	// PRSP-Filter-Base-Template wrapper below (each type only plugs in its own value
	// input via getFilterFormTemplate()), so styling it here themes every clause for
	// every host app. This view (PRSP-FilterType-Base) is always constructed, and
	// pict-view registers a view's CSS into the global cascade at construction, so
	// these rules apply to all clauses regardless of which type rendered them.
	//
	// Host apps brand by defining the --theme-color-* tokens; the hardcoded values are
	// sensible fallbacks. CSS-first: native <select>s are de-nativized with
	// appearance:none + a custom chevron rather than swapped for a combobox widget
	// (that is a later upgrade with cross-browser quirks of its own).
	CSS: /*css*/`
.prsp-filters-clauses { display: flex; flex-direction: column; gap: 0.5rem; }

.prsp-filter { display: flex; align-items: flex-end; gap: 0.5rem; }
.prsp-filter *, .prsp-filter *::before, .prsp-filter *::after { box-sizing: border-box; }
.prsp-filter-body { flex: 1 1 auto; min-width: 0; display: flex; flex-wrap: wrap; align-items: flex-end; gap: 0.4rem 0.75rem; }

/* Inputs rendered by pict-section-form inside a clause. Match the consolidated
   control's search box so clauses stop looking like bare native controls. */
.prsp-filter label { font: inherit; font-size: 0.78rem; font-weight: 600; display: block;
	margin: 0 0 0.2rem; color: var(--theme-color-text-secondary, #45505f); }
.prsp-filter input, .prsp-filter select, .prsp-filter textarea { font: inherit; font-size: 0.92rem; width: 100%;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-filter input:focus, .prsp-filter select:focus, .prsp-filter textarea:focus { outline: none;
	border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
/* De-nativize the <select>: drop the platform arrow, add a themed chevron + room for it. */
.prsp-filter select { appearance: none; -webkit-appearance: none; -moz-appearance: none; cursor: pointer;
	padding-right: 1.9rem;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7686' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
	background-repeat: no-repeat; background-position: right 0.6rem center; background-size: 1.05em; }

/* Remove (trash) control — one per clause, inherited by every filter type. */
.prsp-filter-remove { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 2.05rem; height: 2.05rem; padding: 0; cursor: pointer; line-height: 1;
	border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-muted, #6b7686); }
.prsp-filter-remove:hover { border-color: var(--theme-color-status-error, #d64545); color: var(--theme-color-status-error, #d64545);
	background: color-mix(in srgb, var(--theme-color-status-error, #d64545) 12%, transparent); }
.prsp-filter-remove .pict-icon { font-size: 1.05rem; }
`,
	CSSPriority: 500,

	Manifests: {},

	DefaultRenderable: 'PRSP_Renderable_Filter_Base',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-Base-Form',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-Base-Form] -->
	{~DJ:Record~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-Base-Form] -->
`
		},
		{
			// The shared clause wrapper for every filter type. The type view plugs its own
			// value input in via getFilterFormTemplate(); the themed remove control is
			// inherited here (calls the base removeClause() method, reached through the
			// always-registered PRSP-FilterType-<Type> view) so no host app re-implements one.
			Hash: 'PRSP-Filter-Base-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-Base-Template] -->
	<div class="prsp-filter" id="PRSP_Filter_Container_{~D:Record.Hash~}" data-i-filter-hash="{~D:Record.Hash~}">
		<div class="prsp-filter-body">
			{~TBR:Context[0].getFilterFormTemplate()~}
		</div>
		<button type="button" class="prsp-filter-remove" title="Remove this filter" aria-label="Remove this filter"
			onclick="_Pict.views['PRSP-FilterType-{~D:Record.Type~}'].removeClause(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Hash~}');">
			{~I:Trash~}
		</button>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-Filter-Base-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Filter_Base',
			TemplateHash: 'PRSP-Filter-Base-Template',
			DestinationAddress: '#PRSP_Filter_Base_Container',
			RenderMethod: 'replace',
		}
	],
};

class ViewRecordSetSUBSETFilterBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_SUBSET_Filter, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Hook to prepare state on the render record before rendering.
	 *
	 * @param {Record<string, any>} pRecord - The record used for view rendering.
	 */
	prepareRecord(pRecord)
	{
		pRecord.ClauseValueAddress = pRecord.ClauseAddress + '.Value';
		pRecord.ClauseValuesAddress = pRecord.ClauseAddress + '.Values';

		pRecord.ClauseDescriptor =
		{
			Address: pRecord.ClauseValueAddress,
			Hash: this.fable.DataFormat.sanitizeObjectKey(pRecord.Hash),
			//TODO: figure out a nice pattern for extracting a name for the field from the filter - and allow the filter author to provide the label here
			Name: pRecord.Label || pRecord.ExternalFilterByColumn || pRecord.ExternalFilterByColumns?.[0] || pRecord.FilterByColumn || pRecord.FilterByColumns?.[0] || 'Value',
			DataType: pRecord.DataType || 'String',
			PictForm: pRecord.PictForm || {},
		};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-Base-Form';
	}

	/**
	 * Remove this filter clause from its record set and re-render the filter control.
	 *
	 * Lives on the base view so every filter type inherits a single, themeable remove
	 * affordance and no host application has to re-implement one. Delegates to the
	 * consolidated control view (the canonical re-render path) and falls back to the
	 * record-set provider directly if that view is somehow unavailable.
	 *
	 * @param {Event} pEvent - The DOM event that triggered the removal.
	 * @param {string} pRecordSet - The record set being filtered.
	 * @param {string} pViewContext - The view context for the filter (e.g. List, Dashboard).
	 * @param {string} pHash - The hash of the specific filter clause to remove.
	 */
	removeClause(pEvent, pRecordSet, pViewContext, pHash)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
		}
		const tmpFiltersView = this.pict.views['PRSP-Filters'];
		if (tmpFiltersView && typeof tmpFiltersView.removeFilter === 'function')
		{
			return tmpFiltersView.removeFilter(pEvent, pRecordSet, pViewContext, pHash);
		}
		// Fallback: the consolidated control view isn't present, so remove directly.
		const tmpProvider = this.pict.providers[`RSP-Provider-${pRecordSet}`];
		if (tmpProvider && typeof tmpProvider.removeFilterClause === 'function')
		{
			tmpProvider.removeFilterClause(pHash);
		}
	}

	/**
	 * @return {string} - The prefix for the informary address.
	 */
	getInformaryAddressPrefix()
	{
		return this.pict.views['PRSP-Filters'].getInformaryAddressPrefix();
	}

	/**
	 * @param {string} pInformaryAddress - The address of the informary to get the value from.
	 *
	 * @return {any} - The value at the informary address.
	 */
	getInformaryScopedValue(pInformaryAddress)
	{
		return this.pict.views['PRSP-Filters'].getInformaryScopedValue(pInformaryAddress);
	}
}

module.exports = ViewRecordSetSUBSETFilterBase;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_SUBSET_Filter;

},{"pict-view":693}],645:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/**
 * BooleanMatch — a Yes / No filter for boolean columns. A boolean is stored as 0/1, so under
 * the hood the clause is an exact NumericMatch (`Type: 'NumericMatch'`, `ExactMatch: true`),
 * which pict's Filter.js compiles to `FBV(OR)~<col>~EQ~<0|1>` with no new compile-path type.
 * The clause only differs in how it is *rendered*: the generator tags it
 * `FilterRenderType: 'BooleanMatch'` so the FilterInstanceViews template routes it here (a
 * Yes/No <select>) instead of the numeric text box — see Pict-Template-FilterInstanceViews.
 *
 * Staging only: changing the dropdown mutates the live clause's `Values` but does NOT fire a
 * search — the user commits with Apply / Search (the stage-then-Apply contract, matching the
 * other filter views).
 */
const _DEFAULT_CONFIGURATION_Filter_BooleanMatch =
{
	ViewIdentifier: 'PRSP-FilterType-BooleanMatch',

	CSS: /*css*/`
.prsp-filter-boolean { min-width: 8rem; }
`,

	Templates:
	[
		{
			Hash: 'PRSP-Filter-BooleanMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-BooleanMatch-Template] -->
	<div class="prsp-filter-boolean">
		<label>{~D:Record.Label~}</label>
		<select aria-label="{~D:Record.Label~}"
			onchange="_Pict.views['PRSP-FilterType-BooleanMatch'].selectValue(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}', this.value)">
			<option value="" {~D:Record.BooleanAnySelected~}>Any</option>
			<option value="1" {~D:Record.BooleanYesSelected~}>Yes</option>
			<option value="0" {~D:Record.BooleanNoSelected~}>No</option>
		</select>
	</div>
	<!-- DefaultPackage end view template: [PRSP-Filter-BooleanMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterBooleanMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		// The current selection comes off the live clause's Values (Value as a fallback for
		// clauses restored from an older-shaped filter experience). '' => Any (no constraint).
		const tmpCurrent = (Array.isArray(pRecord.Values) && (pRecord.Values.length > 0)) ? String(pRecord.Values[0])
			: ((pRecord.Value !== undefined && pRecord.Value !== null) ? String(pRecord.Value) : '');
		pRecord.BooleanAnySelected = (tmpCurrent === '') ? 'selected' : '';
		pRecord.BooleanYesSelected = (tmpCurrent === '1') ? 'selected' : '';
		pRecord.BooleanNoSelected = (tmpCurrent === '0') ? 'selected' : '';
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-BooleanMatch-Template';
	}

	/**
	 * Stage the Yes/No selection onto the live clause. '' clears the constraint (Any); '1'/'0'
	 * set an exact match. Staging only — the search fires on Apply / Search, not here.
	 *
	 * @param {Event} pEvent
	 * @param {string} pClauseInformaryAddress
	 * @param {string} pClauseHash
	 * @param {string} pValue - '' | '1' | '0'
	 */
	selectValue(pEvent, pClauseInformaryAddress, pClauseHash, pValue)
	{
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			this.pict.log.error(`[Filter-BooleanMatch] No clause found for address: ${pClauseInformaryAddress}`);
			return;
		}
		if (pValue === '' || pValue === null || pValue === undefined)
		{
			tmpClause.Values = [];
			delete tmpClause.Value;
		}
		else
		{
			tmpClause.Values = [ pValue ];
			tmpClause.Value = pValue;
		}
	}
}

module.exports = ViewRecordSetSUBSETFilterBooleanMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterBase.default_configuration, _DEFAULT_CONFIGURATION_Filter_BooleanMatch);

},{"./RecordSet-Filter-Base":644}],646:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_DateMatch =
{
	ViewIdentifier: 'PRSP-FilterType-DateMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-DateMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-DateMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-DateMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterDateMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Hook to prepare state on the render record before rendering.
	 *
	 * @param {Record<string, any>} pRecord - The record used for view rendering.
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-DateMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterDateMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterDateMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_DateMatch);

},{"./RecordSet-Filter-Base":644}],647:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_DateRange =
{
	ViewIdentifier: 'PRSP-FilterType-DateRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-DateRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-DateRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-DateRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterDateRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	/**
	 * FIXME: this be wrong
	 *
	 * @param {(error?: Error) => void} fCallback
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		return super.onBeforeInitializeAsync((pError) =>
		{
			/** @type {import('pict/types/source/filters/FilterClauseLocal')} */
			//this.filter = this.addFilterClauseType('DateRange');

			return fCallback(pError);
		});
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-DateRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterDateRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterDateRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_DateRange);


},{"./RecordSet-Filter-Base-Range.js":643}],648:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/**
 * DistinctSelectedValueList — a dropdown/checkbox filter whose options ARE the distinct
 * values of a column on the CORE entity (no join), fetched from Meadow's
 * `<Entity>s/Distinct/<Column>` endpoint through the recordset provider's cached
 * `getRecordSetColumnDistinct()`. The clause's `Values` array holds the selection; pict's
 * Filter.js compiles it to an OR-chain of `FBVOR~<col>~EQ~<value>` stanzas inside one
 * paren group.
 *
 * Clause config:
 *   - FilterByColumn {string} - the core-entity column the options come from / filter on.
 *   - Options {Array<any>} - optional STATIC option list; when present the distinct fetch is skipped.
 *   - DistinctFilter {string} - optional FoxHound stanza appended as `/FilteredTo/<...>` on the
 *     distinct query (e.g. `FBV~Deleted~EQ~0` to keep soft-deleted rows' values out of the list).
 *
 * Selected values missing from the option list (e.g. restored from a saved filter experience
 * whose value no longer appears in the data) are unioned in so they stay visible and
 * un-checkable. Selection toggles by option INDEX, never by value — values can contain
 * quotes that would break inline onclick attributes.
 *
 * Staging only: toggling checkboxes mutates the live clause but does NOT fire a search —
 * the user commits with Apply / Search (the stage-then-Apply contract).
 */
const _DEFAULT_CONFIGURATION_Filter_DistinctSelectedValueList =
{
	ViewIdentifier: 'PRSP-FilterType-DistinctSelectedValueList',

	CSS: /*css*/`
.prsp-filter-distinct { min-width: 12rem; }
.prsp-filter-distinct-options { display: flex; flex-direction: column; gap: 0.15rem; max-height: 11rem; overflow-y: auto;
	padding: 0.35rem 0.5rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); }
.prsp-filter-distinct-option { display: flex; align-items: center; gap: 0.45rem; cursor: pointer;
	font-size: 0.92rem; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.prsp-filter-distinct-option input[type="checkbox"] { width: auto; margin: 0; cursor: pointer; }
.prsp-filter-distinct-note { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0; }
`,

	Templates:
	[
		{
			Hash: 'PRSP-Filter-DistinctSelectedValueList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-DistinctSelectedValueList-Template] -->
	<div class="prsp-filter-distinct">
		<label>{~D:Record.Label~}</label>
		<div class="prsp-filter-distinct-options">
			{~TS:PRSP-Filter-Distinct-Loading:Record.DistinctLoading~}
			{~TS:PRSP-Filter-Distinct-Empty:Record.DistinctEmpty~}
			{~TSWP:PRSP-Filter-Distinct-Option:Record.DistinctOptions:Record~}
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-Filter-DistinctSelectedValueList-Template] -->
`
		},
		{
			Hash: 'PRSP-Filter-Distinct-Option',
			Template: /*html*/`
	<label class="prsp-filter-distinct-option">
		<input type="checkbox" {~D:Record.Data.CheckedAttribute~}
			onchange="_Pict.views['PRSP-FilterType-DistinctSelectedValueList'].toggleOption(event, '{~D:Record.Payload.ClauseAddress~}', '{~D:Record.Payload.Hash~}', {~D:Record.Data.OptionIndex~})">
		<span>{~D:Record.Data.Text~}</span>
	</label>
`
		},
		{
			Hash: 'PRSP-Filter-Distinct-Loading',
			Template: /*html*/`
	<span class="prsp-filter-distinct-note">Loading values…</span>
`
		},
		{
			Hash: 'PRSP-Filter-Distinct-Empty',
			Template: /*html*/`
	<span class="prsp-filter-distinct-note">No values available.</span>
`
		},
	],
};

class ViewRecordSetSUBSETFilterDistinctSelectedValueList extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-DistinctSelectedValueList-Template';
	}

	/**
	 * The ordered raw option values for a clause: the static `Options` list when configured,
	 * else the provider's cached distinct values, with any selected values missing from the
	 * list unioned onto the end.
	 *
	 * @param {Record<string, any>} pClause
	 * @param {Record<string, any>} pProvider - The recordset provider (`RSP-Provider-<RecordSet>`).
	 * @return {Array<any>}
	 */
	_optionValues(pClause, pProvider)
	{
		let tmpValues = Array.isArray(pClause.Options) ? pClause.Options.slice() : null;
		if (!tmpValues)
		{
			const tmpCacheKey = this._distinctCacheKey(pClause, pProvider);
			const tmpCached = (pProvider && pProvider._scopeDistinctCache) ? pProvider._scopeDistinctCache[tmpCacheKey] : null;
			tmpValues = Array.isArray(tmpCached) ? tmpCached.slice() : [];
		}
		if (Array.isArray(pClause.Values))
		{
			for (const tmpSelected of pClause.Values)
			{
				if (!tmpValues.some((pValue) => pValue === tmpSelected))
				{
					tmpValues.push(tmpSelected);
				}
			}
		}
		return tmpValues;
	}

	/**
	 * This clause's static `DistinctFilter` narrowed by the current selection of every field named
	 * in `CascadeFrom` — the same rule the quick-filter bar applies, so the drawer control and the
	 * quick control always offer the same option list for a field. A parent with nothing selected
	 * narrows nothing.
	 *
	 * @param {Record<string, any>} pClause @param {Record<string, any>} pProvider
	 * @return {string} The FoxHound filter stanza chain, or '' for no filter.
	 */
	_resolveDistinctFilter(pClause, pProvider)
	{
		let tmpFilter = pClause.DistinctFilter || '';
		const tmpParentFields = Array.isArray(pClause.CascadeFrom) ? pClause.CascadeFrom : [];
		if ((tmpParentFields.length === 0) || !pProvider || (typeof pProvider.getQuickFilterEntityValue !== 'function'))
		{
			return tmpFilter;
		}
		for (const tmpParentField of tmpParentFields)
		{
			const tmpValues = pProvider.getQuickFilterEntityValue(tmpParentField);
			if (!Array.isArray(tmpValues) || (tmpValues.length === 0)) { continue; }
			// A value carrying a comma would split the IN list, so those are skipped.
			const tmpUsable = tmpValues.filter((pValue) => String(pValue).indexOf(',') === -1);
			if (tmpUsable.length === 0) { continue; }
			tmpFilter += `${tmpFilter ? '~' : ''}FBL~${tmpParentField}~INN~${tmpUsable.join(',')}`;
		}
		return tmpFilter;
	}

	/**
	 * The provider cache key for this clause's distinct values. The resolved filter is part of the
	 * key, so each parent selection caches on its own and going back to a previous one is instant.
	 *
	 * @param {Record<string, any>} pClause @param {Record<string, any>} pProvider
	 * @return {string}
	 */
	_distinctCacheKey(pClause, pProvider)
	{
		const tmpFilter = this._resolveDistinctFilter(pClause, pProvider);
		return tmpFilter ? `${pClause.FilterByColumn}::${tmpFilter}` : pClause.FilterByColumn;
	}

	/**
	 * Map the option values to render rows ({ Text, OptionIndex, CheckedAttribute }).
	 *
	 * @param {Record<string, any>} pClause
	 * @param {Record<string, any>} pProvider
	 * @return {Array<{ Text: string, OptionIndex: number, CheckedAttribute: string }>}
	 */
	_composeOptionList(pClause, pProvider)
	{
		const tmpSelected = Array.isArray(pClause.Values) ? pClause.Values : [];
		return this._optionValues(pClause, pProvider).map((pValue, pIndex) => (
		{
			Text: String(pValue),
			OptionIndex: pIndex,
			CheckedAttribute: tmpSelected.some((pSelectedValue) => pSelectedValue === pValue) ? 'checked' : '',
		}));
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecord.RecordSet];
		pRecord.DistinctLoading = [];
		// No static Options: make sure the distinct values are fetched (cached on the provider),
		// re-rendering just this clause's container once they resolve. Errored fetches cache []
		// so this can't loop.
		if (!Array.isArray(pRecord.Options) && pRecord.FilterByColumn
			&& tmpProvider && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
		{
			const tmpCacheKey = this._distinctCacheKey(pRecord, tmpProvider);
			if (!tmpProvider._scopeDistinctCache || !Array.isArray(tmpProvider._scopeDistinctCache[tmpCacheKey]))
			{
				pRecord.DistinctLoading = [ {} ];
				const tmpClauseAddress = pRecord.ClauseAddress;
				const tmpClauseHash = pRecord.Hash;
				tmpProvider.getRecordSetColumnDistinct(pRecord.FilterByColumn, { Filter: this._resolveDistinctFilter(pRecord, tmpProvider) },
					() => this._reRenderClause(tmpClauseAddress, tmpClauseHash));
			}
		}
		pRecord.DistinctOptions = this._composeOptionList(pRecord, tmpProvider);
		pRecord.DistinctEmpty = (pRecord.DistinctLoading.length === 0 && pRecord.DistinctOptions.length === 0) ? [ {} ] : [];
	}

	/**
	 * Toggle an option's membership in the live clause's `Values` by option index. Staging
	 * only — the search fires on Apply / Search, not here.
	 *
	 * @param {Event} pEvent
	 * @param {string} pClauseInformaryAddress
	 * @param {string} pClauseHash
	 * @param {number} pOptionIndex
	 */
	toggleOption(pEvent, pClauseInformaryAddress, pClauseHash, pOptionIndex)
	{
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			this.pict.log.error(`[Filter-DistinctSelectedValueList] No clause found for address: ${pClauseInformaryAddress}`);
			return;
		}
		const tmpProvider = this.pict.providers['RSP-Provider-' + tmpClause.RecordSet];
		const tmpOptionValues = this._optionValues(tmpClause, tmpProvider);
		if (pOptionIndex < 0 || pOptionIndex >= tmpOptionValues.length)
		{
			return;
		}
		const tmpValue = tmpOptionValues[pOptionIndex];
		if (!Array.isArray(tmpClause.Values))
		{
			tmpClause.Values = [];
		}
		const tmpSelectedIndex = tmpClause.Values.findIndex((pSelectedValue) => pSelectedValue === tmpValue);
		if (tmpSelectedIndex >= 0)
		{
			tmpClause.Values.splice(tmpSelectedIndex, 1);
		}
		else
		{
			tmpClause.Values.push(tmpValue);
		}
		this._reRenderClause(pClauseInformaryAddress, pClauseHash);
	}

	/**
	 * Re-render this clause's container (the checkbox list repaints on toggle / fetch resolve).
	 *
	 * @param {string} pClauseInformaryAddress
	 * @param {string} pClauseHash
	 */
	_reRenderClause(pClauseInformaryAddress, pClauseHash)
	{
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			return;
		}
		const tmpRecord = Object.assign({ ClauseAddress: pClauseInformaryAddress }, tmpClause);
		this.prepareRecord(tmpRecord);
		this.render(null, `#PRSP_Filter_Container_${pClauseHash}`, tmpRecord);
	}
}

module.exports = ViewRecordSetSUBSETFilterDistinctSelectedValueList;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterBase.default_configuration, _DEFAULT_CONFIGURATION_Filter_DistinctSelectedValueList);

},{"./RecordSet-Filter-Base":644}],649:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/**
 * Shared base for the four entity-reference filter types — Internal/External join × single/list.
 *
 * These were ~95% duplicate views, each with the same bespoke "search results | selection" table UI
 * and identical search/add/remove logic. This base consolidates all of it. Subclasses supply only the
 * two seams that actually differ:
 *   - `getSearchEntity(pClause)` — internal join searches `RemoteTable`, external `ExternalFilterByTable`.
 *   - `isMultiSelect()` — the `…List` variants append; the plain `…SelectedValue` variants replace.
 *
 * Rendering uses the same mechanism as before (the input template is emitted during the clause's
 * template parse, via `getFilterFormTemplate()`), so the consolidation is behavior-preserving. The
 * input template is itself a seam (`getEntityInputTemplate()`) so a host can swap the table UI for a
 * picker-backed input (a pict-section-form `Picker` InputType) without the module changing.
 *
 * Host-injected contextual scoping rides through `getContextScopeFilter(pClause)` — extra FoxHound
 * stanzas AND-applied to the entity search (project / spec-year / …). The module never learns what
 * those contexts mean; the host overrides the hook to read its own app state.
 */
const _DEFAULT_CONFIGURATION_EntityReference =
{
	ViewIdentifier: 'PRSP-FilterType-EntityReference-Base',

	// When set (by a host), entity clauses delegate their input to this pict-section-form InputType
	// (rendered via {~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}) instead of the built-in
	// table UI — e.g. 'Picker' to use pict-section-picker. Default false → the table UI.
	EntityInputType: false,

	Templates:
	[
		{
			// Table UI (default). Two cells: live search results | current selection.
			Hash: 'PRSP-Filter-EntityRef-Table',
			Template: /*html*/`
	<table><tbody><tr>
		<td valign="top">{~T:PRSP-Filter-EntityRef-SearchResults~}</td>
		<td valign="top">{~T:PRSP-Filter-EntityRef-SelectedValues~}</td>
	</tr></tbody></table>
`
		},
		{
			// Picker / form-input delegation (opt-in via EntityInputType). Renders one dynamic input
			// on the shared PSRSFilterProxyView from the clause's ClauseDescriptor (whose PictForm
			// InputType is stamped in prepareRecord). Bound to the clause's Values address.
			Hash: 'PRSP-Filter-EntityRef-Input',
			Template: /*html*/`
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SearchResults',
			Template: /*html*/`
	<form id="PRSP_Filter_{~D:Record.Hash~}_Search_Form" onsubmit="_Pict.views['{~D:Context[0].Hash~}'].performSearch(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}'); return false;">
		<input id="PRSP_Filter_{~D:Record.Hash~}_Search_Value" type="text" placeholder="Search..." value="{~D:Record.SearchInputValue~}" />
		<button type="submit" id="PRSP_Filter_{~D:Record.Hash~}_Button_Search" onclick="_Pict.views['{~D:Context[0].Hash~}'].performSearch(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}')">Search</button>
	</form>
	<table>
		<thead><tr><th colspan="2">{~D:Record.Label~}</th></tr></thead>
		<tbody>{~TSWP:PRSP-Filter-EntityRef-SearchResults-Entry:Record.SearchResults:Record~}</tbody>
	</table>
	<button type="button" id="PRSP_Filter_{~D:Record.Hash~}_Button_LoadMore" class="is-hidden" onclick="_Pict.views['{~D:Context[0].Hash~}'].loadMore(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}', {~D:Record.SearchResultsOffset:0~})">Load More</button>
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SelectedValues',
			Template: /*html*/`
	<table>
		<thead><tr><th colspan="2">Selection</th></tr></thead>
		<tbody>{~TSWP:PRSP-Filter-EntityRef-SelectedValues-Entry:Record.SelectedValues:Record~}</tbody>
	</table>
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SearchResults-Entry',
			Template: /*html*/`
	<tr><td><button onclick="_Pict.views['{~D:Context[0].Hash~}'].handleAdd(event, {~DVBK:Record.Data:Record.Payload.ExternalFilterTableLookupColumn~}, '{~D:Record.Payload.ClauseAddress~}', '{~D:Record.Payload.Hash~}')">Select</button></td><td>{~TFA:Record.Payload.ExternalRecordDisplayTemplate:Record~}</td></tr>
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SelectedValues-Entry',
			Template: /*html*/`
	<tr><td><button onclick="_Pict.views['{~D:Context[0].Hash~}'].handleRemove(event, {~DVBK:Record.Data:Record.Payload.ExternalFilterTableLookupColumn~}, '{~D:Record.Payload.ClauseAddress~}', '{~D:Record.Payload.Hash~}')">Remove</button></td><td>{~TFA:Record.Payload.ExternalRecordDisplayTemplate:Record~}</td></tr>
`
		},
	],
};

class ViewRecordSetSUBSETFilterEntityReferenceBase extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions.PageSize)
		{
			pOptions.PageSize = 15;
		}
		super(pFable, pOptions, pServiceHash);
	}

	// --- Seams the subclasses override (the only real differences between the 4 types) ---

	/** @param {Record<string, any>} pClause @return {string} The entity to search (RemoteTable / ExternalFilterByTable). */
	getSearchEntity(pClause)
	{
		return pClause.RemoteTable || pClause.ExternalFilterByTable;
	}

	/** @param {Record<string, any>} pClause @return {string} The value/ID column on the searched entity. */
	getLookupColumn(pClause)
	{
		return pClause.ExternalFilterTableLookupColumn || `ID${this.getSearchEntity(pClause)}`;
	}

	/** @return {boolean} True for the `…List` (multi-select) variants. */
	isMultiSelect()
	{
		return true;
	}

	/**
	 * Host-injectable contextual search scope. Returns extra FoxHound filter stanza(s) AND-applied to
	 * the entity search (e.g. "only this project's line items"). Default: the clause's static
	 * `ContextScopeFilter` if any, else none. Hosts override this to read app state — the module never
	 * learns what a "project" or "spec year" is.
	 *
	 * @param {Record<string, any>} pClause @return {string|Array<string>}
	 */
	getContextScopeFilter(pClause)
	{
		// ScopeToRecordSet knob: scope the entity search to the values present in the recordset's
		// data (FBL~<col>~INN~<distinct>), fetched + cached on the recordset provider. The first
		// search may be unscoped until the fetch resolves; subsequent searches are scoped.
		if (pClause && pClause.ScopeToRecordSet && pClause.FilterByColumn)
		{
			const tmpProvider = this.pict.providers['RSP-Provider-' + pClause.RecordSet];
			if (tmpProvider && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
			{
				if (!tmpProvider._scopeDistinctCache || !Array.isArray(tmpProvider._scopeDistinctCache[pClause.FilterByColumn]))
				{
					tmpProvider.getRecordSetColumnDistinct(pClause.FilterByColumn, () => {});
				}
				const tmpVals = (tmpProvider._scopeDistinctCache || {})[pClause.FilterByColumn];
				if (Array.isArray(tmpVals) && tmpVals.length > 0)
				{
					return `FBL~${pClause.FilterByColumn}~INN~${tmpVals.join(',')}`;
				}
			}
		}
		return pClause.ContextScopeFilter || '';
	}

	/** @return {string} The template hash for the clause's value input (table UI, or the opt-in delegated input). */
	getFilterFormTemplate()
	{
		return this.options.EntityInputType ? 'PRSP-Filter-EntityRef-Input' : 'PRSP-Filter-EntityRef-Table';
	}

	/** @param {Record<string, any>} pRecord */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.PictForm = Object.assign({}, pRecord.PictForm);
		if (this.options.EntityInputType)
		{
			// Delegated input: a csv string round-trips through the informary at `.StringArrayValue`,
			// while the picker adapter writes the real ARRAY to `.Values` (what Filter.js reads) via
			// ValueArrayAddress. Keeping the informary off `.Values` avoids a Number field defaulting it
			// to "0". The descriptor also carries everything the picker needs + the contextual scope hook.
			pRecord.ClauseDescriptor.Address = pRecord.ClauseAddress + '.StringArrayValue';
			pRecord.ClauseDescriptor.DataType = 'String';
			pRecord.ClauseDescriptor.PictForm.InputType = pRecord.ClauseDescriptor.PictForm.InputType || this.options.EntityInputType;
			pRecord.ClauseDescriptor.PictForm.Entity = pRecord.ClauseDescriptor.PictForm.Entity || this.getSearchEntity(pRecord);
			pRecord.ClauseDescriptor.PictForm.ValueField = pRecord.ClauseDescriptor.PictForm.ValueField || this.getLookupColumn(pRecord);
			pRecord.ClauseDescriptor.PictForm.Multiple = this.isMultiSelect();
			pRecord.ClauseDescriptor.PictForm.SearchFields = pRecord.ClauseDescriptor.PictForm.SearchFields
				|| pRecord.ExternalFilterByColumns || (pRecord.ExternalFilterByColumn ? [ pRecord.ExternalFilterByColumn ] : [ 'Name' ]);
			// Composed, disambiguated option/chip label (the entity's "list entry" template); falls back to a
			// single display field when unset.
			pRecord.ClauseDescriptor.PictForm.TextTemplate = pRecord.ClauseDescriptor.PictForm.TextTemplate || pRecord.EntityListEntryTemplate;
			pRecord.ClauseDescriptor.PictForm.ValueArrayAddress = pRecord.ClauseValuesAddress;
			pRecord.ClauseDescriptor.PictForm.GetContextScopeFilter = () => this.getContextScopeFilter(this.getInformaryScopedValue(pRecord.ClauseAddress) || pRecord);
			// JoinEntity compound display (host opt-in on the clause): show each searched row joined to a
			// parent entity's field — e.g. a LineItem disambiguated by its Project. The picker fetch-then-
			// merges the join (Meadow can't join in one read). Forwarded straight through; no-op when unset.
			if (pRecord.JoinEntity || pRecord.ClauseDescriptor.PictForm.JoinEntity)
			{
				const tmpPF = pRecord.ClauseDescriptor.PictForm;
				tmpPF.JoinEntity = tmpPF.JoinEntity || pRecord.JoinEntity;
				tmpPF.JoinField = tmpPF.JoinField || pRecord.JoinField;
				tmpPF.JoinEntityValueField = tmpPF.JoinEntityValueField || pRecord.JoinEntityValueField;
				tmpPF.JoinEntityDisplayField = tmpPF.JoinEntityDisplayField || pRecord.JoinEntityDisplayField;
				if (tmpPF.JoinEntityFirst === undefined && pRecord.JoinEntityFirst !== undefined) { tmpPF.JoinEntityFirst = pRecord.JoinEntityFirst; }
				if (tmpPF.JoinSeparator === undefined && pRecord.JoinSeparator !== undefined) { tmpPF.JoinSeparator = pRecord.JoinSeparator; }
			}
			// Saved-filter seeding: mirror the live clause's Values array into the csv `.StringArrayValue`
			// the input reads, so a reloaded/persisted filter shows its current selections on render.
			const tmpLiveClause = this.getInformaryScopedValue(pRecord.ClauseAddress);
			if (tmpLiveClause && Array.isArray(tmpLiveClause.Values))
			{
				tmpLiveClause.StringArrayValue = tmpLiveClause.Values.join(',');
			}
		}
		else
		{
			pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		}
		if (!pRecord.ExternalFilterTableLookupColumn)
		{
			pRecord.ExternalFilterTableLookupColumn = this.getLookupColumn(pRecord);
		}
		if (!pRecord.SearchResults) { pRecord.SearchResults = []; }
		if (!pRecord.SelectedValues) { pRecord.SelectedValues = []; }
	}

	// --- Table UI search/select methods (consolidated from the 4 legacy views) ---

	loadMore(pEvent, pClauseInformaryAddress, pClauseHash, pCurrentOffset = 0)
	{
		this.performSearch(pEvent, pClauseInformaryAddress, pClauseHash, pCurrentOffset + this.options.PageSize);
	}

	performSearch(pEvent, pClauseInformaryAddress, pClauseHash, pOffset = 0)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			this.pict.log.error(`[Filter-EntityReference] No clause found for address: ${pClauseInformaryAddress}`);
			return;
		}
		tmpClause.SearchResultsOffset = pOffset;
		const tmpSearchInputValue = pOffset > 0 ? tmpClause.SearchInputValue : this.pict.ContentAssignment.readContent(`#PRSP_Filter_${tmpClause.Hash}_Search_Value`);
		tmpClause.SearchInputValue = tmpSearchInputValue;
		if (!tmpSearchInputValue)
		{
			tmpClause.SearchResults = [];
			tmpClause.LoadMoreEnabled = false;
			this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
			return;
		}
		const tmpFilterByColumns = tmpClause.ExternalFilterByColumns || (tmpClause.ExternalFilterByColumn ? [ tmpClause.ExternalFilterByColumn ] : [ 'Name' ]);
		const tmpSearchStanza = tmpFilterByColumns.map((pColumn) => `FBVOR~${pColumn}~LK~${encodeURIComponent(`%${tmpSearchInputValue}%`)}`).join('~');
		const tmpScope = this.getContextScopeFilter(tmpClause);
		const tmpScopeStanza = Array.isArray(tmpScope) ? tmpScope.filter(Boolean).join('~') : tmpScope;
		const tmpMeadowFilter = [ tmpScopeStanza, tmpSearchStanza ].filter(Boolean).join('~');
		this.pict.EntityProvider.gatherDataFromServer(
			[
				{
					Entity: this.getSearchEntity(tmpClause),
					Filter: tmpMeadowFilter,
					Destination: pOffset > 0 ? `${this.getInformaryAddressPrefix()}${pClauseInformaryAddress}.SearchResultsAppend` : `${this.getInformaryAddressPrefix()}${pClauseInformaryAddress}.SearchResults`,
					RecordStartCursor: pOffset,
					PageSize: this.options.PageSize,
					URLPrefix: tmpClause.URLPrefix,
				}
			],
			() =>
			{
				if (pOffset > 0 && tmpClause.SearchResultsAppend?.length > 0)
				{
					tmpClause.SearchResults = tmpClause.SearchResults.concat(tmpClause.SearchResultsAppend);
				}
				const tmpLoadedRecords = pOffset > 0 ? tmpClause.SearchResultsAppend : tmpClause.SearchResults;
				delete tmpClause.SearchResultsAppend;
				tmpClause.SearchResultsOffset = pOffset;
				tmpClause.LoadMoreEnabled = tmpLoadedRecords && tmpLoadedRecords.length >= this.options.PageSize;
				this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
				if (tmpClause.LoadMoreEnabled)
				{
					this.pict.ContentAssignment.removeClass(`#PRSP_Filter_${tmpClause.Hash}_Button_LoadMore`, 'is-hidden');
				}
			});
	}

	handleAdd(pEvent, pRecordLookupValue, pClauseInformaryAddress, pClauseHash)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause) { return; }
		const tmpRecordLookupColumn = this.getLookupColumn(tmpClause);
		const tmpRecordToAdd = (tmpClause.SearchResults || []).find((pRow) => pRow[tmpRecordLookupColumn] == pRecordLookupValue);
		if (!tmpRecordToAdd) { return; }
		const tmpValue = tmpRecordToAdd[tmpRecordLookupColumn];
		if (tmpValue == null) { return; }
		if (!tmpClause.SelectedValues) { tmpClause.SelectedValues = []; }
		if (!tmpClause.Values) { tmpClause.Values = []; }
		if (this.isMultiSelect())
		{
			if (tmpClause.SelectedValues.some((pSV) => pSV[tmpRecordLookupColumn] == pRecordLookupValue)) { return; }
			tmpClause.SelectedValues.push(tmpRecordToAdd);
			if (!tmpClause.Values.some((pV) => pV == tmpValue)) { tmpClause.Values.push(tmpValue); }
		}
		else
		{
			tmpClause.SelectedValues = [ tmpRecordToAdd ];
			tmpClause.Values = [ tmpValue ];
		}
		this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
	}

	handleRemove(pEvent, pRecordLookupValue, pClauseInformaryAddress, pClauseHash)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause) { return; }
		const tmpRecordLookupColumn = this.getLookupColumn(tmpClause);
		const tmpIndex = (tmpClause.SelectedValues || []).findIndex((pRow) => pRow[tmpRecordLookupColumn] == pRecordLookupValue);
		if (tmpIndex < 0) { return; }
		const tmpRemoved = tmpClause.SelectedValues.splice(tmpIndex, 1)[0];
		const tmpValue = tmpRemoved[tmpRecordLookupColumn];
		tmpClause.Values = (tmpClause.Values || []).filter((pV) => pV !== tmpValue);
		this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
	}

	/** Re-render a clause's container (the table UI re-paints on every search / add / remove). */
	_reRenderClause(pClause, pClauseInformaryAddress, pClauseHash)
	{
		const tmpRecord = Object.assign({ ClauseAddress: pClauseInformaryAddress }, pClause);
		this.prepareRecord(tmpRecord);
		this.render(null, `#PRSP_Filter_Container_${pClauseHash}`, tmpRecord);
	}
}

module.exports = ViewRecordSetSUBSETFilterEntityReferenceBase;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterBase.default_configuration, _DEFAULT_CONFIGURATION_EntityReference);

},{"./RecordSet-Filter-Base":644}],650:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateMatch =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinDateMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-DateMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-DateMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-DateMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinDateMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Hook to prepare state on the render record before rendering.
	 *
	 * @param {Record<string, any>} pRecord - The record used for view rendering.
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-DateMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinDateMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinDateMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateMatch);

},{"./RecordSet-Filter-Base":644}],651:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateRange =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinDateRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-DateRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-DateRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-DateRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinDateRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-DateRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinDateRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinDateRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateRange);

},{"./RecordSet-Filter-Base-Range.js":643}],652:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericMatch =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinNumericMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-NumericMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-NumericMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-NumericMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinNumericMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-NumericMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinNumericMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinNumericMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericMatch);

},{"./RecordSet-Filter-Base":644}],653:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericRange =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinNumericRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-NumericRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-NumericRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-NumericRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinNumericRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-NumericRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinNumericRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinNumericRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericRange);

},{"./RecordSet-Filter-Base-Range.js":643}],654:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// External-join (through a junction table), single-select entity-reference filter. Shared base;
// entity seam = ExternalFilterByTable, single-select (replace, not append).
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinSelectedValue',
};

class ViewRecordSetSUBSETFilterExternalJoinSelectedValue extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.ExternalFilterByTable;
	}

	isMultiSelect()
	{
		return false;
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinSelectedValue;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":649}],655:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// External-join (through a junction table), multi-select entity-reference filter. Shared base;
// entity seam = ExternalFilterByTable.
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinSelectedValueList',
};

class ViewRecordSetSUBSETFilterExternalJoinSelectedValueList extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.ExternalFilterByTable;
	}

	isMultiSelect()
	{
		return true;
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinSelectedValueList;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":649}],656:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoinStringMatch =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinStringMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoinStringMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoinStringMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoinStringMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinStringMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoinStringMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinStringMatch;
module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinStringMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoinStringMatch);


},{"./RecordSet-Filter-Base.js":644}],657:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_StringRange =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinStringRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-StringRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-StringRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-StringRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinStringRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-StringRange';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinStringRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinStringRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_StringRange);

},{"./RecordSet-Filter-Base-Range.js":643}],658:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateMatch =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinDateMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-DateMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-DateMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-DateMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinDateMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-DateMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinDateMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinDateMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateMatch);

},{"./RecordSet-Filter-Base":644}],659:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateRange =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinDateRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-DateRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-DateRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-DateRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinDateRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-DateRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinDateRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinDateRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateRange);

},{"./RecordSet-Filter-Base-Range.js":643}],660:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericMatch =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinNumericMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-NumericMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-NumericMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-NumericMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinNumericMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-NumericMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinNumericMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinNumericMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericMatch);

},{"./RecordSet-Filter-Base":644}],661:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericRange =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinNumericRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-NumericRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-NumericRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-NumericRange-Template] -->
`
		},
	],
};

class ViewRecordSetSUBSETFilterInternalJoinNumericRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-NumericRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinNumericRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinNumericRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericRange);

},{"./RecordSet-Filter-Base-Range.js":643}],662:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// Internal-join, single-select entity-reference filter. Shared base; entity seam = RemoteTable,
// single-select (replace, not append).
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinSelectedValue',
};

class ViewRecordSetSUBSETFilterInternalJoinSelectedValue extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.RemoteTable;
	}

	isMultiSelect()
	{
		return false;
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinSelectedValue;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":649}],663:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// Internal-join, multi-select entity-reference filter. All behavior lives in the shared base; this
// only names the view type and points the entity seam at RemoteTable.
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinSelectedValueList',
};

class ViewRecordSetSUBSETFilterInternalJoinSelectedValueList extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.RemoteTable;
	}

	isMultiSelect()
	{
		return true;
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinSelectedValueList;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":649}],664:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringMatch =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinStringMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-StringMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-StringMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-StringMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinStringMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-StringMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinStringMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinStringMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringMatch);

},{"./RecordSet-Filter-Base":644}],665:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringRange =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinStringRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-StringRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-StringRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-StringRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinStringRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-StringRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinStringRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinStringRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringRange);

},{"./RecordSet-Filter-Base-Range.js":643}],666:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_NumericMatch =
{
	ViewIdentifier: 'PRSP-FilterType-NumericMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-NumericMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-NumericMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-NumericMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterNumericMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-NumericMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterNumericMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterNumericMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_NumericMatch);

},{"./RecordSet-Filter-Base":644}],667:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_NumericRange =
{
	ViewIdentifier: 'PRSP-FilterType-NumericRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-NumericRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-NumericRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-NumericRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterNumericRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-NumericRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterNumericRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterNumericRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_NumericRange);

},{"./RecordSet-Filter-Base-Range.js":643}],668:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_StringMatch =
{
	ViewIdentifier: 'PRSP-FilterType-StringMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-StringMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-StringMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-StringMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterStringMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-StringMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterStringMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterStringMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_StringMatch);

},{"./RecordSet-Filter-Base":644}],669:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_StringRange =
{
	ViewIdentifier: 'PRSP-FilterType-StringRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-StringRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-StringRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-StringRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterStringRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-StringRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterStringRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterStringRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_StringRange);

},{"./RecordSet-Filter-Base-Range.js":643}],670:[function(require,module,exports){

module.exports =
{
	Base: require('./RecordSet-Filter-Base.js'),

	DateMatch: require('./RecordSet-Filter-DateMatch.js'),
	DateRange: require('./RecordSet-Filter-DateRange.js'),
	NumericMatch: require('./RecordSet-Filter-NumericMatch.js'),
	NumericRange: require('./RecordSet-Filter-NumericRange.js'),
	BooleanMatch: require('./RecordSet-Filter-BooleanMatch.js'),
	StringMatch: require('./RecordSet-Filter-StringMatch.js'),
	StringRange: require('./RecordSet-Filter-StringRange.js'),

	DistinctSelectedValueList: require('./RecordSet-Filter-DistinctSelectedValueList.js'),

	InternalJoinDateMatch: require('./RecordSet-Filter-InternalJoinDateMatch.js'),
	InternalJoinDateRange: require('./RecordSet-Filter-InternalJoinDateRange.js'),
	InternalJoinNumericMatch: require('./RecordSet-Filter-InternalJoinNumericMatch.js'),
	InternalJoinNumericRange: require('./RecordSet-Filter-InternalJoinNumericRange.js'),
	InternalJoinStringMatch: require('./RecordSet-Filter-InternalJoinStringMatch.js'),
	InternalJoinStringRange: require('./RecordSet-Filter-InternalJoinStringRange.js'),
	InternalJoinSelectedValue: require('./RecordSet-Filter-InternalJoinSelectedValue.js'),
	InternalJoinSelectedValueList: require('./RecordSet-Filter-InternalJoinSelectedValueList.js'),

	ExternalJoinDateMatch: require('./RecordSet-Filter-ExternalJoinDateMatch.js'),
	ExternalJoinDateRange: require('./RecordSet-Filter-ExternalJoinDateRange.js'),
	ExternalJoinNumericMatch: require('./RecordSet-Filter-ExternalJoinNumericMatch.js'),
	ExternalJoinNumericRange: require('./RecordSet-Filter-ExternalJoinNumericRange.js'),
	ExternalJoinStringMatch: require('./RecordSet-Filter-ExternalJoinStringMatch.js'),
	ExternalJoinStringRange: require('./RecordSet-Filter-ExternalJoinStringRange.js'),
	ExternalJoinSelectedValue: require('./RecordSet-Filter-ExternalJoinSelectedValue.js'),
	ExternalJoinSelectedValueList: require('./RecordSet-Filter-ExternalJoinSelectedValueList.js'),
};


},{"./RecordSet-Filter-Base.js":644,"./RecordSet-Filter-BooleanMatch.js":645,"./RecordSet-Filter-DateMatch.js":646,"./RecordSet-Filter-DateRange.js":647,"./RecordSet-Filter-DistinctSelectedValueList.js":648,"./RecordSet-Filter-ExternalJoinDateMatch.js":650,"./RecordSet-Filter-ExternalJoinDateRange.js":651,"./RecordSet-Filter-ExternalJoinNumericMatch.js":652,"./RecordSet-Filter-ExternalJoinNumericRange.js":653,"./RecordSet-Filter-ExternalJoinSelectedValue.js":654,"./RecordSet-Filter-ExternalJoinSelectedValueList.js":655,"./RecordSet-Filter-ExternalJoinStringMatch.js":656,"./RecordSet-Filter-ExternalJoinStringRange.js":657,"./RecordSet-Filter-InternalJoinDateMatch.js":658,"./RecordSet-Filter-InternalJoinDateRange.js":659,"./RecordSet-Filter-InternalJoinNumericMatch.js":660,"./RecordSet-Filter-InternalJoinNumericRange.js":661,"./RecordSet-Filter-InternalJoinSelectedValue.js":662,"./RecordSet-Filter-InternalJoinSelectedValueList.js":663,"./RecordSet-Filter-InternalJoinStringMatch.js":664,"./RecordSet-Filter-InternalJoinStringRange.js":665,"./RecordSet-Filter-NumericMatch.js":666,"./RecordSet-Filter-NumericRange.js":667,"./RecordSet-Filter-StringMatch.js":668,"./RecordSet-Filter-StringRange.js":669}],671:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The list's column chooser: a small right-aligned "Columns" button above the table that opens a
 * popover of checkbox rows — the host-curated columns first, then the entity's remaining scalar
 * schema columns — letting the user show/hide columns per record set. Choices persist through the
 * ColumnDataProvider and repaint body-only through the list view (the filter bar is never touched).
 *
 * Renders nothing unless the active record set's configuration sets RecordSetListColumnChooser: true
 * (the list view only populates Record.ColumnChooserSlot when the flag is on).
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_ColumnChooser = (
	{
		ViewIdentifier: 'PRSP-List-ColumnChooser',

		DefaultRenderable: 'PRSP_Renderable_ColumnChooser',
		DefaultDestinationAddress: '#PRSP_ColumnChooser_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		// Mirrors the add-filter popover chrome (fixed + JS-positioned so no ancestor overflow can
		// clip it; transparent backdrop catches outside clicks) with its own class namespace.
		CSS: /*css*/`
	.prsp-colchooser-bar { display: flex; justify-content: flex-end; margin: 0 0 0.35rem; }
	.prsp-colchooser-trigger { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.88rem;
		padding: 0.3rem 0.65rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px;
		background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
	.prsp-colchooser-trigger:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
	.prsp-colchooser-pop { position: fixed; z-index: 30; min-width: 260px; max-width: 340px; display: none; }
	.prsp-colchooser-pop.open { display: block; }
	.prsp-colchooser-backdrop { position: fixed; inset: 0; z-index: 0; }
	.prsp-colchooser-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(70vh, 460px);
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
		border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
	.prsp-colchooser-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.prsp-colchooser-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
	.prsp-colchooser-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
	.prsp-colchooser-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem 0; }
	.prsp-colchooser-empty { padding: 0.7rem 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; }
	.prsp-colchooser-group { padding: 0.45rem 0.8rem 0.2rem; font-size: 0.72rem; font-weight: 650; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); }
	.prsp-colchooser-row { display: flex; align-items: center; gap: 0.5rem; width: 100%; font: inherit; font-size: 0.9rem; text-align: left; cursor: pointer;
		padding: 0.4rem 0.8rem; border: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
	.prsp-colchooser-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
	.prsp-colchooser-check { display: inline-flex; flex: 0 0 auto; font-size: 0.85rem; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
	.prsp-colchooser-row.is-checked .prsp-colchooser-check { visibility: visible; }
	.prsp-colchooser-footer { flex: 0 0 auto; display: flex; justify-content: flex-end; padding: 0.45rem 0.7rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.prsp-colchooser-reset { font: inherit; font-size: 0.84rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
	.prsp-colchooser-reset:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eceef2); }
	`,
		CSSPriority: 500,

		Templates:
		[
			{
				// The {~V:~} slot in PRSP-List-Template renders this with the full list data as Record;
				// the one-or-zero-element ColumnChooserSlot array gates the whole control on the
				// RecordSetListColumnChooser flag with no JS branch.
				Hash: 'PRSP-List-ColumnChooser-Template',
				Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-ColumnChooser-Template] -->
	{~TS:PRSP-List-ColumnChooser-Button:Record.ColumnChooserSlot~}
	<!-- DefaultPackage end view template:  [PRSP-List-ColumnChooser-Template] -->
`
			},
			{
				Hash: 'PRSP-List-ColumnChooser-Button',
				Template: /*html*/`
	<div class="prsp-colchooser-bar">
		<button type="button" class="prsp-colchooser-trigger" id="PRSP_ColumnChooser_Trigger" title="Choose which columns to show" onclick="_Pict.views['PRSP-List-ColumnChooser'].toggleColumnChooser(event, '{~D:Record.RecordSet~}')">{~I:Settings~} Columns</button>
		<div class="prsp-colchooser-pop" id="PRSP_ColumnChooser_Popover"></div>
	</div>
`
			},
			{
				Hash: 'PRSP-ColumnChooser-Popover',
				Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-ColumnChooser-Popover] -->
	<div class="prsp-colchooser-backdrop" onclick="_Pict.views['PRSP-List-ColumnChooser'].closeColumnChooser()"></div>
	<div class="prsp-colchooser-panel">
		<div class="prsp-colchooser-search">
			<span class="prsp-colchooser-search-ic">{~I:Search~}</span>
			<input type="text" id="PRSP_ColumnChooser_Search" placeholder="Search columns…" autocomplete="off" value="{~D:AppData.PRSPColumnChooser.Search~}" oninput="_Pict.views['PRSP-List-ColumnChooser'].searchColumnChooser(this.value)" onkeydown="if (event.key === 'Escape') { event.preventDefault(); _Pict.views['PRSP-List-ColumnChooser'].closeColumnChooser(); }">
		</div>
		<div class="prsp-colchooser-list" id="PRSP_ColumnChooser_List">
			{~T:PRSP-ColumnChooser-List~}
		</div>
		<div class="prsp-colchooser-footer">
			<button type="button" class="prsp-colchooser-reset" onclick="_Pict.views['PRSP-List-ColumnChooser'].resetColumns()">Reset to defaults</button>
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-ColumnChooser-Popover] -->
`
			},
			{
				Hash: 'PRSP-ColumnChooser-List',
				Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-ColumnChooser-List] -->
	{~TS:PRSP-ColumnChooser-Row:AppData.PRSPColumnChooser.CuratedRows~}
	{~NE:AppData.PRSPColumnChooser.HasSchemaRows^<div class="prsp-colchooser-group">More columns</div>~}
	{~TS:PRSP-ColumnChooser-Row:AppData.PRSPColumnChooser.SchemaRows~}
	{~NE:AppData.PRSPColumnChooser.HasAuditRows^<div class="prsp-colchooser-group">Audit columns</div>~}
	{~TS:PRSP-ColumnChooser-Row:AppData.PRSPColumnChooser.AuditRows~}
	{~NE:AppData.PRSPColumnChooser.IsEmpty^<div class="prsp-colchooser-empty">No columns found.</div>~}
	<!-- DefaultPackage end view template: [PRSP-ColumnChooser-List] -->
`
			},
			{
				Hash: 'PRSP-ColumnChooser-Row',
				Template: /*html*/`
	<button type="button" class="prsp-colchooser-row {~D:Record.CheckedClass~}" onclick="_Pict.views['PRSP-List-ColumnChooser'].toggleColumn('{~D:Record.Key~}')">
		<span class="prsp-colchooser-check">{~I:Check~}</span>
		<span class="prsp-colchooser-name">{~D:Record.DisplayName~}</span>
	</button>
`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_ColumnChooser',
				TemplateHash: 'PRSP-List-ColumnChooser-Template',
				ContentDestinationAddress: '#PRSP_ColumnChooser_Container',
				RenderMethod: 'replace'
			},
			{
				RenderableHash: 'PRSP_ColumnChooser_Popover',
				TemplateHash: 'PRSP-ColumnChooser-Popover',
				ContentDestinationAddress: '#PRSP_ColumnChooser_Popover',
				RenderMethod: 'replace'
			},
			{
				RenderableHash: 'PRSP_ColumnChooser_List',
				TemplateHash: 'PRSP-ColumnChooser-List',
				ContentDestinationAddress: '#PRSP_ColumnChooser_List',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetListColumnChooser extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_ColumnChooser, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._chooserRecordSet = null;
		this._chooserSearch = '';
	}

	/**
	 * Open/close the chooser popover (the trigger button's handler).
	 *
	 * Open/closed is derived from the popover's DOM class, not an instance flag — a full list
	 * re-render replaces the popover element (visually closed), so a flag would go stale and
	 * demand a double-click to reopen.
	 *
	 * @param {Event} pEvent - The DOM click event
	 * @param {string} pRecordSet - The record set whose columns to manage
	 */
	toggleColumnChooser(pEvent, pRecordSet)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpPopoverElements = this.pict.ContentAssignment.getElement('#PRSP_ColumnChooser_Popover');
		if (tmpPopoverElements.length && tmpPopoverElements[0].classList.contains('open'))
		{
			return this.closeColumnChooser();
		}
		this._chooserRecordSet = pRecordSet;
		this._chooserSearch = '';
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_Popover', undefined, { RecordSet: pRecordSet });
		this._paintColumnChooserOpenState(true);
	}

	/** Close the chooser popover. */
	closeColumnChooser()
	{
		this._paintColumnChooserOpenState(false);
	}

	/**
	 * Filter the chooser's column list by a search term, re-rendering only the list so the
	 * search input keeps focus.
	 * @param {string} pValue - The search term.
	 */
	searchColumnChooser(pValue)
	{
		this._chooserSearch = pValue || '';
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_List', undefined, { RecordSet: this._chooserRecordSet });
	}

	/**
	 * Flip a column's visibility (a chooser row's handler). Delegates to the list view — which
	 * persists the override and repaints the rows body-only — then repaints the chooser rows
	 * truthfully (the list view may have refused, e.g. hiding the last visible column).
	 * @param {string} pKey - The column key to toggle.
	 */
	toggleColumn(pKey)
	{
		const tmpListView = this.pict.views['RSP-RecordSet-List'];
		if (!tmpListView || !tmpListView._lastRecordListData || !Array.isArray(tmpListView._lastRecordListData.ColumnCandidates))
		{
			return;
		}
		const tmpCandidate = tmpListView._lastRecordListData.ColumnCandidates.find((pCandidate) => pCandidate.Key === pKey);
		if (!tmpCandidate)
		{
			return;
		}
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		const tmpOverrides = tmpColumnProvider ? tmpColumnProvider.getColumnVisibilityOverrides(this._chooserRecordSet, 'List') : {};
		const tmpCurrentlyVisible = tmpListView._effectiveColumnVisibility(tmpCandidate, tmpOverrides);
		tmpListView.setColumnVisibility(this._chooserRecordSet, pKey, !tmpCurrentlyVisible);
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_List', undefined, { RecordSet: this._chooserRecordSet });
	}

	/** Clear all overrides for the record set and repaint with default visibility (footer button). */
	resetColumns()
	{
		const tmpListView = this.pict.views['RSP-RecordSet-List'];
		if (!tmpListView)
		{
			return;
		}
		tmpListView.resetColumnVisibility(this._chooserRecordSet);
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_List', undefined, { RecordSet: this._chooserRecordSet });
	}

	/**
	 * (Re)build the chooser's row models into AppData from the list view's pristine column
	 * candidates (single source of truth) + the current overrides, honouring the search term.
	 */
	_buildColumnChooserRows()
	{
		const tmpListView = this.pict.views['RSP-RecordSet-List'];
		const tmpListData = tmpListView && tmpListView._lastRecordListData;
		const tmpCandidates = (tmpListData && tmpListData.RecordSet === this._chooserRecordSet && Array.isArray(tmpListData.ColumnCandidates))
			? tmpListData.ColumnCandidates : [];
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		const tmpOverrides = tmpColumnProvider ? tmpColumnProvider.getColumnVisibilityOverrides(this._chooserRecordSet, 'List') : {};
		const tmpSearch = (this._chooserSearch || '').toLowerCase();
		const fSearchMatch = (pCandidate) => !tmpSearch || String(pCandidate.DisplayName || pCandidate.Key).toLowerCase().includes(tmpSearch);
		const fMapRow = (pCandidate) => (
			{
				Key: pCandidate.Key,
				DisplayName: pCandidate.DisplayName || pCandidate.Key,
				CheckedClass: tmpListView._effectiveColumnVisibility(pCandidate, tmpOverrides) ? 'is-checked' : '',
			});
		const tmpCuratedRows = tmpCandidates.filter((pCandidate) => pCandidate.Source === 'Curated').filter(fSearchMatch).map(fMapRow);
		const tmpSchemaRows = tmpCandidates.filter((pCandidate) => pCandidate.Source === 'Schema').filter(fSearchMatch).map(fMapRow);
		const tmpAuditRows = tmpCandidates.filter((pCandidate) => pCandidate.Source === 'Audit').filter(fSearchMatch).map(fMapRow);
		this.pict.AppData.PRSPColumnChooser =
		{
			RecordSet: this._chooserRecordSet,
			Search: this._chooserSearch || '',
			CuratedRows: tmpCuratedRows,
			SchemaRows: tmpSchemaRows,
			AuditRows: tmpAuditRows,
			// A group divider only earns its place when rows are showing above it.
			HasSchemaRows: (tmpSchemaRows.length > 0) && (tmpCuratedRows.length > 0),
			HasAuditRows: (tmpAuditRows.length > 0) && ((tmpCuratedRows.length + tmpSchemaRows.length) > 0),
			IsEmpty: (tmpCuratedRows.length + tmpSchemaRows.length + tmpAuditRows.length) === 0,
		};
	}

	/**
	 * Reflect the popover's open/closed state on its container element.
	 * @param {boolean} pOpen - Whether the popover should be open.
	 */
	_paintColumnChooserOpenState(pOpen)
	{
		const tmpPopoverElements = this.pict.ContentAssignment.getElement('#PRSP_ColumnChooser_Popover');
		if (!tmpPopoverElements.length)
		{
			return;
		}
		tmpPopoverElements[0].classList.toggle('open', !!pOpen);
		if (pOpen)
		{
			this._positionColumnChooserPopover(tmpPopoverElements[0]);
		}
	}

	/**
	 * Position the (fixed) popover against the trigger button, flipping above when there's more
	 * room there — same approach as the filters view's add-filter popover, so no ancestor
	 * overflow:hidden can clip it.
	 *
	 * @param {HTMLElement} pPopover - the #PRSP_ColumnChooser_Popover element (already display:block).
	 */
	_positionColumnChooserPopover(pPopover)
	{
		const tmpTriggerElements = this.pict.ContentAssignment.getElement('#PRSP_ColumnChooser_Trigger');
		if (!tmpTriggerElements.length)
		{
			return;
		}
		const tmpPanel = /** @type {HTMLElement} */ (pPopover.querySelector('.prsp-colchooser-panel'));
		const tmpRect = tmpTriggerElements[0].getBoundingClientRect();
		const tmpGap = 6;
		const tmpMargin = 8;
		const tmpVH = window.innerHeight;
		const tmpVW = window.innerWidth;
		const tmpWidth = pPopover.offsetWidth || 280;
		// Right-align the popover to the (right-aligned) trigger, clamped into the viewport.
		pPopover.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.right - tmpWidth, tmpVW - tmpWidth - tmpMargin)))}px`;
		pPopover.style.right = 'auto';
		const tmpSpaceBelow = tmpVH - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		// Prefer the natural downward direction; only flip above when the room below is genuinely cramped.
		if (tmpSpaceBelow >= 220 || tmpSpaceBelow >= tmpSpaceAbove)
		{
			pPopover.style.top = `${Math.round(tmpRect.bottom + tmpGap)}px`;
			pPopover.style.bottom = 'auto';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceBelow, 460))}px`; }
		}
		else
		{
			pPopover.style.top = 'auto';
			pPopover.style.bottom = `${Math.round(tmpVH - tmpRect.top + tmpGap)}px`;
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceAbove, 460))}px`; }
		}
	}
}

module.exports = viewRecordSetListColumnChooser;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_ColumnChooser;

},{"pict-view":693}],672:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_HeaderList =
{
	ViewIdentifier: 'PRSP-List-HeaderList',

	DefaultRenderable: 'PRSP_Renderable_HeaderList',
	DefaultDestinationAddress: '#PRSP_HeaderList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-List-HeaderList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-HeaderList-Template] -->
	<!-- DefaultPackage end view template:	[PRSP-List-HeaderList-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_HeaderList',
			TemplateHash: 'PRSP-List-HeaderList-Template',
			DestinationAddress: '#PRSP_HeaderList_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetListHeaderList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_HeaderList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListHeaderList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_HeaderList;


},{"pict-view":693}],673:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationBottom = (
	{
		ViewIdentifier: 'PRSP-List-PaginationBottom',

		DefaultRenderable: 'PRSP_Renderable_PaginationBottom',
		DefaultDestinationAddress: '#PRSP_PaginationBottom_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-PaginationBottom-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-PaginationBottom-Template] -->
	<nav id="RSP_Lower_Pagination_Container">
	{~T:PRSP-List-Pagination-Template-Description~}
		{~T:PRSP-List-Pagination-Template-Buttons~}
	</nav>
	<!-- DefaultPackage end view template:  [PRSP-List-PaginationBottom-Template] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationBottom',
					TemplateHash: 'PRSP-List-PaginationBottom-Template',
					DestinationAddress: '#PRSP_PaginationBottom_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListPaginationBottom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationBottom, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListPaginationBottom;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationBottom;


},{"pict-view":693}],674:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationTop = (
	{
		ViewIdentifier: 'PRSP-List-PaginationTop',

		DefaultRenderable: 'PRSP_Renderable_PaginationTop',
		DefaultDestinationAddress: '#PRSP_PaginationTop_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-PaginationTop-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-PaginationTop-Template] -->
	<nav id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
		{~T:PRSP-List-Pagination-Template-Description~}
		{~T:PRSP-List-Pagination-Template-Buttons~}
	</nav>
	<div>
		{~TS:PRSP-List-Pagination-Template-Pages:Record.PageLinksLimited~}
	</div>
	<!-- DefaultPackage end view template:  [PRSP-List-PaginationTop-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Description',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Description] -->
	<div>
		Showing
		<span id="PRSP_Pagination_Description_Records_Start">{~D:Record.PageStart~}</span> to
		<span id="PRSP_Pagination_Description_Records_End">{~D:Record.PageEnd~}</span> of
		<span id="PRSP_Pagination_Description_Records_Total">{~D:Record.TotalRecordCount.Count~}</span> total records.
	</div>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Description] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Buttons',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Buttons] -->
	<ul style="list-style-type: none; padding: 0; display: flex; justify-content: center;">
		{~TIfAbs:PRSP-List-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
		{~TS:PRSP-List-Pagination-Template-Button-Page~}
		{~TIfAbs:PRSP-List-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
	</ul>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Buttons] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Button-Previous',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Previous] -->
	<li><a href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">&laquo; Previous</a></li>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Previous] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Button-Next',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Next] -->
	<li style="margin-left: 15px;"><a href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next &raquo;</a></li>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Next] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Button-Page',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Page] -->
	<li><a href="#" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Page] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Pages',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Pages] -->
	<a href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}" class="page-offset_{~D:Record.RelativeOffset~}">{~D:Record.Page~}</a>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Pages] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationTop',
					TemplateHash: 'PRSP-List-PaginationTop-Template',
					DestinationAddress: '#PRSP_PaginationTop_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListPaginationTop extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationTop, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListPaginationTop;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationTop;


},{"pict-view":693}],675:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordList =
{
	ViewIdentifier: 'PRSP-List-RecordList',

	DefaultRenderable: 'PRSP_Renderable_RecordList',
	DefaultDestinationAddress: '#PRSP_RecordList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: /*css*/`
		tr#PRSP_List_Table_Empty:not(:first-child) {
			display: none;
		}
	`,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-List-RecordList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordList-Template] -->
	<section id="PRSP_List_Container">
		{~T:PRSP-List-RecordList-Template-Table~}
	</section>
	<!-- DefaultPackage end view template:	[PRSP-List-RecordList-Template] -->
`
		},
		{
			Hash: 'PRSP-List-RecordList-Template-Table',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordList-Template-Table] -->
	<table id="PRSP_List_Table" tablespacing="0" cellpadding="0" cellspacing="0" style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
		<thead>{~T:PRSP-List-RecordListHeader-Template~}</thead>
		<tbody id="PRSP_RecordList_Container_Entries">
			{~T:PRSP-List-RecordListEntry-Template~}
			{~T:PRSP-List-RecordList-Template-EmptyTable~}
		</tbody>
	</table>
	<!-- DefaultPackage end view template:	[PRSP-List-RecordList-Template-Table] -->
`
		},
		{
			Hash: 'PRSP-List-RecordList-Template-EmptyTable',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordList-Template-EmptyTable] -->
	<tr id="PRSP_List_Table_Empty">
		<td colspan="100%" style="text-align: center; padding: 10px;">No records found.</td>
	</tr>
	<!-- DefaultPackage end view template:	[PRSP-List-RecordList-Template-EmptyTable] -->
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_RecordList',
			TemplateHash: 'PRSP-List-RecordList-Template',
			DestinationAddress: '#PRSP_RecordList_Container',
			RenderMethod: 'replace'
		}
	],

	Manifests: {}
};

class viewRecordSetListRecordList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListRecordList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordList;


},{"pict-view":693}],676:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListEntry = (
	{
		ViewIdentifier: 'PRSP-List-RecordListEntry',

		DefaultRenderable: 'PRSP_Renderable_RecordListEntry',
		DefaultDestinationAddress: '#PRSP_RecordListEntry_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		// Record-list row chrome. Host apps brand it via --theme-color-* tokens; the hardcoded values
		// are fallbacks.
		CSS: /*css*/`
/* Vertically center every cell's content so the text lines up with the action control (it was
   top-aligned, which read as off next to the centered action cell). */
#PRSP_List_Table td { vertical-align: middle; }

/* Deleted rows (visible via the show-deleted filter) read as ghosts of themselves. */
.prsp-list-row.prsp-row-deleted td { opacity: 0.55; }

/* Row-as-button (opt-in via the RowClickOpensRecord record-set config flag): clicking anywhere in the
   row — except the action cell — follows the record's default link. */
.prsp-list-row.prsp-row-clickable { cursor: pointer; }
.prsp-list-row.prsp-row-clickable:hover { background: var(--theme-color-background-hover, var(--theme-color-background-tertiary, #f1f3f7)); }

/* Per-row action menu: a subtle three-dot trigger, revealed on row hover, that opens a small popover
   of the record's links (View, …). Clicks inside it never trigger the row navigation. */
.prsp-row-actions { white-space: nowrap; text-align: right; width: 1%; }
.prsp-row-actions-wrap { position: relative; display: inline-block; }
.prsp-row-actions-trigger { display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
	border: none; background: transparent; line-height: 1; padding: 0.2rem 0.5rem; border-radius: 6px; font-size: 1.05rem;
	color: var(--theme-color-text-muted, #6b7686); opacity: 0; transition: opacity 0.12s ease, background 0.12s ease, color 0.12s ease; }
.prsp-list-row:hover .prsp-row-actions-trigger, .prsp-row-actions-wrap.open .prsp-row-actions-trigger { opacity: 1; }
.prsp-row-actions-trigger:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
.prsp-row-actions-menu { position: absolute; right: 0; top: calc(100% + 2px); z-index: 30; min-width: 9rem; display: none;
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 9px; box-shadow: 0 10px 26px rgba(17, 24, 39, 0.16); padding: 0.25rem; text-align: left; }
.prsp-row-actions-wrap:hover .prsp-row-actions-menu, .prsp-row-actions-wrap.open .prsp-row-actions-menu { display: block; }
.prsp-row-actions-menu ul { list-style: none; margin: 0; padding: 0; }
.prsp-row-actions-menu li > a { display: block; padding: 0.4rem 0.65rem; border-radius: 6px; text-decoration: none; white-space: nowrap;
	color: var(--theme-color-text-primary, #1f2733); font-size: 0.9rem; }
.prsp-row-actions-menu li > a:hover { background: var(--theme-color-background-tertiary, #eceef2); }
`,
		CSSPriority: 500,

		Templates:
			[
				{
					// TODO: Add extras template here; it's in the header but not here yet.
					Hash: 'PRSP-List-RecordListEntry-Template',
					Template: /*html*/`
		{~TSWP:PRSP-List-RecordListEntry-Template-Row:Record.Records.Records:Record~}
	`
				},
				{
					Hash: 'PRSP-List-RecordListEntry-Template-Row',
					// The whole row is a click target for the record's default link — opt-in via the
					// RowClickOpensRecord record-set config flag (which adds prsp-row-clickable). The onclick
					// only fires when that class is present, skips clicks inside the action cell, and follows
					// the default link (data-prsp-default) only — so a host-overridden action cell with no
					// default link makes the row click a harmless no-op.
					Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-List-RecordListEntry-Template] -->
		<tr class="prsp-list-row{~NE:Record.Payload.RecordSetConfiguration.RowClickOpensRecord^ prsp-row-clickable~}{~NE:Record.Data.Deleted^ prsp-row-deleted~}" onclick="if (this.classList.contains('prsp-row-clickable') &amp;&amp; !event.target.closest('.prsp-row-actions')) { var tmpDefaultLink = this.querySelector('.prsp-row-actions a[data-prsp-default]'); if (tmpDefaultLink) { tmpDefaultLink.click(); } }">
			{~TSWP:PRSP-List-RecordListEntry-Template-Row-Cell:Record.Payload.TableCells:Record.Data~}
			{~T:PRSP-List-RecordListHeader-Template-Extra-Row~}
			{~T:PRSP-List-RecordListAction-Template-Cell~}
		</tr>
		<!-- DefaultPackage end view template:  [PRSP-List-RecordListEntry-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Template-Extra-Row',
					Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-List-RecordListHeader-Template-Extra-Row] -->
		{~TBR:Record.Payload.RecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash~}
		<!-- DefaultPackage end view template:  [PRSP-List-RecordListHeader-Extra-Row] -->
	`
				},
				{
					Hash: 'PRSP-List-RecordListEntry-Template-Row-Cell',
					Template: /*html*/`
			<td style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
				{~TBDA:Record.Data.PictDashboard.ValueTemplate~}
			</td>
		`
				},
				{
					Hash: 'PRSP-List-RecordListEntry-Template-Entry-Cell-Datum',
					Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-List-RecordListEntry-Template-Entry-Cell-Datum] -->
		`
				},
				{
					// The action cell renders the three-dot hover menu when RowClickOpensRecord is set, else the
					// original always-visible link list. (Hosts such as LIMS override this whole template; those
					// lists keep their custom actions and — without the flag — their original row behavior.)
					Hash: 'PRSP-List-RecordListAction-Template-Cell',
					// FIXME: Needs a better way of getting the appropriate link templates in (likely requiring piping the RecordSet to the link manager)
					Template: /*html*/`
			<td class="prsp-row-actions" style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
				{~TIfAbs:PRSP-List-RecordListAction-Menu:Record:Record.Payload.RecordSetConfiguration.RowClickOpensRecord^TRUE^~}
				{~TIfAbs:PRSP-List-RecordListAction-List:Record:Record.Payload.RecordSetConfiguration.RowClickOpensRecord^FALSE^~}
			</td>
		`
				},
				{
					Hash: 'PRSP-List-RecordListAction-Menu',
					Template: /*html*/`
				<div class="prsp-row-actions-wrap">
					<button type="button" class="prsp-row-actions-trigger" aria-label="Actions" title="Actions" onclick="event.stopPropagation(); this.parentNode.classList.toggle('open');">{~I:More~}</button>
					<div class="prsp-row-actions-menu">
						<ul>
							{~TSWP:PRSP-List-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
						</ul>
					</div>
				</div>
		`
				},
				{
					Hash: 'PRSP-List-RecordListAction-List',
					Template: /*html*/`
				<ul>
					{~TSWP:PRSP-List-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
				</ul>
		`
				},
				{
					Hash: 'PRSP-List-RecordListAction-Template-Cell-Datum',
					// These use the new TemplateByReference template expression, which uses the values in these addresses to lookup the template hash then renders those template with the current Record state.
					// This is part one of refactoring to include metatemplate resolution ase a core behavior pict itself rather than a pict-section-form capability
					Template: /*html*/`
						<li><a {~NE:Record.Data.Default^data-prsp-default="1"~} href="{~TBR:Record.Data.URL~}">{~TBR:Record.Data.Name~}</a></li>
		`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListEntry',
					TemplateHash: 'PRSP-List-RecordListEntry-Template',
					DestinationAddress: '#PRSP_RecordListEntry_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListRecordListEntry extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListEntry, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListRecordListEntry;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListEntry;

},{"pict-view":693}],677:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListHeader = (
	{
		ViewIdentifier: 'PRSP-List-RecordListHeader',

		DefaultRenderable: 'PRSP_Renderable_RecordListHeader',
		DefaultDestinationAddress: '#PRSP_RecordListHeader_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-RecordListHeader-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordListHeader-Template] -->
	<tr>
		{~TS:PRSP-List-RecordListHeader-Template-Header:Record.TableCells~}
		{~T:PRSP-List-RecordListHeader-Template-Extra-Header~}
		{~T:PRSP-List-RecordListActions-Template-Header~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-List-RecordListHeader-Template] -->
	`
				},
				{
					// Per-column header dispatch: a sortable column (opt in via RecordSetListSortable / column
					// Sortable) renders a clickable, indicator-bearing header; otherwise the plain header. Exactly
					// one slot is populated per cell in RecordSet-List._stampSortState, so this stays a no-op change
					// for every list that has not opted into sorting.
					Hash: 'PRSP-List-RecordListHeader-Template-Header',
					Template: /*html*/`{~TS:PRSP-List-RecordListHeader-Header-Sortable:Record.SortableSlot~}{~TS:PRSP-List-RecordListHeader-Header-Plain:Record.PlainSlot~}`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-Plain',
					Template: /*html*/`
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333);">
		{~D:Record.DisplayName~}
	</th>
	`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-Sortable',
					Template: /*html*/`
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333); cursor: pointer; user-select: none; white-space: nowrap;" title="Sort by {~D:Record.DisplayName~}" onclick="_Pict.views['RSP-RecordSet-List'].sortByColumn('{~D:Record.RecordSet~}', '{~D:Record.Key~}')">
		{~D:Record.DisplayName~}{~TS:PRSP-List-RecordListHeader-Header-ChevronUp:Record.AscendingSlot~}{~TS:PRSP-List-RecordListHeader-Header-ChevronDown:Record.DescendingSlot~}
	</th>
	`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-ChevronUp',
					Template: /*html*/`<span style="margin-left: 4px; opacity: 0.85;">{~I:ChevronUp~}</span>`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-ChevronDown',
					Template: /*html*/`<span style="margin-left: 4px; opacity: 0.85;">{~I:ChevronDown~}</span>`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Template-Extra-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordListHeader-Template-Extra-Header] -->
{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}
	<!-- DefaultPackage end view template:  [PRSP-List-RecordListHeader-Extra-Header] -->
	`
//	{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}

				},
				{
					Hash: 'PRSP-List-RecordListActions-Template-Header',
					// Unlabeled, shrink-to-fit actions column: width:1% + nowrap collapses it to the width of the
					// row's action control (the hover "⋯" trigger), and the other columns absorb the slack.
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordListActions-Template-Header] -->
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; width: 1%; white-space: nowrap; background-color: var(--theme-color-background-tertiary, #f2f2f2);"></th>
	<!-- DefaultPackage end view template:  [PRSP-List-RecordListActions-Template-Header] -->
	`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListHeader',
					TemplateHash: 'PRSP-List-RecordListHeader-Template',
					DestinationAddress: '#PRSP_RecordListHeader_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListRecordListHeader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListHeader, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListRecordListHeader;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListHeader;

},{"pict-view":693}],678:[function(require,module,exports){
/**
 * RecordSet-List-Sort
 *
 * Pure helpers for the OPT-IN sortable-column-header feature of the record set list. Kept free of view/DOM state
 * so the semantics -- which columns are sortable, the current sort parsed from the FoxHound filter string, the
 * click-toggle cycle, and rewriting the filter string -- are unit-testable on their own.
 *
 * Default behavior is unchanged: a column is sortable ONLY when the record set opts in with
 * RecordSetListSortable:true (whole list) or an individual column sets Sortable:true; a column can always opt out
 * with Sortable:false. The sort itself rides the existing FoxHound `FSF~<field>~<ASC|DESC>~0` stanza already
 * carried in the list's filter string, so there is no new transport -- a header click just rewrites that stanza
 * and re-navigates the list route.
 */

// A column is sortable when it opts in explicitly, or the whole list is sortable and the column has not opted out.
function columnIsSortable(pRecordSetConfiguration, pColumn)
{
	if (!pColumn) { return false; }
	if (pColumn.Sortable === true) { return true; }
	if (pColumn.Sortable === false) { return false; }
	return !!(pRecordSetConfiguration && pRecordSetConfiguration.RecordSetListSortable === true);
}

// Parse the active sort (if any) out of a list filter string -> { Field, Direction } or null. The filter string
// may arrive URI-encoded (it rides in the route), so decode defensively.
function parseSort(pFilterString)
{
	if (!pFilterString || typeof pFilterString !== 'string') { return null; }
	let tmpDecoded = pFilterString;
	try { tmpDecoded = decodeURIComponent(pFilterString); } catch (pDecodeError) { /* already decoded */ }
	let tmpMatch = /FSF~([^~]+)~(ASC|DESC)~/i.exec(tmpDecoded);
	if (!tmpMatch) { return null; }
	return { Field: tmpMatch[1], Direction: tmpMatch[2].toUpperCase() };
}

// The next sort state when a header is clicked: an unsorted column (or a different column) sorts ASC; ASC becomes
// DESC; DESC clears back to the natural order (null). A three-state cycle so a click can always undo itself.
function toggleSort(pCurrentSort, pKey)
{
	if (!pCurrentSort || pCurrentSort.Field !== pKey) { return { Field: pKey, Direction: 'ASC' }; }
	if (String(pCurrentSort.Direction).toUpperCase() === 'ASC') { return { Field: pKey, Direction: 'DESC' }; }
	return null;
}

// Rewrite a filter string's sort: strip any existing FSF stanza (fixed 4-token arity: FSF~field~dir~idx, so it
// is `~`-safe) and append the new one. Every other stanza (FBV filter clauses, etc.) is preserved untouched, so
// sorting composes with an active filter.
function applySort(pFilterString, pSort)
{
	let tmpDecoded = '';
	if (pFilterString && typeof pFilterString === 'string')
	{
		try { tmpDecoded = decodeURIComponent(pFilterString); } catch (pDecodeError) { tmpDecoded = pFilterString; }
	}
	let tmpStripped = tmpDecoded.replace(/~?FSF~[^~]+~[^~]+~[^~]+/gi, '');
	tmpStripped = tmpStripped.replace(/^~+/, '').replace(/~+$/, '');
	if (!pSort || !pSort.Field) { return tmpStripped; }
	let tmpSortStanza = 'FSF~' + pSort.Field + '~' + (String(pSort.Direction).toUpperCase() === 'DESC' ? 'DESC' : 'ASC') + '~0';
	return tmpStripped ? (tmpStripped + '~' + tmpSortStanza) : tmpSortStanza;
}

module.exports = { columnIsSortable, parseSort, toggleSort, applySort };

},{}],679:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_Title =
{
	ViewIdentifier: 'PRSP-List-Title',

	DefaultRenderable: 'PRSP_Renderable_Title',
	DefaultDestinationAddress: '#PRSP_Title_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-List-Title-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Title-Template] -->
	<header id="PRSP_Title_Container">
		<h1 id="PRSP_Title">{~D:Record.Title~}</h1>
		<h2 id="PRSP_Subtitle">{~D:Record.Subtitle~}</h2>
		{~TIfAbs:PRSP-List-Title-CreateButton-Template:Record:Record.RecordSetConfiguration.RecordSetListShowCreateButton^TRUE^~}
		{~TIfAbs:PRSP-List-Title-BulkDeleteButton-Template:Record:Record.RecordSetConfiguration.RecordSetAllowBulkDelete^TRUE^~}
	</header>
	<!-- DefaultPackage end view template:	[PRSP-List-Title-Template] -->
`
		},
		{
			Hash: 'PRSP-List-Title-CreateButton-Template',
			Template: /*html*/`
	<!-- Optional list "New" action; opt in per record set via RecordSetConfiguration.RecordSetListShowCreateButton. -->
	<button type="button" class="prsp-list-title-create" title="Create a new record" onclick="_Pict.views['RSP-RecordSet-List'].createNew('{~D:Record.RecordSet~}')">{~I:Plus~} New</button>
`
		},
		{
			Hash: 'PRSP-List-Title-BulkDeleteButton-Template',
			Template: /*html*/`
	<!-- Optional list "Delete records" action; opt in per record set via RecordSetConfiguration.RecordSetAllowBulkDelete. -->
	<button type="button" class="prsp-list-title-bulkdelete" title="Select and delete a batch of records" onclick="_Pict.views['RSP-RecordSet-List'].openBulkDelete('{~D:Record.RecordSet~}')">{~I:Trash~} Delete records</button>
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Title',
			TemplateHash: 'PRSP-List-Title-Template',
			DestinationAddress: '#PRSP_Title_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetListTitle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_Title, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListTitle;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_Title;

},{"pict-view":693}],680:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');

const viewHeaderList = require('./RecordSet-List-HeaderList.js');
const viewTitle = require('./RecordSet-List-Title.js');
const viewFilters = require('../RecordSet-Filters.js');
const viewPaginationTop = require('./RecordSet-List-PaginationTop.js');
const viewRecordList = require('./RecordSet-List-RecordList.js');
const viewRecordListHeader = require('./RecordSet-List-RecordListHeader.js');
const viewRecordListEntry = require('./RecordSet-List-RecordListEntry.js');
const viewPaginationBottom = require('./RecordSet-List-PaginationBottom.js');
const viewColumnChooser = require('./RecordSet-List-ColumnChooser.js');
const libSort = require('./RecordSet-List-Sort.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__List = (
	{
		ViewIdentifier: 'PRSP-List',

		DefaultRenderable: 'PRSP_Renderable_List',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
	.prsp-list-loading { width: 100%; padding: 0.25rem 0 0.5rem; }
	.prsp-list-loading-inner { display: inline-flex; align-items: center; gap: 0.55em; color: var(--theme-color-text-muted, #64748b); font-size: 1rem; padding: 0.5rem 0.25rem 0.7rem; }
	.prsp-list-spinner { display: inline-flex; animation: prsp-list-spin 0.9s linear infinite; }
	@keyframes prsp-list-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
	/* Skeleton ghost rows: a few light, theme-colored bars that fill the loading area so the preserved
	   row height doesn't read as a white void. A bottom fade blends the last rows into the page. */
	.prsp-list-skeleton { position: relative; animation: prsp-list-skeleton-pulse 1.8s ease-in-out infinite; }
	@keyframes prsp-list-skeleton-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.7; } }
	.prsp-list-skeleton-row { height: 2.6rem; margin: 0 0 0.7rem; border-radius: 8px; background: var(--theme-color-background-tertiary, #eceef2); }
	.prsp-list-skeleton-row:nth-child(4n) { width: 94%; }
	.prsp-list-skeleton-row:nth-child(5n) { width: 97%; }
	.prsp-list-skeleton-fade { position: absolute; left: 0; right: 0; bottom: 0; height: 4.5rem; background: linear-gradient(to bottom, transparent, var(--theme-color-background-primary, #fff)); pointer-events: none; }
	`,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Template] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-List-Title~}
		{~V:PRSP-List-HeaderList~}
		<section id="PRSP_Filters_Container">
			{~FV:PRSP-Filters:List~}
		</section>
		<div id="PRSP_ColumnChooser_Container">{~V:PRSP-List-ColumnChooser~}</div>
		<div id="PRSP_PaginationTop_Container">{~V:PRSP-List-PaginationTop~}</div>
		<div id="PRSP_RecordList_Container">{~V:PRSP-List-RecordList~}</div>
		<div id="PRSP_PaginationBottom_Container">{~V:PRSP-List-PaginationBottom~}</div>
	</section>
	<!-- DefaultPackage end view template:  [PRSP-List-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-Template-Record',
					Template: /*html*/`
	<!-- DefaultPackage end view template:  [PRSP-List-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-LoadingShell',
					Template: /*html*/`
	<div id="PRSP_List_Loading" class="prsp-list-loading">
		<div class="prsp-list-loading-inner">
			<span class="prsp-list-spinner" aria-hidden="true">{~I:Refresh~}</span>
			<span class="prsp-list-loading-label">Loading…</span>
		</div>
		<div class="prsp-list-skeleton" aria-hidden="true">
			{~TS:PRSP-List-Skeleton-Row:Record.SkeletonRows~}
			<div class="prsp-list-skeleton-fade"></div>
		</div>
	</div>
	`
				},
				{
					Hash: 'PRSP-List-Skeleton-Row',
					Template: /*html*/`<div class="prsp-list-skeleton-row"></div>`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_List',
					TemplateHash: 'PRSP-List-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetList extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__List, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.childViews = {
			headerList: null,
			title: null,
			paginationTop: null,
			recordList: null,
			recordListHeader: null,
			recordListEntry: null,
			paginationBottom: null,
			columnChooser: null
		};

		// Identity (`RecordSet::FilterString::FilterExperience`) of the list currently painted into the DOM.
		// When a route only changes the page (Offset/PageSize) and this still matches, we re-render just the
		// rows + pagination instead of the whole view — see handleRecordSetListRoute / _paintRecordList.
		this._renderedListIdentity = null;

		// The last fully-composed list data (carrying the pristine ColumnCandidates) and the arguments of
		// the last render call — together they let a column-visibility toggle repaint the rows from data
		// already in hand (or, when a Lite fetch is missing the column, rerun the same render to refetch).
		this._lastRecordListData = null;
		this._lastListRenderArgs = null;
	}

	handleRecordSetListRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet List view route handler called with invalid route payload.`);
		}

		//_Pict.PictSectionRecordSet.recordSetProviderConfigurations['Book'], 'RSP-Provider-Book'
		// FIXME: Not in love with this but good enough to start.
		// FIXME: Typescript mumbo jumbo
		// if (!('PictSectionRecordSet' in this.pict))
		// {
		// 	return false;
		// }
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		if (this.delegateToCustomView('List', tmpProviderConfiguration, pRoutePayload)) { return true; }

		// Seed the initial-load filter from the recordset's RecordSetDefaultFilter when the URL supplies none (a plain
		// /PSRS/<set>/List with no /FilteredTo/ segment). This is how a recordset's default sort/filter (e.g. a
		// FSF~<dateColumn>~DESC~0 date-spine sort) actually reaches SQL on first paint -- otherwise the empty filter
		// yields primary-key order. Any user filter/sort produces a /FilteredTo/... URL, so pRoutePayload wins thereafter.
		const tmpFilterString = pRoutePayload.data.FilterString || (tmpProviderConfiguration && tmpProviderConfiguration.RecordSetDefaultFilter) || '';
		const tmpFilterExperience = pRoutePayload.data.FilterExperience || '';

		const tmpOffset = pRoutePayload.data.Offset ? pRoutePayload.data.Offset : 0;
		const tmpPageSize = pRoutePayload.data.PageSize ? pRoutePayload.data.PageSize : 100;

		// Surgical page render: when only the page changed (same RecordSet, FilterString, and
		// FilterExperience), re-render just the rows + pagination rather than the whole list view. A full
		// re-render rebuilds the filter view — including all of its picker/control state — which is by far
		// the most expensive part of a list paint and entirely wasted when only paging. Requires the list to
		// already be in the DOM (its rows container exists); otherwise we fall through to a full render.
		const tmpListIdentity = `${pRoutePayload.data.RecordSet}::${tmpFilterString}::${tmpFilterExperience}`;
		const tmpRenderBodyOnly = (this._renderedListIdentity === tmpListIdentity)
			&& (this.pict.ContentAssignment.getElement('#PRSP_RecordList_Container').length > 0);
		this._renderedListIdentity = tmpListIdentity;

		return this.renderList(tmpProviderConfiguration, tmpProviderHash, tmpFilterString, tmpFilterExperience, tmpOffset, tmpPageSize, tmpRenderBodyOnly);
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString/:Offset/:PageSize', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/:Offset/:PageSize', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/:Offset', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.resolve();
		return true;
	}

	/**
	 * Navigate to the Create form for a record set. Backs the optional list title-bar "New" button
	 * (opt in per record set via RecordSetConfiguration.RecordSetListShowCreateButton). Routes through
	 * the section router so it works in both hash and memory router modes; falls back to the active
	 * route's record set when called without an argument.
	 * @param {string} [pRecordSet] - The record set to create a new record in.
	 * @return {boolean} True when navigation was issued.
	 */
	createNew(pRecordSet)
	{
		const tmpRecordSet = pRecordSet || this.fable?.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet;
		if (!tmpRecordSet)
		{
			this.log.warn(`RecordSetList: createNew called but no record set could be resolved.`);
			return false;
		}
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ tmpRecordSet }/Create`);
		return true;
	}

	/**
	 * Navigate to the Bulk Delete screen for a record set. Backs the optional list title-bar "Delete
	 * records" button (opt in per record set via RecordSetConfiguration.RecordSetAllowBulkDelete). Routes
	 * through the section router; falls back to the active route's record set when called without an argument.
	 * @param {string} [pRecordSet] - The record set to bulk-delete records from.
	 * @return {boolean} True when navigation was issued.
	 */
	openBulkDelete(pRecordSet)
	{
		const tmpRecordSet = pRecordSet || this.fable?.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet;
		if (!tmpRecordSet)
		{
			this.log.warn(`RecordSetList: openBulkDelete called but no record set could be resolved.`);
			return false;
		}
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ tmpRecordSet }/BulkDelete`);
		return true;
	}

	onBeforeRenderList(pRecordListData)
	{
		return pRecordListData;
	}

	// OPT-IN sortable column headers. Stamp each header cell with whether it is sortable + the active sort, so the
	// header template can render a clickable header + a direction indicator. Off unless the record set opts in
	// with RecordSetListSortable:true or a column sets Sortable:true (see RecordSet-List-Sort.js). The single-
	// element-array slots drive the header template's conditional branches (the pict {~TS:~} pattern). Idempotent.
	_stampSortState(pRecordListData)
	{
		if (!pRecordListData || !Array.isArray(pRecordListData.TableCells))
		{
			return pRecordListData;
		}
		const tmpConfiguration = pRecordListData.RecordSetConfiguration || {};
		const tmpCurrentSort = libSort.parseSort(pRecordListData.FilterString);
		for (let i = 0; i < pRecordListData.TableCells.length; i++)
		{
			const tmpCell = pRecordListData.TableCells[i];
			const tmpSortable = libSort.columnIsSortable(tmpConfiguration, tmpCell);
			tmpCell.Sortable = tmpSortable;
			tmpCell.RecordSet = pRecordListData.RecordSet;
			const tmpActive = !!(tmpSortable && tmpCurrentSort && tmpCurrentSort.Field === tmpCell.Key);
			tmpCell.SortAscending = tmpActive && (tmpCurrentSort.Direction === 'ASC');
			tmpCell.SortDescending = tmpActive && (tmpCurrentSort.Direction === 'DESC');
			tmpCell.SortableSlot = tmpSortable ? [ tmpCell ] : [];
			tmpCell.PlainSlot = tmpSortable ? [] : [ tmpCell ];
			tmpCell.AscendingSlot = tmpCell.SortAscending ? [ 1 ] : [];
			tmpCell.DescendingSlot = tmpCell.SortDescending ? [ 1 ] : [];
		}
		return pRecordListData;
	}

	// A sortable header was clicked: cycle its sort (unsorted -> ASC -> DESC -> unsorted), rewrite the list's
	// FoxHound filter string (preserving any active filter clause), and re-navigate the list route from page 0.
	// The sort rides the FSF stanza through the normal fetch, so any provider that honors FoxHound sorting works.
	sortByColumn(pRecordSet, pColumnKey)
	{
		const tmpArguments = (this._lastListRenderArgs && this._lastListRenderArgs.Args) || [];
		const tmpFromManifest = !!(this._lastListRenderArgs && this._lastListRenderArgs.Method === 'renderListFromManifest');
		// renderList Args: [config, providerHash, filterString, filterExperience, offset, pageSize].
		// renderListFromManifest Args: [manifest, config, providerHash, filterString, filterExperience, offset, pageSize].
		const tmpFilterString = tmpFromManifest ? tmpArguments[3] : tmpArguments[2];
		const tmpFilterExperience = tmpFromManifest ? tmpArguments[4] : tmpArguments[3];
		const tmpPageSize = (tmpFromManifest ? tmpArguments[6] : tmpArguments[5]) || 100;
		const tmpNextSort = libSort.toggleSort(libSort.parseSort(tmpFilterString), pColumnKey);
		const tmpNewFilterString = libSort.applySort(tmpFilterString, tmpNextSort);
		let tmpRoute = `/PSRS/${ pRecordSet }/List`;
		if (tmpNewFilterString)
		{
			tmpRoute += `/FilteredTo/${ encodeURIComponent(tmpNewFilterString) }`;
		}
		tmpRoute += `/0/${ tmpPageSize }`;
		if (tmpFilterExperience)
		{
			tmpRoute += `/FilterExperience/${ encodeURIComponent(tmpFilterExperience) }`;
		}
		this.fable.providers.RecordSetRouter.pictRouter.navigate(tmpRoute);
		return false;
	}

	/**
	 * Paint a loading shell into the list destination synchronously, before the data
	 * fetch, so the previous page doesn't sit silently while a slow query runs. The
	 * real list render (RenderMethod 'replace' into the same destination) overwrites
	 * it when data arrives. Opt out with RecordSetListShowLoadingShell:false.
	 * @param {Record<string, any>} pRecordListData
	 */
	_projectLoadingShell(pRecordListData)
	{
		try
		{
			const tmpConfig = pRecordListData && pRecordListData.RecordSetConfiguration;
			if (tmpConfig && tmpConfig.RecordSetListShowLoadingShell === false)
			{
				return;
			}
			if (!pRecordListData || !pRecordListData.RenderDestination)
			{
				return;
			}
			// When the list is already on screen, scope the spinner to just the rows area so the title,
			// filters, and pagination stay put (and the expensive filter view isn't disturbed). On the first
			// render the rows container doesn't exist yet, so fall back to the whole list destination.
			const tmpRowsElements = this.pict.ContentAssignment.getElement('#PRSP_RecordList_Container');
			const tmpRowsContainerPresent = tmpRowsElements.length > 0;
			const tmpDestination = tmpRowsContainerPresent ? '#PRSP_RecordList_Container' : pRecordListData.RenderDestination;
			// Fill roughly the visible viewport with ghost rows (each skeleton row occupies ~53px), capped to
			// the preserved height so a short list doesn't over-fill, and clamped to a sane range.
			const tmpViewportHeight = (typeof window !== 'undefined' && window.innerHeight) ? window.innerHeight : 800;
			let tmpFillHeight = tmpViewportHeight + 200;
			if (tmpRowsContainerPresent)
			{
				// Pin the rows area to its current height before swapping in the spinner, so the page doesn't
				// collapse and yank the content below it — pagination, the page's footer/colored fill — up into
				// the fold and back. The floor is released once the real rows render (see _paintRecordList).
				const tmpCurrentHeight = tmpRowsElements[0].offsetHeight;
				if (tmpCurrentHeight > 0)
				{
					tmpRowsElements[0].style.minHeight = `${ tmpCurrentHeight }px`;
					tmpFillHeight = Math.min(tmpCurrentHeight, tmpFillHeight);
				}
			}
			const tmpSkeletonRowCount = Math.max(6, Math.min(60, Math.ceil(tmpFillHeight / 53)));
			this.pict.CSSMap.injectCSS();
			// Render the spinner + enough skeleton ghost rows to fill the visible area (so no white void shows).
			const tmpLoadingShellData = { SkeletonRows: new Array(tmpSkeletonRowCount).fill(0) };
			this.pict.ContentAssignment.assignContent(tmpDestination, this.pict.parseTemplateByHash('PRSP-List-LoadingShell', tmpLoadingShellData));
		}
		catch (pError)
		{
			// The loading shell is purely cosmetic; never let it break the list render.
			this.log.warn(`RecordSetList: loading shell render failed: ${ pError && pError.message }`);
		}
	}

	/**
	 * The schema columns that never become list columns automatically: the entity's own
	 * identity pair plus the audit stamps. (Hosts that want one of these in the column
	 * chooser declare it as a curated column, optionally with DefaultHidden.)
	 *
	 * @param {string} pEntity - The entity name (for the ID/GUID identity columns)
	 * @return {Array<string>} The excluded column names.
	 */
	_getExcludedSchemaColumns(pEntity)
	{
		return [
			'ID' + pEntity,
			'GUID' + pEntity,
			'CreateDate',
			'CreatingIDUser',
			'DeleteDate',
			'Deleted',
			'DeletingIDUser',
			'UpdateDate',
			'UpdatingIDUser',
			'IDCustomer', // meadow-endpoints/retold tenancy discriminator — server-managed, hidden from every record view
			'ExternalSyncDate', 'ExternalSyncGUID', // external-sync auditing stamps (Headlight integration sync)
		];
	}

	dynamicallyGenerateColumns(pRecordListData)
	{
		pRecordListData.TableCells = [];
		const tmpEntity = pRecordListData.RecordSetConfiguration.Entity;
		this.excludedByDefaultCells = this._getExcludedSchemaColumns(tmpEntity);

		const tmpSchema = pRecordListData.RecordSchema;
		const tmpProperties = tmpSchema?.properties;
		// loop throught the schema and add the columns to the tableCells
		for (const tmpColumn in tmpProperties)
		{
			if (tmpProperties.hasOwnProperty(tmpColumn))
			{
				// Check if the column is excluded by the default list of columns (or is not a GUID/ID)
				if (this.excludedByDefaultCells.includes(tmpColumn) === false)
				{
					pRecordListData.TableCells.push({
						'Key': tmpColumn,
						'DisplayName': tmpProperties?.[tmpColumn].title || tmpColumn,
						'PictDashboard': {
							'ValueTemplate': '{~ProcessCell:Record.Data.Key~}'
						}
					});
				}
			}
		}
		return pRecordListData;
	}

	/**
	 * Map column name -> Meadow column Type from the entity schema, when available. The schema
	 * endpoint nests the canonical column array at MeadowSchema.MeadowSchema.Schema (with a
	 * legacy flat MeadowSchema.Schema fallback). Returns null when neither is present (e.g.
	 * non-Meadow providers) so callers can skip type-based exclusions.
	 *
	 * @param {Record<string, any>} pRecordSchema - The schema from getRecordSchema()
	 * @return {Record<string, string>|null} Column name -> Type map, or null.
	 */
	_getMeadowColumnTypes(pRecordSchema)
	{
		const tmpSchemaColumns = pRecordSchema?.MeadowSchema?.MeadowSchema?.Schema || pRecordSchema?.MeadowSchema?.Schema;
		if (!Array.isArray(tmpSchemaColumns) || tmpSchemaColumns.length < 1)
		{
			return null;
		}
		/** @type {Record<string, string>} */
		const tmpColumnTypes = {};
		for (const tmpColumn of tmpSchemaColumns)
		{
			if (tmpColumn && tmpColumn.Column)
			{
				tmpColumnTypes[tmpColumn.Column] = tmpColumn.Type;
			}
		}
		return tmpColumnTypes;
	}

	/**
	 * Whether a column candidate is effectively visible: an explicit user override wins,
	 * otherwise the candidate's default (visible unless DefaultHidden).
	 *
	 * @param {Record<string, any>} pCandidate - A ColumnCandidates entry
	 * @param {Record<string, boolean>} pOverrides - The per-recordset override map
	 * @return {boolean}
	 */
	_effectiveColumnVisibility(pCandidate, pOverrides)
	{
		if (pOverrides && (pCandidate.Key in pOverrides))
		{
			return (pOverrides[pCandidate.Key] === true);
		}
		return (pCandidate.DefaultHidden !== true);
	}

	/**
	 * Compute the visible TableCells for a paint from the pristine candidate list + the user's
	 * current overrides. Cells are per-paint shallow copies so host hooks can mutate them without
	 * bleeding into the candidates. An override set that hides everything falls back to the
	 * default-visible set (a fully empty table is a confusing dead end).
	 *
	 * @param {Array<Record<string, any>>} pCandidates - The pristine ColumnCandidates
	 * @param {string} pRecordSet - The record set (for the override lookup)
	 * @return {Array<Record<string, any>>} The visible cells, in candidate order.
	 */
	_computeVisibleTableCells(pCandidates, pRecordSet)
	{
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		const tmpOverrides = tmpColumnProvider ? tmpColumnProvider.getColumnVisibilityOverrides(pRecordSet, 'List') : {};
		let tmpVisibleCells = pCandidates
			.filter((pCandidate) => this._effectiveColumnVisibility(pCandidate, tmpOverrides))
			.map((pCell) => Object.assign({}, pCell));
		if (tmpVisibleCells.length < 1)
		{
			this.log.warn(`RecordSetList: column visibility overrides for [${pRecordSet}] hid every column; rendering the default-visible set instead.`);
			tmpVisibleCells = pCandidates
				.filter((pCandidate) => pCandidate.DefaultHidden !== true)
				.map((pCell) => Object.assign({}, pCell));
		}
		return tmpVisibleCells;
	}

	/**
	 * Compose the column-chooser candidate pool and reduce TableCells to the visible subset.
	 *
	 * No-op unless the recordset opts in with RecordSetListColumnChooser: true — the flag off
	 * leaves TableCells exactly as the existing paths computed it (including the manifest's
	 * shared array reference).
	 *
	 * Candidates are two tiers, in order:
	 *  - Curated: the host-declared columns (manifest Descriptors or RecordSetListColumns),
	 *    shallow-copied (the shared manifest TableCells entries are never mutated), default
	 *    visible unless the column/descriptor declares DefaultHidden: true.
	 *  - Schema: remaining scalar entity columns (identity/audit fields and blob Text/JSON
	 *    columns excluded), default hidden, rendered via the generic ProcessCell template
	 *    (entity-reference ID* columns resolve names exactly like dynamic columns do).
	 *
	 * The pristine candidates ride on pRecordListData.ColumnCandidates (module-owned — host
	 * hooks must not mutate it); TableCells becomes per-paint copies of the visible subset.
	 *
	 * @param {Record<string, any>} pRecordListData - The list data (TableCells already computed)
	 * @return {Record<string, any>} The same list data, candidates composed.
	 */
	_composeColumnCandidates(pRecordListData)
	{
		// Always an array (empty = render nothing): a missing address would make the chooser
		// button's {~TS:~} iterate the record object's own keys instead of rendering nothing.
		pRecordListData.ColumnChooserSlot = [];
		const tmpConfig = pRecordListData.RecordSetConfiguration;
		if (!tmpConfig || tmpConfig.RecordSetListColumnChooser !== true)
		{
			return pRecordListData;
		}

		// Curated tier: shallow copies of whatever the host declared, flagged with source + default.
		const tmpCandidates = (pRecordListData.TableCells || []).map((pCell) =>
			Object.assign({}, pCell, { Source: 'Curated', DefaultHidden: (pCell.DefaultHidden === true) }));
		const tmpCuratedKeys = {};
		for (const tmpCell of tmpCandidates)
		{
			tmpCuratedKeys[tmpCell.Key] = true;
		}

		// Schema tier: every remaining scalar entity column, default hidden.
		const tmpExcludedColumns = this._getExcludedSchemaColumns(tmpConfig.Entity);
		const tmpProperties = pRecordListData.RecordSchema?.properties;
		const tmpMeadowColumnTypes = this._getMeadowColumnTypes(pRecordListData.RecordSchema);
		const tmpBlobTypes = { 'Text': true, 'JSON': true };
		const tmpSchemaCandidates = [];
		for (const tmpColumn in tmpProperties)
		{
			if (!tmpProperties.hasOwnProperty(tmpColumn) || tmpCuratedKeys[tmpColumn] || tmpExcludedColumns.includes(tmpColumn))
			{
				continue;
			}
			// When the Meadow schema is available, only offer real non-blob columns — a JSON-schema-only
			// property is not fetchable by a Lite projection, and blob columns are why Lite exists.
			if (tmpMeadowColumnTypes && (!(tmpColumn in tmpMeadowColumnTypes) || tmpBlobTypes[tmpMeadowColumnTypes[tmpColumn]]))
			{
				continue;
			}
			tmpSchemaCandidates.push(
				{
					Key: tmpColumn,
					DisplayName: tmpProperties[tmpColumn].title || tmpColumn,
					ManifestHash: 'Default',
					PictDashboard: { ValueTemplate: '{~ProcessCell:Record.Data.Key~}' },
					Source: 'Schema',
					DefaultHidden: true,
				});
		}
		tmpSchemaCandidates.sort((pA, pB) => String(pA.DisplayName).localeCompare(String(pB.DisplayName)));

		// Audit tier: the identity pair + audit stamps, with friendly labels, trailing the schema
		// tier. Default hidden; the create/update/delete user references resolve names via the same
		// ProcessCell path as any other entity-reference column. (Pair with the show-deleted filter
		// — RecordSetListShowDeletedFilter — to make the three Deleted* columns meaningful.)
		const tmpAuditColumnLabels =
		{
			[`ID${tmpConfig.Entity}`]: 'ID',
			[`GUID${tmpConfig.Entity}`]: 'GUID',
			'CreateDate': 'Created',
			'CreatingIDUser': 'Created by',
			'UpdateDate': 'Updated',
			'UpdatingIDUser': 'Updated by',
			'Deleted': 'Deleted',
			'DeleteDate': 'Deleted on',
			'DeletingIDUser': 'Deleted by',
		};
		const tmpAuditCandidates = [];
		for (const tmpColumn of Object.keys(tmpAuditColumnLabels))
		{
			if (!tmpProperties || !tmpProperties.hasOwnProperty(tmpColumn) || tmpCuratedKeys[tmpColumn])
			{
				continue;
			}
			tmpAuditCandidates.push(
				{
					Key: tmpColumn,
					DisplayName: tmpAuditColumnLabels[tmpColumn],
					ManifestHash: 'Default',
					PictDashboard: { ValueTemplate: '{~ProcessCell:Record.Data.Key~}' },
					Source: 'Audit',
					DefaultHidden: true,
				});
		}

		pRecordListData.ColumnCandidates = tmpCandidates.concat(tmpSchemaCandidates, tmpAuditCandidates);
		pRecordListData.TableCells = this._computeVisibleTableCells(pRecordListData.ColumnCandidates, pRecordListData.RecordSet);
		// One-or-zero-element array driving the chooser button render (the {~TS:~} conditional trick).
		pRecordListData.ColumnChooserSlot = [ { RecordSet: pRecordListData.RecordSet } ];
		return pRecordListData;
	}

	/**
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 * @param {boolean} [pBodyOnly] - When true, re-render only the rows + pagination (page change), leaving the filter view intact.
	 *
	 * @return {Promise<void>}
	 */
	async renderList(pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize, pBodyOnly)
	{
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetList: No provider found for ${pProviderHash} in RecordSet ${(pRecordSetConfiguration || {}).RecordSet}.  List Render failed.`);
			return;
		}

		// Remember how this list was rendered so a column-visibility change can rerun the exact same
		// render (the manifest delegation below overwrites this with its own, which is what we want).
		this._lastListRenderArgs = { Method: 'renderList', Args: [ pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize ] };

		if (pRecordSetConfiguration.RecordSetListManifestOnly)
		{
			const tmpManifestHash = pRecordSetConfiguration.RecordSetListDefaultManifest || pRecordSetConfiguration.RecordSetListManifests?.[0];
			const tmpManifest = this.pict.PictSectionRecordSet.manifestDefinitions[tmpManifestHash];
			if (!tmpManifest)
			{
				this.pict.log.error(`RecordSetList: No manifest found for ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			}
			else
			{
				return this.renderListFromManifest(tmpManifest, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize, pBodyOnly);
			}
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordListData =
		{
			"Title": pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Paint a loading shell before the (potentially slow) fetch so the prior page
		// doesn't sit silently; the real list render replaces it when data arrives.
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordListData.RecordSet);
		}
		this._projectLoadingShell(tmpRecordListData);
		// Fetch the records
		const [ tmpRecords, tmpTotalRecordCount, tmpRecordSchema ] = await Promise.all([
			this.pict.providers[pProviderHash].getRecords(tmpRecordListData),
			this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordListData),
			this.pict.providers[pProviderHash].getRecordSchema(),
		]);
		tmpRecordListData.Records = tmpRecords;
		// Get the total record count
		tmpRecordListData.TotalRecordCount = tmpTotalRecordCount;
		// Get the record schema
		tmpRecordListData.RecordSchema = tmpRecordSchema;

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordListData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		tmpRecordListData.PageEnd = Number(tmpRecordListData.Offset) + tmpRecordListData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordListData.PageStart = (tmpRecordListData.Records.Records.length > 0) ? (Number(tmpRecordListData.Offset) + 1) : 0;

		// Compute the number of pages total
		tmpRecordListData.PageCount = Math.ceil(tmpRecordListData.TotalRecordCount.Count / tmpRecordListData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordListData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordListData.Offset / tmpRecordListData.PageSize)
			});
		tmpRecordListData.PageLinks = [];
		for (let i = 0; i < tmpRecordListData.PageCount; i++)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinks[tmpRecordListData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordListData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordListData.PageLinks.length, tmpRecordListData.PageLinkBookmarks.Current + 10);
		tmpRecordListData.PageLinksLimited = tmpRecordListData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${0}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordListData.PageLinks.length)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordListData.PageLinkBookmarks.Previous = tmpRecordListData.PageLinkBookmarks.Current - 1;
		tmpRecordListData.PageLinkBookmarks.Next = tmpRecordListData.PageLinkBookmarks.Current + 1;
		tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordListData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordListData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordListData.PageLinkBookmarks.Next >= tmpRecordListData.PageLinks.length)
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Next];
		}

		// When there is only a single page there is nothing to paginate: hide the page
		// buttons and the previous/next links. The "Showing X to Y of Z" summary stays.
		if (tmpRecordListData.PageCount <= 1)
		{
			tmpRecordListData.PageLinksLimited = [];
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		// Put code here to preprocess columns into other data parts.
		if (tmpRecordListData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
		{
			tmpRecordListData.TableCells = tmpRecordListData.RecordSetConfiguration.RecordSetListColumns.map((key) =>
				{
					if (typeof key === 'object')
					{
						if (!key.DisplayName)
						{
							key.DisplayName = key.Key; //FIXME: use schema?
						}
						if (!key.ManifestHash)
						{
							key.ManifestHash = 'Default';
						}
						if (!key.PictDashboard)
						{
							key.PictDashboard =
							{
								ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
							};
						}
						return key;
					}
					return {
						Key: key,
						DisplayName: key, //FIXME: use schema?
						ManifestHash: 'Default',
						PictDashboard:
						{
							ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
						},
					};
				});
		}
		else
		{
			this.dynamicallyGenerateColumns(tmpRecordListData);
		}
		this._composeColumnCandidates(tmpRecordListData);
		this._lastRecordListData = tmpRecordListData;
		tmpRecordListData = this.onBeforeRenderList(tmpRecordListData);

		this._paintRecordList(tmpRecordListData, pBodyOnly);
	}

	/**
	 * @param {object} pManifest
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 * @param {boolean} [pBodyOnly] - When true, re-render only the rows + pagination (page change), leaving the filter view intact.
	 *
	 * @return {Promise<void>}
	 */
	async renderListFromManifest(pManifest, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize, pBodyOnly)
	{
		if (!pRecordSetConfiguration)
		{
			this.pict.log.error(`RecordSetList: No record set configuration found.  List Render failed.`);
			return;
		}
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetList: No provider found for ${pProviderHash} in ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			return;
		}

		// Remember how this list was rendered so a column-visibility change can rerun the exact same
		// render. When renderList delegated here this overwrite wins — a rerun skips re-resolving the
		// manifest — and hosts that call renderListFromManifest directly are covered the same way.
		this._lastListRenderArgs = { Method: 'renderListFromManifest', Args: [ pManifest, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize ] };

		let tmpTitle = pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet;
		if (pManifest && pManifest.TitleTemplate)
		{
			tmpTitle = this.pict.parseTemplate(pManifest.TitleTemplate, pRecordSetConfiguration);
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordListData =
		{
			"Title": tmpTitle,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Paint a loading shell before the (potentially slow) fetch so the prior page
		// doesn't sit silently; the real list render replaces it when data arrives.
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordListData.RecordSet);
		}
		this._projectLoadingShell(tmpRecordListData);
		// Fetch the records
		tmpRecordListData.Records = await this.pict.providers[pProviderHash].getDecoratedRecords(tmpRecordListData);
		// Get the total record count
		tmpRecordListData.TotalRecordCount = await this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordListData);
		// Get the record schema
		tmpRecordListData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordListData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		const tmpOffset = Number(tmpRecordListData.Offset);
		tmpRecordListData.PageEnd = tmpOffset + tmpRecordListData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordListData.PageStart = (tmpRecordListData.Records.Records.length > 0) ? (tmpOffset + 1) : 0;

		// Compute the number of pages total
		tmpRecordListData.PageCount = Math.ceil(tmpRecordListData.TotalRecordCount.Count / tmpRecordListData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordListData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordListData.Offset / tmpRecordListData.PageSize)
			});
		tmpRecordListData.PageLinks = [];
		for (let i = 0; i < tmpRecordListData.PageCount; i++)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinks[tmpRecordListData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordListData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordListData.PageLinks.length, tmpRecordListData.PageLinkBookmarks.Current + 10);
		tmpRecordListData.PageLinksLimited = tmpRecordListData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/0/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/0/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordListData.PageLinks.length)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordListData.PageLinkBookmarks.Previous = tmpRecordListData.PageLinkBookmarks.Current - 1;
		tmpRecordListData.PageLinkBookmarks.Next = tmpRecordListData.PageLinkBookmarks.Current + 1;
		tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordListData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordListData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordListData.PageLinkBookmarks.Next >= tmpRecordListData.PageLinks.length)
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Next];
		}

		// When there is only a single page there is nothing to paginate: hide the page
		// buttons and the previous/next links. The "Showing X to Y of Z" summary stays.
		if (tmpRecordListData.PageCount <= 1)
		{
			tmpRecordListData.PageLinksLimited = [];
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		tmpRecordListData.TableCells = pManifest?.TableCells;

		if (!tmpRecordListData.TableCells)
		{
			if (tmpRecordListData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
			{
				tmpRecordListData.TableCells = tmpRecordListData.RecordSetConfiguration.RecordSetListColumns.map((key) =>
					{
						if (typeof key === 'object')
						{
							if (!key.DisplayName)
							{
								key.DisplayName = key.Key; //FIXME: use schema?
							}
							if (!key.ManifestHash)
							{
								key.ManifestHash = 'Default';
							}
							if (key.PictDashboard && !key.PictDashboard.ValueTemplate)
							{
								key.PictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
							}
							return key;
						}
						return {
							Key: key,
							DisplayName: key, //FIXME: use schema?
							ManifestHash: 'Default',
							PictDashboard:
							{
								ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
							},
						};
					});
			}
			else
			{
				this.dynamicallyGenerateColumns(tmpRecordListData);
			}
		}

		this._composeColumnCandidates(tmpRecordListData);
		this._lastRecordListData = tmpRecordListData;
		tmpRecordListData = this.onBeforeRenderList(tmpRecordListData);

		this.pict.providers.DynamicRecordsetSolver.solveDashboard(pManifest, tmpRecordListData.Records.Records);

		this._paintRecordList(tmpRecordListData, pBodyOnly);
	}

	/**
	 * Paint the computed record-list data into the DOM.
	 *
	 * Full render (pBodyOnly falsy): render the whole `PRSP_Renderable_List` (title, header, filters,
	 * pagination, rows) into the list destination — the original behavior.
	 *
	 * Body-only render (pBodyOnly true): only the page changed, so re-render just the rows and the two
	 * pagination strips into their stable containers, leaving the filter view (and its picker/control state)
	 * completely untouched. Each child is rendered with the freshly-computed record passed as an object, so
	 * it produces exactly what the inline `{~V:~}` render would have.
	 *
	 * @param {Record<string, any>} pRecordListData - The fully-computed list data (records, pagination, cells).
	 * @param {boolean} [pBodyOnly] - When true, surgically re-render only rows + pagination.
	 * @return {void}
	 */
	_paintRecordList(pRecordListData, pBodyOnly)
	{
		// Stamp the opt-in sort state onto the header cells before the header repaints (no-op unless sorting is on).
		this._stampSortState(pRecordListData);
		const fLogRendered = function (pError)
		{
			if (pError)
			{
				this.pict.log.error(`RecordSetList: Error rendering list ${pError}`, pRecordListData);
				return;
			}
			if (this.pict.LogNoisiness > 0)
			{
				this.pict.log.info(`RecordSetList: Rendered list ${pRecordListData.RecordSet} with ${pRecordListData.Records.Records.length} records.`, pRecordListData);
			}
			else
			{
				this.pict.log.info(`RecordSetList: Rendered list ${pRecordListData.RecordSet} with ${pRecordListData.Records.Records.length} records.`);
			}
		}.bind(this);

		if (!pBodyOnly)
		{
			this.renderAsync('PRSP_Renderable_List', pRecordListData.RenderDestination, pRecordListData, fLogRendered);
			return;
		}

		// Page-only change: re-render the two pagination strips (current page + "showing X of Y") and the
		// rows, each into its own stable container. The filter view, title, and header list are left as-is.
		this.childViews.paginationTop.renderAsync('PRSP_Renderable_PaginationTop', '#PRSP_PaginationTop_Container', pRecordListData, null, () => { });
		this.childViews.paginationBottom.renderAsync('PRSP_Renderable_PaginationBottom', '#PRSP_PaginationBottom_Container', pRecordListData, null, () => { });
		this.childViews.recordList.renderAsync('PRSP_Renderable_RecordList', '#PRSP_RecordList_Container', pRecordListData, null,
			function (pError)
			{
				// Release the height floor that was pinned while the spinner showed (see _projectLoadingShell),
				// now that the real rows are back in and the container can size to its content again.
				const tmpRows = this.pict.ContentAssignment.getElement('#PRSP_RecordList_Container');
				if (tmpRows.length)
				{
					tmpRows[0].style.minHeight = '';
				}
				fLogRendered(pError);
			}.bind(this));
	}

	/**
	 * Set a column's visibility for the currently rendered list (called by the column chooser).
	 *
	 * Persists the override, then repaints the rows + pagination body-only from the data already
	 * in hand — except when a Lite-fetched list is showing a schema-tier column whose values were
	 * never fetched, in which case the same render is rerun so the provider widens the projection.
	 *
	 * @param {string} pRecordSet - The record set the column belongs to (stale-chooser guard)
	 * @param {string} pKey - The column key
	 * @param {boolean} pVisible - Whether the column should be visible
	 * @return {boolean} The column's resulting visibility.
	 */
	setColumnVisibility(pRecordSet, pKey, pVisible)
	{
		const tmpListData = this._lastRecordListData;
		if (!tmpListData || tmpListData.RecordSet !== pRecordSet || !Array.isArray(tmpListData.ColumnCandidates))
		{
			this.log.warn(`RecordSetList: setColumnVisibility for [${pRecordSet}.${pKey}] ignored — that list is not the one currently rendered.`);
			return false;
		}
		const tmpCandidate = tmpListData.ColumnCandidates.find((pCandidate) => pCandidate.Key === pKey);
		if (!tmpCandidate)
		{
			this.log.warn(`RecordSetList: setColumnVisibility for unknown column [${pKey}] on [${pRecordSet}] ignored.`);
			return false;
		}
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		if (!tmpColumnProvider)
		{
			return this._effectiveColumnVisibility(tmpCandidate, {});
		}
		// Keep at least one column visible — an all-hidden table is a confusing dead end.
		if (pVisible !== true)
		{
			const tmpOverrides = tmpColumnProvider.getColumnVisibilityOverrides(pRecordSet, 'List');
			const tmpVisibleCount = tmpListData.ColumnCandidates.filter((pCandidate) => this._effectiveColumnVisibility(pCandidate, tmpOverrides)).length;
			if ((tmpVisibleCount <= 1) && this._effectiveColumnVisibility(tmpCandidate, tmpOverrides))
			{
				this.log.warn(`RecordSetList: refusing to hide the last visible column [${pKey}] on [${pRecordSet}].`);
				return true;
			}
		}
		tmpColumnProvider.setColumnVisibilityOverride(pRecordSet, 'List', pKey, (pVisible === true));

		// Lite projections omit unrequested columns entirely, so a newly shown schema- or audit-tier
		// column with no data in the fetched records needs one refetch (the provider reads the override
		// map at fetch time and widens the projection). Curated/manifest columns are always fetched or
		// solved, and schema/audit keys are flat — a first-record key check is sound. (The identity pair,
		// CreatingIDUser, and UpdateDate ride free in every Lite record, so they pass the key check.)
		const tmpRecords = (tmpListData.Records && Array.isArray(tmpListData.Records.Records)) ? tmpListData.Records.Records : [];
		const tmpNeedsRefetch = (pVisible === true)
			&& (tmpCandidate.Source !== 'Curated')
			&& (tmpListData.RecordSetConfiguration && tmpListData.RecordSetConfiguration.RecordSetListLiteFetch === true)
			&& (tmpRecords.length > 0)
			&& !(pKey in tmpRecords[0]);
		if (tmpNeedsRefetch)
		{
			this._rerunLastListRender();
		}
		else
		{
			this._repaintWithColumnState();
		}
		return (pVisible === true);
	}

	/**
	 * Clear every column-visibility override for the currently rendered list and repaint with the
	 * defaults (called by the column chooser's Reset). Never needs a refetch: resetting only
	 * restores curated columns (always fetched) and hides schema extras.
	 *
	 * @param {string} pRecordSet - The record set to reset (stale-chooser guard)
	 * @return {boolean} True when the reset happened.
	 */
	resetColumnVisibility(pRecordSet)
	{
		const tmpListData = this._lastRecordListData;
		if (!tmpListData || tmpListData.RecordSet !== pRecordSet)
		{
			this.log.warn(`RecordSetList: resetColumnVisibility for [${pRecordSet}] ignored — that list is not the one currently rendered.`);
			return false;
		}
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		if (tmpColumnProvider)
		{
			tmpColumnProvider.clearColumnVisibilityOverrides(pRecordSet, 'List');
		}
		this._repaintWithColumnState();
		return true;
	}

	/**
	 * Repaint the rows + pagination (body-only) from the last composed list data, with TableCells
	 * recomputed from the pristine candidates + current overrides. onBeforeRenderList is re-invoked
	 * — it is the documented seam where hosts append custom cells, and rebuilding TableCells from
	 * candidates each paint means hook mutations apply exactly once per paint. (Hosts that decorate
	 * Records in the hook must keep that decoration idempotent; the hook already re-runs on every
	 * page change.) No loading shell: the data is already in hand, so the swap is immediate.
	 *
	 * @return {void}
	 */
	_repaintWithColumnState()
	{
		const tmpSourceData = this._lastRecordListData;
		if (!tmpSourceData || !Array.isArray(tmpSourceData.ColumnCandidates))
		{
			return;
		}
		let tmpPaintData = Object.assign({}, tmpSourceData);
		tmpPaintData.TableCells = this._computeVisibleTableCells(tmpSourceData.ColumnCandidates, tmpSourceData.RecordSet);
		tmpPaintData = this.onBeforeRenderList(tmpPaintData);
		this._paintRecordList(tmpPaintData, true);
	}

	/**
	 * Rerun the last list render with the same arguments (body-only — the list shell and filters
	 * are already on screen). Used when a column toggle needs a refetch under Lite.
	 *
	 * @return {Promise<void>|undefined}
	 */
	_rerunLastListRender()
	{
		if (!this._lastListRenderArgs)
		{
			return;
		}
		const tmpArgs = this._lastListRenderArgs.Args.concat([ true ]);
		return this[this._lastListRenderArgs.Method](...tmpArgs);
	}

	onInitialize()
	{
		this.childViews.headerList = this.pict.addView('PRSP-List-HeaderList', viewHeaderList.default_configuration, viewHeaderList);
		this.childViews.title = this.pict.addView('PRSP-List-Title', viewTitle.default_configuration, viewTitle);
		this.childViews.filters = this.pict.views['PRSP-Filters'] || this.pict.addView('PRSP-Filters', { }, viewFilters);
		this.childViews.paginationTop = this.pict.addView('PRSP-List-PaginationTop', viewPaginationTop.default_configuration, viewPaginationTop);
		this.childViews.recordList = this.pict.addView('PRSP-List-RecordList', viewRecordList.default_configuration, viewRecordList);
		this.childViews.recordListHeader = this.pict.addView('PRSP-List-RecordListHeader', viewRecordListHeader.default_configuration, viewRecordListHeader);
		this.childViews.recordListEntry = this.pict.addView('PRSP-List-RecordListEntry', viewRecordListEntry.default_configuration, viewRecordListEntry);
		this.childViews.paginationBottom = this.pict.addView('PRSP-List-PaginationBottom', viewPaginationBottom.default_configuration, viewPaginationBottom);
		this.childViews.columnChooser = this.pict.addView('PRSP-List-ColumnChooser', viewColumnChooser.default_configuration, viewColumnChooser);

		// Initialize the subviews
		this.childViews.headerList.initialize();
		this.childViews.title.initialize();
		this.childViews.paginationTop.initialize();
		this.childViews.recordList.initialize();
		this.childViews.recordListHeader.initialize();
		this.childViews.recordListEntry.initialize();
		this.childViews.paginationBottom.initialize();
		this.childViews.columnChooser.initialize();

		return super.onInitialize();
	}
}

module.exports = viewRecordSetList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__List;


},{"../RecordSet-Filters.js":626,"../RecordSet-RecordBaseView.js":627,"./RecordSet-List-ColumnChooser.js":671,"./RecordSet-List-HeaderList.js":672,"./RecordSet-List-PaginationBottom.js":673,"./RecordSet-List-PaginationTop.js":674,"./RecordSet-List-RecordList.js":675,"./RecordSet-List-RecordListEntry.js":676,"./RecordSet-List-RecordListHeader.js":677,"./RecordSet-List-Sort.js":678,"./RecordSet-List-Title.js":679}],681:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');
const libViewAssociationEditor = require('../associate/RecordSet-AssociationEditor.js');

// Identity + audit field names stamped on (virtually) every Meadow entity. These are
// surfaced through the record audit header (the first-class activity line + the Details
// modal), not inline in the record body. The entity's own ID/GUID field names are added
// at suppression time via the provider's getIDField()/getGUIDField().
// Audit / sync-bookkeeping fields suppressed from the record body and surfaced in the Details modal.
// ExternalSyncDate / ExternalSyncGUID are the external-sync auditing stamps (Headlight integration sync).
const _AUDIT_FIELD_NAMES = ['CreatingIDUser', 'UpdatingIDUser', 'DeletingIDUser', 'Deleted', 'CreateDate', 'UpdateDate', 'DeleteDate', 'ExternalSyncDate', 'ExternalSyncGUID'];

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__Read = (
	{
		ViewIdentifier: 'PRSP-Read',

		DefaultRenderable: 'PRSP_Renderable_Read',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
			/* Soft-deleted record banner (the ViewDeleted route) — quiet alarm, theme-token driven. */
		.prsp-read-deleted-banner { display: flex; align-items: center; gap: 0.5rem; margin: 0 0 0.85rem; padding: 0.55rem 0.85rem;
			border: 1px solid var(--theme-color-status-error, #c0504d); border-radius: 8px; font-size: 0.92rem;
			color: var(--theme-color-status-error, #c0504d);
			background: color-mix(in srgb, var(--theme-color-status-error, #c0504d) 8%, transparent); }
		.prsp-audit-header { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin: 0 0 1rem; }
			.prsp-audit-line { display: inline-flex; align-items: center; gap: 0.4rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; }
			.prsp-audit-line .pict-icon { font-size: 0.8rem; }
			.prsp-audit-line strong { color: var(--theme-color-text-secondary, #45505f); font-weight: 600; }
			.prsp-audit-button { display: inline-flex; align-items: center; gap: 0.4rem; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-muted, #6b7686); border-radius: 8px; padding: 0.35rem 0.65rem; font: inherit; font-size: 0.82rem; cursor: pointer; transition: all 0.15s ease; }
			.prsp-audit-button:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
			.prsp-record-related:empty { display: none; }
			.prsp-audit-anchor { position: relative; }
			.prsp-audit-popover { position: absolute; top: calc(100% + 8px); right: 0; min-width: 380px; width: max-content; max-width: 90vw; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 14px 36px rgba(15, 23, 42, 0.18); padding: 1rem 1.1rem; z-index: 40; display: none; }
			.prsp-audit-popover.is-open { display: block; }
			.prsp-audit-dl { display: grid; grid-template-columns: auto auto; gap: 0.6rem 1rem; align-items: baseline; margin: 0; }
			.prsp-audit-dl dd { white-space: nowrap; }
			.prsp-audit-dl dt { color: var(--theme-color-text-muted, #6b7686); font-size: 0.74rem; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
			.prsp-audit-dl dd { margin: 0; color: var(--theme-color-text-primary, #1f2733); font-size: 0.9rem; }
			.prsp-audit-dl dd small { color: var(--theme-color-text-muted, #6b7686); }
			.prsp-audit-dl dd.is-deleted { color: var(--theme-color-status-error, #b62828); }
			.prsp-audit-guid { display: inline-flex; align-items: center; gap: 0.4rem; }
			.prsp-audit-guid code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.8rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-secondary, #f5f6f8); padding: 0.1rem 0.4rem; border-radius: 5px; }
			.prsp-audit-copy { border: 0; background: transparent; color: var(--theme-color-text-muted, #6b7686); cursor: pointer; padding: 0.1rem 0.3rem; border-radius: 4px; font-size: 0.85rem; }
			.prsp-audit-copy:hover { color: var(--theme-color-brand-primary, #156dd1); }
			/* Tufte: in view mode the record VALUES are the foreground. Read-only fields render as
			   text (not boxed inputs), so the data outweighs its labels and section chrome. */
			.prsp-record-read input.input[readonly], .prsp-record-read input.input[disabled], .prsp-record-read textarea[readonly], .prsp-record-read textarea[disabled], .prsp-record-read select[disabled] { background: transparent !important; border-color: transparent !important; box-shadow: none !important; padding-left: 0 !important; padding-right: 0 !important; height: auto !important; min-height: 0 !important; opacity: 1 !important; cursor: default !important; color: var(--theme-color-text-primary, #1f2733) !important; -webkit-text-fill-color: var(--theme-color-text-primary, #1f2733) !important; font-weight: 600 !important; font-size: 1.1rem !important; }
			.prsp-record-read .label { font-size: 0.68rem !important; font-weight: 600 !important; text-transform: uppercase !important; letter-spacing: 0.05em !important; color: var(--theme-color-text-muted, #6b7686) !important; margin-bottom: 0.05rem !important; }
			.prsp-record-read .section-header { background: var(--theme-color-background-selected, #e3edfb) !important; color: var(--theme-color-brand-primary, #156dd1) !important; font-size: 0.74rem !important; font-weight: 700 !important; text-transform: uppercase !important; letter-spacing: 0.06em !important; padding: 0.4rem 0.8rem !important; border-radius: 6px !important; border-bottom: 0 !important; margin: 1.1rem 0 0.7rem !important; }
				/* Record header — a readable title (the record's own name, via a heuristic) with the entity
				   type as an eyebrow, instead of a raw "RecordSet GUIDField [guid]" string. */
			.prsp-read-head { margin: 0 0 1.1rem; }
			.prsp-read-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); }
			.prsp-read-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); }
				/* Read-view association tabs — pill nav, shared by the Tab and Split layouts (single source;
				   layouts style only their own nav container). */
			.psrs-tab { padding: 0.4rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; cursor: pointer; font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-panel, #fff); user-select: none; transition: all 0.15s ease; }
			.psrs-tab:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
			.psrs-tab.is-active { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
			.psrs-tab-body { display: none; }
			.psrs-tab-body.is-active { display: block; }
		`,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Read-RecordRead-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-RecordRead-Template] -->
						<div>
							{~TSWP:PRSP-Read-RecordRead-Template-Row:Record.DisplayFields:Record.Record~}
						</div>
						{~T:PRSP-Read-RecordButtonBar-Template~}
						<!-- DefaultPackage end view template:  [PRSP-Read-RecordRead-Template] -->
					`
				},
				{
					Hash: 'PRSP-Read-RecordRead-Template-Row',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-RecordRead-Template] -->
						<div>
							<span style="font-style: italic;">{~D:Record.Data.DisplayName~}</span>
							<span style="font-weight: bold;">{~DVBK:Record.Payload:Record.Data.Key~}</span>
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-RecordRead-Template] -->
					`
				},
				{
					Hash: 'PRSP-Read-RecordButtonBar-Template',
					Template: /*html*/`
						<style>
							.record-button-bar-hidden
							{
								display: none;
							}
							.record-button-bar
							{
								display: flex;
								margin-top: 15px;
							}
							.record-button-bar > button
							{
								margin-right: 10px;
							}
						.record-button-bar > button.prsp-read-delete-btn
							{
								margin-left: auto;
								margin-right: 0;
								border: 1px solid var(--theme-color-status-error, #b62828);
								background: var(--theme-color-status-error, #b62828);
								color: #fff;
								border-radius: 6px;
								cursor: pointer;
							}
						.record-button-bar > button.prsp-read-delete-btn:hover
							{
								background: var(--theme-color-status-error-hover, #9c2020);
							}
						</style>
						<div class="record-button-bar">
							<button id="PRSP-Read-CancelButton" type="button" onclick="_Pict.views['RSP-RecordSet-Read'].cancel()">Cancel</button>
							<button id="PRSP-Read-SaveButton" type="button" onclick="_Pict.views['RSP-RecordSet-Read'].save()">Save</button>
							<button id="PRSP-Read-EditButton" type="button" onclick="_Pict.views['RSP-RecordSet-Read'].edit()">Edit</button>
							<button id="PRSP-Read-DeleteButton" type="button" class="prsp-read-delete-btn" onclick="_Pict.views['RSP-RecordSet-Read'].deleteRecord()">Delete</button>
						</div>
					`
				},
				{
					Hash: 'PRSP-Read-RecordTab-Template',
					Template: /*html*/`<!-- Placeholder for tabs, something has gone wrong if this comment is rendered. -->`
				},
				{
					Hash: 'PRSP-Read-RecordTabNav-Template',
					Template: /*html*/`<!-- Placeholder for tabs, something has gone wrong if this comment is rendered. -->`
				},
				{
					// Readable record header, shared by all three layouts: the record's display name (heuristic)
					// over a small entity-type eyebrow, falling back to the GUID field + value when the record
					// has no obvious name. DisplayTitle / TitleEyebrow are computed in renderRead().
					Hash: 'PRSP-Read-Header-Template',
					Template: /*html*/`
						<div class="prsp-read-head">
							<div class="prsp-read-eyebrow">{~D:Record.TitleEyebrow~}</div>
							<h1 class="prsp-read-title">{~D:Record.DisplayTitle~}</h1>
						</div>`
				},
				{
					Hash: 'PRSP-Read-Basic-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-Basic-Template] -->
						{~T:PRSP-Read-Header-Template~}
						<!--
						{~DJ:Record~}
						-->
						<div>
							{~T:PRSP-Read-RecordRead-Template~}
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-Basic-Template] -->
						`
				},
				{
					Hash: 'PRSP-Read-Split-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-Split-Template] -->
						<style>
							.psrs-split-tabnav { display: flex; justify-content: flex-end; gap: 0.4rem; margin: 0.4rem 0 0.2rem; }
							#PRSP-Read-Tab-Nav { display: inline-flex; gap: 0.35rem; flex-wrap: wrap; }
							.psrs-tab { padding: 0.4rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; cursor: pointer; font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-panel, #fff); user-select: none; }
							.psrs-tab:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
							.psrs-tab.is-active { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
							.psrs-split-view { display: flex; height: 100%; }
							.psrs-left-panel { overflow: auto; }
							.psrs-right-panel { overflow: auto; flex: 1 1 auto; }
							#psrs-resize { flex: 0 0 auto; padding-left: 10px; padding-right: 10px; cursor: col-resize; }
							#psrs-resize > div { width: 1px; height: 100%; background-color: var(--theme-color-border-default, rgba(0,0,0,0.2)); }
							.psrs-tab-body { display: none; }
							.psrs-tab-body.is-active { display: block; }
							/* Collapsed (default): no association is open, so the record takes the full width and the
							   association pane + resizer are hidden until a tab is chosen. */
							.psrs-split-view.psrs-collapsed .psrs-right-panel,
							.psrs-split-view.psrs-collapsed #psrs-resize { display: none; }
							.psrs-split-view.psrs-collapsed .psrs-left-panel { min-width: 100% !important; width: 100%; }
						</style>
						{~T:PRSP-Read-Header-Template~}
						<div class="psrs-split-tabnav">{~T:PRSP-Read-RecordTabNav-Template~}</div>
						<div class="psrs-split-view psrs-collapsed">
							<div class="psrs-left-panel" style="min-width: {~D:Record.SplitLeftWidth~};">
								{~T:PRSP-Read-RecordRead-Template~}
							</div>
							<div id="psrs-resize"><div></div></div>
							<div class="psrs-right-panel">
								{~T:PRSP-Read-RecordTab-Template~}
							</div>
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-Split-Template] -->
						`
				},
				{
					Hash: 'PRSP-Read-Tab-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-Tab-Template] -->
						{~T:PRSP-Read-Header-Template~}
						<!--
						{~DJ:Record~}
						-->
						<style>
							/* Tab layout owns only its nav container; the pill styling for .psrs-tab /
							   .psrs-tab-body is shared from the view's persistent CSS block. */
							#PRSP-Read-Tab-Nav { display: flex; flex-wrap: wrap; gap: 0.35rem; width: 100%; margin: 0 0 1.25rem; padding-bottom: 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
						</style>
						<div class="psrs-tab-view">
							<div id="PRSP-Read-Tabs-Container">
								{~T:PRSP-Read-RecordTabNav-Template~}
								{~T:PRSP-Read-RecordTab-Template~}
							</div>
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-Tab-Template] -->
						`
				},
				{
					Hash: 'PRSP-Read-Link-Name-Template',
					Template: `View`
				},
				{
					Hash: 'PRSP-Read-Link-URL-Template',
					// TODO: Double payload pattern...
					// Soft-deleted rows (visible via the show-deleted filter) route to ViewDeleted, whose
					// lookup explicitly includes deleted records — a plain View would find nothing.
					Template: `#/PSRS/{~D:Record.Payload.Payload.RecordSet~}/View{~NE:Record.Payload.Data.Deleted^Deleted~}/{~DVBK:Record.Payload.Data:Record.Payload.Payload.GUIDAddress~}`
				},
				// --- Record audit header (themeable; apps brand via --theme-color-* tokens) ---
				{
					Hash: 'PRSP-Read-RecordAuditHeader-Template',
					Template: /*html*/`
						{~TS:PRSP-Read-DeletedBanner-Template:AppData.PRSP_RecordAudit.DeletedBannerSlot~}
						<div class="prsp-audit-header">
							<div class="prsp-audit-activity">{~TS:PRSP-Read-RecordAudit-Line-Template:AppData.PRSP_RecordAudit.ActivitySlot~}</div>
							<div class="prsp-audit-anchor">
								<button type="button" class="prsp-audit-button" title="Identity and audit detail" onclick="_Pict.views['RSP-RecordSet-Read'].toggleRecordAudit()">{~I:Info~}<span>Details</span></button>
								<div class="prsp-audit-popover" id="PRSP-Read-AuditPopover">
									<dl class="prsp-audit-dl">
										<dt>{~D:AppData.PRSP_RecordAudit.IDFieldName~}</dt><dd><span class="prsp-audit-guid"><code>{~D:AppData.PRSP_RecordAudit.IDValue~}</code><button type="button" class="prsp-audit-copy" title="Copy" onclick="_Pict.views['RSP-RecordSet-Read'].copyValue('{~D:AppData.PRSP_RecordAudit.IDValue~}')">{~I:Copy~}</button></span></dd>
										<dt>{~D:AppData.PRSP_RecordAudit.GUIDFieldName~}</dt><dd><span class="prsp-audit-guid"><code>{~D:AppData.PRSP_RecordAudit.GUIDValue~}</code><button type="button" class="prsp-audit-copy" title="Copy" onclick="_Pict.views['RSP-RecordSet-Read'].copyValue('{~D:AppData.PRSP_RecordAudit.GUIDValue~}')">{~I:Copy~}</button></span></dd>
										{~TS:PRSP-Read-RecordAudit-Created-Template:AppData.PRSP_RecordAudit.CreatedSlot~}
										{~TS:PRSP-Read-RecordAudit-Updated-Template:AppData.PRSP_RecordAudit.UpdatedSlot~}
										{~TS:PRSP-Read-RecordAudit-Deleted-Template:AppData.PRSP_RecordAudit.DeletedSlot~}
										{~TS:PRSP-Read-RecordAudit-ExternalSync-Template:AppData.PRSP_RecordAudit.ExternalSyncSlot~}
									</dl>
								</div>
							</div>
						</div>
					`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Line-Template',
					Template: /*html*/`<span class="prsp-audit-line">{~I:Refresh~} {~D:Record.Label~} by <strong>{~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</strong> &middot; {~DateFormat:Record.Date^MMM D, YYYY - h:mm A~}</span>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-UserName-Template',
					Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Created-Template',
					Template: /*html*/`<dt>Created</dt><dd>{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~} <small>by {~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</small></dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Updated-Template',
					Template: /*html*/`<dt>Last updated</dt><dd>{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~} <small>by {~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</small></dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Deleted-Template',
					Template: /*html*/`<dt>Deleted</dt><dd class="is-deleted">{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~} <small>by {~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</small></dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-ExternalSync-Template',
					Template: /*html*/`<dt>External sync</dt><dd>{~TIfAbs:PRSP-Read-RecordAudit-ExternalSyncDate-Template:Record:Record.HasDate^TRUE^~}{~NE:Record.NeverSynced^Never synced~}</dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-ExternalSyncDate-Template',
					Template: /*html*/`{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~}`
				},
				{
					// Soft-deleted record banner (the ViewDeleted route, or a record deleted out from
					// under a normal View). The one-or-zero-element DeletedBannerSlot drives it.
					Hash: 'PRSP-Read-DeletedBanner-Template',
					Template: /*html*/`<div class="prsp-read-deleted-banner">{~I:Warning~} This record has been deleted{~TIfAbs:PRSP-Read-DeletedBanner-Date-Template:Record:Record.HasDate^TRUE^~}.</div>`
				},
				{
					Hash: 'PRSP-Read-DeletedBanner-Date-Template',
					Template: /*html*/` on {~DateFormat:Record.Date^MMM D, YYYY - h:mm A~}`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_Read_Basic',
					TemplateHash: 'PRSP-Read-Basic-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Read_Split',
					TemplateHash: 'PRSP-Read-Split-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Read_Tab',
					TemplateHash: 'PRSP-Read-Tab-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetRead extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__Read, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.layoutType = 'Basic';
		this.action = 'View';
		this.tabs = [];
		this.RecordSet = null;
		this.providerHash = null;
		this.activeTab = null;
		this.mouseHandler = null;
		this.manifest = null;
		this.defaultManifest = null;
		this.GUID = null;
	}

	initializeDragListener()
	{
		let isResizing = false;
		const handleMouseMove = (event) =>
		{
			const resizer = document.getElementById("psrs-resize");
			const leftPanel = document.querySelector(".psrs-left-panel");
			const rightPanel = document.querySelector(".psrs-right-panel");
			if (!isResizing || !(resizer.parentNode instanceof HTMLElement && leftPanel instanceof HTMLElement && rightPanel instanceof HTMLElement))
			{
				return;
			}
			const containerRect = resizer.parentNode.getBoundingClientRect();
			const newLeftWidth = event.clientX - containerRect.left;
			const newRightWidth = containerRect.width - newLeftWidth - resizer.offsetWidth;
			leftPanel.style.width = `${newLeftWidth}px`;
			leftPanel.style.minWidth = `${newLeftWidth}px`;
			rightPanel.style.width = `${newRightWidth}px`;
		}
		if (!this.mouseHandler)
		{
			this.mouseHandler = (event) =>
			{
				isResizing = true;
				document.body.style.userSelect = "none";
				document.addEventListener("mousemove", handleMouseMove);
				document.addEventListener("mouseup", () =>
				{
					isResizing = false;
					document.body.style.userSelect = "";
					document.removeEventListener("mousemove", handleMouseMove);
				});
			};
		}
		const resizer = document.getElementById("psrs-resize");
		resizer.removeEventListener('mousedown', this.mouseHandler);
		resizer.addEventListener("mousedown", this.mouseHandler);
	}

	onAfterRender(pRenderable)
	{
		if (this.layoutType == 'Split')
		{
			this.initializeDragListener();
		}
		
		this.pict.CSSMap.injectCSS();
		this._bindAuditDismiss();
		return super.onAfterRender(pRenderable);
	}

	handleRecordSetReadRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}

		this.action = 'View';
		this.viewingDeletedRecord = false;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;
		tmpProviderConfiguration.GUIDRecord = pRoutePayload.data.GUIDRecord;
		// Remember the record on screen so navigateTab() can build the stable tab route for it.
		this._activeReadRecordSet = pRoutePayload.data.RecordSet;
		this._activeReadGUIDRecord = pRoutePayload.data.GUIDRecord;

		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, pRoutePayload.data.GUIDRecord);
	}

	/**
	 * The deleted-record read route (`/PSRS/:RecordSet/ViewDeleted/:GUIDRecord`): identical to the
	 * View route except the record lookup explicitly includes soft-deleted rows (a normal View of a
	 * deleted record finds nothing — delete tracking filters it out — and renders broken). The flag
	 * also rides the read data as ViewingDeletedRecord, which drives the deleted banner.
	 */
	handleRecordSetReadDeletedRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}

		this.action = 'View';
		this.viewingDeletedRecord = true;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;
		tmpProviderConfiguration.GUIDRecord = pRoutePayload.data.GUIDRecord;

		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, pRoutePayload.data.GUIDRecord);
	}

	handleRecordSetEditRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}

		this.action = 'Edit';
		this.viewingDeletedRecord = false;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;
		tmpProviderConfiguration.GUIDRecord = pRoutePayload.data.GUIDRecord;

		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, pRoutePayload.data.GUIDRecord);
	}

	/**
	 * The tabbed read route (`/PSRS/:RecordSet/View/:GUIDRecord/:Tab`): the read view's own tab clicks navigate
	 * here (via navigateTab) so the active tab is a real URL. When the requested record is already on screen this
	 * is a DOM-only setTab (no reload); a cold deep-link renders the record and lands on the requested tab (stashed
	 * in _pendingReadTab, consumed by the first paint). The base View route without a tab still works unchanged.
	 */
	handleRecordSetReadTabRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}
		const tmpRecordSet = pRoutePayload.data.RecordSet;
		const tmpGUIDRecord = pRoutePayload.data.GUIDRecord;
		const tmpTab = pRoutePayload.data.Tab;
		// Already viewing this exact record → just switch the tab in place (setTab toggles the DOM; no re-fetch).
		if ((this.action === 'View') && !this.viewingDeletedRecord && (this._activeReadRecordSet === tmpRecordSet) && (this._activeReadGUIDRecord === tmpGUIDRecord))
		{
			return this.setTab(tmpTab);
		}
		// Cold deep-link: render the record, landing on the requested tab (via _pendingReadTab on first paint).
		this.action = 'View';
		this.viewingDeletedRecord = false;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpRecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${tmpRecordSet}`;
		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = tmpRecordSet;
		tmpProviderConfiguration.GUIDRecord = tmpGUIDRecord;
		this._activeReadRecordSet = tmpRecordSet;
		this._activeReadGUIDRecord = tmpGUIDRecord;
		// A custom view owns its own paint and never consumes _pendingReadTab; stage the pending tab ONLY for the
		// generic renderRead path below, so a delegated view can't leave a stale tab to leak onto the next read.
		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }
		this._pendingReadTab = tmpTab;
		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, tmpGUIDRecord);
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.addRoute('/PSRS/:RecordSet/View/:GUIDRecord', this.handleRecordSetReadRoute.bind(this));
		// A specific tab on the read view, as a stable/deep-linkable route (see navigateTab + handleRecordSetReadTabRoute).
		pPictRouter.addRoute('/PSRS/:RecordSet/View/:GUIDRecord/:Tab', this.handleRecordSetReadTabRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/ViewDeleted/:GUIDRecord', this.handleRecordSetReadDeletedRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/Edit/:GUIDRecord', this.handleRecordSetEditRoute.bind(this));
		return true;
	}

	async cancel()
	{
		await this.onBeforeView();
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/View/${ this.GUID }`);
	}

	async save()
	{
		await this.onBeforeSave();
		await this.pict.providers[this.providerHash].updateRecord(this.pict.AppData[`${ this.RecordSet }Details`]);
		await this.onBeforeView();
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/View/${ this.GUID }`);
	}

	async edit()
	{
		await this.onBeforeEdit();
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/Edit/${ this.GUID }`);
	}

	/**
	 * Delete the record being viewed. Basic path: confirm via the host modal, delete, and return to the
	 * list. When the recordset opts into advanced delete (`RecordSetAdvancedDelete`), the modal also offers
	 * "Reassign & delete", which hands off to the Bulk Delete screen preselected to this one record — so the
	 * relationship-remapping UI (replacement picker) is reused rather than duplicated here.
	 * @return {Promise<void>}
	 */
	async deleteRecord()
	{
		const tmpRecord = this.pict.AppData[`${ this.RecordSet }Details`];
		const tmpProvider = this.pict.providers[this.providerHash];
		if (!tmpRecord || !tmpProvider)
		{
			return;
		}
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const tmpConfig = this.pict.PictSectionRecordSet ? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this.RecordSet] : null;
		const tmpAdvancedEnabled = !!(tmpConfig && tmpConfig.RecordSetAdvancedDelete === true);

		if (tmpAdvancedEnabled && tmpModal && typeof tmpModal.show === 'function')
		{
			const tmpChoice = await tmpModal.show(
				{
					title: 'Delete record',
					content: '<p>Delete this record, or reassign its related records to a replacement first?</p>',
					buttons:
					[
						{ Hash: 'cancel', Label: 'Cancel' },
						{ Hash: 'reassign', Label: 'Reassign & delete…' },
						{ Hash: 'delete', Label: 'Delete', Style: 'danger' },
					],
				});
			if (tmpChoice === 'reassign')
			{
				const tmpIDField = tmpProvider.getIDField();
				this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/BulkDelete/Record/${ tmpRecord[tmpIDField] }`);
				return;
			}
			if (tmpChoice !== 'delete')
			{
				return;
			}
			return this._performDelete(tmpRecord, tmpProvider);
		}

		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm('Delete this record? This cannot be undone.',
				{ title: 'Delete record', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}
		return this._performDelete(tmpRecord, tmpProvider);
	}

	/**
	 * Delete the record through the provider and return to the list (toasting the outcome).
	 * @param {Record<string, any>} pRecord @param {any} pProvider @return {Promise<void>}
	 */
	async _performDelete(pRecord, pProvider)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		try
		{
			await pProvider.deleteRecord(pRecord);
		}
		catch (pError)
		{
			this.pict.log.error(`RecordSetRead: delete failed for ${ this.RecordSet }.`, pError);
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Could not delete the record.', { type: 'error' }); }
			return;
		}
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Record deleted', { type: 'success' }); }
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/List`);
	}

	/**
	 * Build the record audit header state — the first-class activity line plus the data the
	 * Details modal renders. Identity (ID/GUID) and the create/update/delete stamps are read
	 * straight off the fetched record; the acting-user names resolve lazily via {~E:User^…~}
	 * in the templates (cachetrax-cached), so nothing is pre-resolved here. Stored at
	 * AppData.PRSP_RecordAudit for the templates to consume.
	 *
	 * @param {Record<string, any>} pRecord - The fetched record.
	 */
	_prepareRecordAuditState(pRecord)
	{
		if (!pRecord || typeof pRecord !== 'object')
		{
			this.pict.AppData.PRSP_RecordAudit = false;
			return;
		}
		const tmpProvider = this.pict.providers[this.providerHash];
		const tmpIDField = tmpProvider ? tmpProvider.getIDField() : 'ID';
		const tmpGUIDField = tmpProvider ? tmpProvider.getGUIDField() : 'GUID';

		const tmpHasCreate = this._validAuditDate(pRecord.CreateDate);
		const tmpHasUpdate = this._validAuditDate(pRecord.UpdateDate) && (pRecord.UpdateDate !== pRecord.CreateDate);
		const tmpDeleted = !!pRecord.Deleted && this._validAuditDate(pRecord.DeleteDate);

		let tmpActivitySlot = [];
		if (tmpHasUpdate)
		{
			tmpActivitySlot = [{ Label: 'Updated', Date: pRecord.UpdateDate, UserID: pRecord.UpdatingIDUser }];
		}
		else if (tmpHasCreate)
		{
			tmpActivitySlot = [{ Label: 'Created', Date: pRecord.CreateDate, UserID: pRecord.CreatingIDUser }];
		}

		const tmpIDValue = (pRecord[tmpIDField] != null) ? pRecord[tmpIDField] : '';
		this.pict.AppData.PRSP_RecordAudit =
		{
			RecordSet: this.RecordSet,
			DisplayName: this._computeDisplayName(pRecord),
			IDFieldName: tmpIDField,
			GUIDFieldName: tmpGUIDField,
			IDValue: tmpIDValue,
			GUIDValue: (pRecord[tmpGUIDField] != null) ? pRecord[tmpGUIDField] : '',
			ActivitySlot: tmpActivitySlot,
			CreatedSlot: tmpHasCreate ? [{ Date: pRecord.CreateDate, UserID: pRecord.CreatingIDUser }] : [],
			UpdatedSlot: tmpHasUpdate ? [{ Date: pRecord.UpdateDate, UserID: pRecord.UpdatingIDUser }] : [],
			DeletedSlot: tmpDeleted ? [{ Date: pRecord.DeleteDate, UserID: pRecord.DeletingIDUser }] : [],
			// The ViewDeleted route's banner: present whenever the record is soft-deleted (whether the
			// user arrived via ViewDeleted or the record was deleted out from under a normal View).
			DeletedBannerSlot: (!!pRecord.Deleted) ? [{ Date: pRecord.DeleteDate, UserID: pRecord.DeletingIDUser, HasDate: this._validAuditDate(pRecord.DeleteDate) }] : [],
			// External-sync auditing stamp — surfaced in the Details modal for entities that carry the field.
			ExternalSyncSlot: ('ExternalSyncDate' in pRecord) ? [{ Date: pRecord.ExternalSyncDate, HasDate: this._validAuditDate(pRecord.ExternalSyncDate), NeverSynced: !this._validAuditDate(pRecord.ExternalSyncDate) }] : []
		};
	}

	/**
	 * Compute a human-friendly display name for a record using an opinionated heuristic: first +
	 * last name, then a single descriptive field (FullName, Name, Title, …), else ''. Callers fall
	 * back to the GUID. Lets the page title read "Krishna Pavia Tester" instead of a raw GUID.
	 * @param {Record<string, any>} pRecord
	 * @return {string}
	 */
	_computeDisplayName(pRecord)
	{
		if (!pRecord || typeof pRecord !== 'object')
		{
			return '';
		}
		const tmpFirst = pRecord.NameFirst || pRecord.FirstName;
		const tmpLast = pRecord.NameLast || pRecord.LastName;
		if (tmpFirst || tmpLast)
		{
			return [tmpFirst, tmpLast].filter(Boolean).join(' ').trim();
		}
		const tmpCandidateFields = ['FullName', 'Name', 'Title', 'DisplayName', 'Label', 'Subject', 'Description', 'Code', 'Hash'];
		for (const tmpField of tmpCandidateFields)
		{
			if (pRecord[tmpField] != null && String(pRecord[tmpField]).trim() !== '')
			{
				return String(pRecord[tmpField]).trim();
			}
		}
		return '';
	}

	/**
	 * Whether an audit date value is present and meaningful (guards null/empty and the Meadow
	 * "0000-00-00" zero-date sentinel).
	 * @param {any} pValue
	 * @return {boolean}
	 */
	_validAuditDate(pValue)
	{
		if (!pValue)
		{
			return false;
		}
		return String(pValue).indexOf('0000-00-00') !== 0;
	}

	/**
	 * Toggle the anchored identity + audit popover open or closed. The content is rendered inline
	 * with the record (so the {~E:User^…~} names resolve during the read render); this just flips
	 * its visibility — no overlay.
	 */
	toggleRecordAudit()
	{
		const tmpPopover = document.getElementById('PRSP-Read-AuditPopover');
		if (tmpPopover)
		{
			tmpPopover.classList.toggle('is-open');
		}
	}

	/**
	 * Bind the one-time document handlers that dismiss the audit popover on an outside click or
	 * Escape. Browser-level events with no inline-handler equivalent — bound once and guarded so
	 * re-renders don't stack listeners.
	 */
	_bindAuditDismiss()
	{
		if (this._auditDismissBound || typeof document === 'undefined')
		{
			return;
		}
		this._auditDismissBound = true;
		document.addEventListener('click', (pEvent) =>
		{
			const tmpPopover = document.getElementById('PRSP-Read-AuditPopover');
			if (!tmpPopover || !tmpPopover.classList.contains('is-open'))
			{
				return;
			}
			if (tmpPopover.contains(pEvent.target) || (pEvent.target.closest && pEvent.target.closest('.prsp-audit-button')))
			{
				return;
			}
			tmpPopover.classList.remove('is-open');
		});
		document.addEventListener('keydown', (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				const tmpPopover = document.getElementById('PRSP-Read-AuditPopover');
				if (tmpPopover)
				{
					tmpPopover.classList.remove('is-open');
				}
			}
		});
	}

	/**
	 * Copy a record value (ID or GUID) to the clipboard from the audit popover, with a toast.
	 * @param {string} pValue
	 */
	copyValue(pValue)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const fToast = (pMessage, pType) =>
		{
			if (tmpModal && typeof tmpModal.toast === 'function')
			{
				tmpModal.toast(pMessage, { type: pType || 'success' });
			}
		};
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(pValue).then(() => fToast('GUID copied to clipboard')).catch(() => fToast('Could not copy GUID', 'error'));
		}
		else
		{
			fToast('Could not copy GUID', 'error');
		}
	}

	/**
	 * Remove identity + audit descriptors from a (cloned) manifest so they don't render inline
	 * in the record body — they live behind the audit header's Details modal instead. Also
	 * prunes any section left with no descriptors (e.g. an emptied "Audit Trail" section). The
	 * entity's own ID/GUID field names are suppressed alongside the shared audit fields.
	 * @param {Record<string, any>} pManifest - The cloned manifest to mutate.
	 */
	_suppressAuditDescriptors(pManifest)
	{
		if (!pManifest || !pManifest.Descriptors)
		{
			return;
		}
		const tmpProvider = this.pict.providers[this.providerHash];
		const tmpSuppress = _AUDIT_FIELD_NAMES.concat('IDCustomer'); // IDCustomer: meadow-endpoints/retold tenancy discriminator — server-managed
		if (tmpProvider)
		{
			tmpSuppress.push(tmpProvider.getIDField());
			tmpSuppress.push(tmpProvider.getGUIDField());
		}
		for (const tmpKey of Object.keys(pManifest.Descriptors))
		{
			const tmpFieldName = tmpKey.split('.').pop();
			if (tmpSuppress.indexOf(tmpFieldName) >= 0)
			{
				delete pManifest.Descriptors[tmpKey];
			}
		}
		// Drop sections that no longer have any descriptors (so an emptied titled section like
		// "Audit Trail" doesn't render as a bare heading).
		if (Array.isArray(pManifest.Sections))
		{
			const tmpUsedSections = {};
			for (const tmpKey of Object.keys(pManifest.Descriptors))
			{
				const tmpSectionHash = pManifest.Descriptors[tmpKey] && pManifest.Descriptors[tmpKey].PictForm && pManifest.Descriptors[tmpKey].PictForm.Section;
				if (tmpSectionHash)
				{
					tmpUsedSections[tmpSectionHash] = true;
				}
			}
			pManifest.Sections = pManifest.Sections.filter((pSection) => tmpUsedSections[pSection.Hash]);
		}
	}

	onBeforeRenderRead(pRecordReadData)
	{
		this.formatDisplayData(pRecordReadData);
		return pRecordReadData;
	}

	formatDisplayData(pRecordListData)
	{
		pRecordListData.DisplayFields = [];
		const tmpSchema = pRecordListData.RecordSchema;
		const tmpProperties = tmpSchema?.properties;
		// loop throught the schema and add the columns to the tableCells -- just show all for now.
		for (const tmpColumn in tmpProperties)
		{
			pRecordListData.DisplayFields.push({
				'Key': tmpColumn,
				'DisplayName': tmpProperties?.[tmpColumn].title || tmpColumn,
			});
		}
		return pRecordListData;
	}

	async onBeforeEdit()
	{
		// Hook that is called when transitioning to edit mode. 
	}

	async onBeforeSave()
	{
		// Hook that is called before saving.
	}

	async onBeforeView()
	{
		// Hook that is called when transitioning to view mode. 
	}

	async onBeforeTabChange()
	{
		// Hook that is called when transitioning between tabs.
	}

	async renderRead(pRecordConfiguration, pProviderHash, pRecordGUID)
	{
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetRead: No provider found for ${pProviderHash} in ${pRecordConfiguration.RecordSet}.  Read Render failed.`);
			return false;
		}

		let tmpRecordReadData =
		{
			"RecordSet": pRecordConfiguration.RecordSet,

			"RecordConfiguration": pRecordConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"Record": false,

			// Split layout: the starting width of the record (left) pane; the rest goes to the tabs
			// (right) pane. Any CSS width ('40%', '360px', …); default 50%. The divider stays draggable.
			"SplitLeftWidth": pRecordConfiguration.RecordSetReadSplitLeftWidth || '50%',
		};

		this.GUID = pRecordGUID;

		if (pRecordConfiguration.RecordSet !== this.RecordSet)
		{
			this.RecordSet = pRecordConfiguration.RecordSet;
			this.activeTab = null;
		}

		this.providerHash = pProviderHash;

		// If the record configuration does not have a GUID, try to infer one from the RecordSet name
		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordReadData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		tmpRecordReadData.Record = await this.pict.providers[pProviderHash].getRecordByGUID(pRecordGUID, this.viewingDeletedRecord === true);
		tmpRecordReadData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();
		tmpRecordReadData.ViewingDeletedRecord = (this.viewingDeletedRecord === true);
		this.pict.AppData[`${ tmpRecordReadData.RecordSet }Details`] = tmpRecordReadData.Record;

		// Build the audit header state (first-class activity line + the Details modal) for this record.
		this._prepareRecordAuditState(tmpRecordReadData.Record);

		if (pRecordConfiguration.RecordSetReadManifestOnly)
		{
			this.pict.TemplateProvider.addTemplate(`PRSP-Read-RecordRead-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Read-RecordRead-Template] -->
				<div class="prsp-record-read">
				{~T:PRSP-Read-RecordAuditHeader-Template~}
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordRead', null, true) }</div>
				{~T:PRSP-Read-RecordButtonBar-Template~}
				<div class="prsp-record-related" id="PRSP-Read-Related"></div>
				</div>
				<!-- Manifest dynamic pict end template: [PRSP-Read-RecordRead-Template] -->
			`);
		}
		else
		{
			// Construct a default manifest based on the RecordSchema:
			this.defaultManifest = await this._buildDefaultManifest(tmpRecordReadData.RecordSet);
			this.pict.TemplateProvider.addTemplate(`PRSP-Read-RecordRead-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Read-RecordRead-Template] -->
				<div class="prsp-record-read">
				{~T:PRSP-Read-RecordAuditHeader-Template~}
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordRead', null, true, this.action, this.defaultManifest) }</div>
				{~T:PRSP-Read-RecordButtonBar-Template~}
				<div class="prsp-record-related" id="PRSP-Read-Related"></div>
				</div>
				<!-- Manifest dynamic pict end template: [PRSP-Read-RecordRead-Template] -->
			`);
		}

		if (this.layoutType !== 'Basic')
		{
			this.tabs = await this._structureTabs(pRecordConfiguration, tmpRecordReadData.Record);
			this.pict.TemplateProvider.addTemplate('PRSP-Read-RecordTab-Template', /*html*/`
				<!-- DefaultPackage pict view template: [PRSP-Read-RecordTab-Template] -->
				${ this.tabs.map((t) => t.Template).join('') }
				<!-- DefaultPackage end view template:  [PRSP-Read-RecordTab-Template] -->
			`);
			this.pict.TemplateProvider.addTemplate('PRSP-Read-RecordTabNav-Template', /*html*/`
				<!-- DefaultPackage pict view template: [PRSP-Read-RecordTabNav-Template] -->
				<div id="PRSP-Read-Tab-Nav">
					${ this.tabs.map((t) => t.TabTemplate).join('') }
				</div>
				<!-- DefaultPackage end view template:  [PRSP-Read-RecordTabNav-Template] -->
			`);
		}

		// Readable record header: the record's own name (heuristic — Name / Title / DisplayName / …),
		// with the entity type (camelCase split) as an eyebrow. Falls back to the GUID field + value
		// when the record has no obvious display field. Computed before onBeforeRenderRead so apps can
		// still override DisplayTitle / TitleEyebrow there.
		const tmpReadableName = this._computeDisplayName(tmpRecordReadData.Record);
		tmpRecordReadData.DisplayTitle = tmpReadableName || `${ tmpRecordReadData.GUIDAddress } [${ pRecordConfiguration.GUIDRecord }]`;
		tmpRecordReadData.TitleEyebrow = String(pRecordConfiguration.RecordSet || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2');

		tmpRecordReadData = this.onBeforeRenderRead(tmpRecordReadData);

		this.renderAsync(`PRSP_Renderable_Read_${ this.layoutType }`, tmpRecordReadData.RenderDestination, tmpRecordReadData,
			async function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetRead: Error rendering read ${pError}`, tmpRecordReadData);
					return false;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetRead: Rendered read ${tmpRecordReadData.RecordSet} with ${tmpRecordReadData.RecordConfiguration.GUIDRecord} []`, tmpRecordReadData);
				}
				else
				{
					this.pict.log.info(`RecordSetRead: Rendered read ${tmpRecordReadData.RecordSet} with ${tmpRecordReadData.RecordConfiguration.GUIDRecord} []`);
				}
				for (const s of this.manifest?.Sections || [])
				{
					this.pict.views[`PictSectionForm-${ s.Hash }`].render();
					this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
				}
				for (const t of this.tabs)
				{
					// Isolate each tab's render: the tabs share one sequential loop, so without this a single
					// tab that throws (e.g. an association editor whose list is large enough to overflow the
					// template-render stack) would blank not just itself but every tab AFTER it in the loop.
					// Catch, log, drop a small notice into the failed tab's body, and keep rendering the rest.
					try
					{
						if (t.renderAsync)
						{
							await t.renderAsync();
						}
						else
						{
							t.render();
						}
					}
					catch (pTabError)
					{
						this.pict.log.error(`RecordSetRead: tab "${ t.Title || t.Hash }" failed to render: ${ pTabError && (pTabError.message || pTabError) }`, pTabError);
						const tmpTabBody = t.Hash ? document.getElementById(`PSRS-Tab-${ t.Hash }`) : null;
						if (tmpTabBody && (tmpTabBody.innerHTML.trim() === ''))
						{
							tmpTabBody.innerHTML = `<div class="psrs-tab-error">This tab could not be displayed.</div>`;
						}
					}
				}
				if (this.action == 'Edit')
				{
					document.getElementById('PRSP-Read-EditButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-SaveButton').classList.remove('record-button-bar-hidden');
					document.getElementById('PRSP-Read-CancelButton').classList.remove('record-button-bar-hidden');
				}
				else if (this.viewingDeletedRecord === true)
				{
					// A deleted record can't be edited (the Edit route's lookup excludes deleted rows) —
					// the ViewDeleted page is read-only.
					document.getElementById('PRSP-Read-EditButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-SaveButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-CancelButton').classList.add('record-button-bar-hidden');
				}
				else
				{
					document.getElementById('PRSP-Read-EditButton').classList.remove('record-button-bar-hidden');
					document.getElementById('PRSP-Read-SaveButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-CancelButton').classList.add('record-button-bar-hidden');
				}
				// Delete is available only in read (View) mode: not while editing, and not on a record that is
				// already soft-deleted (the ViewDeleted page is read-only).
				const tmpDeleteButton = document.getElementById('PRSP-Read-DeleteButton');
				if (tmpDeleteButton)
				{
					if (this.action == 'Edit' || this.viewingDeletedRecord === true)
					{
						tmpDeleteButton.classList.add('record-button-bar-hidden');
					}
					else
					{
						tmpDeleteButton.classList.remove('record-button-bar-hidden');
					}
				}
				// Split opens to the record alone via the Full Record tab; other tabbed layouts default to the first
				// tab — unless a stable-route deep-link (/PSRS/:RecordSet/View/:GUIDRecord/:Tab) requested a specific
				// tab, which wins for this first paint and is then consumed.
				this.setTab(this._pendingReadTab || this.activeTab || (this.layoutType === 'Split' ? 'FullRecord' : this.tabs?.[0]?.Hash));
				this._pendingReadTab = null;
				return true;
			}.bind(this));
	}

	/**
	 * Switch tabs via a STABLE ROUTE (`#/PSRS/<RecordSet>/View/<GUIDRecord>/<tab>`) so the active tab lives in the
	 * URL — deep-linkable, bookmarkable, browser back/forward — instead of a URL-less DOM toggle. The tab buttons
	 * call this; the `:Tab` route (handleRecordSetReadTabRoute) applies it in place (setTab is DOM-only, so an
	 * already-open record just switches tabs, no reload). Falls back to a direct setTab when the record identity
	 * or window isn't available (e.g. a host that hasn't wired routing).
	 * @param {string} t - the tab Hash
	 */
	navigateTab(t)
	{
		// Only a live View has a stable per-tab route (/PSRS/:RecordSet/View/:GUIDRecord/:Tab). In Edit mode a tab
		// switch must stay a DOM-only toggle — rewriting the hash to a View URL would re-fetch the record and silently
		// discard the in-progress edit. On a soft-deleted (ViewDeleted) page there is no /ViewDeleted/:Tab route, and
		// the stashed identity may still point at a previously-viewed live record, so a View hash would jump off the
		// deleted record (or re-render it through the live lookup that filters it out). Toggle in place in both cases.
		if ((this.action === 'Edit') || (this.viewingDeletedRecord === true))
		{
			return this.setTab(t);
		}
		const tmpRecordSet = this._activeReadRecordSet;
		const tmpGUID = this._activeReadGUIDRecord;
		if (tmpRecordSet && tmpGUID && (typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/PSRS/${ tmpRecordSet }/View/${ tmpGUID }/${ t }`;
			return true;
		}
		return this.setTab(t);
	}

	async setTab(t)
	{
		// Guard against a stale/unknown tab hash (a bookmarked tab renamed across deploys, or one conditionally
		// skipped for this particular record): in a tabbed layout the record body itself lives inside a tab, so
		// activating a hash that matches no tab would leave every body hidden and blank the whole record. Clamp to
		// the first real tab. Split's synthetic 'FullRecord' has no tab body (it collapses the pane), so leave it be.
		if ((this.layoutType !== 'Split') && t && Array.isArray(this.tabs) && (this.tabs.length > 0) && !this.tabs.some((tmpReadTab) => (tmpReadTab.Hash === t)))
		{
			t = this.tabs[0].Hash;
		}
		// Split layout opens to the record alone via the "Full Record" tab. Choosing an association tab
		// expands its editor beside the record; choosing "Full Record" (or re-choosing the active tab)
		// collapses back to the record-only view. Other layouts always activate the target.
		const tmpSplit = (this.layoutType === 'Split');
		const tmpNewActive = (tmpSplit && (!t || t === 'FullRecord' || t === this.activeTab)) ? 'FullRecord' : t;
		if (this.activeTab !== tmpNewActive)
		{
			await this.onBeforeTabChange();
		}
		this.activeTab = tmpNewActive;
		if (tmpSplit)
		{
			const tmpSplitView = document.querySelector('.psrs-split-view');
			if (tmpSplitView)
			{
				tmpSplitView.classList.toggle('psrs-collapsed', (tmpNewActive === 'FullRecord'));
			}
		}
		const tabSet = document.querySelectorAll('.psrs-tab');
		const tabBodySet = document.querySelectorAll('.psrs-tab-body');
		for (const tb of tabSet)
		{
			tb.classList.remove('is-active');
			if (tmpNewActive && tb.id == `PSRS-TabNav-${ tmpNewActive }`)
			{
				tb.classList.add('is-active');
			}
		}
		for (const tb of tabBodySet)
		{
			tb.classList.remove('is-active');
			if (tmpNewActive && tb.id == `PSRS-Tab-${ tmpNewActive }`)
			{
				tb.classList.add('is-active');
			}
		}
	}

	async _buildDefaultManifest(recordSet)
	{
		// Construct a default manifest based on the RecordSchema:
		const defaultManifest = 
		{
			"Form": "DefaultManifest",
			"Scope": "Default",
			"Descriptors": {},
			"Sections": 
			[
				{
					"Name": "",
					"Hash": "DefaultSection",
					"Solvers": [],
					"ShowTitle": false,
					"Groups": [
						{
							"Name": "",
							"Hash": "DefaultGroup",
							"Rows": [],
							"RecordSetSolvers": [],
							"ShowTitle": false
						}
					]
				}
			]
		}
		let rowCounter = 1;
		const providerHash = `RSP-Provider-${ recordSet }`;
		const schema = await this.pict.providers[providerHash].getRecordSchema();
		for (const p of Object.keys(schema.properties))
		{
			const exclusionSet = [this.pict.providers[this.providerHash].getIDField(), this.pict.providers[this.providerHash].getGUIDField()].concat(_AUDIT_FIELD_NAMES, 'IDCustomer');
			if (exclusionSet.includes(p))
			{
				continue;
			}
			const tmpDescriptor =
			{
				"Name": `${ this.pict.providers[providerHash].getHumanReadableFieldName?.(p) || p }`,
				"Hash": `${ this.pict.providers[this.providerHash].options.Entity  }-${ p }`,
				"DataType": "String",
				"PictForm": 
				{
					"Row": `${ rowCounter }`,
					"Section": "DefaultSection",
					"Group": "DefaultGroup"
				}
			};
			rowCounter += 1;
			switch (schema.properties[p].type)
			{
				case 'string':
				case 'autoguid':
					tmpDescriptor.DataType = 'String';
					break;
				case 'datetime':
				case 'date':
				case 'createdate':
				case 'updatedate':
					tmpDescriptor.DataType = 'String';
					tmpDescriptor.PictForm.InputType = 'DateTime'
					break;
				case 'boolean':
				case 'deleted':
					tmpDescriptor.DataType = 'Boolean';
				case 'integer':
				case 'decimal':
				case 'autoidentity':
				case 'createiduser':
				case 'updateiduser':
				case 'deleteiduser':
					tmpDescriptor.DataType = 'Number';
					break;
				default:
					tmpDescriptor.DataType = 'String';
			}

			const tmpForeignEntity = this.pict.PictSectionRecordSet.resolveForeignEntity(p, this.pict.PictSectionRecordSet.recordSetProviderConfigurations[recordSet], this.pict.providers[this.providerHash].getIDField());
			if (tmpForeignEntity && this.pict.providers['Pict-Section-Picker'])
			{
				// Foreign-key column → searchable entity Picker (edit) + resolved name (read, see the view-mode override).
				tmpDescriptor.PictForm.InputType = 'Picker';
				tmpDescriptor.PictForm.Entity = tmpForeignEntity;
				const tmpForeignConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpForeignEntity];
				if (tmpForeignConfig && tmpForeignConfig.SearchFields) { tmpDescriptor.PictForm.SearchFields = tmpForeignConfig.SearchFields; }
			}
			// Per-record-set label override (e.g. Contract/Project IDOrganization → "Prime Contractor").
			const tmpReadRSConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[recordSet];
			if (tmpReadRSConfig && tmpReadRSConfig.FieldLabels && tmpReadRSConfig.FieldLabels[p]) { tmpDescriptor.Name = tmpReadRSConfig.FieldLabels[p]; }
			// JSON/object columns → embedded ObjectEditor (read-only tree in View, editable in Edit). Driven by the
			// schema column type, with a per-record-set ObjectEditorFields list to opt in string-typed JSON blobs.
			// Gated on the pict-section-form ObjectEditor input being registered (graceful on older form versions).
			const tmpObjectEditorFields = (tmpReadRSConfig && Array.isArray(tmpReadRSConfig.ObjectEditorFields)) ? tmpReadRSConfig.ObjectEditorFields : [];
			if (tmpDescriptor.PictForm.InputType !== 'Picker' && this.pict.providers['Pict-Input-ObjectEditor'] &&
				(schema.properties[p].type === 'object' || schema.properties[p].type === 'json' || tmpObjectEditorFields.includes(p)))
			{
				tmpDescriptor.DataType = 'Object';
				tmpDescriptor.PictForm.InputType = 'ObjectEditor';
			}
			defaultManifest.Descriptors[`${ recordSet }Details.${ p }`] = tmpDescriptor;
		}
		return defaultManifest;
	}

	_generateManifestTemplate(config, section, specificManifest, setBaseManifest, action = this.action, defaultManifest)
	{
		// Look for a manifest by the action (if there is no specific manifest passed) and fallback to view if the action manifest isn't present.
		const tmpManifestHash = specificManifest || config[`RecordSetReadDefaultManifest${ action }`] || config[`RecordSetReadManifests${ action }`]?.[0] || config[`RecordSetReadDefaultManifestView`] || config[`RecordSetReadManifestsView`]?.[0];
		// Make sure the copy of the manifest doesn't mutate the original (for read only handling).
		const tmpManifest = JSON.parse(JSON.stringify(defaultManifest ? defaultManifest : this.pict.PictSectionRecordSet.getManifest(tmpManifestHash)));
		if (!tmpManifest)
		{
			this.pict.log.error(`RecordSetRead: No manifest found for ${ config.RecordSet }. Read Render failed.`);
			return '';
		}
		if (!tmpManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetRead: No manifest descriptors found for manifest ${ tmpManifestHash }. Read Render failed.`);
			return '';
		}
		else if (action == 'View' && !config.RecordSetReadOverrideReadOnly)
		{
			// If we are in view mode, apply the read only type unless overriden.
			for (const x of Object.keys(tmpManifest.Descriptors))
			{
				if (!tmpManifest.Descriptors[x].PictForm)
				{
					tmpManifest.Descriptors[x].PictForm = {};
				}
				// Entity-reference (Picker) fields stay a Picker but render read-only (the resolved entity
				// name as plain text, no dropdown); everything else becomes plain read-only text.
				if (tmpManifest.Descriptors[x].PictForm.InputType === 'Picker') { tmpManifest.Descriptors[x].PictForm.ReadOnly = true; continue; }
				// ObjectEditor stays an ObjectEditor but renders its read-only tree (not a plain text field).
				if (tmpManifest.Descriptors[x].PictForm.InputType === 'ObjectEditor') { tmpManifest.Descriptors[x].PictForm.ReadOnly = true; continue; }
				tmpManifest.Descriptors[x].PictForm.InputType = 'ReadOnly';
			}
		}
		// Suppress identity + audit fields from the body; they surface via the audit header's Details modal.
		if (config.RecordSetReadSuppressAuditFields !== false)
		{
			this._suppressAuditDescriptors(tmpManifest);
		}
		if (setBaseManifest)
		{
			this.manifest = tmpManifest;
		}
		let sectionsTemplate = '';
		// Clear any stale views in PictSectionForm before reinstantiating (if we don't the read only state doesn't get cleared).
		for (const s of tmpManifest?.Sections || [])
		{
			delete this.pict.views[`PictSectionForm-${ s.Hash }`]
		}
		this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(tmpManifest);

		for (const pickList of tmpManifest?.PickLists || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
		}

		for (const s of tmpManifest?.Sections || [])
		{
			const viewSectionID = `PSRS-Read-${ section }-Section-${ s.Hash }`;
			sectionsTemplate += /*html*/`<div id="${ viewSectionID }"></div>`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].viewMarshalDestination = 'AppData';
			this.pict.views[`PictSectionForm-${ s.Hash }`].options.DefaultDestinationAddress = `#${ viewSectionID }`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].rebuildCustomTemplate();
		}
		return sectionsTemplate
	}

	async _structureTabs(config, record)
	{
		const validTabs = config.ReadLayout == 'Tab' ? 
		[
			{
				Type: 'Record',
				RecordSet: config.RecordSet,
				Title: config.RecordSetReadTabTitle || 'Record',
				Hash: 'Record',
				Template: /*html*/`
					<div id="PSRS-Tab-Record" class="psrs-tab-body">{~T:PRSP-Read-RecordRead-Template~}</div>
				`,
				TabTemplate: /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-Record" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('Record')">${ config.RecordSetReadTabTitle || 'Record' }</div>
				`,
				render: () => {}
			}
		] : config.ReadLayout == 'Split' ?
		[
			// Split layout: a leading "Full Record" tab that collapses the association pane back to the
			// record-only view (the record itself lives in the left pane, so this body stays empty).
			{
				Type: 'FullRecord',
				Hash: 'FullRecord',
				Title: config.RecordSetReadFullRecordTabTitle || 'Full Record',
				Template: /*html*/`
					<div id="PSRS-Tab-FullRecord" class="psrs-tab-body"></div>
				`,
				TabTemplate: /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-FullRecord" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('FullRecord')">${ config.RecordSetReadFullRecordTabTitle || 'Full Record' }</div>
				`,
				render: () => {}
			}
		] : [];

		for (const t of config.RecordSetReadTabs)
		{
			if (!t.Title)
			{
				this.pict.log.info('Skipping tab that is missing title.');
				continue;
			}
			if (!t.Hash)
			{
				t.Hash = t.Title.replaceAll(' ', '');
			}
			if (t.Type == 'Manifest' || t.Type == 'AttachedRecord')
			{
				let recordSetConfig = null;
				let tmpManifest = null;
				if (t.Type == 'AttachedRecord')
				{
					const getMethod = async (remote, id) => {
						if (this.pict.providers[`RSP-Provider-${ remote }`])
						{
							return await this.pict.providers[`RSP-Provider-${ remote }`].getRecord(id);
						}
						else
						{
							return await new Promise((resolve, reject) =>
							{
								this.pict.EntityProvider.getEntity(remote, id, (pError, pResult) =>
								{
									if (pError)
									{
										resolve(null);
									}
									resolve(pResult);
								});
							});
						}
					};

					const getJoin = async (remote, field, value) => {
						let result = null;
						if (this.pict.providers[`RSP-Provider-${ remote }`])
						{
							result = await this.pict.providers[`RSP-Provider-${ remote }`].getRecordsInline(`FBV~${ field }~EQ~${ value }`);
						}
						else
						{
							result = await new Promise((resolve, reject) =>
							{
								this.pict.EntityProvider.getEntitySet(remote, `FBV~${ field }~EQ~${ value }`, (pError, pResult) =>
								{
									if (pError)
									{
										resolve(null);
									}
									resolve(pResult);
								});
							});
						}
						return result?.[0] || null;
					};
					
					if (!t.RecordSet)
					{
						this.pict.log.info(`Skipping attached record tab because no recordset was included.`);
					}
					recordSetConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[t.RecordSet];
					if (!recordSetConfig)
					{
						this.pict.log.info(`Skipping attached record tab because recordset ${ t.RecordSet } is not registered.`);
						continue;
					}
					t.Manifest = recordSetConfig.RecordSetReadDefaultManifestView || recordSetConfig.RecordSetReadManifestsView?.[0];
					tmpManifest = recordSetConfig.RecordSetReadManifestOnly ? this.pict.PictSectionRecordSet.getManifest(t.Manifest) : await this._buildDefaultManifest(recordSetConfig.RecordSetMeadowEntity || recordSetConfig.RecordSet);
					if (!tmpManifest)
					{
						this.pict.log.info(`Skipping manifest tab because manifest ${ t.Manifest } is not registered or default manifest could not be constructed.`);
						continue;
					}
					if (!t.JoinField)
					{
						t.JoinField = this.pict.providers[`RSP-Provider-${ t.RecordSet }`].getIDField();
					}
					if (t.JoiningRecordSet)
					{
						if (!t.BaseField)
						{
							t.BaseField = this.pict.providers[`RSP-Provider-${ config.RecordSet }`].getIDField();
						}
						if (!record[t.BaseField])
						{
							this.pict.log.info(`Skipping attached record tab because field ${ t.BaseField } does not exist on this record.`);
							continue;
						}
						const tempJoin = await getJoin(t.JoiningRecordSet, t.BaseField, record[t.BaseField]);
						if (!tempJoin?.[t.JoinField])
						{
							this.pict.log.info(`Skipping attached record tab because joining field ${ t.JoinField } does not exist on this record.`);
							continue;
						}
						const tempRecord = await getMethod(recordSetConfig.RecordSetMeadowEntity || recordSetConfig.RecordSet, tempJoin[t.JoinField]);
						this.pict.AppData[`${ t.RecordSet }Details`] = tempRecord;
					}
					else
					{
						if (!record[t.Joinfield])
						{
							this.pict.log.info(`Skipping attached record tab because joining field ${ t.JoinField } does not exist on this record.`);
							continue;
						}
						const tempRecord = await getMethod(recordSetConfig.RecordSetMeadowEntity || recordSetConfig.RecordSet, record[t.Joinfield]);
						this.pict.AppData[`${ t.RecordSet }Details`] = tempRecord;
					}
				}
				if (!tmpManifest)
				{
					tmpManifest = this.pict.PictSectionRecordSet.getManifest(t.Manifest);
				}
				t.Template = /*html*/`
					<div id="PSRS-Tab-${ t.Hash }" class="psrs-tab-body">${ this._generateManifestTemplate(config, 'RecordTab', t.Manifest, false, 'View', recordSetConfig && !recordSetConfig.RecordSetReadManifestOnly ? tmpManifest : null) }</div>
				`;
				t.TabTemplate = /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-${ t.Hash }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ t.Hash }')">${ t.Title }</div>
				`;
				t.render = () =>
				{
					// @ts-ignore
					for (const s of tmpManifest?.Sections || [])
					{
						this.pict.views[`PictSectionForm-${ s.Hash }`].render();
						this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
					}
				};
				validTabs.push(t);
			}
			else if (t.Type == 'View')
			{
				if (!t.View)
				{
					this.pict.log.info(`Skipping view tab because no view was included.`);
					continue;
				}
				const tmpView = this.pict.views[t.View];
				if (!tmpView)
				{
					this.pict.log.info(`Skipping view tab because view ${ t.View } is not registered.`);
					continue;
				}
				t.Template = /*html*/`
					<div id="PSRS-Tab-${ t.Hash }" class="psrs-tab-body"></div>
				`;
				t.TabTemplate = /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-${ t.Hash }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ t.Hash }')">${ t.Title }</div>
				`;
				tmpView.options.DefaultDestinationAddress = `#PSRS-Tab-${ t.Hash }`;
				t.render = () =>
				{
					this.pict.views[`${ t.View }`].renderAsync();
				};
				validTabs.push(t);
			}
			else if (t.Type == 'Association')
			{
				// An embeddable join-management widget for one association, anchored on THIS record.
				// Opt-in is light: a RecordSetReadTabs entry naming an Association registered in
				// settings.Associations. The manager resolves which side is "this side" from the
				// rendering recordset, so opting in Book->Authors and Author->Books are independent.
				const tmpAssociationManager = this.pict.providers.RecordSetAssociationManager;
				if (!tmpAssociationManager || !t.Association)
				{
					this.pict.log.info(`Skipping association tab because no association was included (or the manager is missing).`);
					continue;
				}
				const tmpSides = tmpAssociationManager.resolveSides(t.Association, config.RecordSet);
				if (!tmpSides)
				{
					this.pict.log.info(`Skipping association tab because association ${ t.Association } could not be resolved for ${ config.RecordSet }.`);
					continue;
				}
				const tmpEditorHash = `RSP-AssocEditor-${ config.RecordSet }-${ t.Association }`;
				if (!this.pict.views[tmpEditorHash])
				{
					this.pict.addView(tmpEditorHash, Object.assign({}, libViewAssociationEditor.default_configuration,
						{
							ViewIdentifier: tmpEditorHash,
							AssociationHash: t.Association,
							ThisRecordSet: config.RecordSet,
							DefaultDestinationAddress: `#PSRS-Tab-${ t.Hash }`,
							PickerMode: t.PickerMode || 'single',
						}), libViewAssociationEditor);
				}
				const tmpEditorView = this.pict.views[tmpEditorHash];
				tmpEditorView.options.AssociationHash = t.Association;
				tmpEditorView.options.ThisRecordSet = config.RecordSet;
				tmpEditorView.options.ThisID = record[tmpSides.thisSide.IDField];
				tmpEditorView.options.DefaultDestinationAddress = `#PSRS-Tab-${ t.Hash }`;
				tmpEditorView.options.PickerMode = t.PickerMode || 'single';
				t.Template = /*html*/`
					<div id="PSRS-Tab-${ t.Hash }" class="psrs-tab-body"></div>
				`;
				t.TabTemplate = /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-${ t.Hash }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ t.Hash }')">${ t.Title }</div>
				`;
				t.renderAsync = async () =>
				{
					tmpEditorView.options.ThisID = record[tmpSides.thisSide.IDField];
					tmpEditorView.options.DefaultDestinationAddress = `#PSRS-Tab-${ t.Hash }`;
					await tmpEditorView.renderEditor();
				};
				validTabs.push(t);
			}
		}
		return validTabs;
	}

	onInitialize()
	{

		// Add the route templates for the read view
		this.pict.PictSectionRecordSet.addRecordLinkTemplate('PRSP-Read-Link-Name-Template', 'PRSP-Read-Link-URL-Template', true);

		return super.onInitialize();
	}
}

module.exports = viewRecordSetRead;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__Read;


},{"../RecordSet-RecordBaseView.js":627,"../associate/RecordSet-AssociationEditor.js":631}],682:[function(require,module,exports){
module.exports={
	"RenderOnLoad": true,

	"GridWidth": "auto",
	"GridRowHeight": 40,

	"GridBodyHeight": "auto",
	"GridBodyMinHeight": 130,

	"GridColumnMinWidth": 50,
	"GridColumnWidthResizable": true,
	"GridColumnHeightResizable": false,

	"GridColumnFrozenCount": 0,
	"GridColumnFrozenBorderWidth": 3,

	"GridScrollX": true,
	"GridScrollY": true,

	"GridShowDummyRows": false,
	"GridDraggableRows": false,

	"GridSelectionUnit": "cell",

	"DefaultRenderable": "TuiGrid-Wrap",
	"DefaultDestinationAddress": "#TuiGrid-Container-Div",

	"Templates": [
		{
			"Hash": "TuiGrid-Container",
			"Template": "<!-- TuiGrid-Container Rendering Soon -->"
		}
	],

	"Renderables": [
		{
			"RenderableHash": "TuiGrid-Wrap",
			"TemplateHash": "TuiGrid-Container",
			"DestinationAddress": "#TuiGrid-Container-Div"
		}
	],

	"TargetElementAddress": "#TuiGrid-Container-Div",

	"GridDataAddress": false,

	"GridData": [
		{
			"idrecord": 1,
			"entity": "SampleEntity",
			"name": "Record name 1",
			"description": "description 1"
		},
		{
			"idrecord": 2,
			"entity": "SampleEntity",
			"name": "Record name 2",
			"description": "description 2"
		},
		{
			"idrecord": 3,
			"entity": "SampleEntity",
			"name": "Record name 3",
			"description": "description 3"
		},
		{
			"idrecord": 4,
			"entity": "SampleEntity",
			"name": "Record name 4",
			"description": "description 4"
		},
		{
			"idrecord": 5,
			"entity": "SampleEntity",
			"name": "Record name 5",
			"description": "description 5"
		},
		{
			"idrecord": 6,
			"entity": "SampleEntity",
			"name": "Record name 6",
			"description": "description 6"
		},
		{
			"idrecord": 7,
			"entity": "SampleEntity",
			"name": "Record name 7",
			"description": "description 7"
		},
		{
			"idrecord": 8,
			"entity": "SampleEntity",
			"name": "Record name 8",
			"description": "description 8"
		},
		{
			"idrecord": 9,
			"entity": "SampleEntity",
			"name": "Record name 9",
			"description": "description 9"
		}
	],
	"ColumnsToSolveOnChange": {},
	"TuiColumnSchema": [
		{
			"header": "IDRecord",
			"name": "idrecord",
			"PictTriggerSolveOnChange": true
		},
		{
			"header": "Entity",
			"name": "entity",
			"PictTriggerSolveOnChange": true
		},
		{
			"header": "Name",
			"name": "name",
			"editor": "text"
		},
		{
			"header": "Description",
			"name": "description",
			"editor": "text"
		}
	]
}

},{}],683:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/**
 * @typedef {typeof import('tui-grid').default} TuiGridClass
 * @typedef {import('tui-grid').default} TuiGrid
 */

class PictSectionTuiGrid extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, require('./Pict-Section-TuiGrid-DefaultConfiguration.json'), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {{ [key: string]: any }} */
		this.services;
		this.dateFormatter = this.fable.instantiateServiceProviderWithoutRegistration('Dates');

		this.initialRenderComplete = false;

		this.customFormatters = {};
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		/** @type {TuiGridClass} */
		this._tuiGridPrototype = null;

		/** @type {TuiGrid} */
		this.tuiGrid = null;

		this.customHeaders = require('./Pict-TuiGrid-Headers.js');
		this.customEditors = require('./Pict-TuiGrid-Editors.js');
		this.initializeCustomFormatters();

		this.columnSchema = false;
		this.targetElementAddress = false;
		/** @type {Array<any>} */
		this.gridData = null;

		return super.onBeforeInitialize();
	}

	initializeCustomFormatters()
	{
		this.customFormatters.FormatterTwoDigitNumber = (pCell) =>
			{
				let tmpCellValue = Number.parseFloat(pCell.value);
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				if (isNaN(tmpCellValue))
				{
					return '';
				}
				else
				{
					return this.fable.Math.roundPrecise(pCell.value, tmpPrecision);
				}
			};
		this.customFormatters.FormatterCurrencyNumber = (pCell) =>
			{
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				let tmpCellValue = this.fable.DataFormat.formatterDollars(pCell.value, tmpPrecision);
				return tmpCellValue;
			};

		this.customFormatters.FormatterRoundedNumber = (pCell) =>
			{
				let tmpCellValue = Number.parseFloat(pCell.value);
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				if (isNaN(tmpCellValue))
				{
					return '';
				}
				else
				{
					return this.fable.Math.roundPrecise(pCell.value, tmpPrecision);
				}
			};

		this.customFormatters.FormatterDate = (pCell) =>
			{
				let tmpDate = this.fable.Dates.dayJS.utc(pCell.value);
				if (pCell.dateformat)
				{
					return tmpDate.format(pCell.dateformat);
				}
				else
				{
					return tmpDate.format();
				}
			};
	}

	/**
	 * Construct a tuiGrid instance and connect it to the browser's dom object for the grid.  If the
	 * prototype is not passed in, try to find a window.tui (where the library puts itself) in the window
	 * object.
	 *
	 * @param {TuiGridClass} [pTuiGridPrototype] - The TuiGrid prototype class expected to be loaded in the browser
	 * @returns
	 */
	connectTuiGridPrototype(pTuiGridPrototype)
	{
		if (typeof (pTuiGridPrototype) != 'undefined')
		{
			this._tuiGridPrototype = pTuiGridPrototype;
		}
		else
		{
			this.log.trace(`PICT-TuiGrid No TuiGrid Prototype defined or explicitly set; looking for it in the window object.`);
			if (typeof (window) != 'undefined')
			{
				if ((typeof (window.tui) != 'undefined') && (typeof (window.tui.Grid) != 'undefined'))
				{
					this.log.trace(`PICT-TuiGrid Found TuiGrid Prototype in window.tuiGrid.`);
					this.connectTuiGridPrototype(window.tui.Grid);
				}
				else
				{
					this.log.error(`PICT-TuiGrid No TuiGrid Prototype found in window.tuiGrid.`);
					return false;
				}
			}
			else
			{
				this.log.error(`PICT-TuiGrid No TuiGrid Prototype found in window.tuiGrid -- window object unavailable.`);
				return false;
			}
		}
	}

	/**
	 * @typedef {Object} TUIGridCellChange
	 * @property {any} rowKey - The key of the row that changed.
	 * @property {string} columnName - The name of the column that changed.
	 * @property {any} value - The "current" value of the cell. Slightly different meaning in preChangeHandler vs changeHandler (before / after the change is applied).
	 * @property {any} [nextValue] - The value that the cell will have after the change. Only populated in preChangeHandler (not changeHandler).
	 * @property {any} [prevValue] - The value that the cell had before the change. Only populated in changeHandler (not preChangeHandler).
	 */

	/**
	 * @typedef {Object} TUIGridChangeEvent
	 * @property {TuiGrid} instance - The TuiGrid instance that fired the event.
	 * @property {TUIGridCellChange[]} changes - An array of objects representing the changes to grid cell values.
	 */

	/**
	 * Interface method for handling changesets from the TuiGrid control. Invoked before the change has been applied to the affected cells.
	 *
	 * * The pre-change cell value is stored in value while the new cell value is stored in nextValue.
	 * * Any changes made to nextValue in this method will be reflected in the grid for that cell.
	 *
	 * @param {TUIGridChangeEvent} pChangeData - An event containing an array of objects representing the changes to grid cell values.
	 */
	preChangeHandler(pChangeData)
	{
	}

	/**
	 * Interface method for handling changesets from the TuiGrid control. Invoked after the change has been applied to the affected cells.
	 *
	 * * Performs solver trigger for changes to any columns configured in "ColumnsToSolveOnChange" or with "PictTriggerSolveOnChange": true on a specific row.
	 * * The previous cell value is stored in prevValue while the next cell value is stored in value.
	 *
	 * @param {TUIGridChangeEvent} pChangeData - An event object containing an array of objects representing the changes to grid cell values.
	 */
	changeHandler(pChangeData)
	{
		let tmpSolverNecessary = false;

		for (let i = 0; i < pChangeData.changes.length; i++)
		{
			let tmpEntity = pChangeData.instance.getValue(pChangeData.changes[i].rowKey, 'entity');
			let tmpIDRecord = pChangeData.instance.getValue(pChangeData.changes[i].rowKey, 'idrecord');

			this.log.trace(`Generic Change Handler for TuiGrid Fired, Entity ${tmpEntity} IDRecord ${tmpIDRecord} setting Column [${pChangeData.changes[i].value}] to new Value [${pChangeData.changes[i].value}]`);

			if (this.options.ColumnsToSolveOnChange.hasOwnProperty(pChangeData.changes[i].columnName))
			{
				tmpSolverNecessary = true;
			}
		}

		if (tmpSolverNecessary)
		{
			this.services.PictApplication.solve();
		}
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// This is where we wire up and initialize the tuigrid control -- the initial render has put the placeholder content in place.
		// Check for a tuigrid prototype, and find it in the window object it if it doesn't exist
		if (!this._tuiGridPrototype)
		{
			this.connectTuiGridPrototype();
		}
		// This is where we wire up and initialize the tuigrid control
		if (this.tuiGrid)
		{
			// The grid is already initialized.
			this.log.error(`TuiGrid going to ${this.options.TargetElementAddress} is already initialized!`);
			return false;
		}

		if (this.options.GridDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options,
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.GridDataAddress);
			if (typeof (tmpAddressedData) != 'object')
			{
				this.log.error(`Address for GridData [${this.options.GridDataAddress}] did not return an object; it was a ${typeof (tmpAddressedData)}.`);
				this.gridData = [];
			}
			else
			{
				this.gridData = JSON.parse(JSON.stringify(tmpAddressedData));
			}
		}
		else
		{
			this.gridData = [];
		}

		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (tmpTargetElementSet.length < 1)
		{
			this.log.error(`Could not find target element [${this.options.TargetElementAddress}] for TuiGrid!  Rendering won't function properly.`);
			this.targetElement = false;
			return false;
		}

		// Just go for the first one.
		this.targetElement = tmpTargetElementSet[0];

		// Check to see if there are any custom formatters.
		this.columnSchema = this.options.TuiColumnSchema;
		// Setup the solver and custom schema handlers.
		for (let i = 0; i < this.columnSchema.length; i++)
		{
			let tmpColumn = this.columnSchema[i];
			// If this bit is set on a column, the Form solver will trigger each time a change happens to that column.
			if (tmpColumn.PictTriggerSolveOnChange)
			{
				this.options.ColumnsToSolveOnChange[tmpColumn.name] = tmpColumn;
			}
			// Look to see if there is an internal formatter that matches the type
			if ((tmpColumn.hasOwnProperty('formatter')) && (this.customFormatters.hasOwnProperty(tmpColumn.formatter)))
			{
				// Assign our special formatter to the column.
				tmpColumn.formatter = this.customFormatters[tmpColumn.formatter];
			}
			// Look to see if there is an editor stanza
			if (tmpColumn.hasOwnProperty('editor'))
			{
				// Look to see if there is an internal editor that matches the type
				if ((tmpColumn.editor.hasOwnProperty('type'))
					&& (typeof (tmpColumn.editor.type) == 'string')
					&& (this.customEditors.hasOwnProperty(tmpColumn.editor.type)))
				{
					// Assign our special editor to the column.
					tmpColumn.editor.type = this.customEditors[tmpColumn.editor.type];
				}

				// Look to see if there is an internal editor that matches the type
				if ((tmpColumn.editor.hasOwnProperty('options'))
					&& (typeof (tmpColumn.editor.options) == 'object')
					&& (tmpColumn.editor.options.hasOwnProperty('listItems'))
					&& (typeof (tmpColumn.editor.options.listItems) == 'string'))
				{
					// Look for this address!  For the Record object, we will pass in the options.
					const tmpAddressSpace =
					{
						Fable: this.fable,
						Pict: this.fable,
						AppData: this.AppData,
						Bundle: this.Bundle,
						Options: this.options,
					};
					let tmpListItems = this.fable.manifest.getValueByHash(tmpAddressSpace, tmpColumn.editor.options.listItems);
					if (typeof (tmpListItems) == 'object')
					{
						tmpColumn.editor.options.listItems = tmpListItems;
					}
					else
					{
						this.log.warn(`Pict TuiGrid for column [${tmpColumn.name}] had [${tmpColumn.editor.options.listItems}] as a listItems address, but it didn't return an object.  It was a [${typeof (tmpListItems)}].  Setting to empty list.`);
						tmpColumn.editor.options.listItems = [];
					}
				}
			}
		}

		this.gridSettings = {
				data: this.gridData,
				el: this.targetElement,
				columns: this.columnSchema,

				// This is no bueno, yo
				usageStatistics: false,

				scrollY: this.options.GridScrollY,

				columnOptions:
				{
					resizable: this.options.GridColumnWidthResizable
				}
			};

		this.customConfigureGridSettings();

		let libTuiGrid = this._tuiGridPrototype;
		this.tuiGrid = new libTuiGrid(this.gridSettings);
		this.tuiGrid.on('beforeChange', (pChangeData) =>
		{
			//TODO: the exported event type from tui-grid is incomplete so mask it here
			/** @type {any} */
			const tmpChangeData = pChangeData;
			this.preChangeHandler(tmpChangeData);
		});
		this.tuiGrid.on('afterChange', (pChangeData) =>
		{
			//TODO: the exported event type from tui-grid is incomplete so mask it here
			/** @type {any} */
			const tmpChangeData = pChangeData;
			this.changeHandler(tmpChangeData);
		});
	}

	/**
	 * This is expected to be overloaded with anything that needs to be added to the grid configuration
	 * before the Toast UI Grid component is initialized in the browser.
	 */
	customConfigureGridSettings ()
	{
		// This can be overloaded to tweak up the this.gridSettings
	}

	/**
	 * Lookup a specific record in the toast ui grid data set by value and pull the value from the map into the browser.
	 *
	 * This function exists because if we mutate data in the map of plain javascript records tuigrid
	 * manages, it doesn't automatically refresh the UI.  From reading the TUIGrid documentation, this
	 * is because they don't want to refresh until all the data has changed.
	 *
	 * The best practice has been to have a hidden column behind the tuigrid that maps the correct entity
	 * value set to the record in the map (e.g. IDRecord in one column and Entity in another).
	 *
	 * @param {string} pCellColumnToBeSet - the Column hash to set
	 * @param {string} pCellValueToSet - Value to be set
	 * @param {string} pLookupValue - the Value to look up in tuigrid
	 * @param {string} pLookupColumn - the key of the column in the tuigrid record (which are plain javascript objects defined by the tuigrid config)
	 * @return {void}
	 */
	SetGridValue(pCellColumnToBeSet, pCellValueToSet, pLookupValue, pLookupColumn)
	{
		if (typeof (pLookupValue) == 'undefined')
		{
			console.log(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by [${pLookupColumn}]::[${pLookupValue}].  No valid lookup value!`);
			return;
		}

		if (!this.tuiGrid)
		{
			this.log.warn(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by [${pLookupColumn}]::[${pLookupValue}].  No valid grid!`);
			return;
		}

		const tmpData = this.tuiGrid.getData();

		for (let i = 0; i < tmpData.length; i++)
		{
			const tmpRecord = tmpData[i];

			if (tmpRecord[pLookupColumn] == pLookupValue)
			{
				this.tuiGrid.setValue(i, pCellColumnToBeSet, pCellValueToSet);
			}
		}
	}

	/**
	 * Lookup a specific record in the toast ui grid data set by row key and pull in a column.
	 *
	 * This function exists because if we mutate data in the map of plain javascript records tuigrid
	 * manages, it doesn't automatically refresh the UI.  From reading the TUIGrid documentation, this
	 * is because they don't want to refresh until all the data has changed.
	 *
	 *
	 * @param {string} pCellColumnToBeSet - the Column hash to set
	 * @param {string} pCellValueToSet - Value to be set
	 * @param {string} pRowKey - the key of the row to be set
	 * @return {boolean}
	 */
	SetGridValueByRowKey(pCellColumnToBeSet, pCellValueToSet, pRowKey)
	{
		if (typeof (pRowKey) == 'undefined')
		{
			this.log.error(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by row key [${pRowKey}].  No valid row key!`);
			return false;
		}

		if (!this.tuiGrid)
		{
			this.log.warn(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by row key [${pRowKey}].  No valid grid!`);
			return false;
		}

		this.tuiGrid.setValue(pRowKey, pCellColumnToBeSet, pCellValueToSet);
		return true;
	}
}

module.exports = PictSectionTuiGrid;

/** @type {Record<string, any>} */
module.exports.default_configuration = require('./Pict-Section-TuiGrid-DefaultConfiguration.json');

},{"./Pict-Section-TuiGrid-DefaultConfiguration.json":682,"./Pict-TuiGrid-Editors.js":686,"./Pict-TuiGrid-Headers.js":687,"pict-view":693}],684:[function(require,module,exports){
// Custom number editor class with an option for precision
class tuiCustomEditorNumber
{
	constructor(pProperties)
	{
		const tmpElement = document.createElement('input');

		const decimalPrecision = (pProperties.columnInfo.editor.options.decimalPrecision) ? pProperties.columnInfo.editor.options.decimalPrecision : 3;

		tmpElement.type = 'number';
		tmpElement.value = String(pProperties.value);
		tmpElement.oninput = (pElement) =>
		{
			if (pElement.target instanceof HTMLInputElement)
			{
				const tmpCastNumber = parseFloat(pElement.target.value).toFixed(decimalPrecision).toString()
				if (tmpCastNumber.length < parseFloat(pElement.target.value).toString().length)
				{
					pElement.target.value = tmpCastNumber;
				}
			}
		};

		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	getValue()
	{
		return this.Element.value;
	}

	mounted()
	{
		this.Element.select();
	}
}

module.exports = tuiCustomEditorNumber;

},{}],685:[function(require,module,exports){
// Custom number editor class with an option for precision
class tuiCustomEditorText
{
	constructor(pProperties)
	{
		const tmpElement = document.createElement('input');

		tmpElement.type = 'text';
		tmpElement.value = String(pProperties.value);
		tmpElement.placeholder =  pProperties.columnInfo.editor.options.placeholder || '';
		tmpElement.pattern = pProperties.columnInfo.editor.options.pattern || '';
		tmpElement.minLength = pProperties.columnInfo.editor.options.minLength || '';
		tmpElement.maxLength = pProperties.columnInfo.editor.options.maxLength || '';
		tmpElement.required = pProperties.columnInfo.editor.options.required || '';

		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	getValue()
	{
		return this.Element.value;
	}

	mounted()
	{
		this.Element.select();
	}
}

module.exports = tuiCustomEditorText;

},{}],686:[function(require,module,exports){
module.exports =
{
	EditorNumber: require('./Pict-TuiGrid-Editor-Number.js'),
	EditorText: require('./Pict-TuiGrid-Editor-Text.js'),
};

},{"./Pict-TuiGrid-Editor-Number.js":684,"./Pict-TuiGrid-Editor-Text.js":685}],687:[function(require,module,exports){
// Custom column header where the header is hidden
class tuiCustomColumnHeaderNone
{
	constructor()
	{
		let tmpElement = document.createElement('input');
		tmpElement.type = 'hidden';
		tmpElement.value = '';
		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	render()
	{
		// Noop!
	}
}

module.exports =
{
	CustomColumnHeaderNone: tuiCustomColumnHeaderNone,
};

},{}],688:[function(require,module,exports){
/**
* Template Expression Graph
* @author      Steven Velozo <steven@velozo.com>
* @description Directed graph of template-to-template and template-to-data dependencies.
*/

class TemplateGraph
{
	constructor()
	{
		// Nodes keyed by "type:id" (e.g., "template:MainPage", "data:AppData.User.Name")
		this.Nodes = {};

		// Edges as an array of { From, To, Type } objects
		this.Edges = [];

		// Reverse index: target → array of edge indices for getEdgesTo()
		this._ReverseIndex = {};
		// Forward index: source → array of edge indices for getEdgesFrom()
		this._ForwardIndex = {};
	}

	/**
	 * Add a node to the graph.
	 *
	 * @param {string} pType - The node type ("template", "data", "entity")
	 * @param {string} pID - The node identifier
	 *
	 * @return {string} The node key ("type:id")
	 */
	addNode(pType, pID)
	{
		let tmpKey = `${pType}:${pID}`;

		if (!(tmpKey in this.Nodes))
		{
			this.Nodes[tmpKey] = { Type: pType, ID: pID };
		}

		return tmpKey;
	}

	/**
	 * Add a directed edge to the graph.
	 *
	 * @param {string} pFromKey - The source node key ("type:id")
	 * @param {string} pToKey - The target node key ("type:id")
	 * @param {string} pEdgeType - The edge type ("renders", "reads", "reads-entity", etc.)
	 *
	 * @return {number} The edge index
	 */
	addEdge(pFromKey, pToKey, pEdgeType)
	{
		// Check for duplicate edge
		let tmpForwardEdges = this._ForwardIndex[pFromKey];
		if (tmpForwardEdges)
		{
			for (let i = 0; i < tmpForwardEdges.length; i++)
			{
				let tmpEdge = this.Edges[tmpForwardEdges[i]];
				if (tmpEdge.To === pToKey && tmpEdge.Type === pEdgeType)
				{
					return tmpForwardEdges[i];
				}
			}
		}

		let tmpIndex = this.Edges.length;
		this.Edges.push({ From: pFromKey, To: pToKey, Type: pEdgeType });

		// Update forward index
		if (!(pFromKey in this._ForwardIndex))
		{
			this._ForwardIndex[pFromKey] = [];
		}
		this._ForwardIndex[pFromKey].push(tmpIndex);

		// Update reverse index
		if (!(pToKey in this._ReverseIndex))
		{
			this._ReverseIndex[pToKey] = [];
		}
		this._ReverseIndex[pToKey].push(tmpIndex);

		return tmpIndex;
	}

	/**
	 * Get all nodes in the graph.
	 *
	 * @return {Object} Map of node key → { Type, ID }
	 */
	getNodes()
	{
		return this.Nodes;
	}

	/**
	 * Get all edges in the graph.
	 *
	 * @return {Array<Object>} Array of { From, To, Type }
	 */
	getEdges()
	{
		return this.Edges;
	}

	/**
	 * Get all outgoing edges from a node.
	 *
	 * @param {string} pNodeKey - The source node key ("type:id")
	 *
	 * @return {Array<Object>} Array of { From, To, Type }
	 */
	getEdgesFrom(pNodeKey)
	{
		let tmpIndices = this._ForwardIndex[pNodeKey];
		if (!tmpIndices)
		{
			return [];
		}

		let tmpEdges = [];
		for (let i = 0; i < tmpIndices.length; i++)
		{
			tmpEdges.push(this.Edges[tmpIndices[i]]);
		}
		return tmpEdges;
	}

	/**
	 * Get all incoming edges to a node.
	 *
	 * @param {string} pNodeKey - The target node key ("type:id")
	 *
	 * @return {Array<Object>} Array of { From, To, Type }
	 */
	getEdgesTo(pNodeKey)
	{
		let tmpIndices = this._ReverseIndex[pNodeKey];
		if (!tmpIndices)
		{
			return [];
		}

		let tmpEdges = [];
		for (let i = 0; i < tmpIndices.length; i++)
		{
			tmpEdges.push(this.Edges[tmpIndices[i]]);
		}
		return tmpEdges;
	}

	/**
	 * Export the graph as a serializable JSON object.
	 *
	 * @return {Object} { Nodes: [...], Edges: [...] }
	 */
	toJSON()
	{
		let tmpNodes = [];
		let tmpNodeKeys = Object.keys(this.Nodes);
		for (let i = 0; i < tmpNodeKeys.length; i++)
		{
			let tmpNode = this.Nodes[tmpNodeKeys[i]];
			tmpNodes.push({ Key: tmpNodeKeys[i], Type: tmpNode.Type, ID: tmpNode.ID });
		}

		return {
			Nodes: tmpNodes,
			Edges: this.Edges.slice()
		};
	}

	/**
	 * Export the graph in Graphviz DOT format.
	 *
	 * @return {string} DOT format string
	 */
	toDOT()
	{
		let tmpLines = ['digraph TemplateGraph {'];
		tmpLines.push('\trankdir=LR;');
		tmpLines.push('');

		// Node declarations with shapes by type
		let tmpNodeKeys = Object.keys(this.Nodes);
		for (let i = 0; i < tmpNodeKeys.length; i++)
		{
			let tmpNode = this.Nodes[tmpNodeKeys[i]];
			let tmpShape = 'box';
			if (tmpNode.Type === 'data')
			{
				tmpShape = 'ellipse';
			}
			else if (tmpNode.Type === 'entity')
			{
				tmpShape = 'diamond';
			}

			let tmpSafeKey = tmpNodeKeys[i].replace(/[^a-zA-Z0-9_]/g, '_');
			tmpLines.push(`\t${tmpSafeKey} [label="${tmpNode.ID}" shape=${tmpShape}];`);
		}

		tmpLines.push('');

		// Edge declarations
		for (let i = 0; i < this.Edges.length; i++)
		{
			let tmpEdge = this.Edges[i];
			let tmpFromSafe = tmpEdge.From.replace(/[^a-zA-Z0-9_]/g, '_');
			let tmpToSafe = tmpEdge.To.replace(/[^a-zA-Z0-9_]/g, '_');
			tmpLines.push(`\t${tmpFromSafe} -> ${tmpToSafe} [label="${tmpEdge.Type}"];`);
		}

		tmpLines.push('}');
		return tmpLines.join('\n');
	}

	/**
	 * Clear all nodes and edges.
	 */
	clear()
	{
		this.Nodes = {};
		this.Edges = [];
		this._ReverseIndex = {};
		this._ForwardIndex = {};
	}
}

module.exports = TemplateGraph;

},{}],689:[function(require,module,exports){
/**
* Pict Template Preprocessor
* @author      Steven Velozo <steven@velozo.com>
* @description Compiles template strings into cached segment arrays for fast-path execution,
*              and builds an expression dependency graph for visualization and analysis.
*/

const libFableServiceBase = require('fable-serviceproviderbase');
const libTemplateGraph = require('./Pict-Template-Preprocessor-Graph.js');

class PictTemplatePreprocessor extends libFableServiceBase
{
	/**
	 * @param {Object} pFable - The Fable/Pict Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictTemplatePreprocessor';

		/** @type {Map<string, Array<Object>>} */
		this.cache = new Map();

		this.graph = new libTemplateGraph();

		// Edge classifiers: map of PatternStartString → function(hash) → array of { type, nodeType, nodeID }
		this._EdgeClassifiers = {};
		this._initializeDefaultClassifiers();

		this._installWrappers();
	}

	// -- Edge Classifiers --

	/**
	 * Register default edge classifiers for built-in template expression types.
	 * @private
	 */
	_initializeDefaultClassifiers()
	{
		// Template references: {~Template:TemplateName:DataAddress~} or {~T:...~}
		let fTemplateClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpTemplateName = tmpParts[0].trim();
			if (!tmpTemplateName)
			{
				return [];
			}
			return [{ EdgeType: 'renders', NodeType: 'template', NodeID: tmpTemplateName }];
		};
		this._EdgeClassifiers['{~Template:'] = fTemplateClassifier;
		this._EdgeClassifiers['{~T:'] = fTemplateClassifier;

		// TemplateSet references
		let fTemplateSetClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpTemplateName = tmpParts[0].trim();
			if (!tmpTemplateName)
			{
				return [];
			}
			return [{ EdgeType: 'renders-set', NodeType: 'template', NodeID: tmpTemplateName }];
		};
		this._EdgeClassifiers['{~TemplateSet:'] = fTemplateSetClassifier;
		this._EdgeClassifiers['{~TS:'] = fTemplateSetClassifier;

		// TemplateIf references
		let fTemplateIfClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpTemplateName = tmpParts[0].trim();
			if (!tmpTemplateName)
			{
				return [];
			}
			let tmpEdges = [{ EdgeType: 'renders-if', NodeType: 'template', NodeID: tmpTemplateName }];
			// Also extract data addresses from comparison (third part)
			if (tmpParts.length >= 3)
			{
				let tmpComparisonParts = tmpParts[2].split('^');
				if (tmpComparisonParts.length >= 3)
				{
					tmpEdges.push({ EdgeType: 'reads', NodeType: 'data', NodeID: tmpComparisonParts[0].trim() });
					tmpEdges.push({ EdgeType: 'reads', NodeType: 'data', NodeID: tmpComparisonParts[2].trim() });
				}
			}
			return tmpEdges;
		};
		this._EdgeClassifiers['{~TemplateIf:'] = fTemplateIfClassifier;
		this._EdgeClassifiers['{~TIf:'] = fTemplateIfClassifier;

		// TemplateIfElse references
		let fTemplateIfElseClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpEdges = [];
			if (tmpParts[0])
			{
				tmpEdges.push({ EdgeType: 'renders-if-else', NodeType: 'template', NodeID: tmpParts[0].trim() });
			}
			if (tmpParts.length >= 4 && tmpParts[3])
			{
				tmpEdges.push({ EdgeType: 'renders-if-else', NodeType: 'template', NodeID: tmpParts[3].trim() });
			}
			return tmpEdges;
		};
		this._EdgeClassifiers['{~TemplateIfElse:'] = fTemplateIfElseClassifier;
		this._EdgeClassifiers['{~TIfE:'] = fTemplateIfElseClassifier;

		// Data references
		let fDataClassifier = (pHash) =>
		{
			let tmpAddress = pHash.split(':')[0].trim();
			if (!tmpAddress)
			{
				return [];
			}
			return [{ EdgeType: 'reads', NodeType: 'data', NodeID: tmpAddress }];
		};
		this._EdgeClassifiers['{~Data:'] = fDataClassifier;
		this._EdgeClassifiers['{~D:'] = fDataClassifier;
		this._EdgeClassifiers['{~DataJson:'] = fDataClassifier;
		this._EdgeClassifiers['{~DJ:'] = fDataClassifier;
		this._EdgeClassifiers['{~Dollars:'] = fDataClassifier;
		this._EdgeClassifiers['{~Digits:'] = fDataClassifier;
		this._EdgeClassifiers['{~DateTimeFormat:'] = fDataClassifier;
		this._EdgeClassifiers['{~PascalCaseIdentifier:'] = fDataClassifier;
		this._EdgeClassifiers['{~LogValue:'] = fDataClassifier;
		this._EdgeClassifiers['{~LogValueTree:'] = fDataClassifier;
		this._EdgeClassifiers['{~NotEmpty:'] = fDataClassifier;

		// Entity references: {~Entity:EntityType^IDAddress^TemplateHash~}
		let fEntityClassifier = (pHash) =>
		{
			let tmpParts = pHash.split('^');
			let tmpEdges = [];
			if (tmpParts.length >= 1 && tmpParts[0])
			{
				tmpEdges.push({ EdgeType: 'reads-entity', NodeType: 'entity', NodeID: tmpParts[0].trim() });
			}
			if (tmpParts.length >= 2 && tmpParts[1])
			{
				tmpEdges.push({ EdgeType: 'reads', NodeType: 'data', NodeID: tmpParts[1].trim() });
			}
			if (tmpParts.length >= 3 && tmpParts[2])
			{
				tmpEdges.push({ EdgeType: 'renders', NodeType: 'template', NodeID: tmpParts[2].trim() });
			}
			return tmpEdges;
		};
		this._EdgeClassifiers['{~Entity:'] = fEntityClassifier;
		this._EdgeClassifiers['{~E:'] = fEntityClassifier;
	}

	/**
	 * Register a custom edge classifier for a template expression tag.
	 *
	 * @param {string} pTag - The PatternStartString (e.g., '{~MyCustom:')
	 * @param {function} fClassifier - Function(hash) returning array of { EdgeType, NodeType, NodeID }
	 */
	addEdgeClassifier(pTag, fClassifier)
	{
		this._EdgeClassifiers[pTag] = fClassifier;
	}

	// -- Compile Step --

	/**
	 * Compile a template string into a segment array using the trie parse tree.
	 * Mirrors the parseCharacter state machine from MetaTemplate-StringParser
	 * but records segments instead of executing Parse functions.
	 *
	 * @param {string} pString - The template string to compile
	 * @param {Object} pParseTree - The trie root from MetaTemplate.ParseTree
	 *
	 * @return {Array<Object>} Array of segments: { Type: 'Literal', Value } or { Type: 'Expression', Hash, Leaf, Tag }
	 */
	compile(pString, pParseTree)
	{
		let tmpSegments = [];
		let tmpLiteralBuffer = '';

		// State machine - mirrors StringParser
		let tmpPattern = {};
		let tmpPatternMatch = false;
		let tmpStartPatternMatchComplete = false;
		let tmpEndPatternMatchBegan = false;
		let tmpPatternStartNode = false;
		let tmpOutputBuffer = '';

		let fFlushLiteral = () =>
		{
			if (tmpLiteralBuffer.length > 0)
			{
				tmpSegments.push({ Type: 'Literal', Value: tmpLiteralBuffer });
				tmpLiteralBuffer = '';
			}
		};

		let fRecordExpression = () =>
		{
			// Extract the hash (content between start and end tags)
			let tmpHash = tmpOutputBuffer.substr(
				tmpPattern.PatternStartString.length,
				tmpOutputBuffer.length - (tmpPattern.PatternStartString.length + tmpPattern.PatternEndString.length));

			fFlushLiteral();
			tmpSegments.push({
				Type: 'Expression',
				Hash: tmpHash,
				Leaf: tmpPattern,
				Tag: tmpPattern.PatternStartString
			});
		};

		let fResetState = () =>
		{
			tmpPattern = {};
			tmpPatternMatch = false;
			tmpStartPatternMatchComplete = false;
			tmpEndPatternMatchBegan = false;
			tmpPatternStartNode = false;
			tmpOutputBuffer = '';
		};

		for (let i = 0; i < pString.length; i++)
		{
			let tmpChar = pString[i];

			if (tmpPatternMatch)
			{
				if (!tmpStartPatternMatchComplete && (tmpChar in tmpPattern))
				{
					// Continue matching start pattern
					tmpPattern = tmpPattern[tmpChar];
					tmpOutputBuffer += tmpChar;
				}
				else if (tmpEndPatternMatchBegan)
				{
					if (tmpChar in tmpPattern.PatternEnd)
					{
						tmpPattern = tmpPattern.PatternEnd[tmpChar];
						tmpOutputBuffer += tmpChar;

						// End pattern is complete - record the expression
						fRecordExpression();
						fResetState();
						continue;
					}
					else if (tmpChar in tmpPatternStartNode.PatternEnd)
					{
						// Broke out of end, restart end matching
						tmpPattern = tmpPatternStartNode.PatternEnd[tmpChar];
						tmpOutputBuffer += tmpChar;
					}
					else
					{
						tmpEndPatternMatchBegan = false;
						tmpOutputBuffer += tmpChar;
					}
				}
				else if ('PatternEnd' in tmpPattern)
				{
					if (!tmpStartPatternMatchComplete)
					{
						tmpStartPatternMatchComplete = true;
						tmpPatternStartNode = tmpPattern;
					}

					tmpOutputBuffer += tmpChar;

					if (tmpChar in tmpPattern.PatternEnd)
					{
						tmpEndPatternMatchBegan = true;
						tmpPattern = tmpPattern.PatternEnd[tmpChar];

						// Single-char end pattern completes immediately
						if ('Parse' in tmpPattern)
						{
							fRecordExpression();
							fResetState();
							continue;
						}
					}
				}
				else
				{
					// Start pattern didn't match; flush accumulated chars as literal and retry
					tmpLiteralBuffer += tmpOutputBuffer;
					fResetState();
				}
			}

			if (!tmpPatternMatch)
			{
				if (tmpChar in pParseTree)
				{
					// Potential start of a new pattern
					// Flush any accumulated literal from a failed match
					if (tmpOutputBuffer.length > 0)
					{
						tmpLiteralBuffer += tmpOutputBuffer;
						tmpOutputBuffer = '';
					}
					tmpOutputBuffer = tmpChar;
					tmpPattern = pParseTree[tmpChar];
					tmpPatternMatch = true;
				}
				else
				{
					tmpLiteralBuffer += tmpChar;
				}
			}
		}

		// Flush any remaining content
		if (tmpOutputBuffer.length > 0)
		{
			tmpLiteralBuffer += tmpOutputBuffer;
		}
		fFlushLiteral();

		return tmpSegments;
	}

	// -- Fast-Path Execution --

	/**
	 * Execute a compiled template synchronously.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 * @param {any} pData - The data for template rendering
	 * @param {Array<any>} pContextArray - Context array
	 * @param {any} pScope - Sticky scope
	 * @param {any} pState - State object
	 *
	 * @return {string} The rendered output
	 */
	executeCompiled(pSegments, pData, pContextArray, pScope, pState)
	{
		let tmpPreviousDataContext = (Array.isArray(pContextArray)) ? pContextArray : [];
		let tmpDataContext = Array.from(tmpPreviousDataContext);
		tmpDataContext.push(pData);

		let tmpOutput = '';

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type === 'Literal')
			{
				tmpOutput += tmpSegment.Value;
			}
			else
			{
				let tmpLeaf = tmpSegment.Leaf;
				let tmpContext = ('ParserContext' in tmpLeaf) ? tmpLeaf.ParserContext : false;
				let tmpResult;
				if (tmpContext)
				{
					tmpResult = tmpLeaf.Parse.call(tmpContext, tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
				}
				else
				{
					tmpResult = tmpLeaf.Parse(tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
				}
				// Direct concatenation matches original Pict StringParser behavior
				// (e.g., undefined → "undefined", null → "null")
				tmpOutput += tmpResult;
			}
		}

		return tmpOutput;
	}

	/**
	 * Execute a compiled template asynchronously.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 * @param {any} pData - The data for template rendering
	 * @param {function} fCallback - Callback function (pError, pOutput)
	 * @param {Array<any>} pContextArray - Context array
	 * @param {any} pScope - Sticky scope
	 * @param {any} pState - State object
	 */
	executeCompiledAsync(pSegments, pData, fCallback, pContextArray, pScope, pState)
	{
		let tmpPreviousDataContext = (Array.isArray(pContextArray)) ? pContextArray : [];
		let tmpDataContext = Array.from(tmpPreviousDataContext);
		tmpDataContext.push(pData);

		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpOutputParts = new Array(pSegments.length);

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpIndex = i;
			let tmpSegment = pSegments[tmpIndex];

			if (tmpSegment.Type === 'Literal')
			{
				tmpAnticipate.anticipate(
					(fStepCallback) =>
					{
						tmpOutputParts[tmpIndex] = tmpSegment.Value;
						return fStepCallback();
					});
			}
			else
			{
				tmpAnticipate.anticipate(
					(fStepCallback) =>
					{
						let tmpLeaf = tmpSegment.Leaf;
						let tmpContext = ('ParserContext' in tmpLeaf) ? tmpLeaf.ParserContext : false;

						if (tmpLeaf.isAsync)
						{
							let fAsyncParse = tmpContext ? tmpLeaf.ParseAsync.bind(tmpContext) : tmpLeaf.ParseAsync;
							fAsyncParse(tmpSegment.Hash, pData,
								(pError, pAsyncOutput) =>
								{
									if (pError)
									{
										this.log.info(`Preprocessor ERROR: Async template error parsing ${tmpSegment.Tag}: ${pError}`);
									}
									// Force string coercion to match original Pict concatenation behavior
									// (Array.join swallows undefined/null, but the original parser
									// produces "undefined"/"null" via string concatenation)
									tmpOutputParts[tmpIndex] = '' + pAsyncOutput;
									return fStepCallback();
								}, tmpDataContext, pScope, pState);
						}
						else
						{
							let tmpResult;
							if (tmpContext)
							{
								tmpResult = tmpLeaf.Parse.call(tmpContext, tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
							}
							else
							{
								tmpResult = tmpLeaf.Parse(tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
							}
							// Force string coercion to match original Pict concatenation behavior
							tmpOutputParts[tmpIndex] = '' + tmpResult;
							return fStepCallback();
						}
					});
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				return fCallback(pError, tmpOutputParts.join(''));
			});
	}

	// -- Graph Population --

	/**
	 * Classify expression segments and add edges to the graph.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 * @param {string} pSourceTemplateID - The source template identifier
	 */
	classifyEdges(pSegments, pSourceTemplateID)
	{
		if (!pSourceTemplateID)
		{
			return;
		}

		let tmpSourceKey = this.graph.addNode('template', pSourceTemplateID);

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type !== 'Expression')
			{
				continue;
			}

			let tmpClassifier = this._EdgeClassifiers[tmpSegment.Tag];
			if (!tmpClassifier)
			{
				continue;
			}

			let tmpEdges = tmpClassifier(tmpSegment.Hash);
			for (let j = 0; j < tmpEdges.length; j++)
			{
				let tmpEdge = tmpEdges[j];
				let tmpTargetKey = this.graph.addNode(tmpEdge.NodeType, tmpEdge.NodeID);
				this.graph.addEdge(tmpSourceKey, tmpTargetKey, tmpEdge.EdgeType);
			}
		}
	}

	// -- Entity Prefetch --

	/**
	 * Collect entity expressions from compiled segments.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 *
	 * @return {Array<{EntityType: string, IDAddress: string}>} Array of entity expression descriptors
	 */
	_collectEntityExpressions(pSegments)
	{
		let tmpPlans = [];

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type !== 'Expression')
			{
				continue;
			}
			if (tmpSegment.Tag !== '{~E:' && tmpSegment.Tag !== '{~Entity:')
			{
				continue;
			}

			let tmpParts = tmpSegment.Hash.split('^');
			if (tmpParts.length < 2)
			{
				continue;
			}

			let tmpEntityType = tmpParts[0].trim();
			let tmpIDAddress = tmpParts[1].trim();

			if (tmpEntityType && tmpIDAddress)
			{
				tmpPlans.push({ EntityType: tmpEntityType, IDAddress: tmpIDAddress });
			}
		}

		return tmpPlans;
	}

	/**
	 * Collect entity expressions from a template and one level of referenced child templates.
	 * Compiles templates on demand if not already cached.
	 *
	 * @param {string} pTemplateString - The template string to scan
	 * @param {number} [pMaxDepth=1] - How many levels of template references to follow
	 *
	 * @return {Array<{EntityType: string, IDAddress: string}>} Array of entity expression descriptors
	 */
	_collectEntityExpressionsDeep(pTemplateString, pMaxDepth)
	{
		if (typeof pMaxDepth !== 'number')
		{
			pMaxDepth = 1;
		}

		let tmpCompiled = this.cache.get(pTemplateString);
		if (!tmpCompiled)
		{
			tmpCompiled = this.compile(pTemplateString, this.fable.MetaTemplate.ParseTree);
			this.cache.set(pTemplateString, tmpCompiled);
		}

		let tmpPlans = this._collectEntityExpressions(tmpCompiled);

		if (pMaxDepth <= 0)
		{
			return tmpPlans;
		}

		let tmpVisited = new Set();
		tmpVisited.add(pTemplateString);

		this._scanTemplateReferencesForEntities(tmpCompiled, tmpPlans, tmpVisited, pMaxDepth - 1);

		return tmpPlans;
	}

	/**
	 * Recursively scan template references in segments for entity expressions.
	 * Handles Template, TemplateIf, TemplateIfElse, and TemplateSet references.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array to scan
	 * @param {Array<Object>} pPlans - Accumulator for found entity plans
	 * @param {Set<string>} pVisited - Set of already-visited template strings to avoid cycles
	 * @param {number} pRemainingDepth - How many more levels to follow
	 * @private
	 */
	_scanTemplateReferencesForEntities(pSegments, pPlans, pVisited, pRemainingDepth)
	{
		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type !== 'Expression')
			{
				continue;
			}

			let tmpTemplateNames = [];

			if (tmpSegment.Tag === '{~T:' || tmpSegment.Tag === '{~Template:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
			}
			else if (tmpSegment.Tag === '{~TIf:' || tmpSegment.Tag === '{~TemplateIf:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
			}
			else if (tmpSegment.Tag === '{~TIfE:' || tmpSegment.Tag === '{~TemplateIfElse:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
				if (tmpParts.length >= 4 && tmpParts[3])
				{
					tmpTemplateNames.push(tmpParts[3].trim());
				}
			}
			else if (tmpSegment.Tag === '{~TS:' || tmpSegment.Tag === '{~TemplateSet:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
			}

			for (let j = 0; j < tmpTemplateNames.length; j++)
			{
				let tmpTemplateName = tmpTemplateNames[j];
				let tmpChildTemplateString = this.fable.TemplateProvider.getTemplate(tmpTemplateName);

				if (!tmpChildTemplateString || pVisited.has(tmpChildTemplateString))
				{
					continue;
				}

				pVisited.add(tmpChildTemplateString);

				let tmpChildCompiled = this.cache.get(tmpChildTemplateString);
				if (!tmpChildCompiled)
				{
					tmpChildCompiled = this.compile(tmpChildTemplateString, this.fable.MetaTemplate.ParseTree);
					this.cache.set(tmpChildTemplateString, tmpChildCompiled);
				}

				let tmpChildPlans = this._collectEntityExpressions(tmpChildCompiled);
				for (let k = 0; k < tmpChildPlans.length; k++)
				{
					pPlans.push(tmpChildPlans[k]);
				}

				if (pRemainingDepth > 0)
				{
					this._scanTemplateReferencesForEntities(tmpChildCompiled, pPlans, pVisited, pRemainingDepth - 1);
				}
			}
		}
	}

	/**
	 * Resolve an entity ID address against a record.
	 * Handles common address prefixes: Record., AppData., Scope., Context[N].
	 *
	 * @param {string} pAddress - The address to resolve (e.g., "Record.IDCity")
	 * @param {any} pRecord - The current data record
	 * @param {Array<any>} [pContextArray] - Context array
	 * @param {any} [pScope] - Scope object
	 * @param {any} [pState] - State object
	 *
	 * @return {any} The resolved value, or null if not resolvable
	 */
	_resolveEntityID(pAddress, pRecord, pContextArray, pScope, pState)
	{
		let tmpAddress = pAddress;
		let tmpRoot = pRecord;

		if (tmpAddress.startsWith('Record.'))
		{
			tmpAddress = tmpAddress.substring(7);
			tmpRoot = pRecord;
		}
		else if (tmpAddress.startsWith('AppData.'))
		{
			tmpAddress = tmpAddress.substring(8);
			tmpRoot = this.fable.AppData;
		}
		else if (tmpAddress.startsWith('Scope.'))
		{
			tmpAddress = tmpAddress.substring(6);
			tmpRoot = pScope;
		}
		else if (tmpAddress.startsWith('Context['))
		{
			let tmpMatch = tmpAddress.match(/^Context\[(\d+)\]\.(.+)$/);
			if (tmpMatch && Array.isArray(pContextArray) && pContextArray[parseInt(tmpMatch[1])])
			{
				tmpRoot = pContextArray[parseInt(tmpMatch[1])];
				tmpAddress = tmpMatch[2];
			}
			else
			{
				return null;
			}
		}

		if (tmpRoot == null || typeof tmpRoot !== 'object')
		{
			return null;
		}

		// Walk dot-notation path
		let tmpParts = tmpAddress.split('.');
		let tmpValue = tmpRoot;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpValue == null || typeof tmpValue !== 'object')
			{
				return null;
			}
			tmpValue = tmpValue[tmpParts[i]];
		}

		return tmpValue;
	}

	/**
	 * Extract an array of records from a dataset (handles both Array and Object datasets).
	 *
	 * @param {Array|Object} pDataSet - The dataset
	 *
	 * @return {Array} Array of records
	 */
	_getRecordsFromDataSet(pDataSet)
	{
		if (Array.isArray(pDataSet))
		{
			return pDataSet;
		}
		if (typeof pDataSet === 'object' && pDataSet !== null)
		{
			return Object.values(pDataSet);
		}
		return [];
	}

	/**
	 * Prefetch entities for a template set before iteration begins.
	 * Scans the template (and one level of child templates) for entity expressions,
	 * resolves IDs across the dataset, and batch-fetches them into the EntityProvider cache.
	 *
	 * @param {string} pTemplateString - The template string that will be iterated
	 * @param {Array|Object} pDataSet - The dataset to iterate
	 * @param {function} fCallback - Called when prefetch is complete (pError)
	 * @param {Array<any>} [pContextArray] - Context array
	 * @param {any} [pScope] - Scope object
	 * @param {any} [pState] - State object
	 */
	prefetchEntitiesForSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
	{
		// Guard: EntityProvider must exist
		if (!this.fable.EntityProvider)
		{
			return fCallback();
		}

		// Guard: template string and dataset must be valid
		if (typeof pTemplateString !== 'string' || pTemplateString.length < 1)
		{
			return fCallback();
		}
		if (!pDataSet || (typeof pDataSet !== 'object'))
		{
			return fCallback();
		}

		// Collect entity expressions from the template + one level deep
		let tmpEntityPlans = this._collectEntityExpressionsDeep(pTemplateString, 1);

		if (tmpEntityPlans.length < 1)
		{
			return fCallback();
		}

		// Gather unique IDs per entity type across the dataset
		let tmpRecords = this._getRecordsFromDataSet(pDataSet);
		let tmpEntityBatches = {};  // EntityType → Set of IDs

		for (let i = 0; i < tmpEntityPlans.length; i++)
		{
			let tmpPlan = tmpEntityPlans[i];

			if (!(tmpPlan.EntityType in tmpEntityBatches))
			{
				tmpEntityBatches[tmpPlan.EntityType] = new Set();
				this.fable.EntityProvider.initializeCache(tmpPlan.EntityType);
			}

			for (let j = 0; j < tmpRecords.length; j++)
			{
				let tmpID = this._resolveEntityID(tmpPlan.IDAddress, tmpRecords[j], pContextArray, pScope, pState);
				if (tmpID != null && tmpID !== '' && tmpID !== 0)
				{
					// Only add if not already in EntityProvider cache
					let tmpCached = this.fable.EntityProvider.recordCache[tmpPlan.EntityType].read(tmpID);
					if (!tmpCached)
					{
						tmpEntityBatches[tmpPlan.EntityType].add(tmpID);
					}
				}
			}
		}

		// Batch-fetch each entity type
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpEntityTypes = Object.keys(tmpEntityBatches);

		for (let i = 0; i < tmpEntityTypes.length; i++)
		{
			let tmpEntityType = tmpEntityTypes[i];
			let tmpIDs = tmpEntityBatches[tmpEntityType];

			if (tmpIDs.size < 1)
			{
				continue;
			}

			let tmpIDArray = Array.from(tmpIDs);

			tmpAnticipate.anticipate(
				(fNext) =>
				{
					let tmpFilter = `FBL~ID${tmpEntityType}~INN~${tmpIDArray.join(',')}`;

					this.fable.EntityProvider.getEntitySet(tmpEntityType, tmpFilter,
						(pError, pEntitySet) =>
						{
							if (pError)
							{
								this.log.warn(`Preprocessor: Entity prefetch error for [${tmpEntityType}]: ${pError}`);
							}
							// getEntitySet auto-caches via cacheIndividualEntityRecords
							return fNext();
						});
				});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				return fCallback(pError);
			});
	}

	// -- Wrapper Installation --

	/**
	 * Install preprocessor wrappers around parseTemplate methods on the Pict instance.
	 * Follows the same pattern as Pict-Template-Audit._installWrappers().
	 * @private
	 */
	_installWrappers()
	{
		let tmpPict = this.fable;
		let tmpPreprocessor = this;

		// Save reference to original methods
		this._originalParseTemplate = tmpPict.parseTemplate.bind(tmpPict);
		this._originalParseTemplateByHash = tmpPict.parseTemplateByHash.bind(tmpPict);

		// -- parseTemplate wrapper (the hot path) --
		tmpPict.parseTemplate = function _preprocessorParseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState)
		{
			if (typeof(pTemplateString) !== 'string' || pTemplateString.length < 1)
			{
				if (typeof(fCallback) === 'function')
				{
					return fCallback(null, '');
				}
				return '';
			}

			let tmpCompiled = tmpPreprocessor.cache.get(pTemplateString);
			if (!tmpCompiled)
			{
				tmpCompiled = tmpPreprocessor.compile(pTemplateString, tmpPict.MetaTemplate.ParseTree);
				tmpPreprocessor.cache.set(pTemplateString, tmpCompiled);

				// Extract graph edges if we know the source template
				let tmpSourceTemplate = (pState && pState._PreprocessorSourceTemplate) ? pState._PreprocessorSourceTemplate : null;
				tmpPreprocessor.classifyEdges(tmpCompiled, tmpSourceTemplate);
			}

			if (typeof(fCallback) === 'function')
			{
				return tmpPreprocessor.executeCompiledAsync(tmpCompiled, pData, fCallback, pContextArray, pScope, pState);
			}
			return tmpPreprocessor.executeCompiled(tmpCompiled, pData, pContextArray, pScope, pState);
		};

		// -- parseTemplateByHash wrapper (sets source node hint for graph) --
		tmpPict.parseTemplateByHash = function _preprocessorParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState)
		{
			let tmpTemplateString = tmpPict.TemplateProvider.getTemplate(pTemplateHash);
			if (!tmpTemplateString)
			{
				tmpTemplateString = '';
			}

			if (!pState)
			{
				pState = {};
			}
			pState._PreprocessorSourceTemplate = pTemplateHash;

			return tmpPict.parseTemplate(tmpTemplateString, pData, fCallback, pContextArray, pScope, pState);
		};

		// -- parseTemplateSet wrapper (prefetch entities before iteration) --
		this._originalParseTemplateSet = tmpPict.parseTemplateSet.bind(tmpPict);

		tmpPict.parseTemplateSet = function _preprocessorParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			// Sync path cannot do async prefetch — fall through to original
			if (typeof(fCallback) !== 'function')
			{
				return tmpPreprocessor._originalParseTemplateSet(pTemplateString, pDataSet, null, pContextArray, pScope, pState);
			}

			// Async path: prefetch entities, then proceed with normal iteration
			tmpPreprocessor.prefetchEntitiesForSet(pTemplateString, pDataSet,
				(pPrefetchError) =>
				{
					if (pPrefetchError)
					{
						tmpPreprocessor.log.warn(`Preprocessor: Entity prefetch error during template set: ${pPrefetchError}`);
					}
					return tmpPreprocessor._originalParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState);
				}, pContextArray, pScope, pState);
		};

		// -- parseTemplateSetByHash wrapper (sets source template + prefetch) --
		this._originalParseTemplateSetByHash = tmpPict.parseTemplateSetByHash.bind(tmpPict);

		tmpPict.parseTemplateSetByHash = function _preprocessorParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			let tmpTemplateString = tmpPict.TemplateProvider.getTemplate(pTemplateHash);
			if (!tmpTemplateString)
			{
				tmpTemplateString = '';
			}

			if (!pState)
			{
				pState = {};
			}
			pState._PreprocessorSourceTemplate = pTemplateHash;

			return tmpPict.parseTemplateSet(tmpTemplateString, pDataSet, fCallback, pContextArray, pScope, pState);
		};
	}

	/**
	 * Remove preprocessor wrappers and restore original methods.
	 */
	unwrapTemplateFunctions()
	{
		let tmpPict = this.fable;

		if (this._originalParseTemplate && typeof(this._originalParseTemplate) === 'function')
		{
			tmpPict.parseTemplate = this._originalParseTemplate;
			this._originalParseTemplate = null;
		}

		if (this._originalParseTemplateByHash && typeof(this._originalParseTemplateByHash) === 'function')
		{
			tmpPict.parseTemplateByHash = this._originalParseTemplateByHash;
			this._originalParseTemplateByHash = null;
		}

		if (this._originalParseTemplateSet && typeof(this._originalParseTemplateSet) === 'function')
		{
			tmpPict.parseTemplateSet = this._originalParseTemplateSet;
			this._originalParseTemplateSet = null;
		}

		if (this._originalParseTemplateSetByHash && typeof(this._originalParseTemplateSetByHash) === 'function')
		{
			tmpPict.parseTemplateSetByHash = this._originalParseTemplateSetByHash;
			this._originalParseTemplateSetByHash = null;
		}
	}

	/**
	 * Clear the compiled template cache.
	 */
	clearCache()
	{
		this.cache.clear();
	}

	/**
	 * Clear everything — cache and graph.
	 */
	clear()
	{
		this.cache.clear();
		this.graph.clear();
	}
}

module.exports = PictTemplatePreprocessor;

/** @type {Record<string, any>} */
PictTemplatePreprocessor.default_configuration = {};

},{"./Pict-Template-Preprocessor-Graph.js":688,"fable-serviceproviderbase":398}],690:[function(require,module,exports){
module.exports={
    "name": "pict-template",
    "version": "1.0.15",
    "description": "Pict Template Base Class",
    "main": "source/Pict-Template.js",
    "scripts": {
        "start": "node source/Pict-Template.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Template.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "pict": "^1.0.348",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],691:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":690,"fable-serviceproviderbase":398}],692:[function(require,module,exports){
module.exports={
    "name": "pict-view",
    "version": "1.0.68",
    "description": "Pict View Base Class",
    "main": "source/Pict-View.js",
    "scripts": {
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "start": "node source/Pict-View.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
        "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
        "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
        "types": "tsc -p .",
        "lint": "eslint source/**"
    },
    "types": "types/source/Pict-View.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.1",
        "pict": "^1.0.363",
        "quackage": "^1.0.65",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable": "^3.1.67",
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],693:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":692,"fable-serviceproviderbase":398}],694:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = [
	'Float16Array',
	'Float32Array',
	'Float64Array',
	'Int8Array',
	'Int16Array',
	'Int32Array',
	'Uint8Array',
	'Uint8ClampedArray',
	'Uint16Array',
	'Uint32Array',
	'BigInt64Array',
	'BigUint64Array'
];

},{}],695:[function(require,module,exports){
(function (process){(function (){
'use strict';

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this)}).call(this,require('_process'))

},{"_process":696}],696:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],697:[function(require,module,exports){
exports.publicEncrypt = require('./publicEncrypt')
exports.privateDecrypt = require('./privateDecrypt')

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}

},{"./privateDecrypt":700,"./publicEncrypt":701}],698:[function(require,module,exports){
var createHash = require('create-hash')
var Buffer = require('safe-buffer').Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}

},{"create-hash":349,"safe-buffer":736}],699:[function(require,module,exports){
arguments[4][270][0].apply(exports,arguments)
},{"buffer":280,"dup":270}],700:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var crt = require('browserify-rsa')
var createHash = require('create-hash')
var withPublic = require('./withPublic')
var Buffer = require('safe-buffer').Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}

},{"./mgf":698,"./withPublic":702,"./xor":703,"bn.js":699,"browserify-rsa":301,"create-hash":349,"parse-asn1":467,"safe-buffer":736}],701:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var randomBytes = require('randombytes')
var createHash = require('create-hash')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var withPublic = require('./withPublic')
var crt = require('browserify-rsa')
var Buffer = require('safe-buffer').Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}

},{"./mgf":698,"./withPublic":702,"./xor":703,"bn.js":699,"browserify-rsa":301,"create-hash":349,"parse-asn1":467,"randombytes":704,"safe-buffer":736}],702:[function(require,module,exports){
var BN = require('bn.js')
var Buffer = require('safe-buffer').Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic

},{"bn.js":699,"safe-buffer":736}],703:[function(require,module,exports){
module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}

},{}],704:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = require('safe-buffer').Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":696,"safe-buffer":736}],705:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = require('safe-buffer')
var randombytes = require('randombytes')
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":696,"randombytes":704,"safe-buffer":736}],706:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],707:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');
require('inherits')(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require('_process'))

},{"./_stream_readable":709,"./_stream_writable":711,"_process":696,"inherits":431}],708:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require('./_stream_transform');
require('inherits')(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":710,"inherits":431}],709:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = require('util');
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/buffer_list');
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require('inherits')(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":706,"./_stream_duplex":707,"./internal/streams/async_iterator":712,"./internal/streams/buffer_list":713,"./internal/streams/destroy":714,"./internal/streams/from":716,"./internal/streams/state":718,"./internal/streams/stream":719,"_process":696,"buffer":322,"events":395,"inherits":431,"string_decoder/":748,"util":280}],710:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var _require$codes = require('../errors').codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require('./_stream_duplex');
require('inherits')(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":706,"./_stream_duplex":707,"inherits":431}],711:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require('inherits')(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":706,"./_stream_duplex":707,"./internal/streams/destroy":714,"./internal/streams/state":718,"./internal/streams/stream":719,"_process":696,"buffer":322,"inherits":431,"util-deprecate":752}],712:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = require('./end-of-stream');
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require('_process'))

},{"./end-of-stream":715,"_process":696}],713:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('buffer'),
  Buffer = _require.Buffer;
var _require2 = require('util'),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();
},{"buffer":322,"util":280}],714:[function(require,module,exports){
(function (process){(function (){
'use strict';

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require('_process'))

},{"_process":696}],715:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;
},{"../../../errors":706}],716:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],717:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = require('../../../errors').codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;
},{"../../../errors":706,"./end-of-stream":715}],718:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":706}],719:[function(require,module,exports){
arguments[4][316][0].apply(exports,arguments)
},{"dup":316,"events":395}],720:[function(require,module,exports){
'use strict';

var Buffer = require('buffer').Buffer;
var inherits = require('inherits');
var HashBase = require('hash-base');

var ARRAY16 = new Array(16);

var zl = [
	0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var zr = [
	5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var sl = [
	11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sr = [
	8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

function rotl(x, n) {
	return (x << n) | (x >>> (32 - n));
}

function fn1(a, b, c, d, e, m, k, s) {
	return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0;
}

function fn2(a, b, c, d, e, m, k, s) {
	return (rotl((a + ((b & c) | (~b & d)) + m + k) | 0, s) + e) | 0;
}

function fn3(a, b, c, d, e, m, k, s) {
	return (rotl((a + ((b | ~c) ^ d) + m + k) | 0, s) + e) | 0;
}

function fn4(a, b, c, d, e, m, k, s) {
	return (rotl((a + ((b & d) | (c & ~d)) + m + k) | 0, s) + e) | 0;
}

function fn5(a, b, c, d, e, m, k, s) {
	return (rotl((a + (b ^ (c | ~d)) + m + k) | 0, s) + e) | 0;
}

function RIPEMD160() {
	HashBase.call(this, 64);

	// state
	this._a = 0x67452301;
	this._b = 0xefcdab89;
	this._c = 0x98badcfe;
	this._d = 0x10325476;
	this._e = 0xc3d2e1f0;
}

inherits(RIPEMD160, HashBase);

RIPEMD160.prototype._update = function () {
	var words = ARRAY16;
	for (var j = 0; j < 16; ++j) {
		words[j] = this._block.readInt32LE(j * 4);
	}

	var al = this._a | 0;
	var bl = this._b | 0;
	var cl = this._c | 0;
	var dl = this._d | 0;
	var el = this._e | 0;

	var ar = this._a | 0;
	var br = this._b | 0;
	var cr = this._c | 0;
	var dr = this._d | 0;
	var er = this._e | 0;

	// computation
	for (var i = 0; i < 80; i += 1) {
		var tl;
		var tr;
		if (i < 16) {
			tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
			tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
		} else if (i < 32) {
			tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
			tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
		} else if (i < 48) {
			tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
			tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
		} else if (i < 64) {
			tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
			tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
		} else { // if (i<80) {
			tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
			tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
		}

		al = el;
		el = dl;
		dl = rotl(cl, 10);
		cl = bl;
		bl = tl;

		ar = er;
		er = dr;
		dr = rotl(cr, 10);
		cr = br;
		br = tr;
	}

	// update state
	var t = (this._b + cl + dr) | 0;
	this._b = (this._c + dl + er) | 0;
	this._c = (this._d + el + ar) | 0;
	this._d = (this._e + al + br) | 0;
	this._e = (this._a + bl + cr) | 0;
	this._a = t;
};

RIPEMD160.prototype._digest = function () {
	// create padding and handle blocks
	this._block[this._blockOffset] = 0x80;
	this._blockOffset += 1;
	if (this._blockOffset > 56) {
		this._block.fill(0, this._blockOffset, 64);
		this._update();
		this._blockOffset = 0;
	}

	this._block.fill(0, this._blockOffset, 56);
	this._block.writeUInt32LE(this._length[0], 56);
	this._block.writeUInt32LE(this._length[1], 60);
	this._update();

	// produce result
	var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20); // eslint-disable-line no-buffer-constructor
	buffer.writeInt32LE(this._a, 0);
	buffer.writeInt32LE(this._b, 4);
	buffer.writeInt32LE(this._c, 8);
	buffer.writeInt32LE(this._d, 12);
	buffer.writeInt32LE(this._e, 16);
	return buffer;
};

module.exports = RIPEMD160;

},{"buffer":322,"hash-base":721,"inherits":431}],721:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('./to-buffer');
var Transform = require('readable-stream').Transform;
var inherits = require('inherits');

function HashBase(blockSize) {
	Transform.call(this);

	this._block = Buffer.allocUnsafe(blockSize);
	this._blockSize = blockSize;
	this._blockOffset = 0;
	this._length = [0, 0, 0, 0];

	this._finalized = false;
}

inherits(HashBase, Transform);

HashBase.prototype._transform = function (chunk, encoding, callback) {
	var error = null;
	try {
		this.update(chunk, encoding);
	} catch (err) {
		error = err;
	}

	callback(error);
};

HashBase.prototype._flush = function (callback) {
	var error = null;
	try {
		this.push(this.digest());
	} catch (err) {
		error = err;
	}

	callback(error);
};

HashBase.prototype.update = function (data, encoding) {
	if (this._finalized) {
		throw new Error('Digest already called');
	}

	var dataBuffer = toBuffer(data, encoding); // asserts correct input type

	// consume data
	var block = this._block;
	var offset = 0;
	while (this._blockOffset + dataBuffer.length - offset >= this._blockSize) {
		for (var i = this._blockOffset; i < this._blockSize;) {
			block[i] = dataBuffer[offset];
			i += 1;
			offset += 1;
		}
		this._update();
		this._blockOffset = 0;
	}
	while (offset < dataBuffer.length) {
		block[this._blockOffset] = dataBuffer[offset];
		this._blockOffset += 1;
		offset += 1;
	}

	// update length
	for (var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j) {
		this._length[j] += carry;
		carry = (this._length[j] / 0x0100000000) | 0;
		if (carry > 0) {
			this._length[j] -= 0x0100000000 * carry;
		}
	}

	return this;
};

HashBase.prototype._update = function () {
	throw new Error('_update is not implemented');
};

HashBase.prototype.digest = function (encoding) {
	if (this._finalized) {
		throw new Error('Digest already called');
	}
	this._finalized = true;

	var digest = this._digest();
	if (encoding !== undefined) {
		digest = digest.toString(encoding);
	}

	// reset state
	this._block.fill(0);
	this._blockOffset = 0;
	for (var i = 0; i < 4; ++i) {
		this._length[i] = 0;
	}

	return digest;
};

HashBase.prototype._digest = function () {
	throw new Error('_digest is not implemented');
};

module.exports = HashBase;

},{"./to-buffer":722,"inherits":431,"readable-stream":733,"safe-buffer":736}],722:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('to-buffer');

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = useUint8Array && typeof ArrayBuffer !== 'undefined';
var isView = useArrayBuffer && ArrayBuffer.isView;

module.exports = function (thing, encoding) {
	if (
		typeof thing === 'string'
    || Buffer.isBuffer(thing)
    || (useUint8Array && thing instanceof Uint8Array)
    || (isView && isView(thing))
	) {
		return toBuffer(thing, encoding);
	}
	throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

},{"safe-buffer":736,"to-buffer":750}],723:[function(require,module,exports){
arguments[4][308][0].apply(exports,arguments)
},{"dup":308}],724:[function(require,module,exports){
arguments[4][309][0].apply(exports,arguments)
},{"./_stream_readable":726,"./_stream_writable":728,"core-util-is":346,"dup":309,"inherits":431,"process-nextick-args":695}],725:[function(require,module,exports){
arguments[4][310][0].apply(exports,arguments)
},{"./_stream_transform":727,"core-util-is":346,"dup":310,"inherits":431}],726:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./_stream_duplex":724,"./internal/streams/BufferList":729,"./internal/streams/destroy":730,"./internal/streams/stream":731,"_process":696,"core-util-is":346,"events":395,"inherits":431,"isarray":723,"process-nextick-args":695,"safe-buffer":732,"string_decoder/":734,"util":280}],727:[function(require,module,exports){
arguments[4][312][0].apply(exports,arguments)
},{"./_stream_duplex":724,"core-util-is":346,"dup":312,"inherits":431}],728:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"./_stream_duplex":724,"./internal/streams/destroy":730,"./internal/streams/stream":731,"_process":696,"core-util-is":346,"inherits":431,"process-nextick-args":695,"safe-buffer":732,"timers":749,"util-deprecate":752}],729:[function(require,module,exports){
arguments[4][314][0].apply(exports,arguments)
},{"dup":314,"safe-buffer":732,"util":280}],730:[function(require,module,exports){
arguments[4][315][0].apply(exports,arguments)
},{"dup":315,"process-nextick-args":695}],731:[function(require,module,exports){
arguments[4][316][0].apply(exports,arguments)
},{"dup":316,"events":395}],732:[function(require,module,exports){
arguments[4][317][0].apply(exports,arguments)
},{"buffer":322,"dup":317}],733:[function(require,module,exports){
arguments[4][318][0].apply(exports,arguments)
},{"./lib/_stream_duplex.js":724,"./lib/_stream_passthrough.js":725,"./lib/_stream_readable.js":726,"./lib/_stream_transform.js":727,"./lib/_stream_writable.js":728,"dup":318}],734:[function(require,module,exports){
arguments[4][319][0].apply(exports,arguments)
},{"dup":319,"safe-buffer":735}],735:[function(require,module,exports){
arguments[4][317][0].apply(exports,arguments)
},{"buffer":322,"dup":317}],736:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":322}],737:[function(require,module,exports){
'use strict';

var callBound = require('call-bound');
var isRegex = require('is-regex');

var $exec = callBound('RegExp.prototype.exec');
var $TypeError = require('es-errors/type');

/** @type {import('.')} */
module.exports = function regexTester(regex) {
	if (!isRegex(regex)) {
		throw new $TypeError('`regex` must be a RegExp');
	}
	return function test(s) {
		return $exec(regex, s) !== null;
	};
};

},{"call-bound":333,"es-errors/type":392,"is-regex":436}],738:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var define = require('define-data-property');
var hasDescriptors = require('has-property-descriptors')();
var gOPD = require('gopd');

var $TypeError = require('es-errors/type');
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};

},{"define-data-property":356,"es-errors/type":392,"get-intrinsic":403,"gopd":408,"has-property-descriptors":409}],739:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('to-buffer');

// prototype class for hash functions
function Hash(blockSize, finalSize) {
	this._block = Buffer.alloc(blockSize);
	this._finalSize = finalSize;
	this._blockSize = blockSize;
	this._len = 0;
}

Hash.prototype.update = function (data, enc) {
	/* eslint no-param-reassign: 0 */
	data = toBuffer(data, enc || 'utf8');

	var block = this._block;
	var blockSize = this._blockSize;
	var length = data.length;
	var accum = this._len;

	for (var offset = 0; offset < length;) {
		var assigned = accum % blockSize;
		var remainder = Math.min(length - offset, blockSize - assigned);

		for (var i = 0; i < remainder; i++) {
			block[assigned + i] = data[offset + i];
		}

		accum += remainder;
		offset += remainder;

		if ((accum % blockSize) === 0) {
			this._update(block);
		}
	}

	this._len += length;
	return this;
};

Hash.prototype.digest = function (enc) {
	var rem = this._len % this._blockSize;

	this._block[rem] = 0x80;

	/*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */
	this._block.fill(0, rem + 1);

	if (rem >= this._finalSize) {
		this._update(this._block);
		this._block.fill(0);
	}

	var bits = this._len * 8;

	// uint32
	if (bits <= 0xffffffff) {
		this._block.writeUInt32BE(bits, this._blockSize - 4);

		// uint64
	} else {
		var lowBits = (bits & 0xffffffff) >>> 0;
		var highBits = (bits - lowBits) / 0x100000000;

		this._block.writeUInt32BE(highBits, this._blockSize - 8);
		this._block.writeUInt32BE(lowBits, this._blockSize - 4);
	}

	this._update(this._block);
	var hash = this._hash();

	return enc ? hash.toString(enc) : hash;
};

Hash.prototype._update = function () {
	throw new Error('_update must be implemented by subclass');
};

module.exports = Hash;

},{"safe-buffer":736,"to-buffer":750}],740:[function(require,module,exports){
'use strict';

module.exports = function SHA(algorithm) {
	var alg = algorithm.toLowerCase();

	var Algorithm = module.exports[alg];
	if (!Algorithm) {
		throw new Error(alg + ' is not supported (we accept pull requests)');
	}

	return new Algorithm();
};

module.exports.sha = require('./sha');
module.exports.sha1 = require('./sha1');
module.exports.sha224 = require('./sha224');
module.exports.sha256 = require('./sha256');
module.exports.sha384 = require('./sha384');
module.exports.sha512 = require('./sha512');

},{"./sha":741,"./sha1":742,"./sha224":743,"./sha256":744,"./sha384":745,"./sha512":746}],741:[function(require,module,exports){
'use strict';

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
];

var W = new Array(80);

function Sha() {
	this.init();
	this._w = W;

	Hash.call(this, 64, 56);
}

inherits(Sha, Hash);

Sha.prototype.init = function () {
	this._a = 0x67452301;
	this._b = 0xefcdab89;
	this._c = 0x98badcfe;
	this._d = 0x10325476;
	this._e = 0xc3d2e1f0;

	return this;
};

function rotl5(num) {
	return (num << 5) | (num >>> 27);
}

function rotl30(num) {
	return (num << 30) | (num >>> 2);
}

function ft(s, b, c, d) {
	if (s === 0) {
		return (b & c) | (~b & d);
	}
	if (s === 2) {
		return (b & c) | (b & d) | (c & d);
	}
	return b ^ c ^ d;
}

Sha.prototype._update = function (M) {
	var w = this._w;

	var a = this._a | 0;
	var b = this._b | 0;
	var c = this._c | 0;
	var d = this._d | 0;
	var e = this._e | 0;

	for (var i = 0; i < 16; ++i) {
		w[i] = M.readInt32BE(i * 4);
	}
	for (; i < 80; ++i) {
		w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
	}

	for (var j = 0; j < 80; ++j) {
		var s = ~~(j / 20);
		var t = (rotl5(a) + ft(s, b, c, d) + e + w[j] + K[s]) | 0;

		e = d;
		d = c;
		c = rotl30(b);
		b = a;
		a = t;
	}

	this._a = (a + this._a) | 0;
	this._b = (b + this._b) | 0;
	this._c = (c + this._c) | 0;
	this._d = (d + this._d) | 0;
	this._e = (e + this._e) | 0;
};

Sha.prototype._hash = function () {
	var H = Buffer.allocUnsafe(20);

	H.writeInt32BE(this._a | 0, 0);
	H.writeInt32BE(this._b | 0, 4);
	H.writeInt32BE(this._c | 0, 8);
	H.writeInt32BE(this._d | 0, 12);
	H.writeInt32BE(this._e | 0, 16);

	return H;
};

module.exports = Sha;

},{"./hash":739,"inherits":431,"safe-buffer":736}],742:[function(require,module,exports){
'use strict';

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
];

var W = new Array(80);

function Sha1() {
	this.init();
	this._w = W;

	Hash.call(this, 64, 56);
}

inherits(Sha1, Hash);

Sha1.prototype.init = function () {
	this._a = 0x67452301;
	this._b = 0xefcdab89;
	this._c = 0x98badcfe;
	this._d = 0x10325476;
	this._e = 0xc3d2e1f0;

	return this;
};

function rotl1(num) {
	return (num << 1) | (num >>> 31);
}

function rotl5(num) {
	return (num << 5) | (num >>> 27);
}

function rotl30(num) {
	return (num << 30) | (num >>> 2);
}

function ft(s, b, c, d) {
	if (s === 0) {
		return (b & c) | (~b & d);
	}
	if (s === 2) {
		return (b & c) | (b & d) | (c & d);
	}
	return b ^ c ^ d;
}

Sha1.prototype._update = function (M) {
	var w = this._w;

	var a = this._a | 0;
	var b = this._b | 0;
	var c = this._c | 0;
	var d = this._d | 0;
	var e = this._e | 0;

	for (var i = 0; i < 16; ++i) {
		w[i] = M.readInt32BE(i * 4);
	}
	for (; i < 80; ++i) {
		w[i] = rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
	}

	for (var j = 0; j < 80; ++j) {
		var s = ~~(j / 20);
		var t = (rotl5(a) + ft(s, b, c, d) + e + w[j] + K[s]) | 0;

		e = d;
		d = c;
		c = rotl30(b);
		b = a;
		a = t;
	}

	this._a = (a + this._a) | 0;
	this._b = (b + this._b) | 0;
	this._c = (c + this._c) | 0;
	this._d = (d + this._d) | 0;
	this._e = (e + this._e) | 0;
};

Sha1.prototype._hash = function () {
	var H = Buffer.allocUnsafe(20);

	H.writeInt32BE(this._a | 0, 0);
	H.writeInt32BE(this._b | 0, 4);
	H.writeInt32BE(this._c | 0, 8);
	H.writeInt32BE(this._d | 0, 12);
	H.writeInt32BE(this._e | 0, 16);

	return H;
};

module.exports = Sha1;

},{"./hash":739,"inherits":431,"safe-buffer":736}],743:[function(require,module,exports){
'use strict';

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits');
var Sha256 = require('./sha256');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var W = new Array(64);

function Sha224() {
	this.init();

	this._w = W; // new Array(64)

	Hash.call(this, 64, 56);
}

inherits(Sha224, Sha256);

Sha224.prototype.init = function () {
	this._a = 0xc1059ed8;
	this._b = 0x367cd507;
	this._c = 0x3070dd17;
	this._d = 0xf70e5939;
	this._e = 0xffc00b31;
	this._f = 0x68581511;
	this._g = 0x64f98fa7;
	this._h = 0xbefa4fa4;

	return this;
};

Sha224.prototype._hash = function () {
	var H = Buffer.allocUnsafe(28);

	H.writeInt32BE(this._a, 0);
	H.writeInt32BE(this._b, 4);
	H.writeInt32BE(this._c, 8);
	H.writeInt32BE(this._d, 12);
	H.writeInt32BE(this._e, 16);
	H.writeInt32BE(this._f, 20);
	H.writeInt32BE(this._g, 24);

	return H;
};

module.exports = Sha224;

},{"./hash":739,"./sha256":744,"inherits":431,"safe-buffer":736}],744:[function(require,module,exports){
'use strict';

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x428A2F98,
	0x71374491,
	0xB5C0FBCF,
	0xE9B5DBA5,
	0x3956C25B,
	0x59F111F1,
	0x923F82A4,
	0xAB1C5ED5,
	0xD807AA98,
	0x12835B01,
	0x243185BE,
	0x550C7DC3,
	0x72BE5D74,
	0x80DEB1FE,
	0x9BDC06A7,
	0xC19BF174,
	0xE49B69C1,
	0xEFBE4786,
	0x0FC19DC6,
	0x240CA1CC,
	0x2DE92C6F,
	0x4A7484AA,
	0x5CB0A9DC,
	0x76F988DA,
	0x983E5152,
	0xA831C66D,
	0xB00327C8,
	0xBF597FC7,
	0xC6E00BF3,
	0xD5A79147,
	0x06CA6351,
	0x14292967,
	0x27B70A85,
	0x2E1B2138,
	0x4D2C6DFC,
	0x53380D13,
	0x650A7354,
	0x766A0ABB,
	0x81C2C92E,
	0x92722C85,
	0xA2BFE8A1,
	0xA81A664B,
	0xC24B8B70,
	0xC76C51A3,
	0xD192E819,
	0xD6990624,
	0xF40E3585,
	0x106AA070,
	0x19A4C116,
	0x1E376C08,
	0x2748774C,
	0x34B0BCB5,
	0x391C0CB3,
	0x4ED8AA4A,
	0x5B9CCA4F,
	0x682E6FF3,
	0x748F82EE,
	0x78A5636F,
	0x84C87814,
	0x8CC70208,
	0x90BEFFFA,
	0xA4506CEB,
	0xBEF9A3F7,
	0xC67178F2
];

var W = new Array(64);

function Sha256() {
	this.init();

	this._w = W; // new Array(64)

	Hash.call(this, 64, 56);
}

inherits(Sha256, Hash);

Sha256.prototype.init = function () {
	this._a = 0x6a09e667;
	this._b = 0xbb67ae85;
	this._c = 0x3c6ef372;
	this._d = 0xa54ff53a;
	this._e = 0x510e527f;
	this._f = 0x9b05688c;
	this._g = 0x1f83d9ab;
	this._h = 0x5be0cd19;

	return this;
};

function ch(x, y, z) {
	return z ^ (x & (y ^ z));
}

function maj(x, y, z) {
	return (x & y) | (z & (x | y));
}

function sigma0(x) {
	return ((x >>> 2) | (x << 30)) ^ ((x >>> 13) | (x << 19)) ^ ((x >>> 22) | (x << 10));
}

function sigma1(x) {
	return ((x >>> 6) | (x << 26)) ^ ((x >>> 11) | (x << 21)) ^ ((x >>> 25) | (x << 7));
}

function gamma0(x) {
	return ((x >>> 7) | (x << 25)) ^ ((x >>> 18) | (x << 14)) ^ (x >>> 3);
}

function gamma1(x) {
	return ((x >>> 17) | (x << 15)) ^ ((x >>> 19) | (x << 13)) ^ (x >>> 10);
}

Sha256.prototype._update = function (M) {
	var w = this._w;

	var a = this._a | 0;
	var b = this._b | 0;
	var c = this._c | 0;
	var d = this._d | 0;
	var e = this._e | 0;
	var f = this._f | 0;
	var g = this._g | 0;
	var h = this._h | 0;

	for (var i = 0; i < 16; ++i) {
		w[i] = M.readInt32BE(i * 4);
	}
	for (; i < 64; ++i) {
		w[i] = (gamma1(w[i - 2]) + w[i - 7] + gamma0(w[i - 15]) + w[i - 16]) | 0;
	}

	for (var j = 0; j < 64; ++j) {
		var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + w[j]) | 0;
		var T2 = (sigma0(a) + maj(a, b, c)) | 0;

		h = g;
		g = f;
		f = e;
		e = (d + T1) | 0;
		d = c;
		c = b;
		b = a;
		a = (T1 + T2) | 0;
	}

	this._a = (a + this._a) | 0;
	this._b = (b + this._b) | 0;
	this._c = (c + this._c) | 0;
	this._d = (d + this._d) | 0;
	this._e = (e + this._e) | 0;
	this._f = (f + this._f) | 0;
	this._g = (g + this._g) | 0;
	this._h = (h + this._h) | 0;
};

Sha256.prototype._hash = function () {
	var H = Buffer.allocUnsafe(32);

	H.writeInt32BE(this._a, 0);
	H.writeInt32BE(this._b, 4);
	H.writeInt32BE(this._c, 8);
	H.writeInt32BE(this._d, 12);
	H.writeInt32BE(this._e, 16);
	H.writeInt32BE(this._f, 20);
	H.writeInt32BE(this._g, 24);
	H.writeInt32BE(this._h, 28);

	return H;
};

module.exports = Sha256;

},{"./hash":739,"inherits":431,"safe-buffer":736}],745:[function(require,module,exports){
'use strict';

var inherits = require('inherits');
var SHA512 = require('./sha512');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var W = new Array(160);

function Sha384() {
	this.init();
	this._w = W;

	Hash.call(this, 128, 112);
}

inherits(Sha384, SHA512);

Sha384.prototype.init = function () {
	this._ah = 0xcbbb9d5d;
	this._bh = 0x629a292a;
	this._ch = 0x9159015a;
	this._dh = 0x152fecd8;
	this._eh = 0x67332667;
	this._fh = 0x8eb44a87;
	this._gh = 0xdb0c2e0d;
	this._hh = 0x47b5481d;

	this._al = 0xc1059ed8;
	this._bl = 0x367cd507;
	this._cl = 0x3070dd17;
	this._dl = 0xf70e5939;
	this._el = 0xffc00b31;
	this._fl = 0x68581511;
	this._gl = 0x64f98fa7;
	this._hl = 0xbefa4fa4;

	return this;
};

Sha384.prototype._hash = function () {
	var H = Buffer.allocUnsafe(48);

	function writeInt64BE(h, l, offset) {
		H.writeInt32BE(h, offset);
		H.writeInt32BE(l, offset + 4);
	}

	writeInt64BE(this._ah, this._al, 0);
	writeInt64BE(this._bh, this._bl, 8);
	writeInt64BE(this._ch, this._cl, 16);
	writeInt64BE(this._dh, this._dl, 24);
	writeInt64BE(this._eh, this._el, 32);
	writeInt64BE(this._fh, this._fl, 40);

	return H;
};

module.exports = Sha384;

},{"./hash":739,"./sha512":746,"inherits":431,"safe-buffer":736}],746:[function(require,module,exports){
'use strict';

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x428a2f98,
	0xd728ae22,
	0x71374491,
	0x23ef65cd,
	0xb5c0fbcf,
	0xec4d3b2f,
	0xe9b5dba5,
	0x8189dbbc,
	0x3956c25b,
	0xf348b538,
	0x59f111f1,
	0xb605d019,
	0x923f82a4,
	0xaf194f9b,
	0xab1c5ed5,
	0xda6d8118,
	0xd807aa98,
	0xa3030242,
	0x12835b01,
	0x45706fbe,
	0x243185be,
	0x4ee4b28c,
	0x550c7dc3,
	0xd5ffb4e2,
	0x72be5d74,
	0xf27b896f,
	0x80deb1fe,
	0x3b1696b1,
	0x9bdc06a7,
	0x25c71235,
	0xc19bf174,
	0xcf692694,
	0xe49b69c1,
	0x9ef14ad2,
	0xefbe4786,
	0x384f25e3,
	0x0fc19dc6,
	0x8b8cd5b5,
	0x240ca1cc,
	0x77ac9c65,
	0x2de92c6f,
	0x592b0275,
	0x4a7484aa,
	0x6ea6e483,
	0x5cb0a9dc,
	0xbd41fbd4,
	0x76f988da,
	0x831153b5,
	0x983e5152,
	0xee66dfab,
	0xa831c66d,
	0x2db43210,
	0xb00327c8,
	0x98fb213f,
	0xbf597fc7,
	0xbeef0ee4,
	0xc6e00bf3,
	0x3da88fc2,
	0xd5a79147,
	0x930aa725,
	0x06ca6351,
	0xe003826f,
	0x14292967,
	0x0a0e6e70,
	0x27b70a85,
	0x46d22ffc,
	0x2e1b2138,
	0x5c26c926,
	0x4d2c6dfc,
	0x5ac42aed,
	0x53380d13,
	0x9d95b3df,
	0x650a7354,
	0x8baf63de,
	0x766a0abb,
	0x3c77b2a8,
	0x81c2c92e,
	0x47edaee6,
	0x92722c85,
	0x1482353b,
	0xa2bfe8a1,
	0x4cf10364,
	0xa81a664b,
	0xbc423001,
	0xc24b8b70,
	0xd0f89791,
	0xc76c51a3,
	0x0654be30,
	0xd192e819,
	0xd6ef5218,
	0xd6990624,
	0x5565a910,
	0xf40e3585,
	0x5771202a,
	0x106aa070,
	0x32bbd1b8,
	0x19a4c116,
	0xb8d2d0c8,
	0x1e376c08,
	0x5141ab53,
	0x2748774c,
	0xdf8eeb99,
	0x34b0bcb5,
	0xe19b48a8,
	0x391c0cb3,
	0xc5c95a63,
	0x4ed8aa4a,
	0xe3418acb,
	0x5b9cca4f,
	0x7763e373,
	0x682e6ff3,
	0xd6b2b8a3,
	0x748f82ee,
	0x5defb2fc,
	0x78a5636f,
	0x43172f60,
	0x84c87814,
	0xa1f0ab72,
	0x8cc70208,
	0x1a6439ec,
	0x90befffa,
	0x23631e28,
	0xa4506ceb,
	0xde82bde9,
	0xbef9a3f7,
	0xb2c67915,
	0xc67178f2,
	0xe372532b,
	0xca273ece,
	0xea26619c,
	0xd186b8c7,
	0x21c0c207,
	0xeada7dd6,
	0xcde0eb1e,
	0xf57d4f7f,
	0xee6ed178,
	0x06f067aa,
	0x72176fba,
	0x0a637dc5,
	0xa2c898a6,
	0x113f9804,
	0xbef90dae,
	0x1b710b35,
	0x131c471b,
	0x28db77f5,
	0x23047d84,
	0x32caab7b,
	0x40c72493,
	0x3c9ebe0a,
	0x15c9bebc,
	0x431d67c4,
	0x9c100d4c,
	0x4cc5d4be,
	0xcb3e42b6,
	0x597f299c,
	0xfc657e2a,
	0x5fcb6fab,
	0x3ad6faec,
	0x6c44198c,
	0x4a475817
];

var W = new Array(160);

function Sha512() {
	this.init();
	this._w = W;

	Hash.call(this, 128, 112);
}

inherits(Sha512, Hash);

Sha512.prototype.init = function () {
	this._ah = 0x6a09e667;
	this._bh = 0xbb67ae85;
	this._ch = 0x3c6ef372;
	this._dh = 0xa54ff53a;
	this._eh = 0x510e527f;
	this._fh = 0x9b05688c;
	this._gh = 0x1f83d9ab;
	this._hh = 0x5be0cd19;

	this._al = 0xf3bcc908;
	this._bl = 0x84caa73b;
	this._cl = 0xfe94f82b;
	this._dl = 0x5f1d36f1;
	this._el = 0xade682d1;
	this._fl = 0x2b3e6c1f;
	this._gl = 0xfb41bd6b;
	this._hl = 0x137e2179;

	return this;
};

function Ch(x, y, z) {
	return z ^ (x & (y ^ z));
}

function maj(x, y, z) {
	return (x & y) | (z & (x | y));
}

function sigma0(x, xl) {
	return ((x >>> 28) | (xl << 4)) ^ ((xl >>> 2) | (x << 30)) ^ ((xl >>> 7) | (x << 25));
}

function sigma1(x, xl) {
	return ((x >>> 14) | (xl << 18)) ^ ((x >>> 18) | (xl << 14)) ^ ((xl >>> 9) | (x << 23));
}

function Gamma0(x, xl) {
	return ((x >>> 1) | (xl << 31)) ^ ((x >>> 8) | (xl << 24)) ^ (x >>> 7);
}

function Gamma0l(x, xl) {
	return ((x >>> 1) | (xl << 31)) ^ ((x >>> 8) | (xl << 24)) ^ ((x >>> 7) | (xl << 25));
}

function Gamma1(x, xl) {
	return ((x >>> 19) | (xl << 13)) ^ ((xl >>> 29) | (x << 3)) ^ (x >>> 6);
}

function Gamma1l(x, xl) {
	return ((x >>> 19) | (xl << 13)) ^ ((xl >>> 29) | (x << 3)) ^ ((x >>> 6) | (xl << 26));
}

function getCarry(a, b) {
	return (a >>> 0) < (b >>> 0) ? 1 : 0;
}

Sha512.prototype._update = function (M) {
	var w = this._w;

	var ah = this._ah | 0;
	var bh = this._bh | 0;
	var ch = this._ch | 0;
	var dh = this._dh | 0;
	var eh = this._eh | 0;
	var fh = this._fh | 0;
	var gh = this._gh | 0;
	var hh = this._hh | 0;

	var al = this._al | 0;
	var bl = this._bl | 0;
	var cl = this._cl | 0;
	var dl = this._dl | 0;
	var el = this._el | 0;
	var fl = this._fl | 0;
	var gl = this._gl | 0;
	var hl = this._hl | 0;

	for (var i = 0; i < 32; i += 2) {
		w[i] = M.readInt32BE(i * 4);
		w[i + 1] = M.readInt32BE((i * 4) + 4);
	}
	for (; i < 160; i += 2) {
		var xh = w[i - (15 * 2)];
		var xl = w[i - (15 * 2) + 1];
		var gamma0 = Gamma0(xh, xl);
		var gamma0l = Gamma0l(xl, xh);

		xh = w[i - (2 * 2)];
		xl = w[i - (2 * 2) + 1];
		var gamma1 = Gamma1(xh, xl);
		var gamma1l = Gamma1l(xl, xh);

		// w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
		var Wi7h = w[i - (7 * 2)];
		var Wi7l = w[i - (7 * 2) + 1];

		var Wi16h = w[i - (16 * 2)];
		var Wi16l = w[i - (16 * 2) + 1];

		var Wil = (gamma0l + Wi7l) | 0;
		var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
		Wil = (Wil + gamma1l) | 0;
		Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
		Wil = (Wil + Wi16l) | 0;
		Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;

		w[i] = Wih;
		w[i + 1] = Wil;
	}

	for (var j = 0; j < 160; j += 2) {
		Wih = w[j];
		Wil = w[j + 1];

		var majh = maj(ah, bh, ch);
		var majl = maj(al, bl, cl);

		var sigma0h = sigma0(ah, al);
		var sigma0l = sigma0(al, ah);
		var sigma1h = sigma1(eh, el);
		var sigma1l = sigma1(el, eh);

		// t1 = h + sigma1 + ch + K[j] + w[j]
		var Kih = K[j];
		var Kil = K[j + 1];

		var chh = Ch(eh, fh, gh);
		var chl = Ch(el, fl, gl);

		var t1l = (hl + sigma1l) | 0;
		var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
		t1l = (t1l + chl) | 0;
		t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
		t1l = (t1l + Kil) | 0;
		t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
		t1l = (t1l + Wil) | 0;
		t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0;

		// t2 = sigma0 + maj
		var t2l = (sigma0l + majl) | 0;
		var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;

		hh = gh;
		hl = gl;
		gh = fh;
		gl = fl;
		fh = eh;
		fl = el;
		el = (dl + t1l) | 0;
		eh = (dh + t1h + getCarry(el, dl)) | 0;
		dh = ch;
		dl = cl;
		ch = bh;
		cl = bl;
		bh = ah;
		bl = al;
		al = (t1l + t2l) | 0;
		ah = (t1h + t2h + getCarry(al, t1l)) | 0;
	}

	this._al = (this._al + al) | 0;
	this._bl = (this._bl + bl) | 0;
	this._cl = (this._cl + cl) | 0;
	this._dl = (this._dl + dl) | 0;
	this._el = (this._el + el) | 0;
	this._fl = (this._fl + fl) | 0;
	this._gl = (this._gl + gl) | 0;
	this._hl = (this._hl + hl) | 0;

	this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
	this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
	this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
	this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
	this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
	this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
	this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
	this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
};

Sha512.prototype._hash = function () {
	var H = Buffer.allocUnsafe(64);

	function writeInt64BE(h, l, offset) {
		H.writeInt32BE(h, offset);
		H.writeInt32BE(l, offset + 4);
	}

	writeInt64BE(this._ah, this._al, 0);
	writeInt64BE(this._bh, this._bl, 8);
	writeInt64BE(this._ch, this._cl, 16);
	writeInt64BE(this._dh, this._dl, 24);
	writeInt64BE(this._eh, this._el, 32);
	writeInt64BE(this._fh, this._fl, 40);
	writeInt64BE(this._gh, this._gl, 48);
	writeInt64BE(this._hh, this._hl, 56);

	return H;
};

module.exports = Sha512;

},{"./hash":739,"inherits":431,"safe-buffer":736}],747:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/lib/_stream_readable.js');
Stream.Writable = require('readable-stream/lib/_stream_writable.js');
Stream.Duplex = require('readable-stream/lib/_stream_duplex.js');
Stream.Transform = require('readable-stream/lib/_stream_transform.js');
Stream.PassThrough = require('readable-stream/lib/_stream_passthrough.js');
Stream.finished = require('readable-stream/lib/internal/streams/end-of-stream.js')
Stream.pipeline = require('readable-stream/lib/internal/streams/pipeline.js')

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":395,"inherits":431,"readable-stream/lib/_stream_duplex.js":707,"readable-stream/lib/_stream_passthrough.js":708,"readable-stream/lib/_stream_readable.js":709,"readable-stream/lib/_stream_transform.js":710,"readable-stream/lib/_stream_writable.js":711,"readable-stream/lib/internal/streams/end-of-stream.js":715,"readable-stream/lib/internal/streams/pipeline.js":717}],748:[function(require,module,exports){
arguments[4][319][0].apply(exports,arguments)
},{"dup":319,"safe-buffer":736}],749:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":696,"timers":749}],750:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var isArray = require('isarray');
var typedArrayBuffer = require('typed-array-buffer');

var isView = ArrayBuffer.isView || function isView(obj) {
	try {
		typedArrayBuffer(obj);
		return true;
	} catch (e) {
		return false;
	}
};

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = typeof ArrayBuffer !== 'undefined'
	&& typeof Uint8Array !== 'undefined';
var useFromArrayBuffer = useArrayBuffer && (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);

module.exports = function toBuffer(data, encoding) {
	if (Buffer.isBuffer(data)) {
		if (data.constructor && !('isBuffer' in data)) {
			// probably a SlowBuffer
			return Buffer.from(data);
		}
		return data;
	}

	if (typeof data === 'string') {
		return Buffer.from(data, encoding);
	}

	/*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */
	if (useArrayBuffer && isView(data)) {
		// Bug in Node.js <6.3.1, which treats this as out-of-bounds
		if (data.byteLength === 0) {
			return Buffer.alloc(0);
		}

		// When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
		if (useFromArrayBuffer) {
			var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
			/*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */
			if (res.byteLength === data.byteLength) {
				return res;
			}
		}

		// Convert to Uint8Array bytes and then to Buffer
		var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
		var result = Buffer.from(uint8);

		/*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */
		if (result.length === data.byteLength) {
			return result;
		}
	}

	/*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */
	if (useUint8Array && data instanceof Uint8Array) {
		return Buffer.from(data);
	}

	var isArr = isArray(data);
	if (isArr) {
		for (var i = 0; i < data.length; i += 1) {
			var x = data[i];
			if (
				typeof x !== 'number'
				|| x < 0
				|| x > 255
				|| ~~x !== x // NaN and integer check
			) {
				throw new RangeError('Array items must be numbers in the range 0-255.');
			}
		}
	}

	/*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */
	if (
		isArr || (
			Buffer.isBuffer(data)
			&& data.constructor
			&& typeof data.constructor.isBuffer === 'function'
			&& data.constructor.isBuffer(data)
		)
	) {
		return Buffer.from(data);
	}

	throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

},{"isarray":438,"safe-buffer":736,"typed-array-buffer":751}],751:[function(require,module,exports){
'use strict';

var $TypeError = require('es-errors/type');

var callBound = require('call-bound');

/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */
var $typedArrayBuffer = callBound('TypedArray.prototype.buffer', true);

var isTypedArray = require('is-typed-array');

/** @type {import('.')} */
// node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $typedArrayBuffer || function typedArrayBuffer(x) {
	if (!isTypedArray(x)) {
		throw new $TypeError('Not a Typed Array');
	}
	return x.buffer;
};

},{"call-bound":333,"es-errors/type":392,"is-typed-array":437}],752:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],753:[function(require,module,exports){
arguments[4][273][0].apply(exports,arguments)
},{"dup":273}],754:[function(require,module,exports){
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

'use strict';

var isArgumentsObject = require('is-arguments');
var isGeneratorFunction = require('is-generator-function');
var whichTypedArray = require('which-typed-array');
var isTypedArray = require('is-typed-array');

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});

},{"is-arguments":432,"is-generator-function":435,"is-typed-array":437,"which-typed-array":757}],755:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = require('./support/types');

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

}).call(this)}).call(this,require('_process'))

},{"./support/isBuffer":753,"./support/types":754,"_process":696,"inherits":431}],756:[function(require,module,exports){
var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};

},{}],757:[function(require,module,exports){
(function (global){(function (){
'use strict';

var forEach = require('for-each');
var availableTypedArrays = require('available-typed-arrays');
var callBind = require('call-bind');
var callBound = require('call-bound');
var gOPD = require('gopd');
var getProto = require('get-proto');

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require('has-tostringtag/shams')();

var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');

/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */
/** @import { TypedArrayName } from '.' */

/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};

/** @type {Cache} */
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getProto) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr && getProto) {
			var proto = getProto(arr);
			// @ts-expect-error TS won't narrow inside a closure
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor && proto) {
				var superProto = getProto(proto);
				// @ts-expect-error TS won't narrow inside a closure
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			if (descriptor && descriptor.get) {
				var bound = callBind(descriptor.get);
				cache[
					/** @type {`$${TypedArrayName}`} */
					('$' + typedArray)
				] = bound;
			}
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			var bound = /** @type {typeof BoundSlice | typeof BoundSet} */ (
				// @ts-expect-error TODO FIXME
				callBind(fn)
			);
			cache[
				/** @type {`$${TypedArrayName}`} */
				('$' + typedArray)
			] = bound;
		}
	});
}

/** @type {(value: object) => false | TypedArrayName} */
function tryTypedArrays(value) {
	/** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
	forEach(
		/** @type {Record<`$${TypedArrayName}`, Getter>} */ (cache),
		/** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */
		function (getter, typedArray) {
			if (!found) {
				try {
					// @ts-expect-error a throw is fine here
					if ('$' + getter(value) === typedArray) {
						found = /** @type {TypedArrayName} */ ($slice(typedArray, 1));
					}
				} catch (e) { /**/ }
			}
		}
	);
	return found;
}

/** @type {(value: object) => false | TypedArrayName} */
function trySlices(value) {
	/** @type {ReturnType<typeof trySlices>} */ var found = false;
	forEach(
		/** @type {Record<`$${TypedArrayName}`, Getter>} */(cache),
		/** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function (getter, name) {
			if (!found) {
				try {
					// @ts-expect-error a throw is fine here
					getter(value);
					found = /** @type {TypedArrayName} */ ($slice(name, 1));
				} catch (e) { /**/ }
			}
		}
	);
	return found;
}

/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */
function isTATag(tag) {
	return $indexOf(typedArrays, tag) > -1;
}

/** @type {(value: unknown) => ReturnType<typeof import('.')>} */
function whichTypedArray(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		var tag = $slice($toString(value), 8, -1);
		if (isTATag(tag)) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
}

module.exports = whichTypedArray;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"available-typed-arrays":276,"call-bind":332,"call-bound":333,"for-each":399,"get-proto":406,"gopd":408,"has-tostringtag/shams":412}],758:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "v1", {
  enumerable: true,
  get: function () {
    return _v.default;
  }
});
Object.defineProperty(exports, "v3", {
  enumerable: true,
  get: function () {
    return _v2.default;
  }
});
Object.defineProperty(exports, "v4", {
  enumerable: true,
  get: function () {
    return _v3.default;
  }
});
Object.defineProperty(exports, "v5", {
  enumerable: true,
  get: function () {
    return _v4.default;
  }
});
Object.defineProperty(exports, "NIL", {
  enumerable: true,
  get: function () {
    return _nil.default;
  }
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function () {
    return _version.default;
  }
});
Object.defineProperty(exports, "validate", {
  enumerable: true,
  get: function () {
    return _validate.default;
  }
});
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function () {
    return _stringify.default;
  }
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function () {
    return _parse.default;
  }
});

var _v = _interopRequireDefault(require("./v1.js"));

var _v2 = _interopRequireDefault(require("./v3.js"));

var _v3 = _interopRequireDefault(require("./v4.js"));

var _v4 = _interopRequireDefault(require("./v5.js"));

var _nil = _interopRequireDefault(require("./nil.js"));

var _version = _interopRequireDefault(require("./version.js"));

var _validate = _interopRequireDefault(require("./validate.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

var _parse = _interopRequireDefault(require("./parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./nil.js":760,"./parse.js":761,"./stringify.js":765,"./v1.js":766,"./v3.js":767,"./v4.js":769,"./v5.js":770,"./validate.js":771,"./version.js":772}],759:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports.default = _default;
},{}],760:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports.default = _default;
},{}],761:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports.default = _default;
},{"./validate.js":771}],762:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports.default = _default;
},{}],763:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
},{}],764:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports.default = _default;
},{}],765:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports.default = _default;
},{"./validate.js":771}],766:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.default)(b);
}

var _default = v1;
exports.default = _default;
},{"./rng.js":763,"./stringify.js":765}],767:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _md = _interopRequireDefault(require("./md5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports.default = _default;
},{"./md5.js":759,"./v35.js":768}],768:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.URL = exports.DNS = void 0;

var _stringify = _interopRequireDefault(require("./stringify.js"));

var _parse = _interopRequireDefault(require("./parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function _default(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.default)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
},{"./parse.js":761,"./stringify.js":765}],769:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.default)(rnds);
}

var _default = v4;
exports.default = _default;
},{"./rng.js":763,"./stringify.js":765}],770:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _sha = _interopRequireDefault(require("./sha1.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports.default = _default;
},{"./sha1.js":764,"./v35.js":768}],771:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regex = _interopRequireDefault(require("./regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports.default = _default;
},{"./regex.js":762}],772:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

var _default = version;
exports.default = _default;
},{"./validate.js":771}],773:[function(require,module,exports){
/**
 * How a document's workflow state should read on screen.
 *
 * An approval workflow carries two names per state: `Status` is the hash it keys transitions off
 * (`InTest`, `Pending_DLE`, `Approved`), and `StateName` is the name authored for people ("In Test",
 * "Waiting for District Lab Engineer Approval", "Authorized in Sitemanager"). The panels label this
 * field "Status" to the user, so the authored name is the one that belongs there.
 *
 * The fallback is not decoration. A Draft is created by the API service without consulting the
 * approval workflow, so it carries a `Status` and no `StateName` at all - on LADOTD that is 818 of a
 * 6,000-document sample. Preferring `StateName` without falling back would blank every one of them.
 *
 * @module DocumentStateDisplay
 */

/** @param {any} pValue @return {string} the value as trimmed display text, '' when there is none. */
const asDisplayText = (pValue) => (pValue === undefined || pValue === null) ? '' : String(pValue).trim();

/**
 * The workflow state of a document, as it should be shown to a person.
 *
 * @param {Record<string, any>} pRecord - a document-shaped record carrying `StateName` and/or `Status`.
 * @return {string} the authored state name, else the raw status, else '' (never 'undefined').
 */
function resolveDocumentStateDisplay(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object')
	{
		return '';
	}
	return asDisplayText(pRecord.StateName) || asDisplayText(pRecord.Status);
}

module.exports = { resolveDocumentStateDisplay, asDisplayText };

},{}],774:[function(require,module,exports){
/**
 * HeadlightToastAdapter
 *
 * Pure, framework-free translation between the legacy object-first toast options
 * (`{ message, type: 'is-danger', ... }`) used across ~45 Headlight call sites and
 * the Pict-Section-Modal `toast(message, options)` API. Kept as a plain class (no
 * Pict/DOM dependencies) so it is unit-testable in isolation.
 *
 * Behaviors preserved from the former bulma-toast wrapper:
 *  - `is-*` type classes mapped to PSM's enum (info/success/warning/error)
 *  - single-toast (only one visible at a time) via handle bookkeeping
 *  - duplicate throttle (identical type+message within a short window is dropped)
 *  - HTML messages rendered (auto-detected, or forced via `allowHTML`)
 *
 * Added since: `sticky` toasts, which opt out of auto-dismiss, the throttle, and single-toast eviction.
 */

const _TYPE_MAP =
{
	'is-info': 'info',
	'is-success': 'success',
	'is-warning': 'warning',
	'is-danger': 'error',
	'is-error': 'error',
	// pass-through for callers already using PSM enum values
	'info': 'info',
	'success': 'success',
	'warning': 'warning',
	'error': 'error',
};

class HeadlightToastAdapter
{
	constructor(pOptions)
	{
		this._throttleWindowMS = (pOptions && typeof pOptions.ThrottleWindowMS === 'number') ? pOptions.ThrottleWindowMS : 1000;
		this._recent = {};          // key -> last-shown epoch ms
		this._activeHandles = [];   // outstanding PSM handles (single-toast bookkeeping)
	}

	mapType(pType)
	{
		return _TYPE_MAP[pType] || 'info';
	}

	looksLikeHTML(pMessage)
	{
		// Accept both primitive strings and boxed String objects (typeof 'object').
		if (typeof pMessage !== 'string' && !(pMessage instanceof String))
		{
			return false;
		}
		// RegExp.test coerces a boxed String to its primitive value.
		return /<[a-z][\s\S]*>/i.test(pMessage);
	}

	/**
	 * Translate legacy options into a PSM toast call.
	 * @param {object} pOptions - Legacy toast options ({ message, type, duration, position, dismissible, allowHTML, sticky }).
	 * @param {number} pNowMS - Current epoch ms (injected for testability).
	 * @returns {?{ message: string, sticky: boolean, options: object }} null when throttled or invalid.
	 */
	translate(pOptions, pNowMS)
	{
		if (!pOptions || !pOptions.message)
		{
			return null;
		}

		let tmpType = this.mapType(pOptions.type);
		const tmpSticky = (pOptions.sticky === true);

		// A sticky toast is a state indicator, not a notification: its owner locks the UI on the
		// assumption it is showing, so the duplicate throttle must not be able to swallow it.
		if (!tmpSticky)
		{
			const tmpKey = tmpType + '::' + pOptions.message;

			if (this._recent[tmpKey] && (pNowMS - this._recent[tmpKey]) < this._throttleWindowMS)
			{
				return null;
			}
			this._recent[tmpKey] = pNowMS;
		}

		let tmpAllowHTML = (typeof pOptions.allowHTML === 'boolean') ? pOptions.allowHTML : this.looksLikeHTML(pOptions.message);

		return (
			{
				message: pOptions.message,
				sticky: tmpSticky,
				options:
				{
					type: tmpType,
					duration: tmpSticky ? 0 : ((typeof pOptions.duration === 'number') ? pOptions.duration : 3000),
					position: pOptions.position || 'bottom-center',
					dismissible: (typeof pOptions.dismissible === 'boolean') ? pOptions.dismissible : true,
					allowHTML: tmpAllowHTML,
				},
			});
	}

	/**
	 * Single-toast bookkeeping: dismiss any outstanding non-sticky toast(s), then remember the new handle.
	 * Call with `null` to just clear the prior toast (before showing a new one), then again with
	 * the new handle to track it.
	 *
	 * Sticky handles survive this eviction. A sticky toast explains a UI the user cannot interact with,
	 * so the transient toasts that fire *during* that state must not take the explanation away.
	 * @param {?{ dismiss: function }} pHandle
	 * @param {boolean} [pSticky] - Exempt this handle from eviction until releaseHandle takes it back.
	 */
	trackHandle(pHandle, pSticky)
	{
		const tmpRetained = [];
		while (this._activeHandles.length > 0)
		{
			const tmpPrev = this._activeHandles.pop();
			if (!tmpPrev)
			{
				continue;
			}
			if (tmpPrev.Sticky)
			{
				tmpRetained.push(tmpPrev);
				continue;
			}
			if (tmpPrev.Handle && typeof tmpPrev.Handle.dismiss === 'function')
			{
				tmpPrev.Handle.dismiss();
			}
		}
		this._activeHandles = tmpRetained;
		if (pHandle)
		{
			this._activeHandles.push({ Handle: pHandle, Sticky: Boolean(pSticky) });
		}
	}

	/**
	 * Dismiss a specific handle and stop tracking it. Sticky handles are never evicted automatically,
	 * so their owner hands them back here when the state they describe ends.
	 * @param {?{ dismiss: function }} pHandle
	 */
	releaseHandle(pHandle)
	{
		if (!pHandle)
		{
			return;
		}
		this._activeHandles = this._activeHandles.filter((pEntry) => pEntry.Handle !== pHandle);
		if (typeof pHandle.dismiss === 'function')
		{
			pHandle.dismiss();
		}
	}
}

module.exports = HeadlightToastAdapter;

},{}],775:[function(require,module,exports){
module.exports={
    "NavBar": {
        "hideNavbar": false,
        "colorClass": "is-dark",
        "location": "bottom",
        "Brand": {
            "id": "HeadlightPanels-NavBar-Brand",
            "name": "Approval Actions",
            "displayName": "Draft",
            "hideIcon": null,
            "iconClass": "fa-pencil has-text-text-75",
            "buttonClass": "is-dark is-ghost has-text-white",
            "wrapperClass": "has-background-grey",
            "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Status')"
        },
        "Buttons": [
            {
                "id": "HeadlightPanels-NavBar-CurrentSamples-Button",
                "name": "Current Samples",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-qrcode",
                "buttonClass": "is-dark",
                "wrapperClass": "is-hidden",
                "onclick": "_Pict.views.HeadlightPaneSamples.openCurrentSamplesTab(event)"
            },
            {
                "id": "HeadlightPanels-NavBar-Solver-Button",
                "name": "Solver Logs",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-calculator",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Solver')"
            },
            {
                "id": "HeadlightPanels-NavBar-Validations-Button",
                "name": "Validation Logs",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-exclamation-triangle",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Validations')"
            },
            {
                "id": "HeadlightPanels-NavBar-Download-Button",
                "name": "Download",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-download",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPaneNavigation.toggleDownloadDropdown(event)"
            },
            {
                "id": "HeadlightPanels-NavBar-FullScreen-Button",
                "name": "screenResize",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-up-right-and-down-left-from-center",
                "buttonClass": "is-dark",
                "wrapperClass": "is-hidden-mobile is-hidden-tablet-only",
                "onclick": "_Pict.providers.DocumentProvider.handleScreenResize()"
            },
            {
                "id": "HeadlightPanels-NavBar-Save-Button",
                "name": "save",
                "displayName": "Save",
                "hideIcon": null,
                "iconClass": "fa-save",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "showAutoSaveStatus": true,
                "onclick": "_Pict.providers.DocumentProvider.handleSave()"
            },
            {
                "id": "HeadlightPanels-NavBar-Actions-Button",
                "name": "actions",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-bars",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Navigation')"
            }
        ]
    },
    "NavigationList": [],
    "PanelList": [
        {
            "location": "right",
            "name": "navigation",
            "displayName": "Actions",
            "iconClass": "fa-check-list",
            "view": "HeadlightPaneNavigation"
        },
        {
            "location": "right",
            "name": "settings",
            "displayName": "Settings",
            "iconClass": "fa-cog",
            "view": "HeadlightPaneSettings",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Settings', 'open')"
        },
        {
            "location": "left",
            "name": "status",
            "displayName": "Approval Actions",
            "iconClass": "fa-pencil",
            "view": "HeadlightPaneStatus",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Status')"
        },
        {
            "location": "left",
            "name": "solver",
            "displayName": "Solver Logs",
            "iconClass": "fa-calculator",
            "view": "HeadlightPaneSolver"
        },
        {
            "location": "left",
            "name": "validations",
            "displayName": "Validation Logs",
            "iconClass": "fa-exclamation-triangle",
            "view": "HeadlightPaneValidations"
        },
        {
            "location": "right",
            "name": "profile",
            "displayName": "User Profile",
            "iconClass": "fa-user",
            "view": "HeadlightPaneProfile",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Profile')"
        },
        {
            "location": "right",
            "name": "secret",
            "displayName": "Secrets",
            "iconClass": "fa-person-to-portal",
            "view": "HeadlightPaneSecret"
        },
        {
            "location": "left",
            "name": "bridges",
            "displayName": "Bridges",
            "iconClass": "fa-bridge",
            "view": "HeadlightPaneBridges"
        },
        {
            "location": "left",
            "name": "observations",
            "displayName": "Observations",
            "iconClass": "fa-images",
            "view": "HeadlightPaneObservations",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Observations')"
        },
        {
            "location": "right",
            "name": "observationdetails",
            "displayName": "Observation Details",
            "iconClass": "fa-image",
            "view": "ObservationDetails"
        },
        {
            "location": "left",
            "name": "observationannotation",
            "displayName": "Observation Annotation",
            "iconClass": "fa-image",
            "view": "ObservationAnnotation"
        },
        {
            "location": "left",
            "name": "observationsubimageselector",
            "displayName": "Create Note",
            "iconClass": "fa-sticky-note",
            "view": "ObservationSubImageSelector"
        },
        {
            "location": "left",
            "name": "testinstancewizard",
            "displayName": "Add Test",
            "iconClass": "fa-flask-vial",
            "view": "TestInstanceWizard"
        },
        {
            "location": "left",
            "name": "qrpanel",
            "displayName": "Scanning",
            "iconClass": "fa-qrcode",
            "view": "QRPanel",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('QRPanel')"
        },
        {
            "location": "right",
            "name": "pictsectionopenseadragonannotationselector",
            "displayName": "Annotation Comments",
            "iconClass": "fa-comments",
            "view": "PictSectionOpenSeaDragonAnnotationSelector"
        },
        {
            "location": "right",
            "name": "academyview",
            "displayName": "Academy",
            "iconClass": "fa-graduation-cap",
            "view": "AcademyView"
        },
        {
            "location": "left",
            "name": "documents",
            "displayName": "Documents",
            "iconClass": "fa-files",
            "view": "HeadlightPaneDocuments",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Documents')"
        },
        {
            "location": "left",
            "name": "documentdetails",
            "displayName": "Document Details",
            "iconClass": "fa-documents",
            "view": "DocumentDetails"
        },
        {
            "location": "left",
            "name": "inspection",
            "displayName": "Inspection",
            "iconClass": "fa-building-magnifying-glass",
            "view": "Inspection",
            "navigationHandler": "_Pict.views.HeadlightPaneNavigation.handleInspectionPanelToggle(event)"
        },
        {
            "location": "left",
            "name": "samples",
            "displayName": "Samples",
            "iconClass": "fa-vial",
            "view": "HeadlightPaneSamples",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Samples')"
        },
        {
            "location": "right",
            "name": "sampledetails",
            "displayName": "Sample Details",
            "iconClass": "fa-vial",
            "view": "SampleDetails",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('SampleDetails')"
        },
        {
            "location": "right",
            "name": "projectfilesearch",
            "displayName": "Project Files",
            "iconClass": "fa-files",
            "view": "ProjectFileSearch",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch')"
        },
        {
            "location": "right",
            "name": "comments",
            "displayName": "Comments",
            "iconClass": "fa-comment",
            "view": "CommentCurrent",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Comments')"
        }
        
    ],
    "CurrentStatus": {
        "status": "Draft",
        "statusClass": "has-text-text-75",
        "statusIcon": "fa-pencil"
    },
    "PanelLocations": {
        "left": { 
            "name": "left",
            "displayName": "Left",
            "animateIn": "animate__slideInLeft", 
            "animateOut": "animate__slideOutLeft", 
            "animateDuration": 500 
        },
        "right": { 
            "name": "right",
            "displayName": "Right",
            "animateIn": "animate__slideInRight", 
            "animateOut": "animate__slideOutRight", 
            "animateDuration": 500 
        }
    },
    "PanelOptions": {
        "LeftyMode": false,
        "Context": "",
        "HelpText": true
    }
}

},{}],776:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');

class HeadlightPanelsFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { views: any, ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }} */
		this.fable;

		this.serviceType = 'HeadlightPanels';
		this.isPhoneDevice = false; // This will be set later based on the device type
	}

	// TODO: Add Pin state functions (need to adjust the HeadlightPanels view to support this by data state)
	// TODO: Add color options for the custom panel headers
	// TODO: Add a subtitle option for the custom panel headers

	/**
	 * This function is used to check if the HeadlightPanels view is available.
	 * @return {boolean}
	 */
	checkPanels()
	{
		return this.fable.views.hasOwnProperty('HeadlightPanels');
	}

	/**
	 ********** LEFT **********
	*/

	/**
	 * This function is used to toggle the left panel.
	 * @return {void}
	 */
	leftPanelToggle()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the right panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('right', 'close');
		}
		// toggle the left panel
		return this.fable.views.HeadlightPanels.togglePanel('left');
	}

	/**
	 * This function is used to show the left panel.
	 * @return {void}
	 */
	leftPanelShow()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the right panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('right', 'close');
		}
		// toggle the left panel
		return this.fable.views.HeadlightPanels.togglePanel('left', 'open');
	}

	/**
	 * This function is used to show the left custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	leftCustomPanelShow(pTitle)
	{
		this.leftPanelShow();
		this.fable.views.HeadlightPaneCustomLeft.render();
		this.leftPanelSetCustomTitle(pTitle);
	}

	/**
	 * This function is used to hide the left panel.
	 * @return {void}
	 */
	leftPanelHide()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		this.leftPanelResetCustomWidth();
		return this.fable.views.HeadlightPanels.togglePanel('left', 'close');
	}

	/**
	 * This function is used to set the title of the left custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	leftPanelSetCustomTitle(pTitle)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.ContentAssignment.assignContent('#HeadlightPanels-CustomPanel-Left-Header-Title', pTitle || 'Left Panel');
	}

	/**
	 * This function is used to get the address of the left custom panel content.
	 * @return {string}
	 */
	leftPanelCustomContentAddress()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return '#HeadlightPanels-CustomPanel-Left-Content';
	}

	/**
	 * This function is used to toggle the pin state of the left panel.
	 * @param {string} state - The state to set the pin to
	 * @return {void}
	 */
	leftPanelTogglePinState(state)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.togglePanelPinState('left', null, state);
	}

	/**
	 * This function is used to set the width of the left panel.
	 * @param {number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	leftPanelCustomWidth(pPercentage)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.setPanelCustomWidth('left', pPercentage);
	}

	/**
	 * This function is used to reset the width of the left panel.
	 * @return {void}
	 */
	leftPanelResetCustomWidth()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.resetPanelCustomWidth('left');
	}


	/**
	 ********** RIGHT **********
	*/

	/**
	 * This function is used to toggle the right panel.
	 * @return {void}
	 */
	rightPanelToggle()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the left panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('left', 'close');
		}
		// toggle the right panel
		return this.fable.views.HeadlightPanels.togglePanel('right');
	}

	/**
	 * This function is used to show the right panel.
	 * @return {void}
	 */
	rightPanelShow()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the left panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('left', 'close');
		}
		// toggle the right panel
		return this.fable.views.HeadlightPanels.togglePanel('right', 'open');
	}

	/**
	 * This function is used to show the right custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	rightCustomPanelShow(pTitle)
	{
		this.rightPanelShow();
		this.fable.views.HeadlightPaneCustomRight.render();
		this.rightPanelSetCustomTitle(pTitle);
	}

	/**
	 * This function is used to hide the right panel.
	 * @return {void}
	 */
	rightPanelHide()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		this.rightPanelResetCustomWidth();
		return this.fable.views.HeadlightPanels.togglePanel('right', 'close');
	}

	/**
	 * This function is used to set the title of the right custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	rightPanelSetCustomTitle(pTitle)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.ContentAssignment.assignContent('#HeadlightPanels-CustomPanel-Right-Header-Title', pTitle || 'Right Panel');
	}

	/**
	 * This function is used to get the address of the right custom panel content.
	 * @return {string}
	 */
	rightPanelCustomContentAddress()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return '#HeadlightPanels-CustomPanel-Right-Content';
	}

	/**
	 * This function is used to toggle the pin state of the right panel.
	 * @param {string} state - The state to set the pin to
	 * @return {void}
	 */
	rightPanelTogglePinState(state)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.togglePanelPinState('right', null, state);
	}

	/**
	 * This function is used to set the width of the right panel.
	 * @param {number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	rightPanelCustomWidth(pPercentage)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.setPanelCustomWidth('right', pPercentage);
	}

	/**
	 * This function is used to reset the width of the right panel.
	 * @return {void}
	 */
	rightPanelResetCustomWidth()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.resetPanelCustomWidth('right');
	}

	/**
	 ********** Content Highlighting **********
	 */

	/**
	 * This function is used to apply a UI highlight to the given selector or passed content area.
	 * @param {HTMLElement|string} pSelector - The selector or content area to apply the highlight to
	 */
	applyUIHighlight(pSelector)
	{
		// always clear any existing highlights first
		this.clearUIHighlights();

		if (pSelector instanceof HTMLElement)
		{
			pSelector.classList.add('panels-ui-highlight');
			return;
		}
		else if (Array.isArray(pSelector))
		{
			Array.from(document.querySelectorAll(pSelector)).forEach(
				(el) => el.classList.add('panels-ui-highlight'),
			);
		}
		else
		{
			document.querySelector(pSelector).classList.add('panels-ui-highlight');
		}
	}

	/**
	 * This function is used to clear all UI highlights.
	 */
	clearUIHighlights()
	{
		Array.from(document.querySelectorAll('.panels-ui-highlight')).forEach(
			(el) => el.classList.remove('panels-ui-highlight'),
		);
	}

	/**
	 * This function constructs a url for opening academy content.
	 * @param {string} content - The content to open
	 */
	openAcademyContent(content)
	{
		if (content?.includes('headlight.com'))
		{
			this.fable.views.AcademyView.openWithURL(content);
		}
		else if (window.location.href.includes('localhost'))
		{
			this.fable.views.AcademyView.openWithURL( 'https://fieldbook.qa.headlight.com/Assets/templates/documentation/' + content);
		}
		else
		{
			//@ts-ignore
			this.fable.views.AcademyView.openWithURL(_Pict?.HeadlightRestClient?.serverURL?.replace('/1.0/', '/Assets/templates/documentation/') + content);
		}
	}

	/**
	 * Check if the device is a phone based on user agent or screen size.
	 * @return {boolean}
	 */
	checkIfPhoneDevice()
	{
		// Check if the device is a phone based on the user agent or screen size
		const isPhone = /Mobi|Android/i.test(navigator.userAgent) || screen.width < 744;
		this.setIsPhoneDevice(isPhone);
		return isPhone;
	}

	/**
	 * Get if the device is a phone or not.
	 * @return {boolean}
	 */
	getIsPhoneDevice()
	{
		return this.isPhoneDevice;
	}

	/**
	 * Set if the device is a phone or not.
	 * @param {boolean} pIsPhone
	 * @return {boolean}
	 */
	setIsPhoneDevice(pIsPhone)
	{
		this.isPhoneDevice = pIsPhone;
		this.log.info(`HeadlightPanelsFableService: Device set to ${pIsPhone ? 'phone' : 'desktop'}`);
		return this.isPhoneDevice;
	}
}

module.exports = HeadlightPanelsFableService;
module.exports.default_configuration = {};

},{"fable-serviceproviderbase":398}],777:[function(require,module,exports){
module.exports = ({
	ViewIdentifier: 'HeadlightPanels',
	DefaultRenderable: 'HeadlightPanels',
	DefaultDestinationAddress: '#HeadlightPanels-Container',
	CSS: /*css*/`
		/* Auto-save indicator — sits immediately left of the navbar Save button. Quiet by design:
		   it is ambient status, not a notification. */
		.hl-autosave-status-container {
			display: inline-flex;
			align-items: center;
			margin-right: 0.5rem;
		}
		.hl-autosave-status {
			display: inline-flex;
			align-items: center;
			gap: 0.25rem;
			font-size: 0.75rem;
			line-height: 1;
			white-space: nowrap;
			opacity: 0.65;
			transition: opacity 200ms ease-in-out;
		}
		.hl-autosave-status .icon.is-small {
			font-size: 0.75rem;
		}
		.hl-autosave-status.is-retrying,
		.hl-autosave-status.is-suspended,
		.hl-autosave-status.is-offline {
			opacity: 1;
		}
		.hl-autosave-status.is-saved.is-flashing {
			animation: hl-autosave-flash 2s ease-in-out 1;
		}
		@keyframes hl-autosave-flash {
			0% { opacity: 1; }
			40% { opacity: 1; }
			100% { opacity: 0.65; }
		}
		@media (prefers-reduced-motion: reduce) {
			.hl-autosave-status.is-saved.is-flashing { animation: none; }
		}
		/* Auto-save preferences in the Settings panel. The seconds field is fixed-width and the row wraps
		   rather than growing, so opening this panel never changes its width. */
		.hl-autosave-interval {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 0.4rem;
			font-size: 0.85rem;
			min-width: 0;
		}
		.hl-autosave-interval-input {
			flex: 0 0 auto;
			width: 5.5rem;
		}
		.hl-autosave-note {
			font-size: 0.8rem;
			opacity: 0.7;
		}
		/* Approval actions are inert while a save (manual or auto) is in flight. pointer-events is what
		   actually blocks the click — the handler is bound with onclick, not a disabled attribute.
		   The same treatment covers a Settings row the form manifest has taken out of the user's hands. */
		.panel-block.is-disabled,
		a.panel-block.is-disabled {
			pointer-events: none;
			cursor: not-allowed;
			opacity: 0.5;
		}
		/* An approval action is in flight. The form stays readable on purpose — the user should still be
		   able to see what they just submitted — so this dims and de-fangs rather than covering with a
		   scrim. Scoped to the body because Select2 and flatpickr portal their popups outside the form.
		   The inert attribute is what actually blocks the keyboard; pointer-events only stops the mouse. */
		body.hl-approval-busy {
			cursor: progress;
		}
		body.hl-approval-busy #Headlight-Document-Form {
			pointer-events: none;
			opacity: 0.55;
			transition: opacity 150ms ease-in-out;
		}
		body.hl-approval-busy .select2-container--open,
		body.hl-approval-busy .flatpickr-calendar.open {
			display: none;
		}
		@media (prefers-reduced-motion: reduce) {
			body.hl-approval-busy #Headlight-Document-Form { transition: none; }
		}
		`,
	Templates:
		[
			{
				Hash: 'HeadlightPanels-Template',
				Template: /*html*/`
				<div id="HeadlightPanels-LeftPanel" class="hl-panel-wrapper hl-panel-wrapper-left animate__animated animate__faster"></div>
				<div id="HeadlightPanels-RightPanel" class="hl-panel-wrapper hl-panel-wrapper-right animate__animated animate__faster"></div>
				<nav id="HeadlightPanels-NavBar" class="navbar is-flex is-fixed-{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.location~} {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.colorClass~}">
					<span id="HeadlightPanels-Navbar-Brand-Container">{~T:HeadlightPanels-NavBar-Brand~}</span>
					<div id="HeadlightPanels-Navbar-Button-Container" class="navbar-end">{~T:HeadlightPanels-NavBar-Button-Wrapper~}</div>
				</nav>
				<aside id="HeadlightPanels-FullScreenModal-Container"></aside>`,
			},
			{
				'Hash': 'HeadlightPanels-NavBar-Brand',
				'Template': /*html*/`
				<div class="navbar-brand {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.wrapperClass~}">
					<button 
						id="{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.id~}" 
						type="button" 
						class="button {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.buttonClass~}" 
						name="{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.name~}" 
						onclick="{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.onclick~}"
					>
						<span class="icon {~Hide:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.hideIcon~}">
							<i id="HeadlightPanels-NavBar-Brand-Icon" class="fas fa-fw {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.iconClass~}"></i>
						</span>
						<span id="HeadlightPanels-NavBar-Brand-Text" title="{~DocumentState:AppData.DocumentData.ReportData~}">{~DocumentState:AppData.DocumentData.ReportData~}</span>
					</button>

				</div>`,
			},
			{
				Hash: 'HeadlightPanels-NavBar-Button-Wrapper',
				Template: /*html*/`{~TS:HeadlightPanels-NavBar-Button:Pict.settings.HeadlightPanels.Configuration.NavBar.Buttons~}`,
			},
			{
				Hash: 'HeadlightPanels-NavBar-Button',
				Template: /*html*/`
				<div class="navbar-item {~D:Record.wrapperClass~}">
					{~NE:Record.showAutoSaveStatus^<span id="HeadlightPanels-Navbar-AutoSaveStatus-Container" class="hl-autosave-status-container"></span>~}
					<button id="{~D:Record.id~}" type="button" class="button {~D:Record.buttonClass~}" name="{~D:Record.name~}" onclick="{~D:Record.onclick~}">
						<span class="icon {~Hide:Record.hideIcon~}">
							<i id="{~D:Record.id~}-Icon" class="fas fa-fw {~D:Record.iconClass~}"></i>
						</span>
						{~If:Record.displayName~}
					</button>
				</div>`,
			},
			{
				// Auto-save indicator. Deliberately not a toast: a notification every 90 seconds trains
				// users to dismiss notifications. StatusSlot is empty whenever auto-save is off or the
				// document is not editable, which renders nothing at all.
				Hash: 'HeadlightPanels-NavBar-AutoSaveStatus',
				Template: /*html*/`{~TS:HeadlightPanels-NavBar-AutoSaveStatus-Content:AppData.AutoSave.StatusSlot~}`,
			},
			{
				Hash: 'HeadlightPanels-NavBar-AutoSaveStatus-Content',
				Template: /*html*/`
				<span class="hl-autosave-status {~D:Record.StateClass~} {~D:Record.FlashClass~}" role="status" aria-live="polite" title="{~D:Record.Tooltip~}">
					<span class="icon is-small">
						<i class="fas fa-fw {~D:Record.IconClass~}" aria-hidden="true"></i>
					</span>
					<span class="hl-autosave-status-label is-hidden-mobile">{~D:Record.Label~}</span>
				</span>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ButtonGroup',
				Template: /*html*/`
				<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event)">
					<span class="icon">
						<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
					</span>
				</button>
				<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
					<span class="icon">
						<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
					</span>
				</button>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ModeBanner-Observations',
				Template: /*html*/`
				<div data-panel-mode-show-if="add-to-set" class="notification is-radiusless add-mode-banner px-4 py-2">
					<div class="add-mode-banner-content mr-5">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<strong class="add-mode-message">Adding Observations to <span id="HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target" class="add-mode-title">{~T:HeadlightPanels-ObservationPanel-BannerTarget~}</span></strong>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ModeBanner-Samples',
				Template: /*html*/`
				<div data-panel-mode-show-if="add-to-set" class="notification is-radiusless add-mode-banner px-4 py-2">
					<div class="add-mode-banner-content mr-5">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<strong class="add-mode-message">Adding Samples to <span id="HeadlightPanels-SamplePanel-Sample-Header-Mode-Target" class="add-mode-title">Sample Selector</strong>
					</div>
					<button type="button" class="delete" onclick="_Pict.views.HeadlightPaneSamples.clearSamplePanelTarget()"></button>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ModeBanner-Documents',
				Template: /*html*/`
				<div data-panel-mode-show-if="add-to-inspection" class="notification is-radiusless add-mode-banner px-4 py-2">
					<div class="add-mode-banner-content mr-5">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<strong class="add-mode-message">Adding Documents to <span id="HeadlightPanels-DocumentPanel-Document-Header-Mode-Target" class="add-mode-title">{~T:HeadlightPanels-DocumentPanel-BannerTarget~}</span></strong>
					</div>
				</div>`,
			},
			{
				// This is a generic modal container to be used for any full screen modal content by other views as needed.
				// Treat this as the ONE modal to rule them all.
				Hash: 'HeadlightPanels-FullScreenModal',
				Template: /*html*/`
				<div id="HeadlightPanels-FullScreenModal" class="modal is-active">
					<div class="modal-background"></div>
					<div class="modal-content">
						<div class="box">
							<p>
								<span class="icon">
									<i class="fa fa-fw fa-circle-question"></i>
								</span>
								<span>No content has been set here yet.</span>
							</p>
						</div>
					</div>
					<button class="modal-close is-large" aria-label="close" onclick="_Pict.views.HeadlightPanels.togglePanelFullScreenModal('close')"></button>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-InDevelopmentMessage',
				Template: /*html*/`
				<div class="notification is-warning is-soft has-text-centered m-4">
					<span class="icon">
						<i class="fas fa-fw fa-tools has-text-warning" aria-hidden="true"></i>
					</span>
					<span class="icon-text">This feature is still in development and is not fully available at this time.</span>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'HeadlightPanels',
				TemplateHash: 'HeadlightPanels-Template',
				ContentDestinationAddress: '#HeadlightPanels-Container',
			},
			{
				RenderableHash: 'HeadlightPanels-NavBar-Brand',
				TemplateHash: 'HeadlightPanels-NavBar-Brand',
				ContentDestinationAddress: '#HeadlightPanels-Navbar-Brand-Container',
			},
			{
				RenderableHash: 'HeadlightPanels-NavBar-Button-Wrapper',
				TemplateHash: 'HeadlightPanels-NavBar-Button-Wrapper',
				ContentDestinationAddress: '#HeadlightPanels-Navbar-Button-Container',
			},
			{
				RenderableHash: 'HeadlightPanels-ObservationPanel',
				TemplateHash: 'HeadlightPanels-ObservationPanel',
				ContentDestinationAddress: '#HeadlightPanels-ObservationPanel',
			},
			{
				RenderableHash: 'HeadlightPanels-ObservationPanel-Included',
				TemplateHash: 'HeadlightPanels-ObservationPanel-Included',
				ContentDestinationAddress: '#HeadlightPanels-ObservationPanel-Included-Content',
			},
			{
				RenderableHash: 'HeadlightPanels-ObservationPanel-Detail',
				TemplateHash: 'HeadlightPanels-ObservationPanel-Detail',
				ContentDestinationAddress: '#HeadlightPanels-ObservationPanel-Detail-Content',
			},
			{
				RenderableHash: 'HeadlightPanels-FullScreenModal',
				TemplateHash: 'HeadlightPanels-FullScreenModal',
				ContentDestinationAddress: '#HeadlightPanels-FullScreenModal-Container',
			},
			{
				RenderableHash: 'ObservationDetails-FullScreenModal',
				TemplateHash: 'ObservationDetails-FullScreenModal',
				DestinationAddress: '#HeadlightPanels-FullScreenModal-Container',
				RenderType: 'replace',
			},
		],
});

},{}],778:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class AcademyView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.settings =
		{
			url: '',
		};
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		this.pict.HeadlightPanels.rightPanelCustomWidth(40);
		this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		return super.onAfterRender(pRenderable);
	}

	/**
	 * This is a test
	 */
	openWithURL(url)
	{
		this.settings.url = url;
		this.pict.HeadlightPanels.leftPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.leftPanelHide();
		this.pict.views.HeadlightPanels.handlePanelToggle('AcademyView', 'open');
	}

	resetAndClose()
	{
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelResetCustomWidth();
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
	}

	toggleWidth()
	{
		const toggleEl = this.pict.ContentAssignment.getElement('#split-toggle-icon')?.[0];
		const animate = (el)=>
		{
			el.classList.add('fa-flip');
			setTimeout(()=>
			{
				el.classList.remove('fa-flip');
			}, 500);
		};
		if (toggleEl?.classList?.contains('fa-flip-horizontal'))
		{
			animate(toggleEl);
			toggleEl.classList.remove('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(60);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		}
		else
		{
			animate(toggleEl);
			toggleEl.classList.add('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(40);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		}
	}
}

module.exports = AcademyView;

module.exports.default_configuration =
{
	ViewIdentifier: 'AcademyView',
	DefaultRenderable: 'AcademyView',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'AcademyView-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-AcademyViewPanel" class="panel is-active">
				<p id="HeadlightPanels-AcademyViewPanel-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-left hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.AcademyView.resetAndClose()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button mr-2" class="is-pulled-right" aria-label="expand" title="Resize content" onclick="_Pict.views.AcademyView.toggleWidth()">
						<span class="icon">
							<i class="fas fa-fw fa-table-layout fa-flip-horizontal" aria-hidden="true" id="split-toggle-icon"></i>
						</span>
					</button>
					<span class="icon ml-5">
						<i id="HeadlightPanels-AcademyView-Header-Icon" class="fas fa-fw fa-graduation-cap" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-AcademyView-Header-Title" class="mr-3">Academy</span>
				</p>
				<div id="HeadlightPanels-AcademyView-Content">
					{~T:AcademyView-Content:Pict.views.AcademyView.settings~}
				</div>
			</article>`,
		},
		{
			Hash: 'AcademyView-Content',
			Template: /*html*/`
			<iframe class="has-background-text-40" style="width: 100%; height: 80vh;" src="{~D:Record.url~}" />`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'AcademyView',
			TemplateHash: 'AcademyView-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'AcademyView-Content',
			TemplateHash: 'AcademyView-Content',
			DestinationAddress: '#HeadlightPanels-AcademyView-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":693}],779:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
* @typedef {Object} CommentResult
* @property {number} IDComment
* @property {number} CreatingIDUser
* @property {string} Comment
* @property {string} Date
* @property {number} IsCreatingUser
* @property {Array<CommentResult>} [Children]
* @property {Object} [CreatingUserData]
* @property {string} [CreatingUserData.NameFirst]
* @property {string} [CreatingUserData.NameLast]
* @property {string} [_RowID]
*/

class CommentCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialResultsLoaded = false;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'Date',
			SortDirection: 'DESC',
		};
		this.CurrentSearchEntity = '';
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		this.CurrentSearchFilters.IDDocument = this.AppData?.DocumentData?.ReportData?.IDDocument;
		if (pCallback)
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// if we don't have results, fetch them
		if (!this.initialResultsLoaded)
		{
			this.initialResultsLoaded = true;
			this.fetchComments(null, null, null);
		}
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method fetches all comments.
	 * @param {Event} event - The event that triggered the search.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @param {boolean} pIsChild - Whether the row is a child row.
	 * @return {Promise<void>}
	 * @async
	 */
	async fetchComments(event, pRowID, pIsChild)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// if new comment container exists
		if (document.getElementById('CommentCurrent-Add-Comment-Container'))
		{
			// hide add new comment container
			document.getElementById('CommentCurrent-Add-Comment-Container').classList.add('is-hidden');
		}
		// collapse the filter panel to get out the way of the results
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('CommentCurrentFilters', 'close');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('CommentCurrent-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// TODO: this should probably be moved to a provider but keeping it here for now because it works
		/**
		 * @callback GetCommentStructureCallback
		 * @param {CommentResult[]|any} pResult
		 * @return {void}
		 */
		/**
		 * Fetches the comment structure and updates the UI.
		 * @param {string|null} pRowID
		 * @param {boolean|null} pIsChild
		 * @param {Event|null} event
		 * @return {Promise<void>}
		 */
		this.pict.providers.CommentProvider.getCommentStructure(this.CurrentSearchFilters.IDCustomer, this.CurrentSearchFilters.IDDocument, this.AppData?.DocumentData?.ReportData?.Comments || [],
			/** @type {GetCommentStructureCallback} */
			(pResult) =>
			{
				if (!Array.isArray(pResult))
				{
					// Render comment results template (non-blocking, no side effects here)
					this.pict.views.CommentCurrent.renderAsync('CommentCurrent', '#CommentCurrent-Entry-Container', false, false, () =>
					{
						try
						{
							if (this.CommentCurrentResultsCallback)
							{
									// eslint-disable-next-line new-cap
									this.CommentCurrentResultsCallback(this.CurrentSearchResults);
							}
							else
							{
									this.updateWithResults(/** @type {CommentResult[]} */(pResult), pRowID, pIsChild);
							}
						}
						catch (innerError)
						{
								this.pict.log.error('Error in renderAsync callback:', innerError);
						}
					},
					);
				}
				else
				{
					this.updateWithResults(/** @type {CommentResult[]} */(pResult), pRowID, pIsChild);
				}
			},
		);
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setCommentResultsCallback((pResults) => { console.log(pResults); });
	 */
	setCommentCurrentResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.CommentCurrentResultsCallback = pCallback;
	}

	/**
	 * This method updates the IsCreatingUser property for each comment
	 * in the results to display edit and delete buttons correctly.
	 * @param {CommentResult[]} comments
	 * @return {void}
	 */
	updateIsCreatingUser(comments)
	{
		comments.forEach((comment) =>
		{
			comment.IsCreatingUser = (this.pict.AppData.CurrentUser.UserID === comment.CreatingIDUser) ? 1 : 0;

			if (Array.isArray(comment.Children) && comment.Children.length > 0)
			{
				this.updateIsCreatingUser(comment.Children); // recursive call
			}
		});
	}

	/**
	 * This method updates the results/UI based on new results and total count passed in.
	 * @param {Array} pResults - The results to update with.
	 * @param {string} [pRowID] - The ID of the row to update.
	 * @param {boolean} [pIsChild] - Whether the row is a child row.
	 * @return {void}
	 */
	updateWithResults(pResults, pRowID, pIsChild)
	{
		try
		{
			// update our results list
			this.CurrentSearchResults = pResults;
			// check if the current user is the same as the user who created the comment
			this.updateIsCreatingUser(this.CurrentSearchResults);
			// display results in descending order by updated date
			this.CurrentSearchResults.sort((a, b) =>
			{
				const dateA = new Date(a.Date);
				const dateB = new Date(b.Date);
				return dateB.getTime() - dateA.getTime(); // Sort in descending order
			});

			const pTotalCount = pResults?.length || 0;

			// update the total possible count so we can calculate the total pages
			this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalCount / this.CurrentSearchFilters.PageSize);
			// render the search results view
			this.pict.views.CommentCurrent.renderAsync('CommentCurrent-Results', '#CommentCurrent-Results-Container', false, () =>
			{
				// render the pagination buttons
				this.pict.views.CommentCurrent.renderAsync('CommentCurrent-Pagination', '#CommentCurrent-Pagination-Container', false, () =>
				{
					this.log.info('Comment Search Pagination rendered');
				});
				// if there is a callback function, call it
				if (this.CommentCurrentResultsCallback)
				{
					// eslint-disable-next-line new-cap
					this.CommentCurrentResultsCallback(this.CurrentSearchResults);
				};
			});
		}
		catch (outerError)
		{
			this.pict.log.error('Failed to update with comment results:', outerError);
		}
	}

	/**
	 * This method adds a new comment.
	 * @param {Event} [event] - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	addNewComment(event)
	{
		if (!this.pict.AppData.DocumentData.ReportData.IDDocument)
		{
			this.log.error(`No Document; can't add comment to document that doesn't exist: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Document; can't add comment to document that doesn't exist: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the add comment button
		if (event)
		{
			// if editable container exists
			if (document.getElementById('CommentCurrent-Add-Comment-Container'))
			{
				// show add new comment container
				document.getElementById('CommentCurrent-Add-Comment-Container').classList.remove('is-hidden');
			}
		}
	}

	/**
	 * This method hides the new comment container on cancel event.
	 * @param {Event} event - The event that triggered the search.
	 * @param {string} [pIDComment] - The comment ID of the comment in the treeview.
	 * @async
	 */
	cancelCommentEdit(event, pIDComment)
	{
		// if user clicked the add comment button
		if (event)
		{
			// if new comment container exists
			if (document.getElementById('CommentCurrent-Add-Comment-Container'))
			{
				// hide reply comment container
				document.getElementById('CommentCurrent-Add-Comment-Container').classList.add('is-hidden');
			}
			// if reply container exists
			if (document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`))
			{
				// hide reply comment container
				document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`).classList.add('is-hidden');
			}
			// if editable container exists
			if (document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`))
			{
				// swap editable textarea for readonly
				document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`).classList.add('is-hidden');
				document.getElementById(`CommentCurrent-Readonly-Comment_${pIDComment}`).classList.remove('is-hidden');
			}
		}
	}

	/**
	 * This method adds a new comment.
	 * @param {Event} event - The event that triggered the search.
	 * @param {string} pIDComment - The ID of the comment to reply to.
	 * @return {Promise<void>}
	 * @async
	 */
	handleCommentReplyButton(event, pIDComment)
	{
		if (!pIDComment)
		{
			this.log.error(`No Comment ID; can't reply to comment that doesn't exist: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Comment ID; can't reply to comment that doesn't exist: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the reply to comment button
		if (event)
		{
			// if child and editable containers exist
			if (document.getElementById(`CommentCurrent-Child-Comment_${pIDComment}`) && document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`))
			{
				// show reply comment container under the comment
				document.getElementById(`CommentCurrent-Child-Comment_${pIDComment}`).classList.remove('is-hidden');
				document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`).classList.remove('is-hidden');
			}
		}
	}

	/**
	 * This method edits a comment.
	 * @param {Event} event - The event that triggered the edit.
	 * @param {string} pIDComment - The ID of the comment to edit.
	 * @return {Promise<void>}
	 * @async
	 */
	handleCommentEditButton(event, pIDComment)
	{
		if (!pIDComment)
		{
			this.log.error(`No Comment ID; can't reply to comment that doesn't exist: .`);
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			// if editable container exists
			if (document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`))
			{
				// swap readonlies for inputs
				document.getElementById(`CommentCurrent-Readonly-Comment_${pIDComment}`).classList.add('is-hidden');
				document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`).classList.remove('is-hidden');
			}
		}
	}

	/**
	 * @spec puts a loading spinner on the element for a short time: 1.5 seconds.
	 * @param {HTMLElement} htmlElement
	 */
	animateLoading(htmlElement)
	{
		htmlElement.classList.add('is-loading');
		setTimeout(() => htmlElement.classList.remove('is-loading'), 1500);
	}

	/**
	 * Handles the deletion of a comment.
	 * @param {Event} event - The event that triggered the delete action.
	 * @param {string} pIDComment - The ID of the comment to delete.
	 * @return {void}
	 */
	handleCommentDeleteButton(event, pIDComment)
	{
		// the body and footer templates for the delete modal
		const deleteModalBodyTemplate = /*html*/`
		<span id="DeleteModalBody">
			<div class="cell is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">Are you sure you want to delete this comment?</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to delete or close this modal.</p>
				</div>
			</div>
		</span>`;
		const deleteModalFooterTemplate = /*html*/`
		<div id="DeleteModalFooter" class="buttons is-right">
			<button class="button is-danger is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-danger" type="button" title="Delete Comment" onclick="_Pict.views.CommentCurrent.handleCommentDelete(${pIDComment}, event)">
				<span class="icon">
					<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
				</span>
				<span>Delete</span>
			</button>
		</div>`;
		// the options for the edit modal
		const deleteModalOptions = {
			title: 'Delete Comment?',
			modalBodyTemplate: deleteModalBodyTemplate,
			modalFooterTemplate: deleteModalFooterTemplate,
			confirmText: 'Delete',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(deleteModalOptions, this.confirmDeleteCallback.bind(this));
	}

	/**
	 * Handles deleting comment
	 * @param {number} pIDComment - The ID of the comment to delete.
	 * @param {Event} event - The event that triggered the save action.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleCommentDelete(pIDComment, event)
	{
		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		await this.pict.providers.CommentProvider.deleteComment(pIDComment, (pResult) =>
		{
			if (pResult)
			{
				this.fetchComments(event, null, null);
			}
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Comment Deleted',
				type: 'is-success',
			});
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles updating an existing comment
	 * @param {Event} event - The event that triggered the update
	 * @param {number} pIDComment - The ID of the comment being updated
	 * @param {string} pRowID - The ID of the row in the treeview
	 * @return {Promise<void>}
	 */
	async applyCommentEdit(event, pIDComment, pRowID)
	{
		// set the loading ui state
		if (event?.currentTarget instanceof HTMLElement)
		{
			event.currentTarget.classList.add('is-loading');
		}

		const elValue = document.getElementById(`CommentCurrent-Edit-Textarea-Comment_${pIDComment}`);
		const tmpCommentValue = elValue ? /** @type {HTMLTextAreaElement} */ (elValue).value.trim() : '';

		if (!tmpCommentValue)
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Comment cannot be empty.',
				type: 'is-warning',
			});
			return;
		}

		const tmpComment = {
			IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer,
			IDComment: pIDComment,
			Comment: tmpCommentValue,
		};

		await this.pict.providers.CommentProvider.updateComment(tmpComment, (pResult) =>
		{
			if (pResult)
			{
				this.fetchComments(event, pRowID, true);
			}
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Comment Updated',
				type: 'is-success',
			});
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles adding a new comment or a reply
	 * @param {Event} event - The event that triggered the save
	 * @param {number} [pParentID] - ID of the parent comment (0 for new top-level comment)
	 * @return {Promise<void>}
 	*/
	async handleCommentAdd(event, pParentID)
	{
		const elReply = document.getElementById(`CommentCurrent-Reply-Textarea-Comment_${pParentID}`);
		const tmpCommentReplyValue = elReply ? /** @type {HTMLTextAreaElement} */ (elReply).value.trim() : '';

		const elNewValue = document.getElementById('CommentCurrent-Add-Comment-Textarea');
		const tmpCommentNewValue = elNewValue ? /** @type {HTMLTextAreaElement} */ (elNewValue).value.trim() : '';

		if (event?.currentTarget instanceof HTMLElement)
		{
			event.currentTarget.classList.add('is-loading');
		}

		// Add reply comment
		if (pParentID)
		{
			if (!tmpCommentReplyValue)
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Reply cannot be empty.',
					type: 'is-warning',
				});
				return;
			}
			// Create a new comment object for the reply
			const tmpComment = {
				IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer,
				IDComment: 0,
				IDParent: pParentID,
				Comment: tmpCommentReplyValue,
			};

			await this.pict.providers.CommentProvider.createComment(tmpComment, async (pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Reply Added',
					type: 'is-success',
				});
				if (pResult)
				{
					const newCommentID = pResult.IDComment;
					if (Array.isArray(this.AppData?.DocumentData?.ReportData?.Comments))
					{
						this.AppData.DocumentData.ReportData.Comments.push(newCommentID);
					}

					const tmpDocument = {
						IDDocument: this.AppData?.DocumentData?.ReportData?.IDDocument,
						IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
						Comments: this.AppData?.DocumentData?.ReportData?.Comments,
					};

					await this.pict.providers.CommentProvider.updateCommentsAttachedToDocument(tmpDocument, (pNewResult) =>
					{
						if (pNewResult)
						{
							this.fetchComments(event, null, null);
						}
					});
				}
			});
		}
		// Add top-level comment
		else
		{
			if (!tmpCommentNewValue)
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Comment cannot be empty.',
					type: 'is-warning',
				});
				return;
			}
			// Create a new comment object for the new comment
			const tmpComment = {
				IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer,
				IDComment: 0,
				IDParent: 0,
				Comment: tmpCommentNewValue,
			};

			await this.pict.providers.CommentProvider.createComment(tmpComment, async (pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Comment Added',
					type: 'is-success',
				});
				if (pResult)
				{
					const newCommentID = pResult.IDComment;
					if (Array.isArray(this.AppData?.DocumentData?.ReportData?.Comments))
					{
						this.AppData.DocumentData.ReportData.Comments.push(newCommentID);
					}

					const tmpDocument = {
						IDDocument: this.AppData?.DocumentData?.ReportData?.IDDocument,
						IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
						Comments: this.AppData?.DocumentData?.ReportData?.Comments,
					};

					await this.pict.providers.CommentProvider.updateCommentsAttachedToDocument(tmpDocument, (pNewResult) =>
					{
						if (pNewResult)
						{
							this.fetchComments(event, null, null);
							// if the comment was created successfully, clear out the comment container in the UI
							const elNewComment = document.getElementById(`CommentCurrent-Add-Comment-Textarea`);
							if (elNewComment)
							{
								/** @type {HTMLTextAreaElement} */ (elNewComment).value = '';
							}
						}
					});
				}
			});
		}
		// hide the add new comment container
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// render the current state of the comment panel
			this.pict.views.CommentCurrent.renderAsync(() =>
			{
				this.pict.log.info('Comment Panel Rendered');
			});
		}
	}

	/**
	 * Callback to run when user confirms comment delete
	 * @param {object} event - The click event
	 */
	async confirmDeleteCallback(event)
	{
		if (event)
		{
			// render the current state of the comment panel
			this.pict.views.CommentCurrent.renderAsync(() =>
			{
				this.pict.log.info('Comment Panel Rendered');
			});
		}
	}

	/**
	 * Toggle the visibility of comments with responses
	 * @param {*} event - the event object
	 * @param {string} _RowID - the name and id of the comment
	 * @return {void}
	 */
	toggleSectionVisibility(event, _RowID)
	{
		// find the icon in the button and swap it out
		const tmpIcon = event?.currentTarget?.querySelector('i') || event?.parentElement?.currentTarget?.querySelector('i');
		if (!tmpIcon)
		{
			return;
		}
		if (tmpIcon.classList.contains('fa-chevron-left'))
		{
			tmpIcon.classList.remove('fa-chevron-left');
			tmpIcon.classList.add('fa-chevron-down');
		}
		else
		{
			tmpIcon.classList.remove('fa-chevron-down');
			tmpIcon.classList.add('fa-chevron-left');
		}
		// toggle the visibility of the child folders
		const tmpElementID = `CommentCurrent-Child-${_RowID}`;
		// if the element is not found, return
		if (!document.getElementById(tmpElementID))
		{
			this.log.error(`Element with ID ${tmpElementID} not found`);
			return;
		}
		document.getElementById(tmpElementID)?.classList.toggle('is-hidden', document.getElementById(tmpElementID)?.classList.contains('is-hidden') ? false : true);
	}
}

module.exports = CommentCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'CommentCurrent',
	DefaultRenderable: 'CommentCurrent-Wrapper',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
		[
			{
				Hash: 'CommentCurrent-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-CommentCurrentPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-CommentCurrentPanel-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event, 'Comments')">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('right', 'Comments')">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-CommentCurrent-Header-Icon" class="fas fa-fw fa-comment" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-CommentCurrent-Header-Title" class="mr-3">Comments</span>
					</p>
					<div class="panel-content nested-scroll-content">
						<div id="CommentCurrent-Entry-Container">
							{~T:CommentCurrent-Entry~}
						</div>
						<div id="HeadlightPanels-CommentCurrent-Content" class="has-bottom-navbar-offset">
							{~T:CommentCurrent-Results~}
						</div>
					</div>
				</article>`,
			},
			{
				Hash: 'CommentCurrent-Entry',
				Template: /*html*/`
				<div id="CommentCurrent-Entry-Container" class="container">
					<div class="field p-4">
						<div class="buttons is-right">
							<button class="button is-primary is-fullwidth" id="CommentCurrent-AddButton" title="Add comment" onclick="_Pict.views.CommentCurrent.addNewComment(event)">
								<i class="fas fa-fw fa-plus mr-1"></i> Create New Comment
							</button>
						</div>
					</div>
				</div>
				{~T:CommentCurrent-Add-Comment~}`,
			},
			{
				Hash: 'CommentCurrent-Add-Comment',
				Template: /*html*/`
                <div id="CommentCurrent-Add-Comment-Container" class="column is-hidden">
                    <div class="field">
                        <label class="label block" for="CommentCurrent-Add-Comment-Textarea">Comment</label>
                        <div id="CommentCurrent-Add-Comment-Edit" class="control is-fullwidth is-relative">
                            <textarea
                                id="CommentCurrent-Add-Comment-Textarea"
                                class="textarea"
                                placeholder="Enter a comment..."
                                rows="2"
                            ></textarea>
                        </div>
                    </div>
                    {~T:CommentCurrent-New-Comment-Buttons:Record~}
                </div>`,
			},
			{
				Hash: 'CommentCurrent-Results',
				Template: /*html*/`
				<div id="CommentCurrent-Results-Container" class="container table-container">
					{~TIfAbs:CommentCurrent-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:CommentCurrent-Container:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'CommentCurrent-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fas fa-search"></i>
						</span>
						<span>No comments found.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'CommentCurrent-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			/* ----- start Tree View ---- */
			{
				Hash: 'CommentCurrent-Container',
				Template: /*html*/`{~TS:CommentCurrent:Record.CurrentSearchResults~}`,
			},
			/* ----- Tree View > first layer (results or empty check) ----- */
			{
				Hash: 'CommentCurrent',
				Template: /*html*/`{~T:CommentCurrent-CommentList:Record~}`,
			},
			/* ----- Tree View > second layer (empty) ----- */
			{
				Hash: 'CommentCurrent-Empty',
				Template: /*html*/`
				<div class="notification m-3 p-2 empty-message has-background-text-30">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						No responses found for this comment.
					</p>
				</div>`,
			},
			/* ----- Tree View > second layer (search results processed list) ----- */
			{
				Hash: 'CommentCurrent-Content',
				Template: /*html*/`{~T:CommentCurrent-CommentList:Record~}`,
			},
			{
				Hash: 'CommentCurrent-Child-Content',
				Template: /*html*/`{~T:CommentCurrent-Child-CommentList:Record~}`,
			},
			/* ----- Tree View > third layer (comments) ----- */
			{
				Hash: 'CommentCurrent-CommentList',
				Template: /*html*/`
				<div class="comment mx-3 mb-3" style="border-radius: 15px; overflow: hidden;">
					<div class="panel-block-group">
						<div
							id="CommentCurrent-{~D:Record._RowID~}"
							class="panel-block panel-block-group-header is-relative p-0 has-background-primary-25">
							<div class="navbar-item">
								<span class="icon">
									<i class="fas fa-solid fa-user-circle fa-xl"></i>
								</span>
								<span class="icon-text">{~D:Record.CreatingUserData.NameFirst~} {~D:Record.CreatingUserData.NameLast~}</span>
							</div>
						</div>
						<div class="p-3 has-background-text-30">
							<div id="CommentCurrent-Readonly-{~D:Record._RowID~}" class="is-size-6 has-text-text-100">{~D:Record.Comment~}</div>
							<p id="CommentCurrent-Edit-{~D:Record._RowID~}" class="control is-fullwidth is-relative is-hidden">
								<textarea
									id="CommentCurrent-Edit-Textarea-{~D:Record._RowID~}"
									class="textarea has-background-text-30"
									rows="2"
								>{~D:Record.Comment~}</textarea>
								{~T:CommentCurrent-Edit-Comment-Buttons:Record~}
							</p>
							<div class="help has-text-text-85 mt-2">{~DateFormat:Record.Date^MMMM DD, YYYY - hh:mm a~}
								{~T:CommentCurrent-ActionMenu:Record~}
							</div>
						</div>
					</div>
					<div id="CommentCurrent-Child-{~D:Record._RowID~}" class="is-hoverable panel-block-group">
						<div class="treeview-child">
							{~TS:CommentCurrent-Child-Content:Record.Children~}
							{~T:CommentCurrent-Reply-Comment~}
						</div>
					</div>
				</div>`,
			},
			/* ----- Tree View > third layer (comments) ----- */
			{
				Hash: 'CommentCurrent-Child-CommentList',
				Template: /*html*/`
				<div class="comment">
					<div class="panel-block-group" style="border-left: 10px solid var(--bulma-text-40);">
						<div
							id="CommentCurrent-{~D:Record._RowID~}"
							class="panel-block panel-block-group-header is-relative p-0 has-background-text-20">
							<div class="navbar-item">
								<span class="icon">
									<i class="fas fa-solid fa-user-circle fa-xl"></i>
								</span>
								<span class="icon-text">{~D:Record.CreatingUserData.NameFirst~} {~D:Record.CreatingUserData.NameLast~}</span>
							</div>
						</div>
						<div class="p-3 has-background-text-30">
							<div id="CommentCurrent-Readonly-{~D:Record._RowID~}" class="is-size-6 has-text-text-100">{~D:Record.Comment~}</div>
							<p id="CommentCurrent-Edit-{~D:Record._RowID~}" class="control is-fullwidth is-relative is-hidden">
								<textarea
									id="CommentCurrent-Edit-Textarea-{~D:Record._RowID~}"
									class="textarea has-background-text-30"
									rows="2"
								>{~D:Record.Comment~}</textarea>
								{~T:CommentCurrent-Edit-Comment-Buttons:Record~}
							</p>
							<div class="help has-text-text-85 mt-2">{~DateFormat:Record.Date^MMMM DD, YYYY - hh:mm a~}
								{~T:CommentCurrent-ActionMenu:Record~}
							</div>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'CommentCurrent-ActionMenu',
				Template: /*html*/`
				<ul class="is-inline-flex list-menu visible-mode_{~D:Pict.views.CommentCurrent.SearchPanelMode~}">
					{~TIfAbs:CommentCurrent-Reply-Button:Record:Record.IDParent^==^0~}
					{~TIfAbs:CommentCurrent-Edit-Button:Record:Record.IsCreatingUser^==^1~}
					{~TIfAbs:CommentCurrent-Delete-Button:Record:Record.IsCreatingUser^==^1~}
				</ul>`,
			},
			{
				Hash: 'CommentCurrent-Reply-Button',
				Template: /*html*/
				`<li class="mx-2 list-menu-item mode_comment-reply">
					<a class="move-table-row-down-button has-text-primary-70" onclick="_Pict.views.CommentCurrent.handleCommentReplyButton(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-reply"></i>
						</span>
						<span>Reply</span>
					</a>
				</li>`,
			},
			{
				Hash: 'CommentCurrent-Delete-Button',
				Template: /*html*/
				`<li class="mx-2 list-menu-item mode_comment-delete">
					<a class="delete-table-row-button has-text-primary-70" onclick="_Pict.views.CommentCurrent.handleCommentDeleteButton(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-trash"></i>
						</span>
						<span>Delete</span>
					</a>
				</li>`,
			},
			{
				Hash: 'CommentCurrent-Edit-Button',
				Template: /*html*/
				`<li class="mx-2 list-menu-item mode_comment-edit">
					<a class="move-table-row-down-button has-text-primary-70" onclick="_Pict.views.CommentCurrent.handleCommentEditButton(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-pencil"></i>
						</span>
						<span>Edit</span>
					</a>
				</li>`,
			},
			{
				Hash: 'CommentCurrent-Reply-Comment',
				Template: /*html*/`
				<div id="CommentCurrent-Reply-Comment-Container_{~D:Record.IDComment~}" class="column has-background-text-30 is-hidden" style="border-left: 10px solid var(--bulma-text-40);">
					<textarea 
						id="CommentCurrent-Reply-Textarea-Comment_{~D:Record.IDComment~}"
						class="textarea has-background-text-25"
						rows="2"
						placeholder="Enter a reply to this comment..."
					></textarea>
					{~T:CommentCurrent-New-Comment-Buttons:Record~}
				</div>`,
			},
			{
				Hash: 'CommentCurrent-New-Comment-Buttons',
				Template: /*html*/
				`<span class="buttons is-right mt-2">
					<button class="button is-primary is-dark" type="button" title="Cancel Save" onclick="_Pict.views.CommentCurrent.cancelCommentEdit(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-fw fa-times" aria-hidden="true"></i>
						</span>
						<span>Cancel</span>
					</button>
					<button class="button is-primary" type="button" title="Save Comment" onclick="_Pict.views.CommentCurrent.handleCommentAdd(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-fw fa-comment" aria-hidden="true"></i>
						</span>
						<span>Save</span>
					</button>
				</span>`,
			},
			{
				Hash: 'CommentCurrent-Edit-Comment-Buttons',
				Template: /*html*/
				`<span class="buttons is-right mt-2">
					<button class="button is-primary is-dark" type="button" title="Cancel Save" onclick="_Pict.views.CommentCurrent.cancelCommentEdit(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-fw fa-times" aria-hidden="true"></i>
						</span>
						<span>Cancel</span>
					</button>
					<button class="button is-primary" type="button" title="Save Comment" onclick="_Pict.views.CommentCurrent.applyCommentEdit(event, '{~D:Record.IDComment~}', '{~D:Record._RowID~}')">
						<span class="icon">
							<i class="fas fa-fw fa-comment" aria-hidden="true"></i>
						</span>
						<span>Save</span>
					</button>
				</span>`,
			},
			/* ----- end Tree View ----- */
		],
	Renderables:
		[
			{
				RenderableHash: 'CommentCurrent-Wrapper',
				TemplateHash: 'CommentCurrent-Wrapper',
				DestinationAddress: '#HeadlightPanels-RightPanel',
			},
			{
				RenderableHash: 'CommentCurrent-Results',
				TemplateHash: 'CommentCurrent-Results',
				DestinationAddress: '#CommentCurrent-Results-Container',
			},
			{
				RenderableHash: 'CommentCurrent-Pagination',
				TemplateHash: 'CommentCurrent-Pagination',
				DestinationAddress: '#CommentCurrent-Pagination-Container',
			},
		],
};


},{"pict-view":693}],780:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.CurrentDocumentRecord = {
			DocumentType: '',
			DocumentDate: null,
			Form: 0,
			IDProject: 0,
			Name: '',
			Shift: 'Day',
		};
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.rnis = [];
	}

	async onAfterRenderAsync(pCallback)
	{
		if (this.pict.views.HeadlightPaneDocuments.Intent?.afterRenderHandler)
		{
			this.pict.views.HeadlightPaneDocuments.Intent.afterRenderHandler();
		}
		// set the customer ID if it exists
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser.CustomerID || 0;
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.CurrentDocumentRecord.IDProject = tmpProject ? tmpProject.id : 0;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Enter a project...',
			ElementID: 'DocumentCreate-Entry-Project',
			ParentID: 'DocumentCreate-Container',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		this.rnis = this.CurrentDocumentRecord.Project ? (await this.pict.providers.DocumentProvider.getReportNamedInstancesByProject(this.CurrentDocumentRecord.Project, true, true)) : (await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.CurrentSearchFilters.IDCustomer, true, true));
		this.CurrentDocumentRecord.DocumentType = this.rnis[0]?.Hash || '';
		this.CurrentDocumentRecord.Form = this.rnis[0]?.Options?.FormOnly ? 1 : 0;
		// convert the document types to a format that select2 can use
		const dataDocumentTypes = this.rnis.map((pItem) =>
		{
			return {
				id: pItem.Hash,
				text: pItem.Name,
				_isForm: pItem?.Options?.FormOnly ? 1 : 0,
			};
		});
		// DOCUMENT TYPE Selector Filter
		// if we are in a form already, make it's type the sticky on the top of the list
		const tmpDocumentType = dataDocumentTypes.find((pItem) => pItem.id === this.AppData?.DocumentData?.ReportData?.DocumentType);
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark',
			placeholder: 'Enter a document type...',
			ElementID: 'DocumentCreate-Entry-DocumentType',
			ParentID: 'DocumentCreate-Container',
			data: dataDocumentTypes,
			StickyOption: tmpDocumentType,
			PreselectOption: tmpDocumentType,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		this.updateDocumentNamePrefill(tmpDocumentType);

		//  DESIGNATEDDATE date picker
		window.flatpickr('#DocumentCreate-Entry-Date', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentCreate-Date');
			},
		});

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		const tmpOptions = {
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
		};
		// use local data if provided, else assume server-side paging via entity endpoint
		if (pOptions.data)
		{
			tmpOptions.data = pOptions.data;
		}
		else
		{
			tmpOptions.ajax = {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.DocumentCreate.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.DocumentCreate.CurrentSearchFilters.PageSize : data.length === _Pict.views.DocumentCreate.CurrentSearchFilters.PageSize,
					};
				},
			};
		}
		// initialize the select2 plugin
		$('#' + pOptions.ElementID).select2(tmpOptions);
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method updates the current Document record with the value of the specified field.
	 * @param {string} pField - The field to update in the current Document record.
	 * @return {void}
	 */
	handleNewDocumentRecordChange(pField)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(`#DocumentCreate-Entry-${pField}`);
		this.CurrentDocumentRecord[pField] = tmpValue;
		this.log.info(`Current Document Record updated: ${pField} = ${this.CurrentDocumentRecord[pField]}`);
		// update the Document name prefill if the Document type changes
		if (pField === 'DocumentType')
		{
			this.updateDocumentNamePrefill($('#DocumentCreate-Entry-DocumentType').select2('data')[0]);
			this.CurrentDocumentRecord['Form'] = this.rnis.find((rni) =>
			{
				return rni.Hash === tmpValue;
			})?.Options?.FormOnly ? 1 : 0;
		}
	}

	/**
	 * This method updates the Document name prefill based on the selected Document type.
	 * @param {Object} pDocumentTypeSelect2Option - The selected Document type.
	 * @return {void}
	 */
	updateDocumentNamePrefill(pDocumentTypeSelect2Option)
	{
		// Set the new name to current type as prefill
		if (pDocumentTypeSelect2Option && pDocumentTypeSelect2Option.text)
		{
			this.CurrentDocumentRecord.Name = pDocumentTypeSelect2Option.text + ' (New)';
			this.pict.ContentAssignment.assignContent('#DocumentCreate-Entry-Name', this.CurrentDocumentRecord.Name);
		}
		// need to set the form flag for the document
		this.CurrentDocumentRecord.Form = pDocumentTypeSelect2Option?._isForm;
	}

	/**
	 * This method clears the current Document record.
	 * @return {void}
	 */
	clearDocument()
	{
		this.CurrentDocumentRecord = {
			DocumentType: '',
			DocumentDate: null,
			Form: 0,
			IDProject: 0,
			Name: '',
			Shift: 'Day',
		};
		this.renderAsync(() =>
		{
			this.log.info('Document Create view cleared');
		});
	}

	async createNewDocument(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		document.getElementById('DocumentCreate-CreateButton').classList.add('is-loading');
		this.log.info('Creating new Document...');

		const tmpDocumentRecord = {};
		Object.keys(this.CurrentDocumentRecord).forEach((pKey) =>
		{
			switch (pKey)
			{
			case 'Date':
				//defaulting to current time if date is set
				const currentTime = this.pict.providers.DocumentProvider.getDocumentDateCurrentTime();
				tmpDocumentRecord.DocumentDate = this.CurrentDocumentRecord.Date ? this.fable.Dates.dayJS(this.CurrentDocumentRecord.Date + currentTime).toISOString() : null;
				break;
			case 'Project':
				tmpDocumentRecord.IDProject = parseInt(this.CurrentDocumentRecord.Project);
				break;
			case 'Name':
				tmpDocumentRecord.Name = this.CurrentDocumentRecord.Name || (this.CurrentDocumentRecord.DocumentType + ' (New)');
				break;
			case 'Shift':
				tmpDocumentRecord.Shift = this.CurrentDocumentRecord.Shift;
				break;
			case 'DocumentType':
				tmpDocumentRecord.DocumentType = this.CurrentDocumentRecord.DocumentType;
				break;
			case 'Form':
				tmpDocumentRecord.Form = this.CurrentDocumentRecord.Form;
				break;
			default:
				this.pict.log.warn(`Unknown field to map for CreateNewDocument(): ${pKey}`);
				break;
			}
		});

		this.pict.log.info('Creating new Document with the following data:');
		this.pict.log.info(JSON.stringify(tmpDocumentRecord));

		if (!tmpDocumentRecord.IDProject || !tmpDocumentRecord.Name || !tmpDocumentRecord.DocumentType)
		{
			document.getElementById('DocumentCreate-CreateButton').classList.remove('is-loading');
			this.pict.log.warn('Not all required fields are filled out.');
			return;
		}

		// create the new Document
		const newDocumentResult = await this.pict.providers.DocumentProvider.createDocument(tmpDocumentRecord);
		document.getElementById('DocumentCreate-CreateButton').classList.remove('is-loading');
		this.log.info('Document created, going to the Details view...');

		if (this.pict.views.HeadlightPaneDocuments.Intent?.type === 'add')
		{
			this.pict.views.HeadlightPaneDocuments.Intent.handler(newDocumentResult.IDDocument);
		}
		else
		{
			// navigate to the new Document's Details view
			this.pict.views.DocumentDetails.ActiveDocumentDetails = newDocumentResult;
			this.pict.views.DocumentDetails.showDocumentDetailView(null, newDocumentResult.IDDocument, newDocumentResult);
		}
	}
}

module.exports = DocumentCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentCreate',
	DefaultRenderable: 'DocumentCreate',
	DefaultDestinationAddress: '#DocumentCreate-Container',
	Templates:
	[
		{
			Hash: 'DocumentCreate',
			Template: /*html*/`
			{~T:DocumentCreate-Entry~}`,
		},
		{
			Hash: 'DocumentCreate-Entry',
			Template: /*html*/`
			<form id="DocumentCreate-Form" onsubmit="_Pict.views.DocumentCreate.createNewDocument(event)">
				<div class="columns px-4 mb-0 mt-1">
					{~T:DocumentCreate-Entry-ProjectSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:DocumentCreate-Entry-DocumentTypeSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:DocumentCreate-Entry-NameInput~}
				</div>
				<div class="columns px-4 mb-0 theme-dark">
					{~T:DocumentCreate-Entry-ShiftSelector~}
					{~T:DocumentCreate-Entry-DateInput~}
				</div>
				<div class="columns px-4 mb-0 mt-1">
					<div class="column">
						<div class="buttons is-right">
							<button id="DocumentCreate-ClearButton" type="button" class="button is-primary is-dark" title="Clear documents" onclick="_Pict.views.DocumentCreate.clearDocument()">
								<span class="icon">
									<i class="fa fa-fw fa-refresh"></i>
								</span>
								<span class="icon-text">Clear</span>
							</button>
							<button id="DocumentCreate-CreateButton" type="submit" class="button is-primary" title="Create new document">
								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span class="icon-text">Create New Document</span>
							</button>
						</div>
					</div>
				</div>
			</form>`,
		},
		{
			Hash: 'DocumentCreate-Entry-NameInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Name">Document Name</label>
					<div class="control">
						<input 
							id="DocumentCreate-Entry-Name" 
							class="input" 
							type="text" 
							placeholder="Enter a name for the Document..."
							autocomplete="off"
							{~SelectOnFocus:Record~}
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Name')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-DateInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Date">Document Date</label>
					<div class="control">
						<input 
							id="DocumentCreate-Entry-Date" 
							class="input" 
							type="date" 
							placeholder="Enter a date for the Document..." 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Date')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-DocumentTypeSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-DocumentType">Document Type</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-DocumentType" 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('DocumentType')"
						>{~TS:DocumentCreate-Entry-DocumentTypeSelector-SelectedOptions:Context[0].CurrentSearchFilters.DocumentType~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-ProjectSelector',
			Template: /*html*/`
			<div class="column" id="DocumentCreate-Entry-Project-Wrapper">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Project">Project</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-Project" 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Project')"
						>{~TS:DocumentCreate-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-ShiftSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Shift">Shift</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-Shift" 
							class="input"
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Shift')"
						>
							<option value="Day" selected>Day</option>
							<option value="Night">Night</option>
							<option value="Swing">Swing</option>
						</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Enty-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentCreate',
			TemplateHash: 'DocumentCreate',
			DestinationAddress: '#DocumentCreate-Container',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":693}],781:[function(require,module,exports){
/* eslint-disable no-extra-bind */
const PictViewClass = require('pict-view');

class DocumentCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.CurrentDocumentCloneAction = 'Duplicate';
		this.AvailableCloneForms = [];
		this.AvailableCloneFormsWithMaps = [];
	}

	onBeforeRenderAsync(pCallback)
	{
		if (!this.AppData?.DocumentData)
		{
			this.log.warn('No document data found.');
		}
		else
		{
			this.CurrentDocumentData = this.AppData.DocumentData;
		}

		if (pCallback) pCallback();
	}

	async onAfterRenderAsync(pCallback)
	{
		if (pCallback) pCallback();
	}

	/**
	 * Download the PDF for the selected Document
	 * @param {object} event - The click event
	 */
	handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading');

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, this.AppData?.DocumentData?.ReportData, () =>
			{
				element.classList.remove('is-loading');
			});
		}
	}

	/**
	 * A callback to run when the user confirms the cloning of data into a new form type. This will clone all data from the current form into a new form of a different type.
	 * @param {*} event - the click event
	 */
	confirmCloneCallback(event)
	{
		if (event)
		{
			event.target.classList.add('is-loading');
		}
		// the custom options for the clone
		const customOptions = {};
		// fetch the custom title for the cloned document
		const newDocumentTitle = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Title');
		// set the new document title in case it was changed
		customOptions.Name = newDocumentTitle;
		//set window Target based on call from mobile device or desktop
		const windowTarget = this.pict.providers.DocumentProvider.isOpenDocumentCalledFromMobileDevice() ? '_top' : '_blank';

		const tmpAnticipate = this.fable.newAnticipate();
		const tmpCloneData = {};
		let abandonClone = false;

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Workflow')
				{
					// fetch the clone rules record from the server
					const tmpSelectedMapValue = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
					if (tmpSelectedMapValue)
					{
						this.pict.EntityProvider.getEntitySetPage('ManifestSchema', `FBV~Type~EQ~Clone~FBV~Hash~EQ~${tmpSelectedMapValue}`, 0, 10,
						function(pError, pRecords)
						{
							if (pError)
							{
								this.log.error('Error fetching cloning map manifest schema:', pError);
								fCallback();
							}
							else if (pRecords && pRecords.length > 0)
							{
								if (pRecords.length > 1)
								{
									this.log.warn('Multiple cloning map manifest schemas found, using the first one.');
								}
								else
								{
									this.log.info('Applying cloning map manifest schema:', pRecords[0]);
								}
								tmpCloneData.CloneRulesManifest = pRecords[0];
								fCallback();
							}
							else
							{
								// set this flag to skip the cloning process
								abandonClone = true;
								this.log.warn('No cloning map manifest schema found, skipping cloning map application.');
								const tmpDisplayName = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
								// show toast notification
								// custom body content
								document.getElementById('CloneDocumentModalBody').innerHTML =
								/*html*/`
								<div class="container column is-12">
									<p class="title is-5 has-text-centered p-2 mb-5">
										<span class="icon">
											<i class="fa fa-fw fa-circle-check has-text-danger"></i>
										</span>
										<span> Form data failed to clone.</span>
									</p>
									<p class="subtitle is-6 has-text-centered">The form workflow named <strong>${ tmpDisplayName }</strong> did not have a valid cloning map defined. Please check the workflow settings and try again.</p>
									<p class="subtitle is-6 has-text-centered">Please click button below to close this modal.</p>
								</div>`;
								// custom footer content
								document.getElementById('CloneDocumentModalFooter').innerHTML =
								/*html*/`
								<button class="button is-link" type="button" title="Close modal" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
									<span class="icon">
										<i class="fas fa-fw fa-check" aria-hidden="true"></i>
									</span>
									<span>Close</span>
								</button>`;
								fCallback();
							}
						}.bind(this));
					}
					else
					{
						this.log.info('No cloning map selected, skipping cloning map application.');
						fCallback();
					}
				}
				else
				{
					fCallback();
				}
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Workflow' && tmpCloneData.CloneRulesManifest)
				{
					// create a new document record to clone to
					tmpCloneData.NewDocumentCloneRecord = tmpCloneData?.CloneRulesManifest?.Manifest?.DocumentPayload || {};
					// set the document type to the selected form type
					if (!('FormData' in tmpCloneData?.NewDocumentCloneRecord))
					{
						tmpCloneData.NewDocumentCloneRecord.FormData = {};
					}
					tmpCloneData.NewDocumentCloneRecord.FormData.SourceRecordFormData = this.pict.AppData.DocumentData.ReportData.FormData || {};

					if (!('Descriptors' in tmpCloneData?.CloneRulesManifest?.Manifest))
					{
						tmpCloneData.CloneRulesManifest.Manifest.Descriptors = {};
					}
					// map the data from the current document to the new document based on the cloning map
					const tempDescriptorKeys = Object.keys(tmpCloneData.CloneRulesManifest.Manifest.Descriptors);
					tempDescriptorKeys.forEach(function(pDescriptorKey)
					{
						const tmpDescriptor = tmpCloneData.CloneRulesManifest.Manifest.Descriptors[pDescriptorKey];
						if (tmpDescriptor.hasOwnProperty('ToAddress'))
						{
							this.pict.manifest.setValueAtAddress(tmpCloneData.NewDocumentCloneRecord.FormData, tmpDescriptor.ToAddress, this.pict.manifest.getValueAtAddress(_Pict.AppData.DocumentData.ReportData.FormData, pDescriptorKey));
						}
					}.bind(this));
					// set the document date to now
					tmpCloneData.NewDocumentCloneRecord.DocumentDate = new Date().toISOString();
					// set the name to the new document title
					tmpCloneData.NewDocumentCloneRecord.Name = newDocumentTitle || tmpCloneData?.CloneRulesManifest?.Manifest?.NewDocumentName;
					// set the document project from the cloned document
					tmpCloneData.NewDocumentCloneRecord.IDProject = this.AppData.DocumentData.ReportData.IDProject;
				}
				fCallback();
			}.bind(this));

		// for the non-workflow cloning actions, set up the new document record accordingly
		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Duplicate' || this.CurrentDocumentCloneAction === 'Clone')
				{
					tmpCloneData.NewDocumentCloneRecord = {
						Form: 1,
					};
					// create a new document record to clone to
					tmpCloneData.NewDocumentCloneRecord.FormData = Object.assign({}, this.pict.AppData.DocumentData.ReportData.FormData);
					// set the document date to now
					tmpCloneData.NewDocumentCloneRecord.DocumentDate = new Date().toISOString();
					// set the name to the new document title
					tmpCloneData.NewDocumentCloneRecord.Name = newDocumentTitle;
					// set the document project from the cloned document
					tmpCloneData.NewDocumentCloneRecord.IDProject = this.AppData.DocumentData.ReportData.IDProject;
					// set the document type to the selected form type
					if (this.CurrentDocumentCloneAction === 'Duplicate')
					{
						tmpCloneData.NewDocumentCloneRecord.DocumentType = this.pict.AppData.DocumentData.ReportData.DocumentType;
					}
					else
					{
						// TODO: This needs to take the doc type and actually go fetch the RNI Hash (see Document Provider "handleDocumentDuplication()" for reference)
						//		 however, we're punting this feature for now until we discuss how to best implement this so we don't just orphan a buncha FormData on new docs.

						// const tmpSelectedFormType = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type');
						// if (tmpSelectedFormType)
						// {
						// 	tmpCloneData.NewDocumentCloneRecord.DocumentType = tmpSelectedFormType;
						// }
					}
				}
				fCallback();
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				this.pict.HeadlightRestClient.postJSON(`Document`, tmpCloneData.NewDocumentCloneRecord,
					function(pError, pResponse)
					{
						if (pError)
						{
							this.log.error('Error cloning document data:', pError);
						}
						else
						{
							this.log.info('Document data cloned successfully:', pResponse);
						}
						tmpCloneData.CreatedDocument = pResponse;
						fCallback();
					}.bind(this));
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				// custom body content
				document.getElementById('CloneDocumentModalBody').innerHTML =
				/*html*/`
				<div class="container column is-12">
					<p class="title is-5 has-text-centered p-2 mb-5">
						<span class="icon">
							<i class="fa fa-fw fa-circle-check has-text-success"></i>
						</span>
						<span> Form data successfully cloned.</span>
					</p>
					<p class="subtitle is-6 has-text-centered">A new document titled <strong>${ newDocumentTitle }</strong> has been created with all previously selected data from the original <strong>${ this.AppData.DocumentData.ReportData.Name }</strong> document.</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to open your new document or close this modal.</p>
				</div>`;
				// custom footer content
				document.getElementById('CloneDocumentModalFooter').innerHTML =
				/*html*/`
				<button class="button is-link is-soft" type="button" title="Close modal" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Close</span>
				</button>
				<button class="button is-link" type="button" title="Open new document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, ${tmpCloneData.CreatedDocument.IDDocument}, '${windowTarget}');_Pict.fable.services.HeadlightModal.dismissModals();">
					<span class="icon">
						<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
					</span>
					<span>Open New Document</span>
				</button>`;

				fCallback();
			}.bind(this));

		tmpAnticipate.wait(
			function(pError)
			{
				if (pError)
				{
					this.log.error('Error during anticipation wait:', pError);
				}
				if (event)
				{
					event.target.classList.remove('is-loading');
				}
			}.bind(this));
	};

	/**
	 * Clone the Form for the selected Document into a new form type
	 */
	cloneDataFromForm()
	{
		// filter out the forms that are designed to accept cloned data with a map
		this.AvailableCloneFormsWithMaps = this.collectAllFormsWithCloneActions();
		this.CurrentDocumentCloneAction = 'Duplicate';
		// the body and footer templates for the duplication modal
		const cloneModalBodyTemplate = /*html*/`
		<span id="CloneDocumentModalBody">
			<div class="column is-12">
				<label class="label">Clone Action</label>
				<div class="field">
					<div class="control">
						<div class="control">
							<div class="select is-fullwidth">
								<select id="CLONE-FOR-DocumentDetails-Document-Clone-Action" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, event.target.value)">
									<option value="Duplicate" selected>Duplicate this form</option>
									<option value="Workflow">Workflow to new form</option>
									<!-- IN DEVELOPMENT FEATURE: Hidden for future use <option value="Clone">Clone data to new form</option> -->
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Current Document</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Current-Header-Title" disabled="disabled" class="input" type="text" placeholder="Document Title" value="${this.AppData?.DocumentData?.ReportData?.Name}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field" id="CloneDocument-DuplicateSelectField">
					<label class="label">New Document Type</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Current-Header-Title" disabled="disabled" class="input" type="text" placeholder="Document Title" value="${this.AppData?.DocumentData?.ReportData?.Name}">
					</div>
				</div>
				<div class="field is-hidden" id="CloneDocument-WorkflowSelectField">
					<!-- Workflow-based cloning -->
					<label class="label">New Document Type from Workflow</label>
					<div id="CloneDocument-WorkflowSelectField-Available" class="control ${ this.AvailableCloneFormsWithMaps.length > 0 ? '' : 'is-hidden' }">
						<div class="select is-fullwidth">
							<select id="CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, 'Workflow')">
								${ this.AvailableCloneFormsWithMaps.map((form) => `<option value="${form.Default}">${form.Name}</option>`).join('') }
							</select>
						</div>
					</div>
					<!-- Show a disabled input if there are no available workflows -->
					<div id="CloneDocument-WorkflowSelectField-Empty" class="control ${ this.AvailableCloneFormsWithMaps.length === 0 ? '' : 'is-hidden' }">
						<input class="input" type="text" placeholder="No Available Workflows" disabled="disabled" value="No Available Workflows">
					</div>
				</div>
				<div class="field is-hidden" id="CloneDocument-CloneSelectField">
					<label class="label">New Document Type with Cloned Data</label>
					<div class="control">
						<div class="select is-fullwidth">
							<select id="CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, 'Clone')">
								${ this.AvailableCloneForms.map((form) => `<option value="${form.IDReportNamedInstance}" ${form.Hash === this.AppData.DocumentData.ReportData.DocumentType ? 'selected' : ''}>${form.Name}</option>`).join('') }
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">New Document Title</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Header-Title" class="input" type="text" placeholder="Document Title" value="${this.AppData.DocumentData.ReportData.Name} (copy)">
					</div>
				</div>
			</div>
		</span>`;
		const cloneModalFooterTemplate = /*html*/`
		<div id="CloneDocumentModalFooter" class="buttons is-right">
			<button id="CloneDocument-CancelButton" class="button is-link is-soft" type="button" title="Cancel Cloning" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button id="CloneDocument-ConfirmationButton" class="button is-link" type="button" title="Clone Document" onclick="_Pict.views.DocumentCurrent.confirmCloneCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-clone" aria-hidden="true"></i>
				</span>
				<span>Clone Document</span>
			</button>
		</div>`;
		// the options for the duplication modal
		const duplicationModalOptions = {
			title: 'Clone Data To New Form',
			modalBodyTemplate: cloneModalBodyTemplate,
			modalFooterTemplate: cloneModalFooterTemplate,
			confirmText: 'Clone Data',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(duplicationModalOptions, this.confirmCloneCallback.bind(this));
	}

	/**
	 * Handle the change event from the form type select to update the document title with the selected form name.
	 * @param {*} event - the change event from the form type select
	 * @param {string} pCloneType - the type of cloning being performed ('Duplicate' 'Workflow', or 'Clone')
	 */
	async onCloneFormTypeChange(event, pCloneType)
	{
		if (event && event.target instanceof HTMLSelectElement)
		{
			const tmpCloneType = pCloneType || event.target.value;

			// hide all three fields initially
			document.getElementById('CloneDocument-WorkflowSelectField').classList.add('is-hidden');
			document.getElementById('CloneDocument-CloneSelectField').classList.add('is-hidden');
			document.getElementById('CloneDocument-DuplicateSelectField').classList.add('is-hidden');
			this.CurrentDocumentCloneAction = tmpCloneType;

			// enable the clone button in case it was disabled previously
			document.getElementById('CloneDocument-ConfirmationButton').removeAttribute('disabled');
			document.getElementById('CloneDocument-ConfirmationButton').removeAttribute('title');
			document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').removeAttribute('disabled');

			let displayFormName = '';

			// show the appropriate field based on the selected clone type
			switch (tmpCloneType)
			{
			case 'Duplicate':
				document.getElementById('CloneDocument-DuplicateSelectField').classList.remove('is-hidden');
				displayFormName = this.pict.AppData.DocumentData.ReportData.Name + ' (copy)';
				this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
				setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				break;
			case 'Workflow':
				// show the workflow select field
				const workflowMapElement = document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
				const workflowMap = (workflowMapElement instanceof HTMLSelectElement) ? workflowMapElement.selectedOptions?.[0]?.label : undefined;
				if (workflowMap)
				{
					document.getElementById('CloneDocument-WorkflowSelectField').classList.remove('is-hidden');
					if (workflowMap === 'No Available Workflows')
					{
						document.getElementById('CloneDocument-ConfirmationButton').setAttribute('disabled', 'true');
						document.getElementById('CloneDocument-ConfirmationButton').setAttribute('title', 'Cloning not available');
						document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').setAttribute('disabled', 'true');
						document.getElementById('CloneDocument-WorkflowSelectField-Empty').classList.remove('is-hidden');
						document.getElementById('CloneDocument-WorkflowSelectField-Available').classList.add('is-hidden');
						return;
					}
					// show the available workflow select field
					document.getElementById('CloneDocument-WorkflowSelectField-Available').classList.remove('is-hidden');
					document.getElementById('CloneDocument-WorkflowSelectField-Empty').classList.add('is-hidden');
					// set the document title to the selected form name and highlight it for easy editing
					displayFormName = workflowMap + ' (with workflow data)';
					this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
					setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				}
				break;
			// NOTE: This feature is currently not active in the UI, but the code is left here for future use.
			case 'Clone':
				// fetch the available forms for cloning
				this.AvailableCloneForms = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.pict.AppData?.DocumentData?.ReportData?.IDCustomer).catch((error) =>
				{
					this.log.error('Error fetching available forms for cloning:', error);
					document.getElementById('CloneDocument-ConfirmationButton').setAttribute('disabled', 'true');
					document.getElementById('CloneDocument-ConfirmationButton').setAttribute('title', 'Cloning not available');
					document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').setAttribute('disabled', 'true');
					return [];
				});
				// filter out any non-forms because we can only clone into forms
				this.AvailableCloneForms = this.AvailableCloneForms.filter((document) => document?.Options?.FormOnly);
				// show the clone select field
				const cloneSelectElement = document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type');
				const cloneSelectedForm = (cloneSelectElement instanceof HTMLSelectElement) ? cloneSelectElement.selectedOptions?.[0]?.label : undefined;
				if (cloneSelectedForm)
				{
					document.getElementById('CloneDocument-CloneSelectField').classList.remove('is-hidden');
					displayFormName = cloneSelectedForm + ' (with cloned data)';
					this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
					setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				}
				break;
			default:
				this.log.warn(`Unknown clone type selected: ${tmpCloneType}`);
			}
		}
	}

	/**
	 * Collect all forms with CloneAction input types from the PictFormMetacontroller manifest
	 * @returns {Array} - An array of form descriptors with CloneAction input types
	 */
	collectAllFormsWithCloneActions()
	{
		const tmpDescriptors = this.pict.views.PictFormMetacontroller?.manifestDescription?.Descriptors || {};
		const tmpDescriptorsKeys = Object.keys(tmpDescriptors);
		const tmpDescritporsWithCloneActions = [];
		// iterate through all descriptors to find forms with CloneAction input types
		tmpDescriptorsKeys.forEach((descriptorKey) =>
		{
			const descriptor = tmpDescriptors[descriptorKey];
			if (descriptor?.PictForm)
			{
				const hasCloneAction = descriptor?.PictForm?.InputType === 'CloneAction';
				if (hasCloneAction)
				{
					tmpDescritporsWithCloneActions.push(descriptor);
				}
			}
		});
		return tmpDescritporsWithCloneActions;
	}
}

module.exports = DocumentCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentCurrent',
	DefaultRenderable: 'DocumentCurrent',
	DefaultDestinationAddress: '#DocumentCurrent-Container',
	Templates:
		[
			{
				Hash: 'DocumentCurrent',
				Template: /*html*/`
				<div id="DocumentCurrent-Container" class="container"  style="min-width: 33vw;" data-document-id="{~D:Context[0].CurrentDocumentData.IDDocument~}">
					{~TIfAbs:DocumentCurrent-Empty:Context[0].CurrentDocumentData:Context[0].CurrentDocumentData^==^0~}
					{~TIfAbs:DocumentCurrent-Content:Context[0].CurrentDocumentData:Context[0].CurrentDocumentData^>^0~}
				</div>`,
			},
			{
				Hash: 'DocumentCurrent-Content',
				Template: /*html*/`
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-15">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:Record.ReportData.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">
							<span class="is-pulled-right">
								{~TIfAbs:DocumentCurrent-Locked:Record.ReportData.Locked:Record.ReportData.Locked^==^1~}
								{~TIfAbs:DocumentCurrent-Unlocked:Record.ReportData.Locked:Record.ReportData.Locked^==^0~}
							</span>
							<span class="mr-1">#{~D:Record.ReportData.IDDocument~}</span>
							<span class="mr-1 is-size-7">Form #{~D:Record.ReportData.SequenceNumber~}</span>
						</p>
					</div>
				</div>
				<div class="columns px-5 mt-3">
					<div class="column is-12">
						<span class="title is-block is-6 has-text-text-60">Project</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:Project^Record.ReportData.IDProject^DocumentCurrent-Content-Project^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.ReportData.CreatingIDUser^DocumentCurrent-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Document Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ReportData.DocumentDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.ReportData.UpdatingIDUser^DocumentCurrent-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ReportData.UpdateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Document Type</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.TidingsData.Type~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Timezone</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Timezone~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Status~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Observations</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Observations.length~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Work Shift</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Shift~}</span>
					</div>
				</div>
				<div class="buttons is-right py-2 px-5">
					<button id="DocumentCurrent-CloneButton" class="button is-primary {~Show:Record.ReportData.Form~}" type="button" title="View document" onclick="_Pict.views.DocumentCurrent.cloneDataFromForm()">
						<span class="icon">
							<i class="fas fa-fw fa-clone" aria-hidden="true"></i>
						</span>
						<span>Clone Data To New Form</span>
					</button>
					<button class="button is-primary" type="button" title="Download document PDF" onclick="_Pict.views.DocumentCurrent.handleDocumentDownload(event)">
						<span class="icon">
							<i class="fas fa-fw fa-file-pdf" aria-hidden="true"></i>
						</span>
						<span>Download PDF</span>
					</button>
				</div>`,
			},
			{
				Hash: 'DocumentCurrent-Content-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'DocumentCurrent-Content-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentCurrent-Locked',
				Template: /*html*/`
					<span class="icon has-text-text-95">
						<i class="fas fa-fw fa-sm fa-lock"></i>
					</span>
					<span class="icon-text has-text-text-95">Locked</span>`,
			},
			{
				Hash: 'DocumentCurrent-Unlocked',
				Template: /*html*/`
					<span class="icon">
						<i class="fas fa-fw fa-sm fa-unlock"></i>
					</span>
					<span class="icon-text">Unlocked</span>`,
			},
			{
				Hash: 'DocumentCurrent-Empty',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="title is-5 has-text-white has-text-centered">No Document Selected</p>
					<p class="subtitle is-6 has-text-text-65 has-text-centered">Please select a record to set as the current document.</p>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'DocumentCurrent',
				TemplateHash: 'DocumentCurrent',
				DestinationAddress: '#DocumentCurrent-Container',
				RenderType: 'replace',
			},
		],
};

},{"pict-view":693}],782:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveDocumentDetails = {};
	}

	/**
	 * This method resets the state of the Document Details view to a default state.
	 */
	resetDocumentDetailsView()
	{
		this.ActiveDocumentDetails = {};
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {object} event - The click event
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {string} [pDocumentRecord] - The record of the Document to view (optional)
	 */
	showDocumentDetailView(event, pIDDocument, pDocumentRecord)
	{
		// check the document data first to make sure it's not already loaded
		this.pict.views.DocumentDetails.ActiveDocumentDetails = this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument ? this.pict.AppData.DocumentData.ReportData : null;
		// if not found, try the search results next
		if (!this.pict.views.DocumentDetails.ActiveDocumentDetails)
		{
			this.pict.views.DocumentDetails.ActiveDocumentDetails = pDocumentRecord || this.pict.views.DocumentSearch.CurrentSearchResults.find((obs) => obs.IDDocument == pIDDocument);
		}
		// open the panel if it is not already open
		this.pict.views.HeadlightPanels.handlePanelToggle('DocumentDetails', 'open');
		// render the Document detail view
		this.pict.views.DocumentDetails.renderAsync(false, false, false, false, () =>
		{
			this.log.info('Document Details View Rendered with Active Record', this.pict.views.DocumentDetails.ActiveDocumentDetails);
		});
	}

	/**
	 * Confirmation Modal to open a form in the webApp
	 */
	confirmOpenForm(pIDDocument, windowTarget)
	{
		// footer templates for the confirmation modal
		const confirmModalFooterTemplate = /*html*/`
		<div id="ConfirmModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Open" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Open Document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, ${pIDDocument}, '${windowTarget}'); _Pict.fable.services.HeadlightModal.dismissModals();">
				<span class="icon">
					<i class="fas fa-fw fa-check" aria-hidden="true"></i>
				</span>
				<span>Continue</span>
			</button>
		</div>`;
		// the options for the confirmation modal
		const confirmModalOptions = {
			title: 'Open Document?',
			message: 'Are you sure you want to open this document? This will replace the current document.',
			modalFooterTemplate: confirmModalFooterTemplate,
		};
		this.fable.HeadlightModal.spawnModal(confirmModalOptions, this.pict.providers.DocumentProvider.openFormByIDDocument.bind(this));
	}

	// the callback to run when the user confirms the duplication
	confirmDuplicateCallback(event)
	{
		if (event)
		{
			event.target.classList.add('is-loading');
		}
		// the custom options for the duplication
		const customOptions = {};
		const originalTitle = this.ActiveDocumentDetails.Name;
		// fetch the custom title for the duplicated document
		const newDocumentTitle = this.pict.ContentAssignment.readContent('#DUPLICATE-FOR-DocumentDetails-Document-Header-Title');
		// set the new document title in case it was changed
		customOptions.Name = newDocumentTitle;
		const newDocumentDate = this.pict.ContentAssignment.readContent('#DUPLICATE-FOR-DocumentDetails-Document-Header-Date');
		const currentTime = this.pict.providers.DocumentProvider.getDocumentDateCurrentTime();
		customOptions.DocumentDate = newDocumentDate ? this.fable.Dates.dayJS(newDocumentDate + currentTime).toISOString() : this.fable.Dates.dayJS(new Date()).toISOString();

		//set window Target based on call from mobile device or desktop
		const windowTarget = this.pict.providers.DocumentProvider.isOpenDocumentCalledFromMobileDevice() ? '_top' : '_blank';
		// duplicate the document
		this.pict.providers.DocumentProvider.handleDocumentDuplication(customOptions, this.ActiveDocumentDetails, (pNewDocument) =>
		{
			if (event)
			{
				event.target.classList.remove('is-loading');
			}
			// custom body content
			document.getElementById('DuplicateDocumentModalBody').innerHTML =
			/*html*/`
			<div class="container column is-12">
				<p class="title is-5 has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-circle-check has-text-success"></i>
					</span>
					<span> Document successfully duplicated.</span>
				</p>
				<p class="subtitle is-6 has-text-centered">A new document titled <strong>${ newDocumentTitle }</strong> has been created with all previously saved data from the original <strong>${ originalTitle }</strong> document.</p>
				<p class="subtitle is-6 has-text-centered">Please click button below to open your new document or close this modal.</p>
			</div>`;
			// custom footer content
			document.getElementById('DuplicateDocumentModalFooter').innerHTML =
			/*html*/`
			<button class="button is-link is-soft" type="button" title="Close modal" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Close</span>
			</button>
			<button class="button is-link" type="button" title="Open new document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, '${ pNewDocument?.IDDocument }', '${windowTarget}'); _Pict.fable.services.HeadlightModal.dismissModals();">
				<span class="icon">
					<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
				</span>
				<span>Open New Document</span>
			</button>`;
		});
	};

	handleDeleteActiveForm()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Document',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this document?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.ActiveDocumentDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Document" onclick="_Pict.views.DocumentDetails.onDeleteConfirm()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Document</span>
				</button>
			</div>`,
			confirmText: 'Delete Document',
			cancelText: 'Cancel',
		});
	}

	/**
	 * Handle the deletion of the active Document after confirmation
	 */
	onDeleteConfirm()
	{
		this.pict.providers.DocumentProvider.handleDocumentDeletion(this.ActiveDocumentDetails.IDDocument, (pResponse) =>
		{
			this.fable.services.HeadlightModal.dismissModals();
			// show a success toast
			this.pict.views.HeadlightPanels.toast({
				message: 'Document deleted successfully.',
				type: 'is-success',
			});
			this.resetDocumentDetailsView();
			// close the panel
			this.fable.views.HeadlightPanels.handlePanelToggle('DocumentDetails', 'close');
		});
	}

	/**
	 * Duplicate the Form for the selected Document
	 */
	duplicateActiveForm()
	{
		// the body and footer templates for the duplication modal
		const duplicateModalBodyTemplate = /*html*/`
		<span id="DuplicateDocumentModalBody">
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Title</label>
					<div class="control">
						<input id="DUPLICATE-FOR-DocumentDetails-Document-Header-Title" class="input" type="text" placeholder="Document Title" value="${this.ActiveDocumentDetails.Name} (Copy)">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Type</label>
					<div class="control">
						<input id="DUPLICATE-FOR-DocumentDetails-Document-Header-Type" disabled class="input" type="text" placeholder="Document Type" value="${this.ActiveDocumentDetails.TidingsData.Type}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Date</label>
					<div class="control">
						<input 
							id="DUPLICATE-FOR-DocumentDetails-Document-Header-Date" 
							class="input flatpickr-input active" 
							type="date" 
							placeholder="Enter the date of the Document" 
						/>
					</div>
				</div>
			</div>
		</span>`;
		const duplicateModalFooterTemplate = /*html*/`
		<div id="DuplicateDocumentModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Duplication" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-link" type="button" title="Duplicate Document" onclick="_Pict.views.DocumentDetails.confirmDuplicateCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Duplicate Document</span>
			</button>
		</div>`;
		// the options for the duplication modal
		const duplicationModalOptions = {
			title: 'Duplicate Document',
			modalBodyTemplate: duplicateModalBodyTemplate,
			modalFooterTemplate: duplicateModalFooterTemplate,
			confirmText: 'Create Duplicate',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(duplicationModalOptions, this.confirmDuplicateCallback.bind(this));
	}

	async onBeforeRenderAsync(pCallback)
	{
		if (this.ActiveDocumentDetails && !this.ActiveDocumentDetails?.TidingsData?.Type)
		{
			const customerRNIs = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.ActiveDocumentDetails?.IDCustomer);
			// find the matching document type via the project RNIs
			const match = customerRNIs.find((rni) => rni.Hash === this.ActiveDocumentDetails?.DocumentType);
			if (!match)
			{
				this.pict.log.warn('No matching RNI Hash has been set on this customer!');
			}
			this.ActiveDocumentDetails.TidingsData = match?.Options?.TidingsData;
		}
		pCallback();
	}

	/**
	 * Download the PDF for the selected Document
	 * @param {object} event - The click event
	 */
	handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading');

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, this.ActiveDocumentDetails, () =>
			{
				element.classList.remove('is-loading');
			});
		}
	}
}

module.exports = DocumentDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentDetails',
	DefaultRenderable: 'DocumentDetails',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'DocumentDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-DocumentDetailsPanel" class="panel is-active">
				<p id="HeadlightPanels-DocumentDetailsPanel-Document-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.DocumentDetails.resetDocumentDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-DocumentDetailsPanel-Document-Header-Icon" class="fas fa-fw fa-files" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-DocumentDetailsPanel-Document-Header-Title" class="mr-3">Document Details</span>
				</p>
				<div id="HeadlightPanels-DocumentDetails-Content" class="container panel-content"  style="min-width: 33vw;">
					{~T:DocumentDetails-Content:Context[0].ActiveDocumentDetails~}
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentDetails-Content',
			Template: /*html*/`
			<div class="columns px-4 py-2 m-0 has-background-text-20">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:Record.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">
							<span class="is-pulled-right">
								{~TIfAbs:DocumentDetails-Locked:Record.Locked:Record.Locked^==^1~}
								{~TIfAbs:DocumentDetails-Unlocked:Record.Locked:Record.Locked^==^0~}
							</span>
							<span class="mr-1">#{~D:Record.IDDocument~}</span>
							<span class="mr-1 is-size-7">Form #{~D:Record.SequenceNumber~}</span>
						</p>
					</div>
				</div>
				<div class="columns px-5 mt-3">
					<div class="column is-12">
						<span class="title is-block is-6 has-text-text-60">Project</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:Project^Record.IDProject^DocumentDetails-Content-Project^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^DocumentDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Document Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DocumentDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.UpdatingIDUser^DocumentDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.UpdateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Document Type</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.TidingsData.Type~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Timezone</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Timezone~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~DocumentState:Record~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Observations</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Observations.length~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Work Shift</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Shift~}</span>
					</div>
				</div>
				<div class="buttons is-right py-2 px-5">
					<button class="button is-primary is-dark {~Show:Record.Form~}" type="button" title="Delete document" onclick="_Pict.views.DocumentDetails.handleDeleteActiveForm()">
						<span class="icon">
							<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
						</span>
						<span>Delete</span>
					</button>
					<button class="button is-primary {~Show:Record.Form~}" type="button" title="Duplicate document" onclick="_Pict.views.DocumentDetails.duplicateActiveForm()">
						<span class="icon">
							<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
						</span>
						<span>Duplicate</span>
					</button>
					<button class="button is-primary {~Show:Record.Form~}" type="button" title="Open document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocumentHandler(event, {~D:Record.IDDocument~})">
						<span class="icon">
							<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
						</span>
						<span>Open</span>
					</button>
					<button class="button is-primary" type="button" title="Download document PDF" onclick="_Pict.views.DocumentDetails.handleDocumentDownload(event)">
						<span class="icon">
							<i class="fas fa-fw fa-file-pdf" aria-hidden="true"></i>
						</span>
						<span>Download PDF</span>
					</button>
				</div>`,
		},
		{
			Hash: 'DocumentDetails-Content-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'DocumentDetails-Content-Project',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'DocumentDetails-Locked',
			Template: /*html*/`
				<span class="icon has-text-text-95">
					<i class="fas fa-fw fa-sm fa-lock"></i>
				</span>
				<span class="icon-text has-text-text-95">Locked</span>`,
		},
		{
			Hash: 'DocumentDetails-Unlocked',
			Template: /*html*/`
				<span class="icon">
					<i class="fas fa-fw fa-sm fa-unlock"></i>
				</span>
				<span class="icon-text">Unlocked</span>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentDetails',
			TemplateHash: 'DocumentDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'DocumentDetails-Content',
			TemplateHash: 'DocumentDetails-Content',
			DestinationAddress: '#HeadlightPanels-DocumentDetails-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":693}],783:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			Materials: [],
			MixDesigns: [],
			StartDate: '',
			EndDate: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'DocumentDate',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		// this is the active Document that is selected; will be one we see in the "Document Details" panel, etc.
		this.selectedDocument = {};
		this.mode = 'none';
		this.documentSearchResultsCallback = (results) =>
		{};
	}

	setMode(newMode)
	{
		this.mode = newMode;
	}

	onBeforeRenderAsync(pCallback)
	{
		if (this.pict.views.HeadlightPaneDocuments.Intent?.type === 'add')
		{
			this.mode = 'add-with-intent';
		}
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'DocumentSearch-Projects',
			ParentID: 'DocumentSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// User Selector Filter
		// if we have a user already (we always should...), make them sticky on the top of the list
		const tmpUser = this.AppData?.CurrentUser?.UserID ? { id: this.AppData?.CurrentUser?.UserID, text: this.AppData?.CurrentUser?.NameFirst + ' ' + this.AppData?.CurrentUser?.NameLast } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpUser ? ' has-sticky-option' : ''),
			placeholder: 'Search by users...',
			ElementID: 'DocumentSearch-Users',
			ParentID: 'DocumentSearch-SearchEntry',
			URL: 'Users',
			IDField: 'IDUser',
			TextField: 'NameFirst',
			StickyOption: tmpUser,
			minimumInputLength: 0,
			formatMethod: (pResults) =>
			{
				return pResults.map((pResult) =>
				{
					return {
						IDUser: pResult.IDUser,
						NameFirst: `${pResult.NameFirst} ${pResult.NameLast}`,
					};
				});
			},
		}, () =>
		{
			this.log.info('Select2 Users initialized');
		});

		// START DATE date picker
		window.flatpickr('#DocumentSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				const siblingElement = document.getElementById('DocumentSearch-EndDate');
				siblingElement['_flatpickr'].config.minDate = dateStr ? dateStr : null;
				siblingElement['_flatpickr'].redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#DocumentSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				const siblingElement = document.getElementById('DocumentSearch-StartDate');
				siblingElement['_flatpickr'].config.maxDate = dateStr ? dateStr : null;
				siblingElement['_flatpickr'].redraw();
			},
		});

		this.setCurrentSearchFilters();

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method performs a search based on the current search filters.
	 * @param {Event} event - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleDocumentSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#DocumentSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('DocumentSearch-Results-Container', this.CurrentSearchFilters.PageSize, '2.5rem');
		// collapse the filter panel to get out the way of the results
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters', 'close');
		// perform the search
		const tmpSearchResults = await this.pict.providers.DocumentProvider.performDocumentSearch(this.CurrentSearchFilters);
		// update the search results/UI based on the search results and total search count passed in
		this.updateWithSearchResults(tmpSearchResults.results, tmpSearchResults.count);
	}

	/**
	 * This function is used to handle the selection of a Document from the search results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDDocument - The ID of the Document that was selected
	 * @param {object} pContext - The context of the Document that was selected
	 * @return {void}
	 */
	handleDocumentSelection(event, pIDDocument, pContext)
	{
		if (!pIDDocument)
		{
			this.log.error('No IDDocument provided');
			return;
		}
		// figure out the context of the selection
		switch (pContext)
		{
		case 'Add':
			if (this.pict.views.DocumentSearch.DocumentSelectionCallback)
			{
				if (this.pict.views.DocumentSearch.CurrentSearchResults.length > 0)
				{
					const tmpDocument = this.pict.views.DocumentSearch.CurrentSearchResults.find((pDocument) => pDocument.IDDocument == pIDDocument);
					this.pict.views.DocumentSearch.documentSelectionCallback(tmpDocument);
					this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'close');
				}
			}
			break;
		case 'Details':
			this.pict.views.DocumentDetails.showDocumentDetailView(null, pIDDocument);
			break;
		case 'Add-With-Intent':
			this.pict.views.HeadlightPaneDocuments.Intent.handler(pIDDocument);
			break;
		case 'Inspection-Add':
			if (this.pict.AppData?.CurrentInspection?.IDInspection && pIDDocument)
			{
				this.pict.BridgeDocumentManager.addDocumentToInspection(pIDDocument, this.pict.AppData.CurrentInspection.IDInspection)
					.then((pResult) =>
					{
						// auto-add document to Dossier before switching back to Inspection view
						this.log.debug('auto-adding document to dossier as part of adding document to inspection');
						return this.pict.BridgeDocumentManager.includeDocumentInInspectionDossier(Number(pIDDocument), this.pict.AppData.CurrentInspection.IDInspection, true)
						.catch((pError) =>
						{
							this.log.error(`Error auto-adding document to dossier`, pError);
							this.pict.views.HeadlightPanels?.toast?.({
								message: `Error updating inspection dossier as part of adding document to inspection`,
								type: 'is-danger',
							});
						});
					})
					.then((pResult) =>
					{
						this.pict.views.Inspection.invalidate();
						// show a success message
						this.pict.views.HeadlightPanels.toast({
							message: 'The document has been added to the inspection.',
							type: 'is-success',
						});
						// TODO: understand why this doesn't for updating the popover from add/goto right after the initial add
						// update this currentSearchResults to reflect the document is now in the inspection
						const tmpDocument = this.pict.views.DocumentSearch.CurrentSearchResults.find((pDocument) => pDocument.IDDocument == pIDDocument);
						if (tmpDocument)
						{
							tmpDocument._InCurrentInspection = true;
							// re-render the search results to reflect the change
							this.pict.views.DocumentSearch.updateWithSearchResults(this.pict.views.DocumentSearch.CurrentSearchResults, this.pict.views.DocumentSearch.CurrentSearchFilters.TotalCount);
						}
					})
					.catch((pError) =>
					{
						this.log.error('Error adding document to inspection: ', pError);
						this.pict.views.HeadlightPanels?.toast?.({
							message: `<strong>Error adding document to inspection.</strong>`,
							type: 'is-danger',
						});
					});
			}
			else
			{
				this.pict.views.HeadlightPanels.handlePanelToggle('Inspection');
				this.setMode('none');
			}
			break;
		case 'Inspection-GoTo':
			// clear add mode so we don't accidentally add the document to the inspection again
			this.setMode('none');
			// TODO: pass the highlighted document to the inspection view so we scroll/highlight it
			this.pict.views.HeadlightPanels.handlePanelToggle('Inspection', 'open', () =>
			{
				// try to highlight the document in the inspection view
				this.pict.providers.UtilityProvider.highlightListItemRowElement('#DocumentRow_' + pIDDocument, '.nested-scroll-content');
			});
			break;
		default:
			this.log.error('Unknown context for handleDocumentSelection()!', { pContext });
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.DocumentSearch.CurrentSearchFilters[pOptions.URL] || [];
					let formattedData = [];
					// if we have a custom format method, use it
					if (data && data.length > 0)
					{
						formattedData = pOptions.formatMethod ? pOptions.formatMethod(data) : data;
					}

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(formattedData, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.DocumentSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.DocumentSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.DocumentSearch.handleDocumentSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.DocumentSearch.handleDocumentSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], Materials: [5678]})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('DocumentSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#DocumentSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setDocumentSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setDocumentSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.DocumentSearchResultsCallback = pCallback;
	}


	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Projects');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#DocumentSearch-Projects');
			break;
		case 'User':
		case 'Users':
			this.CurrentSearchFilters.Users = this.pict.ContentAssignment.readContent('#DocumentSearch-Users');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#DocumentSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#DocumentSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#DocumentSearch-SearchText');
			break;
		case 'Status':
			this.CurrentSearchFilters.Status = this.pict.ContentAssignment.readContent('#DocumentSearch-Status');
			break;
		case 'SortBy':
			const tempSortBy = this.pict.ContentAssignment.readContent('#DocumentSearch-SortBy');
			if (typeof tempSortBy === 'string' && tempSortBy != null)
			{
				this.CurrentSearchFilters.SortBy = tempSortBy.split('_')[0];
				this.CurrentSearchFilters.SortDirection = tempSortBy.split('_')[1];
			}
			else
			{
				this.CurrentSearchFilters.SortBy = 'DocumentDate';
				this.CurrentSearchFilters.SortDirection = 'DESC';
			}
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {Promise<void>}
	 */
	async updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// if the mode is 'add-to-inspection', we need to look up if the documents are already in the inspection
		if (this.mode === 'add-to-inspection')
		{
			// if we have an inspection, check if the documents are already in the inspection
			if (this.pict.AppData?.CurrentInspection?.IDInspection)
			{
				await this.pict.BridgeDocumentManager.getListOfCurrentInspectionIDDocuments(this.pict.AppData.CurrentInspection.IDInspection)
					.then((pInspectionDocuments) =>
					{
						// loop through the search results and mark the documents that are already in the inspection
						this.CurrentSearchResults.forEach((pDocument) =>
						{
							// if the document is in the inspection, mark it as such
							if (pInspectionDocuments.find((pInspectionDocument) => pInspectionDocument == pDocument.IDDocument))
							{
								pDocument._InCurrentInspection = true;
							}
							else
							{
								pDocument._InCurrentInspection = false;
							}
						});
					})
					.catch((pError) =>
					{
						this.log.error('Error getting inspection documents for add-to-inspection mode', pError);
					});
			}
			else
			{
				this.log.warn('No current inspection found for add-to-inspection mode, skipping inspection document check.');
			}
		}
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Results', '#DocumentSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#DocumentSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Pagination', '#DocumentSearch-Pagination-Container', false, false, () =>
			{
				this.log.info('Document Search Pagination rendered');
			});
			// if there is a callback function, call it
			if (this.documentSearchResultsCallback)
			{
				this.documentSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}

	/**
	 * This method handles the action popover for the observation search results.
	 * @param {string} pElementId - The ID of the element to attach the popover to.
	 * @param {number} IDDocument - The ID of the document.
	 */
	handleActionPopover(pElementId, IDDocument)
	{
		const tmpMenuElement = document.getElementById(pElementId);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${pElementId} not found for Observation search rults action popover.`);
			return;
		}
		// create the popover menu
		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'DocumentSearch-Results-Popover-Menu',
			PopoverTemplateRecord:
			{
				IDDocument: IDDocument,
				InCurrentInspection: this.CurrentSearchResults.find((pDocument) => pDocument.IDDocument == IDDocument)?._InCurrentInspection || false,
			},
			theme: 'dropdown-dark',
		});
	}
}

module.exports = DocumentSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentSearch',
	DefaultRenderable: 'DocumentSearch-Entry',
	DefaultDestinationAddress: '#DocumentSearch-Entry-Container',
	CSS: /*css*/`
		.mode_add-to-inspection {
			display: none;
		}
		.visible-mode_add-to-inspection .mode_add-to-inspection {
			display: block;
		}
		.mode_add-with-intent {
			display: none;
		}
		.visible-mode_add-with-intent .mode_add-with-intent {
			display: block;
		}
		`,
	Templates:
		[
			{
				Hash: 'DocumentSearch-Entry',
				Template: /*html*/`
				<div id="DocumentSearch-SearchEntry" class="container">
					<form autocomplete="off" role="Document-search" onsubmit="_Pict.views.DocumentSearch.handleDocumentSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="DocumentSearchFilters">
							<div class="columns mb-0 is-hidden">
								{~T:DocumentSearch-Entry-CurrentPage~}
								{~T:DocumentSearch-Entry-PageSize~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-SearchText~}
								{~T:DocumentSearch-Entry-Status~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-UserSelector~}
								{~T:DocumentSearch-Entry-SortBy~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-StartDate~}
								{~T:DocumentSearch-Entry-EndDate~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="DocumentSearch-Pagination-Container" style="flex:auto"></div>
							<button 
								id="DocumentSearch-ToggleButton"
								type="button"
								title="Set filters"
								class="button is-primary is-soft" 
								data-collapsible-toggle="DocumentSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters')"
							>
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="DocumentSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:DocumentSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" id="DocumentSearch-ResetButton" title="Reset filters" onclick="_Pict.views.DocumentSearch.resetSearchFilters()">
								<i class="fas fa-fw fa-undo mr-1"></i> 
								Clear Filters
							</button>
							<button class="button is-primary" type="submit" id="DocumentSearch-SearchButton" title="Search documents">
								<i class="fas fa-fw fa-search mr-1"></i> 
								Search Documents
							</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'DocumentSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="DocumentSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('CurrentPage')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-PageSize" class="block">Page Size</label>
						<input 
							id="DocumentSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('PageSize')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field" style="margin-bottom: 10px;">
						<label class="label block" for="DocumentSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="DocumentSearch-Projects" 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('Projects')"
								multiple
							>{~TS:DocumentSearch-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Projects~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Enty-ProjectSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'DocumentSearch-Entry-UserSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="DocumentSearch-Users">Users</label>
						<div class="control select is-fullwidth">
							<select 
								id="DocumentSearch-Users" 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('Users')"
								multiple
							>{~TS:DocumentSearch-Entry-UserSelector-SelectedOptions:Context[0].CurrentSearchFilters.Users~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="DocumentSearch-SearchText" class="block">Text Search</label>
					<input 
						id="DocumentSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-Status',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="DocumentSearch-Status" class="block">Status</label>
					<input 
						id="DocumentSearch-Status"
						type="text"
						class="input" 
						placeholder="Enter a status to search"
						onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('Status')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Enty-UserSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDUser~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'DocumentSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="DocumentSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="DocumentSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="DocumentSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="DocumentDate_DESC">Document Date (Newest)</option>
								<option value="DocumentDate_ASC">Document Date (Oldest)</option>
								<option value="Status_ASC">Status (A-Z)</option>
								<option value="Status_DESC">Status (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Results',
				Template: /*html*/`
				<div id="DocumentSearch-Results-Container" class="container table-container">
					{~TIfAbs:DocumentSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:DocumentSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th style="min-width: 115px">Document Date</th>
							<th>Project</th>
							<th>Name</th>
							<th>User</th>
							<th class="has-text-centered">Status</th>
							<th class="has-text-centered is-vcentered">Actions</th>
						</tr>
					</thead>
					<tbody id="DocumentSearch-Results-Entries">
						{~TS:DocumentSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'DocumentSearch-Results-Row',
				Template: /*html*/`
				<tr>
					<td>{~DateFormat:Record.DocumentDate^YYYY-MM-DD~}</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-EntityValue-Project:Record:Record.IDProject^>^0~}
						{~TIfAbs:DocumentSearch-Results-EntityValue-NA:Record:Record.IDProject^<=^0~}
					</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:DocumentSearch-Results-DatumValue-NA:Record:Record.Name^<=^0~}
					</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-EntityValue-User:Record:Record.CreatingIDUser^>^0~}
						{~TIfAbs:DocumentSearch-Results-EntityValue-NA:Record:Record.CreatingIDUser^<=^0~}
					</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-DatumValue-Status:Record:Record.Status^>^0~}
						{~TIfAbs:DocumentSearch-Results-DatumValue-NA:Record:Record.Status^<=^0~}
					</td>
					<td class="has-text-centered is-vcentered" id="DocumentSearch-Results-Popover-TriggerButton-{~D:Record.IDDocument~}">
						{~T:DocumentSearch-Results-Popover-TriggerButton:Record~}
					</td>
				</tr>`,
			},
			{
				Hash: 'DocumentSearch-Results-Popover-TriggerButton',
				Template: /*html*/`
				<button 
					id="DocumentSearch-DetailsButton-{~D:Record.IDDocument~}"
					type="button" 
					class="button is-ghost has-text-primary-75 p-0" 
					title="Actions" 
					onclick="_Pict.views.DocumentSearch.handleActionPopover(id, '{~D:Record.IDDocument~}')"
					onmouseover="_Pict.views.DocumentSearch.handleActionPopover(id, '{~D:Record.IDDocument~}')">
					<span class="icon">
						<i class="fas fa-fw fa-lg fa-circle-ellipsis"></i>
					</span>
				</button>`,
			},
			{
				Hash: 'DocumentSearch-Results-Popover-Menu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.DocumentSearch.mode~}">
					<li class="list-menu-item mode_add-with-intent {~Hide:Record.InCurrentInspection~}">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Add-With-Intent');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-plus-circle"></i>
							</span>
							<span class="icon-text">Add</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-inspection {~Hide:Record.InCurrentInspection~}">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Inspection-Add');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-plus-circle"></i>
							</span>
							<span class="icon-text">Add to Inspection</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-inspection {~Show:Record.InCurrentInspection~}">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Inspection-GoTo');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-building-magnifying-glass"></i>
							</span>
							<span class="icon-text">Go to Inspection</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Details');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-memo"></i>
							</span>
							<span class="icon-text">View Details</span>
						</a>
					</li>
				</ul>
				`,
			},
			{
				Hash: 'DocumentSearch-Results-EntityValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'DocumentSearch-Results-DatumValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'DocumentSearch-Results-EntityValue-Project',
				Template: /*html*/`{~Entity:Project^Record.IDProject^DocumentSearch-Results-Project^~}`,
			},
			{
				Hash: 'DocumentSearch-Results-EntityValue-User',
				Template: /*html*/`{~Entity:User^Record.CreatingIDUser^DocumentSearch-Results-User^~}`,
			},
			{
				Hash: 'DocumentSearch-Results-DatumValue-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentSearch-Results-DatumValue-Status',
				Template: /*html*/`{~DocumentState:Record~}`,
			},
			{
				Hash: 'DocumentSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any Documents based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'DocumentSearch-Pagination',
				Template: /*html*/`
				<nav id="DocumentSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="DocumentSearch-PreviousButton" type="button" class="button is-soft mr-2" title="Previous page" onclick="_Pict.views.DocumentSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="DocumentSearch-NextButton" type="button" class="button is-soft" title="Next page" onclick="_Pict.views.DocumentSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'DocumentSearch-Entry',
				TemplateHash: 'DocumentSearch-Entry',
				DestinationAddress: '#DocumentSearch-Entry-Container',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-ProjectSelector',
				TemplateHash: 'DocumentSearch-Entry-ProjectSelector',
				DestinationAddress: '#DocumentSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-MaterialSelector',
				TemplateHash: 'DocumentSearch-Entry-MaterialSelector',
				DestinationAddress: '#DocumentSearch-Entry-MaterialSelector',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-MixDesignSelector',
				TemplateHash: 'DocumentSearch-Entry-MixDesignSelector',
				DestinationAddress: '#DocumentSearch-Entry-MixDesignSelector',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-ActiveFilterCount',
				TemplateHash: 'DocumentSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#DocumentSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'DocumentSearch-Results',
				TemplateHash: 'DocumentSearch-Results',
				DestinationAddress: '#DocumentSearch-Results-Container',
			},
			{
				RenderableHash: 'DocumentSearch-Pagination',
				TemplateHash: 'DocumentSearch-Pagination',
				DestinationAddress: '#DocumentSearch-Pagination-Container',
			},
			{
				RenderableHash: 'DocumentSearch-Results-Popover-TriggerButton',
				TemplateHash: 'DocumentSearch-Results-Popover-TriggerButton',
				DestinationAddress: '#DocumentSearch-Results-Popover-TriggerButton-{~D:Record.IDDocument~}',
			},
		],
};

},{"pict-view":693}],784:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-BridgesPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */
/** @typedef {(bridge: any) => void} BridgeSelectionCallback */

class HeadlightPaneBridges extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.dataLakeBridgeClient = this.fable.instantiateServiceProvider('RestClient', 'LakeBridgeClient');

		this.CurrentBridgeSearchResults = [];
		this.CurrentSearchFiltersCount = 0;
		this.StateAbbreviation = '';
		/**
		 * @type {BridgeSelectionCallback}
		 * @param {any} bridge
		 */
		this.bridgeSelectionCallback = (bridge) =>
		{
			// optional callback function to run when a bridge is selected
		};

		this.currentStart = 0;
		this.pageSize = 100;
	}

	/**
	 * This function is used to handle the search for bridges.
	 * @param {Event} event - The event that triggered the search
	 * @return {boolean} - Always returns false
	 */
	handleBridgeSearch(event)
	{
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#BridgeSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('BridgePanel-SearchResults-Container', this.pageSize, '2rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('BridgeSearchFilters', 'close');

		const tmpCounty = String(this.pict.ContentAssignment.readContent('#BridgesSearchCounty'));

		if (tmpCounty.trim().length > 0)
		{
			this.CountySearch = tmpCounty.trim();
		}
		else
		{
			this.CountySearch = false;
		}

		const tmpStructureNumber = String(this.pict.ContentAssignment.readContent('#BridgesSearchStructureNumber'));

		if (tmpStructureNumber.trim().length > 0)
		{
			this.StructureSearch = tmpStructureNumber.trim();
		}
		else
		{
			this.StructureSearch = false;
		}

		const tmpFacilityCarried = String(this.pict.ContentAssignment.readContent('#BridgesSearchFacilityCarried'));

		if (tmpFacilityCarried.trim().length > 0)
		{
			this.FacilityCarriedSearch = tmpFacilityCarried.trim();
		}
		else
		{
			this.FacilityCarriedSearch = false;
		}

		const tmpFeatureIntersected = String(this.pict.ContentAssignment.readContent('#BridgesSearchFeatureIntersected'));

		if (tmpFeatureIntersected.trim().length > 0)
		{
			this.FeatureIntersectedSearch = tmpFeatureIntersected.trim();
		}
		else
		{
			this.FeatureIntersectedSearch = false;
		}

		const tmpYearBuilt = String(this.pict.ContentAssignment.readContent('#BridgesSearchYearBuilt'));

		if (tmpYearBuilt.trim().length > 0)
		{
			this.YearBuiltSearch = tmpYearBuilt.trim();
		}
		else
		{
			this.YearBuiltSearch = false;
		}

		this.currentStart = 0;

		this.loadBridgeData();
		return false;
	}

	/**
	 * This function is used to load the bridges from the lake.
	 * @return {void}
	 */
	loadBridgeData()
	{
		// get the state filter for the user
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.AppData?.CurrentUser?.CustomerID,
		(pResult) =>
		{
			// set the state abbreviation for the user (if it exists)
			this.StateAbbreviation = pResult?.StateAbbreviation;
			// set the search filters to pass to the provider
			const tmpFilters = {
				County: this.CountySearch,
				StructureNumber: this.StructureSearch,
				FacilityCarried: this.FacilityCarriedSearch,
				FeatureIntersected: this.FeatureIntersectedSearch,
				YearBuilt: this.YearBuiltSearch,
				Start: this.currentStart,
				PageSize: this.pageSize,
				StateAbbreviation: this.StateAbbreviation,
			};
			// perform the search
			this.pict.providers.BridgeProvider.performBridgeSearch(tmpFilters, (pError, pBridgeResults) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error rendering HeadlightPanels-Bridges-SearchResults: ${pError}`);
					this.pict.views.HeadlightPanels?.toast?.({
						message: `<strong>Error loading bridge search results:</strong><br/><em>${pError.message || pError}</em>`,
						type: 'is-danger',
					});
					return;
				}
				this.CurrentBridgeSearchResults = pBridgeResults;
				this.pict.views.HeadlightPaneBridges.renderAsync('HeadlightPanels-Bridges-SearchResults', '#BridgePanel-SearchResults-Container', null, null,
					(pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error rendering HeadlightPanels-Bridges-SearchResults: ${pError}`);
						}
						document.getElementById('BridgeSearch-SearchButton')?.classList?.remove('is-loading');
					});
			});
		});
	}

	/**
	 * This function is used to reset the search filters and reload the bridges from the lake.
	 * @return {boolean} - Always returns
	 */
	resetSearchFilters()
	{
		document.getElementById('BridgeSearch-SearchButton')?.classList?.add('is-loading');

		this.pict.ContentAssignment.assignContent('#BridgesSearchStructureNumber', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchFacilityCarried', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchYearBuilt', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchFeatureIntersected', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchCounty', '');

		this.StructureSearch = false;
		this.FacilityCarriedSearch = false;
		this.YearBuiltSearch = false;
		this.FeatureIntersectedSearch = false;
		this.CountySearch = false;

		this.currentStart = 0;

		this.loadBridgeData();

		return false;
	}

	/**
	 * This function is used to handle the selection of a bridge from the search results.
	 * @param {string} pIDBridge - The ID of the bridge that was selected
	 * @return {void}
	 */
	handleBridgeSelection(pIDBridge)
	{
		if (this.bridgeSelectionCallback)
		{
			if (this.CurrentBridgeSearchResults.length > 0)
			{
				const tmpBridge = this.CurrentBridgeSearchResults.find((pBridge) => pBridge.IDBridge == pIDBridge);
				this.bridgeSelectionCallback(tmpBridge);
				this.pict.views.HeadlightPanels.handlePanelToggle('Bridges', 'close');
			}
		}
	}

	/**
	 * This function is used to set the callback that is run when a bridge is selected from the search results.
	 * @param {BridgeSelectionCallback} fCallback - The callback function to run when a bridge is selected
	 * @return {void}
	 */
	setBridgeSelectionCallback(fCallback)
	{
		this.bridgeSelectionCallback = fCallback;
	}

	/**
	 * This function is used to handle the opening of the bridge panel from the advanced button.
	 * @param {Event} event - The event that triggered the opening of the bridge panel
	 */
	openBridgePanelFromAdvancedButton(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			event.preventDefault();
			// find the parent column of the advanced button
			const tmpParentColumn = event.target.closest('.column');
			// if the parent column exists
			if (tmpParentColumn)
			{
				this.fable.HeadlightPanels.applyUIHighlight(tmpParentColumn);
			}
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Bridges', 'open', () =>
		{
			this.pict.ContentAssignment.setAttribute('#HeadlightPanels-BridgesPanel', 'data-panel-mode', 'add-to-set');
		});
	}
}

module.exports = HeadlightPaneBridges;
// additional view-specific templates
const viewSpecificTemplates = [
	/* Bridge Search Templates - overrides to the default views */
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults',
		Template: /*html*/`
		<div id="HeadlightPanels-Bridges-SearchResults" class="container table-container">
			<table class="table is-striped is-hoverable is-fullwidth">
				<thead>
					<tr>
						<th>County</th>
						<th>Facility Carried</th>
						<th>Feature Intersected</th>
						<th class="has-text-right">Structure #</th>
						<th class="has-text-right">Year Built</th>
						{~T:HeadlightPanels-Bridges-SearchResults-Extra-Header~}
						{~T:HeadlightPanels-Bridges-SearchResults-Selection-Header~}
					</tr>
				</thead>
				<tbody id="HeadlightPanels-Bridges-ResultsEntries">
					{~TS:HeadlightPanels-Bridges-SearchResults-Row:Context[0].CurrentBridgeSearchResults~}
					{~TIfAbs:HeadlightPanels-Bridges-SearchResults-NoResults:Context[0]:Context[0].CurrentBridgeSearchResults.length^==^0~}
				</tbody>
			</table>
		</div>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Row',
		Template: /*html*/`
		<tr>
			<td>{~E:FIPSCounty^Record.IDFIPSCounty^HeadlightPanels-Bridges-SearchResults-County-Row-Cell~}</td>
			<td>{~D:Record.FacilityCarried~}</td>
			<td>{~D:Record.FeatureIntersected~}</td>
			<td class="has-text-right">{~D:Record.StructureNumber~}</td>
			<td class="has-text-right">{~D:Record.YearBuilt~}</td>
			{~T:HeadlightPanels-Bridges-SearchResults-Extra-Column:Record~}
			{~T:HeadlightPanels-Bridges-SearchResults-Selection-Column:Record~}
		</tr>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-NoResults',
		Template: /*html*/`
		<tr>
			<td colspan="5" class="has-text-centered">
				<span class="icon">
					<i class="fa fa-fw fa-info-circle"></i>
				</span>
				<span class="icon-text">No results found</span>
			</td>
		</tr>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-County-Row-Cell',
		Template: /*html*/`{~D:Record.Name~} {~D:Record.GUIDFIPSCounty~}`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Selection-Header',
		Template: /*html*/`<th class="has-text-centered" data-panel-mode-show-if="add-to-set">Select</th>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Selection-Column',
		Template: /*html*/`
		<td class="has-text-centered is-vcentered" data-panel-mode-show-if="add-to-set">
			<button type="button" class="button p-0 is-ghost has-text-primary-75" onclick="_Pict.views.HeadlightPaneBridges.handleBridgeSelection('{~D:Record.IDBridge~}')">
				<span class="icon">
					<i class="fa fa-fw fa-lg fa-plus-circle"></i>
				</span>
			</button>
		</td>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Extra-Header',
		Template: /*html*/``, // This is intentionally blank
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Extra-Column',
		Template: /*html*/``, // This is intentionally blank
	},
	{
		Hash: 'HeadlightPanels-Bridges-ActiveFilterCount',
		Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
	},
];
// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];

const viewSpecificRenderables =
[
	{
		RenderableHash: 'HeadlightPanels-Bridges-SearchResults',
		TemplateHash: 'HeadlightPanels-Bridges-SearchResults',
		DestinationAddress: '#BridgePanel-SearchResults-Container',
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Renderables = [ ..._ViewConfiguration.Renderables, ...viewSpecificRenderables ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],785:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-CustomPaneHtml-View'];

class HeadlightPaneCustom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = HeadlightPaneCustom;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],786:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-DocumentsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */
/** @typedef {(bridge: any) => void} BridgeSelectionCallback */

class HeadlightPaneDocuments extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.Intent = { type: 'none', handler: () =>
		{} };
	}

	closeHandler()
	{
		console.log('[HeadlightPaneDocuments] Documents panel closed.');
		// Reset the intent on close.
		this.resetIntent();
		this.pict.views.DocumentSearch.setMode('none');
	}

	resetIntent()
	{
		this.Intent = { type: 'none', handler: () =>
		{} };
	}

	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(pCallback)
	{
		// set the callback that runs when the search results are returned
		this.pict.views.DocumentSearch.setDocumentSearchResultsCallback((pResults) =>
		{
			// collapse the filter panel
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters', 'close');
			// render the pagination controls
			this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Results', '#DocumentSearch-Results-Container', false, () =>
			{
				// TODO: is this the proper location for this? Should we be using the Entity object?
				const tmpDocuments = this.AppData?.DocumentData;
				if (tmpDocuments)
				{
					// for each Document, if the Document is already included, toggle the button to "on"
					pResults.forEach((pResult) =>
					{
						if (tmpDocuments.find((obs) => obs.IDDocument === pResult.IDDocument))
						{
							document.querySelector(`[data-document-add-context="${pResult.IDDocument}"]`)?.classList?.add('is-active');
						}
					});
				}
			});
		});
		// set the default search filter options for the Document search view
		this.pict.views.DocumentSearch.setCurrentSearchFilters({
			PageSize: 30,
		});
		// render each tab's view; a failure in one must not strand the others
		this.renderTabView('DocumentSearch');
		this.renderTabView('DocumentCreate');
		this.renderTabView('DocumentCurrent');

		if (!this.pict.AppData.DocumentData?.ReportData?.IDDocument)
		{
			const currentTab = document.getElementById('HeadlightPanels-DocumentPanel-Current-Tab');
			if (currentTab)
			{
				currentTab.classList.add('is-hidden');
			}
		}

		// the panel opens in this callback, so we need to wait for it to open before we can build the included Documents list
		if (pCallback)
		{
			pCallback();
		}
	}
}

module.exports = HeadlightPaneDocuments;
// additional view-specific templates
const viewSpecificTemplates = [
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],787:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-NavigationPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneNavigation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// local copy of the navigation list objects
		this.navigationList = [];
		// local copy of the custom navigation list objects
		this.customNavigationList = [];
		// handle the href vs onclick for custom navigation items
		this.pict.MetaTemplate.addPattern('{~CustomNavItemHandler:', '~}', (pHash, pData, fCallback) =>
		{
			// if the url is set, use that as the href
			if (pData && pData.href)
			{
				return `href="${pData.href}" onclick="_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'close');"`; // close the navigation panel after clicking
			}
			// if the navigationHandler is set, use that as the onclick handler
			else if (pData && pData.navigationHandler)
			{
				return `onclick="_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'close', ()=>{${pData.navigationHandler}});"`;
			}
			// otherwise, use the default onclick handler to toggle a panel
			else
			{
				return `onclick="_Pict.views.HeadlightPanels.handlePanelToggle('${pData.name}');"`;
			}
		});
	}

	compileNavigation()
	{
		if (this.pict.settings.HeadlightPanels.Configuration.CustomNavigationList)
		{
			this.compileCustomNavigationList();
		}
		else if (this.pict.settings.HeadlightPanels.Configuration.NavigationList)
		{
			this.compileNavigationList();
		}
		else
		{
			this.pict.log.error('No NavigationList or CustomNavigationList found in the configuration, skipping Navigation panel');
			return;
		}
	}

	/**
	 * Compile the navigation list based on the configuration that has been passed in at the start with
	 * the NavigationList property via the HeadlightPanels.Configuration object
	 * @return {void}
	 */
	compileNavigationList()
	{
		// if the navigation list is already populated, skip processing it again (creating duplicates, etc)
		if (this.navigationList.length)
		{
			return;
		}
		// get the navigation list
		const tempNavList = this.pict.settings.HeadlightPanels.Configuration.NavigationList;

		if (!tempNavList || tempNavList.length === 0)
		{
			this.pict.log.error('No NavigationList found in the configuration, skipping Navigation panel');
			return;
		}

		for (let i = 0; i < tempNavList.length; i++)
		{
			// for each item in the list, look up if there's a corresponding panel and add it to the list
			const tempPanel = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((p) => p.name === tempNavList[i].toLowerCase());
			if (tempPanel)
			{
				this.navigationList.push(tempPanel);
			}
			// if the item is a special case, add it to the list
			// TODO: We should expand this to be more dynamic when we find other special cases we want to add
			else if (tempNavList[i] === 'DownloadDocument')
			{
				this.navigationList.push({
					displayName: 'Download PDF',
					iconClass: 'fa-file-pdf',
					hideOniOS: true,
					navigationHandler: '_Pict.views.HeadlightPaneNavigation.handleDocumentDownload(event)',
				});
			}
			else if (tempNavList[i] === 'CloneDataToNewForm')
			{
				this.navigationList.push({
					displayName: 'Clone Data to New Form',
					iconClass: 'fa-copy',
					navigationHandler: '_Pict.views.DocumentCurrent.cloneDataFromForm()',
				});
			}
			else
			{
				this.pict.log.warn(`Panel ${tempNavList[i]} not found in the PanelList, skipping Navigation item`);
			}
		}
		// Secret panel for users with role index 4 or higher
		if (this.pict.AppData?.CurrentUser?.UserRoleIndex >= 4)
		{
			this.pict.log.info('User role allows for custom navigation list, checking for CustomNavigationList');
			this.navigationList.push({
				'location': 'right',
				'name': 'secret',
				'displayName': 'Secrets',
				'iconClass': 'fa-person-to-portal',
				'view': 'HeadlightPaneSecret',
			});
		}

		this.renderAsync(() =>
		{
			this.pict.log.info('Custom panel configuration set. Re-rendering the panels.');
		});
	}

	compileCustomNavigationList()
	{
		// if the navigation list is already populated, skip processing it again (creating duplicates, etc)
		if (this.customNavigationList.length)
		{
			return;
		}

		this.customNavigationList = this.pict.settings.HeadlightPanels.Configuration.CustomNavigationList || [];

		/* Example of a custom navigation list items
		...,
		{
			Hash: 'Locations',
			Name: 'Locations Of Interest',
			Icon: 'fas fa-location-dot',
			Address: '#/Location/List',
			PanelSource: null
		},
		{
			Hash: 'Settings',
			Name: 'Settings',
			Icon: 'fas fa-cog',
			Address: null,
			PanelSource: 'HeadlightPanels-Settings',
		}
		...,
		*/

		const tmpNavList = [];
		for (let i = 0; i < this.customNavigationList.length; i++)
		{
			// for each item in the list, look up if there's a corresponding panel and add it to the list
			if (this.customNavigationList[i].PanelSource)
			{
				const tmpPanel = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((p) => p.name === this.customNavigationList[i].PanelSource.toLowerCase());
				if (tmpPanel)
				{
					tmpNavList.push(tmpPanel);
				}
				else
				{
					this.pict.log.warn(`Panel ${this.customNavigationList[i].PanelSource} not found in the PanelList, skipping Navigation item`);
				}
			}
			// use the configuration passed in to the custom navigation list
			else
			{
				tmpNavList.push({
					name: this.customNavigationList[i].Hash.toLowerCase(),
					displayName: this.customNavigationList[i].Name || 'Custom Panel',
					iconClass: this.customNavigationList[i].Icon || 'fas fa-wrench',
					href: this.customNavigationList[i].Address || null,
					navigationHandler: this.customNavigationList[i].NavigationHandler || null,
					hideOniOS: this.customNavigationList[i].HideOniOS || false,
				});
			}
		}
		// finally, we just replace the navigationList with the custom navigation list and render it
		// TODO: Do this better, this is a bit of a hack bc I don't want to change the templates right now to avoid regressions
		this.navigationList = tmpNavList;

		// Secret panel for users with role index 4 or higher
		if (this.pict.AppData?.CurrentUser?.UserRoleIndex >= 4)
		{
			this.pict.log.info('User role allows for custom navigation list, checking for CustomNavigationList');
			this.navigationList.push({
				'location': 'right',
				'name': 'secret',
				'displayName': 'Secrets',
				'iconClass': 'fa-person-to-portal',
				'view': 'HeadlightPaneSecret',
			});
		}
		this.renderAsync(() =>
		{
			this.pict.log.info('Custom panel configuration set. Re-rendering the panels.');
		});
	}

	/**
	 * Handle the download of the document
	 * @param {Event} event - The event object
	 * @return {void}
	 */
	async handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading', 'is-dark', 'button');

			// The server re-renders the PDF from the SERVER-PERSISTED FormData,
			// so flush any unsaved in-memory form state first or the download is
			// stale — same root cause as the form-conversion export (PD-8714).
			// Locked documents are read-only and have nothing to save.
			const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
			if (tmpReportData && !tmpReportData.Locked)
			{
				const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync(true);
				if (tmpSaveError)
				{
					this.pict.log.error('Failed to save document before download; the downloaded PDF may be out of date.', tmpSaveError);
					this.pict.views.HeadlightPanels.toast({
						message: 'Could not save the latest changes — the downloaded PDF may be out of date.',
						type: 'is-warning',
					});
				}
			}

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, null, () =>
			{
				element.classList.remove('is-loading', 'is-dark', 'button');
			});
		}
	}

	handleInspectionPanelToggle(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading', 'is-dark', 'button');

			// download the pdf
			this.pict.views.HeadlightPanels.handlePanelToggle('Inspection', 'toggle', () =>
			{
				element.classList.remove('is-loading', 'is-dark', 'button');
			});
		}
	}

	/**
	 * Toggle the download dropdown menu using HeadlightModal.
	 * Loads form conversion options on first open.
	 * @param {Event} pEvent - The click event from the download button
	 * @return {void}
	 */
	async toggleDownloadDropdown(pEvent)
	{
		// If the menu is already open, toggle it closed.
		if (this._downloadMenuOpen)
		{
			this.fable.HeadlightModal.dismissAnchoredMenu();
			this._downloadMenuOpen = false;
			return;
		}

		// Show loading state on the button while fetching schemas
		const tmpButton = document.getElementById('HeadlightPanels-NavBar-Download-Button');
		if (!this._FormConversionSchemasLoaded && tmpButton)
		{
			tmpButton.classList.add('is-loading');
			try
			{
				await this._loadFormConversionSchemas();
			}
			finally
			{
				tmpButton.classList.remove('is-loading');
			}
		}

		// Build the menu items
		let tmpMenuItems = /*html*/`
			<a class="panel-block" onclick="_Pict.views.HeadlightPaneNavigation.handleDropdownPDFDownload(event)">
				<span class="panel-icon"><i class="fas fa-fw fa-file-pdf"></i></span>
				Download PDF
			</a>`;

		if (this._FormConversionSchemas && this._FormConversionSchemas.length > 0)
		{
			for (const tmpSchema of this._FormConversionSchemas)
			{
				const tmpTitle = tmpSchema.Title || ('Template ' + tmpSchema.IDManifestSchema);

				// Determine the file type icon from the template Artifact's mime type
				let tmpIconClass = 'fa-file-arrow-down';
				const tmpMime = tmpSchema.TemplateMimeType || '';
				if (tmpMime.includes('pdf'))
				{
					tmpIconClass = 'fa-file-pdf';
				}
				else if (tmpMime.includes('spreadsheet') || tmpMime.includes('excel') || tmpMime.includes('ms-excel'))
				{
					tmpIconClass = 'fa-file-excel';
				}

				tmpMenuItems += /*html*/`
					<a class="panel-block" onclick="_Pict.views.HeadlightPaneNavigation.handleFormConversionDownload(${tmpSchema.IDManifestSchema}, event)">
						<span class="panel-icon"><i class="fas fa-fw ${tmpIconClass}"></i></span>
						${tmpTitle}
					</a>`;
			}
		}

		// Anchor the menu to the download button. PSM's dropdown handles positioning,
		// auto-flip, viewport clamping, and outside-click / Escape dismissal — the anchor
		// is excluded from its outside-click test, so this button's onclick toggles cleanly.
		const tmpDownloadButton = document.getElementById('HeadlightPanels-NavBar-Download-Button');
		this._downloadMenuOpen = true;
		const tmpMenu = this.fable.HeadlightModal.spawnAnchoredMenu(
			tmpDownloadButton,
			/*html*/`<nav class="panel" style="background-color:var(--bulma-scheme-main);">${tmpMenuItems}</nav>`,
			{ position: 'above', align: 'left' });
		if (tmpMenu && typeof tmpMenu.then === 'function')
		{
			tmpMenu.then(() => { this._downloadMenuOpen = false; });
		}
	}

	/**
	 * Load form conversion schemas from the provider and cache them.
	 * @return {Promise<void>}
	 * @private
	 */
	async _loadFormConversionSchemas()
	{
		try
		{
			const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
			if (!tmpReportData || !tmpReportData.DocumentType || !tmpReportData.IDProject)
			{
				this._FormConversionSchemasLoaded = true;
				this._FormConversionSchemas = [];
				return;
			}

			this._FormConversionSchemas = await this.pict.providers.FormConversionProvider
				.getFormConversionSchemasForDocument(tmpReportData.DocumentType, tmpReportData.IDProject);

			this._FormConversionSchemasLoaded = true;
		}
		catch (pError)
		{
			this.pict.log.error('Error loading form conversion schemas for download dropdown:', pError);
			this._FormConversionSchemas = [];
			this._FormConversionSchemasLoaded = true;
		}
	}

	/**
	 * Handle downloading the standard PDF from the download modal.
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handleDropdownPDFDownload(pEvent)
	{
		this.fable.HeadlightModal.dismissModals();
		this.handleDocumentDownload(pEvent);
	}

	/**
	 * Handle downloading a filled form conversion template.
	 * @param {number} pIDManifestSchema - The ManifestSchema ID to fill
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	async handleFormConversionDownload(pIDManifestSchema, pEvent)
	{
		this.fable.HeadlightModal.dismissModals();

		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData || !tmpReportData.IDDocument)
		{
			this.pict.log.error('No document data available for form conversion download.');
			return;
		}

		this.pict.views.HeadlightPanels.toast({
			message: 'Generating filled template...',
			type: 'is-success',
		});

		// The fill-<IDManifestSchema> renderer fills the template from the
		// SERVER-PERSISTED FormData, not the in-memory form. If the user just
		// changed an input — e.g. a MaterialsEntitySelector whose dependent
		// fields are computed asynchronously after entity-bundle fetches — the
		// latest values may not have reached the server yet, so the exported
		// file would be stale (PD-8714). Flush the current form state with an
		// awaited save before downloading. Locked documents are read-only and
		// have nothing to save, so skip the save for them.
		if (!tmpReportData.Locked)
		{
			const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync(true);
			if (tmpSaveError)
			{
				this.pict.log.error('Failed to save document before form conversion download; the exported file may be out of date.', tmpSaveError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Could not save the latest changes — the exported file may be out of date.',
					type: 'is-warning',
				});
			}
		}

		// Create a download link using the fill-<IDManifestSchema> renderer.
		// The fill URL is otherwise byte-for-byte identical on every export, so
		// the browser (or any intermediate HTTP cache) can serve a previously
		// rendered, now-stale PDF even after the document has been re-saved with
		// new values (PD-8714). Append a unique cache-buster so each export is a
		// distinct request and the server re-fills from the latest saved
		// FormData. The extra query parameter is ignored by the renderer.
		const tmpCacheBuster = `${Date.now()}-${this.pict.getUUID()}`;
		const tmpDownloadLink = document.createElement('a');
		tmpDownloadLink.href = `/1.0/Document/${tmpReportData.IDDocument}/Load/fill-${pIDManifestSchema}?cachebuster=${tmpCacheBuster}`;
		tmpDownloadLink.classList.add('is-hidden');
		tmpDownloadLink.download = '';
		document.body.appendChild(tmpDownloadLink);
		tmpDownloadLink.click();
		document.body.removeChild(tmpDownloadLink);
	}
}

module.exports = HeadlightPaneNavigation;

// additional view-specific templates
const viewSpecificTemplates = [
	{
		// TODO: Make this path less brittle, need to understand local scoping variables to templates better
		Hash: 'HeadlightPanels-NavigationPanel-NavList',
		Template: /*html*/`{~TS:HeadlightPanels-NavigationPanel-NavItem:Context[0].navigationList~}`,
	},
	{
		Hash: 'HeadlightPanels-NavigationPanel-NavItem',
		Template: /*html*/`
		<a class="panel-block {~HideOniOS:Record.hideOniOS~}" {~CustomNavItemHandler:Record~}>
			<span class="panel-icon">
				<i class="fas fa-fw {~D:Record.iconClass~}" aria-hidden="true"></i>
			</span>
			{~D:Record.displayName~}
		</a>`,
	},
	// This is an example of a button that is not part of the navigation list that we want to add to the navigation panel
	{
		Hash: 'HeadlightPanels-NavigationPanel-ExtraButton',
		Template: /*html*/`
		<a class="panel-block is-hidden" onclick="_Pict.views.HeadlightPanels.handlePanelToggle('Secret')">
			<span class="panel-icon">
				<i class="fas fa-fw fa-person-to-portal" aria-hidden="true"></i>
			</span>
			Secrets
		</a>`,
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],788:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ObservationsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneObservations extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// the location to inject an observation into the DOM, if set
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.AddImageTargetDisplayName = '';
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object
	 */
	onBeforeRender(pRenderable)
	{
		this.pict.views.ObservationIncluded.buildIncludedObservationsList(false);

		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback to run after the view is rendered
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object
	 */
	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(fCallback, pRenderable)
	{
		super.onAfterRenderAsync((pError) =>
		{
			// set the callback that runs when the search results are returned
			this.pict.views.ObservationSearch.setObservationSearchResultsCallback((pResults) =>
			{
				// collapse the filter panel
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters', 'close');
				// render the pagination controls
				this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Results', '#ObservationSearch-Results-Container', false, false, () =>
				{
					this.log.info('Observation Search results rendered');
				});
			});
			// set the search filters for the observation search view
			this.pict.views.ObservationSearch.setCurrentSearchFilters({
				PageSize: 15,
			});
			// render each tab's view; a failure in one must not strand the others
			this.renderTabView('ObservationSearch');

			// set the instance configuration for the observation create media view, then render it
			try
			{
				this.pict.views.ObservationCreateMedia.setInstanceConfiguration({
					IDProject: this.AppData?.DocumentData?.ReportData?.IDProject || 0,
					IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0,
					IDDocument: this.AppData?.DocumentData?.ReportData?.IDDocument || 0,
				});
				this.pict.views.ObservationCreateMedia.render();
			}
			catch (pRenderError)
			{
				this.log.error(`Failed to render the ObservationCreateMedia tab: ${pRenderError?.message || pRenderError}`);
			}
			// render the set view
			this.renderTabView('ObservationSet');

			// the panel opens in this callback, so we need to wait for it to open before we can build the included observations list
			if (fCallback)
			{
				fCallback(pError);
			}
		}, pRenderable);
	}

	/**
	 * This function is used to clear the observation panel target and the banner on the header. The removes the "add mode" flow.
	 * @return {void}
	 */
	clearObservationPanelTarget()
	{
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.pict.views.HeadlightPanels.ModePanelLeft = '';
		this.pict.views.HeadlightPanels.ModePanelRight = '';
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', '');
		// hide the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = '';

		this.pict.views.ObservationSearch.setMode('');
	}

	/**
	 * This function is used to handle the selection of an observation detail view or adding an observation to the document.
	 * @param {object} event - The click event
	 * @param {number} pIDObservation - The ID of the observation to add to the document
	 * @param {string} pBackState - The state to return to when the observation detail view is closed
	 * @return {void}
	 */
	handleObservationImagePreviewClick(event, pIDObservation, pBackState)
	{
		this.showObservationDetailView(event, pIDObservation, pBackState);
	}

	/**
	 * This function is used to handle the selection of an observation detail view or adding an observation to the document.
	 * @param {object} event - The click event
	 * @param {number} pIDObservation - The ID of the observation to add to the document
	 */
	async handleObservationAddToProjectFileClick(event, pIDObservation)
	{
		// if in Add Mode, add the observation to project files
		if (document.getElementById('HeadlightPanels-ObservationPanel').getAttribute('data-panel-mode') !== 'add-to-folder')
		{
			this.pict.log.error('Observation Panel is not in "add" mode. Cannot add observation to project files.', { pIDObservation });
			return;
		}
		// and attach it to the project file folder
		await this.handleObservationListSelection(event, pIDObservation, 'add-to-folder');
		// then, re-render the view target
		//FIXME: this is "sharing" the callback with another view, seems like a bad idea
		// const tmpInjectionMethod = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onAfterCallback;
		// if (tmpInjectionMethod)
		// {
		// 	await tmpInjectionMethod([ { IDObservation: pIDObservation } ], event);
		// }
	}

	/**
	 * This function is used to remove an observation from a document.
	 * @param {number} pIDObservation - The observation id to remove from the document
	 * @return {Promise<boolean>}
	 */
	async addObservationToDocument(pIDObservation)
	{
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return false;
		}
		// check if the observation is already included in the document
		const includedObservation = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		if (includedObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is already included in the document.',
				type: 'is-warning',
			});
			return false;
		}
		// we should push the observation record to the document observation list for consistency (not just the ID)
		const tmpObservationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		if (!tmpObservationRecord)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is not found in the system.',
				type: 'is-danger',
			});
			return false;
		}
		// add the observation to the document
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations.concat(tmpObservationRecord);
		}
		else
		{
			this.AppData.DocumentData.ReportData.Observations = [ tmpObservationRecord ];
		}
		// show a success message
		this.pict.views.HeadlightPanels.toast({
			message: 'The observation has been added to the document.',
			type: 'is-success',
		});
		return true;
	}

	/**
	 * This function is used to remove an observation from a document.
	 * @param {number} pIDObservation - The observation id to remove from the document
	 * @return {boolean}
	 */
	removeObservationFromDocument(pIDObservation)
	{
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return false;
		}
		// check if the observation is already included in the document
		const includedObservation = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		if (!includedObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is not included in the document.',
				type: 'is-warning',
			});
			return false;
		}
		// remove the observation from the document
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations.filter((observation) => observation.IDObservation != pIDObservation);
		}
		else
		{
			this.AppData.DocumentData.ReportData.Observations = [];
		}
		// show a success message
		this.pict.views.HeadlightPanels.toast({
			message: 'The observation has been removed from the document.',
			type: 'is-success',
		});
		return true;
	}

	closeHandler()
	{
		// Clear any Add/QuickCapture buttons in ObservationCardDeck inputs that were left in an
		// `is-loading` state by an add flow the user has now dismissed (X, escape, background click,
		// or toggling a different panel). Without this, the button stays stuck because the flow's
		// onAfterCallback (which normally removes the class) only fires when the add completes.
		this.pict.providers?.ObservationCardDeckProvider?.clearPendingAddButtonLoadingState?.();
		this.pict.views.ObservationSearch.setMode('add-to-document');
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterDocumentJoinCallback = undefined;
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = undefined;
	}

	/**
	 * This function is used to handle the addition of an observation to a document.
	 * @param {Event} event - The click event
	 * @param {object} pIDObservation - The observation id to add to the document
	 * @param {string} pAction - The action to take (add or remove)
	 * @param {boolean} [pClosePanel=false] - Whether to close the panel after the action is completed
	 * @return {Promise<void>}
	 * @async
	 */
	async handleObservationListSelection(event, pIDObservation, pAction, pClosePanel = false)
	{
		// prevent the panels from closing
		if (event)
		{
			event.stopPropagation();
			event.preventDefault();
		}
		let observationRecord = this.pict.views.ObservationSearch.CurrentSearchResults?.find((/** @type {{ IDObservation: any; }} */ observation) => observation.IDObservation == pIDObservation);
		if (!observationRecord)
		{
			this.log.warn('Failed to find observation record from search results. Doing a look up for this record...', { pIDObservation });
			// if the observation is not found in the search results, try to get it from the provider
			observationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		}
		// check if the observation is already included in the document
		switch (pAction)
		{
		case 'add-to-document':
			await this.addObservationToDocument(observationRecord.IDObservation);
			// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the added observation
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'add', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
			}
			break;
		case 'add-to-folder':
		case 'add-to-root':
			await this.pict.views.ProjectFileSearch.addObservationToProjectFolderRecord(observationRecord);
			break;
		case 'add-to-set':
			// join to the document record
			if (this.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				// if record is not already in the document, add it
				const tmpObservations = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(observationRecord.IDObservation);
				if (!tmpObservations)
				{
					this.AppData.DocumentData.ReportData.Observations.push(observationRecord);
				}
				// add the observation to the active observation set entity (not just the document)
				if (this.pict.views.ObservationSet?.ActiveObservationSet)
				{
					await this.pict.views.ObservationSet.addObservationToSet(observationRecord.IDObservation);
					this.pict.views.HeadlightPanels.toast({
						message: `Observation added to ${this.pict.views.ObservationSet.ActiveObservationSet.Name || 'Observation Set'}.`,
						type: 'is-success',
					});
				}
				else
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'The observation has been added to the document.',
						type: 'is-success',
					});
				}
				// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the added observation
				if (this.pict.providers.ObservationCardDeckProvider)
				{
					await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'add', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Sets');
				}
			}
			break;
		case 'remove-from-set':
			// nothing to do here
			break;
		case 'remove-from-document':
			this.removeObservationFromDocument(observationRecord.IDObservation);
			// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the removed observation
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'remove', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
			}
			break;
		case 'remove-from-folder':
			this.pict.views.ProjectFileSearch.removeObservationFromProjectFolderRecord(observationRecord);
			break;
		default:
			this.log.warn('Invalid action for observation selection', { pAction });
			break;
		}
		// save the document now that the observation list is in order. handleSaveAsync resolves WITH the save
		// error (it does not reject), so inspect the returned value — a try/catch here would never fire.
		const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync();
		if (tmpSaveError)
		{
			this.pict.log.error('Failed to save document!', tmpSaveError);
			this.pict.views.HeadlightPanels.toast({
				message: 'Failed to save document!',
				type: 'is-danger',
			});
		}
		// rebuild the included observations list now that the document is saved
		this.pict.views.ObservationIncluded.buildIncludedObservationsList(true);

		// don't clear/close by default - the user may want to add more observations
		if (pClosePanel)
		{
			// finally, close the observation panel and clear the target
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
			// clear the observation panel target and the banner on the header
			this.pict.views.HeadlightPaneObservations.clearObservationPanelTarget();
		}
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();

		// gross
		this.hackyBridgeStuffToSeparateOutLater();
		// also gross
		this.handleMediaUploadCallbacks(event, pIDObservation, pAction);
	}

	// TODO: Relocate this asafp
	hackyBridgeStuffToSeparateOutLater()
	{
		// TODO: This logic should be abstracted away from here so that the panels don't need to know about the ElementConditions view.
		if (this.pict.views?.ElementConditions?.findAllOrphanObservations)
		{
			this.pict.views.ElementConditions.findAllOrphanObservations();
		}
	}

	// TODO: Relocate this asafp
	async handleMediaUploadCallbacks(event, pIDObservation, pAction)
	{
		// then, re-render the view target
		//FIXME: this is "sharing" the callback with another view, seems like a bad idea
		const tmpInjectionMethod = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onAfterCallback;
		if (tmpInjectionMethod)
		{
			await tmpInjectionMethod([ { IDObservation: pIDObservation } ], event);
		}
		// adding to the grossness
		const tmpFallbackCallback = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onFallbackCallback;
		if (pAction === 'add-to-document' && tmpFallbackCallback)
		{
			await tmpFallbackCallback([ { IDObservation: pIDObservation } ], event);
		}
	}

	/**
	 * This function is used to set the observation panel target and the banner on the header. This sets the "add mode" flow.
	 * @param {string} pViewHash - The hash of the view that the observation is being added to
	 * @param {string} pInputHash - The hash of the input that the observation is being added to
	 * @param {string} pInputName - The name of the input that the observation is being added to
	 * @param {string} [pMode] - The mode to set the observation panel to (add, remove, etc.)
	 * @return {void}
	 */
	setObservationPanelTarget(pViewHash, pInputHash, pInputName, pMode)
	{
		const tmpMode = pMode || 'add-to-set';
		this.AddImageTargetView = pViewHash;
		this.AddImageTargetInput = pInputHash;
		this.AddImageTargetDisplayName = pInputName;
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', `${tmpMode}`);
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = `${tmpMode}`;
		this.pict.views.HeadlightPanels.ModePanelRight = `${tmpMode}`;
		// set the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = pInputName;
		this.pict.views.ObservationSearch.setMode(pMode);
	}

	/**
	 * Open the observation detail view for the selected observation to view the full details
	 * @param {object} event - The click event
	 * @param {number|string} pIDObservation - The ID of the observation to view
	 * @param {string} pBackTo - The view to return to when the observation detail view is closed
	 * @param {function} [pCallback] - The callback to run after the observation detail view is rendered
	 * @return {Promise<void>}
	 * @async
	 */
	async showObservationDetailView(event, pIDObservation, pBackTo, pCallback)
	{
		// set the view to return to when the observation detail view is closed
		this.pict.views.ObservationDetails.ObservationDetailsBackTo = pBackTo;
		if (pBackTo && document.getElementById('HeadlightPanels-ObservationPanel').getAttribute('data-panel-mode') === 'add-to-set')
		{
			this.pict.views.ObservationDetails.ObservationDetailsBackToSet = true;
		}
		else
		{
			this.pict.views.ObservationDetails.ObservationDetailsBackToSet = false;
		}

		if (event)
		{
			event.currentTarget.classList.add('is-active');
		}
		await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation).then((pResult) =>
		{
			this.pict.views.ObservationDetails.ActiveObservationDetails = pResult;
		});
		// open the panel if it is not already open
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
		// render the observation detail view
		this.pict.views.ObservationDetails.renderAsync(false, false, false, false, () =>
		{
			this.log.info('Observation Details View Rendered with Active Record', this.pict.views.ObservationDetails.ActiveObservationDetails);
			if (pCallback)
			{
				pCallback();
			}
		});
	}
}

module.exports = HeadlightPaneObservations;
// additional view-specific templates
const viewSpecificTemplates = [];
// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],789:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ProfilePaneHtml-View'];

class HeadlightPaneProfile extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	navigateToProfileApp(event)
	{
		const hostParts = document.location.host.split('.');
		hostParts.shift(); // remove current application
		hostParts.unshift('profile');
		const profileURL = '//' + hostParts.join('.');
		window.open(profileURL, '_blank');
	}
}

module.exports = HeadlightPaneProfile;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],790:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SamplesPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSamples extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(pCallback)
	{
		// set the callback that runs when the search results are returned
		this.pict.views.SampleSearch.setSampleSearchResultsCallback((pResults) =>
		{
			// collapse the filter panel
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters', 'close');
			// render the pagination controls
			this.pict.views.SampleSearch.renderAsync('SampleSearch-Results', '#SampleSearch-Results-Container', false, false, () =>
			{
				// TODO: is this the proper location for this? Should we be using the Entity object?
				const tmpSamples = this.AppData?.DocumentData?.ReportData?.Samples;
				if (tmpSamples)
				{
					// for each Sample, if the Sample is already included, toggle the button to "on"
					pResults.forEach((pResult) =>
					{
						if (tmpSamples.find((obs) => obs.IDSample === pResult.IDSample))
						{
							document.querySelector(`[data-sample-add-context="${pResult.IDSample}"]`)?.classList?.add('is-active');
						}
					});
				}
			});
		});
		// set the default search filter options for the sample search view
		this.pict.views.SampleSearch.setCurrentSearchFilters({
			PageSize: 20,
		});
		// render each tab's view; a failure in one must not strand the others
		// (SampleCurrent's data still loads lazily, when its tab is opened)
		this.renderTabView('SampleSearch');
		this.renderTabView('SampleCreate');
		this.renderTabView('SampleScan');
		this.renderTabView('SampleCurrent');

		// the panel opens in this callback, so we need to wait for it to open before we can build the included samples list
		if (pCallback)
		{
			pCallback();
		}
	}

	closeHandler()
	{
		this.pict.providers.QRCodeProvider.stopWorkflow();
		this.pict.providers.QRCodeProvider.closeScanner();
	}

	/**
	 * This function is used to set the callback that is run when a sample is selected from the search results.
	 * @param {function} fCallback - The callback function to run when a sample is selected
	 * @return {void}
	 */
	setSampleSelectionCallback(fCallback)
	{
		this.pict.views.SampleSearch.sampleSelectionCallback = fCallback;
	}

	/**
	 * This function is used to handle the opening of the Sample panel from the advanced button.
	 * @param {Event} event - The event that triggered the opening of the Sample panel
	 */
	openSamplePanelFromAdvancedButton(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			event.preventDefault();
			// find the parent column of the advanced button
			const tmpParentColumn = event.target.closest('.column');
			// if the parent column exists
			if (tmpParentColumn)
			{
				this.fable.HeadlightPanels.applyUIHighlight(tmpParentColumn);
			}
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
		{
			this.pict.ContentAssignment.setAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode', 'add-to-set');
		});
	}

	/**
	 * Open the Samples panel straight to the Current tab. Entry point for the navbar Current Samples
	 * button, which is only visible when this document actually has Samples joined to it.
	 * @param {Event} [event] - The click event
	 * @return {void}
	 */
	openCurrentSamplesTab(event)
	{
		if (event)
		{
			event.preventDefault();
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample');
			this.pict.views.SampleCurrent.handleTabOpened();
		});
	}

	/**
	 * This function is used to clear the Sample panel target and the banner on the header. The removes the "add mode" flow.
	 * @return {void}
	 */
	clearSamplePanelTarget()
	{
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.pict.views.HeadlightPanels.ModePanelLeft = '';
		this.pict.views.HeadlightPanels.ModePanelRight = '';
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-SamplePanel').setAttribute('data-panel-mode', '');
		// hide the banner on the header that you are adding an Sample
		document.getElementById('HeadlightPanels-SamplePanel-Sample-Header-Mode-Target').innerText = '';
	}
}

module.exports = HeadlightPaneSamples;
// additional view-specific templates
const viewSpecificTemplates = [
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],791:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SecretPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSecret extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Toggle the minimum input length for search queries - ex: either 0 or 2
	 * Used to make it easier to search for samples, etc. when server-side searching is enabled
	 * @param {Number} pValue - The value to set the minimum input length to
	 * @return {void}
	 */
	toggleMinimumInputLengthForSearch(pValue)
	{
		// set the minimum input length for search queries
		this.pict.views.HeadlightPanels.MinimumInputLengthForSearch = pValue || 0;
		// re-render the search view to update the search input field
		this.pict.PictApplication.changeTheme('Edit');
	}

	handleDocumentRefreshAndDownload(event)
	{
		if (event)
		{
			// set the button to be loading
			event.target.classList.add('is-loading', 'is-dark', 'button');
		}
		// download the pdf with the forced refresh flag set
		this.pict.providers.DocumentProvider.handleDocumentDownload(true, null, () =>
		{
			event.target.classList.remove('is-loading', 'is-dark', 'button');
		});
	}
}

module.exports = HeadlightPaneSecret;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],792:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SettingsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSettings extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.getLocallyStoredTheme();
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback function to call after rendering
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object to render
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		const tmpPanelSettings = this.AppData.CurrentUser?.Settings;
		if (!tmpPanelSettings || !tmpPanelSettings.HeadlightPanels)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to load the user preferences.');
		}
		else
		{
			for (const [ key, value ] of Object.entries(tmpPanelSettings.HeadlightPanels))
			{
				if (value)
				{
					const setting = document.getElementById(`setting-${key}`) ||
						document.getElementById(`setting-${key}-${value}`);
					if (setting)
					{
						setting.classList.add('is-active');
					}
				}
			}
		}
		this.syncAutoSaveSettings();
		super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Resolve the shared auto-save provider, if this application has one.
	 * @return {any}
	 */
	get autoSaveProvider()
	{
		return this.pict.providers?.AutoSave;
	}

	/**
	 * Paint the auto-save rows from the provider's effective state.
	 *
	 * Called on every render of this pane, because the pane is built on demand and the state it shows
	 * is a blend of the form manifest and the user's stored preference.
	 * @return {void}
	 */
	syncAutoSaveSettings()
	{
		const tmpToggle = document.getElementById('setting-AutoSave');
		const tmpIntervalBlock = document.getElementById('setting-AutoSaveIntervalSeconds');
		const tmpNote = document.getElementById('setting-AutoSave-Note');
		if (!tmpToggle || !tmpIntervalBlock || !tmpNote)
		{
			return;
		}
		const tmpState = this.autoSaveProvider?.getUserFacingState?.();
		// No auto-save provider, or an application with no form to save: hide the controls rather than
		// offering a preference that could not do anything.
		if (!tmpState || !tmpState.Available)
		{
			tmpToggle.classList.add('is-hidden');
			tmpIntervalBlock.classList.add('is-hidden');
			tmpNote.classList.add('is-hidden');
			return;
		}
		tmpToggle.classList.remove('is-hidden');
		tmpToggle.classList.toggle('is-active', tmpState.Enabled);
		// onAfterRenderAsync's generic preference sweep stamps is-active on any `setting-<Key>` element
		// whose stored value is truthy, which catches the interval block because the cadence is a number.
		// It holds an input, not a toggle, so clear it.
		tmpIntervalBlock.classList.remove('is-active');

		// Locked means the user cannot change it from here — the form manifest opted out, or the document
		// belongs to another customer — so the row goes inert. A reason without a lock (impersonation,
		// which only moves the default) still explains itself but leaves the toggle live.
		tmpToggle.classList.toggle('is-disabled', tmpState.Locked);
		tmpNote.classList.toggle('is-hidden', !tmpState.Reason);
		if (tmpState.Reason)
		{
			tmpNote.textContent = tmpState.Reason;
		}

		// The cadence only means anything while auto-save is on.
		tmpIntervalBlock.classList.toggle('is-hidden', !tmpState.Enabled || tmpState.Locked);

		const tmpInput = /** @type {HTMLInputElement} */ (document.getElementById('setting-AutoSaveIntervalSeconds-Input'));
		if (tmpInput)
		{
			tmpInput.min = String(tmpState.MinimumIntervalSeconds);
			tmpInput.max = String(tmpState.MaximumIntervalSeconds);
			tmpInput.value = String(tmpState.IntervalSeconds);
		}
	}

	/**
	 * Turn auto-save on or off for this user, across every form they open.
	 * @return {void}
	 */
	toggleAutoSave()
	{
		const tmpState = this.autoSaveProvider?.getUserFacingState?.();
		if (!tmpState || !tmpState.Available || tmpState.Locked)
		{
			return;
		}
		this.updateUserPreferences('AutoSave', !tmpState.Enabled);
		// Take effect on the document already open rather than at the next page load.
		this.autoSaveProvider.reconfigure();
		this.syncAutoSaveSettings();
	}

	/**
	 * Persist the auto-save cadence, in seconds.
	 *
	 * Wired to the field's change event, so it fires once the user leaves the field or presses Enter
	 * rather than on every keystroke. The value is clamped to the range auto-save supports and echoed
	 * back into the field: the min/max attributes only gate the spinner, so a typed-in 5 would otherwise
	 * sit there reading 5 while auto-save quietly ran at 15.
	 *
	 * @param {string|number} pSeconds - The entered interval, in seconds.
	 * @return {void}
	 */
	setAutoSaveInterval(pSeconds)
	{
		const tmpState = this.autoSaveProvider?.getUserFacingState?.();
		const tmpInput = /** @type {HTMLInputElement} */ (document.getElementById('setting-AutoSaveIntervalSeconds-Input'));
		const tmpSeconds = Math.round(Number(pSeconds));
		if (!Number.isFinite(tmpSeconds) || tmpSeconds <= 0)
		{
			this.log.warn(`Ignoring an unusable auto-save interval: ${pSeconds}`);
			// Put the field back to the value that is actually in effect.
			if (tmpInput && tmpState)
			{
				tmpInput.value = String(tmpState.IntervalSeconds);
			}
			return;
		}
		const tmpMinimum = tmpState?.MinimumIntervalSeconds ?? 15;
		const tmpMaximum = tmpState?.MaximumIntervalSeconds ?? 3600;
		const tmpClamped = Math.min(tmpMaximum, Math.max(tmpMinimum, tmpSeconds));
		if (tmpInput)
		{
			tmpInput.value = String(tmpClamped);
		}
		this.updateUserPreferences('AutoSaveIntervalSeconds', tmpClamped);
		// Re-arming restarts the countdown, which is what someone who just changed the cadence expects.
		this.autoSaveProvider?.reconfigure?.();
	}

	/**
	 * Check the user settings for an active chip type that is passed in.
	 * @param {string} pType - The chip type to check for
	 * @return {boolean} - Whether the chip type is active or not
	 * @example
	 * checkChipTypeActive('New');
	 * checkChipTypeActive('ExternalDatabaseIDs');
	 */
	checkChipTypeActive(pType)
	{
		return this.AppData.CurrentUser?.Settings?.HeadlightPanels?.ActiveChipTypes?.includes(pType);
	}

	/**
	 * This function is used to get the user preferences for the headlight panels.
	 * @param {string} pSetting - The setting to get the user preference for
	 * @return {any} - The user preference for the setting
	 * @example
	 * readUserPrefrence('DocumentTheme');
	 * readUserPrefrence('NavBarLocation');
	 */
	readUserPreference(pSetting)
	{
		const tmpPanelSettings = this.AppData.CurrentUser?.Settings;
		if (!tmpPanelSettings)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to load the user preferences.');
			return;
		}
		// create the HeadlightPanels object if it doesn't exist
		if (!tmpPanelSettings.hasOwnProperty('HeadlightPanels'))
		{
			this.log.warn('No HeadLightPanel user settings found to load the user preferences.');
			return;
		}
		return this.AppData.CurrentUser?.Settings?.HeadlightPanels?.[pSetting];
	}

	/**
	 * This function is used to render the user preferences for the headlight panels and apply them to the document.
	 * @return {void}
	 * @async
	 */
	/**
	 * Resolve the current user's HeadlightPanels preference bag, creating it if this is their first visit.
	 * @return {Object|null} The preference object, or null when there is no user to read preferences from
	 */
	getUserPanelPreferences()
	{
		// these settings are only applicable in interactive mode
		if (!this.AppData.Interactive)
		{
			return null;
		}
		const tmpPanelSettings = this.AppData.CurrentUser?.Settings;
		if (!tmpPanelSettings)
		{
			return null;
		}
		// create the HeadlightPanels object if it doesn't exist
		if (!tmpPanelSettings.hasOwnProperty('HeadlightPanels'))
		{
			tmpPanelSettings.HeadlightPanels = {};
		}
		return tmpPanelSettings.HeadlightPanels;
	}

	/**
	 * Apply the preferences that decide what the very first paint looks like.
	 *
	 * These come straight off the already-loaded CurrentUser record -- there is no fetch to wait on -- and
	 * the navbar's position is baked into the template at render time. Applying them after the render
	 * means the navbar renders in the default position and then visibly jumps to the user's, taking a
	 * body-class reflow with it; the same goes for the theme and the page width.
	 * @return {void}
	 */
	applyPreRenderUserPreferences()
	{
		const tmpPanelPreferences = this.getUserPanelPreferences();
		if (!tmpPanelPreferences)
		{
			return;
		}
		// if a theme is set, apply it to the document
		if (tmpPanelPreferences.hasOwnProperty('DocumentTheme'))
		{
			this.toggleDocumentColorTheme(tmpPanelPreferences.DocumentTheme, true);
		}
		// if a screen width is set, apply it to the document
		//widescreen, fancy, standard
		if (!tmpPanelPreferences.hasOwnProperty('ScreenWidth'))
		{
			tmpPanelPreferences.ScreenWidth = 'standard';
		}
		this.toggleScreenWidth(tmpPanelPreferences.ScreenWidth, true);
		// set the navbar location based on the user's preference (this moves the navbar to the top or bottom of the screen)
		if (tmpPanelPreferences.NavBarLocation)
		{
			this.toggleNavbarLocation(tmpPanelPreferences.NavBarLocation, true);
		}
	}

	loadUserPreferences()
	{
		const tmpPanelPreferences = this.getUserPanelPreferences();
		if (this.AppData.Interactive && !tmpPanelPreferences)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to load the user preferences.');
			return;
		}
		if (!tmpPanelPreferences)
		{
			return;
		}
		// re-applying the first-paint preferences is a no-op; this keeps the call correct on its own
		// for any caller that reaches loadUserPreferences() without the pre-render pass having run
		this.applyPreRenderUserPreferences();
		// the rest need the rendered panel elements, so they can only run after the render
		// set the lefty mode based on the user's preference (this inverts the left and right panel locations)
		if (tmpPanelPreferences.LeftyMode)
		{
			this.toggleLeftyMode(tmpPanelPreferences.LeftyMode, true);
		}
		// handle the state of all active chips based on the user's preference
		if (tmpPanelPreferences.ActiveChipTypes?.length)
		{
			tmpPanelPreferences.ActiveChipTypes.forEach((chip) => this.toggleChipTypeActive(null, chip, true, true));
		}
		// handle the state of the help text based on the user's preference
		if (tmpPanelPreferences.HelpText !== undefined)
		{
			this.toggleHelpText(tmpPanelPreferences.HelpText, true);
		}
	}

	/**
	 * This function is used to toggle the theme of the application between light and dark styling.
	 * This will also store the user's preference in the current user object on the server.
	 * @param {string} pTheme - The theme to set the application to if provided (system, light, dark)
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	*/
	toggleDocumentColorTheme(pTheme, skipSave = false)
	{
		document.documentElement.setAttribute('data-theme', pTheme);

		// NOTE: This is to clear out the old location of the theme in the user settings
		if (this.AppData?.CurrentUser?.Settings.hasOwnProperty('Theme'))
		{
			delete this.AppData.CurrentUser.Settings.Theme;
		}

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('DocumentTheme', pTheme);
	}

	/**
	 * This function is used to get the theme from localStorage for the application,
	 * and toggle between light, dark and system themes.
	 * @return {void}
	*/
	getLocallyStoredTheme()
	{
		const storedTheme = localStorage.getItem('data-theme');
		const themeIcon = document.getElementById('themeIcon');

		if (!themeIcon) return;
		// remove icon classes on init so correct icon displays on toggle
		themeIcon.classList.remove('fa-desktop');
		themeIcon.classList.remove('fa-sun');
		themeIcon.classList.remove('fa-moon');

		// Apply the theme from localStorage as default
		if (storedTheme)
		{
			document.documentElement.setAttribute('data-theme', storedTheme);
		}
		else
		{
			// if there is no stored theme, default to light theme
			document.documentElement.setAttribute('data-theme', 'light');
			localStorage.setItem('data-theme', 'light');
			themeIcon.classList.add('fa-sun');
		}
		if (storedTheme === 'system')
		{
			// if theme is system add desktop icon
			themeIcon.classList.add('fa-desktop');
			themeIcon.title = 'Change the theme to dark mode.';
		}
		// todo: take out this trash, does checking for && storedTheme is dark defeat the purpose of checking user preference? not sure but this makes it work
		else if ((window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) && storedTheme === 'dark')
		{
			document.documentElement.setAttribute('data-theme', 'dark');
			localStorage.setItem('data-theme', 'dark');
			themeIcon.classList.add('fa-moon');
			themeIcon.title = 'Change the theme to light mode.';
		}
		else
		{
			document.documentElement.setAttribute('data-theme', 'light');
			localStorage.setItem('data-theme', 'light');
			themeIcon.classList.add('fa-sun');
			themeIcon.title = 'Change the theme to system mode.';
		}
	}

	/**
	 * This function is used to get the theme from localStorage for the application,
	 * and toggle between light, dark and system themes.
	 * @return {void}
	*/
	toggleLocallyStoredTheme()
	{
		const themeIcon = document.getElementById('themeIcon');

		if (!themeIcon) return;

		if (themeIcon.classList.contains('fa-moon'))
		{
			themeIcon.classList.remove('fa-moon');
			themeIcon.classList.add('fa-sun');
			themeIcon.title = 'Change the theme to system mode.';
			localStorage.setItem('data-theme', 'light');
			document.documentElement.setAttribute('data-theme', 'light');
		}
		else if (themeIcon.classList.contains('fa-sun'))
		{
			themeIcon.classList.remove('fa-sun');
			themeIcon.classList.add('fa-desktop');
			themeIcon.title = 'Change the theme to dark mode.';
			localStorage.setItem('data-theme', 'system');
			document.documentElement.setAttribute('data-theme', 'system');
		}
		else
		{
			themeIcon.classList.remove('fa-desktop');
			themeIcon.classList.add('fa-moon');
			themeIcon.title = 'Change the theme to light mode.';
			localStorage.setItem('data-theme', 'dark');
			document.documentElement.setAttribute('data-theme', 'dark');
		}
	}

	/**
	 * This function is used to toggle the help text visibility on the document.
	 * @param {boolean} pHelpText - The value to set the help text to if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	toggleHelpText(pHelpText, skipSave = false)
	{
		if (pHelpText === undefined)
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText = !this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText;
		}
		else
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText = pHelpText;
		}
		// handle the help text visibility on the document
		if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText)
		{
			document.body.classList.remove('has-hidden-help-text');
		}
		else
		{
			document.body.classList.add('has-hidden-help-text');
		}

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('HelpText', this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText);
	}

	/**
	 * This function is used to toggle between widescreen or standard for all documents.
	 * @param {boolean} pWidth - The value to set the document width if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	//TODO: add a 3rd option for "fancy" that is user defined width
	toggleScreenWidth(pWidth, skipSave = false)
	{
		if (pWidth === undefined)
		{
			this.pict.settings.HeadlightPanels.Configuration.ScreenWidth = 'standard';
		}
		else
		{
			this.pict.settings.HeadlightPanels.Configuration.ScreenWidth = pWidth;
		}
		// apply the widescreen to the document if one desktop
		const isPhoneDevice = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
		const alwaysWideScreenModeClass = 'always-widescreen-mode';
		// set view to default width and icon to standard (it wont be displayed
		// else icon to minimize if widescreen on desktop, else set to standard
		if (isPhoneDevice)
		{
			document.body.classList.remove(alwaysWideScreenModeClass);
			this.pict.providers.DocumentProvider.setScreenResizeIcon('standard');
		}
		else
		{
			if (this.pict.settings.HeadlightPanels.Configuration.ScreenWidth === 'widescreen')
			{
				document.body.classList.add(alwaysWideScreenModeClass);
			}
			else
			{
				document.body.classList.remove(alwaysWideScreenModeClass);
			}
			this.pict.providers.DocumentProvider.setScreenResizeIcon(this.pict.settings.HeadlightPanels.Configuration.ScreenWidth);
		}

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('ScreenWidth', this.pict.settings.HeadlightPanels.Configuration.ScreenWidth);
	}

	/**
	 * This function is used to toggle "lefty mode" for the application. This inverts all
	 * the panels to the opposite side of the screen for left-handed users.
	 * @param {boolean} pUseLeftyMode - The value to set the lefty mode to if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	toggleLeftyMode(pUseLeftyMode, skipSave = false)
	{
		if (pUseLeftyMode === undefined)
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode = !this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode;
		}
		else
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode = pUseLeftyMode;
		}
		// hide the panels from jutting out on the opposite side of the screen from the switch
		if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode)
		{
			document.body.classList.add('use-lefty-mode');
			// animate the panels to the opposite side of the screen
			document.getElementById('HeadlightPanels-LeftPanel').classList.remove('animate__slideOutLeft');
			document.getElementById('HeadlightPanels-RightPanel').classList.remove('animate__slideOutRight');
			document.getElementById('HeadlightPanels-LeftPanel').classList.add('animate__slideOutRight');
			document.getElementById('HeadlightPanels-RightPanel').classList.add('animate__slideOutLeft');
		}
		else
		{
			document.body.classList.remove('use-lefty-mode');
			// remove old classes and reset back to the default side of the screen
			document.getElementById('HeadlightPanels-LeftPanel').classList.remove('animate__slideOutRight');
			document.getElementById('HeadlightPanels-RightPanel').classList.remove('animate__slideOutLeft');
			document.getElementById('HeadlightPanels-LeftPanel').classList.add('animate__slideOutLeft');
			document.getElementById('HeadlightPanels-RightPanel').classList.add('animate__slideOutRight');
		}
		// close any open panels to get us back to a clean slate
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('LeftyMode', this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode);
	}

	/**
	 * This function is used to toggle the location of the navbar between top and bottom.
	 * @param {string} pLocation - The location to set the navbar to if provided (top, bottom)
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	toggleNavbarLocation(pLocation, skipSave = false)
	{
		let newLocation = '';
		if (!pLocation)
		{
			switch (this.pict.settings.HeadlightPanels.Configuration.NavBar.location)
			{
			case 'top':
				newLocation = 'bottom';
				break;
			case 'bottom':
				newLocation = 'top';
				break;
			default:
				newLocation = 'bottom';
			}
		}
		else
		{
			newLocation = pLocation;
		}
		// update the navbar location classes on the DOM
		// (the navbar element does not exist yet when this runs ahead of the first render -- the
		// configuration update below is what puts it in the right place to begin with)
		const navbar = document.getElementById('HeadlightPanels-NavBar');
		if (navbar)
		{
			navbar.classList.remove('is-fixed-' + this.pict.settings.HeadlightPanels.Configuration.NavBar.location);
			navbar.classList.add('is-fixed-' + newLocation);
		}
		document.body.classList.remove('has-navbar-fixed-' + this.pict.settings.HeadlightPanels.Configuration.NavBar.location);
		document.body.classList.add('has-navbar-fixed-' + newLocation);
		// update our configuration
		this.pict.settings.HeadlightPanels.Configuration.NavBar.location = newLocation;

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('NavBarLocation', newLocation);
	}

	/**
	 * This function is used to toggle the visiblity of the a specific label type on the document.
	 * @param {object} event - The event object that triggered the function
	 * @param {string} pChip - The chip type to toggle the visibility of
	 * @param {boolean} pIsActive - The value to set the chip type to if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 * @example
	 * toggleChipTypeActive('ExternalDatabaseIDs', false);
	 * toggleChipTypeActive('New');
	 */
	toggleChipTypeActive(event, pChip, pIsActive, skipSave = false)
	{
		// if an event was passed in, prevent the default behavior (like clicking a link or toggling date picker)
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		// get the user settings object
		const tmpCurrentUserSettings = this.AppData?.CurrentUser?.Settings;
		if (!tmpCurrentUserSettings)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to save the chip type visibility.');
			return;
		}
		// make sure the user settings object exists
		if (!tmpCurrentUserSettings.hasOwnProperty('HeadlightPanels'))
		{
			tmpCurrentUserSettings.HeadlightPanels = {};
		}
		if (!tmpCurrentUserSettings.HeadlightPanels.hasOwnProperty('ActiveChipTypes'))
		{
			tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = [];
		}
		// if the value is not provided, toggle the chip type
		if (pIsActive === undefined)
		{
			if (tmpCurrentUserSettings?.HeadlightPanels?.ActiveChipTypes?.includes(pChip))
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.filter((chip) => chip !== pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.remove('is-active'));
			}
			else
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.push(pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.add('is-active'));
			}
		}
		else
		{
			if (pIsActive)
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.push(pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.add('is-active'));
			}
			else
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.filter((chip) => chip !== pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.remove('is-active'));
			}
		}
		// filter out duplicates
		tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = [ ...new Set(tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes) ];
		// save the user's preference if we're not skipping the save
		if (skipSave) return;
		// tell the server to update (but no need to wait for it to finish)
		this.pict.services.HeadlightDocumentService.updateUserSettings(
			{ HeadlightPanels: { ActiveChipTypes: tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes } });
	}

	/**
	 * This function is used to bus various settings for the user.
	 *
	 * Booleans and strings additionally paint the matching `setting-<Key>` / `setting-<Key>-<value>`
	 * panel row. Numbers (the auto-save cadence) are stored and persisted but painted by their own
	 * control, since a numeric field has no active/inactive row to toggle.
	 * @param {string} pSetting - The setting to update
	 * @param {boolean|string|number} pValue - The value to set the setting to
	 * @return {void}
	 * @example
	 * updateUserPreferences('LeftyMode', true);
	 * updateUserPreferences('Theme', 'dark');
	 */
	updateUserPreferences(pSetting, pValue)
	{
		const tmpCurrentUserSettings = this.AppData?.CurrentUser?.Settings;
		if (!tmpCurrentUserSettings)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to save the user preferences.');
			return;
		}
		if (!tmpCurrentUserSettings.hasOwnProperty('HeadlightPanels'))
		{
			tmpCurrentUserSettings.HeadlightPanels = {};
		}
		if (!tmpCurrentUserSettings.HeadlightPanels.hasOwnProperty(pSetting))
		{
			tmpCurrentUserSettings.HeadlightPanels[pSetting] = false;
		}
		tmpCurrentUserSettings.HeadlightPanels[pSetting] = pValue;
		// tell the server to update (but no need to wait for it to finish). The changed key is passed
		// because an impersonated session saves onto the real user's record and must not carry the
		// impersonated user's other preferences across with it.
		this.pict.services.HeadlightDocumentService.updateUserSettings({ HeadlightPanels: { [pSetting]: pValue } });
		// if the setting is a boolean, toggle the class on the setting element
		if (typeof pValue === 'boolean')
		{
			const tmpPanelBlock = document.getElementById(`setting-${pSetting}`);
			if (tmpPanelBlock)
			{
				if (pValue)
				{
					tmpPanelBlock.classList.add('is-active');
				}
				else
				{
					tmpPanelBlock.classList.remove('is-active');
				}
			}
			else
			{
				this.log.warn(`No panel block found for setting ${pSetting}`);
			}
		}
		// if the setting is a string, set the class on the setting element
		else if (typeof pValue === 'string')
		{
			// clear all classes on the setting element by getting a partial id match
			const tmpPanelBlocks = document.querySelectorAll(`[id^="setting-${pSetting}-"]`);
			tmpPanelBlocks.forEach((block) =>
			{
				block.classList.remove('is-active');
			});
			// set the class on the setting element
			const tmpPanelBlock = document.getElementById(`setting-${pSetting}-${pValue}`);
			if (tmpPanelBlock)
			{
				tmpPanelBlock.classList.add('is-active');
			}
			else
			{
				this.log.warn(`No panel block found for setting ${pSetting}-${pValue}`);
			}
		}
	}
}

module.exports = HeadlightPaneSettings;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],793:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SolverPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSolver extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
	/** @param {()=>void} pCallback */
	onAfterRenderAsync(pCallback)
	{
		this.pict.views.PictFormsSolver.renderAsync(pCallback);
	}
}

module.exports = HeadlightPaneSolver;

module.exports.default_configuration = _ViewConfiguration;

// additional view-specific templates
const viewSpecificTemplates = [];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],794:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-StatusPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneStatus extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Approval payloads from the last open, so reopening paints immediately instead of waiting on
		// three round-trips. Keyed by document: the same pane serves whatever document is loaded, and
		// showing one document's approvals under another would be worse than a slow open. A successful
		// approval action ends in a full page reload, so this can never outlive the user's own change.
		this.ApprovalCache = { IDDocument: null, State: undefined, Users: undefined, History: undefined };
		// True while a cached copy is on screen and the fresh copy is still in flight. Approval actions
		// stay disabled for that window -- painting a stale action live would let the user act on an
		// approval state the server has already moved past.
		this.ApprovalRevalidating = false;
	}

	/**
	 * Read a cached approval payload, discarding the cache if it belongs to a different document.
	 * @param {string} pKey - Which payload (State, Users, History)
	 * @return {any} The cached payload, or undefined when there is nothing usable
	 */
	getCachedApproval(pKey)
	{
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument ?? null;
		if (this.ApprovalCache.IDDocument !== tmpIDDocument)
		{
			this.ApprovalCache = { IDDocument: tmpIDDocument, State: undefined, Users: undefined, History: undefined };
		}
		return this.ApprovalCache[pKey];
	}

	/**
	 * Store an approval payload against the document it was fetched for.
	 * @param {string} pKey - Which payload (State, Users, History)
	 * @param {any} pValue - The payload to keep
	 * @return {void}
	 */
	setCachedApproval(pKey, pValue)
	{
		this.ApprovalCache.IDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument ?? null;
		this.ApprovalCache[pKey] = pValue;
	}

	onAfterRenderAsync(pCallback)
	{
		this.buildApprovalActionButtons();
		this.buildApprovalUserList();
		this.buildApprovalLogs();

		// the panel opens in this callback, so we need to wait for it to open before we can build the content
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Replace a status region's contents -- including its loading skeleton -- with a single message.
	 *
	 * Shared by the empty and the failed states so a region never keeps spinning: the pane HTML ships
	 * a `skeleton-block` placeholder per region, and whatever happens it has to be painted over.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {string} pMessage - The message to display
	 * @return {void}
	 */
	renderPanelMessage(pPanel, pMessage)
	{
		const tmpNotification = document.createElement('div');
		tmpNotification.className = 'notification has-text-text-light is-dark m-3';
		tmpNotification.textContent = pMessage;
		pPanel.innerHTML = '';
		pPanel.appendChild(tmpNotification);
	}

	/**
	 * This function is used to build the approval action buttons for the status panel.
	 * @param {function} [pCallback] - The callback function to execute after the action buttons are built
	 * @return {Promise<void>}
	 * @async
	 */
	async buildApprovalActionButtons(pCallback)
	{
		const id = 'HeadlightPanels-StatusPanel-Approval-Actions-Content';
		const panel = document.getElementById(id);
		if (!panel)
		{
			this.log.error('Failed to find panel element', { id });
			return;
		}
		// Paint whatever the last open left us, so a reopen is not a blank wait, then revalidate behind it.
		const tmpCached = this.getCachedApproval('State');
		const tmpHadCache = (tmpCached !== undefined);
		if (tmpHadCache)
		{
			this.ApprovalRevalidating = true;
			this.paintApprovalActionButtons(panel, tmpCached);
		}
		let fetchedData;
		try
		{
			fetchedData = await this.fable.services.HeadlightDocumentService.fetchApprovalState();
		}
		catch (pError)
		{
			// The service rethrows on failure; unhandled, that both leaves this region on its loading
			// skeleton forever and surfaces as an unhandled rejection (the caller does not await us).
			this.log.error(`Failed to load the approval actions: ${pError?.message || pError}`);
			this.ApprovalRevalidating = false;
			if (tmpHadCache)
			{
				// A stale copy the user can act on beats an error message replacing content they can see;
				// re-enable it now that nothing fresher is coming.
				this.syncApprovalActionButtonState();
			}
			else
			{
				this.renderPanelMessage(panel, 'Could not load the approval actions. Reopen the panel to try again.');
			}
			if (pCallback)
			{
				pCallback();
			}
			return;
		}
		this.setCachedApproval('State', fetchedData);
		this.ApprovalRevalidating = false;
		// Only repaint when something actually moved -- an unnecessary rebuild throws away the buttons
		// the user is reaching for.
		if (!tmpHadCache || JSON.stringify(tmpCached) !== JSON.stringify(fetchedData))
		{
			this.paintApprovalActionButtons(panel, fetchedData);
		}
		// The panel is built on demand, so a save that started before it opened has to be reflected here
		// rather than only on the save-latch transition.
		this.syncApprovalActionButtonState();
		// optional callback
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Paint the approval actions region from a payload. Split out so the cached copy and the freshly
	 * fetched copy go through exactly the same rendering.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {any} pData - The approval state payload
	 * @return {void}
	 */
	paintApprovalActionButtons(pPanel, pData)
	{
		// handle empty message display
		if (!pData?.Actions?.length)
		{
			this.renderPanelMessage(pPanel, 'No approval actions available at this time.');
			return;
		}
		pPanel.innerHTML = '';
		pData.Actions.forEach((item) =>
		{
			const newItem = document.createElement('a');
			newItem.classList.add('panel-block');
			// The marker is what syncApprovalActionButtonState finds; it survives this rebuild.
			newItem.setAttribute('data-approval-action', item);
			newItem.onclick = (event) => this.pict.providers.DocumentProvider.handleApprovalStatusChange(event, item);
			newItem.innerHTML =
			`<span class="panel-icon">
				<i class="fa fa-fw ${ this.pict.providers.DocumentProvider.getApprovalStatusStyle(item).iconClass }"></i>
			</span>
			<span>${ item }</span>`;
			pPanel.appendChild(newItem);
		});
		this.syncApprovalActionButtonState();
	}

	/**
	 * Disable the approval action buttons while the document is being written.
	 *
	 * An approval action changes the document server-side and usually locks it. Taken while a save is
	 * still in flight, the lock lands first and the resolving save is rejected -- the user's last edits
	 * are silently lost. Auto-save makes that window recur on a timer, so the buttons have to reflect
	 * the save latch rather than relying on the user not being quick.
	 *
	 * Derives entirely from provider state, so it is safe to call before the panel has been built.
	 * @return {void}
	 */
	syncApprovalActionButtonState()
	{
		const panel = document.getElementById('HeadlightPanels-StatusPanel-Approval-Actions-Content');
		if (!panel)
		{
			return;
		}
		const documentProvider = this.pict.providers?.DocumentProvider;
		const isBusy = Boolean(documentProvider?.IsSaving) || Boolean(documentProvider?.isTakingAction) || this.ApprovalRevalidating;
		let busyTitle = 'An approval action is already in progress.';
		if (documentProvider?.IsSaving)
		{
			busyTitle = 'Saving the document; approval actions are available once the save completes.';
		}
		else if (this.ApprovalRevalidating)
		{
			busyTitle = 'Checking the current approval state...';
		}
		panel.querySelectorAll('a[data-approval-action]').forEach((element) =>
		{
			element.classList.toggle('is-disabled', isBusy);
			if (isBusy)
			{
				element.setAttribute('aria-disabled', 'true');
				element.setAttribute('tabindex', '-1');
				element.setAttribute('title', busyTitle);
			}
			else
			{
				element.removeAttribute('aria-disabled');
				element.removeAttribute('tabindex');
				element.removeAttribute('title');
			}
		});
	}

	/**
	 * This function is used to build the approval logs for the document.
	 * @return {Promise<void>}
	 * @async
	 */
	async buildApprovalLogs()
	{
		const id = 'HeadlightPanels-StatusPanel-History-Content';
		const panel = document.getElementById(id);
		if (!panel)
		{
			this.log.error('Failed to find panel element', { id });
			return;
		}
		// Paint the last known history first; it is read-only, so a stale copy is harmless while we check.
		const tmpCached = this.getCachedApproval('History');
		const tmpHadCache = (tmpCached !== undefined);
		if (tmpHadCache)
		{
			this.paintApprovalLogs(panel, tmpCached);
		}
		/** @type {{ CreateDate: string, Status: string, AfterStatus: string }[]} */
		let fetchedData;
		try
		{
			fetchedData = await this.fable.services.HeadlightDocumentService.fetchApprovalHistory();
		}
		catch (pError)
		{
			this.log.error(`Failed to load the approval history: ${pError?.message || pError}`);
			if (!tmpHadCache)
			{
				this.renderPanelMessage(panel, 'Could not load the approval history. Reopen the panel to try again.');
			}
			return;
		}
		this.setCachedApproval('History', fetchedData);
		if (!tmpHadCache || JSON.stringify(tmpCached) !== JSON.stringify(fetchedData))
		{
			this.paintApprovalLogs(panel, fetchedData);
		}
	}

	/**
	 * Paint the approval history region from a payload.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {{ CreateDate: string, Status: string, AfterStatus: string }[]} pData - The history payload
	 * @return {void}
	 */
	paintApprovalLogs(pPanel, pData)
	{
		// handle empty message display
		if (!pData || !Array.isArray(pData) || pData.length === 0)
		{
			this.renderPanelMessage(pPanel, 'No logs available at this time.');
			return;
		}
		// sort by most recent first (on a copy -- the cached payload is shared with the next open)
		const tmpSorted = pData.slice().sort((a, b) => new Date(b.CreateDate).getTime() - new Date(a.CreateDate).getTime());
		pPanel.innerHTML = '';
		tmpSorted.forEach((item) =>
		{
			const newItem = document.createElement('div');
			newItem.classList.add('panel-block');
			// TODO:DOUG: CSS class clean up
			newItem.innerHTML =
			`<span class="mr-1 has-text-text-65 has-text-weight-semibold">${ item.Status }</span>
			<i class="fa fa-fw fa-arrow-right"></i>
			<span class="ml-1 has-text-weight-semibold">${ item.AfterStatus }</span>
			<span class="is-size-7 ml-2 has-text-text-75 mt-1"> on ${ this.fable.Dates.dayJS(item.CreateDate).format('MMMM DD, YYYY - hh:mm a') }</span>`;
			pPanel.appendChild(newItem);
		});
	}

	/**
	 * This function is used to build the list of users that can approve the document.
	 * @return {Promise<void>}
	 * @async
	 */
	async buildApprovalUserList()
	{
		const id = 'HeadlightPanels-StatusPanel-Users-Content';
		const panel = document.getElementById(id);
		if (!panel)
		{
			this.log.error('Failed to find panel element', { id });
			return;
		}
		// Paint the last known approver list first; it is read-only, so a stale copy is harmless.
		const tmpCached = this.getCachedApproval('Users');
		const tmpHadCache = (tmpCached !== undefined);
		if (tmpHadCache)
		{
			this.paintApprovalUserList(panel, tmpCached);
		}
		let fetchedData;
		try
		{
			fetchedData = await this.fable.services.HeadlightDocumentService.fetchApprovalUsersList();
		}
		catch (pError)
		{
			this.log.error(`Failed to load the approval user list: ${pError?.message || pError}`);
			if (!tmpHadCache)
			{
				this.renderPanelMessage(panel, 'Could not load the approver list. Reopen the panel to try again.');
			}
			return;
		}
		this.setCachedApproval('Users', fetchedData);
		if (!tmpHadCache || JSON.stringify(tmpCached) !== JSON.stringify(fetchedData))
		{
			this.paintApprovalUserList(panel, fetchedData);
		}
	}

	/**
	 * Paint the approver list region from a payload.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {any[]} pData - The approver list payload
	 * @return {void}
	 */
	paintApprovalUserList(pPanel, pData)
	{
		// handle empty message display
		if (!pData || !Array.isArray(pData) || pData.length === 0)
		{
			this.renderPanelMessage(pPanel, 'No users available at this time.');
			return;
		}
		pPanel.innerHTML = '';
		pData.forEach((item) =>
		{
			const newItem = document.createElement('div');
			newItem.classList.add('panel-block');
			newItem.innerHTML =
			`<span class="panel-icon">
				<i class="fa fa-fw fa-user"></i>
			</span>
			<span>${ item.NameFirst } ${ item.NameLast }</span>
			<span class="has-text-text-65 is-size-7 pl-1">${ item.Title }</span>`;
			pPanel.appendChild(newItem);
		});
	}

	/**
	 * This function is used to update the style of the approval status based on the status of the document.
	 * @param {string} pStatus - The status of the document
	 * @return {void}
	 * @example
	 * updateApprovalsStyleState('Draft');
	 * updateApprovalsStyleState('Submit');
	 */
	updateApprovalsStyleState(pStatus)
	{
		const documentStatus = pStatus || this.pict.AppData?.DocumentData?.ReportData?.Status;
		const backgroundColor = this.pict.providers.DocumentProvider.getApprovalStatusStyle(pStatus).backgroundColor;
		const iconClass = this.pict.providers.DocumentProvider.getApprovalStatusStyle(pStatus).iconClass;

		this.pict.fable.log.info(`Updating approval style state based on status: ${documentStatus}`, { iconClass, backgroundColor });
		this.pict.settings.HeadlightPanels.Configuration.NavBar.Brand.iconClass = iconClass;
		this.pict.settings.HeadlightPanels.Configuration.NavBar.Brand.wrapperClass = backgroundColor;
		this.pict.settings.HeadlightPanels.Configuration.CurrentStatus.iconClass = iconClass;
		this.pict.settings.HeadlightPanels.Configuration.CurrentStatus.wrapperClass = backgroundColor;
	}
}

module.exports = HeadlightPaneStatus;
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693}],795:[function(require,module,exports){
const libPictView = require('pict-view');
const { v4: uuidv4 } = require('uuid');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ValidationsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
 * @typedef {Object} SeverityTreatment
 * @property {string} Label             - Human-readable label (e.g. "Warning").
 * @property {string} IconClass         - FontAwesome icon classes (e.g. "fas fa-fw fa-triangle-exclamation").
 * @property {string} AccentClass       - Bulma color modifier applied to the panel-block (e.g. "is-warning").
 * @property {string} TextClass         - Bulma text-color helper (e.g. "has-text-warning-dark").
 * @property {string} BackgroundClass   - Bulma background-tone helper (e.g. "has-background-warning-light").
 * @property {string} BorderColorVar    - CSS variable used for the left accent border (e.g. "var(--bulma-warning)").
 */

/**
 * @typedef {Object} LogInput
 * @property {string} Message
 * @property {string=} Severity         - One of the keys in the severity map (info, warning, error, success, debug, ...). Case-insensitive.
 * @property {function=} onClickHandler
 */

/**
 * @typedef {Object} ValidationLogEntry
 * @property {string} Key
 * @property {string} Log
 * @property {string} Severity
 * @property {function=} onClickHandler
 */

/**
 * @typedef {Object} ValidationsSection
 * @property {string} Key
 * @property {string} Name
 * @property {ValidationLogEntry[]} Logs
 * @property {boolean=} Collapsed              - Persistent collapse state, flipped by toggleSectionCollapse.
 * @property {string=} ToggleKey               - Computed in onBeforeRenderAsync; identifies the collapsible group in DOM data attributes.
 * @property {string=} HiddenClass             - Computed in onBeforeRenderAsync; 'is-hidden' when Collapsed, '' otherwise.
 * @property {string=} ChevronIconClass        - Computed in onBeforeRenderAsync; 'fa-chevron-right' when Collapsed, 'fa-chevron-down' otherwise.
 */

/**
 * Default severity treatments. Forms can extend or override these via
 * `registerSeverityTreatments(...)` instead of editing this file.
 *
 * @type {Record<string, SeverityTreatment>}
 */
const DEFAULT_SEVERITY_MAP =
{
	info:
	{
		Label: 'Info',
		IconClass: 'fas fa-fw fa-circle-info',
		AccentClass: 'is-info',
		TextClass: 'has-text-info-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-info-dark)',
	},
	success:
	{
		Label: 'Success',
		IconClass: 'fas fa-fw fa-circle-check',
		AccentClass: 'is-success',
		TextClass: 'has-text-success-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-success-dark)',
	},
	warning:
	{
		Label: 'Warning',
		IconClass: 'fas fa-fw fa-triangle-exclamation',
		AccentClass: 'is-warning',
		TextClass: 'has-text-warning-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-warning-dark)',
	},
	error:
	{
		Label: 'Error',
		IconClass: 'fas fa-fw fa-circle-exclamation',
		AccentClass: 'is-danger',
		TextClass: 'has-text-danger-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-danger-dark)',
	},
	debug:
	{
		Label: 'Debug',
		IconClass: 'fas fa-fw fa-bug',
		AccentClass: 'is-dark',
		TextClass: 'has-text-grey-lighter',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-grey-dark)',
	},
	default:
	{
		Label: 'Note',
		IconClass: 'fas fa-fw fa-circle-dot',
		AccentClass: 'is-dark',
		TextClass: 'has-text-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-grey-light)',
	},
};

class HeadlightPaneValidations extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// we'll need to keep track of logs here for re-rendering the pane
		this.HeadlightPaneValidationLog = [];
		/** @type {ValidationsSection[]} */
		this.HeadlightPaneValidationSections = [];

		// Severity map is per-instance so callers can layer in form-specific treatments
		// without leaking into other apps that share this view module. Deep-copy each
		// treatment so registerSeverityTreatments() can mutate fields safely.
		/** @type {Record<string, SeverityTreatment>} */
		this._severityMap = {};
		for (const key of Object.keys(DEFAULT_SEVERITY_MAP))
		{
			this._severityMap[key] = Object.assign({}, DEFAULT_SEVERITY_MAP[key]);
		}
	}

	/**
	 * Merge custom severity treatments into the active severity map. Each entry in
	 * `pCustomMap` is shallow-merged onto the existing treatment for that key, so
	 * callers can override just `IconClass` (for example) without re-stating every
	 * other field. New keys are added wholesale.
	 *
	 * @param {Record<string, Partial<SeverityTreatment>>} pCustomMap
	 */
	registerSeverityTreatments(pCustomMap)
	{
		if (!pCustomMap || typeof pCustomMap !== 'object')
		{
			return;
		}
		for (const rawKey of Object.keys(pCustomMap))
		{
			const key = String(rawKey).toLowerCase();
			const existing = this._severityMap[key] || this._severityMap.default;
			this._severityMap[key] = Object.assign({}, existing, pCustomMap[rawKey]);
		}
	}

	/**
	 * Resolve a severity string (case-insensitive) to a treatment, falling back to
	 * the `default` treatment if the key is missing.
	 *
	 * @param {string=} pSeverity
	 * @return {SeverityTreatment & { Key: string }}
	 */
	getSeverityTreatment(pSeverity)
	{
		const key = (pSeverity ? String(pSeverity).toLowerCase() : 'default');
		const treatment = this._severityMap[key] || this._severityMap.default;
		return Object.assign({ Key: this._severityMap[key] ? key : 'default' }, treatment);
	}

	/**
	 * @return {ValidationsSection[]}
	 */
	get sections()
	{
		return this.HeadlightPaneValidationSections;
	}

	/**
	 * @return {ValidationLogEntry[]}
	 */
	get validations()
	{
		return this.sections.map((s) => s.Logs).flat();
	}

	/**
	 *
	 * @param {string} sectionKey
	 * @return {ValidationsSection | undefined}
	 */
	getSection(sectionKey)
	{
		return this.sections.find((s) => s.Key === sectionKey);
	}

	indexOfSection(sectionKey)
	{
		return this.sections.findIndex((s) => s.Key === sectionKey);
	}

	/**
	 *
	 * @param {string} logKey
	 * @return {ValidationLogEntry | undefined}
	 */
	getLogEntry(logKey)
	{
		return this.validations.find((l) => l.Key === logKey);
	}

	/**
	 * @param {LogInput} logInput
	 * @return {ValidationLogEntry}
	 */
	generateLogEntry(logInput)
	{
		const treatment = this.getSeverityTreatment(logInput.Severity);
		const key = uuidv4();
		// Row-style entry: full-width with an 8px leading border whose
		// color is driven by --hl-log-row-accent-color (panels-logs.scss).
		// We set the var inline from `treatment.BorderColorVar` so custom
		// severities registered via registerSeverityTreatments() pick up
		// their own accent color end-to-end. The `severity-${Key}` and
		// Bulma `is-*` classes provide the same fallback for built-in
		// severities, and `treatment.AccentClass` stays on the row so
		// existing callers/tests that look for it still match.
		// `BackgroundClass` is intentionally NOT applied — the panel's
		// dark surface stays clean and the leading border carries the
		// severity tone. `TextClass` styles the label line only.
		const log = /*html*/`
		<div class="hl-log-row severity-${treatment.Key} ${treatment.AccentClass} is-clickable"
			style="--hl-log-row-accent-color: ${treatment.BorderColorVar};"
			onclick="_Pict.views.HeadlightPaneValidations.onClickEntry('${key}')">
			<p class="hl-log-row-label ${treatment.TextClass}">
				<span class="icon"><i class="${treatment.IconClass}" aria-hidden="true"></i></span>
				<span>${treatment.Label}</span>
			</p>
			<p class="hl-log-row-message">${logInput.Message}</p>
		</div>`;
		return {
			Key: key,
			Log: log,
			Severity: treatment.Key,
			onClickHandler: logInput.onClickHandler,
		};
	}

	/**
	 * Normalize the variadic / array message arguments accepted by addLogSection
	 * and addToLogSection. Allows callers to use any of:
	 *   - a single LogInput object: fn(key, { Message: 'x' })
	 *   - spread args:               fn(key, msg1, msg2, msg3)
	 *   - a single array:            fn(key, [msg1, msg2])
	 *
	 * @param {(LogInput|LogInput[])[]} pRestArgs - The rest-collected `...messages` argument.
	 * @return {LogInput[]}
	 * @private
	 */
	_normalizeMessages(pRestArgs)
	{
		if (pRestArgs.length === 1 && Array.isArray(pRestArgs[0]))
		{
			return pRestArgs[0];
		}
		return /** @type {LogInput[]} */ (pRestArgs);
	}

	/**
	 * Append messages to a section's existing logs (creates the section if it doesn't exist).
	 *
	 * @param {string} sectionKey
	 * @param {...(LogInput|LogInput[])} messages - One or more LogInput objects, spread or as an array.
	 */
	addToLogSection(sectionKey, ...messages)
	{
		const list = this._normalizeMessages(messages);
		let section = this.getSection(sectionKey);
		if (!section)
		{
			section = { Key: sectionKey, Name: sectionKey, Logs: [] };
			// Append new sections so they line up with the order the form's
			// validators registered them (and, by extension, the visual order
			// of the form content itself).
			this.sections.push(section);
		}
		const newLogEntries = list.map((m) => this.generateLogEntry(m));
		// Append within the section too so logs read top-down in the order
		// the validator emitted them.
		section.Logs.push(...newLogEntries);

		this.pict.views.HeadlightPanels.updateNavButtonBadge('Validations', this.validations.length);
		this.render();
	}

	/**
	 * Replace a section's logs with a new set (creates the section if it doesn't exist).
	 *
	 * @param {string} sectionKey
	 * @param {...(LogInput|LogInput[])} messages - One or more LogInput objects, spread or as an array.
	 */
	addLogSection(sectionKey, ...messages)
	{
		const list = this._normalizeMessages(messages);
		const newLogEntries = list.map((m) => this.generateLogEntry(m));
		const existingIndex = this.indexOfSection(sectionKey);
		if (existingIndex >= 0)
		{
			this.sections[existingIndex].Logs = newLogEntries;
		}
		else
		{
			// Append new sections so they line up with the order the form's
			// validators registered them.
			this.sections.push({ Key: sectionKey, Name: sectionKey, Logs: newLogEntries });
		}

		this.pict.views.HeadlightPanels.updateNavButtonBadge('Validations', this.validations.length);
		this.render();
	}

	/**
	 *
	 * @param {string} sectionKey
	 */
	clearSection(sectionKey)
	{
		const index = this.indexOfSection(sectionKey);
		if (index < 0)
		{
			return;
		}
		this.sections.splice(index, 1);

		this.pict.views.HeadlightPanels.updateNavButtonBadge('Validations', this.validations.length);
		this.render();
	}

	generateFlatLogsList()
	{
		this.HeadlightPaneValidationLog = this.validations;
	}

	/**
	 * Compute the data-attribute toggle key used to wire each section's header
	 * to `toggleCollapsiblePanelBlockGroup`. Prefixed so it can't collide with
	 * other collapsibles in the panel pane.
	 *
	 * @param {string} sectionKey
	 * @return {string}
	 * @private
	 */
	_getSectionToggleKey(sectionKey)
	{
		return `ValidationsSection-${sectionKey}`;
	}

	/**
	 * Flip the collapsed state for a section. Updates the persistent
	 * `Collapsed` flag on the section data so the state survives the next
	 * re-render, and toggles the DOM directly via the existing
	 * `toggleCollapsiblePanelBlockGroup` helper for snappy UX.
	 *
	 * @param {string} sectionKey
	 */
	toggleSectionCollapse(sectionKey)
	{
		const section = this.getSection(sectionKey);
		if (!section)
		{
			return;
		}
		section.Collapsed = !section.Collapsed;
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(this._getSectionToggleKey(sectionKey));
	}

	/**
	 * Lifecycle hook that runs ahead of every render — both sync `render()`
	 * and `renderAsync()` flows route through this (the base class's
	 * onBeforeRenderAsync delegates to onBeforeRender). Recomputes the flat
	 * log list used by the empty-state conditional and pre-computes
	 * per-section presentation strings for the section template.
	 *
	 * @param {any} _pRenderable
	 * @return {boolean}
	 */
	onBeforeRender(_pRenderable)
	{
		this.generateFlatLogsList();
		for (const section of this.sections)
		{
			section.ToggleKey = this._getSectionToggleKey(section.Key);
			section.HiddenClass = section.Collapsed ? 'is-hidden' : '';
			section.ChevronIconClass = section.Collapsed ? 'fa-chevron-right' : 'fa-chevron-down';
		}
		return true;
	}

	/**
	 *
	 * @param {string} logKey
	 */
	onClickEntry(logKey)
	{
		this.pict.log.debug(`[Pane-Validations] onClickEntry logKey[${logKey}]`);
		const logEntry = this.getLogEntry(logKey);
		if (!logEntry)
		{
			this.pict.log.error(`[onClickEntry] logKey[${logKey}] is missing`);
			return;
		}
		if (typeof(logEntry.onClickHandler) === 'function')
		{
			this.pict.log.debug(`[Pane-Validations] onClickEntry logKey[${logKey}] calling onClickHandler()`);
			logEntry.onClickHandler();
			return;
		}
		// default behavior: highlight source dom element and shift focus to it
	}
}

module.exports = HeadlightPaneValidations;
module.exports.DEFAULT_SEVERITY_MAP = DEFAULT_SEVERITY_MAP;

// additional view-specific templates
const viewSpecificTemplates = [
	{
		Hash: 'HeadlightPanels-ValidationPanel-Content',
		Template: /*html*/`{~TS:HeadlightPanels-ValidationPanel-Content-Section:Pict.views.HeadlightPaneValidations.HeadlightPaneValidationSections~}`,
	},
	{
		Hash: 'HeadlightPanels-ValidationPanel-Content-Section',
		Template: /*html*/`
		<div class="hl-log-section">
			<div class="hl-log-section-header" data-collapsible-toggle="{~D:Record.ToggleKey~}" onclick="_Pict.views.HeadlightPaneValidations.toggleSectionCollapse('{~D:Record.Key~}')">
				<span class="hl-log-section-icon icon">
					<i class="fas fa-fw fa-list-check" aria-hidden="true"></i>
				</span>
				<span class="hl-log-section-name">{~D:Record.Name~}</span>
				<span class="hl-log-section-badge">{~D:Record.Logs.length~}</span>
				<span class="hl-log-section-chevron icon">
					<i class="fas fa-fw {~D:Record.ChevronIconClass~}" aria-hidden="true"></i>
				</span>
			</div>
			<div data-collapsible-content="{~D:Record.ToggleKey~}" class="hl-log-section-body {~D:Record.HiddenClass~}">
				{~TS:HeadlightPanels-ValidationPanel-Content-LogEntry:Record.Logs~}
			</div>
		</div>
		`,
	},
	{
		Hash: 'HeadlightPanels-ValidationPanel-Content-LogEntry',
		Template: /*html*/`{~D:Record.Log~}`,
	},
	{
		Hash: 'HeadlightPanels-ValidationPanel-EmptyMessage',
		Template: /*html*/`
		<div class="hl-log-row severity-success is-success" style="border-left-width: 5px; padding: 0.85rem 1rem; text-align: center;">
			<p class="hl-log-row-label has-text-success-light is-justify-content-center" style="font-size: 0.85rem;">
				<span class="icon"><i class="fas fa-fw fa-circle-check" aria-hidden="true"></i></span>
				<span>All clear</span>
			</p>
			<p class="hl-log-row-message">No validation issues to address right now.</p>
		</div>`,
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":814,"pict-view":693,"uuid":758}],796:[function(require,module,exports){
const PictViewClass = require('pict-view');
const DefaultConfiguration = require('../configuration/HeadlightPanels-Configuration-Default.json');

const libHeadlightPaneValidations = require('./HeadlightPanels-Pane-Validations.js');
const libDocumentStateDisplay = require('../behaviors/DocumentStateDisplay.js');
const libHeadlightPaneNavigation = require('./HeadlightPanels-Pane-Navigation.js');
const libHeadlightPaneObservations = require('./HeadlightPanels-Pane-Observations.js');
const libHeadlightPaneSecret = require('./HeadlightPanels-Pane-Secret.js');
const libHeadlightPaneProfile = require('./HeadlightPanels-Pane-Profile.js');
const libHeadlightPaneSettings = require('./HeadlightPanels-Pane-Settings.js');
const libHeadlightPaneSolver = require('./HeadlightPanels-Pane-Solver.js');
const libPictFormSolver = require('./Pict-Form-Solver.js');
const libHeadlightPaneStatus = require('./HeadlightPanels-Pane-Status.js');
const libHeadlightPaneBridges = require('./HeadlightPanels-Pane-Bridges.js');
const libHeadlightPaneDocuments = require('./HeadlightPanels-Pane-Documents.js');
const libHeadlightPaneSamples = require('./HeadlightPanels-Pane-Samples.js');
const libHeadlightPaneCustom = require('./HeadlightPanels-Pane-Custom.js');
const libHeadlightPanelsFableService = require('../services/HeadlightPanels-Fable-Service.js');
const libHeadlightModalService = require('../../../../lib/web/headlight-modal/Headlight-Modal-Service.js');
const libMaterialsFormManagerService = require('../../../../lib/service/materials-form-manager/Materials-Form-Manager.js');
const libHeadlightPopoverService = require('../../../../lib/web/headlight-popover/Headlight-Popover-Service.js');
const libNativeBridgeService = require('../../../../lib/web/native-bridge/index.js');
const libEntityProvider = require('../../../../web/providers/Entity-Provider.js');
const libQRPanel = require('./QRPanel.js');
const libHeadlightToastAdapter = require('../behaviors/HeadlightToastAdapter.js');

// Where remembered pane widths live between sessions. They are a cosmetic hint for the loading
// skeleton only -- nothing behaves differently when they are missing, stale or unreadable.
const _PaneWidthStorageKey = 'HeadlightPanels.PaneWidths';

/** @typedef {import('pict') & import('fable') &
 *   {
 *     log: any,
 *     instantiateServiceProviderWithoutRegistration: (hash: String) => any,
 *     instantiateServiceProviderIfNotExists: (hash: string) => any,
 *     TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking'),
 *     MetaTemplate: any,
 *     fable: import('fable'),
 *     HeadlightPanels: import('../services/HeadlightPanels-Fable-Service.js'),
 *     HeadlightRestClient: import('headlight-rest-client'),
 *     BridgeDocumentManager: import('../../../../lib/service/headlight-bridge-document-manager'),
 *     PictApplication: InstanceType<import('headlight-document-application')>,
 *     HeadlightModal: libHeadlightModalService,
 *	   HeadlightPopover: libHeadlightPopoverService,
 *     views: {
 *       HeadlightPanels: HeadlightPanels,
 *     },
 *   }
 * } Pict */
class HeadlightPanels extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		// set the default configuration for the view
		this.setDefaultPanelConfiguration();
		// panel states
		this.LeftPanelActive = false;
		this.LeftPanelPinned = false;
		this.LeftPanelMode = '';
		this.LeftPanelView = '';
		this.RightPanelActive = false;
		this.RightPanelPinned = false;
		this.RightPanelMode = '';
		this.RightPanelView = '';
		this.MinimumInputLengthForSearch = 0;
		// Width of each pane the last time it rendered, so the loading skeleton can hold the panel at the
		// width the content is about to need. The wrapper shrinks to fit, and panes vary widely (a
		// Navigation pane is ~230px where Observations hits the 50vw cap), so there is no useful default.
		this.PaneWidths = this.loadPaneWidths();

		// Adapter that translates legacy object-first toast options into Pict-Section-Modal
		// toast calls (type mapping, single-toast, duplicate throttle, HTML handling).
		this._ToastAdapter = new libHeadlightToastAdapter({ ThrottleWindowMS: 1000 });

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
		this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });

		this.pict.MetaTemplate.addPattern('{~CacheBustPostfix:', '~}', (pHash, pData, fCallback) =>
		{
			return `?t=${ new Date().getTime() }`;
		});

		// add the ".is-hidden" class to the element if the browser is iOS and the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideOniOS:', '~}', (pHash, pData, fCallback) =>
		{
			// do we want to hide the element T/F value
			const tmpHideValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// check if the URL param flag is set to hide the download button by parent apps (SmartForms, etc.)
			const tmpURLParamFlag = new URLSearchParams(window.location.search).get('hideDownloadButton');
			// check if the user agent is iOS (works for browsers, not webview apps)
			const tmpIsIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			// if the hide value is true and the URL param flag is set or the user agent is iOS, return the hidden
			return tmpHideValue && (tmpURLParamFlag || tmpIsIOS) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~Hide:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpValue ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is false
		this.pict.MetaTemplate.addPattern('{~Show:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpValue ? '' : 'is-hidden';
		});

		// do return the value in span tag if the passed value is true and the value is not empty
		this.pict.MetaTemplate.addPattern('{~If:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const tmpDataId = pData && pData.id ? `id="${pData.id}-Text"` : '';
			return tmpValue && tmpValue.length ? `<span ${tmpDataId}>` + tmpValue + '</span>' : '';
		});

		// A document's workflow state as a person should read it. The approval workflow authors a
		// display name per state (`StateName` - "In Test", "Waiting for District Lab Engineer
		// Approval"); `Status` is the machine hash the workflow keys off and was never meant for
		// the screen. Drafts are created by the API without consulting the workflow, so they carry
		// a Status and no StateName - the fallback is what keeps those from rendering blank.
		//
		// Takes the address of the RECORD, not of a field: `{~DocumentState:Record~}`.
		this.pict.MetaTemplate.addPattern('{~DocumentState:', '~}', (pHash, pData, fCallback) =>
		{
			return libDocumentStateDisplay.resolveDocumentStateDisplay(this.pict.resolveStateFromAddress(pHash, pData, fCallback));
		});

		// replace the value with a mapped css class from the Observation Provider
		this.pict.MetaTemplate.addPattern('{~LabelClass:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.pict.providers.ObservationProvider.getLabelClassFromObservationTagObject(tmpRecord);
		});

		// replace the observation type with a mapped display name from the Observation Provider
		this.pict.MetaTemplate.addPattern('{~ObsTypeDisplay:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.pict.providers.ObservationProvider.getObservationMappedDetails(tmpRecord)?.Type || pData;
		});

		// take a code string and return a canvas QR code image
		this.pict.MetaTemplate.addPattern('{~QRCodeImage:', '~}', (pHash, pData, fCallback) =>
		{
			// if the record has a size option from the template string, use that build the QR code image
			// EX: "{~QRCodeImage:Record^128x128^~}" will return a 128x128 QR code image
			const tmpType = pHash.includes('^') && pHash.split('^')?.length > 2 ? pHash.split('^')[2] : null;
			const tmpSize = pHash.includes('^') ? pHash.split('^')[1] : null;
			const tmpHash = pHash.includes('^') ? pHash.split('^')[0] : pHash;
			const tmpRecord = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			if (!tmpRecord)
			{
				return '';
			}
			let tmpHeight;
			let tmpWidth;
			// if we have a size option, make sure it's in the correct format
			if (tmpSize && !tmpSize.includes('x'))
			{
				this.pict.fable.log.error('Invalid QR code size. Please use the format "128x128"');
				return '';
			}
			else
			{
				tmpHeight = tmpSize ? tmpSize.split('x')[1] : '128';
				tmpWidth = tmpSize ? tmpSize.split('x')[0] : '128';
			}
			// create the QR code canvas and return the image tag, adding a white border around the image
			const tmpCanvas = this.pict.providers.QRCodeProvider.create(tmpRecord, { width: tmpWidth, height: tmpHeight, type: tmpType });
			return `<img style="outline: 1px solid white" src="${tmpCanvas}" alt="QR Code" />`;
		});

		this.pict.MetaTemplate.addPattern('{~GoogleMapURL:', '~}', (pHash, pData, fCallback) =>
		{
			// if the record has a size option from the template string, use that to get the map URL
			// EX: "{~GoogleMapURL:Record^128x128^~}" will return the URL for a 128x128 map
			const tmpSize = pHash.includes('^') ? pHash.split('^')[1] : null;
			const tmpHash = pHash.includes('^') ? pHash.split('^')[0] : pHash;
			const tmpRecord = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			// pass the size option to the provider if it exists, it will handle the fallback if not
			return this.pict.providers.UtilityProvider.getGoogleMapURLFromEntityRecord(tmpRecord, { size: tmpSize });
		});

		// watch for the escape key to close the active panel(s)
		document.body.addEventListener('keydown', (event) =>
		{
			// close the modal or the panels on escape key press
			if (event.key === 'Escape')
			{
				if (this.AppData.FullScreenModalActive)
				{
					this.togglePanelFullScreenModal('close');
				}
				else
				{
					this.closeAllUnpinnedPanels();
				}
			}
		});
		// shared providers for core entities
		this.pict.addProvider('EntityDocumentProvider', { Entity: 'Document' }, libEntityProvider);
		this.pict.addProvider('EntityInspectionDocumentProvider', { Entity: 'InspectionDocumentJoin' }, libEntityProvider);
		this.pict.addProvider('EntityInspectionTypeProvider', { Entity: 'InspectionType' }, libEntityProvider);
		this.pict.addProvider('ConfigurationProvider', {}, require('../../../../web/providers/ConfigurationProvider.js'));
		this.pict.addProvider('UploadTracking', {}, require('../../../../web/providers/UploadTrackingProvider.js'));
		this.pict.addProvider('UtilityProvider', {}, require('../../../../web/providers/UtilityProvider.js'));
		this.pict.addProvider('DocumentProvider', {}, require('../../../../web/providers/DocumentProvider.js'));
		this.pict.addProvider('TestInstanceProvider', {}, require('../../../../web/providers/TestInstanceProvider.js'));
		this.pict.addProvider('ProjectProvider', {}, require('../../../../web/providers/ProjectProvider.js'));
		this.pict.addProvider('ObservationProvider', {}, require('../../../../web/providers/ObservationProvider.js'));
		this.pict.addProvider('LocationProvider', {}, require('../../../../web/providers/LocationProvider.js'));
		this.pict.addProvider('SampleProvider', {}, require('../../../../web/providers/SampleProvider.js'));
		this.pict.addProvider('SampleLogProvider', {}, require('../../../../web/providers/SampleLogProvider.js'));
		this.pict.addProvider('GeoProvider', {}, require('../../../../web/providers/GeoProvider.js'));
		this.pict.addProvider('FieldSettingsProvider', {}, require('../../../../web/providers/FieldSettingsProvider.js'));
		this.pict.addProvider('MaterialProvider', {}, require('../../../../web/providers/MaterialProvider.js'));
		this.pict.addProvider('MixDesignProvider', {}, require('../../../../web/providers/MixDesignProvider.js'));
		this.pict.addProvider('UserProvider', {}, require('../../../../web/providers/UserProvider.js'));
		this.pict.addProvider('MarkdownProvider', {}, require('../../../../web/providers/MarkdownProvider.js'));
		this.pict.addProvider('QRCodeProvider',
		{
			globalHandler: (e) =>
			{
				console.log('[HeadlightPanels-View] Received QREvent: ', e);
				if (e.event === 'scanned-Sample' && e.payload?.IDSample)
				{
					this.pict.views.SampleDetails.open(e.payload.IDSample, e.payload);
				}
				if (e.event === 'open' && e.payload.length && e.payload[0] === 'cart')
				{
					this.pict.views.QRPanel.open();
				}
			},
		}, require('../../../../web/providers/QRCodeProvider.js'));
		this.pict.addProvider('ObservationSetProvider', {}, require('../../../../web/providers/ObservationSetProvider.js'));
		this.pict.addProvider('ImportantFilesProvider', {}, require('../../../../web/providers/ImportantFilesProvider.js'));
		this.pict.addProvider('FormConversionProvider', {}, require('../../../../web/providers/FormConversionProvider.js'));
		this.pict.addProvider('FileNavigatorProvider', {}, require('../../../../web/providers/FileNavigatorProvider.js'));
		// TODO: how do we determine if need these included here vs just in dynamic forms?
		this.pict.addProvider('MixSpecificationProvider', {}, require('../../../../web/providers/MixSpecificationProvider.js'));
		this.pict.addProvider('ProductProvider', {}, require('../../../../web/providers/ProductProvider.js'));
		this.pict.addProvider('ProducerProvider', {}, require('../../../../web/providers/ProducerProvider.js'));
		this.pict.addProvider('PlantProvider', {}, require('../../../../web/providers/PlantProvider.js'));
		this.pict.addProvider('LabProvider', {}, require('../../../../web/providers/LabProvider.js'));
		this.pict.addProvider('LineItemProvider', {}, require('../../../../web/providers/LineItemProvider.js'));
		this.pict.addProvider('ProjectFileProvider', {}, require('../../../../web/providers/ProjectFileProvider.js'));
		// TODO: when CommentEntityJoin is complete - I think this needs to move to CORE
		this.pict.addProvider('CommentProvider', {}, require('../../../../web/providers/CommentProvider.js'));
		this.pict.addProvider('InspectionProvider', {}, require('../../../../web/providers/InspectionProvider.js'));

		// Isolated Views (these could be moved to the new location - are not exclusive to the panels)
		this.pict.addView('ObservationIncluded', {}, require('../views/Observation-View-Included.js'));
		this.pict.addView('ObservationCreateMedia', {}, require('../views/Observation-View-Create-Media.js'));
		this.pict.addView('ObservationSearch', {}, require('../views/Observation-View-Search.js'));
		this.pict.addView('ObservationDetails', {}, require('../views/Observation-View-Details.js'));
		this.pict.addView('ObservationAnnotation', {}, require('../views/Observation-Edit-Annotation.js'));
		this.pict.addView('AcademyView', {}, require('../views/Academy-View.js'));
		this.pict.addView('Inspection', {}, require('../views/Inspection-View.js'));
		this.pict.addView('ObservationSubImageSelector', {}, require('../views/Observation-Edit-SubImage.js'));
		this.pict.addView('TestInstanceWizard', {}, require('../views/TestInstance-Wizard.js'));
		this.pict.addView('ObservationSet', {}, require('./Observation-View-Sets.js'));
		this.pict.addView('SampleSearch', {}, require('../views/Sample-View-Search.js'));
		this.pict.addView('SampleDetails', {}, require('../views/Sample-View-Details.js'));
		this.pict.addView('SampleCreate', {}, require('../views/Sample-View-Create.js'));
		this.pict.addView('SampleScan', {}, require('../views/Sample-View-Scan.js'));
		this.pict.addView('SampleCurrent', {}, require('../views/Sample-View-Current.js'));
		this.pict.addView('DocumentSearch', {}, require('../views/Document-View-Search.js'));
		this.pict.addView('DocumentCreate', {}, require('../views/Document-View-Create.js'));
		this.pict.addView('DocumentCurrent', {}, require('../views/Document-View-Current.js'));
		this.pict.addView('DocumentDetails', {}, require('../views/Document-View-Details.js'));
		this.pict.addView('ProjectFileSearch', {}, require('../views/ProjectFile-View-Search.js'));
		this.pict.addView('CommentCurrent', {}, require('../views/Comment-View-Current.js'));
		this.pict.addView('PictFormsSolver', libPictFormSolver.default_configuration, libPictFormSolver);
		// Views
		this.pict.addView('HeadlightPaneValidations', libHeadlightPaneValidations.default_configuration, libHeadlightPaneValidations);
		this.pict.views.HeadlightPaneValidations.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneNavigation', libHeadlightPaneNavigation.default_configuration, libHeadlightPaneNavigation);
		this.pict.views.HeadlightPaneNavigation.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneObservations', libHeadlightPaneObservations.default_configuration, libHeadlightPaneObservations);
		this.pict.views.HeadlightPaneObservations.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneSecret', libHeadlightPaneSecret.default_configuration, libHeadlightPaneSecret);
		this.pict.views.HeadlightPaneSecret.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneProfile', libHeadlightPaneProfile.default_configuration, libHeadlightPaneProfile);
		this.pict.views.HeadlightPaneProfile.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneSettings', libHeadlightPaneSettings.default_configuration, libHeadlightPaneSettings);
		this.pict.views.HeadlightPaneSettings.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneSolver', libHeadlightPaneSolver.default_configuration, libHeadlightPaneSolver);
		this.pict.views.HeadlightPaneSolver.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneStatus', libHeadlightPaneStatus.default_configuration, libHeadlightPaneStatus);
		this.pict.views.HeadlightPaneStatus.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneBridges', libHeadlightPaneBridges.default_configuration, libHeadlightPaneBridges);
		this.pict.views.HeadlightPaneBridges.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneDocuments', libHeadlightPaneDocuments.default_configuration, libHeadlightPaneDocuments);
		this.pict.views.HeadlightPaneDocuments.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneSamples', libHeadlightPaneSamples.default_configuration, libHeadlightPaneSamples);
		this.pict.views.HeadlightPaneSamples.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('QRPanel', libQRPanel.default_configuration, libQRPanel);
		// Custom Panels
		const tmpCustomLeftPanelConfiguration = JSON.parse(JSON.stringify(libHeadlightPaneCustom.default_configuration));
		tmpCustomLeftPanelConfiguration.PanelName = 'Left';
		tmpCustomLeftPanelConfiguration.PanelTitle = 'Left Panel';
		tmpCustomLeftPanelConfiguration.PanelIcon = 'fa-circle-notch';
		tmpCustomLeftPanelConfiguration.PanelMode = '';
		tmpCustomLeftPanelConfiguration.PanelView = '';
		tmpCustomLeftPanelConfiguration.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneCustomLeft', tmpCustomLeftPanelConfiguration, libHeadlightPaneCustom);

		const tmpCustomRightPanelConfiguration = JSON.parse(JSON.stringify(libHeadlightPaneCustom.default_configuration));
		tmpCustomRightPanelConfiguration.PanelName = 'Right';
		tmpCustomRightPanelConfiguration.PanelTitle = 'Right Panel';
		tmpCustomRightPanelConfiguration.PanelIcon = 'fa-circle-notch';
		tmpCustomRightPanelConfiguration.PanelMode = '';
		tmpCustomRightPanelConfiguration.PanelView = '';
		tmpCustomRightPanelConfiguration.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneCustomRight', tmpCustomRightPanelConfiguration, libHeadlightPaneCustom);

		// Fable Service
		this.fable.addAndInstantiateServiceTypeIfNotExists('HeadlightPanels', libHeadlightPanelsFableService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('HeadlightModal', libHeadlightModalService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('MaterialsFormManager', libMaterialsFormManagerService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('NativeBridge', libNativeBridgeService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('HeadlightPopover', libHeadlightPopoverService);
		this.pict.serviceManager.addAndInstantiateServiceType('BridgeDocumentManager', require('../../../../lib/service/headlight-bridge-document-manager'));
	}

	onAfterInitialize()
	{
		this.pict.CSSMap.injectCSS();

		return super.onAfterInitialize();
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		this.pict.fable.log.info('Headlight Panels view onBeforeRender');

		this.pict.views.ObservationCreateMedia.instantiateConfiguration();

		this.pict.services.HeadlightPanels.checkIfPhoneDevice();

		// Apply the preferences that shape the first paint (theme, page width, navbar position) BEFORE
		// the template runs -- the navbar's position is read out of the configuration at render time, so
		// doing this afterwards makes the user watch it jump. The values are already in AppData, so this
		// costs nothing and waits on nothing.
		this.pict.views.HeadlightPaneSettings.applyPreRenderUserPreferences();

		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.fable.log.info('Headlight Panels view onAfterRenderAsync');

		// initialize context specific elements. Will show or hide based on the current context
		const isDocumentContext = this.pict.AppData?.DocumentData?.ReportData;
		isDocumentContext ? this.toggleContextSpecficElements('show') : this.toggleContextSpecficElements('hide');

		// set the body element offset for the fixed navbar
		this.setBodyElementOffsetForFixedNavbar();

		this.adjustBottomToolbarOptions();

		// The navbar renders the Current Samples button hidden by default. Re-apply the known state first
		// (synchronously, so a later render cannot clobber it), then refresh it from the server.
		this.applyCurrentSamplesButtonState();
		this.syncCurrentSamplesButtonState();
		// The navbar render recreates the (empty) auto-save indicator container.
		this.syncAutoSaveStatus();

		// login expired, redirect to login page
		if (!this.AppData.CurrentUser)
		{
			this.pict.fable.log.warn('No user found. Unable to load user settings.');
		}
		else
		{
			// load the user settings for the panels
			this.pict.views.HeadlightPaneSettings.loadUserPreferences();
		}

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Toggle the class name based on the action provided
	 * @param {HTMLElement} pElement - The element to toggle the class on
	 * @param {string} pAction - The action to take on the element (show, hide, toggle)
	 * @return {void}
	 */
	_toggleElementClass(pElement, pAction)
	{
		if (pAction === 'show')
		{
			pElement.classList.remove('is-hidden');
		}
		else if (pAction === 'hide')
		{
			pElement.classList.add('is-hidden');
		}
		else
		{
			pElement.classList.toggle('is-hidden');
		}
	}

	/**
	 * Some elements are hidden or shown based on the context of the content. This method toggles the visibility of these elements.
	 * @param {string} pAction - The action to take on the context specific elements (show, hide, toggle)
	 * @return {void}
	 */
	toggleContextSpecficElements(pAction)
	{
		const tmpNavBar = document.getElementById('HeadlightPanels-Navbar-Brand-Container');
		const tmpSaveButton = document.getElementById('HeadlightPanels-NavBar-Save-Button')?.parentElement;
		const tmpSolverButton = document.getElementById('HeadlightPanels-NavBar-Solver-Button')?.parentElement;
		const tmpFullScreenButton = document.getElementById('HeadlightPanels-Navbar-FullScreen-Button')?.parentElement;
		if (tmpNavBar)
		{
			this._toggleElementClass(tmpNavBar, pAction);
		}
		if (tmpSaveButton)
		{
			this._toggleElementClass(tmpSaveButton, pAction);
		}
		if (tmpSolverButton)
		{
			this._toggleElementClass(tmpSolverButton, pAction);
		}
		if (tmpFullScreenButton)
		{
			this._toggleElementClass(tmpFullScreenButton, pAction);
		}
	}

	/**
	 * Update the navbar once a document has been selected (or removed)
	 * @return {void}
	 */
	updatePanelsBasedOnDocumentContext()
	{
		// if this is a document/form context, show the approval actions branding and document save button
		const isDocumentContext = this.pict.AppData?.DocumentData?.ReportData;
		// if the status panel is enabled, update the approvals style state
		if (isDocumentContext && this.pict.settings.HeadlightPanels.Configuration.PanelList.find((panel) => panel.name === 'status'))
		{
			this.pict.views.HeadlightPaneStatus.updateApprovalsStyleState();
		}
		// re-render the buttons and the branding now that we have the document context
		this.pict.views.HeadlightPanels.renderAsync('HeadlightPanels-NavBar-Brand', null, null, null, () =>
		{
			this.pict.fable.log.info('Re-rendered the navbar branding');

			this.pict.views.HeadlightPanels.renderAsync('HeadlightPanels-NavBar-Button-Wrapper', null, null, null, () =>
			{
				this.pict.fable.log.info('Re-rendered the navbar buttons');
				// adjust the bottom toolbar options based on the context
				if (isDocumentContext)
				{
					this.toggleContextSpecficElements('show');
				}
				else
				{
					this.toggleContextSpecficElements('hide');
				}
				// the re-render above replaces the button element, so re-apply the locked/saving state
				this.syncSaveButtonState();
				// ...and empties the auto-save indicator's container along with it.
				this.syncAutoSaveStatus();
				this.applyCurrentSamplesButtonState();
				this.syncCurrentSamplesButtonState();
			});
		});
	}

	/**
	 * Reflect the current save/approval/locked state on the navbar Save button.
	 *
	 * Called both on every save-latch transition and from the navbar render path, since re-rendering the
	 * button wrapper replaces the element and drops any attribute set on the previous one. Derives entirely
	 * from state, so it is safe to call before the button exists — the next render picks it up.
	 * @return {void}
	 */
	syncSaveButtonState()
	{
		const tmpSaveButton = document.getElementById('HeadlightPanels-NavBar-Save-Button');
		if (!tmpSaveButton)
		{
			return;
		}
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		const tmpIsSaving = Boolean(tmpDocumentProvider?.IsSaving);
		const tmpIsTakingAction = Boolean(tmpDocumentProvider?.isTakingAction);
		const tmpIsLocked = Boolean(this.pict.AppData?.DocumentData?.ReportData?.Locked);
		// is-loading stays keyed to the save alone: a spinner on Save while the user is watching an
		// *approval* land reads as "it is saving", which is not what is happening.
		tmpSaveButton.classList.toggle('is-loading', tmpIsSaving);
		tmpSaveButton.setAttribute('aria-busy', (tmpIsSaving || tmpIsTakingAction) ? 'true' : 'false');
		if (tmpIsSaving || tmpIsTakingAction || tmpIsLocked)
		{
			tmpSaveButton.setAttribute('disabled', 'disabled');
			// The document is not locked yet during an approval action, so that reason outranks the others.
			tmpSaveButton.setAttribute('title', tmpIsTakingAction ? 'An approval action is in progress.' : (tmpIsLocked ? 'Document is locked and can not be saved.' : 'Saving...'));
		}
		else
		{
			tmpSaveButton.removeAttribute('disabled');
			tmpSaveButton.removeAttribute('title');
		}
	}

	/**
	 * Repaint the auto-save indicator that sits beside the navbar Save button.
	 *
	 * The AutoSave provider owns the state and pushes it into `AppData.AutoSave`; this only asks the
	 * template to redraw. Called on every auto-save state transition and from the navbar render path,
	 * because re-rendering the button wrapper replaces the container element. A no-op when the
	 * container is absent (a host application whose navbar has no Save button).
	 * @return {void}
	 */
	syncAutoSaveStatus()
	{
		if (!document.getElementById('HeadlightPanels-Navbar-AutoSaveStatus-Container'))
		{
			return;
		}
		// A one-shot parse rather than render('...'): this fires on every auto-save transition, and the
		// view's own render lifecycle re-instantiates the media configuration and re-probes the device
		// on the way through. None of that belongs on a 90-second timer.
		const tmpStatusHTML = this.pict.parseTemplateByHash('HeadlightPanels-NavBar-AutoSaveStatus', {});
		this.pict.ContentAssignment.assignContent('#HeadlightPanels-Navbar-AutoSaveStatus-Container', tmpStatusHTML);
	}

	/**
	 * Paint the navbar Current Samples button from the cached lookup result.
	 *
	 * Deliberately synchronous, and separate from the lookup: the navbar wrapper re-renders from
	 * configuration (which defaults the button to is-hidden) and replaces the element, so the state has to
	 * be re-applied on every render. An async apply loses that race whenever a render lands between the
	 * lookup starting and finishing -- which is exactly how this button ended up intermittently hidden.
	 * @return {void}
	 */
	applyCurrentSamplesButtonState()
	{
		const tmpWrapper = document.getElementById('HeadlightPanels-NavBar-CurrentSamples-Button')?.parentElement;
		if (!tmpWrapper)
		{
			return;
		}
		tmpWrapper.classList.toggle('is-hidden', !this.HasJoinedSamples);
	}

	/**
	 * Refresh whether this document has Samples joined to it, then paint the button.
	 *
	 * The DocumentPolyJoin rows are written server-side, so a Sample created on this form only shows up
	 * after a save round-trip -- hence this runs from the save-drain completion as well as the render path.
	 * Failures leave the button hidden rather than surfacing an error: it is an optional shortcut.
	 * @return {Promise<void>}
	 * @async
	 */
	async syncCurrentSamplesButtonState()
	{
		if (this._CurrentSamplesLookupInFlight)
		{
			return;
		}
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		let tmpHasSamples = false;
		if (tmpIDDocument)
		{
			this._CurrentSamplesLookupInFlight = true;
			try
			{
				const tmpJoins = await this.pict.providers.SampleProvider.getDocumentSampleJoins(tmpIDDocument);
				tmpHasSamples = Array.isArray(tmpJoins) && tmpJoins.length > 0;
			}
			catch (pError)
			{
				this.log.warn(`Could not resolve joined Samples for the Current Samples button: ${pError?.message || pError}`);
			}
			finally
			{
				this._CurrentSamplesLookupInFlight = false;
			}
		}
		this.HasJoinedSamples = tmpHasSamples;
		this.applyCurrentSamplesButtonState();
	}

	/**
	 * This method adds loading skeleton rows to the specified container.
	 * @param {string} pContainerID - The ID of the container to add the skeleton rows to.
	 * @param {number} [pRowCount] - The number of skeleton rows to add.
	 * @param {number} [pMinHeight] - The minimum height of each skeleton row.
	 * @return {void}
	 */
	addLoadingSkeletonRows(pContainerID, pRowCount, pMinHeight)
	{
		const tmpRowCount = pRowCount || 3;
		const tmpMinHeight = pMinHeight || '4.5rem'; // Bulma default height
		const tmpContainer = document.getElementById(pContainerID);
		if (!tmpContainer)
		{
			this.log.error('Container not found. Please check the ID you provided for skeleton loading UI.');
			return;
		}
		// get the inner width of the container to set the gradient overlay width to reduce the horizontal flicker
		const currentElementInnerWidth = tmpContainer.clientWidth;
		// clear the container before adding the skeleton rows
		tmpContainer.innerHTML = '';
		// add a gradient overlay to the skeleton rows to make it look like an inifinite scroll
		let tmpContent = `<div class="results-loading-gradient-overlay"></div>`;
		for (let i = 0; i < tmpRowCount; i++)
		{
			tmpContent += `<div class="panel-block skeleton-block has-background-text-40 mx-3 mb-1" style="min-height: ${tmpMinHeight}"></div>`;
		}
		// add a div to the end of the skeleton rows with the previous width to prevent the horizontal flicker
		tmpContent += `<div style="width: ${currentElementInnerWidth}px;"></div>`;
		// add the skeleton rows to the container
		tmpContainer.insertAdjacentHTML('beforeend', tmpContent);
	}

	/**
	 * This function is used to adjust the bottom toolbar options based on the context of the content. If the
	 * content is a document, the bottom toolbar is hidden.
	 * @param {boolean} [pIsDocumentContext=false] - The context of the content
	 * @return {void}
	 */
	adjustBottomToolbarOptions(pIsDocumentContext = false)
	{
		const tmpBottomToolbar = document.getElementById('HeadlightPanels-NavBar');
		if (!tmpBottomToolbar)
		{
			this.log.error('Bottom toolbar not found. Please check the ID you provided.');
			return;
		}
		if (pIsDocumentContext)
		{
			tmpBottomToolbar.classList.add('is-hidden');
		}
		else
		{
			tmpBottomToolbar.classList.remove('is-hidden');
		}
	}

	/**
	 * This function is used to close the panel via the x icon for itself.
	 * @param {Event} event - The event object
	 * @param {string} pPanelName - The name of the panel to close
	 * @return {void}
	 */
	closeThisPanel(event, pPanelName)
	{
		// if this panel is pinned, do nothing
		let tmpEventTargetName;
		if (event)
		{
			// if the target is a child of a pinned panel, don't close the panel
			const parentPanel = window.jQuery(event.target).parents('.hl-panel-wrapper')?.[0];
			if (parentPanel?.classList.contains('pinned-open'))
			{
				this.log.info('Panel is pinned open. Ignoring close request.');
				return;
			}
			tmpEventTargetName = event ? window.jQuery(event.target).parents('article[id]')?.[0]?.id : null;
			// strip the panel name from the ID if it's a panel (yuck)
			if (tmpEventTargetName)
			{
				tmpEventTargetName = tmpEventTargetName.replace('HeadlightPanels-', '').replace('Panel', '').toLowerCase();
			}
		}
		const tmpPanelName = pPanelName || tmpEventTargetName;
		if (!tmpPanelName)
		{
			this.log.error('Panel not found. Please check the ID you provided.');
			return;
		}
		this.handlePanelToggle(tmpPanelName, 'close');
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * This function is used to close all unpinned panels at once for background click and escape key hits.
	 * @return {void}
	 */
	closeAllUnpinnedPanels()
	{
		this.log.info('Closing all unpinned panels');
		// if the left panel has any pinned-open panels, don't close the wrapper
		const leftPanel = document.getElementById('HeadlightPanels-LeftPanel');
		if (leftPanel?.classList.contains('is-active') && !leftPanel?.classList.contains('pinned-open'))
		{
			this.togglePanel('left', 'close');
			this.LeftPanelActive = null;
		}
		// if the right panel has any pinned-open panels, don't close the wrapper
		const rightPanel = document.getElementById('HeadlightPanels-RightPanel');
		if (rightPanel?.classList.contains('is-active') && !rightPanel?.classList.contains('pinned-open'))
		{
			this.togglePanel('right', 'close');
			this.RightPanelActive = null;
		}
		// we assume that if the user is pressing escape/closing, they want to close any active media
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * This function is used to close all panels at once and discards all pinned states.
	 * @return {void}
	 */
	closeAllPanels()
	{
		this.log.info('Closing all panels, regardless of pinned state');
		// if the left panel has any pinned-open panels, don't close the wrapper
		const leftPanel = document.getElementById('HeadlightPanels-LeftPanel');
		if (leftPanel?.classList.contains('is-active'))
		{
			this.togglePanel('left', 'close');
			this.LeftPanelActive = null;
			this.LeftPanelPinned = false;
			document.body.style['marginLeft'] = '0';
		}
		// if the right panel has any pinned-open panels, don't close the wrapper
		const rightPanel = document.getElementById('HeadlightPanels-RightPanel');
		if (rightPanel?.classList.contains('is-active'))
		{
			this.togglePanel('right', 'close');
			this.RightPanelActive = null;
			this.RightPanelPinned = false;
			document.body.style['marginRight'] = '0';
		}
		// we assume that if the user is pressing escape/closing, they want to close any active media
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * This function is used to close all panels without prompting to save changes
	 * @return {void}
	 */
	closeAllPanelsWithoutPrompt()
	{
		this.log.info('Closing all panels, regardless of pinned state');
		// if the left panel has any pinned-open panels, don't close the wrapper
		const leftPanel = document.getElementById('HeadlightPanels-LeftPanel');
		if (leftPanel?.classList.contains('is-active'))
		{
			this.togglePanel('left', 'close');
			this.LeftPanelActive = null;
			this.LeftPanelPinned = false;
			document.body.style['marginLeft'] = '0';
		}
		// if the right panel has any pinned-open panels, don't close the wrapper
		const rightPanel = document.getElementById('HeadlightPanels-RightPanel');
		if (rightPanel?.classList.contains('is-active'))
		{
			this.togglePanel('right', 'close');
			this.RightPanelActive = null;
			this.RightPanelPinned = false;
			document.body.style['marginRight'] = '0';
		}
		// we assume that if the user is pressing escape/closing, they want to close any active media
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * Calls the close handler for the currently active panel based on the given location.
	 * @param {string} location - The panel location identifier (e.g., 'Left', 'Right').
	 * @returns {void}
	 */
	callCloseHandler(location)
	{
	/** @type {string} */
		const activePanelKey = 'ActivePanel' + location;

		/** @type {string | undefined} */
		const activePanelName = this[activePanelKey];

		if (!activePanelName)
		{
			this.pict.log.warn(`No active panel name found for key: ${activePanelKey}`);
			return;
		}

		/** @type {{ name: string, view: string }[]} */
		const panelList = this.pict.settings.HeadlightPanels?.Configuration?.PanelList || [];

		/** @type {{ name: string, view: string } | undefined} */
		const activePanel = panelList.find((panel) => panel.name === activePanelName);

		if (!activePanel)
		{
			this.pict.log.warn(`No panel found in PanelList with name: ${activePanelName}`);
			return;
		}

		/** @type {{ closeHandler?: Function } | undefined} */
		const panelView = this.pict.views[activePanel.view];

		if (panelView && typeof panelView.closeHandler === 'function')
		{
			panelView.closeHandler();
		}
		else
		{
			this.pict.log.warn(`No closeHandler found for panel view: ${activePanel.view}`);
		}
	}


	/**
	 * This function is used to toggle the visibility of both the panel and any content within the panel.
	 * @param {string} pPanelName - The name of the panel to toggle
	 * @param {string} pState - The forced state to toggle the panel to (open or close) - not setting this will just toggle the current state
	 * @param {function} [pCallback] - (optional) The callback function to execute after the panel is toggled
	 * @return {void}
	 * @example
	 * handlePanelToggle('Validations', 'open');
	 * handlePanelToggle('Status', 'close);
	 * handlePanelToggle('Settings');
	 *
	*/
	handlePanelToggle(pPanelName, pState, pCallback)
	{
		const tmpPanelSingular = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((panel) => panel.name === pPanelName.toLowerCase());
		const tmpPanelPlural = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((panel) => panel.name === (pPanelName + 's').toLowerCase());
		// TODO: refactor the panel names to be always singular to handle this stupid quirk better
		const tmpPanel = tmpPanelSingular || tmpPanelPlural;
		if (!tmpPanel)
		{
			this.log.error(`Panel not found in the default configuration: ${pPanelName}`);
			if (pCallback) pCallback();
			return;
		}
		const tmpLocation = tmpPanel.location;
		const tmpLocationCap = (tmpLocation.charAt(0).toUpperCase() + tmpLocation.slice(1));
		const tmpState = pState ? pState : 'toggle';
		// if this is panel is already active, close it
		if (this['ActivePanel' + tmpLocationCap] === tmpPanel.name && tmpState === 'toggle')
		{
			this.callCloseHandler(tmpLocationCap);
			// check if the active panel state on the DOM is active
			if (document.getElementById('HeadlightPanels-' + tmpLocationCap + 'Panel').classList.contains('is-active'))
			{
				this.log.info('Closing active panel');
				this['ActivePanel' + tmpLocationCap] = null;
				this.togglePanel(tmpLocation, 'close');
			}
			else
			{
				this.log.info('Opening active panel');
				this['ActivePanel' + tmpLocationCap] = tmpPanel.name;
				this.togglePanel(tmpLocation, 'open');
			}
			if (pCallback) pCallback();
			return;
		}
		// if a DIFFERENT panel is already active in this location and we're about to swap it out,
		// fire the outgoing panel's closeHandler so it can release any pending state (e.g. clearing
		// `is-loading` buttons on inputs that opened the panel). Without this, togglePanel's
		// "panel is already open" early-return swallows the close lifecycle and the previous panel's
		// pending work is silently abandoned.
		if (this['ActivePanel' + tmpLocationCap] && this['ActivePanel' + tmpLocationCap] !== tmpPanel.name)
		{
			this.callCloseHandler(tmpLocationCap);
		}
		// if we are in mobile view, we need to close the other panel if it's open
		if (this.pict.services.HeadlightPanels.isPhoneDevice)
		{
			// if the other panel is open, close it
			const otherPanelLocation = tmpLocation === 'left' ? 'right' : 'left';
			if (this['ActivePanel' + (otherPanelLocation.charAt(0).toUpperCase() + otherPanelLocation.slice(1))])
			{
				this.log.info(`Closing other panel: ${otherPanelLocation}`);
				this.callCloseHandler(otherPanelLocation.charAt(0).toUpperCase() + otherPanelLocation.slice(1));
				this['ActivePanel' + (otherPanelLocation.charAt(0).toUpperCase() + otherPanelLocation.slice(1))] = null;
				this.togglePanel(otherPanelLocation, 'close');
			}
			// TODO: Revisit this later if we need to deal with iOS Safari and the resize event for the dynamic url bar not respecting 100vh in CSS
			// window.addEventListener('resize', () =>
			// {
			// 	const style = window.getComputedStyle(document.querySelector('#HeadlightPanels-Container'));
			// 	const navBarHeight = style.getPropertyValue('--panels-navbar-height');
			// 	const computedHeightValue = `calc(${ window.innerHeight }px - ${ navBarHeight })`;
			// 	style.setProperty('--panels-panel-height', computedHeightValue);
			// });
		}
		this.log.info(`Rendering panel: ${tmpPanel.name} (${tmpPanel.view}) in ${tmpLocation} panel with forced state: ${tmpState}`);
		// Closing: there is nothing to show, so skip the content render entirely and just close.
		if (tmpState === 'close')
		{
			this['ActivePanel' + tmpLocationCap] = tmpPanel.name;
			this.togglePanel(tmpLocation, tmpState, () =>
			{
				if (pCallback) pCallback();
			});
			return;
		}
		// Open the panel FIRST, then render into it. Rendering first leaves the click with no feedback
		// at all for the whole render -- the panel does not even begin to slide in until the content is
		// ready -- and the slide is then pure added latency instead of cover for the render.
		const tmpPanelElement = document.getElementById(`HeadlightPanels-${tmpLocationCap}Panel`);
		if (!tmpPanelElement?.classList.contains('is-active'))
		{
			// The container still holds the previously opened pane's markup, so a closed panel has to be
			// cleared before it slides in or the user watches stale content arrive.
			this.showPaneLoadingSkeleton(tmpLocation, tmpPanel.name);
		}
		this['ActivePanel' + tmpLocationCap] = tmpPanel.name;
		// pCallback has always meant "content rendered AND the panel finished animating", so hold that
		// contract now that the two run concurrently rather than one after the other.
		let tmpPendingSteps = 2;
		const fStepComplete = () =>
		{
			tmpPendingSteps--;
			if (tmpPendingSteps < 1 && pCallback)
			{
				pCallback();
			}
		};
		this.togglePanel(tmpLocation, tmpState, fStepComplete);
		// A pane that fails mid-render would otherwise leave the panel stuck on the loading skeleton it
		// was just opened with, swallow the open callback, and let the error escape to the click handler.
		// Panes render their tab views in a serial chain, so one bad tab is enough to trigger this.
		let tmpRenderSettled = false;
		const fRenderComplete = (pError) =>
		{
			if (tmpRenderSettled)
			{
				return;
			}
			tmpRenderSettled = true;
			if (pError)
			{
				this.log.error(`Failed to render the ${tmpPanel.name} panel: ${pError?.message || pError}`);
				this.showPaneRenderError(tmpLocation);
			}
			else
			{
				this.log.info(`Rendered ${tmpPanel.name} panel content`);
				this.recordPaneWidth(tmpPanel.name, tmpLocationCap);
			}
			fStepComplete();
		};
		try
		{
			this.pict.views[tmpPanel.view].renderAsync(false, false, false, false, fRenderComplete);
		}
		catch (pError)
		{
			fRenderComplete(pError);
		}
	}

	removeLoadingSkeleton(pElement)
	{
		// if the parent element has the skeleton class, remove it there instead
		this.pict.providers.UtilityProvider.removeLoadingSkeleton(pElement);
	}

	/**
	 * Remember how wide a pane rendered, so its next loading skeleton can hold the panel at that width.
	 * @param {string} pPaneName - The pane that just rendered
	 * @param {string} pLocationCap - The capitalised panel location (Left or Right)
	 * @return {void}
	 */
	recordPaneWidth(pPaneName, pLocationCap)
	{
		const tmpPanel = document.getElementById(`HeadlightPanels-${pLocationCap}Panel`);
		if (!tmpPanel)
		{
			return;
		}
		const tmpWidth = Math.round(tmpPanel.getBoundingClientRect().width);
		if (tmpWidth < 1 || this.PaneWidths[pPaneName] === tmpWidth)
		{
			return;
		}
		this.PaneWidths[pPaneName] = tmpWidth;
		this.savePaneWidths();
	}

	/**
	 * Read the remembered pane widths back.
	 *
	 * Storage can be unavailable (private windows, blocked site data) or hold something unexpected, and
	 * this is only a hint for how wide to draw a loading skeleton, so any failure just starts us empty.
	 * @return {Object} Map of pane name to width in pixels
	 */
	loadPaneWidths()
	{
		try
		{
			const tmpStored = window.localStorage.getItem(_PaneWidthStorageKey);
			if (!tmpStored)
			{
				return {};
			}
			const tmpParsed = JSON.parse(tmpStored);
			if (!tmpParsed || typeof tmpParsed !== 'object' || Array.isArray(tmpParsed))
			{
				return {};
			}
			// a corrupted entry should never get to size a panel
			const tmpWidths = {};
			for (const tmpKey of Object.keys(tmpParsed))
			{
				const tmpValue = tmpParsed[tmpKey];
				if (typeof tmpValue === 'number' && isFinite(tmpValue) && tmpValue > 0)
				{
					tmpWidths[tmpKey] = tmpValue;
				}
			}
			return tmpWidths;
		}
		catch (pError)
		{
			this.log?.info(`Could not read the remembered panel widths: ${pError?.message || pError}`);
			return {};
		}
	}

	/**
	 * Persist the remembered pane widths, so only the first ever open of a pane in this browser draws
	 * its skeleton at the bare minimum width.
	 * @return {void}
	 */
	savePaneWidths()
	{
		try
		{
			window.localStorage.setItem(_PaneWidthStorageKey, JSON.stringify(this.PaneWidths));
		}
		catch (pError)
		{
			// full, disabled or unavailable -- the widths simply will not survive the reload
			this.log?.info(`Could not persist the remembered panel widths: ${pError?.message || pError}`);
		}
	}

	/**
	 * A remembered width, clamped into the band the CSS actually allows at the CURRENT viewport.
	 *
	 * Panes that hit the wrapper's cap remember the cap itself rather than their content, so a width
	 * stored on a wide screen would otherwise draw a skeleton wider than the panel can ever be on a
	 * narrow one.
	 * @param {string} pPaneName - The pane to look up
	 * @return {number} A usable width in pixels, or 0 when nothing is remembered
	 */
	getRememberedPaneWidth(pPaneName)
	{
		const tmpRemembered = this.PaneWidths[pPaneName];
		if (!tmpRemembered)
		{
			return 0;
		}
		const tmpViewportWidth = window.innerWidth || 0;
		if (!tmpViewportWidth)
		{
			return tmpRemembered;
		}
		// mirrors `.panel { min-width: 15vw }` and `.hl-panel-wrapper { max-width: 50vw }`
		return Math.min(Math.max(tmpRemembered, tmpViewportWidth * 0.15), tmpViewportWidth * 0.5);
	}

	/**
	 * Replace a panel's loading skeleton with a failure message.
	 *
	 * Without this a pane that throws mid-render leaves the panel pulsing on the skeleton forever, which
	 * reads as "still loading" rather than "this is broken".
	 * @param {string} pLocation - The panel location to fill (left or right)
	 * @param {string} [pMessage] - The message to display
	 * @return {void}
	 */
	showPaneRenderError(pLocation, pMessage)
	{
		const tmpLocationCap = (pLocation.charAt(0).toUpperCase() + pLocation.slice(1));
		const tmpPanel = document.getElementById(`HeadlightPanels-${tmpLocationCap}Panel`);
		if (!tmpPanel)
		{
			return;
		}
		const tmpNotification = document.createElement('div');
		tmpNotification.className = 'notification has-text-text-light is-dark m-3';
		tmpNotification.textContent = pMessage || 'This panel could not be loaded. Close it and try again.';
		tmpPanel.innerHTML = '';
		tmpPanel.appendChild(tmpNotification);
	}

	/**
	 * Paint a placeholder into a panel container so the panel can be shown before its pane has rendered.
	 *
	 * `.skeleton-block` carries its own min-height and pulse animation, so this needs no extra styling.
	 * @param {string} pLocation - The panel location to fill (left or right)
	 * @param {number} [pRowCount] - The number of placeholder rows to paint
	 * @return {void}
	 */
	showPaneLoadingSkeleton(pLocation, pPaneName, pRowCount)
	{
		const tmpLocationCap = (pLocation.charAt(0).toUpperCase() + pLocation.slice(1));
		const tmpPanel = document.getElementById(`HeadlightPanels-${tmpLocationCap}Panel`);
		if (!tmpPanel)
		{
			this.log.error(`Panel not found for the loading skeleton: [${pLocation}]`);
			return;
		}
		// Stand in for the pane as an actual `.panel`, so the placeholder picks up the panel's height and
		// its heading bar from the styles the real pane will use. Every pane has exactly one
		// `.panel-heading`, so this is always the right shape; the tabs strip that five of them add on
		// top of it is deliberately not reproduced.
		const tmpWrapper = document.createElement('article');
		tmpWrapper.className = 'panel is-active hl-pane-loading-skeleton';
		// The panel wrapper shrinks to fit, and it is normally the rendered pane that gives it a width.
		// Bare skeleton rows are much narrower than that, so without a width here the panel slides in as
		// a sliver and snaps wide when the content lands. Match the pane's own floor, then its last
		// known width when we have one.
		tmpWrapper.style.minWidth = '15vw';
		const tmpLastWidth = pPaneName ? this.getRememberedPaneWidth(pPaneName) : 0;
		if (tmpLastWidth)
		{
			tmpWrapper.style.width = `${tmpLastWidth}px`;
		}
		const tmpHeading = document.createElement('p');
		tmpHeading.className = 'panel-heading';
		// the heading draws from its padding rather than its content, but it still needs something in it
		tmpHeading.textContent = '\u00A0';
		tmpWrapper.appendChild(tmpHeading);
		for (let i = 0; i < (pRowCount || 5); i++)
		{
			const tmpRow = document.createElement('div');
			tmpRow.className = 'panel-block skeleton-block has-background-text-40 mx-3 mb-1';
			tmpWrapper.appendChild(tmpRow);
		}
		tmpPanel.innerHTML = '';
		tmpPanel.appendChild(tmpWrapper);
	}

	/**
	 * Add the theme class to the body to account for the navbar location offset
	 * @return {void}
	 */
	setBodyElementOffsetForFixedNavbar()
	{
		if (this.pict.settings.HeadlightPanels.Configuration.NavBar?.location === 'top')
		{
			document.body.classList.add('has-navbar-fixed-top');
			document.body.classList.remove('has-navbar-fixed-bottom');
		}
		else
		{
			document.body.classList.remove('has-navbar-fixed-top');
			document.body.classList.add('has-navbar-fixed-bottom');
		}
	}

	/**
	 * This function is used to set the default configuration for the view. It will blend any custom configuration with the default configuration.
	 * @return {void}
	 */
	setDefaultPanelConfiguration()
	{
		if (!this.pict.settings.HeadlightPanels)
		{
			this.pict.settings.HeadlightPanels = {};
		}
		this.pict.log.info('Setting default panel configuration.');
		this.pict.settings.HeadlightPanels.Configuration = Object.assign({}, DefaultConfiguration);
		// set the default configuration for reference in the view (for developers to see)
		this.pict.settings.HeadlightPanels.Configuration_Default = DefaultConfiguration;
	}

	/**
	 * This function is used to set the custom configuration for the view to be meshed with the default config on init.
	 * @param {Object} pConfiguration - The default configuration to set
	 * @return {void}
	 */
	setPanelConfiguration(pConfiguration)
	{
		this.pict.log.info('Setting custom panel configuration.');
		if (typeof pConfiguration !== 'object')
		{
			this.pict.log.error('Invalid configuration object provided. Please check the configuration object you provided.');
			return;
		}
		if (!this.pict.settings.HeadlightPanels)
		{
			this.pict.settings.HeadlightPanels = {};
		}
		this.pict.settings.HeadlightPanels.Configuration = { ...DefaultConfiguration, ...pConfiguration };
		// set the custom configuration for reference in the view (for developers to see)
		this.pict.settings.HeadlightPanels.Configuration_Custom = Object.assign({}, pConfiguration);
		// recompile and render the view with the new configuration
		this.pict.views.HeadlightPaneNavigation.compileNavigation();
	}

	/**
	 * @typedef {object} HeadlightToastOptions
	 * @property {string} message - The message to show (HTML permitted; rendered when it looks like markup or allowHTML is set).
	 * @property {string} [type='is-info'] - Legacy Bulma type class (is-info/is-success/is-warning/is-danger) or a PSM enum value.
	 * @property {number} [duration=3000] - Auto-dismiss delay in ms; 0 for a persistent toast.
	 * @property {string} [position='bottom-center'] - PSM position key.
	 * @property {boolean} [dismissible=true] - Show a close button.
	 * @property {boolean} [allowHTML] - Force raw-HTML rendering; auto-detected from the message when omitted.
	 * @property {boolean} [sticky=false] - Keep this toast up until dismissToast() takes it back. Exempt from
	 *   auto-dismiss, from the duplicate throttle, and from single-toast eviction. For state, not events.
	 */

	/**
	 * Resolve the Pict-Section-Modal view, tolerating both registration names in use
	 * (canonical 'Pict-Section-Modal' from the shared scaffold, and form-editor's 'PictSectionModal').
	 * @returns {?object}
	 */
	_resolveModal()
	{
		if (!this.pict || !this.pict.views)
		{
			return null;
		}
		return this.pict.views['Pict-Section-Modal'] || this.pict.views['PictSectionModal'] || null;
	}

	/**
	 * Show a toast notification to the user, customized based on the options provided.
	 * Delegates to Pict-Section-Modal via HeadlightToastAdapter (replaces the former bulma-toast wrapper).
	 * @param {HeadlightToastOptions} pOptions
	 * @returns {{ dismiss: function }}
	 */
	toast(pOptions)
	{
		const tmpNoop = { dismiss: () => {} };
		// Check if a message was provided, mininum requirement for a toast notification
		if (!pOptions || !pOptions.message)
		{
			this.pict.log.error('No message provided for toast notification');
			return tmpNoop;
		}

		const tmpModal = this._resolveModal();
		if (!tmpModal || typeof tmpModal.toast !== 'function')
		{
			this.pict.log.warn('Pict-Section-Modal unavailable; toast suppressed', { Message: pOptions.message });
			return tmpNoop;
		}

		const tmpPlan = this._ToastAdapter.translate(pOptions, Date.now());
		if (!tmpPlan)
		{
			// Duplicate suppressed by the throttle window.
			return tmpNoop;
		}

		// Single-toast: dismiss any prior toast before showing the new one, then track the new handle.
		this._ToastAdapter.trackHandle(null);
		const tmpHandle = tmpModal.toast(tmpPlan.message, tmpPlan.options);
		this._ToastAdapter.trackHandle(tmpHandle, tmpPlan.sticky);
		return tmpHandle;
	}

	/**
	 * Dismiss a toast this view handed out, releasing any sticky tracking it held.
	 * Tolerates the noop handle toast() returns when the modal view is unavailable or the throttle fired.
	 * @param {?{ dismiss: function }} pHandle - A handle returned by toast().
	 * @returns {void}
	 */
	dismissToast(pHandle)
	{
		this._ToastAdapter.releaseHandle(pHandle);
	}

	/**
	 * Announce a status message to assistive technology.
	 *
	 * Pict-Section-Modal renders toasts with no live-region semantics, so a screen reader never hears
	 * one at all. This keeps a single polite region on the body and rewrites it.
	 * @param {string} pMessage - The message to announce; an empty string clears the region.
	 * @returns {void}
	 */
	announceStatus(pMessage)
	{
		let tmpRegion = document.getElementById('HeadlightPanels-StatusLiveRegion');
		if (!tmpRegion)
		{
			tmpRegion = document.createElement('div');
			tmpRegion.id = 'HeadlightPanels-StatusLiveRegion';
			tmpRegion.className = 'is-sr-only';
			tmpRegion.setAttribute('role', 'status');
			tmpRegion.setAttribute('aria-live', 'polite');
			tmpRegion.setAttribute('aria-atomic', 'true');
			document.body.appendChild(tmpRegion);
		}
		tmpRegion.textContent = pMessage || '';
	}

	/**
	 * This handles the hide/show collapsing of a block group inside a pane of content.
	 * @param {string} pKey - the key of the group we are toggling
	 * @param {string} pState - the state to toggle the group to (open or close)
	 */
	toggleCollapsiblePanelBlockGroup(pKey, pState)
	{
		const group = document.querySelector(`[data-collapsible-toggle="${pKey}"]`);
		const content = document.querySelector(`[data-collapsible-content="${pKey}"]`);
		if (!group || !content)
		{
			return;
		}
		// handle forced open state
		if (pState === 'open')
		{
			content.classList.remove('is-hidden');
			content.classList.add('animate', 'animate__fadeIn', 'animate__faster');
			// if we have a chevron, turn it
			if (group.querySelector('.fa-chevron-right'))
			{
				group.querySelector('.fa-chevron-right').classList.replace('fa-chevron-right', 'fa-chevron-down');
			}
		}
		// handle forced close state
		else if (pState === 'close')
		{
			content.classList.add('is-hidden');
			// if we have a chevron, turn it
			if (group.querySelector('.fa-chevron-down'))
			{
				group.querySelector('.fa-chevron-down').classList.replace('fa-chevron-down', 'fa-chevron-right');
			}
		}
		// handle toggle state
		else
		{
			// if the content is hidden, show it
			if (content.classList.contains('is-hidden'))
			{
				content.classList.remove('is-hidden');
				// if we have a chevron, turn it
				if (group.querySelector('.fa-chevron-right'))
				{
					group.querySelector('.fa-chevron-right').classList.replace('fa-chevron-right', 'fa-chevron-down');
				}
			}
			// if the content is shown, hide it
			else
			{
				content.classList.add('is-hidden');
				// if we have a chevron, turn it
				if (group.querySelector('.fa-chevron-down'))
				{
					group.querySelector('.fa-chevron-down').classList.replace('fa-chevron-down', 'fa-chevron-right');
				}
			}
		}
	}

	/**
	 * This function is used to toggle the visibility of a panel.
	 * @param {string} pLocation - The location of the panel to toggle (left or right)
	 * @param {string} pState - The state to toggle the panel to (open or close)
	 * @param {function} [fCallback] - (optional) The callback function to execute after the panel is toggled
	 * @return {void}
	 * @example
	 * togglePanel('left', 'open');
	 * togglePanel('right', 'close');
	 */
	togglePanel(pLocation, pState, fCallback = () =>
	{})
	{
		if (!pLocation)
		{
			this.log.error('Panel location not found. Please check the location you provided.');
			fCallback();
			return;
		}
		// get the panel and panel wrapper (always capitalize the first letter of the location for the ID look up)
		const tmpLocationCap = (pLocation.charAt(0).toUpperCase() + pLocation.slice(1));
		const tmpPanelID = `HeadlightPanels-${tmpLocationCap}Panel`;
		const tmpPanel = document.getElementById(tmpPanelID);
		// if the panel is not found, log an error and return
		if (!tmpPanel)
		{
			this.log.error(`Panel not found: [${pLocation}; id=${tmpPanelID}]  Please check the name you provided.`);
			fCallback();
			return;
		}
		// if the panel is already active, determine if we're closing it or opening another panel
		const isPanelActive = tmpPanel.classList.contains('is-active');
		if (isPanelActive && pState === 'open')
		{
			this.log.info('Panel is already open');
			this['ActivePanel' + tmpLocationCap] = tmpPanel.id;
			fCallback();
			return;
		}
		if (!isPanelActive && pState === 'close')
		{
			this.log.info('Panel is already closed');
			this['ActivePanel' + tmpLocationCap] = null;
			fCallback();
			return;
		}
		// // account for the lefty mode setting
		// if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode)
		// {
		// 	pLocation = pLocation === 'left' ? 'right' : 'left';
		// }
		// if the panel is already active, close it
		if (isPanelActive && pState === 'close')
		{
			this.callCloseHandler(tmpLocationCap);
			this.log.info('Closing panel');
			tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateIn);
			tmpPanel.classList.add(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateOut);
			// set a timeout to remove the active/transition classes after the transition duration
			setTimeout(() =>
			{
				this.log.info('Closing panel');
				tmpPanel.classList.remove('is-active');
				tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateOut);
				this.fable.HeadlightPanels.clearUIHighlights();
				this.fable.HeadlightPanels[pLocation + 'PanelResetCustomWidth']();
				fCallback();
			}, this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateDuration);
		}
		else
		{
			this.log.info('Opening panel');
			// if the panel is not active, open it
			tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateOut);
			tmpPanel.classList.add(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateIn);
			tmpPanel.classList.add('is-active');

			// TODO: Revisit these once we separate out "sticky panel that won't close" vs "flex background content shifts when panel opens/closes"
			// for user settings to allow overlapping vs flexing background content (wip)
			// if (this.pict.views.HeadlightPaneSettings.readUserPreference(`PanelOverlap-${pLocation}`))
			// {
			// 	tmpPanel.classList.add('pinned-open');
			// 	document.body.style['margin' + tmpLocationCap] = tmpPanel.offsetWidth + 'px';
			// }
			// else
			// {
			// 	tmpPanel.classList.remove('pinned-open');
			// 	document.body.style['margin' + tmpLocationCap] = 0;
			// }

			// set a timeout to remove the active/transition classes after the transition duration
			setTimeout(() =>
			{
				tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateIn);
				fCallback();
			}, this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateDuration);
		}
	}

	/**
	 * A general utility function to toggle the visibility of the tab content within a panel.
	 * NOTE: this expects the ID pattern to follow this example:
	 * Tab Elements -> `#HeadlightPanels-{Context}Panel-Tabs`
	 * Tab Buttton -> `#HeadlightPanels-{Context}Panel-TabName`
	 * Tab Content -> `#HeadlightPanels-{Context}Panel-Content`
	 * @param {string} id - the ID of the panel to toggle
	 * @param {string} context - the context of the panel
	 * @return {void}
	 */
	toggleTabContent(id, context)
	{
		if (!id)
		{
			this.log.error('Panel ID not found. Please check the ID you provided.', id);
			return;
		}
		if (!context)
		{
			this.log.error('Panel context not found. Please check the context you provided.', context);
			return;
		}
		const panelID = `HeadlightPanels-${context}Panel`;
		const panel = document.getElementById(panelID);
		if (!panel)
		{
			this.log.error(`Panel not found: [${context}; id=${panelID}]  Please check the name you provided.`, panel);
			return;
		}
		// get the clicked tab and panel
		const tabs = document.getElementById('HeadlightPanels-' + context + 'Panel-Tabs').querySelectorAll('a');
		// remove active class from all tabs
		for (let i = 0; i < tabs.length; i++)
		{
			tabs[i].classList.remove('is-active');
		}
		document.getElementById(id + '-Tab').classList.add('is-active');
		// hide all panels
		const contentList = document.getElementById('HeadlightPanels-' + context + 'Panel').querySelectorAll('.panel-content');
		for (let i = 0; i < contentList.length; i++)
		{
			contentList[i].classList.add('is-hidden');
		}
		const activeContent = document.getElementById(id + '-Content');
		// show the clicked panel
		if (activeContent.classList.contains('is-hidden'))
		{
			activeContent.classList.remove('is-hidden');
		}
		else
		{
			activeContent.classList.add('is-hidden');
		}
	}

	/**
	 * This function is used to toggle the full screen modal with populated content.
	 * @param {string} pState - The forced state to toggle the modal to (open or close) - not setting this will just toggle the current state
	 * @param {Object} pOptions - Optional data to populate the modal with
	 * @return {void}
	 */
	togglePanelFullScreenModal(pState, pOptions)
	{
		const pData = pOptions || {};
		const tmpRenderableHash = pOptions?.RenderableHash || 'HeadlightPanels-FullScreenModal';
		const tmpContentDestinationAddress = pOptions?.ContentDestinationAddress || '#HeadlightPanels-FullScreenModal-Container';
		const tmpCallback = pOptions?.Callback || ((pData) =>
		{
			this.log.info('Rendered Headlight Panels fullscreen modal content with the following optional data:', pData);
		});
		// in case we have any active media playing (video, audio), pause it
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		// handle the forced state or the toggle state
		if (pState === 'close')
		{
			this.AppData.FullScreenModalActive = false;
			document.getElementById('HeadlightPanels-FullScreenModal-Container').innerHTML = '';
		}
		else if (pState === 'open')
		{
			this.AppData.FullScreenModalActive = true;
			this.pict.views.HeadlightPanels.renderAsync(tmpRenderableHash, tmpContentDestinationAddress, pData, false, tmpCallback);
		}
		else
		{
			this.AppData.FullScreenModalActive = !this.AppData.FullScreenModalActive;
			// if the modal is active, render the content
			if (this.AppData.FullScreenModalActive)
			{
				this.pict.views.HeadlightPanels.renderAsync(tmpRenderableHash, tmpContentDestinationAddress, pData, false, tmpCallback);
			}
			// if the modal is not active, clear the content
			else
			{
				document.getElementById('HeadlightPanels-FullScreenModal-Container').innerHTML = '';
			}
		}
	}

	/**
	 * This function is used to toggle the pin state of a panel.
	 * @param {string} pLocation - The location of the panel to toggle the pin state for
	 * @param {string} pContext - The context of the panel to toggle the pin state for
	 * @param {string} pState - The forced state to toggle the pin to (true or false) - not setting this will just toggle the current state
	 * @return {void}
	 */
	togglePanelPinState(pLocation, pContext, pState)
	{
		const locMap =
		{
			'left': 'Left',
			'right': 'Right',
		};
		pLocation = locMap[pLocation] || pLocation;
		const panelWrapperElement = pLocation ? document.getElementById('HeadlightPanels-' + pLocation + 'Panel') : document.getElementById('HeadlightPanels-LeftPanel');
		// get the location from the config
		let locationCap = panelWrapperElement.id.split('-')[1].replace('Panel', '');
		// update our pin state so we can track it in the AppData
		this.AppData[locationCap + 'PanelPinned'] = !this.AppData[locationCap + 'PanelPinned'];

		// account for lefty mode
		if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode)
		{
			if (locationCap === 'Left')
			{
				locationCap = 'Right';
			}
			else
			{
				locationCap = 'Left';
			}
		}
		// toggle the pinned-open class
		if (panelWrapperElement.classList.contains('pinned-open') && pState !== 'pin')
		{
			this.log.info('Removing pin from panel');
			panelWrapperElement.classList.remove('pinned-open');
			// reset the body padding
			document.body.style['margin' + locationCap] = 0;
		}
		else if (pState !== 'unpin')
		{
			this.log.info('Pinning panel open');
			panelWrapperElement.classList.add('pinned-open');
			// offset the body padding to account for the pinned panel
			document.body.style['margin' + locationCap] = panelWrapperElement.offsetWidth + 'px';
		}
	}

	/**
	 * This function is used to update the badge on the nav button for a panel.
	 * @param {string} pContext - The context of the panel to update the badge for
	 * @param {number} pLogCount - The number of logs to display in the badge
	 * @return {void}
	 * @example
	 * updateNavButtonBadge('HeadlightPanels-ErrorPanel');
	 */
	updateNavButtonBadge(pContext, pLogCount)
	{
		if (!pContext)
		{
			this.log.error('Panel context not found. Please check the context you provided.');
			return;
		}
		const panelButton = document.getElementById('HeadlightPanels-NavBar-' + pContext + '-Button');
		if (!panelButton)
		{
			this.log.error('Panel button not found. Please check the button you provided.');
			return;
		}
		// TODO: hoist this up to the configuration later
		const panelColorMap = {
			'Solver': 'is-warning',
			'Validations': 'is-danger',
		};
		// get the panel name and log count
		const logCount = pLogCount || 0;
		const navButtonWrapper = panelButton.parentElement;
		// always remove the last badge before adding a new one
		if (navButtonWrapper.querySelector('.badge'))
		{
			navButtonWrapper.removeChild(navButtonWrapper.querySelector('.badge'));
		}
		// only add a badge if there are logs to display
		if (navButtonWrapper && logCount > 0)
		{
			const badge = document.createElement('span');
			badge.classList.add('badge', panelColorMap[pContext] || 'is-info');
			badge.innerText = `${logCount}`;
			navButtonWrapper.append(badge);
		}
	}

	/**
	 * set the width of a panel to a custom (pre-determined) percentage width
	 * @param {String} pDirection - The direction of the panel to toggle
	 * @param {Number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	setPanelCustomWidth(pDirection, pPercentage)
	{
		const tmpDirections = [ 'left', 'right' ];
		const tmpWidths = [ 0, 20, 25, 33, 40, 50, 60, 67, 75, 80, 100 ];
		// validate the direction before we proceed
		if (!tmpDirections.includes(pDirection))
		{
			this.log.error('Invalid direction provided. Please provide a valid direction. Supported directions are:', tmpDirections);
			return;
		}
		// let's validate the width before we proceed
		if (!tmpWidths.find((width) => width == pPercentage))
		{
			this.log.error('Invalid percentage width provided. Please provide a valid percentage width. Supported widths are:', tmpWidths);
			return;
		}
		// reset the panel width before setting the new width
		this.resetPanelCustomWidth(pDirection);
		// get the panel and set the new width
		const tmpPanel = document.querySelector('.hl-panel-wrapper-' + pDirection);
		if (tmpPanel)
		{
			// remove all the width classes, then add the new width
			tmpPanel.classList.add('is-wide-' + pPercentage);
		}
	}

	/**
	 * Reset the width of a panel to default non-wide width
	 * @param {String} pDirection - The direction of the panel to reset
	 * @return {void}
	 */
	resetPanelCustomWidth(pDirection)
	{
		const tmpDirections = [ 'left', 'right' ];
		const tmpWidths = [ 0, 20, 25, 33, 40, 50, 60, 67, 75, 80, 100 ];
		// validate the direction before we proceed
		if (!tmpDirections.includes(pDirection))
		{
			this.log.error('Invalid direction provided. Please provide a valid direction. Supported directions are:', tmpDirections);
			return;
		}
		// get the panel and remove the width class
		const tmpPanel = document.querySelector('.hl-panel-wrapper-' + pDirection);
		if (tmpPanel)
		{
			// remove all the width classes
			tmpPanel.classList.remove(...tmpWidths.map((width) => 'is-wide-' + width));
		}
	}
}

module.exports = HeadlightPanels;
module.exports.default_configuration = require('../templates/HeadlightPanels-Templates-Default.js');

},{"../../../../lib/service/headlight-bridge-document-manager":3,"../../../../lib/service/materials-form-manager/Materials-Form-Manager.js":15,"../../../../lib/web/headlight-modal/Headlight-Modal-Service.js":242,"../../../../lib/web/headlight-popover/Headlight-Popover-Service.js":245,"../../../../lib/web/native-bridge/index.js":251,"../../../../web/providers/CommentProvider.js":853,"../../../../web/providers/ConfigurationProvider.js":855,"../../../../web/providers/DocumentProvider.js":856,"../../../../web/providers/Entity-Provider.js":857,"../../../../web/providers/FieldSettingsProvider.js":859,"../../../../web/providers/FileNavigatorProvider.js":861,"../../../../web/providers/FormConversionProvider.js":862,"../../../../web/providers/GeoProvider.js":863,"../../../../web/providers/ImportantFilesProvider.js":864,"../../../../web/providers/InspectionProvider.js":866,"../../../../web/providers/LabProvider.js":867,"../../../../web/providers/LineItemProvider.js":868,"../../../../web/providers/LocationProvider.js":869,"../../../../web/providers/MarkdownProvider.js":870,"../../../../web/providers/MaterialProvider.js":871,"../../../../web/providers/MixDesignProvider.js":872,"../../../../web/providers/MixSpecificationProvider.js":873,"../../../../web/providers/ObservationProvider.js":875,"../../../../web/providers/ObservationSetProvider.js":876,"../../../../web/providers/PlantProvider.js":877,"../../../../web/providers/ProducerProvider.js":878,"../../../../web/providers/ProductProvider.js":879,"../../../../web/providers/ProjectFileProvider.js":880,"../../../../web/providers/ProjectProvider.js":881,"../../../../web/providers/QRCodeProvider.js":882,"../../../../web/providers/SampleLogProvider.js":883,"../../../../web/providers/SampleProvider.js":884,"../../../../web/providers/TestInstanceProvider.js":886,"../../../../web/providers/UploadTrackingProvider.js":887,"../../../../web/providers/UserProvider.js":888,"../../../../web/providers/UtilityProvider.js":889,"../behaviors/DocumentStateDisplay.js":773,"../behaviors/HeadlightToastAdapter.js":774,"../configuration/HeadlightPanels-Configuration-Default.json":775,"../services/HeadlightPanels-Fable-Service.js":776,"../templates/HeadlightPanels-Templates-Default.js":777,"../views/Academy-View.js":778,"../views/Comment-View-Current.js":779,"../views/Document-View-Create.js":780,"../views/Document-View-Current.js":781,"../views/Document-View-Details.js":782,"../views/Document-View-Search.js":783,"../views/Inspection-View.js":797,"../views/Observation-Edit-Annotation.js":798,"../views/Observation-Edit-SubImage.js":799,"../views/Observation-View-Create-Media.js":800,"../views/Observation-View-Details.js":801,"../views/Observation-View-Included.js":802,"../views/Observation-View-Search.js":803,"../views/ProjectFile-View-Search.js":806,"../views/Sample-View-Create.js":808,"../views/Sample-View-Current.js":809,"../views/Sample-View-Details.js":810,"../views/Sample-View-Scan.js":811,"../views/Sample-View-Search.js":812,"../views/TestInstance-Wizard.js":813,"./HeadlightPanels-Pane-Bridges.js":784,"./HeadlightPanels-Pane-Custom.js":785,"./HeadlightPanels-Pane-Documents.js":786,"./HeadlightPanels-Pane-Navigation.js":787,"./HeadlightPanels-Pane-Observations.js":788,"./HeadlightPanels-Pane-Profile.js":789,"./HeadlightPanels-Pane-Samples.js":790,"./HeadlightPanels-Pane-Secret.js":791,"./HeadlightPanels-Pane-Settings.js":792,"./HeadlightPanels-Pane-Solver.js":793,"./HeadlightPanels-Pane-Status.js":794,"./HeadlightPanels-Pane-Validations.js":795,"./Observation-View-Sets.js":804,"./Pict-Form-Solver.js":805,"./QRPanel.js":807,"headlight-rest-client":12,"pict-view":693}],797:[function(require,module,exports){
const libPictView = require('pict-view');
/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class Inspection extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideIfEqual:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			return tmpValue == tmpCompare ? 'is-hidden' : '';
		});

		this.pict.MetaTemplate.addPattern('{~BitElse:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpTrue, tmpFalse ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			return tmpValue == '1' ? tmpTrue : tmpFalse;
		});

		// add the ".is-hidden" class to the Select a Bridge  title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~HideForBridge:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			const tmpLocked = this.pict.AppData?.DocumentData?.ReportData?.Locked;
			return tmpValue && tmpValue !== tmpCompare || tmpLocked === 1 ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the Add To Inspection btn if the passed value is false
		this.pict.MetaTemplate.addPattern('{~HideForInspection:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			const tmpLocked = this.pict.AppData?.DocumentData?.ReportData?.Locked;
			const tmpDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			// if there is no document, dont allow to add inspections
			return tmpValue && tmpValue > tmpCompare && tmpLocked === 0 && tmpDocument ? '' : 'is-hidden';
		});
	}

	includeChangeHandler(pID)
	{
		this.log.info(`includeChangeHandler: ${pID}`);
		if (!this.pict.AppData.CurrentInspection)
		{
			this.log.error(`No Current Inspection set; can't update include state for document ${pID}.`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Current Inspection set; can't update include state for document: ${pID}.`,
				type: 'is-danger',
			});
			return;
		}
		const tmpDocumentID = pID.split('_')[1];
		if (!tmpDocumentID)
		{
			return;
		}
		const tmpDocument = this.AppData.InspectionDocumentRecords?.find?.((pRecord) => pRecord.IDDocument == tmpDocumentID);
		const tmpCheckbox = document.getElementById(pID);
		const tmpInclude = tmpCheckbox instanceof HTMLInputElement && tmpCheckbox.checked;
		if (tmpDocument)
		{
			tmpDocument.IncludeOnDossier = tmpInclude ? 1 : 0;
		}
		this.pict.BridgeDocumentManager.includeDocumentInInspectionDossier(tmpDocumentID, this.pict.AppData.CurrentInspection.IDInspection, tmpInclude)
		.catch((pError) =>
		{
			this.log.error(`Error updating inspection dossier include state.`, pError);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Error updating inspection dossier.`,
				type: 'is-danger',
			});
		});
	}

	/**
	 * Set Current Inspection Type
	 * @param {object} event - The click event
	 */

	getCurrentType(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		// get current inspection type
		const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
		if (inspectionTypeSelector instanceof HTMLSelectElement)
		{
			const currentInspectionType = this.AppData.InspectionTypes?.find((pType) => pType.IDInspectionType == inspectionTypeSelector.value);
			// set current inspection type name
			this.currentInspectionTypeName = currentInspectionType.Name;
			// update current inspection type based on selection on Current Inspection
			this.AppData.CurrentInspection.IDInspectionType = inspectionTypeSelector.value;
			// update current inspection name in report data based on selection
			this.AppData.DocumentData.ReportData.FormData.CurrentInspection.Type = this.currentInspectionTypeName;
			this.pict.log.info('Current Document FormData:', this.AppData.DocumentData?.ReportData?.FormData);
		}
	}


	inspectionTypeChangeHandler(event)
	{
		if (!this.pict.AppData.CurrentInspection)
		{
			this.log.error(`No Current Inspection set; can't update inspection type for inspection: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Current Inspection set; can't update inspection type for inspection: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
			if (inspectionTypeSelector instanceof HTMLSelectElement)
			{
				// enable inspection type selector
				inspectionTypeSelector.disabled = false;
			}
			if (document.getElementById('CurrentInspection-Type-Button'))
			{
				// change edit aesthetics to save aesthetics
				document.getElementById('CurrentInspection-Type-Button').classList.remove('is-link');
				document.getElementById('CurrentInspection-Type-Button').classList.add('is-success');
				document.getElementById('CurrentInspection-Type-Icon').classList.remove('fa-pencil');
				document.getElementById('CurrentInspection-Type-Icon').classList.add('fa-save');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('title', 'Save Inspection Type');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('onclick', '_Pict.views.Inspection.confirmInspectionType()');
			}
		}
	}

	/**
	 * Confirmation Modal to save the form with the new Inspection Type
	 */
	confirmInspectionType()
	{
		// the body and footer templates for the confirmation modal
		const confirmModalBodyTemplate = /*html*/`
		<span id="ConfirmModalBody">
			<div class="column is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">The Inspection Type will be changed from <strong>${this.existingInspectionTypeName}</strong> to <strong>${this.currentInspectionTypeName}</strong> for form <strong>${this.AppData.CurrentInspection.Name}</strong>.</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to save or close this modal.</p>
				</div>
			</div>
		</span>`;
		const confirmModalFooterTemplate = /*html*/`
		<div id="ConfirmModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Inspection Type" onclick="_Pict.views.Inspection.confirmSaveCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the confirmation modal
		const confirmModalOptions = {
			title: 'Save Inspection Type?',
			modalBodyTemplate: confirmModalBodyTemplate,
			modalFooterTemplate: confirmModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(confirmModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// show save spinner
			event.target.innerHTML = '<span class="icon"><i class="fas fa-fw fa-spinner fa-spin" aria-hidden="true"></i></span>';
		}
		// update bridge current inspection
		await this.pict.providers.BridgeProvider.updateBridgeInspection(this.pict.AppData.CurrentInspection)
		.catch((pError) =>
		{
			this.log.error(`Error updating inspection type.`, pError);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Error updating inspection type.`,
				type: 'is-danger',
			});
		});
		await this.pict.providers.DocumentProvider.handleSave();
		if (event)
		{
			// change save spinner back to save text
			event.target.innerHTML = '<span class="icon"><i class="fas fa-fw fa-save" aria-hidden="true"></i></span><span>Save</span>';
			this.pict.fable.services.HeadlightModal.dismissModals();
			this.log.info(`Inspection type update successful.`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Inspection type has been updated.`,
				type: 'is-success',
			});
			const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
			if (inspectionTypeSelector instanceof HTMLSelectElement)
			{
				// disable inspection type selector after successful save
				inspectionTypeSelector.disabled = true;
			}
			if (document.getElementById('CurrentInspection-Type-Button'))
			{
				// change save aesthetics back to edit aesthetics
				document.getElementById('CurrentInspection-Type-Button').classList.remove('is-success');
				document.getElementById('CurrentInspection-Type-Button').classList.add('is-link');
				document.getElementById('CurrentInspection-Type-Icon').classList.remove('fa-save');
				document.getElementById('CurrentInspection-Type-Icon').classList.add('fa-pencil');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('title', 'Edit Inspection Type');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('onclick', '_Pict.views.Inspection.inspectionTypeChangeHandler(event)');
			}
			// update inspection type values
			this.initializeInspectionTypeSelect();
			// render the current state of the document data
			this.pict.views.BridgeSelection.renderAsync(() =>
			{
				this.pict.log.info('Bridge Selection Rendered');
			});
		}
	}

	invalidate()
	{
		delete this.AppData.InspectionDocumentRecords;
		delete this.AppData.CachedInspectionDocumentRecordsIDInspection;
	}

	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync(async () =>
		{
			const noInspectionSet = !this.pict.AppData.CurrentInspection && this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			const cacheDeleted = !this.AppData.CachedInspectionDocumentRecordsIDInspection && !this.AppData.InspectionDocumentRecords;
			if (noInspectionSet || cacheDeleted)
			{
				try
				{
					await this.pict.providers.InspectionProvider.getCurrentInspectionDocuments(this.pict.AppData?.DocumentData?.ReportData?.IDDocument);
				}
				catch (pError)
				{
					this.log.error('Error loading current Inspection Documents.', pError);
					this.pict.views.HeadlightPanels?.toast?.({
						message: `Error loading current Inspection Documents.`,
						type: 'is-danger',
					});
					return fCallback(pError);
				}
			}
			else
			{
				this.log.info('Current Inspection already set, skipping loading from Document.');
			}
			fCallback();
		}, pRenderable);
	}

	/**
	 * Adds the current document to inspection selected.
	 */
	async setCurrentInspection()
	{
		//there is no Inspection associated with the document yet
		//check if an inspection is selected
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection') || this.pict.views.Inspection.CurrentSearchFilters.Inspection;
		if (selectedInspection)
		{
			const inspectionID = selectedInspection.toString();
			const documentID = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			if (documentID)
			{
				const newInspectionDoc = await this.pict.BridgeDocumentManager.addDocumentToInspection(documentID, inspectionID, true);
				if (newInspectionDoc)
				{
					this.pict.views.HeadlightPanels?.toast?.({
						message: `Document has been added to Inspection.`,
						type: 'is-success',
					});
					this.pict.views.Inspection.renderAsync(() =>
					{
						this.log.info('Current Inspection rendered');
					});
				}
			}
		}
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 */
	updateSelectedInspection()
	{
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection');
		if (selectedInspection)
		{
			this.pict.ContentAssignment.removeAttribute('#buttonAddToInspection', 'disabled');
			this.pict.views.Inspection.CurrentSearchFilters.Inspection = selectedInspection;
		}
	}
	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		this.initializeInspectionTypeSelect();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Add a Document to the current Inspection
	 */
	addDocumentToInspection()
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents');
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-DocumentPanel').setAttribute('data-panel-mode', 'add-to-inspection');
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-inspection';
		this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-inspection';
		this.pict.views.DocumentSearch.setMode('add-to-inspection');
		// set the banner on the header that you are adding an Document
		document.getElementById('HeadlightPanels-DocumentPanel-Document-Header-Mode-Target').innerText = this.AppData.CurrentInspection.Name || ' the current inspection';
	}

	resetInspectionView()
	{
		this.invalidate();
		this.pict.views.Inspection.renderAsync(() =>
		{
			this.log.info('Inspection rendered');
		});
	}

	/**
	 * Validate changes before closing the panel
	 * @param {object} event
	 */
	handleClosePanelEvent(event)
	{
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection');
		if (selectedInspection && !this.pict.AppData?.DocumentData?.ReportData?.CurrentInspection)
		{
			this.fable.HeadlightModal.spawnMiniModal(
				{
					...this.fable.HeadlightModal.MiniModalPreset,
					message: 'Close Current Inspection Panel?',
				},
				() =>
				{
					this.pict.HeadlightPanels.leftPanelHide();
					this.pict.views.Inspection.resetInspectionView();
				},
			null);
		}
		else
		{
			this.pict.views.HeadlightPanels.closeThisPanel(event);
		}
	}

	/**
	 * Add a form to an inspection
	 */
	addFormToInspection()
	{
		this.pict.ContentAssignment.removeClass('#InspectionSelector', 'is-hidden');
		this.pict.ContentAssignment.removeClass('#buttonAddToInspection', 'is-hidden');
		this.pict.ContentAssignment.setAttribute('#buttonShowInspections', 'disabled', 'disabled');
		const tmpInspection = this.AppData?.DocumentData?.ReportData?.CurrentInspection ? { id: this.AppData?.DocumentData?.ReportData?.CurrentInspection.IDInspection, text: this.AppData?.DocumentData?.ReportData?.CurrentInspection?.Name } : null;
		const tmpProject = this.AppData?.DocumentData?.ReportData?.Project?.IDProject ? this.AppData?.DocumentData?.ReportData?.Project?.IDProject : null;
		//this.pict.providers.InspectionSelector.initializeSelect2('Inspection', tmpBridge );
		this.initializeSelect2Plugin({
			IDProject: tmpProject,
			dropdownCssClass: 'theme-dark' + (tmpInspection ? ' has-sticky-option' : ''),
			placeholder: 'Search by Inspections...',
			ElementID: 'Inspection',
			ParentID: 'InspectionSelector',
			URL: 'Inspections',
			IDField: 'IDInspection',
			TextField: 'Name',
			StickyOption: tmpInspection,
			PreselectOption: tmpInspection,
		}, () =>
		{
			this.log.info('Select2 Inspection initialized');
		});
	}


	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Inspection',
				{
					Input: pOptions.ElementID,
					SearchFields: [ 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Enter a inspection name ...',
					HandleSearchFilters: (pFilters) =>
					{
						if (!pOptions.IDProject)
						{
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						pFilters.push(`FBV~IDProject~EQ~${pOptions.IDProject}`);
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](`#${pOptions.ElementID}`).data('select2'))
			{
				//NOTE:has to be attached to a Parent for the drop down to show
				window['jQuery'](`#${pOptions.ElementID}`).select2(Object.assign( { dropdownParent: `#${pOptions.ParentID}` }, tmpSelectOptions));
			}
		}

		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}
	/**
	 * Initialize the Inspection Type Selector
	 */

	initializeInspectionTypeSelect()
	{
		const tmpSelect = document.getElementById('CurrentInspection-Type-Selector');
		if (tmpSelect instanceof HTMLSelectElement)
		{
            tmpSelect.value = this.pict.AppData.CurrentInspection.IDInspectionType;
            const existingInspectionType = this.AppData.InspectionTypes?.find((pType) => pType.IDInspectionType == tmpSelect.value);
			this.existingInspectionTypeName = existingInspectionType.Name;
		}
	}
}

const _ViewConfiguration = (
	{
		ViewIdentifier: 'HeadlightPanels-Inspection',
		DefaultRenderable: 'HeadlightPanels-Inspection',
		DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
		AutoRender: true,
		CSS: '',
		Templates: [
			{
				Hash: 'Datum-Value-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-Inspection" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-Inspection-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.Inspection.handleClosePanelEvent(event);">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-Inspection-Icon" class="fas fa-fw fa-building-magnifying-glass" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-Inspection-Header-Title" class="mr-3">Current Inspection</span>
					</p>
					<div class="column nested-scroll-content has-bottom-navbar-offset">
						{~TIfAbs:HeadlightPanels-Inspection-Empty:AppData.CurrentInspection:AppData.CachedInspectionDocumentRecordsIDInspection^==^0~}
						{~TIfAbs:HeadlightPanels-Inspection-Content:AppData.CurrentInspection:AppData.CachedInspectionDocumentRecordsIDInspection^>^0~}
					</div>
				</article>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Empty',
				Template: /*html*/`
				<div class="notification is-dark has-text-grey has-text-centered {~Show:Pict.AppData.DocumentData.ReportData.Locked~}">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">Document is locked.</span>
				</div>
				<div class="is-dark has-text-grey has-text-centered {~HideForInspection:Pict.AppData.DocumentData.ReportData.Project.IDProject^0~}">
					<button id="buttonShowInspections" class="button is-fullwidth is-primary" type="button" title="Add to inspection" onclick="_Pict.views.Inspection.addFormToInspection()">
						<span class="icon">
							<i class="fas fa-fw fa-plus" aria-hidden="true"></i>
						</span>
						<span>Add to Inspection</span>
					</button>
					<div>
						{~T:HeadlightPanels-Inspection-InspectionSelector~}
						<button id="buttonAddToInspection" class="button is-centered is-primary pt-2 is-hidden" disabled type="button" title="Save" onclick="_Pict.views.Inspection.setCurrentInspection()">
							<span class="icon">
								<i class="fas fa-fw fa-save" aria-hidden="true"></i>
							</span>
							<span>Save</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-InspectionSelector',
				Template: /*html*/`
				<div id="InspectionSelector" class="column is-hidden theme-dark">
					<div class="field" style="margin-bottom: 10px;">
						<label class="label block" for="Inspection">Inspections</label>
						<div class="control control-status select is-fullwidth">
							<select
								id="Inspection"
								onchange="_Pict.views.Inspection.updateSelectedInspection('Inspection')"
							>{~TS:HeadlightPanels-Inspection-InspectionSelector-SelectedOptions:Context[0].CurrentSearchFilters.Inpsection~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Content',
				Template: /*html*/`
				
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-20">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:AppData.CurrentInspection.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">#{~D:AppData.CurrentInspection.IDInspection~}</p>
					</div>
				</div>
				{~T:HeadlightPanels-Inspection-Details:AppData.CurrentInspection~}
				{~T:HeadlightPanels-Inspection-Documents:AppData.InspectionDocumentRecords~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-Empty',
				Template: /*html*/`
				<tr>
					<td colspan="3" class="has-text-centered">
						<div class="notification is-dark">
							<span class="icon">
								<i class="fas fa-info-circle"></i>
							</span>
							<span class="icon-text">No inspection documents found.</span>
						</div>
					</td>
				</tr>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Details',
				Template: /*html*/`
				<div id="InspectionType-Details" data-theme="dark" class="columns m-0 px-3 my-3">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.StatusDisplay~}</span>
					</div>
					<div class="column is-6">
						<div class="field">
							<label class="title is-block is-6 has-text-text-60" for="CurrentInspection-Type-Selector">Type</label>
							{~T:HeadlightPanels-Inspection-Type-Selector~}
						</div>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^ObservationDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Scheduled Start Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ScheduledStartDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Deadline Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DeadlineDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Description</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Description~}</span>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents',
				Template: /*html*/`
				<h3 class="title has-text-text-90 is-5 p-0 m-0 ml-1 mb-2">Inspection Documents</h3>
				<table class="table is-striped is-hoverable is-fullwidth mb-2">
					<thead>
						<tr>
							<th class="has-text-centered">Included in Dossier</th>
							<th colspan="2">Name</th>
						</tr>
					</thead>
					<tbody>
						{~TIfAbs:HeadlightPanels-Inspection-Documents-Empty:AppData.InspectionDocumentRecords:AppData.InspectionDocumentRecords.length^==^0~}
						{~TIfAbs:HeadlightPanels-Inspection-Documents-List:AppData.InspectionDocumentRecords:AppData.InspectionDocumentRecords.length^>^0~}
					</tbody>
				</table>
				<button class="button is-fullwidth is-primary" type="button" title="Add document to inspection" onclick="_Pict.views.Inspection.addDocumentToInspection()">
					<span class="icon">
						<i class="fas fa-fw fa-plus" aria-hidden="true"></i>
					</span>
					<span>Add Document to Inspection</span>
				</button>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-List',
				Template: /*html*/`
				{~TS:HeadlightPanels-Inspection-Documents-List-Entry:Record~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-List-Entry',
				Template: /*html*/`
				<tr id="DocumentRow_{~D:Record.IDDocument~}">
					<td class="is-vcentered has-text-centered">
						<div class="{~HideIfEqual:Record.DocumentType^Inspection-Dossier~}">
							<input type="checkbox" title="Toggle for Dossier inclusion" class="is-checkbox is-success" id="Include_{~D:Record.IDDocument~}" name="document" {~BitElse:Record.IncludeOnDossier^checked^~} onchange="_Pict.views.Inspection.includeChangeHandler(id)">
						</div>
					</td>
					<td class="is-vcentered">{~D:Record.Name~}</td>
					<td class="is-vcentered has-text-right">
						<button class="button is-ghost has-text-primary-75" type="button" title="Open document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocumentHandler(event, '{~D:Record.IDDocument~}')">
							<span class="icon">
								<i class="fas fa-fw fa-edit" aria-hidden="true"></i>
							</span>
							<span>Open</span>
						</button>
					</td>
				</tr>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Type-Selector',
				Template: /*html*/`
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<select 
							id="CurrentInspection-Type-Selector"
							onchange="_Pict.views.Inspection.getCurrentType(event)"
							disabled
						>
						{~TS:HeadlightPanels-Inspection-Types:AppData.InspectionTypes~}
						</select>
					</p>
					<p class="control">
						<button id="CurrentInspection-Type-Button" class="button is-link" type="button" title="Edit Inspection Type" onclick="_Pict.views.Inspection.inspectionTypeChangeHandler(event)">
							<span class="icon is-small">
								<i id="CurrentInspection-Type-Icon" class="fas fa-pencil"></i>
							</span>
						</button>
					</p>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Types',
				Template: /*html*/`
				<option value="{~D:Record.IDInspectionType~}">{~D:Record.Name~}</option>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'HeadlightPanels-Inspection',
				TemplateHash: 'HeadlightPanels-Inspection-Wrapper',
			},
		],
	});


module.exports = Inspection;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":693}],798:[function(require,module,exports){
const PictViewClass = require('pict-view');
const libPictSectionOpenSeaDragon = require('pict-section-openseadragon');
const libPictSectionOpenSeaDragonAnnotationSelector = require('pict-section-openseadragon/source/Pict-Section-OpenSeaDragonAnnotationSelector');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class OSDExtended extends libPictSectionOpenSeaDragon
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.osdSettings;

		/** @type {Pict} */
		this.pict;
	}

	customConfigureViewerSettings()
	{
		Object.assign(this.osdSettings,
		{
			zoomInButton: 'osd-zoom-in',
			zoomOutButton: 'osd-zoom-out',
			homeButton: 'osd-home',
		});
	}
}

class ObservationAnnotation extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationDetailsInFullScreen = false;
		this.ObservationAnnotationBackTo = 'ObservationDetails';
		this.CurrentZoomLevel = 1;
		if (!this.pict.ContentAssignment.getElement('#OSD-SVG-Sandbox')?.length)
		{
			const sandbox = document.createElement('div');
			sandbox.innerHTML = /*html*/`<div id="OSD-SVG-Sandbox" class="osd-sandbox"></div>`;
			document.body.insertBefore(sandbox, document.body.firstChild);
		}
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.ActiveObservationDetails?.IDObservation)
		{
			this.pict.providers.ObservationProvider.getObservationByID(this.ActiveObservationDetails.IDObservation, (returnedObs) =>
			{
				if (this.ActiveObservationDetails?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image')
				{
					const tmpIDArtifact = this.ActiveObservationDetails?.Details?.Image?.[0]?.IDArtifact;
					const tmpVersion = this.ActiveObservationDetails?.Details?.Image?.[0]?.Version;
					const ImageConfiguration =
					{
						ViewIdentifier: 'PictSectionOpenSeaDragon',
						ViewAddress: 'PictSectionOpenSeaDragon',
						EnableAnnotation: true,
						PrefixUrl: './images/',
						Colors:
						{
							'red': 'red',
							'green': 'green',
							'blue': 'blue',
							'cyan': '#4dd0e1',
							'deep-purple': '#673ab7',
							'pink': '#ff4081',
						},
						DrawModeLabel: 'Auto Annotate',
						TileSources:
						{
							type: 'image',
							url: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }`,
						},
					};
					this.ActiveObservationDetails = returnedObs;
					const existingAnnotations = this.ActiveObservationDetails?.Details?.Annotation?.[0]?.Datum?.Annotations;
					if (existingAnnotations)
					{
						ImageConfiguration.Annotations = existingAnnotations;
					}

					const commentConfiguration =
					{
						ViewIdentifier: 'PictSectionOpenSeaDragonAnnotationSelector',
						ViewAddress: 'PictSectionOpenSeaDragonAnnotationSelector',
						Colors:
						{
							'red': 'red',
							'green': 'green',
							'blue': 'blue',
							'cyan': '#4dd0e1',
							'deep-purple': '#673ab7',
							'pink': '#ff4081',
						},
					};
					if (!this.pict.views?.PictSectionOpenSeaDragon)
					{
						this.pict.addView('PictSectionOpenSeaDragon', Object.assign(libPictSectionOpenSeaDragon.default_configuration, ImageConfiguration), OSDExtended);
					}
					else
					{
						this.pict.views.PictSectionOpenSeaDragon.setTileSources(
						{
							type: 'image',
							url: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }`,
						});
						this.pict.views.PictSectionOpenSeaDragon.setAnnotations(ImageConfiguration.Annotations || []);
					}
					if (!this.pict.views?.PictSectionOpenSeaDragonAnnotationSelector)
					{
						this.pict.addView('PictSectionOpenSeaDragonAnnotationSelector', Object.assign(libPictSectionOpenSeaDragonAnnotationSelector.default_configuration, commentConfiguration), libPictSectionOpenSeaDragonAnnotationSelector);
					}
					this.pict.views.PictSectionOpenSeaDragon.render();
					if (!this.pict.views?.OSDCommentWrapper)
					{
						const wrapperConfig =
						{
							ViewIdentifier: 'OSDCommentWrapper',
							DefaultDestinationAddress: '#ObservationComments-Container-Div',
							DefaultRenderable: 'Comment-Wrap',
							Templates: [
								{
									Hash: 'Comment-Wrap-Container',
									Template: /*html*/`
									<article id="HeadlightPanels-NavigationPanel" class="panel is-active" style="max-width: 100%; height: 100%">
										<p id="HeadlightPanels-NavigationPanel-Header" class="px-5 pt-4 pb-4 has-background-text-20" style="color: white;">
											<span class="icon has-text-text-75">
												<i class="fas fa-fw fa-comments" aria-hidden="true"></i>
											</span>
											<span>Comments</span>
										</p>
										<div class="container" style="height: calc(100% - var(--panels-navbar-height));">
											<div id="OpenSeaDragonAnnotationSelector-Container-Div" style="width:100%; height: 100%"></div>
										</div>
										<style>
											.osd-drawmode-toggle-box {
												background-color: var(--bulma-text-70);
												padding-top: 5px;
												padding-left: 10px;
											}
											.osd-drawmode-text {
    											color: var(--bulma-text-15);
											}
											.osd-hatchmode-toggle-box {
												background-color: var(--bulma-text-70);
												padding-top: 5px;
												padding-left: 10px;
											}
											.osd-hatchmode-text {
    											color: var(--bulma-text-15);
											}
											.osd-sandbox {
												position: fixed !important;
												z-index: 9999;
											}
											.osd-scrollable-comments {
												background-color: var(--bulma-text-70) !important;
											}
											.osd-editor-inner {
												border-radius: 6px !important;
												border: 0px !important;
											}
											.osd-comment-color-flag {
												border-bottom: 3px solid var(--bulma-text-70) !important;
												border-right: 3px solid var(--bulma-text-70) !important;
											}
											.osd-editor-inner:hover > span.osd-comment-color-flag{
												height: 14px;
												width: calc(60% + 2px);
												margin-bottom: -2px;
												margin-right: -2px;
												border-bottom: 5px solid var(--bulma-text-70) !important;
												border-right: 5px solid var(--bulma-text-70) !important;
											}
											.osd-scrollable-comments .r6o-widget.comment {
												background-color: var(--bulma-text-35) !important;
												color: white !important;
												border-bottom: 0px !important;
											}
											.osd-scrollable-comments .r6o-widget.comment:last-child {
												border-radius: 0px 0px 6px 6px !important;
											}
											.osd-scrollable-comments .r6o-widget.r6o-tag {
												background-color: var(--bulma-warning-50) !important;
												border-radius: 0px 0px 6px 6px !important;
												border: none !important;
											}
											.osd-scrollable-comments ul.r6o-taglist > li {
												border: 1px solid var(--bulma-text-20) !important;
												background-color: transparent !important;
												border-radius: 6px !important;
												margin: 2px !important;
											}
											.osd-scrollable-comments .r6o-taglist {
												border: none !important;
											}
											.osd-scrollable-comments .r6o-editor-inner {
												background-color: var(--bulma-text-35) !important;
												color: white !important;
											}
											.osd-scrollable-comments span.r6o-label {
												background-color: var(--bulma-text-40) !important;
												padding: 0px 6px !important;
												background-color: transparent !important;
												color: var(--bulma-text-20) !important;
												border: none !important;
												border-radius: 6px !important;
											}
											.osd-scrollable-comments .r6o-widget > .r6o-editable-text.osd-editable-text:not(:first-child) {
												border-top: 1px solid var(--bulma-text-25) !important;
											}
										</style>
									</article>`,
								},
							],
							Renderables: [
								{
									'RenderableHash': 'Comment-Wrap',
									'TemplateHash': 'Comment-Wrap-Container',
									'DestinationAddress': '#HeadlightPanels-RightPanel',
									'RenderType': 'replace',
								},
							],

						};
						this.pict.addView('OSDCommentWrapper', wrapperConfig, PictViewClass);
					}
					this.pict.views.OSDCommentWrapper.render();
					this.pict.views.PictSectionOpenSeaDragonAnnotationSelector.render();
				}
			});
		}
		this.toggleFullScreenView({ val: true });
		this.pict.views.HeadlightPanels.togglePanel('right', 'close');
		return super.onAfterRender(pRenderable);
	}

	updateReportDataObservation(pIdObservation, updatedObsDetails)
	{
		if (this.AppData?.DocumentData?.ReportData?.Observations && Array.isArray(this.AppData?.DocumentData?.ReportData?.Observations))
		{
			let currentObservation = this.pict.AppData.DocumentData?.ReportData.Observations.find((o) => o.IDObservation == pIdObservation);
			if (currentObservation)
			{
				currentObservation = updatedObsDetails;
			}
		}
	}
	// Saves the observation annotations.
	async saveAnnotations()
	{
		const annotationsToSave = this.pict.views?.PictSectionOpenSeaDragon?.captureAnnotations() || [];
		if (this.ActiveObservationDetails?.Details?.Annotation?.[0]?.Datum)
		{
			this.ActiveObservationDetails.Details.Annotation[0].Datum.Annotations = annotationsToSave;
		}
		else if (this.ActiveObservationDetails?.Details)
		{
			this.ActiveObservationDetails.Details.Annotation = [ { Datum: { Annotations: annotationsToSave } } ];
		}

		await this.pict.providers.ObservationProvider.updateObservation(this.ActiveObservationDetails, (returnedObs)=>
		{
			//update the active obs and report data with saved observation
			this.ActiveObservationDetails = returnedObs;
			//NOTE: also update the report data , if it exists, IFF reportData is referenced elsewhere
			this.updateReportDataObservation(this.ActiveObservationDetails.IDObservation, returnedObs);
			this.pict.views.HeadlightPanels.toast({
				message: 'Annotations Saved Successfully.',
				type: 'is-success',
			});
		});
	}

	async saveAndCloseAnnotation(event)
	{
		// this is kind of  a hacky workaround until we refactor panels to handle state w/ the browser routing
		await this.saveAnnotations();
		this.pict.views.HeadlightPanels.closeAllPanels();
		this.pict.fable.services.HeadlightPanels.rightPanelShow();
		this.pict.fable.services.HeadlightPanels.leftPanelShow();
		//resetting back to half the screen because annotations forces a full screen view
		this.pict.HeadlightPanels.rightPanelCustomWidth(50);
		await this.pict.views.HeadlightPaneObservations.showObservationDetailView(event, this.ActiveObservationDetails.IDObservation, null, async () =>
		{
			// Refresh any active CardDecks so the annotation update is visible.
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.reMarshalAllViewsWithCardDecks(this.ActiveObservationDetails.IDObservation, 'AllDocumentLists', true);
			}
		}).then(() =>
		{
			// wait for transcoder to finish processing the image
			this.pict.providers.ObservationProvider.cacheBustObsImages(this.ActiveObservationDetails.IDObservation, [ 5000, 20000 ]);
		});
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open');
	}

	/**
	 * This method will set the left hand annotation panel to be as large as possible if the user toggles the mode active.
	 * @param {Object} [force] - The force object
	 * @property {boolean} force.val
	 */
	toggleFullScreenView(force)
	{
		this.ObservationDetailsInFullScreen = force ? force.val : !this.ObservationDetailsInFullScreen;
		const tmpContainer = document.querySelector('#OpenSeaDragon-Container-Div');
		if (this.ObservationDetailsInFullScreen)
		{
			if (tmpContainer instanceof HTMLElement)
			{
				tmpContainer.style.height = 'calc(100vh - 65px  - 56px - 45px)';
			}
			this.fable.HeadlightPanels.leftPanelCustomWidth(100);
			this.fable.HeadlightPanels.rightPanelCustomWidth(20);
		}
		else
		{
			if (tmpContainer instanceof HTMLElement)
			{
				tmpContainer.style.height = '60vh';
				tmpContainer.style.marginTop = '0';
			}
			document.querySelector('.panel-heading').classList.remove('is-hidden');
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
		}
		// make the image redraw to fit the new size every time the user toggles the full screen mode
		setTimeout(() =>
		{
			this.pict.views.ObservationAnnotation.goHome();
		});
	}

	goHome()
	{
		this.pict.views.PictSectionOpenSeaDragon?.viewer?.viewport?.goHome();
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetObservationAnnotationView()
	{
		this.ActiveObservationDetails = {};
		this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		this.fable.HeadlightPanels.rightPanelResetCustomWidth();
	}

	/**
	 * @deprecated
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		this.pict.HeadlightModal.spawnMiniModal(
		{
			...this.pict.HeadlightModal.MiniModalPreset,
			message: 'Return to Observations List?',
		},
		() =>
		{
			this.pict.views.ObservationDetails.ActiveObservationDetails = this.ActiveObservationDetails;
			this.pict.views.ObservationDetails.returnToPreviousLocation(event, 'ObservationDetails');
			this.pict.views.HeadlightPanels.handlePanelToggle('PictSectionOpenSeaDragonAnnotationSelector', 'close');
			this.resetObservationAnnotationView();
		},
		null);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Observation Annotation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
		},
		null);
	}
}

module.exports = ObservationAnnotation;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationAnnotation',
	DefaultRenderable: 'ObservationAnnotation',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'ObservationAnnotation-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationAnnotationPanel" class="panel is-active">
				<p id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.ObservationAnnotation.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="button is-small is-rounded is-pulled-right hl-panel-fullscreen-button mr-2" aria-label="fullscreen" title="Toggle full screen view" onclick="_Pict.views.ObservationAnnotation.toggleFullScreenView()">
						<span class="hl-panel-fullscreen-button">
							<i class="fas fa-fw fa-expand"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header-Title" class="mr-3">Observation Annotation</span>
				</p>
				<div id="HeadlightPanels-ObservationAnnotation-Content">
					{~T:ObservationAnnotation-Content:Pict.views.ObservationAnnotation.ActiveObservationDetails~}
				</div>
				<style>
					@media screen and (max-width: 900px) {
						.hl-panel-wrapper .open-sea-dragon-content .osd-toolbar
						{
							flex-direction: column;
							height: 100px;
						}
					}
					@media screen and (min-width: 901px) {
						.hl-panel-wrapper .open-sea-dragon-content .osd-toolbar
						{
							flex-direction: row;
							height: 50px;
						}
					}
				</style>
			</article>`,
		},
		{
			Hash: 'ObservationAnnotation-Content',
			Template: /*html*/`
			<div class="container panel-content" style="max-width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<div class="columns" style="margin: 0;">
					<div style="width: 100%; position: relative;">
						<div id="OpenSeaDragon-Container-Div" class="open-sea-dragon-content" style="height: calc(100vh - 65px - 56px - 45px);"></div>
						<div id="OpenSeaDragon-Navigation-Controls" class="open-sea-dragon-navigation-controls">{~T:ObservationAnnotation-Navigation-Controls~}</div>
					</div>
					<div id="ObservationComments-Container-Div" class="" style="height: calc(100vh - 65px - 56px - 45px);"></div>
				</div>
				<button title="Done" onclick="_Pict.views.ObservationAnnotation.saveAndCloseAnnotation()" 
				style="float: right; margin: 10px;" class="button is-small is-primary"><i class="fas fa-fw fa-check-circle" style="margin-right: 5px;"></i>Done</button></div>
				<button title="Save annotation" onclick="_Pict.views.ObservationAnnotation.saveAnnotations()" style="float: right; margin: 10px;" class="button is-success is-small"><i class="fas fa-fw fa-save" style="margin-right: 5px;"></i>Save Annotations</button>
			</div>`,
		},
		{
			Hash: 'ObservationAnnotation-Navigation-Controls',
			Template: /*html*/`
			<div class="buttons is-right" style="width: 50px; position: absolute; top: 0.5rem; right: 0.5rem;">
				<button id="osd-zoom-in" title="Zoom in" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-plus"></i>
					</span>
				</button>
				<button id="osd-zoom-out" title="Zoom out" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-minus"></i>
					</span>
				</button>
				<button id="osd-home" title="Re-center image" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-arrows-to-dot"></i>
					</span>
				</button>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationAnnotation',
			TemplateHash: 'ObservationAnnotation-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationAnnotation-Content',
			TemplateHash: 'ObservationAnnotation-Content',
			DestinationAddress: '#HeadlightPanels-ObservationAnnotation-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-section-openseadragon":601,"pict-section-openseadragon/source/Pict-Section-OpenSeaDragonAnnotationSelector":602,"pict-view":693}],799:[function(require,module,exports){
const PictViewClass = require('pict-view');
const libPictSectionOpenSeaDragon = require('pict-section-openseadragon');
const libPictSectionPDFJS = require('pict-section-pdfjs');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class OSDExtended extends libPictSectionOpenSeaDragon
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.osdSettings;

		/** @type {Pict} */
		this.pict;
	}

	customConfigureViewerSettings()
	{
		Object.assign(this.osdSettings,
		{
			zoomInButton: 'osd-zoom-in',
			zoomOutButton: 'osd-zoom-out',
			homeButton: 'osd-home',
		});
	}
}

class ObservationSubImageSelector extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationSubImageSelectorBackTo = 'ObservationDetails';
		this.pict.MetaTemplate.addPattern('{~PreviewPages:', '~}', (pHash, pData, fCallback) =>
		{
			const template = /*html*/`
			<div class="has-background-text-40" id="PDFJS-Markup-Container-Div" style="min-width: 100%; height: calc(100vh - 65px - 44px - 56px);" ></div>`;
			return template;
		});
		this.wizardStep = 1;
		this.intent =
		{
			type: 'Document',
		};

		this.registerListenersForPDFViewer();
	}

	renderOSD(tileSources)
	{
		if (this.ActiveObservationDetails.IDObservation)
		{
			const ImageConfiguration =
			{
				ViewIdentifier: 'PictSectionOpenSeaDragonSubImage',
				ViewAddress: 'PictSectionOpenSeaDragonSubImage',
				EnableAnnotation: false,
				PrefixUrl: './images/',
				TileSources: tileSources,
			};
			if (!this.pict.views?.PictSectionOpenSeaDragonSubImage)
			{
				this.pict.addView('PictSectionOpenSeaDragonSubImage', Object.assign(libPictSectionOpenSeaDragon.default_configuration, ImageConfiguration), OSDExtended);
			}
			else
			{
				this.pict.views.PictSectionOpenSeaDragonSubImage.setTileSources(tileSources);
			}
			this.pict.views.PictSectionOpenSeaDragonSubImage.render();
		}
	}

	continue()
	{
		function getClosestZoomLevel(osdZoom, zoomLevels)
		{
			let closestZoomLevel;
			for (let i = 0; i < zoomLevels.length; i++)
			{
				if (zoomLevels[i] >= osdZoom)
				{
					closestZoomLevel = zoomLevels[i];
					break;
				}
			}
			if (!closestZoomLevel)
			{
				closestZoomLevel = zoomLevels[zoomLevels.length - 1];
			}
			return Math.max(1, closestZoomLevel);
		}
		const zoomLevels = [ 0.25, 0.5, 1, 2, 4, 8 ];

		const continueButton = document.getElementById('OSD-SubImageSelector-Continue');
		continueButton.classList.add('is-loading');

		this.pict.providers.ObservationProvider.extractInfoByID(this.ActiveObservationDetails.IDObservation, (extractedInfo) =>
		{
			const pageChoice = this.pict.views.PDFMarkupViewer.getCurrentPage();
			if (pageChoice < 1 || pageChoice > extractedInfo?.pages?.length)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'You must pick a page number within the document to proceed.',
					type: 'is-danger',
				});
				return;
			}
			this.wizardStep += 1;
			if (this.wizardStep === 2)
			{
				const pageObj = extractedInfo.pages.find((item)=>
				{
					return item.number == pageChoice;
				});
				const generatedTiles = {
					type: 'legacy-image-pyramid',
					levels: [],
				};
				for (const z of zoomLevels)
				{
					generatedTiles.levels.push(
					{
						url: `/1.0/Observation/${ this.ActiveObservationDetails.IDObservation }/Extract/${ encodeURIComponent(`Page:${ pageObj.number };Scale:${ z }`) }`,
						height: pageObj.height * z,
						width: pageObj.width * z,
					});
				}
				this.renderOSD(generatedTiles);
			}
			if (this.wizardStep === 3)
			{
				this.pict.providers.ObservationProvider.extractSubImage(this.ActiveObservationDetails.IDObservation,
				{
					Page: pageChoice,
					Bounds: this.pict.views.PictSectionOpenSeaDragonSubImage.captureViewport(),
					Scale: getClosestZoomLevel(this.pict.views.PictSectionOpenSeaDragonSubImage.viewer.viewport.getZoom(), zoomLevels),
				},
				(obs)=>
				{
					const openAnnotator = () =>
					{
						this.pict.HeadlightPanels.rightPanelResetCustomWidth();
						this.pict.HeadlightPanels.leftPanelResetCustomWidth();
						try
						{
							this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
							this.pict.views.ObservationAnnotation.ActiveObservationDetails = obs;
							this.pict.views.HeadlightPanels.handlePanelToggle('ObservationAnnotation', 'open');
							this.intent =
							{
								type: 'Document',
							};
							this.pict.views['PictFormMetacontroller-DynamicInputs']?.marshalToViewAsync();
							console.log('Opening annotation panel...');
						}
						catch (e)
						{
							console.error(e);
						}
					};
					if (this.intent?.type === 'ObservationSet' && this.intent?.IDObservationSet !== null)
					{
						this.pict.providers.ObservationSetProvider.addObservation(null, obs, this.intent.IDObservationSet).then(() =>
						{
							openAnnotator();
						});
					}
					else
					{
						if (this.AppData?.DocumentData?.ReportData?.IDDocument)
						{
							this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(obs.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument, openAnnotator);
						}
						else
						{
							openAnnotator();
						}
					}
				});
			}
			const steps = document.querySelectorAll('#ObservationSubImageSelector-Steps-List li');
			steps.forEach((step, i) =>
			{
				if (i + 1 === this.wizardStep - 1)
				{
					step.classList.add('prev-active');
				}
				else
				{
					step.classList.remove('prev-active');
				}
				if (i + 1 === this.wizardStep)
				{
					step.classList.add('is-active');
				}
				else
				{
					step.classList.remove('is-active');
				}
			});
			const stepBodies = document.querySelectorAll('#OSD-Wizard-Body-Pane > div');
			stepBodies.forEach((stepBody, i) =>
			{
				if (i + 1 === this.wizardStep)
				{
					stepBody.classList.add('is-active');
				}
				else
				{
					stepBody.classList.remove('is-active');
				}
			});
			if (this.wizardStep === 3)
			{
				continueButton.classList.add('is-hidden');
			}
			continueButton.classList.remove('is-loading');
		});
	}

	goHome()
	{
		this.pict.views.PictSectionOpenSeaDragon?.viewer?.viewport?.goHome();
	}

	/**
	 * Toggles the disabled attribute on/off for the passed in elements
	 * @param {Array.<{id:string, title:string}>} elements - {id: id of the element to target, title: tooltip when not disabled }
	 * @param {string} disabledText (optional) - tooltip to display when element is disabled
	 */
	toggleDisabled(elements, disabledText)
	{
		for (const [ key ] of Object.entries(elements))
		{
			const element = elements[key];
			if (!element.hasOwnProperty('id') )
			{
				continue;
			}
			const el = document.getElementById(element.id);

			if (!el)
			{
				continue;
			}

			if (el.hasAttribute('disabled'))
			{
				this.pict.ContentAssignment.removeAttribute(`#${element.id}`, 'disabled');
				if (element.title && typeof element.title === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', element.title );
				}
			}
			else
			{
				this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'disabled', 'disabled');
				if (typeof disabledText === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', disabledText);
				}
			}
		};
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 * @param {boolean} [noIntentReset=false] - If true, the intent will not be reset
	 * @param {boolean} [directPanels=false] - If true, the panels will be directly manipulated
	 * @param {string} [startingPage=undefined] - The page to start at
	 */
	resetObservationSubImageSelectorView(noIntentReset, directPanels, startingPage=undefined)
	{
		this.ActiveObservationDetails = {};
		this.wizardStep = 1;
		this.intent = noIntentReset ? this.intent : { type: 'Document' };
		if (directPanels)
		{
			this.pict.HeadlightPanels.leftPanelCustomWidth(100);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelHide();
		}

		// if caller is requesting we start at a specific page, set. Else, clears the selection.
		this.startingPage = startingPage;
	}

	/**
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		this.pict.HeadlightModal.spawnMiniModal(
		{
			...this.pict.HeadlightModal.MiniModalPreset,
			message: 'Return to Observations List?',
		},
		()=>
		{
			this.resetObservationSubImageSelectorView();
			this.pict.HeadlightPanels.rightPanelResetCustomWidth();
			this.pict.HeadlightPanels.leftPanelResetCustomWidth();
			this.pict.views.ObservationDetails.ActiveObservationDetails = this.ActiveObservationDetails;
			this.pict.views.ObservationDetails.returnToPreviousLocation(event, 'ObservationDetails');
			this.pict.views.HeadlightPanels.handlePanelToggle('ObservationSubImageSelector', 'close');
		},
		null);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Markup Observation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		},
		null);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const tmpIDArtifact = this.ActiveObservationDetails?.Details?.File?.[0]?.IDArtifact;
		const tmpVersion = this.ActiveObservationDetails?.Details?.File?.[0]?.Version;
		if (!this.pict.views?.PDFMarkupViewer)
		{
			this.pict.addView('PDFMarkupViewer', Object.assign(libPictSectionPDFJS.default_configuration, { pdfUrl: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`, DefaultDestinationAddress: '#PDFJS-Markup-Container-Div' }), libPictSectionPDFJS);
		}
		if (this.pict.views?.PDFMarkupViewer)
		{
			this.pict.views.PDFMarkupViewer.options.pdfUrl = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
			this.pict.views.PDFMarkupViewer.render();
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * TODO: move to the PDFViewer pict section, and allow parent view to inject a page number
	 * TODO: can we do this without the global listener?
	 * @spec listens for the pdf viewer loading. when fully loaded, auto-moves to a specific page if one is requested (i.e. last viewed one)
	 */
	registerListenersForPDFViewer()
	{
		document.addEventListener('webviewerloaded', async () =>
		{
			const viewer = document.querySelector('pdfjs-viewer-element');
			// Wait for the viewer initialization, receive PDFViewerApplication
			const viewerApp = await viewer.initialize();
			// Use event bus to handle viewer application events
			viewerApp.eventBus.on('pagesloaded', () =>
			{
				this.pict.log.info('Viewer pages loaded, startingPage=', this.startingPage);
				if (this.startingPage)
				{
					viewerApp.page = this.startingPage;
				}
			});
		});
		this.pict.log.debug('PDFViewer Handlers registered');
	}

	handleOnCloseEvent(pEvent)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Markup Observation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationSubImageSelector.resetObservationSubImageSelectorView();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		});
	}

	handleOnPinPanelEvent(pEvent)
	{
		this.pict.views.ObservationSubImageSelector.toggleDisabled(
		[
			{
				_id: 'ObservationEditSubImage-CloseButton',
				title: 'Close panel',
			},
			{
				_id: 'ObservationEditSubImage-BackButton',
				title: 'Back to Included List view',
			},
		],
		'Please unpin panel');

		this.pict.views.HeadlightPanels.togglePanelPinState();
	}
}

module.exports = ObservationSubImageSelector;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSubImageSelector',
	DefaultRenderable: 'ObservationSubImageSelector',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'ObservationSubImageSelector-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationSubImageSelectorPanel" class="panel is-active">
				<p id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header" class="panel-heading pr-4">
					<button id="ObservationEditSubImage-CloseButton" type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.ObservationSubImageSelector.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" 
						onclick="_Pict.views.ObservationSubImageSelector.handleOnPinPanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header-Title" class="mr-3">Create Markup Observation</span>
				</p>
				<div id="HeadlightPanels-ObservationSubImageSelector-Content">
					{~T:ObservationSubImageSelector-Content:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
			</article>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Content',
			Template: /*html*/`
			<header class="has-background-text-15">
				<ul id="ObservationSubImageSelector-Steps-List" class="wizard-list">
					<li id="OSD-Wizard-Tag-1" class="wizard-step-1 is-active"><div><span>Choose a Page</span></div></li>
					<li id="OSD-Wizard-Tag-2" class="wizard-step-2"><div><span>Select an Image Section</span></div></li>
					<li id="OSD-Wizard-Tag-3" class="wizard-step-3 end-block"><div><span>Annotate</span></div></li>
				</ul>
			</header>
			<div id="OSD-Wizard-Body-Pane">
				<div id="OSD-Wizard-Step-1" class="wizard-pane is-active">
					{~T:ObservationSubImageSelector-Wizard-Step-1:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
				<div id="OSD-Wizard-Step-2" class="wizard-pane">
					{~T:ObservationSubImageSelector-Wizard-Step-2:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
				<div id="OSD-Wizard-Step-3" class="wizard-pane">
					{~T:ObservationSubImageSelector-Wizard-Step-3~}
				</div>
			</div>
			<div class="buttons is-right" style="width: 50px; position: absolute; top: calc(100% - 60px); right: 0.5rem;">
				<button id="OSD-SubImageSelector-Continue" title="Continue" onclick="_Pict.views.ObservationSubImageSelector.continue()" 
				style="float: right; margin: 10px;" class="button is-primary has-text-white has-shadow is-normal"><i class="fas fa-fw fa-square-chevron-right" style="margin-right: 5px;"></i>Continue</button>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-1',
			Template: /*html*/`
			<div class="container panel-content" style="min-width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<figure class="image">
					{~PreviewPages:Record~}
				</figure>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-2',
			Template: /*html*/`
			<div class="container panel-content" data-observation-id="{~D:Record.IDObservation~}" style="min-width: 100%;">
				<div id="OpenSeaDragon-Container-Div" class="open-sea-dragon-content" style="height: calc(100vh - 65px - 44px - 56px); min-width: 100%;"></div>
				<div id="OpenSeaDragon-Navigation-Controls" class="open-sea-dragon-navigation-controls">{~T:ObservationSubImageSelector-Navigation-Controls~}</div>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-3',
			Template: /*html*/`
			<div class="container panel-content" data-observation-id="{~D:Record.IDObservation~}">
				<div class="p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<style>
								.lds-ring,
								.lds-ring div {
									box-sizing: border-box;
								}
								.lds-ring {
									display: inline-block;
									position: relative;
									width: 80px;
									height: 80px;
								}
								.lds-ring div {
									box-sizing: border-box;
									display: block;
									position: absolute;
									width: 64px;
									height: 64px;
									margin: 8px;
									border: 8px solid currentColor;
									border-radius: 50%;
									animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
									border-color: currentColor transparent transparent transparent;
								}
								.lds-ring div:nth-child(1) {
									animation-delay: -0.45s;
								}
								.lds-ring div:nth-child(2) {
									animation-delay: -0.3s;
								}
								.lds-ring div:nth-child(3) {
									animation-delay: -0.15s;
								}
								@keyframes lds-ring {
									0% {
										transform: rotate(0deg);
									}
									100% {
										transform: rotate(360deg);
									}
								}
							</style>
							<div class="lds-ring wizard-loader" style="color: white;"><div></div><div></div><div></div><div></div></div>
							<div class="is-size-6 has-text-centered" style="color: white; text-wrap: wrap: max-width: 50vw;">Preparing Image for Annotation...</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Navigation-Controls',
			Template: /*html*/`
			<div class="buttons is-right" style="width: 50px; position: absolute; top: 0.5rem; right: 0.5rem;">
				<button id="osd-zoom-in" title="Zoom in" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-plus"></i>
					</span>
				</button>
				<button id="osd-zoom-out" title="Zoom out"class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-minus"></i>
					</span>
				</button>
				<button id="osd-home" title="Original view" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-home"></i>
					</span>
				</button>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationSubImageSelector',
			TemplateHash: 'ObservationSubImageSelector-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationSubImageSelector-Content',
			TemplateHash: 'ObservationSubImageSelector-Content',
			DestinationAddress: '#HeadlightPanels-ObservationSubImageSelector-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-section-openseadragon":601,"pict-section-pdfjs":603,"pict-view":693}],800:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationCreateMedia extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.FileListToUpload = []; // the list of files to upload, accessible across the component

		// the default options for the component
		this.DefaultConfiguration = {
			ObservationTypes: [ 'Legacy Image', 'Legacy Video', 'Legacy Audio', 'File' ],
			TagTypes: [ 'Tag' ], // TODO: add more types
			TagsList: [], // TODO: replace with types later
			FileSizeLimit: 4000000000, // 4 GB
			FileNumberLimit: 20,
			AllowCamera: true,
			AllowLocationRequest: true,
			FileRestrictions: [],
			DocumentInjectionTarget: null, // passed by method to target a specific element
			DocumentInjectionMethod: 'append', // replace, append, prepend,
			DocumentPreviewIdentifierAttribute: 'data-observation-id', // this is the unique attribute the template agrees to use to locate the preview image for each observation id
			onAfterDocumentJoinCallback: () =>
			{
				// optional callback to run after document join
			},
			onAfterCallback: (observationInfos, event) =>
			{
				// NOTE: You should override this method via configuration to do anything here besides close the panel and clear the banner after an upload action.
				// EX: Observation Image Sets will set this callback to inject the new images into the specific set location on the DOM.
				this.pict.log.info('No custom onAfterCallback specified in configuration for ObservationCreateMedia panel.');
			},
			onFallbackCallback: (observationInfoList) =>
			{
				// NOTE: this override does NOT get overwritten when the panel closes. You should use this when you need to do something on your view whenever a file is uploaded.
				// Example: show uploaded photo as inspection photo on bridge form after upload.
				this.pict.log.info('No custom onFallbackCallback specified in configuration for ObservationCreateMedia panel.');
			},
		};

		// add a pattern to the template engine to convert bytes to megabytes
		this.pict.MetaTemplate.addPattern('{~ToMegaBytes:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpColumnData = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpColumnData ? this.convertBytesToMegabytes(tmpColumnData) : 0;
		});
		this.pict.MetaTemplate.addPattern('{~ToGigaBytes:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpColumnData = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpColumnData ? this.convertBytesToGigabytes(tmpColumnData) : 0;
		});
	}

	instantiateConfiguration()
	{
		this.log.info('Initializing ObservationCreateMedia view...');
		if (!this.InstanceConfiguration)
		{
			this.DefaultConfiguration.IDDocument = this.AppData?.DocumentData?.ReportData?.IDDocument;
			this.DefaultConfiguration.IDProject = this.AppData?.DocumentData?.ReportData?.IDProject;
			this.DefaultConfiguration.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID;
			// the instance configuration for the component (the devloper can mutate this)
			this.InstanceConfiguration = JSON.parse(JSON.stringify(this.DefaultConfiguration));
		}
	}

	/**
	 * This method is used to build the tag selection list for the user to choose from as an observation tag.
	 * This is useful for the user to select from a list of tags that are relevant to the project or customer.
	 * @param {String} pFileGUID - the GUID of the file to build the tag selection list for
	 * @return {void}
	 */
	lookUpTagsForSelectionList(pFileGUID)
	{
		// if we have tags already, use them
		if (this.InstanceConfiguration.TagsList.length > 0)
		{
			this.buildTagSelectionList(pFileGUID);
			return;
		}
		this.log.info('Looking up tags for the selection list...');
		// get the tags from the server
		let tmpUrl = 'ObservationTags/FilteredTo/FBV~TagType~EQ~Tag';
		// if we have a project, filter the tags by the project
		if (this.InstanceConfiguration.IDProject)
		{
			tmpUrl = `ObservationTagProjectJoins/FilteredTo/FBV~IDProject~EQ~${ this.InstanceConfiguration.IDProject }`;
		}
		this.pict.HeadlightRestClient.getJSON(tmpUrl,
		(pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to retrieve tags for selection list.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: `<strong>Failed to retrieve tags for selection list.</strong><br/><em>${pError.message || pError}</em>`,
					type: 'is-danger',
				});
				this.buildTagSelectionList(pFileGUID);
				return;
			}
			if (pBody && Array.isArray(pBody))
			{
				this.InstanceConfiguration.TagsList = pBody;
				this.buildTagSelectionList(pFileGUID);
			}
		});
	}

	/**
	 * This method is to build the tag selection list for the user to choose from as an observation tag.
	 * This is useful for the user to select from a list of tags that are relevant to the project or customer.
	 * @param {String} pFileGUID
	 */
	buildTagSelectionList(pFileGUID)
	{
		const tmpTagList = this.InstanceConfiguration.TagsList;
		// list the tags by name/id for the selection list
		const elementId = '#ObservationCreateMedia-FileList-LabelSelect';
		// pretty up the Tag selector
		if (window.jQuery)
		{
			if (this.pict.ContentAssignment.hasClass(elementId, 'select2-hidden-accessible'))
			{
				window.jQuery(elementId).select2('destroy');
			}
			const tmpSelect2Data = [];
			let tmpSelectedTags = [];
			// if we have a file that already has tags set (multiple files), get the tags from the file
			if (pFileGUID)
			{
				const tmpFile = this.findFileByGUID(pFileGUID);
				if (tmpFile && tmpFile.Tags && tmpFile.Tags.length > 0)
				{
					tmpSelectedTags = tmpFile.Tags;
				}
			}

			// clear out any active selections from the select2 dropdown so they don't double pick
			for (let i=0; i < tmpTagList.length; i++)
			{
				tmpSelect2Data.push({
					id: tmpTagList[i].Tag,
					text: tmpTagList[i].Tag,
					selected: tmpSelectedTags.includes(tmpTagList[i].Tag), // NOTE: Could be an issue if we have two tags with the same name (but that shouldn't be allowed)
				});
			}
			let placeholder = 'Select tags...';
			// if we have no tags, show a message
			if (tmpSelect2Data.length === 0)
			{
				placeholder = 'No tags available.';
			}
			window.jQuery(elementId).html('').select2({
				dropdownParent: $('#ObservationCreateMedia-Content-Entry'),
				placeholder: placeholder,
				width: '100%',
				multiple: true,
				data: tmpSelect2Data,
				tags: true,
				dropdownCssClass: 'theme-dark',
				createTag: function(params)
				{
					const term = params.term.trim();
					if (term === '')
					{
						return null;
					}
					return {
						id: term,
						text: term,
						newTag: true,
					};
				},
			});
		}
	}

	/**
	 * Basic utility method to convert bytes to megabytes.
	 * @param {Number} pBytes
	 * @return {Number}
	 */
	convertBytesToMegabytes(pBytes)
	{
		return Math.round(pBytes / 1000000);
	}

	/**
	 * Basic utility method to convert bytes to gigabytes.
	 * @param {Number} pBytes
	 * @return {Number}
	 */
	convertBytesToGigabytes(pBytes)
	{
		return Math.round(pBytes / 1000000000);
	}

	/**
	 * This is a utility method to find a file in the list by the GUID.
	 * @param {String} pFileGUID
	 * @return {Object}
	 */
	findFileByGUID(pFileGUID)
	{
		let tmpFile = null;
		// find the file in our list by the guid string
		this.FileListToUpload.forEach((pFile, i) =>
		{
			if (pFile.GUID === pFileGUID)
			{
				tmpFile = pFile;
				return;
			}
		});
		return tmpFile;
	}

	/**
	 * This method is used to check if the document is locked before uploading files.
	 * If the document is locked, it will prevent the upload and show a message to the user.
	 * @param {Event} e - the event object
	 */
	checkIfLocked(e)
	{
		if (this.AppData?.DocumentData?.ReportData?.Locked)
		{
			e.preventDefault();
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
		}
	}
	/**
	 * This method is used to update the selection list to show the user which file they have selected for preview/editing.
	 * @param {Object} [pQuickCaptureFile] - a file object from the quick capture event, which bypasses the file picker
	 */
	handleUpdateSelectionList(pQuickCaptureFile)
	{
		// warn developers to migrate to the new event system
		if (pQuickCaptureFile)
		{
			this.pict.log.warn('Use the dedicated quick capture method to add files. See "quickCaptureImage()".');
			return;
		}
		this.log.info('Updating file selection list...');
		this.updateStepsListActiveState(1);
		const filesInput = document.getElementById('ObservationCreateMedia-FileList-Input');
		const tmpFileList = filesInput instanceof HTMLInputElement && filesInput.files;
		const tmpIncludedFileList = [];
		const tmpExcludedFileList = [];
		// clear out the list on the UI everytime
		this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-SelectionList', '');
		// show the empty row message
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-FileList-EmptyRow', 'is-hidden');

		// prevent more files than the limit (if set)
		if (this.InstanceConfiguration.FileNumberLimit && tmpFileList.length > this.InstanceConfiguration.FileNumberLimit)
		{
			this.pict.log.warn('File number limit exceeded! Limit: ', this.InstanceConfiguration.FileNumberLimit, ' Selected: ', tmpFileList.length);
			// inject message on the file picker
			this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-ErrorMessage', /*html*/`
			<div class="column notification is-danger is-dark mb-3 is-size-7">The maximum limit of files allowed for a single upload is set to ${ this.InstanceConfiguration.FileNumberLimit }. Please try again with fewer files selected.</div>`);
			return;
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-ErrorMessage', '');
		}

		// if we have files, then process them
		if (tmpFileList && tmpFileList.length > 0)
		{
			// disable the button until they reset the list
			this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-FileList-CreateButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-FileList-ResetButton', 'disabled');
			// hide the empty row
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-FileList-EmptyRow', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-FileList-EmptyRow', 'is-active');

			// for each file, generate a UI element
			for (let i = 0; i < tmpFileList.length; i++)
			{
				// limit file size (if set)
				if (this.InstanceConfiguration.FileSizeLimit && tmpFileList[i].size > this.InstanceConfiguration.FileSizeLimit)
				{
					this.pict.log.warn('File size limit exceeded! Limit: ', this.InstanceConfiguration.FileSizeLimit, ' Selected: ', tmpFileList[i].size);
					tmpExcludedFileList.push(tmpFileList[i]);
				}
				else
				{
					const tmpFile = tmpFileList[i];
					// formatted object to store in the list
					const tmpFileDetails = {
						Name: tmpFile.name, // can be updated by the user - becomes the 'Observation Name'
						FileName: tmpFile.name, // for display purposes only
						Description: '', // can be updated by the user - becomes the 'Observation Description'
						Tags: [], // can be updated by the user - becomes the 'Observation Tags'
						File: tmpFile, // the original file object in its entirety
						FileTypeIcon: this.pict.providers.ObservationProvider.returnFileIconFromFileType(tmpFile.type), // the icon to display for the file type
						ObservationType: this.pict.providers.ObservationProvider.returnObservationTypeFromFileType(tmpFile.type), // the type of observation to create
						GUID: this.pict.getUUID(), // a unique identifier for the file
					};
					// store this in the 'valid' list to be set to the global list after the loop
					tmpIncludedFileList.push(tmpFileDetails);
					// add the file list item to the page
					this.render('ObservationCreateMedia-Renderable-SelectionListRow', '#ObservationCreateMedia-FileList-SelectionList', tmpFileDetails);
				}
			}

			// now show the error message if we have any excluded files
			if (tmpExcludedFileList.length)
			{
				let tmpUIList = '';
				for (let i = 0; i < tmpExcludedFileList.length; i++)
				{
					tmpUIList += `<li>${ tmpExcludedFileList[i].name }</li>`;
				}
				// inject message above the file list
				this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-ErrorMessage', /*html*/`
				<div class="column notification is-danger is-dark mb-3 is-size-7">
					<span>The following files exceed the max individual file size limit of ${ this.convertBytesToGigabytes(this.InstanceConfiguration.FileSizeLimit) } GB:</span>
					<ol class="pl-5">${ tmpUIList }</ol>
				</div>`);
			}
		}
		const newCount = tmpIncludedFileList.length + '';
		// update the count in the header
		this.pict.ContentAssignment.assignContent('#FilesToUploadCount', newCount);
		// store our local copy for the next step
		this.FileListToUpload = tmpIncludedFileList;
		this.handleUploadButton();

		// set the first row as active
		if (this.FileListToUpload.length > 0)
		{
			const button = document.querySelector('#ObservationCreateMedia-FileList-SelectionList .panel-block:first-child');
			if (button instanceof HTMLElement)
			{
				button.click();
			}
		}
	}

	/**
	 * This method is used to handle the upload button state based on the file list.
	 * If there are files in the list, the button is enabled, otherwise it is disabled.
	 * This is useful for the user to know when they can upload the files.
	 */
	handleUploadButton()
	{
		if ( this.FileListToUpload.length > 0)
		{
			this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-FileList-UploadButton', 'disabled');
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-FileList-UploadButton', 'disabled', 'disabled');
		}
	}

	/**
	 * This method is used to handle the quick capture image event. This does everything from
	 * capturing the image, to uploading it to the server, and then updating the UI, but hides
	 * the details from the user. This is limited to single file only and does not use the upload panel flow.
	 * @param {Object} pFileInput
	 * @param {Object} pConfiguration
	 * @param {Function} pCallback
	 */
	async quickCaptureImage(pFileInput, pConfiguration, pCallback)
	{
		this.pict.log.info('Quick capture image: ', pConfiguration);

		if (!(pFileInput instanceof HTMLInputElement) || !pFileInput.files || pFileInput.files.length === 0)
		{
			this.pict.log.warn('No files selected for quick capture.');
			return;
		}
		else if (pFileInput.files.length > 1)
		{
			this.pict.log.warn('Multiple files selected for quick capture. Only the first file will be used.');
		}
		// set the button to "loading" since we have no other UI to show the user
		if (window.jQuery)
		{
			window.jQuery(pFileInput).parents('.button').addClass('is-loading');
		}
		// if we passed a callback set it now before we set the configuration
		// NOTE: this will run after the uploads are completed
		if (typeof pCallback === 'function')
		{
			this.InstanceConfiguration.onAfterCallback = pCallback;
		}
		this.setInstanceConfiguration(pConfiguration);

		const tmpFile = pFileInput.files[0];
		// formatted object to store in the list
		const tmpFileDetails = {
			Name: tmpFile.name, // can be updated by the user - becomes the 'Observation Name'
			FileName: tmpFile.name, // for display purposes only
			File: tmpFile, // the original file object in its entirety
			ObservationType: this.pict.providers.ObservationProvider.returnObservationTypeFromFileType(tmpFile.type), // the type of observation to create
			GUID: this.pict.getUUID(), // a unique identifier for the file
		};
		this.FileListToUpload = [ tmpFileDetails ];

		this.pict.log.info('Uploading file via Quick Capture: ', this.FileListToUpload);

		const observationResultList = [];

		// for each file, upload it and create an observation in a Promise
		await new Promise((resolve) =>
		{
			this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(tmpFileDetails, this.InstanceConfiguration.IDProject,
			(observationResult) =>
			{
				// add the result to the list
				observationResultList.push(observationResult);
				// update the file object with the result so we can use it for the preview replacement
				tmpFileDetails._ObservationResult = observationResult;
				// join to the document, if we have one
				this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.InstanceConfiguration.IDDocument, async () =>
				{
					// add the new observation to the document list (these are 'included' observations)
					const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
					// add result to our document if we have one and it is not already in the observations list
					if (tmpObservations && Array.isArray(tmpObservations) && tmpObservations.findIndex((o) => o.IDObservation === observationResult.IDObservation) < 0)
					{
						tmpObservations.push(observationResult);
					}
					resolve(observationResult);
				});
			});
		});
		// if we have a callback, run it now
		//FIXME: it seems like we don't need a callback here? we can just return the result?
		if (typeof this.InstanceConfiguration.onAfterCallback == 'function')
		{
			this.log.info('Running onAfterCallback...', this.InstanceConfiguration.onAfterCallback);
			this.FileListToUpload = [];
			await this.InstanceConfiguration.onAfterCallback(observationResultList.map((o) =>
			{
				return { IDObservation: o.IDObservation, Observation: o, FileDetails: tmpFileDetails };
			}));
		}
		else
		{
			const lastObservation = observationResultList[observationResultList.length - 1];
			this.uploadViewFinished(true, lastObservation);
		}
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	/**
	 * This method is used to reset the interim view content back to the initial state.
	 */
	resetIntermViewContent()
	{
		this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value');
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-Content-Interim-ProgressBar', 'is-success');
		this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-Button', 'disabled', '');
		this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', 'File 0 of 0 completed.');
	}

	/**
	 * This method is used to reset the file selection list back to the initial state.
	 * This is useful if the user wants to start over or if they have a file that is too large
	 * and they need to remove it from the list.
	 */
	resetFileSelectionList()
	{
		this.log.info('Resetting file selection list...');
		const tmpFileList = document.getElementById('ObservationCreateMedia-FileList-Input');
		// this may not be set if the user is using the quick capture method
		if (!tmpFileList || !(tmpFileList instanceof HTMLInputElement))
		{
			return;
		}
		// clear out the list on the UI everytime
		tmpFileList.value = '';
		// the re-run the selection flow
		this.handleUpdateSelectionList();
		// swap out the empty panel for the detail panel
		this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel', 'is-hidden');
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-Empty', 'is-hidden');
		// enable the add button again, disable the reset button
		this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-FileList-CreateButton', 'disabled');
		this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-FileList-ResetButton', 'disabled', 'disabled');
		this.updateStepsListActiveState(0);
		this.handleUploadButton();
	}

	/**
	 * This method is used to set the active row in the file selection list and show the details for the file.
	 * @param {String} pFileGUID
	 */
	setFileSelectionRowActive(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);

		if (!tmpFile)
		{
			this.pict.log.warn('File not found for GUID: ', pFileGUID);
			return;
		}

		// swap out the active row
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-FileList-SelectionList .panel-block', [ 'is-active', 'has-background-link-40' ]);
		this.pict.ContentAssignment.addClass(`#ObservationCreateMedia-FileList-SelectionList .panel-block[data-guid="${ pFileGUID }"]`, [ 'is-active', 'has-background-link-40' ]);
		// swap out the empty panel for the detail panel
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel', 'is-hidden');
		this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-Empty', 'is-hidden');
		// update the detail panel
		this.render('ObservationCreateMedia-Renderable-SelectionListDetails', ('#ObservationCreateMedia-DetailPanel'), tmpFile);
		// build the tag selection list
		this.lookUpTagsForSelectionList(pFileGUID);

		// if we have an image, show it in the preview
		if (tmpFile && tmpFile.File.type.includes('image'))
		{
			// update the image file preview
			const fileReader = new FileReader();
			const preview = document.querySelector('#ObservationCreateMedia-DetailPanel img');
			fileReader.onload = (event) =>
			{
				const result = event.target.result;
				if (typeof result === 'string')
				{
					preview.setAttribute('src', result);
				}
			};
			fileReader.readAsDataURL(tmpFile.File);
			// this file type is not an image, swap out the image preview for a placeholder
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-Image', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-NoImage', 'is-hidden');
		}
		else if (tmpFile && tmpFile.File.type.includes('pdf'))
		{
			const fileReader = new FileReader();
			const preview = document.querySelector('#ObservationCreateMedia-DetailPanel iframe');
			fileReader.onload = (event) =>
			{
				const result = event.target.result;
				if (typeof result === 'string')
				{
					preview.setAttribute('src', result);
				}
				this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-skeleton');
			};
			fileReader.readAsDataURL(tmpFile.File);
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-Image', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-skeleton');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-NoImage', 'is-hidden');
		}
		// files don't have a preview
		else
		{
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-Image', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-NoImage', 'is-hidden');
		}
	}

	/**
	 * This can be used by a developer to set the configuration for all instances if they
	 * prefer to set project/customer level defaults in the configuration file this is useful
	 * if you want to set the same configuration for all instances other than the target
	 * project/customer.
	 * @param {Object} pConfiguration
	 */
	setInstanceConfiguration(pConfiguration)
	{
		this.InstanceConfiguration = { ...this.InstanceConfiguration, ...pConfiguration };
	}

	/**
	 * This method is used to update the steps list to show the user where they are in the process.
	 */
	toggleContentViews()
	{
		if (this.pict.ContentAssignment.hasClass('#ObservationCreateMedia-Content-Entry', 'is-hidden'))
		{
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-Content-Entry', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-Content-Interim', 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-Content-Entry', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-Content-Interim', 'is-hidden');
		}
	}

	/**
	 * This method is used to update the title of Observation that will be created.
	 * @param {String} pFileGUID
	 */
	updateFileTitle(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);
		tmpFile.Name = this.pict.ContentAssignment.readContent('#ObservationCreateMedia-DetailPanel input');
	}

	/**
	 * This method is used to update the description of the Observation that will be created.
	 * @param {String} pFileGUID
	 */
	updateFileDescription(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);
		tmpFile.Description = this.pict.ContentAssignment.readContent('#ObservationCreateMedia-DetailPanel textarea');
	}

	/**
	 * This method is used to update the tags of the Observation that will be created.
	 * @param {String} pFileGUID
	 */
	updateFileLabels(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);
		tmpFile.Tags = this.pict.ContentAssignment.readContent('#ObservationCreateMedia-DetailPanel select');
	}

	/**
	 * This method is used to update the interim view content to show the user that the upload is complete.
	 */
	updateIntermViewContent()
	{
		this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value', '100');
		this.pict.ContentAssignment.addClass('#ObservationCreateMedia-Content-Interim-ProgressBar', 'is-success');
		this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-Content-Interim-Button', 'disabled');
		this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', 'Upload complete!');
	}

	/**
	 * This method is used to upload the selected files to the server and create the observations. Optional
	 * callback can be passed to run after the upload is complete.
	 */
	async uploadSelectedFiles()
	{
		// update the UI to show the user we are uploading
		this.updateStepsListActiveState(2);
		// switch to the interim content
		this.toggleContentViews();

		this.pict.log.info('Uploading files: ', this.FileListToUpload);

		const observationResultList = [];
		const observationInfoList = [];

		// for each file, upload it and create an observation in a Promise
		const uploadPromises = this.FileListToUpload.map((pFile, i) =>
		{
			return new Promise((resolve, reject) =>
			{
				// update the current file count
				this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', `Uploading File ${ i + 1 } of ${ this.FileListToUpload.length }.`);
				this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value', '0');
				this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(pFile, this.InstanceConfiguration.IDProject,
				(observationResult) =>
				{
					// add the result to the list
					observationResultList.push(observationResult);
					observationInfoList.push({ IDObservation: observationResult.IDObservation, Observation: observationResult, FileDetails: pFile });
					// update the file object with the result so we can use it for the preview replacement
					pFile._ObservationResult = observationResult;
					// join to the document, if we have one
					this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.InstanceConfiguration.IDDocument, async () =>
					{
						// add the new observation to the document list (these are 'included' observations)
						const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
						// add result to our document if we have one (and only if it is not already added to the document)
						if (tmpObservations && Array.isArray(tmpObservations) && !tmpObservations.map((o) => o.IDObservation).includes(observationResult.IDObservation))
						{
							tmpObservations.push(observationResult);
						}
						// if an observation set is active, add the observation to the set too
						if (this.pict.views.ObservationSet.ActiveObservationSet)
						{
							this.pict.views.ObservationSet.addObservationToSet(observationResult.IDObservation);
						}
						// if we have a post-join callback, then run it now
						if (this.InstanceConfiguration.onAfterDocumentJoinCallback && typeof this.InstanceConfiguration.onAfterDocumentJoinCallback === 'function')
						{
							this.InstanceConfiguration.onAfterDocumentJoinCallback(observationResult);
						}
						resolve(observationResult);
					});
				},
				(pctComplete) =>
				{
					// update the progress bar's value
					const tmpValue = pctComplete * 100 + '';
					this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value', tmpValue);
				});
			});
		});
		// wait for all the promises to resolve — use allSettled so one failed
		// upload doesn't prevent the rest from completing or skip cleanup
		const uploadResults = await Promise.allSettled(uploadPromises);
		const failedUploads = uploadResults.filter((r) => r.status === 'rejected');
		if (failedUploads.length > 0)
		{
			this.pict.log.error(`${failedUploads.length} of ${uploadResults.length} file(s) failed to upload:`, failedUploads);
			this.pict.views.HeadlightPanels.toast({
				message: `${failedUploads.length} of ${uploadResults.length} file(s) failed to upload. Check the console for details.`,
				type: 'is-danger',
			});
		}
		this.pict.log.info('All files uploaded: ', observationResultList);
		this.FileListToUpload = [];
		// if we have a callback, run it now
		if (typeof this.InstanceConfiguration.onAfterCallback == 'function')
		{
			//reset the tag list
			this.resetObservationTagList();
			this.log.info('Running onAfterCallback...', this.InstanceConfiguration.onAfterCallback);
			await this.InstanceConfiguration.onAfterCallback(observationInfoList);
		}
		else
		{
			if (typeof this.InstanceConfiguration.onFallbackCallback == 'function')
			{
				this.log.info('Running onFallbackCallback...', this.InstanceConfiguration.onFallbackCallback);
				await this.InstanceConfiguration.onFallbackCallback(observationInfoList);
			}
			// update the UI to say the view is done (it's safe to close now)
			this.updateStepsListActiveState(3);
			this.updateIntermViewContent();
			// for the upload complete message
			const delayInSeconds = 3;
			// finally, let the user know we are done, then close the view for them if they don't
			for (let i = 0; i < delayInSeconds; i++)
			{
				this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', `<p class="p-2 is-size-5">Upload complete!<p><p class="p-2 has-text-primary-light">Closing in ${ delayInSeconds - i }...</p>`);
				await new Promise((resolve) => setTimeout(resolve, 1000));
			}
		}
		// clean up the panel upload view and run any cache busting for media section content
		const lastObservation = observationResultList[observationResultList.length - 1];
		this.uploadViewFinished(false, lastObservation);
		// close the observation panel
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
		// clear the observation panel target and the banner on the header
		this.pict.views.HeadlightPaneObservations.clearObservationPanelTarget();
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	/**
	 * This method is used to update the active state of the steps list in the header.
	 * @param {Number} pStepNumber
	 */
	updateStepsListActiveState(pStepNumber)
	{
		const steps = document.querySelectorAll('#ObservationCreateMedia-Steps-List li');
		steps.forEach((step, i) =>
		{
			if (i === pStepNumber)
			{
				step.classList.add('is-active');
			}
			else
			{
				step.classList.remove('is-active');
			}
		});
	}

	/**
	 * Resets the tags list for the observation creation view to ensure that new tags are displayed.
	 */
	resetObservationTagList()
	{
		this.InstanceConfiguration.TagsList = [];
	}

	/**
	 * This method is used to handle the file selection event and update the UI accordingly.
	 * @param {boolean} [pQuickCapture=false] - if the file was captured via the quick capture method
	 * @param {Object} [pLastObservation] - the last observation created, if available
	 * @returns {void}
	 */
	uploadViewFinished(pQuickCapture, pLastObservation)
	{
		this.pict.log.info('Upload view completed!');
		this.resetIntermViewContent();
		this.toggleContentViews();
		this.resetFileSelectionList();
		this.resetObservationTagList();

		this.pict.views.ObservationIncluded.buildIncludedObservationsList(true);
		// if we used quick capture, we don't want to open the observation included panel
		if (!pQuickCapture)
		{
			// switch to the included tab
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
				// toggle open the collapsed Image obersvation group
				// TODO: might want to check the file upload type and open the correct group, but the 99% use case is images
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('Legacy Image');
			});
		}
	}
}

module.exports = ObservationCreateMedia;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationCreateMedia',
	DefaultRenderable: 'ObservationCreateMedia',
	DefaultDestinationAddress: '#ObservationCreateMedia-Container',
	Templates:
	[
		{
			Hash: 'ObservationCreateMedia-Template',
			Template: /*html*/`
			<div id="ObservationCreateMedia">
				<header class="has-background-text-15 p-4">
					<ol id="ObservationCreateMedia-Steps-List" class="steps-list">
						<li class="is-active">Add Files</li>
						<li>Edit Details</li>
						<li>Upload Data</li>
						<li>Complete</li>
					</ol>
				</header>
				<!-- step 1: select files / edit details -->
				<div id="ObservationCreateMedia-Content-Entry" class="p-4">
					<div class="columns is-mobile">
						<div class="column is-one-third-tablet">{~T:ObservationCreateMedia-FileSelection-ListPanel~}</div>
						<div class="column has-text-white">
							<div class="notification has-text-centered p-6 empty-message" id="ObservationCreateMedia-DetailPanel-Empty">
								<span class="icon">
									<i class="fas fa-info-circle" aria-hidden="true"></i>
								</span>
								<span>No file preview available.</span>
							</div>
							<div id="ObservationCreateMedia-DetailPanel" class="is-hidden">
								{~T:ObservationCreateMedia-FileSelection-DetailPanel~}
							</div>
							<footer class="mt-4 buttons is-right">
								<button type="button" title="Upload selected file" id="ObservationCreateMedia-FileList-UploadButton" disabled class="button is-primary" onclick="_Pict.views.ObservationCreateMedia.uploadSelectedFiles()">
									<span class="icon"><i class="fas fa-fw fa-upload"></i></span>
									<span>Upload Files</span>
								</button>
							</footer>
						</div>
					</div>
				</div>
				<!-- step 2: upload files / results -->
				<div id="ObservationCreateMedia-Content-Interim" class="is-hidden p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<p class="title is-6 has-text-centered mb-3 has-text-white" id="ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage">File 0 of 0 completed.</p>
							<progress id="ObservationCreateMedia-Content-Interim-ProgressBar" class="progress is-primary" max="100"></progress>
							<div class="is-size-7 has-text-centered">This may take a few minutes depending on the size of the files and your internet connection.</div>
							<div class="is-size-7 has-text-centered">Please do not close this window until the upload is complete.</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationCreateMedia-FileSelection-ListRow',
			Template: /*html*/`
			<a class="panel-block has-background-text-20 mt-1" data-guid="{~D:Record.GUID~}" onclick="_Pict.views.ObservationCreateMedia.setFileSelectionRowActive('{~D:Record.GUID~}')">
				<span class="panel-icon">
					<i class="fas fa-fw {~D:Record.FileTypeIcon~}"></i>
				</span>
				<span class="is-clipped">{~D:Record.FileName~}</span>
			</a>`,
		},
		{
			Hash: 'ObservationCreateMedia-FileSelection-ListPanel',
			Template: /*html*/`
			<div id="ObservationCreateMedia-FileList-Limitations">
				<div class="column notification is-dark is-text mb-3">
					<p class="is-size-7"><strong>Upload Limitations:</strong></p>
					<p class="is-size-7">File Count: <span class="has-text-text-90">{~D:Context[0].InstanceConfiguration.FileNumberLimit~}</span></p>
					<p class="is-size-7">Individual File Size: <span class="has-text-text-90">{~ToGigaBytes:Context[0].InstanceConfiguration.FileSizeLimit~} GB</span></p>
					<p class="is-size-7 mt-2"><i class="fa fa-fw fa-info-circle"></i> You can hold "Shift" or "Control" to select multiple files.</p>
				</div>
			</div>
			<div id="ObservationCreateMedia-FileList-ErrorMessage"><!-- error message - reserved space --></div>
			<article class="is-primary">
				<p class="tag is-dark is-rounded is-pulled-right mt-3 mr-3" id="FilesToUploadCount">0</p>
				<p class="panel-heading is-size-6 has-background-text-15">Files to upload</p>
				<div class="overflow-list-container" id="ObservationCreateMedia-FileList-SelectionList" style="max-height: 50vh; overflow-y: auto;"></div>
				<div class="notification has-text-centered empty-message" style="border-top-left-radius: 0; border-top-right-radius: 0;" id="ObservationCreateMedia-FileList-EmptyRow">
					<p class="is-size-7 mt-3 mb-5">No files selected.</p>
					<label class="button p-0 is-primary is-fullwidth" 
					id="ObservationCreateMedia-FileList-CreateButton">
						<input 
							class="file-input" 
							type="file"
							id="ObservationCreateMedia-FileList-Input"
							name="file-list-to-upload"
							multiple
							onclick="_Pict.views.ObservationCreateMedia.checkIfLocked(event)"
							onchange="_Pict.views.ObservationCreateMedia.handleUpdateSelectionList()"
							/>
						<span class="file-cta" style="border:none">
							<span class="file-icon">
								<i class="fas fa-plus-circle"></i>
							</span>
							<span class="file-label is-hidden-mobile is-hidden-tablet-only"> Select files</span>
							<span class="file-label is-hidden-desktop"> Add</span>
						</span>
					</label>
				</div>
			</article>
			<div class="buttons is-right">
				<button 
					class="button is-primary is-dark mt-2" 
					id="ObservationCreateMedia-FileList-ResetButton"
					disabled 
					type="buton" 
					onclick="_Pict.views.ObservationCreateMedia.resetFileSelectionList()"
					>
					<span class="icon"><i class="fas fa-fw fa-undo"></i></span>
					<span>Reset list</span>
				</button>
			</div>`,
		},
		{
			Hash: 'ObservationCreateMedia-FileSelection-DetailPanel',
			Template: /*html*/`
			<div class="notification has-text-centered p-6 empty-message" id="ObservationCreateMedia-DetailPanel-NoImage">
				<span class="icon">
					<i class="fas fa-question-circle" aria-hidden="true"></i>
				</span>
				<span>No preview available for this file type.</span>
			</div>
			<figure class="image mb-4 is-hidden" id="ObservationCreateMedia-DetailPanel-FilePreview">
				<iframe class="preview-image has-background-text-15" style="width: 100%; height: 25vh; max-height: 350px; object-fit: contain;"></iframe>
			</figure>
			<figure class="image mb-4 is-hidden" id="ObservationCreateMedia-DetailPanel-Image">
				<img class="preview-image has-background-text-15" style="max-width: 100%; height: 25vh; max-height: 350px; object-fit: contain;">
			</figure>
			<div class="field">
				<label class="label">Title</label>
				<div class="control">
					<input 
						class="input" 
						type="text" 
						placeholder="Title" 
						value="{~D:Record.Name~}"
						onchange="_Pict.views.ObservationCreateMedia.updateFileTitle('{~D:Record.GUID~}')"
						>
				</div>
			</div>
			<div class="field">
				<label class="label">Description</label>
				<div class="control">
					<textarea onchange="_Pict.views.ObservationCreateMedia.updateFileDescription('{~D:Record.GUID~}')"
						class="textarea shrunken-textarea" 
						style="min-height: 5em;"
						placeholder="Description">{~D:Record.Description~}</textarea>
				</div>
			</div>
			<div class="field">
				<label class="label">Tags</label>
				<div class="control">
					<div class="select is-fullwidth">
						<select 
							class="is-skeleton"
							multiple
							id="ObservationCreateMedia-FileList-LabelSelect"
							onchange="_Pict.views.ObservationCreateMedia.updateFileLabels('{~D:Record.GUID~}')">
							<option value="" selected>Select a tag</option>
						</select>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationCreateMedia',
			TemplateHash: 'ObservationCreateMedia-Template',
			DestinationAddress: '#ObservationCreateMedia-Container',
		},
		{
			RenderableHash: 'ObservationCreateMedia-Renderable-SelectionListRow',
			TemplateHash: 'ObservationCreateMedia-FileSelection-ListRow',
			RenderMethod: 'append',
		},
		{
			RenderableHash: 'ObservationCreateMedia-Renderable-SelectionListDetails',
			TemplateHash: 'ObservationCreateMedia-FileSelection-DetailPanel',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":693}],801:[function(require,module,exports){
const PictViewClass = require('pict-view');
const libPictSectionPDFJS = require('pict-section-pdfjs');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationDetailsBackTo = null;
		this.ObservationDetailsBackToSet = false;

		// if the observation type is a PDF, use an embed tag, otherwise use an img tag
		this.pict.MetaTemplate.addPattern('{~PreviewImage:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isPDF = tmpValue?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
			const isVideo = tmpValue?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video';
			const isAudio = tmpValue?.Details?.Audio?.[0]?.ArtifactType?.toLowerCase() === 'audio';
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			let tmpIDArtifact;
			let tmpVersion;
			// show a PDF viewer if the observation is a PDF file type
			if (isPDF)
			{
				tmpIDArtifact = tmpValue?.Details?.File?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.File?.[0]?.Version;
				const template = /*html*/`
				<div class="has-background-text-40" id="PDFJS-Container-Div" style="width: 100%; height: 500px; max-height: 500px; overflow: hidden;"></div>
				<div class="image-floated-button buttons" style="box-shadow: none;">
					<button type="button" style="box-shadow: var(--panels-button-shadow);" title="Add Markup Observation" class="button is-warning is-rounded mr-2" onclick="_Pict.views.ObservationDetails.handlePDFNotesButtonClick(event)">
						<span class="icon">
							<i class="fa fa-fw fa-sticky-note"></i>
						</span>
						<span>Add Markup Observation</span>
					</button>
				</div>`;
				return template;
			}
			// show a video player if the observation is a video file type
			else if (isVideo)
			{
				tmpIDArtifact = tmpValue?.Details?.Video?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Video?.[0]?.Version;
				return `<video autoplay muted class="has-background-text-40" style="width: 500px; height: auto" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="video/mp4"></video>`;
			}
			// show an audio player if the observation is an audio file type
			else if (isAudio)
			{
				tmpIDArtifact = tmpValue?.Details?.Audio?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Audio?.[0]?.Version;
				return `<audio class="has-background-text-40" style="width: 500px; height: 75px; padding: 10px" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="audio/mp3"></audio>`;
			}
			else if (isImage)
			{
				// if the observation is locked, don't show the annotate button
				if (this.pict.AppData.DocumentData?.ReportData?.Locked)
				{
					return '';
				}
				const template =
				`<img class="has-background-text-40 detail-image" src="/1.0/Observation/${tmpValue.IDObservation}/Image/Preview?t=${ new Date().getTime() }" alt="Observation Preview" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />
				<button type="button" title="Annotate observation" class="button is-warning is-rounded image-floated-button" onclick="_Pict.views.ObservationDetails.handleAnnotationButtonClick(event)">
					<span class="icon">
						<i class="fa fa-fw fa-pen"></i>
					</span>
					<span>Annotate</span>
				</button>`;
				return template;
			}
			else
			{
				return `<img class="has-background-text-40 detail-image" src="/1.0/Observation/${tmpValue.IDObservation}/Image/Preview?t=${ new Date().getTime() }" alt="Observation Preview" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />`;
			}
		});

		// if the observation is a PDF or an image, show the skeleton loading class (audio/video tags don't have a skeleton)
		this.pict.MetaTemplate.addPattern('{~UseSkeltonLoading:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			return isImage ? 'is-skeleton' : '';
		});

		// TODO: since we no longer have full-screen mode, should we remove this pattern?
		// if the observation type is a PDF, use an embed tag, otherwise use an img tag
		this.pict.MetaTemplate.addPattern('{~FullImage:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isPDF = tmpValue?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
			const isVideo = tmpValue?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video';
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			let tmpIDArtifact; let tmpVersion;
			// show a PDF viewer if the observation is a PDF file type
			if (isPDF)
			{
				tmpIDArtifact = tmpValue?.Details?.File?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.File?.[0]?.Version;
				return `<embed class="has-background-text-40 full-size-pdf-with-offsets" src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />`;
			}
			// show a video player if the observation is a video file type
			else if (isVideo)
			{
				tmpIDArtifact = tmpValue?.Details?.Video?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Video?.[0]?.Version;
				return `<video autoplay class="has-background-text-40 full-size-video-with-offsets" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="video/mp4"></video>`;
			}
			// show a full size image if the observation is an image file type
			else if (isImage)
			{
				tmpIDArtifact = tmpValue?.Details?.Image?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Image?.[0]?.Version;
				return `<img class="has-background-text-40 full-size-image-with-offsets" src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }" alt="Observation Fullsize" />`;
			}
			// audio doesn't have a full size view, nothing else should be shown
			else
			{
				return `<div class="notification has-text-centered m-3"><span class="icon"><i class="fa fa-fw fa-exclamation-triangle"></i></span><span>No full size available.</span></div>`;
			}
		});

		// if the observation has a map location, show it, otherwise show an image message
		this.pict.MetaTemplate.addPattern('{~ShowMiniMap:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hasValidCaptureGeoLocation = false;
			let hasValidUserGeoLocation = false;
			// check if the observation has a valid capture or user geolocation
			if (tmpValue?.CaptureLatitude && tmpValue?.CaptureLongitude)
			{
				hasValidCaptureGeoLocation = this.pict.providers.UtilityProvider.isValidLatitude(tmpValue?.CaptureLatitude) && this.pict.providers.UtilityProvider.isValidLongitude(tmpValue?.CaptureLongitude) && (Number(tmpValue?.CaptureLatitude) !== 0 && Number(tmpValue?.CaptureLongitude) !== 0);
			}
			if (tmpValue?.UserLatitude && tmpValue?.UserLongitude)
			{
				hasValidUserGeoLocation = this.pict.providers.UtilityProvider.isValidLatitude(tmpValue?.UserLatitude) && this.pict.providers.UtilityProvider.isValidLongitude(tmpValue?.UserLongitude) && (Number(tmpValue?.UserLatitude) !== 0 && Number(tmpValue?.UserLongitude) !== 0);
			}
			return hasValidCaptureGeoLocation || hasValidUserGeoLocation ? `/1.0/Observation/Map/For/${tmpValue.IDObservation}` : `null`;
		});

		// If the observation has edit capability, show the edit button
		this.pict.MetaTemplate.addPattern('{~CanEdit:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			this.pict.log.info('ObservationDetails:CanEdit:', tmpValue);
			// if the observation is locked, hide the edit button
			if (this.pict.AppData.DocumentData?.ReportData?.Locked)
			{
				return '';
			}
			// if the user does not have CanEdit ability, hide the edit button
			if (!this.pict.AppData.DocumentData?.ReportData?.CanEdit)
			{
				return '';
			}
			if (tmpValue?.Locked)
			{
				return '';
			}
			const template =
					`<button id="ObservationDetails-Content-Edit-Button" type="button" title="Edit Observation Details" class="button is-primary" onclick="_Pict.views.ObservationDetails.observationDetailsEditHandler(event)">
						<span class="icon">
							<i id="ObservationDetails-Content-Edit-Icon" class="fa fa-fw fa-pencil"></i>
						</span>
						<span>Edit Details</span>
					</button>
					<button id="ObservationDetails-Content-Save-Button" type="button" title="Save Observation Details" class="button is-success is-hidden" onclick="_Pict.views.ObservationDetails.observationDetailsSaveHandler(event)">
						<span class="icon">
							<i id="ObservationDetails-Content-Save-Icon" class="fa fa-fw fa-save"></i>
						</span>
						<span>Save Details</span>
					</button>`;
			return template;
		});
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetObservationDetailsView()
	{
		if (this.pict?.views?.ObservationSubImageSelector?.intent)
		{
			this.pict.views.ObservationSubImageSelector.intent =
			{
				type: 'Document',
			};
		}
		this.ActiveObservationDetails = {};
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const isPDF = this.ActiveObservationDetails?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
		if (isPDF)
		{
			const tmpIDArtifact = this.ActiveObservationDetails?.Details?.File?.[0]?.IDArtifact;
			const tmpVersion = this.ActiveObservationDetails?.Details?.File?.[0]?.Version;
			if (!this.pict.views?.PDFViewer)
			{
				this.pict.addView('PDFViewer', Object.assign(libPictSectionPDFJS.default_configuration, { pdfUrl: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}` }), libPictSectionPDFJS);
			}
			if (this.pict.views?.PDFViewer)
			{
				this.pict.views.PDFViewer.options.pdfUrl = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
				this.pict.views.PDFViewer.render();
			}
		}
		return super.onAfterRender(pRenderable);
	}

	resetObservationTargetPanel()
	{
		if (this.ObservationDetailsBackToSet)
		{
			const observationSetName = document.getElementById('HeadlightPanels-ObservationSet-Title-Wrapper').innerText;
			document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', 'add-to-set');
			document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = observationSetName;
			this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-set';
			this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-set';
			this.pict.views.ObservationSearch.setMode('add-to-set');
		}
	}
	/**
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		// TODO: probably should update this to use data state to track pinned open panels
		if (event && event.target instanceof HTMLElement && event.target.closest('.hl-panel-wrapper').classList.contains('pinned-open'))
		{
			this.log.info('Panel is pinned open, not going back to Observation List view');
			return;
		}
		const tempGroupKey = this.ActiveObservationDetails.ObservationType;
		this.resetObservationDetailsView();
		// go back to the search view if the user came from there
		if (this.ObservationDetailsBackTo === 'Search')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				this.pict.views.ObservationSearch.updateWithSearchResults(this.pict.views.ObservationSearch.CurrentSearchResults, this.pict.views.ObservationSearch.CurrentSearchResults.length);
			});
		}
		else if (this.ObservationDetailsBackTo === 'Included')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(tempGroupKey, 'open');
			});
		}
		else if (this.ObservationDetailsBackTo === 'ProjectFileSearch')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.log.info('Returning to Project Files Search view');
			});
		}
		else
		{
			// close all panels and reset the Observation Details view (same as clicking the close button)
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationDetails.resetObservationDetailsView();
		}
	}

	/**
	 *
	 * @return {number | undefined} the current page being viewed on the PDFViewer
	 */
	getCurrentPage()
	{
		const pageChoice = this.pict.views.PDFViewer.getCurrentPage();
		if (pageChoice && !isNaN(pageChoice))
		{
			return Number(pageChoice);
		}
		return undefined;
	}

	observationDetailsEditHandler(event)
	{
		if (!this.pict.AppData.DocumentData.ReportData.Observations)
		{
			this.log.error(`No Observations; can't update observation details for observation: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Observations; can't update observation details for observation: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			// if editable containers exist
			if (document.getElementById('ObservationDetail-Content-Title-Container') && document.getElementById('ObservationDetail-Content-Description-Container'))
			{
				// swap readonlies for inputs
				document.getElementById('ObservationDetails-Content-Title-Readonly').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Title-Edit').classList.remove('is-hidden');
				document.getElementById('ObservationDetails-Content-Description-Readonly').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Description-Edit').classList.remove('is-hidden');
			}
			// if edit button exists
			if (document.getElementById('ObservationDetails-Content-Edit-Button'))
			{
				// change edit aesthetics to save aesthetics
				document.getElementById('ObservationDetails-Content-Edit-Button').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Save-Button').classList.remove('is-hidden');
			}
		}
	}

	async observationDetailsSaveHandler(event)
	{
		if (event)
		{
			event.currentTarget.classList.add('is-loading');
		}
		const tmpObservationDetails = {};
		// TODO: fix this to be "correct" and not use ts-ignore
		/** @ts-ignore */
		const tmpName = document.getElementById('ObservationDetails-Content-Title-Input').value;
		/** @ts-ignore */
		const tmpDescription = document.getElementById('ObservationDetails-Content-Description-Input').value;
		tmpObservationDetails.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		tmpObservationDetails.IDObservation = this.ActiveObservationDetails.IDObservation;
		tmpObservationDetails.Name = tmpName || tmpObservationDetails.Name;
		tmpObservationDetails.Description = tmpDescription || '';
		// TODO: Future enhancement - list documents that contain observation being changed and alert user the title and/or description will change for all
		await this.pict.providers.ObservationProvider.updateObservation(tmpObservationDetails, (observationResult) =>
		{
			this.ActiveObservationDetails = observationResult;
			// Need to update in-memory representation or updated values won't show up when reopening observation
			if (this.AppData?.DocumentData?.ReportData?.Observations && Array.isArray(this.AppData?.DocumentData?.ReportData?.Observations))
			{
				for (let i = 0; i < this.AppData.DocumentData.ReportData.Observations.length; i++)
				{
					if (this.AppData.DocumentData.ReportData.Observations[i].IDObservation === this.ActiveObservationDetails.IDObservation)
					{
						this.AppData.DocumentData.ReportData.Observations[i] = observationResult;
					}
				}
			}
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
		this.renderAsync(()=>
		{
			this.pict.log.info('Observation Details Updated');
		});
	}

	handlePDFNotesButtonClick(event)
	{
		if (event && event.currentTarget)
		{
			event.currentTarget.classList.add('is-loading');
		}
		this.log.info('PDF Notes button clicked');
		this.pict.views.ObservationSubImageSelector.resetObservationSubImageSelectorView(true, true, this.getCurrentPage());
		this.pict.views.ObservationSubImageSelector.ActiveObservationDetails = this.ActiveObservationDetails;
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationSubImageSelector', 'open');

		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	handleAnnotationButtonClick(event)
	{
		if (event && event.currentTarget)
		{
			event.currentTarget.classList.add('is-loading');
		}
		this.log.info('Annotation button clicked');
		this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
		this.pict.views.ObservationAnnotation.ActiveObservationDetails = this.ActiveObservationDetails;
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationAnnotation', 'open');

		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	toggleWidth()
	{
		const toggleEl = this.pict.ContentAssignment.getElement('#split-toggle-icon')?.[0];
		const animate = (el)=>
		{
			el.classList.add('fa-flip');
			setTimeout(()=>
			{
				el.classList.remove('fa-flip');
			}, 500);
		};
		if (toggleEl?.classList?.contains('fa-flip-horizontal'))
		{
			animate(toggleEl);
			toggleEl.classList.remove('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(40);
		}
		else
		{
			animate(toggleEl);
			toggleEl.classList.add('fa-flip-horizontal');
			// 50 has the right panel flush with the left panel. Any more and it covers the left panel.
			this.pict.HeadlightPanels.rightPanelCustomWidth(50);
		}
	}
}

module.exports = ObservationDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationDetails',
	DefaultRenderable: 'ObservationDetails',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'ObservationDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationDetailsPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
				<p id="HeadlightPanels-ObservationDetailsPanel-Observation-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.ObservationDetails.resetObservationDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					{~TIfAbs:ObservationDetails-BackButton:Record:Pict.views.ObservationDetails.ObservationDetailsBackTo^===^ProjectFileSearch~}
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('Right')">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right mr-2" aria-label="expand" title="Resize observation" onclick="_Pict.views.ObservationDetails.toggleWidth()">
						<span class="icon">
							<i class="fas fa-fw fa-table-layout fa-flip-horizontal" aria-hidden="true" id="split-toggle-icon"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationDetailsPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationDetailsPanel-Observation-Header-Title" class="mr-3">Observation Details</span>
				</p>
				<div id="HeadlightPanels-ObservationDetails-Content" class="nested-scroll-content has-bottom-navbar-offset">
					{~T:ObservationDetails-Content:Pict.views.ObservationDetails.ActiveObservationDetails~}
				</div>
			</article>`,
		},
		{
			Hash: 'ObservationDetails-BackButton',
			Template: /*html*/`
				<button type="button" class="is-pulled-right hl-panel-close-button mr-2 {~Show:Pict.views.ObservationDetails.ObservationDetailsBackTo~}" aria-label="back" title="Back to Project Files" onclick="_Pict.views.ObservationDetails.returnToPreviousLocation(event)">
					<span class="icon">
						<i class="fas fa-fw fa-chevron-circle-left" aria-hidden="true"></i>
					</span>
				</button>
			`,
		},
		{
			Hash: 'ObservationDetails-Content',
			Template: /*html*/`
			<div class="container panel-content nested-scroll-content has-bottom-navbar-offset" style="width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<figure class="image detail-image-wrapper {~UseSkeltonLoading:Record~}">
					{~PreviewImage:Record~}
				</figure>
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-20">
					{~T:ObservationDetails-Content-Title:Record~}
				</div>
				<div class="columns m-0 p-0 mb-4">
					<div class="column is-6 px-5">
						<span class="title is-block is-6 has-text-text-60">Observation Type</span>
						<span class="subtitle is-6 has-text-text-90">{~ObsTypeDisplay:Record.ObservationType~}</span>
					</div>
					<div class="column p-0">
						{~T:ObservationDetails-Content-Map:Record~}
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^ObservationDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Designated Time</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DesignatedTime^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				{~T:ObservationDetails-Content-Description:Record~}
				<div class="columns px-5">
					<div class="column has-text-right">
						{~CanEdit:Record~}
					</div>
				</div>
				<div class="columns is-multiline px-5">
					{~TS:ObservationDetails-Content-TagType:Pict.providers.ObservationProvider.getObservationTagTypes(Context[0].ActiveObservationDetails)~}
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-TagType',
			Template: /*html*/`
			<div class="column">
				<span class="label has-text-text-65">{~D:Record.TagType~}</span>
				<div class="tags tag-list">
					{~TS:ObservationDetails-Content-Tag:Pict.providers.ObservationProvider.getObservationTags(Pict.views.ObservationDetails.ActiveObservationDetails,Record.TagType)~}
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Title',
			Template: /*html*/`
			<div id="ObservationDetail-Content-Title-Container" class="column">
				<p id="ObservationDetails-Content-Title-Readonly" class="title is-4 has-text-white mb-2">{~D:Record.Name~}</p>
				<p id="ObservationDetails-Content-Title-Edit" class="control is-fullwidth is-relative is-hidden">
					<input 
						id="ObservationDetails-Content-Title-Input"
						class="input has-background-text-30"
						value="{~D:Record.Name~}"
					/>
				</p>
				<p class="subtitle is-6 has-text-text-65">
					<span class="is-pulled-right">
						{~TIfAbs:ObservationDetails-Locked:Record.Locked:Record.Locked^==^1~}
						{~TIfAbs:ObservationDetails-Unlocked:Record.Locked:Record.Locked^==^0~}
					</span>
					<span class="mr-1">#{~D:Record.IDObservation~}</span>
				</p>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Description',
			Template: /*html*/`
			<div id="ObservationDetail-Content-Description-Container" class="columns px-5">
				<div class="column">
					<p class="title is-6 has-text-text-65 mb-1">Description</p>
					<div id="ObservationDetails-Content-Description-Readonly" class="is-6 has-text-text-90">{~D:Record.Description~}</div>
					<p id="ObservationDetails-Content-Description-Edit" class="control is-fullwidth is-relative is-hidden">
						<textarea 
							id="ObservationDetails-Content-Description-Input"
							class="textarea has-background-text-30"
							rows="2"
						>{~D:Record.Description~}</textarea>
					</p>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Map',
			Template: /*html*/`
			<figure class="image">
				<img onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~ShowMiniMap:Record~}" />
			</figure>`,
		},
		{
			Hash: 'ObservationDetails-Content-Tag',
			Template: /*html*/`<span class="tag {~LabelClass:Record~}">{~D:Record.Tag~}</span>`,
		},
		{
			Hash: 'ObservationDetails-Content-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'ObservationDetails-Locked',
			Template: /*html*/`
				<span class="icon has-text-text-95">
					<i class="fas fa-fw fa-sm fa-lock"></i>
				</span>
				<span class="icon-text has-text-text-95">Locked</span>`,
		},
		{
			Hash: 'ObservationDetails-Unlocked',
			Template: /*html*/`
				<span class="icon">
					<i class="fas fa-fw fa-sm fa-unlock"></i>
				</span>
				<span class="icon-text">Unlocked</span>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationDetails',
			TemplateHash: 'ObservationDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationDetails-Content',
			TemplateHash: 'ObservationDetails-Content',
			DestinationAddress: '#HeadlightPanels-ObservationDetails-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-section-pdfjs":603,"pict-view":693}],802:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationIncluded extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// set the default data for the included observations
		this.IncludedObservationsGroupedByType = {};
	}

	/**
	 * Build (or rebuild) the included observations list
	 * @param {Boolean} rerender - Whether or not to re-render the panel after building the list
	 * @return {void}
	 */
	buildIncludedObservationsList(rerender = false)
	{
		// group the current observations by type, then re-render the panel
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		this.IncludedObservationsGroupedByType = this.pict.providers.ObservationProvider.groupObservationsByType(tmpObservations);
		if (rerender)
		{
			this.pict.views.HeadlightPanels.renderAsync('HeadlightPanels-ObservationPanel-Included', null, null, null, () =>
			{
				this.log.info('Included observations list rendered.');
			});
		}
	}

	/**
	 * This function is used to handle the removal of an observation from a document.
	 * @param {Event} pEvent - The event for removing an observation from a document.
	 * @param {string} pIDObservation - The observation id to remove from the document
	 * @param {string} pGroupKey - The group key to re-open the collapsible panel
	 * @return {Promise<void>}
	 * @async
	 */
	async handleRemoveIncludedObservation(pEvent, pIDObservation, pGroupKey)
	{
		// prevent onclick event attached to table row that opens detail panel when clicking remove observation
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return;
		}
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations?.filter((observation) => observation.IDObservation != pIDObservation);
		}
		await this.pict.providers.DocumentProvider.handleSave(true);
		// rebuild the included observations list
		this.buildIncludedObservationsList(true);
		// re-open the collapsible panel group if still has items
		if (pGroupKey)
		{
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(pGroupKey);
		}
		// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the removed observation
		if (this.pict.providers.ObservationCardDeckProvider)
		{
			await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'remove', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
		}
	}
}

module.exports = ObservationIncluded;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationIncluded',
	DefaultRenderable: 'ObservationIncluded',
	DefaultDestinationAddress: '#ObservationIncluded-Container',
	Templates:
		[
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included',
				Template: /*html*/`
				<!-- Observation Panel Content > Included View > Empty Message or Observation List (depending on list length) -->
				{~TIfAbs:HeadlightPanels-ObservationPanel-Included-EmptyMessage:AppData:AppData.DocumentData.ReportData.Observations.length^==^0~}
				{~TIfAbs:HeadlightPanels-ObservationPanel-Included-List:AppData:AppData.DocumentData.ReportData.Observations.length^>^0~}`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-EmptyMessage',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationPanel-Included-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="has-text-centered">No observations are included in this document.</p>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List',
				Template: /*html*/`
				<!-- Observation Panel Content > Included View > List -->
				<div id="HeadlightPanels-ObservationPanel-Included-List" class="nested-scroll-content panel-views-height-offset has-preivew-images">
					{~TS:HeadlightPanels-ObservationPanel-Included-List-Group:Pict.views.ObservationIncluded.IncludedObservationsGroupedByType~}
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group',
				Template: /*html*/`
				<div class="panel-block is-collapsible-header pr-6 is-relative" data-collapsible-toggle="{~D:Record.ObservationType~}" onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('{~D:Record.ObservationType~}')">
					<span class="panel-icon panel-block-toggle-icon">
						<i class="fa fa-fw fa-chevron-right"></i>
					</span>
					<span class="panel-icon panel-block-type-icon">
						<i class="fa fa-fw {~D:Record.ObservationTypeDetails.Icon~}"></i>
					</span>
					<span class="has-text-weight-semibold">{~D:Record.ObservationTypeDetails.Type~}</span>
					<span class="tag is-dark has-background-text-15 is-rounded" style="position: absolute; right: 1rem;">{~D:Record.ObservationList.length~}</span>
				</div>
				<div class="is-collapsible-content is-hidden" data-collapsible-content="{~D:Record.ObservationType~}">
					{~TS:HeadlightPanels-ObservationPanel-Included-List-Group-Item:Record.ObservationList~}
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item',
				Template: /*html*/`
				<div id="ObservationPanel-Row" class="panel-block is-block-flex is-align-items-left is-relative p-2 is-clickable" 
					onclick="_Pict.views.HeadlightPaneObservations.handleObservationImagePreviewClick(event, '{~D:Record.IDObservation~}', 'Included')" data-observation-id="{~D:Record.IDObservation~}">
					<a class="preview-image-wrapper" >
						<img class="preview-image" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" alt="Observation Preview for #{~D:Record.IDObservation~}" />
					</a>
					<div class="is-block-flex is-align-items-left mx-4" style="flex-grow: 1">
						<div class="is-size-7 has-text-text-75">
							{~TIfAbs:HeadlightPanels-ObservationPanel-Included-List-Group-Item-Locked:Record.Locked:Record.Locked^==^1~}
							{~TIfAbs:HeadlightPanels-ObservationPanel-Included-List-Group-Item-Unlocked:Record.Locked:Record.Locked^==^0~}
							<span>#{~D:Record.IDObservation~}</span>
						</div>
						<div>{~D:Record.Name~}</div>
						<div class="is-size-7 has-text-text-75">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</div>
						<div class="is-size-7 has-text-text-75"><i class="fa fa-fw fa-user"></i> {~Entity:User^Record.CreatingIDUser^HeadlightPanels-ObservationPanel-Included-List-Group-Item-User^~}</div>
					</div>
					<!-- TODO: convert this to a popover -->
					<div class="buttons mr-4" style="max-width: 100px;">
						<button type="button" data-panel-mode-show-if="add-to-set" title="Add observation to set" data-observation-id="{~D:Record.IDObservation~}" class="button is-ghost-icon has-text-success-75 p-0 mr-2"
							onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-set')">
							<span class="icon">
								<i class="fa fa-fw fa-circle-plus"></i>
							</span>
							<span class="add-to-set-link">Add to Set</span>
						</button>
						<button type="button" title="Remove observation from document" class="button is-ghost-icon has-text-text-85 p-0 mr-2" onclick="_Pict.views.ObservationIncluded.handleRemoveIncludedObservation(event, '{~D:Record.IDObservation~}', '{~D:Record.ObservationType~}')">
							<span class="icon">
								<i class="fa fa-fw fa-times-circle"></i>
							</span>
							<span data-panel-mode-show-if="add-to-set" style="white-space: normal;">Remove from Document</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-BannerTarget',
				Template: /*html*/`{~D:Pict.views.HeadlightPaneObservations.AddImageTargetDisplayName~}`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item-Locked',
				Template: /*html*/`
					<span class=" has-text-text-75" title="Locked">
						<i class="fas fa-fw fa-sm fa-lock"></i>
					</span>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item-Unlocked',
				Template: /*html*/`
					<span class="has-text-text-40" title="Unlocked">
						<i class="fas fa-fw fa-sm fa-unlock"></i>
					</span>`,
			},
		],
	Renderables:
		[

		],
};

},{"pict-view":693}],803:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialSearchResultsLoaded = false;

		this.DefaultSearchFilters = {
			Projects: [],
			ObservationTypes: [],
			StartDate: '',
			EndDate: '',
			SearchText: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'DesignatedTime',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		this.selectedObservation = {};
		this.ObservationTypeManifest = [];
		this.SearchPanelMode = '';
		this.setSelected = false;

		// TODO: We should hide any columns that have exactly one search filter criteria, as they are redundant
		// ex: if you search for "Legacy Image" only, don't show the ObservationType column, bc all results will be "Legacy Image"
	}

	async onBeforeRenderAsync(pCallback)
	{
		if (typeof pCallback == 'function')
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'ObservationSearch-Projects',
			ParentID: 'ObservationSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			width: 'element',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject, // && !this.initialSearchResultsLoaded, // NOTE: was causing weird bug: when re-opening panel the project dropdown filter was losing its value.
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// OBSERVATION TYPE Selector Filter
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark has-sticky-option',
			placeholder: 'Select an observation types...',
			ElementID: 'ObservationSearch-ObservationTypes',
			ParentID: 'ObservationSearch-SearchEntry',
			URL: 'ObservationManifests',
			IDField: 'Name',
			TextField: 'DisplayName',
			StickyOption: { id: 'Legacy Image', text: 'Image' },
		}, () =>
		{
			this.log.info('Select2 ObservationTypes initialized');
		});

		// START DATE date picker
		window.flatpickr('#ObservationSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'ObservationSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				/** @type {any} silence warnings about _flatpickr not being present */
				const siblingElement = document.getElementById('ObservationSearch-EndDate');
				siblingElement._flatpickr.config.minDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#ObservationSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'ObservationSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				/** @type {any} silence warnings about _flatpickr not being present */
				const siblingElement = document.getElementById('ObservationSearch-StartDate');
				siblingElement._flatpickr.config.maxDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		this.setCurrentSearchFilters();
		// if we don't have search results, perform a search
		if (!this.initialSearchResultsLoaded)
		{
			this.initialSearchResultsLoaded = true;
			this.handleObservationSearch();
		}

		if (pCallback) pCallback();
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Event} [event] - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleObservationSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#ObservationSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('ObservationSearch-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters', 'close');
		// perform the observation search
		await this.pict.providers.ObservationProvider.performObservationSearch(this.CurrentSearchFilters, (pSearchResults, pTotalSearchCount) =>
		{
			this.updateWithSearchResults(pSearchResults, pTotalSearchCount);
		});
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.ObservationSearch.handleObservationSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.ObservationSearch.handleObservationSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], ObservationTypes: ['Legacy Narrative'], SearchText: 'dog'})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('ObservationSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#ObservationSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-ObservationTypes', this.CurrentSearchFilters?.ObservationTypes);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-SearchText', this.CurrentSearchFilters?.SearchText || '');
			this.pict.ContentAssignment.assignContent('#ObservationSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.ObservationTypes && my.ObservationTypes.length > 0)
		{
			this.CurrentSearchFiltersCount += my.ObservationTypes.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setObservationSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setObservationSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.observationSearchResultsCallback = pCallback;
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Project');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#ObservationSearch-Projects');
			break;
		case 'ObservationType':
		case 'ObservationTypes':
			this.CurrentSearchFilters.ObservationTypes = this.pict.ContentAssignment.readContent('#ObservationSearch-ObservationTypes');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#ObservationSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#ObservationSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#ObservationSearch-SearchText');
			break;
		case 'SortBy':
			const tmpSortBy = this.pict.ContentAssignment.readContent('#ObservationSearch-SortBy');
			this.CurrentSearchFilters.SortBy = typeof tmpSortBy == 'string' ? tmpSortBy.split('_')[0] : 'DesignatedTime';
			this.CurrentSearchFilters.SortDirection = typeof tmpSortBy == 'string' ? tmpSortBy.split('_')[1] : 'DESC';
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalResultCount = pTotalSearchCount;
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Results', '#ObservationSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#ObservationSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Pagination', '#ObservationSearch-Pagination-Container', false, false, () =>
			{
				this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Pagination-State', '#ObservationSearch-Pagination-State-Container', false, false, () =>
				{
					this.log.info('Observation Search Pagination rendered');
				});
			});
			// if there is a callback function, call it
			if (this.observationSearchResultsCallback)
			{
				this.observationSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}

	/**
	 * This method handles the action popover for the observation search results.
	 * @param {Event} event - The event that triggered the popover.
	 * @param {string} pElementId - The ID of the element to attach the popover to.
	 * @param {number} pIDObservation - The ID of the observation.
	 */
	handleActionPopover(event, pElementId, pIDObservation)
	{
		// prevent the default action of the event
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		const isIncludedInForm = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		const tmpMenuElement = document.getElementById(pElementId);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${pElementId} not found for Observation search rults action popover.`);
			return;
		}
		// create the popover menu
		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'ObservationSearch-Reults-Extra-Row-ActionMenu',
			PopoverTemplateRecord:
			{
				IDObservation: pIDObservation,
				IncludedInForm: isIncludedInForm,
			},
			theme: 'dropdown-dark',
		});
	}

	/**
	 * This method sets the mode of the search panel.
	 * @param {string} pMode - The mode to set the search panel to.
	 * @return {void}
	 */
	setMode(pMode)
	{
		this.SearchPanelMode = pMode;
		if (pMode === 'add-to-set')
		{
			this.setSelected = true;
		}
		else
		{
			this.setSelected = false;
		}
		// render the search entry form with the new mode
		this.renderAsync(() =>
		{
			this.pict.log.info('Search panel mode set to: ' + pMode);
		});
	}
}

module.exports = ObservationSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSearch',
	DefaultRenderable: 'ObservationSearch-Entry',
	DefaultDestinationAddress: '#ObservationSearch-Entry-Container',
	CSS: /*css*/`
		.mode_add-to-set {
			display: none;
		}
		.hide-in-mode_add-to-folder {
			display: none;
		}
		.visible-mode_add-to-set .mode_add-to-set {
			display: block;
		}
		.mode_add-to-folder {
			display: none;
		}
		.visible-mode_add-to-folder .mode_add-to-folder {
			display: block;
		}
		.mode_add-to-root {
			display: none;
		}
		.visible-mode_add-to-root .mode_add-to-root {
			display: block;
		}`,
	Templates:
		[
			{
				Hash: 'ObservationSearch-Entry',
				Template: /*html*/`
				<div id="ObservationSearch-SearchEntry" class="container">
					<form autocomplete="off" role="observation-search" onsubmit="_Pict.views.ObservationSearch.handleObservationSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="ObservationSearchFilters">
							<div class="columns is-hidden">
								{~T:ObservationSearch-Entry-CurrentPage~}
								{~T:ObservationSearch-Entry-PageSize~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-ObservationTypeSelector~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-StartDate~}
								{~T:ObservationSearch-Entry-EndDate~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-SearchText~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="ObservationSearch-Pagination-Container" style="flex:auto"></div>
							<button class="button is-primary is-soft" type="button" data-collapsible-toggle="ObservationSearchFilters" title="Set filters" onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters')" id="ObservationSearch-ToggleButton">
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="ObservationSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:ObservationSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" id="ObservationSearch-ResetButton" title="Reset filters" onclick="_Pict.views.ObservationSearch.resetSearchFilters()"><i class="fas fa-fw fa-undo mr-1"></i> Clear Filters</button>
							<button class="button is-primary" type="submit" title="Search observations" id="ObservationSearch-SearchButton"><i class="fas fa-fw fa-search mr-1"></i> Search Observations</button>
							<div id="ObservationSearch-Pagination-State-Container"></div>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'ObservationSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="ObservationSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('CurrentPage')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-PageSize" class="block">Page Size</label>
						<input 
							id="ObservationSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('PageSize')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ObservationSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-Projects" 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('Projects')"
								multiple
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ObservationTypeSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ObservationSearch-ObservationTypes">Observation Types</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-ObservationTypes" 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('ObservationTypes')"
								multiple
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="ObservationSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="ObservationSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="DesignatedTime_DESC">Designated Time (Newest)</option>
								<option value="DesignatedTime_ASC">Designated Time (Oldest)</option>
								<option value="ObservationType_ASC">Observation Type (A-Z)</option>
								<option value="ObservationType_DESC">Observation Type (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ObservationSearch-SearchText" class="block">Text Search</label>
					<input 
						id="ObservationSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results',
				Template: /*html*/`
				<div id="ObservationSearch-Results-Container" class="container table-container">
					{~TIfAbs:ObservationSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:ObservationSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Designated Time</th>
							<th>Type</th>
							<th>Creating User</th>
							<th>Project</th>
							{~T:ObservationSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="ObservationSearch-ResultsEntries">
						{~TS:ObservationSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'ObservationSearch-Results-Row',
				Template: /*html*/`
				<tr onclick="_Pict.views.HeadlightPaneObservations.handleObservationImagePreviewClick(event, '{~D:Record.IDObservation~}', 'Search')" data-observation-id="{~D:Record.IDObservation~}">
					<td>{~DateFormat:Record.DesignatedTime^YYYY-MM-DD~}</td>
					<td>{~ObsTypeDisplay:Record.ObservationType~}</td>
					<td>{~Entity:User^Record.CreatingIDUser^ObservationSearch-Results-User^~}</td>
					<td>{~Entity:Project^Record.IDProject^ObservationSearch-Results-Project^~}</td>
					{~T:ObservationSearch-Results-Extra-Row:Record~}
				</tr>`,
			},
			{
				Hash: 'ObservationSearch-Results-Extra-Header',
				Template: /*html*/`
				<th>Thumbnail</th>
				<th>Actions</th>`,
			},
			{
				Hash: 'ObservationSearch-Results-Extra-Row',
				Template: /*html*/`
				<td>
					<a class="preview-image-wrapper" style="min-width:100px; min-height:100px">
						<img class="preview-image is-skeleton" height="128" width="128" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" 
							alt="Observation Preview for #{~D:Record.IDObservation~}" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />
					</a>
				</td>
				<td class="is-vcentered">
					<button
						id="PANEL-MENU-BUTTON-FOR-OBSERVATION-{~D:Record.IDObservation~}"
						class="button icon-button is-ghost has-text-primary-60 p-0 ml-3 is-size-5"
						style="float: none"
						title="Actions"
						type="button"
						aria-haspopup="true"
						onmouseover="_Pict.views.ObservationSearch.handleActionPopover(event, id, '{~D:Record.IDObservation~}')"
						onclick="_Pict.views.ObservationSearch.handleActionPopover(event, id, '{~D:Record.IDObservation~}')"
						data-observation-id="{~D:Record.IDObservation~}">
						<span class="icon is-small">
							<i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
						</span>
					</button>
				</td>`,
			},
			{
				Hash: 'ObservationSearch-Reults-Extra-Row-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ObservationSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_add-to-set">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-set');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-plus-circle"></i>
							</span>
							<span>Add to Set</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-folder">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-folder');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-file-plus"></i>
							</span>
							<span>Add File to Folder</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-root">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-root');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-file-plus"></i>
							</span>
							<span>Add File to Project Files</span>
						</a>
					</li>
					<li class="list-menu-item {~Hide:Record.IsObservationLinked~}{~Hide:Pict.views.ObservationSearch.setSelected~}">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-document');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-link"></i>
							</span>
							<span>Include in document</span>
						</a>
					</li>
					<li class="list-menu-item {~Show:Record.IsObservationLinked~}">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'remove-from-document');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-unlink"></i>
							</span>
							<span>Remove from document</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ObservationSearch-Pagination',
				Template: /*html*/`
				<nav id="ObservationSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="ObservationSearch-PreviousButton" type="button" title="Previous page" class="button is-soft mr-2" onclick="_Pict.views.ObservationSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="ObservationSearch-NextButton" type="button" title="Next page" class="button is-soft" onclick="_Pict.views.ObservationSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
			{
				Hash: 'ObservationSearch-Pagination-State',
				Template: /*html*/`
				<div id="ObservationSearch-Pagination-State" class="pagination-state" aria-label="pagination state">
					<p class="is-size-7 has-text-grey">Page {~D:Context[0].CurrentSearchFilters.CurrentPage~} of {~D:Context[0].CurrentSearchFilters.TotalPages~} ({~HumanCount:Context[0].CurrentSearchFilters.TotalResultCount^0~} total records)</p>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any observations based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ObservationSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'ObservationSearch-Entry',
				TemplateHash: 'ObservationSearch-Entry',
				DestinationAddress: '#ObservationSearch-Entry-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ProjectSelector',
				TemplateHash: 'ObservationSearch-Entry-ProjectSelector',
				DestinationAddress: '#ObservationSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ObservationTypeSelector',
				TemplateHash: 'ObservationSearch-Entry-ObservationTypeSelector',
				DestinationAddress: '#ObservationSearch-Entry-ObservationTypeSelector',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ActiveFilterCount',
				TemplateHash: 'ObservationSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#ObservationSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'ObservationSearch-Results',
				TemplateHash: 'ObservationSearch-Results',
				DestinationAddress: '#ObservationSearch-Results-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Pagination',
				TemplateHash: 'ObservationSearch-Pagination',
				DestinationAddress: '#ObservationSearch-Pagination-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Pagination-State',
				TemplateHash: 'ObservationSearch-Pagination-State',
				DestinationAddress: '#ObservationSearch-Pagination-State-Container',
			},
		],
};

},{"pict-view":693}],804:[function(require,module,exports){
/* eslint-disable new-cap */
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationSet extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.IncludedObservationSets = [];
		this.ActiveObservationSetID = null;
		this.ActiveObservationSet = null;
		this.ActiveObservationSetAddCallback = (pIDObservation, ActiveObservationSet)=>
		{
			if (this.pict.views?.['PictFormMetacontroller-DynamicInputs'])
			{
				this.pict.views['PictFormMetacontroller-DynamicInputs'].marshalToViewAsync(()=>
				{});
			}
		};
		this.ActiveObservationSetRemoveCallback = (pIDObservation, ActiveObservationSet)=>
		{
			if (this.pict.views?.['PictFormMetacontroller-DynamicInputs'])
			{
				this.pict.views['PictFormMetacontroller-DynamicInputs'].marshalToViewAsync(()=>
				{});
			}
		};
	}

	/**
	 * Get the active observation set from the provider
	 * @param {string} [pSetID] - The observation set id to get
	 * @return {Promise<boolean>} - Returns true if the active observation set is set
	 */
	async getActiveObservationSet(pSetID)
	{
		if (!this.ActiveObservationSetID)
		{
			this.pict.log.warn('ObservationSet.getActiveObservationSet: ActiveObservationSetID is not defined');
			return;
		}
		this.ActiveObservationSet = await this.pict.providers.ObservationSetProvider.loadSet(this.ActiveObservationSetID);
		return this.ActiveObservationSet;
	}

	/**
	 * Render the observation set view before the main render function is called
	 * @param {import('pict-view').ErrorCallback} pCallback - The callback to call after rendering
	 * @param {import('pict-view').Renderable} pRenderable - The renderable to use for rendering
	 * @return {void}
	 */
	onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.getActiveObservationSet().catch((err) =>
		{
			this.pict.log.error('ObservationSet.onBeforeRenderAsync: Error getting active observation set', err);
		}).finally(() =>
		{
			// set the intent for the sub image selector view
			if (this.pict.views?.ObservationSubImageSelector?.intent)
			{
				this.pict.views.ObservationSubImageSelector.intent =
				{
					type: 'ObservationSet',
					IDObservationSet: this.ActiveObservationSetID,
				};
			}
			super.onBeforeRenderAsync(pCallback, pRenderable);
		});
	}

	/**
	 * Handle the click event for the manage set button in the form selector addon - a button can use this to set the active observation set by passing the id
	 * @param {string} pValue - The observation set id to manage
	 * @param {Function} pCallback - The callback to call after setting the active observation set
	 * @return {Promise<void>}
	 */
	async handleFormManageSetButtonClick(pValue, pCallback)
	{
		// if we specifically want to create a new set, do that now
		if (!pValue)
		{
			this.pict.log.error('ObservationSet.handleFormManageSetButtonClick: pValue is required');
			return;
		}
		// set the active observation set to the selected set for rendering
		await this.setObservationSetID(pValue);
		// open the observation panel and switch to the sets tab
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Sets', 'Observation');
			this.setObservationPanelTarget();
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
	}

	/**
	 * Add an observation to the active observation set
	 * @param {string} pIDObservation - The observation id to add to the set
	 * @return {Promise<void>}
	 */
	async addObservationToSet(pIDObservation)
	{
		if (!this.ActiveObservationSet)
		{
			this.pict.log.warn('ObservationSet.addObservationToSet: ActiveObservationSet is not defined');
			return;
		}
		if (!pIDObservation)
		{
			this.pict.log.error('ObservationSet.addObservationToSet: pIDObservation is required');
			return;
		}
		// get the observation record from the passed id
		const tmpObservationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		// add the observation to the set
		await this.pict.providers.ObservationSetProvider.addObservation(this.ActiveObservationSet, tmpObservationRecord);
		// render the observation set view with the new data
		this.renderAsync('ObservationSet', () =>
		{
			this.pict.log.info('ObservationSet view rendered from addObservationToSet.');
		});
		// if we have a callback, call it
		if (this.ActiveObservationSetAddCallback)
		{
			await this.ActiveObservationSetAddCallback(pIDObservation, this.ActiveObservationSet);
		}
	}

	/**
	 * Handle the removal of an observation from the set via the x button
	 * @param {Event} event - The click event
	 * @param {string} pIDObservation - The observation id to remove from the set
	 * @return {Promise<void>}
	 * @async
	 */
	async handleRemoveObservationFromSet(event, pIDObservation)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		this.pict.log.info('ObservationSet.handleRemoveObservationFromSet: pIDObservation', pIDObservation);
		// find the observation in the set and pass it to the removal function in the provider
		const tmpRemovalObs = this.ActiveObservationSet.Observations.find((obs) => obs.IDObservation == pIDObservation);
		await this.pict.providers.ObservationSetProvider.removeObservation(this.ActiveObservationSet, tmpRemovalObs);
		// render the observation set view with the new data
		this.renderAsync('ObservationSet', () =>
		{
			this.pict.log.info('ObservationSet view rendered from addObservationToSet.');
		});
		// if we have a callback, call it
		if (this.ActiveObservationSetRemoveCallback)
		{
			this.ActiveObservationSetRemoveCallback(pIDObservation, this.ActiveObservationSet);
		}
	}

	/**
	 * Set the observation panel target to the active observation set and enable the "add" mode banner/logic
	 * @return {void}
	 */
	setObservationPanelTarget()
	{
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', 'add-to-set');
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-set';
		this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-set';
		// set the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = this.ActiveObservationSet.Name;
		this.pict.views.ObservationSearch.setMode('add-to-set');
	}

	/**
	 * Handle the click event for the add observation button in the observation set view panel - opens the observation panel to search
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handlePanelAddObservationButtonClick(pEvent)
	{
		// set the tab to the search results
		this.setObservationPanelTarget();
		this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
	}

	/**
	 * Handle the click event for the create media file button in the observation set view panel - opens the observation panel to upload
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handlePanelCreateObservationButtonClick(pEvent)
	{
		// add the loading class to the button
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// open the observation panel and switch to the create tab
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation');
			this.setObservationPanelTarget();
			// remove the loading class from the button
			if (pEvent && pEvent.currentTarget)
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			}
		});
	}

	/**
	 * TODO: Handle the click event for the important files button in the observation set view panel - ???
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handlePanelImportantFilesButtonClick(pEvent)
	{
		// add the loading class to the button
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// open the observation panel and switch to the create tab
		this.pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch', 'open', () =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
	}

	/**
	 * Set the active observation set id for the view
	 * @param {string} pIDObservationSetID - The observation set id to set as active
	 * @return {Promise<void>} - Returns the active observation set
	 */
	async setObservationSetID(pIDObservationSetID)
	{
		this.ActiveObservationSetID = pIDObservationSetID;
		await this.getActiveObservationSet();
	}

	/**
	 * Reset the observation set view to its default state
	 * @return {void}
	 */
	resetObservationSetView()
	{
		this.ActiveObservationSetID = null;
		this.ActiveObservationSet = null;
		this.ActiveObservationSetAddCallback = null;
		this.ActiveObservationSetRemoveCallback = null;
	}

	/**
	 * Handle the click event for the image preview in the observation set list
	 * @param {Event} pEvent - The click event
	 * @param {string} pIDObservation - The observation id to preview
	 * @return {void}
	 */
	handleImagePreviewClick(pEvent, pIDObservation)
	{
		// add the loading class to the image
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// show the observation detail view
		this.pict.log.info('ObservationSet.handleImagePreviewClick: pIDObservation', pIDObservation);
		this.pict.views.HeadlightPaneObservations.showObservationDetailView(pEvent, pIDObservation, null, () =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
	}

	showEditSetNameView()
	{
		this.pict.log.info('ObservationSet.showEditSetNameView: ActiveObservationSet', this.ActiveObservationSet);
		this.renderAsync('ObservationSet-Title-Edit', '#HeadlightPanels-ObservationSet-Title-Wrapper', () =>
		{
			this.pict.log.info('ObservationSet-Title-Edit view rendered.');
		});
	}

	async updateSetName(event)
	{
		// prevent the form from submitting (aka refreshing the page)
		event.preventDefault();
		event.stopPropagation();

		const tmpNewName = document.getElementById('ObservationSet-Edit-Title-Form').querySelector('input').value;
		this.pict.log.info('ObservationSet.updateSetName: tmpNewName', tmpNewName);
		this.ActiveObservationSet.Name = tmpNewName;
		await this.pict.providers.ObservationSetProvider.saveSet(this.ActiveObservationSet);
		this.renderAsync('ObservationSet', '#ObservationSet-ActiveSet-Container', () =>
		{
			this.pict.log.info('ObservationSet view rendered from updateSetName.');
		});
	}

	async updateDisplayedObservationSet(event, observationSet)
	{
		await this.setObservationSetID(observationSet);
		if (event.isDefaultPrevented())
		{
			return;
		}
		this.renderAsync();
	}

	async onAfterRenderAsync(pCallback)
	{
		// OBSERVATION TYPE Selector Filter
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark has-sticky-option',
			ElementID: 'ObservationSets-IncludedList',
			ParentID: 'HeadlightPanels-ObservationSet-Selector-Container',
			URL: 'ObservationManifests',
			IDField: 'Name',
			TextField: 'DisplayName',
			useAjax: false,
		}, () =>
		{
			console.log('ObservationSet Select2 Initialized.');
		});
		pCallback();
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 */
	async initializeSelect2Plugin(pOptions, pCallback)
	{
		const select2Config = {
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
		};

		if (pOptions.useAjax)
		{
			select2Config.ajax = {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${this.pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = this.pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: this.pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === this.pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === this.pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			};
		}
		else
		{
			const IDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			const data = await this.pict.providers.ObservationSetProvider.getObservationSetsForDocument(IDDocument);
			select2Config.data = this.pict.providers.UtilityProvider.formatSelect2Results(data, 'IDObservationSet', 'Name');
		}

		$('#' + pOptions.ElementID).select2(select2Config);

		if (this.ActiveObservationSetID)
		{
			$('#' + pOptions.ElementID).val(this.ActiveObservationSetID);
			const event = $.Event('change');
			event.preventDefault();
			$('#' + pOptions.ElementID).trigger(event);
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}
}

module.exports = ObservationSet;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSet',
	DefaultRenderable: 'ObservationSet',
	DefaultDestinationAddress: '#ObservationSet-ActiveSet-Container',
	Templates:
		[
			{
				Hash: 'ObservationSet',
				Template: /*html*/`
				{~TIfAbs:ObservationSet-ActiveSet:Context[0]:Context[0].ActiveObservationSetID^>^0~}
				{~TIfAbs:ObservationSet-Unset:Context[0]:Context[0].ActiveObservationSetID^<=^0~}`,
			},
			{
				Hash: 'ObservationSet-Unset',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Unset-Message" class="notification has-text-text-light is-dark m-3">
					<p class="has-text-centered">No active observation set.</p>
				</div>`,
			},
			{
				Hash: 'ObservationSet-ActiveSet',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Title-Wrapper" class="p-4 mb-0 has-background-text-15">
					{~T:ObservationSet-Title-Display~}
				</div>
				{~T:ObservationSet-Selector~}
				{~TIfAbs:ObservationSet-List:Context[0].ActiveObservationSet.Observations:Context[0].ActiveObservationSet.Observations.length^>^0~}
				{~TIfAbs:ObservationSet-Empty:Context[0].ActiveObservationSet.Observations:Context[0].ActiveObservationSet.Observations.length^<=^0~}
				<div class="buttons is-right m-4">
					<button type="button" class="button is-primary" title="Add Observation" onclick="_Pict.views.ObservationSet.handlePanelAddObservationButtonClick(event)">
						<span class="icon">
							<i class="fas fa-plus"></i>
						</span>
						<span class="icon-text">Add Observation</span>
					</button>
					<button type="button" class="button is-primary" title="Add Observation" onclick="_Pict.views.ObservationSet.handlePanelCreateObservationButtonClick(event)">
						<span class="icon">
							<i class="fas fa-upload"></i>
						</span>
						<span class="icon-text">Create New Observation</span>
					</button>
					<button type="button" class="button is-primary" title="Add Important File" onclick="_Pict.views.ObservationSet.handlePanelImportantFilesButtonClick(event)">
						<span class="icon">
							<i class="fas fa-file"></i>
						</span>
						<span class="icon-text">Include Project File</span>
					</button>
				</div>`,
			},
			{
				Hash: 'ObservationSet-List',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSetPanel-List">
					{~TS:ObservationSet-List-Item:Record.Observations~}
				</div>`,
			},
			{
				Hash: 'ObservationSet-List-Item',
				Template: /*html*/`
				<div class="panel-block is-block-flex is-align-items-left is-relative p-2 is-clickable" onclick="_Pict.views.ObservationSet.handleImagePreviewClick(event, '{~D:Record.IDObservation~}')" data-observation-id="{~D:Record.IDObservation~}">
					<a class="preview-image-wrapper">
						<img class="preview-image" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" alt="Observation Preview for #{~D:Record.IDObservation~}" />
					</a>
					<div class="is-block-flex is-align-items-left mx-4" style="flex-grow: 1">
						<div class="is-size-7 has-text-text-75">#{~D:Record.IDObservation~}</div>
						<div>{~D:Record.Name~}</div>
						<div class="is-size-7 has-text-text-75">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</div>
						<div class="is-size-7 has-text-text-75"><i class="fa fa-fw fa-user"></i> {~Entity:User^Record.CreatingIDUser^ObservationSet-List-Item-User^~}</div>
					</div>
					<div class="buttons mr-4">
						<button type="button" title="Remove observation from document" class="button is-ghost has-text-text-85 p-0 ml-3" onclick="_Pict.views.ObservationSet.handleRemoveObservationFromSet(event, '{~D:Record.IDObservation~}')">
							<span class="icon">
								<i class="fa fa-fw fa-times-circle"></i>	
							</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSet-Title-Display',
				Template: /*html*/`
				<h1 class="title is-5 has-text-text-90">
					{~D:Context[0].ActiveObservationSet.Name~}
					<a class="ml-1 has-text-link-75" title="Edit Set Name" onclick="_Pict.views.ObservationSet.showEditSetNameView()">
						<span class="icon">
							<i class="fas fa-edit"></i>
						</span>
					</a>
				</h1>`,
			},
			{
				Hash: 'ObservationSet-Title-Edit',
				Template: /*html*/`
				<form id="ObservationSet-Edit-Title-Form" onsubmit="_Pict.views.ObservationSet.updateSetName(event)">
					<div class="field has-addons has-addons-right">
						<div class="control is-expanded">
							<input class="input" type="text" placeholder="Observation Set Name" value="{~D:Context[0].ActiveObservationSet.Name~}">
						</div>
						<div class="control">
							<button id="ObservationSet-Edit-Title-Save-Button" title="Save title" type="submit" class="button is-primary">
								Save
							</button>
						</div>
					</div>
				</form>`,
			},
			{
				Hash: 'ObservationSet-List-Item-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ObservationSet-Empty',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="has-text-centered">No observations found in this set.</p>
				</div>`,
			},
			{
				Hash: 'ObservationSet-Selector',
				Template: /*html*/`
				<div class="columns p-4">
					<div class="column" id="HeadlightPanels-ObservationSet-Selector-Container">
						<div class="field">
							<label class="label block" for="ObservationSets-IncludedList">Document Included Observation Sets</label>
							<div class="control select is-fullwidth">
								<select 
									id="ObservationSets-IncludedList" 
									onchange="_Pict.views.ObservationSet.updateDisplayedObservationSet(event, this.value)">
								></select>
							</div>
						</div>
					</div>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'ObservationSet',
				TemplateHash: 'ObservationSet',
				DestinationAddress: '#ObservationSet-ActiveSet-Container',
				RenderType: 'replace',
			},
			{
				RenderableHash: 'ObservationSet-Title-Display',
				TemplateHash: 'ObservationSet-Title-Display',
				DestinationAddress: '#HeadlightPanels-ObservationSet-Title-Wrapper',
				RenderType: 'replace',
			},
			{
				RenderableHash: 'ObservationSet-Title-Edit',
				TemplateHash: 'ObservationSet-Title-Edit',
				DestinationAddress: '#HeadlightPanels-ObservationSet-Title-Wrapper',
				RenderType: 'replace',
			},
			{
				RenderableHash: 'ObservationSet-Selector',
				TemplateHash: 'ObservationSet-Selector',
				DestinationAddress: '#HeadlightPanels-ObservationSet-Selector-Container',
				RenderType: 'replace',
			},
		],
};

},{"pict-view":693}],805:[function(require,module,exports){
const libPictSectionForm = require(`pict-section-form`);
//const PictViewClass = require('pict-view');


const defaultViewConfiguration = (
	{
		ViewIdentifier: 'Pict-Form-Solver',
		DefaultRenderable: 'HL-Pict-Form-Solver-Renderable',
		DefaultDestinationAddress: '#Pict-Form-Solver-In-Panel-Wrapper',
		RenderOnLoad: false,
		CSS: /*css*/`
            #Pict-Form-Solver-Content {
                color: var(--panels-content-block-text-color);
            }
            /* ── Filter bar ──────────────────────────────────────────
               Sticky search input above the solver entries. Sticky so
               the user keeps the filter affordance in view while
               scrolling through long log lists. The clear (×) button
               and the "no matches" banner are toggled in JS via the
               .is-active class set on their parents. */
            .PSFS-Filter-Bar {
                position: sticky;
                top: 0;
                z-index: 5;
                display: flex;
                align-items: center;
                gap: 0.55rem;
                padding: 0.5rem 0.65rem;
                background-color: var(--bulma-black-bis);
                border-bottom: 1px solid var(--panels-content-block-divider-color);
            }
            /* The Solve button shares the bar with the filter input — pin
               its size so it doesn't shrink when the panel narrows, and
               keep a clear visual gap so the action button doesn't read
               as part of the filter affordance to its right. */
            .PSFS-Filter-Solve {
                flex: 0 0 auto;
            }
            .PSFS-Filter-Bar .control {
                flex: 1 1 auto;
                position: relative;
            }
            /* Match counter on the right of the filter bar. Always
               visible so the user gets a feel for total log volume
               even before they start typing. The leading filter icon
               anchors the column visually; tabular-nums keeps digits
               aligned as the count ticks down character-by-character. */
            .PSFS-Filter-Counter {
                flex: 0 0 auto;
                display: inline-flex;
                align-items: center;
                gap: 0.35rem;
                font-size: 0.72rem;
                color: var(--bulma-text-60);
                font-variant-numeric: tabular-nums;
                white-space: nowrap;
                letter-spacing: 0.02em;
            }
            .PSFS-Filter-Counter .icon {
                font-size: 0.75rem;
                color: inherit;
            }
            .PSFS-Filter-Bar.is-active .PSFS-Filter-Counter {
                color: var(--bulma-warning);
            }
            /* In-place highlighting of matched substrings, à la browser
               Find. The mark element is wrapped around each token hit
               in visible entries by _applyHighlightsTo(). Warning-yellow
               background reads as "active filter highlight" without
               competing with the existing severity-* tones used by
               custom log entries. */
            .PSFS-Filter-Highlight {
                background-color: var(--bulma-warning);
                color: var(--bulma-black);
                padding: 0 0.1rem;
                border-radius: 0.15rem;
                font-weight: 600;
                /* Pict's solver-entry rule uses !important on color to
                   override Pict defaults — we inherit-and-override here
                   so highlights stay visible inside the warning-tinted
                   .PSFExt-Solver-Entry expression band, monospace token
                   chips, and severity-tinted custom log rows alike. */
                box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
            }
            .PSFS-Filter-Input {
                width: 100%;
                padding: 0.4rem 2rem 0.4rem 2rem;
                background-color: var(--panels-input-background-color) !important;
                color: var(--panels-input-text-color) !important;
                border: 1px solid var(--panels-input-border-color) !important;
                border-radius: 0.25rem;
                font-size: 0.85rem;
                line-height: 1.3;
            }
            .PSFS-Filter-Input:focus {
                outline: none;
                border-color: var(--bulma-warning) !important;
                box-shadow: 0 0 0 2px rgba(255, 184, 0, 0.18);
            }
            .PSFS-Filter-Icon {
                position: absolute;
                left: 0.55rem;
                top: 50%;
                transform: translateY(-50%);
                color: var(--bulma-text-60);
                font-size: 0.8rem;
                pointer-events: none;
            }
            .PSFS-Filter-Clear {
                position: absolute;
                right: 0.3rem;
                top: 50%;
                transform: translateY(-50%);
                color: var(--bulma-text-60);
                background: transparent;
                border: 0;
                padding: 0.2rem 0.35rem;
                cursor: pointer;
                border-radius: 0.2rem;
                display: none;
                font-size: 0.8rem;
                line-height: 1;
            }
            .PSFS-Filter-Clear:hover {
                color: var(--bulma-text-95);
                background: rgba(255, 255, 255, 0.06);
            }
            .PSFS-Filter-Bar.is-active .PSFS-Filter-Clear {
                display: inline-flex;
                align-items: center;
            }
            /* Hide-by-filter rule. Used in addition to (not instead of)
               Bulma's .is-hidden so we don't fight collapsible-section
               state — the filter and the user's manual collapse remain
               independently controllable. */
            .PSFS-Filter-Hidden {
                display: none !important;
            }
            .PSFS-Filter-Empty {
                padding: 1.5rem 1rem;
                text-align: center;
                color: var(--bulma-text-60);
                font-size: 0.85rem;
                display: none;
            }
            .PSFS-Filter-Empty.is-active {
                display: block;
            }
            /* Override Bulma's .panel.is-warning tinting on the panel body
               so the Solver pane matches the dark Validations panel. The
               gold .panel-heading is preserved because Bulma themes that
               independently via the heading-specific rule. */
            #HeadlightPanels-SolverPanel-Content {
                background-color: var(--panels-background-color) !important;
            }

            /* ── Standard solver entries (Pict-rendered solver list) ───
               One .PSFExt-Section per solver expression. The caps dark
               header band sits on top with an 8px warning-yellow leading
               border; content rows beneath get an 8px black-ter leading
               border so the eye reads "yellow = parent, gray = children".
               Sections stack flush.
               Pict's support base also ships defaults that paint things
               light (.PSFExt-Section-ExtraData → #fafafa, .PSFExt-Solver-Entry
               → 1px dotted #ccc bottom border, etc) at the same selector
               specificity as our rules, so most overrides need !important
               to win the load-order tiebreak. */
            .PSFExt-Section {
                background-color: transparent !important;
                margin: 0 !important;
                padding: 0 !important;
                border-radius: 0 !important;
            }
            .PSFExt-Section-ExtraData {
                background-color: transparent !important;
                margin: 0 !important;
                padding: 0 !important;
            }
            .PSFExt-Section-Header {
                display: flex;
                align-items: center;
                gap: 0.4rem;
                padding: 0.5rem 0.65rem 0.5rem 0.25rem !important;
                margin: 0 !important;
                background-color: var(--bulma-grey-darker) !important;
                color: var(--bulma-text-95);
                font-size: 0.75rem !important;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                border-left: 8px solid var(--bulma-warning);
            }
            .PSFExt-Section-Header span.PSFExt-DeEmphasize {
                color: var(--bulma-text-65) !important;
                font-weight: 500;
                margin-left: 0.25rem;
                margin-right: 0.25rem;
            }
            /* Section header layout — meta on the left, actions hard-right —
               is handled by Bulma flex utility classes (.is-flex,
               .is-flex-grow-1, .ml-auto) directly on the markup. The
               Edit / More chips use Bulma's .button.is-small.is-dark so
               their look + hover comes from the framework. */

            /* ── Expression display (read-only) ────────────────────────
               This is the always-visible <p class="PSFExt-Solver-Entry">
               that shows the formula. Pict's default theme paints the
               text magenta; we override to a softer dark overlay that
               reads as a code block while still feeling part of the
               panel's gray-tone palette (rather than a stark black band
               against the panel bg). */
            .PSFExt-Solver-Entry {
                word-wrap: break-word;
                margin: 0 !important;
                padding: 0.5rem 0.75rem 0.5rem 0.75rem !important;
                color: var(--bulma-warning-85) !important;
                background-color: rgba(0, 0, 0, 0.25) !important;
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.8rem;
                line-height: 1.5;
                border-bottom: none !important;
                border-left: 8px solid var(--bulma-black-ter) !important;
            }

            /* The expression editor textarea (shown after clicking Edit)
               picks up the panel's input theme so it feels native to the
               surrounding form fields. Pict's default sets a 100%-20px
               width and 80px min-height — overridden so the editor sits
               flush inside our row layout. */
            .PSFExt-ExpressionEditbox {
                width: 100% !important;
                min-height: 60px !important;
                padding: 0.5rem !important;
                background-color: var(--panels-input-background-color) !important;
                color: var(--panels-input-text-color) !important;
                border: 1px solid var(--panels-input-border-color) !important;
                border-radius: 0.25rem;
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.8rem;
                line-height: 1.5;
            }

            /* Small inline "Value:" / "Tokens:" rows under the expression.
               Pict's default sets margin-left, line-height: 0.85, and
               font-size: smaller — all overridden here so rows breathe. */
            .PSFExt-Section .PSFExt-Data {
                margin: 0 !important;
                padding: 0.35rem 0.65rem 0.35rem 0.75rem !important;
                font-size: 0.8rem !important;
                line-height: 1.5 !important;
                color: var(--panels-content-block-text-color);
                border-left: 8px solid var(--bulma-black-ter) !important;
            }
            /* Alternating row tint — slightly lighter wash on every other
               .PSFExt-Data row, matching the custom-logs alternating
               pattern. :nth-of-type counts among <p> siblings, so h5
               group dividers ("Postfix Tokens", "Virtual Symbols") don't
               break the alternation but the visual still feels banded. */
            .PSFExt-Section-ExtraData .PSFExt-Data:nth-of-type(even) {
                background-color: rgba(255, 255, 255, 0.04);
            }
            .PSFExt-Section .PSFExt-Label {
                color: var(--bulma-text-60);
                font-size: 0.7rem;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                margin-right: 0.25rem;
            }

            /* ── Sub-section group headers ─────────────────────────────
               "Postfix Tokens" / "Virtual Symbols" / "Postfix Solve List"
               and the per-entry "Postfix Solve Entry #N Symbol …" bands.
               Sit one tier below the main section header in the visual
               hierarchy: still a caps band, but smaller and on a darker
               surface so the parent → children relationship reads.
               Pict ships defaults that paint these light (#ebebff /
               #fafafa); !important overrides keep the dark caps band. */
            .PSFExt-Content-Header {
                font-weight: 600;
                margin: 0 !important;
                padding: 0.35rem 0.65rem 0.35rem 0.75rem !important;
                background-color: var(--bulma-black-ter) !important;
                color: var(--bulma-text-85);
                text-transform: uppercase;
                letter-spacing: 0.05em;
                font-size: 0.7rem;
                border-left: 8px solid var(--bulma-black-ter) !important;
            }
            .PSFExt-Content-Header.PSFExt-Section-Group-Header {
                font-size: 0.75rem !important;
            }
            .PSFExt-Content-Header.PSFExt-Data-Header {
                background-color: rgba(255, 255, 255, 0.04) !important;
                color: var(--bulma-text-75);
            }

            /* ── Data tables (postfix solve entry breakdowns) ──────────
               Caps headers, dark theme borders, monospace cells where
               appropriate via the Token chip styling on contained spans. */
            .PSFExt-Data-Table {
                margin: 0.25rem 0.5rem;
            }
            .PSFExt-Data-Table th {
                font-weight: 600;
                font-size: 0.7rem;
                padding: 0.4rem 0.5rem;
                color: var(--bulma-text-95);
                background-color: var(--bulma-grey-darker);
                text-transform: uppercase;
                letter-spacing: 0.05em;
                text-align: left;
                border-bottom: 1px solid var(--panels-content-block-divider-color);
            }
            .PSFExt-Data-Table td {
                word-wrap: break-word;
                padding: 0.35rem 0.5rem;
                font-size: 0.8rem;
                border: 1px solid var(--panels-content-block-divider-color);
                color: var(--panels-content-block-text-color);
            }
            .PSFExt-Data-Table td.cell-header {
                font-weight: 600;
                font-size: 0.7rem;
                color: var(--bulma-text-60);
                background-color: var(--panels-content-block-hover-background-color);
                text-transform: uppercase;
                letter-spacing: 0.05em;
            }

            /* ── Custom Solver Log styles ──────────────────────────────
               Section header / badge / collapse styling lives in
               panels-logs.scss (.hl-log-section, .hl-log-section-header,
               .hl-log-section-body) — shared with the Validations pane.
               Below are just the bits unique to the Custom Solver Logs:
               the wrapper banner, entry/calc rows, severity tags, and
               the variable-chip / numeric-formula display used inside
               calc rows. */
            .PSFS-CustomLog-Header {
                font-weight: bold;
                font-size: 1.1rem;
                padding: 0.5rem;
                color: var(--bulma-text-95);
                background-color: var(--bulma-black-ter);
                margin: 0;
            }
            .PSFS-CustomLog-Header .icon {
                color: var(--bulma-warning);
                margin-left: 0.5rem;
            }
            .PSFS-CustomLog-Entry {
                padding: 0.35rem 0.5rem 0.35rem 0.75rem;
                font-size: 0.85rem;
                border-left: 8px solid var(--bulma-black-ter);
                color: var(--panels-content-block-text-color);
            }
            .PSFS-CustomLog-Entry-Severity {
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.7rem;
                padding: 0.05rem 0.3rem;
                border-radius: 0.2rem;
                margin-right: 0.35rem;
            }
            .PSFS-CustomLog-Entry-Severity.severity-error {
                background-color: var(--bulma-danger-dark);
                color: var(--bulma-danger-light);
            }
            .PSFS-CustomLog-Entry-Severity.severity-warning {
                background-color: var(--bulma-warning-dark);
                color: var(--bulma-warning-light);
            }
            .PSFS-CustomLog-Entry-Severity.severity-info {
                background-color: var(--bulma-info-dark);
                color: var(--bulma-info-light);
            }
            .PSFS-CustomLog-Entry-Severity.severity-trace {
                background-color: var(--panels-content-block-hover-background-color);
                color: var(--bulma-text-60);
            }
            .PSFS-CustomLog-Calc {
                padding: 0.35rem 0.5rem 0.35rem 0.75rem;
                font-size: 0.85rem;
                border-left: 8px solid var(--bulma-black-ter);
                color: var(--panels-content-block-text-color);
            }
            .PSFS-CustomLog-Calc-Result {
                font-weight: 700;
                color: var(--bulma-info-light);
            }
            .PSFS-CustomLog-Calc-Formula {
                font-size: 0.8rem;
                color: var(--bulma-text-60);
                margin-top: 0.2rem;
                line-height: 1.6;
            }
            /* Inline pill — used for formula variable references in custom
               log calculations AND Pict's postfix-token names. Subtle
               blue tint so chips stay readable on the dark panel without
               the loud saturated tone we had before. !important on
               bg/color is needed for .PSFExt-Token to override Pict's
               default lime-green token color. */
            .PSFS-CustomLog-Chip,
            .PSFExt-Token {
                display: inline-block;
                padding: 0.1rem 0.4rem;
                background: rgba(78, 154, 220, 0.15) !important;
                color: #7db8e8 !important;
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.75rem;
                border: 1px solid rgba(78, 154, 220, 0.25);
                border-radius: 0.25rem;
                vertical-align: baseline;
            }
            .PSFS-CustomLog-Chip-Op {
                display: inline-block;
                font-size: 0.75rem;
                color: var(--bulma-text-65);
                padding: 0 0.2rem;
                vertical-align: baseline;
            }
            .PSFS-CustomLog-Calc-NumericFormula {
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.75rem;
                color: var(--bulma-text-65);
                margin-top: 0.1rem;
            }
        `,
		Templates: [
			{
				Hash: 'HL-Pict-Form-Solver-Content',
				Template: /*html*/`
<div id="Pict-Form-Solver-Content">
    <div id="PSFS-Filter-Bar" class="PSFS-Filter-Bar">
        <button type="button" class="button is-small is-primary PSFS-Filter-Solve"
            title="Re-run the solver"
            onclick="{~P~}.views.PictFormMetacontroller.solve(); {~P~}.views.PictFormMetacontroller.marshalFormSections(); {~P~}.views['{~D:Context[0].Hash~}'].render();">
            <span class="icon is-small"><i class="fas fa-fw fa-calculator" aria-hidden="true"></i></span>
            <span>Solve</span>
        </button>
        <div class="control">
            <span class="PSFS-Filter-Icon icon"><i class="fas fa-fw fa-magnifying-glass" aria-hidden="true"></i></span>
            <input id="PSFS-Filter-Input" type="text" class="PSFS-Filter-Input"
                placeholder="Filter logs..."
                aria-label="Filter solver logs"
                value="{~D:Context[0].FilterQuery~}"
                oninput="{~P~}.views.PictFormsSolver.applyFilter(this.value)" />
            <button type="button" class="PSFS-Filter-Clear" title="Clear filter"
                onclick="{~P~}.views.PictFormsSolver.clearFilter()">
                <span class="icon is-small"><i class="fas fa-fw fa-xmark" aria-hidden="true"></i></span>
            </button>
        </div>
        <span id="PSFS-Filter-Counter" class="PSFS-Filter-Counter" aria-live="polite">
            <span class="icon"><i class="fas fa-fw fa-filter" aria-hidden="true"></i></span>
            <span id="PSFS-Filter-Counter-Text"></span>
        </span>
    </div>
    {~TS:HL-Pict-Form-Solver-Entries:Context[0].getDynamicState().Solvers~}
    {~TS:HL-Pict-Form-Solver-CustomLogWrap:Context[0].CustomLogSectionsSorted~}
    <div id="PSFS-Filter-Empty" class="PSFS-Filter-Empty">No logs match your filter.</div>
</div>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-Entries',
				Template: /*html*/`
    <div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
        <h3 class="PSFExt-Section-Header">
            <span class="is-flex is-align-items-center is-flex-grow-1">
                <span class="PSFExt-DeEmphasize">{~D:Record.ExpressionScope~}</span> {~D:Record.SectionOrdinal~}.G.{~D:Record.GroupOrdinal~}
                <span class="PSFExt-DeEmphasize">Ord</span>{~D:Record.Ordinal~}
                <span class="PSFExt-DeEmphasize">Ind</span>{~D:Record.Index~}
            </span>
            <span class="is-flex is-align-items-center ml-auto">
                <a class="button is-small is-dark mr-1" href="javascript:void(0);"
                    onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">
                    <span class="icon is-small"><i class="fas fa-fw fa-pencil" aria-hidden="true"></i></span>
                    <span>Edit</span>
                </a>
                <a class="button is-small is-dark" href="javascript:void(0);"
                    onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer', 'PSFExt-Hidden');">
                    <span class="icon is-small"><i class="fas fa-fw fa-circle-info" aria-hidden="true"></i></span>
                    <span>More</span>
                </a>
            </span>
        </h3>
        
        <div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer" class="PSFExt-Hidden">
            <p class="PSFExt-Data">
                <textarea id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox" class="PSFExt-ExpressionEditbox">{~D:Record.Expression~}</textarea>
            </p>
            <div class="buttons is-right p-2 m-0">
                <button type="button" class="button is-small is-primary"
                    onclick="
                        {~P~}.views['{~D:Context[0].Hash~}'].updateExpressionFromElement(
                            '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox',
                            '{~D:Record.ExpressionScope~}', '{~D:Record.ViewHash~}', {~D:Record.SectionOrdinal~}, {~D:Record.Index~},
                            '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display'
                        );
                        {~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');
                    ">
                    <span class="icon is-small"><i class="fas fa-fw fa-check" aria-hidden="true"></i></span>
                    <span>Apply</span>
                </button>
            </div>
        </div>
        <div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Extra" class="PSFExt-Section-ExtraData">
            <p class="PSFExt-Solver-Entry" id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display">{~D:Record.Expression~}</p>
            <p class="PSFExt-Data">
                <span class="PSFExt-Label">Value</span> {~TBT:Record.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record:HL-Pict-Form-RecordValueDisplaySimple~}
            </p>
        </div>
        <div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer" class="PSFExt-Section-ExtraData PSFExt-Hidden">
            <h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Tokens</h5>
            {~TS:HL-Pict-Form-Solver-PostfixToken:Record.LastResultsObject.PostfixTokenObjects~}
            <h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">Virtual Symbols</h5>
            {~TVS:HL-Pict-Form-Solver-VirtualSymbols:Record.LastResultsObject.VirtualSymbols~}
            <h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Solve List</h5>
            {~TVS:HL-Pict-Form-Solver-PostFixSolveEntry:Record.LastResultsObject.PostfixSolveList~}
        </div>
    </div>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-PostfixToken',
				Template: /*html*/`
            <p class="PSFExt-Data">
                <span class="PSFExt-Label">{~D:Record.Type~}</span> <span class="PSFExt-Token">{~D:Record.Token~}</span>
            </p>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-VirtualSymbols',
				Template: /*html*/`
            <p class="PSFExt-Data">
                <span class="PSFExt-Label">{~D:Record.Key~}</span> {~TBT:Record.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record:HL-Pict-Form-RecordValueDisplaySimple~}
            </p>
`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplayComplex',
				Template: /*html*/`
            <!-- Complex Value -->
            {~TBT:Record.Value:array:HL-Pict-Form-RecordValueDisplayArray:Record:HL-Pict-Form-RecordValueDisplayObject~}
`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplayObject',
				Template: /*html*/`JSON Object
            <!-- RAW Object
{~DJ:Record.Value~}
            -->`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplayArray',
				Template: /*html*/`JSON Array ({~D:Record.Value.length~} items)
            <!-- RAW Array
{~DJ:Record.Value~}
            -->`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplaySimple',
				Template: /*html*/`{~D:Record.Value~}`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-PostFixSolveEntry',
				Template: /*html*/`
            <div>
                <h6 class="PSFExt-Content-Header PSFExt-Data-Header">Postfix Solve Entry #{~D:Record.Key~} Symbol <span class="PSFExt-Token">{~D:Record.Value.VirtualSymbolName~}</span></h6>
                <table class="PSFExt-Data-Table" style="width: 98%;">
                    <thead>
                        <tr>
                            <th width="15%">&nbsp;</th>
                            <th width="30%">Left</th>
                            <th width="25%">Operation</th>
                            <th width="30%">Right</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="cell-header">Virtual Symbol</td>
                            <td> {~D:Record.Value.LeftValue.VirtualSymbolName~} </td>
                            <td> {~D:Record.Value.Operation.VirtualSymbolName~} </td>
                            <td> {~D:Record.Value.RightValue.VirtualSymbolName~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Value</td>
                            <td> {~TBT:Record.Value.LeftValue.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record.Value.LeftValue:HL-Pict-Form-RecordValueDisplaySimple~} </td>
                            <td>&nbsp;</td>
                            <td> {~TBT:Record.Value.RightValue.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record.Value.RightValue:HL-Pict-Form-RecordValueDisplaySimple~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Tokens</td>
                            <td> {~D:Record.Value.LeftValue.Token~} </td>
                            <td> {~D:Record.Value.Operation.Token~} </td>
                            <td> {~D:Record.Value.RightValue.Token~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Type</td>
                            <td> {~D:Record.Value.LeftValue.Type~} </td>
                            <td> {~D:Record.Value.Operation.Type~} </td>
                            <td> {~D:Record.Value.RightValue.Type~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Solve Layer</td>
                            <td> {~D:Record.Value.LeftValue.SolveLayerStack~} </td>
                            <td>&nbsp;</td>
                            <td> {~D:Record.Value.RightValue.SolveLayerStack~} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
`,
			},
			// ── Custom Solver Log templates ──────────────────────────────
			{
				Hash: 'HL-Pict-Form-Solver-CustomLogWrap',
				Template: /*html*/`
    <div class="PSFS-CustomLog-Header">
        <span class="icon"><i class="fas fa-fw fa-scroll" aria-hidden="true"></i></span>
        Custom Solver Logs
    </div>
    {~TS:HL-Pict-Form-Solver-CustomLogSection:Record.Sections~}
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-CustomLogSection',
				Template: /*html*/`
    <div class="hl-log-section">
        <div class="hl-log-section-header"
             onclick="{~P~}.views.PictFormsSolver.toggleCustomLogSection('{~D:Record.Key~}')">
            <span class="hl-log-section-icon icon">
                <i class="fas fa-fw fa-list-ol" aria-hidden="true"></i>
            </span>
            <span class="hl-log-section-name">{~D:Record.Name~}</span>
            <span class="hl-log-section-badge">{~D:Record.Entries.length~}</span>
            <span class="hl-log-section-chevron icon">
                <i class="fas fa-fw {~D:Record.ChevronIconClass~}" data-custom-log-chevron="{~D:Record.Key~}" aria-hidden="true"></i>
            </span>
        </div>
        <div data-custom-log-section="{~D:Record.Key~}" class="hl-log-section-body {~D:Record.HiddenClass~}">
            {~TS:HL-Pict-Form-Solver-CustomLogEntry:Record.Entries~}
        </div>
    </div>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-CustomLogEntry',
				Template: /*html*/`{~D:Record.Html~}`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'HL-Pict-Form-Solver-Renderable',
				TemplateHash: 'HL-Pict-Form-Solver-Content',
			},
		],
	});

/**
 * @typedef {Object} CustomLogEntry
 * @property {string} Type       - 'Entry' or 'Calculation'
 * @property {string} Category   - Section key used for grouping
 * @property {string} Label      - Display label (section display name)
 * @property {string} Message    - Human-readable message / description
 * @property {string} Severity   - 'Trace' | 'Info' | 'Warning' | 'Error'
 * @property {string=} Result    - Calculated value (Calculation entries only)
 * @property {string=} Formula   - Expression string (Calculation entries only)
 * @property {string=} FormulaDescription - Variable explanation (Calculation entries only)
 * @property {string} Html       - Pre-rendered HTML for the template
 */

/**
 * @typedef {Object} CustomLogSection
 * @property {string} Key
 * @property {string} Name
 * @property {CustomLogEntry[]} Entries
 * @property {boolean} Collapsed
 * @property {string} HiddenClass
 */

// @ts-ignore
class PictFormsSolver extends libPictSectionForm.PictFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.DisplayShortName = 'HL-SV';
		this.DisplayLongName = 'Headlight-SolverVisualization';

		/** @type {CustomLogSection[]} */
		this._customLogSections = [];

		// Active filter query applied across both the standard Pict
		// solver entries and the custom log sections. Held on the
		// instance (rather than the DOM) so the filter survives every
		// re-render — onAfterRender re-applies it to the freshly
		// rendered nodes. Cleared via clearFilter() or by emptying
		// the input.
		/** @type {string} */
		this._filterQuery = '';
	}

	/**
	 * Current filter query string. Exposed as a getter so the
	 * content template can hydrate the input's `value` attribute on
	 * each render via `{~D:Context[0].FilterQuery~}`.
	 * @return {string}
	 */
	get FilterQuery()
	{
		return this._filterQuery;
	}

	// ── Custom Solver Log API ────────────────────────────────────────

	/**
	 * Sorted snapshot of sections for template consumption.
	 * Exposed as `CustomLogSectionsSorted` on the view instance so the
	 * content template can iterate it via `{~TS:...:Context[0].CustomLogSectionsSorted~}`.
	 *
	 * Returns an array containing a single wrapper object whose `.Sections`
	 * property holds the sorted section list — this matches the `{~TS:...~}`
	 * pattern (iterates an array, each Record has `.Sections`).
	 *
	 * @return {Array<{ Sections: CustomLogSection[] }>}
	 */
	get CustomLogSectionsSorted()
	{
		if (this._customLogSections.length === 0)
		{
			return [];
		}
		const sorted = this._customLogSections.slice().sort((a, b) => a.Key.localeCompare(b.Key));
		// Pre-compute presentation state for each section
		for (const section of sorted)
		{
			section.HiddenClass = section.Collapsed ? 'is-hidden' : '';
			section.ChevronIconClass = section.Collapsed ? 'fa-chevron-right' : 'fa-chevron-down';
		}
		return [ { Sections: sorted } ];
	}

	/**
	 * Find or create a section by key.
	 *
	 * @param {string} pSectionKey
	 * @param {string=} pDisplayName - Human-readable name; defaults to pSectionKey.
	 * @return {CustomLogSection}
	 * @private
	 */
	_getOrCreateSection(pSectionKey, pDisplayName)
	{
		let section = this._customLogSections.find((s) => s.Key === pSectionKey);
		if (!section)
		{
			section = { Key: pSectionKey, Name: pDisplayName || pSectionKey, Entries: [], Collapsed: false, HiddenClass: '' };
			this._customLogSections.push(section);
		}
		return section;
	}

	/**
	 * Parse a formula description string and render variable names as
	 * styled chip elements with operators as plain muted text between them.
	 *
	 * Input strings look like: `TotalWorkCompletedAmount &plus; SubtotalAmount`
	 * where operators are HTML entities (`&plus;`, `&times;`, `&minus;`,
	 * `&divide;`, `&equals;`).
	 *
	 * @param {string} pFormulaDescription - Variable names separated by HTML entity operators
	 * @return {string} HTML string with chip-wrapped variables and operator spans
	 * @private
	 */
	_renderFormulaChips(pFormulaDescription)
	{
		if (!pFormulaDescription)
		{
			return '';
		}

		// Split on HTML entity operators, keeping the delimiters
		const splitPattern = /(&plus;|&times;|&minus;|&divide;|&equals;)/g;
		// Non-global regex for classifying each token (avoids lastIndex drift)
		const isOperator = /^&(?:plus|times|minus|divide|equals);$/;
		const parts = pFormulaDescription.split(splitPattern);

		let html = '';
		for (const part of parts)
		{
			const trimmed = part.trim();
			if (!trimmed)
			{
				continue;
			}

			if (isOperator.test(trimmed))
			{
				html += `<span class="PSFS-CustomLog-Chip-Op">${trimmed}</span>`;
			}
			else
			{
				html += `<span class="PSFS-CustomLog-Chip">${trimmed}</span>`;
			}
		}
		return html;
	}

	/**
	 * Map a severity string to a CSS modifier class.
	 *
	 * @param {string=} pSeverity
	 * @return {string}
	 * @private
	 */
	_severityClass(pSeverity)
	{
		const key = (pSeverity || 'trace').toLowerCase();
		if (key === 'error') return 'severity-error';
		if (key === 'warning') return 'severity-warning';
		if (key === 'info') return 'severity-info';
		return 'severity-trace';
	}

	/**
	 * Add a general log entry. Signature matches the legacy
	 * `Headlight-Section-SolverLog.addEntry()` API so existing call sites
	 * can be routed here without modification.
	 *
	 * @param {string} pCategory     - Section key used for grouping (e.g. '001PaymentObservationQuantities')
	 * @param {string} pLabel        - Section display name (e.g. 'Payment Quantities')
	 * @param {string} pMessage      - Human-readable log message
	 * @param {string=} pSeverity    - 'Trace' | 'Info' | 'Warning' | 'Error'
	 */
	addEntry(pCategory, pLabel, pMessage, pSeverity)
	{
		const section = this._getOrCreateSection(pCategory, pLabel);
		const sevClass = this._severityClass(pSeverity);
		const sevLabel = (pSeverity || 'Trace');

		const html = /*html*/`
		<div class="PSFS-CustomLog-Entry">
			<span class="PSFS-CustomLog-Entry-Severity ${sevClass}">${sevLabel}</span>
			${pMessage}
		</div>`;

		section.Entries.push({
			Type: 'Entry',
			Category: pCategory,
			Label: pLabel,
			Message: pMessage,
			Severity: sevLabel,
			Html: html,
		});
	}

	/**
	 * Add a calculation log entry. Signature matches the legacy
	 * `Headlight-Section-SolverLog.addCalculation()` API.
	 *
	 * @param {string} pCategory           - Section key
	 * @param {string} pLabel              - Section display name
	 * @param {string} pDescription        - What is being calculated
	 * @param {string|number} pResult      - Computed value
	 * @param {string=} pFormula           - Expression string
	 * @param {string=} pFormulaDescription - Human-readable variable breakdown
	 */
	addCalculation(pCategory, pLabel, pDescription, pResult, pFormula, pFormulaDescription)
	{
		const section = this._getOrCreateSection(pCategory, pLabel);

		// Build the formula line with variable chips
		let formulaHtml = '';
		if (pFormulaDescription)
		{
			const chips = this._renderFormulaChips(pFormulaDescription);
			formulaHtml += /*html*/`<div class="PSFS-CustomLog-Calc-Formula">${chips}</div>`;
		}
		// Show the numeric expression on its own quieter line
		if (pFormula)
		{
			formulaHtml += /*html*/`<div class="PSFS-CustomLog-Calc-NumericFormula">${pFormula}</div>`;
		}

		const html = /*html*/`
		<div class="PSFS-CustomLog-Calc">
			<span>${pDescription}</span>
			<span class="PSFS-CustomLog-Calc-Result">= ${pResult}</span>
			${formulaHtml}
		</div>`;

		section.Entries.push({
			Type: 'Calculation',
			Category: pCategory,
			Label: pLabel,
			Message: pDescription,
			Severity: 'Info',
			Result: String(pResult),
			Formula: pFormula || '',
			FormulaDescription: pFormulaDescription || '',
			Html: html,
		});
	}

	/**
	 * Clear all custom log sections. Intended to be called at the start
	 * of each solve cycle so stale entries don't accumulate.
	 */
	resetEntries()
	{
		this._customLogSections = [];
	}

	/**
	 * Toggle the collapsed state of a custom log section.
	 * Called from the section header onclick in the template.
	 *
	 * @param {string} pSectionKey
	 */
	toggleCustomLogSection(pSectionKey)
	{
		const section = this._customLogSections.find((s) => s.Key === pSectionKey);
		if (!section) return;
		section.Collapsed = !section.Collapsed;
		// Toggle the DOM directly for responsiveness — the next full
		// render will pick up the persisted Collapsed flag.
		const el = document.querySelector(`[data-custom-log-section="${pSectionKey}"]`);
		if (el)
		{
			el.classList.toggle('is-hidden');
		}
		// Flip the chevron icon to match
		const chevron = document.querySelector(`[data-custom-log-chevron="${pSectionKey}"]`);
		if (chevron)
		{
			chevron.classList.toggle('fa-chevron-down', !section.Collapsed);
			chevron.classList.toggle('fa-chevron-right', section.Collapsed);
		}
	}

	/**
	 * Trigger a render of the custom log portion. Forms can call this
	 * explicitly after a batch of addEntry/addCalculation calls to
	 * update the panel in one shot rather than per-entry.
	 */
	renderCustomLogs()
	{
		this.render();
	}

	// ── Filter / highlight ──────────────────────────────────────────

	/**
	 * Apply the filter query across all standard solver entries and
	 * custom log sections / entries — hides non-matches and wraps
	 * matched substrings in `<mark>` tags for browser-Find-style
	 * highlighting. Called from the search input's `oninput` handler,
	 * so it runs synchronously against the rendered DOM and the user
	 * sees feedback as they type. The active query is stored on the
	 * instance so it survives re-renders.
	 *
	 * Matching is multi-token substring: the query is split on
	 * whitespace and every token must appear (case-insensitively) as
	 * a literal substring of the target text.
	 *
	 * @param {string} pQuery
	 */
	applyFilter(pQuery)
	{
		this._filterQuery = (pQuery == null ? '' : String(pQuery)).trim();
		this._refreshFilterDOM();
	}

	/**
	 * Clear the active filter and restore visibility of every entry.
	 * Wired to the inline (×) button in the filter bar.
	 */
	clearFilter()
	{
		this._filterQuery = '';
		const tmpInput = document.getElementById('PSFS-Filter-Input');
		if (tmpInput)
		{
			tmpInput.value = '';
			tmpInput.focus();
		}
		this._refreshFilterDOM();
	}

	/**
	 * Walk the rendered solver content and update three things based
	 * on the active filter query:
	 *
	 *   • Visibility — hide entries / sections that don't match.
	 *   • Highlighting — wrap matched substrings in `<mark>` tags so
	 *     the user can see exactly what landed (browser-Find style).
	 *   • Counter + empty state — refresh the right-side count
	 *     ("12 / 47") and toggle the "no logs match" banner.
	 *
	 * Visibility cascades through three layers:
	 *
	 *   1. `.PSFExt-Section` — Pict-rendered solver expression blocks.
	 *      Each is a single coherent unit (header + expression display
	 *      + extra data), matched as a whole by its full text content.
	 *   2. `.hl-log-section` — custom log collapsible groups. Match
	 *      hierarchically: if the section header text matches, every
	 *      entry stays visible; otherwise entries are filtered
	 *      individually and the group hides only when nothing inside
	 *      matches.
	 *   3. The "Custom Solver Logs" wrap header — hides when nothing
	 *      inside it survives, so the user isn't left with an orphan
	 *      heading floating above filtered-away content.
	 *
	 * Sections are hidden via the dedicated `PSFS-Filter-Hidden` class
	 * (not Bulma's `is-hidden`) so the user's manual collapse state on
	 * a custom log section remains independent of the filter — toggling
	 * the chevron and toggling the filter don't fight each other.
	 *
	 * @private
	 */
	_refreshFilterDOM()
	{
		const tmpRoot = document.getElementById('Pict-Form-Solver-Content');
		if (!tmpRoot)
		{
			return;
		}
		const tmpTokens = this._tokenizeFilterQuery(this._filterQuery);
		const tmpHasQuery = tmpTokens.length > 0;
		const tmpFilterBar = document.getElementById('PSFS-Filter-Bar');
		const tmpEmptyMsg = document.getElementById('PSFS-Filter-Empty');
		const tmpCounterText = document.getElementById('PSFS-Filter-Counter-Text');
		if (tmpFilterBar)
		{
			tmpFilterBar.classList.toggle('is-active', tmpHasQuery);
		}

		// Strip last cycle's <mark> highlights before re-evaluating. We
		// do this up front so the textContent reads we use for matching
		// (and any subsequent re-highlight pass) operate on a clean DOM
		// — otherwise mark wrappers from a previous keystroke would
		// accumulate.
		this._clearHighlights(tmpRoot);

		// Pre-build the multi-token highlight regex once per call so we
		// don't compile it inside the inner loop. Null when there's no
		// active query — the per-entry highlight pass becomes a no-op.
		const tmpHighlightRegex = tmpHasQuery ? this._buildHighlightRegex(tmpTokens) : null;

		// Tally counts as we go so the on-screen counter ("12 / 47")
		// reflects the same leaf-level definition the user perceives:
		// each standard solver expression block counts as 1, and each
		// custom log entry row inside a collapsible group counts as 1.
		let tmpVisibleCount = 0;
		let tmpTotalCount = 0;

		// Standard Pict-rendered solver expressions
		const tmpPsfSections = tmpRoot.querySelectorAll('.PSFExt-Section');
		for (const tmpSection of tmpPsfSections)
		{
			tmpTotalCount++;
			const tmpText = (tmpSection.textContent || '').toLowerCase();
			const tmpMatch = !tmpHasQuery || this._matchesAllTokens(tmpTokens, tmpText);
			tmpSection.classList.toggle('PSFS-Filter-Hidden', !tmpMatch);
			if (tmpMatch)
			{
				tmpVisibleCount++;
				if (tmpHighlightRegex)
				{
					this._applyHighlightsTo(tmpSection, tmpHighlightRegex);
				}
			}
		}

		// Custom Solver Log sections (collapsible groups)
		const tmpLogSections = tmpRoot.querySelectorAll('.hl-log-section');
		for (const tmpSection of tmpLogSections)
		{
			const tmpHeaderEl = tmpSection.querySelector('.hl-log-section-name');
			const tmpHeaderText = (tmpHeaderEl ? tmpHeaderEl.textContent || '' : '').toLowerCase();
			const tmpHeaderMatch = !tmpHasQuery || this._matchesAllTokens(tmpTokens, tmpHeaderText);
			let tmpSectionHasMatch = tmpHeaderMatch;

			// Highlight the header itself when it matches — gives the
			// user immediate visual confirmation of which group is
			// pinned by the section-name match path.
			if (tmpHighlightRegex && tmpHeaderEl && tmpHeaderMatch)
			{
				this._applyHighlightsTo(tmpHeaderEl, tmpHighlightRegex);
			}

			const tmpEntries = tmpSection.querySelectorAll('.hl-log-section-body > *');
			for (const tmpEntry of tmpEntries)
			{
				tmpTotalCount++;
				const tmpEntryText = (tmpEntry.textContent || '').toLowerCase();
				// When the section header itself matches, all entries
				// stay visible — the user is exploring the whole group.
				const tmpEntryMatch = tmpHeaderMatch || !tmpHasQuery || this._matchesAllTokens(tmpTokens, tmpEntryText);
				tmpEntry.classList.toggle('PSFS-Filter-Hidden', !tmpEntryMatch);
				if (tmpEntryMatch)
				{
					tmpSectionHasMatch = true;
					tmpVisibleCount++;
					if (tmpHighlightRegex)
					{
						this._applyHighlightsTo(tmpEntry, tmpHighlightRegex);
					}
				}
			}
			tmpSection.classList.toggle('PSFS-Filter-Hidden', !tmpSectionHasMatch);
		}

		// Hide the "Custom Solver Logs" wrap header when nothing inside
		// it survives the filter, so the user isn't left with an orphan
		// section heading floating above filtered-away content.
		const tmpCustomLogHeader = tmpRoot.querySelector('.PSFS-CustomLog-Header');
		if (tmpCustomLogHeader)
		{
			const tmpAnyLogVisible = Array.from(tmpLogSections).some((s) => !s.classList.contains('PSFS-Filter-Hidden'));
			tmpCustomLogHeader.classList.toggle('PSFS-Filter-Hidden', tmpHasQuery && !tmpAnyLogVisible);
		}

		if (tmpEmptyMsg)
		{
			tmpEmptyMsg.classList.toggle('is-active', tmpHasQuery && tmpVisibleCount === 0);
		}

		if (tmpCounterText)
		{
			if (tmpHasQuery)
			{
				tmpCounterText.textContent = `${tmpVisibleCount} / ${tmpTotalCount}`;
			}
			else
			{
				tmpCounterText.textContent = `${tmpTotalCount} log${tmpTotalCount === 1 ? '' : 's'}`;
			}
		}
	}

	/**
	 * Tokenize a filter query into the whitespace-separated lowercase
	 * words used as substring needles. Computed once per filter pass
	 * (not on every target match) so a long log list filters in
	 * O(targets * tokens) rather than re-splitting per row.
	 *
	 * @param {string} pQuery
	 * @return {string[]}
	 * @private
	 */
	_tokenizeFilterQuery(pQuery)
	{
		if (!pQuery)
		{
			return [];
		}
		const tmpTokens = [];
		for (const tmpRaw of String(pQuery).toLowerCase().split(/\s+/))
		{
			if (tmpRaw)
			{
				tmpTokens.push(tmpRaw);
			}
		}
		return tmpTokens;
	}

	/**
	 * Multi-word substring match. Every token in `pTokens` must appear
	 * as a literal (case-insensitive) substring of `pTarget`. Tokens
	 * may match in any order, but each one has to actually be in there
	 * — no character-anywhere-in-order looseness, which let "Result"
	 * pass for queries like "ConnectionsCalculationsLength".
	 *
	 * Single-token queries collapse to the equivalent of a normal
	 * browser-Find substring search; multi-token queries let users
	 * combine keywords ("calc width") without caring about ordering.
	 *
	 * `pTarget` must be pre-lowercased by the caller.
	 *
	 * @param {string[]} pTokens  Lowercased query tokens (non-empty).
	 * @param {string}   pTarget  Pre-lowercased target string.
	 * @return {boolean}
	 * @private
	 */
	_matchesAllTokens(pTokens, pTarget)
	{
		if (!pTokens || pTokens.length === 0)
		{
			return true;
		}
		if (!pTarget)
		{
			return false;
		}
		for (const tmpToken of pTokens)
		{
			if (pTarget.indexOf(tmpToken) === -1)
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * Escape a literal string for safe inclusion in a RegExp source.
	 * Without this, query characters like `(`, `.`, `*`, `?`, `|` etc.
	 * would change the regex's meaning (the user types these often when
	 * filtering for things like `(VFE_4)` or `result=`).
	 *
	 * @param {string} pSource
	 * @return {string}
	 * @private
	 */
	_escapeRegex(pSource)
	{
		return pSource.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	/**
	 * Build a single case-insensitive global regex that captures any
	 * occurrence of any token. Compiled once per filter call and reused
	 * across every visible entry — much cheaper than per-entry compile.
	 *
	 * The capture group is what `String.prototype.split` uses to keep
	 * the matched delimiters in the result array, which is the trick
	 * that drives the chunk-and-wrap loop in `_applyHighlightsTo`.
	 *
	 * @param {string[]} pTokens  Lowercased tokens (non-empty).
	 * @return {RegExp}
	 * @private
	 */
	_buildHighlightRegex(pTokens)
	{
		const tmpAlternation = pTokens.map((t) => this._escapeRegex(t)).join('|');
		return new RegExp(`(${tmpAlternation})`, 'gi');
	}

	/**
	 * Strip every previous-cycle highlight wrapper from `pRoot`. Called
	 * before each filter pass so highlights don't accumulate as the
	 * user keeps typing. Replaces each <mark> with its text content
	 * and normalizes the parent so adjacent text nodes coalesce.
	 *
	 * @param {ParentNode} pRoot
	 * @private
	 */
	_clearHighlights(pRoot)
	{
		if (!pRoot)
		{
			return;
		}
		const tmpMarks = pRoot.querySelectorAll('mark.PSFS-Filter-Highlight');
		const tmpDirtyParents = new Set();
		for (const tmpMark of tmpMarks)
		{
			const tmpParent = tmpMark.parentNode;
			if (!tmpParent)
			{
				continue;
			}
			tmpParent.replaceChild(document.createTextNode(tmpMark.textContent || ''), tmpMark);
			tmpDirtyParents.add(tmpParent);
		}
		for (const tmpParent of tmpDirtyParents)
		{
			if (tmpParent && typeof tmpParent.normalize === 'function')
			{
				tmpParent.normalize();
			}
		}
	}

	/**
	 * Wrap every match of `pRegex` inside `pRootEl` in a styled <mark>
	 * tag — same idea as the browser's Find highlight. Walks text
	 * nodes via TreeWalker so attributes, event handlers, and existing
	 * markup (icons, chips, severity tags, table cells) are preserved.
	 *
	 * Skips text inside <input>, <textarea>, <script>, <style>, and
	 * already-highlighted <mark> wrappers. Empty-value text nodes are
	 * filtered out as well; whitespace-only nodes pass through, but
	 * the regex won't match against them so they're effectively no-ops.
	 *
	 * The DOM mutation runs after the walk completes — modifying nodes
	 * during walking would invalidate the TreeWalker's cursor.
	 *
	 * @param {Element} pRootEl  Element whose descendant text gets highlighted.
	 * @param {RegExp}  pRegex   Global, case-insensitive regex with one capture group.
	 * @private
	 */
	_applyHighlightsTo(pRootEl, pRegex)
	{
		if (!pRootEl || !pRegex)
		{
			return;
		}
		const tmpWalker = document.createTreeWalker(
			pRootEl,
			NodeFilter.SHOW_TEXT,
			{
				acceptNode(pNode)
				{
					const tmpParent = pNode.parentNode;
					if (!tmpParent)
					{
						return NodeFilter.FILTER_REJECT;
					}
					const tmpTag = tmpParent.nodeName;
					if (tmpTag === 'INPUT' || tmpTag === 'TEXTAREA' || tmpTag === 'SCRIPT' || tmpTag === 'STYLE')
					{
						return NodeFilter.FILTER_REJECT;
					}
					if (tmpTag === 'MARK' && tmpParent.classList && tmpParent.classList.contains('PSFS-Filter-Highlight'))
					{
						return NodeFilter.FILTER_REJECT;
					}
					if (!pNode.nodeValue)
					{
						return NodeFilter.FILTER_REJECT;
					}
					return NodeFilter.FILTER_ACCEPT;
				},
			},
		);
		// Collect first, mutate after — TreeWalker doesn't tolerate
		// removing the current text node mid-walk.
		const tmpTextNodes = [];
		while (tmpWalker.nextNode())
		{
			tmpTextNodes.push(tmpWalker.currentNode);
		}
		for (const tmpNode of tmpTextNodes)
		{
			const tmpText = tmpNode.nodeValue;
			// Reset lastIndex so the global regex doesn't carry state
			// between text nodes (each split() resets it implicitly,
			// but being explicit keeps the intent obvious).
			pRegex.lastIndex = 0;
			if (!pRegex.test(tmpText))
			{
				continue;
			}
			pRegex.lastIndex = 0;
			const tmpParts = tmpText.split(pRegex);
			if (tmpParts.length <= 1)
			{
				continue;
			}
			const tmpFragment = document.createDocumentFragment();
			for (let tmpIndex = 0; tmpIndex < tmpParts.length; tmpIndex++)
			{
				const tmpChunk = tmpParts[tmpIndex];
				if (!tmpChunk)
				{
					continue;
				}
				// `String.split` with a capturing group emits the
				// captured matches at odd indices in the result array.
				if (tmpIndex % 2 === 1)
				{
					const tmpMark = document.createElement('mark');
					tmpMark.className = 'PSFS-Filter-Highlight';
					tmpMark.textContent = tmpChunk;
					tmpFragment.appendChild(tmpMark);
				}
				else
				{
					tmpFragment.appendChild(document.createTextNode(tmpChunk));
				}
			}
			const tmpParent = tmpNode.parentNode;
			if (tmpParent)
			{
				tmpParent.replaceChild(tmpFragment, tmpNode);
			}
		}
	}

	/**
	 * Re-apply the active filter and refresh the match counter after
	 * every render. Pict's render pipeline replaces the content
	 * wholesale on each solve cycle, so any filter state held only in
	 * DOM classes would be wiped — this hook reads from the persisted
	 * `_filterQuery` and re-toggles the filter classes against the
	 * freshly rendered nodes. Always runs (even with an empty filter)
	 * so the counter shows total log count by default.
	 *
	 * @param {any} pRenderable
	 * @return {boolean}
	 */
	onAfterRender(pRenderable)
	{
		const tmpResult = super.onAfterRender(pRenderable);
		this._refreshFilterDOM();
		return tmpResult;
	}
}
module.exports = PictFormsSolver;
module.exports.default_configuration = defaultViewConfiguration;

},{"pict-section-form":497}],806:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ProjectFileSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialSearchResultsLoaded = false;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			SearchText: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'Date',
			SortDirection: 'DESC',
		};
		this.CurrentProjectSelection = this.AppData?.DocumentData?.ReportData?.IDProject || null;
		this.CurrentProjectName = this.AppData?.DocumentData?.ReportData?.Project?.Name || null;
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		this.CurrentFolderName = '';
		this.selectedObservation = {};
		this.ObservationTypeManifest = [];
		this.SearchPanelMode = '';
		this.SelectedFileFolder = null;
		this.SelectedFileFolderName = '';

		// TODO: We need to get this from the server from configured types by IDProgram
		// TODO: We also need a default set configured for Headlight
		this.FileTypes = [
			{ id: '', text: 'Select a type', disabled: true },
			{ id: 'Calculations', text: 'Calculations' },
			{ id: 'Images', text: 'Images' },
			{ id: 'Inspection Report', text: 'Inspection Report' },
			{ id: 'Load Rating', text: 'Load Rating' },
			{ id: 'Miscellaneous', text: 'Miscellaneous' },
			{ id: 'Plan', text: 'Plan' },
			{ id: 'Scour', text: 'Scour' },
			{ id: 'Structural Inventory and Appraisal', text: 'Structural Inventory and Appraisal' },
			{ id: 'Unknown', text: 'Unknown' },
			{ id: 'Custom', text: 'Custom' },
		];
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		const elementID = 'ProjectFileSearch-Projects';
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list

		// Bridge App has no DocumentData but exposes the active project on AppData.BridgeProject
		const tmpDefaultIDProject = this.AppData?.DocumentData?.ReportData?.IDProject || this.AppData?.BridgeProject?.IDProject;
		const tmpDefaultProjectName = this.AppData?.DocumentData?.ReportData?.Project?.Name || this.AppData?.BridgeProject?.Name;

		const tmpProject = this.CurrentSearchFilters?.Projects.length === 0 ?
			(tmpDefaultIDProject ? { id: tmpDefaultIDProject, text: tmpDefaultProjectName } : null ) :
			{ id: this.CurrentProjectSelection || tmpDefaultIDProject, text: this.CurrentProjectName || tmpDefaultProjectName };

		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: elementID,
			ParentID: 'ProjectFileSearch-SearchEntry',
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		this.setCurrentSearchFilters();
		//if we don't have search results, perform a search
		if (!this.initialSearchResultsLoaded)
		{
			//handle a preselected option if it exists
			if (tmpProject.id && tmpProject.id > 0)
			{
				//moved this out of the initialization to allow for the select2 change event to trigger after the initial load
				const select2 = $(`#${elementID}`);
				// create the option and append to Select2
				const option = new Option(tmpProject.text, tmpProject.id, true, true);
				select2.append(option).trigger('change');

				// manually trigger the `select2:select` event
				select2.trigger(
				{
					type: 'select2:select',
					params:
					{
						data: tmpProject,
					},
				});
			}
			this.initialSearchResultsLoaded = true;
			this.handleProjectFileSearch();
		}

		// if project container exists
		if (document.getElementById('ProjectFileSearch-Project-Container'))
		{
			// if we have a project, show it
			if (tmpDefaultIDProject)
			{
				document.getElementById('ProjectFileSearch-Project-Selected').classList.remove('is-hidden');
			}
			// if we don't have a project, show empty project id container
			else
			{
				document.getElementById('ProjectFileSearch-Project-Empty').classList.remove('is-hidden');
			}
		}
		this.toggleAllSectionVisibility('open');
		if (pCallback) pCallback();
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Event} [event] - The event that triggered the search.
	 * @param {string} [pRowID] - The ID of the row to search for.
	 * @param {boolean} [pIsChild] - Whether the search is for a child file or folder.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileSearch(event, pRowID, pIsChild)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#ProjectFileSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('ProjectFileSearch-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ProjectFileSearchFilters', 'close');
		// perform the project file search
		await this.pict.providers.ProjectFileProvider.getProjectFilesDataStructure(this.CurrentProjectSelection, this.CurrentSearchFilters, (/** @type {any} */ pResult) =>
		{
			if (!Array.isArray(pResult))
			{
				// Render search results template (non-blocking, no side effects here)
				this.pict.views.ProjectFileSearch.renderAsync('ProjectFileSearch-Results', '#ProjectFileSearch-Results-Container', false, () =>
				{
					try
					{
							this.pict.ContentAssignment.removeClass('#ProjectFileSearch-SearchButton', 'is-loading');

							if (this.ProjectFileSearchResultsCallback)
							{
								// eslint-disable-next-line new-cap
								this.ProjectFileSearchResultsCallback(this.CurrentSearchResults);
							}
					}
					catch (innerError)
					{
							this.pict.log.error('Error in renderAsync callback:', innerError);
					}
				},
				);
			}
			else
			{
				this.updateWithSearchResults(pResult, pRowID, pIsChild);
			}
		});
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ProjectFileSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ProjectFileSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ProjectFileSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});

		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.handleProjectFileSearch();
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], ObservationTypes: ['Legacy Narrative'], SearchText: 'dog'})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('ProjectFileSearch-SearchEntry'))
		{
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-SearchText', this.CurrentSearchFilters?.SearchText || '');
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-SearchFolder', this.CurrentSearchFilters?.SearchFolder || '');
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setProjectFileSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setProjectFileSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.ProjectFileSearchResultsCallback = pCallback;
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Project');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentProjectSelection = /** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).value;
			this.CurrentProjectName	 = /** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).options[/** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).selectedIndex].text;
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#ProjectFileSearch-Projects');
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#ProjectFileSearch-SearchText');
			break;
		case 'SearchFolder':
			this.CurrentSearchFilters.SearchFolder = this.pict.ContentAssignment.readContent('#ProjectFileSearch-SearchFolder');
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {string} [pRowID] - The ID of the row to update.
	 * @param {boolean} [pIsChild] - Whether the row is a child row.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pRowID, pIsChild)
	{
		try
		{
			this.CurrentSearchResults = pSearchResults;
			const pTotalSearchCount = pSearchResults.length;

			// Calculate pagination pages - doesn't really apply to Project File Search, but keeping for future enhancements (sort, filter, etc.)
			this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);

			// Render search results template (non-blocking, no side effects here)
			this.pict.views.ProjectFileSearch.renderAsync(
				'ProjectFileSearch-Results',
				'#ProjectFileSearch-Results-Container',
				false,
				() =>
				{
					try
					{
						this.pict.ContentAssignment.removeClass('#ProjectFileSearch-SearchButton', 'is-loading');

						if (this.ProjectFileSearchResultsCallback)
						{
							// eslint-disable-next-line new-cap
							this.ProjectFileSearchResultsCallback(this.CurrentSearchResults);
						}

						// Delay scroll to ensure DOM is patched
						requestAnimationFrame(() =>
						{
							this._tryScrollToRow(pRowID, pIsChild);
						});
					}
					catch (innerError)
					{
						this.pict.log.error('Error in renderAsync callback:', innerError);
					}
				},
			);
		}
		catch (outerError)
		{
			this.pict.log.error('Failed to update with search results:', outerError);
		}
	}

	/**
	* Smoothly scrolls to a row inside a scrollable container using jQuery.
	* @param {string} pRowID - The row ID to scroll to.
	* @param {boolean} pIsChild - Whether the row is a child row.
	* @param {number} [offset=70] - Offset in pixels from the top of the container.
	* @param {string} [containerSelector='#ProjectFileSearch-Results-Container'] - The scrollable container selector.
	*/
	_tryScrollToRow(pRowID, pIsChild, offset = 70, containerSelector = '#HeadlightPanels-ProjectFileSearch-Content')
	{
		if (!pRowID)
		{
			return;
		}

		const $container = $(containerSelector);
		if ($container.length === 0)
		{
			this.pict.log.warn(`Scroll container "${containerSelector}" not found.`);
			return;
		}

		const elID = pIsChild ?
		`ProjectFileSearch-Results-Treeview-Child-${pRowID}` :
		`ProjectFileSearch-Results-Treeview-${pRowID}`;

		const maxAttempts = 10;
		let attempt = 0;
		const interval = 100;

		const tryScroll = () =>
		{
			const $el = $(`#${elID}`);
			if ($el.length > 0)
			{
			// Offset of element and container from document
				const containerOffset = $container.offset().top;
				const elOffset = $el.offset().top;

				// Calculate scrollTop relative to container's current scroll
				const relativeScrollTop = $container.scrollTop() + (elOffset - containerOffset - offset);

				$container.animate({ scrollTop: relativeScrollTop }, 400);

				$el.addClass('highlight');
				setTimeout(() => $el.removeClass('highlight'), 5000);
			}
			else if (attempt++ < maxAttempts)
			{
				setTimeout(tryScroll, interval);
			}
			else
			{
				this.pict.log.warn(`Row with ID "${elID}" not found after ${maxAttempts} attempts.`);
			}
		};

		setTimeout(tryScroll, interval);
	}


	/**
	 * @spec puts a loading spinner on the element for a short time: 1.5 seconds.
	 * @param {HTMLElement} htmlElement
	 */
	animateLoading(htmlElement)
	{
		htmlElement.classList.add('is-loading');
		setTimeout(() => htmlElement.classList.remove('is-loading'), 1500);
	}

	/**
	 * This method handles the Details button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to view details for.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFilesDetailsClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			this.animateLoading(pEvent.currentTarget);
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);
		// and go to the observation detail view for the new observation
		this.pict.views.ObservationDetails.ActiveObservationDetails = tmpObservation;
		this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
	}

	/**
	 * This method handles the Clone button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to clone.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileCloneClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);

		let tmpIDArtifact;
		let tmpVersion;
		// show a PDF viewer if the observation is a PDF file type
		if (tmpObservation?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf')
		{
			tmpIDArtifact = tmpObservation?.Details?.File?.[0]?.IDArtifact;
			tmpVersion = tmpObservation?.Details?.File?.[0]?.Version;
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The selected project file is not a PDF file and cannot be added to the document.',
				type: 'is-danger',
			});
			return;
		}
		// download the file off of the observation
		const tmpFile = await this.pict.providers.ObservationProvider.downloadFileFromObservation(tmpIDArtifact, tmpVersion);
		// create a temporary file object to pass to the observation provider
		const newObservationObject = {
			File: tmpFile,
			ObservationType: tmpObservation.ObservationType,
			Name: tmpObservation.Details.File[0].Datum.FileName,
		};
		// TODO: Make this convert the file to an observation and add it to the document
		// Create an observation from the file
		await this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(newObservationObject, this.AppData?.DocumentData?.ReportData?.IDProject,
		(observationResult) =>
		{
			// remove the loading spinner from the button
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			// join to the document, if we have one
			this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument);
			const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
			// add result to our document if we have one
			if (tmpObservations && Array.isArray(tmpObservations))
			{
				tmpObservations.push(observationResult);
			}
			// if we have a set (we always should in this case), add the observation to the set
			if (this.pict.views.ObservationSet.ActiveObservationSet)
			{
				this.pict.views.ObservationSet.addObservationToSet(observationResult?.IDObservation);
			}
			// and go to the observation detail view for the new observation
			this.pict.views.ObservationDetails.ActiveObservationDetails = observationResult;
			this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
			this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
		});
	}

	/**
	 * This method handles the Clone button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to clone.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileAddClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);
		// remove the loading spinner from the button
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		// join to the document, if we have one
		this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(tmpObservation.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument);
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		// add result to our document if we have one
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			tmpObservations.push(tmpObservation);
		}
		// if we have a set (we always should in this case), add the observation to the set
		if (this.pict.views.ObservationSet.ActiveObservationSet)
		{
			this.pict.views.ObservationSet.addObservationToSet(tmpObservation?.IDObservation);
		}
		// and go to the observation detail view for the new observation
		this.pict.views.ObservationDetails.ActiveObservationDetails = tmpObservation;
			this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
	}

	/**
	 * Handles the change of file type in the dropdown.
	 * @param {HTMLSelectElement} selectEl - The select element that triggered the change.
	 * @param {string} fileID - The ID of the file whose type is being changed.
	 * @return {void}
	 */
	handleFileTypeChange(selectEl, fileID)
	{
		const customInput = /** @type {HTMLInputElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${fileID}`));
		if (selectEl.value === 'Custom')
		{
			customInput.classList.remove('is-hidden');
			customInput.focus();
		}
		else
		{
			customInput.classList.add('is-hidden');
		}
	}

	/**
	 * Add a dropdown menu to the toggle button for a table row.
	 * @param {string} pDate - The date of the file.
	 * @param {string} pName - The name of the file.
	 * @param {string} pFileID - The IDFile of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pFileType - The Type of the file.
	 * @param {Event} event - The event that triggered the function.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFileEditHandler(event, pDate, pName, pFileID, pRowID, pFileType, pParentIDProjectFileFolder)
	{
		// this is to get any changes to the file name made outside of the EDIT modal
		const fileNameElement = /** @type {HTMLElement} */ (document.getElementById(this.getFileNameDisplayID(pRowID)));
		const fileName = fileNameElement ? fileNameElement.textContent.trim() : pName;
		// the body and footer templates for the confirmation modal
		const editModalBodyTemplate = /*html*/`
		<span id="EditModalBody">
			<div class="fixed-grid has-2-cols">
				<div class="grid">
					<div class="cell">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-Date">Create Date</label>
						<input type="text" class="input" disabled="disabled" id="ProjectFileSearch-Results-Treeview-List-Date" value="${pDate || 'Unknown Date'}" />
					</div>
					<div class="cell">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}">File Type</label>
						<p class="control select is-fullwidth is-relative">
							<select 
								id="ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}" 
								class="input ml-auto mr-2"
								onchange="_Pict.views.ProjectFileSearch.handleFileTypeChange(this, ${pFileID})"
								title="Select File Type">
								${_Pict.views.ProjectFileSearch.renderFileTypeOptions(pFileType)}
							</select>
							<input type="text" class="input mt-2 is-hidden"
								id="ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${pFileID}"
								placeholder="Enter custom file type" />
						</p>
					</div>
					<div class="cell is-col-span-2">
						<div class="control">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}">File Name</label>
						<textarea class="textarea is-justify-content-left" rows="2" max-rows="2" id="ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}">${fileName}</textarea>
						</div>
					</div>
				</div>
			</div>
		</span>`;
		const editModalFooterTemplate = /*html*/`
		<div id="EditModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project File" onclick="_Pict.views.ProjectFileSearch.projectFileSaveHandler(event, ${pFileID}, '${pRowID}', '${fileName}', '${pParentIDProjectFileFolder}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const editModalOptions = {
			title: 'Edit Project File?',
			modalBodyTemplate: editModalBodyTemplate,
			modalFooterTemplate: editModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(editModalOptions, this.confirmSaveCallback.bind(this));
	}

	getFileDisplayID(pRowID)
	{
		return `DISPLAY-FOR-${pRowID}`;
	}

	getFileNameDisplayID(pRowID)
	{
		return `NAME-FOR-${pRowID}`;
	}

	getFileEditID(pRowID)
	{
		return `EDIT-FOR-${pRowID}`;
	}

	getFileInputID(pRowID)
	{
		return `INPUT-FOR-${pRowID}`;
	}

	/**
	 * Switch between edit and display views for a given row.
	 * @param {*} pRowID The row id to switch modes for.
	 */
	projectFileRenameSwitchMode(pRowID)
	{
		// Swap out the display and the input
		const displayElement = document.getElementById(this.getFileDisplayID(pRowID));
		const editElement = document.getElementById(this.getFileEditID(pRowID));
		const inputElement = document.getElementById(this.getFileInputID(pRowID));
		if (displayElement.classList.contains('is-hidden'))
		{
			displayElement.classList.remove('is-hidden');
			editElement.classList.add('is-hidden');
		}
		else
		{
			displayElement.classList.add('is-hidden');
			editElement.classList.remove('is-hidden');
			inputElement.focus();
			// @ts-ignore
			inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
		}
	}

	setProjectFileNameInCurrentSearchResults(pName, pIDProjectFile)
	{
		// Safer findParentNode
		function findNode(nodes, id)
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip undefined or null nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findNode(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		}

		const node = findNode(this.CurrentSearchResults, parseInt(pIDProjectFile));
		node.Name = pName;
	}

	/**
	 * Validates a file name against a set of rules.
	 * @param {string} pFileName - The file name to validate.
	 * @param {string} pParentIDProjectFileFolder - The parent folder ID for the file.
	 * @param {Array} [allowedExtensions=[]] - An array of allowed file extensions.
	 * @param {number} [maxLength=255] - The maximum allowed length for the file name.
	 * @return {boolean} - Returns true if the file name is valid, otherwise false.
	 */
	isValidFileName(pFileName, pParentIDProjectFileFolder, allowedExtensions = [], maxLength = 255)
	{
		const invalidCharsRegex = /[\\/:*?"<>|]/;
		const nameRegex = /^(.*)(\.[^.]+)$/; //if extension is provided

		if (!pFileName || pFileName.trim() === '')
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'File name cannot be blank',
				type: 'is-danger',
			});
			return;
		}

		// Check for invalid characters
		if (invalidCharsRegex.test(pFileName))
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Filename contains invalid characters. Valid characters are alphanumeric, spaces, - _ .',
				type: 'is-danger',
				duration: 5000,
			});
			return false;
		}

		// The regex checks for at least one character before the dot and allows an optional extension after the dot.
		if (nameRegex.test(pFileName) === false)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Filename is not valid. Valid format is name.extension.',
				type: 'is-danger',
				duration: 5000,
			});
			return false;
		}

		// db has name set to Char(255) so check for length
		if (pFileName.length > maxLength)
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filename exceeds maximum length of ${maxLength} characters.`,
				type: 'is-danger',
			});
			return false;
		}

		// Check for extension if allowedExtensions are provided
		if (allowedExtensions.length > 0)
		{
			const parts = pFileName.split('.');
			const extension = parts.pop().toLowerCase();
			if (!allowedExtensions.includes(extension))
			{
				this.pict.views.HeadlightPanels.toast({
					message: `Invalid file extension. Allowed extensions: ${allowedExtensions.join(', ')}`,
					type: 'is-danger',
				});
				return false;
			}
		}

		const checkFileName = this.checkFileNameExists(this.CurrentSearchResults, pFileName, pParentIDProjectFileFolder);
		if (checkFileName !== pFileName)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'A file with this name already exists in this folder',
				type: 'is-danger',
			});
			return false;
		}
		return true;
	}

	async projectFileRename(event, pName, pIDProjectFile, pParentIDProjectFileFolder, pRowID)
	{
		const inputElement = $(`#${this.getFileInputID(pRowID)}`);
		const newFileName = inputElement.val().toString();

		const hasFileNameChanged = pName !== newFileName;
		if (hasFileNameChanged)
		{
			const isValidFileName = this.isValidFileName(newFileName, pParentIDProjectFileFolder);
			if (!isValidFileName)
			{
				return;
			}
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: pIDProjectFile,
			Name: inputElement.val(),
		};

		await this.pict.providers.ProjectFileProvider.updateProjectFile(tmpFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project file name updated',
				type: 'is-success',
			});
			if (pResult)
			{
				$(`#${this.getFileNameDisplayID(pRowID)}`).text(newFileName.toString());
				inputElement.val(newFileName);
				this.setProjectFileNameInCurrentSearchResults(newFileName, pIDProjectFile);
			}
		});

		// Switch back to non-editing mode
		this.projectFileRenameSwitchMode(pRowID);
	}

	/**
	 * Handles the deletion of a project file.
	 * @param {string} pName - The name of the file to delete.
	 * @param {string} pIDProjectFile - The ID of the project file to delete.
	 * @param {Event} event - The event that triggered the delete action.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFileDelete(event, pName, pIDProjectFile)
	{
		// the body and footer templates for the delete modal
		const deleteModalBodyTemplate = /*html*/`
		<span id="DeleteModalBody">
			<div class="cell is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">Delete<strong> ${pName}</strong>?</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to delete or close this modal.</p>
				</div>
			</div>
		</span>`;
		const deleteModalFooterTemplate = /*html*/`
		<div id="DeleteModalFooter" class="buttons is-right">
			<button class="button is-danger is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-danger" type="button" title="Delete Project File" onclick="_Pict.views.ProjectFileSearch.projectFileDeleteHandler(event, ${pIDProjectFile})">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Delete</span>
			</button>
		</div>`;
		// the options for the edit modal
		const deleteModalOptions = {
			title: 'Delete Project File?',
			modalBodyTemplate: deleteModalBodyTemplate,
			modalFooterTemplate: deleteModalFooterTemplate,
			confirmText: 'Delete',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(deleteModalOptions, this.confirmDeleteCallback.bind(this));
	}

	/**
	 * Handles deleting project file
	 * @param {number} pIDProjectFile - The ID of the project file to delete.
	 * @param {Event} event - The event that triggered the save action.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFileDeleteHandler(event, pIDProjectFile)
	{
		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		await this.pict.providers.ProjectFileProvider.handleProjectFileDeletion(pIDProjectFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Deleted',
				type: 'is-success',
			});
			if (pResult)
			{
				this.handleProjectFileSearch(event, null, null);
			}
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles saving updated file type for project file
	 * @param {Event} event - The event that triggered the save action.
	 * @param {number} pFileID - The file object being saved.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFileSaveHandler(event, pFileID, pRowID, pFileName, pParentIDProjectFileFolder)
	{
		//save filename changes
		const tmpFileNameInput = /** @type {HTMLTextAreaElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}`));
		const newFileName = tmpFileNameInput.value;

		//compare newFileName to previous name and only check for existance or validity if it has changed.
		const hasFileNameChanged = pFileName !== newFileName;
		if (hasFileNameChanged)
		{
			const isValidFileName = this.isValidFileName(newFileName, pParentIDProjectFileFolder);
			if (!isValidFileName)
			{
				return;
			}
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}
		const tmpFileTypeSelect = /** @type {HTMLSelectElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}`));
		const tmpFileType = tmpFileTypeSelect.value;
		const tmpCustomFileTypeInput = /** @type {HTMLInputElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${pFileID}`));
		const tmpCustomFileType = tmpCustomFileTypeInput.value;

		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: pFileID,
			FileType: tmpFileType === 'Custom' ? tmpCustomFileType : tmpFileType,
			Name: newFileName,
		};

		await this.pict.providers.ProjectFileProvider.updateProjectFile(tmpFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Updated',
				type: 'is-success',
			});
			if (pResult)
			{
				this.handleProjectFileSearch(event, pRowID, true);
			}
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Add a new project folder.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectRootFolderAddHandler(event, pName, pRowID)
	{
		// the body and footer templates for the confirmation modal
		const addRootFolderModalBodyTemplate = /*html*/`
		<span id="AddRootFolderModalBody">
			<div class="grid">
				<div class="cell is-6">
					<strong>Folder Name</strong>
					<input type="text input is-fullwidth" class="input mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
		       			placeholder="Enter folder name" />
				</div>
			</div>
		</span>`;
		const addRootFolderModalFooterTemplate = /*html*/`
		<div id="AddRootFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project Folder" onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, null, null, document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const addRootFolderModalOptions = {
			title: 'Add Project Folder (root level)?',
			modalBodyTemplate: addRootFolderModalBodyTemplate,
			modalFooterTemplate: addRootFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(addRootFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Add a new project folder.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {number} pParentIDProjectFolder - The IDFile of the parent folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFolderAddHandler(event, pName, pParentIDProjectFolder, pRowID)
	{
		// the body and footer templates for the confirmation modal
		const addFolderModalBodyTemplate = /*html*/`
		<span id="AddFolderModalBody">
			<div class="grid">
				<div class="cell is-6">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name">Folder Name</label>
					<input type="text" class="input is-fullwidth mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
		       			placeholder="Enter folder name" />
				</div>
				<div class="cell is-6">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name-Parent">Parent Folder</label>
					<input type="text" class="input is-fullwidth is-static mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name-Parent"
						value="${pName}" />
				</div>
			</div>
		</span>`;
		const addFolderModalFooterTemplate = /*html*/`
		<div id="AddFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project Folder" onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, null, ${pParentIDProjectFolder}, document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const addFolderModalOptions = {
			title: 'Add Project Folder (to parent folder)?',
			modalBodyTemplate: addFolderModalBodyTemplate,
			modalFooterTemplate: addFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(addFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Edit a project folder name.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFolderEditHandler(event, pName, pIDProjectFileFolder, pParentIDProjectFileFolder, pRowID)
	{
		// the body and footer templates for the rename folder modal
		const renameFolderModalBodyTemplate = /*html*/`
		<span id="RenameFolderModalBody">
			<div class="grid">
				<div class="cell is-12">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name">Folder Name</label>
					<input type="text input is-fullwidth" class="input mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
						value="${pName}"
		       			placeholder="Enter folder name" />
				</div>
			</div>
		</span>`;
		const renameFolderModalFooterTemplate = /*html*/`
		<div id="RenameFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" 
					type="button" 
					title="Save Project Folder" 
					onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, '${pIDProjectFileFolder}', '${pParentIDProjectFileFolder}', document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const renameFolderModalOptions = {
			title: 'Rename Project Folder?',
			modalBodyTemplate: renameFolderModalBodyTemplate,
			modalFooterTemplate: renameFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(renameFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// render the current state of the project file panel
			this.pict.views.ProjectFileSearch.renderAsync(() =>
			{
				this.pict.log.info('Project File Panel Rendered');
			});
		}
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmDeleteCallback(event)
	{
		if (event)
		{
			// render the current state of the project file panel
			this.pict.views.ProjectFileSearch.renderAsync(() =>
			{
				this.pict.log.info('Project File Panel Rendered');
			});
		}
	}

	/**
	 * Ensures a file name is unique among all files recursively under a given parent folder.
	 * Appends `_1`, `_2`, etc. if needed.
	 *
	 * @param {Array} folders - Array of root folder objects.
	 * @param {string} pNewFileName - Desired file name to insert.
	 * @param {any} pParentID - ID of the folder to start checking from (null/0 = root).
	 * @return {string} - A unique file name.
	 */
	checkFileNameExists(folders, pNewFileName, pParentID = null)
	{
		const nameRegex = /^(.*?)(\.[^.]*)?$/; // base + optional extension

		// Safer findParentNode
		function findParentNode(nodes, id)
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip undefined or null nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findParentNode(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		}

		let parentNode;
		if (!pParentID || parseInt(pParentID) === 0)
		{
			parentNode = { Children: folders }; // virtual root node
		}
		else
		{
			parentNode = findParentNode(folders, parseInt(pParentID));
			if (!parentNode) return pNewFileName;
		}

		function collectAllFileNames(node, resultSet)
		{
			if (!node || !node.Children || !Array.isArray(node.Children)) return;

			for (const child of node.Children)
			{
				if (!child) continue; // skip invalid
				if (child.IsFolder)
				{
					collectAllFileNames(child, resultSet);
				}
				else
				{
					if (child.Name)
					{
					resultSet.add(child.Name.toLowerCase());
					}
				}
			}
		}

		const existingNames = new Set();
		collectAllFileNames(parentNode, existingNames);

		if (!existingNames.has(pNewFileName.toLowerCase()))
		{
			return pNewFileName;
		}

		const match = pNewFileName.match(nameRegex);
		const base = match[1];
		const ext = match[2] || '';
		let counter = 1;
		let newName;

		do
		{
			newName = `${base}_${counter}${ext}`;
			counter++;
		} while (existingNames.has(newName.toLowerCase()));

		return newName;
	}


	/**
	 * Recursively checks if a folder name exists under a given parent folder node.
	 * @param {Array} folders - Array of root folders (tree structure).
	 * @param {string} pNewFolderName - Name to check.
	 * @param {any} pParentID - Parent folder ID to start from; null or 0 means root level.
	 * @return {boolean} True if folder name exists under that parent.
	 */
	checkFolderNameExists(folders, pNewFolderName, pParentID = null)
	{
		const lowerName = pNewFolderName.toLowerCase();

		// Safer findParent function
		const findParent = (nodes, id) =>
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip null/undefined nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findParent(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		};

		let parentNode;
		if (!pParentID || parseInt(pParentID) === 0)
		{
			parentNode = { Children: folders }; // virtual root node
		}
		else
		{
			parentNode = findParent(folders, parseInt(pParentID));
			if (!parentNode) return false; // parent not found
		}

		const checkChildren = (nodes) =>
		{
			if (!nodes || !Array.isArray(nodes)) return false;

			for (const node of nodes)
			{
				if (!node) continue; // skip invalid
				if (node.IsFolder && node.Name && node.Name.toLowerCase() === lowerName)
				{
					return true;
				}
			}
			return false;
		};

		// Only check immediate children of parent node
		return checkChildren(parentNode.Children);
	}


	/** Handles the addition of a project file.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/
	projectRootFileAddHandler(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.SelectedFileFolder = 0; // 0 indicates root folder
		this.pict.providers.ProjectFileProvider.openSearchPanel(this.pict.views.ProjectFileSearch, 'Project Files', 'add-to-root');
	}

	/** Handles the addition of a project file.
	* @param {Object} pIDObservation - The Observation object.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/

	/** Handles the addition of a project file.
	* @param {Event} event - The event that triggered the function.
	* @param {string} pName - The name of the project folder.
	* @param {number} pIDProjectFileFolder - The ID of the project folder.
	* @return {void}
	*/
	projectFileAddHandler(event, pName, pIDProjectFileFolder)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.SelectedFileFolder = pIDProjectFileFolder;
		this.SelectedFileFolderName = pName;
		this.pict.providers.ProjectFileProvider.openSearchPanel(this.pict.views.ProjectFileSearch, 'Project Files', 'add-to-folder');
	}

	/** Handles the addition of a project file.
	* @param {Object} pIDObservation - The Observation object.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/

	addObservationToProjectFolderRecord(pIDObservation, event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		if (!pIDObservation || !pIDObservation.IDObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No observation selected to add to project folder',
				type: 'is-danger',
			});
			return;
		}

		let checkFileName = '';
		if (pIDObservation?.Details?.Image?.Datum?.FileName)
		{
			checkFileName = pIDObservation?.Details?.Image?.Datum?.FileName;
		}
		else if (pIDObservation?.Name)
		{
			checkFileName = pIDObservation?.Name;
		}

		const updatedFileName = this.checkFileNameExists(this.CurrentSearchResults, checkFileName, this.SelectedFileFolder);

		this.pict.log.info('Adding observation to project folder record:', pIDObservation, this.SelectedFileFolder);
		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: 0,
			IDObservation: pIDObservation.IDObservation,
			IDProjectFileFolder: this.SelectedFileFolder,
			Name: updatedFileName || pIDObservation.Name,
			FileType: pIDObservation.ObservationType,
		};
		this.pict.providers.ProjectFileProvider.addProjectFile(tmpFile, (/** @type {{ IDProjectFile: any; IDObservation: any; }} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Added',
				type: 'is-success',
			});
			if (pResult)
			{
				const _RowID = `File-${pResult.IDProjectFile}_${pResult.IDObservation}`;
				this.handleProjectFileSearch(event, _RowID, true);
			}
		});
	}

	/**
	 * Handles saving updated file type for project file
	 * @param {Event} event - The event that triggered the save action.
	 * @param {string} pIDProjectFileFolder - The ID of the project folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent project folder.
	 * @param {string} pNewFolderName - The name of the new folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFolderSaveHandler(event, pIDProjectFileFolder, pParentIDProjectFileFolder, pNewFolderName, pRowID)
	{
		const existingFolderName = this.checkFolderNameExists(this.CurrentSearchResults, pNewFolderName, pParentIDProjectFileFolder);

		if (existingFolderName)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'A folder with this name already exists',
				type: 'is-danger',
			});
			return;
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		// safe guard for no changes to save
		// todo: add disable flag to button that re-evals until something changes
		if (!pIDProjectFileFolder && !pParentIDProjectFileFolder && !pNewFolderName)
		{
			return;
		}

		// if we're renaming the folder, update the row ID to match the new name
		if (pIDProjectFileFolder)
		{
			pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pIDProjectFileFolder}`;
		}

		if (pIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: parseInt(pIDProjectFileFolder),
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};
			await this.pict.providers.ProjectFileProvider.updateProjectFolder(tmpFolder, (/** @type {any} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Updated',
					type: 'is-success',
				});
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
			this.pict.fable.services.HeadlightModal.dismissModals();
			return;
		}
		else if (pParentIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: 0,
				ParentIDProjectFileFolder: parseInt(pParentIDProjectFileFolder),
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};

			await this.pict.providers.ProjectFileProvider.addProjectFolder(tmpFolder, (/** @type {{ IDProjectFileFolder: any; }} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Added',
					type: 'is-success',
				});
				// if we're creating a new folder, update the row ID to match the new name
				pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pResult.IDProjectFileFolder}`;
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
		}
		else if (!pParentIDProjectFileFolder && !pIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: 0,
				ParentIDProjectFileFolder: 0,
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};

			await this.pict.providers.ProjectFileProvider.addProjectFolder(tmpFolder, (/** @type {{ IDProjectFileFolder: any; }} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Added',
					type: 'is-success',
				});
				// if we're creating a new folder, update the row ID to match the new name
				pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pResult.IDProjectFileFolder}`;
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
		}
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Renders the file type options for a select dropdown.
	 * Ensures the selectedTypeID is always included, even if it's not in the default list.
	 * @param {string} selectedTypeID - The ID of the currently selected file type.
	 * @return {string} The HTML string for the file type options.
	 */
	renderFileTypeOptions(selectedTypeID)
	{
	/** @type {{ id: string, text: string }[]} */
		let options = this.FileTypes;

		// Check if selectedTypeID exists in the options list
		const selectedExists = options.some((opt) => opt.id === selectedTypeID);

		// If it doesn't exist, add a custom option for it
		if (!selectedExists && selectedTypeID)
		{
			options = [
				...options,
				{ id: selectedTypeID, text: `${selectedTypeID}` },
			];
		}

		return options.map((opt) =>
		{
			const isSelected = opt.id === selectedTypeID ? 'selected' : '';
			const isDisabled = opt.id === '' ? 'disabled selected' : '';
			return `
			<option value="${opt.id}" id="${opt.id}" ${isSelected} ${isDisabled}>
				${opt.text}
			</option>`;
		}).join('');
	}


	/**
	 * Toggle the visibility of Project File Folder
	 * @param {*} event - the event object
	 * @param {string} _RowID - the name and id of the folder
	 * @return {void}
	 */
	toggleSectionVisibility(event, _RowID)
	{
		// find the icon in the button and swap it out
		const tmpIcon = event?.currentTarget?.querySelector('i') || event?.parentElement?.currentTarget?.querySelector('i');
		if (!tmpIcon)
		{
			return;
		}
		if (tmpIcon.classList.contains('fa-folder-open'))
		{
			tmpIcon.classList.remove('fa-folder-open');
			tmpIcon.classList.add('fa-folder-closed');
		}
		else
		{
			tmpIcon.classList.remove('fa-folder-closed');
			tmpIcon.classList.add('fa-folder-open');
		}
		// toggle the visibility of the child folders
		const tmpElementID = `ProjectFileSearch-Results-Treeview-Child-${_RowID}`;
		// if the element is not found, return
		if (!document.getElementById(tmpElementID))
		{
			this.log.error(`Element with ID ${tmpElementID} not found`);
			return;
		}
		document.getElementById(tmpElementID)?.classList.toggle('is-hidden', document.getElementById(tmpElementID)?.classList.contains('is-hidden') ? false : true);
	}

	/**
	 * Toggle the visibility of all sections
	 * @param {*} pVisibility - the visibility to set
	 * @return {void}
	 */
	toggleAllSectionVisibility(pVisibility)
	{
		const tmpSections = document.querySelectorAll('.panel-block-group');
		tmpSections.forEach((section) =>
		{
			if (pVisibility === 'open')
			{
				section.classList.remove('is-hidden');
			}
			else
			{
				section.classList.add('is-hidden');
			}
		});
		const tmpIcons = document.querySelectorAll('.panel-block-group-header i');
		tmpIcons.forEach((icon) =>
		{
			if (icon.classList.contains('fa-folder-open') && pVisibility === 'close')
			{
				icon.classList.remove('fa-folder-open');
				icon.classList.add('fa-folder-closed');
			}
			else
			{
				icon.classList.remove('fa-folder-closed');
				icon.classList.add('fa-folder-open');
			}
		});
	}

	//-----TODO: Extract into it's own provider once nailed down and make dynamic ------ BEGINNING

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pDate - The date of the file.
	 * @param {string} pName - The name of the file.
	 * @param {string} pFileID - The ID of the file.
	 * @param {string} pFileType - The type of the file.
	 */
	handleFileActionPopover(id, pRowID, pDate, pName, pFileID, pFileType)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-FILE-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for file menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-File-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Date: pDate,
				Name: pName,
				ID: pFileID,
				Type: pFileType,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent folder.
	 */
	handleFolderActionPopover(id, pRowID, pName, pIDProjectFileFolder, pParentIDProjectFileFolder)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-FOLDER-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for folder menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-Folder-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Name: pName,
				ID: pIDProjectFileFolder,
				ParentFolder: pParentIDProjectFileFolder,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 */
	handleRootActionPopover(id, pRowID, pName, pIDProjectFileFolder)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-ROOT-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for root menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-Root-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Name: pName,
				ID: pIDProjectFileFolder,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	//-----TODO: Extract into it's own provider once nailed down and make dynamic ------ END
}

module.exports = ProjectFileSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectFileSearch',
	DefaultRenderable: 'ProjectFileSearch-Wrapper',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
		[
			{
				Hash: 'ProjectFileSearch-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-ProjectFileSearchPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event)">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('right')">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header-Icon" class="fas fa-fw fa-files" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header-Title" class="mr-3">Project Files</span>
					</p>
					<div class="panel-content nested-scroll-content">
						<div id="HeadlightPanels-ProjectFileSearch-Entry">
							{~T:ProjectFileSearch-Entry~}
						</div>
						<div id="HeadlightPanels-ProjectFileSearch-Content" class="has-bottom-navbar-offset">
							{~T:ProjectFileSearch-Project-Container~}
							{~T:ProjectFileSearch-Results~}
						</div>
					</div>
				</article>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry',
				Template: /*html*/`
				<div id="ProjectFileSearch-SearchEntry" class="container">
					<form autocomplete="off" role="observation-search" onsubmit="_Pict.views.ProjectFileSearch.handleProjectFileSearch(event, null, null);">
						<div class="px-4 pt-4" data-collapsible-content="ProjectFileSearchFilters">
							<div class="columns is-hidden">
								{~T:ProjectFileSearch-Entry-CurrentPage~}
								{~T:ProjectFileSearch-Entry-PageSize~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-SearchText~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-SearchFolder~}
							</div>
						</div>
						<div class="buttons m-3 mb-5" data-theme="dark">
							<button
								type="button"
								class="button is-primary" 
								title="Add Folder" 
								onclick="_Pict.views.ProjectFileSearch.projectRootFolderAddHandler(event, '{~D:Record.Name~}', '{~D:Record._RowID~}')">
								<span class="icon">
									<i class="fa fa-fw fa-folder-plus"></i>
								</span>
								<span class="icon-text">Add Folder</span>
							</button>
							<button
								type="button" 
								class="button is-primary" 
								title="Add File" 
								onclick="_Pict.views.ProjectFileSearch.projectRootFileAddHandler(event)">
								<span class="icon">
									<i class="fa fa-fw fa-file-plus"></i>
								</span>
								<span class="icon-text">Add File</span>
							</button>
							<button 
								type="button"
								id="ProjectFileSearch-ToggleButton"
								class="button is-primary is-soft" 
								title="Open search panel" 
								data-collapsible-toggle="ProjectFileSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ProjectFileSearchFilters')">
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span class="icon-text">Set Filters</span>
							</button>
							<button 
								type="button"
								class="button is-primary is-soft" 
								title="Reset filters" 
								id="ProjectFileSearch-ResetButton" 
								onclick="_Pict.views.ProjectFileSearch.resetSearchFilters()">
								<span class="icon">
									<i class="fas fa-fw fa-undo mr-1"></i>
								</span>
								<span class="icon-text">Clear Filters</span>
							</button>
							<button
								type="submit" 
								id="ProjectFileSearch-SearchButton"
								class="button is-primary" 
								title="Search project files">
								<span class="icon">
									<i class="fas fa-fw fa-search mr-1"></i>
								</span>
								<span class="icon-text">Search Project Files</span>
							</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ProjectFileSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="ProjectFileSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('CurrentPage')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ProjectFileSearch-PageSize" class="block">Page Size</label>
						<input 
							id="ProjectFileSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('PageSize')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ProjectFileSearch-Projects">Project</label>
						<div class="control select is-fullwidth">
							<select 
								id="ProjectFileSearch-Projects" 
								onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('Projects');_Pict.views.ProjectFileSearch.handleProjectFileSearch(event, null, null);"
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ProjectFileSearch-SearchText" class="block">File Search</label>
					<input 
						id="ProjectFileSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-SearchFolder',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ProjectFileSearch-SearchFolder" class="block">Folder Search</label>
					<input
						id="ProjectFileSearch-SearchFolder"
						type="text"
						class="input"
						placeholder="Enter the name of the folder to search"
						onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('SearchFolder')"
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-Container" class="container table-container">
					{~TIfAbs:ProjectFileSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Container:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span>We could not find any project files based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Type</th>
							<th>File Name</th>
							{~T:ProjectFileSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="ProjectFileSearch-ResultsEntries">
						{~TS:ProjectFileSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Row',
				Template: /*html*/`
				<tr class="is-clickable">
					<td class="is-vcentered" onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}">
						{~TIfAbs:ProjectFileSearch-Results-ProjectFileFolder-Empty:Record:Record.IDProjectFileFolder^==^0~}
						{~TIfAbs:ProjectFileSearch-Results-ProjectFileFolder:Record:Record.IDProjectFileFolder^>^0~}
					</td>
					<td class="is-vcentered" onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}">{~D:Record.Name~}</td>
					{~T:ProjectFileSearch-Results-Extra-Row:Record~}
				</tr>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Extra-Header',
				Template: /*html*/``,
			},
			{
				Hash: 'ProjectFileSearch-Results-Extra-Row',
				Template: /*html*/``,
			},
			{
				Hash: 'ProjectFileSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder',
				Template: /*html*/`{~E:ProjectFileFolder^Record.IDProjectFileFolder^ProjectFileSearch-Results-ProjectFileFolder-Name^~}`,
			},
			/* ----- start Tree View ---- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Container',
				Template: /*html*/`
				<div class="treeview treeview overflow-scroll-container-for-search-results nested-scroll-content has-bottom-navbar-offset">
					{~TS:ProjectFileSearch-Results-Treeview:Record.CurrentSearchResults~}
				</div>`,
			},
			/* ----- Tree View > first layer (results or empty check) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview',
				Template: /*html*/`
					{~T:ProjectFileSearch-Results-Treeview-Content:Record~}
				`,
			},
			/* ----- Tree View > second layer (empty) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span>We could not find any project files based on the current search criteria.</span>
					</p>
				</div>`,
			},
			/* ----- Tree View > second layer (search results processed list) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Content',
				Template: /*html*/`
				{~TIfAbs:ProjectFileSearch-Results-Treeview-File:Record:Record.IsFolder^==^0~}
				{~TIfAbs:ProjectFileSearch-Results-Treeview-FolderList:Record:Record.IsFolder^==^1~}`,
			},
			/* ----- Tree View > third layer (folder of files) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-FolderList',
				Template: /*html*/`
				<div
					id="ProjectFileSearch-Results-Treeview-{~D:Record._RowID~}"
					class="panel-block panel-block-group-header is-relative is-clickable px-1 py-0" 
					onclick="_Pict.views.ProjectFileSearch.toggleSectionVisibility(event, '{~D:Record._RowID~}')">
					<a class="button is-ghost has-text-primary-60">
						<span class="icon">
							<i class="fa fa-fw fa-folder-open"></i>
						</span>
					</a>
					<h4 class="title is-size-6 label has-text-text-90">{~D:Record.Name~}</h4>
					{~T:ProjectFileSearch-Results-Treeview-Folder-Action-Button~}
				</div>
				<div id="ProjectFileSearch-Results-Treeview-Child-{~D:Record._RowID~}" class="is-hoverable is-hidden panel-block-group">
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Folder-Content:Record:Record.Children.length^>^0~}
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Folder-Empty:Record:Record.Children.length^==^0~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File',
				Template: /*html*/`
				<div 
					id="ProjectFileSearch-Results-Treeview-Child-{~D:Record._RowID~}"
					class="panel-block is-file-row is-clickable py-2"
					title="View File Details" 
					onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}"
					data-observation-id="{~D:Record.IDObservation~}"
				>
					<span class="icon has-text-primary-90">
						<i class="fa fa-fw fa-file"></i>
					</span>
					<span id="DISPLAY-FOR-{~D:Record._RowID~}" class="has-text-text-90">
						<span id="NAME-FOR-{~D:Record._RowID~}">
							{~D:Record.Name~}
						</span>
						{~T:ProjectFileSearch-Results-Treeview-File-Action-Button~}
					</span>
					<span id="EDIT-FOR-{~D:Record._RowID~}" class="is-hidden columns is-align-self-center" onclick="event.stopPropagation();">
						<span class="column is-three-fifths py-0">
							<input class="input is-normal" id="INPUT-FOR-{~D:Record._RowID~}" type="text" value="{~D:Record.Name~}" />
						</span>
						<span class="column is-align-content-center py-0">
							<button
								type="button"
								class="button is-small is-link is-soft is-outlined"
								onclick="_Pict.views.ProjectFileSearch.projectFileRenameSwitchMode('{~D:Record._RowID~}')"
								title="Cancel"
							>
								<i id="ObservationDetails-Content-Save-Icon" class="fas fa-fw fa-times"></i>
							</button>
							<button
								type="button"
								class="button is-small is-link"
								onclick="_Pict.views.ProjectFileSearch.projectFileRename(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}', '{~D:Record._RowID~}')"
								title="Save"
							>
								<i class="fa fa-fw fa-save"></i>
							</button>
						</span>
					</span>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Action-Button',
				Template: /*html*/`
				<button
                    id="PANEL-MENU-BUTTON-FOR-FILE-{~D:Record._RowID~}"
                    class="button icon-button is-ghost has-text-primary-60 p-0 ml-3"
					style="float: none"
					title="Actions"
                    type="button"
                    aria-haspopup="true"
                    onmouseover="_Pict.views.ProjectFileSearch.handleFileActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Date~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.Type~}')"
                    onclick="_Pict.views.ProjectFileSearch.handleFileActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Date~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.Type~}'); event.stopPropagation();">
                    <span class="icon is-small">
                        <i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
                    </span>
                </button>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ProjectFileSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_project-file">
						<a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFileEditHandler(event, '{~DateFormat:Record.Date^YYYY-MM-DD - HH:mm a~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record._RowID~}', '{~D:Record.Type~}', '{~D:Record.ParentFolder~}')">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span>Edit</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-file">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFileDelete(event, '{~D:Record.Name~}', '{~D:Record.ID~}')">
							<span class="icon">
								<i class="fas fa-trash"></i>
							</span>
							<span>Delete</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-file">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFileRenameSwitchMode('{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-pen-field"></i>
							</span>
							<span>Rename File</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Action-Button',
				Template: /*html*/`
				<button
                    id="PANEL-MENU-BUTTON-FOR-FOLDER-{~D:Record._RowID~}"
                    class="button icon-button is-ghost has-text-primary-60 p-0 ml-3"
					style="float: none"
					title="Actions"
                    type="button"
                    aria-haspopup="true"
                    onmouseover="_Pict.views.ProjectFileSearch.handleFolderActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}')"
                    onclick="_Pict.views.ProjectFileSearch.handleFolderActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}')">
                    <span class="icon is-small">
                        <i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
                    </span>
                </button>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ProjectFileSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_project-folder">
                        <a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFileAddHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}')">
                            <span class="icon">
                                <i class="fas fa-file-plus"></i>
                            </span>
                            <span>Add File</span>
                        </a>
                    </li>
					<li class="list-menu-item mode_project-folder">
						<a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFolderAddHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-folder-plus"></i>
							</span>
							<span>Add Folder</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-folder">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFolderEditHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}', '{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span>Rename Folder</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Visibility-Buttons',
				Template: /*html*/`
				<div class="buttons mx-4 mb-0">
					<button type="button" class="button is-ghost has-text-primary-soft" title="Expand all" onclick="_Pict.views.ProjectFileSearch.toggleAllSectionVisibility('open')">
						<span class="icon">
							<i class="fa fa-fw fa-expand"></i>
						</span>
						<span class="icon-text">Expand All</span>
					</button>
					<button type="button" class="button is-ghost has-text-primary-soft" title="Collapse all" onclick="_Pict.views.ProjectFileSearch.toggleAllSectionVisibility('close')">
						<span class="icon">
							<i class="fa fa-fw fa-compress"></i>
						</span>
						<span class="icon-text">Collapse All</span>
					</button>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Type-Selector',
				Template: /*html*/`
                <p id="ProjectFileSearch-Results-Treeview-File-Type-Readonly-{~D:Record.ID~}">
					<span class="subtitle is-6 has-text-text-90">{~D:Record.Type~}</span>
				</p>
				<p id="ProjectFileSearch-Results-Treeview-File-Type-Edit-{~D:Record.FolderID~}" class="control select is-fullwidth is-relative is-hidden">
					<select 
						id="ProjectFileSearch-Results-Treeview-File-Type-Select-{~D:Record.ID~}"
						class="input mr-2"
						onchange="_Pict.views.ProjectFileSearch.handleFileTypeChange(event, '{~D:Record.ID~}')">
						{~TS:ProjectFileSearch-Results-Treeview-File-Type-Options:Context[0].Context[0].FileTypes~}
					</select>
					<input 
						type="text" 
						class="input mt-2 is-hidden"
		       			id="ProjectFileSearch-Results-Treeview-File-Type-Custom-{~D:Record.ID~}"
		       			placeholder="Enter custom file type" />
				</p>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Type-Options',
				Template: /*html*/`<option value="{~D:Record.id~}">{~D:Record.text~}</option>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Content',
				Template: /*html*/`
				<div class="treeview-folder">
					{~TS:ProjectFileSearch-Results-Treeview-Content:Record.Children~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Empty',
				Template: /*html*/`
                <div class="notification mx-3 p-2 empty-message has-background-text-30">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa-regular fa-info-circle"></i>
						</span>
						<span class="icon-text">This folder is empty.</span>
					</p>
				</div>`,
			},
			// TODO: Project File Paths for Name: https://bridge.qa.headlight.com/1.0/ImportantProjectFiles/10337/ (which does one folder at a time)
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder-Empty',
				Template: /*html*/`/`,
			},
			{
				Hash: 'ProjectFileSearch-Project-Container',
				Template: /*html*/`
				<div id="ProjectFileSearch-Project-Container" class="columns has-background-text-20">
					<div id="ProjectFileSearch-Project-Selected" class="column is-hidden">
						<span class="title is-6 has-text-white ml-4">{~D:AppData.DocumentData.ReportData.Name~}</span>
					</div>
					<div id="ProjectFileSearch-Project-Empty" class="column is-hidden">
						{~T:ProjectFileSearch-Project-Empty~}
					</div>
					{~T:ProjectFileSearch-Results-Visibility-Buttons~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFiles-Root',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-ProjectFile-Root" class="column">
					{~TS:ProjectFileSearch-Results-ProjectFile-Root-Files:Record.Children~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFile-Root-Files',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-ProjectFile-Root-File-{~D:Record.IDProjectFile~}" class="column">
					{~D:Record.Name~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Project-Empty',
				Template: /*html*/`<p class="title is-5 has-text-white" >No project selected. These are all the files you have access to.</p>`,
			},
			/* ----- end Tree View ----- */
		],
	Renderables:
		[
			{
				RenderableHash: 'ProjectFileSearch-Wrapper',
				TemplateHash: 'ProjectFileSearch-Wrapper',
				DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
			},
			{
				RenderableHash: 'ProjectFileSearch-Entry-ProjectSelector',
				TemplateHash: 'ProjectFileSearch-Entry-ProjectSelector',
				DestinationAddress: '#ProjectFileSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				TemplateHash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#ProjectFileSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'ProjectFileSearch-Results',
				TemplateHash: 'ProjectFileSearch-Results',
				DestinationAddress: '#ProjectFileSearch-Results-Container',
			},
			{
				RenderableHash: 'ProjectFileSearch-Pagination',
				TemplateHash: 'ProjectFileSearch-Pagination',
				DestinationAddress: '#ProjectFileSearch-Pagination-Container',
			},
		],
};

},{"pict-view":693}],807:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class QRPanel extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.samples = [];
		this.location = null;
		this.cameraOpen = false;
		this.removeFromCurrentLocation = pOptions.removeFromCurrentLocation ?? false;
		this.toggleRunning = false;

		this.pict.MetaTemplate.addPattern('{~ParentLocation:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpRecord?.ParentLocation ? `<b>Linked to Location:</b> ${ tmpRecord.ParentLocation.Name }` : '';
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.cameraOpen)
		{
			this.cameraOpen = false;
			this.pict.providers.QRCodeProvider.closeScanner().catch((e) =>
			{
				console.log('Error stopping qr code scanner: ', e);
			}).finally(() =>
			{
				this.toggleCamera();
			});
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Opens the scanner in the left hand panel.
	 */
	open()
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('QRPanel', 'open');
		this.pict.views.HeadlightPanels.setPanelCustomWidth('left', 40);
		this.samples = [];
		this.location = null;
		this.pict.providers.QRCodeProvider.startWorkflow(this.qrEventHandler);
	}

	closeHandler()
	{
		console.log('Closing QR Code Panel.');
		this.samples = [];
		this.location = null;
		this.cameraOpen = false;
		this.pict.providers.QRCodeProvider.stopWorkflow();
		this.pict.providers.QRCodeProvider.closeScanner();
	}

	qrEventHandler = async (e) =>
	{
		console.log('[QRPanel] Received QREvent: ', e);
		if (e.event === 'scanned-Sample')
		{
			if (e.payload.IDSample && !this.samples.map((s) => s.IDSample).includes(e.payload.IDSample))
			{
				this.samples.push(e.payload);
				this.renderAsync();
			}
		}
		if (e.event === 'scanned-Location')
		{
			if (e.payload.IDLocation && this.location?.IDLocation !== e.payload.IDLocation)
			{
				this.location = e.payload;
				this.renderAsync();
			}
		}
		if (e.event === 'submit')
		{
			this.handleSubmit();
		}
		if (e.event === 'clear')
		{
			this.handleClear();
		}
	};

	/**
	 * Removes a sample from the cart by ID.
	 * @param {Number} IDSample
	 */
	removeSample(IDSample)
	{
		this.samples = this.samples.filter((s) =>
		{
			return s.IDSample !== IDSample;
		});
		this.renderAsync();
	}

	/**
	 * Clears the cart.
	 */
	handleClear()
	{
		this.location = null;
		this.samples = [];
		this.renderAsync();
	}

	/**
	 * Updates the cart of samples to the new selected location.
	 */
	async handleSubmit()
	{
		if (this.location?.IDLocation && this.samples?.length)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Updating location for all samples in cart...',
				type: 'is-success',
			});
			try
			{
				for (const s of this.samples)
				{
					await this.pict.providers.LocationProvider.addSampleToLocation(s.IDSample, this.location.IDLocation);
					if (this.removeFromCurrentLocation)
					{
						const currentSampleLocations = await this.pict.providers.LocationProvider.getLocationsBySampleID(s.IDSample);
						for (const l of currentSampleLocations)
						{
							if (l.IDLocation !== this.location.IDLocation)
							{
								await this.pict.providers.LocationProvider.removeSamplefromLocation(s.IDSample, l.IDLocation);
							}
						}
					}
					const tmpLogMessage = `Sample Location updated to ${ this.location.Name }`;
					const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();
					const tmpOptions = {
						IDSample: s.IDSample,
						CaptureLatitude: geoCoords.CaptureLatitude || s.CaptureLatitude,
						CaptureLongitude: geoCoords.CaptureLongitude || s.CaptureLongitude,
						Notes: tmpLogMessage,
					};
					await this.pict.providers.SampleLogProvider.createSampleLog(tmpOptions);
				}
				this.location = null;
			}
			catch (e)
			{
				console.log('Error adding Sample to Location: ', e);
				this.pict.views.HeadlightPanels.toast({
					message: 'Update Failed',
					type: 'is-danger',
				});
			}
		}
		this.renderAsync();
	}

	/**
	 * Opens the camera scanner.
	 */
	async toggleCamera()
	{
		// Don't run this function again until the ui transition is finished.
		if (this.toggleRunning)
		{
			return;
		}
		this.toggleRunning = true;
		this.cameraOpen = !this.cameraOpen;
		if (this.cameraOpen)
		{
			try
			{
				await this.pict.providers.QRCodeProvider.openScanner('QRPanel-ScannerBox', { isPhoneDevice: this.pict.services.HeadlightPanels.isPhoneDevice });
			}
			catch (e)
			{
				console.log('Error starting qr code scanner: ', e);
			}
			document.querySelector('#QRPanel-ScannerBox-Outer').classList.remove('is-hidden');
			document.querySelector('#QRPanel-CameraButton').classList.add('is-close-button');
		}
		else
		{
			try
			{
				await this.pict.providers.QRCodeProvider.closeScanner();
			}
			catch (e)
			{
				console.log('Error starting qr code scanner: ', e);
			}
			document.querySelector('#QRPanel-ScannerBox-Outer').classList.add('is-hidden');
			document.querySelector('#QRPanel-CameraButton').classList.remove('is-close-button');
		}
		this.toggleRunning = false;
	}

	printUtilityCodes()
	{
		const modalTemplate = /*html*/`
			<div id="HeadlightPanels-QRPanel-Modal-Content">
				<style>
					.centered-modal-content
					{
						display: flex;
						justify-content: center;
					}
				</style>
				<div class="panel-content panel-with-tabs-offset centered-modal-content">
					<button id="QRPanel-OpenPrint" class="button is-primary mt-2" onclick="_Pict.providers.QRCodeProvider.print('action/open/cart', { printStyle: 'thin', raw: true, footers: ['HLLOGO Open Scanning Cart']});">
						<span class="icon mr-3">
							<i class="fas fa-fw fa-cart-shopping"></i>
						</span>
						<span class="icon-text">Print "Open Cart" Code</span>
					</button>
					<button id="QRPanel-ClearPrint" class="button is-primary ml-2 mt-2" onclick="_Pict.providers.QRCodeProvider.print('action/clear', { printStyle: 'thin', raw: true, footers: ['HLLOGO Clear Scanning Cart']});">
						<span class="icon mr-3">
							<i class="fas fa-fw fa-cart-circle-xmark"></i>
						</span>
						<span class="icon-text">Print "Clear Cart" Code</span>
					</button>
					<button id="QRPanel-SubmitPrint" class="button is-primary ml-2 mt-2" onclick="_Pict.providers.QRCodeProvider.print('action/submit', { printStyle: 'thin', raw: true, footers: ['HLLOGO Submit Scanning Cart']});">
						<span class="icon mr-3">
							<i class="fas fa-fw fa-cart-shopping-fast"></i>
						</span>
						<span class="icon-text">Print "Submit" Code</span>
					</button>
				</div>
			</div>
		`;
		const printModalOptions = {
			title: 'Print Utility QR Codes',
			modalBodyTemplate: modalTemplate,
			modalFooterTemplate: /*html*/`
				<div class="columns">
					<div id="Footer-ButtonGroup" class="buttons is-right">
						<button id="Footer-Button-Cancel" type="button" class="button is-link is-soft" onclick="_Pict.fable.HeadlightModal.cancelCallback()">
							<span class="icon"><i class="fas fa-fw fa-times"></i></span>
							<span> Close </span>
						</button>
					</div>
				</div>
			`,
			confirmText: '',
			style: 'wide',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(printModalOptions);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} [event] - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
	}

	/**
	 * Callback to return scanned result object from a successful scan. Other views can use this to quickly get scanned results when they don't care about the cart and just want a scan result.
	 * @param {Object} e - The scanned event object
	 * @return {Promise<Object|null>} - A promise that resolves to the scanned sample object or null if not valid
	 */
	returnScannedResultsObject = async (e) =>
	{
		console.log('[QRPanel] Received QREvent: ', e);
		if (e.event === 'scanned-Sample')
		{
			if (e.payload.IDSample)
			{
				return e.payload;
			}
		}
		return null;
	};

	/**
	 * Print an entity's QR label, loading the customer's label configuration first.
	 *
	 * Without the ensure these buttons print the built-in fallback layout: the panels app never loaded the
	 * printable manifests, so QRCodeProvider.typeConfig was empty and per-customer printer configuration
	 * (PrintStyle, title, field rows/columns) was silently ignored.
	 * @param {String} pEntity - The entity type being printed ('Sample' | 'Location')
	 * @param {String} pQRCode - The entity's QR code
	 * @return {Promise<void>}
	 * @async
	 */
	async printEntityLabel(pEntity, pQRCode)
	{
		if (!pQRCode)
		{
			return;
		}
		await this.pict.providers.QRCodeProvider.ensurePrintableManifests();
		this.pict.providers.QRCodeProvider.printDecoratedEntity(pEntity, pQRCode);
	}
}

module.exports = QRPanel;

module.exports.default_configuration =
{
	ViewIdentifier: 'QRPanel',
	DefaultRenderable: 'QRPanel',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'QRPanel-Wrapper',
			Template: /*html*/`
				<article id="HeadlightPanels-QRPanel" class="panel is-active">
					<style>
						.cart-remove
						{
							width: 30px;
							height: 100%;
							display: flex;
							flex-direction: column; 
							justify-content: center;
							background-color: var(--panels-content-block-divider-color);
							color: white;
							position: absolute;
							align-items: center;
							cursor: pointer;
						}
						.cart-remove:hover
						{
							background-color: var(--bulma-danger);
						}
						.clear-cart
						{
							border: 1px solid #3d3d3d;
							color: white;
							background-color: var(--panels-content-block-divider-color);
						}
						.clear-cart:hover
						{
							background-color: var(--bulma-danger);
						}
					</style>
					<p id="HeadlightPanels-QRPanel-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
							onclick="_Pict.views.QRPanel.handleClosePanelEvent(event)">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-QRPanel-Header-Icon" class="fas fa-fw fa-qrcode" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-QRPanel-Header-Title" class="mr-3">Scanning Cart</span>
					</p>
					<style>
						.sample-container {
							overflow: scroll;
						}
						.panel-content-samples {
							max-height: calc(100vh - var(--panels-header-height) - var(--panels-navbar-height)) !important;
							overflow-y: scroll !important;
						}
						.icon-text-for-open-button
						{
							display: inline;
						}
						.icon-text-for-close-button
						{
							display: none;
						}
						.is-close-button .icon-text-for-close-button
						{
							display: inline;
						}
						.is-close-button .icon-text-for-open-button
						{
							display: none;
						}
					</style>
					<div id="HeadlightPanels-QRPanel-Samples-Content" class="panel-content panel-content-samples panel-has-nested-scroll-content">
						<div class="columns m-0 is-mobile">
							<div class="column is-6">
								<button type="button" id="QRPanel-CameraButton" class="button is-primary is-fullwidth" onclick="_Pict.views.QRPanel.toggleCamera()">
									<span class="icon mr-3">
										<i class="fas fa-fw fa-camera-viewfinder"></i>
									</span>
									<span class="icon-text icon-text-for-open-button">Open Camera</span>
									<span class="icon-text icon-text-for-close-button">Close Camera</span>
								</button>
							</div>
							<div class="column is-6">
								<button type="button" title="Removes everything from cart" onclick="_Pict.views.QRPanel.handleClear()" class="button is-fullwidth is-primary is-dark">
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-circle-xmark"></i>
									</span>
									<span class="icon-text">Clear Cart</span>
								</button>
							</div>
						</div>
						<div class="columns m-0 is-mobile">
							<div class="column pt-1 is-12">
								<button type="button" title="Updates Sample Locations" onclick="_Pict.views.QRPanel.handleSubmit()" class="button is-success is-fullwidth">
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-shopping-fast"></i>
									</span>
									<span class="icon-text">Submit (Updates Sample Locations)</span>
								</button>
							</div>								
						</div>
						<div id="QRPanel-SampleScan-Container" class="has-background-text-35 has-text-white" style="max-height: 50vh; overflow-y: scroll;">
							<style>
								@media screen and (max-width: 768px) {
									#QRPanel-ScannerBox__scan_region > video {
										max-height: 180px;
										object-fit: cover;
									}
								}
							</style>
							<div id="QRPanel-ScannerBox-Outer" class="is-hidden">
								<div id="QRPanel-ScannerBox"></div>
							</div>
						</div>
						<div id="QRPanel-Location-Items" class="mt-2">
							{~TIfAbs:QRPanel-Location-NoItem:Context[0].location:Context[0].location^<=^0~}
							{~TIfAbs:QRPanel-Location-Item:Context[0].location:Context[0].location^>^0~}
						</div>
						<div id="Sample-Container" class="sample-container">{~T:QRPanel-Sample-List:Context[0].samples~}</div>
					</div>
				</article>
			`,
		},
		{
			Hash: 'QRPanel-Sample-List',
			Template: /*html*/`
				{~TIfAbs:QRPanel-Sample-Items:Record:Record.length^>^0~}`,
		},
		{
			Hash: 'QRPanel-Sample-Items',
			Template: /*html*/`
			<div id="QRPanel-Sample-Items" class="nested-scroll-content panel-views-height-offset has-sample-header-offset mt-3">
				{~TS:QRPanel-Sample-Item:Record~}
			</div>`,
		},
		{
			Hash: 'QRPanel-Sample-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0">
				<div class="cart-remove" title="Remove Sample from Cart" onclick="_Pict.views.QRPanel.removeSample({~D:Record.IDSample~})">
					<i class="fas fa-fw fa-circle-xmark"></i>
				</div>
				<figure class="image" style="margin-left: 30px;">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Geolocation for sample" />
				</figure>
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div><b>Sample</b> {~D:Record.Name~}</div>
					<div class="is-size-7 has-text-text-75"><b>Code:</b> {~D:Record.QRCode~} - <b>Status:</b> {~D:Record.Status~}</div>
					<div class="is-size-7 has-text-text-75"><b>Project:</b> {~Entity:Project^Record.IDProject^QRPanel-Item-Project^~}</div>
					<div class="is-size-7 has-text-text-75">
						<span class="has-text-text-60"><b class="has-text-text-80">Created</b> on</span>
						<span class="has-text-text-80">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-60">by</span>
						<span class="has-text-text-80">{~Entity:User^Record.CreatingIDUser^QRPanel-Item-User^~}</span>
					</div>
				</div>
				<button title="Print QR Code" onclick="_Pict.views.QRPanel.printEntityLabel('Sample', '{~D:Record.QRCode~}');" style="transform: translateY(-25px); right: 10px;" class="button is-primary"><span class="icon"><i class="fas fa-fw fa-print"></i></span></button>
			</div>`,
		},
		{
			Hash: 'QRPanel-Location-NoItem',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0" style="height: 120px; background-color: rgb(0, 0, 0, 0.2);">
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div class="has-text-centered">
						<span class="icon">
							<i class="fa fa-info-circle"></i>
						</span>
						<span class="icon-text">No Location Scanned</span>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'QRPanel-Location-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0" style="height: 120px; background-color: rgb(0, 0, 0, 0.2);">	
			<figure class="image">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Map for this Location" />
				</figure>
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div><b>Location</b> {~D:Record.Name~}</div>
					<div class="is-size-7 has-text-text-75"><b>Description:</b> {~D:Record.Description~}</div>
					<div class="is-size-7 has-text-text-75"><b>Address:</b></div>
					<div class="is-size-7 has-text-text-75">{~D:Record.Address:No Address~}</div>
					<div class="is-size-7 has-text-text-75">{~D:Record.City:No City~}, {~D:Record.State:No State~}</div>
					<div class="is-size-7 has-text-text-75">{~ParentLocation:Record~}</div>
				</div>
				<button title="Print QR Code" onclick="_Pict.views.QRPanel.printEntityLabel('Location', '{~D:Record.QRCode~}');" style="transform: translateY(-30px); right: 10px;" class="button is-primary"><span class="icon"><i class="fas fa-fw fa-print"></i></span></button>
			</div>`,
		},
		{
			Hash: 'QRPanel-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'QRPanel-Item-Project',
			Template: /*html*/`{~D:Record.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'QRPanel',
			TemplateHash: 'QRPanel-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":693}],808:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// TODO: could we make this 'ActiveSampleRecord' and use to edit samples too?
		this.CurrentSampleRecord = {};
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// set the customer ID if it exists
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser.CustomerID || 0;
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Enter a project...',
			ElementID: 'SampleCreate-Entry-Project',
			ParentID: 'SampleCreate-Container',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// MATERIAL Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a material..',
			ElementID: 'SampleCreate-Entry-Material',
			ParentID: 'SampleCreate-Container',
			URL: 'Materials',
			IDField: 'IDMaterial',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Materials initialized');
		});

		// MIX Design Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a mix Design...',
			ElementID: 'SampleCreate-Entry-MixDesign',
			ParentID: 'SampleCreate-Container',
			URL: 'MixDesigns',
			IDField: 'IDMixDesign',
			TextField: 'MixID',
		}, () =>
		{
			this.log.info('Select2 Mix Designs initialized');
		});

		// PRODUCER Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a producer...',
			ElementID: 'SampleCreate-Entry-Producer',
			ParentID: 'SampleCreate-Container',
			URL: 'Organizations',
			IDField: 'IDOrganization',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Producers initialized');
		});

		// PRODUCT Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a product...',
			ElementID: 'SampleCreate-Entry-Product',
			ParentID: 'SampleCreate-Container',
			URL: 'Products',
			IDField: 'IDProduct',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Products initialized');
		});

		// PLANT Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a plant...',
			ElementID: 'SampleCreate-Entry-Plant',
			ParentID: 'SampleCreate-Container',
			URL: 'ProductionPlants',
			IDField: 'IDProductionPlant',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Plants initialized');
		});

		// LAB Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a lab...',
			ElementID: 'SampleCreate-Entry-Lab',
			ParentID: 'SampleCreate-Container',
			URL: 'Labs',
			IDField: 'IDLab',
			TextField: 'Name',
			minimumInputLength: 0,
		}, () =>
		{
			this.log.info('Select2 Labs initialized');
		});

		//  DESIGNATEDDATE date picker
		window.flatpickr('#SampleCreate-Entry-Date', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleCreate-Date');
			},
		});

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.SampleCreate.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.SampleCreate.CurrentSearchFilters.PageSize : data.length === _Pict.views.SampleCreate.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method updates the current sample record with the value of the specified field.
	 * @param {string} id - The id of the element to get the value from.
	 * @param {string} pField - The field to update in the current sample record.
	 * @return {void}
	 */
	handleNewSampleRecordChange(id, pField)
	{
		const tmpElement = document.getElementById(id);
		if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLTextAreaElement || tmpElement instanceof HTMLSelectElement)
		{
			this.CurrentSampleRecord[pField] = tmpElement.value;
			this.log.info(`Current Sample Record updated: ${pField} = ${this.CurrentSampleRecord[pField]}`);
		}
	}

	/**
	 * This method clears the current sample record.
	 * @return {void}
	 */
	clearSample()
	{
		this.CurrentSampleRecord = {};
		this.renderAsync(() =>
		{
			this.log.info('Sample Create view cleared');
		});
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.CurrentSampleRecord));

		const tmpSampleRecord = {};
		Object.keys(this.CurrentSampleRecord).forEach((pKey) =>
		{
			switch (pKey)
			{
			case 'Date':
				tmpSampleRecord.DesignatedTime = this.CurrentSampleRecord.Date ? this.fable.Dates.dayJS(this.CurrentSampleRecord.Date).toISOString() : null;
				break;
			case 'Project':
				tmpSampleRecord.IDProject = this.CurrentSampleRecord.Project;
				break;
			case 'Material':
				tmpSampleRecord.IDMaterial = this.CurrentSampleRecord.Material;
				break;
			case 'MixDesign':
				tmpSampleRecord.IDMixDesign = this.CurrentSampleRecord.MixDesign;
				break;
			case 'Producer':
				tmpSampleRecord.IDOrganization = this.CurrentSampleRecord.Producer;
				break;
			case 'Product':
				tmpSampleRecord.IDProduct = this.CurrentSampleRecord.Product;
				break;
			case 'Plant':
				tmpSampleRecord.IDProductionPlant = this.CurrentSampleRecord.Plant;
				break;
			case 'Quantity':
				tmpSampleRecord.RepresentedQuantity = this.CurrentSampleRecord.Quantity;
				break;
			case 'Units':
				tmpSampleRecord.RepresentedQuantityUnits = this.CurrentSampleRecord.Units;
				break;
			case 'Notes':
				tmpSampleRecord.Notes = this.CurrentSampleRecord.Notes;
				break;
			case 'Name':
				tmpSampleRecord.Name = this.CurrentSampleRecord.Name;
				break;
			case 'IntendedUse':
				tmpSampleRecord.IntendedUse = this.CurrentSampleRecord.IntendedUse;
				break;
			case 'ManufacturerCode':
				tmpSampleRecord.ManufacturerCode = this.CurrentSampleRecord.ManufacturerCode;
				break;
			case 'Lab':
				// TODO: Lab is not set on the record?, may have to remove this line
				//tmpSampleRecord.IDLab = this.CurrentSampleRecord.Lab;
				break;
			case 'SampleType':
				// TODO: SampleType is not set on the record?, may have to remove this line
				//tmpSampleRecord.SampleType = this.CurrentSampleRecord.SampleType;
				break;
			default:
				tmpSampleRecord[pKey] = this.CurrentSampleRecord[pKey];
				break;
			}
		});

		try
		{
			const pResult = await this.pict.providers.SampleProvider.createSample(tmpSampleRecord);
			this.log.info('Sample created, going to the Details view...');

			// if we are in add mode, we need to update the selector to show the new sample
			// NOTE: Need to do this first before we swap panels since Details view doesn't have an "add mode" (yet)
			if (this.pict.ContentAssignment.readAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode') === 'add-to-set')
			{
				// TODO: This assumes search panel is already rendered, which it is, but we should revisit if we change that
				this.pict.views.SampleSearch.sampleSelectionCallback(pResult);
				this.pict.views.HeadlightPanels.closeAllPanels();
				this.pict.views.HeadlightPanels.toast({ message: 'Sample created and added to the input selector.', type: 'is-success' });
			}

			// show the details view for the new sample
			this.pict.views.SampleDetails.showSampleDetailView(pResult.IDSample, null, 'Details');
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
		}
	}
}

module.exports = SampleCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleCreate',
	DefaultRenderable: 'SampleCreate',
	DefaultDestinationAddress: '#SampleCreate-Container',
	Templates:
	[
		{
			Hash: 'SampleCreate',
			Template: /*html*/`
			{~T:SampleCreate-Entry~}`,
		},
		{
			Hash: 'SampleCreate-Entry',
			Template: /*html*/`
			<form id="SampleCreate-Form" onsubmit="_Pict.views.SampleCreate.createNewSample(event)">
				<div class="columns px-4 my-0">
					{~T:SampleCreate-Entry-NameInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ProjectSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-MixDesignSelector~}
					{~T:SampleCreate-Entry-MaterialSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ProducerSelector~}
					{~T:SampleCreate-Entry-ProductSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-PlantSelector~}
					{~T:SampleCreate-Entry-QuantityInput~}
					{~T:SampleCreate-Entry-UnitsInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ManufacturerCodeInput~}
					{~T:SampleCreate-Entry-IndendedUseInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-NotesInput~}
				</div>
				<div class="columns px-4 mb-0 mt-1">
					<div class="column">
						<div class="buttons is-right">
							<button type="button" class="button is-primary is-soft" title="Clear sample" onclick="_Pict.views.SampleCreate.clearSample()">
								<span class="icon">
									<i class="fa fa-fw fa-refresh"></i>
								</span>
								<span class="icon-text">Clear</span>
							</button>
							<button type="submit" class="button is-primary" title="Create new sample">
								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span class="icon-text">Create New Sample</span>
							</button>
						</div>
					</div>
				</div>
			</form>`,
		},
		{
			Hash: 'SampleCreate-Entry-NameInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Name">Sample Name</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Name" 
							class="input" 
							type="text" 
							placeholder="Enter a name for the sample..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Name')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-DateInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Date">Sample Date</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Date" 
							class="input" 
							type="date" 
							placeholder="Enter a date for the sample..." 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Date')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-SampleTypeInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-SampleType">Sample Type</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-SampleType" 
							class="input" 
							type="text" 
							value="Acceptance" 
							placeholder="Enter a type for the sample..."
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'SampleType')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-QuantityInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Quantity">Rep. Quantity</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Quantity" 
							class="input" 
							type="number" 
							value="0.000" 
							placeholder="Enter a Quantity for the sample..." 
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Quantity')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-UnitsInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Units">Units</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Units" 
							class="input" 
							type="text" 
							value="" 
							placeholder="Variable Units (English)"
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Units')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ManufacturerCodeInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-ManufacturerCode">Manufacturer Code</label>
					<div class="control">
						<input
							id="SampleCreate-Entry-ManufacturerCode"
							class="input"
							type="text"
							value=""
							placeholder="Enter a manufacturer code..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'ManufacturerCode')"
							/>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-IndendedUseInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-IndendedUse">Intended Use</label>
					<div class="control">
						<input
							id="SampleCreate-Entry-IndendedUse"
							class="input"
							type="text"
							value=""
							placeholder="Enter the intended use..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'IntendedUse')"
							/>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-NotesInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Notes">Notes</label>
					<div class="control">
						<textarea 
							id="SampleCreate-Entry-Notes" 
							class="textarea" 
							placeholder="Enter any notes for the sample..."
							rows="2" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Notes')"
						></textarea>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProjectSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Project">Project</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-Project" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Project')"
						>{~TS:SampleCreate-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Enty-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-MaterialSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Material">Material</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-Material" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Material')"
						>{~TS:SampleCreate-Entry~MaterialSelector-SelectedOptions:Context[0].CurrentSearchFilters.Material~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-MaterialSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDMaterial~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-MixDesignSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-MixDesign">Mix Designs</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-MixDesign" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'MixDesign')"
						>{~TS:SampleCreate-Entry~MixDesignSelector-SelectedOptions:Context[0].CurrentSearchFilters.MixDesign~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-MixDesignSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDMixDesign~}" selected>{~D:Record.MixID~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProducerSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Producer">Producer</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Producer"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Producer')"
						>{~TS:SampleCreate-Entry~ProducerSelector-SelectedOptions:Context[0].CurrentSearchFilters.Producer~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProducerSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDOrganization~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProductSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Product">Product</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Product"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Product')"
						>{~TS:SampleCreate-Entry~ProductSelector-SelectedOptions:Context[0].CurrentSearchFilters.Product~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProductSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProduct~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-PlantSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Plant">Plant</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Plant"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Plant')"
						>{~TS:SampleCreate-Entry~PlantSelector-SelectedOptions:Context[0].CurrentSearchFilters.Plant~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-PlantSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProductionPlant~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-LabSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Lab">Destination Lab</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Lab"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Lab')"
						>{~TS:SampleCreate-Entry~LabSelector-SelectedOptions:Context[0].CurrentSearchFilters.Lab~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-LabSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDLab~}" selected>{~D:Record.Name~}</option>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleCreate',
			TemplateHash: 'SampleCreate',
			DestinationAddress: '#SampleCreate-Container',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":693}],809:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
 * The "Current" tab of the Samples panel: the Samples joined to the document being edited.
 *
 * Selecting a row opens the existing Sample Details panel on the RIGHT while this list stays open on
 * the left, so the list and the selected sample's Details/Location/Logs/Print tabs are visible together.
 * That split is why `sampledetails` is configured `location: "right"` (mirroring observations /
 * observationdetails) rather than replacing this panel.
 */
class SampleCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {Array<Object>} Samples joined to the current document. */
		this.CurrentSamples = [];
		/** @type {number|string|null} The row currently open in the Sample Details panel. */
		this.ActiveIDSample = null;
		/** @type {'loading'|'items'|'empty'} Drives which of the three list states the template paints. */
		this.ListState = 'loading';
	}

	/**
	 * Run when the Current tab is activated: load the per-customer print configuration (once) and
	 * refresh the list. Deliberately not done at panel render time — a document whose user never opens
	 * this tab should not pay for either.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleTabOpened()
	{
		await this.pict.providers.QRCodeProvider.ensurePrintableManifests();
		await this.refreshCurrentSamples();
	}

	/**
	 * Fetch the Samples joined to the current document and repaint the list.
	 * @return {Promise<void>}
	 * @async
	 */
	async refreshCurrentSamples()
	{
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (!tmpIDDocument)
		{
			this.CurrentSamples = [];
		}
		else
		{
			try
			{
				const tmpSamples = await this.pict.providers.SampleProvider.getDocumentJoinedSamples(tmpIDDocument);
				// Sample.Name is very often just the QR code again; only carry it when it adds something.
				this.CurrentSamples = tmpSamples.map((pSample) => Object.assign({}, pSample,
					{ _DisplayName: (pSample.Name && pSample.Name !== pSample.QRCode) ? pSample.Name : '' }));
			}
			catch (pError)
			{
				this.log.error(`Failed to load the Samples joined to document ${tmpIDDocument}.`, pError);
				this.CurrentSamples = [];
			}
		}
		this.ListState = this.CurrentSamples.length > 0 ? 'items' : 'empty';
		return new Promise((resolve) =>
		{
			this.renderAsync(() =>
			{
				this._paintActiveRow();
				resolve();
			});
		});
	}

	/**
	 * Open a Sample in the Sample Details panel (right side) and mark its row active here.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to open
	 * @return {void}
	 */
	selectSample(event, pIDSample)
	{
		if (!pIDSample)
		{
			return;
		}
		this.ActiveIDSample = pIDSample;
		this._paintActiveRow();
		const tmpSampleRecord = this.CurrentSamples.find((pSample) => String(pSample.IDSample) === String(pIDSample));
		// so the Details panel's back button returns here rather than to Search
		this.pict.views.SampleDetails.SampleDetailsBackTo = 'Current';
		this.pict.views.SampleDetails.showSampleDetailView(pIDSample, tmpSampleRecord, 'Details');
	}

	/**
	 * Print the QR label for a Sample. Same call the Sample Details Print tab uses, minus the preview
	 * container -- omitting it sends the label to the printer instead of rendering it inline.
	 * @param {Event} event - The click event
	 * @param {string} pQRCode - The Sample QR code
	 * @return {void}
	 */
	printSample(event, pQRCode)
	{
		if (event)
		{
			// the row itself opens the details panel; printing should not also do that
			event.stopPropagation();
		}
		if (!pQRCode)
		{
			return;
		}
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', pQRCode);
	}

	/**
	 * Open a Sample straight to its Print tab, where the label preview renders.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to preview
	 * @return {void}
	 */
	previewSample(event, pIDSample)
	{
		this._openSampleOnTab(event, pIDSample, 'Print');
	}

	/**
	 * Open a Sample straight to its Logs tab.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to open
	 * @return {void}
	 */
	openSampleLogs(event, pIDSample)
	{
		this._openSampleOnTab(event, pIDSample, 'Logs');
	}

	/**
	 * Shared row-action path: mark the row active and open Sample Details on a given tab.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to open
	 * @param {string} pTab - The Sample Details tab to open
	 * @return {void}
	 */
	_openSampleOnTab(event, pIDSample, pTab)
	{
		if (event)
		{
			// the row itself opens the Details tab; a row-action button picks its own
			event.stopPropagation();
		}
		if (!pIDSample)
		{
			return;
		}
		this.ActiveIDSample = pIDSample;
		this._paintActiveRow();
		const tmpSampleRecord = this.CurrentSamples.find((pSample) => String(pSample.IDSample) === String(pIDSample));
		this.pict.views.SampleDetails.SampleDetailsBackTo = 'Current';
		this.pict.views.SampleDetails.showSampleDetailView(pIDSample, tmpSampleRecord, pTab);
	}

	/**
	 * Move the `is-active` highlight onto the row for ActiveIDSample. Re-applied after every render,
	 * since rendering replaces the row elements.
	 * @return {void}
	 */
	_paintActiveRow()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const tmpRows = document.querySelectorAll('[data-sample-current-id]');
		tmpRows.forEach((pRow) =>
		{
			const tmpIsActive = this.ActiveIDSample != null &&
				pRow.getAttribute('data-sample-current-id') === String(this.ActiveIDSample);
			pRow.classList.toggle('is-active', tmpIsActive);
		});
	}
}

module.exports = SampleCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleCurrent',
	DefaultRenderable: 'SampleCurrent-List',
	DefaultDestinationAddress: '#SampleCurrent-Container',
	Templates:
	[
		{
			Hash: 'SampleCurrent-List',
			Template: /*html*/`
			<div id="SampleCurrent-List">
				{~TIfAbs:SampleCurrent-Loading:Context[0]:Context[0].ListState^===^loading~}
				{~TIfAbs:SampleCurrent-Items:Context[0].CurrentSamples:Context[0].ListState^===^items~}
				{~TIfAbs:SampleCurrent-Empty:Context[0]:Context[0].ListState^===^empty~}
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Loading',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left p-5">
				<div class="has-text-centered has-text-text-75" style="flex-grow: 1">
					<span class="icon"><i class="fa fa-fw fa-spinner fa-pulse"></i></span>
					<span class="icon-text">Loading samples&hellip;</span>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Empty',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left p-5">
				<div class="has-text-centered" style="flex-grow: 1">
					<span class="icon"><i class="fa fa-fw fa-vial"></i></span>
					<span class="icon-text">No samples are attached to this document yet.</span>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Items',
			Template: /*html*/`
			<div id="SampleCurrent-Items" class="nested-scroll-content">
				{~TS:SampleCurrent-Item:Record~}
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0 is-clickable"
				data-sample-current-id="{~D:Record.IDSample~}"
				title="Open this sample's details"
				onclick="_Pict.views.SampleCurrent.selectSample(event, '{~D:Record.IDSample~}')">
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div>
						<span class="icon"><i class="fas fa-fw fa-qrcode"></i></span>
						<b>{~D:Record.QRCode~}</b>
						<span class="has-text-text-75">{~D:Record._DisplayName~}</span>
					</div>
					<div class="is-size-7 has-text-text-75">{~StatusPill:Record.Status~}</div>
					<div class="is-size-7 has-text-text-75"><b>Material:</b> {~Entity:Material^Record.IDMaterial^SampleCurrent-Item-Material^~}</div>
					<div class="is-size-7 has-text-text-75"><b>Project:</b> {~Entity:Project^Record.IDProject^SampleCurrent-Item-Project^~}</div>
					<div class="is-size-7 has-text-text-75">
						<span class="has-text-text-60"><b class="has-text-text-80">Created</b> on</span>
						<span class="has-text-text-80">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-60">by</span>
						<span class="has-text-text-80">{~Entity:User^Record.CreatingIDUser^SampleCurrent-Item-User^~}</span>
					</div>
				</div>
				<div class="buttons are-small mr-3 my-2">
					<button type="button" class="button is-soft is-primary" title="Open this sample's logs"
						onclick="_Pict.views.SampleCurrent.openSampleLogs(event, '{~D:Record.IDSample~}')">
						<span class="icon"><i class="fas fa-fw fa-list-timeline"></i></span>
					</button>
					<button type="button" class="button is-soft is-primary" title="Preview the QR code label"
						onclick="_Pict.views.SampleCurrent.previewSample(event, '{~D:Record.IDSample~}')">
						<span class="icon"><i class="fas fa-fw fa-print-magnifying-glass"></i></span>
					</button>
					<button type="button" class="button is-primary" title="Print the QR code label"
						onclick="_Pict.views.SampleCurrent.printSample(event, '{~D:Record.QRCode~}')">
						<span class="icon"><i class="fas fa-fw fa-print"></i></span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Item-Material',
			Template: /*html*/`{~D:Record.Name:Unknown~}`,
		},
		{
			Hash: 'SampleCurrent-Item-Project',
			Template: /*html*/`{~D:Record.Name:Unknown~}`,
		},
		{
			Hash: 'SampleCurrent-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleCurrent-List',
			TemplateHash: 'SampleCurrent-List',
			DestinationAddress: '#SampleCurrent-Container',
		},
	],
};

},{"pict-view":693}],810:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveSampleDetails = {};
		this.ActiveSampleLogs = [];
		this.SampleDetailsBackTo = null;
	}

	async onRenderAsync(pCallback)
	{
		this.log.info('Sample Details view rendered with Active Record', this.ActiveSampleDetails);

		if (pCallback) pCallback();
	}

	/**
	 * Open the Sample detail view for the selected Sample to view the full details
	 * @param {number|string} pIDSample - The ID of the Sample to view
	 * @param {object} pSampleRecord - The Sample record to view
	 * @param {string} pOpenTab - The tab to open when the Sample detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showSampleDetailView(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		// if a Sample record is passed in, use it, otherwise get the Sample record by ID
		if (pSampleRecord)
		{
			this.ActiveSampleDetails = Array.isArray(pSampleRecord) ? pSampleRecord[0] : pSampleRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.SampleProvider.getSampleByID(pIDSample);
			this.ActiveSampleDetails = tmpRecord;
		}
		// if the Sample record is not found, log an error and return
		if (!this.ActiveSampleDetails)
		{
			this.log.error('Sample record not found for ID', pIDSample);
			return;
		}
		else
		{
			// get the logs for the Sample
			const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.ActiveSampleDetails.IDSample);
			this.ActiveSampleLogs = tmpLogs;
		}
		// render the Sample detail view
		this.renderAsync(() =>
		{
			this.log.info('Sample Details View Rendered with Active Record', this.ActiveSampleDetails);
			// open the panel if it is not already open
			this.pict.views.HeadlightPanels.handlePanelToggle('SampleDetails', 'open');
			// set the active tab to the one passed in
			this.pict.views.HeadlightPanels.toggleTabContent(`HeadlightPanels-SampleDetailsPanel-${pOpenTab}`, 'SampleDetails');
			if (pOpenTab === 'Print')
			{
				this.renderPrintPreview();
			}
		});
	}

	open(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		this.resetSampleDetailsView();
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open');
		this.showSampleDetailView(pIDSample, pSampleRecord, pOpenTab);
	}

	/**
	 * This method resets the state of the Sample Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetSampleDetailsView()
	{
		this.log.info('Resetting Active Sample Details');
		this.ActiveSampleDetails = {};
	}

	/**
	 * This method returns the user to the Sample List view and resets the Sample Details view.
	 * This method is called when the user clicks the back button in the Sample Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		// TODO: probably should update this to use data state to track pinned open panels
		if (event && event.target instanceof HTMLElement && event.target.closest('.hl-panel-wrapper').classList.contains('pinned-open'))
		{
			this.log.info('Panel is pinned open, not going back to Sample List view');
			return;
		}
		this.resetSampleDetailsView();
		// go back to the search view if the user came from there
		switch (this.SampleDetailsBackTo)
		{
		case 'Search':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Search', 'Sample');
				this.pict.views.SampleSearch.updateWithSearchResults(this.pict.views.SampleSearch.CurrentSearchResults, this.pict.views.SampleSearch.CurrentSearchResults?.length);
			});
			break;
		case 'Scan':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Scan', 'Sample');
			});
			break;
		case 'Current':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample');
				this.pict.views.SampleCurrent.handleTabOpened();
			});
			break;
		case 'Create':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Create', 'Sample');
			});
			break;
		default:
			// close all panels and reset the Sample Details view (same as clicking the close button)
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.resetSampleDetailsView();
			break;
		}
	}

	/**
	 * This method is used to add a new log to the Sample and refresh the Sample Details view.
	 * @return {Promise<void>}
	 * @async
	 */
	async addNewLogToSample()
	{
		if (!this.ActiveSampleDetails)
		{
			this.log.error('No active Sample to add log to');
			return;
		}
		this.pict.ContentAssignment.addClass('#HeadlightPanels-SampleDetailsPanel-Logs-Add-Button', 'is-loading');
		this.log.info('Adding new log to Sample ID:', this.ActiveSampleDetails.IDSample);

		this.log.info('Attempting to fetch geolocation...');
		const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();

		if (geoCoords)
		{
			// If we got a geolocation, update the sampel with it.
			await this.pict.providers.SampleProvider.updateSample(
				{
					IDSample: this.ActiveSampleDetails.IDSample,
					CaptureLatitude: geoCoords.CaptureLatitude,
					CaptureLongitude: geoCoords.CaptureLongitude,
				},
			);
			this.ActiveSampleDetails.CaptureLatitude = geoCoords.CaptureLatitude;
			this.ActiveSampleDetails.CaptureLongitude = geoCoords.CaptureLongitude;
		}

		const tmpLogMessage = this.pict.ContentAssignment.readContent('#SampleDetails-Tab-Logs-CreateNewLog-Textarea');
		const tmpOptions = {
			IDSample: this.ActiveSampleDetails.IDSample,
			CaptureLatitude: this.ActiveSampleDetails.CaptureLatitude,
			CaptureLongitude: this.ActiveSampleDetails.CaptureLongitude,
			Notes: tmpLogMessage,
		};
		// go make the new log entry, then refresh the view
		await this.pict.providers.SampleLogProvider.createSampleLog(tmpOptions);
		this.log.info('Sample Log added to Sample', this.ActiveSampleDetails.IDSample);
		await this.showSampleDetailView(this.ActiveSampleDetails.IDSample, null, 'Logs');
	}

	/**
	 * This method is used to clear the new log entry field in the Sample Details view.
	 * @return {void}
	 */
	clearNewLogEntry()
	{
		this.pict.ContentAssignment.assignContent('#SampleDetails-Tab-Logs-CreateNewLog-Textarea', '');
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.ActiveSampleDetails)
		{
			this.log.error('No active Sample to print QR Code for');
			return;
		}
		this.log.info('Printing Sample Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.ActiveSampleDetails.QRCode);
	}

	/**
	 * Render the QR label preview into the Print tab.
	 *
	 * `printDecoratedEntity` with a previewID short-circuits the print dialog and paints the label into
	 * that container instead -- the same call the real print uses, so what is previewed is what prints.
	 * @return {Promise<void>}
	 * @async
	 */
	async renderPrintPreview()
	{
		if (!this.ActiveSampleDetails)
		{
			return;
		}
		// per-customer label layout, loaded lazily the first time a label is needed
		await this.pict.providers.QRCodeProvider.ensurePrintableManifests();
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.ActiveSampleDetails.QRCode, 'SampleDetails-PrintPreview');
	}

	/**
	 * This method is used to clear the QR Code label entry fields in the Sample Details view.
	 * @return {void}
	 */
	clearQRCodeLabel()
	{
		this.pict.ContentAssignment.assignContent('#SampleDetails-Tab-Print-HeaderText', '');
		this.pict.ContentAssignment.assignContent('#SampleDetails-Tab-Print-FooterText', '');
	}
}

module.exports = SampleDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleDetails',
	DefaultRenderable: 'SampleDetails',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'SampleDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-SampleDetailsPanel" class="panel is-active">
				<!-- Sample ID: {~D:Context[0].ActiveSampleDetails.IDSample~} -->
				<div id="HeadlightPanels-SampleDetailsPanel-Sample-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.SampleDetails.resetSampleDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-SampleDetailsPanel-Sample-Header-Icon" class="fas fa-fw fa-vial" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-SampleDetailsPanel-Sample-Header-Title" class="mr-3">Sample Details</span>
				</div>
				<!-- Sample Panel Tabs -->
				<div id="HeadlightPanels-SampleDetailsPanel-Tabs" class="panel-tabs pr-6">					
					<a id="HeadlightPanels-SampleDetailsPanel-Details-Tab" class="is-active" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Details', 'SampleDetails')">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span class="icon-text">
							Details
						</span>
					</a>
					<a id="HeadlightPanels-SampleDetailsPanel-Location-Tab" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Location', 'SampleDetails')">
						<span class="icon">
							<i class="fa fa-fw fa-location-pin"></i>
						</span>
						<span class="icon-text">
							Location
						</span>
					</a>
					<a id="HeadlightPanels-SampleDetailsPanel-Logs-Tab" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Logs', 'SampleDetails')">
						<span class="icon">
							<i class="fa fa-fw fa-list-timeline"></i>
						</span>
						<span class="icon-text">
							Logs
						</span>
					</a>
					<a id="HeadlightPanels-SampleDetailsPanel-Print-Tab" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Print', 'SampleDetails'); _Pict.views.SampleDetails.renderPrintPreview();">
						<span class="icon">
							<i class="fa fa-fw fa-qrcode"></i>
						</span>
						<span class="icon-text">
							Print
						</span>
					</a>
				</div>
				<!-- SampleDetails Panel Content -->
				<div id="HeadlightPanels-SampleDetailsPanel-Content" style="min-width:40vw" data-sample-id="{~D:Record.IDSample~}">
					{~T:SampleDetails-SampleHeader:Context[0].ActiveSampleDetails~}
					<!-- SampleDetails Content > Tab Details View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Details-Content" class="panel-content panel-with-tabs-offset-plus-sample-header">
						<div id="SampleDetails-Details-Container">{~T:SampleDetails-Tab-Details:Context[0].ActiveSampleDetails~}</div>
					</div>
					<!-- SampleDetails Content > Tab Location View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Location-Content" class="panel-content panel-with-tabs-offset-plus-sample-header">
						<div id="SampleDetails-Location-Container">{~T:SampleDetails-Tab-Location:Context[0].ActiveSampleDetails~}</div>
					</div>
					<!-- SampleDetails Content > Tab Logs View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Logs-Content" class="panel-content panel-with-tabs-offset-plus-sample-header panel-has-nested-scroll-content">
						<div id="SampleDetails-Logs-Container">{~T:SampleDetails-Tab-Logs:Context[0].ActiveSampleLogs~}</div>
					</div>
					<!-- SampleDetails Content > Tab Print View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Print-Content" class="panel-content panel-with-tabs-offset-plus-sample-header">
						<div id="SampleDetails-Print-Container">{~T:SampleDetails-Tab-Print:Context[0].ActiveSampleDetails~}</div>
					</div>
				</div>
			</article>`,
		},
		{
			Hash: 'SampleDetails-SampleHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-15 is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4 has-text-white">
						{~TIfAbs:SampleDetails-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-65 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
					<span class="label is-size-7 has-text-text-65 mb-0">Status:</p>
					{~StatusPill:Record.Status~}
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Details',
			Template: /*html*/`
			<div class="columns px-3 m-0 mt-3">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Created by</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-User:Record:Record.CreatingIDUser^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.CreatingIDUser^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Created on</span>
					<span class="subtitle is-6 has-text-text-90">
						{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Project</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Project:Record:Record.IDProject^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDProject^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Line Item</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-MixDesign:Record:Record.IDLineItem^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDLineItem^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Material Type</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Material:Record:Record.IDMaterial^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDMaterial^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Mix Design</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-MixDesign:Record:Record.IDMixDesign^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDMixDesign^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Producer</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Organization:Record:Record.IDOrganization^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDOrganization^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Product</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Product:Record:Record.IDProduct^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDProduct^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Production Plant</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-ProductionPlant:Record:Record.IDProductionPlant^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDProductionPlant^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Manufacturer Code</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-ManufacturerCode:Record:Record.ManufacturerCode^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.ManufacturerCode^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Intended Use</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-IntendedUse:Record:Record.IntendedUse^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.IntendedUse^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Represented Quantity</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-RepresentedQuantity:Record:Record.RepresentedQuantity^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.RepresentedQuantity^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Units</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-RepresentedQuantityUnits:Record:Record.RepresentedQuantityUnits^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-RepresentedQuantityUnits-Empty:Record:Record.RepresentedQuantityUnits^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Buy USA</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-BuyUSA-Yes:Record:Record.BuyUSA^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-BuyUSA-No:Record:Record.BuyUSA^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-65">Notes</span>
					<div class="subtitle is-6 has-text-text-90">
						{~T:SampleDetails-DatumValue-Notes:Record~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'SampleDetails-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'SampleDetails-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Sample #{~D:Record.IDSample~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-Status',
			Template: /*html*/`{~D:Record.Status~}`,
		},
		{
			// Remarks are authored as markdown (the test forms' RichText editor writes markdown into
			// Notes), so they are rendered rather than printed raw. The expression carries its own
			// empty case, which also fixes remarks that start with `#` or `-`: the comparison this
			// replaced sorted those below '0' and showed N/A for a note that was actually there.
			Hash: 'SampleDetails-DatumValue-Notes',
			Template: /*html*/`{~MarkdownRemarks:Record.Notes^SampleDetails-DatumValue-NA^~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-GeographicalArea',
			Template: /*html*/`{~D:Record.GeographicalArea~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-ManufacturerCode',
			Template: /*html*/`{~D:Record.ManufacturerCode~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-IntendedUse',
			Template: /*html*/`{~D:Record.IntendedUse~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-BuyUSA-Yes',
			Template: /*html*/`Yes`,
		},
		{
			Hash: 'SampleDetails-DatumValue-BuyUSA-No',
			Template: /*html*/`No`,
		},
		{
			Hash: 'SampleDetails-DatumValue-ProductName',
			Template: /*html*/`{~D:Record.ProductName~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-RepresentedQuantity',
			Template: /*html*/`{~D:Record.RepresentedQuantity~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-RepresentedQuantityUnits',
			Template: /*html*/`{~D:Record.RepresentedQuantityUnits~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-RepresentedQuantityUnits-Empty',
			Template: /*html*/`Variable Units (English)`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Project',
			Template: /*html*/`{~Entity:Project^Record.IDProject^SampleDetails-EntityValue-Project-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Project-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Material',
			Template: /*html*/`{~Entity:Material^Record.IDMaterial^SampleDetails-EntityValue-Material-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Material-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-LineItem',
			Template: /*html*/`{~Entity:LineItem^Record.IDLineItem^SampleDetails-EntityValue-LineItem-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-LineItem-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Product',
			Template: /*html*/`{~Entity:Product^Record.IDProduct^SampleDetails-EntityValue-Product-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Product-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Organization',
			Template: /*html*/`{~Entity:Organization^Record.IDOrganization^SampleDetails-EntityValue-Organization-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Organization-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-ProductionPlant',
			Template: /*html*/`{~Entity:ProductionPlant^Record.IDProductionPlant^SampleDetails-EntityValue-ProductionPlant-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-ProductionPlant-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-MixDesign',
			Template: /*html*/`{~Entity:MixDesign^Record.IDMixDesign^SampleDetails-EntityValue-MixDesign-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-MixDesign-Record',
			Template: /*html*/`{~D:Record.MixID~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-User',
			Template: /*html*/`{~Entity:User^Record.CreatingIDUser^SampleDetails-EntityValue-User-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-User-Record',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'SampleDetails-Tab-Location',
			Template: /*html*/`
			<figure class="image">
				<img class="has-background-text-40" onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~GoogleMapURL:Record^640x480^~}" alt="Sample location on a map" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)">
			</figure>
			<div class="columns px-3 m-0 mt-3">
				<div class="column">
					<span class="title is-block is-6 has-text-text-60">Latitude</span>
					<span class="subtitle is-6 has-text-text-90">
						{~D:Record.CaptureLatitude~}
					</span>
				</div>
				<div class="column">
					<span class="title is-block is-6 has-text-text-60">Longitude</span>
					<span class="subtitle is-6 has-text-text-90">
						{~D:Record.CaptureLongitude~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<span class="title is-block is-6 has-text-text-60">Geographical Area</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-GeographicalArea:Record:Record.GeographicalArea^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.GeographicalArea^<=^0~}
					</span>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs',
			Template: /*html*/`
				{~TIfAbs:SampleDetails-Tab-Logs-Items:Record:Record.length^>^0~}
				{~TIfAbs:SampleDetails-Tab-Logs-Empty:Record:Record.length^<=^0~}
				{~T:SampleDetails-Tab-Logs-Entry:Context[0].ActiveSampleDetails~}`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Empty',
			Template: /*html*/`
			<div class="notification has-text-text-light is-dark m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No logs are available for this sample.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Items',
			Template: /*html*/`
			<div id="SampleDetails-Tab-Logs-Items" class="nested-scroll-content panel-views-height-offset has-sample-header-offset">
				{~TS:SampleDetails-Tab-Logs-Item:Record~}
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0">
				<figure class="image">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Geolocation for sample" />
				</figure>
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div class="is-size-7 has-text-text-75">#{~D:Record.IDSampleLog~}</div>
					<div>{~D:Record.Notes~}</div>
					<div class="is-size-7 has-text-text-75">
						<span class="has-text-text-60">on</span>
						<span class="has-text-text-80">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-60">by</span>
						<span class="has-text-text-80">{~Entity:User^Record.CreatingIDUser^SampleDetails-Tab-Logs-Item-User^~}</span>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Entry',
			Template: /*html*/`
			<div class="column" style="border-top: 1px solid var(--bulma-text-20)">
				<textarea id="SampleDetails-Tab-Logs-CreateNewLog-Textarea" style="min-height: 4rem" class="textarea" placeholder="Enter log notes here"></textarea>
				<div class="buttons mt-2 is-right">
					<button type="button" class="button is-primary is-soft" title="Clear log entry" onclick="_Pict.views.SampleDetails.clearNewLogEntry()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span>Clear</span>
					</button>
					<button type="button" class="button is-primary" title="Add new log to sample"onclick="_Pict.views.SampleDetails.addNewLogToSample()">
						<span class="icon">
							<i class="fa fa-fw fa-pencil"></i>
						</span>
						<span>Add Log</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Print',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column has-background-white p-3" id="SampleDetails-PrintPreview"></div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-primary" title="Print qrcode label" onclick="_Pict.views.SampleDetails.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span>Print QRCode Label</span>
						</button>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleDetails',
			TemplateHash: 'SampleDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":693}],811:[function(require,module,exports){
/* eslint-disable no-extra-bind */
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleScan extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.InAddMode = false;
		this.currentScannedSampleResult = null;
	}

	onBeforeRenderAsync(pCallback)
	{
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// start a new QR code scanning workflow
		this.customOpenQRScannerWorkflow();
		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	customOpenQRScannerWorkflow()
	{
		this.currentScannedSampleResult = null;
		this.pict.providers.QRCodeProvider.startWorkflow((e) =>
		{
			console.log('[Sample Scan Panel] Received QREvent: ', e);
			if (e.event === 'scanned-Sample')
			{
				if (e.payload.IDSample)
				{
					// stop the QR code scanning workflow
					this.pict.views.QRPanel.toggleCamera();
					// handle the scanned sample selection
					this.currentScannedSampleResult = e.payload;
					this.handleSampleScanSelection(null, e.payload.IDSample, e.payload);
				}
			}
		});
	}

	/**
	 * This function is used to handle the selection of a sample from the scan results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDSample - The ID of the sample that was selected
	 * @param {object} pSampleObject - The sample object that was selected
	 * @return {void}
	 */
	handleSampleScanSelection(event, pIDSample, pSampleObject)
	{
		// determine if we are in "add to set" mode
		this.InAddMode = this.pict.ContentAssignment.readAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode') === 'add-to-set';

		if (!pIDSample)
		{
			this.log.error('No IDSample provided');
			return;
		}
		// handle the context of the sample selection
		if (this.InAddMode)
		{
			if (this.pict.views.SampleSearch.sampleSelectionCallback)
			{
				if (pIDSample && pSampleObject)
				{
					this.pict.views.SampleSearch.sampleSelectionCallback(pSampleObject);
					this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'close');
					this.InAddMode = false;
				}
			}
		}
		else
		{
			if (_Pict.PictApplication.options.Name == 'LIMS')
			{
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
				window.open(`#/Sample/${ pSampleObject.GUIDSample }`, '_self');
			}
			else
			{
				this.pict.views.SampleDetails.showSampleDetailView(pIDSample, null, 'Details');
			}
		}
	}
}

module.exports = SampleScan;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleScan',
	DefaultRenderable: 'SampleScan',
	DefaultDestinationAddress: '#SampleScan-Container',
	Templates:
		[
			{
				Hash: 'SampleScan',
				Template: /*html*/`
				<div id="SampleScan-Content" class="container">
					<style>
						.sample-container {
							overflow: scroll;
						}
						.panel-content-samples {
							max-height: calc(100vh - var(--panels-header-height) - var(--panels-navbar-height)) !important;
							overflow-y: scroll !important;
						}
						.icon-text-for-open-button
						{
							display: inline;
						}
						.icon-text-for-close-button
						{
							display: none;
						}
						.is-close-button .icon-text-for-close-button
						{
							display: inline;
						}
						.is-close-button .icon-text-for-open-button
						{
							display: none;
						}
					
					</style>
					<div id="QRPanel-SampleScan-Container" class="has-background-text-35 has-text-white" style="max-height: 50vh; overflow-y: scroll;">
						<style>
							@media screen and (max-width: 768px) {
								#QRPanel-ScannerBox__scan_region > video {
									max-height: 180px;
									object-fit: cover;
								}
							}
						</style>
						<div id="QRPanel-ScannerBox-Outer" class="is-hidden">
							<div id="QRPanel-ScannerBox"></div>
						</div>
					</div>
					<div class="notification is-dark has-text-text-65 mx-4 mt-4 mb-0 scanning-instructions">
						<span class="icon-text">
							<span class="icon">
								<i class="fas fa-fw fa-info-circle"></i>
							</span>
							<span>
								Point your device camera or scanner gun at a QR code to select a valid sample.
							</span>
						</span>
					</div>
					<div class="columns m-0 is-mobile">
						<div class="column is-6">
							<button type="button" id="QRPanel-CameraButton" class="button is-primary is-fullwidth" onclick="_Pict.views.QRPanel.toggleCamera()">
								<span class="icon mr-3">
									<i class="fas fa-fw fa-camera-viewfinder"></i>
								</span>
								<span class="icon-text icon-text-for-open-button">Open Camera</span>
								<span class="icon-text icon-text-for-close-button">Close Camera</span>
							</button>
						</div>
					</div>
				
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'SampleScan',
				TemplateHash: 'SampleScan',
				DestinationAddress: '#SampleScan-Container',
			},
		],
};

},{"pict-view":693}],812:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			Materials: [],
			MixDesigns: [],
			StartDate: '',
			EndDate: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'CreateDate',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		// this is the active sample that is selected; will be one we see in the "Sample Details" panel, etc.
		this.selectedSample = {};

		// make the status a pretty little pill
		this.pict.MetaTemplate.addPattern('{~StatusPill:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpStatusValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// get the status details, this will return a name, color, and icon for any status value
			const tmpStatus = this.pict.providers.SampleProvider.getSampleStatusMappedDetails(tmpStatusValue);
			const tmpDisplayTag =
			`
			<style>
				.is-unknown
				{
					background-color: transparent;
					border: 1px solid var(--bulma-text-70);
					/* the panels chrome is dark; without this the tag inherits .tag's dark text */
					color: var(--bulma-text-70);
				}
				.has-text-unkown
				{
					color: var(--bulma-text-70);
				}
			</style>
			<span class="tag is-rounded pl-1 ${tmpStatus?.color}">
				<span class="icon m-0 ${tmpStatus.iconColor}">
					<i class="fas fa-fw ${tmpStatus?.icon}"></i>
				</span>
				<span class="icon-text">${tmpStatus?.name}</span>
			</span>`;
			return tmpDisplayTag;
		});
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'SampleSearch-Projects',
			ParentID: 'SampleSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// MATERIAL Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			placeholder: 'Search by materials..',
			ElementID: 'SampleSearch-Materials',
			ParentID: 'SampleSearch-SearchEntry',
			URL: 'Materials',
			IDField: 'IDMaterial',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Materials initialized');
		});

		// MIX DESIGN Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			placeholder: 'Search by mix designs...',
			ElementID: 'SampleSearch-MixDesigns',
			ParentID: 'SampleSearch-SearchEntry',
			URL: 'MixDesigns',
			IDField: 'IDMixDesign',
			TextField: 'MixID',
		}, () =>
		{
			this.log.info('Select2 Mix Designs initialized');
		});

		// START DATE date picker
		window.flatpickr('#SampleSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				/** @type {any}  silence _flatpickr error */
				const siblingElement = document.getElementById('SampleSearch-EndDate');
				siblingElement._flatpickr.config.minDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#SampleSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				/** @type {any}  silence _flatpickr error */
				const siblingElement = document.getElementById('SampleSearch-StartDate');
				siblingElement._flatpickr.config.maxDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		this.setCurrentSearchFilters();

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method performs a search based on the current search filters.
	 * @param {Event} event - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleSampleSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#SampleSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('SampleSearch-Results-Container', this.CurrentSearchFilters.PageSize, '2.5rem');
		// collapse the filter panel to get out the way of the results
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters', 'close');
		// perform the search
		const tmpSearchResults = await this.pict.providers.SampleProvider.performSampleSearch(this.CurrentSearchFilters);
		// update the search results/UI based on the search results and total search count passed in
		this.updateWithSearchResults(tmpSearchResults.results, tmpSearchResults.count);
	}

	/**
	 * This function is used to handle the selection of a sample from the search results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDSample - The ID of the sample that was selected
	 * @param {object} pContext - The context of the sample that was selected
	 * @return {void}
	 */
	handleSampleSelection(event, pIDSample, pContext)
	{
		if (!pIDSample)
		{
			this.log.error('No IDSample provided');
			return;
		}
		if (event)
		{
			event.preventDefault();
			if (event.target instanceof HTMLElement)
			{
				// add loading class to button if it exists
				// TODO: probably should have a "find the parents until the button" function to handle this
				if (event.target?.classList?.contains('button'))
				{
					event.target.classList.add('is-loading');
				}
				else if (event.target?.parentElement?.classList?.contains('button'))
				{
					event.target.parentElement.classList.add('is-loading');
				}
				else if (event.target?.parentElement?.parentElement?.classList?.contains('button'))
				{
					event.target.parentElement.parentElement.classList.add('is-loading');
				}
				else
				{
					this.log.info('No button found to add loading class to');
				}
			}
		}
		// handle the context of the sample selection
		if (pContext === 'Add')
		{
			if (this.pict.views.SampleSearch.sampleSelectionCallback)
			{
				if (this.pict.views.SampleSearch.CurrentSearchResults.length > 0)
				{
					const tmpSample = this.pict.views.SampleSearch.CurrentSearchResults.find((pSample) => pSample.IDSample == pIDSample);
					this.pict.views.SampleSearch.sampleSelectionCallback(tmpSample);
					this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'close');
				}
			}
		}
		else if (pContext === 'Details')
		{
			this.pict.views.SampleDetails.showSampleDetailView(pIDSample, null, 'Details');
		}
		else
		{
			this.log.error('Unknown context for handleSampleSelection()!', { pContext });
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.SampleSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.SampleSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.SampleSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.SampleSearch.handleSampleSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.SampleSearch.handleSampleSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], Materials: [5678]})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('SampleSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#SampleSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#SampleSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#SampleSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#SampleSearch-Materials', this.CurrentSearchFilters?.Materials);
			this.pict.ContentAssignment.assignContent('#SampleSearch-MixDesigns', this.CurrentSearchFilters?.MixDesigns);
			this.pict.ContentAssignment.assignContent('#SampleSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#SampleSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#SampleSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.Materials && my.Materials.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Materials.length;
		}
		if (my.MixDesigns && my.MixDesigns.length > 0)
		{
			this.CurrentSearchFiltersCount += my.MixDesigns.length;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setSampleSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setSampleSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.sampleSearchResultsCallback = pCallback;
	}


	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Projects');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#SampleSearch-Projects');
			break;
		case 'Material':
		case 'Materials':
			this.CurrentSearchFilters.Materials = this.pict.ContentAssignment.readContent('#SampleSearch-Materials');
			break;
		case 'MixDesign':
		case 'MixDesigns':
			this.CurrentSearchFilters.MixDesigns = this.pict.ContentAssignment.readContent('#SampleSearch-MixDesigns');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#SampleSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#SampleSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SortBy':
			const tempSortBy = this.pict.ContentAssignment.readContent('#SampleSearch-SortBy');
			this.CurrentSearchFilters.SortBy = typeof tempSortBy == 'string' ? tempSortBy.split('_')[0] : 'CreateDate';
			this.CurrentSearchFilters.SortDirection = typeof tempSortBy == 'string' ? tempSortBy.split('_')[1] : 'DESC';
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.SampleSearch.renderAsync('SampleSearch-Results', '#SampleSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#SampleSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.SampleSearch.renderAsync('SampleSearch-Pagination', '#SampleSearch-Pagination-Container', false, false, () =>
			{
				this.log.info('Sample Search Pagination rendered');
			});
			// if there is a callback function, call it
			if (this.sampleSearchResultsCallback)
			{
				this.sampleSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}
}

module.exports = SampleSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleSearch',
	DefaultRenderable: 'SampleSearch-Entry',
	DefaultDestinationAddress: '#SampleSearch-Entry-Container',
	Templates:
		[
			{
				Hash: 'SampleSearch-Entry',
				Template: /*html*/`
				<div id="SampleSearch-SearchEntry" class="container">
					<form autocomplete="off" role="sample-search" onsubmit="_Pict.views.SampleSearch.handleSampleSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="SampleSearchFilters">
							<div class="columns mb-0 is-hidden">
								{~T:SampleSearch-Entry-CurrentPage~}
								{~T:SampleSearch-Entry-PageSize~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-MaterialSelector~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-MixDesignSelector~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-StartDate~}
								{~T:SampleSearch-Entry-EndDate~}
								{~T:SampleSearch-Entry-SortBy~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="SampleSearch-Pagination-Container" style="flex:auto"></div>
							<button 
								id="SampleSearch-ToggleButton"
								type="button"
								title="Toggle filters" 
								class="button is-primary is-soft" 
								data-collapsible-toggle="SampleSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters')"
							>
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="SampleSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:SampleSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" title="Reset search" id="SampleSearch-ResetButton" onclick="_Pict.views.SampleSearch.resetSearchFilters()"><i class="fas fa-fw fa-undo mr-1"></i> Clear Filters</button>
							<button class="button is-primary" type="submit" title="Search samples" id="SampleSearch-SearchButton"><i class="fas fa-fw fa-search mr-1"></i> Search Samples</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'SampleSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="SampleSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.SampleSearch.updateSearchFilterValue('CurrentPage')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-PageSize" class="block">Page Size</label>
						<input 
							id="SampleSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.SampleSearch.updateSearchFilterValue('PageSize')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="SampleSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-Projects" 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('Projects')"
								multiple
							>{~TS:SampleSearch-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Projects~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Enty-ProjectSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'SampleSearch-Entry-MaterialSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="SampleSearch-Materials">Materials</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-Materials" 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('Materials')"
								multiple
							>{~TS:SampleSearch-Entry~MaterialSelector-SelectedOptions:Context[0].CurrentSearchFilters.Materials~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-MaterialSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDMaterial~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'SampleSearch-Entry-MixDesignSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="SampleSearch-MixDesigns">Mix Designs</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-MixDesigns" 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('MixDesigns')"
								multiple
							>{~TS:SampleSearch-Entry~MixDesignSelector-SelectedOptions:Context[0].CurrentSearchFilters.MixDesigns~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-MixDesignSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDMixDesign~}" selected>{~D:Record.MixID~}</option>`,
			},
			{
				Hash: 'SampleSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="SampleSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="SampleSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="CreateDate_DESC">Create Date (Newest)</option>
								<option value="CreateDate_ASC">Create Date (Oldest)</option>
								<option value="Status_ASC">Status (A-Z)</option>
								<option value="Status_DESC">Status (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Results',
				Template: /*html*/`
				<div id="SampleSearch-Results-Container" class="container table-container">
					{~TIfAbs:SampleSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:SampleSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'SampleSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Create Date</th>
							<th>Project</th>
							<th>Material</th>
							<th>Mix Design</th>
							<th class="has-text-centered">Status</th>
							<th class="has-text-centered">Details</th>
							{~T:SampleSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="SampleSearch-Results-Entries">
						{~TS:SampleSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'SampleSearch-Results-Row',
				Template: /*html*/`
				<tr>
					<td>{~DateFormat:Record.CreateDate^YYYY-MM-DD~}</td>
					<td>
						{~TIfAbs:SampleSearch-Results-EntityValue-Project:Record:Record.IDProject^>^0~}
						{~TIfAbs:SampleSearch-Results-EntityValue-NA:Record:Record.IDProject^<=^0~}
					</td>
					<td>
						{~TIfAbs:SampleSearch-Results-EntityValue-Material:Record:Record.IDMaterial^>^0~}
						{~TIfAbs:SampleSearch-Results-EntityValue-NA:Record:Record.IDMaterial^<=^0~}
					</td>
					<td>
						{~TIfAbs:SampleSearch-Results-EntityValue-MixDesign:Record:Record.IDMixDesign^>^0~}
						{~TIfAbs:SampleSearch-Results-EntityValue-NA:Record:Record.IDMixDesign^<=^0~}
					</td>
					<td class="has-text-centered">
						{~StatusPill:Record.Status~}
					</td>
					<td class="has-text-centered is-vcentered">
						<button type="button" class="button is-ghost has-text-primary-75 p-0" title="See Details" onclick="_Pict.views.SampleSearch.handleSampleSelection(event, '{~D:Record.IDSample~}', 'Details')">
							<span class="icon">
								<i class="fas fa-fw fa-lg fa-circle-ellipsis"></i>
							</span>
						</button>
					</td>
					{~T:SampleSearch-Results-Extra-Column:Record~}
				</tr>`,
			},
			{
				Hash: 'SampleSearch-Results-Extra-Header',
				Template: /*html*/`<th class="has-text-centered" data-panel-mode-show-if="add-to-set">Select</th>`,
			},
			{
				Hash: 'SampleSearch-Results-Extra-Column',
				Template: /*html*/`
				<td class="has-text-centered is-vcentered" data-panel-mode-show-if="add-to-set">
					<button type="button" class="button is-ghost has-text-primary-75 p-0" title="Select Sample" onclick="_Pict.views.SampleSearch.handleSampleSelection(event, '{~D:Record.IDSample~}', 'Add')">
						<span class="icon">
							<i class="fa fa-fw fa-lg fa-plus-circle"></i>
						</span>
					</button>
				</td>`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'SampleSearch-Results-DatumValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-Project',
				Template: /*html*/`{~Entity:Project^Record.IDProject^SampleSearch-Results-Project^~}`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-Material',
				Template: /*html*/`{~Entity:Material^Record.IDMaterial^SampleSearch-Results-Material^~}`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-MixDesign',
				Template: /*html*/`{~Entity:MixDesign^Record.IDMixDesign^SampleSearch-Results-MixDesign^~}`,
			},
			{
				Hash: 'SampleSearch-Results-DatumValue-Status',
				Template: /*html*/`{~D:Record.Status~}`,
			},
			{
				Hash: 'SampleSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any samples based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Results-Material',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'SampleSearch-Results-MixDesign',
				Template: /*html*/`{~D:Record.MixID~}`,
			},
			{
				Hash: 'SampleSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'SampleSearch-Pagination',
				Template: /*html*/`
				<nav id="SampleSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="SampleSearch-PreviousButton" type="button" title="Previous page" class="button is-soft mr-2" onclick="_Pict.views.SampleSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="SampleSearch-NextButton" type="button" title="Next page" class="button is-soft" onclick="_Pict.views.SampleSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'SampleSearch-Entry',
				TemplateHash: 'SampleSearch-Entry',
				DestinationAddress: '#SampleSearch-Entry-Container',
			},
			{
				RenderableHash: 'SampleSearch-Entry-ProjectSelector',
				TemplateHash: 'SampleSearch-Entry-ProjectSelector',
				DestinationAddress: '#SampleSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'SampleSearch-Entry-MaterialSelector',
				TemplateHash: 'SampleSearch-Entry-MaterialSelector',
				DestinationAddress: '#SampleSearch-Entry-MaterialSelector',
			},
			{
				RenderableHash: 'SampleSearch-Entry-MixDesignSelector',
				TemplateHash: 'SampleSearch-Entry-MixDesignSelector',
				DestinationAddress: '#SampleSearch-Entry-MixDesignSelector',
			},
			{
				RenderableHash: 'SampleSearch-Entry-ActiveFilterCount',
				TemplateHash: 'SampleSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#SampleSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'SampleSearch-Results',
				TemplateHash: 'SampleSearch-Results',
				DestinationAddress: '#SampleSearch-Results-Container',
			},
			{
				RenderableHash: 'SampleSearch-Pagination',
				TemplateHash: 'SampleSearch-Pagination',
				DestinationAddress: '#SampleSearch-Pagination-Container',
			},
		],
};

},{"pict-view":693}],813:[function(require,module,exports){
const PictViewClass = require('pict-view');
const ComprehensionProcessor = require('headlight-comprehension-processor');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class TestInstanceWizard extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.wizardStep = 1;
		this.finalStep = 3;
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.SelectedIDTest = 0;
		this.testsToCreate = [];
		this.documentList = [];
		this.formsToCreate = [];
		this.decoratedDocumentRecords = [];
	}

	async continue()
	{
		const continueButton = document.getElementById('TestInstanceWizard-Continue');
		continueButton.classList.add('is-loading');

		switch (this.wizardStep)
		{
			case 1:
				if (!this.testsToCreate.length)
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'No Tests were selected.',
						type: 'is-danger',
					});
					continueButton.classList.remove('is-loading');
					return;
				}
				const foundManifests = [];
				const allSatisfiedIDTests = this.formsToCreate.flatMap((f) => f.SatisfiedIDTests || []);
				const testsForForms = allSatisfiedIDTests.length > 0
					? await this.pict.providers.TestInstanceProvider.getTestsByIDs(allSatisfiedIDTests)
					: [];
				const hashMap = {};
				testsForForms.forEach(t =>
				{
					hashMap[t.Hash] = t;
				});
				for (let f of this.formsToCreate)
				{
					if (f.IDReportNamedInstance)
					{
						const satisfiedHashes = f.SatisfiedTestHashes || [f.TestHash];
						this.decoratedDocumentRecords.push(
							{
								Index: this.decoratedDocumentRecords.length,
								Name: `${ satisfiedHashes.join(', ') } for Sample ${ this.AppData.SampleDetails.QRCode }`,
								DocumentType: f.Hash,
								Tests: satisfiedHashes.map((h) => hashMap[h]).filter(Boolean),
								FormattedTests: [f],
								Type: f.Name
							}
						);
						if (f.LabName)
						{
							const rec = this.decoratedDocumentRecords[this.decoratedDocumentRecords.length - 1];
							rec.Name = `${rec.Name} in ${f.LabName}`;
						}
					}
					else
					{
						foundManifests.push(f);
					}
				}
				if (foundManifests.length)
				{
					const rnis = await this.pict.services.MaterialsFormManager._getAvailableRNIs(this.AppData.SampleDetails?.IDProject);
					let foundGenericMaterialForm = null;
					for (let r of rnis)
					{
						//if (r.Options.TidingsData.Type === 'materials-form' && !foundGenericMaterialForm)
						if (r.GUIDReportNamedInstance == 'LADOTD-LIMS-ContainerForm' && !foundGenericMaterialForm)
						{
							foundGenericMaterialForm = r;
						}
					}
					if (foundGenericMaterialForm)
					{
						const foundManifestsByLab = {};
						for (let f of foundManifests)
						{
							const labName = f.LabName || '';
							if (!foundManifestsByLab[labName])
							{
								foundManifestsByLab[labName] = [];
							}
							foundManifestsByLab[labName].push(f);
						}
						for (const labName of Object.keys(foundManifestsByLab))
						{
							const labManifests = foundManifestsByLab[labName];
							this.decoratedDocumentRecords.push(
								{
									Index: this.decoratedDocumentRecords.length,
									Name: `${ labManifests.map(f => f.TestHash).join(', ') } for Sample ${ this.AppData.SampleDetails.QRCode }`,
									DocumentType: foundGenericMaterialForm.Hash,
									Tests: [...labManifests.map(f => hashMap[f.TestHash])],
									FormattedTests: labManifests,
									Type: foundGenericMaterialForm.Name
								}
							);
							if (labName)
							{
								const rec = this.decoratedDocumentRecords[this.decoratedDocumentRecords.length - 1];
								rec.Name = `${rec.Name} in ${labName}`;
							}
						}
					}
				}
				break;
			case 2:
				const docsToPush = [];
				const comprehensionsToPush = [];
				for (const d of this.decoratedDocumentRecords)
				{
					const tempDoc = {
						Name: d.Name,
						DocumentType: d.DocumentType,
						IDProject: this.AppData.SampleDetails?.IDProject,
						Form: 1
					};
					comprehensionsToPush.push(await this.pict.services.MaterialsFormManager.applyMaterialTestsToDocumentRecord(d.FormattedTests, tempDoc, this.AppData.SampleDetails?.GUIDSample));
					docsToPush.push(tempDoc);
				}
				console.log('Documents to push: ', docsToPush);
				console.log('Comprehensions to push: ', comprehensionsToPush);
				this.uploadData(docsToPush, comprehensionsToPush);
				break;
			case 3:
				break;
			default:
				this.pict.log.warn(`Step in TestInstance creation was not found, this should not happen.`);
				break;
		}
		this.wizardStep += 1;

		this.renderAsync(()=>
		{
			const steps = document.querySelectorAll('#TestInstanceWizard-Steps-List li');
			steps.forEach((step, i) =>
			{
				if (i + 1 === this.wizardStep - 1)
				{
					step.classList.add('prev-active');
				}
				else
				{
					step.classList.remove('prev-active');
				}
				if (i + 1 === this.wizardStep)
				{
					step.classList.add('is-active');
				}
				else
				{
					step.classList.remove('is-active');
				}
			});
			const stepBodies = document.querySelectorAll('#TestInstanceWizard-Body-Pane > div');
			stepBodies.forEach((stepBody, i) =>
			{
				if (i + 1 === this.wizardStep)
				{
					stepBody.classList.add('is-active');
				}
				else
				{
					stepBody.classList.remove('is-active');
				}
			});
			if (this.wizardStep === this.finalStep)
			{
				document.getElementById('TestInstanceWizard-Continue').classList.add('is-hidden');
			}
			document.getElementById('TestInstanceWizard-Continue').classList.remove('is-loading');
		});
	}

	updateDocumentName(index)
	{
		// @ts-ignore
		this.decoratedDocumentRecords[index].Name = document.getElementById(`DocumentCreate-Entry-Name-${ index }`)?.value;
	}

	async uploadData(documents, comprehensions)
	{
		this.fable.addServiceType('ComprehensionProcessor', ComprehensionProcessor);

		/** @type {ComprehensionProcessor} */
		const processor = this.fable.instantiateServiceProviderWithoutRegistration('ComprehensionProcessor', this.options);
		for (let d of documents)
		{
			await this.pict.providers.DocumentProvider.createDocument(d, true);
		}
		for (let c of comprehensions)
		{
			await new Promise((resolve, reject) => 
			{
				processor.integrateComprehension(c, () =>
				{
					resolve();
				});
			});
		}
		if (this.pict.views.LIMSSampleRecordView)
		{
			this.pict.views.LIMSSampleRecordView.renderAsync(()=>
			{
				this.pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-TestInstance-Tab') }, 'LIMSSampleRecordPanel-TestInstances');
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			});
		}
		else
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		}
	}

	/**
	 * Toggles the disabled attribute on/off for the passed in elements
	 * @param {Array.<{id:string, title:string}>} elements - {id: id of the element to target, title: tooltip when not disabled }
	 * @param {string} disabledText (optional) - tooltip to display when element is disabled
	 */
	toggleDisabled(elements, disabledText)
	{
		for (const [ key ] of Object.entries(elements))
		{
			const element = elements[key];
			if (!element.hasOwnProperty('id') )
			{
				continue;
			}
			const el = document.getElementById(element.id);

			if (!el)
			{
				continue;
			}

			if (el.hasAttribute('disabled'))
			{
				this.pict.ContentAssignment.removeAttribute(`#${element.id}`, 'disabled');
				if (element.title && typeof element.title === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', element.title );
				}
			}
			else
			{
				this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'disabled', 'disabled');
				if (typeof disabledText === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', disabledText);
				}
			}
		};
	}

	/**
	 * This method resets the state of the Wizard Panel view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetTestInstanceWizardView()
	{
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.SelectedIDTest = 0;
		this.documentList = [];
		this.testsToCreate = [];
		this.formsToCreate = [];
		this.decoratedDocumentRecords = [];
		this.wizardStep = 1;
		this.setSampleData();
		this.pict.HeadlightPanels.leftPanelCustomWidth(75);
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelHide();
	}

	setSampleData()
	{
		for (const d of (this.AppData.ActiveLIMSSampleDocuments || []))
		{
			if (!d.Locked)
			{
				this.documentList.push(d);
			}
		}
	}

	async addDefaultTests()
	{
		let sampleLabIDs = await this.pict.services.MaterialsFormManager.getSampleLabIDs(this.AppData.SampleDetails?.IDSample);
		if (!Array.isArray(sampleLabIDs) || sampleLabIDs.length < 1)
		{
			sampleLabIDs = null;
		}
		const defaults = await this.pict.services.MaterialsFormManager.getMaterialTestDefaults(this.AppData.SampleDetails?.IDMaterial, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.MaterialType, sampleLabIDs);
		console.log('Found defaults: ', defaults);
		if (defaults.length)
		{
			const allSatisfiedIDTests = defaults.flatMap((f) => f.SatisfiedIDTests || []);
			const defaultTests = allSatisfiedIDTests.length > 0
				? await this.pict.providers.TestInstanceProvider.getTestsByIDs(allSatisfiedIDTests)
				: [];
			this.addTests(defaultTests.map(t => { return { IDTest: t.IDTest } }));
			this.addForms(defaults);
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: `No Default Tests found for this Sample.`,
				type: 'is-warning',
			});
		}
	}

	async addActiveTest()
	{
		if (!this.SelectedIDTest)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Test was selected to add.',
				type: 'is-danger',
			});
			return;
		}
		const tempForm = await this.pict.services.MaterialsFormManager.getTestDefinitionForTestID(this.SelectedIDTest, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.IDMaterial);
		if (tempForm)
		{
			// @ts-ignore
			this.addTests([{ IDTest: parseInt(this.SelectedIDTest) }]);
			this.addForms([tempForm]);
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Form is available for this Test.',
				type: 'is-warning',
			});
		}
	}

	openTestInstanceWizard()
	{
		this.resetTestInstanceWizardView();
		this.pict.views.HeadlightPanels.handlePanelToggle('TestInstanceWizard', 'open');
	}

	async addTests(testArray)
	{
		this.testsToCreate = this.testsToCreate.concat(testArray).sort((a, b) => a.IDTest - b.IDTest);
		this.renderAsync();
	}

	addForms(formsArray)
	{
		this.formsToCreate = this.formsToCreate.concat(formsArray).sort((a, b) => a.TestHash - b.TestHash);
	}

	async removeTest(test)
	{
		const tempTests = [];
		
		let found = false;
		for (const t of this.testsToCreate)
		{
			if (test !== t.IDTest || found)
			{
				tempTests.push(t);
			}
			else
			{
				found = true;
			}
		}
		this.testsToCreate = tempTests.sort();
		const tempTest = await this.pict.providers.TestInstanceProvider.getTestByID(test);
		const tempForms = [];
		for (let f of this.formsToCreate)
		{
			const satisfiedHashes = f.SatisfiedTestHashes || [f.TestHash];
			const satisfiedIDTests = f.SatisfiedIDTests || [];
			if (!satisfiedHashes.includes(tempTest.Hash))
			{
				// This form doesn't cover the removed test; keep it as-is
				tempForms.push(f);
			}
			else if (satisfiedHashes.length > 1)
			{
				// This form covers the removed test but also satisfies others; keep it
				// with the removed test's entries pruned from the satisfied lists
				const hashIdx = satisfiedHashes.indexOf(tempTest.Hash);
				f.SatisfiedTestHashes = satisfiedHashes.filter((h) => h !== tempTest.Hash);
				f.SatisfiedIDTests = satisfiedIDTests.filter((id) => id !== test);
				tempForms.push(f);
			}
			// else: form only satisfied this one test — drop it entirely
		}
		this.formsToCreate = tempForms.sort();
		this.renderAsync();
	}

	/**
	 * This method is used to handle the closing of the Wizard panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close panel and cancel Test creation?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		},
		null);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		return super.onAfterRender(pRenderable);
	}

	async onAfterRenderAsync(callback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.CurrentUser.CustomerID || 0;

		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Select a Test..',
			ElementID: 'TestInstanceWizard-TestSelector',
			ParentID: 'TestInstanceWizard-Step-1',
			URL: 'Tests',
			IDField: 'IDTest',
			TextField: ['Hash', 'Name'],
		}, () =>
		{
			this.log.info('Select2 Tests initialized');
		});
		callback();
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						},
						{
							field: 'Active',
							comparator: 'EQ',
							target: '1',
						},
						{
							field: '',
							target: '',
							comparator: 'FOP',
						},
						{
							field: 'Standalone',
							comparator: 'EQ',
							target: '1',
						},
						{
							field: 'Injectable',
							comparator: 'EQ',
							target: '1',
							connector: 'OR'
						},
						{
							field: '',
							target: '',
							comparator: 'FCP',
						}],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// Spec-year scope: narrow to tests reachable from the contract's
					// material spec set (via TSMTJ+TSSTJ). Resolver returns null when
					// the gate fails open (no FK, empty stub, no spec infra), which
					// leaves the picker at its default customer-wide filter.
					const tmpAllowedTestIDs = _Pict.providers.SpecScopeResolver?.getAllowedTestIDs?.();
					if (tmpAllowedTestIDs && tmpAllowedTestIDs.size > 0)
					{
						tmpSearchQuery.filters.push({
							field: 'IDTest',
							comparator: 'INN',
							target: Array.from(tmpAllowedTestIDs).join(','),
						});
					}
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: 'Hash',
							comparator: 'LK',
							target: params.term,
							connector: 'OR'
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.TestInstanceWizard.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption, true),
						more: params.term ? data.length === _Pict.views.TestInstanceWizard.CurrentSearchFilters.PageSize : data.length === _Pict.views.TestInstanceWizard.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	handleOnCloseEvent(pEvent)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close panel and cancel Test creation?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.TestInstanceWizard.resetTestInstanceWizardView();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		});
	}

	handleOnPinPanelEvent(pEvent)
	{
		this.pict.views.TestInstanceWizard.toggleDisabled(
		[
			{
				_id: 'TestInstanceWizard-CloseButton',
				title: 'Close panel',
			}
		],
		'Please unpin panel');

		this.pict.views.HeadlightPanels.togglePanelPinState();
	}

	updateIDTest(IDTest)
	{
		this.SelectedIDTest = IDTest;
	}
}

module.exports = TestInstanceWizard;

module.exports.default_configuration =
{
	ViewIdentifier: 'TestInstanceWizard',
	DefaultRenderable: 'TestInstanceWizard',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'TestInstanceWizard-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-TestInstanceWizardPanel" class="panel is-active">
				<p id="HeadlightPanels-TestInstanceWizardPanel-Header" class="panel-heading pr-4">
					<button id="TestInstanceWizard-CloseButton" type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.TestInstanceWizard.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" 
						onclick="_Pict.views.TestInstanceWizard.handleOnPinPanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-TestInstanceWizardPanel-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-TestInstanceWizardPanel-Header-Title" class="mr-3">Add Tests</span>
				</p>
				<div id="HeadlightPanels-TestInstanceWizard-Content">
					{~T:TestInstanceWizard-Content~}
				</div>
			</article>`,
		},
		{
			Hash: 'TestInstanceWizard-Content',
			Template: /*html*/`
			<header class="has-background-text-15">
				<ul id="TestInstanceWizard-Steps-List" class="wizard-list">
					<li id="Wizard-Tag-1" class="wizard-step-1 is-active"><div><span>Select Tests</span></div></li>
					<li id="Wizard-Tag-2" class="wizard-step-2"><div><span>Test Forms</span></div></li>
					<li id="Wizard-Tag-3" class="wizard-step-3 end-block"><div><span>Finalize</span></div></li>
				</ul>
			</header>
			<div id="TestInstanceWizard-Body-Pane">
				<div id="TestInstanceWizard-Step-1" class="wizard-pane is-active">
					{~T:TestInstanceWizard-Wizard-Step-1~}
				</div>
				<div id="TestInstanceWizard-Step-2" class="wizard-pane">
					{~T:TestInstanceWizard-Wizard-Step-2~}
				</div>
				<div id="TestInstanceWizard-Step-3" class="wizard-pane">
					{~T:TestInstanceWizard-Wizard-Step-3~}
				</div>
			</div>
			<div class="buttons is-right" style="width: 50px; position: absolute; top: calc(100% - 60px); right: 0.5rem;">
				<button id="TestInstanceWizard-Continue" title="Continue" onclick="_Pict.views.TestInstanceWizard.continue()" 
				style="float: right; margin: 10px;" class="button is-primary has-text-white has-shadow is-normal"><i class="fas fa-fw fa-square-chevron-right" style="margin-right: 5px;"></i>Continue</button>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-1',
			Template: /*html*/`
			<div class="container panel-content" id="TestInstanceWizard-Step-1" style="min-width: 100%;">
				<div class="columns px-4 mb-3 mt-3">
					<div class="column">
						{~T:TestInstanceWizard-TestSelector~}
						{~T:TestInstanceWizard-Tab-Tests-Items~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Tests-Items',
			Template: /*html*/`
			<div id="TestInstanceWizard-Tab-Tests-Items">
				<style>
					.test-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.test-entry
					{
						border-top: 1px solid var(--bulma-border);
						border-bottom: 1px solid var(--bulma-border);
					}
				</style>
				{~TS:TestInstanceWizard-Tab-Test-Item:Context[0].testsToCreate~}
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Test-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 test-entry">
				<div class="test-entry-row mx-4 my-2" style="flex-grow: 1">
					<div>{~Entity:Test^Record.IDTest^TestInstanceWizard-Entity^~}{~QuickSummary:Test^Record.IDTest~}</div>
					<button type="button" class="is-pulled-right hl-panel-close-button" 
						onclick="_Pict.views.TestInstanceWizard.removeTest({~D:Record.IDTest~})">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Entity',
			Template: /*html*/`{~D:Record.Hash~} {~D:Record.Name~}`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-2',
			Template: /*html*/`
			<div class="container panel-content" style="min-width: 100%;">
				<div id="TestInstanceWizard-Document-List">
					{~T:TestInstanceWizard-Tab-Documents:Context[0].decoratedDocumentRecords~}
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-3',
			Template: /*html*/`
			<div class="container panel-content">
				<div class="p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<style>
								.lds-ring,
								.lds-ring div {
									box-sizing: border-box;
								}
								.lds-ring {
									display: inline-block;
									position: relative;
									width: 80px;
									height: 80px;
								}
								.lds-ring div {
									box-sizing: border-box;
									display: block;
									position: absolute;
									width: 64px;
									height: 64px;
									margin: 8px;
									border: 8px solid currentColor;
									border-radius: 50%;
									animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
									border-color: currentColor transparent transparent transparent;
								}
								.lds-ring div:nth-child(1) {
									animation-delay: -0.45s;
								}
								.lds-ring div:nth-child(2) {
									animation-delay: -0.3s;
								}
								.lds-ring div:nth-child(3) {
									animation-delay: -0.15s;
								}
								@keyframes lds-ring {
									0% {
										transform: rotate(0deg);
									}
									100% {
										transform: rotate(360deg);
									}
								}
							</style>
							<div class="lds-ring wizard-loader" style="color: white;"><div></div><div></div><div></div><div></div></div>
							<div class="is-size-6 has-text-centered" style="color: white; text-wrap: wrap: max-width: 50vw;">Creating Tests and Forms...</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-TestSelector',
			Template: /*html*/`
			<div style="margin-bottom: 10px; display: flex;">
				<div style="width: 100%; max-width: 30%; margin-right: 10px;">
					<div class="field">
						<label class="label block" for="TestInstanceWizard-TestSelector">Select a Test to Add:</label>
						<div class="control select is-fullwidth">
							<select 
								id="TestInstanceWizard-TestSelector" 
								onchange="_Pict.views.TestInstanceWizard.updateIDTest(value)"
							></select>
						</div>
					</div>
				</div>
				<div style="margin-right: 10px;"><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.TestInstanceWizard.addActiveTest()" class="button is-primary has-text-white is-normal"><i class="fas fa-fw fa-plus" style="margin-right: 5px;"></i>Add Selected Test</button></div>
				<div><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.TestInstanceWizard.addDefaultTests()" class="button is-primary has-text-white is-normal"><i class="fas fa-fw fa-list" style="margin-right: 5px;"></i>Add Default Tests</button></div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents',
			Template: /*html*/`
				{~TIfAbs:TestInstanceWizard-Tab-Documents-Items:Record:Record.length^>^0~}
				{~TIfAbs:TestInstanceWizard-Tab-Documents-Empty:Record:Record.length^<=^0~}
			`
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No valid documents found to add this test to.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Items',
			Template: /*html*/`
			<div id="TestInstanceWizard-Tab-Documents-Items">
				<style>
					.document-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.document-entry
					{
						border-top: 1px solid var(--bulma-border);
						border-bottom: 1px solid var(--bulma-border);
					}
					.document-status
					{
						margin-right: 10vw;
					}
				</style>
				<div style="margin-bottom: 10px; font-weight: bold; color: white; margin-left: 10px; margin-top: 10px;">Test Forms to Create:</div>
				{~TS:TestInstanceWizard-Tab-Documents-Item:Record~}
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 document-entry">
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div class="field">
						<label class="label block" for="DocumentCreate-Entry-Name">Document Name</label>
						<div class="control">
							<input 
								id="DocumentCreate-Entry-Name-{~D:Record.Index~}" 
								class="input" 
								type="text" 
								placeholder="Enter a name for the Document..."
								autocomplete="off"
								value="{~D:Record.Name~}"
								onChange="_Pict.views.TestInstanceWizard.updateDocumentName({~D:Record.Index~})"
							/>
						</div>
					</div>
					<div class="document-entry-row is-size-7">
						<span>
							<b>Document Type:</b> {~DocumentTypeName:Record.DocumentType~}
						</span>
					</div>
					<div class="is-size-7">
						<b>Attached Tests:</b>
					</div>
					<div class="is-size-7">
						{~TS:TestInstanceWizard-Tab-Attached-Test-Item:Record.Tests~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Attached-Test-Item',
			Template: /*html*/`{~D:Record.Hash~} {~D:Record.Name~} <br />`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'TestInstanceWizard',
			TemplateHash: 'TestInstanceWizard-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'TestInstanceWizard-Content',
			TemplateHash: 'TestInstanceWizard-Content',
			DestinationAddress: '#HeadlightPanels-TestInstanceWizard-Content',
			RenderType: 'replace',
		},
	],
};

},{"headlight-comprehension-processor":5,"pict-view":693}],814:[function(require,module,exports){
module.exports={
    "HeadlightPanels-Pane-BridgesPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-BridgesPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-BridgesPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-BridgesPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-BridgesPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-BridgesPanel-Header\" class=\"panel-heading pr-4\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-BridgesPanel-Header-Icon\" class=\"fas fa-fw fa-bridge\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-BridgesPanel-Header-Title\">Bridges</span>\n    </div>\n    <div id=\"HeadlightPanels-BridgePanel-Content\" class=\"panel-content\">\n        <div id=\"HeadlightPanels-Bridges-SearchEntry\" class=\"container\">\n            <form autocomplete=\"off\" role=\"Bridge-search\" onsubmit=\"_Pict.views.HeadlightPaneBridges.handleBridgeSearch(event);\">\n                <div class=\"px-4 pt-4\" data-collapsible-content=\"BridgeSearchFilters\">\n                    <div class=\"columns\">\n                        <!-- TODO: convert this to an entity selector later -->\n                        <div class=\"column is-hidden\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchCounty\" class=\"block\">County</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchCounty\" placeholder=\"Enter a county\">\n                            </div>\n                        </div>\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchStructureNumber\" class=\"block\">Structure Number</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchStructureNumber\" placeholder=\"Enter a structure number\">\n                            </div>\n                        </div>\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchYear\" class=\"block\">Year Built</label>\n                                <input class=\"input\" type=\"number\" id=\"BridgesSearchYearBuilt\" placeholder=\"Enter a year\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"columns\">\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchFacilityCarried\" class=\"block\">Facility Carried</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchFacilityCarried\" placeholder=\"Enter a facility\">\n                            </div>\n                        </div>\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchFeatureIntersected\" class=\"block\">Feature Intersected</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchFeatureIntersected\" placeholder=\"Enter an intersection\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"buttons p-4 is-right\" data-theme=\"dark\">\n                    <div id=\"BridgeSearch-Pagination-Container\" style=\"flex:auto\"></div>\n                    <button \n                        id=\"BridgeSearch-ToggleButton\"\n                        type=\"button\" \n                        class=\"button is-primary is-soft\" \n                        data-collapsible-toggle=\"BridgeSearchFilters\" \n                        onclick=\"_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('BridgeSearchFilters')\"\n                    >\n                        <span class=\"icon\">\n                            <i class=\"fas fa-fw fa-filter\"></i>\n                        </span>\n                        <span>Set Filters</span>\n                        <!-- hide the badge until we fix the count to be accurate -->\n                        <span id=\"BridgeSearch-Entry-ActiveFilterCount\" class=\"is-hidden badge is-warning\">{~T:HeadlightPanels-Bridges-ActiveFilterCount~}</span>\n                    </button>\n                    <button class=\"button is-primary is-soft\" type=\"button\" id=\"BridgeSearch-ResetButton\" onclick=\"_Pict.views.HeadlightPaneBridges.resetSearchFilters()\"><i class=\"fas fa-fw fa-undo mr-1\"></i> Clear Filters</button>\n                    <button class=\"button is-primary\" type=\"submit\" id=\"BridgeSearch-SearchButton\"><i class=\"fas fa-fw fa-search mr-1\"></i> Search Bridges</button>\n                </div>\n            </form>\n        </div>\n        <div id=\"BridgePanel-SearchResults-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-BridgesPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-BridgesPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/BridgesPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-CommentsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-CommentsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-CommentsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-CommentsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-CommentPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-CommentPanel-Header\" class=\"panel-heading pr-4 {~D:options.HeadlightPanels.Configuration.CurrentDocument.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-CommentPanel-Header-Icon\" class=\"fas fa-fw fa-comment\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-CommentPanel-Header-Title\">Comments</span>\n    </div>\n    <div id=\"HeadlightPanels-CommentPanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Comments~}\n    </div>\n    <!-- Comment Panel Tabs -->\n    <!-- <div id=\"HeadlightPanels-CommentPanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\n        <a id=\"HeadlightPanels-CommentPanel-Current-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-CommentPanel-Current', 'Comment')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-comment\"></i>\n            </span>\n            <span title=\"Current comments\" class=\"icon-text\">\n                Current\n            </span>\n        </a>\n    </div> -->\n    <!-- Comment Panel Content > Current View -->\n    <div id=\"HeadlightPanels-CommentPanel-Current-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"CommentCurrent-Entry-Container\"></div>\n        <div id=\"CommentCurrent-Results-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-CommentsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-CommentsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/CommentsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-CustomPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-CustomPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-CustomPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-CustomPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}\" data-panel-mode=\"{~D:Context[0].options.PanelMode~}\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Header\" class=\"panel-heading pr-4\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Header-Icon\" class=\"fas fa-fw {~D:Context[0].options.PanelIcon~}\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Header-Title\">{~D:Context[0].options.PanelTitle~}</span>\n    </div>\n    <div id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Content\" class=\"panel-content\">\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-CustomPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-CustomPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/CustomPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-DocumentsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-DocumentsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-DocumentsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-DocumentsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-DocumentPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-DocumentPanel-Header\" class=\"panel-heading pr-4 {~D:options.HeadlightPanels.Configuration.CurrentDocument.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-DocumentPanel-Header-Icon\" class=\"fas fa-fw fa-files\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-DocumentPanel-Header-Title\">Documents</span>\n    </div>\n    <div id=\"HeadlightPanels-DocumentPanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Documents~}\n    </div>\n    <!-- Document Panel Tabs -->\n    <div id=\"HeadlightPanels-DocumentPanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\n        <a id=\"HeadlightPanels-DocumentPanel-Search-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Search', 'Document')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-search\"></i>\n            </span>\n            <span title=\"Search documents\" class=\"icon-text\">\n                Search\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-DocumentPanel-Create-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Create', 'Document')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-plus-circle\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Create\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-DocumentPanel-Current-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Current', 'Document')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-file\"></i>\n            </span>\n            <span title=\"Current document\" class=\"icon-text\">\n                Current\n            </span>\n        </a>\n    </div>\n    <!-- Document Panel Content > Search View -->\n    <div id=\"HeadlightPanels-DocumentPanel-Search-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"DocumentSearch-Entry-Container\"></div>\n        <div id=\"DocumentSearch-Results-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n    <!-- Document Panel Content > Create View -->\n    <div id=\"HeadlightPanels-DocumentPanel-Create-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"DocumentCreate-Container\"><!-- Injected from Document-View-Create.js --></div>\n    </div>\n    <!-- Document Panel Content > Current View -->\n    <div id=\"HeadlightPanels-DocumentPanel-Current-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"DocumentCurrent-Container\"><!-- Injected from Document-View-Current.js --></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-DocumentsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-DocumentsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/DocumentsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-NavigationPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-NavigationPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-NavigationPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-NavigationPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-NavigationPanel\" class=\"panel is-active is-dark\">\n    <p id=\"HeadlightPanels-NavigationPanel-Header\" class=\"panel-heading\">\n        <button type=\"button\" class=\"is-pulled-right hl-panel-close-button ml-2\" aria-label=\"close\" title=\"Close panel\" onclick=\"_Pict.views.HeadlightPanels.closeThisPanel(event)\">\n            <span class=\"icon\">\n                <i class=\"fas fa-fw fa-times-circle\" aria-hidden=\"true\"></i>\n            </span>\n        </button>\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-list-check\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Actions</span>\n    </p>\n    <div id=\"HeadlightPanels-NavigationPanel-Content\" class=\"panel-content\">\n        {~T:HeadlightPanels-NavigationPanel-NavList~}\n        {~TIfAbs:HeadlightPanels-NavigationPanel-ExtraButton:AppData:AppData.CurrentUser.UserRoleIndex^>=^4~}\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-NavigationPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-NavigationPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/NavigationPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-ObservationsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-ObservationsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-ObservationsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-ObservationsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-ObservationPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-ObservationPanel-Header\" class=\"panel-heading pr-4 {~D:Pict.settings.HeadlightPanels.Configuration.CurrentObservation.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-ObservationPanel-Header-Icon\" class=\"fas fa-fw fa-images\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-ObservationPanel-Header-Title\">Observations</span>\n    </div>\n    <div id=\"HeadlightPanels-ObservationPanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Observations~}\n        {~T:HeadlightPanels-Header-ModeBanner-ObservationsToProjectFiles~}\n    </div>\n    <!-- Observation Panel Tabs -->\n    <div id=\"HeadlightPanels-ObservationPanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\t\n        <a id=\"HeadlightPanels-ObservationPanel-Included-Tab\" title=\"Included in form\" class=\"is-active {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-paperclip\"></i>\n            </span>\n            <span class=\"icon-text\">Included<span class=\"is-hidden-mobile\"> in form</span></span>\n        </a>\n        <a id=\"HeadlightPanels-ObservationPanel-Search-Tab\" title=\"Search observations\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-search\"></i>\n            </span>\n            <span class=\"icon-text\">Search</span>\n            </a>\n        <a id=\"HeadlightPanels-ObservationPanel-Upload-Tab\" title=\"Upload observations\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-upload\"></i>\n            </span>\n            <span class=\"icon-text\">Upload</span>\n        </a>\n        <a id=\"HeadlightPanels-ObservationPanel-Sets-Tab\" title=\"Observation sets\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Sets', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-layer-group\"></i>\n            </span>\n            <span class=\"icon-text\">Sets</span>\n        </a>\n    </div>\n    <!-- Observation Panel Content > Included View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Included-Content\" class=\"panel-content panel-with-tabs-offset {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\">\n        {~T:HeadlightPanels-ObservationPanel-Included~}\n    </div>\n    <!-- Observation Panel Content > Search View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Search-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"ObservationSearch-Entry-Container\"></div>\n        <div id=\"ObservationSearch-Results-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n    <!-- Observation Panel Content > Upload View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Upload-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"ObservationCreateMedia-Container\"></div>\n    </div>\n    <!-- Observtion Panel Contenst > Sets View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Sets-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"ObservationSet-Selector-Container\"></div>\n        <div id=\"ObservationSet-ActiveSet-Container\">{~T:ObservationSet-Unset~}</div>\n    </div>\n\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-ObservationsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-ObservationsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/ObservationsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-ProfilePaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-ProfilePaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-ProfilePaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-ProfilePaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-ProfilePanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-ProfilePanel-Header\" style=\"min-width:300px\" class=\"panel-heading pr-4 {~D:Pict.settings.HeadlightPanels.Configuration.CurrentProfile.wrapperClass~}\">\n        <button type=\"button\" class=\"is-pulled-right hl-panel-close-button\" aria-label=\"close\" title=\"Close panel\" onclick=\"_Pict.views.HeadlightPanels.closeThisPanel(event)\">\n            <span class=\"icon\">\n                <i class=\"fas fa-fw fa-times-circle\" aria-hidden=\"true\"></i>\n            </span>\n        </button>\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-ProfilePanel-Header-Icon\" class=\"fas fa-fw fa-user-circle\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-ProfilePanel-Header-Title\">User Profile</span>\n    </div>\n    <div id=\"HeadlightPanels-ProfilePanel-Content\" class=\"panel-content panel-has-nested-scroll-content\">\n        <div class=\"nested-scroll-content has-bottom-navbar-offset\">\n            <div class=\"columns px-5 pt-4 pb-2 mb-3 has-background-text-20\">\n                <div class=\"column\">\n                    <p class=\"title is-4 has-text-white\">{~D:AppData.CurrentUser.NameFirst~} {~D:AppData.CurrentUser.NameLast~}</p>\n                    <p class=\"subtitle is-6 has-text-text-65\">{~D:AppData.CurrentUser.Title~}</p>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">Login</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.LoginID~}</span>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">Email</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.Email~}</span>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">User Role</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.UserRole~}</span>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">Timezone</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.Timezone~}</span>\n                </div>\n            </div>\n            <div class=\"columns\">\n                <div class=\"column\">\n                    <a class=\"panel-block px-5\" onclick=\"_Pict.views.HeadlightPaneProfile.navigateToProfileApp(event)\">\n                        <span class=\"panel-icon\">\n                            <i class=\"fas fa-edit has-text-primary-75\" aria-hidden=\"true\"></i>\n                        </span>\n                        <span class=\"has-text-primary-85\">Edit Profile</span>\n                    </a>\n                </div>\n            </div>\n            <div class=\"columns\">\n                <div class=\"column\">\n                    <a class=\"panel-block px-5\" href=\"#/Logout\" onclick=\"_Pict.PictApplication.logout()\">\n                        <span class=\"panel-icon\">\n                            <i class=\"fas fa-sign-out has-text-primary-75\" aria-hidden=\"true\"></i>\n                        </span>\n                        <span class=\"has-text-primary-85\">Logout</span>\n                    </a>\n                </div>\n            </div>\n        </div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-ProfilePaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-ProfilePaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/ProfilePane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SamplesPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SamplesPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SamplesPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SamplesPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SamplePanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-SamplePanel-Header\" class=\"panel-heading pr-4 {~D:options.HeadlightPanels.Configuration.CurrentDocument.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-SamplePanel-Header-Icon\" class=\"fas fa-fw fa-vial\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-SamplePanel-Header-Title\">Samples</span>\n    </div>\n    <div id=\"HeadlightPanels-SamplePanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Samples~}\n    </div>\n    <!-- Sample Panel Tabs -->\n    <div id=\"HeadlightPanels-SamplePanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\t\n        <a id=\"HeadlightPanels-SamplePanel-Search-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Search', 'Sample')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-search\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Search\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-SamplePanel-Create-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Create', 'Sample')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-plus-circle\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Create\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-SamplePanel-Scan-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Scan', 'Sample')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-qrcode\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Scan QR Code\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-SamplePanel-Current-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample'); _Pict.views.SampleCurrent.handleTabOpened();\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-vial\"></i>\n            </span>\n            <span title=\"Samples on this document\" class=\"icon-text\">\n                Current\n            </span>\n        </a>\n    </div>\n    <!-- Sample Panel Content > Search View -->\n    <div id=\"HeadlightPanels-SamplePanel-Search-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"SampleSearch-Entry-Container\"></div>\n        <div id=\"SampleSearch-Results-Container\" class=\"overflow-scroll-container-for-search-results\" style=\"min-width: 40vw;\"></div>\n    </div>\n    <!-- Sample Panel Content > Create View -->\n    <div id=\"HeadlightPanels-SamplePanel-Create-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"SampleCreate-Container\" style=\"min-width: 40vw;\"><!-- Injected from Sample-View-Create.js --></div>\n    </div>\n    <!-- Sample Panel Content > Scan View -->\n    <div id=\"HeadlightPanels-SamplePanel-Scan-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"SampleScan-Container\" style=\"min-width: 40vw;\"><!-- Injected from Sample-View-Scan.js --></div>\n    </div>\n    <!-- Sample Panel Content > Current View -->\n    <div id=\"HeadlightPanels-SamplePanel-Current-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"SampleCurrent-Container\" style=\"min-width: 40vw;\"><!-- Injected from Sample-View-Current.js --></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SamplesPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SamplesPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SamplesPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SecretPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SecretPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SecretPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SecretPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SecretPanel\" class=\"panel is-active is-dark\">\n    <p id=\"HeadlightPanels-SecretPanel-Header\" class=\"panel-heading\">\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-person-from-portal\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Secrets</span>\n    </p>\n    <div id=\"HeadlightPanels-SecretPanel-Content\" class=\"panel-content\">\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.PictFormMetacontroller.showSupportViewInlineEditor();_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'close')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-wrench\" aria-hidden=\"true\"></i>\n            </span>\n            Open Support View Inline Tool\n        </a>\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.providers.DocumentProvider.viewDocumentFile(null, true)\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-code\" aria-hidden=\"true\"></i>\n            </span>\n            View Document JSON\n        </a>\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.HeadlightPaneSecret.handleDocumentRefreshAndDownload(event)\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-download\" aria-hidden=\"true\"></i>\n            </span>\n            Regenerate PDF Download\n        </a>\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.HeadlightPaneSecret.toggleMinimumInputLengthForSearch(0)\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-filter-slash\" aria-hidden=\"true\"></i>\n            </span>\n            Disable All \"Minimum Input Length\"\n        </a>\n        <div class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" style=\"align-items: normal;\">\n            <span class=\"panel-icon mt-1\">\n                <i class=\"fas fa-palette\" aria-hidden=\"true\"></i>\n            </span>\n            <div class=\"field theme-dark\">\n                <label class=\"label\" for=\"HeadlightPanels-SecretPanel-Theme\">Theme</label>\n                <p class=\"control select is-fullwidth\" style=\"min-width: 250px;\">\n                    <select id=\"HeadlightPanels-SecretPanel-Theme\" onchange=\"_Pict.PictApplication.changeTheme(event.target.value)\">\n                        <option value=\"Edit\" selected>Edit (Default)</option>\n                        <option value=\"Read\">Read-only/Locked</option>\n                        <option value=\"Print\">Print/PDF</option>\n                    </select>\n                </p>\n            </div>\n        </div>\n        <div class=\"panel-block\" style=\"align-items: normal;\">\n            <span class=\"panel-icon mt-1\">\n                <i class=\"fas fa-ruler\" aria-hidden=\"true\"></i>\n            </span>\n            <div class=\"field theme-dark\">\n                <label class=\"label\" for=\"HeadlightPanels-SecretPanel-Theme\">Left Panel Width</label>\n                <p class=\"control select is-fullwidth\" style=\"min-width: 250px;\">\n                    <select id=\"HeadlightPanels-SecretPanel-Theme\" onchange=\"_Pict.views.HeadlightPanels.setPanelCustomWidth('left', event.target.value)\">\n                        <option value=\"75\" selected>Default</option>\n                        <option value=\"0\">0% (Hidden)</option>\n                        <option value=\"20\">20% (1/5th)</option>\n                        <option value=\"25\">25% (1/4th)</option>\n                        <option value=\"33\">33% (1/3rd)</option>\n                        <option value=\"40\">40% (2/5th)</option>\n                        <option value=\"50\">50% (1/2)</option>\n                        <option value=\"60\">60% (3/5th)</option>\n                        <option value=\"67\">67% (2/3rd)</option>\n                        <option value=\"75\">75% (3/4th)</option>\n                        <option value=\"80\">80% (4/5th)</option>\n                        <option value=\"100\">100% (Full)</option>\n                    </select>\n                </p>\n            </div>\n        </div>\n        <div class=\"panel-block\" style=\"align-items: normal;\">\n            <span class=\"panel-icon mt-1\">\n                <i class=\"fas fa-ruler\" aria-hidden=\"true\"></i>\n            </span>\n            <div class=\"field theme-dark\">\n                <label class=\"label\" for=\"HeadlightPanels-SecretPanel-Theme\">Right Panel Width</label>\n                <p class=\"control select is-fullwidth\" style=\"min-width: 250px;\">\n                    <select id=\"HeadlightPanels-SecretPanel-Theme\" onchange=\"_Pict.views.HeadlightPanels.setPanelCustomWidth('right', event.target.value)\">\n                        <option value=\"25\" selected>Default</option>\n                        <option value=\"0\">0% (Hidden)</option>\n                        <option value=\"20\">20% (1/5th)</option>\n                        <option value=\"25\">25% (1/4th)</option>\n                        <option value=\"33\">33% (1/3rd)</option>\n                        <option value=\"40\">40% (2/5th)</option>\n                        <option value=\"50\">50% (1/2)</option>\n                        <option value=\"60\">60% (3/5th)</option>\n                        <option value=\"67\">67% (2/3rd)</option>\n                        <option value=\"75\">75% (3/4th)</option>\n                        <option value=\"80\">80% (4/5th)</option>\n                        <option value=\"100\">100% (Full)</option>\n                    </select>\n                </p>\n            </div>\n        </div>\n        <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'open')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-chevron-left\" aria-hidden=\"true\"></i>\n            </span>\n            Back to Actions\n        </a>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SecretPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SecretPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SecretPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SettingsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SettingsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SettingsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SettingsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SettingsPanel\" class=\"panel is-active is-dark\">\n    <p id=\"HeadlightPanels-SettingsPanel-Header\" class=\"panel-heading\">\n        <button type=\"button\" class=\"is-pulled-right hl-panel-close-button\" aria-label=\"close\" title=\"Close panel\" onclick=\"_Pict.views.HeadlightPanels.handlePanelToggle('navigation', 'close')\">\n            <span class=\"icon\">\n                <i class=\"fas fa-fw fa-times-circle\" aria-hidden=\"true\"></i>\n            </span>\n        </button>\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-cogs\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Settings</span>\n    </p>\n    <div id=\"HeadlightPanels-SettingsPanel-Content\" class=\"panel-content\">\n        <a id=\"setting-DocumentTheme-light\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleDocumentColorTheme('light')\">\n        <span class=\"panel-icon\">\n            <i class=\"fas fa-sun\" aria-hidden=\"true\"></i>\n        </span>\n            Set Light Theme\n        </a>\n        <a id=\"setting-DocumentTheme-dark\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleDocumentColorTheme('dark')\">\n        <span class=\"panel-icon\">\n            <i class=\"fas fa-moon\" aria-hidden=\"true\"></i>\n        </span>\n            Set Dark Theme\n        </a>\n        <a id=\"setting-DocumentTheme-system\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleDocumentColorTheme('system')\">\n        <span class=\"panel-icon\">\n            <i class=\"fas fa-desktop\" aria-hidden=\"true\"></i>\n        </span>\n            Use System Theme\n        </a>\n\n        <!-- TODO: Revisit these once we separate out \"sticky panel that won't close\" vs \"flex background content shifts when panel opens/closes\" -->\n        <!-- <a id=\"setting-PanelOverlap-left\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.togglePanelOverlap('left')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-chevron-circle-right\" aria-hidden=\"true\"></i>\n            </span>\n            Panels Overlap Left\n        </a>\n        <a id=\"setting-PanelOverlap-right\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.togglePanelOverlap('right')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-chevron-circle-left\" aria-hidden=\"true\"></i>\n            </span>\n            Panels Overlap Right\n        </a> -->\n\n        <!-- TODO: Revisit these when we build a top nav that other apps can hook into via configuration -->\n        <!-- <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleNavbarLocation()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-arrow-up-arrow-down\" aria-hidden=\"true\"></i>\n            </span>\n            Toggle Navbar Location\n        </a>\n        <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleLeftyMode()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-right-left\" aria-hidden=\"true\"></i>\n            </span>\n            Toggle Left-hand Mode\n        </a> -->\n\n        <!-- TODO: Invest time into this panel to allow custom options to be pushed in per app -->\n        <a id=\"setting-PrinterCodes\" class=\"panel-block is-hidden\" href=\"#/Printer-Codes\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-print\" aria-hidden=\"true\"></i>\n            </span>\n            QR Printer Codes\n        </a>\n        <a id=\"setting-HelpText\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleHelpText()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-question-circle\" aria-hidden=\"true\"></i>\n            </span>\n            Toggle Help Text\n        </a>\n\n        <!-- Auto-save preferences. Hidden wholesale by syncAutoSaveSettings() in applications that have\n             no form to save (LIMS, the configuration apps) or whose navbar offers no Save button. -->\n        <a id=\"setting-AutoSave\" class=\"panel-block is-hidden\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleAutoSave()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-clock-rotate-left\" aria-hidden=\"true\"></i>\n            </span>\n            Auto-save this form\n        </a>\n        <div id=\"setting-AutoSaveIntervalSeconds\" class=\"panel-block hl-autosave-interval-block is-hidden\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-stopwatch\" aria-hidden=\"true\"></i>\n            </span>\n            <label class=\"hl-autosave-interval\" for=\"setting-AutoSaveIntervalSeconds-Input\">\n                <span>Auto-save every</span>\n                <input\n                    id=\"setting-AutoSaveIntervalSeconds-Input\"\n                    class=\"input is-small hl-autosave-interval-input\"\n                    type=\"number\"\n                    min=\"15\"\n                    max=\"3600\"\n                    step=\"1\"\n                    value=\"90\"\n                    onchange=\"_Pict.views.HeadlightPaneSettings.setAutoSaveInterval(this.value)\"\n                />\n                <span>seconds</span>\n            </label>\n        </div>\n        <p id=\"setting-AutoSave-Note\" class=\"panel-block hl-autosave-note is-hidden\">\n            Auto-save is turned off for this form type.\n        </p>\n        <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'open')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-chevron-left\" aria-hidden=\"true\"></i>\n            </span>\n            Back to Actions\n        </a>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SettingsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SettingsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SettingsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SolverPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SolverPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SolverPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SolverPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SolverPanel\" class=\"panel is-active is-warning\">\n    <p id=\"HeadlightPanels-SolverPanel-Header\" class=\"panel-heading\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-calculator\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Solver Logs</span>\n    </p>\n    <div id=\"HeadlightPanels-SolverPanel-Content\" class=\"panel-content\">\n        <div id=\"Pict-Form-Solver-In-Panel-Wrapper\" class=\"overflow-scroll-container\"></div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SolverPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SolverPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SolverPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-StatusPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-StatusPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-StatusPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-StatusPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-StatusPanel\" class=\"panel is-active\">\n    <p id=\"HeadlightPanels-StatusPanel-Status-Header\" class=\"panel-heading {~D:Pict.settings.HeadlightPanels.Configuration.CurrentStatus.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-StatusPanel-Status-Header-Icon\" class=\"fas fa-fw {~D:Pict.settings.HeadlightPanels.Configuration.CurrentStatus.iconClass~}\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-StatusPanel-Status-Header-Title\">{~D:AppData.DocumentData.ReportData.Status~}</span>\n    </p>\n    <!-- Status Panel Tabs -->\n    <p id=\"HeadlightPanels-StatusPanel-Tabs\" class=\"panel-tabs\">\n        <a id=\"HeadlightPanels-StatusPanel-Approval-Actions-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-Approval-Actions', 'Status')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-clipboard\"></i>\n            </span>\n            <span title=\"Status\" class=\"icon-text\">\n                Status\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-StatusPanel-History-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-History', 'Status')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-clock\"></i>\n            </span>\n            <span title=\"History\" class=\"icon-text\">\n                History\n            </span>\n        </a>\n        <!--<a id=\"HeadlightPanels-StatusPanel-Workflow-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-Workflow', 'Status')\">Workflow</a>-->\n        <a id=\"HeadlightPanels-StatusPanel-Users-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-Users', 'Status')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-users\"></i>\n            </span>\n            <span title=\"Users\" class=\"icon-text\">\n                Users\n            </span>\n        </a>\n    </p>\n    <!-- Status Panel Content > Approval Actions View -->\n    <div id=\"HeadlightPanels-StatusPanel-Approval-Actions-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div class=\"panel-block skeleton-block has-background-text-40\"></div>\n    </div>\n    <!-- Status Panel Content > History View -->\n    <div id=\"HeadlightPanels-StatusPanel-History-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div class=\"panel-block skeleton-block has-background-text-40\"></div>\n    </div>            \n    <!-- Status Panel Content > Workflow View -->\n    <div id=\"HeadlightPanels-StatusPanel-Users-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div class=\"panel-block skeleton-block has-background-text-40\"></div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-StatusPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-StatusPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/StatusPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-ValidationsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-ValidationsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-ValidationsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-ValidationsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-ValidationsPanel\" class=\"panel is-active is-danger\">\n    <p id=\"HeadlightPanels-ValidationsPanel-Header\" class=\"panel-heading\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-triangle-exclamation\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Validation Logs</span>\n    </p>\n    <div id=\"HeadlightPanels-ValidationsPanel-Content\" class=\"panel-content\">\n        <div class=\"overflow-scroll-container\">\n            {~TIfAbs:HeadlightPanels-ValidationPanel-EmptyMessage:Record:Pict.views.HeadlightPaneValidations.HeadlightPaneValidationLog.length^==^0~}\n            {~T:HeadlightPanels-ValidationPanel-Content~}\n        </div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-ValidationsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-ValidationsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/ValidationsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    }
}
},{}],815:[function(require,module,exports){
arguments[4][397][0].apply(exports,arguments)
},{"dup":397}],816:[function(require,module,exports){
arguments[4][398][0].apply(exports,arguments)
},{"../package.json":815,"dup":398}],817:[function(require,module,exports){
arguments[4][692][0].apply(exports,arguments)
},{"dup":692}],818:[function(require,module,exports){
arguments[4][693][0].apply(exports,arguments)
},{"../package.json":817,"dup":693,"fable-serviceproviderbase":816}],819:[function(require,module,exports){

const Util = require('util');

const libPictSectionRecordSet = require('pict-section-recordset');

const libPictSectionForm = require('pict-section-form');

const libPictPreprocessor = require('pict-template-preprocessor');

const libHeadlightConfigurableApplication = require('headlight-configurable-application');

// Providers
const libLIMSRouter = require('./providers/LIMS-Router.js');

const libEntityProvider = require('./providers/Entity-Provider.js');

const HeadlightDynamicInputsBundle = require('headlight-dynamic-inputs-bundle');
const libVocabularySelectorMap = require('headlight-dynamic-inputs-bundle/source/providers/_VocabularySelectorMap.js');

// Views
const configEmptyView = require('./views/Empty.json');
const LIMSPrinterCodes = require('./views/Printer-Codes.js');
const LIMSTestbed = require('./views/LIMS-Testbed.js');
const LIMSLocationRecordView = require('./views/Location-Record-View.js');
const LIMSSampleRecordCreate = require('./views/Sample-Record-Create.js');
const LIMSLocationRecordCreate = require('./views/Location-Record-Create.js');
const LIMSSampleRecordEdit = require('./views/Sample-Record-Edit.js');
const LIMSLocationRecordEdit = require('./views/Location-Record-Edit.js');
const LIMSSampleRecordView = require('./views/Sample-Record-View.js');
const LIMSDocumentRecordEdit = require('./views/Document-Record-Edit.js');
const LIMSDocumentRecordView = require('./views/Document-Record-View.js');
const LIMSDocumentRecordCreate = require('./views/Document-Record-Create.js');
const LIMSSamplePlanCopy = require('./views/SamplePlan-Copy.js');


const libDynamicRecordsetSolver = require('pict-section-recordset/source/providers/RecordSet-DynamicRecordsetSolver.js');
const libFilterDataProvider = require('pict-section-recordset/source/providers/Filter-Data-Provider.js');
const libFilterPersistenceView = require('pict-section-recordset/source/views/Filter-PersistenceView.js');

const customLoginPageOptions = {
	title: 'HeadLight LIMS',
	titleStyles: `
		z-index: 1;
		text-shadow:  5px 9px 2px var(--bulma-black);
		word-wrap: break-word;
		overflow-wrap: break-word;
		text-align: center;
		font-size: 4rem !important; /* Default size */
		margin: 0 0 5vh 0;	/* Default margin */`,
	wallpaperStyles: `
		background-image: url('../../images/headlight-samples.jpg');
		background-size: cover;
		background-repeat: no-repeat;
		background-color: var(--bulma-grey);
		background-blend-mode: multiply;`,
	closePanelsOnLogout: true,
};

/**
 * @typedef {Object} Anticipate
 * @property {(fNext: (error?: any) => any) => void} anticipate - Add a function to the serial async queue.
 * @property {() => ((error?: any) => any)} buildAnticipatorCallback - Don't know.
 * @property {(fCallback: (error?: any) => any) => void} wait - Wait for the serial async queue to complete and return the final result.
 */

/**
 * FIXME: figure out how to flow these types through in a more sane way....
 * @typedef {import('headlight-configurable-application').Pict &
 * {
 *   HeadlightRestClient: import('headlight-rest-client'),
 *   ManifestPackagingService: import('manifest-packaging-service'),
 *   providers:
 *   {
 *		  RecordExtension: import('./providers/RecordExtension-Provider.js'),
 *		  FormInitialBundle: InstanceType<typeof import('./providers/FormInitialBundle-Provider.js')>,
 *   },
 *   MetaTemplate: any, // import('fable').MetaTemplate,
 *   PictApplication: LIMS,
 *   PictSectionRecordSet: InstanceType<libPictSectionRecordSet>,
 *   PictRouter: import('pict-router'),
 *   fable: import('fable') & import('pict'),
 *   newAnticipate: () => Anticipate,
 *   log: any,
 *   newManyfest: (manifest: any) => any
 *   options: any,
 * 	 RestClient: any,
 *   instantiateServiceProviderWithoutRegistration: (hash: string) => any,
 *   instantiateServiceProviderIfNotExists: (hash: string) => any,
 *   TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking'),
 * }} LIMSPict
 */


class LIMS extends libHeadlightConfigurableApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {string} */
		this.cachedLogoutRoute = null;
		/** @type {LIMSPict} */
		this.pict;

		this.navInitialized = false;

		this.rnis = [];
		/** @type {Promise<Array<any>>|null} */
		this._reportNamedInstanceLoad = null;
		/** @type {number|null} */
		this._reportNamedInstanceCustomer = null;

		// Register and instantiate -- wrappers install automatically
		this.pict.addServiceType('PictTemplatePreprocessor', libPictPreprocessor);
		this.pict.instantiateServiceProvider('PictTemplatePreprocessor');

		// Add the pict form service
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);
		// for filter data/persistence management
		this.pict.addProvider('FilterDataProvider', libFilterDataProvider.default_configuration, libFilterDataProvider);
		this.pict.addView('FilterPersistenceView', libFilterPersistenceView.default_configuration, libFilterPersistenceView);

		this.pict.addAndInstantiateServiceType('ManifestPackagingService', require('manifest-packaging-service'));
		this.pict.addServiceType('PictSectionRecordSet', libPictSectionRecordSet);
		this.dynamicInputsBundle = new HeadlightDynamicInputsBundle(this.pict);
		this.dynamicInputsBundle.attachProviders();
		this.pict.addProvider('EntityDocumentProvider', { Entity: 'Document' }, libEntityProvider);
		this.pict.addProvider('ModulesProvider', { }, require('../../providers/ModulesProvider.js'));
		this.pict.addProvider('MarkdownProvider', { }, require('../../providers/MarkdownProvider.js'));
		this.pict.addProvider('ComplexFilterProvider',
		{
			endCapTemplate: '<span class="is-hidden-mobile">{~CreateEntityButton:Record~}</span>',
		},
		require('../../providers/ComplexFilterProvider.js'));
		this.pict.addProvider('ImprovedTabularRecordSetProvider',
		{
			endCapTemplate: '<span class="is-hidden-desktop is-hidden-tablet">{~CreateEntityButton:Record~}</span>',
			includePrint: true,
			overrideURLTemplate: `#/{~D:Record.Payload.Payload.RecordSet~}/{~DVBK:Record.Payload.Data:Record.Payload.Payload.GUIDAddress~}`,
		},
		require('../../providers/ImprovedTabularRecordSetProvider.js'));
		this.pict.addProvider('RecordExtension', { }, require('./providers/RecordExtension-Provider.js'));
		this.pict.addProvider('FormInitialBundle', { }, require('./providers/FormInitialBundle-Provider.js'));
		this.pict.addProvider('EntityCacheConfigurationProvider', { }, require('../../providers/EntityCacheConfigurationProvider.js'));

		this.AppData.Interactive = true;

		this.AppData.listConfigurations = {};

		this.AppData.SampleStatuses = [];

		this.AppData.disableSampleCreate = false;
		this.AppData.disableSampleEdit = false;
		this.PermissionsControl = new window.PermissionsControl({ CacheNamespace: 'LIMS', CacheExpirationMinutes: 2 });
		this.PermissionsControl.clear();

		// Application usability views
		this.pict.addView('Empty', configEmptyView);
		this.pict.addView('Jumbotron', require('./views/Jumbotron.js').default_configuration, require('./views/Jumbotron.js'));
		this.pict.addView('LIMSPrinterCodes', LIMSPrinterCodes.default_configuration, LIMSPrinterCodes);
		this.pict.addView('LIMSTestbed', LIMSTestbed.default_configuration, LIMSTestbed);
		this.pict.addView('LIMSLocationRecordView', LIMSLocationRecordView.default_configuration, LIMSLocationRecordView);
		this.pict.addView('LIMSLocationRecordEdit', LIMSLocationRecordEdit.default_configuration, LIMSLocationRecordEdit);
		this.pict.addView('LIMSLocationRecordCreate', LIMSLocationRecordCreate.default_configuration, LIMSLocationRecordCreate);
		this.pict.addView('LIMSDocumentRecordView', LIMSDocumentRecordView.default_configuration, LIMSDocumentRecordView);
		this.pict.addView('LIMSDocumentRecordEdit', LIMSDocumentRecordEdit.default_configuration, LIMSDocumentRecordEdit);
		this.pict.addView('LIMSDocumentRecordCreate', LIMSDocumentRecordCreate.default_configuration, LIMSDocumentRecordCreate);
		this.pict.addView('LIMSSampleRecordCreate', LIMSSampleRecordCreate.default_configuration, LIMSSampleRecordCreate);
		this.pict.addView('LIMSSampleRecordEdit', LIMSSampleRecordEdit.default_configuration, LIMSSampleRecordEdit);
		this.pict.addView('LIMSSampleRecordView', LIMSSampleRecordView.default_configuration, LIMSSampleRecordView);
		this.pict.addView('LIMSSamplePlanCopy', LIMSSamplePlanCopy.default_configuration, LIMSSamplePlanCopy);
		this.pict.addServiceType('SamplePlanService', require('headlight-lims-sampleplan'));

		this.sharedBundleConfig =
		[
			{
				'Entity': 'ListDefault',
				'Filter': 'FBV~NamespaceKey~EQ~Misc~FBV~NamespaceValue~EQ~Container',
				'Destination': 'AppData.Containers',
			},
			{
				'Entity': 'ListDefault',
				'Filter': 'FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~Country',
				'Destination': 'AppData.SourceCountries',
			},
			{
				'Entity': 'ListDefault',
				'Filter': 'FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State',
				'Destination': 'AppData.SourceStates',
			},
			{
				'Entity': 'Location',
				'Filter': 'FBV~IDLocation~GT~0',
				'Destination': 'AppData.Locations',
			},
		];

		this.dynamicInputsBundle.attachInstructions();

		this.pict.MetaTemplate.addPattern('{~ParseSourceLocation:', '~}', (pHash, pData, fCallback) =>
		{
			const record = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.formatLocation(record.Extension.SourceCity, record.Extension.SourceState, record.Extension.SourceCountry);
		});
		this.pict.MetaTemplate.addPattern('{~DateFormatLIMS:', '~}', (pHash, pData, fCallback) =>
		{
			// format the passed date or fallback to CreateDate
			const [ tmpDataAddress, tmpDateFormat ] = pHash.split('^');
			const tmpDate = this.pict.resolveStateFromAddress(tmpDataAddress, pData, fCallback) ||
				this.pict.resolveStateFromAddress(tmpDataAddress.split('.').slice(0, -1).join('.') + '.CreateDate', pData, fCallback);
			return tmpDate ? this.pict.fable.Dates.dayJS(tmpDate).format(tmpDateFormat) : '';
		});
		this.pict.MetaTemplate.addPattern('{~DateFormatNoFallback:', '~}', (pHash, pData, fCallback) =>
		{
			// format the passed date or fallback to CreateDate
			const [ tmpDataAddress, tmpDateFormat ] = pHash.split('^');
			const tmpDate = this.pict.resolveStateFromAddress(tmpDataAddress, pData, fCallback);
			return tmpDate && this.pict.fable.Dates.dayJS(tmpDate).isValid() ? this.pict.parseTemplate(`{~DateFormat:${tmpDataAddress}^${tmpDateFormat}~}`, pData) : '';
		});
		this.pict.MetaTemplate.addPattern('{~DocumentTypeName:', '~}', (pHash, pData, fCallback) =>
		{
			const hash = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let type = '';
			for (const r of this.rnis)
			{
				if (r?.Hash === hash)
				{
					type = r.Name;
				}
			}
			return type;
		});
		this.pict.MetaTemplate.addPattern('{~SampleStatusName:', '~}', (pHash, pData, fCallback) =>
		{
			return this.resolveSampleStatusName(this.pict.resolveStateFromAddress(pHash, pData, fCallback));
		});
		this.pict.MetaTemplate.addPattern('{~CreateEntityButton:', '~}', (pHash, pData, fCallback) =>
		{
			const supportedEntities = [ 'Location', 'Sample' ];
			let createSupported = false;
			let entity = '';
			for (const e of supportedEntities)
			{
				if (window.location.href.includes(`${ e }/List`))
				{
					createSupported = true;
					entity = e;
				}
			}
			if (entity == 'Sample' && this.AppData.disableSampleCreate)
			{
				createSupported = false;
			}
			return createSupported ? /*html*/`
				<div class="column has-text-right is-narrow pl-0">
					<a href="#/Create-${ entity }" class="button is-info">
						<span class="icon">
							<i class="fas fa-plus"></i>
						</span>
						<span class="icon-text">Create New ${ entity }</span>
					</a>
				</div>
			` : '';
		});
		this.pict.MetaTemplate.addPattern('{~SampleClasses:', '~}', (pHash, pData, fCallback) =>
		{
			return window.location.href.includes('/Sample/List') ? 'has-6-cols' : 'has-5-cols';
		});
		this.pict.TemplateProvider.addTemplate('User-Name', /*html*/`
			{~D:Record.NameFirst~} {~D:Record.NameLast~}
		`);
		this.pict.TemplateProvider.addTemplate('Entity-Name', /*html*/`
			{~D:Record.Name~}
		`);
		this.pict.addProviderSingleton('DynamicRecordsetSolver', libDynamicRecordsetSolver.default_configuration, libDynamicRecordsetSolver);
	}

	formatLocation(city, state, country)
	{
		if (!city && !state && !country)
		{
			return '';
		}
		else if (city && state)
		{
			return `${ city }, ${ state }`;
		}
		else if ((city && country) || (state && country))
		{
			return `${ city || '---' }, ${ state || '---' }, ${ country || '---' }`;
		}
		else
		{
			return city || state || country;
		}
	}

	async onBeforeRenderAsync(fCallback)
	{
		this.pict.log.info('LIMS onBeforeRenderAsync');
		if (this.loggedIn)
		{
			await this.loadReportNamedInstances();
		}
		return super.onBeforeRenderAsync(fCallback);
	}

	/**
	 * The customer's ReportNamedInstances, loaded once per customer.
	 *
	 * Both the app render hook and the post-login setup want these, and the read behind them
	 * (DocumentProvider.getReportNamedInstancesByCustomer) is an uncached paged entity-set fetch, so
	 * they used to each hit the wire at startup. They now share one in-flight promise. A failed load
	 * clears the memo so the next ask retries.
	 *
	 * @return {Promise<Array<any>>} - The customer's ReportNamedInstance records.
	 */
	async loadReportNamedInstances()
	{
		const tmpIDCustomer = this.AppData.CurrentUser?.CustomerID;
		if (!this._reportNamedInstanceLoad || (this._reportNamedInstanceCustomer !== tmpIDCustomer))
		{
			this._reportNamedInstanceCustomer = tmpIDCustomer;
			this._reportNamedInstanceLoad = this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(tmpIDCustomer)
				.then((pReportNamedInstances) =>
				{
					this.rnis = pReportNamedInstances;
					return pReportNamedInstances;
				})
				.catch((pError) =>
				{
					this._reportNamedInstanceLoad = null;
					throw pError;
				});
		}
		return this._reportNamedInstanceLoad;
	}

	/**
	 * The customer's curated SampleStatus vocabulary — a small code list, read in full, used to label
	 * the Sample list's Status column. Mirrors the read the SampleStatusSelector input type does
	 * (meadow pluralizes a scope by appending an 's', hence `SampleStatuss`). A customer that has
	 * curated no rows resolves to an empty list, and the default labels are used instead.
	 *
	 * @return {Promise<void>}
	 */
	async loadSampleStatusVocabulary()
	{
		this.AppData.SampleStatuses = await new Promise((resolve) =>
		{
			this.pict.HeadlightRestClient.getJSON('SampleStatuss/FilteredTo/FSF~Ordinal~ASC~0/0/500', (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords))
				{
					this.pict.log.warn(`Could not load the SampleStatus vocabulary; falling back to the default status labels: ${pError?.message || pError || 'unexpected payload'}`);
					return resolve([]);
				}
				resolve(pRecords);
			});
		});
	}

	/**
	 * Sample.Status persists the SampleStatus code ('RECV'), not a display name, so anywhere the raw
	 * column is rendered it reads as a hash. Resolve it against the customer's curated vocabulary,
	 * falling back to the same default list the SampleStatusSelector input type uses, and finally to
	 * the raw code for a status nobody has a label for.
	 *
	 * @param {string} pStatus - The status code stored on the Sample record.
	 * @return {string} - The display name.
	 */
	resolveSampleStatusName(pStatus)
	{
		if (!pStatus)
		{
			return '';
		}
		for (const tmpStatus of this.AppData.SampleStatuses || [])
		{
			if (tmpStatus?.Hash === pStatus)
			{
				return tmpStatus.Name || pStatus;
			}
		}
		for (const tmpFallbackStatus of libVocabularySelectorMap.DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS)
		{
			if (tmpFallbackStatus.id === pStatus)
			{
				return tmpFallbackStatus.text;
			}
		}
		return pStatus;
	}

	/**
	 * Force the record set list/dashboard cells that need an app-level renderer onto the right
	 * template, whatever composed them.
	 *
	 * A column with no explicit ValueTemplate falls to the generic ProcessCell renderer, which only
	 * resolves ID* foreign keys and otherwise prints the raw column value — so Sample.Status shows as
	 * `RECV`. The in-repo list manifest declares the right template for its own Status descriptor, but
	 * the column chooser's schema tier and any database manifest that supersedes it do not, so the
	 * composed cells get rewritten here instead.
	 *
	 * onBeforeRenderList is the recordset section's host seam: it runs after the cells are composed and
	 * again on every repaint (a chooser toggle, a page change), and the cells it is handed are per-paint
	 * shallow copies, so mutating them never bleeds into the shared manifest.
	 */
	overrideRecordSetValueTemplates()
	{
		const tmpValueTemplateOverrides =
		{
			Sample: { Status: '{~SampleStatusName:Record.Payload.Status~}' },
		};
		const fApplyValueTemplateOverrides = (pRecordListData) =>
		{
			const tmpOverrides = tmpValueTemplateOverrides[pRecordListData?.RecordSetConfiguration?.Entity];
			if (!tmpOverrides || !Array.isArray(pRecordListData.TableCells))
			{
				return pRecordListData;
			}
			for (const tmpCell of pRecordListData.TableCells)
			{
				if (tmpCell && (tmpCell.Key in tmpOverrides))
				{
					// New object rather than an in-place edit: PictDashboard is still the manifest's own.
					tmpCell.PictDashboard = Object.assign({}, tmpCell.PictDashboard, { ValueTemplate: tmpOverrides[tmpCell.Key] });
				}
			}
			return pRecordListData;
		};
		for (const tmpView of [ this.pict.PictSectionRecordSet?.childViews?.list, this.pict.PictSectionRecordSet?.childViews?.dashboard ])
		{
			if (!tmpView || tmpView._limsValueTemplateOverridesInstalled)
			{
				continue;
			}
			const fBaseOnBeforeRenderList = tmpView.onBeforeRenderList.bind(tmpView);
			tmpView.onBeforeRenderList = (pRecordListData) => fApplyValueTemplateOverrides(fBaseOnBeforeRenderList(pRecordListData));
			tmpView._limsValueTemplateOverridesInstalled = true;
		}
	}

	/**
	 * This will change later but for now this can be called when needed to set the columns to display on the record set list view for Samples.
	 */
	async setSampleListColumns()
	{
		if (!this.loggedIn)
		{
			return;
		}
		// TODO: this is dumb, we need to genericize display names of stuff somewhere.
		const sampleColumnDisplayNameLookup =
		{
			'IDSample': 'Sample ID',
			'GUIDSample': 'Sample GUID',
			'CreateDate': 'Create Date',
			'CreatingIDUser': 'Logged By',
			'UpdateDate': 'Update Date',
			'UpdatingIDUser': 'Updating User',
			'DesignatedTime': 'Sampled On',
			'Deleted': 'Deleted',
			'DeleteDate': 'Delete Date',
			'DeletingIDUser': 'Deleting User',
			'ExternalSyncDate': 'External Sync Date',
			'IDCustomer': 'Customer',
			'QRCode': 'QR Code',
			'CaptureLatitude': 'Capture Latitude',
			'CaptureLongitude': 'Capture Longitude',
			'Name': 'Name',
			'IDProject': 'Project',
			'ParentIDSample': 'Parent Sample',
			'IDMaterial': 'Material',
			'IDProductionPlant': 'Production Plant',
			'IDLineItem': 'Line Item',
			'Notes': 'Notes',
			'Status': 'Status',
			'LabControlNumber': 'PSID', //NOTE: paragon specific
			'LabReferenceNumber': 'Lab Reference Number',
			'ProductName': 'Product Name',
			'MaterialType': 'Material Type',
			'IDOrganization': 'Producer',
			'IDMixDesign': 'Mix Design',
			'ManufacturerCode': 'Manufacturer Code',
			'IntendedUse': 'Intended Use',
			'BuyUSA': 'Buy USA',
			'ReceivedFrom': 'Source',
			'GeographicalArea': 'Geographical Area',
			'Station': 'Station',
			'Offset': 'Offset',
			'RepresentedQuantity': 'Represented',
			'SampledQuantity': 'Sampled Quantity',
			'SampledQuantityUnits': 'Sampled Quantity Units',
			'RepresentedQuantityUnits': 'Represented Quantity Units',
			'Units': 'Units',
			'RequestedBy': 'Requested By',
			'ExternalSyncGUID': 'External Sync GUID',
			'IDProduct': 'Product',
			'SampledByIDUser': 'Sampled By',
			'WitnessIDUser': 'Witness',
			'AuthorizedIDUser': 'Authorized By',
			'CMSIDUser': 'CMS User',
			'Datum': 'Datum',
		};
		await this.pict.providers.FieldSettingsProvider.registerNamespaceByEntity('SampleList', 'Sample', 'List', false, [ 'IDMaterial' ]);
		// Update the shown colums based on config.
		if (this.pict?.PictSectionRecordSet?.recordSetProviderConfigurations?.Sample)
		{
			this.pict.PictSectionRecordSet.recordSetProviderConfigurations.Sample.RecordSetListColumns = [];
			for (const f of this.pict.providers.FieldSettingsProvider.getShownFields('SampleList'))
			{
				this.pict.PictSectionRecordSet.recordSetProviderConfigurations.Sample.RecordSetListColumns.push(
					{
						Key: f,
						DisplayName: sampleColumnDisplayNameLookup[f],
					},
				);
			}
		}
	}

	/**
	 * This will change later but for now this can be called when needed to set the columns to display on the record set list view for Locations.
	 */
	async setLocationListColumns()
	{
		if (!this.loggedIn)
		{
			return;
		}
		// TODO: this is dumb, we need to genericize display names of stuff somewhere.
		const locationColumnDisplayNameLookup =
		{
			'IDLocation': 'Location ID',
			'GUIDLocation': 'Location GUID',
			'CreateDate': 'Create Date',
			'CreatingIDUser': 'Creating User',
			'UpdateDate': 'Update Date',
			'UpdatingIDUser': 'Updating User',
			'Deleted': 'Deleted',
			'DeleteDate': 'Delete Date',
			'DeletingIDUser': 'Deleting User',
			'ExternalSyncDate': 'External Sync Date',
			'Type': 'Type',
			'Name': 'Name',
			'Description': 'Description',
			'QRCode': 'QR Code',
			'Address': 'Address',
			'ExternalLocationID': 'External Location',
			'ParentIDLocation': 'Parent Location',
			'City': 'City',
			'State': 'State',
			'Zip': 'Zip Code',
			'Phone': 'Phone Number',
			'Latitude': 'Latitude',
			'Longitude': 'Longitude',
			'IDCustomer': 'Customer',
		};
		await this.pict.providers.FieldSettingsProvider.registerNamespaceByEntity('LocationList', 'Location', 'List', false, [ 'Name' ]);
		// Update the shown colums based on config.
		if (this.pict?.PictSectionRecordSet?.recordSetProviderConfigurations?.Location)
		{
			this.pict.PictSectionRecordSet.recordSetProviderConfigurations.Location.RecordSetListColumns = [];
			for (const f of this.pict.providers.FieldSettingsProvider.getShownFields('LocationList'))
			{
				this.pict.PictSectionRecordSet.recordSetProviderConfigurations.Location.RecordSetListColumns.push(
					{
						Key: f,
						DisplayName: locationColumnDisplayNameLookup[f],
					},
				);
			}
		}
	}

	async logout(event)
	{
		// I think this should be a consistent method on the base class.
		this.pict.views.Empty.renderAsync(
			(pError) =>
			{
				super.logout(event);
			});
	}

	/**
	 * Show the jumbotron view - if the first time, render it, else just show it
	 */
	showJumbotron()
	{
		const tempJumbotronContainer = document.getElementById('Jumbotron');

		if (!tempJumbotronContainer)
		{
			this.pict.views.Jumbotron.renderAsync();
		}
		else
		{
			tempJumbotronContainer.classList.remove('is-hidden');
		}
	}

	/**
	 * Hide the jumbotron view
	 */
	hideJumbotron()
	{
		const tempJumbotronContainer = document.getElementById('Jumbotron');
		if (tempJumbotronContainer)
		{
			tempJumbotronContainer.classList.add('is-hidden');
		}
	}

	/**
	 * Paint a skeleton into a detail surface before its data lands, so the page doesn't sit as an
	 * empty frame and then pop. Every detail view renders with 'replace' into its destination, so
	 * the real render overwrites this with no teardown.
	 *
	 * @param {string} [pDestinationAddress] - Where to paint; defaults to the app container.
	 * @param {number} [pRowCount] - How many ghost field rows to draw.
	 * @param {boolean} [pIncludeHeader] - Draw the record header + tab strip placeholders (full-page shells only).
	 */
	showDetailLoadingShell(pDestinationAddress, pRowCount, pIncludeHeader)
	{
		try
		{
			const tmpDestination = pDestinationAddress || '#LIMS-Application-Container';
			const tmpRowCount = Math.max(1, Math.min(24, pRowCount || 6));
			const tmpIncludeHeader = (pIncludeHeader !== false);
			let tmpRows = '';
			for (let i = 0; i < tmpRowCount; i++)
			{
				tmpRows += '<div class="lims-detail-skeleton-row"></div>';
			}
			this.pict.ContentAssignment.assignContent(tmpDestination, /*html*/`
				<div class="lims-detail-loading">
					<div class="lims-detail-loading-inner">
						<span class="lims-detail-spinner" aria-hidden="true"><i class="fas fa-fw fa-circle-notch"></i></span>
						<span>Loading…</span>
					</div>
					<div class="lims-detail-skeleton" aria-hidden="true">
						${ tmpIncludeHeader ? '<div class="lims-detail-skeleton-header"></div><div class="lims-detail-skeleton-tabs"></div>' : '' }
						${ tmpRows }
						<div class="lims-detail-skeleton-fade"></div>
					</div>
				</div>`);
		}
		catch (error)
		{
			// The shell is purely cosmetic; never let it break a navigation.
			this.pict.log.warn(`Error rendering the LIMS detail loading shell: ${error.message || error}`);
		}
	}

	showProfile()
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Profile', 'open');
	}

	_updateUserProfile()
	{
		const session = this.AppData.CurrentUser;
		if (session?.LoggedIn)
		{
			let userHash = session.LoginID;
			if (!userHash)
			{
				userHash = session.Email;
			}
			if (!userHash)
			{
				userHash = `${session.NameFirst} ${session.NameLast}`;
			}
			if (!userHash)
			{
				userHash = 'no user name';
			}
			const userColor = this.pict.providers.UtilityProvider.stringToHSLColor(userHash, 75, 50);
			$('#Header_ProfileIcon').css('color', userColor);
			const name = $('#Header_ProfileName');
			name.text(`${session.NameFirst.charAt(0)}${session.NameLast.charAt(0)}`);
		}
		else
		{
			$('#Header_ProfileIcon').css('color', null); //FIXME: ??
			$('#Header_ProfileName').text('Profile');
		}
	}

	updateProgramDisplayInNav()
	{
		const session = this.AppData.CurrentUser;
		if (session?.LoggedIn)
		{
			// get elements
			const programImage = document.getElementById('Header_ProgramImage');
			const programName = document.getElementById('Header_ProgramName');

			if (!programImage || !programName || !(programImage instanceof HTMLImageElement))
			{
				this.pict.log.error('Could not find program image or name elements, or they are not of the expected type');
				return;
			}
			//check if program name exists
			if (this.AppData.Module?.ProgramName)
			{
				programName.textContent = this.AppData.Module.ProgramName;
			}
			//check if program image exists
			if (this.AppData.Module?.ProgramLogoURL)
			{
				programImage.src = this.AppData.Module.ProgramLogoURL;
			}
		}
	}


	/**
	 * Called during initialization to register templates.
	 */
	registerTemplates()
	{
		super.registerTemplates();
		const themeTemplateSets = this.customizeThemeTemplates(HeadlightDynamicInputsBundle.getThemeMap());
		for (const templateSet of Object.values(themeTemplateSets || { }))
		{
			this.pict.providers.PictFormSectionDefaultTemplateProvider.injectTemplateSet(templateSet);
		}
	}

	/**
	 * Change the theme to one of the available themes.
	 *
	 * @param {string} pTheme - The theme to change to.
	 */
	changeTheme(pTheme)
	{
		if (pTheme == this.theme)
		{
			return;
		}
		this.theme = pTheme;
		//FIXME: tried using print theme for read, but it is interactive ? ? ?
		const newTheme = 'PictProvider-Theme-' + (pTheme == 'Create' ? 'Edit' : pTheme == 'Read' ? 'Read' : pTheme);
		this.pict.log.info(`Changing theme to: ${newTheme}`);
		this.pict.views.PictFormMetacontroller.formTemplatePrefix = newTheme;
	}

	/**
	 * @typedef {Object} ThemeProvider
	 * @property {String} TemplatePrefix - The template prefix for the theme.
	 * @property {Array<Object>} Templates - The templates for the theme.
	 * TODO: this is probably incomplete, and definitely not living in the right place; move this eventually
	 */
	/**
	 * @typedef {{ [key: string]: ThemeProvider }} ThemeProviderMap
	 */
	/**
	 * Hook to customize theme providers.
	 *
	 * @param {ThemeProviderMap} templateSets - The template sets to customize.
	 * @return {ThemeProviderMap} The customized template sets.
	 */
	customizeThemeTemplates(templateSets)
	{
		return templateSets;
	}

	async onInitializeAsync(fCallback)
	{
		this.pict.views.PictFormMetacontroller.viewMarshalDestination = 'AppData';
		this.pict.instantiateServiceProvider('PictSectionRecordSet', this.options);
		this.pict.PictSectionRecordSet.sessionProviders.push(async (capability) =>
		{
			return this.pict.providers.SessionProvider.getSession().then((session) => session.LoggedIn).catch((error) => false);
		});
		this.pict.providers.SessionProvider.onSessionChange((pNewSession) =>
		{
			if (this.pict.views.HeadlightPanels)
			{
				this.pict.views.HeadlightPanels.closeAllPanels();
			}
		});
		//NOTE: this attaches listeners to the router when constructed, so we must do that before initializing the PSRS below, or we won't get hooks for its routes
		this.pict.addProvider('LIMSRouter', libLIMSRouter.default_configuration, libLIMSRouter);
		// Initialize the views for the foundation metacontroller service
		this.pict.PictSectionRecordSet.initialize();
		await super.onInitializeAsync(fCallback);
	}

	async onAfterInitializeAsync(fCallback)
	{
		try
		{
			this.pict.providers.ComplexFilterProvider.prepareComplexFilter();
			this.pict.providers.ImprovedTabularRecordSetProvider.prepareTable();
			this.overrideRecordSetValueTemplates();
			this.pict.PictSectionRecordSet.childViews.read.options.DefaultDestinationAddress = '#LIMS-Application-Container';
			this.pict.PictSectionRecordSet.childViews.list.options.DefaultDestinationAddress = '#LIMS-Application-Container';
			this.pict.PictSectionRecordSet.childViews.dashboard.options.DefaultDestinationAddress = '#LIMS-Application-Container';

			// set an event listener on the body for the escape to close any open modals
			document.body.addEventListener('keydown', (event) =>
			{
				if (event.key === 'Escape')
				{
					document.querySelectorAll('.modal').forEach((modal) =>
					{
						modal.classList.remove('is-active');
					});
				}
			});

			this._updateUserProfile();
			this.updateProgramDisplayInNav();
			const session = await this.pict.providers.SessionProvider.getSession();

			if (session.LoggedIn)
			{
				this.pict.options.Timezone = session.Timezone || 'America/Los_Angeles'; //TODO: are there cases where we need to do project level customization here?
				await this.loadSharedBundle();
			}
			this.pict.providers.QRCodeProvider.registerGlobalHandler((e) =>
			{
				console.log('[LIMS-Application-Web] Received QREvent: ', e);
				if (e.event === 'scanned-Sample' && e.payload?.GUIDSample)
				{
					window.open(`#/Sample/${ e.payload.GUIDSample }`, '_self');
				}
				if (e.event === 'open' && e.payload.length && e.payload[0] === 'cart')
				{
					this.pict.views.QRPanel.open();
				}
			});
			this.pict.providers.LIMSRouter.initialize();
			this.pict.providers.RecordSetRouter.initialize();
		}
		catch (error)
		{
			this.pict.log.error(`Error initializing LIMS: ${error.message || error}`);
		}
		finally
		{
			this.pict.views.PictFormMetacontroller.generateMetatemplate();
			super.onAfterInitializeAsync(fCallback);
		}
	}

	onAfterLoginAsync(fCallback)
	{
		super.onAfterLoginAsync(async (pError) =>
		{
			try
			{
				if (!this.loggedIn)
				{
					// set the login page background image
					this.pict.views.HeadlightLogin.customizeLoginPage(customLoginPageOptions);
				}
				else
				{
					//FIXME: need to fix the init flow so we aren't duplicating this in two places
					//FIXME: this does not exist...
					//this.AppData.Module = await this.pict.providers.ModulesProvider.getModuleByHash('LIMS_MANAGEMENT');
					this.pict.providers.RecordSetRouter.addRoutes(this.pict.providers.RecordSetRouter.pictRouter);
				}
			}
			catch (error)
			{
				this.pict.log.error(`Error during onAfterLoginAsync: ${error.message || error}`);
			}
			finally
			{
				fCallback(pError);
			}
		});
	}

	async loadSharedBundle()
	{
		await Util.promisify(this.pict.EntityProvider.gatherDataFromServer).bind(this.pict.EntityProvider)(this.sharedBundleConfig);
		this.seedReferenceEntityCache();
	}

	/**
	 * Push the shared bundle's already-loaded reference records into the entity record cache.
	 *
	 * Without this the Samples list re-reads storage locations a row at a time: the recordset's
	 * connected-entity prefetch only batches top-level ID* columns, so the list manifest's nested
	 * `{~E:Location^Record.Payload.Extension.StorageLocation^…~}` lookup falls through to a per-row
	 * EntityProvider.getEntity, which has no in-flight de-duplication. The whole Location set is
	 * already in hand from login, so it just needs to land in the bucket those lookups read.
	 *
	 * The bucket's 30 second default lifetime is also far too short for a set loaded once per
	 * session, hence the per-seed MaxAge.
	 */
	seedReferenceEntityCache()
	{
		const tmpSeeds =
		[
			{ Entity: 'Location', Records: this.AppData.Locations, IDField: 'IDLocation', MaxAge: 15 * 60 * 1000 },
		];
		for (const tmpSeed of tmpSeeds)
		{
			if (!Array.isArray(tmpSeed.Records) || !tmpSeed.Records.length)
			{
				continue;
			}
			try
			{
				this.pict.EntityProvider.initializeCache(tmpSeed.Entity);
				const tmpCache = this.pict.EntityProvider.recordCache[tmpSeed.Entity];
				tmpCache.maxAge = tmpSeed.MaxAge;
				tmpCache.maxLength = Math.max(tmpCache.maxLength, tmpSeed.Records.length);
				for (const tmpRecord of tmpSeed.Records)
				{
					if (tmpRecord && tmpRecord[tmpSeed.IDField])
					{
						tmpCache.put(tmpRecord, tmpRecord[tmpSeed.IDField]);
					}
				}
			}
			catch (error)
			{
				// Seeding is an optimization; a miss just means the old per-row reads.
				this.pict.log.warn(`Error seeding the ${tmpSeed.Entity} entity cache: ${error.message || error}`);
			}
		}
	}

	onInteractiveLogin()
	{
		this.navInitialized = false;
		this.PermissionsControl.clear();
		this.pict.ContentAssignment.assignContent('#LIMS-Application-Container', `<div class="is-loading-splash has-background-text-soft" style="z-index: 25"><h1 class="title">Loading...</h1></div>`);
		this.loginAsync((pError) =>
		{
				this.pict.providers.PictRouter.router.navigate('/');
				if (pError)
				{
					this.pict.log.error(`Error during login: ${pError.message || pError}`);
					return;
				}
		});
	}

	onLoadDataAsync(fCallback)
	{
		super.onLoadDataAsync((pError) =>
		{
			if (!this.loggedIn)
			{
				return fCallback(pError);
			}
			this.pict.providers.QRCodeProvider.initializeLogos();
			// gather the shared bundle data (dropdown values, etc.)
			this.loadSharedBundle().then(() => this.onAfterLogin()).catch((error) =>
			{
				this.pict.log.error(`Error loading shared bundle: ${error.message || error}`);
			}).finally(() =>
			{
				fCallback(pError);
			});
		});
	}

	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			//FIXME: Hack hiding the buttons because context is not being respected here... some sort of event life cycle thing again.
			//
			document.getElementById('HeadlightPanels-NavBar-Save-Button')?.classList?.add?.('is-hidden');
			document.getElementById('HeadlightPanels-NavBar-Solver-Button')?.classList?.remove?.('is-hidden');
			document.getElementById('HeadlightPanels-Navbar-Brand-Container')?.classList?.add?.('is-hidden');
			return fCallback(pError);
		});
	}

	async applySampleDisabledState()
	{
		const sampleCreateManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
		const sampleEditManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
		if (sampleCreateManifest && sampleCreateManifest.Descriptors && !Object.keys(sampleCreateManifest.Descriptors).length)
		{
			this.AppData.disableSampleCreate = true;
			document.getElementById('lims-nav-create-sample')?.classList?.add?.('is-hidden');
		}
		if (sampleEditManifest && sampleEditManifest.Descriptors && !Object.keys(sampleEditManifest.Descriptors).length)
		{
			this.AppData.disableSampleEdit = true;
		}
	}


	//FIXME: I think this should get called more than it is - ex. if you are already logged in on page load...?
	async onAfterLogin()
	{
		this.PermissionsControl.clear();
		const session = this.AppData.CurrentUser;
		// Apply the session to the permissions library.
		this.PermissionsControl.setSession(session);
		const appAccess = await this.PermissionsControl.checkModulePermission('LIMS');
		if ('Denied' == appAccess)
		{
			this.pict.views.HeadlightPanels.toast({ message: `You do not have permission to access the LIMS app.`, type: 'is-danger' });
			this.logout();
			return;
		}
		// Prefill the manifest cache with the set of entities to cache.
		await this.pict.ManifestPackagingService.primeManifestCache(null, [ 'Sample', 'Location', 'LineItem', 'Test', 'Document', 'Project', 'TestInstance' ]);
		const promiseSet = [];
		promiseSet.push(this.pict.ManifestPackagingService.loadRecordSetSchemasForProduct(null, [ 'List', 'Filter', 'Dashboard' ]).then(()=>
		{
			if (this.navInitialized)
			{
				return;
			}
			this.navInitialized = true;
			const nav = this.pict.ManifestPackagingService.constructDashboardNav();
			if (!document.querySelector('#LIMSNavbarTopBurgerButton > .navbar-start').innerHTML.includes(nav.topNav))
			{
				document.querySelector('#LIMSNavbarTopBurgerButton > .navbar-start').innerHTML += nav.topNav;
			}
			const navArray = 
			[
				{
					Hash: 'Scan Sample',
					Name: 'Scan Sample',
					Icon: 'fas fa-qrcode',
					Address: null,
					// TODO: This method of hiding tabs is a bit jank, should refactor at some point.
					NavigationHandler: `_Pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
					{
						_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Scan', 'Sample');
						const stuffToHide = ['HeadlightPanels-SamplePanel-Create-Tab', 'HeadlightPanels-SamplePanel-Search-Tab'];
						for (let s of stuffToHide)
						{
							document.getElementById(s)?.classList?.add?.('is-hidden');
						}
					});`,
					PanelSource: null,
				},
				{
					Hash: 'Scanning Cart',
					Name: 'Scanning Cart',
					Icon: 'fas fa-scanner-gun',
					Address: null,
					NavigationHandler: '_Pict.views.QRPanel.open()',
					PanelSource: null,
				},
				{
					Hash: 'Samples',
					Name: 'Samples',
					Icon: 'fas fa-flask',
					Address: '#/PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0',
					PanelSource: null,
				},
				{
					Hash: 'Documents',
					Name: 'Documents',
					Icon: 'fas fa-files',
					Address: '#/PSRS/Document/List',
					PanelSource: null,
				},
				{
					Hash: 'Locations',
					Name: 'Locations',
					Icon: 'fas fa-location-dot',
					Address: '#/PSRS/Location/List',
					PanelSource: null,
				},
				{
					Hash: 'LIMSTestbed',
					Name: 'LIMS Testbed',
					Icon: 'fas fa-vial',
					Address: '#/Testbed',
					PanelSource: null,
				}
			].concat(nav.sideNav).concat([
				{
					Hash: 'Settings',
					Name: 'Settings',
					Icon: 'fas fa-cog',
					Address: null,
					PanelSource: 'settings',
				},
			]);

			this.pict.views.HeadlightPanels.setPanelConfiguration({
				PanelOptions: {
					Context: 'LIMS',
				},
				CustomNavigationList: navArray,
			});
		}));
		const summaryManifestEntities = [ 'LineItem', 'Test', 'Document', 'Project', 'TestInstance' ];
		promiseSet.push(this.pict.ManifestPackagingService.loadQuickSummaryManifests(summaryManifestEntities, require('./views/defaultSummaryManifests.json')));
		const printableManifestEntities = [ 'Sample', 'Location' ];
		promiseSet.push(this.pict.ManifestPackagingService.loadPrintableManifests(printableManifestEntities, require('./views/defaultPrintableManifests.json')));
		promiseSet.push(this.applySampleDisabledState());
		promiseSet.push(this.loadReportNamedInstances());
		promiseSet.push(this.loadSampleStatusVocabulary());
		await Promise.all(promiseSet);

		if (Array.isArray(this.options.DefaultRecordSetConfigurations))
		{
			this.pict.services.PictSectionRecordSet.loadRecordSetConfigurationArray(this.options.DefaultRecordSetConfigurations);
		}

		if (session?.LoggedIn)
		{
			this.pict.options.Timezone = session.Timezone || 'America/Los_Angeles'; //TODO: are there cases where we need to do project level customization here?
			//FIXME: this does not exist...
			//this.AppData.Module = await this.pict.providers.ModulesProvider.getModuleByHash('LIMS_MANAGEMENT');
		}
		this._updateUserProfile();

		this.pict.AppData.JumbotronShown = false;
		this.updateProgramDisplayInNav();

		const tmpAnticipate = this.pict.newAnticipate();
		tmpAnticipate.anticipate(
			(fNext) =>
			{
				//NOTE: reading defaultRoute here as navigating to '/' if we are already there doesn't trigger the router
				const currentPath = this.pict.providers.PictRouter.router.getCurrentLocation()?.url;
				if (!currentPath || currentPath === '/')
				{
					let tmpRoute = this.cachedLogoutRoute;
					if (!tmpRoute || tmpRoute == '/')
					{
						tmpRoute = this.pict.providers.LIMSRouter.defaultRoute;
					}
					this.cachedLogoutRoute = null;
					this.pict.providers.PictRouter.navigate(tmpRoute);
				}
				//TODO: can this wait until nav is done? should it?
				fNext();
			});

		return new Promise((resolve, reject) =>
		{
			tmpAnticipate.wait((pError) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve();
			});
		});
	}
}

module.exports = LIMS;

module.exports.default_configuration = (
	{
		Name: 'LIMS',
		Hash: 'LIMSPictRecordSetApplication',
		InitializeOnLoad: true,
		AutoRender: false,
		Document:
	{
		Required: false,
	},
	});

module.exports.default_configuration.pict_configuration = (
	{
		'Product': 'LIMS',
		'ProductVersion': '1.0.0',

		'PictApplicationConfiguration':
	{
		AutoRenderMainViewportViewAfterInitialize: false,
	},
		'IsHeadlightWebApplication': true,

		'Login':
	{
		Required: true,
	},

		'Manifests':
	{
		'Sample-List': require('./views/defaultSampleListManifest.json'),
		'Location-List': require('./views/defaultLocationListManifest.json'),
		'Document-List': require('./views/defaultDocumentListManifest.json'),
	},
		'DefaultRecordSetConfigurations':
	[
		{
			'RecordSet': 'Sample',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Sample',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'QRCode', 'LabControlNumber', 'Notes' ],
			// Whole-row click opens the sample; quick-filter bar for the common cuts (name, when, who logged it).
			'RowClickOpensRecord': true,
			'QuickFilters': [ 'Name', { 'Field': 'CreateDate', 'Label': 'Logged' }, { 'Field': 'CreatingIDUser', 'Label': 'Logged by' } ],
			'RecordSetListColumns':
			[
				{ Key: 'LabControlNumber', DisplayName: 'PSID' },
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'ReceivedFrom', DisplayName: 'Source' },
			],
			'FilterEndpointOverride': 'LIMS/SamplesFiltered',
			'RecordSetListManifestOnly': true,
			// User-facing show/hide columns (manifest columns + remaining scalar schema columns).
			'RecordSetListColumnChooser': true,
			// Quick-bar toggle to enumerate soft-deleted rows (pairs with the audit columns).
			'RecordSetListShowDeletedFilter': true,
			'RecordSetListHasExtraColumns': false,
			//"RecordSetListExtraColumnsHeaderTemplate": '<th class="has-text-centered">PSID</th><th class="has-text-centered">Name</th><th class="has-text-centered">Source</th><th class="has-text-centered">Material</th><th class="has-text-centered">Source Location</th><th class="has-text-centered">Sampled On</th><th class="has-text-centered">Received On</th><th class="has-text-centered">Logged By</th>',
			//"RecordSetListExtraColumnRowTemplate": '<td>{~D:Record.Data.LabControlNumber~}</td><td>{~D:Record.Data.Name~}</td><td>{~D:Record.Data.ReceivedFrom~}</td><td>{~E:Material^Record.Data.IDMaterial^Entity-Name~}</td><td>{~ParseSourceLocation:Record.Data~}</td><td>{~DateFormatLIMS:Record.Data.DesignatedTime^MM/DD/YYYY~}</td><td>{~DateFormatLIMS:Record.Data.Extension.ReceivedDate^MM/DD/YYYY~}</td><td>{~E:User^Record.Data.CreatingIDUser^User-Name~}</td>',
			'RecordSetIgnoreFilterFields':
			[
				'IDSample',
				'GUIDSample',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'ExternalSyncDate',
				'IDCustomer',
				'CaptureLatitude',
				'CaptureLongitude',
				'ParentIDSample',
				'IDProductionPlant',
				'IDLineItem',
				'Status',
				'ProductName',
				'MaterialType',
				'IDOrganization',
				'IDMixDesign',
				'ManufacturerCode',
				'IntendedUse',
				'BuyUSA',
				'ReceivedFrom',
				'GeographicalArea',
				'Station',
				'Offset',
				'RepresentedQuantity',
				'SampledQuantity',
				'SampledQuantityUnits',
				'RepresentedQuantityUnits',
				'Units',
				'RequestedBy',
				'ExternalSyncGUID',
				'IDProduct',
				'SampledByIDUser',
				'WitnessIDUser',
				'AuthorizedIDUser',
				'CMSIDUser',
				'Datum',
			],
			'RecordSetListDefaultManifest': 'Sample-List',
			'RecordSetListManifests': [ 'Sample-List' ],
			'RecordSetDashboardDefaultManifest': 'Sample-List',
			'RecordSetDashboardManifests': [ 'Sample-List' ],
		},
		{
			'RecordSet': 'Location',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Location',

			'RecordSetListColumns': [
				{
					'Key': 'Name',
					'DisplayName': 'Name',
				},
				{
					'Key': 'Type',
					'DisplayName': 'Type',
				},
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListManifests': [ 'Location-List' ],
			'RecordSetDashboardDefaultManifest': 'Location-List',
			'RecordSetDashboardManifests': [ 'Location-List' ],
			// User-facing show/hide columns (manifest columns + remaining scalar schema columns).
			'RecordSetListColumnChooser': true,
			// Quick-bar toggle to enumerate soft-deleted rows (pairs with the audit columns).
			'RecordSetListShowDeletedFilter': true,
			'RecordSetListHasExtraColumns': true,
			'SearchFields': [ 'Name', 'Type' ],
			'RowClickOpensRecord': true,
			'QuickFilters': [ 'Name', { 'Field': 'CreateDate', 'Label': 'Added' } ],

			'RecordSetURLPrefix': '/1.0/',
			'RecordSetIgnoreFilterFields':
			[
				'CreatingIDUser', 'UpdatingIDUser', 'Deleted', 'DeleteDate', 'DeletingIDUser', 'ExternalSyncDate', 'Type', 'Description', 'Address', 'ExternalLocationID', 'ParentIDLocation', 'Phone', 'Latitude', 'Longitude', 'IDCustomer',
			],
		},
		{
			'RecordSet': 'Document',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Document',

			'RecordSetListColumns': [
				{
					'Key': 'Name',
					'DisplayName': 'Name',
				},
				{
					'Key': 'Status',
					'DisplayName': 'Status',
				},
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListManifests': [ 'Document-List' ],
			'RecordSetListLiteFetch': true,
			// User-facing show/hide columns; under Lite, showing a schema column refetches once
			// with the projection widened to include it.
			'RecordSetListColumnChooser': true,
			// Quick-bar toggle to enumerate soft-deleted rows (pairs with the audit columns).
			'RecordSetListShowDeletedFilter': true,
			'RecordSetDashboardDefaultManifest': 'Document-List',
			'RecordSetDashboardManifests': [ 'Document-List' ],
			'RecordSetListHasExtraColumns': false,
			'SearchFields': [ 'Name' ],
			'RowClickOpensRecord': true,
			'QuickFilters': [ 'Name', 'Status', { 'Field': 'CreateDate', 'Label': 'Created' } ],
			//"RecordSetListExtraColumnsHeaderTemplate": '<th class="has-text-centered">Created By</th><th class="has-text-centered">Created On</th><th class="has-text-centered">Type</th><th class="has-text-centered">Project</th>',
			//"RecordSetListExtraColumnRowTemplate": '<td>{~E:User^Record.Data.CreatingIDUser^User-Name~}</td><td>{~DateFormatLIMS:Record.Data.CreateDate^MM/DD/YYYY~}</td><td>{~DocumentTypeName:Record.Data.DocumentType~}</td><td>{~E:Project^Record.Data.IDProject^Entity-Name~}</td>',
			'RecordSetURLPrefix': '/1.0/',
			'RecordSetIgnoreFilterFields':
			[
				'CreatingIDUser',
				'UpdatingIDUser',
				'Description',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDDevice',
				'IDProject',
				'DocumentType',
				'ExternalSyncDate',
				'Version',
				'AppHash',
				'Timezone',
				'Shift',
				'StateName',
				'StateStep',
				'Locked',
				'Form',
				'FormDataJSON',
				'EntityDataJSON',
				'ExternalSyncGUID',
				'IDCustomer',
				'StaleUserActions',
			],
		},
	],
	});

},{"../../providers/ComplexFilterProvider.js":854,"../../providers/EntityCacheConfigurationProvider.js":858,"../../providers/ImprovedTabularRecordSetProvider.js":865,"../../providers/MarkdownProvider.js":870,"../../providers/ModulesProvider.js":874,"./providers/Entity-Provider.js":820,"./providers/FormInitialBundle-Provider.js":821,"./providers/LIMS-Router.js":822,"./providers/RecordExtension-Provider.js":823,"./views/Document-Record-Create.js":824,"./views/Document-Record-Edit.js":825,"./views/Document-Record-View.js":826,"./views/Empty.json":827,"./views/Jumbotron.js":828,"./views/LIMS-Testbed.js":829,"./views/Location-Record-Create.js":830,"./views/Location-Record-Edit.js":831,"./views/Location-Record-View.js":832,"./views/Printer-Codes.js":833,"./views/Sample-Record-Create.js":834,"./views/Sample-Record-Edit.js":835,"./views/Sample-Record-View.js":836,"./views/SamplePlan-Copy.js":837,"./views/defaultDocumentListManifest.json":840,"./views/defaultLocationListManifest.json":844,"./views/defaultPrintableManifests.json":846,"./views/defaultSampleListManifest.json":849,"./views/defaultSummaryManifests.json":851,"headlight-configurable-application":17,"headlight-dynamic-inputs-bundle":26,"headlight-dynamic-inputs-bundle/source/providers/_VocabularySelectorMap.js":145,"headlight-lims-sampleplan":10,"manifest-packaging-service":14,"pict-section-form":497,"pict-section-recordset":609,"pict-section-recordset/source/providers/Filter-Data-Provider.js":612,"pict-section-recordset/source/providers/RecordSet-DynamicRecordsetSolver.js":616,"pict-section-recordset/source/views/Filter-PersistenceView.js":625,"pict-template-preprocessor":689,"util":755}],820:[function(require,module,exports){
// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

const libPictProvider = require('pict-provider');

class EntityProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.HasInitialized = false;
		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;

		// Check to see that the Entiy was passed in with the options object or not
		if (typeof(this.options.Entity) !== 'string')
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity not defined or is not a string in provider options; initializeEntity must be called manually.`);
		}
		else if (this.options.Entity.length === 0)
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity is an empty string in provider options; initializeEntity must be called manually.`);
		}
		else
		{
			this.Entity = this.options.Entity;
			this.HasEntity = true;
		}
	}

	onInitializeAsync(fCallback)
	{
		const tmpAnticipate = this.pict.newAnticipate();

		if (this.HasEntity)
		{
			tmpAnticipate.anticipate(this.initializeEntity.bind(this));
		}
		tmpAnticipate.wait(fCallback);
	}

	setEntity(pEntity)
	{
		if (this.HasEntity)
		{
			this.pict.log.error(`Entity already set to ${this.Entity} so setEntity cannot be called again.`);
			return false;
		}
		if (typeof(pEntity) !== 'string')
		{
			this.pict.log.error(`Entity must be a string when calling setEntity.`);
			return false;
		}
		if (pEntity.length === 0)
		{
			this.pict.log.error(`Entity must be a non-empty string when calling setEntity.`);
			return false;
		}

		this.Entity = pEntity;
		this.HasEntity = true;
		return true;
	}

	initializeEntity(fCallback)
	{
		if (!this.HasEntity)
		{
			this.pict.log.error(`Entity not set so initializeEntity cannot be called.`);
			return fCallback('Entity not set so initializeEntity cannot be called.');
		}
		if (this.HasInitialized)
		{
			this.pict.log.error(`Entity already initialized so initializeEntity cannot be called again.`);
			return fCallback('Entity already initialized so initializeEntity cannot be called again.');
		}

		const tmpAnticipate = this.pict.newAnticipate();

		tmpAnticipate.anticipate(this.loadSchema.bind(this));

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error initializing Entity [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Entity [${this.Entity}] successfully initialized.`);
					this.HasInitialized = true;
				}
				return fCallback(pError);
			});
	}


	loadSchema(fCallback)
	{
		const tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () =>
		{};
		return tmpCallback();
	}

	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecords(fCallback, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Default to 0 for the cursor start
		const tmpRecordCursorStart = (typeof(pRecordCursorStart) === 'number') ? pRecordCursorStart : 0;
		// Default to 100 records
		const tmpRecordCount = (typeof(pRecordCount) === 'number') ? pRecordCount : 100;
		// Default to no meadow filter
		const tmpMeadowFilter = (typeof(pMeadowFilter) === 'string') ? pMeadowFilter : false;

		// Construct the URI
		let tmpURI = `${this.Entity}s`;
		if (tmpMeadowFilter)
		{
			tmpURI += `/${tmpMeadowFilter}`;
		}
		tmpURI += `/${tmpRecordCursorStart}/${tmpRecordCount}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Loaded ${tmpRequestResponse.Response.length} records loaded for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordsToAddress(fCallback, pAddress, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		return this.loadRecords(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pMeadowFilter, pRecordCursorStart, pRecordCount);
	}


	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecordByID(fCallback, pIDEntity)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		if (typeof(pIDEntity) == 'undefined')
		{
			this.pict.log.error(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
			return fCallback(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		let tmpURI = `${this.Entity}`;
		// TODO: Guards on the data type?  We want to at least support string and number but maybe function?  aaah.
		tmpURI += `/${pIDEntity}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading record for [${this.Entity}] by ID ${pIDEntity} URI [${tmpURI}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Record loaded for [${this.Entity}] by ID ${pIDEntity}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordByIDToAddress(fCallback, pAddress, pIDEntity)
	{
		return this.loadRecordByID(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pIDEntity);
	}

	upsertRecord(fCallback, pRecord)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}
		if (typeof(pRecord) != 'object')
		{
			this.pict.log.error(`Record must be an object when calling upsertRecord.`);
			return fCallback(`Record must be an object when calling upsertRecord.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		const tmpURI = `${this.Entity}/Upsert`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.putJSON(tmpURI, pRecord,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error Upserting record for [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.error(`Record upserted for [${this.Entity}].`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	upsertRecordToAddress(fCallback, pAddress, pRecord)
	{
		return this.upsertRecord(
			(pUpsertError, pRecords) =>
			{
				if (pUpsertError)
				{
					this.pict.log.error(`Error upserting record for [${this.Entity}] to address ${pAddress}: ${pUpsertError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pUpsertError, pRecords);
			}, pRecord);
	}
}

module.exports = EntityProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'InterimEntityProvider',
	});

},{"pict-provider":479}],821:[function(require,module,exports){
const PictProvider = require('pict-provider');

const DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'FormInitialBundle-Provider',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

class FormInitialBundleProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, DEFAULT_PROVIDER_CONFIGURATION, pOptions), pServiceHash);

		/** @type {import('../LIMS-Application-Web.js').LIMSPict} */
		this.pict;
	}

	/**
	 * Whether a bundle has a ProjectDataset step.
	 *
	 * @param {Array<Record<string, any>>} pBundle - The entity bundle description.
	 * @return {boolean}
	 */
	hasProjectDatasetStep(pBundle)
	{
		return Array.isArray(pBundle) && pBundle.some((pStep) => pStep && (pStep.Type === 'ProjectDataset'));
	}

	/**
	 * Remove the output of every ProjectDataset step in a bundle, so the next gather builds it fresh.
	 * pict's projectDataset only creates its output when missing and otherwise appends to it or updates it in place.
	 *
	 * @param {Array<Record<string, any>>} pBundle - The entity bundle description.
	 * @return {Array<{ Address: string, Value: any }>} The removed outputs, for restoreProjectDatasetOutputs.
	 */
	clearProjectDatasetOutputs(pBundle)
	{
		const tmpCleared = [];
		if (!Array.isArray(pBundle))
		{
			return tmpCleared;
		}
		const tmpAddressSpace = this.pict.EntityProvider.prepareState({});
		for (const tmpStep of pBundle)
		{
			if (tmpStep && (tmpStep.Type === 'ProjectDataset') && (typeof tmpStep.OutputRecordsetAddress === 'string') && (tmpStep.OutputRecordsetAddress.length > 0))
			{
				tmpCleared.push({ Address: tmpStep.OutputRecordsetAddress, Value: this.pict.manifest.getValueByHash(tmpAddressSpace, tmpStep.OutputRecordsetAddress) });
				this.pict.manifest.deleteValueByHash(tmpAddressSpace, tmpStep.OutputRecordsetAddress);
			}
		}
		return tmpCleared;
	}

	/**
	 * Put back the outputs clearProjectDatasetOutputs removed.
	 *
	 * @param {Array<{ Address: string, Value: any }>} pCleared - The return value of clearProjectDatasetOutputs.
	 * @return {void}
	 */
	restoreProjectDatasetOutputs(pCleared)
	{
		const tmpAddressSpace = this.pict.EntityProvider.prepareState({});
		for (const tmpEntry of pCleared)
		{
			if (typeof tmpEntry.Value !== 'undefined')
			{
				this.pict.manifest.setValueByHash(tmpAddressSpace, tmpEntry.Address, tmpEntry.Value);
			}
		}
	}

	/**
	 * Rebuild every pick list a form manifest declares.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest.
	 * @return {void}
	 */
	rebuildPickLists(pManifest)
	{
		for (const tmpPickList of (pManifest && pManifest.PickLists) || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(tmpPickList.Hash);
		}
	}

	/**
	 * Gather a form manifest's InitialBundle, replacing any ProjectDataset output from an earlier gather, then
	 * rebuild the manifest's pick lists. When the gather fails, the earlier ProjectDataset outputs are put back and
	 * the lists are still rebuilt.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest.
	 * @param {Function} fCallback - Called with the gather error, if any.
	 * @return {void}
	 */
	gatherInitialBundle(pManifest, fCallback)
	{
		const tmpBundle = pManifest ? pManifest.InitialBundle : undefined;
		const tmpCleared = this.clearProjectDatasetOutputs(tmpBundle);
		this.pict.EntityProvider.gatherDataFromServer(tmpBundle, (pError) =>
		{
			if (pError)
			{
				this.restoreProjectDatasetOutputs(tmpCleared);
			}
			this.rebuildPickLists(pManifest);
			return fCallback(pError);
		});
	}
}

module.exports = FormInitialBundleProvider;
module.exports.default_configuration = DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],822:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libPictRouter = require('pict-router');

class LIMSRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.currentView = 'unknown';
		this.currentSample = null;
		this.currentDocument = null;

		this.defaultRoute = 'PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0';
		// We are using this state so that after relogin we go back to the last known route, cleanly.
		this.cachedLogoutRoute = false;
		/** @type {import('../LIMS-Application-Web.js').LIMSPict} */
		this.pict;
		if (!('PictRouter' in this.pict.providers))
		{
			this.pict.addProvider('PictRouter', { RouterMode: 'memory' }, libPictRouter);
		}
		this.router.hooks(
		{
			before: async (next, params) =>
			{
				if (params?.url == 'Logout')
				{
					return next();
				}
				if (!this.AppData.CurrentUser)
				{
					await new Promise((resolve, reject) =>
					{
						this.pict.RestClient.getJSON('/1.0/CheckSession', (pError, pResponse, pBody) =>
						{
							if (pBody.LoggedIn)
							{
								this.AppData.CurrentUser = pBody;
							}
							resolve();
						});
					});
				}
				this.pict.PictApplication.PermissionsControl.setSession(this.AppData.CurrentUser);
				if (params?.url?.includes?.('/SpecificDashboard/'))
				{
					await this.pict.services.ManifestPackagingService.dynamicDashboardLoad(params.data.RecordSet, params.data.DashboardHash);
				}
				// Always apply the sorting parameter for sample lists even while filtering and searching.
				if (params?.url?.startsWith?.('PSRS/Sample/List/FilterExperience/'))
				{
					this.router.navigate(params.url.replace('FilterExperience', 'FilteredTo/FSF~CreateDate~DESC~0/FilterExperience'));
					return next(false);
				}
				else if (params?.url?.startsWith?.('PSRS/Sample/List/FilteredTo/') && !params?.url?.includes('FSF~CreateDate~DESC~0'))
				{
					this.router.navigate(params.url.replace('FilteredTo/', 'FilteredTo/FSF~CreateDate~DESC~0~'));
					return next(false);
				}
				this.pict.log.info(`Route transition before hook`, { params });
				if (this.pict.AppData.JumbotronShown)
				{
					this.pict.PictApplication.hideJumbotron();
				}
				else
				{
					this.pict.PictApplication.showJumbotron();
					this.pict.AppData.JumbotronShown = true;
				}
				next();
			},
		});
	}

	get pictRouter()
	{
		return this.pict.providers.PictRouter;
	}

	get router()
	{
		return this.pictRouter.router;
	}

	onBeforeLoadDataAsync(fCallback)
	{
		super.onBeforeLoadDataAsync((pError) =>
		{
			/** [ Application State Management Routes ]
			 *
			 * These routes are used to manage the state of the application.
			 *
			 */

			// TODO: Once we have a stable, clean pattern shift this to the base pict router class
			this.pictRouter.addRoute('/',
			(pRouteData) =>
			{
				if (this.pict.PictApplication.loggedIn)
				{
					if (this.cachedLogoutRoute)
					{
						const tmpCachedRoute = this.cachedLogoutRoute;
						this.cachedLogoutRoute = false;
						this.router.navigate(tmpCachedRoute);
					}
					else
					{
						this.router.navigate(this.defaultRoute);
					}
				}
				else
				{
					this.pict.views.Empty.renderAsync();
				}
			});

			this.pictRouter.addRoute('/Logout',
			(pRouteData) =>
			{
				// This route is just a placeholder to cache the previous route, so login takes you fluidly back to the correct route.
				const tmpCurrentRoute = this.router.lastResolved();
				if (!tmpCurrentRoute)
				{
					if (this.pict.PictApplication.loggedIn)
					{
						this.router.navigate(this.defaultRoute);
					}
					else
					{
						this.router.navigate('/');
					}
				}
				else if (tmpCurrentRoute.length > 0)
				{
					// Cache the last route so we can go back to it after relogin
					this.cachedLogoutRoute = tmpCurrentRoute[0].hashString;
				}
				else
				{
					this.cachedLogoutRoute = false;
				}
			});

			this.pictRouter.addRoute('/Create-Sample',
			(pRouteData) =>
			{
				this.pict.log.info(`Samples Create route called`);

				this.currentView = 'Create-Sample';
				this.pict.PictApplication.changeTheme('Create');
				this.pict.views.LIMSSampleRecordCreate.onNavigate();
			});

			this.pictRouter.addRoute('/Create-Sample/ClonedFrom/:GUIDSample',
			(pRouteData) =>
			{
				this.pict.log.info(`Samples Create route called`);

				this.currentView = 'Create-Sample';
				this.pict.PictApplication.changeTheme('Create');
				this.pict.views.LIMSSampleRecordCreate.onNavigate(true, pRouteData.data.GUIDSample);
			});

			this.pictRouter.addRoute('/Create-Location',
			(pRouteData) =>
			{
				this.pict.log.info(`Location Create route called`);

				this.currentView = 'Create-Location';
				this.pict.views.LIMSLocationRecordCreate.renderAsync(
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error rendering Location Create view: ${pError}`);
					}
					else
					{
						this.pict.log.info(`Location Create view rendered`);
					}
				});
			});

			this.pictRouter.addRoute('/Sample/ID/:SampleID',
			(pRouteData) =>
			{
				this.pict.log.info(`Samples ID route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				//TODO: load the sample from the ID
				this.pict.HeadlightRestClient.getJSON(`Sample/${pRouteData.data.SampleID}`, (pError, pRecord) =>
				{
					if (pError)
					{
						//FIXME: toast? user visible error
						this.pict.log.error(`Error rendering Samples ID redirect: ${pError}`);
					}
					else
					{
						this.currentView = 'Sample/' + pRecord.GUIDSample;
						this.pict.PictApplication.changeTheme('Read');
						this.pict.views.LIMSSampleRecordView.onNavigate(pRecord.GUIDSample);
					}
				});
			});

			this.pictRouter.addRoute('/Sample/:SampleGUID',
			(pRouteData) =>
			{
				this.pict.log.info(`Sample Read route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				this.currentView = 'Sample/' + pRouteData.data.SampleGUID;
				this.pict.PictApplication.changeTheme('Read');
				this.pict.views.LIMSSampleRecordView.onNavigate(pRouteData.data.SampleGUID);
			});

			this.pictRouter.addRoute('/Location/:LocationGUID',
			(pRouteData) =>
			{
				this.pict.log.info(`Location Read route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				this.currentView = 'Location/' + pRouteData.data.LocationGUID;
				this.pict.views.LIMSLocationRecordView.renderAsync(
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error rendering Location Read view: ${pError}`);
					}
					else
					{
						this.pict.log.info(`Location Read view rendered`);
					}
				});
			});

			this.pictRouter.addRoute('/Location/:LocationGUID/Edit',
			(pRouteData) =>
			{
				this.pict.log.info(`Location Edit route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				this.currentView = 'Location/' + pRouteData.data.LocationGUID + '/Edit';
				this.pict.views.LIMSLocationRecordEdit.renderAsync(
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error rendering Location Edit view: ${pError}`);
					}
					else
					{
						this.pict.log.info(`Location Edit view rendered`);
					}
				});
			});

			this.pictRouter.addRoute('/Document/:DocumentGUID',
			(pRouteData) =>
			{
				this.pict.log.info(`Document Read route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				this.currentView = 'Document/' + pRouteData.data.DocumentGUID;
				this.pict.views.LIMSDocumentRecordView.renderAsync(
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error rendering Document Read view: ${pError}`);
					}
					else
					{
						this.pict.log.info(`Document Read view rendered`);
					}
				});
			});

			this.pictRouter.addRoute('/Document/:DocumentGUID/Edit',
			(pRouteData) =>
			{
				this.pict.log.info(`Document Edit route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				this.currentView = 'Document/' + pRouteData.data.DocumentGUID + '/Edit';
				this.pict.views.LIMSDocumentRecordEdit.renderAsync(
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error rendering Document Edit view: ${pError}`);
					}
					else
					{
						this.pict.log.info(`Document Edit view rendered`);
					}
				});
			});

			this.pictRouter.addRoute('/Create-Document',
			(pRouteData) =>
			{
				this.pict.log.info(`Document Create route called`);

				this.currentView = 'Create-Document';
				this.pict.views.LIMSDocumentRecordCreate.renderAsync(
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error rendering Document Create view: ${pError}`);
					}
					else
					{
						this.pict.log.info(`Document Create view rendered`);
					}
				});
			});

			this.pictRouter.addRoute('/Sample/:SampleGUID/Edit',
			(pRouteData) =>
			{
				this.pict.log.info(`Samples Edit route called`);

				// Skeleton up front so the page is never an empty frame while the record loads.
				this.pict.PictApplication.showDetailLoadingShell();

				this.currentView = 'Sample/' + pRouteData.data.SampleGUID + '/Edit';
				this.pict.PictApplication.changeTheme('Edit');
				this.pict.views.LIMSSampleRecordEdit.onNavigate(pRouteData.data.SampleGUID);
			});

			this.pictRouter.addRoute('/Printer-Codes',
			(pRouteData) =>
			{
				this.pict.log.info(`Printer Codes route called`);

				this.currentView = 'Printer-Codes';
				this.pict.PictApplication.changeTheme('Edit');
				this.pict.views.LIMSPrinterCodes.renderAsync(
					(pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error rendering Printer Codes view: ${pError}`);
						}
						else
						{
							this.pict.log.info(`Printer Codes view rendered`);
						}
					});
			});
			this.pictRouter.addRoute('/SamplePlan-Copy',
			(pRouteData) =>
			{
				this.pict.log.info(`SamplePlan Copy route called`);

				this.currentView = 'SamplePlan-Copy';
				this.pict.PictApplication.changeTheme('Edit');
				this.pict.views.LIMSSamplePlanCopy.renderAsync(
					(pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error rendering SamplePlan Copy view: ${pError}`);
						}
						else
						{
							this.pict.log.info(`SamplePlan Copy view rendered`);
						}
					});
			});
			this.pictRouter.addRoute('/Testbed',
			(pRouteData) =>
			{
				this.pict.log.info(`Testbed route called`);

				this.currentView = 'Testbed';
				this.pict.views.LIMSTestbed.renderAsync(
					(pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error rendering Testbed view: ${pError}`);
						}
						else
						{
							this.pict.log.info(`Testbed view rendered`);
						}
					});
			});
			return fCallback(pError);
		});
	}
}

module.exports = LIMSRouter;

module.exports.default_configuration = (
	{
		Name: 'LIMSRouter',
	});

},{"pict-provider":479,"pict-router":480}],823:[function(require,module,exports){
const PictProvider = require('pict-provider');

const DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'RecordExtension-Provider',
	EntityType: 'Sample',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

class RecordExtensionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, DEFAULT_PROVIDER_CONFIGURATION, pOptions), pServiceHash);

		/** @type {import('../LIMS-Application-Web.js').LIMSPict} */
		this.pict;
	}

	/**
	 * @param {string} uri - The URI to fetch data from.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (err, data) =>
			{
				if (err)
				{
					this.pict.log.error('Error fetching data from URI:', uri, err);
					reject(err);
					return;
				}

				resolve(data);
			});
		});
	}

	/**
	 * @param {string} entityType - The type of entity to load the schema for.
	 */
	async loadSchema(entityType)
	{
		//FIXME: add this to the fable service below (and finish it)
		const rootManifest = await this._get(`ManifestSchemas/FilteredTo/FBL~Type~EQ~RecordExtension~FBV~SubType~EQ~${entityType}`).then((manifestSchemas) => manifestSchemas[0]);
		if (!rootManifest)
		{
			return null;
		}
		const manifestSchemaPartialJoins = await this._get(`ManifestSchemaManifestSchemaPartialJoins/FilteredTo/FBL~IDManifestSchema~EQ~${rootManifest.IDManifestSchema}`);
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			await this._get(`ManifestSchemaPartials/FilteredTo/FBL~IDManifestSchemaPartial~INN~${manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial).join()}`) : [];
		const manifest = this.pict.ManifestPackagingService._mergeManifests(rootManifest, manifestPartials);
		//TODO: atm this is used for forms only, so it creates this wrapper
		return manifest?.DefaultFormManifest;
	}

	/**
	 * @param {string} entityType - The type of entity to extend records for.
	 * @param {Array<Record<string, any>>} records - The records to extend.
	 */
	async extendRecords(entityType, records)
	{
		const extensions = await this._get(`RecordExtendedSchemaDatas/FilteredTo/FBV~EntityType~EQ~${encodeURIComponent(entityType)}~FBL~IDEntity~INN~${records.map((r) => r[`ID${entityType}`]).join()}`);
		for (const record of records)
		{
			const extension = extensions.find((e) => e.IDEntity == record[`ID${entityType}`]);
			if (extension)
			{
				//TODOL keep this whole record around?
				record.Extended = extension.Data || { };
			}
			else
			{
				record.Extended = { };
			}
		}
	}

	async saveExtendedSchemaData(entityType, entityID, extended)
	{
		let recordExtendedSchemaData = await this._get(`RecordExtendedSchemaDatas/FilteredTo/FBL~IDEntity~EQ~${entityID}~FBV~EntityType~EQ~${encodeURIComponent(entityType)}`)
			.then((data) => data[0]);
		if (!recordExtendedSchemaData)
		{
			recordExtendedSchemaData = {
				EntityType: entityType,
				IDEntity: entityID,
				Data: { },
			};
		}
		Object.assign(recordExtendedSchemaData.Data, extended);
		await new Promise((resolve, reject) => this.pict.HeadlightRestClient.putJSON(`RecordExtendedSchemaData/Upsert`, recordExtendedSchemaData, (err, data) =>
		{
			if (err)
			{
				this.pict.log.error('Error saving extended schema data:', err);
				reject(err);
			}
			else
			{
				resolve(data);
			}
		}));
	}
}

module.exports = RecordExtensionProvider;
module.exports.default_configuration = DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":479}],824:[function(require,module,exports){
const PictViewClass = require('pict-view');

class LIMSDocumentRecordCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.DocumentDetails = {};
		this.ActiveDocumentLogs = [];
		this.LIMSDocumentRecordBackTo = null;
		this.manifest = require('./defaultDocumentCreateManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.DocumentDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Create');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Document', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-DocumentCreate'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-DocumentCreate'].options.DefaultDestinationAddress = '#LIMSDocumentRecordCreate-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-DocumentCreate'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-DocumentCreate'].rebuildCustomTemplate();
				this.log.info('Document Details view rendered with Active Record', this.AppData.DocumentDetails);
			}
			catch (error)
			{
				this.log.error('Error in Document Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	async clearDocument(pRender = true)
	{
		this.AppData.DocumentDetails = {};
		if (pRender)
		{
			await new Promise((resolve) => this.renderAsync(() =>
			{
				this.log.info('Document Create view cleared');
				resolve();
			}));
		}
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {object} pDocumentRecord - The Document record to view
	 * @param {string} pOpenTab - The tab to open when the Document detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showDocumentDetailView(pIDDocument, pDocumentRecord, pOpenTab = 'Details')
	{
		// if a Document record is passed in, use it, otherwise get the Document record by ID
		if (pDocumentRecord)
		{
			this.AppData.DocumentDetails = Array.isArray(pDocumentRecord) ? pDocumentRecord[0] : pDocumentRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByID(pIDDocument);
			this.AppData.DocumentDetails = tmpRecord;
		}
		// render the Document detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Document Details View Rendered with Active Record', this.AppData.DocumentDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-DocumentCreate'].render();
		this.pict.views['PictSectionForm-DocumentCreate'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async createNewDocument(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new Document...');
		this.log.info(JSON.stringify(this.AppData.DocumentDetails));

		const tmpDocument = this.AppData.DocumentDetails;

		// save the Document
		try
		{
			delete tmpDocument.CreatingIDUser;
			const tmpResult = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.upsertEntity('Document', tmpDocument, (pError, pResult) =>
				{
					if (pError)
					{
						reject(pError);
					}
					resolve(pResult);
				});
			});
			this.AppData.DocumentDetails = tmpResult;
			this.log.info('Document created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating Document', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Document: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.DocumentDetails)
		{
			this.log.error('No active Document to view');
			return;
		}
		this.log.info('Going to Read Document view for Document GUID:', this.AppData.DocumentDetails.GUIDDocument);
		this.pict.providers.LIMSRouter.router.navigate(`/Document/${ this.AppData.DocumentDetails.GUIDDocument }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Document form submitted');

		this.createNewDocument(event);
	}
}

module.exports = LIMSDocumentRecordCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSDocumentRecordCreate',
	DefaultRenderable: 'LIMSDocumentRecordCreate',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSDocumentRecordCreate-Wrapper',
			Template: /*html*/`
			<form class="container form" data-document-id="{~D:Record.IDDocument~}" onsubmit="_Pict.views.LIMSDocumentRecordCreate.handleFormSubmitAction(event);">
				{~T:LIMSDocumentRecordCreate-DocumentHeader:AppData.DocumentDetails~}
				<!-- LIMSDocumentRecord Content > Tab Details View -->
				<div id="LIMSDocumentRecordCreatePanel-Details-Content" class="tab-content is-active">
					<div id="LIMSDocumentRecordCreate-Details-Container">{~T:LIMSDocumentRecordCreate-Tab-Details:AppData.DocumentDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DocumentHeader',
			Template: /*html*/`
			<header id="PRSP_Title_Container" class="p-5 pb-0 has-background-text-soft is-vcentered">
				<h2 class="title is-size-4" id="PRSP_Title">Create New Document</h2>
			</header>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSDocumentRecordCreate-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSDocumentRecordCreate-Tab-Details-Buttons-Create:AppData.DocumentDetails~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-Tab-Details-Buttons-Create',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" class="button is-link is-soft" title="Clear Document" onclick="_Pict.views.LIMSDocumentRecordCreate.clearDocument(true)">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span class="icon-text">Clear</span>
					</button>
					<button type="submit" class="button is-link" title="Create new Document">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save New Document</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Document #{~D:Record.IDDocument~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-ParentDocument',
			Template: /*html*/`{~D:Record.ParentDocument.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSDocumentRecordCreate',
			TemplateHash: 'LIMSDocumentRecordCreate-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultDocumentCreateManifest.json":838,"pict-view":818}],825:[function(require,module,exports){
const PictViewClass = require('pict-view');

class LIMSDocumentRecordEdit extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.DocumentDetails = {};
		this.ActiveDocumentLogs = [];
		this.LIMSDocumentRecordBackTo = null;
		this.manifest = require('./defaultDocumentEditManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.DocumentDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Edit');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Document', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-DocumentEdit'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-DocumentEdit'].options.DefaultDestinationAddress = '#LIMSDocumentRecordEdit-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-DocumentEdit'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-DocumentEdit'].rebuildCustomTemplate();
				this.log.info('Document Details view rendered with Active Record', this.AppData.DocumentDetails);

				// get the IDDocument from the router parameters
				const tmpGUIDDocument = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDDocument)
				{
					this.log.info('Document Details view opened with GUIDDocument', tmpGUIDDocument);
					// get the Document record by ID
					const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByGUID(tmpGUIDDocument);
					if (tmpRecord)
					{
						this.AppData.DocumentDetails = tmpRecord;
						this.log.info('Document Details view opened with Document record', this.AppData.DocumentDetails);
					}
					else
					{
						this.log.error('Document record not found for ID', tmpGUIDDocument);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Document Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {object} pDocumentRecord - The Document record to view
	 * @param {string} pOpenTab - The tab to open when the Document detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showDocumentDetailView(pIDDocument, pDocumentRecord, pOpenTab = 'Details')
	{
		// if a Document record is passed in, use it, otherwise get the Document record by ID
		if (pDocumentRecord)
		{
			this.AppData.DocumentDetails = Array.isArray(pDocumentRecord) ? pDocumentRecord[0] : pDocumentRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByID(pIDDocument);
			this.AppData.DocumentDetails = tmpRecord;
		}
		// render the Document detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Document Details View Rendered with Active Record', this.AppData.DocumentDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-DocumentEdit'].render();
		this.pict.views['PictSectionForm-DocumentEdit'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async saveDocumentChanges()
	{
		this.log.info('Saving Document changes');
		const tmpDocument = this.AppData.DocumentDetails;
		// Remove field we shouldn't save.
		const removedFields = [ 'CreateDate', 'UpdateDate', 'DeleteDate', 'CreatingIDUser', 'DeletingIDUser', 'Deleted', 'UpdatingIDUser', 'ParentDocument' ];
		for (const r of removedFields)
		{
			delete tmpDocument[r];
		}
		if (tmpDocument.DocumentDate?.length && !tmpDocument.DocumentDate.includes('T'))
		{
			tmpDocument.DocumentDate = this.fable.Dates.dayJS(tmpDocument.DocumentDate + this.pict.providers.DocumentProvider.getDocumentDateCurrentTime()).toISOString();
		}
		// save the Document
		const tmpResult = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.updateEntity('Document', tmpDocument, (pError, pResult) =>
			{
				if (pError)
				{
					reject(pError);
				}
				resolve(pResult);
			});
		});
		if (tmpResult)
		{
			this.log.info('Document changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Document changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Document changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Document changes', type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.DocumentDetails)
		{
			this.log.error('No active Document to view');
			return;
		}
		this.log.info('Going to Read Document view for Document GUID:', this.AppData.DocumentDetails.GUIDDocument);
		this.pict.providers.LIMSRouter.router.navigate(`/Document/${ this.AppData.DocumentDetails.GUIDDocument }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Document form submitted');

		this.saveDocumentChanges();
	}
}

module.exports = LIMSDocumentRecordEdit;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSDocumentRecordEdit',
	DefaultRenderable: 'LIMSDocumentRecordEdit',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSDocumentRecordEdit-Wrapper',
			Template: /*html*/`
			<form class="container form" data-document-id="{~D:Record.IDDocument~}" onsubmit="_Pict.views.LIMSDocumentRecordEdit.handleFormSubmitAction(event);">
				{~T:LIMSDocumentRecordEdit-DocumentHeader:AppData.DocumentDetails~}
				<!-- Document Panel Tabs -->
				{~T:LIMSDocumentRecordEdit-Panel-Tabs:AppData.DocumentDetails~}
				<!-- LIMSDocumentRecord Content > Tab Details View -->
				<div id="LIMSDocumentRecordEditPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSDocumentRecordEdit-Details-Container">{~T:LIMSDocumentRecordEdit-Tab-Details:AppData.DocumentDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSDocumentRecordEditPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSDocumentRecordEdit.toggleTabContent(event, 'LIMSDocumentRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSDocumentRecordViewPanel-Print-Tab" onclick="_Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.IDDocument~});">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DocumentHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSDocumentRecordEdit-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSDocumentRecordEdit-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-file fa-sm"></i>
						</span>
						<span class="icon-text">Type: {~DocumentTypeName:Record.DocumentType~}</span>
					</p>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSDocumentRecordEdit-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSDocumentRecordEdit-Tab-Details-Buttons-Edit:AppData.DocumentDetails~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-Tab-Details-Buttons-Edit',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" id="LIMSDocumentRecordEdit-Tab-Details-Cancel-Button" class="button is-link is-soft" onclick="_Pict.views.LIMSDocumentRecordEdit.goToReadView(event)">
						<span class="icon">
							<i class="fa fa-fw fa-times"></i>
						</span>
						<span class="icon-text">Cancel</span>
					</button>
					<button type="submit" id="LIMSDocumentRecordEditPanel-Logs-Add-Button" class="button is-link">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save Changes</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Document #{~D:Record.IDDocument~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-ParentDocument',
			Template: /*html*/`{~D:Record.ParentDocument.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSDocumentRecordEdit',
			TemplateHash: 'LIMSDocumentRecordEdit-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultDocumentEditManifest.json":839,"pict-view":818}],826:[function(require,module,exports){
const PictViewClass = require('pict-view');

class LIMSDocumentRecordView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.DocumentDetails = {};
		this.ActiveDocumentLogs = [];
		this.LIMSDocumentRecordBackTo = null;
		this.manifest = require('./defaultDocumentViewManifest.json');
		this.pict.MetaTemplate.addPattern('{~ShowOnLocked:', '~}', (pHash, pData, fCallback) =>
		{
			if (this.AppData.DocumentDetails?.CanEdit && !this.AppData.DocumentDetails?.Locked)
			{
				return 'is-hidden';
			}
			return '';
		});
		this.pict.MetaTemplate.addPattern('{~HideOnLocked:', '~}', (pHash, pData, fCallback) =>
		{
			if (this.AppData.DocumentDetails?.CanEdit && !this.AppData.DocumentDetails?.Locked)
			{
				return '';
			}
			return 'is-hidden';
		});
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.DocumentDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Read');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Document', 'View', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-DocumentView'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-DocumentView'].options.DefaultDestinationAddress = '#LIMSDocumentRecordView-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-DocumentView'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-DocumentView'].rebuildCustomTemplate();
				this.log.info('Document Details view rendered with Active Record', this.AppData.DocumentDetails);

				// get the IDDocument from the router parameters
				const tmpGUIDDocument = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDDocument)
				{
					this.log.info('Document Details view opened with GUIDDocument', tmpGUIDDocument);
					// get the Document record by ID
					const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByGUID(tmpGUIDDocument);
					if (tmpRecord)
					{
						this.setDocumentDetails(tmpRecord);
						this.log.info('Document Details view opened with Document record', this.AppData.DocumentDetails);
					}
					else
					{
						this.log.error('Document record not found for ID', tmpGUIDDocument);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Document Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Bind a Document record to the details view, adding the state label the screen should show.
	 *
	 * An approval workflow carries two names per state: `Status` is the hash it keys transitions off
	 * (`InTest`, `Pending_DLE`, `Submitted`) and `StateName` is the name authored for people ("In Test",
	 * "Waiting for District Lab Engineer Approval", "Submitted for Review"). This view labels the field
	 * "Status" to the user, so the authored name is the one that belongs there - and it is what the form's
	 * own toolbar shows, so reading the hash here made the two disagree on the same document.
	 *
	 * The fallback matters: a Draft is created by the API service without consulting the approval
	 * workflow, so it carries a Status and no StateName at all. Mirrors
	 * `web/headlight_panels/source/behaviors/DocumentStateDisplay.js`, which does the same for the panels.
	 *
	 * @param {Record<string, any>} pRecord - the Document record to bind.
	 */
	setDocumentDetails(pRecord)
	{
		const tmpRecord = pRecord || {};
		const tmpText = (pValue) => (pValue === undefined || pValue === null) ? '' : String(pValue).trim();
		tmpRecord.StatusDisplay = tmpText(tmpRecord.StateName) || tmpText(tmpRecord.Status);
		this.AppData.DocumentDetails = tmpRecord;
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {object} pDocumentRecord - The Document record to view
	 * @param {string} pOpenTab - The tab to open when the Document detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showDocumentDetailView(pIDDocument, pDocumentRecord, pOpenTab = 'Details')
	{
		// if a Document record is passed in, use it, otherwise get the Document record by ID
		if (pDocumentRecord)
		{
			this.setDocumentDetails(Array.isArray(pDocumentRecord) ? pDocumentRecord[0] : pDocumentRecord);
		}
		else
		{
			const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByID(pIDDocument);
			this.setDocumentDetails(tmpRecord);
		}
		// render the Document detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Document Details View Rendered with Active Record', this.AppData.DocumentDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-DocumentView'].render();
		this.pict.views['PictSectionForm-DocumentView'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	goToEditView()
	{
		if (!this.AppData.DocumentDetails)
		{
			this.log.error('[Document-Record-View] No active Document to edit');
			return;
		}
		this.log.info('[Document-Record-View] Going to Edit Document view for Document GUID:', this.AppData.DocumentDetails.GUIDDocument);
		this.pict.providers.LIMSRouter.router.navigate(`/Document/${this.AppData.DocumentDetails.GUIDDocument}/Edit`);
	}

	confirmDeleteDocument()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Document',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Document?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.DocumentDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Document" onclick="_Pict.views.LIMSDocumentRecordView.deleteDocument()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Document</span>
				</button>
			</div>`,
			confirmText: 'Delete Document',
			cancelText: 'Cancel',
		});
	}

	deleteDocument()
	{
		if (!this.AppData.DocumentDetails)
		{
			this.log.error('[Document-Record-View] No active Document to delete');
			return;
		}
		this.log.info('[Document-Record-View] Deleting Document ID:', this.AppData.DocumentDetails.IDDocument);
		this.pict.HeadlightRestClient.deleteEntity('Document', this.AppData.DocumentDetails.IDDocument, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Document/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}
}

module.exports = LIMSDocumentRecordView;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSDocumentRecordView',
	DefaultRenderable: 'LIMSDocumentRecordView',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSDocumentRecordView-Wrapper',
			Template: /*html*/`
			<form class="container form" data-document-id="{~D:Record.IDDocument~}">
				{~T:LIMSDocumentRecordView-DocumentHeader:AppData.DocumentDetails~}
				<!-- Document Panel Tabs -->
				{~T:LIMSDocumentRecordView-Panel-Tabs:AppData.DocumentDetails~}
				<!-- LIMSDocumentRecord Content > Tab Details View -->
				<div id="LIMSDocumentRecordViewPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSDocumentRecordView-Details-Container">{~T:LIMSDocumentRecordView-Tab-Details:AppData.DocumentDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSDocumentRecordViewPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSDocumentRecordView.toggleTabContent(event, 'LIMSDocumentRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSDocumentRecordViewPanel-Open-Tab" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.IDDocument~});">
							<span class="icon">
								<i class="fa fa-fw fa-external-link-alt"></i>
							</span>
							<span class="icon-text">
								Open
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSDocumentRecordViewPanel-Print-Tab" onclick="_Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.IDDocument~});">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DocumentHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSDocumentRecordView-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSDocumentRecordView-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-file fa-sm"></i>
						</span>
						<span class="icon-text">Type: {~DocumentTypeName:Record.DocumentType~}</span>
					</p>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSDocumentRecordView-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSDocumentRecordView-Tab-Details-Buttons-Read:AppData.DocumentDetails~}`,
		},
		{
			Hash: 'LIMSDocumentRecordView-Tab-Details-Buttons-Read',
			Template: /*html*/`
			<div class="buttons my-2 mr-6 is-right">
				<!-- Delete Document Button -->
				<button type="button" id="LIMSDocumentRecordViewPanel-Details-Delete-Button" class="button is-link is-outlined {~HideOnLocked:AppData~}" onclick="_Pict.views.LIMSDocumentRecordView.confirmDeleteDocument()">
					<span class="icon">
						<i class="fa fa-fw fa-trash"></i>
					</span>
					<span class="icon-text">Delete Document</span>
				</button>
				<button title="This Document cannot be edited." type="button" id="LIMSDocumentRecordViewPanel-Details-Delete-Button" disabled class="is-disabled button is-link is-outlined {~ShowOnLocked:AppData~}">
					<span class="icon-text">Delete Document</span>
				</button>
				<!-- Edit Document Button -->
				<button type="button" id="LIMSDocumentRecordViewPanel-Logs-Add-Button" class="button is-link {~HideOnLocked:AppData~}" onclick="_Pict.views.LIMSDocumentRecordView.goToEditView()">
					<span class="icon">
						<i class="fa fa-fw fa-pencil"></i>
					</span>
					<span class="icon-text">Edit Document Metadata</span>
				</button>
				<button title="This Document cannot be edited." type="button" id="LIMSDocumentRecordViewPanel-Logs-Add-Button" disabled class="is-disabled button is-link {~ShowOnLocked:AppData~}">
					<span class="icon">
						<i class="fa fa-fw fa-lock"></i>
					</span>
					<span class="icon-text">Edit Document Metadata</span>
				</button>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Document #{~D:Record.IDDocument~}`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSDocumentRecordView-DatumValue-ParentDocument',
			Template: /*html*/`{~D:Record.ParentDocument.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSDocumentRecordView',
			TemplateHash: 'LIMSDocumentRecordView-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultDocumentViewManifest.json":841,"pict-view":818}],827:[function(require,module,exports){
module.exports={
	"ViewIdentifier": "Empty",

	"DefaultRenderable": "Empty-Renderable",
	"DefaultDestinationAddress": "#LIMS-Application-Container",

	"Templates": [
		{
			"Hash": "Empty-Template",
			"Template": "<!-- Empty Space -->"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "Empty-Renderable",
			"TemplateHash": "Empty-Template"
		}
	]
}

},{}],828:[function(require,module,exports){
const libPictView = require('pict-view');

class BridgeJumbotron extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('./../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;
	}

	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.log.info(`Jumbotron onBeforeRenderAsync`);
				if (this.pict.AppData.Module)
				{
					this.pict.AppData.ProgramName = `${this.pict.AppData.Module.ProgramName}`;
					this.pict.AppData.BridgeSplashJumbotronLogo = `${this.pict.AppData.Module.ProgramLogoURL}`;
				}
				else if (this.pict.PictApplication.loggedIn)
				{
					//FIXME: we need to wait for the signal from the application that we are authenticated before we can make this request
					const moduleData = await this.pict.providers.ModulesProvider.getModuleByHash('LIMS_MANAGEMENT');
					if (!moduleData)
					{
						this.pict.log.error(`Unable to get module data for LIMS_MANAGEMENT`);
						return fCallback();
					}
					this.pict.AppData.ProgramName = `${moduleData.ProgramName}`;
					this.pict.AppData.BridgeSplashJumbotronLogo = `${moduleData.ProgramLogoURL}`;
				}
			}
			catch (error)
			{
				this.pict.log.error(`Error in Jumbotron onBeforeRenderAsync: ${error.message}`);
			}
			fCallback();
		}, pRenderable);
	}
}

module.exports = BridgeJumbotron;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'Jumbotron',
		DefaultRenderable: 'Jumbotron',
		DefaultDestinationAddress: 'body',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'Jumbotron-Wrapper',
				Template: /*html*/`
				<div id="Jumbotron">
				   <section class="has-background-primary-soft has-text-link-20 hero is-link-85 hero-container">
					<div class="hero-body px-6 py-5">
						<div class="columns">
						   <div class="column is-narrow">
								<img style="max-height: 75px" src="{~D:Pict.AppData.BridgeSplashJumbotronLogo~}"/>
							</div>
							<div class="column">
								<p class="has-text-primary is-size-2 title">HeadLight LIMS</p>
								<p class="has-text-primary is-size-4 subtitle">{~D:Pict.AppData.ProgramName~}</p>
							</div>
						</div>
					</div>
				</section>
				</div>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'Jumbotron',
				TemplateHash: 'Jumbotron-Wrapper',
				RenderMethod: 'prepend',
			} ],
	});

},{"pict-view":818}],829:[function(require,module,exports){
const libPictView = require('pict-view');

class LIMSTestbed extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;
		this.latestForms = [];
		this.testbedProject = null;
		this.containerRNIs = [];
		this.noDataRefresh = false;
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		// Close panels on page load.
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		const session = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('CheckSession', (error, result) =>
			{
				resolve(result);
			});
		});
		if (!session.LoggedIn)
		{
			return;
		}
		if (!this.noDataRefresh)
		{
			this.pict.PictApplication.rnis = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.AppData.CurrentUser?.CustomerID);
			this.testbedProject = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Projects/By/GUIDProject/testbed-project-${ session.CustomerID }`, (error, result) =>
				{
					resolve(result.length ? result[0] : null);
				});
			});
			if (!this.testbedProject)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'No testbed set up for this customer, redirecting...',
					type: 'is-warning',
				});
				this.pict.providers.LIMSRouter.router.navigate('/PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0');
				return;
			}
			this.containerRNIs = await this.pict.providers.DocumentProvider.getCreatableContainerRNIsByProject(this.testbedProject.IDProject);
			this.latestForms = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Documents/FilteredTo/FBV~IDProject~EQ~${ this.testbedProject.IDProject }~FBV~CreatingIDUser~EQ~${ session.UserID }~FSF~CreateDate~DESC~0`, (error, result) =>
				{
					resolve(result);
				});
			});
		}
		else
		{
			// TODO: This state tracking is doing odd stuff later
			this.noDataRefresh = false;
		}
		super.onBeforeRenderAsync(pCallback, pRenderable);
	}

	async createDocument()
	{
		await this.rerender(true);
		// TODO: Some of this stuff like the hiding things with ids is pretty jank, need a better mechanism for this.
		this.pict.views.HeadlightPaneDocuments.Intent =
		{
			type: 'add',
			handler: (IDDocument) =>
			{
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
				this.renderAsync();
			},
			afterRenderHandler: () =>
			{
				this.pict.views.DocumentCreate.CurrentDocumentRecord.Project = this.testbedProject.IDProject;
				const stuffToHide = [ 'HeadlightPanels-DocumentPanel-Search-Tab', 'DocumentCreate-Entry-Project-Wrapper', 'DocumentCreate-ClearButton' ];
				for (const s of stuffToHide)
				{
					document.getElementById(s)?.classList?.add?.('is-hidden');
				}
			},
		};
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'open');
		this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Create', 'Document');
	}

	async createContainerForm()
	{
		this.fable.HeadlightModal.addLoader('Creating Document...');
		try
		{
			await this.rerender(true);
			// Just use the first container form we found for now.
			const tmpDocumentRecord =
			{
				DocumentType: this.containerRNIs[0].Hash,
				Name: this.containerRNIs[0].Name,
				IDProject: this.testbedProject.IDProject,
			};
			await this.pict.providers.DocumentProvider.createDocument(tmpDocumentRecord);
			await this.rerender();
		}
		catch (e)
		{
			this.log.error('Error creating document: ', e);
		}
		this.fable.HeadlightModal.dismissLoader();
	}

	/**
	 * Swaps out the template for the document name for an in line editable one.
	 * @param {number} id - The document's ID.
	 * @param {string} currentName - The document's current Name.
	 */
	async editDocumentName(id, currentName)
	{
		await this.rerender(true);
		const docElement = document.getElementById(`document-id-${ id }-container`);
		if (docElement)
		{
			docElement.innerHTML = /*html*/`
				<input id="document-id-${ id }-editable" value="${ currentName }" style="width: 70%;"/>
				<span class="button is-ghost icon is-size-6" onclick="_Pict.views.LIMSTestbed.rerender(true)">
					<i class="fas fa-circle-x"></i>
				</span>
				<span class="button is-ghost icon is-size-6" onclick="_Pict.views.LIMSTestbed.applyDocumentName(${ id })">
					<i class="fas fa-circle-check"></i>
				</span>
			`;
		}
	}

	/**
	 * Applies a name edit to the document.
	 * @param {number} id - The document's ID.
	 */
	async applyDocumentName(id)
	{
		/** @type {any} */
		const docElement = document.getElementById(`document-id-${ id }-editable`);
		if (docElement?.value)
		{
			this.fable.HeadlightModal.addLoader('Updating Document...');
			try
			{
				const tmpResult = await new Promise((resolve, reject) =>
				{
					this.pict.HeadlightRestClient.updateEntity('Document', { IDDocument: id, Name: docElement.value, IDProject: this.testbedProject.IDProject }, (pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						resolve(pResult);
					});
				});
				if (tmpResult)
				{
					this.log.info('Document changes saved successfully');
					this.pict.views.HeadlightPanels.toast({ message: 'Document updated successfully.', type: 'is-success' });
				}
			}
			catch (e)
			{
				this.log.error('Error updating document: ', e);
			}
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({ message: 'No name was entered, Document name not updated.', type: 'is-warning' });
		}
		await this.rerender();
		this.fable.HeadlightModal.dismissLoader();
	}

	/**
	 * Rerenders the view.
	 * @return {Promise<void>}
	 */
	async rerender(noDataRefresh)
	{
		return await new Promise((resolve, reject) =>
		{
			if (noDataRefresh)
			{
				this.noDataRefresh = true;
			}
			this.renderAsync(()=>
			{
				return resolve();
			});
		});
	}
}

module.exports = LIMSTestbed;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'LIMSTestbed',
		DefaultRenderable: 'LIMSTestbed',
		DefaultDestinationAddress: '#LIMS-Application-Container',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'LIMSTestbed-Wrapper',
				Template: /*html*/`
				<section id="LIMSTestbed" class="form p-5">
					<h2 class="title is-4 mb-3">LIMS Testbed</h2>
					<div class="content">
						<div class="columns is-vcentered">
							<div class="column">
								<button 
									type="button"
									id="LIMSTestbed-Create-Document" 
									class="button is-link" 
									onclick="_Pict.views.LIMSTestbed.createDocument()"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-file"></i>
									</span>
									Create New Form
								</button>
								<button 
									type="button"
									id="LIMSTestbed-Create-Container-Form" 
									class="button is-link {~TIfAbs:LIMSTestbed-Hide-Class:Record:Context[0].containerRNIs.length^==^0~}" 
									onclick="_Pict.views.LIMSTestbed.createContainerForm()"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-list-check"></i>
									</span>
									Create Generic Materials Form
								</button>
							</div>
						</div>
						<div class="columns is-vcentered">
							{~T:LIMSTestbed-Documents:Context[0].latestForms~}
						</div>
					</div>
				</section>`,
			},
			{
				Hash: 'LIMSTestbed-Hide-Class',
				Template: 'is-hidden',
			},
			{
				Hash: 'LIMSTestbed-Documents',
				Template: /*html*/`
					{~TIfAbs:LIMSTestbed-Documents-Items:Record:Record.length^>^0~}
					{~TIfAbs:LIMSTestbed-Documents-Empty:Record:Record.length^<=^0~}
				`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Empty',
				Template: /*html*/`
				<div class="notification empty-message m-3 is-fullwidth column">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span class="icon-text">No documents created by your user were found in the testbed project.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Items',
				Template: /*html*/`
				<div id="LIMSTestbed-Documents-Items" class="column">
					<style>
						.document-entry-row
						{
							display:flex;
							justify-content: space-between;
						}
						ul 
						{
							list-style-type: none !important;
						}
						.document-entry
						{
							border-top: 1px solid var(--bulma-border);;
							border-bottom: 1px solid var(--bulma-border);;
						}
						.document-status
						{
							margin-right: 10vw;
						}
					</style>
					{~TS:LIMSTestbed-Documents-Item:Record~}
				</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Actions',
				Template: /*html*/`
					<!-- LIMS testbed document action cell (bespoke buttons; NOT the PSRS list action-cell template) -->
					<div class="document-actions">
						<ul class="buttons has-addons is-centered">
							<!-- TODO: check if the entity is print-able - currently, they both are -->
							<li>
								<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault(); _Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.IDDocument~});">
									<span class="icon">
										<i class="fas fa-print"></i>
									</span>
									<span class="icon-text">Print</span>
								</a>
							</li>
							<li>
								<a class="button is-ghost" href="#/Document/{~D:Record.GUIDDocument~}" title="{~TBR:Record.Name~}">
									<span class="icon">
										<i class="fas fa-search"></i>
									</span>
									<span class="icon-text">View</span>
								</a>
							</li>
							<li>
								<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.IDDocument~});" title="{~TBR:Record.Name~}">
									<span class="icon">
										<i class="fas fa-pencil"></i>
									</span>
									<span class="icon-text">Edit</span>
								</a>
							</li>
						</ul>
					</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Item',
				Template: /*html*/`
				<div class="panel-block is-block-flex is-align-items-left is-relative p-4 document-entry">
					<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
						<div>
							<span class="tag">#{~D:Record.SequenceNumber~}</span>&nbsp;
							<span id="document-id-{~D:Record.IDDocument~}-container">
								{~D:Record.Name~}
								<span class="button is-ghost icon is-size-7 {~TIfAbs:LIMSTestbed-Hide-Class:Record:Record.CanEdit^==^false~} {~TIfAbs:LIMSTestbed-Hide-Class:Record:Record.Locked^==^1~}" onclick="_Pict.views.LIMSTestbed.editDocumentName({~D:Record.IDDocument~}, '{~D:Record.Name~}')">
									<i class="fas fa-pencil"></i>
								</span>
							</span>
						</div>
						<div class="document-entry-row is-size-7">
							<span>
								<b class="has-text-text-50">Type:</b> {~DocumentTypeName:Record.DocumentType~}
							</span>
							<span class='document-status'>
								<b class="has-text-text-50">Status:</b> {~D:Record.Status~}
							</span>
						</div>
						<div class="is-size-7">
							<span class="has-text-soft">Created on</span>
							<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
							<span class="has-text-soft">by</span>
							<span>{~Entity:User^Record.CreatingIDUser^LIMSTestbed-Documents-Item-User^~}</span>
						</div>
					</div>
					<div class="image">
						{~T:LIMSTestbed-Documents-Actions:Record~}
					</div>
				</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Item-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'LIMSTestbed',
				TemplateHash: 'LIMSTestbed-Wrapper',
				RenderMethod: 'replace',
			} ],
	});

},{"pict-view":818}],830:[function(require,module,exports){
const PictViewClass = require('pict-view');

class LIMSLocationRecordCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.LocationDetails = {};
		this.ActiveLocationLogs = [];
		this.LIMSLocationRecordBackTo = null;
		this.manifest = require('./defaultLocationCreateManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.LocationDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Create');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Location', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-LocationCreate'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-LocationCreate'].options.DefaultDestinationAddress = '#LIMSLocationRecordCreate-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-LocationCreate'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-LocationCreate'].rebuildCustomTemplate();
				this.log.info('Location Details view rendered with Active Record', this.AppData.LocationDetails);
			}
			catch (error)
			{
				this.log.error('Error in Location Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	async clearLocation(pRender = true)
	{
		this.AppData.LocationDetails = {};
		if (pRender)
		{
			await new Promise((resolve) => this.renderAsync(() =>
			{
				this.log.info('Location Create view cleared');
				resolve();
			}));
		}
	}

	/**
	 * Open the Location detail view for the selected Location to view the full details
	 * @param {number|string} pIDLocation - The ID of the Location to view
	 * @param {object} pLocationRecord - The Location record to view
	 * @param {string} pOpenTab - The tab to open when the Location detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showLocationDetailView(pIDLocation, pLocationRecord, pOpenTab = 'Details')
	{
		// if a Location record is passed in, use it, otherwise get the Location record by ID
		if (pLocationRecord)
		{
			this.AppData.LocationDetails = Array.isArray(pLocationRecord) ? pLocationRecord[0] : pLocationRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.LocationProvider.getLocationByID(pIDLocation);
			this.AppData.LocationDetails = tmpRecord;
		}
		// render the Location detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Location Details View Rendered with Active Record', this.AppData.LocationDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-LocationCreate'].render();
		this.pict.views['PictSectionForm-LocationCreate'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to print QR Code for');
			return;
		}
		this.log.info('Printing Location Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Location', this.AppData.LocationDetails.QRCode);
	}

	goToCreateView()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Create] No active Location to Create');
			return;
		}
		this.log.info('[Location-Record-Create] Going to Create Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${this.AppData.LocationDetails.GUIDLocation}/Create`);
	}

	confirmDeleteLocation()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Location',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Location?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.LocationDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Location" onclick="_Pict.views.LIMSLocationRecordCreate.deleteLocation()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Location</span>
				</button>
			</div>`,
			confirmText: 'Delete Location',
			cancelText: 'Cancel',
		});
	}

	deleteLocation()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Create] No active Location to delete');
			return;
		}
		this.log.info('[Location-Record-Create] Deleting Location ID:', this.AppData.LocationDetails.IDLocation);
		this.pict.HeadlightRestClient.deleteEntity('Location', this.AppData.LocationDetails.IDLocation, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Location/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async createNewLocation(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new Location...');
		this.log.info(JSON.stringify(this.AppData.LocationDetails));

		const tmpLocation = this.AppData.LocationDetails;

		// save the Location
		try
		{
			delete tmpLocation.CreatingIDUser;
			const tmpResult = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.upsertEntity('Location', tmpLocation, (pError, pResult) =>
				{
					if (pError)
					{
						reject(pError);
					}
					resolve(pResult);
				});
			});
			this.AppData.LocationDetails = tmpResult;
			this.log.info('Location created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating Location', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Location: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to view');
			return;
		}
		this.log.info('Going to Read Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${ this.AppData.LocationDetails.GUIDLocation }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Location form submitted');

		this.createNewLocation(event);
	}
}

module.exports = LIMSLocationRecordCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSLocationRecordCreate',
	DefaultRenderable: 'LIMSLocationRecordCreate',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSLocationRecordCreate-Wrapper',
			Template: /*html*/`
			<form class="container form" data-location-id="{~D:Record.IDLocation~}" onsubmit="_Pict.views.LIMSLocationRecordCreate.handleFormSubmitAction(event);">
				{~T:LIMSLocationRecordCreate-LocationHeader:AppData.LocationDetails~}
				<!-- LIMSLocationRecord Content > Tab Details View -->
				<div id="LIMSLocationRecordCreatePanel-Details-Content" class="tab-content is-active">
					<div id="LIMSLocationRecordCreate-Details-Container">{~T:LIMSLocationRecordCreate-Tab-Details:AppData.LocationDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-LocationHeader',
			Template: /*html*/`
			<header id="PRSP_Title_Container" class="p-5 pb-0 has-background-text-soft is-vcentered">
				<h2 class="title is-size-4" id="PRSP_Title">Create New Location</h2>
			</header>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSLocationRecordCreate-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSLocationRecordCreate-Tab-Details-Buttons-Create:AppData.LocationDetails~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-Tab-Details-Buttons-Create',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" class="button is-link is-soft" title="Clear Location" onclick="_Pict.views.LIMSLocationRecordCreate.clearLocation(true)">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span class="icon-text">Clear</span>
					</button>
					<button type="submit" class="button is-link" title="Create new location">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save New Location</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Location #{~D:Record.IDLocation~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-ParentLocation',
			Template: /*html*/`{~D:Record.ParentLocation.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSLocationRecordCreate',
			TemplateHash: 'LIMSLocationRecordCreate-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultLocationCreateManifest.json":842,"pict-view":818}],831:[function(require,module,exports){
const PictViewClass = require('pict-view');

class LIMSLocationRecordEdit extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.LocationDetails = {};
		this.ActiveLocationLogs = [];
		this.LIMSLocationRecordBackTo = null;
		this.manifest = require('./defaultLocationEditManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.LocationDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Edit');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Location', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-LocationEdit'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-LocationEdit'].options.DefaultDestinationAddress = '#LIMSLocationRecordEdit-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-LocationEdit'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-LocationEdit'].rebuildCustomTemplate();
				this.log.info('Location Details view rendered with Active Record', this.AppData.LocationDetails);

				// get the IDLocation from the router parameters
				const tmpGUIDLocation = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDLocation)
				{
					this.log.info('Location Details view opened with GUIDLocation', tmpGUIDLocation);
					// get the Location record by ID
					const tmpRecord = await this.pict.providers.LocationProvider.getLocationByGUID(tmpGUIDLocation);
					if (tmpRecord)
					{
						this.AppData.LocationDetails = tmpRecord;
						this.log.info('Location Details view opened with Location record', this.AppData.LocationDetails);
					}
					else
					{
						this.log.error('Location record not found for ID', tmpGUIDLocation);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Location Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Open the Location detail view for the selected Location to view the full details
	 * @param {number|string} pIDLocation - The ID of the Location to view
	 * @param {object} pLocationRecord - The Location record to view
	 * @param {string} pOpenTab - The tab to open when the Location detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showLocationDetailView(pIDLocation, pLocationRecord, pOpenTab = 'Details')
	{
		// if a Location record is passed in, use it, otherwise get the Location record by ID
		if (pLocationRecord)
		{
			this.AppData.LocationDetails = Array.isArray(pLocationRecord) ? pLocationRecord[0] : pLocationRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.LocationProvider.getLocationByID(pIDLocation);
			this.AppData.LocationDetails = tmpRecord;
		}
		// render the Location detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Location Details View Rendered with Active Record', this.AppData.LocationDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-LocationEdit'].render();
		this.pict.views['PictSectionForm-LocationEdit'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to print QR Code for');
			return;
		}
		this.log.info('Printing Location Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Location', this.AppData.LocationDetails.QRCode);
	}

	goToEditView()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Edit] No active Location to edit');
			return;
		}
		this.log.info('[Location-Record-Edit] Going to Edit Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${this.AppData.LocationDetails.GUIDLocation}/Edit`);
	}

	confirmDeleteLocation()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Location',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Location?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.LocationDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Location" onclick="_Pict.views.LIMSLocationRecordEdit.deleteLocation()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Location</span>
				</button>
			</div>`,
			confirmText: 'Delete Location',
			cancelText: 'Cancel',
		});
	}

	deleteLocation()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Edit] No active Location to delete');
			return;
		}
		this.log.info('[Location-Record-Edit] Deleting Location ID:', this.AppData.LocationDetails.IDLocation);
		this.pict.HeadlightRestClient.deleteEntity('Location', this.AppData.LocationDetails.IDLocation, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Location/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async saveLocationChanges()
	{
		this.log.info('Saving Location changes');
		const tmpLocation = this.AppData.LocationDetails;
		// Remove field we shouldn't save.
		const removedFields = [ 'CreateDate', 'UpdateDate', 'DeleteDate', 'CreatingIDUser', 'DeletingIDUser', 'Deleted', 'UpdatingIDUser', 'ParentLocation' ];
		for (const r of removedFields)
		{
			delete tmpLocation[r];
		}
		// save the Location
		const tmpResult = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.updateEntity('Location', tmpLocation, (pError, pResult) =>
			{
				if (pError)
				{
					reject(pError);
				}
				resolve(pResult);
			});
		});
		if (tmpResult)
		{
			this.log.info('Location changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Location changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Location changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Location changes', type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to view');
			return;
		}
		this.log.info('Going to Read Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${ this.AppData.LocationDetails.GUIDLocation }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Location form submitted');

		this.saveLocationChanges();
	}
}

module.exports = LIMSLocationRecordEdit;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSLocationRecordEdit',
	DefaultRenderable: 'LIMSLocationRecordEdit',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSLocationRecordEdit-Wrapper',
			Template: /*html*/`
			<form class="container form" data-location-id="{~D:Record.IDLocation~}" onsubmit="_Pict.views.LIMSLocationRecordEdit.handleFormSubmitAction(event);">
				{~T:LIMSLocationRecordEdit-LocationHeader:AppData.LocationDetails~}
				<!-- Location Panel Tabs -->
				{~T:LIMSLocationRecordEdit-Panel-Tabs:AppData.LocationDetails~}
				<!-- LIMSLocationRecord Content > Tab Details View -->
				<div id="LIMSLocationRecordEditPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSLocationRecordEdit-Details-Container">{~T:LIMSLocationRecordEdit-Tab-Details:AppData.LocationDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSLocationRecordEditPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSLocationRecordEdit.toggleTabContent(event, 'LIMSLocationRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSLocationRecordEditPanel-Print-Tab" onclick="_Pict.views.LIMSLocationRecordEdit.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-LocationHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSLocationRecordEdit-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSLocationRecordEdit-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^Location^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSLocationRecordEdit-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSLocationRecordEdit-Tab-Details-Buttons-Edit:AppData.LocationDetails~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-Tab-Details-Buttons-Edit',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" id="LIMSLocationRecordEdit-Tab-Details-Cancel-Button" class="button is-link is-soft" onclick="_Pict.views.LIMSLocationRecordEdit.goToReadView(event)">
						<span class="icon">
							<i class="fa fa-fw fa-times"></i>
						</span>
						<span class="icon-text">Cancel</span>
					</button>
					<button type="submit" id="LIMSLocationRecordEditPanel-Logs-Add-Button" class="button is-link">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save Changes</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Location #{~D:Record.IDLocation~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-ParentLocation',
			Template: /*html*/`{~D:Record.ParentLocation.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSLocationRecordEdit',
			TemplateHash: 'LIMSLocationRecordEdit-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultLocationEditManifest.json":843,"pict-view":818}],832:[function(require,module,exports){
const PictViewClass = require('pict-view');

class LIMSLocationRecordView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.LocationDetails = {};
		this.ActiveLocationLogs = [];
		this.LIMSLocationRecordBackTo = null;
		this.manifest = require('./defaultLocationViewManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.LocationDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Read');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Location', 'View', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-LocationView'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-LocationView'].options.DefaultDestinationAddress = '#LIMSLocationRecordView-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-LocationView'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-LocationView'].rebuildCustomTemplate();
				this.log.info('Location Details view rendered with Active Record', this.AppData.LocationDetails);

				// get the IDLocation from the router parameters
				const tmpGUIDLocation = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDLocation)
				{
					this.log.info('Location Details view opened with GUIDLocation', tmpGUIDLocation);
					// get the Location record by ID
					const tmpRecord = await this.pict.providers.LocationProvider.getLocationByGUID(tmpGUIDLocation);
					if (tmpRecord)
					{
						this.AppData.LocationDetails = tmpRecord;
						this.log.info('Location Details view opened with Location record', this.AppData.LocationDetails);
					}
					else
					{
						this.log.error('Location record not found for ID', tmpGUIDLocation);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Location Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Open the Location detail view for the selected Location to view the full details
	 * @param {number|string} pIDLocation - The ID of the Location to view
	 * @param {object} pLocationRecord - The Location record to view
	 * @param {string} pOpenTab - The tab to open when the Location detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showLocationDetailView(pIDLocation, pLocationRecord, pOpenTab = 'Details')
	{
		// if a Location record is passed in, use it, otherwise get the Location record by ID
		if (pLocationRecord)
		{
			this.AppData.LocationDetails = Array.isArray(pLocationRecord) ? pLocationRecord[0] : pLocationRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.LocationProvider.getLocationByID(pIDLocation);
			this.AppData.LocationDetails = tmpRecord;
		}
		// render the Location detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Location Details View Rendered with Active Record', this.AppData.LocationDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-LocationView'].render();
		this.pict.views['PictSectionForm-LocationView'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to print QR Code for');
			return;
		}
		this.log.info('Printing Location Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Location', this.AppData.LocationDetails.QRCode);
	}

	goToEditView()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-View] No active Location to edit');
			return;
		}
		this.log.info('[Location-Record-View] Going to Edit Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${this.AppData.LocationDetails.GUIDLocation}/Edit`);
	}

	confirmDeleteLocation()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Location',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Location?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.LocationDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Location" onclick="_Pict.views.LIMSLocationRecordView.deleteLocation()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Location</span>
				</button>
			</div>`,
			confirmText: 'Delete Location',
			cancelText: 'Cancel',
		});
	}

	deleteLocation()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-View] No active Location to delete');
			return;
		}
		this.log.info('[Location-Record-View] Deleting Location ID:', this.AppData.LocationDetails.IDLocation);
		this.pict.HeadlightRestClient.deleteEntity('Location', this.AppData.LocationDetails.IDLocation, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Location/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}
}

module.exports = LIMSLocationRecordView;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSLocationRecordView',
	DefaultRenderable: 'LIMSLocationRecordView',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSLocationRecordView-Wrapper',
			Template: /*html*/`
			<form class="container form" data-location-id="{~D:Record.IDLocation~}">
				{~T:LIMSLocationRecordView-LocationHeader:AppData.LocationDetails~}
				<!-- Location Panel Tabs -->
				{~T:LIMSLocationRecordView-Panel-Tabs:AppData.LocationDetails~}
				<!-- LIMSLocationRecord Content > Tab Details View -->
				<div id="LIMSLocationRecordViewPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSLocationRecordView-Details-Container">{~T:LIMSLocationRecordView-Tab-Details:AppData.LocationDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSLocationRecordView-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSLocationRecordViewPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSLocationRecordView.toggleTabContent(event, 'LIMSLocationRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSLocationRecordViewPanel-Print-Tab" onclick="_Pict.views.LIMSLocationRecordView.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSLocationRecordView-LocationHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSLocationRecordView-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSLocationRecordView-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^Location^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordView-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSLocationRecordView-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSLocationRecordView-Tab-Details-Buttons-Read:AppData.LocationDetails~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-Tab-Details-Buttons-Read',
			Template: /*html*/`
			<div class="buttons my-2 mr-6 is-right">
				<!-- Delete Location Button -->
				<button type="button" id="LIMSLocationRecordViewPanel-Details-Delete-Button" class="button is-link is-outlined" onclick="_Pict.views.LIMSLocationRecordView.confirmDeleteLocation()">
					<span class="icon">
						<i class="fa fa-fw fa-trash"></i>
					</span>
					<span class="icon-text">Delete Location</span>
				</button>
				<!-- Edit Location Button -->
				<button type="button" id="LIMSLocationRecordViewPanel-Logs-Add-Button" class="button is-link" onclick="_Pict.views.LIMSLocationRecordView.goToEditView()">
					<span class="icon">
						<i class="fa fa-fw fa-pencil"></i>
					</span>
					<span class="icon-text">Edit Location</span>
				</button>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordView-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Location #{~D:Record.IDLocation~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-ParentLocation',
			Template: /*html*/`{~D:Record.ParentLocation.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSLocationRecordView',
			TemplateHash: 'LIMSLocationRecordView-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultLocationViewManifest.json":845,"pict-view":818}],833:[function(require,module,exports){
const libPictView = require('pict-view');

class PrinterCodes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;
	}
}

module.exports = PrinterCodes;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'PrinterCodes',
		DefaultRenderable: 'PrinterCodes',
		DefaultDestinationAddress: '#LIMS-Application-Container',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'PrinterCodes-Wrapper',
				Template: /*html*/`
				<section id="PrinterCodes" class="form p-5">
					<h2 class="title is-4 mb-3">Printer Codes</h2>
					<div class="content">
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>A scan code for the "Open the cart" action to start a scan session.</em>
							</div>
							<div class="column is-3">
								<button 
									type="button"
									id="QRPanel-OpenPrint" 
									class="button is-link is-fullwidth" 
									onclick="_Pict.providers.QRCodeProvider.print('action/open/cart', { printStyle: 'thin', raw: true, footers: ['HLLOGO Open Scanning Cart']});"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-shopping"></i>
									</span>
									Print "Open Cart" Code
								</button>
							</div>
						</div>
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>A scan code for the "Clear the cart" action during a scan session.</em>
							</div>
							<div class="column is-3">
								<button 
									type="button"
									id="QRPanel-ClearPrint" 
									class="button is-link is-fullwidth" 
									onclick="_Pict.providers.QRCodeProvider.print('action/clear', { printStyle: 'thin', raw: true, footers: ['HLLOGO Clear Scanning Cart']});"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-circle-xmark"></i>
									</span>
									Print "Clear Cart" Code
								</button>
							</div>
						</div>
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>A scan code for the "Submit the Cart" action to submit a scan session.</em>
							</div>
							<div class="column is-3">
								<button 
									type="button"
									id="QRPanel-SubmitPrint" 
									class="button is-link is-fullwidth" 
									onclick="_Pict.providers.QRCodeProvider.print('action/submit', { printStyle: 'thin', raw: true, footers: ['HLLOGO Submit Scanning Cart']});"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-shopping-fast"></i>
									</span>
									Print "Submit" Code
								</button>
							</div>
						</div>
					</div>
				</section>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'PrinterCodes',
				TemplateHash: 'PrinterCodes-Wrapper',
				RenderMethod: 'replace',
			} ],
	});

},{"pict-view":818}],834:[function(require,module,exports){

const PictViewClass = require('pict-view');

class LIMSSampleRecordCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.ActiveSampleLogs = [];
		/** @type {Record<string, any>} */
		this.extendedSchema = null;

		this.AppData.SampleDetails = { };

		this.cloneFrom = null;

		this.manifest = require('./defaultSampleCreateManifest.json');
	}

	async onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	async onNavigate(pResetState = true, GUIDSample)
	{
		if (pResetState)
		{
			delete this.AppData.SampleSequence;
			delete this.AppData.LoggedBy;
			delete this.cloneFrom;
			await this.clearSample(false);
		}
		if (GUIDSample)
		{
			this.cloneFrom = GUIDSample;
		}
		await new Promise((resolve) => this.renderAsync((pError) =>
		{
			if (pError)
			{
				this.log.error(`Error rendering Sample view: ${pError.message || pError}`, { stack: pError.stack });
			}
			else
			{
				this.log.info('Sample view rendered');
			}
			resolve();
		}));
	}

	async onBeforeRenderAsync(fCallback, pRenderable)
	{
		const session = await this.pict.providers.SessionProvider.getSession();
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-SampleCreate'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-SampleCreate'].options.DefaultDestinationAddress = '#LIMSSampleRecordCreate-Container';
			this.pict.views['PictSectionForm-SampleCreate'].rebuildCustomTemplate();
			this.initialized = true;
		}
		if (this.cloneFrom && this.manifest?.Descriptors)
		{
			const clonedFromSample = await this.pict.providers.SampleProvider.getSampleByGUID(this.cloneFrom);
			if (clonedFromSample)
			{
				this.AppData.SampleDetails = { CreatingIDUser: this.AppData.SampleDetails.CreatingIDUser };
				const findPathValue = (tokens, parent = { SampleDetails: clonedFromSample }) =>
				{
					const val = parent?.[tokens[0]];
					return !val ? null : tokens.length == 1 ? val : findPathValue(tokens.slice(1), val);
				};
				const applyPathValue = (tokens, value, parent = this.AppData) =>
				{
					if (tokens.length > 1)
					{
						parent[tokens[0]] = parent[tokens[0]] || {};
						applyPathValue(tokens.slice(1), value, parent[tokens[0]]);
					}
					else if (tokens.length == 1)
					{
						parent[tokens[0]] = value;
					}
				};
				// @ts-ignore
				for (const d of Object.keys(this.manifest.Descriptors))
				{
					const path = this.manifest.Descriptors[d]?.DataAddress || d;
					const val = findPathValue(path.split('.'));
					if (val)
					{
						applyPathValue(path.split('.'), val);
					}
				}
			}
		}
		return super.onBeforeRenderAsync(() =>
		{
			this.pict.views['PictSectionForm-SampleCreate'].rebuildCustomTemplate();
			this.pict.providers.FormInitialBundle.gatherInitialBundle(this.manifest, (pError) =>
			{
				if (pError && this.pict.providers.FormInitialBundle.hasProjectDatasetStep(this.manifest.InitialBundle))
				{
					this.log.error(`Error gathering the Sample Create initial bundle: ${pError.message || pError}`, { stack: pError.stack });
					return fCallback();
				}
				return fCallback(pError);
			});
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-SampleCreate'].render();
		this.pict.views['PictSectionForm-SampleCreate'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method clears the current sample record.
	 * @param {boolean} pRender - If true, the view will be re-rendered after clearing the sample.
	 * @return {Promise<void>}
	 */
	async clearSample(pRender = true)
	{
		try
		{
			const newSample = { CreatingIDUser: 0 }; //FIXME: get from session (or hide that field on create maybe)
			this.AppData.SampleDetails = newSample;
			const session = await this.pict.providers.SessionProvider.getSession();
			if (session.LoggedIn)
			{
				newSample.CreatingIDUser = session.UserID;
			}
		}
		catch (error)
		{
			this.log.error(`Error getting session: ${error.message || error}`, { stack: error.stack });
		}
		finally
		{
			if (pRender)
			{
				await new Promise((resolve) => this.renderAsync(() =>
				{
					this.log.info('Sample Create view cleared');
					resolve();
				}));
			}
		}
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.AppData.SampleDetails));

		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		try
		{
			delete tmpSample.CreatingIDUser;
			const tmpResult = await this.pict.providers.SampleProvider.createSample(tmpSample, null, true);
			this.AppData.SampleDetails = tmpResult;
			this.log.info('Sample created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Sample: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToEditView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to edit');
			return;
		}
		this.log.info('Going to Edit Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}/Edit`);
	}

	goToReadView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to view');
			return;
		}
		this.log.info('Going to Read Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}`);
	}

	async saveSampleChanges()
	{
		this.log.info('Saving Sample changes');
		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		const tmpResult = await this.pict.providers.SampleProvider.updateSample(tmpSample);
		if (tmpResult)
		{
			this.log.info('Sample changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Sample changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Sample changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Sample changes', type: 'is-danger' });
		}
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Sample form submitted');

		this.createNewSample(event);
	}
}

module.exports = LIMSSampleRecordCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSSampleRecordCreate',
	DefaultRenderable: 'LIMSSampleRecordCreate',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	Templates:
	[
		{
			Hash: 'LIMSSampleRecordCreate-Wrapper',
			Template: /*html*/`
			<form class="container form" data-sample-id="{~D:Record.IDSample~}" onsubmit="_Pict.views.LIMSSampleRecordCreate.handleFormSubmitAction(event);">
				{~T:LIMSSampleRecordCreate-NewSampleHeader:AppData.SampleDetails~}
				<!-- LIMSSampleRecordCreate Content -->
				<div id="LIMSSampleRecordPanel-Details-Content">
					<div id="LIMSSampleRecordCreate-Details-Container">{~T:LIMSSampleRecordCreate-Details:AppData.SampleDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSSampleRecordCreate-NewSampleHeader',
			Template: /*html*/`
				<header id="PRSP_Title_Container" class="p-5 pb-0 has-background-text-soft is-vcentered">
					<h2 class="title is-size-4" id="PRSP_Title">Create New Sample</h2>
				</header>`,
		},
		{
			Hash: 'LIMSSampleRecordCreate-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSSampleRecordCreate-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSSampleRecordCreate-Details-Buttons-Create:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordCreate-Details-Buttons-Create',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" class="button is-link is-soft" title="Clear sample" onclick="_Pict.views.LIMSSampleRecordCreate.clearSample()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span class="icon-text">Clear</span>
					</button>
					<button type="submit" class="button is-link" title="Create new sample">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save New Sample</span>
					</button>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSSampleRecordCreate',
			TemplateHash: 'LIMSSampleRecordCreate-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultSampleCreateManifest.json":847,"pict-view":818}],835:[function(require,module,exports){

const PictViewClass = require('pict-view');

class LIMSSampleRecordEdit extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.ActiveSampleLogs = [];

		this.AppData.SampleDetails = { };

		/** @type {Record<string, any>} */
		this.manifest = require('./defaultSampleEditManifest.json');
	}

	async onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	async onNavigate(pSampleGUID, pResetState = true)
	{
		this.AppData.GUIDSample = pSampleGUID;
		if (pResetState)
		{
			delete this.AppData.LoggedBy;
			//TODO: if we came here from the sample view screen, do we want to leave this rather than re-loading?
			this.AppData.SampleDetails = { };
		}
		if (this.initialized)
		{
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
		}
		await new Promise((resolve) => this.renderAsync((pError) =>
		{
			if (pError)
			{
				this.log.error(`Error rendering Sample Edit view: ${pError.message || pError}`, { stack: pError.stack });
			}
			else
			{
				this.log.info('Sample Edit view rendered');
			}
			resolve();
		}));
	}

	async onBeforeRenderAsync(fCallback, pRenderable)
	{
		const session = await this.pict.providers.SessionProvider.getSession();
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-SampleEdit'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-SampleEdit'].options.DefaultDestinationAddress = '#LIMSSampleRecordEdit-Container';
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-SampleEdit'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			let tmpInitialBundleGather = Promise.resolve();
			if (Array.isArray(this.manifest.InitialBundle) && this.manifest.InitialBundle.length > 0)
			{
				tmpInitialBundleGather = new Promise((resolve) => this.pict.providers.FormInitialBundle.gatherInitialBundle(this.manifest, (pError) =>
				{
					if (pError)
					{
						this.log.error(`Error gathering the Sample Edit initial bundle: ${pError.message || pError}`, { stack: pError.stack });
					}
					resolve();
				})).catch((pError) =>
				{
					this.log.error(`Error gathering the Sample Edit initial bundle: ${pError.message || pError}`, { stack: pError.stack });
				});
			}
			try
			{
				await this.pict.PictApplication.applySampleDisabledState();
				this.pict.views['PictSectionForm-SampleEdit'].rebuildCustomTemplate();
				this.log.info('Sample-Record-Edit rendered with Active Record', this.AppData.SampleDetails);

				if (this.AppData.GUIDSample)
				{
					this.log.info('Sample Details view opened with GUIDSample', this.AppData.GUIDSample);
					// get the Sample record by ID
					const tmpRecord = await this.pict.providers.SampleProvider.getSampleByGUID(this.AppData.GUIDSample);
					if (tmpRecord)
					{
						this.AppData.SampleDetails = tmpRecord;
						this.log.info('Sample Details view opened with Sample record', this.AppData.SampleDetails);
						// get the logs for the Sample
						const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.AppData.SampleDetails.IDSample);
						this.ActiveSampleLogs = tmpLogs;
						// Resolve spec-year scope for downstream picker providers
						// (e.g. MaterialSelector). Awaiting ensures the scope is
						// loaded before the form renders so pickers apply the
						// filter on first search. Fails open per §5.1 of the
						// spec-year design doc.
						if (this.pict.providers.SpecScopeResolver && tmpRecord.IDProject > 0)
						{
							await this.pict.providers.SpecScopeResolver.loadForProject(tmpRecord.IDProject);
						}
					}
					else
					{
						//FIXME: should notify the user / show a message / render a template ...
						this.log.error('Sample record not found for ID', this.AppData.GUIDSample);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Sample Details onBeforeRenderAsync:', error);
			}

			await tmpInitialBundleGather;
			return fCallback();
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {ErrorCallback} fCallback
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-SampleEdit'].render();
		this.pict.views['PictSectionForm-SampleEdit'].marshalToView();
		if (this.AppData.disableSampleEdit)
		{
			document.getElementById('LIMSSampleRecordPanel-Save-Changes')?.classList?.add?.('is-hidden');
		}
		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Open the Sample detail view for the selected Sample to view the full details
	 * @param {number|string} pIDSample - The ID of the Sample to view
	 * @param {object} pSampleRecord - The Sample record to view
	 * @param {string} pOpenTab - The tab to open when the Sample detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showSampleDetailView(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		// if a Sample record is passed in, use it, otherwise get the Sample record by ID
		if (pSampleRecord)
		{
			this.AppData.SampleDetails = Array.isArray(pSampleRecord) ? pSampleRecord[0] : pSampleRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.SampleProvider.getSampleByID(pIDSample);
			this.AppData.SampleDetails = tmpRecord;
		}
		// if the Sample record is not found, log an error and return
		if (!this.AppData.SampleDetails)
		{
			this.log.error('Sample record not found for ID', pIDSample);
			return;
		}
		else
		{
			// get the logs for the Sample
			const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.AppData.SampleDetails.IDSample);
			this.ActiveSampleLogs = tmpLogs;
		}
		// render the Sample detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Sample Edit rendered with Active Record', this.AppData.SampleDetails);
				resolve();
			});
		});
	}

	/**
	 * This method is used to add a new log to the Sample and refresh the Sample Details view.
	 * @return {Promise<void>}
	 * @async
	 */
	async addNewLogToSample()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to add log to');
			return;
		}
		this.pict.ContentAssignment.addClass('#LIMSSampleRecordPanel-Logs-Add-Button', 'is-loading');
		this.log.info('Adding new log to Sample ID:', this.AppData.SampleDetails.IDSample);

		this.log.info('Attempting to fetch geolocation...');
		const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();

		if (geoCoords)
		{
			// If we got a geolocation, update the sampel with it.
			await this.pict.providers.SampleProvider.updateSample(
				{
					IDSample: this.AppData.SampleDetails.IDSample,
					CaptureLatitude: geoCoords.CaptureLatitude,
					CaptureLongitude: geoCoords.CaptureLongitude,
				},
			);
			this.AppData.SampleDetails.CaptureLatitude = geoCoords.CaptureLatitude;
			this.AppData.SampleDetails.CaptureLongitude = geoCoords.CaptureLongitude;
		}

		const tmpLogMessage = this.pict.ContentAssignment.readContent('#LIMSSampleRecordEdit-Tab-Logs-CreateNewLog-Textarea');
		const tmpOptions = {
			IDSample: this.AppData.SampleDetails.IDSample,
			CaptureLatitude: this.AppData.SampleDetails.CaptureLatitude,
			CaptureLongitude: this.AppData.SampleDetails.CaptureLongitude,
			Notes: tmpLogMessage,
		};
		// go make the new log entry, then refresh the view
		await this.pict.providers.SampleLogProvider.createSampleLog(tmpOptions);
		this.log.info('Sample Log added to Sample', this.AppData.SampleDetails.IDSample);
		// NOTE: can't go back to "Logs" since we're already on "Logs" tab
		await this.showSampleDetailView(this.AppData.SampleDetails.IDSample, null, 'Logs');
		// a bit hacky to get back to the same tab again, but limited time right now
		document.getElementById('LIMSSampleRecordPanel-Logs-Tab').click();
	}

	/**
	 * This method is used to clear the new log entry field in the Sample Details view.
	 * @return {void}
	 */
	clearNewLogEntry()
	{
		this.pict.ContentAssignment.assignContent('#LIMSSampleRecordEdit-Tab-Logs-CreateNewLog-Textarea', '');
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to print QR Code for');
			return;
		}
		this.log.info('Printing Sample Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.AppData.SampleDetails.QRCode);
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
		if (pTabID?.includes('Print'))
		{
			this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.AppData.SampleDetails.QRCode, 'LIMSSampleRecordEdit-PrintPreview');
		}
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.AppData.SampleDetails));

		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		try
		{
			const tmpResult = await this.pict.providers.SampleProvider.createSample(tmpSample, null, true);
			this.AppData.SampleDetails = tmpResult;
			this.log.info('Sample created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Sample: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToEditView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to edit');
			return;
		}
		this.log.info('Going to Edit Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}/Edit`);
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to view');
			return;
		}
		this.log.info('Going to Read Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}`);
	}

	async saveSampleChanges()
	{
		this.log.info('Saving Sample changes');
		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		const tmpResult = await this.pict.providers.SampleProvider.updateSample(tmpSample);
		if (tmpResult)
		{
			this.log.info('Sample changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Sample changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Sample changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Sample changes', type: 'is-danger' });
		}
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Sample form submitted');

		//FIXME: async? error handling?
		this.saveSampleChanges();
	}
}

module.exports = LIMSSampleRecordEdit;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSSampleRecordEdit',
	DefaultRenderable: 'LIMSSampleRecordEdit',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSSampleRecordEdit-Wrapper',
			Template: /*html*/`
			<form class="container form" data-sample-id="{~D:Record.IDSample~}" onsubmit="_Pict.views.LIMSSampleRecordEdit.handleFormSubmitAction(event);">
				{~T:LIMSSampleRecordEdit-SampleHeader:AppData.SampleDetails~}
				<!-- Sample Panel Tabs -->
				{~T:LIMSSampleRecordEdit-Panel-Tabs:AppData.SampleDetails~}
				<!-- LIMSSampleRecordEdit Content > Tab Details View -->
				<div id="LIMSSampleRecordPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSSampleRecordEdit-Details-Container">{~T:LIMSSampleRecordEdit-Tab-Details:AppData.SampleDetails~}</div>
				</div>
				<!-- LIMSSampleRecordEdit Content > Tab Logs View -->
				<div id="LIMSSampleRecordPanel-Logs-Content" class="tab-content">
					<div id="LIMSSampleRecordEdit-Logs-Container">{~T:LIMSSampleRecordEdit-Tab-Logs:Context[0].ActiveSampleLogs~}</div>
				</div>
				<!-- LIMSSampleRecordEdit Content > Tab Print View -->
				<div id="LIMSSampleRecordPanel-Print-Content" class="tab-content">
					<div id="LIMSSampleRecordEdit-Print-Container">{~T:LIMSSampleRecordEdit-Tab-Print:AppData.SampleDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">
				<ul>
					<li class="is-active">
						<a id="LIMSSampleRecordPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSSampleRecordEdit.toggleTabContent(event, 'LIMSSampleRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-Logs-Tab" onclick="_Pict.views.LIMSSampleRecordEdit.toggleTabContent(event, 'LIMSSampleRecordPanel-Logs')">
							<span class="icon">
								<i class="fa fa-fw fa-list-timeline"></i>
							</span>
							<span class="icon-text">
								Logs
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-Print-Tab" onclick="_Pict.views.LIMSSampleRecordEdit.toggleTabContent(event, 'LIMSSampleRecordPanel-Print');">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-SampleHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">{~D:Record.Name:N/A~}</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
					<span class="label is-size-7 has-text-text-50 mb-0">Status:</p>
					{~StatusPill:Record.Status~}
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSSampleRecordEdit-Container" class="px-5 mt-2"></div>
			{~T:LIMSSampleRecordEdit-Tab-Details-Buttons-Edit:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Details-Buttons-Edit',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" id="LIMSSampleRecordEdit-Tab-Details-Cancel-Button" class="button is-link is-soft" onclick="_Pict.views.LIMSSampleRecordEdit.goToReadView(event)">
						<span class="icon">
							<i class="fa fa-fw fa-times"></i>
						</span>
						<span class="icon-text">Cancel</span>
					</button>
					<button type="submit" id="LIMSSampleRecordPanel-Save-Changes" class="button is-link">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save Changes</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordEdit-Tab-Logs-Items:Record:Record.length^>^0~}
				{~TIfAbs:LIMSSampleRecordEdit-Tab-Logs-Empty:Record:Record.length^<=^0~}
				{~T:LIMSSampleRecordEdit-Tab-Logs-Entry:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No logs are available for this sample.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Items',
			Template: /*html*/`
			<div id="LIMSSampleRecordEdit-Tab-Logs-Items">
				{~TS:LIMSSampleRecordEdit-Tab-Logs-Item:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4">
				<figure class="image">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-light.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Geolocation for sample" />
				</figure>
				<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
					<div class="is-size-7">#{~D:Record.IDSampleLog~}</div>
					<div>{~D:Record.Notes~}</div>
					<div class="is-size-7">
						<span class="has-text-soft">on</span>
						<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-soft">by</span>
						<span>{~Entity:User^Record.CreatingIDUser^LIMSSampleRecordEdit-Tab-Logs-Item-User^~}</span>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Entry',
			Template: /*html*/`
			<div class="column" style="border-top: 1px solid var(--bulma-border);">
				<textarea id="LIMSSampleRecordEdit-Tab-Logs-CreateNewLog-Textarea" style="min-height: 4rem" class="textarea" placeholder="Enter log notes here"></textarea>
				<div class="buttons mt-2 is-right">
					<button type="button" class="button is-link is-soft" title="Clear log entry" onclick="_Pict.views.LIMSSampleRecordEdit.clearNewLogEntry()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span>Clear</span>
					</button>
					<button type="button" class="button is-link" title="Add new log to sample"onclick="_Pict.views.LIMSSampleRecordEdit.addNewLogToSample()">
						<span class="icon">
							<i class="fa fa-fw fa-plus"></i>
						</span>
						<span>Add Log</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Print',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column" id="LIMSSampleRecordEdit-PrintPreview">
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-link" title="Print qrcode label" onclick="_Pict.views.LIMSSampleRecordEdit.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span>Print QRCode Label</span>
						</button>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSSampleRecordEdit',
			TemplateHash: 'LIMSSampleRecordEdit-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultSampleEditManifest.json":848,"pict-view":818}],836:[function(require,module,exports){

const PictViewClass = require('pict-view');

class LIMSSampleRecordView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.ActiveSampleLogs = [];
		/** @type {Record<string, any>} */
		this.extendedSchema = null;

		this.AppData.SampleDetails = { };
		this.AppData.ActiveLIMSSampleDocuments = [];
		this.AppData.ActiveLIMSSampleLineItems = [];
		this.AppData.ActiveLIMSSampleTestInstanceBundle = [];
		this.CurrentSearchFilters = {
			PageSize: 250,
			CurrentPage: 1,
			LineItem: [],
		};
		this.deletePermission = 'Denied';
		this.ActiveLineItemID = 0;
		this.ActiveLIProjectID = 0;
		this.ActiveRepresentedQuantity = 0;
		this.lineItemAddOpen = false;

		this.manifest = require('./defaultSampleViewManifest.json');

		this.pict.MetaTemplate.addPattern('{~TestInstanceName:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.AppData.ActiveLIMSSampleTestInstanceBundle?.TestMap?.[tmpRecord.IDTest]?.Name || tmpRecord.Name || 'N/A';
		});

		this.pict.MetaTemplate.addPattern('{~TestInstanceStatus:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const status = tmpRecord.Status || tmpRecord.TestResult || 'N/A';
			const colorMap =
			{
				'pass': 'green',
				'fail': 'red',
				'sqty': 'green',
			};
			return `<span style="font-weight: bold; color: ${ colorMap[status?.toLowerCase()] || 'black' };" >${ status }</span>`;
		});

		this.pict.MetaTemplate.addPattern('{~TestInstanceAttachedDocuments:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const documents = this.AppData.ActiveLIMSSampleTestInstanceBundle?.TestInstanceDocumentMap?.[tmpRecord.IDTestInstance];
			if (!documents?.length)
			{
				return '<em class="has-text-text-50">None</em>';
			}
			let outTemplate = '';
			for (const d of documents)
			{
				outTemplate += `<div><a class="is-ghost" target="_blank" href="#/Document/${ d.GUIDDocument }">${ d.Name }</a>${ this.fable.parseTemplate('{~QuickSummary:Document^Record.IDDocument~}', d) }</div>`;
			}
			return outTemplate;
		});

		this.pict.MetaTemplate.addPattern('{~AddDocumentButtonClass:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// Note: this button is hidden for now.
			return this.AppData.ActiveLIMSSampleTestInstanceBundle?.TestInstanceDocumentMap?.[tmpRecord.IDTestInstance]?.length ? 'is-hidden' : 'is-hidden';
		});
	}

	/*
	 * Lifecycle hook that triggers when the view is initialized.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 */
	async onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	/**
	 * Navigation handler
	 * @param {string} pSampleGUID - GUID for the Sample being rendered.
	 * @param {boolean} [pResetState] - Whether the component state should be reset while navigating.
	 */
	async onNavigate(pSampleGUID, pResetState = true)
	{
		this.AppData.GUIDSample = pSampleGUID;
		if (pResetState)
		{
			delete this.AppData.LoggedBy;
			//TODO: if we came here from the sample edit screen, do we want to leave this rather than re-loading?
			this.AppData.SampleDetails = { };
			this.AppData.ActiveLIMSSampleDocuments = [];
			this.AppData.ActiveLIMSSampleLineItems = [];
			this.AppData.ActiveLIMSSampleTestInstanceBundle = [];
			// A fresh sample opens on the Details tab; no heavy tab data is loaded
			// until the user actually opens that tab (see _ensureTabDataLoaded).
			this._activatedTabs = {};
			this.ActiveLIProjectID = 0;
			this.ActiveLineItemID = 0;
			this.ActiveRepresentedQuantity = 0;
			this.lineItemAddOpen = false;
		}
		if (this.initialized)
		{
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
		}
		await new Promise((resolve) => this.renderAsync((pError) =>
		{
			if (pError)
			{
				this.log.error(`[Sample-Record-View] Error rendering Sample view: ${pError.message || pError}`, { stack: pError.stack });
			}
			else
			{
				this.log.info('[Sample-Record-View] Sample view rendered');
			}
			resolve();
		}));
	}

	/*
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	async onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.ActiveLineItemID = 0;
		this.ActiveRepresentedQuantity = 0;
		this.deletePermission = 'Denied';

		const session = await this.pict.providers.SessionProvider.getSession();
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'View', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-SampleView'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-SampleView'].options.DefaultDestinationAddress = '#LIMSSampleRecordView-View-Container';
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-SampleView'].rebuildCustomTemplate();
			this.initialized = true;
		}
		// Kicked off next to the record read rather than awaited inline; it settles with the rest of
		// the page's loads below.
		let tmpDeletePermissionLoad = null;
		if (this.AppData.GUIDSample)
		{
			// get the Sample record by ID
			const tmpRecord = await this.pict.providers.SampleProvider.getSampleByGUID(this.AppData.GUIDSample);
			if (tmpRecord)
			{
				this.AppData.SampleDetails = tmpRecord;
				tmpDeletePermissionLoad = Promise.resolve(this.pict.PictApplication.PermissionsControl.checkEntityPermission('Sample', this.AppData.SampleDetails, 'Delete'))
					.then((pPermission) => { this.deletePermission = pPermission; })
					// Handled here rather than by the gather below so a failed check leaves deletePermission
					// at its 'Denied' default instead of failing the whole page load.
					.catch((pError) => { this.log.error('Error resolving the Sample delete permission:', pError); });
			}
		}
		return super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-SampleView'].rebuildCustomTemplate();
				this.log.info('Sample-Record-View rendered with Active Record', this.AppData.SampleDetails);

				// Once the Sample record is in hand nothing below depends on anything else below, so
				// they are gathered and awaited together instead of as a serial chain. They all still
				// settle before fCallback, so the render contract is unchanged.
				const tmpPageLoads = [ this.pict.PictApplication.applySampleDisabledState() ];
				if (tmpDeletePermissionLoad)
				{
					tmpPageLoads.push(tmpDeletePermissionLoad);
				}

				if (this.AppData.GUIDSample)
				{
					this.log.info('Sample Details view opened with GUIDSample', this.AppData.GUIDSample);
					if (this.AppData.SampleDetails)
					{
						this.ActiveLIProjectID = this.AppData.SampleDetails.IDProject || 0;
						tmpPageLoads.push(new Promise((resolve, reject) =>
						{
							this.pict.HeadlightRestClient.getEntitySet('Project', `FBV~IDProject~EQ~${ this.AppData.SampleDetails.IDProject }`, (err, res) =>
							{
								if (err)
								{
									return reject(err);
								}
								resolve(res);
							});
						}).then((pProjects) => { this.CurrentSearchFilters.Project = pProjects; }));
						// Resolve spec-year scope so downstream picker providers
						// (e.g. MaterialSelector) can apply contract-scoped filters
						// on their first AJAX search. Resolver fails open per §5.1
						// of the spec-year design doc if the contract has no FK,
						// the set is empty, or the customer has no spec sets.
						if (this.pict.providers.SpecScopeResolver && this.ActiveLIProjectID > 0)
						{
							tmpPageLoads.push(this.pict.providers.SpecScopeResolver.loadForProject(this.ActiveLIProjectID));
						}
						this.log.info('Sample Details view opened with Sample record', this.AppData.SampleDetails);
						// Load only the data for tabs the user has actually opened. The
						// default Details tab needs none of this, so a fresh sample open
						// fires zero of these heavy fan-outs. Each heavy tab loads its
						// data the first time it is activated (see _ensureTabDataLoaded);
						// the flags survive renderAsync refreshes (reset only on navigate).
						this._activatedTabs = this._activatedTabs || {};
						if (this._activatedTabs.Documents)
						{
							tmpPageLoads.push(this.pict.providers.DocumentProvider.getDocumentsByRemoteID(this.AppData.SampleDetails.IDSample, 'Sample')
								.then((pDocuments) => { this.AppData.ActiveLIMSSampleDocuments = pDocuments; }));
						}
						if (this._activatedTabs.LineItems)
						{
							tmpPageLoads.push(this.pict.providers.LineItemProvider.getLineItemsByIDSample(this.AppData.SampleDetails.IDSample)
								.then((pLineItems) => { this.AppData.ActiveLIMSSampleLineItems = pLineItems; }));
						}
						if (this._activatedTabs.TestInstances)
						{
							tmpPageLoads.push(this.pict.providers.TestInstanceProvider.getTestInstanceBundleForSample(this.AppData.SampleDetails.IDSample)
								.then((pBundle) => { this.AppData.ActiveLIMSSampleTestInstanceBundle = pBundle; }));
						}
						// Sample logs stay eager — a single cheap request, and the add-log
						// flow (showSampleDetailView) depends on them being present.
						tmpPageLoads.push(this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.AppData.SampleDetails.IDSample)
							.then((pLogs) => { this.ActiveSampleLogs = pLogs; }));
					}
					else
					{
						//FIXME: should notify the user / show a message / render a template ...
						this.log.error('Sample record not found for ID', this.AppData.GUIDSample);
					}
				}
				await Promise.all(tmpPageLoads);
			}
			catch (error)
			{
				this.log.error('Error in Sample Details onBeforeRenderAsync:', error);
			}
			fCallback();
		}, pRenderable);
	}

	/*
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-SampleView'].render();
		this.pict.views['PictSectionForm-SampleView'].marshalToView();
		if (this.AppData.disableSampleEdit)
		{
			document.getElementById('LIMSSampleRecordPanel-Edit')?.classList?.add?.('is-hidden');
		}
		if (this.AppData.disableSampleCreate)
		{
			document.getElementById('LIMSSampleRecordPanel-Clone')?.classList?.add?.('is-hidden');
		}
		this.initializeSelect2Plugin({
			placeholder: 'Select a Project..',
			ElementID: 'LIMSSampleRecordView-ProjectSelector',
			ParentID: 'LIMSSampleRecordView-ProjectSelectorParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: [ 'Name' ],
		}, () =>
		{
			this.log.info('Select2 LineItems initialized');
		});
		this.initializeSelect2Plugin({
			IDProject: this.pict.AppData.SampleDetails.IDProject,
			placeholder: 'Select a Line Item..',
			ElementID: 'LIMSSampleRecordView-LineItemSelector',
			ParentID: 'LIMSSampleRecordView-LineItemSelectorParent',
			URL: 'LineItems',
			IDField: 'IDLineItem',
			TextField: [ 'Name' ],
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		if (this.deletePermission == 'Allowed')
		{
			document.getElementById('LIMSSampleRecordPanel-Details-Delete-Button')?.classList?.remove?.('is-hidden');
		}
		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Initializes a Select2 Selector via jQuery
	 * @param {object} pOptions - The select customization options.
	 * @param {function} pCallback - Callback for when initialization is complete.
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-light',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-light',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 250,
						},
					};
					if (pOptions.URL == 'LineItems')
					{
						tmpSearchQuery.filters.push({
							field: 'IDProject',
							comparator: 'EQ',
							target: _Pict.views.LIMSSampleRecordView.ActiveLIProjectID || pOptions.IDProject,
						});
					}
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.LIMSSampleRecordView.CurrentSearchFilters[pOptions.URL] || [];
					if (data.length == 1 && params.page == 1 && pOptions.URL == 'LineItems' && !_Pict.views.LIMSSampleRecordView.ActiveLineItemID)
					{
						_Pict.views.LIMSSampleRecordView.ActiveLineItemID = data[0].IDLineItem;
					}

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption, true),
						more: params.term ? data.length === _Pict.views.LIMSSampleRecordView.CurrentSearchFilters.PageSize : data.length === _Pict.views.LIMSSampleRecordView.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Open the Sample detail view for the selected Sample to view the full details
	 * @param {number|string} pIDSample - The ID of the Sample to view
	 * @param {object} pSampleRecord - The Sample record to view
	 * @param {string} pOpenTab - The tab to open when the Sample detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showSampleDetailView(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		// if a Sample record is passed in, use it, otherwise get the Sample record by ID
		if (pSampleRecord)
		{
			this.AppData.SampleDetails = Array.isArray(pSampleRecord) ? pSampleRecord[0] : pSampleRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.SampleProvider.getSampleByID(pIDSample);
			this.AppData.SampleDetails = tmpRecord;
		}
		// if the Sample record is not found, log an error and return
		if (!this.AppData.SampleDetails)
		{
			this.log.error('[Sample-Record-View] Sample record not found for ID', pIDSample);
			return;
		}

		// get the logs for the Sample
		const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.AppData.SampleDetails.IDSample);
		this.ActiveSampleLogs = tmpLogs;
		// render the Sample detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('[Sample-Record-View] Sample Details View Rendered with Active Record', this.AppData.SampleDetails);
				resolve();
			});
		});
	}

	/**
	 * This method is used to add a new log to the Sample and refresh the Sample Details view.
	 * @return {Promise<void>}
	 * @async
	 */
	async addNewLogToSample()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('[Sample-Record-View] No active Sample to add log to');
			return;
		}
		this.pict.ContentAssignment.addClass('#LIMSSampleRecordPanel-Logs-Add-Button', 'is-loading');
		this.log.info('[Sample-Record-View] Adding new log to Sample ID:', this.AppData.SampleDetails.IDSample);

		this.log.info('[Sample-Record-View] Attempting to fetch geolocation...');
		const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();

		if (geoCoords)
		{
			// If we got a geolocation, update the sampel with it.
			await this.pict.providers.SampleProvider.updateSample(
				{
					IDSample: this.AppData.SampleDetails.IDSample,
					CaptureLatitude: geoCoords.CaptureLatitude,
					CaptureLongitude: geoCoords.CaptureLongitude,
				},
			);
			this.AppData.SampleDetails.CaptureLatitude = geoCoords.CaptureLatitude;
			this.AppData.SampleDetails.CaptureLongitude = geoCoords.CaptureLongitude;
		}

		const tmpLogMessage = this.pict.ContentAssignment.readContent('#LIMSSampleRecordView-Tab-Logs-CreateNewLog-Textarea');
		const tmpOptions = {
			IDSample: this.AppData.SampleDetails.IDSample,
			CaptureLatitude: this.AppData.SampleDetails.CaptureLatitude,
			CaptureLongitude: this.AppData.SampleDetails.CaptureLongitude,
			Notes: tmpLogMessage,
		};
		// go make the new log entry, then refresh the view
		await this.pict.providers.SampleLogProvider.createSampleLog(tmpOptions);
		this.log.info('[Sample-Record-View] Sample Log added to Sample', this.AppData.SampleDetails.IDSample);
		// NOTE: can't go back to "Logs" since we're already on "Logs" tab
		await this.showSampleDetailView(this.AppData.SampleDetails.IDSample, null, 'Logs');
		// a bit hacky to get back to the same tab again, but limited time right now
		document.getElementById('LIMSSampleRecordPanel-Logs-Tab').click();
	}

	/**
	 * Handler that is called when a document gets attached to the Sample.
	 * @param {number} IDDocument - The document ID being attached.
	 */
	async documentAttachHandler(IDDocument)
	{
		await this.pict.providers.DocumentProvider.addRemoteToDocument(IDDocument, this.AppData.SampleDetails.IDSample, 'Sample');
		this.renderAsync(()=>
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'close');
			this.pict.views.LIMSSampleRecordView.toggleTabContent({}, 'LIMSSampleRecordPanel-Documents');
		});
	}

	/**
	 * Opens the document panel to allow attaching a document to the Sample.
	 */
	attachDocument()
	{
		this.pict.views.HeadlightPaneDocuments.Intent =
		{
			type: 'add',
			handler: (IDDocument) =>
			{
 this.documentAttachHandler(IDDocument);
			},
			afterRenderHandler: () =>
			{
				// If the sample has a project, lock the project selector down.
				if (this.AppData.SampleDetails.IDProject)
				{
					this.pict.views.DocumentCreate.CurrentDocumentRecord.Project = this.AppData.SampleDetails.IDProject;
					const stuffToHide = [ 'DocumentCreate-Entry-Project-Wrapper', 'DocumentCreate-ClearButton' ];
					for (const s of stuffToHide)
					{
						document.getElementById(s)?.classList?.add?.('is-hidden');
					}
				}
			},
		};
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'open');
	}

	/**
	 * Toggles the collapsible section for adding a LineItem open and closed.
	 */
	toggleLineItemAdd()
	{
		this.lineItemAddOpen = !this.lineItemAddOpen;
		if (this.lineItemAddOpen)
		{
			document.getElementById('LIMSSampleRecordView-Tab-LineItems-Caret-Icon').classList.add('fa-caret-up');
			document.getElementById('LIMSSampleRecordView-Tab-LineItems-Caret-Icon').classList.remove('fa-caret-down');
			document.getElementById('LIMSSampleRecordView-Tab-LineItems-Add-Content').classList.remove('is-hidden');
		}
		else
		{
			document.getElementById('LIMSSampleRecordView-Tab-LineItems-Caret-Icon').classList.remove('fa-caret-up');
			document.getElementById('LIMSSampleRecordView-Tab-LineItems-Caret-Icon').classList.add('fa-caret-down');
			document.getElementById('LIMSSampleRecordView-Tab-LineItems-Add-Content').classList.add('is-hidden');
		}
	}

	/**
	 * Opens a modal that allows for editing the Represented Quantity of a LineItem attached to the Sample.
	 * @param {string} GUIDSampleLineItemJoin - The GUID of the join being updated.
	 * @param {number} IDLineItem - ID of the LI in the join.
	 */
	async updateQuantityForItem(GUIDSampleLineItemJoin, IDLineItem)
	{
		const li = await new Promise((resolve, reject) => 
		{
			this.pict.HeadlightRestClient.getEntity('LineItem', IDLineItem, (err, res) =>
			{
				if (err)
				{
					return reject(err);
				}
				resolve(res);
			});
		});
		this.fable.HeadlightModal.spawnModal({
			title: `Update Quantity for ${ li.Name || 'Line Item' }`,
			message: '',
			style: 'wide',
			confirmText: 'Update',
			confirmColor: 'is-success',
			confirmIcon: 'check',
			modalBodyTemplate: /*html*/`
				<div class="container column is-12">
					<div class="mr-2" style="width: 100%;">
						<input class="is-hidden" id="LIMSUpdateQuantity-ID" value="${ GUIDSampleLineItemJoin }" />
						<div class="field">
							<label class="label block" for="LIMSUpdateQuantity-Modal">New Represented Quantity:</label>
							<div class="control">
								<input 
									id="LIMSUpdateQuantity-Modal" 
									class="input" 
									type="number"
									placeholder="0"
									autocomplete="off"
								/>
							</div>
						</div>
					</div>
				</div>`,
		}, async ()=>
		{
			this.fable.HeadlightModal.addLoader('Updating Line Item...');
			// @ts-ignore
			const newQuantity = Number(document.getElementById('LIMSUpdateQuantity-Modal')?.value) || 0;

			await _Pict.providers.LineItemProvider.saveSampleLineItemJoin(
				{
					// @ts-ignore
					GUIDSampleLineItemJoin: document.getElementById('LIMSUpdateQuantity-ID').value,
					RepresentedQuantity: newQuantity,
				},
			);
			await _Pict.views.LIMSSampleRecordView.updateSampleQuantityFromLineItems();
			_Pict.views.LIMSSampleRecordView.renderAsync(()=>
			{
				_Pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-LineItems-Tab') }, 'LIMSSampleRecordPanel-LineItems');
				this.fable.HeadlightModal.dismissLoader();
			});
		});
	}

	/**
	 * Removes a LineItem from the Sample
	 * @param {number} IDSampleLineItemJoin - The join id for the join being removed.
	 */
	async removeSampleLineItemJoin(IDSampleLineItemJoin)
	{
		this.fable.HeadlightModal.addLoader('Removing Line Item...');
		await this.pict.providers.LineItemProvider.deleteSampleLineItemJoin(IDSampleLineItemJoin);
		await this.updateSampleQuantityFromLineItems();
		this.renderAsync(() =>
		{
			_Pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-LineItems-Tab') }, 'LIMSSampleRecordPanel-LineItems');
			this.fable.HeadlightModal.dismissLoader();
		});
	}

	/**
	 * Updates the Sample Quantity by summing up the total quantities for all attached LineItems.
	 */
	async updateSampleQuantityFromLineItems()
	{
		this.AppData.ActiveLIMSSampleLineItems = await this.pict.providers.LineItemProvider.getLineItemsByIDSample(this.pict.AppData.SampleDetails.IDSample);
		let quantity = 0;
		for (const li of this.AppData.ActiveLIMSSampleLineItems)
		{
			quantity += Number(li.RepresentedQuantity) || 0;
		}
		await this.pict.providers.SampleProvider.updateSample(
			{
				IDSample: this.pict.AppData.SampleDetails.IDSample,
				GUIDSample: this.pict.AppData.SampleDetails.GUIDSample,
				RepresentedQuantity: quantity,
			},
		);
	}

	/**
	 * Updates the "selected" LineItem that will be added to the Sample. Triggered by the LineItem selector.
	 * @param {number} value - Selected IDLineItem
	 */
	updateIDLineItem(value)
	{
		this.ActiveLineItemID = value;
	}

	/**
	 * Updates the "selected" Project that filters the LineItem. Triggered by the Project selector.
	 * @param {number} value - Selected IDProject
	 */
	updateIDProject(value)
	{
		this.ActiveLIProjectID = value;
	}

	/**
	 * Updates the Quantity that will be added the LineItem join when it is added to the Sample.
	 * @param {number} value - Manually entered Represented Quantity.
	 */
	updateLineItemRepresentedQuantity(value)
	{
		this.ActiveRepresentedQuantity = value;
	}

	/**
	 * Adds the selected LineItem to the Sample.
	 * @return {Promise<void>}
	 */
	async addLineItem()
	{
		if (!this.ActiveLineItemID)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Line Item was selected.',
				type: 'is-danger',
			});
			return;
		}
		this.fable.HeadlightModal.addLoader('Adding Line Item...');
		await this.pict.providers.LineItemProvider.saveSampleLineItemJoin(
		{
			IDSample: this.pict.AppData.SampleDetails.IDSample,
			IDLineItem: this.ActiveLineItemID,
			RepresentedQuantity: this.ActiveRepresentedQuantity || 0,
		});
		await _Pict.views.LIMSSampleRecordView.updateSampleQuantityFromLineItems();
		this.renderAsync(()=>
		{
			_Pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-LineItems-Tab') }, 'LIMSSampleRecordPanel-LineItems');
			this.fable.HeadlightModal.dismissLoader();
		});
	}

	/**
	 * Opens the document panel to allow creating a new document that will be added to the Sample.
	 */
	createNewDocumentAndAttach()
	{
		this.pict.views.HeadlightPaneDocuments.Intent =
		{
			type: 'add',
			handler: (IDDocument) =>
			{
 this.documentAttachHandler(IDDocument);
			},
			afterRenderHandler: () =>
			{
				// If the sample has a project, lock the project selector down.
				if (this.AppData.SampleDetails.IDProject)
				{
					this.pict.views.DocumentCreate.CurrentDocumentRecord.Project = this.AppData.SampleDetails.IDProject;
					const stuffToHide = [ 'DocumentCreate-Entry-Project-Wrapper', 'DocumentCreate-ClearButton' ];
					for (const s of stuffToHide)
					{
						document.getElementById(s)?.classList?.add?.('is-hidden');
					}
				}
			},
		};
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'open');
		this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Create', 'Document');
	}

	/**
	 * This method is used to clear the new log entry field in the Sample Details view.
	 * @return {void}
	 */
	clearNewLogEntry()
	{
		this.pict.ContentAssignment.assignContent('#LIMSSampleRecordView-Tab-Logs-CreateNewLog-Textarea', '');
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('[Sample-Record-View] No active Sample to print QR Code for');
			return;
		}
		this.log.info('[Sample-Record-View] Printing Sample Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.AppData.SampleDetails.QRCode);
	}

	/**
	 * Handles toggling between tabs.
	 * @param {object} event - The click event.
	 * @param {string} pTabID - ID of the tab being switched to.
	 */
	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
		if (pTabID?.includes('Print'))
		{
			this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.AppData.SampleDetails.QRCode, 'LIMSSampleRecordView-PrintPreview');
		}
		// Lazy-load this tab's remote data the first time it is opened.
		this._ensureTabDataLoaded(pTabID);
	}

	/**
	 * Lazy-load a tab's remote data the first time it is activated, then
	 * re-render so the tab fills in. The Details tab (default) carries no remote
	 * data, so a fresh sample open never triggers these fetches.
	 * @param {string} pTabID - Panel id being activated (e.g. 'LIMSSampleRecordPanel-Documents').
	 */
	_ensureTabDataLoaded(pTabID)
	{
		const tmpTabDataKeys =
		{
			'LIMSSampleRecordPanel-Documents': 'Documents',
			'LIMSSampleRecordPanel-LineItems': 'LineItems',
			'LIMSSampleRecordPanel-TestInstances': 'TestInstances',
		};
		const tmpKey = tmpTabDataKeys[pTabID];
		if (!tmpKey || !this.AppData.GUIDSample)
		{
			return;
		}
		this._activatedTabs = this._activatedTabs || {};
		if (this._activatedTabs[tmpKey])
		{
			return;
		}
		this._activatedTabs[tmpKey] = true;
		// The tab is already visible at this point, so fill it with a skeleton rather than leaving it
		// blank for the length of the fetch.
		this.pict.PictApplication.showDetailLoadingShell(`#LIMSSampleRecordView-${ tmpKey }-Container`, 5, false);
		// Re-render so onBeforeRenderAsync loads this tab's data, then re-show it.
		this.renderAsync(() =>
		{
			this.toggleTabContent({ currentTarget: document.getElementById(`${ pTabID }-Tab`) }, pTabID);
		});
	}

	/**
	 * Toggles the page into Edit mode.
	 * @return {void}
	 */
	goToEditView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('[Sample-Record-View] No active Sample to edit');
			return;
		}
		this.log.info('[Sample-Record-View] Going to Edit Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}/Edit`);
	}

	/**
	 * Confirmation prompt for deleting a Sample.
	 */
	confirmDeleteSample()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Sample',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Sample?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.SampleDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Sample" onclick="_Pict.views.LIMSSampleRecordView.deleteSample()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Sample</span>
				</button>
			</div>`,
			confirmText: 'Delete Sample',
			cancelText: 'Cancel',
		});
	}

	/**
	 * Handles deleting the current sample.
	 * @return {void}
	 */
	deleteSample()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('[Sample-Record-View] No active Sample to delete');
			return;
		}
		this.log.info('[Sample-Record-View] Deleting Sample ID:', this.AppData.SampleDetails.IDSample);
		this.pict.providers.SampleProvider.deleteSample(this.AppData.SampleDetails.IDSample);
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles removing a TestInstance attached to a Sample.
	 * @param {number} IDTestInstance - The Test ID being removed.
	 */
	deleteTestInstance(IDTestInstance)
	{
		if (this.pict.AppData.SampleDetails.Locked)
		{
			return;
		}
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Remove Test',
			message: 'Are you sure you want to delete this Test?',
			confirmText: 'Delete',
			confirmColor: 'is-danger',
			confirmIcon: 'trash',
		}, ()=>
		{
			_Pict.providers.TestInstanceProvider.deleteTestInstanceByID(IDTestInstance);
			_Pict.views.LIMSSampleRecordView.renderAsync(()=>
			{
				_Pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-TestInstances-Tab') }, 'LIMSSampleRecordPanel-TestInstances');
			});
		});
	}
}

module.exports = LIMSSampleRecordView;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSSampleRecordView',
	DefaultRenderable: 'LIMSSampleRecordView',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSSampleRecordView-Wrapper',
			Template: /*html*/`
			<form class="container form" data-sample-id="{~D:Record.IDSample~}" onsubmit="_Pict.views.LIMSSampleRecordView.handleFormSubmitAction(event);">
				{~T:LIMSSampleRecordView-SampleHeader:AppData.SampleDetails~}
				<!-- Sample Panel Tabs -->
				{~T:LIMSSampleRecordView-Panel-Tabs:AppData.SampleDetails~}
				<!-- LIMSSampleRecordView Content > Tab Documents View -->
				<div id="LIMSSampleRecordPanel-Documents-Content" class="tab-content">
					<div id="LIMSSampleRecordView-Documents-Container">{~T:LIMSSampleRecordView-Tab-Documents:AppData.ActiveLIMSSampleDocuments~}</div>
				</div>
				<div id="LIMSSampleRecordPanel-LineItems-Content" class="tab-content">
					<div id="LIMSSampleRecordView-LineItems-Container">{~T:LIMSSampleRecordView-Tab-LineItems:AppData.ActiveLIMSSampleLineItems~}</div>
				</div>
				<div id="LIMSSampleRecordPanel-TestInstances-Content" class="tab-content">
					<div id="LIMSSampleRecordView-TestInstances-Container">{~T:LIMSSampleRecordView-Tab-TestInstances:AppData.ActiveLIMSSampleTestInstanceBundle.TestInstances~}</div>
				</div>
				<!-- LIMSSampleRecordView Content > Tab Details View -->
				<div id="LIMSSampleRecordPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSSampleRecordView-Details-Container">{~T:LIMSSampleRecordView-Tab-Details:AppData.SampleDetails~}</div>
				</div>
				<!-- LIMSSampleRecordView Content > Tab Logs View -->
				<div id="LIMSSampleRecordPanel-Logs-Content" class="tab-content">
					<div id="LIMSSampleRecordView-Logs-Container">{~T:LIMSSampleRecordView-Tab-Logs:Context[0].ActiveSampleLogs~}</div>
				</div>
				<!-- LIMSSampleRecordView Content > Tab Print View -->
				<div id="LIMSSampleRecordPanel-Print-Content" class="tab-content">
					<div id="LIMSSampleRecordView-Print-Container">{~T:LIMSSampleRecordView-Tab-Print:AppData.SampleDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSSampleRecordView-NewSampleHeader',
			Template: /*html*/`<h1 class="title is-4">Create New Sample</h1>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">
				<style>
					li.tab-spacer
					{
						width: 100%;
					}
				</style>
				<ul>
					<li>
						<a id="LIMSSampleRecordPanel-Documents-Tab" class="is-active" onclick="_Pict.views.LIMSSampleRecordView.toggleTabContent(event, 'LIMSSampleRecordPanel-Documents')">
							<span class="icon">
								<i class="fa fa-fw fa-files"></i>
							</span>
							<span class="icon-text">
								Documents
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-LineItems-Tab" class="is-active" onclick="_Pict.views.LIMSSampleRecordView.toggleTabContent(event, 'LIMSSampleRecordPanel-LineItems')">
							<span class="icon">
								<i class="fa fa-fw fa-list-tree"></i>
							</span>
							<span class="icon-text">
								Line Items
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-TestInstances-Tab" class="is-active" onclick="_Pict.views.LIMSSampleRecordView.toggleTabContent(event, 'LIMSSampleRecordPanel-TestInstances')">
							<span class="icon">
								<i class="fa fa-fw fa-flask-vial"></i>
							</span>
							<span class="icon-text">
								Tests
							</span>
						</a>
					</li>
					<li class="is-active">
						<a id="LIMSSampleRecordPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSSampleRecordView.toggleTabContent(event, 'LIMSSampleRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li class="tab-spacer"></li>
					<li>
						<a id="LIMSSampleRecordPanel-Logs-Tab" onclick="_Pict.views.LIMSSampleRecordView.toggleTabContent(event, 'LIMSSampleRecordPanel-Logs')">
							<span class="icon">
								<i class="fa fa-fw fa-list-timeline"></i>
							</span>
							<span class="icon-text">
								Logs
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-Print-Tab" onclick="_Pict.views.LIMSSampleRecordView.toggleTabContent(event, 'LIMSSampleRecordPanel-Print');">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSSampleRecordView-SampleHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">{~D:Record.Name:N/A~}</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
					<span class="label is-size-6 has-text-text-50 mb-0">Status:</p>
					<div class="pl-2">{~StatusPill:Record.Status~}</div>
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSSampleRecordView-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSSampleRecordView-Tab-Details-Buttons-Read:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordView-Tab-LineItems-Items:Record:Record.length^>^0~}
				{~TIfAbs:LIMSSampleRecordView-Tab-LineItems-Empty:Record:Record.length^<=^0~}
			`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				{~T:LIMSSampleRecordView-Tab-LineItems-Add:Record~}
				<p class="has-text-centered mt-2">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No Line Items are currently attached to this sample.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-AddLineItemsButton',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordView-AddLineItemsButton-Disabled:Record:Record.Locked^==^1~}
				{~TIfAbs:LIMSSampleRecordView-AddLineItemsButton-Enabled:Record:Record.Locked^!=^1~}
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-AddLineItemsButton-Enabled',
			Template: /*html*/`
						<button type="button" class="button is-link" title="Add Line Items" onclick="_Pict.views.LIMSSampleRecordView.toggleLineItemAdd()">
							<span class="icon">
								<i class="fa fa-fw fa-plus"></i>
							</span>
							<span>Add Line Items</span>
							<span class="icon">
								<i id="LIMSSampleRecordView-Tab-LineItems-Caret-Icon" 
									class="fa fa-fw fa-{~TIfAbs:LIMSSampleRecordView-Tab-LineItems-Caret-Up:Record:Context[0].lineItemAddOpen^TRUE^true~}{~TIfAbs:LIMSSampleRecordView-Tab-LineItems-Caret-Down:Record:Context[0].lineItemAddOpen^FALSE^false~}"></i>
							</span>
						</button>`,
		},
		{
			Hash: 'LIMSSampleRecordView-AddLineItemsButton-Disabled',
			Template: /*html*/`
						<button type="button" class="button is-link" disabled title="Sample is locked; cannot add Line Items">
							<span class="icon">
								<i class="fa fa-fw fa-plus"></i>
							</span>
							<span>Add Line Items</span>
						</button>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Add',
			Template: /*html*/`
			<div class="column" style="border-bottom: 1px solid var(--bulma-border);">
				<div class="mb-2" style="display: flex; flex-direction: row;">
					<div class="ml-3 mt-2" style="width: 100%;">
						<b class="has-text-text-50">Current Sample Represented Quantity:</b>
						<b>{~D:AppData.SampleDetails.RepresentedQuantity~}</b>
					</div>
					<div class="buttons is-right mr-1">
						{~T:LIMSSampleRecordView-AddLineItemsButton:AppData.SampleDetails~}
					</div>
				</div>
				{~T:LIMSSampleRecordView-Tab-LineItems-Add-Content:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Add-Content',
			Template: /*html*/`
				<div id="LIMSSampleRecordView-Tab-LineItems-Add-Content" class="{~TIfAbs:LIMSSampleRecordView-Hide-Class:Record:Context[0].lineItemAddOpen^FALSE^false~}">
					{~T:LIMSSampleRecordView-LineItemSelector~}
				</div>
			`,
		},
		{
			Hash: 'LIMSSampleRecordView-LineItemSelector',
			Template: /*html*/`
			<div style="margin-bottom: 10px; display: flex;">
				<div class="mx-2" style="width: 100%;" id="LIMSSampleRecordView-ProjectSelectorParent">
					<div class="field" style="width: 100%;">
						<label class="label block" for="LIMSSampleRecordView-ProjectSelector">Select the Line Item's Project:</label>
						<div class="control select is-fullwidth">
							<select 
								id="LIMSSampleRecordView-ProjectSelector" 
								style="width: 100%;"
								onchange="_Pict.views.LIMSSampleRecordView.updateIDProject(value)"
							>{~TS:LIMSSampleRecordView-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
						</div>
					</div>
				</div>
				<div class="mr-2" style="width: 100%;" id="LIMSSampleRecordView-LineItemSelectorParent">
					<div class="field" style="width: 100%;">
						<label class="label block" for="LIMSSampleRecordView-LineItemSelector">Select a Line Item to Add:</label>
						<div class="control select is-fullwidth">
							<select 
								id="LIMSSampleRecordView-LineItemSelector" 
								style="width: 100%;"
								onchange="_Pict.views.LIMSSampleRecordView.updateIDLineItem(value)"
							>{~TS:LIMSSampleRecordView-LineItemSelector-SelectedOptions:Context[0].CurrentSearchFilters.LineItem~}</select>
						</div>
					</div>
				</div>
				<div class="mr-2" style="width: 100%;">
					<div class="field">
						<label class="label block" for="LIMSSampleRecordView-LineItemRepresentedQuantity">Represented Quantity:</label>
						<div class="control">
							<input 
								id="LIMSSampleRecordView-LineItemRepresentedQuantity" 
								class="input" 
								type="number"
								placeholder="0"
								autocomplete="off"
								onchange="_Pict.views.LIMSSampleRecordView.updateLineItemRepresentedQuantity(value)"
							/>
						</div>
					</div>
				</div>
				<div style="margin-right: 10px;"><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.LIMSSampleRecordView.addLineItem()" class="button is-rounded is-link has-text-white"><i class="fas fa-fw fa-check" style="margin-right: 5px;"></i></button></div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-LineItemSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDLineItem~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'LIMSSampleRecordView-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Hide-Class',
			Template: 'is-hidden',
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Caret-Down',
			Template: 'caret-down',
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Caret-Up',
			Template: 'caret-up',
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Items',
			Template: /*html*/`
			<div id="LIMSSampleRecordView-Tab-LineItems-Items">
				<style>
					.test-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.test-entry
					{
						border-top: 1px solid var(--bulma-border);;
						border-bottom: 1px solid var(--bulma-border);;
					}
					.test-status
					{
						margin-right: 10vw;
					}
					.hover-red:hover
					{
						color: red !important;
					}
				</style>
				{~T:LIMSSampleRecordView-Tab-LineItems-Add:Record~}
				{~TS:LIMSSampleRecordView-Tab-LineItems-Item:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Actions',
			Template: /*html*/`
				<!-- LIMS Sample record-view tab action cell (bespoke per-tab buttons; NOT the PSRS list action-cell template) -->
				<div class="test-actions">
					<ul class="buttons has-addons is-centered">
						<li>
							<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault(); _Pict.views.LIMSSampleRecordView.updateQuantityForItem('{~D:Record.GUIDSampleLineItemJoin~}', {~D:Record.IDLineItem~})">
								<span class="icon">
									<i class="fas fa-pencil"></i>
								</span>
								<span class="icon-text">Edit Quantity</span>
							</a>
						</li>
						<li>
							<a class="button is-ghost hover-red" href="javascript:void(0)" onclick="event.preventDefault(); _Pict.views.LIMSSampleRecordView.removeSampleLineItemJoin({~D:Record.IDSampleLineItemJoin~})">
								<span class="icon">
									<i class="fas fa-trash"></i>
								</span>
								<span class="icon-text">Remove</span>
							</a>
						</li>
					</ul>
				</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 test-entry">
				<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
					<div class="test-entry-row">
						<span class="mr-2">
							<b>{~D:Record.Name~}</b>
							{~QuickSummary:LineItem^Record.IDLineItem~}
						</span>
						<span class="test-status">
							<span class="has-text-text-50">Represented Quantity:</span> <b>{~D:Record.RepresentedQuantity~}</b>
						</span>
					</div>
					<div class="is-size-7 test-entry-row ">
						<span><b class="has-text-text-50">Project:</b> {~Entity:Project^Record.IDProject^LIMSSampleRecordView-Entity-Name^~}
						{~QuickSummary:Project^Record.IDProject~}
						</span>
					</div>
					<div class="is-size-7 test-entry-row ">
						<span>
							<span class="has-text-text-50">Created on</span>
							<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
							<span class="has-text-text-50">by</span>
							<span>{~Entity:User^Record.CreatingIDUser^LIMSSampleRecordView-Tab-Documents-Item-User^~}</span>
						</span>
					</div>
				</div>
				<div class="image">
					{~T:LIMSSampleRecordView-Tab-LineItems-Actions:Record~}
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-LineItems-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-TestInstances',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordView-Tab-TestInstances-Items:Record:Record.length^>^0~}
				{~TIfAbs:LIMSSampleRecordView-Tab-TestInstances-Empty:Record:Record.length^<=^0~}
			`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-TestInstances-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No Tests are currently attached to this sample.</span>
				</p>
				{~T:LIMSSampleRecordView-AddTestsButton:AppData.SampleDetails~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-AddTestsButton',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordView-AddTestsButton-Disabled:Record:Record.Locked^==^1~}
				{~TIfAbs:LIMSSampleRecordView-AddTestsButton-Enabled:Record:Record.Locked^!=^1~}
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-AddTestsButton-Enabled',
			Template: /*html*/`
				<div class="column" style="border-top: 1px solid var(--bulma-border);">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-link" title="Add New Tests" onclick="_Pict.views.TestInstanceWizard.openTestInstanceWizard();">
							<span class="icon">
								<i class="fa fa-fw fa-plus"></i>
							</span>
							<span>Add Tests</span>
						</button>
					</div>
				</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-AddTestsButton-Disabled',
			Template: /*html*/`
				<div class="column" style="border-top: 1px solid var(--bulma-border);">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-link" title="Sample is locked; tests cannot be added" disabled>
							<span class="icon">
								<i class="fa fa-fw fa-plus"></i>
							</span>
							<span>Add Tests</span>
						</button>
					</div>
				</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-TestInstances-Items',
			Template: /*html*/`
			<div id="LIMSSampleRecordView-Tab-TestInstances-Items">
				<style>
					.test-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.test-entry
					{
						border-top: 1px solid var(--bulma-border);;
						border-bottom: 1px solid var(--bulma-border);;
					}
					.test-status
					{
						margin-right: 10vw;
					}
					.hover-red:hover
					{
						color: red !important;
					}
				</style>
				{~T:LIMSSampleRecordView-AddTestsButton:AppData.SampleDetails~}
				{~TS:LIMSSampleRecordView-Tab-TestInstances-Item:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-TestInstances-Actions',
			Template: /*html*/`
				<!-- LIMS Sample record-view tab action cell (bespoke per-tab buttons; NOT the PSRS list action-cell template) -->
				<div class="test-actions">
					<ul class="buttons has-addons is-centered">
						<li class="{~AddDocumentButtonClass:Record~}">
							<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault(); ">
								<span class="icon">
									<i class="fas fa-paperclip-vertical"></i>
								</span>
								<span class="icon-text">Add to Document</span>
							</a>
						</li>
						<li>
							<a class="button is-ghost hover-red" href="javascript:void(0)" onclick="event.preventDefault(); _Pict.views.LIMSSampleRecordView.deleteTestInstance({~D:Record.IDTestInstance~})">
								<span class="icon">
									<i class="fas fa-trash"></i>
								</span>
								<span class="icon-text">Remove</span>
							</a>
						</li>
					</ul>
				</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-TestInstances-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 test-entry">
				<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
					<div>
						<b>{~TestInstanceName:Record~}</b>
						{~QuickSummary:TestInstance^Record.IDTestInstance~}
					</div>
					<div class="is-size-7 test-entry-row">
						<span>
							<span class="has-text-text-50">Created on</span>
							<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
							<span class="has-text-text-50">by</span>
							<span>{~Entity:User^Record.CreatingIDUser^LIMSSampleRecordView-Tab-Documents-Item-User^~}</span>
						</span>
					</div>
					<div class="is-size-7 is-flex">
						<span class="has-text-text-50 pr-1">Status:</span> {~TestInstanceStatus:Record~}
					</div>
					<div class="is-size-7 is-flex">
						<span class="has-text-text-50 pr-1">Remarks:</span>
						<!-- min-width lets the rendered remark wrap inside the flex row instead of overflowing it. -->
						<div style="flex-grow: 1; min-width: 0;">{~MarkdownRemarksClamped:Record.Notes^LIMSSampleRecordView-Remarks-Empty^~}</div>
					</div>
					<div class="is-size-7">
						<b class="has-text-text-50 pr-1">Attached Documents:</b>
						<div style="display: flex; flex-direction: column;">{~TestInstanceAttachedDocuments:Record~}</div>
					</div>
				</div>
				<div class="image">
					{~T:LIMSSampleRecordView-Tab-TestInstances-Actions:Record~}
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Remarks-Empty',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-TestInstances-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Documents',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordView-Tab-Documents-Items:Record:Record.length^>^0~}
				{~TIfAbs:LIMSSampleRecordView-Tab-Documents-Empty:Record:Record.length^<=^0~}
			`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Documents-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No documents are currently attached to this sample.</span>
				</p>
				<div class="column" style="border-top: 1px solid var(--bulma-border);">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-link is-soft" title="Attach an Existing Document" onclick="_Pict.views.LIMSSampleRecordView.attachDocument()">
							<span class="icon">
								<i class="fa fa-fw fa-paperclip-vertical"></i>
							</span>
							<span>Attach Document</span>
						</button>
						<button type="button" class="button is-link" title="Create a New Document to Attach"onclick="_Pict.views.LIMSSampleRecordView.createNewDocumentAndAttach()">
							<span class="icon">
								<i class="fa fa-fw fa-file-plus"></i>
							</span>
							<span>New Document</span>
						</button>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Documents-Items',
			Template: /*html*/`
			<div id="LIMSSampleRecordView-Tab-Documents-Items">
				<style>
					.document-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.document-entry
					{
						border-top: 1px solid var(--bulma-border);;
						border-bottom: 1px solid var(--bulma-border);;
					}
					.document-status
					{
						margin-right: 10vw;
					}
				</style>
				<div class="column" style="border-bottom: 1px solid var(--bulma-border);">
					<div class="buttons is-right">
						<button type="button" class="button is-link is-soft" title="Attach an Existing Document" onclick="_Pict.views.LIMSSampleRecordView.attachDocument()">
							<span class="icon">
								<i class="fa fa-fw fa-paperclip-vertical"></i>
							</span>
							<span>Attach Document</span>
						</button>
						<button type="button" class="button is-link" title="Create a New Document to Attach"onclick="_Pict.views.LIMSSampleRecordView.createNewDocumentAndAttach()">
							<span class="icon">
								<i class="fa fa-fw fa-file-plus"></i>
							</span>
							<span>New Document</span>
						</button>
					</div>
				</div>
				{~TS:LIMSSampleRecordView-Tab-Documents-Item:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Documents-Actions',
			Template: /*html*/`
				<!-- LIMS Sample record-view tab action cell (bespoke per-tab buttons; NOT the PSRS list action-cell template) -->
				<div class="document-actions">
					<ul class="buttons has-addons is-centered">
						<!-- TODO: check if the entity is print-able - currently, they both are -->
						<li>
							<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault(); _Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.IDDocument~});">
								<span class="icon">
									<i class="fas fa-print"></i>
								</span>
								<span class="icon-text">Print</span>
							</a>
						</li>
						<li>
							<a class="button is-ghost" href="#/Document/{~D:Record.GUIDDocument~}" title="{~TBR:Record.Name~}">
								<span class="icon">
									<i class="fas fa-search"></i>
								</span>
								<span class="icon-text">View</span>
							</a>
						</li>
						<li>
							<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.IDDocument~});" title="{~TBR:Record.Name~}">
								<span class="icon">
									<i class="fas fa-pencil"></i>
								</span>
								<span class="icon-text">Edit</span>
							</a>
						</li>
					</ul>
				</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Documents-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 document-entry">
				<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
					<div>
						<span class="tag">#{~D:Record.SequenceNumber~}</span>&nbsp;<b>{~D:Record.Name~}</b>
						{~QuickSummary:Document^Record.IDDocument~}
					</div>
					<div class="document-entry-row is-size-7">
						<span><b class="has-text-text-50">Type:</b> {~DocumentTypeName:Record.DocumentType~}</span>
						<span class='document-status'>
							Status: <b>{~D:Record.Status~}</b>
						</span>
					</div>
					<div class="is-size-7">
						<span class="has-text-text-50">Created on</span>
						<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-50">by</span>
						<span>{~Entity:User^Record.CreatingIDUser^LIMSSampleRecordView-Tab-Documents-Item-User^~}</span>
					</div>
				</div>
				<div class="image">
					{~T:LIMSSampleRecordView-Tab-Documents-Actions:Record~}
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Documents-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-Entity-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-EditSampleButton',
			Template: /*html*/`
				<!-- Edit Sample Button -->
				{~TIfAbs:LIMSSampleRecordView-EditSampleButton-Disabled:Record:Record.Locked^==^1~}
				{~TIfAbs:LIMSSampleRecordView-EditSampleButton-Enabled:Record:Record.Locked^!=^1~}
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-EditSampleButton-Enabled',
			Template: /*html*/`
				<button type="button" id="LIMSSampleRecordPanel-Edit" class="button is-link" onclick="_Pict.views.LIMSSampleRecordView.goToEditView()">
					<span class="icon">
						<i class="fa fa-fw fa-pencil"></i>
					</span>
					<span class="icon-text">Edit Sample</span>
				</button>
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-EditSampleButton-Disabled',
			Template: /*html*/`
				<button type="button" id="LIMSSampleRecordPanel-Edit" class="button is-link" disabled title="Sample is locked; editing is disabled">
					<span class="icon">
						<i class="fa fa-fw fa-pencil"></i>
					</span>
					<span class="icon-text">Edit Sample</span>
				</button>
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-DeleteSampleButton',
			Template: /*html*/`
				<!-- Delete Sample Button -->
				{~TIfAbs:LIMSSampleRecordView-DeleteSampleButton-Disabled:Record:Record.Locked^==^1~}
				{~TIfAbs:LIMSSampleRecordView-DeleteSampleButton-Enabled:Record:Record.Locked^!=^1~}
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-DeleteSampleButton-Enabled',
			Template: /*html*/`
				<button type="button" id="LIMSSampleRecordPanel-Details-Delete-Button" class="button is-link is-outlined is-hidden" onclick="_Pict.views.LIMSSampleRecordView.confirmDeleteSample()">
					<span class="icon">
						<i class="fa fa-fw fa-trash"></i>
					</span>
					<span class="icon-text">Delete Sample</span>
				</button>
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-DeleteSampleButton-Disabled',
			Template: /*html*/`
				<button type="button" id="LIMSSampleRecordPanel-Details-Delete-Button" class="button is-link is-outlined is-hidden" disabled title="Sample is locked; deletion is disabled">
					<span class="icon">
						<i class="fa fa-fw fa-trash"></i>
					</span>
					<span class="icon-text">Delete Sample</span>
				</button>
				`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Details-Buttons-Read',
			Template: /*html*/`
			<div class="buttons my-2 mr-6 is-right">
				{~T:LIMSSampleRecordView-DeleteSampleButton:AppData.SampleDetails~}
				<!-- Clone Sample Button -->
				<button type="button" id="LIMSSampleRecordPanel-Clone" class="button is-link" onclick="_Pict.providers.LIMSRouter.router.navigate('/Create-Sample/ClonedFrom/' + _Pict.AppData.SampleDetails.GUIDSample);">
					<span class="icon">
						<i class="fa fa-fw fa-clone"></i>
					</span>
					<span class="icon-text">Clone Sample</span>
				</button>
				{~T:LIMSSampleRecordView-EditSampleButton:AppData.SampleDetails~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Logs',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordView-Tab-Logs-Items:Record:Record.length^>^0~}
				{~TIfAbs:LIMSSampleRecordView-Tab-Logs-Empty:Record:Record.length^<=^0~}
				{~T:LIMSSampleRecordView-Tab-Logs-Entry:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Logs-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No logs are available for this sample.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Logs-Items',
			Template: /*html*/`
			<div id="LIMSSampleRecordView-Tab-Logs-Items">
				{~TS:LIMSSampleRecordView-Tab-Logs-Item:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Logs-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4">
				<figure class="image">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-light.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Geolocation for sample" />
				</figure>
				<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
					<div class="is-size-7 has-text-text-50">#{~D:Record.IDSampleLog~}</div>
					<div><b>{~D:Record.Notes~}</b></div>
					<div class="is-size-7">
						<span class="has-text-text-50">on</span>
						<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-50">by</span>
						<span>{~Entity:User^Record.CreatingIDUser^LIMSSampleRecordView-Tab-Logs-Item-User^~}</span>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Logs-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Logs-Entry',
			Template: /*html*/`
			<div class="column" style="border-top: 1px solid var(--bulma-border);">
				<textarea id="LIMSSampleRecordView-Tab-Logs-CreateNewLog-Textarea" style="min-height: 4rem" class="textarea" placeholder="Enter log notes here"></textarea>
				<div class="buttons mt-2 is-right">
					<button type="button" class="button is-link is-soft" title="Clear log entry" onclick="_Pict.views.LIMSSampleRecordView.clearNewLogEntry()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span>Clear</span>
					</button>
					<button type="button" class="button is-link" title="Add new log to sample"onclick="_Pict.views.LIMSSampleRecordView.addNewLogToSample()">
						<span class="icon">
							<i class="fa fa-fw fa-plus"></i>
						</span>
						<span>Add Log</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordView-Tab-Print',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column" id="LIMSSampleRecordView-PrintPreview">
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-link" title="Print qrcode label" onclick="_Pict.views.LIMSSampleRecordView.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span>Print QRCode Label</span>
						</button>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSSampleRecordView',
			TemplateHash: 'LIMSSampleRecordView-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};

},{"./defaultSampleViewManifest.json":850,"pict-view":818}],837:[function(require,module,exports){
const libPictView = require('pict-view');

const ENTITY_LABELS = (
	{
		Contract: 'Contract specification sets',
		LineItem: 'Line item pay items',
		ProjectLineItemMaterialTest: 'Sample plan tests',
		MaterialLineItemJoin: 'Line item materials',
	});

const LOAD_STATUS_LABELS = (
	{
		'Loaded': 'Saved',
		'Errors': 'Some failed',
		'Not attempted': 'Skipped (an earlier step failed)',
	});

class LIMSSamplePlanCopy extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.comprehensionResult = null;
		this.loadResult = null;
		this.statusMessage = '';
		this.isProcessing = false;

		this._selectedSource = null;
		this._selectedDest = null;

		this.sourceSets = null;
		this.destSets = null;
		this.projectSetsDiffer = false;
		this.specSetView = null;

		this.flipTargetSpecificationSet = false;
	}

	/**
	 * @return {string} What the copy does about differing specification sets, given the checkbox.
	 */
	get setMismatchOutcome()
	{
		if (this.flipTargetSpecificationSet)
		{
			return 'The copy will also move the destination\'s contract and line item pay items onto the source\'s specification sets.';
		}
		return 'The destination keeps its specification sets; sample plan tests are copied onto its line items by item code.';
	}

	/**
	 * Record whether the copy also moves the destination onto the source's specification sets. A preview built
	 * with the other choice no longer matches, so it is cleared.
	 * @param {boolean} pChecked - The checkbox state.
	 */
	async setFlipTargetSpecificationSet(pChecked)
	{
		this.flipTargetSpecificationSet = pChecked === true;
		this.saveSelections();
		if (this.comprehensionResult)
		{
			this.comprehensionResult = null;
			this.loadResult = null;
			this.specSetView = null;
			this.pict.views.HeadlightPanels.toast({ message: 'Preview again to see the copy with this choice.', type: 'is-info' });
		}
		await this.rerender();
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		super.onBeforeRenderAsync(pCallback, pRenderable);
	}

	onAfterRender(pRenderable)
	{
		this.initializeSelect2Plugin({
			placeholder: 'Search for a source project...',
			ElementID: 'SamplePlanCopy-SourceProject',
			ParentID: 'SamplePlanCopy-SourceProjectParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: ['Name'],
			PageSize: 50,
		});
		this.initializeSelect2Plugin({
			placeholder: 'Search for a destination project...',
			ElementID: 'SamplePlanCopy-DestProject',
			ParentID: 'SamplePlanCopy-DestProjectParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: ['Name'],
			PageSize: 50,
		});

		$('#SamplePlanCopy-SourceProject').on('select2:select',
			() =>
			{
				this.onProjectSelected('Source');
			});
		$('#SamplePlanCopy-DestProject').on('select2:select',
			() =>
			{
				this.onProjectSelected('Dest');
			});

		// Restore previously selected values after rerender
		if (this._selectedSource)
		{
			let tmpOption = new Option(this._selectedSource.text, this._selectedSource.id, true, true);
			$('#SamplePlanCopy-SourceProject').append(tmpOption).trigger('change');
		}
		if (this._selectedDest)
		{
			let tmpOption = new Option(this._selectedDest.text, this._selectedDest.id, true, true);
			$('#SamplePlanCopy-DestProject').append(tmpOption).trigger('change');
		}

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Initializes a Select2 Selector via jQuery for project search.
	 * @param {object} pOptions - The select customization options.
	 */
	initializeSelect2Plugin(pOptions)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-light',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-light',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: 0,
			language: {
				searching: function()
				{
					return 'Searching...';
				},
				noResults: function()
				{
					return 'No projects found.';
				},
				loadingMore: function()
				{
					return 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return 'Type to search for a project...';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [
							{
								field: 'Deleted',
								comparator: 'EQ',
								target: '0',
							},
						],
						pagination: {
							start: 1,
							limit: pOptions.PageSize || 50,
						},
						sort: {
							field: 'Name',
							direction: 'ASC',
						},
					};
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;
					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, [], null, true),
					};
				},
			},
		});
	}

	/**
	 * Save the current select2 selections so they can be restored after rerender.
	 */
	saveSelections()
	{
		let tmpSourceEl = $('#SamplePlanCopy-SourceProject');
		let tmpDestEl = $('#SamplePlanCopy-DestProject');

		let tmpSourceData = tmpSourceEl.select2('data');
		if (tmpSourceData && tmpSourceData.length > 0)
		{
			this._selectedSource = { id: tmpSourceData[0].id, text: tmpSourceData[0].text };
		}

		let tmpDestData = tmpDestEl.select2('data');
		if (tmpDestData && tmpDestData.length > 0)
		{
			this._selectedDest = { id: tmpDestData[0].id, text: tmpDestData[0].text };
		}
	}

	/**
	 * Look up the specification sets of a newly selected project and show them under its picker.
	 * @param {string} pSide - 'Source' or 'Dest'.
	 */
	onProjectSelected(pSide)
	{
		let tmpElementID = (pSide === 'Source') ? '#SamplePlanCopy-SourceProject' : '#SamplePlanCopy-DestProject';
		let tmpIDProject = parseInt($(tmpElementID).val(), 10);
		if (isNaN(tmpIDProject))
		{
			return;
		}

		let tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
		tmpService.describeProjectSpecificationSets(tmpIDProject, null,
			(pError, pSets) =>
			{
				if (parseInt($(tmpElementID).val(), 10) !== tmpIDProject)
				{
					return;
				}

				let tmpDisplay = null;
				if (pError)
				{
					this.log.error(`Error describing specification sets for project ${tmpIDProject}`, pError);
					this.pict.views.HeadlightPanels.toast({ message: 'Could not read the specification sets for that project.', type: 'is-warning' });
				}
				else
				{
					tmpDisplay = this.formatProjectSets(pSets, pSets.SpecificationSetNames);
				}

				if (pSide === 'Source')
				{
					this.sourceSets = tmpDisplay;
				}
				else
				{
					this.destSets = tmpDisplay;
				}
				this.projectSetsDiffer = this.isSpecificationSetMismatch(this.sourceSets, this.destSets);
				this.saveSelections();
				this.rerender();
			});
	}

	/**
	 * @param {number} pIDTestSpecificationSet - A set ID.
	 * @param {Record<string, string>} pNames - Set names by ID.
	 * @return {string} A display label.
	 */
	formatSetLabel(pIDTestSpecificationSet, pNames)
	{
		if (!(pIDTestSpecificationSet > 0))
		{
			return 'None';
		}
		return (pNames || {})[pIDTestSpecificationSet] || `Specification set ${pIDTestSpecificationSet}`;
	}

	/**
	 * @param {Record<string, any>} pSets - A ProjectSpecificationSets from SamplePlanService.
	 * @param {Record<string, string>} pNames - Set names by ID.
	 * @return {Record<string, any>} Display fields for one project.
	 */
	formatProjectSets(pSets, pNames)
	{
		let tmpBasisLabel = 'Unknown: no contract, and the line items do not share one specification set';
		if (pSets.Basis === 'Contract')
		{
			tmpBasisLabel = `Its contract, ${pSets.Contract.Name || pSets.Contract.IDContract}`;
		}
		else if (pSets.Basis === 'PayItems')
		{
			tmpBasisLabel = 'Its line items\' pay items (no contract)';
		}
		return (
			{
				Known: pSets.ItemIDTestSpecificationSet > 0,
				ItemIDTestSpecificationSet: pSets.ItemIDTestSpecificationSet,
				MaterialIDTestSpecificationSet: pSets.MaterialIDTestSpecificationSet,
				PayItemSetIDs: Object.keys(pSets.PayItemSetDistribution || {}).map((pID) => parseInt(pID, 10)),
				ItemLabel: this.formatSetLabel(pSets.ItemIDTestSpecificationSet, pNames),
				MaterialLabel: this.formatSetLabel(pSets.MaterialIDTestSpecificationSet, pNames),
				BasisLabel: tmpBasisLabel,
			});
	}

	/**
	 * @param {Record<string, any>|null} pSource - Source display sets.
	 * @param {Record<string, any>|null} pDest - Destination display sets.
	 * @return {boolean} True when a copy between them would realign the destination.
	 */
	isSpecificationSetMismatch(pSource, pDest)
	{
		if (!pSource || !pDest || !pSource.Known)
		{
			return false;
		}
		if (pDest.Known && ((pSource.ItemIDTestSpecificationSet !== pDest.ItemIDTestSpecificationSet) || (pSource.MaterialIDTestSpecificationSet !== pDest.MaterialIDTestSpecificationSet)))
		{
			return true;
		}
		return pDest.PayItemSetIDs.some((pID) => pID !== pSource.ItemIDTestSpecificationSet);
	}

	/**
	 * Flatten the service's specification set report into template-ready fields.
	 * @param {Record<string, any>} pSpecSets - reportData.specificationSets from SamplePlanService.
	 * @return {Record<string, any>|null} Display fields, or null when the report carries none.
	 */
	prepareSpecificationSetView(pSpecSets)
	{
		if (!pSpecSets || !pSpecSets.Alignment)
		{
			return null;
		}
		let tmpNames = pSpecSets.Names || {};
		let tmpAlignment = pSpecSets.Alignment;
		let tmpSource = this.formatProjectSets(pSpecSets.Source, tmpNames);
		let tmpDest = this.formatProjectSets(pSpecSets.Dest, tmpNames);
		let tmpContract = tmpAlignment.Contract;
		let tmpShared = tmpContract ? tmpContract.SharedWithProjects : [];
		return (
			{
				Crossing: tmpAlignment.Crossing === true,
				ShowChanges: (tmpAlignment.Crossing === true) && (tmpAlignment.Flip !== false),
				ShowKept: (tmpAlignment.Crossing === true) && (tmpAlignment.Flip === false),
				SourceItemLabel: tmpSource.ItemLabel,
				SourceMaterialLabel: tmpSource.MaterialLabel,
				SourceBasisLabel: tmpSource.BasisLabel,
				DestItemLabel: tmpDest.ItemLabel,
				DestMaterialLabel: tmpDest.MaterialLabel,
				DestBasisLabel: tmpDest.BasisLabel,
				TargetItemLabel: this.formatSetLabel(tmpAlignment.ItemIDTestSpecificationSet, tmpNames),
				HasContractUpdate: !!tmpContract,
				NoContract: (tmpAlignment.Crossing === true) && !pSpecSets.Dest.Contract,
				ContractLabel: tmpContract ? `${tmpContract.Name || 'Contract'} [${tmpContract.IDContract}]` : '',
				ContractItemBefore: tmpContract ? this.formatSetLabel(tmpContract.Before.ItemIDTestSpecificationSet, tmpNames) : '',
				ContractItemAfter: tmpContract ? this.formatSetLabel(tmpContract.After.ItemIDTestSpecificationSet, tmpNames) : '',
				ContractMaterialBefore: tmpContract ? this.formatSetLabel(tmpContract.Before.MaterialIDTestSpecificationSet, tmpNames) : '',
				ContractMaterialAfter: tmpContract ? this.formatSetLabel(tmpContract.After.MaterialIDTestSpecificationSet, tmpNames) : '',
				ContractShared: tmpShared.length > 0,
				SharedProjectCount: tmpShared.length,
				SharedProjects: tmpShared.map((pProject) => ({ Value: `${pProject.Name || '(unnamed)'} [${pProject.IDProject}]` })),
				RemapCount: tmpAlignment.LineItemRemaps.length,
				Remaps: tmpAlignment.LineItemRemaps.map((pRemap) => (
					{
						ItemCode: pRemap.ItemCode,
						Name: pRemap.Name,
						From: this.formatSetLabel(pRemap.FromIDTestSpecificationSet, tmpNames),
						To: this.formatSetLabel(tmpAlignment.ItemIDTestSpecificationSet, tmpNames),
					})),
				HasUnmapped: tmpAlignment.Unmapped.length > 0,
				UnmappedCount: tmpAlignment.Unmapped.length,
				Unmapped: tmpAlignment.Unmapped,
			});
	}

	async buildComprehension()
	{
		let tmpSourceID = parseInt($('#SamplePlanCopy-SourceProject').val(), 10);
		let tmpDestID = parseInt($('#SamplePlanCopy-DestProject').val(), 10);

		if (isNaN(tmpSourceID) || isNaN(tmpDestID))
		{
			this.pict.views.HeadlightPanels.toast({ message: 'Please select both a source and destination project.', type: 'is-warning' });
			return;
		}

		if (tmpSourceID === tmpDestID)
		{
			this.pict.views.HeadlightPanels.toast({ message: 'Source and destination projects must be different.', type: 'is-warning' });
			return;
		}

		this.saveSelections();
		this.isProcessing = true;
		this.comprehensionResult = null;
		this.loadResult = null;
		this.specSetView = null;
		this.statusMessage = 'Preparing the preview... This may take a moment for large projects.';
		await this.rerender();

		try
		{
			let tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
			this.comprehensionResult = await new Promise((resolve, reject) =>
			{
				tmpService.buildComprehension(tmpSourceID, tmpDestID, { FlipTargetSpecificationSet: this.flipTargetSpecificationSet },
					(pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						else
						{
							resolve(pResult);
						}
					});
			});

			// Ensure warnings are plain strings for template rendering
			if (this.comprehensionResult && this.comprehensionResult.warnings)
			{
				this.comprehensionResult.warnings = this.comprehensionResult.warnings.map(
					(pWarning) => (typeof pWarning === 'string') ? { Value: pWarning } : pWarning
				);
			}

			this.specSetView = this.prepareSpecificationSetView(this.comprehensionResult.reportData.specificationSets);

			this.statusMessage = '';
			this.pict.views.HeadlightPanels.toast({ message: 'Preview ready.', type: 'is-success' });
		}
		catch (pError)
		{
			this.log.error('Error building comprehension', pError);
			this.statusMessage = `Error: ${pError.message || pError}`;
			this.pict.views.HeadlightPanels.toast({ message: 'Could not prepare the preview. Check the console for details.', type: 'is-danger' });
		}

		this.isProcessing = false;
		await this.rerender();
	}

	exportComprehension()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		let tmpJSON = JSON.stringify(this.comprehensionResult.comprehension, null, 2);
		let tmpBlob = new Blob([tmpJSON], { type: 'application/json' });
		let tmpURL = URL.createObjectURL(tmpBlob);

		let tmpSourceName = this.comprehensionResult.reportData.sourceProject.Name || this.comprehensionResult.reportData.sourceProject.IDProject;
		let tmpDestName = this.comprehensionResult.reportData.destProject.Name || this.comprehensionResult.reportData.destProject.IDProject;

		let tmpLink = document.createElement('a');
		tmpLink.href = tmpURL;
		tmpLink.download = `Comprehension-MaterialsSamplePlan_From_${tmpSourceName}_To_${tmpDestName}.json`;
		document.body.appendChild(tmpLink);
		tmpLink.click();
		document.body.removeChild(tmpLink);
		URL.revokeObjectURL(tmpURL);
	}

	confirmLoadToDestination()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		let tmpStats = this.comprehensionResult.reportData.stats;
		let tmpDestName = this.comprehensionResult.reportData.destProject.Name || this.comprehensionResult.reportData.destProject.IDProject;
		let tmpSpecSetView = this.specSetView;
		let tmpSharedContract = !!(tmpSpecSetView && tmpSpecSetView.ContractShared);

		let fRenderRows = (pRows) => pRows.map((pRow) => /*html*/`
						<tr>
							<td>${pRow.Label}</td>
							<td class="has-text-right"><strong>${pRow.Count}</strong></td>
						</tr>`)
			.join('');
		let tmpChangeRows = fRenderRows([
			{ Label: ENTITY_LABELS.Contract, Count: tmpStats.contractUpdateCount || 0 },
			{ Label: ENTITY_LABELS.LineItem, Count: tmpStats.lineItemRemapCount || 0 },
			{ Label: ENTITY_LABELS.ProjectLineItemMaterialTest, Count: tmpStats.plimtCount },
			{ Label: ENTITY_LABELS.MaterialLineItemJoin, Count: tmpStats.mljCount },
		].filter((pRow, pIndex) => (pIndex > 1) || (pRow.Count > 0)));
		let tmpUnchangedRows = fRenderRows([
			{ Label: 'Sample plan tests in the source', Count: tmpStats.sourcePlimtCount || 0 },
			{ Label: 'Source tests not copied (item code not on the destination)', Count: tmpStats.unmappedSourcePlimtCount || 0 },
			{ Label: 'Repeated source tests, copied once', Count: tmpStats.collapsedPlimtCount || 0 },
			{ Label: 'Sample plan tests already on the destination (kept)', Count: tmpStats.destExistingPlimtCount || 0 },
			{ Label: 'Line item materials already on the destination (kept)', Count: tmpStats.destExistingMljCount || 0 },
		]);

		let tmpSpecSetNotices = '';
		if (tmpSpecSetView && tmpSpecSetView.ShowKept)
		{
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-info is-soft mb-3">
					<strong>The destination keeps its specification sets.</strong> Its contract and line item pay items are not changed; sample plan tests are copied onto its line items by item code.
				</div>`;
		}
		if (tmpSpecSetView && tmpSpecSetView.ShowChanges)
		{
			let tmpContractChange = '';
			if (tmpSpecSetView.HasContractUpdate)
			{
				tmpContractChange = ` Contract ${tmpSpecSetView.ContractLabel} moves to <strong>${tmpSpecSetView.ContractItemAfter}</strong> (item) and <strong>${tmpSpecSetView.ContractMaterialAfter}</strong> (material).`;
			}
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-warning is-soft mb-3">
					<strong>This copy crosses specification sets.</strong> The destination's line items move onto <strong>${tmpSpecSetView.TargetItemLabel}</strong> pay items.${tmpContractChange}
				</div>`;
		}
		if (tmpSharedContract)
		{
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-danger is-soft mb-3">
					<p><strong>Shared contract.</strong> ${tmpSpecSetView.ContractLabel} is also used by ${tmpSpecSetView.SharedProjectCount} other project(s). Their specification sets change too, while their line items stay on their current pay items:</p>
					<ul>${tmpSpecSetView.SharedProjects.map((pProject) => `<li>${pProject.Value}</li>`).join('')}</ul>
				</div>`;
		}

		this.fable.HeadlightModal.spawnModal({
			title: 'Confirm Sample Plan Copy',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5 has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-warning"></i>
					</span>
					<span> Copy the sample plan to the destination?</span>
				</p>
				${tmpSpecSetNotices}
				<p class="is-6 has-text-centered mb-3">This will add or update the following in <strong>${tmpDestName}</strong>:</p>
				<table class="table is-fullwidth is-narrow mx-auto" style="max-width:400px;">
					<tbody>${tmpChangeRows}
					</tbody>
				</table>
				<p class="is-6 has-text-centered mb-3">The copy does not remove anything:</p>
				<table class="table is-fullwidth is-narrow mx-auto" style="max-width:520px;">
					<tbody>${tmpUnchangedRows}
					</tbody>
				</table>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-soft" type="button" title="Cancel" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button ${tmpSharedContract ? 'is-danger' : 'is-success'}" type="button" title="Copy to Destination" onclick="_Pict.views.LIMSSamplePlanCopy.loadToDestination()">
					<span class="icon">
						<i class="fas fa-fw fa-upload" aria-hidden="true"></i>
					</span>
					<span>Copy to Destination</span>
				</button>
			</div>`,
			confirmText: 'Copy to Destination',
			cancelText: 'Cancel',
		});
	}

	async loadToDestination()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		this.fable.HeadlightModal.dismissModals();

		this.saveSelections();
		this.isProcessing = true;
		this.loadResult = null;
		this.statusMessage = 'Copying the sample plan to the destination project...';
		await this.rerender();

		try
		{
			let tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
			this.loadResult = await new Promise((resolve, reject) =>
			{
				tmpService.loadComprehension(this.comprehensionResult.comprehension,
					(pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						else
						{
							resolve(pResult);
						}
					});
			});

			this.loadResult.entities = this.loadResult.entities.map((pEntity) => Object.assign({}, pEntity,
				{
					Label: ENTITY_LABELS[pEntity.Entity] || pEntity.Entity,
					StatusLabel: LOAD_STATUS_LABELS[pEntity.Status] || pEntity.Status,
				}));

			this.statusMessage = '';
			if (this.loadResult.entities.some((pEntity) => pEntity.Failed > 0))
			{
				this.pict.views.HeadlightPanels.toast({ message: 'Sample plan copied, but some changes failed. See Copy Results.', type: 'is-warning' });
			}
			else
			{
				this.pict.views.HeadlightPanels.toast({ message: 'Sample plan copied.', type: 'is-success' });
			}
		}
		catch (pError)
		{
			this.log.error('Error loading comprehension', pError);
			this.statusMessage = `Error: ${pError.message || pError}`;
			this.pict.views.HeadlightPanels.toast({ message: 'Could not copy the sample plan. Check the console for details.', type: 'is-danger' });
		}

		this.isProcessing = false;
		await this.rerender();
	}

	/**
	 * Re-render the view, preserving select2 selections.
	 */
	async rerender()
	{
		return await new Promise((resolve) =>
		{
			this.renderAsync(() =>
			{
				resolve();
			});
		});
	}
}

module.exports = LIMSSamplePlanCopy;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'LIMSSamplePlanCopy',
		DefaultRenderable: 'LIMSSamplePlanCopy',
		DefaultDestinationAddress: '#LIMS-Application-Container',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'LIMSSamplePlanCopy-Wrapper',
				Template: /*html*/`
				<section id="LIMSSamplePlanCopy" class="form p-5">
					<h2 class="title is-4 mb-3">Copy Sample Plan</h2>
					<div class="content">
						<div class="box">
							<div class="columns">
								<div class="column">
									<div class="field">
										<label class="label">Source Project (Master Sample Plan)</label>
										<div class="control" id="SamplePlanCopy-SourceProjectParent">
											<select id="SamplePlanCopy-SourceProject" style="width:100%">
											</select>
										</div>
										<p class="help">The project containing the sample plan to copy from.</p>
										{~TIfAbs:LIMSSamplePlanCopy-ProjectSets:Context[0].sourceSets:Context[0].sourceSets^!=^null~}
									</div>
								</div>
								<div class="column">
									<div class="field">
										<label class="label">Destination Project</label>
										<div class="control" id="SamplePlanCopy-DestProjectParent">
											<select id="SamplePlanCopy-DestProject" style="width:100%">
											</select>
										</div>
										<p class="help">The project to copy the sample plan into.</p>
										{~TIfAbs:LIMSSamplePlanCopy-ProjectSets:Context[0].destSets:Context[0].destSets^!=^null~}
									</div>
								</div>
							</div>
							<div class="field">
								<label class="checkbox">
									<input
										type="checkbox"
										id="SamplePlanCopy-FlipTargetSpecificationSet"
										onchange="_Pict.views.LIMSSamplePlanCopy.setFlipTargetSpecificationSet(this.checked)"
										{~TIfAbs:LIMSSamplePlanCopy-Checked:Record:Context[0].flipTargetSpecificationSet^TRUE^x~}
										{~TIfAbs:LIMSSamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
									/>
									Also move the destination onto the source's specification sets
								</label>
								<p class="help">Changes the destination contract's specification sets and switches its line items to the source set's pay items. Leave this off to keep the destination on its current specification sets; sample plan tests are copied by item code either way.</p>
							</div>
							<div class="field">
								<div class="control">
									<button
										type="button"
										class="button is-info"
										onclick="_Pict.views.LIMSSamplePlanCopy.buildComprehension()"
										{~TIfAbs:LIMSSamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
									>
										<span class="icon mr-2">
											<i class="fas fa-fw fa-copy"></i>
										</span>
										Preview Copy
									</button>
								</div>
							</div>
						</div>
						{~TIfAbs:LIMSSamplePlanCopy-SetMismatch:Record:Context[0].projectSetsDiffer^TRUE^x~}
						{~T:LIMSSamplePlanCopy-Status:Record~}
						{~T:LIMSSamplePlanCopy-Results:Record~}
						{~T:LIMSSamplePlanCopy-LoadResults:Record~}
					</div>
				</section>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-Disabled',
				Template: 'disabled',
			},
			{
				Hash: 'LIMSSamplePlanCopy-Checked',
				Template: 'checked',
			},
			{
				Hash: 'LIMSSamplePlanCopy-Status',
				Template: /*html*/`
					{~TIfAbs:LIMSSamplePlanCopy-StatusMessage:Record:Context[0].statusMessage.length^>^0~}
				`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-StatusMessage',
				Template: /*html*/`
				<div class="notification is-info is-soft">
					<span class="icon mr-2">
						<i class="fas fa-spinner fa-spin"></i>
					</span>
					{~D:Context[0].statusMessage~}
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-Results',
				Template: /*html*/`
					{~TIfAbs:LIMSSamplePlanCopy-ResultsContent:Record:Context[0].comprehensionResult^!=^null~}
				`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-ResultsContent',
				Template: /*html*/`
				<div class="box">
					<h3 class="title is-5 mb-3">Copy Preview</h3>
					{~TIfAbs:LIMSSamplePlanCopy-Warnings:Record:Context[0].comprehensionResult.warnings.length^>^0~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSets:Record:Context[0].specSetView^!=^null~}
					<div class="columns">
						<div class="column">
							<table class="table is-fullwidth is-striped">
								<thead>
									<tr>
										<th>Metric</th>
										<th class="has-text-right">Count</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Source Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.sourceLineItemCount~}</td>
									</tr>
									<tr>
										<td>Destination Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.destLineItemCount~}</td>
									</tr>
									<tr>
										<td>Matched Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.matched~}</td>
									</tr>
									<tr>
										<td>Unmatched Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.unmatched~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests to Copy</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.plimtCount~}</td>
									</tr>
									<tr>
										<td>Line Item Materials to Copy</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.mljCount~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests in the Source</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.sourcePlimtCount~}</td>
									</tr>
									<tr>
										<td>Source Tests Not Copied (item code not on the destination)</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.unmappedSourcePlimtCount~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests Already on the Destination (kept)</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.destExistingPlimtCount~}</td>
									</tr>
									{~TIfAbs:LIMSSamplePlanCopy-RealignmentStatRows:Record:Context[0].specSetView.ShowChanges^TRUE^x~}
								</tbody>
							</table>
						</div>
						<div class="column">
							<div class="field mb-2">
								<strong>Source Project:</strong> {~D:Context[0].comprehensionResult.reportData.sourceProject.Name~}
								<span class="tag ml-2">ID: {~D:Context[0].comprehensionResult.reportData.sourceProject.IDProject~}</span>
							</div>
							<div class="field mb-4">
								<strong>Destination Project:</strong> {~D:Context[0].comprehensionResult.reportData.destProject.Name~}
								<span class="tag ml-2">ID: {~D:Context[0].comprehensionResult.reportData.destProject.IDProject~}</span>
							</div>
							<div class="field mb-2">
								<em>Generated: {~D:Context[0].comprehensionResult.reportData.generatedDate~}</em>
							</div>
						</div>
					</div>
					<div class="buttons">
						<button
							type="button"
							class="button is-link"
							onclick="_Pict.views.LIMSSamplePlanCopy.exportComprehension()"
						>
							<span class="icon mr-2">
								<i class="fas fa-fw fa-download"></i>
							</span>
							Download Preview (JSON)
						</button>
						<button
							type="button"
							class="button is-success"
							onclick="_Pict.views.LIMSSamplePlanCopy.confirmLoadToDestination()"
							{~TIfAbs:LIMSSamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
						>
							<span class="icon mr-2">
								<i class="fas fa-fw fa-upload"></i>
							</span>
							Copy to Destination
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-Warnings',
				Template: /*html*/`
				<div class="notification is-warning is-soft mb-3">
					<strong>Warnings:</strong>
					<ul>
						{~TS:LIMSSamplePlanCopy-WarningItem:Context[0].comprehensionResult.warnings~}
					</ul>
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-WarningItem',
				Template: /*html*/`<li>{~D:Record.Value~}</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-LoadResults',
				Template: /*html*/`
					{~TIfAbs:LIMSSamplePlanCopy-LoadResultsContent:Record:Context[0].loadResult^!=^null~}
				`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-LoadResultsContent',
				Template: /*html*/`
				<div class="box">
					<h3 class="title is-5 mb-3">Copy Results</h3>
					<table class="table is-fullwidth is-striped">
						<thead>
							<tr>
								<th>Change</th>
								<th class="has-text-right">Records</th>
								<th class="has-text-right">Saved</th>
								<th class="has-text-right">Failed</th>
								<th>Status</th>
							</tr>
						</thead>
						<tbody>
							{~TS:LIMSSamplePlanCopy-LoadResultRow:Context[0].loadResult.entities~}
						</tbody>
					</table>
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-LoadResultRow',
				Template: /*html*/`
							<tr>
								<td>{~D:Record.Label~}</td>
								<td class="has-text-right">{~D:Record.Sent~}</td>
								<td class="has-text-right">{~D:Record.Succeeded~}</td>
								<td class="has-text-right">{~D:Record.Failed~}</td>
								<td>{~D:Record.StatusLabel~}</td>
							</tr>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-ProjectSets',
				Template: /*html*/`
					<div class="tags mt-2 mb-0">
						<span class="tag is-info">Item set: {~D:Record.ItemLabel~}</span>
						<span class="tag">Material set: {~D:Record.MaterialLabel~}</span>
					</div>
					<p class="help mt-0">Based on: {~D:Record.BasisLabel~}</p>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SetMismatch',
				Template: /*html*/`
					<div class="notification is-warning is-soft">
						<span class="icon mr-2">
							<i class="fas fa-fw fa-exclamation-triangle"></i>
						</span>
						<strong>These projects use different specification sets.</strong>
						Source: {~D:Context[0].sourceSets.ItemLabel~} (item), {~D:Context[0].sourceSets.MaterialLabel~} (material).
						Destination: {~D:Context[0].destSets.ItemLabel~} (item), {~D:Context[0].destSets.MaterialLabel~} (material).
						{~D:Context[0].setMismatchOutcome~}
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSets',
				Template: /*html*/`
					<table class="table is-fullwidth is-narrow mb-3">
						<thead>
							<tr>
								<th>Specification Sets</th>
								<th>Item</th>
								<th>Material</th>
								<th>Based On</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Source</td>
								<td>{~D:Context[0].specSetView.SourceItemLabel~}</td>
								<td>{~D:Context[0].specSetView.SourceMaterialLabel~}</td>
								<td>{~D:Context[0].specSetView.SourceBasisLabel~}</td>
							</tr>
							<tr>
								<td>Destination</td>
								<td>{~D:Context[0].specSetView.DestItemLabel~}</td>
								<td>{~D:Context[0].specSetView.DestMaterialLabel~}</td>
								<td>{~D:Context[0].specSetView.DestBasisLabel~}</td>
							</tr>
						</tbody>
					</table>
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetCrossing:Record:Context[0].specSetView.ShowChanges^TRUE^x~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetKept:Record:Context[0].specSetView.ShowKept^TRUE^x~}`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetKept',
				Template: /*html*/`
					<div class="notification is-info is-soft mb-3">
						<strong>The destination keeps its specification sets.</strong> Its contract and line item pay items are not changed; sample plan tests are copied onto its line items by item code.
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetCrossing',
				Template: /*html*/`
					<div class="notification is-warning is-soft mb-3">
						<p class="mb-2"><strong>This copy crosses specification sets.</strong> Copying also updates the destination to match the source:</p>
						<ul>
							{~TIfAbs:LIMSSamplePlanCopy-SpecSetContractChange:Record:Context[0].specSetView.HasContractUpdate^TRUE^x~}
							{~TIfAbs:LIMSSamplePlanCopy-SpecSetNoContract:Record:Context[0].specSetView.NoContract^TRUE^x~}
							{~TIfAbs:LIMSSamplePlanCopy-SpecSetLineItemChange:Record:Context[0].specSetView.RemapCount^>^0~}
						</ul>
					</div>
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetShared:Record:Context[0].specSetView.ContractShared^TRUE^x~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetUnmapped:Record:Context[0].specSetView.HasUnmapped^TRUE^x~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetRemaps:Record:Context[0].specSetView.RemapCount^>^0~}`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetContractChange',
				Template: /*html*/`
							<li>
								<strong>Contract</strong> {~D:Context[0].specSetView.ContractLabel~}:
								item set {~D:Context[0].specSetView.ContractItemBefore~} &rarr; {~D:Context[0].specSetView.ContractItemAfter~},
								material set {~D:Context[0].specSetView.ContractMaterialBefore~} &rarr; {~D:Context[0].specSetView.ContractMaterialAfter~}
							</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetNoContract',
				Template: /*html*/`<li><strong>Contract</strong>: the destination has no contract, so only its line items change.</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetLineItemChange',
				Template: /*html*/`<li><strong>Line items</strong>: {~D:Context[0].specSetView.RemapCount~} line item(s) switch to the pay item with the same item code in {~D:Context[0].specSetView.TargetItemLabel~}.</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetShared',
				Template: /*html*/`
					<div class="notification is-danger is-soft mb-3">
						<strong>Shared contract.</strong> {~D:Context[0].specSetView.ContractLabel~} is also used by {~D:Context[0].specSetView.SharedProjectCount~} other project(s). Their specification sets change too, while their line items stay on their current pay items:
						<ul>
							{~TS:LIMSSamplePlanCopy-WarningItem:Context[0].specSetView.SharedProjects~}
						</ul>
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetUnmapped',
				Template: /*html*/`
					<div class="notification is-warning is-soft mb-3">
						<strong>{~D:Context[0].specSetView.UnmappedCount~} line item(s) keep their current pay item</strong> because {~D:Context[0].specSetView.TargetItemLabel~} has no single pay item with the same item code:
						<ul>
							{~TS:LIMSSamplePlanCopy-UnmappedItem:Context[0].specSetView.Unmapped~}
						</ul>
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-UnmappedItem',
				Template: /*html*/`<li>{~D:Record.ItemCode~} {~D:Record.Name~}: {~D:Record.Reason~}</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetRemaps',
				Template: /*html*/`
					<details class="mb-3">
						<summary>Line item pay item changes ({~D:Context[0].specSetView.RemapCount~})</summary>
						<div style="max-height:320px; overflow-y:auto;">
							<table class="table is-fullwidth is-narrow is-striped">
								<thead>
									<tr>
										<th>Item Code</th>
										<th>Line Item</th>
										<th>Current Pay Item Set</th>
										<th>New Pay Item Set</th>
									</tr>
								</thead>
								<tbody>
									{~TS:LIMSSamplePlanCopy-RemapRow:Context[0].specSetView.Remaps~}
								</tbody>
							</table>
						</div>
					</details>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-RemapRow',
				Template: /*html*/`
									<tr>
										<td>{~D:Record.ItemCode~}</td>
										<td>{~D:Record.Name~}</td>
										<td>{~D:Record.From~}</td>
										<td>{~D:Record.To~}</td>
									</tr>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-RealignmentStatRows',
				Template: /*html*/`
									<tr>
										<td>Contract Specification Set Changes</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.contractUpdateCount~}</td>
									</tr>
									<tr>
										<td>Line Item Pay Item Changes</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.lineItemRemapCount~}</td>
									</tr>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'LIMSSamplePlanCopy',
				TemplateHash: 'LIMSSamplePlanCopy-Wrapper',
				RenderMethod: 'replace',
			},
		],
	});

},{"pict-view":818}],838:[function(require,module,exports){
module.exports={
	"Form": "DocumentCreateManifest",
	"Descriptors": {
	},
	"Sections": [
		{
			"Name": "Document Create",
			"Hash": "DocumentCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Document Create",
					"Hash": "DocumentCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
},{}],839:[function(require,module,exports){
module.exports={
	"Form": "DocumentEditManifest",
	"Descriptors": {
		"DocumentDetails.Name": {
			"Name": "Name",
			"Hash": "EditDocumentName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentEdit",
				"Group": "DocumentEdit"
			}
		},
		"DocumentDetails.DocumentDate": {
			"Name": "Document Date",
			"Hash": "EditDocumentDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentEdit",
				"Group": "DocumentEdit"
			}
		}
	},
	"Sections": [
		{
			"Name": "Document Edit",
			"Hash": "DocumentEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Document Edit",
					"Hash": "DocumentEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],840:[function(require,module,exports){
module.exports={
	"Scope": "Document-List",
	"CoreEntity": "Document",
	"TitleTemplate": "Documents",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "Name",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Status",
			"Hash": "Status",
			"PictDashboard": {}
		},
		"CreatingIDUser":
		{
			"Name": "Created By",
			"Hash": "CreatingIDUser",
			"PictDashboard": {}
		},
		"DocumentDate":
		{
			"Name": "Date",
			"Hash": "DocumentDate",
			"PictDashboard": {
				"ValueTemplate": "{~DateFormatNoFallback:Record.Payload.DocumentDate^MM/DD/YYYY~}"
			}
		},
		"DocumentType":
		{
			"Name": "Type",
			"Hash": "DocumentType",
			"PictDashboard": {
				"ValueTemplate": "{~DocumentTypeName:Record.Payload.DocumentType~}"
			}
		},
		"IDProject":
		{
			"Name": "Project",
			"Hash": "IDProject",
			"PictDashboard": {}
		}
	}
}

},{}],841:[function(require,module,exports){
module.exports={
	"Form": "DocumentViewManifest",
	"Descriptors": {
		"DocumentDetails.Name": {
			"Name": "Name",
			"Hash": "ViewDocumentName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentView",
				"Group": "DocumentView"
			}
		},
		"DocumentType": {
			"Name": "Type",
			"Hash": "ViewDocumentDocumentType",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentView",
				"Group": "DocumentView",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.TempRNI.Name~}",

					"EmptyValueTestList": ["AppData.TempRNI"],
					"EmptyValueTemplate": "N/A",

					"EntitiesBundle": [
						{
							"Entity": "ReportNamedInstance",
							"Filter": "FBV~IDCustomer~EQ~{~D:AppData.DocumentDetails.IDCustomer~}~FBV~Hash~EQ~{~D:AppData.DocumentDetails.DocumentType~}",
							"Destination": "AppData.TempRNI",
							"SingleRecord": true
						}]
				}
			}
		},
		"DocumentDetails.CreatingIDUser": {
			"Name": "Created By",
			"Hash": "ViewDocumentCreatingIDUser",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "DocumentView",
				"Group": "DocumentView",
				"Entity": "User"
			}
		},
		"DocumentDetails.DocumentDate": {
			"Name": "Document Date",
			"Hash": "ViewDocumentDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "2",
				"Section": "DocumentView",
				"Group": "DocumentView"
			}
		},
		"DocumentDetails.IDProject": {
			"Name": "Project",
			"Hash": "ViewDocumentIDProject",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"InputType": "Picker",
				"Section": "DocumentView",
				"Group": "DocumentView",
				"Entity": "Project"
			}
		},
		"DocumentDetails.StatusDisplay": {
			"Name": "Status",
			"Hash": "ViewDocumentStatus",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"Section": "DocumentView",
				"Group": "DocumentView"
			}
		}
	},
	"Sections": [
		{
			"Name": "Document View",
			"Hash": "DocumentView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Document View",
					"Hash": "DocumentView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],842:[function(require,module,exports){
module.exports={
	"Form": "LocationCreateManifest",
	"Descriptors": {
		"LocationDetails.Name": {
			"Name": "Name",
			"Hash": "CreateLocationName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationCreate",
				"Group": "LocationCreate"
			}
		},
		"LocationDetails.Description": {
			"Name": "Description",
			"Hash": "CreateLocationDescription",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "TextArea",
				"Section": "LocationCreate",
				"Group": "LocationCreate"
			}
		},
		"LocationDetails.QRCode": {
			"Name": "QR Code",
			"Hash": "CreateLocationQRCode",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationCreate",
				"Group": "LocationCreate"
			}
		},
		"LocationDetails.ParentIDLocation": {
			"Name": "Linked To",
			"Hash": "CreateLocationParentIDLocation",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "LocationCreate",
				"Group": "LocationCreate",
				"Entity": "Location"
			}
		}
	},
	"Sections": [
		{
			"Name": "Location Create",
			"Hash": "LocationCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Location Create",
					"Hash": "LocationCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],843:[function(require,module,exports){
module.exports={
	"Form": "LocationEditManifest",
	"Descriptors": {
		"LocationDetails.Name": {
			"Name": "Name",
			"Hash": "EditLocationName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationEdit",
				"Group": "LocationEdit"
			}
		},
		"LocationDetails.Description": {
			"Name": "Description",
			"Hash": "EditLocationDescription",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "TextArea",
				"Section": "LocationEdit",
				"Group": "LocationEdit"
			}
		},
		"LocationDetails.QRCode": {
			"Name": "QR Code",
			"Hash": "EditLocationQRCode",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationEdit",
				"Group": "LocationEdit"
			}
		},
		"LocationDetails.ParentIDLocation": {
			"Name": "Linked To",
			"Hash": "EditLocationParentIDLocation",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "LocationEdit",
				"Group": "LocationEdit",
				"Entity": "Location"
			}
		}
	},
	"Sections": [
		{
			"Name": "Location Edit",
			"Hash": "LocationEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Location Edit",
					"Hash": "LocationEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],844:[function(require,module,exports){
module.exports={
	"Scope": "Location-List",
	"CoreEntity": "Location",
	"TitleTemplate": "Locations",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "Name",
			"PictDashboard": {}
		}
	}
}
},{}],845:[function(require,module,exports){
module.exports={
	"Form": "LocationViewManifest",
	"Descriptors": {
		"LocationDetails.Name": {
			"Name": "Name",
			"Hash": "ViewLocationName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationView",
				"Group": "LocationView"
			}
		},
		"LocationDetails.Description": {
			"Name": "Description",
			"Hash": "ViewLocationDescription",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"Section": "LocationView",
				"Group": "LocationView"
			}
		},
		"LocationDetails.QRCode": {
			"Name": "QR Code",
			"Hash": "ViewLocationQRCode",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationView",
				"Group": "LocationView"
			}
		},
		"LocationDetails.ParentIDLocation": {
			"Name": "Linked To",
			"Hash": "ViewLocationParentIDLocation",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "LocationView",
				"Group": "LocationView",
				"Entity": "Location"
			}
		}
	},
	"Sections": [
		{
			"Name": "Location View",
			"Hash": "LocationView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Location View",
					"Hash": "LocationView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],846:[function(require,module,exports){
module.exports={}
},{}],847:[function(require,module,exports){
module.exports={
	"Form": "SampleCreateManifest",
	"InitialBundle":
	[
		{
			"Type": "Custom",
			"Protocol": "HTTPS",
			"URL": "Sample/Sequence",
			"Destination": "AppData.SampleSequence"
		}
	],
	"PickLists": [
		{
			"Hash": "CreateStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleSequence.Next": {
			"Name": "Sample Number",
			"Hash": "CreateSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "CreateDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "CreateReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "CreateSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "CreateContainer",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateContainers"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "CreateContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "CreateSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "CreateSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateCities",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-AutofillTriggerGroup"
				],
				"AutofillTriggerGroup": {
					"TriggerGroupHash": "SourceLocation",
					"SelectOptionsRefresh": true
				}
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "CreateSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"AllowCustomValues": true,
				"SelectOptionsPickList": "CreateStates",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-EntityBundleRequest",
					"Pict-Input-AutofillTriggerGroup"
				],
				"EntitiesBundle": [
					{
						"Entity": "ListDefault",
						"Filter": "FBV~Hash~EQ~{~D:Record.Value~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State",
						"Destination": "AppData.CurrentState",
						"SingleRecord": true
					},
					{
						"Entity": "ListDefaultListDefaultJoin",
						"Filter": "FBV~ScopeIDListDefault~EQ~{~D:AppData.CurrentState.IDListDefault~}",
						"Destination": "AppData.StateCityJoins"
					},
					{
						"Entity": "ListDefault",
						"Filter": "FBL~IDListDefault~INN~{~PJU:,^IDListDefault^AppData.StateCityJoins~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~City",
						"Destination": "AppData.SourceCities"
					}
				],
				"EntityBundleTriggerGroup": "SourceLocation"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "CreateSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateCountries",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "CreateLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "CreateStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "CreateMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "CreateNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample Create",
			"Hash": "SampleCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample Create",
					"Hash": "SampleCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],848:[function(require,module,exports){
module.exports={
	"Form": "SampleEditManifest",
	"PickLists": [
		{
			"Hash": "EditStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleDetails.LabControlNumber": {
			"Name": "Sample Number",
			"Hash": "EditSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "EditDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "EditReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "EditSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "EditContainer",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditContainers"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "EditContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "EditSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "EditSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditCities",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-AutofillTriggerGroup"
				],
				"AutofillTriggerGroup": {
					"TriggerGroupHash": "SourceLocation",
					"SelectOptionsRefresh": true
				}
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "EditSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditStates",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-EntityBundleRequest",
					"Pict-Input-AutofillTriggerGroup"
				],
				"EntitiesBundle": [
					{
						"Entity": "ListDefault",
						"Filter": "FBV~Hash~EQ~{~D:Record.Value~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State",
						"Destination": "AppData.CurrentState",
						"SingleRecord": true
					},
					{
						"Entity": "ListDefaultListDefaultJoin",
						"Filter": "FBV~ScopeIDListDefault~EQ~{~D:AppData.CurrentState.IDListDefault~}",
						"Destination": "AppData.StateCityJoins"
					},
					{
						"Entity": "ListDefault",
						"Filter": "FBL~IDListDefault~INN~{~PJU:,^IDListDefault^AppData.StateCityJoins~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~City",
						"Destination": "AppData.SourceCities"
					}
				],
				"EntityBundleTriggerGroup": "SourceLocation"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "EditSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditCountries",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "EditLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "EditStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "EditMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "EditNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample Edit",
			"Hash": "SampleEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample Edit",
					"Hash": "SampleEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],849:[function(require,module,exports){
module.exports={
	"Scope": "Sample-List",
	"CoreEntity": "Sample",
	"TitleTemplate": "Samples",
	"Descriptors":
	{
		"LabControlNumber":
		{
			"Name": "PSID",
			"Hash": "PSID",
			"PictDashboard": {}
		},
		"Name":
		{
			"Name": "Name",
			"Hash": "Name",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Sample Status",
			"Hash": "Status",
			"DefaultHidden": true,
			"PictDashboard":
			{
				"ValueTemplate": "{~SampleStatusName:Record.Payload.Status~}"
			}
		},
		"ReceivedFrom":
		{
			"Name": "Source",
			"Hash": "Source",
			"PictDashboard": {}
		},
		"IDMaterial":
		{
			"Name": "Material",
			"Hash": "Material",
			"PictDashboard": {}
		},
		"SourceLocation":
		{
			"Name": "Source Location",
			"Hash": "SourceLocation",
			"PictDashboard":
			{
				"ValueTemplate": "{~ParseSourceLocation:Record.Payload~}"
			}
		},
		"Extension.StorageLocation":
		{
			"Name": "Storage Location",
			"Hash": "StorageLocation",
			"PictDashboard": 
			{
				"ValueTemplate": "{~E:Location^Record.Payload.Extension.StorageLocation^Datum-Value-Name~}"
			}
		},
		"Extension.ReceivedDate":
		{
			"Name": "Received On",
			"Hash": "ReceivedOn",
			"PictDashboard":
			{
				"ValueTemplate": "{~DateFormatNoFallback:Record.Payload.Extension.ReceivedDate^MM/DD/YYYY~}"
			}
		},
		"CreatingIDUser":
		{
			"Name": "Logged By",
			"Hash": "LoggedBy",
			"PictDashboard": {}
		}
	}
}

},{}],850:[function(require,module,exports){
module.exports={
	"Form": "SampleExtendedSchema",
	"PickLists": [
		{
			"Hash": "ViewStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleDetails.LabControlNumber": {
			"Name": "Sample Number",
			"Hash": "ViewSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "ViewDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "ViewReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "ViewSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "ViewContainer",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "ViewContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "ViewSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "ViewSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "ViewSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "ViewSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "ViewLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleView",
				"Group": "SampleView",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "ViewStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleView",
				"Group": "SampleView",
				"SelectOptionsPickList": "ViewLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "ViewMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "ViewNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "MarkdownDisplay",
				"Row": "6",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample View",
			"Hash": "SampleView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample View",
					"Hash": "SampleView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],851:[function(require,module,exports){
module.exports={
	"Test":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"Description":
			{
				"Hash": "Description",
				"Name": "Description"
			},
			"Hash":
			{
				"Hash": "Hash",
				"Name": "Hash"
			}
		}
	},
	"Document":
	{
		"Descriptors":
		{
			"DocumentDate_Formatted":
			{
				"Hash": "DocumentDate_Formatted",
				"Name": "Date",
				"DataType": "DateTime"
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Creator"
			},
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Project":
			{
				"Hash": "_Project",
				"Name": "Project"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"StateName":
			{
				"Hash": "StateName",
				"Name": "Status Info"
			}
		}
	},
	"Project":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"Description":
			{
				"Hash": "Description",
				"Name": "Description"
			},
			"_Contract":
			{
				"Hash": "_Contract",
				"Name": "Contract"
			},
			"_Organization":
			{
				"Hash": "_Organization",
				"Name": "Contractor"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"ContractedDays":
			{
				"Hash": "ContractedDays",
				"Name": "Contracted Days",
				"DataType": "PreciseNumber"
			},
			"InitialContractAmount_Formatted":
			{
				"Hash": "InitialContractAmount",
				"Name": "Initial Contract Amount",
				"DataType": "PreciseNumber"
			},
			"CurrentTotalContractAmount_Formatted":
			{
				"Hash": "CurrentTotalContractAmount",
				"Name": "Current Total Contract Amount",
				"DataType": "PreciseNumber"
			},
			"CurrentTotalContractPaid_Formatted":
			{
				"Hash": "CurrentTotalContractPaid",
				"Name": "Current Total Contract Paid",
				"DataType": "PreciseNumber"
			}
		}
	},
	"TestInstance":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Test":
			{
				"Hash": "_Test",
				"Name": "Test"
			},
			"_Lab":
			{
				"Hash": "Lab",
				"Name": "Lab"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"TestResult":
			{
				"Hash": "TestResult",
				"Name": "Test Result"
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Created By"
			}
		}
	},
	"LineItem": 
	{
		"Descriptors":
		{
			"ItemCode":
			{
				"Hash": "ItemCode",
				"Name": "Item Code"
			},
			"ItemNumber":
			{
				"Hash": "ItemNumber",
				"Name": "Item Number"
			},
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Project":
			{
				"Hash": "_Project",
				"Name": "Project"
			},
			"_Contract":
			{
				"Hash": "_Contract",
				"Name": "Contract"
			},
			"_BidItem":
			{
				"Hash": "_BidItem",
				"Name": "Bid Item"
			},
			"_PayItem":
			{
				"Hash": "_PayItem",
				"Name": "Pay Item"
			},
			"ContractQuantity_Formatted":
			{
				"Hash": "ContractQuantity_Formatted",
				"Name": "Contract Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ChangeOrderQuantity_Formatted":
			{
				"Hash": "ChangeOrderQuantity_Formatted",
				"Name": "Change Order Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ExpectedQuantity_Formatted":
			{
				"Hash": "ExpectedQuantity_Formatted",
				"Name": "Expected Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ActualQuantity_Formatted":
			{
				"Hash": "ActualQuantity_Formatted",
				"Name": "Actual Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"InstalledQuantity_Formatted":
			{
				"Hash": "InstalledQuantity_Formatted",
				"Name": "Installed Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"CreateDate_Formatted":
			{
				"Hash": "CreateDate_Formatted",
				"Name": "Created On",
				"DataType": "DateTime",
				"HeadlightSummary":
				{
					"DateFormat": "YYYY-MM-DD"
				}
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Created By",
				"HeadlightSummary":
				{
					"DisplayFields": ["NameFirst", "NameLast"]
				}
			}
		}
	}
}

},{}],852:[function(require,module,exports){
const markdown = `
##### *To use a barcode scanner in this application while using firefox, you need to disable the "/" shortcut key in the browser settings.*

#### Step 1

* Go to the *Advanced Prefences* menu in Firefox by opening a new tab and entering **about:config** in the address bar.

#### Step 2

* In the search bar, enter the following setting name: **accessibility.typeaheadfind.manual**

#### Step 3

* Toggle the setting to false with the button on the right.
* This should disable the "/" shortcut key and allow the scanner to work properly.
`;

const title = 'Disabling the "/" shortcut key in Firefox';
module.exports = 
{
    markdown,
    title
};
},{}],853:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
// @ts-ignore
const PictProvider = require('pict-provider');

class CommentProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	getParentCommentKey(pIDParent)
	{
		return `ParentKey~${pIDParent}`;
	}

	/**
	 * Get comments by customer ID
	 * @param {Number} pIDCustomer - The ID of the customer to get comments for
	 * @param {Number} pIDDocument - The ID of the document to get comments for
	 * @param {Array<Number>} pCommentIDs - The IDs of the comments to get
	 * @param {Function} fCallback - The callback function to call when the comments are fetched
	 * @async
	 */
	getCommentStructure(pIDCustomer, pIDDocument, pCommentIDs, fCallback)
	{
		this.pict.log.info(`I am getting all comments for ${pIDCustomer}`);

		// @ts-ignore
		const tmpAnticipate = this.pict.newAnticipate();

		const tmpCommentDataStructureState = {
			CommentIDs: [],
			Comments: [],
			ParentCommentMap: {},
			MergedComments: [],
			Users: [],
		};

		// Step 1: Fetch commentIDs for Document
		tmpAnticipate.anticipate(function(fNext)
		{
			// force the cache to expire for this document so it picks up the latest comments
			this.pict.EntityProvider?.recordSetCache?.['Document']?.expire(`FBV~IDDocument~EQ~${pIDDocument}`);
			// force the cache to expire for the comment id's so it picks up the latest comments
			this.pict.EntityProvider?.recordSetCache?.['Comment']?.expire(`FBL~IDComment~INN~${pCommentIDs.join(',')}`);
			// Get the comment IDs for the document
			this.pict.EntityProvider.getEntitySet(
				'Document',
				`FBV~IDDocument~EQ~${pIDDocument}`,
				function(pError, pRecordSet)
				{
					if (pError)
					{
						this.log.error(`Error downloading data for document ${pIDDocument}: ${pError}`, pError);
						return fCallback(pError);
					}
					// Check actual structure of pRecordSet
					const firstRecord = Array.isArray(pRecordSet) ? pRecordSet[0] : (pRecordSet.Entities ? pRecordSet.Entities[0] : pRecordSet);
					tmpCommentDataStructureState.CommentIDs = (firstRecord && firstRecord.Comments) ? firstRecord.Comments : [];

					fNext();
				}.bind(this),
			);
		}.bind(this));

		// Step 2: Get comment data for each comment by Document ID
		tmpAnticipate.anticipate(function(fNext)
		{
			if (tmpCommentDataStructureState.CommentIDs.length === 0)
			{
				this.pict.log.info('No comments found for the document.');
				return fNext([]);
			}

			const commentIDs = tmpCommentDataStructureState.CommentIDs.join(',');
			this.pict.EntityProvider.getEntitySet(
				'Comment',
				`FBL~IDComment~INN~${commentIDs}`,
				function(pError, pRecordSet)
				{
					if (pError)
					{
						this.pict.log.error(`Error downloading comments: ${pError}`, pError);
						return fCallback(pError);
					}

					tmpCommentDataStructureState.Comments = pRecordSet;
					fNext();
				}.bind(this),
			);
		}.bind(this));

		// Step 3: Fetch user data for customer
		tmpAnticipate.anticipate(function(fNext)
		{
			// fetch all the users that appear in the comments
			if (tmpCommentDataStructureState.Comments.length === 0)
			{
				this.pict.log.info('No comments found, skipping user fetch.');
				tmpCommentDataStructureState.Users = [];
				return fNext();
			}
			// Collect unique user IDs from comments (rather than fetching all users)
			const userIDs = tmpCommentDataStructureState.Comments.reduce((acc, comment) =>
			{
				if (comment.CreatingIDUser && !acc.includes(comment.CreatingIDUser))
				{
					acc.push(comment.CreatingIDUser);
				}
				if (comment.UpdatingIDUser && !acc.includes(comment.UpdatingIDUser))
				{
					acc.push(comment.UpdatingIDUser);
				}
				return acc;
			}, []);
			this.pict.EntityProvider.getEntitySet(
				'User',
				`FBL~IDUser~INN~${userIDs.join(',')}`,
				function(pError, pRecordSet)
				{
					if (pError)
					{
						this.log.error(`Error downloading users for customer ${pIDCustomer}: ${pError}`, pError);
						return fCallback(pError);
					}

					tmpCommentDataStructureState.Users = pRecordSet;
					fNext();
				}.bind(this),
			);
		}.bind(this));

		// Step 4: Transform and nest comments
		tmpAnticipate.anticipate(function(fNext)
		{
			const { Comments, ParentCommentMap, MergedComments } = tmpCommentDataStructureState;

			// Build map of comments by ID
			for (const raw of Comments)
			{
				// for each comment, we need to find the user who created it and the user who last updated it
				const creatingUser = tmpCommentDataStructureState.Users.find((user) => user.IDUser === raw.CreatingIDUser);
				const updatingUser = tmpCommentDataStructureState.Users.find((user) => user.IDUser === raw.UpdatingIDUser);
				if (creatingUser)
				{
					raw.CreatingUserData = creatingUser;
				}
				if (updatingUser)
				{
					raw.UpdatingUserData = updatingUser;
				}

				const structured = {
					IDComment: raw.IDComment,
					CreateDate: raw.CreateDate,
					CreatingIDUser: raw.CreatingIDUser,
					CreatingUserData: raw.CreatingUserData || null,
					UpdatingIDUser: raw.UpdatingIDUser,
					UpdatingUserData: raw.UpdatingUserData || null,
					Date: raw.UpdateDate,
					Entity: raw.Entity || '',
					IDParent: raw.IDParent || 0,
					IDEntity: raw.IDEntity || 0,
					Comment: raw.Comment,
					CommentHtml: raw.CommentHtml,
					Children: [],
					_RowID: `Comment_${raw.IDComment}`,
				};

				ParentCommentMap[structured.IDComment] = structured;
			}

			// Nest comments under their parents
			for (const id in ParentCommentMap)
			{
				if (Object.prototype.hasOwnProperty.call(ParentCommentMap, id))
				{
					const comment = ParentCommentMap[id];
					if (comment.IDParent && ParentCommentMap[comment.IDParent])
					{
						ParentCommentMap[comment.IDParent].Children.push(comment);
					}
					else
					{
						MergedComments.push(comment);
					}
				}
			}

			fNext(MergedComments);
		});

		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Get comments by entity
	 * @param {Number} pIDEntity - The ID of the entity to get comments for. Currently doesn't exist - created for future use.
	 * @param {Function} pCallback - The callback function to call when the comments are fetched
	 * @return {Promise}
	 * @async
	 */
	async getCommentsByEntity(pIDEntity, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// force the cache to expire for this entity so it picks up the latest comments
				this.pict.EntityProvider?.recordSetCache?.['Entity']?.expire(`FBV~IDEntity~EQ~${pIDEntity}`);
				// Get the comments for the entity
				this.fable.services.HeadlightRestClient.getJSON(`Comments/By/IDEntity/${pIDEntity}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching comments: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching comments: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get comments by customer ID
	 * @param {Number} pIDCustomer - The ID of the customer to get comments for
	 * @param {Function} pCallback - The callback function to call when the comments are fetched
	 * @return {Promise}
	 * @async
	 */
	async getCommentsByCustomer(pIDCustomer, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// force the cache to expire for this customer so it picks up the latest comments
				this.pict.EntityProvider?.recordSetCache?.['Customer']?.expire(`FBV~IDCustomer~EQ~${pIDCustomer}`);
				// Get the comments for the customer
				this.fable.services.HeadlightRestClient.getJSON(`Comments/By/IDCustomer/${pIDCustomer}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching comments: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching comments: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get comments by comment ID
	 * @param {Number} pIDComment - The ID of the customer to get comments for
	 * @param {Function} pCallback - The callback function to call when the comments are fetched
	 * @return {Promise}
	 * @async
	 */
	async getCommentByID(pIDComment, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// force the cache to expire for this comment so it picks up the latest changes on comment edit actions
				this.pict.EntityProvider?.recordSetCache?.['Comment']?.expire(`${pIDComment}`);
				// Get the comment by ID
				this.fable.services.HeadlightRestClient.getJSON(`Comment/${pIDComment}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching comment by ID: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching comment by ID: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Add a new comment to the server.
	 * @param {Object} pComment - The new comment to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async createComment(pComment, fOnSaveResult)
	{
		const tmpURL = `Comment/`;
		await new Promise((resolve, reject) => this.fable.services.HeadlightRestClient.postJSON(tmpURL, pComment,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating comment: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred creating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating comment: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error creating comment: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred creating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating comment: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
			},
		));
	}

	/**
	 * Post an update to a comment to the server.
	 * @param {Object} pIDComment - The updated IDComment to post
	 * @param {Function} fOnSaveResult - The callback function to call when the comment is posted
	 */
	async updateComment(pIDComment, fOnSaveResult)
	{
		const tmpURL = `Comment/`;
		// force the cache to expire for this comment so it picks up the latest changes on comment edit actions
		this.pict.EntityProvider?.recordSetCache?.['Comment']?.expire(`${pIDComment}`);
		// update the comment
		await new Promise((resolve, reject) => this.fable.services.HeadlightRestClient.putJSON(tmpURL, pIDComment,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating comment: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating comment: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
			},
		));
	}

	/**
	 * Post update to comments list attached to a document.
	 * @param {Object} pIDDocument - The updated IDDocument to post
	 * @param {Function} fOnSaveResult - The callback function to call when the comment is posted
	 */
	async updateCommentsAttachedToDocument(pIDDocument, fOnSaveResult)
	{
		const tmpURL = `Document/`;
		// force the cache to expire for this document so it picks up the latest comments
		this.pict.EntityProvider?.recordSetCache?.['Document']?.expire(`FBV~IDDocument~EQ~${pIDDocument.IDDocument}`);
		// update the document comments
		await new Promise((resolve, reject) => this.fable.services.HeadlightRestClient.putJSON(tmpURL, pIDDocument,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating comment record for document: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment record attached to this document.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment record for document: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating comment record for document: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment record attached to this document.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment record for document: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
			},
		));
	}

	/**
	 * Delete a comment.
	 * @param {number} pIDComment - The comment to delete
	 * @param {Function} fOnDeleteResult - The callback function to call when the project file is posted
	 */
	deleteComment(pIDComment, fOnDeleteResult)
	{
		if (!pIDComment)
		{
			this.pict.log.error('pIDComment was not passed.');
			return;
		}
		this.fable.HeadlightRestClient.deleteEntity('Comment', pIDComment, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete comment.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete comment!',
					type: 'is-danger',
				});
				fOnDeleteResult(pError);
			}
			else
			{
				this.pict.log.info('Comment deleted successfully.', pBody);
				if (typeof fOnDeleteResult === 'function')
				{
					fOnDeleteResult(pBody);
				}
			}
		});
	}
}

module.exports = CommentProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],854:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ComplexFilterProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.filterState = {};
		this.blacklistedFilters = [ 'DeleteDate', 'ExternalSyncDate', 'ExternalSyncGUID', 'UpdatingIDUser', 'UpdateDate' ];
		this.renderOverriden = false;
		// NOTE: endCapTemplate is kept as a public option but is no longer rendered — its only
		// consumer was the old PRSP-SUBSET-Filters-Template-Input-Fieldset (removed). The module owns
		// the search row now; reintroduce an end-cap slot there if an app turns out to need one.
		this.endCapTemplate = pOptions.endCapTemplate || '';
		// a local copy of the current route params to avoid "ComplexFilterView" view being set to pViewContext at any given time
		this.routeViewHash = null;
		this.routeRecordSet = null;
	}
	/*
		KNOWN TODO/BUGS:
		- Wrong input types generating for filter descriptors ("DateRange" is generating a "StringMatch" input, etc) -> This is a lib bug (added hack/workaround for now).
		- Add "complex filters" like "IDUser > (User Name First + User Name Last)", etc
		- Basic search query doesn't persist across views when doing a search (core library/route issue)
	*/

	/**
	 * Initializes the filter experience manager for the LIMS app by extracting the record set and view context from the current route, opening the filter persistence UI, and setting callbacks to update the filter experience view when filters are added, updated, or deleted.
	 * This ensures that the filter experience view is always ready to go when the user opens it, and that it stays in sync with the current filters and any changes made to them.
	 */
	initializeFilterExperienceManagerForLIMSApp()
	{
		const tmpRouteUrl = this.pict.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.url;
		this.routeRecordSet = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[0];
		this.routeViewHash = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[1];
		// always initiailize the filter experience view so that it's ready to go when the user opens it, but keep it hidden until then
		this.pict.views.FilterPersistenceView.initializeFilterPersistenceViewUI(this.routeRecordSet, this.routeViewHash, () =>
		{
			this.inintializeSelect2('#FilterPersistenceView-StoredFiltersSelect');
			// set the callback to reset the filter experience view when adding a new filter to the filter list
			this.pict.views['PRSP-Filters'].setAddFilterCallback(() =>
			{
				this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = true;
				this.pict.views.FilterPersistenceView.handleModifiedFiltersState();
			});
			// set the callback to reset the filter experience view when updating/deleting a filter in the filter list
			this.pict.views['PRSP-Filters'].setRemoveFilterCallback(() =>
			{
				this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = true;
				this.pict.views.FilterPersistenceView.handleModifiedFiltersState();
			});
		});
	}

	/**
	 * Initializes the select2 dropdown for saved filter experiences.
	 * This is called when the user opens the filter experience section for the first time, and also whenever the filter experience data is updated to ensure the dropdown is in sync.
	 * @param {string} pHTMLElementSelector - The selector for the HTML select element to initialize select2 on.
	 */
	inintializeSelect2(pHTMLElementSelector)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectElementSelector = document.querySelector(pHTMLElementSelector);
			// get all the options with values on the select element and use them to populate the select2 dropdown, this is needed to properly display the saved filter experiences in the filter experience dropdown
			const tmpOptions = [];
			if (tmpSelectElementSelector && tmpSelectElementSelector instanceof HTMLSelectElement)
			{
				for (const option of tmpSelectElementSelector.options)
				{
					if (option.value)
					{
						tmpOptions.push({ id: option.value, text: option.text });
					}
				}
			}
			const tmpSelectOptions = {
				data: tmpOptions,
				width: '100%',
				placeholder: 'Select a filter experience',
				dropdownParent: document.querySelector('#FilterPersistenceView-Container'),
			};
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](tmpSelectElementSelector).data('select2'))
			{
				window['jQuery'](tmpSelectElementSelector).select2(tmpSelectOptions);
			}
			else
			{
				// if it is already initialized, we need to update the options manually and trigger a change to update the display
				window['jQuery'](tmpSelectElementSelector).empty().select2(tmpSelectOptions);
				window['jQuery'](tmpSelectElementSelector).trigger('change');
			}
		}
	}

	handleSaveFilterPersistenceSettings(event, recordSet, viewContext)
	{
		const tmpCurrentFilterName = this.pict.providers.FilterDataProvider.getCurrentFilterName();
		this.pict.views.FilterPersistenceView.saveFilterPersistenceSettings(event, () =>
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filter experience "${tmpCurrentFilterName}" saved successfully`,
				type: 'is-success',
			});
		});
	}

	handleDeleteFilterPersistenceSettings(event)
	{
		const tmpCurrentFilterName = this.pict.providers.FilterDataProvider.getCurrentFilterName();
		this.pict.views.FilterPersistenceView.deleteFilterPersistenceSettings(event, () =>
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filter experience "${tmpCurrentFilterName}" deleted successfully`,
				type: 'is-success',
			});
		});
	}


	getActiveFilters()
	{
		const activeRecordSet = this.pict.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet || '';
		const activeFilters = this.pict?.Bundle?._ActiveFilterState?.[activeRecordSet]?.FilterClauses || [];
		//FIXME: don't want to make everything cascading async but want to force load this if it isn't there
		this.pict.providers?.[`RSP-Provider-${ activeRecordSet }`]?.getRecordSchema?.()?.catch?.((e) =>
		{
			this.pict.log.error('Failed to get record schema for active record set', e);
		});
		const activeSchema = this.pict.providers?.[`RSP-Provider-${ activeRecordSet }`]?.getFilterSchema();
		return { activeFilters, activeRecordSet, activeSchema };
	}

	updateFilters()
	{
		this.filterState = this.getActiveFilters();
	}


	/**
	 * Prepares the complex filter view by overriding the onBeforeRender and onAfterRender functions of the filter view to update the filter state and apply visibility states for disabled filters.
	 * Also overrides the prepareRecord function for specific filter types to ensure the correct input types are generated for the filter descriptors (workaround for lib bug).
	 * This is called when the filter view is rendered to ensure the complex filter functionality is properly integrated into the filter view.
	 */
	prepareComplexFilter()
	{
		if (!this.renderOverriden)
		{
			const beforeRenderStub = this.pict.views['PRSP-Filters'].onBeforeRender.bind(this.pict.views['PRSP-Filters']); ;
			this.pict.views['PRSP-Filters'].onBeforeRender =
			function(callback, renderable)
			{
				this.pict.providers.ComplexFilterProvider.prepareComplexFilter();
				beforeRenderStub(callback, renderable);
			};
			this.pict.views['PRSP-Filters'].onBeforeRender = this.pict.views['PRSP-Filters'].onBeforeRender.bind(this.pict.views['PRSP-Filters']);
			const afterRenderStub = this.pict.views['PRSP-Filters'].onAfterRender.bind(this.pict.views['PRSP-Filters']); ;
			this.pict.views['PRSP-Filters'].onAfterRender =
			function(callback, renderable)
			{
				this.pict.providers.ComplexFilterProvider.initializeFilterExperienceManagerForLIMSApp();
				afterRenderStub(callback, renderable);
			};
			this.pict.views['PRSP-Filters'].onAfterRender = this.pict.views['PRSP-Filters'].onAfterRender.bind(this.pict.views['PRSP-Filters']);
			// Entity-reference filters now delegate their input to the pict-native 'Picker' InputType
			// (the select2-free replacement for EntitySelectorMultiple). pict-section-recordset's Phase 3
			// entity-reference base natively stamps the ClauseDescriptor InputType + Entity and bridges
			// Values↔StringArrayValue, so the prepareRecord patches that used to live here are gone — we
			// just opt the filter types into the picker.
			[ 'InternalJoinSelectedValue', 'InternalJoinSelectedValueList', 'ExternalJoinSelectedValue', 'ExternalJoinSelectedValueList' ].forEach((pType) =>
			{
				const tmpEntityFilterView = this.pict.views['PRSP-FilterType-' + pType];
				if (tmpEntityFilterView) { tmpEntityFilterView.options.EntityInputType = 'Picker'; }
			});
			const tempPrepareStringRecord = this.pict.views['PRSP-FilterType-StringMatch'].prepareRecord.bind(this.pict.views['PRSP-FilterType-StringMatch']);
			this.pict.views['PRSP-FilterType-StringMatch'].prepareRecord =
			function(pRecord)
			{
				tempPrepareStringRecord(pRecord);
				if (!pRecord.ClauseDescriptor?.DataType)
				{
					pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'String';
				}
				if (!pRecord.ClauseDescriptor?.PictForm)
				{
					pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
				}
			};
			// The module's add-filter popover owns field visibility now — hand it our blacklist so
			// internal/audit columns (DeleteDate, ExternalSync*, etc.) stay hidden from it.
			this.pict.views['PRSP-Filters'].filterFieldBlacklist = this.blacklistedFilters;
			// Quick Filters are opt-in across Headlight: the curated bar shows only on record sets that
			// declare an explicit `QuickFilters` config (no schema-derived clever defaults). (The recordset
			// date-range filter fix still applies everywhere regardless of this.)
			this.pict.views['PRSP-Filters'].quickFiltersAutoDefault = false;
			this.renderOverriden = true;
		}
		// update the filter state
		this.updateFilters();

		// (The entity SelectedValueList template overrides that used to live here are gone — the module's
		// entity-reference base owns its input template natively now, delegating to the Picker InputType.)
		//@ts-ignore
		this.pict.PictApplication.changeTheme('Edit');
		// The filter clause + chrome + the add-filter popover + the entity-reference inputs are all owned
		// by pict-section-recordset now (entity filters delegate to the pict-native 'Picker' InputType,
		// opted in above) and branded via Headlight's --theme-color-* tokens; this provider just hands the
		// module its field blacklist (above). What remains here is the filter-experience manager (below).
		this.pict.TemplateProvider.addTemplate('FilterPersistenceView-Container', /*html*/`
			<!-- LIMS Custom pict view template: [FilterPersistenceView-Container] -->
			<div id="FilterPersistenceView-Content">
				<!-- Content for Filter Persistence View goes here -->
				<div id="FilterPersistenceView-Body">
					<label class="label" for="FilterPersistenceView-CurrentFilterNameInput">Current Filter Experience: <span id="FilterPersistenceView-CurrentFilterNameInput-ValidationMessage" class="is-size-7 has-text-weight-normal has-text-danger-50 ml-1"></span></label>
					<fieldset class="FilterPersistenceView-ActiveSettings field has-addons has-addons-right">						
						<p class="control is-expanded">
							<input class="input" type="text" id="FilterPersistenceView-CurrentFilterNameInput" name="CurrentFilterName" value="" onfocus="this.select()" />
						</p>
						<p class="control has-text-right">

							<button type="button" class="button is-info" id="FilterPersistenceView-SaveFilterButton" onclick="_Pict.providers.ComplexFilterProvider.handleSaveFilterPersistenceSettings(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">
								<span class="icon"><i class="fas fa-save"></i></span>
								<span id="FilterPersistenceView-SaveFilterButtonText" class="icon-text">Save</span>
							</button>
						</p>
					</fieldset>
					<div class="FilterPersistenceView-StoredSettings">
						<!-- Dropdown for stored filter experiences -->
						<fieldset class="field">
							<label class="label" for="FilterPersistenceView-StoredFiltersSelect">Saved Filter Experiences:</label>
							<p class="control select is-fullwidth">
								<select class="input" id="FilterPersistenceView-StoredFiltersSelect" onchange="_Pict.views['FilterPersistenceView'].setFilterExperienceToSelection(event)" name="StoredFilterName">
									<!-- Options will be populated dynamically -->
								</select>
							</p>
							<p class="control has-text-right mt-2">
								<button type="button" class="button is-info" id="FilterPersistenceView-LoadFilterButton" 
									onclick="_Pict.views['FilterPersistenceView'].loadFilterPersistenceSettings(event);">
									<span class="icon"><i class="fas fa-download"></i></span>
									<span class="icon-text">Load</span>
								</button>
								<button type="button" class="button is-info" id="FilterPersistenceView-SetAsDefaultButton" onclick="_Pict.views['FilterPersistenceView'].toggleFilterExperienceAsTheDefault(event, true)">
									<span class="icon"><i class="fas fa-star"></i></span>
									<span class="icon-text">Set As Default</span>
								</button>
								<button type="button" class="button is-info" id="FilterPersistenceView-RemoveAsDefaultButton" onclick="_Pict.views['FilterPersistenceView'].toggleFilterExperienceAsTheDefault(event, false)">
									<span class="icon"><i class="fas fa-star-half-alt"></i></span>
									<span class="icon-text">Remove As Default</span>
								</button>
								<button type="button" class="button is-info" id="FilterPersistenceView-DeleteFilterButton" onclick="_Pict.providers.ComplexFilterProvider.handleDeleteFilterPersistenceSettings(event)">
									<span class="icon"><i class="fas fa-trash"></i></span>
									<span class="icon-text">Delete</span>
								</button>
							</p>
						</fieldset>
					</div>
				</div>
				<div id="FilterPersistenceView-Footer" class="container pt-3">
					<div class="columns is-vcentered">
						<div class="column">
							<label for="OptionalSettings-RememberLastUsed" class="label">
								<input type="checkbox" id="OptionalSettings-RememberLastUsed" name="RememberLastUsed" onchange="_Pict.views['FilterPersistenceView'].toggleRememberLastUsedFilterExperience(event)"	 />
								Remember my last search filter experience
							</label>
						</div>
					</div>
				</div>
			</div>
			<!-- LIMS Custom end view template:  [FilterPersistenceView-Container] -->
		`);
	}
}

module.exports = ComplexFilterProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],855:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ConfigurationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// temporary configuration by scope for testing
		// TODO: Remove this when the Configuration API is available
		this.tmpConfigurationByScope = [
			{
				'IDCustomer': 117,
				'ConfigurationID': 'HDOT',
				'State': 'Hawaii',
				'StateAbbreviation': 'HI',
				'Agency': 'HDOT',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 13,
					'LeafletInitialCenter': [ 21.315603, -157.858093 ],
				},
			},
			{
				'IDCustomer': 63,
				'ConfigurationID': 'ALDOT',
				'State': 'Alabama',
				'StateAbbreviation': 'AL',
				'Agency': 'ALDOT',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 32.4074958, -86.2651064 ],
				},
			},
			{
				'IDCustomer': 16,
				'ConfigurationID': 'Transystems',
				'State': [ 'South Carolina', 'Pennsylvania' ],
				'StateAbbreviation': [ 'SC', 'PA' ],
				'Agency': 'Transystems',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 32.89979011186591, -79.97861499691103 ],
				},
			},
			{
				'IDCustomer': 1,
				'ConfigurationID': 'Headlight',
				'State': 'Headlight',
				'StateAbbreviation': null,
				'Agency': 'Headlight',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 47.6142773, -122.3586997 ],
				},
			},
			{
				'IDCustomer': 188,
				'ConfigurationID': 'MoffattNichol',
				'State': [ 'Alaska', 'Louisiana' ],
				'StateAbbreviation': [ 'AK', 'LA' ],
				'Agency': 'Moffatt & Nichol',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 61.1070663, -150.0733888 ],
				},
			},
			{
				'IDCustomer': 178,
				'ConfigurationID': 'BridgeEngineering',
				'State': 'Headlight',
				'StateAbbreviation': null,
				'Agency': 'Bridge Engineering',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 32.8001818028968, -96.67293809033943 ],
				},
			},
			{
				'IDCustomer': 184,
				'ConfigurationID': 'IndustrySolutions',
				'State': 'Pennsylvania',
				'StateAbbreviation': 'PA',
				'Agency': 'Industry Solutions',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 40.437801138712196, -79.99294555569139 ],
				},
			},
		];
	}

	getConfigurationByScope(pScope, pCallback)
	{
		if (!pScope)
		{
			this.pict.log.error('No Configuration Scope provided.');
			return new Error('No Configuration Scope provided.');
		}
		const tmpScopeConfig = this.tmpConfigurationByScope.filter((pConfig) => pConfig.IDCustomer === pScope);

		// find the temporary configuration by scope for testing where the pScope is the IDCustomer (for now)
		if (tmpScopeConfig && tmpScopeConfig.length > 0)
		{
			// return the first configuration found
			const tmpResult = tmpScopeConfig[0];
			this.pict.log.info(`Configuration found for ${pScope}`, tmpResult);
			if (pCallback)
			{
				pCallback(tmpResult);
			}
			return tmpResult;
		}
		else
		{
			this.pict.log.error(`Configuration not found for passed value: ${pScope}`);
			if (pCallback)
			{
				pCallback({});
			}
			return {};
		}
		// this.pict.HeadlightRestClient.getJSON(`Configuration/Scope/${pScope}`, (pError, pBody) =>
		// {
		// 	if (pError)
		// 	{
		// 		this.pict.log.error(`Error getting Configuration: ${pError}`, pError);
		// 		return reject(pError);
		// 	}
		// 	resolve(pBody);
		// });
	}
}

module.exports = ConfigurationProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],856:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const EntityDataBaseline = require('headlight-dynamic-inputs-bundle/source/providers/_EntityDataBaseline.js');

// Bounds one drain of the save queue. Reachable only by a save trigger that fires from inside the save
// lifecycle itself (an onAfterDocumentSave override, say), which would otherwise re-queue forever.
const MAX_CONSECUTIVE_SAVE_CYCLES = 25;

// Busy-toast phrasing keyed on the lowercased approval action. The action list is server-defined
// (fetchApprovalState), so anything unrecognized falls back to naming the action verbatim.
const APPROVAL_BUSY_PHRASE =
{
	'submit': 'Submitting this document for approval.',
	'approve': 'Approving this document.',
	'reject': 'Rejecting this document.',
	'draft': 'Returning this document to draft.',
};
const APPROVAL_BUSY_SUFFIX = ' This can take a few moments; the page will refresh when it finishes.';
// How long a silent server gets before the busy toast escalates its wording. Never releases the lock.
const APPROVAL_BUSY_ESCALATION_MS = 30000;

class DocumentProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & Pict} */
		this.fable;
		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;
		/** @type {any} */
		this.AppData;
		/** @type {any} */
		this.log;
		/** @type {any} */
		this.services;

		this.pict.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });

		/** @type {boolean} - Whether a save lifecycle is currently running. */
		this.IsSaving = false;
		/** @type {boolean} - Whether a save was requested while one was already running. */
		this._SavePending = false;
		/** @type {boolean} - Mute setting for the queued trailing save; any un-muted requester un-mutes it. */
		this._PendingMuteNotification = true;
		/** @type {Array<(pError?: Error) => void>} - Resolvers waiting on the trailing save that will carry their mutation. */
		this._PendingSaveWaiters = [];
		/** @type {Array<() => void>} - Resolvers waiting for the current save drain to finish, whatever its outcome. */
		this._SaveSettledWaiters = [];
		/** @type {boolean} - Whether an approval action (submit/approve/reject) is currently running. */
		this.isTakingAction = false;
		/** @type {?{ dismiss: function }} - Handle for the persistent toast shown while an action runs. */
		this._ApprovalBusyToast = null;
		/** @type {string} - The action the busy state is describing, for the toast copy. */
		this._ApprovalBusyAction = '';
		/** @type {any} - Timer that escalates the busy toast wording when the server goes quiet. */
		this._ApprovalBusyEscalationTimer = null;
		/** @type {boolean} - Whether a page reload has been requested and now owns the busy state. */
		this._ApprovalReloadPending = false;
	}

	/**
	 * Resolve once no save lifecycle is in flight.
	 *
	 * Unlike handleSaveAsync this never *requests* a save — it only waits for one that is already
	 * running. Callers that must not act on a half-written document (approval actions, which lock it)
	 * use this to close the window where the user could beat an in-flight save to the punch.
	 *
	 * @return {Promise<void>} Resolves immediately when nothing is saving.
	 */
	whenSaveSettled()
	{
		if (!this.IsSaving)
		{
			return Promise.resolve();
		}
		return new Promise((resolve) =>
		{
			this._SaveSettledWaiters.push(resolve);
		});
	}

	/**
	 * This function is used to get the style of the approval status based on the status of the document.
	 * @param {string} pStatus - The status of the document
	 * @return {object} - The icon class and background color for the status
	 * @example
	 * getApprovalStatusStyle('Draft');
	 * getApprovalStatusStyle('Submit');
	 * getApprovalStatusStyle('Approve');
	 */
	getApprovalStatusStyle(pStatus)
	{
		const returnObject = {};
		const documentStatus = pStatus || this.pict.AppData?.DocumentData?.ReportData?.Status;
		switch (documentStatus)
		{
		case 'Draft':
			returnObject.iconClass = 'fa-clipboard';
			returnObject.backgroundColor = 'has-background-grey';
			break;
		case 'Submit':
		case 'Submitted':
			returnObject.iconClass = 'fa-paper-plane';
			returnObject.backgroundColor = 'has-background-info-40';
			break;
		case 'Approve':
		case 'Approved':
			returnObject.iconClass = 'fa-check-circle';
			returnObject.backgroundColor = 'has-background-success-40';
			break;
		case 'Reject':
		case 'Rejected':
			returnObject.iconClass = 'fa-ban';
			returnObject.backgroundColor = 'has-background-danger-40';
			break;
		default:
			returnObject.iconClass = 'fa-question-circle';
			returnObject.backgroundColor = 'has-background-grey';
			break;
		}
		return returnObject;
	}

	/**
	 * This function is used to handle the change of the approval status of a document.
	 * @param {Event} event - The click event
	 * @param {string} action - The action to take on the document
	 * @return {void}
	 * @example
	 * handleApprovalStatusChange(event, 'Approve');
	 * handleApprovalStatusChange(event, 'Reject');
	 * handleApprovalStatusChange(event, 'Submit');
	 * handleApprovalStatusChange(event, 'Draft');
	 */
	handleApprovalStatusChange(event, action)
	{
		if (event)
		{
			event.preventDefault();
		}
		this.takeApprovalAction(action);
	}

	/**
	 * This function is used to determine if the open document action was called from a mobile device.
	 * @return {boolean} - True if the open document action was called from a mobile device, false otherwise
	 */
	isOpenDocumentCalledFromMobileDevice()
	{
		// @ts-ignore
		const platform = window.navigator?.platform || window.navigator?.userAgentData?.platform || '';
		const isMobileDevice = (window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g) || platform.toUpperCase() === 'MACINTEL') && window.navigator.maxTouchPoints > 1;
		const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
		if (isMobileDevice && !isSafari)
		{
			return true;
		}
		return false;
	}

	/**
	 * Open the Form Handler to show a confirmation modal when called from the webapp
	 * @param {object} event - The click event
	 * @param {number|string} [pIDDocument] - The ID of the Document to view
	 */
	//TODO: is this method in the right file as it calls a view ?
	openFormByIDDocumentHandler(event, pIDDocument)
	{
		const tmpIDDocument = pIDDocument || this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (this.isOpenDocumentCalledFromMobileDevice())
		{
			this.pict.views.DocumentDetails.confirmOpenForm(tmpIDDocument, '_top');
			return;
		}

		this.openFormByIDDocument(event, tmpIDDocument);
	}

	/**
	 * Opens a document in a new tab.
	 * @param {Object} event
	 * @param {Number} tmpIDDocument
	 * @param {String} [windowTarget='_blank'] - The target window for the document (default is '_blank')
	 */
	openFormByIDDocument(event, tmpIDDocument, windowTarget = '_blank')
	{
		const tmpElement = event.currentTarget;
		this.log.info('Open Form for Document ID:', tmpIDDocument);
		if (event)
		{
			tmpElement.classList.add('is-loading');
		}
		// Needed for handling ios issues.
		const windowReference = window.open('', windowTarget);
		const template =
		`<style> 
			@-webkit-keyframes load8 { 
				0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 
				100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); } 
			} 
			@keyframes load8 { 
				0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 
				100% { -webkit-transform: rotate(360deg);transform: rotate(360deg); } 
			} 
			*, *:before, *:after { 
				box-sizing: border-box;
			}
			body { 
				padding: 15px 0; 
				margin: 0 auto; 
				background-color: #53565A; 
				font-family: Arial, sans-serif; 
				width: 100%; 
				font-size: 15px; 
				max-width: 1000px;
			}
			.loading-splash-screen {
				width: 100%; 
				height: 100vh; 
				background: #53565A; 
				position: fixed; 
				top: 0; 
				left: 0; 
				text-align: center; 
				z-index: 10002; 
				display:flex; 
				align-items: center;
			}
			 .loading-splash-screen .loading-spinner, 
			 .loading-splash-screen .loading-spinner:after { 
			 	border-radius: 50%; width: 15em; height: 15em;
			}  
			.loading-spinner { 
				margin: 60px auto; 
				font-size: 10px; 
				position: relative; 
				text-indent: -9999em; 
				border-top: 1.1em solid rgba(255, 255, 255, 0.2); 
				border-right: 1.1em solid rgba(255, 255, 255, 0.2); 
				border-bottom: 1.1em solid rgba(255, 255, 255, 0.2); 
				border-left: 1.1em solid #ffffff; 
				-webkit-transform: translateZ(0); 
				-ms-transform: translateZ(0); 
				transform: translateZ(0); 
				-webkit-animation: load8 1.1s infinite linear; animation: load8 1.1s infinite linear;
			}
			</style>
			<div id="LoadingSplashScreen" class="loading-splash-screen">
				<div class="loading-spinner">Loading...</div>
			</div>
		`;
        windowReference.document.write(template);
		this.pict.HeadlightRestClient.getJSON('Report/Render/' + tmpIDDocument + '/default',
		(pError, pBody) =>
		{
			windowReference.location = window.location.origin + '/1.0/Report/' + pBody.GUIDReportDescription + '/index.html';
			if (event)
			{
				tmpElement.classList.remove('is-loading');
			}
			if (pError)
			{
				windowReference.close();
				this.log.error('Error retrieving Report Description:', pError);
				this.pict.views.HeadlightPanels?.toast?.({
					message: `<strong>Error retrieving Report Description:</strong><br/><em>${pError.message || pError}</em>`,
					type: 'is-danger',
				});
				return;
			}
		});
	}

	/**
	 * This function is used to handle the download of a document.
	 * @param {boolean} forceRender - Whether to force the document to render in the browser
	 * @param {object} [pReportData] - The report data to use when rendering the document (optional, used for "not my current document" scenarios)
	 * @param {Function} [pCallback] - The callback function to call when the download is complete
	 * @return {Promise<void>}
	 * @async
	 */
	async handleDocumentDownload(forceRender = false, pReportData = null, pCallback)
	{
		if (!this.IsDownloading)
		{
			this.IsDownloading = true;

			const tmpReportData = pReportData || this.AppData?.DocumentData?.ReportData;
			try
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'Document download started...',
					type: 'is-success',
				});
				await this.services.HeadlightDocumentService.downloadDocument(forceRender, tmpReportData);
			}
			catch (e)
			{
				this.pict.log.error('Failed to download document', { error: e });
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to download document!',
					type: 'is-danger',
				});
			}
			finally
			{
				this.IsDownloading = false;
				// Call the callback function if provided
				if (pCallback)
				{
					pCallback();
				}
			}
		}
		else
		{
			this.pict.log.warn('Form processor not found or download operation is already in progress.');
		}
	}

	/**
	 * Fire-and-forget document save: requests a save and returns immediately — it does NOT wait for the
	 * Document PUT to land. Callers that must wait before proceeding (e.g. before locking on submit, or
	 * before reading the freshly-persisted copy) must use handleSaveAsync — which awaits the full lifecycle.
	 * `await handleSave(...)` is a no-op wait; not-async by design so that reads honestly.
	 * @param {boolean} [muteNotification] - Whether to mute the save notification.
	 * @return {void}
	 */
	handleSave(muteNotification = false)
	{
		this.handleSaveAsync(muteNotification);
	}

	/**
	 * Awaitable variant of handleSave.
	 *
	 * Resolves only after a save lifecycle carrying this caller's state has completed (including
	 * _saveDocument's PUT /Document/), so callers that must read the freshly-persisted server copy can
	 * guarantee the latest in-memory FormData has been flushed first. The form-conversion / PDF export is the
	 * motivating case: it downloads a server-rendered file filled from the persisted FormData, so it must
	 * save before fetching (PD-8714).
	 *
	 * Resolves with the save error (if any) rather than rejecting, so callers can decide whether to continue.
	 *
	 * Save lifecycles are serialized — only one runs at a time. A caller arriving while a save is in flight
	 * (a double-clicked Save button, or a background trigger firing mid-save) does not start a second
	 * lifecycle; it queues exactly one trailing save that runs after the in-flight one drains, and so carries
	 * whatever it mutated. Coalescing onto the in-flight save instead would silently drop those mutations,
	 * because callers mutate ReportData/FormData immediately before asking for a save.
	 *
	 * @param {boolean} [muteNotification] - Whether to mute the save toast.
	 * @return {Promise<Error|undefined>} Resolves once a save covering this request has completed.
	 */
	handleSaveAsync(muteNotification = false)
	{
		if (this.IsSaving)
		{
			this._SavePending = true;
			this._PendingMuteNotification = this._PendingMuteNotification && muteNotification;
			return new Promise((resolve) =>
			{
				this._PendingSaveWaiters.push(resolve);
			});
		}
		return this._drainSaveQueue(muteNotification);
	}

	/**
	 * Run save lifecycles until nothing further has been requested, holding the single-flight latch across
	 * the whole drain so the Save button does not flicker between queued cycles.
	 * @param {boolean} pMuteNotification - Whether to mute the toast for the first cycle.
	 * @return {Promise<Error|undefined>} Resolves with the error from the last cycle run, if any.
	 */
	async _drainSaveQueue(pMuteNotification)
	{
		this.IsSaving = true;
		this._syncSaveButtonState();
		// Approval actions must not be reachable while the document is being written; see
		// _syncApprovalActionState.
		this._syncApprovalActionState();
		let tmpMuteNotification = pMuteNotification;
		let tmpCycleCount = 0;
		/** @type {Error|undefined} */
		let tmpError;
		try
		{
			do
			{
				// Snapshot before running: these waiters queued during the previous cycle, so the cycle about
				// to run is the one that carries their mutation.
				this._SavePending = false;
				const tmpWaiters = this._PendingSaveWaiters;
				this._PendingSaveWaiters = [];
				tmpError = await this._runSaveLifecycle(tmpMuteNotification);
				tmpMuteNotification = this._PendingMuteNotification;
				this._PendingMuteNotification = true;
				for (const fWaiter of tmpWaiters)
				{
					fWaiter(tmpError);
				}
				tmpCycleCount++;
				if (tmpCycleCount >= MAX_CONSECUTIVE_SAVE_CYCLES && this._SavePending)
				{
					this.pict.log.error(`Document save queue drained ${tmpCycleCount} consecutive cycles and is still being re-queued; abandoning the queued save to avoid a save loop.`);
					break;
				}
			}
			while (this._SavePending);
		}
		finally
		{
			this.IsSaving = false;
			this._SavePending = false;
			this._PendingMuteNotification = true;
			const tmpOrphanedWaiters = this._PendingSaveWaiters;
			this._PendingSaveWaiters = [];
			for (const fWaiter of tmpOrphanedWaiters)
			{
				fWaiter(tmpError);
			}
			this._syncSaveButtonState();
			this._syncApprovalActionState();
			this._syncCurrentSamplesButtonState();
			const tmpSettledWaiters = this._SaveSettledWaiters;
			this._SaveSettledWaiters = [];
			for (const fSettledWaiter of tmpSettledWaiters)
			{
				fSettledWaiter();
			}
			// Restart the auto-save countdown from this save, so a manual save buys the user a full
			// interval rather than an auto-save moments later.
			this.pict.providers?.AutoSave?.onSaveLifecycleSettled?.(tmpError);
		}
		return tmpError;
	}

	/**
	 * Execute one full save lifecycle. Never rejects; resolves with the error when one occurred.
	 *
	 * The lifecycle is an Anticipate waterfall fanned out across providers, and it stalls forever if any hook
	 * fails to invoke its callback — a hung socket in FormEntityCreator's Document PUT is the realistic case.
	 * The watchdog releases the latch on a stall so the user is not stranded behind a permanently disabled
	 * Save button with no indication of what happened.
	 * @param {boolean} pMuteNotification - Whether to mute the save toast.
	 * @return {Promise<Error|undefined>}
	 */
	_runSaveLifecycle(pMuteNotification)
	{
		this._MuteNotification = pMuteNotification;
		const tmpUploadID = this.pict.providers.UploadTracking.trackUpload();
		// Falls back rather than trusting options: a missing value would otherwise become a 0ms timeout and
		// make every save look like it stalled.
		const tmpWatchdogTimeoutMS = this.options.SaveWatchdogTimeoutMS || 120000;
		return new Promise((resolve) =>
		{
			let tmpSettled = false;
			/** @type {any} */
			let tmpWatchdogTimer = null;
			/**
			 * @param {Error} [pError] - The error the lifecycle (or the watchdog) produced.
			 * @return {void}
			 */
			const fSettle = (pError) =>
			{
				if (tmpSettled)
				{
					return;
				}
				tmpSettled = true;
				if (tmpWatchdogTimer)
				{
					clearTimeout(tmpWatchdogTimer);
					tmpWatchdogTimer = null;
				}
				this.pict.providers.UploadTracking.untrackUpload(tmpUploadID);
				return resolve(pError);
			};
			tmpWatchdogTimer = setTimeout(() =>
			{
				const tmpTimeoutError = new Error(`Document save did not complete within ${tmpWatchdogTimeoutMS}ms.`);
				this.pict.log.error('Document save watchdog fired; releasing the save lock.', { error: tmpTimeoutError });
				// Surfaced even when the save was muted — a stalled background save is exactly the condition
				// the user otherwise has no way to see.
				this.pict.views?.HeadlightPanels?.toast({
					message: 'The server has not responded to the save. Your latest changes may not be saved.',
					type: 'is-warning',
				});
				return fSettle(tmpTimeoutError);
			}, tmpWatchdogTimeoutMS);
			this.pict.PictApplication.saveDataAsync(fSettle);
		});
	}

	/**
	 * Push the current save state onto the navbar Save button. The button belongs to the panels view and is
	 * re-rendered whenever the document context changes, so that render path calls this too.
	 * @return {void}
	 */
	_syncSaveButtonState()
	{
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (tmpPanelsView && typeof tmpPanelsView.syncSaveButtonState === 'function')
		{
			tmpPanelsView.syncSaveButtonState();
		}
	}

	/**
	 * Push the current save/approval state onto the approval action buttons in the Status panel.
	 *
	 * The buttons live in a panel that is built on demand and rebuilt whenever the approval state is
	 * re-fetched, so both this and that build path apply the state. Derives entirely from provider
	 * state, so calling it before the panel exists is a no-op that the next build picks up.
	 * @return {void}
	 */
	_syncApprovalActionState()
	{
		const tmpStatusPane = this.pict.views?.HeadlightPaneStatus;
		if (tmpStatusPane && typeof tmpStatusPane.syncApprovalActionButtonState === 'function')
		{
			tmpStatusPane.syncApprovalActionButtonState();
		}
	}

	/**
	 * Latch (or release) the approval busy state and repaint everything that reflects it.
	 *
	 * Latch first, then repaint: the latch is what stands auto-save down and blocks a second entry into
	 * takeApprovalAction; the repaints are what tell the user. Every _sync below derives entirely from
	 * the latch, so each is a safe no-op before its DOM exists.
	 * @param {boolean} pIsBusy - Whether an approval action is running.
	 * @param {string} [pAction] - The action being taken, used for the toast copy.
	 * @return {void}
	 */
	_setApprovalBusy(pIsBusy, pAction)
	{
		// A reload is committing. Releasing now would re-enable a form that is about to be replaced and
		// take away the only explanation the user has for the wait; see _beginApprovalReload.
		if (!pIsBusy && this._ApprovalReloadPending)
		{
			return;
		}
		this.isTakingAction = Boolean(pIsBusy);
		this._ApprovalBusyAction = pIsBusy ? (pAction || '') : '';
		this._syncDocumentFormBusyState();
		this._syncSaveButtonState();
		this._syncApprovalActionState();
		this._syncApprovalBusyToast();
	}

	/**
	 * Make the document form inert while an approval action runs.
	 *
	 * `inert` is what actually stops the keyboard — pointer-events only stops the mouse, and almost
	 * nothing in a manifest-driven form carries a disabled attribute. The class goes on the body rather
	 * than the form because Select2 dropdowns and flatpickr calendars portal outside it.
	 * @return {void}
	 */
	_syncDocumentFormBusyState()
	{
		const tmpFormElement = document.getElementById('Headlight-Document-Form');
		if (!tmpFormElement)
		{
			return;
		}
		if (this.isTakingAction)
		{
			// Blur before going inert so focus lands on the body rather than being dropped mid-subtree.
			if (tmpFormElement.contains(document.activeElement) && typeof document.activeElement?.blur === 'function')
			{
				document.activeElement.blur();
			}
			document.body.classList.add('hl-approval-busy');
			tmpFormElement.setAttribute('aria-busy', 'true');
			tmpFormElement.setAttribute('inert', '');
		}
		else
		{
			document.body.classList.remove('hl-approval-busy');
			tmpFormElement.setAttribute('aria-busy', 'false');
			tmpFormElement.removeAttribute('inert');
		}
	}

	/**
	 * Compose the busy-toast copy for an approval action.
	 * @param {string} pAction - The action being taken.
	 * @return {string}
	 */
	_getApprovalBusyMessage(pAction)
	{
		// hasOwnProperty, not a bare lookup: the action name is server-defined, so "constructor" or
		// "toString" would otherwise resolve off Object.prototype and render a function into the toast.
		const tmpKey = String(pAction || '').toLowerCase();
		if (Object.prototype.hasOwnProperty.call(APPROVAL_BUSY_PHRASE, tmpKey))
		{
			return APPROVAL_BUSY_PHRASE[tmpKey] + APPROVAL_BUSY_SUFFIX;
		}
		// A server-defined action name. Name it verbatim rather than guessing a verb for it.
		return (pAction ? `Applying the ${pAction} action to this document.` : 'Updating the document status.') + APPROVAL_BUSY_SUFFIX;
	}

	/**
	 * Show or tear down the persistent toast that explains the busy state.
	 *
	 * Sticky, because the toasts this action itself fires (a failed save, a validation error, the save
	 * watchdog) would otherwise evict the one explanation the user has for a page that stopped responding.
	 * @return {void}
	 */
	_syncApprovalBusyToast()
	{
		if (this._ApprovalBusyEscalationTimer)
		{
			clearTimeout(this._ApprovalBusyEscalationTimer);
			this._ApprovalBusyEscalationTimer = null;
		}
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (!this.isTakingAction)
		{
			if (this._ApprovalBusyToast)
			{
				tmpPanelsView?.dismissToast?.(this._ApprovalBusyToast);
				this._ApprovalBusyToast = null;
			}
			tmpPanelsView?.announceStatus?.('');
			return;
		}
		if (this._ApprovalBusyToast || typeof tmpPanelsView?.toast !== 'function')
		{
			return;
		}
		const tmpMessage = this._getApprovalBusyMessage(this._ApprovalBusyAction);
		this._ApprovalBusyToast = tmpPanelsView.toast(
			{
				message: tmpMessage,
				type: 'is-info',
				sticky: true,
				// No dismiss button: closing it would leave the page locked with nothing left saying why.
				dismissible: false,
				// The action name comes from the server; never let it reach the DOM as markup.
				allowHTML: false,
			});
		tmpPanelsView.announceStatus?.(tmpMessage);
		this._ApprovalBusyEscalationTimer = setTimeout(() => this._escalateApprovalBusyToast(), this.options.ApprovalBusyEscalationMS || APPROVAL_BUSY_ESCALATION_MS);
	}

	/**
	 * Swap the busy toast for a "still waiting" one. Deliberately does not release the lock: the action
	 * may still land server-side, and re-arming auto-save and the action buttons underneath it is exactly
	 * the race the save guard closed.
	 * @return {void}
	 */
	_escalateApprovalBusyToast()
	{
		this._ApprovalBusyEscalationTimer = null;
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (!this.isTakingAction || this._ApprovalReloadPending || typeof tmpPanelsView?.toast !== 'function')
		{
			return;
		}
		this.pict.log.warn(`Approval action "${this._ApprovalBusyAction}" has not responded yet; escalating the busy notice.`);
		tmpPanelsView.dismissToast?.(this._ApprovalBusyToast);
		const tmpMessage = 'The server has not responded yet. Keep this page open; it will refresh as soon as the action finishes.';
		this._ApprovalBusyToast = tmpPanelsView.toast({ message: tmpMessage, type: 'is-warning', sticky: true, dismissible: false, allowHTML: false });
		tmpPanelsView.announceStatus?.(tmpMessage);
	}

	/**
	 * Latch the reload phase of an approval action, then reload.
	 *
	 * window.location.reload() does not stop the caller — the finally in takeApprovalAction still runs and
	 * the page keeps executing until the navigation commits. The latch makes that release a no-op, so the
	 * form stays inert and the toast stays up right through the fetch. Extracted so tests can drive the
	 * success path without navigating.
	 * @return {void}
	 */
	_beginApprovalReload()
	{
		this._ApprovalReloadPending = true;
		if (this._ApprovalBusyEscalationTimer)
		{
			clearTimeout(this._ApprovalBusyEscalationTimer);
			this._ApprovalBusyEscalationTimer = null;
		}
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (typeof tmpPanelsView?.toast === 'function')
		{
			// The action landed; what is left is the reload. Say so, so a slow refresh does not read as a hang.
			tmpPanelsView.dismissToast?.(this._ApprovalBusyToast);
			const tmpMessage = 'Status updated. Refreshing the page...';
			this._ApprovalBusyToast = tmpPanelsView.toast({ message: tmpMessage, type: 'is-success', sticky: true, dismissible: false, allowHTML: false });
			tmpPanelsView.announceStatus?.(tmpMessage);
		}
		window.location.reload();
	}

	/**
	 * Re-check whether this document has joined Samples once a save settles, so the navbar Current Samples
	 * button appears without a full view refresh. The join is created server-side, so it cannot be derived
	 * from local state at creation time.
	 * @return {void}
	 */
	_syncCurrentSamplesButtonState()
	{
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (tmpPanelsView && typeof tmpPanelsView.syncCurrentSamplesButtonState === 'function')
		{
			tmpPanelsView.syncCurrentSamplesButtonState();
		}
	}

	// eslint-disable-next-line valid-jsdoc
	/**
	 * This function is used to tie the document save for forms into the application save lifecycle.
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		let onBeforeSavePromise = Promise.resolve();
		//FIXME: migrate this to the new lifecycle events and sunset this
		if (typeof this.pict.PictApplication.onBeforeDocumentSave === 'function')
		{
			onBeforeSavePromise = this.pict.PictApplication.onBeforeDocumentSave();
			if (typeof onBeforeSavePromise.then !== 'function')
			{
				onBeforeSavePromise = Promise.resolve();
			}
		}
		onBeforeSavePromise.then(() =>
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}).catch((error) =>
		{
			this.pict.log.error('Error in onBeforeDocumentSave:', error);
			// Proceed with the save operation even if onBeforeDocumentSave fails
			return super.onBeforeSaveDataAsync(fCallback);
		});
	}

	// eslint-disable-next-line valid-jsdoc
	/**
	 * Ties the document save for forms into the application save lifecycle.
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onSaveDataAsync(fCallback)
	{
		this._saveDocument().then(() =>
		{
			return super.onSaveDataAsync(fCallback);
		}).catch((err) =>
		{
			return super.onSaveDataAsync((pParentError) =>
			{
				return fCallback(err || pParentError);
			});
		});
	}

	/**
	 * Persist the document, then run the application's post-save hook.
	 *
	 * Rethrows a save failure so it reaches the save-data lifecycle callback and, through it, the value
	 * handleSaveAsync resolves with — callers that gate on a successful save (submit, which locks the
	 * document) cannot honour a failure they were never told about. Because the lifecycle waterfall
	 * short-circuits on error, a failed save also skips the remaining onAfterSaveDataAsync hooks, so entity
	 * comprehension is not pushed against a document whose own write did not land.
	 * @return {Promise<void>}
	 */
	async _saveDocument()
	{
		// The baseline advances on the server having seen the payload, not on the record being persisted.
		// It describes what the comprehension has already asked the server to write, and the server is the
		// only thing that applies it - so on the local transport the baseline must stay where it is and
		// every save re-emits everything changed since load. Folding on a local write instead would have
		// the next save's prune drop the records the first save emitted, because they now match the
		// baseline, and only the final document is ever synced.
		const tmpDocumentService = this.pict.services.HeadlightDocumentService;
		const tmpIsServerTransport = (typeof tmpDocumentService.isLocalDocumentTransport !== 'function') ||
			!tmpDocumentService.isLocalDocumentTransport();
		try
		{
			// Fold every provider's emission into the delta baseline ONCE, here, immediately before the
			// PUT: the baseline lives in FormData, and FormData is snapshotted into the PUT body, so a fold
			// after the save would never reach the server and every reload would start from a stale one.
			if (tmpIsServerTransport)
			{
				EntityDataBaseline.foldPendingEmission(this.pict);
			}
			const tmpSavedRecord = await this.pict.services.HeadlightDocumentService.saveDocument();
			this._adoptResolvedRecordIdentities(tmpSavedRecord);
			if (tmpIsServerTransport)
			{
				this._releaseUnappliedRecords(tmpSavedRecord);
			}
		}
		catch (pSaveError)
		{
			// The delta baseline was folded forward before this PUT so it would ride the same payload. The
			// PUT did not land, so it is now claiming records were written that may not have been -
			// discarding it makes the retry project everything whole rather than silently emitting nothing.
			// Nothing was folded on the local transport, so there is nothing to unwind.
			if (tmpIsServerTransport)
			{
				EntityDataBaseline.clearBaseline(this.pict);
			}
			this.pict.log.error('Failed to save document', { error: pSaveError });
			if (!this._MuteNotification)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to save document!',
					type: 'is-danger',
				});
			}
			throw pSaveError;
		}
		if (!this._MuteNotification)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Document saved successfully!',
				type: 'is-success',
			});
		}
		// The document is already persisted by this point, so a failure in the post-save hook is not a save
		// failure and must not be reported as one.
		if (typeof this.pict.PictApplication.onAfterDocumentSave === 'function')
		{
			try
			{
				await this.pict.PictApplication.onAfterDocumentSave();
			}
			catch (pAfterSaveError)
			{
				this.pict.log.error('Document saved, but onAfterDocumentSave failed', { error: pAfterSaveError });
			}
		}
	}

	/**
	 * Adopt the row ids the server resolved for records this save created.
	 *
	 * The form mints GUIDs and the server resolves them to rows; until the ids come back the form
	 * cannot tell a record it created from one it has never saved, and re-asserts every field of it on
	 * every subsequent save. Runs here rather than in the input providers' post-save hook because it has
	 * to land BEFORE those hooks fold the emission into the delta baseline.
	 *
	 * Absent on any path the server does not decorate - bulk writes, offline replay, a form not on the
	 * scoped path - and a save with nothing to resolve. All of those simply keep today's behaviour.
	 *
	 * @param {Record<string, any>} [pSavedRecord] - The document record the save returned.
	 * @return {void}
	 */
	_adoptResolvedRecordIdentities(pSavedRecord)
	{
		const tmpIdentities = pSavedRecord && pSavedRecord.ComprehensionRecordIdentities;
		if (!tmpIdentities || typeof tmpIdentities !== 'object')
		{
			return;
		}
		try
		{
			const tmpAdopted = EntityDataBaseline.applyResolvedIdentities(this.pict, tmpIdentities);
			// Trace, not info: one line per save is noise in normal operation, but the count is the only
			// thing that separates "the save carried no identities" from "it carried some and none matched
			// a held record", which is worth having when a form starts re-emitting records it should not.
			this.pict.log.trace(`DocumentProvider: took ${tmpAdopted} server-resolved record id(s) from the save.`);
		}
		catch (pError)
		{
			this.pict.log.error(`DocumentProvider: could not adopt the server-resolved record ids; the next save may re-assert those records whole: ${pError.message || pError}`);
		}
	}

	/**
	 * Un-baseline the records this save asked for and the server refused, so the next save sends them again.
	 *
	 * The baseline was folded before the PUT and already counts them as written. The save response carries
	 * the document's `EntityData` with the new `ExecutionLog` entry, which is the source of record for what
	 * landed.
	 *
	 * @param {Record<string, any>} [pSavedRecord] - The document record the save returned.
	 * @return {void}
	 */
	_releaseUnappliedRecords(pSavedRecord)
	{
		if (!pSavedRecord || typeof pSavedRecord !== 'object')
		{
			return;
		}
		try
		{
			EntityDataBaseline.releaseUnappliedRecords(this.pict, pSavedRecord.EntityData || pSavedRecord.EntityDataJSON);
		}
		catch (pError)
		{
			this.pict.log.error(`DocumentProvider: could not read which records the save left unapplied; they will not be retried until the document is reopened: ${pError.message || pError}`);
		}
	}

	/**
	 * This function is used to take an approval action on a document.
	 * @param {string} action - The action to take on the document
	 * @return {Promise<void>}
	 * @async
	 * @example
	 * takeApprovalAction('Approve');
	 * takeApprovalAction('Reject');
	 * takeApprovalAction('Submit');
	 */
	async takeApprovalAction(action)
	{
		if (!this.isTakingAction)
		{
			// Latch and lock before the first await — the user needs to know something is happening at
			// click time, not after the save settles. The latch is also what stands auto-save down and
			// stops a second click landing.
			this._setApprovalBusy(true, action);
			let isFormValid = true;

			try
			{
				// An approval action changes (and often locks) the document server-side. Acting while a
				// save is still in flight lets the lock land first, which rejects the resolving save and
				// loses whatever it carried -- the "beat the clock" race. The buttons are disabled for
				// the duration of a save, so reaching this await means something bypassed the UI (an
				// auto-save that started between the click and the handler, a keyboard activation, a
				// programmatic call); wait it out rather than racing it.
				await this.whenSaveSettled();
				// toggle the panel before rendering the new status
				this.pict.views.HeadlightPanels.handlePanelToggle('Status');

				// if the action is to submit the form, we need to check validation before proceeding
				//FIXME: these being hard-coded is no-bueno
				if (action?.toLowerCase() === 'submit' || action?.toLowerCase() === 'approve')
				{
					// if the action is to submit the form, we need to check validation before proceeding
					if (action?.toLowerCase() === 'submit')
					{
						// Await the full save (Document PUT) BEFORE the approval action locks the doc: if the lock
						// lands first the resolving save is rejected and the GUID->id resolution is lost. Abort the
						// submit on save failure rather than lock over unsaved state.
						const tmpSaveError = await this.handleSaveAsync(true);
						if (tmpSaveError)
						{
							this.log.error('Aborting submit: the document save failed', { error: tmpSaveError });
							this.pict.views.HeadlightPanels.toast({
								message: `<strong>Failed to save document; can't submit.</strong><br/><em>${tmpSaveError.message || tmpSaveError}</em>`,
								type: 'is-danger',
							});
							return;
						}
					}
					// All form-validation logic + styling is delegated to the
					// InputValidation provider so it stays consistent with
					// the per-input flows (visibility-aware required sync,
					// correct ancestor traversal via closest(), Select2
					// widget mirroring, data-required hidden-bearer value
					// checks for custom widgets like Signature, aria-invalid
					// sync, etc).
					const formElement = document.getElementById('Headlight-Document-Form');
					const inputValidationProvider = this.pict.providers.InputValidation;
					const hasInputValidationProvider = inputValidationProvider
						&& typeof inputValidationProvider.preSubmitVisibilitySweep === 'function'
						&& typeof inputValidationProvider.applyFormSubmissionStyling === 'function';

					if (formElement && hasInputValidationProvider)
					{
						// Step 1 — sync `required` on every manifest-required
						// input based on current visibility. Hidden-tab
						// fields lose `required`, fields that came back
						// into view get it restored. Keeps the browser's
						// native checkValidity() honest.
						inputValidationProvider.preSubmitVisibilitySweep(formElement);

						// Step 2 — apply styling across the form and let the
						// provider tell us whether anything visible is still
						// in a failing state. Provider handles all the
						// per-input edge cases (Select2 widget mirroring,
						// hidden data-bearer value checks, etc).
						const tmpProviderSaysValid = inputValidationProvider.applyFormSubmissionStyling(formElement);
						const tmpNativeInvalid = formElement instanceof HTMLFormElement && !formElement.checkValidity();

						if (tmpNativeInvalid || !tmpProviderSaysValid)
						{
							formElement.classList.add('show-validation');
							this.pict.views.HeadlightPanels.toast({
								message: 'Form validation failed. Please correct the errors and try again.',
								type: 'is-danger',
							});
							isFormValid = false;
						}
					}
					else if (formElement instanceof HTMLFormElement && !formElement.checkValidity())
					{
						// Fallback when the InputValidation provider isn't
						// available — purely native checks, no styling
						// niceties.
						formElement.classList.add('show-validation');
						this.pict.views.HeadlightPanels.toast({
							message: 'Form validation failed. Please correct the errors and try again.',
							type: 'is-danger',
						});
						isFormValid = false;
					}
				}
				// if the form is verfied as valid (on submission checks), then proceed with the action
				if (isFormValid)
				{
					// remove the validation class from the form
					document.getElementById('Headlight-Document-Form')?.classList.remove('show-validation');
					// send the action to the service to update the document status
					const response = await this.services.HeadlightDocumentService.doApprovalAction(action);
					this.AppData.DocumentData.ReportData.Status = response.Status;
					// TODO: replace reload by getting view rerender to work correctly
					// rerendering the views introduces new bugs
					// reload page to update nav bar and signature section
					this._beginApprovalReload();
				}
			}
			catch (e)
			{
				this.pict.log.error('Failed to change the document status', { error: e });
				// post a note to the user that the action failed
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to change the document status!',
					type: 'is-danger',
				});
			}
			finally
			{
				// A no-op once a reload is committing, so the lock and its toast survive the navigation.
				this._setApprovalBusy(false);
			}
		}
		else
		{
			this.pict.log.warn('Approval action is already in progress.');
		}
	}

	/**
	 * This method is sued to view the document file as a PDF or JSON blob in a new tab.
	 * @param {string} pTarget - The target for the document file
	 * @param {boolean} asRawJSON - Whether to view the document file as raw JSON
	 * @param {number} [passedID] - If an id is passed, view that document file instead.
	 * @return {Promise<Window>}
	 * @example
	 * viewDocumentFile('_blank', false);
	 */
	viewDocumentFile(pTarget, asRawJSON = false, passedID)
	{
		return new Promise((resolve, reject) =>
		{
			const documentId = passedID || this.AppData?.DocumentData?.ReportData?.IDDocument;

			if (!documentId)
			{
				return reject(new Error('Document ID is missing'));
			}

			const extension = asRawJSON ? 'json' : 'pdf';

			try
			{
				const openedWindow = window.open(`${this.options.HeadlightAPIURL}Document/${documentId}/DCR.${extension}`, pTarget || '_blank');
				if (openedWindow)
				{
					return resolve(openedWindow);
				}
				else
				{
					return reject(new Error('Failed to open document'));
				}
			}
			catch (e)
			{
				return reject(e);
			}
		});
	}

	/**
	 * This method is used to get the document record for a specific document id.
	 * @param {any} pIDDocument - The document id to get the record for
	 * @param {Function} [pCallback] - The callback function to call when the document record is retrieved
	 * @return {Promise<Object>}
	 */
	async getDocument(pIDDocument, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Document/${pIDDocument}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Document: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Document: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * This method is used to get the document record for a specific document guid.
	 * @param {any} pGUIDDocument - The document guid to get the record for
	 * @param {Function} pCallback - The callback function to call when the document record is retrieved
	 * @return {Promise<Object>}
	 */
	async getDocumentByGUID(pGUIDDocument, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Documents/By/GUIDDocument/${pGUIDDocument}`,
					(pError, pBody) =>
					{
						if (pError || !pBody.length)
						{
							this.pict.log.error(`Error fetching Document: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody[0]);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody[0]);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Document: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Add a polyjoin for a remote entity to a document (only if it does not already exist).
	 * @param {Number} pIDDocument - The ID of the Document being added to.
	 * @param {Number} pIDRemote - The ID of the RemoteEntity to get Documents for
	 * @param {Number} pRemoteType - The Type of Entity to get Documents for
	 * @param {Function} [pCallback] - The callback function to call when the Documents are fetched
	 * @return {Promise}
	 */
	async addRemoteToDocument(pIDDocument, pIDRemote, pRemoteType, pCallback)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`DocumentPolyJoins/FilteredTo/FBV~IDDocument~EQ~${ pIDDocument }~FBV~IDRemote~EQ~${ pIDRemote }~FBV~RemoteType~EQ~${ pRemoteType }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error joining to document: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
							this.pict.providers.UploadTracking.untrackUpload(uploadID);
						}
						else
						{
							if (pBody.length)
							{
								resolve(true);
								if (pCallback)
								{
									pCallback(true);
								}
								this.pict.providers.UploadTracking.untrackUpload(uploadID);
							}
							else
							{
								this.pict.fable.services.HeadlightRestClient.postJSON('DocumentPolyJoin',
									{
										RemoteType: pRemoteType,
										IDRemote: pIDRemote,
										IDDocument: pIDDocument,
									},
									async (pError, pBody) =>
									{
										if (pError)
										{
											this.pict.log.error(`Error joining to document: `, pError);
											reject(pError);
											// if we have a callback, run it now
											if (pCallback)
											{
												pCallback(null);
											}
										}
										else
										{
											resolve(true);
											if (pCallback)
											{
												pCallback(true);
											}
										}
										this.pict.providers.UploadTracking.untrackUpload(uploadID);
									});
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error joining to document: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
		}
	}

	/**
	 * Get Documents by a DocumentPolyJoin Remote ID
	 * @param {Number} pIDRemote - The ID of the RemoteEntity to get Documents for
	 * @param {Number} pRemoteType - The Type of Entity to get Documents for
	 * @param {Function} [pCallback] - The callback function to call when the Documents are fetched
	 * @return {Promise}
	 */
	async getDocumentsByRemoteID(pIDRemote, pRemoteType, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`DocumentPolyJoins/FilteredTo/FBV~IDRemote~EQ~${ pIDRemote }~FBV~RemoteType~EQ~${ pRemoteType }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Documents: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							if (pBody.length)
							{
								// Batch-fetch every joined Document in ONE request (no Count)
								// instead of one Document/{id} GET per join. This N+1 used to
								// dominate Sample-open time when a sample had many documents.
								const tmpDocumentIDs = pBody.map((pJoin) => pJoin.IDDocument);
								this.pict.fable.services.HeadlightRestClient.getJSON(`Documents/FilteredTo/FBL~IDDocument~INN~${ tmpDocumentIDs.join(',') }/0/${ tmpDocumentIDs.length }`,
									(pDocumentError, pDocumentBody) =>
									{
										if (pDocumentError)
										{
											this.pict.log.error(`Error fetching Documents: `, pDocumentError);
											reject(pDocumentError);
											if (pCallback)
											{
												pCallback(null);
											}
											return;
										}
										// Preserve the CreateDate-DESC order from the join query.
										const tmpDocumentsByID = {};
										for (const tmpDocument of (pDocumentBody || []))
										{
											tmpDocumentsByID[tmpDocument.IDDocument] = tmpDocument;
										}
										const fullDocuments = tmpDocumentIDs.map((pID) => tmpDocumentsByID[pID]).filter((pDocument) => pDocument);
										resolve(fullDocuments);
										if (pCallback)
										{
											pCallback(fullDocuments);
										}
									});
							}
							else
							{
								resolve([]);
								if (pCallback)
								{
									pCallback([]);
								}
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Documents: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the Documents
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	async getDocuments()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Documents';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Documents/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Documents list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Document search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<number>}
	 * @async
	 * @example
	 * getDocumentSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getDocumentSearchCount(pSearchQuery)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `Documents/Count${tmpFilter ? `/${tmpFilter}` : ''}`;

		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
					reject(pError);
				}
				else
				{
					resolve(pBody?.Count || 0);
				}
			});
		});
	}

	/**
	 * Get the Document search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 * getDocumentSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getDocumentSearchResults(pSearchQuery)
	{
		const tmpURL = `Documents/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
					reject(pError);
				}
				if (!Array.isArray(pBody))
				{
					//FIXME: ...
					return resolve([]);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Returns the current time formatted as HH:mm:ss (using dayjs)
	 * @return {string} The current time formatted as HH:mm:ss
	 */
	getDocumentDateCurrentTime()
	{
		return ` ${ this.fable.Dates.dayJS(new Date()).format('HH:mm:ss') }`;
	}

	/**
	 * This method performs an Document search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @return {Promise<{ results: any, count: number }>}
	 * @async
	 */
	async performDocumentSearch(pOptions = {})
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions)
			{
				this.pict.log.error('No search options provided.');
				return reject(new Error('No search options provided.'));
			}

			const tmpSearchQuery = {
				filters: [],
				pagination: {
					start: pOptions?.CurrentPage || 1,
					limit: pOptions?.PageSize || 25,
				},
				sort: {
					field: pOptions.SortBy || 'DocumentDate',
					direction: pOptions.SortDirection || 'DESC',
				},
			};

			// handle the search filters
			if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'Name',
					comparator: 'LK',
					target: pOptions.SearchText,
				});
			}

			// handle the search filters
			if (pOptions?.Status && pOptions.Status?.trim().length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'Status',
					comparator: 'LK',
					target: pOptions.Status,
				});
			}

			if (pOptions?.Projects && pOptions.Projects.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDProject',
					comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
				});
			}

			if (pOptions?.Users && pOptions.Users.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'CreatingIDUser',
					comparator: pOptions.Users.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Users.length === 1 ? pOptions.Users[0] : pOptions.Users,
				});
			}

			if (pOptions?.StartDate && pOptions.StartDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'DocumentDate',
					comparator: 'GE',
					target: pOptions.StartDate,
				});
			}

			if (pOptions?.EndDate && pOptions.EndDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'DocumentDate',
					comparator: 'LE',
					target: pOptions.EndDate,
				});
			}

			// Perform the search by calling both getDocumentSearchCount and getDocumentSearchResults
			Promise.all([
				this.getDocumentSearchCount(tmpSearchQuery),
				this.getDocumentSearchResults(tmpSearchQuery),
			])
				.then(([ tmpCountResults, tmpResults ]) =>
				{
					resolve({ results: tmpResults, count: tmpCountResults });
				})
				.catch((error) =>
				{
					this.log.error('Error during Document search:', error);
					reject(error);
				});
		});
	}

	/**
	 * This method is used to get the document types for a specific Customer.
	 * @param {number} pIDCustomer - The Customer id to get the document types for
	 * @param {Boolean} [excludeContainers] - Exclude "container" type forms from the list. Defaults to false.
	 *  @param {Boolean} [excludeNonManual] - Exclude forms that are not meant to be manually created. Defaults to false.
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 * getReportNamedInstancesByCustomer(1234);
	 */
	async getReportNamedInstancesByCustomer(pIDCustomer, excludeContainers = false, excludeNonManual = false)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('ReportNamedInstance', `FBV~IDCustomer~EQ~${ pIDCustomer }~FSF~Name~ASC~0`, ()=>{}, ()=>{}, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Document Types list.', pError);
					return reject(pError);
				}
				if (excludeContainers)
				{
					const nonContainerForms = [];
					for (const f of pBody)
					{
						if (!f.Options?.Container)
						{
							nonContainerForms.push(f);
						}
					}
					pBody = nonContainerForms;
				}
				if (excludeNonManual)
				{
					const nonManualForms = [];
					for (const f of pBody)
					{
						if (!f.Options?.NoManualCreation)
						{
							nonManualForms.push(f);
						}
					}
					pBody = nonManualForms;
				}
				resolve(pBody.sort((a, b) => 
				{
					if ( a.Name < b.Name ){
						return -1;
					}
					if ( a.Name > b.Name ){
						return 1;
					}
				}));
			});
		});
	}

	async _getReportNamedInstancesByProjectPaged(pIDProject, page)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`ReportNamedInstancesByProject/${ pIDProject }/${ page * 250 }/250`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
					reject(pError);
				}
				if (!Array.isArray(pBody))
				{
					return resolve([]);
				}
				resolve(pBody);
			});
		});
	}

	async getCreatableContainerRNIsByProject(pIDProject)
	{
		const results = await this.getReportNamedInstancesByProject(pIDProject);
		const containerForms = [];
		for (let r of results)
		{
			if (r.Options?.Container && !r.Options?.NoManualCreation)
			{
				containerForms.push(r);
			}
		}
		return containerForms;
	}

	async getReportNamedInstancesByProject(pIDProject, excludeContainers = false, excludeNonManual = false)
	{
		let hitEnd = false;
		let results = [];
		let page = 0;
		while (!hitEnd)
		{
			const pagedResults = await this._getReportNamedInstancesByProjectPaged(pIDProject, page);
			page += 1;
			if (pagedResults?.length < 250)
			{
				hitEnd = true;
			}
			results = results.concat(pagedResults);
		}
		if (excludeContainers)
		{
			const nonContainerForms = [];
			for (const f of results)
			{
				if (!f.Options?.Container)
				{
					nonContainerForms.push(f);
				}
			}
			results = nonContainerForms
		}
		if (excludeNonManual)
		{
			const nonManualForms = [];
			for (const f of results)
			{
				if (!f.Options?.NoManualCreation)
				{
					nonManualForms.push(f);
				}
			}
			results = nonManualForms;
		}
		return results.sort((a, b) => 
		{
			if ( a.Name < b.Name ){
				return -1;
			}
			if ( a.Name > b.Name ){
				return 1;
			}
		});
	}

	/**
	 * This method is used to handle the duplication of a document (a new instance by the clonee user, with all the previous form data carried over).
	 * @param {object} pCustomOptions - The custom options to use when duplicating the document
	 * @param {object} pDocumentObject - The document object to duplicate
	 * @param {Function} pCallback - The callback function to call when the duplication is complete
	 */
	async handleDocumentDuplication(pCustomOptions, pDocumentObject, pCallback)
	{
		if (!pDocumentObject || typeof pDocumentObject !== 'object')
		{
			this.pict.log.error('Document object was not passed.');
			return;
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		// NOTE: This is super confusing, but a legacy thing that we need to work around
		// The document TYPE is stored in the TidingsData.Type field, but we need to find the matching document HASH to set the exact instance for the new document
		const documentRNIHash = pCustomOptions.Type || pDocumentObject?.ReportData?.DocumentType || pDocumentObject?.DocumentType;
		// get the RNIs for the customer
		const customerRNIs = await this.getReportNamedInstancesByCustomer(pDocumentObject?.ReportData?.IDCustomer || pDocumentObject?.IDCustomer);
		// find the matching document type via the project RNIs
		const match = customerRNIs.find((rni) => rni.Hash === documentRNIHash);
		if (!match)
		{
			this.pict.log.error('No matching RNI Hash has been set on this customer!');
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
			return;
		}
		const documentName = pCustomOptions.Name || ( match?.Name || pDocumentObject?.ReportData?.Name || pDocumentObject?.Name ) + ' - Copy';
		// duplicate the document
		const newDocument = {
			IDDocument: 0,
			Version: 0,
			Form: pDocumentObject?.ReportData?.Form || pDocumentObject?.Form,
			Name: documentName,
			DocumentType: match.Hash,
			FormData: pDocumentObject?.ReportData?.FormData || pDocumentObject?.FormData || {},
			IDProject: pDocumentObject?.ReportData?.IDProject || pDocumentObject?.IDProject,
		};
		// if we have a custom document date, set it, otherwise use the current date
		if (pCustomOptions.DocumentDate)
		{
			newDocument.DocumentDate = pCustomOptions.DocumentDate;
		}
		// Stuff our meta data into the document (someday the server will provide this for us so we don't have to do this manually)
		newDocument.FormData.Meta = {
			ClonedFromDocumentType: pDocumentObject?.ReportData?.DocumentType || pDocumentObject?.DocumentType,
			ClonedFromDocumentId: pDocumentObject?.ReportData?.IDDocument || pDocumentObject?.IDDocument,
			ClonedFromGUIDDocument: pDocumentObject?.ReportData?.GUIDDocument || pDocumentObject?.GUIDDocument,
		};
		const tmpURL = 'Document';
		this.pict.HeadlightRestClient.postJSON(tmpURL, newDocument, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to duplicate document.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to duplicate document!',
					type: 'is-danger',
				});
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			}
			else
			{
				this.pict.log.info('Document duplicated successfully.', pBody);
				if (typeof pCallback === 'function')
				{
					pCallback(pBody);
					this.pict.providers.UploadTracking.untrackUpload(uploadID);
				}
			}
		});
	}

	/**
	 * This method is used to handle the deletion of a document.
	 * @param {any} pIDDocument - The document id to delete
	 * @param {Function} pCallback - The callback function to call when the deletion is complete
	 * @return {void}
	 */
	handleDocumentDeletion(pIDDocument, pCallback)
	{
		if (!pIDDocument)
		{
			this.pict.log.error('IDDocument object was not passed.');
			return;
		}
		this.pict.HeadlightRestClient.deleteEntity('Document', pIDDocument, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete document.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete document!',
					type: 'is-danger',
				});
				pCallback(pError);
			}
			else
			{
				this.pict.log.info('Document deleted successfully.', pBody);
				if (typeof pCallback === 'function')
				{
					pCallback(pBody);
				}
			}
		});
	}

	/**
	 * This method is used to handle the creation of a document.
	 * @param {object} pDocument - The document object to create
	 * @param {boolean} pMuteToasts - Whether to mute the toasts
	 * @return {Promise<any>}
	 * @async
	 */
	async createDocument(pDocument, pMuteToasts = false)
	{
		if (!pDocument || typeof pDocument !== 'object')
		{
			this.pict.log.error('Document object was not passed.');
			return;
		}
		// check for required fields
		if (!pDocument?.Name || !pDocument?.DocumentType || !pDocument?.IDProject)
		{
			this.pict.log.error('Document object is missing required fields.');
			return;
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		// create a new document object to send to the server
		const newDocument = {
			IDDocument: 0,
			Version: 0,
			Form: pDocument?.Form,
			Name: pDocument?.Name,
			DocumentType: pDocument?.DocumentType,
			IDProject: pDocument?.IDProject,
		};
		if (pDocument.GUIDDocument)
		{
			newDocument.GUIDDocument = pDocument.GUIDDocument;
		}
		// optional fields
		if (pDocument?.DocumentDate)
		{
			newDocument.DocumentDate = pDocument.DocumentDate;
		}
		if (pDocument?.FormData)
		{
			newDocument.FormData = pDocument.FormData;
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON('Document', pDocument, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to create document.', pError);
					if (!pMuteToasts)
					{
						this.pict.views.HeadlightPanels.toast({
							message: 'Failed to create document!',
							type: 'is-danger',
						});
					}
					this.pict.providers.UploadTracking.untrackUpload(uploadID);
					return reject(pError);
				}
				if (!pMuteToasts)
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'Document created successfully!',
						type: 'is-success',
					});
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
				resolve(pBody);
			});
		});
	}

	setScreenResizeIcon(screenMode)
	{
		const iconElement = document.getElementById('HeadlightPanels-NavBar-FullScreen-Button-Icon');
		const maximizeClass = 'fa-up-right-and-down-left-from-center';
		const minimizeClass = 'fa-down-left-and-up-right-to-center';
		if (iconElement)
		{
			if (screenMode === 'widescreen')
			{
				iconElement.classList.remove(maximizeClass);
				iconElement.classList.add(minimizeClass);
			}
			else
			{
				iconElement.classList.remove(minimizeClass);
				iconElement.classList.add(maximizeClass);
			}
		}
	}

	handleScreenResize(passedID)
	{
		let screenMode = 'standard';
		const alwaysWideScreenModeClass = 'always-widescreen-mode';
		const docElement = passedID ? document.getElementById(passedID) : document.body;
		if (docElement.classList.contains(alwaysWideScreenModeClass))
		{
			screenMode = 'standard';
			docElement.classList.remove(alwaysWideScreenModeClass);
		}
		else
		{
			screenMode = 'widescreen';
			docElement.classList.add(alwaysWideScreenModeClass);
		}
		this.pict.views.HeadlightPaneSettings.updateUserPreferences('ScreenWidth', screenMode);
		this.setScreenResizeIcon(screenMode);
	}

	/**
	 * This method is used to check if an observation is included in the document.
	 * @param {string} pObservationID - The observation ID to check
	 * @return {boolean} - True if the observation is included in the document, false otherwise
	 * @example
	 * isObservationIncludedInDocument('1234');
	 */
	isObservationIncludedInDocument(pObservationID)
	{
		if (!pObservationID)
		{
			this.pict.log.error('No Observation ID provided.');
			return false;
		}
		const tmpObservation = this.AppData?.DocumentData?.ReportData?.Observations?.find((observation) => observation.IDObservation === pObservationID);
		if (tmpObservation)
		{
			return true;
		}
		return false;
	}
}

module.exports = DocumentProvider;
module.exports.default_configuration = { AutoSaveDataWithApp: true, SaveWatchdogTimeoutMS: 120000 };

},{"headlight-dynamic-inputs-bundle/source/providers/_EntityDataBaseline.js":132,"headlight-rest-client":12,"pict-provider":479}],857:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

const libPictProvider = require('pict-provider');

class EntityProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.HasInitialized = false;
		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		// Check to see that the Entiy was passed in with the options object or not
		if (typeof(this.options.Entity) !== 'string')
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity not defined or is not a string in provider options; initializeEntity must be called manually.`);
		}
		else if (this.options.Entity.length === 0)
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity is an empty string in provider options; initializeEntity must be called manually.`);
		}
		else
		{
			this.Entity = this.options.Entity;
			this.HasEntity = true;
		}
	}

	onInitializeAsync(fCallback)
	{
		const tmpAnticipate = this.pict.newAnticipate();

		if (this.HasEntity && this.pict.PictApplication.loggedIn)
		{
			tmpAnticipate.anticipate(this.initializeEntity.bind(this));
		}

		tmpAnticipate.wait(fCallback);
	}

	onBeforeLoadDataAsync(fCallback)
	{
		const tmpAnticipate = this.pict.newAnticipate();

		if (this.HasEntity && this.pict.PictApplication.loggedIn && !this.HasInitialized)
		{
			tmpAnticipate.anticipate(this.initializeEntity.bind(this));
		}

		tmpAnticipate.wait(fCallback);
	}

	setEntity(pEntity)
	{
		if (this.HasEntity)
		{
			this.pict.log.error(`Entity already set to ${this.Entity} so setEntity cannot be called again.`);
			return false;
		}
		if (typeof(pEntity) !== 'string')
		{
			this.pict.log.error(`Entity must be a string when calling setEntity.`);
			return false;
		}
		if (pEntity.length === 0)
		{
			this.pict.log.error(`Entity must be a non-empty string when calling setEntity.`);
			return false;
		}

		this.Entity = pEntity;
		this.HasEntity = true;
		return true;
	}

	initializeEntity(fCallback)
	{
		if (!this.HasEntity)
		{
			this.pict.log.error(`Entity not set so initializeEntity cannot be called.`);
			return fCallback('Entity not set so initializeEntity cannot be called.');
		}
		if (this.HasInitialized)
		{
			this.pict.log.error(`Entity already initialized so initializeEntity cannot be called again.`);
			return fCallback('Entity already initialized so initializeEntity cannot be called again.');
		}

		const tmpAnticipate = this.pict.newAnticipate();

		tmpAnticipate.anticipate(this.loadSchema.bind(this));

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error initializing Entity [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Entity [${this.Entity}] successfully initialized.`);
					this.HasInitialized = true;
				}
				return fCallback(pError);
			});
	}


	loadSchema(fCallback)
	{
		const tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () =>
		{};
		return tmpCallback();
		// TODO: Why does this take 100ms per schema; these should be instant...
		// let tmpAnticipate = this.pict.newAnticipate();

		// tmpAnticipate.anticipate(
		// 	(fRequestCallback) =>
		// 	{
		// 		return this.pict.HeadlightRestClient.getJSON(`${this.Entity}/Schema`,
		// 			(pError, pResponse) =>
		// 			{
		// 				if (pError)
		// 				{
		// 					this.pict.log.error(`Error loading schema for Entity [${this.Entity}]: ${pError}`);
		// 				}
		// 				else
		// 				{
		// 					this.EntitySchema = pResponse;
		// 					this.pict.log.info(`Schema successfully loaded by provider for Entity [${this.Entity}]`);
		// 				}
		// 				return fRequestCallback(pError);
		// 			}
		// 		);
		// 	});

		// tmpAnticipate.wait(
		// 	function(pError)
		// 	{
		// 		if (pError)
		// 		{
		// 			this.pict.log.error(`Error loading schema for Entity [${this.Entity}]: ${pError}`);
		// 		}
		// 		else
		// 		{
		// 			this.pict.log.info(`Schema successfully loaded by provider for Entity [${this.Entity}]`);
		// 		}
		// 		return tmpCallback(pError);
		// 	});
	}


	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecords(fCallback, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Default to 0 for the cursor start
		const tmpRecordCursorStart = (typeof(pRecordCursorStart) === 'number') ? pRecordCursorStart : 0;
		// Default to 100 records
		const tmpRecordCount = (typeof(pRecordCount) === 'number') ? pRecordCount : 100;
		// Default to no meadow filter
		const tmpMeadowFilter = (typeof(pMeadowFilter) === 'string') ? pMeadowFilter : false;

		// Construct the URI
		let tmpURI = `${this.Entity}s`;
		if (tmpMeadowFilter)
		{
			tmpURI += `/${tmpMeadowFilter}`;
		}
		tmpURI += `/${tmpRecordCursorStart}/${tmpRecordCount}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		if (this.Entity == 'BridgeRawData')
		{
			tmpAnticipate.anticipate((fRequestCallback) =>
			{
				tmpRequestResponse.Response =
				tmpRequestResponse.Response.map((record) =>
				{
					return {
						...record,
						'Record': JSON.parse(record['Record']),
					};
				});

				return fRequestCallback();
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Loaded ${tmpRequestResponse.Response.length} records loaded for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordsToAddress(fCallback, pAddress, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		return this.loadRecords(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pMeadowFilter, pRecordCursorStart, pRecordCount);
	}


	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecordByID(fCallback, pIDEntity)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		if (typeof(pIDEntity) == 'undefined')
		{
			this.pict.log.error(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
			return fCallback(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		let tmpURI = `${this.Entity}`;
		// TODO: Guards on the data type?  We want to at least support string and number but maybe function?  aaah.
		tmpURI += `/${pIDEntity}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		if (this.Entity == 'BridgeRawData')
		{
			tmpAnticipate.anticipate(
				(fRequestCallback) =>
				{
					return this.pict.HeadlightRestClient.getJSON(tmpURI,
						(pError, pResponse) =>
						{
							tmpRequestResponse.Response = {
								...pResponse,
								'Record': JSON.parse(pResponse['Record']),
							};

							return fRequestCallback(pError);
						});
				});
		}

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading record for [${this.Entity}] by ID ${pIDEntity} URI [${tmpURI}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Record loaded for [${this.Entity}] by ID ${pIDEntity}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordByIDToAddress(fCallback, pAddress, pIDEntity)
	{
		return this.loadRecordByID(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pIDEntity);
	}


	upsertRecord(fCallback, pRecord)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}
		if (typeof(pRecord) != 'object')
		{
			this.pict.log.error(`Record must be an object when calling upsertRecord.`);
			return fCallback(`Record must be an object when calling upsertRecord.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		const tmpURI = `${this.Entity}/Upsert`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.putJSON(tmpURI, pRecord,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error Upserting record for [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.error(`Record upserted for [${this.Entity}].`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	upsertRecordToAddress(fCallback, pAddress, pRecord)
	{
		return this.upsertRecord(
			(pUpsertError, pRecords) =>
			{
				if (pUpsertError)
				{
					this.pict.log.error(`Error upserting record for [${this.Entity}] to address ${pAddress}: ${pUpsertError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pUpsertError, pRecords);
			}, pRecord);
	}


	// generateEmptyRecord(fCallback)
	// {
	// 	if (!this.HasInitialized)
	// 	{
	// 		this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
	// 		return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
	// 	}

	// 	let tmpAnticipate = this.pict.newAnticipate();

	// 	// Construct the URI
	// 	let tmpURI = `${this.Entity}/Schema/New`;

	// 	// Create a container object for the request (we may tack more onto this for other types of requests)
	// 	let tmpRequestResponse = {};

	// 	tmpAnticipate.anticipate(
	// 		(fRequestCallback) =>
	// 		{
	// 			return this.pict.HeadlightRestClient.getJSON(tmpURI,
	// 				(pError, pResponse) =>
	// 				{
	// 					tmpRequestResponse.Response = pResponse;
	// 					return fRequestCallback(pError);
	// 				});
	// 		});

	// 	tmpAnticipate.anticipate(
	// 		(fCleanupCallback) =>
	// 		{
	// 			if (typeof(tmpRequestResponse.Response) !== 'object')
	// 			{
	// 				this.pict.log.error(`Empty record prototype for [${this.Entity}] URI [${tmpURI}] is not an object.`);
	// 				return fCleanupCallback(`Empty record prototype for [${this.Entity}] URI [${tmpURI}] is not an object.`);
	// 			}
	// 			// Delete the Identifier columns if they are in the schema for the record, so this can be used as a clean prototype for a new record
	// 			if (`ID${this.Entity}` in tmpRequestResponse.Response)
	// 			{
	// 				delete tmpRequestResponse.Response[`ID${this.Entity}`];
	// 			}
	// 			if (`GUID${this.Entity}` in tmpRequestResponse.Response)
	// 			{
	// 				delete tmpRequestResponse.Response[`GUID${this.Entity}`];
	// 			}
	// 			return fCleanupCallback();
	// 		});

	// 	return tmpAnticipate.wait(
	// 		function(pError)
	// 		{
	// 			if (pError)
	// 			{
	// 				this.pict.log.error(`Error generating new record prototype for [${this.Entity}] URI [${tmpURI}]: ${pError}`);
	// 			}
	// 			else
	// 			{
	// 				this.pict.log.error(`Record prototype generated for [${this.Entity}].`);
	// 			}
	// 			return fCallback(pError, tmpRequestResponse.Response);
	// 		}
	// 	);
	// }
}

module.exports = EntityProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'InterimEntityProvider',
	});

},{"pict-provider":479}],858:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

const CustomCacheConfig =
{
	Customer: { Record: { maxAge: 60 * 60 * 24 * 1000, maxLength: 1 }, List: { maxAge: 60 * 60 * 24 * 1000, maxLength: 100 } },
	Material: { Record: { maxAge: 30 * 1000 }, List: { maxAge: 30 * 1000 } },
	LineItem: { Record: { maxAge: 30 * 1000 }, List: { maxAge: 30 * 1000 } },
	Sample: { Record: { maxAge: 30 * 1000 }, List: { maxAge: 30 * 1000 } },
};

class EntityCacheConfigurationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	onInitialize()
	{
		for (const [ entity, optionTypes ] of Object.entries(CustomCacheConfig))
		{
			this.pict.EntityProvider.initializeCache(entity);
			if (optionTypes.Record)
			{
				if (optionTypes.Record.maxAge)
				{
					this.pict.EntityProvider.recordCache[entity].maxAge = optionTypes.Record.maxAge;
				}
				if (optionTypes.Record.maxLength)
				{
					this.pict.EntityProvider.recordCache[entity].maxLength = optionTypes.Record.maxLength;
				}
			}
			if (optionTypes.List)
			{
				if (optionTypes.List.maxAge)
				{
					this.pict.EntityProvider.recordSetCache[entity].maxAge = optionTypes.List.maxAge;
				}
				if (optionTypes.List.maxLength)
				{
					this.pict.EntityProvider.recordSetCache[entity].maxLength = optionTypes.List.maxLength;
				}
			}
		}
		return super.onInitialize();
	}
}

module.exports = EntityCacheConfigurationProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],859:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/**
 * Show/Hide fields config example:
 * FieldDisplaySets:
 * {
 * 		"Default":
 * 		{
 * 			"Sample":
 * 			{
 * 				"Hide": ["IDLineItem", "Station", "Offset"],
 * 				"Show": ["Name", "QRCode", "IDMaterial"]
 * 			}
 * 		},
 * 		"List":
 * 		{
 * 			"Sample":
 * 			{
 * 				"Show": ["Name", "QRCode", "IDMaterial"]
 * 			}
 * 		},
 * 		"Edit":
 * 		{
 * 		},
 * 		"Create":
 * 		{
 * 		},
 * 		"Read":
 * 		{
 * 		},
 * }
 */

class FieldSettingsProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
        this.fieldNamespaces = {};
	}

	/**
	 * Registers a set of fields with a namespace.
	 * For each field, creates a settings object with default values.
	 * Currently the only settings field is "hide" but more can be added as needed.
	 * @param {String} name
	 * @param {Array<String>} fields
	 */
	registerNamespace(name, fields)
	{
		this.fieldNamespaces[name] = { };
		for (const f of fields)
		{
			this.fieldNamespaces[name][f] =
			{
				hide: false,
			};
		}
	}

	/**
	 * Registers a namespace using a schema to derive fields.
	 * @param {String} name
	 * @param {Object} schema
	 */
	registerNamespaceBySchema(name, schema)
	{
		this.registerNamespace(name, Object.keys(schema.properties));
	}

	/**
	 * Registers a namespace by looking up an entity name to pull the schema and generate the field list.
	 * @param {String} name - namespace being used for the field set.
	 * @param {String} entity - the entity we are getting the fields for.
	 * @param {String} [viewType] - the type of view (List/Edit/Read/Create). If not provided we will only use default config.
	 * @param {Boolean} [defaultToShow] - Should fields default to showing? I.e. do we use the "hide specific fields" config vs. the "only show these specific fields" config.
	 * @param {Array<string>} [defaultFields] - A default set of fields to show. Only applicable if defaultToShow is false.
	 */
	async registerNamespaceByEntity(name, entity, viewType, defaultToShow = true, defaultFields = [ 'Name' ])
	{
		try
		{
			const schema = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`${ entity }/Schema`, (error, result) =>
				{
					if (error)
					{
						reject(error);
					}
					else
					{
						resolve(result);
					}
				});
			});

			const config = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Configuration/For/FieldDisplaySets`, (error, result) =>
				{
					if (error)
					{
						reject(error);
					}
					else
					{
						resolve(result);
					}
				});
			});

			const fields = Object.keys(schema.properties);

			this.registerNamespace(name, fields);

			const configFields = defaultToShow ?
								(config?.[viewType || 'Default']?.[entity]?.['Hide'] || config?.['Default']?.[entity]?.['Hide'] || []) :
								(config?.[viewType || 'Default']?.[entity]?.['Show'] || config?.['Default']?.[entity]?.['Show'] || []);
			if (defaultToShow)
			{
				// If fields should default to shown, just hide the ones in the "Hide" config.
				this.hideFields(name, configFields);
			}
			else
			{
				// Otherwise, hide all the fields not in the "Show" config. If nothing is specified in the show config then default to only showing the name.
				if (!configFields.length)
				{
					this.hideFields(name, fields.filter((f) =>
					{
						return !defaultFields.includes(f);
					}));
				}
				else
				{
					this.hideFields(name, fields.filter((f) =>
					{
						return !configFields.includes(f);
					}));
				}
			}
		}
		catch (e)
		{
			this.pict.log.error(`Failed to get the field information for ${ entity }: `, e);
		}
	}

	/**
	 * Checks if a namespace has already been instantiated.
	 * @param {String} name
	 * @return {Boolean}
	 */
	checkNamespace(name)
	{
		return this.fieldNamespaces[name] ? true : false;
	}

	/**
	 * Sets the hide setting to true for the specified fields in the given namespace.
	 * @param {String} name
	 * @param {Array<String>} fields
	 */
	hideFields(name, fields)
	{
		this.fieldNamespaces[name] = this.fieldNamespaces[name] || {};
		for (const f of fields)
		{
			this.fieldNamespaces[name][f] = this.fieldNamespaces[name][f] || {};
			this.fieldNamespaces[name][f].hide = true;
		}
	}

	/**
	 * Sets the hide setting to false for the specified fields in the given namespace.
	 * @param {String} name
	 * @param {Array<String>} fields
	 */
	unhideFields(name, fields)
	{
		this.fieldNamespaces[name] = this.fieldNamespaces[name] || {};
		for (const f of fields)
		{
			this.fieldNamespaces[name][f] = this.fieldNamespaces[name][f] || {};
			this.fieldNamespaces[name][f].hide = false;
		}
	}

	/**
	 * Sets the hide setting to true for one field in the given namespace.
	 * @param {String} name
	 * @param {String} field
	 */
	hideField(name, field)
	{
		this.hideFields(name, [ field ]);
	}

	/**
	 * Sets the hide setting to false for one field in the given namespace.
	 * @param {String} name
	 * @param {String} field
	 */
	unhideField(name, field)
	{
		this.unhideFields(name, [ field ]);
	}

	/**
	 * Returns if a field within a namespace is hidden or not.
	 * @param {String} name
	 * @param {String} field
	 * @return {Boolean}
	 */
	isHidden(name, field)
	{
		return this.fieldNamespaces?.[name]?.[field]?.hide || false;
	}

	/**
	 * Returns the set of fields that are not hidden for a namespace.
	 * @param {String} name
	 * @return {Array<String>}
	 */
	getShownFields(name)
	{
		return this.fieldNamespaces?.[name] ?
			Object.keys(this.fieldNamespaces[name]).filter((field) =>
			{
				return !this.isHidden(name, field);
			}) : [];
	}

	/**
	 * Returns the set of fields that are hidden for a namespace.
	 * @param {String} name
	 * @return {Array<String>}
	 */
	getHiddenFields(name)
	{
		return this.fieldNamespaces?.[name] ?
			Object.keys(this.fieldNamespaces[name]).filter((field) =>
			{
				return this.isHidden(name, field);
			}) : [];
	}
}

module.exports = FieldSettingsProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],860:[function(require,module,exports){

class FileHandle
{
	/**
	 * @param {Object} pFileInfo - File metadata.
	 * @param {FileHandle} [pParent] - (optional) Parent file handle.
	 */
	constructor(pFileInfo, pParent)
	{
		this._FileInfo = pFileInfo || { };
		this._Parent = pParent || null;
	}

	get name()
	{
		return this._FileInfo.Name;
	}

	get type()
	{
		return this._FileInfo.Type;
	}

	get subType()
	{
		return this._FileInfo.SubType || '';
	}

	get path()
	{
		return this._FileInfo.Path;
	}

	get isFolder()
	{
		return this._FileInfo.IsFolder;
	}

	get index()
	{
		return this._FileInfo.Index || 0;
	}

	get parent()
	{
		return this._Parent;
	}

	get observation()
	{
		return this._FileInfo.Observation;
	}
}

module.exports = FileHandle;
module.exports.default_configuration = {};

},{}],861:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/** @typedef {import('./FileHandle.js')} FileHandle */
/** @typedef {Symbol} NavClass */
/**
 * Enum for navigation classes.
 *
 * @readonly
 * @enum {NavClass}
 *
 * @property {NavClass} SIMPLE - non-navigable - ex. a single image
 * @property {NavClass} LINEAR - Linear navigation, ex. pages in a PDF or word document
 * @property {NavClass} UNKNOWN - unknown (or unsupported) file type
 */
const NavClass = Object.freeze(
	{
		SIMPLE: Symbol('simple'),
		LINEAR: Symbol('linear'),
		UNKNOWN: Symbol('unknown'),
	});

/**
 * Flow:
 *
 * 1. Navigate (ex. to a page)
 * 2. Extract (ex. a rectangle)
 * Result: a canvas with the rasterized subimage?
 */
class FileNavigatorProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON PUT request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON POST request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _post(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON DELETE request.
	 *
	 * @param {string} entityType - The entity type to delete.
	 * @param {number} entityID - The entity ID to delete.
	 * @return {Promise<any>} - The response.
	 */
	async _del(entityType, entityID)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.deleteEntity(entityType, entityID, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {FileHandle} pFileHandle
	 * @return {NavClass}
	 */
	getFileNavClass(pFileHandle)
	{
		if (pFileHandle.type === 'application/pdf')
		{
			return NavClass.LINEAR;
		}
		return NavClass.UNKNOWN;
	}

	/**
	 * @typedef {Object} FileHandleInfo
	 * @property {Array<FileHandle>} items
	 */

	/**
	 * @typedef {Object} NavParams
	 * TODO: define what this supports...
	 */

	/**
	 * Used to explore the file. List pages, preview them, etc.
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {Object} pNavParams
	 * @return {Promise<FileHandleInfo>}
	 */
	async navigateFile(pFileHandle, pNavParams)
	{
		const navClass = this.getFileNavClass(pFileHandle);
		if (navClass !== NavClass.LINEAR)
		{
			throw new Error(`Unsupported navigation class: ${navClass.toString()}`);
		}
		return await this._navigateFileLinear(pFileHandle, pNavParams);
	}

	/**
	 * Used to explore the file. List pages, preview them, etc. For linear navigation file types.
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {NavParams} pNavParams
	 * @return {Promise<FileHandleInfo>}
	 */
	async _navigateFileLinear(pFileHandle, pNavParams)
	{
		if (pFileHandle.type !== 'application/pdf')
		{
			throw new Error(`Unsupported file type: ${pFileHandle.type}`);
		}
		const nav =
		{
			items:
			[
			],
		};
		return nav;
	}

	/**
	 * Extract an item from a file.
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {Object} pExtractParams - Provide { canvas, scale, index }. Canvas will be resized to the desired dimensions. Scale is the zoom factor.
	 * NOTE: index in specific to linear navigation. will rev this doc eventually
	 * @return {Promise<string>} URL for the extracted item
	 */
	async extract(pFileHandle, pExtractParams)
	{
		if (pFileHandle.subType !== 'page')
		{
			throw new Error(`Unsupported file type for extract: ${pFileHandle.type}`);
		}
		const observationID = pFileHandle.observation?.IDObservation;
		if (!observationID)
		{
			throw new Error('No observation ID for source file');
		}
		const extractParamsString = Object.entries(pExtractParams).map(([ key, value ]) => `${key}:${encodeURIComponent(value)}`).join(';');
		return `Observation/${observationID}/Extract/${encodeURIComponent(extractParamsString)}`;
	}

	/**
	 * Extract items from a file. Useful for doing a page preview
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {Object} pExtractParams - Provide { items, scale }. Canvas will be resized to the desired dimensions. Scale is the zoom factor.
	 * @return {Promise<Array<string>>}
	 */
	async bulkExtract(pFileHandle, pExtractParams)
	{
		const result = [];
		for (const item of pExtractParams.items)
		{
			//FIXME: probably too slow like this...
			//FIXME: this assumes each page has the same paramemeters...
			result.push(await this.extract(item, pExtractParams));
		}
		return result;
	}

	/**
	 * Extract a subimage from a file and clone it to a new image observation.
	 *
	 * @param {FileHandle} pFileHandle The source observation.
	 * @param {Object} pExtractParams The extract parameters: { Page: number, Bounds: { } } (bounds from openseadragon)
	 */
	async cloneExtract(pFileHandle, pExtractParams)
	{
		if (pFileHandle.subType !== 'page')
		{
			throw new Error(`Unsupported file type for extract: ${pFileHandle.type}`);
		}
		const observationID = pFileHandle.observation?.IDObservation;
		if (!observationID)
		{
			throw new Error('No observation ID for source file');
		}
		await this._post(`Observation/${observationID}/Extract/Clone`, pExtractParams);
	}
}

module.exports = FileNavigatorProvider;
module.exports.NavClass = NavClass;
module.exports.default_configuration = {};

},{"headlight-rest-client":12,"pict-provider":479}],862:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/**
 * Provider for looking up Form-Conversion ManifestSchemas associated with a
 * ReportNamedInstance via the ReportNamedInstanceManifestSchemaJoin table.
 *
 * @class FormConversionProvider
 * @extends PictProvider
 */
class FormConversionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/**
		 * Cached Form-Conversion schemas keyed by IDReportNamedInstance.
		 * @type {Object.<number, Array>}
		 */
		this._SchemaCache = {};
	}

	/**
	 * Get Form-Conversion ManifestSchemas for a ReportNamedInstance.
	 *
	 * 1. Queries ReportNamedInstanceManifestSchemaJoins filtered by IDReportNamedInstance
	 * 2. Collects IDManifestSchema values from the join records
	 * 3. Batch-fetches ManifestSchemas with FBL~IDManifestSchema~INN~{ids}~FBV~Type~EQ~Form-Conversion
	 *
	 * @param {number} pIDReportNamedInstance
	 * @returns {Promise<Array>} Array of ManifestSchema records with Type = 'Form-Conversion'
	 */
	async getFormConversionSchemas(pIDReportNamedInstance)
	{
		if (!pIDReportNamedInstance)
		{
			return [];
		}

		// Check cache first
		if (this._SchemaCache[pIDReportNamedInstance])
		{
			return this._SchemaCache[pIDReportNamedInstance];
		}

		// Step 1: Get join records
		const tmpJoinRecords = await new Promise((pResolve, pReject) =>
		{
			this.fable.HeadlightRestClient.getJSON(
				`ReportNamedInstanceManifestSchemaJoins/FilteredTo/FBV~IDReportNamedInstance~EQ~${pIDReportNamedInstance}/0/100`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.error('Error fetching ReportNamedInstanceManifestSchemaJoins:', pError);
						return pReject(pError);
					}
					return pResolve(pBody || []);
				});
		});

		if (!tmpJoinRecords.length)
		{
			this._SchemaCache[pIDReportNamedInstance] = [];
			return [];
		}

		// Step 2: Collect ManifestSchema IDs
		const tmpManifestSchemaIDs = tmpJoinRecords
			.map((pJoin) => pJoin.IDManifestSchema)
			.filter((pID) => pID && pID > 0);

		if (!tmpManifestSchemaIDs.length)
		{
			this._SchemaCache[pIDReportNamedInstance] = [];
			return [];
		}

		// Step 3: Batch-fetch ManifestSchemas filtered to Form-Conversion type
		const tmpIDList = tmpManifestSchemaIDs.join(',');
		const tmpSchemas = await new Promise((pResolve, pReject) =>
		{
			this.fable.HeadlightRestClient.getJSON(
				`ManifestSchemas/FilteredTo/FBL~IDManifestSchema~INN~${tmpIDList}~FBV~Type~EQ~Form-Conversion/0/100`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.error('Error fetching ManifestSchemas for Form-Conversion:', pError);
						return pReject(pError);
					}
					return pResolve(pBody || []);
				});
		});

		// Enrich schemas with file type info from their template Artifacts
		const tmpArtifactIDs = tmpSchemas
			.map((pSchema) => pSchema.IDArtifact)
			.filter((pID) => pID && pID > 0);

		if (tmpArtifactIDs.length > 0)
		{
			const tmpArtifactIDList = [...new Set(tmpArtifactIDs)].join(',');
			const tmpArtifacts = await new Promise((pResolve, pReject) =>
			{
				this.fable.HeadlightRestClient.getJSON(
					`Artifacts/FilteredTo/FBL~IDArtifact~INN~${tmpArtifactIDList}/0/100`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.log.warn('Error fetching Artifacts for Form-Conversion schemas:', pError);
							return pResolve([]);
						}
						return pResolve(pBody || []);
					});
			});

			// Build a lookup map by IDArtifact
			const tmpArtifactMap = {};
			for (const tmpArtifact of tmpArtifacts)
			{
				tmpArtifactMap[tmpArtifact.IDArtifact] = tmpArtifact;
			}

			// Resolve file type for each schema from its Artifact
			for (const tmpSchema of tmpSchemas)
			{
				const tmpArtifact = tmpArtifactMap[tmpSchema.IDArtifact];
				if (tmpArtifact)
				{
					let tmpDatum = tmpArtifact.Datum;
					if (typeof tmpDatum === 'string')
					{
						try { tmpDatum = JSON.parse(tmpDatum); }
						catch (pErr) { tmpDatum = {}; }
					}

					// Resolve mime type from Datum.FileMimeType, with fallback to FileName extension
					let tmpMimeType = tmpDatum?.FileMimeType || '';
					if (!tmpMimeType && tmpDatum?.FileName)
					{
						const tmpExtMatch = tmpDatum.FileName.match(/\.([^.]+)$/);
						const tmpExt = tmpExtMatch ? tmpExtMatch[1].toLowerCase() : '';
						if (tmpExt === 'pdf') { tmpMimeType = 'application/pdf'; }
						else if (tmpExt === 'xlsx') { tmpMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; }
						else if (tmpExt === 'xls') { tmpMimeType = 'application/vnd.ms-excel'; }
					}

					tmpSchema.TemplateMimeType = tmpMimeType;
				}
			}
		}

		this._SchemaCache[pIDReportNamedInstance] = tmpSchemas;
		return tmpSchemas;
	}

	/**
	 * Resolve the IDReportNamedInstance from a DocumentType hash and IDProject,
	 * then load associated Form-Conversion schemas.
	 *
	 * Uses the ReportNamedInstancesByProject endpoint to find the matching RNI,
	 * then delegates to getFormConversionSchemas().
	 *
	 * @param {string} pDocumentType - The DocumentType hash (e.g. 'MI-CAG-Walbec')
	 * @param {number} pIDProject - The project ID (from ReportData.IDProject)
	 * @returns {Promise<Array>} Array of ManifestSchema records with Title for display
	 */
	async getFormConversionSchemasForDocument(pDocumentType, pIDProject)
	{
		if (!pDocumentType || !pIDProject)
		{
			return [];
		}

		// Look up RNIs for this project
		const tmpRNIs = await new Promise((pResolve, pReject) =>
		{
			this.fable.HeadlightRestClient.getJSON(
				`ReportNamedInstancesByProject/${pIDProject}/0/250`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.error('Error fetching ReportNamedInstances for project:', pError);
						return pReject(pError);
					}
					return pResolve(pBody || []);
				});
		});

		// Find the RNI matching the document type hash
		const tmpMatchingRNI = tmpRNIs.find((pRNI) => pRNI.Hash === pDocumentType);
		if (!tmpMatchingRNI)
		{
			this.log.warn(`No ReportNamedInstance found with Hash '${pDocumentType}' for project ${pIDProject}`);
			return [];
		}

		return this.getFormConversionSchemas(tmpMatchingRNI.IDReportNamedInstance);
	}
}

module.exports = FormConversionProvider;

},{"pict-provider":479}],863:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class GeoProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Function to get user's geocoordinates from the browser. Returns null if it cannot get them.
	 * @return {Promise<Object|null>}
	 */
	async getGeoCoords()
	{
		// Attempt to fetch a location from the native app.
		try
		{
			const coords = await this.fable.NativeBridge.getLocation();
			return {
				CaptureLatitude: coords.Latitude,
				CaptureLongitude: coords.Longitude,
				Latitude: coords.Latitude,
				Longitude: coords.Longitude,
			};
		}
		catch (error)
		{
			console.log('No native location method available: ', error);
		}

		// Check for a passed location from the native app if available.
		if (typeof window.Mixins.deviceGeolocation === 'object')
		{
			return {
				CaptureLatitude: window.Mixins.deviceGeolocation.Latitude || window.Mixins.deviceGeolocation.latitude,
				CaptureLongitude: window.Mixins.deviceGeolocation.Longitude || window.Mixins.deviceGeolocation.longitude,
				Latitude: window.Mixins.deviceGeolocation.Latitude || window.Mixins.deviceGeolocation.latitude,
				Longitude: window.Mixins.deviceGeolocation.Longitude || window.Mixins.deviceGeolocation.longitude,
			};
		}

		return await new Promise((resolve, reject) =>
		{
			window.navigator.geolocation.getCurrentPosition(
				(position) =>
				{
					resolve({
						CaptureLatitude: position.coords.latitude,
						CaptureLongitude: position.coords.longitude,
						Latitude: position.coords.latitude,
						Longitude: position.coords.longitude,
					});
				},
				() =>
				{
					this.pict.log.info('Couldn\'t get geolocation, returning null...');
					resolve(null);
				},
				{
					maximumAge: 12*60*60*1000,
				},
			);
		});
	}
}

module.exports = GeoProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],864:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

const FileHandle = require('./FileHandle.js');

class ImportantFilesProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {string|number} pIDProject - The project ID.
	 * @param {string} pPath - The path to the directory to list.
	 * @return {Promise<FileHandle[]>}
	 */
	async listFiles(pIDProject, pPath = '/')
	{
		const files = await this._get(`ImportantProjectFiles/${pIDProject}${pPath}`);
		const result = [];
		for (const folder of files.Folders)
		{
			result.push(new FileHandle({ Name: folder.Name, IsFolder: true, Path: `${pPath}/${folder.Name}` }));
		}
		for (const file of files.Files)
		{
			//TODO: populate the file type, etc. - can we tell from the observation? maybe the artifact datum?
			//FIXME: populate `Parent` when we start populating that as part of the artifact extraction adventure
			//       probably create a factory or something so we can centralize building this for file handles
			result.push(new FileHandle({ Name: file.Name, Path: `${pPath}/${file.Name}`, IsFolder: false, Observation: file.Observation }));
		}
		return result;
	}

	/**
	 * @param {FileHandle} pFileHandle - The file to get the URL for.
	 * @return {string} - The URI.
	 */
	getDownloadURI(pFileHandle)
	{
		if (!pFileHandle.observation)
		{
			throw new Error(`Cannot provide a URL for a file that isn't an observation.`);
		}
		return `/1.0/ImportantProjectFile/${pFileHandle.observation.IDProject}/${pFileHandle.path}`;
	}
}

module.exports = ImportantFilesProvider;
module.exports.default_configuration = {};

},{"./FileHandle.js":860,"headlight-rest-client":12,"pict-provider":479}],865:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ImprovedTabularRecordSetProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.options = pOptions;
		this.renderOverriden = false;
	}

	prepareTable()
	{
		const activeRecordSet = this.pict.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet || '';
		const isDocumentRecord = activeRecordSet === 'Document';
		// override table display logic
		if (!this.renderOverriden)
		{
			const beforeRenderStubList = this.pict.views['PRSP-List-RecordList'].onBeforeRender.bind(this.pict.views['PRSP-List-RecordList']); ;
			this.pict.views['PRSP-List-RecordList'].onBeforeRender =
			function(callback, renderable)
			{
				this.pict.providers.ImprovedTabularRecordSetProvider.prepareTable();
				beforeRenderStubList(callback, renderable);
			};
			const beforeRenderStubDashboard = this.pict.views['PRSP-Dashboard-RecordList'].onBeforeRender.bind(this.pict.views['PRSP-Dashboard-RecordList']); ;
			this.pict.views['PRSP-Dashboard-RecordList'].onBeforeRender =
			function(callback, renderable)
			{
				this.pict.providers.ImprovedTabularRecordSetProvider.prepareTable();
				beforeRenderStubDashboard(callback, renderable);
			};
			// Permission-expression layer (Phase 2b): gate the record read-view Edit/Save buttons by
			// can(entity,'Update'). The read view shows the Edit button via getElementById after render
			// (RecordSet-Read.js), so removing it from the DOM would null-crash those calls — instead a body
			// class + !important CSS (below) hides it while it stays in the DOM. renderRead is the definitive
			// per-record-page method; wrapping it sets the body class from the active route each time.
			const tmpReadView = this.pict.views['RSP-RecordSet-Read'];
			if (tmpReadView && typeof tmpReadView.renderRead === 'function' && !tmpReadView._pcfgEditGateInstalled)
			{
				const tmpOriginalRenderRead = tmpReadView.renderRead.bind(tmpReadView);
				tmpReadView.renderRead = async function(...pRenderArgs)
				{
					const tmpRenderResult = await tmpOriginalRenderRead(...pRenderArgs);
					try { _Pict.providers.ImprovedTabularRecordSetProvider.applyReadEditGate(); }
					catch (pGateError) { /* non-fatal: gating is a UI hint, the server stays authoritative */ }
					return tmpRenderResult;
				};
				tmpReadView._pcfgEditGateInstalled = true;
			}
			this.renderOverriden = true;
			if (this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
			{
				// Neutral list "New" button (see PRSP-List-Title-Template below); brand-coloured on hover/focus.
				this.pict.CSSMap.addCSS('ImprovedTabularRecordSet-ListNew-CSS', /*css*/`
					.button.prsp-list-new { background: transparent; border-color: var(--theme-color-border-default, #d7dce3); color: var(--theme-color-text-muted, #6b7686); transition: color 0.12s ease, border-color 0.12s ease; }
					.button.prsp-list-new:hover, .button.prsp-list-new:focus { background: transparent; border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); box-shadow: none; }
					/* Permission-expression layer: hide the record Edit/Save buttons when the current user can't update the active entity. */
					body.pcfg-cannot-update-record #PRSP-Read-EditButton, body.pcfg-cannot-update-record #PRSP-Read-SaveButton { display: none !important; }
				`, 500);
				this.pict.CSSMap.injectCSS();
			}
		}
		if (this.options?.overrideURLTemplate)
		{
			this.pict.TemplateProvider.addTemplate('PRSP-Read-Link-URL-Template', this.options.overrideURLTemplate);
		}
		// List "New" action. createFromActiveList() reads the live #/PSRS/<RecordSet>/List hash at CLICK time and
		// routes to that record-set's Create form, so it is always correct regardless of render/route ordering
		// (baking the record-set into the template at registration time races with the title render). Rendered
		// here, not via an app-level override, so it survives prepareTable()'s per-render re-registration.
		// Neutral .prsp-list-new style, brand-coloured on hover.
		// Permission-expression layer (Phase 2): the "New" button renders only where the current user can
		// create the entity. Gated by a template tag on the record set's OWN config flag
		// (RecordSetListShowCreateButton, stamped per can(entity,'Create') at login) — not a JS-time check on
		// the active route, which the title can out-race (the same reason createFromActiveList reads the hash
		// at click time). Record.RecordSetConfiguration is always the correct entity's config at title render.
		this.pict.TemplateProvider.addTemplate('HLPC-List-New-Button', /*html*/`<div class="column is-narrow"><button class="button is-small prsp-list-new" title="Create a new record" onclick="_Pict.providers.ImprovedTabularRecordSetProvider.createFromActiveList()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>New</span></button></div>`);
		const tmpNewButton = `{~TIfAbs:HLPC-List-New-Button:Record:Record.RecordSetConfiguration.RecordSetListShowCreateButton^TRUE^~}`;
		this.pict.TemplateProvider.addTemplate('PRSP-List-Title-Template', /*html*/`
			<!--START ImprovedTabularRecordSet Custom: [PRSP-List-Title-Template] -->
				<header id="PRSP_Title_Container" class="columns is-mobile is-vcentered">
					<div class="column"><h2 class="title is-size-4 mb-0" id="PRSP_Title">{~D:Record.Title~}</h2></div>
					${ this.options?.endCapTemplate || '' }
					<div class="is-hidden-mobile column is-narrow pt-3 has-text-text is-size-7 has-text-right">{~T:PRSP-List-Pagination-Template-Description~}</div>
					${ tmpNewButton }
				</header>
				<div class="is-hidden-desktop is-hidden-tablet pb-2 has-text-text is-size-7 has-text-centered">{~T:PRSP-List-Pagination-Template-Description~}</div>
			<!--  END ImprovedTabularRecordSet Custom: [PRSP-List-Title-Template] -->
		`);

		// Trim the verbose "… total records." tail from the shared pagination description (used by the title bar
		// and the top/bottom pagination). Keeps the live-updated count spans the pagination logic writes to.
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Description', /*html*/`
			<div>
				Showing
				<span id="PRSP_Pagination_Description_Records_Start">{~D:Record.PageStart~}</span> to
				<span id="PRSP_Pagination_Description_Records_End">{~D:Record.PageEnd~}</span> of
				<span id="PRSP_Pagination_Description_Records_Total">{~D:Record.TotalRecordCount.Count~}</span>
			</div>
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordList-Template-Table', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-Table] -->
			<div class="table-container">
				<table id="PRSP_List_Table" class="table is-striped is-hoverable is-fullwidth is-bordered">
					<thead>{~T:PRSP-List-RecordListHeader-Template~}</thead>
					<tbody id="PRSP_RecordList_Container_Entries">
						{~T:PRSP-List-RecordListEntry-Template~}
						{~T:PRSP-List-RecordList-Template-EmptyTable~}
					</tbody>
				</table>
			</div>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-Table] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordList-Template-EmptyTable', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-EmptyTable] -->
			<tr id="PRSP_List_Table_Empty">
				<td colspan="100%" class="has-text-centered has-text-text-50">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">No records found.</span>
				</td>
			</tr>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-EmptyTable] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListAction-Template-Cell', this.options.disableActions ? '' : /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordListAction-Template-Cell'] -->
			<td class="has-text-centered prsp-row-actions">
				<ul class="buttons has-addons is-centered">
					<!-- TODO: check if the entity is print-able - for now, this is just part of the provider options -->
					${ this.options.includePrint ? /*html*/`
						<li>
							<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault();
									if (window.location.href.includes('Document/List'))
									{
										_Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.Data.IDDocument~});
									}
									else
									{
										_Pict.providers.QRCodeProvider.printDecoratedEntity('{~D:Record.Payload.RecordSetConfiguration.Entity~}', '{~D:Record.Data.QRCode~}');
									}">
								<span class="icon">
									<i class="fas fa-print"></i>
								</span>
								<span class="icon-text">Print</span>
							</a>
						</li>
					` : '' }
					{~TSWP:PRSP-List-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
					${ isDocumentRecord ? /*html*/`<li>
						<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.Data.IDDocument~});" title="{~TBR:Record.Name~}">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span class="icon-text">Edit</span>
						</a>
					</li>` : ''}
				</ul>
			</td>
			<!-- END ImprovedTabularRecordSet Custom:   [PRSP-List-RecordListAction-Template-Cell] -->`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListAction-Template-Cell-Datum', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordListAction-Template-Cell-Datum] -->
			<li>
				<a class="button is-ghost" {~NE:Record.Data.Default^data-prsp-default="1"~} href="{~TBR:Record.Data.URL~}" title="{~TBR:Record.Data.Name~}">
					<span class="icon">
						<i class="fas fa-search"></i>
					</span>
					<span class="icon-text">View</span>
				</a>
			</li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-RecordListAction-Template-Cell-Datum] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListHeader-Template-Header', /*html*/`<th>{~D:Record.DisplayName~}</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListActions-Template-Header', this.options.disableActions ? '' : /*html*/`<th class="has-text-centered">Actions</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Button-Previous',
			`<a class="pagination-previous" href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">Previous</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Button-Next',
			`<a class="pagination-next" href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-PaginationTop-Template', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-PaginationTop-Template] -->
			<nav class="pagination is-small my-3 is-rounded" id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
				{~TIfAbs:PRSP-List-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
				{~TIfAbs:PRSP-List-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
				<ul class="pagination-list">{~TS:PRSP-List-Pagination-Template-Pages:Record.PageLinksLimited~}</ul>
			</nav>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-PaginationTop-Template] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Pages', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-Pagination-Template-Pages] -->
			<li><a class="pagination-link page-offset_{~D:Record.RelativeOffset~} {~TIfAbs:PaginationActiveClass:Record:Record.RelativeOffset^==^0~}" href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-Pagination-Template-Pages] -->
		`);
		this.pict.TemplateProvider.addTemplate('PaginationActiveClass', /*html*/`is-current`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-PaginationBottom-Template', `{~T:PRSP-List-PaginationTop-Template~}`);
		this.pict.TemplateProvider.addTemplate('PRSP-SUBSET-Filters-Template-Button-Fieldset', /*html*/`<!-- intentionally blank -->`);

		// Dashboard templates
		if (this.options?.overrideDashboardURLTemplate)
		{
			this.pict.TemplateProvider.addTemplate('PRSP-Read-Dashboard-URL-Template', this.options.overrideURLTemplate);
		}
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Title-Template', /*html*/`
			<!--START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Title-Template] -->
				<header id="PRSP_Title_Container" class="columns is-mobile is-vcentered">
					<div class="column"><h2 class="title is-size-4 mb-0" id="PRSP_Title">{~D:Record.Title~}</h2></div>
					${ this.options?.endCapTemplate || '' }
					<div class="is-hidden-mobile column pt-3 has-text-text is-size-7 has-text-right">{~T:PRSP-Dashboard-Pagination-Template-Description~}</div>
				</header>
				<div class="is-hidden-desktop is-hidden-tablet pb-2 has-text-text is-size-7 has-text-centered">{~T:PRSP-Dashboard-Pagination-Template-Description~}</div>
			<!--  END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Title-Template] -->
		`);

		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordList-Template-Table', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-Table] -->
			<div class="table-container">
				<table id="PRSP_List_Table" class="table is-striped is-hoverable is-fullwidth is-bordered">
					<thead>{~T:PRSP-Dashboard-RecordListHeader-Template~}</thead>
					<tbody id="PRSP_RecordList_Container_Entries">
						{~T:PRSP-Dashboard-RecordListEntry-Template~}
						{~T:PRSP-Dashboard-RecordList-Template-EmptyTable~}
					</tbody>
				</table>
			</div>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-Table] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordList-Template-EmptyTable', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-EmptyTable] -->
			<tr id="PRSP_List_Table_Empty">
				<td colspan="100%" class="has-text-centered has-text-text-50">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">No records found.</span>
				</td>
			</tr>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-EmptyTable] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListEntry-Template-Row-Cell', /*html*/`<td>{~TBDA:Record.Data.PictDashboard.ValueTemplate~}</td>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListAction-Template-Cell', this.options.disableActions ? '' : /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordListAction-Template-Cell'] -->
			<td class="has-text-centered">
				<ul class="buttons has-addons is-centered">
					<!-- TODO: check if the entity is print-able - for now, this is just part of the provider options -->
					${ this.options.includePrint ? /*html*/`
						<li>
							<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault();
									if (window.location.href.includes('Document/List'))
									{
										_Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.Data.IDDocument~});
									}
									else
									{
										_Pict.providers.QRCodeProvider.printDecoratedEntity('{~D:Record.Payload.RecordSetConfiguration.Entity~}', '{~D:Record.Data.QRCode~}');
									}">
								<span class="icon">
									<i class="fas fa-print"></i>
								</span>
								<span class="icon-text">Print</span>
							</a>
						</li>
					` : '' }
					{~TSWP:PRSP-Dashboard-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
					${ isDocumentRecord ? /*html*/`<li>
						<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.Data.IDDocument~});" title="{~TBR:Record.Name~}">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span class="icon-text">Edit</span>
						</a>
					</li>` : ''}
				</ul>
			</td>
			<!-- END ImprovedTabularRecordSet Custom:   [PRSP-Dashboard-RecordListAction-Template-Cell] -->`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListAction-Template-Cell-Datum', this.options.disableActions ? '' : /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordListAction-Template-Cell-Datum] -->
			<li>
				<a class="button is-ghost" href="{~TBR:Record.Data.URL~}" title="{~TBR:Record.Data.Name~}">
					<span class="icon">
						<i class="fas fa-search"></i>
					</span>
					<span class="icon-text">View</span>
				</a>
			</li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordListAction-Template-Cell-Datum] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListHeader-Template-Header', /*html*/`<th>{~D:Record.DisplayName~}</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListActions-Template-Header', this.options.disableActions ? '' : /*html*/`<th class="has-text-centered">Actions</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Pagination-Template-Button-Previous',
			`<a class="pagination-previous" href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">Previous</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Pagination-Template-Button-Next',
			`<a class="pagination-next" href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-PaginationTop-Template', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-PaginationTop-Template] -->
			<nav class="pagination is-small my-3 is-rounded" id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
				{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
				{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
				<ul class="pagination-list">{~TS:PRSP-Dashboard-Pagination-Template-Pages:Record.PageLinksLimited~}</ul>
			</nav>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-PaginationTop-Template] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Pagination-Template-Pages', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Pagination-Template-Pages] -->
			<li><a class="pagination-link page-offset_{~D:Record.RelativeOffset~} {~TIfAbs:PaginationActiveClass:Record:Record.RelativeOffset^==^0~}" href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Pagination-Template-Pages] -->
		`);
		this.pict.TemplateProvider.addTemplate('PaginationActiveClass', /*html*/`is-current`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-PaginationBottom-Template', `{~T:PRSP-Dashboard-PaginationTop-Template~}`);
		this.pict.TemplateProvider.addTemplate('PRSP-SUBSET-Filters-Template-Button-Fieldset', /*html*/`<!-- intentionally blank -->`);
	}

	/**
	 * The list title-bar "New" button handler. Resolves the active record-set from the current
	 * #/PSRS/<RecordSet>/List hash at click time (race-free) and routes to its Create form. One handler
	 * serves every record-set list in every app that mounts this provider.
	 */
	createFromActiveList()
	{
		const tmpHash = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
		const tmpMatch = tmpHash.match(/\/PSRS\/([^/?#]+)/);
		if (tmpMatch && tmpMatch[1])
		{
			window.location.hash = `#/PSRS/${tmpMatch[1]}/Create`;
		}
	}

	/**
	 * Permission-expression layer (Phase 2b): after a record read page renders, toggle a body class that
	 * hides the Edit/Save buttons (via CSS) when the current user can't update the active entity. The entity
	 * is read from the live #/PSRS/<Entity>/(View|Edit|Read) hash, so it is always the record on screen.
	 * Fail-open (no service / no entity / not-yet-loaded → editable); the server stays authoritative.
	 */
	applyReadEditGate()
	{
		if (typeof document === 'undefined' || !document.body)
		{
			return;
		}
		let tmpEntity = '';
		const tmpHash = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
		const tmpMatch = /#?\/PSRS\/([A-Za-z0-9_]+)\/(View|Edit|Read)/.exec(tmpHash);
		if (tmpMatch)
		{
			tmpEntity = tmpMatch[1];
		}
		const tmpPermissions = this.pict.fable.EffectivePermissionsService;
		const tmpCanUpdate = (!tmpPermissions || !tmpEntity) ? true : tmpPermissions.can(tmpEntity, 'Update');
		document.body.classList.toggle('pcfg-cannot-update-record', !tmpCanUpdate);
	}
}

module.exports = ImprovedTabularRecordSetProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],866:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class InspectionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	async getInspectionFromDocumentID(pDocumentID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pDocumentID)
			{
				this.pict.log.error('No Document ID provided.');
				return reject(new Error('No Document ID provided.'));
			}
			this.fable.HeadlightRestClient.getJSON(`Inspections/FilteredTo/FBV~InspectionDocumentJoin.IDDocument~EQ~${ pDocumentID }/0/100?Joins=InspectionDocumentJoin,IDInspection,IDInspection;`,
				(pError, pResponse) =>
				{
					if (pError)
					{
						this.log.error('Error loading Inspection from Document:', pError);
						return reject(pError);
					}
					if (pResponse?.length)
					{
						this.pict.AppData.CurrentInspection = pResponse[0];
					}
					if (!this.pict.AppData.CurrentInspection)
					{
						this.log.warn(`No Current Inspection set. Can't load Inspection Documents.`);
						this.AppData.InspectionDocumentRecords = [];
						this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
						return resolve();
					}
					const currentInspectionID = this.pict.AppData.CurrentInspection.IDInspection;
					const cachedInspectionID = this.pict.AppData.CachedInspectionDocumentRecordsIDInspection;
					if ('InspectionDocumentRecords' in this.pict.AppData && currentInspectionID == cachedInspectionID)
					{
						return resolve(currentInspectionID);
					}
					delete this.AppData.InspectionDocumentRecords;
					delete this.AppData.CachedInspectionDocumentRecordsIDInspection;
					resolve(currentInspectionID);
				});
		});
	}

	async getInspectionDocumentJoins(inspectionID)
	{
		await new Promise((resolve, reject) =>
		{
			return this.pict.providers.EntityInspectionDocumentProvider.loadRecordsToAddress((error) =>
			{
				if (error)
				{
					this.log.warn(`Error retrieving Documents for Inspection ID ${inspectionID}:`, error);
					return reject(error);
				}
				resolve();
			}, 'AppData.InspectionDocumentJoins', `FilteredTo/FBV~IDInspection~EQ~${inspectionID}`, 0, 100);
		});
	}

	async getInspectionTypes()
	{
		await new Promise((resolve, reject) =>
		{
			if (Array.isArray(this.pict.AppData.InspectionTypes))
			{
				this.pict.log.info('InspectionTypes loaded', this.pict.AppData.InspectionTypes);
				return resolve();
			}
			// todo: do inspection types exist by default? this may need a fallback
			return this.pict.providers.EntityInspectionTypeProvider.loadRecordsToAddress((error) =>
			{
				if (error)
				{
					this.log.warn(`Error retrieving Inspection Types`, error);
					return reject(error);
				}
				resolve();
			}, 'AppData.InspectionTypes', null, null, null);
		});
	}

	async getCurrentInspectionDocumentRecords(inspectionID)
	{
		await new Promise((resolve, reject) =>
		{
			if (this.pict.AppData.InspectionDocumentJoins.length < 1)
			{
				// no need to hit server for nothing
				this.pict.AppData.CachedInspectionDocumentRecordsIDInspection = inspectionID;
				this.pict.AppData.InspectionDocumentRecords = [];
				return resolve();
			}

			const documentIds = this.pict.AppData.InspectionDocumentJoins.map((pJoin) => pJoin.IDDocument).join(',');

			return this.pict.providers.EntityDocumentProvider.loadRecordsToAddress(() =>
			{
				this.pict.AppData.CachedInspectionDocumentRecordsIDInspection = inspectionID;
				this.AppData.InspectionDocumentRecords.forEach((d) =>
				{
					//FIXME: zzzz - propagating include bit from join record to document record for UI, for now
					const join = this.AppData.InspectionDocumentJoins.find((pJoin) => pJoin.IDDocument == d.IDDocument);
					d.IncludeOnDossier = join ? join.IncludeOnDossier : 0;
					d.Ordinal = join ? join.Ordinal : this.AppData.InspectionDocumentJoins.length;

					const timeDelta = Math.abs(new Date().getTime() - new Date(join.CreateDate).getTime());
					// doc was added within 1 minute of rendering this screen. Probably from current user's action.
					d.NewlyAdded = timeDelta <= 60000;
				});
				this.AppData.InspectionDocumentRecords.sort((a, b) => a.Ordinal - b.Ordinal);
				resolve();
			}, 'AppData.InspectionDocumentRecords', `FilteredTo/FBL~IDDocument~INN~${documentIds}`, 0, this.AppData.InspectionDocumentJoins.length);
		});
	}

	async getCurrentInspectionDocuments(pDocumentID)
	{
		return new Promise(async (resolve, reject) =>
		{
			if (!pDocumentID)
			{
				this.pict.log.warn('No Document ID provided. Returning empty Inspection Documents.');
				this.AppData.InspectionDocumentRecords = [];
				this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
				return resolve();
			}

			// If the InspectionDocumentRecords are already loaded and match the current inspection, return them
			if (this.AppData.InspectionDocumentRecords && this.AppData.CachedInspectionDocumentRecordsIDInspection == this.pict.AppData.CurrentInspection?.IDInspection)
			{
				this.pict.log.info('Returning cached Inspection Documents for Document ID:', pDocumentID);
				return resolve();
			}

			try
			{
				await this.getInspectionTypes();
				const inspectionID = await this.getInspectionFromDocumentID(pDocumentID);
				if (!inspectionID)
				{
					this.pict.log.warn('No Inspection ID found for Document ID:', pDocumentID);
					this.AppData.InspectionDocumentRecords = [];
					this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
					return resolve();
				}
				await this.getInspectionDocumentJoins(inspectionID);
				await this.getCurrentInspectionDocumentRecords(inspectionID);
				resolve();
			}
			catch (pError)
			{
				this.pict.log.error(`Error retrieving Inspection Document Record for document id ${pDocumentID}:`, pError);
				reject(pError);
			}
		});
	}
}

module.exports = InspectionProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],867:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LabProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Lab by ID
	 * @param {String|Number} pLabID - The Lab ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getLabByID(pLabID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pLabID)
			{
				this.pict.log.error('No Lab ID provided.');
				return reject(new Error('No Lab ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Lab/${pLabID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Lab: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = LabProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],868:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LineItemProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the LineItem by ID
	 * @param {String|Number} pLineItemID - The LineItem ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getLineItemByID(pLineItemID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pLineItemID)
			{
				this.pict.log.error('No LineItem ID provided.');
				return reject(new Error('No LineItem ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`LineItem/${pLineItemID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting LineItem: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	async saveSampleLineItemJoin(payload)
	{
		await this._put('SampleLineItemJoin/Upsert', payload);
	}

	/**
	 * Get the LineItems
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */

	getLineItems()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'LineItems';

			// Check if we need to filter by customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `LineItems/By/IDCustomer/${this.pict.AppData.DocumentData.ReportData.IDCustomer}`;
			}

			// Make the request to get LineItems
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get LineItems list.', pError);
					return reject(pError);
				}

				resolve(pBody);
			});
		});
	}

	async _getSampleLineItemJoinsByIDSample(IDSample)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('SampleLineItemJoin', `FBV~IDSample~EQ~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLineItemJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
	}

	async _getLineItemsByIDs(IDLineItems)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('LineItem', `FBL~IDLineItem~INN~${ IDLineItems.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting LineItems: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
	}

	async getLineItemsByIDSample(IDSample)
	{
		const slijs = await this._getSampleLineItemJoinsByIDSample(IDSample);
		if (!slijs?.length)
		{
			return [];
		}
		const lineItems = await this._getLineItemsByIDs(slijs.map(slij => slij.IDLineItem));
		const slijMap = [];
		for (let s of slijs)
		{
			slijMap[s.IDLineItem] = s;
		}
		const decoratedLineItems = [];
		for (let l of lineItems)
		{
			// Decorate the LI with the important join information.
			decoratedLineItems.push(Object.assign(l, { RepresentedQuantity: slijMap[l.IDLineItem].RepresentedQuantity, IDSampleLineItemJoin: slijMap[l.IDLineItem].IDSampleLineItemJoin, GUIDSampleLineItemJoin: slijMap[l.IDLineItem].GUIDSampleLineItemJoin }));
		}
		return decoratedLineItems;
	}

	async deleteSampleLineItemJoin(IDSampleLineItemJoin)
	{
		return await new Promise((resolve, reject) => 
		{
			this.pict.HeadlightRestClient.deleteEntity('SampleLineItemJoin', IDSampleLineItemJoin, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error removing lineitem from sample: `, pError);
					return reject(pError);
				}
				resolve(true);
			});
		});
	}
}

module.exports = LineItemProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],869:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LocationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Locations by Sample ID
	 * @param {Number} pIDSample - The ID of the Sample to get Locations for
	 * @param {Function} [pCallback] - The callback function to call when the Location is fetched
	 * @return {Promise}
	 * @async
	 */
	async getLocationsBySampleID(pIDSample, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// First check if there is already a join between these.
				this.pict.fable.services.HeadlightRestClient.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${ pIDSample }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Locations: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							if (pBody.length)
							{
								const fullLocations = [];
								for (const j of pBody)
								{
									fullLocations.push(await this.getLocationByID(j.IDLocation));
								}
								resolve(fullLocations);
								if (pCallback)
								{
									pCallback(fullLocations);
								}
							}
							else
							{
								resolve([]);
								if (pCallback)
								{
									pCallback([]);
								}
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Locations: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the Location by GUID
	 * @param {Number} pGUIDLocation - The GUID of the Location to get
	 * @param {Function} [pCallback] - The callback function to call when the Location is fetched
	 * @param {Number} [recursiveDepth] - The depth of current recursion
	 * @return {Promise}
	 * @async
	 */
	async getLocationByGUID(pGUIDLocation, pCallback, recursiveDepth = 0)
	{
		const maxRecursiveDepth = 1;
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Locations/By/GUIDLocation/${ pGUIDLocation }`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Location: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							pBody = pBody[0];
							if (pBody.ParentIDLocation && recursiveDepth < maxRecursiveDepth)
							{
								try
								{
									pBody.ParentLocation = await this.getLocationByID(pBody.ParentIDLocation, null, recursiveDepth + 1);
								}
								catch (pError)
								{
									this.pict.log.error(`Error fetching Location: `, pError);
									reject(pError);
									// if we have a callback, run it now
									if (pCallback)
									{
										pCallback(null);
									}
								}
							}
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the Location by ID
	 * @param {Number} pIDLocation - The ID of the Location to get
	 * @param {Function} [pCallback] - The callback function to call when the Location is fetched
	 * @param {Number} [recursiveDepth] - The depth of current recursion
	 * @return {Promise}
	 * @async
	 */
	async getLocationByID(pIDLocation, pCallback, recursiveDepth = 0)
	{
		const maxRecursiveDepth = 1;
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Location/${ pIDLocation }`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Location: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							if (pBody.ParentIDLocation && recursiveDepth < maxRecursiveDepth)
							{
								try
								{
									pBody.ParentLocation = await this.getLocationByID(pBody.ParentIDLocation, null, recursiveDepth + 1);
								}
								catch (pError)
								{
									this.pict.log.error(`Error fetching Location: `, pError);
									reject(pError);
									// if we have a callback, run it now
									if (pCallback)
									{
										pCallback(null);
									}
								}
							}
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Add a sample to a location.
	 * @param {Number} pIDSample - The ID of the Sample to add to the location
	 * @param {Number} pIDLocation - The ID of the Location to add the Sample to
	 * @param {Function} [pCallback] - The callback function to call when the action is complete
	 * @return {Promise}
	 * @async
	 */
	async addSampleToLocation(pIDSample, pIDLocation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// First check if there is already a join between these.
				this.pict.fable.services.HeadlightRestClient.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${ pIDSample }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error adding sample to location: `, pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
								return;
							}
							reject(pError);
						}
						else
						{
							// If we found a join already, return it.
							if (pBody?.length && pBody[0].IDLocation == pIDLocation)
							{
								resolve(pBody[0]);
								// if we have a callback, run it now
								if (pCallback)
								{
									pCallback(pBody[0]);
								}
							}
							else
							{
								// Otherwise, create the join and return that.
								this.pict.HeadlightRestClient.putJSON('SampleLocationJoin/Upsert', { IDSample: pIDSample, IDLocation: pIDLocation }, (pError, pBody) =>
								{
									if (pError)
									{
										this.pict.log.error(`Error adding sample to location: `, pError);
										// if we have a callback, run it now
										if (pCallback)
										{
											pCallback(null);
											return;
										}
										reject(pError);
									}
									else
									{
										this.pict.HeadlightRestClient.getJSON(`Sample/${ pIDSample }`, async (pError, pBody) =>
										{
											if (pError)
											{
												this.pict.log.error(`Error adding sample to location: `, pError);
												// if we have a callback, run it now
												if (pCallback)
												{
													pCallback(null);
													return;
												}
												reject(pError);
											}
											else
											{
												if (parseInt(pBody?.Extension?.StorageLocation) !== pIDLocation)
												{
													this.pict.HeadlightRestClient.putJSON('Sample',
													{
														IDSample: pIDSample,
														Extension: Object.assign(pBody.Extension, { StorageLocation: `${ pIDLocation }` }),
													}, async (pError, pBody) =>
													{
														if (pError)
														{
															this.pict.log.error(`Error adding sample to location: `, pError);
															// if we have a callback, run it now
															if (pCallback)
															{
																pCallback(null);
																return;
															}
															reject(pError);
														}
														else
														{
															resolve(pBody);
															// if we have a callback, run it now
															if (pCallback)
															{
																pCallback(pBody);
															}
														}
													});
												}
												else
												{
													resolve(pBody);
													// if we have a callback, run it now
													if (pCallback)
													{
														pCallback(pBody);
													}
												}
											}
										});
									}
								});
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error adding Sample to Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Remove a sample from a location.
	 * @param {Number} pIDSample - The ID of the Sample to remove from the location
	 * @param {Number} pIDLocation - The ID of the Location to remove the Sample from
	 * @param {Function} [pCallback] - The callback function to call when the action is complete
	 * @return {Promise}
	 * @async
	 */
	async removeSamplefromLocation(pIDSample, pIDLocation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// First check if there is already a join between these.
				this.pict.fable.services.HeadlightRestClient.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${ pIDSample }~FBV~IDLocation~EQ~${ pIDLocation }`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error removing sample from location: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							// If we found a join already, delete it.
							if (pBody?.length)
							{
								this.pict.HeadlightRestClient.deleteEntity('SampleLocationJoin', pBody[0].IDSampleLocationJoin, (pError, pBody) =>
								{
									if (pError)
									{
										this.pict.log.error(`Error removing sample from location: `, pError);
										reject(pError);
										// if we have a callback, run it now
										if (pCallback)
										{
											pCallback(null);
										}
									}
									else
									{
										resolve(true);
										// if we have a callback, run it now
										if (pCallback)
										{
											pCallback(true);
										}
									}
								});
							}
							else
							{
								// Otherwise, just return;
								resolve(true);
								// if we have a callback, run it now
								if (pCallback)
								{
									pCallback(true);
								}
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error removing Sample from Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}
}

module.exports = LocationProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],870:[function(require,module,exports){
const FirefoxHotkeyInstructions = require('../../web/markdown_display/FirefoxHotkeyInstructions');

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libMarked = require('marked');
// The shared renderer for markdown a user typed, deep-required from the dynamic inputs bundle the
// same way LIMS already requires _VocabularySelectorMap.js. Shared so a remark reads the same way
// on a panel, in the LIMS sample record and on a dynamic form.
const libUserMarkdown = require('headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js');

class MarkdownProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.markdownFilesMap =
		{
			FirefoxHotkeyInstructions: FirefoxHotkeyInstructions,
		};

		this._remarksCSSRegistered = false;

		// `{~MarkdownRemarks:Record.Notes~}` renders a remark as markdown.
		// `{~MarkdownRemarksClamped:Record.Notes~}` does the same but collapses a long one behind a
		// Read more toggle. Both take an optional template hash to render when the remark is empty:
		// `{~MarkdownRemarks:Record.Notes^SampleDetails-DatumValue-NA^~}`.
		this.pict.MetaTemplate.addPattern('{~MarkdownRemarks:', '~}', (pHash, pData, pContext) =>
		{
			return this.renderRemarksExpression(pHash, pData, pContext, false);
		});
		this.pict.MetaTemplate.addPattern('{~MarkdownRemarksClamped:', '~}', (pHash, pData, pContext) =>
		{
			return this.renderRemarksExpression(pHash, pData, pContext, true);
		});
	}

	/**
	 * Uses the name of the file to get the markdown from a file as a string (see the markdown_display folder).
	 * This will return null if the file name is not present.
	 * @param {String} name
	 * @return {String|null}
	 */
	getMarkdownByName(name)
	{
		return this.markdownFilesMap[name]?.markdown || null;
	}

	/**
	 * Uses the name of the file to get the title from a file as a string (see the markdown_display folder).
	 * This will return null if the file name is not present.
	 * @param {String} name
	 * @return {String|null}
	 */
	getMarkdownTitleByName(name)
	{
		return this.markdownFilesMap[name]?.title || null;
	}

	/**
	 * Uses the name of the file to get the markdown from a file converted to html.
	 * This will return null if the file name is not present.
	 * @param {String} name
	 * @return {String|null}
	 */
	getMarkdownAsHTMLByName(name)
	{
		const md = this.getMarkdownByName(name);
		if (!md)
		{
			return null;
		}
		return this.getMarkdownAsHTML(md);
	}

	/**
	 * Converts markdown to html.
	 * @param {String} markdown
	 * @return {String}
	 */
	getMarkdownAsHTML(markdown)
	{
		return this._addBulmaFlavor(String(libMarked.parse(markdown)));
	}

	/**
	 * Opens markdown in modal by file name (if file with that name is registered).
	 * @param {String} name
	 */
	openMarkdownInModalByName(name)
	{
		const md = this.getMarkdownByName(name);
		const title = this.getMarkdownTitleByName(name);
		if (md)
		{
			this.openMarkdownInModal(md, title);
		}
	}

	/**
	 * Opens markdown in a modal. Can optionally include a title for the modal.
	 * @param {String} markdown
	 * @param {String} [title]
	 */
	openMarkdownInModal(markdown, title)
	{
		const markdownModalOptions = {
			title: `<b>${ title || '' }</b>`,
			modalBodyTemplate: /*html*/`
				<div>
					${ this.getMarkdownAsHTML(markdown) }
				</div>
			`,
			modalFooterTemplate: /*html*/`
				<div class="columns">
					<div id="Footer-ButtonGroup" class="buttons is-right">
						<button id="Footer-Button-Cancel" type="button" class="button is-link is-soft" onclick="_Pict.fable.HeadlightModal.cancelCallback()">
							<span class="icon"><i class="fas fa-fw fa-times"></i></span>
							<span> Close </span>
						</button>
					</div>
				</div>
			`,
			confirmText: '',
			style: 'wide',
			cancelText: 'Cancel',
		};
		this.pict.services.HeadlightModal.spawnModal(markdownModalOptions);
	}

	/**
	 * Escapes a value for use as HTML text or as an attribute value.
	 *
	 * @param {any} pValue
	 * @return {String}
	 */
	escapeHTML(pValue)
	{
		return libUserMarkdown.escapeHTML(pValue);
	}

	/**
	 * Converts markdown a user typed (a remark, a note, a comment) to display HTML.
	 * Returns an empty string for an empty or null value.
	 *
	 * @param {any} pMarkdown
	 * @return {String}
	 */
	getUserMarkdownAsHTML(pMarkdown)
	{
		return libUserMarkdown.renderUserMarkdown(pMarkdown, this.log);
	}

	/**
	 * Renders a remark as the shared remarks block: the same markdown treatment the Sample
	 * Authorization form gives test remarks, so a remark reads the same way wherever it is shown.
	 *
	 * @param {any} pMarkdown - the remark source.
	 * @param {Object} [pOptions] - `Clamp` clamps the remark to three lines, with a Read more toggle when it runs longer.
	 * @return {String} - the rendered block, or an empty string when there is no remark.
	 */
	getRemarksAsHTML(pMarkdown, pOptions)
	{
		const tmpContent = this.getUserMarkdownAsHTML(pMarkdown);
		if (!tmpContent)
		{
			return '';
		}
		this.registerRemarksCSS();
		if (pOptions && pOptions.Clamp)
		{
			return `<details class="hl-md-remarks-collapse"><summary><div class="content hl-md-remarks hl-md-remarks-text">${ tmpContent }</div></summary></details>`;
		}
		return `<div class="content hl-md-remarks">${ tmpContent }</div>`;
	}

	/**
	 * Renders a `{~MarkdownRemarks:~}` / `{~MarkdownRemarksClamped:~}` expression.
	 *
	 * The expression is `<DataAddress>` or `<DataAddress>^<EmptyTemplateHash>^`. The empty-template
	 * hash is rendered in place of the remark when there is nothing to show -- it carries whatever
	 * "N/A" treatment the screen already uses.
	 *
	 * @param {String} pHash - the contents of the template expression.
	 * @param {any} pData - the Record the expression is rendering against.
	 * @param {Array<any>} pContext - the template context array.
	 * @param {Boolean} pClamp - true to collapse a long remark behind a Read more toggle.
	 * @return {String}
	 */
	renderRemarksExpression(pHash, pData, pContext, pClamp)
	{
		const tmpHashParts = String(pHash).split('^');
		const tmpRemarks = this.pict.resolveStateFromAddress(tmpHashParts[0].trim(), pData, pContext);
		const tmpContent = this.getRemarksAsHTML(tmpRemarks, { Clamp: pClamp });
		if (tmpContent)
		{
			return tmpContent;
		}
		const tmpEmptyTemplateHash = (tmpHashParts.length > 1) ? tmpHashParts[1].trim() : '';
		return tmpEmptyTemplateHash ? this.pict.parseTemplateByHash(tmpEmptyTemplateHash, pData, null, pContext) : '';
	}

	/**
	 * Puts the remarks styling in the page. Called the first time a remark actually renders rather
	 * than from the constructor, because the provider is built before the document is ready.
	 */
	registerRemarksCSS()
	{
		if (this._remarksCSSRegistered || !this.pict.CSSMap)
		{
			return;
		}
		this._remarksCSSRegistered = true;
		this.pict.CSSMap.addCSS('Headlight-Markdown-Remarks', libUserMarkdown.RemarksCSS, 500, 'MarkdownProvider');
		this.pict.CSSMap.injectCSS();
		libUserMarkdown.watchRemarksTruncation();
	}

	/**
	 * Adds Bulma flavor to the provided content (expected "default Bulma classes" on HTML elements).
	 * @param {string} pContent - The content to which to add Bulma flavor.
	 * @return {string} - The content with Bulma flavor added.
	 */
	_addBulmaFlavor(pContent)
	{
		if (pContent)
		{
			// for tables, add the table class
			pContent = pContent.replace(/<table>/g, '<table class="table is-fullwidth is-striped is-hoverable">');
			// for images, add the image class
			pContent = pContent.replace(/<img/g, '<img class="image"');
			// h1-h6
			pContent = pContent.replace(/<h1>/g, '<h1 class="title is-1">');
			pContent = pContent.replace(/<h2>/g, '<h2 class="title is-2">');
			pContent = pContent.replace(/<h3>/g, '<h3 class="title is-3">');
			pContent = pContent.replace(/<h4>/g, '<h4 class="title is-4">');
			pContent = pContent.replace(/<h5>/g, '<h5 class="title is-5">');
			pContent = pContent.replace(/<h6>/g, '<h6 class="title is-6">');
		}
		return pContent;
	}
}

module.exports = MarkdownProvider;
module.exports.default_configuration = {};

},{"../../web/markdown_display/FirefoxHotkeyInstructions":852,"headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js":144,"marked":442,"pict-provider":479}],871:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MaterialProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Material by ID
	 * @param {String|Number} pMaterialID - The Material ID to search for=
	 * @return {Promise<void>}
	 * @async
	 */
	getMaterialByID(pMaterialID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMaterialID)
			{
				this.pict.log.error('No Material ID provided.');
				return reject(new Error('No Material ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Material/${pMaterialID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Material: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Materials
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	async getMaterials()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Materials';

			// Check if we need to filter by customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Materials/By/IDCustomer/${this.pict.AppData.DocumentData.ReportData.IDCustomer}`;
			}

			// Make the request to get materials
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Materials list.', pError);
					reject(pError);
				}
				else
				{
					resolve(pBody);
				}
			});
		});
	}
}

module.exports = MaterialProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],872:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MixDesignProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the MixDesign by ID
	 * @param {String|Number} pMixDesignID - The MixDesign ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getMixDesignByID(pMixDesignID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMixDesignID)
			{
				this.pict.log.error('No MixDesign ID provided.');
				return reject(new Error('No MixDesign ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`MixDesign/${pMixDesignID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixDesign: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the MixDesign by ID
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getMixDesigns()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'MixDesigns';

			// Filter out by customer if we have a customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `MixDesigns/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			// Make the request to get MixDesigns
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixDesigns list: ${pError}`, pError);
					return reject(pError);
				}

				resolve(pBody);
			});
		});
	}
}

module.exports = MixDesignProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],873:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MixSpecificationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the MixSpecification by ID
	 * @param {String|Number} pMixSpecificationID - The MixSpecification ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getMixSpecificationByID(pMixSpecificationID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMixSpecificationID)
			{
				this.pict.log.error('No MixSpecification ID provided.');
				return reject(new Error('No MixSpecification ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`MixSpecification/${pMixSpecificationID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixSpecification: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = MixSpecificationProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],874:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ModulesProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get available module hashes
	 *
	 * @return {Promise<Array<string>>}
	 */
	async getModules()
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('Permissions/Modules/For/User', (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Modules: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get module by hash.
	 *
	 * @param {string} pHash
	 *
	 * @return {Promise<any>}
	 */
	async getModuleByHash(pHash)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`Modules/FilteredTo/FBV~ModuleHash~EQ~${encodeURIComponent(pHash)}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Module by hash [${pHash}]: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody[0]);
			});
		});
	}
}

module.exports = ModulesProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],875:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ObservationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Load the EXIF data from an image file and attach it to an observation object
	 * @param {Object} pNewObservationObject - The observation object to attach the EXIF data to
	 * @param {Object} pFileDetails - The details of the file to upload
	 * @param {String} pDatumType - The type of the datum to upload
	 * @return {Promise<Object>} - A promise that resolves to the observation object with the EXIF data attached
	 */
	async attachEXIFDatumToObservation(pNewObservationObject, pFileDetails, pDatumType)
	{
		return new Promise((resolve, reject) =>
		{
			// fetch any EXIF data for the observation -- DOCS: https://github.com/exif-heic-js/exif-heic-js
			const readerExif = new FileReader();
			const methodName = pFileDetails.File.type.toLowerCase() === 'image/heic' ? 'findEXIFinHEIC' : 'findEXIFinJPEG';
			this.pict.log.info('[Image] Reading EXIF Data from file:', pFileDetails.File.type);
			this.pict.log.info('[Image] Using EXIF Method:', methodName);
			// on load of EXIF Data
			readerExif.onload = (buffer) =>
			{
				// take the exif data and set it on the File Object first (so we can use it later)
				const exifData = window[methodName](buffer.target.result);

				if (exifData && exifData.GPSLongitude && exifData.GPSLatitude)
				{
					let tmpLongitude = this.convertEXIFDataToGeolocation(exifData.GPSLongitude[0], exifData.GPSLongitude[1], exifData.GPSLongitude[2], exifData.GPSLongitudeRef);
					tmpLongitude = parseFloat(tmpLongitude.toFixed(8));
					let tmpLatitude = this.convertEXIFDataToGeolocation(exifData.GPSLatitude[0], exifData.GPSLatitude[1], exifData.GPSLatitude[2], exifData.GPSLatitudeRef);
					tmpLatitude = parseFloat(tmpLatitude.toFixed(8));
					this.pict.log.info('[Image] Found EXIF Data: lat/long', (tmpLatitude + ', ' + tmpLongitude));

					if (tmpLatitude && tmpLongitude)
					{
						// set the file details (used below in the generic datum fields loop for Observation Datum)
						pFileDetails.File.Latitude = tmpLatitude;
						pFileDetails.File.Longitude = tmpLongitude;
						// set the observation object's dedicated lat/long Capture fields
						pNewObservationObject.CaptureLatitude = tmpLatitude;
						pNewObservationObject.CaptureLongitude = tmpLongitude;
					}
				}
				// set altitude (store on file object)
				if (exifData && exifData.GPSAltitude && Object.keys(exifData.GPSAltitude)?.length)
				{
					pFileDetails.File.Altitude = parseFloat(exifData.GPSAltitude);
					this.pict.log.info('[Image] Found EXIF Data: altitude', exifData.GPSAltitude);
				}

				// set any additional EXIF data from the File object to the Observation Datum fields, if found
				const datumKeys = [ 'Altitude', 'DeviceTilt', 'HeadingMagnetic', 'HeadingTrue', 'HorizontalAccuracy', 'Latitude', 'Longitude', 'VerticalAccuracy' ];
				datumKeys.forEach((key) =>
				{
					if (pFileDetails.File[key])
					{
						pNewObservationObject.Details[pDatumType][0].Datum[key] = pFileDetails.File[key];
					}
				});
				resolve(pNewObservationObject);
			};
			// call the methods above by reading the file as an array buffer
			readerExif.readAsArrayBuffer(pFileDetails.File);
		});
	}

	/**
	 * Broadcast a document change to other applications listening for changes (FB Web, etc.)
	 * @param {Number} pIDDocument - The ID of the document that was changed
	 * @param {Number} pIDProject - The ID of the project that the document belongs to
	 * @return {void}
	 */
	broadcastDocumentChangeOnObservationJoin = (pIDDocument, pIDProject) =>
	{
		if (!pIDDocument && !pIDProject)
		{
			this.pict.log.warn('Cannot broadcast document change - missing required data (need either IDDocument and/or IDProject).');
			return;
		}
		if (window.localStorage)
		{
			// we are doing a set, then remove in this same browser tab, however, other browser tabs will see the set action
			// and can do a callback via the watcher they should have applied (listed below)

			// NOTE: Some of this can't be known unless we fetch the document record, so we mimic this as a courtesy to other apps for now...
			//	   The primary document/app's saving method is still the best way to refresh parent/external views watching changes.
			const tmpDocumentChange = JSON.stringify({
				action: 'ObservationsAdded',
				updateTime: new Date(),
				IDDocument: pIDDocument,
				IDProject: pIDProject,
			});
			window.localStorage.setItem('documentChange', tmpDocumentChange);
			window.localStorage.removeItem('documentChange');

			// a generic watcher with jQuery for usage

			// // the receiving method an app should use to 'catch' this broadcast
			// $(window).on('storage', function(ev) {
			//	 // if this isn't the storage we're looking for, we're done here
			//	 if (ev.originalEvent.key !== 'documentChange') {
			//		 return;
			//	 }
			//	 // parse the stringy data we should be getting
			//	 let obj = ev.originalEvent.newValue && ev.originalEvent.newValue.length ? JSON.parse(ev.originalEvent.newValue) : {};
			//	 // on save or on status change
			//	 if (obj.action === 'Save') {
			//		 console.log(`A form was saved in another tab, we should probably update/refresh data?`);
			//		 // set your app action callback here!
			//	 } else if (obj.action === 'ApprovalStatusChange') {
			//		 console.log(`A form had a status change in another tab, we should probably update/refresh data?`);
			//		 // set your app action callback here!
			//	 }
			// });
		}
	};

	/**
	 * Convert EXIF data to a geolocation
	 * @param {Number} degrees - The degrees of the geolocation
	 * @param {Number} minutes - The minutes of the geolocation
	 * @param {Number} seconds - The seconds of the geolocation
	 * @param {String} direction - The direction of the geolocation
	 * @return {Number} - The geolocation
	 * @example
	 * convertEXIFDataToGeolocation(40, 26, 46.8, 'N'); // returns 40.44633333333333
	 * convertEXIFDataToGeolocation(79, 58, 56.4, 'W'); // returns -79.98233333333333
	 */
	convertEXIFDataToGeolocation = (degrees, minutes, seconds, direction) =>
	{
		let dd = degrees + minutes/60 + seconds/(60*60);
		// Don't do anything for N or E
		if (direction == 'S' || direction == 'W')
		{
			dd = dd * -1;
		}
		return dd;
	};

	/**
	 * Get the observation by ID
	 * @param {Number} pIDObservation - The ID of the observation to get
	 * @param {Function} [pCallback] - The callback function to call when the observation is fetched
	 * @return {Promise}
	 * @async
	 */
	async getObservationByID(pIDObservation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Observation/${pIDObservation}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching observation: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching observation: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Extract file observation page info.
	 * @param {Number} pIDObservation - The ID of the document that was changed
	 * @param {Function} pCallback - Callback to return the extracted info.
	 */
	async extractInfoByID(pIDObservation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Observation/${pIDObservation}/ExtractInfo`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error extracting info for observation: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error extracting info for observation: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Extract file observation page info.
	 * @param {Number} IDObservation - The ID of the File Observation.
	 * @param {Object} boundaries - The ID of the document that was changed.
	 * @param {Function} pCallback - Callback to return the subImage Observation.
	 */
	async extractSubImage(IDObservation, boundaries, pCallback)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `Observation/${ IDObservation }/Extract/Clone`;
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, boundaries,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating observation: `, pError);
					reject(new Error(`Error creating observation: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error creating observation: `, pBody.Error);
					reject(new Error(`Error creating observation: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					pCallback(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	async getObservationByIDList(pIDObservationList)
	{
		if (!Array.isArray(pIDObservationList) || pIDObservationList.length === 0)
		{
			return [];
		}
		// Concurrent callers asking for the same ids (several card decks marshaling at once) share one
		// request. Each gets its own record copies, since callers stamp per-namespace ordinals on them.
		const tmpRequestKey = pIDObservationList.map(String).sort().join(',');
		this._observationListRequests = this._observationListRequests || {};
		if (!this._observationListRequests[tmpRequestKey])
		{
			this._observationListRequests[tmpRequestKey] = new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Observations/FilteredTo/FBL~IDObservation~INN~${pIDObservationList.join(',')}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching observations by id list: `, pError);
							reject(pError);
						}
						else
						{
							resolve(pBody);
						}
					});
			}).finally(() =>
			{
				delete this._observationListRequests[tmpRequestKey];
			});
		}
		const tmpRecords = await this._observationListRequests[tmpRequestKey];
		return Array.isArray(tmpRecords) ? tmpRecords.map((pRecord) => Object.assign({}, pRecord)) : tmpRecords;
	}

	/**
	 * Get the tag types for an observation
	 * @param {Object} pObservation - The observation to get the tag types for
	 * @param {Number} pIDObservation - The ID of the observation to get the tag types for
	 * @return {Array<Object>} - An array of tag types for the observation
	 */
	getObservationTagTypes(pObservation, pIDObservation)
	{
		const tmpObservation = pObservation;

		// Build a map of all tag types for this observation, ignoring the SAVE tag.
		const tmpTagTypes = [];
		const tmpObservationTagSet = Object.keys(tmpObservation.Labels);

		for (let i = 0; i < tmpObservationTagSet.length; i++)
		{
			if (tmpObservationTagSet[i] !== 'SAVE')
			{
				tmpTagTypes.push({ TagType: tmpObservationTagSet[i], TagCount: tmpObservation.Labels[tmpObservationTagSet[i]].length });
			}
		}

		return tmpTagTypes;
	}

	/**
	 * Get the tags for an observation of a specific type
	 * @param {Object} pObservation - The observation to get the tags for
	 * @param {String} pTagType - The type of the tags to get
	 * @return {Array<String>} - An array of tags for the observation of the specified type
	 */
	getObservationTags(pObservation, pTagType)
	{
		const tmpObservation = pObservation;

		// Build a map of the tags for this type.
		const tmpTags = [];

		if (tmpObservation.Labels[pTagType])
		{
			const tmpLabelSet = tmpObservation.Labels[pTagType];

			for (let i = 0; i < tmpLabelSet.length; i++)
			{
				tmpTags.push(tmpLabelSet[i]);
			}
		}

		return tmpTags;
	}

	/**
	 * Get the observation types for a project or customer
	 * @param {Number} [pIDProject] - The ID of the project to get the observation types for
	 * @param {Function} [pCallback] - The callback function to call when the observation types are fetched
	 * @async
	 */
	async getObservationTypeManifest(pIDProject, pCallback)
	{
		let tmpURL = ``;
		// TODO: Come back to this later for Project level manifest joins - we need to filter by customer for now
		// if (pIDProject)
		// {
		// 	tmpURL = `ProjectObservationManifestJoins/By/IDProject/${pIDProject}`;
		// }
		// else
		// {
		tmpURL = `ObservationManifests`;
		// }

		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error fetching ObservationManifests: `, pError);
					reject(new Error(`Error fetching ObservationManifests: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error fetching ObservationManifests: `, pBody.Error);
					reject(new Error(`Error fetching ObservationManifests: ` + pBody.Error));
				}
				else if (pBody)
				{
					// filter out duplicates if we have them
					const tmpUniqueObservationTypes = [];
					const tmpUniqueObservationTypeMap = {};
					pBody.forEach((item) =>
					{
						// For PROJECTS, we need to filter by the project ID
						// if (!tmpUniqueObservationTypeMap[item.ObservationManifestName]) {
						// 	tmpUniqueObservationTypeMap[item.ObservationManifestName] = true;
						// 	tmpUniqueObservationTypes.push(item);
						// }
						// For CUSTOMERS (data format is different)
						if (!tmpUniqueObservationTypeMap[item.Name])
						{
							tmpUniqueObservationTypeMap[item.Name] = true;
							tmpUniqueObservationTypes.push(item);
						}
					});
					resolve(tmpUniqueObservationTypes);
					// if we have a callback, run it now
					if (pCallback)
					{
						pCallback(tmpUniqueObservationTypes);
					}
				}
			},
		));
	}

	/**
	 * Get the class for a label based on the observation tag object
	 * @param {Object} pTagObject - The tag object to get the class for
	 * @return {String} - The class for the label
	 * @example
	 * getLabelClassFromObservationTagObject({ TagType: 'Tag' }); // returns 'is-primary-25'
	 * getLabelClassFromObservationTagObject({ TagType: 'BidItem' }); // returns 'is-info-25'
	 */
	getLabelClassFromObservationTagObject(pTagObject)
	{
		let tmpClass = 'is-dark';

		if (!pTagObject || !pTagObject.TagType)
		{
			return tmpClass;
		}
		// TODO: revisit these colors for consistency and color blindness
		switch (pTagObject.TagType)
		{
		case 'Tag':
			tmpClass = 'has-text-white has-background-primary-25';
			break;
		case 'BidItem':
			tmpClass = 'has-text-white has-background-info-25';
			break;
		case 'Contractor':
			tmpClass = 'has-text-white has-background-link-25';
			break;
		case 'LineItem':
			tmpClass = 'has-text-white has-background-link-15';
			break;
		case 'Equipment':
			tmpClass = 'has-text-white has-background-info-15';
			break;
		}
		return tmpClass;
	}

	/**
	 * Get the display mapped details of an observation type
	 * @param {String} pObservationType - The type of the observation to get details for
	 * @return {Object} - An object with the display details of the observation type
	 * @example
	 * getObservationMappedDetails('Legacy Audio'); // returns { Icon: 'fa-volume-up', Type: 'Audio' }
	 * getObservationMappedDetails('Legacy Image'); // returns { Icon: 'fa-image', Type: 'Image' }
	 */
	getObservationMappedDetails = (pObservationType) =>
	{
		// TODO: this stuff should be moved to a configuration file or a centralized location for consistency
		const observationIconMap =
		{
			'File': 'fa-file',
			'Legacy Audio': 'fa-volume-up',
			'Legacy Equipment': 'fa-hammer',
			'Legacy Image': 'fa-image',
			'Legacy Narrative': 'fa-book',
			'Legacy Personnel': 'fa-user',
			'Legacy Start/Stop Work': 'fa-clock',
			'Legacy Temperature': 'fa-thermometer-half',
			'Legacy Traffic Control': 'fa-traffic-light-stop',
			'Legacy Video': 'fa-video',
			'Legacy Weather': 'fa-cloud-sun-rain',
			'WorkItem': 'fa-tasks',
		};
		const observationTypeMap =
		{
			'File': 'File',
			'Legacy Audio': 'Audio',
			'Legacy Density': 'Density Measurement',
			'Legacy Image': 'Image',
			'Legacy Narrative': 'Narrative',
			'Legacy Equipment': 'Equipment',
			'Legacy Materials': 'Material',
			'Legacy Personnel': 'Personnel',
			'Legacy Start/Stop Work': 'Start/Stop',
			'Legacy Temperature': 'Temperature',
			'Legacy Traffic Control': 'Traffic Control',
			'Legacy Video': 'Video',
			'Legacy Weather': 'Weather',
			'WorkItem': 'Work Item',
		};
		return {
			Icon: observationIconMap[pObservationType] || 'fa-table',
			Type: observationTypeMap[pObservationType] || pObservationType,
		};
	};

	/**
	 * Get the observation search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Object} pOptions - Contains the pagination options
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getObservationSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getObservationSearchCount(pSearchQuery, pOptions, pCallback)
	{
		const tmpURL = `ObservationsFilter/Count`;
		this.pict.HeadlightRestClient.postJSON(tmpURL, pSearchQuery,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the observation search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Object} pOptions - Contains the pagination options
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getObservationSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getObservationSearchResults(pSearchQuery, pOptions, pCallback)
	{
		const tmpURL = `ObservationsFilter`;
		const currentPage = pOptions?.CurrentPage || 1;
		const limit = pOptions?.PageSize || 25;
		const startCount = (currentPage - 1) * limit;
		const endCount = currentPage * limit;
		this.pict.HeadlightRestClient.postJSON(`${tmpURL}/${startCount}/${endCount}`, pSearchQuery,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * Group all passed observations by their Observation Type, returning an object with the observations grouped by type
	 * @param {Array} pObservations - The observations to group
	 * @return {Object} - An object with the observations grouped by their Observation Type
	 */
	groupObservationsByType = (pObservations) =>
	{
		const tmpGroupedObservations = {};
		if (!pObservations || !Array.isArray(pObservations))
		{
			return tmpGroupedObservations;
		}
		pObservations?.forEach((observation) =>
		{
			const tmpType = observation.ObservationType;
			if (!tmpGroupedObservations[tmpType])
			{
				tmpGroupedObservations[tmpType] =
				{
					ObservationList: [],
					ObservationType: observation.ObservationType,
					ObservationTypeDetails: this.getObservationMappedDetails(observation.ObservationType),
				};
			}
			tmpGroupedObservations[tmpType].ObservationList.push(observation);
		});
		return tmpGroupedObservations;
	};

	/**
	 * Cache busting for observation images of type (standard, preview and thumbnail-dense) for the observation.
	 * @param {Number} idObs - The ID of the observation to refresh.
	 * @param {Array} timeSet - An array of times to trigger a refresh on.
	 */
	cacheBustObsImages(idObs, timeSet)
	{
		const images = document.querySelectorAll(`[src*="/1.0/Observation/${ idObs }/Image/"]`);
		const outLineClassThick = 'has-animated-thick-outline';
		const defaultOutlineClass = 'has-animated-outline';
		let outLineClass = defaultOutlineClass;
		if (images.length)
		{
			images.forEach((i) =>
			{
				outLineClass = defaultOutlineClass;
				if (i instanceof HTMLImageElement && i.src?.includes('Preview'))
				{
					outLineClass = outLineClassThick;
				}
				i.classList.add(outLineClass);
			});
		}
		for (const time of timeSet)
		{
			setTimeout(()=>
			{
				const images = document.querySelectorAll(`[src*="/1.0/Observation/${ idObs }/Image/"]`);
				if (images.length)
				{
					images.forEach((i) =>
					{
						if (!(i instanceof HTMLImageElement))
						{
							return;
						}
						const srcWStamp = i.src?.split('?t')?.[0] + '?t=' + new Date().getTime();
						i.src = srcWStamp;
						if (time === timeSet[timeSet.length - 1])
						{
							outLineClass = defaultOutlineClass;
							if (i.src?.includes('Preview'))
							{
								outLineClass = outLineClassThick;
							}
							i.classList.remove(outLineClass);
						}
					});
				}
			}, time);
		}
	}

	/**
	 * Do a direct observation join to a document record (vs saving the document with the observation attached)
	 * @param {Number} pIDObservation - The ID of the observation to join
	 * @param {Number} pIDDocument - The ID of the document to join the observation to
	 * @param {Function} pCallback - The callback function to call when the observation is joined
	 * @example
	 * joinObservationToDocumentRecord(123, (response) => { console.log(response); });
	 */
	async joinObservationToDocumentRecord(pIDObservation, pIDDocument, pCallback)
	{
		// If we passed a document ID, join the observations to the document
		// NOTE: if you don't want to join the observations to the document, just don't pass an IDDocument
		if (!pIDDocument)
		{
			this.pict.log.warn('No document ID provided - skipping observation join.');
			return;
		}

		const tmpURL = `Document/${pIDDocument}/AddObservation/${pIDObservation}`;
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
			async (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating document observation join: `, pError);
					reject(new Error(`Error updating document observation join: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating document observation join: `, pBody.Error);
					reject(new Error(`Error updating document observation join: ` + pBody.Error));
				}
				else if (pBody)
				{
					if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument)
					{
						const obs = await this.getObservationByID(pIDObservation);
						this.pict.AppData.DocumentData.ReportData.Observations.push(obs);
						this.pict.providers.MediaRegistry.refreshDocumentObservations();
					}
					resolve(pBody);
					// if we have a callback, run it now
					if (pCallback)
					{
						pCallback(pBody);
					}
					// broadcast the document change for FB and other apps to pick up
					this.broadcastDocumentChangeOnObservationJoin(pIDObservation, pIDDocument);
				}
			},
		));
	}

	/**
	 * Do a direct observation unjoin from a document record (vs saving the document with the observation detached)
	 * @param {Number} pIDObservation - The ID of the observation to unjoin
	 * @param {Number} pIDDocument - The ID of the document to unjoin the observation from
	 * @param {Function} pCallback - The callback function to call when the observation is unjoined
	 * @example
	 * unjoinObservationFromDocumentRecord(123, (response) => { console.log(response); });
	 */
	unjoinObservationFromDocumentRecord(pIDObservation, pIDDocument, pCallback)
	{
		// If we passed a document ID, join the observations to the document
		// NOTE: if you don't want to join the observations to the document, just don't pass an IDDocument
		if (!pIDDocument)
		{
			this.pict.log.warn('No document ID provided - skipping observation join.');
			return;
		}

		const tmpURL = `Document/${pIDDocument}/RemoveObservation/${pIDObservation}`;
		this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating document observation join: `, pError);
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating document observation join: `, pBody.Error);
				}
				else if (pBody)
				{
					if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument)
					{
						this.pict.AppData.DocumentData.ReportData.Observations = this.pict.AppData.DocumentData.ReportData.Observations.filter((o) => o.IDObservation !== pIDObservation);
						this.pict.providers.MediaRegistry.refreshDocumentObservations();
					}
					// if we have a callback, run it now
					if (pCallback)
					{
						pCallback(pBody);
					}
					// broadcast the document change for FB and other apps to pick up
					this.broadcastDocumentChangeOnObservationJoin(pIDObservation, pIDDocument);
				}
			},
		);
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @param {Function} pLocalCallback - The callback function to call when the search is complete
	 * @async
	 */
	async performObservationSearch(pOptions = {}, pLocalCallback)
	{
		// TODO: when adding sorting to this, add {~T:ObservationSearch-Entry-SortBy~} back to ObservationSearch-Entry template
		const tmpSearchQuery = {};
		// handle the search filters
		if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
		{
			tmpSearchQuery['SearchText'] = pOptions.SearchText;
		}
		if (pOptions?.Projects && pOptions.Projects.length > 0)
		{
			tmpSearchQuery['IDProject'] = pOptions.Projects;
		}
		if (pOptions?.ObservationTypes && pOptions.ObservationTypes.length > 0)
		{
			tmpSearchQuery['ObservationType'] = pOptions.ObservationTypes;
		}
		if (pOptions?.StartDate && pOptions.StartDate.length > 0)
		{
			tmpSearchQuery['DesignatedTime'] = {
				From: pOptions.StartDate,
			};
		}
		if (pOptions?.EndDate && pOptions.EndDate.length > 0)
		{
			if (!tmpSearchQuery['DesignatedTime'])
			{
				tmpSearchQuery['DesignatedTime'] = {};
			}
			tmpSearchQuery['DesignatedTime'] = {
				To: pOptions.EndDate,
			};
		}

		try
		{
			// get the count of results first
			this.getObservationSearchCount(tmpSearchQuery, pOptions, (pCountResults) =>
			{
				// get the results
				this.getObservationSearchResults(tmpSearchQuery, pOptions, (pSearchResults) =>
				{
					// if there is a local callback function, call it
					if (pLocalCallback)
					{
						// call the local callback with the results of both the count and the search
						pLocalCallback(pSearchResults, pCountResults);
					}
				});
			});
		}
		catch (error)
		{
			this.pict.log.error('Error performing observation search:', error);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error performing observation search:</strong><br/><em>${error.message || error}</em>`,
				type: 'is-danger',
			});
			// if there is a local callback function, call it
			if (pLocalCallback)
			{
				pLocalCallback([]);
			}
		}
	}

	/**
	 * Format the observation record to be uploaded to the server. This also attaches the EXIF data to the observation if it is available.
	 * @param {Object} pFileDetails - The details of the file to upload
	 * @param {Number} pIDProject - The ID of the project to upload the observation to
	 * @param {Function} onObservationResult - The callback function to call when the observation is posted
	 * @param {Function} onProgressChange - The callback function to call when the progress of the upload changes
	 */
	async prepareObservationObjectFromFile(pFileDetails, pIDProject, onObservationResult, onProgressChange)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const datumType = pFileDetails?.ObservationType.replace('Legacy ', ''); // probably a better way to get these (manifest?)
		let tmpObservation = {
			Name: pFileDetails.Name || pFileDetails.FileName || `New ${ pFileDetails.ObservationType } Observation`,
			Description: pFileDetails.Description,
			Tags: Array.isArray(pFileDetails.Tags) ? pFileDetails.Tags : [ pFileDetails.Tags ],
			ObservationType: pFileDetails.ObservationType,
			Details: {},
			IDObservation: 0,
			IDProject: pIDProject,
			// set by Exif data below, if available
			CaptureLatitude: '0.00000000',
			CaptureLongitude: '0.00000000',
			// TODO: add these to the UI and allow the user to set them
			UserLatitude: pFileDetails.UserLatitude || '0.00000000',
			UserLongitude: pFileDetails.UserLongitude || '0.00000000',
			AlignmentStation: pFileDetails.AlignmentStation || 0,
			AlignmentOffset: pFileDetails.AlignmentOffset || 0,
		};
		// format this for the API
		tmpObservation.Details[datumType] = [ {
			'ArtifactType': datumType,
			'IDArtifact': 0,
			'Datum': {
				'FileName': pFileDetails.FileName,
				'FileMimeType': pFileDetails.File.type,
			},
		} ];
		// additional EXIF Data fields that might be set on images needs to be processed first
		if (pFileDetails.File.type.toLowerCase() === 'image/heic' || pFileDetails.File.type.toLowerCase() === 'image/jpg' || pFileDetails.File.type.toLowerCase() === 'image/jpeg')
		{
			await this.attachEXIFDatumToObservation(tmpObservation, pFileDetails, datumType);
		}

		const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();
		tmpObservation = Object.assign(tmpObservation, geoCoords);

		try
		{
			await this.uploadObservation(tmpObservation, pFileDetails, datumType, onObservationResult, onProgressChange);
		}
		catch (e)
		{
			this.pict.log.error('Error uploading observation: ', e);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error uploading observation:</strong><br/><em>${e.message || e}</em>`,
				type: 'is-danger',
			});
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
	}

	/**
	 * This method is used to return the appropriate icon for the passed file type.
	 * @param {String} pFileType
	 * @return {String}
	 */
	returnFileIconFromFileType = (pFileType) =>
	{
		switch (pFileType)
		{
		case 'image/jpeg':
		case 'image/png':
		case 'image/gif':
		case 'image/bmp':
			return 'fa-file-image';
		case 'video/mp4':
		case 'video/mov':
		case 'video/avi':
		case 'video/wmv':
			return 'fa-file-video';
		case 'audio/mp3':
		case 'audio/wav':
		case 'audio/aac':
		case 'audio/wma':
		case 'audio/mpeg':
			return 'fa-file-audio';
		case 'application/pdf':
			return 'fa-file-pdf';
		case 'application/msword':
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			return 'fa-file-word';
		case 'application/vnd.ms-excel':
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			return 'fa-file-excel';
		case 'application/vnd.ms-powerpoint':
		case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
			return 'fa-file-powerpoint';
		case 'text/plain':
			return 'fa-file-lines';
		case 'text/csv':
			return 'fa-file-csv';
		case 'application/zip':
		case 'application/x-7z-compressed':
		case 'application/x-rar-compressed':
		case 'application/x-tar':
		case 'application/gzip':
			return 'fa-file-zipper';
		case 'text/html':
			return 'fa-file-code';
		case 'application/json':
			return 'fa-file-code';
		case 'application/xml':
			return 'fa-file-code';
		default:
			return 'fa-file';
		}
	};

	/**
	 * This method is used to return the proper Observation Type for the passed file type.
	 * @param {String} pFileType
	 * @return {String}
	 */
	returnObservationTypeFromFileType = (pFileType) =>
	{
		switch (pFileType)
		{
		case 'image/jpeg':
		case 'image/png':
		case 'image/gif':
		case 'image/bmp':
			return 'Legacy Image';
		case 'video/mp4':
		case 'video/mov':
		case 'video/avi':
		case 'video/wmv':
			return 'Legacy Video';
		case 'audio/mp3':
		case 'audio/wav':
		case 'audio/aac':
		case 'audio/wma':
		case 'audio/mpeg':
			return 'Legacy Audio';
		default:
			return 'File';
		}
	};

	/**
	 * Get the file type from an observation record
	 * @param {Object} pObservation - The observation record
	 * @return {String} - The file type of the observation
	 */
	getObservationFileType(pObservation)
	{
		if (!pObservation || typeof pObservation !== 'object')
		{
			this.pict.log.error('Invalid observation record');
			return '';
		}
		// return the file type based on the observation type
		switch (pObservation.ObservationType)
		{
		case 'File':
			return pObservation?.Details?.File?.[0]?.Datum?.FileMimeType;
		case 'Legacy Image':
			return pObservation?.Details?.Image?.[0]?.Datum?.FileMimeType;
		case 'Legacy Audio':
			return pObservation?.Details?.Audio?.[0]?.Datum?.FileMimeType;
		case 'Legacy Video':
			return pObservation?.Details?.Video?.[0]?.Datum?.FileMimeType;
		default:
			return '';
		}
	}

	/**
	 * Post a new Observation to the server and upload the associated file
	 * @param {Object} pObservationDetails - The details of the observation to post
	 * @param {Object} pFileDetails - The details of the file to upload
	 * @param {String} pDatumType - The type of the datum to upload
	 * @param {Function} onObservationResult - The callback function to call when the observation is posted
	 * @param {Function} onProgressChange - The callback function to call when the progress of the upload changes
	 */
	async uploadObservation(pObservationDetails, pFileDetails, pDatumType, onObservationResult, onProgressChange)
	{
		const tmpURL = `Observation/`;
		const newObservationRecord = await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pObservationDetails,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating observation: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: `<strong>Error creating observation:</strong><br/><em>${pError.message || pError}</em>`,
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating observation: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error creating observation: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: `<strong>Error creating observation:</strong><br/><em>${pBody.Error.message || pBody.Error}</em>`,
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating observation: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
				}
			},
		));
		const artifact = newObservationRecord.Details[pDatumType][0];
		const file = pFileDetails.File;
		// show the progress bar update as the file is sent
		await this.uploadWithProgress(`Artifact/Media/${artifact.IDArtifact}/${artifact.Version}`, file, onProgressChange);
		// notify the caller AFTER the binary upload completes, not just after
		// the observation record is created — otherwise the upload panel closes
		// before large files finish transferring (race condition for >100MB files)
		onObservationResult(newObservationRecord);
	}

	/**
	 * Post an update to an Observation to the server.
	 * @param {Object} pObservationDetails - The details of the observation to post
	 * @param {Function} onObservationResult - The callback function to call when the observation is posted
	 */
	async updateObservation(pObservationDetails, onObservationResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `Observation/`;
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pObservationDetails,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating observation: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the observation.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating observation: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating observation: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the observation.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating observation: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					onObservationResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Upload a file to the server with progress updates.
	 *
	 * Uses HeadlightRestClient.postBinary() so the request participates
	 * in REST interception (offline mode routes to BlobStore).
	 *
	 * @param {string} pURL - The relative URL to upload the file to (e.g. /1.0/Artifact/Media/5/1)
	 * @param {File} pFile - The file to upload
	 * @param {function} fOnProgressChange - Callback with progress ratio (0.0 to 1.0)
	 * @returns {Promise<boolean>} Resolves to true if the upload was successful
	 */
	async uploadWithProgress(pURL, pFile, fOnProgressChange)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.fable.services.HeadlightRestClient.postBinary(
				pURL,
				pFile,
				pFile.type,
				(pError, pBody) =>
				{
					if (pError)
					{
						reject(pError);
					}
					else
					{
						resolve(true);
					}
				},
				fOnProgressChange
			);
		});
	}

	/**
	 * Download a binary file from an Artifact.
	 *
	 * Uses HeadlightRestClient.getBinaryBlob() so the request participates
	 * in REST interception (offline mode retrieves from BlobStore).
	 *
	 * @param {number|string} pArtifactID - The Artifact ID
	 * @param {number|string} pVersion - The Artifact version
	 * @returns {Promise<Blob>} The downloaded file as a Blob
	 */
	async downloadFileFromObservation(pArtifactID, pVersion)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.fable.services.HeadlightRestClient.getBinaryBlob(
				`Artifact/Media/${pArtifactID}/${pVersion}`,
				(pError, pBlob) =>
				{
					if (pError)
					{
						reject(pError);
					}
					else
					{
						resolve(pBlob);
					}
				}
			);
		});
	}

	/**
	 * Get a displayable URL for an observation's media.
	 *
	 * Returns a blob: URL from BlobStore if available offline,
	 * otherwise returns the server URL for online display.
	 *
	 * @param {object} pObservation - The observation record
	 * @param {string} pDatumType - The datum type key (e.g. 'Image', 'Video')
	 * @param {function} fCallback - Callback(pError, pURL)
	 */
	getObservationImageURL(pObservation, pDatumType, fCallback)
	{
		if (!pObservation || !pObservation.Details)
		{
			return fCallback(new Error('No observation or details provided'));
		}

		let tmpDetails = pObservation.Details;
		if (typeof tmpDetails === 'string')
		{
			try
			{
				tmpDetails = JSON.parse(tmpDetails);
			}
			catch (e)
			{
				return fCallback(new Error('Could not parse observation Details'));
			}
		}

		let tmpDatumEntries = tmpDetails[pDatumType];
		if (!Array.isArray(tmpDatumEntries) || tmpDatumEntries.length === 0)
		{
			return fCallback(new Error(`No ${pDatumType} datum entries found`));
		}

		let tmpEntry = tmpDatumEntries[0];
		let tmpIDArtifact = tmpEntry.IDArtifact;
		let tmpVersion = tmpEntry.Version || 1;

		if (!tmpIDArtifact)
		{
			return fCallback(new Error('No IDArtifact on datum entry'));
		}

		let tmpURL = `Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;

		// Try to get the blob through HeadlightRestClient (interceptor will
		// return from BlobStore if offline, or network if online)
		this.pict.fable.services.HeadlightRestClient.getBinaryBlob(tmpURL,
			(pError, pBlob) =>
			{
				if (pError || !pBlob)
				{
					// Fall back to the server URL for direct browser loading
					let tmpServerURL = this.pict.fable.services.HeadlightRestClient.formatUrl(tmpURL, true);
					return fCallback(null, tmpServerURL);
				}

				// Create an Object URL from the blob for display
				try
				{
					let tmpBlobURL = URL.createObjectURL(pBlob);
					return fCallback(null, tmpBlobURL);
				}
				catch (e)
				{
					let tmpServerURL = this.pict.fable.services.HeadlightRestClient.formatUrl(tmpURL, true);
					return fCallback(null, tmpServerURL);
				}
			});
	}

	getLabelTypeFromObservation(pObservation)
	{
		if (pObservation && pObservation.ObservationType)
		{
			const tmpLabelType = this.getObservationMappedDetails(pObservation.ObservationType);
			return tmpLabelType;
		}
		return null;
	}
	/**
	 * Sorts the observations by a given key and order
	 * @param {Array} pObservations - The observations to sort
	 * @param {String} pSortBy - The key to sort by
	 * @param {String} pSortOrder - The order to sort by (asc or desc)
	 * @return {Array} - The sorted observations
	 */
	sortObservationsByKey(pObservations, pSortBy, pSortOrder)
	{
		if (!pObservations || !pObservations.length)
		{
			return pObservations;
		}
		if (!pSortBy)
		{
			this.pict.log.warn('No sort key provided - returning unsorted observations.');
			return pObservations;
		}
		// TODO: Add support for Labels and Datums
		const tmpSortOrder = pSortOrder && pSortOrder.toLowerCase() === 'desc' ? -1 : 1;
		const tmpSortedObservations = pObservations.sort((a, b) =>
		{
			const aValue = a[pSortBy];
			const bValue = b[pSortBy];
			if (aValue < bValue)
			{
				return -1 * tmpSortOrder;
			}
			if (aValue > bValue)
			{
				return 1 * tmpSortOrder;
			}
			return 0;
		});
		return tmpSortedObservations;
	}

	/**
	 * Handles filtering a list of observations based on the filter options passed in.
	 * This is used to apply the filters set in the options to the observation list after we get the search results back from the server.
	 * This is used in cases where a subset list of observations is already provided locally (ex: in the document data) and we want to apply
	 * the filters from options to that list without having to make another call to the server.
	 *
	 * Expected JSON PictForm structure:
	 * "FiltersObject": {
	 *     "Include": {
	 * 			"ObservationTypes": ["Type1", "Type2"],
	 * 			"Descriptions": ["Description1", "Description2"],
	 * 			"LabelTypes": [
	 * 				{
	 * 					"LabelType": "LabelType1",
	 * 					"Values": ["Value1", "Value2"]
	 * 				},
	 * 				{
	 * 					"LabelType": "LabelType2",
	 * 					"Values": ["Value3", "Value4"]
	 * 				}
	 * 			]
	 * 		}
	 * 		"Exclude": {
	 * 			"ObservationTypes": ["Type3", "Type4"],
	 * 			"Descriptions": ["Description3", "Description4"],
	 * 			"LabelTypes": [
	 * 				{
	 * 					"LabelType": "LabelType3",
	 * 					"Values": ["Value5", "Value6"]
	 * 				},
	 * 				{
	 * 					"LabelType": "LabelType4",
	 * 					"Values": ["Value7", "Value8"]
	 * 				}
	 * 			]
	 * 		}
	 * }
	 *
	 * @param {Object} pFilters - The filter options to apply to the observation list.
	 * @param {Array} pObservationList - The list of observations to be filtered.
	 * @return {Array} - The filtered list of observations after applying the filters from options.
	 */
	handleFilteringObservationsInList(pFilters, pObservationList)
	{
		// if there are no observations in the list, we can just return the empty list without doing any filtering
		if (!pObservationList || !pObservationList.length)
		{
			return pObservationList;
		}
		if (!pFilters || !Object.keys(pFilters).length)
		{
			this.pict.log.info(`No observation filters set in options. Returning unfiltered observation list.`);
			return pObservationList;
		}
		// apply the filters from options to the observation list. We apply the "Include" filters first, and then the "Exclude" filters second,
		// so that we can first narrow down the list based on what we want to include, and then remove any observations that we want to exclude from that narrowed down list.
		const { Include, Exclude } = pFilters;
		let filteredObservationList = pObservationList;
		// apply the "Include" filters first to narrow down the list
		if (Include && Object.keys(Include).length)
		{
			if (Include.ObservationTypes && Include.ObservationTypes.length)
			{
				filteredObservationList = filteredObservationList.filter((o) => Include.ObservationTypes.includes(o.ObservationType));
			}
			// complex LabelType structure needs to be traversed for observation labels
			if (Include.LabelTypes && Include.LabelTypes.length)
			{
				for (const labelFilter of Include.LabelTypes)
				{
					filteredObservationList = filteredObservationList.filter((o) =>
					{
						if (o.Labels.hasOwnProperty(labelFilter.Type) && o.Labels[labelFilter.Type].length)
						{
							return o.Labels[labelFilter.Type].find((l) => l.TagType === labelFilter.Type && labelFilter.Values.includes(l.Tag));
						}
						return false;
					});
				}
			}
		}
		// then apply the "Exclude" filters to remove any observations we don't want in the list after we've narrowed it down with the "Include" filters
		if (Exclude && Object.keys(Exclude).length)
		{
			if (Exclude.ObservationTypes && Exclude.ObservationTypes.length)
			{
				filteredObservationList = filteredObservationList.filter((o) => !Exclude.ObservationTypes.includes(o.ObservationType));
			}
			// complex LabelType structure needs to be traversed for observation labels
			if (Exclude.LabelTypes && Exclude.LabelTypes.length)
			{
				for (const labelFilter of Exclude.LabelTypes)
				{
					filteredObservationList = filteredObservationList.filter((o) =>
					{
						if (o.Labels.hasOwnProperty(labelFilter.Type) && o.Labels[labelFilter.Type].length)
						{
							return !o.Labels[labelFilter.Type].find((l) => l.TagType === labelFilter.Type && labelFilter.Values.includes(l.Tag));
						}
						return true;
					});
				}
			}
		}
		this.pict.log.info(`Applied observation filters. Original list had ${pObservationList.length} observations, after filtering it has ${filteredObservationList.length} observations.`);
		return filteredObservationList;
	}
}

module.exports = ObservationProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],876:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('./FileHandle.js')} FileHandle */

const PictProvider = require('pict-provider');

class ObservationSetProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/*
	 * Operations:
	 *
	 * Set level:
	 *
	 * Create (doesn't save)
	 * List (with optional filters)
	 * Load (by ID)
	 * Save
	 * Search
	 *
	 * Observation level:
	 *
	 * Add obs
	 * Remove obs
	 *
	 * Should not be here but here for now:
	 *
	 * Save file handle to observation
	 */

	/**
	 * @param {string} pName - The observation set name.
	 * @param {number} [pIDProject] - The project ID the set lives in.
	 *
	 * @return {ObservationSet} - The observation set object.
	 */
	createSet(pName, pIDProject = 0)
	{
		return { Name: pName || 'New Observation Set', Observations: [], IDProject: pIDProject };
	}

	/**
	 * @typedef {Object} ObservationSetFilters
	 * @property {number|string} [IDProject] - The project ID the set lives in.
	 * @property {number|string} [CreatingIDUser] - The ID of user who created the set.
	 * @property {string} [Name] - The name of the observation set.
	 * @property {Array<number>} [ObservationIDs] - Sets that container the specified observation IDs.
	 * @property {number} [Offset] - The offset to start at. Defaults to zero.
	 * @property {number} [PageSize] - The number of items to return. Defaults to 300.
	 * TODO: This is a brainstorm of what this could possibly do
	 */

	/**
	 * @typedef {Object} ObservationSet
	 * @property {number} [IDObservationSet] - The ID of the observation set.
	 * @property {number} [IDProject] - The project ID the set lives in.
	 * @property {string} [Name] - The name of the observation set.
	 * @property {string} [Description] - The description of the set.
	 * @property {number} [CreatingIDUser] - The ID of user who created the set.
	 * @property {Date} [CreateDate] - The date the set was created.
	 * @property {Array<Observation>} Observations - The observations in the set.
	 * TODO: whatever is in here
	 */

	/**
	 * @typedef {any} Observation
	 * TODO: placeholder for now
	 */

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON PUT request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON POST request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _post(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON DELETE request.
	 *
	 * @param {string} entityType - The entity type to delete.
	 * @param {number} entityID - The entity ID to delete.
	 * @return {Promise<any>} - The response.
	 */
	async _del(entityType, entityID)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.deleteEntity(entityType, entityID, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {ObservationSetFilters} pFilters - The filters to apply.
	 * @return {Promise<Array<ObservationSet>>} - The list of observation sets.
	 */
	async listSets(pFilters)
	{
		let filterStanza = '';
		if (pFilters.IDProject)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBV~IDProject~EQ~${pFilters.IDProject}`;
		}
		if (pFilters.CreatingIDUser)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBV~CreatingIDUser~EQ~${pFilters.CreatingIDUser}`;
		}
		if (pFilters.Name)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBV~Name~LK~${encodeURIComponent(`%${pFilters.Name}%`)}`;
		}
		if (pFilters.ObservationIDs)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBL~ObservationIDs~INN~${pFilters.ObservationIDs.join(',')}`;
		}
		let { Offset: offset, PageSize: pageSize } = pFilters;
		if (typeof offset !== 'number' || offset < 0)
		{
			offset = 0;
		}
		if (typeof pageSize !== 'number' || pageSize < 1)
		{
			pageSize = 300;
		}
		if (filterStanza)
		{
			return await this._get(`ObservationSets/FilteredTo/${filterStanza}/${offset}/${pageSize}`);
		}
		return await this._get(`ObservationSets/${offset}/${pageSize}`);
	}

	/**
	 * @param {ObservationSet} pSet - The set to join to a Document by the current IDDocument on AppData.
	 * @return {Promise<void>}
	 */
	async joinSetToDocumentId(pSet)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;

		if (pSet.IDObservationSet && tmpIDDocument)
		{
			const documentJoins = await this._get(`DocumentPolyJoins/By/IDDocument/${tmpIDDocument}`);
			const tmpSetJoinRecord =
			{
				RemoteType: 'ObservationSet',
				IDRemote: pSet.IDObservationSet,
				IDDocument: tmpIDDocument,
			};
			// if no joins yet, then create one
			if (documentJoins.length === 0)
			{
				await this._post(`DocumentPolyJoins`, [ tmpSetJoinRecord ]);
			}
			else
			{
				// if there is a list of joins, make sure we don't have a join already by the same ID
				const existingJoin = documentJoins.find((x) => x.IDRemote == pSet.IDObservationSet);
				if (!existingJoin)
				{
					await this._post(`DocumentPolyJoins`, [ tmpSetJoinRecord ]);
				}
			}
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
	}

	/**
	 * @param {ObservationSet} pSet - The set to delete the join from a Document by the current IDDocument on AppData.
	 * @return {Promise<void>}
	 */
	async deleteDocumentSetJoin(pSet)
	{
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (pSet.IDObservationSet && tmpIDDocument)
		{
			const documentJoins = await this._get(`DocumentPolyJoins/By/IDDocument/${tmpIDDocument}`);
			const existingJoin = documentJoins.find((x) => x.IDRemote == pSet.IDObservationSet);
			if (existingJoin)
			{
				await this._del(`DocumentPolyJoins`, existingJoin.IDDocumentPolyJoin);
			}
		}
	}

	/**
	 * @param {ObservationSet} pIDDocument - The set to get the joins from a Document by the current IDDocument on AppData.
	 * @return {Promise<Array<any>>} - The list of "ObservationSet" joins for the current document.
	 */
	async getDocumentSetJoinList(pIDDocument)
	{
		const IDDocument = pIDDocument ?? this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (IDDocument)
		{
			// filter out any joins that are not "ObservationSet" type
			return await this._get(`DocumentPolyJoins/FilteredTo/FBV~IDDocument~EQ~${IDDocument}~FBV~RemoteType~EQ~ObservationSet`);
		}
		return Promise.resolve([]);
	}

	/**
	 * @param {ObservationSet} pIDDocument - The set to get the joins from a Document by the current IDDocument on AppData.
	 * @return {Promise<Array<any>>} - The list of "ObservationSet" joins for the current document.
	 */
	async getObservationSetsForDocument(pIDDocument)
	{
		const IDDocument = pIDDocument ?? this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (IDDocument)
		{
			// filter out any joins that are not "ObservationSet" type
			const tmpExistingJoins = await this.getDocumentSetJoinList(IDDocument);
			if (tmpExistingJoins && tmpExistingJoins.length > 0)
			{
				return this._get(`ObservationSets/FilteredTo/FBL~IDObservationSet~INN~${tmpExistingJoins.map((x) => x.IDRemote).join(',')}`);
			}
		}
		return Promise.resolve([]);
	}

	/**
	 * NOTE: Does not save the observation records; save them first!
	 *
	 * @param {ObservationSet} pSet - The set to save.
	 * @return {Promise<ObservationSet>} - The saved set.
	 */
	async saveSet(pSet)
	{
		// check for passing the wrong thing
		if (typeof pSet !== 'object' || !pSet)
		{
			if (typeof pSet === 'string' || typeof pSet === 'number')
			{
				this.pict.log('warn', 'saveSet is expecting a passed "set", not an ID! You passed:', pSet);
				return this.loadSet(pSet);
			}
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		try
		{
			const setObservations = pSet.Observations || [];
			let setToSave = Object.assign({}, pSet);
			delete setToSave.Observations;
			if (!pSet.IDObservationSet && !this.debouncedSet)
			{
				this.debouncedSet = this._put(`ObservationSet/Upsert`, setToSave);
				setToSave = Object.assign({}, await this.debouncedSet);
			}
			else if (!pSet.IDObservationSet && this.debouncedSet)
			{
				setToSave = Object.assign(await this.debouncedSet, pSet);
			}
			else
			{
				setToSave = await this._put(`ObservationSet/Upsert`, setToSave);
				const existingObservations = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${setToSave.IDObservationSet}`);
				const desiredObservations = setObservations.map((x) => x.IDObservation).filter((x) => x > 0);
				const toAdd = setObservations.filter((x) => !existingObservations.find((y) => y.IDObservation === x.IDObservation)).map((x) => ({ IDObservation: x.IDObservation, IDObservationSet: setToSave.IDObservationSet }));
				const toRemove = existingObservations.filter((x) => !desiredObservations.includes(x.IDObservation));

				for (const obs of toRemove)
				{
					await this._del('ObservationSetObservationJoin', obs.IDObservationSetObservationJoin);
				}
				await this._post(`ObservationSetObservationJoins`, toAdd);
			}
			Object.assign(pSet, setToSave);
		}
		finally
		{
			this.debouncedSet = null;
			// join to document if it's not already joined
			this.joinSetToDocumentId(pSet);
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
			return pSet;
		}
	}

	async loadSet(pIDObservationSet)
	{
		const set = await this._get(`ObservationSet/${pIDObservationSet}`);
		const joins = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${pIDObservationSet}`);
		set.Observations = await this._get(`Observations/FilteredTo/FBL~IDObservation~INN~${joins.map((x) => x.IDObservation).join(',')}`);
		return set;
	}

	async loadSetObservations(pIDObservationSet)
	{
		const set = await this.loadSet(pIDObservationSet);
		return set.Observations;
	}

	async isIncludedInSet(pIDObservationSet, pIDObservation)
	{
		const setObservations = await this.loadSetObservations(pIDObservationSet);
		return setObservations.map((o) => o.IDObservation).includes(parseInt(pIDObservation));
	}

	/**
	 * @param {ObservationSet} pSet - The set to add the observation to.
	 * @param {Observation} pObservation - The observation to add.
	 * @param {Number} pSetID - An ObservationSet ID to add the observation to.
	 * @return {Promise<ObservationSet>} - The set with the observation added.
	 */
	async addObservation(pSet, pObservation, pSetID)
	{
		if (!pObservation)
		{
			throw new Error('Observation is required');
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		if (!pSet && pSetID)
		{
			pSet =
			{
				IDObservationSet: pSetID,
				Observations: [],
			};
		}
		if (!pSet.Observations)
		{
			pSet.Observations = [];
		}
		if (pSet.IDObservationSet && pObservation.IDObservation)
		{
			const joins = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${pSet.IDObservationSet}~FBV~IDObservation~EQ~${pObservation.IDObservation}`);
			if (joins.length > 0) // already joined
			{
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
				return pSet;
			}
			await this._post(`ObservationSetObservationJoin`, { IDObservation: pObservation.IDObservation, IDObservationSet: pSet.IDObservationSet });
		}

		pSet.Observations.push(pObservation);
		if (this.pict.providers.MediaRegistry && this.pict.providers.DocumentProvider)
		{
			this.pict.providers.MediaRegistry.updateNamespacesByIDObservationSet(pSet.IDObservationSet, pSet.Observations);
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
		return pSet;
	}

	/**
	 * @param {ObservationSet} pSet - The set to remove the observation from.
	 * @param {Observation} pObservation - The observation to remove.
	 * @return {Promise<ObservationSet>} - The set with the observation removed.
	 */
	async removeObservation(pSet, pObservation)
	{
		if (!pObservation)
		{
			throw new Error('Observation is required');
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		if (!pSet.Observations)
		{
			pSet.Observations = [];
		}

		const index = pSet.Observations.findIndex((x) => x === pObservation);
		if (index >= 0)
		{
			pSet.Observations.splice(index, 1);
		}
		if (pSet.IDObservationSet && pObservation.IDObservation)
		{
			const joins = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${pSet.IDObservationSet}~FBV~IDObservation~EQ~${pObservation.IDObservation}`);
			if (joins.length > 0)
			{
				await this._del(`ObservationSetObservationJoin`, joins[0].IDObservationSetObservationJoin);
			}
		}
		if (this.pict.providers.MediaRegistry && this.pict.providers.DocumentProvider)
		{
			this.pict.providers.MediaRegistry.updateNamespacesByIDObservationSet(pSet.IDObservationSet, pSet.Observations);
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
		return pSet;
	}

	/**
	 * @param {Observation} pObservation - The observation to save.
	 * @param {FileHandle} pFileHandle - The file handle to save
	 * @return {Promise<Observation>} - The saved observation.
	 */
	async createObservationFromFileHandle(pObservation, pFileHandle)
	{
		throw new Error('Not implemented');
		//FIXME: implement
		// 1. create obs
		// 2. upload file
		// 3. create tracking relationship / metadata (needs definition)
	}
}

module.exports = ObservationSetProvider;
module.exports.default_configuration = {};

},{"headlight-rest-client":12,"pict-provider":479}],877:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class PlantProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Plant by ID
	 * @param {String|Number} pPlantID - The Plant ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getPlantByID(pPlantID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pPlantID)
			{
				this.pict.log.error('No Plant ID provided.');
				return reject(new Error('No Plant ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`ProductionPlant/${pPlantID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Plant: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = PlantProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],878:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProducerProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Producer by ID
	 * @param {String|Number} pProducerID - The Producer ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getProducerByID(pProducerID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProducerID)
			{
				this.pict.log.error('No Producer ID provided.');
				return reject(new Error('No Producer ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Organization/${pProducerID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Producer: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Producers
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 */
	getProducers()
	{
		return new Promise((resolve, reject) =>
		{
			// NOTE: Producers are a subset of Organizations set by the Type field
			const tmpSearchQuery = {
				filters: [
					{
						field: 'Type',
						comparator: 'EQ',
						target: 'Producer',
					},
				],
				orderBy: 'Name',
				orderDirection: 'ASC',
			};

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpSearchQuery.filters.push({
					field: 'IDCustomer',
					comparator: 'EQ',
					target: this.pict.AppData?.DocumentData?.ReportData?.IDCustomer || 0,
				});
			}

			const tmpURL = `Organizations/` + this.pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery);

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Producers list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ProducerProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],879:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProductProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Product by ID
	 * @param {String|Number} pProductID - The Product ID to search for
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getProductByID(pProductID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProductID)
			{
				this.pict.log.error('No Product ID provided.');
				return reject(new Error('No Product ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Product/${pProductID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Product: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ProductProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],880:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
// @ts-ignore
const PictProvider = require('pict-provider');

class ProjectFileProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Get the parent folder IDs for a given folder
	 * @param {Object} folder - The folder object to get the parent IDs for
	 * @param {Object} currentDataStructureList - The current data structure list to check against
	 * @param {Array} parentFolderIDs - The array of parent folder IDs to populate
	 * @return {Array} - An array of parent folder IDs
	 */
	getParentFolderIDs(folder, currentDataStructureList, parentFolderIDs = [])
	{
		if (folder.ParentIDProjectFileFolder === 0)
		{
			return parentFolderIDs;
		}
		if (folder.ParentIDProjectFileFolder > 0 && !currentDataStructureList.ProjectFileFolders.find( (x) => x.IDProjectFileFolder === folder.ParentIDProjectFileFolder))
		{
			//console.log('[DEBUG] getParentIDs', folder.ParentIDProjectFileFolder, parentFolderIDs, currentFolderList);
			parentFolderIDs.push(folder.ParentIDProjectFileFolder);

			const parentFolder = currentDataStructureList.AllProjectFileFolders.find((x) => x.IDProjectFileFolder === folder.ParentIDProjectFileFolder);
			if (Object.keys(parentFolder).length !== 0)
			{
				//add folder to existing list of ProjectFileFolders
				currentDataStructureList.ProjectFileFolders.push(parentFolder);
				return this.getParentFolderIDs(parentFolder, currentDataStructureList, parentFolderIDs);
			}
			else
			{
				this.log.error(`Parent folder with ID ${folder.ParentIDProjectFileFolder} not found for folder ${folder.Name}`);
				return parentFolderIDs;
			}
		}
	}

	getProjectFolderMapKey(pIDProjectFolder)
	{
		return `ProjectFolderMap~${pIDProjectFolder}`;
	}

	/**
	 * @param {string} rawString with special characters to escape
	 * @description Escapes special characters in a string to be used in a regular expression.
	 * @return {string} - The escaped string.
	 */
	escapeRegExp(rawString)
	{
		return rawString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	/**
	 * Get the project files and return in a structured format
	 * @param {Number} pIDProject - ID of the project being searched in
	 * @param {Object} pSearchFilters - Object containing the search filters, e.g. SearchText for files and SearchFolder for folders
	 * @param {Function} fCallback
	 */
	getProjectFilesDataStructure(pIDProject, pSearchFilters, fCallback)
	{
		this.pict.log.info(`I am getting project files for project ${pIDProject}`);

		let fileMeadowQuery = `FBV~IDProject~EQ~${pIDProject}`;

		const folderMeadowQuery = `FBV~IDProject~EQ~${pIDProject}`;
		const hasFolderSearchFilters = pSearchFilters?.SearchFolder && pSearchFilters?.SearchFolder.trim().length > 0;
		if (pSearchFilters?.SearchText && pSearchFilters?.SearchText.trim().length > 0)
		{
			fileMeadowQuery = `FBV~IDProject~EQ~${pIDProject}~FBV~Name~LK~%25${encodeURIComponent(pSearchFilters.SearchText.replace(/\*/g, '%25'))}%25`;
		}

		// @ts-ignore
		const tmpAnticipate = this.pict.newAnticipate();

		const tmpProjectFileDataStructureState = {};

		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Expire the cache for ProjectFile
				this.pict.EntityProvider?.recordSetCache?.['ProjectFile']?.expire(`FBV~IDProject~EQ~${pIDProject}`);
				this.pict.EntityProvider.getEntitySet('ProjectFile', fileMeadowQuery,
					function(pError, pRecordSet)
					{
						if (pError)
						{
							this.log.error(`Error downloading project files for project ${pIDProject}: ${pError}`, pError);
							return fCallback(pError);
						}

						// for (let i = 0; i < pRecordSet.length; i++)
						// {
						// 	this.pict.log.info(`I found project file number ${i} for project ${pIDProject}: ${JSON.stringify(pRecordSet[i])}`);
						// }

						tmpProjectFileDataStructureState.ProjectFiles = pRecordSet;

						return fNext();
					}.bind(this));
			}.bind(this));


		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Expire the cache for ProjectFileFolder
				this.pict.EntityProvider?.recordSetCache?.['ProjectFileFolder']?.expire(`FBV~IDProject~EQ~${pIDProject}`);
				//folderMeadowQuery is set to Project ID and then filtered later to match the Name
				this.pict.EntityProvider.getEntitySet('ProjectFileFolder', folderMeadowQuery,
					function(pError, pRecordSet)
					{
						if (pError)
						{
							this.log.error(`Error downloading project file folders for project ${pIDProject}: ${pError}`, pError);
							return fCallback(pError);
						}

						// for (let i = 0; i < pRecordSet.length; i++)
						// {
						// 	this.pict.log.info(`I found project file folder number ${i} for project ${pIDProject}: ${JSON.stringify(pRecordSet[i])}`);
						// }

						tmpProjectFileDataStructureState.AllProjectFileFolders = pRecordSet;
						if (!hasFolderSearchFilters)
						{
							// if there are no search filters, just return all folders
							tmpProjectFileDataStructureState.ProjectFileFolders = pRecordSet;
							return fNext();
						}
						const regex = new RegExp(this.escapeRegExp(pSearchFilters.SearchFolder), 'i'); // 'i' flag for case-insensitive matching
						tmpProjectFileDataStructureState.ProjectFileFolders = pRecordSet.filter((folder) => regex.test(folder.Name));
						return fNext();
					}.bind(this));
			}.bind(this));

		//retrieve parent folders and add to the data structure
		tmpAnticipate.anticipate(
			function(fNext)
			{
				if (hasFolderSearchFilters)
				{
					const tmpParentFolderIDs = [];
					for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFileFolders.length; i++)
					{
						const tmpFolder = tmpProjectFileDataStructureState.ProjectFileFolders[i];
						// if the folder has a parent and Not in ProjectFolderMap, add to list
						if (tmpFolder.ParentIDProjectFileFolder > 0 && !tmpParentFolderIDs.includes(tmpFolder.ParentIDProjectFileFolder))
						{
							tmpParentFolderIDs.push(this.getParentFolderIDs(tmpFolder, tmpProjectFileDataStructureState, tmpParentFolderIDs));
						}
					}

					if (tmpParentFolderIDs.length > 0)
					{
						//sort the project files as the above array is not built in any order
						tmpProjectFileDataStructureState.ProjectFileFolders.sort((a, b) =>
						{
							return a.IDProjectFileFolder - b.IDProjectFileFolder;
						});
						return fNext();
					}
					else
					{
						// No missing parent folders
						return fNext();
					}
				}
				else
				{
					// No missing parent folders
					return fNext();
				}
			}.bind(this));

		/*
		* This is where we take both project files and folders and merge them
		* into the same data structure to make them simpler to deal with on
		* the UI.
		*
		* The data structure will be an array of objects.
		* Each object will have the following properties:
		* - Name - the file name
		* - Type - the type of the object (Folder or any of the the file types appropriate to the Headlight Program)
		* - Size - the size of the object (in bytes -- would be awesome to show how large folders are but we can make that advanced thing later)
		* - Date - the date of the object
		* - Entity - A simple string reference to which entity this came from (ProjectFile or ProjectFileFolder)
		* - ID - the ID of the Entity
		*
		* Example Objects:
		* {
		* 	Name: 'MyFile.txt',
		* 	Type: 'File',
		* 	Size: 1234,
		* 	Date: '2014-01-01 12:00:00',
		* 	Entity: 'ProjectFile',
		* 	ID: 1234
		* }
		*
		* {
		* 	Name: 'MyFolder',
		* 	Type: 'Folder',
		* 	Size: 0,
		* 	Date: '2014-01-01 12:00:00',
		* 	Entity: 'ProjectFileFolder',
		* 	ID: 1234,
		*   ParentFolder: 1233
		* }
		*/
		tmpAnticipate.anticipate(
			function(fNext)
			{
				tmpProjectFileDataStructureState.MergedProjectFiles = [];
				// The folder map is going to potentially have circular references
				// This means the data structure won't be serializable.  Too bad.
				tmpProjectFileDataStructureState.ProjectFolderMap = {};

				// First, enumerate all folders and make map of them
				for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFileFolders.length; i++)
				{
					const tmpFolder = tmpProjectFileDataStructureState.ProjectFileFolders[i];

					tmpProjectFileDataStructureState.ProjectFolderMap[this.getProjectFolderMapKey(tmpFolder.IDProjectFileFolder)] = (
						{
							Name: tmpFolder.Name,
							Type: 'Folder',
							Size: 0,
							Date: tmpFolder.UpdateDate,
							Entity: 'ProjectFileFolder',
							IsFolder: 1,
							IsCustomerFolder: 0,
							ID: tmpFolder.IDProjectFileFolder,
							ParentFolder: tmpFolder.ParentIDProjectFileFolder,
							Children: [],
							_RowID: `${tmpFolder.Name.trim().replace(/ /g, '_').replace(/'/g, '')}_${tmpFolder.IDProjectFileFolder}`,
						});
				}

				// Second, build the tree of the folders
				const tmpProjectFileFolderKeys = Object.keys(tmpProjectFileDataStructureState.ProjectFolderMap);
				for (let i = 0; i < tmpProjectFileFolderKeys.length; i++)
				{
					const tmpFolderKey = tmpProjectFileFolderKeys[i];
					const tmpFolder = tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey];

					// Add the folder to its parent
					if (tmpFolder.ParentFolder > 0)
					{
						const tmpParentFolderKey = this.getProjectFolderMapKey(tmpFolder.ParentFolder);
						if (tmpProjectFileDataStructureState.ProjectFolderMap[tmpParentFolderKey])
						{
							tmpProjectFileDataStructureState.ProjectFolderMap[tmpParentFolderKey].Children.push(tmpFolder);
						}
						else
						{
							this.log.error(`Error adding folder ${tmpFolder.Name} to parent ${tmpParentFolderKey}: Parent not found`);
						}
					}
					else
					{
						// This is a root folder
						tmpProjectFileDataStructureState.MergedProjectFiles.push(tmpFolder);
					}
				}

				// Lastly, add the files to the folder on the tree
				for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFiles.length; i++)
				{
					const tmpFile = tmpProjectFileDataStructureState.ProjectFiles[i];

					const tmpFolderKey = this.getProjectFolderMapKey(tmpFile.IDProjectFileFolder);
					if (tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey])
					{
						tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey].Children.push(
							{
								Name: tmpFile.Name,
								Type: tmpFile.FileType,
								Size: 0,
								Date: tmpFile.UpdateDate,
								Entity: 'ProjectFile',
								IsFolder: 0,
								ID: tmpFile.IDProjectFile,
								IDObservation: tmpFile.IDObservation,
								_RowID: `File-${tmpFile.IDProjectFile}_${tmpFile.IDObservation}`,
							});
					}
					// If the file is not in a folder, create a 'Customer Files' folder and add it there
					else if (tmpFile.IDProjectFileFolder === 0)
					{
						const tmpCustomerFilesFolderKey = this.getProjectFolderMapKey(0);
						if (!tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey])
						{
							tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey] = (
								{
									Name: 'Customer Files',
									Type: 'Folder',
									Size: 0,
									Date: tmpFile.UpdateDate,
									Entity: 'ProjectFileFolder',
									IsFolder: 1,
									ID: 0,
									ParentFolder: 0,
									IsCustomerFolder: 1,
									Children: [],
									_RowID: `Customer_Files_0`,
								});
							tmpProjectFileDataStructureState.MergedProjectFiles.push(tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey]);
						}
						tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey].Children.push(
							{
								Name: tmpFile.Name,
								Type: tmpFile.FileType,
								Size: 0,
								Date: tmpFile.UpdateDate,
								Entity: 'ProjectFile',
								IsFolder: 0,
								ID: tmpFile.IDProjectFile,
								IDObservation: tmpFile.IDObservation,
								_RowID: `File-${tmpFile.IDProjectFile}_${tmpFile.IDObservation}`,
							});
					}
					// If the folder is not found, log an error
					else
					{
						this.log.error(`Error adding file ${tmpFile.Name} to folder ${tmpFolderKey}: Folder not found`);
					}
				}

				// hide empty folders if we're searching for a file
				if (pSearchFilters?.SearchText && pSearchFilters?.SearchText.trim().length > 0)
				{
					const doesFolderHaveFiles = (arr) =>
					{
						for (let i = 0; i < arr.length; i++)
						{
							const element = arr[i];

							if (element.IsFolder === 0)
							{
								return element;
							}
							else if (element.Children?.length > 0)
							{
								const foundInNested = doesFolderHaveFiles(element.Children);
								if (foundInNested !== undefined)
								{
									return foundInNested;
								}
								else
								{
									delete arr[i];
								}
							}
						}
						return undefined;
					};

					for (let index = 0; index < tmpProjectFileDataStructureState.MergedProjectFiles.length; index++)
					{
						if (!doesFolderHaveFiles(tmpProjectFileDataStructureState.MergedProjectFiles[index].Children))
						{
							delete tmpProjectFileDataStructureState.MergedProjectFiles[index];
						}
					}
				}
				return fNext(tmpProjectFileDataStructureState.MergedProjectFiles);
			}.bind(this));

		tmpAnticipate.wait(fCallback);
	}


	/**
	 * Get the ProjectFile by ID
	 * @param {Number} pIDProjectFile - The ID of the ProjectFile to get
	 * @param {Function} pCallback - The callback function to call when the ProjectFile is fetched
	 * @return {Promise}
	 * @async
	 */
	async getProjectFileByID(pIDProjectFile, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(`ProjectFile/${pIDProjectFile}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFile: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFile: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	async getProjectFileByIDList(pIDProjectFileList, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(`ProjectFiles/FilteredTo/FBL~IDProjectFile~INN~${pIDProjectFileList.join(',')}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFiles by id list: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFiles by id list: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the ProjectFolders by ProjectID
	 * @param {Number} pIDProject - The ID of the Project to get
	 * @param {Function} pCallback - The callback function to call when the ProjectFolders are fetched
	 * @return {Promise}
	 * @async
	 */
	async getProjectFileFoldersByProjectID(pIDProject, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				const tmpURL = `ProjectFileFolders/By/IDProject/${pIDProject}`;

				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFileFolders: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFileFolders: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the ProjectFileFolder search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileFolderSearchCount({ IDProject: 1234, Name: '2014' }, (count) => { console.log(count); });
	 */
	async getProjectFileFolderSearchCount(pSearchQuery, pCallback)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `ProjectFileFolders/Count${tmpFilter ? `/${tmpFilter}` : ''}`;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the ProjectFileFolder search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileFolderSearchResults({ IDProject: 1234, Name: '2014' }, (results) => { console.log(results); });
	 */
	async getProjectFileFolderSearchResults(pSearchQuery, pCallback)
	{
		const tmpURL = `ProjectFileFolders/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * Get the ProjectFile search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getProjectFileSearchCount(pSearchQuery, pCallback)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `ProjectFiles/Count${tmpFilter ? `/${tmpFilter}` : ''}`;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the ProjectFile search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getProjectFileSearchResults(pSearchQuery, pCallback)
	{
		const tmpURL = `ProjectFiles/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * This method performs an ProjectFile search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @param {Function} pLocalCallback - The callback function to call when the search is complete
	 * @async
	 */
	async performProjectFileSearch(pOptions = {}, pLocalCallback)
	{
		const tmpSearchQuery = {
			filters: [],
			pagination: {
				start: pOptions?.CurrentPage || 1,
				limit: pOptions?.PageSize || 25,
			},
			sort: {
				field: pOptions.SortBy || 'CreateDate',
				direction: pOptions.SortDirection || 'DESC',
			},
		};
		const folderSearchQuery = JSON.parse(JSON.stringify(tmpSearchQuery));

		// handle the search filters
		if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
		{
			tmpSearchQuery.filters.push({
				field: 'Name',
				comparator: 'LK',
				target: pOptions.SearchText,
			});
		}
		if (pOptions?.Projects && pOptions.Projects.length > 0)
		{
			tmpSearchQuery.filters.push({
				field: 'IDProject',
				comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
				target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
			});

			folderSearchQuery.filters.push({
				field: 'IDProject',
				comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
				target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
			});
		}
		if (pOptions?.SearchFolder && pOptions.SearchFolder?.trim().length > 0)
		{
			folderSearchQuery.filters.push({
				field: 'Name',
				comparator: 'LK',
				target: pOptions.SearchFolder,
			});
		}

		try
		{
			// @ts-ignore
			this.getProjectFileFolderSearchCount(folderSearchQuery, (pFolderCountResults) =>
			{
				this.getProjectFileFolderSearchResults(folderSearchQuery, (pFolderSearchResults) =>
				{
					if (pFolderSearchResults)
					{
						tmpSearchQuery.filters.push({
							field: 'IDProjectFileFolder',
							comparator: pFolderSearchResults.length === 1 ? 'EQ' : 'INN',
							target: pFolderSearchResults.length === 1 ? pFolderSearchResults[0].IDProjectFileFolder : pFolderSearchResults.map((x) => x.IDProjectFileFolder),
						});
					}

					this.getProjectFileSearchCount(tmpSearchQuery, (pCountResults) =>
					{
						// get the results
						this.getProjectFileSearchResults(tmpSearchQuery, (pSearchResults) =>
						{
							// if there is a local callback function, call it
							if (pLocalCallback)
							{
								// call the local callback with the results of both the count and the search
								pLocalCallback(pSearchResults, pCountResults);
							}
						});
					});
				});
			});
		}
		catch (error)
		{
			this.pict.log.error('Error performing ProjectFile search:', error);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error performing ProjectFile search:</strong><br/><em>${error.message || error}</em>`,
				type: 'is-danger',
			});
			// if there is a local callback function, call it
			if (pLocalCallback)
			{
				pLocalCallback([]);
			}
		}
	}

	/**
	 * Post an update to a Project File to the server.
	 * @param {Object} pProjectFile - The updated ProjectFile to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async updateProjectFile(pProjectFile, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFile/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pProjectFile,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating file: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating file: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating file: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating file: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Add a new Project File to the server.
	 * @param {Object} pProjectFile - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async addProjectFile(pProjectFile, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFile/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pProjectFile,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding file: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding file: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error adding file: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding file: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Add a new Project Folder to the server.
	 * @param {Object} pProjectFileFolder - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async addProjectFolder(pProjectFileFolder, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFileFolder/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pProjectFileFolder,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding folder: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding folder: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error adding folder: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding folder: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Post an update to a Project Folder to the server.
	 * @param {Object} pProjectFileFolder - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async updateProjectFolder(pProjectFileFolder, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFileFolder/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pProjectFileFolder,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating folder: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating folder: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating folder: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating folder: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Opens the observation panel for the user to select/search/upload images.
	 * @param {number} pIDProjectFile - The view object.
	 * @param {Object} pCallback - The input object.
	 * @return {void}
	 */
	handleProjectFileDeletion(pIDProjectFile, pCallback)
	{
		if (!pIDProjectFile)
		{
			this.pict.log.error('IDProjectFile was not passed.');
			return;
		}
		// @ts-ignore
		this.pict.HeadlightRestClient.deleteEntity('ProjectFile', pIDProjectFile, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete project file.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete project file!',
					type: 'is-danger',
				});
				pCallback(pError);
			}
			else
			{
			this.pict.log.info('Project File deleted successfully.', pBody);
			if (typeof pCallback === 'function')
			{
				pCallback(pBody);
			}
			}
		});
	}

	/**
	 * Opens the observation search panel for the user to select/search/ observations to add as project files.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pTarget - The target of the observation addition.
	 * @return {void}
	 */
	openSearchPanel(pView, pInput, pTarget)
	{
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterDocumentJoinCallback = async (observationResult) =>
		{
			await this.pict.views.ProjectFileSearch.addObservationToProjectFolderRecord(observationResult);
		};
		pView.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', async () =>
		{
			if (pTarget && pTarget === 'add-to-folder')
			{
				// start at the upload tab
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				// set the target for the observation panel to update
				pView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(pView.Hash, pInput, pInput, 'add-to-folder');
				//FIXME: mirgate this to call the new entry point to encapsulate this state
				this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Folder';
				this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Folder';
			}
			if (pTarget && pTarget === 'add-to-root')
			{
				// start at the upload tab
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				// set the target for the observation panel to update
				pView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(pView.Hash, pInput, pInput, 'add-to-root');
				//FIXME: mirgate this to call the new entry point to encapsulate this state
				this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Project Root';
				this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Project Root';
			}
		});
	}
}

module.exports = ProjectFileProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],881:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProjectProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Project by ID
	 * @param {String|Number} pProjectID - The Project ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getProjectByID(pProjectID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProjectID)
			{
				this.pict.log.error('No Project ID provided.');
				return reject(new Error('No Project ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Project/${pProjectID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Project: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Projects
	 * @param {string} pCustomerID - The Customer ID to search for
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getProjects(pCustomerID)
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Projects';

			// Filter by customer ID if provided
			if (pCustomerID)
			{
				tmpURL = `Projects/By/IDCustomer/${pCustomerID}`;
			}

			// Make the API call
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Projects list.', pError);
					return reject(pError); // Reject the promise in case of error
				}
				resolve(pBody); // Resolve with the retrieved data
			});
		});
	}
}

module.exports = ProjectProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],882:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/**
 * @typedef {Object|Array<String>} Payload
 * @property {String} [QRCode] - QRCode value of the item scanned.
 */
/**
 * @typedef {Object} QREvent
 * @property {Payload} payload - payload for the event.
 * @property {String} event - the action for the ui to consume from the event.
 */

/**
 * Entities whose "Printable" manifests describe a QR label layout.
 */
const _PrintableManifestEntities = [ 'Sample', 'Location' ];

/**
 * The product that OWNS the printable manifests (`LIMS-Sample-Printable` et al).
 *
 * They are LIMS configuration, not per-consumer configuration: a form document, the panels and the LIMS
 * app all print the same customer's label. Left unset the loader would look them up under the hosting
 * app's own product (e.g. `HeadlightDynamicForm-Sample-Printable`), find nothing, and silently fall back
 * to the built-in layout. Duplicating the manifests per product would mean keeping N copies of one
 * customer's label in sync, so the product is named here instead.
 */
const _PrintableManifestProduct = 'LIMS';

const libManifestPackagingService = require('manifest-packaging-service');

const qrTranslator = require('../../lib/qrcode-management/source/qr-translation.js');

const PictProvider = require('pict-provider');

const busLib = require('../../lib/qrcode-management/source/QRBus.js');

// Inline data URI for the HeadLight logo so QR code generation works in
// offline (iOS WKWebView) contexts where /images/ paths are unavailable.
//TODO: this is to support offline but is a bit hard to support - see if we can make this more robust
const HEADLIGHT_LOGO_BLACK_DATA_URI = 'data:image/png;base64,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';

class Dialog
{
	/**
	 *
	 * @param {Object} options
	 * @param {Object} options.body - The body of the dialog, can be a string or an HTMLElement
	 * @param {boolean} [options.closeOnBackdropClick=true] - Whether the dialog should close when the backdrop is clicked
	 */
	constructor(options)
	{
		this._dialog = document.createElement('div');
		Object.assign(this._dialog.style, {
			display: 'none',
			position: 'fixed',
			left: '50%',
			marginLeft: '-150px',
			width: '300px',
			top: '100px',
			zIndex: 1001,
			background: 'white',
		});

		this._dropShadow = document.createElement('div');
		Object.assign(this._dropShadow.style, {
			display: 'none',
			position: 'fixed',
			left: '0',
			top: '0',
			right: '0',
			bottom: '0',
			zIndex: 1000,
			backdropFilter: 'grayscale(1) blur(3px)',
			background: '#333333ba',
		});
		document.body.appendChild(this._dialog);
		document.body.appendChild(this._dropShadow);

		if (options.closeOnBackdropClick !== false)
		{
			this._dropShadow.addEventListener('click', () => this.hide());
		}

		if (typeof options.body === 'string')
		{
			this._dialog.innerHTML = options.body;
		}
		else if (options.body instanceof HTMLElement)
		{
			this._dialog.appendChild(options.body);
		}
		else
		{
			throw new Error('Unsupported options.body type: ' + typeof options.body);
		}
	}

	/**
	 * Locks scroll while dialog is open
	 * @return {void}
	 */
	lockScroll()
	{
		if (document.body.getAttribute('scroll-locked') === 'true')
		{
			return;
		}
		document.body.setAttribute('scroll-locked', 'true');
		document.body.style.overflow = 'hidden';
		document.body.style.position = 'relative';
	}

	/**
	 * Unlocks scroll when dialog is closed.
	 */
	unlockScroll()
	{
		document.body.removeAttribute('scroll-locked');
		document.body.style.overflow = '';
		document.body.style.position = '';
	}

	/**
	 * Shows the popup dialog.
	 */
	show()
	{
		this._dialog.style.display = 'block';
		this._dropShadow.style.display = 'block';
		this.lockScroll();
	}

	/**
	 * Hides the popup dialog.
	 */
	hide()
	{
		this._dialog.style.display = 'none';
		this._dropShadow.style.display = 'none';
		this.unlockScroll();
	}

	/**
	 * Destroys the popup dialog.
	 */
	destroy()
	{
		if (this._dialog.parentElement)
		{
			this._dialog.parentElement.removeChild(this._dialog);
		}
	}
}

// Documentation: https://scanapp.org/html5-qrcode-docs/docs/apis

class QRCodeProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this._dialog;
		this._qrCodeScanner;
		this._hiddenLayer;
		this._canvas;
		this._qrCodeContainer;
		this._printFrame;

		this.typeConfig = {};

		this.capturedQRCode = '';
		this.scannerTimer = Date.now();
		this.readerActive = false;
		this.globalHandler = (event) =>
		{};
		if (pOptions.globalHandler)
		{
			this.globalHandler = pOptions.globalHandler;
		}
		this.handler = this.globalHandler;

		this.printStyle = pOptions.printStyle || 'thin';
		this.customerLogo = null;
		this.getHeadlightLogo = null;

		this.lastCameraEvent =
		{
			time: Date.now(),
			content: '',
		};

		this.cameraKey = '';

		// Uncomment the block below to test the timing of scanning/keyboard events.
		/*
		window.logger = [];
		window.called = false;
		window.calledStart = 0;
		window.elapsed = 0;
		this.perfTimer = performance.now();
		*/

		this.QRBus = new busLib.QRBus({
			eventHandler: this.passEvent,
			getByQRCode: this.getByQRCode,
		});

		document.addEventListener('keypress', this.scannerWatcher);
		this.logosInitialized = false;
	}

	onAfterInitializeAsync(fCallback)
	{
		super.onAfterInitializeAsync((pError) =>
		{
			this.initializeLogos().finally(() => fCallback(pError));
		});
	}

	onBeforeLoadDataAsync(fCallback)
	{
		super.onBeforeLoadDataAsync((pError) =>
		{
			// The logos are only needed when a label prints; start loading them but do not hold up the document.
			this.initializeLogos();
			return fCallback(pError);
		});
	}

	onInitialize()
	{
		if (this.pict.providers.SessionProvider)
		{
			this.pict.providers.SessionProvider.onSessionChange((pNewSession) =>
			{
				delete this.headlightLogo;
				delete this.customerLogo;
				delete this.logosInitialized;
				delete this._logosPromise;
			});
		}
		return super.onInitialize();
	}

	/**
	 * Load the HeadLight and customer logos used on printed labels. Safe to call repeatedly: one load
	 * is shared, and the print paths await it so a label never draws before the logos arrive.
	 * @return {Promise<void>}
	 */
	initializeLogos()
	{
		if (!this.pict.PictApplication.loggedIn || this.logosInitialized)
		{
			return Promise.resolve();
		}
		if (this._logosPromise)
		{
			return this._logosPromise;
		}
		this.headlightLogo = new Image();
		this.headlightLogo.src = HEADLIGHT_LOGO_BLACK_DATA_URI;
		this._logosPromise = this.getCustomerLogo().then((res) =>
		{
			if (res)
			{
				this.customerLogo = new Image();
				this.customerLogo.src = `/1.0/Customer/Logo/${ res.IDCustomer }`;
				this.logosInitialized = true;
			}
		}).catch((err) =>
		{
			console.log('[QRCodeProvider] Error fetching customer logo, leaving logo field empty.');
		}).finally(() =>
		{
			delete this._logosPromise;
		});
		return this._logosPromise;
	}

	/**
	 * The current session, from the SessionProvider's copy when it has one (no extra CheckSession round trip).
	 * @return {Promise<any>}
	 */
	async _resolveSession()
	{
		const tmpSessionProvider = this.pict.providers?.SessionProvider;
		if (tmpSessionProvider && (typeof tmpSessionProvider.getSession === 'function'))
		{
			const tmpSession = await tmpSessionProvider.getSession();
			if (tmpSession)
			{
				return tmpSession;
			}
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('CheckSession', (pError, pResult) => (pError ? reject(pError) : resolve(pResult)));
		});
	}

	async getCustomerLogo()
	{
		const tmpSession = await this._resolveSession();
		const customerID = tmpSession?.CustomerID || tmpSession?.IDCustomer;
		return new Promise((resolve, reject) =>
		{
			let tmpRequestOptions = (
				{
					url: this.pict.HeadlightRestClient.formatUrl(`Customer/Logo/${ customerID }`),
				});
			tmpRequestOptions = this.pict.HeadlightRestClient._prepareRequestOptions(tmpRequestOptions);
			this.pict.HeadlightRestClient.restClient.getRawText(tmpRequestOptions, (pError, pResponse, pBody) =>
			{
				pError = this.pict.HeadlightRestClient._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					reject(pError);
				}
				resolve(pResponse.statusCode === 200 ? { IDCustomer: customerID, Body: pBody } : null);
			});
		});
	}

	generateNewQRCode(sample)
	{
		let QRCode = '';
		const user = this.pict.AppData?.FullUserRecord;
		// if we are using legacy format, we also need to get the user record to use for the QR code hash generation
		if (this.pict.AppData?.CurrentUser?.CustomerID == 10)
		{
			this.pict.log.info('Using Legacy Sample GUID format.');
			// LADOTD QRs feed SiteManager, which keys on the user's external (SiteManager) id. With no
			// ExternalSyncGUID, mint a deterministic placeholder "HL<IDUser>" — matching the materials app
			// (sample.ts generateGUID) — so the format stays valid instead of degrading to a plain user GUID.
			QRCode = this.pict.fable.services.HeadlightQRCodeHash.generateQRCodeHash({
				GUIDPrefix: user?.ExternalSyncGUID || `HL${this.pict.AppData?.CurrentUser?.UserID}`,
				LegacyFormat: true,
			});
		}
		else
		{
			this.pict.log.info('Using Standard Sample GUID format.');
			QRCode = this.pict.fable.services.HeadlightQRCodeHash.generateQRCodeHash({ IDProject: sample.IDProject, IDUser: this.pict.AppData?.CurrentUser?.UserID });
		}
		return QRCode;
	}

	/**
	 * Handler to pass to the QRBus instance, this function gets an entity by its QRCode.
	 * @param {String} entity
	 * @param {String} qr
	 * @return {Promise<Object|Error>}
	 */
	getByQRCode = async (entity, qr) =>
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${ entity }s/By/QRCode/${ qr }`, (error, result) =>
			{
				if (error)
				{
					reject(error);
				}
				else
				{
					if (entity === 'Location' && result?.[0]?.ParentIDLocation)
					{
						this.pict.HeadlightRestClient.getJSON(`${ entity }s/By/IDLocation/${ result[0].ParentIDLocation }`, (error, parentResult) =>
						{
							if (error)
							{
								reject(error);
							}
							else
							{
								if (parentResult.length)
								{
									result[0].ParentLocation = parentResult[0];
								}
								resolve(result[0]);
							}
						});
					}
					else if (result.length)
					{
						resolve(result[0]);
					}
					else
					{
						reject(new Error('No Item found with that QR Code.'));
					}
				}
			});
		});
	};

	/**
	 * Generic "get entity by ID" function.
	 * @param {String} entity - the type of entity
	 * @param {Number} ID -  the id of the entity
	 */
	getByID = async (entity, ID) =>
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${ entity }/${ ID }`, (error, result) =>
			{
				if (error)
				{
					reject(error);
				}
				else
				{
					resolve(result);
				}
			});
		});
	};

	/**
	 * Registers the "application level" handler for scanning events (when not in a workflow).
	 * @param {Function} func
	 */
	registerGlobalHandler(func)
	{
		this.globalHandler = func;
		this.handler = func;
	}

	/**
	 * Registers a workflow handler for scanning events (that temporarily replaces the global handler).
	 * Also resets the "last camera event".
	 * @param {Function} func
	 */
	startWorkflow(func)
	{
		this.handler = func;
		this.cameraKey = `${ Date.now() }`;
		this.lastCameraEvent =
		{
			time: Date.now(),
			content: '',
		};
	}

	/**
	 * Deregisters any current workflow handler for scanning events (and sets handling back to the global handler).
	 * Also resets the "last camera event".
	 */
	stopWorkflow()
	{
		this.handler = this.globalHandler;
		this.cameraKey = '';
		this.lastCameraEvent =
		{
			time: Date.now(),
			content: '',
		};
	}

	/**
	 * Passes events from the QRBus library on through to the current handler.
	 * @param {QREvent} event
	 */
	passEvent = (event) =>
	{
		this.handler(event);
	};

	/**
	 * Listener that watches for scan events from a barcode scanner and then sends them to the QRBus instance.
	 * @param {KeyboardEvent} event
	 */
	scannerWatcher = (event) =>
	{
		// Don't look for scan events on the login page.
		const isLoginPageActive = document.querySelector('#HeadlightLogin-Standard-Wrap.active:not(.is-hidden)');
		if (isLoginPageActive)
		{
			return;
		}
		// Leaving a bunch of comments in here with code that can be uncommented to test timing issues with scan events.
		//window.calledStart = window.called ? window.calledStart : performance.now();
		//window.called = true;
		//let k = Math.random();
		//window.logger.push(k + ' listener started ' + Date.now() + ' / ' + performance.now() + ' ' + event.key);
		const now = Date.now();
		//let nowPerf = performance.now();
		let sinceLast = now - this.scannerTimer;
		//let sinceLastPerf = nowPerf - this.perfTimer;
		if (sinceLast > 200)
		{
			//window.logger.push('Hit gap ' + sinceLast + ' ' + now + ' ' + this.scannerTimer + ' / ' + sinceLastPerf + ' ' + nowPerf + ' ' + this.perfTimer);
			this.scannerTimer = Date.now();
			//this.perfTimer = performance.now();
			this.capturedQRCode = '';
		}
		else if (event.key === 'Enter')
		{
			//window.called = false;
			//console.log(window.logger);
			//console.log(window.elapsed);
			if (this.capturedQRCode)
			{
				console.log('captured scan: ', this.capturedQRCode);
			}
			if (this.capturedQRCode.length > 10)
			{
				this.QRBus.receiveScan(this.capturedQRCode);
			}
			else
			{
				console.log('Cancelling scan b/c qr code is too small: ', this.capturedQRCode);
			}
			this.capturedQRCode = '';
		}
		sinceLast = now - this.scannerTimer;
		//sinceLastPerf = nowPerf - this.perfTimer;
		if (sinceLast <= 200)
		{
			this.capturedQRCode += event.key;
			this.scannerTimer = Date.now();
			//this.perfTimer = performance.now();
		}
		//window.logger.push(k + ' listener ended ' + this.capturedQRCode + ' ' + this.scannerTimer + ' ' + Date.now() + ' ' + sinceLast + ' / ' + this.perfTimer + ' ' + performance.now() + ' ' + sinceLastPerf);
		//window.elapsed = performance.now() - window.calledStart;
	};

	/**
	* @typedef {object} QRCodeOptions
	* @property {string} [previewID] - The ID of a DOM element to render the preview into.
	* @property {boolean} [raw] - if true, code is used as is and not put in a URL
	* @property {string} [type] - If passed, the passed type will be included in the qr code url
	* @property {string} [printStyle] - the style of label to print, current options are 'thin' and 'wide'
	* @property {number} [size] - same as width and height
	* @property {string[]} [footers] - additional text to print below the QR code
	* @property {string[]} [headers] - additional text to print above the QR code
	* @property {string[]} [bigRows] - lists footer rows that should be displayed in "bigger" text
	*/

	/**
	 * Passthrough to the "scanQRCode" method.
	 * @param {String} id
	 */
	async scan(id)
	{
		return await this.scanQrCode(id);
	}

	/**
	 * Opens a QR scanner camera instance onto an element with a given id.
	 * @param {String} id
	 * @param {Object} [options] - options for the scanner
	 */
	async openScanner(id, options = {})
	{
		return await this.scanQrCode(id, true, options);
	}

	/**
	 * Closes any open QR Scanner camera instance.
	 */
	async closeScanner()
	{
		return await new Promise((resolve, reject) =>
		{
			async function stopper(tries)
			{
				// @ts-ignore
				const localThis = _Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode;
				if (!localThis.canvasElement)
				{
					if (!tries || tries < 10)
					{
						console.log('deferring scanner stop: ', tries);
						setTimeout(()=>
						{
							stopper(tries ? tries + 1 : 1);
						}, 200);
					}
					else
					{
						console.log('Failed to stop camera, exhausted retries.');
						resolve();
					}
					return;
				}
				// @ts-ignore
				if (_Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode && _Pict.providers.QRCodeProvider._qrCodeScanner?.html5Qrcode?.stateManagerProxy?.isScanning())
				{
					// @ts-ignore
					await _Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode.stop();
				}
				resolve();
			};
			stopper();
		});
	}

	/**
	 * @param {string} code
	 * @param {QRCodeOptions} [options]
	 * @return {string} - base64 encoded image
	 */
	create(code, options = {})
	{
		const text = options.raw ? code : `${this.pict.providers.UtilityProvider.buildLinksUrl()}${ options.type ? `/${ options.type }` : '' }/qr/${code}`;
		return this.generateQRCodeImage({
			text: text,
			width: options.size || 256,
			height: options.size || 256,
		});
	}

	/**
	 * Formats strings for the "wide" print layout.
	 * @param {Array<String>} displayStrings
	 * @return {Array<String>}
	 */
	formatStringsForPrinting(displayStrings)
	{
		const finaldisplayStrings = [];
		displayStrings.forEach((s) =>
		{
			const tokens = s.split('COMPUTED_COLUMN');
			if (!tokens?.[1])
			{
				finaldisplayStrings.push(s.length > 80 ? s.substring(0, 77) + '...' : s);
				return;
			}
			if (tokens[0].length > 35)
			{
				tokens[0] = tokens[0].substring(0, 35) + '...';
			}
			if (tokens[1]?.length > 35)
			{
				tokens[1] = tokens[1].substring(0, 35) + '...';
			}
			finaldisplayStrings.push(`${ tokens[0].padEnd(40) }${ tokens[1] }`);
		});
		return finaldisplayStrings;
	}

	/**
	 * Using a Sample record, constructs the set of information to use while printing. Used for the "wide" template.
	 * @param {Object} record
	 * @return {Promise<Array<String>>}
	 */
	async getSamplePrintablesWide(record)
	{
		const formatLocation = (city, state, country) =>
		{
			if (!city && !state && !country)
			{
				return 'N/A';
			}
			else if (city && state)
			{
				return `${ city }, ${ state }`;
			}
			else if ((city && country) || (state && country))
			{
				return `${ city || '---' }, ${ state || '---' }, ${ country || '---' }`;
			}
			else
			{
				return city || state || country;
			}
		};
		const center = 'COMPUTED_COLUMN';
		const sampledByUser = record.SampledByIDUser ? (await this.getByID('User', record.SampledByIDUser)) : (await this.getByID('User', record.CreatingIDUser));
		const displayStrings = [
			`Description: ${ record.Name || 'N/A' }`,
			`Received: ${ record.ReceivedDate ? this.pict.fable.Dates.dayJS(record.ReceivedDate).format('MM/DD/YYYY') : 'N/A' }${ center }Sampled: ${ record.DesignatedTime ? this.pict.fable.Dates.dayJS(record.DesignatedTime).format('MM/DD/YYYY') : 'N/A' }`,
			`Container: ${ record.Container || 'N/A' }${ center }Container Count: ${ record.ContainerCount || 'N/A' }`,
			`Source: ${ record.ReceivedFrom || 'N/A' }${ center }Source Loc.: ${ formatLocation(record.SourceCity, record.SourceState, record.SourceCountry) }`,
		];
		const currentSampleLocation = parseInt(record?.Extension?.StorageLocation) ? (await this.pict.providers.LocationProvider.getLocationByID(parseInt(record?.Extension?.StorageLocation))) : null;
		displayStrings.push(`Storage Loc.: ${ currentSampleLocation?.Name || 'N/A' }${ center }Logged By: ${ sampledByUser.NameFirst } ${ sampledByUser.NameLast }`);
		// Probably applicable to most customers but commenting out for now for paragon.
		/*displayStrings.push(`Material: ${ record.IDMaterial ? (await this.getByID('Material', record.IDMaterial)).Name : 'N/A' }${ center }Location: ${ currentSampleLocations.map((loc)=>{ return `${ loc.Name }${ loc.ParentLocation ? ` linked to: ${ loc.ParentLocation.Name }` : '' }`; }).join(', ') || 'N/A' }`);
		if (record.IDOrganization)
		{
			const org = await this.getByID('Organization', record.IDOrganization);
			displayStrings.push(`Producer: ${ org.Name || 'N/A' }${ center }Producer Location: ${ org.City && org.State ? `${ org.City }, ${ org.State }` : 'N/A' }`);
		}*/
		// Probably applicable to most customers but commenting out for now for paragon.
		/*
		let plantString = '';
		if (record.IDProductionPlant)
		{
			const plant = await this.getByID('ProductionPlant', record.IDProductionPlant);
			plantString += `Plant: ${ plant.Name || 'N/A' }`;
		}
		if (record.IDProject)
		{
			const project = await this.getByID('Project', record.IDProject);
			plantString += plantString ? `${ center }Project: ${ project.Name || 'N/A' }` : `Project: ${ project.Name || 'N/A' }`;
		}
		if (plantString)
		{
			displayStrings.push(plantString);
		}*/
		displayStrings.push(`Notes: ${ record.Notes || 'N/A' }`);
		return this.formatStringsForPrinting(displayStrings);
	}

	/**
	 * Using a Location record, constructs the set of information to use while printing. Used for the "wide" template.
	 * @param {Object} record
	 * @return {Array<String>}
	 */
	getLocationPrintablesWide(record)
	{
		//const center = 'COMPUTED_COLUMN';
		const displayStrings =
		[
			`Name: ${ record.Name || 'N/A' }`,
		];
		return this.formatStringsForPrinting(displayStrings);
	}

	/**
	 * Using a Sample record, constructs the set of information to use while printing.
	 * @param {Object} record
	 * @param {String} [printStyleType]
	 * @return {Promise<Array<String>>}
	 */
	async getSamplePrintables(record, printStyleType)
	{
		const printStyle = printStyleType || this.printStyle;
		if (printStyle === 'wide')
		{
			return await this.getSamplePrintablesWide(record);
		}
		const sampledByUser = record.SampledByIDUser ? (await this.getByID('User', record.SampledByIDUser)) : (await this.getByID('User', record.CreatingIDUser));
		const displayStrings = [
			record.QRCode,
			`Name: ${ record.Name || 'N/A' }`,
			`Sample Date: ${ this.pict.fable.Dates.dayJS(record.DesignatedTime || record.CreateDate).toISOString() }`,
			`Material: ${ record.IDMaterial ? (await this.getByID('Material', record.IDMaterial)).Name : 'N/A' }`,
			`Sampled By: ${ sampledByUser.NameFirst } ${ sampledByUser.NameLast }`,
		];
		const currentSampleLocations = await this.pict.providers.LocationProvider.getLocationsBySampleID(record.IDSample);
		displayStrings.push(`Location: ${ currentSampleLocations.map((loc)=>
		{
			return `${ loc.Name }${ loc.ParentLocation ? ` linked to: ${ loc.ParentLocation.Name }` : '' }`;
		}).join(', ') || 'N/A' }`);
		if (record.IDProject)
		{
			const project = await this.getByID('Project', record.IDProject);
			displayStrings.push(`Project: ${ project.Name || 'N/A' }`);
		}
		if (record.IDOrganization)
		{
			const org = await this.getByID('Organization', record.IDOrganization);
			displayStrings.push(`Producer: ${ org.Name || 'N/A' }`);
			displayStrings.push(`Producer Location: ${ org.City && org.State ? `${ org.City }, ${ org.State }` : 'N/A' }`);
		}
		if (record.IDProductionPlant)
		{
			const plant = await this.getByID('ProductionPlant', record.IDProductionPlant);
			displayStrings.push(`Plant: ${ plant.Name || 'N/A' }`);
		}
		displayStrings.push(`Notes: ${ record.Notes || 'N/A' }`);
		return displayStrings;
	}

	/**
	 * Using a Location record, constructs the set of information to use while printing.
	 * @param {Object} record
	 * @param {String} [printStyleType]
	 * @return {Array<String>}
	 */
	getLocationPrintables(record, printStyleType)
	{
		const printStyle = printStyleType || this.printStyle;
		if (printStyle === 'wide')
		{
			return this.getLocationPrintablesWide(record);
		}
		const headlightLogo = 'HLLOGO';
		const color = (color) =>
		{
			return `COLORBEGIN${ color }COLOREND`;
		};
		const displayStrings =
		[
			`${ headlightLogo } ${ color('darkgrey') }Location`,
		];
		return displayStrings;
	}

	/**
	 * Marks the set of rows to apply a forced larger font to for Samples.
	 * @return {Array<String>}
	 */
	getSampleBigRows()
	{
		return [
			'Description',
		];
	}

	/**
	 * Make sure the per-customer label configuration is loaded into `typeConfig`, once.
	 *
	 * `typeConfig` drives `getTemplatedEntitySettings` — PrintStyle (thin/wide), the title template, and
	 * which fields print in which row/column. Apps that load it at startup (LIMS) leave nothing to do here;
	 * apps that never did (the panels/document context) would otherwise print the built-in fallback layout
	 * and silently ignore the customer's printer configuration.
	 *
	 * Deliberately NOT called from `printDecoratedEntity`: that would also change label output for
	 * consumers which have never loaded printable manifests and do not expect the LIMS layout (e.g.
	 * bridge_inspection_v2 printing through ImprovedTabularRecordSetProvider). Callers opt in.
	 *
	 * Never throws — a failed load leaves the built-in layout in place.
	 * @return {Promise<void>}
	 * @async
	 */
	async ensurePrintableManifests()
	{
		// an app that loaded them at startup has already populated typeConfig; nothing to do
		if (this._PrintableManifestsEnsured || Object.keys(this.typeConfig || {}).length > 0)
		{
			this._PrintableManifestsEnsured = true;
			return;
		}
		this._PrintableManifestsEnsured = true;
		try
		{
			if (!this.pict.ManifestPackagingService)
			{
				this.pict.addAndInstantiateServiceType('ManifestPackagingService', libManifestPackagingService);
			}
			await this.pict.ManifestPackagingService.loadPrintableManifests(_PrintableManifestEntities, {}, _PrintableManifestProduct);
			this.pict.log.info('Loaded the printable manifests for QR labels.');
		}
		catch (pError)
		{
			this.pict.log.warn(`Could not load the printable manifests; QR labels will use the default layout: ${pError?.message || pError}`);
		}
	}

	applyTypeConfig(tc)
	{
        this.typeConfig = Object.assign(this.typeConfig, tc);
	}

	addManifestForType(type, manifest)
	{
        this.typeConfig[type] = manifest;
	}

	_getHumanReadableEntityName(pEntity)
	{
		return pEntity.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
	}

	async getTemplatedEntitySettings(entity, record)
	{
		if (!this.pict.services.HeadlightQuickSummaries || !this.typeConfig[entity])
		{
			return null;
		}
		const returnObject =
		{
			headers: [],
			footers: [],
			bigRows: [],
			printStyle: this.typeConfig[entity].PrintStyle || 'thin',
		};
		const processedRecord = await this.pict.services.HeadlightQuickSummaries.processRecord(entity, record, 'Printable', this.typeConfig);
		returnObject.headers = [ this.typeConfig[entity].TitleTemplate ? this.fable.parseTemplate(this.typeConfig[entity].TitleTemplate, processedRecord) : this._getHumanReadableEntityName(entity) ];
		const fields = Object.keys(this.typeConfig[entity].Descriptors);
		const rows = [];
		let minRows = 0;
		for (const f of fields)
		{
			const field = this.typeConfig[entity].Descriptors[f];
			if (field.Row && field.Row > minRows)
			{
				minRows = field.Row;
			}
		}
		for (let x = 0; x < minRows; x++)
		{
			rows.push([]);
		}
		for (const f of fields)
		{
			const field = this.typeConfig[entity].Descriptors[f];
			if (returnObject.printStyle == 'thin' && field.Column > 1)
			{
				console.warn(`Field ${ f } was not printed b/c the print style is set to "thin" and the Column # was greater than 1.`);
				continue;
			}
			if (returnObject.printStyle == 'wide' && field.Column > 2)
			{
				console.warn(`Field ${ f } was not printed b/c the print style is set to "wide" and the Column # was greater than 2.`);
				continue;
			}
			if (!field.Row)
			{
				console.warn(`Field ${ f } was not printed b/c a Row was not specified`);
				continue;
			}
			rows[field.Row - 1].push(Object.assign(field, { FieldAddress: f }));
			rows[field.Row - 1] = rows[field.Row - 1].sort((a, b) =>
			{
				if (a.Column > b.Column)
				{
					return 1;
				}
				else if (b.Column > a.Column)
				{
					return -1;
				}
				return 0;
			});
		}
		const generatePrintableLine = (row) =>
		{
			if (!row.length)
			{
				return null;
			}
			let returnString = `${ row[0].Name }: ${ row[0].HeadlightPrintable?.ValueTemplate ? this.fable.parseTemplate(row[0].HeadlightPrintable?.ValueTemplate, processedRecord) : (processedRecord[row[0].FieldAddress] || 'N/A') }`;
			if (returnObject.printStyle == 'wide' && row[1])
			{
				returnString += `COMPUTED_COLUMN${ row[1].Name }: ${ row[1].HeadlightPrintable?.ValueTemplate ? this.fable.parseTemplate(row[1].HeadlightPrintable?.ValueTemplate, processedRecord) : (processedRecord[row[1].FieldAddress] || 'N/A') }`;
			}
			return returnString;
		};
		const tempFooters = [];
		for (const r of rows)
		{
			const line = generatePrintableLine(r);
			if (line)
			{
				tempFooters.push(generatePrintableLine(r));
			}
		}
		returnObject.footers = this.formatStringsForPrinting(tempFooters);
		return returnObject;
	}

	/**
	 * Prints a QR Code for an entity but decorated with additional information about the entity.
	 * @param {String} entity - The entity type being printed.
	 * @param {String} qr - The QR Code of that entity.
	 * @param {String} [previewID] - Tells the function this is a print preview and shouldn't open a print modal.
	 * 								 This is the DOM id of the container to place the preview in.
	 * @param {String} [printStyleOverride] - Allows overriding of the default printing style.
	 * @return {Promise}
	 */
	async printDecoratedEntity(entity = 'Sample', qr, previewID, printStyleOverride)
	{
		const printStyle = printStyleOverride ? printStyleOverride : entity === 'Sample' ? 'wide' : this.printStyle;
		await this.initializeLogos();
		try
		{
			const record = await this.getByQRCode(entity, qr);
			if (this.pict.providers.RecordExtension)
			{
				await this.pict.providers.RecordExtension.extendRecords(entity, [ record ]);
				if (record.Extended)
				{
					for (const k of Object.keys(record.Extended))
					{
						record[k] = record.Extended[k];
					}
				}
			}
			let settingsObj =
			{
				previewID: previewID,
				raw: entity !== 'Sample',
				printStyle: printStyle,
				headers: entity !== 'Sample' ? record?.Name ? [ record.Name ] : [ entity ] : [],
				bigRows: this[`get${ entity }BigRows`] ? this[`get${ entity }BigRows`]() : [],
				footers: this[`get${ entity }Printables`] ? await this[`get${ entity }Printables`](record, printStyle) : [ qr ],
			};
			if (entity === 'Sample')
			{
				settingsObj.headers.push('PSID ' + (record.LabControlNumber || '---'));
			}
			const templatedEntitySettings = await this.getTemplatedEntitySettings(entity, record);
			// If there is a manifest, allow that to override the printing settings.
			if (templatedEntitySettings)
			{
				settingsObj = Object.assign(settingsObj, templatedEntitySettings);
			}
			const code = entity === 'Sample' ? qr : `${ this.pict.providers.UtilityProvider.buildLinksUrl() }/${ entity }/qr/${ qr }`;
			return await this.print(code, settingsObj);
		}
		catch (e)
		{
			console.log(`Error printing ${ entity } with QR code ${ qr }: `, e);
			return null;
		}
	}

	/**
	 * @param {string} code
	 * @param {QRCodeOptions} [options]
	 *
	 * @return {Promise<'canceled' | 'printed' | undefined>}
	 */
	print(code, options = {})
	{
		const printStyle = options.printStyle || this.printStyle;
		const text = options.raw ? code : `${this.pict.providers.UtilityProvider.buildLinksUrl()}/qr/${code}`;
		const height = 100;
		const topPadding = printStyle === 'wide' ? 100 : 50;
		const footers = [];
		const headers = [];
		let overallSize = 128;
		if (options.footers?.length)
		{
			for (const subText of options.footers)
			{
				footers.push({
					text: subText,
					padding: [ topPadding, 64, 0, 64 ],
					height: height,
				});
				overallSize += height + topPadding;
			}
		}
		if (options.headers?.length)
		{
			for (const subText of options.headers)
			{
				headers.push({
					text: subText,
					padding: [ 0, 64, topPadding, 64 ],
					height: height,
				});
				overallSize += height + topPadding;
			}
		}
		// This is the max percentage of the sticker the text should take up. QR code will take the remaining space.
		const scaleFactor = printStyle === 'wide' ? 65 : 60;

		// Calculate the size the sticker image needs to be based on the text size and scale factor.
		const adjustedScale = (overallSize / scaleFactor) * 100;

		return this.printQrCode({
			previewID: options.previewID,
			text: text,
			width: printStyle === 'wide' ? adjustedScale * (3/2) : adjustedScale,
			height: adjustedScale,
			padding: 64,
			footer: footers,
			header: headers,
			bigRows: options.bigRows || [],
			printStyle: printStyle,
		});
	}

	/* -- Print QR Code Methods ---------------------------------------- */

	/**
	* Converts base64 data to an object url
	* @param {string} b64Data
	* @return {string}
	* @private
	*/
	_toObjectUrl(b64Data)
	{
		if (!b64Data.startsWith('data:'))
		{
			throw new Error('Invalid base64 data, expected data:{contentType};base64,{data}');
		}
		const contentType = b64Data.substring('data:'.length, b64Data.indexOf(';'));
		const content = b64Data.substring(b64Data.indexOf(';base64,') + 8);
		const blob = this._b64toBlob(content, contentType);
		return URL.createObjectURL(blob);
	}

	/**
	* Converts a base64 string to a blob
	* @param {string} b64Data
	* @param {string} contentType
	* @param {number} sliceSize
	* @return {module:buffer.Blob}
	* @private
	*/
	_b64toBlob(b64Data, contentType='', sliceSize=512)
	{
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize)
		{
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++)
			{
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
	}

	/**
	* YOU PROBABLY DONT WANT THIS METHOD, USE `print` INSTEAD
	*
	* Prints using the newTab method, this is one of several ways to print a QR code.
	* See the `print` method for more details.
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	printInNewTab(options)
	{
		const src = this.generateQRCodeImage(options);
		const blobUrl = this._toObjectUrl(src);
		window.open('./Global/qrcode/printTab.html?v=' + blobUrl, '_blank');

		return undefined;
	}

	/**
	* "Prints" a preview of the printout into a DOM element.
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	printPreview(options)
	{
		const src = this.generateQRCodeImage(options);
		const blobUrl = this._toObjectUrl(src);
		const el = document.querySelector(`#${ options.previewID }`);
		if (el)
		{
			el.innerHTML = /*html*/`<img src="${ blobUrl }" />`;
		}

		return undefined;
	}

	/**
	* YOU PROBABLY DONT WANT THIS METHOD, USE `print` INSTEAD
	*
	* Prints using an embedded iframe, this is one of several ways to print a QR code.
	* See the `print` method for more details.
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	printInline(options)
	{
		const src = this.generateQRCodeImage(options);

		const blobUrl = this._toObjectUrl(src);

		const { printFrame } = this.getGenerationLayers();

		let resolveDeferred;
		const deferred = new Promise(function(resolve, reject)
		{
			resolveDeferred = resolve;
		});

		printFrame.contentWindow.document.open();
		window.onfocus=function()
		{
			resolveDeferred();
		};
		window.addEventListener('focus', function(event)
		{
			resolveDeferred();
		}, { once: true });

		printFrame.contentWindow.document.write(`<html lang="en">
			<head>
				<title>QR Code</title>
				<style>
					html, body {
						overflow-x: hidden;
					}
					
					img {
						height: 100%;
						width: 100%;
						max-height: 600px; /* cant seem to get this to scale right, i give up */
						object-fit: contain;
						flex: 1;
					}
					
					.column {
						display: flex;
						flex-direction: column;
						flex: 1;
					}
					
					button {
						appearance: none;
						display: block;
						width: calc(100% - 32px);
						box-sizing: border-box;
						padding: 12px 16px;
						font-size: 36px;
						background-color: #38b2ff;
						border: 1px solid #008ee3;
						color: white;
						font-weight: bold;
						margin: 16px;
						max-width: 600px;
						align-self: center;
					}
					
					@media print {
						@page {
							size: 62mm 100mm;
							margin: 0cm !important;
							padding: 0cm !important;
						}
					
						html, body {
							padding: 0 !important;
							margin: 0 !important;
							position: relative !important;
							inset: 0 !important;
						}
					
						/*@media print {*/
						/*}*/
						* { margin: 0 !important; padding: 0 !important; }
						#controls, .footer, .footerarea{ display: none; }
						html, body {
							/*changing width to 100% causes huge overflow and wrap*/
							height:100%;
							overflow: hidden;
							background: #FFF;
							font-size: 9.5pt;
							page-break-inside: avoid;
						}
						.template { width: auto; left:0; top:0; }
						li { margin: 0 0 10px 20px !important;}
					
					
						button {
							display: none;
						}
					
						img {
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							align-self: initial;
					
							object-fit: contain;
							flex: 0;
						}
					}
				</style>
			</head>
			<body onload="print()">
				<img src="${blobUrl}" alt="${options.text}"/>
			</body>
			</html>`);
		printFrame.contentWindow.document.close();

		return deferred;
	}

	async printNative(options)
	{
		const src = this.generateQRCodeImage(options);
		return this.fable.NativeBridge.printImage({
			jobName: 'QR Code',
			base64Image: src,
		});
	}

	/**
	* Prints a QR code using the best method available for the current browser.
	*
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	async printQrCode(options)
	{
		await this.initializeLogos();
		if (options.previewID)
		{
			return this.printPreview(options);
		}
		const method = this.getPrintMethod();
		if (method === 'native')
		{
			return this.printNative(options);
		}
		else if (method === 'window')
		{
			return this.printInNewTab(options);
		}
		else
		{
			return this.printInline(options);
		}
	}

	/**
	* Gets the ideal printing method for the given browser.
	*
	* @return {'native'|'inline'|'window'}
	*/
	getPrintMethod()
	{
		const ua = navigator.userAgent;
		const iOS = ua.match(/iPad/i) || ua.match(/iPhone/i);
		const webkit = ua.match(/WebKit/i);
		const isSafariMobile = iOS && webkit && !ua.match(/CriOS/i);

		if (this.fable.NativeBridge.hasNativeSupport())
		{
			return 'native';
		}
		else if (isSafariMobile)
		{
			return 'window';
		}
		else
		{
			return 'inline';
		}
	}

	/**
	 * This is a copy of a method inside the HTML5QRCode lib. It should be exactly the same except it has a fix to handle a bug where it can sometimes call removeChild on an element that doesn't exist.
	 * TODO: Hopefully the library fixes this bug themselves at some point, there is an open issue on their github for it.
	 * @param {Number} [tries] - how many times the scanner has tried to run. WE will give up after a few retries.
	 * @return {Promise<void>}
	 */
	localScannerStop(tries)
	{
		// @ts-ignore
		const localThis = _Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode;
		if (!localThis.stateManagerProxy.isScanning())
		{
			console.log('Returning early, scanner is not already running.');
			return;
		}

		const toStoppedStateTransaction = localThis.stateManagerProxy.startTransition(1);

		this.shouldScan = false;
		if (localThis.foreverScanTimeout)
		{
			clearTimeout(localThis.foreverScanTimeout);
		}

		// Removes the shaded region if exists.
		const removeQrRegion = () =>
		{
			if (!localThis.element)
			{
				return;
			}
			const childElement = document.getElementById('qr-shaded-region');
			if (childElement)
			{
				localThis.element.removeChild(childElement);
			}
		};

		return localThis.renderedCamera.close().then(() =>
		{
			localThis.renderedCamera = null;

			if (localThis.element && localThis.canavsElement)
			{
				localThis.element.removeChild(localThis.canvasElement);
				localThis.canvasElement = null;
			}

			removeQrRegion();
			if (localThis.qrRegion)
			{
				localThis.qrRegion = null;
			}
			if (localThis.context)
			{
				localThis.context = null;
			}

			toStoppedStateTransaction.execute();
			try
			{
				localThis.hidePausedState();
			}
			catch (e)
			{
				console.log('Scanner ui element not present, skipping.');
			}
			localThis.isScanning = false;
			return Promise.resolve();
		});
	}

	/* -- QR Code Scan Methods ---------------------------------------- */

	/**
	* Scans a QRCode and gives you back the result
	* @param {String} [id] - optional, an id of an element to inject the scanner onto.
	* @param {Boolean} [keepOpen] - optional, keeps the camera in an open scanning mode.
	* @param {Object} [pOptions] - optional, options for the scanner
	* @return {Promise<String>}
	*/
	async scanQrCode(id, keepOpen, pOptions = {})
	{
		const Html5QrcodeScanner = window.Html5QrcodeScanner;
		if (typeof Html5QrcodeScanner === 'undefined')
		{
			throw new Error('QRCode scanning is not supported. Missing library Html5QrcodeScanner');
		}

		if (!this._qrCodeScanner)
		{
			if (!id)
			{
				this._dialog = new Dialog({
					closeOnBackdropClick: true,
					body: `<div id="qrcode-scanner" style="width: 100%; height: 100%;"></div>`,
				});
			}
			this._qrCodeScanner = new window.Html5QrcodeScanner(id || 'qrcode-scanner', {
				fps: 20,
				rememberLastUsedCamera: true,
				videoConstraints: { facingMode: 'environment' },
				qrbox: {
					width: pOptions?.isPhoneDevice ? 150 : 250,
					height: pOptions?.isPhoneDevice ? 150 : 250,
				},
				// turn off file upload feature, it doesnt work well with iOS devices (safari)
				// enum found at https://github.com/mebjas/html5-qrcode/blob/master/src/core.ts#L76
				supportedScanTypes: [ 0 ],
			});
		}
		// Make sure events can't "persist" between instances of opening the cart (i.e. if an event fires before the cart closes, it should not get picked up if the cart closes and reopens).
		const instanceCameraKey = `${ this.cameraKey }`;
		if (keepOpen)
		{
			this._qrCodeScanner.render((result)=>
			{
				if (this.cameraKey && instanceCameraKey === this.cameraKey && Date.now() - this.lastCameraEvent.time > 1000 && this.lastCameraEvent.content !== result)
				{
					this.lastCameraEvent =
					{
						time: Date.now(),
						content: result,
					};
					this.QRBus.receiveScan(result);
				}
			});
			const embedUI = document.querySelector('#QRPanel-ScannerBox__dashboard_section');
			// Remove this for now until we have a better solution for detecting mobile.
			/*const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
			if (!isMobile)
			{
				embedUI.classList.add('is-hidden');
			}*/
			if (embedUI.innerHTML.includes('Request Camera Permissions'))
			{
				// @ts-ignore
				document.querySelector('#html5-qrcode-button-camera-permission').click();
			}
			// Replace the stop method with a local version that fixes a bug in it.
			// See method jsdoc comment for more details.
			this._qrCodeScanner.html5Qrcode.stop = this.localScannerStop;
			return Promise.resolve('');
		}
		else
		{
			return await new Promise((resolve, reject) =>
			{
				if (this._dialog)
				{
					this._dialog.show();
				}
				this._qrCodeScanner.render((result) =>
				{
					if (this._dialog)
					{
						try
						{
							this._qrCodeScanner.html5Qrcode.stop();
						}
						catch (e)
						{
							console.error('Error stopping scanner', e);
						}
						this._dialog.hide();
					}
					resolve(qrTranslator.translateQRCode(result).code);
				});
			});
		}
	}

	/* -- QR Code Generation Methods ---------------------------------------- */

	/**
	 * @typedef {Object} Footer
	 * @property {string} footer.text - The text to put in the footer
	 * @property {number} footer.height - The height of the footer, this will be used to calculate the font size
	 * @property {number|Array<number>} [footer.padding] - The padding around the footer
	 */

	/**
	 * @typedef {Object} Header
	 * @property {string} header.text - The text to put in the header
	 * @property {number} header.height - The height of the header, this will be used to calculate the font size
	 * @property {number|Array<number>} [header.padding] - The padding around the header
	 */

	/**
	* @typedef {Object} QRCodePrinterOptions
	* @property {string} text - The text to encode in the QR code
	* @property {string} [previewID] - The ID of a DOM element to render the print preview into.
	* @property {number} [width] - The width of the QR code
	* @property {number} [height] - The height of the QR code
	* @property {string} [printStyle] - Style of label to print, current options are 'thin' and 'wide'
	* @property {number|Array<number>} [padding] - The padding around the QR code
	*
	* @property {Array<Header>} [header] - The header to put above the QR code
	*
	* @property {Array<Footer>} [footer] - The footer to put below the QR code

	* @property {Array<String>} [bigRows] - lists footer rows that should be displayed in "bigger" text
	*
	*/

	/**
	* Parse a padding format into a common output of top, left, bottom, right
	* @param {number|Array<number>} padding - The padding to parse
	* @return {{top: number, left: number, bottom: number, right: number}}
	*/
	_parsePadding(padding)
	{
		if (Array.isArray(padding))
		{
			return {
				top: padding[0] ?? 0,
				right: padding[1] ?? 0,
				bottom: padding[2] ?? padding[0] ?? 0,
				left: padding[3] ?? padding[1] ?? 0,
			};
		}
		return {
			top: padding || 0,
			bottom: padding || 0,
			left: padding || 0,
			right: padding || 0,
		};
	}

	/**
	 * @typedef {Object} TextMetrics
	 * @property {Number} usedFontSize
	 */

	/**
	* Given the text and the width and height, this will return the ideal font size for the text to fit within the given width and height
	* @param {object} ctx
	* @param {string} text
	* @param {number} width
	* @param {number} height
	* @return {TextMetrics}
	* @private
	*/
	_setIdealFontSize(ctx, text, width, height)
	{
		let size = 0; const step = .5;
		let tmpSize;
		do
		{
			size += step;
			ctx.font = 'bold ' + size + 'px "Noto Sans Mono", monospace';
			tmpSize = ctx.measureText(text);
		} while (tmpSize.width < width && (tmpSize.actualBoundingBoxAscent + tmpSize.actualBoundingBoxDescent) < height);

		// we can overshoot, check if we did then bring it down a notch
		if (tmpSize.width > width || (tmpSize.actualBoundingBoxAscent + tmpSize.actualBoundingBoxDescent) > height)
		{
			size -= step;
			ctx.font = 'bold ' + size + 'px "Noto Sans Mono", monospace';
			tmpSize = ctx.measureText(text);
		}

		tmpSize.usedFontSize = size;
		return tmpSize;
	}

	/**
	* Generates a QR code image given the provided options.
	* The QRCode library we use only does the QRCode but It's ridiculous to try and
	* get print styles to conform in a standard way. However, what is a great standard is the
	* canvas library! use that to put stuff where we want then make an image from it
	* @param {QRCodePrinterOptions} options
	* @return {string} - base64 encoded image
	*/
	generateQRCodeImage(options)
	{
		if (typeof window.QRCode === 'undefined')
		{
			throw new Error('QRCode generation is not supported. Missing library QRCode');
		}

		// init if we need to

		const { canvas, qrCodeContainer } = this.getGenerationLayers();

		const printStyle = options.printStyle || this.printStyle;

		if (printStyle === 'wide' && !options.previewID)
		{
			canvas.style.width = options.height+'px';
			canvas.style.height = options.width+'px';
			canvas.style.border = '1px solid black';

			canvas.width = options.height;
			canvas.height = options.width;
		}
		else
		{
			canvas.style.width = options.width+'px';
			canvas.style.height = options.height+'px';
			canvas.style.border = '1px solid black';

			canvas.width = options.width;
			canvas.height = options.height;
		}

		const ctx = canvas.getContext('2d');
		if (printStyle === 'wide' && options?.footer?.length && !options.previewID)
		{
			ctx.translate(canvas.width, 0);
			ctx.rotate(Math.PI/2);
		}
		ctx.fillStyle = 'white';
		ctx.fillRect(0, 0, options.width, options.height);

		ctx.save();
		const offset = this._parsePadding(options.padding);
		// given our root padding we want to move everything in by this amount
		// translate the entire thing by that offset
		ctx.translate(offset.left, offset.top);

		let { width, height } = options;
		// adjust the perceived width and height of below by our padding options
		width -= offset.left + offset.right;
		height -= offset.top + offset.bottom;

		const sanitizeText = (string) =>
		{
			const tokens = [ 'HLLOGO', 'COLORBEGIN', 'COLOREND' ];
			for (const t of tokens)
			{
				if (t === 'COLORBEGIN' && string.includes('COLORBEGIN'))
				{
					const fontColor = string.split('COLORBEGIN')[1].split('COLOREND')[0];
					string = string.replace(fontColor, '');
				}
				string = string.replace(t, '');
			}
			return string;
		};

		let ctxFont = 0;
		const textSet = [].concat(options.header || []).concat(options.footer || []);

		const sanitizeTextForTesting = (string) =>
		{
			const double = string.includes('HLLOGO');
			const tokens = [ 'HLLOGO', 'COLORBEGIN', 'COLOREND' ];
			for (const t of tokens)
			{
				if (t === 'COLORBEGIN' && string.includes('COLORBEGIN'))
				{
					const fontColor = string.split('COLORBEGIN')[1].split('COLOREND')[0];
					string = string.replace(fontColor, '');
				}
				string = string.replace(t, '');
			}
			return double && textSet.length > 1 ? string + string : string;
		};

		for (const note of textSet)
		{
			const padding = this._parsePadding(note.padding);
			const tmpInsets = this._setIdealFontSize(
				ctx,
				sanitizeTextForTesting(note.text),
				width - padding.left - padding.right,
				note.height,
			);
			if (tmpInsets.usedFontSize < ctxFont || !ctxFont)
			{
				ctxFont = tmpInsets.usedFontSize;
			}
		}

		let extraBottomOffset = 0;
		if (options?.footer?.length && printStyle === 'wide' && ctxFont)
		{
			ctx.font = 'bold ' + ctxFont + 'px "Noto Sans Mono", monospace';
			if (!options.bigRows)
			{
				options.bigRows = [];
			}
			const tmpSize = ctx.measureText('test');
			const smallFooterSize = (tmpSize.actualBoundingBoxAscent + tmpSize.actualBoundingBoxDescent + options.footer[0].padding[0]);
			ctx.font = 'bold ' + (ctxFont * 1.5) + 'px "Noto Sans Mono", monospace';
			const tmpSizeBig = ctx.measureText('test');
			const bigFooterSize = (tmpSizeBig.actualBoundingBoxAscent + tmpSizeBig.actualBoundingBoxDescent + options.footer[0].padding[0]);
			const footerBoundsCalc = (smallFooterSize * (options.footer.length - options.bigRows.length)) + (bigFooterSize * options.bigRows.length);
			if (footerBoundsCalc < (height * 0.65))
			{
				extraBottomOffset = (height * 0.65) - footerBoundsCalc;
			}
		}

		const imageInset = this._parsePadding(0);

		if (options.header)
		{
			ctx.font = 'bold ' + `${ printStyle === 'wide' ? ctxFont*2.5 : ctxFont }` + 'px "Noto Sans Mono", monospace';
			for (const headNote of options.header)
			{
				const padding = this._parsePadding(headNote.padding);
				const tmpInsets = ctx.measureText(sanitizeText(headNote.text));
				console.log('header insets', tmpInsets);

				imageInset.top += tmpInsets.actualBoundingBoxAscent + tmpInsets.actualBoundingBoxDescent + padding.top + padding.bottom;

				ctx.fillStyle = 'black';

				ctx.fillText(
					sanitizeText(headNote.text),
					printStyle === 'wide' && !this.customerLogo ? padding.left : width / 2 - tmpInsets.width / 2,
					imageInset.top - padding.bottom,
				);
			}
		}
		if (this.customerLogo && printStyle === 'wide')
		{
			ctx.drawImage(this.customerLogo, 0, 0, width / 4, (width / 4) * (this.customerLogo.height / this.customerLogo.width));
		}
		if (printStyle === 'wide')
		{
			ctx.font = 'bold ' + (ctxFont * 0.75) + 'px "Noto Sans Mono", monospace';
			ctx.fillText(
				'Print Date: ' + this.pict.fable.Dates.dayJS(new Date().toISOString()).format('MM/DD/YYYY'),
				(width / 5) * 3,
				height,
			);
		}

		if (options.footer)
		{
			options.footer = options.footer.reverse();
			let currentOffset = height - extraBottomOffset;
			ctx.font = 'bold ' + ctxFont + 'px "Noto Sans Mono", monospace';
			for (const footNote of options.footer)
			{
				const tokens = footNote.text.split('N/A');
				let paddedPlaceholder = '';
				for (let x = 0; x < tokens.length; x++)
				{
					const tempSpacer = ('').padEnd(tokens[x].length);
					paddedPlaceholder = paddedPlaceholder.concat(tempSpacer);
					if ((x + 1) < tokens.length)
					{
						paddedPlaceholder = paddedPlaceholder.concat('N/A');
					}
				}
				footNote.text = tokens.join('   ');
				const bigRow = options.bigRows?.filter((r)=>
				{
					return footNote.text.startsWith(r);
				})?.length;
				let tmpFont = 'bold ' + ctxFont + 'px "Noto Sans Mono", monospace';
				if (bigRow)
				{
					tmpFont = 'bold ' + (ctxFont * 1.5) + 'px "Noto Sans Mono", monospace';
				}
				ctx.font = tmpFont;
				const padding = this._parsePadding(footNote.padding);
				const tmpInsets = ctx.measureText(sanitizeText(footNote.text));
				console.log('footer insets', tmpInsets);

				const tmpTextOffset = tmpInsets.actualBoundingBoxAscent + tmpInsets.actualBoundingBoxDescent + padding.top + padding.bottom;
				imageInset.bottom += tmpTextOffset;
				currentOffset -= tmpInsets.actualBoundingBoxDescent;
				// Boxes which are helpful for debugging painting issues
				/*ctx.strokeStyle = 'green';
				ctx.strokeRect(
					width / 2 - tmpInsets.width / 2,
					height - footNote.height,
					tmpInsets.width,
					tmpInsets.actualBoundingBoxAscent + tmpInsets.actualBoundingBoxDescent);

				ctx.strokeStyle = 'red';
				ctx.strokeRect(0, height - footNote.height, width, footNote.height);*/

				let fontColor = 'black';
				if (footNote.text.includes('COLORBEGIN'))
				{
					fontColor = footNote.text.split('COLORBEGIN')[1].split('COLOREND')[0];
				}
				let imageWidth = 0;
				if (footNote.text.includes('HLLOGO'))
				{
					imageWidth = (tmpTextOffset - padding.top + padding.bottom) * (this.headlightLogo.width / this.headlightLogo.height);
					ctx.drawImage(this.headlightLogo, 0, currentOffset - tmpInsets.actualBoundingBoxAscent, imageWidth, tmpTextOffset - padding.top - padding.bottom);
				}
				ctx.fillStyle = fontColor;
				ctx.fillText(
					sanitizeText(footNote.text),
					imageWidth ? imageWidth : (printStyle === 'wide' ? padding.left : width / 2 - tmpInsets.width / 2),
					currentOffset,
				);
				ctx.fillStyle = 'grey';
				ctx.fillText(
					paddedPlaceholder,
					imageWidth ? imageWidth : (printStyle === 'wide' ? padding.left : width / 2 - tmpInsets.width / 2),
					currentOffset,
				);
				currentOffset -= tmpInsets.actualBoundingBoxAscent + padding.top + padding.bottom;
				if (printStyle === 'wide')
				{
					for (let x = 0; x < 10; x++)
					{
						ctx.moveTo(0, currentOffset + padding.top/2 + padding.bottom + x);
						ctx.lineTo(options.previewID ? canvas.width : canvas.height, currentOffset + padding.top/2 + padding.bottom + x);
						ctx.stroke();
					}
				}
			}
		}

		ctx.fillStyle = 'black';

		const availableHeight = printStyle === 'wide' ? height - imageInset.bottom : height - imageInset.top - imageInset.bottom;
		const availableWidth = width - imageInset.left - imageInset.right;

		let boundingRectSize = Math.min(availableWidth, availableHeight);
		if (printStyle === 'wide' && boundingRectSize > (height * 0.3) && textSet.length)
		{
			boundingRectSize = height * 0.3;
		}

		console.log('Done', imageInset);
		// ctx.rect(imageInset.left, imageInset.top, width-imageInset.left-imageInset.right, height-imageInset.top-imageInset.bottom);
		// ctx.stroke();
		for (const child of [ ...qrCodeContainer.children ])
		{
			qrCodeContainer.removeChild(child);
		}
		console.log('boundingRectSize', boundingRectSize);
		new window.QRCode(qrCodeContainer, {
			text: options.text,
			width: boundingRectSize,
			height: boundingRectSize,
			colorDark: '#000000',
			colorLight: '#ffffff',
			correctLevel: window.QRCode.CorrectLevel.H,
		}).makeCode(options.text);
		const qrCodeCanvas = qrCodeContainer.querySelector('canvas');

		// console.log('image', qrCodeCanvas.toDataURL());
		ctx.drawImage(
			qrCodeCanvas,
			// shift to middle of bounding box
			printStyle === 'wide' ? imageInset.left + (availableWidth - boundingRectSize) : imageInset.left + (availableWidth - boundingRectSize) / 2,
			printStyle === 'wide' ? 0 : imageInset.top + (availableHeight - boundingRectSize) / 2,
			boundingRectSize,
			boundingRectSize,
		);
		ctx.restore();

		return canvas.toDataURL('image/jpeg', .7);
	}

	/* -- Utility Methods ---------------------------------------- */

	/**
	* Get the layers used for generating QR codes and printing them.
	* @return {{canvas: HTMLCanvasElement, qrCodeContainer: HTMLDivElement, printFrame: HTMLIFrameElement, hiddenLayer: HTMLDivElement}}
	*/
	getGenerationLayers()
	{
		if (!this._hiddenLayer)
		{
			this._hiddenLayer = document.createElement('div');

			this._hiddenLayer.style.visibility = 'hidden';
			this._hiddenLayer.style.height = '0';
			this._hiddenLayer.style.width = '0';
			this._hiddenLayer.style.position = 'absolute';
			this._hiddenLayer.style.top = '-10000px';
			this._hiddenLayer.style.left = '-10000px';

			this._qrCodeContainer = document.createElement('div');
			this._qrCodeContainer.style.display = 'none';
			this._hiddenLayer.appendChild(this._qrCodeContainer);

			this._canvas = document.createElement('canvas');
			this._hiddenLayer.appendChild(this._canvas);

			this._printFrame = document.createElement('iframe');
			this._hiddenLayer.appendChild(this._printFrame);

			document.body.appendChild(this._hiddenLayer);
		}

		return {
			hiddenLayer: this._hiddenLayer,
			canvas: this._canvas,
			qrCodeContainer: this._qrCodeContainer,
			printFrame: this._printFrame,
		};
	}
}

module.exports = QRCodeProvider;
module.exports.default_configuration = {};

},{"../../lib/qrcode-management/source/QRBus.js":1,"../../lib/qrcode-management/source/qr-translation.js":2,"manifest-packaging-service":14,"pict-provider":479}],883:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class SampleLogProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the SampleLog by ID
	 * @param {String|Number} pSampleLogID - The SampleLog ID to search for
	 * @return {Promise<any>}
	 * @async
	 */
	getSampleLogByID(pSampleLogID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleLogID)
			{
				this.pict.log.error('No SampleLog ID provided.');
				return reject(new Error('No SampleLog ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`SampleLog/${pSampleLogID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLog: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the SampleLogs by an IDSample
     * @param {Object} pIDSample - The IDSample to search for
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getSampleLogsByIDSample(pIDSample)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pIDSample)
			{
				this.pict.log.error('No IDSample provided.');
				return reject(new Error('No IDSample provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`SampleLogs/FilteredTo/FBV~IDSample~EQ~${pIDSample}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLogs for IDSample ${pIDSample}: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the SampleLogs
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 */
	getSampleLogs()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'SampleLogs';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `SampleLogs/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get SampleLogs list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Create a new sample log entry for a given sample
	 * @param {Object} pOptions - The options to use when adding the log
	 * @return {Promise<any>}
	 * @async
	 */
	async createSampleLog(pOptions)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions?.IDSample)
			{
				this.pict.log.error('No Sample ID provided.');
				return reject(new Error('No Sample ID provided.'));
			}
			if (!pOptions?.Notes)
			{
				this.pict.log.error('No Log Entry provided.');
				return reject(new Error('No Log Entry provided.'));
			}
			const tmpOptions = {
				IDSample: pOptions?.IDSample || 0,
				Notes: pOptions?.Notes || '',
				CaptureDate: pOptions?.CaptureDate || new Date().toISOString(),
				CaptureLatitude: pOptions?.CaptureLatitude || 0,
				CaptureLongitude: pOptions?.CaptureLongitude || 0,
				IDLab: pOptions?.IDLab || 0,
			};

			this.pict.HeadlightRestClient.postJSON(`SampleLog`, tmpOptions, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding Sample Log Entry: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = SampleLogProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],884:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class SampleProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Sample Status Mapped Details - this provides a consistent breakdown of the status of a sample for display purposes
	 * @param {string} pStatusString - The status string to map
	 * @return {Object} - The mapped details of the status
	 */
	getSampleStatusMappedDetails(pStatusString)
	{
		switch (pStatusString ? pStatusString.toLowerCase() : '')
		{
		case 'pass':
		case 'sqty':
		case 'passing':
			return {
				name: 'Pass',
				color: 'is-success',
				icon: 'fa-check-circle',
				iconColor: 'has-text-success-soft',
				original: pStatusString,
			};
		case 'fail':
		case 'failing':
			return {
				name: 'Fail',
				color: 'is-danger',
				icon: 'fa-exclamation-circle',
				iconColor: 'has-text-danger-soft',
				original: pStatusString,
			};
		case 'pending':
			return {
				name: 'Pending',
				color: 'is-warning',
				icon: 'fa-clock',
				iconColor: 'has-text-warning-soft',
				original: pStatusString,
			};
		case 'void':
			return {
				name: 'Void',
				color: 'is-text',
				icon: 'fa-ban',
				iconColor: 'has-text-text-60',
				original: pStatusString,
			};
		case 'info':
			return {
				name: 'Info',
				color: 'is-info',
				icon: 'fa-info-circle',
				iconColor: 'has-text-info-soft',
				original: pStatusString,
			};
		default:
			if (pStatusString)
			{
				return {
					name: pStatusString,
					color: 'is-unknown',
					icon: 'fa-info-circle',
					iconColor: 'has-text-unkown',
					original: pStatusString,
				};
			}
			return {
				name: 'N/A',
				color: 'is-text',
				icon: 'fa-question-circle',
				iconColor: 'has-text-text-60',
				original: pStatusString,
			};
		}
	}

	/**
	 * Get the Sample by ID
	 * @param {String|Number} pSampleID - The Sample ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getSampleByID(pSampleID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleID)
			{
				this.pict.log.error('No Sample ID provided.');
				return reject(new Error('No Sample ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Sample/${pSampleID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Sample by GUID
	 * @param {String|Number} pSampleGUID - The Sample GUID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getSampleByGUID(pSampleGUID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleGUID)
			{
				this.pict.log.error('No Sample GUID provided.');
				return reject(new Error('No Sample GUID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Samples/FilteredTo/FBV~GUIDSample~EQ~${pSampleGUID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample: ${pError}`, pError);
					return reject(pError);
				}
				if (pBody.length > 1)
				{
					this.pict.log.error(`More than one Sample found for GUID: ${pSampleGUID}`, pBody);
				}
				resolve(pBody[0]);
			});
		});
	}

	/**
	 * Get the Sample by QR Code
	 * @param {Object} pQRCode - The QR Code to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getSampleByQRCode(pQRCode)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pQRCode)
			{
				this.pict.log.error('No QR Code provided.');
				return reject(new Error('No QR Code provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Samples/FilteredTo/FBV~QRCode~EQ~${pQRCode}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Samples
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getSamples()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Samples';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Samples/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Samples list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Promise wrapper over the paged entity-set fetch.
	 * @param {String} pEntity - The entity type to fetch
	 * @param {String} pFilter - A Meadow filter string
	 * @return {Promise<Array<Object>>}
	 */
	_getEntitySet(pEntity, pFilter)
	{
		// the paged client takes per-page / progress callbacks we have no use for here
		const fNoOp = () =>
		{
			// intentionally empty
		};
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages(pEntity, pFilter, fNoOp, fNoOp, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Failed to get the ${pEntity} set.`, pError);
					return reject(pError);
				}
				resolve(pRecords || []);
			});
		});
	}

	/**
	 * Get the DocumentPolyJoin rows tying Samples to a Document. The joins are written server-side
	 * (SampleTestController), so a freshly created Sample only appears here after a save round-trip.
	 * @param {Number|String} pIDDocument - The Document to fetch Sample joins for
	 * @return {Promise<Array<Object>>}
	 * @async
	 */
	async getDocumentSampleJoins(pIDDocument)
	{
		if (!pIDDocument)
		{
			return [];
		}
		return await this._getEntitySet('DocumentPolyJoin', `FBV~RemoteType~EQ~Sample~FBV~IDDocument~EQ~${pIDDocument}`);
	}

	/**
	 * Get the Samples joined to a Document. Replaces the legacy sample-log component's raw
	 * `Samples/FilteredTo/...?Joins=DocumentPolyJoin` URL with the standard two-hop entity fetch.
	 * @param {Number|String} pIDDocument - The Document to fetch joined Samples for
	 * @return {Promise<Array<Object>>}
	 * @async
	 */
	async getDocumentJoinedSamples(pIDDocument)
	{
		const tmpJoins = await this.getDocumentSampleJoins(pIDDocument);
		const tmpSampleIDs = [ ...new Set(tmpJoins.map((pJoin) => pJoin.IDRemote).filter((pIDRemote) => !!pIDRemote)) ];
		if (!tmpSampleIDs.length)
		{
			return [];
		}
		return await this._getEntitySet('Sample', `FBL~IDSample~INN~${tmpSampleIDs.join(',')}`);
	}

	/**
	 * Get the Sample search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<void>}
	 * @async
	 * @example
	 * getObservationSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getSampleSearchCount(pSearchQuery)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `Samples/Count${tmpFilter ? `/${tmpFilter}` : ''}`;

		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
					reject(pError);
				}
				else
				{
					resolve(pBody?.Count || 0);
				}
			});
		});
	}

	/**
	 * Get the Sample search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<Array>}
	 * @async
	 * @example
	 * getSampleSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getSampleSearchResults(pSearchQuery)
	{
		const tmpURL = `Samples/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
					reject(pError);
				}
				resolve(Array.isArray(pBody) ? pBody : []);
			});
		});
	}

	/**
	 * This method performs an Sample search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @return {Promise<Object>}
	 * @async
	 */
	performSampleSearch(pOptions = {})
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions)
			{
				this.pict.log.error('No search options provided.');
				return reject(new Error('No search options provided.'));
			}

			const tmpSearchQuery = {
				filters: [ {
					field: 'IDCustomer',
					comparator: 'EQ',
					target: pOptions.IDCustomer || 0,
				} ],
				pagination: {
					start: pOptions?.CurrentPage || 1,
					limit: pOptions?.PageSize || 25,
				},
				sort: {
					field: pOptions.SortBy || 'CreateDate',
					direction: pOptions.SortDirection || 'DESC',
				},
			};

			// Handle the search filters
			if (pOptions?.Projects && pOptions.Projects.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDProject',
					comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
				});
			}

			if (pOptions?.Materials && pOptions.Materials.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDMaterial',
					comparator: pOptions.Materials.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Materials.length === 1 ? pOptions.Materials[0] : pOptions.Materials,
				});
			}

			if (pOptions?.MixDesigns && pOptions.MixDesigns.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDMixDesign',
					comparator: pOptions.MixDesigns.length === 1 ? 'EQ' : 'INN',
					target: pOptions.MixDesigns.length === 1 ? pOptions.MixDesigns[0] : pOptions.MixDesigns,
				});
			}

			if (pOptions?.StartDate && pOptions.StartDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'CreateDate',
					comparator: 'GE',
					target: pOptions.StartDate,
				});
			}

			if (pOptions?.EndDate && pOptions.EndDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'CreateDate',
					comparator: 'LE',
					target: pOptions.EndDate,
				});
			}

			// Perform the search by calling both getSampleSearchCount and getSampleSearchResults
			Promise.all([
				this.getSampleSearchCount(tmpSearchQuery),
				this.getSampleSearchResults(tmpSearchQuery),
			])
				.then(([ tmpCountResults, tmpResults ]) =>
				{
					resolve({ results: tmpResults, count: tmpCountResults });
				})
				.catch((error) =>
				{
					this.pict.log.error('Error during sample search:', error);
					reject(error);
				});
		});
	}

	/**
	 * Create a new Sample
	 * @param {Object} pSampleData - The Sample data to create
	 * @param {Function} [pCallback] - The callback function to call when the creation is complete
	 * @param {Boolean} [disableAutomaticDesignatedTime] - If true, the Sample will not get a date automatically set.
	 *
	 * @return {Promise<void>}
	 * @async
	 * FIXME: Why do we have an async method with a callback that is only invoked sometimes?
	 */
	async createSample(pSampleData, pCallback, disableAutomaticDesignatedTime)
	{
		if (!pSampleData)
		{
			this.pict.log.error('No Sample data provided.');
			throw new Error('No Sample data provided.');
		}
		// get the customer record to use for the QR code hash generation (we need the legacy format check)
		const useLegacyFormat = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('Customer/' + this.pict.AppData?.CurrentUser?.CustomerID, (pError, pResult) =>
			{
				if (pError)
				{
					this.pict.log.error('Error getting customer record:', pError);
					return reject(pError);
				}
				let tmpCustomerProperties = pResult?.CustomProperties || {};
				// check if we need to parse the custom properties
				if (typeof tmpCustomerProperties === 'string' && tmpCustomerProperties.trim().startsWith('{'))
				{
					tmpCustomerProperties = JSON.parse(tmpCustomerProperties);
				}
				// check if we need to use the legacy format
				const tmpLegacyFormat = pResult && tmpCustomerProperties?.CustomSampleGUID === 'SiteManagerSampleGUID';
				resolve(tmpLegacyFormat);
			});
		});
		// if we are using legacy format, we also need to get the user record to use for the QR code hash generation
		if (useLegacyFormat === true)
		{
			this.pict.log.info('Using Legacy Sample GUID format.');
			// get the user record to use for the QR code hash generation
			const tmpUserRecord = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON('User/' + this.pict.AppData?.CurrentUser?.UserID, (pError, pResult) =>
				{
					if (pError)
					{
						this.pict.log.error('Error getting user record:', pError);
						return reject(pError);
					}
					resolve(pResult);
				});
			});
			// LADOTD QRs feed SiteManager, which keys on the user's external (SiteManager) id. With no
			// ExternalSyncGUID, mint a deterministic placeholder "HL<IDUser>" — matching the materials app
			// (sample.ts generateGUID) — so the format stays valid instead of degrading to a plain user GUID.
			pSampleData.QRCode = this.pict.fable.services.HeadlightQRCodeHash.generateQRCodeHash({
				GUIDPrefix: pSampleData.GUIDPrefix || tmpUserRecord?.ExternalSyncGUID || `HL${this.pict.AppData?.CurrentUser?.UserID}`,
				LegacyFormat: true,
			});
		}
		else
		{
			this.pict.log.info('Using Standard Sample GUID format.');
			pSampleData.QRCode = this.pict.fable.services.HeadlightQRCodeHash.generateQRCodeHash({ IDProject: pSampleData.IDProject, IDUser: this.pict.AppData?.CurrentUser?.UserID });
		}
		if (pSampleData.DesignatedTime?.length && !pSampleData.DesignatedTime.includes('T'))
		{
			pSampleData.DesignatedTime = this.fable.Dates.dayJS(pSampleData.DesignatedTime + this.getCurrentTime()).toISOString();
		}
		// Set the Designated Time to the current time if not provided (unless explcitly disabled)
		if (!pSampleData.DesignatedTime && !disableAutomaticDesignatedTime)
		{
			this.pict.log.info('No Designated Time was passed, setting to current time.');
			pSampleData.DesignatedTime = new Date().toISOString();
		}
		// strip out any _ prefixed fields (these are internal only)
		Object.keys(pSampleData).forEach((pKey) =>
		{
			if (pKey.startsWith('_'))
			{
				delete pSampleData[pKey];
			}
		});
		// Go build us a sample record
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON('Sample', this.buildSampleAPIPayload(pSampleData), async (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating Sample: ${pError}`, pError);
					return reject(pError);
				}
				if (parseInt(pBody?.Extension?.StorageLocation))
				{
					await this.pict.providers.LocationProvider.addSampleToLocation(pBody.IDSample, parseInt(pBody?.Extension?.StorageLocation));
				}
				this.pict.log.info('Sample created successfully.');
				// go create a sample log record for the creation step
				this.pict.providers.SampleLogProvider.createSampleLog({
					IDSample: pBody.IDSample,
					IDUser: pBody.CreatingIDUser,
					IDSampleStatus: pBody.IDSampleStatus,
					Notes: 'Sample created.',
				}).catch((pError) =>
				{
					this.pict.log.error(`Error creating Sample Log for newly created sample: ${pError}`, pError);
				}).finally(() =>
				{
					resolve(pBody);
					if (pCallback)
					{
						pCallback(pBody);
					}
				});
			});
		});
	}

	getCurrentTime()
	{
		return ` ${ this.fable.Dates.dayJS(new Date()).format('HH:mm:ss') }`;
	}

	/**
	 * The Sample record as the API should see it.
	 *
	 * Entity pickers keep a `<field>__Record` snapshot beside each value so the control can paint its
	 * selection without a refetch. That is client-side display state — the Sample schema has no such
	 * column — so it is dropped here rather than posted. A COPY, deliberately: the caller's object is the
	 * live form's data, and the picker reads those snapshots, so removing them in place would blank the
	 * control after a save.
	 *
	 * @param {Object} pSampleData - The Sample data being sent.
	 * @return {Object} a shallow copy without the `__Record` snapshots.
	 */
	buildSampleAPIPayload(pSampleData)
	{
		const tmpPayload = {};
		for (const tmpKey of Object.keys(pSampleData))
		{
			if (tmpKey.endsWith('__Record'))
			{
				continue;
			}
			tmpPayload[tmpKey] = pSampleData[tmpKey];
		}
		return tmpPayload;
	}

	/**
	 * Update an existing Sample
	 * @param {Object} pSampleData - The Sample data to update
	 * @return {Promise<void>}
	 * @async
	 */
	async updateSample(pSampleData)
	{
		if (!pSampleData)
		{
			this.pict.log.error('No Sample data provided.');
			throw new Error('No Sample data provided.');
		}
		if (pSampleData.DesignatedTime?.length && !pSampleData.DesignatedTime.includes('T'))
		{
			pSampleData.DesignatedTime = this.fable.Dates.dayJS(pSampleData.DesignatedTime + this.getCurrentTime()).toISOString();
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON('Sample/Upsert', this.buildSampleAPIPayload(pSampleData), async (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating Sample: ${pError}`, pError);
					return reject(pError);
				}
				if (parseInt(pBody?.Extension?.StorageLocation))
				{
					await this.pict.providers.LocationProvider.addSampleToLocation(pBody.IDSample, parseInt(pBody?.Extension?.StorageLocation));
				}

				resolve(pBody);
			});
		});
	}

	/**
	 * Delete an existing Sample
	 * @param {Object} pSampleId - The IDSample to delete the Sample record
	 * @return {Promise<void>}
	 * @async
	 */
	async deleteSample(pSampleId)
	{
		if (!pSampleId)
		{
			this.pict.log.error('No Sample id provided.');
			throw new Error('No Sample id provided.');
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.deleteEntity('Sample', pSampleId, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error deleting Sample: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Sample schema
	 * @return {Promise<void>}
	 * @async
	 */
	async getSampleSchema()
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('Sample/Schema', (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample schema: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = SampleProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],885:[function(require,module,exports){
// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const libPictProvider = require('pict-provider');

class SessionProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		/** @type {any} */
		this._Session = null;

		this.sessionChangeCallbacks = [];
	}

	onSessionChange(fCallback)
	{
		if (typeof fCallback === 'function')
		{
			this.sessionChangeCallbacks.push(fCallback);
		}
	}

	onInitializeAsync(fCallback)
	{
		// check for initial logged in state
		this.syncLoggedInState().catch((error) =>
		{
			this.pict.log.error(`Error syncing logged in state: ${error.message || error}`);
		}).finally(fCallback);
	}

	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (error, payload) =>
			{
				if (error)
				{
					return reject(error);
				}
				resolve(payload);
			});
		});
	}

	async _triggerSessionChange(pOldSession, pNewSession)
	{
		for (const callback of this.sessionChangeCallbacks)
		{
			try
			{
				await callback(pNewSession, pOldSession);
			}
			catch (error)
			{
				this.pict.log.error(`Error in session change callback: ${error.message || error}`, { stack: error.stack });
			}
		}
	}

	/**
	 * Shape of the session object stored in memcache, and returned from CheckSession.
	 * @typedef {Object} SessionInfo
	 * @property {string} SessionID - The session ID.
	 * @property {boolean} LoggedIn - True if the user is logged in.
	 * @property {string} UserRole - The human readable role of the user.
	 * @property {number} UserRoleIndex - The user's (0-5) level.
	 * @property {number} UserID - The IDUser (database ID) of the user.
	 * @property {number} CustomerID - The IDCustomer (database ID) of the customer.
	 * @property {boolean} [Impersonation] - True when this session is impersonating another user.
	 * @property {string} Title - The title of the user.
	 * @property {string} NameFirst - The first name of the user.
	 * @property {string} NameLast - The last name of the user.
	 * @property {string} Email - The email of the user.
	 * @property {string} LoginID - The login ID of the user.
	 * @property {string} UIHash - The UI hash of the user. (not sure what this is for)
	 * @property {string} Timezone - The timezone of the user.
	 * @property {Record<string, any>} Settings - The user's settings.
	 * @property {string} LastSessionID - The user's last session ID.
	 * @property {string} LastLoginTime - The time of the user's last login.
	 * @property {Array<string>} UserRoles - The roles of the user.
	 * @property {string} DeviceID - The device ID associated with the session.
	 * @property {number} IDDevice - The IDDevice (database ID) of the device record associated with the session.
	 */

	/**
	 * @return {Promise<SessionInfo | null>}
	 */
	async syncLoggedInState()
	{
		const session = await this._get(`CheckSession`);
		if (!session || !session.LoggedIn)
		{
			if (this._Session && this._Session.LoggedIn)
			{
				await this._triggerSessionChange(this._Session, null);
			}
			this._Session = null;
			this._Permissions = null;
			return this._Session;
		}
		if (!this._Session || this._Session.UserID != session.UserID)
		{
			await this._triggerSessionChange(this._Session, session);

			// some kind of event that user changed?
			this._Permissions = null;
		}
		this._Session = session;
		// Customer permissions load lazily through getPermissions(); nothing needs them at boot.
		return this._Session;
	}

	/**
	 * @return {boolean} whether a logged-in session is cached from a previous sync.
	 */
	hasSession()
	{
		return !!(this._Session && this._Session.LoggedIn);
	}

	/**
	 * Drop the cached session so the next getSession()/syncLoggedInState() asks the server again.
	 */
	invalidateSession()
	{
		this._Session = null;
		this._Permissions = null;
	}

	async getPermissions()
	{
		if (!this._Permissions)
		{
			//FIXME: project aware permissions
			this._Permissions = await this._get(`Permissions/For/User/In/Customer/${this._Session.CustomerID}`);
		}
		return this._Permissions;
	}

	async getSession()
	{
		if (!this._Session)
		{
			this._Session = await this._get(`CheckSession`);
		}
		return this._Session;
	}
}

module.exports = SessionProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'SessionProvider',
	});

},{"pict-provider":479}],886:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class TestInstanceProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

    /**
	 * Get Test by ID
	 * @param {String|Number} pTestID - The Test ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getTestByID(pTestID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pTestID)
			{
				this.pict.log.error('No Test ID provided.');
				return reject(new Error('No Test ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Test/${pTestID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Test: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the TestInstance by ID
	 * @param {String|Number} pTestInstanceID - The TestInstance ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getTestInstanceByID(pTestInstanceID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pTestInstanceID)
			{
				this.pict.log.error('No TestInstance ID provided.');
				return reject(new Error('No TestInstance ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`TestInstance/${pTestInstanceID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting TestInstance: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

    deleteTestInstanceByID(pTestInstanceID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pTestInstanceID)
			{
				this.pict.log.error('No TestInstance ID provided.');
				return reject(new Error('No TestInstance ID provided.'));
			}

			this.pict.HeadlightRestClient.deleteEntity('TestInstance', pTestInstanceID, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error deleting TestInstance: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

    async _getDocumentPolyJoinsForTestInstances(IDTestInstances)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('DocumentPolyJoin', `FBV~RemoteType~EQ~TestInstance~FBL~IDRemote~INN~${ IDTestInstances.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting DocumentPolyJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getDocumentPolyJoinsForSample(IDSample)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('DocumentPolyJoin', `FBV~RemoteType~EQ~Sample~FBL~IDRemote~INN~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting DocumentPolyJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getDocumentsByIDs(IDDocuments)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('Document', `FBL~IDDocument~INN~${ IDDocuments.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Documents: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getDocumentMapForTestInstances(IDTestInstances)
    {
        const dpjs = await this._getDocumentPolyJoinsForTestInstances(IDTestInstances);
        const docs = await this._getDocumentsByIDs(dpjs.map(d => d.IDDocument));
        const docIDMap = {}
        for (let d of docs)
        {
            docIDMap[d.IDDocument] = d;
        }
        const tiDocMap = {};
        for (let t of IDTestInstances)
        {
            tiDocMap[t] = [];
        }
        for (let d of dpjs)
        {
            const doc = docIDMap[d.IDDocument];
            if (doc)
            {
                tiDocMap[d.IDRemote].push(docIDMap[d.IDDocument]);
            }
        }
        return tiDocMap;
    }

    async _getDocumentsForSample(IDSample)
    {
        const dpjs = await this._getDocumentPolyJoinsForSample(IDSample);
        return await this._getDocumentsByIDs(dpjs.map(d => d.IDDocument));
    }

    /**
	 * Get Tests by IDs
	 * @param {Array<number>} pIDTests - The Test IDs to search for
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	async getTestsByIDs(pIDTests)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('Test', `FBL~IDTest~INN~${ pIDTests.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Tests: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async getTestsByHashes(TestHashes)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('Test', `FBL~Hash~INN~${ TestHashes.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Tests: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getTestInstanceSampleJoinsForSample(IDSample)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('TestInstanceSampleJoin', `FBV~IDSample~EQ~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting TestInstanceSampleJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getTestInstancesByIDs(IDTestInstances)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('TestInstance', `FBL~IDTestInstance~INN~${ IDTestInstances.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting TestInstances: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getTestInstancesForSample(IDSample)
    {
        const tisjs = await this._getTestInstanceSampleJoinsForSample(IDSample);
        return await this._getTestInstancesByIDs(tisjs.map(t => t.IDTestInstance));
    }

	async getTestInstanceBundleForSample(IDSample)
    {
        try
        {
            const TestInstances = await this._getTestInstancesForSample(IDSample);
            const TestInstanceDocumentMap = await this._getDocumentMapForTestInstances(TestInstances.map(t => t.IDTestInstance));
            const Tests = await this.getTestsByIDs(TestInstances.map(t => t.IDTest));
            const TestMap = {};
            for (let t of Tests)
            {
                TestMap[t.IDTest] = t;
            }

            // For now, let's also check Entity Data for Test Instance associations as well.
            // RIDOT doesn't have joins from TestInstance to Document currently for example.
            const tiGUIDMap = {};
            for (let t of TestInstances)
            {
                tiGUIDMap[t.GUIDTestInstance] = t.IDTestInstance;
            }
            const DocumentsForSample = await this._getDocumentsForSample(IDSample);
            for (let d of DocumentsForSample)
            {
                if (d.EntityData?.TestInstance?.length)
                {
                    for (let t of d.EntityData.TestInstance)
                    {
                        if (t.GUIDTestInstance.includes('{IDDocument}'))
                        {
                            t.GUIDTestInstance = t.GUIDTestInstance.replace('{IDDocument}', d.IDDocument);
                        }
                        if (tiGUIDMap[t.GUIDTestInstance] && TestInstanceDocumentMap[tiGUIDMap[t.GUIDTestInstance]] && !TestInstanceDocumentMap[tiGUIDMap[t.GUIDTestInstance]].map(d => d.IDDocument).includes(d.IDDocument))
                        {
                            TestInstanceDocumentMap[tiGUIDMap[t.GUIDTestInstance]].push(d)
                        }
                    }
                }
            }

            return { TestInstances, TestInstanceDocumentMap, TestMap };
        }
        catch (e)
        {
            console.log(`Failed to get Test Instance Bundle for Sample ${ IDSample }: `, e);
            return { TestInstances: [], TestInstanceDocumentMap: {}, TestMap: {} };
        }
    }
}

module.exports = TestInstanceProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],887:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UploadTrackingProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		window.Mixins =
		{
			currentlyUploading: 0,
		};

		this.trackedUploads = [];
		this.nextUploadID = 0;
	}

	/**
	 * Adds an upload to the list of uploads being tracked, then sets the numeric flag that FB ios looks for.
	 * Gives back an id that can be used to remove the upload from the list later.
	 *
	 * @return {Number} - An id that can be used to untrack the upload later.
	 */
	trackUpload()
	{
		// Generating an error, not for the error but just to retain a copy of the stack.
		const error = new Error();
		// Monotonic rather than a timestamp: two uploads starting in the same millisecond would otherwise
		// share an id, and untracking either one would clear both while a transfer was still in flight.
		const id = ++this.nextUploadID;
		this.trackedUploads.push(
			{
				id,
				stack: error.stack,
			},
		);
		window.Mixins.currentlyUploading = this.trackedUploads.length;
		return id;
	}

	/**
	 * Removes an upload from the list of uploads being tracked using its id.
	 * @param {Number} id - An id passed from the calling function, should be the same one used to originally add the upload.
	 */
	untrackUpload(id)
	{
		this.trackedUploads = this.trackedUploads.filter((u) =>
		{
			return u.id !== id;
		});
		window.Mixins.currentlyUploading = this.trackedUploads.length;
	}
}

module.exports = UploadTrackingProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],888:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UserProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the user by ID
	 * @param {String|Number} pUserID - The user ID to search for
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getUserByID(pUserID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pUserID)
			{
				this.pict.log.error('No User ID provided.');
				return reject(new Error('No User ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`User/${pUserID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting User: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get users by a list of user IDs
	 * @param {Array<String|Number>} pUserList - The list of user IDs to search for
	 * @return {Promise<Array>} - A promise that resolves to an array of users
	 * @async
	 * @example
	 */
	getUsersByIDList(pUserList)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pUserList || !Array.isArray(pUserList) || pUserList.length === 0)
			{
				this.pict.log.error('No User List provided.');
				return reject(new Error('No User List provided.'));
			}

			this.pict.HeadlightRestClient.getJSON('Users/FilteredTo/FBL~IDUser~INN~' + pUserList.join(','), (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Users: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = UserProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}],889:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UtilityProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	// TODO: This may be eventually replaced with the HeadlightRestClient/OfflineRestClient
	/**
	 * @param {object} options - JSON containing all the configurations for this query (including filters, sorting, etc.)
	 * @return {string} a meadow filter query stanza created from 'options' (e.g FBV~Something~EQ~Less~FSF~Else~ASC~0/0/250)
	 */
	generateMeadowFilter(options)
	{
		const queryFilter = [];
		// add filter stanzas
		for (const entry of (options.filters?? []))
		{
			const filterPrefix = entry.connector === 'OR' ? 'FBVOR' : 'FBV';
			switch (entry.comparator)
			{
			case 'FOP':
				queryFilter.push('FOP~0~(~0');
				break;
			case 'FCP':
				queryFilter.push('FCP~0~)~0');
				break;
			case 'INN':
			case 'NIN':
				const listPrefix = entry.connector === 'OR' ? 'FBLOR' : 'FBL';
				let inList = Array.isArray(entry.target) ? entry.target : [ entry.target ];
				inList = inList.map((singleTarget) => encodeURIComponent(singleTarget));
				queryFilter.push(`${listPrefix}~${entry.field}~${entry.comparator}~${inList}`);
				break;
			case 'LK':
				queryFilter.push(`${filterPrefix}~${entry.field}~LK~%25${encodeURIComponent(entry.target.replace(/\*/g, '%25'))}%25`);
				break;
			default:
				queryFilter.push(`${filterPrefix}~${entry.field}~${entry.comparator}~${encodeURIComponent(entry.target)}`);
				break;
			}
		}
		// add sorting
		if (options.hasOwnProperty('sort') && options.sort.field && options.sort.direction)
		{
			queryFilter.push(`FSF~${options.sort.field}~${options.sort.direction}~0`);
		}
		const filterString = queryFilter.join('~');
		// NOTED: Removed pagination due to issues with /Count/ fetching
		// add pagination
		// if (options.hasOwnProperty('pagination'))
		// {
		// 	filterString += `/${options.pagination.start}/${options.pagination.limit}`;
		// }
		const hasFilters = (queryFilter.length > 0) || (options.sort && options.sort?.field && options.sort?.direction);
		return (hasFilters ? 'FilteredTo/' : '') + filterString;
	}

	/**
	 * This method formats the results for the Select2 AJAX call.
	 * @param {Array} pData - The data to format.
	 * @param {string|array} pIDKey - The key(s) to use for the ID.
	 * @param {string|array} pTextKey - The key(s) to use for the text.
	 * @param {Array} pSelectedOptions - The selected options to add to the top of the list.
	 * @param {Object} pStickyOption - The sticky option to add to the top of the list.
	 * @param {Boolean} [joinTextKeys] - Should the text key array be joined together.
	 * @return {Array} The formatted results.
	 */
	formatSelect2Results(pData, pIDKey, pTextKey, pSelectedOptions, pStickyOption, joinTextKeys)
	{
		let results = $.map(pData, function(item)
		{
			const result = {};
			// if they pIDKey is an array, we need to loop through the array keys as fallback values
			if (Array.isArray(pIDKey))
			{
				for (let i = 0; i < pIDKey.length; i++)
				{
					if (item[pIDKey[i]])
					{
						result.id = item[pIDKey[i]];
						// if we have selected options, mark them as selected in the dropdown list
						if (pSelectedOptions && pSelectedOptions.includes(result.id))
						{
							result.selected = true;
						}
						break;
					}
				}
			}
			else
			{
				result.id = item?.[pIDKey] || item?.Hash || 0;
			}
			// if they pTextKey is an array, we need to loop through the array keys as fallback values
			if (Array.isArray(pTextKey))
			{
				for (let i = 0; i < pTextKey.length; i++)
				{
					if (item[pTextKey[i]])
					{
						result.text = joinTextKeys ? result.text ? (result.text + ' ' + item[pTextKey[i]]) : item[pTextKey[i]] : item[pTextKey[i]];
						if (!joinTextKeys)
						{
							break;
						}
					}
				}
			}
			else
			{
				result.text = item?.[pTextKey] || item?.Value || ' ';
			}
			return result;
		});
		// go ahead and sort by the text value before returning
		results.sort((a, b) => (a.text > b.text) ? 1 : -1);
		// if we have a sticky option, add it to the top of the dropdown list
		if (pStickyOption)
		{
			// set the sticky flag so we can style it differently in the dropdown
			pStickyOption.sticky = true;
			// remove the sticky option from the results if it already exists
			results = results.filter((item) => item.id !== pStickyOption.id);
			// then, add it to the top of the list
			results.unshift(pStickyOption);
		}
		return results;
	}

	/**
	 * Clear the date time picker.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	clearDateTimePicker(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				tmpFlatpickrInstance.clear();
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}

	/**
	 * Set the date time picker to the 'now' date/time.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	setDateTimePickerToNow(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				tmpFlatpickrInstance.setDate(new Date());
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}

	/**
	 * This method builds the extra buttons for the flatpickr date picker.
	 * @param {Object} pInstance - The flatpickr instance.
	 * @param {string} pElementID - The ID of the date picker input element.
	 * @return {void}
	 */
	buildFlatpickrExtraButtons(pInstance, pElementID)
	{
		const template =
		`<div class="flatpicker-extras">
			<div class="buttons py-1 is-centered">
				<button class="button is-outline is-small" type="button" onclick="_Pict.providers.UtilityProvider.clearDateTimePicker('#${pElementID}')">
					<span class="icon">
						<i class="fa fa-fw fa-undo"></i>
					</span>
					<span class="icon-text">
						Clear
					</span>
				</button>
				<button class="button is-link is-small " type="button" onclick="_Pict.providers.UtilityProvider.setDateTimePickerToNow('#${pElementID}')">
					<span class="icon">
						<i class="fa fa-fw fa-calendar"></i>
					</span>
					<span class="icon-text">
						Set to Current Date
					</span>
				</button>
			</div>
		</div>`;
		// add the extra buttons to the calendar container
		if (!pInstance.calendarContainer)
		{
			console.warn('[Utility] Unable to add flatpickr extra buttons, calendarContainer is not defined.');
			return;
		}
		pInstance.calendarContainer.insertAdjacentHTML('beforeend', template);
	}

	/**
	 * This method is used to validate if a passed string is a valid latitude geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLatitude('24.034345') => '24.034345'
	 */
	isValidLatitude = (value) =>
	{
		const latReg = RegExp(/^(\+|-)?(?:90(?:(?:\.0{0,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = latReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Latitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * This method is used to validate if a passed string is a valid longitue geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLongitude('24.034345') => '24.034345'
	 */
	isValidLongitude = (value) =>
	{
		const longReg = RegExp(/^(\+|-)?(?:180(?:(?:\.0{0,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = longReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Longitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * Get a Google Maps URL for a the passed entity record.
	 * @param {Object} pEntity - The record to get the Google Maps URL for (this assume the record has a User/Capture latitude and longitude)
	 * @param {Object} pOptions - The options for the Google Maps URL
	 * @return {string} - The Google Maps URL
	 */
	getGoogleMapURLFromEntityRecord(pEntity, pOptions = {})
	{
		// Documentation for Google Maps = https://developers.google.com/maps/documentation/maps-static/dev-guide
		let staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap`;
		const tmpMarkerColor = pOptions.markerColor || 'orange';
		// map params for google maps
		const urlParams = {
			scale: pOptions.scale || 1,
			size: pOptions.size || '640x480',
			key: pOptions.key || 'AIzaSyD4ZhOfhsWIII7qOYKRS2SfKZ1iPeIeQfU',
			maptype: pOptions.maptype || 'roadmap',
		};
		// build url from params
		Object.entries(urlParams).forEach(([ key, val ]) =>
		{
			staticMapUrl += `${ key === 'scale' ? '?' : '&' }${ key }=${ val }`;
		});
		// TODO: make this better for "0.000" strings, etc
		const tmpLatitude = pEntity.Latitude || pEntity.CaptureLatitude || pEntity.UserLatitude || 0;
		const tmpLongitude = pEntity.Longitude || pEntity.CaptureLongitude || pEntity.UserLongitude || 0;

		let hasValidGeolocation = false;
		if (tmpLatitude && tmpLongitude)
		{
			hasValidGeolocation = this.isValidLatitude(tmpLatitude) && this.isValidLongitude(tmpLongitude) && (Number(tmpLatitude) !== 0 && Number(tmpLongitude) !== 0);
		}

		if (hasValidGeolocation)
		{
			staticMapUrl += `&markers=color:${ tmpMarkerColor }%7Csize:tiny%7C${ tmpLatitude },${ tmpLongitude }`;
		}
		else
		{
			console.warn(`[Utility] Unable to get Google Maps URL for entity record:`, pEntity);
			return '';
		}
		return staticMapUrl;
	};

	/**
	 * Remove all 'is-loading' classes from the document.
	 * @return {void}
	 */
	removeAllLoadingClasses()
	{
		document.querySelectorAll('.is-loading').forEach((element) =>
		{
			element.classList.remove('is-loading');
		});
	}

	/**
	 * This method generates a HSL color based on the passed string.
	 * @param {string} str - The string to generate the color from.
	 * @param {number} s - The saturation of the color (0-100).
	 * @param {number} l - The lightness of the color (0-100).
	 * @return {string} - The HSL color.
	 */
	stringToHSLColor(str, s, l)
	{
		let hash = 0;
		for (let i = 0; i < str.length; i++)
		{
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}

		const h = hash % 360;
		return 'hsl('+h+', '+s+'%, '+l+'%)';
	}

	/**
	 * This method highlights a list item row element by adding a class and scrolling it into view.
	 * @param {HTMLElement} pListItemRowElement - The list item row element to highlight.
	 * @param {string} pScrollConainerElement - The scroll container element to scroll into view (optional).
	 * @return {boolean} - Returns true if the element was highlighted, false otherwise.
	 * @example
	 * _Pict.providers.UtilityProvider.highlightListItemRowElement(document.querySelector('.list-item-row[data-obseravtion-id="123456"]'));
	 */
	highlightListItemRowElement(pListItemRowElement, pScrollConainerElement)
	{
		if (!pListItemRowElement)
		{
			console.warn('[Utility] Unable to highlight list item row element, it is null or undefined.');
			return false;
		}
		const tmpListItemRowElement = pListItemRowElement instanceof HTMLElement ? pListItemRowElement : document.querySelector(pListItemRowElement);
		if (tmpListItemRowElement)
		{
			tmpListItemRowElement.classList.add('is-selected', 'animate__animated', 'animate__pulse');
			// NOTE: Do not do "tmpListItemRowElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });" bc it scrolls the whole page, not just the list item row
			if (this.pict.ContentAssignment.hasJquery)
			{
				// if we have a scroll container element, use it to scroll the list item into view
				if (pScrollConainerElement && $(pScrollConainerElement).length > 0)
				{
					$(pScrollConainerElement).animate({
						scrollTop: $(tmpListItemRowElement).offset().top - $(pScrollConainerElement).offset().top + $(pScrollConainerElement).scrollTop(),
					}, 500);
				}
			}
			setTimeout(() =>
			{
				tmpListItemRowElement.classList.remove('is-selected', 'animate__animated', 'animate__pulse');
			}
			, 5000); // 5 seconds
			return true;
		}
		else
		{
			console.warn('[Utility] Unable to highlight list item row element, it is null or undefined.');
			return false;
		}
	}

	/**
	 * This method is used to remove the loading skeletons from an element. It tries to be smart about where he classes are on the parent element and the element itself.
	 * @param {HTMLElement|jQuery} pElement - The element to remove the loading skeletons from.
	 * @return {boolean} - Returns true if the skeletons were removed, false otherwise.
	 */
	removeLoadingSkeleton(pElement)
	{
		if (!pElement)
		{
			console.warn('[Utility] Unable to remove loading skeletons, the element is null or undefined.');
			return false;
		}
		// if the element is a jQuery object, get the first element
		if (pElement instanceof jQuery)
		{
			pElement = pElement[0];
		}
		// if the element is not an HTMLElement, return false
		if (!(pElement instanceof HTMLElement))
		{
			console.warn('[Utility] Unable to remove loading skeletons, the element is not an HTMLElement.');
			return false;
		}
		// if the parent element has the 'is-skeleton' class, remove it there
		if (pElement?.parentElement?.classList?.contains('is-skeleton'))
		{
			pElement.parentElement.classList.remove('is-skeleton');
			return true;
		}
		// if the element itself has the 'is-skeleton' class, remove it there
		else if (pElement?.classList?.contains('is-skeleton'))
		{
			pElement.classList.remove('is-skeleton');
			return true;
		}
		else
		{
			console.warn('[Utility] Unable to remove loading skeletons, the element does not have the is-skeleton class.');
			return false;
		}
	}

	/**
	 * A general utility to pause any active media on the page.
	 * @return {void}
	 */
	pauseAnyActiveMedia()
	{
		const tmpMedia = document.querySelectorAll('video, audio');
		tmpMedia.forEach(
			/**
			 * @param {HTMLMediaElement|HTMLVideoElement} media
			 */
			(media) =>
			{
				if (!media.paused)
				{
					media.pause();
				}
			});
	}

	/**
	 * This method returns the subdomain based on the current environment.
	 * It checks if the URL contains 'localhost' or '.qa.' for QA, '.stg.' for staging, and returns an empty string for production.
	 * @return {string} - The subdomain for the current environment.
	 */
	getEnvironmentSubdomainFromWindowLocation()
	{
		if (window?.location?.href?.includes('localhost') || window?.location?.href?.includes('.qa.'))
		{
			return '.qa';
		}
		else if (window?.location?.href?.includes('.stg.'))
		{
			return '.stg';
		}
		else
		{
			return '';
		}
	};

	/**
	 * This method builds the links URL based on the current environment.
	 * It uses the getEnvironmentSubdomainFromWindowLocation method to determine the subdomain.
	 * @return {string} - The links URL for the current environment.
	 */
	buildLinksUrl()
	{
		const subdomain = this.getEnvironmentSubdomainFromWindowLocation();
		return `https://links${ subdomain }.headlight.com`;
	}
}

module.exports = UtilityProvider;
module.exports.default_configuration = {};

},{"pict-provider":479}]},{},[819])(819)
});

